{ 
    "trip_id": { 
"1" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "04:28:00" , 
"departure_time" : "04:28:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "04:39:36" , 
"departure_time" : "04:39:56" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "04:49:20" , 
"departure_time" : "04:49:26" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "05:00:06" , 
"departure_time" : "05:00:18" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "05:13:12" , 
"departure_time" : "05:14:07" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "05:20:55" , 
"departure_time" : "05:21:12" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "05:33:17" , 
"departure_time" : "05:34:24" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "05:41:07" , 
"departure_time" : "05:41:43" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "06:04:36" , 
"departure_time" : "06:04:36" , 
"distance_traveled" : 67.6532
}], 
"2" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "04:28:00" , 
"departure_time" : "04:29:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "04:39:37" , 
"departure_time" : "04:39:54" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "04:49:17" , 
"departure_time" : "04:50:38" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "05:01:21" , 
"departure_time" : "05:02:48" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "05:14:27" , 
"departure_time" : "05:15:35" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "05:21:08" , 
"departure_time" : "05:21:22" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "05:33:14" , 
"departure_time" : "05:34:22" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "05:41:08" , 
"departure_time" : "05:41:17" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "06:04:09" , 
"departure_time" : "06:04:09" , 
"distance_traveled" : 67.6532
}],
"3" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "05:55:00" , 
"departure_time" : "05:55:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "06:06:19" , 
"departure_time" : "06:06:24" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "06:16:05" , 
"departure_time" : "06:17:21" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "06:28:16" , 
"departure_time" : "06:29:53" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "06:41:37" , 
"departure_time" : "06:41:39" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "06:47:02" , 
"departure_time" : "06:48:03" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "07:02:01" , 
"departure_time" : "07:03:09" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "07:09:08" , 
"departure_time" : "07:10:05" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "07:32:57" , 
"departure_time" : "07:32:57" , 
"distance_traveled" : 67.6532
}], 
"4" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "05:55:00" , 
"departure_time" : "05:56:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "06:06:18" , 
"departure_time" : "06:07:18" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "06:17:00" , 
"departure_time" : "06:18:36" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "06:28:36" , 
"departure_time" : "06:28:44" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "06:40:08" , 
"departure_time" : "06:40:37" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "06:47:29" , 
"departure_time" : "06:48:58" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "07:02:29" , 
"departure_time" : "07:02:39" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "07:08:10" , 
"departure_time" : "07:09:20" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "07:33:10" , 
"departure_time" : "07:33:10" , 
"distance_traveled" : 67.6532
} ], 
"5" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "07:26:00" , 
"departure_time" : "07:27:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "07:37:12" , 
"departure_time" : "07:37:53" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "07:50:41" , 
"departure_time" : "07:51:53" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "08:02:12" , 
"departure_time" : "08:03:52" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "08:15:40" , 
"departure_time" : "08:16:14" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "08:21:34" , 
"departure_time" : "08:21:56" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "08:34:22" , 
"departure_time" : "08:35:20" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "08:41:58" , 
"departure_time" : "08:43:33" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "09:06:35" , 
"departure_time" : "09:06:35" , 
"distance_traveled" : 67.6532
} ], 
"6" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "07:26:00" , 
"departure_time" : "07:28:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "07:38:04" , 
"departure_time" : "07:39:15" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "07:51:11" , 
"departure_time" : "07:52:46" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "08:02:35" , 
"departure_time" : "08:04:12" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "08:15:37" , 
"departure_time" : "08:16:15" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "08:21:38" , 
"departure_time" : "08:23:15" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "08:35:37" , 
"departure_time" : "08:35:54" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "08:41:17" , 
"departure_time" : "08:41:49" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "09:05:32" , 
"departure_time" : "09:05:32" , 
"distance_traveled" : 67.6532
} ], 
"7" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "09:17:00" , 
"departure_time" : "09:17:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "09:28:24" , 
"departure_time" : "09:29:31" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "09:42:07" , 
"departure_time" : "09:43:15" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "09:53:08" , 
"departure_time" : "09:54:15" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "10:06:07" , 
"departure_time" : "10:06:28" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "10:12:21" , 
"departure_time" : "10:13:13" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "10:26:52" , 
"departure_time" : "10:27:06" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "10:33:14" , 
"departure_time" : "10:34:18" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "10:58:04" , 
"departure_time" : "10:58:04" , 
"distance_traveled" : 67.6532
} ], 
"8" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "09:17:00" , 
"departure_time" : "09:18:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "09:28:30" , 
"departure_time" : "09:29:04" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "09:41:34" , 
"departure_time" : "09:42:02" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "09:52:28" , 
"departure_time" : "09:54:00" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "10:06:32" , 
"departure_time" : "10:07:27" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "10:12:55" , 
"departure_time" : "10:13:37" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "10:26:42" , 
"departure_time" : "10:26:52" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "10:33:10" , 
"departure_time" : "10:33:20" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "10:57:10" , 
"departure_time" : "10:57:10" , 
"distance_traveled" : 67.6532
} ], 
"9" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "10:31:00" , 
"departure_time" : "10:31:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "10:42:20" , 
"departure_time" : "10:42:58" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "10:52:38" , 
"departure_time" : "10:53:58" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "11:07:20" , 
"departure_time" : "11:08:22" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "11:20:02" , 
"departure_time" : "11:20:35" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "11:26:33" , 
"departure_time" : "11:27:12" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "11:39:39" , 
"departure_time" : "11:40:08" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "11:46:29" , 
"departure_time" : "11:46:46" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "12:11:17" , 
"departure_time" : "12:11:17" , 
"distance_traveled" : 67.6532
} ], 
"10" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "10:31:00" , 
"departure_time" : "10:31:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "10:42:40" , 
"departure_time" : "10:44:11" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "10:53:31" , 
"departure_time" : "10:54:21" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "11:06:50" , 
"departure_time" : "11:07:41" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "11:19:51" , 
"departure_time" : "11:20:08" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "11:26:17" , 
"departure_time" : "11:27:56" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "11:40:39" , 
"departure_time" : "11:41:26" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "11:46:47" , 
"departure_time" : "11:47:33" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "12:11:46" , 
"departure_time" : "12:11:46" , 
"distance_traveled" : 67.6532
} ], 
"11" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "12:02:00" , 
"departure_time" : "12:04:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "12:14:19" , 
"departure_time" : "12:15:44" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "12:24:25" , 
"departure_time" : "12:25:24" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "12:37:59" , 
"departure_time" : "12:39:25" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "12:52:26" , 
"departure_time" : "12:53:11" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "12:58:45" , 
"departure_time" : "12:59:37" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "13:11:52" , 
"departure_time" : "13:13:05" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "13:19:13" , 
"departure_time" : "13:19:49" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "13:43:36" , 
"departure_time" : "13:43:36" , 
"distance_traveled" : 67.6532
} ], 
"12" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "12:02:00" , 
"departure_time" : "12:02:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "12:13:13" , 
"departure_time" : "12:14:23" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "12:24:10" , 
"departure_time" : "12:25:31" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "12:38:21" , 
"departure_time" : "12:39:09" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "12:51:48" , 
"departure_time" : "12:52:17" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "12:58:29" , 
"departure_time" : "12:59:07" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "13:11:38" , 
"departure_time" : "13:12:22" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "13:18:44" , 
"departure_time" : "13:18:55" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "13:43:11" , 
"departure_time" : "13:43:11" , 
"distance_traveled" : 67.6532
} ], 
"13" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "13:37:00" , 
"departure_time" : "13:38:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "13:49:07" , 
"departure_time" : "13:50:46" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "14:02:39" , 
"departure_time" : "14:02:42" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "14:12:03" , 
"departure_time" : "14:13:12" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "14:26:09" , 
"departure_time" : "14:26:28" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "14:32:19" , 
"departure_time" : "14:32:54" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "14:45:35" , 
"departure_time" : "14:46:45" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "14:53:10" , 
"departure_time" : "14:54:29" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "15:18:19" , 
"departure_time" : "15:18:19" , 
"distance_traveled" : 67.6532
} ], 
"14" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "13:37:00" , 
"departure_time" : "13:39:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "13:49:03" , 
"departure_time" : "13:50:06" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "14:02:03" , 
"departure_time" : "14:02:51" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "14:12:48" , 
"departure_time" : "14:12:51" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "14:25:03" , 
"departure_time" : "14:25:04" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "14:32:01" , 
"departure_time" : "14:33:31" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "14:46:30" , 
"departure_time" : "14:47:14" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "14:52:44" , 
"departure_time" : "14:52:52" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "15:17:08" , 
"departure_time" : "15:17:08" , 
"distance_traveled" : 67.6532
} ], 
"15" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "15:29:00" , 
"departure_time" : "15:29:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "15:40:38" , 
"departure_time" : "15:42:13" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "15:54:35" , 
"departure_time" : "15:55:16" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "16:04:41" , 
"departure_time" : "16:04:54" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "16:17:13" , 
"departure_time" : "16:17:18" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "16:25:05" , 
"departure_time" : "16:26:14" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "16:38:09" , 
"departure_time" : "16:39:41" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "16:45:32" , 
"departure_time" : "16:47:07" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "17:10:35" , 
"departure_time" : "17:10:35" , 
"distance_traveled" : 67.6532
} ], 
"16" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "15:29:00" , 
"departure_time" : "15:31:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "15:41:02" , 
"departure_time" : "15:41:08" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "15:53:06" , 
"departure_time" : "15:54:02" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "16:04:56" , 
"departure_time" : "16:06:17" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "16:18:21" , 
"departure_time" : "16:19:51" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "16:26:30" , 
"departure_time" : "16:27:54" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "16:38:24" , 
"departure_time" : "16:39:12" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "16:44:48" , 
"departure_time" : "16:45:42" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "17:09:54" , 
"departure_time" : "17:09:54" , 
"distance_traveled" : 67.6532
} ], 
"17" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "17:21:00" , 
"departure_time" : "17:22:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "17:32:25" , 
"departure_time" : "17:33:16" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "17:45:51" , 
"departure_time" : "17:47:14" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "17:57:23" , 
"departure_time" : "17:57:41" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "18:09:18" , 
"departure_time" : "18:09:32" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "18:16:14" , 
"departure_time" : "18:16:16" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "18:29:02" , 
"departure_time" : "18:29:32" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "18:36:30" , 
"departure_time" : "18:37:31" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "19:02:01" , 
"departure_time" : "19:02:01" , 
"distance_traveled" : 67.6532
} ], 
"18" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "17:21:00" , 
"departure_time" : "17:23:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "17:33:05" , 
"departure_time" : "17:33:11" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "17:45:06" , 
"departure_time" : "17:46:37" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "17:57:31" , 
"departure_time" : "17:58:48" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "18:10:17" , 
"departure_time" : "18:11:01" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "18:16:44" , 
"departure_time" : "18:16:58" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "18:29:14" , 
"departure_time" : "18:29:23" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "18:36:09" , 
"departure_time" : "18:36:53" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "19:01:44" , 
"departure_time" : "19:01:44" , 
"distance_traveled" : 67.6532
} ], 
"19" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "19:13:00" , 
"departure_time" : "19:15:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "19:25:24" , 
"departure_time" : "19:25:57" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "19:37:33" , 
"departure_time" : "19:37:37" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "19:48:04" , 
"departure_time" : "19:48:53" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "20:02:49" , 
"departure_time" : "20:03:07" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "20:09:18" , 
"departure_time" : "20:10:21" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "20:23:03" , 
"departure_time" : "20:23:40" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "20:29:37" , 
"departure_time" : "20:30:54" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "20:55:17" , 
"departure_time" : "20:55:17" , 
"distance_traveled" : 67.6532
} ], 
"20" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "19:13:00" , 
"departure_time" : "19:14:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "19:24:41" , 
"departure_time" : "19:26:06" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "19:38:25" , 
"departure_time" : "19:39:16" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "19:48:51" , 
"departure_time" : "19:50:05" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "20:03:14" , 
"departure_time" : "20:04:44" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "20:10:30" , 
"departure_time" : "20:10:48" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "20:22:18" , 
"departure_time" : "20:22:20" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "20:29:02" , 
"departure_time" : "20:30:41" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "20:55:39" , 
"departure_time" : "20:55:39" , 
"distance_traveled" : 67.6532
} ], 
"21" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "20:48:00" , 
"departure_time" : "20:51:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "21:00:39" , 
"departure_time" : "21:00:51" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "21:12:12" , 
"departure_time" : "21:13:31" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "21:24:19" , 
"departure_time" : "21:25:47" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "21:37:28" , 
"departure_time" : "21:37:30" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "21:44:02" , 
"departure_time" : "21:44:13" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "21:57:11" , 
"departure_time" : "21:58:08" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "22:04:57" , 
"departure_time" : "22:05:52" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "22:28:55" , 
"departure_time" : "22:28:55" , 
"distance_traveled" : 67.6532
} ], 
"22" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "20:48:00" , 
"departure_time" : "20:49:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "20:59:09" , 
"departure_time" : "21:00:12" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "21:13:03" , 
"departure_time" : "21:13:22" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "21:23:19" , 
"departure_time" : "21:24:00" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "21:36:41" , 
"departure_time" : "21:37:57" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "21:45:16" , 
"departure_time" : "21:45:51" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "21:57:35" , 
"departure_time" : "21:57:38" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "22:04:03" , 
"departure_time" : "22:05:03" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "22:29:00" , 
"departure_time" : "22:29:00" , 
"distance_traveled" : 67.6532
} ], 
"23" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "22:51:00" , 
"departure_time" : "22:53:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "23:03:13" , 
"departure_time" : "23:04:37" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "23:13:24" , 
"departure_time" : "23:14:33" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "23:24:09" , 
"departure_time" : "23:24:48" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "23:36:39" , 
"departure_time" : "23:37:34" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "23:43:55" , 
"departure_time" : "23:45:34" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "23:57:39" , 
"departure_time" : "23:59:09" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "24:04:30" , 
"departure_time" : "24:04:57" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "24:27:27" , 
"departure_time" : "24:27:27" , 
"distance_traveled" : 67.6532
} ], 
"24" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "22:51:00" , 
"departure_time" : "22:53:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "23:03:38" , 
"departure_time" : "23:04:33" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "23:12:55" , 
"departure_time" : "23:14:13" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "23:24:18" , 
"departure_time" : "23:25:11" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "23:36:53" , 
"departure_time" : "23:38:09" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "23:44:16" , 
"departure_time" : "23:45:53" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "23:57:37" , 
"departure_time" : "23:58:20" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "24:03:43" , 
"departure_time" : "24:05:15" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "24:28:32" , 
"departure_time" : "24:28:32" , 
"distance_traveled" : 67.6532
} ], 
"25" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "04:11:00" , 
"departure_time" : "04:14:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "04:23:32" , 
"departure_time" : "04:25:06" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "04:33:34" , 
"departure_time" : "04:33:43" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "04:43:09" , 
"departure_time" : "04:43:33" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "04:56:24" , 
"departure_time" : "04:56:41" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "05:03:17" , 
"departure_time" : "05:04:02" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "05:15:45" , 
"departure_time" : "05:17:14" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "05:23:29" , 
"departure_time" : "05:23:54" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "05:47:25" , 
"departure_time" : "05:47:25" , 
"distance_traveled" : 67.6532
} ], 
"26" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "04:11:00" , 
"departure_time" : "04:11:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "04:22:21" , 
"departure_time" : "04:22:51" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "04:32:30" , 
"departure_time" : "04:33:03" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "04:43:33" , 
"departure_time" : "04:44:15" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "04:56:42" , 
"departure_time" : "04:57:16" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "05:03:34" , 
"departure_time" : "05:04:10" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "05:15:36" , 
"departure_time" : "05:15:42" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "05:22:06" , 
"departure_time" : "05:23:25" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "05:48:19" , 
"departure_time" : "05:48:19" , 
"distance_traveled" : 67.6532
} ], 
"27" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "05:38:00" , 
"departure_time" : "05:39:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "05:49:26" , 
"departure_time" : "05:49:48" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "05:59:22" , 
"departure_time" : "06:00:23" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "06:11:01" , 
"departure_time" : "06:11:56" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "06:23:55" , 
"departure_time" : "06:25:29" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "06:31:34" , 
"departure_time" : "06:32:16" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "06:44:42" , 
"departure_time" : "06:45:49" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "06:52:07" , 
"departure_time" : "06:52:58" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "07:15:51" , 
"departure_time" : "07:15:51" , 
"distance_traveled" : 67.6532
} ], 
"28" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "05:38:00" , 
"departure_time" : "05:40:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "05:50:36" , 
"departure_time" : "05:51:36" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "06:00:00" , 
"departure_time" : "06:00:51" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "06:10:51" , 
"departure_time" : "06:11:15" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "06:23:24" , 
"departure_time" : "06:24:16" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "06:30:52" , 
"departure_time" : "06:31:37" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "06:44:45" , 
"departure_time" : "06:45:57" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "06:52:12" , 
"departure_time" : "06:53:10" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "07:15:58" , 
"departure_time" : "07:15:58" , 
"distance_traveled" : 67.6532
} ], 
"29" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "06:49:00" , 
"departure_time" : "06:50:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "07:00:25" , 
"departure_time" : "07:02:02" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "07:11:37" , 
"departure_time" : "07:12:15" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "07:24:38" , 
"departure_time" : "07:24:40" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "07:37:02" , 
"departure_time" : "07:38:24" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "07:45:22" , 
"departure_time" : "07:45:56" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "07:57:34" , 
"departure_time" : "07:58:48" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "08:05:14" , 
"departure_time" : "08:05:41" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "08:28:27" , 
"departure_time" : "08:28:27" , 
"distance_traveled" : 67.6532
} ], 
"30" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "06:49:00" , 
"departure_time" : "06:49:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "07:00:08" , 
"departure_time" : "07:01:21" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "07:11:13" , 
"departure_time" : "07:12:42" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "07:25:29" , 
"departure_time" : "07:26:44" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "07:38:15" , 
"departure_time" : "07:39:34" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "07:45:19" , 
"departure_time" : "07:46:03" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "07:57:44" , 
"departure_time" : "07:58:25" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "08:04:41" , 
"departure_time" : "08:05:34" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "08:28:53" , 
"departure_time" : "08:28:53" , 
"distance_traveled" : 67.6532
} ], 
"31" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "08:20:00" , 
"departure_time" : "08:21:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "08:31:35" , 
"departure_time" : "08:32:58" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "08:42:23" , 
"departure_time" : "08:43:22" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "08:55:59" , 
"departure_time" : "08:57:24" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "09:09:25" , 
"departure_time" : "09:10:23" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "09:16:58" , 
"departure_time" : "09:17:46" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "09:28:48" , 
"departure_time" : "09:29:40" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "09:35:52" , 
"departure_time" : "09:36:19" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "10:00:27" , 
"departure_time" : "10:00:27" , 
"distance_traveled" : 67.6532
} ], 
"32" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "08:20:00" , 
"departure_time" : "08:21:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "08:31:41" , 
"departure_time" : "08:31:55" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "08:41:14" , 
"departure_time" : "08:42:21" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "08:56:07" , 
"departure_time" : "08:57:17" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "09:09:10" , 
"departure_time" : "09:09:24" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "09:16:14" , 
"departure_time" : "09:17:30" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "09:29:16" , 
"departure_time" : "09:29:21" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "09:35:05" , 
"departure_time" : "09:35:41" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "10:00:36" , 
"departure_time" : "10:00:36" , 
"distance_traveled" : 67.6532
} ], 
"33" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "10:12:00" , 
"departure_time" : "10:13:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "10:24:16" , 
"departure_time" : "10:24:54" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "10:36:38" , 
"departure_time" : "10:37:04" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "10:47:26" , 
"departure_time" : "10:48:52" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "11:01:26" , 
"departure_time" : "11:02:00" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "11:07:34" , 
"departure_time" : "11:07:42" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "11:20:08" , 
"departure_time" : "11:21:35" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "11:28:27" , 
"departure_time" : "11:28:59" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "11:52:32" , 
"departure_time" : "11:52:32" , 
"distance_traveled" : 67.6532
} ], 
"34" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "10:12:00" , 
"departure_time" : "10:13:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "10:23:57" , 
"departure_time" : "10:25:21" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "10:37:24" , 
"departure_time" : "10:37:47" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "10:47:23" , 
"departure_time" : "10:48:06" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "11:00:43" , 
"departure_time" : "11:01:54" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "11:08:11" , 
"departure_time" : "11:08:12" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "11:20:01" , 
"departure_time" : "11:20:08" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "11:27:07" , 
"departure_time" : "11:27:16" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "11:52:09" , 
"departure_time" : "11:52:09" , 
"distance_traveled" : 67.6532
} ], 
"35" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "12:04:00" , 
"departure_time" : "12:05:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "12:15:51" , 
"departure_time" : "12:17:24" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "12:29:33" , 
"departure_time" : "12:30:41" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "12:40:08" , 
"departure_time" : "12:41:32" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "12:53:24" , 
"departure_time" : "12:53:27" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "12:59:03" , 
"departure_time" : "13:00:04" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "13:12:01" , 
"departure_time" : "13:13:01" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "13:19:00" , 
"departure_time" : "13:20:13" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "13:44:13" , 
"departure_time" : "13:44:13" , 
"distance_traveled" : 67.6532
} ], 
"36" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "12:04:00" , 
"departure_time" : "12:06:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "12:16:36" , 
"departure_time" : "12:18:08" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "12:29:32" , 
"departure_time" : "12:31:05" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "12:40:33" , 
"departure_time" : "12:40:38" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "12:52:05" , 
"departure_time" : "12:52:54" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "12:59:49" , 
"departure_time" : "13:00:22" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "13:11:33" , 
"departure_time" : "13:12:24" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "13:18:51" , 
"departure_time" : "13:20:03" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "13:44:12" , 
"departure_time" : "13:44:12" , 
"distance_traveled" : 67.6532
} ], 
"37" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "13:55:00" , 
"departure_time" : "13:56:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "14:06:05" , 
"departure_time" : "14:07:12" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "14:20:07" , 
"departure_time" : "14:21:01" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "14:30:54" , 
"departure_time" : "14:31:03" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "14:43:09" , 
"departure_time" : "14:43:58" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "14:51:49" , 
"departure_time" : "14:51:53" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "15:03:04" , 
"departure_time" : "15:04:17" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "15:11:13" , 
"departure_time" : "15:12:19" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "15:35:06" , 
"departure_time" : "15:35:06" , 
"distance_traveled" : 67.6532
} ], 
"38" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "13:55:00" , 
"departure_time" : "13:56:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "14:06:23" , 
"departure_time" : "14:07:37" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "14:20:14" , 
"departure_time" : "14:20:43" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "14:30:29" , 
"departure_time" : "14:32:02" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "14:44:33" , 
"departure_time" : "14:44:57" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "14:51:24" , 
"departure_time" : "14:51:36" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "15:03:12" , 
"departure_time" : "15:04:08" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "15:10:56" , 
"departure_time" : "15:12:29" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "15:35:33" , 
"departure_time" : "15:35:33" , 
"distance_traveled" : 67.6532
} ], 
"39" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "15:47:00" , 
"departure_time" : "15:49:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "15:59:01" , 
"departure_time" : "15:59:43" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "16:11:42" , 
"departure_time" : "16:13:01" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "16:23:19" , 
"departure_time" : "16:24:30" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "16:36:11" , 
"departure_time" : "16:37:44" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "16:43:33" , 
"departure_time" : "16:45:06" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "16:56:33" , 
"departure_time" : "16:57:26" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "17:02:53" , 
"departure_time" : "17:03:27" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "17:27:34" , 
"departure_time" : "17:27:34" , 
"distance_traveled" : 67.6532
} ], 
"40" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "15:47:00" , 
"departure_time" : "15:48:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "15:59:03" , 
"departure_time" : "16:00:02" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "16:11:59" , 
"departure_time" : "16:12:50" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "16:22:51" , 
"departure_time" : "16:22:59" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "16:35:08" , 
"departure_time" : "16:36:40" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "16:43:32" , 
"departure_time" : "16:45:04" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "16:56:32" , 
"departure_time" : "16:58:09" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "17:03:37" , 
"departure_time" : "17:04:51" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "17:28:14" , 
"departure_time" : "17:28:14" , 
"distance_traveled" : 67.6532
} ], 
"41" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "16:59:00" , 
"departure_time" : "17:00:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "17:10:11" , 
"departure_time" : "17:10:37" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "17:20:26" , 
"departure_time" : "17:21:37" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "17:32:11" , 
"departure_time" : "17:33:13" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "17:48:02" , 
"departure_time" : "17:48:21" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "17:54:19" , 
"departure_time" : "17:55:36" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "18:08:17" , 
"departure_time" : "18:08:57" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "18:14:40" , 
"departure_time" : "18:15:28" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "18:39:48" , 
"departure_time" : "18:39:48" , 
"distance_traveled" : 67.6532
} ], 
"42" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "16:59:00" , 
"departure_time" : "17:00:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "17:10:54" , 
"departure_time" : "17:11:27" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "17:20:33" , 
"departure_time" : "17:21:21" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "17:31:48" , 
"departure_time" : "17:33:01" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "17:48:13" , 
"departure_time" : "17:48:24" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "17:54:11" , 
"departure_time" : "17:55:34" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "18:08:23" , 
"departure_time" : "18:09:06" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "18:14:43" , 
"departure_time" : "18:15:23" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "18:39:40" , 
"departure_time" : "18:39:40" , 
"distance_traveled" : 67.6532
} ], 
"43" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "18:54:00" , 
"departure_time" : "18:55:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "19:06:14" , 
"departure_time" : "19:07:23" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "19:16:09" , 
"departure_time" : "19:17:27" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "19:27:18" , 
"departure_time" : "19:28:20" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "19:41:02" , 
"departure_time" : "19:41:13" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "19:50:11" , 
"departure_time" : "19:50:59" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "20:02:48" , 
"departure_time" : "20:03:31" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "20:09:43" , 
"departure_time" : "20:09:55" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "20:34:12" , 
"departure_time" : "20:34:12" , 
"distance_traveled" : 67.6532
} ], 
"44" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "18:54:00" , 
"departure_time" : "18:55:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "19:06:34" , 
"departure_time" : "19:08:00" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "19:16:26" , 
"departure_time" : "19:17:25" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "19:26:59" , 
"departure_time" : "19:28:05" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "19:41:06" , 
"departure_time" : "19:42:32" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "19:51:26" , 
"departure_time" : "19:51:49" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "20:02:23" , 
"departure_time" : "20:02:27" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "20:09:04" , 
"departure_time" : "20:09:56" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "20:34:52" , 
"departure_time" : "20:34:52" , 
"distance_traveled" : 67.6532
} ], 
"45" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "20:53:00" , 
"departure_time" : "20:54:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "21:05:07" , 
"departure_time" : "21:06:13" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "21:15:06" , 
"departure_time" : "21:16:38" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "21:26:32" , 
"departure_time" : "21:26:58" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "21:38:26" , 
"departure_time" : "21:39:36" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "21:49:10" , 
"departure_time" : "21:49:50" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "22:00:40" , 
"departure_time" : "22:01:29" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "22:07:49" , 
"departure_time" : "22:09:11" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "22:33:22" , 
"departure_time" : "22:33:22" , 
"distance_traveled" : 67.6532
} ], 
"46" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "20:53:00" , 
"departure_time" : "20:55:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "21:05:08" , 
"departure_time" : "21:06:47" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "21:15:39" , 
"departure_time" : "21:16:47" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "21:26:08" , 
"departure_time" : "21:27:10" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "21:39:02" , 
"departure_time" : "21:39:28" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "21:48:26" , 
"departure_time" : "21:49:51" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "22:01:25" , 
"departure_time" : "22:01:38" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "22:07:13" , 
"departure_time" : "22:07:20" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "22:32:07" , 
"departure_time" : "22:32:07" , 
"distance_traveled" : 67.6532
} ], 
"47" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "22:51:00" , 
"departure_time" : "22:52:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "23:03:32" , 
"departure_time" : "23:05:04" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "23:13:32" , 
"departure_time" : "23:15:01" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "23:24:29" , 
"departure_time" : "23:24:50" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "23:36:21" , 
"departure_time" : "23:36:57" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "23:43:36" , 
"departure_time" : "23:45:02" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "23:57:26" , 
"departure_time" : "23:58:01" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "24:03:35" , 
"departure_time" : "24:03:55" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "24:27:20" , 
"departure_time" : "24:27:20" , 
"distance_traveled" : 67.6532
} ], 
"48" :  [ 
{ 
"stop_id" : 10,
"arrival_time" : "22:51:00" , 
"departure_time" : "22:51:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 2,
"arrival_time" : "23:02:23" , 
"departure_time" : "23:02:34" , 
"distance_traveled" : 5.8924
}, 
{ 
"stop_id" : 39,
"arrival_time" : "23:12:11" , 
"departure_time" : "23:13:11" , 
"distance_traveled" : 16.4295
}, 
{ 
"stop_id" : 55,
"arrival_time" : "23:24:00" , 
"departure_time" : "23:25:12" , 
"distance_traveled" : 27.2915
}, 
{ 
"stop_id" : 9,
"arrival_time" : "23:37:12" , 
"departure_time" : "23:38:01" , 
"distance_traveled" : 40.2494
}, 
{ 
"stop_id" : 71,
"arrival_time" : "23:43:49" , 
"departure_time" : "23:44:59" , 
"distance_traveled" : 46.3121
}, 
{ 
"stop_id" : 28,
"arrival_time" : "23:57:10" , 
"departure_time" : "23:57:16" , 
"distance_traveled" : 53.536
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "24:03:06" , 
"departure_time" : "24:03:11" , 
"distance_traveled" : 57.3989
}, 
{ 
"stop_id" : 1,
"arrival_time" : "24:27:05" , 
"departure_time" : "24:27:05" , 
"distance_traveled" : 67.6532
} ], 
"49" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "24:50:00" , 
"departure_time" : "24:51:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "25:12:15" , 
"departure_time" : "25:12:27" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "25:18:12" , 
"departure_time" : "25:18:59" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "25:30:47" , 
"departure_time" : "25:32:21" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "25:38:34" , 
"departure_time" : "25:38:45" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "25:50:11" , 
"departure_time" : "25:51:19" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "26:02:08" , 
"departure_time" : "26:03:45" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "26:12:37" , 
"departure_time" : "26:13:05" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "26:24:28" , 
"departure_time" : "26:24:28" , 
"distance_traveled" : 67.7758
} ], 
"50" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "24:50:00" , 
"departure_time" : "24:50:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "25:11:18" , 
"departure_time" : "25:11:55" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "25:18:37" , 
"departure_time" : "25:20:00" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "25:31:23" , 
"departure_time" : "25:31:41" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "25:37:18" , 
"departure_time" : "25:38:44" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "25:51:26" , 
"departure_time" : "25:52:37" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "26:02:11" , 
"departure_time" : "26:02:37" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "26:11:26" , 
"departure_time" : "26:12:49" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "26:25:23" , 
"departure_time" : "26:25:23" , 
"distance_traveled" : 67.7758
} ], 
"51" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "24:50:00" , 
"departure_time" : "24:52:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "25:12:22" , 
"departure_time" : "25:12:36" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "25:18:14" , 
"departure_time" : "25:19:03" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "25:30:49" , 
"departure_time" : "25:31:21" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "25:37:32" , 
"departure_time" : "25:38:03" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "25:50:31" , 
"departure_time" : "25:52:02" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "26:02:31" , 
"departure_time" : "26:03:35" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "26:12:04" , 
"departure_time" : "26:12:17" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "26:24:13" , 
"departure_time" : "26:24:13" , 
"distance_traveled" : 67.7758
} ], 
"52" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "24:50:00" , 
"departure_time" : "24:50:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "25:11:04" , 
"departure_time" : "25:11:12" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "25:18:08" , 
"departure_time" : "25:18:15" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "25:30:07" , 
"departure_time" : "25:31:40" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "25:38:33" , 
"departure_time" : "25:38:50" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "25:50:17" , 
"departure_time" : "25:50:49" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "26:01:32" , 
"departure_time" : "26:02:55" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "26:12:23" , 
"departure_time" : "26:13:48" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "26:25:25" , 
"departure_time" : "26:25:25" , 
"distance_traveled" : 67.7758
} ], 
"53" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "24:50:00" , 
"departure_time" : "24:51:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "25:11:32" , 
"departure_time" : "25:12:53" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "25:19:21" , 
"departure_time" : "25:21:01" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "25:31:40" , 
"departure_time" : "25:32:27" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "25:37:47" , 
"departure_time" : "25:38:51" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "25:51:04" , 
"departure_time" : "25:51:06" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "26:01:02" , 
"departure_time" : "26:01:40" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "26:11:38" , 
"departure_time" : "26:12:56" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "26:25:18" , 
"departure_time" : "26:25:18" , 
"distance_traveled" : 67.7758
} ], 
"54" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "06:28:00" , 
"departure_time" : "06:30:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "06:49:45" , 
"departure_time" : "06:49:58" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "06:56:13" , 
"departure_time" : "06:56:15" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "07:09:02" , 
"departure_time" : "07:09:34" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "07:16:32" , 
"departure_time" : "07:17:42" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "07:30:10" , 
"departure_time" : "07:30:41" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "07:40:31" , 
"departure_time" : "07:40:35" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "07:50:04" , 
"departure_time" : "07:50:24" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "08:03:20" , 
"departure_time" : "08:03:20" , 
"distance_traveled" : 67.7758
} ], 
"55" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "06:28:00" , 
"departure_time" : "06:29:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "06:49:52" , 
"departure_time" : "06:51:23" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "06:57:31" , 
"departure_time" : "06:57:47" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "07:09:16" , 
"departure_time" : "07:09:46" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "07:16:30" , 
"departure_time" : "07:16:59" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "07:29:29" , 
"departure_time" : "07:30:50" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "07:41:21" , 
"departure_time" : "07:41:40" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "07:50:19" , 
"departure_time" : "07:50:36" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "08:03:17" , 
"departure_time" : "08:03:17" , 
"distance_traveled" : 67.7758
} ], 
"56" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "08:20:00" , 
"departure_time" : "08:21:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "08:42:40" , 
"departure_time" : "08:42:46" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "08:48:06" , 
"departure_time" : "08:49:30" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "09:01:24" , 
"departure_time" : "09:02:16" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "09:07:52" , 
"departure_time" : "09:09:20" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "09:21:28" , 
"departure_time" : "09:22:58" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "09:32:30" , 
"departure_time" : "09:33:26" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "09:41:56" , 
"departure_time" : "09:42:13" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "09:54:17" , 
"departure_time" : "09:54:17" , 
"distance_traveled" : 67.7758
} ], 
"57" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "08:20:00" , 
"departure_time" : "08:20:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "08:41:19" , 
"departure_time" : "08:42:43" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "08:49:24" , 
"departure_time" : "08:50:31" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "09:01:07" , 
"departure_time" : "09:02:35" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "09:08:28" , 
"departure_time" : "09:09:30" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "09:21:02" , 
"departure_time" : "09:21:25" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "09:31:23" , 
"departure_time" : "09:32:12" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "09:41:49" , 
"departure_time" : "09:42:12" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "09:54:23" , 
"departure_time" : "09:54:23" , 
"distance_traveled" : 67.7758
} ], 
"58" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "09:53:00" , 
"departure_time" : "09:53:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "10:14:19" , 
"departure_time" : "10:15:01" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "10:21:42" , 
"departure_time" : "10:22:37" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "10:34:55" , 
"departure_time" : "10:36:11" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "10:42:16" , 
"departure_time" : "10:42:35" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "10:54:19" , 
"departure_time" : "10:55:05" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "11:05:46" , 
"departure_time" : "11:06:37" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "11:15:51" , 
"departure_time" : "11:17:05" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "11:29:14" , 
"departure_time" : "11:29:14" , 
"distance_traveled" : 67.7758
} ], 
"59" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "09:53:00" , 
"departure_time" : "09:55:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "10:15:19" , 
"departure_time" : "10:16:26" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "10:22:07" , 
"departure_time" : "10:22:42" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "10:34:35" , 
"departure_time" : "10:36:04" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "10:42:29" , 
"departure_time" : "10:43:53" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "10:55:24" , 
"departure_time" : "10:56:38" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "11:06:14" , 
"departure_time" : "11:07:00" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "11:15:46" , 
"departure_time" : "11:16:29" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "11:28:43" , 
"departure_time" : "11:28:43" , 
"distance_traveled" : 67.7758
} ], 
"60" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "11:25:00" , 
"departure_time" : "11:26:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "11:47:15" , 
"departure_time" : "11:48:39" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "11:54:24" , 
"departure_time" : "11:55:40" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "12:06:16" , 
"departure_time" : "12:07:42" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "12:13:26" , 
"departure_time" : "12:14:57" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "12:27:31" , 
"departure_time" : "12:28:31" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "12:37:00" , 
"departure_time" : "12:37:49" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "12:46:49" , 
"departure_time" : "12:47:37" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "13:00:48" , 
"departure_time" : "13:00:48" , 
"distance_traveled" : 67.7758
} ], 
"61" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "11:25:00" , 
"departure_time" : "11:26:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "11:47:11" , 
"departure_time" : "11:48:39" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "11:54:28" , 
"departure_time" : "11:55:05" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "12:05:37" , 
"departure_time" : "12:07:08" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "12:13:31" , 
"departure_time" : "12:14:13" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "12:26:42" , 
"departure_time" : "12:28:18" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "12:37:36" , 
"departure_time" : "12:37:52" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "12:46:16" , 
"departure_time" : "12:46:37" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "13:00:21" , 
"departure_time" : "13:00:21" , 
"distance_traveled" : 67.7758
} ], 
"62" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "12:38:00" , 
"departure_time" : "12:39:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "13:00:27" , 
"departure_time" : "13:01:12" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "13:06:45" , 
"departure_time" : "13:07:19" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "13:19:34" , 
"departure_time" : "13:19:54" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "13:27:20" , 
"departure_time" : "13:28:42" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "13:41:22" , 
"departure_time" : "13:42:20" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "13:50:58" , 
"departure_time" : "13:51:29" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "14:01:31" , 
"departure_time" : "14:01:43" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "14:14:12" , 
"departure_time" : "14:14:12" , 
"distance_traveled" : 67.7758
} ], 
"63" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "12:38:00" , 
"departure_time" : "12:38:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "12:59:13" , 
"departure_time" : "13:00:31" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "13:07:18" , 
"departure_time" : "13:07:27" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "13:19:09" , 
"departure_time" : "13:19:47" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "13:27:38" , 
"departure_time" : "13:28:51" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "13:41:13" , 
"departure_time" : "13:42:27" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "13:51:14" , 
"departure_time" : "13:51:35" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "14:01:21" , 
"departure_time" : "14:02:30" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "14:15:09" , 
"departure_time" : "14:15:09" , 
"distance_traveled" : 67.7758
} ], 
"64" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "14:31:00" , 
"departure_time" : "14:32:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "14:52:04" , 
"departure_time" : "14:53:09" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "15:00:05" , 
"departure_time" : "15:00:20" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "15:11:15" , 
"departure_time" : "15:12:39" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "15:20:24" , 
"departure_time" : "15:21:12" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "15:32:48" , 
"departure_time" : "15:33:04" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "15:43:16" , 
"departure_time" : "15:44:22" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "15:54:06" , 
"departure_time" : "15:55:00" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "16:06:54" , 
"departure_time" : "16:06:54" , 
"distance_traveled" : 67.7758
} ], 
"65" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "14:31:00" , 
"departure_time" : "14:32:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "14:52:39" , 
"departure_time" : "14:52:57" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "14:59:18" , 
"departure_time" : "14:59:21" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "15:11:03" , 
"departure_time" : "15:11:19" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "15:19:16" , 
"departure_time" : "15:20:26" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "15:33:10" , 
"departure_time" : "15:34:44" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "15:44:34" , 
"departure_time" : "15:45:55" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "15:54:21" , 
"departure_time" : "15:55:53" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "16:07:32" , 
"departure_time" : "16:07:32" , 
"distance_traveled" : 67.7758
} ], 
"66" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "16:23:00" , 
"departure_time" : "16:24:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "16:44:03" , 
"departure_time" : "16:44:32" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "16:51:29" , 
"departure_time" : "16:53:05" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "17:05:36" , 
"departure_time" : "17:06:21" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "17:11:45" , 
"departure_time" : "17:13:13" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "17:25:28" , 
"departure_time" : "17:26:38" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "17:35:10" , 
"departure_time" : "17:35:23" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "17:45:13" , 
"departure_time" : "17:45:57" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "17:58:44" , 
"departure_time" : "17:58:44" , 
"distance_traveled" : 67.7758
} ], 
"67" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "16:23:00" , 
"departure_time" : "16:25:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "16:45:29" , 
"departure_time" : "16:46:15" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "16:51:46" , 
"departure_time" : "16:52:23" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "17:04:37" , 
"departure_time" : "17:05:54" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "17:12:17" , 
"departure_time" : "17:12:18" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "17:24:01" , 
"departure_time" : "17:25:22" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "17:35:21" , 
"departure_time" : "17:36:10" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "17:45:49" , 
"departure_time" : "17:45:54" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "17:58:05" , 
"departure_time" : "17:58:05" , 
"distance_traveled" : 67.7758
} ], 
"68" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "18:15:00" , 
"departure_time" : "18:15:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "18:36:15" , 
"departure_time" : "18:36:18" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "18:43:03" , 
"departure_time" : "18:43:18" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "18:55:15" , 
"departure_time" : "18:55:23" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "19:03:08" , 
"departure_time" : "19:04:06" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "19:16:58" , 
"departure_time" : "19:17:18" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "19:26:20" , 
"departure_time" : "19:27:01" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "19:37:41" , 
"departure_time" : "19:38:38" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "19:50:57" , 
"departure_time" : "19:50:57" , 
"distance_traveled" : 67.7758
} ], 
"69" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "18:15:00" , 
"departure_time" : "18:16:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "18:36:33" , 
"departure_time" : "18:37:13" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "18:43:40" , 
"departure_time" : "18:44:11" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "18:55:31" , 
"departure_time" : "18:56:16" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "19:03:45" , 
"departure_time" : "19:04:37" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "19:16:52" , 
"departure_time" : "19:18:18" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "19:27:26" , 
"departure_time" : "19:28:42" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "19:38:16" , 
"departure_time" : "19:38:46" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "19:50:30" , 
"departure_time" : "19:50:30" , 
"distance_traveled" : 67.7758
} ], 
"70" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "19:50:00" , 
"departure_time" : "19:51:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "20:12:07" , 
"departure_time" : "20:12:16" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "20:18:09" , 
"departure_time" : "20:18:40" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "20:31:31" , 
"departure_time" : "20:32:53" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "20:39:22" , 
"departure_time" : "20:40:05" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "20:51:43" , 
"departure_time" : "20:52:50" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "21:03:07" , 
"departure_time" : "21:03:28" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "21:12:21" , 
"departure_time" : "21:12:39" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "21:25:18" , 
"departure_time" : "21:25:18" , 
"distance_traveled" : 67.7758
} ], 
"71" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "19:50:00" , 
"departure_time" : "19:50:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "20:11:18" , 
"departure_time" : "20:12:12" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "20:18:54" , 
"departure_time" : "20:19:07" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "20:31:13" , 
"departure_time" : "20:32:04" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "20:38:51" , 
"departure_time" : "20:39:29" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "20:51:38" , 
"departure_time" : "20:53:13" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "21:03:35" , 
"departure_time" : "21:04:14" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "21:12:39" , 
"departure_time" : "21:14:05" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "21:26:26" , 
"departure_time" : "21:26:26" , 
"distance_traveled" : 67.7758
} ], 
"72" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "21:24:00" , 
"departure_time" : "21:26:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "21:45:34" , 
"departure_time" : "21:46:40" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "21:53:06" , 
"departure_time" : "21:53:53" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "22:05:47" , 
"departure_time" : "22:06:52" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "22:13:05" , 
"departure_time" : "22:14:18" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "22:26:13" , 
"departure_time" : "22:26:29" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "22:36:16" , 
"departure_time" : "22:37:46" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "22:47:30" , 
"departure_time" : "22:48:25" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "22:59:55" , 
"departure_time" : "22:59:55" , 
"distance_traveled" : 67.7758
} ], 
"73" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "21:24:00" , 
"departure_time" : "21:25:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "21:45:28" , 
"departure_time" : "21:46:19" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "21:52:51" , 
"departure_time" : "21:53:43" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "22:05:52" , 
"departure_time" : "22:07:14" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "22:13:22" , 
"departure_time" : "22:14:04" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "22:25:42" , 
"departure_time" : "22:25:46" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "22:36:04" , 
"departure_time" : "22:36:39" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "22:46:35" , 
"departure_time" : "22:47:41" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "23:00:06" , 
"departure_time" : "23:00:06" , 
"distance_traveled" : 67.7758
} ], 
"74" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "22:55:00" , 
"departure_time" : "22:57:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "23:17:27" , 
"departure_time" : "23:18:41" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "23:24:14" , 
"departure_time" : "23:25:46" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "23:36:32" , 
"departure_time" : "23:36:59" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "23:45:27" , 
"departure_time" : "23:46:23" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "23:58:56" , 
"departure_time" : "23:59:54" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "24:09:58" , 
"departure_time" : "24:10:50" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "24:19:52" , 
"departure_time" : "24:20:02" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "24:32:10" , 
"departure_time" : "24:32:10" , 
"distance_traveled" : 67.7758
} ], 
"75" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "22:55:00" , 
"departure_time" : "22:55:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "23:16:05" , 
"departure_time" : "23:17:44" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "23:24:39" , 
"departure_time" : "23:26:18" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "23:36:39" , 
"departure_time" : "23:37:37" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "23:45:58" , 
"departure_time" : "23:47:29" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "23:59:31" , 
"departure_time" : "24:00:27" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "24:09:56" , 
"departure_time" : "24:10:34" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "24:19:38" , 
"departure_time" : "24:20:41" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "24:33:03" , 
"departure_time" : "24:33:03" , 
"distance_traveled" : 67.7758
} ], 
"76" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "06:11:00" , 
"departure_time" : "06:13:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "06:33:03" , 
"departure_time" : "06:33:28" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "06:39:25" , 
"departure_time" : "06:40:00" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "06:52:35" , 
"departure_time" : "06:52:51" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "06:59:16" , 
"departure_time" : "06:59:49" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "07:12:33" , 
"departure_time" : "07:12:56" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "07:23:23" , 
"departure_time" : "07:24:03" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "07:33:40" , 
"departure_time" : "07:34:09" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "07:46:29" , 
"departure_time" : "07:46:29" , 
"distance_traveled" : 67.7758
} ], 
"77" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "06:11:00" , 
"departure_time" : "06:12:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "06:32:43" , 
"departure_time" : "06:33:45" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "06:40:02" , 
"departure_time" : "06:40:14" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "06:52:12" , 
"departure_time" : "06:53:26" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "07:00:14" , 
"departure_time" : "07:01:29" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "07:13:15" , 
"departure_time" : "07:13:57" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "07:23:42" , 
"departure_time" : "07:25:21" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "07:34:39" , 
"departure_time" : "07:36:12" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "07:47:33" , 
"departure_time" : "07:47:33" , 
"distance_traveled" : 67.7758
} ], 
"78" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "07:43:00" , 
"departure_time" : "07:45:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "08:05:24" , 
"departure_time" : "08:07:00" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "08:12:36" , 
"departure_time" : "08:13:45" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "08:24:09" , 
"departure_time" : "08:24:47" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "08:30:38" , 
"departure_time" : "08:31:56" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "08:44:18" , 
"departure_time" : "08:44:53" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "08:54:35" , 
"departure_time" : "08:55:19" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "09:04:44" , 
"departure_time" : "09:06:18" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "09:18:34" , 
"departure_time" : "09:18:34" , 
"distance_traveled" : 67.7758
} ], 
"79" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "07:43:00" , 
"departure_time" : "07:44:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "08:04:06" , 
"departure_time" : "08:04:55" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "08:11:49" , 
"departure_time" : "08:12:16" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "08:23:27" , 
"departure_time" : "08:24:33" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "08:31:06" , 
"departure_time" : "08:32:41" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "08:44:35" , 
"departure_time" : "08:44:46" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "08:54:11" , 
"departure_time" : "08:55:28" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "09:05:17" , 
"departure_time" : "09:06:55" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "09:18:38" , 
"departure_time" : "09:18:38" , 
"distance_traveled" : 67.7758
} ], 
"80" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "09:14:00" , 
"departure_time" : "09:16:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "09:36:04" , 
"departure_time" : "09:36:22" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "09:42:18" , 
"departure_time" : "09:43:50" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "09:55:32" , 
"departure_time" : "09:56:43" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "10:03:11" , 
"departure_time" : "10:03:38" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "10:15:27" , 
"departure_time" : "10:16:18" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "10:25:51" , 
"departure_time" : "10:26:39" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "10:36:48" , 
"departure_time" : "10:37:33" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "10:49:45" , 
"departure_time" : "10:49:45" , 
"distance_traveled" : 67.7758
} ], 
"81" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "09:14:00" , 
"departure_time" : "09:15:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "09:35:49" , 
"departure_time" : "09:37:14" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "09:43:25" , 
"departure_time" : "09:44:49" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "09:55:24" , 
"departure_time" : "09:55:30" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "10:02:06" , 
"departure_time" : "10:02:34" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "10:15:28" , 
"departure_time" : "10:16:23" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "10:25:55" , 
"departure_time" : "10:26:28" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "10:36:33" , 
"departure_time" : "10:37:13" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "10:49:40" , 
"departure_time" : "10:49:40" , 
"distance_traveled" : 67.7758
} ], 
"82" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "11:06:00" , 
"departure_time" : "11:07:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "11:27:57" , 
"departure_time" : "11:29:21" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "11:35:24" , 
"departure_time" : "11:36:14" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "11:46:50" , 
"departure_time" : "11:47:10" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "11:54:20" , 
"departure_time" : "11:55:35" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "12:08:15" , 
"departure_time" : "12:08:48" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "12:17:33" , 
"departure_time" : "12:18:45" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "12:29:12" , 
"departure_time" : "12:30:23" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "12:42:11" , 
"departure_time" : "12:42:11" , 
"distance_traveled" : 67.7758
} ], 
"83" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "11:06:00" , 
"departure_time" : "11:07:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "11:27:10" , 
"departure_time" : "11:27:54" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "11:34:44" , 
"departure_time" : "11:35:09" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "11:46:25" , 
"departure_time" : "11:46:40" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "11:54:15" , 
"departure_time" : "11:55:18" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "12:08:03" , 
"departure_time" : "12:09:06" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "12:18:03" , 
"departure_time" : "12:18:10" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "12:28:07" , 
"departure_time" : "12:28:52" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "12:41:45" , 
"departure_time" : "12:41:45" , 
"distance_traveled" : 67.7758
} ], 
"84" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "12:58:00" , 
"departure_time" : "12:59:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "13:20:06" , 
"departure_time" : "13:21:46" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "13:27:40" , 
"departure_time" : "13:29:08" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "13:39:28" , 
"departure_time" : "13:41:05" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "13:46:37" , 
"departure_time" : "13:46:49" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "13:58:12" , 
"departure_time" : "13:58:16" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "14:09:04" , 
"departure_time" : "14:10:43" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "14:20:39" , 
"departure_time" : "14:21:53" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "14:33:14" , 
"departure_time" : "14:33:14" , 
"distance_traveled" : 67.7758
} ], 
"85" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "12:58:00" , 
"departure_time" : "12:59:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "13:19:07" , 
"departure_time" : "13:20:36" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "13:27:29" , 
"departure_time" : "13:27:42" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "13:38:13" , 
"departure_time" : "13:38:53" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "13:45:40" , 
"departure_time" : "13:46:18" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "13:58:38" , 
"departure_time" : "13:59:24" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "14:09:46" , 
"departure_time" : "14:11:10" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "14:20:24" , 
"departure_time" : "14:20:29" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "14:32:05" , 
"departure_time" : "14:32:05" , 
"distance_traveled" : 67.7758
} ], 
"86" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "14:49:00" , 
"departure_time" : "14:50:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "15:11:19" , 
"departure_time" : "15:11:47" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "15:17:28" , 
"departure_time" : "15:18:08" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "15:30:40" , 
"departure_time" : "15:31:46" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "15:38:06" , 
"departure_time" : "15:39:45" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "15:51:39" , 
"departure_time" : "15:52:59" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "16:01:20" , 
"departure_time" : "16:02:52" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "16:12:32" , 
"departure_time" : "16:13:31" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "16:24:59" , 
"departure_time" : "16:24:59" , 
"distance_traveled" : 67.7758
} ], 
"87" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "14:49:00" , 
"departure_time" : "14:51:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "15:11:35" , 
"departure_time" : "15:11:41" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "15:17:06" , 
"departure_time" : "15:17:19" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "15:30:13" , 
"departure_time" : "15:30:21" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "15:37:08" , 
"departure_time" : "15:38:33" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "15:51:25" , 
"departure_time" : "15:51:58" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "16:00:33" , 
"departure_time" : "16:01:47" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "16:12:14" , 
"departure_time" : "16:12:23" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "16:24:09" , 
"departure_time" : "16:24:09" , 
"distance_traveled" : 67.7758
} ], 
"88" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "16:41:00" , 
"departure_time" : "16:42:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "17:03:22" , 
"departure_time" : "17:04:44" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "17:10:22" , 
"departure_time" : "17:10:43" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "17:22:21" , 
"departure_time" : "17:23:34" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "17:30:13" , 
"departure_time" : "17:31:01" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "17:42:48" , 
"departure_time" : "17:43:06" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "17:52:18" , 
"departure_time" : "17:52:46" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "18:03:28" , 
"departure_time" : "18:04:17" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "18:16:49" , 
"departure_time" : "18:16:49" , 
"distance_traveled" : 67.7758
} ], 
"89" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "16:41:00" , 
"departure_time" : "16:42:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "17:03:00" , 
"departure_time" : "17:04:18" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "17:10:18" , 
"departure_time" : "17:10:41" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "17:22:23" , 
"departure_time" : "17:22:46" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "17:29:23" , 
"departure_time" : "17:29:46" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "17:42:23" , 
"departure_time" : "17:43:01" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "17:52:38" , 
"departure_time" : "17:53:51" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "18:04:13" , 
"departure_time" : "18:04:15" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "18:16:02" , 
"departure_time" : "18:16:02" , 
"distance_traveled" : 67.7758
} ], 
"90" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "17:53:00" , 
"departure_time" : "17:54:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "18:15:18" , 
"departure_time" : "18:15:26" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "18:21:08" , 
"departure_time" : "18:22:23" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "18:34:15" , 
"departure_time" : "18:35:04" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "18:40:49" , 
"departure_time" : "18:40:52" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "18:53:03" , 
"departure_time" : "18:54:26" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "19:05:23" , 
"departure_time" : "19:06:25" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "19:18:02" , 
"departure_time" : "19:18:38" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "19:31:36" , 
"departure_time" : "19:31:36" , 
"distance_traveled" : 67.7758
} ], 
"91" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "17:53:00" , 
"departure_time" : "17:53:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "18:14:22" , 
"departure_time" : "18:15:39" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "18:22:17" , 
"departure_time" : "18:22:30" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "18:33:13" , 
"departure_time" : "18:34:19" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "18:41:06" , 
"departure_time" : "18:42:05" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "18:53:59" , 
"departure_time" : "18:55:26" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "19:05:27" , 
"departure_time" : "19:06:01" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "19:17:34" , 
"departure_time" : "19:17:55" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "19:31:21" , 
"departure_time" : "19:31:21" , 
"distance_traveled" : 67.7758
} ], 
"92" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "19:03:00" , 
"departure_time" : "19:04:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "19:24:50" , 
"departure_time" : "19:26:09" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "19:32:19" , 
"departure_time" : "19:33:11" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "19:43:52" , 
"departure_time" : "19:45:09" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "19:51:17" , 
"departure_time" : "19:51:54" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "20:03:37" , 
"departure_time" : "20:04:20" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "20:14:43" , 
"departure_time" : "20:14:47" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "20:24:04" , 
"departure_time" : "20:25:19" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "20:38:15" , 
"departure_time" : "20:38:15" , 
"distance_traveled" : 67.7758
} ], 
"93" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "19:03:00" , 
"departure_time" : "19:04:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "19:24:17" , 
"departure_time" : "19:24:40" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "19:31:23" , 
"departure_time" : "19:31:47" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "19:43:24" , 
"departure_time" : "19:44:43" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "19:51:19" , 
"departure_time" : "19:52:08" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "20:03:49" , 
"departure_time" : "20:04:20" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "20:14:31" , 
"departure_time" : "20:15:01" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "20:24:30" , 
"departure_time" : "20:25:01" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "20:37:31" , 
"departure_time" : "20:37:31" , 
"distance_traveled" : 67.7758
} ], 
"94" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "21:01:00" , 
"departure_time" : "21:02:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "21:22:43" , 
"departure_time" : "21:23:33" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "21:29:50" , 
"departure_time" : "21:30:23" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "21:41:33" , 
"departure_time" : "21:41:51" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "21:48:18" , 
"departure_time" : "21:49:17" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "22:02:59" , 
"departure_time" : "22:04:19" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "22:13:20" , 
"departure_time" : "22:13:30" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "22:22:10" , 
"departure_time" : "22:23:31" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "22:37:21" , 
"departure_time" : "22:37:21" , 
"distance_traveled" : 67.7758
} ], 
"95" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "21:01:00" , 
"departure_time" : "21:02:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "21:22:10" , 
"departure_time" : "21:22:20" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "21:29:10" , 
"departure_time" : "21:29:37" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "21:41:27" , 
"departure_time" : "21:43:01" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "21:49:34" , 
"departure_time" : "21:51:04" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "22:03:30" , 
"departure_time" : "22:04:04" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "22:12:34" , 
"departure_time" : "22:12:43" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "22:22:09" , 
"departure_time" : "22:23:38" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "22:37:29" , 
"departure_time" : "22:37:29" , 
"distance_traveled" : 67.7758
} ], 
"96" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "22:55:00" , 
"departure_time" : "22:57:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "23:17:19" , 
"departure_time" : "23:17:41" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "23:23:22" , 
"departure_time" : "23:24:41" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "23:36:19" , 
"departure_time" : "23:36:31" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "23:45:12" , 
"departure_time" : "23:46:50" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "23:59:38" , 
"departure_time" : "24:01:14" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "24:10:36" , 
"departure_time" : "24:12:07" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "24:20:31" , 
"departure_time" : "24:21:08" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "24:32:37" , 
"departure_time" : "24:32:37" , 
"distance_traveled" : 67.7758
} ], 
"97" :  [ 
{ 
"stop_id" : 1,
"arrival_time" : "22:55:00" , 
"departure_time" : "22:55:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43298,
"arrival_time" : "23:16:14" , 
"departure_time" : "23:17:03" , 
"distance_traveled" : 10.2544
}, 
{ 
"stop_id" : 28,
"arrival_time" : "23:23:49" , 
"departure_time" : "23:24:08" , 
"distance_traveled" : 14.1172
}, 
{ 
"stop_id" : 71,
"arrival_time" : "23:35:19" , 
"departure_time" : "23:35:45" , 
"distance_traveled" : 21.3411
}, 
{ 
"stop_id" : 9,
"arrival_time" : "23:45:26" , 
"departure_time" : "23:46:33" , 
"distance_traveled" : 27.5265
}, 
{ 
"stop_id" : 55,
"arrival_time" : "23:59:07" , 
"departure_time" : "24:00:09" , 
"distance_traveled" : 40.4845
}, 
{ 
"stop_id" : 39,
"arrival_time" : "24:10:02" , 
"departure_time" : "24:11:07" , 
"distance_traveled" : 51.3464
}, 
{ 
"stop_id" : 2,
"arrival_time" : "24:20:05" , 
"departure_time" : "24:21:40" , 
"distance_traveled" : 61.8831
}, 
{ 
"stop_id" : 10,
"arrival_time" : "24:33:35" , 
"departure_time" : "24:33:35" , 
"distance_traveled" : 67.7758
} ], 
"98" :  [ 
{ 
"stop_id" : 67,
"arrival_time" : "05:21:00" , 
"departure_time" : "05:23:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "05:26:11" , 
"departure_time" : "05:27:46" , 
"distance_traveled" : 2.4222
}, 
{ 
"stop_id" : 35,
"arrival_time" : "05:34:35" , 
"departure_time" : "05:35:04" , 
"distance_traveled" : 7.3699
}, 
{ 
"stop_id" : 34,
"arrival_time" : "05:40:29" , 
"departure_time" : "05:42:02" , 
"distance_traveled" : 11.5784
}, 
{ 
"stop_id" : 96,
"arrival_time" : "05:46:33" , 
"departure_time" : "05:47:31" , 
"distance_traveled" : 14.3161
}, 
{ 
"stop_id" : 20,
"arrival_time" : "05:48:58" , 
"departure_time" : "05:50:38" , 
"distance_traveled" : 16.1373
}, 
{ 
"stop_id" : 147,
"arrival_time" : "05:55:40" , 
"departure_time" : "05:56:39" , 
"distance_traveled" : 20.2576
}, 
{ 
"stop_id" : 69,
"arrival_time" : "05:58:59" , 
"departure_time" : "06:00:19" , 
"distance_traveled" : 22.572
}, 
{ 
"stop_id" : 98,
"arrival_time" : "06:03:20" , 
"departure_time" : "06:04:31" , 
"distance_traveled" : 24.492
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "06:06:11" , 
"departure_time" : "06:06:48" , 
"distance_traveled" : 25.6345
}, 
{ 
"stop_id" : 72,
"arrival_time" : "06:09:37" , 
"departure_time" : "06:10:29" , 
"distance_traveled" : 28.5491
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "06:15:52" , 
"departure_time" : "06:16:52" , 
"distance_traveled" : 31.4549
}, 
{ 
"stop_id" : 89,
"arrival_time" : "06:19:00" , 
"departure_time" : "06:20:08" , 
"distance_traveled" : 32.3441
}, 
{ 
"stop_id" : 150,
"arrival_time" : "06:22:08" , 
"departure_time" : "06:22:28" , 
"distance_traveled" : 33.4888
}, 
{ 
"stop_id" : 153,
"arrival_time" : "06:23:20" , 
"departure_time" : "06:23:31" , 
"distance_traveled" : 34.4464
}, 
{ 
"stop_id" : 152,
"arrival_time" : "06:26:11" , 
"departure_time" : "06:26:54" , 
"distance_traveled" : 35.3068
}, 
{ 
"stop_id" : 14,
"arrival_time" : "06:30:43" , 
"departure_time" : "06:31:26" , 
"distance_traveled" : 35.9706
}, 
{ 
"stop_id" : 50,
"arrival_time" : "06:33:43" , 
"departure_time" : "06:35:07" , 
"distance_traveled" : 36.5735
}, 
{ 
"stop_id" : 19,
"arrival_time" : "06:36:24" , 
"departure_time" : "06:36:39" , 
"distance_traveled" : 37.1725
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:42:15" , 
"departure_time" : "06:42:27" , 
"distance_traveled" : 40.9758
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:00:12" , 
"departure_time" : "07:00:12" , 
"distance_traveled" : 48.764
} ], 
"99" :  [ 
{ 
"stop_id" : 67,
"arrival_time" : "05:21:00" , 
"departure_time" : "05:22:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "05:26:32" , 
"departure_time" : "05:26:44" , 
"distance_traveled" : 2.4222
}, 
{ 
"stop_id" : 35,
"arrival_time" : "05:33:12" , 
"departure_time" : "05:34:00" , 
"distance_traveled" : 7.3699
}, 
{ 
"stop_id" : 34,
"arrival_time" : "05:40:48" , 
"departure_time" : "05:42:23" , 
"distance_traveled" : 11.5784
}, 
{ 
"stop_id" : 96,
"arrival_time" : "05:46:35" , 
"departure_time" : "05:46:41" , 
"distance_traveled" : 14.3161
}, 
{ 
"stop_id" : 20,
"arrival_time" : "05:48:06" , 
"departure_time" : "05:49:12" , 
"distance_traveled" : 16.1373
}, 
{ 
"stop_id" : 147,
"arrival_time" : "05:55:06" , 
"departure_time" : "05:55:43" , 
"distance_traveled" : 20.2576
}, 
{ 
"stop_id" : 69,
"arrival_time" : "05:58:37" , 
"departure_time" : "05:59:57" , 
"distance_traveled" : 22.572
}, 
{ 
"stop_id" : 98,
"arrival_time" : "06:03:20" , 
"departure_time" : "06:04:57" , 
"distance_traveled" : 24.492
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "06:06:37" , 
"departure_time" : "06:06:51" , 
"distance_traveled" : 25.6345
}, 
{ 
"stop_id" : 72,
"arrival_time" : "06:09:14" , 
"departure_time" : "06:09:28" , 
"distance_traveled" : 28.5491
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "06:15:14" , 
"departure_time" : "06:16:28" , 
"distance_traveled" : 31.4549
}, 
{ 
"stop_id" : 89,
"arrival_time" : "06:19:14" , 
"departure_time" : "06:20:41" , 
"distance_traveled" : 32.3441
}, 
{ 
"stop_id" : 150,
"arrival_time" : "06:22:27" , 
"departure_time" : "06:22:49" , 
"distance_traveled" : 33.4888
}, 
{ 
"stop_id" : 153,
"arrival_time" : "06:23:22" , 
"departure_time" : "06:23:51" , 
"distance_traveled" : 34.4464
}, 
{ 
"stop_id" : 152,
"arrival_time" : "06:26:29" , 
"departure_time" : "06:27:38" , 
"distance_traveled" : 35.3068
}, 
{ 
"stop_id" : 14,
"arrival_time" : "06:31:09" , 
"departure_time" : "06:31:45" , 
"distance_traveled" : 35.9706
}, 
{ 
"stop_id" : 50,
"arrival_time" : "06:33:36" , 
"departure_time" : "06:34:54" , 
"distance_traveled" : 36.5735
}, 
{ 
"stop_id" : 19,
"arrival_time" : "06:36:18" , 
"departure_time" : "06:37:57" , 
"distance_traveled" : 37.1725
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:43:39" , 
"departure_time" : "06:44:24" , 
"distance_traveled" : 40.9758
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:00:45" , 
"departure_time" : "07:00:45" , 
"distance_traveled" : 48.764
} ], 
"100" :  [ 
{ 
"stop_id" : 67,
"arrival_time" : "06:21:00" , 
"departure_time" : "06:22:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "06:25:52" , 
"departure_time" : "06:25:53" , 
"distance_traveled" : 2.4222
}, 
{ 
"stop_id" : 35,
"arrival_time" : "06:33:01" , 
"departure_time" : "06:33:43" , 
"distance_traveled" : 7.3699
}, 
{ 
"stop_id" : 34,
"arrival_time" : "06:40:42" , 
"departure_time" : "06:41:23" , 
"distance_traveled" : 11.5784
}, 
{ 
"stop_id" : 96,
"arrival_time" : "06:45:41" , 
"departure_time" : "06:46:28" , 
"distance_traveled" : 14.3161
}, 
{ 
"stop_id" : 20,
"arrival_time" : "06:48:47" , 
"departure_time" : "06:49:56" , 
"distance_traveled" : 16.1373
}, 
{ 
"stop_id" : 147,
"arrival_time" : "06:55:09" , 
"departure_time" : "06:55:54" , 
"distance_traveled" : 20.2576
}, 
{ 
"stop_id" : 69,
"arrival_time" : "06:58:45" , 
"departure_time" : "06:59:49" , 
"distance_traveled" : 22.572
}, 
{ 
"stop_id" : 98,
"arrival_time" : "07:03:04" , 
"departure_time" : "07:04:31" , 
"distance_traveled" : 24.492
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "07:06:27" , 
"departure_time" : "07:06:49" , 
"distance_traveled" : 25.6345
}, 
{ 
"stop_id" : 72,
"arrival_time" : "07:09:22" , 
"departure_time" : "07:09:45" , 
"distance_traveled" : 28.5491
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "07:15:23" , 
"departure_time" : "07:16:27" , 
"distance_traveled" : 31.4549
}, 
{ 
"stop_id" : 89,
"arrival_time" : "07:19:04" , 
"departure_time" : "07:20:36" , 
"distance_traveled" : 32.3441
}, 
{ 
"stop_id" : 150,
"arrival_time" : "07:22:32" , 
"departure_time" : "07:22:39" , 
"distance_traveled" : 33.4888
}, 
{ 
"stop_id" : 153,
"arrival_time" : "07:23:07" , 
"departure_time" : "07:23:48" , 
"distance_traveled" : 34.4464
}, 
{ 
"stop_id" : 152,
"arrival_time" : "07:26:41" , 
"departure_time" : "07:27:13" , 
"distance_traveled" : 35.3068
}, 
{ 
"stop_id" : 14,
"arrival_time" : "07:30:32" , 
"departure_time" : "07:31:38" , 
"distance_traveled" : 35.9706
}, 
{ 
"stop_id" : 50,
"arrival_time" : "07:34:06" , 
"departure_time" : "07:35:08" , 
"distance_traveled" : 36.5735
}, 
{ 
"stop_id" : 19,
"arrival_time" : "07:36:02" , 
"departure_time" : "07:37:16" , 
"distance_traveled" : 37.1725
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:43:14" , 
"departure_time" : "07:44:45" , 
"distance_traveled" : 40.9758
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:01:31" , 
"departure_time" : "08:01:31" , 
"distance_traveled" : 48.764
} ], 
"101" :  [ 
{ 
"stop_id" : 67,
"arrival_time" : "06:21:00" , 
"departure_time" : "06:24:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "06:26:36" , 
"departure_time" : "06:27:39" , 
"distance_traveled" : 2.4222
}, 
{ 
"stop_id" : 35,
"arrival_time" : "06:34:03" , 
"departure_time" : "06:34:19" , 
"distance_traveled" : 7.3699
}, 
{ 
"stop_id" : 34,
"arrival_time" : "06:40:16" , 
"departure_time" : "06:41:40" , 
"distance_traveled" : 11.5784
}, 
{ 
"stop_id" : 96,
"arrival_time" : "06:46:24" , 
"departure_time" : "06:47:47" , 
"distance_traveled" : 14.3161
}, 
{ 
"stop_id" : 20,
"arrival_time" : "06:49:23" , 
"departure_time" : "06:50:25" , 
"distance_traveled" : 16.1373
}, 
{ 
"stop_id" : 147,
"arrival_time" : "06:55:02" , 
"departure_time" : "06:56:28" , 
"distance_traveled" : 20.2576
}, 
{ 
"stop_id" : 69,
"arrival_time" : "06:59:26" , 
"departure_time" : "06:59:38" , 
"distance_traveled" : 22.572
}, 
{ 
"stop_id" : 98,
"arrival_time" : "07:02:12" , 
"departure_time" : "07:02:28" , 
"distance_traveled" : 24.492
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "07:05:16" , 
"departure_time" : "07:05:25" , 
"distance_traveled" : 25.6345
}, 
{ 
"stop_id" : 72,
"arrival_time" : "07:09:09" , 
"departure_time" : "07:09:30" , 
"distance_traveled" : 28.5491
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "07:15:21" , 
"departure_time" : "07:16:44" , 
"distance_traveled" : 31.4549
}, 
{ 
"stop_id" : 89,
"arrival_time" : "07:19:23" , 
"departure_time" : "07:20:28" , 
"distance_traveled" : 32.3441
}, 
{ 
"stop_id" : 150,
"arrival_time" : "07:22:05" , 
"departure_time" : "07:22:18" , 
"distance_traveled" : 33.4888
}, 
{ 
"stop_id" : 153,
"arrival_time" : "07:23:13" , 
"departure_time" : "07:24:21" , 
"distance_traveled" : 34.4464
}, 
{ 
"stop_id" : 152,
"arrival_time" : "07:27:08" , 
"departure_time" : "07:27:39" , 
"distance_traveled" : 35.3068
}, 
{ 
"stop_id" : 14,
"arrival_time" : "07:30:31" , 
"departure_time" : "07:30:59" , 
"distance_traveled" : 35.9706
}, 
{ 
"stop_id" : 50,
"arrival_time" : "07:33:28" , 
"departure_time" : "07:34:01" , 
"distance_traveled" : 36.5735
}, 
{ 
"stop_id" : 19,
"arrival_time" : "07:35:33" , 
"departure_time" : "07:37:12" , 
"distance_traveled" : 37.1725
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:43:39" , 
"departure_time" : "07:43:41" , 
"distance_traveled" : 40.9758
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:00:02" , 
"departure_time" : "08:00:02" , 
"distance_traveled" : 48.764
} ], 
"102" :  [ 
{ 
"stop_id" : 67,
"arrival_time" : "07:25:00" , 
"departure_time" : "07:25:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "07:29:10" , 
"departure_time" : "07:29:12" , 
"distance_traveled" : 2.4222
}, 
{ 
"stop_id" : 35,
"arrival_time" : "07:37:02" , 
"departure_time" : "07:38:03" , 
"distance_traveled" : 7.3699
}, 
{ 
"stop_id" : 34,
"arrival_time" : "07:45:01" , 
"departure_time" : "07:46:32" , 
"distance_traveled" : 11.5784
}, 
{ 
"stop_id" : 96,
"arrival_time" : "07:49:31" , 
"departure_time" : "07:50:52" , 
"distance_traveled" : 14.3161
}, 
{ 
"stop_id" : 20,
"arrival_time" : "07:53:21" , 
"departure_time" : "07:54:33" , 
"distance_traveled" : 16.1373
}, 
{ 
"stop_id" : 147,
"arrival_time" : "07:59:12" , 
"departure_time" : "08:00:10" , 
"distance_traveled" : 20.2576
}, 
{ 
"stop_id" : 69,
"arrival_time" : "08:02:58" , 
"departure_time" : "08:03:26" , 
"distance_traveled" : 22.572
}, 
{ 
"stop_id" : 98,
"arrival_time" : "08:05:28" , 
"departure_time" : "08:07:07" , 
"distance_traveled" : 24.492
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "08:09:39" , 
"departure_time" : "08:10:30" , 
"distance_traveled" : 25.6345
}, 
{ 
"stop_id" : 72,
"arrival_time" : "08:11:51" , 
"departure_time" : "08:11:55" , 
"distance_traveled" : 28.5491
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "08:17:04" , 
"departure_time" : "08:17:29" , 
"distance_traveled" : 31.4549
}, 
{ 
"stop_id" : 89,
"arrival_time" : "08:20:25" , 
"departure_time" : "08:22:01" , 
"distance_traveled" : 32.3441
}, 
{ 
"stop_id" : 150,
"arrival_time" : "08:24:36" , 
"departure_time" : "08:24:49" , 
"distance_traveled" : 33.4888
}, 
{ 
"stop_id" : 153,
"arrival_time" : "08:25:13" , 
"departure_time" : "08:26:21" , 
"distance_traveled" : 34.4464
}, 
{ 
"stop_id" : 152,
"arrival_time" : "08:29:08" , 
"departure_time" : "08:30:34" , 
"distance_traveled" : 35.3068
}, 
{ 
"stop_id" : 14,
"arrival_time" : "08:33:26" , 
"departure_time" : "08:34:43" , 
"distance_traveled" : 35.9706
}, 
{ 
"stop_id" : 50,
"arrival_time" : "08:36:17" , 
"departure_time" : "08:37:14" , 
"distance_traveled" : 36.5735
}, 
{ 
"stop_id" : 19,
"arrival_time" : "08:37:57" , 
"departure_time" : "08:39:32" , 
"distance_traveled" : 37.1725
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:45:35" , 
"departure_time" : "08:47:09" , 
"distance_traveled" : 40.9758
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:01:34" , 
"departure_time" : "09:01:34" , 
"distance_traveled" : 48.764
} ], 
"103" :  [ 
{ 
"stop_id" : 67,
"arrival_time" : "07:25:00" , 
"departure_time" : "07:27:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "07:30:15" , 
"departure_time" : "07:30:39" , 
"distance_traveled" : 2.4222
}, 
{ 
"stop_id" : 35,
"arrival_time" : "07:37:24" , 
"departure_time" : "07:38:45" , 
"distance_traveled" : 7.3699
}, 
{ 
"stop_id" : 34,
"arrival_time" : "07:45:21" , 
"departure_time" : "07:45:58" , 
"distance_traveled" : 11.5784
}, 
{ 
"stop_id" : 96,
"arrival_time" : "07:48:37" , 
"departure_time" : "07:49:53" , 
"distance_traveled" : 14.3161
}, 
{ 
"stop_id" : 20,
"arrival_time" : "07:53:16" , 
"departure_time" : "07:53:54" , 
"distance_traveled" : 16.1373
}, 
{ 
"stop_id" : 147,
"arrival_time" : "07:58:38" , 
"departure_time" : "07:59:05" , 
"distance_traveled" : 20.2576
}, 
{ 
"stop_id" : 69,
"arrival_time" : "08:02:27" , 
"departure_time" : "08:03:09" , 
"distance_traveled" : 22.572
}, 
{ 
"stop_id" : 98,
"arrival_time" : "08:05:42" , 
"departure_time" : "08:05:49" , 
"distance_traveled" : 24.492
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "08:08:07" , 
"departure_time" : "08:09:10" , 
"distance_traveled" : 25.6345
}, 
{ 
"stop_id" : 72,
"arrival_time" : "08:12:03" , 
"departure_time" : "08:12:05" , 
"distance_traveled" : 28.5491
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "08:17:02" , 
"departure_time" : "08:17:07" , 
"distance_traveled" : 31.4549
}, 
{ 
"stop_id" : 89,
"arrival_time" : "08:20:05" , 
"departure_time" : "08:20:48" , 
"distance_traveled" : 32.3441
}, 
{ 
"stop_id" : 150,
"arrival_time" : "08:23:43" , 
"departure_time" : "08:25:22" , 
"distance_traveled" : 33.4888
}, 
{ 
"stop_id" : 153,
"arrival_time" : "08:26:39" , 
"departure_time" : "08:28:08" , 
"distance_traveled" : 34.4464
}, 
{ 
"stop_id" : 152,
"arrival_time" : "08:29:29" , 
"departure_time" : "08:30:42" , 
"distance_traveled" : 35.3068
}, 
{ 
"stop_id" : 14,
"arrival_time" : "08:33:13" , 
"departure_time" : "08:33:57" , 
"distance_traveled" : 35.9706
}, 
{ 
"stop_id" : 50,
"arrival_time" : "08:35:44" , 
"departure_time" : "08:36:55" , 
"distance_traveled" : 36.5735
}, 
{ 
"stop_id" : 19,
"arrival_time" : "08:38:11" , 
"departure_time" : "08:39:30" , 
"distance_traveled" : 37.1725
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:45:19" , 
"departure_time" : "08:46:24" , 
"distance_traveled" : 40.9758
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:01:05" , 
"departure_time" : "09:01:05" , 
"distance_traveled" : 48.764
} ], 
"104" :  [ 
{ 
"stop_id" : 67,
"arrival_time" : "06:42:00" , 
"departure_time" : "06:43:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "06:46:23" , 
"departure_time" : "06:47:54" , 
"distance_traveled" : 2.4222
}, 
{ 
"stop_id" : 35,
"arrival_time" : "06:55:31" , 
"departure_time" : "06:56:52" , 
"distance_traveled" : 7.3699
}, 
{ 
"stop_id" : 34,
"arrival_time" : "07:02:21" , 
"departure_time" : "07:02:47" , 
"distance_traveled" : 11.5784
}, 
{ 
"stop_id" : 96,
"arrival_time" : "07:05:26" , 
"departure_time" : "07:06:41" , 
"distance_traveled" : 14.3161
}, 
{ 
"stop_id" : 20,
"arrival_time" : "07:10:15" , 
"departure_time" : "07:11:45" , 
"distance_traveled" : 16.1373
}, 
{ 
"stop_id" : 147,
"arrival_time" : "07:16:30" , 
"departure_time" : "07:16:57" , 
"distance_traveled" : 20.2576
}, 
{ 
"stop_id" : 69,
"arrival_time" : "07:20:27" , 
"departure_time" : "07:20:34" , 
"distance_traveled" : 22.572
}, 
{ 
"stop_id" : 98,
"arrival_time" : "07:24:07" , 
"departure_time" : "07:24:22" , 
"distance_traveled" : 24.492
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "07:27:15" , 
"departure_time" : "07:28:18" , 
"distance_traveled" : 25.6345
}, 
{ 
"stop_id" : 72,
"arrival_time" : "07:32:03" , 
"departure_time" : "07:33:36" , 
"distance_traveled" : 28.5491
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "07:39:33" , 
"departure_time" : "07:40:58" , 
"distance_traveled" : 31.4549
}, 
{ 
"stop_id" : 153,
"arrival_time" : "07:45:25" , 
"departure_time" : "07:46:25" , 
"distance_traveled" : 34.4464
}, 
{ 
"stop_id" : 14,
"arrival_time" : "07:50:00" , 
"departure_time" : "07:50:15" , 
"distance_traveled" : 35.971
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:00:15" , 
"departure_time" : "08:01:48" , 
"distance_traveled" : 40.9862
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:18:33" , 
"departure_time" : "08:18:33" , 
"distance_traveled" : 48.7845
} ], 
"105" :  [ 
{ 
"stop_id" : 67,
"arrival_time" : "06:42:00" , 
"departure_time" : "06:45:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "06:47:36" , 
"departure_time" : "06:48:15" , 
"distance_traveled" : 2.4222
}, 
{ 
"stop_id" : 35,
"arrival_time" : "06:54:39" , 
"departure_time" : "06:56:13" , 
"distance_traveled" : 7.3699
}, 
{ 
"stop_id" : 34,
"arrival_time" : "07:02:34" , 
"departure_time" : "07:02:36" , 
"distance_traveled" : 11.5784
}, 
{ 
"stop_id" : 96,
"arrival_time" : "07:05:02" , 
"departure_time" : "07:05:48" , 
"distance_traveled" : 14.3161
}, 
{ 
"stop_id" : 20,
"arrival_time" : "07:09:46" , 
"departure_time" : "07:11:23" , 
"distance_traveled" : 16.1373
}, 
{ 
"stop_id" : 147,
"arrival_time" : "07:16:37" , 
"departure_time" : "07:16:59" , 
"distance_traveled" : 20.2576
}, 
{ 
"stop_id" : 69,
"arrival_time" : "07:20:22" , 
"departure_time" : "07:21:06" , 
"distance_traveled" : 22.572
}, 
{ 
"stop_id" : 98,
"arrival_time" : "07:24:44" , 
"departure_time" : "07:25:04" , 
"distance_traveled" : 24.492
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "07:27:20" , 
"departure_time" : "07:28:53" , 
"distance_traveled" : 25.6345
}, 
{ 
"stop_id" : 72,
"arrival_time" : "07:32:33" , 
"departure_time" : "07:33:17" , 
"distance_traveled" : 28.5491
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "07:38:44" , 
"departure_time" : "07:39:05" , 
"distance_traveled" : 31.4549
}, 
{ 
"stop_id" : 153,
"arrival_time" : "07:44:21" , 
"departure_time" : "07:44:25" , 
"distance_traveled" : 34.4464
}, 
{ 
"stop_id" : 14,
"arrival_time" : "07:49:04" , 
"departure_time" : "07:49:31" , 
"distance_traveled" : 35.971
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:00:27" , 
"departure_time" : "08:01:39" , 
"distance_traveled" : 40.9862
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:18:12" , 
"departure_time" : "08:18:12" , 
"distance_traveled" : 48.7845
} ], 
"106" :  [ 
{ 
"stop_id" : 67,
"arrival_time" : "06:03:00" , 
"departure_time" : "06:05:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "06:08:39" , 
"departure_time" : "06:08:51" , 
"distance_traveled" : 2.4222
}, 
{ 
"stop_id" : 35,
"arrival_time" : "06:16:12" , 
"departure_time" : "06:16:55" , 
"distance_traveled" : 7.3699
}, 
{ 
"stop_id" : 34,
"arrival_time" : "06:23:43" , 
"departure_time" : "06:24:59" , 
"distance_traveled" : 11.5784
}, 
{ 
"stop_id" : 96,
"arrival_time" : "06:29:16" , 
"departure_time" : "06:29:20" , 
"distance_traveled" : 14.3161
}, 
{ 
"stop_id" : 20,
"arrival_time" : "06:32:04" , 
"departure_time" : "06:32:59" , 
"distance_traveled" : 16.1373
}, 
{ 
"stop_id" : 147,
"arrival_time" : "06:38:55" , 
"departure_time" : "06:39:08" , 
"distance_traveled" : 20.2576
}, 
{ 
"stop_id" : 69,
"arrival_time" : "06:42:13" , 
"departure_time" : "06:43:44" , 
"distance_traveled" : 22.572
}, 
{ 
"stop_id" : 98,
"arrival_time" : "06:48:31" , 
"departure_time" : "06:49:59" , 
"distance_traveled" : 24.492
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "06:52:28" , 
"departure_time" : "06:53:07" , 
"distance_traveled" : 25.6345
}, 
{ 
"stop_id" : 72,
"arrival_time" : "06:55:39" , 
"departure_time" : "06:55:47" , 
"distance_traveled" : 28.5491
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "07:02:08" , 
"departure_time" : "07:03:48" , 
"distance_traveled" : 31.4549
}, 
{ 
"stop_id" : 153,
"arrival_time" : "07:09:40" , 
"departure_time" : "07:10:07" , 
"distance_traveled" : 34.4464
}, 
{ 
"stop_id" : 152,
"arrival_time" : "07:11:27" , 
"departure_time" : "07:12:45" , 
"distance_traveled" : 35.3068
}, 
{ 
"stop_id" : 14,
"arrival_time" : "07:15:18" , 
"departure_time" : "07:16:47" , 
"distance_traveled" : 35.9706
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:26:29" , 
"departure_time" : "07:27:20" , 
"distance_traveled" : 40.9858
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:42:51" , 
"departure_time" : "07:42:51" , 
"distance_traveled" : 48.7841
} ], 
"107" :  [ 
{ 
"stop_id" : 67,
"arrival_time" : "06:03:00" , 
"departure_time" : "06:05:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "06:08:36" , 
"departure_time" : "06:08:37" , 
"distance_traveled" : 2.4222
}, 
{ 
"stop_id" : 35,
"arrival_time" : "06:16:01" , 
"departure_time" : "06:17:32" , 
"distance_traveled" : 7.3699
}, 
{ 
"stop_id" : 34,
"arrival_time" : "06:24:31" , 
"departure_time" : "06:25:53" , 
"distance_traveled" : 11.5784
}, 
{ 
"stop_id" : 96,
"arrival_time" : "06:29:22" , 
"departure_time" : "06:30:14" , 
"distance_traveled" : 14.3161
}, 
{ 
"stop_id" : 20,
"arrival_time" : "06:32:52" , 
"departure_time" : "06:34:08" , 
"distance_traveled" : 16.1373
}, 
{ 
"stop_id" : 147,
"arrival_time" : "06:39:16" , 
"departure_time" : "06:40:06" , 
"distance_traveled" : 20.2576
}, 
{ 
"stop_id" : 69,
"arrival_time" : "06:42:50" , 
"departure_time" : "06:43:18" , 
"distance_traveled" : 22.572
}, 
{ 
"stop_id" : 98,
"arrival_time" : "06:47:28" , 
"departure_time" : "06:48:40" , 
"distance_traveled" : 24.492
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "06:52:12" , 
"departure_time" : "06:52:22" , 
"distance_traveled" : 25.6345
}, 
{ 
"stop_id" : 72,
"arrival_time" : "06:55:10" , 
"departure_time" : "06:56:08" , 
"distance_traveled" : 28.5491
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "07:02:58" , 
"departure_time" : "07:04:29" , 
"distance_traveled" : 31.4549
}, 
{ 
"stop_id" : 153,
"arrival_time" : "07:09:31" , 
"departure_time" : "07:09:37" , 
"distance_traveled" : 34.4464
}, 
{ 
"stop_id" : 152,
"arrival_time" : "07:11:06" , 
"departure_time" : "07:11:15" , 
"distance_traveled" : 35.3068
}, 
{ 
"stop_id" : 14,
"arrival_time" : "07:14:09" , 
"departure_time" : "07:15:45" , 
"distance_traveled" : 35.9706
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:26:36" , 
"departure_time" : "07:28:07" , 
"distance_traveled" : 40.9858
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:43:31" , 
"departure_time" : "07:43:31" , 
"distance_traveled" : 48.7841
} ], 
"108" :  [ 
{ 
"stop_id" : 54,
"arrival_time" : "05:05:00" , 
"departure_time" : "05:07:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 93,
"arrival_time" : "05:17:10" , 
"departure_time" : "05:18:10" , 
"distance_traveled" : 7.3807
}, 
{ 
"stop_id" : 101,
"arrival_time" : "05:21:00" , 
"departure_time" : "05:22:20" , 
"distance_traveled" : 9.5714
}, 
{ 
"stop_id" : 67,
"arrival_time" : "05:26:20" , 
"departure_time" : "05:27:13" , 
"distance_traveled" : 12.0591
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "05:29:53" , 
"departure_time" : "05:30:43" , 
"distance_traveled" : 14.4854
}, 
{ 
"stop_id" : 35,
"arrival_time" : "05:37:50" , 
"departure_time" : "05:38:58" , 
"distance_traveled" : 19.4331
}, 
{ 
"stop_id" : 34,
"arrival_time" : "05:45:08" , 
"departure_time" : "05:45:55" , 
"distance_traveled" : 23.6417
}, 
{ 
"stop_id" : 96,
"arrival_time" : "05:48:47" , 
"departure_time" : "05:49:23" , 
"distance_traveled" : 26.3794
}, 
{ 
"stop_id" : 20,
"arrival_time" : "05:52:36" , 
"departure_time" : "05:53:16" , 
"distance_traveled" : 28.2006
}, 
{ 
"stop_id" : 147,
"arrival_time" : "05:58:40" , 
"departure_time" : "05:59:05" , 
"distance_traveled" : 32.3208
}, 
{ 
"stop_id" : 69,
"arrival_time" : "06:03:25" , 
"departure_time" : "06:03:32" , 
"distance_traveled" : 34.6352
}, 
{ 
"stop_id" : 98,
"arrival_time" : "06:07:07" , 
"departure_time" : "06:08:37" , 
"distance_traveled" : 36.5553
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "06:12:30" , 
"departure_time" : "06:12:44" , 
"distance_traveled" : 37.6977
}, 
{ 
"stop_id" : 72,
"arrival_time" : "06:14:14" , 
"departure_time" : "06:15:19" , 
"distance_traveled" : 40.6123
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "06:22:05" , 
"departure_time" : "06:23:27" , 
"distance_traveled" : 43.5182
}, 
{ 
"stop_id" : 153,
"arrival_time" : "06:28:22" , 
"departure_time" : "06:29:14" , 
"distance_traveled" : 46.5097
}, 
{ 
"stop_id" : 14,
"arrival_time" : "06:32:52" , 
"departure_time" : "06:34:14" , 
"distance_traveled" : 48.0343
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:43:22" , 
"departure_time" : "06:43:33" , 
"distance_traveled" : 53.0494
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:00:11" , 
"departure_time" : "07:00:11" , 
"distance_traveled" : 60.8477
} ], 
"109" :  [ 
{ 
"stop_id" : 54,
"arrival_time" : "05:05:00" , 
"departure_time" : "05:05:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 93,
"arrival_time" : "05:16:43" , 
"departure_time" : "05:17:29" , 
"distance_traveled" : 7.3807
}, 
{ 
"stop_id" : 101,
"arrival_time" : "05:20:46" , 
"departure_time" : "05:21:08" , 
"distance_traveled" : 9.5714
}, 
{ 
"stop_id" : 67,
"arrival_time" : "05:25:22" , 
"departure_time" : "05:26:47" , 
"distance_traveled" : 12.0591
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "05:30:25" , 
"departure_time" : "05:31:55" , 
"distance_traveled" : 14.4854
}, 
{ 
"stop_id" : 35,
"arrival_time" : "05:38:30" , 
"departure_time" : "05:39:59" , 
"distance_traveled" : 19.4331
}, 
{ 
"stop_id" : 34,
"arrival_time" : "05:45:29" , 
"departure_time" : "05:45:38" , 
"distance_traveled" : 23.6417
}, 
{ 
"stop_id" : 96,
"arrival_time" : "05:48:09" , 
"departure_time" : "05:48:10" , 
"distance_traveled" : 26.3794
}, 
{ 
"stop_id" : 20,
"arrival_time" : "05:52:01" , 
"departure_time" : "05:53:18" , 
"distance_traveled" : 28.2006
}, 
{ 
"stop_id" : 147,
"arrival_time" : "05:59:17" , 
"departure_time" : "05:59:23" , 
"distance_traveled" : 32.3208
}, 
{ 
"stop_id" : 69,
"arrival_time" : "06:03:06" , 
"departure_time" : "06:04:07" , 
"distance_traveled" : 34.6352
}, 
{ 
"stop_id" : 98,
"arrival_time" : "06:08:01" , 
"departure_time" : "06:09:14" , 
"distance_traveled" : 36.5553
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "06:12:13" , 
"departure_time" : "06:13:32" , 
"distance_traveled" : 37.6977
}, 
{ 
"stop_id" : 72,
"arrival_time" : "06:15:19" , 
"departure_time" : "06:15:44" , 
"distance_traveled" : 40.6123
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "06:21:25" , 
"departure_time" : "06:21:32" , 
"distance_traveled" : 43.5182
}, 
{ 
"stop_id" : 153,
"arrival_time" : "06:27:07" , 
"departure_time" : "06:28:27" , 
"distance_traveled" : 46.5097
}, 
{ 
"stop_id" : 14,
"arrival_time" : "06:33:20" , 
"departure_time" : "06:33:22" , 
"distance_traveled" : 48.0343
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:42:02" , 
"departure_time" : "06:43:16" , 
"distance_traveled" : 53.0494
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:01:14" , 
"departure_time" : "07:01:14" , 
"distance_traveled" : 60.8477
} ], 
"110" :  [ 
{ 
"stop_id" : 67,
"arrival_time" : "07:19:00" , 
"departure_time" : "07:20:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "07:23:04" , 
"departure_time" : "07:23:19" , 
"distance_traveled" : 2.4222
}, 
{ 
"stop_id" : 35,
"arrival_time" : "07:31:15" , 
"departure_time" : "07:32:43" , 
"distance_traveled" : 7.3699
}, 
{ 
"stop_id" : 34,
"arrival_time" : "07:39:28" , 
"departure_time" : "07:39:49" , 
"distance_traveled" : 11.5784
}, 
{ 
"stop_id" : 96,
"arrival_time" : "07:42:21" , 
"departure_time" : "07:43:11" , 
"distance_traveled" : 14.3161
}, 
{ 
"stop_id" : 20,
"arrival_time" : "07:46:50" , 
"departure_time" : "07:47:28" , 
"distance_traveled" : 16.1373
}, 
{ 
"stop_id" : 147,
"arrival_time" : "07:52:38" , 
"departure_time" : "07:53:58" , 
"distance_traveled" : 20.2576
}, 
{ 
"stop_id" : 69,
"arrival_time" : "07:57:20" , 
"departure_time" : "07:57:21" , 
"distance_traveled" : 22.572
}, 
{ 
"stop_id" : 98,
"arrival_time" : "08:01:01" , 
"departure_time" : "08:01:47" , 
"distance_traveled" : 24.492
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "08:04:46" , 
"departure_time" : "08:05:34" , 
"distance_traveled" : 25.6345
}, 
{ 
"stop_id" : 72,
"arrival_time" : "08:08:48" , 
"departure_time" : "08:09:57" , 
"distance_traveled" : 28.5491
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "08:15:09" , 
"departure_time" : "08:15:27" , 
"distance_traveled" : 31.4549
}, 
{ 
"stop_id" : 89,
"arrival_time" : "08:17:18" , 
"departure_time" : "08:18:01" , 
"distance_traveled" : 32.3441
}, 
{ 
"stop_id" : 150,
"arrival_time" : "08:21:43" , 
"departure_time" : "08:23:19" , 
"distance_traveled" : 33.4888
}, 
{ 
"stop_id" : 153,
"arrival_time" : "08:24:36" , 
"departure_time" : "08:25:00" , 
"distance_traveled" : 34.4464
}, 
{ 
"stop_id" : 152,
"arrival_time" : "08:26:24" , 
"departure_time" : "08:26:29" , 
"distance_traveled" : 35.3068
}, 
{ 
"stop_id" : 14,
"arrival_time" : "08:30:05" , 
"departure_time" : "08:31:06" , 
"distance_traveled" : 35.9706
}, 
{ 
"stop_id" : 50,
"arrival_time" : "08:34:01" , 
"departure_time" : "08:35:10" , 
"distance_traveled" : 36.5735
}, 
{ 
"stop_id" : 19,
"arrival_time" : "08:37:09" , 
"departure_time" : "08:37:17" , 
"distance_traveled" : 37.1725
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:44:08" , 
"departure_time" : "08:44:35" , 
"distance_traveled" : 40.9758
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:02:27" , 
"departure_time" : "09:02:27" , 
"distance_traveled" : 48.764
} ], 
"111" :  [ 
{ 
"stop_id" : 67,
"arrival_time" : "07:19:00" , 
"departure_time" : "07:20:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "07:24:21" , 
"departure_time" : "07:25:36" , 
"distance_traveled" : 2.4222
}, 
{ 
"stop_id" : 35,
"arrival_time" : "07:32:15" , 
"departure_time" : "07:33:04" , 
"distance_traveled" : 7.3699
}, 
{ 
"stop_id" : 34,
"arrival_time" : "07:38:49" , 
"departure_time" : "07:39:27" , 
"distance_traveled" : 11.5784
}, 
{ 
"stop_id" : 96,
"arrival_time" : "07:42:38" , 
"departure_time" : "07:43:14" , 
"distance_traveled" : 14.3161
}, 
{ 
"stop_id" : 20,
"arrival_time" : "07:46:36" , 
"departure_time" : "07:47:15" , 
"distance_traveled" : 16.1373
}, 
{ 
"stop_id" : 147,
"arrival_time" : "07:52:39" , 
"departure_time" : "07:53:23" , 
"distance_traveled" : 20.2576
}, 
{ 
"stop_id" : 69,
"arrival_time" : "07:56:44" , 
"departure_time" : "07:58:18" , 
"distance_traveled" : 22.572
}, 
{ 
"stop_id" : 98,
"arrival_time" : "08:02:34" , 
"departure_time" : "08:03:39" , 
"distance_traveled" : 24.492
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "08:05:05" , 
"departure_time" : "08:06:26" , 
"distance_traveled" : 25.6345
}, 
{ 
"stop_id" : 72,
"arrival_time" : "08:09:21" , 
"departure_time" : "08:10:11" , 
"distance_traveled" : 28.5491
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "08:14:50" , 
"departure_time" : "08:15:35" , 
"distance_traveled" : 31.4549
}, 
{ 
"stop_id" : 89,
"arrival_time" : "08:17:45" , 
"departure_time" : "08:19:24" , 
"distance_traveled" : 32.3441
}, 
{ 
"stop_id" : 150,
"arrival_time" : "08:22:39" , 
"departure_time" : "08:24:11" , 
"distance_traveled" : 33.4888
}, 
{ 
"stop_id" : 153,
"arrival_time" : "08:24:32" , 
"departure_time" : "08:25:59" , 
"distance_traveled" : 34.4464
}, 
{ 
"stop_id" : 152,
"arrival_time" : "08:27:27" , 
"departure_time" : "08:27:29" , 
"distance_traveled" : 35.3068
}, 
{ 
"stop_id" : 14,
"arrival_time" : "08:30:02" , 
"departure_time" : "08:30:55" , 
"distance_traveled" : 35.9706
}, 
{ 
"stop_id" : 50,
"arrival_time" : "08:33:53" , 
"departure_time" : "08:35:20" , 
"distance_traveled" : 36.5735
}, 
{ 
"stop_id" : 19,
"arrival_time" : "08:37:27" , 
"departure_time" : "08:38:04" , 
"distance_traveled" : 37.1725
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:44:37" , 
"departure_time" : "08:46:09" , 
"distance_traveled" : 40.9758
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:03:32" , 
"departure_time" : "09:03:32" , 
"distance_traveled" : 48.764
} ], 
"112" :  [ 
{ 
"stop_id" : 54,
"arrival_time" : "08:23:00" , 
"departure_time" : "08:25:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 93,
"arrival_time" : "08:35:00" , 
"departure_time" : "08:35:03" , 
"distance_traveled" : 7.3807
}, 
{ 
"stop_id" : 101,
"arrival_time" : "08:39:03" , 
"departure_time" : "08:40:18" , 
"distance_traveled" : 9.5714
}, 
{ 
"stop_id" : 67,
"arrival_time" : "08:44:15" , 
"departure_time" : "08:44:46" , 
"distance_traveled" : 12.0591
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "08:47:31" , 
"departure_time" : "08:49:04" , 
"distance_traveled" : 14.4854
}, 
{ 
"stop_id" : 35,
"arrival_time" : "08:57:33" , 
"departure_time" : "08:58:19" , 
"distance_traveled" : 19.4331
}, 
{ 
"stop_id" : 34,
"arrival_time" : "09:02:46" , 
"departure_time" : "09:04:17" , 
"distance_traveled" : 23.6417
}, 
{ 
"stop_id" : 96,
"arrival_time" : "09:08:31" , 
"departure_time" : "09:09:36" , 
"distance_traveled" : 26.3794
}, 
{ 
"stop_id" : 20,
"arrival_time" : "09:12:05" , 
"departure_time" : "09:13:35" , 
"distance_traveled" : 28.2006
}, 
{ 
"stop_id" : 147,
"arrival_time" : "09:18:30" , 
"departure_time" : "09:19:46" , 
"distance_traveled" : 32.3208
}, 
{ 
"stop_id" : 69,
"arrival_time" : "09:22:16" , 
"departure_time" : "09:23:01" , 
"distance_traveled" : 34.6352
}, 
{ 
"stop_id" : 98,
"arrival_time" : "09:26:45" , 
"departure_time" : "09:28:00" , 
"distance_traveled" : 36.5553
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "09:30:15" , 
"departure_time" : "09:31:30" , 
"distance_traveled" : 37.6977
}, 
{ 
"stop_id" : 72,
"arrival_time" : "09:34:15" , 
"departure_time" : "09:35:32" , 
"distance_traveled" : 40.6123
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "09:41:17" , 
"departure_time" : "09:42:56" , 
"distance_traveled" : 43.5182
}, 
{ 
"stop_id" : 89,
"arrival_time" : "09:44:39" , 
"departure_time" : "09:45:52" , 
"distance_traveled" : 44.4074
}, 
{ 
"stop_id" : 95,
"arrival_time" : "09:46:13" , 
"departure_time" : "09:46:25" , 
"distance_traveled" : 45.0405
}, 
{ 
"stop_id" : 150,
"arrival_time" : "09:48:12" , 
"departure_time" : "09:48:50" , 
"distance_traveled" : 45.5521
}, 
{ 
"stop_id" : 153,
"arrival_time" : "09:50:38" , 
"departure_time" : "09:51:01" , 
"distance_traveled" : 46.5097
}, 
{ 
"stop_id" : 152,
"arrival_time" : "09:53:23" , 
"departure_time" : "09:53:35" , 
"distance_traveled" : 47.3701
}, 
{ 
"stop_id" : 14,
"arrival_time" : "09:56:12" , 
"departure_time" : "09:57:21" , 
"distance_traveled" : 48.0339
}, 
{ 
"stop_id" : 50,
"arrival_time" : "10:00:09" , 
"departure_time" : "10:00:17" , 
"distance_traveled" : 48.6367
}, 
{ 
"stop_id" : 19,
"arrival_time" : "10:01:08" , 
"departure_time" : "10:02:43" , 
"distance_traveled" : 49.2358
}, 
{ 
"stop_id" : 154,
"arrival_time" : "10:04:35" , 
"departure_time" : "10:06:10" , 
"distance_traveled" : 49.9347
}, 
{ 
"stop_id" : 106,
"arrival_time" : "10:12:35" , 
"departure_time" : "10:13:52" , 
"distance_traveled" : 53.0491
}, 
{ 
"stop_id" : 63,
"arrival_time" : "10:31:17" , 
"departure_time" : "10:31:17" , 
"distance_traveled" : 60.8473
} ], 
"113" :  [ 
{ 
"stop_id" : 54,
"arrival_time" : "08:23:00" , 
"departure_time" : "08:24:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 93,
"arrival_time" : "08:34:24" , 
"departure_time" : "08:35:10" , 
"distance_traveled" : 7.3807
}, 
{ 
"stop_id" : 101,
"arrival_time" : "08:39:46" , 
"departure_time" : "08:40:08" , 
"distance_traveled" : 9.5714
}, 
{ 
"stop_id" : 67,
"arrival_time" : "08:43:22" , 
"departure_time" : "08:44:34" , 
"distance_traveled" : 12.0591
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "08:48:12" , 
"departure_time" : "08:49:29" , 
"distance_traveled" : 14.4854
}, 
{ 
"stop_id" : 35,
"arrival_time" : "08:57:17" , 
"departure_time" : "08:57:56" , 
"distance_traveled" : 19.4331
}, 
{ 
"stop_id" : 34,
"arrival_time" : "09:02:39" , 
"departure_time" : "09:03:54" , 
"distance_traveled" : 23.6417
}, 
{ 
"stop_id" : 96,
"arrival_time" : "09:08:15" , 
"departure_time" : "09:08:40" , 
"distance_traveled" : 26.3794
}, 
{ 
"stop_id" : 20,
"arrival_time" : "09:11:25" , 
"departure_time" : "09:12:20" , 
"distance_traveled" : 28.2006
}, 
{ 
"stop_id" : 147,
"arrival_time" : "09:17:55" , 
"departure_time" : "09:18:58" , 
"distance_traveled" : 32.3208
}, 
{ 
"stop_id" : 69,
"arrival_time" : "09:22:03" , 
"departure_time" : "09:22:52" , 
"distance_traveled" : 34.6352
}, 
{ 
"stop_id" : 98,
"arrival_time" : "09:26:49" , 
"departure_time" : "09:27:13" , 
"distance_traveled" : 36.5553
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "09:29:24" , 
"departure_time" : "09:30:13" , 
"distance_traveled" : 37.6977
}, 
{ 
"stop_id" : 72,
"arrival_time" : "09:33:49" , 
"departure_time" : "09:34:56" , 
"distance_traveled" : 40.6123
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "09:41:07" , 
"departure_time" : "09:42:47" , 
"distance_traveled" : 43.5182
}, 
{ 
"stop_id" : 89,
"arrival_time" : "09:44:40" , 
"departure_time" : "09:44:52" , 
"distance_traveled" : 44.4074
}, 
{ 
"stop_id" : 95,
"arrival_time" : "09:45:12" , 
"departure_time" : "09:45:26" , 
"distance_traveled" : 45.0405
}, 
{ 
"stop_id" : 150,
"arrival_time" : "09:48:14" , 
"departure_time" : "09:48:22" , 
"distance_traveled" : 45.5521
}, 
{ 
"stop_id" : 153,
"arrival_time" : "09:50:08" , 
"departure_time" : "09:51:00" , 
"distance_traveled" : 46.5097
}, 
{ 
"stop_id" : 152,
"arrival_time" : "09:53:52" , 
"departure_time" : "09:54:05" , 
"distance_traveled" : 47.3701
}, 
{ 
"stop_id" : 14,
"arrival_time" : "09:56:13" , 
"departure_time" : "09:56:15" , 
"distance_traveled" : 48.0339
}, 
{ 
"stop_id" : 50,
"arrival_time" : "09:59:02" , 
"departure_time" : "10:00:21" , 
"distance_traveled" : 48.6367
}, 
{ 
"stop_id" : 19,
"arrival_time" : "10:02:19" , 
"departure_time" : "10:03:50" , 
"distance_traveled" : 49.2358
}, 
{ 
"stop_id" : 154,
"arrival_time" : "10:04:31" , 
"departure_time" : "10:05:45" , 
"distance_traveled" : 49.9347
}, 
{ 
"stop_id" : 106,
"arrival_time" : "10:12:14" , 
"departure_time" : "10:13:49" , 
"distance_traveled" : 53.0491
}, 
{ 
"stop_id" : 63,
"arrival_time" : "10:31:35" , 
"departure_time" : "10:31:35" , 
"distance_traveled" : 60.8473
} ], 
"114" :  [ 
{ 
"stop_id" : 67,
"arrival_time" : "05:21:00" , 
"departure_time" : "05:23:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "05:26:15" , 
"departure_time" : "05:26:29" , 
"distance_traveled" : 2.4222
}, 
{ 
"stop_id" : 35,
"arrival_time" : "05:33:14" , 
"departure_time" : "05:33:40" , 
"distance_traveled" : 7.3699
}, 
{ 
"stop_id" : 34,
"arrival_time" : "05:40:26" , 
"departure_time" : "05:40:44" , 
"distance_traveled" : 11.5784
}, 
{ 
"stop_id" : 96,
"arrival_time" : "05:45:18" , 
"departure_time" : "05:45:27" , 
"distance_traveled" : 14.3161
}, 
{ 
"stop_id" : 20,
"arrival_time" : "05:48:09" , 
"departure_time" : "05:48:57" , 
"distance_traveled" : 16.1373
}, 
{ 
"stop_id" : 147,
"arrival_time" : "05:54:48" , 
"departure_time" : "05:55:11" , 
"distance_traveled" : 20.2576
}, 
{ 
"stop_id" : 69,
"arrival_time" : "05:58:23" , 
"departure_time" : "05:58:49" , 
"distance_traveled" : 22.572
}, 
{ 
"stop_id" : 98,
"arrival_time" : "06:02:26" , 
"departure_time" : "06:03:13" , 
"distance_traveled" : 24.492
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "06:05:47" , 
"departure_time" : "06:06:10" , 
"distance_traveled" : 25.6345
}, 
{ 
"stop_id" : 72,
"arrival_time" : "06:09:23" , 
"departure_time" : "06:10:56" , 
"distance_traveled" : 28.5491
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "06:16:33" , 
"departure_time" : "06:17:24" , 
"distance_traveled" : 31.4549
}, 
{ 
"stop_id" : 89,
"arrival_time" : "06:18:51" , 
"departure_time" : "06:20:09" , 
"distance_traveled" : 32.3441
}, 
{ 
"stop_id" : 150,
"arrival_time" : "06:22:18" , 
"departure_time" : "06:22:20" , 
"distance_traveled" : 33.4888
}, 
{ 
"stop_id" : 153,
"arrival_time" : "06:23:02" , 
"departure_time" : "06:24:02" , 
"distance_traveled" : 34.4464
}, 
{ 
"stop_id" : 152,
"arrival_time" : "06:27:00" , 
"departure_time" : "06:27:56" , 
"distance_traveled" : 35.3068
}, 
{ 
"stop_id" : 14,
"arrival_time" : "06:30:56" , 
"departure_time" : "06:31:10" , 
"distance_traveled" : 35.9706
}, 
{ 
"stop_id" : 50,
"arrival_time" : "06:33:14" , 
"departure_time" : "06:34:13" , 
"distance_traveled" : 36.5735
}, 
{ 
"stop_id" : 19,
"arrival_time" : "06:35:59" , 
"departure_time" : "06:37:37" , 
"distance_traveled" : 37.1725
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:43:38" , 
"departure_time" : "06:44:01" , 
"distance_traveled" : 40.9758
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:00:23" , 
"departure_time" : "07:00:23" , 
"distance_traveled" : 48.764
} ], 
"115" :  [ 
{ 
"stop_id" : 67,
"arrival_time" : "06:21:00" , 
"departure_time" : "06:22:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "06:26:31" , 
"departure_time" : "06:28:05" , 
"distance_traveled" : 2.4222
}, 
{ 
"stop_id" : 35,
"arrival_time" : "06:34:34" , 
"departure_time" : "06:35:24" , 
"distance_traveled" : 7.3699
}, 
{ 
"stop_id" : 34,
"arrival_time" : "06:40:50" , 
"departure_time" : "06:41:32" , 
"distance_traveled" : 11.5784
}, 
{ 
"stop_id" : 96,
"arrival_time" : "06:45:42" , 
"departure_time" : "06:45:43" , 
"distance_traveled" : 14.3161
}, 
{ 
"stop_id" : 20,
"arrival_time" : "06:48:01" , 
"departure_time" : "06:48:14" , 
"distance_traveled" : 16.1373
}, 
{ 
"stop_id" : 147,
"arrival_time" : "06:54:13" , 
"departure_time" : "06:55:15" , 
"distance_traveled" : 20.2576
}, 
{ 
"stop_id" : 69,
"arrival_time" : "06:59:02" , 
"departure_time" : "06:59:54" , 
"distance_traveled" : 22.572
}, 
{ 
"stop_id" : 98,
"arrival_time" : "07:02:52" , 
"departure_time" : "07:03:20" , 
"distance_traveled" : 24.492
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "07:05:28" , 
"departure_time" : "07:05:56" , 
"distance_traveled" : 25.6345
}, 
{ 
"stop_id" : 72,
"arrival_time" : "07:09:28" , 
"departure_time" : "07:10:10" , 
"distance_traveled" : 28.5491
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "07:15:42" , 
"departure_time" : "07:15:44" , 
"distance_traveled" : 31.4549
}, 
{ 
"stop_id" : 89,
"arrival_time" : "07:18:02" , 
"departure_time" : "07:19:37" , 
"distance_traveled" : 32.3441
}, 
{ 
"stop_id" : 150,
"arrival_time" : "07:22:35" , 
"departure_time" : "07:23:02" , 
"distance_traveled" : 33.4888
}, 
{ 
"stop_id" : 153,
"arrival_time" : "07:23:27" , 
"departure_time" : "07:25:06" , 
"distance_traveled" : 34.4464
}, 
{ 
"stop_id" : 152,
"arrival_time" : "07:27:39" , 
"departure_time" : "07:28:55" , 
"distance_traveled" : 35.3068
}, 
{ 
"stop_id" : 14,
"arrival_time" : "07:31:16" , 
"departure_time" : "07:32:49" , 
"distance_traveled" : 35.9706
}, 
{ 
"stop_id" : 50,
"arrival_time" : "07:34:33" , 
"departure_time" : "07:35:14" , 
"distance_traveled" : 36.5735
}, 
{ 
"stop_id" : 19,
"arrival_time" : "07:35:41" , 
"departure_time" : "07:35:56" , 
"distance_traveled" : 37.1725
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:42:15" , 
"departure_time" : "07:43:21" , 
"distance_traveled" : 40.9758
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:01:06" , 
"departure_time" : "08:01:06" , 
"distance_traveled" : 48.764
} ], 
"116" :  [ 
{ 
"stop_id" : 67,
"arrival_time" : "07:25:00" , 
"departure_time" : "07:27:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "07:30:16" , 
"departure_time" : "07:31:31" , 
"distance_traveled" : 2.4222
}, 
{ 
"stop_id" : 35,
"arrival_time" : "07:38:15" , 
"departure_time" : "07:38:48" , 
"distance_traveled" : 7.3699
}, 
{ 
"stop_id" : 34,
"arrival_time" : "07:44:33" , 
"departure_time" : "07:45:27" , 
"distance_traveled" : 11.5784
}, 
{ 
"stop_id" : 96,
"arrival_time" : "07:48:54" , 
"departure_time" : "07:49:19" , 
"distance_traveled" : 14.3161
}, 
{ 
"stop_id" : 20,
"arrival_time" : "07:52:25" , 
"departure_time" : "07:53:48" , 
"distance_traveled" : 16.1373
}, 
{ 
"stop_id" : 147,
"arrival_time" : "07:59:23" , 
"departure_time" : "08:00:26" , 
"distance_traveled" : 20.2576
}, 
{ 
"stop_id" : 69,
"arrival_time" : "08:03:03" , 
"departure_time" : "08:03:30" , 
"distance_traveled" : 22.572
}, 
{ 
"stop_id" : 98,
"arrival_time" : "08:05:27" , 
"departure_time" : "08:06:37" , 
"distance_traveled" : 24.492
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "08:09:10" , 
"departure_time" : "08:10:35" , 
"distance_traveled" : 25.6345
}, 
{ 
"stop_id" : 72,
"arrival_time" : "08:12:25" , 
"departure_time" : "08:13:14" , 
"distance_traveled" : 28.5491
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "08:17:49" , 
"departure_time" : "08:19:24" , 
"distance_traveled" : 31.4549
}, 
{ 
"stop_id" : 89,
"arrival_time" : "08:21:35" , 
"departure_time" : "08:21:47" , 
"distance_traveled" : 32.3441
}, 
{ 
"stop_id" : 150,
"arrival_time" : "08:23:12" , 
"departure_time" : "08:23:19" , 
"distance_traveled" : 33.4888
}, 
{ 
"stop_id" : 153,
"arrival_time" : "08:25:07" , 
"departure_time" : "08:25:09" , 
"distance_traveled" : 34.4464
}, 
{ 
"stop_id" : 152,
"arrival_time" : "08:28:02" , 
"departure_time" : "08:28:39" , 
"distance_traveled" : 35.3068
}, 
{ 
"stop_id" : 14,
"arrival_time" : "08:32:37" , 
"departure_time" : "08:34:11" , 
"distance_traveled" : 35.9706
}, 
{ 
"stop_id" : 50,
"arrival_time" : "08:36:34" , 
"departure_time" : "08:36:51" , 
"distance_traveled" : 36.5735
}, 
{ 
"stop_id" : 19,
"arrival_time" : "08:37:17" , 
"departure_time" : "08:38:42" , 
"distance_traveled" : 37.1725
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:45:25" , 
"departure_time" : "08:45:30" , 
"distance_traveled" : 40.9758
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:00:05" , 
"departure_time" : "09:00:05" , 
"distance_traveled" : 48.764
} ], 
"117" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "15:55:00" , 
"departure_time" : "15:55:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:11:43" , 
"departure_time" : "16:13:21" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 19,
"arrival_time" : "16:19:38" , 
"departure_time" : "16:19:50" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "16:20:12" , 
"departure_time" : "16:21:08" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "16:23:56" , 
"departure_time" : "16:24:21" , 
"distance_traveled" : 12.7936
}, 
{ 
"stop_id" : 152,
"arrival_time" : "16:27:25" , 
"departure_time" : "16:28:36" , 
"distance_traveled" : 13.4574
}, 
{ 
"stop_id" : 153,
"arrival_time" : "16:30:11" , 
"departure_time" : "16:30:38" , 
"distance_traveled" : 14.3178
}, 
{ 
"stop_id" : 150,
"arrival_time" : "16:32:27" , 
"departure_time" : "16:32:31" , 
"distance_traveled" : 15.2754
}, 
{ 
"stop_id" : 89,
"arrival_time" : "16:34:04" , 
"departure_time" : "16:35:03" , 
"distance_traveled" : 16.4201
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "16:37:59" , 
"departure_time" : "16:39:26" , 
"distance_traveled" : 17.3093
}, 
{ 
"stop_id" : 72,
"arrival_time" : "16:45:27" , 
"departure_time" : "16:46:48" , 
"distance_traveled" : 20.215
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "16:48:21" , 
"departure_time" : "16:48:25" , 
"distance_traveled" : 22.0023
}, 
{ 
"stop_id" : 98,
"arrival_time" : "16:50:04" , 
"departure_time" : "16:50:49" , 
"distance_traveled" : 23.1447
}, 
{ 
"stop_id" : 69,
"arrival_time" : "16:55:45" , 
"departure_time" : "16:55:53" , 
"distance_traveled" : 25.0648
}, 
{ 
"stop_id" : 147,
"arrival_time" : "16:59:08" , 
"departure_time" : "17:00:17" , 
"distance_traveled" : 27.3792
}, 
{ 
"stop_id" : 20,
"arrival_time" : "17:07:09" , 
"departure_time" : "17:07:25" , 
"distance_traveled" : 31.4866
}, 
{ 
"stop_id" : 96,
"arrival_time" : "17:09:16" , 
"departure_time" : "17:09:59" , 
"distance_traveled" : 33.3206
}, 
{ 
"stop_id" : 34,
"arrival_time" : "17:14:43" , 
"departure_time" : "17:15:57" , 
"distance_traveled" : 36.0578
}, 
{ 
"stop_id" : 35,
"arrival_time" : "17:22:14" , 
"departure_time" : "17:23:33" , 
"distance_traveled" : 40.2659
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "17:29:19" , 
"departure_time" : "17:29:34" , 
"distance_traveled" : 45.2136
}, 
{ 
"stop_id" : 67,
"arrival_time" : "17:33:15" , 
"departure_time" : "17:33:15" , 
"distance_traveled" : 47.628
} ], 
"118" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "15:55:00" , 
"departure_time" : "15:56:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:12:17" , 
"departure_time" : "16:12:27" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 19,
"arrival_time" : "16:18:10" , 
"departure_time" : "16:18:56" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "16:20:46" , 
"departure_time" : "16:22:24" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "16:24:38" , 
"departure_time" : "16:24:47" , 
"distance_traveled" : 12.7936
}, 
{ 
"stop_id" : 152,
"arrival_time" : "16:27:09" , 
"departure_time" : "16:28:32" , 
"distance_traveled" : 13.4574
}, 
{ 
"stop_id" : 153,
"arrival_time" : "16:30:23" , 
"departure_time" : "16:31:38" , 
"distance_traveled" : 14.3178
}, 
{ 
"stop_id" : 150,
"arrival_time" : "16:33:15" , 
"departure_time" : "16:34:50" , 
"distance_traveled" : 15.2754
}, 
{ 
"stop_id" : 89,
"arrival_time" : "16:35:35" , 
"departure_time" : "16:36:25" , 
"distance_traveled" : 16.4201
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "16:37:50" , 
"departure_time" : "16:39:11" , 
"distance_traveled" : 17.3093
}, 
{ 
"stop_id" : 72,
"arrival_time" : "16:45:21" , 
"departure_time" : "16:46:58" , 
"distance_traveled" : 20.215
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "16:48:37" , 
"departure_time" : "16:49:09" , 
"distance_traveled" : 22.0023
}, 
{ 
"stop_id" : 98,
"arrival_time" : "16:50:32" , 
"departure_time" : "16:51:47" , 
"distance_traveled" : 23.1447
}, 
{ 
"stop_id" : 69,
"arrival_time" : "16:56:15" , 
"departure_time" : "16:57:16" , 
"distance_traveled" : 25.0648
}, 
{ 
"stop_id" : 147,
"arrival_time" : "17:00:01" , 
"departure_time" : "17:00:22" , 
"distance_traveled" : 27.3792
}, 
{ 
"stop_id" : 20,
"arrival_time" : "17:06:21" , 
"departure_time" : "17:07:49" , 
"distance_traveled" : 31.4866
}, 
{ 
"stop_id" : 96,
"arrival_time" : "17:10:28" , 
"departure_time" : "17:10:37" , 
"distance_traveled" : 33.3206
}, 
{ 
"stop_id" : 34,
"arrival_time" : "17:14:09" , 
"departure_time" : "17:15:20" , 
"distance_traveled" : 36.0578
}, 
{ 
"stop_id" : 35,
"arrival_time" : "17:22:11" , 
"departure_time" : "17:22:56" , 
"distance_traveled" : 40.2659
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "17:28:45" , 
"departure_time" : "17:30:24" , 
"distance_traveled" : 45.2136
}, 
{ 
"stop_id" : 67,
"arrival_time" : "17:34:39" , 
"departure_time" : "17:34:39" , 
"distance_traveled" : 47.628
} ], 
"119" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:10:00" , 
"departure_time" : "17:12:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:26:46" , 
"departure_time" : "17:28:20" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 19,
"arrival_time" : "17:34:34" , 
"departure_time" : "17:35:08" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "17:35:34" , 
"departure_time" : "17:36:54" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "17:39:20" , 
"departure_time" : "17:40:25" , 
"distance_traveled" : 12.7936
}, 
{ 
"stop_id" : 152,
"arrival_time" : "17:43:05" , 
"departure_time" : "17:43:37" , 
"distance_traveled" : 13.4574
}, 
{ 
"stop_id" : 153,
"arrival_time" : "17:44:32" , 
"departure_time" : "17:46:04" , 
"distance_traveled" : 14.3178
}, 
{ 
"stop_id" : 150,
"arrival_time" : "17:48:32" , 
"departure_time" : "17:48:45" , 
"distance_traveled" : 15.2754
}, 
{ 
"stop_id" : 89,
"arrival_time" : "17:49:13" , 
"departure_time" : "17:50:11" , 
"distance_traveled" : 16.4201
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "17:52:58" , 
"departure_time" : "17:53:45" , 
"distance_traveled" : 17.3093
}, 
{ 
"stop_id" : 72,
"arrival_time" : "17:59:47" , 
"departure_time" : "18:00:29" , 
"distance_traveled" : 20.215
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "18:02:42" , 
"departure_time" : "18:03:55" , 
"distance_traveled" : 22.0023
}, 
{ 
"stop_id" : 98,
"arrival_time" : "18:06:13" , 
"departure_time" : "18:06:47" , 
"distance_traveled" : 23.1447
}, 
{ 
"stop_id" : 69,
"arrival_time" : "18:09:34" , 
"departure_time" : "18:10:36" , 
"distance_traveled" : 25.0648
}, 
{ 
"stop_id" : 147,
"arrival_time" : "18:14:02" , 
"departure_time" : "18:15:11" , 
"distance_traveled" : 27.3792
}, 
{ 
"stop_id" : 20,
"arrival_time" : "18:21:09" , 
"departure_time" : "18:22:26" , 
"distance_traveled" : 31.4866
}, 
{ 
"stop_id" : 96,
"arrival_time" : "18:25:17" , 
"departure_time" : "18:26:01" , 
"distance_traveled" : 33.3206
}, 
{ 
"stop_id" : 34,
"arrival_time" : "18:29:44" , 
"departure_time" : "18:29:52" , 
"distance_traveled" : 36.0578
}, 
{ 
"stop_id" : 35,
"arrival_time" : "18:36:08" , 
"departure_time" : "18:36:49" , 
"distance_traveled" : 40.2659
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "18:43:41" , 
"departure_time" : "18:44:26" , 
"distance_traveled" : 45.2136
}, 
{ 
"stop_id" : 67,
"arrival_time" : "18:48:45" , 
"departure_time" : "18:48:45" , 
"distance_traveled" : 47.628
} ], 
"120" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:10:00" , 
"departure_time" : "17:11:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:27:01" , 
"departure_time" : "17:27:51" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 19,
"arrival_time" : "17:33:50" , 
"departure_time" : "17:35:29" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "17:36:39" , 
"departure_time" : "17:37:15" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "17:38:36" , 
"departure_time" : "17:39:22" , 
"distance_traveled" : 12.7936
}, 
{ 
"stop_id" : 152,
"arrival_time" : "17:42:46" , 
"departure_time" : "17:43:58" , 
"distance_traveled" : 13.4574
}, 
{ 
"stop_id" : 153,
"arrival_time" : "17:45:12" , 
"departure_time" : "17:46:02" , 
"distance_traveled" : 14.3178
}, 
{ 
"stop_id" : 150,
"arrival_time" : "17:47:50" , 
"departure_time" : "17:48:56" , 
"distance_traveled" : 15.2754
}, 
{ 
"stop_id" : 89,
"arrival_time" : "17:50:06" , 
"departure_time" : "17:51:32" , 
"distance_traveled" : 16.4201
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "17:53:26" , 
"departure_time" : "17:53:35" , 
"distance_traveled" : 17.3093
}, 
{ 
"stop_id" : 72,
"arrival_time" : "17:59:09" , 
"departure_time" : "17:59:40" , 
"distance_traveled" : 20.215
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "18:02:31" , 
"departure_time" : "18:04:07" , 
"distance_traveled" : 22.0023
}, 
{ 
"stop_id" : 98,
"arrival_time" : "18:06:36" , 
"departure_time" : "18:07:36" , 
"distance_traveled" : 23.1447
}, 
{ 
"stop_id" : 69,
"arrival_time" : "18:10:00" , 
"departure_time" : "18:11:35" , 
"distance_traveled" : 25.0648
}, 
{ 
"stop_id" : 147,
"arrival_time" : "18:14:35" , 
"departure_time" : "18:15:50" , 
"distance_traveled" : 27.3792
}, 
{ 
"stop_id" : 20,
"arrival_time" : "18:21:15" , 
"departure_time" : "18:21:34" , 
"distance_traveled" : 31.4866
}, 
{ 
"stop_id" : 96,
"arrival_time" : "18:24:19" , 
"departure_time" : "18:25:10" , 
"distance_traveled" : 33.3206
}, 
{ 
"stop_id" : 34,
"arrival_time" : "18:29:51" , 
"departure_time" : "18:30:27" , 
"distance_traveled" : 36.0578
}, 
{ 
"stop_id" : 35,
"arrival_time" : "18:36:36" , 
"departure_time" : "18:37:09" , 
"distance_traveled" : 40.2659
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "18:43:33" , 
"departure_time" : "18:43:41" , 
"distance_traveled" : 45.2136
}, 
{ 
"stop_id" : 67,
"arrival_time" : "18:48:08" , 
"departure_time" : "18:48:08" , 
"distance_traveled" : 47.628
} ], 
"121" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:00:00" , 
"departure_time" : "18:01:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:16:56" , 
"departure_time" : "18:17:26" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 19,
"arrival_time" : "18:23:30" , 
"departure_time" : "18:23:57" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "18:25:27" , 
"departure_time" : "18:26:13" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "18:28:46" , 
"departure_time" : "18:30:16" , 
"distance_traveled" : 12.7936
}, 
{ 
"stop_id" : 152,
"arrival_time" : "18:33:30" , 
"departure_time" : "18:35:07" , 
"distance_traveled" : 13.4574
}, 
{ 
"stop_id" : 153,
"arrival_time" : "18:35:37" , 
"departure_time" : "18:36:14" , 
"distance_traveled" : 14.3178
}, 
{ 
"stop_id" : 150,
"arrival_time" : "18:37:37" , 
"departure_time" : "18:38:08" , 
"distance_traveled" : 15.2754
}, 
{ 
"stop_id" : 89,
"arrival_time" : "18:39:31" , 
"departure_time" : "18:40:17" , 
"distance_traveled" : 16.4201
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "18:42:46" , 
"departure_time" : "18:43:08" , 
"distance_traveled" : 17.3093
}, 
{ 
"stop_id" : 72,
"arrival_time" : "18:49:22" , 
"departure_time" : "18:50:41" , 
"distance_traveled" : 20.215
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "18:53:19" , 
"departure_time" : "18:54:59" , 
"distance_traveled" : 22.0023
}, 
{ 
"stop_id" : 98,
"arrival_time" : "18:56:40" , 
"departure_time" : "18:57:10" , 
"distance_traveled" : 23.1447
}, 
{ 
"stop_id" : 69,
"arrival_time" : "19:00:30" , 
"departure_time" : "19:00:37" , 
"distance_traveled" : 25.0648
}, 
{ 
"stop_id" : 147,
"arrival_time" : "19:04:07" , 
"departure_time" : "19:05:14" , 
"distance_traveled" : 27.3792
}, 
{ 
"stop_id" : 20,
"arrival_time" : "19:12:07" , 
"departure_time" : "19:12:26" , 
"distance_traveled" : 31.4866
}, 
{ 
"stop_id" : 96,
"arrival_time" : "19:14:19" , 
"departure_time" : "19:15:38" , 
"distance_traveled" : 33.3206
}, 
{ 
"stop_id" : 34,
"arrival_time" : "19:20:19" , 
"departure_time" : "19:21:18" , 
"distance_traveled" : 36.0578
}, 
{ 
"stop_id" : 35,
"arrival_time" : "19:26:59" , 
"departure_time" : "19:28:28" , 
"distance_traveled" : 40.2659
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "19:34:29" , 
"departure_time" : "19:36:05" , 
"distance_traveled" : 45.2136
}, 
{ 
"stop_id" : 67,
"arrival_time" : "19:39:36" , 
"departure_time" : "19:39:36" , 
"distance_traveled" : 47.628
} ], 
"122" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:00:00" , 
"departure_time" : "18:03:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:17:29" , 
"departure_time" : "18:18:17" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 19,
"arrival_time" : "18:23:48" , 
"departure_time" : "18:23:51" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "18:25:03" , 
"departure_time" : "18:25:07" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "18:28:04" , 
"departure_time" : "18:28:50" , 
"distance_traveled" : 12.7936
}, 
{ 
"stop_id" : 152,
"arrival_time" : "18:32:46" , 
"departure_time" : "18:33:54" , 
"distance_traveled" : 13.4574
}, 
{ 
"stop_id" : 153,
"arrival_time" : "18:35:08" , 
"departure_time" : "18:35:39" , 
"distance_traveled" : 14.3178
}, 
{ 
"stop_id" : 150,
"arrival_time" : "18:37:31" , 
"departure_time" : "18:37:32" , 
"distance_traveled" : 15.2754
}, 
{ 
"stop_id" : 89,
"arrival_time" : "18:39:01" , 
"departure_time" : "18:40:15" , 
"distance_traveled" : 16.4201
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "18:43:14" , 
"departure_time" : "18:43:47" , 
"distance_traveled" : 17.3093
}, 
{ 
"stop_id" : 72,
"arrival_time" : "18:49:33" , 
"departure_time" : "18:50:58" , 
"distance_traveled" : 20.215
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "18:53:25" , 
"departure_time" : "18:53:39" , 
"distance_traveled" : 22.0023
}, 
{ 
"stop_id" : 98,
"arrival_time" : "18:55:14" , 
"departure_time" : "18:55:26" , 
"distance_traveled" : 23.1447
}, 
{ 
"stop_id" : 69,
"arrival_time" : "19:00:12" , 
"departure_time" : "19:01:44" , 
"distance_traveled" : 25.0648
}, 
{ 
"stop_id" : 147,
"arrival_time" : "19:05:32" , 
"departure_time" : "19:05:54" , 
"distance_traveled" : 27.3792
}, 
{ 
"stop_id" : 20,
"arrival_time" : "19:11:22" , 
"departure_time" : "19:12:42" , 
"distance_traveled" : 31.4866
}, 
{ 
"stop_id" : 96,
"arrival_time" : "19:15:20" , 
"departure_time" : "19:15:22" , 
"distance_traveled" : 33.3206
}, 
{ 
"stop_id" : 34,
"arrival_time" : "19:19:02" , 
"departure_time" : "19:20:00" , 
"distance_traveled" : 36.0578
}, 
{ 
"stop_id" : 35,
"arrival_time" : "19:26:58" , 
"departure_time" : "19:27:51" , 
"distance_traveled" : 40.2659
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "19:33:53" , 
"departure_time" : "19:34:03" , 
"distance_traveled" : 45.2136
}, 
{ 
"stop_id" : 67,
"arrival_time" : "19:38:10" , 
"departure_time" : "19:38:10" , 
"distance_traveled" : 47.628
} ], 
"123" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:50:00" , 
"departure_time" : "17:51:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:08:39" , 
"departure_time" : "18:09:19" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 14,
"arrival_time" : "18:16:40" , 
"departure_time" : "18:17:26" , 
"distance_traveled" : 12.8136
}, 
{ 
"stop_id" : 152,
"arrival_time" : "18:20:46" , 
"departure_time" : "18:21:34" , 
"distance_traveled" : 13.4775
}, 
{ 
"stop_id" : 153,
"arrival_time" : "18:23:48" , 
"departure_time" : "18:23:55" , 
"distance_traveled" : 14.3379
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "18:29:07" , 
"departure_time" : "18:30:39" , 
"distance_traveled" : 17.3294
}, 
{ 
"stop_id" : 72,
"arrival_time" : "18:37:32" , 
"departure_time" : "18:39:05" , 
"distance_traveled" : 20.235
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "18:40:33" , 
"departure_time" : "18:41:50" , 
"distance_traveled" : 22.0223
}, 
{ 
"stop_id" : 98,
"arrival_time" : "18:43:17" , 
"departure_time" : "18:44:14" , 
"distance_traveled" : 23.1648
}, 
{ 
"stop_id" : 69,
"arrival_time" : "18:47:57" , 
"departure_time" : "18:49:14" , 
"distance_traveled" : 25.0848
}, 
{ 
"stop_id" : 147,
"arrival_time" : "18:53:17" , 
"departure_time" : "18:54:21" , 
"distance_traveled" : 27.3992
}, 
{ 
"stop_id" : 20,
"arrival_time" : "19:00:04" , 
"departure_time" : "19:01:31" , 
"distance_traveled" : 31.5066
}, 
{ 
"stop_id" : 96,
"arrival_time" : "19:04:27" , 
"departure_time" : "19:05:39" , 
"distance_traveled" : 33.3407
}, 
{ 
"stop_id" : 34,
"arrival_time" : "19:11:12" , 
"departure_time" : "19:11:33" , 
"distance_traveled" : 36.0778
}, 
{ 
"stop_id" : 35,
"arrival_time" : "19:18:21" , 
"departure_time" : "19:18:21" , 
"distance_traveled" : 40.286
} ], 
"124" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:50:00" , 
"departure_time" : "17:51:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:08:34" , 
"departure_time" : "18:09:37" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 14,
"arrival_time" : "18:17:03" , 
"departure_time" : "18:18:07" , 
"distance_traveled" : 12.8136
}, 
{ 
"stop_id" : 152,
"arrival_time" : "18:21:04" , 
"departure_time" : "18:21:24" , 
"distance_traveled" : 13.4775
}, 
{ 
"stop_id" : 153,
"arrival_time" : "18:23:20" , 
"departure_time" : "18:24:56" , 
"distance_traveled" : 14.3379
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "18:30:36" , 
"departure_time" : "18:30:43" , 
"distance_traveled" : 17.3294
}, 
{ 
"stop_id" : 72,
"arrival_time" : "18:36:07" , 
"departure_time" : "18:36:37" , 
"distance_traveled" : 20.235
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "18:39:30" , 
"departure_time" : "18:40:25" , 
"distance_traveled" : 22.0223
}, 
{ 
"stop_id" : 98,
"arrival_time" : "18:42:55" , 
"departure_time" : "18:44:23" , 
"distance_traveled" : 23.1648
}, 
{ 
"stop_id" : 69,
"arrival_time" : "18:48:28" , 
"departure_time" : "18:48:52" , 
"distance_traveled" : 25.0848
}, 
{ 
"stop_id" : 147,
"arrival_time" : "18:52:24" , 
"departure_time" : "18:53:21" , 
"distance_traveled" : 27.3992
}, 
{ 
"stop_id" : 20,
"arrival_time" : "18:59:57" , 
"departure_time" : "19:01:07" , 
"distance_traveled" : 31.5066
}, 
{ 
"stop_id" : 96,
"arrival_time" : "19:04:10" , 
"departure_time" : "19:05:35" , 
"distance_traveled" : 33.3407
}, 
{ 
"stop_id" : 34,
"arrival_time" : "19:11:25" , 
"departure_time" : "19:12:43" , 
"distance_traveled" : 36.0778
}, 
{ 
"stop_id" : 35,
"arrival_time" : "19:19:18" , 
"departure_time" : "19:19:18" , 
"distance_traveled" : 40.286
} ], 
"125" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:12:00" , 
"departure_time" : "17:13:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:28:29" , 
"departure_time" : "17:29:25" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 14,
"arrival_time" : "17:37:56" , 
"departure_time" : "17:38:40" , 
"distance_traveled" : 12.8136
}, 
{ 
"stop_id" : 153,
"arrival_time" : "17:42:44" , 
"departure_time" : "17:43:36" , 
"distance_traveled" : 14.3381
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "17:48:52" , 
"departure_time" : "17:50:09" , 
"distance_traveled" : 17.3297
}, 
{ 
"stop_id" : 72,
"arrival_time" : "17:55:17" , 
"departure_time" : "17:55:57" , 
"distance_traveled" : 20.2354
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "17:58:40" , 
"departure_time" : "17:59:05" , 
"distance_traveled" : 22.0227
}, 
{ 
"stop_id" : 98,
"arrival_time" : "18:00:25" , 
"departure_time" : "18:00:48" , 
"distance_traveled" : 23.1652
}, 
{ 
"stop_id" : 69,
"arrival_time" : "18:05:23" , 
"departure_time" : "18:06:22" , 
"distance_traveled" : 25.0852
}, 
{ 
"stop_id" : 147,
"arrival_time" : "18:09:59" , 
"departure_time" : "18:10:53" , 
"distance_traveled" : 27.3996
}, 
{ 
"stop_id" : 20,
"arrival_time" : "18:16:54" , 
"departure_time" : "18:17:33" , 
"distance_traveled" : 31.507
}, 
{ 
"stop_id" : 96,
"arrival_time" : "18:20:39" , 
"departure_time" : "18:20:46" , 
"distance_traveled" : 33.3411
}, 
{ 
"stop_id" : 34,
"arrival_time" : "18:25:07" , 
"departure_time" : "18:25:42" , 
"distance_traveled" : 36.0782
}, 
{ 
"stop_id" : 35,
"arrival_time" : "18:33:35" , 
"departure_time" : "18:34:09" , 
"distance_traveled" : 40.2864
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "18:40:34" , 
"departure_time" : "18:40:46" , 
"distance_traveled" : 45.2341
}, 
{ 
"stop_id" : 67,
"arrival_time" : "18:45:12" , 
"departure_time" : "18:45:28" , 
"distance_traveled" : 47.6485
}, 
{ 
"stop_id" : 101,
"arrival_time" : "18:50:16" , 
"departure_time" : "18:50:23" , 
"distance_traveled" : 50.1205
}, 
{ 
"stop_id" : 93,
"arrival_time" : "18:55:07" , 
"departure_time" : "18:55:07" , 
"distance_traveled" : 52.3356
} ], 
"126" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:12:00" , 
"departure_time" : "17:12:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:28:11" , 
"departure_time" : "17:28:16" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 14,
"arrival_time" : "17:37:05" , 
"departure_time" : "17:38:27" , 
"distance_traveled" : 12.8136
}, 
{ 
"stop_id" : 153,
"arrival_time" : "17:43:22" , 
"departure_time" : "17:43:47" , 
"distance_traveled" : 14.3381
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "17:48:25" , 
"departure_time" : "17:48:41" , 
"distance_traveled" : 17.3297
}, 
{ 
"stop_id" : 72,
"arrival_time" : "17:54:16" , 
"departure_time" : "17:55:28" , 
"distance_traveled" : 20.2354
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "17:59:12" , 
"departure_time" : "18:00:39" , 
"distance_traveled" : 22.0227
}, 
{ 
"stop_id" : 98,
"arrival_time" : "18:01:27" , 
"departure_time" : "18:01:30" , 
"distance_traveled" : 23.1652
}, 
{ 
"stop_id" : 69,
"arrival_time" : "18:05:03" , 
"departure_time" : "18:06:15" , 
"distance_traveled" : 25.0852
}, 
{ 
"stop_id" : 147,
"arrival_time" : "18:10:12" , 
"departure_time" : "18:11:40" , 
"distance_traveled" : 27.3996
}, 
{ 
"stop_id" : 20,
"arrival_time" : "18:17:28" , 
"departure_time" : "18:19:04" , 
"distance_traveled" : 31.507
}, 
{ 
"stop_id" : 96,
"arrival_time" : "18:21:36" , 
"departure_time" : "18:22:49" , 
"distance_traveled" : 33.3411
}, 
{ 
"stop_id" : 34,
"arrival_time" : "18:26:13" , 
"departure_time" : "18:26:24" , 
"distance_traveled" : 36.0782
}, 
{ 
"stop_id" : 35,
"arrival_time" : "18:33:11" , 
"departure_time" : "18:33:36" , 
"distance_traveled" : 40.2864
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "18:40:25" , 
"departure_time" : "18:41:29" , 
"distance_traveled" : 45.2341
}, 
{ 
"stop_id" : 67,
"arrival_time" : "18:46:04" , 
"departure_time" : "18:46:51" , 
"distance_traveled" : 47.6485
}, 
{ 
"stop_id" : 101,
"arrival_time" : "18:50:47" , 
"departure_time" : "18:51:01" , 
"distance_traveled" : 50.1205
}, 
{ 
"stop_id" : 93,
"arrival_time" : "18:55:14" , 
"departure_time" : "18:55:14" , 
"distance_traveled" : 52.3356
} ], 
"127" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "15:34:00" , 
"departure_time" : "15:35:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:51:09" , 
"departure_time" : "15:51:36" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 19,
"arrival_time" : "15:57:27" , 
"departure_time" : "15:58:16" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "16:00:49" , 
"departure_time" : "16:01:21" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "16:03:32" , 
"departure_time" : "16:03:40" , 
"distance_traveled" : 12.7936
}, 
{ 
"stop_id" : 152,
"arrival_time" : "16:06:08" , 
"departure_time" : "16:06:58" , 
"distance_traveled" : 13.4574
}, 
{ 
"stop_id" : 153,
"arrival_time" : "16:09:50" , 
"departure_time" : "16:10:18" , 
"distance_traveled" : 14.3178
}, 
{ 
"stop_id" : 150,
"arrival_time" : "16:11:28" , 
"departure_time" : "16:12:17" , 
"distance_traveled" : 15.2754
}, 
{ 
"stop_id" : 89,
"arrival_time" : "16:14:49" , 
"departure_time" : "16:15:14" , 
"distance_traveled" : 16.4201
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "16:17:25" , 
"departure_time" : "16:18:34" , 
"distance_traveled" : 17.3093
}, 
{ 
"stop_id" : 72,
"arrival_time" : "16:24:09" , 
"departure_time" : "16:24:55" , 
"distance_traveled" : 20.215
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "16:26:46" , 
"departure_time" : "16:27:44" , 
"distance_traveled" : 22.0023
}, 
{ 
"stop_id" : 98,
"arrival_time" : "16:29:58" , 
"departure_time" : "16:30:36" , 
"distance_traveled" : 23.1447
}, 
{ 
"stop_id" : 69,
"arrival_time" : "16:34:38" , 
"departure_time" : "16:34:58" , 
"distance_traveled" : 25.0648
}, 
{ 
"stop_id" : 147,
"arrival_time" : "16:38:20" , 
"departure_time" : "16:38:56" , 
"distance_traveled" : 27.3792
}, 
{ 
"stop_id" : 20,
"arrival_time" : "16:45:36" , 
"departure_time" : "16:45:52" , 
"distance_traveled" : 31.4866
}, 
{ 
"stop_id" : 96,
"arrival_time" : "16:48:16" , 
"departure_time" : "16:48:28" , 
"distance_traveled" : 33.3206
}, 
{ 
"stop_id" : 34,
"arrival_time" : "16:52:12" , 
"departure_time" : "16:52:12" , 
"distance_traveled" : 36.0578
} ], 
"128" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "15:34:00" , 
"departure_time" : "15:35:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:51:29" , 
"departure_time" : "15:51:46" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 19,
"arrival_time" : "15:57:17" , 
"departure_time" : "15:58:38" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "16:01:21" , 
"departure_time" : "16:02:47" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "16:04:26" , 
"departure_time" : "16:05:50" , 
"distance_traveled" : 12.7936
}, 
{ 
"stop_id" : 152,
"arrival_time" : "16:07:24" , 
"departure_time" : "16:08:45" , 
"distance_traveled" : 13.4574
}, 
{ 
"stop_id" : 153,
"arrival_time" : "16:10:21" , 
"departure_time" : "16:11:16" , 
"distance_traveled" : 14.3178
}, 
{ 
"stop_id" : 150,
"arrival_time" : "16:11:55" , 
"departure_time" : "16:11:58" , 
"distance_traveled" : 15.2754
}, 
{ 
"stop_id" : 89,
"arrival_time" : "16:14:03" , 
"departure_time" : "16:14:56" , 
"distance_traveled" : 16.4201
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "16:17:53" , 
"departure_time" : "16:18:10" , 
"distance_traveled" : 17.3093
}, 
{ 
"stop_id" : 72,
"arrival_time" : "16:23:17" , 
"departure_time" : "16:24:22" , 
"distance_traveled" : 20.215
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "16:27:05" , 
"departure_time" : "16:27:35" , 
"distance_traveled" : 22.0023
}, 
{ 
"stop_id" : 98,
"arrival_time" : "16:29:30" , 
"departure_time" : "16:31:04" , 
"distance_traveled" : 23.1447
}, 
{ 
"stop_id" : 69,
"arrival_time" : "16:35:34" , 
"departure_time" : "16:37:06" , 
"distance_traveled" : 25.0648
}, 
{ 
"stop_id" : 147,
"arrival_time" : "16:39:32" , 
"departure_time" : "16:39:48" , 
"distance_traveled" : 27.3792
}, 
{ 
"stop_id" : 20,
"arrival_time" : "16:45:16" , 
"departure_time" : "16:45:48" , 
"distance_traveled" : 31.4866
}, 
{ 
"stop_id" : 96,
"arrival_time" : "16:48:32" , 
"departure_time" : "16:49:17" , 
"distance_traveled" : 33.3206
}, 
{ 
"stop_id" : 34,
"arrival_time" : "16:52:45" , 
"departure_time" : "16:52:45" , 
"distance_traveled" : 36.0578
} ], 
"129" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:33:00" , 
"departure_time" : "18:34:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:50:08" , 
"departure_time" : "18:50:50" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 19,
"arrival_time" : "18:56:42" , 
"departure_time" : "18:57:31" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "18:59:49" , 
"departure_time" : "19:00:23" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "19:02:34" , 
"departure_time" : "19:02:42" , 
"distance_traveled" : 12.7936
}, 
{ 
"stop_id" : 152,
"arrival_time" : "19:05:08" , 
"departure_time" : "19:06:36" , 
"distance_traveled" : 13.4574
}, 
{ 
"stop_id" : 153,
"arrival_time" : "19:09:28" , 
"departure_time" : "19:10:41" , 
"distance_traveled" : 14.3178
}, 
{ 
"stop_id" : 150,
"arrival_time" : "19:12:13" , 
"departure_time" : "19:13:50" , 
"distance_traveled" : 15.2754
}, 
{ 
"stop_id" : 89,
"arrival_time" : "19:15:37" , 
"departure_time" : "19:16:01" , 
"distance_traveled" : 16.4201
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "19:16:24" , 
"departure_time" : "19:17:23" , 
"distance_traveled" : 17.3093
}, 
{ 
"stop_id" : 72,
"arrival_time" : "19:23:59" , 
"departure_time" : "19:25:32" , 
"distance_traveled" : 20.215
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "19:27:33" , 
"departure_time" : "19:29:01" , 
"distance_traveled" : 22.0023
}, 
{ 
"stop_id" : 98,
"arrival_time" : "19:30:28" , 
"departure_time" : "19:31:38" , 
"distance_traveled" : 23.1447
}, 
{ 
"stop_id" : 69,
"arrival_time" : "19:35:10" , 
"departure_time" : "19:35:40" , 
"distance_traveled" : 25.0648
}, 
{ 
"stop_id" : 147,
"arrival_time" : "19:38:30" , 
"departure_time" : "19:39:14" , 
"distance_traveled" : 27.3792
}, 
{ 
"stop_id" : 20,
"arrival_time" : "19:45:44" , 
"departure_time" : "19:46:25" , 
"distance_traveled" : 31.4866
}, 
{ 
"stop_id" : 96,
"arrival_time" : "19:48:41" , 
"departure_time" : "19:49:54" , 
"distance_traveled" : 33.3206
}, 
{ 
"stop_id" : 34,
"arrival_time" : "19:54:13" , 
"departure_time" : "19:55:40" , 
"distance_traveled" : 36.0578
}, 
{ 
"stop_id" : 35,
"arrival_time" : "20:01:27" , 
"departure_time" : "20:01:48" , 
"distance_traveled" : 40.2659
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "20:07:21" , 
"departure_time" : "20:08:25" , 
"distance_traveled" : 45.2136
}, 
{ 
"stop_id" : 67,
"arrival_time" : "20:14:04" , 
"departure_time" : "20:14:04" , 
"distance_traveled" : 47.628
} ], 
"130" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:33:00" , 
"departure_time" : "18:35:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:50:40" , 
"departure_time" : "18:51:47" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 19,
"arrival_time" : "18:57:07" , 
"departure_time" : "18:57:23" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "18:59:16" , 
"departure_time" : "19:00:34" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "19:03:18" , 
"departure_time" : "19:04:46" , 
"distance_traveled" : 12.7936
}, 
{ 
"stop_id" : 152,
"arrival_time" : "19:06:28" , 
"departure_time" : "19:07:08" , 
"distance_traveled" : 13.4574
}, 
{ 
"stop_id" : 153,
"arrival_time" : "19:08:40" , 
"departure_time" : "19:10:12" , 
"distance_traveled" : 14.3178
}, 
{ 
"stop_id" : 150,
"arrival_time" : "19:12:32" , 
"departure_time" : "19:12:53" , 
"distance_traveled" : 15.2754
}, 
{ 
"stop_id" : 89,
"arrival_time" : "19:14:21" , 
"departure_time" : "19:14:46" , 
"distance_traveled" : 16.4201
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "19:16:25" , 
"departure_time" : "19:16:35" , 
"distance_traveled" : 17.3093
}, 
{ 
"stop_id" : 72,
"arrival_time" : "19:23:10" , 
"departure_time" : "19:23:57" , 
"distance_traveled" : 20.215
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "19:26:47" , 
"departure_time" : "19:28:21" , 
"distance_traveled" : 22.0023
}, 
{ 
"stop_id" : 98,
"arrival_time" : "19:30:34" , 
"departure_time" : "19:32:06" , 
"distance_traveled" : 23.1447
}, 
{ 
"stop_id" : 69,
"arrival_time" : "19:35:32" , 
"departure_time" : "19:36:09" , 
"distance_traveled" : 25.0648
}, 
{ 
"stop_id" : 147,
"arrival_time" : "19:38:37" , 
"departure_time" : "19:39:24" , 
"distance_traveled" : 27.3792
}, 
{ 
"stop_id" : 20,
"arrival_time" : "19:45:47" , 
"departure_time" : "19:47:15" , 
"distance_traveled" : 31.4866
}, 
{ 
"stop_id" : 96,
"arrival_time" : "19:49:28" , 
"departure_time" : "19:49:46" , 
"distance_traveled" : 33.3206
}, 
{ 
"stop_id" : 34,
"arrival_time" : "19:53:18" , 
"departure_time" : "19:54:13" , 
"distance_traveled" : 36.0578
}, 
{ 
"stop_id" : 35,
"arrival_time" : "20:00:55" , 
"departure_time" : "20:01:38" , 
"distance_traveled" : 40.2659
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "20:07:43" , 
"departure_time" : "20:08:57" , 
"distance_traveled" : 45.2136
}, 
{ 
"stop_id" : 67,
"arrival_time" : "20:14:14" , 
"departure_time" : "20:14:14" , 
"distance_traveled" : 47.628
} ], 
"131" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "13:58:00" , 
"departure_time" : "14:00:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "14:17:40" , 
"departure_time" : "14:18:36" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 154,
"arrival_time" : "14:22:56" , 
"departure_time" : "14:23:33" , 
"distance_traveled" : 10.8928
}, 
{ 
"stop_id" : 19,
"arrival_time" : "14:24:37" , 
"departure_time" : "14:25:45" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "14:28:08" , 
"departure_time" : "14:28:42" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "14:30:34" , 
"departure_time" : "14:30:39" , 
"distance_traveled" : 12.7936
}, 
{ 
"stop_id" : 152,
"arrival_time" : "14:33:05" , 
"departure_time" : "14:33:49" , 
"distance_traveled" : 13.4574
}, 
{ 
"stop_id" : 153,
"arrival_time" : "14:36:44" , 
"departure_time" : "14:38:22" , 
"distance_traveled" : 14.3178
}, 
{ 
"stop_id" : 150,
"arrival_time" : "14:40:38" , 
"departure_time" : "14:41:06" , 
"distance_traveled" : 15.2754
}, 
{ 
"stop_id" : 95,
"arrival_time" : "14:41:28" , 
"departure_time" : "14:41:45" , 
"distance_traveled" : 15.7869
}, 
{ 
"stop_id" : 89,
"arrival_time" : "14:43:17" , 
"departure_time" : "14:44:27" , 
"distance_traveled" : 16.4201
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "14:47:10" , 
"departure_time" : "14:47:35" , 
"distance_traveled" : 17.3093
}, 
{ 
"stop_id" : 72,
"arrival_time" : "14:52:25" , 
"departure_time" : "14:53:44" , 
"distance_traveled" : 20.215
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "14:57:19" , 
"departure_time" : "14:58:11" , 
"distance_traveled" : 22.0023
}, 
{ 
"stop_id" : 98,
"arrival_time" : "14:58:52" , 
"departure_time" : "14:59:46" , 
"distance_traveled" : 23.1447
}, 
{ 
"stop_id" : 69,
"arrival_time" : "15:03:54" , 
"departure_time" : "15:05:22" , 
"distance_traveled" : 25.0648
}, 
{ 
"stop_id" : 147,
"arrival_time" : "15:08:28" , 
"departure_time" : "15:08:57" , 
"distance_traveled" : 27.3792
}, 
{ 
"stop_id" : 20,
"arrival_time" : "15:14:29" , 
"departure_time" : "15:15:03" , 
"distance_traveled" : 31.4866
}, 
{ 
"stop_id" : 96,
"arrival_time" : "15:18:34" , 
"departure_time" : "15:19:50" , 
"distance_traveled" : 33.3206
}, 
{ 
"stop_id" : 34,
"arrival_time" : "15:24:16" , 
"departure_time" : "15:25:00" , 
"distance_traveled" : 36.0578
}, 
{ 
"stop_id" : 35,
"arrival_time" : "15:29:44" , 
"departure_time" : "15:29:44" , 
"distance_traveled" : 40.2659
} ], 
"132" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "13:58:00" , 
"departure_time" : "14:00:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "14:17:21" , 
"departure_time" : "14:18:28" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 154,
"arrival_time" : "14:23:07" , 
"departure_time" : "14:23:38" , 
"distance_traveled" : 10.8928
}, 
{ 
"stop_id" : 19,
"arrival_time" : "14:24:31" , 
"departure_time" : "14:26:01" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "14:28:30" , 
"departure_time" : "14:29:42" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "14:31:12" , 
"departure_time" : "14:32:24" , 
"distance_traveled" : 12.7936
}, 
{ 
"stop_id" : 152,
"arrival_time" : "14:34:12" , 
"departure_time" : "14:34:57" , 
"distance_traveled" : 13.4574
}, 
{ 
"stop_id" : 153,
"arrival_time" : "14:36:45" , 
"departure_time" : "14:37:01" , 
"distance_traveled" : 14.3178
}, 
{ 
"stop_id" : 150,
"arrival_time" : "14:39:16" , 
"departure_time" : "14:40:00" , 
"distance_traveled" : 15.2754
}, 
{ 
"stop_id" : 95,
"arrival_time" : "14:41:44" , 
"departure_time" : "14:42:05" , 
"distance_traveled" : 15.7869
}, 
{ 
"stop_id" : 89,
"arrival_time" : "14:43:21" , 
"departure_time" : "14:43:56" , 
"distance_traveled" : 16.4201
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "14:46:35" , 
"departure_time" : "14:47:14" , 
"distance_traveled" : 17.3093
}, 
{ 
"stop_id" : 72,
"arrival_time" : "14:52:39" , 
"departure_time" : "14:53:48" , 
"distance_traveled" : 20.215
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "14:57:09" , 
"departure_time" : "14:58:14" , 
"distance_traveled" : 22.0023
}, 
{ 
"stop_id" : 98,
"arrival_time" : "14:59:05" , 
"departure_time" : "14:59:08" , 
"distance_traveled" : 23.1447
}, 
{ 
"stop_id" : 69,
"arrival_time" : "15:03:03" , 
"departure_time" : "15:03:59" , 
"distance_traveled" : 25.0648
}, 
{ 
"stop_id" : 147,
"arrival_time" : "15:07:56" , 
"departure_time" : "15:09:36" , 
"distance_traveled" : 27.3792
}, 
{ 
"stop_id" : 20,
"arrival_time" : "15:15:40" , 
"departure_time" : "15:16:56" , 
"distance_traveled" : 31.4866
}, 
{ 
"stop_id" : 96,
"arrival_time" : "15:19:16" , 
"departure_time" : "15:20:04" , 
"distance_traveled" : 33.3206
}, 
{ 
"stop_id" : 34,
"arrival_time" : "15:23:48" , 
"departure_time" : "15:25:23" , 
"distance_traveled" : 36.0578
}, 
{ 
"stop_id" : 35,
"arrival_time" : "15:30:35" , 
"departure_time" : "15:30:35" , 
"distance_traveled" : 40.2659
} ], 
"133" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:32:00" , 
"departure_time" : "16:34:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:48:25" , 
"departure_time" : "16:49:59" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 19,
"arrival_time" : "16:56:34" , 
"departure_time" : "16:56:57" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "16:58:23" , 
"departure_time" : "16:58:49" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "17:01:26" , 
"departure_time" : "17:03:02" , 
"distance_traveled" : 12.7936
}, 
{ 
"stop_id" : 152,
"arrival_time" : "17:05:36" , 
"departure_time" : "17:06:35" , 
"distance_traveled" : 13.4574
}, 
{ 
"stop_id" : 153,
"arrival_time" : "17:07:59" , 
"departure_time" : "17:09:06" , 
"distance_traveled" : 14.3178
}, 
{ 
"stop_id" : 150,
"arrival_time" : "17:10:07" , 
"departure_time" : "17:10:36" , 
"distance_traveled" : 15.2754
}, 
{ 
"stop_id" : 89,
"arrival_time" : "17:12:29" , 
"departure_time" : "17:12:48" , 
"distance_traveled" : 16.4201
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "17:15:19" , 
"departure_time" : "17:16:46" , 
"distance_traveled" : 17.3093
}, 
{ 
"stop_id" : 72,
"arrival_time" : "17:23:27" , 
"departure_time" : "17:24:52" , 
"distance_traveled" : 20.215
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "17:27:25" , 
"departure_time" : "17:28:17" , 
"distance_traveled" : 22.0023
}, 
{ 
"stop_id" : 98,
"arrival_time" : "17:29:52" , 
"departure_time" : "17:30:39" , 
"distance_traveled" : 23.1447
}, 
{ 
"stop_id" : 69,
"arrival_time" : "17:33:47" , 
"departure_time" : "17:34:12" , 
"distance_traveled" : 25.0648
}, 
{ 
"stop_id" : 147,
"arrival_time" : "17:38:25" , 
"departure_time" : "17:38:47" , 
"distance_traveled" : 27.3792
}, 
{ 
"stop_id" : 20,
"arrival_time" : "17:45:22" , 
"departure_time" : "17:46:54" , 
"distance_traveled" : 31.4866
}, 
{ 
"stop_id" : 96,
"arrival_time" : "17:50:32" , 
"departure_time" : "17:51:06" , 
"distance_traveled" : 33.3206
}, 
{ 
"stop_id" : 34,
"arrival_time" : "17:54:34" , 
"departure_time" : "17:55:23" , 
"distance_traveled" : 36.0578
}, 
{ 
"stop_id" : 35,
"arrival_time" : "18:01:49" , 
"departure_time" : "18:01:58" , 
"distance_traveled" : 40.2659
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "18:08:09" , 
"departure_time" : "18:08:24" , 
"distance_traveled" : 45.2136
}, 
{ 
"stop_id" : 67,
"arrival_time" : "18:14:15" , 
"departure_time" : "18:15:01" , 
"distance_traveled" : 47.628
}, 
{ 
"stop_id" : 101,
"arrival_time" : "18:19:46" , 
"departure_time" : "18:20:04" , 
"distance_traveled" : 50.1
}, 
{ 
"stop_id" : 93,
"arrival_time" : "18:23:18" , 
"departure_time" : "18:23:32" , 
"distance_traveled" : 52.3152
}, 
{ 
"stop_id" : 54,
"arrival_time" : "18:39:14" , 
"departure_time" : "18:39:14" , 
"distance_traveled" : 59.6992
} ], 
"134" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:32:00" , 
"departure_time" : "16:33:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:49:34" , 
"departure_time" : "16:50:15" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 19,
"arrival_time" : "16:55:41" , 
"departure_time" : "16:57:14" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "16:59:33" , 
"departure_time" : "17:01:01" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "17:02:28" , 
"departure_time" : "17:03:43" , 
"distance_traveled" : 12.7936
}, 
{ 
"stop_id" : 152,
"arrival_time" : "17:05:15" , 
"departure_time" : "17:06:16" , 
"distance_traveled" : 13.4574
}, 
{ 
"stop_id" : 153,
"arrival_time" : "17:08:01" , 
"departure_time" : "17:08:20" , 
"distance_traveled" : 14.3178
}, 
{ 
"stop_id" : 150,
"arrival_time" : "17:09:19" , 
"departure_time" : "17:09:35" , 
"distance_traveled" : 15.2754
}, 
{ 
"stop_id" : 89,
"arrival_time" : "17:12:16" , 
"departure_time" : "17:12:45" , 
"distance_traveled" : 16.4201
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "17:15:29" , 
"departure_time" : "17:16:02" , 
"distance_traveled" : 17.3093
}, 
{ 
"stop_id" : 72,
"arrival_time" : "17:22:33" , 
"departure_time" : "17:24:10" , 
"distance_traveled" : 20.215
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "17:27:37" , 
"departure_time" : "17:27:50" , 
"distance_traveled" : 22.0023
}, 
{ 
"stop_id" : 98,
"arrival_time" : "17:29:13" , 
"departure_time" : "17:30:04" , 
"distance_traveled" : 23.1447
}, 
{ 
"stop_id" : 69,
"arrival_time" : "17:33:51" , 
"departure_time" : "17:33:53" , 
"distance_traveled" : 25.0648
}, 
{ 
"stop_id" : 147,
"arrival_time" : "17:38:02" , 
"departure_time" : "17:38:18" , 
"distance_traveled" : 27.3792
}, 
{ 
"stop_id" : 20,
"arrival_time" : "17:45:16" , 
"departure_time" : "17:46:11" , 
"distance_traveled" : 31.4866
}, 
{ 
"stop_id" : 96,
"arrival_time" : "17:49:55" , 
"departure_time" : "17:51:11" , 
"distance_traveled" : 33.3206
}, 
{ 
"stop_id" : 34,
"arrival_time" : "17:55:16" , 
"departure_time" : "17:56:47" , 
"distance_traveled" : 36.0578
}, 
{ 
"stop_id" : 35,
"arrival_time" : "18:02:31" , 
"departure_time" : "18:02:53" , 
"distance_traveled" : 40.2659
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "18:08:22" , 
"departure_time" : "18:08:58" , 
"distance_traveled" : 45.2136
}, 
{ 
"stop_id" : 67,
"arrival_time" : "18:14:36" , 
"departure_time" : "18:15:10" , 
"distance_traveled" : 47.628
}, 
{ 
"stop_id" : 101,
"arrival_time" : "18:19:34" , 
"departure_time" : "18:19:53" , 
"distance_traveled" : 50.1
}, 
{ 
"stop_id" : 93,
"arrival_time" : "18:23:19" , 
"departure_time" : "18:24:07" , 
"distance_traveled" : 52.3152
}, 
{ 
"stop_id" : 54,
"arrival_time" : "18:39:48" , 
"departure_time" : "18:39:48" , 
"distance_traveled" : 59.6992
} ], 
"135" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "22:04:00" , 
"departure_time" : "22:06:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "22:23:26" , 
"departure_time" : "22:24:39" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 154,
"arrival_time" : "22:30:13" , 
"departure_time" : "22:31:31" , 
"distance_traveled" : 10.8928
}, 
{ 
"stop_id" : 19,
"arrival_time" : "22:32:18" , 
"departure_time" : "22:32:23" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "22:34:05" , 
"departure_time" : "22:35:33" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "22:38:28" , 
"departure_time" : "22:38:49" , 
"distance_traveled" : 12.7936
}, 
{ 
"stop_id" : 152,
"arrival_time" : "22:40:21" , 
"departure_time" : "22:41:55" , 
"distance_traveled" : 13.4574
}, 
{ 
"stop_id" : 153,
"arrival_time" : "22:43:34" , 
"departure_time" : "22:44:42" , 
"distance_traveled" : 14.3178
}, 
{ 
"stop_id" : 150,
"arrival_time" : "22:46:08" , 
"departure_time" : "22:47:45" , 
"distance_traveled" : 15.2754
}, 
{ 
"stop_id" : 95,
"arrival_time" : "22:48:37" , 
"departure_time" : "22:49:58" , 
"distance_traveled" : 15.7869
}, 
{ 
"stop_id" : 89,
"arrival_time" : "22:51:21" , 
"departure_time" : "22:52:41" , 
"distance_traveled" : 16.4201
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "22:54:20" , 
"departure_time" : "22:55:30" , 
"distance_traveled" : 17.3093
}, 
{ 
"stop_id" : 72,
"arrival_time" : "22:59:10" , 
"departure_time" : "23:00:28" , 
"distance_traveled" : 20.215
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "23:03:18" , 
"departure_time" : "23:03:22" , 
"distance_traveled" : 22.0023
}, 
{ 
"stop_id" : 98,
"arrival_time" : "23:05:04" , 
"departure_time" : "23:06:25" , 
"distance_traveled" : 23.1447
}, 
{ 
"stop_id" : 69,
"arrival_time" : "23:10:21" , 
"departure_time" : "23:11:16" , 
"distance_traveled" : 25.0648
}, 
{ 
"stop_id" : 147,
"arrival_time" : "23:13:55" , 
"departure_time" : "23:14:40" , 
"distance_traveled" : 27.3792
}, 
{ 
"stop_id" : 20,
"arrival_time" : "23:19:45" , 
"departure_time" : "23:20:28" , 
"distance_traveled" : 31.4866
}, 
{ 
"stop_id" : 96,
"arrival_time" : "23:23:43" , 
"departure_time" : "23:24:09" , 
"distance_traveled" : 33.3206
}, 
{ 
"stop_id" : 34,
"arrival_time" : "23:27:26" , 
"departure_time" : "23:28:31" , 
"distance_traveled" : 36.0578
}, 
{ 
"stop_id" : 35,
"arrival_time" : "23:36:05" , 
"departure_time" : "23:36:32" , 
"distance_traveled" : 40.2659
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "23:42:27" , 
"departure_time" : "23:42:32" , 
"distance_traveled" : 45.2136
}, 
{ 
"stop_id" : 67,
"arrival_time" : "23:47:05" , 
"departure_time" : "23:47:37" , 
"distance_traveled" : 47.628
}, 
{ 
"stop_id" : 101,
"arrival_time" : "23:52:32" , 
"departure_time" : "23:52:37" , 
"distance_traveled" : 50.1
}, 
{ 
"stop_id" : 93,
"arrival_time" : "23:58:05" , 
"departure_time" : "23:58:05" , 
"distance_traveled" : 52.3152
} ], 
"136" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "22:04:00" , 
"departure_time" : "22:04:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "22:22:15" , 
"departure_time" : "22:23:26" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 154,
"arrival_time" : "22:30:11" , 
"departure_time" : "22:30:48" , 
"distance_traveled" : 10.8928
}, 
{ 
"stop_id" : 19,
"arrival_time" : "22:31:37" , 
"departure_time" : "22:32:38" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "22:35:01" , 
"departure_time" : "22:36:02" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "22:38:01" , 
"departure_time" : "22:38:12" , 
"distance_traveled" : 12.7936
}, 
{ 
"stop_id" : 152,
"arrival_time" : "22:40:11" , 
"departure_time" : "22:41:01" , 
"distance_traveled" : 13.4574
}, 
{ 
"stop_id" : 153,
"arrival_time" : "22:42:50" , 
"departure_time" : "22:44:12" , 
"distance_traveled" : 14.3178
}, 
{ 
"stop_id" : 150,
"arrival_time" : "22:46:22" , 
"departure_time" : "22:47:57" , 
"distance_traveled" : 15.2754
}, 
{ 
"stop_id" : 95,
"arrival_time" : "22:48:35" , 
"departure_time" : "22:49:21" , 
"distance_traveled" : 15.7869
}, 
{ 
"stop_id" : 89,
"arrival_time" : "22:50:46" , 
"departure_time" : "22:51:51" , 
"distance_traveled" : 16.4201
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "22:54:05" , 
"departure_time" : "22:54:06" , 
"distance_traveled" : 17.3093
}, 
{ 
"stop_id" : 72,
"arrival_time" : "22:58:01" , 
"departure_time" : "22:59:16" , 
"distance_traveled" : 20.215
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "23:03:15" , 
"departure_time" : "23:03:30" , 
"distance_traveled" : 22.0023
}, 
{ 
"stop_id" : 98,
"arrival_time" : "23:05:15" , 
"departure_time" : "23:06:27" , 
"distance_traveled" : 23.1447
}, 
{ 
"stop_id" : 69,
"arrival_time" : "23:10:12" , 
"departure_time" : "23:11:14" , 
"distance_traveled" : 25.0648
}, 
{ 
"stop_id" : 147,
"arrival_time" : "23:14:02" , 
"departure_time" : "23:15:02" , 
"distance_traveled" : 27.3792
}, 
{ 
"stop_id" : 20,
"arrival_time" : "23:20:00" , 
"departure_time" : "23:21:17" , 
"distance_traveled" : 31.4866
}, 
{ 
"stop_id" : 96,
"arrival_time" : "23:24:17" , 
"departure_time" : "23:24:23" , 
"distance_traveled" : 33.3206
}, 
{ 
"stop_id" : 34,
"arrival_time" : "23:27:06" , 
"departure_time" : "23:27:41" , 
"distance_traveled" : 36.0578
}, 
{ 
"stop_id" : 35,
"arrival_time" : "23:35:35" , 
"departure_time" : "23:35:38" , 
"distance_traveled" : 40.2659
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "23:42:03" , 
"departure_time" : "23:42:33" , 
"distance_traveled" : 45.2136
}, 
{ 
"stop_id" : 67,
"arrival_time" : "23:47:30" , 
"departure_time" : "23:48:30" , 
"distance_traveled" : 47.628
}, 
{ 
"stop_id" : 101,
"arrival_time" : "23:53:00" , 
"departure_time" : "23:53:18" , 
"distance_traveled" : 50.1
}, 
{ 
"stop_id" : 93,
"arrival_time" : "23:58:18" , 
"departure_time" : "23:58:18" , 
"distance_traveled" : 52.3152
} ], 
"137" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "19:22:00" , 
"departure_time" : "19:22:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:39:24" , 
"departure_time" : "19:40:32" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 154,
"arrival_time" : "19:46:08" , 
"departure_time" : "19:46:22" , 
"distance_traveled" : 10.8928
}, 
{ 
"stop_id" : 19,
"arrival_time" : "19:48:14" , 
"departure_time" : "19:48:33" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "19:50:19" , 
"departure_time" : "19:50:39" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "19:53:20" , 
"departure_time" : "19:54:31" , 
"distance_traveled" : 12.7936
}, 
{ 
"stop_id" : 152,
"arrival_time" : "19:57:11" , 
"departure_time" : "19:58:37" , 
"distance_traveled" : 13.4574
}, 
{ 
"stop_id" : 153,
"arrival_time" : "20:00:26" , 
"departure_time" : "20:00:44" , 
"distance_traveled" : 14.3178
}, 
{ 
"stop_id" : 150,
"arrival_time" : "20:02:18" , 
"departure_time" : "20:02:56" , 
"distance_traveled" : 15.2754
}, 
{ 
"stop_id" : 95,
"arrival_time" : "20:04:38" , 
"departure_time" : "20:05:46" , 
"distance_traveled" : 15.7869
}, 
{ 
"stop_id" : 89,
"arrival_time" : "20:08:08" , 
"departure_time" : "20:08:56" , 
"distance_traveled" : 16.4201
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "20:09:48" , 
"departure_time" : "20:11:21" , 
"distance_traveled" : 17.3093
}, 
{ 
"stop_id" : 72,
"arrival_time" : "20:17:33" , 
"departure_time" : "20:18:44" , 
"distance_traveled" : 20.215
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "20:20:11" , 
"departure_time" : "20:20:22" , 
"distance_traveled" : 22.0023
}, 
{ 
"stop_id" : 98,
"arrival_time" : "20:23:11" , 
"departure_time" : "20:23:51" , 
"distance_traveled" : 23.1447
}, 
{ 
"stop_id" : 69,
"arrival_time" : "20:27:40" , 
"departure_time" : "20:28:36" , 
"distance_traveled" : 25.0648
}, 
{ 
"stop_id" : 147,
"arrival_time" : "20:31:56" , 
"departure_time" : "20:32:19" , 
"distance_traveled" : 27.3792
}, 
{ 
"stop_id" : 20,
"arrival_time" : "20:37:23" , 
"departure_time" : "20:38:12" , 
"distance_traveled" : 31.4866
}, 
{ 
"stop_id" : 96,
"arrival_time" : "20:41:49" , 
"departure_time" : "20:42:18" , 
"distance_traveled" : 33.3206
}, 
{ 
"stop_id" : 34,
"arrival_time" : "20:46:29" , 
"departure_time" : "20:47:05" , 
"distance_traveled" : 36.0578
}, 
{ 
"stop_id" : 35,
"arrival_time" : "20:53:36" , 
"departure_time" : "20:54:52" , 
"distance_traveled" : 40.2659
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "21:02:16" , 
"departure_time" : "21:03:11" , 
"distance_traveled" : 45.2136
}, 
{ 
"stop_id" : 67,
"arrival_time" : "21:06:55" , 
"departure_time" : "21:07:01" , 
"distance_traveled" : 47.628
}, 
{ 
"stop_id" : 101,
"arrival_time" : "21:11:06" , 
"departure_time" : "21:12:19" , 
"distance_traveled" : 50.1
}, 
{ 
"stop_id" : 93,
"arrival_time" : "21:17:13" , 
"departure_time" : "21:18:38" , 
"distance_traveled" : 52.3152
}, 
{ 
"stop_id" : 54,
"arrival_time" : "21:27:25" , 
"departure_time" : "21:27:25" , 
"distance_traveled" : 59.6992
} ], 
"138" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "19:22:00" , 
"departure_time" : "19:24:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:40:12" , 
"departure_time" : "19:41:20" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 154,
"arrival_time" : "19:46:08" , 
"departure_time" : "19:46:15" , 
"distance_traveled" : 10.8928
}, 
{ 
"stop_id" : 19,
"arrival_time" : "19:48:07" , 
"departure_time" : "19:49:26" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "19:51:19" , 
"departure_time" : "19:51:22" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "19:53:03" , 
"departure_time" : "19:53:40" , 
"distance_traveled" : 12.7936
}, 
{ 
"stop_id" : 152,
"arrival_time" : "19:56:37" , 
"departure_time" : "19:57:15" , 
"distance_traveled" : 13.4574
}, 
{ 
"stop_id" : 153,
"arrival_time" : "19:59:38" , 
"departure_time" : "20:00:00" , 
"distance_traveled" : 14.3178
}, 
{ 
"stop_id" : 150,
"arrival_time" : "20:02:22" , 
"departure_time" : "20:03:35" , 
"distance_traveled" : 15.2754
}, 
{ 
"stop_id" : 95,
"arrival_time" : "20:05:13" , 
"departure_time" : "20:05:33" , 
"distance_traveled" : 15.7869
}, 
{ 
"stop_id" : 89,
"arrival_time" : "20:07:20" , 
"departure_time" : "20:08:11" , 
"distance_traveled" : 16.4201
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "20:09:51" , 
"departure_time" : "20:10:21" , 
"distance_traveled" : 17.3093
}, 
{ 
"stop_id" : 72,
"arrival_time" : "20:16:30" , 
"departure_time" : "20:18:07" , 
"distance_traveled" : 20.215
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "20:20:37" , 
"departure_time" : "20:22:01" , 
"distance_traveled" : 22.0023
}, 
{ 
"stop_id" : 98,
"arrival_time" : "20:24:24" , 
"departure_time" : "20:25:06" , 
"distance_traveled" : 23.1447
}, 
{ 
"stop_id" : 69,
"arrival_time" : "20:27:42" , 
"departure_time" : "20:28:29" , 
"distance_traveled" : 25.0648
}, 
{ 
"stop_id" : 147,
"arrival_time" : "20:31:47" , 
"departure_time" : "20:33:10" , 
"distance_traveled" : 27.3792
}, 
{ 
"stop_id" : 20,
"arrival_time" : "20:38:23" , 
"departure_time" : "20:39:29" , 
"distance_traveled" : 31.4866
}, 
{ 
"stop_id" : 96,
"arrival_time" : "20:42:06" , 
"departure_time" : "20:42:38" , 
"distance_traveled" : 33.3206
}, 
{ 
"stop_id" : 34,
"arrival_time" : "20:46:32" , 
"departure_time" : "20:47:02" , 
"distance_traveled" : 36.0578
}, 
{ 
"stop_id" : 35,
"arrival_time" : "20:53:30" , 
"departure_time" : "20:54:36" , 
"distance_traveled" : 40.2659
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "21:02:06" , 
"departure_time" : "21:03:41" , 
"distance_traveled" : 45.2136
}, 
{ 
"stop_id" : 67,
"arrival_time" : "21:07:35" , 
"departure_time" : "21:09:07" , 
"distance_traveled" : 47.628
}, 
{ 
"stop_id" : 101,
"arrival_time" : "21:12:32" , 
"departure_time" : "21:13:20" , 
"distance_traveled" : 50.1
}, 
{ 
"stop_id" : 93,
"arrival_time" : "21:16:48" , 
"departure_time" : "21:18:11" , 
"distance_traveled" : 52.3152
}, 
{ 
"stop_id" : 54,
"arrival_time" : "21:27:23" , 
"departure_time" : "21:27:23" , 
"distance_traveled" : 59.6992
} ], 
"139" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "20:58:00" , 
"departure_time" : "20:59:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "21:14:21" , 
"departure_time" : "21:14:29" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 154,
"arrival_time" : "21:20:08" , 
"departure_time" : "21:20:51" , 
"distance_traveled" : 10.8928
}, 
{ 
"stop_id" : 19,
"arrival_time" : "21:22:43" , 
"departure_time" : "21:23:17" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "21:25:34" , 
"departure_time" : "21:26:36" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "21:29:02" , 
"departure_time" : "21:30:11" , 
"distance_traveled" : 12.7936
}, 
{ 
"stop_id" : 152,
"arrival_time" : "21:32:09" , 
"departure_time" : "21:32:55" , 
"distance_traveled" : 13.4574
}, 
{ 
"stop_id" : 153,
"arrival_time" : "21:34:46" , 
"departure_time" : "21:35:31" , 
"distance_traveled" : 14.3178
}, 
{ 
"stop_id" : 150,
"arrival_time" : "21:36:45" , 
"departure_time" : "21:37:15" , 
"distance_traveled" : 15.2754
}, 
{ 
"stop_id" : 95,
"arrival_time" : "21:38:30" , 
"departure_time" : "21:39:01" , 
"distance_traveled" : 15.7869
}, 
{ 
"stop_id" : 89,
"arrival_time" : "21:40:31" , 
"departure_time" : "21:41:14" , 
"distance_traveled" : 16.4201
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "21:43:43" , 
"departure_time" : "21:44:13" , 
"distance_traveled" : 17.3093
}, 
{ 
"stop_id" : 72,
"arrival_time" : "21:50:30" , 
"departure_time" : "21:51:18" , 
"distance_traveled" : 20.215
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "21:53:48" , 
"departure_time" : "21:54:16" , 
"distance_traveled" : 22.0023
}, 
{ 
"stop_id" : 98,
"arrival_time" : "21:56:28" , 
"departure_time" : "21:57:19" , 
"distance_traveled" : 23.1447
}, 
{ 
"stop_id" : 69,
"arrival_time" : "22:00:51" , 
"departure_time" : "22:01:57" , 
"distance_traveled" : 25.0648
}, 
{ 
"stop_id" : 147,
"arrival_time" : "22:05:06" , 
"departure_time" : "22:06:25" , 
"distance_traveled" : 27.3792
}, 
{ 
"stop_id" : 20,
"arrival_time" : "22:12:19" , 
"departure_time" : "22:13:49" , 
"distance_traveled" : 31.4866
}, 
{ 
"stop_id" : 96,
"arrival_time" : "22:16:30" , 
"departure_time" : "22:17:02" , 
"distance_traveled" : 33.3206
}, 
{ 
"stop_id" : 34,
"arrival_time" : "22:21:32" , 
"departure_time" : "22:22:50" , 
"distance_traveled" : 36.0578
}, 
{ 
"stop_id" : 35,
"arrival_time" : "22:29:18" , 
"departure_time" : "22:29:21" , 
"distance_traveled" : 40.2659
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "22:35:03" , 
"departure_time" : "22:36:27" , 
"distance_traveled" : 45.2136
}, 
{ 
"stop_id" : 67,
"arrival_time" : "22:42:24" , 
"departure_time" : "22:42:41" , 
"distance_traveled" : 47.628
}, 
{ 
"stop_id" : 101,
"arrival_time" : "22:47:17" , 
"departure_time" : "22:47:35" , 
"distance_traveled" : 50.1
}, 
{ 
"stop_id" : 93,
"arrival_time" : "22:52:18" , 
"departure_time" : "22:52:31" , 
"distance_traveled" : 52.3152
}, 
{ 
"stop_id" : 54,
"arrival_time" : "23:07:13" , 
"departure_time" : "23:07:13" , 
"distance_traveled" : 59.6992
} ], 
"140" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "20:58:00" , 
"departure_time" : "20:59:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "21:15:21" , 
"departure_time" : "21:16:42" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 154,
"arrival_time" : "21:21:21" , 
"departure_time" : "21:22:29" , 
"distance_traveled" : 10.8928
}, 
{ 
"stop_id" : 19,
"arrival_time" : "21:23:08" , 
"departure_time" : "21:24:34" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "21:26:26" , 
"departure_time" : "21:27:33" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "21:29:07" , 
"departure_time" : "21:30:18" , 
"distance_traveled" : 12.7936
}, 
{ 
"stop_id" : 152,
"arrival_time" : "21:32:11" , 
"departure_time" : "21:33:05" , 
"distance_traveled" : 13.4574
}, 
{ 
"stop_id" : 153,
"arrival_time" : "21:34:54" , 
"departure_time" : "21:35:36" , 
"distance_traveled" : 14.3178
}, 
{ 
"stop_id" : 150,
"arrival_time" : "21:36:42" , 
"departure_time" : "21:38:11" , 
"distance_traveled" : 15.2754
}, 
{ 
"stop_id" : 95,
"arrival_time" : "21:39:29" , 
"departure_time" : "21:39:32" , 
"distance_traveled" : 15.7869
}, 
{ 
"stop_id" : 89,
"arrival_time" : "21:40:03" , 
"departure_time" : "21:40:49" , 
"distance_traveled" : 16.4201
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "21:43:46" , 
"departure_time" : "21:45:03" , 
"distance_traveled" : 17.3093
}, 
{ 
"stop_id" : 72,
"arrival_time" : "21:51:17" , 
"departure_time" : "21:51:18" , 
"distance_traveled" : 20.215
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "21:53:01" , 
"departure_time" : "21:53:10" , 
"distance_traveled" : 22.0023
}, 
{ 
"stop_id" : 98,
"arrival_time" : "21:56:09" , 
"departure_time" : "21:57:39" , 
"distance_traveled" : 23.1447
}, 
{ 
"stop_id" : 69,
"arrival_time" : "22:01:30" , 
"departure_time" : "22:01:50" , 
"distance_traveled" : 25.0648
}, 
{ 
"stop_id" : 147,
"arrival_time" : "22:04:20" , 
"departure_time" : "22:05:57" , 
"distance_traveled" : 27.3792
}, 
{ 
"stop_id" : 20,
"arrival_time" : "22:12:37" , 
"departure_time" : "22:13:26" , 
"distance_traveled" : 31.4866
}, 
{ 
"stop_id" : 96,
"arrival_time" : "22:15:49" , 
"departure_time" : "22:16:06" , 
"distance_traveled" : 33.3206
}, 
{ 
"stop_id" : 34,
"arrival_time" : "22:21:17" , 
"departure_time" : "22:21:43" , 
"distance_traveled" : 36.0578
}, 
{ 
"stop_id" : 35,
"arrival_time" : "22:28:26" , 
"departure_time" : "22:28:27" , 
"distance_traveled" : 40.2659
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "22:35:01" , 
"departure_time" : "22:35:40" , 
"distance_traveled" : 45.2136
}, 
{ 
"stop_id" : 67,
"arrival_time" : "22:41:39" , 
"departure_time" : "22:42:32" , 
"distance_traveled" : 47.628
}, 
{ 
"stop_id" : 101,
"arrival_time" : "22:47:53" , 
"departure_time" : "22:48:06" , 
"distance_traveled" : 50.1
}, 
{ 
"stop_id" : 93,
"arrival_time" : "22:52:13" , 
"departure_time" : "22:53:37" , 
"distance_traveled" : 52.3152
}, 
{ 
"stop_id" : 54,
"arrival_time" : "23:08:24" , 
"departure_time" : "23:08:24" , 
"distance_traveled" : 59.6992
} ], 
"141" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "15:55:00" , 
"departure_time" : "15:57:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:11:45" , 
"departure_time" : "16:12:07" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 19,
"arrival_time" : "16:18:22" , 
"departure_time" : "16:19:59" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "16:21:37" , 
"departure_time" : "16:22:45" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "16:24:08" , 
"departure_time" : "16:25:32" , 
"distance_traveled" : 12.7936
}, 
{ 
"stop_id" : 152,
"arrival_time" : "16:28:24" , 
"departure_time" : "16:29:47" , 
"distance_traveled" : 13.4574
}, 
{ 
"stop_id" : 153,
"arrival_time" : "16:30:23" , 
"departure_time" : "16:30:42" , 
"distance_traveled" : 14.3178
}, 
{ 
"stop_id" : 150,
"arrival_time" : "16:32:19" , 
"departure_time" : "16:33:32" , 
"distance_traveled" : 15.2754
}, 
{ 
"stop_id" : 89,
"arrival_time" : "16:35:13" , 
"departure_time" : "16:36:20" , 
"distance_traveled" : 16.4201
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "16:38:07" , 
"departure_time" : "16:39:32" , 
"distance_traveled" : 17.3093
}, 
{ 
"stop_id" : 72,
"arrival_time" : "16:45:25" , 
"departure_time" : "16:46:10" , 
"distance_traveled" : 20.215
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "16:47:45" , 
"departure_time" : "16:49:14" , 
"distance_traveled" : 22.0023
}, 
{ 
"stop_id" : 98,
"arrival_time" : "16:51:29" , 
"departure_time" : "16:52:03" , 
"distance_traveled" : 23.1447
}, 
{ 
"stop_id" : 69,
"arrival_time" : "16:55:34" , 
"departure_time" : "16:55:51" , 
"distance_traveled" : 25.0648
}, 
{ 
"stop_id" : 147,
"arrival_time" : "16:59:17" , 
"departure_time" : "16:59:59" , 
"distance_traveled" : 27.3792
}, 
{ 
"stop_id" : 20,
"arrival_time" : "17:06:42" , 
"departure_time" : "17:07:05" , 
"distance_traveled" : 31.4866
}, 
{ 
"stop_id" : 96,
"arrival_time" : "17:09:23" , 
"departure_time" : "17:10:23" , 
"distance_traveled" : 33.3206
}, 
{ 
"stop_id" : 34,
"arrival_time" : "17:15:00" , 
"departure_time" : "17:15:58" , 
"distance_traveled" : 36.0578
}, 
{ 
"stop_id" : 35,
"arrival_time" : "17:21:58" , 
"departure_time" : "17:23:02" , 
"distance_traveled" : 40.2659
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "17:29:04" , 
"departure_time" : "17:30:06" , 
"distance_traveled" : 45.2136
}, 
{ 
"stop_id" : 67,
"arrival_time" : "17:34:02" , 
"departure_time" : "17:34:02" , 
"distance_traveled" : 47.628
} ], 
"142" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:10:00" , 
"departure_time" : "17:12:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:27:12" , 
"departure_time" : "17:28:31" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 19,
"arrival_time" : "17:34:19" , 
"departure_time" : "17:35:52" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "17:36:33" , 
"departure_time" : "17:36:40" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "17:38:07" , 
"departure_time" : "17:39:46" , 
"distance_traveled" : 12.7936
}, 
{ 
"stop_id" : 152,
"arrival_time" : "17:43:39" , 
"departure_time" : "17:44:30" , 
"distance_traveled" : 13.4574
}, 
{ 
"stop_id" : 153,
"arrival_time" : "17:44:51" , 
"departure_time" : "17:45:06" , 
"distance_traveled" : 14.3178
}, 
{ 
"stop_id" : 150,
"arrival_time" : "17:47:15" , 
"departure_time" : "17:47:34" , 
"distance_traveled" : 15.2754
}, 
{ 
"stop_id" : 89,
"arrival_time" : "17:49:19" , 
"departure_time" : "17:49:40" , 
"distance_traveled" : 16.4201
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "17:52:21" , 
"departure_time" : "17:52:23" , 
"distance_traveled" : 17.3093
}, 
{ 
"stop_id" : 72,
"arrival_time" : "17:59:02" , 
"departure_time" : "17:59:10" , 
"distance_traveled" : 20.215
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "18:02:08" , 
"departure_time" : "18:02:24" , 
"distance_traveled" : 22.0023
}, 
{ 
"stop_id" : 98,
"arrival_time" : "18:05:16" , 
"departure_time" : "18:06:15" , 
"distance_traveled" : 23.1447
}, 
{ 
"stop_id" : 69,
"arrival_time" : "18:09:59" , 
"departure_time" : "18:10:25" , 
"distance_traveled" : 25.0648
}, 
{ 
"stop_id" : 147,
"arrival_time" : "18:13:26" , 
"departure_time" : "18:14:12" , 
"distance_traveled" : 27.3792
}, 
{ 
"stop_id" : 20,
"arrival_time" : "18:20:46" , 
"departure_time" : "18:21:47" , 
"distance_traveled" : 31.4866
}, 
{ 
"stop_id" : 96,
"arrival_time" : "18:25:01" , 
"departure_time" : "18:26:38" , 
"distance_traveled" : 33.3206
}, 
{ 
"stop_id" : 34,
"arrival_time" : "18:30:37" , 
"departure_time" : "18:31:13" , 
"distance_traveled" : 36.0578
}, 
{ 
"stop_id" : 35,
"arrival_time" : "18:36:36" , 
"departure_time" : "18:36:47" , 
"distance_traveled" : 40.2659
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "18:43:11" , 
"departure_time" : "18:43:57" , 
"distance_traveled" : 45.2136
}, 
{ 
"stop_id" : 67,
"arrival_time" : "18:48:46" , 
"departure_time" : "18:48:46" , 
"distance_traveled" : 47.628
} ], 
"143" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:00:00" , 
"departure_time" : "18:01:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:17:11" , 
"departure_time" : "18:18:30" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 19,
"arrival_time" : "18:24:19" , 
"departure_time" : "18:25:12" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "18:25:53" , 
"departure_time" : "18:27:23" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "18:29:30" , 
"departure_time" : "18:31:00" , 
"distance_traveled" : 12.7936
}, 
{ 
"stop_id" : 152,
"arrival_time" : "18:33:30" , 
"departure_time" : "18:34:05" , 
"distance_traveled" : 13.4574
}, 
{ 
"stop_id" : 153,
"arrival_time" : "18:34:35" , 
"departure_time" : "18:35:10" , 
"distance_traveled" : 14.3178
}, 
{ 
"stop_id" : 150,
"arrival_time" : "18:37:35" , 
"departure_time" : "18:38:42" , 
"distance_traveled" : 15.2754
}, 
{ 
"stop_id" : 89,
"arrival_time" : "18:40:07" , 
"departure_time" : "18:41:39" , 
"distance_traveled" : 16.4201
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "18:43:32" , 
"departure_time" : "18:44:22" , 
"distance_traveled" : 17.3093
}, 
{ 
"stop_id" : 72,
"arrival_time" : "18:49:50" , 
"departure_time" : "18:50:26" , 
"distance_traveled" : 20.215
}, 
{ 
"stop_id" : 39635,
"arrival_time" : "18:52:36" , 
"departure_time" : "18:53:32" , 
"distance_traveled" : 22.0023
}, 
{ 
"stop_id" : 98,
"arrival_time" : "18:55:56" , 
"departure_time" : "18:57:19" , 
"distance_traveled" : 23.1447
}, 
{ 
"stop_id" : 69,
"arrival_time" : "19:01:23" , 
"departure_time" : "19:02:39" , 
"distance_traveled" : 25.0648
}, 
{ 
"stop_id" : 147,
"arrival_time" : "19:05:16" , 
"departure_time" : "19:05:24" , 
"distance_traveled" : 27.3792
}, 
{ 
"stop_id" : 20,
"arrival_time" : "19:11:08" , 
"departure_time" : "19:12:29" , 
"distance_traveled" : 31.4866
}, 
{ 
"stop_id" : 96,
"arrival_time" : "19:15:21" , 
"departure_time" : "19:16:18" , 
"distance_traveled" : 33.3206
}, 
{ 
"stop_id" : 34,
"arrival_time" : "19:19:57" , 
"departure_time" : "19:20:43" , 
"distance_traveled" : 36.0578
}, 
{ 
"stop_id" : 35,
"arrival_time" : "19:26:46" , 
"departure_time" : "19:28:00" , 
"distance_traveled" : 40.2659
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "19:34:14" , 
"departure_time" : "19:34:30" , 
"distance_traveled" : 45.2136
}, 
{ 
"stop_id" : 67,
"arrival_time" : "19:38:16" , 
"departure_time" : "19:38:16" , 
"distance_traveled" : 47.628
} ], 
"144" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "06:33:00" , 
"departure_time" : "06:34:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "06:37:13" , 
"departure_time" : "06:38:47" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "06:39:34" , 
"departure_time" : "06:40:50" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "06:41:16" , 
"departure_time" : "06:41:59" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "06:42:43" , 
"departure_time" : "06:43:36" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "06:45:53" , 
"departure_time" : "06:46:23" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "06:49:30" , 
"departure_time" : "06:50:44" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "06:53:14" , 
"departure_time" : "06:54:08" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "06:54:54" , 
"departure_time" : "06:55:36" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "06:56:42" , 
"departure_time" : "06:57:24" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:03:42" , 
"departure_time" : "07:04:13" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:14:31" , 
"departure_time" : "07:14:49" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:28:18" , 
"departure_time" : "07:28:18" , 
"distance_traveled" : 19.9627
} ], 
"145" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "06:33:00" , 
"departure_time" : "06:34:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "06:37:14" , 
"departure_time" : "06:37:33" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "06:38:19" , 
"departure_time" : "06:39:13" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "06:40:54" , 
"departure_time" : "06:42:06" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "06:43:12" , 
"departure_time" : "06:44:44" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "06:46:32" , 
"departure_time" : "06:47:47" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "06:50:15" , 
"departure_time" : "06:51:32" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "06:53:17" , 
"departure_time" : "06:53:47" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "06:54:30" , 
"departure_time" : "06:54:33" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "06:56:03" , 
"departure_time" : "06:56:28" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:03:25" , 
"departure_time" : "07:04:08" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:14:43" , 
"departure_time" : "07:15:48" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:29:05" , 
"departure_time" : "07:29:05" , 
"distance_traveled" : 19.9627
} ], 
"146" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "07:33:00" , 
"departure_time" : "07:34:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "07:36:01" , 
"departure_time" : "07:37:10" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "07:39:09" , 
"departure_time" : "07:39:53" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "07:40:44" , 
"departure_time" : "07:42:08" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "07:43:24" , 
"departure_time" : "07:44:36" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "07:46:12" , 
"departure_time" : "07:46:30" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "07:49:18" , 
"departure_time" : "07:50:36" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "07:53:18" , 
"departure_time" : "07:54:29" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "07:55:11" , 
"departure_time" : "07:56:51" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "07:57:40" , 
"departure_time" : "07:58:54" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:04:14" , 
"departure_time" : "08:05:06" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:14:52" , 
"departure_time" : "08:15:41" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:28:49" , 
"departure_time" : "08:28:49" , 
"distance_traveled" : 19.9627
} ], 
"147" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "07:33:00" , 
"departure_time" : "07:35:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "07:37:16" , 
"departure_time" : "07:38:06" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "07:38:50" , 
"departure_time" : "07:38:58" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "07:40:08" , 
"departure_time" : "07:40:42" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "07:42:34" , 
"departure_time" : "07:43:34" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "07:46:00" , 
"departure_time" : "07:46:18" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "07:49:18" , 
"departure_time" : "07:49:37" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "07:52:19" , 
"departure_time" : "07:52:43" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "07:54:24" , 
"departure_time" : "07:55:29" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "07:57:05" , 
"departure_time" : "07:57:37" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:03:32" , 
"departure_time" : "08:04:54" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:15:22" , 
"departure_time" : "08:15:42" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:28:20" , 
"departure_time" : "08:28:20" , 
"distance_traveled" : 19.9627
} ], 
"148" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "08:33:00" , 
"departure_time" : "08:33:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "08:36:22" , 
"departure_time" : "08:37:16" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "08:38:54" , 
"departure_time" : "08:39:55" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "08:41:01" , 
"departure_time" : "08:41:32" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "08:42:31" , 
"departure_time" : "08:42:36" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "08:45:05" , 
"departure_time" : "08:45:36" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "08:49:31" , 
"departure_time" : "08:49:38" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "08:52:07" , 
"departure_time" : "08:53:07" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "08:55:00" , 
"departure_time" : "08:56:22" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "08:57:22" , 
"departure_time" : "08:57:50" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:03:28" , 
"departure_time" : "09:04:20" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:14:52" , 
"departure_time" : "09:15:16" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:28:24" , 
"departure_time" : "09:28:24" , 
"distance_traveled" : 19.9627
} ], 
"149" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "08:33:00" , 
"departure_time" : "08:34:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "08:36:36" , 
"departure_time" : "08:37:59" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "08:39:23" , 
"departure_time" : "08:39:40" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "08:40:17" , 
"departure_time" : "08:40:48" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "08:42:31" , 
"departure_time" : "08:42:36" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "08:45:05" , 
"departure_time" : "08:45:58" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "08:49:53" , 
"departure_time" : "08:50:05" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "08:52:12" , 
"departure_time" : "08:53:51" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "08:55:39" , 
"departure_time" : "08:55:59" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "08:56:20" , 
"departure_time" : "08:57:30" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:04:10" , 
"departure_time" : "09:04:51" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:14:41" , 
"departure_time" : "09:15:11" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:28:30" , 
"departure_time" : "09:28:30" , 
"distance_traveled" : 19.9627
} ], 
"150" :  [ 
{ 
"stop_id" : 14,
"arrival_time" : "17:00:00" , 
"departure_time" : "17:02:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 50,
"arrival_time" : "17:03:40" , 
"departure_time" : "17:04:56" , 
"distance_traveled" : 0.6028
}, 
{ 
"stop_id" : 19,
"arrival_time" : "17:06:16" , 
"departure_time" : "17:07:31" , 
"distance_traveled" : 1.2019
}, 
{ 
"stop_id" : 154,
"arrival_time" : "17:08:15" , 
"departure_time" : "17:09:20" , 
"distance_traveled" : 1.9008
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:14:05" , 
"departure_time" : "17:15:30" , 
"distance_traveled" : 5.0152
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:33:25" , 
"departure_time" : "17:33:25" , 
"distance_traveled" : 12.8134
} ], 
"151" :  [ 
{ 
"stop_id" : 14,
"arrival_time" : "17:00:00" , 
"departure_time" : "17:01:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 50,
"arrival_time" : "17:02:13" , 
"departure_time" : "17:03:38" , 
"distance_traveled" : 0.6028
}, 
{ 
"stop_id" : 19,
"arrival_time" : "17:06:25" , 
"departure_time" : "17:07:38" , 
"distance_traveled" : 1.2019
}, 
{ 
"stop_id" : 154,
"arrival_time" : "17:08:13" , 
"departure_time" : "17:09:37" , 
"distance_traveled" : 1.9008
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:14:24" , 
"departure_time" : "17:15:14" , 
"distance_traveled" : 5.0152
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:32:50" , 
"departure_time" : "17:32:50" , 
"distance_traveled" : 12.8134
} ], 
"152" :  [ 
{ 
"stop_id" : 14,
"arrival_time" : "24:01:00" , 
"departure_time" : "24:03:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 50,
"arrival_time" : "24:04:23" , 
"departure_time" : "24:05:31" , 
"distance_traveled" : 0.6028
}, 
{ 
"stop_id" : 19,
"arrival_time" : "24:07:08" , 
"departure_time" : "24:08:11" , 
"distance_traveled" : 1.2019
}, 
{ 
"stop_id" : 154,
"arrival_time" : "24:09:03" , 
"departure_time" : "24:09:28" , 
"distance_traveled" : 1.9008
}, 
{ 
"stop_id" : 106,
"arrival_time" : "24:14:25" , 
"departure_time" : "24:15:40" , 
"distance_traveled" : 5.0152
}, 
{ 
"stop_id" : 63,
"arrival_time" : "24:39:15" , 
"departure_time" : "24:39:15" , 
"distance_traveled" : 12.8134
} ], 
"153" :  [ 
{ 
"stop_id" : 14,
"arrival_time" : "24:01:00" , 
"departure_time" : "24:03:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 50,
"arrival_time" : "24:03:51" , 
"departure_time" : "24:04:28" , 
"distance_traveled" : 0.6028
}, 
{ 
"stop_id" : 19,
"arrival_time" : "24:06:37" , 
"departure_time" : "24:08:04" , 
"distance_traveled" : 1.2019
}, 
{ 
"stop_id" : 154,
"arrival_time" : "24:09:27" , 
"departure_time" : "24:09:52" , 
"distance_traveled" : 1.9006
}, 
{ 
"stop_id" : 106,
"arrival_time" : "24:14:25" , 
"departure_time" : "24:15:10" , 
"distance_traveled" : 5.0153
}, 
{ 
"stop_id" : 63,
"arrival_time" : "24:38:45" , 
"departure_time" : "24:38:45" , 
"distance_traveled" : 12.8134
} ], 
"154" :  [ 
{ 
"stop_id" : 14,
"arrival_time" : "24:01:00" , 
"departure_time" : "24:03:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 50,
"arrival_time" : "24:04:23" , 
"departure_time" : "24:04:25" , 
"distance_traveled" : 0.6028
}, 
{ 
"stop_id" : 19,
"arrival_time" : "24:06:02" , 
"departure_time" : "24:07:28" , 
"distance_traveled" : 1.2019
}, 
{ 
"stop_id" : 154,
"arrival_time" : "24:09:26" , 
"departure_time" : "24:09:34" , 
"distance_traveled" : 1.9008
}, 
{ 
"stop_id" : 106,
"arrival_time" : "24:19:08" , 
"departure_time" : "24:20:46" , 
"distance_traveled" : 5.0152
}, 
{ 
"stop_id" : 63,
"arrival_time" : "24:39:38" , 
"departure_time" : "24:39:38" , 
"distance_traveled" : 12.8134
} ], 
"155" :  [ 
{ 
"stop_id" : 14,
"arrival_time" : "17:00:00" , 
"departure_time" : "17:02:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 50,
"arrival_time" : "17:03:07" , 
"departure_time" : "17:04:15" , 
"distance_traveled" : 0.6028
}, 
{ 
"stop_id" : 19,
"arrival_time" : "17:06:08" , 
"departure_time" : "17:07:29" , 
"distance_traveled" : 1.2019
}, 
{ 
"stop_id" : 154,
"arrival_time" : "17:08:21" , 
"departure_time" : "17:08:27" , 
"distance_traveled" : 1.9008
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:13:06" , 
"departure_time" : "17:19:07" , 
"distance_traveled" : 5.0152
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:38:01" , 
"departure_time" : "17:38:01" , 
"distance_traveled" : 12.8134
} ], 
"156" :  [ 
{ 
"stop_id" : 14,
"arrival_time" : "17:00:00" , 
"departure_time" : "17:00:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 50,
"arrival_time" : "17:02:38" , 
"departure_time" : "17:03:12" , 
"distance_traveled" : 0.6028
}, 
{ 
"stop_id" : 19,
"arrival_time" : "17:05:34" , 
"departure_time" : "17:06:34" , 
"distance_traveled" : 1.2019
}, 
{ 
"stop_id" : 154,
"arrival_time" : "17:08:00" , 
"departure_time" : "17:09:23" , 
"distance_traveled" : 1.9008
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:14:23" , 
"departure_time" : "17:21:18" , 
"distance_traveled" : 5.0152
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:38:55" , 
"departure_time" : "17:38:55" , 
"distance_traveled" : 12.8134
} ], 
"157" :  [ 
{ 
"stop_id" : 14,
"arrival_time" : "07:00:00" , 
"departure_time" : "07:01:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 50,
"arrival_time" : "07:02:14" , 
"departure_time" : "07:02:53" , 
"distance_traveled" : 0.6028
}, 
{ 
"stop_id" : 19,
"arrival_time" : "07:05:39" , 
"departure_time" : "07:05:58" , 
"distance_traveled" : 1.2019
}, 
{ 
"stop_id" : 154,
"arrival_time" : "07:07:19" , 
"departure_time" : "07:07:33" , 
"distance_traveled" : 1.9008
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:13:14" , 
"departure_time" : "07:19:33" , 
"distance_traveled" : 5.0152
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:38:19" , 
"departure_time" : "07:38:19" , 
"distance_traveled" : 12.8134
} ], 
"158" :  [ 
{ 
"stop_id" : 14,
"arrival_time" : "07:00:00" , 
"departure_time" : "07:01:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 50,
"arrival_time" : "07:03:29" , 
"departure_time" : "07:03:44" , 
"distance_traveled" : 0.6028
}, 
{ 
"stop_id" : 19,
"arrival_time" : "07:05:15" , 
"departure_time" : "07:05:37" , 
"distance_traveled" : 1.2019
}, 
{ 
"stop_id" : 154,
"arrival_time" : "07:07:22" , 
"departure_time" : "07:07:36" , 
"distance_traveled" : 1.9008
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:13:14" , 
"departure_time" : "07:20:04" , 
"distance_traveled" : 5.0152
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:38:50" , 
"departure_time" : "07:38:50" , 
"distance_traveled" : 12.8134
} ], 
"159" :  [ 
{ 
"stop_id" : 14,
"arrival_time" : "09:00:00" , 
"departure_time" : "09:02:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 50,
"arrival_time" : "09:03:24" , 
"departure_time" : "09:04:45" , 
"distance_traveled" : 0.6028
}, 
{ 
"stop_id" : 19,
"arrival_time" : "09:06:21" , 
"departure_time" : "09:07:04" , 
"distance_traveled" : 1.2019
}, 
{ 
"stop_id" : 154,
"arrival_time" : "09:07:43" , 
"departure_time" : "09:08:03" , 
"distance_traveled" : 1.9008
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:13:20" , 
"departure_time" : "09:19:43" , 
"distance_traveled" : 5.0152
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:38:23" , 
"departure_time" : "09:38:23" , 
"distance_traveled" : 12.8134
} ], 
"160" :  [ 
{ 
"stop_id" : 14,
"arrival_time" : "09:00:00" , 
"departure_time" : "09:00:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 50,
"arrival_time" : "09:02:15" , 
"departure_time" : "09:03:35" , 
"distance_traveled" : 0.6028
}, 
{ 
"stop_id" : 19,
"arrival_time" : "09:06:20" , 
"departure_time" : "09:07:09" , 
"distance_traveled" : 1.2019
}, 
{ 
"stop_id" : 154,
"arrival_time" : "09:07:49" , 
"departure_time" : "09:09:06" , 
"distance_traveled" : 1.9008
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:14:17" , 
"departure_time" : "09:21:11" , 
"distance_traveled" : 5.0152
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:38:54" , 
"departure_time" : "09:38:54" , 
"distance_traveled" : 12.8134
} ], 
"161" :  [ 
{ 
"stop_id" : 14,
"arrival_time" : "11:00:00" , 
"departure_time" : "11:00:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 50,
"arrival_time" : "11:02:03" , 
"departure_time" : "11:02:56" , 
"distance_traveled" : 0.6028
}, 
{ 
"stop_id" : 19,
"arrival_time" : "11:05:53" , 
"departure_time" : "11:06:15" , 
"distance_traveled" : 1.2019
}, 
{ 
"stop_id" : 154,
"arrival_time" : "11:07:22" , 
"departure_time" : "11:07:31" , 
"distance_traveled" : 1.9008
}, 
{ 
"stop_id" : 106,
"arrival_time" : "11:13:09" , 
"departure_time" : "11:20:35" , 
"distance_traveled" : 5.0152
}, 
{ 
"stop_id" : 63,
"arrival_time" : "11:39:26" , 
"departure_time" : "11:39:26" , 
"distance_traveled" : 12.8134
} ], 
"162" :  [ 
{ 
"stop_id" : 14,
"arrival_time" : "11:00:00" , 
"departure_time" : "11:02:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 50,
"arrival_time" : "11:02:40" , 
"departure_time" : "11:04:09" , 
"distance_traveled" : 0.6028
}, 
{ 
"stop_id" : 19,
"arrival_time" : "11:06:29" , 
"departure_time" : "11:07:40" , 
"distance_traveled" : 1.2019
}, 
{ 
"stop_id" : 154,
"arrival_time" : "11:08:11" , 
"departure_time" : "11:09:33" , 
"distance_traveled" : 1.9008
}, 
{ 
"stop_id" : 106,
"arrival_time" : "11:14:22" , 
"departure_time" : "11:21:40" , 
"distance_traveled" : 5.0152
}, 
{ 
"stop_id" : 63,
"arrival_time" : "11:39:18" , 
"departure_time" : "11:39:18" , 
"distance_traveled" : 12.8134
} ], 
"163" :  [ 
{ 
"stop_id" : 14,
"arrival_time" : "13:00:00" , 
"departure_time" : "13:02:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 50,
"arrival_time" : "13:03:08" , 
"departure_time" : "13:03:10" , 
"distance_traveled" : 0.6028
}, 
{ 
"stop_id" : 19,
"arrival_time" : "13:05:02" , 
"departure_time" : "13:05:13" , 
"distance_traveled" : 1.2019
}, 
{ 
"stop_id" : 154,
"arrival_time" : "13:07:11" , 
"departure_time" : "13:07:25" , 
"distance_traveled" : 1.9008
}, 
{ 
"stop_id" : 106,
"arrival_time" : "13:13:14" , 
"departure_time" : "13:19:34" , 
"distance_traveled" : 5.0152
}, 
{ 
"stop_id" : 63,
"arrival_time" : "13:38:20" , 
"departure_time" : "13:38:20" , 
"distance_traveled" : 12.8134
} ], 
"164" :  [ 
{ 
"stop_id" : 14,
"arrival_time" : "13:00:00" , 
"departure_time" : "13:01:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 50,
"arrival_time" : "13:02:57" , 
"departure_time" : "13:04:20" , 
"distance_traveled" : 0.6028
}, 
{ 
"stop_id" : 19,
"arrival_time" : "13:06:23" , 
"departure_time" : "13:07:03" , 
"distance_traveled" : 1.2019
}, 
{ 
"stop_id" : 154,
"arrival_time" : "13:07:40" , 
"departure_time" : "13:08:24" , 
"distance_traveled" : 1.9008
}, 
{ 
"stop_id" : 106,
"arrival_time" : "13:13:44" , 
"departure_time" : "13:20:15" , 
"distance_traveled" : 5.0152
}, 
{ 
"stop_id" : 63,
"arrival_time" : "13:38:31" , 
"departure_time" : "13:38:31" , 
"distance_traveled" : 12.8134
} ], 
"165" :  [ 
{ 
"stop_id" : 14,
"arrival_time" : "15:00:00" , 
"departure_time" : "15:01:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 50,
"arrival_time" : "15:02:58" , 
"departure_time" : "15:03:42" , 
"distance_traveled" : 0.6028
}, 
{ 
"stop_id" : 19,
"arrival_time" : "15:05:44" , 
"departure_time" : "15:06:24" , 
"distance_traveled" : 1.2019
}, 
{ 
"stop_id" : 154,
"arrival_time" : "15:07:40" , 
"departure_time" : "15:08:43" , 
"distance_traveled" : 1.9008
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:14:03" , 
"departure_time" : "15:20:24" , 
"distance_traveled" : 5.0152
}, 
{ 
"stop_id" : 63,
"arrival_time" : "15:38:21" , 
"departure_time" : "15:38:21" , 
"distance_traveled" : 12.8134
} ], 
"166" :  [ 
{ 
"stop_id" : 14,
"arrival_time" : "15:00:00" , 
"departure_time" : "15:00:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 50,
"arrival_time" : "15:02:29" , 
"departure_time" : "15:03:00" , 
"distance_traveled" : 0.6028
}, 
{ 
"stop_id" : 19,
"arrival_time" : "15:05:31" , 
"departure_time" : "15:07:10" , 
"distance_traveled" : 1.2019
}, 
{ 
"stop_id" : 154,
"arrival_time" : "15:08:39" , 
"departure_time" : "15:09:20" , 
"distance_traveled" : 1.9008
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:13:41" , 
"departure_time" : "15:20:46" , 
"distance_traveled" : 5.0152
}, 
{ 
"stop_id" : 63,
"arrival_time" : "15:39:05" , 
"departure_time" : "15:39:05" , 
"distance_traveled" : 12.8134
} ], 
"167" :  [ 
{ 
"stop_id" : 14,
"arrival_time" : "19:00:00" , 
"departure_time" : "19:01:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 50,
"arrival_time" : "19:02:48" , 
"departure_time" : "19:03:50" , 
"distance_traveled" : 0.6028
}, 
{ 
"stop_id" : 19,
"arrival_time" : "19:06:02" , 
"departure_time" : "19:07:17" , 
"distance_traveled" : 1.2019
}, 
{ 
"stop_id" : 154,
"arrival_time" : "19:08:15" , 
"departure_time" : "19:08:52" , 
"distance_traveled" : 1.9008
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:13:37" , 
"departure_time" : "19:20:40" , 
"distance_traveled" : 5.0152
}, 
{ 
"stop_id" : 63,
"arrival_time" : "19:39:03" , 
"departure_time" : "19:39:03" , 
"distance_traveled" : 12.8134
} ], 
"168" :  [ 
{ 
"stop_id" : 14,
"arrival_time" : "19:00:00" , 
"departure_time" : "19:02:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 50,
"arrival_time" : "19:03:26" , 
"departure_time" : "19:04:14" , 
"distance_traveled" : 0.6028
}, 
{ 
"stop_id" : 19,
"arrival_time" : "19:05:48" , 
"departure_time" : "19:06:23" , 
"distance_traveled" : 1.2019
}, 
{ 
"stop_id" : 154,
"arrival_time" : "19:07:35" , 
"departure_time" : "19:08:44" , 
"distance_traveled" : 1.9008
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:14:09" , 
"departure_time" : "19:21:16" , 
"distance_traveled" : 5.0152
}, 
{ 
"stop_id" : 63,
"arrival_time" : "19:39:07" , 
"departure_time" : "19:39:07" , 
"distance_traveled" : 12.8134
} ], 
"169" :  [ 
{ 
"stop_id" : 14,
"arrival_time" : "21:00:00" , 
"departure_time" : "21:02:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 50,
"arrival_time" : "21:03:39" , 
"departure_time" : "21:05:18" , 
"distance_traveled" : 0.6028
}, 
{ 
"stop_id" : 19,
"arrival_time" : "21:06:39" , 
"departure_time" : "21:07:02" , 
"distance_traveled" : 1.2019
}, 
{ 
"stop_id" : 154,
"arrival_time" : "21:07:23" , 
"departure_time" : "21:07:28" , 
"distance_traveled" : 1.9008
}, 
{ 
"stop_id" : 106,
"arrival_time" : "21:13:05" , 
"departure_time" : "21:19:30" , 
"distance_traveled" : 5.0152
}, 
{ 
"stop_id" : 63,
"arrival_time" : "21:38:25" , 
"departure_time" : "21:38:25" , 
"distance_traveled" : 12.8134
} ], 
"170" :  [ 
{ 
"stop_id" : 14,
"arrival_time" : "21:00:00" , 
"departure_time" : "21:02:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 50,
"arrival_time" : "21:03:36" , 
"departure_time" : "21:03:50" , 
"distance_traveled" : 0.6028
}, 
{ 
"stop_id" : 19,
"arrival_time" : "21:05:14" , 
"departure_time" : "21:06:44" , 
"distance_traveled" : 1.2019
}, 
{ 
"stop_id" : 154,
"arrival_time" : "21:08:30" , 
"departure_time" : "21:09:12" , 
"distance_traveled" : 1.9008
}, 
{ 
"stop_id" : 106,
"arrival_time" : "21:13:42" , 
"departure_time" : "21:20:05" , 
"distance_traveled" : 5.0152
}, 
{ 
"stop_id" : 63,
"arrival_time" : "21:38:23" , 
"departure_time" : "21:38:23" , 
"distance_traveled" : 12.8134
} ], 
"171" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "18:39:00" , 
"departure_time" : "18:40:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "18:44:17" , 
"departure_time" : "18:44:21" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 150,
"arrival_time" : "18:46:04" , 
"departure_time" : "18:47:21" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 152,
"arrival_time" : "18:50:17" , 
"departure_time" : "18:51:46" , 
"distance_traveled" : 3.7697
}, 
{ 
"stop_id" : 14,
"arrival_time" : "18:53:29" , 
"departure_time" : "18:55:00" , 
"distance_traveled" : 4.4335
}, 
{ 
"stop_id" : 50,
"arrival_time" : "18:56:31" , 
"departure_time" : "18:57:20" , 
"distance_traveled" : 5.0364
}, 
{ 
"stop_id" : 19,
"arrival_time" : "18:58:49" , 
"departure_time" : "18:59:31" , 
"distance_traveled" : 5.6354
}, 
{ 
"stop_id" : 154,
"arrival_time" : "19:00:42" , 
"departure_time" : "19:01:05" , 
"distance_traveled" : 6.3343
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:06:23" , 
"departure_time" : "19:06:26" , 
"distance_traveled" : 9.4487
}, 
{ 
"stop_id" : 63,
"arrival_time" : "19:22:03" , 
"departure_time" : "19:22:03" , 
"distance_traveled" : 17.247
} ], 
"172" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "18:39:00" , 
"departure_time" : "18:39:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "18:43:05" , 
"departure_time" : "18:43:45" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 150,
"arrival_time" : "18:46:40" , 
"departure_time" : "18:47:38" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 152,
"arrival_time" : "18:49:58" , 
"departure_time" : "18:50:09" , 
"distance_traveled" : 3.7697
}, 
{ 
"stop_id" : 14,
"arrival_time" : "18:52:11" , 
"departure_time" : "18:52:54" , 
"distance_traveled" : 4.4335
}, 
{ 
"stop_id" : 50,
"arrival_time" : "18:55:43" , 
"departure_time" : "18:57:14" , 
"distance_traveled" : 5.0364
}, 
{ 
"stop_id" : 19,
"arrival_time" : "18:59:31" , 
"departure_time" : "18:59:44" , 
"distance_traveled" : 5.6354
}, 
{ 
"stop_id" : 154,
"arrival_time" : "19:00:13" , 
"departure_time" : "19:01:50" , 
"distance_traveled" : 6.3343
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:07:37" , 
"departure_time" : "19:08:33" , 
"distance_traveled" : 9.4487
}, 
{ 
"stop_id" : 63,
"arrival_time" : "19:22:56" , 
"departure_time" : "19:22:56" , 
"distance_traveled" : 17.247
} ], 
"173" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "07:17:00" , 
"departure_time" : "07:19:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "07:21:25" , 
"departure_time" : "07:22:55" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "07:24:30" , 
"departure_time" : "07:25:57" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "07:26:27" , 
"departure_time" : "07:26:52" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "07:28:25" , 
"departure_time" : "07:29:23" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "07:31:58" , 
"departure_time" : "07:33:11" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "07:36:13" , 
"departure_time" : "07:37:38" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "07:40:25" , 
"departure_time" : "07:40:53" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "07:43:28" , 
"departure_time" : "07:44:56" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "07:47:28" , 
"departure_time" : "07:47:38" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:19:10" , 
"departure_time" : "08:19:10" , 
"distance_traveled" : 19.9426
} ], 
"174" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "07:17:00" , 
"departure_time" : "07:17:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "07:20:24" , 
"departure_time" : "07:21:32" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "07:24:08" , 
"departure_time" : "07:25:34" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "07:26:26" , 
"departure_time" : "07:26:41" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "07:28:15" , 
"departure_time" : "07:28:19" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "07:31:04" , 
"departure_time" : "07:32:10" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "07:36:06" , 
"departure_time" : "07:36:24" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "07:39:18" , 
"departure_time" : "07:39:31" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "07:43:13" , 
"departure_time" : "07:44:35" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "07:47:22" , 
"departure_time" : "07:47:25" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:19:03" , 
"departure_time" : "08:19:03" , 
"distance_traveled" : 19.9426
} ], 
"175" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "16:08:00" , 
"departure_time" : "16:08:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "16:11:19" , 
"departure_time" : "16:12:18" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 150,
"arrival_time" : "16:14:59" , 
"departure_time" : "16:16:35" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "16:17:36" , 
"departure_time" : "16:19:01" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "16:20:25" , 
"departure_time" : "16:21:41" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "16:23:16" , 
"departure_time" : "16:23:23" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "16:25:07" , 
"departure_time" : "16:26:46" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "16:29:39" , 
"departure_time" : "16:31:14" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "16:31:35" , 
"departure_time" : "16:31:47" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:36:12" , 
"departure_time" : "16:37:19" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 63,
"arrival_time" : "16:53:07" , 
"departure_time" : "16:53:07" , 
"distance_traveled" : 17.3292
} ], 
"176" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "16:08:00" , 
"departure_time" : "16:10:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "16:12:40" , 
"departure_time" : "16:14:13" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 150,
"arrival_time" : "16:15:33" , 
"departure_time" : "16:17:03" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "16:17:30" , 
"departure_time" : "16:18:24" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "16:19:54" , 
"departure_time" : "16:21:20" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "16:23:26" , 
"departure_time" : "16:23:57" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "16:25:31" , 
"departure_time" : "16:27:03" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "16:29:32" , 
"departure_time" : "16:30:55" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "16:31:23" , 
"departure_time" : "16:31:57" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:36:34" , 
"departure_time" : "16:38:06" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 63,
"arrival_time" : "16:53:32" , 
"departure_time" : "16:53:32" , 
"distance_traveled" : 17.3292
} ], 
"177" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "17:07:00" , 
"departure_time" : "17:08:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "17:10:05" , 
"departure_time" : "17:10:27" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 150,
"arrival_time" : "17:13:22" , 
"departure_time" : "17:13:49" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "17:15:27" , 
"departure_time" : "17:16:48" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "17:19:21" , 
"departure_time" : "17:19:43" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "17:21:22" , 
"departure_time" : "17:22:16" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "17:24:54" , 
"departure_time" : "17:26:13" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "17:28:19" , 
"departure_time" : "17:29:43" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "17:30:24" , 
"departure_time" : "17:30:51" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:37:27" , 
"departure_time" : "17:37:59" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 105,
"arrival_time" : "17:57:32" , 
"departure_time" : "17:57:32" , 
"distance_traveled" : 19.9629
} ], 
"178" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "17:07:00" , 
"departure_time" : "17:08:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "17:10:47" , 
"departure_time" : "17:11:00" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 150,
"arrival_time" : "17:13:13" , 
"departure_time" : "17:14:16" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "17:16:03" , 
"departure_time" : "17:16:21" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "17:18:18" , 
"departure_time" : "17:19:58" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "17:22:40" , 
"departure_time" : "17:22:42" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "17:24:02" , 
"departure_time" : "17:24:39" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "17:27:37" , 
"departure_time" : "17:29:16" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "17:30:39" , 
"departure_time" : "17:32:11" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:38:32" , 
"departure_time" : "17:39:34" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 105,
"arrival_time" : "17:58:02" , 
"departure_time" : "17:58:02" , 
"distance_traveled" : 19.9629
} ], 
"179" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "22:25:00" , 
"departure_time" : "22:26:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "22:29:20" , 
"departure_time" : "22:29:41" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 150,
"arrival_time" : "22:31:21" , 
"departure_time" : "22:31:35" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "22:34:14" , 
"departure_time" : "22:35:25" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "22:37:11" , 
"departure_time" : "22:37:25" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "22:40:14" , 
"departure_time" : "22:40:32" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "22:43:18" , 
"departure_time" : "22:43:55" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "22:46:37" , 
"departure_time" : "22:47:12" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 106,
"arrival_time" : "22:53:35" , 
"departure_time" : "22:54:29" , 
"distance_traveled" : 9.5208
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:03:54" , 
"departure_time" : "23:05:33" , 
"distance_traveled" : 14.9545
}, 
{ 
"stop_id" : 105,
"arrival_time" : "23:17:39" , 
"departure_time" : "23:17:39" , 
"distance_traveled" : 19.9426
} ], 
"180" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "22:25:00" , 
"departure_time" : "22:28:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "22:30:22" , 
"departure_time" : "22:31:23" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 150,
"arrival_time" : "22:32:01" , 
"departure_time" : "22:33:18" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "22:35:17" , 
"departure_time" : "22:36:16" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "22:36:59" , 
"departure_time" : "22:37:41" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "22:40:42" , 
"departure_time" : "22:41:47" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "22:44:05" , 
"departure_time" : "22:44:57" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "22:46:52" , 
"departure_time" : "22:47:23" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 106,
"arrival_time" : "22:53:31" , 
"departure_time" : "22:54:25" , 
"distance_traveled" : 9.5208
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:03:54" , 
"departure_time" : "23:05:20" , 
"distance_traveled" : 14.9545
}, 
{ 
"stop_id" : 105,
"arrival_time" : "23:17:26" , 
"departure_time" : "23:17:26" , 
"distance_traveled" : 19.9426
} ], 
"181" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "23:13:00" , 
"departure_time" : "23:15:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "23:17:39" , 
"departure_time" : "23:17:59" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 150,
"arrival_time" : "23:19:20" , 
"departure_time" : "23:19:43" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "23:22:23" , 
"departure_time" : "23:22:38" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "23:24:15" , 
"departure_time" : "23:25:38" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "23:29:23" , 
"departure_time" : "23:29:32" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "23:30:09" , 
"departure_time" : "23:30:28" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "23:33:19" , 
"departure_time" : "23:33:21" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 106,
"arrival_time" : "23:40:02" , 
"departure_time" : "23:41:10" , 
"distance_traveled" : 9.5208
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:52:08" , 
"departure_time" : "23:52:14" , 
"distance_traveled" : 14.9545
}, 
{ 
"stop_id" : 105,
"arrival_time" : "24:05:06" , 
"departure_time" : "24:05:06" , 
"distance_traveled" : 19.9426
} ], 
"182" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "23:13:00" , 
"departure_time" : "23:13:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "23:17:24" , 
"departure_time" : "23:17:41" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 150,
"arrival_time" : "23:19:17" , 
"departure_time" : "23:19:20" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "23:22:03" , 
"departure_time" : "23:23:36" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "23:25:33" , 
"departure_time" : "23:25:35" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "23:28:02" , 
"departure_time" : "23:29:41" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "23:31:39" , 
"departure_time" : "23:32:28" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "23:33:49" , 
"departure_time" : "23:34:37" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 106,
"arrival_time" : "23:40:48" , 
"departure_time" : "23:41:05" , 
"distance_traveled" : 9.5208
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:51:17" , 
"departure_time" : "23:52:09" , 
"distance_traveled" : 14.9545
}, 
{ 
"stop_id" : 105,
"arrival_time" : "24:05:52" , 
"departure_time" : "24:05:52" , 
"distance_traveled" : 19.9426
} ], 
"183" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "06:30:00" , 
"departure_time" : "06:31:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "06:33:55" , 
"departure_time" : "06:34:36" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "06:36:41" , 
"departure_time" : "06:37:32" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "06:38:51" , 
"departure_time" : "06:39:42" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "06:40:51" , 
"departure_time" : "06:42:19" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "06:44:28" , 
"departure_time" : "06:45:02" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "06:46:34" , 
"departure_time" : "06:46:46" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "06:49:12" , 
"departure_time" : "06:50:29" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "06:53:17" , 
"departure_time" : "06:54:39" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "06:56:22" , 
"departure_time" : "06:57:37" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:02:15" , 
"departure_time" : "07:03:15" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:18:00" , 
"departure_time" : "07:18:00" , 
"distance_traveled" : 17.3292
} ], 
"184" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "06:30:00" , 
"departure_time" : "06:31:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "06:33:33" , 
"departure_time" : "06:35:11" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "06:37:38" , 
"departure_time" : "06:38:24" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "06:38:46" , 
"departure_time" : "06:39:34" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "06:40:48" , 
"departure_time" : "06:42:18" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "06:44:30" , 
"departure_time" : "06:44:50" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "06:46:20" , 
"departure_time" : "06:46:25" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "06:49:05" , 
"departure_time" : "06:50:32" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "06:53:27" , 
"departure_time" : "06:54:06" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "06:55:39" , 
"departure_time" : "06:56:20" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:01:41" , 
"departure_time" : "07:03:00" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:18:19" , 
"departure_time" : "07:18:19" , 
"distance_traveled" : 17.3292
} ], 
"185" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "07:10:00" , 
"departure_time" : "07:12:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "07:14:07" , 
"departure_time" : "07:15:41" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "07:17:34" , 
"departure_time" : "07:18:06" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "07:18:32" , 
"departure_time" : "07:19:57" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "07:22:25" , 
"departure_time" : "07:23:38" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "07:25:13" , 
"departure_time" : "07:25:43" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "07:27:30" , 
"departure_time" : "07:28:28" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "07:30:58" , 
"departure_time" : "07:32:25" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "07:34:27" , 
"departure_time" : "07:35:25" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "07:36:58" , 
"departure_time" : "07:37:55" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:44:57" , 
"departure_time" : "07:46:14" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:01:17" , 
"departure_time" : "08:01:17" , 
"distance_traveled" : 17.3292
} ], 
"186" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "07:10:00" , 
"departure_time" : "07:12:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "07:14:15" , 
"departure_time" : "07:15:19" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "07:17:04" , 
"departure_time" : "07:18:22" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "07:19:18" , 
"departure_time" : "07:20:26" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "07:22:08" , 
"departure_time" : "07:23:09" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "07:25:01" , 
"departure_time" : "07:26:15" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "07:28:14" , 
"departure_time" : "07:29:24" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "07:31:10" , 
"departure_time" : "07:32:17" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "07:34:07" , 
"departure_time" : "07:35:42" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "07:37:35" , 
"departure_time" : "07:37:52" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:44:17" , 
"departure_time" : "07:45:46" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:01:29" , 
"departure_time" : "08:01:29" , 
"distance_traveled" : 17.3292
} ], 
"187" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "07:50:00" , 
"departure_time" : "07:52:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "07:54:15" , 
"departure_time" : "07:55:52" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "07:56:37" , 
"departure_time" : "07:57:21" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "07:57:44" , 
"departure_time" : "07:59:21" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "08:01:37" , 
"departure_time" : "08:02:45" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "08:04:08" , 
"departure_time" : "08:05:25" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "08:07:17" , 
"departure_time" : "08:08:51" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "08:10:34" , 
"departure_time" : "08:12:05" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "08:13:31" , 
"departure_time" : "08:14:32" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "08:15:01" , 
"departure_time" : "08:15:41" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:21:40" , 
"departure_time" : "08:23:12" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:38:32" , 
"departure_time" : "08:38:32" , 
"distance_traveled" : 17.3292
} ], 
"188" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "07:50:00" , 
"departure_time" : "07:52:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "07:54:19" , 
"departure_time" : "07:55:55" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "07:56:36" , 
"departure_time" : "07:57:38" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "07:58:02" , 
"departure_time" : "07:59:40" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "08:01:38" , 
"departure_time" : "08:02:58" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "08:04:20" , 
"departure_time" : "08:04:42" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "08:06:22" , 
"departure_time" : "08:07:32" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "08:10:10" , 
"departure_time" : "08:11:45" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "08:13:35" , 
"departure_time" : "08:13:41" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "08:14:06" , 
"departure_time" : "08:14:26" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:21:20" , 
"departure_time" : "08:22:36" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:38:16" , 
"departure_time" : "08:38:16" , 
"distance_traveled" : 17.3292
} ], 
"189" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "06:45:00" , 
"departure_time" : "06:46:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "06:48:02" , 
"departure_time" : "06:49:10" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "06:51:08" , 
"departure_time" : "06:51:48" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "06:52:40" , 
"departure_time" : "06:54:10" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "06:56:30" , 
"departure_time" : "06:57:49" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "06:59:19" , 
"departure_time" : "07:00:46" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "07:03:27" , 
"departure_time" : "07:03:31" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "07:05:04" , 
"departure_time" : "07:05:56" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "07:08:52" , 
"departure_time" : "07:09:15" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "07:10:23" , 
"departure_time" : "07:11:32" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:18:09" , 
"departure_time" : "07:18:56" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:40:47" , 
"departure_time" : "07:40:47" , 
"distance_traveled" : 19.9629
} ], 
"190" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "06:45:00" , 
"departure_time" : "06:46:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "06:48:38" , 
"departure_time" : "06:49:20" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "06:50:42" , 
"departure_time" : "06:50:53" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "06:52:11" , 
"departure_time" : "06:52:25" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "06:55:14" , 
"departure_time" : "06:55:28" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "06:58:14" , 
"departure_time" : "06:59:25" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "07:03:11" , 
"departure_time" : "07:03:26" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "07:05:15" , 
"departure_time" : "07:05:59" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "07:08:44" , 
"departure_time" : "07:10:17" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "07:11:33" , 
"departure_time" : "07:12:27" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:17:54" , 
"departure_time" : "07:19:13" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:41:19" , 
"departure_time" : "07:41:19" , 
"distance_traveled" : 19.9629
} ], 
"191" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "08:03:00" , 
"departure_time" : "08:05:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "08:08:12" , 
"departure_time" : "08:09:39" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "08:10:27" , 
"departure_time" : "08:11:38" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "08:13:11" , 
"departure_time" : "08:14:23" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "08:15:12" , 
"departure_time" : "08:15:28" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "08:17:16" , 
"departure_time" : "08:18:45" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "08:22:29" , 
"departure_time" : "08:23:45" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "08:25:16" , 
"departure_time" : "08:25:32" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "08:27:16" , 
"departure_time" : "08:28:28" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "08:31:12" , 
"departure_time" : "08:32:31" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:38:19" , 
"departure_time" : "08:38:27" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:59:08" , 
"departure_time" : "08:59:08" , 
"distance_traveled" : 19.9629
} ], 
"192" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "08:03:00" , 
"departure_time" : "08:04:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "08:07:54" , 
"departure_time" : "08:08:40" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "08:09:46" , 
"departure_time" : "08:10:03" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "08:12:17" , 
"departure_time" : "08:12:26" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "08:14:09" , 
"departure_time" : "08:14:13" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "08:17:04" , 
"departure_time" : "08:18:29" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "08:22:25" , 
"departure_time" : "08:23:20" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "08:24:55" , 
"departure_time" : "08:25:56" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "08:28:01" , 
"departure_time" : "08:29:03" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "08:31:02" , 
"departure_time" : "08:31:11" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:37:09" , 
"departure_time" : "08:38:22" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:00:13" , 
"departure_time" : "09:00:13" , 
"distance_traveled" : 19.9629
} ], 
"193" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "05:10:00" , 
"departure_time" : "05:11:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "05:14:10" , 
"departure_time" : "05:14:57" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "05:16:47" , 
"departure_time" : "05:17:58" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "05:19:11" , 
"departure_time" : "05:19:18" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "05:21:07" , 
"departure_time" : "05:22:30" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "05:25:23" , 
"departure_time" : "05:25:55" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "05:27:32" , 
"departure_time" : "05:28:34" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "05:31:02" , 
"departure_time" : "05:32:36" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "05:34:34" , 
"departure_time" : "05:35:23" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "05:35:49" , 
"departure_time" : "05:36:41" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "05:42:52" , 
"departure_time" : "05:43:05" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:51:13" , 
"departure_time" : "05:51:23" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:04:10" , 
"departure_time" : "06:04:10" , 
"distance_traveled" : 19.9627
} ], 
"194" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "05:10:00" , 
"departure_time" : "05:10:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "05:14:10" , 
"departure_time" : "05:15:04" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "05:16:54" , 
"departure_time" : "05:17:27" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "05:18:33" , 
"departure_time" : "05:18:37" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "05:21:04" , 
"departure_time" : "05:21:27" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "05:24:23" , 
"departure_time" : "05:24:50" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "05:27:27" , 
"departure_time" : "05:28:50" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "05:31:23" , 
"departure_time" : "05:33:02" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "05:34:39" , 
"departure_time" : "05:35:32" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "05:35:53" , 
"departure_time" : "05:37:00" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "05:43:07" , 
"departure_time" : "05:43:24" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:51:17" , 
"departure_time" : "05:52:39" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:05:22" , 
"departure_time" : "06:05:22" , 
"distance_traveled" : 19.9627
} ], 
"195" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "05:51:00" , 
"departure_time" : "05:53:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "05:55:48" , 
"departure_time" : "05:56:15" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "05:57:27" , 
"departure_time" : "05:58:01" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "05:59:34" , 
"departure_time" : "05:59:42" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "06:01:08" , 
"departure_time" : "06:02:23" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "06:05:15" , 
"departure_time" : "06:05:29" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "06:07:14" , 
"departure_time" : "06:07:51" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "06:10:37" , 
"departure_time" : "06:12:02" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "06:14:25" , 
"departure_time" : "06:15:32" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "06:16:07" , 
"departure_time" : "06:16:36" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:23:29" , 
"departure_time" : "06:24:32" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:34:03" , 
"departure_time" : "06:34:32" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:46:29" , 
"departure_time" : "06:46:29" , 
"distance_traveled" : 19.9627
} ], 
"196" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "05:51:00" , 
"departure_time" : "05:51:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "05:55:12" , 
"departure_time" : "05:55:26" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "05:57:14" , 
"departure_time" : "05:58:27" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "06:00:13" , 
"departure_time" : "06:00:17" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "06:01:04" , 
"departure_time" : "06:01:43" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "06:04:39" , 
"departure_time" : "06:04:46" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "06:07:07" , 
"departure_time" : "06:07:20" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "06:10:13" , 
"departure_time" : "06:10:44" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "06:13:31" , 
"departure_time" : "06:14:18" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "06:15:47" , 
"departure_time" : "06:16:54" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:24:07" , 
"departure_time" : "06:24:48" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:33:41" , 
"departure_time" : "06:34:47" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:47:06" , 
"departure_time" : "06:47:06" , 
"distance_traveled" : 19.9627
} ], 
"197" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "08:55:00" , 
"departure_time" : "08:57:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "08:59:00" , 
"departure_time" : "09:00:31" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "09:01:31" , 
"departure_time" : "09:02:44" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "09:04:13" , 
"departure_time" : "09:04:34" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "09:05:21" , 
"departure_time" : "09:05:36" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "09:08:15" , 
"departure_time" : "09:08:34" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "09:12:19" , 
"departure_time" : "09:13:53" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "09:16:34" , 
"departure_time" : "09:16:36" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "09:17:02" , 
"departure_time" : "09:17:56" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "09:19:54" , 
"departure_time" : "09:20:21" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:26:27" , 
"departure_time" : "09:27:47" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:39:20" , 
"departure_time" : "09:39:56" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:51:36" , 
"departure_time" : "09:51:36" , 
"distance_traveled" : 19.9627
} ], 
"198" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "08:55:00" , 
"departure_time" : "08:56:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "08:58:54" , 
"departure_time" : "08:59:17" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "09:00:23" , 
"departure_time" : "09:01:55" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "09:04:32" , 
"departure_time" : "09:05:43" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "09:06:11" , 
"departure_time" : "09:06:17" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "09:08:06" , 
"departure_time" : "09:09:24" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "09:13:18" , 
"departure_time" : "09:14:38" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "09:16:20" , 
"departure_time" : "09:16:50" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "09:17:30" , 
"departure_time" : "09:18:42" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "09:20:12" , 
"departure_time" : "09:21:32" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:27:20" , 
"departure_time" : "09:27:42" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:38:22" , 
"departure_time" : "09:38:52" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:51:30" , 
"departure_time" : "09:51:30" , 
"distance_traveled" : 19.9627
} ], 
"199" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "10:02:00" , 
"departure_time" : "10:02:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "10:06:20" , 
"departure_time" : "10:07:35" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "10:09:15" , 
"departure_time" : "10:09:16" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "10:10:01" , 
"departure_time" : "10:10:21" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "10:13:20" , 
"departure_time" : "10:13:26" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "10:16:06" , 
"departure_time" : "10:16:24" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "10:19:18" , 
"departure_time" : "10:20:03" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "10:22:45" , 
"departure_time" : "10:23:42" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "10:25:57" , 
"departure_time" : "10:27:27" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "10:28:30" , 
"departure_time" : "10:28:33" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "10:34:03" , 
"departure_time" : "10:34:46" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:44:43" , 
"departure_time" : "10:45:47" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:57:04" , 
"departure_time" : "10:57:04" , 
"distance_traveled" : 19.9627
} ], 
"200" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "10:02:00" , 
"departure_time" : "10:03:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "10:06:42" , 
"departure_time" : "10:08:18" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "10:09:36" , 
"departure_time" : "10:09:44" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "10:10:08" , 
"departure_time" : "10:10:57" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "10:13:49" , 
"departure_time" : "10:14:09" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "10:16:20" , 
"departure_time" : "10:16:28" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "10:19:08" , 
"departure_time" : "10:19:17" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "10:22:09" , 
"departure_time" : "10:23:16" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "10:26:07" , 
"departure_time" : "10:26:58" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "10:27:51" , 
"departure_time" : "10:29:20" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "10:35:29" , 
"departure_time" : "10:36:08" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:44:39" , 
"departure_time" : "10:44:42" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:56:03" , 
"departure_time" : "10:56:03" , 
"distance_traveled" : 19.9627
} ], 
"201" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "10:51:00" , 
"departure_time" : "10:52:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "10:53:59" , 
"departure_time" : "10:54:29" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "10:56:30" , 
"departure_time" : "10:56:43" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "10:58:13" , 
"departure_time" : "10:58:25" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "11:01:12" , 
"departure_time" : "11:02:34" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "11:05:22" , 
"departure_time" : "11:05:34" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "11:07:12" , 
"departure_time" : "11:07:30" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "11:10:18" , 
"departure_time" : "11:10:33" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "11:13:15" , 
"departure_time" : "11:13:48" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "11:15:33" , 
"departure_time" : "11:17:03" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "11:24:30" , 
"departure_time" : "11:24:42" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:34:12" , 
"departure_time" : "11:34:27" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "11:47:15" , 
"departure_time" : "11:47:15" , 
"distance_traveled" : 19.9627
} ], 
"202" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "10:51:00" , 
"departure_time" : "10:52:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "10:53:45" , 
"departure_time" : "10:54:47" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "10:57:02" , 
"departure_time" : "10:57:56" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "10:58:54" , 
"departure_time" : "10:59:53" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "11:01:59" , 
"departure_time" : "11:02:26" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "11:04:27" , 
"departure_time" : "11:05:10" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "11:07:43" , 
"departure_time" : "11:08:00" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "11:10:17" , 
"departure_time" : "11:10:59" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "11:13:42" , 
"departure_time" : "11:14:35" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "11:15:53" , 
"departure_time" : "11:17:11" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "11:24:18" , 
"departure_time" : "11:24:28" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:34:10" , 
"departure_time" : "11:35:34" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "11:48:24" , 
"departure_time" : "11:48:24" , 
"distance_traveled" : 19.9627
} ], 
"203" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "11:47:00" , 
"departure_time" : "11:48:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "11:51:03" , 
"departure_time" : "11:52:27" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "11:54:24" , 
"departure_time" : "11:54:31" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "11:55:07" , 
"departure_time" : "11:55:35" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "11:58:28" , 
"departure_time" : "11:59:02" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "12:01:34" , 
"departure_time" : "12:01:52" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "12:04:18" , 
"departure_time" : "12:04:19" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "12:07:01" , 
"departure_time" : "12:08:04" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "12:11:03" , 
"departure_time" : "12:12:13" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "12:13:10" , 
"departure_time" : "12:13:12" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "12:19:02" , 
"departure_time" : "12:19:57" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:31:55" , 
"departure_time" : "12:32:15" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "12:44:20" , 
"departure_time" : "12:44:20" , 
"distance_traveled" : 19.9627
} ], 
"204" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "11:47:00" , 
"departure_time" : "11:47:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "11:51:24" , 
"departure_time" : "11:53:01" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "11:54:37" , 
"departure_time" : "11:56:00" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "11:56:23" , 
"departure_time" : "11:57:14" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "11:58:51" , 
"departure_time" : "11:59:35" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "12:01:44" , 
"departure_time" : "12:02:31" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "12:04:47" , 
"departure_time" : "12:05:37" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "12:07:50" , 
"departure_time" : "12:08:59" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "12:11:09" , 
"departure_time" : "12:12:11" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "12:13:02" , 
"departure_time" : "12:13:47" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "12:19:45" , 
"departure_time" : "12:21:07" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:32:22" , 
"departure_time" : "12:33:50" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "12:45:28" , 
"departure_time" : "12:45:28" , 
"distance_traveled" : 19.9627
} ], 
"205" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "12:47:00" , 
"departure_time" : "12:49:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "12:51:41" , 
"departure_time" : "12:51:49" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "12:53:08" , 
"departure_time" : "12:54:07" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "12:55:59" , 
"departure_time" : "12:56:03" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "12:58:04" , 
"departure_time" : "12:58:48" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "13:01:44" , 
"departure_time" : "13:03:16" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "13:05:32" , 
"departure_time" : "13:06:06" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "13:07:34" , 
"departure_time" : "13:07:47" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "13:10:13" , 
"departure_time" : "13:11:12" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "13:12:59" , 
"departure_time" : "13:14:37" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "13:20:38" , 
"departure_time" : "13:21:10" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:29:32" , 
"departure_time" : "13:29:41" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "13:42:09" , 
"departure_time" : "13:42:09" , 
"distance_traveled" : 19.9627
} ], 
"206" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "12:47:00" , 
"departure_time" : "12:47:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "12:51:25" , 
"departure_time" : "12:52:01" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "12:53:36" , 
"departure_time" : "12:54:46" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "12:56:10" , 
"departure_time" : "12:56:44" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "12:58:34" , 
"departure_time" : "12:58:49" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "13:01:15" , 
"departure_time" : "13:01:21" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "13:04:06" , 
"departure_time" : "13:05:16" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "13:08:10" , 
"departure_time" : "13:08:59" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "13:10:49" , 
"departure_time" : "13:11:57" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "13:13:08" , 
"departure_time" : "13:14:38" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "13:20:30" , 
"departure_time" : "13:20:54" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:29:24" , 
"departure_time" : "13:29:25" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "13:42:01" , 
"departure_time" : "13:42:01" , 
"distance_traveled" : 19.9627
} ], 
"207" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "13:47:00" , 
"departure_time" : "13:47:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "13:51:56" , 
"departure_time" : "13:52:01" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "13:53:05" , 
"departure_time" : "13:53:13" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "13:55:08" , 
"departure_time" : "13:55:42" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "13:58:34" , 
"departure_time" : "13:58:58" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "14:01:24" , 
"departure_time" : "14:02:16" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "14:04:52" , 
"departure_time" : "14:06:14" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "14:08:22" , 
"departure_time" : "14:08:42" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "14:10:20" , 
"departure_time" : "14:10:59" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "14:12:39" , 
"departure_time" : "14:12:43" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "14:20:04" , 
"departure_time" : "14:21:22" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:36:18" , 
"departure_time" : "14:36:59" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "14:49:41" , 
"departure_time" : "14:49:41" , 
"distance_traveled" : 19.9627
} ], 
"208" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "13:47:00" , 
"departure_time" : "13:48:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "13:52:15" , 
"departure_time" : "13:52:26" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "13:53:11" , 
"departure_time" : "13:54:46" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "13:56:35" , 
"departure_time" : "13:56:47" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "13:58:12" , 
"departure_time" : "13:58:55" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "14:01:43" , 
"departure_time" : "14:02:10" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "14:04:27" , 
"departure_time" : "14:04:43" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "14:07:16" , 
"departure_time" : "14:08:06" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "14:10:50" , 
"departure_time" : "14:12:29" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "14:13:39" , 
"departure_time" : "14:13:59" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "14:20:20" , 
"departure_time" : "14:21:22" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:36:02" , 
"departure_time" : "14:37:40" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "14:50:38" , 
"departure_time" : "14:50:38" , 
"distance_traveled" : 19.9627
} ], 
"209" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "14:45:00" , 
"departure_time" : "14:47:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "14:49:24" , 
"departure_time" : "14:50:18" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "14:51:54" , 
"departure_time" : "14:53:01" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "14:54:07" , 
"departure_time" : "14:55:42" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "14:56:35" , 
"departure_time" : "14:58:08" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "14:59:33" , 
"departure_time" : "15:00:30" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "15:01:57" , 
"departure_time" : "15:02:52" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "15:04:55" , 
"departure_time" : "15:05:54" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "15:07:59" , 
"departure_time" : "15:08:52" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "15:09:53" , 
"departure_time" : "15:10:57" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:19:04" , 
"departure_time" : "15:19:31" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:35:27" , 
"departure_time" : "15:36:36" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "15:49:09" , 
"departure_time" : "15:49:09" , 
"distance_traveled" : 19.9627
} ], 
"210" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "14:45:00" , 
"departure_time" : "14:47:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "14:50:10" , 
"departure_time" : "14:51:46" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "14:52:36" , 
"departure_time" : "14:53:39" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "14:54:03" , 
"departure_time" : "14:54:56" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "14:55:53" , 
"departure_time" : "14:56:41" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "14:58:48" , 
"departure_time" : "14:59:17" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "15:01:29" , 
"departure_time" : "15:02:24" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "15:04:55" , 
"departure_time" : "15:06:26" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "15:08:31" , 
"departure_time" : "15:09:45" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "15:10:14" , 
"departure_time" : "15:10:42" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:18:28" , 
"departure_time" : "15:19:18" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:35:50" , 
"departure_time" : "15:35:54" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "15:48:04" , 
"departure_time" : "15:48:04" , 
"distance_traveled" : 19.9627
} ], 
"211" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "16:21:00" , 
"departure_time" : "16:21:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "16:24:50" , 
"departure_time" : "16:26:07" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "16:27:17" , 
"departure_time" : "16:28:44" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "16:29:27" , 
"departure_time" : "16:30:41" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "16:32:14" , 
"departure_time" : "16:33:01" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "16:34:47" , 
"departure_time" : "16:35:23" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "16:37:36" , 
"departure_time" : "16:37:57" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "16:40:21" , 
"departure_time" : "16:41:20" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "16:43:59" , 
"departure_time" : "16:44:54" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "16:45:55" , 
"departure_time" : "16:46:23" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:52:28" , 
"departure_time" : "16:53:02" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:03:34" , 
"departure_time" : "17:05:06" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "17:17:32" , 
"departure_time" : "17:17:32" , 
"distance_traveled" : 19.9627
} ], 
"212" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "16:21:00" , 
"departure_time" : "16:23:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "16:25:17" , 
"departure_time" : "16:25:21" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "16:26:04" , 
"departure_time" : "16:27:10" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "16:29:06" , 
"departure_time" : "16:29:17" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "16:31:11" , 
"departure_time" : "16:31:46" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "16:34:35" , 
"departure_time" : "16:36:11" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "16:38:36" , 
"departure_time" : "16:39:18" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "16:40:42" , 
"departure_time" : "16:42:05" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "16:44:23" , 
"departure_time" : "16:44:45" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "16:45:22" , 
"departure_time" : "16:46:51" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:53:29" , 
"departure_time" : "16:54:52" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:04:23" , 
"departure_time" : "17:04:47" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "17:16:24" , 
"departure_time" : "17:16:24" , 
"distance_traveled" : 19.9627
} ], 
"213" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "18:06:00" , 
"departure_time" : "18:07:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "18:10:24" , 
"departure_time" : "18:12:03" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "18:13:39" , 
"departure_time" : "18:14:37" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "18:14:58" , 
"departure_time" : "18:15:27" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "18:17:29" , 
"departure_time" : "18:17:44" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "18:20:15" , 
"departure_time" : "18:20:17" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "18:23:02" , 
"departure_time" : "18:24:24" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "18:27:22" , 
"departure_time" : "18:28:46" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "18:30:24" , 
"departure_time" : "18:30:59" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "18:31:35" , 
"departure_time" : "18:32:37" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:39:02" , 
"departure_time" : "18:40:22" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:50:20" , 
"departure_time" : "18:51:55" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "19:02:35" , 
"departure_time" : "19:02:35" , 
"distance_traveled" : 19.9627
} ], 
"214" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "18:06:00" , 
"departure_time" : "18:08:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "18:09:44" , 
"departure_time" : "18:11:04" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "18:13:20" , 
"departure_time" : "18:14:40" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "18:15:20" , 
"departure_time" : "18:16:18" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "18:17:58" , 
"departure_time" : "18:18:25" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "18:20:27" , 
"departure_time" : "18:22:06" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "18:24:39" , 
"departure_time" : "18:25:28" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "18:26:49" , 
"departure_time" : "18:27:00" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "18:29:11" , 
"departure_time" : "18:29:20" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "18:31:09" , 
"departure_time" : "18:31:50" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:38:41" , 
"departure_time" : "18:38:52" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:49:11" , 
"departure_time" : "18:50:09" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "19:01:58" , 
"departure_time" : "19:01:58" , 
"distance_traveled" : 19.9627
} ], 
"215" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "19:22:00" , 
"departure_time" : "19:24:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "19:26:35" , 
"departure_time" : "19:26:41" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "19:27:06" , 
"departure_time" : "19:28:19" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "19:30:13" , 
"departure_time" : "19:31:34" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "19:33:21" , 
"departure_time" : "19:34:32" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "19:36:11" , 
"departure_time" : "19:37:44" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "19:39:33" , 
"departure_time" : "19:40:32" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "19:41:59" , 
"departure_time" : "19:43:29" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "19:44:30" , 
"departure_time" : "19:45:33" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "19:46:03" , 
"departure_time" : "19:46:21" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:52:18" , 
"departure_time" : "19:52:47" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:03:29" , 
"departure_time" : "20:04:12" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "20:16:43" , 
"departure_time" : "20:16:43" , 
"distance_traveled" : 19.9627
} ], 
"216" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "19:22:00" , 
"departure_time" : "19:22:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "19:25:05" , 
"departure_time" : "19:25:57" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "19:27:52" , 
"departure_time" : "19:28:46" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "19:29:54" , 
"departure_time" : "19:30:17" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "19:32:23" , 
"departure_time" : "19:32:26" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "19:35:03" , 
"departure_time" : "19:35:09" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "19:38:06" , 
"departure_time" : "19:39:43" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "19:42:37" , 
"departure_time" : "19:42:53" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "19:43:16" , 
"departure_time" : "19:44:13" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "19:45:57" , 
"departure_time" : "19:46:10" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:52:13" , 
"departure_time" : "19:53:13" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:04:00" , 
"departure_time" : "20:04:55" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "20:16:55" , 
"departure_time" : "20:16:55" , 
"distance_traveled" : 19.9627
} ], 
"217" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "21:09:00" , 
"departure_time" : "21:11:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "21:15:28" , 
"departure_time" : "21:15:57" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "21:16:29" , 
"departure_time" : "21:17:27" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "21:19:58" , 
"departure_time" : "21:20:20" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "21:21:22" , 
"departure_time" : "21:21:32" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "21:24:10" , 
"departure_time" : "21:24:44" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "21:27:34" , 
"departure_time" : "21:27:36" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "21:30:02" , 
"departure_time" : "21:31:03" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "21:33:01" , 
"departure_time" : "21:33:44" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "21:34:43" , 
"departure_time" : "21:34:54" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "21:41:11" , 
"departure_time" : "21:42:16" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:51:05" , 
"departure_time" : "21:51:54" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "22:05:49" , 
"departure_time" : "22:05:49" , 
"distance_traveled" : 19.9627
} ], 
"218" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "21:09:00" , 
"departure_time" : "21:11:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "21:15:23" , 
"departure_time" : "21:15:52" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "21:16:29" , 
"departure_time" : "21:17:36" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "21:20:07" , 
"departure_time" : "21:21:08" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "21:22:01" , 
"departure_time" : "21:22:55" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "21:24:54" , 
"departure_time" : "21:25:51" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "21:27:57" , 
"departure_time" : "21:28:27" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "21:30:30" , 
"departure_time" : "21:30:31" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "21:32:01" , 
"departure_time" : "21:32:12" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "21:34:11" , 
"departure_time" : "21:35:17" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "21:42:06" , 
"departure_time" : "21:43:18" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:51:12" , 
"departure_time" : "21:51:35" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "22:05:23" , 
"departure_time" : "22:05:23" , 
"distance_traveled" : 19.9627
} ], 
"219" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "20:04:00" , 
"departure_time" : "20:05:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "20:09:36" , 
"departure_time" : "20:09:59" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "20:10:23" , 
"departure_time" : "20:12:02" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "20:13:39" , 
"departure_time" : "20:14:31" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "20:15:52" , 
"departure_time" : "20:16:38" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "20:18:46" , 
"departure_time" : "20:19:28" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "20:21:42" , 
"departure_time" : "20:23:16" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "20:25:34" , 
"departure_time" : "20:25:39" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "20:26:05" , 
"departure_time" : "20:26:47" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "20:28:42" , 
"departure_time" : "20:30:02" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "20:37:20" , 
"departure_time" : "20:38:07" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:47:47" , 
"departure_time" : "20:49:12" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "21:01:25" , 
"departure_time" : "21:01:25" , 
"distance_traveled" : 19.9631
} ], 
"220" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "20:04:00" , 
"departure_time" : "20:06:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "20:08:46" , 
"departure_time" : "20:09:37" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "20:10:51" , 
"departure_time" : "20:11:10" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "20:12:19" , 
"departure_time" : "20:13:58" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "20:16:39" , 
"departure_time" : "20:17:48" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "20:19:09" , 
"departure_time" : "20:19:30" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "20:21:21" , 
"departure_time" : "20:22:12" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "20:24:51" , 
"departure_time" : "20:25:58" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "20:27:07" , 
"departure_time" : "20:27:24" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "20:28:17" , 
"departure_time" : "20:29:15" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "20:36:58" , 
"departure_time" : "20:37:40" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:47:42" , 
"departure_time" : "20:49:08" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "21:01:26" , 
"departure_time" : "21:01:26" , 
"distance_traveled" : 19.9631
} ], 
"221" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "04:45:00" , 
"departure_time" : "04:48:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 150,
"arrival_time" : "04:51:39" , 
"departure_time" : "04:52:04" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "04:52:25" , 
"departure_time" : "04:52:36" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "04:55:11" , 
"departure_time" : "04:55:29" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "04:58:18" , 
"departure_time" : "04:59:58" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "05:02:40" , 
"departure_time" : "05:03:57" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "05:05:17" , 
"departure_time" : "05:06:31" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 106,
"arrival_time" : "05:12:14" , 
"departure_time" : "05:12:38" , 
"distance_traveled" : 9.5208
}, 
{ 
"stop_id" : 105,
"arrival_time" : "05:32:24" , 
"departure_time" : "05:32:24" , 
"distance_traveled" : 19.9428
} ], 
"222" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "04:45:00" , 
"departure_time" : "04:45:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 150,
"arrival_time" : "04:50:35" , 
"departure_time" : "04:51:44" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "04:53:09" , 
"departure_time" : "04:53:58" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "04:55:49" , 
"departure_time" : "04:57:20" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "04:59:31" , 
"departure_time" : "05:00:34" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "05:02:03" , 
"departure_time" : "05:03:14" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "05:05:11" , 
"departure_time" : "05:05:49" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 106,
"arrival_time" : "05:11:38" , 
"departure_time" : "05:12:44" , 
"distance_traveled" : 9.5208
}, 
{ 
"stop_id" : 105,
"arrival_time" : "05:33:06" , 
"departure_time" : "05:33:06" , 
"distance_traveled" : 19.9428
} ], 
"223" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "21:44:00" , 
"departure_time" : "21:45:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "21:47:39" , 
"departure_time" : "21:48:39" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "21:50:00" , 
"departure_time" : "21:50:53" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "21:51:53" , 
"departure_time" : "21:53:13" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "21:54:20" , 
"departure_time" : "21:55:50" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "21:57:30" , 
"departure_time" : "21:58:08" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "22:00:38" , 
"departure_time" : "22:01:09" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "22:02:31" , 
"departure_time" : "22:03:45" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "22:06:14" , 
"departure_time" : "22:06:45" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "22:07:31" , 
"departure_time" : "22:07:36" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "22:13:05" , 
"departure_time" : "22:19:34" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 63,
"arrival_time" : "22:38:29" , 
"departure_time" : "22:38:29" , 
"distance_traveled" : 17.3292
} ], 
"224" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "23:45:00" , 
"departure_time" : "23:46:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "23:49:19" , 
"departure_time" : "23:49:48" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "23:50:29" , 
"departure_time" : "23:51:14" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "23:52:45" , 
"departure_time" : "23:54:19" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "23:55:34" , 
"departure_time" : "23:56:10" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "23:57:36" , 
"departure_time" : "23:58:39" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "24:02:03" , 
"departure_time" : "24:02:21" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "24:03:18" , 
"departure_time" : "24:04:07" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "24:06:49" , 
"departure_time" : "24:07:43" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "24:08:54" , 
"departure_time" : "24:09:20" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "24:14:26" , 
"departure_time" : "24:14:56" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 63,
"arrival_time" : "24:36:30" , 
"departure_time" : "24:36:30" , 
"distance_traveled" : 17.3292
} ], 
"225" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "05:26:00" , 
"departure_time" : "05:27:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "05:30:04" , 
"departure_time" : "05:31:05" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "05:32:01" , 
"departure_time" : "05:33:41" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "05:34:40" , 
"departure_time" : "05:34:51" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "05:35:11" , 
"departure_time" : "05:35:27" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "05:38:16" , 
"departure_time" : "05:38:30" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "05:42:14" , 
"departure_time" : "05:42:22" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "05:45:08" , 
"departure_time" : "05:45:45" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "05:47:37" , 
"departure_time" : "05:47:41" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "05:49:04" , 
"departure_time" : "05:49:27" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "05:56:23" , 
"departure_time" : "05:56:34" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:07:11" , 
"departure_time" : "06:07:33" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:21:22" , 
"departure_time" : "06:21:22" , 
"distance_traveled" : 19.9627
} ], 
"226" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "06:33:00" , 
"departure_time" : "06:34:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "06:37:22" , 
"departure_time" : "06:37:49" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "06:38:27" , 
"departure_time" : "06:39:34" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "06:41:07" , 
"departure_time" : "06:42:27" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "06:43:20" , 
"departure_time" : "06:43:36" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "06:45:16" , 
"departure_time" : "06:46:36" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "06:50:20" , 
"departure_time" : "06:50:41" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "06:52:21" , 
"departure_time" : "06:53:12" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "06:54:51" , 
"departure_time" : "06:55:03" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "06:56:12" , 
"departure_time" : "06:56:22" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:03:10" , 
"departure_time" : "07:04:45" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:15:35" , 
"departure_time" : "07:16:05" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:28:30" , 
"departure_time" : "07:28:30" , 
"distance_traveled" : 19.9627
} ], 
"227" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "07:33:00" , 
"departure_time" : "07:33:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "07:36:10" , 
"departure_time" : "07:36:34" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "07:38:24" , 
"departure_time" : "07:39:44" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "07:41:20" , 
"departure_time" : "07:42:08" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "07:42:48" , 
"departure_time" : "07:43:45" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "07:45:57" , 
"departure_time" : "07:46:14" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "07:49:17" , 
"departure_time" : "07:50:03" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "07:52:46" , 
"departure_time" : "07:53:52" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "07:55:06" , 
"departure_time" : "07:55:36" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "07:56:30" , 
"departure_time" : "07:56:50" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:03:20" , 
"departure_time" : "08:04:08" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:14:48" , 
"departure_time" : "08:16:18" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:29:30" , 
"departure_time" : "08:29:30" , 
"distance_traveled" : 19.9627
} ], 
"228" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "09:33:00" , 
"departure_time" : "09:34:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "09:36:28" , 
"departure_time" : "09:37:50" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "09:39:22" , 
"departure_time" : "09:40:07" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "09:40:45" , 
"departure_time" : "09:42:04" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "09:43:19" , 
"departure_time" : "09:44:34" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "09:46:15" , 
"departure_time" : "09:47:20" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "09:50:05" , 
"departure_time" : "09:51:25" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "09:53:20" , 
"departure_time" : "09:54:06" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "09:54:46" , 
"departure_time" : "09:56:16" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "09:57:30" , 
"departure_time" : "09:57:50" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "10:03:20" , 
"departure_time" : "10:04:55" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:15:35" , 
"departure_time" : "10:16:30" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:28:55" , 
"departure_time" : "10:28:55" , 
"distance_traveled" : 19.9627
} ], 
"229" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "11:33:00" , 
"departure_time" : "11:34:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "11:36:50" , 
"departure_time" : "11:38:02" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "11:39:12" , 
"departure_time" : "11:39:13" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "11:40:01" , 
"departure_time" : "11:40:59" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "11:42:58" , 
"departure_time" : "11:44:00" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "11:46:02" , 
"departure_time" : "11:46:04" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "11:49:02" , 
"departure_time" : "11:49:33" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "11:52:31" , 
"departure_time" : "11:53:40" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "11:55:09" , 
"departure_time" : "11:56:47" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "11:57:38" , 
"departure_time" : "11:59:02" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "12:04:24" , 
"departure_time" : "12:04:59" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:14:35" , 
"departure_time" : "12:14:54" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "12:28:19" , 
"departure_time" : "12:28:19" , 
"distance_traveled" : 19.9627
} ], 
"230" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "13:33:00" , 
"departure_time" : "13:33:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "13:36:32" , 
"departure_time" : "13:36:58" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "13:38:26" , 
"departure_time" : "13:39:30" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "13:41:04" , 
"departure_time" : "13:41:27" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "13:42:23" , 
"departure_time" : "13:42:57" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "13:45:34" , 
"departure_time" : "13:46:33" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "13:49:59" , 
"departure_time" : "13:51:29" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "13:53:30" , 
"departure_time" : "13:55:03" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "13:55:33" , 
"departure_time" : "13:56:37" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "13:57:04" , 
"departure_time" : "13:57:16" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "14:03:12" , 
"departure_time" : "14:03:18" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:14:06" , 
"departure_time" : "14:14:41" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "14:28:35" , 
"departure_time" : "14:28:35" , 
"distance_traveled" : 19.9627
} ], 
"231" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "15:23:00" , 
"departure_time" : "15:24:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "15:26:49" , 
"departure_time" : "15:27:56" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "15:29:07" , 
"departure_time" : "15:29:32" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "15:30:25" , 
"departure_time" : "15:30:53" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "15:32:28" , 
"departure_time" : "15:32:58" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "15:35:30" , 
"departure_time" : "15:35:53" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "15:39:23" , 
"departure_time" : "15:40:19" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "15:42:56" , 
"departure_time" : "15:43:57" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "15:45:01" , 
"departure_time" : "15:45:03" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "15:46:02" , 
"departure_time" : "15:46:23" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:53:21" , 
"departure_time" : "15:54:37" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:05:16" , 
"departure_time" : "16:06:04" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "16:18:48" , 
"departure_time" : "16:18:48" , 
"distance_traveled" : 19.9627
} ], 
"232" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "16:23:00" , 
"departure_time" : "16:25:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "16:27:25" , 
"departure_time" : "16:29:02" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "16:29:37" , 
"departure_time" : "16:30:52" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "16:31:15" , 
"departure_time" : "16:31:22" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "16:32:07" , 
"departure_time" : "16:32:50" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "16:35:43" , 
"departure_time" : "16:35:46" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "16:39:03" , 
"departure_time" : "16:39:04" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "16:42:01" , 
"departure_time" : "16:42:28" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "16:44:27" , 
"departure_time" : "16:44:55" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "16:46:28" , 
"departure_time" : "16:46:46" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:53:18" , 
"departure_time" : "16:54:45" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:05:27" , 
"departure_time" : "17:05:50" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "17:18:23" , 
"departure_time" : "17:18:23" , 
"distance_traveled" : 19.9627
} ], 
"233" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "17:23:00" , 
"departure_time" : "17:24:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "17:27:31" , 
"departure_time" : "17:28:07" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "17:28:36" , 
"departure_time" : "17:28:44" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "17:30:08" , 
"departure_time" : "17:30:49" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "17:32:41" , 
"departure_time" : "17:33:06" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "17:35:25" , 
"departure_time" : "17:36:07" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "17:39:42" , 
"departure_time" : "17:40:45" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "17:43:03" , 
"departure_time" : "17:43:06" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "17:44:03" , 
"departure_time" : "17:45:04" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "17:47:01" , 
"departure_time" : "17:47:49" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:53:48" , 
"departure_time" : "17:54:48" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:05:00" , 
"departure_time" : "18:05:06" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:18:06" , 
"departure_time" : "18:18:06" , 
"distance_traveled" : 19.9627
} ], 
"234" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "19:33:00" , 
"departure_time" : "19:33:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "19:36:34" , 
"departure_time" : "19:37:52" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "19:39:18" , 
"departure_time" : "19:39:47" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "19:40:29" , 
"departure_time" : "19:41:11" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "19:42:42" , 
"departure_time" : "19:43:12" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "19:45:30" , 
"departure_time" : "19:45:58" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "19:49:28" , 
"departure_time" : "19:50:12" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "19:52:44" , 
"departure_time" : "19:53:53" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "19:55:09" , 
"departure_time" : "19:55:56" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "19:56:47" , 
"departure_time" : "19:56:57" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "20:03:10" , 
"departure_time" : "20:03:26" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:14:16" , 
"departure_time" : "20:15:15" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "20:28:59" , 
"departure_time" : "20:28:59" , 
"distance_traveled" : 19.9627
} ], 
"235" :  [ 
{ 
"stop_id" : 38081,
"arrival_time" : "08:33:00" , 
"departure_time" : "08:35:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 89,
"arrival_time" : "08:37:22" , 
"departure_time" : "08:38:58" , 
"distance_traveled" : 0.8892
}, 
{ 
"stop_id" : 95,
"arrival_time" : "08:39:36" , 
"departure_time" : "08:40:04" , 
"distance_traveled" : 1.5223
}, 
{ 
"stop_id" : 150,
"arrival_time" : "08:40:28" , 
"departure_time" : "08:40:32" , 
"distance_traveled" : 2.0339
}, 
{ 
"stop_id" : 153,
"arrival_time" : "08:42:04" , 
"departure_time" : "08:43:05" , 
"distance_traveled" : 2.9915
}, 
{ 
"stop_id" : 152,
"arrival_time" : "08:46:01" , 
"departure_time" : "08:46:47" , 
"distance_traveled" : 3.8519
}, 
{ 
"stop_id" : 14,
"arrival_time" : "08:49:46" , 
"departure_time" : "08:50:49" , 
"distance_traveled" : 4.5157
}, 
{ 
"stop_id" : 50,
"arrival_time" : "08:53:03" , 
"departure_time" : "08:54:30" , 
"distance_traveled" : 5.1186
}, 
{ 
"stop_id" : 19,
"arrival_time" : "08:55:27" , 
"departure_time" : "08:56:17" , 
"distance_traveled" : 5.7176
}, 
{ 
"stop_id" : 154,
"arrival_time" : "08:56:50" , 
"departure_time" : "08:57:25" , 
"distance_traveled" : 6.4165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:03:35" , 
"departure_time" : "09:03:43" , 
"distance_traveled" : 9.5309
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:14:08" , 
"departure_time" : "09:14:22" , 
"distance_traveled" : 14.9746
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:28:14" , 
"departure_time" : "09:28:14" , 
"distance_traveled" : 19.9627
} ], 
"236" :  [ 
{ 
"stop_id" : 14,
"arrival_time" : "24:01:00" , 
"departure_time" : "24:01:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 50,
"arrival_time" : "24:03:20" , 
"departure_time" : "24:03:22" , 
"distance_traveled" : 0.6028
}, 
{ 
"stop_id" : 19,
"arrival_time" : "24:06:02" , 
"departure_time" : "24:07:33" , 
"distance_traveled" : 1.2019
}, 
{ 
"stop_id" : 154,
"arrival_time" : "24:09:31" , 
"departure_time" : "24:09:50" , 
"distance_traveled" : 1.9008
}, 
{ 
"stop_id" : 106,
"arrival_time" : "24:14:19" , 
"departure_time" : "24:15:06" , 
"distance_traveled" : 5.0152
}, 
{ 
"stop_id" : 63,
"arrival_time" : "24:38:47" , 
"departure_time" : "24:38:47" , 
"distance_traveled" : 12.8134
} ], 
"237" :  [ 
{ 
"stop_id" : 14,
"arrival_time" : "17:00:00" , 
"departure_time" : "17:01:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 50,
"arrival_time" : "17:02:38" , 
"departure_time" : "17:03:45" , 
"distance_traveled" : 0.6028
}, 
{ 
"stop_id" : 19,
"arrival_time" : "17:06:07" , 
"departure_time" : "17:07:03" , 
"distance_traveled" : 1.2019
}, 
{ 
"stop_id" : 154,
"arrival_time" : "17:07:56" , 
"departure_time" : "17:08:27" , 
"distance_traveled" : 1.9008
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:13:31" , 
"departure_time" : "17:14:41" , 
"distance_traveled" : 5.0152
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:33:10" , 
"departure_time" : "17:33:10" , 
"distance_traveled" : 12.8134
} ], 
"238" :  [ 
{ 
"stop_id" : 14,
"arrival_time" : "17:00:00" , 
"departure_time" : "17:02:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 50,
"arrival_time" : "17:03:27" , 
"departure_time" : "17:04:04" , 
"distance_traveled" : 0.6028
}, 
{ 
"stop_id" : 19,
"arrival_time" : "17:05:37" , 
"departure_time" : "17:05:50" , 
"distance_traveled" : 1.2019
}, 
{ 
"stop_id" : 154,
"arrival_time" : "17:07:13" , 
"departure_time" : "17:08:32" , 
"distance_traveled" : 1.9008
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:14:19" , 
"departure_time" : "17:21:05" , 
"distance_traveled" : 5.0152
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:38:46" , 
"departure_time" : "17:38:46" , 
"distance_traveled" : 12.8134
} ], 
"239" :  [ 
{ 
"stop_id" : 14,
"arrival_time" : "21:00:00" , 
"departure_time" : "21:01:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 50,
"arrival_time" : "21:02:50" , 
"departure_time" : "21:04:03" , 
"distance_traveled" : 0.6028
}, 
{ 
"stop_id" : 19,
"arrival_time" : "21:06:13" , 
"departure_time" : "21:07:08" , 
"distance_traveled" : 1.2019
}, 
{ 
"stop_id" : 154,
"arrival_time" : "21:07:55" , 
"departure_time" : "21:08:39" , 
"distance_traveled" : 1.9008
}, 
{ 
"stop_id" : 106,
"arrival_time" : "21:13:44" , 
"departure_time" : "21:19:51" , 
"distance_traveled" : 5.0152
}, 
{ 
"stop_id" : 63,
"arrival_time" : "21:38:07" , 
"departure_time" : "21:38:07" , 
"distance_traveled" : 12.8134
} ], 
"240" :  [ 
{ 
"stop_id" : 14,
"arrival_time" : "07:00:00" , 
"departure_time" : "07:01:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 50,
"arrival_time" : "07:03:17" , 
"departure_time" : "07:03:37" , 
"distance_traveled" : 0.6028
}, 
{ 
"stop_id" : 19,
"arrival_time" : "07:05:20" , 
"departure_time" : "07:06:32" , 
"distance_traveled" : 1.2019
}, 
{ 
"stop_id" : 154,
"arrival_time" : "07:08:12" , 
"departure_time" : "07:09:33" , 
"distance_traveled" : 1.9008
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:14:21" , 
"departure_time" : "07:21:49" , 
"distance_traveled" : 5.0152
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:39:28" , 
"departure_time" : "07:39:28" , 
"distance_traveled" : 12.8134
} ], 
"241" :  [ 
{ 
"stop_id" : 14,
"arrival_time" : "09:00:00" , 
"departure_time" : "09:02:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 50,
"arrival_time" : "09:02:33" , 
"departure_time" : "09:03:37" , 
"distance_traveled" : 0.6028
}, 
{ 
"stop_id" : 19,
"arrival_time" : "09:06:04" , 
"departure_time" : "09:06:40" , 
"distance_traveled" : 1.2019
}, 
{ 
"stop_id" : 154,
"arrival_time" : "09:07:36" , 
"departure_time" : "09:07:45" , 
"distance_traveled" : 1.9008
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:13:09" , 
"departure_time" : "09:20:01" , 
"distance_traveled" : 5.0152
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:38:52" , 
"departure_time" : "09:38:52" , 
"distance_traveled" : 12.8134
} ], 
"242" :  [ 
{ 
"stop_id" : 14,
"arrival_time" : "11:00:00" , 
"departure_time" : "11:01:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 50,
"arrival_time" : "11:02:17" , 
"departure_time" : "11:02:24" , 
"distance_traveled" : 0.6028
}, 
{ 
"stop_id" : 19,
"arrival_time" : "11:05:07" , 
"departure_time" : "11:06:12" , 
"distance_traveled" : 1.2019
}, 
{ 
"stop_id" : 154,
"arrival_time" : "11:08:05" , 
"departure_time" : "11:09:06" , 
"distance_traveled" : 1.9008
}, 
{ 
"stop_id" : 106,
"arrival_time" : "11:14:01" , 
"departure_time" : "11:20:30" , 
"distance_traveled" : 5.0152
}, 
{ 
"stop_id" : 63,
"arrival_time" : "11:38:29" , 
"departure_time" : "11:38:29" , 
"distance_traveled" : 12.8134
} ], 
"243" :  [ 
{ 
"stop_id" : 14,
"arrival_time" : "13:00:00" , 
"departure_time" : "13:01:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 50,
"arrival_time" : "13:03:06" , 
"departure_time" : "13:03:59" , 
"distance_traveled" : 0.6028
}, 
{ 
"stop_id" : 19,
"arrival_time" : "13:05:53" , 
"departure_time" : "13:06:40" , 
"distance_traveled" : 1.2019
}, 
{ 
"stop_id" : 154,
"arrival_time" : "13:07:47" , 
"departure_time" : "13:09:24" , 
"distance_traveled" : 1.9008
}, 
{ 
"stop_id" : 106,
"arrival_time" : "13:14:37" , 
"departure_time" : "13:21:39" , 
"distance_traveled" : 5.0152
}, 
{ 
"stop_id" : 63,
"arrival_time" : "13:39:02" , 
"departure_time" : "13:39:02" , 
"distance_traveled" : 12.8134
} ], 
"244" :  [ 
{ 
"stop_id" : 14,
"arrival_time" : "15:00:00" , 
"departure_time" : "15:01:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 50,
"arrival_time" : "15:02:12" , 
"departure_time" : "15:02:17" , 
"distance_traveled" : 0.6028
}, 
{ 
"stop_id" : 19,
"arrival_time" : "15:05:05" , 
"departure_time" : "15:05:51" , 
"distance_traveled" : 1.2019
}, 
{ 
"stop_id" : 154,
"arrival_time" : "15:07:46" , 
"departure_time" : "15:07:59" , 
"distance_traveled" : 1.9008
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:13:13" , 
"departure_time" : "15:20:40" , 
"distance_traveled" : 5.0152
}, 
{ 
"stop_id" : 63,
"arrival_time" : "15:39:27" , 
"departure_time" : "15:39:27" , 
"distance_traveled" : 12.8134
} ], 
"245" :  [ 
{ 
"stop_id" : 14,
"arrival_time" : "19:00:00" , 
"departure_time" : "19:02:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 50,
"arrival_time" : "19:03:28" , 
"departure_time" : "19:03:34" , 
"distance_traveled" : 0.6028
}, 
{ 
"stop_id" : 19,
"arrival_time" : "19:05:06" , 
"departure_time" : "19:05:40" , 
"distance_traveled" : 1.2019
}, 
{ 
"stop_id" : 154,
"arrival_time" : "19:07:34" , 
"departure_time" : "19:07:43" , 
"distance_traveled" : 1.9008
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:13:09" , 
"departure_time" : "19:20:37" , 
"distance_traveled" : 5.0152
}, 
{ 
"stop_id" : 63,
"arrival_time" : "19:39:28" , 
"departure_time" : "19:39:28" , 
"distance_traveled" : 12.8134
} ], 
"246" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "24:34:00" , 
"departure_time" : "24:35:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:43:01" , 
"departure_time" : "24:43:24" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "24:53:23" , 
"departure_time" : "24:54:02" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "24:59:39" , 
"departure_time" : "25:00:15" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "25:02:36" , 
"departure_time" : "25:02:37" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "25:04:01" , 
"departure_time" : "25:04:20" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "25:07:19" , 
"departure_time" : "25:08:46" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "25:12:27" , 
"departure_time" : "25:13:47" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "25:14:20" , 
"departure_time" : "25:15:02" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "25:16:42" , 
"departure_time" : "25:17:17" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 95,
"arrival_time" : "25:18:35" , 
"departure_time" : "25:18:45" , 
"distance_traveled" : 18.4206
}, 
{ 
"stop_id" : 89,
"arrival_time" : "25:20:10" , 
"departure_time" : "25:20:27" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "25:24:17" , 
"departure_time" : "25:24:17" , 
"distance_traveled" : 19.943
} ], 
"247" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "24:34:00" , 
"departure_time" : "24:34:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:43:21" , 
"departure_time" : "24:44:13" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "24:53:52" , 
"departure_time" : "24:54:22" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "24:59:30" , 
"departure_time" : "25:00:59" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "25:03:29" , 
"departure_time" : "25:04:02" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "25:04:33" , 
"departure_time" : "25:05:07" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "25:07:34" , 
"departure_time" : "25:07:52" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "25:11:18" , 
"departure_time" : "25:12:38" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "25:14:20" , 
"departure_time" : "25:15:56" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "25:17:36" , 
"departure_time" : "25:18:16" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 95,
"arrival_time" : "25:18:40" , 
"departure_time" : "25:20:13" , 
"distance_traveled" : 18.4206
}, 
{ 
"stop_id" : 89,
"arrival_time" : "25:21:33" , 
"departure_time" : "25:22:45" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "25:25:12" , 
"departure_time" : "25:25:12" , 
"distance_traveled" : 19.943
} ], 
"248" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:44:00" , 
"departure_time" : "15:46:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:01:13" , 
"departure_time" : "16:01:33" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 154,
"arrival_time" : "16:07:20" , 
"departure_time" : "16:08:28" , 
"distance_traveled" : 13.5267
}, 
{ 
"stop_id" : 19,
"arrival_time" : "16:10:08" , 
"departure_time" : "16:10:13" , 
"distance_traveled" : 14.2256
}, 
{ 
"stop_id" : 50,
"arrival_time" : "16:12:05" , 
"departure_time" : "16:12:16" , 
"distance_traveled" : 14.8246
}, 
{ 
"stop_id" : 14,
"arrival_time" : "16:15:11" , 
"departure_time" : "16:16:32" , 
"distance_traveled" : 15.4275
}, 
{ 
"stop_id" : 152,
"arrival_time" : "16:19:21" , 
"departure_time" : "16:19:58" , 
"distance_traveled" : 16.0913
}, 
{ 
"stop_id" : 153,
"arrival_time" : "16:20:37" , 
"departure_time" : "16:22:11" , 
"distance_traveled" : 16.9517
}, 
{ 
"stop_id" : 150,
"arrival_time" : "16:24:34" , 
"departure_time" : "16:26:02" , 
"distance_traveled" : 17.9093
}, 
{ 
"stop_id" : 95,
"arrival_time" : "16:26:28" , 
"departure_time" : "16:27:35" , 
"distance_traveled" : 18.4208
}, 
{ 
"stop_id" : 89,
"arrival_time" : "16:29:07" , 
"departure_time" : "16:30:35" , 
"distance_traveled" : 19.054
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "16:33:28" , 
"departure_time" : "16:33:28" , 
"distance_traveled" : 19.9432
} ], 
"249" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:44:00" , 
"departure_time" : "15:47:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:01:32" , 
"departure_time" : "16:01:40" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 154,
"arrival_time" : "16:07:08" , 
"departure_time" : "16:07:38" , 
"distance_traveled" : 13.5267
}, 
{ 
"stop_id" : 19,
"arrival_time" : "16:09:30" , 
"departure_time" : "16:10:22" , 
"distance_traveled" : 14.2256
}, 
{ 
"stop_id" : 50,
"arrival_time" : "16:12:52" , 
"departure_time" : "16:13:27" , 
"distance_traveled" : 14.8246
}, 
{ 
"stop_id" : 14,
"arrival_time" : "16:15:35" , 
"departure_time" : "16:16:15" , 
"distance_traveled" : 15.4275
}, 
{ 
"stop_id" : 152,
"arrival_time" : "16:18:40" , 
"departure_time" : "16:18:55" , 
"distance_traveled" : 16.0913
}, 
{ 
"stop_id" : 153,
"arrival_time" : "16:20:15" , 
"departure_time" : "16:21:55" , 
"distance_traveled" : 16.9517
}, 
{ 
"stop_id" : 150,
"arrival_time" : "16:24:40" , 
"departure_time" : "16:25:45" , 
"distance_traveled" : 17.9093
}, 
{ 
"stop_id" : 95,
"arrival_time" : "16:26:05" , 
"departure_time" : "16:27:00" , 
"distance_traveled" : 18.4208
}, 
{ 
"stop_id" : 89,
"arrival_time" : "16:28:55" , 
"departure_time" : "16:30:24" , 
"distance_traveled" : 19.054
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "16:33:29" , 
"departure_time" : "16:33:29" , 
"distance_traveled" : 19.9432
} ], 
"250" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:44:00" , 
"departure_time" : "16:46:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:01:13" , 
"departure_time" : "17:02:08" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 154,
"arrival_time" : "17:07:55" , 
"departure_time" : "17:08:19" , 
"distance_traveled" : 13.5267
}, 
{ 
"stop_id" : 19,
"arrival_time" : "17:09:24" , 
"departure_time" : "17:09:57" , 
"distance_traveled" : 14.2256
}, 
{ 
"stop_id" : 50,
"arrival_time" : "17:12:33" , 
"departure_time" : "17:13:32" , 
"distance_traveled" : 14.8246
}, 
{ 
"stop_id" : 14,
"arrival_time" : "17:15:59" , 
"departure_time" : "17:17:27" , 
"distance_traveled" : 15.4275
}, 
{ 
"stop_id" : 152,
"arrival_time" : "17:19:28" , 
"departure_time" : "17:20:07" , 
"distance_traveled" : 16.0913
}, 
{ 
"stop_id" : 153,
"arrival_time" : "17:20:39" , 
"departure_time" : "17:22:07" , 
"distance_traveled" : 16.9517
}, 
{ 
"stop_id" : 150,
"arrival_time" : "17:24:28" , 
"departure_time" : "17:24:41" , 
"distance_traveled" : 17.9093
}, 
{ 
"stop_id" : 95,
"arrival_time" : "17:25:13" , 
"departure_time" : "17:26:28" , 
"distance_traveled" : 18.4208
}, 
{ 
"stop_id" : 89,
"arrival_time" : "17:29:15" , 
"departure_time" : "17:30:44" , 
"distance_traveled" : 19.054
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "17:33:29" , 
"departure_time" : "17:33:29" , 
"distance_traveled" : 19.9432
} ], 
"251" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:44:00" , 
"departure_time" : "16:45:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:00:12" , 
"departure_time" : "17:00:14" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 154,
"arrival_time" : "17:07:02" , 
"departure_time" : "17:08:11" , 
"distance_traveled" : 13.5267
}, 
{ 
"stop_id" : 19,
"arrival_time" : "17:10:09" , 
"departure_time" : "17:10:36" , 
"distance_traveled" : 14.2256
}, 
{ 
"stop_id" : 50,
"arrival_time" : "17:12:27" , 
"departure_time" : "17:12:28" , 
"distance_traveled" : 14.8246
}, 
{ 
"stop_id" : 14,
"arrival_time" : "17:15:01" , 
"departure_time" : "17:16:02" , 
"distance_traveled" : 15.4275
}, 
{ 
"stop_id" : 152,
"arrival_time" : "17:19:01" , 
"departure_time" : "17:20:13" , 
"distance_traveled" : 16.0913
}, 
{ 
"stop_id" : 153,
"arrival_time" : "17:21:12" , 
"departure_time" : "17:22:37" , 
"distance_traveled" : 16.9517
}, 
{ 
"stop_id" : 150,
"arrival_time" : "17:24:25" , 
"departure_time" : "17:26:04" , 
"distance_traveled" : 17.9093
}, 
{ 
"stop_id" : 95,
"arrival_time" : "17:26:39" , 
"departure_time" : "17:26:50" , 
"distance_traveled" : 18.4208
}, 
{ 
"stop_id" : 89,
"arrival_time" : "17:28:11" , 
"departure_time" : "17:29:10" , 
"distance_traveled" : 19.054
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "17:32:59" , 
"departure_time" : "17:32:59" , 
"distance_traveled" : 19.9432
} ], 
"252" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:48:00" , 
"departure_time" : "17:50:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:05:25" , 
"departure_time" : "18:06:08" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 154,
"arrival_time" : "18:11:43" , 
"departure_time" : "18:12:12" , 
"distance_traveled" : 13.5267
}, 
{ 
"stop_id" : 19,
"arrival_time" : "18:13:29" , 
"departure_time" : "18:15:01" , 
"distance_traveled" : 14.2256
}, 
{ 
"stop_id" : 50,
"arrival_time" : "18:17:32" , 
"departure_time" : "18:18:16" , 
"distance_traveled" : 14.8246
}, 
{ 
"stop_id" : 14,
"arrival_time" : "18:19:44" , 
"departure_time" : "18:20:43" , 
"distance_traveled" : 15.4275
}, 
{ 
"stop_id" : 152,
"arrival_time" : "18:22:59" , 
"departure_time" : "18:23:02" , 
"distance_traveled" : 16.0913
}, 
{ 
"stop_id" : 153,
"arrival_time" : "18:24:03" , 
"departure_time" : "18:25:17" , 
"distance_traveled" : 16.9517
}, 
{ 
"stop_id" : 150,
"arrival_time" : "18:28:14" , 
"departure_time" : "18:29:00" , 
"distance_traveled" : 17.9093
}, 
{ 
"stop_id" : 95,
"arrival_time" : "18:29:46" , 
"departure_time" : "18:31:26" , 
"distance_traveled" : 18.4208
}, 
{ 
"stop_id" : 89,
"arrival_time" : "18:33:40" , 
"departure_time" : "18:34:50" , 
"distance_traveled" : 19.054
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "18:37:10" , 
"departure_time" : "18:37:10" , 
"distance_traveled" : 19.9432
} ], 
"253" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:48:00" , 
"departure_time" : "17:49:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:04:42" , 
"departure_time" : "18:05:16" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 154,
"arrival_time" : "18:11:34" , 
"departure_time" : "18:11:57" , 
"distance_traveled" : 13.5267
}, 
{ 
"stop_id" : 19,
"arrival_time" : "18:13:23" , 
"departure_time" : "18:14:04" , 
"distance_traveled" : 14.2256
}, 
{ 
"stop_id" : 50,
"arrival_time" : "18:16:41" , 
"departure_time" : "18:16:57" , 
"distance_traveled" : 14.8246
}, 
{ 
"stop_id" : 14,
"arrival_time" : "18:19:16" , 
"departure_time" : "18:20:00" , 
"distance_traveled" : 15.4275
}, 
{ 
"stop_id" : 152,
"arrival_time" : "18:22:44" , 
"departure_time" : "18:24:02" , 
"distance_traveled" : 16.0913
}, 
{ 
"stop_id" : 153,
"arrival_time" : "18:25:18" , 
"departure_time" : "18:25:48" , 
"distance_traveled" : 16.9517
}, 
{ 
"stop_id" : 150,
"arrival_time" : "18:27:30" , 
"departure_time" : "18:27:41" , 
"distance_traveled" : 17.9093
}, 
{ 
"stop_id" : 95,
"arrival_time" : "18:29:11" , 
"departure_time" : "18:30:13" , 
"distance_traveled" : 18.4208
}, 
{ 
"stop_id" : 89,
"arrival_time" : "18:33:02" , 
"departure_time" : "18:33:14" , 
"distance_traveled" : 19.054
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "18:36:12" , 
"departure_time" : "18:36:12" , 
"distance_traveled" : 19.9432
} ], 
"254" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "25:15:00" , 
"departure_time" : "25:16:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "25:33:20" , 
"departure_time" : "25:43:32" , 
"distance_traveled" : 7.7985
}, 
{ 
"stop_id" : 154,
"arrival_time" : "25:48:12" , 
"departure_time" : "25:48:31" , 
"distance_traveled" : 10.9129
}, 
{ 
"stop_id" : 19,
"arrival_time" : "25:49:19" , 
"departure_time" : "25:49:27" , 
"distance_traveled" : 11.6117
}, 
{ 
"stop_id" : 50,
"arrival_time" : "25:51:08" , 
"departure_time" : "25:51:23" , 
"distance_traveled" : 12.2108
}, 
{ 
"stop_id" : 14,
"arrival_time" : "25:54:15" , 
"departure_time" : "25:54:15" , 
"distance_traveled" : 12.8136
} ], 
"255" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "25:15:00" , 
"departure_time" : "25:16:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "25:33:40" , 
"departure_time" : "25:43:25" , 
"distance_traveled" : 7.7985
}, 
{ 
"stop_id" : 154,
"arrival_time" : "25:47:45" , 
"departure_time" : "25:49:03" , 
"distance_traveled" : 10.9129
}, 
{ 
"stop_id" : 19,
"arrival_time" : "25:50:18" , 
"departure_time" : "25:50:53" , 
"distance_traveled" : 11.6117
}, 
{ 
"stop_id" : 50,
"arrival_time" : "25:51:35" , 
"departure_time" : "25:52:00" , 
"distance_traveled" : 12.2108
}, 
{ 
"stop_id" : 14,
"arrival_time" : "25:54:25" , 
"departure_time" : "25:54:25" , 
"distance_traveled" : 12.8136
} ], 
"256" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "25:15:00" , 
"departure_time" : "25:16:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "25:33:32" , 
"departure_time" : "25:43:45" , 
"distance_traveled" : 7.7985
}, 
{ 
"stop_id" : 154,
"arrival_time" : "25:48:13" , 
"departure_time" : "25:49:45" , 
"distance_traveled" : 10.9129
}, 
{ 
"stop_id" : 19,
"arrival_time" : "25:50:32" , 
"departure_time" : "25:51:53" , 
"distance_traveled" : 11.6117
}, 
{ 
"stop_id" : 50,
"arrival_time" : "25:52:21" , 
"departure_time" : "25:53:49" , 
"distance_traveled" : 12.2108
}, 
{ 
"stop_id" : 14,
"arrival_time" : "25:55:28" , 
"departure_time" : "25:55:28" , 
"distance_traveled" : 12.8136
} ], 
"257" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "06:08:00" , 
"departure_time" : "06:09:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:27:10" , 
"departure_time" : "06:28:20" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 154,
"arrival_time" : "06:34:10" , 
"departure_time" : "06:34:23" , 
"distance_traveled" : 10.8928
}, 
{ 
"stop_id" : 19,
"arrival_time" : "06:35:13" , 
"departure_time" : "06:36:50" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "06:39:37" , 
"departure_time" : "06:39:41" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "06:40:04" , 
"departure_time" : "06:40:04" , 
"distance_traveled" : 12.7936
} ], 
"258" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "06:08:00" , 
"departure_time" : "06:08:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:27:44" , 
"departure_time" : "06:28:01" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 154,
"arrival_time" : "06:33:17" , 
"departure_time" : "06:33:42" , 
"distance_traveled" : 10.8928
}, 
{ 
"stop_id" : 19,
"arrival_time" : "06:35:25" , 
"departure_time" : "06:35:39" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "06:38:14" , 
"departure_time" : "06:38:36" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "06:40:22" , 
"departure_time" : "06:40:22" , 
"distance_traveled" : 12.7936
} ], 
"259" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "08:08:00" , 
"departure_time" : "08:09:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:27:28" , 
"departure_time" : "08:35:04" , 
"distance_traveled" : 7.7985
}, 
{ 
"stop_id" : 154,
"arrival_time" : "08:39:36" , 
"departure_time" : "08:40:39" , 
"distance_traveled" : 10.9129
}, 
{ 
"stop_id" : 19,
"arrival_time" : "08:41:03" , 
"departure_time" : "08:41:33" , 
"distance_traveled" : 11.6117
}, 
{ 
"stop_id" : 50,
"arrival_time" : "08:43:30" , 
"departure_time" : "08:44:30" , 
"distance_traveled" : 12.2108
}, 
{ 
"stop_id" : 14,
"arrival_time" : "08:46:00" , 
"departure_time" : "08:46:00" , 
"distance_traveled" : 12.8136
} ], 
"260" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "08:08:00" , 
"departure_time" : "08:10:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:27:23" , 
"departure_time" : "08:34:41" , 
"distance_traveled" : 7.7985
}, 
{ 
"stop_id" : 154,
"arrival_time" : "08:39:18" , 
"departure_time" : "08:40:04" , 
"distance_traveled" : 10.9129
}, 
{ 
"stop_id" : 19,
"arrival_time" : "08:40:46" , 
"departure_time" : "08:41:58" , 
"distance_traveled" : 11.6117
}, 
{ 
"stop_id" : 50,
"arrival_time" : "08:44:12" , 
"departure_time" : "08:44:31" , 
"distance_traveled" : 12.2108
}, 
{ 
"stop_id" : 14,
"arrival_time" : "08:45:19" , 
"departure_time" : "08:45:19" , 
"distance_traveled" : 12.8136
} ], 
"261" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "10:08:00" , 
"departure_time" : "10:08:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "10:26:09" , 
"departure_time" : "10:33:05" , 
"distance_traveled" : 7.7985
}, 
{ 
"stop_id" : 154,
"arrival_time" : "10:38:56" , 
"departure_time" : "10:39:16" , 
"distance_traveled" : 10.9129
}, 
{ 
"stop_id" : 19,
"arrival_time" : "10:40:20" , 
"departure_time" : "10:41:43" , 
"distance_traveled" : 11.6117
}, 
{ 
"stop_id" : 50,
"arrival_time" : "10:44:23" , 
"departure_time" : "10:45:44" , 
"distance_traveled" : 12.2108
}, 
{ 
"stop_id" : 14,
"arrival_time" : "10:46:21" , 
"departure_time" : "10:46:21" , 
"distance_traveled" : 12.8136
} ], 
"262" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "10:08:00" , 
"departure_time" : "10:10:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "10:27:36" , 
"departure_time" : "10:34:12" , 
"distance_traveled" : 7.7985
}, 
{ 
"stop_id" : 154,
"arrival_time" : "10:38:36" , 
"departure_time" : "10:40:06" , 
"distance_traveled" : 10.9129
}, 
{ 
"stop_id" : 19,
"arrival_time" : "10:41:30" , 
"departure_time" : "10:42:07" , 
"distance_traveled" : 11.6117
}, 
{ 
"stop_id" : 50,
"arrival_time" : "10:43:37" , 
"departure_time" : "10:43:52" , 
"distance_traveled" : 12.2108
}, 
{ 
"stop_id" : 14,
"arrival_time" : "10:45:15" , 
"departure_time" : "10:45:15" , 
"distance_traveled" : 12.8136
} ], 
"263" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "12:08:00" , 
"departure_time" : "12:08:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "12:26:28" , 
"departure_time" : "12:32:45" , 
"distance_traveled" : 7.7985
}, 
{ 
"stop_id" : 154,
"arrival_time" : "12:38:17" , 
"departure_time" : "12:38:50" , 
"distance_traveled" : 10.9129
}, 
{ 
"stop_id" : 19,
"arrival_time" : "12:40:33" , 
"departure_time" : "12:40:38" , 
"distance_traveled" : 11.6117
}, 
{ 
"stop_id" : 50,
"arrival_time" : "12:43:05" , 
"departure_time" : "12:44:04" , 
"distance_traveled" : 12.2108
}, 
{ 
"stop_id" : 14,
"arrival_time" : "12:45:59" , 
"departure_time" : "12:45:59" , 
"distance_traveled" : 12.8136
} ], 
"264" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "12:08:00" , 
"departure_time" : "12:09:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "12:26:21" , 
"departure_time" : "12:32:30" , 
"distance_traveled" : 7.7985
}, 
{ 
"stop_id" : 154,
"arrival_time" : "12:38:09" , 
"departure_time" : "12:39:12" , 
"distance_traveled" : 10.9129
}, 
{ 
"stop_id" : 19,
"arrival_time" : "12:41:03" , 
"departure_time" : "12:41:12" , 
"distance_traveled" : 11.6117
}, 
{ 
"stop_id" : 50,
"arrival_time" : "12:43:09" , 
"departure_time" : "12:43:35" , 
"distance_traveled" : 12.2108
}, 
{ 
"stop_id" : 14,
"arrival_time" : "12:45:26" , 
"departure_time" : "12:45:26" , 
"distance_traveled" : 12.8136
} ], 
"265" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "14:08:00" , 
"departure_time" : "14:09:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "14:26:38" , 
"departure_time" : "14:32:45" , 
"distance_traveled" : 7.7985
}, 
{ 
"stop_id" : 154,
"arrival_time" : "14:38:07" , 
"departure_time" : "14:38:28" , 
"distance_traveled" : 10.9129
}, 
{ 
"stop_id" : 19,
"arrival_time" : "14:40:21" , 
"departure_time" : "14:41:31" , 
"distance_traveled" : 11.6117
}, 
{ 
"stop_id" : 50,
"arrival_time" : "14:44:10" , 
"departure_time" : "14:45:48" , 
"distance_traveled" : 12.2108
}, 
{ 
"stop_id" : 14,
"arrival_time" : "14:46:38" , 
"departure_time" : "14:46:38" , 
"distance_traveled" : 12.8136
} ], 
"266" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "14:08:00" , 
"departure_time" : "14:10:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "14:27:16" , 
"departure_time" : "14:34:54" , 
"distance_traveled" : 7.7985
}, 
{ 
"stop_id" : 154,
"arrival_time" : "14:39:38" , 
"departure_time" : "14:39:55" , 
"distance_traveled" : 10.9129
}, 
{ 
"stop_id" : 19,
"arrival_time" : "14:40:17" , 
"departure_time" : "14:41:01" , 
"distance_traveled" : 11.6117
}, 
{ 
"stop_id" : 50,
"arrival_time" : "14:43:44" , 
"departure_time" : "14:44:20" , 
"distance_traveled" : 12.2108
}, 
{ 
"stop_id" : 14,
"arrival_time" : "14:45:36" , 
"departure_time" : "14:45:36" , 
"distance_traveled" : 12.8136
} ], 
"267" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:08:00" , 
"departure_time" : "16:09:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:26:32" , 
"departure_time" : "16:32:48" , 
"distance_traveled" : 7.7985
}, 
{ 
"stop_id" : 154,
"arrival_time" : "16:38:16" , 
"departure_time" : "16:38:26" , 
"distance_traveled" : 10.9129
}, 
{ 
"stop_id" : 19,
"arrival_time" : "16:40:10" , 
"departure_time" : "16:40:19" , 
"distance_traveled" : 11.6117
}, 
{ 
"stop_id" : 50,
"arrival_time" : "16:43:09" , 
"departure_time" : "16:44:28" , 
"distance_traveled" : 12.2108
}, 
{ 
"stop_id" : 14,
"arrival_time" : "16:46:19" , 
"departure_time" : "16:46:19" , 
"distance_traveled" : 12.8136
} ], 
"268" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:08:00" , 
"departure_time" : "16:10:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:27:16" , 
"departure_time" : "16:33:23" , 
"distance_traveled" : 7.7985
}, 
{ 
"stop_id" : 154,
"arrival_time" : "16:38:07" , 
"departure_time" : "16:39:06" , 
"distance_traveled" : 10.9129
}, 
{ 
"stop_id" : 19,
"arrival_time" : "16:40:59" , 
"departure_time" : "16:41:37" , 
"distance_traveled" : 11.6117
}, 
{ 
"stop_id" : 50,
"arrival_time" : "16:43:38" , 
"departure_time" : "16:44:11" , 
"distance_traveled" : 12.2108
}, 
{ 
"stop_id" : 14,
"arrival_time" : "16:45:33" , 
"departure_time" : "16:45:33" , 
"distance_traveled" : 12.8136
} ], 
"269" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:08:00" , 
"departure_time" : "18:09:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:27:11" , 
"departure_time" : "18:34:45" , 
"distance_traveled" : 7.7985
}, 
{ 
"stop_id" : 154,
"arrival_time" : "18:39:34" , 
"departure_time" : "18:40:29" , 
"distance_traveled" : 10.9129
}, 
{ 
"stop_id" : 19,
"arrival_time" : "18:40:55" , 
"departure_time" : "18:41:07" , 
"distance_traveled" : 11.6117
}, 
{ 
"stop_id" : 50,
"arrival_time" : "18:43:12" , 
"departure_time" : "18:43:44" , 
"distance_traveled" : 12.2108
}, 
{ 
"stop_id" : 14,
"arrival_time" : "18:45:32" , 
"departure_time" : "18:45:32" , 
"distance_traveled" : 12.8136
} ], 
"270" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:08:00" , 
"departure_time" : "18:09:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:27:11" , 
"departure_time" : "18:34:06" , 
"distance_traveled" : 7.7985
}, 
{ 
"stop_id" : 154,
"arrival_time" : "18:38:55" , 
"departure_time" : "18:39:18" , 
"distance_traveled" : 10.9129
}, 
{ 
"stop_id" : 19,
"arrival_time" : "18:40:23" , 
"departure_time" : "18:41:03" , 
"distance_traveled" : 11.6117
}, 
{ 
"stop_id" : 50,
"arrival_time" : "18:43:40" , 
"departure_time" : "18:43:46" , 
"distance_traveled" : 12.2108
}, 
{ 
"stop_id" : 14,
"arrival_time" : "18:45:06" , 
"departure_time" : "18:45:06" , 
"distance_traveled" : 12.8136
} ], 
"271" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "20:08:00" , 
"departure_time" : "20:08:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "20:26:25" , 
"departure_time" : "20:32:31" , 
"distance_traveled" : 7.7985
}, 
{ 
"stop_id" : 154,
"arrival_time" : "20:38:06" , 
"departure_time" : "20:39:10" , 
"distance_traveled" : 10.9129
}, 
{ 
"stop_id" : 19,
"arrival_time" : "20:41:04" , 
"departure_time" : "20:42:27" , 
"distance_traveled" : 11.6117
}, 
{ 
"stop_id" : 50,
"arrival_time" : "20:44:23" , 
"departure_time" : "20:44:40" , 
"distance_traveled" : 12.2108
}, 
{ 
"stop_id" : 14,
"arrival_time" : "20:45:17" , 
"departure_time" : "20:45:17" , 
"distance_traveled" : 12.8136
} ], 
"272" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "20:08:00" , 
"departure_time" : "20:08:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "20:26:38" , 
"departure_time" : "20:33:02" , 
"distance_traveled" : 7.7985
}, 
{ 
"stop_id" : 154,
"arrival_time" : "20:38:24" , 
"departure_time" : "20:39:51" , 
"distance_traveled" : 10.9129
}, 
{ 
"stop_id" : 19,
"arrival_time" : "20:41:27" , 
"departure_time" : "20:42:31" , 
"distance_traveled" : 11.6117
}, 
{ 
"stop_id" : 50,
"arrival_time" : "20:44:04" , 
"departure_time" : "20:44:10" , 
"distance_traveled" : 12.2108
}, 
{ 
"stop_id" : 14,
"arrival_time" : "20:45:06" , 
"departure_time" : "20:45:06" , 
"distance_traveled" : 12.8136
} ], 
"273" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "23:08:00" , 
"departure_time" : "23:08:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "23:26:12" , 
"departure_time" : "23:33:27" , 
"distance_traveled" : 7.7985
}, 
{ 
"stop_id" : 154,
"arrival_time" : "23:39:15" , 
"departure_time" : "23:39:53" , 
"distance_traveled" : 10.9129
}, 
{ 
"stop_id" : 19,
"arrival_time" : "23:40:38" , 
"departure_time" : "23:41:34" , 
"distance_traveled" : 11.6117
}, 
{ 
"stop_id" : 50,
"arrival_time" : "23:43:56" , 
"departure_time" : "23:44:28" , 
"distance_traveled" : 12.2108
}, 
{ 
"stop_id" : 14,
"arrival_time" : "23:45:32" , 
"departure_time" : "23:45:32" , 
"distance_traveled" : 12.8136
} ], 
"274" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "23:08:00" , 
"departure_time" : "23:09:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "23:26:58" , 
"departure_time" : "23:33:18" , 
"distance_traveled" : 7.7985
}, 
{ 
"stop_id" : 154,
"arrival_time" : "23:38:20" , 
"departure_time" : "23:39:38" , 
"distance_traveled" : 10.9129
}, 
{ 
"stop_id" : 19,
"arrival_time" : "23:41:18" , 
"departure_time" : "23:42:37" , 
"distance_traveled" : 11.6117
}, 
{ 
"stop_id" : 50,
"arrival_time" : "23:44:19" , 
"departure_time" : "23:45:32" , 
"distance_traveled" : 12.2108
}, 
{ 
"stop_id" : 14,
"arrival_time" : "23:46:13" , 
"departure_time" : "23:46:13" , 
"distance_traveled" : 12.8136
} ], 
"275" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "06:42:00" , 
"departure_time" : "06:44:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:59:09" , 
"departure_time" : "07:00:34" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 19,
"arrival_time" : "07:05:25" , 
"departure_time" : "07:05:37" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "07:06:12" , 
"departure_time" : "07:06:24" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "07:09:12" , 
"departure_time" : "07:09:37" , 
"distance_traveled" : 12.7936
}, 
{ 
"stop_id" : 152,
"arrival_time" : "07:12:25" , 
"departure_time" : "07:12:46" , 
"distance_traveled" : 13.4574
}, 
{ 
"stop_id" : 150,
"arrival_time" : "07:15:21" , 
"departure_time" : "07:16:17" , 
"distance_traveled" : 15.1934
}, 
{ 
"stop_id" : 89,
"arrival_time" : "07:18:56" , 
"departure_time" : "07:20:34" , 
"distance_traveled" : 16.3383
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "07:21:38" , 
"departure_time" : "07:21:38" , 
"distance_traveled" : 17.2275
} ], 
"276" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "06:42:00" , 
"departure_time" : "06:43:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:58:05" , 
"departure_time" : "06:59:09" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 19,
"arrival_time" : "07:05:04" , 
"departure_time" : "07:06:30" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "07:07:26" , 
"departure_time" : "07:07:51" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "07:09:25" , 
"departure_time" : "07:11:01" , 
"distance_traveled" : 12.7936
}, 
{ 
"stop_id" : 152,
"arrival_time" : "07:13:36" , 
"departure_time" : "07:14:49" , 
"distance_traveled" : 13.4574
}, 
{ 
"stop_id" : 150,
"arrival_time" : "07:16:13" , 
"departure_time" : "07:17:39" , 
"distance_traveled" : 15.1934
}, 
{ 
"stop_id" : 89,
"arrival_time" : "07:19:26" , 
"departure_time" : "07:20:23" , 
"distance_traveled" : 16.3383
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "07:20:57" , 
"departure_time" : "07:20:57" , 
"distance_traveled" : 17.2275
} ], 
"277" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:52:00" , 
"departure_time" : "16:53:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:10:06" , 
"departure_time" : "17:10:57" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 154,
"arrival_time" : "17:16:51" , 
"departure_time" : "17:16:59" , 
"distance_traveled" : 13.5267
}, 
{ 
"stop_id" : 19,
"arrival_time" : "17:19:08" , 
"departure_time" : "17:20:28" , 
"distance_traveled" : 14.2256
}, 
{ 
"stop_id" : 50,
"arrival_time" : "17:22:20" , 
"departure_time" : "17:23:20" , 
"distance_traveled" : 14.8246
}, 
{ 
"stop_id" : 14,
"arrival_time" : "17:25:00" , 
"departure_time" : "17:25:20" , 
"distance_traveled" : 15.4275
}, 
{ 
"stop_id" : 152,
"arrival_time" : "17:28:20" , 
"departure_time" : "17:29:38" , 
"distance_traveled" : 16.0913
}, 
{ 
"stop_id" : 153,
"arrival_time" : "17:31:18" , 
"departure_time" : "17:32:32" , 
"distance_traveled" : 16.9517
}, 
{ 
"stop_id" : 150,
"arrival_time" : "17:34:14" , 
"departure_time" : "17:35:27" , 
"distance_traveled" : 17.9093
}, 
{ 
"stop_id" : 95,
"arrival_time" : "17:36:13" , 
"departure_time" : "17:37:40" , 
"distance_traveled" : 18.4208
}, 
{ 
"stop_id" : 89,
"arrival_time" : "17:39:27" , 
"departure_time" : "17:40:44" , 
"distance_traveled" : 19.054
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "17:42:17" , 
"departure_time" : "17:42:17" , 
"distance_traveled" : 19.9432
} ], 
"278" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:52:00" , 
"departure_time" : "16:54:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:11:02" , 
"departure_time" : "17:12:29" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 154,
"arrival_time" : "17:17:27" , 
"departure_time" : "17:17:32" , 
"distance_traveled" : 13.5267
}, 
{ 
"stop_id" : 19,
"arrival_time" : "17:19:05" , 
"departure_time" : "17:19:58" , 
"distance_traveled" : 14.2256
}, 
{ 
"stop_id" : 50,
"arrival_time" : "17:21:53" , 
"departure_time" : "17:23:02" , 
"distance_traveled" : 14.8246
}, 
{ 
"stop_id" : 14,
"arrival_time" : "17:25:09" , 
"departure_time" : "17:26:11" , 
"distance_traveled" : 15.4275
}, 
{ 
"stop_id" : 152,
"arrival_time" : "17:29:02" , 
"departure_time" : "17:30:30" , 
"distance_traveled" : 16.0913
}, 
{ 
"stop_id" : 153,
"arrival_time" : "17:31:28" , 
"departure_time" : "17:32:20" , 
"distance_traveled" : 16.9517
}, 
{ 
"stop_id" : 150,
"arrival_time" : "17:33:52" , 
"departure_time" : "17:34:24" , 
"distance_traveled" : 17.9093
}, 
{ 
"stop_id" : 95,
"arrival_time" : "17:35:32" , 
"departure_time" : "17:36:17" , 
"distance_traveled" : 18.4208
}, 
{ 
"stop_id" : 89,
"arrival_time" : "17:38:45" , 
"departure_time" : "17:39:03" , 
"distance_traveled" : 19.054
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "17:41:18" , 
"departure_time" : "17:41:18" , 
"distance_traveled" : 19.9432
} ], 
"279" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:10:00" , 
"departure_time" : "18:10:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:29:14" , 
"departure_time" : "18:30:04" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 154,
"arrival_time" : "18:35:50" , 
"departure_time" : "18:37:11" , 
"distance_traveled" : 13.5267
}, 
{ 
"stop_id" : 19,
"arrival_time" : "18:39:21" , 
"departure_time" : "18:40:27" , 
"distance_traveled" : 14.2256
}, 
{ 
"stop_id" : 50,
"arrival_time" : "18:42:06" , 
"departure_time" : "18:42:49" , 
"distance_traveled" : 14.8246
}, 
{ 
"stop_id" : 14,
"arrival_time" : "18:44:43" , 
"departure_time" : "18:45:16" , 
"distance_traveled" : 15.4275
}, 
{ 
"stop_id" : 152,
"arrival_time" : "18:48:33" , 
"departure_time" : "18:50:09" , 
"distance_traveled" : 16.0913
}, 
{ 
"stop_id" : 153,
"arrival_time" : "18:52:36" , 
"departure_time" : "18:54:15" , 
"distance_traveled" : 16.9517
}, 
{ 
"stop_id" : 150,
"arrival_time" : "18:55:39" , 
"departure_time" : "18:55:46" , 
"distance_traveled" : 17.9093
}, 
{ 
"stop_id" : 95,
"arrival_time" : "18:57:07" , 
"departure_time" : "18:57:32" , 
"distance_traveled" : 18.4208
}, 
{ 
"stop_id" : 89,
"arrival_time" : "18:59:25" , 
"departure_time" : "19:00:38" , 
"distance_traveled" : 19.054
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "19:04:13" , 
"departure_time" : "19:04:13" , 
"distance_traveled" : 19.9432
} ], 
"280" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:10:00" , 
"departure_time" : "18:12:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:29:48" , 
"departure_time" : "18:30:40" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 154,
"arrival_time" : "18:35:52" , 
"departure_time" : "18:36:58" , 
"distance_traveled" : 13.5267
}, 
{ 
"stop_id" : 19,
"arrival_time" : "18:39:06" , 
"departure_time" : "18:40:27" , 
"distance_traveled" : 14.2256
}, 
{ 
"stop_id" : 50,
"arrival_time" : "18:42:21" , 
"departure_time" : "18:43:10" , 
"distance_traveled" : 14.8246
}, 
{ 
"stop_id" : 14,
"arrival_time" : "18:44:49" , 
"departure_time" : "18:45:57" , 
"distance_traveled" : 15.4275
}, 
{ 
"stop_id" : 152,
"arrival_time" : "18:49:08" , 
"departure_time" : "18:49:18" , 
"distance_traveled" : 16.0913
}, 
{ 
"stop_id" : 153,
"arrival_time" : "18:51:10" , 
"departure_time" : "18:52:12" , 
"distance_traveled" : 16.9517
}, 
{ 
"stop_id" : 150,
"arrival_time" : "18:55:02" , 
"departure_time" : "18:56:25" , 
"distance_traveled" : 17.9093
}, 
{ 
"stop_id" : 95,
"arrival_time" : "18:58:23" , 
"departure_time" : "18:59:07" , 
"distance_traveled" : 18.4208
}, 
{ 
"stop_id" : 89,
"arrival_time" : "18:59:44" , 
"departure_time" : "19:00:45" , 
"distance_traveled" : 19.054
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "19:04:01" , 
"departure_time" : "19:04:01" , 
"distance_traveled" : 19.9432
} ], 
"281" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "06:50:00" , 
"departure_time" : "06:52:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:01:28" , 
"departure_time" : "07:02:14" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:09:46" , 
"departure_time" : "07:10:26" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "07:16:40" , 
"departure_time" : "07:16:41" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "07:19:01" , 
"departure_time" : "07:20:18" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "07:23:17" , 
"departure_time" : "07:24:28" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "07:26:11" , 
"departure_time" : "07:26:17" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "07:28:06" , 
"departure_time" : "07:28:22" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "07:31:16" , 
"departure_time" : "07:31:42" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "07:34:26" , 
"departure_time" : "07:35:31" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 89,
"arrival_time" : "07:38:05" , 
"departure_time" : "07:38:42" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "07:41:37" , 
"departure_time" : "07:41:37" , 
"distance_traveled" : 19.943
} ], 
"282" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "06:50:00" , 
"departure_time" : "06:51:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:00:43" , 
"departure_time" : "07:01:08" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:09:25" , 
"departure_time" : "07:10:54" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "07:17:29" , 
"departure_time" : "07:18:55" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "07:20:26" , 
"departure_time" : "07:21:47" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "07:23:21" , 
"departure_time" : "07:23:31" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "07:25:10" , 
"departure_time" : "07:25:11" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "07:28:01" , 
"departure_time" : "07:29:41" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "07:32:40" , 
"departure_time" : "07:33:36" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "07:34:56" , 
"departure_time" : "07:35:21" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 89,
"arrival_time" : "07:37:25" , 
"departure_time" : "07:38:53" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "07:42:28" , 
"departure_time" : "07:42:28" , 
"distance_traveled" : 19.943
} ], 
"283" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:25:00" , 
"departure_time" : "17:27:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:42:27" , 
"departure_time" : "17:43:08" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 154,
"arrival_time" : "17:47:41" , 
"departure_time" : "17:47:48" , 
"distance_traveled" : 10.8928
}, 
{ 
"stop_id" : 19,
"arrival_time" : "17:50:07" , 
"departure_time" : "17:51:06" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "17:53:59" , 
"departure_time" : "17:55:33" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "17:57:34" , 
"departure_time" : "17:58:34" , 
"distance_traveled" : 12.7936
}, 
{ 
"stop_id" : 152,
"arrival_time" : "18:00:00" , 
"departure_time" : "18:00:24" , 
"distance_traveled" : 13.4574
}, 
{ 
"stop_id" : 153,
"arrival_time" : "18:02:24" , 
"departure_time" : "18:02:47" , 
"distance_traveled" : 14.3178
}, 
{ 
"stop_id" : 150,
"arrival_time" : "18:04:23" , 
"departure_time" : "18:05:36" , 
"distance_traveled" : 15.2754
}, 
{ 
"stop_id" : 95,
"arrival_time" : "18:07:13" , 
"departure_time" : "18:07:37" , 
"distance_traveled" : 15.7869
}, 
{ 
"stop_id" : 89,
"arrival_time" : "18:09:24" , 
"departure_time" : "18:10:04" , 
"distance_traveled" : 16.4201
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "18:12:40" , 
"departure_time" : "18:12:40" , 
"distance_traveled" : 17.3093
} ], 
"284" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:25:00" , 
"departure_time" : "17:26:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:41:53" , 
"departure_time" : "17:42:04" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 154,
"arrival_time" : "17:47:11" , 
"departure_time" : "17:47:38" , 
"distance_traveled" : 10.8928
}, 
{ 
"stop_id" : 19,
"arrival_time" : "17:50:27" , 
"departure_time" : "17:51:19" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "17:53:52" , 
"departure_time" : "17:55:14" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "17:57:22" , 
"departure_time" : "17:57:29" , 
"distance_traveled" : 12.7936
}, 
{ 
"stop_id" : 152,
"arrival_time" : "17:59:07" , 
"departure_time" : "17:59:42" , 
"distance_traveled" : 13.4574
}, 
{ 
"stop_id" : 153,
"arrival_time" : "18:02:35" , 
"departure_time" : "18:02:58" , 
"distance_traveled" : 14.3178
}, 
{ 
"stop_id" : 150,
"arrival_time" : "18:04:23" , 
"departure_time" : "18:04:24" , 
"distance_traveled" : 15.2754
}, 
{ 
"stop_id" : 95,
"arrival_time" : "18:06:01" , 
"departure_time" : "18:06:51" , 
"distance_traveled" : 15.7869
}, 
{ 
"stop_id" : 89,
"arrival_time" : "18:09:50" , 
"departure_time" : "18:11:09" , 
"distance_traveled" : 16.4201
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "18:13:19" , 
"departure_time" : "18:13:19" , 
"distance_traveled" : 17.3093
} ], 
"285" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:56:00" , 
"departure_time" : "17:58:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:12:54" , 
"departure_time" : "18:13:13" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 154,
"arrival_time" : "18:19:19" , 
"departure_time" : "18:20:55" , 
"distance_traveled" : 10.8928
}, 
{ 
"stop_id" : 19,
"arrival_time" : "18:22:36" , 
"departure_time" : "18:22:42" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "18:24:06" , 
"departure_time" : "18:25:08" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "18:28:02" , 
"departure_time" : "18:28:49" , 
"distance_traveled" : 12.7936
}, 
{ 
"stop_id" : 152,
"arrival_time" : "18:30:47" , 
"departure_time" : "18:31:49" , 
"distance_traveled" : 13.4574
}, 
{ 
"stop_id" : 153,
"arrival_time" : "18:34:02" , 
"departure_time" : "18:35:16" , 
"distance_traveled" : 14.3178
}, 
{ 
"stop_id" : 150,
"arrival_time" : "18:37:14" , 
"departure_time" : "18:38:24" , 
"distance_traveled" : 15.2754
}, 
{ 
"stop_id" : 95,
"arrival_time" : "18:39:10" , 
"departure_time" : "18:40:09" , 
"distance_traveled" : 15.7869
}, 
{ 
"stop_id" : 89,
"arrival_time" : "18:40:59" , 
"departure_time" : "18:42:33" , 
"distance_traveled" : 16.4201
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "18:44:34" , 
"departure_time" : "18:44:34" , 
"distance_traveled" : 17.3093
} ], 
"286" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:56:00" , 
"departure_time" : "17:57:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:12:12" , 
"departure_time" : "18:12:30" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 154,
"arrival_time" : "18:19:18" , 
"departure_time" : "18:19:20" , 
"distance_traveled" : 10.8928
}, 
{ 
"stop_id" : 19,
"arrival_time" : "18:21:02" , 
"departure_time" : "18:21:26" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "18:24:24" , 
"departure_time" : "18:24:26" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "18:27:02" , 
"departure_time" : "18:28:18" , 
"distance_traveled" : 12.7936
}, 
{ 
"stop_id" : 152,
"arrival_time" : "18:31:16" , 
"departure_time" : "18:32:46" , 
"distance_traveled" : 13.4574
}, 
{ 
"stop_id" : 153,
"arrival_time" : "18:34:30" , 
"departure_time" : "18:35:36" , 
"distance_traveled" : 14.3178
}, 
{ 
"stop_id" : 150,
"arrival_time" : "18:37:06" , 
"departure_time" : "18:37:29" , 
"distance_traveled" : 15.2754
}, 
{ 
"stop_id" : 95,
"arrival_time" : "18:38:23" , 
"departure_time" : "18:38:30" , 
"distance_traveled" : 15.7869
}, 
{ 
"stop_id" : 89,
"arrival_time" : "18:40:07" , 
"departure_time" : "18:40:18" , 
"distance_traveled" : 16.4201
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "18:43:11" , 
"departure_time" : "18:43:11" , 
"distance_traveled" : 17.3093
} ], 
"287" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:31:00" , 
"departure_time" : "17:32:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:49:16" , 
"departure_time" : "17:49:48" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 154,
"arrival_time" : "17:55:32" , 
"departure_time" : "17:55:59" , 
"distance_traveled" : 13.5267
}, 
{ 
"stop_id" : 19,
"arrival_time" : "17:58:27" , 
"departure_time" : "17:59:57" , 
"distance_traveled" : 14.2256
}, 
{ 
"stop_id" : 50,
"arrival_time" : "18:02:30" , 
"departure_time" : "18:03:17" , 
"distance_traveled" : 14.8246
}, 
{ 
"stop_id" : 14,
"arrival_time" : "18:05:47" , 
"departure_time" : "18:06:41" , 
"distance_traveled" : 15.4275
}, 
{ 
"stop_id" : 152,
"arrival_time" : "18:09:54" , 
"departure_time" : "18:10:33" , 
"distance_traveled" : 16.0913
}, 
{ 
"stop_id" : 153,
"arrival_time" : "18:12:39" , 
"departure_time" : "18:12:49" , 
"distance_traveled" : 16.9517
}, 
{ 
"stop_id" : 150,
"arrival_time" : "18:15:10" , 
"departure_time" : "18:16:50" , 
"distance_traveled" : 17.9093
}, 
{ 
"stop_id" : 95,
"arrival_time" : "18:18:40" , 
"departure_time" : "18:19:25" , 
"distance_traveled" : 18.4208
}, 
{ 
"stop_id" : 89,
"arrival_time" : "18:20:45" , 
"departure_time" : "18:22:04" , 
"distance_traveled" : 19.054
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "18:24:19" , 
"departure_time" : "18:24:19" , 
"distance_traveled" : 19.9432
} ], 
"288" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:31:00" , 
"departure_time" : "17:32:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:48:14" , 
"departure_time" : "17:49:07" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 154,
"arrival_time" : "17:55:53" , 
"departure_time" : "17:56:39" , 
"distance_traveled" : 13.5267
}, 
{ 
"stop_id" : 19,
"arrival_time" : "17:58:46" , 
"departure_time" : "18:00:08" , 
"distance_traveled" : 14.2256
}, 
{ 
"stop_id" : 50,
"arrival_time" : "18:02:22" , 
"departure_time" : "18:02:56" , 
"distance_traveled" : 14.8246
}, 
{ 
"stop_id" : 14,
"arrival_time" : "18:05:34" , 
"departure_time" : "18:06:47" , 
"distance_traveled" : 15.4275
}, 
{ 
"stop_id" : 152,
"arrival_time" : "18:10:13" , 
"departure_time" : "18:11:49" , 
"distance_traveled" : 16.0913
}, 
{ 
"stop_id" : 153,
"arrival_time" : "18:13:36" , 
"departure_time" : "18:14:22" , 
"distance_traveled" : 16.9517
}, 
{ 
"stop_id" : 150,
"arrival_time" : "18:15:46" , 
"departure_time" : "18:16:58" , 
"distance_traveled" : 17.9093
}, 
{ 
"stop_id" : 95,
"arrival_time" : "18:18:12" , 
"departure_time" : "18:18:34" , 
"distance_traveled" : 18.4208
}, 
{ 
"stop_id" : 89,
"arrival_time" : "18:20:22" , 
"departure_time" : "18:21:21" , 
"distance_traveled" : 19.054
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "18:23:59" , 
"departure_time" : "18:23:59" , 
"distance_traveled" : 19.9432
} ], 
"289" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "07:40:00" , 
"departure_time" : "07:41:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:49:08" , 
"departure_time" : "07:50:17" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:00:09" , 
"departure_time" : "08:00:41" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "08:06:32" , 
"departure_time" : "08:07:01" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "08:08:29" , 
"departure_time" : "08:08:52" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "08:11:23" , 
"departure_time" : "08:12:45" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "08:15:22" , 
"departure_time" : "08:16:50" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "08:19:28" , 
"departure_time" : "08:19:33" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "08:20:05" , 
"departure_time" : "08:21:44" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "08:24:39" , 
"departure_time" : "08:25:27" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 89,
"arrival_time" : "08:26:48" , 
"departure_time" : "08:28:20" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "08:32:32" , 
"departure_time" : "08:32:32" , 
"distance_traveled" : 19.943
} ], 
"290" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "07:40:00" , 
"departure_time" : "07:42:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:50:11" , 
"departure_time" : "07:50:43" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:59:32" , 
"departure_time" : "08:00:44" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "08:07:12" , 
"departure_time" : "08:07:45" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "08:08:33" , 
"departure_time" : "08:10:11" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "08:12:38" , 
"departure_time" : "08:13:45" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "08:15:07" , 
"departure_time" : "08:16:00" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "08:18:53" , 
"departure_time" : "08:19:50" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "08:20:57" , 
"departure_time" : "08:22:25" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "08:24:28" , 
"departure_time" : "08:24:53" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 89,
"arrival_time" : "08:26:25" , 
"departure_time" : "08:27:15" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "08:31:50" , 
"departure_time" : "08:31:50" , 
"distance_traveled" : 19.943
} ], 
"291" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "09:09:00" , 
"departure_time" : "09:10:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:18:43" , 
"departure_time" : "09:20:21" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:28:38" , 
"departure_time" : "09:28:58" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "09:33:20" , 
"departure_time" : "09:34:30" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "09:36:10" , 
"departure_time" : "09:36:22" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "09:37:12" , 
"departure_time" : "09:38:38" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "09:41:26" , 
"departure_time" : "09:42:07" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "09:43:41" , 
"departure_time" : "09:44:54" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "09:46:13" , 
"departure_time" : "09:47:07" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "09:48:54" , 
"departure_time" : "09:49:01" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 89,
"arrival_time" : "09:51:07" , 
"departure_time" : "09:51:57" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "09:54:50" , 
"departure_time" : "09:54:50" , 
"distance_traveled" : 19.943
} ], 
"292" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "09:09:00" , 
"departure_time" : "09:10:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:18:51" , 
"departure_time" : "09:19:29" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:27:38" , 
"departure_time" : "09:28:26" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "09:33:48" , 
"departure_time" : "09:35:08" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "09:36:20" , 
"departure_time" : "09:36:28" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "09:37:08" , 
"departure_time" : "09:37:39" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "09:40:31" , 
"departure_time" : "09:41:59" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "09:44:28" , 
"departure_time" : "09:45:15" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "09:45:47" , 
"departure_time" : "09:47:10" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "09:49:23" , 
"departure_time" : "09:50:46" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 89,
"arrival_time" : "09:52:23" , 
"departure_time" : "09:53:09" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "09:54:46" , 
"departure_time" : "09:54:46" , 
"distance_traveled" : 19.943
} ], 
"293" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "22:41:00" , 
"departure_time" : "22:42:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:51:16" , 
"departure_time" : "22:52:42" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "23:02:26" , 
"departure_time" : "23:03:56" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "23:08:30" , 
"departure_time" : "23:09:30" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "23:10:00" , 
"departure_time" : "23:11:14" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "23:13:14" , 
"departure_time" : "23:14:14" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "23:16:00" , 
"departure_time" : "23:17:00" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "23:19:00" , 
"departure_time" : "23:19:55" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "23:21:55" , 
"departure_time" : "23:23:14" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "23:25:19" , 
"departure_time" : "23:25:56" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 95,
"arrival_time" : "23:26:37" , 
"departure_time" : "23:28:16" , 
"distance_traveled" : 18.4206
}, 
{ 
"stop_id" : 89,
"arrival_time" : "23:30:39" , 
"departure_time" : "23:30:41" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "23:33:02" , 
"departure_time" : "23:33:02" , 
"distance_traveled" : 19.943
} ], 
"294" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "22:41:00" , 
"departure_time" : "22:42:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:52:36" , 
"departure_time" : "22:54:08" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "23:02:32" , 
"departure_time" : "23:02:47" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "23:07:15" , 
"departure_time" : "23:07:58" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "23:09:43" , 
"departure_time" : "23:09:45" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "23:12:02" , 
"departure_time" : "23:12:53" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "23:15:51" , 
"departure_time" : "23:17:29" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "23:19:38" , 
"departure_time" : "23:20:13" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "23:21:35" , 
"departure_time" : "23:21:56" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "23:24:21" , 
"departure_time" : "23:25:25" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 95,
"arrival_time" : "23:27:04" , 
"departure_time" : "23:28:01" , 
"distance_traveled" : 18.4206
}, 
{ 
"stop_id" : 89,
"arrival_time" : "23:29:57" , 
"departure_time" : "23:30:48" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "23:33:51" , 
"departure_time" : "23:33:51" , 
"distance_traveled" : 19.943
} ], 
"295" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "23:41:00" , 
"departure_time" : "23:42:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:52:08" , 
"departure_time" : "23:53:41" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "24:02:33" , 
"departure_time" : "24:03:05" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "24:07:32" , 
"departure_time" : "24:07:41" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "24:09:09" , 
"departure_time" : "24:09:29" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "24:12:20" , 
"departure_time" : "24:13:27" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "24:16:07" , 
"departure_time" : "24:17:29" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "24:20:22" , 
"departure_time" : "24:21:10" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "24:21:48" , 
"departure_time" : "24:23:28" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "24:25:40" , 
"departure_time" : "24:26:08" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 95,
"arrival_time" : "24:27:28" , 
"departure_time" : "24:27:37" , 
"distance_traveled" : 18.4206
}, 
{ 
"stop_id" : 89,
"arrival_time" : "24:29:09" , 
"departure_time" : "24:30:18" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "24:34:09" , 
"departure_time" : "24:34:09" , 
"distance_traveled" : 19.943
} ], 
"296" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "23:41:00" , 
"departure_time" : "23:43:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:51:51" , 
"departure_time" : "23:53:30" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "24:02:39" , 
"departure_time" : "24:03:14" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "24:07:35" , 
"departure_time" : "24:07:44" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "24:09:09" , 
"departure_time" : "24:09:27" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "24:12:18" , 
"departure_time" : "24:12:55" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "24:15:37" , 
"departure_time" : "24:16:26" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "24:19:49" , 
"departure_time" : "24:19:54" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "24:21:05" , 
"departure_time" : "24:22:41" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "24:25:36" , 
"departure_time" : "24:26:13" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 95,
"arrival_time" : "24:27:37" , 
"departure_time" : "24:28:25" , 
"distance_traveled" : 18.4206
}, 
{ 
"stop_id" : 89,
"arrival_time" : "24:29:48" , 
"departure_time" : "24:30:11" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "24:33:23" , 
"departure_time" : "24:33:23" , 
"distance_traveled" : 19.943
} ], 
"297" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "08:14:00" , 
"departure_time" : "08:15:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:24:22" , 
"departure_time" : "08:24:58" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:32:36" , 
"departure_time" : "08:32:40" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "08:39:04" , 
"departure_time" : "08:39:19" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "08:41:15" , 
"departure_time" : "08:41:43" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "08:44:28" , 
"departure_time" : "08:45:32" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "08:48:04" , 
"departure_time" : "08:48:32" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "08:50:28" , 
"departure_time" : "08:50:48" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "08:52:20" , 
"departure_time" : "08:52:33" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "08:55:13" , 
"departure_time" : "08:55:34" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 95,
"arrival_time" : "08:57:21" , 
"departure_time" : "08:58:09" , 
"distance_traveled" : 18.4206
}, 
{ 
"stop_id" : 89,
"arrival_time" : "09:00:48" , 
"departure_time" : "09:02:04" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "09:07:16" , 
"departure_time" : "09:07:16" , 
"distance_traveled" : 19.943
} ], 
"298" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "08:14:00" , 
"departure_time" : "08:15:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:23:19" , 
"departure_time" : "08:24:11" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:32:52" , 
"departure_time" : "08:33:17" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "08:39:25" , 
"departure_time" : "08:40:48" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "08:42:23" , 
"departure_time" : "08:43:12" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "08:44:49" , 
"departure_time" : "08:45:58" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "08:48:09" , 
"departure_time" : "08:48:22" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "08:50:13" , 
"departure_time" : "08:50:59" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "08:52:46" , 
"departure_time" : "08:53:31" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "08:55:45" , 
"departure_time" : "08:57:23" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 95,
"arrival_time" : "08:58:38" , 
"departure_time" : "08:59:43" , 
"distance_traveled" : 18.4206
}, 
{ 
"stop_id" : 89,
"arrival_time" : "09:01:05" , 
"departure_time" : "09:01:59" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "09:06:54" , 
"departure_time" : "09:06:54" , 
"distance_traveled" : 19.943
} ], 
"299" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "10:29:00" , 
"departure_time" : "10:30:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:38:43" , 
"departure_time" : "10:39:50" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "10:50:07" , 
"departure_time" : "10:50:39" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "10:56:32" , 
"departure_time" : "10:57:48" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "10:59:16" , 
"departure_time" : "11:00:49" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "11:02:33" , 
"departure_time" : "11:02:51" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "11:04:18" , 
"departure_time" : "11:04:58" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "11:07:40" , 
"departure_time" : "11:07:53" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "11:09:13" , 
"departure_time" : "11:10:14" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "11:13:01" , 
"departure_time" : "11:13:19" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 95,
"arrival_time" : "11:14:18" , 
"departure_time" : "11:14:42" , 
"distance_traveled" : 18.4206
}, 
{ 
"stop_id" : 89,
"arrival_time" : "11:17:24" , 
"departure_time" : "11:17:54" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "11:27:30" , 
"departure_time" : "11:27:30" , 
"distance_traveled" : 19.943
} ], 
"300" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "10:29:00" , 
"departure_time" : "10:30:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:38:34" , 
"departure_time" : "10:38:55" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "10:49:21" , 
"departure_time" : "10:49:40" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "10:56:19" , 
"departure_time" : "10:56:30" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "10:58:11" , 
"departure_time" : "10:59:14" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "11:02:03" , 
"departure_time" : "11:02:32" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "11:04:29" , 
"departure_time" : "11:05:59" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "11:08:30" , 
"departure_time" : "11:09:51" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "11:10:21" , 
"departure_time" : "11:11:19" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "11:12:58" , 
"departure_time" : "11:14:07" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 95,
"arrival_time" : "11:15:09" , 
"departure_time" : "11:16:38" , 
"distance_traveled" : 18.4206
}, 
{ 
"stop_id" : 89,
"arrival_time" : "11:18:29" , 
"departure_time" : "11:20:06" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "11:28:37" , 
"departure_time" : "11:28:37" , 
"distance_traveled" : 19.943
} ], 
"301" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "11:29:00" , 
"departure_time" : "11:31:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:39:06" , 
"departure_time" : "11:40:44" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "11:50:38" , 
"departure_time" : "11:52:14" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "11:57:36" , 
"departure_time" : "11:57:53" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "11:58:17" , 
"departure_time" : "11:58:51" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "12:01:34" , 
"departure_time" : "12:01:42" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "12:04:08" , 
"departure_time" : "12:04:13" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "12:07:05" , 
"departure_time" : "12:08:42" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "12:10:37" , 
"departure_time" : "12:11:32" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "12:12:55" , 
"departure_time" : "12:14:29" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 95,
"arrival_time" : "12:15:34" , 
"departure_time" : "12:15:57" , 
"distance_traveled" : 18.4206
}, 
{ 
"stop_id" : 89,
"arrival_time" : "12:17:23" , 
"departure_time" : "12:17:44" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "12:25:21" , 
"departure_time" : "12:25:21" , 
"distance_traveled" : 19.943
} ], 
"302" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "11:29:00" , 
"departure_time" : "11:29:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:38:21" , 
"departure_time" : "11:39:02" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "11:49:41" , 
"departure_time" : "11:49:47" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "11:56:06" , 
"departure_time" : "11:56:45" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "11:58:39" , 
"departure_time" : "11:59:55" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "12:02:16" , 
"departure_time" : "12:03:21" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "12:05:05" , 
"departure_time" : "12:06:10" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "12:08:05" , 
"departure_time" : "12:09:22" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "12:10:17" , 
"departure_time" : "12:11:57" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "12:13:40" , 
"departure_time" : "12:15:08" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 95,
"arrival_time" : "12:15:28" , 
"departure_time" : "12:16:27" , 
"distance_traveled" : 18.4206
}, 
{ 
"stop_id" : 89,
"arrival_time" : "12:17:59" , 
"departure_time" : "12:18:18" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "12:25:19" , 
"departure_time" : "12:25:19" , 
"distance_traveled" : 19.943
} ], 
"303" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "12:29:00" , 
"departure_time" : "12:29:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:38:25" , 
"departure_time" : "12:39:34" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "12:50:09" , 
"departure_time" : "12:50:44" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "12:56:35" , 
"departure_time" : "12:57:13" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "12:58:38" , 
"departure_time" : "12:58:42" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "13:01:04" , 
"departure_time" : "13:01:53" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "13:04:49" , 
"departure_time" : "13:05:14" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "13:07:25" , 
"departure_time" : "13:08:40" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "13:10:15" , 
"departure_time" : "13:10:45" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "13:12:30" , 
"departure_time" : "13:13:33" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 95,
"arrival_time" : "13:15:03" , 
"departure_time" : "13:15:25" , 
"distance_traveled" : 18.4206
}, 
{ 
"stop_id" : 89,
"arrival_time" : "13:17:22" , 
"departure_time" : "13:18:46" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "13:26:24" , 
"departure_time" : "13:26:24" , 
"distance_traveled" : 19.943
} ], 
"304" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "12:29:00" , 
"departure_time" : "12:31:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:39:02" , 
"departure_time" : "12:39:23" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "12:49:21" , 
"departure_time" : "12:49:27" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "12:56:06" , 
"departure_time" : "12:56:34" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "12:58:28" , 
"departure_time" : "12:59:06" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "13:01:38" , 
"departure_time" : "13:02:02" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "13:04:24" , 
"departure_time" : "13:05:14" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "13:07:50" , 
"departure_time" : "13:09:07" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "13:10:17" , 
"departure_time" : "13:11:20" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "13:13:03" , 
"departure_time" : "13:13:45" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 95,
"arrival_time" : "13:14:42" , 
"departure_time" : "13:15:44" , 
"distance_traveled" : 18.4206
}, 
{ 
"stop_id" : 89,
"arrival_time" : "13:18:02" , 
"departure_time" : "13:18:42" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "13:25:40" , 
"departure_time" : "13:25:40" , 
"distance_traveled" : 19.943
} ], 
"305" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "13:29:00" , 
"departure_time" : "13:29:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:38:10" , 
"departure_time" : "13:38:12" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "13:49:02" , 
"departure_time" : "13:49:54" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "13:56:52" , 
"departure_time" : "13:58:02" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "13:59:10" , 
"departure_time" : "13:59:54" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "14:01:44" , 
"departure_time" : "14:03:06" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "14:05:22" , 
"departure_time" : "14:06:12" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "14:07:50" , 
"departure_time" : "14:08:06" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "14:09:16" , 
"departure_time" : "14:09:38" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "14:12:22" , 
"departure_time" : "14:12:26" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 95,
"arrival_time" : "14:14:04" , 
"departure_time" : "14:14:22" , 
"distance_traveled" : 18.4206
}, 
{ 
"stop_id" : 89,
"arrival_time" : "14:17:18" , 
"departure_time" : "14:18:22" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "14:28:04" , 
"departure_time" : "14:28:04" , 
"distance_traveled" : 19.943
} ], 
"306" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "13:29:00" , 
"departure_time" : "13:31:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:39:13" , 
"departure_time" : "13:40:39" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "13:50:26" , 
"departure_time" : "13:51:08" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "13:56:42" , 
"departure_time" : "13:57:17" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "13:58:35" , 
"departure_time" : "13:58:43" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "14:01:08" , 
"departure_time" : "14:02:09" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "14:05:01" , 
"departure_time" : "14:06:26" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "14:08:25" , 
"departure_time" : "14:09:16" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "14:09:51" , 
"departure_time" : "14:11:28" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "14:13:37" , 
"departure_time" : "14:14:46" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 95,
"arrival_time" : "14:15:09" , 
"departure_time" : "14:16:48" , 
"distance_traveled" : 18.4206
}, 
{ 
"stop_id" : 89,
"arrival_time" : "14:18:39" , 
"departure_time" : "14:19:25" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "14:27:46" , 
"departure_time" : "14:27:46" , 
"distance_traveled" : 19.943
} ], 
"307" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "14:51:00" , 
"departure_time" : "14:52:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:02:00" , 
"departure_time" : "15:02:46" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:11:46" , 
"departure_time" : "15:13:03" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "15:19:17" , 
"departure_time" : "15:19:31" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "15:20:14" , 
"departure_time" : "15:21:28" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "15:24:14" , 
"departure_time" : "15:24:35" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "15:26:21" , 
"departure_time" : "15:26:52" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "15:29:31" , 
"departure_time" : "15:30:20" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "15:31:49" , 
"departure_time" : "15:32:48" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "15:34:59" , 
"departure_time" : "15:35:57" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 95,
"arrival_time" : "15:36:58" , 
"departure_time" : "15:37:19" , 
"distance_traveled" : 18.4206
}, 
{ 
"stop_id" : 89,
"arrival_time" : "15:39:21" , 
"departure_time" : "15:40:46" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "15:45:25" , 
"departure_time" : "15:45:25" , 
"distance_traveled" : 19.943
} ], 
"308" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "14:51:00" , 
"departure_time" : "14:52:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:01:21" , 
"departure_time" : "15:02:41" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:12:20" , 
"departure_time" : "15:12:48" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "15:18:28" , 
"departure_time" : "15:18:37" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "15:20:09" , 
"departure_time" : "15:20:32" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "15:23:23" , 
"departure_time" : "15:24:57" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "15:27:34" , 
"departure_time" : "15:28:24" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "15:29:50" , 
"departure_time" : "15:31:24" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "15:32:34" , 
"departure_time" : "15:33:25" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "15:34:51" , 
"departure_time" : "15:35:28" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 95,
"arrival_time" : "15:36:37" , 
"departure_time" : "15:36:42" , 
"distance_traveled" : 18.4206
}, 
{ 
"stop_id" : 89,
"arrival_time" : "15:39:05" , 
"departure_time" : "15:40:39" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "15:45:34" , 
"departure_time" : "15:45:34" , 
"distance_traveled" : 19.943
} ], 
"309" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:47:00" , 
"departure_time" : "15:49:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:58:07" , 
"departure_time" : "15:58:24" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:07:17" , 
"departure_time" : "16:08:03" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "16:13:46" , 
"departure_time" : "16:14:01" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "16:16:15" , 
"departure_time" : "16:17:09" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "16:18:54" , 
"departure_time" : "16:19:30" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "16:21:36" , 
"departure_time" : "16:23:05" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "16:26:29" , 
"departure_time" : "16:28:06" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "16:28:37" , 
"departure_time" : "16:29:08" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "16:30:31" , 
"departure_time" : "16:30:43" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 95,
"arrival_time" : "16:32:12" , 
"departure_time" : "16:33:04" , 
"distance_traveled" : 18.4206
}, 
{ 
"stop_id" : 89,
"arrival_time" : "16:35:52" , 
"departure_time" : "16:36:51" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "16:38:59" , 
"departure_time" : "16:38:59" , 
"distance_traveled" : 19.943
} ], 
"310" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:47:00" , 
"departure_time" : "15:48:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:57:17" , 
"departure_time" : "15:58:57" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:08:40" , 
"departure_time" : "16:09:37" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "16:13:57" , 
"departure_time" : "16:15:01" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "16:17:04" , 
"departure_time" : "16:17:15" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "16:18:11" , 
"departure_time" : "16:18:39" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "16:21:28" , 
"departure_time" : "16:21:33" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "16:25:05" , 
"departure_time" : "16:25:30" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "16:27:25" , 
"departure_time" : "16:27:54" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "16:30:29" , 
"departure_time" : "16:31:22" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 95,
"arrival_time" : "16:32:53" , 
"departure_time" : "16:33:07" , 
"distance_traveled" : 18.4206
}, 
{ 
"stop_id" : 89,
"arrival_time" : "16:35:14" , 
"departure_time" : "16:35:25" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "16:38:11" , 
"departure_time" : "16:38:11" , 
"distance_traveled" : 19.943
} ], 
"311" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:41:00" , 
"departure_time" : "18:42:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:52:14" , 
"departure_time" : "18:52:35" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:01:21" , 
"departure_time" : "19:01:47" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "19:08:26" , 
"departure_time" : "19:09:08" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "19:11:42" , 
"departure_time" : "19:12:14" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "19:14:32" , 
"departure_time" : "19:14:38" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "19:17:06" , 
"departure_time" : "19:17:37" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "19:21:31" , 
"departure_time" : "19:23:07" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "19:24:36" , 
"departure_time" : "19:24:49" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "19:26:13" , 
"departure_time" : "19:26:42" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 95,
"arrival_time" : "19:29:29" , 
"departure_time" : "19:30:42" , 
"distance_traveled" : 18.4206
}, 
{ 
"stop_id" : 89,
"arrival_time" : "19:32:13" , 
"departure_time" : "19:32:18" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "19:35:05" , 
"departure_time" : "19:35:05" , 
"distance_traveled" : 19.943
} ], 
"312" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:41:00" , 
"departure_time" : "18:41:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:51:29" , 
"departure_time" : "18:52:00" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:01:31" , 
"departure_time" : "19:02:53" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "19:09:22" , 
"departure_time" : "19:10:27" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "19:12:05" , 
"departure_time" : "19:12:50" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "19:14:45" , 
"departure_time" : "19:15:14" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "19:17:29" , 
"departure_time" : "19:18:43" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "19:22:14" , 
"departure_time" : "19:22:58" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "19:23:44" , 
"departure_time" : "19:24:30" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "19:26:46" , 
"departure_time" : "19:28:00" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 95,
"arrival_time" : "19:30:14" , 
"departure_time" : "19:31:04" , 
"distance_traveled" : 18.4206
}, 
{ 
"stop_id" : 89,
"arrival_time" : "19:31:50" , 
"departure_time" : "19:32:46" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "19:35:56" , 
"departure_time" : "19:35:56" , 
"distance_traveled" : 19.943
} ], 
"313" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:37:00" , 
"departure_time" : "19:39:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:48:18" , 
"departure_time" : "19:49:21" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:57:03" , 
"departure_time" : "19:58:02" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "20:02:59" , 
"departure_time" : "20:03:08" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "20:05:09" , 
"departure_time" : "20:06:15" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "20:09:06" , 
"departure_time" : "20:10:45" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "20:12:39" , 
"departure_time" : "20:13:40" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "20:15:01" , 
"departure_time" : "20:15:38" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "20:17:37" , 
"departure_time" : "20:17:38" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "20:20:01" , 
"departure_time" : "20:21:01" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 95,
"arrival_time" : "20:23:00" , 
"departure_time" : "20:23:40" , 
"distance_traveled" : 18.4206
}, 
{ 
"stop_id" : 89,
"arrival_time" : "20:25:40" , 
"departure_time" : "20:26:09" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "20:29:29" , 
"departure_time" : "20:29:29" , 
"distance_traveled" : 19.943
} ], 
"314" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:37:00" , 
"departure_time" : "19:38:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:47:42" , 
"departure_time" : "19:48:21" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:56:39" , 
"departure_time" : "19:57:39" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "20:03:00" , 
"departure_time" : "20:04:00" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "20:06:00" , 
"departure_time" : "20:06:02" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "20:08:02" , 
"departure_time" : "20:08:20" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "20:11:18" , 
"departure_time" : "20:11:59" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "20:14:41" , 
"departure_time" : "20:14:47" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "20:17:06" , 
"departure_time" : "20:17:38" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "20:20:32" , 
"departure_time" : "20:20:35" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 95,
"arrival_time" : "20:22:03" , 
"departure_time" : "20:23:24" , 
"distance_traveled" : 18.4206
}, 
{ 
"stop_id" : 89,
"arrival_time" : "20:26:21" , 
"departure_time" : "20:26:47" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "20:29:26" , 
"departure_time" : "20:29:26" , 
"distance_traveled" : 19.943
} ], 
"315" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:35:00" , 
"departure_time" : "20:36:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:44:44" , 
"departure_time" : "20:46:00" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "20:55:16" , 
"departure_time" : "20:56:11" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "21:00:55" , 
"departure_time" : "21:02:05" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "21:04:10" , 
"departure_time" : "21:05:41" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "21:07:31" , 
"departure_time" : "21:07:52" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "21:09:21" , 
"departure_time" : "21:10:00" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "21:12:39" , 
"departure_time" : "21:13:50" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "21:16:11" , 
"departure_time" : "21:17:18" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "21:19:07" , 
"departure_time" : "21:20:21" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 95,
"arrival_time" : "21:21:14" , 
"departure_time" : "21:21:51" , 
"distance_traveled" : 18.4206
}, 
{ 
"stop_id" : 89,
"arrival_time" : "21:23:37" , 
"departure_time" : "21:24:35" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "21:26:58" , 
"departure_time" : "21:26:58" , 
"distance_traveled" : 19.943
} ], 
"316" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:35:00" , 
"departure_time" : "20:36:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:44:04" , 
"departure_time" : "20:44:48" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "20:54:44" , 
"departure_time" : "20:55:52" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "21:01:08" , 
"departure_time" : "21:02:21" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "21:04:13" , 
"departure_time" : "21:05:31" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "21:07:18" , 
"departure_time" : "21:07:55" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "21:09:37" , 
"departure_time" : "21:11:16" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "21:13:39" , 
"departure_time" : "21:14:38" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "21:15:59" , 
"departure_time" : "21:16:07" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "21:18:08" , 
"departure_time" : "21:19:00" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 95,
"arrival_time" : "21:20:52" , 
"departure_time" : "21:22:14" , 
"distance_traveled" : 18.4206
}, 
{ 
"stop_id" : 89,
"arrival_time" : "21:24:22" , 
"departure_time" : "21:25:14" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "21:26:52" , 
"departure_time" : "21:26:52" , 
"distance_traveled" : 19.943
} ], 
"317" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "21:32:00" , 
"departure_time" : "21:33:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:42:36" , 
"departure_time" : "21:43:57" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "21:53:21" , 
"departure_time" : "21:54:30" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "21:59:09" , 
"departure_time" : "21:59:55" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "22:00:46" , 
"departure_time" : "22:00:50" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "22:03:04" , 
"departure_time" : "22:04:28" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "22:07:24" , 
"departure_time" : "22:09:03" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "22:10:39" , 
"departure_time" : "22:11:37" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "22:12:58" , 
"departure_time" : "22:13:53" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "22:15:55" , 
"departure_time" : "22:17:22" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 95,
"arrival_time" : "22:18:27" , 
"departure_time" : "22:19:30" , 
"distance_traveled" : 18.4206
}, 
{ 
"stop_id" : 89,
"arrival_time" : "22:21:03" , 
"departure_time" : "22:21:57" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "22:23:54" , 
"departure_time" : "22:23:54" , 
"distance_traveled" : 19.943
} ], 
"318" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "21:32:00" , 
"departure_time" : "21:34:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:43:31" , 
"departure_time" : "21:44:53" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "21:53:22" , 
"departure_time" : "21:53:26" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "21:58:04" , 
"departure_time" : "21:58:16" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "22:00:12" , 
"departure_time" : "22:01:04" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "22:03:52" , 
"departure_time" : "22:04:52" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "22:07:00" , 
"departure_time" : "22:07:22" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "22:09:22" , 
"departure_time" : "22:10:01" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "22:12:39" , 
"departure_time" : "22:13:57" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "22:16:18" , 
"departure_time" : "22:17:10" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 95,
"arrival_time" : "22:17:52" , 
"departure_time" : "22:19:14" , 
"distance_traveled" : 18.4206
}, 
{ 
"stop_id" : 89,
"arrival_time" : "22:21:22" , 
"departure_time" : "22:21:25" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "22:23:03" , 
"departure_time" : "22:23:03" , 
"distance_traveled" : 19.943
} ], 
"319" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "09:43:00" , 
"departure_time" : "09:44:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:54:17" , 
"departure_time" : "09:54:45" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "10:03:28" , 
"departure_time" : "10:04:03" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "10:10:35" , 
"departure_time" : "10:11:54" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "10:13:19" , 
"departure_time" : "10:14:07" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "10:15:48" , 
"departure_time" : "10:16:50" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "10:20:02" , 
"departure_time" : "10:21:12" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "10:23:10" , 
"departure_time" : "10:23:43" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "10:25:33" , 
"departure_time" : "10:26:35" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "10:29:02" , 
"departure_time" : "10:30:27" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 95,
"arrival_time" : "10:31:25" , 
"departure_time" : "10:32:31" , 
"distance_traveled" : 18.4206
}, 
{ 
"stop_id" : 89,
"arrival_time" : "10:33:06" , 
"departure_time" : "10:33:41" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "10:38:35" , 
"departure_time" : "10:38:35" , 
"distance_traveled" : 19.943
} ], 
"320" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "09:43:00" , 
"departure_time" : "09:43:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:53:22" , 
"departure_time" : "09:54:24" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "10:04:02" , 
"departure_time" : "10:05:33" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 154,
"arrival_time" : "10:11:31" , 
"departure_time" : "10:11:53" , 
"distance_traveled" : 13.5265
}, 
{ 
"stop_id" : 19,
"arrival_time" : "10:12:22" , 
"departure_time" : "10:12:48" , 
"distance_traveled" : 14.2254
}, 
{ 
"stop_id" : 50,
"arrival_time" : "10:15:26" , 
"departure_time" : "10:16:49" , 
"distance_traveled" : 14.8244
}, 
{ 
"stop_id" : 14,
"arrival_time" : "10:20:23" , 
"departure_time" : "10:21:23" , 
"distance_traveled" : 15.4273
}, 
{ 
"stop_id" : 152,
"arrival_time" : "10:23:00" , 
"departure_time" : "10:24:27" , 
"distance_traveled" : 16.0911
}, 
{ 
"stop_id" : 153,
"arrival_time" : "10:26:27" , 
"departure_time" : "10:27:29" , 
"distance_traveled" : 16.9515
}, 
{ 
"stop_id" : 150,
"arrival_time" : "10:29:02" , 
"departure_time" : "10:29:22" , 
"distance_traveled" : 17.9091
}, 
{ 
"stop_id" : 95,
"arrival_time" : "10:30:20" , 
"departure_time" : "10:31:54" , 
"distance_traveled" : 18.4206
}, 
{ 
"stop_id" : 89,
"arrival_time" : "10:33:34" , 
"departure_time" : "10:35:12" , 
"distance_traveled" : 19.0538
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "10:39:38" , 
"departure_time" : "10:39:38" , 
"distance_traveled" : 19.943
} ], 
"321" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "05:54:00" , 
"departure_time" : "05:55:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:11:12" , 
"departure_time" : "06:11:20" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 14,
"arrival_time" : "06:20:08" , 
"departure_time" : "06:21:32" , 
"distance_traveled" : 15.4475
}, 
{ 
"stop_id" : 89,
"arrival_time" : "06:28:24" , 
"departure_time" : "06:29:57" , 
"distance_traveled" : 18.9919
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "06:32:33" , 
"departure_time" : "06:32:33" , 
"distance_traveled" : 19.8811
} ], 
"322" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "05:54:00" , 
"departure_time" : "05:57:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:12:36" , 
"departure_time" : "06:13:22" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 14,
"arrival_time" : "06:20:46" , 
"departure_time" : "06:22:20" , 
"distance_traveled" : 15.4475
}, 
{ 
"stop_id" : 89,
"arrival_time" : "06:28:34" , 
"departure_time" : "06:29:19" , 
"distance_traveled" : 18.9919
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "06:31:45" , 
"departure_time" : "06:31:45" , 
"distance_traveled" : 19.8811
} ], 
"323" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "25:15:00" , 
"departure_time" : "25:16:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "25:32:45" , 
"departure_time" : "25:41:53" , 
"distance_traveled" : 7.7985
}, 
{ 
"stop_id" : 154,
"arrival_time" : "25:47:08" , 
"departure_time" : "25:47:28" , 
"distance_traveled" : 10.9129
}, 
{ 
"stop_id" : 19,
"arrival_time" : "25:49:20" , 
"departure_time" : "25:50:59" , 
"distance_traveled" : 11.6117
}, 
{ 
"stop_id" : 50,
"arrival_time" : "25:52:39" , 
"departure_time" : "25:53:00" , 
"distance_traveled" : 12.2108
}, 
{ 
"stop_id" : 14,
"arrival_time" : "25:54:21" , 
"departure_time" : "25:55:35" , 
"distance_traveled" : 12.8136
}, 
{ 
"stop_id" : 152,
"arrival_time" : "25:58:14" , 
"departure_time" : "25:59:50" , 
"distance_traveled" : 13.4775
}, 
{ 
"stop_id" : 153,
"arrival_time" : "26:01:36" , 
"departure_time" : "26:02:06" , 
"distance_traveled" : 14.3379
}, 
{ 
"stop_id" : 150,
"arrival_time" : "26:02:30" , 
"departure_time" : "26:03:20" , 
"distance_traveled" : 15.2955
}, 
{ 
"stop_id" : 95,
"arrival_time" : "26:04:50" , 
"departure_time" : "26:05:26" , 
"distance_traveled" : 15.807
}, 
{ 
"stop_id" : 89,
"arrival_time" : "26:06:36" , 
"departure_time" : "26:06:47" , 
"distance_traveled" : 16.4402
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "26:09:11" , 
"departure_time" : "26:09:11" , 
"distance_traveled" : 17.3294
} ], 
"324" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "20:08:00" , 
"departure_time" : "20:08:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "20:26:03" , 
"departure_time" : "20:33:15" , 
"distance_traveled" : 7.7985
}, 
{ 
"stop_id" : 154,
"arrival_time" : "20:39:12" , 
"departure_time" : "20:40:32" , 
"distance_traveled" : 10.9129
}, 
{ 
"stop_id" : 19,
"arrival_time" : "20:41:20" , 
"departure_time" : "20:42:32" , 
"distance_traveled" : 11.6117
}, 
{ 
"stop_id" : 50,
"arrival_time" : "20:44:12" , 
"departure_time" : "20:44:18" , 
"distance_traveled" : 12.2108
}, 
{ 
"stop_id" : 14,
"arrival_time" : "20:45:06" , 
"departure_time" : "20:46:31" , 
"distance_traveled" : 12.8136
}, 
{ 
"stop_id" : 152,
"arrival_time" : "20:50:25" , 
"departure_time" : "20:50:55" , 
"distance_traveled" : 13.4775
}, 
{ 
"stop_id" : 153,
"arrival_time" : "20:52:30" , 
"departure_time" : "20:53:56" , 
"distance_traveled" : 14.3379
}, 
{ 
"stop_id" : 150,
"arrival_time" : "20:55:26" , 
"departure_time" : "20:56:12" , 
"distance_traveled" : 15.2955
}, 
{ 
"stop_id" : 95,
"arrival_time" : "20:56:46" , 
"departure_time" : "20:57:23" , 
"distance_traveled" : 15.807
}, 
{ 
"stop_id" : 89,
"arrival_time" : "20:58:37" , 
"departure_time" : "20:59:58" , 
"distance_traveled" : 16.4402
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "21:02:21" , 
"departure_time" : "21:02:21" , 
"distance_traveled" : 17.3294
} ], 
"325" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "23:08:00" , 
"departure_time" : "23:10:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "23:27:03" , 
"departure_time" : "23:33:14" , 
"distance_traveled" : 7.7985
}, 
{ 
"stop_id" : 154,
"arrival_time" : "23:38:11" , 
"departure_time" : "23:39:11" , 
"distance_traveled" : 10.9129
}, 
{ 
"stop_id" : 19,
"arrival_time" : "23:41:00" , 
"departure_time" : "23:42:29" , 
"distance_traveled" : 11.6117
}, 
{ 
"stop_id" : 50,
"arrival_time" : "23:44:29" , 
"departure_time" : "23:46:01" , 
"distance_traveled" : 12.2108
}, 
{ 
"stop_id" : 14,
"arrival_time" : "23:46:32" , 
"departure_time" : "23:46:38" , 
"distance_traveled" : 12.8136
}, 
{ 
"stop_id" : 152,
"arrival_time" : "23:49:06" , 
"departure_time" : "23:49:18" , 
"distance_traveled" : 13.4775
}, 
{ 
"stop_id" : 153,
"arrival_time" : "23:52:12" , 
"departure_time" : "23:52:41" , 
"distance_traveled" : 14.3379
}, 
{ 
"stop_id" : 150,
"arrival_time" : "23:54:29" , 
"departure_time" : "23:55:13" , 
"distance_traveled" : 15.2955
}, 
{ 
"stop_id" : 95,
"arrival_time" : "23:56:44" , 
"departure_time" : "23:56:50" , 
"distance_traveled" : 15.807
}, 
{ 
"stop_id" : 89,
"arrival_time" : "23:58:06" , 
"departure_time" : "23:59:42" , 
"distance_traveled" : 16.4402
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "24:02:36" , 
"departure_time" : "24:02:36" , 
"distance_traveled" : 17.3294
} ], 
"326" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "07:05:00" , 
"departure_time" : "07:08:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:23:38" , 
"departure_time" : "07:24:36" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 154,
"arrival_time" : "07:29:58" , 
"departure_time" : "07:31:19" , 
"distance_traveled" : 13.5267
}, 
{ 
"stop_id" : 19,
"arrival_time" : "07:32:21" , 
"departure_time" : "07:33:51" , 
"distance_traveled" : 14.2256
}, 
{ 
"stop_id" : 50,
"arrival_time" : "07:35:30" , 
"departure_time" : "07:36:28" , 
"distance_traveled" : 14.8246
}, 
{ 
"stop_id" : 14,
"arrival_time" : "07:37:58" , 
"departure_time" : "07:39:12" , 
"distance_traveled" : 15.4275
}, 
{ 
"stop_id" : 152,
"arrival_time" : "07:41:14" , 
"departure_time" : "07:41:30" , 
"distance_traveled" : 16.0913
}, 
{ 
"stop_id" : 153,
"arrival_time" : "07:42:16" , 
"departure_time" : "07:43:23" , 
"distance_traveled" : 16.9517
}, 
{ 
"stop_id" : 150,
"arrival_time" : "07:46:07" , 
"departure_time" : "07:47:09" , 
"distance_traveled" : 17.9093
}, 
{ 
"stop_id" : 95,
"arrival_time" : "07:48:02" , 
"departure_time" : "07:48:36" , 
"distance_traveled" : 18.4208
}, 
{ 
"stop_id" : 89,
"arrival_time" : "07:50:34" , 
"departure_time" : "07:51:28" , 
"distance_traveled" : 19.054
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "07:54:54" , 
"departure_time" : "07:54:54" , 
"distance_traveled" : 19.9432
} ], 
"327" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "07:55:00" , 
"departure_time" : "07:56:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:12:10" , 
"departure_time" : "08:12:11" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 154,
"arrival_time" : "08:19:01" , 
"departure_time" : "08:19:49" , 
"distance_traveled" : 13.5267
}, 
{ 
"stop_id" : 19,
"arrival_time" : "08:21:48" , 
"departure_time" : "08:23:15" , 
"distance_traveled" : 14.2256
}, 
{ 
"stop_id" : 50,
"arrival_time" : "08:25:27" , 
"departure_time" : "08:25:44" , 
"distance_traveled" : 14.8246
}, 
{ 
"stop_id" : 14,
"arrival_time" : "08:27:17" , 
"departure_time" : "08:27:59" , 
"distance_traveled" : 15.4275
}, 
{ 
"stop_id" : 152,
"arrival_time" : "08:30:42" , 
"departure_time" : "08:31:02" , 
"distance_traveled" : 16.0913
}, 
{ 
"stop_id" : 153,
"arrival_time" : "08:32:20" , 
"departure_time" : "08:32:53" , 
"distance_traveled" : 16.9517
}, 
{ 
"stop_id" : 150,
"arrival_time" : "08:35:33" , 
"departure_time" : "08:36:08" , 
"distance_traveled" : 17.9093
}, 
{ 
"stop_id" : 95,
"arrival_time" : "08:37:35" , 
"departure_time" : "08:37:59" , 
"distance_traveled" : 18.4208
}, 
{ 
"stop_id" : 89,
"arrival_time" : "08:40:24" , 
"departure_time" : "08:40:46" , 
"distance_traveled" : 19.054
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "08:44:22" , 
"departure_time" : "08:44:22" , 
"distance_traveled" : 19.9432
} ], 
"328" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "09:17:00" , 
"departure_time" : "09:17:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:34:01" , 
"departure_time" : "09:34:51" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 154,
"arrival_time" : "09:41:50" , 
"departure_time" : "09:42:17" , 
"distance_traveled" : 13.5267
}, 
{ 
"stop_id" : 19,
"arrival_time" : "09:43:27" , 
"departure_time" : "09:44:41" , 
"distance_traveled" : 14.2256
}, 
{ 
"stop_id" : 50,
"arrival_time" : "09:47:14" , 
"departure_time" : "09:47:40" , 
"distance_traveled" : 14.8246
}, 
{ 
"stop_id" : 14,
"arrival_time" : "09:49:26" , 
"departure_time" : "09:50:33" , 
"distance_traveled" : 15.4275
}, 
{ 
"stop_id" : 152,
"arrival_time" : "09:53:07" , 
"departure_time" : "09:53:41" , 
"distance_traveled" : 16.0913
}, 
{ 
"stop_id" : 153,
"arrival_time" : "09:54:34" , 
"departure_time" : "09:56:00" , 
"distance_traveled" : 16.9517
}, 
{ 
"stop_id" : 150,
"arrival_time" : "09:58:26" , 
"departure_time" : "09:58:41" , 
"distance_traveled" : 17.9093
}, 
{ 
"stop_id" : 95,
"arrival_time" : "09:59:15" , 
"departure_time" : "09:59:27" , 
"distance_traveled" : 18.4208
}, 
{ 
"stop_id" : 89,
"arrival_time" : "10:02:12" , 
"departure_time" : "10:03:45" , 
"distance_traveled" : 19.054
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "10:07:33" , 
"departure_time" : "10:07:33" , 
"distance_traveled" : 19.9432
} ], 
"329" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "11:17:00" , 
"departure_time" : "11:20:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "11:34:27" , 
"departure_time" : "11:35:17" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 154,
"arrival_time" : "11:40:50" , 
"departure_time" : "11:41:51" , 
"distance_traveled" : 13.5267
}, 
{ 
"stop_id" : 19,
"arrival_time" : "11:43:01" , 
"departure_time" : "11:44:39" , 
"distance_traveled" : 14.2256
}, 
{ 
"stop_id" : 50,
"arrival_time" : "11:46:38" , 
"departure_time" : "11:47:16" , 
"distance_traveled" : 14.8246
}, 
{ 
"stop_id" : 14,
"arrival_time" : "11:48:38" , 
"departure_time" : "11:50:04" , 
"distance_traveled" : 15.4275
}, 
{ 
"stop_id" : 152,
"arrival_time" : "11:52:26" , 
"departure_time" : "11:53:43" , 
"distance_traveled" : 16.0913
}, 
{ 
"stop_id" : 153,
"arrival_time" : "11:54:17" , 
"departure_time" : "11:54:18" , 
"distance_traveled" : 16.9517
}, 
{ 
"stop_id" : 150,
"arrival_time" : "11:56:01" , 
"departure_time" : "11:56:40" , 
"distance_traveled" : 17.9093
}, 
{ 
"stop_id" : 95,
"arrival_time" : "11:58:39" , 
"departure_time" : "11:59:00" , 
"distance_traveled" : 18.4208
}, 
{ 
"stop_id" : 89,
"arrival_time" : "12:01:21" , 
"departure_time" : "12:02:40" , 
"distance_traveled" : 19.054
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "12:06:19" , 
"departure_time" : "12:06:19" , 
"distance_traveled" : 19.9432
} ], 
"330" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "13:17:00" , 
"departure_time" : "13:19:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "13:33:55" , 
"departure_time" : "13:35:26" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 154,
"arrival_time" : "13:41:31" , 
"departure_time" : "13:42:23" , 
"distance_traveled" : 13.5267
}, 
{ 
"stop_id" : 19,
"arrival_time" : "13:42:52" , 
"departure_time" : "13:43:09" , 
"distance_traveled" : 14.2256
}, 
{ 
"stop_id" : 50,
"arrival_time" : "13:45:17" , 
"departure_time" : "13:46:43" , 
"distance_traveled" : 14.8246
}, 
{ 
"stop_id" : 14,
"arrival_time" : "13:49:26" , 
"departure_time" : "13:50:21" , 
"distance_traveled" : 15.4275
}, 
{ 
"stop_id" : 152,
"arrival_time" : "13:51:55" , 
"departure_time" : "13:53:27" , 
"distance_traveled" : 16.0913
}, 
{ 
"stop_id" : 153,
"arrival_time" : "13:54:32" , 
"departure_time" : "13:54:57" , 
"distance_traveled" : 16.9517
}, 
{ 
"stop_id" : 150,
"arrival_time" : "13:56:25" , 
"departure_time" : "13:56:54" , 
"distance_traveled" : 17.9093
}, 
{ 
"stop_id" : 95,
"arrival_time" : "13:58:29" , 
"departure_time" : "13:59:46" , 
"distance_traveled" : 18.4208
}, 
{ 
"stop_id" : 89,
"arrival_time" : "14:02:17" , 
"departure_time" : "14:02:36" , 
"distance_traveled" : 19.054
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "14:05:19" , 
"departure_time" : "14:05:19" , 
"distance_traveled" : 19.9432
} ], 
"331" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "14:51:00" , 
"departure_time" : "14:52:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:08:32" , 
"departure_time" : "15:10:10" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 154,
"arrival_time" : "15:15:38" , 
"departure_time" : "15:17:13" , 
"distance_traveled" : 13.5267
}, 
{ 
"stop_id" : 19,
"arrival_time" : "15:17:35" , 
"departure_time" : "15:17:44" , 
"distance_traveled" : 14.2256
}, 
{ 
"stop_id" : 50,
"arrival_time" : "15:19:09" , 
"departure_time" : "15:19:43" , 
"distance_traveled" : 14.8246
}, 
{ 
"stop_id" : 14,
"arrival_time" : "15:22:34" , 
"departure_time" : "15:23:18" , 
"distance_traveled" : 15.4275
}, 
{ 
"stop_id" : 152,
"arrival_time" : "15:25:44" , 
"departure_time" : "15:26:26" , 
"distance_traveled" : 16.0913
}, 
{ 
"stop_id" : 153,
"arrival_time" : "15:27:42" , 
"departure_time" : "15:28:11" , 
"distance_traveled" : 16.9517
}, 
{ 
"stop_id" : 150,
"arrival_time" : "15:30:29" , 
"departure_time" : "15:31:15" , 
"distance_traveled" : 17.9093
}, 
{ 
"stop_id" : 95,
"arrival_time" : "15:32:46" , 
"departure_time" : "15:33:30" , 
"distance_traveled" : 18.4208
}, 
{ 
"stop_id" : 89,
"arrival_time" : "15:35:44" , 
"departure_time" : "15:37:12" , 
"distance_traveled" : 19.054
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "15:40:28" , 
"departure_time" : "15:40:28" , 
"distance_traveled" : 19.9432
} ], 
"332" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:44:00" , 
"departure_time" : "15:46:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:00:41" , 
"departure_time" : "16:01:27" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 154,
"arrival_time" : "16:07:46" , 
"departure_time" : "16:08:45" , 
"distance_traveled" : 13.5267
}, 
{ 
"stop_id" : 19,
"arrival_time" : "16:09:59" , 
"departure_time" : "16:10:04" , 
"distance_traveled" : 14.2256
}, 
{ 
"stop_id" : 50,
"arrival_time" : "16:12:05" , 
"departure_time" : "16:13:44" , 
"distance_traveled" : 14.8246
}, 
{ 
"stop_id" : 14,
"arrival_time" : "16:16:39" , 
"departure_time" : "16:18:10" , 
"distance_traveled" : 15.4275
}, 
{ 
"stop_id" : 152,
"arrival_time" : "16:19:31" , 
"departure_time" : "16:21:05" , 
"distance_traveled" : 16.0913
}, 
{ 
"stop_id" : 153,
"arrival_time" : "16:21:34" , 
"departure_time" : "16:21:52" , 
"distance_traveled" : 16.9517
}, 
{ 
"stop_id" : 150,
"arrival_time" : "16:23:18" , 
"departure_time" : "16:23:56" , 
"distance_traveled" : 17.9093
}, 
{ 
"stop_id" : 95,
"arrival_time" : "16:25:38" , 
"departure_time" : "16:26:37" , 
"distance_traveled" : 18.4208
}, 
{ 
"stop_id" : 89,
"arrival_time" : "16:28:59" , 
"departure_time" : "16:30:15" , 
"distance_traveled" : 19.054
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "16:33:16" , 
"departure_time" : "16:33:16" , 
"distance_traveled" : 19.9432
} ], 
"333" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:44:00" , 
"departure_time" : "16:46:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:01:31" , 
"departure_time" : "17:02:07" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 154,
"arrival_time" : "17:07:36" , 
"departure_time" : "17:09:15" , 
"distance_traveled" : 13.5267
}, 
{ 
"stop_id" : 19,
"arrival_time" : "17:10:39" , 
"departure_time" : "17:10:52" , 
"distance_traveled" : 14.2256
}, 
{ 
"stop_id" : 50,
"arrival_time" : "17:12:13" , 
"departure_time" : "17:12:21" , 
"distance_traveled" : 14.8246
}, 
{ 
"stop_id" : 14,
"arrival_time" : "17:15:08" , 
"departure_time" : "17:15:11" , 
"distance_traveled" : 15.4275
}, 
{ 
"stop_id" : 152,
"arrival_time" : "17:18:03" , 
"departure_time" : "17:18:39" , 
"distance_traveled" : 16.0913
}, 
{ 
"stop_id" : 153,
"arrival_time" : "17:20:36" , 
"departure_time" : "17:21:53" , 
"distance_traveled" : 16.9517
}, 
{ 
"stop_id" : 150,
"arrival_time" : "17:24:17" , 
"departure_time" : "17:25:14" , 
"distance_traveled" : 17.9093
}, 
{ 
"stop_id" : 95,
"arrival_time" : "17:25:57" , 
"departure_time" : "17:27:19" , 
"distance_traveled" : 18.4208
}, 
{ 
"stop_id" : 89,
"arrival_time" : "17:29:22" , 
"departure_time" : "17:30:22" , 
"distance_traveled" : 19.054
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "17:33:00" , 
"departure_time" : "17:33:00" , 
"distance_traveled" : 19.9432
} ], 
"334" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:48:00" , 
"departure_time" : "17:50:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:05:31" , 
"departure_time" : "18:06:16" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 154,
"arrival_time" : "18:11:45" , 
"departure_time" : "18:12:37" , 
"distance_traveled" : 13.5267
}, 
{ 
"stop_id" : 19,
"arrival_time" : "18:13:52" , 
"departure_time" : "18:15:28" , 
"distance_traveled" : 14.2256
}, 
{ 
"stop_id" : 50,
"arrival_time" : "18:17:36" , 
"departure_time" : "18:19:03" , 
"distance_traveled" : 14.8246
}, 
{ 
"stop_id" : 14,
"arrival_time" : "18:20:27" , 
"departure_time" : "18:20:52" , 
"distance_traveled" : 15.4275
}, 
{ 
"stop_id" : 152,
"arrival_time" : "18:22:25" , 
"departure_time" : "18:22:37" , 
"distance_traveled" : 16.0913
}, 
{ 
"stop_id" : 153,
"arrival_time" : "18:24:12" , 
"departure_time" : "18:25:35" , 
"distance_traveled" : 16.9517
}, 
{ 
"stop_id" : 150,
"arrival_time" : "18:28:23" , 
"departure_time" : "18:29:53" , 
"distance_traveled" : 17.9093
}, 
{ 
"stop_id" : 95,
"arrival_time" : "18:30:30" , 
"departure_time" : "18:30:39" , 
"distance_traveled" : 18.4208
}, 
{ 
"stop_id" : 89,
"arrival_time" : "18:32:09" , 
"departure_time" : "18:32:40" , 
"distance_traveled" : 19.054
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "18:36:31" , 
"departure_time" : "18:36:31" , 
"distance_traveled" : 19.9432
} ], 
"335" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:20:00" , 
"departure_time" : "19:21:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:36:47" , 
"departure_time" : "19:37:48" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 154,
"arrival_time" : "19:44:01" , 
"departure_time" : "19:44:41" , 
"distance_traveled" : 13.5267
}, 
{ 
"stop_id" : 19,
"arrival_time" : "19:45:40" , 
"departure_time" : "19:46:54" , 
"distance_traveled" : 14.2256
}, 
{ 
"stop_id" : 50,
"arrival_time" : "19:49:14" , 
"departure_time" : "19:50:02" , 
"distance_traveled" : 14.8246
}, 
{ 
"stop_id" : 14,
"arrival_time" : "19:51:48" , 
"departure_time" : "19:53:10" , 
"distance_traveled" : 15.4275
}, 
{ 
"stop_id" : 152,
"arrival_time" : "19:55:22" , 
"departure_time" : "19:55:47" , 
"distance_traveled" : 16.0913
}, 
{ 
"stop_id" : 153,
"arrival_time" : "19:56:25" , 
"departure_time" : "19:57:29" , 
"distance_traveled" : 16.9517
}, 
{ 
"stop_id" : 150,
"arrival_time" : "20:00:04" , 
"departure_time" : "20:01:05" , 
"distance_traveled" : 17.9093
}, 
{ 
"stop_id" : 95,
"arrival_time" : "20:02:01" , 
"departure_time" : "20:02:49" , 
"distance_traveled" : 18.4208
}, 
{ 
"stop_id" : 89,
"arrival_time" : "20:04:48" , 
"departure_time" : "20:06:17" , 
"distance_traveled" : 19.054
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "20:09:29" , 
"departure_time" : "20:09:29" , 
"distance_traveled" : 19.9432
} ], 
"336" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "21:20:00" , 
"departure_time" : "21:22:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "21:36:47" , 
"departure_time" : "21:36:49" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 154,
"arrival_time" : "21:43:02" , 
"departure_time" : "21:44:06" , 
"distance_traveled" : 13.5267
}, 
{ 
"stop_id" : 19,
"arrival_time" : "21:46:04" , 
"departure_time" : "21:46:43" , 
"distance_traveled" : 14.2256
}, 
{ 
"stop_id" : 50,
"arrival_time" : "21:48:39" , 
"departure_time" : "21:49:45" , 
"distance_traveled" : 14.8246
}, 
{ 
"stop_id" : 14,
"arrival_time" : "21:52:06" , 
"departure_time" : "21:53:05" , 
"distance_traveled" : 15.4275
}, 
{ 
"stop_id" : 152,
"arrival_time" : "21:54:59" , 
"departure_time" : "21:56:38" , 
"distance_traveled" : 16.0913
}, 
{ 
"stop_id" : 153,
"arrival_time" : "21:57:39" , 
"departure_time" : "21:58:27" , 
"distance_traveled" : 16.9517
}, 
{ 
"stop_id" : 150,
"arrival_time" : "21:59:48" , 
"departure_time" : "22:01:08" , 
"distance_traveled" : 17.9093
}, 
{ 
"stop_id" : 95,
"arrival_time" : "22:02:20" , 
"departure_time" : "22:03:13" , 
"distance_traveled" : 18.4208
}, 
{ 
"stop_id" : 89,
"arrival_time" : "22:04:53" , 
"departure_time" : "22:05:47" , 
"distance_traveled" : 19.054
}, 
{ 
"stop_id" : 38081,
"arrival_time" : "22:08:54" , 
"departure_time" : "22:08:54" , 
"distance_traveled" : 19.9432
} ], 
"337" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "25:15:00" , 
"departure_time" : "25:15:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "25:33:01" , 
"departure_time" : "25:41:40" , 
"distance_traveled" : 7.7985
}, 
{ 
"stop_id" : 154,
"arrival_time" : "25:47:39" , 
"departure_time" : "25:47:45" , 
"distance_traveled" : 10.9129
}, 
{ 
"stop_id" : 19,
"arrival_time" : "25:49:06" , 
"departure_time" : "25:50:37" , 
"distance_traveled" : 11.6117
}, 
{ 
"stop_id" : 50,
"arrival_time" : "25:52:31" , 
"departure_time" : "25:53:32" , 
"distance_traveled" : 12.2108
}, 
{ 
"stop_id" : 14,
"arrival_time" : "25:55:01" , 
"departure_time" : "25:55:01" , 
"distance_traveled" : 12.8136
} ], 
"338" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "20:08:00" , 
"departure_time" : "20:10:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "20:27:34" , 
"departure_time" : "20:33:40" , 
"distance_traveled" : 7.7985
}, 
{ 
"stop_id" : 154,
"arrival_time" : "20:38:06" , 
"departure_time" : "20:38:29" , 
"distance_traveled" : 10.9129
}, 
{ 
"stop_id" : 19,
"arrival_time" : "20:40:23" , 
"departure_time" : "20:40:41" , 
"distance_traveled" : 11.6117
}, 
{ 
"stop_id" : 50,
"arrival_time" : "20:43:18" , 
"departure_time" : "20:44:43" , 
"distance_traveled" : 12.2108
}, 
{ 
"stop_id" : 14,
"arrival_time" : "20:46:25" , 
"departure_time" : "20:46:25" , 
"distance_traveled" : 12.8136
} ], 
"339" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "23:08:00" , 
"departure_time" : "23:10:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "23:27:20" , 
"departure_time" : "23:34:39" , 
"distance_traveled" : 7.7985
}, 
{ 
"stop_id" : 154,
"arrival_time" : "23:39:19" , 
"departure_time" : "23:39:53" , 
"distance_traveled" : 10.9129
}, 
{ 
"stop_id" : 19,
"arrival_time" : "23:40:34" , 
"departure_time" : "23:41:20" , 
"distance_traveled" : 11.6117
}, 
{ 
"stop_id" : 50,
"arrival_time" : "23:43:46" , 
"departure_time" : "23:44:19" , 
"distance_traveled" : 12.2108
}, 
{ 
"stop_id" : 14,
"arrival_time" : "23:45:33" , 
"departure_time" : "23:45:33" , 
"distance_traveled" : 12.8136
} ], 
"340" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "06:08:00" , 
"departure_time" : "06:08:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:27:04" , 
"departure_time" : "06:27:18" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 154,
"arrival_time" : "06:33:14" , 
"departure_time" : "06:33:37" , 
"distance_traveled" : 10.8928
}, 
{ 
"stop_id" : 19,
"arrival_time" : "06:35:23" , 
"departure_time" : "06:36:32" , 
"distance_traveled" : 11.5917
}, 
{ 
"stop_id" : 50,
"arrival_time" : "06:39:09" , 
"departure_time" : "06:39:29" , 
"distance_traveled" : 12.1907
}, 
{ 
"stop_id" : 14,
"arrival_time" : "06:40:20" , 
"departure_time" : "06:40:20" , 
"distance_traveled" : 12.7936
} ], 
"341" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "08:08:00" , 
"departure_time" : "08:09:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:27:36" , 
"departure_time" : "08:34:09" , 
"distance_traveled" : 7.7985
}, 
{ 
"stop_id" : 154,
"arrival_time" : "08:38:33" , 
"departure_time" : "08:39:16" , 
"distance_traveled" : 10.9129
}, 
{ 
"stop_id" : 19,
"arrival_time" : "08:40:43" , 
"departure_time" : "08:42:19" , 
"distance_traveled" : 11.6117
}, 
{ 
"stop_id" : 50,
"arrival_time" : "08:44:36" , 
"departure_time" : "08:44:46" , 
"distance_traveled" : 12.2108
}, 
{ 
"stop_id" : 14,
"arrival_time" : "08:45:10" , 
"departure_time" : "08:45:10" , 
"distance_traveled" : 12.8136
} ], 
"342" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "10:08:00" , 
"departure_time" : "10:08:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "10:26:18" , 
"departure_time" : "10:33:13" , 
"distance_traveled" : 7.7985
}, 
{ 
"stop_id" : 154,
"arrival_time" : "10:38:55" , 
"departure_time" : "10:38:58" , 
"distance_traveled" : 10.9129
}, 
{ 
"stop_id" : 19,
"arrival_time" : "10:40:03" , 
"departure_time" : "10:41:19" , 
"distance_traveled" : 11.6117
}, 
{ 
"stop_id" : 50,
"arrival_time" : "10:44:16" , 
"departure_time" : "10:45:03" , 
"distance_traveled" : 12.2108
}, 
{ 
"stop_id" : 14,
"arrival_time" : "10:45:47" , 
"departure_time" : "10:45:47" , 
"distance_traveled" : 12.8136
} ], 
"343" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "12:08:00" , 
"departure_time" : "12:09:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "12:26:14" , 
"departure_time" : "12:33:50" , 
"distance_traveled" : 7.7985
}, 
{ 
"stop_id" : 154,
"arrival_time" : "12:39:36" , 
"departure_time" : "12:40:53" , 
"distance_traveled" : 10.9129
}, 
{ 
"stop_id" : 19,
"arrival_time" : "12:41:17" , 
"departure_time" : "12:41:30" , 
"distance_traveled" : 11.6117
}, 
{ 
"stop_id" : 50,
"arrival_time" : "12:43:13" , 
"departure_time" : "12:43:41" , 
"distance_traveled" : 12.2108
}, 
{ 
"stop_id" : 14,
"arrival_time" : "12:45:28" , 
"departure_time" : "12:45:28" , 
"distance_traveled" : 12.8136
} ], 
"344" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "14:08:00" , 
"departure_time" : "14:09:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "14:27:26" , 
"departure_time" : "14:33:40" , 
"distance_traveled" : 7.7985
}, 
{ 
"stop_id" : 154,
"arrival_time" : "14:38:14" , 
"departure_time" : "14:39:00" , 
"distance_traveled" : 10.9129
}, 
{ 
"stop_id" : 19,
"arrival_time" : "14:40:46" , 
"departure_time" : "14:42:02" , 
"distance_traveled" : 11.6117
}, 
{ 
"stop_id" : 50,
"arrival_time" : "14:44:16" , 
"departure_time" : "14:44:42" , 
"distance_traveled" : 12.2108
}, 
{ 
"stop_id" : 14,
"arrival_time" : "14:45:26" , 
"departure_time" : "14:45:26" , 
"distance_traveled" : 12.8136
} ], 
"345" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:08:00" , 
"departure_time" : "16:09:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:26:47" , 
"departure_time" : "16:33:22" , 
"distance_traveled" : 7.7985
}, 
{ 
"stop_id" : 154,
"arrival_time" : "16:38:35" , 
"departure_time" : "16:39:15" , 
"distance_traveled" : 10.9129
}, 
{ 
"stop_id" : 19,
"arrival_time" : "16:40:40" , 
"departure_time" : "16:40:52" , 
"distance_traveled" : 11.6117
}, 
{ 
"stop_id" : 50,
"arrival_time" : "16:43:12" , 
"departure_time" : "16:44:38" , 
"distance_traveled" : 12.2108
}, 
{ 
"stop_id" : 14,
"arrival_time" : "16:46:26" , 
"departure_time" : "16:46:26" , 
"distance_traveled" : 12.8136
} ], 
"346" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:08:00" , 
"departure_time" : "18:10:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:27:12" , 
"departure_time" : "18:34:12" , 
"distance_traveled" : 7.7985
}, 
{ 
"stop_id" : 154,
"arrival_time" : "18:39:00" , 
"departure_time" : "18:39:48" , 
"distance_traveled" : 10.9129
}, 
{ 
"stop_id" : 19,
"arrival_time" : "18:40:48" , 
"departure_time" : "18:41:35" , 
"distance_traveled" : 11.6117
}, 
{ 
"stop_id" : 50,
"arrival_time" : "18:43:47" , 
"departure_time" : "18:44:47" , 
"distance_traveled" : 12.2108
}, 
{ 
"stop_id" : 14,
"arrival_time" : "18:46:00" , 
"departure_time" : "18:46:00" , 
"distance_traveled" : 12.8136
} ], 
"347" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "06:09:00" , 
"departure_time" : "06:11:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "06:12:27" , 
"departure_time" : "06:13:27" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "06:14:00" , 
"departure_time" : "06:14:17" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "06:15:17" , 
"departure_time" : "06:15:26" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "06:17:09" , 
"departure_time" : "06:18:01" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "06:18:52" , 
"departure_time" : "06:19:57" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:22:05" , 
"departure_time" : "06:23:32" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:25:27" , 
"departure_time" : "06:25:40" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:25:13" , 
"departure_time" : "06:26:02" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:27:49" , 
"departure_time" : "06:28:41" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:29:52" , 
"departure_time" : "06:31:27" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:32:35" , 
"departure_time" : "06:32:50" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:33:15" , 
"departure_time" : "06:34:23" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:37:08" , 
"departure_time" : "06:38:19" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "06:41:11" , 
"departure_time" : "06:41:11" , 
"distance_traveled" : 9.0456
} ], 
"348" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "06:29:00" , 
"departure_time" : "06:31:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "06:32:23" , 
"departure_time" : "06:33:02" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "06:33:39" , 
"departure_time" : "06:35:03" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "06:36:24" , 
"departure_time" : "06:36:59" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "06:37:35" , 
"departure_time" : "06:38:32" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "06:38:57" , 
"departure_time" : "06:39:28" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:41:31" , 
"departure_time" : "06:42:15" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:44:44" , 
"departure_time" : "06:45:05" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:45:21" , 
"departure_time" : "06:46:44" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:48:23" , 
"departure_time" : "06:48:43" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:49:20" , 
"departure_time" : "06:49:49" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:51:29" , 
"departure_time" : "06:52:41" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:54:12" , 
"departure_time" : "06:55:01" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:56:49" , 
"departure_time" : "06:57:16" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "07:00:27" , 
"departure_time" : "07:00:27" , 
"distance_traveled" : 9.0456
} ], 
"349" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "06:49:00" , 
"departure_time" : "06:50:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "06:52:27" , 
"departure_time" : "06:53:32" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "06:54:05" , 
"departure_time" : "06:54:51" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "06:55:46" , 
"departure_time" : "06:57:06" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "06:58:20" , 
"departure_time" : "06:59:05" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "06:58:45" , 
"departure_time" : "06:59:10" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:01:25" , 
"departure_time" : "07:01:46" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:04:21" , 
"departure_time" : "07:05:27" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:06:06" , 
"departure_time" : "07:06:11" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:07:05" , 
"departure_time" : "07:07:31" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:09:26" , 
"departure_time" : "07:10:17" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:11:51" , 
"departure_time" : "07:12:42" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:13:51" , 
"departure_time" : "07:15:02" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:17:11" , 
"departure_time" : "07:18:12" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "07:21:01" , 
"departure_time" : "07:21:01" , 
"distance_traveled" : 9.0456
} ], 
"350" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "07:09:00" , 
"departure_time" : "07:10:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "07:11:13" , 
"departure_time" : "07:11:57" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "07:13:44" , 
"departure_time" : "07:14:30" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "07:15:46" , 
"departure_time" : "07:16:45" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "07:17:59" , 
"departure_time" : "07:18:28" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "07:18:29" , 
"departure_time" : "07:18:32" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:21:03" , 
"departure_time" : "07:22:34" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:25:31" , 
"departure_time" : "07:25:44" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:25:13" , 
"departure_time" : "07:25:25" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:27:12" , 
"departure_time" : "07:28:08" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:29:56" , 
"departure_time" : "07:30:04" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:31:08" , 
"departure_time" : "07:32:35" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:34:27" , 
"departure_time" : "07:35:30" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:37:03" , 
"departure_time" : "07:37:23" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "07:40:20" , 
"departure_time" : "07:40:20" , 
"distance_traveled" : 9.0456
} ], 
"351" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "07:29:00" , 
"departure_time" : "07:30:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "07:31:45" , 
"departure_time" : "07:31:46" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "07:33:01" , 
"departure_time" : "07:33:46" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "07:35:45" , 
"departure_time" : "07:37:05" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "07:38:20" , 
"departure_time" : "07:39:17" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "07:38:57" , 
"departure_time" : "07:39:07" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:41:10" , 
"departure_time" : "07:42:36" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:45:26" , 
"departure_time" : "07:46:13" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:45:47" , 
"departure_time" : "07:46:36" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:47:49" , 
"departure_time" : "07:48:40" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:49:51" , 
"departure_time" : "07:50:19" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:51:28" , 
"departure_time" : "07:51:29" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:53:01" , 
"departure_time" : "07:54:24" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:57:23" , 
"departure_time" : "07:58:38" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "08:01:15" , 
"departure_time" : "08:01:15" , 
"distance_traveled" : 9.0456
} ], 
"352" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "07:49:00" , 
"departure_time" : "07:50:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "07:51:43" , 
"departure_time" : "07:52:27" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "07:53:44" , 
"departure_time" : "07:53:56" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "07:55:12" , 
"departure_time" : "07:55:41" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "07:57:29" , 
"departure_time" : "07:58:15" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "07:58:46" , 
"departure_time" : "07:58:52" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:01:06" , 
"departure_time" : "08:01:13" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:04:07" , 
"departure_time" : "08:05:30" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:06:23" , 
"departure_time" : "08:07:29" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:08:06" , 
"departure_time" : "08:08:17" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:09:11" , 
"departure_time" : "08:09:49" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:11:38" , 
"departure_time" : "08:11:46" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:13:08" , 
"departure_time" : "08:13:26" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:16:18" , 
"departure_time" : "08:17:37" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "08:21:19" , 
"departure_time" : "08:21:19" , 
"distance_traveled" : 9.0456
} ], 
"353" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "08:09:00" , 
"departure_time" : "08:11:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "08:11:42" , 
"departure_time" : "08:12:55" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "08:14:13" , 
"departure_time" : "08:15:15" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "08:16:02" , 
"departure_time" : "08:16:13" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "08:17:11" , 
"departure_time" : "08:18:24" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "08:19:13" , 
"departure_time" : "08:19:14" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:21:01" , 
"departure_time" : "08:22:06" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:25:05" , 
"departure_time" : "08:25:52" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:25:47" , 
"departure_time" : "08:26:56" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:28:09" , 
"departure_time" : "08:29:14" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:30:05" , 
"departure_time" : "08:30:26" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:31:21" , 
"departure_time" : "08:32:43" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:34:22" , 
"departure_time" : "08:35:28" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:37:06" , 
"departure_time" : "08:38:01" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "08:40:55" , 
"departure_time" : "08:40:55" , 
"distance_traveled" : 9.0456
} ], 
"354" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "08:29:00" , 
"departure_time" : "08:30:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "08:31:09" , 
"departure_time" : "08:32:49" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "08:34:40" , 
"departure_time" : "08:35:16" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "08:35:36" , 
"departure_time" : "08:36:27" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "08:37:51" , 
"departure_time" : "08:38:35" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "08:38:44" , 
"departure_time" : "08:38:59" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:41:15" , 
"departure_time" : "08:41:58" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:44:43" , 
"departure_time" : "08:45:16" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:45:33" , 
"departure_time" : "08:45:56" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:47:23" , 
"departure_time" : "08:47:59" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:49:36" , 
"departure_time" : "08:49:54" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:51:18" , 
"departure_time" : "08:52:47" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:54:29" , 
"departure_time" : "08:55:17" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:56:48" , 
"departure_time" : "08:58:03" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "09:01:15" , 
"departure_time" : "09:01:15" , 
"distance_traveled" : 9.0456
} ], 
"355" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "08:49:00" , 
"departure_time" : "08:50:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "08:51:26" , 
"departure_time" : "08:51:43" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "08:53:17" , 
"departure_time" : "08:54:28" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "08:56:11" , 
"departure_time" : "08:56:48" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "08:57:37" , 
"departure_time" : "08:58:26" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "08:58:49" , 
"departure_time" : "08:59:12" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:01:23" , 
"departure_time" : "09:02:09" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:04:46" , 
"departure_time" : "09:05:18" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:05:32" , 
"departure_time" : "09:06:07" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:07:35" , 
"departure_time" : "09:08:11" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:09:36" , 
"departure_time" : "09:11:08" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:12:32" , 
"departure_time" : "09:12:42" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:13:10" , 
"departure_time" : "09:13:59" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:16:49" , 
"departure_time" : "09:18:11" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "09:21:22" , 
"departure_time" : "09:21:22" , 
"distance_traveled" : 9.0456
} ], 
"356" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "09:09:00" , 
"departure_time" : "09:11:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "09:12:31" , 
"departure_time" : "09:13:34" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "09:14:03" , 
"departure_time" : "09:14:22" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "09:15:19" , 
"departure_time" : "09:15:20" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "09:17:01" , 
"departure_time" : "09:18:27" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "09:19:26" , 
"departure_time" : "09:20:53" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:22:27" , 
"departure_time" : "09:23:49" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:25:22" , 
"departure_time" : "09:26:33" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:26:11" , 
"departure_time" : "09:26:41" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:27:30" , 
"departure_time" : "09:28:01" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:29:31" , 
"departure_time" : "09:29:57" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:31:26" , 
"departure_time" : "09:32:38" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:34:12" , 
"departure_time" : "09:34:39" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:36:27" , 
"departure_time" : "09:38:02" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "09:41:35" , 
"departure_time" : "09:41:35" , 
"distance_traveled" : 9.0456
} ], 
"357" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "09:29:00" , 
"departure_time" : "09:30:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "09:31:18" , 
"departure_time" : "09:32:10" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "09:33:52" , 
"departure_time" : "09:34:26" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "09:35:34" , 
"departure_time" : "09:35:42" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "09:37:08" , 
"departure_time" : "09:38:15" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "09:39:07" , 
"departure_time" : "09:40:10" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:42:03" , 
"departure_time" : "09:43:00" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:44:57" , 
"departure_time" : "09:46:31" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:46:34" , 
"departure_time" : "09:47:46" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:48:12" , 
"departure_time" : "09:49:28" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:50:16" , 
"departure_time" : "09:50:56" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:51:40" , 
"departure_time" : "09:52:37" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:53:57" , 
"departure_time" : "09:54:17" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:56:20" , 
"departure_time" : "09:56:30" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "10:00:10" , 
"departure_time" : "10:00:10" , 
"distance_traveled" : 9.0456
} ], 
"358" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "09:49:00" , 
"departure_time" : "09:50:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "09:52:21" , 
"departure_time" : "09:53:22" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "09:54:01" , 
"departure_time" : "09:54:12" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "09:55:11" , 
"departure_time" : "09:55:24" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "09:57:13" , 
"departure_time" : "09:57:23" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "09:58:10" , 
"departure_time" : "09:58:18" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:01:08" , 
"departure_time" : "10:01:23" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:04:15" , 
"departure_time" : "10:04:22" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:05:07" , 
"departure_time" : "10:06:00" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:07:53" , 
"departure_time" : "10:08:39" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:09:46" , 
"departure_time" : "10:10:06" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:11:20" , 
"departure_time" : "10:12:49" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:14:29" , 
"departure_time" : "10:15:54" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:17:25" , 
"departure_time" : "10:18:26" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "10:21:01" , 
"departure_time" : "10:21:01" , 
"distance_traveled" : 9.0456
} ], 
"359" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "10:09:00" , 
"departure_time" : "10:10:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "10:11:12" , 
"departure_time" : "10:12:08" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "10:13:56" , 
"departure_time" : "10:14:42" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "10:15:46" , 
"departure_time" : "10:17:13" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "10:18:27" , 
"departure_time" : "10:18:41" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "10:18:14" , 
"departure_time" : "10:19:08" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:21:54" , 
"departure_time" : "10:22:46" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:24:52" , 
"departure_time" : "10:25:01" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:25:09" , 
"departure_time" : "10:25:11" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:27:02" , 
"departure_time" : "10:27:37" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:29:35" , 
"departure_time" : "10:31:01" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:32:26" , 
"departure_time" : "10:33:28" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:34:02" , 
"departure_time" : "10:35:18" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:37:16" , 
"departure_time" : "10:37:53" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "10:40:37" , 
"departure_time" : "10:40:37" , 
"distance_traveled" : 9.0456
} ], 
"360" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "10:29:00" , 
"departure_time" : "10:30:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "10:31:46" , 
"departure_time" : "10:32:08" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "10:33:22" , 
"departure_time" : "10:34:23" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "10:36:01" , 
"departure_time" : "10:36:11" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "10:37:10" , 
"departure_time" : "10:37:56" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "10:38:46" , 
"departure_time" : "10:39:39" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:41:53" , 
"departure_time" : "10:42:12" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:44:19" , 
"departure_time" : "10:45:00" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:45:41" , 
"departure_time" : "10:46:31" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:47:50" , 
"departure_time" : "10:49:24" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:50:34" , 
"departure_time" : "10:51:54" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:52:20" , 
"departure_time" : "10:53:29" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:54:09" , 
"departure_time" : "10:55:09" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:57:00" , 
"departure_time" : "10:57:36" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "11:00:36" , 
"departure_time" : "11:00:36" , 
"distance_traveled" : 9.0456
} ], 
"361" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "10:49:00" , 
"departure_time" : "10:50:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "10:51:44" , 
"departure_time" : "10:52:22" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "10:53:38" , 
"departure_time" : "10:53:50" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "10:55:12" , 
"departure_time" : "10:55:51" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "10:57:39" , 
"departure_time" : "10:58:36" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "10:58:57" , 
"departure_time" : "10:59:41" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:01:44" , 
"departure_time" : "11:02:54" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:05:10" , 
"departure_time" : "11:05:58" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:05:48" , 
"departure_time" : "11:07:08" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:08:20" , 
"departure_time" : "11:09:49" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:10:29" , 
"departure_time" : "11:11:50" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:12:21" , 
"departure_time" : "11:13:37" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:14:16" , 
"departure_time" : "11:15:00" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:16:44" , 
"departure_time" : "11:17:11" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "11:20:27" , 
"departure_time" : "11:20:27" , 
"distance_traveled" : 9.0456
} ], 
"362" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "11:09:00" , 
"departure_time" : "11:10:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "11:12:07" , 
"departure_time" : "11:12:27" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "11:13:20" , 
"departure_time" : "11:14:02" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "11:15:42" , 
"departure_time" : "11:16:41" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "11:17:59" , 
"departure_time" : "11:18:15" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "11:18:16" , 
"departure_time" : "11:18:34" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:21:18" , 
"departure_time" : "11:21:36" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:24:18" , 
"departure_time" : "11:25:50" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:26:32" , 
"departure_time" : "11:27:45" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:28:13" , 
"departure_time" : "11:29:30" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:30:17" , 
"departure_time" : "11:30:20" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:31:03" , 
"departure_time" : "11:32:33" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:34:30" , 
"departure_time" : "11:36:04" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:37:34" , 
"departure_time" : "11:39:11" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "11:41:37" , 
"departure_time" : "11:41:37" , 
"distance_traveled" : 9.0456
} ], 
"363" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "11:29:00" , 
"departure_time" : "11:30:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "11:31:07" , 
"departure_time" : "11:31:30" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "11:33:23" , 
"departure_time" : "11:33:28" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "11:35:05" , 
"departure_time" : "11:35:13" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "11:37:08" , 
"departure_time" : "11:38:26" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "11:39:18" , 
"departure_time" : "11:39:47" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:41:29" , 
"departure_time" : "11:41:35" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:44:06" , 
"departure_time" : "11:44:32" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:45:26" , 
"departure_time" : "11:45:43" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:47:17" , 
"departure_time" : "11:47:36" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:49:19" , 
"departure_time" : "11:50:13" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:51:54" , 
"departure_time" : "11:52:57" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:54:03" , 
"departure_time" : "11:54:23" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:56:20" , 
"departure_time" : "11:57:20" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "12:01:00" , 
"departure_time" : "12:01:00" , 
"distance_traveled" : 9.0456
} ], 
"364" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "11:49:00" , 
"departure_time" : "11:51:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "11:52:30" , 
"departure_time" : "11:53:59" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "11:54:29" , 
"departure_time" : "11:56:07" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "11:56:38" , 
"departure_time" : "11:58:00" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "11:58:22" , 
"departure_time" : "11:59:44" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "11:59:22" , 
"departure_time" : "11:59:24" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:01:02" , 
"departure_time" : "12:02:08" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:05:06" , 
"departure_time" : "12:05:15" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:05:09" , 
"departure_time" : "12:05:54" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:07:45" , 
"departure_time" : "12:07:55" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:09:10" , 
"departure_time" : "12:09:19" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:11:09" , 
"departure_time" : "12:12:08" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:13:59" , 
"departure_time" : "12:15:24" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:17:25" , 
"departure_time" : "12:17:36" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "12:20:11" , 
"departure_time" : "12:20:11" , 
"distance_traveled" : 9.0456
} ], 
"365" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "12:09:00" , 
"departure_time" : "12:09:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "12:11:44" , 
"departure_time" : "12:13:13" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "12:14:29" , 
"departure_time" : "12:15:51" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "12:16:22" , 
"departure_time" : "12:16:51" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "12:17:29" , 
"departure_time" : "12:18:25" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "12:18:56" , 
"departure_time" : "12:19:38" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:21:42" , 
"departure_time" : "12:22:49" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:25:07" , 
"departure_time" : "12:25:48" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:25:41" , 
"departure_time" : "12:26:32" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:27:51" , 
"departure_time" : "12:28:40" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:29:49" , 
"departure_time" : "12:31:26" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:32:37" , 
"departure_time" : "12:33:53" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:34:16" , 
"departure_time" : "12:35:31" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:37:15" , 
"departure_time" : "12:38:24" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "12:41:09" , 
"departure_time" : "12:41:09" , 
"distance_traveled" : 9.0456
} ], 
"366" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "12:29:00" , 
"departure_time" : "12:31:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "12:32:34" , 
"departure_time" : "12:33:45" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "12:34:11" , 
"departure_time" : "12:35:25" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "12:36:14" , 
"departure_time" : "12:36:32" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "12:37:18" , 
"departure_time" : "12:37:23" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "12:38:05" , 
"departure_time" : "12:38:57" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:41:52" , 
"departure_time" : "12:43:13" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:45:21" , 
"departure_time" : "12:45:25" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:45:04" , 
"departure_time" : "12:45:20" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:47:16" , 
"departure_time" : "12:47:47" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:49:31" , 
"departure_time" : "12:50:14" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:51:43" , 
"departure_time" : "12:52:13" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:53:30" , 
"departure_time" : "12:54:42" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:57:12" , 
"departure_time" : "12:57:48" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "13:00:36" , 
"departure_time" : "13:00:36" , 
"distance_traveled" : 9.0456
} ], 
"367" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "12:49:00" , 
"departure_time" : "12:50:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "12:51:56" , 
"departure_time" : "12:53:13" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "12:54:17" , 
"departure_time" : "12:54:21" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "12:55:04" , 
"departure_time" : "12:56:39" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "12:58:35" , 
"departure_time" : "12:59:35" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "12:59:00" , 
"departure_time" : "13:00:24" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:02:24" , 
"departure_time" : "13:03:16" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:04:52" , 
"departure_time" : "13:05:14" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:05:22" , 
"departure_time" : "13:06:58" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:08:36" , 
"departure_time" : "13:09:44" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:10:08" , 
"departure_time" : "13:11:27" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:12:19" , 
"departure_time" : "13:13:50" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:14:31" , 
"departure_time" : "13:15:49" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:17:18" , 
"departure_time" : "13:18:43" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "13:21:25" , 
"departure_time" : "13:21:25" , 
"distance_traveled" : 9.0456
} ], 
"368" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "13:09:00" , 
"departure_time" : "13:11:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "13:12:34" , 
"departure_time" : "13:13:33" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "13:13:59" , 
"departure_time" : "13:14:08" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "13:15:09" , 
"departure_time" : "13:16:41" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "13:18:32" , 
"departure_time" : "13:19:00" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "13:18:28" , 
"departure_time" : "13:19:43" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:22:15" , 
"departure_time" : "13:23:43" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:25:28" , 
"departure_time" : "13:26:08" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:25:40" , 
"departure_time" : "13:26:51" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:28:11" , 
"departure_time" : "13:28:54" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:29:43" , 
"departure_time" : "13:30:44" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:32:01" , 
"departure_time" : "13:32:53" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:33:52" , 
"departure_time" : "13:34:22" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:36:30" , 
"departure_time" : "13:37:14" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "13:40:44" , 
"departure_time" : "13:40:44" , 
"distance_traveled" : 9.0456
} ], 
"369" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "13:29:00" , 
"departure_time" : "13:30:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "13:31:45" , 
"departure_time" : "13:33:22" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "13:34:37" , 
"departure_time" : "13:35:34" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "13:35:57" , 
"departure_time" : "13:36:43" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "13:37:46" , 
"departure_time" : "13:39:15" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "13:39:29" , 
"departure_time" : "13:40:20" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:41:51" , 
"departure_time" : "13:42:36" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:44:45" , 
"departure_time" : "13:45:33" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:45:48" , 
"departure_time" : "13:45:54" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:47:06" , 
"departure_time" : "13:47:38" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:49:32" , 
"departure_time" : "13:50:41" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:52:09" , 
"departure_time" : "13:52:31" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:53:22" , 
"departure_time" : "13:54:28" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:57:06" , 
"departure_time" : "13:58:07" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "14:01:01" , 
"departure_time" : "14:01:01" , 
"distance_traveled" : 9.0456
} ], 
"370" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "13:49:00" , 
"departure_time" : "13:50:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "13:51:04" , 
"departure_time" : "13:52:28" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "13:54:24" , 
"departure_time" : "13:55:24" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "13:56:00" , 
"departure_time" : "13:56:20" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "13:57:20" , 
"departure_time" : "13:58:10" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "13:58:50" , 
"departure_time" : "13:59:30" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:01:40" , 
"departure_time" : "14:01:55" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:04:15" , 
"departure_time" : "14:05:26" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:06:11" , 
"departure_time" : "14:07:28" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:08:17" , 
"departure_time" : "14:08:41" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:09:24" , 
"departure_time" : "14:09:46" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:11:22" , 
"departure_time" : "14:11:36" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:13:14" , 
"departure_time" : "14:14:03" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:16:49" , 
"departure_time" : "14:17:33" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "14:20:44" , 
"departure_time" : "14:20:44" , 
"distance_traveled" : 9.0456
} ], 
"371" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "14:09:00" , 
"departure_time" : "14:11:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "14:12:19" , 
"departure_time" : "14:13:40" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "14:14:21" , 
"departure_time" : "14:15:39" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "14:16:18" , 
"departure_time" : "14:17:11" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "14:17:53" , 
"departure_time" : "14:19:12" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "14:19:19" , 
"departure_time" : "14:20:42" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:22:23" , 
"departure_time" : "14:22:59" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:24:36" , 
"departure_time" : "14:24:49" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:25:13" , 
"departure_time" : "14:25:30" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:27:17" , 
"departure_time" : "14:28:05" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:29:48" , 
"departure_time" : "14:30:03" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:31:15" , 
"departure_time" : "14:31:35" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:33:20" , 
"departure_time" : "14:33:26" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:36:06" , 
"departure_time" : "14:37:32" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "14:41:26" , 
"departure_time" : "14:41:26" , 
"distance_traveled" : 9.0456
} ], 
"372" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "14:29:00" , 
"departure_time" : "14:30:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "14:31:07" , 
"departure_time" : "14:32:32" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "14:34:25" , 
"departure_time" : "14:35:11" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "14:35:46" , 
"departure_time" : "14:37:18" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "14:38:32" , 
"departure_time" : "14:38:44" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "14:38:12" , 
"departure_time" : "14:38:52" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:41:40" , 
"departure_time" : "14:42:14" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:44:34" , 
"departure_time" : "14:44:35" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:45:01" , 
"departure_time" : "14:45:29" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:47:28" , 
"departure_time" : "14:48:02" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:49:34" , 
"departure_time" : "14:50:51" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:52:17" , 
"departure_time" : "14:53:15" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:53:58" , 
"departure_time" : "14:54:01" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:56:03" , 
"departure_time" : "14:57:38" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "15:01:35" , 
"departure_time" : "15:01:35" , 
"distance_traveled" : 9.0456
} ], 
"373" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "14:49:00" , 
"departure_time" : "14:50:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "14:51:17" , 
"departure_time" : "14:51:40" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "14:53:23" , 
"departure_time" : "14:54:18" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "14:55:55" , 
"departure_time" : "14:56:53" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "14:57:58" , 
"departure_time" : "14:59:36" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "14:59:38" , 
"departure_time" : "14:59:39" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:01:01" , 
"departure_time" : "15:02:07" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:05:06" , 
"departure_time" : "15:05:21" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:05:15" , 
"departure_time" : "15:05:42" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:07:27" , 
"departure_time" : "15:08:08" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:09:41" , 
"departure_time" : "15:09:47" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:11:06" , 
"departure_time" : "15:11:09" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:13:03" , 
"departure_time" : "15:14:18" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:17:15" , 
"departure_time" : "15:18:12" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "15:20:57" , 
"departure_time" : "15:20:57" , 
"distance_traveled" : 9.0456
} ], 
"374" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "15:09:00" , 
"departure_time" : "15:10:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "15:11:09" , 
"departure_time" : "15:11:22" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "15:13:13" , 
"departure_time" : "15:14:11" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "15:15:58" , 
"departure_time" : "15:16:14" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "15:17:16" , 
"departure_time" : "15:18:51" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "15:19:35" , 
"departure_time" : "15:20:06" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:21:31" , 
"departure_time" : "15:21:44" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:24:13" , 
"departure_time" : "15:24:29" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:25:16" , 
"departure_time" : "15:26:18" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:28:02" , 
"departure_time" : "15:28:22" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:29:20" , 
"departure_time" : "15:30:20" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:32:00" , 
"departure_time" : "15:32:34" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:33:34" , 
"departure_time" : "15:34:01" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:36:27" , 
"departure_time" : "15:37:05" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "15:40:38" , 
"departure_time" : "15:40:38" , 
"distance_traveled" : 9.0456
} ], 
"375" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "15:29:00" , 
"departure_time" : "15:29:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "15:31:02" , 
"departure_time" : "15:31:20" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "15:33:18" , 
"departure_time" : "15:34:05" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "15:35:47" , 
"departure_time" : "15:36:29" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "15:37:42" , 
"departure_time" : "15:39:05" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "15:39:23" , 
"departure_time" : "15:40:36" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:42:13" , 
"departure_time" : "15:43:06" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:44:53" , 
"departure_time" : "15:45:28" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:45:35" , 
"departure_time" : "15:46:27" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:47:52" , 
"departure_time" : "15:48:20" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:49:28" , 
"departure_time" : "15:49:50" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:51:22" , 
"departure_time" : "15:51:57" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:53:35" , 
"departure_time" : "15:54:06" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:56:31" , 
"departure_time" : "15:56:52" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "16:00:21" , 
"departure_time" : "16:00:21" , 
"distance_traveled" : 9.0456
} ], 
"376" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "15:49:00" , 
"departure_time" : "15:50:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "15:51:52" , 
"departure_time" : "15:52:55" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "15:54:03" , 
"departure_time" : "15:54:28" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "15:55:25" , 
"departure_time" : "15:56:12" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "15:57:47" , 
"departure_time" : "15:59:10" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "15:59:23" , 
"departure_time" : "15:59:39" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:01:16" , 
"departure_time" : "16:01:53" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:04:37" , 
"departure_time" : "16:05:30" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:05:53" , 
"departure_time" : "16:06:59" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:08:06" , 
"departure_time" : "16:09:32" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:10:26" , 
"departure_time" : "16:10:51" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:11:25" , 
"departure_time" : "16:11:27" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:13:02" , 
"departure_time" : "16:13:04" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:16:02" , 
"departure_time" : "16:17:20" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "16:21:18" , 
"departure_time" : "16:21:18" , 
"distance_traveled" : 9.0456
} ], 
"377" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "16:09:00" , 
"departure_time" : "16:10:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "16:11:04" , 
"departure_time" : "16:11:32" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "16:13:28" , 
"departure_time" : "16:14:09" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "16:15:41" , 
"departure_time" : "16:16:31" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "16:17:50" , 
"departure_time" : "16:18:09" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "16:18:19" , 
"departure_time" : "16:19:47" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:22:28" , 
"departure_time" : "16:23:09" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:24:41" , 
"departure_time" : "16:25:42" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:26:01" , 
"departure_time" : "16:26:51" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:27:50" , 
"departure_time" : "16:28:22" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:29:32" , 
"departure_time" : "16:29:57" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:31:25" , 
"departure_time" : "16:31:54" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:33:29" , 
"departure_time" : "16:33:39" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:36:10" , 
"departure_time" : "16:37:28" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "16:41:18" , 
"departure_time" : "16:41:18" , 
"distance_traveled" : 9.0456
} ], 
"378" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "16:29:00" , 
"departure_time" : "16:31:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "16:32:34" , 
"departure_time" : "16:34:05" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "16:34:31" , 
"departure_time" : "16:35:02" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "16:35:31" , 
"departure_time" : "16:35:37" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "16:37:06" , 
"departure_time" : "16:38:37" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "16:39:31" , 
"departure_time" : "16:40:25" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:41:54" , 
"departure_time" : "16:43:28" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:45:34" , 
"departure_time" : "16:47:00" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:46:26" , 
"departure_time" : "16:47:35" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:48:09" , 
"departure_time" : "16:49:05" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:49:56" , 
"departure_time" : "16:50:04" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:51:08" , 
"departure_time" : "16:52:44" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:54:36" , 
"departure_time" : "16:55:07" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:56:31" , 
"departure_time" : "16:57:17" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "17:00:46" , 
"departure_time" : "17:00:46" , 
"distance_traveled" : 9.0456
} ], 
"379" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "16:49:00" , 
"departure_time" : "16:50:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "16:52:08" , 
"departure_time" : "16:53:34" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "16:54:26" , 
"departure_time" : "16:55:17" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "16:55:51" , 
"departure_time" : "16:56:40" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "16:57:49" , 
"departure_time" : "16:58:52" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "16:59:03" , 
"departure_time" : "17:00:21" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:02:18" , 
"departure_time" : "17:03:47" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:05:29" , 
"departure_time" : "17:05:39" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:05:10" , 
"departure_time" : "17:06:45" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:08:35" , 
"departure_time" : "17:08:45" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:09:10" , 
"departure_time" : "17:10:42" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:12:32" , 
"departure_time" : "17:12:34" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:13:02" , 
"departure_time" : "17:13:07" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:16:05" , 
"departure_time" : "17:17:39" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "17:21:34" , 
"departure_time" : "17:21:34" , 
"distance_traveled" : 9.0456
} ], 
"380" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "17:09:00" , 
"departure_time" : "17:11:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "17:12:07" , 
"departure_time" : "17:12:09" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "17:13:02" , 
"departure_time" : "17:13:21" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "17:15:19" , 
"departure_time" : "17:15:35" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "17:17:16" , 
"departure_time" : "17:18:14" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "17:18:58" , 
"departure_time" : "17:19:12" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:21:14" , 
"departure_time" : "17:22:52" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:25:38" , 
"departure_time" : "17:26:18" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:25:40" , 
"departure_time" : "17:26:46" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:28:06" , 
"departure_time" : "17:29:40" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:30:34" , 
"departure_time" : "17:31:15" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:31:41" , 
"departure_time" : "17:32:14" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:33:33" , 
"departure_time" : "17:33:57" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:36:24" , 
"departure_time" : "17:37:01" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "17:40:37" , 
"departure_time" : "17:40:37" , 
"distance_traveled" : 9.0456
} ], 
"381" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "17:29:00" , 
"departure_time" : "17:29:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "17:31:19" , 
"departure_time" : "17:32:02" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "17:33:43" , 
"departure_time" : "17:34:04" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "17:35:21" , 
"departure_time" : "17:36:29" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "17:38:08" , 
"departure_time" : "17:38:11" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "17:38:03" , 
"departure_time" : "17:38:38" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:41:35" , 
"departure_time" : "17:41:48" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:44:13" , 
"departure_time" : "17:44:42" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:45:29" , 
"departure_time" : "17:47:09" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:48:40" , 
"departure_time" : "17:50:18" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:50:38" , 
"departure_time" : "17:51:44" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:52:06" , 
"departure_time" : "17:53:25" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:54:19" , 
"departure_time" : "17:54:48" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:56:29" , 
"departure_time" : "17:57:12" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "18:00:43" , 
"departure_time" : "18:00:43" , 
"distance_traveled" : 9.0456
} ], 
"382" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "17:49:00" , 
"departure_time" : "17:50:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "17:52:14" , 
"departure_time" : "17:52:22" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "17:53:08" , 
"departure_time" : "17:53:31" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "17:55:23" , 
"departure_time" : "17:55:44" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "17:57:21" , 
"departure_time" : "17:59:00" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "17:59:39" , 
"departure_time" : "17:59:43" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:01:04" , 
"departure_time" : "18:02:02" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:04:58" , 
"departure_time" : "18:05:17" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:05:19" , 
"departure_time" : "18:05:36" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:07:17" , 
"departure_time" : "18:07:44" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:09:27" , 
"departure_time" : "18:10:35" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:12:08" , 
"departure_time" : "18:12:47" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:13:39" , 
"departure_time" : "18:14:39" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:17:00" , 
"departure_time" : "18:18:26" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "18:21:26" , 
"departure_time" : "18:21:26" , 
"distance_traveled" : 9.0456
} ], 
"383" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "18:09:00" , 
"departure_time" : "18:11:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "18:11:39" , 
"departure_time" : "18:11:53" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "18:13:14" , 
"departure_time" : "18:14:30" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "18:16:16" , 
"departure_time" : "18:16:47" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "18:17:31" , 
"departure_time" : "18:18:23" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "18:18:52" , 
"departure_time" : "18:20:15" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:22:23" , 
"departure_time" : "18:23:05" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:24:42" , 
"departure_time" : "18:25:51" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:26:09" , 
"departure_time" : "18:26:55" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:27:46" , 
"departure_time" : "18:27:56" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:29:10" , 
"departure_time" : "18:30:30" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:32:20" , 
"departure_time" : "18:32:40" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:33:20" , 
"departure_time" : "18:34:06" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:36:46" , 
"departure_time" : "18:38:04" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "18:41:18" , 
"departure_time" : "18:41:18" , 
"distance_traveled" : 9.0456
} ], 
"384" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "18:29:00" , 
"departure_time" : "18:31:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "18:32:14" , 
"departure_time" : "18:33:09" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "18:33:55" , 
"departure_time" : "18:34:28" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "18:35:33" , 
"departure_time" : "18:35:54" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "18:37:21" , 
"departure_time" : "18:38:13" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "18:38:52" , 
"departure_time" : "18:38:56" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:41:04" , 
"departure_time" : "18:41:22" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:44:18" , 
"departure_time" : "18:45:22" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:46:04" , 
"departure_time" : "18:46:26" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:47:22" , 
"departure_time" : "18:47:53" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:49:31" , 
"departure_time" : "18:50:15" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:51:44" , 
"departure_time" : "18:52:07" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:53:23" , 
"departure_time" : "18:53:39" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:56:16" , 
"departure_time" : "18:57:32" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "19:01:16" , 
"departure_time" : "19:01:16" , 
"distance_traveled" : 9.0456
} ], 
"385" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "18:49:00" , 
"departure_time" : "18:51:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "18:51:46" , 
"departure_time" : "18:53:25" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "18:54:39" , 
"departure_time" : "18:55:30" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "18:55:51" , 
"departure_time" : "18:57:25" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "18:58:34" , 
"departure_time" : "18:59:56" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "18:59:22" , 
"departure_time" : "18:59:29" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:01:07" , 
"departure_time" : "19:02:27" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:05:20" , 
"departure_time" : "19:06:44" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:06:24" , 
"departure_time" : "19:06:53" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:07:29" , 
"departure_time" : "19:07:35" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:09:06" , 
"departure_time" : "19:10:29" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:12:23" , 
"departure_time" : "19:13:02" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:13:39" , 
"departure_time" : "19:15:12" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:17:33" , 
"departure_time" : "19:18:22" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "19:20:49" , 
"departure_time" : "19:20:49" , 
"distance_traveled" : 9.0456
} ], 
"386" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "19:09:00" , 
"departure_time" : "19:10:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "19:11:24" , 
"departure_time" : "19:12:02" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "19:13:38" , 
"departure_time" : "19:14:44" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "19:16:06" , 
"departure_time" : "19:16:10" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "19:17:04" , 
"departure_time" : "19:17:31" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "19:18:27" , 
"departure_time" : "19:18:51" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:21:24" , 
"departure_time" : "19:23:00" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:25:36" , 
"departure_time" : "19:26:04" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:25:28" , 
"departure_time" : "19:26:24" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:27:56" , 
"departure_time" : "19:29:18" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:30:22" , 
"departure_time" : "19:30:33" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:31:11" , 
"departure_time" : "19:32:24" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:34:13" , 
"departure_time" : "19:34:19" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:36:06" , 
"departure_time" : "19:37:40" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "19:41:34" , 
"departure_time" : "19:41:34" , 
"distance_traveled" : 9.0456
} ], 
"387" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "19:29:00" , 
"departure_time" : "19:31:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "19:31:45" , 
"departure_time" : "19:32:41" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "19:33:56" , 
"departure_time" : "19:34:11" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "19:35:15" , 
"departure_time" : "19:35:37" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "19:37:22" , 
"departure_time" : "19:38:15" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "19:38:53" , 
"departure_time" : "19:39:57" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:42:04" , 
"departure_time" : "19:43:34" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:45:30" , 
"departure_time" : "19:46:11" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:45:41" , 
"departure_time" : "19:46:50" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:48:09" , 
"departure_time" : "19:48:35" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:49:26" , 
"departure_time" : "19:51:06" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:52:40" , 
"departure_time" : "19:53:36" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:53:56" , 
"departure_time" : "19:54:49" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:56:53" , 
"departure_time" : "19:57:17" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "20:00:24" , 
"departure_time" : "20:00:24" , 
"distance_traveled" : 9.0456
} ], 
"388" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "19:49:00" , 
"departure_time" : "19:50:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "19:51:50" , 
"departure_time" : "19:53:06" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "19:54:16" , 
"departure_time" : "19:54:20" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "19:55:04" , 
"departure_time" : "19:56:02" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "19:57:58" , 
"departure_time" : "19:58:24" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "19:58:26" , 
"departure_time" : "19:59:37" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:02:11" , 
"departure_time" : "20:03:05" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:04:54" , 
"departure_time" : "20:05:33" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:05:39" , 
"departure_time" : "20:06:25" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:07:46" , 
"departure_time" : "20:08:35" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:09:49" , 
"departure_time" : "20:09:58" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:11:09" , 
"departure_time" : "20:11:42" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:13:33" , 
"departure_time" : "20:14:06" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:16:33" , 
"departure_time" : "20:18:09" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "20:21:36" , 
"departure_time" : "20:21:36" , 
"distance_traveled" : 9.0456
} ], 
"389" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "20:09:00" , 
"departure_time" : "20:10:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "20:11:18" , 
"departure_time" : "20:12:42" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "20:14:24" , 
"departure_time" : "20:15:19" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "20:15:55" , 
"departure_time" : "20:16:48" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "20:17:53" , 
"departure_time" : "20:18:29" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "20:18:36" , 
"departure_time" : "20:20:08" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:22:32" , 
"departure_time" : "20:23:25" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:24:53" , 
"departure_time" : "20:26:05" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:26:12" , 
"departure_time" : "20:26:32" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:27:20" , 
"departure_time" : "20:28:40" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:30:20" , 
"departure_time" : "20:30:23" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:31:03" , 
"departure_time" : "20:31:48" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:33:45" , 
"departure_time" : "20:34:59" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:37:14" , 
"departure_time" : "20:37:29" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "20:40:15" , 
"departure_time" : "20:40:15" , 
"distance_traveled" : 9.0456
} ], 
"390" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "20:29:00" , 
"departure_time" : "20:30:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "20:32:26" , 
"departure_time" : "20:32:56" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "20:33:30" , 
"departure_time" : "20:34:34" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "20:36:04" , 
"departure_time" : "20:37:44" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "20:38:40" , 
"departure_time" : "20:40:04" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "20:39:24" , 
"departure_time" : "20:39:46" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:41:22" , 
"departure_time" : "20:42:27" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:45:05" , 
"departure_time" : "20:46:45" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:46:40" , 
"departure_time" : "20:47:54" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:48:14" , 
"departure_time" : "20:48:54" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:49:40" , 
"departure_time" : "20:50:44" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:52:04" , 
"departure_time" : "20:53:04" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:54:00" , 
"departure_time" : "20:54:56" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:56:56" , 
"departure_time" : "20:58:34" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "21:01:38" , 
"departure_time" : "21:01:38" , 
"distance_traveled" : 9.0456
} ], 
"391" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "20:49:00" , 
"departure_time" : "20:50:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "20:51:09" , 
"departure_time" : "20:52:22" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "20:54:13" , 
"departure_time" : "20:55:52" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "20:56:39" , 
"departure_time" : "20:57:32" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "20:57:53" , 
"departure_time" : "20:58:39" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "20:58:46" , 
"departure_time" : "20:59:30" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:01:44" , 
"departure_time" : "21:02:33" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "21:04:49" , 
"departure_time" : "21:05:16" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "21:05:27" , 
"departure_time" : "21:06:50" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:08:23" , 
"departure_time" : "21:10:03" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "21:10:40" , 
"departure_time" : "21:10:45" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:11:05" , 
"departure_time" : "21:11:54" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:13:49" , 
"departure_time" : "21:15:22" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:17:33" , 
"departure_time" : "21:18:51" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "21:21:18" , 
"departure_time" : "21:21:18" , 
"distance_traveled" : 9.0456
} ], 
"392" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "21:09:00" , 
"departure_time" : "21:10:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "21:11:38" , 
"departure_time" : "21:12:19" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "21:13:41" , 
"departure_time" : "21:14:39" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "21:15:58" , 
"departure_time" : "21:16:55" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "21:17:57" , 
"departure_time" : "21:19:09" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "21:19:12" , 
"departure_time" : "21:20:50" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:22:38" , 
"departure_time" : "21:23:02" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "21:24:24" , 
"departure_time" : "21:25:34" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "21:26:10" , 
"departure_time" : "21:26:18" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:27:08" , 
"departure_time" : "21:28:09" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "21:30:01" , 
"departure_time" : "21:31:22" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:32:21" , 
"departure_time" : "21:33:38" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:34:17" , 
"departure_time" : "21:35:02" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:36:45" , 
"departure_time" : "21:37:06" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "21:40:21" , 
"departure_time" : "21:40:21" , 
"distance_traveled" : 9.0456
} ], 
"393" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "21:29:00" , 
"departure_time" : "21:29:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "21:31:06" , 
"departure_time" : "21:32:20" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "21:34:14" , 
"departure_time" : "21:35:02" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "21:35:48" , 
"departure_time" : "21:37:07" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "21:38:19" , 
"departure_time" : "21:39:57" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "21:39:38" , 
"departure_time" : "21:40:50" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:42:12" , 
"departure_time" : "21:42:56" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "21:44:44" , 
"departure_time" : "21:45:20" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "21:45:36" , 
"departure_time" : "21:45:52" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:47:16" , 
"departure_time" : "21:48:04" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "21:49:48" , 
"departure_time" : "21:50:55" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:52:07" , 
"departure_time" : "21:53:37" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:54:30" , 
"departure_time" : "21:54:52" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:56:22" , 
"departure_time" : "21:57:10" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "22:00:48" , 
"departure_time" : "22:00:48" , 
"distance_traveled" : 9.0456
} ], 
"394" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "21:49:00" , 
"departure_time" : "21:50:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "21:51:22" , 
"departure_time" : "21:51:38" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "21:53:16" , 
"departure_time" : "21:54:49" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "21:56:33" , 
"departure_time" : "21:57:11" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "21:57:38" , 
"departure_time" : "21:58:49" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "21:59:11" , 
"departure_time" : "22:00:44" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:02:33" , 
"departure_time" : "22:03:42" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:05:09" , 
"departure_time" : "22:06:11" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:06:02" , 
"departure_time" : "22:06:38" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:07:36" , 
"departure_time" : "22:08:33" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:09:57" , 
"departure_time" : "22:11:08" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:12:11" , 
"departure_time" : "22:13:06" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:13:55" , 
"departure_time" : "22:14:58" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:17:03" , 
"departure_time" : "22:17:30" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "22:20:27" , 
"departure_time" : "22:20:27" , 
"distance_traveled" : 9.0456
} ], 
"395" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "22:09:00" , 
"departure_time" : "22:09:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "22:11:07" , 
"departure_time" : "22:12:27" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "22:14:20" , 
"departure_time" : "22:15:05" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "22:15:45" , 
"departure_time" : "22:16:58" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "22:18:13" , 
"departure_time" : "22:18:43" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "22:18:30" , 
"departure_time" : "22:19:16" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:21:46" , 
"departure_time" : "22:23:10" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:25:24" , 
"departure_time" : "22:25:34" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:25:10" , 
"departure_time" : "22:26:35" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:28:25" , 
"departure_time" : "22:28:46" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:29:21" , 
"departure_time" : "22:30:28" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:32:07" , 
"departure_time" : "22:33:34" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:34:27" , 
"departure_time" : "22:35:55" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:37:28" , 
"departure_time" : "22:38:21" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "22:40:53" , 
"departure_time" : "22:40:53" , 
"distance_traveled" : 9.0456
} ], 
"396" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "22:29:00" , 
"departure_time" : "22:30:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "22:31:15" , 
"departure_time" : "22:32:51" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "22:34:36" , 
"departure_time" : "22:36:02" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "22:36:26" , 
"departure_time" : "22:37:28" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "22:38:02" , 
"departure_time" : "22:38:22" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "22:38:20" , 
"departure_time" : "22:39:14" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:41:54" , 
"departure_time" : "22:42:37" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:44:43" , 
"departure_time" : "22:45:10" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:45:27" , 
"departure_time" : "22:46:00" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:47:33" , 
"departure_time" : "22:48:41" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:50:08" , 
"departure_time" : "22:51:18" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:52:10" , 
"departure_time" : "22:52:23" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:53:13" , 
"departure_time" : "22:53:57" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:56:44" , 
"departure_time" : "22:57:07" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "23:00:23" , 
"departure_time" : "23:00:23" , 
"distance_traveled" : 9.0456
} ], 
"397" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "22:49:00" , 
"departure_time" : "22:51:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "22:52:39" , 
"departure_time" : "22:53:28" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "22:53:49" , 
"departure_time" : "22:54:10" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "22:55:21" , 
"departure_time" : "22:56:37" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "22:58:16" , 
"departure_time" : "22:58:33" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "22:58:17" , 
"departure_time" : "22:58:37" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:01:20" , 
"departure_time" : "23:01:27" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:04:07" , 
"departure_time" : "23:04:28" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "23:05:21" , 
"departure_time" : "23:05:41" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:07:20" , 
"departure_time" : "23:07:23" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:09:03" , 
"departure_time" : "23:09:12" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:11:09" , 
"departure_time" : "23:11:44" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:13:35" , 
"departure_time" : "23:14:03" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:16:28" , 
"departure_time" : "23:16:55" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "23:20:27" , 
"departure_time" : "23:20:27" , 
"distance_traveled" : 9.0456
} ], 
"398" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "23:09:00" , 
"departure_time" : "23:11:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "23:12:39" , 
"departure_time" : "23:14:07" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "23:14:28" , 
"departure_time" : "23:15:12" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "23:15:44" , 
"departure_time" : "23:17:14" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "23:18:30" , 
"departure_time" : "23:19:27" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "23:18:57" , 
"departure_time" : "23:20:08" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:22:11" , 
"departure_time" : "23:23:16" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:25:05" , 
"departure_time" : "23:26:37" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "23:26:32" , 
"departure_time" : "23:27:35" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:28:03" , 
"departure_time" : "23:28:30" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:29:27" , 
"departure_time" : "23:30:18" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:31:51" , 
"departure_time" : "23:32:37" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:33:46" , 
"departure_time" : "23:33:50" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:36:04" , 
"departure_time" : "23:36:40" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "23:40:36" , 
"departure_time" : "23:40:36" , 
"distance_traveled" : 9.0456
} ], 
"399" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "23:29:00" , 
"departure_time" : "23:30:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "23:31:27" , 
"departure_time" : "23:31:34" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "23:33:07" , 
"departure_time" : "23:33:44" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "23:35:37" , 
"departure_time" : "23:36:40" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "23:38:03" , 
"departure_time" : "23:38:47" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "23:38:44" , 
"departure_time" : "23:40:04" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:42:20" , 
"departure_time" : "23:42:38" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:44:18" , 
"departure_time" : "23:45:21" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "23:46:03" , 
"departure_time" : "23:46:24" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:47:21" , 
"departure_time" : "23:48:32" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:50:11" , 
"departure_time" : "23:51:51" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:52:40" , 
"departure_time" : "23:52:59" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:53:19" , 
"departure_time" : "23:54:46" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:57:27" , 
"departure_time" : "23:57:31" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "24:00:04" , 
"departure_time" : "24:00:04" , 
"distance_traveled" : 9.0456
} ], 
"400" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "23:49:00" , 
"departure_time" : "23:50:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "23:52:40" , 
"departure_time" : "23:53:12" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "23:53:32" , 
"departure_time" : "23:54:19" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "23:55:47" , 
"departure_time" : "23:57:06" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "23:58:19" , 
"departure_time" : "23:58:45" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "23:58:26" , 
"departure_time" : "23:59:41" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "24:02:15" , 
"departure_time" : "24:02:35" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "24:04:20" , 
"departure_time" : "24:04:21" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "24:05:01" , 
"departure_time" : "24:05:50" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "24:07:49" , 
"departure_time" : "24:08:26" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "24:09:37" , 
"departure_time" : "24:10:30" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "24:11:53" , 
"departure_time" : "24:12:58" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "24:14:05" , 
"departure_time" : "24:15:32" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "24:17:27" , 
"departure_time" : "24:17:28" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "24:20:01" , 
"departure_time" : "24:20:01" , 
"distance_traveled" : 9.0456
} ], 
"401" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "24:20:00" , 
"departure_time" : "24:21:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "24:23:28" , 
"departure_time" : "24:24:33" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "24:25:05" , 
"departure_time" : "24:25:16" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "24:26:11" , 
"departure_time" : "24:27:13" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "24:29:02" , 
"departure_time" : "24:29:55" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "24:29:53" , 
"departure_time" : "24:30:55" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "24:33:02" , 
"departure_time" : "24:33:14" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "24:35:12" , 
"departure_time" : "24:35:56" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "24:36:44" , 
"departure_time" : "24:37:53" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "24:39:09" , 
"departure_time" : "24:39:40" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "24:40:31" , 
"departure_time" : "24:41:56" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "24:43:25" , 
"departure_time" : "24:43:45" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "24:44:20" , 
"departure_time" : "24:45:13" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "24:47:53" , 
"departure_time" : "24:48:43" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "24:51:50" , 
"departure_time" : "24:51:50" , 
"distance_traveled" : 9.0456
} ], 
"402" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "24:54:00" , 
"departure_time" : "24:55:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "24:56:29" , 
"departure_time" : "24:57:52" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "24:59:23" , 
"departure_time" : "25:01:02" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "25:01:39" , 
"departure_time" : "25:01:41" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "25:02:02" , 
"departure_time" : "25:02:05" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "25:03:03" , 
"departure_time" : "25:03:09" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "25:06:06" , 
"departure_time" : "25:07:26" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "25:10:20" , 
"departure_time" : "25:11:49" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "25:11:29" , 
"departure_time" : "25:11:50" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "25:12:21" , 
"departure_time" : "25:13:55" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "25:15:34" , 
"departure_time" : "25:15:57" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "25:16:23" , 
"departure_time" : "25:16:42" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "25:18:19" , 
"departure_time" : "25:18:34" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "25:21:15" , 
"departure_time" : "25:22:31" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "25:26:16" , 
"departure_time" : "25:26:16" , 
"distance_traveled" : 9.0456
} ], 
"403" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "25:24:00" , 
"departure_time" : "25:25:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "25:26:43" , 
"departure_time" : "25:27:51" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "25:29:08" , 
"departure_time" : "25:29:45" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "25:30:37" , 
"departure_time" : "25:31:02" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "25:32:25" , 
"departure_time" : "25:32:54" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "25:33:29" , 
"departure_time" : "25:33:46" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "25:36:17" , 
"departure_time" : "25:37:55" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "25:40:38" , 
"departure_time" : "25:42:05" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "25:41:27" , 
"departure_time" : "25:42:58" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "25:43:31" , 
"departure_time" : "25:44:38" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "25:45:07" , 
"departure_time" : "25:46:20" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "25:47:13" , 
"departure_time" : "25:48:50" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "25:49:37" , 
"departure_time" : "25:49:49" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "25:51:12" , 
"departure_time" : "25:51:17" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "25:55:05" , 
"departure_time" : "25:55:05" , 
"distance_traveled" : 9.0456
} ], 
"404" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "05:48:00" , 
"departure_time" : "05:48:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "05:50:45" , 
"departure_time" : "05:51:59" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "05:53:14" , 
"departure_time" : "05:53:16" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "05:55:02" , 
"departure_time" : "05:55:54" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "05:58:52" , 
"departure_time" : "06:00:05" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:00:13" , 
"departure_time" : "06:00:51" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:02:38" , 
"departure_time" : "06:03:17" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:04:39" , 
"departure_time" : "06:04:52" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:06:13" , 
"departure_time" : "06:06:43" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:08:30" , 
"departure_time" : "06:09:49" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:12:19" , 
"departure_time" : "06:12:51" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "06:16:32" , 
"departure_time" : "06:17:10" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "06:18:38" , 
"departure_time" : "06:19:03" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "06:21:25" , 
"departure_time" : "06:22:25" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "06:25:00" , 
"departure_time" : "06:25:38" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "06:26:38" , 
"departure_time" : "06:26:42" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "06:28:04" , 
"departure_time" : "06:28:04" , 
"distance_traveled" : 10.0595
} ], 
"405" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "06:08:00" , 
"departure_time" : "06:08:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "06:10:12" , 
"departure_time" : "06:10:42" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "06:12:30" , 
"departure_time" : "06:14:06" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:16:36" , 
"departure_time" : "06:17:43" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:19:07" , 
"departure_time" : "06:20:16" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:20:09" , 
"departure_time" : "06:21:20" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:23:11" , 
"departure_time" : "06:24:36" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:25:25" , 
"departure_time" : "06:25:44" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:26:19" , 
"departure_time" : "06:26:56" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:28:37" , 
"departure_time" : "06:29:31" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:31:54" , 
"departure_time" : "06:32:06" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "06:36:12" , 
"departure_time" : "06:37:11" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "06:38:59" , 
"departure_time" : "06:39:23" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "06:41:24" , 
"departure_time" : "06:42:38" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "06:45:14" , 
"departure_time" : "06:45:54" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "06:46:40" , 
"departure_time" : "06:48:07" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "06:49:27" , 
"departure_time" : "06:49:27" , 
"distance_traveled" : 10.0595
} ], 
"406" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "06:28:00" , 
"departure_time" : "06:30:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "06:31:20" , 
"departure_time" : "06:31:31" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "06:32:11" , 
"departure_time" : "06:33:23" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:36:12" , 
"departure_time" : "06:37:51" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:39:39" , 
"departure_time" : "06:39:43" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:39:04" , 
"departure_time" : "06:40:06" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:43:02" , 
"departure_time" : "06:43:04" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:44:02" , 
"departure_time" : "06:45:39" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:47:37" , 
"departure_time" : "06:48:34" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:48:57" , 
"departure_time" : "06:50:20" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:52:23" , 
"departure_time" : "06:53:04" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "06:56:41" , 
"departure_time" : "06:57:19" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "06:58:38" , 
"departure_time" : "06:59:56" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "07:02:18" , 
"departure_time" : "07:02:41" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "07:04:23" , 
"departure_time" : "07:06:01" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:07:38" , 
"departure_time" : "07:08:13" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "07:08:35" , 
"departure_time" : "07:08:35" , 
"distance_traveled" : 10.0595
} ], 
"407" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "06:48:00" , 
"departure_time" : "06:48:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "06:50:15" , 
"departure_time" : "06:50:20" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "06:52:05" , 
"departure_time" : "06:53:20" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:56:15" , 
"departure_time" : "06:57:26" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:59:11" , 
"departure_time" : "06:59:52" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:59:41" , 
"departure_time" : "06:59:54" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:02:13" , 
"departure_time" : "07:02:23" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:04:10" , 
"departure_time" : "07:05:02" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:06:52" , 
"departure_time" : "07:08:01" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:09:09" , 
"departure_time" : "07:10:23" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:12:14" , 
"departure_time" : "07:13:30" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:17:16" , 
"departure_time" : "07:17:29" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "07:18:13" , 
"departure_time" : "07:19:42" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "07:22:29" , 
"departure_time" : "07:22:37" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "07:24:08" , 
"departure_time" : "07:25:10" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:27:02" , 
"departure_time" : "07:28:07" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "07:29:05" , 
"departure_time" : "07:29:05" , 
"distance_traveled" : 10.0595
} ], 
"408" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "07:08:00" , 
"departure_time" : "07:10:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "07:10:58" , 
"departure_time" : "07:11:24" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "07:12:26" , 
"departure_time" : "07:13:46" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:16:20" , 
"departure_time" : "07:17:16" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:18:56" , 
"departure_time" : "07:20:01" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:20:05" , 
"departure_time" : "07:21:10" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:23:05" , 
"departure_time" : "07:23:53" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:24:48" , 
"departure_time" : "07:26:22" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:27:34" , 
"departure_time" : "07:27:52" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:28:18" , 
"departure_time" : "07:28:49" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:31:31" , 
"departure_time" : "07:31:37" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:36:06" , 
"departure_time" : "07:36:54" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "07:38:48" , 
"departure_time" : "07:39:07" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "07:41:19" , 
"departure_time" : "07:42:13" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "07:44:54" , 
"departure_time" : "07:45:31" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:46:37" , 
"departure_time" : "07:47:38" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "07:49:01" , 
"departure_time" : "07:49:01" , 
"distance_traveled" : 10.0595
} ], 
"409" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "07:28:00" , 
"departure_time" : "07:30:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "07:31:33" , 
"departure_time" : "07:32:00" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "07:32:27" , 
"departure_time" : "07:33:45" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:36:18" , 
"departure_time" : "07:36:45" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:38:27" , 
"departure_time" : "07:38:56" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:39:29" , 
"departure_time" : "07:39:47" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:42:18" , 
"departure_time" : "07:43:15" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:44:57" , 
"departure_time" : "07:46:15" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:47:18" , 
"departure_time" : "07:47:45" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:48:27" , 
"departure_time" : "07:49:06" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:51:39" , 
"departure_time" : "07:53:01" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:57:22" , 
"departure_time" : "07:59:02" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "07:59:40" , 
"departure_time" : "08:00:24" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:01:44" , 
"departure_time" : "08:03:11" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:05:27" , 
"departure_time" : "08:06:07" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:06:40" , 
"departure_time" : "08:07:33" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "08:08:53" , 
"departure_time" : "08:08:53" , 
"distance_traveled" : 10.0595
} ], 
"410" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "07:48:00" , 
"departure_time" : "07:49:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "07:50:31" , 
"departure_time" : "07:50:46" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "07:52:15" , 
"departure_time" : "07:53:51" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:56:36" , 
"departure_time" : "07:57:47" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:59:11" , 
"departure_time" : "08:00:30" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:00:19" , 
"departure_time" : "08:01:28" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:03:09" , 
"departure_time" : "08:03:20" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:04:11" , 
"departure_time" : "08:05:15" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:07:04" , 
"departure_time" : "08:07:20" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:08:16" , 
"departure_time" : "08:09:43" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:12:27" , 
"departure_time" : "08:13:58" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:17:31" , 
"departure_time" : "08:18:03" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:18:32" , 
"departure_time" : "08:19:24" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:21:52" , 
"departure_time" : "08:22:33" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:24:41" , 
"departure_time" : "08:25:13" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:26:32" , 
"departure_time" : "08:27:34" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "08:29:02" , 
"departure_time" : "08:29:02" , 
"distance_traveled" : 10.0595
} ], 
"411" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "08:08:00" , 
"departure_time" : "08:09:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "08:10:06" , 
"departure_time" : "08:10:59" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "08:12:53" , 
"departure_time" : "08:13:52" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:15:59" , 
"departure_time" : "08:16:46" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:18:47" , 
"departure_time" : "08:20:12" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:20:25" , 
"departure_time" : "08:21:49" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:23:24" , 
"departure_time" : "08:23:35" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:24:11" , 
"departure_time" : "08:24:33" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:26:22" , 
"departure_time" : "08:27:40" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:29:18" , 
"departure_time" : "08:30:18" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:32:00" , 
"departure_time" : "08:32:54" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:36:54" , 
"departure_time" : "08:37:51" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:38:57" , 
"departure_time" : "08:39:50" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:41:53" , 
"departure_time" : "08:42:40" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:44:47" , 
"departure_time" : "08:44:53" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:46:06" , 
"departure_time" : "08:47:44" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "08:49:38" , 
"departure_time" : "08:49:38" , 
"distance_traveled" : 10.0595
} ], 
"412" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "08:28:00" , 
"departure_time" : "08:30:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "08:31:07" , 
"departure_time" : "08:32:22" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "08:33:15" , 
"departure_time" : "08:34:15" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:36:00" , 
"departure_time" : "08:37:37" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:39:37" , 
"departure_time" : "08:39:57" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:39:20" , 
"departure_time" : "08:40:16" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:42:56" , 
"departure_time" : "08:44:35" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:45:39" , 
"departure_time" : "08:46:40" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:47:01" , 
"departure_time" : "08:48:12" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:49:11" , 
"departure_time" : "08:49:17" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:51:06" , 
"departure_time" : "08:52:12" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:57:06" , 
"departure_time" : "08:57:07" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:58:01" , 
"departure_time" : "08:58:59" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "09:01:58" , 
"departure_time" : "09:02:35" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "09:04:37" , 
"departure_time" : "09:04:48" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "09:06:11" , 
"departure_time" : "09:06:14" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "09:08:03" , 
"departure_time" : "09:08:03" , 
"distance_traveled" : 10.0595
} ], 
"413" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "08:48:00" , 
"departure_time" : "08:48:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "08:50:03" , 
"departure_time" : "08:50:52" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "08:52:49" , 
"departure_time" : "08:53:26" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:55:37" , 
"departure_time" : "08:55:51" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:58:14" , 
"departure_time" : "08:59:46" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:00:32" , 
"departure_time" : "09:01:04" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:02:32" , 
"departure_time" : "09:02:36" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:04:04" , 
"departure_time" : "09:04:28" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:06:24" , 
"departure_time" : "09:06:57" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:08:33" , 
"departure_time" : "09:10:09" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:12:36" , 
"departure_time" : "09:12:43" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "09:16:07" , 
"departure_time" : "09:16:23" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:18:16" , 
"departure_time" : "09:18:47" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "09:21:31" , 
"departure_time" : "09:21:57" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "09:24:26" , 
"departure_time" : "09:24:58" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "09:26:32" , 
"departure_time" : "09:27:11" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "09:28:39" , 
"departure_time" : "09:28:39" , 
"distance_traveled" : 10.0595
} ], 
"414" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "09:08:00" , 
"departure_time" : "09:09:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "09:10:44" , 
"departure_time" : "09:12:14" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "09:13:30" , 
"departure_time" : "09:14:36" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:16:06" , 
"departure_time" : "09:16:25" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:18:19" , 
"departure_time" : "09:18:49" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:19:30" , 
"departure_time" : "09:20:10" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:22:40" , 
"departure_time" : "09:24:17" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:25:37" , 
"departure_time" : "09:26:32" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:26:55" , 
"departure_time" : "09:27:38" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:28:43" , 
"departure_time" : "09:29:30" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:31:47" , 
"departure_time" : "09:33:12" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "09:37:25" , 
"departure_time" : "09:37:54" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:38:29" , 
"departure_time" : "09:39:04" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "09:41:35" , 
"departure_time" : "09:42:49" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "09:45:14" , 
"departure_time" : "09:45:32" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "09:46:18" , 
"departure_time" : "09:47:17" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "09:48:59" , 
"departure_time" : "09:48:59" , 
"distance_traveled" : 10.0595
} ], 
"415" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "09:28:00" , 
"departure_time" : "09:30:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "09:31:10" , 
"departure_time" : "09:32:49" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "09:33:39" , 
"departure_time" : "09:35:09" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:36:30" , 
"departure_time" : "09:37:48" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:39:18" , 
"departure_time" : "09:39:48" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:39:30" , 
"departure_time" : "09:39:45" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:42:15" , 
"departure_time" : "09:42:47" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:44:32" , 
"departure_time" : "09:46:06" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:47:34" , 
"departure_time" : "09:47:52" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:48:18" , 
"departure_time" : "09:48:58" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:51:40" , 
"departure_time" : "09:52:48" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "09:57:08" , 
"departure_time" : "09:57:19" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:58:11" , 
"departure_time" : "09:58:44" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "10:01:33" , 
"departure_time" : "10:01:39" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "10:04:06" , 
"departure_time" : "10:04:17" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "10:06:11" , 
"departure_time" : "10:06:44" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "10:08:33" , 
"departure_time" : "10:08:33" , 
"distance_traveled" : 10.0595
} ], 
"416" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "09:48:00" , 
"departure_time" : "09:49:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "09:50:30" , 
"departure_time" : "09:51:31" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "09:53:01" , 
"departure_time" : "09:53:53" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:55:52" , 
"departure_time" : "09:56:47" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:58:55" , 
"departure_time" : "09:59:40" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:59:45" , 
"departure_time" : "10:00:26" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:02:41" , 
"departure_time" : "10:04:10" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:05:29" , 
"departure_time" : "10:05:44" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:06:15" , 
"departure_time" : "10:06:20" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:08:05" , 
"departure_time" : "10:08:22" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:11:17" , 
"departure_time" : "10:12:30" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "10:17:13" , 
"departure_time" : "10:17:58" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "10:18:45" , 
"departure_time" : "10:20:16" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "10:22:31" , 
"departure_time" : "10:23:41" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "10:25:10" , 
"departure_time" : "10:25:52" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "10:26:42" , 
"departure_time" : "10:27:49" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "10:29:07" , 
"departure_time" : "10:29:07" , 
"distance_traveled" : 10.0595
} ], 
"417" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "10:08:00" , 
"departure_time" : "10:09:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "10:10:22" , 
"departure_time" : "10:11:24" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "10:13:02" , 
"departure_time" : "10:14:23" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:16:21" , 
"departure_time" : "10:17:34" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:19:13" , 
"departure_time" : "10:20:30" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:20:17" , 
"departure_time" : "10:21:48" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:23:31" , 
"departure_time" : "10:24:45" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:25:14" , 
"departure_time" : "10:26:52" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:27:38" , 
"departure_time" : "10:27:45" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:28:07" , 
"departure_time" : "10:28:40" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:31:33" , 
"departure_time" : "10:32:53" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "10:37:20" , 
"departure_time" : "10:38:12" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "10:38:52" , 
"departure_time" : "10:40:09" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "10:42:17" , 
"departure_time" : "10:43:36" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "10:45:19" , 
"departure_time" : "10:46:59" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "10:47:40" , 
"departure_time" : "10:48:11" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "10:48:31" , 
"departure_time" : "10:48:31" , 
"distance_traveled" : 10.0595
} ], 
"418" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "10:28:00" , 
"departure_time" : "10:29:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "10:30:58" , 
"departure_time" : "10:32:30" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "10:33:32" , 
"departure_time" : "10:34:20" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:35:48" , 
"departure_time" : "10:36:46" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:38:58" , 
"departure_time" : "10:40:25" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:40:27" , 
"departure_time" : "10:40:40" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:42:13" , 
"departure_time" : "10:42:59" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:44:46" , 
"departure_time" : "10:45:51" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:47:05" , 
"departure_time" : "10:47:57" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:48:52" , 
"departure_time" : "10:49:19" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:51:27" , 
"departure_time" : "10:52:11" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "10:56:44" , 
"departure_time" : "10:57:35" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "10:58:51" , 
"departure_time" : "10:59:18" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "11:01:27" , 
"departure_time" : "11:01:35" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "11:04:08" , 
"departure_time" : "11:04:16" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "11:06:08" , 
"departure_time" : "11:06:55" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "11:08:47" , 
"departure_time" : "11:08:47" , 
"distance_traveled" : 10.0595
} ], 
"419" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "10:48:00" , 
"departure_time" : "10:50:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "10:51:37" , 
"departure_time" : "10:51:44" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "10:52:07" , 
"departure_time" : "10:53:35" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:56:28" , 
"departure_time" : "10:57:23" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:58:55" , 
"departure_time" : "10:59:13" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:59:18" , 
"departure_time" : "10:59:46" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:02:28" , 
"departure_time" : "11:03:07" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:04:39" , 
"departure_time" : "11:06:11" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:07:32" , 
"departure_time" : "11:08:33" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:09:01" , 
"departure_time" : "11:09:09" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:11:08" , 
"departure_time" : "11:11:52" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "11:16:44" , 
"departure_time" : "11:16:52" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "11:18:08" , 
"departure_time" : "11:19:11" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "11:22:03" , 
"departure_time" : "11:22:20" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "11:24:17" , 
"departure_time" : "11:24:38" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "11:26:21" , 
"departure_time" : "11:26:57" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "11:28:36" , 
"departure_time" : "11:28:36" , 
"distance_traveled" : 10.0595
} ], 
"420" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "11:08:00" , 
"departure_time" : "11:09:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "11:10:34" , 
"departure_time" : "11:10:57" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "11:12:23" , 
"departure_time" : "11:12:33" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:15:10" , 
"departure_time" : "11:15:18" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:18:08" , 
"departure_time" : "11:18:30" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:19:22" , 
"departure_time" : "11:20:32" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:23:10" , 
"departure_time" : "11:23:55" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:24:45" , 
"departure_time" : "11:26:18" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:27:33" , 
"departure_time" : "11:28:43" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:29:10" , 
"departure_time" : "11:29:36" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:31:26" , 
"departure_time" : "11:32:05" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "11:36:39" , 
"departure_time" : "11:37:14" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "11:38:35" , 
"departure_time" : "11:38:47" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "11:41:12" , 
"departure_time" : "11:42:13" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "11:45:01" , 
"departure_time" : "11:46:14" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "11:47:13" , 
"departure_time" : "11:47:16" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "11:48:03" , 
"departure_time" : "11:48:03" , 
"distance_traveled" : 10.0595
} ], 
"421" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "11:28:00" , 
"departure_time" : "11:29:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "11:31:26" , 
"departure_time" : "11:32:03" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "11:32:37" , 
"departure_time" : "11:32:45" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:35:08" , 
"departure_time" : "11:35:41" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:38:33" , 
"departure_time" : "11:38:44" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:39:11" , 
"departure_time" : "11:40:25" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:43:14" , 
"departure_time" : "11:43:44" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:44:30" , 
"departure_time" : "11:45:53" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:47:23" , 
"departure_time" : "11:48:07" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:48:44" , 
"departure_time" : "11:49:33" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:51:49" , 
"departure_time" : "11:53:06" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "11:57:17" , 
"departure_time" : "11:58:55" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "11:59:38" , 
"departure_time" : "11:59:57" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "12:01:19" , 
"departure_time" : "12:02:08" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "12:04:49" , 
"departure_time" : "12:05:23" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "12:06:34" , 
"departure_time" : "12:07:12" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "12:08:38" , 
"departure_time" : "12:08:38" , 
"distance_traveled" : 10.0595
} ], 
"422" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "11:48:00" , 
"departure_time" : "11:48:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "11:50:16" , 
"departure_time" : "11:51:10" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "11:52:54" , 
"departure_time" : "11:53:03" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:55:09" , 
"departure_time" : "11:56:25" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:59:16" , 
"departure_time" : "12:00:55" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:00:39" , 
"departure_time" : "12:01:24" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:02:45" , 
"departure_time" : "12:03:07" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:04:22" , 
"departure_time" : "12:04:32" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:06:10" , 
"departure_time" : "12:07:36" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:09:26" , 
"departure_time" : "12:09:40" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:11:14" , 
"departure_time" : "12:11:59" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "12:16:45" , 
"departure_time" : "12:17:01" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "12:18:16" , 
"departure_time" : "12:18:41" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "12:21:25" , 
"departure_time" : "12:22:53" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "12:25:28" , 
"departure_time" : "12:25:38" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "12:26:10" , 
"departure_time" : "12:26:25" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "12:28:15" , 
"departure_time" : "12:28:15" , 
"distance_traveled" : 10.0595
} ], 
"423" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "12:08:00" , 
"departure_time" : "12:08:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "12:10:39" , 
"departure_time" : "12:10:46" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "12:12:07" , 
"departure_time" : "12:13:18" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:16:11" , 
"departure_time" : "12:17:33" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:19:22" , 
"departure_time" : "12:20:04" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:19:42" , 
"departure_time" : "12:20:42" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:23:00" , 
"departure_time" : "12:24:36" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:25:36" , 
"departure_time" : "12:27:12" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:27:36" , 
"departure_time" : "12:28:40" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:29:04" , 
"departure_time" : "12:29:50" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:31:46" , 
"departure_time" : "12:33:15" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "12:37:29" , 
"departure_time" : "12:38:30" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "12:39:01" , 
"departure_time" : "12:40:21" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "12:42:20" , 
"departure_time" : "12:43:12" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "12:44:52" , 
"departure_time" : "12:45:20" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "12:46:28" , 
"departure_time" : "12:47:37" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "12:49:09" , 
"departure_time" : "12:49:09" , 
"distance_traveled" : 10.0595
} ], 
"424" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "12:28:00" , 
"departure_time" : "12:29:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "12:30:36" , 
"departure_time" : "12:32:05" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "12:33:29" , 
"departure_time" : "12:34:25" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:35:56" , 
"departure_time" : "12:36:25" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:38:29" , 
"departure_time" : "12:39:49" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:40:20" , 
"departure_time" : "12:40:36" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:42:16" , 
"departure_time" : "12:43:14" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:44:58" , 
"departure_time" : "12:45:59" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:47:01" , 
"departure_time" : "12:47:11" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:48:10" , 
"departure_time" : "12:48:41" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:51:31" , 
"departure_time" : "12:53:10" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "12:57:39" , 
"departure_time" : "12:58:33" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "12:58:54" , 
"departure_time" : "12:59:25" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "13:01:31" , 
"departure_time" : "13:02:01" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "13:04:30" , 
"departure_time" : "13:05:43" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "13:07:13" , 
"departure_time" : "13:07:25" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "13:08:12" , 
"departure_time" : "13:08:12" , 
"distance_traveled" : 10.0595
} ], 
"425" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "12:48:00" , 
"departure_time" : "12:48:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "12:50:13" , 
"departure_time" : "12:51:20" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "12:53:07" , 
"departure_time" : "12:53:22" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:55:15" , 
"departure_time" : "12:56:51" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:59:36" , 
"departure_time" : "13:00:09" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:59:33" , 
"departure_time" : "12:59:51" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:02:18" , 
"departure_time" : "13:02:48" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:04:30" , 
"departure_time" : "13:06:00" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:07:30" , 
"departure_time" : "13:08:04" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:08:34" , 
"departure_time" : "13:09:00" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:11:26" , 
"departure_time" : "13:12:02" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "13:16:36" , 
"departure_time" : "13:17:01" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "13:18:25" , 
"departure_time" : "13:19:10" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "13:21:45" , 
"departure_time" : "13:23:15" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "13:25:30" , 
"departure_time" : "13:26:58" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "13:27:28" , 
"departure_time" : "13:29:04" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "13:29:36" , 
"departure_time" : "13:29:36" , 
"distance_traveled" : 10.0595
} ], 
"426" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "13:08:00" , 
"departure_time" : "13:10:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "13:10:47" , 
"departure_time" : "13:11:37" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "13:12:50" , 
"departure_time" : "13:13:52" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:16:02" , 
"departure_time" : "13:17:14" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:19:12" , 
"departure_time" : "13:20:45" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:20:33" , 
"departure_time" : "13:21:36" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:23:03" , 
"departure_time" : "13:24:23" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:25:20" , 
"departure_time" : "13:26:00" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:26:40" , 
"departure_time" : "13:28:00" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:29:20" , 
"departure_time" : "13:30:23" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:32:03" , 
"departure_time" : "13:33:37" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "13:37:34" , 
"departure_time" : "13:37:53" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "13:38:19" , 
"departure_time" : "13:39:31" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "13:42:12" , 
"departure_time" : "13:42:23" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "13:44:11" , 
"departure_time" : "13:44:38" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "13:46:27" , 
"departure_time" : "13:46:33" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "13:48:06" , 
"departure_time" : "13:48:06" , 
"distance_traveled" : 10.0595
} ], 
"427" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "13:28:00" , 
"departure_time" : "13:28:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "13:30:14" , 
"departure_time" : "13:30:42" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "13:32:28" , 
"departure_time" : "13:33:04" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:35:36" , 
"departure_time" : "13:36:24" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:38:48" , 
"departure_time" : "13:39:01" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:39:13" , 
"departure_time" : "13:40:51" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:43:38" , 
"departure_time" : "13:43:44" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:44:06" , 
"departure_time" : "13:45:00" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:46:54" , 
"departure_time" : "13:48:00" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:49:06" , 
"departure_time" : "13:50:36" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:52:30" , 
"departure_time" : "13:52:32" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "13:56:02" , 
"departure_time" : "13:56:22" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "13:58:20" , 
"departure_time" : "13:58:38" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "14:01:18" , 
"departure_time" : "14:01:36" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "14:04:18" , 
"departure_time" : "14:05:37" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "14:07:19" , 
"departure_time" : "14:08:58" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "14:09:39" , 
"departure_time" : "14:09:39" , 
"distance_traveled" : 10.0595
} ], 
"428" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "13:48:00" , 
"departure_time" : "13:50:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "13:51:18" , 
"departure_time" : "13:52:43" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "13:53:25" , 
"departure_time" : "13:53:50" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:55:25" , 
"departure_time" : "13:56:42" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:59:17" , 
"departure_time" : "13:59:56" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:59:39" , 
"departure_time" : "14:01:09" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:03:30" , 
"departure_time" : "14:04:26" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:04:56" , 
"departure_time" : "14:05:16" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:06:20" , 
"departure_time" : "14:07:55" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:09:35" , 
"departure_time" : "14:10:53" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:12:18" , 
"departure_time" : "14:13:15" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "14:16:57" , 
"departure_time" : "14:18:04" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "14:19:07" , 
"departure_time" : "14:20:37" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "14:22:30" , 
"departure_time" : "14:22:57" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "14:24:27" , 
"departure_time" : "14:26:03" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "14:27:36" , 
"departure_time" : "14:28:25" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "14:28:49" , 
"departure_time" : "14:28:49" , 
"distance_traveled" : 10.0595
} ], 
"429" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "14:08:00" , 
"departure_time" : "14:09:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "14:11:09" , 
"departure_time" : "14:11:54" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "14:12:45" , 
"departure_time" : "14:13:00" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:15:15" , 
"departure_time" : "14:16:00" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:18:45" , 
"departure_time" : "14:20:14" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:20:29" , 
"departure_time" : "14:22:04" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:23:35" , 
"departure_time" : "14:24:39" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:25:04" , 
"departure_time" : "14:25:50" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:26:46" , 
"departure_time" : "14:27:51" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:29:05" , 
"departure_time" : "14:30:38" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:32:33" , 
"departure_time" : "14:32:57" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "14:36:24" , 
"departure_time" : "14:36:55" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "14:38:31" , 
"departure_time" : "14:38:39" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "14:41:08" , 
"departure_time" : "14:41:42" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "14:44:34" , 
"departure_time" : "14:45:43" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "14:47:09" , 
"departure_time" : "14:47:28" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "14:48:19" , 
"departure_time" : "14:48:19" , 
"distance_traveled" : 10.0595
} ], 
"430" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "14:28:00" , 
"departure_time" : "14:29:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "14:31:36" , 
"departure_time" : "14:33:13" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "14:33:37" , 
"departure_time" : "14:33:50" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:35:13" , 
"departure_time" : "14:36:46" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:39:33" , 
"departure_time" : "14:39:43" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:39:10" , 
"departure_time" : "14:39:58" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:42:48" , 
"departure_time" : "14:43:59" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:45:11" , 
"departure_time" : "14:46:43" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:47:32" , 
"departure_time" : "14:48:40" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:49:08" , 
"departure_time" : "14:49:49" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:51:41" , 
"departure_time" : "14:53:18" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "14:57:37" , 
"departure_time" : "14:59:17" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "14:59:40" , 
"departure_time" : "15:00:38" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "15:01:58" , 
"departure_time" : "15:02:36" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "15:04:38" , 
"departure_time" : "15:06:13" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "15:07:35" , 
"departure_time" : "15:08:31" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "15:08:56" , 
"departure_time" : "15:08:56" , 
"distance_traveled" : 10.0595
} ], 
"431" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "14:48:00" , 
"departure_time" : "14:50:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "14:51:10" , 
"departure_time" : "14:51:48" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "14:52:38" , 
"departure_time" : "14:54:18" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:56:40" , 
"departure_time" : "14:56:50" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:58:10" , 
"departure_time" : "14:58:12" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:59:02" , 
"departure_time" : "14:59:31" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:02:29" , 
"departure_time" : "15:03:50" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:05:21" , 
"departure_time" : "15:06:13" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:06:52" , 
"departure_time" : "15:08:00" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:09:08" , 
"departure_time" : "15:10:11" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:12:03" , 
"departure_time" : "15:12:35" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "15:16:32" , 
"departure_time" : "15:17:50" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "15:19:18" , 
"departure_time" : "15:19:32" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "15:21:14" , 
"departure_time" : "15:21:37" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "15:24:23" , 
"departure_time" : "15:26:02" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "15:27:39" , 
"departure_time" : "15:28:31" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "15:28:52" , 
"departure_time" : "15:28:52" , 
"distance_traveled" : 10.0595
} ], 
"432" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "15:08:00" , 
"departure_time" : "15:09:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "15:10:41" , 
"departure_time" : "15:11:33" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "15:12:52" , 
"departure_time" : "15:12:54" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:15:02" , 
"departure_time" : "15:15:05" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:18:03" , 
"departure_time" : "15:18:14" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:19:11" , 
"departure_time" : "15:20:05" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:22:54" , 
"departure_time" : "15:23:27" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:24:33" , 
"departure_time" : "15:24:41" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:26:08" , 
"departure_time" : "15:27:09" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:29:01" , 
"departure_time" : "15:29:13" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:31:12" , 
"departure_time" : "15:32:35" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "15:37:23" , 
"departure_time" : "15:38:28" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "15:39:05" , 
"departure_time" : "15:39:39" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "15:41:34" , 
"departure_time" : "15:41:57" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "15:44:23" , 
"departure_time" : "15:45:21" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "15:46:58" , 
"departure_time" : "15:48:22" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "15:49:24" , 
"departure_time" : "15:49:24" , 
"distance_traveled" : 10.0595
} ], 
"433" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "15:28:00" , 
"departure_time" : "15:29:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "15:30:34" , 
"departure_time" : "15:30:47" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "15:32:13" , 
"departure_time" : "15:33:30" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:36:17" , 
"departure_time" : "15:36:52" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:38:35" , 
"departure_time" : "15:39:56" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:40:21" , 
"departure_time" : "15:41:58" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:43:37" , 
"departure_time" : "15:45:01" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:45:24" , 
"departure_time" : "15:45:39" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:46:15" , 
"departure_time" : "15:46:55" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:48:40" , 
"departure_time" : "15:49:26" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:51:46" , 
"departure_time" : "15:52:57" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "15:57:11" , 
"departure_time" : "15:58:24" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "15:59:13" , 
"departure_time" : "15:59:55" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:01:42" , 
"departure_time" : "16:03:13" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "16:05:31" , 
"departure_time" : "16:06:22" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:06:51" , 
"departure_time" : "16:07:23" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "16:08:32" , 
"departure_time" : "16:08:32" , 
"distance_traveled" : 10.0595
} ], 
"434" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "15:48:00" , 
"departure_time" : "15:49:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "15:50:31" , 
"departure_time" : "15:51:03" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "15:52:32" , 
"departure_time" : "15:53:37" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:56:05" , 
"departure_time" : "15:57:25" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:59:20" , 
"departure_time" : "16:00:52" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:00:32" , 
"departure_time" : "16:01:48" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:03:16" , 
"departure_time" : "16:03:28" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:04:12" , 
"departure_time" : "16:04:51" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:06:39" , 
"departure_time" : "16:06:41" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:08:02" , 
"departure_time" : "16:09:14" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:12:12" , 
"departure_time" : "16:12:17" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:16:05" , 
"departure_time" : "16:16:30" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:18:25" , 
"departure_time" : "16:19:53" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:22:28" , 
"departure_time" : "16:23:54" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "16:25:26" , 
"departure_time" : "16:26:32" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:27:06" , 
"departure_time" : "16:28:01" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "16:28:55" , 
"departure_time" : "16:28:55" , 
"distance_traveled" : 10.0595
} ], 
"435" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "16:08:00" , 
"departure_time" : "16:09:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "16:10:55" , 
"departure_time" : "16:12:25" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "16:13:30" , 
"departure_time" : "16:14:52" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:16:22" , 
"departure_time" : "16:16:42" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:18:20" , 
"departure_time" : "16:19:39" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:20:19" , 
"departure_time" : "16:21:37" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:23:18" , 
"departure_time" : "16:23:29" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:24:11" , 
"departure_time" : "16:25:47" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:27:36" , 
"departure_time" : "16:28:16" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:28:40" , 
"departure_time" : "16:29:03" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:31:23" , 
"departure_time" : "16:32:33" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:37:10" , 
"departure_time" : "16:37:28" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:38:18" , 
"departure_time" : "16:39:27" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:42:09" , 
"departure_time" : "16:43:25" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "16:45:16" , 
"departure_time" : "16:46:11" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:46:55" , 
"departure_time" : "16:47:44" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "16:48:49" , 
"departure_time" : "16:48:49" , 
"distance_traveled" : 10.0595
} ], 
"436" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "16:28:00" , 
"departure_time" : "16:30:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "16:31:36" , 
"departure_time" : "16:31:47" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "16:32:11" , 
"departure_time" : "16:33:31" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:36:20" , 
"departure_time" : "16:37:01" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:38:41" , 
"departure_time" : "16:38:52" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:39:11" , 
"departure_time" : "16:39:35" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:42:24" , 
"departure_time" : "16:42:52" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:44:28" , 
"departure_time" : "16:44:39" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:46:11" , 
"departure_time" : "16:46:27" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:48:16" , 
"departure_time" : "16:48:56" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:51:40" , 
"departure_time" : "16:53:00" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:57:20" , 
"departure_time" : "16:58:21" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:59:01" , 
"departure_time" : "16:59:26" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:01:25" , 
"departure_time" : "17:02:25" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:05:00" , 
"departure_time" : "17:05:36" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:06:36" , 
"departure_time" : "17:07:39" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "17:09:03" , 
"departure_time" : "17:09:03" , 
"distance_traveled" : 10.0595
} ], 
"437" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "16:48:00" , 
"departure_time" : "16:49:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "16:50:29" , 
"departure_time" : "16:51:40" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "16:53:11" , 
"departure_time" : "16:54:28" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:56:17" , 
"departure_time" : "16:56:30" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:58:13" , 
"departure_time" : "16:59:34" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:00:21" , 
"departure_time" : "17:01:17" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:02:56" , 
"departure_time" : "17:03:58" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:05:02" , 
"departure_time" : "17:05:40" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:06:38" , 
"departure_time" : "17:08:11" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:09:33" , 
"departure_time" : "17:09:46" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:11:13" , 
"departure_time" : "17:11:52" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:16:39" , 
"departure_time" : "17:18:10" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "17:19:31" , 
"departure_time" : "17:19:58" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:21:27" , 
"departure_time" : "17:21:50" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:24:23" , 
"departure_time" : "17:25:49" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:27:26" , 
"departure_time" : "17:27:49" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "17:28:23" , 
"departure_time" : "17:28:23" , 
"distance_traveled" : 10.0595
} ], 
"438" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "17:08:00" , 
"departure_time" : "17:09:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "17:10:53" , 
"departure_time" : "17:11:26" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "17:12:33" , 
"departure_time" : "17:12:41" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:15:08" , 
"departure_time" : "17:16:10" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:19:02" , 
"departure_time" : "17:19:10" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:19:08" , 
"departure_time" : "17:20:28" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:23:20" , 
"departure_time" : "17:24:59" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:25:39" , 
"departure_time" : "17:26:38" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:26:59" , 
"departure_time" : "17:27:32" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:28:33" , 
"departure_time" : "17:29:55" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:32:22" , 
"departure_time" : "17:32:27" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:36:05" , 
"departure_time" : "17:37:16" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "17:39:11" , 
"departure_time" : "17:39:47" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:41:36" , 
"departure_time" : "17:42:13" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:44:37" , 
"departure_time" : "17:45:45" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:47:08" , 
"departure_time" : "17:47:52" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "17:48:44" , 
"departure_time" : "17:48:44" , 
"distance_traveled" : 10.0595
} ], 
"439" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "17:28:00" , 
"departure_time" : "17:30:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "17:31:29" , 
"departure_time" : "17:31:51" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "17:32:22" , 
"departure_time" : "17:33:55" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:36:33" , 
"departure_time" : "17:37:33" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:39:00" , 
"departure_time" : "17:39:20" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:39:20" , 
"departure_time" : "17:39:49" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:42:29" , 
"departure_time" : "17:43:11" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:44:42" , 
"departure_time" : "17:46:11" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:47:29" , 
"departure_time" : "17:48:38" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:49:09" , 
"departure_time" : "17:50:40" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:52:31" , 
"departure_time" : "17:53:07" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:56:36" , 
"departure_time" : "17:56:39" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "17:58:03" , 
"departure_time" : "17:59:42" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:02:39" , 
"departure_time" : "18:04:18" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:05:39" , 
"departure_time" : "18:07:00" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:07:21" , 
"departure_time" : "18:08:04" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "18:08:43" , 
"departure_time" : "18:08:43" , 
"distance_traveled" : 10.0595
} ], 
"440" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "17:48:00" , 
"departure_time" : "17:50:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "17:51:27" , 
"departure_time" : "17:52:55" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "17:53:28" , 
"departure_time" : "17:53:53" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:55:25" , 
"departure_time" : "17:56:13" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:58:48" , 
"departure_time" : "17:59:26" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:59:38" , 
"departure_time" : "18:00:01" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:02:23" , 
"departure_time" : "18:02:57" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:04:34" , 
"departure_time" : "18:04:51" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:06:17" , 
"departure_time" : "18:07:48" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:09:31" , 
"departure_time" : "18:10:11" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:11:40" , 
"departure_time" : "18:12:59" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:17:19" , 
"departure_time" : "18:17:34" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:18:15" , 
"departure_time" : "18:19:38" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:22:23" , 
"departure_time" : "18:23:05" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:24:42" , 
"departure_time" : "18:26:12" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:27:30" , 
"departure_time" : "18:28:18" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "18:28:48" , 
"departure_time" : "18:28:48" , 
"distance_traveled" : 10.0595
} ], 
"441" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "18:08:00" , 
"departure_time" : "18:09:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "18:10:47" , 
"departure_time" : "18:11:49" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "18:13:02" , 
"departure_time" : "18:13:25" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:15:23" , 
"departure_time" : "18:16:52" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:19:29" , 
"departure_time" : "18:21:03" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:20:34" , 
"departure_time" : "18:21:48" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:23:14" , 
"departure_time" : "18:24:34" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:25:20" , 
"departure_time" : "18:26:46" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:27:26" , 
"departure_time" : "18:28:19" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:28:53" , 
"departure_time" : "18:30:18" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:32:25" , 
"departure_time" : "18:32:45" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:36:20" , 
"departure_time" : "18:36:55" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:38:35" , 
"departure_time" : "18:39:36" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:42:01" , 
"departure_time" : "18:42:17" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:44:16" , 
"departure_time" : "18:44:35" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:46:19" , 
"departure_time" : "18:46:35" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "18:48:16" , 
"departure_time" : "18:48:16" , 
"distance_traveled" : 10.0595
} ], 
"442" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "18:28:00" , 
"departure_time" : "18:29:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "18:30:55" , 
"departure_time" : "18:32:09" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "18:33:14" , 
"departure_time" : "18:34:50" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:36:36" , 
"departure_time" : "18:36:45" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:38:09" , 
"departure_time" : "18:38:36" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:39:27" , 
"departure_time" : "18:39:44" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:42:17" , 
"departure_time" : "18:42:27" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:44:10" , 
"departure_time" : "18:45:41" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:47:31" , 
"departure_time" : "18:49:07" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:49:36" , 
"departure_time" : "18:50:04" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:51:28" , 
"departure_time" : "18:52:09" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:56:41" , 
"departure_time" : "18:57:59" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:59:18" , 
"departure_time" : "18:59:39" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "19:01:21" , 
"departure_time" : "19:01:35" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "19:04:14" , 
"departure_time" : "19:05:06" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "19:06:52" , 
"departure_time" : "19:07:12" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "19:08:20" , 
"departure_time" : "19:08:20" , 
"distance_traveled" : 10.0595
} ], 
"443" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "18:48:00" , 
"departure_time" : "18:48:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "18:50:37" , 
"departure_time" : "18:52:09" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "18:53:32" , 
"departure_time" : "18:54:54" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:56:22" , 
"departure_time" : "18:57:48" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:59:26" , 
"departure_time" : "18:59:50" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:59:24" , 
"departure_time" : "19:00:14" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:02:50" , 
"departure_time" : "19:03:24" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:04:34" , 
"departure_time" : "19:06:10" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:07:36" , 
"departure_time" : "19:07:41" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:08:05" , 
"departure_time" : "19:08:55" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:11:50" , 
"departure_time" : "19:12:14" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "19:16:24" , 
"departure_time" : "19:17:28" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "19:19:04" , 
"departure_time" : "19:19:21" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "19:21:17" , 
"departure_time" : "19:21:25" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "19:24:08" , 
"departure_time" : "19:24:45" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "19:26:37" , 
"departure_time" : "19:27:18" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "19:28:41" , 
"departure_time" : "19:28:41" , 
"distance_traveled" : 10.0595
} ], 
"444" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "19:08:00" , 
"departure_time" : "19:09:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "19:10:44" , 
"departure_time" : "19:10:46" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "19:12:02" , 
"departure_time" : "19:13:26" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:16:24" , 
"departure_time" : "19:17:28" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:19:04" , 
"departure_time" : "19:19:05" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:19:01" , 
"departure_time" : "19:19:19" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:22:18" , 
"departure_time" : "19:22:40" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:24:22" , 
"departure_time" : "19:24:38" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:26:16" , 
"departure_time" : "19:26:37" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:28:21" , 
"departure_time" : "19:29:22" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:32:01" , 
"departure_time" : "19:33:17" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "19:37:16" , 
"departure_time" : "19:38:00" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "19:38:44" , 
"departure_time" : "19:39:45" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "19:42:01" , 
"departure_time" : "19:43:08" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "19:45:07" , 
"departure_time" : "19:46:45" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "19:47:38" , 
"departure_time" : "19:47:45" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "19:48:07" , 
"departure_time" : "19:48:07" , 
"distance_traveled" : 10.0595
} ], 
"445" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "19:28:00" , 
"departure_time" : "19:28:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "19:30:31" , 
"departure_time" : "19:31:22" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "19:32:51" , 
"departure_time" : "19:33:52" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:36:01" , 
"departure_time" : "19:36:14" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:38:13" , 
"departure_time" : "19:38:39" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:39:26" , 
"departure_time" : "19:40:04" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:42:38" , 
"departure_time" : "19:44:09" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:45:31" , 
"departure_time" : "19:46:47" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:47:16" , 
"departure_time" : "19:47:19" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:48:03" , 
"departure_time" : "19:48:11" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:51:08" , 
"departure_time" : "19:52:36" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "19:57:28" , 
"departure_time" : "19:58:19" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "19:58:51" , 
"departure_time" : "19:59:27" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "20:01:36" , 
"departure_time" : "20:03:01" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "20:05:25" , 
"departure_time" : "20:06:52" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "20:07:27" , 
"departure_time" : "20:07:35" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "20:08:08" , 
"departure_time" : "20:08:08" , 
"distance_traveled" : 10.0595
} ], 
"446" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "19:48:00" , 
"departure_time" : "19:48:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "19:50:43" , 
"departure_time" : "19:52:01" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "19:53:18" , 
"departure_time" : "19:53:36" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:55:18" , 
"departure_time" : "19:55:29" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:58:11" , 
"departure_time" : "19:58:19" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:59:08" , 
"departure_time" : "19:59:10" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:02:02" , 
"departure_time" : "20:03:42" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:05:40" , 
"departure_time" : "20:06:13" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:06:33" , 
"departure_time" : "20:06:38" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:08:05" , 
"departure_time" : "20:09:42" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:12:37" , 
"departure_time" : "20:14:05" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "20:17:28" , 
"departure_time" : "20:18:26" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "20:18:58" , 
"departure_time" : "20:19:02" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "20:21:04" , 
"departure_time" : "20:21:11" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "20:24:07" , 
"departure_time" : "20:24:27" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "20:26:20" , 
"departure_time" : "20:27:55" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "20:29:35" , 
"departure_time" : "20:29:35" , 
"distance_traveled" : 10.0595
} ], 
"447" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "20:08:00" , 
"departure_time" : "20:10:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "20:11:20" , 
"departure_time" : "20:12:40" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "20:13:20" , 
"departure_time" : "20:14:16" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:15:56" , 
"departure_time" : "20:16:44" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:18:48" , 
"departure_time" : "20:19:27" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:19:39" , 
"departure_time" : "20:21:05" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:23:26" , 
"departure_time" : "20:24:22" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:24:56" , 
"departure_time" : "20:25:44" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:26:48" , 
"departure_time" : "20:28:07" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:29:19" , 
"departure_time" : "20:29:41" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:31:22" , 
"departure_time" : "20:31:54" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "20:36:32" , 
"departure_time" : "20:36:40" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "20:38:08" , 
"departure_time" : "20:39:36" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "20:42:28" , 
"departure_time" : "20:43:08" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "20:44:40" , 
"departure_time" : "20:45:21" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "20:46:41" , 
"departure_time" : "20:47:47" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "20:49:06" , 
"departure_time" : "20:49:06" , 
"distance_traveled" : 10.0595
} ], 
"448" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "20:28:00" , 
"departure_time" : "20:29:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "20:30:11" , 
"departure_time" : "20:31:18" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "20:33:07" , 
"departure_time" : "20:33:17" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:35:10" , 
"departure_time" : "20:35:43" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:38:33" , 
"departure_time" : "20:39:32" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:39:59" , 
"departure_time" : "20:40:56" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:42:57" , 
"departure_time" : "20:43:24" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:44:27" , 
"departure_time" : "20:44:51" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:46:24" , 
"departure_time" : "20:46:32" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:48:08" , 
"departure_time" : "20:48:37" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:51:29" , 
"departure_time" : "20:51:34" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "20:56:05" , 
"departure_time" : "20:56:08" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "20:58:03" , 
"departure_time" : "20:58:04" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "21:01:01" , 
"departure_time" : "21:02:41" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "21:05:40" , 
"departure_time" : "21:06:19" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "21:06:39" , 
"departure_time" : "21:07:58" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "21:09:19" , 
"departure_time" : "21:09:19" , 
"distance_traveled" : 10.0595
} ], 
"449" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "20:48:00" , 
"departure_time" : "20:50:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "20:50:58" , 
"departure_time" : "20:51:36" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "20:52:38" , 
"departure_time" : "20:53:27" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:55:49" , 
"departure_time" : "20:57:17" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:59:28" , 
"departure_time" : "20:59:35" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:59:07" , 
"departure_time" : "21:00:37" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:03:30" , 
"departure_time" : "21:04:14" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "21:04:44" , 
"departure_time" : "21:04:47" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:06:03" , 
"departure_time" : "21:07:09" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:09:06" , 
"departure_time" : "21:10:33" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:12:27" , 
"departure_time" : "21:12:34" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "21:16:07" , 
"departure_time" : "21:17:42" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "21:19:35" , 
"departure_time" : "21:20:51" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "21:22:16" , 
"departure_time" : "21:23:52" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "21:25:36" , 
"departure_time" : "21:26:35" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "21:26:59" , 
"departure_time" : "21:27:25" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "21:28:26" , 
"departure_time" : "21:28:26" , 
"distance_traveled" : 10.0595
} ], 
"450" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "21:08:00" , 
"departure_time" : "21:08:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "21:10:33" , 
"departure_time" : "21:10:53" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "21:12:20" , 
"departure_time" : "21:13:07" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:15:47" , 
"departure_time" : "21:17:23" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "21:19:36" , 
"departure_time" : "21:20:05" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "21:19:29" , 
"departure_time" : "21:19:33" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:22:04" , 
"departure_time" : "21:22:29" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "21:24:25" , 
"departure_time" : "21:25:52" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:27:27" , 
"departure_time" : "21:27:55" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:28:28" , 
"departure_time" : "21:28:33" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:31:05" , 
"departure_time" : "21:31:41" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "21:36:36" , 
"departure_time" : "21:37:08" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "21:38:32" , 
"departure_time" : "21:40:09" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "21:42:37" , 
"departure_time" : "21:43:03" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "21:44:26" , 
"departure_time" : "21:45:19" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "21:46:53" , 
"departure_time" : "21:48:10" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "21:49:17" , 
"departure_time" : "21:49:17" , 
"distance_traveled" : 10.0595
} ], 
"451" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "21:28:00" , 
"departure_time" : "21:30:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "21:31:20" , 
"departure_time" : "21:31:33" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "21:32:13" , 
"departure_time" : "21:33:46" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:36:33" , 
"departure_time" : "21:37:26" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "21:38:53" , 
"departure_time" : "21:39:31" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "21:39:38" , 
"departure_time" : "21:40:26" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:42:48" , 
"departure_time" : "21:43:20" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "21:44:32" , 
"departure_time" : "21:46:08" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:47:36" , 
"departure_time" : "21:48:38" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:49:02" , 
"departure_time" : "21:50:30" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:52:28" , 
"departure_time" : "21:53:17" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "21:56:49" , 
"departure_time" : "21:58:23" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "21:59:34" , 
"departure_time" : "22:00:58" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "22:02:24" , 
"departure_time" : "22:02:27" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "22:04:03" , 
"departure_time" : "22:05:18" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "22:07:15" , 
"departure_time" : "22:08:10" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "22:08:55" , 
"departure_time" : "22:08:55" , 
"distance_traveled" : 10.0595
} ], 
"452" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "21:48:00" , 
"departure_time" : "21:50:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "21:51:20" , 
"departure_time" : "21:52:43" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "21:53:23" , 
"departure_time" : "21:54:20" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:55:57" , 
"departure_time" : "21:57:28" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "21:59:31" , 
"departure_time" : "22:00:04" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "21:59:33" , 
"departure_time" : "21:59:40" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:02:07" , 
"departure_time" : "22:03:12" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:05:05" , 
"departure_time" : "22:05:40" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:06:35" , 
"departure_time" : "22:08:00" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:09:25" , 
"departure_time" : "22:09:29" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:11:04" , 
"departure_time" : "22:12:37" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "22:17:33" , 
"departure_time" : "22:18:54" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "22:19:21" , 
"departure_time" : "22:20:28" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "22:22:07" , 
"departure_time" : "22:23:12" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "22:25:05" , 
"departure_time" : "22:25:42" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "22:26:37" , 
"departure_time" : "22:27:21" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "22:28:44" , 
"departure_time" : "22:28:44" , 
"distance_traveled" : 10.0595
} ], 
"453" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "22:08:00" , 
"departure_time" : "22:09:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "22:10:45" , 
"departure_time" : "22:10:59" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "22:12:14" , 
"departure_time" : "22:12:32" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:15:18" , 
"departure_time" : "22:15:25" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:18:07" , 
"departure_time" : "22:19:36" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:20:29" , 
"departure_time" : "22:20:40" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:22:11" , 
"departure_time" : "22:23:17" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:25:06" , 
"departure_time" : "22:26:22" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:27:16" , 
"departure_time" : "22:27:27" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:28:11" , 
"departure_time" : "22:28:58" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:31:47" , 
"departure_time" : "22:32:27" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "22:36:40" , 
"departure_time" : "22:38:04" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "22:39:24" , 
"departure_time" : "22:40:28" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "22:42:04" , 
"departure_time" : "22:42:42" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "22:44:38" , 
"departure_time" : "22:46:01" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "22:47:23" , 
"departure_time" : "22:48:44" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "22:49:21" , 
"departure_time" : "22:49:21" , 
"distance_traveled" : 10.0595
} ], 
"454" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "22:28:00" , 
"departure_time" : "22:30:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "22:31:36" , 
"departure_time" : "22:32:20" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "22:32:44" , 
"departure_time" : "22:33:32" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:35:48" , 
"departure_time" : "22:37:02" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:39:14" , 
"departure_time" : "22:40:05" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:39:51" , 
"departure_time" : "22:40:30" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:42:39" , 
"departure_time" : "22:44:01" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:45:22" , 
"departure_time" : "22:45:41" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:46:19" , 
"departure_time" : "22:46:36" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:48:17" , 
"departure_time" : "22:49:24" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:52:07" , 
"departure_time" : "22:52:53" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "22:56:46" , 
"departure_time" : "22:56:49" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "22:58:03" , 
"departure_time" : "22:59:41" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "23:02:38" , 
"departure_time" : "23:03:34" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "23:04:56" , 
"departure_time" : "23:05:47" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "23:06:51" , 
"departure_time" : "23:07:23" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "23:08:32" , 
"departure_time" : "23:08:32" , 
"distance_traveled" : 10.0595
} ], 
"455" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "22:48:00" , 
"departure_time" : "22:49:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "22:51:15" , 
"departure_time" : "22:52:36" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "22:53:21" , 
"departure_time" : "22:53:40" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:55:19" , 
"departure_time" : "22:56:15" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:58:56" , 
"departure_time" : "23:00:33" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "23:00:37" , 
"departure_time" : "23:02:03" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:03:26" , 
"departure_time" : "23:05:00" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:05:34" , 
"departure_time" : "23:06:12" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:06:38" , 
"departure_time" : "23:06:50" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:08:12" , 
"departure_time" : "23:08:47" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:11:35" , 
"departure_time" : "23:12:58" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "23:17:23" , 
"departure_time" : "23:17:43" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "23:18:20" , 
"departure_time" : "23:19:24" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "23:22:04" , 
"departure_time" : "23:22:52" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "23:24:48" , 
"departure_time" : "23:26:20" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "23:27:32" , 
"departure_time" : "23:27:53" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "23:28:21" , 
"departure_time" : "23:28:21" , 
"distance_traveled" : 10.0595
} ], 
"456" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "23:08:00" , 
"departure_time" : "23:09:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "23:11:14" , 
"departure_time" : "23:12:30" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "23:13:16" , 
"departure_time" : "23:13:55" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:15:39" , 
"departure_time" : "23:16:36" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:18:57" , 
"departure_time" : "23:20:31" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "23:20:34" , 
"departure_time" : "23:20:40" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:22:06" , 
"departure_time" : "23:22:22" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:24:16" , 
"departure_time" : "23:25:34" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:27:18" , 
"departure_time" : "23:27:20" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:28:02" , 
"departure_time" : "23:28:53" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:31:51" , 
"departure_time" : "23:33:30" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "23:37:39" , 
"departure_time" : "23:37:49" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "23:38:10" , 
"departure_time" : "23:39:49" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "23:42:39" , 
"departure_time" : "23:44:11" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "23:45:32" , 
"departure_time" : "23:45:34" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "23:46:02" , 
"departure_time" : "23:47:03" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "23:49:01" , 
"departure_time" : "23:49:01" , 
"distance_traveled" : 10.0595
} ], 
"457" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "23:28:00" , 
"departure_time" : "23:29:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "23:30:39" , 
"departure_time" : "23:31:58" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "23:33:19" , 
"departure_time" : "23:34:14" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:35:55" , 
"departure_time" : "23:36:37" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:38:42" , 
"departure_time" : "23:39:53" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "23:40:11" , 
"departure_time" : "23:41:19" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:43:08" , 
"departure_time" : "23:44:39" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:45:31" , 
"departure_time" : "23:47:11" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:47:40" , 
"departure_time" : "23:48:03" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:48:23" , 
"departure_time" : "23:48:50" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:51:27" , 
"departure_time" : "23:53:07" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "23:57:40" , 
"departure_time" : "23:58:43" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "23:59:03" , 
"departure_time" : "23:59:55" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "24:01:52" , 
"departure_time" : "24:02:48" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "24:04:56" , 
"departure_time" : "24:06:32" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "24:07:36" , 
"departure_time" : "24:09:02" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "24:09:26" , 
"departure_time" : "24:09:26" , 
"distance_traveled" : 10.0595
} ], 
"458" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "23:48:00" , 
"departure_time" : "23:51:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "23:51:39" , 
"departure_time" : "23:52:32" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "23:52:53" , 
"departure_time" : "23:54:27" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:56:34" , 
"departure_time" : "23:57:18" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:58:44" , 
"departure_time" : "23:59:56" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "24:00:12" , 
"departure_time" : "24:01:14" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "24:03:02" , 
"departure_time" : "24:03:42" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "24:04:40" , 
"departure_time" : "24:05:09" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "24:06:29" , 
"departure_time" : "24:07:32" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "24:09:03" , 
"departure_time" : "24:10:35" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "24:12:32" , 
"departure_time" : "24:13:29" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "24:16:57" , 
"departure_time" : "24:17:20" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "24:18:23" , 
"departure_time" : "24:19:40" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "24:22:17" , 
"departure_time" : "24:22:23" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "24:24:06" , 
"departure_time" : "24:25:45" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "24:27:39" , 
"departure_time" : "24:27:57" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "24:28:18" , 
"departure_time" : "24:28:18" , 
"distance_traveled" : 10.0595
} ], 
"459" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "24:18:00" , 
"departure_time" : "24:18:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "24:20:33" , 
"departure_time" : "24:21:06" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "24:22:33" , 
"departure_time" : "24:22:58" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "24:25:25" , 
"departure_time" : "24:27:03" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "24:29:38" , 
"departure_time" : "24:31:02" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "24:30:24" , 
"departure_time" : "24:31:19" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "24:32:55" , 
"departure_time" : "24:34:16" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "24:35:21" , 
"departure_time" : "24:35:30" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "24:36:09" , 
"departure_time" : "24:36:18" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "24:38:09" , 
"departure_time" : "24:39:08" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "24:41:59" , 
"departure_time" : "24:43:03" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "24:47:04" , 
"departure_time" : "24:47:59" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "24:48:55" , 
"departure_time" : "24:50:24" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "24:52:29" , 
"departure_time" : "24:53:21" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "24:54:52" , 
"departure_time" : "24:56:19" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "24:57:27" , 
"departure_time" : "24:58:59" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "24:59:32" , 
"departure_time" : "24:59:32" , 
"distance_traveled" : 10.0595
} ], 
"460" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "24:48:00" , 
"departure_time" : "24:50:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "24:50:30" , 
"departure_time" : "24:50:34" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "24:52:04" , 
"departure_time" : "24:53:25" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "24:56:21" , 
"departure_time" : "24:57:27" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "24:59:06" , 
"departure_time" : "24:59:42" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "24:59:36" , 
"departure_time" : "25:01:16" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "25:03:40" , 
"departure_time" : "25:04:47" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "25:05:07" , 
"departure_time" : "25:06:01" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "25:06:54" , 
"departure_time" : "25:08:01" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "25:09:07" , 
"departure_time" : "25:10:33" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "25:12:26" , 
"departure_time" : "25:13:25" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "25:16:59" , 
"departure_time" : "25:18:33" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "25:19:34" , 
"departure_time" : "25:21:03" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "25:22:29" , 
"departure_time" : "25:23:48" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "25:25:19" , 
"departure_time" : "25:26:40" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "25:27:21" , 
"departure_time" : "25:27:58" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "25:28:37" , 
"departure_time" : "25:28:37" , 
"distance_traveled" : 10.0595
} ], 
"461" :  [ 
{ 
"stop_id" : 36998,
"arrival_time" : "05:20:00" , 
"departure_time" : "05:21:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "05:23:34" , 
"departure_time" : "05:24:51" , 
"distance_traveled" : 0.6824
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "05:25:17" , 
"departure_time" : "05:26:56" , 
"distance_traveled" : 0.9598
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "05:27:39" , 
"departure_time" : "05:27:55" , 
"distance_traveled" : 1.3676
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "05:28:16" , 
"departure_time" : "05:28:54" , 
"distance_traveled" : 1.6621
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "05:30:38" , 
"departure_time" : "05:30:51" , 
"distance_traveled" : 1.9112
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "05:32:13" , 
"departure_time" : "05:33:03" , 
"distance_traveled" : 2.2581
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "05:35:50" , 
"departure_time" : "05:36:54" , 
"distance_traveled" : 2.5511
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "05:40:04" , 
"departure_time" : "05:40:04" , 
"distance_traveled" : 3.4288
} ], 
"462" :  [ 
{ 
"stop_id" : 36998,
"arrival_time" : "05:41:00" , 
"departure_time" : "05:42:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "05:44:15" , 
"departure_time" : "05:45:32" , 
"distance_traveled" : 0.6824
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "05:46:17" , 
"departure_time" : "05:47:27" , 
"distance_traveled" : 0.9598
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "05:48:10" , 
"departure_time" : "05:48:18" , 
"distance_traveled" : 1.3676
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "05:49:08" , 
"departure_time" : "05:50:26" , 
"distance_traveled" : 1.6621
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "05:52:18" , 
"departure_time" : "05:52:22" , 
"distance_traveled" : 1.9112
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "05:53:04" , 
"departure_time" : "05:53:46" , 
"distance_traveled" : 2.2581
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "05:56:42" , 
"departure_time" : "05:57:29" , 
"distance_traveled" : 2.5511
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "06:00:47" , 
"departure_time" : "06:00:47" , 
"distance_traveled" : 3.4288
} ], 
"463" :  [ 
{ 
"stop_id" : 36998,
"arrival_time" : "06:01:00" , 
"departure_time" : "06:02:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:04:31" , 
"departure_time" : "06:06:01" , 
"distance_traveled" : 0.6824
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:06:30" , 
"departure_time" : "06:08:06" , 
"distance_traveled" : 0.9598
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:08:36" , 
"departure_time" : "06:09:08" , 
"distance_traveled" : 1.3676
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:09:32" , 
"departure_time" : "06:10:23" , 
"distance_traveled" : 1.6621
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:11:51" , 
"departure_time" : "06:13:31" , 
"distance_traveled" : 1.9112
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:14:40" , 
"departure_time" : "06:15:03" , 
"distance_traveled" : 2.2581
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:16:23" , 
"departure_time" : "06:16:53" , 
"distance_traveled" : 2.5511
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "06:20:30" , 
"departure_time" : "06:20:30" , 
"distance_traveled" : 3.4288
} ], 
"464" :  [ 
{ 
"stop_id" : 36998,
"arrival_time" : "05:35:00" , 
"departure_time" : "05:35:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "05:38:10" , 
"departure_time" : "05:39:32" , 
"distance_traveled" : 0.6824
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "05:40:22" , 
"departure_time" : "05:41:45" , 
"distance_traveled" : 0.9598
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "05:43:23" , 
"departure_time" : "05:43:34" , 
"distance_traveled" : 1.3676
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "05:44:11" , 
"departure_time" : "05:45:47" , 
"distance_traveled" : 1.6621
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "05:47:36" , 
"departure_time" : "05:48:43" , 
"distance_traveled" : 1.9112
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "05:49:07" , 
"departure_time" : "05:50:11" , 
"distance_traveled" : 2.2581
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "05:52:04" , 
"departure_time" : "05:53:14" , 
"distance_traveled" : 2.5511
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "05:57:10" , 
"departure_time" : "05:58:07" , 
"distance_traveled" : 3.9917
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "05:58:57" , 
"departure_time" : "05:59:04" , 
"distance_traveled" : 4.5428
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "06:01:07" , 
"departure_time" : "06:02:00" , 
"distance_traveled" : 5.825
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "06:04:53" , 
"departure_time" : "06:05:18" , 
"distance_traveled" : 6.9854
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "06:06:25" , 
"departure_time" : "06:07:00" , 
"distance_traveled" : 7.6831
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "06:08:35" , 
"departure_time" : "06:08:35" , 
"distance_traveled" : 8.2778
} ], 
"465" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "05:45:00" , 
"departure_time" : "05:47:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "05:49:25" , 
"departure_time" : "05:51:04" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "05:51:39" , 
"departure_time" : "05:52:11" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "05:52:32" , 
"departure_time" : "05:53:24" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "05:54:52" , 
"departure_time" : "05:55:19" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "05:56:27" , 
"departure_time" : "05:56:50" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "05:58:23" , 
"departure_time" : "05:58:36" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "05:59:13" , 
"departure_time" : "05:59:41" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:02:28" , 
"departure_time" : "06:03:50" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "06:06:22" , 
"departure_time" : "06:07:28" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "06:07:06" , 
"departure_time" : "06:07:12" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "06:08:06" , 
"departure_time" : "06:08:12" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "06:10:06" , 
"departure_time" : "06:11:27" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "06:13:21" , 
"departure_time" : "06:14:48" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "06:16:27" , 
"departure_time" : "06:16:27" , 
"distance_traveled" : 9.0369
} ], 
"466" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "06:05:00" , 
"departure_time" : "06:07:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:08:51" , 
"departure_time" : "06:09:55" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:11:04" , 
"departure_time" : "06:11:17" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:12:13" , 
"departure_time" : "06:12:58" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:14:45" , 
"departure_time" : "06:15:14" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:16:29" , 
"departure_time" : "06:17:05" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:18:36" , 
"departure_time" : "06:18:55" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:19:19" , 
"departure_time" : "06:19:52" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:22:33" , 
"departure_time" : "06:23:31" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "06:25:58" , 
"departure_time" : "06:27:13" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "06:27:15" , 
"departure_time" : "06:28:19" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "06:29:04" , 
"departure_time" : "06:29:21" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "06:30:17" , 
"departure_time" : "06:31:00" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "06:32:43" , 
"departure_time" : "06:34:02" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "06:36:19" , 
"departure_time" : "06:36:19" , 
"distance_traveled" : 9.0369
} ], 
"467" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "06:25:00" , 
"departure_time" : "06:26:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:28:29" , 
"departure_time" : "06:29:04" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:30:35" , 
"departure_time" : "06:31:37" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:33:02" , 
"departure_time" : "06:34:28" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:35:26" , 
"departure_time" : "06:35:48" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:36:22" , 
"departure_time" : "06:37:21" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:38:59" , 
"departure_time" : "06:39:55" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:39:56" , 
"departure_time" : "06:40:54" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:42:58" , 
"departure_time" : "06:44:09" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "06:46:11" , 
"departure_time" : "06:46:42" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "06:46:31" , 
"departure_time" : "06:47:58" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "06:49:27" , 
"departure_time" : "06:50:23" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "06:50:56" , 
"departure_time" : "06:52:26" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "06:53:30" , 
"departure_time" : "06:54:56" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "06:56:26" , 
"departure_time" : "06:56:26" , 
"distance_traveled" : 9.0369
} ], 
"468" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "06:45:00" , 
"departure_time" : "06:47:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:48:47" , 
"departure_time" : "06:48:54" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:50:07" , 
"departure_time" : "06:51:27" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:53:20" , 
"departure_time" : "06:53:57" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:54:37" , 
"departure_time" : "06:55:42" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:57:05" , 
"departure_time" : "06:57:31" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:58:26" , 
"departure_time" : "06:59:18" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:59:52" , 
"departure_time" : "07:01:12" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:03:20" , 
"departure_time" : "07:04:08" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "07:05:48" , 
"departure_time" : "07:06:51" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "07:07:03" , 
"departure_time" : "07:08:30" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "07:09:27" , 
"departure_time" : "07:09:38" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "07:10:11" , 
"departure_time" : "07:11:24" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "07:13:13" , 
"departure_time" : "07:14:15" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "07:16:02" , 
"departure_time" : "07:16:02" , 
"distance_traveled" : 9.0369
} ], 
"469" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "07:05:00" , 
"departure_time" : "07:06:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:08:35" , 
"departure_time" : "07:09:52" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:11:17" , 
"departure_time" : "07:11:28" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:12:11" , 
"departure_time" : "07:12:12" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:14:01" , 
"departure_time" : "07:15:26" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:17:25" , 
"departure_time" : "07:18:52" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:19:27" , 
"departure_time" : "07:20:40" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:20:13" , 
"departure_time" : "07:21:08" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:22:55" , 
"departure_time" : "07:24:31" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "07:26:36" , 
"departure_time" : "07:27:23" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "07:26:47" , 
"departure_time" : "07:28:20" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "07:29:33" , 
"departure_time" : "07:30:37" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "07:31:04" , 
"departure_time" : "07:31:50" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "07:32:46" , 
"departure_time" : "07:33:17" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "07:35:31" , 
"departure_time" : "07:35:31" , 
"distance_traveled" : 9.0369
} ], 
"470" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "07:25:00" , 
"departure_time" : "07:26:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:29:18" , 
"departure_time" : "07:29:51" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:30:33" , 
"departure_time" : "07:31:46" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:33:13" , 
"departure_time" : "07:33:34" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:34:21" , 
"departure_time" : "07:35:42" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:37:21" , 
"departure_time" : "07:38:51" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:39:30" , 
"departure_time" : "07:40:53" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:40:23" , 
"departure_time" : "07:41:33" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:43:10" , 
"departure_time" : "07:44:17" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "07:46:07" , 
"departure_time" : "07:47:37" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "07:47:30" , 
"departure_time" : "07:49:07" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "07:49:37" , 
"departure_time" : "07:51:01" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "07:51:24" , 
"departure_time" : "07:51:47" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "07:52:23" , 
"departure_time" : "07:52:24" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "07:55:01" , 
"departure_time" : "07:55:01" , 
"distance_traveled" : 9.0369
} ], 
"471" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "07:45:00" , 
"departure_time" : "07:46:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:49:27" , 
"departure_time" : "07:50:33" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:51:06" , 
"departure_time" : "07:52:17" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:53:11" , 
"departure_time" : "07:53:56" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:54:45" , 
"departure_time" : "07:55:05" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:56:20" , 
"departure_time" : "07:57:18" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:58:58" , 
"departure_time" : "08:00:17" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:00:19" , 
"departure_time" : "08:01:14" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:02:55" , 
"departure_time" : "08:03:33" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "08:05:38" , 
"departure_time" : "08:06:11" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "08:06:33" , 
"departure_time" : "08:07:26" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "08:08:53" , 
"departure_time" : "08:09:24" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "08:10:31" , 
"departure_time" : "08:11:25" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "08:12:54" , 
"departure_time" : "08:14:08" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "08:16:14" , 
"departure_time" : "08:16:14" , 
"distance_traveled" : 9.0369
} ], 
"472" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "08:05:00" , 
"departure_time" : "08:07:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:09:28" , 
"departure_time" : "08:10:05" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:10:37" , 
"departure_time" : "08:10:57" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:12:20" , 
"departure_time" : "08:13:36" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:15:16" , 
"departure_time" : "08:16:14" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:16:58" , 
"departure_time" : "08:18:11" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:19:13" , 
"departure_time" : "08:20:26" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:20:13" , 
"departure_time" : "08:20:17" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:22:04" , 
"departure_time" : "08:23:31" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "08:26:27" , 
"departure_time" : "08:27:29" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "08:27:02" , 
"departure_time" : "08:28:18" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "08:29:16" , 
"departure_time" : "08:30:53" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "08:31:37" , 
"departure_time" : "08:32:39" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "08:33:02" , 
"departure_time" : "08:34:32" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "08:36:30" , 
"departure_time" : "08:36:30" , 
"distance_traveled" : 9.0369
} ], 
"473" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "08:25:00" , 
"departure_time" : "08:27:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:29:01" , 
"departure_time" : "08:30:19" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:31:18" , 
"departure_time" : "08:31:47" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:32:29" , 
"departure_time" : "08:33:21" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:34:52" , 
"departure_time" : "08:34:53" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:36:01" , 
"departure_time" : "08:36:42" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:38:41" , 
"departure_time" : "08:40:07" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:40:26" , 
"departure_time" : "08:41:57" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:43:31" , 
"departure_time" : "08:44:22" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "08:45:51" , 
"departure_time" : "08:46:15" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "08:46:24" , 
"departure_time" : "08:46:33" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "08:48:09" , 
"departure_time" : "08:48:53" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "08:50:44" , 
"departure_time" : "08:51:05" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "08:52:21" , 
"departure_time" : "08:52:23" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "08:55:02" , 
"departure_time" : "08:55:02" , 
"distance_traveled" : 9.0369
} ], 
"474" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "08:45:00" , 
"departure_time" : "08:45:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:48:49" , 
"departure_time" : "08:48:50" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:50:01" , 
"departure_time" : "08:50:08" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:52:07" , 
"departure_time" : "08:53:44" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:55:37" , 
"departure_time" : "08:56:17" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:56:40" , 
"departure_time" : "08:58:20" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:59:40" , 
"departure_time" : "09:01:04" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:00:24" , 
"departure_time" : "09:01:55" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:03:31" , 
"departure_time" : "09:04:36" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "09:06:05" , 
"departure_time" : "09:06:35" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "09:06:30" , 
"departure_time" : "09:07:31" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "09:09:01" , 
"departure_time" : "09:09:33" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "09:10:32" , 
"departure_time" : "09:11:42" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "09:13:10" , 
"departure_time" : "09:14:16" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "09:16:06" , 
"departure_time" : "09:16:06" , 
"distance_traveled" : 9.0369
} ], 
"475" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "09:05:00" , 
"departure_time" : "09:07:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:09:16" , 
"departure_time" : "09:10:37" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:11:21" , 
"departure_time" : "09:12:54" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:13:33" , 
"departure_time" : "09:14:54" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:15:21" , 
"departure_time" : "09:15:32" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:16:11" , 
"departure_time" : "09:17:33" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:19:22" , 
"departure_time" : "09:20:46" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:20:24" , 
"departure_time" : "09:20:48" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:22:24" , 
"departure_time" : "09:23:23" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "09:25:59" , 
"departure_time" : "09:26:51" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "09:26:52" , 
"departure_time" : "09:28:14" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "09:29:22" , 
"departure_time" : "09:30:22" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "09:31:00" , 
"departure_time" : "09:32:10" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "09:33:10" , 
"departure_time" : "09:34:40" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "09:36:30" , 
"departure_time" : "09:36:30" , 
"distance_traveled" : 9.0369
} ], 
"476" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "09:25:00" , 
"departure_time" : "09:26:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:28:27" , 
"departure_time" : "09:29:11" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:30:44" , 
"departure_time" : "09:30:55" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:32:11" , 
"departure_time" : "09:33:31" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:35:20" , 
"departure_time" : "09:36:29" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:37:09" , 
"departure_time" : "09:37:58" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:38:49" , 
"departure_time" : "09:39:51" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:40:02" , 
"departure_time" : "09:41:25" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:43:23" , 
"departure_time" : "09:43:35" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "09:45:12" , 
"departure_time" : "09:45:47" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "09:46:35" , 
"departure_time" : "09:47:26" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "09:48:51" , 
"departure_time" : "09:49:15" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "09:50:24" , 
"departure_time" : "09:51:03" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "09:52:39" , 
"departure_time" : "09:52:56" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "09:55:17" , 
"departure_time" : "09:55:17" , 
"distance_traveled" : 9.0369
} ], 
"477" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "09:45:00" , 
"departure_time" : "09:46:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:49:02" , 
"departure_time" : "09:49:28" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:50:26" , 
"departure_time" : "09:51:14" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:52:48" , 
"departure_time" : "09:54:23" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:55:35" , 
"departure_time" : "09:56:45" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:57:10" , 
"departure_time" : "09:58:28" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:59:18" , 
"departure_time" : "10:00:30" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:00:12" , 
"departure_time" : "10:01:42" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:03:30" , 
"departure_time" : "10:05:06" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "10:06:36" , 
"departure_time" : "10:07:16" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "10:06:40" , 
"departure_time" : "10:06:44" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "10:08:04" , 
"departure_time" : "10:09:14" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "10:11:10" , 
"departure_time" : "10:12:21" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "10:13:11" , 
"departure_time" : "10:13:39" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "10:15:28" , 
"departure_time" : "10:15:28" , 
"distance_traveled" : 9.0369
} ], 
"478" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "10:05:00" , 
"departure_time" : "10:06:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:08:42" , 
"departure_time" : "10:09:15" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:10:33" , 
"departure_time" : "10:11:32" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:12:59" , 
"departure_time" : "10:13:11" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:14:12" , 
"departure_time" : "10:15:33" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:17:21" , 
"departure_time" : "10:18:23" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:19:02" , 
"departure_time" : "10:19:50" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:19:48" , 
"departure_time" : "10:20:07" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:22:19" , 
"departure_time" : "10:23:32" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "10:26:13" , 
"departure_time" : "10:27:44" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "10:27:31" , 
"departure_time" : "10:27:33" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "10:28:02" , 
"departure_time" : "10:28:52" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "10:30:50" , 
"departure_time" : "10:31:52" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "10:33:02" , 
"departure_time" : "10:34:39" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "10:36:37" , 
"departure_time" : "10:36:37" , 
"distance_traveled" : 9.0369
} ], 
"479" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "10:25:00" , 
"departure_time" : "10:26:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:28:14" , 
"departure_time" : "10:29:08" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:30:54" , 
"departure_time" : "10:31:13" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:32:19" , 
"departure_time" : "10:32:21" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:34:02" , 
"departure_time" : "10:34:35" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:36:33" , 
"departure_time" : "10:36:46" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:38:13" , 
"departure_time" : "10:38:40" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:39:27" , 
"departure_time" : "10:40:43" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:43:16" , 
"departure_time" : "10:43:55" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "10:45:39" , 
"departure_time" : "10:46:02" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "10:46:23" , 
"departure_time" : "10:47:27" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "10:49:04" , 
"departure_time" : "10:50:36" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "10:51:32" , 
"departure_time" : "10:52:14" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "10:52:42" , 
"departure_time" : "10:54:05" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "10:56:23" , 
"departure_time" : "10:56:23" , 
"distance_traveled" : 9.0369
} ], 
"480" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "10:45:00" , 
"departure_time" : "10:46:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:48:07" , 
"departure_time" : "10:48:18" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:50:11" , 
"departure_time" : "10:51:46" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:53:35" , 
"departure_time" : "10:53:39" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:54:04" , 
"departure_time" : "10:55:08" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:57:04" , 
"departure_time" : "10:58:20" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:59:16" , 
"departure_time" : "11:00:16" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:00:00" , 
"departure_time" : "11:00:34" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:02:34" , 
"departure_time" : "11:03:54" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "11:06:20" , 
"departure_time" : "11:07:10" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "11:06:50" , 
"departure_time" : "11:07:05" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "11:08:15" , 
"departure_time" : "11:09:31" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "11:11:16" , 
"departure_time" : "11:11:23" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "11:12:07" , 
"departure_time" : "11:13:31" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "11:16:24" , 
"departure_time" : "11:16:24" , 
"distance_traveled" : 9.0369
} ], 
"481" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "11:05:00" , 
"departure_time" : "11:07:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:09:18" , 
"departure_time" : "11:10:44" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:11:26" , 
"departure_time" : "11:12:08" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:12:42" , 
"departure_time" : "11:14:17" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:15:35" , 
"departure_time" : "11:15:41" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:16:06" , 
"departure_time" : "11:16:15" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:18:09" , 
"departure_time" : "11:18:24" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:19:15" , 
"departure_time" : "11:20:30" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:23:15" , 
"departure_time" : "11:23:53" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "11:25:38" , 
"departure_time" : "11:26:14" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "11:26:36" , 
"departure_time" : "11:27:59" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "11:29:23" , 
"departure_time" : "11:29:45" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "11:30:22" , 
"departure_time" : "11:30:38" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "11:32:16" , 
"departure_time" : "11:33:05" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "11:35:49" , 
"departure_time" : "11:35:49" , 
"distance_traveled" : 9.0369
} ], 
"482" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "11:25:00" , 
"departure_time" : "11:26:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:29:10" , 
"departure_time" : "11:30:30" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:31:20" , 
"departure_time" : "11:31:54" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:32:34" , 
"departure_time" : "11:33:46" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:35:12" , 
"departure_time" : "11:36:00" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:36:48" , 
"departure_time" : "11:38:28" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:39:40" , 
"departure_time" : "11:40:09" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:39:29" , 
"departure_time" : "11:40:15" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:42:46" , 
"departure_time" : "11:43:36" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "11:45:50" , 
"departure_time" : "11:46:01" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "11:46:11" , 
"departure_time" : "11:47:21" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "11:49:10" , 
"departure_time" : "11:49:37" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "11:50:27" , 
"departure_time" : "11:50:41" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "11:52:14" , 
"departure_time" : "11:52:39" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "11:55:25" , 
"departure_time" : "11:55:25" , 
"distance_traveled" : 9.0369
} ], 
"483" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "11:45:00" , 
"departure_time" : "11:45:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:48:04" , 
"departure_time" : "11:49:19" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:51:15" , 
"departure_time" : "11:51:38" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:52:23" , 
"departure_time" : "11:53:36" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:55:13" , 
"departure_time" : "11:56:51" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:57:38" , 
"departure_time" : "11:59:07" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:59:29" , 
"departure_time" : "12:00:46" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:00:17" , 
"departure_time" : "12:01:42" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:03:25" , 
"departure_time" : "12:03:39" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "12:05:14" , 
"departure_time" : "12:05:24" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "12:06:10" , 
"departure_time" : "12:07:26" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "12:09:16" , 
"departure_time" : "12:10:24" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "12:11:08" , 
"departure_time" : "12:11:45" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "12:12:37" , 
"departure_time" : "12:13:53" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "12:16:16" , 
"departure_time" : "12:16:16" , 
"distance_traveled" : 9.0369
} ], 
"484" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "12:05:00" , 
"departure_time" : "12:07:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:08:45" , 
"departure_time" : "12:10:00" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:11:15" , 
"departure_time" : "12:12:29" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:13:14" , 
"departure_time" : "12:14:35" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:15:21" , 
"departure_time" : "12:16:06" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:16:45" , 
"departure_time" : "12:18:00" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:19:15" , 
"departure_time" : "12:19:33" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:19:18" , 
"departure_time" : "12:20:16" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:22:58" , 
"departure_time" : "12:23:43" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "12:25:45" , 
"departure_time" : "12:27:25" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "12:27:40" , 
"departure_time" : "12:28:07" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "12:28:27" , 
"departure_time" : "12:29:14" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "12:30:47" , 
"departure_time" : "12:32:03" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "12:33:16" , 
"departure_time" : "12:33:33" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "12:35:17" , 
"departure_time" : "12:35:17" , 
"distance_traveled" : 9.0369
} ], 
"485" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "12:25:00" , 
"departure_time" : "12:26:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:28:47" , 
"departure_time" : "12:29:54" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:31:07" , 
"departure_time" : "12:32:41" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:33:34" , 
"departure_time" : "12:34:32" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:34:58" , 
"departure_time" : "12:35:22" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:36:24" , 
"departure_time" : "12:37:40" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:39:16" , 
"departure_time" : "12:39:38" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:39:22" , 
"departure_time" : "12:40:13" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:42:51" , 
"departure_time" : "12:44:18" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "12:46:27" , 
"departure_time" : "12:48:00" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "12:47:33" , 
"departure_time" : "12:47:53" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "12:48:20" , 
"departure_time" : "12:48:57" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "12:50:37" , 
"departure_time" : "12:52:12" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "12:53:35" , 
"departure_time" : "12:54:27" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "12:55:52" , 
"departure_time" : "12:55:52" , 
"distance_traveled" : 9.0369
} ], 
"486" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "12:45:00" , 
"departure_time" : "12:46:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:49:06" , 
"departure_time" : "12:50:21" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:51:15" , 
"departure_time" : "12:52:25" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:53:10" , 
"departure_time" : "12:53:22" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:54:12" , 
"departure_time" : "12:54:28" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:56:16" , 
"departure_time" : "12:57:35" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:59:19" , 
"departure_time" : "13:00:32" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:00:13" , 
"departure_time" : "13:00:54" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:02:41" , 
"departure_time" : "13:03:10" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "13:05:29" , 
"departure_time" : "13:05:35" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "13:06:06" , 
"departure_time" : "13:06:35" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "13:08:29" , 
"departure_time" : "13:08:51" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "13:10:22" , 
"departure_time" : "13:10:33" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "13:12:11" , 
"departure_time" : "13:12:57" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "13:15:46" , 
"departure_time" : "13:15:46" , 
"distance_traveled" : 9.0369
} ], 
"487" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "13:05:00" , 
"departure_time" : "13:06:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:09:02" , 
"departure_time" : "13:09:45" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:10:43" , 
"departure_time" : "13:12:03" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:13:20" , 
"departure_time" : "13:13:24" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:14:04" , 
"departure_time" : "13:15:10" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:17:06" , 
"departure_time" : "13:17:20" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:18:14" , 
"departure_time" : "13:19:37" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:20:23" , 
"departure_time" : "13:20:39" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:22:16" , 
"departure_time" : "13:23:17" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "13:26:01" , 
"departure_time" : "13:27:18" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "13:27:17" , 
"departure_time" : "13:27:29" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "13:28:12" , 
"departure_time" : "13:28:14" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "13:30:02" , 
"departure_time" : "13:30:52" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "13:32:50" , 
"departure_time" : "13:33:14" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "13:35:24" , 
"departure_time" : "13:35:24" , 
"distance_traveled" : 9.0369
} ], 
"488" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "13:25:00" , 
"departure_time" : "13:25:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:28:20" , 
"departure_time" : "13:29:45" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:31:25" , 
"departure_time" : "13:31:44" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:32:19" , 
"departure_time" : "13:32:27" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:34:08" , 
"departure_time" : "13:35:23" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:37:15" , 
"departure_time" : "13:38:12" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:38:57" , 
"departure_time" : "13:40:32" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:40:35" , 
"departure_time" : "13:40:41" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:42:06" , 
"departure_time" : "13:42:59" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "13:45:53" , 
"departure_time" : "13:46:12" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "13:46:19" , 
"departure_time" : "13:47:44" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "13:49:25" , 
"departure_time" : "13:51:02" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "13:51:37" , 
"departure_time" : "13:52:00" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "13:52:23" , 
"departure_time" : "13:53:33" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "13:56:10" , 
"departure_time" : "13:56:10" , 
"distance_traveled" : 9.0369
} ], 
"489" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "13:45:00" , 
"departure_time" : "13:46:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:48:04" , 
"departure_time" : "13:49:21" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:51:17" , 
"departure_time" : "13:51:38" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:52:21" , 
"departure_time" : "13:52:24" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:54:03" , 
"departure_time" : "13:54:20" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:56:17" , 
"departure_time" : "13:57:14" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:58:57" , 
"departure_time" : "14:00:11" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:00:14" , 
"departure_time" : "14:01:53" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:03:39" , 
"departure_time" : "14:04:44" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "14:06:05" , 
"departure_time" : "14:06:52" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "14:06:47" , 
"departure_time" : "14:08:25" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "14:09:38" , 
"departure_time" : "14:09:49" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "14:10:11" , 
"departure_time" : "14:10:19" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "14:12:08" , 
"departure_time" : "14:13:48" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "14:16:40" , 
"departure_time" : "14:16:40" , 
"distance_traveled" : 9.0369
} ], 
"490" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "14:05:00" , 
"departure_time" : "14:07:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:08:34" , 
"departure_time" : "14:08:54" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:10:20" , 
"departure_time" : "14:11:24" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:13:04" , 
"departure_time" : "14:13:25" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:14:21" , 
"departure_time" : "14:15:52" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:17:31" , 
"departure_time" : "14:18:18" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:18:47" , 
"departure_time" : "14:18:59" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:19:12" , 
"departure_time" : "14:19:18" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:22:06" , 
"departure_time" : "14:22:29" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "14:25:23" , 
"departure_time" : "14:25:35" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "14:26:12" , 
"departure_time" : "14:26:59" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "14:28:47" , 
"departure_time" : "14:30:06" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "14:31:19" , 
"departure_time" : "14:32:08" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "14:32:49" , 
"departure_time" : "14:33:36" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "14:35:47" , 
"departure_time" : "14:35:47" , 
"distance_traveled" : 9.0369
} ], 
"491" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "14:25:00" , 
"departure_time" : "14:26:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:29:03" , 
"departure_time" : "14:29:25" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:30:22" , 
"departure_time" : "14:30:34" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:32:12" , 
"departure_time" : "14:33:21" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:35:09" , 
"departure_time" : "14:35:36" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:36:27" , 
"departure_time" : "14:37:38" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:39:11" , 
"departure_time" : "14:40:04" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:39:53" , 
"departure_time" : "14:40:07" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:42:14" , 
"departure_time" : "14:42:52" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "14:45:38" , 
"departure_time" : "14:46:10" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "14:46:32" , 
"departure_time" : "14:47:19" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "14:48:47" , 
"departure_time" : "14:49:14" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "14:50:27" , 
"departure_time" : "14:51:32" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "14:53:05" , 
"departure_time" : "14:53:50" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "14:55:45" , 
"departure_time" : "14:55:45" , 
"distance_traveled" : 9.0369
} ], 
"492" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "14:45:00" , 
"departure_time" : "14:47:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:49:23" , 
"departure_time" : "14:49:59" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:50:36" , 
"departure_time" : "14:51:43" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:53:07" , 
"departure_time" : "14:53:27" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:54:20" , 
"departure_time" : "14:55:00" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:56:40" , 
"departure_time" : "14:58:18" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:59:38" , 
"departure_time" : "15:00:33" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:59:55" , 
"departure_time" : "15:01:29" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:03:34" , 
"departure_time" : "15:04:57" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "15:06:23" , 
"departure_time" : "15:07:44" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "15:07:21" , 
"departure_time" : "15:08:18" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "15:08:57" , 
"departure_time" : "15:09:18" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "15:10:21" , 
"departure_time" : "15:11:15" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "15:12:54" , 
"departure_time" : "15:13:13" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "15:15:19" , 
"departure_time" : "15:15:19" , 
"distance_traveled" : 9.0369
} ], 
"493" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "15:05:00" , 
"departure_time" : "15:06:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:09:18" , 
"departure_time" : "15:10:42" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:11:24" , 
"departure_time" : "15:12:32" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:13:08" , 
"departure_time" : "15:13:46" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:14:38" , 
"departure_time" : "15:15:24" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:16:46" , 
"departure_time" : "15:17:55" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:19:09" , 
"departure_time" : "15:20:40" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:20:31" , 
"departure_time" : "15:20:36" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:22:05" , 
"departure_time" : "15:23:21" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "15:26:16" , 
"departure_time" : "15:27:04" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "15:26:48" , 
"departure_time" : "15:27:48" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "15:29:00" , 
"departure_time" : "15:29:40" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "15:30:40" , 
"departure_time" : "15:31:49" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "15:33:09" , 
"departure_time" : "15:34:42" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "15:36:33" , 
"departure_time" : "15:36:33" , 
"distance_traveled" : 9.0369
} ], 
"494" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "15:25:00" , 
"departure_time" : "15:27:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:28:43" , 
"departure_time" : "15:29:53" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:31:10" , 
"departure_time" : "15:32:00" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:32:50" , 
"departure_time" : "15:33:26" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:34:36" , 
"departure_time" : "15:34:49" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:36:13" , 
"departure_time" : "15:36:31" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:38:18" , 
"departure_time" : "15:39:01" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:39:43" , 
"departure_time" : "15:41:05" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:43:22" , 
"departure_time" : "15:44:55" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "15:46:33" , 
"departure_time" : "15:46:55" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "15:46:22" , 
"departure_time" : "15:47:57" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "15:49:35" , 
"departure_time" : "15:49:48" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "15:50:13" , 
"departure_time" : "15:51:14" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "15:53:01" , 
"departure_time" : "15:54:01" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "15:56:00" , 
"departure_time" : "15:56:00" , 
"distance_traveled" : 9.0369
} ], 
"495" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "15:45:00" , 
"departure_time" : "15:46:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:48:58" , 
"departure_time" : "15:50:36" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:51:38" , 
"departure_time" : "15:51:42" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:52:04" , 
"departure_time" : "15:52:45" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:54:41" , 
"departure_time" : "15:55:44" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:57:03" , 
"departure_time" : "15:58:04" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:59:01" , 
"departure_time" : "16:00:35" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:00:34" , 
"departure_time" : "16:01:30" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:02:56" , 
"departure_time" : "16:03:30" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "16:05:34" , 
"departure_time" : "16:07:12" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "16:07:38" , 
"departure_time" : "16:07:46" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "16:08:08" , 
"departure_time" : "16:08:39" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "16:10:31" , 
"departure_time" : "16:11:49" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "16:13:18" , 
"departure_time" : "16:13:33" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "16:15:15" , 
"departure_time" : "16:15:15" , 
"distance_traveled" : 9.0369
} ], 
"496" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "16:05:00" , 
"departure_time" : "16:05:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:08:33" , 
"departure_time" : "16:09:17" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:10:44" , 
"departure_time" : "16:12:22" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:13:38" , 
"departure_time" : "16:14:41" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:15:03" , 
"departure_time" : "16:16:35" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:17:32" , 
"departure_time" : "16:19:07" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:19:35" , 
"departure_time" : "16:20:36" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:20:01" , 
"departure_time" : "16:21:04" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:23:03" , 
"departure_time" : "16:23:30" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "16:25:27" , 
"departure_time" : "16:25:45" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "16:26:18" , 
"departure_time" : "16:27:21" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "16:29:03" , 
"departure_time" : "16:29:27" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "16:30:24" , 
"departure_time" : "16:30:50" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "16:32:26" , 
"departure_time" : "16:32:52" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "16:35:26" , 
"departure_time" : "16:35:26" , 
"distance_traveled" : 9.0369
} ], 
"497" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "16:25:00" , 
"departure_time" : "16:26:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:28:40" , 
"departure_time" : "16:29:16" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:30:36" , 
"departure_time" : "16:32:04" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:33:28" , 
"departure_time" : "16:34:14" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:34:46" , 
"departure_time" : "16:36:20" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:37:34" , 
"departure_time" : "16:38:01" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:38:27" , 
"departure_time" : "16:38:32" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:39:05" , 
"departure_time" : "16:39:50" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:42:45" , 
"departure_time" : "16:44:03" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "16:46:18" , 
"departure_time" : "16:46:30" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "16:46:12" , 
"departure_time" : "16:47:52" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "16:49:40" , 
"departure_time" : "16:50:57" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "16:51:17" , 
"departure_time" : "16:51:32" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "16:52:15" , 
"departure_time" : "16:53:05" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "16:55:50" , 
"departure_time" : "16:55:50" , 
"distance_traveled" : 9.0369
} ], 
"498" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "16:45:00" , 
"departure_time" : "16:47:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:49:30" , 
"departure_time" : "16:49:49" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:50:19" , 
"departure_time" : "16:50:32" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:52:13" , 
"departure_time" : "16:53:31" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:55:18" , 
"departure_time" : "16:55:53" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:56:35" , 
"departure_time" : "16:57:09" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:58:34" , 
"departure_time" : "16:59:19" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:59:45" , 
"departure_time" : "16:59:48" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:02:03" , 
"departure_time" : "17:02:17" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "17:05:14" , 
"departure_time" : "17:05:42" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "17:06:28" , 
"departure_time" : "17:06:55" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "17:08:27" , 
"departure_time" : "17:08:42" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "17:10:15" , 
"departure_time" : "17:10:21" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "17:12:06" , 
"departure_time" : "17:13:25" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "17:16:19" , 
"departure_time" : "17:16:19" , 
"distance_traveled" : 9.0369
} ], 
"499" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "17:05:00" , 
"departure_time" : "17:07:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:09:16" , 
"departure_time" : "17:09:28" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:10:12" , 
"departure_time" : "17:11:39" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:13:27" , 
"departure_time" : "17:14:54" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:15:27" , 
"departure_time" : "17:16:14" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:16:47" , 
"departure_time" : "17:17:24" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:18:37" , 
"departure_time" : "17:20:02" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:20:25" , 
"departure_time" : "17:22:05" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:23:40" , 
"departure_time" : "17:24:52" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "17:26:12" , 
"departure_time" : "17:26:30" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "17:26:18" , 
"departure_time" : "17:27:03" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "17:28:45" , 
"departure_time" : "17:29:34" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "17:30:49" , 
"departure_time" : "17:32:21" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "17:33:32" , 
"departure_time" : "17:35:05" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "17:36:33" , 
"departure_time" : "17:36:33" , 
"distance_traveled" : 9.0369
} ], 
"500" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "17:25:00" , 
"departure_time" : "17:26:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:28:16" , 
"departure_time" : "17:28:41" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:30:25" , 
"departure_time" : "17:31:02" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:32:37" , 
"departure_time" : "17:33:10" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:34:33" , 
"departure_time" : "17:35:30" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:36:57" , 
"departure_time" : "17:36:58" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:38:01" , 
"departure_time" : "17:38:44" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:39:43" , 
"departure_time" : "17:40:00" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:42:17" , 
"departure_time" : "17:42:32" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "17:45:15" , 
"departure_time" : "17:45:59" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "17:46:44" , 
"departure_time" : "17:48:16" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "17:49:32" , 
"departure_time" : "17:49:41" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "17:50:09" , 
"departure_time" : "17:51:02" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "17:52:53" , 
"departure_time" : "17:53:12" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "17:55:19" , 
"departure_time" : "17:55:19" , 
"distance_traveled" : 9.0369
} ], 
"501" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "17:45:00" , 
"departure_time" : "17:46:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:49:18" , 
"departure_time" : "17:50:37" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:51:19" , 
"departure_time" : "17:52:20" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:53:01" , 
"departure_time" : "17:53:06" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:54:05" , 
"departure_time" : "17:54:55" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:56:50" , 
"departure_time" : "17:57:24" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:58:34" , 
"departure_time" : "17:58:58" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:59:24" , 
"departure_time" : "18:00:11" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:02:47" , 
"departure_time" : "18:04:03" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "18:06:16" , 
"departure_time" : "18:06:24" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "18:06:08" , 
"departure_time" : "18:06:53" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "18:08:45" , 
"departure_time" : "18:09:46" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "18:11:01" , 
"departure_time" : "18:11:27" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "18:12:26" , 
"departure_time" : "18:13:06" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "18:15:40" , 
"departure_time" : "18:15:40" , 
"distance_traveled" : 9.0369
} ], 
"502" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "18:05:00" , 
"departure_time" : "18:05:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:08:10" , 
"departure_time" : "18:08:17" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:10:07" , 
"departure_time" : "18:11:34" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:13:27" , 
"departure_time" : "18:13:51" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:14:24" , 
"departure_time" : "18:14:35" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:16:11" , 
"departure_time" : "18:17:01" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:18:50" , 
"departure_time" : "18:19:04" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:19:14" , 
"departure_time" : "18:19:25" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:22:11" , 
"departure_time" : "18:23:21" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "18:26:10" , 
"departure_time" : "18:27:36" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "18:27:26" , 
"departure_time" : "18:27:34" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "18:28:08" , 
"departure_time" : "18:29:07" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "18:30:59" , 
"departure_time" : "18:31:57" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "18:32:58" , 
"departure_time" : "18:34:17" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "18:36:19" , 
"departure_time" : "18:36:19" , 
"distance_traveled" : 9.0369
} ], 
"503" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "18:25:00" , 
"departure_time" : "18:26:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:28:35" , 
"departure_time" : "18:29:26" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:30:51" , 
"departure_time" : "18:31:33" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:32:42" , 
"departure_time" : "18:33:31" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:34:49" , 
"departure_time" : "18:35:00" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:36:11" , 
"departure_time" : "18:37:20" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:39:09" , 
"departure_time" : "18:40:20" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:40:11" , 
"departure_time" : "18:41:49" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:43:38" , 
"departure_time" : "18:44:15" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "18:45:37" , 
"departure_time" : "18:47:08" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "18:47:31" , 
"departure_time" : "18:48:09" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "18:48:38" , 
"departure_time" : "18:49:41" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "18:51:03" , 
"departure_time" : "18:52:05" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "18:53:02" , 
"departure_time" : "18:54:32" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "18:56:30" , 
"departure_time" : "18:56:30" , 
"distance_traveled" : 9.0369
} ], 
"504" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "18:45:00" , 
"departure_time" : "18:47:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:48:35" , 
"departure_time" : "18:49:18" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:50:43" , 
"departure_time" : "18:52:16" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:53:33" , 
"departure_time" : "18:53:50" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:54:17" , 
"departure_time" : "18:54:33" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:56:16" , 
"departure_time" : "18:57:31" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:59:15" , 
"departure_time" : "19:00:24" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:00:09" , 
"departure_time" : "19:00:15" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:02:06" , 
"departure_time" : "19:02:18" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "19:05:12" , 
"departure_time" : "19:06:51" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "19:07:39" , 
"departure_time" : "19:07:50" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "19:08:11" , 
"departure_time" : "19:09:15" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "19:11:04" , 
"departure_time" : "19:12:42" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "19:13:38" , 
"departure_time" : "19:14:09" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "19:15:31" , 
"departure_time" : "19:15:31" , 
"distance_traveled" : 9.0369
} ], 
"505" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "19:05:00" , 
"departure_time" : "19:05:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:08:21" , 
"departure_time" : "19:08:23" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:10:02" , 
"departure_time" : "19:10:22" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:12:20" , 
"departure_time" : "19:13:26" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:15:06" , 
"departure_time" : "19:16:34" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:17:28" , 
"departure_time" : "19:18:00" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:18:32" , 
"departure_time" : "19:18:46" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:19:14" , 
"departure_time" : "19:19:54" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:22:40" , 
"departure_time" : "19:23:58" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "19:26:18" , 
"departure_time" : "19:27:38" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "19:27:20" , 
"departure_time" : "19:28:32" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "19:29:12" , 
"departure_time" : "19:30:23" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "19:31:11" , 
"departure_time" : "19:32:50" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "19:33:39" , 
"departure_time" : "19:34:54" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "19:36:15" , 
"departure_time" : "19:36:15" , 
"distance_traveled" : 9.0369
} ], 
"506" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "19:25:00" , 
"departure_time" : "19:26:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:28:39" , 
"departure_time" : "19:30:00" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:31:21" , 
"departure_time" : "19:32:58" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:33:37" , 
"departure_time" : "19:33:38" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:34:01" , 
"departure_time" : "19:34:06" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:36:05" , 
"departure_time" : "19:37:05" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:39:00" , 
"departure_time" : "19:40:02" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:40:02" , 
"departure_time" : "19:41:31" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:43:29" , 
"departure_time" : "19:43:45" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "19:45:16" , 
"departure_time" : "19:46:35" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "19:47:19" , 
"departure_time" : "19:47:57" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "19:48:38" , 
"departure_time" : "19:49:41" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "19:51:03" , 
"departure_time" : "19:51:37" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "19:52:34" , 
"departure_time" : "19:53:05" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "19:55:31" , 
"departure_time" : "19:55:31" , 
"distance_traveled" : 9.0369
} ], 
"507" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "19:45:00" , 
"departure_time" : "19:45:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:48:09" , 
"departure_time" : "19:48:19" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:50:10" , 
"departure_time" : "19:51:01" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:52:51" , 
"departure_time" : "19:53:04" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:54:13" , 
"departure_time" : "19:55:23" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:57:10" , 
"departure_time" : "19:58:13" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:59:03" , 
"departure_time" : "19:59:35" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:59:32" , 
"departure_time" : "20:00:00" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:02:28" , 
"departure_time" : "20:03:15" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "20:05:47" , 
"departure_time" : "20:05:48" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "20:06:01" , 
"departure_time" : "20:06:36" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "20:08:35" , 
"departure_time" : "20:09:59" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "20:11:24" , 
"departure_time" : "20:12:29" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "20:13:05" , 
"departure_time" : "20:13:42" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "20:15:37" , 
"departure_time" : "20:15:37" , 
"distance_traveled" : 9.0369
} ], 
"508" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "20:05:00" , 
"departure_time" : "20:06:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:08:23" , 
"departure_time" : "20:10:01" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:11:38" , 
"departure_time" : "20:11:40" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:12:02" , 
"departure_time" : "20:12:32" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:14:30" , 
"departure_time" : "20:15:28" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:16:58" , 
"departure_time" : "20:17:12" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:18:14" , 
"departure_time" : "20:18:59" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:19:45" , 
"departure_time" : "20:21:11" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:23:26" , 
"departure_time" : "20:23:37" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "20:25:11" , 
"departure_time" : "20:26:47" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "20:27:36" , 
"departure_time" : "20:28:19" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "20:28:43" , 
"departure_time" : "20:29:34" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "20:30:51" , 
"departure_time" : "20:31:35" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "20:32:44" , 
"departure_time" : "20:34:01" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "20:36:17" , 
"departure_time" : "20:36:17" , 
"distance_traveled" : 9.0369
} ], 
"509" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "20:25:00" , 
"departure_time" : "20:26:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:28:41" , 
"departure_time" : "20:29:00" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:30:19" , 
"departure_time" : "20:30:20" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:32:01" , 
"departure_time" : "20:33:07" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:35:06" , 
"departure_time" : "20:35:38" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:36:32" , 
"departure_time" : "20:36:48" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:38:16" , 
"departure_time" : "20:39:02" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:39:46" , 
"departure_time" : "20:40:06" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:42:20" , 
"departure_time" : "20:42:59" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "20:45:39" , 
"departure_time" : "20:46:45" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "20:47:06" , 
"departure_time" : "20:48:08" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "20:49:02" , 
"departure_time" : "20:49:57" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "20:50:55" , 
"departure_time" : "20:51:32" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "20:52:37" , 
"departure_time" : "20:53:02" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "20:55:25" , 
"departure_time" : "20:55:25" , 
"distance_traveled" : 9.0369
} ], 
"510" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "20:45:00" , 
"departure_time" : "20:46:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:48:47" , 
"departure_time" : "20:50:00" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:51:13" , 
"departure_time" : "20:52:49" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:53:36" , 
"departure_time" : "20:55:03" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:55:27" , 
"departure_time" : "20:56:05" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:56:38" , 
"departure_time" : "20:58:00" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:59:22" , 
"departure_time" : "20:59:37" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:59:15" , 
"departure_time" : "21:00:31" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:03:16" , 
"departure_time" : "21:04:42" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "21:06:26" , 
"departure_time" : "21:06:46" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "21:06:20" , 
"departure_time" : "21:07:34" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "21:09:14" , 
"departure_time" : "21:09:39" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "21:10:25" , 
"departure_time" : "21:11:38" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "21:13:13" , 
"departure_time" : "21:13:55" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "21:15:42" , 
"departure_time" : "21:15:42" , 
"distance_traveled" : 9.0369
} ], 
"511" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "21:05:00" , 
"departure_time" : "21:06:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:08:21" , 
"departure_time" : "21:09:36" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:11:15" , 
"departure_time" : "21:12:49" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:13:34" , 
"departure_time" : "21:13:38" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "21:14:04" , 
"departure_time" : "21:15:38" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:17:34" , 
"departure_time" : "21:18:44" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "21:19:10" , 
"departure_time" : "21:20:04" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "21:19:54" , 
"departure_time" : "21:21:13" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:23:19" , 
"departure_time" : "21:24:08" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "21:25:49" , 
"departure_time" : "21:26:35" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "21:26:46" , 
"departure_time" : "21:27:06" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "21:28:20" , 
"departure_time" : "21:29:12" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "21:30:52" , 
"departure_time" : "21:31:25" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "21:32:33" , 
"departure_time" : "21:32:39" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "21:35:06" , 
"departure_time" : "21:35:06" , 
"distance_traveled" : 9.0369
} ], 
"512" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "21:25:00" , 
"departure_time" : "21:26:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:29:14" , 
"departure_time" : "21:30:32" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:31:18" , 
"departure_time" : "21:31:57" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:32:39" , 
"departure_time" : "21:32:55" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "21:34:16" , 
"departure_time" : "21:35:23" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:37:07" , 
"departure_time" : "21:38:20" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "21:39:13" , 
"departure_time" : "21:40:34" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "21:40:21" , 
"departure_time" : "21:40:38" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:42:17" , 
"departure_time" : "21:43:22" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "21:46:05" , 
"departure_time" : "21:47:34" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "21:47:29" , 
"departure_time" : "21:48:36" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "21:49:07" , 
"departure_time" : "21:49:34" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "21:50:27" , 
"departure_time" : "21:50:28" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "21:52:01" , 
"departure_time" : "21:53:21" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "21:56:20" , 
"departure_time" : "21:56:20" , 
"distance_traveled" : 9.0369
} ], 
"513" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "21:45:00" , 
"departure_time" : "21:47:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:49:06" , 
"departure_time" : "21:49:59" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:50:53" , 
"departure_time" : "21:51:25" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:52:32" , 
"departure_time" : "21:52:38" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "21:54:06" , 
"departure_time" : "21:54:35" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:56:29" , 
"departure_time" : "21:56:48" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "21:58:19" , 
"departure_time" : "21:59:42" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:00:23" , 
"departure_time" : "22:00:27" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:02:04" , 
"departure_time" : "22:02:32" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "22:05:28" , 
"departure_time" : "22:06:02" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "22:06:34" , 
"departure_time" : "22:07:13" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "22:08:39" , 
"departure_time" : "22:09:52" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "22:11:13" , 
"departure_time" : "22:12:24" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "22:13:11" , 
"departure_time" : "22:14:25" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "22:16:14" , 
"departure_time" : "22:16:14" , 
"distance_traveled" : 9.0369
} ], 
"514" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "22:05:00" , 
"departure_time" : "22:06:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:08:22" , 
"departure_time" : "22:09:45" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:11:23" , 
"departure_time" : "22:11:36" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:12:13" , 
"departure_time" : "22:12:53" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:14:40" , 
"departure_time" : "22:15:46" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:17:06" , 
"departure_time" : "22:18:42" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:19:36" , 
"departure_time" : "22:20:50" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:20:14" , 
"departure_time" : "22:21:19" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:23:05" , 
"departure_time" : "22:24:32" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "22:26:27" , 
"departure_time" : "22:27:35" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "22:27:08" , 
"departure_time" : "22:27:22" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "22:28:14" , 
"departure_time" : "22:29:54" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "22:31:40" , 
"departure_time" : "22:32:28" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "22:32:48" , 
"departure_time" : "22:33:22" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "22:35:34" , 
"departure_time" : "22:35:34" , 
"distance_traveled" : 9.0369
} ], 
"515" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "22:25:00" , 
"departure_time" : "22:25:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:28:14" , 
"departure_time" : "22:28:51" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:30:37" , 
"departure_time" : "22:31:49" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:33:12" , 
"departure_time" : "22:34:10" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:34:58" , 
"departure_time" : "22:35:01" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:36:03" , 
"departure_time" : "22:36:25" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:38:22" , 
"departure_time" : "22:39:27" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:40:05" , 
"departure_time" : "22:40:22" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:42:17" , 
"departure_time" : "22:43:24" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "22:46:07" , 
"departure_time" : "22:46:24" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "22:46:17" , 
"departure_time" : "22:47:16" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "22:48:59" , 
"departure_time" : "22:49:16" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "22:50:17" , 
"departure_time" : "22:51:36" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "22:53:19" , 
"departure_time" : "22:54:01" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "22:55:42" , 
"departure_time" : "22:55:42" , 
"distance_traveled" : 9.0369
} ], 
"516" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "22:45:00" , 
"departure_time" : "22:46:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:48:32" , 
"departure_time" : "22:49:43" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:51:11" , 
"departure_time" : "22:51:21" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:52:10" , 
"departure_time" : "22:53:19" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:55:09" , 
"departure_time" : "22:55:29" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:56:20" , 
"departure_time" : "22:56:56" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:58:36" , 
"departure_time" : "22:59:24" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:59:48" , 
"departure_time" : "23:00:38" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:02:50" , 
"departure_time" : "23:03:29" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "23:05:39" , 
"departure_time" : "23:07:07" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "23:07:28" , 
"departure_time" : "23:08:35" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "23:09:07" , 
"departure_time" : "23:10:22" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "23:11:15" , 
"departure_time" : "23:12:54" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "23:13:39" , 
"departure_time" : "23:14:23" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "23:15:44" , 
"departure_time" : "23:15:44" , 
"distance_traveled" : 9.0369
} ], 
"517" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "23:05:00" , 
"departure_time" : "23:06:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:09:11" , 
"departure_time" : "23:09:54" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:10:43" , 
"departure_time" : "23:12:10" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:13:27" , 
"departure_time" : "23:14:19" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:14:52" , 
"departure_time" : "23:15:24" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:16:32" , 
"departure_time" : "23:18:02" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "23:19:30" , 
"departure_time" : "23:19:53" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:19:23" , 
"departure_time" : "23:20:43" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:23:20" , 
"departure_time" : "23:23:35" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "23:25:15" , 
"departure_time" : "23:25:43" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "23:26:28" , 
"departure_time" : "23:26:47" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "23:28:19" , 
"departure_time" : "23:29:06" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "23:30:47" , 
"departure_time" : "23:31:35" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "23:32:48" , 
"departure_time" : "23:32:52" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "23:35:04" , 
"departure_time" : "23:35:04" , 
"distance_traveled" : 9.0369
} ], 
"518" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "23:25:00" , 
"departure_time" : "23:26:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:28:59" , 
"departure_time" : "23:30:10" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:31:11" , 
"departure_time" : "23:32:43" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:33:32" , 
"departure_time" : "23:35:05" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:35:33" , 
"departure_time" : "23:36:18" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:36:45" , 
"departure_time" : "23:37:49" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "23:39:04" , 
"departure_time" : "23:40:36" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:40:32" , 
"departure_time" : "23:40:47" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:42:15" , 
"departure_time" : "23:43:51" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "23:46:36" , 
"departure_time" : "23:48:03" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "23:47:27" , 
"departure_time" : "23:47:40" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "23:48:13" , 
"departure_time" : "23:49:08" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "23:50:55" , 
"departure_time" : "23:52:34" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "23:53:39" , 
"departure_time" : "23:55:14" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "23:56:35" , 
"departure_time" : "23:56:35" , 
"distance_traveled" : 9.0369
} ], 
"519" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "23:45:00" , 
"departure_time" : "23:46:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:48:24" , 
"departure_time" : "23:50:02" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:51:38" , 
"departure_time" : "23:52:13" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:52:35" , 
"departure_time" : "23:52:56" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:54:21" , 
"departure_time" : "23:54:27" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:56:06" , 
"departure_time" : "23:57:23" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "23:59:17" , 
"departure_time" : "23:59:26" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:59:09" , 
"departure_time" : "23:59:37" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "24:02:28" , 
"departure_time" : "24:03:04" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "24:05:36" , 
"departure_time" : "24:05:45" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "24:06:09" , 
"departure_time" : "24:06:13" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "24:08:04" , 
"departure_time" : "24:08:41" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "24:10:37" , 
"departure_time" : "24:11:34" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "24:12:57" , 
"departure_time" : "24:13:19" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "24:15:22" , 
"departure_time" : "24:15:22" , 
"distance_traveled" : 9.0369
} ], 
"520" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "24:05:00" , 
"departure_time" : "24:06:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "24:08:57" , 
"departure_time" : "24:10:32" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "24:11:35" , 
"departure_time" : "24:12:50" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "24:13:15" , 
"departure_time" : "24:13:18" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "24:14:03" , 
"departure_time" : "24:15:24" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "24:17:21" , 
"departure_time" : "24:18:16" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "24:18:55" , 
"departure_time" : "24:19:15" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "24:19:20" , 
"departure_time" : "24:19:22" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "24:22:02" , 
"departure_time" : "24:22:20" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "24:25:18" , 
"departure_time" : "24:25:25" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "24:26:07" , 
"departure_time" : "24:27:01" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "24:28:54" , 
"departure_time" : "24:30:32" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "24:31:38" , 
"departure_time" : "24:33:13" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "24:33:35" , 
"departure_time" : "24:33:46" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "24:35:11" , 
"departure_time" : "24:35:11" , 
"distance_traveled" : 9.0369
} ], 
"521" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "24:35:00" , 
"departure_time" : "24:35:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "24:38:15" , 
"departure_time" : "24:39:05" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "24:40:50" , 
"departure_time" : "24:41:06" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "24:42:16" , 
"departure_time" : "24:43:14" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "24:44:58" , 
"departure_time" : "24:45:02" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "24:46:04" , 
"departure_time" : "24:46:57" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "24:48:53" , 
"departure_time" : "24:49:21" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "24:49:28" , 
"departure_time" : "24:49:51" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "24:52:23" , 
"departure_time" : "24:53:44" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "24:56:21" , 
"departure_time" : "24:56:33" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "24:56:12" , 
"departure_time" : "24:56:42" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "24:58:30" , 
"departure_time" : "24:58:31" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "25:00:01" , 
"departure_time" : "25:00:40" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "25:02:39" , 
"departure_time" : "25:03:40" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "25:06:01" , 
"departure_time" : "25:06:01" , 
"distance_traveled" : 9.0369
} ], 
"522" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "25:05:00" , 
"departure_time" : "25:07:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "25:09:15" , 
"departure_time" : "25:09:39" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "25:10:24" , 
"departure_time" : "25:11:52" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "25:13:28" , 
"departure_time" : "25:14:52" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "25:15:24" , 
"departure_time" : "25:16:26" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "25:17:02" , 
"departure_time" : "25:17:54" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "25:18:52" , 
"departure_time" : "25:19:53" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "25:20:01" , 
"departure_time" : "25:20:16" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "25:22:15" , 
"departure_time" : "25:23:42" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "25:26:27" , 
"departure_time" : "25:26:49" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "25:26:22" , 
"departure_time" : "25:27:18" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "25:28:56" , 
"departure_time" : "25:29:33" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "25:30:37" , 
"departure_time" : "25:31:09" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "25:32:32" , 
"departure_time" : "25:33:11" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "25:35:39" , 
"departure_time" : "25:35:39" , 
"distance_traveled" : 9.0369
} ], 
"523" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "25:35:00" , 
"departure_time" : "25:35:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "25:38:04" , 
"departure_time" : "25:38:29" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "25:40:25" , 
"departure_time" : "25:42:01" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "25:43:36" , 
"departure_time" : "25:43:56" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "25:44:20" , 
"departure_time" : "25:44:38" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "25:46:18" , 
"departure_time" : "25:47:56" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "25:49:38" , 
"departure_time" : "25:49:54" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "25:49:16" , 
"departure_time" : "25:49:53" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "25:52:37" , 
"departure_time" : "25:53:50" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "25:56:13" , 
"departure_time" : "25:57:41" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "25:57:28" , 
"departure_time" : "25:57:57" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "25:58:29" , 
"departure_time" : "26:00:00" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "26:01:31" , 
"departure_time" : "26:03:06" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "26:03:35" , 
"departure_time" : "26:04:23" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "26:05:48" , 
"departure_time" : "26:05:48" , 
"distance_traveled" : 9.0369
} ], 
"524" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "26:05:00" , 
"departure_time" : "26:06:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "26:08:56" , 
"departure_time" : "26:09:13" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "26:10:17" , 
"departure_time" : "26:11:06" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "26:12:49" , 
"departure_time" : "26:12:59" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "26:14:10" , 
"departure_time" : "26:14:31" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "26:16:21" , 
"departure_time" : "26:17:39" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "26:19:18" , 
"departure_time" : "26:20:10" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "26:19:52" , 
"departure_time" : "26:21:29" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "26:23:37" , 
"departure_time" : "26:24:41" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "26:26:04" , 
"departure_time" : "26:26:08" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "26:26:04" , 
"departure_time" : "26:26:35" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "26:28:31" , 
"departure_time" : "26:28:44" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "26:30:13" , 
"departure_time" : "26:31:30" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "26:33:17" , 
"departure_time" : "26:34:35" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "26:36:18" , 
"departure_time" : "26:36:18" , 
"distance_traveled" : 9.0369
} ], 
"525" :  [ 
{ 
"stop_id" : 36999,
"arrival_time" : "05:58:00" , 
"departure_time" : "06:00:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "06:01:39" , 
"departure_time" : "06:02:20" , 
"distance_traveled" : 0.3424
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "06:02:41" , 
"departure_time" : "06:02:41" , 
"distance_traveled" : 0.9097
} ], 
"526" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "05:36:00" , 
"departure_time" : "05:37:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "05:38:24" , 
"departure_time" : "05:39:08" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "05:40:44" , 
"departure_time" : "05:41:05" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "05:43:21" , 
"departure_time" : "05:44:42" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "05:47:21" , 
"departure_time" : "05:49:01" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "05:48:40" , 
"departure_time" : "05:49:36" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "05:53:56" , 
"departure_time" : "05:55:18" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "05:56:22" , 
"departure_time" : "05:57:04" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "05:57:42" , 
"departure_time" : "05:57:49" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "05:59:07" , 
"departure_time" : "06:00:46" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:02:39" , 
"departure_time" : "06:04:15" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:04:36" , 
"departure_time" : "06:06:03" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:05:27" , 
"departure_time" : "06:06:48" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:08:21" , 
"departure_time" : "06:09:40" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "06:11:19" , 
"departure_time" : "06:12:54" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "06:13:35" , 
"departure_time" : "06:13:42" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "06:14:07" , 
"departure_time" : "06:14:07" , 
"distance_traveled" : 10.0589
} ], 
"527" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "05:56:00" , 
"departure_time" : "05:56:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "05:58:03" , 
"departure_time" : "05:58:04" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "06:00:01" , 
"departure_time" : "06:01:17" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "06:04:16" , 
"departure_time" : "06:05:33" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "06:07:17" , 
"departure_time" : "06:07:59" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "06:07:42" , 
"departure_time" : "06:08:29" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:13:47" , 
"departure_time" : "06:15:05" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:16:18" , 
"departure_time" : "06:17:24" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:18:06" , 
"departure_time" : "06:18:32" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:19:26" , 
"departure_time" : "06:19:58" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:21:32" , 
"departure_time" : "06:22:06" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:23:34" , 
"departure_time" : "06:23:40" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:24:06" , 
"departure_time" : "06:25:17" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:28:11" , 
"departure_time" : "06:29:25" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "06:31:14" , 
"departure_time" : "06:32:09" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "06:32:55" , 
"departure_time" : "06:33:56" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "06:35:01" , 
"departure_time" : "06:35:01" , 
"distance_traveled" : 10.0589
} ], 
"528" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "06:16:00" , 
"departure_time" : "06:17:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "06:18:04" , 
"departure_time" : "06:18:07" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "06:20:03" , 
"departure_time" : "06:20:13" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "06:23:10" , 
"departure_time" : "06:23:17" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "06:26:07" , 
"departure_time" : "06:27:11" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "06:28:04" , 
"departure_time" : "06:28:08" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:33:04" , 
"departure_time" : "06:34:31" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:36:27" , 
"departure_time" : "06:37:37" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:38:10" , 
"departure_time" : "06:39:13" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:40:03" , 
"departure_time" : "06:40:33" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:41:30" , 
"departure_time" : "06:41:53" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:43:23" , 
"departure_time" : "06:43:24" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:44:01" , 
"departure_time" : "06:44:35" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:47:34" , 
"departure_time" : "06:48:23" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "06:50:49" , 
"departure_time" : "06:50:52" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "06:52:03" , 
"departure_time" : "06:52:51" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "06:54:48" , 
"departure_time" : "06:54:48" , 
"distance_traveled" : 10.0589
} ], 
"529" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "06:36:00" , 
"departure_time" : "06:37:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "06:39:10" , 
"departure_time" : "06:40:12" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "06:41:02" , 
"departure_time" : "06:42:15" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "06:44:13" , 
"departure_time" : "06:44:53" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "06:46:40" , 
"departure_time" : "06:47:42" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "06:48:02" , 
"departure_time" : "06:49:13" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:54:11" , 
"departure_time" : "06:54:33" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:55:22" , 
"departure_time" : "06:56:17" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:57:55" , 
"departure_time" : "06:58:18" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:59:23" , 
"departure_time" : "07:00:44" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:02:21" , 
"departure_time" : "07:02:23" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:03:02" , 
"departure_time" : "07:03:40" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:04:38" , 
"departure_time" : "07:05:29" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:07:51" , 
"departure_time" : "07:08:01" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "07:10:10" , 
"departure_time" : "07:10:30" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "07:12:20" , 
"departure_time" : "07:12:51" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "07:14:31" , 
"departure_time" : "07:14:31" , 
"distance_traveled" : 10.0589
} ], 
"530" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "06:56:00" , 
"departure_time" : "06:57:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "06:58:52" , 
"departure_time" : "07:00:13" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "07:01:21" , 
"departure_time" : "07:02:15" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "07:03:54" , 
"departure_time" : "07:05:01" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "07:07:07" , 
"departure_time" : "07:07:56" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:07:49" , 
"departure_time" : "07:09:11" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:14:22" , 
"departure_time" : "07:14:32" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:15:10" , 
"departure_time" : "07:16:02" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:17:52" , 
"departure_time" : "07:18:33" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:19:41" , 
"departure_time" : "07:20:12" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:21:31" , 
"departure_time" : "07:22:13" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:23:42" , 
"departure_time" : "07:24:14" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:24:32" , 
"departure_time" : "07:25:42" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:28:10" , 
"departure_time" : "07:28:34" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "07:30:24" , 
"departure_time" : "07:31:56" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "07:33:32" , 
"departure_time" : "07:34:00" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "07:34:28" , 
"departure_time" : "07:34:28" , 
"distance_traveled" : 10.0589
} ], 
"531" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "07:16:00" , 
"departure_time" : "07:16:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:18:19" , 
"departure_time" : "07:19:06" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "07:20:47" , 
"departure_time" : "07:21:58" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "07:24:11" , 
"departure_time" : "07:24:53" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "07:26:42" , 
"departure_time" : "07:27:33" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:27:51" , 
"departure_time" : "07:28:24" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:33:33" , 
"departure_time" : "07:34:57" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:36:24" , 
"departure_time" : "07:36:54" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:37:30" , 
"departure_time" : "07:37:54" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:39:24" , 
"departure_time" : "07:39:46" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:41:22" , 
"departure_time" : "07:42:57" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:44:35" , 
"departure_time" : "07:45:24" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:44:49" , 
"departure_time" : "07:46:03" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:48:14" , 
"departure_time" : "07:48:20" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "07:50:06" , 
"departure_time" : "07:50:16" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "07:52:10" , 
"departure_time" : "07:53:22" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "07:55:12" , 
"departure_time" : "07:55:12" , 
"distance_traveled" : 10.0589
} ], 
"532" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "07:36:00" , 
"departure_time" : "07:37:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:38:03" , 
"departure_time" : "07:38:56" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "07:40:53" , 
"departure_time" : "07:41:21" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "07:43:28" , 
"departure_time" : "07:44:40" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "07:47:12" , 
"departure_time" : "07:47:43" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:47:31" , 
"departure_time" : "07:48:57" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:54:26" , 
"departure_time" : "07:55:32" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:56:06" , 
"departure_time" : "07:56:37" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:57:31" , 
"departure_time" : "07:58:04" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:59:33" , 
"departure_time" : "07:59:45" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:01:12" , 
"departure_time" : "08:02:18" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:04:06" , 
"departure_time" : "08:04:49" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:04:43" , 
"departure_time" : "08:06:02" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:08:19" , 
"departure_time" : "08:09:45" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "08:11:26" , 
"departure_time" : "08:12:12" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "08:12:46" , 
"departure_time" : "08:14:24" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "08:15:38" , 
"departure_time" : "08:15:38" , 
"distance_traveled" : 10.0589
} ], 
"533" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "07:56:00" , 
"departure_time" : "07:58:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:59:14" , 
"departure_time" : "07:59:19" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:00:05" , 
"departure_time" : "08:01:23" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:04:18" , 
"departure_time" : "08:05:58" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:07:40" , 
"departure_time" : "08:07:48" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:07:08" , 
"departure_time" : "08:08:13" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:14:05" , 
"departure_time" : "08:15:12" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:16:07" , 
"departure_time" : "08:17:14" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:18:07" , 
"departure_time" : "08:19:39" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:20:32" , 
"departure_time" : "08:21:23" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:21:51" , 
"departure_time" : "08:22:20" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:23:29" , 
"departure_time" : "08:23:38" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:24:09" , 
"departure_time" : "08:24:13" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:27:04" , 
"departure_time" : "08:27:53" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "08:30:49" , 
"departure_time" : "08:30:52" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "08:32:03" , 
"departure_time" : "08:32:33" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "08:34:30" , 
"departure_time" : "08:34:30" , 
"distance_traveled" : 10.0589
} ], 
"534" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "08:16:00" , 
"departure_time" : "08:17:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:19:18" , 
"departure_time" : "08:20:29" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:21:11" , 
"departure_time" : "08:22:04" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:23:53" , 
"departure_time" : "08:25:28" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:27:35" , 
"departure_time" : "08:27:50" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:27:15" , 
"departure_time" : "08:28:24" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:34:09" , 
"departure_time" : "08:34:26" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:35:17" , 
"departure_time" : "08:35:54" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:37:37" , 
"departure_time" : "08:38:52" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:40:15" , 
"departure_time" : "08:40:19" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:41:04" , 
"departure_time" : "08:41:16" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:43:12" , 
"departure_time" : "08:43:15" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:44:03" , 
"departure_time" : "08:44:20" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:47:17" , 
"departure_time" : "08:47:40" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "08:50:23" , 
"departure_time" : "08:51:40" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "08:53:17" , 
"departure_time" : "08:54:49" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "08:55:32" , 
"departure_time" : "08:55:32" , 
"distance_traveled" : 10.0589
} ], 
"535" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "08:36:00" , 
"departure_time" : "08:38:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:38:31" , 
"departure_time" : "08:39:53" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:41:22" , 
"departure_time" : "08:42:22" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:44:00" , 
"departure_time" : "08:44:51" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:46:51" , 
"departure_time" : "08:47:30" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:47:39" , 
"departure_time" : "08:48:32" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:53:53" , 
"departure_time" : "08:54:18" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:55:25" , 
"departure_time" : "08:57:01" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:58:36" , 
"departure_time" : "08:58:39" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:59:03" , 
"departure_time" : "08:59:15" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:01:12" , 
"departure_time" : "09:01:56" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:03:44" , 
"departure_time" : "09:05:21" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:05:37" , 
"departure_time" : "09:06:36" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:07:59" , 
"departure_time" : "09:08:49" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "09:10:50" , 
"departure_time" : "09:11:32" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "09:12:42" , 
"departure_time" : "09:14:07" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "09:15:25" , 
"departure_time" : "09:15:25" , 
"distance_traveled" : 10.0589
} ], 
"536" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "08:56:00" , 
"departure_time" : "08:58:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:59:05" , 
"departure_time" : "08:59:06" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "09:00:01" , 
"departure_time" : "09:01:34" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "09:04:33" , 
"departure_time" : "09:04:50" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:06:17" , 
"departure_time" : "09:07:14" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "09:07:57" , 
"departure_time" : "09:08:33" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:13:36" , 
"departure_time" : "09:13:55" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:15:19" , 
"departure_time" : "09:16:56" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:18:37" , 
"departure_time" : "09:18:46" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:19:09" , 
"departure_time" : "09:19:36" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:21:27" , 
"departure_time" : "09:22:09" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:23:42" , 
"departure_time" : "09:24:46" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:25:04" , 
"departure_time" : "09:26:19" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:28:15" , 
"departure_time" : "09:29:26" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "09:31:11" , 
"departure_time" : "09:31:17" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "09:32:06" , 
"departure_time" : "09:32:39" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "09:34:33" , 
"departure_time" : "09:34:33" , 
"distance_traveled" : 10.0589
} ], 
"537" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "09:16:00" , 
"departure_time" : "09:17:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "09:19:24" , 
"departure_time" : "09:20:42" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "09:21:18" , 
"departure_time" : "09:22:21" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "09:24:03" , 
"departure_time" : "09:24:58" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:26:55" , 
"departure_time" : "09:28:32" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "09:28:37" , 
"departure_time" : "09:29:01" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:33:24" , 
"departure_time" : "09:34:08" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:35:44" , 
"departure_time" : "09:36:36" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:37:52" , 
"departure_time" : "09:38:45" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:39:53" , 
"departure_time" : "09:40:01" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:41:08" , 
"departure_time" : "09:41:55" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:43:47" , 
"departure_time" : "09:45:17" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:45:30" , 
"departure_time" : "09:46:35" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:48:05" , 
"departure_time" : "09:49:30" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "09:51:25" , 
"departure_time" : "09:51:47" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "09:52:22" , 
"departure_time" : "09:53:35" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "09:55:13" , 
"departure_time" : "09:55:13" , 
"distance_traveled" : 10.0589
} ], 
"538" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "09:36:00" , 
"departure_time" : "09:38:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "09:39:02" , 
"departure_time" : "09:39:06" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "09:40:04" , 
"departure_time" : "09:40:32" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "09:43:28" , 
"departure_time" : "09:44:42" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:47:14" , 
"departure_time" : "09:48:12" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "09:47:58" , 
"departure_time" : "09:49:29" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:54:31" , 
"departure_time" : "09:55:36" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:56:05" , 
"departure_time" : "09:56:59" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:57:54" , 
"departure_time" : "09:58:32" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:59:38" , 
"departure_time" : "10:00:29" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:01:51" , 
"departure_time" : "10:03:16" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:04:25" , 
"departure_time" : "10:04:30" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:04:05" , 
"departure_time" : "10:04:12" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:07:07" , 
"departure_time" : "10:08:25" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "10:11:18" , 
"departure_time" : "10:11:26" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "10:12:08" , 
"departure_time" : "10:13:29" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "10:15:21" , 
"departure_time" : "10:15:21" , 
"distance_traveled" : 10.0589
} ], 
"539" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "09:56:00" , 
"departure_time" : "09:59:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "09:59:40" , 
"departure_time" : "10:00:16" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "10:00:36" , 
"departure_time" : "10:02:02" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "10:04:26" , 
"departure_time" : "10:04:43" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "10:06:17" , 
"departure_time" : "10:06:48" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "10:07:31" , 
"departure_time" : "10:08:57" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:14:26" , 
"departure_time" : "10:15:13" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:15:47" , 
"departure_time" : "10:15:54" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:17:07" , 
"departure_time" : "10:18:23" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:20:16" , 
"departure_time" : "10:21:22" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:22:06" , 
"departure_time" : "10:23:09" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:24:03" , 
"departure_time" : "10:25:11" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:25:08" , 
"departure_time" : "10:26:05" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:27:57" , 
"departure_time" : "10:28:22" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "10:30:25" , 
"departure_time" : "10:31:33" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "10:33:08" , 
"departure_time" : "10:34:30" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "10:35:22" , 
"departure_time" : "10:35:22" , 
"distance_traveled" : 10.0589
} ], 
"540" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "10:16:00" , 
"departure_time" : "10:17:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "10:18:03" , 
"departure_time" : "10:19:30" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "10:21:27" , 
"departure_time" : "10:22:50" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "10:24:23" , 
"departure_time" : "10:25:31" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "10:27:08" , 
"departure_time" : "10:28:43" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "10:28:35" , 
"departure_time" : "10:29:06" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:33:31" , 
"departure_time" : "10:33:42" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:35:11" , 
"departure_time" : "10:35:33" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:37:22" , 
"departure_time" : "10:37:24" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:39:02" , 
"departure_time" : "10:40:11" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:42:09" , 
"departure_time" : "10:42:30" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:43:21" , 
"departure_time" : "10:43:58" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:44:37" , 
"departure_time" : "10:46:04" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:48:27" , 
"departure_time" : "10:50:04" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "10:51:37" , 
"departure_time" : "10:52:08" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "10:52:31" , 
"departure_time" : "10:52:56" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "10:54:25" , 
"departure_time" : "10:54:25" , 
"distance_traveled" : 10.0589
} ], 
"541" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "10:36:00" , 
"departure_time" : "10:36:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "10:38:15" , 
"departure_time" : "10:39:38" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "10:41:23" , 
"departure_time" : "10:41:41" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "10:43:18" , 
"departure_time" : "10:43:24" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "10:46:06" , 
"departure_time" : "10:46:27" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "10:47:21" , 
"departure_time" : "10:47:41" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:53:20" , 
"departure_time" : "10:53:39" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:55:19" , 
"departure_time" : "10:55:44" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:57:25" , 
"departure_time" : "10:57:53" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:59:28" , 
"departure_time" : "11:00:11" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:01:43" , 
"departure_time" : "11:02:52" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:04:09" , 
"departure_time" : "11:04:19" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:04:10" , 
"departure_time" : "11:04:35" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:07:25" , 
"departure_time" : "11:08:09" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "11:10:44" , 
"departure_time" : "11:11:27" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "11:12:43" , 
"departure_time" : "11:12:45" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "11:14:02" , 
"departure_time" : "11:14:02" , 
"distance_traveled" : 10.0589
} ], 
"542" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "10:56:00" , 
"departure_time" : "10:56:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "10:58:37" , 
"departure_time" : "11:00:00" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "11:01:23" , 
"departure_time" : "11:02:27" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "11:04:04" , 
"departure_time" : "11:04:56" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "11:06:52" , 
"departure_time" : "11:08:27" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "11:08:35" , 
"departure_time" : "11:09:22" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:13:47" , 
"departure_time" : "11:15:10" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:16:23" , 
"departure_time" : "11:17:39" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:18:16" , 
"departure_time" : "11:18:44" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:19:28" , 
"departure_time" : "11:20:04" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:21:36" , 
"departure_time" : "11:22:52" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:24:16" , 
"departure_time" : "11:25:17" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:25:01" , 
"departure_time" : "11:25:02" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:27:01" , 
"departure_time" : "11:28:18" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "11:31:17" , 
"departure_time" : "11:31:42" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "11:32:25" , 
"departure_time" : "11:32:31" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "11:34:06" , 
"departure_time" : "11:34:06" , 
"distance_traveled" : 10.0589
} ], 
"543" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "11:16:00" , 
"departure_time" : "11:17:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "11:19:32" , 
"departure_time" : "11:19:48" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "11:20:16" , 
"departure_time" : "11:21:02" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "11:23:46" , 
"departure_time" : "11:24:26" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "11:26:40" , 
"departure_time" : "11:27:52" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "11:28:12" , 
"departure_time" : "11:29:20" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:34:08" , 
"departure_time" : "11:35:05" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:35:57" , 
"departure_time" : "11:37:34" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:38:37" , 
"departure_time" : "11:39:02" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:39:25" , 
"departure_time" : "11:40:50" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:42:25" , 
"departure_time" : "11:42:40" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:43:15" , 
"departure_time" : "11:44:39" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:45:24" , 
"departure_time" : "11:46:12" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:47:48" , 
"departure_time" : "11:48:03" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "11:50:15" , 
"departure_time" : "11:51:32" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "11:53:17" , 
"departure_time" : "11:54:47" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "11:55:30" , 
"departure_time" : "11:55:30" , 
"distance_traveled" : 10.0589
} ], 
"544" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "11:36:00" , 
"departure_time" : "11:37:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "11:38:20" , 
"departure_time" : "11:38:23" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "11:40:03" , 
"departure_time" : "11:40:26" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "11:43:23" , 
"departure_time" : "11:43:35" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "11:46:12" , 
"departure_time" : "11:47:19" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "11:48:07" , 
"departure_time" : "11:48:42" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:53:35" , 
"departure_time" : "11:55:06" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:56:31" , 
"departure_time" : "11:56:34" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:57:03" , 
"departure_time" : "11:57:46" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:59:43" , 
"departure_time" : "12:00:22" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:01:39" , 
"departure_time" : "12:02:38" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:03:59" , 
"departure_time" : "12:04:43" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:04:44" , 
"departure_time" : "12:04:49" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:07:05" , 
"departure_time" : "12:08:02" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "12:10:57" , 
"departure_time" : "12:11:23" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "12:12:26" , 
"departure_time" : "12:13:37" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "12:15:11" , 
"departure_time" : "12:15:11" , 
"distance_traveled" : 10.0589
} ], 
"545" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "11:56:00" , 
"departure_time" : "11:58:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "11:59:16" , 
"departure_time" : "12:00:09" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "12:00:53" , 
"departure_time" : "12:02:04" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "12:04:11" , 
"departure_time" : "12:04:17" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "12:06:06" , 
"departure_time" : "12:07:08" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "12:08:02" , 
"departure_time" : "12:08:05" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:13:03" , 
"departure_time" : "12:13:50" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:15:47" , 
"departure_time" : "12:16:18" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:17:31" , 
"departure_time" : "12:18:09" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:19:38" , 
"departure_time" : "12:21:04" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:22:26" , 
"departure_time" : "12:22:44" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:23:18" , 
"departure_time" : "12:24:30" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:25:12" , 
"departure_time" : "12:26:42" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:28:30" , 
"departure_time" : "12:29:01" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "12:30:31" , 
"departure_time" : "12:31:47" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "12:33:16" , 
"departure_time" : "12:33:29" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "12:34:13" , 
"departure_time" : "12:34:13" , 
"distance_traveled" : 10.0589
} ], 
"546" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "12:16:00" , 
"departure_time" : "12:16:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "12:18:20" , 
"departure_time" : "12:19:16" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "12:20:56" , 
"departure_time" : "12:22:18" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "12:24:22" , 
"departure_time" : "12:25:07" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "12:26:45" , 
"departure_time" : "12:27:18" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "12:27:33" , 
"departure_time" : "12:28:57" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:34:24" , 
"departure_time" : "12:35:18" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:35:54" , 
"departure_time" : "12:37:32" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:38:38" , 
"departure_time" : "12:38:39" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:39:01" , 
"departure_time" : "12:39:28" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:41:27" , 
"departure_time" : "12:42:59" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:44:32" , 
"departure_time" : "12:44:55" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:44:23" , 
"departure_time" : "12:45:03" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:47:40" , 
"departure_time" : "12:48:52" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "12:51:12" , 
"departure_time" : "12:51:15" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "12:52:03" , 
"departure_time" : "12:53:33" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "12:55:30" , 
"departure_time" : "12:55:30" , 
"distance_traveled" : 10.0589
} ], 
"547" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "12:36:00" , 
"departure_time" : "12:38:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "12:38:32" , 
"departure_time" : "12:38:41" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "12:40:09" , 
"departure_time" : "12:40:10" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "12:43:01" , 
"departure_time" : "12:44:10" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "12:47:09" , 
"departure_time" : "12:48:16" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "12:48:07" , 
"departure_time" : "12:49:01" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:53:54" , 
"departure_time" : "12:54:45" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:55:51" , 
"departure_time" : "12:56:48" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:57:57" , 
"departure_time" : "12:58:35" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:59:38" , 
"departure_time" : "13:01:15" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:02:37" , 
"departure_time" : "13:03:04" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:03:27" , 
"departure_time" : "13:03:38" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:04:11" , 
"departure_time" : "13:05:38" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:08:27" , 
"departure_time" : "13:09:04" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "13:10:37" , 
"departure_time" : "13:12:01" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "13:13:24" , 
"departure_time" : "13:13:49" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "13:14:25" , 
"departure_time" : "13:14:25" , 
"distance_traveled" : 10.0589
} ], 
"548" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "12:56:00" , 
"departure_time" : "12:57:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "12:59:05" , 
"departure_time" : "13:00:12" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "13:01:07" , 
"departure_time" : "13:02:43" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "13:04:36" , 
"departure_time" : "13:05:33" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "13:06:57" , 
"departure_time" : "13:07:34" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "13:07:37" , 
"departure_time" : "13:09:11" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:14:34" , 
"departure_time" : "13:15:40" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:16:06" , 
"departure_time" : "13:17:11" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:18:05" , 
"departure_time" : "13:18:52" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:19:47" , 
"departure_time" : "13:21:21" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:22:34" , 
"departure_time" : "13:23:53" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:24:19" , 
"departure_time" : "13:24:28" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:24:09" , 
"departure_time" : "13:24:45" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:27:36" , 
"departure_time" : "13:27:48" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "13:30:12" , 
"departure_time" : "13:31:49" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "13:33:37" , 
"departure_time" : "13:34:08" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "13:34:31" , 
"departure_time" : "13:34:31" , 
"distance_traveled" : 10.0589
} ], 
"549" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "13:16:00" , 
"departure_time" : "13:18:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "13:19:31" , 
"departure_time" : "13:20:30" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "13:20:59" , 
"departure_time" : "13:21:41" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "13:23:42" , 
"departure_time" : "13:24:52" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "13:27:10" , 
"departure_time" : "13:27:28" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "13:27:18" , 
"departure_time" : "13:27:24" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:33:06" , 
"departure_time" : "13:33:26" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:35:20" , 
"departure_time" : "13:36:55" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:38:35" , 
"departure_time" : "13:39:56" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:40:21" , 
"departure_time" : "13:41:54" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:42:33" , 
"departure_time" : "13:43:40" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:44:07" , 
"departure_time" : "13:45:12" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:45:05" , 
"departure_time" : "13:45:14" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:47:09" , 
"departure_time" : "13:48:15" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "13:51:06" , 
"departure_time" : "13:52:32" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "13:53:26" , 
"departure_time" : "13:54:16" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "13:54:50" , 
"departure_time" : "13:54:50" , 
"distance_traveled" : 10.0589
} ], 
"550" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "13:36:00" , 
"departure_time" : "13:38:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "13:39:14" , 
"departure_time" : "13:39:45" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "13:40:31" , 
"departure_time" : "13:40:34" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "13:43:03" , 
"departure_time" : "13:44:00" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "13:46:57" , 
"departure_time" : "13:47:04" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "13:47:07" , 
"departure_time" : "13:47:50" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:53:43" , 
"departure_time" : "13:55:13" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:56:30" , 
"departure_time" : "13:58:03" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:58:33" , 
"departure_time" : "13:59:42" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:00:09" , 
"departure_time" : "14:00:19" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:01:10" , 
"departure_time" : "14:02:18" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:04:08" , 
"departure_time" : "14:05:21" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:05:13" , 
"departure_time" : "14:06:25" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:08:12" , 
"departure_time" : "14:09:00" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "14:10:48" , 
"departure_time" : "14:11:11" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "14:12:23" , 
"departure_time" : "14:13:44" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "14:15:21" , 
"departure_time" : "14:15:21" , 
"distance_traveled" : 10.0589
} ], 
"551" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "13:56:00" , 
"departure_time" : "13:58:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "13:59:18" , 
"departure_time" : "14:00:18" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "14:01:00" , 
"departure_time" : "14:01:12" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "14:03:12" , 
"departure_time" : "14:03:48" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "14:06:36" , 
"departure_time" : "14:07:10" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "14:07:34" , 
"departure_time" : "14:09:14" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:14:40" , 
"departure_time" : "14:14:54" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:15:14" , 
"departure_time" : "14:16:47" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:18:33" , 
"departure_time" : "14:18:42" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:19:09" , 
"departure_time" : "14:20:49" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:22:40" , 
"departure_time" : "14:23:48" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:24:08" , 
"departure_time" : "14:25:04" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:24:56" , 
"departure_time" : "14:26:24" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:28:28" , 
"departure_time" : "14:28:54" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "14:30:26" , 
"departure_time" : "14:30:53" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "14:32:27" , 
"departure_time" : "14:33:45" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "14:35:18" , 
"departure_time" : "14:35:18" , 
"distance_traveled" : 10.0589
} ], 
"552" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "14:16:00" , 
"departure_time" : "14:17:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "14:18:16" , 
"departure_time" : "14:19:04" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "14:20:48" , 
"departure_time" : "14:20:52" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "14:23:04" , 
"departure_time" : "14:24:23" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "14:27:19" , 
"departure_time" : "14:28:00" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "14:27:41" , 
"departure_time" : "14:27:56" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:33:15" , 
"departure_time" : "14:34:48" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:36:33" , 
"departure_time" : "14:38:06" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:38:33" , 
"departure_time" : "14:39:04" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:39:31" , 
"departure_time" : "14:39:50" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:41:19" , 
"departure_time" : "14:42:07" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:43:48" , 
"departure_time" : "14:44:20" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:44:32" , 
"departure_time" : "14:45:51" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:48:19" , 
"departure_time" : "14:49:48" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "14:51:29" , 
"departure_time" : "14:52:09" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "14:52:40" , 
"departure_time" : "14:53:01" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "14:54:21" , 
"departure_time" : "14:54:21" , 
"distance_traveled" : 10.0589
} ], 
"553" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "14:36:00" , 
"departure_time" : "14:37:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "14:39:21" , 
"departure_time" : "14:40:18" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "14:40:57" , 
"departure_time" : "14:41:05" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "14:43:08" , 
"departure_time" : "14:44:33" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "14:47:25" , 
"departure_time" : "14:47:40" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "14:47:15" , 
"departure_time" : "14:48:52" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:54:37" , 
"departure_time" : "14:54:42" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:55:05" , 
"departure_time" : "14:55:34" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:57:29" , 
"departure_time" : "14:58:34" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:00:05" , 
"departure_time" : "15:01:17" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:02:12" , 
"departure_time" : "15:03:00" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:03:48" , 
"departure_time" : "15:04:57" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:05:09" , 
"departure_time" : "15:05:26" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:07:17" , 
"departure_time" : "15:07:31" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "15:10:14" , 
"departure_time" : "15:11:50" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "15:13:36" , 
"departure_time" : "15:15:00" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "15:15:24" , 
"departure_time" : "15:15:24" , 
"distance_traveled" : 10.0589
} ], 
"554" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "14:56:00" , 
"departure_time" : "14:57:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "14:58:19" , 
"departure_time" : "14:59:46" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "15:01:27" , 
"departure_time" : "15:02:42" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "15:04:15" , 
"departure_time" : "15:05:02" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "15:06:47" , 
"departure_time" : "15:08:00" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "15:08:13" , 
"departure_time" : "15:09:17" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:14:04" , 
"departure_time" : "15:14:13" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:15:09" , 
"departure_time" : "15:15:43" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:17:34" , 
"departure_time" : "15:18:27" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:19:53" , 
"departure_time" : "15:20:47" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:21:54" , 
"departure_time" : "15:23:11" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:24:17" , 
"departure_time" : "15:25:32" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:25:15" , 
"departure_time" : "15:26:44" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:28:29" , 
"departure_time" : "15:29:07" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "15:30:38" , 
"departure_time" : "15:32:16" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "15:33:38" , 
"departure_time" : "15:34:43" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "15:35:05" , 
"departure_time" : "15:35:05" , 
"distance_traveled" : 10.0589
} ], 
"555" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "15:16:00" , 
"departure_time" : "15:18:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "15:19:22" , 
"departure_time" : "15:19:56" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "15:20:34" , 
"departure_time" : "15:22:09" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "15:24:35" , 
"departure_time" : "15:24:38" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "15:26:03" , 
"departure_time" : "15:26:44" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "15:27:41" , 
"departure_time" : "15:28:31" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:33:50" , 
"departure_time" : "15:35:22" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:36:32" , 
"departure_time" : "15:38:01" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:38:29" , 
"departure_time" : "15:39:36" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:40:07" , 
"departure_time" : "15:40:52" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:41:45" , 
"departure_time" : "15:42:15" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:43:30" , 
"departure_time" : "15:44:05" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:44:35" , 
"departure_time" : "15:45:51" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:48:16" , 
"departure_time" : "15:48:29" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "15:50:13" , 
"departure_time" : "15:51:02" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "15:52:49" , 
"departure_time" : "15:54:13" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "15:55:24" , 
"departure_time" : "15:55:24" , 
"distance_traveled" : 10.0589
} ], 
"556" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "15:36:00" , 
"departure_time" : "15:37:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "15:38:19" , 
"departure_time" : "15:39:24" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "15:41:05" , 
"departure_time" : "15:41:42" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "15:43:37" , 
"departure_time" : "15:44:32" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "15:46:55" , 
"departure_time" : "15:47:17" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "15:47:22" , 
"departure_time" : "15:48:22" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:54:00" , 
"departure_time" : "15:55:16" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:56:16" , 
"departure_time" : "15:57:14" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:57:58" , 
"departure_time" : "15:58:19" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:59:21" , 
"departure_time" : "15:59:38" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:01:17" , 
"departure_time" : "16:02:05" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:03:48" , 
"departure_time" : "16:04:28" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:04:40" , 
"departure_time" : "16:05:28" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:07:48" , 
"departure_time" : "16:08:39" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "16:10:51" , 
"departure_time" : "16:12:05" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "16:13:14" , 
"departure_time" : "16:14:13" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "16:14:59" , 
"departure_time" : "16:14:59" , 
"distance_traveled" : 10.0589
} ], 
"557" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "15:56:00" , 
"departure_time" : "15:57:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "15:58:02" , 
"departure_time" : "15:58:10" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "16:00:08" , 
"departure_time" : "16:01:32" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:04:24" , 
"departure_time" : "16:05:20" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:06:56" , 
"departure_time" : "16:08:26" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:08:30" , 
"departure_time" : "16:09:04" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:13:34" , 
"departure_time" : "16:13:35" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:15:01" , 
"departure_time" : "16:16:34" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:18:33" , 
"departure_time" : "16:19:33" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:20:00" , 
"departure_time" : "16:21:23" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:22:23" , 
"departure_time" : "16:22:47" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:23:24" , 
"departure_time" : "16:24:45" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:25:21" , 
"departure_time" : "16:25:54" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:27:33" , 
"departure_time" : "16:29:05" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "16:31:32" , 
"departure_time" : "16:31:38" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "16:32:06" , 
"departure_time" : "16:33:41" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "16:35:35" , 
"departure_time" : "16:35:35" , 
"distance_traveled" : 10.0589
} ], 
"558" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "16:16:00" , 
"departure_time" : "16:18:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:18:59" , 
"departure_time" : "16:20:23" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "16:21:24" , 
"departure_time" : "16:22:13" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:23:49" , 
"departure_time" : "16:24:55" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:27:06" , 
"departure_time" : "16:27:52" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:27:46" , 
"departure_time" : "16:28:51" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:34:05" , 
"departure_time" : "16:34:25" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:35:20" , 
"departure_time" : "16:36:04" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:37:44" , 
"departure_time" : "16:37:53" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:39:09" , 
"departure_time" : "16:39:49" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:41:40" , 
"departure_time" : "16:43:15" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:44:35" , 
"departure_time" : "16:44:40" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:44:05" , 
"departure_time" : "16:45:29" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:48:24" , 
"departure_time" : "16:49:46" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "16:51:22" , 
"departure_time" : "16:52:27" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "16:53:05" , 
"departure_time" : "16:53:07" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "16:54:02" , 
"departure_time" : "16:54:02" , 
"distance_traveled" : 10.0589
} ], 
"559" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "16:36:00" , 
"departure_time" : "16:37:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:39:10" , 
"departure_time" : "16:40:35" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "16:41:25" , 
"departure_time" : "16:42:40" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:44:15" , 
"departure_time" : "16:44:53" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:46:38" , 
"departure_time" : "16:46:46" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:47:08" , 
"departure_time" : "16:48:14" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:54:06" , 
"departure_time" : "16:55:41" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:56:35" , 
"departure_time" : "16:56:48" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:57:13" , 
"departure_time" : "16:58:30" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:00:17" , 
"departure_time" : "17:00:57" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:01:40" , 
"departure_time" : "17:03:12" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:04:32" , 
"departure_time" : "17:05:26" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:04:54" , 
"departure_time" : "17:05:13" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:07:19" , 
"departure_time" : "17:08:31" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "17:11:12" , 
"departure_time" : "17:12:46" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "17:13:34" , 
"departure_time" : "17:14:28" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "17:14:54" , 
"departure_time" : "17:14:54" , 
"distance_traveled" : 10.0589
} ], 
"560" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "16:56:00" , 
"departure_time" : "16:58:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:59:25" , 
"departure_time" : "17:01:00" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:01:35" , 
"departure_time" : "17:02:14" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:03:39" , 
"departure_time" : "17:03:44" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "17:06:05" , 
"departure_time" : "17:07:12" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:08:07" , 
"departure_time" : "17:08:58" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:13:51" , 
"departure_time" : "17:14:37" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:15:46" , 
"departure_time" : "17:17:03" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:18:17" , 
"departure_time" : "17:19:26" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:20:09" , 
"departure_time" : "17:21:32" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:22:23" , 
"departure_time" : "17:24:00" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:24:37" , 
"departure_time" : "17:26:05" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:25:28" , 
"departure_time" : "17:25:42" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:27:14" , 
"departure_time" : "17:28:07" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "17:30:53" , 
"departure_time" : "17:31:01" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "17:32:08" , 
"departure_time" : "17:33:29" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "17:35:21" , 
"departure_time" : "17:35:21" , 
"distance_traveled" : 10.0589
} ], 
"561" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "17:16:00" , 
"departure_time" : "17:17:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:18:26" , 
"departure_time" : "17:18:38" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:20:12" , 
"departure_time" : "17:21:15" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:24:03" , 
"departure_time" : "17:25:05" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "17:27:02" , 
"departure_time" : "17:27:36" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:27:34" , 
"departure_time" : "17:28:13" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:33:39" , 
"departure_time" : "17:34:27" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:35:48" , 
"departure_time" : "17:37:17" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:38:29" , 
"departure_time" : "17:38:37" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:39:08" , 
"departure_time" : "17:40:27" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:42:19" , 
"departure_time" : "17:42:44" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:43:25" , 
"departure_time" : "17:43:27" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:44:02" , 
"departure_time" : "17:45:34" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:48:32" , 
"departure_time" : "17:49:48" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "17:51:16" , 
"departure_time" : "17:52:23" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "17:53:07" , 
"departure_time" : "17:53:29" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "17:54:22" , 
"departure_time" : "17:54:22" , 
"distance_traveled" : 10.0589
} ], 
"562" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "17:36:00" , 
"departure_time" : "17:37:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:39:18" , 
"departure_time" : "17:39:58" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:40:40" , 
"departure_time" : "17:41:30" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:43:50" , 
"departure_time" : "17:44:34" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "17:46:44" , 
"departure_time" : "17:47:30" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:47:46" , 
"departure_time" : "17:49:14" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:54:28" , 
"departure_time" : "17:54:56" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:55:28" , 
"departure_time" : "17:56:59" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:58:31" , 
"departure_time" : "17:59:27" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:59:56" , 
"departure_time" : "18:00:29" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:01:33" , 
"departure_time" : "18:03:10" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:04:37" , 
"departure_time" : "18:05:47" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:05:10" , 
"departure_time" : "18:06:42" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:08:32" , 
"departure_time" : "18:09:58" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "18:11:26" , 
"departure_time" : "18:12:34" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "18:13:08" , 
"departure_time" : "18:13:43" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "18:14:35" , 
"departure_time" : "18:14:35" , 
"distance_traveled" : 10.0589
} ], 
"563" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "17:56:00" , 
"departure_time" : "17:57:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:58:40" , 
"departure_time" : "17:59:26" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:00:46" , 
"departure_time" : "18:02:19" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:04:33" , 
"departure_time" : "18:06:09" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:07:36" , 
"departure_time" : "18:08:32" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:07:56" , 
"departure_time" : "18:09:32" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:14:36" , 
"departure_time" : "18:15:26" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:15:50" , 
"departure_time" : "18:16:01" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:17:11" , 
"departure_time" : "18:18:17" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:20:06" , 
"departure_time" : "18:21:36" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:22:30" , 
"departure_time" : "18:22:51" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:23:21" , 
"departure_time" : "18:24:43" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:25:22" , 
"departure_time" : "18:27:02" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:28:40" , 
"departure_time" : "18:29:24" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "18:30:44" , 
"departure_time" : "18:31:30" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "18:32:46" , 
"departure_time" : "18:34:13" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "18:35:27" , 
"departure_time" : "18:35:27" , 
"distance_traveled" : 10.0589
} ], 
"564" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "18:16:00" , 
"departure_time" : "18:18:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:19:06" , 
"departure_time" : "18:20:41" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:21:35" , 
"departure_time" : "18:22:17" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:23:42" , 
"departure_time" : "18:24:26" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:26:44" , 
"departure_time" : "18:28:22" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:28:38" , 
"departure_time" : "18:29:49" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:34:11" , 
"departure_time" : "18:34:59" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:35:48" , 
"departure_time" : "18:36:17" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:37:29" , 
"departure_time" : "18:38:56" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:40:27" , 
"departure_time" : "18:41:33" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:42:06" , 
"departure_time" : "18:42:31" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:43:25" , 
"departure_time" : "18:44:26" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:45:01" , 
"departure_time" : "18:46:15" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:48:14" , 
"departure_time" : "18:48:43" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "18:50:29" , 
"departure_time" : "18:50:34" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "18:52:05" , 
"departure_time" : "18:52:49" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "18:54:44" , 
"departure_time" : "18:54:44" , 
"distance_traveled" : 10.0589
} ], 
"565" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "18:36:00" , 
"departure_time" : "18:37:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:38:24" , 
"departure_time" : "18:39:52" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:41:28" , 
"departure_time" : "18:41:43" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:43:15" , 
"departure_time" : "18:44:28" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:47:13" , 
"departure_time" : "18:48:01" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:47:48" , 
"departure_time" : "18:48:28" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:53:40" , 
"departure_time" : "18:55:19" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:56:39" , 
"departure_time" : "18:57:10" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:57:31" , 
"departure_time" : "18:58:29" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:59:58" , 
"departure_time" : "19:01:27" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:02:29" , 
"departure_time" : "19:02:42" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:03:13" , 
"departure_time" : "19:03:59" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:04:46" , 
"departure_time" : "19:06:21" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:08:35" , 
"departure_time" : "19:09:56" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "19:11:21" , 
"departure_time" : "19:11:53" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "19:12:32" , 
"departure_time" : "19:13:02" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "19:14:30" , 
"departure_time" : "19:14:30" , 
"distance_traveled" : 10.0589
} ], 
"566" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "18:56:00" , 
"departure_time" : "18:57:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:58:38" , 
"departure_time" : "19:00:00" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "19:01:22" , 
"departure_time" : "19:01:33" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "19:03:11" , 
"departure_time" : "19:04:48" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "19:07:37" , 
"departure_time" : "19:08:25" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "19:07:48" , 
"departure_time" : "19:08:00" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:13:12" , 
"departure_time" : "19:14:06" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:15:54" , 
"departure_time" : "19:16:19" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:17:25" , 
"departure_time" : "19:18:54" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:20:29" , 
"departure_time" : "19:21:31" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:22:02" , 
"departure_time" : "19:22:19" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:23:17" , 
"departure_time" : "19:24:34" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:25:17" , 
"departure_time" : "19:26:50" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:28:33" , 
"departure_time" : "19:28:40" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "19:30:07" , 
"departure_time" : "19:31:29" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "19:33:22" , 
"departure_time" : "19:34:14" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "19:34:52" , 
"departure_time" : "19:34:52" , 
"distance_traveled" : 10.0589
} ], 
"567" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "19:16:00" , 
"departure_time" : "19:18:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "19:19:08" , 
"departure_time" : "19:19:38" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "19:20:30" , 
"departure_time" : "19:20:40" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "19:23:10" , 
"departure_time" : "19:23:48" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "19:26:38" , 
"departure_time" : "19:26:59" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "19:27:21" , 
"departure_time" : "19:28:36" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:34:15" , 
"departure_time" : "19:34:40" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:35:25" , 
"departure_time" : "19:36:22" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:37:57" , 
"departure_time" : "19:39:06" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:40:09" , 
"departure_time" : "19:41:15" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:42:06" , 
"departure_time" : "19:42:09" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:43:03" , 
"departure_time" : "19:44:07" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:45:04" , 
"departure_time" : "19:46:43" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:48:39" , 
"departure_time" : "19:49:36" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "19:50:57" , 
"departure_time" : "19:51:08" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "19:52:11" , 
"departure_time" : "19:53:27" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "19:55:16" , 
"departure_time" : "19:55:16" , 
"distance_traveled" : 10.0589
} ], 
"568" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "19:36:00" , 
"departure_time" : "19:37:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "19:38:38" , 
"departure_time" : "19:39:15" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "19:40:37" , 
"departure_time" : "19:41:08" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "19:43:31" , 
"departure_time" : "19:44:53" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "19:47:22" , 
"departure_time" : "19:47:40" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "19:47:18" , 
"departure_time" : "19:47:25" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:53:07" , 
"departure_time" : "19:53:57" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:55:50" , 
"departure_time" : "19:56:09" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:57:19" , 
"departure_time" : "19:58:38" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:00:19" , 
"departure_time" : "20:00:30" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:01:11" , 
"departure_time" : "20:01:37" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:03:26" , 
"departure_time" : "20:04:02" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:04:36" , 
"departure_time" : "20:05:07" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:07:31" , 
"departure_time" : "20:07:45" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "20:10:14" , 
"departure_time" : "20:11:12" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "20:12:58" , 
"departure_time" : "20:13:24" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "20:14:26" , 
"departure_time" : "20:14:26" , 
"distance_traveled" : 10.0589
} ], 
"569" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "19:56:00" , 
"departure_time" : "19:57:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "19:58:53" , 
"departure_time" : "20:00:26" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "20:01:33" , 
"departure_time" : "20:03:00" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "20:04:27" , 
"departure_time" : "20:05:32" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "20:07:05" , 
"departure_time" : "20:07:36" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "20:07:31" , 
"departure_time" : "20:08:53" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:14:22" , 
"departure_time" : "20:15:31" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:16:09" , 
"departure_time" : "20:16:43" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:17:34" , 
"departure_time" : "20:18:11" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:19:37" , 
"departure_time" : "20:19:40" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:21:03" , 
"departure_time" : "20:22:05" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:24:02" , 
"departure_time" : "20:24:32" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:24:30" , 
"departure_time" : "20:25:10" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:27:40" , 
"departure_time" : "20:29:09" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "20:31:29" , 
"departure_time" : "20:32:58" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "20:33:29" , 
"departure_time" : "20:35:01" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "20:35:32" , 
"departure_time" : "20:35:32" , 
"distance_traveled" : 10.0589
} ], 
"570" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "20:16:00" , 
"departure_time" : "20:17:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "20:18:20" , 
"departure_time" : "20:19:25" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "20:21:05" , 
"departure_time" : "20:22:01" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "20:23:56" , 
"departure_time" : "20:24:02" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "20:26:06" , 
"departure_time" : "20:27:34" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "20:28:28" , 
"departure_time" : "20:28:48" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:33:20" , 
"departure_time" : "20:34:46" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:36:26" , 
"departure_time" : "20:37:04" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:37:38" , 
"departure_time" : "20:38:48" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:40:10" , 
"departure_time" : "20:41:17" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:42:07" , 
"departure_time" : "20:43:30" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:44:23" , 
"departure_time" : "20:45:49" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:45:26" , 
"departure_time" : "20:45:59" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:47:33" , 
"departure_time" : "20:48:38" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "20:51:05" , 
"departure_time" : "20:51:31" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "20:52:26" , 
"departure_time" : "20:53:35" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "20:55:09" , 
"departure_time" : "20:55:09" , 
"distance_traveled" : 10.0589
} ], 
"571" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "20:36:00" , 
"departure_time" : "20:37:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "20:38:22" , 
"departure_time" : "20:39:50" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "20:41:28" , 
"departure_time" : "20:42:29" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "20:44:01" , 
"departure_time" : "20:44:46" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "20:46:45" , 
"departure_time" : "20:48:11" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "20:48:26" , 
"departure_time" : "20:49:31" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:54:05" , 
"departure_time" : "20:54:16" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:55:11" , 
"departure_time" : "20:56:12" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:58:01" , 
"departure_time" : "20:58:05" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:59:04" , 
"departure_time" : "21:00:44" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:02:40" , 
"departure_time" : "21:03:18" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "21:03:38" , 
"departure_time" : "21:04:01" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "21:04:23" , 
"departure_time" : "21:04:34" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:07:11" , 
"departure_time" : "21:08:00" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "21:10:49" , 
"departure_time" : "21:11:02" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "21:12:13" , 
"departure_time" : "21:13:21" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "21:15:08" , 
"departure_time" : "21:15:08" , 
"distance_traveled" : 10.0589
} ], 
"572" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "20:56:00" , 
"departure_time" : "20:58:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "20:58:52" , 
"departure_time" : "20:59:09" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "21:00:17" , 
"departure_time" : "21:01:11" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "21:03:54" , 
"departure_time" : "21:05:15" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "21:07:21" , 
"departure_time" : "21:08:09" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "21:07:48" , 
"departure_time" : "21:09:19" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:14:31" , 
"departure_time" : "21:14:59" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:15:28" , 
"departure_time" : "21:16:01" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:17:33" , 
"departure_time" : "21:18:19" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "21:19:46" , 
"departure_time" : "21:21:17" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:22:31" , 
"departure_time" : "21:23:21" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "21:23:50" , 
"departure_time" : "21:24:05" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "21:24:15" , 
"departure_time" : "21:25:17" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:28:02" , 
"departure_time" : "21:28:47" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "21:30:45" , 
"departure_time" : "21:31:06" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "21:32:21" , 
"departure_time" : "21:33:08" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "21:34:47" , 
"departure_time" : "21:34:47" , 
"distance_traveled" : 10.0589
} ], 
"573" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "21:16:00" , 
"departure_time" : "21:16:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "21:18:10" , 
"departure_time" : "21:18:12" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "21:20:02" , 
"departure_time" : "21:20:05" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "21:23:03" , 
"departure_time" : "21:24:30" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "21:27:27" , 
"departure_time" : "21:27:51" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "21:27:24" , 
"departure_time" : "21:28:02" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:33:38" , 
"departure_time" : "21:34:00" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:35:22" , 
"departure_time" : "21:36:55" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:38:33" , 
"departure_time" : "21:39:16" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "21:39:43" , 
"departure_time" : "21:40:42" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:41:59" , 
"departure_time" : "21:43:10" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "21:44:11" , 
"departure_time" : "21:45:08" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "21:44:57" , 
"departure_time" : "21:46:05" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:48:08" , 
"departure_time" : "21:48:53" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "21:50:45" , 
"departure_time" : "21:51:54" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "21:53:09" , 
"departure_time" : "21:54:27" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "21:55:18" , 
"departure_time" : "21:55:18" , 
"distance_traveled" : 10.0589
} ], 
"574" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "21:36:00" , 
"departure_time" : "21:37:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "21:38:15" , 
"departure_time" : "21:39:25" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "21:41:10" , 
"departure_time" : "21:41:27" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "21:43:17" , 
"departure_time" : "21:44:22" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "21:47:05" , 
"departure_time" : "21:47:56" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "21:47:51" , 
"departure_time" : "21:49:16" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:54:25" , 
"departure_time" : "21:54:33" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:55:08" , 
"departure_time" : "21:55:22" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:57:14" , 
"departure_time" : "21:58:28" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:00:14" , 
"departure_time" : "22:01:05" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:01:51" , 
"departure_time" : "22:02:31" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:03:40" , 
"departure_time" : "22:04:48" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:05:08" , 
"departure_time" : "22:05:53" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:07:45" , 
"departure_time" : "22:08:25" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "22:10:40" , 
"departure_time" : "22:11:27" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "22:12:47" , 
"departure_time" : "22:13:48" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "22:15:01" , 
"departure_time" : "22:15:01" , 
"distance_traveled" : 10.0589
} ], 
"575" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "21:56:00" , 
"departure_time" : "21:57:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "21:58:14" , 
"departure_time" : "21:58:58" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "22:00:44" , 
"departure_time" : "22:01:46" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "22:04:02" , 
"departure_time" : "22:04:47" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "22:06:45" , 
"departure_time" : "22:08:12" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "22:08:27" , 
"departure_time" : "22:09:26" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:13:59" , 
"departure_time" : "22:15:22" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:16:23" , 
"departure_time" : "22:16:42" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:17:19" , 
"departure_time" : "22:18:28" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:20:09" , 
"departure_time" : "22:20:22" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:21:13" , 
"departure_time" : "22:21:41" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:23:28" , 
"departure_time" : "22:24:06" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:24:38" , 
"departure_time" : "22:25:04" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:27:26" , 
"departure_time" : "22:28:53" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "22:31:27" , 
"departure_time" : "22:32:53" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "22:33:26" , 
"departure_time" : "22:33:51" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "22:34:25" , 
"departure_time" : "22:34:25" , 
"distance_traveled" : 10.0589
} ], 
"576" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "22:16:00" , 
"departure_time" : "22:16:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "22:18:14" , 
"departure_time" : "22:18:58" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "22:20:44" , 
"departure_time" : "22:20:48" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "22:23:04" , 
"departure_time" : "22:23:13" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "22:26:09" , 
"departure_time" : "22:27:39" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "22:28:30" , 
"departure_time" : "22:28:32" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:33:02" , 
"departure_time" : "22:33:30" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:35:28" , 
"departure_time" : "22:36:01" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:37:33" , 
"departure_time" : "22:38:39" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:40:06" , 
"departure_time" : "22:41:41" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:42:35" , 
"departure_time" : "22:43:23" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:43:48" , 
"departure_time" : "22:45:15" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:45:27" , 
"departure_time" : "22:46:09" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:47:42" , 
"departure_time" : "22:48:43" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "22:51:01" , 
"departure_time" : "22:51:13" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "22:52:12" , 
"departure_time" : "22:52:54" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "22:54:42" , 
"departure_time" : "22:54:42" , 
"distance_traveled" : 10.0589
} ], 
"577" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "22:36:00" , 
"departure_time" : "22:37:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "22:38:48" , 
"departure_time" : "22:39:45" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "22:40:57" , 
"departure_time" : "22:42:08" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "22:44:11" , 
"departure_time" : "22:45:25" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "22:47:14" , 
"departure_time" : "22:48:00" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "22:47:46" , 
"departure_time" : "22:48:13" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:53:27" , 
"departure_time" : "22:54:58" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:56:31" , 
"departure_time" : "22:57:00" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:57:29" , 
"departure_time" : "22:58:57" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:00:28" , 
"departure_time" : "23:01:01" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:01:33" , 
"departure_time" : "23:01:48" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "23:03:15" , 
"departure_time" : "23:03:34" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:04:19" , 
"departure_time" : "23:05:21" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:08:02" , 
"departure_time" : "23:09:41" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "23:11:39" , 
"departure_time" : "23:11:46" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "23:12:07" , 
"departure_time" : "23:12:29" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "23:14:22" , 
"departure_time" : "23:14:22" , 
"distance_traveled" : 10.0589
} ], 
"578" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "22:56:00" , 
"departure_time" : "22:57:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "22:58:38" , 
"departure_time" : "23:00:07" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "23:01:29" , 
"departure_time" : "23:02:36" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "23:04:07" , 
"departure_time" : "23:04:52" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "23:06:45" , 
"departure_time" : "23:08:01" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "23:08:16" , 
"departure_time" : "23:08:28" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:13:12" , 
"departure_time" : "23:14:26" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:16:14" , 
"departure_time" : "23:16:16" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:17:02" , 
"departure_time" : "23:17:08" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:19:06" , 
"departure_time" : "23:19:14" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:21:08" , 
"departure_time" : "23:21:16" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "23:23:08" , 
"departure_time" : "23:23:47" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:24:39" , 
"departure_time" : "23:25:09" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:27:30" , 
"departure_time" : "23:27:35" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "23:30:05" , 
"departure_time" : "23:30:51" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "23:32:46" , 
"departure_time" : "23:33:25" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "23:34:39" , 
"departure_time" : "23:34:39" , 
"distance_traveled" : 10.0589
} ], 
"579" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "23:16:00" , 
"departure_time" : "23:18:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "23:19:29" , 
"departure_time" : "23:20:00" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "23:20:31" , 
"departure_time" : "23:21:50" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "23:24:19" , 
"departure_time" : "23:24:39" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "23:26:20" , 
"departure_time" : "23:26:54" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "23:27:34" , 
"departure_time" : "23:28:52" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:34:18" , 
"departure_time" : "23:34:34" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:35:16" , 
"departure_time" : "23:36:05" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:37:49" , 
"departure_time" : "23:38:16" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:39:27" , 
"departure_time" : "23:40:10" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:41:43" , 
"departure_time" : "23:42:20" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "23:43:37" , 
"departure_time" : "23:45:03" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:45:26" , 
"departure_time" : "23:45:34" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:47:08" , 
"departure_time" : "23:47:27" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "23:50:19" , 
"departure_time" : "23:50:47" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "23:52:28" , 
"departure_time" : "23:53:29" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "23:55:01" , 
"departure_time" : "23:55:01" , 
"distance_traveled" : 10.0589
} ], 
"580" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "23:36:00" , 
"departure_time" : "23:38:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "23:39:10" , 
"departure_time" : "23:40:09" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "23:40:59" , 
"departure_time" : "23:41:35" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "23:43:36" , 
"departure_time" : "23:43:46" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "23:46:10" , 
"departure_time" : "23:46:13" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "23:47:03" , 
"departure_time" : "23:48:32" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:54:29" , 
"departure_time" : "23:54:58" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:55:29" , 
"departure_time" : "23:56:55" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:58:26" , 
"departure_time" : "23:58:49" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:59:23" , 
"departure_time" : "24:00:10" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "24:01:47" , 
"departure_time" : "24:02:06" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "24:03:19" , 
"departure_time" : "24:04:41" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "24:05:22" , 
"departure_time" : "24:06:00" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "24:07:38" , 
"departure_time" : "24:07:55" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "24:10:17" , 
"departure_time" : "24:10:55" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "24:12:38" , 
"departure_time" : "24:12:58" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "24:14:20" , 
"departure_time" : "24:14:20" , 
"distance_traveled" : 10.0589
} ], 
"581" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "23:56:00" , 
"departure_time" : "23:56:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "23:58:07" , 
"departure_time" : "23:59:31" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "24:01:24" , 
"departure_time" : "24:01:55" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "24:03:31" , 
"departure_time" : "24:03:40" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "24:06:09" , 
"departure_time" : "24:06:54" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "24:07:45" , 
"departure_time" : "24:08:53" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "24:14:08" , 
"departure_time" : "24:15:33" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "24:16:25" , 
"departure_time" : "24:18:00" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "24:18:35" , 
"departure_time" : "24:19:32" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "24:19:57" , 
"departure_time" : "24:21:30" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "24:22:33" , 
"departure_time" : "24:23:22" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "24:23:49" , 
"departure_time" : "24:25:10" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "24:25:21" , 
"departure_time" : "24:26:33" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "24:28:12" , 
"departure_time" : "24:28:32" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "24:30:20" , 
"departure_time" : "24:30:23" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "24:32:03" , 
"departure_time" : "24:32:33" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "24:34:30" , 
"departure_time" : "24:34:30" , 
"distance_traveled" : 10.0589
} ], 
"582" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "24:16:00" , 
"departure_time" : "24:16:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "24:18:21" , 
"departure_time" : "24:19:12" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "24:20:51" , 
"departure_time" : "24:22:28" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "24:24:37" , 
"departure_time" : "24:26:06" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "24:27:29" , 
"departure_time" : "24:28:31" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "24:28:02" , 
"departure_time" : "24:29:39" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "24:34:37" , 
"departure_time" : "24:35:07" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "24:35:30" , 
"departure_time" : "24:36:47" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "24:38:17" , 
"departure_time" : "24:39:13" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "24:39:56" , 
"departure_time" : "24:40:13" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "24:41:17" , 
"departure_time" : "24:42:32" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "24:44:15" , 
"departure_time" : "24:44:59" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "24:44:44" , 
"departure_time" : "24:46:08" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "24:48:24" , 
"departure_time" : "24:48:30" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "24:50:06" , 
"departure_time" : "24:51:07" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "24:53:01" , 
"departure_time" : "24:54:37" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "24:55:36" , 
"departure_time" : "24:55:36" , 
"distance_traveled" : 10.0589
} ], 
"583" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "24:36:00" , 
"departure_time" : "24:37:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "24:38:11" , 
"departure_time" : "24:38:44" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "24:40:33" , 
"departure_time" : "24:41:04" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "24:43:31" , 
"departure_time" : "24:43:50" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "24:46:19" , 
"departure_time" : "24:46:24" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "24:47:05" , 
"departure_time" : "24:47:42" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "24:53:37" , 
"departure_time" : "24:54:47" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "24:56:10" , 
"departure_time" : "24:56:45" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "24:57:35" , 
"departure_time" : "24:58:40" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "25:00:05" , 
"departure_time" : "25:00:36" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "25:01:31" , 
"departure_time" : "25:01:50" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "25:03:19" , 
"departure_time" : "25:04:45" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "25:05:26" , 
"departure_time" : "25:05:51" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "25:07:25" , 
"departure_time" : "25:08:16" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "25:10:51" , 
"departure_time" : "25:12:18" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "25:13:27" , 
"departure_time" : "25:13:45" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "25:14:18" , 
"departure_time" : "25:14:18" , 
"distance_traveled" : 10.0589
} ], 
"584" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "25:01:00" , 
"departure_time" : "25:01:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "25:03:15" , 
"departure_time" : "25:03:27" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "25:05:12" , 
"departure_time" : "25:06:39" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "25:09:27" , 
"departure_time" : "25:09:49" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "25:11:22" , 
"departure_time" : "25:11:51" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "25:12:29" , 
"departure_time" : "25:13:29" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "25:19:00" , 
"departure_time" : "25:19:49" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "25:20:49" , 
"departure_time" : "25:20:54" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "25:22:05" , 
"departure_time" : "25:22:13" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "25:24:08" , 
"departure_time" : "25:24:09" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "25:26:01" , 
"departure_time" : "25:26:27" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "25:28:26" , 
"departure_time" : "25:29:30" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "25:30:04" , 
"departure_time" : "25:31:08" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "25:33:04" , 
"departure_time" : "25:33:36" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "25:35:32" , 
"departure_time" : "25:36:58" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "25:38:26" , 
"departure_time" : "25:39:27" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "25:40:01" , 
"departure_time" : "25:40:01" , 
"distance_traveled" : 10.0589
} ], 
"585" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "25:31:00" , 
"departure_time" : "25:33:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "25:34:32" , 
"departure_time" : "25:35:44" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "25:36:12" , 
"departure_time" : "25:37:25" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "25:39:13" , 
"departure_time" : "25:40:30" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "25:42:17" , 
"departure_time" : "25:43:20" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "25:43:03" , 
"departure_time" : "25:44:21" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "25:49:18" , 
"departure_time" : "25:50:56" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "25:51:38" , 
"departure_time" : "25:52:21" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "25:52:43" , 
"departure_time" : "25:53:14" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "25:54:31" , 
"departure_time" : "25:55:27" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "25:56:56" , 
"departure_time" : "25:58:17" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "25:59:21" , 
"departure_time" : "26:00:04" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "25:59:43" , 
"departure_time" : "25:59:45" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "26:02:02" , 
"departure_time" : "26:02:22" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "26:05:20" , 
"departure_time" : "26:06:49" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "26:08:29" , 
"departure_time" : "26:08:58" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "26:09:29" , 
"departure_time" : "26:09:29" , 
"distance_traveled" : 10.0589
} ], 
"586" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "06:09:00" , 
"departure_time" : "06:09:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "06:11:18" , 
"departure_time" : "06:12:07" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "06:13:49" , 
"departure_time" : "06:15:04" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "06:16:15" , 
"departure_time" : "06:16:38" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "06:17:23" , 
"departure_time" : "06:18:52" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "06:19:29" , 
"departure_time" : "06:20:16" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:21:47" , 
"departure_time" : "06:22:24" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:24:37" , 
"departure_time" : "06:25:49" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:26:12" , 
"departure_time" : "06:26:26" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:27:14" , 
"departure_time" : "06:27:59" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:29:45" , 
"departure_time" : "06:30:49" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:32:04" , 
"departure_time" : "06:33:04" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:34:00" , 
"departure_time" : "06:34:22" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:36:22" , 
"departure_time" : "06:36:28" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "06:40:06" , 
"departure_time" : "06:40:06" , 
"distance_traveled" : 9.0456
} ], 
"587" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "06:29:00" , 
"departure_time" : "06:30:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "06:32:28" , 
"departure_time" : "06:32:41" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "06:33:13" , 
"departure_time" : "06:34:38" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "06:36:25" , 
"departure_time" : "06:37:01" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "06:37:36" , 
"departure_time" : "06:38:50" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "06:39:14" , 
"departure_time" : "06:40:06" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:41:52" , 
"departure_time" : "06:42:37" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:44:45" , 
"departure_time" : "06:46:06" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:46:21" , 
"departure_time" : "06:47:15" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:47:54" , 
"departure_time" : "06:48:28" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:49:34" , 
"departure_time" : "06:50:44" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:52:10" , 
"departure_time" : "06:52:56" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:53:46" , 
"departure_time" : "06:54:45" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:56:59" , 
"departure_time" : "06:58:20" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "07:01:21" , 
"departure_time" : "07:01:21" , 
"distance_traveled" : 9.0456
} ], 
"588" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "06:49:00" , 
"departure_time" : "06:51:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "06:52:22" , 
"departure_time" : "06:52:53" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "06:53:31" , 
"departure_time" : "06:53:34" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "06:55:03" , 
"departure_time" : "06:56:20" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "06:58:17" , 
"departure_time" : "06:58:24" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "06:58:07" , 
"departure_time" : "06:58:40" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:01:33" , 
"departure_time" : "07:01:56" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:04:23" , 
"departure_time" : "07:04:29" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:05:06" , 
"departure_time" : "07:06:16" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:08:10" , 
"departure_time" : "07:08:51" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:09:41" , 
"departure_time" : "07:11:15" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:12:34" , 
"departure_time" : "07:13:17" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:13:43" , 
"departure_time" : "07:14:31" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:16:48" , 
"departure_time" : "07:16:53" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "07:20:05" , 
"departure_time" : "07:20:05" , 
"distance_traveled" : 9.0456
} ], 
"589" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "07:09:00" , 
"departure_time" : "07:09:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "07:11:38" , 
"departure_time" : "07:13:09" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "07:14:31" , 
"departure_time" : "07:14:52" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "07:15:21" , 
"departure_time" : "07:16:06" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "07:17:45" , 
"departure_time" : "07:17:56" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "07:18:11" , 
"departure_time" : "07:19:37" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:22:26" , 
"departure_time" : "07:22:34" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:24:08" , 
"departure_time" : "07:25:26" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:26:18" , 
"departure_time" : "07:27:16" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:27:58" , 
"departure_time" : "07:29:22" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:30:24" , 
"departure_time" : "07:30:46" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:31:22" , 
"departure_time" : "07:31:46" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:33:24" , 
"departure_time" : "07:33:41" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:36:17" , 
"departure_time" : "07:36:57" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "07:40:40" , 
"departure_time" : "07:40:40" , 
"distance_traveled" : 9.0456
} ], 
"590" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "07:29:00" , 
"departure_time" : "07:29:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "07:31:04" , 
"departure_time" : "07:32:39" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "07:34:35" , 
"departure_time" : "07:35:54" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "07:36:19" , 
"departure_time" : "07:37:48" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "07:38:29" , 
"departure_time" : "07:39:17" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "07:38:48" , 
"departure_time" : "07:39:24" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:41:36" , 
"departure_time" : "07:43:01" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:45:25" , 
"departure_time" : "07:46:10" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:45:45" , 
"departure_time" : "07:45:58" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:47:13" , 
"departure_time" : "07:48:44" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:50:31" , 
"departure_time" : "07:51:56" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:52:25" , 
"departure_time" : "07:53:29" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:54:04" , 
"departure_time" : "07:55:07" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:57:03" , 
"departure_time" : "07:57:20" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "08:00:17" , 
"departure_time" : "08:00:17" , 
"distance_traveled" : 9.0456
} ], 
"591" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "07:49:00" , 
"departure_time" : "07:50:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "07:52:33" , 
"departure_time" : "07:52:58" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "07:53:25" , 
"departure_time" : "07:55:02" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "07:56:37" , 
"departure_time" : "07:57:11" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "07:57:34" , 
"departure_time" : "07:57:37" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "07:58:03" , 
"departure_time" : "07:59:10" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:02:07" , 
"departure_time" : "08:03:20" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:05:13" , 
"departure_time" : "08:05:52" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:05:39" , 
"departure_time" : "08:07:05" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:08:26" , 
"departure_time" : "08:09:40" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:10:14" , 
"departure_time" : "08:11:07" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:11:53" , 
"departure_time" : "08:11:54" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:13:01" , 
"departure_time" : "08:14:38" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:17:37" , 
"departure_time" : "08:18:29" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "08:20:52" , 
"departure_time" : "08:20:52" , 
"distance_traveled" : 9.0456
} ], 
"592" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "08:09:00" , 
"departure_time" : "08:10:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "08:11:30" , 
"departure_time" : "08:13:07" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "08:14:37" , 
"departure_time" : "08:14:50" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "08:15:13" , 
"departure_time" : "08:15:29" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "08:17:16" , 
"departure_time" : "08:17:43" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "08:18:27" , 
"departure_time" : "08:18:45" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:21:18" , 
"departure_time" : "08:22:57" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:25:39" , 
"departure_time" : "08:26:58" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:26:19" , 
"departure_time" : "08:26:33" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:27:14" , 
"departure_time" : "08:28:51" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:30:37" , 
"departure_time" : "08:30:41" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:31:04" , 
"departure_time" : "08:31:08" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:33:04" , 
"departure_time" : "08:33:23" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:36:19" , 
"departure_time" : "08:37:40" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "08:41:21" , 
"departure_time" : "08:41:21" , 
"distance_traveled" : 9.0456
} ], 
"593" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "08:29:00" , 
"departure_time" : "08:30:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "08:31:23" , 
"departure_time" : "08:32:08" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "08:33:45" , 
"departure_time" : "08:33:57" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "08:35:12" , 
"departure_time" : "08:36:01" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "08:37:49" , 
"departure_time" : "08:38:34" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "08:38:45" , 
"departure_time" : "08:39:58" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:42:13" , 
"departure_time" : "08:42:59" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:44:46" , 
"departure_time" : "08:45:03" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:45:17" , 
"departure_time" : "08:46:02" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:47:45" , 
"departure_time" : "08:49:24" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:50:39" , 
"departure_time" : "08:51:25" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:51:46" , 
"departure_time" : "08:53:11" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:54:25" , 
"departure_time" : "08:55:37" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:57:12" , 
"departure_time" : "08:58:27" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "09:01:15" , 
"departure_time" : "09:01:15" , 
"distance_traveled" : 9.0456
} ], 
"594" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "08:49:00" , 
"departure_time" : "08:50:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "08:51:20" , 
"departure_time" : "08:52:29" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "08:54:09" , 
"departure_time" : "08:55:16" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "08:56:07" , 
"departure_time" : "08:57:02" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "08:57:55" , 
"departure_time" : "08:58:57" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "08:59:02" , 
"departure_time" : "09:00:07" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:02:05" , 
"departure_time" : "09:03:29" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:05:24" , 
"departure_time" : "09:06:29" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:06:05" , 
"departure_time" : "09:06:21" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:07:16" , 
"departure_time" : "09:08:05" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:09:49" , 
"departure_time" : "09:10:55" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:12:06" , 
"departure_time" : "09:12:35" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:13:29" , 
"departure_time" : "09:13:43" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:16:14" , 
"departure_time" : "09:16:57" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "09:20:43" , 
"departure_time" : "09:20:43" , 
"distance_traveled" : 9.0456
} ], 
"595" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "09:09:00" , 
"departure_time" : "09:10:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "09:12:15" , 
"departure_time" : "09:12:32" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "09:13:17" , 
"departure_time" : "09:13:44" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "09:15:27" , 
"departure_time" : "09:16:17" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "09:17:50" , 
"departure_time" : "09:18:14" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "09:18:24" , 
"departure_time" : "09:19:29" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:22:05" , 
"departure_time" : "09:23:24" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:25:19" , 
"departure_time" : "09:25:56" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:25:37" , 
"departure_time" : "09:26:25" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:27:48" , 
"departure_time" : "09:28:23" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:29:35" , 
"departure_time" : "09:30:29" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:31:54" , 
"departure_time" : "09:32:02" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:33:08" , 
"departure_time" : "09:33:56" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:36:48" , 
"departure_time" : "09:38:08" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "09:41:20" , 
"departure_time" : "09:41:20" , 
"distance_traveled" : 9.0456
} ], 
"596" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "09:29:00" , 
"departure_time" : "09:31:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "09:31:50" , 
"departure_time" : "09:32:37" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "09:33:47" , 
"departure_time" : "09:33:57" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "09:35:10" , 
"departure_time" : "09:35:45" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "09:37:35" , 
"departure_time" : "09:39:13" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "09:39:38" , 
"departure_time" : "09:40:29" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:41:51" , 
"departure_time" : "09:42:46" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:44:55" , 
"departure_time" : "09:45:33" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:45:38" , 
"departure_time" : "09:47:18" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:48:40" , 
"departure_time" : "09:49:42" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:50:02" , 
"departure_time" : "09:50:53" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:51:51" , 
"departure_time" : "09:53:26" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:54:35" , 
"departure_time" : "09:55:23" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:56:48" , 
"departure_time" : "09:57:02" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "10:00:14" , 
"departure_time" : "10:00:14" , 
"distance_traveled" : 9.0456
} ], 
"597" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "09:49:00" , 
"departure_time" : "09:50:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "09:52:19" , 
"departure_time" : "09:52:44" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "09:53:25" , 
"departure_time" : "09:53:37" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "09:55:12" , 
"departure_time" : "09:56:32" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "09:58:20" , 
"departure_time" : "09:59:27" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "09:59:07" , 
"departure_time" : "09:59:11" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:01:04" , 
"departure_time" : "10:01:09" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:04:05" , 
"departure_time" : "10:05:31" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:06:26" , 
"departure_time" : "10:06:36" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:07:10" , 
"departure_time" : "10:07:22" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:09:12" , 
"departure_time" : "10:10:31" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:12:19" , 
"departure_time" : "10:12:48" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:13:29" , 
"departure_time" : "10:14:20" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:16:51" , 
"departure_time" : "10:17:46" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "10:20:55" , 
"departure_time" : "10:20:55" , 
"distance_traveled" : 9.0456
} ], 
"598" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "10:09:00" , 
"departure_time" : "10:10:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "10:11:56" , 
"departure_time" : "10:13:13" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "10:14:17" , 
"departure_time" : "10:14:49" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "10:15:32" , 
"departure_time" : "10:17:08" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "10:18:36" , 
"departure_time" : "10:20:09" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "10:19:33" , 
"departure_time" : "10:19:40" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:21:07" , 
"departure_time" : "10:21:53" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:24:46" , 
"departure_time" : "10:25:14" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:25:28" , 
"departure_time" : "10:25:51" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:27:23" , 
"departure_time" : "10:28:26" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:30:03" , 
"departure_time" : "10:30:17" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:31:14" , 
"departure_time" : "10:31:51" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:33:37" , 
"departure_time" : "10:34:48" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:37:11" , 
"departure_time" : "10:37:47" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "10:40:36" , 
"departure_time" : "10:40:36" , 
"distance_traveled" : 9.0456
} ], 
"599" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "10:29:00" , 
"departure_time" : "10:29:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "10:31:04" , 
"departure_time" : "10:31:33" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "10:33:29" , 
"departure_time" : "10:33:59" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "10:35:30" , 
"departure_time" : "10:35:35" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "10:37:05" , 
"departure_time" : "10:38:00" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "10:38:55" , 
"departure_time" : "10:39:30" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:41:35" , 
"departure_time" : "10:43:00" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:45:25" , 
"departure_time" : "10:46:43" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:46:18" , 
"departure_time" : "10:47:08" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:47:50" , 
"departure_time" : "10:48:54" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:50:04" , 
"departure_time" : "10:50:06" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:51:02" , 
"departure_time" : "10:52:16" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:54:14" , 
"departure_time" : "10:55:04" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:56:50" , 
"departure_time" : "10:58:10" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "11:01:20" , 
"departure_time" : "11:01:20" , 
"distance_traveled" : 9.0456
} ], 
"600" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "10:49:00" , 
"departure_time" : "10:50:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "10:51:04" , 
"departure_time" : "10:52:21" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "10:54:17" , 
"departure_time" : "10:54:34" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "10:55:17" , 
"departure_time" : "10:56:20" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "10:58:03" , 
"departure_time" : "10:58:04" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "10:58:01" , 
"departure_time" : "10:58:04" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:01:03" , 
"departure_time" : "11:02:17" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:05:14" , 
"departure_time" : "11:05:37" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:05:23" , 
"departure_time" : "11:06:01" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:07:38" , 
"departure_time" : "11:09:06" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:10:28" , 
"departure_time" : "11:11:00" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:11:32" , 
"departure_time" : "11:13:05" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:14:33" , 
"departure_time" : "11:14:52" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:16:19" , 
"departure_time" : "11:16:46" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "11:20:27" , 
"departure_time" : "11:20:27" , 
"distance_traveled" : 9.0456
} ], 
"601" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "11:09:00" , 
"departure_time" : "11:10:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "11:12:23" , 
"departure_time" : "11:12:43" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "11:13:20" , 
"departure_time" : "11:14:39" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "11:16:19" , 
"departure_time" : "11:16:53" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "11:17:34" , 
"departure_time" : "11:18:41" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "11:19:07" , 
"departure_time" : "11:19:37" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:21:30" , 
"departure_time" : "11:22:28" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:24:58" , 
"departure_time" : "11:25:06" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:25:08" , 
"departure_time" : "11:26:10" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:28:02" , 
"departure_time" : "11:29:30" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:30:28" , 
"departure_time" : "11:30:41" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:31:13" , 
"departure_time" : "11:31:35" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:33:22" , 
"departure_time" : "11:34:41" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:37:19" , 
"departure_time" : "11:38:41" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "11:41:22" , 
"departure_time" : "11:41:22" , 
"distance_traveled" : 9.0456
} ], 
"602" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "11:29:00" , 
"departure_time" : "11:31:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "11:31:57" , 
"departure_time" : "11:32:11" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "11:33:14" , 
"departure_time" : "11:33:47" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "11:35:33" , 
"departure_time" : "11:36:22" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "11:37:49" , 
"departure_time" : "11:37:52" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "11:38:03" , 
"departure_time" : "11:38:41" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:41:38" , 
"departure_time" : "11:42:52" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:45:14" , 
"departure_time" : "11:46:00" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:45:46" , 
"departure_time" : "11:46:33" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:47:47" , 
"departure_time" : "11:48:34" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:49:47" , 
"departure_time" : "11:50:05" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:51:18" , 
"departure_time" : "11:51:37" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:53:19" , 
"departure_time" : "11:54:07" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:56:48" , 
"departure_time" : "11:57:49" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "12:01:01" , 
"departure_time" : "12:01:01" , 
"distance_traveled" : 9.0456
} ], 
"603" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "11:49:00" , 
"departure_time" : "11:50:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "11:51:27" , 
"departure_time" : "11:51:58" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "11:53:31" , 
"departure_time" : "11:53:41" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "11:55:10" , 
"departure_time" : "11:56:42" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "11:58:32" , 
"departure_time" : "11:58:55" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "11:58:23" , 
"departure_time" : "11:59:19" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:01:56" , 
"departure_time" : "12:02:48" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:04:52" , 
"departure_time" : "12:05:56" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:06:04" , 
"departure_time" : "12:07:09" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:08:05" , 
"departure_time" : "12:09:36" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:10:31" , 
"departure_time" : "12:11:00" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:11:29" , 
"departure_time" : "12:12:12" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:13:43" , 
"departure_time" : "12:13:46" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:16:03" , 
"departure_time" : "12:16:21" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "12:20:18" , 
"departure_time" : "12:20:18" , 
"distance_traveled" : 9.0456
} ], 
"604" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "12:09:00" , 
"departure_time" : "12:10:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "12:11:54" , 
"departure_time" : "12:13:19" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "12:14:25" , 
"departure_time" : "12:14:46" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "12:15:21" , 
"departure_time" : "12:16:23" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "12:18:02" , 
"departure_time" : "12:19:12" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "12:19:10" , 
"departure_time" : "12:19:37" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:21:27" , 
"departure_time" : "12:21:50" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:24:23" , 
"departure_time" : "12:25:34" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:26:11" , 
"departure_time" : "12:27:00" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:27:49" , 
"departure_time" : "12:27:51" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:29:02" , 
"departure_time" : "12:30:17" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:32:15" , 
"departure_time" : "12:33:09" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:33:54" , 
"departure_time" : "12:34:25" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:36:31" , 
"departure_time" : "12:37:29" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "12:40:58" , 
"departure_time" : "12:40:58" , 
"distance_traveled" : 9.0456
} ], 
"605" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "12:29:00" , 
"departure_time" : "12:31:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "12:32:30" , 
"departure_time" : "12:33:55" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "12:34:25" , 
"departure_time" : "12:35:15" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "12:35:50" , 
"departure_time" : "12:35:54" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "12:37:04" , 
"departure_time" : "12:37:35" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "12:38:31" , 
"departure_time" : "12:39:38" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:42:07" , 
"departure_time" : "12:43:07" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:45:00" , 
"departure_time" : "12:45:18" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:45:18" , 
"departure_time" : "12:46:51" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:48:33" , 
"departure_time" : "12:48:54" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:49:21" , 
"departure_time" : "12:50:05" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:51:44" , 
"departure_time" : "12:52:06" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:53:22" , 
"departure_time" : "12:54:01" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:56:39" , 
"departure_time" : "12:57:42" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "13:01:03" , 
"departure_time" : "13:01:03" , 
"distance_traveled" : 9.0456
} ], 
"606" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "12:49:00" , 
"departure_time" : "12:50:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "12:51:51" , 
"departure_time" : "12:52:53" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "12:54:02" , 
"departure_time" : "12:55:16" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "12:56:14" , 
"departure_time" : "12:56:59" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "12:57:45" , 
"departure_time" : "12:57:55" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "12:58:10" , 
"departure_time" : "12:58:22" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:01:12" , 
"departure_time" : "13:02:13" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:05:01" , 
"departure_time" : "13:06:38" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:06:37" , 
"departure_time" : "13:07:14" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:07:37" , 
"departure_time" : "13:09:14" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:10:37" , 
"departure_time" : "13:10:40" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:11:03" , 
"departure_time" : "13:11:16" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:13:13" , 
"departure_time" : "13:14:28" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:17:15" , 
"departure_time" : "13:18:35" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "13:21:20" , 
"departure_time" : "13:21:20" , 
"distance_traveled" : 9.0456
} ], 
"607" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "13:09:00" , 
"departure_time" : "13:11:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "13:12:01" , 
"departure_time" : "13:13:33" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "13:14:32" , 
"departure_time" : "13:14:45" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "13:15:13" , 
"departure_time" : "13:15:55" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "13:17:42" , 
"departure_time" : "13:18:08" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "13:18:26" , 
"departure_time" : "13:19:40" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:22:14" , 
"departure_time" : "13:22:18" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:24:04" , 
"departure_time" : "13:24:26" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:25:22" , 
"departure_time" : "13:25:48" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:27:26" , 
"departure_time" : "13:28:16" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:29:50" , 
"departure_time" : "13:30:19" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:31:29" , 
"departure_time" : "13:32:51" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:34:22" , 
"departure_time" : "13:35:59" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:37:37" , 
"departure_time" : "13:38:32" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "13:40:55" , 
"departure_time" : "13:40:55" , 
"distance_traveled" : 9.0456
} ], 
"608" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "13:29:00" , 
"departure_time" : "13:30:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "13:31:49" , 
"departure_time" : "13:32:02" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "13:33:13" , 
"departure_time" : "13:33:53" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "13:35:40" , 
"departure_time" : "13:36:34" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "13:37:54" , 
"departure_time" : "13:38:32" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "13:38:38" , 
"departure_time" : "13:39:49" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:42:11" , 
"departure_time" : "13:43:27" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:45:16" , 
"departure_time" : "13:45:31" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:45:15" , 
"departure_time" : "13:45:48" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:47:33" , 
"departure_time" : "13:47:44" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:49:11" , 
"departure_time" : "13:50:20" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:52:09" , 
"departure_time" : "13:52:18" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:53:09" , 
"departure_time" : "13:54:09" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:57:00" , 
"departure_time" : "13:58:18" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "14:01:18" , 
"departure_time" : "14:01:18" , 
"distance_traveled" : 9.0456
} ], 
"609" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "13:49:00" , 
"departure_time" : "13:50:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "13:51:21" , 
"departure_time" : "13:51:46" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "13:53:25" , 
"departure_time" : "13:54:28" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "13:56:03" , 
"departure_time" : "13:56:49" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "13:57:46" , 
"departure_time" : "13:58:39" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "13:58:53" , 
"departure_time" : "14:00:17" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:02:24" , 
"departure_time" : "14:03:57" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:05:33" , 
"departure_time" : "14:06:38" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:06:05" , 
"departure_time" : "14:06:34" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:07:29" , 
"departure_time" : "14:09:03" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:10:34" , 
"departure_time" : "14:11:27" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:11:53" , 
"departure_time" : "14:12:58" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:14:05" , 
"departure_time" : "14:14:46" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:16:41" , 
"departure_time" : "14:17:18" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "14:20:37" , 
"departure_time" : "14:20:37" , 
"distance_traveled" : 9.0456
} ], 
"610" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "14:09:00" , 
"departure_time" : "14:11:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "14:12:34" , 
"departure_time" : "14:13:59" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "14:14:25" , 
"departure_time" : "14:15:43" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "14:16:18" , 
"departure_time" : "14:17:41" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "14:18:23" , 
"departure_time" : "14:19:47" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "14:19:24" , 
"departure_time" : "14:19:51" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:21:27" , 
"departure_time" : "14:22:37" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:25:10" , 
"departure_time" : "14:25:36" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:25:26" , 
"departure_time" : "14:26:07" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:27:41" , 
"departure_time" : "14:29:18" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:30:37" , 
"departure_time" : "14:31:44" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:32:07" , 
"departure_time" : "14:33:00" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:33:53" , 
"departure_time" : "14:35:05" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:37:12" , 
"departure_time" : "14:37:48" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "14:40:36" , 
"departure_time" : "14:40:36" , 
"distance_traveled" : 9.0456
} ], 
"611" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "14:29:00" , 
"departure_time" : "14:30:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "14:31:55" , 
"departure_time" : "14:33:18" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "14:34:23" , 
"departure_time" : "14:35:35" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "14:36:12" , 
"departure_time" : "14:37:13" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "14:38:01" , 
"departure_time" : "14:38:55" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "14:38:54" , 
"departure_time" : "14:39:54" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:42:00" , 
"departure_time" : "14:42:41" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:44:41" , 
"departure_time" : "14:44:51" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:45:10" , 
"departure_time" : "14:45:31" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:47:21" , 
"departure_time" : "14:47:51" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:49:30" , 
"departure_time" : "14:50:47" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:52:17" , 
"departure_time" : "14:53:49" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:54:32" , 
"departure_time" : "14:56:06" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:57:34" , 
"departure_time" : "14:58:04" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "15:00:30" , 
"departure_time" : "15:00:30" , 
"distance_traveled" : 9.0456
} ], 
"612" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "14:49:00" , 
"departure_time" : "14:49:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "14:51:13" , 
"departure_time" : "14:51:56" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "14:53:43" , 
"departure_time" : "14:54:35" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "14:55:52" , 
"departure_time" : "14:56:13" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "14:57:21" , 
"departure_time" : "14:58:45" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "14:59:24" , 
"departure_time" : "15:00:45" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:02:21" , 
"departure_time" : "15:02:30" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:04:09" , 
"departure_time" : "15:04:38" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:05:29" , 
"departure_time" : "15:05:44" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:07:15" , 
"departure_time" : "15:08:11" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:09:56" , 
"departure_time" : "15:11:17" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:12:21" , 
"departure_time" : "15:13:56" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:14:35" , 
"departure_time" : "15:15:12" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:16:37" , 
"departure_time" : "15:16:51" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "15:20:14" , 
"departure_time" : "15:20:14" , 
"distance_traveled" : 9.0456
} ], 
"613" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "15:09:00" , 
"departure_time" : "15:10:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "15:12:22" , 
"departure_time" : "15:14:00" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "15:14:38" , 
"departure_time" : "15:14:48" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "15:15:10" , 
"departure_time" : "15:16:04" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "15:17:54" , 
"departure_time" : "15:18:09" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "15:18:15" , 
"departure_time" : "15:18:49" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:21:34" , 
"departure_time" : "15:22:07" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:24:33" , 
"departure_time" : "15:25:28" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:25:55" , 
"departure_time" : "15:26:37" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:27:42" , 
"departure_time" : "15:28:18" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:29:36" , 
"departure_time" : "15:30:39" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:32:03" , 
"departure_time" : "15:32:07" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:33:04" , 
"departure_time" : "15:33:44" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:36:40" , 
"departure_time" : "15:37:04" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "15:40:24" , 
"departure_time" : "15:40:24" , 
"distance_traveled" : 9.0456
} ], 
"614" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "15:29:00" , 
"departure_time" : "15:30:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "15:31:54" , 
"departure_time" : "15:33:34" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "15:34:40" , 
"departure_time" : "15:35:13" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "15:35:33" , 
"departure_time" : "15:36:17" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "15:37:44" , 
"departure_time" : "15:38:05" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "15:38:21" , 
"departure_time" : "15:39:52" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:42:31" , 
"departure_time" : "15:43:39" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:45:08" , 
"departure_time" : "15:45:12" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:45:04" , 
"departure_time" : "15:46:09" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:48:05" , 
"departure_time" : "15:48:43" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:49:38" , 
"departure_time" : "15:50:57" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:52:19" , 
"departure_time" : "15:52:36" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:53:17" , 
"departure_time" : "15:53:50" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:56:33" , 
"departure_time" : "15:56:45" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "16:00:12" , 
"departure_time" : "16:00:12" , 
"distance_traveled" : 9.0456
} ], 
"615" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "15:49:00" , 
"departure_time" : "15:50:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "15:51:48" , 
"departure_time" : "15:52:43" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "15:53:55" , 
"departure_time" : "15:54:43" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "15:55:48" , 
"departure_time" : "15:56:26" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "15:57:38" , 
"departure_time" : "15:58:10" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "15:58:32" , 
"departure_time" : "15:59:35" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:02:03" , 
"departure_time" : "16:03:01" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:04:58" , 
"departure_time" : "16:05:45" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:05:47" , 
"departure_time" : "16:06:55" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:08:08" , 
"departure_time" : "16:08:55" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:09:47" , 
"departure_time" : "16:11:14" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:12:27" , 
"departure_time" : "16:12:29" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:13:02" , 
"departure_time" : "16:13:30" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:16:28" , 
"departure_time" : "16:16:29" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "16:20:01" , 
"departure_time" : "16:20:01" , 
"distance_traveled" : 9.0456
} ], 
"616" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "16:09:00" , 
"departure_time" : "16:10:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "16:12:10" , 
"departure_time" : "16:13:08" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "16:13:58" , 
"departure_time" : "16:14:13" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "16:15:15" , 
"departure_time" : "16:15:25" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "16:17:10" , 
"departure_time" : "16:17:49" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "16:18:39" , 
"departure_time" : "16:19:19" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:21:40" , 
"departure_time" : "16:23:04" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:25:24" , 
"departure_time" : "16:26:53" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:26:29" , 
"departure_time" : "16:27:39" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:28:10" , 
"departure_time" : "16:28:16" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:29:06" , 
"departure_time" : "16:29:59" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:31:53" , 
"departure_time" : "16:32:52" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:33:59" , 
"departure_time" : "16:34:59" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:37:00" , 
"departure_time" : "16:38:04" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "16:41:04" , 
"departure_time" : "16:41:04" , 
"distance_traveled" : 9.0456
} ], 
"617" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "16:29:00" , 
"departure_time" : "16:31:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "16:32:26" , 
"departure_time" : "16:33:55" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "16:34:29" , 
"departure_time" : "16:35:04" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "16:35:35" , 
"departure_time" : "16:36:30" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "16:37:55" , 
"departure_time" : "16:38:47" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "16:38:52" , 
"departure_time" : "16:40:30" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:42:38" , 
"departure_time" : "16:43:02" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:44:24" , 
"departure_time" : "16:46:04" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:46:40" , 
"departure_time" : "16:47:36" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:47:56" , 
"departure_time" : "16:48:04" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:49:08" , 
"departure_time" : "16:50:37" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:52:29" , 
"departure_time" : "16:53:08" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:53:39" , 
"departure_time" : "16:54:38" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:56:59" , 
"departure_time" : "16:58:00" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "17:01:01" , 
"departure_time" : "17:01:01" , 
"distance_traveled" : 9.0456
} ], 
"618" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "16:49:00" , 
"departure_time" : "16:51:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "16:51:59" , 
"departure_time" : "16:52:08" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "16:53:09" , 
"departure_time" : "16:53:56" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "16:55:47" , 
"departure_time" : "16:56:30" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "16:57:43" , 
"departure_time" : "16:58:27" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "16:58:44" , 
"departure_time" : "17:00:02" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:02:18" , 
"departure_time" : "17:02:56" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:04:38" , 
"departure_time" : "17:05:57" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:06:19" , 
"departure_time" : "17:07:54" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:08:35" , 
"departure_time" : "17:09:21" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:09:46" , 
"departure_time" : "17:10:44" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:11:58" , 
"departure_time" : "17:13:37" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:14:39" , 
"departure_time" : "17:16:07" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:17:28" , 
"departure_time" : "17:18:56" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "17:21:28" , 
"departure_time" : "17:21:28" , 
"distance_traveled" : 9.0456
} ], 
"619" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "17:09:00" , 
"departure_time" : "17:10:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "17:11:10" , 
"departure_time" : "17:12:30" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "17:14:20" , 
"departure_time" : "17:14:31" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "17:15:11" , 
"departure_time" : "17:16:17" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "17:18:06" , 
"departure_time" : "17:19:14" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "17:19:08" , 
"departure_time" : "17:19:59" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:21:51" , 
"departure_time" : "17:23:16" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:25:25" , 
"departure_time" : "17:27:01" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:26:36" , 
"departure_time" : "17:27:24" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:27:48" , 
"departure_time" : "17:28:20" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:29:32" , 
"departure_time" : "17:29:44" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:31:12" , 
"departure_time" : "17:32:49" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:34:37" , 
"departure_time" : "17:35:48" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:37:11" , 
"departure_time" : "17:38:21" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "17:41:10" , 
"departure_time" : "17:41:10" , 
"distance_traveled" : 9.0456
} ], 
"620" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "17:29:00" , 
"departure_time" : "17:31:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "17:31:55" , 
"departure_time" : "17:32:59" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "17:34:04" , 
"departure_time" : "17:35:40" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "17:36:36" , 
"departure_time" : "17:38:10" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "17:38:34" , 
"departure_time" : "17:39:05" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "17:38:31" , 
"departure_time" : "17:38:34" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:41:03" , 
"departure_time" : "17:42:30" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:45:27" , 
"departure_time" : "17:45:55" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:45:28" , 
"departure_time" : "17:45:47" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:47:19" , 
"departure_time" : "17:48:38" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:50:19" , 
"departure_time" : "17:50:52" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:51:33" , 
"departure_time" : "17:52:46" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:54:13" , 
"departure_time" : "17:54:29" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:56:16" , 
"departure_time" : "17:57:36" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "18:01:20" , 
"departure_time" : "18:01:20" , 
"distance_traveled" : 9.0456
} ], 
"621" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "17:49:00" , 
"departure_time" : "17:50:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "17:51:06" , 
"departure_time" : "17:51:11" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "17:53:05" , 
"departure_time" : "17:54:24" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "17:56:19" , 
"departure_time" : "17:56:30" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "17:57:11" , 
"departure_time" : "17:58:21" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "17:59:10" , 
"departure_time" : "17:59:50" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:01:40" , 
"departure_time" : "18:02:02" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:04:22" , 
"departure_time" : "18:05:42" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:06:20" , 
"departure_time" : "18:07:18" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:07:58" , 
"departure_time" : "18:08:40" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:09:42" , 
"departure_time" : "18:10:21" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:11:39" , 
"departure_time" : "18:12:56" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:14:17" , 
"departure_time" : "18:14:27" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:16:10" , 
"departure_time" : "18:17:33" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "18:21:23" , 
"departure_time" : "18:21:23" , 
"distance_traveled" : 9.0456
} ], 
"622" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "18:09:00" , 
"departure_time" : "18:10:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "18:11:29" , 
"departure_time" : "18:12:30" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "18:14:01" , 
"departure_time" : "18:15:31" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "18:16:30" , 
"departure_time" : "18:17:14" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "18:17:44" , 
"departure_time" : "18:18:47" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "18:19:03" , 
"departure_time" : "18:19:52" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:21:49" , 
"departure_time" : "18:23:00" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:25:11" , 
"departure_time" : "18:26:06" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:25:55" , 
"departure_time" : "18:27:04" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:28:09" , 
"departure_time" : "18:28:30" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:29:21" , 
"departure_time" : "18:30:34" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:32:13" , 
"departure_time" : "18:32:35" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:33:22" , 
"departure_time" : "18:33:50" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:36:28" , 
"departure_time" : "18:37:27" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "18:40:59" , 
"departure_time" : "18:40:59" , 
"distance_traveled" : 9.0456
} ], 
"623" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "18:29:00" , 
"departure_time" : "18:31:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "18:32:19" , 
"departure_time" : "18:33:43" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "18:34:24" , 
"departure_time" : "18:34:43" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "18:35:19" , 
"departure_time" : "18:35:40" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "18:37:21" , 
"departure_time" : "18:37:54" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "18:38:33" , 
"departure_time" : "18:39:07" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:41:34" , 
"departure_time" : "18:42:42" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:45:08" , 
"departure_time" : "18:46:44" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:46:36" , 
"departure_time" : "18:47:24" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:47:48" , 
"departure_time" : "18:48:08" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:49:20" , 
"departure_time" : "18:50:17" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:51:57" , 
"departure_time" : "18:53:01" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:54:04" , 
"departure_time" : "18:54:16" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:56:12" , 
"departure_time" : "18:57:11" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "19:00:59" , 
"departure_time" : "19:00:59" , 
"distance_traveled" : 9.0456
} ], 
"624" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "18:49:00" , 
"departure_time" : "18:50:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "18:51:20" , 
"departure_time" : "18:52:53" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "18:54:33" , 
"departure_time" : "18:55:48" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "18:56:15" , 
"departure_time" : "18:56:50" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "18:57:35" , 
"departure_time" : "18:59:15" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "18:59:40" , 
"departure_time" : "19:00:48" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:02:08" , 
"departure_time" : "19:03:35" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:05:27" , 
"departure_time" : "19:05:41" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:05:14" , 
"departure_time" : "19:05:28" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:07:14" , 
"departure_time" : "19:08:36" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:10:22" , 
"departure_time" : "19:11:03" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:11:41" , 
"departure_time" : "19:12:15" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:13:34" , 
"departure_time" : "19:15:07" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:17:33" , 
"departure_time" : "19:18:58" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "19:21:25" , 
"departure_time" : "19:21:25" , 
"distance_traveled" : 9.0456
} ], 
"625" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "19:09:00" , 
"departure_time" : "19:11:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "19:12:14" , 
"departure_time" : "19:12:47" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "19:13:33" , 
"departure_time" : "19:13:37" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "19:15:04" , 
"departure_time" : "19:16:12" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "19:18:08" , 
"departure_time" : "19:18:43" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "19:18:35" , 
"departure_time" : "19:19:57" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:22:22" , 
"departure_time" : "19:22:55" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:24:33" , 
"departure_time" : "19:24:58" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:25:25" , 
"departure_time" : "19:25:32" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:27:07" , 
"departure_time" : "19:27:20" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:29:13" , 
"departure_time" : "19:30:42" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:32:29" , 
"departure_time" : "19:33:02" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:33:33" , 
"departure_time" : "19:34:00" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:36:27" , 
"departure_time" : "19:37:37" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "19:41:10" , 
"departure_time" : "19:41:10" , 
"distance_traveled" : 9.0456
} ], 
"626" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "19:29:00" , 
"departure_time" : "19:31:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "19:31:59" , 
"departure_time" : "19:32:00" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "19:33:01" , 
"departure_time" : "19:34:37" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "19:36:36" , 
"departure_time" : "19:37:03" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "19:37:27" , 
"departure_time" : "19:38:23" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "19:38:56" , 
"departure_time" : "19:39:59" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:42:03" , 
"departure_time" : "19:42:06" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:44:03" , 
"departure_time" : "19:44:55" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:45:52" , 
"departure_time" : "19:46:49" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:47:57" , 
"departure_time" : "19:49:02" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:50:05" , 
"departure_time" : "19:50:47" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:51:42" , 
"departure_time" : "19:52:21" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:53:39" , 
"departure_time" : "19:54:53" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:57:14" , 
"departure_time" : "19:57:31" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "20:00:17" , 
"departure_time" : "20:00:17" , 
"distance_traveled" : 9.0456
} ], 
"627" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "19:49:00" , 
"departure_time" : "19:50:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "19:52:39" , 
"departure_time" : "19:52:55" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "19:53:16" , 
"departure_time" : "19:53:49" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "19:55:33" , 
"departure_time" : "19:56:26" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "19:57:53" , 
"departure_time" : "19:58:42" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "19:58:49" , 
"departure_time" : "20:00:20" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:02:31" , 
"departure_time" : "20:03:12" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:04:41" , 
"departure_time" : "20:05:17" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:05:36" , 
"departure_time" : "20:06:14" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:07:38" , 
"departure_time" : "20:09:02" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:10:24" , 
"departure_time" : "20:11:04" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:11:40" , 
"departure_time" : "20:12:35" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:13:55" , 
"departure_time" : "20:14:20" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:16:25" , 
"departure_time" : "20:17:52" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "20:21:27" , 
"departure_time" : "20:21:27" , 
"distance_traveled" : 9.0456
} ], 
"628" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "20:09:00" , 
"departure_time" : "20:11:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "20:12:09" , 
"departure_time" : "20:12:20" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "20:13:11" , 
"departure_time" : "20:13:19" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "20:15:08" , 
"departure_time" : "20:16:46" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "20:18:38" , 
"departure_time" : "20:20:14" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "20:19:36" , 
"departure_time" : "20:20:52" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:22:16" , 
"departure_time" : "20:23:12" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:24:56" , 
"departure_time" : "20:24:57" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:25:01" , 
"departure_time" : "20:25:20" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:27:19" , 
"departure_time" : "20:27:33" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:29:14" , 
"departure_time" : "20:29:28" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:31:14" , 
"departure_time" : "20:32:44" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:34:30" , 
"departure_time" : "20:35:17" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:36:47" , 
"departure_time" : "20:37:04" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "20:40:17" , 
"departure_time" : "20:40:17" , 
"distance_traveled" : 9.0456
} ], 
"629" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "20:29:00" , 
"departure_time" : "20:29:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "20:31:34" , 
"departure_time" : "20:32:23" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "20:33:49" , 
"departure_time" : "20:34:35" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "20:35:46" , 
"departure_time" : "20:37:24" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "20:38:38" , 
"departure_time" : "20:39:27" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "20:38:49" , 
"departure_time" : "20:39:42" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:41:53" , 
"departure_time" : "20:43:08" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:45:15" , 
"departure_time" : "20:46:51" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:46:36" , 
"departure_time" : "20:46:38" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:47:02" , 
"departure_time" : "20:48:40" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:50:38" , 
"departure_time" : "20:50:39" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:51:01" , 
"departure_time" : "20:51:39" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:53:38" , 
"departure_time" : "20:54:59" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:57:21" , 
"departure_time" : "20:58:53" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "21:01:32" , 
"departure_time" : "21:01:32" , 
"distance_traveled" : 9.0456
} ], 
"630" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "20:49:00" , 
"departure_time" : "20:50:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "20:51:16" , 
"departure_time" : "20:52:24" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "20:54:08" , 
"departure_time" : "20:55:17" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "20:56:09" , 
"departure_time" : "20:57:24" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "20:58:15" , 
"departure_time" : "20:59:27" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "20:59:12" , 
"departure_time" : "21:00:34" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:02:22" , 
"departure_time" : "21:03:32" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "21:05:10" , 
"departure_time" : "21:06:06" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "21:05:56" , 
"departure_time" : "21:06:56" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:08:00" , 
"departure_time" : "21:09:06" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "21:10:06" , 
"departure_time" : "21:10:08" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:11:02" , 
"departure_time" : "21:11:41" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:13:39" , 
"departure_time" : "21:13:44" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:16:05" , 
"departure_time" : "21:17:19" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "21:21:14" , 
"departure_time" : "21:21:14" , 
"distance_traveled" : 9.0456
} ], 
"631" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "21:09:00" , 
"departure_time" : "21:10:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "21:11:08" , 
"departure_time" : "21:11:19" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "21:13:11" , 
"departure_time" : "21:13:56" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "21:15:45" , 
"departure_time" : "21:17:20" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "21:18:35" , 
"departure_time" : "21:19:44" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "21:19:09" , 
"departure_time" : "21:20:43" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:22:34" , 
"departure_time" : "21:23:59" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "21:25:25" , 
"departure_time" : "21:25:53" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "21:25:28" , 
"departure_time" : "21:25:55" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:27:27" , 
"departure_time" : "21:27:55" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "21:29:28" , 
"departure_time" : "21:31:01" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:32:33" , 
"departure_time" : "21:33:58" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:34:25" , 
"departure_time" : "21:35:13" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:36:48" , 
"departure_time" : "21:37:01" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "21:40:13" , 
"departure_time" : "21:40:13" , 
"distance_traveled" : 9.0456
} ], 
"632" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "21:29:00" , 
"departure_time" : "21:29:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "21:31:23" , 
"departure_time" : "21:32:08" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "21:33:45" , 
"departure_time" : "21:34:43" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "21:35:58" , 
"departure_time" : "21:37:01" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "21:38:03" , 
"departure_time" : "21:39:26" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "21:39:23" , 
"departure_time" : "21:40:38" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:42:15" , 
"departure_time" : "21:43:23" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "21:45:08" , 
"departure_time" : "21:45:55" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "21:45:47" , 
"departure_time" : "21:47:04" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:48:17" , 
"departure_time" : "21:49:50" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "21:50:33" , 
"departure_time" : "21:51:33" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:52:00" , 
"departure_time" : "21:52:02" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:53:02" , 
"departure_time" : "21:53:06" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:56:04" , 
"departure_time" : "21:57:27" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "22:01:23" , 
"departure_time" : "22:01:23" , 
"distance_traveled" : 9.0456
} ], 
"633" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "21:49:00" , 
"departure_time" : "21:51:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "21:52:03" , 
"departure_time" : "21:52:20" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "21:53:17" , 
"departure_time" : "21:54:48" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "21:56:31" , 
"departure_time" : "21:57:31" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "21:58:00" , 
"departure_time" : "21:58:41" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "21:58:41" , 
"departure_time" : "21:59:06" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:01:25" , 
"departure_time" : "22:03:02" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:05:37" , 
"departure_time" : "22:07:17" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:06:40" , 
"departure_time" : "22:06:47" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:07:07" , 
"departure_time" : "22:08:47" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:10:40" , 
"departure_time" : "22:11:40" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:12:00" , 
"departure_time" : "22:13:31" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:14:31" , 
"departure_time" : "22:14:59" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:16:28" , 
"departure_time" : "22:17:47" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "22:21:19" , 
"departure_time" : "22:21:19" , 
"distance_traveled" : 9.0456
} ], 
"634" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "22:09:00" , 
"departure_time" : "22:10:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "22:11:18" , 
"departure_time" : "22:12:27" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "22:14:09" , 
"departure_time" : "22:15:09" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "22:16:00" , 
"departure_time" : "22:16:22" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "22:17:22" , 
"departure_time" : "22:17:38" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "22:18:16" , 
"departure_time" : "22:19:35" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:22:19" , 
"departure_time" : "22:22:47" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:24:28" , 
"departure_time" : "22:25:19" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:25:51" , 
"departure_time" : "22:26:16" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:27:25" , 
"departure_time" : "22:27:57" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:29:32" , 
"departure_time" : "22:30:34" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:32:02" , 
"departure_time" : "22:33:32" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:34:30" , 
"departure_time" : "22:36:10" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:37:40" , 
"departure_time" : "22:38:57" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "22:41:17" , 
"departure_time" : "22:41:17" , 
"distance_traveled" : 9.0456
} ], 
"635" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "22:29:00" , 
"departure_time" : "22:31:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "22:32:37" , 
"departure_time" : "22:33:56" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "22:34:19" , 
"departure_time" : "22:35:51" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "22:36:32" , 
"departure_time" : "22:37:04" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "22:37:32" , 
"departure_time" : "22:38:03" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "22:38:31" , 
"departure_time" : "22:39:03" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:41:32" , 
"departure_time" : "22:41:47" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:44:15" , 
"departure_time" : "22:45:41" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:46:26" , 
"departure_time" : "22:47:58" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:48:32" , 
"departure_time" : "22:49:34" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:50:02" , 
"departure_time" : "22:50:35" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:51:33" , 
"departure_time" : "22:52:15" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:53:42" , 
"departure_time" : "22:54:46" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:57:04" , 
"departure_time" : "22:57:17" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "23:00:13" , 
"departure_time" : "23:00:13" , 
"distance_traveled" : 9.0456
} ], 
"636" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "22:49:00" , 
"departure_time" : "22:49:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "22:51:40" , 
"departure_time" : "22:53:20" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "22:54:40" , 
"departure_time" : "22:55:53" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "22:56:13" , 
"departure_time" : "22:56:35" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "22:57:22" , 
"departure_time" : "22:58:05" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "22:58:43" , 
"departure_time" : "23:00:21" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:02:38" , 
"departure_time" : "23:03:54" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:05:16" , 
"departure_time" : "23:05:17" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "23:05:01" , 
"departure_time" : "23:06:24" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:08:23" , 
"departure_time" : "23:09:03" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:09:40" , 
"departure_time" : "23:10:06" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:11:26" , 
"departure_time" : "23:12:07" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:13:41" , 
"departure_time" : "23:14:43" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:17:02" , 
"departure_time" : "23:18:04" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "23:21:02" , 
"departure_time" : "23:21:02" , 
"distance_traveled" : 9.0456
} ], 
"637" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "23:09:00" , 
"departure_time" : "23:11:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "23:12:12" , 
"departure_time" : "23:12:30" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "23:13:18" , 
"departure_time" : "23:14:08" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "23:15:50" , 
"departure_time" : "23:16:27" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "23:17:37" , 
"departure_time" : "23:18:31" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "23:18:54" , 
"departure_time" : "23:19:07" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:21:13" , 
"departure_time" : "23:22:19" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:25:06" , 
"departure_time" : "23:25:29" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "23:25:23" , 
"departure_time" : "23:26:16" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:27:53" , 
"departure_time" : "23:28:43" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:29:50" , 
"departure_time" : "23:30:29" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:31:39" , 
"departure_time" : "23:32:42" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:34:03" , 
"departure_time" : "23:35:16" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:37:13" , 
"departure_time" : "23:38:09" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "23:40:56" , 
"departure_time" : "23:40:56" , 
"distance_traveled" : 9.0456
} ], 
"638" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "23:29:00" , 
"departure_time" : "23:30:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "23:31:32" , 
"departure_time" : "23:32:27" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "23:33:55" , 
"departure_time" : "23:35:32" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "23:36:37" , 
"departure_time" : "23:37:34" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "23:37:57" , 
"departure_time" : "23:38:40" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "23:38:43" , 
"departure_time" : "23:39:15" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:41:32" , 
"departure_time" : "23:42:06" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:44:34" , 
"departure_time" : "23:46:03" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "23:46:29" , 
"departure_time" : "23:47:34" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:48:05" , 
"departure_time" : "23:49:12" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:50:07" , 
"departure_time" : "23:50:43" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:51:36" , 
"departure_time" : "23:52:17" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:53:41" , 
"departure_time" : "23:54:44" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:57:03" , 
"departure_time" : "23:57:26" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "24:00:23" , 
"departure_time" : "24:00:23" , 
"distance_traveled" : 9.0456
} ], 
"639" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "23:49:00" , 
"departure_time" : "23:50:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "23:51:41" , 
"departure_time" : "23:51:49" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "23:53:08" , 
"departure_time" : "23:54:23" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "23:56:15" , 
"departure_time" : "23:57:50" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "23:58:35" , 
"departure_time" : "23:59:43" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "23:59:08" , 
"departure_time" : "23:59:52" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "24:01:44" , 
"departure_time" : "24:02:06" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "24:04:22" , 
"departure_time" : "24:05:23" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "24:06:01" , 
"departure_time" : "24:07:19" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "24:08:18" , 
"departure_time" : "24:08:24" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "24:09:06" , 
"departure_time" : "24:09:14" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "24:11:08" , 
"departure_time" : "24:11:51" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "24:13:43" , 
"departure_time" : "24:14:51" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "24:17:08" , 
"departure_time" : "24:18:47" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "24:21:39" , 
"departure_time" : "24:21:39" , 
"distance_traveled" : 9.0456
} ], 
"640" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "24:20:00" , 
"departure_time" : "24:21:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "24:22:01" , 
"departure_time" : "24:23:24" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "24:25:23" , 
"departure_time" : "24:27:03" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "24:27:40" , 
"departure_time" : "24:28:32" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "24:28:52" , 
"departure_time" : "24:29:08" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "24:29:16" , 
"departure_time" : "24:30:13" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "24:32:57" , 
"departure_time" : "24:34:16" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "24:36:19" , 
"departure_time" : "24:37:31" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "24:37:12" , 
"departure_time" : "24:38:29" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "24:39:17" , 
"departure_time" : "24:40:53" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "24:41:36" , 
"departure_time" : "24:42:07" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "24:42:31" , 
"departure_time" : "24:42:51" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "24:44:20" , 
"departure_time" : "24:44:24" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "24:47:04" , 
"departure_time" : "24:48:41" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "24:52:37" , 
"departure_time" : "24:52:37" , 
"distance_traveled" : 9.0456
} ], 
"641" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "24:54:00" , 
"departure_time" : "24:56:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "24:56:34" , 
"departure_time" : "24:57:18" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "24:58:44" , 
"departure_time" : "24:59:44" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "25:01:00" , 
"departure_time" : "25:01:17" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "25:02:17" , 
"departure_time" : "25:03:37" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "25:04:20" , 
"departure_time" : "25:05:18" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "25:06:58" , 
"departure_time" : "25:08:06" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "25:10:08" , 
"departure_time" : "25:10:17" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "25:10:09" , 
"departure_time" : "25:11:01" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "25:12:52" , 
"departure_time" : "25:14:13" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "25:15:21" , 
"departure_time" : "25:17:00" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "25:17:39" , 
"departure_time" : "25:18:36" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "25:18:57" , 
"departure_time" : "25:20:19" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "25:22:22" , 
"departure_time" : "25:23:44" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "25:26:22" , 
"departure_time" : "25:26:22" , 
"distance_traveled" : 9.0456
} ], 
"642" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "25:24:00" , 
"departure_time" : "25:26:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "25:26:38" , 
"departure_time" : "25:27:13" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "25:28:35" , 
"departure_time" : "25:28:45" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "25:30:10" , 
"departure_time" : "25:31:07" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "25:32:57" , 
"departure_time" : "25:33:38" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "25:33:41" , 
"departure_time" : "25:35:07" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "25:37:26" , 
"departure_time" : "25:38:20" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "25:39:54" , 
"departure_time" : "25:41:27" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "25:41:33" , 
"departure_time" : "25:42:29" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "25:42:56" , 
"departure_time" : "25:43:03" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "25:44:07" , 
"departure_time" : "25:45:30" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "25:47:23" , 
"departure_time" : "25:48:13" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "25:48:50" , 
"departure_time" : "25:49:44" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "25:51:54" , 
"departure_time" : "25:52:44" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "25:55:50" , 
"departure_time" : "25:55:50" , 
"distance_traveled" : 9.0456
} ], 
"643" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "05:48:00" , 
"departure_time" : "05:49:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "05:50:21" , 
"departure_time" : "05:51:15" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "05:52:54" , 
"departure_time" : "05:53:24" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "05:55:30" , 
"departure_time" : "05:57:00" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "05:59:30" , 
"departure_time" : "06:00:02" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "05:59:32" , 
"departure_time" : "06:00:23" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:02:51" , 
"departure_time" : "06:03:12" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:04:21" , 
"departure_time" : "06:05:01" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:06:40" , 
"departure_time" : "06:07:59" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:09:19" , 
"departure_time" : "06:10:40" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:12:21" , 
"departure_time" : "06:12:34" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "06:16:13" , 
"departure_time" : "06:17:09" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "06:18:56" , 
"departure_time" : "06:20:11" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "06:22:15" , 
"departure_time" : "06:22:42" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "06:24:27" , 
"departure_time" : "06:25:21" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "06:26:54" , 
"departure_time" : "06:28:26" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "06:29:32" , 
"departure_time" : "06:29:32" , 
"distance_traveled" : 10.0595
} ], 
"644" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "06:08:00" , 
"departure_time" : "06:09:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "06:10:10" , 
"departure_time" : "06:10:18" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "06:12:08" , 
"departure_time" : "06:12:20" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:15:12" , 
"departure_time" : "06:16:35" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:19:23" , 
"departure_time" : "06:19:56" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:19:33" , 
"departure_time" : "06:20:15" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:22:42" , 
"departure_time" : "06:23:54" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:25:12" , 
"departure_time" : "06:26:10" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:26:58" , 
"departure_time" : "06:28:37" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:29:39" , 
"departure_time" : "06:30:33" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:31:54" , 
"departure_time" : "06:32:02" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "06:36:08" , 
"departure_time" : "06:37:29" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "06:39:21" , 
"departure_time" : "06:39:40" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "06:41:19" , 
"departure_time" : "06:41:21" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "06:44:02" , 
"departure_time" : "06:45:11" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "06:47:09" , 
"departure_time" : "06:47:34" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "06:48:25" , 
"departure_time" : "06:48:25" , 
"distance_traveled" : 10.0595
} ], 
"645" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "06:28:00" , 
"departure_time" : "06:30:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "06:31:35" , 
"departure_time" : "06:33:12" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "06:33:37" , 
"departure_time" : "06:35:14" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:36:37" , 
"departure_time" : "06:37:28" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:38:51" , 
"departure_time" : "06:40:29" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:40:38" , 
"departure_time" : "06:41:36" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:42:58" , 
"departure_time" : "06:43:50" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:44:52" , 
"departure_time" : "06:46:12" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:47:20" , 
"departure_time" : "06:48:50" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:49:30" , 
"departure_time" : "06:49:54" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:51:24" , 
"departure_time" : "06:51:32" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "06:56:08" , 
"departure_time" : "06:56:14" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "06:58:06" , 
"departure_time" : "06:59:31" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "07:02:25" , 
"departure_time" : "07:03:47" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "07:05:22" , 
"departure_time" : "07:05:41" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:06:19" , 
"departure_time" : "07:07:02" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "07:08:43" , 
"departure_time" : "07:08:43" , 
"distance_traveled" : 10.0595
} ], 
"646" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "06:48:00" , 
"departure_time" : "06:49:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "06:51:08" , 
"departure_time" : "06:52:44" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "06:53:36" , 
"departure_time" : "06:54:05" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:55:29" , 
"departure_time" : "06:56:49" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:59:20" , 
"departure_time" : "07:00:43" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:00:23" , 
"departure_time" : "07:00:30" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:02:07" , 
"departure_time" : "07:02:21" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:04:14" , 
"departure_time" : "07:04:46" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:06:32" , 
"departure_time" : "07:07:12" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:08:40" , 
"departure_time" : "07:08:57" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:11:17" , 
"departure_time" : "07:12:03" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:16:46" , 
"departure_time" : "07:17:09" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "07:18:23" , 
"departure_time" : "07:19:17" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "07:21:54" , 
"departure_time" : "07:23:03" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "07:25:09" , 
"departure_time" : "07:26:31" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:27:22" , 
"departure_time" : "07:28:12" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "07:28:50" , 
"departure_time" : "07:28:50" , 
"distance_traveled" : 10.0595
} ], 
"647" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "07:08:00" , 
"departure_time" : "07:10:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "07:11:29" , 
"departure_time" : "07:12:13" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "07:12:44" , 
"departure_time" : "07:14:14" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:16:30" , 
"departure_time" : "07:17:14" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:18:44" , 
"departure_time" : "07:18:46" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:19:02" , 
"departure_time" : "07:20:09" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:23:07" , 
"departure_time" : "07:24:01" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:24:54" , 
"departure_time" : "07:25:24" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:26:30" , 
"departure_time" : "07:27:35" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:29:05" , 
"departure_time" : "07:30:40" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:32:35" , 
"departure_time" : "07:33:54" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:37:19" , 
"departure_time" : "07:38:37" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "07:39:18" , 
"departure_time" : "07:39:53" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "07:41:35" , 
"departure_time" : "07:41:50" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "07:44:15" , 
"departure_time" : "07:45:41" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:47:26" , 
"departure_time" : "07:48:38" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "07:49:12" , 
"departure_time" : "07:49:12" , 
"distance_traveled" : 10.0595
} ], 
"648" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "07:28:00" , 
"departure_time" : "07:30:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "07:31:05" , 
"departure_time" : "07:32:23" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "07:33:18" , 
"departure_time" : "07:34:47" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:36:29" , 
"departure_time" : "07:37:32" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:39:03" , 
"departure_time" : "07:39:07" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:39:04" , 
"departure_time" : "07:39:06" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:42:02" , 
"departure_time" : "07:42:35" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:44:33" , 
"departure_time" : "07:45:06" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:46:33" , 
"departure_time" : "07:46:44" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:48:11" , 
"departure_time" : "07:48:36" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:51:25" , 
"departure_time" : "07:52:21" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:56:56" , 
"departure_time" : "07:58:31" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "07:59:35" , 
"departure_time" : "08:00:59" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:02:24" , 
"departure_time" : "08:02:46" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:04:22" , 
"departure_time" : "08:05:22" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:07:00" , 
"departure_time" : "08:08:09" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "08:09:09" , 
"departure_time" : "08:09:09" , 
"distance_traveled" : 10.0595
} ], 
"649" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "07:48:00" , 
"departure_time" : "07:49:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "07:50:24" , 
"departure_time" : "07:50:40" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "07:52:16" , 
"departure_time" : "07:53:01" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:55:45" , 
"departure_time" : "07:55:55" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:58:10" , 
"departure_time" : "07:58:23" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:59:13" , 
"departure_time" : "08:00:12" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:02:59" , 
"departure_time" : "08:03:13" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:04:14" , 
"departure_time" : "08:04:54" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:06:40" , 
"departure_time" : "08:07:34" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:08:54" , 
"departure_time" : "08:09:03" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:11:09" , 
"departure_time" : "08:12:45" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:17:36" , 
"departure_time" : "08:19:05" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:19:29" , 
"departure_time" : "08:19:54" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:21:25" , 
"departure_time" : "08:21:39" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:24:14" , 
"departure_time" : "08:25:24" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:27:10" , 
"departure_time" : "08:27:59" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "08:28:49" , 
"departure_time" : "08:28:49" , 
"distance_traveled" : 10.0595
} ], 
"650" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "08:08:00" , 
"departure_time" : "08:10:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "08:11:21" , 
"departure_time" : "08:12:51" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "08:13:30" , 
"departure_time" : "08:14:10" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:15:40" , 
"departure_time" : "08:16:38" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:18:58" , 
"departure_time" : "08:19:38" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:19:40" , 
"departure_time" : "08:20:02" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:22:22" , 
"departure_time" : "08:24:02" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:25:40" , 
"departure_time" : "08:26:25" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:26:45" , 
"departure_time" : "08:28:15" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:29:30" , 
"departure_time" : "08:30:59" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:32:29" , 
"departure_time" : "08:32:42" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:36:13" , 
"departure_time" : "08:36:48" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:38:35" , 
"departure_time" : "08:39:40" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:42:05" , 
"departure_time" : "08:43:24" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:45:19" , 
"departure_time" : "08:46:40" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:47:21" , 
"departure_time" : "08:48:38" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "08:49:17" , 
"departure_time" : "08:49:17" , 
"distance_traveled" : 10.0595
} ], 
"651" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "08:28:00" , 
"departure_time" : "08:29:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "08:30:35" , 
"departure_time" : "08:30:57" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "08:32:22" , 
"departure_time" : "08:32:35" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:35:13" , 
"departure_time" : "08:36:26" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:39:13" , 
"departure_time" : "08:40:53" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:40:40" , 
"departure_time" : "08:40:45" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:42:05" , 
"departure_time" : "08:42:54" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:44:49" , 
"departure_time" : "08:46:14" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:47:25" , 
"departure_time" : "08:48:46" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:49:21" , 
"departure_time" : "08:49:32" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:51:11" , 
"departure_time" : "08:51:26" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:56:15" , 
"departure_time" : "08:56:58" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:58:43" , 
"departure_time" : "08:59:52" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "09:02:09" , 
"departure_time" : "09:03:01" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "09:04:52" , 
"departure_time" : "09:06:15" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "09:07:23" , 
"departure_time" : "09:07:34" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "09:08:11" , 
"departure_time" : "09:08:11" , 
"distance_traveled" : 10.0595
} ], 
"652" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "08:48:00" , 
"departure_time" : "08:49:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "08:51:15" , 
"departure_time" : "08:52:52" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "08:53:37" , 
"departure_time" : "08:54:37" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:56:00" , 
"departure_time" : "08:56:09" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:58:09" , 
"departure_time" : "08:58:26" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:59:17" , 
"departure_time" : "08:59:27" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:02:10" , 
"departure_time" : "09:03:21" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:05:11" , 
"departure_time" : "09:06:44" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:07:33" , 
"departure_time" : "09:08:16" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:08:43" , 
"departure_time" : "09:09:07" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:11:24" , 
"departure_time" : "09:12:47" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "09:17:23" , 
"departure_time" : "09:18:31" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:19:08" , 
"departure_time" : "09:20:41" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "09:22:33" , 
"departure_time" : "09:22:57" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "09:24:24" , 
"departure_time" : "09:25:32" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "09:27:08" , 
"departure_time" : "09:28:36" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "09:29:28" , 
"departure_time" : "09:29:28" , 
"distance_traveled" : 10.0595
} ], 
"653" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "09:08:00" , 
"departure_time" : "09:10:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "09:10:46" , 
"departure_time" : "09:10:59" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "09:12:13" , 
"departure_time" : "09:12:28" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:15:15" , 
"departure_time" : "09:15:54" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:18:39" , 
"departure_time" : "09:18:49" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:19:10" , 
"departure_time" : "09:20:06" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:22:56" , 
"departure_time" : "09:24:11" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:25:15" , 
"departure_time" : "09:25:22" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:26:07" , 
"departure_time" : "09:27:33" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:29:26" , 
"departure_time" : "09:30:15" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:31:49" , 
"departure_time" : "09:33:06" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "09:37:17" , 
"departure_time" : "09:37:19" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:38:02" , 
"departure_time" : "09:38:52" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "09:41:50" , 
"departure_time" : "09:43:24" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "09:45:34" , 
"departure_time" : "09:45:35" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "09:46:01" , 
"departure_time" : "09:46:51" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "09:48:50" , 
"departure_time" : "09:48:50" , 
"distance_traveled" : 10.0595
} ], 
"654" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "09:28:00" , 
"departure_time" : "09:29:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "09:30:56" , 
"departure_time" : "09:32:15" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "09:33:19" , 
"departure_time" : "09:34:46" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:36:27" , 
"departure_time" : "09:37:58" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:39:31" , 
"departure_time" : "09:39:57" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:39:26" , 
"departure_time" : "09:40:47" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:43:21" , 
"departure_time" : "09:44:21" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:45:00" , 
"departure_time" : "09:45:44" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:46:44" , 
"departure_time" : "09:46:52" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:48:08" , 
"departure_time" : "09:49:40" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:52:32" , 
"departure_time" : "09:52:51" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "09:56:19" , 
"departure_time" : "09:57:14" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:58:55" , 
"departure_time" : "10:00:19" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "10:02:24" , 
"departure_time" : "10:03:52" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "10:05:28" , 
"departure_time" : "10:06:07" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "10:06:39" , 
"departure_time" : "10:07:26" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "10:08:47" , 
"departure_time" : "10:08:47" , 
"distance_traveled" : 10.0595
} ], 
"655" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "09:48:00" , 
"departure_time" : "09:49:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "09:50:43" , 
"departure_time" : "09:51:25" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "09:52:42" , 
"departure_time" : "09:53:53" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:56:11" , 
"departure_time" : "09:57:49" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:59:38" , 
"departure_time" : "10:01:18" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:00:40" , 
"departure_time" : "10:01:08" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:02:28" , 
"departure_time" : "10:02:51" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:04:23" , 
"departure_time" : "10:04:25" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:06:02" , 
"departure_time" : "10:07:39" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:09:37" , 
"departure_time" : "10:10:19" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:11:42" , 
"departure_time" : "10:12:51" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "10:17:09" , 
"departure_time" : "10:18:17" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "10:19:08" , 
"departure_time" : "10:20:04" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "10:21:56" , 
"departure_time" : "10:23:36" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "10:25:40" , 
"departure_time" : "10:27:10" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "10:27:30" , 
"departure_time" : "10:28:19" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "10:28:49" , 
"departure_time" : "10:28:49" , 
"distance_traveled" : 10.0595
} ], 
"656" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "10:08:00" , 
"departure_time" : "10:09:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "10:10:49" , 
"departure_time" : "10:11:20" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "10:12:31" , 
"departure_time" : "10:13:01" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:15:30" , 
"departure_time" : "10:17:00" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:19:30" , 
"departure_time" : "10:20:37" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:20:07" , 
"departure_time" : "10:20:52" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:22:45" , 
"departure_time" : "10:23:00" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:24:15" , 
"departure_time" : "10:25:17" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:27:02" , 
"departure_time" : "10:27:29" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:28:27" , 
"departure_time" : "10:30:04" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:32:37" , 
"departure_time" : "10:32:39" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "10:36:02" , 
"departure_time" : "10:36:16" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "10:38:14" , 
"departure_time" : "10:38:50" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "10:41:36" , 
"departure_time" : "10:41:42" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "10:44:06" , 
"departure_time" : "10:45:20" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "10:47:14" , 
"departure_time" : "10:48:21" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "10:49:07" , 
"departure_time" : "10:49:07" , 
"distance_traveled" : 10.0595
} ], 
"657" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "10:28:00" , 
"departure_time" : "10:29:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "10:30:30" , 
"departure_time" : "10:31:43" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "10:33:13" , 
"departure_time" : "10:33:21" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:35:08" , 
"departure_time" : "10:35:17" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:38:09" , 
"departure_time" : "10:38:42" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:39:33" , 
"departure_time" : "10:40:26" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:42:53" , 
"departure_time" : "10:43:13" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:44:20" , 
"departure_time" : "10:44:26" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:46:06" , 
"departure_time" : "10:47:26" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:49:20" , 
"departure_time" : "10:50:58" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:52:38" , 
"departure_time" : "10:53:34" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "10:56:56" , 
"departure_time" : "10:57:08" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "10:58:12" , 
"departure_time" : "10:59:30" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "11:02:18" , 
"departure_time" : "11:02:26" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "11:04:08" , 
"departure_time" : "11:04:45" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "11:06:37" , 
"departure_time" : "11:07:15" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "11:08:38" , 
"departure_time" : "11:08:38" , 
"distance_traveled" : 10.0595
} ], 
"658" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "10:48:00" , 
"departure_time" : "10:49:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "10:50:24" , 
"departure_time" : "10:51:44" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "10:53:20" , 
"departure_time" : "10:54:24" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:56:04" , 
"departure_time" : "10:57:13" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:59:09" , 
"departure_time" : "11:00:33" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:00:24" , 
"departure_time" : "11:01:58" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:03:34" , 
"departure_time" : "11:04:01" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:04:27" , 
"departure_time" : "11:05:08" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:06:41" , 
"departure_time" : "11:08:02" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:09:21" , 
"departure_time" : "11:09:53" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:11:32" , 
"departure_time" : "11:11:59" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "11:16:27" , 
"departure_time" : "11:18:04" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "11:19:37" , 
"departure_time" : "11:20:16" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "11:21:39" , 
"departure_time" : "11:22:36" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "11:24:57" , 
"departure_time" : "11:25:54" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "11:26:57" , 
"departure_time" : "11:27:58" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "11:29:01" , 
"departure_time" : "11:29:01" , 
"distance_traveled" : 10.0595
} ], 
"659" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "11:08:00" , 
"departure_time" : "11:10:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "11:11:04" , 
"departure_time" : "11:11:44" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "11:12:40" , 
"departure_time" : "11:13:31" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:15:51" , 
"departure_time" : "11:17:15" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:19:24" , 
"departure_time" : "11:21:00" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:20:36" , 
"departure_time" : "11:20:50" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:22:14" , 
"departure_time" : "11:23:30" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:25:16" , 
"departure_time" : "11:26:23" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:27:07" , 
"departure_time" : "11:28:16" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:29:09" , 
"departure_time" : "11:29:57" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:31:48" , 
"departure_time" : "11:32:46" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "11:36:58" , 
"departure_time" : "11:38:01" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "11:39:03" , 
"departure_time" : "11:40:15" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "11:42:12" , 
"departure_time" : "11:42:37" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "11:44:25" , 
"departure_time" : "11:44:54" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "11:46:29" , 
"departure_time" : "11:47:12" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "11:48:43" , 
"departure_time" : "11:48:43" , 
"distance_traveled" : 10.0595
} ], 
"660" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "11:28:00" , 
"departure_time" : "11:29:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "11:30:50" , 
"departure_time" : "11:32:26" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "11:33:36" , 
"departure_time" : "11:34:18" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:35:42" , 
"departure_time" : "11:35:58" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:38:16" , 
"departure_time" : "11:39:21" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:40:05" , 
"departure_time" : "11:41:13" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:43:08" , 
"departure_time" : "11:43:41" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:44:33" , 
"departure_time" : "11:45:13" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:46:40" , 
"departure_time" : "11:47:21" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:48:41" , 
"departure_time" : "11:49:03" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:51:22" , 
"departure_time" : "11:51:40" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "11:56:18" , 
"departure_time" : "11:56:35" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "11:58:17" , 
"departure_time" : "11:58:38" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "12:01:21" , 
"departure_time" : "12:02:12" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "12:04:51" , 
"departure_time" : "12:05:12" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "12:06:21" , 
"departure_time" : "12:07:50" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "12:09:29" , 
"departure_time" : "12:09:29" , 
"distance_traveled" : 10.0595
} ], 
"661" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "11:48:00" , 
"departure_time" : "11:50:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "11:51:26" , 
"departure_time" : "11:52:57" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "11:53:31" , 
"departure_time" : "11:53:46" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:55:15" , 
"departure_time" : "11:55:37" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:58:22" , 
"departure_time" : "11:59:49" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:00:27" , 
"departure_time" : "12:01:41" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:03:14" , 
"departure_time" : "12:04:13" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:04:59" , 
"departure_time" : "12:05:00" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:06:01" , 
"departure_time" : "12:06:54" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:08:53" , 
"departure_time" : "12:09:48" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:11:55" , 
"departure_time" : "12:13:04" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "12:17:09" , 
"departure_time" : "12:18:00" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "12:18:51" , 
"departure_time" : "12:20:28" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "12:22:37" , 
"departure_time" : "12:24:12" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "12:25:35" , 
"departure_time" : "12:25:47" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "12:26:12" , 
"departure_time" : "12:27:35" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "12:29:23" , 
"departure_time" : "12:29:23" , 
"distance_traveled" : 10.0595
} ], 
"662" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "12:08:00" , 
"departure_time" : "12:10:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "12:10:51" , 
"departure_time" : "12:10:59" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "12:12:08" , 
"departure_time" : "12:12:13" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:15:05" , 
"departure_time" : "12:16:28" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:19:23" , 
"departure_time" : "12:21:00" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:20:37" , 
"departure_time" : "12:21:14" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:22:37" , 
"departure_time" : "12:23:42" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:25:05" , 
"departure_time" : "12:26:29" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:27:24" , 
"departure_time" : "12:28:39" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:29:15" , 
"departure_time" : "12:30:21" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:32:06" , 
"departure_time" : "12:32:20" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "12:36:14" , 
"departure_time" : "12:37:46" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "12:39:32" , 
"departure_time" : "12:40:05" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "12:41:33" , 
"departure_time" : "12:43:02" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "12:45:29" , 
"departure_time" : "12:45:46" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "12:46:17" , 
"departure_time" : "12:47:14" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "12:48:57" , 
"departure_time" : "12:48:57" , 
"distance_traveled" : 10.0595
} ], 
"663" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "12:28:00" , 
"departure_time" : "12:28:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "12:30:02" , 
"departure_time" : "12:31:41" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "12:33:39" , 
"departure_time" : "12:34:01" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:35:22" , 
"departure_time" : "12:36:00" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:38:38" , 
"departure_time" : "12:40:08" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:40:30" , 
"departure_time" : "12:40:41" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:42:11" , 
"departure_time" : "12:43:02" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:44:51" , 
"departure_time" : "12:45:49" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:46:58" , 
"departure_time" : "12:47:17" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:48:19" , 
"departure_time" : "12:49:49" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:52:30" , 
"departure_time" : "12:53:54" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "12:57:24" , 
"departure_time" : "12:58:53" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "12:59:29" , 
"departure_time" : "12:59:45" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "13:01:16" , 
"departure_time" : "13:01:49" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "13:04:33" , 
"departure_time" : "13:05:50" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "13:07:17" , 
"departure_time" : "13:07:22" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "13:08:05" , 
"departure_time" : "13:08:05" , 
"distance_traveled" : 10.0595
} ], 
"664" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "12:48:00" , 
"departure_time" : "12:49:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "12:51:03" , 
"departure_time" : "12:51:22" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "12:52:19" , 
"departure_time" : "12:53:13" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:55:54" , 
"departure_time" : "12:56:20" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:58:26" , 
"departure_time" : "12:58:39" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:59:13" , 
"departure_time" : "12:59:53" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:02:40" , 
"departure_time" : "13:03:31" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:04:51" , 
"departure_time" : "13:05:20" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:06:29" , 
"departure_time" : "13:07:25" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:08:56" , 
"departure_time" : "13:09:58" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:12:02" , 
"departure_time" : "13:13:18" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "13:17:16" , 
"departure_time" : "13:18:32" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "13:19:16" , 
"departure_time" : "13:19:54" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "13:21:38" , 
"departure_time" : "13:23:05" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "13:25:27" , 
"departure_time" : "13:26:51" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "13:27:24" , 
"departure_time" : "13:28:13" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "13:28:49" , 
"departure_time" : "13:28:49" , 
"distance_traveled" : 10.0595
} ], 
"665" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "13:08:00" , 
"departure_time" : "13:09:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "13:10:44" , 
"departure_time" : "13:11:55" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "13:13:11" , 
"departure_time" : "13:14:32" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:16:21" , 
"departure_time" : "13:17:16" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:18:55" , 
"departure_time" : "13:19:41" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:19:46" , 
"departure_time" : "13:20:12" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:22:26" , 
"departure_time" : "13:22:32" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:24:06" , 
"departure_time" : "13:24:09" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:26:03" , 
"departure_time" : "13:27:17" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:29:14" , 
"departure_time" : "13:30:45" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:32:31" , 
"departure_time" : "13:32:59" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "13:36:28" , 
"departure_time" : "13:37:50" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "13:39:22" , 
"departure_time" : "13:39:38" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "13:41:16" , 
"departure_time" : "13:42:14" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "13:44:58" , 
"departure_time" : "13:46:10" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "13:47:12" , 
"departure_time" : "13:47:55" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "13:48:43" , 
"departure_time" : "13:48:43" , 
"distance_traveled" : 10.0595
} ], 
"666" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "13:28:00" , 
"departure_time" : "13:28:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "13:30:06" , 
"departure_time" : "13:30:33" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "13:32:27" , 
"departure_time" : "13:32:42" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:35:15" , 
"departure_time" : "13:36:42" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:39:27" , 
"departure_time" : "13:40:12" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:39:45" , 
"departure_time" : "13:41:03" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:43:18" , 
"departure_time" : "13:43:29" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:44:11" , 
"departure_time" : "13:45:07" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:46:56" , 
"departure_time" : "13:47:41" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:48:45" , 
"departure_time" : "13:49:46" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:52:01" , 
"departure_time" : "13:52:03" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "13:56:02" , 
"departure_time" : "13:56:08" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "13:58:06" , 
"departure_time" : "13:58:50" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "14:01:44" , 
"departure_time" : "14:03:01" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "14:05:17" , 
"departure_time" : "14:06:05" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "14:06:48" , 
"departure_time" : "14:06:55" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "14:08:07" , 
"departure_time" : "14:08:07" , 
"distance_traveled" : 10.0595
} ], 
"667" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "13:48:00" , 
"departure_time" : "13:48:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "13:50:43" , 
"departure_time" : "13:52:18" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "13:53:35" , 
"departure_time" : "13:54:26" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:55:51" , 
"departure_time" : "13:57:11" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:59:20" , 
"departure_time" : "14:00:58" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:00:38" , 
"departure_time" : "14:01:22" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:02:44" , 
"departure_time" : "14:04:20" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:05:36" , 
"departure_time" : "14:06:52" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:07:16" , 
"departure_time" : "14:07:30" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:08:14" , 
"departure_time" : "14:08:32" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:11:18" , 
"departure_time" : "14:12:47" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "14:17:29" , 
"departure_time" : "14:19:03" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "14:19:34" , 
"departure_time" : "14:20:44" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "14:22:10" , 
"departure_time" : "14:22:55" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "14:24:45" , 
"departure_time" : "14:26:24" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "14:27:39" , 
"departure_time" : "14:28:42" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "14:29:03" , 
"departure_time" : "14:29:03" , 
"distance_traveled" : 10.0595
} ], 
"668" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "14:08:00" , 
"departure_time" : "14:10:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "14:11:18" , 
"departure_time" : "14:11:23" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "14:12:05" , 
"departure_time" : "14:12:32" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:15:27" , 
"departure_time" : "14:15:34" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:18:07" , 
"departure_time" : "14:18:10" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:19:03" , 
"departure_time" : "14:19:53" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:22:50" , 
"departure_time" : "14:24:12" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:25:22" , 
"departure_time" : "14:26:37" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:27:15" , 
"departure_time" : "14:28:27" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:29:12" , 
"departure_time" : "14:30:46" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:32:34" , 
"departure_time" : "14:32:55" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "14:36:21" , 
"departure_time" : "14:37:09" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "14:38:48" , 
"departure_time" : "14:39:00" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "14:41:12" , 
"departure_time" : "14:42:47" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "14:45:35" , 
"departure_time" : "14:45:40" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "14:46:05" , 
"departure_time" : "14:46:45" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "14:48:40" , 
"departure_time" : "14:48:40" , 
"distance_traveled" : 10.0595
} ], 
"669" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "14:28:00" , 
"departure_time" : "14:29:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "14:30:38" , 
"departure_time" : "14:30:55" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "14:32:17" , 
"departure_time" : "14:32:58" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:35:41" , 
"departure_time" : "14:36:18" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:38:37" , 
"departure_time" : "14:40:05" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:40:28" , 
"departure_time" : "14:41:20" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:42:52" , 
"departure_time" : "14:44:29" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:45:37" , 
"departure_time" : "14:46:29" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:46:52" , 
"departure_time" : "14:46:56" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:48:04" , 
"departure_time" : "14:49:03" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:51:59" , 
"departure_time" : "14:53:02" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "14:57:03" , 
"departure_time" : "14:57:43" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "14:58:40" , 
"departure_time" : "14:59:37" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "15:01:57" , 
"departure_time" : "15:02:25" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "15:04:28" , 
"departure_time" : "15:04:53" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "15:06:25" , 
"departure_time" : "15:07:28" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "15:09:03" , 
"departure_time" : "15:09:03" , 
"distance_traveled" : 10.0595
} ], 
"670" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "14:48:00" , 
"departure_time" : "14:49:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "14:50:10" , 
"departure_time" : "14:50:40" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "14:52:30" , 
"departure_time" : "14:52:42" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:55:12" , 
"departure_time" : "14:56:31" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:59:19" , 
"departure_time" : "14:59:48" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:59:29" , 
"departure_time" : "14:59:49" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:02:20" , 
"departure_time" : "15:03:26" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:05:06" , 
"departure_time" : "15:06:44" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:07:38" , 
"departure_time" : "15:09:17" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:09:39" , 
"departure_time" : "15:10:48" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:12:09" , 
"departure_time" : "15:12:55" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "15:16:46" , 
"departure_time" : "15:16:58" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "15:18:12" , 
"departure_time" : "15:19:00" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "15:21:48" , 
"departure_time" : "15:23:11" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "15:25:23" , 
"departure_time" : "15:26:25" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "15:27:02" , 
"departure_time" : "15:27:21" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "15:28:19" , 
"departure_time" : "15:28:19" , 
"distance_traveled" : 10.0595
} ], 
"671" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "15:08:00" , 
"departure_time" : "15:08:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "15:10:18" , 
"departure_time" : "15:11:16" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "15:12:58" , 
"departure_time" : "15:13:44" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:15:46" , 
"departure_time" : "15:16:39" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:18:53" , 
"departure_time" : "15:20:17" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:20:24" , 
"departure_time" : "15:21:25" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:23:01" , 
"departure_time" : "15:24:40" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:25:39" , 
"departure_time" : "15:26:02" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:26:23" , 
"departure_time" : "15:26:40" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:28:17" , 
"departure_time" : "15:29:36" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:32:19" , 
"departure_time" : "15:32:53" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "15:36:34" , 
"departure_time" : "15:37:04" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "15:38:30" , 
"departure_time" : "15:38:54" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "15:41:24" , 
"departure_time" : "15:42:21" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "15:44:57" , 
"departure_time" : "15:46:35" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "15:47:38" , 
"departure_time" : "15:48:25" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "15:48:47" , 
"departure_time" : "15:48:47" , 
"distance_traveled" : 10.0595
} ], 
"672" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "15:28:00" , 
"departure_time" : "15:29:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "15:30:33" , 
"departure_time" : "15:32:04" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "15:33:31" , 
"departure_time" : "15:33:38" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:35:07" , 
"departure_time" : "15:35:13" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:38:06" , 
"departure_time" : "15:38:15" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:39:09" , 
"departure_time" : "15:40:24" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:43:15" , 
"departure_time" : "15:44:00" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:44:45" , 
"departure_time" : "15:44:53" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:46:08" , 
"departure_time" : "15:46:11" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:48:03" , 
"departure_time" : "15:48:45" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:51:42" , 
"departure_time" : "15:52:23" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "15:56:41" , 
"departure_time" : "15:57:55" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "15:59:14" , 
"departure_time" : "15:59:39" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:01:25" , 
"departure_time" : "16:02:25" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "16:05:00" , 
"departure_time" : "16:06:11" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:07:11" , 
"departure_time" : "16:07:15" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "16:08:04" , 
"departure_time" : "16:08:04" , 
"distance_traveled" : 10.0595
} ], 
"673" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "15:48:00" , 
"departure_time" : "15:48:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "15:50:47" , 
"departure_time" : "15:51:22" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "15:52:35" , 
"departure_time" : "15:52:40" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:55:05" , 
"departure_time" : "15:55:27" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:58:22" , 
"departure_time" : "15:59:44" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:00:22" , 
"departure_time" : "16:01:59" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:03:37" , 
"departure_time" : "16:04:17" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:04:40" , 
"departure_time" : "16:05:17" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:06:37" , 
"departure_time" : "16:07:01" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:08:24" , 
"departure_time" : "16:09:14" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:11:50" , 
"departure_time" : "16:12:37" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:16:47" , 
"departure_time" : "16:18:09" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:19:22" , 
"departure_time" : "16:19:37" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:21:15" , 
"departure_time" : "16:21:27" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "16:24:12" , 
"departure_time" : "16:24:42" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:26:30" , 
"departure_time" : "16:27:02" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "16:28:32" , 
"departure_time" : "16:28:32" , 
"distance_traveled" : 10.0595
} ], 
"674" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "16:08:00" , 
"departure_time" : "16:10:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "16:11:40" , 
"departure_time" : "16:12:34" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "16:12:54" , 
"departure_time" : "16:14:27" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:16:33" , 
"departure_time" : "16:17:51" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:19:18" , 
"departure_time" : "16:19:47" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:19:29" , 
"departure_time" : "16:20:09" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:22:40" , 
"departure_time" : "16:23:16" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:24:36" , 
"departure_time" : "16:25:41" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:27:05" , 
"departure_time" : "16:28:01" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:28:56" , 
"departure_time" : "16:30:29" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:32:33" , 
"departure_time" : "16:33:49" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:37:16" , 
"departure_time" : "16:38:44" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:39:28" , 
"departure_time" : "16:40:27" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:41:59" , 
"departure_time" : "16:42:11" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "16:44:12" , 
"departure_time" : "16:44:48" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:46:36" , 
"departure_time" : "16:46:48" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "16:48:12" , 
"departure_time" : "16:48:12" , 
"distance_traveled" : 10.0595
} ], 
"675" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "16:28:00" , 
"departure_time" : "16:29:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "16:30:51" , 
"departure_time" : "16:31:37" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "16:32:46" , 
"departure_time" : "16:33:52" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:36:06" , 
"departure_time" : "16:36:37" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:38:31" , 
"departure_time" : "16:39:20" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:39:49" , 
"departure_time" : "16:41:02" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:43:13" , 
"departure_time" : "16:43:21" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:44:08" , 
"departure_time" : "16:45:43" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:47:35" , 
"departure_time" : "16:48:16" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:48:41" , 
"departure_time" : "16:49:29" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:51:48" , 
"departure_time" : "16:52:45" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:56:57" , 
"departure_time" : "16:57:34" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:58:37" , 
"departure_time" : "16:59:42" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:02:05" , 
"departure_time" : "17:02:17" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:04:12" , 
"departure_time" : "17:05:34" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:07:22" , 
"departure_time" : "17:08:30" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "17:09:08" , 
"departure_time" : "17:09:08" , 
"distance_traveled" : 10.0595
} ], 
"676" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "16:48:00" , 
"departure_time" : "16:50:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "16:51:08" , 
"departure_time" : "16:51:16" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "16:52:08" , 
"departure_time" : "16:53:31" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:56:23" , 
"departure_time" : "16:56:36" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:58:13" , 
"departure_time" : "16:58:39" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:59:26" , 
"departure_time" : "17:00:38" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:03:12" , 
"departure_time" : "17:03:29" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:04:17" , 
"departure_time" : "17:05:00" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:06:43" , 
"departure_time" : "17:07:35" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:08:52" , 
"departure_time" : "17:09:44" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:11:52" , 
"departure_time" : "17:12:36" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:16:44" , 
"departure_time" : "17:17:30" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "17:18:46" , 
"departure_time" : "17:19:11" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:21:25" , 
"departure_time" : "17:21:58" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:24:33" , 
"departure_time" : "17:25:20" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:26:47" , 
"departure_time" : "17:27:23" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "17:28:36" , 
"departure_time" : "17:28:36" , 
"distance_traveled" : 10.0595
} ], 
"677" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "17:08:00" , 
"departure_time" : "17:09:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "17:10:24" , 
"departure_time" : "17:10:27" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "17:12:03" , 
"departure_time" : "17:12:25" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:15:22" , 
"departure_time" : "17:16:15" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:18:53" , 
"departure_time" : "17:19:20" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:19:27" , 
"departure_time" : "17:20:25" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:22:58" , 
"departure_time" : "17:23:20" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:24:22" , 
"departure_time" : "17:25:21" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:26:59" , 
"departure_time" : "17:28:01" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:29:02" , 
"departure_time" : "17:29:11" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:31:09" , 
"departure_time" : "17:31:13" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:36:04" , 
"departure_time" : "17:37:36" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "17:39:32" , 
"departure_time" : "17:39:43" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:41:11" , 
"departure_time" : "17:42:51" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:45:40" , 
"departure_time" : "17:46:53" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:47:13" , 
"departure_time" : "17:47:32" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "17:48:19" , 
"departure_time" : "17:48:19" , 
"distance_traveled" : 10.0595
} ], 
"678" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "17:28:00" , 
"departure_time" : "17:28:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "17:30:37" , 
"departure_time" : "17:30:58" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "17:32:21" , 
"departure_time" : "17:33:17" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:35:56" , 
"departure_time" : "17:36:50" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:38:54" , 
"departure_time" : "17:39:11" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:39:17" , 
"departure_time" : "17:40:16" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:42:59" , 
"departure_time" : "17:44:14" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:45:15" , 
"departure_time" : "17:46:26" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:47:11" , 
"departure_time" : "17:48:15" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:49:04" , 
"departure_time" : "17:49:28" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:51:24" , 
"departure_time" : "17:52:05" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:56:41" , 
"departure_time" : "17:56:49" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "17:58:08" , 
"departure_time" : "17:58:19" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:01:11" , 
"departure_time" : "18:01:23" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:04:12" , 
"departure_time" : "18:05:22" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:07:10" , 
"departure_time" : "18:08:24" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "18:09:14" , 
"departure_time" : "18:09:14" , 
"distance_traveled" : 10.0595
} ], 
"679" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "17:48:00" , 
"departure_time" : "17:49:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "17:50:19" , 
"departure_time" : "17:51:47" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "17:53:28" , 
"departure_time" : "17:54:50" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:56:22" , 
"departure_time" : "17:57:36" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:59:14" , 
"departure_time" : "18:00:28" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:00:14" , 
"departure_time" : "18:00:30" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:02:16" , 
"departure_time" : "18:03:21" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:05:05" , 
"departure_time" : "18:06:14" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:07:09" , 
"departure_time" : "18:08:32" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:09:23" , 
"departure_time" : "18:09:57" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:11:34" , 
"departure_time" : "18:12:10" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:16:36" , 
"departure_time" : "18:16:40" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:18:04" , 
"departure_time" : "18:19:32" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:22:28" , 
"departure_time" : "18:22:31" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:24:03" , 
"departure_time" : "18:25:35" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:27:32" , 
"departure_time" : "18:28:13" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "18:28:41" , 
"departure_time" : "18:28:41" , 
"distance_traveled" : 10.0595
} ], 
"680" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "18:08:00" , 
"departure_time" : "18:08:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "18:10:17" , 
"departure_time" : "18:11:00" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "18:12:43" , 
"departure_time" : "18:13:35" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:15:52" , 
"departure_time" : "18:16:52" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:19:00" , 
"departure_time" : "18:20:30" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:20:30" , 
"departure_time" : "18:20:43" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:22:13" , 
"departure_time" : "18:22:20" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:24:07" , 
"departure_time" : "18:24:42" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:26:35" , 
"departure_time" : "18:27:36" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:29:01" , 
"departure_time" : "18:29:33" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:31:32" , 
"departure_time" : "18:31:33" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:36:01" , 
"departure_time" : "18:37:17" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:39:16" , 
"departure_time" : "18:40:28" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:42:12" , 
"departure_time" : "18:42:28" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:44:16" , 
"departure_time" : "18:45:17" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:47:01" , 
"departure_time" : "18:48:00" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "18:48:59" , 
"departure_time" : "18:48:59" , 
"distance_traveled" : 10.0595
} ], 
"681" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "18:28:00" , 
"departure_time" : "18:29:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "18:30:51" , 
"departure_time" : "18:32:03" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "18:33:12" , 
"departure_time" : "18:33:49" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:35:37" , 
"departure_time" : "18:35:51" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:38:14" , 
"departure_time" : "18:38:16" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:39:02" , 
"departure_time" : "18:39:38" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:42:36" , 
"departure_time" : "18:44:07" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:45:31" , 
"departure_time" : "18:46:10" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:46:39" , 
"departure_time" : "18:47:52" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:49:13" , 
"departure_time" : "18:50:21" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:52:08" , 
"departure_time" : "18:53:20" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:57:12" , 
"departure_time" : "18:58:17" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:59:05" , 
"departure_time" : "19:00:34" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "19:02:29" , 
"departure_time" : "19:02:37" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "19:04:08" , 
"departure_time" : "19:05:24" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "19:07:16" , 
"departure_time" : "19:07:39" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "19:08:23" , 
"departure_time" : "19:08:23" , 
"distance_traveled" : 10.0595
} ], 
"682" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "18:48:00" , 
"departure_time" : "18:48:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "18:50:28" , 
"departure_time" : "18:51:56" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "18:53:28" , 
"departure_time" : "18:55:06" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:56:38" , 
"departure_time" : "18:56:49" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:58:11" , 
"departure_time" : "18:59:11" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:00:00" , 
"departure_time" : "19:00:37" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:02:37" , 
"departure_time" : "19:03:01" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:04:24" , 
"departure_time" : "19:06:01" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:07:37" , 
"departure_time" : "19:08:53" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:09:16" , 
"departure_time" : "19:09:44" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:11:28" , 
"departure_time" : "19:12:47" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "19:17:19" , 
"departure_time" : "19:17:26" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "19:18:07" , 
"departure_time" : "19:18:49" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "19:21:42" , 
"departure_time" : "19:22:58" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "19:25:16" , 
"departure_time" : "19:26:26" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "19:27:10" , 
"departure_time" : "19:28:23" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "19:29:13" , 
"departure_time" : "19:29:13" , 
"distance_traveled" : 10.0595
} ], 
"683" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "19:08:00" , 
"departure_time" : "19:09:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "19:10:36" , 
"departure_time" : "19:11:40" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "19:13:04" , 
"departure_time" : "19:13:52" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:15:48" , 
"departure_time" : "19:16:42" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:18:54" , 
"departure_time" : "19:19:11" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:19:17" , 
"departure_time" : "19:20:32" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:23:15" , 
"departure_time" : "19:24:40" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:25:25" , 
"departure_time" : "19:26:12" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:26:47" , 
"departure_time" : "19:28:25" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:29:38" , 
"departure_time" : "19:30:40" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:32:02" , 
"departure_time" : "19:33:13" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "19:37:11" , 
"departure_time" : "19:37:27" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "19:38:16" , 
"departure_time" : "19:38:31" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "19:41:15" , 
"departure_time" : "19:41:35" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "19:44:20" , 
"departure_time" : "19:44:27" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "19:46:07" , 
"departure_time" : "19:46:46" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "19:48:39" , 
"departure_time" : "19:48:39" , 
"distance_traveled" : 10.0595
} ], 
"684" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "19:28:00" , 
"departure_time" : "19:30:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "19:31:27" , 
"departure_time" : "19:32:02" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "19:32:35" , 
"departure_time" : "19:32:45" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:35:10" , 
"departure_time" : "19:35:27" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:38:17" , 
"departure_time" : "19:38:46" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:39:29" , 
"departure_time" : "19:40:59" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:43:30" , 
"departure_time" : "19:44:39" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:45:09" , 
"departure_time" : "19:45:19" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:46:10" , 
"departure_time" : "19:47:30" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:49:20" , 
"departure_time" : "19:50:59" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:52:39" , 
"departure_time" : "19:52:59" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "19:56:20" , 
"departure_time" : "19:56:49" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "19:58:29" , 
"departure_time" : "19:59:37" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "20:02:08" , 
"departure_time" : "20:03:27" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "20:05:19" , 
"departure_time" : "20:05:34" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "20:06:15" , 
"departure_time" : "20:06:44" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "20:08:29" , 
"departure_time" : "20:08:29" , 
"distance_traveled" : 10.0595
} ], 
"685" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "19:48:00" , 
"departure_time" : "19:49:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "19:51:21" , 
"departure_time" : "19:53:01" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "19:53:40" , 
"departure_time" : "19:54:32" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:55:52" , 
"departure_time" : "19:57:10" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:59:18" , 
"departure_time" : "19:59:47" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:59:29" , 
"departure_time" : "20:00:04" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:02:35" , 
"departure_time" : "20:03:01" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:04:26" , 
"departure_time" : "20:06:04" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:07:38" , 
"departure_time" : "20:09:05" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:09:27" , 
"departure_time" : "20:10:23" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:11:56" , 
"departure_time" : "20:12:02" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "20:16:06" , 
"departure_time" : "20:16:22" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "20:18:16" , 
"departure_time" : "20:19:45" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "20:22:29" , 
"departure_time" : "20:22:44" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "20:24:15" , 
"departure_time" : "20:25:35" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "20:27:20" , 
"departure_time" : "20:28:43" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "20:29:23" , 
"departure_time" : "20:29:23" , 
"distance_traveled" : 10.0595
} ], 
"686" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "20:08:00" , 
"departure_time" : "20:10:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "20:11:00" , 
"departure_time" : "20:11:35" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "20:12:35" , 
"departure_time" : "20:13:23" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:15:48" , 
"departure_time" : "20:17:18" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:19:30" , 
"departure_time" : "20:21:02" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:20:32" , 
"departure_time" : "20:20:39" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:22:07" , 
"departure_time" : "20:23:40" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:25:33" , 
"departure_time" : "20:26:18" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:26:45" , 
"departure_time" : "20:27:10" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:28:25" , 
"departure_time" : "20:28:33" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:31:08" , 
"departure_time" : "20:32:28" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "20:37:20" , 
"departure_time" : "20:37:33" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "20:38:13" , 
"departure_time" : "20:38:32" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "20:41:19" , 
"departure_time" : "20:42:45" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "20:45:26" , 
"departure_time" : "20:46:15" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "20:46:49" , 
"departure_time" : "20:47:55" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "20:49:06" , 
"departure_time" : "20:49:06" , 
"distance_traveled" : 10.0595
} ], 
"687" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "20:28:00" , 
"departure_time" : "20:29:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "20:30:12" , 
"departure_time" : "20:30:28" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "20:32:16" , 
"departure_time" : "20:33:17" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:36:01" , 
"departure_time" : "20:37:32" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:39:31" , 
"departure_time" : "20:40:57" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:40:26" , 
"departure_time" : "20:41:02" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:42:36" , 
"departure_time" : "20:43:38" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:45:02" , 
"departure_time" : "20:45:57" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:46:55" , 
"departure_time" : "20:47:54" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:48:59" , 
"departure_time" : "20:50:28" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:52:29" , 
"departure_time" : "20:53:26" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "20:56:57" , 
"departure_time" : "20:57:58" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "20:59:01" , 
"departure_time" : "21:00:36" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "21:02:35" , 
"departure_time" : "21:02:39" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "21:04:04" , 
"departure_time" : "21:04:47" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "21:06:43" , 
"departure_time" : "21:07:55" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "21:09:12" , 
"departure_time" : "21:09:12" , 
"distance_traveled" : 10.0595
} ], 
"688" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "20:48:00" , 
"departure_time" : "20:49:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "20:50:05" , 
"departure_time" : "20:50:06" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "20:52:01" , 
"departure_time" : "20:53:34" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:56:33" , 
"departure_time" : "20:58:01" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:59:28" , 
"departure_time" : "21:00:27" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:59:59" , 
"departure_time" : "21:00:49" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:02:50" , 
"departure_time" : "21:04:14" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "21:05:24" , 
"departure_time" : "21:06:02" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:06:38" , 
"departure_time" : "21:07:59" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:09:21" , 
"departure_time" : "21:10:12" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:11:51" , 
"departure_time" : "21:13:19" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "21:17:28" , 
"departure_time" : "21:19:07" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "21:19:39" , 
"departure_time" : "21:20:43" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "21:22:04" , 
"departure_time" : "21:22:28" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "21:24:24" , 
"departure_time" : "21:26:02" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "21:27:38" , 
"departure_time" : "21:28:20" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "21:28:42" , 
"departure_time" : "21:28:42" , 
"distance_traveled" : 10.0595
} ], 
"689" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "21:08:00" , 
"departure_time" : "21:09:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "21:10:31" , 
"departure_time" : "21:11:38" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "21:13:07" , 
"departure_time" : "21:14:30" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:16:23" , 
"departure_time" : "21:18:01" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "21:19:38" , 
"departure_time" : "21:19:57" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "21:19:19" , 
"departure_time" : "21:19:42" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:22:23" , 
"departure_time" : "21:23:29" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "21:25:06" , 
"departure_time" : "21:26:38" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:27:32" , 
"departure_time" : "21:27:51" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:28:19" , 
"departure_time" : "21:29:00" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:31:41" , 
"departure_time" : "21:32:07" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "21:36:26" , 
"departure_time" : "21:37:13" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "21:38:47" , 
"departure_time" : "21:39:16" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "21:41:29" , 
"departure_time" : "21:42:28" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "21:44:59" , 
"departure_time" : "21:46:06" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "21:47:07" , 
"departure_time" : "21:48:06" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "21:48:59" , 
"departure_time" : "21:48:59" , 
"distance_traveled" : 10.0595
} ], 
"690" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "21:28:00" , 
"departure_time" : "21:29:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "21:30:51" , 
"departure_time" : "21:30:52" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "21:32:01" , 
"departure_time" : "21:33:23" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:36:22" , 
"departure_time" : "21:37:41" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "21:39:19" , 
"departure_time" : "21:39:47" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "21:39:28" , 
"departure_time" : "21:39:37" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:42:09" , 
"departure_time" : "21:43:18" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "21:45:09" , 
"departure_time" : "21:45:38" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:46:29" , 
"departure_time" : "21:46:41" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:48:12" , 
"departure_time" : "21:49:41" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:52:29" , 
"departure_time" : "21:53:01" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "21:56:32" , 
"departure_time" : "21:57:59" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "21:59:27" , 
"departure_time" : "22:00:41" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "22:02:14" , 
"departure_time" : "22:03:37" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "22:05:23" , 
"departure_time" : "22:06:17" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "22:06:54" , 
"departure_time" : "22:07:43" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "22:08:49" , 
"departure_time" : "22:08:49" , 
"distance_traveled" : 10.0595
} ], 
"691" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "21:48:00" , 
"departure_time" : "21:50:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "21:51:22" , 
"departure_time" : "21:51:36" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "21:52:14" , 
"departure_time" : "21:53:36" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:56:22" , 
"departure_time" : "21:56:58" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "21:58:36" , 
"departure_time" : "21:59:57" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:00:21" , 
"departure_time" : "22:01:58" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:03:37" , 
"departure_time" : "22:04:44" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:05:07" , 
"departure_time" : "22:05:24" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:06:17" , 
"departure_time" : "22:07:18" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:09:01" , 
"departure_time" : "22:09:29" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:11:28" , 
"departure_time" : "22:12:31" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "22:17:03" , 
"departure_time" : "22:18:07" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "22:19:04" , 
"departure_time" : "22:20:12" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "22:22:08" , 
"departure_time" : "22:23:03" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "22:24:55" , 
"departure_time" : "22:26:05" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "22:27:10" , 
"departure_time" : "22:27:54" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "22:28:44" , 
"departure_time" : "22:28:44" , 
"distance_traveled" : 10.0595
} ], 
"692" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "22:08:00" , 
"departure_time" : "22:10:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "22:11:31" , 
"departure_time" : "22:11:51" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "22:12:20" , 
"departure_time" : "22:13:08" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:15:48" , 
"departure_time" : "22:16:12" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:18:24" , 
"departure_time" : "22:18:27" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:19:03" , 
"departure_time" : "22:20:05" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:23:02" , 
"departure_time" : "22:24:19" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:25:17" , 
"departure_time" : "22:26:07" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:26:50" , 
"departure_time" : "22:27:35" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:28:45" , 
"departure_time" : "22:29:46" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:32:01" , 
"departure_time" : "22:32:29" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "22:36:28" , 
"departure_time" : "22:37:09" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "22:38:41" , 
"departure_time" : "22:39:23" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "22:41:42" , 
"departure_time" : "22:42:31" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "22:44:49" , 
"departure_time" : "22:45:45" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "22:46:56" , 
"departure_time" : "22:46:59" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "22:48:03" , 
"departure_time" : "22:48:03" , 
"distance_traveled" : 10.0595
} ], 
"693" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "22:28:00" , 
"departure_time" : "22:28:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "22:30:50" , 
"departure_time" : "22:32:15" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "22:33:25" , 
"departure_time" : "22:35:02" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:36:37" , 
"departure_time" : "22:37:30" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:38:53" , 
"departure_time" : "22:39:51" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:39:58" , 
"departure_time" : "22:40:48" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:42:50" , 
"departure_time" : "22:43:21" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:44:31" , 
"departure_time" : "22:45:37" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:47:06" , 
"departure_time" : "22:48:06" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:49:00" , 
"departure_time" : "22:50:04" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:52:04" , 
"departure_time" : "22:53:08" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "22:57:04" , 
"departure_time" : "22:57:42" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "22:58:38" , 
"departure_time" : "22:58:56" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "23:01:18" , 
"departure_time" : "23:01:23" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "23:04:05" , 
"departure_time" : "23:04:32" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "23:06:27" , 
"departure_time" : "23:07:25" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "23:08:58" , 
"departure_time" : "23:08:58" , 
"distance_traveled" : 10.0595
} ], 
"694" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "22:48:00" , 
"departure_time" : "22:50:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "22:51:18" , 
"departure_time" : "22:52:31" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "22:53:13" , 
"departure_time" : "22:54:47" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:56:34" , 
"departure_time" : "22:57:23" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:58:49" , 
"departure_time" : "22:59:35" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:59:46" , 
"departure_time" : "23:01:18" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:03:32" , 
"departure_time" : "23:04:29" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:04:57" , 
"departure_time" : "23:06:28" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:07:31" , 
"departure_time" : "23:09:09" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:09:38" , 
"departure_time" : "23:10:16" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:11:38" , 
"departure_time" : "23:11:43" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "23:16:05" , 
"departure_time" : "23:16:21" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "23:18:16" , 
"departure_time" : "23:18:36" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "23:21:20" , 
"departure_time" : "23:22:07" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "23:24:47" , 
"departure_time" : "23:25:42" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "23:26:55" , 
"departure_time" : "23:27:04" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "23:28:09" , 
"departure_time" : "23:28:09" , 
"distance_traveled" : 10.0595
} ], 
"695" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "23:08:00" , 
"departure_time" : "23:08:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "23:10:23" , 
"departure_time" : "23:10:51" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "23:12:28" , 
"departure_time" : "23:12:41" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:15:13" , 
"departure_time" : "23:15:44" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:18:31" , 
"departure_time" : "23:18:53" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "23:19:22" , 
"departure_time" : "23:20:13" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:22:51" , 
"departure_time" : "23:23:01" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:24:10" , 
"departure_time" : "23:25:34" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:27:24" , 
"departure_time" : "23:28:58" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:29:34" , 
"departure_time" : "23:30:56" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:32:22" , 
"departure_time" : "23:33:06" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "23:36:44" , 
"departure_time" : "23:36:54" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "23:38:10" , 
"departure_time" : "23:39:34" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "23:42:24" , 
"departure_time" : "23:43:41" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "23:45:17" , 
"departure_time" : "23:45:30" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "23:46:13" , 
"departure_time" : "23:47:21" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "23:49:08" , 
"departure_time" : "23:49:08" , 
"distance_traveled" : 10.0595
} ], 
"696" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "23:28:00" , 
"departure_time" : "23:29:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "23:30:48" , 
"departure_time" : "23:31:09" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "23:32:21" , 
"departure_time" : "23:33:41" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:36:20" , 
"departure_time" : "23:36:43" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:38:23" , 
"departure_time" : "23:38:36" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "23:39:13" , 
"departure_time" : "23:40:38" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:43:25" , 
"departure_time" : "23:44:55" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:45:30" , 
"departure_time" : "23:46:12" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:46:42" , 
"departure_time" : "23:47:35" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:48:53" , 
"departure_time" : "23:49:16" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:51:23" , 
"departure_time" : "23:52:14" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "23:56:51" , 
"departure_time" : "23:57:16" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "23:58:25" , 
"departure_time" : "24:00:00" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "24:02:35" , 
"departure_time" : "24:02:50" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "24:04:15" , 
"departure_time" : "24:05:52" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "24:07:37" , 
"departure_time" : "24:08:57" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "24:09:20" , 
"departure_time" : "24:09:20" , 
"distance_traveled" : 10.0595
} ], 
"697" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "23:48:00" , 
"departure_time" : "23:50:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "23:51:28" , 
"departure_time" : "23:51:36" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "23:52:08" , 
"departure_time" : "23:52:39" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:55:31" , 
"departure_time" : "23:56:06" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:58:35" , 
"departure_time" : "23:59:50" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "24:00:15" , 
"departure_time" : "24:00:36" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "24:02:21" , 
"departure_time" : "24:03:54" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "24:05:33" , 
"departure_time" : "24:05:46" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "24:06:13" , 
"departure_time" : "24:06:59" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "24:08:46" , 
"departure_time" : "24:08:59" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "24:11:13" , 
"departure_time" : "24:12:53" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "24:17:40" , 
"departure_time" : "24:19:17" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "24:19:37" , 
"departure_time" : "24:19:44" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "24:21:07" , 
"departure_time" : "24:22:29" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "24:25:22" , 
"departure_time" : "24:26:29" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "24:27:07" , 
"departure_time" : "24:28:38" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "24:29:31" , 
"departure_time" : "24:29:31" , 
"distance_traveled" : 10.0595
} ], 
"698" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "24:18:00" , 
"departure_time" : "24:19:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "24:20:02" , 
"departure_time" : "24:21:35" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "24:23:33" , 
"departure_time" : "24:23:40" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "24:25:07" , 
"departure_time" : "24:25:27" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "24:28:20" , 
"departure_time" : "24:29:39" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "24:30:19" , 
"departure_time" : "24:30:47" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "24:32:28" , 
"departure_time" : "24:33:28" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "24:35:00" , 
"departure_time" : "24:36:38" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "24:37:38" , 
"departure_time" : "24:38:50" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "24:39:12" , 
"departure_time" : "24:39:18" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "24:41:06" , 
"departure_time" : "24:41:10" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "24:46:04" , 
"departure_time" : "24:47:42" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "24:49:38" , 
"departure_time" : "24:50:42" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "24:52:04" , 
"departure_time" : "24:52:44" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "24:54:40" , 
"departure_time" : "24:54:54" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "24:56:14" , 
"departure_time" : "24:57:29" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "24:59:15" , 
"departure_time" : "24:59:15" , 
"distance_traveled" : 10.0595
} ], 
"699" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "24:48:00" , 
"departure_time" : "24:50:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "24:51:02" , 
"departure_time" : "24:51:51" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "24:52:49" , 
"departure_time" : "24:54:00" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "24:56:11" , 
"departure_time" : "24:57:49" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "24:59:38" , 
"departure_time" : "25:00:30" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "24:59:52" , 
"departure_time" : "25:01:29" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "25:03:37" , 
"departure_time" : "25:04:27" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "25:04:50" , 
"departure_time" : "25:06:03" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "25:07:13" , 
"departure_time" : "25:07:33" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "25:08:20" , 
"departure_time" : "25:09:10" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "25:11:50" , 
"departure_time" : "25:12:09" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "25:16:19" , 
"departure_time" : "25:17:05" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "25:18:46" , 
"departure_time" : "25:19:10" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "25:21:24" , 
"departure_time" : "25:22:50" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "25:25:26" , 
"departure_time" : "25:25:27" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "25:26:01" , 
"departure_time" : "25:27:29" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "25:29:28" , 
"departure_time" : "25:29:28" , 
"distance_traveled" : 10.0595
} ], 
"700" :  [ 
{ 
"stop_id" : 36998,
"arrival_time" : "05:20:00" , 
"departure_time" : "05:21:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "05:23:26" , 
"departure_time" : "05:24:27" , 
"distance_traveled" : 0.6824
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "05:25:01" , 
"departure_time" : "05:25:56" , 
"distance_traveled" : 0.9598
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "05:26:55" , 
"departure_time" : "05:28:15" , 
"distance_traveled" : 1.3676
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "05:29:20" , 
"departure_time" : "05:30:19" , 
"distance_traveled" : 1.6621
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "05:30:59" , 
"departure_time" : "05:31:35" , 
"distance_traveled" : 1.9112
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "05:32:36" , 
"departure_time" : "05:32:47" , 
"distance_traveled" : 2.2581
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "05:35:11" , 
"departure_time" : "05:36:12" , 
"distance_traveled" : 2.5511
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "05:40:01" , 
"departure_time" : "05:40:01" , 
"distance_traveled" : 3.4288
} ], 
"701" :  [ 
{ 
"stop_id" : 36998,
"arrival_time" : "05:41:00" , 
"departure_time" : "05:43:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "05:45:01" , 
"departure_time" : "05:45:20" , 
"distance_traveled" : 0.6824
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "05:45:19" , 
"departure_time" : "05:46:04" , 
"distance_traveled" : 0.9598
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "05:47:45" , 
"departure_time" : "05:48:28" , 
"distance_traveled" : 1.3676
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "05:49:43" , 
"departure_time" : "05:50:27" , 
"distance_traveled" : 1.6621
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "05:51:44" , 
"departure_time" : "05:52:11" , 
"distance_traveled" : 1.9112
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "05:53:27" , 
"departure_time" : "05:54:13" , 
"distance_traveled" : 2.2581
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "05:56:46" , 
"departure_time" : "05:57:13" , 
"distance_traveled" : 2.5511
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "06:00:27" , 
"departure_time" : "06:00:27" , 
"distance_traveled" : 3.4288
} ], 
"702" :  [ 
{ 
"stop_id" : 36998,
"arrival_time" : "06:01:00" , 
"departure_time" : "06:02:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:05:22" , 
"departure_time" : "06:06:13" , 
"distance_traveled" : 0.6824
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:05:51" , 
"departure_time" : "06:06:32" , 
"distance_traveled" : 0.9598
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:07:41" , 
"departure_time" : "06:08:29" , 
"distance_traveled" : 1.3676
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:09:48" , 
"departure_time" : "06:11:06" , 
"distance_traveled" : 1.6621
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:12:18" , 
"departure_time" : "06:12:23" , 
"distance_traveled" : 1.9112
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:13:05" , 
"departure_time" : "06:13:57" , 
"distance_traveled" : 2.2581
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:16:52" , 
"departure_time" : "06:16:59" , 
"distance_traveled" : 2.5511
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "06:20:07" , 
"departure_time" : "06:20:07" , 
"distance_traveled" : 3.4288
} ], 
"703" :  [ 
{ 
"stop_id" : 36998,
"arrival_time" : "05:35:00" , 
"departure_time" : "05:36:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "05:39:39" , 
"departure_time" : "05:40:26" , 
"distance_traveled" : 0.6824
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "05:39:47" , 
"departure_time" : "05:40:53" , 
"distance_traveled" : 0.9598
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "05:43:06" , 
"departure_time" : "05:44:39" , 
"distance_traveled" : 1.3676
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "05:45:33" , 
"departure_time" : "05:46:23" , 
"distance_traveled" : 1.6621
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "05:46:50" , 
"departure_time" : "05:47:14" , 
"distance_traveled" : 1.9112
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "05:48:24" , 
"departure_time" : "05:49:54" , 
"distance_traveled" : 2.2581
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "05:52:30" , 
"departure_time" : "05:52:32" , 
"distance_traveled" : 2.5511
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "05:56:02" , 
"departure_time" : "05:56:20" , 
"distance_traveled" : 3.9917
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "05:58:18" , 
"departure_time" : "05:58:23" , 
"distance_traveled" : 4.5428
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "06:01:05" , 
"departure_time" : "06:02:44" , 
"distance_traveled" : 5.825
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "06:05:39" , 
"departure_time" : "06:06:14" , 
"distance_traveled" : 6.9854
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "06:06:35" , 
"departure_time" : "06:08:14" , 
"distance_traveled" : 7.6831
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "06:09:39" , 
"departure_time" : "06:09:39" , 
"distance_traveled" : 8.2778
} ], 
"704" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "05:45:00" , 
"departure_time" : "05:47:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "05:48:35" , 
"departure_time" : "05:48:37" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "05:50:02" , 
"departure_time" : "05:50:30" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "05:52:28" , 
"departure_time" : "05:53:18" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "05:54:50" , 
"departure_time" : "05:54:55" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "05:56:05" , 
"departure_time" : "05:56:57" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "05:58:52" , 
"departure_time" : "05:58:55" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "05:59:03" , 
"departure_time" : "06:00:12" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:03:09" , 
"departure_time" : "06:04:33" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "06:06:24" , 
"departure_time" : "06:06:57" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "06:06:33" , 
"departure_time" : "06:08:00" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "06:09:27" , 
"departure_time" : "06:10:55" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "06:11:28" , 
"departure_time" : "06:12:17" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "06:12:49" , 
"departure_time" : "06:14:19" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "06:16:30" , 
"departure_time" : "06:16:30" , 
"distance_traveled" : 9.0369
} ], 
"705" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "06:05:00" , 
"departure_time" : "06:07:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:08:38" , 
"departure_time" : "06:09:25" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:10:47" , 
"departure_time" : "06:11:24" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:12:37" , 
"departure_time" : "06:14:08" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:15:31" , 
"departure_time" : "06:15:34" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:16:03" , 
"departure_time" : "06:17:14" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:19:11" , 
"departure_time" : "06:20:15" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:20:04" , 
"departure_time" : "06:20:13" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:22:09" , 
"departure_time" : "06:22:42" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "06:25:33" , 
"departure_time" : "06:26:29" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "06:26:56" , 
"departure_time" : "06:27:58" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "06:29:02" , 
"departure_time" : "06:29:21" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "06:30:19" , 
"departure_time" : "06:31:46" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "06:33:27" , 
"departure_time" : "06:34:58" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "06:36:31" , 
"departure_time" : "06:36:31" , 
"distance_traveled" : 9.0369
} ], 
"706" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "06:25:00" , 
"departure_time" : "06:27:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:28:48" , 
"departure_time" : "06:28:59" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:30:11" , 
"departure_time" : "06:31:15" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:33:04" , 
"departure_time" : "06:34:04" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:35:00" , 
"departure_time" : "06:36:39" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:37:39" , 
"departure_time" : "06:38:26" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:38:47" , 
"departure_time" : "06:38:52" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:39:05" , 
"departure_time" : "06:39:25" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:42:20" , 
"departure_time" : "06:43:44" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "06:46:24" , 
"departure_time" : "06:46:29" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "06:46:05" , 
"departure_time" : "06:47:20" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "06:49:15" , 
"departure_time" : "06:49:18" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "06:50:03" , 
"departure_time" : "06:50:24" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "06:52:21" , 
"departure_time" : "06:52:47" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "06:55:26" , 
"departure_time" : "06:55:26" , 
"distance_traveled" : 9.0369
} ], 
"707" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "06:45:00" , 
"departure_time" : "06:45:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:48:29" , 
"departure_time" : "06:48:46" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:50:17" , 
"departure_time" : "06:50:50" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:52:33" , 
"departure_time" : "06:54:02" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:55:29" , 
"departure_time" : "06:56:40" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:57:11" , 
"departure_time" : "06:57:40" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:58:29" , 
"departure_time" : "06:59:01" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:59:32" , 
"departure_time" : "07:01:10" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:03:38" , 
"departure_time" : "07:04:56" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "07:06:18" , 
"departure_time" : "07:07:53" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "07:07:35" , 
"departure_time" : "07:08:40" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "07:09:05" , 
"departure_time" : "07:09:16" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "07:10:11" , 
"departure_time" : "07:11:09" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "07:12:58" , 
"departure_time" : "07:13:15" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "07:15:17" , 
"departure_time" : "07:15:17" , 
"distance_traveled" : 9.0369
} ], 
"708" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "07:05:00" , 
"departure_time" : "07:06:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:09:17" , 
"departure_time" : "07:10:52" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:11:35" , 
"departure_time" : "07:12:55" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:13:20" , 
"departure_time" : "07:14:00" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:14:40" , 
"departure_time" : "07:14:56" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:16:16" , 
"departure_time" : "07:17:09" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:18:53" , 
"departure_time" : "07:19:54" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:20:01" , 
"departure_time" : "07:21:26" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:23:25" , 
"departure_time" : "07:24:53" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "07:26:28" , 
"departure_time" : "07:27:45" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "07:27:17" , 
"departure_time" : "07:28:50" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "07:29:33" , 
"departure_time" : "07:30:00" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "07:30:27" , 
"departure_time" : "07:30:38" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "07:32:11" , 
"departure_time" : "07:33:51" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "07:36:40" , 
"departure_time" : "07:36:40" , 
"distance_traveled" : 9.0369
} ], 
"709" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "07:25:00" , 
"departure_time" : "07:27:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:28:22" , 
"departure_time" : "07:28:56" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:30:34" , 
"departure_time" : "07:31:22" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:32:48" , 
"departure_time" : "07:33:32" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:34:44" , 
"departure_time" : "07:35:36" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:36:52" , 
"departure_time" : "07:38:10" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:39:18" , 
"departure_time" : "07:39:28" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:39:10" , 
"departure_time" : "07:39:41" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:42:31" , 
"departure_time" : "07:43:20" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "07:45:49" , 
"departure_time" : "07:47:07" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "07:47:18" , 
"departure_time" : "07:48:06" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "07:48:48" , 
"departure_time" : "07:50:23" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "07:51:35" , 
"departure_time" : "07:52:25" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "07:52:50" , 
"departure_time" : "07:53:57" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "07:56:07" , 
"departure_time" : "07:56:07" , 
"distance_traveled" : 9.0369
} ], 
"710" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "07:45:00" , 
"departure_time" : "07:46:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:48:14" , 
"departure_time" : "07:48:44" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:50:30" , 
"departure_time" : "07:51:11" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:52:41" , 
"departure_time" : "07:53:01" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:54:20" , 
"departure_time" : "07:54:24" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:56:04" , 
"departure_time" : "07:56:39" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:58:35" , 
"departure_time" : "07:59:46" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:00:11" , 
"departure_time" : "08:00:59" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:02:48" , 
"departure_time" : "08:03:51" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "08:06:03" , 
"departure_time" : "08:07:35" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "08:07:32" , 
"departure_time" : "08:07:53" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "08:08:21" , 
"departure_time" : "08:08:28" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "08:10:07" , 
"departure_time" : "08:10:23" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "08:12:16" , 
"departure_time" : "08:13:48" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "08:16:32" , 
"departure_time" : "08:16:32" , 
"distance_traveled" : 9.0369
} ], 
"711" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "08:05:00" , 
"departure_time" : "08:06:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:08:06" , 
"departure_time" : "08:08:36" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:10:30" , 
"departure_time" : "08:11:33" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:13:03" , 
"departure_time" : "08:13:14" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:14:11" , 
"departure_time" : "08:14:37" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:16:26" , 
"departure_time" : "08:18:00" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:19:34" , 
"departure_time" : "08:20:22" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:19:48" , 
"departure_time" : "08:21:21" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:23:33" , 
"departure_time" : "08:24:39" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "08:26:06" , 
"departure_time" : "08:27:05" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "08:26:59" , 
"departure_time" : "08:28:25" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "08:29:26" , 
"departure_time" : "08:30:50" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "08:31:24" , 
"departure_time" : "08:32:24" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "08:33:00" , 
"departure_time" : "08:33:10" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "08:35:10" , 
"departure_time" : "08:35:10" , 
"distance_traveled" : 9.0369
} ], 
"712" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "08:25:00" , 
"departure_time" : "08:26:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:29:08" , 
"departure_time" : "08:29:50" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:30:42" , 
"departure_time" : "08:32:18" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:33:36" , 
"departure_time" : "08:34:20" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:34:44" , 
"departure_time" : "08:36:23" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:37:39" , 
"departure_time" : "08:38:09" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:38:30" , 
"departure_time" : "08:39:38" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:40:08" , 
"departure_time" : "08:40:57" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:42:49" , 
"departure_time" : "08:43:44" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "08:45:55" , 
"departure_time" : "08:46:16" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "08:46:21" , 
"departure_time" : "08:47:17" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "08:48:56" , 
"departure_time" : "08:50:18" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "08:51:22" , 
"departure_time" : "08:51:32" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "08:52:10" , 
"departure_time" : "08:53:22" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "08:56:12" , 
"departure_time" : "08:56:12" , 
"distance_traveled" : 9.0369
} ], 
"713" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "08:45:00" , 
"departure_time" : "08:47:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:48:53" , 
"departure_time" : "08:49:55" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:51:02" , 
"departure_time" : "08:51:36" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:52:34" , 
"departure_time" : "08:54:06" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:55:32" , 
"departure_time" : "08:57:11" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:57:39" , 
"departure_time" : "08:58:15" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:58:36" , 
"departure_time" : "08:59:54" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:00:18" , 
"departure_time" : "09:00:52" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:02:34" , 
"departure_time" : "09:02:52" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "09:05:18" , 
"departure_time" : "09:06:10" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "09:06:52" , 
"departure_time" : "09:08:08" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "09:09:16" , 
"departure_time" : "09:10:15" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "09:10:59" , 
"departure_time" : "09:12:31" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "09:13:32" , 
"departure_time" : "09:14:46" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "09:16:14" , 
"departure_time" : "09:16:14" , 
"distance_traveled" : 9.0369
} ], 
"714" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "09:05:00" , 
"departure_time" : "09:07:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:09:04" , 
"departure_time" : "09:10:19" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:11:15" , 
"departure_time" : "09:11:17" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:12:02" , 
"departure_time" : "09:12:07" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:14:05" , 
"departure_time" : "09:15:01" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:16:56" , 
"departure_time" : "09:17:20" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:18:24" , 
"departure_time" : "09:19:27" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:20:03" , 
"departure_time" : "09:21:43" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:23:40" , 
"departure_time" : "09:25:05" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "09:26:25" , 
"departure_time" : "09:27:31" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "09:27:06" , 
"departure_time" : "09:27:36" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "09:28:30" , 
"departure_time" : "09:28:42" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "09:30:12" , 
"departure_time" : "09:31:05" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "09:32:53" , 
"departure_time" : "09:32:57" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "09:35:04" , 
"departure_time" : "09:35:04" , 
"distance_traveled" : 9.0369
} ], 
"715" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "09:25:00" , 
"departure_time" : "09:25:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:28:30" , 
"departure_time" : "09:29:55" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:31:25" , 
"departure_time" : "09:32:47" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:33:22" , 
"departure_time" : "09:34:28" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:35:06" , 
"departure_time" : "09:36:44" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:37:38" , 
"departure_time" : "09:37:56" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:38:18" , 
"departure_time" : "09:39:48" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:40:30" , 
"departure_time" : "09:40:45" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:42:15" , 
"departure_time" : "09:42:46" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "09:45:31" , 
"departure_time" : "09:46:00" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "09:46:29" , 
"departure_time" : "09:47:00" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "09:48:31" , 
"departure_time" : "09:50:03" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "09:51:32" , 
"departure_time" : "09:51:50" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "09:52:18" , 
"departure_time" : "09:53:40" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "09:56:22" , 
"departure_time" : "09:56:22" , 
"distance_traveled" : 9.0369
} ], 
"716" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "09:45:00" , 
"departure_time" : "09:46:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:48:13" , 
"departure_time" : "09:48:39" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:50:26" , 
"departure_time" : "09:50:51" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:52:25" , 
"departure_time" : "09:53:31" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:55:06" , 
"departure_time" : "09:56:35" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:57:29" , 
"departure_time" : "09:58:17" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:58:48" , 
"departure_time" : "09:59:46" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:59:58" , 
"departure_time" : "10:00:48" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:02:50" , 
"departure_time" : "10:03:03" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "10:05:13" , 
"departure_time" : "10:05:29" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "10:06:16" , 
"departure_time" : "10:06:27" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "10:08:11" , 
"departure_time" : "10:09:23" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "10:11:12" , 
"departure_time" : "10:12:44" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "10:13:32" , 
"departure_time" : "10:14:37" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "10:16:05" , 
"departure_time" : "10:16:05" , 
"distance_traveled" : 9.0369
} ], 
"717" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "10:05:00" , 
"departure_time" : "10:07:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:09:26" , 
"departure_time" : "10:10:12" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:10:46" , 
"departure_time" : "10:11:09" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:12:23" , 
"departure_time" : "10:12:54" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:14:31" , 
"departure_time" : "10:16:03" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:17:32" , 
"departure_time" : "10:18:36" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:19:04" , 
"departure_time" : "10:20:17" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:20:13" , 
"departure_time" : "10:21:44" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:23:31" , 
"departure_time" : "10:24:39" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "10:26:08" , 
"departure_time" : "10:26:38" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "10:26:30" , 
"departure_time" : "10:28:06" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "10:29:36" , 
"departure_time" : "10:30:55" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "10:31:19" , 
"departure_time" : "10:32:59" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "10:33:40" , 
"departure_time" : "10:35:03" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "10:36:23" , 
"departure_time" : "10:36:23" , 
"distance_traveled" : 9.0369
} ], 
"718" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "10:25:00" , 
"departure_time" : "10:27:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:28:37" , 
"departure_time" : "10:29:48" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:31:11" , 
"departure_time" : "10:31:54" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:32:43" , 
"departure_time" : "10:33:30" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:34:47" , 
"departure_time" : "10:36:16" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:37:29" , 
"departure_time" : "10:38:49" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:39:20" , 
"departure_time" : "10:40:02" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:39:42" , 
"departure_time" : "10:41:20" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:43:38" , 
"departure_time" : "10:44:58" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "10:46:20" , 
"departure_time" : "10:47:47" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "10:47:27" , 
"departure_time" : "10:48:41" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "10:49:14" , 
"departure_time" : "10:50:37" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "10:51:23" , 
"departure_time" : "10:51:36" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "10:52:13" , 
"departure_time" : "10:53:29" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "10:56:16" , 
"departure_time" : "10:56:16" , 
"distance_traveled" : 9.0369
} ], 
"719" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "10:45:00" , 
"departure_time" : "10:47:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:49:32" , 
"departure_time" : "10:50:13" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:50:41" , 
"departure_time" : "10:51:26" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:52:45" , 
"departure_time" : "10:53:23" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:54:38" , 
"departure_time" : "10:55:07" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:56:29" , 
"departure_time" : "10:57:31" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:59:02" , 
"departure_time" : "10:59:29" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:59:27" , 
"departure_time" : "11:00:13" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:02:46" , 
"departure_time" : "11:04:06" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "11:06:20" , 
"departure_time" : "11:07:16" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "11:06:56" , 
"departure_time" : "11:07:33" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "11:08:37" , 
"departure_time" : "11:09:08" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "11:10:31" , 
"departure_time" : "11:11:39" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "11:13:08" , 
"departure_time" : "11:13:46" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "11:15:38" , 
"departure_time" : "11:15:38" , 
"distance_traveled" : 9.0369
} ], 
"720" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "11:05:00" , 
"departure_time" : "11:07:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:09:32" , 
"departure_time" : "11:11:05" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:11:33" , 
"departure_time" : "11:12:06" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:12:33" , 
"departure_time" : "11:13:45" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:15:12" , 
"departure_time" : "11:15:18" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:16:06" , 
"departure_time" : "11:16:27" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:18:21" , 
"departure_time" : "11:19:11" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:19:50" , 
"departure_time" : "11:20:46" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:22:56" , 
"departure_time" : "11:22:58" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "11:25:02" , 
"departure_time" : "11:26:25" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "11:27:23" , 
"departure_time" : "11:27:30" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "11:28:07" , 
"departure_time" : "11:29:06" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "11:30:59" , 
"departure_time" : "11:31:38" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "11:32:39" , 
"departure_time" : "11:34:03" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "11:36:24" , 
"departure_time" : "11:36:24" , 
"distance_traveled" : 9.0369
} ], 
"721" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "11:25:00" , 
"departure_time" : "11:26:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:28:21" , 
"departure_time" : "11:28:52" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:30:31" , 
"departure_time" : "11:30:32" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:32:01" , 
"departure_time" : "11:33:15" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:35:14" , 
"departure_time" : "11:35:33" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:36:19" , 
"departure_time" : "11:36:27" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:38:08" , 
"departure_time" : "11:39:14" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:40:06" , 
"departure_time" : "11:40:10" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:42:04" , 
"departure_time" : "11:43:10" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "11:46:06" , 
"departure_time" : "11:47:11" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "11:47:05" , 
"departure_time" : "11:47:55" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "11:48:50" , 
"departure_time" : "11:49:44" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "11:50:54" , 
"departure_time" : "11:51:08" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "11:52:14" , 
"departure_time" : "11:52:47" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "11:55:33" , 
"departure_time" : "11:55:33" , 
"distance_traveled" : 9.0369
} ], 
"722" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "11:45:00" , 
"departure_time" : "11:46:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:49:09" , 
"departure_time" : "11:49:56" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:50:47" , 
"departure_time" : "11:52:17" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:53:30" , 
"departure_time" : "11:54:30" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:55:00" , 
"departure_time" : "11:55:44" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:56:44" , 
"departure_time" : "11:56:51" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:58:07" , 
"departure_time" : "11:58:51" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:59:44" , 
"departure_time" : "12:01:23" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:03:39" , 
"departure_time" : "12:04:29" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "12:05:50" , 
"departure_time" : "12:06:59" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "12:07:09" , 
"departure_time" : "12:07:20" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "12:08:11" , 
"departure_time" : "12:08:17" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "12:10:06" , 
"departure_time" : "12:10:21" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "12:12:15" , 
"departure_time" : "12:13:12" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "12:15:57" , 
"departure_time" : "12:15:57" , 
"distance_traveled" : 9.0369
} ], 
"723" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "12:05:00" , 
"departure_time" : "12:06:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:08:29" , 
"departure_time" : "12:09:44" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:11:15" , 
"departure_time" : "12:12:53" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:13:38" , 
"departure_time" : "12:13:55" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:14:17" , 
"departure_time" : "12:15:01" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:16:44" , 
"departure_time" : "12:18:06" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:19:22" , 
"departure_time" : "12:19:39" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:19:17" , 
"departure_time" : "12:19:37" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:22:20" , 
"departure_time" : "12:23:13" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "12:25:53" , 
"departure_time" : "12:27:20" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "12:27:27" , 
"departure_time" : "12:29:05" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "12:29:38" , 
"departure_time" : "12:30:36" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "12:30:58" , 
"departure_time" : "12:31:41" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "12:32:43" , 
"departure_time" : "12:32:44" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "12:35:01" , 
"departure_time" : "12:35:01" , 
"distance_traveled" : 9.0369
} ], 
"724" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "12:25:00" , 
"departure_time" : "12:25:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:28:23" , 
"departure_time" : "12:28:44" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:30:21" , 
"departure_time" : "12:31:59" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:33:38" , 
"departure_time" : "12:34:46" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:35:08" , 
"departure_time" : "12:35:46" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:36:38" , 
"departure_time" : "12:38:04" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:39:26" , 
"departure_time" : "12:41:06" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:40:40" , 
"departure_time" : "12:41:25" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:42:45" , 
"departure_time" : "12:43:21" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "12:45:36" , 
"departure_time" : "12:46:01" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "12:46:25" , 
"departure_time" : "12:47:22" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "12:48:57" , 
"departure_time" : "12:50:06" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "12:51:09" , 
"departure_time" : "12:52:27" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "12:53:18" , 
"departure_time" : "12:54:19" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "12:56:01" , 
"departure_time" : "12:56:01" , 
"distance_traveled" : 9.0369
} ], 
"725" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "12:45:00" , 
"departure_time" : "12:47:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:49:30" , 
"departure_time" : "12:49:57" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:50:27" , 
"departure_time" : "12:51:35" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:53:08" , 
"departure_time" : "12:54:03" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:54:55" , 
"departure_time" : "12:55:35" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:56:40" , 
"departure_time" : "12:56:56" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:58:16" , 
"departure_time" : "12:59:04" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:59:48" , 
"departure_time" : "12:59:55" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:02:07" , 
"departure_time" : "13:02:11" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "13:05:04" , 
"departure_time" : "13:05:21" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "13:06:17" , 
"departure_time" : "13:07:01" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "13:08:44" , 
"departure_time" : "13:08:46" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "13:10:02" , 
"departure_time" : "13:10:50" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "13:12:48" , 
"departure_time" : "13:12:54" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "13:15:06" , 
"departure_time" : "13:15:06" , 
"distance_traveled" : 9.0369
} ], 
"726" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "13:05:00" , 
"departure_time" : "13:05:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:08:53" , 
"departure_time" : "13:09:46" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:10:53" , 
"departure_time" : "13:12:06" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:13:13" , 
"departure_time" : "13:14:10" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:14:57" , 
"departure_time" : "13:16:30" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:17:33" , 
"departure_time" : "13:18:59" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:19:26" , 
"departure_time" : "13:19:32" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:19:06" , 
"departure_time" : "13:19:13" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:22:07" , 
"departure_time" : "13:23:24" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "13:26:17" , 
"departure_time" : "13:26:49" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "13:26:32" , 
"departure_time" : "13:27:41" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "13:29:09" , 
"departure_time" : "13:29:43" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "13:30:34" , 
"departure_time" : "13:31:16" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "13:32:42" , 
"departure_time" : "13:33:10" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "13:35:28" , 
"departure_time" : "13:35:28" , 
"distance_traveled" : 9.0369
} ], 
"727" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "13:25:00" , 
"departure_time" : "13:27:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:29:35" , 
"departure_time" : "13:30:03" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:30:28" , 
"departure_time" : "13:31:44" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:33:16" , 
"departure_time" : "13:34:38" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:35:22" , 
"departure_time" : "13:35:49" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:36:27" , 
"departure_time" : "13:37:55" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:39:28" , 
"departure_time" : "13:40:29" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:40:01" , 
"departure_time" : "13:41:06" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:43:05" , 
"departure_time" : "13:44:29" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "13:46:24" , 
"departure_time" : "13:47:46" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "13:47:22" , 
"departure_time" : "13:47:57" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "13:48:35" , 
"departure_time" : "13:49:53" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "13:51:18" , 
"departure_time" : "13:52:19" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "13:53:01" , 
"departure_time" : "13:54:11" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "13:56:10" , 
"departure_time" : "13:56:10" , 
"distance_traveled" : 9.0369
} ], 
"728" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "13:45:00" , 
"departure_time" : "13:47:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:49:35" , 
"departure_time" : "13:51:10" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:51:35" , 
"departure_time" : "13:52:07" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:52:32" , 
"departure_time" : "13:53:04" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:54:32" , 
"departure_time" : "13:56:01" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:57:29" , 
"departure_time" : "13:58:19" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:58:50" , 
"departure_time" : "14:00:24" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:00:34" , 
"departure_time" : "14:01:56" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:03:22" , 
"departure_time" : "14:03:29" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "14:05:07" , 
"departure_time" : "14:06:41" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "14:07:34" , 
"departure_time" : "14:08:49" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "14:09:15" , 
"departure_time" : "14:10:43" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "14:11:28" , 
"departure_time" : "14:12:50" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "14:13:22" , 
"departure_time" : "14:14:25" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "14:16:03" , 
"departure_time" : "14:16:03" , 
"distance_traveled" : 9.0369
} ], 
"729" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "14:05:00" , 
"departure_time" : "14:07:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:09:22" , 
"departure_time" : "14:10:52" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:11:30" , 
"departure_time" : "14:13:08" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:13:38" , 
"departure_time" : "14:14:14" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:14:36" , 
"departure_time" : "14:15:30" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:16:54" , 
"departure_time" : "14:18:30" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:19:36" , 
"departure_time" : "14:20:16" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:19:40" , 
"departure_time" : "14:20:46" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:23:06" , 
"departure_time" : "14:23:55" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "14:25:49" , 
"departure_time" : "14:27:25" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "14:27:36" , 
"departure_time" : "14:28:02" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "14:28:26" , 
"departure_time" : "14:28:37" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "14:30:11" , 
"departure_time" : "14:30:35" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "14:32:24" , 
"departure_time" : "14:33:22" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "14:35:58" , 
"departure_time" : "14:35:58" , 
"distance_traveled" : 9.0369
} ], 
"730" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "14:25:00" , 
"departure_time" : "14:26:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:28:41" , 
"departure_time" : "14:29:57" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:31:16" , 
"departure_time" : "14:32:52" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:33:36" , 
"departure_time" : "14:35:14" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:35:38" , 
"departure_time" : "14:37:14" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:37:36" , 
"departure_time" : "14:38:24" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:38:48" , 
"departure_time" : "14:39:41" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:39:53" , 
"departure_time" : "14:41:03" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:43:10" , 
"departure_time" : "14:44:44" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "14:46:34" , 
"departure_time" : "14:47:12" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "14:46:38" , 
"departure_time" : "14:48:06" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "14:49:28" , 
"departure_time" : "14:50:11" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "14:50:43" , 
"departure_time" : "14:51:41" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "14:52:58" , 
"departure_time" : "14:53:45" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "14:55:47" , 
"departure_time" : "14:55:47" , 
"distance_traveled" : 9.0369
} ], 
"731" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "14:45:00" , 
"departure_time" : "14:47:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:49:20" , 
"departure_time" : "14:50:36" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:51:16" , 
"departure_time" : "14:51:29" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:52:13" , 
"departure_time" : "14:52:32" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:54:19" , 
"departure_time" : "14:54:47" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:56:28" , 
"departure_time" : "14:56:45" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:58:17" , 
"departure_time" : "14:58:47" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:59:30" , 
"departure_time" : "15:00:08" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:02:38" , 
"departure_time" : "15:03:04" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "15:05:26" , 
"departure_time" : "15:06:57" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "15:07:31" , 
"departure_time" : "15:07:34" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "15:08:03" , 
"departure_time" : "15:08:54" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "15:10:51" , 
"departure_time" : "15:12:07" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "15:13:16" , 
"departure_time" : "15:13:25" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "15:15:09" , 
"departure_time" : "15:15:09" , 
"distance_traveled" : 9.0369
} ], 
"732" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "15:05:00" , 
"departure_time" : "15:06:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:09:25" , 
"departure_time" : "15:10:51" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:11:26" , 
"departure_time" : "15:12:09" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:12:43" , 
"departure_time" : "15:13:01" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:14:18" , 
"departure_time" : "15:15:14" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:16:56" , 
"departure_time" : "15:17:00" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:18:04" , 
"departure_time" : "15:18:22" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:19:18" , 
"departure_time" : "15:19:40" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:22:22" , 
"departure_time" : "15:22:55" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "15:25:33" , 
"departure_time" : "15:26:04" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "15:26:31" , 
"departure_time" : "15:28:01" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "15:29:30" , 
"departure_time" : "15:29:54" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "15:30:24" , 
"departure_time" : "15:32:03" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "15:33:39" , 
"departure_time" : "15:33:54" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "15:35:15" , 
"departure_time" : "15:35:15" , 
"distance_traveled" : 9.0369
} ], 
"733" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "15:25:00" , 
"departure_time" : "15:25:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:28:01" , 
"departure_time" : "15:28:42" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:30:41" , 
"departure_time" : "15:31:07" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:32:26" , 
"departure_time" : "15:33:20" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:34:54" , 
"departure_time" : "15:36:05" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:37:11" , 
"departure_time" : "15:37:52" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:38:41" , 
"departure_time" : "15:39:19" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:39:38" , 
"departure_time" : "15:41:06" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:43:28" , 
"departure_time" : "15:44:24" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "15:45:56" , 
"departure_time" : "15:46:44" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "15:46:48" , 
"departure_time" : "15:47:40" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "15:48:52" , 
"departure_time" : "15:49:26" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "15:50:34" , 
"departure_time" : "15:51:31" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "15:52:57" , 
"departure_time" : "15:52:59" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "15:55:02" , 
"departure_time" : "15:55:02" , 
"distance_traveled" : 9.0369
} ], 
"734" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "15:45:00" , 
"departure_time" : "15:46:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:49:38" , 
"departure_time" : "15:50:52" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:51:14" , 
"departure_time" : "15:52:16" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:53:02" , 
"departure_time" : "15:53:17" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:54:15" , 
"departure_time" : "15:55:21" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:57:06" , 
"departure_time" : "15:57:31" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:58:25" , 
"departure_time" : "15:59:50" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:00:25" , 
"departure_time" : "16:01:50" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:03:25" , 
"departure_time" : "16:03:29" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "16:05:04" , 
"departure_time" : "16:06:12" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "16:07:08" , 
"departure_time" : "16:07:19" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "16:08:11" , 
"departure_time" : "16:08:46" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "16:10:35" , 
"departure_time" : "16:11:40" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "16:13:05" , 
"departure_time" : "16:14:33" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "16:16:28" , 
"departure_time" : "16:16:28" , 
"distance_traveled" : 9.0369
} ], 
"735" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "16:05:00" , 
"departure_time" : "16:07:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:08:52" , 
"departure_time" : "16:09:49" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:10:57" , 
"departure_time" : "16:11:13" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:12:16" , 
"departure_time" : "16:13:56" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:15:40" , 
"departure_time" : "16:16:40" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:17:00" , 
"departure_time" : "16:18:25" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:19:25" , 
"departure_time" : "16:20:28" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:20:03" , 
"departure_time" : "16:20:42" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:22:39" , 
"departure_time" : "16:24:12" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "16:26:33" , 
"departure_time" : "16:26:38" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "16:26:05" , 
"departure_time" : "16:26:49" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "16:28:44" , 
"departure_time" : "16:29:38" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "16:30:54" , 
"departure_time" : "16:32:09" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "16:33:15" , 
"departure_time" : "16:34:46" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "16:36:31" , 
"departure_time" : "16:36:31" , 
"distance_traveled" : 9.0369
} ], 
"736" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "16:25:00" , 
"departure_time" : "16:26:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:28:08" , 
"departure_time" : "16:29:46" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:31:38" , 
"departure_time" : "16:32:57" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:33:19" , 
"departure_time" : "16:34:12" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:34:53" , 
"departure_time" : "16:35:00" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:36:07" , 
"departure_time" : "16:36:35" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:38:28" , 
"departure_time" : "16:39:33" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:40:05" , 
"departure_time" : "16:41:07" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:43:02" , 
"departure_time" : "16:43:45" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "16:45:43" , 
"departure_time" : "16:45:55" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "16:46:12" , 
"departure_time" : "16:47:03" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "16:48:51" , 
"departure_time" : "16:49:57" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "16:51:06" , 
"departure_time" : "16:51:11" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "16:52:05" , 
"departure_time" : "16:52:27" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "16:55:22" , 
"departure_time" : "16:55:22" , 
"distance_traveled" : 9.0369
} ], 
"737" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "16:45:00" , 
"departure_time" : "16:46:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:49:24" , 
"departure_time" : "16:49:34" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:50:10" , 
"departure_time" : "16:51:42" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:53:32" , 
"departure_time" : "16:54:35" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:55:03" , 
"departure_time" : "16:56:16" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:57:13" , 
"departure_time" : "16:58:44" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:59:31" , 
"departure_time" : "16:59:49" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:59:18" , 
"departure_time" : "16:59:33" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:02:15" , 
"departure_time" : "17:03:34" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "17:06:19" , 
"departure_time" : "17:07:56" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "17:07:37" , 
"departure_time" : "17:09:11" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "17:09:34" , 
"departure_time" : "17:10:59" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "17:11:25" , 
"departure_time" : "17:12:47" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "17:13:22" , 
"departure_time" : "17:14:41" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "17:16:19" , 
"departure_time" : "17:16:19" , 
"distance_traveled" : 9.0369
} ], 
"738" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "17:05:00" , 
"departure_time" : "17:07:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:08:52" , 
"departure_time" : "17:09:01" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:10:09" , 
"departure_time" : "17:10:19" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:12:10" , 
"departure_time" : "17:12:57" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:14:47" , 
"departure_time" : "17:14:50" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:16:03" , 
"departure_time" : "17:16:16" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:18:13" , 
"departure_time" : "17:19:03" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:19:50" , 
"departure_time" : "17:21:17" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:23:27" , 
"departure_time" : "17:23:43" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "17:25:16" , 
"departure_time" : "17:25:30" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "17:26:14" , 
"departure_time" : "17:27:02" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "17:28:48" , 
"departure_time" : "17:30:14" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "17:31:26" , 
"departure_time" : "17:32:13" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "17:32:47" , 
"departure_time" : "17:33:48" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "17:36:01" , 
"departure_time" : "17:36:01" , 
"distance_traveled" : 9.0369
} ], 
"739" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "17:25:00" , 
"departure_time" : "17:26:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:28:13" , 
"departure_time" : "17:28:46" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:30:33" , 
"departure_time" : "17:30:56" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:32:23" , 
"departure_time" : "17:32:47" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:34:24" , 
"departure_time" : "17:35:34" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:37:10" , 
"departure_time" : "17:38:40" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:39:30" , 
"departure_time" : "17:40:02" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:39:32" , 
"departure_time" : "17:39:56" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:42:24" , 
"departure_time" : "17:42:51" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "17:45:27" , 
"departure_time" : "17:46:38" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "17:47:11" , 
"departure_time" : "17:47:40" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "17:48:29" , 
"departure_time" : "17:49:23" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "17:50:54" , 
"departure_time" : "17:51:59" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "17:53:05" , 
"departure_time" : "17:53:06" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "17:55:01" , 
"departure_time" : "17:55:01" , 
"distance_traveled" : 9.0369
} ], 
"740" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "17:45:00" , 
"departure_time" : "17:45:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:48:21" , 
"departure_time" : "17:49:34" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:51:13" , 
"departure_time" : "17:52:03" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:52:50" , 
"departure_time" : "17:54:23" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:55:33" , 
"departure_time" : "17:57:12" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:57:39" , 
"departure_time" : "17:59:05" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:59:26" , 
"departure_time" : "17:59:28" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:59:02" , 
"departure_time" : "17:59:41" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:02:39" , 
"departure_time" : "18:03:48" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "18:06:09" , 
"departure_time" : "18:07:48" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "18:07:39" , 
"departure_time" : "18:08:16" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "18:08:37" , 
"departure_time" : "18:09:13" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "18:10:36" , 
"departure_time" : "18:11:51" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "18:13:15" , 
"departure_time" : "18:14:18" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "18:16:03" , 
"departure_time" : "18:16:03" , 
"distance_traveled" : 9.0369
} ], 
"741" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "18:05:00" , 
"departure_time" : "18:06:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:08:21" , 
"departure_time" : "18:09:52" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:11:31" , 
"departure_time" : "18:12:24" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:12:53" , 
"departure_time" : "18:13:21" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:14:28" , 
"departure_time" : "18:15:56" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:17:28" , 
"departure_time" : "18:18:32" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:19:04" , 
"departure_time" : "18:19:27" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:19:23" , 
"departure_time" : "18:19:37" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:22:14" , 
"departure_time" : "18:23:54" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "18:26:40" , 
"departure_time" : "18:28:03" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "18:27:23" , 
"departure_time" : "18:28:06" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "18:28:43" , 
"departure_time" : "18:30:09" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "18:31:26" , 
"departure_time" : "18:32:15" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "18:32:49" , 
"departure_time" : "18:33:36" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "18:35:47" , 
"departure_time" : "18:35:47" , 
"distance_traveled" : 9.0369
} ], 
"742" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "18:25:00" , 
"departure_time" : "18:26:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:28:48" , 
"departure_time" : "18:30:27" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:31:39" , 
"departure_time" : "18:32:12" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:32:33" , 
"departure_time" : "18:34:13" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:35:40" , 
"departure_time" : "18:36:02" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:36:22" , 
"departure_time" : "18:37:10" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:38:48" , 
"departure_time" : "18:40:06" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:40:18" , 
"departure_time" : "18:41:05" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:42:47" , 
"departure_time" : "18:43:59" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "18:46:12" , 
"departure_time" : "18:46:37" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "18:46:25" , 
"departure_time" : "18:46:31" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "18:48:06" , 
"departure_time" : "18:49:32" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "18:51:26" , 
"departure_time" : "18:52:46" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "18:53:20" , 
"departure_time" : "18:53:33" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "18:55:13" , 
"departure_time" : "18:55:13" , 
"distance_traveled" : 9.0369
} ], 
"743" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "18:45:00" , 
"departure_time" : "18:45:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:48:23" , 
"departure_time" : "18:49:23" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:51:00" , 
"departure_time" : "18:52:39" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:53:39" , 
"departure_time" : "18:55:17" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:55:38" , 
"departure_time" : "18:56:25" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:56:47" , 
"departure_time" : "18:57:44" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:58:57" , 
"departure_time" : "19:00:24" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:00:27" , 
"departure_time" : "19:00:35" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:02:08" , 
"departure_time" : "19:02:27" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "19:05:19" , 
"departure_time" : "19:05:26" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "19:06:07" , 
"departure_time" : "19:07:13" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "19:09:06" , 
"departure_time" : "19:09:57" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "19:10:51" , 
"departure_time" : "19:11:26" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "19:12:35" , 
"departure_time" : "19:13:10" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "19:15:35" , 
"departure_time" : "19:15:35" , 
"distance_traveled" : 9.0369
} ], 
"744" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "19:05:00" , 
"departure_time" : "19:06:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:09:02" , 
"departure_time" : "19:09:05" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:10:03" , 
"departure_time" : "19:10:29" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:12:26" , 
"departure_time" : "19:12:33" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:14:07" , 
"departure_time" : "19:15:07" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:17:00" , 
"departure_time" : "19:18:01" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:19:01" , 
"departure_time" : "19:20:30" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:20:29" , 
"departure_time" : "19:20:40" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:22:11" , 
"departure_time" : "19:23:51" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "19:26:40" , 
"departure_time" : "19:26:54" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "19:26:14" , 
"departure_time" : "19:27:03" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "19:28:49" , 
"departure_time" : "19:28:51" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "19:30:02" , 
"departure_time" : "19:31:07" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "19:33:05" , 
"departure_time" : "19:33:22" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "19:35:17" , 
"departure_time" : "19:35:17" , 
"distance_traveled" : 9.0369
} ], 
"745" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "19:25:00" , 
"departure_time" : "19:25:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:28:17" , 
"departure_time" : "19:29:17" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:31:00" , 
"departure_time" : "19:31:01" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:32:01" , 
"departure_time" : "19:32:10" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:34:09" , 
"departure_time" : "19:34:28" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:36:19" , 
"departure_time" : "19:36:31" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:38:12" , 
"departure_time" : "19:39:40" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:40:28" , 
"departure_time" : "19:41:30" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:43:02" , 
"departure_time" : "19:43:19" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "19:45:17" , 
"departure_time" : "19:46:41" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "19:47:24" , 
"departure_time" : "19:47:34" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "19:48:10" , 
"departure_time" : "19:49:30" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "19:51:20" , 
"departure_time" : "19:52:40" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "19:53:20" , 
"departure_time" : "19:54:27" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "19:56:07" , 
"departure_time" : "19:56:07" , 
"distance_traveled" : 9.0369
} ], 
"746" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "19:45:00" , 
"departure_time" : "19:47:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:49:14" , 
"departure_time" : "19:49:53" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:50:39" , 
"departure_time" : "19:51:21" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:52:42" , 
"departure_time" : "19:54:09" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:55:27" , 
"departure_time" : "19:56:27" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:57:00" , 
"departure_time" : "19:58:04" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:59:04" , 
"departure_time" : "20:00:42" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:00:38" , 
"departure_time" : "20:01:22" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:02:44" , 
"departure_time" : "20:03:01" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "20:05:17" , 
"departure_time" : "20:05:57" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "20:06:40" , 
"departure_time" : "20:07:18" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "20:08:38" , 
"departure_time" : "20:09:28" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "20:10:50" , 
"departure_time" : "20:11:28" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "20:12:38" , 
"departure_time" : "20:14:14" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "20:16:36" , 
"departure_time" : "20:16:36" , 
"distance_traveled" : 9.0369
} ], 
"747" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "20:05:00" , 
"departure_time" : "20:07:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:08:45" , 
"departure_time" : "20:10:20" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:11:35" , 
"departure_time" : "20:12:38" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:13:03" , 
"departure_time" : "20:14:18" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:15:15" , 
"departure_time" : "20:16:40" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:17:25" , 
"departure_time" : "20:18:52" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:19:27" , 
"departure_time" : "20:20:08" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:19:41" , 
"departure_time" : "20:21:08" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:23:27" , 
"departure_time" : "20:24:38" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "20:26:11" , 
"departure_time" : "20:26:25" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "20:26:14" , 
"departure_time" : "20:26:22" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "20:28:08" , 
"departure_time" : "20:29:27" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "20:31:19" , 
"departure_time" : "20:32:54" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "20:33:35" , 
"departure_time" : "20:34:45" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "20:36:10" , 
"departure_time" : "20:36:10" , 
"distance_traveled" : 9.0369
} ], 
"748" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "20:25:00" , 
"departure_time" : "20:26:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:28:10" , 
"departure_time" : "20:28:58" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:30:48" , 
"departure_time" : "20:31:07" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:32:19" , 
"departure_time" : "20:33:35" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:35:16" , 
"departure_time" : "20:36:03" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:36:47" , 
"departure_time" : "20:38:13" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:39:26" , 
"departure_time" : "20:40:51" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:40:25" , 
"departure_time" : "20:41:38" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:43:13" , 
"departure_time" : "20:44:27" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "20:46:14" , 
"departure_time" : "20:47:33" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "20:47:19" , 
"departure_time" : "20:48:12" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "20:48:53" , 
"departure_time" : "20:49:46" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "20:50:53" , 
"departure_time" : "20:51:23" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "20:52:30" , 
"departure_time" : "20:52:41" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "20:55:11" , 
"departure_time" : "20:55:11" , 
"distance_traveled" : 9.0369
} ], 
"749" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "20:45:00" , 
"departure_time" : "20:45:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:48:30" , 
"departure_time" : "20:49:03" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:50:33" , 
"departure_time" : "20:51:55" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:53:22" , 
"departure_time" : "20:54:51" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:55:29" , 
"departure_time" : "20:57:08" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:57:39" , 
"departure_time" : "20:58:12" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:58:33" , 
"departure_time" : "20:59:15" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:59:42" , 
"departure_time" : "21:01:02" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:03:20" , 
"departure_time" : "21:04:33" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "21:06:13" , 
"departure_time" : "21:06:40" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "21:06:27" , 
"departure_time" : "21:07:05" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "21:08:38" , 
"departure_time" : "21:09:58" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "21:11:20" , 
"departure_time" : "21:11:32" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "21:12:12" , 
"departure_time" : "21:13:16" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "21:16:04" , 
"departure_time" : "21:16:04" , 
"distance_traveled" : 9.0369
} ], 
"750" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "21:05:00" , 
"departure_time" : "21:06:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:08:25" , 
"departure_time" : "21:08:43" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:10:18" , 
"departure_time" : "21:10:57" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:12:39" , 
"departure_time" : "21:12:47" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "21:14:08" , 
"departure_time" : "21:15:07" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:16:59" , 
"departure_time" : "21:18:03" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "21:19:04" , 
"departure_time" : "21:20:01" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "21:19:57" , 
"departure_time" : "21:20:45" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:22:48" , 
"departure_time" : "21:24:23" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "21:26:35" , 
"departure_time" : "21:27:56" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "21:27:21" , 
"departure_time" : "21:27:29" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "21:28:08" , 
"departure_time" : "21:28:48" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "21:30:40" , 
"departure_time" : "21:30:59" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "21:32:19" , 
"departure_time" : "21:32:34" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "21:35:15" , 
"departure_time" : "21:35:15" , 
"distance_traveled" : 9.0369
} ], 
"751" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "21:25:00" , 
"departure_time" : "21:26:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:29:11" , 
"departure_time" : "21:30:23" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:31:12" , 
"departure_time" : "21:31:22" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:32:10" , 
"departure_time" : "21:32:37" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "21:34:27" , 
"departure_time" : "21:35:53" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:37:26" , 
"departure_time" : "21:38:10" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "21:38:44" , 
"departure_time" : "21:39:21" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "21:39:37" , 
"departure_time" : "21:40:52" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:43:15" , 
"departure_time" : "21:43:30" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "21:45:15" , 
"departure_time" : "21:45:51" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "21:46:36" , 
"departure_time" : "21:47:48" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "21:49:12" , 
"departure_time" : "21:49:19" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "21:50:07" , 
"departure_time" : "21:50:45" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "21:52:38" , 
"departure_time" : "21:53:27" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "21:55:49" , 
"departure_time" : "21:55:49" , 
"distance_traveled" : 9.0369
} ], 
"752" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "21:45:00" , 
"departure_time" : "21:47:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:49:18" , 
"departure_time" : "21:50:39" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:51:21" , 
"departure_time" : "21:51:22" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:52:01" , 
"departure_time" : "21:52:03" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "21:54:02" , 
"departure_time" : "21:54:54" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:56:52" , 
"departure_time" : "21:57:46" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "21:58:54" , 
"departure_time" : "22:00:22" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:00:28" , 
"departure_time" : "22:01:26" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:02:58" , 
"departure_time" : "22:03:39" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "22:05:41" , 
"departure_time" : "22:07:20" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "22:07:39" , 
"departure_time" : "22:09:00" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "22:09:21" , 
"departure_time" : "22:09:43" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "22:10:22" , 
"departure_time" : "22:10:35" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "22:12:13" , 
"departure_time" : "22:13:02" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "22:15:49" , 
"departure_time" : "22:15:49" , 
"distance_traveled" : 9.0369
} ], 
"753" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "22:05:00" , 
"departure_time" : "22:06:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:09:04" , 
"departure_time" : "22:10:18" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:11:14" , 
"departure_time" : "22:11:24" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:12:10" , 
"departure_time" : "22:12:47" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:14:37" , 
"departure_time" : "22:15:07" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:16:30" , 
"departure_time" : "22:17:20" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:18:50" , 
"departure_time" : "22:19:55" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:20:05" , 
"departure_time" : "22:20:20" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:22:15" , 
"departure_time" : "22:22:25" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "22:25:10" , 
"departure_time" : "22:25:44" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "22:26:34" , 
"departure_time" : "22:27:04" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "22:28:30" , 
"departure_time" : "22:30:05" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "22:31:35" , 
"departure_time" : "22:33:09" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "22:33:34" , 
"departure_time" : "22:35:03" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "22:36:29" , 
"departure_time" : "22:36:29" , 
"distance_traveled" : 9.0369
} ], 
"754" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "22:25:00" , 
"departure_time" : "22:27:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:29:20" , 
"departure_time" : "22:30:23" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:31:03" , 
"departure_time" : "22:32:36" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:33:33" , 
"departure_time" : "22:34:03" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:34:30" , 
"departure_time" : "22:35:27" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:36:57" , 
"departure_time" : "22:37:14" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:38:17" , 
"departure_time" : "22:38:54" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:39:37" , 
"departure_time" : "22:40:22" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:42:45" , 
"departure_time" : "22:43:10" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "22:45:25" , 
"departure_time" : "22:46:08" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "22:46:43" , 
"departure_time" : "22:47:29" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "22:48:46" , 
"departure_time" : "22:49:10" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "22:50:24" , 
"departure_time" : "22:51:33" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "22:53:09" , 
"departure_time" : "22:53:38" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "22:55:29" , 
"departure_time" : "22:55:29" , 
"distance_traveled" : 9.0369
} ], 
"755" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "22:45:00" , 
"departure_time" : "22:46:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:49:19" , 
"departure_time" : "22:50:12" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:50:53" , 
"departure_time" : "22:51:28" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:52:35" , 
"departure_time" : "22:52:56" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:54:21" , 
"departure_time" : "22:54:52" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:56:31" , 
"departure_time" : "22:57:17" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:58:46" , 
"departure_time" : "22:59:26" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:59:40" , 
"departure_time" : "23:00:13" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:02:33" , 
"departure_time" : "23:03:07" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "23:05:34" , 
"departure_time" : "23:06:39" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "23:07:05" , 
"departure_time" : "23:07:24" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "23:08:19" , 
"departure_time" : "23:09:57" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "23:11:38" , 
"departure_time" : "23:12:02" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "23:12:24" , 
"departure_time" : "23:13:39" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "23:16:15" , 
"departure_time" : "23:16:15" , 
"distance_traveled" : 9.0369
} ], 
"756" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "23:05:00" , 
"departure_time" : "23:07:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:08:58" , 
"departure_time" : "23:09:30" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:10:32" , 
"departure_time" : "23:11:38" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:13:06" , 
"departure_time" : "23:13:36" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:14:30" , 
"departure_time" : "23:15:35" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:17:05" , 
"departure_time" : "23:18:40" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "23:19:35" , 
"departure_time" : "23:20:39" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:20:04" , 
"departure_time" : "23:20:07" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:22:03" , 
"departure_time" : "23:23:20" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "23:26:17" , 
"departure_time" : "23:27:21" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "23:27:04" , 
"departure_time" : "23:27:19" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "23:28:15" , 
"departure_time" : "23:29:08" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "23:30:53" , 
"departure_time" : "23:31:59" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "23:33:06" , 
"departure_time" : "23:33:29" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "23:35:23" , 
"departure_time" : "23:35:23" , 
"distance_traveled" : 9.0369
} ], 
"757" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "23:25:00" , 
"departure_time" : "23:26:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:28:55" , 
"departure_time" : "23:29:34" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:30:39" , 
"departure_time" : "23:30:54" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:32:15" , 
"departure_time" : "23:32:23" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:34:08" , 
"departure_time" : "23:34:33" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:36:25" , 
"departure_time" : "23:37:41" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "23:39:16" , 
"departure_time" : "23:39:41" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:39:25" , 
"departure_time" : "23:40:24" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:42:59" , 
"departure_time" : "23:44:23" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "23:46:24" , 
"departure_time" : "23:46:25" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "23:46:01" , 
"departure_time" : "23:47:40" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "23:49:39" , 
"departure_time" : "23:51:08" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "23:51:29" , 
"departure_time" : "23:51:34" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "23:52:05" , 
"departure_time" : "23:52:53" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "23:55:48" , 
"departure_time" : "23:55:48" , 
"distance_traveled" : 9.0369
} ], 
"758" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "23:45:00" , 
"departure_time" : "23:46:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:48:28" , 
"departure_time" : "23:49:27" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:50:59" , 
"departure_time" : "23:51:24" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:52:25" , 
"departure_time" : "23:53:04" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:54:39" , 
"departure_time" : "23:55:58" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:57:19" , 
"departure_time" : "23:57:41" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "23:58:22" , 
"departure_time" : "23:58:50" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:59:28" , 
"departure_time" : "24:00:04" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "24:02:36" , 
"departure_time" : "24:03:59" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "24:06:23" , 
"departure_time" : "24:07:33" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "24:07:10" , 
"departure_time" : "24:07:34" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "24:08:24" , 
"departure_time" : "24:08:28" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "24:10:04" , 
"departure_time" : "24:10:41" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "24:12:37" , 
"departure_time" : "24:13:19" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "24:15:42" , 
"departure_time" : "24:15:42" , 
"distance_traveled" : 9.0369
} ], 
"759" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "24:05:00" , 
"departure_time" : "24:07:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "24:09:31" , 
"departure_time" : "24:09:58" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "24:10:27" , 
"departure_time" : "24:11:53" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "24:13:26" , 
"departure_time" : "24:14:56" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "24:15:30" , 
"departure_time" : "24:15:36" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "24:16:06" , 
"departure_time" : "24:17:20" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "24:19:14" , 
"departure_time" : "24:20:28" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "24:20:14" , 
"departure_time" : "24:20:36" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "24:22:22" , 
"departure_time" : "24:22:37" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "24:25:15" , 
"departure_time" : "24:25:59" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "24:26:44" , 
"departure_time" : "24:27:51" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "24:29:07" , 
"departure_time" : "24:29:32" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "24:30:25" , 
"departure_time" : "24:31:31" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "24:33:06" , 
"departure_time" : "24:33:29" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "24:35:23" , 
"departure_time" : "24:35:23" , 
"distance_traveled" : 9.0369
} ], 
"760" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "24:35:00" , 
"departure_time" : "24:36:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "24:38:55" , 
"departure_time" : "24:39:11" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "24:40:16" , 
"departure_time" : "24:40:31" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "24:42:15" , 
"departure_time" : "24:42:22" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "24:44:07" , 
"departure_time" : "24:45:27" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "24:47:20" , 
"departure_time" : "24:47:47" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "24:48:27" , 
"departure_time" : "24:49:02" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "24:49:35" , 
"departure_time" : "24:49:36" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "24:52:01" , 
"departure_time" : "24:52:34" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "24:55:33" , 
"departure_time" : "24:55:49" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "24:56:16" , 
"departure_time" : "24:56:56" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "24:58:40" , 
"departure_time" : "24:59:17" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "25:00:37" , 
"departure_time" : "25:01:52" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "25:03:15" , 
"departure_time" : "25:03:45" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "25:05:30" , 
"departure_time" : "25:05:30" , 
"distance_traveled" : 9.0369
} ], 
"761" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "25:05:00" , 
"departure_time" : "25:07:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "25:09:36" , 
"departure_time" : "25:11:15" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "25:11:39" , 
"departure_time" : "25:12:34" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "25:12:55" , 
"departure_time" : "25:13:22" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "25:14:27" , 
"departure_time" : "25:15:04" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "25:16:37" , 
"departure_time" : "25:17:21" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "25:18:44" , 
"departure_time" : "25:20:08" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "25:20:24" , 
"departure_time" : "25:21:20" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "25:22:56" , 
"departure_time" : "25:24:16" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "25:26:20" , 
"departure_time" : "25:26:29" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "25:26:09" , 
"departure_time" : "25:27:13" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "25:29:04" , 
"departure_time" : "25:30:23" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "25:31:19" , 
"departure_time" : "25:31:24" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "25:32:05" , 
"departure_time" : "25:32:18" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "25:35:13" , 
"departure_time" : "25:35:13" , 
"distance_traveled" : 9.0369
} ], 
"762" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "25:35:00" , 
"departure_time" : "25:36:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "25:39:13" , 
"departure_time" : "25:40:24" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "25:41:11" , 
"departure_time" : "25:42:08" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "25:42:57" , 
"departure_time" : "25:44:19" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "25:45:22" , 
"departure_time" : "25:46:21" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "25:46:59" , 
"departure_time" : "25:47:13" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "25:48:14" , 
"departure_time" : "25:49:30" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "25:50:16" , 
"departure_time" : "25:51:16" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "25:53:00" , 
"departure_time" : "25:53:17" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "25:55:17" , 
"departure_time" : "25:55:34" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "25:56:17" , 
"departure_time" : "25:56:58" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "25:58:41" , 
"departure_time" : "26:00:15" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "26:01:34" , 
"departure_time" : "26:02:44" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "26:03:10" , 
"departure_time" : "26:03:32" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "26:05:22" , 
"departure_time" : "26:05:22" , 
"distance_traveled" : 9.0369
} ], 
"763" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "26:05:00" , 
"departure_time" : "26:06:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "26:09:31" , 
"departure_time" : "26:10:49" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "26:11:18" , 
"departure_time" : "26:11:39" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "26:12:21" , 
"departure_time" : "26:12:50" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "26:14:29" , 
"departure_time" : "26:15:26" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "26:16:57" , 
"departure_time" : "26:17:15" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "26:18:18" , 
"departure_time" : "26:19:22" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "26:20:04" , 
"departure_time" : "26:21:26" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "26:23:22" , 
"departure_time" : "26:24:38" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "26:26:16" , 
"departure_time" : "26:26:28" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "26:26:12" , 
"departure_time" : "26:26:49" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "26:28:37" , 
"departure_time" : "26:29:54" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "26:31:17" , 
"departure_time" : "26:32:34" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "26:33:17" , 
"departure_time" : "26:33:57" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "26:35:40" , 
"departure_time" : "26:35:40" , 
"distance_traveled" : 9.0369
} ], 
"764" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "05:36:00" , 
"departure_time" : "05:37:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "05:38:50" , 
"departure_time" : "05:40:24" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "05:41:34" , 
"departure_time" : "05:42:32" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "05:43:58" , 
"departure_time" : "05:44:21" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "05:46:23" , 
"departure_time" : "05:46:28" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "05:47:05" , 
"departure_time" : "05:47:24" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "05:53:19" , 
"departure_time" : "05:53:32" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "05:55:13" , 
"departure_time" : "05:56:14" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "05:58:01" , 
"departure_time" : "05:58:11" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "05:59:10" , 
"departure_time" : "05:59:19" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:01:09" , 
"departure_time" : "06:02:08" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:03:59" , 
"departure_time" : "06:05:05" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:05:06" , 
"departure_time" : "06:06:01" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:07:55" , 
"departure_time" : "06:09:15" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "06:11:20" , 
"departure_time" : "06:11:23" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "06:12:03" , 
"departure_time" : "06:12:18" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "06:14:15" , 
"departure_time" : "06:14:15" , 
"distance_traveled" : 10.0589
} ], 
"765" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "05:56:00" , 
"departure_time" : "05:56:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "05:58:13" , 
"departure_time" : "05:58:34" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "06:00:21" , 
"departure_time" : "06:01:34" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "06:04:13" , 
"departure_time" : "06:04:52" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "06:06:39" , 
"departure_time" : "06:08:13" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "06:08:34" , 
"departure_time" : "06:08:39" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:13:05" , 
"departure_time" : "06:14:06" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:16:01" , 
"departure_time" : "06:17:41" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:18:40" , 
"departure_time" : "06:19:00" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:19:20" , 
"departure_time" : "06:20:47" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:22:27" , 
"departure_time" : "06:22:36" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:23:09" , 
"departure_time" : "06:23:13" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:24:04" , 
"departure_time" : "06:24:29" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:27:25" , 
"departure_time" : "06:28:09" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "06:30:44" , 
"departure_time" : "06:32:05" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "06:33:21" , 
"departure_time" : "06:33:58" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "06:34:37" , 
"departure_time" : "06:34:37" , 
"distance_traveled" : 10.0589
} ], 
"766" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "06:16:00" , 
"departure_time" : "06:16:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "06:18:17" , 
"departure_time" : "06:19:36" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "06:21:19" , 
"departure_time" : "06:21:48" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "06:23:29" , 
"departure_time" : "06:24:44" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "06:27:15" , 
"departure_time" : "06:28:06" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "06:27:51" , 
"departure_time" : "06:28:04" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:33:13" , 
"departure_time" : "06:34:25" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:36:12" , 
"departure_time" : "06:36:15" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:37:03" , 
"departure_time" : "06:38:25" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:40:22" , 
"departure_time" : "06:40:46" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:41:24" , 
"departure_time" : "06:41:39" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:43:15" , 
"departure_time" : "06:44:03" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:44:48" , 
"departure_time" : "06:45:08" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:47:20" , 
"departure_time" : "06:47:32" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "06:50:12" , 
"departure_time" : "06:51:21" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "06:53:09" , 
"departure_time" : "06:54:17" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "06:55:08" , 
"departure_time" : "06:55:08" , 
"distance_traveled" : 10.0589
} ], 
"767" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "06:36:00" , 
"departure_time" : "06:37:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "06:38:04" , 
"departure_time" : "06:39:43" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "06:41:39" , 
"departure_time" : "06:42:24" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "06:43:45" , 
"departure_time" : "06:43:49" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "06:46:04" , 
"departure_time" : "06:47:31" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "06:48:27" , 
"departure_time" : "06:50:04" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:54:37" , 
"departure_time" : "06:56:08" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:56:31" , 
"departure_time" : "06:57:49" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:58:18" , 
"departure_time" : "06:59:00" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:59:42" , 
"departure_time" : "07:00:47" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:02:05" , 
"departure_time" : "07:03:32" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:04:27" , 
"departure_time" : "07:05:57" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:05:30" , 
"departure_time" : "07:05:31" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:07:01" , 
"departure_time" : "07:08:37" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "07:11:36" , 
"departure_time" : "07:11:57" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "07:12:21" , 
"departure_time" : "07:13:40" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "07:15:19" , 
"departure_time" : "07:15:19" , 
"distance_traveled" : 10.0589
} ], 
"768" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "06:56:00" , 
"departure_time" : "06:58:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "06:58:45" , 
"departure_time" : "06:59:40" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "07:00:55" , 
"departure_time" : "07:01:32" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "07:03:37" , 
"departure_time" : "07:04:58" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "07:07:21" , 
"departure_time" : "07:07:30" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:07:09" , 
"departure_time" : "07:08:33" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:14:24" , 
"departure_time" : "07:14:53" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:15:29" , 
"departure_time" : "07:16:47" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:18:18" , 
"departure_time" : "07:18:36" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:19:18" , 
"departure_time" : "07:19:54" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:21:36" , 
"departure_time" : "07:22:57" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:24:21" , 
"departure_time" : "07:25:57" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:25:36" , 
"departure_time" : "07:26:10" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:27:34" , 
"departure_time" : "07:28:12" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "07:30:38" , 
"departure_time" : "07:31:49" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "07:33:11" , 
"departure_time" : "07:34:25" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "07:35:14" , 
"departure_time" : "07:35:14" , 
"distance_traveled" : 10.0589
} ], 
"769" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "07:16:00" , 
"departure_time" : "07:17:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:18:04" , 
"departure_time" : "07:19:43" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "07:21:39" , 
"departure_time" : "07:21:56" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "07:23:17" , 
"departure_time" : "07:24:53" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "07:27:36" , 
"departure_time" : "07:29:12" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:28:36" , 
"departure_time" : "07:30:05" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:34:29" , 
"departure_time" : "07:34:43" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:35:14" , 
"departure_time" : "07:35:49" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:37:35" , 
"departure_time" : "07:37:50" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:39:15" , 
"departure_time" : "07:39:31" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:41:16" , 
"departure_time" : "07:41:25" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:43:09" , 
"departure_time" : "07:43:39" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:44:30" , 
"departure_time" : "07:44:36" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:47:06" , 
"departure_time" : "07:48:37" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "07:51:31" , 
"departure_time" : "07:51:46" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "07:52:15" , 
"departure_time" : "07:52:54" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "07:54:39" , 
"departure_time" : "07:54:39" , 
"distance_traveled" : 10.0589
} ], 
"770" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "07:36:00" , 
"departure_time" : "07:37:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:38:37" , 
"departure_time" : "07:39:58" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "07:41:21" , 
"departure_time" : "07:41:58" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "07:43:37" , 
"departure_time" : "07:44:02" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "07:46:25" , 
"departure_time" : "07:46:49" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:47:24" , 
"departure_time" : "07:47:50" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:53:26" , 
"departure_time" : "07:53:52" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:55:26" , 
"departure_time" : "07:56:58" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:58:32" , 
"departure_time" : "07:59:05" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:59:33" , 
"departure_time" : "08:00:35" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:02:02" , 
"departure_time" : "08:03:31" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:04:29" , 
"departure_time" : "08:05:26" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:04:57" , 
"departure_time" : "08:06:10" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:08:13" , 
"departure_time" : "08:09:18" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "08:11:05" , 
"departure_time" : "08:11:07" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "08:12:02" , 
"departure_time" : "08:12:07" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "08:14:05" , 
"departure_time" : "08:14:05" , 
"distance_traveled" : 10.0589
} ], 
"771" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "07:56:00" , 
"departure_time" : "07:57:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:59:36" , 
"departure_time" : "08:00:12" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:00:36" , 
"departure_time" : "08:01:32" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:03:56" , 
"departure_time" : "08:05:16" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:07:20" , 
"departure_time" : "08:07:41" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:07:21" , 
"departure_time" : "08:07:55" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:13:34" , 
"departure_time" : "08:14:49" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:16:15" , 
"departure_time" : "08:17:35" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:18:20" , 
"departure_time" : "08:18:29" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:19:09" , 
"departure_time" : "08:19:43" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:21:34" , 
"departure_time" : "08:23:01" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:24:27" , 
"departure_time" : "08:26:05" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:25:38" , 
"departure_time" : "08:27:18" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:28:40" , 
"departure_time" : "08:30:02" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "08:31:22" , 
"departure_time" : "08:32:53" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "08:33:31" , 
"departure_time" : "08:33:58" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "08:34:27" , 
"departure_time" : "08:34:27" , 
"distance_traveled" : 10.0589
} ], 
"772" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "08:16:00" , 
"departure_time" : "08:17:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:19:27" , 
"departure_time" : "08:19:51" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:20:24" , 
"departure_time" : "08:20:38" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:23:14" , 
"departure_time" : "08:24:26" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:27:12" , 
"departure_time" : "08:27:29" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:27:17" , 
"departure_time" : "08:27:49" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:33:32" , 
"departure_time" : "08:34:27" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:35:55" , 
"departure_time" : "08:36:40" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:37:45" , 
"departure_time" : "08:38:19" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:39:34" , 
"departure_time" : "08:39:42" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:41:08" , 
"departure_time" : "08:41:36" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:43:28" , 
"departure_time" : "08:44:03" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:44:35" , 
"departure_time" : "08:45:30" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:47:55" , 
"departure_time" : "08:48:20" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "08:50:25" , 
"departure_time" : "08:50:31" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "08:52:06" , 
"departure_time" : "08:53:34" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "08:55:28" , 
"departure_time" : "08:55:28" , 
"distance_traveled" : 10.0589
} ], 
"773" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "08:36:00" , 
"departure_time" : "08:37:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:38:16" , 
"departure_time" : "08:39:36" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:41:20" , 
"departure_time" : "08:42:37" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:44:17" , 
"departure_time" : "08:44:40" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:46:23" , 
"departure_time" : "08:46:42" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:47:19" , 
"departure_time" : "08:47:45" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:53:26" , 
"departure_time" : "08:53:40" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:55:14" , 
"departure_time" : "08:56:48" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:58:34" , 
"departure_time" : "08:59:53" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:00:19" , 
"departure_time" : "09:00:29" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:01:10" , 
"departure_time" : "09:02:03" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:03:53" , 
"departure_time" : "09:05:26" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:05:33" , 
"departure_time" : "09:06:18" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:07:45" , 
"departure_time" : "09:07:58" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "09:10:13" , 
"departure_time" : "09:11:33" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "09:13:20" , 
"departure_time" : "09:14:22" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "09:15:02" , 
"departure_time" : "09:15:02" , 
"distance_traveled" : 10.0589
} ], 
"774" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "08:56:00" , 
"departure_time" : "08:58:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:59:11" , 
"departure_time" : "09:00:15" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "09:01:04" , 
"departure_time" : "09:02:33" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "09:04:29" , 
"departure_time" : "09:05:23" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:06:54" , 
"departure_time" : "09:07:41" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "09:07:47" , 
"departure_time" : "09:08:01" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:13:14" , 
"departure_time" : "09:13:43" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:15:29" , 
"departure_time" : "09:17:06" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:18:37" , 
"departure_time" : "09:19:32" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:19:55" , 
"departure_time" : "09:21:32" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:22:37" , 
"departure_time" : "09:23:10" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:23:33" , 
"departure_time" : "09:25:12" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:25:39" , 
"departure_time" : "09:25:53" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:27:14" , 
"departure_time" : "09:27:27" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "09:30:13" , 
"departure_time" : "09:30:46" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "09:32:33" , 
"departure_time" : "09:33:51" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "09:35:18" , 
"departure_time" : "09:35:18" , 
"distance_traveled" : 10.0589
} ], 
"775" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "09:16:00" , 
"departure_time" : "09:18:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "09:19:33" , 
"departure_time" : "09:20:22" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "09:20:49" , 
"departure_time" : "09:21:19" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "09:23:30" , 
"departure_time" : "09:23:52" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:26:22" , 
"departure_time" : "09:27:58" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "09:28:36" , 
"departure_time" : "09:29:44" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:34:08" , 
"departure_time" : "09:35:42" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:36:34" , 
"departure_time" : "09:37:52" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:38:18" , 
"departure_time" : "09:39:33" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:40:15" , 
"departure_time" : "09:40:50" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:41:35" , 
"departure_time" : "09:42:06" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:43:31" , 
"departure_time" : "09:44:56" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:45:25" , 
"departure_time" : "09:46:19" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:47:54" , 
"departure_time" : "09:49:28" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "09:51:34" , 
"departure_time" : "09:52:22" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "09:52:48" , 
"departure_time" : "09:53:28" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "09:54:40" , 
"departure_time" : "09:54:40" , 
"distance_traveled" : 10.0589
} ], 
"776" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "09:36:00" , 
"departure_time" : "09:37:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "09:39:01" , 
"departure_time" : "09:40:16" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "09:41:15" , 
"departure_time" : "09:42:26" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "09:44:11" , 
"departure_time" : "09:44:56" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:46:45" , 
"departure_time" : "09:47:41" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "09:47:56" , 
"departure_time" : "09:48:14" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:53:18" , 
"departure_time" : "09:54:34" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:56:16" , 
"departure_time" : "09:56:46" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:57:30" , 
"departure_time" : "09:58:19" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:59:49" , 
"departure_time" : "10:01:18" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:02:29" , 
"departure_time" : "10:03:11" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:03:42" , 
"departure_time" : "10:04:08" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:04:26" , 
"departure_time" : "10:04:55" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:07:29" , 
"departure_time" : "10:08:53" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "10:11:24" , 
"departure_time" : "10:12:32" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "10:13:08" , 
"departure_time" : "10:13:37" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "10:14:29" , 
"departure_time" : "10:14:29" , 
"distance_traveled" : 10.0589
} ], 
"777" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "09:56:00" , 
"departure_time" : "09:58:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "09:59:35" , 
"departure_time" : "09:59:59" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "10:00:24" , 
"departure_time" : "10:00:44" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "10:03:20" , 
"departure_time" : "10:04:15" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "10:06:55" , 
"departure_time" : "10:07:58" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "10:08:03" , 
"departure_time" : "10:09:29" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:14:26" , 
"departure_time" : "10:15:12" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:15:46" , 
"departure_time" : "10:17:02" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:18:16" , 
"departure_time" : "10:18:36" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:19:20" , 
"departure_time" : "10:19:25" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:21:05" , 
"departure_time" : "10:21:33" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:23:28" , 
"departure_time" : "10:24:10" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:24:42" , 
"departure_time" : "10:25:40" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:27:58" , 
"departure_time" : "10:29:37" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "10:31:39" , 
"departure_time" : "10:32:39" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "10:33:00" , 
"departure_time" : "10:34:24" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "10:35:24" , 
"departure_time" : "10:35:24" , 
"distance_traveled" : 10.0589
} ], 
"778" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "10:16:00" , 
"departure_time" : "10:18:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "10:19:11" , 
"departure_time" : "10:20:22" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "10:21:11" , 
"departure_time" : "10:21:23" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "10:23:12" , 
"departure_time" : "10:23:19" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "10:26:07" , 
"departure_time" : "10:26:18" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "10:27:11" , 
"departure_time" : "10:28:07" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:33:56" , 
"departure_time" : "10:34:26" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:35:30" , 
"departure_time" : "10:35:43" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:37:13" , 
"departure_time" : "10:38:38" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:40:25" , 
"departure_time" : "10:40:40" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:41:15" , 
"departure_time" : "10:41:17" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:43:02" , 
"departure_time" : "10:43:15" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:44:13" , 
"departure_time" : "10:45:05" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:47:52" , 
"departure_time" : "10:48:10" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "10:50:18" , 
"departure_time" : "10:50:55" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "10:52:37" , 
"departure_time" : "10:53:36" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "10:54:59" , 
"departure_time" : "10:54:59" , 
"distance_traveled" : 10.0589
} ], 
"779" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "10:36:00" , 
"departure_time" : "10:37:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "10:38:52" , 
"departure_time" : "10:39:30" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "10:40:38" , 
"departure_time" : "10:42:11" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "10:44:33" , 
"departure_time" : "10:45:49" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "10:47:16" , 
"departure_time" : "10:48:52" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "10:48:36" , 
"departure_time" : "10:50:01" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:54:25" , 
"departure_time" : "10:55:18" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:55:53" , 
"departure_time" : "10:56:03" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:57:10" , 
"departure_time" : "10:58:36" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:00:26" , 
"departure_time" : "11:01:36" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:02:10" , 
"departure_time" : "11:02:51" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:03:41" , 
"departure_time" : "11:05:19" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:05:38" , 
"departure_time" : "11:06:08" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:07:30" , 
"departure_time" : "11:08:32" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "11:11:02" , 
"departure_time" : "11:11:57" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "11:12:55" , 
"departure_time" : "11:14:35" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "11:15:40" , 
"departure_time" : "11:15:40" , 
"distance_traveled" : 10.0589
} ], 
"780" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "10:56:00" , 
"departure_time" : "10:57:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "10:58:16" , 
"departure_time" : "10:59:43" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "11:01:27" , 
"departure_time" : "11:02:25" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "11:03:58" , 
"departure_time" : "11:04:32" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "11:06:34" , 
"departure_time" : "11:07:48" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "11:08:14" , 
"departure_time" : "11:09:13" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:13:59" , 
"departure_time" : "11:14:53" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:15:54" , 
"departure_time" : "11:16:10" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:17:16" , 
"departure_time" : "11:18:05" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:19:49" , 
"departure_time" : "11:19:59" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:21:10" , 
"departure_time" : "11:21:48" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:23:38" , 
"departure_time" : "11:24:36" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:24:58" , 
"departure_time" : "11:25:28" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:27:30" , 
"departure_time" : "11:28:09" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "11:30:39" , 
"departure_time" : "11:31:13" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "11:32:34" , 
"departure_time" : "11:32:59" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "11:34:25" , 
"departure_time" : "11:34:25" , 
"distance_traveled" : 10.0589
} ], 
"781" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "11:16:00" , 
"departure_time" : "11:17:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "11:19:18" , 
"departure_time" : "11:20:15" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "11:20:57" , 
"departure_time" : "11:21:57" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "11:24:00" , 
"departure_time" : "11:24:52" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "11:26:52" , 
"departure_time" : "11:28:00" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "11:28:08" , 
"departure_time" : "11:28:56" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:33:48" , 
"departure_time" : "11:33:54" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:35:06" , 
"departure_time" : "11:35:52" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:37:46" , 
"departure_time" : "11:39:20" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:40:34" , 
"departure_time" : "11:40:36" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:41:02" , 
"departure_time" : "11:41:40" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:43:38" , 
"departure_time" : "11:44:40" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:45:02" , 
"departure_time" : "11:45:25" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:47:23" , 
"departure_time" : "11:47:47" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "11:50:24" , 
"departure_time" : "11:51:13" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "11:52:49" , 
"departure_time" : "11:53:27" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "11:54:38" , 
"departure_time" : "11:54:38" , 
"distance_traveled" : 10.0589
} ], 
"782" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "11:36:00" , 
"departure_time" : "11:36:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "11:38:12" , 
"departure_time" : "11:39:21" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "11:41:09" , 
"departure_time" : "11:42:46" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "11:44:37" , 
"departure_time" : "11:46:08" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "11:47:31" , 
"departure_time" : "11:48:16" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "11:47:45" , 
"departure_time" : "11:48:20" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:53:35" , 
"departure_time" : "11:53:53" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:55:18" , 
"departure_time" : "11:56:33" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:58:15" , 
"departure_time" : "11:59:32" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:00:17" , 
"departure_time" : "12:01:16" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:01:59" , 
"departure_time" : "12:03:04" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:04:05" , 
"departure_time" : "12:05:05" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:05:00" , 
"departure_time" : "12:05:51" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:07:51" , 
"departure_time" : "12:08:30" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "12:10:39" , 
"departure_time" : "12:11:54" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "12:13:15" , 
"departure_time" : "12:13:23" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "12:14:08" , 
"departure_time" : "12:14:08" , 
"distance_traveled" : 10.0589
} ], 
"783" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "11:56:00" , 
"departure_time" : "11:57:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "11:59:25" , 
"departure_time" : "11:59:47" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "12:00:22" , 
"departure_time" : "12:01:54" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "12:04:32" , 
"departure_time" : "12:05:00" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "12:06:28" , 
"departure_time" : "12:07:37" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "12:08:09" , 
"departure_time" : "12:08:30" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:13:21" , 
"departure_time" : "12:14:58" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:16:37" , 
"departure_time" : "12:17:16" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:17:39" , 
"departure_time" : "12:18:38" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:19:59" , 
"departure_time" : "12:20:34" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:21:35" , 
"departure_time" : "12:22:13" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:23:38" , 
"departure_time" : "12:24:23" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:24:45" , 
"departure_time" : "12:26:00" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:28:15" , 
"departure_time" : "12:28:54" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "12:30:39" , 
"departure_time" : "12:31:24" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "12:32:45" , 
"departure_time" : "12:33:26" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "12:34:41" , 
"departure_time" : "12:34:41" , 
"distance_traveled" : 10.0589
} ], 
"784" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "12:16:00" , 
"departure_time" : "12:18:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "12:19:33" , 
"departure_time" : "12:21:09" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "12:21:36" , 
"departure_time" : "12:22:16" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "12:23:40" , 
"departure_time" : "12:24:23" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "12:26:43" , 
"departure_time" : "12:27:36" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "12:27:53" , 
"departure_time" : "12:29:18" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:34:25" , 
"departure_time" : "12:34:43" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:35:18" , 
"departure_time" : "12:35:41" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:37:23" , 
"departure_time" : "12:39:02" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:40:39" , 
"departure_time" : "12:42:19" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:42:40" , 
"departure_time" : "12:43:15" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:43:35" , 
"departure_time" : "12:45:11" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:45:36" , 
"departure_time" : "12:46:45" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:48:09" , 
"departure_time" : "12:49:45" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "12:51:36" , 
"departure_time" : "12:51:51" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "12:52:15" , 
"departure_time" : "12:53:14" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "12:54:59" , 
"departure_time" : "12:54:59" , 
"distance_traveled" : 10.0589
} ], 
"785" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "12:36:00" , 
"departure_time" : "12:37:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "12:38:33" , 
"departure_time" : "12:38:52" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "12:40:19" , 
"departure_time" : "12:40:34" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "12:43:15" , 
"departure_time" : "12:44:52" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "12:47:37" , 
"departure_time" : "12:47:47" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "12:47:10" , 
"departure_time" : "12:47:30" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:53:20" , 
"departure_time" : "12:54:02" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:55:42" , 
"departure_time" : "12:57:22" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:58:40" , 
"departure_time" : "12:59:36" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:59:56" , 
"departure_time" : "13:01:35" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:02:39" , 
"departure_time" : "13:04:19" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:04:40" , 
"departure_time" : "13:05:25" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:04:45" , 
"departure_time" : "13:04:59" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:07:14" , 
"departure_time" : "13:08:09" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "13:10:55" , 
"departure_time" : "13:11:26" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "13:12:31" , 
"departure_time" : "13:13:27" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "13:14:56" , 
"departure_time" : "13:14:56" , 
"distance_traveled" : 10.0589
} ], 
"786" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "12:56:00" , 
"departure_time" : "12:57:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "12:58:21" , 
"departure_time" : "12:58:30" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "13:00:09" , 
"departure_time" : "13:00:41" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "13:03:32" , 
"departure_time" : "13:03:55" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "13:06:23" , 
"departure_time" : "13:07:28" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "13:08:05" , 
"departure_time" : "13:08:39" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:13:34" , 
"departure_time" : "13:13:51" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:15:17" , 
"departure_time" : "13:15:28" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:17:11" , 
"departure_time" : "13:18:29" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:20:18" , 
"departure_time" : "13:21:26" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:22:08" , 
"departure_time" : "13:22:45" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:23:37" , 
"departure_time" : "13:24:23" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:24:46" , 
"departure_time" : "13:25:14" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:27:28" , 
"departure_time" : "13:27:54" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "13:30:26" , 
"departure_time" : "13:31:44" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "13:33:18" , 
"departure_time" : "13:33:44" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "13:34:26" , 
"departure_time" : "13:34:26" , 
"distance_traveled" : 10.0589
} ], 
"787" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "13:16:00" , 
"departure_time" : "13:17:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "13:19:07" , 
"departure_time" : "13:19:42" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "13:20:35" , 
"departure_time" : "13:20:36" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "13:23:01" , 
"departure_time" : "13:24:30" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "13:27:29" , 
"departure_time" : "13:27:37" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "13:27:08" , 
"departure_time" : "13:27:35" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:33:27" , 
"departure_time" : "13:33:38" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:35:11" , 
"departure_time" : "13:36:51" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:38:40" , 
"departure_time" : "13:39:47" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:40:07" , 
"departure_time" : "13:41:34" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:42:27" , 
"departure_time" : "13:43:41" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:44:14" , 
"departure_time" : "13:45:29" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:45:15" , 
"departure_time" : "13:46:12" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:47:57" , 
"departure_time" : "13:48:17" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "13:50:20" , 
"departure_time" : "13:51:23" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "13:53:03" , 
"departure_time" : "13:53:06" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "13:54:03" , 
"departure_time" : "13:54:03" , 
"distance_traveled" : 10.0589
} ], 
"788" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "13:36:00" , 
"departure_time" : "13:36:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "13:38:33" , 
"departure_time" : "13:38:35" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "13:40:02" , 
"departure_time" : "13:40:42" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "13:43:40" , 
"departure_time" : "13:44:25" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "13:46:45" , 
"departure_time" : "13:47:29" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "13:47:44" , 
"departure_time" : "13:48:53" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:54:09" , 
"departure_time" : "13:55:17" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:56:08" , 
"departure_time" : "13:56:59" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:57:51" , 
"departure_time" : "13:58:19" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:59:28" , 
"departure_time" : "14:00:42" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:02:14" , 
"departure_time" : "14:02:25" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:03:11" , 
"departure_time" : "14:04:30" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:05:19" , 
"departure_time" : "14:05:34" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:07:15" , 
"departure_time" : "14:08:21" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "14:11:06" , 
"departure_time" : "14:12:30" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "14:13:24" , 
"departure_time" : "14:14:36" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "14:15:12" , 
"departure_time" : "14:15:12" , 
"distance_traveled" : 10.0589
} ], 
"789" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "13:56:00" , 
"departure_time" : "13:57:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "13:58:07" , 
"departure_time" : "13:59:29" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "14:01:22" , 
"departure_time" : "14:01:30" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "14:03:08" , 
"departure_time" : "14:03:48" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "14:06:40" , 
"departure_time" : "14:07:57" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "14:08:17" , 
"departure_time" : "14:08:44" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:13:27" , 
"departure_time" : "14:14:28" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:16:01" , 
"departure_time" : "14:16:34" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:17:33" , 
"departure_time" : "14:18:03" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:19:30" , 
"departure_time" : "14:20:38" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:22:08" , 
"departure_time" : "14:22:32" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:23:24" , 
"departure_time" : "14:24:26" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:25:02" , 
"departure_time" : "14:26:41" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:28:39" , 
"departure_time" : "14:29:21" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "14:30:42" , 
"departure_time" : "14:31:49" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "14:33:07" , 
"departure_time" : "14:33:11" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "14:34:04" , 
"departure_time" : "14:34:04" , 
"distance_traveled" : 10.0589
} ], 
"790" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "14:16:00" , 
"departure_time" : "14:17:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "14:19:35" , 
"departure_time" : "14:19:38" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "14:20:03" , 
"departure_time" : "14:20:07" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "14:23:04" , 
"departure_time" : "14:23:59" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "14:26:55" , 
"departure_time" : "14:28:28" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "14:28:33" , 
"departure_time" : "14:29:44" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:34:11" , 
"departure_time" : "14:34:26" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:35:15" , 
"departure_time" : "14:36:47" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:38:32" , 
"departure_time" : "14:39:31" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:39:59" , 
"departure_time" : "14:41:21" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:42:22" , 
"departure_time" : "14:42:43" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:43:21" , 
"departure_time" : "14:44:00" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:44:39" , 
"departure_time" : "14:45:54" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:48:15" , 
"departure_time" : "14:49:30" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "14:51:15" , 
"departure_time" : "14:52:23" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "14:53:08" , 
"departure_time" : "14:53:59" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "14:54:51" , 
"departure_time" : "14:54:51" , 
"distance_traveled" : 10.0589
} ], 
"791" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "14:36:00" , 
"departure_time" : "14:38:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "14:39:35" , 
"departure_time" : "14:39:50" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "14:40:15" , 
"departure_time" : "14:40:47" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "14:43:32" , 
"departure_time" : "14:43:48" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "14:46:16" , 
"departure_time" : "14:46:52" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "14:47:36" , 
"departure_time" : "14:49:12" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:54:36" , 
"departure_time" : "14:54:44" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:55:08" , 
"departure_time" : "14:55:19" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:57:11" , 
"departure_time" : "14:58:15" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:00:04" , 
"departure_time" : "15:01:29" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:02:25" , 
"departure_time" : "15:04:02" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:04:37" , 
"departure_time" : "15:05:42" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:05:05" , 
"departure_time" : "15:05:27" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:07:22" , 
"departure_time" : "15:07:32" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "15:10:10" , 
"departure_time" : "15:10:21" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "15:12:11" , 
"departure_time" : "15:13:39" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "15:15:28" , 
"departure_time" : "15:15:28" , 
"distance_traveled" : 10.0589
} ], 
"792" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "14:56:00" , 
"departure_time" : "14:57:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "14:58:09" , 
"departure_time" : "14:58:49" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "15:00:40" , 
"departure_time" : "15:02:04" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "15:04:24" , 
"departure_time" : "15:05:52" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "15:07:28" , 
"departure_time" : "15:09:06" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "15:08:38" , 
"departure_time" : "15:09:34" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:13:56" , 
"departure_time" : "15:14:18" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:15:22" , 
"departure_time" : "15:15:38" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:17:16" , 
"departure_time" : "15:18:20" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:20:04" , 
"departure_time" : "15:20:44" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:21:40" , 
"departure_time" : "15:22:35" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:23:55" , 
"departure_time" : "15:24:06" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:24:11" , 
"departure_time" : "15:25:26" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:28:15" , 
"departure_time" : "15:29:35" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "15:31:20" , 
"departure_time" : "15:32:02" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "15:32:42" , 
"departure_time" : "15:33:52" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "15:35:10" , 
"departure_time" : "15:35:10" , 
"distance_traveled" : 10.0589
} ], 
"793" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "15:16:00" , 
"departure_time" : "15:17:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "15:18:46" , 
"departure_time" : "15:18:59" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "15:20:13" , 
"departure_time" : "15:21:52" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "15:24:39" , 
"departure_time" : "15:25:33" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "15:26:54" , 
"departure_time" : "15:28:05" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "15:28:11" , 
"departure_time" : "15:28:40" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:33:29" , 
"departure_time" : "15:34:30" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:36:01" , 
"departure_time" : "15:37:36" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:38:35" , 
"departure_time" : "15:38:53" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:39:18" , 
"departure_time" : "15:40:45" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:42:27" , 
"departure_time" : "15:43:50" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:44:23" , 
"departure_time" : "15:45:53" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:45:30" , 
"departure_time" : "15:45:56" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:47:26" , 
"departure_time" : "15:48:43" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "15:51:17" , 
"departure_time" : "15:52:43" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "15:53:26" , 
"departure_time" : "15:54:02" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "15:54:36" , 
"departure_time" : "15:54:36" , 
"distance_traveled" : 10.0589
} ], 
"794" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "15:36:00" , 
"departure_time" : "15:37:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "15:39:18" , 
"departure_time" : "15:39:28" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "15:40:10" , 
"departure_time" : "15:40:30" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "15:43:20" , 
"departure_time" : "15:43:24" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "15:46:04" , 
"departure_time" : "15:46:58" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "15:47:54" , 
"departure_time" : "15:49:21" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:54:27" , 
"departure_time" : "15:55:49" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:56:22" , 
"departure_time" : "15:57:24" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:58:02" , 
"departure_time" : "15:58:46" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:59:44" , 
"departure_time" : "16:00:57" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:02:13" , 
"departure_time" : "16:02:37" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:03:24" , 
"departure_time" : "16:04:08" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:04:44" , 
"departure_time" : "16:05:01" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:07:17" , 
"departure_time" : "16:07:37" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "16:10:20" , 
"departure_time" : "16:11:17" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "16:12:57" , 
"departure_time" : "16:13:59" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "16:15:02" , 
"departure_time" : "16:15:02" , 
"distance_traveled" : 10.0589
} ], 
"795" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "15:56:00" , 
"departure_time" : "15:57:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "15:58:22" , 
"departure_time" : "15:58:55" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "16:00:33" , 
"departure_time" : "16:01:16" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:03:43" , 
"departure_time" : "16:04:36" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:06:53" , 
"departure_time" : "16:07:52" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:07:59" , 
"departure_time" : "16:09:27" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:14:28" , 
"departure_time" : "16:15:06" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:15:38" , 
"departure_time" : "16:16:07" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:17:29" , 
"departure_time" : "16:17:34" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:19:05" , 
"departure_time" : "16:19:21" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:21:16" , 
"departure_time" : "16:22:38" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:24:22" , 
"departure_time" : "16:25:03" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:24:41" , 
"departure_time" : "16:25:25" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:27:44" , 
"departure_time" : "16:28:21" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "16:30:37" , 
"departure_time" : "16:31:37" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "16:33:00" , 
"departure_time" : "16:34:20" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "16:35:20" , 
"departure_time" : "16:35:20" , 
"distance_traveled" : 10.0589
} ], 
"796" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "16:16:00" , 
"departure_time" : "16:17:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:18:39" , 
"departure_time" : "16:19:22" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "16:20:43" , 
"departure_time" : "16:20:56" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:23:13" , 
"departure_time" : "16:23:29" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:26:16" , 
"departure_time" : "16:27:10" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:27:54" , 
"departure_time" : "16:29:11" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:34:17" , 
"departure_time" : "16:35:49" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:36:32" , 
"departure_time" : "16:36:39" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:37:07" , 
"departure_time" : "16:37:31" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:39:24" , 
"departure_time" : "16:41:04" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:42:40" , 
"departure_time" : "16:42:47" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:43:07" , 
"departure_time" : "16:43:51" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:44:44" , 
"departure_time" : "16:46:12" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:48:28" , 
"departure_time" : "16:49:36" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "16:51:08" , 
"departure_time" : "16:52:24" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "16:53:16" , 
"departure_time" : "16:53:53" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "16:54:37" , 
"departure_time" : "16:54:37" , 
"distance_traveled" : 10.0589
} ], 
"797" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "16:36:00" , 
"departure_time" : "16:38:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:39:39" , 
"departure_time" : "16:40:32" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "16:40:53" , 
"departure_time" : "16:41:23" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:43:30" , 
"departure_time" : "16:43:47" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:46:17" , 
"departure_time" : "16:47:14" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:47:57" , 
"departure_time" : "16:49:18" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:54:21" , 
"departure_time" : "16:55:11" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:55:50" , 
"departure_time" : "16:57:22" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:58:32" , 
"departure_time" : "16:59:47" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:00:15" , 
"departure_time" : "17:00:40" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:01:25" , 
"departure_time" : "17:01:58" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:03:33" , 
"departure_time" : "17:05:10" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:05:37" , 
"departure_time" : "17:05:41" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:07:04" , 
"departure_time" : "17:07:24" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "17:10:20" , 
"departure_time" : "17:11:57" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "17:13:37" , 
"departure_time" : "17:14:25" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "17:14:48" , 
"departure_time" : "17:14:48" , 
"distance_traveled" : 10.0589
} ], 
"798" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "16:56:00" , 
"departure_time" : "16:57:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:58:43" , 
"departure_time" : "17:00:13" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:01:30" , 
"departure_time" : "17:02:03" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:03:33" , 
"departure_time" : "17:04:13" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "17:06:40" , 
"departure_time" : "17:07:27" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:07:47" , 
"departure_time" : "17:08:25" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:13:38" , 
"departure_time" : "17:14:08" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:15:30" , 
"departure_time" : "17:16:57" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:18:27" , 
"departure_time" : "17:19:43" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:20:16" , 
"departure_time" : "17:20:31" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:21:15" , 
"departure_time" : "17:22:14" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:23:59" , 
"departure_time" : "17:25:28" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:25:29" , 
"departure_time" : "17:26:10" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:27:41" , 
"departure_time" : "17:29:20" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "17:31:39" , 
"departure_time" : "17:33:00" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "17:33:21" , 
"departure_time" : "17:33:22" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "17:34:01" , 
"departure_time" : "17:34:01" , 
"distance_traveled" : 10.0589
} ], 
"799" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "17:16:00" , 
"departure_time" : "17:17:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:19:35" , 
"departure_time" : "17:20:38" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:21:03" , 
"departure_time" : "17:22:12" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:24:09" , 
"departure_time" : "17:24:24" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "17:26:15" , 
"departure_time" : "17:27:06" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:27:51" , 
"departure_time" : "17:29:27" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:34:36" , 
"departure_time" : "17:36:11" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:36:35" , 
"departure_time" : "17:37:29" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:37:54" , 
"departure_time" : "17:39:12" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:40:18" , 
"departure_time" : "17:41:36" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:42:18" , 
"departure_time" : "17:43:57" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:44:39" , 
"departure_time" : "17:45:42" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:45:03" , 
"departure_time" : "17:45:04" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:47:01" , 
"departure_time" : "17:48:23" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "17:51:22" , 
"departure_time" : "17:53:02" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "17:53:40" , 
"departure_time" : "17:54:30" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "17:54:50" , 
"departure_time" : "17:54:50" , 
"distance_traveled" : 10.0589
} ], 
"800" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "17:36:00" , 
"departure_time" : "17:37:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:38:17" , 
"departure_time" : "17:39:26" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:41:09" , 
"departure_time" : "17:42:01" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:43:52" , 
"departure_time" : "17:43:55" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "17:46:03" , 
"departure_time" : "17:46:49" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:47:46" , 
"departure_time" : "17:48:50" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:54:04" , 
"departure_time" : "17:55:24" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:56:20" , 
"departure_time" : "17:57:24" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:58:04" , 
"departure_time" : "17:58:13" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:59:09" , 
"departure_time" : "17:59:46" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:01:37" , 
"departure_time" : "18:02:36" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:03:59" , 
"departure_time" : "18:04:33" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:04:34" , 
"departure_time" : "18:05:04" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:07:30" , 
"departure_time" : "18:07:42" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "18:10:12" , 
"departure_time" : "18:11:02" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "18:12:50" , 
"departure_time" : "18:13:04" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "18:14:14" , 
"departure_time" : "18:14:14" , 
"distance_traveled" : 10.0589
} ], 
"801" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "17:56:00" , 
"departure_time" : "17:56:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:58:26" , 
"departure_time" : "17:59:50" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:01:24" , 
"departure_time" : "18:01:26" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:03:02" , 
"departure_time" : "18:03:06" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:06:04" , 
"departure_time" : "18:06:45" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:07:41" , 
"departure_time" : "18:08:46" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:14:05" , 
"departure_time" : "18:14:45" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:15:40" , 
"departure_time" : "18:16:28" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:17:48" , 
"departure_time" : "18:18:52" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:20:04" , 
"departure_time" : "18:20:15" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:21:11" , 
"departure_time" : "18:22:06" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:23:55" , 
"departure_time" : "18:24:48" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:24:53" , 
"departure_time" : "18:25:41" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:27:48" , 
"departure_time" : "18:27:49" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "18:30:01" , 
"departure_time" : "18:30:32" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "18:32:31" , 
"departure_time" : "18:33:50" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "18:35:19" , 
"departure_time" : "18:35:19" , 
"distance_traveled" : 10.0589
} ], 
"802" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "18:16:00" , 
"departure_time" : "18:18:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:19:10" , 
"departure_time" : "18:20:12" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:21:02" , 
"departure_time" : "18:22:03" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:24:01" , 
"departure_time" : "18:24:22" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:26:21" , 
"departure_time" : "18:27:21" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:28:00" , 
"departure_time" : "18:29:35" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:34:35" , 
"departure_time" : "18:35:29" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:35:54" , 
"departure_time" : "18:37:05" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:38:11" , 
"departure_time" : "18:38:25" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:39:14" , 
"departure_time" : "18:40:02" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:41:48" , 
"departure_time" : "18:42:11" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:43:23" , 
"departure_time" : "18:44:09" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:44:46" , 
"departure_time" : "18:45:13" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:47:27" , 
"departure_time" : "18:47:55" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "18:50:28" , 
"departure_time" : "18:51:58" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "18:53:30" , 
"departure_time" : "18:54:36" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "18:55:06" , 
"departure_time" : "18:55:06" , 
"distance_traveled" : 10.0589
} ], 
"803" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "18:36:00" , 
"departure_time" : "18:38:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:39:15" , 
"departure_time" : "18:39:44" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:40:29" , 
"departure_time" : "18:41:03" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:43:34" , 
"departure_time" : "18:44:33" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:46:59" , 
"departure_time" : "18:47:45" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:47:46" , 
"departure_time" : "18:48:37" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:53:51" , 
"departure_time" : "18:55:13" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:56:22" , 
"departure_time" : "18:57:36" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:58:14" , 
"departure_time" : "18:58:52" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:59:38" , 
"departure_time" : "19:00:11" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:01:33" , 
"departure_time" : "19:03:07" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:04:34" , 
"departure_time" : "19:04:43" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:04:09" , 
"departure_time" : "19:05:02" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:07:53" , 
"departure_time" : "19:08:01" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "19:10:08" , 
"departure_time" : "19:10:17" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "19:12:09" , 
"departure_time" : "19:12:27" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "19:14:18" , 
"departure_time" : "19:14:18" , 
"distance_traveled" : 10.0589
} ], 
"804" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "18:56:00" , 
"departure_time" : "18:57:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:59:15" , 
"departure_time" : "18:59:25" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "19:00:10" , 
"departure_time" : "19:00:17" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "19:03:07" , 
"departure_time" : "19:03:51" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "19:06:44" , 
"departure_time" : "19:07:48" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "19:08:04" , 
"departure_time" : "19:09:38" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:14:34" , 
"departure_time" : "19:16:00" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:16:26" , 
"departure_time" : "19:17:13" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:17:47" , 
"departure_time" : "19:18:05" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:19:18" , 
"departure_time" : "19:20:31" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:22:13" , 
"departure_time" : "19:23:47" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:24:34" , 
"departure_time" : "19:24:56" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:24:22" , 
"departure_time" : "19:25:25" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:28:03" , 
"departure_time" : "19:28:35" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "19:30:32" , 
"departure_time" : "19:31:51" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "19:33:19" , 
"departure_time" : "19:34:34" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "19:35:15" , 
"departure_time" : "19:35:15" , 
"distance_traveled" : 10.0589
} ], 
"805" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "19:16:00" , 
"departure_time" : "19:18:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "19:18:54" , 
"departure_time" : "19:19:03" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "19:20:09" , 
"departure_time" : "19:20:24" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "19:23:15" , 
"departure_time" : "19:24:24" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "19:27:09" , 
"departure_time" : "19:27:38" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "19:27:29" , 
"departure_time" : "19:28:14" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:33:45" , 
"departure_time" : "19:33:50" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:35:05" , 
"departure_time" : "19:35:42" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:37:37" , 
"departure_time" : "19:37:58" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:39:21" , 
"departure_time" : "19:39:25" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:41:04" , 
"departure_time" : "19:41:21" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:43:17" , 
"departure_time" : "19:43:26" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:44:09" , 
"departure_time" : "19:45:27" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:48:18" , 
"departure_time" : "19:48:25" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "19:50:07" , 
"departure_time" : "19:50:16" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "19:52:09" , 
"departure_time" : "19:52:12" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "19:54:03" , 
"departure_time" : "19:54:03" , 
"distance_traveled" : 10.0589
} ], 
"806" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "19:36:00" , 
"departure_time" : "19:37:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "19:39:38" , 
"departure_time" : "19:39:51" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "19:40:13" , 
"departure_time" : "19:41:07" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "19:43:54" , 
"departure_time" : "19:45:22" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "19:47:28" , 
"departure_time" : "19:49:02" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "19:48:34" , 
"departure_time" : "19:49:27" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:53:53" , 
"departure_time" : "19:55:21" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:56:28" , 
"departure_time" : "19:57:21" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:57:53" , 
"departure_time" : "19:58:39" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:59:46" , 
"departure_time" : "20:00:17" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:01:31" , 
"departure_time" : "20:02:03" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:03:32" , 
"departure_time" : "20:04:45" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:05:13" , 
"departure_time" : "20:05:34" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:07:21" , 
"departure_time" : "20:08:44" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "20:11:23" , 
"departure_time" : "20:12:33" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "20:13:10" , 
"departure_time" : "20:14:31" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "20:15:21" , 
"departure_time" : "20:15:21" , 
"distance_traveled" : 10.0589
} ], 
"807" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "19:56:00" , 
"departure_time" : "19:58:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "19:58:58" , 
"departure_time" : "19:59:50" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "20:00:52" , 
"departure_time" : "20:01:15" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "20:03:23" , 
"departure_time" : "20:04:07" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "20:06:44" , 
"departure_time" : "20:07:58" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "20:08:14" , 
"departure_time" : "20:08:55" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:13:41" , 
"departure_time" : "20:14:40" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:15:59" , 
"departure_time" : "20:17:38" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:18:39" , 
"departure_time" : "20:18:47" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:19:08" , 
"departure_time" : "20:19:34" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:21:26" , 
"departure_time" : "20:22:58" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:24:32" , 
"departure_time" : "20:26:06" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:25:34" , 
"departure_time" : "20:25:44" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:27:10" , 
"departure_time" : "20:27:35" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "20:30:25" , 
"departure_time" : "20:30:52" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "20:32:27" , 
"departure_time" : "20:32:36" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "20:34:09" , 
"departure_time" : "20:34:09" , 
"distance_traveled" : 10.0589
} ], 
"808" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "20:16:00" , 
"departure_time" : "20:17:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "20:19:33" , 
"departure_time" : "20:19:42" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "20:20:09" , 
"departure_time" : "20:20:39" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "20:23:30" , 
"departure_time" : "20:24:35" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "20:27:05" , 
"departure_time" : "20:28:27" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "20:28:22" , 
"departure_time" : "20:29:10" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:33:48" , 
"departure_time" : "20:34:21" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:35:33" , 
"departure_time" : "20:37:12" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:38:39" , 
"departure_time" : "20:39:59" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:40:20" , 
"departure_time" : "20:41:27" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:42:07" , 
"departure_time" : "20:42:49" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:43:42" , 
"departure_time" : "20:43:45" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:44:03" , 
"departure_time" : "20:45:03" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:48:00" , 
"departure_time" : "20:48:16" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "20:50:16" , 
"departure_time" : "20:51:21" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "20:53:05" , 
"departure_time" : "20:54:05" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "20:55:00" , 
"departure_time" : "20:55:00" , 
"distance_traveled" : 10.0589
} ], 
"809" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "20:36:00" , 
"departure_time" : "20:37:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "20:38:04" , 
"departure_time" : "20:38:55" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "20:40:51" , 
"departure_time" : "20:41:28" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "20:43:37" , 
"departure_time" : "20:45:14" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "20:47:37" , 
"departure_time" : "20:48:14" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "20:47:37" , 
"departure_time" : "20:48:08" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:53:31" , 
"departure_time" : "20:54:21" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:55:50" , 
"departure_time" : "20:56:10" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:57:20" , 
"departure_time" : "20:58:42" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "21:00:22" , 
"departure_time" : "21:01:52" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:02:30" , 
"departure_time" : "21:03:04" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "21:03:34" , 
"departure_time" : "21:04:53" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "21:05:19" , 
"departure_time" : "21:05:45" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:07:26" , 
"departure_time" : "21:07:59" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "21:10:33" , 
"departure_time" : "21:10:48" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "21:12:15" , 
"departure_time" : "21:12:47" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "21:14:32" , 
"departure_time" : "21:14:32" , 
"distance_traveled" : 10.0589
} ], 
"810" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "20:56:00" , 
"departure_time" : "20:56:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "20:58:15" , 
"departure_time" : "20:59:53" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "21:01:38" , 
"departure_time" : "21:01:52" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "21:03:14" , 
"departure_time" : "21:04:54" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "21:07:40" , 
"departure_time" : "21:08:07" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "21:07:27" , 
"departure_time" : "21:08:30" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:14:03" , 
"departure_time" : "21:14:33" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:15:30" , 
"departure_time" : "21:16:56" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:18:26" , 
"departure_time" : "21:19:40" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "21:20:14" , 
"departure_time" : "21:20:23" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:21:09" , 
"departure_time" : "21:22:08" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "21:23:59" , 
"departure_time" : "21:24:10" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "21:24:11" , 
"departure_time" : "21:25:39" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:28:28" , 
"departure_time" : "21:29:22" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "21:30:54" , 
"departure_time" : "21:32:13" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "21:33:19" , 
"departure_time" : "21:33:59" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "21:34:40" , 
"departure_time" : "21:34:40" , 
"distance_traveled" : 10.0589
} ], 
"811" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "21:16:00" , 
"departure_time" : "21:17:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "21:19:06" , 
"departure_time" : "21:19:30" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "21:20:24" , 
"departure_time" : "21:20:50" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "21:23:26" , 
"departure_time" : "21:23:48" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "21:26:22" , 
"departure_time" : "21:28:02" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "21:28:40" , 
"departure_time" : "21:29:12" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:33:32" , 
"departure_time" : "21:34:51" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:36:19" , 
"departure_time" : "21:37:46" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:38:27" , 
"departure_time" : "21:38:41" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "21:39:14" , 
"departure_time" : "21:40:44" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:42:30" , 
"departure_time" : "21:43:34" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "21:44:04" , 
"departure_time" : "21:44:17" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "21:44:13" , 
"departure_time" : "21:44:52" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:47:39" , 
"departure_time" : "21:47:44" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "21:50:05" , 
"departure_time" : "21:50:32" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "21:52:27" , 
"departure_time" : "21:52:50" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "21:54:23" , 
"departure_time" : "21:54:23" , 
"distance_traveled" : 10.0589
} ], 
"812" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "21:36:00" , 
"departure_time" : "21:37:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "21:38:56" , 
"departure_time" : "21:40:00" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "21:41:04" , 
"departure_time" : "21:41:09" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "21:43:05" , 
"departure_time" : "21:43:25" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "21:46:20" , 
"departure_time" : "21:46:25" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "21:47:05" , 
"departure_time" : "21:47:41" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:53:36" , 
"departure_time" : "21:54:50" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:56:14" , 
"departure_time" : "21:56:35" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:57:21" , 
"departure_time" : "21:58:59" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:00:38" , 
"departure_time" : "22:01:07" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:01:29" , 
"departure_time" : "22:03:03" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:04:34" , 
"departure_time" : "22:05:08" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:04:34" , 
"departure_time" : "22:05:09" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:07:35" , 
"departure_time" : "22:09:04" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "22:11:29" , 
"departure_time" : "22:12:47" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "22:13:18" , 
"departure_time" : "22:13:33" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "22:14:15" , 
"departure_time" : "22:14:15" , 
"distance_traveled" : 10.0589
} ], 
"813" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "21:56:00" , 
"departure_time" : "21:57:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "21:59:39" , 
"departure_time" : "22:00:30" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "22:00:51" , 
"departure_time" : "22:02:13" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "22:04:22" , 
"departure_time" : "22:05:09" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "22:06:47" , 
"departure_time" : "22:07:08" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "22:07:21" , 
"departure_time" : "22:07:50" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:13:29" , 
"departure_time" : "22:15:00" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:16:31" , 
"departure_time" : "22:18:08" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:18:37" , 
"departure_time" : "22:18:56" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:19:19" , 
"departure_time" : "22:19:34" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:21:15" , 
"departure_time" : "22:21:20" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:23:05" , 
"departure_time" : "22:23:26" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:24:21" , 
"departure_time" : "22:25:07" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:27:46" , 
"departure_time" : "22:28:22" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "22:30:36" , 
"departure_time" : "22:31:27" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "22:32:51" , 
"departure_time" : "22:33:52" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "22:35:01" , 
"departure_time" : "22:35:01" , 
"distance_traveled" : 10.0589
} ], 
"814" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "22:16:00" , 
"departure_time" : "22:17:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "22:18:32" , 
"departure_time" : "22:19:45" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "22:21:13" , 
"departure_time" : "22:21:49" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "22:23:36" , 
"departure_time" : "22:25:12" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "22:27:36" , 
"departure_time" : "22:28:59" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "22:28:23" , 
"departure_time" : "22:28:37" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:33:14" , 
"departure_time" : "22:33:32" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:35:18" , 
"departure_time" : "22:36:16" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:37:58" , 
"departure_time" : "22:38:44" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:39:46" , 
"departure_time" : "22:41:18" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:42:32" , 
"departure_time" : "22:43:05" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:43:33" , 
"departure_time" : "22:44:06" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:44:33" , 
"departure_time" : "22:44:39" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:47:06" , 
"departure_time" : "22:47:15" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "22:50:09" , 
"departure_time" : "22:51:48" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "22:53:39" , 
"departure_time" : "22:55:07" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "22:55:28" , 
"departure_time" : "22:55:28" , 
"distance_traveled" : 10.0589
} ], 
"815" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "22:36:00" , 
"departure_time" : "22:38:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "22:39:18" , 
"departure_time" : "22:39:57" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "22:40:39" , 
"departure_time" : "22:41:40" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "22:44:01" , 
"departure_time" : "22:44:05" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "22:46:04" , 
"departure_time" : "22:47:35" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "22:48:31" , 
"departure_time" : "22:48:47" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:53:16" , 
"departure_time" : "22:53:52" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:55:36" , 
"departure_time" : "22:56:07" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:57:31" , 
"departure_time" : "22:58:55" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:00:24" , 
"departure_time" : "23:00:34" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:01:10" , 
"departure_time" : "23:02:33" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "23:04:23" , 
"departure_time" : "23:05:31" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:05:08" , 
"departure_time" : "23:06:27" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:08:19" , 
"departure_time" : "23:09:32" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "23:11:13" , 
"departure_time" : "23:11:44" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "23:12:31" , 
"departure_time" : "23:13:55" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "23:15:24" , 
"departure_time" : "23:15:24" , 
"distance_traveled" : 10.0589
} ], 
"816" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "22:56:00" , 
"departure_time" : "22:57:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "22:58:03" , 
"departure_time" : "22:59:32" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "23:01:29" , 
"departure_time" : "23:02:39" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "23:04:10" , 
"departure_time" : "23:05:03" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "23:06:53" , 
"departure_time" : "23:07:03" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "23:07:10" , 
"departure_time" : "23:07:46" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:13:36" , 
"departure_time" : "23:14:04" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:15:28" , 
"departure_time" : "23:15:41" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:17:13" , 
"departure_time" : "23:17:21" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:19:08" , 
"departure_time" : "23:20:47" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:22:39" , 
"departure_time" : "23:22:45" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "23:23:06" , 
"departure_time" : "23:23:54" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:24:48" , 
"departure_time" : "23:25:43" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:27:55" , 
"departure_time" : "23:29:02" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "23:31:07" , 
"departure_time" : "23:32:31" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "23:33:24" , 
"departure_time" : "23:33:34" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "23:34:10" , 
"departure_time" : "23:34:10" , 
"distance_traveled" : 10.0589
} ], 
"817" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "23:16:00" , 
"departure_time" : "23:17:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "23:18:58" , 
"departure_time" : "23:19:19" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "23:20:21" , 
"departure_time" : "23:21:41" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "23:24:20" , 
"departure_time" : "23:24:44" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "23:26:24" , 
"departure_time" : "23:27:03" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "23:27:39" , 
"departure_time" : "23:27:40" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:33:01" , 
"departure_time" : "23:34:34" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:36:33" , 
"departure_time" : "23:37:20" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:37:47" , 
"departure_time" : "23:38:31" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:39:44" , 
"departure_time" : "23:41:05" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:42:21" , 
"departure_time" : "23:43:38" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "23:44:17" , 
"departure_time" : "23:44:52" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:44:35" , 
"departure_time" : "23:44:43" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:47:08" , 
"departure_time" : "23:47:11" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "23:50:03" , 
"departure_time" : "23:50:13" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "23:52:10" , 
"departure_time" : "23:52:34" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "23:54:24" , 
"departure_time" : "23:54:24" , 
"distance_traveled" : 10.0589
} ], 
"818" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "23:36:00" , 
"departure_time" : "23:37:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "23:39:32" , 
"departure_time" : "23:40:12" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "23:40:40" , 
"departure_time" : "23:40:56" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "23:43:16" , 
"departure_time" : "23:44:34" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "23:47:18" , 
"departure_time" : "23:48:13" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "23:47:55" , 
"departure_time" : "23:48:23" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:53:28" , 
"departure_time" : "23:54:53" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:56:25" , 
"departure_time" : "23:56:43" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:57:18" , 
"departure_time" : "23:57:39" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:59:21" , 
"departure_time" : "24:00:13" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "24:01:52" , 
"departure_time" : "24:01:55" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "24:03:03" , 
"departure_time" : "24:04:07" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "24:05:04" , 
"departure_time" : "24:06:03" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "24:07:59" , 
"departure_time" : "24:08:35" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "24:10:36" , 
"departure_time" : "24:11:47" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "24:13:11" , 
"departure_time" : "24:14:01" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "24:14:50" , 
"departure_time" : "24:14:50" , 
"distance_traveled" : 10.0589
} ], 
"819" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "23:56:00" , 
"departure_time" : "23:57:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "23:58:56" , 
"departure_time" : "24:00:04" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "24:01:08" , 
"departure_time" : "24:01:55" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "24:03:47" , 
"departure_time" : "24:04:21" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "24:06:34" , 
"departure_time" : "24:06:50" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "24:07:16" , 
"departure_time" : "24:08:18" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "24:14:02" , 
"departure_time" : "24:14:59" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "24:15:57" , 
"departure_time" : "24:16:14" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "24:17:17" , 
"departure_time" : "24:17:26" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "24:19:09" , 
"departure_time" : "24:20:49" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "24:22:40" , 
"departure_time" : "24:23:53" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "24:24:13" , 
"departure_time" : "24:24:48" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "24:24:35" , 
"departure_time" : "24:25:56" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "24:28:21" , 
"departure_time" : "24:29:20" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "24:30:59" , 
"departure_time" : "24:31:27" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "24:32:28" , 
"departure_time" : "24:32:37" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "24:34:09" , 
"departure_time" : "24:34:09" , 
"distance_traveled" : 10.0589
} ], 
"820" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "24:16:00" , 
"departure_time" : "24:17:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "24:19:01" , 
"departure_time" : "24:20:40" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "24:21:39" , 
"departure_time" : "24:22:22" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "24:23:43" , 
"departure_time" : "24:24:52" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "24:27:09" , 
"departure_time" : "24:28:18" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "24:28:09" , 
"departure_time" : "24:28:36" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "24:33:27" , 
"departure_time" : "24:33:29" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "24:35:02" , 
"departure_time" : "24:35:59" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "24:37:57" , 
"departure_time" : "24:39:26" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "24:40:29" , 
"departure_time" : "24:41:48" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "24:42:19" , 
"departure_time" : "24:42:47" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "24:43:28" , 
"departure_time" : "24:43:42" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "24:44:14" , 
"departure_time" : "24:45:27" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "24:48:13" , 
"departure_time" : "24:48:54" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "24:50:41" , 
"departure_time" : "24:52:12" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "24:53:31" , 
"departure_time" : "24:54:42" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "24:55:11" , 
"departure_time" : "24:55:11" , 
"distance_traveled" : 10.0589
} ], 
"821" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "24:36:00" , 
"departure_time" : "24:38:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "24:39:39" , 
"departure_time" : "24:40:00" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "24:40:21" , 
"departure_time" : "24:41:12" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "24:43:51" , 
"departure_time" : "24:44:17" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "24:46:26" , 
"departure_time" : "24:47:38" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "24:48:12" , 
"departure_time" : "24:49:06" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "24:53:54" , 
"departure_time" : "24:55:00" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "24:56:06" , 
"departure_time" : "24:57:36" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "24:58:30" , 
"departure_time" : "25:00:10" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "25:00:40" , 
"departure_time" : "25:01:50" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "25:02:10" , 
"departure_time" : "25:02:44" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "25:03:34" , 
"departure_time" : "25:05:04" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "25:05:30" , 
"departure_time" : "25:06:33" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "25:08:03" , 
"departure_time" : "25:08:52" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "25:10:49" , 
"departure_time" : "25:11:17" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "25:12:28" , 
"departure_time" : "25:12:55" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "25:14:27" , 
"departure_time" : "25:14:27" , 
"distance_traveled" : 10.0589
} ], 
"822" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "25:01:00" , 
"departure_time" : "25:02:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "25:03:40" , 
"departure_time" : "25:04:28" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "25:05:48" , 
"departure_time" : "25:07:23" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "25:09:35" , 
"departure_time" : "25:11:03" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "25:12:28" , 
"departure_time" : "25:13:21" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "25:12:53" , 
"departure_time" : "25:13:24" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "25:18:31" , 
"departure_time" : "25:19:39" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "25:21:08" , 
"departure_time" : "25:21:21" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "25:22:13" , 
"departure_time" : "25:22:17" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "25:24:04" , 
"departure_time" : "25:25:05" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "25:27:01" , 
"departure_time" : "25:28:04" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "25:29:03" , 
"departure_time" : "25:29:14" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "25:29:11" , 
"departure_time" : "25:30:28" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "25:33:17" , 
"departure_time" : "25:33:33" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "25:35:16" , 
"departure_time" : "25:36:07" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "25:37:51" , 
"departure_time" : "25:37:54" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "25:39:03" , 
"departure_time" : "25:39:03" , 
"distance_traveled" : 10.0589
} ], 
"823" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "25:31:00" , 
"departure_time" : "25:31:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "25:33:01" , 
"departure_time" : "25:34:02" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "25:36:01" , 
"departure_time" : "25:37:06" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "25:39:05" , 
"departure_time" : "25:40:08" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "25:42:03" , 
"departure_time" : "25:43:06" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "25:43:03" , 
"departure_time" : "25:43:52" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "25:48:49" , 
"departure_time" : "25:50:05" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "25:51:16" , 
"departure_time" : "25:52:31" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "25:53:15" , 
"departure_time" : "25:54:33" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "25:55:18" , 
"departure_time" : "25:55:42" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "25:56:24" , 
"departure_time" : "25:56:32" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "25:58:08" , 
"departure_time" : "25:58:22" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "25:59:14" , 
"departure_time" : "25:59:18" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "26:02:04" , 
"departure_time" : "26:03:39" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "26:06:35" , 
"departure_time" : "26:07:14" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "26:07:39" , 
"departure_time" : "26:08:15" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "26:09:36" , 
"departure_time" : "26:09:36" , 
"distance_traveled" : 10.0589
} ], 
"824" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "05:11:00" , 
"departure_time" : "05:12:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "05:14:07" , 
"departure_time" : "05:14:37" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "05:15:30" , 
"departure_time" : "05:16:59" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "05:18:29" , 
"departure_time" : "05:19:33" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "05:20:04" , 
"departure_time" : "05:20:33" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "05:20:29" , 
"departure_time" : "05:21:09" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "05:23:40" , 
"departure_time" : "05:25:02" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "05:27:22" , 
"departure_time" : "05:28:42" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "05:28:20" , 
"departure_time" : "05:29:22" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "05:30:02" , 
"departure_time" : "05:31:27" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "05:32:25" , 
"departure_time" : "05:32:51" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "05:33:26" , 
"departure_time" : "05:34:37" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "05:36:11" , 
"departure_time" : "05:37:15" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "05:39:04" , 
"departure_time" : "05:39:18" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "05:43:14" , 
"departure_time" : "05:43:14" , 
"distance_traveled" : 9.0456
} ], 
"825" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "05:25:00" , 
"departure_time" : "05:25:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "05:27:07" , 
"departure_time" : "05:28:01" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "05:29:54" , 
"departure_time" : "05:30:22" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "05:31:28" , 
"departure_time" : "05:33:03" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "05:34:35" , 
"departure_time" : "05:34:48" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "05:34:13" , 
"departure_time" : "05:34:54" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "05:37:41" , 
"departure_time" : "05:38:45" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "05:41:04" , 
"departure_time" : "05:42:35" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "05:42:31" , 
"departure_time" : "05:43:58" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "05:44:27" , 
"departure_time" : "05:44:46" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "05:45:19" , 
"departure_time" : "05:46:51" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "05:48:32" , 
"departure_time" : "05:49:53" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "05:50:21" , 
"departure_time" : "05:50:41" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "05:52:20" , 
"departure_time" : "05:52:24" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "05:57:04" , 
"departure_time" : "05:57:04" , 
"distance_traveled" : 9.0456
} ], 
"826" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "05:40:00" , 
"departure_time" : "05:41:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "05:43:26" , 
"departure_time" : "05:43:43" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "05:44:17" , 
"departure_time" : "05:44:52" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "05:46:35" , 
"departure_time" : "05:46:59" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "05:48:24" , 
"departure_time" : "05:49:14" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "05:49:50" , 
"departure_time" : "05:50:38" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "05:52:48" , 
"departure_time" : "05:53:55" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "05:56:07" , 
"departure_time" : "05:56:08" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "05:56:01" , 
"departure_time" : "05:57:08" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "05:59:07" , 
"departure_time" : "06:00:41" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:01:34" , 
"departure_time" : "06:02:55" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:03:21" , 
"departure_time" : "06:03:33" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:04:12" , 
"departure_time" : "06:04:17" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:07:05" , 
"departure_time" : "06:07:33" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "06:12:28" , 
"departure_time" : "06:12:28" , 
"distance_traveled" : 9.0456
} ], 
"827" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "05:54:00" , 
"departure_time" : "05:55:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "05:56:46" , 
"departure_time" : "05:57:28" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "05:58:42" , 
"departure_time" : "05:58:44" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "06:00:02" , 
"departure_time" : "06:00:26" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "06:02:24" , 
"departure_time" : "06:03:34" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "06:04:10" , 
"departure_time" : "06:04:13" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:06:03" , 
"departure_time" : "06:06:05" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:09:02" , 
"departure_time" : "06:09:10" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:10:08" , 
"departure_time" : "06:10:35" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:12:27" , 
"departure_time" : "06:12:47" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:14:20" , 
"departure_time" : "06:15:45" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:17:25" , 
"departure_time" : "06:18:13" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:18:48" , 
"departure_time" : "06:19:51" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:22:03" , 
"departure_time" : "06:23:24" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "06:27:21" , 
"departure_time" : "06:27:21" , 
"distance_traveled" : 9.0456
} ], 
"828" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "06:06:00" , 
"departure_time" : "06:07:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "06:08:06" , 
"departure_time" : "06:08:15" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "06:10:09" , 
"departure_time" : "06:11:40" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "06:13:31" , 
"departure_time" : "06:14:43" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "06:15:12" , 
"departure_time" : "06:16:07" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "06:15:55" , 
"departure_time" : "06:16:23" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:18:28" , 
"departure_time" : "06:18:30" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:21:02" , 
"departure_time" : "06:21:24" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:22:22" , 
"departure_time" : "06:23:19" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:24:57" , 
"departure_time" : "06:26:10" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:27:13" , 
"departure_time" : "06:27:34" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:28:21" , 
"departure_time" : "06:29:17" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:30:56" , 
"departure_time" : "06:32:04" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:34:08" , 
"departure_time" : "06:34:22" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "06:38:14" , 
"departure_time" : "06:38:14" , 
"distance_traveled" : 9.0456
} ], 
"829" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "06:18:00" , 
"departure_time" : "06:19:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "06:20:59" , 
"departure_time" : "06:21:13" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "06:22:14" , 
"departure_time" : "06:23:23" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "06:25:09" , 
"departure_time" : "06:25:14" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "06:26:05" , 
"departure_time" : "06:26:38" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "06:27:33" , 
"departure_time" : "06:29:01" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:31:28" , 
"departure_time" : "06:31:57" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:33:29" , 
"departure_time" : "06:34:24" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:34:55" , 
"departure_time" : "06:36:10" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:37:15" , 
"departure_time" : "06:37:34" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:38:19" , 
"departure_time" : "06:38:59" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:40:40" , 
"departure_time" : "06:41:27" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:42:47" , 
"departure_time" : "06:43:58" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:46:11" , 
"departure_time" : "06:47:29" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "06:51:18" , 
"departure_time" : "06:51:18" , 
"distance_traveled" : 9.0456
} ], 
"830" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "06:36:00" , 
"departure_time" : "06:38:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "06:39:30" , 
"departure_time" : "06:40:43" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "06:41:13" , 
"departure_time" : "06:42:49" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "06:43:36" , 
"departure_time" : "06:44:13" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "06:44:37" , 
"departure_time" : "06:45:58" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "06:46:21" , 
"departure_time" : "06:47:33" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:49:12" , 
"departure_time" : "06:50:37" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:52:25" , 
"departure_time" : "06:53:51" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:53:26" , 
"departure_time" : "06:53:29" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:54:03" , 
"departure_time" : "06:55:38" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:57:35" , 
"departure_time" : "06:57:48" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:58:13" , 
"departure_time" : "06:59:41" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:01:28" , 
"departure_time" : "07:02:02" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:03:34" , 
"departure_time" : "07:04:39" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "07:09:05" , 
"departure_time" : "07:09:05" , 
"distance_traveled" : 9.0456
} ], 
"831" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "06:47:00" , 
"departure_time" : "06:48:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "06:49:13" , 
"departure_time" : "06:49:44" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "06:51:31" , 
"departure_time" : "06:51:56" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "06:53:25" , 
"departure_time" : "06:54:17" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "06:55:52" , 
"departure_time" : "06:56:13" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "06:56:21" , 
"departure_time" : "06:56:44" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:59:23" , 
"departure_time" : "07:00:33" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:03:10" , 
"departure_time" : "07:04:41" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:04:31" , 
"departure_time" : "07:05:57" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:06:26" , 
"departure_time" : "07:07:18" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:07:52" , 
"departure_time" : "07:09:26" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:10:34" , 
"departure_time" : "07:10:37" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:11:03" , 
"departure_time" : "07:11:09" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:14:06" , 
"departure_time" : "07:15:43" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "07:20:37" , 
"departure_time" : "07:20:37" , 
"distance_traveled" : 9.0456
} ], 
"832" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "07:16:00" , 
"departure_time" : "07:17:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "07:18:19" , 
"departure_time" : "07:18:53" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "07:20:34" , 
"departure_time" : "07:21:23" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "07:22:49" , 
"departure_time" : "07:23:41" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "07:24:52" , 
"departure_time" : "07:25:08" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "07:25:16" , 
"departure_time" : "07:26:40" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:29:24" , 
"departure_time" : "07:30:05" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:31:41" , 
"departure_time" : "07:31:49" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:32:08" , 
"departure_time" : "07:33:06" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:34:58" , 
"departure_time" : "07:35:18" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:36:20" , 
"departure_time" : "07:36:38" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:38:18" , 
"departure_time" : "07:38:48" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:40:30" , 
"departure_time" : "07:41:29" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:43:59" , 
"departure_time" : "07:44:16" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "07:48:17" , 
"departure_time" : "07:48:17" , 
"distance_traveled" : 9.0456
} ], 
"833" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "07:45:00" , 
"departure_time" : "07:45:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "07:47:40" , 
"departure_time" : "07:48:24" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "07:49:44" , 
"departure_time" : "07:50:36" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "07:51:52" , 
"departure_time" : "07:53:15" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "07:54:23" , 
"departure_time" : "07:55:48" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "07:55:25" , 
"departure_time" : "07:55:34" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:57:09" , 
"departure_time" : "07:57:49" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:00:40" , 
"departure_time" : "08:02:03" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:02:23" , 
"departure_time" : "08:02:54" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:03:31" , 
"departure_time" : "08:03:52" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:05:21" , 
"departure_time" : "08:05:30" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:07:09" , 
"departure_time" : "08:07:14" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:09:05" , 
"departure_time" : "08:10:22" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:13:17" , 
"departure_time" : "08:14:23" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "08:18:06" , 
"departure_time" : "08:18:06" , 
"distance_traveled" : 9.0456
} ], 
"834" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "08:10:00" , 
"departure_time" : "08:12:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "08:13:01" , 
"departure_time" : "08:14:06" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "08:15:05" , 
"departure_time" : "08:16:43" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "08:17:38" , 
"departure_time" : "08:18:13" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "08:18:35" , 
"departure_time" : "08:20:01" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "08:20:26" , 
"departure_time" : "08:20:37" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:22:11" , 
"departure_time" : "08:23:05" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:25:54" , 
"departure_time" : "08:26:15" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:26:21" , 
"departure_time" : "08:27:03" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:28:42" , 
"departure_time" : "08:30:06" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:31:24" , 
"departure_time" : "08:31:31" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:32:07" , 
"departure_time" : "08:33:05" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:34:58" , 
"departure_time" : "08:35:59" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:38:01" , 
"departure_time" : "08:39:39" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "08:43:38" , 
"departure_time" : "08:43:38" , 
"distance_traveled" : 9.0456
} ], 
"835" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "08:29:00" , 
"departure_time" : "08:32:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "08:32:26" , 
"departure_time" : "08:33:42" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "08:34:16" , 
"departure_time" : "08:34:34" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "08:35:18" , 
"departure_time" : "08:36:07" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "08:37:49" , 
"departure_time" : "08:39:06" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "08:39:17" , 
"departure_time" : "08:39:46" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:41:29" , 
"departure_time" : "08:43:03" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:45:34" , 
"departure_time" : "08:46:40" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:46:06" , 
"departure_time" : "08:47:23" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:48:17" , 
"departure_time" : "08:49:03" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:49:46" , 
"departure_time" : "08:50:39" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:51:53" , 
"departure_time" : "08:52:55" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:54:02" , 
"departure_time" : "08:54:24" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:56:22" , 
"departure_time" : "08:56:55" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "09:01:33" , 
"departure_time" : "09:01:33" , 
"distance_traveled" : 9.0456
} ], 
"836" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "09:11:00" , 
"departure_time" : "09:12:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "09:13:50" , 
"departure_time" : "09:14:21" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "09:15:31" , 
"departure_time" : "09:16:53" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "09:18:22" , 
"departure_time" : "09:18:39" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "09:19:17" , 
"departure_time" : "09:20:46" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "09:21:29" , 
"departure_time" : "09:21:50" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:23:21" , 
"departure_time" : "09:24:42" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:27:21" , 
"departure_time" : "09:28:54" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:28:33" , 
"departure_time" : "09:28:45" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:29:12" , 
"departure_time" : "09:29:28" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:31:16" , 
"departure_time" : "09:31:50" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:33:34" , 
"departure_time" : "09:34:15" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:35:41" , 
"departure_time" : "09:35:46" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:38:05" , 
"departure_time" : "09:39:16" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "09:44:11" , 
"departure_time" : "09:44:11" , 
"distance_traveled" : 9.0456
} ], 
"837" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "09:23:00" , 
"departure_time" : "09:25:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "09:25:56" , 
"departure_time" : "09:26:17" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "09:27:21" , 
"departure_time" : "09:28:16" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "09:29:55" , 
"departure_time" : "09:29:57" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "09:31:02" , 
"departure_time" : "09:32:13" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "09:33:11" , 
"departure_time" : "09:33:36" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:35:25" , 
"departure_time" : "09:37:00" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:39:35" , 
"departure_time" : "09:39:37" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:39:02" , 
"departure_time" : "09:40:36" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:42:34" , 
"departure_time" : "09:43:40" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:44:06" , 
"departure_time" : "09:45:17" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:46:11" , 
"departure_time" : "09:46:24" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:47:13" , 
"departure_time" : "09:48:09" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:50:56" , 
"departure_time" : "09:51:05" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "09:55:09" , 
"departure_time" : "09:55:09" , 
"distance_traveled" : 9.0456
} ], 
"838" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "09:32:00" , 
"departure_time" : "09:33:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "09:35:18" , 
"departure_time" : "09:36:23" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "09:37:05" , 
"departure_time" : "09:37:31" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "09:38:26" , 
"departure_time" : "09:39:43" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "09:41:17" , 
"departure_time" : "09:42:26" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "09:42:09" , 
"departure_time" : "09:43:33" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:45:24" , 
"departure_time" : "09:46:37" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:48:13" , 
"departure_time" : "09:48:16" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:48:03" , 
"departure_time" : "09:48:07" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:50:04" , 
"departure_time" : "09:50:48" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:52:44" , 
"departure_time" : "09:52:57" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:54:13" , 
"departure_time" : "09:54:54" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:56:41" , 
"departure_time" : "09:58:20" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:00:39" , 
"departure_time" : "10:01:21" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "10:04:42" , 
"departure_time" : "10:04:42" , 
"distance_traveled" : 9.0456
} ], 
"839" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "09:49:00" , 
"departure_time" : "09:51:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "09:52:27" , 
"departure_time" : "09:52:49" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "09:53:22" , 
"departure_time" : "09:55:02" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "09:56:40" , 
"departure_time" : "09:57:26" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "09:57:46" , 
"departure_time" : "09:59:11" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "09:59:25" , 
"departure_time" : "09:59:58" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:01:33" , 
"departure_time" : "10:02:58" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:05:25" , 
"departure_time" : "10:06:50" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:06:25" , 
"departure_time" : "10:07:39" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:08:14" , 
"departure_time" : "10:09:30" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:10:16" , 
"departure_time" : "10:10:56" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:11:40" , 
"departure_time" : "10:12:04" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:13:24" , 
"departure_time" : "10:14:01" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:16:37" , 
"departure_time" : "10:16:50" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "10:21:13" , 
"departure_time" : "10:21:13" , 
"distance_traveled" : 9.0456
} ], 
"840" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "10:11:00" , 
"departure_time" : "10:11:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "10:13:28" , 
"departure_time" : "10:13:33" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "10:15:05" , 
"departure_time" : "10:15:55" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "10:17:50" , 
"departure_time" : "10:19:28" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "10:20:38" , 
"departure_time" : "10:20:55" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "10:20:17" , 
"departure_time" : "10:21:41" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:24:24" , 
"departure_time" : "10:25:13" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:26:49" , 
"departure_time" : "10:27:39" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:27:50" , 
"departure_time" : "10:28:03" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:29:13" , 
"departure_time" : "10:30:34" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:32:21" , 
"departure_time" : "10:32:32" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:33:11" , 
"departure_time" : "10:34:37" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:36:26" , 
"departure_time" : "10:37:16" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:38:50" , 
"departure_time" : "10:39:28" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "10:43:38" , 
"departure_time" : "10:43:38" , 
"distance_traveled" : 9.0456
} ], 
"841" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "10:31:00" , 
"departure_time" : "10:32:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "10:34:06" , 
"departure_time" : "10:34:11" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "10:35:05" , 
"departure_time" : "10:35:23" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "10:37:18" , 
"departure_time" : "10:37:40" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "10:39:22" , 
"departure_time" : "10:40:08" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "10:40:46" , 
"departure_time" : "10:41:34" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:43:48" , 
"departure_time" : "10:45:14" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:47:26" , 
"departure_time" : "10:47:35" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:47:09" , 
"departure_time" : "10:48:38" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:50:29" , 
"departure_time" : "10:51:44" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:52:15" , 
"departure_time" : "10:53:21" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:54:06" , 
"departure_time" : "10:54:27" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:55:21" , 
"departure_time" : "10:55:31" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:58:10" , 
"departure_time" : "10:58:39" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "11:03:29" , 
"departure_time" : "11:03:29" , 
"distance_traveled" : 9.0456
} ], 
"842" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "10:51:00" , 
"departure_time" : "10:52:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "10:54:08" , 
"departure_time" : "10:55:13" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "10:56:05" , 
"departure_time" : "10:57:02" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "10:57:57" , 
"departure_time" : "10:58:16" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "10:59:19" , 
"departure_time" : "11:00:39" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "11:01:20" , 
"departure_time" : "11:02:34" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:04:14" , 
"departure_time" : "11:04:56" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:06:42" , 
"departure_time" : "11:07:40" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:07:58" , 
"departure_time" : "11:09:22" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:10:24" , 
"departure_time" : "11:11:29" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:12:05" , 
"departure_time" : "11:13:41" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:14:36" , 
"departure_time" : "11:14:42" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:15:06" , 
"departure_time" : "11:16:37" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:19:31" , 
"departure_time" : "11:20:24" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "11:23:53" , 
"departure_time" : "11:23:53" , 
"distance_traveled" : 9.0456
} ], 
"843" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "11:11:00" , 
"departure_time" : "11:12:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "11:13:20" , 
"departure_time" : "11:14:00" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "11:15:40" , 
"departure_time" : "11:15:54" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "11:17:14" , 
"departure_time" : "11:18:05" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "11:19:51" , 
"departure_time" : "11:21:25" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "11:21:34" , 
"departure_time" : "11:22:44" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:24:10" , 
"departure_time" : "11:25:01" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:26:51" , 
"departure_time" : "11:26:59" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:27:08" , 
"departure_time" : "11:28:07" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:29:59" , 
"departure_time" : "11:30:48" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:31:49" , 
"departure_time" : "11:32:52" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:34:03" , 
"departure_time" : "11:34:26" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:35:23" , 
"departure_time" : "11:36:54" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:39:31" , 
"departure_time" : "11:40:04" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "11:43:33" , 
"departure_time" : "11:43:33" , 
"distance_traveled" : 9.0456
} ], 
"844" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "11:31:00" , 
"departure_time" : "11:32:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "11:34:01" , 
"departure_time" : "11:35:11" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "11:36:10" , 
"departure_time" : "11:36:52" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "11:37:42" , 
"departure_time" : "11:39:19" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "11:40:37" , 
"departure_time" : "11:41:41" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "11:41:04" , 
"departure_time" : "11:41:29" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:43:25" , 
"departure_time" : "11:45:01" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:47:36" , 
"departure_time" : "11:47:48" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:47:12" , 
"departure_time" : "11:48:45" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:50:33" , 
"departure_time" : "11:51:15" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:51:42" , 
"departure_time" : "11:52:47" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:54:05" , 
"departure_time" : "11:54:51" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:55:46" , 
"departure_time" : "11:56:20" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:58:34" , 
"departure_time" : "11:59:34" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "12:04:00" , 
"departure_time" : "12:04:00" , 
"distance_traveled" : 9.0456
} ], 
"845" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "11:51:00" , 
"departure_time" : "11:53:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "11:54:03" , 
"departure_time" : "11:54:50" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "11:55:47" , 
"departure_time" : "11:56:48" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "11:58:01" , 
"departure_time" : "11:59:16" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "12:00:15" , 
"departure_time" : "12:01:22" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "12:01:07" , 
"departure_time" : "12:02:18" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:04:11" , 
"departure_time" : "12:05:10" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:06:59" , 
"departure_time" : "12:07:07" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:07:08" , 
"departure_time" : "12:07:43" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:09:35" , 
"departure_time" : "12:10:57" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:12:22" , 
"departure_time" : "12:13:12" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:13:50" , 
"departure_time" : "12:15:16" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:16:26" , 
"departure_time" : "12:16:39" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:18:13" , 
"departure_time" : "12:18:59" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "12:23:46" , 
"departure_time" : "12:23:46" , 
"distance_traveled" : 9.0456
} ], 
"846" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "12:11:00" , 
"departure_time" : "12:12:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "12:13:52" , 
"departure_time" : "12:14:38" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "12:15:46" , 
"departure_time" : "12:16:58" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "12:18:12" , 
"departure_time" : "12:19:47" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "12:20:35" , 
"departure_time" : "12:21:57" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "12:21:22" , 
"departure_time" : "12:21:44" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:23:22" , 
"departure_time" : "12:23:29" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:26:07" , 
"departure_time" : "12:26:45" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:27:38" , 
"departure_time" : "12:28:58" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:30:20" , 
"departure_time" : "12:31:30" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:32:10" , 
"departure_time" : "12:32:54" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:33:44" , 
"departure_time" : "12:34:22" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:35:38" , 
"departure_time" : "12:36:46" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:39:08" , 
"departure_time" : "12:39:30" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "12:43:22" , 
"departure_time" : "12:43:22" , 
"distance_traveled" : 9.0456
} ], 
"847" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "12:31:00" , 
"departure_time" : "12:32:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "12:34:24" , 
"departure_time" : "12:35:07" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "12:35:43" , 
"departure_time" : "12:36:48" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "12:38:05" , 
"departure_time" : "12:39:04" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "12:39:59" , 
"departure_time" : "12:40:40" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "12:40:41" , 
"departure_time" : "12:42:14" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:44:33" , 
"departure_time" : "12:46:11" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:47:38" , 
"departure_time" : "12:47:54" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:47:16" , 
"departure_time" : "12:48:34" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:50:18" , 
"departure_time" : "12:50:46" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:51:28" , 
"departure_time" : "12:52:35" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:54:07" , 
"departure_time" : "12:54:15" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:55:08" , 
"departure_time" : "12:56:48" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:59:40" , 
"departure_time" : "13:01:08" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "13:04:28" , 
"departure_time" : "13:04:28" , 
"distance_traveled" : 9.0456
} ], 
"848" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "12:51:00" , 
"departure_time" : "12:52:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "12:53:17" , 
"departure_time" : "12:54:43" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "12:56:26" , 
"departure_time" : "12:56:30" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "12:57:04" , 
"departure_time" : "12:58:12" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "13:00:08" , 
"departure_time" : "13:01:12" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "13:01:04" , 
"departure_time" : "13:01:48" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:03:44" , 
"departure_time" : "13:04:52" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:07:08" , 
"departure_time" : "13:08:36" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:08:28" , 
"departure_time" : "13:09:09" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:09:41" , 
"departure_time" : "13:10:37" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:11:56" , 
"departure_time" : "13:12:24" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:13:28" , 
"departure_time" : "13:14:42" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:16:14" , 
"departure_time" : "13:17:21" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:19:07" , 
"departure_time" : "13:19:13" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "13:23:06" , 
"departure_time" : "13:23:06" , 
"distance_traveled" : 9.0456
} ], 
"849" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "13:11:00" , 
"departure_time" : "13:12:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "13:14:00" , 
"departure_time" : "13:14:48" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "13:15:48" , 
"departure_time" : "13:15:52" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "13:17:04" , 
"departure_time" : "13:18:23" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "13:20:19" , 
"departure_time" : "13:21:54" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "13:21:35" , 
"departure_time" : "13:21:57" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:23:22" , 
"departure_time" : "13:23:53" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:26:31" , 
"departure_time" : "13:27:15" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:27:44" , 
"departure_time" : "13:29:13" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:30:29" , 
"departure_time" : "13:31:13" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:31:44" , 
"departure_time" : "13:32:40" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:33:56" , 
"departure_time" : "13:34:58" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:36:02" , 
"departure_time" : "13:37:23" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:39:21" , 
"departure_time" : "13:40:06" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "13:43:45" , 
"departure_time" : "13:43:45" , 
"distance_traveled" : 9.0456
} ], 
"850" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "13:31:00" , 
"departure_time" : "13:32:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "13:33:46" , 
"departure_time" : "13:34:53" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "13:36:07" , 
"departure_time" : "13:36:30" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "13:37:23" , 
"departure_time" : "13:37:26" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "13:39:03" , 
"departure_time" : "13:40:31" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "13:41:28" , 
"departure_time" : "13:42:05" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:43:37" , 
"departure_time" : "13:44:03" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:46:26" , 
"departure_time" : "13:46:34" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:47:08" , 
"departure_time" : "13:48:25" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:50:17" , 
"departure_time" : "13:51:21" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:52:04" , 
"departure_time" : "13:53:44" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:54:40" , 
"departure_time" : "13:54:53" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:55:13" , 
"departure_time" : "13:55:47" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:58:34" , 
"departure_time" : "13:59:28" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "14:03:54" , 
"departure_time" : "14:03:54" , 
"distance_traveled" : 9.0456
} ], 
"851" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "13:51:00" , 
"departure_time" : "13:52:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "13:53:08" , 
"departure_time" : "13:54:20" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "13:56:12" , 
"departure_time" : "13:56:15" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "13:57:03" , 
"departure_time" : "13:57:36" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "13:59:33" , 
"departure_time" : "13:59:55" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "14:00:22" , 
"departure_time" : "14:01:12" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:03:50" , 
"departure_time" : "14:04:14" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:06:24" , 
"departure_time" : "14:07:52" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:08:28" , 
"departure_time" : "14:09:01" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:09:33" , 
"departure_time" : "14:10:10" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:11:37" , 
"departure_time" : "14:12:13" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:13:36" , 
"departure_time" : "14:13:50" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:15:14" , 
"departure_time" : "14:15:21" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:18:07" , 
"departure_time" : "14:18:19" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "14:23:12" , 
"departure_time" : "14:23:12" , 
"distance_traveled" : 9.0456
} ], 
"852" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "14:11:00" , 
"departure_time" : "14:11:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "14:13:30" , 
"departure_time" : "14:13:40" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "14:15:10" , 
"departure_time" : "14:15:11" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "14:17:01" , 
"departure_time" : "14:18:03" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "14:20:02" , 
"departure_time" : "14:21:42" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "14:21:40" , 
"departure_time" : "14:21:55" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:23:15" , 
"departure_time" : "14:23:25" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:26:10" , 
"departure_time" : "14:26:17" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:27:07" , 
"departure_time" : "14:28:18" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:30:11" , 
"departure_time" : "14:30:21" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:31:10" , 
"departure_time" : "14:31:42" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:33:32" , 
"departure_time" : "14:34:03" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:35:31" , 
"departure_time" : "14:35:37" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:38:06" , 
"departure_time" : "14:38:28" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "14:43:22" , 
"departure_time" : "14:43:22" , 
"distance_traveled" : 9.0456
} ], 
"853" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "14:31:00" , 
"departure_time" : "14:32:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "14:34:16" , 
"departure_time" : "14:35:56" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "14:36:40" , 
"departure_time" : "14:37:02" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "14:37:22" , 
"departure_time" : "14:37:29" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "14:39:07" , 
"departure_time" : "14:39:29" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "14:40:22" , 
"departure_time" : "14:41:05" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:43:43" , 
"departure_time" : "14:44:11" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:46:28" , 
"departure_time" : "14:47:20" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:47:52" , 
"departure_time" : "14:48:46" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:49:54" , 
"departure_time" : "14:49:59" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:51:05" , 
"departure_time" : "14:52:16" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:54:11" , 
"departure_time" : "14:55:42" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:56:31" , 
"departure_time" : "14:56:57" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:58:26" , 
"departure_time" : "14:58:52" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "15:03:26" , 
"departure_time" : "15:03:26" , 
"distance_traveled" : 9.0456
} ], 
"854" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "14:51:00" , 
"departure_time" : "14:52:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "14:54:11" , 
"departure_time" : "14:54:15" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "14:55:04" , 
"departure_time" : "14:56:18" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "14:58:14" , 
"departure_time" : "14:59:01" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "14:59:47" , 
"departure_time" : "15:00:17" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "15:00:30" , 
"departure_time" : "15:01:52" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:04:22" , 
"departure_time" : "15:05:27" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:07:05" , 
"departure_time" : "15:08:27" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:08:22" , 
"departure_time" : "15:09:34" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:10:12" , 
"departure_time" : "15:10:56" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:11:44" , 
"departure_time" : "15:11:49" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:13:05" , 
"departure_time" : "15:13:31" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:15:26" , 
"departure_time" : "15:15:33" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:18:07" , 
"departure_time" : "15:19:14" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "15:24:07" , 
"departure_time" : "15:24:07" , 
"distance_traveled" : 9.0456
} ], 
"855" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "15:09:00" , 
"departure_time" : "15:11:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "15:12:06" , 
"departure_time" : "15:12:29" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "15:13:23" , 
"departure_time" : "15:13:34" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "15:15:11" , 
"departure_time" : "15:16:47" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "15:18:36" , 
"departure_time" : "15:19:12" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "15:18:36" , 
"departure_time" : "15:19:28" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:21:52" , 
"departure_time" : "15:21:59" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:24:07" , 
"departure_time" : "15:25:27" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:26:20" , 
"departure_time" : "15:27:42" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:28:22" , 
"departure_time" : "15:28:38" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:29:16" , 
"departure_time" : "15:29:46" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:31:30" , 
"departure_time" : "15:32:18" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:33:48" , 
"departure_time" : "15:34:48" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:37:00" , 
"departure_time" : "15:37:45" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "15:41:45" , 
"departure_time" : "15:41:45" , 
"distance_traveled" : 9.0456
} ], 
"856" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "15:17:00" , 
"departure_time" : "15:17:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "15:19:13" , 
"departure_time" : "15:19:18" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "15:21:05" , 
"departure_time" : "15:22:05" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "15:24:00" , 
"departure_time" : "15:24:35" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "15:25:35" , 
"departure_time" : "15:26:59" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "15:27:24" , 
"departure_time" : "15:28:14" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:29:50" , 
"departure_time" : "15:31:17" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:33:27" , 
"departure_time" : "15:33:51" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:33:24" , 
"departure_time" : "15:34:51" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:36:27" , 
"departure_time" : "15:36:49" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:37:22" , 
"departure_time" : "15:38:42" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:40:20" , 
"departure_time" : "15:40:59" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:41:39" , 
"departure_time" : "15:42:17" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:44:38" , 
"departure_time" : "15:46:13" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "15:50:35" , 
"departure_time" : "15:50:35" , 
"distance_traveled" : 9.0456
} ], 
"857" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "15:29:00" , 
"departure_time" : "15:31:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "15:32:24" , 
"departure_time" : "15:33:54" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "15:34:30" , 
"departure_time" : "15:35:41" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "15:36:11" , 
"departure_time" : "15:37:45" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "15:38:34" , 
"departure_time" : "15:39:56" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "15:39:22" , 
"departure_time" : "15:40:07" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:41:45" , 
"departure_time" : "15:43:22" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:45:37" , 
"departure_time" : "15:46:03" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:45:26" , 
"departure_time" : "15:45:53" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:47:27" , 
"departure_time" : "15:47:42" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:49:15" , 
"departure_time" : "15:49:52" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:51:37" , 
"departure_time" : "15:52:06" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:53:29" , 
"departure_time" : "15:55:00" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:57:31" , 
"departure_time" : "15:58:11" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "16:01:40" , 
"departure_time" : "16:01:40" , 
"distance_traveled" : 9.0456
} ], 
"858" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "15:35:00" , 
"departure_time" : "15:37:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "15:38:23" , 
"departure_time" : "15:38:56" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "15:39:33" , 
"departure_time" : "15:40:29" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "15:41:56" , 
"departure_time" : "15:43:29" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "15:44:33" , 
"departure_time" : "15:45:33" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "15:45:00" , 
"departure_time" : "15:45:18" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:47:18" , 
"departure_time" : "15:47:22" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:50:04" , 
"departure_time" : "15:51:39" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:52:35" , 
"departure_time" : "15:52:36" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:53:01" , 
"departure_time" : "15:54:13" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:56:12" , 
"departure_time" : "15:56:20" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:57:08" , 
"departure_time" : "15:57:22" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:59:14" , 
"departure_time" : "16:00:54" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:03:40" , 
"departure_time" : "16:04:51" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "16:08:11" , 
"departure_time" : "16:08:11" , 
"distance_traveled" : 9.0456
} ], 
"859" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "15:48:00" , 
"departure_time" : "15:50:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "15:51:05" , 
"departure_time" : "15:51:08" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "15:52:03" , 
"departure_time" : "15:53:10" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "15:55:07" , 
"departure_time" : "15:55:29" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "15:56:22" , 
"departure_time" : "15:57:06" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "15:57:44" , 
"departure_time" : "15:59:00" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:01:16" , 
"departure_time" : "16:02:52" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:04:36" , 
"departure_time" : "16:05:08" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:04:32" , 
"departure_time" : "16:05:34" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:07:02" , 
"departure_time" : "16:08:04" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:09:02" , 
"departure_time" : "16:09:55" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:10:53" , 
"departure_time" : "16:11:33" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:12:40" , 
"departure_time" : "16:13:15" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:15:35" , 
"departure_time" : "16:16:32" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "16:20:57" , 
"departure_time" : "16:20:57" , 
"distance_traveled" : 9.0456
} ], 
"860" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "15:54:00" , 
"departure_time" : "15:56:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "15:57:09" , 
"departure_time" : "15:58:31" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "15:59:22" , 
"departure_time" : "15:59:53" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "16:00:31" , 
"departure_time" : "16:00:54" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "16:02:23" , 
"departure_time" : "16:02:58" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "16:03:35" , 
"departure_time" : "16:04:16" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:06:41" , 
"departure_time" : "16:06:57" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:09:16" , 
"departure_time" : "16:09:18" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:10:02" , 
"departure_time" : "16:10:34" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:12:32" , 
"departure_time" : "16:13:25" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:14:53" , 
"departure_time" : "16:15:42" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:16:49" , 
"departure_time" : "16:17:17" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:18:28" , 
"departure_time" : "16:20:07" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:22:39" , 
"departure_time" : "16:23:38" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "16:26:59" , 
"departure_time" : "16:26:59" , 
"distance_traveled" : 9.0456
} ], 
"861" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "16:07:00" , 
"departure_time" : "16:08:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "16:09:50" , 
"departure_time" : "16:11:15" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "16:12:25" , 
"departure_time" : "16:13:40" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "16:14:15" , 
"departure_time" : "16:15:45" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "16:16:30" , 
"departure_time" : "16:16:31" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "16:16:01" , 
"departure_time" : "16:17:20" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:20:19" , 
"departure_time" : "16:20:36" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:22:17" , 
"departure_time" : "16:23:36" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:24:19" , 
"departure_time" : "16:25:49" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:26:30" , 
"departure_time" : "16:27:55" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:28:25" , 
"departure_time" : "16:30:02" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:30:37" , 
"departure_time" : "16:30:55" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:31:18" , 
"departure_time" : "16:32:03" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:34:45" , 
"departure_time" : "16:35:14" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "16:39:29" , 
"departure_time" : "16:39:29" , 
"distance_traveled" : 9.0456
} ], 
"862" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "16:26:00" , 
"departure_time" : "16:26:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "16:28:06" , 
"departure_time" : "16:28:16" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "16:30:10" , 
"departure_time" : "16:30:30" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "16:32:20" , 
"departure_time" : "16:32:30" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "16:34:10" , 
"departure_time" : "16:35:17" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "16:36:07" , 
"departure_time" : "16:36:46" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:38:39" , 
"departure_time" : "16:39:14" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:41:35" , 
"departure_time" : "16:42:21" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:42:46" , 
"departure_time" : "16:42:47" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:44:01" , 
"departure_time" : "16:45:33" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:47:32" , 
"departure_time" : "16:49:10" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:49:38" , 
"departure_time" : "16:51:10" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:51:32" , 
"departure_time" : "16:53:05" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:54:33" , 
"departure_time" : "16:54:45" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "16:58:12" , 
"departure_time" : "16:58:12" , 
"distance_traveled" : 9.0456
} ], 
"863" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "16:47:00" , 
"departure_time" : "16:48:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "16:49:59" , 
"departure_time" : "16:50:19" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "16:51:20" , 
"departure_time" : "16:52:48" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "16:54:28" , 
"departure_time" : "16:54:41" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "16:55:13" , 
"departure_time" : "16:56:36" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "16:57:23" , 
"departure_time" : "16:58:16" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:59:53" , 
"departure_time" : "17:00:12" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:02:19" , 
"departure_time" : "17:03:31" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:04:12" , 
"departure_time" : "17:05:00" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:05:48" , 
"departure_time" : "17:06:55" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:08:07" , 
"departure_time" : "17:09:08" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:10:01" , 
"departure_time" : "17:11:21" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:12:20" , 
"departure_time" : "17:13:32" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:15:12" , 
"departure_time" : "17:16:31" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "17:20:19" , 
"departure_time" : "17:20:19" , 
"distance_traveled" : 9.0456
} ], 
"864" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "17:08:00" , 
"departure_time" : "17:09:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "17:10:19" , 
"departure_time" : "17:11:36" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "17:13:17" , 
"departure_time" : "17:14:15" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "17:14:58" , 
"departure_time" : "17:15:02" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "17:16:04" , 
"departure_time" : "17:16:54" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "17:17:50" , 
"departure_time" : "17:18:45" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:20:55" , 
"departure_time" : "17:22:32" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:24:37" , 
"departure_time" : "17:25:24" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:24:47" , 
"departure_time" : "17:24:58" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:26:11" , 
"departure_time" : "17:26:16" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:28:05" , 
"departure_time" : "17:29:39" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:31:34" , 
"departure_time" : "17:32:36" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:33:02" , 
"departure_time" : "17:33:03" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:35:01" , 
"departure_time" : "17:35:30" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "17:40:29" , 
"departure_time" : "17:40:29" , 
"distance_traveled" : 9.0456
} ], 
"865" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "17:22:00" , 
"departure_time" : "17:23:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "17:25:26" , 
"departure_time" : "17:26:36" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "17:27:10" , 
"departure_time" : "17:28:22" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "17:29:12" , 
"departure_time" : "17:29:23" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "17:30:11" , 
"departure_time" : "17:31:00" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "17:31:49" , 
"departure_time" : "17:32:54" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:35:05" , 
"departure_time" : "17:35:49" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:37:44" , 
"departure_time" : "17:38:14" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:38:30" , 
"departure_time" : "17:39:04" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:40:34" , 
"departure_time" : "17:41:52" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:43:18" , 
"departure_time" : "17:44:49" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:45:31" , 
"departure_time" : "17:46:18" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:46:47" , 
"departure_time" : "17:48:24" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:50:37" , 
"departure_time" : "17:52:02" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "17:55:25" , 
"departure_time" : "17:55:25" , 
"distance_traveled" : 9.0456
} ], 
"866" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "17:35:00" , 
"departure_time" : "17:37:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "17:37:43" , 
"departure_time" : "17:39:10" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "17:40:27" , 
"departure_time" : "17:41:39" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "17:42:12" , 
"departure_time" : "17:43:22" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "17:44:10" , 
"departure_time" : "17:44:39" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "17:44:29" , 
"departure_time" : "17:44:31" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:47:02" , 
"departure_time" : "17:47:48" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:50:46" , 
"departure_time" : "17:52:11" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:52:25" , 
"departure_time" : "17:52:42" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:53:17" , 
"departure_time" : "17:54:20" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:56:03" , 
"departure_time" : "17:57:21" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:58:18" , 
"departure_time" : "17:59:46" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:00:28" , 
"departure_time" : "18:00:31" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:02:03" , 
"departure_time" : "18:02:41" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "18:07:38" , 
"departure_time" : "18:07:38" , 
"distance_traveled" : 9.0456
} ], 
"867" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "17:39:00" , 
"departure_time" : "17:40:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "17:41:23" , 
"departure_time" : "17:42:31" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "17:44:08" , 
"departure_time" : "17:44:32" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "17:45:24" , 
"departure_time" : "17:46:38" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "17:48:14" , 
"departure_time" : "17:48:28" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "17:48:14" , 
"departure_time" : "17:49:48" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:52:34" , 
"departure_time" : "17:52:47" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:54:13" , 
"departure_time" : "17:54:51" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:55:38" , 
"departure_time" : "17:57:14" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:58:36" , 
"departure_time" : "17:59:05" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:59:29" , 
"departure_time" : "18:00:18" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:01:49" , 
"departure_time" : "18:02:51" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:04:02" , 
"departure_time" : "18:04:33" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:06:31" , 
"departure_time" : "18:06:47" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "18:11:16" , 
"departure_time" : "18:11:16" , 
"distance_traveled" : 9.0456
} ], 
"868" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "17:55:00" , 
"departure_time" : "17:55:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "17:57:12" , 
"departure_time" : "17:58:04" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "17:59:52" , 
"departure_time" : "18:00:42" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "18:01:50" , 
"departure_time" : "18:02:59" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "18:04:09" , 
"departure_time" : "18:05:48" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "18:05:39" , 
"departure_time" : "18:07:09" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:08:30" , 
"departure_time" : "18:09:56" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:11:26" , 
"departure_time" : "18:12:45" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:12:19" , 
"departure_time" : "18:13:42" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:14:23" , 
"departure_time" : "18:15:28" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:16:05" , 
"departure_time" : "18:17:19" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:18:14" , 
"departure_time" : "18:18:42" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:19:28" , 
"departure_time" : "18:20:23" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:22:55" , 
"departure_time" : "18:23:01" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "18:27:06" , 
"departure_time" : "18:27:06" , 
"distance_traveled" : 9.0456
} ], 
"869" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "18:16:00" , 
"departure_time" : "18:17:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "18:19:16" , 
"departure_time" : "18:19:24" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "18:20:08" , 
"departure_time" : "18:20:35" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "18:22:27" , 
"departure_time" : "18:23:15" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "18:24:48" , 
"departure_time" : "18:25:19" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "18:25:31" , 
"departure_time" : "18:26:04" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:28:33" , 
"departure_time" : "18:29:19" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:31:46" , 
"departure_time" : "18:32:48" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:33:02" , 
"departure_time" : "18:34:33" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:35:31" , 
"departure_time" : "18:35:56" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:36:25" , 
"departure_time" : "18:37:42" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:39:17" , 
"departure_time" : "18:39:58" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:40:41" , 
"departure_time" : "18:42:20" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:44:39" , 
"departure_time" : "18:44:48" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "18:48:09" , 
"departure_time" : "18:48:09" , 
"distance_traveled" : 9.0456
} ], 
"870" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "18:29:00" , 
"departure_time" : "18:29:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "18:31:06" , 
"departure_time" : "18:32:39" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "18:34:33" , 
"departure_time" : "18:36:04" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "18:36:31" , 
"departure_time" : "18:37:36" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "18:38:05" , 
"departure_time" : "18:39:43" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "18:39:38" , 
"departure_time" : "18:40:24" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:41:46" , 
"departure_time" : "18:42:52" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:45:06" , 
"departure_time" : "18:45:21" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:45:15" , 
"departure_time" : "18:46:48" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:48:33" , 
"departure_time" : "18:48:51" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:49:18" , 
"departure_time" : "18:50:37" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:52:19" , 
"departure_time" : "18:53:10" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:53:51" , 
"departure_time" : "18:54:03" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:56:12" , 
"departure_time" : "18:56:40" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "19:01:28" , 
"departure_time" : "19:01:28" , 
"distance_traveled" : 9.0456
} ], 
"871" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "18:51:00" , 
"departure_time" : "18:52:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "18:53:36" , 
"departure_time" : "18:54:54" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "18:56:18" , 
"departure_time" : "18:56:55" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "18:57:37" , 
"departure_time" : "18:57:42" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "18:59:05" , 
"departure_time" : "19:00:11" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "19:01:06" , 
"departure_time" : "19:01:34" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:03:28" , 
"departure_time" : "19:03:35" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:06:07" , 
"departure_time" : "19:06:56" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:07:49" , 
"departure_time" : "19:08:11" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:09:22" , 
"departure_time" : "19:09:30" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:11:08" , 
"departure_time" : "19:11:49" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:13:41" , 
"departure_time" : "19:14:10" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:15:29" , 
"departure_time" : "19:16:13" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:18:44" , 
"departure_time" : "19:19:08" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "19:23:24" , 
"departure_time" : "19:23:24" , 
"distance_traveled" : 9.0456
} ], 
"872" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "19:01:00" , 
"departure_time" : "19:02:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "19:04:20" , 
"departure_time" : "19:04:36" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "19:05:16" , 
"departure_time" : "19:06:21" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "19:08:05" , 
"departure_time" : "19:08:26" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "19:09:21" , 
"departure_time" : "19:10:15" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "19:10:54" , 
"departure_time" : "19:12:05" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:14:11" , 
"departure_time" : "19:14:59" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:16:48" , 
"departure_time" : "19:17:24" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:17:36" , 
"departure_time" : "19:18:48" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:20:12" , 
"departure_time" : "19:21:33" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:22:21" , 
"departure_time" : "19:23:10" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:23:49" , 
"departure_time" : "19:25:29" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:26:40" , 
"departure_time" : "19:26:56" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:28:16" , 
"departure_time" : "19:29:32" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "19:34:16" , 
"departure_time" : "19:34:16" , 
"distance_traveled" : 9.0456
} ], 
"873" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "19:17:00" , 
"departure_time" : "19:19:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "19:20:25" , 
"departure_time" : "19:21:23" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "19:21:58" , 
"departure_time" : "19:22:41" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "19:23:43" , 
"departure_time" : "19:24:28" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "19:25:45" , 
"departure_time" : "19:27:23" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "19:27:38" , 
"departure_time" : "19:28:29" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:29:51" , 
"departure_time" : "19:31:16" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:33:25" , 
"departure_time" : "19:34:46" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:34:21" , 
"departure_time" : "19:34:57" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:35:36" , 
"departure_time" : "19:36:48" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:38:12" , 
"departure_time" : "19:38:43" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:39:31" , 
"departure_time" : "19:40:30" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:41:59" , 
"departure_time" : "19:42:43" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:44:44" , 
"departure_time" : "19:45:48" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "19:50:04" , 
"departure_time" : "19:50:04" , 
"distance_traveled" : 9.0456
} ], 
"874" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "19:39:00" , 
"departure_time" : "19:41:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "19:42:21" , 
"departure_time" : "19:42:51" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "19:43:30" , 
"departure_time" : "19:43:39" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "19:45:09" , 
"departure_time" : "19:45:18" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "19:47:09" , 
"departure_time" : "19:47:45" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "19:48:36" , 
"departure_time" : "19:48:54" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:51:18" , 
"departure_time" : "19:52:42" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:55:24" , 
"departure_time" : "19:56:47" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:56:23" , 
"departure_time" : "19:57:22" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:57:59" , 
"departure_time" : "19:58:33" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:59:34" , 
"departure_time" : "20:00:14" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:01:40" , 
"departure_time" : "20:01:43" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:03:03" , 
"departure_time" : "20:03:57" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:06:54" , 
"departure_time" : "20:08:15" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "20:12:21" , 
"departure_time" : "20:12:21" , 
"distance_traveled" : 9.0456
} ], 
"875" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "20:09:00" , 
"departure_time" : "20:11:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "20:11:47" , 
"departure_time" : "20:13:20" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "20:14:33" , 
"departure_time" : "20:16:06" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "20:16:33" , 
"departure_time" : "20:16:35" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "20:17:02" , 
"departure_time" : "20:18:41" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "20:19:39" , 
"departure_time" : "20:20:03" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:21:24" , 
"departure_time" : "20:22:53" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:25:29" , 
"departure_time" : "20:26:50" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:26:21" , 
"departure_time" : "20:27:45" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:28:24" , 
"departure_time" : "20:28:49" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:29:25" , 
"departure_time" : "20:29:59" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:31:34" , 
"departure_time" : "20:31:44" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:33:10" , 
"departure_time" : "20:33:29" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:36:19" , 
"departure_time" : "20:36:29" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "20:41:10" , 
"departure_time" : "20:41:10" , 
"distance_traveled" : 9.0456
} ], 
"876" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "20:39:00" , 
"departure_time" : "20:39:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "20:41:27" , 
"departure_time" : "20:42:28" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "20:44:01" , 
"departure_time" : "20:44:32" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "20:45:31" , 
"departure_time" : "20:46:17" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "20:47:46" , 
"departure_time" : "20:48:28" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "20:48:42" , 
"departure_time" : "20:49:28" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:51:46" , 
"departure_time" : "20:52:54" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:55:08" , 
"departure_time" : "20:55:09" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:55:01" , 
"departure_time" : "20:55:23" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:57:22" , 
"departure_time" : "20:57:33" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:59:11" , 
"departure_time" : "20:59:48" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:01:37" , 
"departure_time" : "21:01:44" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:03:07" , 
"departure_time" : "21:03:44" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:06:37" , 
"departure_time" : "21:07:32" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "21:11:55" , 
"departure_time" : "21:11:55" , 
"distance_traveled" : 9.0456
} ], 
"877" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "21:09:00" , 
"departure_time" : "21:10:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "21:11:17" , 
"departure_time" : "21:12:39" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "21:14:22" , 
"departure_time" : "21:14:56" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "21:15:34" , 
"departure_time" : "21:16:59" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "21:18:25" , 
"departure_time" : "21:19:36" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "21:19:11" , 
"departure_time" : "21:19:42" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:21:31" , 
"departure_time" : "21:21:54" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "21:24:23" , 
"departure_time" : "21:25:47" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "21:26:24" , 
"departure_time" : "21:27:18" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:27:54" , 
"departure_time" : "21:28:22" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "21:29:28" , 
"departure_time" : "21:29:40" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:31:12" , 
"departure_time" : "21:31:59" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:33:47" , 
"departure_time" : "21:35:18" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:37:31" , 
"departure_time" : "21:38:33" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "21:42:02" , 
"departure_time" : "21:42:02" , 
"distance_traveled" : 9.0456
} ], 
"878" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "21:39:00" , 
"departure_time" : "21:40:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "21:41:41" , 
"departure_time" : "21:42:05" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "21:43:24" , 
"departure_time" : "21:43:32" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "21:45:08" , 
"departure_time" : "21:45:17" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "21:47:09" , 
"departure_time" : "21:48:06" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "21:48:57" , 
"departure_time" : "21:50:11" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:52:14" , 
"departure_time" : "21:53:52" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "21:55:38" , 
"departure_time" : "21:56:07" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "21:55:29" , 
"departure_time" : "21:55:31" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:57:02" , 
"departure_time" : "21:57:11" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "21:59:09" , 
"departure_time" : "21:59:43" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:01:34" , 
"departure_time" : "22:02:34" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:04:00" , 
"departure_time" : "22:04:13" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:06:13" , 
"departure_time" : "22:07:40" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "22:12:27" , 
"departure_time" : "22:12:27" , 
"distance_traveled" : 9.0456
} ], 
"879" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "22:09:00" , 
"departure_time" : "22:10:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "22:11:30" , 
"departure_time" : "22:12:37" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "22:14:07" , 
"departure_time" : "22:14:50" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "22:15:43" , 
"departure_time" : "22:16:46" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "22:18:03" , 
"departure_time" : "22:18:25" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "22:18:22" , 
"departure_time" : "22:18:38" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:21:16" , 
"departure_time" : "22:21:20" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:24:04" , 
"departure_time" : "22:25:18" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:26:14" , 
"departure_time" : "22:27:47" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:28:33" , 
"departure_time" : "22:29:07" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:29:34" , 
"departure_time" : "22:31:01" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:32:27" , 
"departure_time" : "22:33:51" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:34:24" , 
"departure_time" : "22:35:20" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:36:56" , 
"departure_time" : "22:37:18" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "22:41:22" , 
"departure_time" : "22:41:22" , 
"distance_traveled" : 9.0456
} ], 
"880" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "22:39:00" , 
"departure_time" : "22:40:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "22:42:33" , 
"departure_time" : "22:42:41" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "22:43:08" , 
"departure_time" : "22:44:18" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "22:46:10" , 
"departure_time" : "22:46:39" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "22:47:29" , 
"departure_time" : "22:48:06" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "22:48:37" , 
"departure_time" : "22:49:23" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:51:46" , 
"departure_time" : "22:52:38" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:54:52" , 
"departure_time" : "22:56:04" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:56:12" , 
"departure_time" : "22:57:27" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:58:15" , 
"departure_time" : "22:58:48" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:59:33" , 
"departure_time" : "23:00:57" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:02:24" , 
"departure_time" : "23:03:40" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:04:16" , 
"departure_time" : "23:05:33" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:07:17" , 
"departure_time" : "23:08:52" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "23:12:35" , 
"departure_time" : "23:12:35" , 
"distance_traveled" : 9.0456
} ], 
"881" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "23:09:00" , 
"departure_time" : "23:10:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "23:11:14" , 
"departure_time" : "23:12:27" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "23:14:13" , 
"departure_time" : "23:15:43" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "23:16:30" , 
"departure_time" : "23:17:15" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "23:17:45" , 
"departure_time" : "23:18:44" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "23:18:59" , 
"departure_time" : "23:19:23" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:21:24" , 
"departure_time" : "23:22:00" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:24:36" , 
"departure_time" : "23:25:36" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "23:26:00" , 
"departure_time" : "23:27:16" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:28:16" , 
"departure_time" : "23:28:40" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:29:24" , 
"departure_time" : "23:30:09" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:31:45" , 
"departure_time" : "23:32:00" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:33:15" , 
"departure_time" : "23:34:35" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:37:20" , 
"departure_time" : "23:38:00" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "23:41:40" , 
"departure_time" : "23:41:40" , 
"distance_traveled" : 9.0456
} ], 
"882" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "23:39:00" , 
"departure_time" : "23:39:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "23:41:09" , 
"departure_time" : "23:41:37" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "23:43:28" , 
"departure_time" : "23:44:05" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "23:45:37" , 
"departure_time" : "23:46:01" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "23:47:24" , 
"departure_time" : "23:48:18" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "23:48:54" , 
"departure_time" : "23:49:09" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:51:15" , 
"departure_time" : "23:51:58" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:54:43" , 
"departure_time" : "23:56:05" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "23:56:22" , 
"departure_time" : "23:56:52" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:57:30" , 
"departure_time" : "23:58:16" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:59:46" , 
"departure_time" : "23:59:50" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "24:01:04" , 
"departure_time" : "24:02:37" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "24:04:33" , 
"departure_time" : "24:06:01" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "24:07:28" , 
"departure_time" : "24:08:03" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "24:11:35" , 
"departure_time" : "24:11:35" , 
"distance_traveled" : 9.0456
} ], 
"883" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "24:09:00" , 
"departure_time" : "24:09:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "24:11:02" , 
"departure_time" : "24:11:36" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "24:13:34" , 
"departure_time" : "24:14:29" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "24:15:55" , 
"departure_time" : "24:16:37" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "24:17:42" , 
"departure_time" : "24:18:37" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "24:18:55" , 
"departure_time" : "24:20:31" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "24:22:36" , 
"departure_time" : "24:23:25" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "24:24:49" , 
"departure_time" : "24:25:18" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "24:25:29" , 
"departure_time" : "24:26:14" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "24:27:45" , 
"departure_time" : "24:27:47" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "24:29:02" , 
"departure_time" : "24:29:47" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "24:31:45" , 
"departure_time" : "24:31:49" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "24:33:04" , 
"departure_time" : "24:34:33" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "24:37:29" , 
"departure_time" : "24:37:33" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "24:41:04" , 
"departure_time" : "24:41:04" , 
"distance_traveled" : 9.0456
} ], 
"884" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "24:39:00" , 
"departure_time" : "24:39:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "24:41:16" , 
"departure_time" : "24:42:33" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "24:44:17" , 
"departure_time" : "24:45:52" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "24:46:35" , 
"departure_time" : "24:47:18" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "24:47:43" , 
"departure_time" : "24:47:56" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "24:48:13" , 
"departure_time" : "24:48:36" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "24:51:23" , 
"departure_time" : "24:53:00" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "24:55:37" , 
"departure_time" : "24:56:19" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "24:55:42" , 
"departure_time" : "24:57:20" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "24:58:38" , 
"departure_time" : "25:00:03" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "25:00:25" , 
"departure_time" : "25:02:03" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "25:02:38" , 
"departure_time" : "25:03:53" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "25:04:15" , 
"departure_time" : "25:05:16" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "25:07:01" , 
"departure_time" : "25:07:02" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "25:11:01" , 
"departure_time" : "25:11:01" , 
"distance_traveled" : 9.0456
} ], 
"885" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "25:09:00" , 
"departure_time" : "25:09:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "25:11:11" , 
"departure_time" : "25:12:51" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "25:14:40" , 
"departure_time" : "25:15:39" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "25:15:59" , 
"departure_time" : "25:16:31" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "25:17:32" , 
"departure_time" : "25:19:01" , 
"distance_traveled" : 3.5483
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "25:19:29" , 
"departure_time" : "25:19:56" , 
"distance_traveled" : 4.1962
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "25:21:27" , 
"departure_time" : "25:21:43" , 
"distance_traveled" : 5.618
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "25:24:16" , 
"departure_time" : "25:24:59" , 
"distance_traveled" : 6.2992
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "25:25:43" , 
"departure_time" : "25:25:44" , 
"distance_traveled" : 6.5767
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "25:27:01" , 
"departure_time" : "25:27:39" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "25:29:38" , 
"departure_time" : "25:31:12" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "25:32:34" , 
"departure_time" : "25:33:06" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "25:33:32" , 
"departure_time" : "25:33:40" , 
"distance_traveled" : 7.875
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "25:36:08" , 
"departure_time" : "25:37:06" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "25:41:58" , 
"departure_time" : "25:41:58" , 
"distance_traveled" : 9.0456
} ], 
"886" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "06:33:00" , 
"departure_time" : "06:34:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "06:35:23" , 
"departure_time" : "06:35:45" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "06:37:22" , 
"departure_time" : "06:38:45" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "06:40:23" , 
"departure_time" : "06:41:57" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:49:34" , 
"departure_time" : "06:50:44" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:51:10" , 
"departure_time" : "06:51:40" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:52:30" , 
"departure_time" : "06:53:57" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:57:27" , 
"departure_time" : "06:58:59" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "07:01:32" , 
"departure_time" : "07:01:32" , 
"distance_traveled" : 9.0456
} ], 
"887" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "06:58:00" , 
"departure_time" : "06:59:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "07:00:26" , 
"departure_time" : "07:01:49" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "07:03:23" , 
"departure_time" : "07:03:58" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "07:04:35" , 
"departure_time" : "07:05:03" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:13:28" , 
"departure_time" : "07:13:40" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:15:12" , 
"departure_time" : "07:16:15" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:18:03" , 
"departure_time" : "07:18:29" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:21:26" , 
"departure_time" : "07:22:41" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "07:26:15" , 
"departure_time" : "07:26:15" , 
"distance_traveled" : 9.0456
} ], 
"888" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "07:12:00" , 
"departure_time" : "07:13:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "07:14:11" , 
"departure_time" : "07:15:09" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "07:16:58" , 
"departure_time" : "07:17:15" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "07:18:17" , 
"departure_time" : "07:19:33" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:28:16" , 
"departure_time" : "07:29:41" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:30:25" , 
"departure_time" : "07:31:35" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:32:10" , 
"departure_time" : "07:33:42" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:36:32" , 
"departure_time" : "07:36:47" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "07:39:15" , 
"departure_time" : "07:39:15" , 
"distance_traveled" : 9.0456
} ], 
"889" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "07:28:00" , 
"departure_time" : "07:28:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "07:30:19" , 
"departure_time" : "07:31:11" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "07:32:52" , 
"departure_time" : "07:34:24" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "07:35:32" , 
"departure_time" : "07:36:32" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:44:00" , 
"departure_time" : "07:44:50" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:45:50" , 
"departure_time" : "07:47:30" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:48:40" , 
"departure_time" : "07:49:33" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:51:53" , 
"departure_time" : "07:53:27" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "07:56:34" , 
"departure_time" : "07:56:34" , 
"distance_traveled" : 9.0456
} ], 
"890" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "07:39:00" , 
"departure_time" : "07:41:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "07:41:33" , 
"departure_time" : "07:42:55" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "07:44:22" , 
"departure_time" : "07:45:20" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "07:45:58" , 
"departure_time" : "07:47:37" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:55:39" , 
"departure_time" : "07:57:08" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:57:29" , 
"departure_time" : "07:57:53" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:58:24" , 
"departure_time" : "07:59:29" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:03:05" , 
"departure_time" : "08:04:28" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "08:07:23" , 
"departure_time" : "08:07:23" , 
"distance_traveled" : 9.0456
} ], 
"891" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "07:51:00" , 
"departure_time" : "07:53:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "07:54:33" , 
"departure_time" : "07:55:40" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "07:56:07" , 
"departure_time" : "07:56:55" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "07:57:48" , 
"departure_time" : "07:58:04" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:06:16" , 
"departure_time" : "08:07:05" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:08:49" , 
"departure_time" : "08:08:50" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:10:01" , 
"departure_time" : "08:10:22" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:14:21" , 
"departure_time" : "08:14:32" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "08:18:11" , 
"departure_time" : "08:18:11" , 
"distance_traveled" : 9.0456
} ], 
"892" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "07:58:00" , 
"departure_time" : "07:59:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "08:01:04" , 
"departure_time" : "08:01:21" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "08:02:17" , 
"departure_time" : "08:03:11" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "08:04:54" , 
"departure_time" : "08:05:06" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:13:12" , 
"departure_time" : "08:13:23" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:15:11" , 
"departure_time" : "08:16:32" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:18:21" , 
"departure_time" : "08:19:31" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:22:10" , 
"departure_time" : "08:22:25" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "08:25:15" , 
"departure_time" : "08:25:15" , 
"distance_traveled" : 9.0456
} ], 
"893" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "08:19:00" , 
"departure_time" : "08:19:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "08:21:43" , 
"departure_time" : "08:22:08" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "08:23:25" , 
"departure_time" : "08:24:09" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "08:25:44" , 
"departure_time" : "08:26:44" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:35:00" , 
"departure_time" : "08:35:12" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:36:12" , 
"departure_time" : "08:37:21" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:39:09" , 
"departure_time" : "08:39:39" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:42:30" , 
"departure_time" : "08:43:24" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "08:46:54" , 
"departure_time" : "08:46:54" , 
"distance_traveled" : 9.0456
} ], 
"894" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "08:40:00" , 
"departure_time" : "08:41:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "08:42:57" , 
"departure_time" : "08:44:16" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "08:45:19" , 
"departure_time" : "08:45:57" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "08:46:38" , 
"departure_time" : "08:48:02" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:56:24" , 
"departure_time" : "08:57:53" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:58:29" , 
"departure_time" : "08:59:20" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:59:51" , 
"departure_time" : "09:00:16" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:03:25" , 
"departure_time" : "09:04:57" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "09:08:32" , 
"departure_time" : "09:08:32" , 
"distance_traveled" : 9.0456
} ], 
"895" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "08:54:00" , 
"departure_time" : "08:56:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "08:57:04" , 
"departure_time" : "08:58:04" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "08:59:00" , 
"departure_time" : "08:59:36" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "09:00:36" , 
"departure_time" : "09:00:38" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:09:02" , 
"departure_time" : "09:09:32" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:11:30" , 
"departure_time" : "09:12:37" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:14:07" , 
"departure_time" : "09:15:33" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:18:26" , 
"departure_time" : "09:19:59" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "09:22:33" , 
"departure_time" : "09:22:33" , 
"distance_traveled" : 9.0456
} ], 
"896" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "16:23:00" , 
"departure_time" : "16:24:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "16:25:23" , 
"departure_time" : "16:26:11" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "16:27:48" , 
"departure_time" : "16:29:05" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "16:30:17" , 
"departure_time" : "16:31:09" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:38:52" , 
"departure_time" : "16:40:04" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:41:12" , 
"departure_time" : "16:42:03" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:42:51" , 
"departure_time" : "16:44:21" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:47:30" , 
"departure_time" : "16:48:08" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "16:50:38" , 
"departure_time" : "16:50:38" , 
"distance_traveled" : 9.0456
} ], 
"897" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "16:53:00" , 
"departure_time" : "16:53:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "16:55:08" , 
"departure_time" : "16:56:04" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "16:57:56" , 
"departure_time" : "16:59:13" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "17:00:17" , 
"departure_time" : "17:01:08" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:08:51" , 
"departure_time" : "17:09:09" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:10:18" , 
"departure_time" : "17:11:37" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:13:19" , 
"departure_time" : "17:14:49" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:17:30" , 
"departure_time" : "17:18:36" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "17:21:06" , 
"departure_time" : "17:21:06" , 
"distance_traveled" : 9.0456
} ], 
"898" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "18:08:00" , 
"departure_time" : "18:10:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "18:10:58" , 
"departure_time" : "18:12:05" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "18:13:07" , 
"departure_time" : "18:14:14" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "18:15:07" , 
"departure_time" : "18:15:29" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:23:22" , 
"departure_time" : "18:24:21" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:25:59" , 
"departure_time" : "18:26:13" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:27:14" , 
"departure_time" : "18:27:56" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:31:42" , 
"departure_time" : "18:32:05" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "18:35:23" , 
"departure_time" : "18:35:23" , 
"distance_traveled" : 9.0456
} ], 
"899" :  [ 
{ 
"stop_id" : 42673,
"arrival_time" : "18:43:00" , 
"departure_time" : "18:43:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "18:45:34" , 
"departure_time" : "18:45:38" , 
"distance_traveled" : 0.9155
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "18:47:04" , 
"departure_time" : "18:48:35" , 
"distance_traveled" : 1.7758
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "18:50:31" , 
"departure_time" : "18:51:55" , 
"distance_traveled" : 2.3381
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:59:24" , 
"departure_time" : "19:00:19" , 
"distance_traveled" : 6.9845
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:00:55" , 
"departure_time" : "19:02:03" , 
"distance_traveled" : 7.279
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:03:08" , 
"departure_time" : "19:03:52" , 
"distance_traveled" : 7.528
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:06:44" , 
"departure_time" : "19:08:09" , 
"distance_traveled" : 8.168
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "19:11:25" , 
"departure_time" : "19:11:25" , 
"distance_traveled" : 9.0456
} ], 
"900" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "05:09:00" , 
"departure_time" : "05:11:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "05:11:25" , 
"departure_time" : "05:11:27" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "05:12:02" , 
"departure_time" : "05:13:03" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "05:16:01" , 
"departure_time" : "05:16:22" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "05:18:21" , 
"departure_time" : "05:19:44" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "05:20:23" , 
"departure_time" : "05:21:04" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "05:21:41" , 
"departure_time" : "05:23:08" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "05:24:27" , 
"departure_time" : "05:25:54" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "05:26:27" , 
"departure_time" : "05:27:24" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "05:27:57" , 
"departure_time" : "05:29:30" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "05:31:33" , 
"departure_time" : "05:33:01" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "05:37:28" , 
"departure_time" : "05:37:44" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "05:38:16" , 
"departure_time" : "05:39:38" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "05:42:22" , 
"departure_time" : "05:43:11" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "05:44:49" , 
"departure_time" : "05:44:59" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "05:46:10" , 
"departure_time" : "05:46:31" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "05:48:21" , 
"departure_time" : "05:48:21" , 
"distance_traveled" : 10.0595
} ], 
"901" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "05:21:00" , 
"departure_time" : "05:22:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "05:22:58" , 
"departure_time" : "05:24:25" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "05:25:27" , 
"departure_time" : "05:26:47" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "05:28:20" , 
"departure_time" : "05:29:37" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "05:31:17" , 
"departure_time" : "05:32:00" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "05:31:43" , 
"departure_time" : "05:33:16" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "05:34:33" , 
"departure_time" : "05:34:52" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "05:35:19" , 
"departure_time" : "05:36:07" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "05:37:48" , 
"departure_time" : "05:38:08" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "05:39:20" , 
"departure_time" : "05:40:21" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "05:43:01" , 
"departure_time" : "05:43:04" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "05:48:03" , 
"departure_time" : "05:49:04" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "05:51:01" , 
"departure_time" : "05:51:25" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "05:53:24" , 
"departure_time" : "05:54:51" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "05:57:27" , 
"departure_time" : "05:57:30" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "05:58:03" , 
"departure_time" : "05:58:04" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "06:00:01" , 
"departure_time" : "06:00:01" , 
"distance_traveled" : 10.0595
} ], 
"902" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "05:36:00" , 
"departure_time" : "05:36:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "05:37:30" , 
"departure_time" : "05:38:18" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "05:39:48" , 
"departure_time" : "05:40:14" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "05:42:26" , 
"departure_time" : "05:42:55" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "05:45:29" , 
"departure_time" : "05:46:19" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "05:46:50" , 
"departure_time" : "05:47:30" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "05:48:40" , 
"departure_time" : "05:48:58" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "05:50:18" , 
"departure_time" : "05:51:07" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "05:52:49" , 
"departure_time" : "05:53:32" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "05:54:43" , 
"departure_time" : "05:55:02" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "05:57:19" , 
"departure_time" : "05:57:55" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "06:03:36" , 
"departure_time" : "06:03:45" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "06:05:09" , 
"departure_time" : "06:06:43" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "06:09:34" , 
"departure_time" : "06:11:07" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "06:12:33" , 
"departure_time" : "06:12:51" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "06:13:18" , 
"departure_time" : "06:14:00" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "06:15:42" , 
"departure_time" : "06:15:42" , 
"distance_traveled" : 10.0595
} ], 
"903" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "05:50:00" , 
"departure_time" : "05:52:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "05:52:30" , 
"departure_time" : "05:53:05" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "05:53:35" , 
"departure_time" : "05:54:32" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "05:56:57" , 
"departure_time" : "05:57:45" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "05:59:48" , 
"departure_time" : "05:59:54" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:00:06" , 
"departure_time" : "06:01:42" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:03:36" , 
"departure_time" : "06:05:09" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:05:33" , 
"departure_time" : "06:06:02" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:06:29" , 
"departure_time" : "06:07:07" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:08:38" , 
"departure_time" : "06:08:39" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:11:01" , 
"departure_time" : "06:11:42" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "06:17:41" , 
"departure_time" : "06:17:51" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "06:19:10" , 
"departure_time" : "06:20:05" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "06:22:55" , 
"departure_time" : "06:24:13" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "06:26:18" , 
"departure_time" : "06:26:38" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "06:27:20" , 
"departure_time" : "06:27:26" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "06:29:06" , 
"departure_time" : "06:29:06" , 
"distance_traveled" : 10.0595
} ], 
"904" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "06:04:00" , 
"departure_time" : "06:04:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "06:05:31" , 
"departure_time" : "06:05:58" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "06:07:27" , 
"departure_time" : "06:08:42" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:11:15" , 
"departure_time" : "06:11:28" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:13:13" , 
"departure_time" : "06:14:42" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:15:29" , 
"departure_time" : "06:16:07" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:16:38" , 
"departure_time" : "06:17:05" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:18:27" , 
"departure_time" : "06:18:42" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:20:15" , 
"departure_time" : "06:20:16" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:22:01" , 
"departure_time" : "06:23:36" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:26:35" , 
"departure_time" : "06:27:30" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "06:31:55" , 
"departure_time" : "06:32:11" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "06:33:16" , 
"departure_time" : "06:33:39" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "06:36:23" , 
"departure_time" : "06:37:59" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "06:40:36" , 
"departure_time" : "06:41:46" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "06:42:10" , 
"departure_time" : "06:43:31" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "06:44:21" , 
"departure_time" : "06:44:21" , 
"distance_traveled" : 10.0595
} ], 
"905" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "06:16:00" , 
"departure_time" : "06:17:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "06:17:27" , 
"departure_time" : "06:19:04" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "06:20:37" , 
"departure_time" : "06:22:00" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:23:23" , 
"departure_time" : "06:24:37" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:26:14" , 
"departure_time" : "06:27:51" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:27:37" , 
"departure_time" : "06:28:07" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:28:30" , 
"departure_time" : "06:29:09" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:30:39" , 
"departure_time" : "06:31:06" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:32:27" , 
"departure_time" : "06:33:37" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:35:10" , 
"departure_time" : "06:36:37" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:38:27" , 
"departure_time" : "06:38:50" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "06:43:23" , 
"departure_time" : "06:44:40" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "06:46:17" , 
"departure_time" : "06:47:20" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "06:49:03" , 
"departure_time" : "06:49:07" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "06:51:04" , 
"departure_time" : "06:52:40" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "06:54:36" , 
"departure_time" : "06:54:49" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "06:55:13" , 
"departure_time" : "06:55:13" , 
"distance_traveled" : 10.0595
} ], 
"906" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "06:26:00" , 
"departure_time" : "06:27:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "06:28:00" , 
"departure_time" : "06:28:56" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "06:29:56" , 
"departure_time" : "06:30:05" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:32:09" , 
"departure_time" : "06:33:21" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:36:12" , 
"departure_time" : "06:36:38" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:36:26" , 
"departure_time" : "06:37:39" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:39:13" , 
"departure_time" : "06:39:21" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:40:08" , 
"departure_time" : "06:41:22" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:43:14" , 
"departure_time" : "06:44:03" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:44:49" , 
"departure_time" : "06:45:09" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:47:20" , 
"departure_time" : "06:48:58" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "06:54:38" , 
"departure_time" : "06:55:26" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "06:55:48" , 
"departure_time" : "06:57:01" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "06:59:13" , 
"departure_time" : "07:00:51" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "07:02:38" , 
"departure_time" : "07:03:27" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:03:49" , 
"departure_time" : "07:04:50" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "07:06:01" , 
"departure_time" : "07:06:01" , 
"distance_traveled" : 10.0595
} ], 
"907" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "06:38:00" , 
"departure_time" : "06:39:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "06:39:15" , 
"departure_time" : "06:40:15" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "06:42:00" , 
"departure_time" : "06:42:29" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:44:29" , 
"departure_time" : "06:45:46" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:48:17" , 
"departure_time" : "06:48:19" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:48:02" , 
"departure_time" : "06:48:35" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:50:33" , 
"departure_time" : "06:50:54" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:52:21" , 
"departure_time" : "06:52:57" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:54:36" , 
"departure_time" : "06:55:12" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:56:36" , 
"departure_time" : "06:57:36" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:00:00" , 
"departure_time" : "07:00:31" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:05:31" , 
"departure_time" : "07:06:20" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "07:07:49" , 
"departure_time" : "07:08:45" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "07:10:56" , 
"departure_time" : "07:11:08" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "07:13:12" , 
"departure_time" : "07:14:22" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:16:10" , 
"departure_time" : "07:17:28" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "07:18:18" , 
"departure_time" : "07:18:18" , 
"distance_traveled" : 10.0595
} ], 
"908" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "06:47:00" , 
"departure_time" : "06:49:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "06:48:53" , 
"departure_time" : "06:49:46" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "06:50:53" , 
"departure_time" : "06:52:33" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:54:40" , 
"departure_time" : "06:56:12" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:57:32" , 
"departure_time" : "06:58:59" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:58:27" , 
"departure_time" : "06:59:50" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:00:23" , 
"departure_time" : "07:01:17" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:01:54" , 
"departure_time" : "07:02:34" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:03:40" , 
"departure_time" : "07:04:13" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:05:33" , 
"departure_time" : "07:05:35" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:08:02" , 
"departure_time" : "07:09:25" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:15:23" , 
"departure_time" : "07:16:38" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "07:17:15" , 
"departure_time" : "07:18:22" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "07:20:07" , 
"departure_time" : "07:20:46" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "07:22:39" , 
"departure_time" : "07:24:16" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:25:37" , 
"departure_time" : "07:25:57" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "07:26:20" , 
"departure_time" : "07:26:20" , 
"distance_traveled" : 10.0595
} ], 
"909" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "06:57:00" , 
"departure_time" : "06:58:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "06:58:54" , 
"departure_time" : "06:59:25" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "07:00:31" , 
"departure_time" : "07:01:47" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:04:16" , 
"departure_time" : "07:05:10" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:06:54" , 
"departure_time" : "07:08:27" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:08:33" , 
"departure_time" : "07:09:58" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:10:25" , 
"departure_time" : "07:11:18" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:11:53" , 
"departure_time" : "07:12:52" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:13:59" , 
"departure_time" : "07:15:16" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:16:17" , 
"departure_time" : "07:17:19" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:19:02" , 
"departure_time" : "07:20:00" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:24:58" , 
"departure_time" : "07:25:46" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "07:26:48" , 
"departure_time" : "07:28:16" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "07:30:28" , 
"departure_time" : "07:30:49" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "07:32:21" , 
"departure_time" : "07:33:25" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:35:04" , 
"departure_time" : "07:36:10" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "07:37:06" , 
"departure_time" : "07:37:06" , 
"distance_traveled" : 10.0595
} ], 
"910" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "07:09:00" , 
"departure_time" : "07:10:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "07:10:14" , 
"departure_time" : "07:11:22" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "07:13:08" , 
"departure_time" : "07:14:04" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:15:56" , 
"departure_time" : "07:16:59" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:19:03" , 
"departure_time" : "07:19:06" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:19:03" , 
"departure_time" : "07:20:20" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:22:17" , 
"departure_time" : "07:22:28" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:23:11" , 
"departure_time" : "07:24:51" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:26:40" , 
"departure_time" : "07:27:22" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:27:42" , 
"departure_time" : "07:28:56" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:31:14" , 
"departure_time" : "07:32:04" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:36:50" , 
"departure_time" : "07:37:59" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "07:39:09" , 
"departure_time" : "07:40:23" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "07:42:14" , 
"departure_time" : "07:43:23" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "07:45:09" , 
"departure_time" : "07:46:15" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:47:06" , 
"departure_time" : "07:47:35" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "07:48:29" , 
"departure_time" : "07:48:29" , 
"distance_traveled" : 10.0595
} ], 
"911" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "07:18:00" , 
"departure_time" : "07:19:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "07:20:17" , 
"departure_time" : "07:21:56" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "07:22:39" , 
"departure_time" : "07:22:43" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:24:04" , 
"departure_time" : "07:25:24" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:28:20" , 
"departure_time" : "07:29:36" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:29:16" , 
"departure_time" : "07:30:08" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:30:52" , 
"departure_time" : "07:31:56" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:33:04" , 
"departure_time" : "07:34:42" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:35:38" , 
"departure_time" : "07:36:46" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:37:08" , 
"departure_time" : "07:37:17" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:39:09" , 
"departure_time" : "07:39:29" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:45:20" , 
"departure_time" : "07:46:11" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "07:47:51" , 
"departure_time" : "07:48:50" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "07:50:59" , 
"departure_time" : "07:52:05" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "07:54:06" , 
"departure_time" : "07:55:13" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:56:07" , 
"departure_time" : "07:56:16" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "07:57:09" , 
"departure_time" : "07:57:09" , 
"distance_traveled" : 10.0595
} ], 
"912" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "07:27:00" , 
"departure_time" : "07:28:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "07:29:14" , 
"departure_time" : "07:29:22" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "07:30:08" , 
"departure_time" : "07:30:21" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:33:13" , 
"departure_time" : "07:34:06" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:36:53" , 
"departure_time" : "07:37:41" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:37:48" , 
"departure_time" : "07:38:01" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:39:13" , 
"departure_time" : "07:40:51" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:42:38" , 
"departure_time" : "07:43:24" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:43:46" , 
"departure_time" : "07:44:40" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:45:54" , 
"departure_time" : "07:46:31" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:48:37" , 
"departure_time" : "07:48:43" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:54:06" , 
"departure_time" : "07:55:03" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "07:56:57" , 
"departure_time" : "07:57:08" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "07:59:11" , 
"departure_time" : "08:00:38" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:03:27" , 
"departure_time" : "08:05:04" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:05:37" , 
"departure_time" : "08:06:54" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "08:07:17" , 
"departure_time" : "08:07:17" , 
"distance_traveled" : 10.0595
} ], 
"913" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "07:38:00" , 
"departure_time" : "07:39:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "07:39:40" , 
"departure_time" : "07:41:00" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "07:42:20" , 
"departure_time" : "07:43:26" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:45:06" , 
"departure_time" : "07:45:19" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:47:13" , 
"departure_time" : "07:47:46" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:48:33" , 
"departure_time" : "07:49:01" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:50:28" , 
"departure_time" : "07:51:48" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:53:20" , 
"departure_time" : "07:53:44" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:54:24" , 
"departure_time" : "07:55:49" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:57:25" , 
"departure_time" : "07:57:35" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:59:10" , 
"departure_time" : "08:00:04" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:05:54" , 
"departure_time" : "08:07:10" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:08:16" , 
"departure_time" : "08:08:57" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:10:41" , 
"departure_time" : "08:11:36" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:13:55" , 
"departure_time" : "08:14:25" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:15:30" , 
"departure_time" : "08:16:21" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "08:17:51" , 
"departure_time" : "08:17:51" , 
"distance_traveled" : 10.0595
} ], 
"914" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "07:45:00" , 
"departure_time" : "07:47:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "07:47:11" , 
"departure_time" : "07:48:46" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "07:49:35" , 
"departure_time" : "07:50:02" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:51:27" , 
"departure_time" : "07:53:00" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:55:33" , 
"departure_time" : "07:55:38" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:55:05" , 
"departure_time" : "07:55:45" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:57:40" , 
"departure_time" : "07:58:30" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:59:50" , 
"departure_time" : "08:00:26" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:01:36" , 
"departure_time" : "08:02:07" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:03:31" , 
"departure_time" : "08:03:34" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:06:03" , 
"departure_time" : "08:07:12" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:13:09" , 
"departure_time" : "08:14:38" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:15:29" , 
"departure_time" : "08:15:53" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:17:24" , 
"departure_time" : "08:18:31" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:21:07" , 
"departure_time" : "08:21:45" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:22:38" , 
"departure_time" : "08:22:43" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "08:24:05" , 
"departure_time" : "08:24:05" , 
"distance_traveled" : 10.0595
} ], 
"915" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "07:57:00" , 
"departure_time" : "07:58:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "07:59:08" , 
"departure_time" : "08:00:17" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "08:01:09" , 
"departure_time" : "08:01:12" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:03:03" , 
"departure_time" : "08:03:13" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:06:10" , 
"departure_time" : "08:06:34" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:07:24" , 
"departure_time" : "08:08:17" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:09:53" , 
"departure_time" : "08:11:33" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:12:40" , 
"departure_time" : "08:13:41" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:14:01" , 
"departure_time" : "08:15:38" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:16:37" , 
"departure_time" : "08:17:39" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:19:02" , 
"departure_time" : "08:19:41" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:24:39" , 
"departure_time" : "08:24:43" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:26:04" , 
"departure_time" : "08:27:41" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:30:37" , 
"departure_time" : "08:30:57" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:32:20" , 
"departure_time" : "08:33:07" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:34:47" , 
"departure_time" : "08:35:38" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "08:36:51" , 
"departure_time" : "08:36:51" , 
"distance_traveled" : 10.0595
} ], 
"916" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "08:08:00" , 
"departure_time" : "08:09:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "08:10:01" , 
"departure_time" : "08:11:24" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "08:12:23" , 
"departure_time" : "08:13:07" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:14:44" , 
"departure_time" : "08:15:07" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:17:23" , 
"departure_time" : "08:17:34" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:18:11" , 
"departure_time" : "08:19:50" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:21:39" , 
"departure_time" : "08:22:16" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:22:37" , 
"departure_time" : "08:23:23" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:24:46" , 
"departure_time" : "08:25:40" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:26:54" , 
"departure_time" : "08:28:03" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:30:09" , 
"departure_time" : "08:30:25" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:35:16" , 
"departure_time" : "08:36:09" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:37:53" , 
"departure_time" : "08:39:33" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:41:40" , 
"departure_time" : "08:42:10" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:43:30" , 
"departure_time" : "08:44:23" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:45:53" , 
"departure_time" : "08:45:54" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "08:47:01" , 
"departure_time" : "08:47:01" , 
"distance_traveled" : 10.0595
} ], 
"917" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "08:18:00" , 
"departure_time" : "08:19:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "08:20:40" , 
"departure_time" : "08:21:40" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "08:22:00" , 
"departure_time" : "08:22:41" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:24:41" , 
"departure_time" : "08:26:14" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:28:33" , 
"departure_time" : "08:29:38" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:29:05" , 
"departure_time" : "08:29:15" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:30:10" , 
"departure_time" : "08:30:11" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:32:01" , 
"departure_time" : "08:32:20" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:34:19" , 
"departure_time" : "08:34:37" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:36:18" , 
"departure_time" : "08:36:54" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:39:36" , 
"departure_time" : "08:41:12" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:46:36" , 
"departure_time" : "08:47:01" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:47:25" , 
"departure_time" : "08:48:35" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:51:10" , 
"departure_time" : "08:51:21" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:53:11" , 
"departure_time" : "08:53:42" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:55:31" , 
"departure_time" : "08:56:00" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "08:57:29" , 
"departure_time" : "08:57:29" , 
"distance_traveled" : 10.0595
} ], 
"918" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "08:31:00" , 
"departure_time" : "08:32:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "08:33:28" , 
"departure_time" : "08:34:52" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "08:35:24" , 
"departure_time" : "08:36:14" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:37:50" , 
"departure_time" : "08:39:20" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:41:30" , 
"departure_time" : "08:42:38" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:42:08" , 
"departure_time" : "08:43:41" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:44:33" , 
"departure_time" : "08:44:52" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:45:19" , 
"departure_time" : "08:45:59" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:47:40" , 
"departure_time" : "08:47:49" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:49:09" , 
"departure_time" : "08:49:45" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:52:36" , 
"departure_time" : "08:52:48" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:58:12" , 
"departure_time" : "08:59:23" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:01:11" , 
"departure_time" : "09:02:22" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "09:04:11" , 
"departure_time" : "09:04:29" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "09:06:18" , 
"departure_time" : "09:06:54" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "09:08:36" , 
"departure_time" : "09:09:43" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "09:11:07" , 
"departure_time" : "09:11:07" , 
"distance_traveled" : 10.0595
} ], 
"919" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "08:39:00" , 
"departure_time" : "08:40:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "08:40:27" , 
"departure_time" : "08:41:32" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "08:43:05" , 
"departure_time" : "08:43:49" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:45:44" , 
"departure_time" : "08:46:17" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:48:33" , 
"departure_time" : "08:49:32" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:49:59" , 
"departure_time" : "08:50:10" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:51:11" , 
"departure_time" : "08:52:26" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:54:15" , 
"departure_time" : "08:54:38" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:55:23" , 
"departure_time" : "08:55:37" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:57:14" , 
"departure_time" : "08:57:25" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:00:11" , 
"departure_time" : "09:01:40" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "09:07:29" , 
"departure_time" : "09:08:45" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:09:16" , 
"departure_time" : "09:10:21" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "09:12:05" , 
"departure_time" : "09:12:33" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "09:14:28" , 
"departure_time" : "09:16:05" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "09:17:37" , 
"departure_time" : "09:18:53" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "09:19:16" , 
"departure_time" : "09:19:16" , 
"distance_traveled" : 10.0595
} ], 
"920" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "08:45:00" , 
"departure_time" : "08:46:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "08:46:33" , 
"departure_time" : "08:46:37" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "08:48:04" , 
"departure_time" : "08:48:41" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:51:37" , 
"departure_time" : "08:51:45" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:54:08" , 
"departure_time" : "08:54:10" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:55:02" , 
"departure_time" : "08:56:04" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:58:02" , 
"departure_time" : "08:58:42" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:59:40" , 
"departure_time" : "09:00:59" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:02:19" , 
"departure_time" : "09:03:28" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:04:09" , 
"departure_time" : "09:04:39" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:06:30" , 
"departure_time" : "09:08:07" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "09:13:37" , 
"departure_time" : "09:13:56" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:14:19" , 
"departure_time" : "09:14:34" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "09:17:15" , 
"departure_time" : "09:18:42" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "09:21:27" , 
"departure_time" : "09:21:29" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "09:22:02" , 
"departure_time" : "09:23:40" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "09:25:38" , 
"departure_time" : "09:25:38" , 
"distance_traveled" : 10.0595
} ], 
"921" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "09:02:00" , 
"departure_time" : "09:04:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "09:04:14" , 
"departure_time" : "09:05:35" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "09:06:21" , 
"departure_time" : "09:07:37" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:09:16" , 
"departure_time" : "09:10:50" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:12:34" , 
"departure_time" : "09:13:43" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:13:09" , 
"departure_time" : "09:14:33" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:15:24" , 
"departure_time" : "09:16:45" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:17:21" , 
"departure_time" : "09:18:03" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:18:42" , 
"departure_time" : "09:19:54" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:21:12" , 
"departure_time" : "09:21:28" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:23:16" , 
"departure_time" : "09:24:43" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "09:30:27" , 
"departure_time" : "09:32:00" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:32:33" , 
"departure_time" : "09:33:29" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "09:34:56" , 
"departure_time" : "09:36:30" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "09:38:34" , 
"departure_time" : "09:39:17" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "09:39:43" , 
"departure_time" : "09:41:18" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "09:42:35" , 
"departure_time" : "09:42:35" , 
"distance_traveled" : 10.0595
} ], 
"922" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "09:14:00" , 
"departure_time" : "09:16:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "09:16:17" , 
"departure_time" : "09:17:41" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "09:18:24" , 
"departure_time" : "09:19:24" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:21:00" , 
"departure_time" : "09:21:11" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:23:11" , 
"departure_time" : "09:24:20" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:25:09" , 
"departure_time" : "09:26:33" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:27:24" , 
"departure_time" : "09:27:51" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:28:27" , 
"departure_time" : "09:29:43" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:31:16" , 
"departure_time" : "09:31:36" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:32:20" , 
"departure_time" : "09:32:57" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:35:37" , 
"departure_time" : "09:36:07" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "09:41:30" , 
"departure_time" : "09:41:58" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:43:28" , 
"departure_time" : "09:44:07" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "09:46:39" , 
"departure_time" : "09:47:27" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "09:49:48" , 
"departure_time" : "09:51:04" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "09:52:16" , 
"departure_time" : "09:53:20" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "09:54:04" , 
"departure_time" : "09:54:04" , 
"distance_traveled" : 10.0595
} ], 
"923" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "09:24:00" , 
"departure_time" : "09:25:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "09:25:32" , 
"departure_time" : "09:26:57" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "09:28:25" , 
"departure_time" : "09:28:53" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:30:28" , 
"departure_time" : "09:31:47" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:34:19" , 
"departure_time" : "09:35:10" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:34:51" , 
"departure_time" : "09:36:13" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:37:22" , 
"departure_time" : "09:38:49" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:39:27" , 
"departure_time" : "09:40:27" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:41:00" , 
"departure_time" : "09:42:03" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:43:03" , 
"departure_time" : "09:44:35" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:46:32" , 
"departure_time" : "09:47:31" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "09:51:59" , 
"departure_time" : "09:52:52" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:53:53" , 
"departure_time" : "09:55:28" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "09:57:35" , 
"departure_time" : "09:57:49" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "09:59:14" , 
"departure_time" : "10:00:30" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "10:02:16" , 
"departure_time" : "10:03:34" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "10:04:18" , 
"departure_time" : "10:04:18" , 
"distance_traveled" : 10.0595
} ], 
"924" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "09:35:00" , 
"departure_time" : "09:37:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "09:37:04" , 
"departure_time" : "09:37:06" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "09:38:02" , 
"departure_time" : "09:38:48" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:41:46" , 
"departure_time" : "09:43:26" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:45:40" , 
"departure_time" : "09:47:03" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:46:23" , 
"departure_time" : "09:46:36" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:47:13" , 
"departure_time" : "09:48:35" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:50:22" , 
"departure_time" : "09:52:00" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:52:38" , 
"departure_time" : "09:53:38" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:54:00" , 
"departure_time" : "09:54:18" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:56:18" , 
"departure_time" : "09:57:45" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "10:03:27" , 
"departure_time" : "10:04:22" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "10:04:55" , 
"departure_time" : "10:06:16" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "10:08:21" , 
"departure_time" : "10:09:09" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "10:10:48" , 
"departure_time" : "10:11:51" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "10:13:03" , 
"departure_time" : "10:13:42" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "10:14:39" , 
"departure_time" : "10:14:39" , 
"distance_traveled" : 10.0595
} ], 
"925" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "09:49:00" , 
"departure_time" : "09:51:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "09:51:26" , 
"departure_time" : "09:52:28" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "09:53:02" , 
"departure_time" : "09:53:25" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:55:23" , 
"departure_time" : "09:56:47" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:59:24" , 
"departure_time" : "09:59:48" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:59:24" , 
"departure_time" : "09:59:26" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:01:02" , 
"departure_time" : "10:02:06" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:04:04" , 
"departure_time" : "10:05:40" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:06:36" , 
"departure_time" : "10:07:10" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:07:34" , 
"departure_time" : "10:08:35" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:11:01" , 
"departure_time" : "10:11:38" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "10:16:37" , 
"departure_time" : "10:17:39" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "10:19:02" , 
"departure_time" : "10:20:35" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "10:22:33" , 
"departure_time" : "10:23:44" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "10:25:11" , 
"departure_time" : "10:26:28" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "10:27:17" , 
"departure_time" : "10:27:18" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "10:28:01" , 
"departure_time" : "10:28:01" , 
"distance_traveled" : 10.0595
} ], 
"926" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "10:06:00" , 
"departure_time" : "10:06:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "10:07:21" , 
"departure_time" : "10:08:11" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "10:09:50" , 
"departure_time" : "10:10:38" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:12:48" , 
"departure_time" : "10:13:12" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:15:24" , 
"departure_time" : "10:15:43" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:16:19" , 
"departure_time" : "10:16:41" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:18:22" , 
"departure_time" : "10:18:38" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:20:16" , 
"departure_time" : "10:21:07" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:22:51" , 
"departure_time" : "10:22:54" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:24:03" , 
"departure_time" : "10:25:08" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:28:05" , 
"departure_time" : "10:28:19" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "10:33:14" , 
"departure_time" : "10:34:31" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "10:36:17" , 
"departure_time" : "10:37:07" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "10:38:50" , 
"departure_time" : "10:39:16" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "10:41:26" , 
"departure_time" : "10:42:57" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "10:44:31" , 
"departure_time" : "10:44:47" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "10:45:16" , 
"departure_time" : "10:45:16" , 
"distance_traveled" : 10.0595
} ], 
"927" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "10:26:00" , 
"departure_time" : "10:26:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "10:27:27" , 
"departure_time" : "10:28:50" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "10:30:23" , 
"departure_time" : "10:31:52" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:33:29" , 
"departure_time" : "10:34:25" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:35:56" , 
"departure_time" : "10:36:46" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:36:50" , 
"departure_time" : "10:37:37" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:38:47" , 
"departure_time" : "10:38:59" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:40:12" , 
"departure_time" : "10:40:49" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:42:37" , 
"departure_time" : "10:42:59" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:44:22" , 
"departure_time" : "10:44:46" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:47:24" , 
"departure_time" : "10:48:23" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "10:53:59" , 
"departure_time" : "10:54:42" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "10:55:43" , 
"departure_time" : "10:56:53" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "10:59:10" , 
"departure_time" : "10:59:18" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "11:01:08" , 
"departure_time" : "11:02:06" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "11:03:58" , 
"departure_time" : "11:04:42" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "11:05:44" , 
"departure_time" : "11:05:44" , 
"distance_traveled" : 10.0595
} ], 
"928" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "10:46:00" , 
"departure_time" : "10:46:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "10:47:05" , 
"departure_time" : "10:48:10" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "10:50:05" , 
"departure_time" : "10:50:23" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:52:18" , 
"departure_time" : "10:53:39" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:56:21" , 
"departure_time" : "10:56:44" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:56:23" , 
"departure_time" : "10:56:44" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:58:21" , 
"departure_time" : "10:59:27" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:01:06" , 
"departure_time" : "11:01:38" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:02:32" , 
"departure_time" : "11:02:52" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:04:20" , 
"departure_time" : "11:05:29" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:08:09" , 
"departure_time" : "11:09:12" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "11:14:03" , 
"departure_time" : "11:15:19" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "11:16:16" , 
"departure_time" : "11:16:34" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "11:18:18" , 
"departure_time" : "11:19:43" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "11:22:25" , 
"departure_time" : "11:23:33" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "11:24:08" , 
"departure_time" : "11:24:34" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "11:25:26" , 
"departure_time" : "11:25:26" , 
"distance_traveled" : 10.0595
} ], 
"929" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "11:06:00" , 
"departure_time" : "11:07:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "11:07:56" , 
"departure_time" : "11:09:05" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "11:10:09" , 
"departure_time" : "11:10:28" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:12:19" , 
"departure_time" : "11:13:18" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:15:59" , 
"departure_time" : "11:16:03" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:16:04" , 
"departure_time" : "11:17:16" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:19:12" , 
"departure_time" : "11:19:16" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:20:04" , 
"departure_time" : "11:20:14" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:22:10" , 
"departure_time" : "11:22:14" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:24:04" , 
"departure_time" : "11:24:06" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:27:02" , 
"departure_time" : "11:28:42" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "11:34:40" , 
"departure_time" : "11:35:40" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "11:36:00" , 
"departure_time" : "11:37:01" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "11:39:01" , 
"departure_time" : "11:39:59" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "11:41:58" , 
"departure_time" : "11:42:13" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "11:43:15" , 
"departure_time" : "11:44:09" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "11:45:54" , 
"departure_time" : "11:45:54" , 
"distance_traveled" : 10.0595
} ], 
"930" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "11:26:00" , 
"departure_time" : "11:27:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "11:27:21" , 
"departure_time" : "11:28:25" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "11:30:04" , 
"departure_time" : "11:30:39" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:32:35" , 
"departure_time" : "11:33:34" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:35:59" , 
"departure_time" : "11:36:40" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:36:41" , 
"departure_time" : "11:37:05" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:38:24" , 
"departure_time" : "11:39:02" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:40:38" , 
"departure_time" : "11:41:46" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:43:08" , 
"departure_time" : "11:44:39" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:45:31" , 
"departure_time" : "11:45:38" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:47:07" , 
"departure_time" : "11:47:58" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "11:53:51" , 
"departure_time" : "11:54:51" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "11:56:00" , 
"departure_time" : "11:56:39" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "11:58:39" , 
"departure_time" : "11:59:57" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "12:02:18" , 
"departure_time" : "12:02:44" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "12:03:26" , 
"departure_time" : "12:04:24" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "12:05:58" , 
"departure_time" : "12:05:58" , 
"distance_traveled" : 10.0595
} ], 
"931" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "11:46:00" , 
"departure_time" : "11:48:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "11:48:21" , 
"departure_time" : "11:49:57" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "11:50:36" , 
"departure_time" : "11:51:10" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:52:34" , 
"departure_time" : "11:53:57" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:56:23" , 
"departure_time" : "11:58:00" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:57:37" , 
"departure_time" : "11:57:51" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:58:14" , 
"departure_time" : "11:59:01" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:00:47" , 
"departure_time" : "12:01:54" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:03:07" , 
"departure_time" : "12:03:23" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:04:16" , 
"departure_time" : "12:05:11" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:07:55" , 
"departure_time" : "12:08:09" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "12:13:14" , 
"departure_time" : "12:14:44" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "12:16:30" , 
"departure_time" : "12:17:20" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "12:18:50" , 
"departure_time" : "12:20:07" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "12:22:17" , 
"departure_time" : "12:23:51" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "12:24:34" , 
"departure_time" : "12:26:04" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "12:26:30" , 
"departure_time" : "12:26:30" , 
"distance_traveled" : 10.0595
} ], 
"932" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "12:06:00" , 
"departure_time" : "12:08:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "12:07:51" , 
"departure_time" : "12:08:58" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "12:10:07" , 
"departure_time" : "12:11:16" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:13:09" , 
"departure_time" : "12:14:12" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:16:03" , 
"departure_time" : "12:17:03" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:17:00" , 
"departure_time" : "12:18:25" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:19:25" , 
"departure_time" : "12:19:53" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:20:28" , 
"departure_time" : "12:21:06" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:22:38" , 
"departure_time" : "12:23:17" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:24:39" , 
"departure_time" : "12:26:15" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:28:36" , 
"departure_time" : "12:30:02" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "12:34:26" , 
"departure_time" : "12:34:35" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "12:35:09" , 
"departure_time" : "12:35:13" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "12:38:04" , 
"departure_time" : "12:38:21" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "12:41:17" , 
"departure_time" : "12:41:19" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "12:43:02" , 
"departure_time" : "12:44:06" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "12:46:04" , 
"departure_time" : "12:46:04" , 
"distance_traveled" : 10.0595
} ], 
"933" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "12:26:00" , 
"departure_time" : "12:27:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "12:27:34" , 
"departure_time" : "12:27:59" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "12:29:25" , 
"departure_time" : "12:30:04" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:32:39" , 
"departure_time" : "12:33:14" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:35:35" , 
"departure_time" : "12:36:13" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:36:38" , 
"departure_time" : "12:37:55" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:39:17" , 
"departure_time" : "12:40:01" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:40:44" , 
"departure_time" : "12:42:03" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:43:19" , 
"departure_time" : "12:44:49" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:45:30" , 
"departure_time" : "12:45:57" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:47:27" , 
"departure_time" : "12:48:19" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "12:53:52" , 
"departure_time" : "12:54:09" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "12:55:17" , 
"departure_time" : "12:55:35" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "12:58:18" , 
"departure_time" : "12:58:29" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "13:01:11" , 
"departure_time" : "13:01:23" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "13:03:12" , 
"departure_time" : "13:03:17" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "13:05:05" , 
"departure_time" : "13:05:05" , 
"distance_traveled" : 10.0595
} ], 
"934" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "12:46:00" , 
"departure_time" : "12:47:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "12:48:37" , 
"departure_time" : "12:50:17" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "12:50:40" , 
"departure_time" : "12:51:17" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:52:37" , 
"departure_time" : "12:53:44" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:56:07" , 
"departure_time" : "12:56:20" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:56:13" , 
"departure_time" : "12:57:03" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:58:50" , 
"departure_time" : "12:58:52" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:00:02" , 
"departure_time" : "13:00:11" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:02:09" , 
"departure_time" : "13:02:40" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:04:31" , 
"departure_time" : "13:04:47" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:07:16" , 
"departure_time" : "13:07:35" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "13:13:19" , 
"departure_time" : "13:14:36" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "13:16:17" , 
"departure_time" : "13:17:00" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "13:18:43" , 
"departure_time" : "13:19:41" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "13:21:58" , 
"departure_time" : "13:22:26" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "13:23:28" , 
"departure_time" : "13:24:02" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "13:25:34" , 
"departure_time" : "13:25:34" , 
"distance_traveled" : 10.0595
} ], 
"935" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "13:06:00" , 
"departure_time" : "13:08:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "13:08:29" , 
"departure_time" : "13:09:53" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "13:10:24" , 
"departure_time" : "13:11:55" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:13:31" , 
"departure_time" : "13:14:49" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:16:18" , 
"departure_time" : "13:17:48" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:17:30" , 
"departure_time" : "13:17:55" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:18:25" , 
"departure_time" : "13:20:02" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:21:37" , 
"departure_time" : "13:22:34" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:22:57" , 
"departure_time" : "13:23:41" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:24:44" , 
"departure_time" : "13:26:04" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:28:20" , 
"departure_time" : "13:29:31" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "13:34:11" , 
"departure_time" : "13:35:26" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "13:36:15" , 
"departure_time" : "13:37:25" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "13:39:10" , 
"departure_time" : "13:40:39" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "13:42:29" , 
"departure_time" : "13:43:43" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "13:44:14" , 
"departure_time" : "13:45:18" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "13:46:04" , 
"departure_time" : "13:46:04" , 
"distance_traveled" : 10.0595
} ], 
"936" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "13:26:00" , 
"departure_time" : "13:28:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "13:28:12" , 
"departure_time" : "13:29:47" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "13:30:35" , 
"departure_time" : "13:31:59" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:33:24" , 
"departure_time" : "13:33:40" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:35:16" , 
"departure_time" : "13:35:23" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:36:07" , 
"departure_time" : "13:36:13" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:38:06" , 
"departure_time" : "13:39:26" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:41:20" , 
"departure_time" : "13:42:12" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:42:52" , 
"departure_time" : "13:43:02" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:44:10" , 
"departure_time" : "13:45:41" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:48:31" , 
"departure_time" : "13:50:05" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "13:54:34" , 
"departure_time" : "13:55:08" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "13:55:34" , 
"departure_time" : "13:57:09" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "13:59:35" , 
"departure_time" : "13:59:56" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "14:01:21" , 
"departure_time" : "14:01:39" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "14:03:18" , 
"departure_time" : "14:04:47" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "14:06:29" , 
"departure_time" : "14:06:29" , 
"distance_traveled" : 10.0595
} ], 
"937" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "13:46:00" , 
"departure_time" : "13:48:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "13:48:26" , 
"departure_time" : "13:49:40" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "13:50:14" , 
"departure_time" : "13:51:22" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:53:08" , 
"departure_time" : "13:54:31" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:56:23" , 
"departure_time" : "13:56:29" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:56:06" , 
"departure_time" : "13:57:22" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:59:16" , 
"departure_time" : "14:00:48" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:01:32" , 
"departure_time" : "14:01:49" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:02:17" , 
"departure_time" : "14:02:52" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:04:35" , 
"departure_time" : "14:05:33" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:07:58" , 
"departure_time" : "14:09:30" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "14:14:32" , 
"departure_time" : "14:15:48" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "14:16:16" , 
"departure_time" : "14:16:43" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "14:18:27" , 
"departure_time" : "14:18:54" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "14:21:27" , 
"departure_time" : "14:22:26" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "14:23:59" , 
"departure_time" : "14:24:35" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "14:25:36" , 
"departure_time" : "14:25:36" , 
"distance_traveled" : 10.0595
} ], 
"938" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "14:06:00" , 
"departure_time" : "14:07:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "14:08:08" , 
"departure_time" : "14:09:21" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "14:10:13" , 
"departure_time" : "14:11:02" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:12:49" , 
"departure_time" : "14:14:29" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:16:40" , 
"departure_time" : "14:17:20" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:16:40" , 
"departure_time" : "14:16:45" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:18:05" , 
"departure_time" : "14:18:08" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:20:03" , 
"departure_time" : "14:21:34" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:23:31" , 
"departure_time" : "14:23:54" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:24:23" , 
"departure_time" : "14:25:53" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:28:30" , 
"departure_time" : "14:28:47" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "14:33:17" , 
"departure_time" : "14:34:52" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "14:36:35" , 
"departure_time" : "14:36:41" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "14:38:06" , 
"departure_time" : "14:39:10" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "14:42:04" , 
"departure_time" : "14:42:10" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "14:43:06" , 
"departure_time" : "14:44:15" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "14:46:09" , 
"departure_time" : "14:46:09" , 
"distance_traveled" : 10.0595
} ], 
"939" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "14:26:00" , 
"departure_time" : "14:27:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "14:27:45" , 
"departure_time" : "14:28:12" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "14:29:27" , 
"departure_time" : "14:30:52" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:33:25" , 
"departure_time" : "14:34:25" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:36:00" , 
"departure_time" : "14:37:17" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:37:17" , 
"departure_time" : "14:38:13" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:38:56" , 
"departure_time" : "14:40:29" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:41:33" , 
"departure_time" : "14:42:26" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:42:53" , 
"departure_time" : "14:43:31" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:44:38" , 
"departure_time" : "14:45:20" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:47:42" , 
"departure_time" : "14:48:28" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "14:53:46" , 
"departure_time" : "14:54:49" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "14:56:03" , 
"departure_time" : "14:57:16" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "14:59:13" , 
"departure_time" : "14:59:47" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "15:01:34" , 
"departure_time" : "15:02:27" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "15:03:53" , 
"departure_time" : "15:04:59" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "15:06:06" , 
"departure_time" : "15:06:06" , 
"distance_traveled" : 10.0595
} ], 
"940" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "14:46:00" , 
"departure_time" : "14:47:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "14:47:11" , 
"departure_time" : "14:47:43" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "14:49:32" , 
"departure_time" : "14:49:50" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:52:18" , 
"departure_time" : "14:53:55" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:56:37" , 
"departure_time" : "14:58:16" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:57:39" , 
"departure_time" : "14:58:23" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:58:44" , 
"departure_time" : "15:00:19" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:01:35" , 
"departure_time" : "15:03:09" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:03:34" , 
"departure_time" : "15:04:50" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:05:16" , 
"departure_time" : "15:05:19" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:07:03" , 
"departure_time" : "15:08:28" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "15:14:25" , 
"departure_time" : "15:15:17" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "15:15:52" , 
"departure_time" : "15:17:20" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "15:19:28" , 
"departure_time" : "15:20:31" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "15:22:03" , 
"departure_time" : "15:22:33" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "15:23:30" , 
"departure_time" : "15:24:50" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "15:26:20" , 
"departure_time" : "15:26:20" , 
"distance_traveled" : 10.0595
} ], 
"941" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "15:05:00" , 
"departure_time" : "15:07:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "15:07:11" , 
"departure_time" : "15:08:37" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "15:09:26" , 
"departure_time" : "15:09:30" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:11:04" , 
"departure_time" : "15:11:38" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:14:34" , 
"departure_time" : "15:15:08" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:15:34" , 
"departure_time" : "15:16:53" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:18:19" , 
"departure_time" : "15:18:35" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:19:16" , 
"departure_time" : "15:19:24" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:21:08" , 
"departure_time" : "15:22:48" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:24:40" , 
"departure_time" : "15:26:00" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:27:20" , 
"departure_time" : "15:27:26" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "15:32:06" , 
"departure_time" : "15:33:30" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "15:35:24" , 
"departure_time" : "15:36:50" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "15:38:26" , 
"departure_time" : "15:38:45" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "15:40:19" , 
"departure_time" : "15:41:15" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "15:42:56" , 
"departure_time" : "15:43:48" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "15:44:52" , 
"departure_time" : "15:44:52" , 
"distance_traveled" : 10.0595
} ], 
"942" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "15:18:00" , 
"departure_time" : "15:19:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "15:19:47" , 
"departure_time" : "15:21:17" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "15:22:30" , 
"departure_time" : "15:22:48" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:24:18" , 
"departure_time" : "15:24:59" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:27:41" , 
"departure_time" : "15:28:48" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:29:07" , 
"departure_time" : "15:30:35" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:31:28" , 
"departure_time" : "15:31:51" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:32:23" , 
"departure_time" : "15:32:24" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:34:01" , 
"departure_time" : "15:34:20" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:36:19" , 
"departure_time" : "15:37:49" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:40:30" , 
"departure_time" : "15:41:25" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "15:45:55" , 
"departure_time" : "15:47:15" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "15:48:20" , 
"departure_time" : "15:49:31" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "15:51:11" , 
"departure_time" : "15:52:07" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "15:53:56" , 
"departure_time" : "15:54:21" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "15:55:25" , 
"departure_time" : "15:56:19" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "15:57:54" , 
"departure_time" : "15:57:54" , 
"distance_traveled" : 10.0595
} ], 
"943" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "15:27:00" , 
"departure_time" : "15:29:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "15:29:16" , 
"departure_time" : "15:30:52" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "15:31:36" , 
"departure_time" : "15:33:15" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:34:39" , 
"departure_time" : "15:34:41" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:36:02" , 
"departure_time" : "15:37:24" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:38:22" , 
"departure_time" : "15:39:30" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:40:08" , 
"departure_time" : "15:40:26" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:41:18" , 
"departure_time" : "15:42:47" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:44:29" , 
"departure_time" : "15:45:12" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:45:43" , 
"departure_time" : "15:47:04" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:49:21" , 
"departure_time" : "15:49:52" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "15:54:31" , 
"departure_time" : "15:54:46" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "15:56:15" , 
"departure_time" : "15:56:22" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "15:59:07" , 
"departure_time" : "16:00:08" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "16:03:01" , 
"departure_time" : "16:03:38" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:04:37" , 
"departure_time" : "16:05:55" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "16:07:18" , 
"departure_time" : "16:07:18" , 
"distance_traveled" : 10.0595
} ], 
"944" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "15:37:00" , 
"departure_time" : "15:38:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "15:38:07" , 
"departure_time" : "15:38:20" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "15:40:13" , 
"departure_time" : "15:41:18" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:44:05" , 
"departure_time" : "15:45:08" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:47:03" , 
"departure_time" : "15:48:19" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:48:16" , 
"departure_time" : "15:48:31" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:49:15" , 
"departure_time" : "15:50:32" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:52:17" , 
"departure_time" : "15:53:10" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:53:53" , 
"departure_time" : "15:53:54" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:55:01" , 
"departure_time" : "15:55:07" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:58:06" , 
"departure_time" : "15:59:17" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:05:11" , 
"departure_time" : "16:05:23" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:06:12" , 
"departure_time" : "16:07:14" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:10:02" , 
"departure_time" : "16:10:55" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "16:12:53" , 
"departure_time" : "16:13:49" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:14:56" , 
"departure_time" : "16:15:13" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "16:16:17" , 
"departure_time" : "16:16:17" , 
"distance_traveled" : 10.0595
} ], 
"945" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "15:49:00" , 
"departure_time" : "15:50:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "15:51:07" , 
"departure_time" : "15:52:30" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "15:53:23" , 
"departure_time" : "15:54:39" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:56:16" , 
"departure_time" : "15:57:12" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:58:56" , 
"departure_time" : "16:00:01" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:00:05" , 
"departure_time" : "16:01:14" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:02:09" , 
"departure_time" : "16:02:44" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:03:35" , 
"departure_time" : "16:04:39" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:06:04" , 
"departure_time" : "16:06:10" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:07:06" , 
"departure_time" : "16:08:14" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:11:08" , 
"departure_time" : "16:12:17" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:17:09" , 
"departure_time" : "16:17:32" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:18:23" , 
"departure_time" : "16:19:31" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:22:08" , 
"departure_time" : "16:23:42" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "16:25:34" , 
"departure_time" : "16:26:22" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:26:48" , 
"departure_time" : "16:27:04" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "16:28:16" , 
"departure_time" : "16:28:16" , 
"distance_traveled" : 10.0595
} ], 
"946" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "15:55:00" , 
"departure_time" : "15:56:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "15:56:48" , 
"departure_time" : "15:57:35" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "15:58:47" , 
"departure_time" : "15:59:13" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:01:26" , 
"departure_time" : "16:01:28" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:04:02" , 
"departure_time" : "16:04:17" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:05:15" , 
"departure_time" : "16:05:51" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:07:36" , 
"departure_time" : "16:09:05" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:10:29" , 
"departure_time" : "16:10:34" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:11:05" , 
"departure_time" : "16:11:33" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:13:28" , 
"departure_time" : "16:14:53" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:17:25" , 
"departure_time" : "16:18:09" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:22:44" , 
"departure_time" : "16:24:00" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:25:16" , 
"departure_time" : "16:26:38" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:28:22" , 
"departure_time" : "16:28:49" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "16:30:27" , 
"departure_time" : "16:31:00" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:32:33" , 
"departure_time" : "16:32:51" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "16:34:18" , 
"departure_time" : "16:34:18" , 
"distance_traveled" : 10.0595
} ], 
"947" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "16:10:00" , 
"departure_time" : "16:10:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "16:11:08" , 
"departure_time" : "16:11:39" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "16:13:31" , 
"departure_time" : "16:15:03" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:17:32" , 
"departure_time" : "16:19:12" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:20:40" , 
"departure_time" : "16:21:09" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:20:29" , 
"departure_time" : "16:21:02" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:22:33" , 
"departure_time" : "16:23:19" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:24:46" , 
"departure_time" : "16:24:47" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:26:01" , 
"departure_time" : "16:27:11" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:29:10" , 
"departure_time" : "16:29:48" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:31:38" , 
"departure_time" : "16:31:39" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:37:01" , 
"departure_time" : "16:37:39" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:39:38" , 
"departure_time" : "16:40:31" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:42:53" , 
"departure_time" : "16:43:26" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "16:45:33" , 
"departure_time" : "16:45:37" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:47:04" , 
"departure_time" : "16:48:06" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "16:50:02" , 
"departure_time" : "16:50:02" , 
"distance_traveled" : 10.0595
} ], 
"948" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "16:20:00" , 
"departure_time" : "16:21:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "16:21:08" , 
"departure_time" : "16:21:10" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "16:23:02" , 
"departure_time" : "16:23:10" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:26:08" , 
"departure_time" : "16:27:22" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:30:14" , 
"departure_time" : "16:31:25" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:31:11" , 
"departure_time" : "16:32:03" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:32:52" , 
"departure_time" : "16:34:12" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:35:20" , 
"departure_time" : "16:35:44" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:36:24" , 
"departure_time" : "16:37:59" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:39:35" , 
"departure_time" : "16:40:38" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:42:03" , 
"departure_time" : "16:43:07" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:48:04" , 
"departure_time" : "16:48:36" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:49:32" , 
"departure_time" : "16:50:23" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:52:51" , 
"departure_time" : "16:54:23" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "16:56:32" , 
"departure_time" : "16:57:47" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:58:15" , 
"departure_time" : "16:58:42" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "16:59:27" , 
"departure_time" : "16:59:27" , 
"distance_traveled" : 10.0595
} ], 
"949" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "16:28:00" , 
"departure_time" : "16:28:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "16:29:26" , 
"departure_time" : "16:29:29" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "16:31:03" , 
"departure_time" : "16:31:56" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:34:53" , 
"departure_time" : "16:35:42" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:37:49" , 
"departure_time" : "16:38:50" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:39:01" , 
"departure_time" : "16:39:32" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:40:31" , 
"departure_time" : "16:41:23" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:42:52" , 
"departure_time" : "16:43:02" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:44:10" , 
"departure_time" : "16:44:32" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:46:22" , 
"departure_time" : "16:47:22" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:50:00" , 
"departure_time" : "16:50:35" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:55:35" , 
"departure_time" : "16:55:37" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:57:02" , 
"departure_time" : "16:58:36" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:01:34" , 
"departure_time" : "17:02:43" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:04:09" , 
"departure_time" : "17:05:17" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:06:08" , 
"departure_time" : "17:06:53" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "17:07:45" , 
"departure_time" : "17:07:45" , 
"distance_traveled" : 10.0595
} ], 
"950" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "16:41:00" , 
"departure_time" : "16:42:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "16:42:34" , 
"departure_time" : "16:43:48" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "16:45:14" , 
"departure_time" : "16:45:59" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:47:45" , 
"departure_time" : "16:47:48" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:50:03" , 
"departure_time" : "16:51:04" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:52:01" , 
"departure_time" : "16:52:37" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:53:36" , 
"departure_time" : "16:54:53" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:56:17" , 
"departure_time" : "16:56:27" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:57:10" , 
"departure_time" : "16:57:39" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:59:29" , 
"departure_time" : "16:59:54" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:02:25" , 
"departure_time" : "17:03:23" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:08:58" , 
"departure_time" : "17:09:37" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "17:10:39" , 
"departure_time" : "17:11:21" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:13:42" , 
"departure_time" : "17:13:56" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:16:14" , 
"departure_time" : "17:17:45" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:19:31" , 
"departure_time" : "17:19:37" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "17:20:06" , 
"departure_time" : "17:20:06" , 
"distance_traveled" : 10.0595
} ], 
"951" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "16:49:00" , 
"departure_time" : "16:49:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "16:50:53" , 
"departure_time" : "16:51:52" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "16:52:59" , 
"departure_time" : "16:54:18" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:56:19" , 
"departure_time" : "16:57:09" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:58:50" , 
"departure_time" : "17:00:18" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:00:28" , 
"departure_time" : "17:01:40" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:02:12" , 
"departure_time" : "17:02:56" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:03:44" , 
"departure_time" : "17:05:23" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:06:39" , 
"departure_time" : "17:08:09" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:08:30" , 
"departure_time" : "17:08:36" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:10:06" , 
"departure_time" : "17:11:35" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:17:29" , 
"departure_time" : "17:17:50" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "17:18:21" , 
"departure_time" : "17:19:51" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:22:30" , 
"departure_time" : "17:23:39" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:25:09" , 
"departure_time" : "17:26:27" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:27:18" , 
"departure_time" : "17:27:23" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "17:28:05" , 
"departure_time" : "17:28:05" , 
"distance_traveled" : 10.0595
} ], 
"952" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "16:59:00" , 
"departure_time" : "16:59:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "17:00:44" , 
"departure_time" : "17:01:34" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "17:02:50" , 
"departure_time" : "17:03:01" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:05:11" , 
"departure_time" : "17:05:45" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:08:34" , 
"departure_time" : "17:09:22" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:09:48" , 
"departure_time" : "17:10:18" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:11:30" , 
"departure_time" : "17:11:45" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:13:15" , 
"departure_time" : "17:13:25" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:15:10" , 
"departure_time" : "17:15:32" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:17:22" , 
"departure_time" : "17:18:21" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:20:59" , 
"departure_time" : "17:21:28" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:26:29" , 
"departure_time" : "17:27:13" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "17:28:44" , 
"departure_time" : "17:29:56" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:32:12" , 
"departure_time" : "17:33:42" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:35:30" , 
"departure_time" : "17:36:51" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:37:21" , 
"departure_time" : "17:38:41" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "17:39:20" , 
"departure_time" : "17:39:20" , 
"distance_traveled" : 10.0595
} ], 
"953" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "17:09:00" , 
"departure_time" : "17:11:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "17:11:06" , 
"departure_time" : "17:12:11" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "17:13:05" , 
"departure_time" : "17:13:27" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:15:22" , 
"departure_time" : "17:16:52" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:19:30" , 
"departure_time" : "17:19:40" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:19:10" , 
"departure_time" : "17:20:10" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:22:00" , 
"departure_time" : "17:23:22" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:24:22" , 
"departure_time" : "17:24:55" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:25:33" , 
"departure_time" : "17:25:35" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:27:02" , 
"departure_time" : "17:28:18" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:31:16" , 
"departure_time" : "17:32:17" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:37:01" , 
"departure_time" : "17:37:39" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "17:38:38" , 
"departure_time" : "17:39:56" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:42:18" , 
"departure_time" : "17:42:42" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:44:24" , 
"departure_time" : "17:45:49" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:47:25" , 
"departure_time" : "17:48:46" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "17:49:21" , 
"departure_time" : "17:49:21" , 
"distance_traveled" : 10.0595
} ], 
"954" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "17:19:00" , 
"departure_time" : "17:21:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "17:21:00" , 
"departure_time" : "17:21:30" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "17:22:30" , 
"departure_time" : "17:23:49" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:26:19" , 
"departure_time" : "17:26:45" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:28:26" , 
"departure_time" : "17:28:39" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:29:13" , 
"departure_time" : "17:29:32" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:31:19" , 
"departure_time" : "17:32:03" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:33:44" , 
"departure_time" : "17:34:42" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:35:58" , 
"departure_time" : "17:37:00" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:38:02" , 
"departure_time" : "17:38:44" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:40:42" , 
"departure_time" : "17:40:48" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:46:06" , 
"departure_time" : "17:46:12" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "17:48:06" , 
"departure_time" : "17:49:23" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:52:17" , 
"departure_time" : "17:53:56" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:55:39" , 
"departure_time" : "17:57:00" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:57:21" , 
"departure_time" : "17:58:51" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "17:59:30" , 
"departure_time" : "17:59:30" , 
"distance_traveled" : 10.0595
} ], 
"955" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "17:25:00" , 
"departure_time" : "17:26:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "17:26:24" , 
"departure_time" : "17:27:45" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "17:29:21" , 
"departure_time" : "17:29:46" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:31:25" , 
"departure_time" : "17:32:31" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:35:06" , 
"departure_time" : "17:36:29" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:36:23" , 
"departure_time" : "17:36:40" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:37:17" , 
"departure_time" : "17:38:25" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:40:08" , 
"departure_time" : "17:40:57" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:41:49" , 
"departure_time" : "17:42:30" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:43:41" , 
"departure_time" : "17:45:14" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:47:33" , 
"departure_time" : "17:48:02" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:52:29" , 
"departure_time" : "17:53:21" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "17:54:52" , 
"departure_time" : "17:56:18" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:58:26" , 
"departure_time" : "17:59:14" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:00:48" , 
"departure_time" : "18:01:14" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:02:26" , 
"departure_time" : "18:03:47" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "18:05:21" , 
"departure_time" : "18:05:21" , 
"distance_traveled" : 10.0595
} ], 
"956" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "17:38:00" , 
"departure_time" : "17:40:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "17:39:58" , 
"departure_time" : "17:40:33" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "17:41:35" , 
"departure_time" : "17:42:00" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:44:25" , 
"departure_time" : "17:45:27" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:48:02" , 
"departure_time" : "17:48:09" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:48:07" , 
"departure_time" : "17:49:38" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:51:31" , 
"departure_time" : "17:53:09" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:53:38" , 
"departure_time" : "17:55:01" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:55:23" , 
"departure_time" : "17:55:55" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:56:32" , 
"departure_time" : "17:57:23" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:59:51" , 
"departure_time" : "17:59:53" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:05:02" , 
"departure_time" : "18:05:46" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:07:44" , 
"departure_time" : "18:08:15" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:10:31" , 
"departure_time" : "18:11:06" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:13:35" , 
"departure_time" : "18:14:56" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:16:21" , 
"departure_time" : "18:16:46" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "18:17:25" , 
"departure_time" : "18:17:25" , 
"distance_traveled" : 10.0595
} ], 
"957" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "17:47:00" , 
"departure_time" : "17:48:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "17:49:03" , 
"departure_time" : "17:50:25" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "17:51:22" , 
"departure_time" : "17:52:31" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:54:09" , 
"departure_time" : "17:54:13" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:56:04" , 
"departure_time" : "17:57:13" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:58:09" , 
"departure_time" : "17:59:45" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:00:36" , 
"departure_time" : "18:02:07" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:02:31" , 
"departure_time" : "18:03:12" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:03:41" , 
"departure_time" : "18:05:10" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:06:29" , 
"departure_time" : "18:07:46" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:09:17" , 
"departure_time" : "18:09:19" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:14:02" , 
"departure_time" : "18:15:21" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:17:19" , 
"departure_time" : "18:18:10" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:19:51" , 
"departure_time" : "18:21:07" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:23:16" , 
"departure_time" : "18:24:41" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:25:25" , 
"departure_time" : "18:27:00" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "18:27:35" , 
"departure_time" : "18:27:35" , 
"distance_traveled" : 10.0595
} ], 
"958" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "17:54:00" , 
"departure_time" : "17:55:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "17:55:03" , 
"departure_time" : "17:56:20" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "17:58:17" , 
"departure_time" : "17:58:28" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:00:11" , 
"departure_time" : "18:01:47" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:04:36" , 
"departure_time" : "18:05:58" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:05:22" , 
"departure_time" : "18:06:55" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:07:33" , 
"departure_time" : "18:09:02" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:09:29" , 
"departure_time" : "18:09:34" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:10:05" , 
"departure_time" : "18:10:23" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:12:18" , 
"departure_time" : "18:12:22" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:15:04" , 
"departure_time" : "18:15:30" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:21:26" , 
"departure_time" : "18:22:02" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:23:36" , 
"departure_time" : "18:23:58" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:26:22" , 
"departure_time" : "18:26:45" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:29:23" , 
"departure_time" : "18:29:37" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:31:14" , 
"departure_time" : "18:32:24" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "18:34:10" , 
"departure_time" : "18:34:10" , 
"distance_traveled" : 10.0595
} ], 
"959" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "18:06:00" , 
"departure_time" : "18:07:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "18:07:22" , 
"departure_time" : "18:08:37" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "18:10:15" , 
"departure_time" : "18:10:26" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:12:11" , 
"departure_time" : "18:13:17" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:16:06" , 
"departure_time" : "18:17:06" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:17:00" , 
"departure_time" : "18:18:25" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:19:25" , 
"departure_time" : "18:20:39" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:21:14" , 
"departure_time" : "18:21:48" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:22:34" , 
"departure_time" : "18:23:59" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:25:25" , 
"departure_time" : "18:26:51" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:28:26" , 
"departure_time" : "18:29:43" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:34:17" , 
"departure_time" : "18:34:27" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:35:10" , 
"departure_time" : "18:35:24" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:38:14" , 
"departure_time" : "18:38:50" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:41:36" , 
"departure_time" : "18:41:58" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:43:22" , 
"departure_time" : "18:44:05" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "18:45:43" , 
"departure_time" : "18:45:43" , 
"distance_traveled" : 10.0595
} ], 
"960" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "18:17:00" , 
"departure_time" : "18:18:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "18:18:41" , 
"departure_time" : "18:20:06" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "18:21:25" , 
"departure_time" : "18:22:46" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:24:21" , 
"departure_time" : "18:25:13" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:26:52" , 
"departure_time" : "18:28:07" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:28:15" , 
"departure_time" : "18:29:03" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:29:48" , 
"departure_time" : "18:30:17" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:31:29" , 
"departure_time" : "18:31:41" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:33:12" , 
"departure_time" : "18:34:09" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:35:57" , 
"departure_time" : "18:36:31" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:38:34" , 
"departure_time" : "18:40:05" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:45:31" , 
"departure_time" : "18:45:41" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:46:10" , 
"departure_time" : "18:47:40" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:50:30" , 
"departure_time" : "18:51:50" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:53:20" , 
"departure_time" : "18:54:52" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:55:32" , 
"departure_time" : "18:55:40" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "18:56:08" , 
"departure_time" : "18:56:08" , 
"distance_traveled" : 10.0595
} ], 
"961" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "18:28:00" , 
"departure_time" : "18:29:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "18:30:12" , 
"departure_time" : "18:31:48" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "18:32:36" , 
"departure_time" : "18:34:05" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:35:29" , 
"departure_time" : "18:37:06" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:38:37" , 
"departure_time" : "18:39:39" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:39:02" , 
"departure_time" : "18:40:07" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:41:05" , 
"departure_time" : "18:42:23" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:43:18" , 
"departure_time" : "18:44:28" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:45:10" , 
"departure_time" : "18:45:15" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:46:05" , 
"departure_time" : "18:46:24" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:49:19" , 
"departure_time" : "18:50:28" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:56:09" , 
"departure_time" : "18:57:34" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:58:25" , 
"departure_time" : "18:58:58" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "19:00:33" , 
"departure_time" : "19:01:32" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "19:03:59" , 
"departure_time" : "19:04:02" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "19:05:03" , 
"departure_time" : "19:05:36" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "19:07:33" , 
"departure_time" : "19:07:33" , 
"distance_traveled" : 10.0595
} ], 
"962" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "18:40:00" , 
"departure_time" : "18:41:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "18:41:30" , 
"departure_time" : "18:42:16" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "18:43:46" , 
"departure_time" : "18:44:16" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:46:30" , 
"departure_time" : "18:47:46" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:50:16" , 
"departure_time" : "18:51:16" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:51:00" , 
"departure_time" : "18:51:47" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:52:47" , 
"departure_time" : "18:54:19" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:55:32" , 
"departure_time" : "18:56:00" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:56:28" , 
"departure_time" : "18:57:00" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:58:32" , 
"departure_time" : "18:59:34" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:02:02" , 
"departure_time" : "19:02:59" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "19:07:57" , 
"departure_time" : "19:08:13" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "19:09:16" , 
"departure_time" : "19:10:23" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "19:13:07" , 
"departure_time" : "19:13:50" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "19:15:43" , 
"departure_time" : "19:17:19" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "19:18:36" , 
"departure_time" : "19:18:39" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "19:19:03" , 
"departure_time" : "19:19:03" , 
"distance_traveled" : 10.0595
} ], 
"963" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "18:51:00" , 
"departure_time" : "18:52:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "18:53:29" , 
"departure_time" : "18:53:44" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "18:54:15" , 
"departure_time" : "18:54:46" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:57:31" , 
"departure_time" : "18:58:42" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:01:11" , 
"departure_time" : "19:01:51" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:01:40" , 
"departure_time" : "19:02:36" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:03:56" , 
"departure_time" : "19:04:43" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:05:47" , 
"departure_time" : "19:06:19" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:07:32" , 
"departure_time" : "19:08:17" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:09:45" , 
"departure_time" : "19:10:40" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:12:55" , 
"departure_time" : "19:14:08" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "19:19:13" , 
"departure_time" : "19:19:45" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "19:20:32" , 
"departure_time" : "19:21:52" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "19:24:20" , 
"departure_time" : "19:24:29" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "19:26:09" , 
"departure_time" : "19:27:28" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "19:29:19" , 
"departure_time" : "19:30:15" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "19:30:56" , 
"departure_time" : "19:30:56" , 
"distance_traveled" : 10.0595
} ], 
"964" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "19:02:00" , 
"departure_time" : "19:04:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "19:04:25" , 
"departure_time" : "19:05:58" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "19:06:33" , 
"departure_time" : "19:07:00" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:08:27" , 
"departure_time" : "19:09:43" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:12:16" , 
"departure_time" : "19:13:28" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:13:12" , 
"departure_time" : "19:14:43" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:15:31" , 
"departure_time" : "19:16:03" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:16:32" , 
"departure_time" : "19:16:56" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:18:24" , 
"departure_time" : "19:18:36" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:20:12" , 
"departure_time" : "19:20:49" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:23:37" , 
"departure_time" : "19:24:35" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "19:29:58" , 
"departure_time" : "19:31:18" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "19:32:20" , 
"departure_time" : "19:33:27" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "19:35:07" , 
"departure_time" : "19:35:59" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "19:37:52" , 
"departure_time" : "19:38:30" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "19:39:38" , 
"departure_time" : "19:41:13" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "19:42:35" , 
"departure_time" : "19:42:35" , 
"distance_traveled" : 10.0595
} ], 
"965" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "19:16:00" , 
"departure_time" : "19:18:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "19:18:19" , 
"departure_time" : "19:18:55" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "19:19:36" , 
"departure_time" : "19:20:20" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:22:44" , 
"departure_time" : "19:23:10" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:25:26" , 
"departure_time" : "19:25:51" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:26:25" , 
"departure_time" : "19:26:46" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:28:21" , 
"departure_time" : "19:29:48" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:31:27" , 
"departure_time" : "19:31:30" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:32:03" , 
"departure_time" : "19:33:39" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:35:36" , 
"departure_time" : "19:36:26" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:37:50" , 
"departure_time" : "19:39:01" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "19:44:11" , 
"departure_time" : "19:45:48" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "19:46:37" , 
"departure_time" : "19:48:00" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "19:49:23" , 
"departure_time" : "19:49:29" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "19:51:06" , 
"departure_time" : "19:52:38" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "19:54:32" , 
"departure_time" : "19:55:44" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "19:56:12" , 
"departure_time" : "19:56:12" , 
"distance_traveled" : 10.0595
} ], 
"966" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "19:26:00" , 
"departure_time" : "19:27:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "19:27:29" , 
"departure_time" : "19:28:47" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "19:30:18" , 
"departure_time" : "19:31:03" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:32:45" , 
"departure_time" : "19:32:51" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:35:06" , 
"departure_time" : "19:36:26" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:37:20" , 
"departure_time" : "19:37:49" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:38:29" , 
"departure_time" : "19:38:50" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:40:21" , 
"departure_time" : "19:41:14" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:42:53" , 
"departure_time" : "19:43:52" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:44:59" , 
"departure_time" : "19:46:26" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:48:27" , 
"departure_time" : "19:50:02" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "19:54:35" , 
"departure_time" : "19:55:34" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "19:55:59" , 
"departure_time" : "19:57:36" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "19:59:37" , 
"departure_time" : "19:59:42" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "20:01:05" , 
"departure_time" : "20:02:23" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "20:04:18" , 
"departure_time" : "20:04:45" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "20:05:27" , 
"departure_time" : "20:05:27" , 
"distance_traveled" : 10.0595
} ], 
"967" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "19:36:00" , 
"departure_time" : "19:36:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "19:37:03" , 
"departure_time" : "19:37:57" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "19:39:54" , 
"departure_time" : "19:40:15" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:42:21" , 
"departure_time" : "19:43:19" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:45:58" , 
"departure_time" : "19:47:08" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:47:10" , 
"departure_time" : "19:48:12" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:49:02" , 
"departure_time" : "19:50:42" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:51:40" , 
"departure_time" : "19:52:45" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:53:05" , 
"departure_time" : "19:53:55" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:54:50" , 
"departure_time" : "19:56:30" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:58:40" , 
"departure_time" : "19:58:43" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "20:03:03" , 
"departure_time" : "20:03:44" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "20:05:41" , 
"departure_time" : "20:06:43" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "20:09:02" , 
"departure_time" : "20:10:41" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "20:12:39" , 
"departure_time" : "20:12:54" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "20:13:15" , 
"departure_time" : "20:13:58" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "20:15:43" , 
"departure_time" : "20:15:43" , 
"distance_traveled" : 10.0595
} ], 
"968" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "19:56:00" , 
"departure_time" : "19:57:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "19:57:55" , 
"departure_time" : "19:58:26" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "19:59:31" , 
"departure_time" : "20:00:36" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:03:05" , 
"departure_time" : "20:04:30" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:06:25" , 
"departure_time" : "20:06:47" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:06:22" , 
"departure_time" : "20:07:20" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:08:58" , 
"departure_time" : "20:10:21" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:11:23" , 
"departure_time" : "20:12:28" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:13:05" , 
"departure_time" : "20:13:32" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:14:27" , 
"departure_time" : "20:15:04" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:17:37" , 
"departure_time" : "20:19:00" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "20:24:23" , 
"departure_time" : "20:25:35" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "20:26:12" , 
"departure_time" : "20:26:55" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "20:28:43" , 
"departure_time" : "20:29:29" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "20:31:46" , 
"departure_time" : "20:33:08" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "20:34:22" , 
"departure_time" : "20:35:33" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "20:36:11" , 
"departure_time" : "20:36:11" , 
"distance_traveled" : 10.0595
} ], 
"969" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "20:26:00" , 
"departure_time" : "20:28:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "20:27:53" , 
"departure_time" : "20:29:01" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "20:30:08" , 
"departure_time" : "20:31:22" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:33:14" , 
"departure_time" : "20:34:06" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:35:52" , 
"departure_time" : "20:37:10" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:37:18" , 
"departure_time" : "20:38:33" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:39:15" , 
"departure_time" : "20:39:37" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:40:22" , 
"departure_time" : "20:40:45" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:42:23" , 
"departure_time" : "20:42:59" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:44:36" , 
"departure_time" : "20:44:53" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:47:17" , 
"departure_time" : "20:47:21" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "20:53:04" , 
"departure_time" : "20:53:39" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "20:55:35" , 
"departure_time" : "20:56:21" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "20:58:46" , 
"departure_time" : "20:59:46" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "21:02:00" , 
"departure_time" : "21:02:11" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "21:03:11" , 
"departure_time" : "21:04:01" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "21:05:50" , 
"departure_time" : "21:05:50" , 
"distance_traveled" : 10.0595
} ], 
"970" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "20:56:00" , 
"departure_time" : "20:58:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "20:58:21" , 
"departure_time" : "21:00:00" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "21:00:39" , 
"departure_time" : "21:01:38" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:02:59" , 
"departure_time" : "21:04:06" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "21:06:07" , 
"departure_time" : "21:06:39" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "21:06:32" , 
"departure_time" : "21:07:52" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:09:20" , 
"departure_time" : "21:10:18" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "21:10:58" , 
"departure_time" : "21:12:18" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:13:20" , 
"departure_time" : "21:14:24" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:15:04" , 
"departure_time" : "21:15:48" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:17:44" , 
"departure_time" : "21:19:01" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "21:24:17" , 
"departure_time" : "21:25:22" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "21:26:05" , 
"departure_time" : "21:26:40" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "21:28:35" , 
"departure_time" : "21:29:33" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "21:31:58" , 
"departure_time" : "21:32:42" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "21:33:44" , 
"departure_time" : "21:33:58" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "21:35:14" , 
"departure_time" : "21:35:14" , 
"distance_traveled" : 10.0595
} ], 
"971" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "21:26:00" , 
"departure_time" : "21:26:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "21:27:44" , 
"departure_time" : "21:27:59" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "21:29:15" , 
"departure_time" : "21:29:56" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:32:41" , 
"departure_time" : "21:32:44" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "21:35:03" , 
"departure_time" : "21:36:29" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "21:37:26" , 
"departure_time" : "21:38:05" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:38:39" , 
"departure_time" : "21:39:32" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "21:40:53" , 
"departure_time" : "21:42:22" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:43:29" , 
"departure_time" : "21:43:39" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:44:10" , 
"departure_time" : "21:44:44" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:47:34" , 
"departure_time" : "21:48:00" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "21:53:26" , 
"departure_time" : "21:54:40" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "21:56:14" , 
"departure_time" : "21:57:35" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "21:59:21" , 
"departure_time" : "22:00:46" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "22:02:25" , 
"departure_time" : "22:02:30" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "22:03:05" , 
"departure_time" : "22:03:07" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "22:05:02" , 
"departure_time" : "22:05:02" , 
"distance_traveled" : 10.0595
} ], 
"972" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "21:56:00" , 
"departure_time" : "21:56:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "21:57:54" , 
"departure_time" : "21:58:40" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "21:59:46" , 
"departure_time" : "22:00:32" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:02:46" , 
"departure_time" : "22:03:11" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:05:25" , 
"departure_time" : "22:05:52" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:06:27" , 
"departure_time" : "22:06:56" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:08:29" , 
"departure_time" : "22:09:59" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:11:30" , 
"departure_time" : "22:11:38" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:12:08" , 
"departure_time" : "22:13:38" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:15:30" , 
"departure_time" : "22:17:03" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:18:33" , 
"departure_time" : "22:19:06" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "22:23:33" , 
"departure_time" : "22:24:12" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "22:25:39" , 
"departure_time" : "22:25:52" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "22:28:13" , 
"departure_time" : "22:29:21" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "22:32:08" , 
"departure_time" : "22:32:14" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "22:33:06" , 
"departure_time" : "22:34:39" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "22:36:33" , 
"departure_time" : "22:36:33" , 
"distance_traveled" : 10.0595
} ], 
"973" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "22:26:00" , 
"departure_time" : "22:29:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "22:28:28" , 
"departure_time" : "22:30:08" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "22:30:40" , 
"departure_time" : "22:31:38" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:32:58" , 
"departure_time" : "22:33:27" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:35:29" , 
"departure_time" : "22:35:39" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:36:10" , 
"departure_time" : "22:37:05" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:38:55" , 
"departure_time" : "22:40:32" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:41:37" , 
"departure_time" : "22:42:40" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:43:03" , 
"departure_time" : "22:44:40" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:45:37" , 
"departure_time" : "22:45:44" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:47:07" , 
"departure_time" : "22:47:55" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "22:53:48" , 
"departure_time" : "22:55:01" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "22:56:13" , 
"departure_time" : "22:57:45" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "22:59:32" , 
"departure_time" : "23:00:15" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "23:01:43" , 
"departure_time" : "23:02:22" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "23:03:39" , 
"departure_time" : "23:03:57" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "23:05:18" , 
"departure_time" : "23:05:18" , 
"distance_traveled" : 10.0595
} ], 
"974" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "22:56:00" , 
"departure_time" : "22:57:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "22:58:27" , 
"departure_time" : "22:59:48" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "23:00:21" , 
"departure_time" : "23:01:16" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:02:55" , 
"departure_time" : "23:03:37" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:05:42" , 
"departure_time" : "23:06:40" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "23:06:58" , 
"departure_time" : "23:07:00" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:08:02" , 
"departure_time" : "23:08:42" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:10:40" , 
"departure_time" : "23:11:17" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:12:37" , 
"departure_time" : "23:13:25" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:14:48" , 
"departure_time" : "23:15:18" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:17:30" , 
"departure_time" : "23:18:10" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "23:23:40" , 
"departure_time" : "23:25:08" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "23:26:28" , 
"departure_time" : "23:26:31" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "23:28:03" , 
"departure_time" : "23:29:38" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "23:32:35" , 
"departure_time" : "23:33:14" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "23:33:39" , 
"departure_time" : "23:33:57" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "23:35:18" , 
"departure_time" : "23:35:18" , 
"distance_traveled" : 10.0595
} ], 
"975" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "23:26:00" , 
"departure_time" : "23:27:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "23:27:49" , 
"departure_time" : "23:28:46" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "23:29:57" , 
"departure_time" : "23:31:24" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:33:27" , 
"departure_time" : "23:33:37" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:35:10" , 
"departure_time" : "23:35:53" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "23:36:43" , 
"departure_time" : "23:37:03" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:38:20" , 
"departure_time" : "23:38:36" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:40:16" , 
"departure_time" : "23:41:04" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:42:48" , 
"departure_time" : "23:43:36" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:44:48" , 
"departure_time" : "23:45:24" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:47:36" , 
"departure_time" : "23:47:50" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "23:53:14" , 
"departure_time" : "23:53:33" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "23:55:19" , 
"departure_time" : "23:56:41" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "23:59:22" , 
"departure_time" : "24:01:02" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "24:02:40" , 
"departure_time" : "24:03:55" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "24:04:15" , 
"departure_time" : "24:05:26" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "24:06:11" , 
"departure_time" : "24:06:11" , 
"distance_traveled" : 10.0595
} ], 
"976" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "23:56:00" , 
"departure_time" : "23:57:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "23:57:12" , 
"departure_time" : "23:58:02" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "23:59:50" , 
"departure_time" : "24:00:28" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "24:02:38" , 
"departure_time" : "24:02:59" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "24:05:21" , 
"departure_time" : "24:06:16" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "24:06:55" , 
"departure_time" : "24:07:02" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "24:08:07" , 
"departure_time" : "24:08:26" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "24:10:19" , 
"departure_time" : "24:11:13" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "24:12:54" , 
"departure_time" : "24:14:33" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "24:15:39" , 
"departure_time" : "24:16:06" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "24:17:27" , 
"departure_time" : "24:18:40" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "24:24:13" , 
"departure_time" : "24:24:30" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "24:25:17" , 
"departure_time" : "24:26:07" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "24:28:50" , 
"departure_time" : "24:30:22" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "24:32:32" , 
"departure_time" : "24:32:56" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "24:33:24" , 
"departure_time" : "24:33:59" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "24:35:35" , 
"departure_time" : "24:35:35" , 
"distance_traveled" : 10.0595
} ], 
"977" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "24:26:00" , 
"departure_time" : "24:26:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "24:27:04" , 
"departure_time" : "24:27:06" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "24:29:02" , 
"departure_time" : "24:30:24" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "24:33:22" , 
"departure_time" : "24:34:39" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "24:36:17" , 
"departure_time" : "24:37:19" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "24:37:02" , 
"departure_time" : "24:37:33" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "24:38:31" , 
"departure_time" : "24:39:07" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "24:40:36" , 
"departure_time" : "24:41:14" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "24:42:38" , 
"departure_time" : "24:42:49" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "24:44:11" , 
"departure_time" : "24:45:41" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "24:48:30" , 
"departure_time" : "24:48:54" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "24:53:24" , 
"departure_time" : "24:54:52" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "24:56:28" , 
"departure_time" : "24:57:20" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "24:58:52" , 
"departure_time" : "24:59:56" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "25:02:04" , 
"departure_time" : "25:03:09" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "25:04:05" , 
"departure_time" : "25:04:10" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "25:05:05" , 
"departure_time" : "25:05:05" , 
"distance_traveled" : 10.0595
} ], 
"978" :  [ 
{ 
"stop_id" : 37001,
"arrival_time" : "24:56:00" , 
"departure_time" : "24:57:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "24:58:02" , 
"departure_time" : "24:59:13" , 
"distance_traveled" : 0.5682
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "25:00:11" , 
"departure_time" : "25:00:30" , 
"distance_traveled" : 0.9097
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "25:02:19" , 
"departure_time" : "25:03:15" , 
"distance_traveled" : 1.7828
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "25:05:56" , 
"departure_time" : "25:07:27" , 
"distance_traveled" : 2.464
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "25:07:31" , 
"departure_time" : "25:08:38" , 
"distance_traveled" : 2.7415
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "25:09:07" , 
"departure_time" : "25:09:37" , 
"distance_traveled" : 3.1492
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "25:10:30" , 
"departure_time" : "25:10:49" , 
"distance_traveled" : 3.4438
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "25:12:19" , 
"departure_time" : "25:12:39" , 
"distance_traveled" : 3.6928
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "25:14:20" , 
"departure_time" : "25:15:47" , 
"distance_traveled" : 4.0398
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "25:18:27" , 
"departure_time" : "25:19:06" , 
"distance_traveled" : 4.3328
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "25:23:39" , 
"departure_time" : "25:24:35" , 
"distance_traveled" : 5.7733
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "25:25:56" , 
"departure_time" : "25:26:31" , 
"distance_traveled" : 6.3244
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "25:28:35" , 
"departure_time" : "25:28:41" , 
"distance_traveled" : 7.6066
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "25:31:06" , 
"departure_time" : "25:32:00" , 
"distance_traveled" : 8.767
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "25:33:54" , 
"departure_time" : "25:35:26" , 
"distance_traveled" : 9.4648
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "25:36:32" , 
"departure_time" : "25:36:32" , 
"distance_traveled" : 10.0595
} ], 
"979" :  [ 
{ 
"stop_id" : 36998,
"arrival_time" : "04:37:00" , 
"departure_time" : "04:39:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "04:41:14" , 
"departure_time" : "04:41:36" , 
"distance_traveled" : 0.6824
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "04:41:22" , 
"departure_time" : "04:42:32" , 
"distance_traveled" : 0.9598
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "04:44:10" , 
"departure_time" : "04:44:57" , 
"distance_traveled" : 1.3676
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "04:45:47" , 
"departure_time" : "04:47:03" , 
"distance_traveled" : 1.6621
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "04:48:16" , 
"departure_time" : "04:49:56" , 
"distance_traveled" : 1.9112
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "04:50:40" , 
"departure_time" : "04:50:50" , 
"distance_traveled" : 2.2581
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "04:52:10" , 
"departure_time" : "04:52:36" , 
"distance_traveled" : 2.5511
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "04:57:26" , 
"departure_time" : "04:57:26" , 
"distance_traveled" : 3.4288
} ], 
"980" :  [ 
{ 
"stop_id" : 36998,
"arrival_time" : "04:42:00" , 
"departure_time" : "04:42:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "04:45:16" , 
"departure_time" : "04:46:49" , 
"distance_traveled" : 0.6824
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "04:47:33" , 
"departure_time" : "04:48:23" , 
"distance_traveled" : 0.9598
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "04:48:50" , 
"departure_time" : "04:49:55" , 
"distance_traveled" : 1.3676
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "04:51:05" , 
"departure_time" : "04:51:12" , 
"distance_traveled" : 1.6621
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "04:52:07" , 
"departure_time" : "04:53:17" , 
"distance_traveled" : 1.9112
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "04:55:10" , 
"departure_time" : "04:56:44" , 
"distance_traveled" : 2.2581
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "04:58:34" , 
"departure_time" : "04:58:51" , 
"distance_traveled" : 2.5511
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "05:02:17" , 
"departure_time" : "05:02:17" , 
"distance_traveled" : 3.4288
} ], 
"981" :  [ 
{ 
"stop_id" : 36998,
"arrival_time" : "04:57:00" , 
"departure_time" : "04:57:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "05:00:39" , 
"departure_time" : "05:02:09" , 
"distance_traveled" : 0.6824
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "05:02:30" , 
"departure_time" : "05:03:31" , 
"distance_traveled" : 0.9598
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "05:04:01" , 
"departure_time" : "05:05:27" , 
"distance_traveled" : 1.3676
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "05:06:26" , 
"departure_time" : "05:06:58" , 
"distance_traveled" : 1.6621
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "05:07:32" , 
"departure_time" : "05:08:51" , 
"distance_traveled" : 1.9112
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "05:10:19" , 
"departure_time" : "05:11:28" , 
"distance_traveled" : 2.2581
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "05:13:09" , 
"departure_time" : "05:13:40" , 
"distance_traveled" : 2.5511
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "05:17:31" , 
"departure_time" : "05:17:31" , 
"distance_traveled" : 3.4288
} ], 
"982" :  [ 
{ 
"stop_id" : 36998,
"arrival_time" : "05:08:00" , 
"departure_time" : "05:10:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "05:12:33" , 
"departure_time" : "05:13:51" , 
"distance_traveled" : 0.6824
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "05:13:18" , 
"departure_time" : "05:13:48" , 
"distance_traveled" : 0.9598
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "05:14:30" , 
"departure_time" : "05:15:50" , 
"distance_traveled" : 1.3676
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "05:17:20" , 
"departure_time" : "05:18:51" , 
"distance_traveled" : 1.6621
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "05:19:31" , 
"departure_time" : "05:20:06" , 
"distance_traveled" : 1.9112
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "05:20:35" , 
"departure_time" : "05:22:11" , 
"distance_traveled" : 2.2581
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "05:24:36" , 
"departure_time" : "05:25:11" , 
"distance_traveled" : 2.5511
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "05:28:35" , 
"departure_time" : "05:28:35" , 
"distance_traveled" : 3.4288
} ], 
"983" :  [ 
{ 
"stop_id" : 36998,
"arrival_time" : "15:36:00" , 
"departure_time" : "15:37:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:40:11" , 
"departure_time" : "15:40:52" , 
"distance_traveled" : 0.6824
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:40:41" , 
"departure_time" : "15:42:01" , 
"distance_traveled" : 0.9598
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:43:20" , 
"departure_time" : "15:44:29" , 
"distance_traveled" : 1.3676
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:45:09" , 
"departure_time" : "15:46:33" , 
"distance_traveled" : 1.6621
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:47:24" , 
"departure_time" : "15:48:50" , 
"distance_traveled" : 1.9112
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:49:26" , 
"departure_time" : "15:50:08" , 
"distance_traveled" : 2.2581
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:51:42" , 
"departure_time" : "15:51:58" , 
"distance_traveled" : 2.5511
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "15:56:16" , 
"departure_time" : "15:56:16" , 
"distance_traveled" : 3.4288
} ], 
"984" :  [ 
{ 
"stop_id" : 36998,
"arrival_time" : "16:13:00" , 
"departure_time" : "16:13:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:16:28" , 
"departure_time" : "16:17:09" , 
"distance_traveled" : 0.6824
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:17:41" , 
"departure_time" : "16:19:16" , 
"distance_traveled" : 0.9598
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:20:35" , 
"departure_time" : "16:20:52" , 
"distance_traveled" : 1.3676
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:21:17" , 
"departure_time" : "16:21:59" , 
"distance_traveled" : 1.6621
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:23:42" , 
"departure_time" : "16:24:50" , 
"distance_traveled" : 1.9112
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:26:08" , 
"departure_time" : "16:26:50" , 
"distance_traveled" : 2.2581
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:28:42" , 
"departure_time" : "16:30:15" , 
"distance_traveled" : 2.5511
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "16:34:33" , 
"departure_time" : "16:34:33" , 
"distance_traveled" : 3.4288
} ], 
"985" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "05:09:00" , 
"departure_time" : "05:10:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "05:13:17" , 
"departure_time" : "05:14:36" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "05:16:19" , 
"departure_time" : "05:17:37" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "05:19:18" , 
"departure_time" : "05:20:07" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "05:21:49" , 
"departure_time" : "05:21:52" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "05:23:03" , 
"departure_time" : "05:23:24" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "05:25:21" , 
"departure_time" : "05:25:21" , 
"distance_traveled" : 5.6273
} ], 
"986" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "05:23:00" , 
"departure_time" : "05:23:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "05:27:06" , 
"departure_time" : "05:27:56" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "05:29:50" , 
"departure_time" : "05:30:59" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "05:33:09" , 
"departure_time" : "05:33:19" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "05:35:10" , 
"departure_time" : "05:35:28" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "05:37:18" , 
"departure_time" : "05:38:28" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "05:40:10" , 
"departure_time" : "05:40:10" , 
"distance_traveled" : 5.6273
} ], 
"987" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "05:37:00" , 
"departure_time" : "05:38:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "05:41:13" , 
"departure_time" : "05:41:17" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "05:43:04" , 
"departure_time" : "05:44:39" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "05:47:35" , 
"departure_time" : "05:48:43" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "05:50:08" , 
"departure_time" : "05:51:30" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "05:52:22" , 
"departure_time" : "05:53:08" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "05:53:46" , 
"departure_time" : "05:53:46" , 
"distance_traveled" : 5.6273
} ], 
"988" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "05:50:00" , 
"departure_time" : "05:52:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "05:55:34" , 
"departure_time" : "05:57:14" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "05:57:40" , 
"departure_time" : "05:57:54" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "05:59:14" , 
"departure_time" : "05:59:30" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "06:02:16" , 
"departure_time" : "06:02:40" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "06:04:24" , 
"departure_time" : "06:04:26" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "06:06:02" , 
"departure_time" : "06:06:02" , 
"distance_traveled" : 5.6273
} ], 
"989" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "06:03:00" , 
"departure_time" : "06:03:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "06:07:29" , 
"departure_time" : "06:07:36" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "06:09:07" , 
"departure_time" : "06:10:05" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "06:12:58" , 
"departure_time" : "06:13:42" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "06:15:44" , 
"departure_time" : "06:17:04" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "06:18:20" , 
"departure_time" : "06:19:34" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "06:20:14" , 
"departure_time" : "06:20:14" , 
"distance_traveled" : 5.6273
} ], 
"990" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "06:18:00" , 
"departure_time" : "06:20:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "06:23:18" , 
"departure_time" : "06:24:52" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "06:25:34" , 
"departure_time" : "06:26:52" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "06:28:18" , 
"departure_time" : "06:28:31" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "06:30:13" , 
"departure_time" : "06:30:18" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "06:32:05" , 
"departure_time" : "06:32:59" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "06:34:54" , 
"departure_time" : "06:34:54" , 
"distance_traveled" : 5.6273
} ], 
"991" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "06:32:00" , 
"departure_time" : "06:34:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "06:37:34" , 
"departure_time" : "06:37:52" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "06:38:18" , 
"departure_time" : "06:39:31" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "06:42:13" , 
"departure_time" : "06:43:51" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "06:45:38" , 
"departure_time" : "06:45:56" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "06:46:18" , 
"departure_time" : "06:46:42" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "06:48:24" , 
"departure_time" : "06:48:24" , 
"distance_traveled" : 5.6273
} ], 
"992" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "06:44:00" , 
"departure_time" : "06:45:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "06:49:04" , 
"departure_time" : "06:49:25" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "06:50:21" , 
"departure_time" : "06:51:12" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "06:53:51" , 
"departure_time" : "06:55:27" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "06:57:36" , 
"departure_time" : "06:58:07" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "06:58:31" , 
"departure_time" : "06:59:10" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "07:00:39" , 
"departure_time" : "07:00:39" , 
"distance_traveled" : 5.6273
} ], 
"993" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "06:58:00" , 
"departure_time" : "06:58:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:02:18" , 
"departure_time" : "07:02:32" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "07:04:14" , 
"departure_time" : "07:04:51" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "07:07:37" , 
"departure_time" : "07:07:57" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "07:10:20" , 
"departure_time" : "07:11:34" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:13:14" , 
"departure_time" : "07:13:56" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "07:14:42" , 
"departure_time" : "07:14:42" , 
"distance_traveled" : 5.6273
} ], 
"994" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "07:14:00" , 
"departure_time" : "07:15:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:18:46" , 
"departure_time" : "07:19:41" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "07:20:55" , 
"departure_time" : "07:22:26" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "07:24:31" , 
"departure_time" : "07:24:37" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "07:26:06" , 
"departure_time" : "07:26:32" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:28:26" , 
"departure_time" : "07:29:12" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "07:30:46" , 
"departure_time" : "07:30:46" , 
"distance_traveled" : 5.6273
} ], 
"995" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "07:27:00" , 
"departure_time" : "07:28:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:31:30" , 
"departure_time" : "07:32:25" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "07:33:55" , 
"departure_time" : "07:34:35" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "07:36:40" , 
"departure_time" : "07:37:37" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "07:39:57" , 
"departure_time" : "07:41:37" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:42:40" , 
"departure_time" : "07:43:20" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "07:43:40" , 
"departure_time" : "07:43:40" , 
"distance_traveled" : 5.6273
} ], 
"996" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "07:43:00" , 
"departure_time" : "07:44:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:47:58" , 
"departure_time" : "07:48:37" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "07:49:39" , 
"departure_time" : "07:49:53" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "07:52:14" , 
"departure_time" : "07:52:52" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "07:55:38" , 
"departure_time" : "07:56:18" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:57:40" , 
"departure_time" : "07:58:44" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "08:00:04" , 
"departure_time" : "08:00:04" , 
"distance_traveled" : 5.6273
} ], 
"997" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "07:56:00" , 
"departure_time" : "07:57:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:00:20" , 
"departure_time" : "08:01:10" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:02:50" , 
"departure_time" : "08:03:30" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:05:40" , 
"departure_time" : "08:06:56" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:09:16" , 
"departure_time" : "08:10:25" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:11:09" , 
"departure_time" : "08:12:44" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "08:13:35" , 
"departure_time" : "08:13:35" , 
"distance_traveled" : 5.6273
} ], 
"998" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "08:13:00" , 
"departure_time" : "08:15:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:18:18" , 
"departure_time" : "08:18:40" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:19:22" , 
"departure_time" : "08:19:24" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:22:02" , 
"departure_time" : "08:22:59" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:25:57" , 
"departure_time" : "08:27:09" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:28:12" , 
"departure_time" : "08:28:53" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "08:29:41" , 
"departure_time" : "08:29:41" , 
"distance_traveled" : 5.6273
} ], 
"999" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "08:26:00" , 
"departure_time" : "08:27:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:30:30" , 
"departure_time" : "08:31:26" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:32:56" , 
"departure_time" : "08:33:52" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:35:56" , 
"departure_time" : "08:36:53" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:38:57" , 
"departure_time" : "08:39:56" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:40:59" , 
"departure_time" : "08:41:44" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "08:42:45" , 
"departure_time" : "08:42:45" , 
"distance_traveled" : 5.6273
} ], 
"1000" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "08:43:00" , 
"departure_time" : "08:44:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:47:40" , 
"departure_time" : "08:48:13" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:49:33" , 
"departure_time" : "08:50:20" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:52:47" , 
"departure_time" : "08:52:51" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:55:04" , 
"departure_time" : "08:55:07" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:57:03" , 
"departure_time" : "08:57:31" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "08:59:28" , 
"departure_time" : "08:59:28" , 
"distance_traveled" : 5.6273
} ], 
"1001" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "08:58:00" , 
"departure_time" : "08:59:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "09:02:34" , 
"departure_time" : "09:03:53" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:05:19" , 
"departure_time" : "09:05:28" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "09:07:09" , 
"departure_time" : "09:07:17" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "09:10:08" , 
"departure_time" : "09:11:24" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "09:13:16" , 
"departure_time" : "09:13:39" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "09:14:23" , 
"departure_time" : "09:14:23" , 
"distance_traveled" : 5.6273
} ], 
"1002" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "09:12:00" , 
"departure_time" : "09:12:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "09:16:04" , 
"departure_time" : "09:17:10" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:19:06" , 
"departure_time" : "09:20:07" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "09:22:01" , 
"departure_time" : "09:22:44" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "09:24:43" , 
"departure_time" : "09:26:10" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "09:27:27" , 
"departure_time" : "09:27:33" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "09:28:06" , 
"departure_time" : "09:28:06" , 
"distance_traveled" : 5.6273
} ], 
"1003" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "09:23:00" , 
"departure_time" : "09:24:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "09:28:24" , 
"departure_time" : "09:28:41" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:29:17" , 
"departure_time" : "09:30:20" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "09:33:03" , 
"departure_time" : "09:33:23" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "09:35:20" , 
"departure_time" : "09:36:38" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "09:38:18" , 
"departure_time" : "09:39:41" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "09:40:23" , 
"departure_time" : "09:40:23" , 
"distance_traveled" : 5.6273
} ], 
"1004" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "09:40:00" , 
"departure_time" : "09:42:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "09:45:05" , 
"departure_time" : "09:45:55" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:46:50" , 
"departure_time" : "09:47:52" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "09:50:02" , 
"departure_time" : "09:51:15" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "09:53:13" , 
"departure_time" : "09:54:44" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "09:55:31" , 
"departure_time" : "09:56:36" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "09:57:05" , 
"departure_time" : "09:57:05" , 
"distance_traveled" : 5.6273
} ], 
"1005" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "09:52:00" , 
"departure_time" : "09:54:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "09:57:32" , 
"departure_time" : "09:58:58" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:59:26" , 
"departure_time" : "09:59:58" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "10:01:32" , 
"departure_time" : "10:02:24" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "10:04:52" , 
"departure_time" : "10:06:24" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "10:07:32" , 
"departure_time" : "10:09:10" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "10:09:38" , 
"departure_time" : "10:09:38" , 
"distance_traveled" : 5.6273
} ], 
"1006" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "10:04:00" , 
"departure_time" : "10:06:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "10:08:57" , 
"departure_time" : "10:09:38" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "10:10:41" , 
"departure_time" : "10:10:44" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "10:13:03" , 
"departure_time" : "10:14:06" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "10:17:03" , 
"departure_time" : "10:18:33" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "10:19:30" , 
"departure_time" : "10:20:36" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "10:21:06" , 
"departure_time" : "10:21:06" , 
"distance_traveled" : 5.6273
} ], 
"1007" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "10:24:00" , 
"departure_time" : "10:25:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "10:28:30" , 
"departure_time" : "10:28:56" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "10:30:26" , 
"departure_time" : "10:30:44" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "10:33:18" , 
"departure_time" : "10:34:47" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "10:37:29" , 
"departure_time" : "10:39:09" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "10:39:40" , 
"departure_time" : "10:39:49" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "10:40:09" , 
"departure_time" : "10:40:09" , 
"distance_traveled" : 5.6273
} ], 
"1008" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "10:44:00" , 
"departure_time" : "10:45:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "10:49:25" , 
"departure_time" : "10:49:28" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "10:50:03" , 
"departure_time" : "10:50:07" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "10:53:04" , 
"departure_time" : "10:53:36" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "10:56:32" , 
"departure_time" : "10:58:09" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "10:59:37" , 
"departure_time" : "11:00:08" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "11:00:31" , 
"departure_time" : "11:00:31" , 
"distance_traveled" : 5.6273
} ], 
"1009" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "11:04:00" , 
"departure_time" : "11:05:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "11:08:58" , 
"departure_time" : "11:10:07" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "11:11:09" , 
"departure_time" : "11:11:32" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "11:13:23" , 
"departure_time" : "11:14:02" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "11:16:39" , 
"departure_time" : "11:16:48" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "11:18:09" , 
"departure_time" : "11:18:40" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "11:20:31" , 
"departure_time" : "11:20:31" , 
"distance_traveled" : 5.6273
} ], 
"1010" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "11:24:00" , 
"departure_time" : "11:25:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "11:28:58" , 
"departure_time" : "11:29:25" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "11:30:27" , 
"departure_time" : "11:31:35" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "11:34:08" , 
"departure_time" : "11:35:47" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "11:37:39" , 
"departure_time" : "11:38:56" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "11:39:17" , 
"departure_time" : "11:40:52" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "11:41:35" , 
"departure_time" : "11:41:35" , 
"distance_traveled" : 5.6273
} ], 
"1011" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "11:44:00" , 
"departure_time" : "11:46:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "11:48:57" , 
"departure_time" : "11:50:10" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "11:51:13" , 
"departure_time" : "11:51:56" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "11:53:43" , 
"departure_time" : "11:53:45" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "11:56:02" , 
"departure_time" : "11:56:55" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "11:58:53" , 
"departure_time" : "11:59:21" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "12:00:28" , 
"departure_time" : "12:00:28" , 
"distance_traveled" : 5.6273
} ], 
"1012" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "12:04:00" , 
"departure_time" : "12:04:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "12:08:09" , 
"departure_time" : "12:09:16" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "12:11:07" , 
"departure_time" : "12:11:24" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "12:13:17" , 
"departure_time" : "12:14:24" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "12:17:07" , 
"departure_time" : "12:18:04" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "12:18:57" , 
"departure_time" : "12:20:35" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "12:21:38" , 
"departure_time" : "12:21:38" , 
"distance_traveled" : 5.6273
} ], 
"1013" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "12:24:00" , 
"departure_time" : "12:25:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "12:28:01" , 
"departure_time" : "12:29:29" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "12:31:28" , 
"departure_time" : "12:31:49" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "12:33:21" , 
"departure_time" : "12:34:15" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "12:36:54" , 
"departure_time" : "12:37:48" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "12:38:54" , 
"departure_time" : "12:39:18" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "12:40:24" , 
"departure_time" : "12:40:24" , 
"distance_traveled" : 5.6273
} ], 
"1014" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "12:44:00" , 
"departure_time" : "12:45:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "12:49:16" , 
"departure_time" : "12:50:12" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "12:50:56" , 
"departure_time" : "12:50:58" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "12:53:02" , 
"departure_time" : "12:54:39" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "12:57:37" , 
"departure_time" : "12:57:58" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "12:58:21" , 
"departure_time" : "12:58:49" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "13:00:28" , 
"departure_time" : "13:00:28" , 
"distance_traveled" : 5.6273
} ], 
"1015" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "13:04:00" , 
"departure_time" : "13:04:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "13:08:19" , 
"departure_time" : "13:08:30" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "13:10:11" , 
"departure_time" : "13:11:22" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "13:14:11" , 
"departure_time" : "13:14:29" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "13:16:18" , 
"departure_time" : "13:17:15" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "13:18:57" , 
"departure_time" : "13:20:07" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "13:21:10" , 
"departure_time" : "13:21:10" , 
"distance_traveled" : 5.6273
} ], 
"1016" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "13:24:00" , 
"departure_time" : "13:26:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "13:29:22" , 
"departure_time" : "13:30:29" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "13:31:07" , 
"departure_time" : "13:31:15" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "13:33:08" , 
"departure_time" : "13:34:20" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "13:37:12" , 
"departure_time" : "13:38:14" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "13:39:02" , 
"departure_time" : "13:40:04" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "13:41:02" , 
"departure_time" : "13:41:02" , 
"distance_traveled" : 5.6273
} ], 
"1017" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "13:44:00" , 
"departure_time" : "13:45:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "13:48:08" , 
"departure_time" : "13:48:28" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "13:50:20" , 
"departure_time" : "13:50:59" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "13:53:39" , 
"departure_time" : "13:54:48" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "13:57:09" , 
"departure_time" : "13:57:48" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "13:58:39" , 
"departure_time" : "13:59:54" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "14:01:15" , 
"departure_time" : "14:01:15" , 
"distance_traveled" : 5.6273
} ], 
"1018" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "14:04:00" , 
"departure_time" : "14:05:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "14:08:21" , 
"departure_time" : "14:09:55" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "14:11:34" , 
"departure_time" : "14:11:47" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "14:13:13" , 
"departure_time" : "14:13:51" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "14:16:38" , 
"departure_time" : "14:17:53" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "14:19:15" , 
"departure_time" : "14:20:00" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "14:20:45" , 
"departure_time" : "14:20:45" , 
"distance_traveled" : 5.6273
} ], 
"1019" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "14:24:00" , 
"departure_time" : "14:26:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "14:29:19" , 
"departure_time" : "14:30:20" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "14:31:01" , 
"departure_time" : "14:32:39" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "14:34:38" , 
"departure_time" : "14:35:07" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "14:36:29" , 
"departure_time" : "14:36:59" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "14:38:30" , 
"departure_time" : "14:38:59" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "14:40:29" , 
"departure_time" : "14:40:29" , 
"distance_traveled" : 5.6273
} ], 
"1020" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "14:44:00" , 
"departure_time" : "14:45:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "14:49:24" , 
"departure_time" : "14:51:04" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "14:51:40" , 
"departure_time" : "14:53:07" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "14:54:27" , 
"departure_time" : "14:55:22" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "14:56:55" , 
"departure_time" : "14:58:24" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "14:59:29" , 
"departure_time" : "15:00:42" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "15:01:13" , 
"departure_time" : "15:01:13" , 
"distance_traveled" : 5.6273
} ], 
"1021" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "15:04:00" , 
"departure_time" : "15:05:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "15:08:35" , 
"departure_time" : "15:09:21" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "15:10:46" , 
"departure_time" : "15:12:06" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "15:14:20" , 
"departure_time" : "15:15:58" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "15:17:38" , 
"departure_time" : "15:18:55" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "15:19:17" , 
"departure_time" : "15:20:57" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "15:21:40" , 
"departure_time" : "15:21:40" , 
"distance_traveled" : 5.6273
} ], 
"1022" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "15:19:00" , 
"departure_time" : "15:20:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "15:23:13" , 
"departure_time" : "15:23:45" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "15:25:32" , 
"departure_time" : "15:26:36" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "15:29:04" , 
"departure_time" : "15:30:22" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "15:32:18" , 
"departure_time" : "15:32:47" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "15:33:29" , 
"departure_time" : "15:33:50" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "15:35:21" , 
"departure_time" : "15:35:21" , 
"distance_traveled" : 5.6273
} ], 
"1023" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "15:32:00" , 
"departure_time" : "15:33:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "15:37:24" , 
"departure_time" : "15:38:45" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "15:39:21" , 
"departure_time" : "15:39:39" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "15:41:18" , 
"departure_time" : "15:41:59" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "15:44:41" , 
"departure_time" : "15:45:59" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "15:47:18" , 
"departure_time" : "15:48:57" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "15:49:39" , 
"departure_time" : "15:49:39" , 
"distance_traveled" : 5.6273
} ], 
"1024" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "15:46:00" , 
"departure_time" : "15:48:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "15:50:43" , 
"departure_time" : "15:52:20" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "15:53:37" , 
"departure_time" : "15:54:25" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "15:55:48" , 
"departure_time" : "15:55:53" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "15:58:05" , 
"departure_time" : "15:58:55" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:00:50" , 
"departure_time" : "16:01:35" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "16:02:45" , 
"departure_time" : "16:02:45" , 
"distance_traveled" : 5.6273
} ], 
"1025" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "16:04:00" , 
"departure_time" : "16:05:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:09:03" , 
"departure_time" : "16:09:53" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:10:50" , 
"departure_time" : "16:11:20" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:13:30" , 
"departure_time" : "16:14:12" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "16:16:42" , 
"departure_time" : "16:18:10" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:19:28" , 
"departure_time" : "16:20:04" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "16:20:36" , 
"departure_time" : "16:20:36" , 
"distance_traveled" : 5.6273
} ], 
"1026" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "16:14:00" , 
"departure_time" : "16:15:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:19:13" , 
"departure_time" : "16:19:24" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:20:11" , 
"departure_time" : "16:21:17" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:24:06" , 
"departure_time" : "16:25:44" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "16:27:38" , 
"departure_time" : "16:27:57" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:28:19" , 
"departure_time" : "16:28:46" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "16:30:27" , 
"departure_time" : "16:30:27" , 
"distance_traveled" : 5.6273
} ], 
"1027" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "16:29:00" , 
"departure_time" : "16:30:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:33:40" , 
"departure_time" : "16:35:09" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:36:29" , 
"departure_time" : "16:37:53" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:39:24" , 
"departure_time" : "16:40:10" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "16:41:46" , 
"departure_time" : "16:42:04" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:43:18" , 
"departure_time" : "16:43:32" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "16:45:14" , 
"departure_time" : "16:45:14" , 
"distance_traveled" : 5.6273
} ], 
"1028" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "16:45:00" , 
"departure_time" : "16:45:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:49:06" , 
"departure_time" : "16:49:47" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:51:41" , 
"departure_time" : "16:52:07" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:54:26" , 
"departure_time" : "16:54:33" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "16:57:07" , 
"departure_time" : "16:57:56" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:59:49" , 
"departure_time" : "17:00:22" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "17:01:33" , 
"departure_time" : "17:01:33" , 
"distance_traveled" : 5.6273
} ], 
"1029" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "17:01:00" , 
"departure_time" : "17:02:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:06:06" , 
"departure_time" : "17:07:34" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "17:08:28" , 
"departure_time" : "17:09:44" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:11:16" , 
"departure_time" : "17:11:32" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:13:16" , 
"departure_time" : "17:14:14" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:15:58" , 
"departure_time" : "17:16:50" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "17:17:52" , 
"departure_time" : "17:17:52" , 
"distance_traveled" : 5.6273
} ], 
"1030" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "17:14:00" , 
"departure_time" : "17:15:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:18:57" , 
"departure_time" : "17:19:15" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "17:20:18" , 
"departure_time" : "17:20:58" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:23:40" , 
"departure_time" : "17:24:09" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:26:29" , 
"departure_time" : "17:27:07" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:28:38" , 
"departure_time" : "17:29:20" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "17:30:42" , 
"departure_time" : "17:30:42" , 
"distance_traveled" : 5.6273
} ], 
"1031" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "17:27:00" , 
"departure_time" : "17:27:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:31:04" , 
"departure_time" : "17:31:45" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "17:33:41" , 
"departure_time" : "17:35:03" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:37:22" , 
"departure_time" : "17:37:46" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:39:24" , 
"departure_time" : "17:39:58" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:41:34" , 
"departure_time" : "17:42:59" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "17:44:25" , 
"departure_time" : "17:44:25" , 
"distance_traveled" : 5.6273
} ], 
"1032" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "17:44:00" , 
"departure_time" : "17:46:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:49:20" , 
"departure_time" : "17:50:13" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "17:50:53" , 
"departure_time" : "17:52:06" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:54:13" , 
"departure_time" : "17:55:37" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:57:24" , 
"departure_time" : "17:57:37" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:58:13" , 
"departure_time" : "17:59:14" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "18:01:01" , 
"departure_time" : "18:01:01" , 
"distance_traveled" : 5.6273
} ], 
"1033" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "17:59:00" , 
"departure_time" : "18:00:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:03:52" , 
"departure_time" : "18:05:02" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:06:10" , 
"departure_time" : "18:06:55" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:08:45" , 
"departure_time" : "18:10:09" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:12:24" , 
"departure_time" : "18:13:58" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:14:34" , 
"departure_time" : "18:15:22" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "18:15:48" , 
"departure_time" : "18:15:48" , 
"distance_traveled" : 5.6273
} ], 
"1034" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "18:15:00" , 
"departure_time" : "18:17:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:20:25" , 
"departure_time" : "18:21:42" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:22:17" , 
"departure_time" : "18:22:47" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:24:30" , 
"departure_time" : "18:25:27" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:27:57" , 
"departure_time" : "18:28:04" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:29:07" , 
"departure_time" : "18:29:37" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "18:31:30" , 
"departure_time" : "18:31:30" , 
"distance_traveled" : 5.6273
} ], 
"1035" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "18:32:00" , 
"departure_time" : "18:32:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:36:28" , 
"departure_time" : "18:37:49" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:39:21" , 
"departure_time" : "18:39:23" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:41:02" , 
"departure_time" : "18:41:07" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:44:05" , 
"departure_time" : "18:45:20" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:47:15" , 
"departure_time" : "18:48:00" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "18:48:45" , 
"departure_time" : "18:48:45" , 
"distance_traveled" : 5.6273
} ], 
"1036" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "18:45:00" , 
"departure_time" : "18:46:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:49:25" , 
"departure_time" : "18:50:40" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:52:15" , 
"departure_time" : "18:52:32" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:54:17" , 
"departure_time" : "18:54:41" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:57:24" , 
"departure_time" : "18:58:10" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:59:46" , 
"departure_time" : "19:01:20" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "19:02:34" , 
"departure_time" : "19:02:34" , 
"distance_traveled" : 5.6273
} ], 
"1037" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "18:58:00" , 
"departure_time" : "18:59:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "19:02:18" , 
"departure_time" : "19:02:33" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "19:04:15" , 
"departure_time" : "19:04:29" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "19:07:14" , 
"departure_time" : "19:08:14" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "19:11:00" , 
"departure_time" : "19:12:37" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "19:13:37" , 
"departure_time" : "19:14:00" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "19:14:23" , 
"departure_time" : "19:14:23" , 
"distance_traveled" : 5.6273
} ], 
"1038" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "19:12:00" , 
"departure_time" : "19:14:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "19:17:40" , 
"departure_time" : "19:19:00" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "19:19:20" , 
"departure_time" : "19:20:36" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "19:22:16" , 
"departure_time" : "19:23:55" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "19:25:39" , 
"departure_time" : "19:26:52" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "19:27:13" , 
"departure_time" : "19:28:40" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "19:29:27" , 
"departure_time" : "19:29:27" , 
"distance_traveled" : 5.6273
} ], 
"1039" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "19:37:00" , 
"departure_time" : "19:38:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "19:41:01" , 
"departure_time" : "19:42:34" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "19:44:33" , 
"departure_time" : "19:45:39" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "19:47:06" , 
"departure_time" : "19:48:13" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "19:50:07" , 
"departure_time" : "19:50:54" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "19:51:47" , 
"departure_time" : "19:52:57" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "19:54:10" , 
"departure_time" : "19:54:10" , 
"distance_traveled" : 5.6273
} ], 
"1040" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "20:07:00" , 
"departure_time" : "20:08:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "20:11:33" , 
"departure_time" : "20:13:02" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "20:14:29" , 
"departure_time" : "20:15:58" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "20:17:29" , 
"departure_time" : "20:18:31" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "20:20:02" , 
"departure_time" : "20:21:17" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "20:22:15" , 
"departure_time" : "20:23:31" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "20:24:16" , 
"departure_time" : "20:24:16" , 
"distance_traveled" : 5.6273
} ], 
"1041" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "20:37:00" , 
"departure_time" : "20:38:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "20:41:14" , 
"departure_time" : "20:42:50" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "20:44:36" , 
"departure_time" : "20:45:26" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "20:46:50" , 
"departure_time" : "20:47:37" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "20:49:47" , 
"departure_time" : "20:49:49" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "20:51:02" , 
"departure_time" : "20:51:33" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "20:53:31" , 
"departure_time" : "20:53:31" , 
"distance_traveled" : 5.6273
} ], 
"1042" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "21:07:00" , 
"departure_time" : "21:07:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "21:11:04" , 
"departure_time" : "21:12:08" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "21:14:04" , 
"departure_time" : "21:14:54" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "21:16:50" , 
"departure_time" : "21:17:46" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "21:19:56" , 
"departure_time" : "21:20:13" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "21:21:17" , 
"departure_time" : "21:22:12" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "21:23:55" , 
"departure_time" : "21:23:55" , 
"distance_traveled" : 5.6273
} ], 
"1043" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "21:37:00" , 
"departure_time" : "21:38:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "21:41:58" , 
"departure_time" : "21:42:29" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "21:43:31" , 
"departure_time" : "21:45:00" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "21:47:29" , 
"departure_time" : "21:47:53" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "21:49:24" , 
"departure_time" : "21:49:45" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "21:51:21" , 
"departure_time" : "21:51:24" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "21:53:03" , 
"departure_time" : "21:53:03" , 
"distance_traveled" : 5.6273
} ], 
"1044" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "22:07:00" , 
"departure_time" : "22:07:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "22:11:48" , 
"departure_time" : "22:12:44" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "22:13:56" , 
"departure_time" : "22:13:59" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "22:16:03" , 
"departure_time" : "22:16:40" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "22:19:37" , 
"departure_time" : "22:20:20" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "22:21:43" , 
"departure_time" : "22:23:17" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "22:24:34" , 
"departure_time" : "22:24:34" , 
"distance_traveled" : 5.6273
} ], 
"1045" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "22:37:00" , 
"departure_time" : "22:39:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "22:42:21" , 
"departure_time" : "22:43:15" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "22:43:54" , 
"departure_time" : "22:44:04" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "22:46:10" , 
"departure_time" : "22:46:48" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "22:49:38" , 
"departure_time" : "22:50:48" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "22:52:10" , 
"departure_time" : "22:52:46" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "22:53:36" , 
"departure_time" : "22:53:36" , 
"distance_traveled" : 5.6273
} ], 
"1046" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "23:07:00" , 
"departure_time" : "23:08:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "23:11:48" , 
"departure_time" : "23:12:33" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "23:13:45" , 
"departure_time" : "23:15:22" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "23:17:37" , 
"departure_time" : "23:18:33" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "23:19:56" , 
"departure_time" : "23:20:29" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "23:21:33" , 
"departure_time" : "23:22:35" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "23:24:02" , 
"departure_time" : "23:24:02" , 
"distance_traveled" : 5.6273
} ], 
"1047" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "23:37:00" , 
"departure_time" : "23:38:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "23:41:03" , 
"departure_time" : "23:41:34" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "23:43:31" , 
"departure_time" : "23:44:48" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "23:47:17" , 
"departure_time" : "23:48:16" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "23:49:59" , 
"departure_time" : "23:51:03" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "23:52:04" , 
"departure_time" : "23:53:14" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "23:54:10" , 
"departure_time" : "23:54:10" , 
"distance_traveled" : 5.6273
} ], 
"1048" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "24:07:00" , 
"departure_time" : "24:09:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "24:12:27" , 
"departure_time" : "24:14:04" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "24:14:37" , 
"departure_time" : "24:16:11" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "24:17:34" , 
"departure_time" : "24:18:16" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "24:19:42" , 
"departure_time" : "24:20:55" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "24:22:13" , 
"departure_time" : "24:23:44" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "24:24:31" , 
"departure_time" : "24:24:31" , 
"distance_traveled" : 5.6273
} ], 
"1049" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "24:37:00" , 
"departure_time" : "24:39:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "24:41:55" , 
"departure_time" : "24:43:31" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "24:44:36" , 
"departure_time" : "24:44:43" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "24:46:07" , 
"departure_time" : "24:47:20" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "24:50:13" , 
"departure_time" : "24:50:47" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "24:51:34" , 
"departure_time" : "24:52:47" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "24:54:13" , 
"departure_time" : "24:54:13" , 
"distance_traveled" : 5.6273
} ], 
"1050" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "25:07:00" , 
"departure_time" : "25:08:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "25:11:12" , 
"departure_time" : "25:12:52" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "25:14:40" , 
"departure_time" : "25:16:10" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "25:17:30" , 
"departure_time" : "25:18:42" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "25:20:12" , 
"departure_time" : "25:21:03" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "25:21:51" , 
"departure_time" : "25:21:56" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "25:23:05" , 
"departure_time" : "25:23:05" , 
"distance_traveled" : 5.6273
} ], 
"1051" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "25:37:00" , 
"departure_time" : "25:37:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "25:41:07" , 
"departure_time" : "25:42:36" , 
"distance_traveled" : 1.3411
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "25:44:29" , 
"departure_time" : "25:44:45" , 
"distance_traveled" : 1.8922
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "25:46:16" , 
"departure_time" : "25:46:20" , 
"distance_traveled" : 3.1744
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "25:49:04" , 
"departure_time" : "25:50:27" , 
"distance_traveled" : 4.3348
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "25:52:23" , 
"departure_time" : "25:53:20" , 
"distance_traveled" : 5.0326
}, 
{ 
"stop_id" : 38579,
"arrival_time" : "25:53:57" , 
"departure_time" : "25:53:57" , 
"distance_traveled" : 5.6273
} ], 
"1052" :  [ 
{ 
"stop_id" : 38229,
"arrival_time" : "07:03:00" , 
"departure_time" : "07:04:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "07:05:14" , 
"departure_time" : "07:05:20" , 
"distance_traveled" : 0.8614
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "07:07:06" , 
"departure_time" : "07:08:27" , 
"distance_traveled" : 1.4237
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "07:10:21" , 
"departure_time" : "07:10:48" , 
"distance_traveled" : 2.6339
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "07:10:27" , 
"departure_time" : "07:11:44" , 
"distance_traveled" : 3.2818
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:14:17" , 
"departure_time" : "07:14:31" , 
"distance_traveled" : 4.7036
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:16:14" , 
"departure_time" : "07:16:38" , 
"distance_traveled" : 5.3848
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:17:24" , 
"departure_time" : "07:18:04" , 
"distance_traveled" : 5.6623
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:19:40" , 
"departure_time" : "07:20:35" , 
"distance_traveled" : 6.0701
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:21:55" , 
"departure_time" : "07:22:03" , 
"distance_traveled" : 6.3646
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:23:08" , 
"departure_time" : "07:24:10" , 
"distance_traveled" : 6.6136
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:26:02" , 
"departure_time" : "07:27:15" , 
"distance_traveled" : 6.9606
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:29:13" , 
"departure_time" : "07:29:22" , 
"distance_traveled" : 7.2536
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "07:33:09" , 
"departure_time" : "07:33:09" , 
"distance_traveled" : 8.1312
} ], 
"1053" :  [ 
{ 
"stop_id" : 38229,
"arrival_time" : "08:02:00" , 
"departure_time" : "08:02:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "08:04:11" , 
"departure_time" : "08:04:31" , 
"distance_traveled" : 0.8614
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "08:06:20" , 
"departure_time" : "08:07:26" , 
"distance_traveled" : 1.4237
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "08:09:06" , 
"departure_time" : "08:09:43" , 
"distance_traveled" : 2.6339
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "08:09:37" , 
"departure_time" : "08:10:09" , 
"distance_traveled" : 3.2818
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:12:32" , 
"departure_time" : "08:12:48" , 
"distance_traveled" : 4.7036
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:15:16" , 
"departure_time" : "08:16:56" , 
"distance_traveled" : 5.3848
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:17:40" , 
"departure_time" : "08:18:31" , 
"distance_traveled" : 5.6623
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:18:51" , 
"departure_time" : "08:19:14" , 
"distance_traveled" : 6.0701
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:20:23" , 
"departure_time" : "08:20:55" , 
"distance_traveled" : 6.3646
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:22:32" , 
"departure_time" : "08:23:49" , 
"distance_traveled" : 6.6136
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:25:17" , 
"departure_time" : "08:26:54" , 
"distance_traveled" : 6.9606
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:28:37" , 
"departure_time" : "08:28:55" , 
"distance_traveled" : 7.2536
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "08:32:18" , 
"departure_time" : "08:32:18" , 
"distance_traveled" : 8.1312
} ], 
"1054" :  [ 
{ 
"stop_id" : 38229,
"arrival_time" : "08:46:00" , 
"departure_time" : "08:47:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "08:49:17" , 
"departure_time" : "08:50:51" , 
"distance_traveled" : 0.8614
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "08:51:34" , 
"departure_time" : "08:53:02" , 
"distance_traveled" : 1.4237
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "08:53:28" , 
"departure_time" : "08:54:18" , 
"distance_traveled" : 2.6339
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "08:53:50" , 
"departure_time" : "08:54:17" , 
"distance_traveled" : 3.2818
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:56:27" , 
"departure_time" : "08:57:05" , 
"distance_traveled" : 4.7036
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:59:38" , 
"departure_time" : "09:00:55" , 
"distance_traveled" : 5.3848
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:01:17" , 
"departure_time" : "09:02:26" , 
"distance_traveled" : 5.6623
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:03:09" , 
"departure_time" : "09:03:37" , 
"distance_traveled" : 6.0701
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:04:28" , 
"departure_time" : "09:05:25" , 
"distance_traveled" : 6.3646
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:06:57" , 
"departure_time" : "09:08:00" , 
"distance_traveled" : 6.6136
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:09:03" , 
"departure_time" : "09:09:08" , 
"distance_traveled" : 6.9606
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:11:05" , 
"departure_time" : "09:12:03" , 
"distance_traveled" : 7.2536
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "09:16:58" , 
"departure_time" : "09:16:58" , 
"distance_traveled" : 8.1312
} ], 
"1055" :  [ 
{ 
"stop_id" : 38229,
"arrival_time" : "09:02:00" , 
"departure_time" : "09:04:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "09:05:28" , 
"departure_time" : "09:06:29" , 
"distance_traveled" : 0.8614
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "09:07:01" , 
"departure_time" : "09:08:18" , 
"distance_traveled" : 1.4237
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "09:09:17" , 
"departure_time" : "09:09:23" , 
"distance_traveled" : 2.6339
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "09:09:06" , 
"departure_time" : "09:10:18" , 
"distance_traveled" : 3.2818
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:13:12" , 
"departure_time" : "09:14:47" , 
"distance_traveled" : 4.7036
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:16:35" , 
"departure_time" : "09:16:51" , 
"distance_traveled" : 5.3848
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:16:16" , 
"departure_time" : "09:16:37" , 
"distance_traveled" : 5.6623
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:18:21" , 
"departure_time" : "09:18:41" , 
"distance_traveled" : 6.0701
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:20:20" , 
"departure_time" : "09:21:27" , 
"distance_traveled" : 6.3646
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:23:07" , 
"departure_time" : "09:24:43" , 
"distance_traveled" : 6.6136
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:25:36" , 
"departure_time" : "09:26:56" , 
"distance_traveled" : 6.9606
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:28:20" , 
"departure_time" : "09:28:42" , 
"distance_traveled" : 7.2536
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "09:32:22" , 
"departure_time" : "09:32:22" , 
"distance_traveled" : 8.1312
} ], 
"1056" :  [ 
{ 
"stop_id" : 38229,
"arrival_time" : "10:05:00" , 
"departure_time" : "10:06:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "10:07:54" , 
"departure_time" : "10:07:59" , 
"distance_traveled" : 0.8614
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "10:09:05" , 
"departure_time" : "10:09:58" , 
"distance_traveled" : 1.4237
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "10:11:53" , 
"departure_time" : "10:13:07" , 
"distance_traveled" : 2.6339
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "10:13:14" , 
"departure_time" : "10:14:08" , 
"distance_traveled" : 3.2818
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:15:54" , 
"departure_time" : "10:17:01" , 
"distance_traveled" : 4.7036
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:19:07" , 
"departure_time" : "10:20:29" , 
"distance_traveled" : 5.3848
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:20:22" , 
"departure_time" : "10:20:26" , 
"distance_traveled" : 5.6623
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:21:04" , 
"departure_time" : "10:21:30" , 
"distance_traveled" : 6.0701
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:23:26" , 
"departure_time" : "10:24:56" , 
"distance_traveled" : 6.3646
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:26:30" , 
"departure_time" : "10:28:00" , 
"distance_traveled" : 6.6136
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:28:30" , 
"departure_time" : "10:28:56" , 
"distance_traveled" : 6.9606
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:30:26" , 
"departure_time" : "10:31:17" , 
"distance_traveled" : 7.2536
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "10:35:51" , 
"departure_time" : "10:35:51" , 
"distance_traveled" : 8.1312
} ], 
"1057" :  [ 
{ 
"stop_id" : 38229,
"arrival_time" : "16:33:00" , 
"departure_time" : "16:35:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "16:36:12" , 
"departure_time" : "16:37:10" , 
"distance_traveled" : 0.8614
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "16:37:58" , 
"departure_time" : "16:38:05" , 
"distance_traveled" : 1.4237
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "16:39:07" , 
"departure_time" : "16:39:58" , 
"distance_traveled" : 2.6339
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "16:40:51" , 
"departure_time" : "16:42:31" , 
"distance_traveled" : 3.2818
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:44:40" , 
"departure_time" : "16:44:57" , 
"distance_traveled" : 4.7036
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:46:17" , 
"departure_time" : "16:46:53" , 
"distance_traveled" : 5.3848
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:47:36" , 
"departure_time" : "16:49:16" , 
"distance_traveled" : 5.6623
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:50:40" , 
"departure_time" : "16:51:08" , 
"distance_traveled" : 6.0701
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:51:28" , 
"departure_time" : "16:52:03" , 
"distance_traveled" : 6.3646
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:53:35" , 
"departure_time" : "16:54:03" , 
"distance_traveled" : 6.6136
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:55:28" , 
"departure_time" : "16:56:08" , 
"distance_traveled" : 6.9606
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:58:40" , 
"departure_time" : "16:58:54" , 
"distance_traveled" : 7.2536
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "17:03:14" , 
"departure_time" : "17:03:14" , 
"distance_traveled" : 8.1312
} ], 
"1058" :  [ 
{ 
"stop_id" : 38229,
"arrival_time" : "16:41:00" , 
"departure_time" : "16:41:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "16:43:34" , 
"departure_time" : "16:44:16" , 
"distance_traveled" : 0.8614
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "16:45:42" , 
"departure_time" : "16:45:56" , 
"distance_traveled" : 1.4237
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "16:47:14" , 
"departure_time" : "16:48:40" , 
"distance_traveled" : 2.6339
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "16:49:26" , 
"departure_time" : "16:50:59" , 
"distance_traveled" : 3.2818
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:52:33" , 
"departure_time" : "16:52:42" , 
"distance_traveled" : 4.7036
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:54:09" , 
"departure_time" : "16:54:39" , 
"distance_traveled" : 5.3848
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:55:30" , 
"departure_time" : "16:57:06" , 
"distance_traveled" : 5.6623
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:58:36" , 
"departure_time" : "17:00:16" , 
"distance_traveled" : 6.0701
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:00:40" , 
"departure_time" : "17:01:17" , 
"distance_traveled" : 6.3646
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:01:37" , 
"departure_time" : "17:02:45" , 
"distance_traveled" : 6.6136
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:04:08" , 
"departure_time" : "17:04:25" , 
"distance_traveled" : 6.9606
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:06:17" , 
"departure_time" : "17:07:30" , 
"distance_traveled" : 7.2536
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "17:12:13" , 
"departure_time" : "17:12:13" , 
"distance_traveled" : 8.1312
} ], 
"1059" :  [ 
{ 
"stop_id" : 38229,
"arrival_time" : "16:58:00" , 
"departure_time" : "17:00:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "17:01:31" , 
"departure_time" : "17:02:37" , 
"distance_traveled" : 0.8614
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "17:03:06" , 
"departure_time" : "17:03:25" , 
"distance_traveled" : 1.4237
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "17:04:19" , 
"departure_time" : "17:05:27" , 
"distance_traveled" : 2.6339
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "17:06:08" , 
"departure_time" : "17:06:51" , 
"distance_traveled" : 3.2818
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:08:43" , 
"departure_time" : "17:09:00" , 
"distance_traveled" : 4.7036
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:11:17" , 
"departure_time" : "17:12:19" , 
"distance_traveled" : 5.3848
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:13:02" , 
"departure_time" : "17:13:55" , 
"distance_traveled" : 5.6623
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:14:53" , 
"departure_time" : "17:16:25" , 
"distance_traveled" : 6.0701
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:17:32" , 
"departure_time" : "17:18:10" , 
"distance_traveled" : 6.3646
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:18:38" , 
"departure_time" : "17:19:44" , 
"distance_traveled" : 6.6136
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:21:06" , 
"departure_time" : "17:22:32" , 
"distance_traveled" : 6.9606
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:24:26" , 
"departure_time" : "17:24:51" , 
"distance_traveled" : 7.2536
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "17:28:25" , 
"departure_time" : "17:28:25" , 
"distance_traveled" : 8.1312
} ], 
"1060" :  [ 
{ 
"stop_id" : 38229,
"arrival_time" : "17:12:00" , 
"departure_time" : "17:12:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "17:14:14" , 
"departure_time" : "17:15:10" , 
"distance_traveled" : 0.8614
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "17:16:56" , 
"departure_time" : "17:18:02" , 
"distance_traveled" : 1.4237
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "17:19:06" , 
"departure_time" : "17:20:32" , 
"distance_traveled" : 2.6339
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "17:20:26" , 
"departure_time" : "17:20:32" , 
"distance_traveled" : 3.2818
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:22:06" , 
"departure_time" : "17:22:12" , 
"distance_traveled" : 4.7036
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:25:06" , 
"departure_time" : "17:26:01" , 
"distance_traveled" : 5.3848
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:26:55" , 
"departure_time" : "17:27:50" , 
"distance_traveled" : 5.6623
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:28:55" , 
"departure_time" : "17:29:38" , 
"distance_traveled" : 6.0701
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:30:43" , 
"departure_time" : "17:31:56" , 
"distance_traveled" : 6.3646
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:33:13" , 
"departure_time" : "17:33:41" , 
"distance_traveled" : 6.6136
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:34:28" , 
"departure_time" : "17:35:28" , 
"distance_traveled" : 6.9606
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:38:00" , 
"departure_time" : "17:38:34" , 
"distance_traveled" : 7.2536
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "17:42:34" , 
"departure_time" : "17:42:34" , 
"distance_traveled" : 8.1312
} ], 
"1061" :  [ 
{ 
"stop_id" : 38229,
"arrival_time" : "18:00:00" , 
"departure_time" : "18:01:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "18:03:09" , 
"departure_time" : "18:04:20" , 
"distance_traveled" : 0.8614
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "18:05:11" , 
"departure_time" : "18:06:16" , 
"distance_traveled" : 1.4237
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "18:07:05" , 
"departure_time" : "18:08:10" , 
"distance_traveled" : 2.6339
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "18:08:05" , 
"departure_time" : "18:08:31" , 
"distance_traveled" : 3.2818
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:10:26" , 
"departure_time" : "18:11:10" , 
"distance_traveled" : 4.7036
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:13:44" , 
"departure_time" : "18:13:48" , 
"distance_traveled" : 5.3848
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:14:04" , 
"departure_time" : "18:14:20" , 
"distance_traveled" : 5.6623
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:16:16" , 
"departure_time" : "18:16:58" , 
"distance_traveled" : 6.0701
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:18:42" , 
"departure_time" : "18:20:19" , 
"distance_traveled" : 6.3646
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:21:37" , 
"departure_time" : "18:22:22" , 
"distance_traveled" : 6.6136
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:22:45" , 
"departure_time" : "18:22:50" , 
"distance_traveled" : 6.9606
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:25:05" , 
"departure_time" : "18:26:11" , 
"distance_traveled" : 7.2536
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "18:31:06" , 
"departure_time" : "18:31:06" , 
"distance_traveled" : 8.1312
} ], 
"1062" :  [ 
{ 
"stop_id" : 38229,
"arrival_time" : "18:21:00" , 
"departure_time" : "18:22:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "18:23:41" , 
"departure_time" : "18:23:55" , 
"distance_traveled" : 0.8614
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "18:25:14" , 
"departure_time" : "18:25:55" , 
"distance_traveled" : 1.4237
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "18:27:41" , 
"departure_time" : "18:28:02" , 
"distance_traveled" : 2.6339
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "18:28:21" , 
"departure_time" : "18:28:36" , 
"distance_traveled" : 3.2818
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:31:15" , 
"departure_time" : "18:31:59" , 
"distance_traveled" : 4.7036
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:34:44" , 
"departure_time" : "18:36:24" , 
"distance_traveled" : 5.3848
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:36:40" , 
"departure_time" : "18:37:13" , 
"distance_traveled" : 5.6623
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:37:33" , 
"departure_time" : "18:38:43" , 
"distance_traveled" : 6.0701
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:40:10" , 
"departure_time" : "18:41:46" , 
"distance_traveled" : 6.3646
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:42:36" , 
"departure_time" : "18:43:59" , 
"distance_traveled" : 6.6136
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:44:23" , 
"departure_time" : "18:45:41" , 
"distance_traveled" : 6.9606
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:47:18" , 
"departure_time" : "18:47:37" , 
"distance_traveled" : 7.2536
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "18:51:19" , 
"departure_time" : "18:51:19" , 
"distance_traveled" : 8.1312
} ], 
"1063" :  [ 
{ 
"stop_id" : 37003,
"arrival_time" : "06:35:00" , 
"departure_time" : "06:35:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "06:36:11" , 
"departure_time" : "06:37:39" , 
"distance_traveled" : 0.6491
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:40:28" , 
"departure_time" : "06:40:46" , 
"distance_traveled" : 2.0708
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:42:18" , 
"departure_time" : "06:42:59" , 
"distance_traveled" : 2.7521
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:43:41" , 
"departure_time" : "06:43:58" , 
"distance_traveled" : 3.0295
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:45:17" , 
"departure_time" : "06:45:45" , 
"distance_traveled" : 3.4373
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:47:28" , 
"departure_time" : "06:48:56" , 
"distance_traveled" : 3.7318
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:50:28" , 
"departure_time" : "06:51:45" , 
"distance_traveled" : 3.9809
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:52:17" , 
"departure_time" : "06:52:30" , 
"distance_traveled" : 4.3278
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:54:13" , 
"departure_time" : "06:55:16" , 
"distance_traveled" : 4.6208
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "07:00:03" , 
"departure_time" : "07:00:03" , 
"distance_traveled" : 5.4985
} ], 
"1064" :  [ 
{ 
"stop_id" : 37003,
"arrival_time" : "07:38:00" , 
"departure_time" : "07:40:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "07:40:01" , 
"departure_time" : "07:40:52" , 
"distance_traveled" : 0.6491
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:42:51" , 
"departure_time" : "07:43:31" , 
"distance_traveled" : 2.0708
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:45:40" , 
"departure_time" : "07:46:33" , 
"distance_traveled" : 2.7521
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:46:53" , 
"departure_time" : "07:47:05" , 
"distance_traveled" : 3.0295
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:48:12" , 
"departure_time" : "07:49:43" , 
"distance_traveled" : 3.4373
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:51:31" , 
"departure_time" : "07:52:41" , 
"distance_traveled" : 3.7318
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:53:10" , 
"departure_time" : "07:54:21" , 
"distance_traveled" : 3.9809
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:55:11" , 
"departure_time" : "07:56:07" , 
"distance_traveled" : 4.3278
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:57:56" , 
"departure_time" : "07:58:24" , 
"distance_traveled" : 4.6208
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "08:02:28" , 
"departure_time" : "08:02:28" , 
"distance_traveled" : 5.4985
} ], 
"1065" :  [ 
{ 
"stop_id" : 37003,
"arrival_time" : "08:28:00" , 
"departure_time" : "08:28:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "08:29:12" , 
"departure_time" : "08:30:22" , 
"distance_traveled" : 0.6491
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:33:10" , 
"departure_time" : "08:33:36" , 
"distance_traveled" : 2.0708
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:35:26" , 
"departure_time" : "08:36:07" , 
"distance_traveled" : 2.7521
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:36:41" , 
"departure_time" : "08:38:12" , 
"distance_traveled" : 3.0295
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:39:31" , 
"departure_time" : "08:39:59" , 
"distance_traveled" : 3.4373
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:40:28" , 
"departure_time" : "08:42:03" , 
"distance_traveled" : 3.7318
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:43:35" , 
"departure_time" : "08:44:44" , 
"distance_traveled" : 3.9809
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:45:09" , 
"departure_time" : "08:45:36" , 
"distance_traveled" : 4.3278
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:47:27" , 
"departure_time" : "08:48:34" , 
"distance_traveled" : 4.6208
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "08:53:07" , 
"departure_time" : "08:53:07" , 
"distance_traveled" : 5.4985
} ], 
"1066" :  [ 
{ 
"stop_id" : 37003,
"arrival_time" : "17:38:00" , 
"departure_time" : "17:40:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "17:40:08" , 
"departure_time" : "17:41:33" , 
"distance_traveled" : 0.6491
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:43:25" , 
"departure_time" : "17:44:49" , 
"distance_traveled" : 2.0708
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:46:24" , 
"departure_time" : "17:46:51" , 
"distance_traveled" : 2.7521
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:46:27" , 
"departure_time" : "17:47:14" , 
"distance_traveled" : 3.0295
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:48:47" , 
"departure_time" : "17:48:56" , 
"distance_traveled" : 3.4373
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:50:09" , 
"departure_time" : "17:51:04" , 
"distance_traveled" : 3.7318
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:52:55" , 
"departure_time" : "17:54:11" , 
"distance_traveled" : 3.9809
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:55:16" , 
"departure_time" : "17:56:52" , 
"distance_traveled" : 4.3278
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:58:36" , 
"departure_time" : "17:58:56" , 
"distance_traveled" : 4.6208
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "18:02:20" , 
"departure_time" : "18:02:20" , 
"distance_traveled" : 5.4985
} ], 
"1067" :  [ 
{ 
"stop_id" : 37003,
"arrival_time" : "19:07:00" , 
"departure_time" : "19:07:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "19:08:14" , 
"departure_time" : "19:09:39" , 
"distance_traveled" : 0.6491
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:12:25" , 
"departure_time" : "19:12:56" , 
"distance_traveled" : 2.0708
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:14:31" , 
"departure_time" : "19:16:11" , 
"distance_traveled" : 2.7521
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:16:40" , 
"departure_time" : "19:18:10" , 
"distance_traveled" : 3.0295
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:18:30" , 
"departure_time" : "19:18:50" , 
"distance_traveled" : 3.4373
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:19:20" , 
"departure_time" : "19:20:56" , 
"distance_traveled" : 3.7318
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:22:36" , 
"departure_time" : "19:22:47" , 
"distance_traveled" : 3.9809
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:23:11" , 
"departure_time" : "19:24:51" , 
"distance_traveled" : 4.3278
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:27:40" , 
"departure_time" : "19:28:14" , 
"distance_traveled" : 4.6208
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "19:31:34" , 
"departure_time" : "19:31:34" , 
"distance_traveled" : 5.4985
} ], 
"1068" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "04:44:00" , 
"departure_time" : "04:45:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "04:46:27" , 
"departure_time" : "04:47:57" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "04:49:30" , 
"departure_time" : "04:51:08" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "04:52:38" , 
"departure_time" : "04:53:57" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "04:55:19" , 
"departure_time" : "04:56:03" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "04:55:44" , 
"departure_time" : "04:57:23" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "05:01:39" , 
"departure_time" : "05:01:39" , 
"distance_traveled" : 5.6227
} ], 
"1069" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "04:59:00" , 
"departure_time" : "05:01:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "05:02:13" , 
"departure_time" : "05:03:43" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "05:04:30" , 
"departure_time" : "05:05:46" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "05:07:16" , 
"departure_time" : "05:08:12" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "05:09:56" , 
"departure_time" : "05:11:12" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "05:11:16" , 
"departure_time" : "05:11:42" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "05:15:26" , 
"departure_time" : "05:15:26" , 
"distance_traveled" : 5.6227
} ], 
"1070" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "05:14:00" , 
"departure_time" : "05:15:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "05:16:57" , 
"departure_time" : "05:17:58" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "05:19:01" , 
"departure_time" : "05:19:34" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "05:21:33" , 
"departure_time" : "05:23:10" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "05:25:37" , 
"departure_time" : "05:26:07" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "05:25:30" , 
"departure_time" : "05:26:54" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "05:31:24" , 
"departure_time" : "05:31:24" , 
"distance_traveled" : 5.6227
} ], 
"1071" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "05:29:00" , 
"departure_time" : "05:31:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "05:32:05" , 
"departure_time" : "05:32:43" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "05:33:38" , 
"departure_time" : "05:33:39" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "05:36:01" , 
"departure_time" : "05:36:18" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "05:39:17" , 
"departure_time" : "05:39:47" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "05:40:30" , 
"departure_time" : "05:41:18" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "05:45:48" , 
"departure_time" : "05:45:48" , 
"distance_traveled" : 5.6227
} ], 
"1072" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "05:43:00" , 
"departure_time" : "05:44:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "05:45:33" , 
"departure_time" : "05:47:10" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "05:48:37" , 
"departure_time" : "05:48:49" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "05:50:12" , 
"departure_time" : "05:50:47" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "05:53:35" , 
"departure_time" : "05:54:06" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "05:54:31" , 
"departure_time" : "05:54:32" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "05:59:01" , 
"departure_time" : "05:59:01" , 
"distance_traveled" : 5.6227
} ], 
"1073" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "05:57:00" , 
"departure_time" : "05:57:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "05:59:37" , 
"departure_time" : "06:00:30" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "06:01:53" , 
"departure_time" : "06:02:59" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "06:05:06" , 
"departure_time" : "06:05:46" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "06:07:40" , 
"departure_time" : "06:08:00" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "06:08:20" , 
"departure_time" : "06:09:39" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "06:14:19" , 
"departure_time" : "06:14:19" , 
"distance_traveled" : 5.6227
} ], 
"1074" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "06:11:00" , 
"departure_time" : "06:13:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "06:14:02" , 
"departure_time" : "06:14:27" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "06:15:25" , 
"departure_time" : "06:16:26" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "06:19:01" , 
"departure_time" : "06:20:13" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "06:22:12" , 
"departure_time" : "06:22:21" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "06:22:09" , 
"departure_time" : "06:22:52" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "06:27:43" , 
"departure_time" : "06:27:43" , 
"distance_traveled" : 5.6227
} ], 
"1075" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "06:23:00" , 
"departure_time" : "06:24:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "06:25:20" , 
"departure_time" : "06:26:45" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "06:28:25" , 
"departure_time" : "06:29:24" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "06:30:59" , 
"departure_time" : "06:32:10" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "06:34:11" , 
"departure_time" : "06:35:12" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "06:35:01" , 
"departure_time" : "06:35:12" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "06:39:11" , 
"departure_time" : "06:39:11" , 
"distance_traveled" : 5.6227
} ], 
"1076" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "06:38:00" , 
"departure_time" : "06:39:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "06:41:23" , 
"departure_time" : "06:43:03" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "06:43:40" , 
"departure_time" : "06:44:08" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "06:45:28" , 
"departure_time" : "06:45:38" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "06:48:10" , 
"departure_time" : "06:49:30" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "06:50:20" , 
"departure_time" : "06:50:57" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "06:54:37" , 
"departure_time" : "06:54:37" , 
"distance_traveled" : 5.6227
} ], 
"1077" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "06:53:00" , 
"departure_time" : "06:54:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "06:55:48" , 
"departure_time" : "06:56:46" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "06:57:58" , 
"departure_time" : "06:59:07" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "07:01:09" , 
"departure_time" : "07:02:33" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "07:04:24" , 
"departure_time" : "07:05:06" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:04:42" , 
"departure_time" : "07:04:51" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "07:09:09" , 
"departure_time" : "07:09:09" , 
"distance_traveled" : 5.6227
} ], 
"1078" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "07:04:00" , 
"departure_time" : "07:04:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:06:39" , 
"departure_time" : "07:07:06" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "07:08:27" , 
"departure_time" : "07:09:51" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "07:12:24" , 
"departure_time" : "07:14:04" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "07:15:40" , 
"departure_time" : "07:16:48" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:16:08" , 
"departure_time" : "07:17:34" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "07:21:26" , 
"departure_time" : "07:21:26" , 
"distance_traveled" : 5.6227
} ], 
"1079" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "07:21:00" , 
"departure_time" : "07:22:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:23:13" , 
"departure_time" : "07:24:04" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "07:25:51" , 
"departure_time" : "07:27:16" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "07:29:25" , 
"departure_time" : "07:30:15" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "07:31:50" , 
"departure_time" : "07:33:28" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:33:38" , 
"departure_time" : "07:35:07" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "07:38:29" , 
"departure_time" : "07:38:29" , 
"distance_traveled" : 5.6227
} ], 
"1080" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "07:34:00" , 
"departure_time" : "07:35:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:36:13" , 
"departure_time" : "07:36:14" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "07:38:01" , 
"departure_time" : "07:38:22" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "07:41:21" , 
"departure_time" : "07:42:03" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "07:44:42" , 
"departure_time" : "07:45:03" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:45:21" , 
"departure_time" : "07:46:14" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "07:50:53" , 
"departure_time" : "07:50:53" , 
"distance_traveled" : 5.6227
} ], 
"1081" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "07:52:00" , 
"departure_time" : "07:53:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:54:15" , 
"departure_time" : "07:55:43" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "07:57:28" , 
"departure_time" : "07:59:06" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:00:38" , 
"departure_time" : "08:01:50" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:03:12" , 
"departure_time" : "08:04:13" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:04:01" , 
"departure_time" : "08:04:33" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "08:08:32" , 
"departure_time" : "08:08:32" , 
"distance_traveled" : 5.6227
} ], 
"1082" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "08:04:00" , 
"departure_time" : "08:05:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:06:57" , 
"departure_time" : "08:07:27" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:08:30" , 
"departure_time" : "08:09:30" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:12:00" , 
"departure_time" : "08:13:12" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:15:12" , 
"departure_time" : "08:16:50" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:16:38" , 
"departure_time" : "08:17:55" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "08:21:17" , 
"departure_time" : "08:21:17" , 
"distance_traveled" : 5.6227
} ], 
"1083" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "08:20:00" , 
"departure_time" : "08:22:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:23:36" , 
"departure_time" : "08:24:31" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:24:55" , 
"departure_time" : "08:25:38" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:27:43" , 
"departure_time" : "08:28:32" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:30:49" , 
"departure_time" : "08:31:15" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:31:26" , 
"departure_time" : "08:31:33" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "08:36:07" , 
"departure_time" : "08:36:07" , 
"distance_traveled" : 5.6227
} ], 
"1084" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "08:33:00" , 
"departure_time" : "08:34:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:36:06" , 
"departure_time" : "08:37:26" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:38:20" , 
"departure_time" : "08:39:40" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:41:20" , 
"departure_time" : "08:41:47" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:43:27" , 
"departure_time" : "08:44:41" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:45:14" , 
"departure_time" : "08:45:48" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "08:49:34" , 
"departure_time" : "08:49:34" , 
"distance_traveled" : 5.6227
} ], 
"1085" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "08:47:00" , 
"departure_time" : "08:48:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:49:37" , 
"departure_time" : "08:50:25" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:51:48" , 
"departure_time" : "08:52:14" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:54:26" , 
"departure_time" : "08:56:05" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:58:39" , 
"departure_time" : "08:59:17" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:58:38" , 
"departure_time" : "08:59:46" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "09:04:08" , 
"departure_time" : "09:04:08" , 
"distance_traveled" : 5.6227
} ], 
"1086" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "09:03:00" , 
"departure_time" : "09:05:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "09:05:59" , 
"departure_time" : "09:06:34" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "09:07:35" , 
"departure_time" : "09:08:40" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "09:11:05" , 
"departure_time" : "09:12:16" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:14:11" , 
"departure_time" : "09:14:59" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "09:14:48" , 
"departure_time" : "09:15:33" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "09:19:45" , 
"departure_time" : "09:19:45" , 
"distance_traveled" : 5.6227
} ], 
"1087" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "09:19:00" , 
"departure_time" : "09:20:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "09:21:56" , 
"departure_time" : "09:22:48" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "09:23:52" , 
"departure_time" : "09:25:24" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "09:27:32" , 
"departure_time" : "09:29:03" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:30:31" , 
"departure_time" : "09:31:38" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "09:31:07" , 
"departure_time" : "09:31:56" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "09:35:49" , 
"departure_time" : "09:35:49" , 
"distance_traveled" : 5.6227
} ], 
"1088" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "09:32:00" , 
"departure_time" : "09:34:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "09:35:38" , 
"departure_time" : "09:36:44" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "09:37:06" , 
"departure_time" : "09:38:27" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "09:40:21" , 
"departure_time" : "09:41:22" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:43:01" , 
"departure_time" : "09:44:30" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "09:44:29" , 
"departure_time" : "09:45:03" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "09:48:34" , 
"departure_time" : "09:48:34" , 
"distance_traveled" : 5.6227
} ], 
"1089" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "09:43:00" , 
"departure_time" : "09:44:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "09:46:09" , 
"departure_time" : "09:47:32" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "09:48:23" , 
"departure_time" : "09:48:43" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "09:50:20" , 
"departure_time" : "09:50:45" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:53:25" , 
"departure_time" : "09:54:46" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "09:55:21" , 
"departure_time" : "09:56:25" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "10:00:04" , 
"departure_time" : "10:00:04" , 
"distance_traveled" : 5.6227
} ], 
"1090" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "10:02:00" , 
"departure_time" : "10:03:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "10:04:29" , 
"departure_time" : "10:06:09" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "10:07:40" , 
"departure_time" : "10:08:51" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "10:10:11" , 
"departure_time" : "10:11:25" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "10:13:14" , 
"departure_time" : "10:14:29" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "10:14:15" , 
"departure_time" : "10:15:35" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "10:19:20" , 
"departure_time" : "10:19:20" , 
"distance_traveled" : 5.6227
} ], 
"1091" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "10:24:00" , 
"departure_time" : "10:25:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "10:26:08" , 
"departure_time" : "10:26:14" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "10:28:06" , 
"departure_time" : "10:29:06" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "10:32:00" , 
"departure_time" : "10:32:17" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "10:34:17" , 
"departure_time" : "10:35:06" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "10:35:49" , 
"departure_time" : "10:36:02" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "10:40:13" , 
"departure_time" : "10:40:13" , 
"distance_traveled" : 5.6227
} ], 
"1092" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "10:44:00" , 
"departure_time" : "10:44:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "10:46:07" , 
"departure_time" : "10:47:42" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "10:49:35" , 
"departure_time" : "10:49:50" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "10:51:15" , 
"departure_time" : "10:52:19" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "10:55:04" , 
"departure_time" : "10:56:19" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "10:56:15" , 
"departure_time" : "10:56:23" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "11:00:08" , 
"departure_time" : "11:00:08" , 
"distance_traveled" : 5.6227
} ], 
"1093" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "11:04:00" , 
"departure_time" : "11:04:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "11:06:51" , 
"departure_time" : "11:07:45" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "11:08:54" , 
"departure_time" : "11:09:14" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "11:11:20" , 
"departure_time" : "11:11:25" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "11:14:05" , 
"departure_time" : "11:14:42" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "11:15:37" , 
"departure_time" : "11:16:47" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "11:21:10" , 
"departure_time" : "11:21:10" , 
"distance_traveled" : 5.6227
} ], 
"1094" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "11:24:00" , 
"departure_time" : "11:25:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "11:26:38" , 
"departure_time" : "11:28:09" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "11:29:31" , 
"departure_time" : "11:30:29" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "11:31:58" , 
"departure_time" : "11:32:38" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "11:34:40" , 
"departure_time" : "11:36:11" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "11:36:31" , 
"departure_time" : "11:38:00" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "11:41:29" , 
"departure_time" : "11:41:29" , 
"distance_traveled" : 5.6227
} ], 
"1095" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "11:44:00" , 
"departure_time" : "11:46:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "11:47:03" , 
"departure_time" : "11:48:27" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "11:49:24" , 
"departure_time" : "11:50:01" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "11:51:37" , 
"departure_time" : "11:52:36" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "11:54:59" , 
"departure_time" : "11:55:43" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "11:55:44" , 
"departure_time" : "11:56:17" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "12:00:33" , 
"departure_time" : "12:00:33" , 
"distance_traveled" : 5.6227
} ], 
"1096" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "12:04:00" , 
"departure_time" : "12:05:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "12:06:58" , 
"departure_time" : "12:07:14" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "12:08:16" , 
"departure_time" : "12:08:52" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "12:11:36" , 
"departure_time" : "12:12:52" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "12:15:16" , 
"departure_time" : "12:16:24" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "12:16:08" , 
"departure_time" : "12:16:28" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "12:20:20" , 
"departure_time" : "12:20:20" , 
"distance_traveled" : 5.6227
} ], 
"1097" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "12:24:00" , 
"departure_time" : "12:24:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "12:26:20" , 
"departure_time" : "12:26:43" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "12:28:23" , 
"departure_time" : "12:29:03" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "12:31:40" , 
"departure_time" : "12:31:52" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "12:34:12" , 
"departure_time" : "12:35:19" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "12:36:07" , 
"departure_time" : "12:36:38" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "12:40:31" , 
"departure_time" : "12:40:31" , 
"distance_traveled" : 5.6227
} ], 
"1098" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "12:44:00" , 
"departure_time" : "12:44:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "12:46:03" , 
"departure_time" : "12:46:26" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "12:48:23" , 
"departure_time" : "12:49:36" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "12:52:13" , 
"departure_time" : "12:52:46" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "12:54:33" , 
"departure_time" : "12:55:26" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "12:55:53" , 
"departure_time" : "12:57:07" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "13:01:14" , 
"departure_time" : "13:01:14" , 
"distance_traveled" : 5.6227
} ], 
"1099" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "13:04:00" , 
"departure_time" : "13:06:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "13:07:26" , 
"departure_time" : "13:07:50" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "13:08:24" , 
"departure_time" : "13:08:50" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "13:11:26" , 
"departure_time" : "13:12:40" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "13:15:14" , 
"departure_time" : "13:15:37" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "13:15:23" , 
"departure_time" : "13:15:41" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "13:20:18" , 
"departure_time" : "13:20:18" , 
"distance_traveled" : 5.6227
} ], 
"1100" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "13:24:00" , 
"departure_time" : "13:25:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "13:27:02" , 
"departure_time" : "13:27:24" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "13:28:22" , 
"departure_time" : "13:29:40" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "13:32:18" , 
"departure_time" : "13:33:23" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "13:35:05" , 
"departure_time" : "13:35:54" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "13:35:49" , 
"departure_time" : "13:35:57" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "13:40:08" , 
"departure_time" : "13:40:08" , 
"distance_traveled" : 5.6227
} ], 
"1101" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "13:44:00" , 
"departure_time" : "13:44:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "13:46:18" , 
"departure_time" : "13:47:04" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "13:48:46" , 
"departure_time" : "13:50:11" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "13:52:25" , 
"departure_time" : "13:52:51" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "13:54:26" , 
"departure_time" : "13:54:50" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "13:55:24" , 
"departure_time" : "13:56:58" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "14:01:34" , 
"departure_time" : "14:01:34" , 
"distance_traveled" : 5.6227
} ], 
"1102" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "14:04:00" , 
"departure_time" : "14:07:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "14:07:32" , 
"departure_time" : "14:08:14" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "14:08:42" , 
"departure_time" : "14:09:08" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "14:11:26" , 
"departure_time" : "14:12:17" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "14:14:51" , 
"departure_time" : "14:14:57" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "14:15:06" , 
"departure_time" : "14:15:59" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "14:20:53" , 
"departure_time" : "14:20:53" , 
"distance_traveled" : 5.6227
} ], 
"1103" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "14:24:00" , 
"departure_time" : "14:25:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "14:26:18" , 
"departure_time" : "14:27:55" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "14:29:37" , 
"departure_time" : "14:31:08" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "14:32:31" , 
"departure_time" : "14:33:02" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "14:34:31" , 
"departure_time" : "14:35:05" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "14:35:34" , 
"departure_time" : "14:35:37" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "14:40:03" , 
"departure_time" : "14:40:03" , 
"distance_traveled" : 5.6227
} ], 
"1104" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "14:44:00" , 
"departure_time" : "14:45:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "14:46:57" , 
"departure_time" : "14:47:22" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "14:48:25" , 
"departure_time" : "14:49:17" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "14:51:52" , 
"departure_time" : "14:53:09" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "14:55:17" , 
"departure_time" : "14:56:05" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "14:55:48" , 
"departure_time" : "14:57:14" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "15:01:26" , 
"departure_time" : "15:01:26" , 
"distance_traveled" : 5.6227
} ], 
"1105" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "14:58:00" , 
"departure_time" : "15:00:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "15:01:02" , 
"departure_time" : "15:01:36" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "15:02:34" , 
"departure_time" : "15:03:59" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "15:06:25" , 
"departure_time" : "15:06:50" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "15:08:25" , 
"departure_time" : "15:08:29" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "15:09:04" , 
"departure_time" : "15:10:30" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "15:15:26" , 
"departure_time" : "15:15:26" , 
"distance_traveled" : 5.6227
} ], 
"1106" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "15:12:00" , 
"departure_time" : "15:13:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "15:14:04" , 
"departure_time" : "15:14:30" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "15:16:26" , 
"departure_time" : "15:17:40" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "15:20:14" , 
"departure_time" : "15:20:43" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "15:22:29" , 
"departure_time" : "15:22:46" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "15:23:17" , 
"departure_time" : "15:23:53" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "15:28:36" , 
"departure_time" : "15:28:36" , 
"distance_traveled" : 5.6227
} ], 
"1107" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "15:26:00" , 
"departure_time" : "15:27:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "15:29:13" , 
"departure_time" : "15:30:41" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "15:31:28" , 
"departure_time" : "15:31:50" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "15:33:22" , 
"departure_time" : "15:34:41" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "15:37:19" , 
"departure_time" : "15:37:23" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "15:37:04" , 
"departure_time" : "15:38:29" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "15:43:25" , 
"departure_time" : "15:43:25" , 
"distance_traveled" : 5.6227
} ], 
"1108" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "15:41:00" , 
"departure_time" : "15:43:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "15:43:59" , 
"departure_time" : "15:44:18" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "15:45:19" , 
"departure_time" : "15:45:49" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "15:48:30" , 
"departure_time" : "15:49:41" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "15:52:11" , 
"departure_time" : "15:52:41" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "15:52:30" , 
"departure_time" : "15:53:45" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "15:58:15" , 
"departure_time" : "15:58:15" , 
"distance_traveled" : 5.6227
} ], 
"1109" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "15:52:00" , 
"departure_time" : "15:53:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "15:54:02" , 
"departure_time" : "15:54:10" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "15:56:08" , 
"departure_time" : "15:57:41" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:00:33" , 
"departure_time" : "16:02:13" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:03:40" , 
"departure_time" : "16:03:42" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:03:02" , 
"departure_time" : "16:03:50" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "16:08:48" , 
"departure_time" : "16:08:48" , 
"distance_traveled" : 5.6227
} ], 
"1110" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "16:07:00" , 
"departure_time" : "16:08:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:10:02" , 
"departure_time" : "16:10:54" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "16:11:52" , 
"departure_time" : "16:12:23" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:14:31" , 
"departure_time" : "16:14:42" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:17:11" , 
"departure_time" : "16:17:36" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:18:25" , 
"departure_time" : "16:19:24" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "16:23:59" , 
"departure_time" : "16:23:59" , 
"distance_traveled" : 5.6227
} ], 
"1111" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "16:25:00" , 
"departure_time" : "16:26:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:27:44" , 
"departure_time" : "16:29:04" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "16:30:20" , 
"departure_time" : "16:30:54" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:32:34" , 
"departure_time" : "16:33:52" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:36:18" , 
"departure_time" : "16:36:43" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:36:25" , 
"departure_time" : "16:36:48" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "16:41:23" , 
"departure_time" : "16:41:23" , 
"distance_traveled" : 5.6227
} ], 
"1112" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "16:36:00" , 
"departure_time" : "16:37:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:39:00" , 
"departure_time" : "16:40:13" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "16:41:13" , 
"departure_time" : "16:41:50" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:43:37" , 
"departure_time" : "16:45:11" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:47:34" , 
"departure_time" : "16:47:42" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:47:08" , 
"departure_time" : "16:47:39" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "16:52:31" , 
"departure_time" : "16:52:31" , 
"distance_traveled" : 5.6227
} ], 
"1113" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "16:49:00" , 
"departure_time" : "16:50:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:51:58" , 
"departure_time" : "16:53:07" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "16:54:09" , 
"departure_time" : "16:55:36" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:57:27" , 
"departure_time" : "16:58:02" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:59:35" , 
"departure_time" : "17:01:06" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:01:31" , 
"departure_time" : "17:02:11" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "17:05:40" , 
"departure_time" : "17:05:40" , 
"distance_traveled" : 5.6227
} ], 
"1114" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "17:07:00" , 
"departure_time" : "17:08:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:10:12" , 
"departure_time" : "17:10:53" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:11:41" , 
"departure_time" : "17:13:15" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:15:34" , 
"departure_time" : "17:16:06" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "17:17:32" , 
"departure_time" : "17:17:48" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:18:16" , 
"departure_time" : "17:19:20" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "17:24:04" , 
"departure_time" : "17:24:04" , 
"distance_traveled" : 5.6227
} ], 
"1115" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "17:21:00" , 
"departure_time" : "17:22:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:23:07" , 
"departure_time" : "17:23:31" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:25:24" , 
"departure_time" : "17:26:26" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:29:02" , 
"departure_time" : "17:30:28" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "17:32:26" , 
"departure_time" : "17:33:33" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:33:07" , 
"departure_time" : "17:34:24" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "17:38:17" , 
"departure_time" : "17:38:17" , 
"distance_traveled" : 5.6227
} ], 
"1116" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "17:39:00" , 
"departure_time" : "17:41:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:42:05" , 
"departure_time" : "17:42:15" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:43:10" , 
"departure_time" : "17:44:35" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:47:25" , 
"departure_time" : "17:48:28" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "17:50:03" , 
"departure_time" : "17:51:01" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:50:58" , 
"departure_time" : "17:52:17" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "17:56:19" , 
"departure_time" : "17:56:19" , 
"distance_traveled" : 5.6227
} ], 
"1117" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "17:52:00" , 
"departure_time" : "17:54:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:55:38" , 
"departure_time" : "17:57:13" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:57:35" , 
"departure_time" : "17:57:38" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:59:03" , 
"departure_time" : "17:59:05" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:02:02" , 
"departure_time" : "18:02:30" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:03:28" , 
"departure_time" : "18:04:27" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "18:08:59" , 
"departure_time" : "18:08:59" , 
"distance_traveled" : 5.6227
} ], 
"1118" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "18:08:00" , 
"departure_time" : "18:10:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:11:23" , 
"departure_time" : "18:12:02" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:12:39" , 
"departure_time" : "18:13:55" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:16:16" , 
"departure_time" : "18:17:11" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:18:55" , 
"departure_time" : "18:20:18" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:20:23" , 
"departure_time" : "18:20:30" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "18:24:07" , 
"departure_time" : "18:24:07" , 
"distance_traveled" : 5.6227
} ], 
"1119" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "18:25:00" , 
"departure_time" : "18:25:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:27:34" , 
"departure_time" : "18:28:14" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:29:40" , 
"departure_time" : "18:31:19" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:33:39" , 
"departure_time" : "18:35:03" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:36:24" , 
"departure_time" : "18:37:01" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:36:37" , 
"departure_time" : "18:37:23" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "18:41:46" , 
"departure_time" : "18:41:46" , 
"distance_traveled" : 5.6227
} ], 
"1120" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "18:36:00" , 
"departure_time" : "18:37:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:38:19" , 
"departure_time" : "18:39:28" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:41:09" , 
"departure_time" : "18:42:40" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:44:31" , 
"departure_time" : "18:45:57" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:47:26" , 
"departure_time" : "18:49:01" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:48:35" , 
"departure_time" : "18:49:33" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "18:52:58" , 
"departure_time" : "18:52:58" , 
"distance_traveled" : 5.6227
} ], 
"1121" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "18:52:00" , 
"departure_time" : "18:53:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:54:37" , 
"departure_time" : "18:54:38" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:56:01" , 
"departure_time" : "18:56:27" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:59:26" , 
"departure_time" : "18:59:40" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "19:02:14" , 
"departure_time" : "19:03:27" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "19:04:13" , 
"departure_time" : "19:05:36" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "19:09:23" , 
"departure_time" : "19:09:23" , 
"distance_traveled" : 5.6227
} ], 
"1122" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "19:08:00" , 
"departure_time" : "19:10:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "19:10:56" , 
"departure_time" : "19:12:19" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "19:13:23" , 
"departure_time" : "19:14:14" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "19:15:51" , 
"departure_time" : "19:17:04" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "19:19:13" , 
"departure_time" : "19:19:51" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "19:19:38" , 
"departure_time" : "19:21:16" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "19:25:38" , 
"departure_time" : "19:25:38" , 
"distance_traveled" : 5.6227
} ], 
"1123" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "19:34:00" , 
"departure_time" : "19:36:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "19:36:48" , 
"departure_time" : "19:37:13" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "19:38:25" , 
"departure_time" : "19:39:06" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "19:41:41" , 
"departure_time" : "19:42:28" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "19:44:47" , 
"departure_time" : "19:46:05" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "19:46:18" , 
"departure_time" : "19:47:55" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "19:51:37" , 
"departure_time" : "19:51:37" , 
"distance_traveled" : 5.6227
} ], 
"1124" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "19:58:00" , 
"departure_time" : "19:59:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "20:00:17" , 
"departure_time" : "20:01:13" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "20:02:56" , 
"departure_time" : "20:03:32" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "20:05:36" , 
"departure_time" : "20:06:39" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "20:09:03" , 
"departure_time" : "20:10:24" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "20:10:21" , 
"departure_time" : "20:11:40" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "20:15:19" , 
"departure_time" : "20:15:19" , 
"distance_traveled" : 5.6227
} ], 
"1125" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "20:28:00" , 
"departure_time" : "20:30:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "20:30:52" , 
"departure_time" : "20:31:09" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "20:32:17" , 
"departure_time" : "20:32:21" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "20:35:04" , 
"departure_time" : "20:35:30" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "20:38:26" , 
"departure_time" : "20:39:03" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "20:39:37" , 
"departure_time" : "20:39:58" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "20:44:21" , 
"departure_time" : "20:44:21" , 
"distance_traveled" : 5.6227
} ], 
"1126" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "20:58:00" , 
"departure_time" : "20:59:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "21:01:20" , 
"departure_time" : "21:01:43" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "21:02:23" , 
"departure_time" : "21:02:34" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "21:05:11" , 
"departure_time" : "21:06:00" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "21:08:49" , 
"departure_time" : "21:10:08" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "21:10:19" , 
"departure_time" : "21:11:12" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "21:14:53" , 
"departure_time" : "21:14:53" , 
"distance_traveled" : 5.6227
} ], 
"1127" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "21:28:00" , 
"departure_time" : "21:30:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "21:31:39" , 
"departure_time" : "21:32:31" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "21:32:52" , 
"departure_time" : "21:33:44" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "21:35:52" , 
"departure_time" : "21:36:17" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "21:38:25" , 
"departure_time" : "21:39:09" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "21:39:44" , 
"departure_time" : "21:41:01" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "21:45:17" , 
"departure_time" : "21:45:17" , 
"distance_traveled" : 5.6227
} ], 
"1128" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "21:58:00" , 
"departure_time" : "22:00:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "22:01:23" , 
"departure_time" : "22:01:48" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "22:02:25" , 
"departure_time" : "22:02:58" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "22:05:33" , 
"departure_time" : "22:07:01" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "22:09:28" , 
"departure_time" : "22:09:49" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "22:09:21" , 
"departure_time" : "22:10:54" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "22:15:33" , 
"departure_time" : "22:15:33" , 
"distance_traveled" : 5.6227
} ], 
"1129" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "22:28:00" , 
"departure_time" : "22:30:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "22:30:34" , 
"departure_time" : "22:31:01" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "22:32:27" , 
"departure_time" : "22:33:59" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "22:36:32" , 
"departure_time" : "22:37:57" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "22:39:25" , 
"departure_time" : "22:39:36" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "22:39:11" , 
"departure_time" : "22:40:27" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "22:45:16" , 
"departure_time" : "22:45:16" , 
"distance_traveled" : 5.6227
} ], 
"1130" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "22:58:00" , 
"departure_time" : "23:00:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "23:01:00" , 
"departure_time" : "23:01:50" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "23:02:50" , 
"departure_time" : "23:03:28" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "23:05:38" , 
"departure_time" : "23:05:39" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "23:08:01" , 
"departure_time" : "23:08:52" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "23:09:51" , 
"departure_time" : "23:10:53" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "23:15:02" , 
"departure_time" : "23:15:02" , 
"distance_traveled" : 5.6227
} ], 
"1131" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "23:28:00" , 
"departure_time" : "23:29:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "23:30:33" , 
"departure_time" : "23:30:55" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "23:32:22" , 
"departure_time" : "23:33:50" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "23:36:28" , 
"departure_time" : "23:37:11" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "23:38:43" , 
"departure_time" : "23:39:24" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "23:39:41" , 
"departure_time" : "23:40:29" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "23:44:48" , 
"departure_time" : "23:44:48" , 
"distance_traveled" : 5.6227
} ], 
"1132" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "23:59:00" , 
"departure_time" : "24:00:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "24:01:24" , 
"departure_time" : "24:03:03" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "24:04:39" , 
"departure_time" : "24:06:09" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "24:07:30" , 
"departure_time" : "24:08:23" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "24:09:53" , 
"departure_time" : "24:10:13" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "24:10:20" , 
"departure_time" : "24:11:25" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "24:16:05" , 
"departure_time" : "24:16:05" , 
"distance_traveled" : 5.6227
} ], 
"1133" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "24:28:00" , 
"departure_time" : "24:30:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "24:31:03" , 
"departure_time" : "24:31:21" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "24:32:18" , 
"departure_time" : "24:33:42" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "24:36:24" , 
"departure_time" : "24:37:34" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "24:39:10" , 
"departure_time" : "24:39:45" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "24:39:35" , 
"departure_time" : "24:41:00" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "24:45:25" , 
"departure_time" : "24:45:25" , 
"distance_traveled" : 5.6227
} ], 
"1134" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "24:58:00" , 
"departure_time" : "25:00:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "25:00:36" , 
"departure_time" : "25:02:08" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "25:03:32" , 
"departure_time" : "25:04:06" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "25:05:34" , 
"departure_time" : "25:07:00" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "25:09:26" , 
"departure_time" : "25:10:31" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "25:10:05" , 
"departure_time" : "25:11:23" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 39348,
"arrival_time" : "25:15:18" , 
"departure_time" : "25:15:18" , 
"distance_traveled" : 5.6227
} ], 
"1135" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "05:06:00" , 
"departure_time" : "05:08:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "05:09:51" , 
"departure_time" : "05:11:13" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "05:12:22" , 
"departure_time" : "05:13:49" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "05:14:27" , 
"departure_time" : "05:16:07" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "05:16:40" , 
"departure_time" : "05:16:44" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "05:17:04" , 
"departure_time" : "05:17:28" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "05:19:24" , 
"departure_time" : "05:20:20" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "05:20:56" , 
"departure_time" : "05:21:32" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "05:23:36" , 
"departure_time" : "05:23:54" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "05:26:18" , 
"departure_time" : "05:27:17" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "05:27:59" , 
"departure_time" : "05:28:53" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "05:29:54" , 
"departure_time" : "05:30:31" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "05:31:37" , 
"departure_time" : "05:32:33" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "05:33:56" , 
"departure_time" : "05:34:56" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "05:37:00" , 
"departure_time" : "05:37:00" , 
"distance_traveled" : 9.0369
} ], 
"1136" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "05:21:00" , 
"departure_time" : "05:22:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "05:24:50" , 
"departure_time" : "05:25:24" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "05:26:34" , 
"departure_time" : "05:27:14" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "05:28:40" , 
"departure_time" : "05:29:31" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "05:30:51" , 
"departure_time" : "05:30:54" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "05:32:03" , 
"departure_time" : "05:32:23" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "05:34:20" , 
"departure_time" : "05:35:13" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "05:35:53" , 
"departure_time" : "05:37:28" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "05:39:35" , 
"departure_time" : "05:40:59" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "05:42:24" , 
"departure_time" : "05:43:47" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "05:43:23" , 
"departure_time" : "05:44:58" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "05:45:35" , 
"departure_time" : "05:46:45" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "05:47:10" , 
"departure_time" : "05:47:39" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "05:48:29" , 
"departure_time" : "05:49:33" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "05:52:04" , 
"departure_time" : "05:52:04" , 
"distance_traveled" : 9.0369
} ], 
"1137" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "05:34:00" , 
"departure_time" : "05:36:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "05:38:00" , 
"departure_time" : "05:38:30" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "05:39:30" , 
"departure_time" : "05:40:12" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "05:41:42" , 
"departure_time" : "05:42:57" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "05:44:15" , 
"departure_time" : "05:44:22" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "05:45:07" , 
"departure_time" : "05:46:38" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "05:48:31" , 
"departure_time" : "05:48:45" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "05:48:14" , 
"departure_time" : "05:49:44" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "05:52:30" , 
"departure_time" : "05:52:45" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "05:54:15" , 
"departure_time" : "05:55:42" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "05:56:27" , 
"departure_time" : "05:56:42" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "05:57:15" , 
"departure_time" : "05:58:08" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "05:59:53" , 
"departure_time" : "06:00:36" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "06:01:43" , 
"departure_time" : "06:02:12" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "06:04:29" , 
"departure_time" : "06:04:29" , 
"distance_traveled" : 9.0369
} ], 
"1138" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "05:46:00" , 
"departure_time" : "05:47:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "05:49:37" , 
"departure_time" : "05:51:05" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "05:52:28" , 
"departure_time" : "05:52:46" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "05:53:18" , 
"departure_time" : "05:53:24" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "05:55:06" , 
"departure_time" : "05:56:18" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "05:58:12" , 
"departure_time" : "05:59:49" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:00:37" , 
"departure_time" : "06:00:48" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:00:11" , 
"departure_time" : "06:00:30" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:03:19" , 
"departure_time" : "06:04:17" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "06:06:58" , 
"departure_time" : "06:07:13" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "06:07:15" , 
"departure_time" : "06:07:33" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "06:09:18" , 
"departure_time" : "06:10:37" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "06:12:19" , 
"departure_time" : "06:13:58" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "06:14:39" , 
"departure_time" : "06:15:28" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "06:16:49" , 
"departure_time" : "06:16:49" , 
"distance_traveled" : 9.0369
} ], 
"1139" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "06:01:00" , 
"departure_time" : "06:01:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:04:10" , 
"departure_time" : "06:04:35" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:06:25" , 
"departure_time" : "06:06:51" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:08:26" , 
"departure_time" : "06:09:52" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:11:26" , 
"departure_time" : "06:12:44" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:13:18" , 
"departure_time" : "06:14:40" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:15:22" , 
"departure_time" : "06:15:48" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:15:26" , 
"departure_time" : "06:15:50" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:18:24" , 
"departure_time" : "06:19:33" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "06:22:09" , 
"departure_time" : "06:23:00" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "06:22:51" , 
"departure_time" : "06:24:20" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "06:25:29" , 
"departure_time" : "06:25:51" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "06:26:22" , 
"departure_time" : "06:26:44" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "06:28:22" , 
"departure_time" : "06:29:42" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "06:32:20" , 
"departure_time" : "06:32:20" , 
"distance_traveled" : 9.0369
} ], 
"1140" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "06:15:00" , 
"departure_time" : "06:17:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:18:48" , 
"departure_time" : "06:18:55" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:20:07" , 
"departure_time" : "06:21:26" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:23:19" , 
"departure_time" : "06:23:58" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:24:39" , 
"departure_time" : "06:24:41" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:26:02" , 
"departure_time" : "06:26:07" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:28:05" , 
"departure_time" : "06:28:39" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:29:34" , 
"departure_time" : "06:30:57" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:33:23" , 
"departure_time" : "06:34:18" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "06:35:55" , 
"departure_time" : "06:36:51" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "06:36:56" , 
"departure_time" : "06:38:06" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "06:39:10" , 
"departure_time" : "06:39:23" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "06:40:13" , 
"departure_time" : "06:40:29" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "06:42:16" , 
"departure_time" : "06:43:34" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "06:46:18" , 
"departure_time" : "06:46:18" , 
"distance_traveled" : 9.0369
} ], 
"1141" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "06:41:00" , 
"departure_time" : "06:42:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:44:40" , 
"departure_time" : "06:44:48" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:46:08" , 
"departure_time" : "06:46:39" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:48:31" , 
"departure_time" : "06:49:03" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:50:32" , 
"departure_time" : "06:52:02" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:53:30" , 
"departure_time" : "06:53:55" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:54:25" , 
"departure_time" : "06:54:44" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:55:19" , 
"departure_time" : "06:56:19" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:59:00" , 
"departure_time" : "06:59:54" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "07:01:54" , 
"departure_time" : "07:02:00" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "07:02:06" , 
"departure_time" : "07:03:13" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "07:05:07" , 
"departure_time" : "07:05:45" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "07:06:38" , 
"departure_time" : "07:08:02" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "07:09:24" , 
"departure_time" : "07:09:46" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "07:11:22" , 
"departure_time" : "07:11:22" , 
"distance_traveled" : 9.0369
} ], 
"1142" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "06:53:00" , 
"departure_time" : "06:53:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:56:18" , 
"departure_time" : "06:57:53" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:59:35" , 
"departure_time" : "07:00:15" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:00:40" , 
"departure_time" : "07:01:27" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:02:47" , 
"departure_time" : "07:04:12" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:05:25" , 
"departure_time" : "07:05:35" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:06:10" , 
"departure_time" : "07:07:39" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:08:29" , 
"departure_time" : "07:09:36" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:11:07" , 
"departure_time" : "07:11:39" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "07:13:32" , 
"departure_time" : "07:14:33" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "07:15:01" , 
"departure_time" : "07:16:22" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "07:17:21" , 
"departure_time" : "07:17:50" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "07:18:29" , 
"departure_time" : "07:18:45" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "07:20:16" , 
"departure_time" : "07:21:09" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "07:23:53" , 
"departure_time" : "07:23:53" , 
"distance_traveled" : 9.0369
} ], 
"1143" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "07:03:00" , 
"departure_time" : "07:04:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:06:13" , 
"departure_time" : "07:07:32" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:09:19" , 
"departure_time" : "07:10:35" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:11:16" , 
"departure_time" : "07:12:17" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:13:01" , 
"departure_time" : "07:14:40" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:15:39" , 
"departure_time" : "07:16:17" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:16:38" , 
"departure_time" : "07:17:19" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:17:41" , 
"departure_time" : "07:19:04" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:21:23" , 
"departure_time" : "07:23:00" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "07:24:37" , 
"departure_time" : "07:24:40" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "07:24:03" , 
"departure_time" : "07:25:33" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "07:27:30" , 
"departure_time" : "07:28:36" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "07:29:06" , 
"departure_time" : "07:29:42" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "07:30:36" , 
"departure_time" : "07:31:47" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "07:34:11" , 
"departure_time" : "07:34:11" , 
"distance_traveled" : 9.0369
} ], 
"1144" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "07:36:00" , 
"departure_time" : "07:38:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:40:06" , 
"departure_time" : "07:40:34" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:41:28" , 
"departure_time" : "07:41:53" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:43:25" , 
"departure_time" : "07:43:36" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:45:11" , 
"departure_time" : "07:46:20" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:48:09" , 
"departure_time" : "07:48:20" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:49:11" , 
"departure_time" : "07:50:03" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:50:52" , 
"departure_time" : "07:51:04" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:53:12" , 
"departure_time" : "07:53:46" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "07:56:34" , 
"departure_time" : "07:57:18" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "07:57:44" , 
"departure_time" : "07:59:11" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "08:00:27" , 
"departure_time" : "08:02:00" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "08:02:33" , 
"departure_time" : "08:02:50" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "08:03:17" , 
"departure_time" : "08:04:45" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "08:07:28" , 
"departure_time" : "08:07:28" , 
"distance_traveled" : 9.0369
} ], 
"1145" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "07:45:00" , 
"departure_time" : "07:47:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:48:54" , 
"departure_time" : "07:49:14" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:50:20" , 
"departure_time" : "07:51:20" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:53:00" , 
"departure_time" : "07:54:08" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:55:08" , 
"departure_time" : "07:56:18" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:57:10" , 
"departure_time" : "07:58:36" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:59:26" , 
"departure_time" : "08:00:38" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:00:12" , 
"departure_time" : "08:01:39" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:03:27" , 
"departure_time" : "08:04:37" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "08:06:10" , 
"departure_time" : "08:07:36" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "08:07:26" , 
"departure_time" : "08:07:44" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "08:08:18" , 
"departure_time" : "08:09:25" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "08:11:07" , 
"departure_time" : "08:11:25" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "08:12:18" , 
"departure_time" : "08:13:52" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "08:16:34" , 
"departure_time" : "08:16:34" , 
"distance_traveled" : 9.0369
} ], 
"1146" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "07:54:00" , 
"departure_time" : "07:56:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:57:34" , 
"departure_time" : "07:58:50" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:00:16" , 
"departure_time" : "08:00:31" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:01:15" , 
"departure_time" : "08:02:54" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:04:39" , 
"departure_time" : "08:04:41" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:05:02" , 
"departure_time" : "08:06:41" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:08:39" , 
"departure_time" : "08:09:00" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:08:21" , 
"departure_time" : "08:09:08" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:11:47" , 
"departure_time" : "08:11:48" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "08:14:01" , 
"departure_time" : "08:14:12" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "08:15:11" , 
"departure_time" : "08:16:05" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "08:17:54" , 
"departure_time" : "08:18:42" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "08:19:48" , 
"departure_time" : "08:20:08" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "08:21:20" , 
"departure_time" : "08:22:03" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "08:24:43" , 
"departure_time" : "08:24:43" , 
"distance_traveled" : 9.0369
} ], 
"1147" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "08:37:00" , 
"departure_time" : "08:38:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:41:05" , 
"departure_time" : "08:41:32" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:42:27" , 
"departure_time" : "08:42:43" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:44:16" , 
"departure_time" : "08:44:26" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:46:10" , 
"departure_time" : "08:46:26" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:48:16" , 
"departure_time" : "08:48:50" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:50:34" , 
"departure_time" : "08:51:32" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:51:58" , 
"departure_time" : "08:52:04" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:54:06" , 
"departure_time" : "08:54:27" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "08:57:21" , 
"departure_time" : "08:57:38" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "08:58:17" , 
"departure_time" : "08:58:21" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "09:00:04" , 
"departure_time" : "09:01:19" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "09:03:15" , 
"departure_time" : "09:03:51" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "09:04:36" , 
"departure_time" : "09:05:59" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "09:08:23" , 
"departure_time" : "09:08:23" , 
"distance_traveled" : 9.0369
} ], 
"1148" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "08:39:00" , 
"departure_time" : "08:40:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:42:05" , 
"departure_time" : "08:43:19" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:45:14" , 
"departure_time" : "08:46:46" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:47:32" , 
"departure_time" : "08:49:12" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:49:40" , 
"departure_time" : "08:50:35" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:50:55" , 
"departure_time" : "08:52:07" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:53:12" , 
"departure_time" : "08:53:58" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:53:46" , 
"departure_time" : "08:54:21" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:56:35" , 
"departure_time" : "08:56:39" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "08:59:04" , 
"departure_time" : "09:00:38" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "09:01:34" , 
"departure_time" : "09:01:56" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "09:02:22" , 
"departure_time" : "09:02:51" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "09:04:29" , 
"departure_time" : "09:05:43" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "09:07:14" , 
"departure_time" : "09:08:13" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "09:09:59" , 
"departure_time" : "09:09:59" , 
"distance_traveled" : 9.0369
} ], 
"1149" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "08:50:00" , 
"departure_time" : "08:51:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:53:38" , 
"departure_time" : "08:54:13" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:55:35" , 
"departure_time" : "08:57:02" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:58:27" , 
"departure_time" : "08:58:49" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:59:22" , 
"departure_time" : "09:00:34" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:02:12" , 
"departure_time" : "09:03:11" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:03:59" , 
"departure_time" : "09:04:13" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:04:14" , 
"departure_time" : "09:05:54" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:08:40" , 
"departure_time" : "09:08:52" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "09:10:12" , 
"departure_time" : "09:11:23" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "09:12:11" , 
"departure_time" : "09:12:27" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "09:13:16" , 
"departure_time" : "09:13:18" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "09:15:02" , 
"departure_time" : "09:16:35" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "09:18:33" , 
"departure_time" : "09:20:02" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "09:21:29" , 
"departure_time" : "09:21:29" , 
"distance_traveled" : 9.0369
} ], 
"1150" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "09:10:00" , 
"departure_time" : "09:11:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:13:07" , 
"departure_time" : "09:14:38" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:16:31" , 
"departure_time" : "09:17:17" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:17:46" , 
"departure_time" : "09:18:41" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:19:55" , 
"departure_time" : "09:20:29" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:21:34" , 
"departure_time" : "09:21:47" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:23:13" , 
"departure_time" : "09:24:20" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:25:07" , 
"departure_time" : "09:25:16" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:27:09" , 
"departure_time" : "09:27:46" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "09:30:37" , 
"departure_time" : "09:31:28" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "09:31:51" , 
"departure_time" : "09:33:06" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "09:34:15" , 
"departure_time" : "09:34:26" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "09:35:11" , 
"departure_time" : "09:35:13" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "09:37:02" , 
"departure_time" : "09:37:21" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "09:40:19" , 
"departure_time" : "09:40:19" , 
"distance_traveled" : 9.0369
} ], 
"1151" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "09:18:00" , 
"departure_time" : "09:19:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:22:27" , 
"departure_time" : "09:23:48" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:24:21" , 
"departure_time" : "09:24:47" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:25:26" , 
"departure_time" : "09:25:30" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:27:04" , 
"departure_time" : "09:28:16" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:30:12" , 
"departure_time" : "09:30:35" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:31:23" , 
"departure_time" : "09:31:40" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:32:17" , 
"departure_time" : "09:33:53" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:36:36" , 
"departure_time" : "09:36:57" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "09:38:21" , 
"departure_time" : "09:38:42" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "09:39:21" , 
"departure_time" : "09:40:06" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "09:41:45" , 
"departure_time" : "09:43:22" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "09:44:37" , 
"departure_time" : "09:44:59" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "09:45:22" , 
"departure_time" : "09:45:41" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "09:48:19" , 
"departure_time" : "09:48:19" , 
"distance_traveled" : 9.0369
} ], 
"1152" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "09:29:00" , 
"departure_time" : "09:30:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:33:16" , 
"departure_time" : "09:34:19" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:35:03" , 
"departure_time" : "09:35:24" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:36:21" , 
"departure_time" : "09:37:23" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:39:02" , 
"departure_time" : "09:40:04" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:41:02" , 
"departure_time" : "09:41:34" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:42:32" , 
"departure_time" : "09:43:54" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:44:22" , 
"departure_time" : "09:44:27" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:46:05" , 
"departure_time" : "09:47:18" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "09:50:13" , 
"departure_time" : "09:50:16" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "09:50:03" , 
"departure_time" : "09:50:08" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "09:52:05" , 
"departure_time" : "09:52:26" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "09:54:21" , 
"departure_time" : "09:54:58" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "09:56:37" , 
"departure_time" : "09:57:42" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "10:00:05" , 
"departure_time" : "10:00:05" , 
"distance_traveled" : 9.0369
} ], 
"1153" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "09:50:00" , 
"departure_time" : "09:51:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:53:08" , 
"departure_time" : "09:54:12" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:56:04" , 
"departure_time" : "09:56:12" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:57:08" , 
"departure_time" : "09:57:25" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:59:17" , 
"departure_time" : "10:00:37" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:02:20" , 
"departure_time" : "10:02:35" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:03:15" , 
"departure_time" : "10:04:17" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:05:02" , 
"departure_time" : "10:05:45" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:07:43" , 
"departure_time" : "10:09:02" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "10:11:19" , 
"departure_time" : "10:12:38" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "10:12:19" , 
"departure_time" : "10:12:30" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "10:13:11" , 
"departure_time" : "10:14:30" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "10:16:19" , 
"departure_time" : "10:16:28" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "10:17:09" , 
"departure_time" : "10:18:06" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "10:20:57" , 
"departure_time" : "10:20:57" , 
"distance_traveled" : 9.0369
} ], 
"1154" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "10:00:00" , 
"departure_time" : "10:02:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:04:32" , 
"departure_time" : "10:04:53" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:05:21" , 
"departure_time" : "10:05:29" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:07:08" , 
"departure_time" : "10:07:58" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:09:50" , 
"departure_time" : "10:11:04" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:12:14" , 
"departure_time" : "10:12:48" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:13:34" , 
"departure_time" : "10:15:10" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:15:36" , 
"departure_time" : "10:16:11" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:17:35" , 
"departure_time" : "10:17:48" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "10:20:13" , 
"departure_time" : "10:20:59" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "10:21:46" , 
"departure_time" : "10:23:21" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "10:24:35" , 
"departure_time" : "10:24:40" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "10:25:05" , 
"departure_time" : "10:26:05" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "10:28:00" , 
"departure_time" : "10:29:35" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "10:31:35" , 
"departure_time" : "10:31:35" , 
"distance_traveled" : 9.0369
} ], 
"1155" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "10:10:00" , 
"departure_time" : "10:12:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:13:45" , 
"departure_time" : "10:14:58" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:16:13" , 
"departure_time" : "10:17:11" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:17:58" , 
"departure_time" : "10:18:10" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:19:12" , 
"departure_time" : "10:20:38" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:22:26" , 
"departure_time" : "10:23:55" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:24:29" , 
"departure_time" : "10:24:34" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:24:05" , 
"departure_time" : "10:25:23" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:28:18" , 
"departure_time" : "10:29:31" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "10:31:13" , 
"departure_time" : "10:31:25" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "10:31:12" , 
"departure_time" : "10:32:38" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "10:34:26" , 
"departure_time" : "10:35:37" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "10:36:11" , 
"departure_time" : "10:37:40" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "10:38:29" , 
"departure_time" : "10:39:25" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "10:40:56" , 
"departure_time" : "10:40:56" , 
"distance_traveled" : 9.0369
} ], 
"1156" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "10:31:00" , 
"departure_time" : "10:32:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:34:54" , 
"departure_time" : "10:36:23" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:37:29" , 
"departure_time" : "10:39:03" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:39:34" , 
"departure_time" : "10:40:59" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:41:25" , 
"departure_time" : "10:42:39" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:43:14" , 
"departure_time" : "10:43:20" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:44:06" , 
"departure_time" : "10:44:37" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:45:31" , 
"departure_time" : "10:46:46" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:49:15" , 
"departure_time" : "10:49:53" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "10:51:38" , 
"departure_time" : "10:53:18" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "10:53:40" , 
"departure_time" : "10:54:16" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "10:54:36" , 
"departure_time" : "10:56:09" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "10:57:33" , 
"departure_time" : "10:57:43" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "10:58:10" , 
"departure_time" : "10:59:49" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "11:02:39" , 
"departure_time" : "11:02:39" , 
"distance_traveled" : 9.0369
} ], 
"1157" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "10:40:00" , 
"departure_time" : "10:42:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:43:48" , 
"departure_time" : "10:44:56" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:46:08" , 
"departure_time" : "10:47:41" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:48:33" , 
"departure_time" : "10:49:59" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:50:26" , 
"departure_time" : "10:51:41" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:52:15" , 
"departure_time" : "10:53:12" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:53:57" , 
"departure_time" : "10:54:46" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:54:49" , 
"departure_time" : "10:54:52" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:57:03" , 
"departure_time" : "10:57:35" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "11:00:32" , 
"departure_time" : "11:01:45" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "11:02:13" , 
"departure_time" : "11:03:01" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "11:03:48" , 
"departure_time" : "11:04:33" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "11:05:45" , 
"departure_time" : "11:07:08" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "11:08:23" , 
"departure_time" : "11:08:28" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "11:10:05" , 
"departure_time" : "11:10:05" , 
"distance_traveled" : 9.0369
} ], 
"1158" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "10:55:00" , 
"departure_time" : "10:55:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:58:51" , 
"departure_time" : "10:59:03" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:00:12" , 
"departure_time" : "11:01:41" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:03:29" , 
"departure_time" : "11:04:00" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:04:31" , 
"departure_time" : "11:05:33" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:07:02" , 
"departure_time" : "11:08:05" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:09:03" , 
"departure_time" : "11:09:37" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:09:34" , 
"departure_time" : "11:10:51" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:13:17" , 
"departure_time" : "11:14:28" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "11:16:11" , 
"departure_time" : "11:17:50" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "11:17:39" , 
"departure_time" : "11:18:12" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "11:18:33" , 
"departure_time" : "11:19:50" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "11:21:17" , 
"departure_time" : "11:21:31" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "11:22:14" , 
"departure_time" : "11:22:20" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "11:25:06" , 
"departure_time" : "11:25:06" , 
"distance_traveled" : 9.0369
} ], 
"1159" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "11:15:00" , 
"departure_time" : "11:16:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:19:21" , 
"departure_time" : "11:20:50" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:21:29" , 
"departure_time" : "11:22:06" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:22:37" , 
"departure_time" : "11:23:24" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:24:47" , 
"departure_time" : "11:25:05" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:26:18" , 
"departure_time" : "11:26:23" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:28:05" , 
"departure_time" : "11:28:26" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:29:21" , 
"departure_time" : "11:31:01" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:33:40" , 
"departure_time" : "11:35:14" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "11:36:34" , 
"departure_time" : "11:37:03" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "11:36:29" , 
"departure_time" : "11:37:06" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "11:38:37" , 
"departure_time" : "11:39:32" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "11:40:55" , 
"departure_time" : "11:41:42" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "11:42:47" , 
"departure_time" : "11:43:03" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "11:45:16" , 
"departure_time" : "11:45:16" , 
"distance_traveled" : 9.0369
} ], 
"1160" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "11:35:00" , 
"departure_time" : "11:35:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:38:32" , 
"departure_time" : "11:39:42" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:41:10" , 
"departure_time" : "11:41:53" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:42:43" , 
"departure_time" : "11:43:41" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:44:58" , 
"departure_time" : "11:46:04" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:47:06" , 
"departure_time" : "11:48:19" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:49:13" , 
"departure_time" : "11:49:36" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:49:23" , 
"departure_time" : "11:50:29" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:53:06" , 
"departure_time" : "11:53:45" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "11:55:39" , 
"departure_time" : "11:55:57" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "11:56:18" , 
"departure_time" : "11:57:52" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "11:59:34" , 
"departure_time" : "12:01:09" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "12:01:35" , 
"departure_time" : "12:03:07" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "12:03:32" , 
"departure_time" : "12:03:43" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "12:05:11" , 
"departure_time" : "12:05:11" , 
"distance_traveled" : 9.0369
} ], 
"1161" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "11:55:00" , 
"departure_time" : "11:55:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:58:31" , 
"departure_time" : "11:59:26" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:00:55" , 
"departure_time" : "12:01:37" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:02:42" , 
"departure_time" : "12:03:28" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:04:46" , 
"departure_time" : "12:04:58" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:06:12" , 
"departure_time" : "12:07:43" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:09:31" , 
"departure_time" : "12:09:52" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:09:21" , 
"departure_time" : "12:09:36" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:12:15" , 
"departure_time" : "12:12:41" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "12:15:26" , 
"departure_time" : "12:15:55" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "12:16:29" , 
"departure_time" : "12:17:36" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "12:19:07" , 
"departure_time" : "12:19:13" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "12:20:06" , 
"departure_time" : "12:20:58" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "12:22:52" , 
"departure_time" : "12:24:00" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "12:26:08" , 
"departure_time" : "12:26:08" , 
"distance_traveled" : 9.0369
} ], 
"1162" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "12:15:00" , 
"departure_time" : "12:16:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:18:16" , 
"departure_time" : "12:19:36" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:21:20" , 
"departure_time" : "12:22:02" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:22:42" , 
"departure_time" : "12:23:57" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:25:15" , 
"departure_time" : "12:25:57" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:26:42" , 
"departure_time" : "12:27:35" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:28:53" , 
"departure_time" : "12:29:18" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:29:25" , 
"departure_time" : "12:30:12" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:32:47" , 
"departure_time" : "12:33:52" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "12:36:05" , 
"departure_time" : "12:37:41" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "12:37:36" , 
"departure_time" : "12:38:08" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "12:38:32" , 
"departure_time" : "12:38:37" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "12:40:05" , 
"departure_time" : "12:40:19" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "12:42:14" , 
"departure_time" : "12:42:18" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "12:45:04" , 
"departure_time" : "12:45:04" , 
"distance_traveled" : 9.0369
} ], 
"1163" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "12:35:00" , 
"departure_time" : "12:35:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:38:22" , 
"departure_time" : "12:38:54" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:40:32" , 
"departure_time" : "12:41:01" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:42:29" , 
"departure_time" : "12:44:08" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:45:39" , 
"departure_time" : "12:46:20" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:46:41" , 
"departure_time" : "12:47:58" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:49:17" , 
"departure_time" : "12:50:47" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:50:30" , 
"departure_time" : "12:52:07" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:53:37" , 
"departure_time" : "12:53:45" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "12:55:08" , 
"departure_time" : "12:56:19" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "12:57:11" , 
"departure_time" : "12:58:48" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "12:59:37" , 
"departure_time" : "13:00:57" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "13:01:20" , 
"departure_time" : "13:01:40" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "13:02:20" , 
"departure_time" : "13:03:59" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "13:06:39" , 
"departure_time" : "13:06:39" , 
"distance_traveled" : 9.0369
} ], 
"1164" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "12:55:00" , 
"departure_time" : "12:56:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:58:16" , 
"departure_time" : "12:58:24" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:00:08" , 
"departure_time" : "13:01:31" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:03:23" , 
"departure_time" : "13:03:27" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:04:04" , 
"departure_time" : "13:04:37" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:06:33" , 
"departure_time" : "13:06:47" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:08:14" , 
"departure_time" : "13:08:39" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:09:25" , 
"departure_time" : "13:10:21" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:12:56" , 
"departure_time" : "13:13:33" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "13:15:37" , 
"departure_time" : "13:15:41" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "13:16:04" , 
"departure_time" : "13:17:32" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "13:19:28" , 
"departure_time" : "13:20:41" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "13:21:13" , 
"departure_time" : "13:22:41" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "13:23:28" , 
"departure_time" : "13:25:01" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "13:26:33" , 
"departure_time" : "13:26:33" , 
"distance_traveled" : 9.0369
} ], 
"1165" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "13:15:00" , 
"departure_time" : "13:16:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:18:03" , 
"departure_time" : "13:18:46" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:20:43" , 
"departure_time" : "13:21:02" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:22:19" , 
"departure_time" : "13:23:51" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:25:32" , 
"departure_time" : "13:25:36" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:26:04" , 
"departure_time" : "13:26:49" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:28:45" , 
"departure_time" : "13:29:26" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:29:41" , 
"departure_time" : "13:29:49" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:32:08" , 
"departure_time" : "13:33:22" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "13:36:14" , 
"departure_time" : "13:36:17" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "13:36:03" , 
"departure_time" : "13:36:59" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "13:38:56" , 
"departure_time" : "13:40:35" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "13:41:39" , 
"departure_time" : "13:43:17" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "13:43:38" , 
"departure_time" : "13:44:26" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "13:45:48" , 
"departure_time" : "13:45:48" , 
"distance_traveled" : 9.0369
} ], 
"1166" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "13:35:00" , 
"departure_time" : "13:37:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:39:35" , 
"departure_time" : "13:41:04" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:41:29" , 
"departure_time" : "13:42:48" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:43:19" , 
"departure_time" : "13:44:52" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:45:33" , 
"departure_time" : "13:47:11" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:47:38" , 
"departure_time" : "13:49:12" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:49:34" , 
"departure_time" : "13:49:54" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:49:20" , 
"departure_time" : "13:49:38" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:52:18" , 
"departure_time" : "13:52:33" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "13:55:15" , 
"departure_time" : "13:55:48" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "13:56:33" , 
"departure_time" : "13:57:42" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "13:59:09" , 
"departure_time" : "14:00:27" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "14:01:18" , 
"departure_time" : "14:02:16" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "14:02:58" , 
"departure_time" : "14:03:35" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "14:05:37" , 
"departure_time" : "14:05:37" , 
"distance_traveled" : 9.0369
} ], 
"1167" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "13:55:00" , 
"departure_time" : "13:56:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:58:46" , 
"departure_time" : "13:59:09" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:00:23" , 
"departure_time" : "14:00:47" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:02:24" , 
"departure_time" : "14:02:38" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:04:14" , 
"departure_time" : "14:05:33" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:07:19" , 
"departure_time" : "14:08:56" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:09:37" , 
"departure_time" : "14:09:55" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:09:18" , 
"departure_time" : "14:10:52" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:13:34" , 
"departure_time" : "14:14:58" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "14:16:24" , 
"departure_time" : "14:17:09" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "14:16:45" , 
"departure_time" : "14:17:49" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "14:19:04" , 
"departure_time" : "14:19:05" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "14:20:01" , 
"departure_time" : "14:20:48" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "14:22:47" , 
"departure_time" : "14:23:45" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "14:25:58" , 
"departure_time" : "14:25:58" , 
"distance_traveled" : 9.0369
} ], 
"1168" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "14:15:00" , 
"departure_time" : "14:16:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:18:25" , 
"departure_time" : "14:18:31" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:20:06" , 
"departure_time" : "14:20:13" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:22:07" , 
"departure_time" : "14:22:28" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:24:21" , 
"departure_time" : "14:25:18" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:26:57" , 
"departure_time" : "14:27:57" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:29:00" , 
"departure_time" : "14:29:53" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:29:53" , 
"departure_time" : "14:31:03" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:33:10" , 
"departure_time" : "14:33:23" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "14:35:13" , 
"departure_time" : "14:36:49" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "14:37:36" , 
"departure_time" : "14:38:26" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "14:38:50" , 
"departure_time" : "14:39:55" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "14:41:05" , 
"departure_time" : "14:42:35" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "14:43:30" , 
"departure_time" : "14:44:08" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "14:45:38" , 
"departure_time" : "14:45:38" , 
"distance_traveled" : 9.0369
} ], 
"1169" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "14:35:00" , 
"departure_time" : "14:35:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:38:21" , 
"departure_time" : "14:38:49" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:40:28" , 
"departure_time" : "14:41:06" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:42:38" , 
"departure_time" : "14:42:50" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:44:12" , 
"departure_time" : "14:45:32" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:47:20" , 
"departure_time" : "14:47:45" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:48:25" , 
"departure_time" : "14:48:37" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:49:12" , 
"departure_time" : "14:50:04" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:52:52" , 
"departure_time" : "14:53:54" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "14:56:02" , 
"departure_time" : "14:56:22" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "14:56:20" , 
"departure_time" : "14:57:03" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "14:58:43" , 
"departure_time" : "14:58:59" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "15:00:16" , 
"departure_time" : "15:00:44" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "15:02:28" , 
"departure_time" : "15:02:32" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "15:05:04" , 
"departure_time" : "15:05:04" , 
"distance_traveled" : 9.0369
} ], 
"1170" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "14:55:00" , 
"departure_time" : "14:56:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:59:20" , 
"departure_time" : "14:59:49" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:00:29" , 
"departure_time" : "15:01:53" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:03:24" , 
"departure_time" : "15:03:42" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:04:18" , 
"departure_time" : "15:04:45" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:06:27" , 
"departure_time" : "15:07:20" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:08:53" , 
"departure_time" : "15:09:49" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:09:56" , 
"departure_time" : "15:10:56" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:13:00" , 
"departure_time" : "15:14:17" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "15:16:17" , 
"departure_time" : "15:17:20" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "15:17:03" , 
"departure_time" : "15:17:41" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "15:18:38" , 
"departure_time" : "15:18:43" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "15:20:05" , 
"departure_time" : "15:21:00" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "15:22:55" , 
"departure_time" : "15:23:31" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "15:25:36" , 
"departure_time" : "15:25:36" , 
"distance_traveled" : 9.0369
} ], 
"1171" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "15:13:00" , 
"departure_time" : "15:14:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:16:50" , 
"departure_time" : "15:17:21" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:18:31" , 
"departure_time" : "15:19:51" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:21:20" , 
"departure_time" : "15:22:42" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:23:22" , 
"departure_time" : "15:24:41" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:25:19" , 
"departure_time" : "15:26:24" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:27:05" , 
"departure_time" : "15:27:12" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:27:07" , 
"departure_time" : "15:27:52" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:30:45" , 
"departure_time" : "15:32:05" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "15:34:20" , 
"departure_time" : "15:35:13" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "15:34:53" , 
"departure_time" : "15:34:59" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "15:36:06" , 
"departure_time" : "15:36:15" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "15:38:09" , 
"departure_time" : "15:38:57" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "15:40:48" , 
"departure_time" : "15:40:58" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "15:43:10" , 
"departure_time" : "15:43:10" , 
"distance_traveled" : 9.0369
} ], 
"1172" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "15:30:00" , 
"departure_time" : "15:31:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:34:23" , 
"departure_time" : "15:34:56" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:35:33" , 
"departure_time" : "15:36:34" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:38:01" , 
"departure_time" : "15:38:24" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:39:23" , 
"departure_time" : "15:39:40" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:41:17" , 
"departure_time" : "15:41:53" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:43:36" , 
"departure_time" : "15:43:39" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:44:03" , 
"departure_time" : "15:45:29" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:48:26" , 
"departure_time" : "15:50:02" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "15:51:36" , 
"departure_time" : "15:51:41" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "15:51:05" , 
"departure_time" : "15:51:35" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "15:53:30" , 
"departure_time" : "15:54:23" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "15:55:53" , 
"departure_time" : "15:56:06" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "15:57:13" , 
"departure_time" : "15:57:21" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "16:00:08" , 
"departure_time" : "16:00:08" , 
"distance_traveled" : 9.0369
} ], 
"1173" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "15:44:00" , 
"departure_time" : "15:44:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:47:07" , 
"departure_time" : "15:48:03" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:49:56" , 
"departure_time" : "15:51:12" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:52:16" , 
"departure_time" : "15:53:44" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:54:28" , 
"departure_time" : "15:55:57" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:56:29" , 
"departure_time" : "15:57:13" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:57:44" , 
"departure_time" : "15:57:59" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:58:15" , 
"departure_time" : "15:59:36" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:02:21" , 
"departure_time" : "16:03:18" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "16:04:57" , 
"departure_time" : "16:04:58" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "16:05:01" , 
"departure_time" : "16:06:21" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "16:08:20" , 
"departure_time" : "16:08:55" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "16:09:35" , 
"departure_time" : "16:10:50" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "16:12:15" , 
"departure_time" : "16:13:08" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "16:14:53" , 
"departure_time" : "16:14:53" , 
"distance_traveled" : 9.0369
} ], 
"1174" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "15:52:00" , 
"departure_time" : "15:54:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:56:15" , 
"departure_time" : "15:57:34" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:58:19" , 
"departure_time" : "15:59:11" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:59:52" , 
"departure_time" : "16:00:51" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:01:59" , 
"departure_time" : "16:03:02" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:04:03" , 
"departure_time" : "16:04:41" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:05:38" , 
"departure_time" : "16:05:48" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:06:10" , 
"departure_time" : "16:06:20" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:09:10" , 
"departure_time" : "16:09:59" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "16:12:49" , 
"departure_time" : "16:13:23" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "16:13:34" , 
"departure_time" : "16:15:07" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "16:16:33" , 
"departure_time" : "16:17:30" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "16:17:57" , 
"departure_time" : "16:19:18" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "16:20:21" , 
"departure_time" : "16:21:08" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "16:22:47" , 
"departure_time" : "16:22:47" , 
"distance_traveled" : 9.0369
} ], 
"1175" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "16:16:00" , 
"departure_time" : "16:17:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:19:33" , 
"departure_time" : "16:20:35" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:22:02" , 
"departure_time" : "16:22:19" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:23:17" , 
"departure_time" : "16:23:22" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:25:05" , 
"departure_time" : "16:25:57" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:27:52" , 
"departure_time" : "16:28:57" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:30:05" , 
"departure_time" : "16:31:31" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:31:26" , 
"departure_time" : "16:32:38" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:34:12" , 
"departure_time" : "16:35:03" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "16:36:51" , 
"departure_time" : "16:37:32" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "16:37:41" , 
"departure_time" : "16:38:24" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "16:39:43" , 
"departure_time" : "16:40:24" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "16:41:41" , 
"departure_time" : "16:42:20" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "16:43:39" , 
"departure_time" : "16:44:14" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "16:46:35" , 
"departure_time" : "16:46:35" , 
"distance_traveled" : 9.0369
} ], 
"1176" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "16:47:00" , 
"departure_time" : "16:49:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:51:37" , 
"departure_time" : "16:51:48" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:52:11" , 
"departure_time" : "16:52:56" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:54:45" , 
"departure_time" : "16:55:29" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:56:44" , 
"departure_time" : "16:56:48" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:58:04" , 
"departure_time" : "16:58:56" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:00:52" , 
"departure_time" : "17:02:01" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:02:09" , 
"departure_time" : "17:03:34" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:05:25" , 
"departure_time" : "17:05:56" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "17:07:31" , 
"departure_time" : "17:07:45" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "17:08:14" , 
"departure_time" : "17:09:33" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "17:11:19" , 
"departure_time" : "17:11:22" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "17:12:03" , 
"departure_time" : "17:12:59" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "17:14:56" , 
"departure_time" : "17:15:37" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "17:17:41" , 
"departure_time" : "17:17:41" , 
"distance_traveled" : 9.0369
} ], 
"1177" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "16:59:00" , 
"departure_time" : "16:59:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:02:09" , 
"departure_time" : "17:03:12" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:05:03" , 
"departure_time" : "17:06:40" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:07:37" , 
"departure_time" : "17:08:48" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:09:11" , 
"departure_time" : "17:09:54" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:10:43" , 
"departure_time" : "17:12:15" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:13:32" , 
"departure_time" : "17:14:22" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:13:50" , 
"departure_time" : "17:15:16" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:17:26" , 
"departure_time" : "17:18:59" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "17:20:33" , 
"departure_time" : "17:20:44" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "17:20:11" , 
"departure_time" : "17:20:14" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "17:22:03" , 
"departure_time" : "17:22:54" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "17:24:51" , 
"departure_time" : "17:25:54" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "17:27:03" , 
"departure_time" : "17:27:53" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "17:29:50" , 
"departure_time" : "17:29:50" , 
"distance_traveled" : 9.0369
} ], 
"1178" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "17:16:00" , 
"departure_time" : "17:18:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:20:30" , 
"departure_time" : "17:21:11" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:21:41" , 
"departure_time" : "17:22:22" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:23:41" , 
"departure_time" : "17:24:13" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:25:32" , 
"departure_time" : "17:25:35" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:27:03" , 
"departure_time" : "17:28:25" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:30:22" , 
"departure_time" : "17:31:26" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:31:04" , 
"departure_time" : "17:32:41" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:34:37" , 
"departure_time" : "17:35:44" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "17:37:07" , 
"departure_time" : "17:37:28" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "17:37:21" , 
"departure_time" : "17:37:32" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "17:39:11" , 
"departure_time" : "17:40:26" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "17:42:15" , 
"departure_time" : "17:43:06" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "17:43:51" , 
"departure_time" : "17:44:09" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "17:46:18" , 
"departure_time" : "17:46:18" , 
"distance_traveled" : 9.0369
} ], 
"1179" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "17:36:00" , 
"departure_time" : "17:36:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:39:31" , 
"departure_time" : "17:40:47" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:42:16" , 
"departure_time" : "17:42:55" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:43:39" , 
"departure_time" : "17:43:47" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:45:08" , 
"departure_time" : "17:46:30" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:48:22" , 
"departure_time" : "17:49:33" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:50:11" , 
"departure_time" : "17:50:25" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:50:14" , 
"departure_time" : "17:51:35" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:54:21" , 
"departure_time" : "17:55:55" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "17:57:34" , 
"departure_time" : "17:58:47" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "17:58:13" , 
"departure_time" : "17:58:45" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "17:59:32" , 
"departure_time" : "17:59:40" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "18:01:08" , 
"departure_time" : "18:01:24" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "18:03:16" , 
"departure_time" : "18:03:20" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "18:06:04" , 
"departure_time" : "18:06:04" , 
"distance_traveled" : 9.0369
} ], 
"1180" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "17:57:00" , 
"departure_time" : "17:58:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:01:24" , 
"departure_time" : "18:02:40" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:03:16" , 
"departure_time" : "18:03:52" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:04:36" , 
"departure_time" : "18:04:42" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:06:06" , 
"departure_time" : "18:07:05" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:08:59" , 
"departure_time" : "18:09:42" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:10:43" , 
"departure_time" : "18:11:23" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:11:40" , 
"departure_time" : "18:12:23" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:14:43" , 
"departure_time" : "18:14:56" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "18:17:13" , 
"departure_time" : "18:18:03" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "18:18:50" , 
"departure_time" : "18:19:58" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "18:21:08" , 
"departure_time" : "18:22:21" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "18:23:13" , 
"departure_time" : "18:24:50" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "18:25:37" , 
"departure_time" : "18:26:07" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "18:27:30" , 
"departure_time" : "18:27:30" , 
"distance_traveled" : 9.0369
} ], 
"1181" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "18:07:00" , 
"departure_time" : "18:08:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:11:19" , 
"departure_time" : "18:11:33" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:12:14" , 
"departure_time" : "18:13:28" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:15:14" , 
"departure_time" : "18:15:56" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:16:42" , 
"departure_time" : "18:18:14" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:19:32" , 
"departure_time" : "18:20:02" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:20:30" , 
"departure_time" : "18:20:57" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:21:27" , 
"departure_time" : "18:22:58" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:25:31" , 
"departure_time" : "18:25:53" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "18:27:22" , 
"departure_time" : "18:28:38" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "18:29:16" , 
"departure_time" : "18:30:28" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "18:31:12" , 
"departure_time" : "18:31:18" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "18:32:06" , 
"departure_time" : "18:32:43" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "18:34:37" , 
"departure_time" : "18:35:20" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "18:37:43" , 
"departure_time" : "18:37:43" , 
"distance_traveled" : 9.0369
} ], 
"1182" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "18:19:00" , 
"departure_time" : "18:20:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:22:21" , 
"departure_time" : "18:22:26" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:24:05" , 
"departure_time" : "18:24:28" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:26:23" , 
"departure_time" : "18:27:56" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:29:33" , 
"departure_time" : "18:30:25" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:30:52" , 
"departure_time" : "18:31:42" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:32:50" , 
"departure_time" : "18:34:25" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:34:35" , 
"departure_time" : "18:35:58" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:37:23" , 
"departure_time" : "18:38:09" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "18:39:46" , 
"departure_time" : "18:41:19" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "18:41:33" , 
"departure_time" : "18:41:55" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "18:42:22" , 
"departure_time" : "18:42:30" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "18:44:08" , 
"departure_time" : "18:44:14" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "18:46:06" , 
"departure_time" : "18:47:32" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "18:50:26" , 
"departure_time" : "18:50:26" , 
"distance_traveled" : 9.0369
} ], 
"1183" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "18:42:00" , 
"departure_time" : "18:44:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:46:09" , 
"departure_time" : "18:46:16" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:47:07" , 
"departure_time" : "18:48:14" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:50:07" , 
"departure_time" : "18:50:22" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:51:15" , 
"departure_time" : "18:52:52" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:54:37" , 
"departure_time" : "18:55:12" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:55:35" , 
"departure_time" : "18:56:59" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:57:24" , 
"departure_time" : "18:58:24" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:00:00" , 
"departure_time" : "19:00:20" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "19:02:20" , 
"departure_time" : "19:02:56" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "19:03:36" , 
"departure_time" : "19:04:43" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "19:06:07" , 
"departure_time" : "19:07:35" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "19:08:28" , 
"departure_time" : "19:08:44" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "19:09:16" , 
"departure_time" : "19:09:46" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "19:12:30" , 
"departure_time" : "19:12:30" , 
"distance_traveled" : 9.0369
} ], 
"1184" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "18:53:00" , 
"departure_time" : "18:54:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:57:05" , 
"departure_time" : "18:58:19" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:59:14" , 
"departure_time" : "19:00:37" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:01:23" , 
"departure_time" : "19:02:55" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:03:32" , 
"departure_time" : "19:05:03" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:05:31" , 
"departure_time" : "19:06:11" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:06:40" , 
"departure_time" : "19:07:28" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:07:48" , 
"departure_time" : "19:08:32" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:10:44" , 
"departure_time" : "19:11:00" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "19:13:16" , 
"departure_time" : "19:14:48" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "19:15:32" , 
"departure_time" : "19:16:40" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "19:17:08" , 
"departure_time" : "19:18:28" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "19:19:20" , 
"departure_time" : "19:20:24" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "19:21:04" , 
"departure_time" : "19:21:40" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "19:23:36" , 
"departure_time" : "19:23:36" , 
"distance_traveled" : 9.0369
} ], 
"1185" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "19:01:00" , 
"departure_time" : "19:02:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:04:38" , 
"departure_time" : "19:05:18" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:06:40" , 
"departure_time" : "19:06:58" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:08:18" , 
"departure_time" : "19:08:20" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:10:02" , 
"departure_time" : "19:11:30" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:13:28" , 
"departure_time" : "19:14:28" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:15:00" , 
"departure_time" : "19:15:40" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:15:40" , 
"departure_time" : "19:16:34" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:18:54" , 
"departure_time" : "19:20:20" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "19:22:26" , 
"departure_time" : "19:22:46" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "19:22:20" , 
"departure_time" : "19:22:34" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "19:24:14" , 
"departure_time" : "19:25:02" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "19:26:48" , 
"departure_time" : "19:27:42" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "19:28:54" , 
"departure_time" : "19:29:15" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "19:31:21" , 
"departure_time" : "19:31:21" , 
"distance_traveled" : 9.0369
} ], 
"1186" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "19:16:00" , 
"departure_time" : "19:17:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:19:59" , 
"departure_time" : "19:21:22" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:22:23" , 
"departure_time" : "19:23:54" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:24:31" , 
"departure_time" : "19:25:18" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:25:47" , 
"departure_time" : "19:27:03" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:28:16" , 
"departure_time" : "19:29:16" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:30:00" , 
"departure_time" : "19:30:29" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:30:29" , 
"departure_time" : "19:31:01" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:33:32" , 
"departure_time" : "19:34:20" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "19:36:48" , 
"departure_time" : "19:37:14" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "19:37:26" , 
"departure_time" : "19:38:58" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "19:40:32" , 
"departure_time" : "19:41:52" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "19:42:20" , 
"departure_time" : "19:43:41" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "19:44:21" , 
"departure_time" : "19:45:43" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "19:47:22" , 
"departure_time" : "19:47:22" , 
"distance_traveled" : 9.0369
} ], 
"1187" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "19:27:00" , 
"departure_time" : "19:29:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:31:01" , 
"departure_time" : "19:31:58" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:32:57" , 
"departure_time" : "19:34:29" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:35:32" , 
"departure_time" : "19:36:29" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:36:57" , 
"departure_time" : "19:38:36" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:39:39" , 
"departure_time" : "19:39:59" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:40:20" , 
"departure_time" : "19:41:54" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:42:34" , 
"departure_time" : "19:43:35" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:45:01" , 
"departure_time" : "19:46:24" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "19:48:23" , 
"departure_time" : "19:49:05" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "19:48:42" , 
"departure_time" : "19:49:30" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "19:50:48" , 
"departure_time" : "19:51:47" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "19:52:59" , 
"departure_time" : "19:53:43" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "19:54:44" , 
"departure_time" : "19:55:25" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "19:57:41" , 
"departure_time" : "19:57:41" , 
"distance_traveled" : 9.0369
} ], 
"1188" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "19:35:00" , 
"departure_time" : "19:35:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:38:12" , 
"departure_time" : "19:38:21" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:40:09" , 
"departure_time" : "19:41:34" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:43:25" , 
"departure_time" : "19:45:05" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:45:40" , 
"departure_time" : "19:46:23" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:46:43" , 
"departure_time" : "19:47:01" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:48:18" , 
"departure_time" : "19:49:13" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:49:55" , 
"departure_time" : "19:50:17" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:52:22" , 
"departure_time" : "19:53:05" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "19:55:43" , 
"departure_time" : "19:56:16" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "19:56:33" , 
"departure_time" : "19:58:03" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "19:59:30" , 
"departure_time" : "20:00:13" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "20:00:43" , 
"departure_time" : "20:01:57" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "20:03:14" , 
"departure_time" : "20:04:06" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "20:05:52" , 
"departure_time" : "20:05:52" , 
"distance_traveled" : 9.0369
} ], 
"1189" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "19:45:00" , 
"departure_time" : "19:47:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:49:17" , 
"departure_time" : "19:49:45" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:50:28" , 
"departure_time" : "19:50:34" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:52:06" , 
"departure_time" : "19:53:45" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:55:39" , 
"departure_time" : "19:56:48" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:57:09" , 
"departure_time" : "19:57:49" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:58:40" , 
"departure_time" : "20:00:02" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:00:22" , 
"departure_time" : "20:01:27" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:03:05" , 
"departure_time" : "20:04:07" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "20:06:02" , 
"departure_time" : "20:07:01" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "20:06:59" , 
"departure_time" : "20:08:05" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "20:09:06" , 
"departure_time" : "20:10:24" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "20:11:18" , 
"departure_time" : "20:12:26" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "20:13:08" , 
"departure_time" : "20:13:23" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "20:15:15" , 
"departure_time" : "20:15:15" , 
"distance_traveled" : 9.0369
} ], 
"1190" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "20:05:00" , 
"departure_time" : "20:06:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:09:38" , 
"departure_time" : "20:10:33" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:10:55" , 
"departure_time" : "20:11:51" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:12:56" , 
"departure_time" : "20:13:09" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:14:13" , 
"departure_time" : "20:15:11" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:16:58" , 
"departure_time" : "20:17:04" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:18:06" , 
"departure_time" : "20:18:51" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:19:45" , 
"departure_time" : "20:20:43" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:22:58" , 
"departure_time" : "20:23:30" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "20:25:32" , 
"departure_time" : "20:26:14" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "20:26:42" , 
"departure_time" : "20:28:15" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "20:29:33" , 
"departure_time" : "20:29:49" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "20:30:16" , 
"departure_time" : "20:31:14" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "20:32:58" , 
"departure_time" : "20:34:13" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "20:36:15" , 
"departure_time" : "20:36:15" , 
"distance_traveled" : 9.0369
} ], 
"1191" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "20:35:00" , 
"departure_time" : "20:37:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:39:01" , 
"departure_time" : "20:39:24" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:40:23" , 
"departure_time" : "20:40:33" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:42:10" , 
"departure_time" : "20:43:38" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:45:28" , 
"departure_time" : "20:45:51" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:46:23" , 
"departure_time" : "20:46:41" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:48:18" , 
"departure_time" : "20:49:31" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:50:13" , 
"departure_time" : "20:51:45" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:53:32" , 
"departure_time" : "20:54:45" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "20:56:13" , 
"departure_time" : "20:57:27" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "20:57:14" , 
"departure_time" : "20:58:37" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "20:59:23" , 
"departure_time" : "21:00:54" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "21:01:31" , 
"departure_time" : "21:02:26" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "21:02:55" , 
"departure_time" : "21:04:04" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "21:06:09" , 
"departure_time" : "21:06:09" , 
"distance_traveled" : 9.0369
} ], 
"1192" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "21:05:00" , 
"departure_time" : "21:07:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:09:20" , 
"departure_time" : "21:09:23" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:10:03" , 
"departure_time" : "21:10:04" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:12:01" , 
"departure_time" : "21:13:35" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "21:15:34" , 
"departure_time" : "21:16:50" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:17:16" , 
"departure_time" : "21:17:47" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "21:18:31" , 
"departure_time" : "21:18:54" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "21:19:23" , 
"departure_time" : "21:20:23" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:23:00" , 
"departure_time" : "21:24:27" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "21:26:27" , 
"departure_time" : "21:27:02" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "21:26:35" , 
"departure_time" : "21:27:32" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "21:28:57" , 
"departure_time" : "21:29:07" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "21:30:10" , 
"departure_time" : "21:30:51" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "21:32:41" , 
"departure_time" : "21:34:18" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "21:36:37" , 
"departure_time" : "21:36:37" , 
"distance_traveled" : 9.0369
} ], 
"1193" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "21:35:00" , 
"departure_time" : "21:37:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:38:35" , 
"departure_time" : "21:38:42" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:40:07" , 
"departure_time" : "21:40:17" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:42:10" , 
"departure_time" : "21:42:21" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "21:44:11" , 
"departure_time" : "21:45:27" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:47:16" , 
"departure_time" : "21:48:47" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "21:49:31" , 
"departure_time" : "21:50:08" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "21:49:37" , 
"departure_time" : "21:50:17" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:52:40" , 
"departure_time" : "21:53:45" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "21:56:05" , 
"departure_time" : "21:57:08" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "21:57:03" , 
"departure_time" : "21:57:32" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "21:58:29" , 
"departure_time" : "21:59:18" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "22:00:49" , 
"departure_time" : "22:01:50" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "22:03:01" , 
"departure_time" : "22:04:01" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "22:06:00" , 
"departure_time" : "22:06:00" , 
"distance_traveled" : 9.0369
} ], 
"1194" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "22:05:00" , 
"departure_time" : "22:07:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:09:11" , 
"departure_time" : "22:09:49" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:10:38" , 
"departure_time" : "22:11:28" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:12:50" , 
"departure_time" : "22:14:12" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:15:22" , 
"departure_time" : "22:16:31" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:17:09" , 
"departure_time" : "22:17:25" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:18:16" , 
"departure_time" : "22:19:20" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:20:04" , 
"departure_time" : "22:21:13" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:23:09" , 
"departure_time" : "22:23:26" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "22:25:17" , 
"departure_time" : "22:26:46" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "22:27:29" , 
"departure_time" : "22:29:01" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "22:29:32" , 
"departure_time" : "22:31:01" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "22:31:29" , 
"departure_time" : "22:32:51" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "22:33:22" , 
"departure_time" : "22:34:31" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "22:36:09" , 
"departure_time" : "22:36:09" , 
"distance_traveled" : 9.0369
} ], 
"1195" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "22:35:00" , 
"departure_time" : "22:36:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:38:42" , 
"departure_time" : "22:39:46" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:41:04" , 
"departure_time" : "22:41:22" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:42:18" , 
"departure_time" : "22:43:31" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:45:13" , 
"departure_time" : "22:45:54" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:46:41" , 
"departure_time" : "22:47:39" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:48:58" , 
"departure_time" : "22:50:23" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:50:25" , 
"departure_time" : "22:51:11" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:52:46" , 
"departure_time" : "22:54:02" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "22:56:16" , 
"departure_time" : "22:56:33" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "22:56:17" , 
"departure_time" : "22:56:46" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "22:58:29" , 
"departure_time" : "23:00:04" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "23:01:35" , 
"departure_time" : "23:02:32" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "23:02:57" , 
"departure_time" : "23:03:02" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "23:05:05" , 
"departure_time" : "23:05:05" , 
"distance_traveled" : 9.0369
} ], 
"1196" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "23:05:00" , 
"departure_time" : "23:05:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:08:12" , 
"departure_time" : "23:08:16" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:10:04" , 
"departure_time" : "23:11:03" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:12:59" , 
"departure_time" : "23:14:07" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:15:08" , 
"departure_time" : "23:16:09" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:17:01" , 
"departure_time" : "23:17:14" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "23:18:13" , 
"departure_time" : "23:18:17" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:19:04" , 
"departure_time" : "23:19:12" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:22:08" , 
"departure_time" : "23:23:23" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "23:26:15" , 
"departure_time" : "23:27:26" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "23:27:11" , 
"departure_time" : "23:28:51" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "23:29:40" , 
"departure_time" : "23:30:13" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "23:30:33" , 
"departure_time" : "23:31:49" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "23:33:16" , 
"departure_time" : "23:33:51" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "23:35:35" , 
"departure_time" : "23:35:35" , 
"distance_traveled" : 9.0369
} ], 
"1197" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "23:35:00" , 
"departure_time" : "23:36:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:38:59" , 
"departure_time" : "23:39:55" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:40:56" , 
"departure_time" : "23:41:53" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:42:57" , 
"departure_time" : "23:44:37" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:45:40" , 
"departure_time" : "23:46:57" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:47:17" , 
"departure_time" : "23:48:20" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "23:49:03" , 
"departure_time" : "23:49:25" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:49:22" , 
"departure_time" : "23:50:22" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:53:00" , 
"departure_time" : "23:53:28" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "23:55:28" , 
"departure_time" : "23:55:36" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "23:56:08" , 
"departure_time" : "23:57:09" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "23:59:01" , 
"departure_time" : "24:00:23" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "24:01:22" , 
"departure_time" : "24:02:00" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "24:02:38" , 
"departure_time" : "24:03:27" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "24:05:49" , 
"departure_time" : "24:05:49" , 
"distance_traveled" : 9.0369
} ], 
"1198" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "24:05:00" , 
"departure_time" : "24:06:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "24:08:22" , 
"departure_time" : "24:09:01" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "24:10:39" , 
"departure_time" : "24:10:59" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "24:12:20" , 
"departure_time" : "24:12:53" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "24:14:33" , 
"departure_time" : "24:15:35" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "24:17:02" , 
"departure_time" : "24:17:04" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "24:18:02" , 
"departure_time" : "24:19:39" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "24:20:37" , 
"departure_time" : "24:21:23" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "24:22:46" , 
"departure_time" : "24:24:24" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "24:26:38" , 
"departure_time" : "24:28:09" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "24:27:31" , 
"departure_time" : "24:28:01" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "24:28:30" , 
"departure_time" : "24:28:47" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "24:30:17" , 
"departure_time" : "24:30:47" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "24:32:30" , 
"departure_time" : "24:32:46" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "24:35:16" , 
"departure_time" : "24:35:16" , 
"distance_traveled" : 9.0369
} ], 
"1199" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "24:35:00" , 
"departure_time" : "24:36:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "24:39:31" , 
"departure_time" : "24:40:06" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "24:40:35" , 
"departure_time" : "24:42:12" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "24:43:37" , 
"departure_time" : "24:45:15" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "24:45:38" , 
"departure_time" : "24:46:44" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "24:47:06" , 
"departure_time" : "24:47:55" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "24:48:49" , 
"departure_time" : "24:49:06" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "24:49:17" , 
"departure_time" : "24:50:40" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "24:53:23" , 
"departure_time" : "24:53:40" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "24:55:17" , 
"departure_time" : "24:56:49" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "24:57:32" , 
"departure_time" : "24:58:57" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "24:59:25" , 
"departure_time" : "25:00:49" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "25:01:24" , 
"departure_time" : "25:02:50" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "25:03:26" , 
"departure_time" : "25:04:51" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "25:06:25" , 
"departure_time" : "25:06:25" , 
"distance_traveled" : 9.0369
} ], 
"1200" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "25:05:00" , 
"departure_time" : "25:07:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "25:09:31" , 
"departure_time" : "25:11:03" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "25:11:32" , 
"departure_time" : "25:12:23" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "25:12:51" , 
"departure_time" : "25:13:55" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "25:15:04" , 
"departure_time" : "25:16:32" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "25:17:28" , 
"departure_time" : "25:18:00" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "25:18:32" , 
"departure_time" : "25:18:56" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "25:19:24" , 
"departure_time" : "25:20:19" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "25:22:55" , 
"departure_time" : "25:23:31" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "25:25:36" , 
"departure_time" : "25:26:05" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "25:26:29" , 
"departure_time" : "25:27:25" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "25:28:56" , 
"departure_time" : "25:29:02" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "25:30:06" , 
"departure_time" : "25:31:40" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "25:33:34" , 
"departure_time" : "25:34:12" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "25:35:38" , 
"departure_time" : "25:35:38" , 
"distance_traveled" : 9.0369
} ], 
"1201" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "25:35:00" , 
"departure_time" : "25:36:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "25:38:32" , 
"departure_time" : "25:39:27" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "25:40:55" , 
"departure_time" : "25:41:54" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "25:42:59" , 
"departure_time" : "25:44:01" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "25:45:02" , 
"departure_time" : "25:46:20" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "25:47:18" , 
"departure_time" : "25:47:43" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "25:48:25" , 
"departure_time" : "25:48:52" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "25:49:27" , 
"departure_time" : "25:49:52" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "25:52:25" , 
"departure_time" : "25:52:32" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "25:55:07" , 
"departure_time" : "25:55:41" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "25:56:34" , 
"departure_time" : "25:58:00" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "25:59:26" , 
"departure_time" : "26:00:25" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "26:00:59" , 
"departure_time" : "26:01:17" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "26:02:18" , 
"departure_time" : "26:03:08" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "26:05:50" , 
"departure_time" : "26:05:50" , 
"distance_traveled" : 9.0369
} ], 
"1202" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "26:05:00" , 
"departure_time" : "26:06:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "26:08:12" , 
"departure_time" : "26:08:36" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "26:10:24" , 
"departure_time" : "26:11:11" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "26:12:47" , 
"departure_time" : "26:13:13" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "26:14:26" , 
"departure_time" : "26:14:56" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "26:16:30" , 
"departure_time" : "26:17:03" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "26:18:33" , 
"departure_time" : "26:18:56" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "26:19:23" , 
"departure_time" : "26:19:33" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "26:22:10" , 
"departure_time" : "26:22:16" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "26:25:06" , 
"departure_time" : "26:26:07" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "26:27:01" , 
"departure_time" : "26:27:12" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "26:28:11" , 
"departure_time" : "26:29:42" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "26:31:31" , 
"departure_time" : "26:32:28" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "26:32:57" , 
"departure_time" : "26:33:14" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "26:35:17" , 
"departure_time" : "26:35:17" , 
"distance_traveled" : 9.0369
} ], 
"1203" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "07:08:00" , 
"departure_time" : "07:08:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:11:14" , 
"departure_time" : "07:12:06" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:15:52" , 
"departure_time" : "07:17:01" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:18:09" , 
"departure_time" : "07:19:40" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:20:31" , 
"departure_time" : "07:20:34" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:24:03" , 
"departure_time" : "07:25:33" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "07:30:30" , 
"departure_time" : "07:31:47" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "07:32:17" , 
"departure_time" : "07:32:55" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "07:33:38" , 
"departure_time" : "07:34:26" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "07:36:48" , 
"departure_time" : "07:36:48" , 
"distance_traveled" : 9.0369
} ], 
"1204" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "07:22:00" , 
"departure_time" : "07:23:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:26:08" , 
"departure_time" : "07:26:38" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:29:30" , 
"departure_time" : "07:29:43" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:31:13" , 
"departure_time" : "07:31:22" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:33:09" , 
"departure_time" : "07:34:28" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:39:19" , 
"departure_time" : "07:40:13" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "07:43:54" , 
"departure_time" : "07:45:04" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "07:46:10" , 
"departure_time" : "07:47:08" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "07:47:58" , 
"departure_time" : "07:48:31" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "07:50:33" , 
"departure_time" : "07:50:33" , 
"distance_traveled" : 9.0369
} ], 
"1205" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "08:07:00" , 
"departure_time" : "08:08:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:10:29" , 
"departure_time" : "08:10:37" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:14:08" , 
"departure_time" : "08:14:21" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:16:13" , 
"departure_time" : "08:17:15" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:19:02" , 
"departure_time" : "08:20:12" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:24:10" , 
"departure_time" : "08:24:43" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "08:28:33" , 
"departure_time" : "08:29:33" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "08:31:00" , 
"departure_time" : "08:32:14" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "08:33:14" , 
"departure_time" : "08:34:31" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "08:36:17" , 
"departure_time" : "08:36:17" , 
"distance_traveled" : 9.0369
} ], 
"1206" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "08:22:00" , 
"departure_time" : "08:23:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:25:09" , 
"departure_time" : "08:26:10" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:30:01" , 
"departure_time" : "08:30:10" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:31:09" , 
"departure_time" : "08:32:12" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:34:03" , 
"departure_time" : "08:34:20" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:38:17" , 
"departure_time" : "08:39:10" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "08:43:53" , 
"departure_time" : "08:44:59" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "08:46:06" , 
"departure_time" : "08:47:25" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "08:48:19" , 
"departure_time" : "08:49:23" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "08:51:04" , 
"departure_time" : "08:51:04" , 
"distance_traveled" : 9.0369
} ], 
"1207" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "16:10:00" , 
"departure_time" : "16:11:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:13:11" , 
"departure_time" : "16:13:13" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:17:02" , 
"departure_time" : "16:18:42" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:20:40" , 
"departure_time" : "16:20:57" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:21:17" , 
"departure_time" : "16:22:30" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:27:13" , 
"departure_time" : "16:28:35" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "16:32:22" , 
"departure_time" : "16:32:28" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "16:33:06" , 
"departure_time" : "16:34:19" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "16:36:13" , 
"departure_time" : "16:37:29" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "16:39:16" , 
"departure_time" : "16:39:16" , 
"distance_traveled" : 9.0369
} ], 
"1208" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "16:36:00" , 
"departure_time" : "16:38:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:40:34" , 
"departure_time" : "16:41:25" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:43:51" , 
"departure_time" : "16:44:03" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:45:12" , 
"departure_time" : "16:45:15" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:47:03" , 
"departure_time" : "16:48:34" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:53:31" , 
"departure_time" : "16:54:39" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "16:58:08" , 
"departure_time" : "16:59:09" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "17:00:01" , 
"departure_time" : "17:00:38" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "17:01:37" , 
"departure_time" : "17:01:45" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "17:04:08" , 
"departure_time" : "17:04:08" , 
"distance_traveled" : 9.0369
} ], 
"1209" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "17:06:00" , 
"departure_time" : "17:07:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:10:17" , 
"departure_time" : "17:10:48" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:13:31" , 
"departure_time" : "17:14:01" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:15:30" , 
"departure_time" : "17:16:45" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:18:15" , 
"departure_time" : "17:19:19" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:23:04" , 
"departure_time" : "17:23:53" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "17:27:49" , 
"departure_time" : "17:28:22" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "17:29:33" , 
"departure_time" : "17:29:48" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "17:31:15" , 
"departure_time" : "17:32:16" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "17:35:01" , 
"departure_time" : "17:35:01" , 
"distance_traveled" : 9.0369
} ], 
"1210" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "17:24:00" , 
"departure_time" : "17:25:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:27:09" , 
"departure_time" : "17:28:04" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:31:55" , 
"departure_time" : "17:32:44" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:33:49" , 
"departure_time" : "17:34:10" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:35:21" , 
"departure_time" : "17:36:25" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:41:04" , 
"departure_time" : "17:41:58" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "17:45:54" , 
"departure_time" : "17:47:16" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "17:48:22" , 
"departure_time" : "17:48:49" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "17:49:27" , 
"departure_time" : "17:50:46" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "17:53:19" , 
"departure_time" : "17:53:19" , 
"distance_traveled" : 9.0369
} ], 
"1211" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "17:46:00" , 
"departure_time" : "17:48:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:50:27" , 
"departure_time" : "17:51:32" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:54:05" , 
"departure_time" : "17:54:55" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:55:50" , 
"departure_time" : "17:57:22" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:58:32" , 
"departure_time" : "18:00:09" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:03:37" , 
"departure_time" : "18:04:33" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "18:07:56" , 
"departure_time" : "18:08:16" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "18:09:20" , 
"departure_time" : "18:11:00" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "18:12:40" , 
"departure_time" : "18:14:07" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "18:15:27" , 
"departure_time" : "18:15:27" , 
"distance_traveled" : 9.0369
} ], 
"1212" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "18:12:00" , 
"departure_time" : "18:15:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:16:40" , 
"departure_time" : "18:17:11" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:19:31" , 
"departure_time" : "18:19:33" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:21:02" , 
"departure_time" : "18:21:16" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:23:14" , 
"departure_time" : "18:23:48" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:28:34" , 
"departure_time" : "18:30:12" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "18:34:38" , 
"departure_time" : "18:35:20" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "18:35:42" , 
"departure_time" : "18:37:09" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "18:38:27" , 
"departure_time" : "18:38:44" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "18:40:17" , 
"departure_time" : "18:40:17" , 
"distance_traveled" : 9.0369
} ], 
"1213" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "18:30:00" , 
"departure_time" : "18:30:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:33:05" , 
"departure_time" : "18:33:55" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:37:50" , 
"departure_time" : "18:38:03" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:39:13" , 
"departure_time" : "18:39:31" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:41:18" , 
"departure_time" : "18:41:54" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:46:36" , 
"departure_time" : "18:48:11" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "18:52:35" , 
"departure_time" : "18:54:04" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "18:54:29" , 
"departure_time" : "18:55:27" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "18:55:58" , 
"departure_time" : "18:57:33" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "18:59:35" , 
"departure_time" : "18:59:35" , 
"distance_traveled" : 9.0369
} ], 
"1214" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "19:07:00" , 
"departure_time" : "19:08:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:10:09" , 
"departure_time" : "19:10:29" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:14:20" , 
"departure_time" : "19:15:30" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:17:10" , 
"departure_time" : "19:17:24" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:18:14" , 
"departure_time" : "19:18:51" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:23:37" , 
"departure_time" : "19:24:30" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "19:28:53" , 
"departure_time" : "19:29:51" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "19:30:58" , 
"departure_time" : "19:32:21" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "19:33:23" , 
"departure_time" : "19:35:00" , 
"distance_traveled" : 8.135
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "19:36:37" , 
"departure_time" : "19:36:37" , 
"distance_traveled" : 9.0369
} ], 
"1215" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "05:00:00" , 
"departure_time" : "05:02:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "05:04:07" , 
"departure_time" : "05:05:20" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "05:06:13" , 
"departure_time" : "05:07:45" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "05:08:32" , 
"departure_time" : "05:09:25" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "05:09:53" , 
"departure_time" : "05:11:26" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "05:12:33" , 
"departure_time" : "05:12:45" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "05:13:12" , 
"departure_time" : "05:13:23" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "05:14:11" , 
"departure_time" : "05:15:08" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "05:17:57" , 
"departure_time" : "05:18:17" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "05:20:20" , 
"departure_time" : "05:21:11" , 
"distance_traveled" : 4.3057
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "05:22:51" , 
"departure_time" : "05:24:11" , 
"distance_traveled" : 4.6472
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "05:25:20" , 
"departure_time" : "05:25:20" , 
"distance_traveled" : 5.2144
} ], 
"1216" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "06:30:00" , 
"departure_time" : "06:31:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:33:04" , 
"departure_time" : "06:33:25" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:35:21" , 
"departure_time" : "06:36:34" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:38:13" , 
"departure_time" : "06:38:37" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:39:24" , 
"departure_time" : "06:40:46" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:42:22" , 
"departure_time" : "06:43:05" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:43:43" , 
"departure_time" : "06:44:50" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:45:07" , 
"departure_time" : "06:45:20" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:47:13" , 
"departure_time" : "06:48:16" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "06:51:03" , 
"departure_time" : "06:51:44" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "06:51:41" , 
"departure_time" : "06:53:04" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "06:54:23" , 
"departure_time" : "06:55:35" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "06:56:12" , 
"departure_time" : "06:56:34" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "06:57:22" , 
"departure_time" : "06:57:22" , 
"distance_traveled" : 8.135
} ], 
"1217" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "07:29:00" , 
"departure_time" : "07:30:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:33:33" , 
"departure_time" : "07:33:56" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:34:23" , 
"departure_time" : "07:35:12" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:36:49" , 
"departure_time" : "07:37:33" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:38:44" , 
"departure_time" : "07:39:46" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:41:02" , 
"departure_time" : "07:42:01" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:42:59" , 
"departure_time" : "07:43:25" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:43:26" , 
"departure_time" : "07:45:04" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:47:38" , 
"departure_time" : "07:47:50" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "07:49:12" , 
"departure_time" : "07:50:30" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "07:51:18" , 
"departure_time" : "07:51:31" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "07:52:13" , 
"departure_time" : "07:53:35" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "07:55:22" , 
"departure_time" : "07:56:01" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "07:56:39" , 
"departure_time" : "07:56:39" , 
"distance_traveled" : 8.135
} ], 
"1218" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "08:11:00" , 
"departure_time" : "08:12:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:14:49" , 
"departure_time" : "08:16:06" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:17:17" , 
"departure_time" : "08:18:02" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:18:45" , 
"departure_time" : "08:19:03" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:20:18" , 
"departure_time" : "08:20:37" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:22:19" , 
"departure_time" : "08:23:06" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:24:47" , 
"departure_time" : "08:25:04" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:25:17" , 
"departure_time" : "08:25:39" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:28:22" , 
"departure_time" : "08:28:49" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "08:31:27" , 
"departure_time" : "08:31:30" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "08:32:03" , 
"departure_time" : "08:32:19" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "08:34:16" , 
"departure_time" : "08:35:24" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "08:37:08" , 
"departure_time" : "08:37:34" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "08:38:26" , 
"departure_time" : "08:38:26" , 
"distance_traveled" : 8.135
} ], 
"1219" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "08:29:00" , 
"departure_time" : "08:30:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:32:42" , 
"departure_time" : "08:32:52" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:34:10" , 
"departure_time" : "08:34:45" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:36:35" , 
"departure_time" : "08:37:01" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:38:26" , 
"departure_time" : "08:39:54" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:41:28" , 
"departure_time" : "08:42:24" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:42:56" , 
"departure_time" : "08:44:33" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:44:37" , 
"departure_time" : "08:45:51" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:47:14" , 
"departure_time" : "08:47:45" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "08:49:31" , 
"departure_time" : "08:49:33" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "08:50:02" , 
"departure_time" : "08:51:41" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "08:53:39" , 
"departure_time" : "08:55:15" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "08:55:36" , 
"departure_time" : "08:55:53" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "08:56:17" , 
"departure_time" : "08:56:17" , 
"distance_traveled" : 8.135
} ], 
"1220" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "08:56:00" , 
"departure_time" : "08:57:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:00:01" , 
"departure_time" : "09:00:53" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:01:52" , 
"departure_time" : "09:03:05" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:04:13" , 
"departure_time" : "09:04:44" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:05:31" , 
"departure_time" : "09:06:03" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:07:32" , 
"departure_time" : "09:09:00" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:10:28" , 
"departure_time" : "09:11:44" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:11:16" , 
"departure_time" : "09:12:47" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:14:31" , 
"departure_time" : "09:14:45" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "09:16:14" , 
"departure_time" : "09:16:55" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "09:17:41" , 
"departure_time" : "09:18:53" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "09:20:12" , 
"departure_time" : "09:20:37" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "09:21:25" , 
"departure_time" : "09:22:54" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "09:24:29" , 
"departure_time" : "09:24:29" , 
"distance_traveled" : 8.135
} ], 
"1221" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "09:04:00" , 
"departure_time" : "09:06:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:07:46" , 
"departure_time" : "09:08:38" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:09:52" , 
"departure_time" : "09:11:08" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:12:16" , 
"departure_time" : "09:13:33" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:14:17" , 
"departure_time" : "09:15:25" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:16:08" , 
"departure_time" : "09:17:01" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:17:53" , 
"departure_time" : "09:18:09" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:18:16" , 
"departure_time" : "09:19:32" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:22:16" , 
"departure_time" : "09:23:03" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "09:24:47" , 
"departure_time" : "09:26:03" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "09:26:16" , 
"departure_time" : "09:27:43" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "09:28:27" , 
"departure_time" : "09:28:28" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "09:29:01" , 
"departure_time" : "09:30:00" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "09:31:59" , 
"departure_time" : "09:31:59" , 
"distance_traveled" : 8.135
} ], 
"1222" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "09:34:00" , 
"departure_time" : "09:35:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:37:21" , 
"departure_time" : "09:38:36" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:40:15" , 
"departure_time" : "09:41:42" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:42:27" , 
"departure_time" : "09:42:56" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:43:29" , 
"departure_time" : "09:44:40" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:46:11" , 
"departure_time" : "09:46:43" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:47:32" , 
"departure_time" : "09:48:06" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:48:34" , 
"departure_time" : "09:49:28" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:51:54" , 
"departure_time" : "09:53:09" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "09:55:15" , 
"departure_time" : "09:56:41" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "09:56:26" , 
"departure_time" : "09:57:36" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "09:58:10" , 
"departure_time" : "09:59:40" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "10:00:30" , 
"departure_time" : "10:01:37" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "10:02:07" , 
"departure_time" : "10:02:07" , 
"distance_traveled" : 8.135
} ], 
"1223" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "09:43:00" , 
"departure_time" : "09:45:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:47:09" , 
"departure_time" : "09:47:53" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:48:44" , 
"departure_time" : "09:50:24" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:51:40" , 
"departure_time" : "09:53:06" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:53:26" , 
"departure_time" : "09:54:56" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:55:30" , 
"departure_time" : "09:56:27" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:56:57" , 
"departure_time" : "09:57:12" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:57:15" , 
"departure_time" : "09:58:50" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:01:35" , 
"departure_time" : "10:02:12" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "10:03:37" , 
"departure_time" : "10:04:12" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "10:04:35" , 
"departure_time" : "10:04:53" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "10:06:18" , 
"departure_time" : "10:06:22" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "10:08:04" , 
"departure_time" : "10:08:50" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "10:10:46" , 
"departure_time" : "10:10:46" , 
"distance_traveled" : 8.135
} ], 
"1224" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "16:02:00" , 
"departure_time" : "16:03:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:05:33" , 
"departure_time" : "16:06:20" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:07:47" , 
"departure_time" : "16:08:20" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:09:33" , 
"departure_time" : "16:10:31" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:11:58" , 
"departure_time" : "16:12:50" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:13:52" , 
"departure_time" : "16:15:15" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:16:23" , 
"departure_time" : "16:17:26" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:17:03" , 
"departure_time" : "16:18:15" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:20:12" , 
"departure_time" : "16:20:34" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "16:22:22" , 
"departure_time" : "16:22:30" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "16:23:08" , 
"departure_time" : "16:23:27" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "16:25:19" , 
"departure_time" : "16:26:59" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "16:28:40" , 
"departure_time" : "16:28:55" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "16:29:15" , 
"departure_time" : "16:29:15" , 
"distance_traveled" : 8.135
} ], 
"1225" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "16:23:00" , 
"departure_time" : "16:24:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:27:10" , 
"departure_time" : "16:27:36" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:28:26" , 
"departure_time" : "16:29:23" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:30:57" , 
"departure_time" : "16:31:59" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:33:02" , 
"departure_time" : "16:34:42" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:35:40" , 
"departure_time" : "16:37:13" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:37:33" , 
"departure_time" : "16:38:29" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:37:56" , 
"departure_time" : "16:39:06" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:41:10" , 
"departure_time" : "16:42:11" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "16:44:01" , 
"departure_time" : "16:45:31" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "16:45:30" , 
"departure_time" : "16:46:42" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "16:47:12" , 
"departure_time" : "16:47:58" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "16:48:46" , 
"departure_time" : "16:50:00" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "16:51:14" , 
"departure_time" : "16:51:14" , 
"distance_traveled" : 8.135
} ], 
"1226" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "16:41:00" , 
"departure_time" : "16:43:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:45:20" , 
"departure_time" : "16:46:56" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:47:36" , 
"departure_time" : "16:47:46" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:48:10" , 
"departure_time" : "16:49:44" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:51:34" , 
"departure_time" : "16:51:54" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:52:20" , 
"departure_time" : "16:52:25" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:54:05" , 
"departure_time" : "16:54:59" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:55:54" , 
"departure_time" : "16:55:57" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:58:03" , 
"departure_time" : "16:58:17" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "17:01:14" , 
"departure_time" : "17:01:15" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "17:02:01" , 
"departure_time" : "17:02:43" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "17:04:42" , 
"departure_time" : "17:06:10" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "17:07:28" , 
"departure_time" : "17:08:33" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "17:09:05" , 
"departure_time" : "17:09:05" , 
"distance_traveled" : 8.135
} ], 
"1227" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "17:29:00" , 
"departure_time" : "17:30:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:32:20" , 
"departure_time" : "17:32:25" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:34:05" , 
"departure_time" : "17:34:54" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:36:49" , 
"departure_time" : "17:37:33" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:38:44" , 
"departure_time" : "17:39:47" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:41:03" , 
"departure_time" : "17:42:38" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:43:35" , 
"departure_time" : "17:44:18" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:43:43" , 
"departure_time" : "17:45:13" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:47:30" , 
"departure_time" : "17:48:23" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "17:49:53" , 
"departure_time" : "17:51:21" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "17:51:28" , 
"departure_time" : "17:53:06" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "17:53:38" , 
"departure_time" : "17:55:00" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "17:55:22" , 
"departure_time" : "17:56:25" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "17:57:03" , 
"departure_time" : "17:57:03" , 
"distance_traveled" : 8.135
} ], 
"1228" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "17:50:00" , 
"departure_time" : "17:52:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:54:06" , 
"departure_time" : "17:54:46" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:55:40" , 
"departure_time" : "17:57:07" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:58:27" , 
"departure_time" : "17:59:45" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:00:18" , 
"departure_time" : "18:00:23" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:01:05" , 
"departure_time" : "18:01:06" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:03:01" , 
"departure_time" : "18:04:09" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:05:08" , 
"departure_time" : "18:05:32" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:07:24" , 
"departure_time" : "18:08:16" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "18:10:52" , 
"departure_time" : "18:11:06" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "18:11:14" , 
"departure_time" : "18:12:29" , 
"distance_traveled" : 5.5023
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "18:14:15" , 
"departure_time" : "18:15:38" , 
"distance_traveled" : 6.7125
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "18:16:23" , 
"departure_time" : "18:18:02" , 
"distance_traveled" : 7.2748
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "18:18:39" , 
"departure_time" : "18:18:39" , 
"distance_traveled" : 8.135
} ], 
"1229" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "07:12:00" , 
"departure_time" : "07:14:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:15:57" , 
"departure_time" : "07:17:14" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:18:17" , 
"departure_time" : "07:18:40" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:19:23" , 
"departure_time" : "07:20:28" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:22:05" , 
"departure_time" : "07:22:10" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:23:05" , 
"departure_time" : "07:24:34" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:26:29" , 
"departure_time" : "07:27:24" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:26:55" , 
"departure_time" : "07:27:20" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:29:25" , 
"departure_time" : "07:30:10" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "07:32:45" , 
"departure_time" : "07:34:21" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "07:34:36" , 
"departure_time" : "07:34:36" , 
"distance_traveled" : 5.5023
} ], 
"1230" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "07:59:00" , 
"departure_time" : "08:01:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:02:58" , 
"departure_time" : "08:03:20" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:04:22" , 
"departure_time" : "08:05:10" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:06:48" , 
"departure_time" : "08:07:32" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:08:44" , 
"departure_time" : "08:09:27" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:10:43" , 
"departure_time" : "08:11:05" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:12:22" , 
"departure_time" : "08:13:44" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:14:22" , 
"departure_time" : "08:15:27" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:17:05" , 
"departure_time" : "08:17:41" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "08:19:36" , 
"departure_time" : "08:20:04" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "08:20:28" , 
"departure_time" : "08:20:28" , 
"distance_traveled" : 5.5023
} ], 
"1231" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "17:10:00" , 
"departure_time" : "17:11:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:13:49" , 
"departure_time" : "17:14:46" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:15:57" , 
"departure_time" : "17:16:51" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:17:54" , 
"departure_time" : "17:19:30" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:20:36" , 
"departure_time" : "17:22:08" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:22:32" , 
"departure_time" : "17:22:49" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:23:17" , 
"departure_time" : "17:24:44" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:25:27" , 
"departure_time" : "17:26:11" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:27:44" , 
"departure_time" : "17:29:22" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "17:31:38" , 
"departure_time" : "17:32:39" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "17:32:01" , 
"departure_time" : "17:32:01" , 
"distance_traveled" : 5.5023
} ], 
"1232" :  [ 
{ 
"stop_id" : 39348,
"arrival_time" : "18:36:00" , 
"departure_time" : "18:38:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:40:32" , 
"departure_time" : "18:41:57" , 
"distance_traveled" : 0.8826
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:42:25" , 
"departure_time" : "18:42:43" , 
"distance_traveled" : 1.1756
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:43:18" , 
"departure_time" : "18:43:51" , 
"distance_traveled" : 1.5225
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:45:33" , 
"departure_time" : "18:46:01" , 
"distance_traveled" : 1.7716
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:47:28" , 
"departure_time" : "18:48:03" , 
"distance_traveled" : 2.0661
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:49:35" , 
"departure_time" : "18:50:01" , 
"distance_traveled" : 2.4739
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:50:26" , 
"departure_time" : "18:50:33" , 
"distance_traveled" : 2.7513
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:53:07" , 
"departure_time" : "18:53:24" , 
"distance_traveled" : 3.4326
}, 
{ 
"stop_id" : 37002,
"arrival_time" : "18:56:17" , 
"departure_time" : "18:57:14" , 
"distance_traveled" : 4.8544
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "18:57:57" , 
"departure_time" : "18:57:57" , 
"distance_traveled" : 5.5023
} ], 
"1233" :  [ 
{ 
"stop_id" : 37002,
"arrival_time" : "05:08:00" , 
"departure_time" : "05:09:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "05:09:20" , 
"departure_time" : "05:09:49" , 
"distance_traveled" : 0.6504
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "05:11:29" , 
"departure_time" : "05:11:46" , 
"distance_traveled" : 1.8606
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "05:13:17" , 
"departure_time" : "05:13:32" , 
"distance_traveled" : 2.4229
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "05:15:15" , 
"departure_time" : "05:16:51" , 
"distance_traveled" : 3.2831
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "05:19:36" , 
"departure_time" : "05:19:36" , 
"distance_traveled" : 4.185
} ], 
"1234" :  [ 
{ 
"stop_id" : 37002,
"arrival_time" : "05:36:00" , 
"departure_time" : "05:39:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "05:38:30" , 
"departure_time" : "05:38:53" , 
"distance_traveled" : 0.6504
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "05:39:23" , 
"departure_time" : "05:40:56" , 
"distance_traveled" : 1.8606
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "05:42:33" , 
"departure_time" : "05:43:57" , 
"distance_traveled" : 2.4229
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "05:44:24" , 
"departure_time" : "05:45:10" , 
"distance_traveled" : 3.2831
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "05:46:46" , 
"departure_time" : "05:46:46" , 
"distance_traveled" : 4.185
} ], 
"1235" :  [ 
{ 
"stop_id" : 37002,
"arrival_time" : "06:32:00" , 
"departure_time" : "06:34:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "06:34:24" , 
"departure_time" : "06:35:09" , 
"distance_traveled" : 0.6504
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "06:35:45" , 
"departure_time" : "06:36:02" , 
"distance_traveled" : 1.8606
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "06:37:17" , 
"departure_time" : "06:38:55" , 
"distance_traveled" : 2.4229
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "06:40:38" , 
"departure_time" : "06:42:08" , 
"distance_traveled" : 3.2831
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "06:43:30" , 
"departure_time" : "06:43:30" , 
"distance_traveled" : 4.185
} ], 
"1236" :  [ 
{ 
"stop_id" : 37002,
"arrival_time" : "06:57:00" , 
"departure_time" : "07:00:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "06:59:34" , 
"departure_time" : "07:00:01" , 
"distance_traveled" : 0.6504
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "07:00:27" , 
"departure_time" : "07:01:57" , 
"distance_traveled" : 1.8606
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "07:03:30" , 
"departure_time" : "07:03:41" , 
"distance_traveled" : 2.4229
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "07:04:11" , 
"departure_time" : "07:05:51" , 
"distance_traveled" : 3.2831
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "07:08:40" , 
"departure_time" : "07:08:40" , 
"distance_traveled" : 4.185
} ], 
"1237" :  [ 
{ 
"stop_id" : 37002,
"arrival_time" : "07:34:00" , 
"departure_time" : "07:37:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "07:36:24" , 
"departure_time" : "07:37:43" , 
"distance_traveled" : 0.6504
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "07:38:19" , 
"departure_time" : "07:38:33" , 
"distance_traveled" : 1.8606
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "07:39:14" , 
"departure_time" : "07:39:44" , 
"distance_traveled" : 2.4229
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "07:41:30" , 
"departure_time" : "07:42:12" , 
"distance_traveled" : 3.2831
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "07:44:42" , 
"departure_time" : "07:44:42" , 
"distance_traveled" : 4.185
} ], 
"1238" :  [ 
{ 
"stop_id" : 37002,
"arrival_time" : "14:50:00" , 
"departure_time" : "14:51:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "14:52:16" , 
"departure_time" : "14:52:55" , 
"distance_traveled" : 0.6504
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "14:53:39" , 
"departure_time" : "14:54:03" , 
"distance_traveled" : 1.8606
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "14:55:24" , 
"departure_time" : "14:55:47" , 
"distance_traveled" : 2.4229
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "14:57:23" , 
"departure_time" : "14:59:01" , 
"distance_traveled" : 3.2831
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "15:01:38" , 
"departure_time" : "15:01:38" , 
"distance_traveled" : 4.185
} ], 
"1239" :  [ 
{ 
"stop_id" : 37002,
"arrival_time" : "15:17:00" , 
"departure_time" : "15:20:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "15:19:38" , 
"departure_time" : "15:20:28" , 
"distance_traveled" : 0.6504
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "15:20:50" , 
"departure_time" : "15:22:12" , 
"distance_traveled" : 1.8606
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "15:23:22" , 
"departure_time" : "15:24:59" , 
"distance_traveled" : 2.4229
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "15:25:37" , 
"departure_time" : "15:26:51" , 
"distance_traveled" : 3.2831
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "15:28:14" , 
"departure_time" : "15:28:14" , 
"distance_traveled" : 4.185
} ], 
"1240" :  [ 
{ 
"stop_id" : 37002,
"arrival_time" : "15:35:00" , 
"departure_time" : "15:37:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "15:37:32" , 
"departure_time" : "15:38:29" , 
"distance_traveled" : 0.6504
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "15:38:57" , 
"departure_time" : "15:39:02" , 
"distance_traveled" : 1.8606
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "15:40:05" , 
"departure_time" : "15:40:09" , 
"distance_traveled" : 2.4229
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "15:42:04" , 
"departure_time" : "15:43:01" , 
"distance_traveled" : 3.2831
}, 
{ 
"stop_id" : 42673,
"arrival_time" : "15:45:57" , 
"departure_time" : "15:45:57" , 
"distance_traveled" : 4.185
} ], 
"1241" :  [ 
{ 
"stop_id" : 37002,
"arrival_time" : "16:30:00" , 
"departure_time" : "16:31:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37003,
"arrival_time" : "16:31:12" , 
"departure_time" : "16:31:45" , 
"distance_traveled" : 0.6504
}, 
{ 
"stop_id" : 37004,
"arrival_time" : "16:33:33" , 
"departure_time" : "16:34:25" , 
"distance_traveled" : 1.8606
}, 
{ 
"stop_id" : 37005,
"arrival_time" : "16:35:52" , 
"departure_time" : "16:37:04" , 
"distance_traveled" : 2.4229
}, 
{ 
"stop_id" : 38229,
"arrival_time" : "16:38:12" , 
"departure_time" : "16:38:12" , 
"distance_traveled" : 3.2831
} ], 
"1242" :  [ 
{ 
"stop_id" : 36999,
"arrival_time" : "04:57:00" , 
"departure_time" : "04:59:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "04:59:49" , 
"departure_time" : "05:00:53" , 
"distance_traveled" : 0.3424
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "05:02:04" , 
"departure_time" : "05:02:04" , 
"distance_traveled" : 0.9097
} ], 
"1243" :  [ 
{ 
"stop_id" : 36999,
"arrival_time" : "05:11:00" , 
"departure_time" : "05:12:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "05:13:31" , 
"departure_time" : "05:14:59" , 
"distance_traveled" : 0.3424
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "05:16:28" , 
"departure_time" : "05:16:28" , 
"distance_traveled" : 0.9097
} ], 
"1244" :  [ 
{ 
"stop_id" : 36999,
"arrival_time" : "06:06:00" , 
"departure_time" : "06:08:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "06:08:36" , 
"departure_time" : "06:08:40" , 
"distance_traveled" : 0.3424
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "06:10:04" , 
"departure_time" : "06:10:04" , 
"distance_traveled" : 0.9097
} ], 
"1245" :  [ 
{ 
"stop_id" : 36999,
"arrival_time" : "07:16:00" , 
"departure_time" : "07:17:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "07:19:21" , 
"departure_time" : "07:20:54" , 
"distance_traveled" : 0.3424
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "07:21:33" , 
"departure_time" : "07:21:33" , 
"distance_traveled" : 0.9097
} ], 
"1246" :  [ 
{ 
"stop_id" : 36999,
"arrival_time" : "15:18:00" , 
"departure_time" : "15:20:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "15:20:43" , 
"departure_time" : "15:21:43" , 
"distance_traveled" : 0.3424
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "15:23:00" , 
"departure_time" : "15:23:00" , 
"distance_traveled" : 0.9097
} ], 
"1247" :  [ 
{ 
"stop_id" : 36999,
"arrival_time" : "15:40:00" , 
"departure_time" : "15:42:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "15:43:04" , 
"departure_time" : "15:43:17" , 
"distance_traveled" : 0.3424
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "15:44:13" , 
"departure_time" : "15:44:13" , 
"distance_traveled" : 0.9097
} ], 
"1248" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "05:05:00" , 
"departure_time" : "05:05:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "05:07:10" , 
"departure_time" : "05:08:27" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "05:10:17" , 
"departure_time" : "05:11:56" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "05:13:39" , 
"departure_time" : "05:15:18" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "05:16:39" , 
"departure_time" : "05:16:42" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "05:16:03" , 
"departure_time" : "05:16:13" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "05:21:10" , 
"departure_time" : "05:22:33" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "05:24:23" , 
"departure_time" : "05:24:35" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "05:25:12" , 
"departure_time" : "05:25:51" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "05:27:39" , 
"departure_time" : "05:27:47" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "05:29:08" , 
"departure_time" : "05:29:38" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "05:31:30" , 
"departure_time" : "05:31:52" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "05:32:22" , 
"departure_time" : "05:32:46" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "05:35:24" , 
"departure_time" : "05:35:49" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "05:38:25" , 
"departure_time" : "05:38:41" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "05:40:16" , 
"departure_time" : "05:40:37" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "05:42:21" , 
"departure_time" : "05:42:21" , 
"distance_traveled" : 10.0589
} ], 
"1249" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "05:19:00" , 
"departure_time" : "05:19:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "05:21:31" , 
"departure_time" : "05:22:20" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "05:23:49" , 
"departure_time" : "05:24:00" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "05:26:11" , 
"departure_time" : "05:26:58" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "05:29:47" , 
"departure_time" : "05:31:10" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "05:31:23" , 
"departure_time" : "05:31:29" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "05:35:06" , 
"departure_time" : "05:35:17" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "05:37:11" , 
"departure_time" : "05:38:22" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "05:40:11" , 
"departure_time" : "05:41:49" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "05:42:38" , 
"departure_time" : "05:43:22" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "05:43:44" , 
"departure_time" : "05:44:26" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "05:45:42" , 
"departure_time" : "05:47:02" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "05:47:20" , 
"departure_time" : "05:48:56" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "05:50:36" , 
"departure_time" : "05:51:48" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "05:53:12" , 
"departure_time" : "05:54:29" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "05:55:17" , 
"departure_time" : "05:56:19" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "05:57:02" , 
"departure_time" : "05:57:02" , 
"distance_traveled" : 10.0589
} ], 
"1250" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "05:36:00" , 
"departure_time" : "05:38:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "05:39:02" , 
"departure_time" : "05:40:37" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "05:41:35" , 
"departure_time" : "05:41:46" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "05:43:11" , 
"departure_time" : "05:44:09" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "05:46:58" , 
"departure_time" : "05:47:21" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "05:47:23" , 
"departure_time" : "05:48:18" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "05:52:55" , 
"departure_time" : "05:53:34" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "05:54:39" , 
"departure_time" : "05:54:43" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "05:56:04" , 
"departure_time" : "05:56:31" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "05:58:27" , 
"departure_time" : "05:58:34" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:00:07" , 
"departure_time" : "06:00:14" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:02:07" , 
"departure_time" : "06:03:45" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:04:38" , 
"departure_time" : "06:05:16" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:06:38" , 
"departure_time" : "06:07:19" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "06:09:41" , 
"departure_time" : "06:10:26" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "06:11:45" , 
"departure_time" : "06:13:14" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "06:14:29" , 
"departure_time" : "06:14:29" , 
"distance_traveled" : 10.0589
} ], 
"1251" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "05:50:00" , 
"departure_time" : "05:53:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "05:53:40" , 
"departure_time" : "05:54:59" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "05:55:19" , 
"departure_time" : "05:55:42" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "05:57:23" , 
"departure_time" : "05:58:47" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "06:01:24" , 
"departure_time" : "06:02:16" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "06:01:52" , 
"departure_time" : "06:02:23" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:06:31" , 
"departure_time" : "06:06:39" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:08:08" , 
"departure_time" : "06:09:42" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:11:34" , 
"departure_time" : "06:12:04" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:12:30" , 
"departure_time" : "06:12:47" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:14:17" , 
"departure_time" : "06:15:39" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:17:22" , 
"departure_time" : "06:19:01" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:18:39" , 
"departure_time" : "06:19:34" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:20:55" , 
"departure_time" : "06:21:23" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "06:23:28" , 
"departure_time" : "06:23:55" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "06:25:27" , 
"departure_time" : "06:26:13" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "06:27:46" , 
"departure_time" : "06:27:46" , 
"distance_traveled" : 10.0589
} ], 
"1252" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "06:04:00" , 
"departure_time" : "06:05:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "06:06:41" , 
"departure_time" : "06:07:00" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "06:08:19" , 
"departure_time" : "06:08:47" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "06:11:28" , 
"departure_time" : "06:12:29" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "06:15:01" , 
"departure_time" : "06:15:26" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "06:15:25" , 
"departure_time" : "06:16:10" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:20:45" , 
"departure_time" : "06:22:03" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:23:18" , 
"departure_time" : "06:23:46" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:24:28" , 
"departure_time" : "06:25:12" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:26:44" , 
"departure_time" : "06:27:58" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:29:14" , 
"departure_time" : "06:30:11" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:30:57" , 
"departure_time" : "06:32:25" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:32:28" , 
"departure_time" : "06:33:37" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:35:09" , 
"departure_time" : "06:35:44" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "06:37:35" , 
"departure_time" : "06:38:13" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "06:39:38" , 
"departure_time" : "06:40:31" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "06:41:53" , 
"departure_time" : "06:41:53" , 
"distance_traveled" : 10.0589
} ], 
"1253" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "06:13:00" , 
"departure_time" : "06:14:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "06:15:45" , 
"departure_time" : "06:16:13" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "06:17:28" , 
"departure_time" : "06:18:28" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "06:21:00" , 
"departure_time" : "06:22:24" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "06:24:24" , 
"departure_time" : "06:25:11" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "06:24:47" , 
"departure_time" : "06:26:00" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:30:13" , 
"departure_time" : "06:30:24" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:31:11" , 
"departure_time" : "06:31:45" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:33:34" , 
"departure_time" : "06:35:10" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:36:36" , 
"departure_time" : "06:37:22" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:37:46" , 
"departure_time" : "06:39:15" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:40:29" , 
"departure_time" : "06:41:47" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:41:18" , 
"departure_time" : "06:42:27" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:44:09" , 
"departure_time" : "06:45:17" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "06:47:08" , 
"departure_time" : "06:48:13" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "06:49:05" , 
"departure_time" : "06:49:06" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "06:50:01" , 
"departure_time" : "06:50:01" , 
"distance_traveled" : 10.0589
} ], 
"1254" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "06:26:00" , 
"departure_time" : "06:26:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "06:28:55" , 
"departure_time" : "06:29:04" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "06:30:09" , 
"departure_time" : "06:31:29" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "06:34:20" , 
"departure_time" : "06:34:57" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "06:36:37" , 
"departure_time" : "06:36:49" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "06:37:12" , 
"departure_time" : "06:38:50" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:43:38" , 
"departure_time" : "06:43:50" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:44:12" , 
"departure_time" : "06:45:28" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:47:16" , 
"departure_time" : "06:48:24" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:49:08" , 
"departure_time" : "06:49:18" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "06:50:10" , 
"departure_time" : "06:50:32" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "06:52:22" , 
"departure_time" : "06:52:26" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "06:53:04" , 
"departure_time" : "06:54:03" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "06:56:59" , 
"departure_time" : "06:58:31" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "07:00:32" , 
"departure_time" : "07:00:35" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "07:01:03" , 
"departure_time" : "07:01:57" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "07:03:54" , 
"departure_time" : "07:03:54" , 
"distance_traveled" : 10.0589
} ], 
"1255" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "06:36:00" , 
"departure_time" : "06:36:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "06:38:02" , 
"departure_time" : "06:38:29" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "06:40:27" , 
"departure_time" : "06:41:29" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "06:44:02" , 
"departure_time" : "06:44:27" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "06:46:25" , 
"departure_time" : "06:47:39" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "06:48:14" , 
"departure_time" : "06:49:04" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "06:52:50" , 
"departure_time" : "06:53:23" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "06:54:33" , 
"departure_time" : "06:55:03" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "06:56:30" , 
"departure_time" : "06:57:29" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "06:58:59" , 
"departure_time" : "07:00:19" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:01:20" , 
"departure_time" : "07:01:29" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:02:09" , 
"departure_time" : "07:02:52" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:03:43" , 
"departure_time" : "07:05:15" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:07:32" , 
"departure_time" : "07:08:52" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "07:10:20" , 
"departure_time" : "07:10:27" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "07:11:07" , 
"departure_time" : "07:11:28" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "07:13:21" , 
"departure_time" : "07:13:21" , 
"distance_traveled" : 10.0589
} ], 
"1256" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "06:48:00" , 
"departure_time" : "06:50:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "06:51:39" , 
"departure_time" : "06:52:20" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "06:52:41" , 
"departure_time" : "06:53:58" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "06:56:17" , 
"departure_time" : "06:57:17" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "06:59:00" , 
"departure_time" : "07:00:00" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:00:00" , 
"departure_time" : "07:01:16" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:05:16" , 
"departure_time" : "07:05:44" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:06:28" , 
"departure_time" : "07:08:08" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:09:40" , 
"departure_time" : "07:10:00" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:10:20" , 
"departure_time" : "07:11:54" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:13:34" , 
"departure_time" : "07:15:14" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:15:40" , 
"departure_time" : "07:15:52" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:15:12" , 
"departure_time" : "07:16:47" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:19:35" , 
"departure_time" : "07:20:06" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "07:21:31" , 
"departure_time" : "07:22:03" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "07:23:32" , 
"departure_time" : "07:24:44" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "07:26:12" , 
"departure_time" : "07:26:12" , 
"distance_traveled" : 10.0589
} ], 
"1257" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "07:02:00" , 
"departure_time" : "07:03:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:04:26" , 
"departure_time" : "07:05:09" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "07:06:43" , 
"departure_time" : "07:07:38" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "07:09:55" , 
"departure_time" : "07:09:56" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "07:12:01" , 
"departure_time" : "07:13:02" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:14:01" , 
"departure_time" : "07:14:28" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:18:27" , 
"departure_time" : "07:19:15" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:20:48" , 
"departure_time" : "07:21:04" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:22:16" , 
"departure_time" : "07:23:46" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:25:30" , 
"departure_time" : "07:26:31" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:27:01" , 
"departure_time" : "07:28:22" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:29:21" , 
"departure_time" : "07:30:37" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:30:16" , 
"departure_time" : "07:30:45" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:32:29" , 
"departure_time" : "07:33:40" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "07:36:11" , 
"departure_time" : "07:37:07" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "07:37:56" , 
"departure_time" : "07:38:34" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "07:39:38" , 
"departure_time" : "07:39:38" , 
"distance_traveled" : 10.0589
} ], 
"1258" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "07:12:00" , 
"departure_time" : "07:14:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:15:40" , 
"departure_time" : "07:16:16" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "07:16:36" , 
"departure_time" : "07:18:11" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "07:20:35" , 
"departure_time" : "07:21:47" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "07:23:12" , 
"departure_time" : "07:23:54" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:23:42" , 
"departure_time" : "07:24:44" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:29:02" , 
"departure_time" : "07:29:33" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:30:31" , 
"departure_time" : "07:30:48" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:32:17" , 
"departure_time" : "07:33:41" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:35:24" , 
"departure_time" : "07:36:24" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:37:00" , 
"departure_time" : "07:38:22" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:39:22" , 
"departure_time" : "07:40:42" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:40:20" , 
"departure_time" : "07:41:48" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:43:28" , 
"departure_time" : "07:43:51" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "07:45:23" , 
"departure_time" : "07:45:38" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "07:47:15" , 
"departure_time" : "07:48:28" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "07:50:13" , 
"departure_time" : "07:50:13" , 
"distance_traveled" : 10.0589
} ], 
"1259" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "07:25:00" , 
"departure_time" : "07:26:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:27:35" , 
"departure_time" : "07:28:05" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "07:29:30" , 
"departure_time" : "07:30:52" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "07:33:22" , 
"departure_time" : "07:34:00" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "07:35:38" , 
"departure_time" : "07:36:52" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:37:14" , 
"departure_time" : "07:38:53" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:42:39" , 
"departure_time" : "07:42:46" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:43:07" , 
"departure_time" : "07:43:16" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:45:09" , 
"departure_time" : "07:46:29" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:48:20" , 
"departure_time" : "07:48:36" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "07:49:16" , 
"departure_time" : "07:50:08" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "07:51:52" , 
"departure_time" : "07:52:56" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "07:53:04" , 
"departure_time" : "07:54:13" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "07:56:09" , 
"departure_time" : "07:57:11" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "07:59:02" , 
"departure_time" : "08:00:28" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "08:01:26" , 
"departure_time" : "08:02:23" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "08:02:57" , 
"departure_time" : "08:02:57" , 
"distance_traveled" : 10.0589
} ], 
"1260" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "07:37:00" , 
"departure_time" : "07:38:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:39:51" , 
"departure_time" : "07:40:00" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "07:41:09" , 
"departure_time" : "07:41:19" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "07:44:10" , 
"departure_time" : "07:44:52" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "07:47:42" , 
"departure_time" : "07:49:07" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:49:25" , 
"departure_time" : "07:50:50" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "07:54:25" , 
"departure_time" : "07:55:18" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "07:55:53" , 
"departure_time" : "07:56:30" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "07:57:37" , 
"departure_time" : "07:58:27" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "07:59:50" , 
"departure_time" : "08:00:46" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:01:56" , 
"departure_time" : "08:02:01" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:03:05" , 
"departure_time" : "08:03:07" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:04:02" , 
"departure_time" : "08:05:20" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:08:18" , 
"departure_time" : "08:09:08" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "08:10:50" , 
"departure_time" : "08:11:38" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "08:12:48" , 
"departure_time" : "08:13:54" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "08:15:06" , 
"departure_time" : "08:15:06" , 
"distance_traveled" : 10.0589
} ], 
"1261" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "07:44:00" , 
"departure_time" : "07:45:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:46:46" , 
"departure_time" : "07:48:08" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "07:49:22" , 
"departure_time" : "07:50:51" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "07:52:29" , 
"departure_time" : "07:52:52" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "07:54:23" , 
"departure_time" : "07:55:25" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "07:56:02" , 
"departure_time" : "07:57:28" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:01:26" , 
"departure_time" : "08:01:41" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:02:15" , 
"departure_time" : "08:03:19" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:05:04" , 
"departure_time" : "08:05:44" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:06:40" , 
"departure_time" : "08:07:22" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:08:42" , 
"departure_time" : "08:10:13" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:11:31" , 
"departure_time" : "08:11:58" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:11:27" , 
"departure_time" : "08:12:25" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:14:58" , 
"departure_time" : "08:15:51" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "08:17:53" , 
"departure_time" : "08:19:21" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "08:20:28" , 
"departure_time" : "08:20:41" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "08:21:13" , 
"departure_time" : "08:21:13" , 
"distance_traveled" : 10.0589
} ], 
"1262" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "07:56:00" , 
"departure_time" : "07:57:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "07:58:55" , 
"departure_time" : "07:59:43" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:00:48" , 
"departure_time" : "08:02:01" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:04:13" , 
"departure_time" : "08:05:04" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:06:51" , 
"departure_time" : "08:08:08" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:08:17" , 
"departure_time" : "08:09:12" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:12:55" , 
"departure_time" : "08:14:07" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:15:12" , 
"departure_time" : "08:15:38" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:16:26" , 
"departure_time" : "08:17:53" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:19:27" , 
"departure_time" : "08:19:52" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:20:25" , 
"departure_time" : "08:21:31" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:23:06" , 
"departure_time" : "08:24:17" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:24:11" , 
"departure_time" : "08:24:26" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:26:15" , 
"departure_time" : "08:27:54" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "08:30:39" , 
"departure_time" : "08:31:43" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "08:32:04" , 
"departure_time" : "08:33:05" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "08:34:01" , 
"departure_time" : "08:34:01" , 
"distance_traveled" : 10.0589
} ], 
"1263" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "08:02:00" , 
"departure_time" : "08:04:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:05:20" , 
"departure_time" : "08:06:53" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:07:33" , 
"departure_time" : "08:08:43" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:10:10" , 
"departure_time" : "08:11:12" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:13:02" , 
"departure_time" : "08:13:22" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:13:20" , 
"departure_time" : "08:13:33" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:18:13" , 
"departure_time" : "08:19:38" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:21:25" , 
"departure_time" : "08:22:43" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:23:18" , 
"departure_time" : "08:23:40" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:24:22" , 
"departure_time" : "08:25:25" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:27:03" , 
"departure_time" : "08:27:29" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:28:26" , 
"departure_time" : "08:29:51" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:30:25" , 
"departure_time" : "08:31:29" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:33:04" , 
"departure_time" : "08:33:30" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "08:35:26" , 
"departure_time" : "08:36:33" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "08:38:07" , 
"departure_time" : "08:38:37" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "08:39:30" , 
"departure_time" : "08:39:30" , 
"distance_traveled" : 10.0589
} ], 
"1264" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "08:14:00" , 
"departure_time" : "08:14:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:16:14" , 
"departure_time" : "08:16:18" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:18:04" , 
"departure_time" : "08:18:30" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:21:26" , 
"departure_time" : "08:22:22" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:24:56" , 
"departure_time" : "08:26:12" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:26:16" , 
"departure_time" : "08:26:33" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:30:17" , 
"departure_time" : "08:31:56" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:33:39" , 
"departure_time" : "08:33:50" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:34:11" , 
"departure_time" : "08:34:41" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:36:30" , 
"departure_time" : "08:37:28" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:38:58" , 
"departure_time" : "08:40:23" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:41:25" , 
"departure_time" : "08:42:04" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:41:39" , 
"departure_time" : "08:42:10" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:44:31" , 
"departure_time" : "08:45:44" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "08:48:13" , 
"departure_time" : "08:49:34" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "08:50:21" , 
"departure_time" : "08:51:31" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "08:52:10" , 
"departure_time" : "08:52:10" , 
"distance_traveled" : 10.0589
} ], 
"1265" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "08:22:00" , 
"departure_time" : "08:24:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:24:55" , 
"departure_time" : "08:26:02" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:27:07" , 
"departure_time" : "08:27:24" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:29:17" , 
"departure_time" : "08:29:50" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:32:33" , 
"departure_time" : "08:33:10" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:33:37" , 
"departure_time" : "08:34:18" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:38:41" , 
"departure_time" : "08:38:54" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:40:13" , 
"departure_time" : "08:41:05" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:42:52" , 
"departure_time" : "08:44:16" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:45:24" , 
"departure_time" : "08:46:08" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:46:44" , 
"departure_time" : "08:48:07" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:49:23" , 
"departure_time" : "08:49:55" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:49:32" , 
"departure_time" : "08:50:32" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "08:53:00" , 
"departure_time" : "08:54:35" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "08:56:35" , 
"departure_time" : "08:56:45" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "08:57:10" , 
"departure_time" : "08:58:16" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "09:00:06" , 
"departure_time" : "09:00:06" , 
"distance_traveled" : 10.0589
} ], 
"1266" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "08:30:00" , 
"departure_time" : "08:31:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:32:30" , 
"departure_time" : "08:33:15" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:34:45" , 
"departure_time" : "08:34:46" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:37:01" , 
"departure_time" : "08:38:35" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:41:34" , 
"departure_time" : "08:42:05" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:41:31" , 
"departure_time" : "08:42:12" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:46:41" , 
"departure_time" : "08:48:19" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "08:49:38" , 
"departure_time" : "08:49:52" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "08:50:14" , 
"departure_time" : "08:51:18" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "08:53:04" , 
"departure_time" : "08:53:54" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "08:54:50" , 
"departure_time" : "08:55:23" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "08:56:33" , 
"departure_time" : "08:56:49" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "08:57:16" , 
"departure_time" : "08:58:17" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:01:01" , 
"departure_time" : "09:01:35" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "09:03:34" , 
"departure_time" : "09:04:48" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "09:06:14" , 
"departure_time" : "09:06:54" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "09:07:40" , 
"departure_time" : "09:07:40" , 
"distance_traveled" : 10.0589
} ], 
"1267" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "08:41:00" , 
"departure_time" : "08:41:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:43:12" , 
"departure_time" : "08:44:15" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:46:03" , 
"departure_time" : "08:46:36" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "08:48:33" , 
"departure_time" : "08:48:51" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "08:51:18" , 
"departure_time" : "08:51:44" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "08:52:26" , 
"departure_time" : "08:53:12" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "08:57:46" , 
"departure_time" : "08:59:23" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:00:37" , 
"departure_time" : "09:01:15" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:01:38" , 
"departure_time" : "09:02:13" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:03:35" , 
"departure_time" : "09:05:10" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:06:35" , 
"departure_time" : "09:07:56" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:08:21" , 
"departure_time" : "09:09:16" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:08:55" , 
"departure_time" : "09:09:18" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:11:23" , 
"departure_time" : "09:12:25" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "09:15:02" , 
"departure_time" : "09:15:05" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "09:16:03" , 
"departure_time" : "09:16:04" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "09:18:01" , 
"departure_time" : "09:18:01" , 
"distance_traveled" : 10.0589
} ], 
"1268" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "08:53:00" , 
"departure_time" : "08:54:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "08:56:25" , 
"departure_time" : "08:57:28" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "08:58:03" , 
"departure_time" : "08:58:16" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "09:00:13" , 
"departure_time" : "09:00:21" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:03:08" , 
"departure_time" : "09:04:15" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "09:05:07" , 
"departure_time" : "09:05:34" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:09:27" , 
"departure_time" : "09:11:03" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:12:36" , 
"departure_time" : "09:13:19" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:13:43" , 
"departure_time" : "09:14:40" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:15:57" , 
"departure_time" : "09:16:19" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:17:22" , 
"departure_time" : "09:17:48" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:19:26" , 
"departure_time" : "09:19:55" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:20:29" , 
"departure_time" : "09:21:13" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:23:44" , 
"departure_time" : "09:24:45" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "09:27:01" , 
"departure_time" : "09:28:23" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "09:29:22" , 
"departure_time" : "09:30:35" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "09:31:13" , 
"departure_time" : "09:31:13" , 
"distance_traveled" : 10.0589
} ], 
"1269" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "09:01:00" , 
"departure_time" : "09:03:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "09:04:14" , 
"departure_time" : "09:05:05" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "09:05:51" , 
"departure_time" : "09:07:01" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "09:09:10" , 
"departure_time" : "09:09:36" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:11:26" , 
"departure_time" : "09:11:43" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "09:12:17" , 
"departure_time" : "09:13:10" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:17:53" , 
"departure_time" : "09:18:06" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:19:13" , 
"departure_time" : "09:19:17" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:21:04" , 
"departure_time" : "09:21:17" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:23:13" , 
"departure_time" : "09:24:08" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:25:55" , 
"departure_time" : "09:26:12" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:27:17" , 
"departure_time" : "09:28:03" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:28:46" , 
"departure_time" : "09:29:14" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:31:28" , 
"departure_time" : "09:31:57" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "09:34:29" , 
"departure_time" : "09:35:39" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "09:37:10" , 
"departure_time" : "09:38:35" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "09:39:25" , 
"departure_time" : "09:39:25" , 
"distance_traveled" : 10.0589
} ], 
"1270" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "09:14:00" , 
"departure_time" : "09:16:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "09:17:11" , 
"departure_time" : "09:18:11" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "09:19:00" , 
"departure_time" : "09:19:05" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "09:21:05" , 
"departure_time" : "09:22:43" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:25:38" , 
"departure_time" : "09:27:15" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "09:26:37" , 
"departure_time" : "09:26:51" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:30:14" , 
"departure_time" : "09:31:02" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:32:48" , 
"departure_time" : "09:32:54" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:34:06" , 
"departure_time" : "09:35:40" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:37:34" , 
"departure_time" : "09:37:35" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:38:01" , 
"departure_time" : "09:39:06" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:41:05" , 
"departure_time" : "09:42:36" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:42:31" , 
"departure_time" : "09:44:07" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:45:36" , 
"departure_time" : "09:46:25" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "09:47:49" , 
"departure_time" : "09:49:24" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "09:50:35" , 
"departure_time" : "09:50:59" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "09:51:24" , 
"departure_time" : "09:51:24" , 
"distance_traveled" : 10.0589
} ], 
"1271" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "09:24:00" , 
"departure_time" : "09:25:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "09:27:00" , 
"departure_time" : "09:27:47" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "09:28:47" , 
"departure_time" : "09:29:02" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "09:31:15" , 
"departure_time" : "09:32:07" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:34:52" , 
"departure_time" : "09:36:32" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "09:36:40" , 
"departure_time" : "09:36:53" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:40:13" , 
"departure_time" : "09:40:51" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:42:38" , 
"departure_time" : "09:43:53" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:45:15" , 
"departure_time" : "09:45:16" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:46:01" , 
"departure_time" : "09:46:47" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:48:46" , 
"departure_time" : "09:50:04" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "09:51:18" , 
"departure_time" : "09:52:23" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "09:52:05" , 
"departure_time" : "09:52:25" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "09:54:20" , 
"departure_time" : "09:55:58" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "09:58:38" , 
"departure_time" : "09:59:41" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "10:00:03" , 
"departure_time" : "10:00:09" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "10:01:06" , 
"departure_time" : "10:01:06" , 
"distance_traveled" : 10.0589
} ], 
"1272" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "09:34:00" , 
"departure_time" : "09:35:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "09:36:56" , 
"departure_time" : "09:38:28" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "09:39:32" , 
"departure_time" : "09:39:56" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "09:41:24" , 
"departure_time" : "09:41:35" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "09:44:11" , 
"departure_time" : "09:44:17" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "09:45:06" , 
"departure_time" : "09:45:45" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "09:50:39" , 
"departure_time" : "09:50:54" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "09:52:15" , 
"departure_time" : "09:53:23" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "09:55:08" , 
"departure_time" : "09:55:26" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "09:56:18" , 
"departure_time" : "09:56:47" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "09:58:29" , 
"departure_time" : "09:59:43" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:01:14" , 
"departure_time" : "10:01:23" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:01:09" , 
"departure_time" : "10:01:26" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:04:17" , 
"departure_time" : "10:05:32" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "10:08:15" , 
"departure_time" : "10:08:21" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "10:09:06" , 
"departure_time" : "10:09:26" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "10:11:20" , 
"departure_time" : "10:11:20" , 
"distance_traveled" : 10.0589
} ], 
"1273" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "09:54:00" , 
"departure_time" : "09:54:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "09:56:01" , 
"departure_time" : "09:56:21" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "09:58:20" , 
"departure_time" : "09:59:47" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "10:02:27" , 
"departure_time" : "10:03:32" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "10:05:05" , 
"departure_time" : "10:06:17" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "10:06:12" , 
"departure_time" : "10:07:21" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:11:09" , 
"departure_time" : "10:11:21" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:12:12" , 
"departure_time" : "10:12:49" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:14:37" , 
"departure_time" : "10:15:42" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:17:05" , 
"departure_time" : "10:18:07" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:19:02" , 
"departure_time" : "10:19:34" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:20:32" , 
"departure_time" : "10:21:18" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:21:46" , 
"departure_time" : "10:23:16" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:25:30" , 
"departure_time" : "10:27:06" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "10:28:36" , 
"departure_time" : "10:30:05" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "10:30:29" , 
"departure_time" : "10:32:02" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "10:32:33" , 
"departure_time" : "10:32:33" , 
"distance_traveled" : 10.0589
} ], 
"1274" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "10:14:00" , 
"departure_time" : "10:15:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "10:16:23" , 
"departure_time" : "10:17:26" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "10:19:03" , 
"departure_time" : "10:19:43" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "10:21:40" , 
"departure_time" : "10:22:35" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "10:24:55" , 
"departure_time" : "10:25:35" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "10:25:40" , 
"departure_time" : "10:27:18" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:31:38" , 
"departure_time" : "10:32:39" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:33:01" , 
"departure_time" : "10:34:31" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:35:30" , 
"departure_time" : "10:36:22" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:36:52" , 
"departure_time" : "10:37:18" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:38:26" , 
"departure_time" : "10:39:09" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "10:40:43" , 
"departure_time" : "10:41:51" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "10:42:08" , 
"departure_time" : "10:42:36" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "10:44:28" , 
"departure_time" : "10:45:21" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "10:47:53" , 
"departure_time" : "10:49:10" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "10:50:17" , 
"departure_time" : "10:51:06" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "10:51:49" , 
"departure_time" : "10:51:49" , 
"distance_traveled" : 10.0589
} ], 
"1275" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "10:34:00" , 
"departure_time" : "10:36:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "10:37:24" , 
"departure_time" : "10:38:46" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "10:39:22" , 
"departure_time" : "10:39:41" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "10:41:19" , 
"departure_time" : "10:42:16" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "10:44:57" , 
"departure_time" : "10:45:04" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "10:45:07" , 
"departure_time" : "10:46:19" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "10:51:12" , 
"departure_time" : "10:51:13" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "10:52:01" , 
"departure_time" : "10:52:19" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "10:54:18" , 
"departure_time" : "10:55:36" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "10:57:18" , 
"departure_time" : "10:58:12" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "10:58:54" , 
"departure_time" : "10:59:31" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:00:37" , 
"departure_time" : "11:02:14" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:02:37" , 
"departure_time" : "11:03:15" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:04:38" , 
"departure_time" : "11:05:44" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "11:08:06" , 
"departure_time" : "11:08:26" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "11:09:20" , 
"departure_time" : "11:09:54" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "11:11:34" , 
"departure_time" : "11:11:34" , 
"distance_traveled" : 10.0589
} ], 
"1276" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "10:54:00" , 
"departure_time" : "10:55:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "10:57:05" , 
"departure_time" : "10:58:39" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "10:59:34" , 
"departure_time" : "10:59:39" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "11:01:05" , 
"departure_time" : "11:02:00" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "11:04:55" , 
"departure_time" : "11:05:54" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "11:05:59" , 
"departure_time" : "11:07:09" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:11:10" , 
"departure_time" : "11:11:16" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:12:06" , 
"departure_time" : "11:12:52" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:14:46" , 
"departure_time" : "11:15:35" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:16:49" , 
"departure_time" : "11:17:54" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:19:05" , 
"departure_time" : "11:19:29" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:20:24" , 
"departure_time" : "11:20:36" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:21:12" , 
"departure_time" : "11:21:33" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:24:21" , 
"departure_time" : "11:24:56" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "11:27:35" , 
"departure_time" : "11:29:12" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "11:30:37" , 
"departure_time" : "11:30:58" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "11:31:21" , 
"departure_time" : "11:31:21" , 
"distance_traveled" : 10.0589
} ], 
"1277" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "11:14:00" , 
"departure_time" : "11:15:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "11:17:23" , 
"departure_time" : "11:18:30" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "11:19:07" , 
"departure_time" : "11:19:08" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "11:21:01" , 
"departure_time" : "11:22:27" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "11:25:26" , 
"departure_time" : "11:26:57" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "11:26:31" , 
"departure_time" : "11:28:05" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:31:34" , 
"departure_time" : "11:32:07" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:32:33" , 
"departure_time" : "11:33:34" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:35:01" , 
"departure_time" : "11:36:13" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:37:12" , 
"departure_time" : "11:38:34" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:39:22" , 
"departure_time" : "11:40:53" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "11:41:31" , 
"departure_time" : "11:43:04" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "11:42:33" , 
"departure_time" : "11:44:00" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "11:45:27" , 
"departure_time" : "11:45:28" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "11:47:01" , 
"departure_time" : "11:47:44" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "11:49:43" , 
"departure_time" : "11:49:53" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "11:51:10" , 
"departure_time" : "11:51:10" , 
"distance_traveled" : 10.0589
} ], 
"1278" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "11:34:00" , 
"departure_time" : "11:35:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "11:37:13" , 
"departure_time" : "11:37:44" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "11:38:31" , 
"departure_time" : "11:39:14" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "11:41:43" , 
"departure_time" : "11:43:21" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "11:45:38" , 
"departure_time" : "11:45:39" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "11:45:01" , 
"departure_time" : "11:46:38" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "11:51:37" , 
"departure_time" : "11:52:05" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "11:52:28" , 
"departure_time" : "11:53:37" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "11:55:09" , 
"departure_time" : "11:56:23" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "11:57:14" , 
"departure_time" : "11:57:23" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "11:58:09" , 
"departure_time" : "11:58:31" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:00:22" , 
"departure_time" : "12:01:21" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:01:59" , 
"departure_time" : "12:02:26" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:04:27" , 
"departure_time" : "12:04:46" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "12:07:19" , 
"departure_time" : "12:08:13" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "12:09:54" , 
"departure_time" : "12:11:21" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "12:12:27" , 
"departure_time" : "12:12:27" , 
"distance_traveled" : 10.0589
} ], 
"1279" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "11:54:00" , 
"departure_time" : "11:57:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "11:57:35" , 
"departure_time" : "11:59:03" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "11:59:28" , 
"departure_time" : "12:01:07" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "12:02:39" , 
"departure_time" : "12:04:06" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "12:05:27" , 
"departure_time" : "12:07:07" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "12:06:40" , 
"departure_time" : "12:08:20" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:11:40" , 
"departure_time" : "12:13:20" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:13:40" , 
"departure_time" : "12:15:20" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:15:40" , 
"departure_time" : "12:16:19" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:16:39" , 
"departure_time" : "12:17:31" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:18:52" , 
"departure_time" : "12:19:25" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:20:33" , 
"departure_time" : "12:21:38" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:22:05" , 
"departure_time" : "12:23:06" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:25:01" , 
"departure_time" : "12:26:39" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "12:28:38" , 
"departure_time" : "12:29:20" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "12:29:42" , 
"departure_time" : "12:29:47" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "12:31:05" , 
"departure_time" : "12:31:05" , 
"distance_traveled" : 10.0589
} ], 
"1280" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "12:14:00" , 
"departure_time" : "12:15:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "12:17:39" , 
"departure_time" : "12:18:36" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "12:18:57" , 
"departure_time" : "12:20:09" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "12:22:12" , 
"departure_time" : "12:23:22" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "12:25:10" , 
"departure_time" : "12:25:11" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "12:25:01" , 
"departure_time" : "12:26:12" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:31:11" , 
"departure_time" : "12:32:38" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:33:27" , 
"departure_time" : "12:33:37" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:34:10" , 
"departure_time" : "12:35:47" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:37:37" , 
"departure_time" : "12:38:39" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:39:02" , 
"departure_time" : "12:40:24" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "12:41:22" , 
"departure_time" : "12:42:46" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "12:42:24" , 
"departure_time" : "12:43:24" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "12:45:00" , 
"departure_time" : "12:46:31" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "12:48:31" , 
"departure_time" : "12:50:11" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "12:50:40" , 
"departure_time" : "12:51:46" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "12:52:06" , 
"departure_time" : "12:52:06" , 
"distance_traveled" : 10.0589
} ], 
"1281" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "12:34:00" , 
"departure_time" : "12:35:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "12:36:10" , 
"departure_time" : "12:37:43" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "12:39:33" , 
"departure_time" : "12:40:42" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "12:42:09" , 
"departure_time" : "12:42:28" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "12:44:19" , 
"departure_time" : "12:45:16" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "12:45:57" , 
"departure_time" : "12:47:08" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "12:51:11" , 
"departure_time" : "12:52:39" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "12:53:28" , 
"departure_time" : "12:54:51" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "12:55:23" , 
"departure_time" : "12:55:55" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "12:56:32" , 
"departure_time" : "12:58:07" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "12:59:35" , 
"departure_time" : "13:00:28" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:00:53" , 
"departure_time" : "13:01:39" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:01:46" , 
"departure_time" : "13:02:05" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:04:19" , 
"departure_time" : "13:05:58" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "13:08:39" , 
"departure_time" : "13:09:49" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "13:10:10" , 
"departure_time" : "13:10:22" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "13:11:12" , 
"departure_time" : "13:11:12" , 
"distance_traveled" : 10.0589
} ], 
"1282" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "12:54:00" , 
"departure_time" : "12:55:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "12:57:13" , 
"departure_time" : "12:57:14" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "12:58:01" , 
"departure_time" : "12:59:08" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "13:02:07" , 
"departure_time" : "13:03:01" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "13:04:54" , 
"departure_time" : "13:05:50" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "13:05:56" , 
"departure_time" : "13:07:11" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:11:15" , 
"departure_time" : "13:11:39" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:12:24" , 
"departure_time" : "13:13:59" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:15:35" , 
"departure_time" : "13:16:24" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:16:49" , 
"departure_time" : "13:17:31" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:18:42" , 
"departure_time" : "13:20:18" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:21:36" , 
"departure_time" : "13:22:20" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:21:44" , 
"departure_time" : "13:23:24" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:25:40" , 
"departure_time" : "13:26:39" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "13:27:59" , 
"departure_time" : "13:29:34" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "13:30:35" , 
"departure_time" : "13:31:24" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "13:31:49" , 
"departure_time" : "13:31:49" , 
"distance_traveled" : 10.0589
} ], 
"1283" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "13:14:00" , 
"departure_time" : "13:15:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "13:16:42" , 
"departure_time" : "13:18:14" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "13:19:32" , 
"departure_time" : "13:20:20" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "13:21:48" , 
"departure_time" : "13:23:01" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "13:25:13" , 
"departure_time" : "13:26:02" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "13:25:49" , 
"departure_time" : "13:26:03" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:30:14" , 
"departure_time" : "13:30:20" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:32:06" , 
"departure_time" : "13:33:09" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:35:03" , 
"departure_time" : "13:36:32" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:37:29" , 
"departure_time" : "13:38:34" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:39:05" , 
"departure_time" : "13:40:18" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "13:41:13" , 
"departure_time" : "13:42:44" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "13:42:31" , 
"departure_time" : "13:43:31" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "13:45:00" , 
"departure_time" : "13:46:21" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "13:48:21" , 
"departure_time" : "13:48:52" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "13:49:31" , 
"departure_time" : "13:50:17" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "13:51:46" , 
"departure_time" : "13:51:46" , 
"distance_traveled" : 10.0589
} ], 
"1284" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "13:34:00" , 
"departure_time" : "13:35:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "13:36:15" , 
"departure_time" : "13:36:38" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "13:38:23" , 
"departure_time" : "13:39:09" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "13:41:46" , 
"departure_time" : "13:42:24" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "13:44:38" , 
"departure_time" : "13:44:48" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "13:45:10" , 
"departure_time" : "13:46:34" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "13:51:24" , 
"departure_time" : "13:52:22" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "13:52:58" , 
"departure_time" : "13:53:07" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "13:54:09" , 
"departure_time" : "13:54:18" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "13:56:09" , 
"departure_time" : "13:56:20" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "13:58:11" , 
"departure_time" : "13:58:35" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:00:24" , 
"departure_time" : "14:00:53" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:01:29" , 
"departure_time" : "14:02:26" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:04:57" , 
"departure_time" : "14:06:15" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "14:08:18" , 
"departure_time" : "14:09:46" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "14:10:28" , 
"departure_time" : "14:11:26" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "14:11:58" , 
"departure_time" : "14:11:58" , 
"distance_traveled" : 10.0589
} ], 
"1285" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "13:54:00" , 
"departure_time" : "13:55:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "13:56:52" , 
"departure_time" : "13:57:40" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "13:58:48" , 
"departure_time" : "14:00:20" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "14:02:32" , 
"departure_time" : "14:02:56" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "14:04:24" , 
"departure_time" : "14:05:07" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "14:05:43" , 
"departure_time" : "14:06:20" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:10:37" , 
"departure_time" : "14:11:53" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:13:16" , 
"departure_time" : "14:14:35" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:15:19" , 
"departure_time" : "14:16:58" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:17:39" , 
"departure_time" : "14:18:49" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:19:10" , 
"departure_time" : "14:19:18" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:20:08" , 
"departure_time" : "14:21:46" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:22:38" , 
"departure_time" : "14:22:51" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:24:13" , 
"departure_time" : "14:25:28" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "14:28:15" , 
"departure_time" : "14:29:47" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "14:30:32" , 
"departure_time" : "14:31:13" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "14:31:41" , 
"departure_time" : "14:31:41" , 
"distance_traveled" : 10.0589
} ], 
"1286" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "14:14:00" , 
"departure_time" : "14:15:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "14:17:05" , 
"departure_time" : "14:18:34" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "14:19:29" , 
"departure_time" : "14:19:57" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "14:21:28" , 
"departure_time" : "14:21:50" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "14:24:22" , 
"departure_time" : "14:25:36" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "14:26:14" , 
"departure_time" : "14:26:51" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:30:37" , 
"departure_time" : "14:31:54" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:33:17" , 
"departure_time" : "14:34:03" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:34:46" , 
"departure_time" : "14:35:59" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:37:13" , 
"departure_time" : "14:37:49" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:38:36" , 
"departure_time" : "14:40:03" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "14:41:27" , 
"departure_time" : "14:42:59" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "14:42:32" , 
"departure_time" : "14:43:31" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "14:44:59" , 
"departure_time" : "14:46:22" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "14:48:23" , 
"departure_time" : "14:49:23" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "14:50:00" , 
"departure_time" : "14:51:34" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "14:52:34" , 
"departure_time" : "14:52:34" , 
"distance_traveled" : 10.0589
} ], 
"1287" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "14:34:00" , 
"departure_time" : "14:35:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "14:36:02" , 
"departure_time" : "14:37:03" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "14:39:01" , 
"departure_time" : "14:40:16" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "14:42:15" , 
"departure_time" : "14:43:05" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "14:44:50" , 
"departure_time" : "14:45:11" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "14:45:21" , 
"departure_time" : "14:45:45" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "14:50:24" , 
"departure_time" : "14:51:38" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "14:53:14" , 
"departure_time" : "14:53:26" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "14:54:12" , 
"departure_time" : "14:54:33" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "14:56:21" , 
"departure_time" : "14:56:41" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "14:58:20" , 
"departure_time" : "14:59:02" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:00:42" , 
"departure_time" : "15:00:53" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:01:11" , 
"departure_time" : "15:02:37" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:05:26" , 
"departure_time" : "15:06:46" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "15:08:20" , 
"departure_time" : "15:09:13" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "15:09:53" , 
"departure_time" : "15:10:55" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "15:12:02" , 
"departure_time" : "15:12:02" , 
"distance_traveled" : 10.0589
} ], 
"1288" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "14:54:00" , 
"departure_time" : "14:55:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "14:56:09" , 
"departure_time" : "14:57:33" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "14:59:24" , 
"departure_time" : "15:00:17" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "15:01:53" , 
"departure_time" : "15:02:55" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "15:05:02" , 
"departure_time" : "15:06:16" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "15:06:14" , 
"departure_time" : "15:06:53" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:10:39" , 
"departure_time" : "15:11:33" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:12:54" , 
"departure_time" : "15:13:54" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:15:00" , 
"departure_time" : "15:15:58" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:16:58" , 
"departure_time" : "15:17:08" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:18:10" , 
"departure_time" : "15:19:30" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:21:20" , 
"departure_time" : "15:22:46" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:22:26" , 
"departure_time" : "15:23:30" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:25:04" , 
"departure_time" : "15:25:07" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "15:27:03" , 
"departure_time" : "15:28:31" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "15:30:28" , 
"departure_time" : "15:30:42" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "15:31:14" , 
"departure_time" : "15:31:14" , 
"distance_traveled" : 10.0589
} ], 
"1289" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "15:14:00" , 
"departure_time" : "15:15:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "15:17:32" , 
"departure_time" : "15:18:52" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "15:19:20" , 
"departure_time" : "15:20:15" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "15:21:55" , 
"departure_time" : "15:22:09" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "15:24:14" , 
"departure_time" : "15:25:19" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "15:26:05" , 
"departure_time" : "15:27:12" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:31:07" , 
"departure_time" : "15:31:29" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:32:22" , 
"departure_time" : "15:32:54" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:34:32" , 
"departure_time" : "15:34:38" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:36:06" , 
"departure_time" : "15:36:56" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:38:50" , 
"departure_time" : "15:39:33" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:40:43" , 
"departure_time" : "15:41:32" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:41:49" , 
"departure_time" : "15:42:44" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:44:55" , 
"departure_time" : "15:45:48" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "15:47:53" , 
"departure_time" : "15:48:25" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "15:49:32" , 
"departure_time" : "15:50:41" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "15:52:09" , 
"departure_time" : "15:52:09" , 
"distance_traveled" : 10.0589
} ], 
"1290" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "15:29:00" , 
"departure_time" : "15:31:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "15:31:53" , 
"departure_time" : "15:33:33" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "15:34:40" , 
"departure_time" : "15:35:06" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "15:36:26" , 
"departure_time" : "15:37:55" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "15:40:29" , 
"departure_time" : "15:40:41" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "15:40:12" , 
"departure_time" : "15:41:49" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:46:37" , 
"departure_time" : "15:47:06" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:47:29" , 
"departure_time" : "15:48:50" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:50:21" , 
"departure_time" : "15:51:01" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:51:40" , 
"departure_time" : "15:53:01" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "15:54:21" , 
"departure_time" : "15:54:33" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "15:55:12" , 
"departure_time" : "15:56:17" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "15:57:05" , 
"departure_time" : "15:57:53" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "15:59:48" , 
"departure_time" : "16:01:17" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "16:03:29" , 
"departure_time" : "16:04:52" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "16:05:23" , 
"departure_time" : "16:06:20" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "16:06:57" , 
"departure_time" : "16:06:57" , 
"distance_traveled" : 10.0589
} ], 
"1291" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "15:37:00" , 
"departure_time" : "15:38:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "15:39:32" , 
"departure_time" : "15:40:31" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "15:41:59" , 
"departure_time" : "15:42:40" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "15:44:41" , 
"departure_time" : "15:45:27" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "15:47:46" , 
"departure_time" : "15:48:26" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "15:48:40" , 
"departure_time" : "15:49:08" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "15:53:28" , 
"departure_time" : "15:53:54" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "15:55:26" , 
"departure_time" : "15:56:59" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "15:58:33" , 
"departure_time" : "15:58:38" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "15:59:05" , 
"departure_time" : "16:00:14" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:02:09" , 
"departure_time" : "16:03:34" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:04:25" , 
"departure_time" : "16:05:09" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:04:44" , 
"departure_time" : "16:05:52" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:08:08" , 
"departure_time" : "16:08:57" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "16:10:49" , 
"departure_time" : "16:10:57" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "16:12:08" , 
"departure_time" : "16:13:34" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "16:15:26" , 
"departure_time" : "16:15:26" , 
"distance_traveled" : 10.0589
} ], 
"1292" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "15:46:00" , 
"departure_time" : "15:48:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "15:49:08" , 
"departure_time" : "15:49:28" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "15:50:20" , 
"departure_time" : "15:50:58" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "15:53:38" , 
"departure_time" : "15:55:13" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "15:57:35" , 
"departure_time" : "15:58:10" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "15:57:35" , 
"departure_time" : "15:59:11" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:03:36" , 
"departure_time" : "16:04:23" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:04:47" , 
"departure_time" : "16:04:55" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:06:08" , 
"departure_time" : "16:07:35" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:09:27" , 
"departure_time" : "16:10:48" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:11:21" , 
"departure_time" : "16:11:44" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:12:23" , 
"departure_time" : "16:13:50" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:14:27" , 
"departure_time" : "16:15:33" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:17:06" , 
"departure_time" : "16:18:17" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "16:20:11" , 
"departure_time" : "16:21:35" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "16:22:24" , 
"departure_time" : "16:23:45" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "16:24:21" , 
"departure_time" : "16:24:21" , 
"distance_traveled" : 10.0589
} ], 
"1293" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "15:54:00" , 
"departure_time" : "15:56:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "15:56:49" , 
"departure_time" : "15:57:57" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "15:59:08" , 
"departure_time" : "16:00:21" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:02:13" , 
"departure_time" : "16:03:52" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:05:39" , 
"departure_time" : "16:05:42" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:05:03" , 
"departure_time" : "16:06:40" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:11:37" , 
"departure_time" : "16:12:28" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:12:51" , 
"departure_time" : "16:13:49" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:14:58" , 
"departure_time" : "16:16:23" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:17:25" , 
"departure_time" : "16:17:45" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:18:20" , 
"departure_time" : "16:19:49" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:21:29" , 
"departure_time" : "16:22:30" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:22:01" , 
"departure_time" : "16:23:08" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:25:07" , 
"departure_time" : "16:26:16" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "16:28:09" , 
"departure_time" : "16:29:39" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "16:30:30" , 
"departure_time" : "16:30:53" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "16:31:23" , 
"departure_time" : "16:31:23" , 
"distance_traveled" : 10.0589
} ], 
"1294" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "16:05:00" , 
"departure_time" : "16:05:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:07:26" , 
"departure_time" : "16:08:38" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "16:10:12" , 
"departure_time" : "16:10:54" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:12:42" , 
"departure_time" : "16:13:02" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:15:20" , 
"departure_time" : "16:15:41" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:16:21" , 
"departure_time" : "16:16:33" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:21:12" , 
"departure_time" : "16:22:14" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:24:02" , 
"departure_time" : "16:25:31" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:26:29" , 
"departure_time" : "16:27:29" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:28:00" , 
"departure_time" : "16:29:06" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:30:06" , 
"departure_time" : "16:30:18" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:31:12" , 
"departure_time" : "16:32:48" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:33:36" , 
"departure_time" : "16:33:42" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:35:06" , 
"departure_time" : "16:35:11" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "16:38:05" , 
"departure_time" : "16:38:48" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "16:40:43" , 
"departure_time" : "16:41:07" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "16:42:24" , 
"departure_time" : "16:42:24" , 
"distance_traveled" : 10.0589
} ], 
"1295" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "16:12:00" , 
"departure_time" : "16:13:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:15:32" , 
"departure_time" : "16:15:45" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "16:16:13" , 
"departure_time" : "16:16:46" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:19:33" , 
"departure_time" : "16:20:01" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:22:28" , 
"departure_time" : "16:22:29" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:23:01" , 
"departure_time" : "16:23:38" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:28:37" , 
"departure_time" : "16:29:20" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:30:43" , 
"departure_time" : "16:32:21" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:33:38" , 
"departure_time" : "16:35:16" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:35:38" , 
"departure_time" : "16:36:23" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:36:45" , 
"departure_time" : "16:38:08" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:39:23" , 
"departure_time" : "16:40:11" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:39:48" , 
"departure_time" : "16:41:07" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:43:19" , 
"departure_time" : "16:44:52" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "16:46:33" , 
"departure_time" : "16:47:48" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "16:48:15" , 
"departure_time" : "16:49:44" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "16:50:29" , 
"departure_time" : "16:50:29" , 
"distance_traveled" : 10.0589
} ], 
"1296" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "16:20:00" , 
"departure_time" : "16:22:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:22:35" , 
"departure_time" : "16:23:51" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "16:25:16" , 
"departure_time" : "16:26:51" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:28:35" , 
"departure_time" : "16:29:03" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:30:28" , 
"departure_time" : "16:30:47" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:31:19" , 
"departure_time" : "16:32:32" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:37:13" , 
"departure_time" : "16:38:05" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:38:52" , 
"departure_time" : "16:39:37" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:40:45" , 
"departure_time" : "16:41:39" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:42:54" , 
"departure_time" : "16:43:57" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:45:03" , 
"departure_time" : "16:45:35" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:46:32" , 
"departure_time" : "16:46:52" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:47:20" , 
"departure_time" : "16:48:18" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "16:50:58" , 
"departure_time" : "16:51:23" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "16:53:25" , 
"departure_time" : "16:53:28" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "16:55:03" , 
"departure_time" : "16:56:36" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "16:58:33" , 
"departure_time" : "16:58:33" , 
"distance_traveled" : 10.0589
} ], 
"1297" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "16:32:00" , 
"departure_time" : "16:34:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:34:51" , 
"departure_time" : "16:36:05" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "16:37:14" , 
"departure_time" : "16:37:28" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:39:14" , 
"departure_time" : "16:40:02" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:42:48" , 
"departure_time" : "16:43:14" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:43:26" , 
"departure_time" : "16:44:06" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:48:40" , 
"departure_time" : "16:49:27" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "16:50:47" , 
"departure_time" : "16:50:51" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "16:52:04" , 
"departure_time" : "16:53:42" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "16:55:38" , 
"departure_time" : "16:56:57" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "16:57:19" , 
"departure_time" : "16:57:43" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "16:58:24" , 
"departure_time" : "16:58:51" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "16:59:27" , 
"departure_time" : "17:00:31" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:03:04" , 
"departure_time" : "17:04:29" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "17:06:25" , 
"departure_time" : "17:08:03" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "17:08:38" , 
"departure_time" : "17:08:50" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "17:09:12" , 
"departure_time" : "17:09:12" , 
"distance_traveled" : 10.0589
} ], 
"1298" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "16:42:00" , 
"departure_time" : "16:42:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:44:46" , 
"departure_time" : "16:45:47" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "16:47:01" , 
"departure_time" : "16:47:06" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "16:49:05" , 
"departure_time" : "16:50:32" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "16:53:27" , 
"departure_time" : "16:54:55" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "16:54:28" , 
"departure_time" : "16:55:10" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "16:58:42" , 
"departure_time" : "16:59:20" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:00:38" , 
"departure_time" : "17:01:13" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:02:35" , 
"departure_time" : "17:04:14" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:05:39" , 
"departure_time" : "17:06:56" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:07:17" , 
"departure_time" : "17:08:44" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:09:27" , 
"departure_time" : "17:10:45" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:10:18" , 
"departure_time" : "17:10:35" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:12:17" , 
"departure_time" : "17:12:19" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "17:15:02" , 
"departure_time" : "17:15:21" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "17:17:19" , 
"departure_time" : "17:18:32" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "17:20:13" , 
"departure_time" : "17:20:13" , 
"distance_traveled" : 10.0589
} ], 
"1299" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "16:55:00" , 
"departure_time" : "16:57:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "16:58:37" , 
"departure_time" : "17:00:16" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:00:39" , 
"departure_time" : "17:01:42" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:03:03" , 
"departure_time" : "17:04:05" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "17:06:02" , 
"departure_time" : "17:06:35" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:06:33" , 
"departure_time" : "17:08:02" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:12:29" , 
"departure_time" : "17:13:27" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:13:58" , 
"departure_time" : "17:14:03" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:15:05" , 
"departure_time" : "17:15:41" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:17:36" , 
"departure_time" : "17:18:55" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:20:19" , 
"departure_time" : "17:21:46" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:22:27" , 
"departure_time" : "17:23:57" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:23:30" , 
"departure_time" : "17:24:20" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:25:50" , 
"departure_time" : "17:27:27" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "17:29:37" , 
"departure_time" : "17:30:58" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "17:31:21" , 
"departure_time" : "17:32:40" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "17:33:19" , 
"departure_time" : "17:33:19" , 
"distance_traveled" : 10.0589
} ], 
"1300" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "17:05:00" , 
"departure_time" : "17:06:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:07:28" , 
"departure_time" : "17:08:09" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:09:41" , 
"departure_time" : "17:10:06" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:12:25" , 
"departure_time" : "17:13:10" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "17:15:45" , 
"departure_time" : "17:16:47" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:17:02" , 
"departure_time" : "17:17:10" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:21:08" , 
"departure_time" : "17:21:50" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:23:42" , 
"departure_time" : "17:24:14" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:25:32" , 
"departure_time" : "17:25:55" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:27:23" , 
"departure_time" : "17:28:12" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:29:49" , 
"departure_time" : "17:31:23" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:32:34" , 
"departure_time" : "17:32:40" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:32:06" , 
"departure_time" : "17:32:24" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:35:18" , 
"departure_time" : "17:36:46" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "17:39:28" , 
"departure_time" : "17:39:52" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "17:40:24" , 
"departure_time" : "17:40:47" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "17:42:23" , 
"departure_time" : "17:42:23" , 
"distance_traveled" : 10.0589
} ], 
"1301" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "17:13:00" , 
"departure_time" : "17:14:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:16:05" , 
"departure_time" : "17:16:24" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:17:19" , 
"departure_time" : "17:17:40" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:20:21" , 
"departure_time" : "17:21:58" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "17:24:37" , 
"departure_time" : "17:26:00" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:25:23" , 
"departure_time" : "17:25:45" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:29:22" , 
"departure_time" : "17:30:10" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:31:48" , 
"departure_time" : "17:32:26" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:33:38" , 
"departure_time" : "17:34:46" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:36:08" , 
"departure_time" : "17:36:49" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:37:41" , 
"departure_time" : "17:38:48" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:40:07" , 
"departure_time" : "17:41:40" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:41:33" , 
"departure_time" : "17:42:04" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:43:31" , 
"departure_time" : "17:44:25" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "17:46:54" , 
"departure_time" : "17:47:11" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "17:48:17" , 
"departure_time" : "17:48:34" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "17:50:17" , 
"departure_time" : "17:50:17" , 
"distance_traveled" : 10.0589
} ], 
"1302" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "17:25:00" , 
"departure_time" : "17:26:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:28:09" , 
"departure_time" : "17:28:57" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:29:48" , 
"departure_time" : "17:31:21" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:33:33" , 
"departure_time" : "17:35:12" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "17:36:39" , 
"departure_time" : "17:36:51" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:36:12" , 
"departure_time" : "17:37:23" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:42:11" , 
"departure_time" : "17:42:17" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:43:06" , 
"departure_time" : "17:43:14" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:45:08" , 
"departure_time" : "17:46:25" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:48:17" , 
"departure_time" : "17:49:00" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "17:49:43" , 
"departure_time" : "17:50:43" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "17:52:00" , 
"departure_time" : "17:53:18" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "17:53:18" , 
"departure_time" : "17:54:06" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "17:55:48" , 
"departure_time" : "17:56:55" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "17:59:07" , 
"departure_time" : "18:00:36" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "18:01:29" , 
"departure_time" : "18:02:34" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "18:03:05" , 
"departure_time" : "18:03:05" , 
"distance_traveled" : 10.0589
} ], 
"1303" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "17:35:00" , 
"departure_time" : "17:37:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:38:18" , 
"departure_time" : "17:39:47" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:40:29" , 
"departure_time" : "17:41:06" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:42:37" , 
"departure_time" : "17:43:59" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "17:46:22" , 
"departure_time" : "17:46:37" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:46:15" , 
"departure_time" : "17:47:01" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "17:51:46" , 
"departure_time" : "17:52:12" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "17:53:26" , 
"departure_time" : "17:53:46" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "17:55:20" , 
"departure_time" : "17:56:56" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "17:58:36" , 
"departure_time" : "17:59:46" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:00:10" , 
"departure_time" : "18:01:27" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:02:17" , 
"departure_time" : "18:03:11" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:02:54" , 
"departure_time" : "18:03:48" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:05:54" , 
"departure_time" : "18:07:08" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "18:09:14" , 
"departure_time" : "18:10:10" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "18:10:56" , 
"departure_time" : "18:11:21" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "18:12:25" , 
"departure_time" : "18:12:25" , 
"distance_traveled" : 10.0589
} ], 
"1304" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "17:46:00" , 
"departure_time" : "17:47:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:48:51" , 
"departure_time" : "17:49:15" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "17:50:24" , 
"departure_time" : "17:50:56" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "17:53:32" , 
"departure_time" : "17:54:30" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "17:56:58" , 
"departure_time" : "17:58:05" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "17:58:07" , 
"departure_time" : "17:58:55" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:02:48" , 
"departure_time" : "18:04:13" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:05:25" , 
"departure_time" : "18:06:46" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:07:21" , 
"departure_time" : "18:08:12" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:08:51" , 
"departure_time" : "18:09:48" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:10:57" , 
"departure_time" : "18:12:33" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:13:36" , 
"departure_time" : "18:14:15" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:13:39" , 
"departure_time" : "18:14:01" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:16:22" , 
"departure_time" : "18:17:57" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "18:20:35" , 
"departure_time" : "18:20:57" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "18:21:22" , 
"departure_time" : "18:22:42" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "18:24:20" , 
"departure_time" : "18:24:20" , 
"distance_traveled" : 10.0589
} ], 
"1305" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "17:56:00" , 
"departure_time" : "17:58:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "17:59:03" , 
"departure_time" : "18:00:27" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:01:24" , 
"departure_time" : "18:01:38" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:03:14" , 
"departure_time" : "18:04:29" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:07:15" , 
"departure_time" : "18:08:16" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:08:01" , 
"departure_time" : "18:08:31" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:12:30" , 
"departure_time" : "18:14:08" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:15:38" , 
"departure_time" : "18:16:31" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:16:53" , 
"departure_time" : "18:17:49" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:18:56" , 
"departure_time" : "18:20:34" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:21:38" , 
"departure_time" : "18:22:40" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:23:02" , 
"departure_time" : "18:24:37" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:24:35" , 
"departure_time" : "18:25:20" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:26:45" , 
"departure_time" : "18:27:40" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "18:29:55" , 
"departure_time" : "18:31:17" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "18:32:22" , 
"departure_time" : "18:32:54" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "18:33:32" , 
"departure_time" : "18:33:32" , 
"distance_traveled" : 10.0589
} ], 
"1306" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "18:02:00" , 
"departure_time" : "18:02:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:04:01" , 
"departure_time" : "18:04:09" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:06:08" , 
"departure_time" : "18:06:30" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:09:22" , 
"departure_time" : "18:10:45" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:13:23" , 
"departure_time" : "18:14:41" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:14:18" , 
"departure_time" : "18:14:50" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:18:32" , 
"departure_time" : "18:19:54" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:21:22" , 
"departure_time" : "18:21:35" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:22:13" , 
"departure_time" : "18:23:40" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:25:27" , 
"departure_time" : "18:25:32" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:26:05" , 
"departure_time" : "18:26:54" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:28:49" , 
"departure_time" : "18:30:05" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:30:16" , 
"departure_time" : "18:31:13" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:32:57" , 
"departure_time" : "18:34:32" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "18:36:35" , 
"departure_time" : "18:37:24" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "18:37:49" , 
"departure_time" : "18:39:11" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "18:40:22" , 
"departure_time" : "18:40:22" , 
"distance_traveled" : 10.0589
} ], 
"1307" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "18:10:00" , 
"departure_time" : "18:12:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:13:25" , 
"departure_time" : "18:14:13" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:14:48" , 
"departure_time" : "18:15:18" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:17:30" , 
"departure_time" : "18:17:52" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:20:22" , 
"departure_time" : "18:21:35" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:22:13" , 
"departure_time" : "18:22:16" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:26:03" , 
"departure_time" : "18:26:44" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:28:41" , 
"departure_time" : "18:29:16" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:30:35" , 
"departure_time" : "18:31:25" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:32:50" , 
"departure_time" : "18:33:06" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:34:16" , 
"departure_time" : "18:35:17" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:37:01" , 
"departure_time" : "18:38:21" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:38:20" , 
"departure_time" : "18:38:30" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:40:10" , 
"departure_time" : "18:41:18" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "18:44:08" , 
"departure_time" : "18:45:02" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "18:45:54" , 
"departure_time" : "18:47:00" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "18:48:06" , 
"departure_time" : "18:48:06" , 
"distance_traveled" : 10.0589
} ], 
"1308" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "18:21:00" , 
"departure_time" : "18:23:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:23:56" , 
"departure_time" : "18:25:07" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:26:11" , 
"departure_time" : "18:26:35" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:28:24" , 
"departure_time" : "18:28:39" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:31:15" , 
"departure_time" : "18:31:46" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:32:31" , 
"departure_time" : "18:32:50" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:37:19" , 
"departure_time" : "18:38:21" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:40:02" , 
"departure_time" : "18:41:36" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:42:34" , 
"departure_time" : "18:44:07" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:44:33" , 
"departure_time" : "18:44:44" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:45:11" , 
"departure_time" : "18:45:26" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:47:15" , 
"departure_time" : "18:48:45" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:49:30" , 
"departure_time" : "18:50:36" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "18:52:06" , 
"departure_time" : "18:53:12" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "18:55:06" , 
"departure_time" : "18:56:01" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "18:56:55" , 
"departure_time" : "18:58:17" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "18:59:22" , 
"departure_time" : "18:59:22" , 
"distance_traveled" : 10.0589
} ], 
"1309" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "18:31:00" , 
"departure_time" : "18:33:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:33:54" , 
"departure_time" : "18:33:58" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:35:04" , 
"departure_time" : "18:36:42" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:39:38" , 
"departure_time" : "18:40:36" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:41:58" , 
"departure_time" : "18:42:32" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:42:34" , 
"departure_time" : "18:43:03" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:47:29" , 
"departure_time" : "18:49:08" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:50:39" , 
"departure_time" : "18:51:14" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:51:35" , 
"departure_time" : "18:52:04" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "18:53:29" , 
"departure_time" : "18:54:54" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "18:56:25" , 
"departure_time" : "18:56:56" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "18:57:31" , 
"departure_time" : "18:58:46" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "18:59:15" , 
"departure_time" : "19:00:36" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:02:21" , 
"departure_time" : "19:02:47" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "19:04:26" , 
"departure_time" : "19:05:23" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "19:06:57" , 
"departure_time" : "19:07:11" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "19:08:14" , 
"departure_time" : "19:08:14" , 
"distance_traveled" : 10.0589
} ], 
"1310" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "18:38:00" , 
"departure_time" : "18:39:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:41:21" , 
"departure_time" : "18:42:46" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:43:25" , 
"departure_time" : "18:43:56" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:45:31" , 
"departure_time" : "18:46:55" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "18:49:24" , 
"departure_time" : "18:50:47" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "18:50:23" , 
"departure_time" : "18:51:50" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "18:55:27" , 
"departure_time" : "18:56:04" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "18:56:37" , 
"departure_time" : "18:58:13" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "18:59:36" , 
"departure_time" : "19:00:44" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:01:08" , 
"departure_time" : "19:02:45" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:03:37" , 
"departure_time" : "19:04:31" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:04:54" , 
"departure_time" : "19:05:51" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:05:57" , 
"departure_time" : "19:06:50" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:08:53" , 
"departure_time" : "19:10:28" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "19:12:35" , 
"departure_time" : "19:13:03" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "19:13:28" , 
"departure_time" : "19:13:48" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "19:15:20" , 
"departure_time" : "19:15:20" , 
"distance_traveled" : 10.0589
} ], 
"1311" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "18:50:00" , 
"departure_time" : "18:50:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "18:52:09" , 
"departure_time" : "18:52:55" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "18:54:46" , 
"departure_time" : "18:56:07" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "18:58:21" , 
"departure_time" : "18:58:45" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "19:00:24" , 
"departure_time" : "19:01:09" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "19:01:45" , 
"departure_time" : "19:02:54" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:07:09" , 
"departure_time" : "19:07:56" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:08:47" , 
"departure_time" : "19:09:05" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:10:18" , 
"departure_time" : "19:11:29" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:13:11" , 
"departure_time" : "19:13:41" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:14:30" , 
"departure_time" : "19:15:37" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:17:07" , 
"departure_time" : "19:18:13" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:18:06" , 
"departure_time" : "19:18:33" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:20:27" , 
"departure_time" : "19:20:37" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "19:23:10" , 
"departure_time" : "19:24:17" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "19:26:07" , 
"departure_time" : "19:26:08" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "19:27:01" , 
"departure_time" : "19:27:01" , 
"distance_traveled" : 10.0589
} ], 
"1312" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "19:00:00" , 
"departure_time" : "19:00:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "19:02:11" , 
"departure_time" : "19:02:48" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "19:04:37" , 
"departure_time" : "19:05:46" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "19:08:09" , 
"departure_time" : "19:09:02" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "19:10:53" , 
"departure_time" : "19:12:05" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "19:12:12" , 
"departure_time" : "19:12:26" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:16:14" , 
"departure_time" : "19:17:34" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:19:20" , 
"departure_time" : "19:20:26" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:21:06" , 
"departure_time" : "19:22:05" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:22:59" , 
"departure_time" : "19:23:28" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:24:29" , 
"departure_time" : "19:24:52" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:26:23" , 
"departure_time" : "19:27:35" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:28:12" , 
"departure_time" : "19:29:12" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:31:00" , 
"departure_time" : "19:31:50" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "19:33:50" , 
"departure_time" : "19:33:54" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "19:35:04" , 
"departure_time" : "19:35:41" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "19:37:37" , 
"departure_time" : "19:37:37" , 
"distance_traveled" : 10.0589
} ], 
"1313" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "19:11:00" , 
"departure_time" : "19:13:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "19:14:31" , 
"departure_time" : "19:15:38" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "19:16:07" , 
"departure_time" : "19:17:27" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "19:19:20" , 
"departure_time" : "19:20:47" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "19:22:27" , 
"departure_time" : "19:22:30" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "19:22:03" , 
"departure_time" : "19:22:19" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:27:16" , 
"departure_time" : "19:28:15" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:29:59" , 
"departure_time" : "19:31:23" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:32:24" , 
"departure_time" : "19:33:19" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:33:55" , 
"departure_time" : "19:35:16" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:36:21" , 
"departure_time" : "19:37:54" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:38:33" , 
"departure_time" : "19:39:37" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:39:04" , 
"departure_time" : "19:40:26" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:42:22" , 
"departure_time" : "19:43:37" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "19:45:15" , 
"departure_time" : "19:46:50" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "19:47:35" , 
"departure_time" : "19:49:09" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "19:49:34" , 
"departure_time" : "19:49:34" , 
"distance_traveled" : 10.0589
} ], 
"1314" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "19:24:00" , 
"departure_time" : "19:26:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "19:27:25" , 
"departure_time" : "19:29:04" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "19:29:39" , 
"departure_time" : "19:30:45" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "19:32:06" , 
"departure_time" : "19:33:44" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "19:35:38" , 
"departure_time" : "19:36:27" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "19:35:49" , 
"departure_time" : "19:36:21" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:40:32" , 
"departure_time" : "19:40:37" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:42:05" , 
"departure_time" : "19:43:09" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:45:04" , 
"departure_time" : "19:45:45" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:46:41" , 
"departure_time" : "19:46:50" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "19:48:09" , 
"departure_time" : "19:48:29" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "19:50:20" , 
"departure_time" : "19:51:07" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "19:51:47" , 
"departure_time" : "19:52:24" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "19:54:37" , 
"departure_time" : "19:55:03" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "19:57:26" , 
"departure_time" : "19:57:29" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "19:59:03" , 
"departure_time" : "20:00:13" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "20:02:10" , 
"departure_time" : "20:02:10" , 
"distance_traveled" : 10.0589
} ], 
"1315" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "19:36:00" , 
"departure_time" : "19:38:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "19:39:35" , 
"departure_time" : "19:40:35" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "19:41:00" , 
"departure_time" : "19:41:09" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "19:43:09" , 
"departure_time" : "19:43:33" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "19:46:24" , 
"departure_time" : "19:47:17" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "19:47:53" , 
"departure_time" : "19:49:29" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "19:53:36" , 
"departure_time" : "19:54:03" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "19:54:27" , 
"departure_time" : "19:55:34" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "19:57:07" , 
"departure_time" : "19:58:23" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "19:59:16" , 
"departure_time" : "20:00:35" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:01:19" , 
"departure_time" : "20:01:20" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:02:01" , 
"departure_time" : "20:02:56" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:03:55" , 
"departure_time" : "20:05:16" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:07:21" , 
"departure_time" : "20:07:31" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "20:09:10" , 
"departure_time" : "20:10:38" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "20:12:28" , 
"departure_time" : "20:12:31" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "20:13:03" , 
"departure_time" : "20:13:03" , 
"distance_traveled" : 10.0589
} ], 
"1316" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "19:46:00" , 
"departure_time" : "19:46:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "19:48:56" , 
"departure_time" : "19:50:12" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "19:51:16" , 
"departure_time" : "19:51:52" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "19:53:36" , 
"departure_time" : "19:54:58" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "19:57:22" , 
"departure_time" : "19:58:01" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "19:57:39" , 
"departure_time" : "19:59:12" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:03:33" , 
"departure_time" : "20:04:44" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:05:11" , 
"departure_time" : "20:06:41" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:07:30" , 
"departure_time" : "20:09:05" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:09:35" , 
"departure_time" : "20:10:57" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:11:22" , 
"departure_time" : "20:12:15" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:12:53" , 
"departure_time" : "20:13:55" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:14:02" , 
"departure_time" : "20:14:38" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:16:36" , 
"departure_time" : "20:16:54" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "20:19:18" , 
"departure_time" : "20:19:54" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "20:21:36" , 
"departure_time" : "20:22:15" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "20:23:39" , 
"departure_time" : "20:23:39" , 
"distance_traveled" : 10.0589
} ], 
"1317" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "20:00:00" , 
"departure_time" : "20:01:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "20:02:52" , 
"departure_time" : "20:03:15" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "20:04:23" , 
"departure_time" : "20:05:03" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "20:07:40" , 
"departure_time" : "20:07:46" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "20:10:06" , 
"departure_time" : "20:11:41" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "20:12:35" , 
"departure_time" : "20:13:01" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:16:26" , 
"departure_time" : "20:17:53" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:19:27" , 
"departure_time" : "20:20:15" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:20:48" , 
"departure_time" : "20:22:00" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:23:12" , 
"departure_time" : "20:23:39" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:24:27" , 
"departure_time" : "20:24:41" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:26:14" , 
"departure_time" : "20:26:18" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:27:04" , 
"departure_time" : "20:28:42" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:31:38" , 
"departure_time" : "20:32:19" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "20:33:41" , 
"departure_time" : "20:33:45" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "20:35:04" , 
"departure_time" : "20:36:31" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "20:38:27" , 
"departure_time" : "20:38:27" , 
"distance_traveled" : 10.0589
} ], 
"1318" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "20:10:00" , 
"departure_time" : "20:12:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "20:12:35" , 
"departure_time" : "20:13:22" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "20:14:47" , 
"departure_time" : "20:16:13" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "20:18:26" , 
"departure_time" : "20:18:53" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "20:20:27" , 
"departure_time" : "20:21:33" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "20:22:06" , 
"departure_time" : "20:22:30" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:26:24" , 
"departure_time" : "20:26:41" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:28:17" , 
"departure_time" : "20:29:03" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:30:46" , 
"departure_time" : "20:32:06" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:33:20" , 
"departure_time" : "20:33:44" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:34:24" , 
"departure_time" : "20:35:29" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:37:05" , 
"departure_time" : "20:37:32" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:37:27" , 
"departure_time" : "20:37:34" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:40:07" , 
"departure_time" : "20:40:27" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "20:43:20" , 
"departure_time" : "20:43:52" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "20:45:32" , 
"departure_time" : "20:46:07" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "20:47:35" , 
"departure_time" : "20:47:35" , 
"distance_traveled" : 10.0589
} ], 
"1319" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "20:20:00" , 
"departure_time" : "20:20:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "20:22:06" , 
"departure_time" : "20:22:16" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "20:24:10" , 
"departure_time" : "20:24:24" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "20:27:14" , 
"departure_time" : "20:27:17" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "20:30:03" , 
"departure_time" : "20:31:34" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "20:32:31" , 
"departure_time" : "20:32:32" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:36:01" , 
"departure_time" : "20:37:05" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:39:04" , 
"departure_time" : "20:39:33" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "20:40:29" , 
"departure_time" : "20:41:27" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "20:42:58" , 
"departure_time" : "20:43:09" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "20:44:11" , 
"departure_time" : "20:45:51" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "20:47:40" , 
"departure_time" : "20:48:46" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "20:48:06" , 
"departure_time" : "20:49:28" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "20:51:22" , 
"departure_time" : "20:52:18" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "20:53:56" , 
"departure_time" : "20:55:27" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "20:56:31" , 
"departure_time" : "20:58:05" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "20:58:34" , 
"departure_time" : "20:58:34" , 
"distance_traveled" : 10.0589
} ], 
"1320" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "20:40:00" , 
"departure_time" : "20:42:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "20:42:28" , 
"departure_time" : "20:43:54" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "20:45:26" , 
"departure_time" : "20:45:43" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "20:47:17" , 
"departure_time" : "20:48:45" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "20:51:28" , 
"departure_time" : "20:51:54" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "20:51:26" , 
"departure_time" : "20:52:26" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "20:57:00" , 
"departure_time" : "20:58:08" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "20:59:08" , 
"departure_time" : "20:59:49" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:00:41" , 
"departure_time" : "21:01:07" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "21:02:26" , 
"departure_time" : "21:03:29" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:05:03" , 
"departure_time" : "21:06:01" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "21:06:58" , 
"departure_time" : "21:08:10" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "21:08:12" , 
"departure_time" : "21:09:51" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:11:39" , 
"departure_time" : "21:12:54" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "21:14:15" , 
"departure_time" : "21:15:53" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "21:16:38" , 
"departure_time" : "21:17:06" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "21:17:28" , 
"departure_time" : "21:17:28" , 
"distance_traveled" : 10.0589
} ], 
"1321" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "21:10:00" , 
"departure_time" : "21:11:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "21:13:27" , 
"departure_time" : "21:13:52" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "21:14:25" , 
"departure_time" : "21:15:56" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "21:18:31" , 
"departure_time" : "21:19:17" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "21:20:46" , 
"departure_time" : "21:21:30" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "21:21:44" , 
"departure_time" : "21:22:44" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:27:00" , 
"departure_time" : "21:27:34" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:28:34" , 
"departure_time" : "21:29:44" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "21:31:10" , 
"departure_time" : "21:32:33" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "21:33:23" , 
"departure_time" : "21:34:09" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "21:34:46" , 
"departure_time" : "21:36:19" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "21:37:33" , 
"departure_time" : "21:38:40" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "21:38:07" , 
"departure_time" : "21:39:37" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "21:41:30" , 
"departure_time" : "21:41:58" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "21:43:28" , 
"departure_time" : "21:43:40" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "21:45:12" , 
"departure_time" : "21:46:51" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "21:48:39" , 
"departure_time" : "21:48:39" , 
"distance_traveled" : 10.0589
} ], 
"1322" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "21:40:00" , 
"departure_time" : "21:41:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "21:42:10" , 
"departure_time" : "21:42:54" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "21:44:44" , 
"departure_time" : "21:46:22" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "21:48:38" , 
"departure_time" : "21:49:50" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "21:51:12" , 
"departure_time" : "21:52:46" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "21:52:34" , 
"departure_time" : "21:52:37" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "21:56:03" , 
"departure_time" : "21:56:34" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "21:58:31" , 
"departure_time" : "21:58:57" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:00:26" , 
"departure_time" : "22:01:52" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:03:26" , 
"departure_time" : "22:04:33" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:05:07" , 
"departure_time" : "22:05:21" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:06:14" , 
"departure_time" : "22:06:35" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:07:21" , 
"departure_time" : "22:08:21" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:11:00" , 
"departure_time" : "22:11:24" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "22:13:24" , 
"departure_time" : "22:14:05" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "22:15:41" , 
"departure_time" : "22:16:07" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "22:17:26" , 
"departure_time" : "22:17:26" , 
"distance_traveled" : 10.0589
} ], 
"1323" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "22:10:00" , 
"departure_time" : "22:10:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "22:12:21" , 
"departure_time" : "22:12:55" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "22:14:34" , 
"departure_time" : "22:15:31" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "22:17:57" , 
"departure_time" : "22:18:09" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "22:20:12" , 
"departure_time" : "22:21:19" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "22:22:07" , 
"departure_time" : "22:23:40" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:27:33" , 
"departure_time" : "22:27:38" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:28:05" , 
"departure_time" : "22:28:06" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "22:30:01" , 
"departure_time" : "22:31:26" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "22:33:25" , 
"departure_time" : "22:33:27" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "22:34:02" , 
"departure_time" : "22:35:12" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "22:37:10" , 
"departure_time" : "22:37:46" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "22:37:36" , 
"departure_time" : "22:37:46" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "22:40:10" , 
"departure_time" : "22:41:32" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "22:44:22" , 
"departure_time" : "22:45:47" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "22:46:25" , 
"departure_time" : "22:46:30" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "22:47:05" , 
"departure_time" : "22:47:05" , 
"distance_traveled" : 10.0589
} ], 
"1324" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "22:40:00" , 
"departure_time" : "22:40:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "22:42:09" , 
"departure_time" : "22:43:42" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "22:45:33" , 
"departure_time" : "22:46:13" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "22:47:40" , 
"departure_time" : "22:48:13" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "22:50:33" , 
"departure_time" : "22:51:54" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "22:52:21" , 
"departure_time" : "22:53:54" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "22:57:33" , 
"departure_time" : "22:58:24" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "22:58:51" , 
"departure_time" : "22:59:56" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:01:05" , 
"departure_time" : "23:01:58" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:02:53" , 
"departure_time" : "23:03:33" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:04:40" , 
"departure_time" : "23:05:07" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "23:06:27" , 
"departure_time" : "23:07:47" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:08:20" , 
"departure_time" : "23:08:42" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:10:22" , 
"departure_time" : "23:11:05" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "23:13:43" , 
"departure_time" : "23:13:56" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "23:15:13" , 
"departure_time" : "23:15:20" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "23:17:07" , 
"departure_time" : "23:17:07" , 
"distance_traveled" : 10.0589
} ], 
"1325" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "23:10:00" , 
"departure_time" : "23:10:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "23:12:44" , 
"departure_time" : "23:13:50" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "23:15:06" , 
"departure_time" : "23:15:50" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "23:17:44" , 
"departure_time" : "23:17:56" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "23:20:12" , 
"departure_time" : "23:21:36" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "23:22:24" , 
"departure_time" : "23:22:52" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:26:28" , 
"departure_time" : "23:26:51" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:28:23" , 
"departure_time" : "23:29:58" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "23:31:35" , 
"departure_time" : "23:32:10" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "23:32:35" , 
"departure_time" : "23:32:39" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "23:34:04" , 
"departure_time" : "23:34:18" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "23:36:14" , 
"departure_time" : "23:37:28" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "23:38:14" , 
"departure_time" : "23:38:36" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "23:40:22" , 
"departure_time" : "23:40:44" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "23:43:22" , 
"departure_time" : "23:43:36" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "23:45:14" , 
"departure_time" : "23:46:20" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "23:48:06" , 
"departure_time" : "23:48:06" , 
"distance_traveled" : 10.0589
} ], 
"1326" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "23:40:00" , 
"departure_time" : "23:41:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "23:42:34" , 
"departure_time" : "23:43:49" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "23:45:15" , 
"departure_time" : "23:45:55" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "23:47:40" , 
"departure_time" : "23:49:12" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "23:51:32" , 
"departure_time" : "23:53:08" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "23:52:36" , 
"departure_time" : "23:53:11" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "23:56:35" , 
"departure_time" : "23:57:37" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "23:59:02" , 
"departure_time" : "23:59:46" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "24:00:44" , 
"departure_time" : "24:01:33" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "24:02:49" , 
"departure_time" : "24:03:08" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "24:04:19" , 
"departure_time" : "24:04:24" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "24:06:05" , 
"departure_time" : "24:07:05" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "24:08:00" , 
"departure_time" : "24:09:23" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "24:11:23" , 
"departure_time" : "24:12:32" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "24:14:09" , 
"departure_time" : "24:14:37" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "24:15:28" , 
"departure_time" : "24:16:51" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "24:18:23" , 
"departure_time" : "24:18:23" , 
"distance_traveled" : 10.0589
} ], 
"1327" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "24:10:00" , 
"departure_time" : "24:12:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "24:13:19" , 
"departure_time" : "24:14:22" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "24:15:03" , 
"departure_time" : "24:15:36" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "24:17:33" , 
"departure_time" : "24:18:01" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "24:20:28" , 
"departure_time" : "24:21:41" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "24:22:13" , 
"departure_time" : "24:23:01" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "24:26:48" , 
"departure_time" : "24:28:28" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "24:29:40" , 
"departure_time" : "24:30:39" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "24:30:59" , 
"departure_time" : "24:32:30" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "24:33:31" , 
"departure_time" : "24:35:11" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "24:35:40" , 
"departure_time" : "24:36:48" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "24:37:08" , 
"departure_time" : "24:38:43" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "24:38:35" , 
"departure_time" : "24:39:46" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "24:41:11" , 
"departure_time" : "24:41:18" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "24:43:07" , 
"departure_time" : "24:43:26" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "24:45:19" , 
"departure_time" : "24:46:53" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "24:48:34" , 
"departure_time" : "24:48:34" , 
"distance_traveled" : 10.0589
} ], 
"1328" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "24:40:00" , 
"departure_time" : "24:41:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "24:42:10" , 
"departure_time" : "24:42:49" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "24:44:39" , 
"departure_time" : "24:45:24" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "24:47:45" , 
"departure_time" : "24:49:10" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "24:51:25" , 
"departure_time" : "24:52:22" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "24:51:57" , 
"departure_time" : "24:52:33" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "24:56:36" , 
"departure_time" : "24:57:27" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "24:58:51" , 
"departure_time" : "24:59:52" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "25:01:01" , 
"departure_time" : "25:01:10" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "25:02:09" , 
"departure_time" : "25:02:56" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "25:04:47" , 
"departure_time" : "25:06:22" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "25:07:35" , 
"departure_time" : "25:07:41" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "25:07:06" , 
"departure_time" : "25:07:13" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "25:10:07" , 
"departure_time" : "25:10:11" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "25:13:04" , 
"departure_time" : "25:13:07" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "25:15:03" , 
"departure_time" : "25:16:25" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "25:18:22" , 
"departure_time" : "25:18:22" , 
"distance_traveled" : 10.0589
} ], 
"1329" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "25:10:00" , 
"departure_time" : "25:12:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "25:12:58" , 
"departure_time" : "25:13:26" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "25:14:28" , 
"departure_time" : "25:14:48" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "25:17:20" , 
"departure_time" : "25:17:42" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "25:20:22" , 
"departure_time" : "25:21:53" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "25:22:31" , 
"departure_time" : "25:23:32" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "25:27:01" , 
"departure_time" : "25:27:13" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "25:28:12" , 
"departure_time" : "25:29:18" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "25:31:06" , 
"departure_time" : "25:31:22" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "25:32:16" , 
"departure_time" : "25:33:45" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "25:35:29" , 
"departure_time" : "25:36:53" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "25:37:24" , 
"departure_time" : "25:38:20" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "25:37:56" , 
"departure_time" : "25:38:19" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "25:40:23" , 
"departure_time" : "25:41:47" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "25:44:24" , 
"departure_time" : "25:45:32" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "25:46:08" , 
"departure_time" : "25:46:42" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "25:47:34" , 
"departure_time" : "25:47:34" , 
"distance_traveled" : 10.0589
} ], 
"1330" :  [ 
{ 
"stop_id" : 38579,
"arrival_time" : "25:40:00" , 
"departure_time" : "25:41:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38578,
"arrival_time" : "25:42:38" , 
"departure_time" : "25:43:42" , 
"distance_traveled" : 0.5945
}, 
{ 
"stop_id" : 9878,
"arrival_time" : "25:45:04" , 
"departure_time" : "25:46:05" , 
"distance_traveled" : 1.2928
}, 
{ 
"stop_id" : 17699,
"arrival_time" : "25:48:01" , 
"departure_time" : "25:48:43" , 
"distance_traveled" : 2.4532
}, 
{ 
"stop_id" : 38442,
"arrival_time" : "25:50:42" , 
"departure_time" : "25:50:50" , 
"distance_traveled" : 3.7354
}, 
{ 
"stop_id" : 38441,
"arrival_time" : "25:51:08" , 
"departure_time" : "25:52:43" , 
"distance_traveled" : 4.2866
}, 
{ 
"stop_id" : 37378,
"arrival_time" : "25:57:35" , 
"departure_time" : "25:57:56" , 
"distance_traveled" : 5.7271
}, 
{ 
"stop_id" : 37377,
"arrival_time" : "25:58:21" , 
"departure_time" : "25:58:47" , 
"distance_traveled" : 6.0201
}, 
{ 
"stop_id" : 37376,
"arrival_time" : "26:00:26" , 
"departure_time" : "26:01:14" , 
"distance_traveled" : 6.367
}, 
{ 
"stop_id" : 36994,
"arrival_time" : "26:02:48" , 
"departure_time" : "26:03:47" , 
"distance_traveled" : 6.6161
}, 
{ 
"stop_id" : 36995,
"arrival_time" : "26:04:59" , 
"departure_time" : "26:05:12" , 
"distance_traveled" : 6.9106
}, 
{ 
"stop_id" : 36996,
"arrival_time" : "26:06:13" , 
"departure_time" : "26:06:45" , 
"distance_traveled" : 7.3184
}, 
{ 
"stop_id" : 36997,
"arrival_time" : "26:07:32" , 
"departure_time" : "26:07:36" , 
"distance_traveled" : 7.5958
}, 
{ 
"stop_id" : 36998,
"arrival_time" : "26:10:04" , 
"departure_time" : "26:11:23" , 
"distance_traveled" : 8.2771
}, 
{ 
"stop_id" : 36999,
"arrival_time" : "26:14:19" , 
"departure_time" : "26:15:12" , 
"distance_traveled" : 9.1502
}, 
{ 
"stop_id" : 37000,
"arrival_time" : "26:15:53" , 
"departure_time" : "26:16:29" , 
"distance_traveled" : 9.4917
}, 
{ 
"stop_id" : 37001,
"arrival_time" : "26:17:36" , 
"departure_time" : "26:17:36" , 
"distance_traveled" : 10.0589
} ], 
"1331" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "24:08:00" , 
"departure_time" : "24:09:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "24:12:10" , 
"departure_time" : "24:13:20" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "24:15:10" , 
"departure_time" : "24:16:19" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "24:18:09" , 
"departure_time" : "24:19:45" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "24:21:36" , 
"departure_time" : "24:22:03" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "24:23:27" , 
"departure_time" : "24:24:59" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "24:28:32" , 
"departure_time" : "24:28:38" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "24:30:06" , 
"departure_time" : "24:30:56" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 51,
"arrival_time" : "24:34:50" , 
"departure_time" : "24:35:25" , 
"distance_traveled" : 11.1142
}, 
{ 
"stop_id" : 126,
"arrival_time" : "24:37:35" , 
"departure_time" : "24:38:40" , 
"distance_traveled" : 12.6545
}, 
{ 
"stop_id" : 25,
"arrival_time" : "24:41:05" , 
"departure_time" : "24:41:51" , 
"distance_traveled" : 13.9055
}, 
{ 
"stop_id" : 121,
"arrival_time" : "24:45:46" , 
"departure_time" : "24:46:31" , 
"distance_traveled" : 16.6331
}, 
{ 
"stop_id" : 46,
"arrival_time" : "24:48:45" , 
"departure_time" : "24:49:33" , 
"distance_traveled" : 17.9117
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "24:51:48" , 
"departure_time" : "24:51:49" , 
"distance_traveled" : 18.9337
}, 
{ 
"stop_id" : 134,
"arrival_time" : "24:56:01" , 
"departure_time" : "24:57:18" , 
"distance_traveled" : 20.871
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "25:06:17" , 
"departure_time" : "25:06:30" , 
"distance_traveled" : 25.9892
}, 
{ 
"stop_id" : 63,
"arrival_time" : "25:21:13" , 
"departure_time" : "25:21:13" , 
"distance_traveled" : 29.5491
} ], 
"1332" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "24:08:00" , 
"departure_time" : "24:08:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "24:11:11" , 
"departure_time" : "24:12:32" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "24:15:21" , 
"departure_time" : "24:16:31" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "24:18:10" , 
"departure_time" : "24:19:13" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "24:21:03" , 
"departure_time" : "24:22:27" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "24:24:24" , 
"departure_time" : "24:25:30" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "24:28:06" , 
"departure_time" : "24:28:46" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "24:30:40" , 
"departure_time" : "24:32:15" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 51,
"arrival_time" : "24:35:35" , 
"departure_time" : "24:36:23" , 
"distance_traveled" : 11.1142
}, 
{ 
"stop_id" : 126,
"arrival_time" : "24:37:48" , 
"departure_time" : "24:38:07" , 
"distance_traveled" : 12.6545
}, 
{ 
"stop_id" : 25,
"arrival_time" : "24:40:19" , 
"departure_time" : "24:40:26" , 
"distance_traveled" : 13.9055
}, 
{ 
"stop_id" : 121,
"arrival_time" : "24:45:07" , 
"departure_time" : "24:46:46" , 
"distance_traveled" : 16.6331
}, 
{ 
"stop_id" : 46,
"arrival_time" : "24:49:39" , 
"departure_time" : "24:51:14" , 
"distance_traveled" : 17.9117
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "24:52:35" , 
"departure_time" : "24:54:13" , 
"distance_traveled" : 18.9337
}, 
{ 
"stop_id" : 134,
"arrival_time" : "24:57:38" , 
"departure_time" : "24:57:53" , 
"distance_traveled" : 20.871
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "25:05:15" , 
"departure_time" : "25:06:23" , 
"distance_traveled" : 25.9892
}, 
{ 
"stop_id" : 63,
"arrival_time" : "25:22:08" , 
"departure_time" : "25:22:08" , 
"distance_traveled" : 29.5491
} ], 
"1333" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "24:08:00" , 
"departure_time" : "24:09:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "24:11:19" , 
"departure_time" : "24:11:38" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "24:14:19" , 
"departure_time" : "24:15:15" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "24:17:56" , 
"departure_time" : "24:19:08" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "24:21:12" , 
"departure_time" : "24:21:39" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "24:23:27" , 
"departure_time" : "24:24:33" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "24:28:06" , 
"departure_time" : "24:29:40" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "24:31:34" , 
"departure_time" : "24:33:02" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 51,
"arrival_time" : "24:35:28" , 
"departure_time" : "24:35:29" , 
"distance_traveled" : 11.1142
}, 
{ 
"stop_id" : 126,
"arrival_time" : "24:37:01" , 
"departure_time" : "24:38:07" , 
"distance_traveled" : 12.6545
}, 
{ 
"stop_id" : 25,
"arrival_time" : "24:41:06" , 
"departure_time" : "24:42:20" , 
"distance_traveled" : 13.9055
}, 
{ 
"stop_id" : 121,
"arrival_time" : "24:46:14" , 
"departure_time" : "24:47:08" , 
"distance_traveled" : 16.6331
}, 
{ 
"stop_id" : 46,
"arrival_time" : "24:48:54" , 
"departure_time" : "24:49:26" , 
"distance_traveled" : 17.9117
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "24:51:32" , 
"departure_time" : "24:52:05" , 
"distance_traveled" : 18.9337
}, 
{ 
"stop_id" : 134,
"arrival_time" : "24:56:33" , 
"departure_time" : "24:57:14" , 
"distance_traveled" : 20.871
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "25:05:41" , 
"departure_time" : "25:07:13" , 
"distance_traveled" : 25.9892
}, 
{ 
"stop_id" : 63,
"arrival_time" : "25:22:32" , 
"departure_time" : "25:22:32" , 
"distance_traveled" : 29.5491
} ], 
"1334" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "06:35:00" , 
"departure_time" : "06:37:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "06:39:14" , 
"departure_time" : "06:39:43" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "06:41:29" , 
"departure_time" : "06:41:38" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "06:45:09" , 
"departure_time" : "06:46:28" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "06:50:19" , 
"departure_time" : "06:51:41" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "06:53:22" , 
"departure_time" : "06:54:17" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "06:57:55" , 
"departure_time" : "06:58:10" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "07:00:15" , 
"departure_time" : "07:00:17" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "07:04:02" , 
"departure_time" : "07:05:31" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "07:09:29" , 
"departure_time" : "07:10:07" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:16:38" , 
"departure_time" : "07:17:45" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:29:07" , 
"departure_time" : "07:29:07" , 
"distance_traveled" : 22.2972
} ], 
"1335" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "06:35:00" , 
"departure_time" : "06:37:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "06:38:54" , 
"departure_time" : "06:40:31" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "06:42:37" , 
"departure_time" : "06:43:45" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "06:46:08" , 
"departure_time" : "06:46:42" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "06:49:34" , 
"departure_time" : "06:49:54" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "06:52:20" , 
"departure_time" : "06:53:00" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "06:57:40" , 
"departure_time" : "06:57:48" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "07:00:08" , 
"departure_time" : "07:00:15" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "07:04:07" , 
"departure_time" : "07:04:31" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "07:08:24" , 
"departure_time" : "07:09:21" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:16:57" , 
"departure_time" : "07:16:59" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:28:02" , 
"departure_time" : "07:28:02" , 
"distance_traveled" : 22.2972
} ], 
"1336" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "07:35:00" , 
"departure_time" : "07:36:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "07:39:32" , 
"departure_time" : "07:40:44" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "07:42:12" , 
"departure_time" : "07:43:19" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "07:46:07" , 
"departure_time" : "07:46:33" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "07:49:26" , 
"departure_time" : "07:50:43" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "07:53:17" , 
"departure_time" : "07:53:38" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "07:57:21" , 
"departure_time" : "07:58:02" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "08:00:41" , 
"departure_time" : "08:01:23" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "08:04:42" , 
"departure_time" : "08:05:38" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "08:08:56" , 
"departure_time" : "08:09:07" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:16:11" , 
"departure_time" : "08:17:14" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:29:03" , 
"departure_time" : "08:29:03" , 
"distance_traveled" : 22.2972
} ], 
"1337" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "07:35:00" , 
"departure_time" : "07:36:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "07:38:48" , 
"departure_time" : "07:40:23" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "07:42:35" , 
"departure_time" : "07:43:48" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "07:46:13" , 
"departure_time" : "07:47:07" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "07:49:54" , 
"departure_time" : "07:51:13" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "07:53:19" , 
"departure_time" : "07:54:26" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "07:58:07" , 
"departure_time" : "07:59:20" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "08:01:13" , 
"departure_time" : "08:02:24" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "08:05:11" , 
"departure_time" : "08:06:15" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "08:09:04" , 
"departure_time" : "08:09:21" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:16:17" , 
"departure_time" : "08:17:52" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:29:35" , 
"departure_time" : "08:29:35" , 
"distance_traveled" : 22.2972
} ], 
"1338" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "08:35:00" , 
"departure_time" : "08:37:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "08:38:52" , 
"departure_time" : "08:39:53" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "08:42:01" , 
"departure_time" : "08:42:44" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "08:45:43" , 
"departure_time" : "08:45:49" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "08:49:06" , 
"departure_time" : "08:49:30" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "08:52:24" , 
"departure_time" : "08:52:36" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "08:57:12" , 
"departure_time" : "08:57:46" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "09:00:34" , 
"departure_time" : "09:01:29" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "09:04:55" , 
"departure_time" : "09:06:06" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "09:09:11" , 
"departure_time" : "09:10:47" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:17:36" , 
"departure_time" : "09:17:58" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:28:22" , 
"departure_time" : "09:28:22" , 
"distance_traveled" : 22.2972
} ], 
"1339" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "08:35:00" , 
"departure_time" : "08:36:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "08:39:31" , 
"departure_time" : "08:39:48" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "08:41:17" , 
"departure_time" : "08:41:36" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "08:45:19" , 
"departure_time" : "08:45:43" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "08:49:24" , 
"departure_time" : "08:50:32" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "08:53:08" , 
"departure_time" : "08:53:53" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "08:57:45" , 
"departure_time" : "08:57:46" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "09:00:01" , 
"departure_time" : "09:00:31" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "09:04:30" , 
"departure_time" : "09:05:02" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "09:08:32" , 
"departure_time" : "09:08:38" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:16:06" , 
"departure_time" : "09:16:32" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:28:26" , 
"departure_time" : "09:28:26" , 
"distance_traveled" : 22.2972
} ], 
"1340" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "09:35:00" , 
"departure_time" : "09:35:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "09:38:11" , 
"departure_time" : "09:38:54" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "09:41:43" , 
"departure_time" : "09:43:18" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "09:46:35" , 
"departure_time" : "09:47:28" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "09:49:53" , 
"departure_time" : "09:50:52" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "09:52:59" , 
"departure_time" : "09:53:35" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "09:57:36" , 
"departure_time" : "09:59:06" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "10:01:30" , 
"departure_time" : "10:02:14" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "10:04:44" , 
"departure_time" : "10:05:29" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "10:08:45" , 
"departure_time" : "10:09:25" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "10:16:40" , 
"departure_time" : "10:17:13" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "10:28:33" , 
"departure_time" : "10:28:33" , 
"distance_traveled" : 22.2972
} ], 
"1341" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "09:35:00" , 
"departure_time" : "09:35:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "09:38:04" , 
"departure_time" : "09:38:52" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "09:41:48" , 
"departure_time" : "09:42:26" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "09:45:38" , 
"departure_time" : "09:45:47" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "09:49:09" , 
"departure_time" : "09:50:36" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "09:53:27" , 
"departure_time" : "09:54:20" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "09:57:53" , 
"departure_time" : "09:59:21" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "10:01:28" , 
"departure_time" : "10:01:31" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "10:04:03" , 
"departure_time" : "10:05:03" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "10:09:00" , 
"departure_time" : "10:10:14" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "10:17:14" , 
"departure_time" : "10:17:16" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "10:28:02" , 
"departure_time" : "10:28:02" , 
"distance_traveled" : 22.2972
} ], 
"1342" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "11:35:00" , 
"departure_time" : "11:36:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "11:39:35" , 
"departure_time" : "11:40:03" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "11:41:28" , 
"departure_time" : "11:41:59" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "11:45:31" , 
"departure_time" : "11:46:26" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "11:49:55" , 
"departure_time" : "11:50:33" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "11:52:38" , 
"departure_time" : "11:52:42" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "11:57:04" , 
"departure_time" : "11:57:23" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "12:00:19" , 
"departure_time" : "12:01:09" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "12:04:50" , 
"departure_time" : "12:05:45" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "12:08:55" , 
"departure_time" : "12:09:53" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "12:16:58" , 
"departure_time" : "12:18:19" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "12:29:21" , 
"departure_time" : "12:29:21" , 
"distance_traveled" : 22.2972
} ], 
"1343" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "11:35:00" , 
"departure_time" : "11:37:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "11:39:12" , 
"departure_time" : "11:40:02" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "11:41:50" , 
"departure_time" : "11:42:06" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "11:45:16" , 
"departure_time" : "11:45:46" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "11:49:30" , 
"departure_time" : "11:50:14" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "11:52:44" , 
"departure_time" : "11:53:25" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "11:57:41" , 
"departure_time" : "11:58:55" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "12:01:14" , 
"departure_time" : "12:02:44" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "12:05:30" , 
"departure_time" : "12:05:57" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "12:08:27" , 
"departure_time" : "12:09:45" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "12:17:18" , 
"departure_time" : "12:18:25" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "12:29:07" , 
"departure_time" : "12:29:07" , 
"distance_traveled" : 22.2972
} ], 
"1344" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "13:35:00" , 
"departure_time" : "13:37:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "13:39:21" , 
"departure_time" : "13:39:53" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "13:41:32" , 
"departure_time" : "13:42:26" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "13:45:54" , 
"departure_time" : "13:46:18" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "13:49:24" , 
"departure_time" : "13:51:01" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "13:53:37" , 
"departure_time" : "13:54:23" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "13:57:46" , 
"departure_time" : "13:57:49" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "14:00:03" , 
"departure_time" : "14:00:06" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "14:04:03" , 
"departure_time" : "14:04:21" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "14:08:18" , 
"departure_time" : "14:09:05" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "14:16:47" , 
"departure_time" : "14:18:19" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "14:29:32" , 
"departure_time" : "14:29:32" , 
"distance_traveled" : 22.2972
} ], 
"1345" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "13:35:00" , 
"departure_time" : "13:36:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "13:38:14" , 
"departure_time" : "13:39:25" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "13:42:11" , 
"departure_time" : "13:43:19" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "13:46:08" , 
"departure_time" : "13:46:27" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "13:49:19" , 
"departure_time" : "13:50:26" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "13:53:07" , 
"departure_time" : "13:54:09" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "13:58:02" , 
"departure_time" : "13:59:30" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "14:01:28" , 
"departure_time" : "14:02:59" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "14:05:31" , 
"departure_time" : "14:06:19" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "14:08:48" , 
"departure_time" : "14:10:08" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "14:17:20" , 
"departure_time" : "14:18:24" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "14:29:04" , 
"departure_time" : "14:29:04" , 
"distance_traveled" : 22.2972
} ], 
"1346" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "14:35:00" , 
"departure_time" : "14:36:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "14:38:24" , 
"departure_time" : "14:39:16" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "14:41:52" , 
"departure_time" : "14:43:14" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "14:46:22" , 
"departure_time" : "14:47:42" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "14:50:20" , 
"departure_time" : "14:51:17" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "14:52:57" , 
"departure_time" : "14:53:42" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "14:57:45" , 
"departure_time" : "14:58:13" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "15:00:28" , 
"departure_time" : "15:01:38" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "15:05:10" , 
"departure_time" : "15:06:29" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "15:09:19" , 
"departure_time" : "15:09:39" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "15:16:20" , 
"departure_time" : "15:17:24" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "15:29:04" , 
"departure_time" : "15:29:04" , 
"distance_traveled" : 22.2972
} ], 
"1347" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "14:35:00" , 
"departure_time" : "14:36:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "14:38:18" , 
"departure_time" : "14:39:49" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "14:42:31" , 
"departure_time" : "14:42:46" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "14:45:15" , 
"departure_time" : "14:46:35" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "14:50:20" , 
"departure_time" : "14:51:55" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "14:53:35" , 
"departure_time" : "14:54:01" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "14:57:26" , 
"departure_time" : "14:58:37" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "15:01:11" , 
"departure_time" : "15:02:09" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "15:04:58" , 
"departure_time" : "15:06:37" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "15:09:39" , 
"departure_time" : "15:10:14" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "15:16:35" , 
"departure_time" : "15:17:13" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "15:28:38" , 
"departure_time" : "15:28:38" , 
"distance_traveled" : 22.2972
} ], 
"1348" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "15:35:00" , 
"departure_time" : "15:36:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "15:38:48" , 
"departure_time" : "15:39:05" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "15:41:17" , 
"departure_time" : "15:42:09" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "15:45:52" , 
"departure_time" : "15:46:59" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "15:50:07" , 
"departure_time" : "15:50:46" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "15:52:39" , 
"departure_time" : "15:53:31" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "15:57:52" , 
"departure_time" : "15:59:05" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "16:01:13" , 
"departure_time" : "16:02:50" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "16:05:37" , 
"departure_time" : "16:05:44" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "16:08:07" , 
"departure_time" : "16:09:32" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:17:25" , 
"departure_time" : "16:17:31" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "16:28:06" , 
"departure_time" : "16:28:06" , 
"distance_traveled" : 22.2972
} ], 
"1349" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "15:35:00" , 
"departure_time" : "15:35:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "15:38:32" , 
"departure_time" : "15:39:10" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "15:41:38" , 
"departure_time" : "15:41:47" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "15:45:09" , 
"departure_time" : "15:45:28" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "15:49:19" , 
"departure_time" : "15:50:54" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "15:53:35" , 
"departure_time" : "15:54:33" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "15:57:58" , 
"departure_time" : "15:58:02" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "16:00:04" , 
"departure_time" : "16:01:13" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "16:05:09" , 
"departure_time" : "16:06:13" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "16:09:04" , 
"departure_time" : "16:10:30" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:17:26" , 
"departure_time" : "16:18:45" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "16:29:19" , 
"departure_time" : "16:29:19" , 
"distance_traveled" : 22.2972
} ], 
"1350" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "16:35:00" , 
"departure_time" : "16:36:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "16:38:30" , 
"departure_time" : "16:39:08" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "16:41:38" , 
"departure_time" : "16:42:25" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "16:45:47" , 
"departure_time" : "16:47:16" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "16:50:29" , 
"departure_time" : "16:51:39" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "16:53:10" , 
"departure_time" : "16:53:39" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "16:57:29" , 
"departure_time" : "16:58:33" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "17:01:04" , 
"departure_time" : "17:02:39" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "17:05:35" , 
"departure_time" : "17:06:07" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "17:08:32" , 
"departure_time" : "17:09:26" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:16:54" , 
"departure_time" : "17:18:15" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:29:21" , 
"departure_time" : "17:29:21" , 
"distance_traveled" : 22.2972
} ], 
"1351" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "16:35:00" , 
"departure_time" : "16:36:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "16:38:01" , 
"departure_time" : "16:38:14" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "16:41:13" , 
"departure_time" : "16:41:23" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "16:45:10" , 
"departure_time" : "16:45:53" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "16:49:43" , 
"departure_time" : "16:49:54" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "16:52:11" , 
"departure_time" : "16:53:34" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "16:58:23" , 
"departure_time" : "16:58:27" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "17:00:04" , 
"departure_time" : "17:00:55" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "17:04:51" , 
"departure_time" : "17:05:15" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "17:08:24" , 
"departure_time" : "17:09:20" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:16:56" , 
"departure_time" : "17:17:42" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:28:46" , 
"departure_time" : "17:28:46" , 
"distance_traveled" : 22.2972
} ], 
"1352" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "17:34:00" , 
"departure_time" : "17:36:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "17:39:31" , 
"departure_time" : "17:40:00" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "17:41:29" , 
"departure_time" : "17:41:41" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "17:45:12" , 
"departure_time" : "17:46:02" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "17:49:50" , 
"departure_time" : "17:51:12" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "17:53:22" , 
"departure_time" : "17:53:32" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "17:57:10" , 
"departure_time" : "17:58:37" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "18:01:27" , 
"departure_time" : "18:02:28" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "18:05:01" , 
"departure_time" : "18:05:43" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "18:08:42" , 
"departure_time" : "18:10:02" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:17:20" , 
"departure_time" : "18:17:34" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "18:28:14" , 
"departure_time" : "18:28:14" , 
"distance_traveled" : 22.2972
} ], 
"1353" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "17:34:00" , 
"departure_time" : "17:34:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "17:38:14" , 
"departure_time" : "17:39:37" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "17:42:23" , 
"departure_time" : "17:43:50" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "17:46:27" , 
"departure_time" : "17:47:57" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "17:50:30" , 
"departure_time" : "17:52:06" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "17:53:36" , 
"departure_time" : "17:54:59" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "17:58:23" , 
"departure_time" : "17:59:52" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "18:01:29" , 
"departure_time" : "18:02:48" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "18:05:19" , 
"departure_time" : "18:05:59" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "18:08:40" , 
"departure_time" : "18:09:28" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:16:48" , 
"departure_time" : "18:17:26" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "18:28:38" , 
"departure_time" : "18:28:38" , 
"distance_traveled" : 22.2972
} ], 
"1354" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "18:34:00" , 
"departure_time" : "18:35:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "18:39:18" , 
"departure_time" : "18:40:00" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:41:42" , 
"departure_time" : "18:43:14" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "18:46:32" , 
"departure_time" : "18:46:52" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "18:49:20" , 
"departure_time" : "18:50:44" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "18:53:24" , 
"departure_time" : "18:53:56" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "18:57:32" , 
"departure_time" : "18:58:47" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "19:01:15" , 
"departure_time" : "19:01:42" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "19:04:27" , 
"departure_time" : "19:05:50" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "19:09:23" , 
"departure_time" : "19:10:17" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:16:54" , 
"departure_time" : "19:17:34" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "19:28:40" , 
"departure_time" : "19:28:40" , 
"distance_traveled" : 22.2972
} ], 
"1355" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "18:34:00" , 
"departure_time" : "18:35:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "18:38:54" , 
"departure_time" : "18:39:58" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:42:04" , 
"departure_time" : "18:43:39" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "18:46:35" , 
"departure_time" : "18:47:41" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "18:50:06" , 
"departure_time" : "18:51:37" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "18:53:31" , 
"departure_time" : "18:53:52" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "18:57:21" , 
"departure_time" : "18:57:53" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "19:00:32" , 
"departure_time" : "19:01:14" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "19:04:42" , 
"departure_time" : "19:04:59" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "19:08:17" , 
"departure_time" : "19:09:31" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:17:14" , 
"departure_time" : "19:17:20" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "19:28:06" , 
"departure_time" : "19:28:06" , 
"distance_traveled" : 22.2972
} ], 
"1356" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "19:34:00" , 
"departure_time" : "19:34:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "19:38:13" , 
"departure_time" : "19:39:01" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "19:41:48" , 
"departure_time" : "19:43:01" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "19:46:13" , 
"departure_time" : "19:46:47" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "19:49:34" , 
"departure_time" : "19:49:50" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "19:52:16" , 
"departure_time" : "19:52:41" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "19:57:25" , 
"departure_time" : "19:57:31" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "20:00:06" , 
"departure_time" : "20:00:53" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "20:04:47" , 
"departure_time" : "20:05:52" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "20:09:05" , 
"departure_time" : "20:09:21" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "20:16:16" , 
"departure_time" : "20:17:13" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "20:28:57" , 
"departure_time" : "20:28:57" , 
"distance_traveled" : 22.2972
} ], 
"1357" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "19:34:00" , 
"departure_time" : "19:35:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "19:38:22" , 
"departure_time" : "19:39:19" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "19:41:57" , 
"departure_time" : "19:42:49" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "19:45:52" , 
"departure_time" : "19:46:20" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "19:49:28" , 
"departure_time" : "19:50:43" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "19:53:15" , 
"departure_time" : "19:53:41" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "19:57:26" , 
"departure_time" : "19:57:28" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "20:00:02" , 
"departure_time" : "20:00:54" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "20:04:52" , 
"departure_time" : "20:05:24" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "20:08:32" , 
"departure_time" : "20:09:13" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "20:16:41" , 
"departure_time" : "20:17:01" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "20:28:20" , 
"departure_time" : "20:28:20" , 
"distance_traveled" : 22.2972
} ], 
"1358" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "20:35:00" , 
"departure_time" : "20:35:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "20:38:14" , 
"departure_time" : "20:38:54" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "20:41:40" , 
"departure_time" : "20:43:18" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "20:46:38" , 
"departure_time" : "20:48:01" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "20:50:23" , 
"departure_time" : "20:51:28" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "20:53:05" , 
"departure_time" : "20:54:37" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "20:58:32" , 
"departure_time" : "20:58:53" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "21:00:21" , 
"departure_time" : "21:00:44" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "21:04:23" , 
"departure_time" : "21:04:44" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "21:08:21" , 
"departure_time" : "21:09:58" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "21:17:37" , 
"departure_time" : "21:17:38" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "21:28:01" , 
"departure_time" : "21:28:01" , 
"distance_traveled" : 22.2972
} ], 
"1359" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "20:35:00" , 
"departure_time" : "20:35:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "20:38:24" , 
"departure_time" : "20:39:08" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "20:41:44" , 
"departure_time" : "20:42:05" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "20:45:21" , 
"departure_time" : "20:45:37" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "20:49:16" , 
"departure_time" : "20:50:24" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "20:53:08" , 
"departure_time" : "20:53:55" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "20:57:47" , 
"departure_time" : "20:58:55" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "21:01:08" , 
"departure_time" : "21:01:42" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "21:04:34" , 
"departure_time" : "21:05:43" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "21:09:09" , 
"departure_time" : "21:10:30" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "21:17:21" , 
"departure_time" : "21:18:09" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "21:28:48" , 
"departure_time" : "21:28:48" , 
"distance_traveled" : 22.2972
} ], 
"1360" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "21:35:00" , 
"departure_time" : "21:37:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "21:39:38" , 
"departure_time" : "21:41:17" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "21:42:39" , 
"departure_time" : "21:43:40" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "21:46:01" , 
"departure_time" : "21:47:27" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "21:50:26" , 
"departure_time" : "21:51:25" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "21:52:59" , 
"departure_time" : "21:54:16" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "21:58:17" , 
"departure_time" : "21:59:21" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "22:01:04" , 
"departure_time" : "22:02:11" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "22:05:07" , 
"departure_time" : "22:05:16" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "22:08:09" , 
"departure_time" : "22:09:49" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "22:17:40" , 
"departure_time" : "22:19:15" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "22:29:35" , 
"departure_time" : "22:29:35" , 
"distance_traveled" : 22.2972
} ], 
"1361" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "21:35:00" , 
"departure_time" : "21:36:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "21:38:03" , 
"departure_time" : "21:38:30" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "21:41:27" , 
"departure_time" : "21:42:17" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "21:45:50" , 
"departure_time" : "21:46:51" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "21:50:01" , 
"departure_time" : "21:51:22" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "21:53:21" , 
"departure_time" : "21:54:21" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "21:58:00" , 
"departure_time" : "21:59:39" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "22:01:39" , 
"departure_time" : "22:02:31" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "22:04:52" , 
"departure_time" : "22:06:00" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "22:09:08" , 
"departure_time" : "22:10:01" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "22:16:53" , 
"departure_time" : "22:18:01" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "22:29:08" , 
"departure_time" : "22:29:08" , 
"distance_traveled" : 22.2972
} ], 
"1362" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "22:18:00" , 
"departure_time" : "22:19:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "22:21:19" , 
"departure_time" : "22:22:36" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "22:25:17" , 
"departure_time" : "22:26:21" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "22:28:04" , 
"departure_time" : "22:28:40" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "22:31:36" , 
"departure_time" : "22:32:27" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "22:35:51" , 
"departure_time" : "22:37:15" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "22:39:24" , 
"departure_time" : "22:39:26" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "22:41:02" , 
"departure_time" : "22:41:42" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 51,
"arrival_time" : "22:45:40" , 
"departure_time" : "22:46:31" , 
"distance_traveled" : 11.1142
}, 
{ 
"stop_id" : 126,
"arrival_time" : "22:49:51" , 
"departure_time" : "22:50:16" , 
"distance_traveled" : 12.6545
}, 
{ 
"stop_id" : 25,
"arrival_time" : "22:52:25" , 
"departure_time" : "22:53:04" , 
"distance_traveled" : 13.9055
}, 
{ 
"stop_id" : 121,
"arrival_time" : "22:57:39" , 
"departure_time" : "22:59:10" , 
"distance_traveled" : 16.6331
}, 
{ 
"stop_id" : 46,
"arrival_time" : "23:01:31" , 
"departure_time" : "23:02:59" , 
"distance_traveled" : 17.9117
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "23:05:28" , 
"departure_time" : "23:06:39" , 
"distance_traveled" : 18.9337
}, 
{ 
"stop_id" : 134,
"arrival_time" : "23:09:11" , 
"departure_time" : "23:09:30" , 
"distance_traveled" : 20.871
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "23:16:19" , 
"departure_time" : "23:17:12" , 
"distance_traveled" : 25.9892
}, 
{ 
"stop_id" : 63,
"arrival_time" : "23:28:53" , 
"departure_time" : "23:28:53" , 
"distance_traveled" : 29.5491
} ], 
"1363" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "22:18:00" , 
"departure_time" : "22:20:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "22:22:16" , 
"departure_time" : "22:22:39" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "22:24:23" , 
"departure_time" : "22:25:45" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "22:28:22" , 
"departure_time" : "22:28:50" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "22:31:28" , 
"departure_time" : "22:31:35" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "22:35:07" , 
"departure_time" : "22:35:24" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "22:38:17" , 
"departure_time" : "22:38:24" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "22:41:07" , 
"departure_time" : "22:41:12" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 51,
"arrival_time" : "22:45:05" , 
"departure_time" : "22:45:49" , 
"distance_traveled" : 11.1142
}, 
{ 
"stop_id" : 126,
"arrival_time" : "22:49:44" , 
"departure_time" : "22:51:06" , 
"distance_traveled" : 12.6545
}, 
{ 
"stop_id" : 25,
"arrival_time" : "22:53:22" , 
"departure_time" : "22:54:59" , 
"distance_traveled" : 13.9055
}, 
{ 
"stop_id" : 121,
"arrival_time" : "22:58:37" , 
"departure_time" : "23:00:12" , 
"distance_traveled" : 16.6331
}, 
{ 
"stop_id" : 46,
"arrival_time" : "23:01:35" , 
"departure_time" : "23:02:01" , 
"distance_traveled" : 17.9117
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "23:04:26" , 
"departure_time" : "23:05:48" , 
"distance_traveled" : 18.9337
}, 
{ 
"stop_id" : 134,
"arrival_time" : "23:09:22" , 
"departure_time" : "23:10:03" , 
"distance_traveled" : 20.871
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "23:16:41" , 
"departure_time" : "23:17:53" , 
"distance_traveled" : 25.9892
}, 
{ 
"stop_id" : 63,
"arrival_time" : "23:29:12" , 
"departure_time" : "23:29:12" , 
"distance_traveled" : 29.5491
} ], 
"1364" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "07:08:00" , 
"departure_time" : "07:10:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "07:12:22" , 
"departure_time" : "07:13:31" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "07:15:09" , 
"departure_time" : "07:15:28" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "07:17:19" , 
"departure_time" : "07:17:35" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "07:20:16" , 
"departure_time" : "07:21:25" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "07:24:09" , 
"departure_time" : "07:24:58" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "07:27:49" , 
"departure_time" : "07:28:02" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "07:30:13" , 
"departure_time" : "07:30:34" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "07:33:21" , 
"departure_time" : "07:33:30" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "07:37:09" , 
"departure_time" : "07:37:43" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "07:42:34" , 
"departure_time" : "07:43:19" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "07:48:45" , 
"departure_time" : "07:49:04" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "07:51:19" , 
"departure_time" : "07:52:21" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "07:55:02" , 
"departure_time" : "07:56:00" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "07:57:58" , 
"departure_time" : "07:58:13" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "07:59:15" , 
"departure_time" : "08:00:44" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:08:29" , 
"departure_time" : "08:08:32" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:19:03" , 
"departure_time" : "08:19:03" , 
"distance_traveled" : 30.7472
} ], 
"1365" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "07:08:00" , 
"departure_time" : "07:08:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "07:11:16" , 
"departure_time" : "07:12:35" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "07:15:19" , 
"departure_time" : "07:16:41" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "07:18:22" , 
"departure_time" : "07:19:18" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "07:20:56" , 
"departure_time" : "07:22:02" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "07:24:06" , 
"departure_time" : "07:24:57" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "07:27:51" , 
"departure_time" : "07:29:07" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "07:31:16" , 
"departure_time" : "07:32:20" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "07:34:04" , 
"departure_time" : "07:34:28" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "07:37:24" , 
"departure_time" : "07:37:41" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "07:42:17" , 
"departure_time" : "07:43:11" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "07:48:54" , 
"departure_time" : "07:49:40" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "07:51:46" , 
"departure_time" : "07:52:22" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "07:54:36" , 
"departure_time" : "07:55:54" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "07:58:18" , 
"departure_time" : "07:58:28" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "07:59:10" , 
"departure_time" : "08:00:34" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:08:24" , 
"departure_time" : "08:09:42" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:20:18" , 
"departure_time" : "08:20:18" , 
"distance_traveled" : 30.7472
} ], 
"1366" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "08:08:00" , 
"departure_time" : "08:10:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "08:12:08" , 
"departure_time" : "08:13:27" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "08:15:19" , 
"departure_time" : "08:15:33" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "08:17:14" , 
"departure_time" : "08:17:57" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "08:20:43" , 
"departure_time" : "08:21:55" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "08:24:12" , 
"departure_time" : "08:25:47" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "08:28:35" , 
"departure_time" : "08:28:44" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "08:30:09" , 
"departure_time" : "08:30:27" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "08:33:18" , 
"departure_time" : "08:34:46" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "08:38:28" , 
"departure_time" : "08:38:58" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "08:42:30" , 
"departure_time" : "08:43:34" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "08:49:04" , 
"departure_time" : "08:49:58" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "08:51:54" , 
"departure_time" : "08:52:52" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "08:54:58" , 
"departure_time" : "08:55:01" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "08:57:03" , 
"departure_time" : "08:58:11" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "09:00:08" , 
"departure_time" : "09:01:03" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:07:55" , 
"departure_time" : "09:08:41" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:19:46" , 
"departure_time" : "09:19:46" , 
"distance_traveled" : 30.7472
} ], 
"1367" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "08:08:00" , 
"departure_time" : "08:09:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "08:11:36" , 
"departure_time" : "08:13:01" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "08:15:25" , 
"departure_time" : "08:15:43" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "08:17:18" , 
"departure_time" : "08:18:55" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "08:21:37" , 
"departure_time" : "08:22:57" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "08:24:20" , 
"departure_time" : "08:25:15" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "08:27:55" , 
"departure_time" : "08:28:17" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "08:30:22" , 
"departure_time" : "08:30:24" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "08:33:02" , 
"departure_time" : "08:34:14" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "08:38:12" , 
"departure_time" : "08:38:22" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "08:42:10" , 
"departure_time" : "08:43:14" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "08:49:04" , 
"departure_time" : "08:49:31" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "08:51:27" , 
"departure_time" : "08:51:37" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "08:54:10" , 
"departure_time" : "08:55:27" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "08:58:17" , 
"departure_time" : "08:58:54" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "08:59:37" , 
"departure_time" : "08:59:56" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:07:19" , 
"departure_time" : "09:08:39" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:20:20" , 
"departure_time" : "09:20:20" , 
"distance_traveled" : 30.7472
} ], 
"1368" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "09:08:00" , 
"departure_time" : "09:10:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "09:12:30" , 
"departure_time" : "09:13:58" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "09:15:28" , 
"departure_time" : "09:16:45" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "09:18:17" , 
"departure_time" : "09:19:49" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "09:21:32" , 
"departure_time" : "09:22:52" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "09:24:20" , 
"departure_time" : "09:25:21" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "09:28:01" , 
"departure_time" : "09:29:27" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "09:31:26" , 
"departure_time" : "09:32:47" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "09:34:21" , 
"departure_time" : "09:35:37" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "09:38:16" , 
"departure_time" : "09:38:49" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "09:42:33" , 
"departure_time" : "09:42:36" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "09:48:03" , 
"departure_time" : "09:48:23" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "09:51:20" , 
"departure_time" : "09:52:17" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "09:54:57" , 
"departure_time" : "09:56:04" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "09:58:07" , 
"departure_time" : "09:59:36" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "10:00:29" , 
"departure_time" : "10:01:48" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "10:08:19" , 
"departure_time" : "10:09:04" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "10:19:45" , 
"departure_time" : "10:19:45" , 
"distance_traveled" : 30.7472
} ], 
"1369" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "09:08:00" , 
"departure_time" : "09:10:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "09:12:24" , 
"departure_time" : "09:13:24" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "09:15:00" , 
"departure_time" : "09:15:37" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "09:17:37" , 
"departure_time" : "09:18:48" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "09:21:11" , 
"departure_time" : "09:22:38" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "09:24:27" , 
"departure_time" : "09:25:13" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "09:27:46" , 
"departure_time" : "09:28:33" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "09:30:47" , 
"departure_time" : "09:31:04" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "09:33:17" , 
"departure_time" : "09:33:36" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "09:37:19" , 
"departure_time" : "09:37:56" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "09:42:37" , 
"departure_time" : "09:43:01" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "09:48:24" , 
"departure_time" : "09:49:01" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "09:51:37" , 
"departure_time" : "09:51:52" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "09:54:15" , 
"departure_time" : "09:55:54" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "09:58:39" , 
"departure_time" : "09:59:44" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "10:00:05" , 
"departure_time" : "10:01:33" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "10:08:28" , 
"departure_time" : "10:10:01" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "10:20:33" , 
"departure_time" : "10:20:33" , 
"distance_traveled" : 30.7472
} ], 
"1370" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "10:08:00" , 
"departure_time" : "10:11:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "10:12:34" , 
"departure_time" : "10:13:46" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "10:15:12" , 
"departure_time" : "10:15:42" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "10:17:30" , 
"departure_time" : "10:18:24" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "10:20:54" , 
"departure_time" : "10:22:20" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "10:24:26" , 
"departure_time" : "10:24:52" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "10:27:26" , 
"departure_time" : "10:27:57" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "10:30:31" , 
"departure_time" : "10:31:22" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "10:33:51" , 
"departure_time" : "10:34:32" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "10:37:41" , 
"departure_time" : "10:37:57" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "10:42:16" , 
"departure_time" : "10:43:43" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "10:49:27" , 
"departure_time" : "10:49:36" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "10:51:09" , 
"departure_time" : "10:51:12" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "10:54:03" , 
"departure_time" : "10:54:37" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "10:57:34" , 
"departure_time" : "10:57:52" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "10:59:18" , 
"departure_time" : "11:00:48" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "11:08:30" , 
"departure_time" : "11:08:50" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "11:19:20" , 
"departure_time" : "11:19:20" , 
"distance_traveled" : 30.7472
} ], 
"1371" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "10:08:00" , 
"departure_time" : "10:09:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "10:12:34" , 
"departure_time" : "10:13:37" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "10:15:03" , 
"departure_time" : "10:15:33" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "10:17:30" , 
"departure_time" : "10:18:50" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "10:21:20" , 
"departure_time" : "10:21:40" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "10:23:20" , 
"departure_time" : "10:23:55" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "10:27:35" , 
"departure_time" : "10:28:04" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "10:30:29" , 
"departure_time" : "10:31:13" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "10:33:44" , 
"departure_time" : "10:34:10" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "10:37:26" , 
"departure_time" : "10:39:02" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "10:43:36" , 
"departure_time" : "10:43:44" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "10:48:08" , 
"departure_time" : "10:49:00" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "10:51:52" , 
"departure_time" : "10:53:08" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "10:55:16" , 
"departure_time" : "10:56:10" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "10:57:54" , 
"departure_time" : "10:58:58" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "11:00:04" , 
"departure_time" : "11:00:42" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "11:07:38" , 
"departure_time" : "11:08:47" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "11:20:09" , 
"departure_time" : "11:20:09" , 
"distance_traveled" : 30.7472
} ], 
"1372" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "11:08:00" , 
"departure_time" : "11:09:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "11:11:35" , 
"departure_time" : "11:13:09" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "11:15:34" , 
"departure_time" : "11:16:04" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "11:17:30" , 
"departure_time" : "11:19:07" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "11:21:37" , 
"departure_time" : "11:22:39" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "11:24:02" , 
"departure_time" : "11:24:36" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "11:27:34" , 
"departure_time" : "11:28:56" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "11:31:22" , 
"departure_time" : "11:31:40" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "11:33:18" , 
"departure_time" : "11:34:48" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "11:38:30" , 
"departure_time" : "11:39:03" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "11:42:33" , 
"departure_time" : "11:43:20" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "11:48:47" , 
"departure_time" : "11:48:57" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "11:51:10" , 
"departure_time" : "11:51:12" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "11:54:02" , 
"departure_time" : "11:54:20" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "11:57:18" , 
"departure_time" : "11:58:24" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "12:00:06" , 
"departure_time" : "12:01:37" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "12:08:31" , 
"departure_time" : "12:09:30" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "12:19:59" , 
"departure_time" : "12:19:59" , 
"distance_traveled" : 30.7472
} ], 
"1373" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "11:08:00" , 
"departure_time" : "11:10:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "11:12:10" , 
"departure_time" : "11:13:24" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "11:15:14" , 
"departure_time" : "11:15:43" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "11:17:29" , 
"departure_time" : "11:17:58" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "11:20:29" , 
"departure_time" : "11:21:46" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "11:24:17" , 
"departure_time" : "11:25:12" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "11:27:55" , 
"departure_time" : "11:28:36" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "11:30:41" , 
"departure_time" : "11:31:00" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "11:33:19" , 
"departure_time" : "11:34:46" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "11:38:27" , 
"departure_time" : "11:38:50" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "11:42:23" , 
"departure_time" : "11:42:34" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "11:48:11" , 
"departure_time" : "11:49:13" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "11:52:02" , 
"departure_time" : "11:53:04" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "11:55:02" , 
"departure_time" : "11:56:01" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "11:57:59" , 
"departure_time" : "11:58:03" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "11:59:04" , 
"departure_time" : "11:59:17" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "12:07:13" , 
"departure_time" : "12:07:39" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "12:19:26" , 
"departure_time" : "12:19:26" , 
"distance_traveled" : 30.7472
} ], 
"1374" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "12:08:00" , 
"departure_time" : "12:09:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "12:11:52" , 
"departure_time" : "12:12:11" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "12:14:19" , 
"departure_time" : "12:15:28" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "12:18:09" , 
"departure_time" : "12:18:11" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "12:20:02" , 
"departure_time" : "12:21:31" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "12:24:29" , 
"departure_time" : "12:25:48" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "12:28:19" , 
"departure_time" : "12:29:24" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "12:31:05" , 
"departure_time" : "12:31:15" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "12:33:10" , 
"departure_time" : "12:33:14" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "12:37:04" , 
"departure_time" : "12:37:57" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "12:42:53" , 
"departure_time" : "12:44:24" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "12:49:31" , 
"departure_time" : "12:50:39" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "12:52:08" , 
"departure_time" : "12:53:46" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "12:55:38" , 
"departure_time" : "12:55:42" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "12:57:04" , 
"departure_time" : "12:57:39" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "12:59:35" , 
"departure_time" : "12:59:59" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "13:07:24" , 
"departure_time" : "13:08:20" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "13:19:56" , 
"departure_time" : "13:19:56" , 
"distance_traveled" : 30.7472
} ], 
"1375" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "12:08:00" , 
"departure_time" : "12:09:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "12:11:31" , 
"departure_time" : "12:12:25" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "12:14:54" , 
"departure_time" : "12:15:57" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "12:18:03" , 
"departure_time" : "12:18:06" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "12:20:03" , 
"departure_time" : "12:20:25" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "12:23:22" , 
"departure_time" : "12:23:53" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "12:27:31" , 
"departure_time" : "12:29:04" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "12:31:33" , 
"departure_time" : "12:32:31" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "12:33:58" , 
"departure_time" : "12:35:21" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "12:38:23" , 
"departure_time" : "12:38:59" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "12:42:36" , 
"departure_time" : "12:43:03" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "12:48:27" , 
"departure_time" : "12:49:45" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "12:52:18" , 
"departure_time" : "12:53:26" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "12:55:08" , 
"departure_time" : "12:55:17" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "12:57:09" , 
"departure_time" : "12:58:00" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "12:59:51" , 
"departure_time" : "13:01:03" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "13:08:12" , 
"departure_time" : "13:09:50" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "13:20:38" , 
"departure_time" : "13:20:38" , 
"distance_traveled" : 30.7472
} ], 
"1376" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "13:08:00" , 
"departure_time" : "13:10:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "13:11:54" , 
"departure_time" : "13:13:33" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "13:15:39" , 
"departure_time" : "13:16:15" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "13:17:36" , 
"departure_time" : "13:18:47" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "13:21:11" , 
"departure_time" : "13:21:56" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "13:23:45" , 
"departure_time" : "13:23:52" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "13:27:07" , 
"departure_time" : "13:27:29" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "13:30:22" , 
"departure_time" : "13:31:43" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "13:34:21" , 
"departure_time" : "13:35:06" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "13:37:45" , 
"departure_time" : "13:38:23" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "13:42:38" , 
"departure_time" : "13:43:12" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "13:48:34" , 
"departure_time" : "13:48:54" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "13:51:20" , 
"departure_time" : "13:52:29" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "13:55:09" , 
"departure_time" : "13:56:18" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "13:58:09" , 
"departure_time" : "13:59:05" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "13:59:56" , 
"departure_time" : "14:00:38" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "14:07:42" , 
"departure_time" : "14:08:58" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "14:20:16" , 
"departure_time" : "14:20:16" , 
"distance_traveled" : 30.7472
} ], 
"1377" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "13:08:00" , 
"departure_time" : "13:09:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "13:11:02" , 
"departure_time" : "13:11:38" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "13:14:36" , 
"departure_time" : "13:15:08" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "13:17:32" , 
"departure_time" : "13:17:40" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "13:20:08" , 
"departure_time" : "13:21:17" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "13:24:09" , 
"departure_time" : "13:24:57" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "13:27:48" , 
"departure_time" : "13:28:00" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "13:30:12" , 
"departure_time" : "13:31:29" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "13:34:17" , 
"departure_time" : "13:35:12" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "13:37:55" , 
"departure_time" : "13:39:12" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "13:43:17" , 
"departure_time" : "13:44:06" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "13:48:49" , 
"departure_time" : "13:49:09" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "13:51:20" , 
"departure_time" : "13:52:10" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "13:54:50" , 
"departure_time" : "13:55:16" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "13:57:26" , 
"departure_time" : "13:58:30" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "14:00:04" , 
"departure_time" : "14:01:22" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "14:08:18" , 
"departure_time" : "14:08:43" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "14:19:25" , 
"departure_time" : "14:19:25" , 
"distance_traveled" : 30.7472
} ], 
"1378" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "14:08:00" , 
"departure_time" : "14:08:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "14:11:33" , 
"departure_time" : "14:12:39" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "14:15:06" , 
"departure_time" : "14:16:05" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "14:17:59" , 
"departure_time" : "14:18:56" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "14:20:57" , 
"departure_time" : "14:20:59" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "14:23:02" , 
"departure_time" : "14:23:12" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "14:27:10" , 
"departure_time" : "14:27:50" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "14:30:40" , 
"departure_time" : "14:31:24" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "14:33:44" , 
"departure_time" : "14:34:04" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "14:37:20" , 
"departure_time" : "14:38:15" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "14:42:55" , 
"departure_time" : "14:43:51" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "14:48:56" , 
"departure_time" : "14:49:12" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "14:51:16" , 
"departure_time" : "14:52:23" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "14:55:07" , 
"departure_time" : "14:56:11" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "14:58:04" , 
"departure_time" : "14:58:11" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "14:59:07" , 
"departure_time" : "14:59:40" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "15:07:33" , 
"departure_time" : "15:08:43" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "15:20:10" , 
"departure_time" : "15:20:10" , 
"distance_traveled" : 30.7472
} ], 
"1379" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "14:08:00" , 
"departure_time" : "14:10:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "14:12:04" , 
"departure_time" : "14:13:14" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "14:15:10" , 
"departure_time" : "14:15:29" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "14:17:19" , 
"departure_time" : "14:18:19" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "14:21:00" , 
"departure_time" : "14:22:31" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "14:24:31" , 
"departure_time" : "14:25:48" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "14:28:17" , 
"departure_time" : "14:29:56" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "14:31:39" , 
"departure_time" : "14:32:26" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "14:33:47" , 
"departure_time" : "14:34:59" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "14:38:12" , 
"departure_time" : "14:38:40" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "14:42:28" , 
"departure_time" : "14:42:43" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "14:48:15" , 
"departure_time" : "14:48:16" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "14:51:01" , 
"departure_time" : "14:51:42" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "14:54:41" , 
"departure_time" : "14:56:04" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "14:58:23" , 
"departure_time" : "14:59:29" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "15:00:06" , 
"departure_time" : "15:01:07" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "15:08:01" , 
"departure_time" : "15:08:55" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "15:19:54" , 
"departure_time" : "15:19:54" , 
"distance_traveled" : 30.7472
} ], 
"1380" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "15:08:00" , 
"departure_time" : "15:10:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "15:12:39" , 
"departure_time" : "15:13:42" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "15:15:03" , 
"departure_time" : "15:16:06" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "15:18:03" , 
"departure_time" : "15:18:42" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "15:20:39" , 
"departure_time" : "15:21:29" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "15:23:50" , 
"departure_time" : "15:23:52" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "15:27:02" , 
"departure_time" : "15:28:10" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "15:31:08" , 
"departure_time" : "15:32:04" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "15:33:56" , 
"departure_time" : "15:35:36" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "15:38:40" , 
"departure_time" : "15:40:04" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "15:43:24" , 
"departure_time" : "15:44:32" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "15:49:08" , 
"departure_time" : "15:50:48" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "15:52:40" , 
"departure_time" : "15:52:59" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "15:54:19" , 
"departure_time" : "15:55:17" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "15:57:58" , 
"departure_time" : "15:58:27" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "15:59:29" , 
"departure_time" : "16:00:16" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:07:47" , 
"departure_time" : "16:09:09" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "16:20:22" , 
"departure_time" : "16:20:22" , 
"distance_traveled" : 30.7472
} ], 
"1381" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "15:08:00" , 
"departure_time" : "15:10:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "15:12:20" , 
"departure_time" : "15:13:50" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "15:15:30" , 
"departure_time" : "15:15:57" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "15:17:27" , 
"departure_time" : "15:18:49" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "15:21:22" , 
"departure_time" : "15:21:59" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "15:23:37" , 
"departure_time" : "15:24:15" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "15:27:38" , 
"departure_time" : "15:27:49" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "15:30:11" , 
"departure_time" : "15:30:36" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "15:33:25" , 
"departure_time" : "15:34:24" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "15:37:59" , 
"departure_time" : "15:38:29" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "15:42:30" , 
"departure_time" : "15:43:21" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "15:48:51" , 
"departure_time" : "15:50:11" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "15:52:20" , 
"departure_time" : "15:53:36" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "15:55:16" , 
"departure_time" : "15:55:21" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "15:57:05" , 
"departure_time" : "15:58:30" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "16:00:25" , 
"departure_time" : "16:00:57" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:07:32" , 
"departure_time" : "16:08:01" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "16:19:29" , 
"departure_time" : "16:19:29" , 
"distance_traveled" : 30.7472
} ], 
"1382" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "16:08:00" , 
"departure_time" : "16:09:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "16:11:31" , 
"departure_time" : "16:12:59" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "16:15:28" , 
"departure_time" : "16:16:59" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "16:18:31" , 
"departure_time" : "16:19:53" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "16:21:22" , 
"departure_time" : "16:21:57" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "16:23:35" , 
"departure_time" : "16:23:57" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "16:27:22" , 
"departure_time" : "16:27:28" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "16:30:06" , 
"departure_time" : "16:30:40" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "16:33:34" , 
"departure_time" : "16:35:09" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "16:38:35" , 
"departure_time" : "16:39:35" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "16:43:00" , 
"departure_time" : "16:44:02" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "16:49:02" , 
"departure_time" : "16:49:19" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "16:51:17" , 
"departure_time" : "16:51:34" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "16:54:17" , 
"departure_time" : "16:55:06" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "16:57:49" , 
"departure_time" : "16:58:18" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "16:59:29" , 
"departure_time" : "17:00:26" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:07:57" , 
"departure_time" : "17:08:14" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:19:17" , 
"departure_time" : "17:19:17" , 
"distance_traveled" : 30.7472
} ], 
"1383" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "16:08:00" , 
"departure_time" : "16:09:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "16:11:52" , 
"departure_time" : "16:12:11" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "16:14:19" , 
"departure_time" : "16:15:35" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "16:18:16" , 
"departure_time" : "16:19:12" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "16:20:56" , 
"departure_time" : "16:22:03" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "16:24:07" , 
"departure_time" : "16:24:09" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "16:27:02" , 
"departure_time" : "16:28:17" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "16:31:15" , 
"departure_time" : "16:32:27" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "16:34:12" , 
"departure_time" : "16:35:24" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "16:38:12" , 
"departure_time" : "16:39:08" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "16:42:56" , 
"departure_time" : "16:44:13" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "16:49:17" , 
"departure_time" : "16:49:44" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "16:51:27" , 
"departure_time" : "16:51:42" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "16:54:15" , 
"departure_time" : "16:55:28" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "16:58:13" , 
"departure_time" : "16:59:49" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "17:00:36" , 
"departure_time" : "17:01:42" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:08:06" , 
"departure_time" : "17:09:08" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:20:02" , 
"departure_time" : "17:20:02" , 
"distance_traveled" : 30.7472
} ], 
"1384" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "17:08:00" , 
"departure_time" : "17:09:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "17:11:04" , 
"departure_time" : "17:12:28" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "17:15:24" , 
"departure_time" : "17:16:32" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "17:18:08" , 
"departure_time" : "17:18:38" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "17:20:30" , 
"departure_time" : "17:20:51" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "17:23:21" , 
"departure_time" : "17:24:07" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "17:27:46" , 
"departure_time" : "17:29:05" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "17:31:19" , 
"departure_time" : "17:32:41" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "17:34:22" , 
"departure_time" : "17:35:52" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "17:38:30" , 
"departure_time" : "17:39:27" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "17:42:57" , 
"departure_time" : "17:43:01" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "17:48:04" , 
"departure_time" : "17:48:46" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "17:51:42" , 
"departure_time" : "17:52:43" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "17:55:01" , 
"departure_time" : "17:55:14" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "17:57:13" , 
"departure_time" : "17:58:53" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "18:00:40" , 
"departure_time" : "18:01:04" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:07:24" , 
"departure_time" : "18:09:01" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "18:20:37" , 
"departure_time" : "18:20:37" , 
"distance_traveled" : 30.7472
} ], 
"1385" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "17:08:00" , 
"departure_time" : "17:09:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "17:11:04" , 
"departure_time" : "17:12:27" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "17:15:23" , 
"departure_time" : "17:15:39" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "17:17:16" , 
"departure_time" : "17:18:54" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "17:21:38" , 
"departure_time" : "17:22:00" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "17:23:22" , 
"departure_time" : "17:23:55" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "17:27:33" , 
"departure_time" : "17:27:42" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "17:30:09" , 
"departure_time" : "17:30:56" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "17:33:47" , 
"departure_time" : "17:34:16" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "17:37:29" , 
"departure_time" : "17:38:47" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "17:43:18" , 
"departure_time" : "17:44:40" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "17:49:22" , 
"departure_time" : "17:50:23" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "17:52:01" , 
"departure_time" : "17:53:32" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "17:55:31" , 
"departure_time" : "17:56:43" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "17:58:12" , 
"departure_time" : "17:58:36" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "17:59:24" , 
"departure_time" : "17:59:53" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:07:29" , 
"departure_time" : "18:07:59" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "18:19:30" , 
"departure_time" : "18:19:30" , 
"distance_traveled" : 30.7472
} ], 
"1386" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "18:08:00" , 
"departure_time" : "18:09:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "18:11:30" , 
"departure_time" : "18:12:52" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "18:15:22" , 
"departure_time" : "18:15:23" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "18:17:01" , 
"departure_time" : "18:18:22" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "18:21:21" , 
"departure_time" : "18:22:30" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "18:24:09" , 
"departure_time" : "18:25:17" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "18:28:08" , 
"departure_time" : "18:28:55" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:30:47" , 
"departure_time" : "18:31:22" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "18:33:35" , 
"departure_time" : "18:34:28" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "18:37:53" , 
"departure_time" : "18:37:55" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "18:42:02" , 
"departure_time" : "18:43:18" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "18:49:16" , 
"departure_time" : "18:50:50" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "18:52:34" , 
"departure_time" : "18:54:08" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "18:55:34" , 
"departure_time" : "18:55:44" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "18:57:10" , 
"departure_time" : "18:57:53" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "18:59:43" , 
"departure_time" : "19:01:10" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:08:27" , 
"departure_time" : "19:08:28" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "19:19:01" , 
"departure_time" : "19:19:01" , 
"distance_traveled" : 30.7472
} ], 
"1387" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "18:08:00" , 
"departure_time" : "18:08:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "18:11:19" , 
"departure_time" : "18:12:45" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "18:15:26" , 
"departure_time" : "18:16:30" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "18:18:04" , 
"departure_time" : "18:19:17" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "18:21:13" , 
"departure_time" : "18:21:24" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "18:23:11" , 
"departure_time" : "18:24:07" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "18:27:56" , 
"departure_time" : "18:28:16" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:30:20" , 
"departure_time" : "18:30:58" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "18:33:38" , 
"departure_time" : "18:35:09" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "18:38:31" , 
"departure_time" : "18:38:50" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "18:42:19" , 
"departure_time" : "18:43:51" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "18:49:32" , 
"departure_time" : "18:50:08" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "18:51:36" , 
"departure_time" : "18:52:16" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "18:54:40" , 
"departure_time" : "18:55:32" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "18:57:52" , 
"departure_time" : "18:58:37" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "18:59:45" , 
"departure_time" : "19:00:03" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:07:18" , 
"departure_time" : "19:08:50" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "19:20:32" , 
"departure_time" : "19:20:32" , 
"distance_traveled" : 30.7472
} ], 
"1388" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "19:08:00" , 
"departure_time" : "19:10:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "19:11:37" , 
"departure_time" : "19:12:30" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "19:14:53" , 
"departure_time" : "19:16:23" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "19:18:30" , 
"departure_time" : "19:19:35" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "19:21:05" , 
"departure_time" : "19:22:37" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "19:24:32" , 
"departure_time" : "19:25:18" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "19:27:46" , 
"departure_time" : "19:28:17" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "19:30:31" , 
"departure_time" : "19:31:50" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "19:34:19" , 
"departure_time" : "19:34:30" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "19:37:11" , 
"departure_time" : "19:38:12" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "19:43:01" , 
"departure_time" : "19:43:39" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "19:48:38" , 
"departure_time" : "19:49:59" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "19:52:21" , 
"departure_time" : "19:53:15" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "19:54:54" , 
"departure_time" : "19:55:42" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "19:57:48" , 
"departure_time" : "19:58:01" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "19:59:13" , 
"departure_time" : "20:00:05" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "20:07:52" , 
"departure_time" : "20:09:13" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "20:20:21" , 
"departure_time" : "20:20:21" , 
"distance_traveled" : 30.7472
} ], 
"1389" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "19:08:00" , 
"departure_time" : "19:10:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "19:11:54" , 
"departure_time" : "19:13:09" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "19:15:15" , 
"departure_time" : "19:15:42" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "19:17:27" , 
"departure_time" : "19:18:31" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "19:21:04" , 
"departure_time" : "19:21:07" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "19:23:03" , 
"departure_time" : "19:23:24" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "19:27:21" , 
"departure_time" : "19:28:49" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "19:31:28" , 
"departure_time" : "19:32:21" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "19:33:53" , 
"departure_time" : "19:35:19" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "19:38:26" , 
"departure_time" : "19:39:29" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "19:43:03" , 
"departure_time" : "19:44:18" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "19:49:15" , 
"departure_time" : "19:50:12" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "19:51:57" , 
"departure_time" : "19:52:33" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "19:54:36" , 
"departure_time" : "19:54:47" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "19:57:11" , 
"departure_time" : "19:57:21" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "19:59:10" , 
"departure_time" : "20:00:50" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "20:08:40" , 
"departure_time" : "20:09:28" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "20:19:48" , 
"departure_time" : "20:19:48" , 
"distance_traveled" : 30.7472
} ], 
"1390" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "20:08:00" , 
"departure_time" : "20:08:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "20:11:09" , 
"departure_time" : "20:11:15" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "20:14:06" , 
"departure_time" : "20:14:09" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "20:17:03" , 
"departure_time" : "20:17:06" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "20:20:03" , 
"departure_time" : "20:20:58" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "20:23:55" , 
"departure_time" : "20:25:19" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "20:28:24" , 
"departure_time" : "20:29:03" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "20:30:39" , 
"departure_time" : "20:31:22" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "20:33:43" , 
"departure_time" : "20:35:22" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "20:38:39" , 
"departure_time" : "20:39:38" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "20:42:59" , 
"departure_time" : "20:43:44" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "20:48:45" , 
"departure_time" : "20:49:26" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "20:51:41" , 
"departure_time" : "20:51:43" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "20:54:02" , 
"departure_time" : "20:54:04" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "20:57:02" , 
"departure_time" : "20:57:19" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "20:59:17" , 
"departure_time" : "21:00:38" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "21:08:21" , 
"departure_time" : "21:08:43" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "21:19:22" , 
"departure_time" : "21:19:22" , 
"distance_traveled" : 30.7472
} ], 
"1391" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "20:08:00" , 
"departure_time" : "20:09:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "20:11:45" , 
"departure_time" : "20:13:01" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "20:15:16" , 
"departure_time" : "20:16:18" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "20:18:02" , 
"departure_time" : "20:18:57" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "20:20:55" , 
"departure_time" : "20:22:18" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "20:24:23" , 
"departure_time" : "20:24:42" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "20:27:19" , 
"departure_time" : "20:28:34" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "20:31:15" , 
"departure_time" : "20:32:21" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "20:34:06" , 
"departure_time" : "20:34:44" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "20:37:38" , 
"departure_time" : "20:38:54" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "20:43:16" , 
"departure_time" : "20:43:37" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "20:48:21" , 
"departure_time" : "20:48:35" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "20:51:14" , 
"departure_time" : "20:52:06" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "20:54:52" , 
"departure_time" : "20:55:38" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "20:57:46" , 
"departure_time" : "20:57:52" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "20:59:06" , 
"departure_time" : "20:59:58" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "21:07:52" , 
"departure_time" : "21:09:19" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "21:20:27" , 
"departure_time" : "21:20:27" , 
"distance_traveled" : 30.7472
} ], 
"1392" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "21:08:00" , 
"departure_time" : "21:11:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "21:12:37" , 
"departure_time" : "21:13:40" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "21:15:03" , 
"departure_time" : "21:15:41" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "21:17:38" , 
"departure_time" : "21:17:44" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "21:20:06" , 
"departure_time" : "21:20:40" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "21:23:34" , 
"departure_time" : "21:24:37" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "21:28:03" , 
"departure_time" : "21:29:17" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "21:31:14" , 
"departure_time" : "21:32:03" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "21:33:49" , 
"departure_time" : "21:35:13" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "21:38:24" , 
"departure_time" : "21:39:27" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "21:43:03" , 
"departure_time" : "21:44:23" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "21:49:20" , 
"departure_time" : "21:50:06" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "21:51:46" , 
"departure_time" : "21:53:16" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "21:55:30" , 
"departure_time" : "21:56:38" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "21:58:08" , 
"departure_time" : "21:58:22" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "21:59:14" , 
"departure_time" : "22:00:03" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "22:07:49" , 
"departure_time" : "22:08:21" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "22:19:32" , 
"departure_time" : "22:19:32" , 
"distance_traveled" : 30.7472
} ], 
"1393" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "21:08:00" , 
"departure_time" : "21:10:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "21:12:33" , 
"departure_time" : "21:13:08" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "21:14:35" , 
"departure_time" : "21:15:06" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "21:17:31" , 
"departure_time" : "21:18:02" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "21:20:31" , 
"departure_time" : "21:21:17" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "21:23:46" , 
"departure_time" : "21:25:21" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "21:28:35" , 
"departure_time" : "21:30:14" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "21:31:39" , 
"departure_time" : "21:32:53" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "21:34:14" , 
"departure_time" : "21:34:54" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "21:37:40" , 
"departure_time" : "21:38:57" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "21:43:17" , 
"departure_time" : "21:44:36" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "21:49:19" , 
"departure_time" : "21:50:07" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "21:51:48" , 
"departure_time" : "21:52:48" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "21:55:00" , 
"departure_time" : "21:56:21" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "21:58:21" , 
"departure_time" : "21:59:26" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "22:00:05" , 
"departure_time" : "22:01:15" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "22:08:10" , 
"departure_time" : "22:08:59" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "22:19:49" , 
"departure_time" : "22:19:49" , 
"distance_traveled" : 30.7472
} ], 
"1394" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "07:40:00" , 
"departure_time" : "07:41:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "07:43:11" , 
"departure_time" : "07:43:38" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "07:47:27" , 
"departure_time" : "07:48:12" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 126,
"arrival_time" : "07:53:45" , 
"departure_time" : "07:54:12" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "07:57:27" , 
"departure_time" : "07:58:52" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "08:03:25" , 
"departure_time" : "08:05:00" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "08:08:35" , 
"departure_time" : "08:09:32" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "08:12:57" , 
"departure_time" : "08:14:12" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:22:15" , 
"departure_time" : "08:23:06" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:33:51" , 
"departure_time" : "08:33:51" , 
"distance_traveled" : 22.2972
} ], 
"1395" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "07:40:00" , 
"departure_time" : "07:42:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "07:44:39" , 
"departure_time" : "07:44:57" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "07:47:18" , 
"departure_time" : "07:47:28" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 126,
"arrival_time" : "07:53:10" , 
"departure_time" : "07:53:45" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "07:57:35" , 
"departure_time" : "07:57:44" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "08:02:09" , 
"departure_time" : "08:03:24" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "08:08:15" , 
"departure_time" : "08:08:51" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "08:12:36" , 
"departure_time" : "08:13:55" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:22:19" , 
"departure_time" : "08:22:22" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:33:03" , 
"departure_time" : "08:33:03" , 
"distance_traveled" : 22.2972
} ], 
"1396" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "19:52:00" , 
"departure_time" : "19:53:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "19:56:09" , 
"departure_time" : "19:56:13" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "19:59:04" , 
"departure_time" : "20:00:30" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "20:04:26" , 
"departure_time" : "20:04:54" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "20:06:28" , 
"departure_time" : "20:06:45" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "20:10:17" , 
"departure_time" : "20:11:23" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "20:15:06" , 
"departure_time" : "20:15:26" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "20:19:20" , 
"departure_time" : "20:20:38" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "20:25:18" , 
"departure_time" : "20:26:42" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "20:33:24" , 
"departure_time" : "20:34:08" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "20:44:44" , 
"departure_time" : "20:44:44" , 
"distance_traveled" : 22.2972
} ], 
"1397" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "19:52:00" , 
"departure_time" : "19:54:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "19:56:37" , 
"departure_time" : "19:56:42" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "19:59:05" , 
"departure_time" : "19:59:47" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "20:03:42" , 
"departure_time" : "20:03:59" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "20:06:17" , 
"departure_time" : "20:06:19" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "20:10:02" , 
"departure_time" : "20:10:44" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "20:14:42" , 
"departure_time" : "20:14:43" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "20:19:01" , 
"departure_time" : "20:19:38" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "20:24:37" , 
"departure_time" : "20:24:47" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "20:32:10" , 
"departure_time" : "20:32:46" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "20:44:36" , 
"departure_time" : "20:44:36" , 
"distance_traveled" : 22.2972
} ], 
"1398" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "06:37:00" , 
"departure_time" : "06:38:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "06:41:17" , 
"departure_time" : "06:42:27" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "06:44:10" , 
"departure_time" : "06:45:31" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "06:48:21" , 
"departure_time" : "06:49:48" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "06:52:27" , 
"departure_time" : "06:53:26" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "06:54:59" , 
"departure_time" : "06:56:15" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "06:59:16" , 
"departure_time" : "06:59:50" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "07:02:34" , 
"departure_time" : "07:03:18" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 51,
"arrival_time" : "07:06:44" , 
"departure_time" : "07:07:50" , 
"distance_traveled" : 11.1142
}, 
{ 
"stop_id" : 126,
"arrival_time" : "07:11:06" , 
"departure_time" : "07:11:14" , 
"distance_traveled" : 12.6545
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:28:08" , 
"departure_time" : "07:28:28" , 
"distance_traveled" : 25.9892
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:40:20" , 
"departure_time" : "07:40:20" , 
"distance_traveled" : 29.5491
} ], 
"1399" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "06:37:00" , 
"departure_time" : "06:38:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "06:40:51" , 
"departure_time" : "06:41:17" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "06:43:26" , 
"departure_time" : "06:44:04" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "06:47:38" , 
"departure_time" : "06:48:31" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "06:51:53" , 
"departure_time" : "06:52:29" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "06:54:36" , 
"departure_time" : "06:55:01" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "06:58:25" , 
"departure_time" : "06:59:58" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "07:03:33" , 
"departure_time" : "07:04:15" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 51,
"arrival_time" : "07:06:42" , 
"departure_time" : "07:08:21" , 
"distance_traveled" : 11.1142
}, 
{ 
"stop_id" : 126,
"arrival_time" : "07:11:39" , 
"departure_time" : "07:12:15" , 
"distance_traveled" : 12.6545
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:28:36" , 
"departure_time" : "07:29:02" , 
"distance_traveled" : 25.9892
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:40:26" , 
"departure_time" : "07:40:26" , 
"distance_traveled" : 29.5491
} ], 
"1400" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "07:10:00" , 
"departure_time" : "07:11:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "07:14:27" , 
"departure_time" : "07:15:15" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "07:17:48" , 
"departure_time" : "07:19:07" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "07:22:19" , 
"departure_time" : "07:23:01" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "07:24:42" , 
"departure_time" : "07:25:55" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "07:29:13" , 
"departure_time" : "07:30:13" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "07:33:00" , 
"departure_time" : "07:34:10" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "07:37:10" , 
"departure_time" : "07:37:58" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 51,
"arrival_time" : "07:40:48" , 
"departure_time" : "07:42:01" , 
"distance_traveled" : 11.1142
}, 
{ 
"stop_id" : 126,
"arrival_time" : "07:45:13" , 
"departure_time" : "07:45:45" , 
"distance_traveled" : 12.6545
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:02:32" , 
"departure_time" : "08:03:10" , 
"distance_traveled" : 25.9892
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:14:38" , 
"departure_time" : "08:14:38" , 
"distance_traveled" : 29.5491
} ], 
"1401" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "07:10:00" , 
"departure_time" : "07:11:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "07:13:43" , 
"departure_time" : "07:13:54" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "07:17:11" , 
"departure_time" : "07:18:47" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "07:22:36" , 
"departure_time" : "07:23:56" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "07:25:20" , 
"departure_time" : "07:26:20" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "07:29:00" , 
"departure_time" : "07:29:23" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "07:32:23" , 
"departure_time" : "07:33:22" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "07:36:59" , 
"departure_time" : "07:37:27" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 51,
"arrival_time" : "07:40:28" , 
"departure_time" : "07:40:59" , 
"distance_traveled" : 11.1142
}, 
{ 
"stop_id" : 126,
"arrival_time" : "07:44:31" , 
"departure_time" : "07:45:24" , 
"distance_traveled" : 12.6545
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:02:53" , 
"departure_time" : "08:04:13" , 
"distance_traveled" : 25.9892
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:15:20" , 
"departure_time" : "08:15:20" , 
"distance_traveled" : 29.5491
} ], 
"1402" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "07:43:00" , 
"departure_time" : "07:45:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "07:47:37" , 
"departure_time" : "07:47:54" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "07:49:17" , 
"departure_time" : "07:49:56" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "07:53:39" , 
"departure_time" : "07:54:25" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "07:56:46" , 
"departure_time" : "07:57:55" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "08:01:09" , 
"departure_time" : "08:02:21" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "08:04:12" , 
"departure_time" : "08:04:38" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "08:07:26" , 
"departure_time" : "08:07:58" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 51,
"arrival_time" : "08:11:32" , 
"departure_time" : "08:11:43" , 
"distance_traveled" : 11.1142
}, 
{ 
"stop_id" : 126,
"arrival_time" : "08:15:11" , 
"departure_time" : "08:15:22" , 
"distance_traveled" : 12.6545
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:33:11" , 
"departure_time" : "08:33:21" , 
"distance_traveled" : 25.9892
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:45:10" , 
"departure_time" : "08:45:10" , 
"distance_traveled" : 29.5491
} ], 
"1403" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "07:43:00" , 
"departure_time" : "07:44:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "07:47:09" , 
"departure_time" : "07:47:22" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "07:49:13" , 
"departure_time" : "07:49:44" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "07:53:31" , 
"departure_time" : "07:54:22" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "07:56:51" , 
"departure_time" : "07:57:26" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "08:00:35" , 
"departure_time" : "08:01:02" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "08:03:27" , 
"departure_time" : "08:04:51" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "08:08:24" , 
"departure_time" : "08:09:58" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 51,
"arrival_time" : "08:12:34" , 
"departure_time" : "08:13:53" , 
"distance_traveled" : 11.1142
}, 
{ 
"stop_id" : 126,
"arrival_time" : "08:16:19" , 
"departure_time" : "08:16:41" , 
"distance_traveled" : 12.6545
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:33:22" , 
"departure_time" : "08:34:58" , 
"distance_traveled" : 25.9892
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:46:36" , 
"departure_time" : "08:46:36" , 
"distance_traveled" : 29.5491
} ], 
"1404" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "07:09:00" , 
"departure_time" : "07:11:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "07:13:44" , 
"departure_time" : "07:14:15" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "07:17:31" , 
"departure_time" : "07:18:14" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "07:22:43" , 
"departure_time" : "07:23:41" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "07:26:58" , 
"departure_time" : "07:28:03" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "07:30:05" , 
"departure_time" : "07:30:42" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "07:35:37" , 
"departure_time" : "07:35:39" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "07:38:02" , 
"departure_time" : "07:38:22" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "07:42:20" , 
"departure_time" : "07:43:20" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "07:48:00" , 
"departure_time" : "07:48:08" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:56:08" , 
"departure_time" : "07:57:02" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:08:54" , 
"departure_time" : "08:08:54" , 
"distance_traveled" : 22.2972
} ], 
"1405" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "07:09:00" , 
"departure_time" : "07:11:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "07:14:26" , 
"departure_time" : "07:14:54" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "07:17:28" , 
"departure_time" : "07:17:55" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "07:22:27" , 
"departure_time" : "07:22:44" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "07:26:17" , 
"departure_time" : "07:26:59" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "07:29:42" , 
"departure_time" : "07:29:52" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "07:35:10" , 
"departure_time" : "07:35:20" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "07:38:10" , 
"departure_time" : "07:39:22" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "07:43:12" , 
"departure_time" : "07:43:57" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "07:47:45" , 
"departure_time" : "07:48:33" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:56:48" , 
"departure_time" : "07:57:54" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:09:06" , 
"departure_time" : "08:09:06" , 
"distance_traveled" : 22.2972
} ], 
"1406" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "10:20:00" , 
"departure_time" : "10:21:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "10:23:35" , 
"departure_time" : "10:24:34" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "10:26:59" , 
"departure_time" : "10:28:17" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "10:31:18" , 
"departure_time" : "10:31:39" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "10:34:21" , 
"departure_time" : "10:35:00" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "10:37:39" , 
"departure_time" : "10:39:14" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "10:43:35" , 
"departure_time" : "10:44:40" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "10:46:05" , 
"departure_time" : "10:46:12" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "10:48:07" , 
"departure_time" : "10:49:09" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "10:54:02" , 
"departure_time" : "10:54:40" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "11:01:38" , 
"departure_time" : "11:03:02" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "11:14:24" , 
"departure_time" : "11:14:24" , 
"distance_traveled" : 22.2972
} ], 
"1407" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "10:20:00" , 
"departure_time" : "10:22:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "10:24:10" , 
"departure_time" : "10:24:11" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "10:26:01" , 
"departure_time" : "10:27:30" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "10:31:29" , 
"departure_time" : "10:31:34" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "10:34:05" , 
"departure_time" : "10:34:42" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "10:37:37" , 
"departure_time" : "10:38:33" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "10:42:56" , 
"departure_time" : "10:43:38" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "10:45:42" , 
"departure_time" : "10:46:50" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "10:49:08" , 
"departure_time" : "10:49:41" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "10:53:33" , 
"departure_time" : "10:53:50" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "11:01:17" , 
"departure_time" : "11:02:39" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "11:14:22" , 
"departure_time" : "11:14:22" , 
"distance_traveled" : 22.2972
} ], 
"1408" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "11:20:00" , 
"departure_time" : "11:21:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "11:23:25" , 
"departure_time" : "11:23:56" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "11:26:31" , 
"departure_time" : "11:27:08" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "11:30:37" , 
"departure_time" : "11:31:56" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "11:35:19" , 
"departure_time" : "11:35:31" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "11:37:12" , 
"departure_time" : "11:37:16" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "11:42:04" , 
"departure_time" : "11:43:15" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "11:46:11" , 
"departure_time" : "11:46:30" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "11:48:19" , 
"departure_time" : "11:48:53" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "11:53:34" , 
"departure_time" : "11:55:11" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "12:02:37" , 
"departure_time" : "12:02:38" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "12:13:01" , 
"departure_time" : "12:13:01" , 
"distance_traveled" : 22.2972
} ], 
"1409" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "11:20:00" , 
"departure_time" : "11:20:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "11:23:19" , 
"departure_time" : "11:23:26" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "11:26:07" , 
"departure_time" : "11:26:40" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "11:30:33" , 
"departure_time" : "11:31:15" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "11:34:42" , 
"departure_time" : "11:34:48" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "11:37:06" , 
"departure_time" : "11:38:27" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "11:43:21" , 
"departure_time" : "11:44:39" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "11:46:18" , 
"departure_time" : "11:47:47" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "11:49:29" , 
"departure_time" : "11:50:40" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "11:54:11" , 
"departure_time" : "11:55:38" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "12:02:27" , 
"departure_time" : "12:02:34" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "12:13:07" , 
"departure_time" : "12:13:07" , 
"distance_traveled" : 22.2972
} ], 
"1410" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "12:20:00" , 
"departure_time" : "12:20:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "12:23:18" , 
"departure_time" : "12:23:20" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "12:26:02" , 
"departure_time" : "12:26:59" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "12:30:57" , 
"departure_time" : "12:32:13" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "12:35:16" , 
"departure_time" : "12:36:45" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "12:38:29" , 
"departure_time" : "12:38:31" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "12:42:02" , 
"departure_time" : "12:43:02" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "12:46:00" , 
"departure_time" : "12:46:27" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "12:48:27" , 
"departure_time" : "12:49:04" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "12:53:37" , 
"departure_time" : "12:54:16" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "13:01:39" , 
"departure_time" : "13:02:59" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "13:14:20" , 
"departure_time" : "13:14:20" , 
"distance_traveled" : 22.2972
} ], 
"1411" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "12:20:00" , 
"departure_time" : "12:21:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "12:23:34" , 
"departure_time" : "12:25:14" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "12:27:40" , 
"departure_time" : "12:28:53" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "12:31:13" , 
"departure_time" : "12:32:47" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "12:35:34" , 
"departure_time" : "12:36:18" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "12:37:44" , 
"departure_time" : "12:38:55" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "12:43:11" , 
"departure_time" : "12:43:54" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "12:45:43" , 
"departure_time" : "12:46:35" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "12:48:52" , 
"departure_time" : "12:49:50" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "12:53:58" , 
"departure_time" : "12:55:05" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "13:02:07" , 
"departure_time" : "13:03:08" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "13:14:01" , 
"departure_time" : "13:14:01" , 
"distance_traveled" : 22.2972
} ], 
"1412" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "14:16:00" , 
"departure_time" : "14:17:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "14:19:12" , 
"departure_time" : "14:20:32" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "14:23:20" , 
"departure_time" : "14:23:59" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "14:26:39" , 
"departure_time" : "14:27:30" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "14:30:51" , 
"departure_time" : "14:32:03" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "14:34:12" , 
"departure_time" : "14:35:44" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "14:39:32" , 
"departure_time" : "14:40:33" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "14:42:01" , 
"departure_time" : "14:42:08" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "14:44:07" , 
"departure_time" : "14:44:20" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "14:49:13" , 
"departure_time" : "14:50:18" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "14:58:05" , 
"departure_time" : "14:58:11" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "15:09:06" , 
"departure_time" : "15:09:06" , 
"distance_traveled" : 22.2972
} ], 
"1413" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "14:16:00" , 
"departure_time" : "14:16:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "14:19:13" , 
"departure_time" : "14:19:24" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "14:22:11" , 
"departure_time" : "14:22:20" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "14:26:09" , 
"departure_time" : "14:26:29" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "14:30:20" , 
"departure_time" : "14:31:22" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "14:34:02" , 
"departure_time" : "14:34:49" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "14:38:47" , 
"departure_time" : "14:40:01" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "14:42:14" , 
"departure_time" : "14:42:39" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "14:44:25" , 
"departure_time" : "14:45:35" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "14:50:10" , 
"departure_time" : "14:50:46" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "14:57:36" , 
"departure_time" : "14:58:37" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "15:10:01" , 
"departure_time" : "15:10:01" , 
"distance_traveled" : 22.2972
} ], 
"1414" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "06:20:00" , 
"departure_time" : "06:21:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "06:23:44" , 
"departure_time" : "06:25:13" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "06:28:29" , 
"departure_time" : "06:29:33" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 52,
"arrival_time" : "06:31:04" , 
"departure_time" : "06:31:31" , 
"distance_traveled" : 3.8966
}, 
{ 
"stop_id" : 58,
"arrival_time" : "06:34:27" , 
"departure_time" : "06:35:29" , 
"distance_traveled" : 5.6032
}, 
{ 
"stop_id" : 116,
"arrival_time" : "06:40:02" , 
"departure_time" : "06:40:19" , 
"distance_traveled" : 7.6979
}, 
{ 
"stop_id" : 29,
"arrival_time" : "06:45:17" , 
"departure_time" : "06:46:24" , 
"distance_traveled" : 11.2223
}, 
{ 
"stop_id" : 115,
"arrival_time" : "06:50:07" , 
"departure_time" : "06:51:21" , 
"distance_traveled" : 12.8761
}, 
{ 
"stop_id" : 33,
"arrival_time" : "06:53:14" , 
"departure_time" : "06:54:36" , 
"distance_traveled" : 14.1328
}, 
{ 
"stop_id" : 75,
"arrival_time" : "06:56:22" , 
"departure_time" : "06:56:31" , 
"distance_traveled" : 15.2339
}, 
{ 
"stop_id" : 66,
"arrival_time" : "06:58:09" , 
"departure_time" : "06:58:12" , 
"distance_traveled" : 15.8152
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:07:03" , 
"departure_time" : "07:07:21" , 
"distance_traveled" : 19.9354
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:19:18" , 
"departure_time" : "07:19:18" , 
"distance_traveled" : 23.4953
} ], 
"1415" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "06:20:00" , 
"departure_time" : "06:21:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "06:23:50" , 
"departure_time" : "06:24:44" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "06:27:54" , 
"departure_time" : "06:28:54" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 52,
"arrival_time" : "06:31:00" , 
"departure_time" : "06:32:40" , 
"distance_traveled" : 3.8966
}, 
{ 
"stop_id" : 58,
"arrival_time" : "06:35:40" , 
"departure_time" : "06:36:15" , 
"distance_traveled" : 5.6032
}, 
{ 
"stop_id" : 116,
"arrival_time" : "06:39:35" , 
"departure_time" : "06:40:22" , 
"distance_traveled" : 7.6979
}, 
{ 
"stop_id" : 29,
"arrival_time" : "06:45:47" , 
"departure_time" : "06:46:38" , 
"distance_traveled" : 11.2223
}, 
{ 
"stop_id" : 115,
"arrival_time" : "06:49:51" , 
"departure_time" : "06:50:51" , 
"distance_traveled" : 12.8761
}, 
{ 
"stop_id" : 33,
"arrival_time" : "06:53:00" , 
"departure_time" : "06:54:15" , 
"distance_traveled" : 14.1328
}, 
{ 
"stop_id" : 75,
"arrival_time" : "06:56:15" , 
"departure_time" : "06:56:28" , 
"distance_traveled" : 15.2339
}, 
{ 
"stop_id" : 66,
"arrival_time" : "06:58:13" , 
"departure_time" : "06:58:46" , 
"distance_traveled" : 15.8152
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:07:33" , 
"departure_time" : "07:08:26" , 
"distance_traveled" : 19.9354
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:19:53" , 
"departure_time" : "07:19:53" , 
"distance_traveled" : 23.4953
} ], 
"1416" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "06:47:00" , 
"departure_time" : "06:49:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "06:51:07" , 
"departure_time" : "06:51:11" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "06:53:04" , 
"departure_time" : "06:53:15" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 52,
"arrival_time" : "06:56:11" , 
"departure_time" : "06:56:27" , 
"distance_traveled" : 3.8966
}, 
{ 
"stop_id" : 58,
"arrival_time" : "07:01:16" , 
"departure_time" : "07:02:08" , 
"distance_traveled" : 5.6032
}, 
{ 
"stop_id" : 116,
"arrival_time" : "07:05:52" , 
"departure_time" : "07:06:50" , 
"distance_traveled" : 7.6979
}, 
{ 
"stop_id" : 29,
"arrival_time" : "07:12:58" , 
"departure_time" : "07:13:56" , 
"distance_traveled" : 11.2223
}, 
{ 
"stop_id" : 115,
"arrival_time" : "07:16:58" , 
"departure_time" : "07:18:22" , 
"distance_traveled" : 12.8761
}, 
{ 
"stop_id" : 33,
"arrival_time" : "07:21:24" , 
"departure_time" : "07:21:42" , 
"distance_traveled" : 14.1328
}, 
{ 
"stop_id" : 75,
"arrival_time" : "07:24:18" , 
"departure_time" : "07:25:10" , 
"distance_traveled" : 15.2339
}, 
{ 
"stop_id" : 66,
"arrival_time" : "07:27:52" , 
"departure_time" : "07:28:00" , 
"distance_traveled" : 15.8152
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:35:08" , 
"departure_time" : "07:36:06" , 
"distance_traveled" : 19.9354
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:47:58" , 
"departure_time" : "07:47:58" , 
"distance_traveled" : 23.4953
} ], 
"1417" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "06:47:00" , 
"departure_time" : "06:49:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "06:51:19" , 
"departure_time" : "06:51:25" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "06:53:06" , 
"departure_time" : "06:54:33" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 52,
"arrival_time" : "06:57:27" , 
"departure_time" : "06:57:42" , 
"distance_traveled" : 3.8966
}, 
{ 
"stop_id" : 58,
"arrival_time" : "07:01:15" , 
"departure_time" : "07:02:19" , 
"distance_traveled" : 5.6032
}, 
{ 
"stop_id" : 116,
"arrival_time" : "07:06:04" , 
"departure_time" : "07:07:11" , 
"distance_traveled" : 7.6979
}, 
{ 
"stop_id" : 29,
"arrival_time" : "07:13:07" , 
"departure_time" : "07:13:30" , 
"distance_traveled" : 11.2223
}, 
{ 
"stop_id" : 115,
"arrival_time" : "07:16:23" , 
"departure_time" : "07:16:28" , 
"distance_traveled" : 12.8761
}, 
{ 
"stop_id" : 33,
"arrival_time" : "07:20:05" , 
"departure_time" : "07:20:35" , 
"distance_traveled" : 14.1328
}, 
{ 
"stop_id" : 75,
"arrival_time" : "07:24:30" , 
"departure_time" : "07:24:59" , 
"distance_traveled" : 15.2339
}, 
{ 
"stop_id" : 66,
"arrival_time" : "07:27:29" , 
"departure_time" : "07:29:07" , 
"distance_traveled" : 15.8152
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:36:38" , 
"departure_time" : "07:37:49" , 
"distance_traveled" : 19.9354
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:48:11" , 
"departure_time" : "07:48:11" , 
"distance_traveled" : 23.4953
} ], 
"1418" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "07:19:00" , 
"departure_time" : "07:20:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "07:23:35" , 
"departure_time" : "07:24:40" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "07:27:05" , 
"departure_time" : "07:27:35" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 52,
"arrival_time" : "07:30:30" , 
"departure_time" : "07:31:22" , 
"distance_traveled" : 3.8966
}, 
{ 
"stop_id" : 58,
"arrival_time" : "07:34:52" , 
"departure_time" : "07:35:35" , 
"distance_traveled" : 5.6032
}, 
{ 
"stop_id" : 116,
"arrival_time" : "07:39:43" , 
"departure_time" : "07:40:30" , 
"distance_traveled" : 7.6979
}, 
{ 
"stop_id" : 29,
"arrival_time" : "07:46:47" , 
"departure_time" : "07:46:48" , 
"distance_traveled" : 11.2223
}, 
{ 
"stop_id" : 115,
"arrival_time" : "07:50:01" , 
"departure_time" : "07:50:21" , 
"distance_traveled" : 12.8761
}, 
{ 
"stop_id" : 33,
"arrival_time" : "07:53:20" , 
"departure_time" : "07:54:04" , 
"distance_traveled" : 14.1328
}, 
{ 
"stop_id" : 75,
"arrival_time" : "07:57:44" , 
"departure_time" : "07:58:35" , 
"distance_traveled" : 15.2339
}, 
{ 
"stop_id" : 66,
"arrival_time" : "08:01:51" , 
"departure_time" : "08:02:22" , 
"distance_traveled" : 15.8152
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:10:31" , 
"departure_time" : "08:12:01" , 
"distance_traveled" : 19.9354
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:23:30" , 
"departure_time" : "08:23:30" , 
"distance_traveled" : 23.4953
} ], 
"1419" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "07:19:00" , 
"departure_time" : "07:21:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "07:24:13" , 
"departure_time" : "07:25:13" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "07:27:00" , 
"departure_time" : "07:27:41" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 52,
"arrival_time" : "07:30:41" , 
"departure_time" : "07:31:24" , 
"distance_traveled" : 3.8966
}, 
{ 
"stop_id" : 58,
"arrival_time" : "07:34:43" , 
"departure_time" : "07:34:58" , 
"distance_traveled" : 5.6032
}, 
{ 
"stop_id" : 116,
"arrival_time" : "07:39:15" , 
"departure_time" : "07:40:36" , 
"distance_traveled" : 7.6979
}, 
{ 
"stop_id" : 29,
"arrival_time" : "07:47:21" , 
"departure_time" : "07:48:14" , 
"distance_traveled" : 11.2223
}, 
{ 
"stop_id" : 115,
"arrival_time" : "07:50:53" , 
"departure_time" : "07:52:05" , 
"distance_traveled" : 12.8761
}, 
{ 
"stop_id" : 33,
"arrival_time" : "07:54:12" , 
"departure_time" : "07:54:54" , 
"distance_traveled" : 14.1328
}, 
{ 
"stop_id" : 75,
"arrival_time" : "07:57:42" , 
"departure_time" : "07:59:14" , 
"distance_traveled" : 15.2339
}, 
{ 
"stop_id" : 66,
"arrival_time" : "08:02:32" , 
"departure_time" : "08:02:54" , 
"distance_traveled" : 15.8152
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:10:22" , 
"departure_time" : "08:10:53" , 
"distance_traveled" : 19.9354
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:22:31" , 
"departure_time" : "08:22:31" , 
"distance_traveled" : 23.4953
} ], 
"1420" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "07:51:00" , 
"departure_time" : "07:51:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "07:54:05" , 
"departure_time" : "07:54:40" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "07:58:35" , 
"departure_time" : "08:00:03" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 52,
"arrival_time" : "08:03:28" , 
"departure_time" : "08:03:35" , 
"distance_traveled" : 3.8966
}, 
{ 
"stop_id" : 58,
"arrival_time" : "08:06:07" , 
"departure_time" : "08:06:57" , 
"distance_traveled" : 5.6032
}, 
{ 
"stop_id" : 116,
"arrival_time" : "08:10:50" , 
"departure_time" : "08:12:30" , 
"distance_traveled" : 7.6979
}, 
{ 
"stop_id" : 29,
"arrival_time" : "08:18:40" , 
"departure_time" : "08:18:50" , 
"distance_traveled" : 11.2223
}, 
{ 
"stop_id" : 115,
"arrival_time" : "08:21:10" , 
"departure_time" : "08:22:08" , 
"distance_traveled" : 12.8761
}, 
{ 
"stop_id" : 33,
"arrival_time" : "08:24:58" , 
"departure_time" : "08:25:21" , 
"distance_traveled" : 14.1328
}, 
{ 
"stop_id" : 75,
"arrival_time" : "08:27:23" , 
"departure_time" : "08:28:21" , 
"distance_traveled" : 15.2339
}, 
{ 
"stop_id" : 66,
"arrival_time" : "08:30:58" , 
"departure_time" : "08:31:51" , 
"distance_traveled" : 15.8152
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:38:53" , 
"departure_time" : "08:40:05" , 
"distance_traveled" : 19.9354
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:51:12" , 
"departure_time" : "08:51:12" , 
"distance_traveled" : 23.4953
} ], 
"1421" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "07:51:00" , 
"departure_time" : "07:53:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "07:55:11" , 
"departure_time" : "07:55:28" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "07:58:17" , 
"departure_time" : "07:58:45" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 52,
"arrival_time" : "08:02:28" , 
"departure_time" : "08:03:22" , 
"distance_traveled" : 3.8966
}, 
{ 
"stop_id" : 58,
"arrival_time" : "08:06:54" , 
"departure_time" : "08:07:06" , 
"distance_traveled" : 5.6032
}, 
{ 
"stop_id" : 116,
"arrival_time" : "08:10:12" , 
"departure_time" : "08:10:15" , 
"distance_traveled" : 7.6979
}, 
{ 
"stop_id" : 29,
"arrival_time" : "08:17:03" , 
"departure_time" : "08:17:35" , 
"distance_traveled" : 11.2223
}, 
{ 
"stop_id" : 115,
"arrival_time" : "08:21:32" , 
"departure_time" : "08:21:40" , 
"distance_traveled" : 12.8761
}, 
{ 
"stop_id" : 33,
"arrival_time" : "08:24:08" , 
"departure_time" : "08:24:56" , 
"distance_traveled" : 14.1328
}, 
{ 
"stop_id" : 75,
"arrival_time" : "08:27:48" , 
"departure_time" : "08:28:33" , 
"distance_traveled" : 15.2339
}, 
{ 
"stop_id" : 66,
"arrival_time" : "08:30:45" , 
"departure_time" : "08:31:16" , 
"distance_traveled" : 15.8152
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:38:31" , 
"departure_time" : "08:39:33" , 
"distance_traveled" : 19.9354
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:51:02" , 
"departure_time" : "08:51:02" , 
"distance_traveled" : 23.4953
} ], 
"1422" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "08:34:00" , 
"departure_time" : "08:35:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "08:38:24" , 
"departure_time" : "08:39:19" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "08:41:55" , 
"departure_time" : "08:42:57" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 52,
"arrival_time" : "08:45:02" , 
"departure_time" : "08:46:17" , 
"distance_traveled" : 3.8966
}, 
{ 
"stop_id" : 58,
"arrival_time" : "08:49:15" , 
"departure_time" : "08:49:45" , 
"distance_traveled" : 5.6032
}, 
{ 
"stop_id" : 116,
"arrival_time" : "08:53:30" , 
"departure_time" : "08:53:51" , 
"distance_traveled" : 7.6979
}, 
{ 
"stop_id" : 29,
"arrival_time" : "08:59:21" , 
"departure_time" : "09:00:45" , 
"distance_traveled" : 11.2223
}, 
{ 
"stop_id" : 115,
"arrival_time" : "09:04:24" , 
"departure_time" : "09:04:45" , 
"distance_traveled" : 12.8761
}, 
{ 
"stop_id" : 33,
"arrival_time" : "09:06:21" , 
"departure_time" : "09:06:48" , 
"distance_traveled" : 14.1328
}, 
{ 
"stop_id" : 75,
"arrival_time" : "09:09:27" , 
"departure_time" : "09:09:28" , 
"distance_traveled" : 15.2339
}, 
{ 
"stop_id" : 66,
"arrival_time" : "09:11:01" , 
"departure_time" : "09:11:12" , 
"distance_traveled" : 15.8152
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:19:11" , 
"departure_time" : "09:20:46" , 
"distance_traveled" : 19.9354
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:32:35" , 
"departure_time" : "09:32:35" , 
"distance_traveled" : 23.4953
} ], 
"1423" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "08:34:00" , 
"departure_time" : "08:36:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "08:38:31" , 
"departure_time" : "08:39:56" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "08:42:25" , 
"departure_time" : "08:43:09" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 52,
"arrival_time" : "08:44:44" , 
"departure_time" : "08:44:56" , 
"distance_traveled" : 3.8966
}, 
{ 
"stop_id" : 58,
"arrival_time" : "08:48:12" , 
"departure_time" : "08:48:46" , 
"distance_traveled" : 5.6032
}, 
{ 
"stop_id" : 116,
"arrival_time" : "08:53:34" , 
"departure_time" : "08:53:57" , 
"distance_traveled" : 7.6979
}, 
{ 
"stop_id" : 29,
"arrival_time" : "08:59:23" , 
"departure_time" : "09:00:41" , 
"distance_traveled" : 11.2223
}, 
{ 
"stop_id" : 115,
"arrival_time" : "09:04:18" , 
"departure_time" : "09:05:35" , 
"distance_traveled" : 12.8761
}, 
{ 
"stop_id" : 33,
"arrival_time" : "09:07:17" , 
"departure_time" : "09:08:47" , 
"distance_traveled" : 14.1328
}, 
{ 
"stop_id" : 75,
"arrival_time" : "09:10:30" , 
"departure_time" : "09:10:34" , 
"distance_traveled" : 15.2339
}, 
{ 
"stop_id" : 66,
"arrival_time" : "09:11:04" , 
"departure_time" : "09:11:25" , 
"distance_traveled" : 15.8152
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:19:21" , 
"departure_time" : "09:20:23" , 
"distance_traveled" : 19.9354
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:32:02" , 
"departure_time" : "09:32:02" , 
"distance_traveled" : 23.4953
} ], 
"1424" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "08:58:00" , 
"departure_time" : "08:59:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "09:01:08" , 
"departure_time" : "09:02:22" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "09:06:14" , 
"departure_time" : "09:06:16" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 52,
"arrival_time" : "09:08:02" , 
"departure_time" : "09:09:18" , 
"distance_traveled" : 3.8966
}, 
{ 
"stop_id" : 58,
"arrival_time" : "09:13:16" , 
"departure_time" : "09:14:53" , 
"distance_traveled" : 5.6032
}, 
{ 
"stop_id" : 116,
"arrival_time" : "09:17:37" , 
"departure_time" : "09:18:32" , 
"distance_traveled" : 7.6979
}, 
{ 
"stop_id" : 29,
"arrival_time" : "09:21:55" , 
"departure_time" : "09:22:04" , 
"distance_traveled" : 11.2223
}, 
{ 
"stop_id" : 115,
"arrival_time" : "09:24:09" , 
"departure_time" : "09:24:46" , 
"distance_traveled" : 12.8761
}, 
{ 
"stop_id" : 33,
"arrival_time" : "09:27:37" , 
"departure_time" : "09:27:41" , 
"distance_traveled" : 14.1328
}, 
{ 
"stop_id" : 75,
"arrival_time" : "09:30:04" , 
"departure_time" : "09:30:25" , 
"distance_traveled" : 15.2339
}, 
{ 
"stop_id" : 66,
"arrival_time" : "09:32:21" , 
"departure_time" : "09:33:45" , 
"distance_traveled" : 15.8152
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:42:24" , 
"departure_time" : "09:43:07" , 
"distance_traveled" : 19.9354
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:53:43" , 
"departure_time" : "09:53:43" , 
"distance_traveled" : 23.4953
} ], 
"1425" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "08:58:00" , 
"departure_time" : "08:58:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "09:01:07" , 
"departure_time" : "09:01:39" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "09:05:32" , 
"departure_time" : "09:05:33" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 52,
"arrival_time" : "09:08:01" , 
"departure_time" : "09:09:05" , 
"distance_traveled" : 3.8966
}, 
{ 
"stop_id" : 58,
"arrival_time" : "09:13:04" , 
"departure_time" : "09:13:54" , 
"distance_traveled" : 5.6032
}, 
{ 
"stop_id" : 116,
"arrival_time" : "09:16:50" , 
"departure_time" : "09:16:53" , 
"distance_traveled" : 7.6979
}, 
{ 
"stop_id" : 29,
"arrival_time" : "09:21:03" , 
"departure_time" : "09:22:28" , 
"distance_traveled" : 11.2223
}, 
{ 
"stop_id" : 115,
"arrival_time" : "09:25:25" , 
"departure_time" : "09:26:57" , 
"distance_traveled" : 12.8761
}, 
{ 
"stop_id" : 33,
"arrival_time" : "09:28:32" , 
"departure_time" : "09:28:53" , 
"distance_traveled" : 14.1328
}, 
{ 
"stop_id" : 75,
"arrival_time" : "09:30:21" , 
"departure_time" : "09:30:54" , 
"distance_traveled" : 15.2339
}, 
{ 
"stop_id" : 66,
"arrival_time" : "09:32:33" , 
"departure_time" : "09:33:57" , 
"distance_traveled" : 15.8152
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:42:24" , 
"departure_time" : "09:43:38" , 
"distance_traveled" : 19.9354
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:54:14" , 
"departure_time" : "09:54:14" , 
"distance_traveled" : 23.4953
} ], 
"1426" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "15:34:00" , 
"departure_time" : "15:35:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "15:37:24" , 
"departure_time" : "15:38:46" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "15:42:22" , 
"departure_time" : "15:42:33" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 52,
"arrival_time" : "15:44:11" , 
"departure_time" : "15:44:26" , 
"distance_traveled" : 3.8966
}, 
{ 
"stop_id" : 58,
"arrival_time" : "15:48:15" , 
"departure_time" : "15:49:20" , 
"distance_traveled" : 5.6032
}, 
{ 
"stop_id" : 116,
"arrival_time" : "15:53:05" , 
"departure_time" : "15:54:02" , 
"distance_traveled" : 7.6979
}, 
{ 
"stop_id" : 29,
"arrival_time" : "15:58:57" , 
"departure_time" : "16:00:21" , 
"distance_traveled" : 11.2223
}, 
{ 
"stop_id" : 115,
"arrival_time" : "16:02:24" , 
"departure_time" : "16:03:33" , 
"distance_traveled" : 12.8761
}, 
{ 
"stop_id" : 33,
"arrival_time" : "16:05:09" , 
"departure_time" : "16:06:42" , 
"distance_traveled" : 14.1328
}, 
{ 
"stop_id" : 75,
"arrival_time" : "16:08:33" , 
"departure_time" : "16:09:51" , 
"distance_traveled" : 15.2339
}, 
{ 
"stop_id" : 66,
"arrival_time" : "16:10:18" , 
"departure_time" : "16:11:38" , 
"distance_traveled" : 15.8152
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:19:20" , 
"departure_time" : "16:20:17" , 
"distance_traveled" : 19.9354
}, 
{ 
"stop_id" : 63,
"arrival_time" : "16:30:57" , 
"departure_time" : "16:30:57" , 
"distance_traveled" : 23.4953
} ], 
"1427" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "15:34:00" , 
"departure_time" : "15:36:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "15:38:27" , 
"departure_time" : "15:39:41" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "15:42:14" , 
"departure_time" : "15:42:27" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 52,
"arrival_time" : "15:44:13" , 
"departure_time" : "15:44:57" , 
"distance_traveled" : 3.8966
}, 
{ 
"stop_id" : 58,
"arrival_time" : "15:48:44" , 
"departure_time" : "15:48:53" , 
"distance_traveled" : 5.6032
}, 
{ 
"stop_id" : 116,
"arrival_time" : "15:52:09" , 
"departure_time" : "15:53:12" , 
"distance_traveled" : 7.6979
}, 
{ 
"stop_id" : 29,
"arrival_time" : "15:59:03" , 
"departure_time" : "15:59:36" , 
"distance_traveled" : 11.2223
}, 
{ 
"stop_id" : 115,
"arrival_time" : "16:01:33" , 
"departure_time" : "16:01:53" , 
"distance_traveled" : 12.8761
}, 
{ 
"stop_id" : 33,
"arrival_time" : "16:04:20" , 
"departure_time" : "16:04:48" , 
"distance_traveled" : 14.1328
}, 
{ 
"stop_id" : 75,
"arrival_time" : "16:07:28" , 
"departure_time" : "16:09:03" , 
"distance_traveled" : 15.2339
}, 
{ 
"stop_id" : 66,
"arrival_time" : "16:10:35" , 
"departure_time" : "16:11:45" , 
"distance_traveled" : 15.8152
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:19:10" , 
"departure_time" : "16:19:20" , 
"distance_traveled" : 19.9354
}, 
{ 
"stop_id" : 63,
"arrival_time" : "16:30:10" , 
"departure_time" : "16:30:10" , 
"distance_traveled" : 23.4953
} ], 
"1428" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "23:34:00" , 
"departure_time" : "23:34:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "23:38:31" , 
"departure_time" : "23:38:39" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "23:41:08" , 
"departure_time" : "23:42:11" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 52,
"arrival_time" : "23:45:03" , 
"departure_time" : "23:45:34" , 
"distance_traveled" : 3.8966
}, 
{ 
"stop_id" : 58,
"arrival_time" : "23:48:31" , 
"departure_time" : "23:49:03" , 
"distance_traveled" : 5.6032
}, 
{ 
"stop_id" : 116,
"arrival_time" : "23:53:32" , 
"departure_time" : "23:55:11" , 
"distance_traveled" : 7.6979
}, 
{ 
"stop_id" : 29,
"arrival_time" : "23:59:39" , 
"departure_time" : "23:59:44" , 
"distance_traveled" : 11.2223
}, 
{ 
"stop_id" : 115,
"arrival_time" : "24:01:05" , 
"departure_time" : "24:01:57" , 
"distance_traveled" : 12.8761
}, 
{ 
"stop_id" : 33,
"arrival_time" : "24:04:52" , 
"departure_time" : "24:05:30" , 
"distance_traveled" : 14.1328
}, 
{ 
"stop_id" : 75,
"arrival_time" : "24:07:38" , 
"departure_time" : "24:09:08" , 
"distance_traveled" : 15.2339
}, 
{ 
"stop_id" : 66,
"arrival_time" : "24:10:30" , 
"departure_time" : "24:10:40" , 
"distance_traveled" : 15.8152
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "24:17:10" , 
"departure_time" : "24:18:20" , 
"distance_traveled" : 19.9354
}, 
{ 
"stop_id" : 63,
"arrival_time" : "24:30:10" , 
"departure_time" : "24:30:10" , 
"distance_traveled" : 23.4953
} ], 
"1429" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "23:34:00" , 
"departure_time" : "23:35:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "23:38:16" , 
"departure_time" : "23:39:06" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "23:41:50" , 
"departure_time" : "23:42:17" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 52,
"arrival_time" : "23:44:27" , 
"departure_time" : "23:46:07" , 
"distance_traveled" : 3.8966
}, 
{ 
"stop_id" : 58,
"arrival_time" : "23:49:40" , 
"departure_time" : "23:49:57" , 
"distance_traveled" : 5.6032
}, 
{ 
"stop_id" : 116,
"arrival_time" : "23:53:17" , 
"departure_time" : "23:54:30" , 
"distance_traveled" : 7.6979
}, 
{ 
"stop_id" : 29,
"arrival_time" : "23:59:13" , 
"departure_time" : "23:59:36" , 
"distance_traveled" : 11.2223
}, 
{ 
"stop_id" : 115,
"arrival_time" : "24:01:23" , 
"departure_time" : "24:01:30" , 
"distance_traveled" : 12.8761
}, 
{ 
"stop_id" : 33,
"arrival_time" : "24:04:07" , 
"departure_time" : "24:04:14" , 
"distance_traveled" : 14.1328
}, 
{ 
"stop_id" : 75,
"arrival_time" : "24:07:07" , 
"departure_time" : "24:07:11" , 
"distance_traveled" : 15.2339
}, 
{ 
"stop_id" : 66,
"arrival_time" : "24:09:04" , 
"departure_time" : "24:09:33" , 
"distance_traveled" : 15.8152
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "24:17:29" , 
"departure_time" : "24:17:55" , 
"distance_traveled" : 19.9354
}, 
{ 
"stop_id" : 63,
"arrival_time" : "24:29:26" , 
"departure_time" : "24:29:26" , 
"distance_traveled" : 23.4953
} ], 
"1430" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "05:56:00" , 
"departure_time" : "05:57:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "06:00:26" , 
"departure_time" : "06:01:03" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 128,
"arrival_time" : "06:04:37" , 
"departure_time" : "06:05:10" , 
"distance_traveled" : 4.0337
}, 
{ 
"stop_id" : 3,
"arrival_time" : "06:07:33" , 
"departure_time" : "06:08:02" , 
"distance_traveled" : 5.9167
}, 
{ 
"stop_id" : 151,
"arrival_time" : "06:10:29" , 
"departure_time" : "06:11:04" , 
"distance_traveled" : 7.2525
}, 
{ 
"stop_id" : 64,
"arrival_time" : "06:14:35" , 
"departure_time" : "06:15:40" , 
"distance_traveled" : 8.4761
}, 
{ 
"stop_id" : 131,
"arrival_time" : "06:18:05" , 
"departure_time" : "06:19:18" , 
"distance_traveled" : 9.7036
}, 
{ 
"stop_id" : 51,
"arrival_time" : "06:22:13" , 
"departure_time" : "06:23:15" , 
"distance_traveled" : 11.1146
}, 
{ 
"stop_id" : 126,
"arrival_time" : "06:26:02" , 
"departure_time" : "06:27:33" , 
"distance_traveled" : 12.6549
}, 
{ 
"stop_id" : 25,
"arrival_time" : "06:30:31" , 
"departure_time" : "06:30:56" , 
"distance_traveled" : 13.9059
}, 
{ 
"stop_id" : 121,
"arrival_time" : "06:34:25" , 
"departure_time" : "06:36:05" , 
"distance_traveled" : 16.6335
}, 
{ 
"stop_id" : 46,
"arrival_time" : "06:38:40" , 
"departure_time" : "06:40:17" , 
"distance_traveled" : 17.9121
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "06:42:37" , 
"departure_time" : "06:44:08" , 
"distance_traveled" : 18.9341
}, 
{ 
"stop_id" : 134,
"arrival_time" : "06:47:31" , 
"departure_time" : "06:48:38" , 
"distance_traveled" : 20.8714
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "06:55:07" , 
"departure_time" : "06:55:16" , 
"distance_traveled" : 25.9896
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:06:09" , 
"departure_time" : "07:06:09" , 
"distance_traveled" : 29.5494
} ], 
"1431" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "05:56:00" , 
"departure_time" : "05:57:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "06:00:29" , 
"departure_time" : "06:01:55" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 128,
"arrival_time" : "06:05:26" , 
"departure_time" : "06:05:43" , 
"distance_traveled" : 4.0337
}, 
{ 
"stop_id" : 3,
"arrival_time" : "06:07:17" , 
"departure_time" : "06:07:58" , 
"distance_traveled" : 5.9167
}, 
{ 
"stop_id" : 151,
"arrival_time" : "06:10:41" , 
"departure_time" : "06:11:05" , 
"distance_traveled" : 7.2525
}, 
{ 
"stop_id" : 64,
"arrival_time" : "06:14:24" , 
"departure_time" : "06:15:42" , 
"distance_traveled" : 8.4761
}, 
{ 
"stop_id" : 131,
"arrival_time" : "06:18:18" , 
"departure_time" : "06:19:39" , 
"distance_traveled" : 9.7036
}, 
{ 
"stop_id" : 51,
"arrival_time" : "06:22:21" , 
"departure_time" : "06:22:43" , 
"distance_traveled" : 11.1146
}, 
{ 
"stop_id" : 126,
"arrival_time" : "06:25:22" , 
"departure_time" : "06:26:03" , 
"distance_traveled" : 12.6549
}, 
{ 
"stop_id" : 25,
"arrival_time" : "06:29:41" , 
"departure_time" : "06:30:10" , 
"distance_traveled" : 13.9059
}, 
{ 
"stop_id" : 121,
"arrival_time" : "06:34:29" , 
"departure_time" : "06:34:44" , 
"distance_traveled" : 16.6335
}, 
{ 
"stop_id" : 46,
"arrival_time" : "06:37:15" , 
"departure_time" : "06:37:19" , 
"distance_traveled" : 17.9121
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "06:41:04" , 
"departure_time" : "06:42:02" , 
"distance_traveled" : 18.9341
}, 
{ 
"stop_id" : 134,
"arrival_time" : "06:46:58" , 
"departure_time" : "06:48:33" , 
"distance_traveled" : 20.8714
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "06:55:35" , 
"departure_time" : "06:55:55" , 
"distance_traveled" : 25.9896
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:06:20" , 
"departure_time" : "07:06:20" , 
"distance_traveled" : 29.5494
} ], 
"1432" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "08:05:00" , 
"departure_time" : "08:05:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "08:07:25" , 
"departure_time" : "08:08:42" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 128,
"arrival_time" : "08:13:17" , 
"departure_time" : "08:14:42" , 
"distance_traveled" : 4.0337
}, 
{ 
"stop_id" : 3,
"arrival_time" : "08:16:25" , 
"departure_time" : "08:17:59" , 
"distance_traveled" : 5.9167
}, 
{ 
"stop_id" : 151,
"arrival_time" : "08:19:34" , 
"departure_time" : "08:20:12" , 
"distance_traveled" : 7.2525
}, 
{ 
"stop_id" : 64,
"arrival_time" : "08:22:38" , 
"departure_time" : "08:23:25" , 
"distance_traveled" : 8.4761
}, 
{ 
"stop_id" : 131,
"arrival_time" : "08:25:47" , 
"departure_time" : "08:27:13" , 
"distance_traveled" : 9.7036
}, 
{ 
"stop_id" : 51,
"arrival_time" : "08:30:26" , 
"departure_time" : "08:31:30" , 
"distance_traveled" : 11.1146
}, 
{ 
"stop_id" : 126,
"arrival_time" : "08:34:04" , 
"departure_time" : "08:34:23" , 
"distance_traveled" : 12.6549
}, 
{ 
"stop_id" : 25,
"arrival_time" : "08:36:19" , 
"departure_time" : "08:37:55" , 
"distance_traveled" : 13.9059
}, 
{ 
"stop_id" : 121,
"arrival_time" : "08:42:36" , 
"departure_time" : "08:43:51" , 
"distance_traveled" : 16.6335
}, 
{ 
"stop_id" : 46,
"arrival_time" : "08:46:15" , 
"departure_time" : "08:47:51" , 
"distance_traveled" : 17.9121
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "08:49:36" , 
"departure_time" : "08:49:49" , 
"distance_traveled" : 18.9341
}, 
{ 
"stop_id" : 134,
"arrival_time" : "08:53:13" , 
"departure_time" : "08:53:21" , 
"distance_traveled" : 20.8714
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:01:08" , 
"departure_time" : "09:01:19" , 
"distance_traveled" : 25.9896
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:13:11" , 
"departure_time" : "09:13:11" , 
"distance_traveled" : 29.5494
} ], 
"1433" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "08:05:00" , 
"departure_time" : "08:06:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "08:08:18" , 
"departure_time" : "08:08:40" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 128,
"arrival_time" : "08:12:22" , 
"departure_time" : "08:13:50" , 
"distance_traveled" : 4.0337
}, 
{ 
"stop_id" : 3,
"arrival_time" : "08:16:28" , 
"departure_time" : "08:17:02" , 
"distance_traveled" : 5.9167
}, 
{ 
"stop_id" : 151,
"arrival_time" : "08:18:34" , 
"departure_time" : "08:19:07" , 
"distance_traveled" : 7.2525
}, 
{ 
"stop_id" : 64,
"arrival_time" : "08:22:33" , 
"departure_time" : "08:22:54" , 
"distance_traveled" : 8.4761
}, 
{ 
"stop_id" : 131,
"arrival_time" : "08:25:21" , 
"departure_time" : "08:26:15" , 
"distance_traveled" : 9.7036
}, 
{ 
"stop_id" : 51,
"arrival_time" : "08:29:54" , 
"departure_time" : "08:30:05" , 
"distance_traveled" : 11.1146
}, 
{ 
"stop_id" : 126,
"arrival_time" : "08:33:11" , 
"departure_time" : "08:33:41" , 
"distance_traveled" : 12.6549
}, 
{ 
"stop_id" : 25,
"arrival_time" : "08:36:30" , 
"departure_time" : "08:37:44" , 
"distance_traveled" : 13.9059
}, 
{ 
"stop_id" : 121,
"arrival_time" : "08:42:14" , 
"departure_time" : "08:42:58" , 
"distance_traveled" : 16.6335
}, 
{ 
"stop_id" : 46,
"arrival_time" : "08:45:44" , 
"departure_time" : "08:46:33" , 
"distance_traveled" : 17.9121
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "08:48:49" , 
"departure_time" : "08:49:08" , 
"distance_traveled" : 18.9341
}, 
{ 
"stop_id" : 134,
"arrival_time" : "08:53:19" , 
"departure_time" : "08:54:50" , 
"distance_traveled" : 20.8714
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:02:31" , 
"departure_time" : "09:03:51" , 
"distance_traveled" : 25.9896
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:14:20" , 
"departure_time" : "09:14:20" , 
"distance_traveled" : 29.5494
} ], 
"1434" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "05:30:00" , 
"departure_time" : "05:32:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "05:33:09" , 
"departure_time" : "05:33:58" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "05:35:49" , 
"departure_time" : "05:36:39" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "05:38:50" , 
"departure_time" : "05:40:26" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "05:43:36" , 
"departure_time" : "05:43:58" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "05:45:22" , 
"departure_time" : "05:47:02" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "05:49:40" , 
"departure_time" : "05:50:06" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "05:51:26" , 
"departure_time" : "05:51:30" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 51,
"arrival_time" : "05:55:04" , 
"departure_time" : "05:56:32" , 
"distance_traveled" : 11.1142
}, 
{ 
"stop_id" : 126,
"arrival_time" : "06:00:28" , 
"departure_time" : "06:01:15" , 
"distance_traveled" : 12.6545
}, 
{ 
"stop_id" : 25,
"arrival_time" : "06:02:47" , 
"departure_time" : "06:04:03" , 
"distance_traveled" : 13.9055
}, 
{ 
"stop_id" : 121,
"arrival_time" : "06:08:16" , 
"departure_time" : "06:09:26" , 
"distance_traveled" : 16.6331
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "06:13:10" , 
"departure_time" : "06:14:44" , 
"distance_traveled" : 18.9337
}, 
{ 
"stop_id" : 134,
"arrival_time" : "06:18:34" , 
"departure_time" : "06:19:20" , 
"distance_traveled" : 20.871
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "06:25:46" , 
"departure_time" : "06:27:03" , 
"distance_traveled" : 25.9892
}, 
{ 
"stop_id" : 63,
"arrival_time" : "06:38:17" , 
"departure_time" : "06:38:17" , 
"distance_traveled" : 29.5491
} ], 
"1435" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "05:30:00" , 
"departure_time" : "05:32:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "05:33:19" , 
"departure_time" : "05:34:04" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "05:35:45" , 
"departure_time" : "05:36:48" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "05:39:03" , 
"departure_time" : "05:39:35" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "05:42:32" , 
"departure_time" : "05:44:04" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "05:46:32" , 
"departure_time" : "05:47:36" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "05:49:04" , 
"departure_time" : "05:50:12" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "05:52:08" , 
"departure_time" : "05:52:39" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 51,
"arrival_time" : "05:55:31" , 
"departure_time" : "05:56:26" , 
"distance_traveled" : 11.1142
}, 
{ 
"stop_id" : 126,
"arrival_time" : "05:59:55" , 
"departure_time" : "06:00:12" , 
"distance_traveled" : 12.6545
}, 
{ 
"stop_id" : 25,
"arrival_time" : "06:02:17" , 
"departure_time" : "06:03:38" , 
"distance_traveled" : 13.9055
}, 
{ 
"stop_id" : 121,
"arrival_time" : "06:08:21" , 
"departure_time" : "06:09:36" , 
"distance_traveled" : 16.6331
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "06:13:15" , 
"departure_time" : "06:13:39" , 
"distance_traveled" : 18.9337
}, 
{ 
"stop_id" : 134,
"arrival_time" : "06:17:24" , 
"departure_time" : "06:18:39" , 
"distance_traveled" : 20.871
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "06:26:15" , 
"departure_time" : "06:27:37" , 
"distance_traveled" : 25.9892
}, 
{ 
"stop_id" : 63,
"arrival_time" : "06:38:22" , 
"departure_time" : "06:38:22" , 
"distance_traveled" : 29.5491
} ], 
"1436" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "06:22:00" , 
"departure_time" : "06:24:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "06:25:59" , 
"departure_time" : "06:26:57" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "06:28:58" , 
"departure_time" : "06:29:20" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "06:31:22" , 
"departure_time" : "06:31:49" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "06:35:27" , 
"departure_time" : "06:36:39" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "06:39:12" , 
"departure_time" : "06:39:32" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "06:42:20" , 
"departure_time" : "06:43:33" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "06:46:13" , 
"departure_time" : "06:47:46" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 51,
"arrival_time" : "06:50:33" , 
"departure_time" : "06:51:15" , 
"distance_traveled" : 11.1142
}, 
{ 
"stop_id" : 126,
"arrival_time" : "06:53:42" , 
"departure_time" : "06:55:10" , 
"distance_traveled" : 12.6545
}, 
{ 
"stop_id" : 25,
"arrival_time" : "06:58:28" , 
"departure_time" : "06:59:55" , 
"distance_traveled" : 13.9055
}, 
{ 
"stop_id" : 121,
"arrival_time" : "07:03:27" , 
"departure_time" : "07:03:35" , 
"distance_traveled" : 16.6331
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "07:07:08" , 
"departure_time" : "07:08:00" , 
"distance_traveled" : 18.9337
}, 
{ 
"stop_id" : 134,
"arrival_time" : "07:12:52" , 
"departure_time" : "07:14:24" , 
"distance_traveled" : 20.871
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:21:32" , 
"departure_time" : "07:22:12" , 
"distance_traveled" : 25.9892
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:32:40" , 
"departure_time" : "07:32:40" , 
"distance_traveled" : 29.5491
} ], 
"1437" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "06:22:00" , 
"departure_time" : "06:24:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "06:26:37" , 
"departure_time" : "06:26:46" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "06:28:09" , 
"departure_time" : "06:28:38" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "06:31:29" , 
"departure_time" : "06:33:02" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "06:36:33" , 
"departure_time" : "06:36:49" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "06:38:16" , 
"departure_time" : "06:38:58" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "06:42:42" , 
"departure_time" : "06:43:39" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "06:45:57" , 
"departure_time" : "06:46:22" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 51,
"arrival_time" : "06:49:25" , 
"departure_time" : "06:50:16" , 
"distance_traveled" : 11.1142
}, 
{ 
"stop_id" : 126,
"arrival_time" : "06:53:51" , 
"departure_time" : "06:54:54" , 
"distance_traveled" : 12.6545
}, 
{ 
"stop_id" : 25,
"arrival_time" : "06:58:03" , 
"departure_time" : "06:58:09" , 
"distance_traveled" : 13.9055
}, 
{ 
"stop_id" : 121,
"arrival_time" : "07:02:06" , 
"departure_time" : "07:02:28" , 
"distance_traveled" : 16.6331
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "07:07:22" , 
"departure_time" : "07:08:54" , 
"distance_traveled" : 18.9337
}, 
{ 
"stop_id" : 134,
"arrival_time" : "07:13:32" , 
"departure_time" : "07:14:08" , 
"distance_traveled" : 20.871
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:20:36" , 
"departure_time" : "07:20:47" , 
"distance_traveled" : 25.9892
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:32:11" , 
"departure_time" : "07:32:11" , 
"distance_traveled" : 29.5491
} ], 
"1438" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "09:14:00" , 
"departure_time" : "09:14:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "09:17:07" , 
"departure_time" : "09:17:24" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "09:20:17" , 
"departure_time" : "09:20:47" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "09:23:30" , 
"departure_time" : "09:24:39" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "09:28:09" , 
"departure_time" : "09:29:18" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "09:31:09" , 
"departure_time" : "09:32:01" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "09:33:52" , 
"departure_time" : "09:34:42" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "09:37:50" , 
"departure_time" : "09:38:27" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 51,
"arrival_time" : "09:40:37" , 
"departure_time" : "09:42:03" , 
"distance_traveled" : 11.1142
}, 
{ 
"stop_id" : 126,
"arrival_time" : "09:45:26" , 
"departure_time" : "09:46:57" , 
"distance_traveled" : 12.6545
}, 
{ 
"stop_id" : 25,
"arrival_time" : "09:48:31" , 
"departure_time" : "09:49:32" , 
"distance_traveled" : 13.9055
}, 
{ 
"stop_id" : 121,
"arrival_time" : "09:52:01" , 
"departure_time" : "09:53:09" , 
"distance_traveled" : 16.6331
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "09:57:08" , 
"departure_time" : "09:57:10" , 
"distance_traveled" : 18.9337
}, 
{ 
"stop_id" : 134,
"arrival_time" : "10:01:02" , 
"departure_time" : "10:02:39" , 
"distance_traveled" : 20.871
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "10:11:37" , 
"departure_time" : "10:12:09" , 
"distance_traveled" : 25.9892
}, 
{ 
"stop_id" : 63,
"arrival_time" : "10:22:32" , 
"departure_time" : "10:22:32" , 
"distance_traveled" : 29.5491
} ], 
"1439" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "09:14:00" , 
"departure_time" : "09:14:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "09:17:18" , 
"departure_time" : "09:18:08" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "09:20:50" , 
"departure_time" : "09:21:39" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "09:23:49" , 
"departure_time" : "09:24:09" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "09:27:20" , 
"departure_time" : "09:28:12" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "09:30:52" , 
"departure_time" : "09:31:29" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "09:33:37" , 
"departure_time" : "09:33:43" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "09:37:06" , 
"departure_time" : "09:38:31" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 51,
"arrival_time" : "09:41:25" , 
"departure_time" : "09:42:01" , 
"distance_traveled" : 11.1142
}, 
{ 
"stop_id" : 126,
"arrival_time" : "09:44:36" , 
"departure_time" : "09:45:22" , 
"distance_traveled" : 12.6545
}, 
{ 
"stop_id" : 25,
"arrival_time" : "09:47:46" , 
"departure_time" : "09:47:58" , 
"distance_traveled" : 13.9055
}, 
{ 
"stop_id" : 121,
"arrival_time" : "09:51:12" , 
"departure_time" : "09:52:47" , 
"distance_traveled" : 16.6331
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "09:57:35" , 
"departure_time" : "09:57:38" , 
"distance_traveled" : 18.9337
}, 
{ 
"stop_id" : 134,
"arrival_time" : "10:01:03" , 
"departure_time" : "10:02:26" , 
"distance_traveled" : 20.871
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "10:11:23" , 
"departure_time" : "10:11:48" , 
"distance_traveled" : 25.9892
}, 
{ 
"stop_id" : 63,
"arrival_time" : "10:22:25" , 
"departure_time" : "10:22:25" , 
"distance_traveled" : 29.5491
} ], 
"1440" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "16:27:00" , 
"departure_time" : "16:27:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "16:30:26" , 
"departure_time" : "16:30:41" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "16:33:15" , 
"departure_time" : "16:34:47" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "16:37:32" , 
"departure_time" : "16:38:03" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "16:40:31" , 
"departure_time" : "16:40:42" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "16:43:11" , 
"departure_time" : "16:44:02" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "16:46:51" , 
"departure_time" : "16:47:03" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "16:50:12" , 
"departure_time" : "16:51:10" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 51,
"arrival_time" : "16:54:58" , 
"departure_time" : "16:56:22" , 
"distance_traveled" : 11.1142
}, 
{ 
"stop_id" : 126,
"arrival_time" : "16:58:24" , 
"departure_time" : "16:59:59" , 
"distance_traveled" : 12.6545
}, 
{ 
"stop_id" : 25,
"arrival_time" : "17:02:35" , 
"departure_time" : "17:02:50" , 
"distance_traveled" : 13.9055
}, 
{ 
"stop_id" : 121,
"arrival_time" : "17:06:15" , 
"departure_time" : "17:07:38" , 
"distance_traveled" : 16.6331
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "17:11:23" , 
"departure_time" : "17:12:21" , 
"distance_traveled" : 18.9337
}, 
{ 
"stop_id" : 134,
"arrival_time" : "17:15:58" , 
"departure_time" : "17:16:31" , 
"distance_traveled" : 20.871
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:23:33" , 
"departure_time" : "17:24:32" , 
"distance_traveled" : 25.9892
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:35:59" , 
"departure_time" : "17:35:59" , 
"distance_traveled" : 29.5491
} ], 
"1441" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "16:27:00" , 
"departure_time" : "16:28:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "16:30:42" , 
"departure_time" : "16:31:11" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "16:33:29" , 
"departure_time" : "16:34:46" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "16:37:17" , 
"departure_time" : "16:37:18" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "16:40:01" , 
"departure_time" : "16:41:32" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "16:44:31" , 
"departure_time" : "16:44:47" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "16:46:16" , 
"departure_time" : "16:47:43" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "16:51:27" , 
"departure_time" : "16:52:46" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 51,
"arrival_time" : "16:55:19" , 
"departure_time" : "16:56:30" , 
"distance_traveled" : 11.1142
}, 
{ 
"stop_id" : 126,
"arrival_time" : "16:58:11" , 
"departure_time" : "16:58:25" , 
"distance_traveled" : 12.6545
}, 
{ 
"stop_id" : 25,
"arrival_time" : "17:01:14" , 
"departure_time" : "17:02:36" , 
"distance_traveled" : 13.9055
}, 
{ 
"stop_id" : 121,
"arrival_time" : "17:07:22" , 
"departure_time" : "17:08:24" , 
"distance_traveled" : 16.6331
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "17:11:02" , 
"departure_time" : "17:12:25" , 
"distance_traveled" : 18.9337
}, 
{ 
"stop_id" : 134,
"arrival_time" : "17:16:23" , 
"departure_time" : "17:17:36" , 
"distance_traveled" : 20.871
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:24:13" , 
"departure_time" : "17:25:03" , 
"distance_traveled" : 25.9892
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:35:50" , 
"departure_time" : "17:35:50" , 
"distance_traveled" : 29.5491
} ], 
"1442" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "08:34:00" , 
"departure_time" : "08:35:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "08:37:54" , 
"departure_time" : "08:38:14" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "08:40:20" , 
"departure_time" : "08:41:20" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "08:44:00" , 
"departure_time" : "08:45:18" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "08:47:18" , 
"departure_time" : "08:48:53" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "08:51:35" , 
"departure_time" : "08:51:58" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "08:53:23" , 
"departure_time" : "08:54:38" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "08:57:15" , 
"departure_time" : "08:57:26" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 51,
"arrival_time" : "09:00:11" , 
"departure_time" : "09:01:10" , 
"distance_traveled" : 11.1142
}, 
{ 
"stop_id" : 126,
"arrival_time" : "09:04:59" , 
"departure_time" : "09:06:26" , 
"distance_traveled" : 12.6545
}, 
{ 
"stop_id" : 25,
"arrival_time" : "09:08:27" , 
"departure_time" : "09:09:24" , 
"distance_traveled" : 13.9055
}, 
{ 
"stop_id" : 121,
"arrival_time" : "09:12:57" , 
"departure_time" : "09:13:00" , 
"distance_traveled" : 16.6331
}, 
{ 
"stop_id" : 46,
"arrival_time" : "09:15:03" , 
"departure_time" : "09:16:37" , 
"distance_traveled" : 17.9117
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "09:19:34" , 
"departure_time" : "09:19:40" , 
"distance_traveled" : 18.9337
}, 
{ 
"stop_id" : 134,
"arrival_time" : "09:23:06" , 
"departure_time" : "09:24:37" , 
"distance_traveled" : 20.871
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:32:31" , 
"departure_time" : "09:32:50" , 
"distance_traveled" : 25.9892
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:43:19" , 
"departure_time" : "09:43:19" , 
"distance_traveled" : 29.5491
} ], 
"1443" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "08:34:00" , 
"departure_time" : "08:35:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "08:38:32" , 
"departure_time" : "08:39:15" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "08:40:43" , 
"departure_time" : "08:41:36" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "08:43:53" , 
"departure_time" : "08:44:32" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "08:46:39" , 
"departure_time" : "08:47:46" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "08:51:07" , 
"departure_time" : "08:52:24" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "08:54:17" , 
"departure_time" : "08:55:02" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "08:56:45" , 
"departure_time" : "08:58:08" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 51,
"arrival_time" : "09:01:23" , 
"departure_time" : "09:02:08" , 
"distance_traveled" : 11.1142
}, 
{ 
"stop_id" : 126,
"arrival_time" : "09:04:45" , 
"departure_time" : "09:05:36" , 
"distance_traveled" : 12.6545
}, 
{ 
"stop_id" : 25,
"arrival_time" : "09:07:51" , 
"departure_time" : "09:08:57" , 
"distance_traveled" : 13.9055
}, 
{ 
"stop_id" : 121,
"arrival_time" : "09:13:06" , 
"departure_time" : "09:13:58" , 
"distance_traveled" : 16.6331
}, 
{ 
"stop_id" : 46,
"arrival_time" : "09:15:52" , 
"departure_time" : "09:16:04" , 
"distance_traveled" : 17.9117
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "09:18:12" , 
"departure_time" : "09:18:33" , 
"distance_traveled" : 18.9337
}, 
{ 
"stop_id" : 134,
"arrival_time" : "09:23:21" , 
"departure_time" : "09:24:34" , 
"distance_traveled" : 20.871
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:32:13" , 
"departure_time" : "09:32:33" , 
"distance_traveled" : 25.9892
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:43:20" , 
"departure_time" : "09:43:20" , 
"distance_traveled" : 29.5491
} ], 
"1444" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "15:12:00" , 
"departure_time" : "15:12:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "15:14:26" , 
"departure_time" : "15:15:10" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "15:17:44" , 
"departure_time" : "15:18:33" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "15:20:49" , 
"departure_time" : "15:21:39" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "15:24:50" , 
"departure_time" : "15:26:19" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "15:28:29" , 
"departure_time" : "15:29:24" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "15:30:55" , 
"departure_time" : "15:31:47" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "15:34:52" , 
"departure_time" : "15:36:02" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 51,
"arrival_time" : "15:39:10" , 
"departure_time" : "15:39:21" , 
"distance_traveled" : 11.1142
}, 
{ 
"stop_id" : 126,
"arrival_time" : "15:41:11" , 
"departure_time" : "15:41:52" , 
"distance_traveled" : 12.6545
}, 
{ 
"stop_id" : 25,
"arrival_time" : "15:44:41" , 
"departure_time" : "15:45:18" , 
"distance_traveled" : 13.9055
}, 
{ 
"stop_id" : 121,
"arrival_time" : "15:49:37" , 
"departure_time" : "15:49:43" , 
"distance_traveled" : 16.6331
}, 
{ 
"stop_id" : 46,
"arrival_time" : "15:52:06" , 
"departure_time" : "15:53:06" , 
"distance_traveled" : 17.9117
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "15:56:00" , 
"departure_time" : "15:56:01" , 
"distance_traveled" : 18.9337
}, 
{ 
"stop_id" : 134,
"arrival_time" : "16:00:01" , 
"departure_time" : "16:00:26" , 
"distance_traveled" : 20.871
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:08:25" , 
"departure_time" : "16:09:59" , 
"distance_traveled" : 25.9892
}, 
{ 
"stop_id" : 63,
"arrival_time" : "16:21:34" , 
"departure_time" : "16:21:34" , 
"distance_traveled" : 29.5491
} ], 
"1445" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "15:12:00" , 
"departure_time" : "15:13:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "15:14:25" , 
"departure_time" : "15:14:29" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "15:17:04" , 
"departure_time" : "15:17:29" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "15:20:25" , 
"departure_time" : "15:21:07" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "15:24:42" , 
"departure_time" : "15:25:26" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "15:27:44" , 
"departure_time" : "15:28:24" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "15:30:40" , 
"departure_time" : "15:30:50" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "15:34:10" , 
"departure_time" : "15:35:30" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 51,
"arrival_time" : "15:39:20" , 
"departure_time" : "15:40:23" , 
"distance_traveled" : 11.1142
}, 
{ 
"stop_id" : 126,
"arrival_time" : "15:42:03" , 
"departure_time" : "15:43:18" , 
"distance_traveled" : 12.6545
}, 
{ 
"stop_id" : 25,
"arrival_time" : "15:45:15" , 
"departure_time" : "15:46:52" , 
"distance_traveled" : 13.9055
}, 
{ 
"stop_id" : 121,
"arrival_time" : "15:50:37" , 
"departure_time" : "15:51:16" , 
"distance_traveled" : 16.6331
}, 
{ 
"stop_id" : 46,
"arrival_time" : "15:52:39" , 
"departure_time" : "15:53:42" , 
"distance_traveled" : 17.9117
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "15:56:03" , 
"departure_time" : "15:57:40" , 
"distance_traveled" : 18.9337
}, 
{ 
"stop_id" : 134,
"arrival_time" : "16:01:37" , 
"departure_time" : "16:01:59" , 
"distance_traveled" : 20.871
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:08:22" , 
"departure_time" : "16:09:37" , 
"distance_traveled" : 25.9892
}, 
{ 
"stop_id" : 63,
"arrival_time" : "16:21:15" , 
"departure_time" : "16:21:15" , 
"distance_traveled" : 29.5491
} ], 
"1446" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "04:50:00" , 
"departure_time" : "04:51:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "04:53:35" , 
"departure_time" : "04:54:37" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "04:57:02" , 
"departure_time" : "04:57:19" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "04:59:17" , 
"departure_time" : "05:00:30" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "05:03:13" , 
"departure_time" : "05:03:15" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "05:05:02" , 
"departure_time" : "05:05:24" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "05:08:22" , 
"departure_time" : "05:09:24" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "05:12:02" , 
"departure_time" : "05:12:12" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "05:14:10" , 
"departure_time" : "05:15:11" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "05:18:01" , 
"departure_time" : "05:18:46" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "05:21:45" , 
"departure_time" : "05:22:20" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "05:28:35" , 
"departure_time" : "05:29:16" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "05:31:41" , 
"departure_time" : "05:32:23" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "05:34:42" , 
"departure_time" : "05:34:45" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "05:37:03" , 
"departure_time" : "05:37:18" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "05:40:15" , 
"departure_time" : "05:40:56" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "05:48:41" , 
"departure_time" : "05:49:59" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "06:01:18" , 
"departure_time" : "06:01:18" , 
"distance_traveled" : 30.7472
} ], 
"1447" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "04:50:00" , 
"departure_time" : "04:52:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "04:54:05" , 
"departure_time" : "04:55:32" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "04:57:27" , 
"departure_time" : "04:58:10" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "04:59:43" , 
"departure_time" : "05:01:11" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "05:03:28" , 
"departure_time" : "05:04:47" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "05:06:19" , 
"departure_time" : "05:06:51" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "05:08:32" , 
"departure_time" : "05:09:36" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "05:12:04" , 
"departure_time" : "05:13:41" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "05:15:37" , 
"departure_time" : "05:16:23" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "05:17:46" , 
"departure_time" : "05:19:22" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "05:22:36" , 
"departure_time" : "05:22:37" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "05:28:01" , 
"departure_time" : "05:29:16" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "05:32:15" , 
"departure_time" : "05:32:32" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "05:34:17" , 
"departure_time" : "05:35:17" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "05:38:00" , 
"departure_time" : "05:38:59" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "05:40:59" , 
"departure_time" : "05:41:35" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "05:48:36" , 
"departure_time" : "05:48:46" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "06:00:10" , 
"departure_time" : "06:00:10" , 
"distance_traveled" : 30.7472
} ], 
"1448" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "05:20:00" , 
"departure_time" : "05:20:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "05:23:22" , 
"departure_time" : "05:24:57" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "05:27:35" , 
"departure_time" : "05:28:49" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "05:30:14" , 
"departure_time" : "05:30:51" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "05:32:37" , 
"departure_time" : "05:33:47" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "05:36:10" , 
"departure_time" : "05:36:42" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "05:38:32" , 
"departure_time" : "05:39:28" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "05:41:56" , 
"departure_time" : "05:43:31" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "05:45:35" , 
"departure_time" : "05:45:42" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "05:47:07" , 
"departure_time" : "05:47:58" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "05:51:51" , 
"departure_time" : "05:52:40" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "05:58:49" , 
"departure_time" : "06:00:12" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "06:03:23" , 
"departure_time" : "06:03:32" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "06:05:09" , 
"departure_time" : "06:05:22" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "06:08:13" , 
"departure_time" : "06:08:42" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "06:10:29" , 
"departure_time" : "06:10:38" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "06:18:09" , 
"departure_time" : "06:19:12" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "06:31:03" , 
"departure_time" : "06:31:03" , 
"distance_traveled" : 30.7472
} ], 
"1449" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "05:20:00" , 
"departure_time" : "05:21:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "05:23:27" , 
"departure_time" : "05:24:40" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "05:27:13" , 
"departure_time" : "05:28:00" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "05:29:47" , 
"departure_time" : "05:31:25" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "05:33:38" , 
"departure_time" : "05:33:45" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "05:35:07" , 
"departure_time" : "05:36:21" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "05:39:14" , 
"departure_time" : "05:39:47" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "05:41:33" , 
"departure_time" : "05:42:54" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "05:45:21" , 
"departure_time" : "05:46:43" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "05:48:22" , 
"departure_time" : "05:48:37" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "05:51:15" , 
"departure_time" : "05:52:45" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "05:59:30" , 
"departure_time" : "06:00:27" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "06:02:57" , 
"departure_time" : "06:04:25" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "06:06:28" , 
"departure_time" : "06:07:22" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "06:08:54" , 
"departure_time" : "06:10:11" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "06:11:17" , 
"departure_time" : "06:11:29" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "06:18:12" , 
"departure_time" : "06:19:14" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "06:31:02" , 
"departure_time" : "06:31:02" , 
"distance_traveled" : 30.7472
} ], 
"1450" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "09:54:00" , 
"departure_time" : "09:56:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "09:58:13" , 
"departure_time" : "09:59:18" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "10:01:05" , 
"departure_time" : "10:01:13" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "10:04:08" , 
"departure_time" : "10:05:25" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "10:08:17" , 
"departure_time" : "10:09:00" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "10:10:43" , 
"departure_time" : "10:11:59" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "10:15:16" , 
"departure_time" : "10:15:49" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "10:17:33" , 
"departure_time" : "10:18:03" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "10:20:30" , 
"departure_time" : "10:21:32" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "10:25:02" , 
"departure_time" : "10:26:27" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "10:29:25" , 
"departure_time" : "10:29:34" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "10:34:09" , 
"departure_time" : "10:35:22" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "10:39:13" , 
"departure_time" : "10:40:08" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "10:41:55" , 
"departure_time" : "10:42:24" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "10:44:29" , 
"departure_time" : "10:44:43" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "10:46:14" , 
"departure_time" : "10:47:03" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "10:54:49" , 
"departure_time" : "10:55:03" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "11:06:14" , 
"departure_time" : "11:06:14" , 
"distance_traveled" : 30.7472
} ], 
"1451" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "09:54:00" , 
"departure_time" : "09:54:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "09:57:25" , 
"departure_time" : "09:58:07" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "10:00:42" , 
"departure_time" : "10:01:41" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "10:04:59" , 
"departure_time" : "10:06:04" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "10:08:05" , 
"departure_time" : "10:08:11" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "10:10:06" , 
"departure_time" : "10:11:17" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "10:15:11" , 
"departure_time" : "10:15:49" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "10:17:38" , 
"departure_time" : "10:18:17" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "10:20:39" , 
"departure_time" : "10:21:02" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "10:24:23" , 
"departure_time" : "10:26:02" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "10:29:39" , 
"departure_time" : "10:29:46" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "10:34:07" , 
"departure_time" : "10:35:41" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "10:39:34" , 
"departure_time" : "10:40:54" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "10:42:20" , 
"departure_time" : "10:42:46" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "10:44:26" , 
"departure_time" : "10:44:37" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "10:46:11" , 
"departure_time" : "10:47:45" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "10:55:34" , 
"departure_time" : "10:56:17" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "11:06:43" , 
"departure_time" : "11:06:43" , 
"distance_traveled" : 30.7472
} ], 
"1452" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "10:54:00" , 
"departure_time" : "10:55:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "10:57:55" , 
"departure_time" : "10:59:28" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "11:01:33" , 
"departure_time" : "11:03:05" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "11:05:32" , 
"departure_time" : "11:05:49" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "11:07:17" , 
"departure_time" : "11:08:51" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "11:11:34" , 
"departure_time" : "11:12:02" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "11:14:28" , 
"departure_time" : "11:15:46" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "11:18:18" , 
"departure_time" : "11:18:56" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "11:20:38" , 
"departure_time" : "11:20:40" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "11:24:02" , 
"departure_time" : "11:24:25" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "11:28:23" , 
"departure_time" : "11:28:26" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "11:34:03" , 
"departure_time" : "11:35:11" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "11:39:08" , 
"departure_time" : "11:40:26" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "11:42:18" , 
"departure_time" : "11:43:10" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "11:44:52" , 
"departure_time" : "11:44:53" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "11:46:01" , 
"departure_time" : "11:46:42" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "11:54:41" , 
"departure_time" : "11:54:44" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "12:06:03" , 
"departure_time" : "12:06:03" , 
"distance_traveled" : 30.7472
} ], 
"1453" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "10:54:00" , 
"departure_time" : "10:55:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "10:58:07" , 
"departure_time" : "10:59:36" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "11:01:29" , 
"departure_time" : "11:02:19" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "11:04:50" , 
"departure_time" : "11:05:08" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "11:07:18" , 
"departure_time" : "11:07:53" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "11:10:35" , 
"departure_time" : "11:12:12" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "11:15:37" , 
"departure_time" : "11:15:59" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "11:17:22" , 
"departure_time" : "11:17:41" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "11:20:19" , 
"departure_time" : "11:21:51" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "11:25:32" , 
"departure_time" : "11:26:19" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "11:28:47" , 
"departure_time" : "11:29:39" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "11:34:52" , 
"departure_time" : "11:36:00" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "11:39:08" , 
"departure_time" : "11:39:35" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "11:41:27" , 
"departure_time" : "11:42:00" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "11:44:33" , 
"departure_time" : "11:45:10" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "11:46:37" , 
"departure_time" : "11:47:10" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "11:54:33" , 
"departure_time" : "11:55:37" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "12:07:04" , 
"departure_time" : "12:07:04" , 
"distance_traveled" : 30.7472
} ], 
"1454" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "11:54:00" , 
"departure_time" : "11:56:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "11:57:57" , 
"departure_time" : "11:58:04" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "12:00:07" , 
"departure_time" : "12:00:36" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "12:04:29" , 
"departure_time" : "12:06:09" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "12:08:40" , 
"departure_time" : "12:10:01" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "12:11:21" , 
"departure_time" : "12:12:01" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "12:14:40" , 
"departure_time" : "12:14:50" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "12:17:10" , 
"departure_time" : "12:18:40" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "12:21:30" , 
"departure_time" : "12:22:42" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "12:25:12" , 
"departure_time" : "12:25:50" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "12:28:38" , 
"departure_time" : "12:29:43" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "12:35:05" , 
"departure_time" : "12:36:13" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "12:39:08" , 
"departure_time" : "12:40:03" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "12:41:55" , 
"departure_time" : "12:43:18" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "12:45:23" , 
"departure_time" : "12:46:30" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "12:47:07" , 
"departure_time" : "12:47:08" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "12:54:01" , 
"departure_time" : "12:55:39" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "13:07:38" , 
"departure_time" : "13:07:38" , 
"distance_traveled" : 30.7472
} ], 
"1455" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "11:54:00" , 
"departure_time" : "11:56:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "11:57:43" , 
"departure_time" : "11:57:56" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "12:00:13" , 
"departure_time" : "12:00:42" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "12:04:29" , 
"departure_time" : "12:05:52" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "12:08:23" , 
"departure_time" : "12:08:57" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "12:10:34" , 
"departure_time" : "12:11:54" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "12:15:20" , 
"departure_time" : "12:16:04" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "12:17:44" , 
"departure_time" : "12:19:04" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "12:21:20" , 
"departure_time" : "12:22:24" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "12:25:04" , 
"departure_time" : "12:25:52" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "12:28:48" , 
"departure_time" : "12:30:27" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "12:35:39" , 
"departure_time" : "12:36:47" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "12:39:08" , 
"departure_time" : "12:39:13" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "12:41:05" , 
"departure_time" : "12:41:36" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "12:44:31" , 
"departure_time" : "12:46:11" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "12:47:40" , 
"departure_time" : "12:49:13" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "12:55:33" , 
"departure_time" : "12:57:09" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "13:07:36" , 
"departure_time" : "13:07:36" , 
"distance_traveled" : 30.7472
} ], 
"1456" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "12:54:00" , 
"departure_time" : "12:56:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "12:57:51" , 
"departure_time" : "12:59:14" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "13:01:23" , 
"departure_time" : "13:01:52" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "13:04:29" , 
"departure_time" : "13:05:24" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "13:07:55" , 
"departure_time" : "13:09:19" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "13:11:24" , 
"departure_time" : "13:12:51" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "13:15:27" , 
"departure_time" : "13:16:44" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "13:18:17" , 
"departure_time" : "13:18:31" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "13:20:14" , 
"departure_time" : "13:21:48" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "13:25:34" , 
"departure_time" : "13:25:54" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "13:28:20" , 
"departure_time" : "13:28:54" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "13:34:34" , 
"departure_time" : "13:35:58" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "13:39:24" , 
"departure_time" : "13:39:45" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "13:41:21" , 
"departure_time" : "13:41:53" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "13:44:32" , 
"departure_time" : "13:46:04" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "13:47:32" , 
"departure_time" : "13:49:12" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "13:55:40" , 
"departure_time" : "13:56:54" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "14:07:14" , 
"departure_time" : "14:07:14" , 
"distance_traveled" : 30.7472
} ], 
"1457" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "12:54:00" , 
"departure_time" : "12:55:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "12:57:04" , 
"departure_time" : "12:58:03" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "13:00:59" , 
"departure_time" : "13:01:52" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "13:04:53" , 
"departure_time" : "13:05:40" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "13:07:47" , 
"departure_time" : "13:09:19" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "13:11:32" , 
"departure_time" : "13:12:15" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "13:14:43" , 
"departure_time" : "13:15:05" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "13:17:22" , 
"departure_time" : "13:18:43" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "13:21:21" , 
"departure_time" : "13:21:54" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "13:24:33" , 
"departure_time" : "13:26:07" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "13:29:34" , 
"departure_time" : "13:31:01" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "13:35:27" , 
"departure_time" : "13:36:26" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "13:38:59" , 
"departure_time" : "13:39:16" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "13:41:17" , 
"departure_time" : "13:41:18" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "13:44:01" , 
"departure_time" : "13:44:47" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "13:46:46" , 
"departure_time" : "13:46:57" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "13:54:11" , 
"departure_time" : "13:54:34" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "14:06:23" , 
"departure_time" : "14:06:23" , 
"distance_traveled" : 30.7472
} ], 
"1458" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "13:52:00" , 
"departure_time" : "13:53:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "13:55:40" , 
"departure_time" : "13:56:36" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "13:58:56" , 
"departure_time" : "13:59:24" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "14:02:28" , 
"departure_time" : "14:03:48" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "14:06:20" , 
"departure_time" : "14:07:37" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "14:09:17" , 
"departure_time" : "14:10:07" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "14:12:50" , 
"departure_time" : "14:13:46" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "14:15:56" , 
"departure_time" : "14:16:40" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "14:18:44" , 
"departure_time" : "14:19:45" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "14:23:01" , 
"departure_time" : "14:23:19" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "14:26:18" , 
"departure_time" : "14:26:45" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "14:32:27" , 
"departure_time" : "14:32:57" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "14:36:30" , 
"departure_time" : "14:36:34" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "14:39:04" , 
"departure_time" : "14:39:16" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "14:42:12" , 
"departure_time" : "14:43:42" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "14:45:30" , 
"departure_time" : "14:46:19" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "14:52:49" , 
"departure_time" : "14:54:26" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "15:05:37" , 
"departure_time" : "15:05:37" , 
"distance_traveled" : 30.7472
} ], 
"1459" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "13:52:00" , 
"departure_time" : "13:55:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "13:56:37" , 
"departure_time" : "13:57:53" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "13:59:16" , 
"departure_time" : "14:00:47" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "14:03:31" , 
"departure_time" : "14:05:09" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "14:06:38" , 
"departure_time" : "14:06:56" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "14:08:18" , 
"departure_time" : "14:09:09" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "14:12:51" , 
"departure_time" : "14:13:20" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "14:15:29" , 
"departure_time" : "14:16:17" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "14:18:48" , 
"departure_time" : "14:19:01" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "14:22:13" , 
"departure_time" : "14:22:21" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "14:26:08" , 
"departure_time" : "14:26:25" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "14:32:17" , 
"departure_time" : "14:32:31" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "14:36:14" , 
"departure_time" : "14:36:45" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "14:39:31" , 
"departure_time" : "14:41:05" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "14:43:34" , 
"departure_time" : "14:44:21" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "14:44:47" , 
"departure_time" : "14:44:58" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "14:52:11" , 
"departure_time" : "14:53:44" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "15:05:33" , 
"departure_time" : "15:05:33" , 
"distance_traveled" : 30.7472
} ], 
"1460" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "14:47:00" , 
"departure_time" : "14:48:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "14:50:04" , 
"departure_time" : "14:50:19" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "14:53:15" , 
"departure_time" : "14:54:24" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "14:57:09" , 
"departure_time" : "14:57:41" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "14:59:32" , 
"departure_time" : "15:01:00" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "15:04:28" , 
"departure_time" : "15:05:57" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "15:07:29" , 
"departure_time" : "15:08:06" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "15:10:37" , 
"departure_time" : "15:11:10" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "15:13:33" , 
"departure_time" : "15:13:46" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "15:17:13" , 
"departure_time" : "15:18:07" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "15:21:54" , 
"departure_time" : "15:23:16" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "15:28:22" , 
"departure_time" : "15:28:56" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "15:30:34" , 
"departure_time" : "15:31:57" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "15:34:23" , 
"departure_time" : "15:35:59" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "15:37:36" , 
"departure_time" : "15:38:42" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "15:39:06" , 
"departure_time" : "15:39:49" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "15:46:43" , 
"departure_time" : "15:47:49" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "15:59:06" , 
"departure_time" : "15:59:06" , 
"distance_traveled" : 30.7472
} ], 
"1461" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "14:47:00" , 
"departure_time" : "14:48:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "14:50:25" , 
"departure_time" : "14:51:01" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "14:53:36" , 
"departure_time" : "14:53:56" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "14:56:20" , 
"departure_time" : "14:57:52" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "15:00:32" , 
"departure_time" : "15:00:40" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "15:03:08" , 
"departure_time" : "15:04:00" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "15:06:52" , 
"departure_time" : "15:07:50" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "15:10:58" , 
"departure_time" : "15:11:17" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "15:13:19" , 
"departure_time" : "15:13:56" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "15:17:37" , 
"departure_time" : "15:19:04" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "15:22:27" , 
"departure_time" : "15:22:46" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "15:27:19" , 
"departure_time" : "15:28:26" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "15:31:07" , 
"departure_time" : "15:31:39" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "15:33:32" , 
"departure_time" : "15:34:01" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "15:36:29" , 
"departure_time" : "15:37:10" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "15:38:41" , 
"departure_time" : "15:39:11" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "15:46:30" , 
"departure_time" : "15:48:05" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "15:59:35" , 
"departure_time" : "15:59:35" , 
"distance_traveled" : 30.7472
} ], 
"1462" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "16:05:00" , 
"departure_time" : "16:07:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "16:08:43" , 
"departure_time" : "16:10:23" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "16:12:40" , 
"departure_time" : "16:12:47" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "16:14:07" , 
"departure_time" : "16:14:34" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "16:18:27" , 
"departure_time" : "16:19:13" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "16:21:46" , 
"departure_time" : "16:21:51" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "16:25:05" , 
"departure_time" : "16:26:13" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "16:29:08" , 
"departure_time" : "16:29:13" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "16:31:05" , 
"departure_time" : "16:31:34" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "16:35:29" , 
"departure_time" : "16:36:27" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "16:39:58" , 
"departure_time" : "16:40:53" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "16:46:55" , 
"departure_time" : "16:48:29" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "16:50:34" , 
"departure_time" : "16:51:30" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "16:52:56" , 
"departure_time" : "16:54:22" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "16:55:26" , 
"departure_time" : "16:56:46" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "16:58:20" , 
"departure_time" : "16:58:26" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:05:06" , 
"departure_time" : "17:06:07" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:18:01" , 
"departure_time" : "17:18:01" , 
"distance_traveled" : 30.7472
} ], 
"1463" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "16:05:00" , 
"departure_time" : "16:07:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "16:09:25" , 
"departure_time" : "16:10:26" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "16:12:01" , 
"departure_time" : "16:13:29" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "16:15:28" , 
"departure_time" : "16:16:40" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "16:19:12" , 
"departure_time" : "16:20:26" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "16:22:14" , 
"departure_time" : "16:23:34" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "16:26:20" , 
"departure_time" : "16:26:35" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "16:28:15" , 
"departure_time" : "16:28:17" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "16:31:02" , 
"departure_time" : "16:32:18" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "16:36:16" , 
"departure_time" : "16:37:47" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "16:40:31" , 
"departure_time" : "16:41:31" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "16:47:00" , 
"departure_time" : "16:47:41" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "16:49:41" , 
"departure_time" : "16:50:00" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "16:52:19" , 
"departure_time" : "16:52:56" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "16:54:37" , 
"departure_time" : "16:55:19" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "16:57:42" , 
"departure_time" : "16:58:49" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:06:07" , 
"departure_time" : "17:06:30" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:17:23" , 
"departure_time" : "17:17:23" , 
"distance_traveled" : 30.7472
} ], 
"1464" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "16:55:00" , 
"departure_time" : "16:56:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "16:59:00" , 
"departure_time" : "16:59:25" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "17:01:25" , 
"departure_time" : "17:03:01" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "17:05:36" , 
"departure_time" : "17:06:25" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "17:07:49" , 
"departure_time" : "17:09:10" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "17:11:21" , 
"departure_time" : "17:11:41" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "17:14:20" , 
"departure_time" : "17:15:34" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "17:18:14" , 
"departure_time" : "17:18:17" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "17:20:03" , 
"departure_time" : "17:20:49" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "17:24:46" , 
"departure_time" : "17:25:15" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "17:28:29" , 
"departure_time" : "17:28:32" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "17:35:03" , 
"departure_time" : "17:36:42" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "17:39:39" , 
"departure_time" : "17:40:06" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "17:41:27" , 
"departure_time" : "17:42:52" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "17:44:25" , 
"departure_time" : "17:45:39" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "17:47:14" , 
"departure_time" : "17:47:38" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:54:24" , 
"departure_time" : "17:54:49" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "18:06:25" , 
"departure_time" : "18:06:25" , 
"distance_traveled" : 30.7472
} ], 
"1465" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "16:55:00" , 
"departure_time" : "16:56:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "16:58:45" , 
"departure_time" : "16:59:20" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "17:01:35" , 
"departure_time" : "17:01:44" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "17:04:09" , 
"departure_time" : "17:04:32" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "17:07:23" , 
"departure_time" : "17:08:04" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "17:10:41" , 
"departure_time" : "17:11:50" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "17:15:09" , 
"departure_time" : "17:15:32" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "17:17:23" , 
"departure_time" : "17:18:56" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "17:21:33" , 
"departure_time" : "17:23:11" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "17:25:38" , 
"departure_time" : "17:26:43" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "17:29:05" , 
"departure_time" : "17:30:14" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "17:36:09" , 
"departure_time" : "17:37:11" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "17:39:02" , 
"departure_time" : "17:40:29" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "17:42:27" , 
"departure_time" : "17:43:20" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "17:43:53" , 
"departure_time" : "17:44:57" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "17:47:04" , 
"departure_time" : "17:48:23" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:55:19" , 
"departure_time" : "17:55:51" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "18:06:32" , 
"departure_time" : "18:06:32" , 
"distance_traveled" : 30.7472
} ], 
"1466" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "17:46:00" , 
"departure_time" : "17:47:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "17:48:29" , 
"departure_time" : "17:48:57" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "17:51:28" , 
"departure_time" : "17:52:57" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "17:56:29" , 
"departure_time" : "17:57:03" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "17:58:34" , 
"departure_time" : "17:59:00" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "18:02:26" , 
"departure_time" : "18:02:45" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "18:05:19" , 
"departure_time" : "18:05:32" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:09:13" , 
"departure_time" : "18:10:34" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "18:13:21" , 
"departure_time" : "18:14:39" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "18:17:18" , 
"departure_time" : "18:18:52" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "18:21:34" , 
"departure_time" : "18:21:39" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "18:27:05" , 
"departure_time" : "18:27:54" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "18:30:49" , 
"departure_time" : "18:32:27" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "18:34:38" , 
"departure_time" : "18:35:44" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "18:37:06" , 
"departure_time" : "18:38:42" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "18:40:36" , 
"departure_time" : "18:40:53" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:47:17" , 
"departure_time" : "18:47:28" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "18:59:11" , 
"departure_time" : "18:59:11" , 
"distance_traveled" : 30.7472
} ], 
"1467" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "17:46:00" , 
"departure_time" : "17:46:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "17:48:20" , 
"departure_time" : "17:49:54" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "17:52:34" , 
"departure_time" : "17:52:47" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "17:55:13" , 
"departure_time" : "17:56:20" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "17:59:07" , 
"departure_time" : "17:59:37" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "18:02:30" , 
"departure_time" : "18:02:35" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "18:05:05" , 
"departure_time" : "18:06:01" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:09:56" , 
"departure_time" : "18:10:15" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "18:12:19" , 
"departure_time" : "18:13:10" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "18:16:51" , 
"departure_time" : "18:17:48" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "18:20:57" , 
"departure_time" : "18:22:20" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "18:28:23" , 
"departure_time" : "18:28:42" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "18:30:19" , 
"departure_time" : "18:31:13" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "18:33:54" , 
"departure_time" : "18:34:02" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "18:36:08" , 
"departure_time" : "18:37:09" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "18:40:01" , 
"departure_time" : "18:40:41" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:47:40" , 
"departure_time" : "18:49:15" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "19:00:35" , 
"departure_time" : "19:00:35" , 
"distance_traveled" : 30.7472
} ], 
"1468" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "18:23:00" , 
"departure_time" : "18:25:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "18:27:11" , 
"departure_time" : "18:28:27" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "18:30:16" , 
"departure_time" : "18:31:17" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "18:33:01" , 
"departure_time" : "18:33:45" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "18:35:44" , 
"departure_time" : "18:36:13" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "18:39:29" , 
"departure_time" : "18:40:35" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "18:44:06" , 
"departure_time" : "18:45:13" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:47:07" , 
"departure_time" : "18:48:17" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "18:50:10" , 
"departure_time" : "18:51:27" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "18:54:17" , 
"departure_time" : "18:55:16" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "18:58:59" , 
"departure_time" : "19:00:07" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "19:04:08" , 
"departure_time" : "19:04:30" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "19:06:22" , 
"departure_time" : "19:06:30" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "19:09:08" , 
"departure_time" : "19:10:44" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "19:13:36" , 
"departure_time" : "19:14:32" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "19:14:56" , 
"departure_time" : "19:15:01" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:22:05" , 
"departure_time" : "19:22:24" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "19:34:19" , 
"departure_time" : "19:34:19" , 
"distance_traveled" : 30.7472
} ], 
"1469" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "18:23:00" , 
"departure_time" : "18:23:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "18:26:33" , 
"departure_time" : "18:26:44" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "18:29:11" , 
"departure_time" : "18:30:08" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "18:32:57" , 
"departure_time" : "18:33:25" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "18:35:28" , 
"departure_time" : "18:36:52" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "18:40:24" , 
"departure_time" : "18:41:56" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "18:44:32" , 
"departure_time" : "18:45:39" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:47:07" , 
"departure_time" : "18:48:27" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "18:50:20" , 
"departure_time" : "18:50:51" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "18:53:31" , 
"departure_time" : "18:54:45" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "18:59:14" , 
"departure_time" : "18:59:49" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "19:03:35" , 
"departure_time" : "19:03:53" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "19:06:18" , 
"departure_time" : "19:07:06" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "19:09:48" , 
"departure_time" : "19:10:29" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "19:12:41" , 
"departure_time" : "19:14:12" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "19:15:31" , 
"departure_time" : "19:15:47" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:22:16" , 
"departure_time" : "19:22:20" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "19:34:04" , 
"departure_time" : "19:34:04" , 
"distance_traveled" : 30.7472
} ], 
"1470" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "19:12:00" , 
"departure_time" : "19:12:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "19:14:41" , 
"departure_time" : "19:15:56" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "19:18:15" , 
"departure_time" : "19:19:35" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "19:22:20" , 
"departure_time" : "19:22:22" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "19:24:02" , 
"departure_time" : "19:25:21" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "19:28:19" , 
"departure_time" : "19:29:48" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "19:31:29" , 
"departure_time" : "19:33:01" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "19:35:32" , 
"departure_time" : "19:36:32" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "19:38:00" , 
"departure_time" : "19:38:36" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "19:41:36" , 
"departure_time" : "19:42:56" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "19:46:20" , 
"departure_time" : "19:47:53" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "19:52:33" , 
"departure_time" : "19:53:45" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "19:55:12" , 
"departure_time" : "19:56:38" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "19:58:26" , 
"departure_time" : "19:58:46" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "20:00:20" , 
"departure_time" : "20:01:46" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "20:03:26" , 
"departure_time" : "20:03:46" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "20:10:20" , 
"departure_time" : "20:10:51" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "20:22:31" , 
"departure_time" : "20:22:31" , 
"distance_traveled" : 30.7472
} ], 
"1471" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "19:12:00" , 
"departure_time" : "19:13:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "19:15:15" , 
"departure_time" : "19:16:19" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "19:18:04" , 
"departure_time" : "19:18:18" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "19:21:14" , 
"departure_time" : "19:22:10" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "19:24:56" , 
"departure_time" : "19:26:18" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "19:28:22" , 
"departure_time" : "19:29:58" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "19:31:36" , 
"departure_time" : "19:33:15" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "19:35:39" , 
"departure_time" : "19:35:44" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "19:37:05" , 
"departure_time" : "19:37:08" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "19:41:03" , 
"departure_time" : "19:42:37" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "19:46:34" , 
"departure_time" : "19:48:09" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "19:52:35" , 
"departure_time" : "19:53:09" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "19:54:34" , 
"departure_time" : "19:55:01" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "19:57:27" , 
"departure_time" : "19:57:28" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "20:00:01" , 
"departure_time" : "20:01:28" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "20:03:27" , 
"departure_time" : "20:03:31" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "20:10:04" , 
"departure_time" : "20:10:50" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "20:22:46" , 
"departure_time" : "20:22:46" , 
"distance_traveled" : 30.7472
} ], 
"1472" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "19:53:00" , 
"departure_time" : "19:54:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "19:56:31" , 
"departure_time" : "19:56:54" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "19:59:23" , 
"departure_time" : "20:00:10" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "20:03:47" , 
"departure_time" : "20:05:04" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "20:08:17" , 
"departure_time" : "20:08:43" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "20:10:26" , 
"departure_time" : "20:11:53" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "20:14:27" , 
"departure_time" : "20:15:49" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "20:17:22" , 
"departure_time" : "20:17:54" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "20:19:32" , 
"departure_time" : "20:19:45" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "20:23:13" , 
"departure_time" : "20:24:40" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "20:28:27" , 
"departure_time" : "20:29:30" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "20:35:03" , 
"departure_time" : "20:36:10" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "20:38:07" , 
"departure_time" : "20:38:27" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "20:40:20" , 
"departure_time" : "20:40:55" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "20:43:35" , 
"departure_time" : "20:44:32" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "20:46:57" , 
"departure_time" : "20:47:46" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "20:53:49" , 
"departure_time" : "20:54:45" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "21:05:56" , 
"departure_time" : "21:05:56" , 
"distance_traveled" : 30.7472
} ], 
"1473" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "19:53:00" , 
"departure_time" : "19:54:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "19:56:13" , 
"departure_time" : "19:57:06" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "19:59:53" , 
"departure_time" : "20:00:24" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "20:03:31" , 
"departure_time" : "20:05:11" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "20:08:40" , 
"departure_time" : "20:09:27" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "20:10:47" , 
"departure_time" : "20:12:21" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "20:14:34" , 
"departure_time" : "20:15:55" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "20:17:21" , 
"departure_time" : "20:18:35" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "20:20:14" , 
"departure_time" : "20:20:34" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "20:23:20" , 
"departure_time" : "20:24:49" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "20:28:29" , 
"departure_time" : "20:29:41" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "20:35:12" , 
"departure_time" : "20:35:40" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "20:37:28" , 
"departure_time" : "20:38:45" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "20:41:17" , 
"departure_time" : "20:41:49" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "20:43:32" , 
"departure_time" : "20:44:19" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "20:46:47" , 
"departure_time" : "20:47:02" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "20:53:15" , 
"departure_time" : "20:54:07" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "21:05:52" , 
"departure_time" : "21:05:52" , 
"distance_traveled" : 30.7472
} ], 
"1474" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "20:50:00" , 
"departure_time" : "20:52:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "20:53:23" , 
"departure_time" : "20:54:13" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "20:55:50" , 
"departure_time" : "20:56:30" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "20:59:40" , 
"departure_time" : "21:01:11" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "21:03:31" , 
"departure_time" : "21:04:06" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "21:05:35" , 
"departure_time" : "21:07:13" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "21:09:38" , 
"departure_time" : "21:11:00" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "21:13:22" , 
"departure_time" : "21:13:50" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "21:15:28" , 
"departure_time" : "21:15:40" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "21:19:12" , 
"departure_time" : "21:20:09" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "21:23:57" , 
"departure_time" : "21:24:26" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "21:28:29" , 
"departure_time" : "21:28:37" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "21:31:08" , 
"departure_time" : "21:32:26" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "21:35:18" , 
"departure_time" : "21:35:40" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "21:37:22" , 
"departure_time" : "21:37:51" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "21:39:29" , 
"departure_time" : "21:40:05" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "21:47:36" , 
"departure_time" : "21:47:57" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "21:59:21" , 
"departure_time" : "21:59:21" , 
"distance_traveled" : 30.7472
} ], 
"1475" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "20:50:00" , 
"departure_time" : "20:51:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "20:52:43" , 
"departure_time" : "20:53:54" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "20:56:11" , 
"departure_time" : "20:56:54" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "20:59:43" , 
"departure_time" : "20:59:48" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "21:02:05" , 
"departure_time" : "21:03:40" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "21:06:35" , 
"departure_time" : "21:07:19" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "21:08:44" , 
"departure_time" : "21:09:07" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "21:12:23" , 
"departure_time" : "21:13:23" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "21:16:00" , 
"departure_time" : "21:16:57" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "21:19:57" , 
"departure_time" : "21:20:24" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "21:23:27" , 
"departure_time" : "21:23:50" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "21:28:23" , 
"departure_time" : "21:29:01" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "21:31:38" , 
"departure_time" : "21:31:57" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "21:34:19" , 
"departure_time" : "21:35:25" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "21:38:06" , 
"departure_time" : "21:39:24" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "21:40:18" , 
"departure_time" : "21:40:31" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "21:47:13" , 
"departure_time" : "21:47:21" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "21:59:08" , 
"departure_time" : "21:59:08" , 
"distance_traveled" : 30.7472
} ], 
"1476" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "21:50:00" , 
"departure_time" : "21:50:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "21:52:10" , 
"departure_time" : "21:53:47" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "21:56:37" , 
"departure_time" : "21:57:16" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "21:59:39" , 
"departure_time" : "21:59:52" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "22:02:13" , 
"departure_time" : "22:03:30" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "22:06:17" , 
"departure_time" : "22:06:55" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "22:08:38" , 
"departure_time" : "22:09:46" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "22:13:08" , 
"departure_time" : "22:14:44" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "22:16:36" , 
"departure_time" : "22:17:09" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "22:19:33" , 
"departure_time" : "22:20:57" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "22:24:24" , 
"departure_time" : "22:26:03" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "22:29:39" , 
"departure_time" : "22:31:14" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "22:32:35" , 
"departure_time" : "22:33:53" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "22:35:18" , 
"departure_time" : "22:35:27" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "22:37:09" , 
"departure_time" : "22:37:10" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "22:39:01" , 
"departure_time" : "22:40:40" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "22:48:39" , 
"departure_time" : "22:48:43" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "22:59:04" , 
"departure_time" : "22:59:04" , 
"distance_traveled" : 30.7472
} ], 
"1477" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "21:50:00" , 
"departure_time" : "21:50:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "21:52:23" , 
"departure_time" : "21:53:42" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "21:56:19" , 
"departure_time" : "21:57:19" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "22:00:00" , 
"departure_time" : "22:00:32" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "22:02:32" , 
"departure_time" : "22:03:32" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "22:06:00" , 
"departure_time" : "22:06:20" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "22:08:20" , 
"departure_time" : "22:09:11" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "22:12:51" , 
"departure_time" : "22:13:03" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "22:15:12" , 
"departure_time" : "22:15:39" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "22:19:27" , 
"departure_time" : "22:20:53" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "22:24:26" , 
"departure_time" : "22:25:53" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "22:29:27" , 
"departure_time" : "22:29:39" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "22:31:12" , 
"departure_time" : "22:32:26" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "22:35:14" , 
"departure_time" : "22:35:38" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "22:37:24" , 
"departure_time" : "22:38:32" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "22:40:08" , 
"departure_time" : "22:41:30" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "22:48:22" , 
"departure_time" : "22:49:42" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "23:00:20" , 
"departure_time" : "23:00:20" , 
"distance_traveled" : 30.7472
} ], 
"1478" :  [ 
{ 
"stop_id" : 131,
"arrival_time" : "17:38:00" , 
"departure_time" : "17:39:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 51,
"arrival_time" : "17:42:15" , 
"departure_time" : "17:42:24" , 
"distance_traveled" : 1.4136
}, 
{ 
"stop_id" : 126,
"arrival_time" : "17:46:09" , 
"departure_time" : "17:47:36" , 
"distance_traveled" : 2.954
}, 
{ 
"stop_id" : 25,
"arrival_time" : "17:50:27" , 
"departure_time" : "17:51:07" , 
"distance_traveled" : 4.2049
}, 
{ 
"stop_id" : 121,
"arrival_time" : "17:54:40" , 
"departure_time" : "17:55:11" , 
"distance_traveled" : 6.9326
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "17:59:31" , 
"departure_time" : "18:01:08" , 
"distance_traveled" : 9.2331
}, 
{ 
"stop_id" : 134,
"arrival_time" : "18:05:37" , 
"departure_time" : "18:06:49" , 
"distance_traveled" : 11.1705
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:13:12" , 
"departure_time" : "18:13:58" , 
"distance_traveled" : 16.2886
}, 
{ 
"stop_id" : 63,
"arrival_time" : "18:24:46" , 
"departure_time" : "18:24:46" , 
"distance_traveled" : 19.8485
} ], 
"1479" :  [ 
{ 
"stop_id" : 131,
"arrival_time" : "17:38:00" , 
"departure_time" : "17:39:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 51,
"arrival_time" : "17:42:34" , 
"departure_time" : "17:44:10" , 
"distance_traveled" : 1.4136
}, 
{ 
"stop_id" : 126,
"arrival_time" : "17:47:36" , 
"departure_time" : "17:48:28" , 
"distance_traveled" : 2.954
}, 
{ 
"stop_id" : 25,
"arrival_time" : "17:49:52" , 
"departure_time" : "17:50:39" , 
"distance_traveled" : 4.2049
}, 
{ 
"stop_id" : 121,
"arrival_time" : "17:54:47" , 
"departure_time" : "17:55:18" , 
"distance_traveled" : 6.9326
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "17:59:31" , 
"departure_time" : "17:59:46" , 
"distance_traveled" : 9.2331
}, 
{ 
"stop_id" : 134,
"arrival_time" : "18:04:15" , 
"departure_time" : "18:05:44" , 
"distance_traveled" : 11.1705
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:13:29" , 
"departure_time" : "18:15:08" , 
"distance_traveled" : 16.2886
}, 
{ 
"stop_id" : 63,
"arrival_time" : "18:25:39" , 
"departure_time" : "18:25:39" , 
"distance_traveled" : 19.8485
} ], 
"1480" :  [ 
{ 
"stop_id" : 131,
"arrival_time" : "18:52:00" , 
"departure_time" : "18:54:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 51,
"arrival_time" : "18:55:36" , 
"departure_time" : "18:56:22" , 
"distance_traveled" : 1.4136
}, 
{ 
"stop_id" : 126,
"arrival_time" : "18:59:46" , 
"departure_time" : "19:00:27" , 
"distance_traveled" : 2.954
}, 
{ 
"stop_id" : 25,
"arrival_time" : "19:02:41" , 
"departure_time" : "19:03:20" , 
"distance_traveled" : 4.2049
}, 
{ 
"stop_id" : 121,
"arrival_time" : "19:06:39" , 
"departure_time" : "19:07:40" , 
"distance_traveled" : 6.9326
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "19:12:01" , 
"departure_time" : "19:13:00" , 
"distance_traveled" : 9.2331
}, 
{ 
"stop_id" : 134,
"arrival_time" : "19:16:59" , 
"departure_time" : "19:18:34" , 
"distance_traveled" : 11.1705
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:26:35" , 
"departure_time" : "19:27:21" , 
"distance_traveled" : 16.2886
}, 
{ 
"stop_id" : 63,
"arrival_time" : "19:37:46" , 
"departure_time" : "19:37:46" , 
"distance_traveled" : 19.8485
} ], 
"1481" :  [ 
{ 
"stop_id" : 131,
"arrival_time" : "18:52:00" , 
"departure_time" : "18:53:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 51,
"arrival_time" : "18:55:56" , 
"departure_time" : "18:57:14" , 
"distance_traveled" : 1.4136
}, 
{ 
"stop_id" : 126,
"arrival_time" : "19:00:18" , 
"departure_time" : "19:01:55" , 
"distance_traveled" : 2.954
}, 
{ 
"stop_id" : 25,
"arrival_time" : "19:03:37" , 
"departure_time" : "19:04:37" , 
"distance_traveled" : 4.2049
}, 
{ 
"stop_id" : 121,
"arrival_time" : "19:07:00" , 
"departure_time" : "19:08:20" , 
"distance_traveled" : 6.9326
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "19:12:20" , 
"departure_time" : "19:12:50" , 
"distance_traveled" : 9.2331
}, 
{ 
"stop_id" : 134,
"arrival_time" : "19:16:30" , 
"departure_time" : "19:17:48" , 
"distance_traveled" : 11.1705
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:26:18" , 
"departure_time" : "19:27:47" , 
"distance_traveled" : 16.2886
}, 
{ 
"stop_id" : 63,
"arrival_time" : "19:38:29" , 
"departure_time" : "19:38:29" , 
"distance_traveled" : 19.8485
} ], 
"1482" :  [ 
{ 
"stop_id" : 131,
"arrival_time" : "20:34:00" , 
"departure_time" : "20:36:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 51,
"arrival_time" : "20:37:44" , 
"departure_time" : "20:38:28" , 
"distance_traveled" : 1.4136
}, 
{ 
"stop_id" : 126,
"arrival_time" : "20:41:44" , 
"departure_time" : "20:41:50" , 
"distance_traveled" : 2.954
}, 
{ 
"stop_id" : 25,
"arrival_time" : "20:44:06" , 
"departure_time" : "20:44:38" , 
"distance_traveled" : 4.2049
}, 
{ 
"stop_id" : 121,
"arrival_time" : "20:49:32" , 
"departure_time" : "20:50:06" , 
"distance_traveled" : 6.9326
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "20:54:34" , 
"departure_time" : "20:55:18" , 
"distance_traveled" : 9.2331
}, 
{ 
"stop_id" : 134,
"arrival_time" : "20:59:44" , 
"departure_time" : "21:00:37" , 
"distance_traveled" : 11.1705
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "21:07:53" , 
"departure_time" : "21:08:23" , 
"distance_traveled" : 16.2886
}, 
{ 
"stop_id" : 63,
"arrival_time" : "21:19:30" , 
"departure_time" : "21:19:30" , 
"distance_traveled" : 19.8485
} ], 
"1483" :  [ 
{ 
"stop_id" : 131,
"arrival_time" : "20:34:00" , 
"departure_time" : "20:36:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 51,
"arrival_time" : "20:38:30" , 
"departure_time" : "20:39:43" , 
"distance_traveled" : 1.4136
}, 
{ 
"stop_id" : 126,
"arrival_time" : "20:42:13" , 
"departure_time" : "20:43:02" , 
"distance_traveled" : 2.954
}, 
{ 
"stop_id" : 25,
"arrival_time" : "20:44:49" , 
"departure_time" : "20:45:28" , 
"distance_traveled" : 4.2049
}, 
{ 
"stop_id" : 121,
"arrival_time" : "20:49:39" , 
"departure_time" : "20:50:27" , 
"distance_traveled" : 6.9326
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "20:54:48" , 
"departure_time" : "20:55:07" , 
"distance_traveled" : 9.2331
}, 
{ 
"stop_id" : 134,
"arrival_time" : "20:59:19" , 
"departure_time" : "21:00:02" , 
"distance_traveled" : 11.1705
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "21:07:43" , 
"departure_time" : "21:08:15" , 
"distance_traveled" : 16.2886
}, 
{ 
"stop_id" : 63,
"arrival_time" : "21:19:32" , 
"departure_time" : "21:19:32" , 
"distance_traveled" : 19.8485
} ], 
"1484" :  [ 
{ 
"stop_id" : 131,
"arrival_time" : "21:34:00" , 
"departure_time" : "21:34:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 51,
"arrival_time" : "21:38:17" , 
"departure_time" : "21:38:40" , 
"distance_traveled" : 1.4136
}, 
{ 
"stop_id" : 126,
"arrival_time" : "21:41:23" , 
"departure_time" : "21:41:28" , 
"distance_traveled" : 2.954
}, 
{ 
"stop_id" : 25,
"arrival_time" : "21:44:05" , 
"departure_time" : "21:45:21" , 
"distance_traveled" : 4.2049
}, 
{ 
"stop_id" : 121,
"arrival_time" : "21:50:16" , 
"departure_time" : "21:51:37" , 
"distance_traveled" : 6.9326
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "21:55:21" , 
"departure_time" : "21:55:22" , 
"distance_traveled" : 9.2331
}, 
{ 
"stop_id" : 134,
"arrival_time" : "21:59:01" , 
"departure_time" : "22:00:05" , 
"distance_traveled" : 11.1705
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "22:08:04" , 
"departure_time" : "22:08:17" , 
"distance_traveled" : 16.2886
}, 
{ 
"stop_id" : 63,
"arrival_time" : "22:19:13" , 
"departure_time" : "22:19:13" , 
"distance_traveled" : 19.8485
} ], 
"1485" :  [ 
{ 
"stop_id" : 131,
"arrival_time" : "21:34:00" , 
"departure_time" : "21:34:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 51,
"arrival_time" : "21:38:26" , 
"departure_time" : "21:38:48" , 
"distance_traveled" : 1.4136
}, 
{ 
"stop_id" : 126,
"arrival_time" : "21:41:22" , 
"departure_time" : "21:41:46" , 
"distance_traveled" : 2.954
}, 
{ 
"stop_id" : 25,
"arrival_time" : "21:44:24" , 
"departure_time" : "21:45:46" , 
"distance_traveled" : 4.2049
}, 
{ 
"stop_id" : 121,
"arrival_time" : "21:50:22" , 
"departure_time" : "21:52:02" , 
"distance_traveled" : 6.9326
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "21:55:40" , 
"departure_time" : "21:56:26" , 
"distance_traveled" : 9.2331
}, 
{ 
"stop_id" : 134,
"arrival_time" : "21:59:46" , 
"departure_time" : "22:00:27" , 
"distance_traveled" : 11.1705
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "22:07:41" , 
"departure_time" : "22:08:44" , 
"distance_traveled" : 16.2886
}, 
{ 
"stop_id" : 63,
"arrival_time" : "22:20:03" , 
"departure_time" : "22:20:03" , 
"distance_traveled" : 19.8485
} ], 
"1486" :  [ 
{ 
"stop_id" : 131,
"arrival_time" : "22:30:00" , 
"departure_time" : "22:31:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 51,
"arrival_time" : "22:34:11" , 
"departure_time" : "22:35:15" , 
"distance_traveled" : 1.4136
}, 
{ 
"stop_id" : 126,
"arrival_time" : "22:38:04" , 
"departure_time" : "22:38:12" , 
"distance_traveled" : 2.954
}, 
{ 
"stop_id" : 25,
"arrival_time" : "22:40:08" , 
"departure_time" : "22:40:54" , 
"distance_traveled" : 4.2049
}, 
{ 
"stop_id" : 121,
"arrival_time" : "22:45:46" , 
"departure_time" : "22:46:53" , 
"distance_traveled" : 6.9326
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "22:51:07" , 
"departure_time" : "22:51:55" , 
"distance_traveled" : 9.2331
}, 
{ 
"stop_id" : 134,
"arrival_time" : "22:55:48" , 
"departure_time" : "22:56:21" , 
"distance_traveled" : 11.1705
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "23:03:33" , 
"departure_time" : "23:04:42" , 
"distance_traveled" : 16.2886
}, 
{ 
"stop_id" : 63,
"arrival_time" : "23:16:09" , 
"departure_time" : "23:16:09" , 
"distance_traveled" : 19.8485
} ], 
"1487" :  [ 
{ 
"stop_id" : 131,
"arrival_time" : "22:30:00" , 
"departure_time" : "22:32:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 51,
"arrival_time" : "22:35:09" , 
"departure_time" : "22:36:25" , 
"distance_traveled" : 1.4136
}, 
{ 
"stop_id" : 126,
"arrival_time" : "22:38:16" , 
"departure_time" : "22:38:49" , 
"distance_traveled" : 2.954
}, 
{ 
"stop_id" : 25,
"arrival_time" : "22:40:33" , 
"departure_time" : "22:40:52" , 
"distance_traveled" : 4.2049
}, 
{ 
"stop_id" : 121,
"arrival_time" : "22:45:19" , 
"departure_time" : "22:45:47" , 
"distance_traveled" : 6.9326
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "22:50:28" , 
"departure_time" : "22:51:17" , 
"distance_traveled" : 9.2331
}, 
{ 
"stop_id" : 134,
"arrival_time" : "22:55:49" , 
"departure_time" : "22:56:22" , 
"distance_traveled" : 11.1705
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "23:03:33" , 
"departure_time" : "23:04:42" , 
"distance_traveled" : 16.2886
}, 
{ 
"stop_id" : 63,
"arrival_time" : "23:16:09" , 
"departure_time" : "23:16:09" , 
"distance_traveled" : 19.8485
} ], 
"1488" :  [ 
{ 
"stop_id" : 131,
"arrival_time" : "06:11:00" , 
"departure_time" : "06:13:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 51,
"arrival_time" : "06:15:58" , 
"departure_time" : "06:16:15" , 
"distance_traveled" : 1.4136
}, 
{ 
"stop_id" : 126,
"arrival_time" : "06:19:17" , 
"departure_time" : "06:20:12" , 
"distance_traveled" : 2.954
}, 
{ 
"stop_id" : 25,
"arrival_time" : "06:22:55" , 
"departure_time" : "06:23:57" , 
"distance_traveled" : 4.2049
}, 
{ 
"stop_id" : 121,
"arrival_time" : "06:28:02" , 
"departure_time" : "06:28:39" , 
"distance_traveled" : 6.9326
}, 
{ 
"stop_id" : 46,
"arrival_time" : "06:30:37" , 
"departure_time" : "06:30:57" , 
"distance_traveled" : 8.2112
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "06:34:20" , 
"departure_time" : "06:35:37" , 
"distance_traveled" : 9.2331
}, 
{ 
"stop_id" : 134,
"arrival_time" : "06:39:17" , 
"departure_time" : "06:40:38" , 
"distance_traveled" : 11.1705
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "06:47:21" , 
"departure_time" : "06:48:23" , 
"distance_traveled" : 16.2886
}, 
{ 
"stop_id" : 63,
"arrival_time" : "06:59:02" , 
"departure_time" : "06:59:02" , 
"distance_traveled" : 19.8485
} ], 
"1489" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "06:35:00" , 
"departure_time" : "06:36:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "06:38:54" , 
"departure_time" : "06:40:14" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "06:42:20" , 
"departure_time" : "06:42:27" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "06:45:07" , 
"departure_time" : "06:45:53" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "06:49:46" , 
"departure_time" : "06:50:35" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "06:52:49" , 
"departure_time" : "06:53:35" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "06:57:46" , 
"departure_time" : "06:58:12" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "07:00:26" , 
"departure_time" : "07:01:48" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "07:05:22" , 
"departure_time" : "07:06:09" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "07:08:47" , 
"departure_time" : "07:08:58" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:16:11" , 
"departure_time" : "07:16:39" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:28:28" , 
"departure_time" : "07:28:28" , 
"distance_traveled" : 22.2972
} ], 
"1490" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "05:26:00" , 
"departure_time" : "05:27:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "05:30:31" , 
"departure_time" : "05:30:50" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "05:32:19" , 
"departure_time" : "05:32:52" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "05:35:33" , 
"departure_time" : "05:37:02" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "05:39:29" , 
"departure_time" : "05:40:06" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "05:41:37" , 
"departure_time" : "05:41:54" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "05:45:17" , 
"departure_time" : "05:46:28" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "05:49:11" , 
"departure_time" : "05:50:23" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "05:52:12" , 
"departure_time" : "05:53:18" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "05:56:06" , 
"departure_time" : "05:56:13" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "06:00:07" , 
"departure_time" : "06:01:25" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "06:07:18" , 
"departure_time" : "06:07:22" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "06:09:04" , 
"departure_time" : "06:10:18" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "06:13:14" , 
"departure_time" : "06:14:27" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "06:16:13" , 
"departure_time" : "06:17:48" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "06:18:35" , 
"departure_time" : "06:19:37" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "06:26:02" , 
"departure_time" : "06:26:49" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "06:37:47" , 
"departure_time" : "06:37:47" , 
"distance_traveled" : 30.7472
} ], 
"1491" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "06:43:00" , 
"departure_time" : "06:43:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "06:46:07" , 
"departure_time" : "06:47:09" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "06:50:02" , 
"departure_time" : "06:51:28" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "06:53:26" , 
"departure_time" : "06:54:28" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "06:56:02" , 
"departure_time" : "06:57:13" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "06:59:11" , 
"departure_time" : "06:59:38" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "07:02:27" , 
"departure_time" : "07:02:47" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "07:05:20" , 
"departure_time" : "07:05:43" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "07:08:23" , 
"departure_time" : "07:09:30" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "07:13:07" , 
"departure_time" : "07:13:16" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "07:17:09" , 
"departure_time" : "07:17:26" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "07:23:17" , 
"departure_time" : "07:24:13" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "07:26:56" , 
"departure_time" : "07:27:04" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "07:29:08" , 
"departure_time" : "07:29:39" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "07:32:31" , 
"departure_time" : "07:34:11" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "07:35:40" , 
"departure_time" : "07:36:04" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:42:24" , 
"departure_time" : "07:42:58" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:54:34" , 
"departure_time" : "07:54:34" , 
"distance_traveled" : 30.7472
} ], 
"1492" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "24:08:00" , 
"departure_time" : "24:09:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "24:12:23" , 
"departure_time" : "24:13:02" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "24:14:39" , 
"departure_time" : "24:14:50" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "24:17:11" , 
"departure_time" : "24:18:47" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "24:21:36" , 
"departure_time" : "24:22:57" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "24:24:21" , 
"departure_time" : "24:25:37" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "24:28:16" , 
"departure_time" : "24:29:46" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "24:31:30" , 
"departure_time" : "24:31:57" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 51,
"arrival_time" : "24:34:27" , 
"departure_time" : "24:34:59" , 
"distance_traveled" : 11.1142
}, 
{ 
"stop_id" : 126,
"arrival_time" : "24:37:32" , 
"departure_time" : "24:39:10" , 
"distance_traveled" : 12.6545
}, 
{ 
"stop_id" : 25,
"arrival_time" : "24:41:38" , 
"departure_time" : "24:43:09" , 
"distance_traveled" : 13.9055
}, 
{ 
"stop_id" : 121,
"arrival_time" : "24:46:31" , 
"departure_time" : "24:46:57" , 
"distance_traveled" : 16.6331
}, 
{ 
"stop_id" : 46,
"arrival_time" : "24:48:26" , 
"departure_time" : "24:49:27" , 
"distance_traveled" : 17.9117
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "24:52:01" , 
"departure_time" : "24:52:37" , 
"distance_traveled" : 18.9337
}, 
{ 
"stop_id" : 134,
"arrival_time" : "24:56:36" , 
"departure_time" : "24:57:19" , 
"distance_traveled" : 20.871
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "25:05:43" , 
"departure_time" : "25:05:49" , 
"distance_traveled" : 25.9892
}, 
{ 
"stop_id" : 63,
"arrival_time" : "25:21:06" , 
"departure_time" : "25:21:06" , 
"distance_traveled" : 29.5491
} ], 
"1493" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "06:35:00" , 
"departure_time" : "06:35:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "06:38:28" , 
"departure_time" : "06:39:14" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "06:41:46" , 
"departure_time" : "06:42:56" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "06:46:10" , 
"departure_time" : "06:47:00" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "06:49:50" , 
"departure_time" : "06:49:56" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "06:52:06" , 
"departure_time" : "06:53:21" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "06:58:15" , 
"departure_time" : "06:59:31" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "07:01:16" , 
"departure_time" : "07:02:02" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "07:04:46" , 
"departure_time" : "07:05:54" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "07:09:08" , 
"departure_time" : "07:10:17" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:17:09" , 
"departure_time" : "07:17:31" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:28:22" , 
"departure_time" : "07:28:22" , 
"distance_traveled" : 22.2972
} ], 
"1494" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "07:35:00" , 
"departure_time" : "07:36:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "07:39:17" , 
"departure_time" : "07:40:28" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "07:42:11" , 
"departure_time" : "07:43:18" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "07:46:07" , 
"departure_time" : "07:46:41" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "07:49:34" , 
"departure_time" : "07:50:42" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "07:53:08" , 
"departure_time" : "07:54:07" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "07:57:59" , 
"departure_time" : "07:58:37" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "08:00:38" , 
"departure_time" : "08:01:20" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "08:04:42" , 
"departure_time" : "08:04:44" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "08:08:02" , 
"departure_time" : "08:09:34" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:17:32" , 
"departure_time" : "08:18:01" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:28:29" , 
"departure_time" : "08:28:29" , 
"distance_traveled" : 22.2972
} ], 
"1495" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "08:35:00" , 
"departure_time" : "08:36:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "08:38:33" , 
"departure_time" : "08:39:31" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "08:41:58" , 
"departure_time" : "08:42:32" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "08:45:34" , 
"departure_time" : "08:46:16" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "08:49:42" , 
"departure_time" : "08:51:22" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "08:53:40" , 
"departure_time" : "08:54:57" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "08:58:17" , 
"departure_time" : "08:59:51" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "09:01:34" , 
"departure_time" : "09:02:41" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "09:05:07" , 
"departure_time" : "09:05:11" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "09:08:04" , 
"departure_time" : "09:09:36" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:17:32" , 
"departure_time" : "09:17:33" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:28:01" , 
"departure_time" : "09:28:01" , 
"distance_traveled" : 22.2972
} ], 
"1496" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "09:35:00" , 
"departure_time" : "09:36:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "09:39:33" , 
"departure_time" : "09:40:59" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "09:42:26" , 
"departure_time" : "09:44:05" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "09:46:39" , 
"departure_time" : "09:47:47" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "09:50:08" , 
"departure_time" : "09:51:01" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "09:52:53" , 
"departure_time" : "09:53:36" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "09:57:43" , 
"departure_time" : "09:58:05" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "10:00:22" , 
"departure_time" : "10:01:50" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "10:05:28" , 
"departure_time" : "10:06:42" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "10:09:14" , 
"departure_time" : "10:10:06" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "10:16:52" , 
"departure_time" : "10:17:53" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "10:29:01" , 
"departure_time" : "10:29:01" , 
"distance_traveled" : 22.2972
} ], 
"1497" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "11:35:00" , 
"departure_time" : "11:37:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "11:39:33" , 
"departure_time" : "11:41:13" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "11:42:40" , 
"departure_time" : "11:43:04" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "11:45:24" , 
"departure_time" : "11:45:42" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "11:49:18" , 
"departure_time" : "11:50:03" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "11:52:45" , 
"departure_time" : "11:52:57" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "11:57:12" , 
"departure_time" : "11:57:16" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "12:00:04" , 
"departure_time" : "12:01:22" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "12:05:18" , 
"departure_time" : "12:05:25" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "12:08:07" , 
"departure_time" : "12:08:30" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "12:16:23" , 
"departure_time" : "12:17:29" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "12:29:06" , 
"departure_time" : "12:29:06" , 
"distance_traveled" : 22.2972
} ], 
"1498" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "13:35:00" , 
"departure_time" : "13:37:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "13:39:02" , 
"departure_time" : "13:39:37" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "13:41:35" , 
"departure_time" : "13:42:12" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "13:45:37" , 
"departure_time" : "13:46:02" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "13:49:25" , 
"departure_time" : "13:51:02" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "13:53:37" , 
"departure_time" : "13:55:09" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "13:58:32" , 
"departure_time" : "13:59:27" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "14:00:55" , 
"departure_time" : "14:00:59" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "14:04:04" , 
"departure_time" : "14:04:18" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "14:08:14" , 
"departure_time" : "14:08:36" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "14:16:22" , 
"departure_time" : "14:17:49" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "14:29:27" , 
"departure_time" : "14:29:27" , 
"distance_traveled" : 22.2972
} ], 
"1499" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "14:35:00" , 
"departure_time" : "14:37:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "14:39:02" , 
"departure_time" : "14:40:41" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "14:42:39" , 
"departure_time" : "14:43:13" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "14:45:34" , 
"departure_time" : "14:45:50" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "14:49:16" , 
"departure_time" : "14:50:04" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "14:52:48" , 
"departure_time" : "14:54:18" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "14:58:30" , 
"departure_time" : "15:00:01" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "15:01:31" , 
"departure_time" : "15:03:10" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "15:05:39" , 
"departure_time" : "15:07:03" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "15:09:24" , 
"departure_time" : "15:10:59" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "15:17:35" , 
"departure_time" : "15:17:39" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "15:28:04" , 
"departure_time" : "15:28:04" , 
"distance_traveled" : 22.2972
} ], 
"1500" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "15:35:00" , 
"departure_time" : "15:35:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "15:38:26" , 
"departure_time" : "15:39:32" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "15:42:06" , 
"departure_time" : "15:42:45" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "15:45:39" , 
"departure_time" : "15:45:51" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "15:49:12" , 
"departure_time" : "15:50:19" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "15:53:07" , 
"departure_time" : "15:54:29" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "15:58:22" , 
"departure_time" : "15:59:05" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "16:00:43" , 
"departure_time" : "16:02:10" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "16:05:27" , 
"departure_time" : "16:05:34" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "16:08:07" , 
"departure_time" : "16:09:17" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:17:10" , 
"departure_time" : "16:18:08" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "16:28:58" , 
"departure_time" : "16:28:58" , 
"distance_traveled" : 22.2972
} ], 
"1501" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "16:35:00" , 
"departure_time" : "16:36:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "16:38:50" , 
"departure_time" : "16:40:23" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "16:42:33" , 
"departure_time" : "16:43:30" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "16:45:57" , 
"departure_time" : "16:47:02" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "16:50:05" , 
"departure_time" : "16:51:44" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "16:53:39" , 
"departure_time" : "16:54:56" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "16:58:17" , 
"departure_time" : "16:59:20" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "17:01:03" , 
"departure_time" : "17:01:35" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "17:04:32" , 
"departure_time" : "17:04:42" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "17:08:10" , 
"departure_time" : "17:08:40" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:16:30" , 
"departure_time" : "17:16:46" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:28:16" , 
"departure_time" : "17:28:16" , 
"distance_traveled" : 22.2972
} ], 
"1502" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "17:34:00" , 
"departure_time" : "17:34:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "17:38:32" , 
"departure_time" : "17:39:31" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "17:41:59" , 
"departure_time" : "17:43:24" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "17:46:25" , 
"departure_time" : "17:47:18" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "17:49:53" , 
"departure_time" : "17:51:29" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "17:53:36" , 
"departure_time" : "17:54:24" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "17:57:48" , 
"departure_time" : "17:58:48" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "18:01:00" , 
"departure_time" : "18:02:02" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "18:05:02" , 
"departure_time" : "18:05:05" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "18:08:03" , 
"departure_time" : "18:09:14" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:17:11" , 
"departure_time" : "18:18:21" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "18:29:10" , 
"departure_time" : "18:29:10" , 
"distance_traveled" : 22.2972
} ], 
"1503" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "18:34:00" , 
"departure_time" : "18:35:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "18:38:43" , 
"departure_time" : "18:39:35" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:41:52" , 
"departure_time" : "18:42:16" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "18:45:24" , 
"departure_time" : "18:45:46" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "18:49:22" , 
"departure_time" : "18:49:52" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "18:52:30" , 
"departure_time" : "18:53:11" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "18:57:41" , 
"departure_time" : "18:58:24" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "19:00:43" , 
"departure_time" : "19:02:23" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "19:05:40" , 
"departure_time" : "19:06:59" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "19:09:19" , 
"departure_time" : "19:10:33" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:17:14" , 
"departure_time" : "19:18:13" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "19:28:59" , 
"departure_time" : "19:28:59" , 
"distance_traveled" : 22.2972
} ], 
"1504" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "19:34:00" , 
"departure_time" : "19:36:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "19:39:11" , 
"departure_time" : "19:40:42" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "19:42:31" , 
"departure_time" : "19:44:05" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "19:46:34" , 
"departure_time" : "19:47:06" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "19:49:32" , 
"departure_time" : "19:50:37" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "19:53:05" , 
"departure_time" : "19:54:45" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "19:58:40" , 
"departure_time" : "19:59:10" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "20:00:30" , 
"departure_time" : "20:01:34" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "20:05:04" , 
"departure_time" : "20:06:35" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "20:09:31" , 
"departure_time" : "20:11:07" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "20:17:36" , 
"departure_time" : "20:19:03" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "20:29:27" , 
"departure_time" : "20:29:27" , 
"distance_traveled" : 22.2972
} ], 
"1505" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "20:35:00" , 
"departure_time" : "20:37:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "20:38:39" , 
"departure_time" : "20:38:53" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "20:41:14" , 
"departure_time" : "20:42:18" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "20:46:04" , 
"departure_time" : "20:47:38" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "20:50:34" , 
"departure_time" : "20:50:57" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "20:52:23" , 
"departure_time" : "20:52:54" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "20:57:31" , 
"departure_time" : "20:57:35" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "21:00:04" , 
"departure_time" : "21:01:31" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "21:05:27" , 
"departure_time" : "21:05:58" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "21:08:31" , 
"departure_time" : "21:08:42" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "21:16:11" , 
"departure_time" : "21:16:31" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "21:28:20" , 
"departure_time" : "21:28:20" , 
"distance_traveled" : 22.2972
} ], 
"1506" :  [ 
{ 
"stop_id" : 151,
"arrival_time" : "21:35:00" , 
"departure_time" : "21:35:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 64,
"arrival_time" : "21:38:20" , 
"departure_time" : "21:39:41" , 
"distance_traveled" : 1.2239
}, 
{ 
"stop_id" : 131,
"arrival_time" : "21:42:21" , 
"departure_time" : "21:42:22" , 
"distance_traveled" : 2.4513
}, 
{ 
"stop_id" : 51,
"arrival_time" : "21:45:01" , 
"departure_time" : "21:45:32" , 
"distance_traveled" : 3.8623
}, 
{ 
"stop_id" : 126,
"arrival_time" : "21:49:31" , 
"departure_time" : "21:49:52" , 
"distance_traveled" : 5.4027
}, 
{ 
"stop_id" : 25,
"arrival_time" : "21:52:21" , 
"departure_time" : "21:52:54" , 
"distance_traveled" : 6.6536
}, 
{ 
"stop_id" : 121,
"arrival_time" : "21:57:33" , 
"departure_time" : "21:58:27" , 
"distance_traveled" : 9.3812
}, 
{ 
"stop_id" : 46,
"arrival_time" : "22:00:54" , 
"departure_time" : "22:01:26" , 
"distance_traveled" : 10.6598
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "22:04:32" , 
"departure_time" : "22:04:37" , 
"distance_traveled" : 11.6818
}, 
{ 
"stop_id" : 134,
"arrival_time" : "22:08:05" , 
"departure_time" : "22:08:38" , 
"distance_traveled" : 13.6191
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "22:16:33" , 
"departure_time" : "22:16:59" , 
"distance_traveled" : 18.7373
}, 
{ 
"stop_id" : 63,
"arrival_time" : "22:28:26" , 
"departure_time" : "22:28:26" , 
"distance_traveled" : 22.2972
} ], 
"1507" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "22:18:00" , 
"departure_time" : "22:19:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "22:22:30" , 
"departure_time" : "22:23:43" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "22:25:13" , 
"departure_time" : "22:26:11" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "22:27:58" , 
"departure_time" : "22:28:38" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "22:31:40" , 
"departure_time" : "22:33:08" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "22:36:28" , 
"departure_time" : "22:37:23" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "22:38:55" , 
"departure_time" : "22:40:11" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "22:42:16" , 
"departure_time" : "22:42:17" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 51,
"arrival_time" : "22:45:01" , 
"departure_time" : "22:45:54" , 
"distance_traveled" : 11.1142
}, 
{ 
"stop_id" : 126,
"arrival_time" : "22:49:53" , 
"departure_time" : "22:50:36" , 
"distance_traveled" : 12.6545
}, 
{ 
"stop_id" : 25,
"arrival_time" : "22:52:43" , 
"departure_time" : "22:53:34" , 
"distance_traveled" : 13.9055
}, 
{ 
"stop_id" : 121,
"arrival_time" : "22:57:51" , 
"departure_time" : "22:59:04" , 
"distance_traveled" : 16.6331
}, 
{ 
"stop_id" : 46,
"arrival_time" : "23:01:13" , 
"departure_time" : "23:02:14" , 
"distance_traveled" : 17.9117
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "23:05:01" , 
"departure_time" : "23:05:31" , 
"distance_traveled" : 18.9337
}, 
{ 
"stop_id" : 134,
"arrival_time" : "23:08:30" , 
"departure_time" : "23:10:09" , 
"distance_traveled" : 20.871
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "23:17:39" , 
"departure_time" : "23:18:38" , 
"distance_traveled" : 25.9892
}, 
{ 
"stop_id" : 63,
"arrival_time" : "23:28:59" , 
"departure_time" : "23:28:59" , 
"distance_traveled" : 29.5491
} ], 
"1508" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "07:08:00" , 
"departure_time" : "07:09:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "07:11:06" , 
"departure_time" : "07:12:20" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "07:15:14" , 
"departure_time" : "07:15:46" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "07:17:32" , 
"departure_time" : "07:18:22" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "07:20:50" , 
"departure_time" : "07:22:09" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "07:24:19" , 
"departure_time" : "07:24:58" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "07:27:39" , 
"departure_time" : "07:28:27" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "07:30:48" , 
"departure_time" : "07:31:10" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "07:33:22" , 
"departure_time" : "07:34:27" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "07:38:05" , 
"departure_time" : "07:38:10" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "07:42:05" , 
"departure_time" : "07:43:20" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "07:49:15" , 
"departure_time" : "07:49:25" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "07:51:10" , 
"departure_time" : "07:51:43" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "07:54:33" , 
"departure_time" : "07:55:02" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "07:57:29" , 
"departure_time" : "07:58:51" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "08:00:22" , 
"departure_time" : "08:00:54" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:07:32" , 
"departure_time" : "08:08:26" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:19:54" , 
"departure_time" : "08:19:54" , 
"distance_traveled" : 30.7472
} ], 
"1509" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "08:08:00" , 
"departure_time" : "08:09:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "08:11:34" , 
"departure_time" : "08:11:54" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "08:14:20" , 
"departure_time" : "08:14:55" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "08:17:35" , 
"departure_time" : "08:19:14" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "08:21:39" , 
"departure_time" : "08:22:05" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "08:23:26" , 
"departure_time" : "08:23:29" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "08:27:03" , 
"departure_time" : "08:27:57" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "08:30:54" , 
"departure_time" : "08:31:24" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "08:33:30" , 
"departure_time" : "08:33:52" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "08:37:22" , 
"departure_time" : "08:38:03" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "08:42:41" , 
"departure_time" : "08:43:14" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "08:48:33" , 
"departure_time" : "08:50:09" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "08:52:36" , 
"departure_time" : "08:54:15" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "08:55:39" , 
"departure_time" : "08:57:09" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "08:58:30" , 
"departure_time" : "08:59:43" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "09:00:13" , 
"departure_time" : "09:01:22" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:08:09" , 
"departure_time" : "09:08:37" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:19:28" , 
"departure_time" : "09:19:28" , 
"distance_traveled" : 30.7472
} ], 
"1510" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "09:08:00" , 
"departure_time" : "09:09:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "09:11:49" , 
"departure_time" : "09:13:03" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "09:15:14" , 
"departure_time" : "09:16:20" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "09:18:06" , 
"departure_time" : "09:18:09" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "09:20:03" , 
"departure_time" : "09:20:28" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "09:23:25" , 
"departure_time" : "09:24:57" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "09:28:32" , 
"departure_time" : "09:29:51" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "09:31:19" , 
"departure_time" : "09:31:26" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "09:33:07" , 
"departure_time" : "09:34:41" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "09:38:34" , 
"departure_time" : "09:38:40" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "09:42:06" , 
"departure_time" : "09:42:12" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "09:48:06" , 
"departure_time" : "09:48:33" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "09:51:27" , 
"departure_time" : "09:52:07" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "09:54:40" , 
"departure_time" : "09:54:56" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "09:57:16" , 
"departure_time" : "09:57:49" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "09:59:33" , 
"departure_time" : "10:00:58" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "10:08:25" , 
"departure_time" : "10:10:05" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "10:20:40" , 
"departure_time" : "10:20:40" , 
"distance_traveled" : 30.7472
} ], 
"1511" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "10:08:00" , 
"departure_time" : "10:10:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "10:11:33" , 
"departure_time" : "10:11:37" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "10:14:04" , 
"departure_time" : "10:14:23" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "10:17:19" , 
"departure_time" : "10:17:37" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "10:20:18" , 
"departure_time" : "10:21:55" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "10:24:37" , 
"departure_time" : "10:25:27" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "10:27:50" , 
"departure_time" : "10:28:02" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "10:30:12" , 
"departure_time" : "10:30:59" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "10:33:47" , 
"departure_time" : "10:34:05" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "10:37:18" , 
"departure_time" : "10:38:15" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "10:42:57" , 
"departure_time" : "10:44:24" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "10:49:27" , 
"departure_time" : "10:49:29" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "10:51:02" , 
"departure_time" : "10:51:35" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "10:54:33" , 
"departure_time" : "10:56:02" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "10:58:29" , 
"departure_time" : "10:59:55" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "11:00:26" , 
"departure_time" : "11:01:08" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "11:07:42" , 
"departure_time" : "11:09:09" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "11:20:27" , 
"departure_time" : "11:20:27" , 
"distance_traveled" : 30.7472
} ], 
"1512" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "11:08:00" , 
"departure_time" : "11:10:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "11:12:17" , 
"departure_time" : "11:12:41" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "11:14:24" , 
"departure_time" : "11:14:50" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "11:17:26" , 
"departure_time" : "11:17:58" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "11:20:32" , 
"departure_time" : "11:21:35" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "11:24:03" , 
"departure_time" : "11:25:14" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "11:28:11" , 
"departure_time" : "11:28:50" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "11:30:39" , 
"departure_time" : "11:31:20" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "11:33:41" , 
"departure_time" : "11:34:51" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "11:38:10" , 
"departure_time" : "11:38:54" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "11:42:44" , 
"departure_time" : "11:43:31" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "11:48:47" , 
"departure_time" : "11:49:33" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "11:51:46" , 
"departure_time" : "11:52:33" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "11:54:47" , 
"departure_time" : "11:54:48" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "11:57:01" , 
"departure_time" : "11:58:23" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "12:00:22" , 
"departure_time" : "12:01:04" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "12:07:42" , 
"departure_time" : "12:08:56" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "12:20:14" , 
"departure_time" : "12:20:14" , 
"distance_traveled" : 30.7472
} ], 
"1513" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "12:08:00" , 
"departure_time" : "12:09:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "12:11:35" , 
"departure_time" : "12:12:41" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "12:15:06" , 
"departure_time" : "12:16:38" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "12:18:32" , 
"departure_time" : "12:18:44" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "12:20:12" , 
"departure_time" : "12:20:27" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "12:23:15" , 
"departure_time" : "12:23:42" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "12:27:27" , 
"departure_time" : "12:28:56" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "12:31:29" , 
"departure_time" : "12:32:14" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "12:33:45" , 
"departure_time" : "12:35:05" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "12:38:20" , 
"departure_time" : "12:39:47" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "12:43:27" , 
"departure_time" : "12:44:13" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "12:48:46" , 
"departure_time" : "12:50:12" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "12:52:26" , 
"departure_time" : "12:52:48" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "12:54:22" , 
"departure_time" : "12:54:55" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "12:57:33" , 
"departure_time" : "12:58:06" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "12:59:33" , 
"departure_time" : "13:01:10" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "13:08:37" , 
"departure_time" : "13:09:33" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "13:19:56" , 
"departure_time" : "13:19:56" , 
"distance_traveled" : 30.7472
} ], 
"1514" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "13:08:00" , 
"departure_time" : "13:08:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "13:11:03" , 
"departure_time" : "13:12:08" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "13:15:05" , 
"departure_time" : "13:16:43" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "13:18:38" , 
"departure_time" : "13:18:49" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "13:20:11" , 
"departure_time" : "13:20:19" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "13:23:08" , 
"departure_time" : "13:23:27" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "13:27:19" , 
"departure_time" : "13:27:20" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "13:30:01" , 
"departure_time" : "13:31:15" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "13:34:14" , 
"departure_time" : "13:35:17" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "13:38:03" , 
"departure_time" : "13:38:39" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "13:42:36" , 
"departure_time" : "13:43:36" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "13:49:00" , 
"departure_time" : "13:50:40" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "13:52:40" , 
"departure_time" : "13:53:50" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "13:55:10" , 
"departure_time" : "13:55:30" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "13:57:20" , 
"departure_time" : "13:58:09" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "13:59:49" , 
"departure_time" : "14:00:52" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "14:08:03" , 
"departure_time" : "14:08:49" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "14:19:46" , 
"departure_time" : "14:19:46" , 
"distance_traveled" : 30.7472
} ], 
"1515" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "14:08:00" , 
"departure_time" : "14:10:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "14:12:34" , 
"departure_time" : "14:12:55" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "14:14:21" , 
"departure_time" : "14:15:13" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "14:17:52" , 
"departure_time" : "14:19:09" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "14:21:17" , 
"departure_time" : "14:21:38" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "14:23:21" , 
"departure_time" : "14:24:32" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "14:28:11" , 
"departure_time" : "14:29:29" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "14:31:18" , 
"departure_time" : "14:32:09" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "14:33:51" , 
"departure_time" : "14:35:02" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "14:38:11" , 
"departure_time" : "14:39:17" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "14:43:06" , 
"departure_time" : "14:44:15" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "14:49:09" , 
"departure_time" : "14:49:37" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "14:51:28" , 
"departure_time" : "14:52:11" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "14:54:43" , 
"departure_time" : "14:56:13" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "14:58:30" , 
"departure_time" : "14:59:17" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "14:59:47" , 
"departure_time" : "15:00:17" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "15:07:30" , 
"departure_time" : "15:08:57" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "15:20:27" , 
"departure_time" : "15:20:27" , 
"distance_traveled" : 30.7472
} ], 
"1516" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "15:08:00" , 
"departure_time" : "15:09:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "15:11:07" , 
"departure_time" : "15:12:26" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "15:15:19" , 
"departure_time" : "15:16:09" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "15:17:50" , 
"departure_time" : "15:18:43" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "15:20:53" , 
"departure_time" : "15:21:24" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "15:23:31" , 
"departure_time" : "15:24:29" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "15:27:58" , 
"departure_time" : "15:28:48" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "15:30:50" , 
"departure_time" : "15:31:36" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "15:33:46" , 
"departure_time" : "15:34:19" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "15:37:33" , 
"departure_time" : "15:39:10" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "15:43:37" , 
"departure_time" : "15:43:50" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "15:48:13" , 
"departure_time" : "15:49:14" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "15:52:01" , 
"departure_time" : "15:53:35" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "15:55:34" , 
"departure_time" : "15:55:40" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "15:57:06" , 
"departure_time" : "15:58:31" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "16:00:25" , 
"departure_time" : "16:01:01" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:07:36" , 
"departure_time" : "16:07:53" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "16:19:17" , 
"departure_time" : "16:19:17" , 
"distance_traveled" : 30.7472
} ], 
"1517" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "16:08:00" , 
"departure_time" : "16:08:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "16:11:26" , 
"departure_time" : "16:12:54" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "16:15:28" , 
"departure_time" : "16:16:24" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "16:17:56" , 
"departure_time" : "16:18:45" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "16:20:49" , 
"departure_time" : "16:21:33" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "16:23:44" , 
"departure_time" : "16:24:39" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "16:27:55" , 
"departure_time" : "16:28:00" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "16:30:05" , 
"departure_time" : "16:30:17" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "16:33:12" , 
"departure_time" : "16:33:30" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "16:37:18" , 
"departure_time" : "16:38:54" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "16:43:36" , 
"departure_time" : "16:44:40" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "16:49:04" , 
"departure_time" : "16:49:30" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "16:51:26" , 
"departure_time" : "16:52:12" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "16:54:46" , 
"departure_time" : "16:55:31" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "16:57:45" , 
"departure_time" : "16:58:49" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "17:00:04" , 
"departure_time" : "17:00:30" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:07:26" , 
"departure_time" : "17:08:25" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:19:59" , 
"departure_time" : "17:19:59" , 
"distance_traveled" : 30.7472
} ], 
"1518" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "17:08:00" , 
"departure_time" : "17:09:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "17:11:30" , 
"departure_time" : "17:11:53" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "17:14:23" , 
"departure_time" : "17:15:02" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "17:17:39" , 
"departure_time" : "17:17:47" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "17:20:08" , 
"departure_time" : "17:20:39" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "17:23:31" , 
"departure_time" : "17:25:01" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "17:28:30" , 
"departure_time" : "17:29:06" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "17:30:36" , 
"departure_time" : "17:32:14" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "17:34:38" , 
"departure_time" : "17:35:04" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "17:37:26" , 
"departure_time" : "17:38:09" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "17:42:43" , 
"departure_time" : "17:43:40" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "17:48:57" , 
"departure_time" : "17:49:44" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "17:51:47" , 
"departure_time" : "17:52:43" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "17:54:56" , 
"departure_time" : "17:55:31" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "17:57:35" , 
"departure_time" : "17:58:35" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "18:00:00" , 
"departure_time" : "18:00:41" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:07:41" , 
"departure_time" : "18:08:40" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "18:19:59" , 
"departure_time" : "18:19:59" , 
"distance_traveled" : 30.7472
} ], 
"1519" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "18:08:00" , 
"departure_time" : "18:09:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "18:11:41" , 
"departure_time" : "18:12:15" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "18:14:34" , 
"departure_time" : "18:14:48" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "18:17:14" , 
"departure_time" : "18:17:44" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "18:20:30" , 
"departure_time" : "18:20:37" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "18:23:07" , 
"departure_time" : "18:24:03" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "18:27:56" , 
"departure_time" : "18:27:57" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:30:01" , 
"departure_time" : "18:30:53" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "18:33:52" , 
"departure_time" : "18:35:05" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "18:38:13" , 
"departure_time" : "18:39:32" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "18:43:19" , 
"departure_time" : "18:44:36" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "18:49:17" , 
"departure_time" : "18:50:25" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "18:52:08" , 
"departure_time" : "18:52:40" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "18:54:32" , 
"departure_time" : "18:55:08" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "18:57:36" , 
"departure_time" : "18:58:30" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "18:59:54" , 
"departure_time" : "18:59:57" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:07:03" , 
"departure_time" : "19:07:32" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "19:19:29" , 
"departure_time" : "19:19:29" , 
"distance_traveled" : 30.7472
} ], 
"1520" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "19:08:00" , 
"departure_time" : "19:08:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "19:11:07" , 
"departure_time" : "19:12:46" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "19:15:39" , 
"departure_time" : "19:17:15" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "19:18:36" , 
"departure_time" : "19:18:49" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "19:20:13" , 
"departure_time" : "19:20:58" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "19:23:45" , 
"departure_time" : "19:24:08" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "19:27:23" , 
"departure_time" : "19:27:41" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "19:30:18" , 
"departure_time" : "19:31:41" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "19:34:23" , 
"departure_time" : "19:34:29" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "19:37:06" , 
"departure_time" : "19:38:10" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "19:43:04" , 
"departure_time" : "19:43:30" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "19:48:26" , 
"departure_time" : "19:48:37" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "19:51:11" , 
"departure_time" : "19:51:27" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "19:54:16" , 
"departure_time" : "19:55:55" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "19:58:39" , 
"departure_time" : "19:59:59" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "20:00:20" , 
"departure_time" : "20:00:53" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "20:07:33" , 
"departure_time" : "20:09:10" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "20:20:37" , 
"departure_time" : "20:20:37" , 
"distance_traveled" : 30.7472
} ], 
"1521" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "20:08:00" , 
"departure_time" : "20:11:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "20:12:40" , 
"departure_time" : "20:13:21" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "20:14:41" , 
"departure_time" : "20:15:13" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "20:17:32" , 
"departure_time" : "20:18:06" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "20:20:34" , 
"departure_time" : "20:20:44" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "20:23:10" , 
"departure_time" : "20:24:14" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "20:28:04" , 
"departure_time" : "20:28:19" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "20:30:15" , 
"departure_time" : "20:31:04" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "20:33:49" , 
"departure_time" : "20:34:38" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "20:37:49" , 
"departure_time" : "20:39:10" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "20:43:21" , 
"departure_time" : "20:43:22" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "20:48:01" , 
"departure_time" : "20:49:25" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "20:52:24" , 
"departure_time" : "20:52:41" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "20:54:17" , 
"departure_time" : "20:55:19" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "20:58:02" , 
"departure_time" : "20:59:42" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "21:00:40" , 
"departure_time" : "21:01:56" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "21:08:16" , 
"departure_time" : "21:08:28" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "21:19:12" , 
"departure_time" : "21:19:12" , 
"distance_traveled" : 30.7472
} ], 
"1522" :  [ 
{ 
"stop_id" : 144,
"arrival_time" : "21:08:00" , 
"departure_time" : "21:08:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 78,
"arrival_time" : "21:11:26" , 
"departure_time" : "21:12:16" , 
"distance_traveled" : 1.3782
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "21:14:50" , 
"departure_time" : "21:16:09" , 
"distance_traveled" : 2.715
}, 
{ 
"stop_id" : 128,
"arrival_time" : "21:18:19" , 
"departure_time" : "21:19:21" , 
"distance_traveled" : 3.9994
}, 
{ 
"stop_id" : 3,
"arrival_time" : "21:21:02" , 
"departure_time" : "21:21:41" , 
"distance_traveled" : 5.9163
}, 
{ 
"stop_id" : 151,
"arrival_time" : "21:23:39" , 
"departure_time" : "21:25:05" , 
"distance_traveled" : 7.2521
}, 
{ 
"stop_id" : 64,
"arrival_time" : "21:28:26" , 
"departure_time" : "21:29:55" , 
"distance_traveled" : 8.4758
}, 
{ 
"stop_id" : 131,
"arrival_time" : "21:31:29" , 
"departure_time" : "21:32:45" , 
"distance_traveled" : 9.7032
}, 
{ 
"stop_id" : 52,
"arrival_time" : "21:34:16" , 
"departure_time" : "21:34:38" , 
"distance_traveled" : 11.1485
}, 
{ 
"stop_id" : 58,
"arrival_time" : "21:37:22" , 
"departure_time" : "21:37:38" , 
"distance_traveled" : 12.8551
}, 
{ 
"stop_id" : 116,
"arrival_time" : "21:42:16" , 
"departure_time" : "21:43:12" , 
"distance_traveled" : 14.9498
}, 
{ 
"stop_id" : 29,
"arrival_time" : "21:48:56" , 
"departure_time" : "21:50:00" , 
"distance_traveled" : 18.4742
}, 
{ 
"stop_id" : 115,
"arrival_time" : "21:52:04" , 
"departure_time" : "21:52:09" , 
"distance_traveled" : 20.128
}, 
{ 
"stop_id" : 33,
"arrival_time" : "21:54:05" , 
"departure_time" : "21:54:31" , 
"distance_traveled" : 21.3847
}, 
{ 
"stop_id" : 75,
"arrival_time" : "21:57:26" , 
"departure_time" : "21:59:02" , 
"distance_traveled" : 22.4858
}, 
{ 
"stop_id" : 66,
"arrival_time" : "22:00:36" , 
"departure_time" : "22:00:59" , 
"distance_traveled" : 23.067
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "22:07:23" , 
"departure_time" : "22:08:06" , 
"distance_traveled" : 27.1873
}, 
{ 
"stop_id" : 63,
"arrival_time" : "22:19:43" , 
"departure_time" : "22:19:43" , 
"distance_traveled" : 30.7472
} ], 
"1523" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "24:08:00" , 
"departure_time" : "24:09:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "24:18:21" , 
"departure_time" : "24:19:07" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "24:24:46" , 
"departure_time" : "24:26:04" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "24:28:18" , 
"departure_time" : "24:29:29" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "24:31:11" , 
"departure_time" : "24:31:13" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "24:33:02" , 
"departure_time" : "24:34:00" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "24:36:58" , 
"departure_time" : "24:37:33" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "24:42:35" , 
"departure_time" : "24:43:57" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "24:47:22" , 
"departure_time" : "24:48:37" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "24:51:15" , 
"departure_time" : "24:52:48" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "24:55:33" , 
"departure_time" : "24:56:40" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "24:58:07" , 
"departure_time" : "24:58:21" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "25:00:14" , 
"departure_time" : "25:01:07" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "25:04:53" , 
"departure_time" : "25:05:07" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "25:08:14" , 
"departure_time" : "25:08:38" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "25:11:24" , 
"departure_time" : "25:13:03" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "25:16:39" , 
"departure_time" : "25:17:43" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "25:20:04" , 
"departure_time" : "25:20:04" , 
"distance_traveled" : 30.7256
} ], 
"1524" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "24:08:00" , 
"departure_time" : "24:10:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "24:19:37" , 
"departure_time" : "24:20:54" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "24:25:17" , 
"departure_time" : "24:26:36" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "24:28:19" , 
"departure_time" : "24:28:54" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "24:30:35" , 
"departure_time" : "24:30:42" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "24:33:07" , 
"departure_time" : "24:33:27" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "24:36:20" , 
"departure_time" : "24:37:34" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "24:43:14" , 
"departure_time" : "24:44:16" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "24:47:02" , 
"departure_time" : "24:47:49" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "24:50:47" , 
"departure_time" : "24:51:02" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "24:54:15" , 
"departure_time" : "24:54:29" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "24:57:14" , 
"departure_time" : "24:57:26" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "25:00:12" , 
"departure_time" : "25:00:14" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "25:04:02" , 
"departure_time" : "25:04:53" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "25:08:51" , 
"departure_time" : "25:08:58" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "25:11:07" , 
"departure_time" : "25:11:29" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "25:15:22" , 
"departure_time" : "25:15:35" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "25:19:13" , 
"departure_time" : "25:19:13" , 
"distance_traveled" : 30.7256
} ], 
"1525" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "24:21:00" , 
"departure_time" : "24:21:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "24:31:39" , 
"departure_time" : "24:32:48" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "24:39:09" , 
"departure_time" : "24:40:22" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "24:41:13" , 
"departure_time" : "24:42:06" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "24:43:53" , 
"departure_time" : "24:44:11" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "24:46:18" , 
"departure_time" : "24:46:44" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "24:50:26" , 
"departure_time" : "24:50:54" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "24:55:28" , 
"departure_time" : "24:55:56" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "24:59:28" , 
"departure_time" : "25:00:55" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "25:04:27" , 
"departure_time" : "25:04:28" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "25:06:01" , 
"departure_time" : "25:06:01" , 
"distance_traveled" : 21.0006
} ], 
"1526" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "24:21:00" , 
"departure_time" : "24:21:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "24:31:32" , 
"departure_time" : "24:32:31" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "24:38:59" , 
"departure_time" : "24:39:28" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "24:40:29" , 
"departure_time" : "24:41:20" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "24:43:51" , 
"departure_time" : "24:44:44" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "24:46:53" , 
"departure_time" : "24:47:15" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "24:50:22" , 
"departure_time" : "24:50:27" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "24:55:05" , 
"departure_time" : "24:56:37" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "25:00:32" , 
"departure_time" : "25:01:54" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "25:04:22" , 
"departure_time" : "25:05:08" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "25:06:46" , 
"departure_time" : "25:06:46" , 
"distance_traveled" : 21.0006
} ], 
"1527" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "21:15:00" , 
"departure_time" : "21:17:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "21:26:28" , 
"departure_time" : "21:26:33" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "21:32:05" , 
"departure_time" : "21:32:39" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "21:34:34" , 
"departure_time" : "21:35:00" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "21:37:26" , 
"departure_time" : "21:38:56" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "21:41:30" , 
"departure_time" : "21:42:12" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "21:44:42" , 
"departure_time" : "21:45:17" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "21:49:35" , 
"departure_time" : "21:50:01" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "21:53:26" , 
"departure_time" : "21:53:35" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "21:57:09" , 
"departure_time" : "21:58:25" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "22:02:16" , 
"departure_time" : "22:02:16" , 
"distance_traveled" : 21.0006
} ], 
"1528" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "22:13:00" , 
"departure_time" : "22:14:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "22:23:08" , 
"departure_time" : "22:23:51" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "22:30:43" , 
"departure_time" : "22:32:07" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "22:33:24" , 
"departure_time" : "22:33:48" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "22:35:24" , 
"departure_time" : "22:36:44" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "22:39:20" , 
"departure_time" : "22:40:15" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "22:42:55" , 
"departure_time" : "22:44:13" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "22:49:18" , 
"departure_time" : "22:50:09" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "22:53:51" , 
"departure_time" : "22:54:42" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "22:57:51" , 
"departure_time" : "22:59:29" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "23:02:38" , 
"departure_time" : "23:02:38" , 
"distance_traveled" : 21.0006
} ], 
"1529" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "23:13:00" , 
"departure_time" : "23:15:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "23:23:25" , 
"departure_time" : "23:24:59" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "23:31:34" , 
"departure_time" : "23:31:47" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "23:32:13" , 
"departure_time" : "23:33:04" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "23:35:51" , 
"departure_time" : "23:37:04" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "23:39:13" , 
"departure_time" : "23:39:16" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "23:42:03" , 
"departure_time" : "23:42:34" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "23:48:31" , 
"departure_time" : "23:49:52" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "23:54:21" , 
"departure_time" : "23:54:51" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "23:57:30" , 
"departure_time" : "23:57:43" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "24:01:13" , 
"departure_time" : "24:01:13" , 
"distance_traveled" : 21.0006
} ], 
"1530" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "06:17:00" , 
"departure_time" : "06:17:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "06:27:25" , 
"departure_time" : "06:28:32" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "06:36:07" , 
"departure_time" : "06:37:13" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "06:40:06" , 
"departure_time" : "06:40:37" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 121,
"arrival_time" : "06:44:31" , 
"departure_time" : "06:46:10" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "06:50:39" , 
"departure_time" : "06:50:43" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "06:52:04" , 
"departure_time" : "06:52:28" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "06:55:24" , 
"departure_time" : "06:55:59" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "06:59:35" , 
"departure_time" : "06:59:44" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "07:03:09" , 
"departure_time" : "07:03:26" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "07:07:17" , 
"departure_time" : "07:07:17" , 
"distance_traveled" : 22.3157
} ], 
"1531" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "07:17:00" , 
"departure_time" : "07:18:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:28:05" , 
"departure_time" : "07:28:47" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "07:35:42" , 
"departure_time" : "07:35:43" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "07:39:01" , 
"departure_time" : "07:40:14" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "07:43:13" , 
"departure_time" : "07:44:09" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "07:45:56" , 
"departure_time" : "07:46:13" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "07:50:17" , 
"departure_time" : "07:51:23" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "07:55:06" , 
"departure_time" : "07:55:32" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "07:57:26" , 
"departure_time" : "07:58:18" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "08:01:52" , 
"departure_time" : "08:03:21" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "08:05:29" , 
"departure_time" : "08:06:00" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "08:08:31" , 
"departure_time" : "08:08:31" , 
"distance_traveled" : 22.3157
} ], 
"1532" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "24:21:00" , 
"departure_time" : "24:21:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "24:31:07" , 
"departure_time" : "24:31:50" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "24:38:43" , 
"departure_time" : "24:39:02" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "24:40:19" , 
"departure_time" : "24:40:24" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "24:43:05" , 
"departure_time" : "24:43:06" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "24:46:01" , 
"departure_time" : "24:47:24" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "24:51:23" , 
"departure_time" : "24:52:18" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "24:55:55" , 
"departure_time" : "24:56:55" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "25:00:00" , 
"departure_time" : "25:00:37" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "25:03:37" , 
"departure_time" : "25:03:49" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "25:06:12" , 
"departure_time" : "25:06:12" , 
"distance_traveled" : 21.0006
} ], 
"1533" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "08:17:00" , 
"departure_time" : "08:18:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:28:40" , 
"departure_time" : "08:28:59" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "08:35:19" , 
"departure_time" : "08:35:53" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "08:39:34" , 
"departure_time" : "08:40:47" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "08:43:13" , 
"departure_time" : "08:44:18" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "08:46:05" , 
"departure_time" : "08:47:10" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "08:51:05" , 
"departure_time" : "08:51:12" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "08:54:07" , 
"departure_time" : "08:55:04" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "08:57:57" , 
"departure_time" : "08:59:05" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "09:02:08" , 
"departure_time" : "09:02:25" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "09:04:17" , 
"departure_time" : "09:04:23" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "09:08:06" , 
"departure_time" : "09:08:06" , 
"distance_traveled" : 22.3157
} ], 
"1534" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "10:17:00" , 
"departure_time" : "10:17:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "10:27:29" , 
"departure_time" : "10:28:45" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "10:36:16" , 
"departure_time" : "10:37:50" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "10:40:34" , 
"departure_time" : "10:41:56" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "10:43:22" , 
"departure_time" : "10:44:19" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "10:45:57" , 
"departure_time" : "10:45:58" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "10:50:01" , 
"departure_time" : "10:51:00" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "10:54:59" , 
"departure_time" : "10:55:18" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "10:57:19" , 
"departure_time" : "10:58:37" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "11:02:18" , 
"departure_time" : "11:03:48" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "11:05:30" , 
"departure_time" : "11:05:46" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "11:08:16" , 
"departure_time" : "11:08:16" , 
"distance_traveled" : 22.3157
} ], 
"1535" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "21:15:00" , 
"departure_time" : "21:16:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "21:26:02" , 
"departure_time" : "21:26:06" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "21:32:04" , 
"departure_time" : "21:33:13" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "21:35:09" , 
"departure_time" : "21:35:39" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "21:37:30" , 
"departure_time" : "21:38:56" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "21:41:26" , 
"departure_time" : "21:42:47" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "21:45:21" , 
"departure_time" : "21:46:43" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "21:50:22" , 
"departure_time" : "21:51:41" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "21:54:19" , 
"departure_time" : "21:55:15" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "21:57:56" , 
"departure_time" : "21:59:11" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "22:02:15" , 
"departure_time" : "22:02:15" , 
"distance_traveled" : 21.0006
} ], 
"1536" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "12:17:00" , 
"departure_time" : "12:19:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "12:28:01" , 
"departure_time" : "12:29:30" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "12:36:29" , 
"departure_time" : "12:36:31" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "12:39:02" , 
"departure_time" : "12:40:26" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "12:43:24" , 
"departure_time" : "12:43:43" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "12:45:19" , 
"departure_time" : "12:45:39" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "12:50:20" , 
"departure_time" : "12:51:00" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "12:54:40" , 
"departure_time" : "12:55:51" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "12:58:11" , 
"departure_time" : "12:59:35" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "13:02:24" , 
"departure_time" : "13:02:52" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "13:04:28" , 
"departure_time" : "13:05:25" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "13:08:57" , 
"departure_time" : "13:08:57" , 
"distance_traveled" : 22.3157
} ], 
"1537" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "22:13:00" , 
"departure_time" : "22:14:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "22:23:13" , 
"departure_time" : "22:24:46" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "22:31:33" , 
"departure_time" : "22:31:46" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "22:32:13" , 
"departure_time" : "22:32:21" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "22:35:08" , 
"departure_time" : "22:36:20" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "22:39:12" , 
"departure_time" : "22:39:28" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "22:42:16" , 
"departure_time" : "22:42:48" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "22:48:32" , 
"departure_time" : "22:49:10" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "22:53:38" , 
"departure_time" : "22:54:20" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "22:57:42" , 
"departure_time" : "22:58:02" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "23:01:20" , 
"departure_time" : "23:01:20" , 
"distance_traveled" : 21.0006
} ], 
"1538" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "13:17:00" , 
"departure_time" : "13:18:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "13:28:01" , 
"departure_time" : "13:29:39" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "13:36:38" , 
"departure_time" : "13:37:33" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "13:39:55" , 
"departure_time" : "13:40:58" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "13:43:03" , 
"departure_time" : "13:43:24" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "13:45:21" , 
"departure_time" : "13:45:54" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "13:50:33" , 
"departure_time" : "13:51:26" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "13:54:53" , 
"departure_time" : "13:55:06" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "13:57:13" , 
"departure_time" : "13:57:43" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "14:01:30" , 
"departure_time" : "14:02:05" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "14:04:35" , 
"departure_time" : "14:04:59" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "14:08:24" , 
"departure_time" : "14:08:24" , 
"distance_traveled" : 22.3157
} ], 
"1539" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "23:13:00" , 
"departure_time" : "23:14:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "23:23:39" , 
"departure_time" : "23:24:22" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "23:30:43" , 
"departure_time" : "23:31:00" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "23:32:17" , 
"departure_time" : "23:33:24" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "23:36:07" , 
"departure_time" : "23:37:11" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "23:39:04" , 
"departure_time" : "23:39:34" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "23:42:30" , 
"departure_time" : "23:43:28" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "23:48:58" , 
"departure_time" : "23:49:44" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "23:53:46" , 
"departure_time" : "23:54:18" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "23:57:32" , 
"departure_time" : "23:57:40" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "24:01:08" , 
"departure_time" : "24:01:08" , 
"distance_traveled" : 21.0006
} ], 
"1540" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "14:17:00" , 
"departure_time" : "14:17:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "14:27:22" , 
"departure_time" : "14:27:51" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "14:35:29" , 
"departure_time" : "14:35:39" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "14:39:10" , 
"departure_time" : "14:39:34" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "14:42:24" , 
"departure_time" : "14:43:53" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "14:46:29" , 
"departure_time" : "14:47:08" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "14:50:39" , 
"departure_time" : "14:51:45" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "14:55:06" , 
"departure_time" : "14:55:21" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "14:57:15" , 
"departure_time" : "14:57:31" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "15:01:16" , 
"departure_time" : "15:01:55" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "15:04:39" , 
"departure_time" : "15:06:13" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "15:09:34" , 
"departure_time" : "15:09:34" , 
"distance_traveled" : 22.3157
} ], 
"1541" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "06:17:00" , 
"departure_time" : "06:19:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "06:27:41" , 
"departure_time" : "06:28:29" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "06:35:48" , 
"departure_time" : "06:36:48" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "06:40:00" , 
"departure_time" : "06:40:12" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 121,
"arrival_time" : "06:44:12" , 
"departure_time" : "06:44:15" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "06:49:03" , 
"departure_time" : "06:50:43" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "06:53:40" , 
"departure_time" : "06:53:46" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "06:55:06" , 
"departure_time" : "06:56:39" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "07:00:33" , 
"departure_time" : "07:01:59" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "07:04:26" , 
"departure_time" : "07:05:20" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "07:07:54" , 
"departure_time" : "07:07:54" , 
"distance_traveled" : 22.3157
} ], 
"1542" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "15:17:00" , 
"departure_time" : "15:18:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "15:27:11" , 
"departure_time" : "15:27:42" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "15:35:31" , 
"departure_time" : "15:36:33" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "15:40:02" , 
"departure_time" : "15:40:56" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "15:42:54" , 
"departure_time" : "15:43:46" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "15:45:52" , 
"departure_time" : "15:46:11" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "15:50:19" , 
"departure_time" : "15:51:48" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "15:55:29" , 
"departure_time" : "15:56:16" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "15:57:47" , 
"departure_time" : "15:58:20" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "16:01:33" , 
"departure_time" : "16:02:36" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "16:05:03" , 
"departure_time" : "16:06:25" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "16:09:22" , 
"departure_time" : "16:09:22" , 
"distance_traveled" : 22.3157
} ], 
"1543" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "07:17:00" , 
"departure_time" : "07:18:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:27:27" , 
"departure_time" : "07:27:47" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "07:35:20" , 
"departure_time" : "07:35:52" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "07:39:32" , 
"departure_time" : "07:41:04" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "07:43:32" , 
"departure_time" : "07:44:58" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "07:46:26" , 
"departure_time" : "07:47:50" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "07:51:24" , 
"departure_time" : "07:52:57" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "07:55:33" , 
"departure_time" : "07:56:32" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "07:57:59" , 
"departure_time" : "07:58:26" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "08:01:27" , 
"departure_time" : "08:02:23" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "08:04:56" , 
"departure_time" : "08:06:03" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "08:09:07" , 
"departure_time" : "08:09:07" , 
"distance_traveled" : 22.3157
} ], 
"1544" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:17:00" , 
"departure_time" : "16:18:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:27:52" , 
"departure_time" : "16:29:31" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "16:36:39" , 
"departure_time" : "16:36:49" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "16:39:10" , 
"departure_time" : "16:39:53" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "16:42:43" , 
"departure_time" : "16:42:49" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "16:45:06" , 
"departure_time" : "16:45:53" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "16:50:47" , 
"departure_time" : "16:51:31" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "16:54:44" , 
"departure_time" : "16:55:14" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "16:57:30" , 
"departure_time" : "16:58:46" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "17:02:16" , 
"departure_time" : "17:03:34" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "17:05:18" , 
"departure_time" : "17:06:05" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "17:07:47" , 
"departure_time" : "17:07:47" , 
"distance_traveled" : 22.3157
} ], 
"1545" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "08:17:00" , 
"departure_time" : "08:19:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:28:32" , 
"departure_time" : "08:28:52" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "08:35:20" , 
"departure_time" : "08:36:55" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "08:40:35" , 
"departure_time" : "08:40:48" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "08:42:13" , 
"departure_time" : "08:43:30" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "08:46:17" , 
"departure_time" : "08:46:45" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "08:50:28" , 
"departure_time" : "08:51:06" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "08:54:38" , 
"departure_time" : "08:55:48" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "08:58:10" , 
"departure_time" : "08:59:36" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "09:02:26" , 
"departure_time" : "09:03:44" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "09:05:18" , 
"departure_time" : "09:05:45" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "09:08:27" , 
"departure_time" : "09:08:27" , 
"distance_traveled" : 22.3157
} ], 
"1546" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:17:00" , 
"departure_time" : "17:17:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:27:02" , 
"departure_time" : "17:27:52" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "17:35:50" , 
"departure_time" : "17:36:15" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "17:39:25" , 
"departure_time" : "17:40:28" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "17:43:03" , 
"departure_time" : "17:44:00" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "17:45:57" , 
"departure_time" : "17:47:29" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "17:51:32" , 
"departure_time" : "17:52:55" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "17:55:23" , 
"departure_time" : "17:56:35" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "17:58:12" , 
"departure_time" : "17:59:11" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:01:59" , 
"departure_time" : "18:02:24" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "18:04:25" , 
"departure_time" : "18:05:14" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "18:08:49" , 
"departure_time" : "18:08:49" , 
"distance_traveled" : 22.3157
} ], 
"1547" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "10:17:00" , 
"departure_time" : "10:19:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "10:28:30" , 
"departure_time" : "10:29:25" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "10:35:55" , 
"departure_time" : "10:36:00" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "10:39:05" , 
"departure_time" : "10:39:56" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "10:42:51" , 
"departure_time" : "10:44:30" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "10:46:39" , 
"departure_time" : "10:46:41" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "10:50:02" , 
"departure_time" : "10:51:00" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "10:54:58" , 
"departure_time" : "10:56:24" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "10:58:26" , 
"departure_time" : "10:58:39" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "11:01:13" , 
"departure_time" : "11:01:52" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "11:04:39" , 
"departure_time" : "11:06:10" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "11:09:31" , 
"departure_time" : "11:09:31" , 
"distance_traveled" : 22.3157
} ], 
"1548" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:17:00" , 
"departure_time" : "18:19:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:27:45" , 
"departure_time" : "18:27:47" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "18:35:02" , 
"departure_time" : "18:35:56" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "18:39:54" , 
"departure_time" : "18:41:04" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "18:43:10" , 
"departure_time" : "18:44:43" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "18:46:33" , 
"departure_time" : "18:48:03" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "18:51:30" , 
"departure_time" : "18:51:33" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "18:54:03" , 
"departure_time" : "18:55:34" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "18:58:31" , 
"departure_time" : "18:58:54" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "19:01:23" , 
"departure_time" : "19:02:44" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "19:05:21" , 
"departure_time" : "19:06:07" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "19:07:46" , 
"departure_time" : "19:07:46" , 
"distance_traveled" : 22.3157
} ], 
"1549" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "12:17:00" , 
"departure_time" : "12:18:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "12:27:22" , 
"departure_time" : "12:28:35" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "12:36:13" , 
"departure_time" : "12:37:44" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "12:40:31" , 
"departure_time" : "12:41:57" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "12:43:26" , 
"departure_time" : "12:44:46" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "12:46:20" , 
"departure_time" : "12:46:25" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "12:50:05" , 
"departure_time" : "12:50:17" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "12:54:12" , 
"departure_time" : "12:55:12" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "12:58:00" , 
"departure_time" : "12:58:52" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "13:01:52" , 
"departure_time" : "13:03:09" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "13:05:17" , 
"departure_time" : "13:06:19" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "13:09:02" , 
"departure_time" : "13:09:02" , 
"distance_traveled" : 22.3157
} ], 
"1550" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "19:17:00" , 
"departure_time" : "19:19:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:28:15" , 
"departure_time" : "19:28:47" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "19:35:32" , 
"departure_time" : "19:36:25" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "19:39:53" , 
"departure_time" : "19:41:04" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "19:43:11" , 
"departure_time" : "19:44:16" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "19:46:05" , 
"departure_time" : "19:47:25" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "19:51:20" , 
"departure_time" : "19:51:41" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "19:54:21" , 
"departure_time" : "19:54:25" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "19:57:04" , 
"departure_time" : "19:58:13" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "20:02:09" , 
"departure_time" : "20:03:28" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "20:05:19" , 
"departure_time" : "20:06:59" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "20:07:40" , 
"departure_time" : "20:07:40" , 
"distance_traveled" : 22.3157
} ], 
"1551" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "13:17:00" , 
"departure_time" : "13:20:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "13:28:37" , 
"departure_time" : "13:29:09" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "13:35:32" , 
"departure_time" : "13:35:58" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "13:39:26" , 
"departure_time" : "13:40:04" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "13:42:38" , 
"departure_time" : "13:43:53" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "13:46:15" , 
"departure_time" : "13:46:26" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "13:50:11" , 
"departure_time" : "13:50:39" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "13:54:28" , 
"departure_time" : "13:55:20" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "13:57:52" , 
"departure_time" : "13:58:41" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "14:01:49" , 
"departure_time" : "14:02:37" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "14:04:48" , 
"departure_time" : "14:06:13" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "14:09:25" , 
"departure_time" : "14:09:25" , 
"distance_traveled" : 22.3157
} ], 
"1552" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "20:17:00" , 
"departure_time" : "20:19:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "20:28:04" , 
"departure_time" : "20:28:30" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "20:35:26" , 
"departure_time" : "20:35:53" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "20:39:27" , 
"departure_time" : "20:39:39" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "20:42:12" , 
"departure_time" : "20:42:40" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "20:45:28" , 
"departure_time" : "20:45:56" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "20:50:28" , 
"departure_time" : "20:51:54" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "20:55:26" , 
"departure_time" : "20:55:32" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "20:57:06" , 
"departure_time" : "20:57:13" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "21:00:07" , 
"departure_time" : "21:01:03" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "21:04:56" , 
"departure_time" : "21:06:29" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "21:09:33" , 
"departure_time" : "21:09:33" , 
"distance_traveled" : 22.3157
} ], 
"1553" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "14:17:00" , 
"departure_time" : "14:19:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "14:27:53" , 
"departure_time" : "14:29:12" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "14:36:19" , 
"departure_time" : "14:36:54" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "14:39:35" , 
"departure_time" : "14:40:24" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "14:42:49" , 
"departure_time" : "14:42:57" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "14:45:08" , 
"departure_time" : "14:45:09" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "14:50:01" , 
"departure_time" : "14:50:44" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "14:54:43" , 
"departure_time" : "14:55:25" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "14:57:42" , 
"departure_time" : "14:58:55" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "15:02:13" , 
"departure_time" : "15:03:47" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "15:05:34" , 
"departure_time" : "15:07:11" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "15:09:37" , 
"departure_time" : "15:09:37" , 
"distance_traveled" : 22.3157
} ], 
"1554" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "23:21:00" , 
"departure_time" : "23:23:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "23:32:11" , 
"departure_time" : "23:32:29" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "23:39:18" , 
"departure_time" : "23:40:57" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "23:44:39" , 
"departure_time" : "23:44:53" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "23:46:14" , 
"departure_time" : "23:47:04" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "23:49:50" , 
"departure_time" : "23:50:04" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "23:54:14" , 
"departure_time" : "23:55:43" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "23:59:29" , 
"departure_time" : "24:00:45" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "24:02:16" , 
"departure_time" : "24:03:38" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "24:06:22" , 
"departure_time" : "24:07:48" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "24:09:26" , 
"departure_time" : "24:10:25" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "24:11:59" , 
"departure_time" : "24:12:41" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "24:15:42" , 
"departure_time" : "24:15:56" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "24:19:14" , 
"departure_time" : "24:19:41" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "24:22:27" , 
"departure_time" : "24:23:50" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "24:26:23" , 
"departure_time" : "24:26:39" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "24:29:16" , 
"departure_time" : "24:29:16" , 
"distance_traveled" : 29.571
} ], 
"1555" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "15:17:00" , 
"departure_time" : "15:18:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "15:27:59" , 
"departure_time" : "15:29:16" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "15:36:17" , 
"departure_time" : "15:36:23" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "15:39:06" , 
"departure_time" : "15:40:32" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "15:43:26" , 
"departure_time" : "15:44:40" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "15:46:14" , 
"departure_time" : "15:46:20" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "15:50:06" , 
"departure_time" : "15:50:30" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "15:54:24" , 
"departure_time" : "15:54:49" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "15:57:25" , 
"departure_time" : "15:57:46" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "16:01:21" , 
"departure_time" : "16:01:56" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "16:04:35" , 
"departure_time" : "16:05:08" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "16:08:33" , 
"departure_time" : "16:08:33" , 
"distance_traveled" : 22.3157
} ], 
"1556" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "22:21:00" , 
"departure_time" : "22:23:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "22:32:36" , 
"departure_time" : "22:34:10" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "22:40:34" , 
"departure_time" : "22:41:28" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "22:43:54" , 
"departure_time" : "22:45:06" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "22:47:12" , 
"departure_time" : "22:47:37" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "22:49:25" , 
"departure_time" : "22:49:50" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "22:54:25" , 
"departure_time" : "22:54:47" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "22:58:22" , 
"departure_time" : "22:58:52" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "23:01:30" , 
"departure_time" : "23:03:04" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "23:06:34" , 
"departure_time" : "23:07:02" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "23:08:28" , 
"departure_time" : "23:09:57" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "23:12:29" , 
"departure_time" : "23:12:35" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "23:15:06" , 
"departure_time" : "23:16:38" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "23:20:32" , 
"departure_time" : "23:21:01" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "23:22:29" , 
"departure_time" : "23:23:49" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "23:26:20" , 
"departure_time" : "23:27:41" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "23:30:21" , 
"departure_time" : "23:30:21" , 
"distance_traveled" : 29.571
} ], 
"1557" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:17:00" , 
"departure_time" : "16:18:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:27:09" , 
"departure_time" : "16:27:41" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "16:35:32" , 
"departure_time" : "16:35:51" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "16:39:19" , 
"departure_time" : "16:40:00" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "16:42:41" , 
"departure_time" : "16:44:00" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "16:46:19" , 
"departure_time" : "16:47:23" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "16:51:04" , 
"departure_time" : "16:51:36" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "16:54:32" , 
"departure_time" : "16:54:56" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "16:57:24" , 
"departure_time" : "16:58:50" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "17:02:26" , 
"departure_time" : "17:03:39" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "17:05:13" , 
"departure_time" : "17:06:00" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "17:07:47" , 
"departure_time" : "17:07:47" , 
"distance_traveled" : 22.3157
} ], 
"1558" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "25:32:00" , 
"departure_time" : "25:32:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "25:43:06" , 
"departure_time" : "25:44:20" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "25:50:14" , 
"departure_time" : "25:50:33" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "25:51:19" , 
"departure_time" : "25:52:10" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "25:54:51" , 
"departure_time" : "25:56:20" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "25:58:29" , 
"departure_time" : "25:58:50" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "26:00:21" , 
"departure_time" : "26:00:39" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "26:05:18" , 
"departure_time" : "26:06:47" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "26:10:29" , 
"departure_time" : "26:11:07" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "26:13:38" , 
"departure_time" : "26:14:31" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "26:17:53" , 
"departure_time" : "26:19:03" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "26:21:10" , 
"departure_time" : "26:21:47" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "26:24:37" , 
"departure_time" : "26:25:50" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "26:28:13" , 
"departure_time" : "26:28:26" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "26:32:13" , 
"departure_time" : "26:32:21" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "26:34:08" , 
"departure_time" : "26:34:36" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "26:38:28" , 
"departure_time" : "26:39:42" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "26:42:14" , 
"departure_time" : "26:42:14" , 
"distance_traveled" : 30.7256
} ], 
"1559" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:17:00" , 
"departure_time" : "17:18:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:27:02" , 
"departure_time" : "17:27:14" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "17:35:12" , 
"departure_time" : "17:36:38" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "17:40:26" , 
"departure_time" : "17:40:35" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "17:42:09" , 
"departure_time" : "17:43:36" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "17:46:27" , 
"departure_time" : "17:47:33" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "17:51:06" , 
"departure_time" : "17:51:30" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "17:54:24" , 
"departure_time" : "17:55:40" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "17:58:16" , 
"departure_time" : "17:58:34" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:01:18" , 
"departure_time" : "18:02:19" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "18:05:01" , 
"departure_time" : "18:06:27" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "18:09:26" , 
"departure_time" : "18:09:26" , 
"distance_traveled" : 22.3157
} ], 
"1560" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "25:32:00" , 
"departure_time" : "25:33:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "25:43:18" , 
"departure_time" : "25:44:04" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "25:49:46" , 
"departure_time" : "25:50:14" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "25:51:28" , 
"departure_time" : "25:52:51" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "25:55:23" , 
"departure_time" : "25:56:28" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "25:58:05" , 
"departure_time" : "25:59:38" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "26:01:33" , 
"departure_time" : "26:01:53" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "26:05:20" , 
"departure_time" : "26:06:24" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "26:10:04" , 
"departure_time" : "26:10:24" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "26:13:20" , 
"departure_time" : "26:14:45" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "26:18:25" , 
"departure_time" : "26:18:36" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "26:20:11" , 
"departure_time" : "26:21:46" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "26:25:35" , 
"departure_time" : "26:26:48" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "26:28:13" , 
"departure_time" : "26:28:54" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "26:32:41" , 
"departure_time" : "26:34:11" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "26:35:30" , 
"departure_time" : "26:37:05" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "26:39:35" , 
"departure_time" : "26:39:44" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "26:41:09" , 
"departure_time" : "26:41:09" , 
"distance_traveled" : 30.7256
} ], 
"1561" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:17:00" , 
"departure_time" : "18:18:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:28:30" , 
"departure_time" : "18:29:55" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "18:36:25" , 
"departure_time" : "18:38:04" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "18:40:39" , 
"departure_time" : "18:40:57" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "18:42:18" , 
"departure_time" : "18:43:55" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "18:46:37" , 
"departure_time" : "18:47:50" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "18:51:13" , 
"departure_time" : "18:52:29" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "18:55:16" , 
"departure_time" : "18:55:34" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "18:57:18" , 
"departure_time" : "18:58:39" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "19:02:21" , 
"departure_time" : "19:03:39" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "19:05:18" , 
"departure_time" : "19:05:32" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "19:07:14" , 
"departure_time" : "19:07:14" , 
"distance_traveled" : 22.3157
} ], 
"1562" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "06:25:00" , 
"departure_time" : "06:26:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "06:36:28" , 
"departure_time" : "06:37:01" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "06:41:33" , 
"departure_time" : "06:42:18" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "06:44:45" , 
"departure_time" : "06:45:37" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "06:46:52" , 
"departure_time" : "06:47:29" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "06:49:37" , 
"departure_time" : "06:50:02" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "06:53:25" , 
"departure_time" : "06:53:41" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "06:59:16" , 
"departure_time" : "07:00:45" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "07:05:29" , 
"departure_time" : "07:06:38" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "07:09:09" , 
"departure_time" : "07:09:13" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "07:12:04" , 
"departure_time" : "07:13:43" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "07:16:39" , 
"departure_time" : "07:16:59" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "07:19:20" , 
"departure_time" : "07:19:33" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "07:23:13" , 
"departure_time" : "07:23:31" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "07:28:18" , 
"departure_time" : "07:29:27" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "07:32:09" , 
"departure_time" : "07:32:13" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "07:34:04" , 
"departure_time" : "07:34:37" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "07:40:33" , 
"departure_time" : "07:40:33" , 
"distance_traveled" : 30.7256
} ], 
"1563" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "19:17:00" , 
"departure_time" : "19:18:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:27:40" , 
"departure_time" : "19:28:01" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "19:35:21" , 
"departure_time" : "19:36:16" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "19:39:55" , 
"departure_time" : "19:40:47" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "19:42:52" , 
"departure_time" : "19:44:18" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "19:46:26" , 
"departure_time" : "19:46:51" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "19:50:25" , 
"departure_time" : "19:51:29" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "19:55:04" , 
"departure_time" : "19:55:23" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "19:57:19" , 
"departure_time" : "19:58:43" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "20:02:24" , 
"departure_time" : "20:03:53" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "20:05:29" , 
"departure_time" : "20:06:46" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "20:07:17" , 
"departure_time" : "20:07:17" , 
"distance_traveled" : 22.3157
} ], 
"1564" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "07:25:00" , 
"departure_time" : "07:27:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:35:58" , 
"departure_time" : "07:37:17" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "07:42:19" , 
"departure_time" : "07:42:59" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "07:44:40" , 
"departure_time" : "07:45:51" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "07:47:11" , 
"departure_time" : "07:47:15" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "07:49:04" , 
"departure_time" : "07:50:38" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "07:54:34" , 
"departure_time" : "07:55:35" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "08:00:01" , 
"departure_time" : "08:00:43" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "08:04:42" , 
"departure_time" : "08:05:42" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "08:09:00" , 
"departure_time" : "08:09:40" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "08:12:40" , 
"departure_time" : "08:14:05" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "08:16:25" , 
"departure_time" : "08:16:56" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "08:19:31" , 
"departure_time" : "08:20:26" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "08:23:55" , 
"departure_time" : "08:24:55" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "08:29:00" , 
"departure_time" : "08:29:57" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "08:31:57" , 
"departure_time" : "08:32:49" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "08:34:52" , 
"departure_time" : "08:34:59" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "08:40:07" , 
"departure_time" : "08:40:07" , 
"distance_traveled" : 30.7256
} ], 
"1565" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "20:17:00" , 
"departure_time" : "20:18:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "20:28:34" , 
"departure_time" : "20:30:07" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "20:36:33" , 
"departure_time" : "20:36:57" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "20:39:24" , 
"departure_time" : "20:39:28" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "20:42:04" , 
"departure_time" : "20:43:32" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "20:46:28" , 
"departure_time" : "20:46:59" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "20:50:31" , 
"departure_time" : "20:50:41" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "20:54:10" , 
"departure_time" : "20:54:35" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "20:57:25" , 
"departure_time" : "20:58:44" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "21:01:19" , 
"departure_time" : "21:01:51" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "21:04:32" , 
"departure_time" : "21:04:53" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "21:08:21" , 
"departure_time" : "21:08:21" , 
"distance_traveled" : 22.3157
} ], 
"1566" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "08:25:00" , 
"departure_time" : "08:26:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:36:38" , 
"departure_time" : "08:38:17" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "08:42:39" , 
"departure_time" : "08:44:05" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "08:45:26" , 
"departure_time" : "08:46:29" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "08:47:03" , 
"departure_time" : "08:48:31" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "08:50:28" , 
"departure_time" : "08:50:49" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "08:53:21" , 
"departure_time" : "08:54:15" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "08:59:54" , 
"departure_time" : "09:01:31" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "09:05:37" , 
"departure_time" : "09:07:14" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "09:09:37" , 
"departure_time" : "09:10:32" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "09:12:55" , 
"departure_time" : "09:13:04" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "09:15:09" , 
"departure_time" : "09:16:00" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "09:19:51" , 
"departure_time" : "09:20:58" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "09:24:07" , 
"departure_time" : "09:24:26" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "09:28:19" , 
"departure_time" : "09:29:17" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "09:31:58" , 
"departure_time" : "09:32:07" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "09:34:09" , 
"departure_time" : "09:34:24" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "09:40:15" , 
"departure_time" : "09:40:15" , 
"distance_traveled" : 30.7256
} ], 
"1567" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "23:21:00" , 
"departure_time" : "23:22:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "23:32:33" , 
"departure_time" : "23:33:52" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "23:40:19" , 
"departure_time" : "23:40:35" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "23:43:16" , 
"departure_time" : "23:44:06" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "23:46:50" , 
"departure_time" : "23:47:34" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "23:49:44" , 
"departure_time" : "23:51:21" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "23:55:37" , 
"departure_time" : "23:55:43" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "23:58:06" , 
"departure_time" : "23:58:48" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "24:01:42" , 
"departure_time" : "24:02:19" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "24:05:37" , 
"departure_time" : "24:06:05" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "24:08:28" , 
"departure_time" : "24:08:52" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "24:11:24" , 
"departure_time" : "24:12:43" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "24:16:19" , 
"departure_time" : "24:16:53" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "24:19:34" , 
"departure_time" : "24:19:55" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "24:22:21" , 
"departure_time" : "24:22:30" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "24:25:09" , 
"departure_time" : "24:26:20" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "24:30:11" , 
"departure_time" : "24:30:11" , 
"distance_traveled" : 29.571
} ], 
"1568" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "09:25:00" , 
"departure_time" : "09:27:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:36:36" , 
"departure_time" : "09:36:55" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "09:41:19" , 
"departure_time" : "09:42:53" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "09:45:34" , 
"departure_time" : "09:46:23" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "09:46:49" , 
"departure_time" : "09:47:21" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "09:49:32" , 
"departure_time" : "09:50:24" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "09:53:52" , 
"departure_time" : "09:55:27" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "10:00:35" , 
"departure_time" : "10:01:04" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "10:04:29" , 
"departure_time" : "10:05:23" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "10:08:54" , 
"departure_time" : "10:09:19" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "10:12:25" , 
"departure_time" : "10:12:28" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "10:15:03" , 
"departure_time" : "10:15:58" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "10:19:55" , 
"departure_time" : "10:20:43" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "10:23:48" , 
"departure_time" : "10:25:10" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "10:29:22" , 
"departure_time" : "10:30:38" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "10:32:16" , 
"departure_time" : "10:32:48" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "10:34:32" , 
"departure_time" : "10:34:44" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "10:40:12" , 
"departure_time" : "10:40:12" , 
"distance_traveled" : 30.7256
} ], 
"1569" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "22:21:00" , 
"departure_time" : "22:21:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "22:31:43" , 
"departure_time" : "22:33:13" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "22:40:30" , 
"departure_time" : "22:40:49" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "22:43:19" , 
"departure_time" : "22:43:26" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "22:46:07" , 
"departure_time" : "22:46:14" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "22:49:07" , 
"departure_time" : "22:50:43" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "22:55:36" , 
"departure_time" : "22:56:56" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "22:59:20" , 
"departure_time" : "22:59:29" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "23:01:09" , 
"departure_time" : "23:02:11" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "23:06:02" , 
"departure_time" : "23:07:20" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "23:09:18" , 
"departure_time" : "23:10:41" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "23:12:23" , 
"departure_time" : "23:13:59" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "23:16:36" , 
"departure_time" : "23:17:21" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "23:19:45" , 
"departure_time" : "23:21:22" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "23:23:37" , 
"departure_time" : "23:25:15" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "23:26:38" , 
"departure_time" : "23:27:10" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "23:29:32" , 
"departure_time" : "23:29:32" , 
"distance_traveled" : 29.571
} ], 
"1570" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "10:25:00" , 
"departure_time" : "10:26:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "10:36:06" , 
"departure_time" : "10:36:32" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "10:41:26" , 
"departure_time" : "10:41:31" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "10:44:05" , 
"departure_time" : "10:44:33" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "10:46:28" , 
"departure_time" : "10:47:36" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "10:50:08" , 
"departure_time" : "10:51:24" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "10:54:16" , 
"departure_time" : "10:55:03" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "10:59:47" , 
"departure_time" : "11:00:02" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "11:04:15" , 
"departure_time" : "11:04:20" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "11:08:05" , 
"departure_time" : "11:09:07" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "11:13:02" , 
"departure_time" : "11:13:19" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "11:15:17" , 
"departure_time" : "11:15:41" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "11:19:24" , 
"departure_time" : "11:19:30" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "11:23:06" , 
"departure_time" : "11:24:37" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "11:29:31" , 
"departure_time" : "11:30:42" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "11:32:11" , 
"departure_time" : "11:33:15" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "11:35:04" , 
"departure_time" : "11:36:36" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "11:41:32" , 
"departure_time" : "11:41:32" , 
"distance_traveled" : 30.7256
} ], 
"1571" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "25:32:00" , 
"departure_time" : "25:33:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "25:42:17" , 
"departure_time" : "25:43:03" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "25:48:46" , 
"departure_time" : "25:49:48" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "25:52:02" , 
"departure_time" : "25:53:12" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "25:54:10" , 
"departure_time" : "25:54:37" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "25:56:27" , 
"departure_time" : "25:57:31" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "26:00:04" , 
"departure_time" : "26:00:14" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "26:05:10" , 
"departure_time" : "26:06:16" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "26:10:06" , 
"departure_time" : "26:10:18" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "26:13:12" , 
"departure_time" : "26:14:22" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "26:18:10" , 
"departure_time" : "26:18:22" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "26:20:12" , 
"departure_time" : "26:21:52" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "26:24:40" , 
"departure_time" : "26:24:53" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "26:27:13" , 
"departure_time" : "26:28:45" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "26:32:32" , 
"departure_time" : "26:33:45" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "26:35:13" , 
"departure_time" : "26:36:28" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "26:38:15" , 
"departure_time" : "26:39:33" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "26:42:18" , 
"departure_time" : "26:42:18" , 
"distance_traveled" : 30.7256
} ], 
"1572" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "11:25:00" , 
"departure_time" : "11:27:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "11:36:25" , 
"departure_time" : "11:36:54" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "11:41:29" , 
"departure_time" : "11:42:20" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "11:44:51" , 
"departure_time" : "11:46:12" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "11:47:21" , 
"departure_time" : "11:48:26" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "11:50:05" , 
"departure_time" : "11:50:52" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "11:53:47" , 
"departure_time" : "11:54:10" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "11:59:23" , 
"departure_time" : "12:00:02" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "12:04:39" , 
"departure_time" : "12:05:52" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "12:09:13" , 
"departure_time" : "12:10:51" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "12:13:38" , 
"departure_time" : "12:14:46" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "12:16:08" , 
"departure_time" : "12:16:11" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "12:19:03" , 
"departure_time" : "12:19:39" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "12:23:36" , 
"departure_time" : "12:24:16" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "12:28:40" , 
"departure_time" : "12:29:51" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "12:32:11" , 
"departure_time" : "12:32:41" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "12:34:30" , 
"departure_time" : "12:35:26" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "12:40:56" , 
"departure_time" : "12:40:56" , 
"distance_traveled" : 30.7256
} ], 
"1573" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "12:25:00" , 
"departure_time" : "12:26:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "12:35:57" , 
"departure_time" : "12:37:17" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "12:42:20" , 
"departure_time" : "12:43:19" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "12:44:59" , 
"departure_time" : "12:45:44" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "12:46:45" , 
"departure_time" : "12:47:47" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "12:50:02" , 
"departure_time" : "12:50:22" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "12:53:20" , 
"departure_time" : "12:54:45" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "13:00:25" , 
"departure_time" : "13:01:58" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "13:05:33" , 
"departure_time" : "13:06:58" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "13:09:25" , 
"departure_time" : "13:10:48" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "13:13:23" , 
"departure_time" : "13:14:45" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "13:16:22" , 
"departure_time" : "13:16:34" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "13:19:12" , 
"departure_time" : "13:20:25" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "13:24:13" , 
"departure_time" : "13:24:47" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "13:28:34" , 
"departure_time" : "13:29:50" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "13:32:16" , 
"departure_time" : "13:33:15" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "13:34:59" , 
"departure_time" : "13:35:39" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "13:40:40" , 
"departure_time" : "13:40:40" , 
"distance_traveled" : 30.7256
} ], 
"1574" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "06:25:00" , 
"departure_time" : "06:26:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "06:36:07" , 
"departure_time" : "06:36:28" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "06:41:21" , 
"departure_time" : "06:42:06" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "06:44:45" , 
"departure_time" : "06:45:55" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "06:47:10" , 
"departure_time" : "06:48:38" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "06:50:28" , 
"departure_time" : "06:51:59" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "06:54:31" , 
"departure_time" : "06:55:27" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "06:59:56" , 
"departure_time" : "07:01:16" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "07:05:20" , 
"departure_time" : "07:06:53" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "07:09:33" , 
"departure_time" : "07:09:58" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "07:12:25" , 
"departure_time" : "07:13:29" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "07:16:04" , 
"departure_time" : "07:16:59" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "07:19:55" , 
"departure_time" : "07:20:12" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "07:23:17" , 
"departure_time" : "07:24:21" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "07:29:04" , 
"departure_time" : "07:29:17" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "07:31:13" , 
"departure_time" : "07:31:33" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "07:34:20" , 
"departure_time" : "07:34:29" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "07:40:09" , 
"departure_time" : "07:40:09" , 
"distance_traveled" : 30.7256
} ], 
"1575" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "13:25:00" , 
"departure_time" : "13:25:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "13:35:16" , 
"departure_time" : "13:35:22" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "13:41:06" , 
"departure_time" : "13:41:16" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "13:44:10" , 
"departure_time" : "13:45:30" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "13:47:20" , 
"departure_time" : "13:48:39" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "13:50:19" , 
"departure_time" : "13:51:15" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "13:53:56" , 
"departure_time" : "13:54:40" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "13:59:44" , 
"departure_time" : "14:00:51" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "14:05:07" , 
"departure_time" : "14:05:30" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "14:08:23" , 
"departure_time" : "14:08:41" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "14:12:18" , 
"departure_time" : "14:12:45" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "14:15:27" , 
"departure_time" : "14:16:34" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "14:20:07" , 
"departure_time" : "14:21:31" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "14:24:24" , 
"departure_time" : "14:24:43" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "14:28:19" , 
"departure_time" : "14:29:54" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "14:32:35" , 
"departure_time" : "14:33:35" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "14:35:00" , 
"departure_time" : "14:35:13" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "14:40:13" , 
"departure_time" : "14:40:13" , 
"distance_traveled" : 30.7256
} ], 
"1576" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "07:25:00" , 
"departure_time" : "07:25:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:35:03" , 
"departure_time" : "07:35:56" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "07:41:53" , 
"departure_time" : "07:43:15" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "07:45:22" , 
"departure_time" : "07:46:35" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "07:47:13" , 
"departure_time" : "07:48:43" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "07:50:30" , 
"departure_time" : "07:51:00" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "07:53:30" , 
"departure_time" : "07:54:53" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "08:00:23" , 
"departure_time" : "08:01:48" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "08:05:25" , 
"departure_time" : "08:06:19" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "08:08:54" , 
"departure_time" : "08:10:19" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "08:13:25" , 
"departure_time" : "08:13:27" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "08:15:02" , 
"departure_time" : "08:15:14" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "08:19:12" , 
"departure_time" : "08:19:20" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "08:23:08" , 
"departure_time" : "08:24:26" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "08:29:18" , 
"departure_time" : "08:30:11" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "08:31:53" , 
"departure_time" : "08:32:02" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "08:34:09" , 
"departure_time" : "08:34:11" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "08:40:02" , 
"departure_time" : "08:40:02" , 
"distance_traveled" : 30.7256
} ], 
"1577" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "14:25:00" , 
"departure_time" : "14:25:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "14:35:18" , 
"departure_time" : "14:35:59" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "14:41:41" , 
"departure_time" : "14:42:36" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "14:44:55" , 
"departure_time" : "14:45:00" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "14:46:05" , 
"departure_time" : "14:47:05" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "14:50:00" , 
"departure_time" : "14:51:38" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "14:54:38" , 
"departure_time" : "14:55:47" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "15:00:09" , 
"departure_time" : "15:00:20" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "15:04:11" , 
"departure_time" : "15:04:46" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "15:08:35" , 
"departure_time" : "15:09:55" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "15:13:20" , 
"departure_time" : "15:14:35" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "15:16:15" , 
"departure_time" : "15:17:43" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "15:20:28" , 
"departure_time" : "15:21:36" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "15:24:08" , 
"departure_time" : "15:24:21" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "15:28:13" , 
"departure_time" : "15:28:34" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "15:31:21" , 
"departure_time" : "15:31:42" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "15:34:21" , 
"departure_time" : "15:34:23" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "15:40:02" , 
"departure_time" : "15:40:02" , 
"distance_traveled" : 30.7256
} ], 
"1578" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "08:25:00" , 
"departure_time" : "08:25:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:35:10" , 
"departure_time" : "08:35:19" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "08:41:09" , 
"departure_time" : "08:42:36" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "08:45:27" , 
"departure_time" : "08:47:02" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "08:47:35" , 
"departure_time" : "08:48:37" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "08:50:02" , 
"departure_time" : "08:51:31" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "08:54:29" , 
"departure_time" : "08:55:54" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "09:00:25" , 
"departure_time" : "09:01:32" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "09:05:07" , 
"departure_time" : "09:05:11" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "09:08:04" , 
"departure_time" : "09:08:42" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "09:12:38" , 
"departure_time" : "09:12:50" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "09:15:12" , 
"departure_time" : "09:15:42" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "09:19:30" , 
"departure_time" : "09:21:05" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "09:24:35" , 
"departure_time" : "09:25:05" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "09:28:30" , 
"departure_time" : "09:29:43" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "09:32:13" , 
"departure_time" : "09:32:17" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "09:34:04" , 
"departure_time" : "09:35:42" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "09:41:38" , 
"departure_time" : "09:41:38" , 
"distance_traveled" : 30.7256
} ], 
"1579" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "15:25:00" , 
"departure_time" : "15:27:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "15:35:48" , 
"departure_time" : "15:35:59" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "15:41:11" , 
"departure_time" : "15:42:06" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "15:44:55" , 
"departure_time" : "15:45:36" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "15:46:41" , 
"departure_time" : "15:47:38" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "15:49:57" , 
"departure_time" : "15:51:31" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "15:53:34" , 
"departure_time" : "15:53:39" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "15:59:05" , 
"departure_time" : "16:00:04" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "16:03:59" , 
"departure_time" : "16:04:09" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "16:07:10" , 
"departure_time" : "16:08:37" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "16:12:27" , 
"departure_time" : "16:12:40" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "16:15:13" , 
"departure_time" : "16:16:50" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "16:19:37" , 
"departure_time" : "16:20:35" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "16:22:58" , 
"departure_time" : "16:23:14" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "16:27:16" , 
"departure_time" : "16:27:28" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "16:30:12" , 
"departure_time" : "16:30:37" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "16:33:25" , 
"departure_time" : "16:33:29" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "16:39:04" , 
"departure_time" : "16:39:04" , 
"distance_traveled" : 30.7256
} ], 
"1580" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "09:25:00" , 
"departure_time" : "09:26:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:36:14" , 
"departure_time" : "09:36:40" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "09:41:26" , 
"departure_time" : "09:42:31" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "09:45:05" , 
"departure_time" : "09:46:29" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "09:47:24" , 
"departure_time" : "09:47:53" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "09:49:29" , 
"departure_time" : "09:50:27" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "09:53:58" , 
"departure_time" : "09:55:08" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "10:00:10" , 
"departure_time" : "10:00:57" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "10:04:47" , 
"departure_time" : "10:05:27" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "10:08:40" , 
"departure_time" : "10:08:51" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "10:12:11" , 
"departure_time" : "10:13:11" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "10:16:00" , 
"departure_time" : "10:17:32" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "10:20:32" , 
"departure_time" : "10:22:08" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "10:24:36" , 
"departure_time" : "10:25:25" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "10:28:49" , 
"departure_time" : "10:30:23" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "10:32:34" , 
"departure_time" : "10:32:46" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "10:34:12" , 
"departure_time" : "10:35:18" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "10:41:06" , 
"departure_time" : "10:41:06" , 
"distance_traveled" : 30.7256
} ], 
"1581" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:25:00" , 
"departure_time" : "16:27:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:36:08" , 
"departure_time" : "16:37:15" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "16:42:07" , 
"departure_time" : "16:42:47" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "16:44:40" , 
"departure_time" : "16:45:21" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "16:47:41" , 
"departure_time" : "16:48:53" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "16:51:12" , 
"departure_time" : "16:52:02" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "16:53:50" , 
"departure_time" : "16:55:25" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "17:01:35" , 
"departure_time" : "17:01:58" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "17:04:23" , 
"departure_time" : "17:05:01" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "17:08:38" , 
"departure_time" : "17:09:25" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "17:12:47" , 
"departure_time" : "17:14:15" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "17:17:28" , 
"departure_time" : "17:18:37" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "17:20:09" , 
"departure_time" : "17:21:30" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "17:24:21" , 
"departure_time" : "17:25:21" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "17:29:00" , 
"departure_time" : "17:30:00" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "17:32:00" , 
"departure_time" : "17:33:10" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "17:35:10" , 
"departure_time" : "17:35:54" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "17:39:44" , 
"departure_time" : "17:39:44" , 
"distance_traveled" : 30.7256
} ], 
"1582" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "10:25:00" , 
"departure_time" : "10:26:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "10:36:01" , 
"departure_time" : "10:37:31" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "10:42:30" , 
"departure_time" : "10:42:45" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "10:44:15" , 
"departure_time" : "10:45:24" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "10:47:09" , 
"departure_time" : "10:47:56" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "10:49:47" , 
"departure_time" : "10:50:16" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "10:53:29" , 
"departure_time" : "10:54:36" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "11:00:07" , 
"departure_time" : "11:01:31" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "11:05:24" , 
"departure_time" : "11:05:39" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "11:08:15" , 
"departure_time" : "11:08:51" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "11:12:36" , 
"departure_time" : "11:13:22" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "11:15:46" , 
"departure_time" : "11:15:59" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "11:19:13" , 
"departure_time" : "11:20:08" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "11:23:55" , 
"departure_time" : "11:24:43" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "11:28:48" , 
"departure_time" : "11:30:19" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "11:32:31" , 
"departure_time" : "11:32:56" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "11:34:25" , 
"departure_time" : "11:35:35" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "11:41:10" , 
"departure_time" : "11:41:10" , 
"distance_traveled" : 30.7256
} ], 
"1583" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:25:00" , 
"departure_time" : "17:27:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:36:35" , 
"departure_time" : "17:36:53" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "17:41:18" , 
"departure_time" : "17:42:22" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "17:45:04" , 
"departure_time" : "17:45:17" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "17:46:13" , 
"departure_time" : "17:46:25" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "17:49:12" , 
"departure_time" : "17:49:32" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "17:53:20" , 
"departure_time" : "17:53:31" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "17:59:11" , 
"departure_time" : "18:00:33" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "18:05:22" , 
"departure_time" : "18:06:27" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "18:09:05" , 
"departure_time" : "18:10:27" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:13:22" , 
"departure_time" : "18:13:26" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "18:15:04" , 
"departure_time" : "18:16:28" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "18:20:24" , 
"departure_time" : "18:21:59" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "18:24:35" , 
"departure_time" : "18:25:01" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "18:28:26" , 
"departure_time" : "18:28:54" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "18:31:28" , 
"departure_time" : "18:31:44" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "18:34:16" , 
"departure_time" : "18:35:41" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "18:41:25" , 
"departure_time" : "18:41:25" , 
"distance_traveled" : 30.7256
} ], 
"1584" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "11:25:00" , 
"departure_time" : "11:27:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "11:36:11" , 
"departure_time" : "11:36:39" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "11:41:28" , 
"departure_time" : "11:42:16" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "11:44:48" , 
"departure_time" : "11:46:01" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "11:47:13" , 
"departure_time" : "11:47:51" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "11:49:38" , 
"departure_time" : "11:50:06" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "11:53:28" , 
"departure_time" : "11:54:51" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "12:00:23" , 
"departure_time" : "12:00:41" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "12:04:18" , 
"departure_time" : "12:05:52" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "12:09:34" , 
"departure_time" : "12:10:18" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "12:12:44" , 
"departure_time" : "12:14:24" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "12:16:40" , 
"departure_time" : "12:17:30" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "12:19:50" , 
"departure_time" : "12:19:51" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "12:23:01" , 
"departure_time" : "12:23:07" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "12:28:06" , 
"departure_time" : "12:29:23" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "12:32:17" , 
"departure_time" : "12:33:45" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "12:35:28" , 
"departure_time" : "12:36:19" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "12:40:51" , 
"departure_time" : "12:40:51" , 
"distance_traveled" : 30.7256
} ], 
"1585" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:25:00" , 
"departure_time" : "18:26:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:35:38" , 
"departure_time" : "18:36:27" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "18:41:49" , 
"departure_time" : "18:42:08" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "18:44:19" , 
"departure_time" : "18:44:42" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "18:46:23" , 
"departure_time" : "18:47:44" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "18:50:21" , 
"departure_time" : "18:51:30" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "18:54:09" , 
"departure_time" : "18:54:49" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "18:59:40" , 
"departure_time" : "19:00:51" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "19:05:11" , 
"departure_time" : "19:06:10" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "19:08:59" , 
"departure_time" : "19:09:25" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "19:12:26" , 
"departure_time" : "19:12:44" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "19:15:18" , 
"departure_time" : "19:15:37" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "19:19:19" , 
"departure_time" : "19:19:52" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "19:23:33" , 
"departure_time" : "19:23:45" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "19:28:12" , 
"departure_time" : "19:28:44" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "19:31:32" , 
"departure_time" : "19:32:45" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "19:35:13" , 
"departure_time" : "19:36:41" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "19:41:28" , 
"departure_time" : "19:41:28" , 
"distance_traveled" : 30.7256
} ], 
"1586" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "12:25:00" , 
"departure_time" : "12:26:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "12:35:11" , 
"departure_time" : "12:36:04" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "12:41:53" , 
"departure_time" : "12:42:44" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "12:44:51" , 
"departure_time" : "12:46:14" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "12:47:23" , 
"departure_time" : "12:48:01" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "12:49:38" , 
"departure_time" : "12:50:37" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "12:53:59" , 
"departure_time" : "12:55:38" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "13:00:39" , 
"departure_time" : "13:01:08" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "13:04:29" , 
"departure_time" : "13:05:29" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "13:09:00" , 
"departure_time" : "13:09:34" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "13:12:34" , 
"departure_time" : "13:12:52" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "13:15:18" , 
"departure_time" : "13:16:27" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "13:20:09" , 
"departure_time" : "13:20:33" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "13:23:24" , 
"departure_time" : "13:23:41" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "13:28:17" , 
"departure_time" : "13:29:24" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "13:32:07" , 
"departure_time" : "13:33:38" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "13:35:31" , 
"departure_time" : "13:36:21" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "13:40:50" , 
"departure_time" : "13:40:50" , 
"distance_traveled" : 30.7256
} ], 
"1587" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "19:25:00" , 
"departure_time" : "19:26:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:35:18" , 
"departure_time" : "19:36:13" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "19:41:55" , 
"departure_time" : "19:43:27" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "19:45:32" , 
"departure_time" : "19:46:36" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "19:47:04" , 
"departure_time" : "19:48:16" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "19:50:12" , 
"departure_time" : "19:51:36" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "19:54:24" , 
"departure_time" : "19:55:50" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "20:00:26" , 
"departure_time" : "20:01:50" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "20:05:24" , 
"departure_time" : "20:07:03" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "20:09:39" , 
"departure_time" : "20:10:36" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "20:12:57" , 
"departure_time" : "20:14:20" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "20:16:23" , 
"departure_time" : "20:17:57" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "20:20:34" , 
"departure_time" : "20:20:54" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "20:23:20" , 
"departure_time" : "20:23:58" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "20:28:38" , 
"departure_time" : "20:30:00" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "20:32:22" , 
"departure_time" : "20:33:53" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "20:35:31" , 
"departure_time" : "20:35:56" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "20:40:25" , 
"departure_time" : "20:40:25" , 
"distance_traveled" : 30.7256
} ], 
"1588" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "13:25:00" , 
"departure_time" : "13:26:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "13:35:41" , 
"departure_time" : "13:36:03" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "13:41:22" , 
"departure_time" : "13:42:36" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "13:45:14" , 
"departure_time" : "13:46:52" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "13:47:38" , 
"departure_time" : "13:48:10" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "13:49:32" , 
"departure_time" : "13:49:36" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "13:53:04" , 
"departure_time" : "13:54:27" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "14:00:23" , 
"departure_time" : "14:01:16" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "14:04:53" , 
"departure_time" : "14:06:10" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "14:09:17" , 
"departure_time" : "14:10:30" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "14:13:13" , 
"departure_time" : "14:14:30" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "14:16:17" , 
"departure_time" : "14:17:10" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "14:19:53" , 
"departure_time" : "14:21:09" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "14:24:16" , 
"departure_time" : "14:25:06" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "14:28:50" , 
"departure_time" : "14:30:12" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "14:32:22" , 
"departure_time" : "14:32:50" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "14:34:28" , 
"departure_time" : "14:34:51" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "14:40:23" , 
"departure_time" : "14:40:23" , 
"distance_traveled" : 30.7256
} ], 
"1589" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "20:25:00" , 
"departure_time" : "20:26:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "20:36:26" , 
"departure_time" : "20:36:37" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "20:42:11" , 
"departure_time" : "20:43:38" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "20:45:27" , 
"departure_time" : "20:45:46" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "20:47:19" , 
"departure_time" : "20:48:09" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "20:50:50" , 
"departure_time" : "20:51:05" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "20:54:15" , 
"departure_time" : "20:55:15" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "21:01:00" , 
"departure_time" : "21:01:58" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "21:05:58" , 
"departure_time" : "21:07:29" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "21:10:31" , 
"departure_time" : "21:11:58" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "21:14:27" , 
"departure_time" : "21:14:34" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "21:17:07" , 
"departure_time" : "21:18:10" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "21:21:03" , 
"departure_time" : "21:21:10" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "21:24:07" , 
"departure_time" : "21:24:31" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "21:29:24" , 
"departure_time" : "21:30:18" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "21:32:54" , 
"departure_time" : "21:33:59" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "21:36:05" , 
"departure_time" : "21:36:38" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "21:40:33" , 
"departure_time" : "21:40:33" , 
"distance_traveled" : 30.7256
} ], 
"1590" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "14:25:00" , 
"departure_time" : "14:25:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "14:35:26" , 
"departure_time" : "14:37:00" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "14:42:34" , 
"departure_time" : "14:43:21" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "14:44:47" , 
"departure_time" : "14:45:42" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "14:46:55" , 
"departure_time" : "14:47:29" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "14:49:34" , 
"departure_time" : "14:49:43" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "14:53:09" , 
"departure_time" : "14:53:24" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "14:59:15" , 
"departure_time" : "15:00:12" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "15:04:57" , 
"departure_time" : "15:06:25" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "15:09:28" , 
"departure_time" : "15:09:52" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "15:12:24" , 
"departure_time" : "15:13:38" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "15:16:14" , 
"departure_time" : "15:16:43" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "15:19:29" , 
"departure_time" : "15:19:37" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "15:23:08" , 
"departure_time" : "15:23:37" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "15:28:29" , 
"departure_time" : "15:29:02" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "15:31:33" , 
"departure_time" : "15:32:33" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "15:35:00" , 
"departure_time" : "15:35:11" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "15:40:11" , 
"departure_time" : "15:40:11" , 
"distance_traveled" : 30.7256
} ], 
"1591" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "06:53:00" , 
"departure_time" : "06:54:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:05:28" , 
"departure_time" : "07:05:50" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "07:12:22" , 
"departure_time" : "07:12:44" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 121,
"arrival_time" : "07:18:22" , 
"departure_time" : "07:19:28" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "07:24:06" , 
"departure_time" : "07:25:03" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "07:26:57" , 
"departure_time" : "07:28:11" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "07:31:14" , 
"departure_time" : "07:32:22" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "07:34:08" , 
"departure_time" : "07:34:40" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "07:36:32" , 
"departure_time" : "07:37:58" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "07:41:26" , 
"departure_time" : "07:41:26" , 
"distance_traveled" : 22.3157
} ], 
"1592" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "15:25:00" , 
"departure_time" : "15:27:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "15:35:43" , 
"departure_time" : "15:36:56" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "15:42:13" , 
"departure_time" : "15:43:53" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "15:45:40" , 
"departure_time" : "15:45:57" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "15:46:17" , 
"departure_time" : "15:46:46" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "15:49:29" , 
"departure_time" : "15:49:49" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "15:52:20" , 
"departure_time" : "15:52:40" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "15:59:20" , 
"departure_time" : "16:00:21" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "16:04:01" , 
"departure_time" : "16:05:04" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "16:08:03" , 
"departure_time" : "16:09:40" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "16:12:37" , 
"departure_time" : "16:13:37" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "16:16:00" , 
"departure_time" : "16:16:53" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "16:18:53" , 
"departure_time" : "16:19:24" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "16:22:31" , 
"departure_time" : "16:22:42" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "16:27:11" , 
"departure_time" : "16:27:41" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "16:30:30" , 
"departure_time" : "16:31:30" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "16:34:00" , 
"departure_time" : "16:34:06" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "16:39:06" , 
"departure_time" : "16:39:06" , 
"distance_traveled" : 30.7256
} ], 
"1593" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "10:39:00" , 
"departure_time" : "10:39:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "10:50:31" , 
"departure_time" : "10:51:00" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "10:58:29" , 
"departure_time" : "10:58:31" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "11:02:02" , 
"departure_time" : "11:03:23" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "11:05:21" , 
"departure_time" : "11:06:36" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "11:08:15" , 
"departure_time" : "11:09:35" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "11:13:20" , 
"departure_time" : "11:13:39" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "11:15:19" , 
"departure_time" : "11:16:12" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "11:19:53" , 
"departure_time" : "11:20:43" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "11:22:50" , 
"departure_time" : "11:22:50" , 
"distance_traveled" : 19.8432
} ], 
"1594" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:25:00" , 
"departure_time" : "16:26:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:35:26" , 
"departure_time" : "16:36:30" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "16:42:04" , 
"departure_time" : "16:43:29" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "16:45:25" , 
"departure_time" : "16:46:34" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "16:48:09" , 
"departure_time" : "16:48:46" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "16:50:37" , 
"departure_time" : "16:51:54" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "16:54:17" , 
"departure_time" : "16:55:52" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "17:01:35" , 
"departure_time" : "17:02:07" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "17:04:32" , 
"departure_time" : "17:05:22" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "17:08:50" , 
"departure_time" : "17:10:28" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "17:13:38" , 
"departure_time" : "17:14:58" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "17:17:20" , 
"departure_time" : "17:18:08" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "17:19:48" , 
"departure_time" : "17:19:49" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "17:23:01" , 
"departure_time" : "17:23:35" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "17:28:34" , 
"departure_time" : "17:29:48" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "17:32:14" , 
"departure_time" : "17:33:45" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "17:35:31" , 
"departure_time" : "17:37:03" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "17:40:32" , 
"departure_time" : "17:40:32" , 
"distance_traveled" : 30.7256
} ], 
"1595" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "11:39:00" , 
"departure_time" : "11:41:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "11:50:48" , 
"departure_time" : "11:52:09" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "11:59:21" , 
"departure_time" : "11:59:50" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "12:01:29" , 
"departure_time" : "12:02:54" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "12:06:25" , 
"departure_time" : "12:06:58" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "12:07:33" , 
"departure_time" : "12:08:24" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "12:13:51" , 
"departure_time" : "12:13:53" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "12:16:02" , 
"departure_time" : "12:17:28" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "12:20:26" , 
"departure_time" : "12:20:56" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "12:22:30" , 
"departure_time" : "12:22:30" , 
"distance_traveled" : 19.8432
} ], 
"1596" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:25:00" , 
"departure_time" : "17:26:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:35:32" , 
"departure_time" : "17:35:51" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "17:41:19" , 
"departure_time" : "17:42:08" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "17:44:49" , 
"departure_time" : "17:45:11" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "17:46:22" , 
"departure_time" : "17:46:29" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "17:49:07" , 
"departure_time" : "17:49:56" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "17:53:49" , 
"departure_time" : "17:55:12" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "18:00:23" , 
"departure_time" : "18:00:33" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "18:04:10" , 
"departure_time" : "18:04:46" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "18:08:36" , 
"departure_time" : "18:09:41" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:13:05" , 
"departure_time" : "18:14:37" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "18:16:32" , 
"departure_time" : "18:18:03" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "18:20:31" , 
"departure_time" : "18:21:10" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "18:23:39" , 
"departure_time" : "18:25:15" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "18:29:36" , 
"departure_time" : "18:31:02" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "18:32:26" , 
"departure_time" : "18:32:30" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "18:34:04" , 
"departure_time" : "18:34:11" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "18:40:07" , 
"departure_time" : "18:40:07" , 
"distance_traveled" : 30.7256
} ], 
"1597" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "07:24:00" , 
"departure_time" : "07:24:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:35:07" , 
"departure_time" : "07:35:10" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "07:43:03" , 
"departure_time" : "07:43:29" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 121,
"arrival_time" : "07:49:26" , 
"departure_time" : "07:49:28" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "07:54:02" , 
"departure_time" : "07:55:32" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "07:58:30" , 
"departure_time" : "08:00:06" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "08:01:36" , 
"departure_time" : "08:02:43" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "08:05:07" , 
"departure_time" : "08:06:41" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "08:08:34" , 
"departure_time" : "08:09:42" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "08:11:08" , 
"departure_time" : "08:11:08" , 
"distance_traveled" : 22.3157
} ], 
"1598" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:25:00" , 
"departure_time" : "18:27:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:36:11" , 
"departure_time" : "18:36:52" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "18:41:41" , 
"departure_time" : "18:42:40" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "18:44:59" , 
"departure_time" : "18:45:32" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "18:46:33" , 
"departure_time" : "18:47:44" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "18:50:11" , 
"departure_time" : "18:50:23" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "18:53:12" , 
"departure_time" : "18:54:13" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "19:00:01" , 
"departure_time" : "19:01:08" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "19:05:07" , 
"departure_time" : "19:05:24" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "19:08:17" , 
"departure_time" : "19:09:14" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "19:12:57" , 
"departure_time" : "19:14:31" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "19:16:34" , 
"departure_time" : "19:17:30" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "19:19:56" , 
"departure_time" : "19:20:10" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "19:23:14" , 
"departure_time" : "19:24:23" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "19:29:09" , 
"departure_time" : "19:30:20" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "19:32:11" , 
"departure_time" : "19:33:24" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "19:35:13" , 
"departure_time" : "19:36:38" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "19:41:25" , 
"departure_time" : "19:41:25" , 
"distance_traveled" : 30.7256
} ], 
"1599" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:26:00" , 
"departure_time" : "16:27:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:37:21" , 
"departure_time" : "16:38:37" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "16:45:16" , 
"departure_time" : "16:45:48" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "16:47:32" , 
"departure_time" : "16:48:45" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "16:51:13" , 
"departure_time" : "16:51:39" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "16:53:26" , 
"departure_time" : "16:54:17" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "16:56:51" , 
"departure_time" : "16:58:26" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "17:03:35" , 
"departure_time" : "17:04:51" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "17:07:16" , 
"departure_time" : "17:07:27" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "17:10:11" , 
"departure_time" : "17:11:27" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "17:15:16" , 
"departure_time" : "17:15:16" , 
"distance_traveled" : 21.0006
} ], 
"1600" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "19:25:00" , 
"departure_time" : "19:26:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:35:31" , 
"departure_time" : "19:36:42" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "19:42:11" , 
"departure_time" : "19:42:32" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "19:44:21" , 
"departure_time" : "19:45:29" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "19:47:08" , 
"departure_time" : "19:48:10" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "19:50:02" , 
"departure_time" : "19:51:12" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "19:54:10" , 
"departure_time" : "19:54:56" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "19:59:46" , 
"departure_time" : "20:00:54" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "20:05:08" , 
"departure_time" : "20:06:34" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "20:09:26" , 
"departure_time" : "20:10:39" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "20:13:13" , 
"departure_time" : "20:13:39" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "20:15:26" , 
"departure_time" : "20:16:47" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "20:20:21" , 
"departure_time" : "20:21:53" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "20:24:32" , 
"departure_time" : "20:25:48" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "20:29:16" , 
"departure_time" : "20:30:55" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "20:32:39" , 
"departure_time" : "20:34:15" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "20:35:36" , 
"departure_time" : "20:35:45" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "20:40:09" , 
"departure_time" : "20:40:09" , 
"distance_traveled" : 30.7256
} ], 
"1601" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:23:00" , 
"departure_time" : "16:24:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:35:18" , 
"departure_time" : "16:35:42" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 131,
"arrival_time" : "16:55:24" , 
"departure_time" : "16:56:07" , 
"distance_traveled" : 20.9674
}, 
{ 
"stop_id" : 64,
"arrival_time" : "16:58:43" , 
"departure_time" : "16:59:13" , 
"distance_traveled" : 22.1951
}, 
{ 
"stop_id" : 151,
"arrival_time" : "17:02:30" , 
"departure_time" : "17:02:53" , 
"distance_traveled" : 23.4371
}, 
{ 
"stop_id" : 3,
"arrival_time" : "17:06:23" , 
"departure_time" : "17:07:26" , 
"distance_traveled" : 24.7769
}, 
{ 
"stop_id" : 128,
"arrival_time" : "17:11:03" , 
"departure_time" : "17:12:36" , 
"distance_traveled" : 26.6597
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "17:14:33" , 
"departure_time" : "17:14:59" , 
"distance_traveled" : 27.9782
}, 
{ 
"stop_id" : 78,
"arrival_time" : "17:16:26" , 
"departure_time" : "17:17:30" , 
"distance_traveled" : 29.315
}, 
{ 
"stop_id" : 144,
"arrival_time" : "17:21:04" , 
"departure_time" : "17:21:04" , 
"distance_traveled" : 30.6924
} ], 
"1602" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "20:25:00" , 
"departure_time" : "20:27:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "20:36:02" , 
"departure_time" : "20:37:31" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "20:43:29" , 
"departure_time" : "20:44:15" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "20:44:46" , 
"departure_time" : "20:44:47" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "20:47:01" , 
"departure_time" : "20:47:26" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "20:50:25" , 
"departure_time" : "20:52:02" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "20:55:37" , 
"departure_time" : "20:56:19" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "21:00:42" , 
"departure_time" : "21:01:26" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "21:05:44" , 
"departure_time" : "21:07:03" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "21:10:19" , 
"departure_time" : "21:11:38" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "21:14:19" , 
"departure_time" : "21:15:28" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "21:18:09" , 
"departure_time" : "21:18:59" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "21:20:50" , 
"departure_time" : "21:21:19" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "21:24:29" , 
"departure_time" : "21:25:45" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "21:30:16" , 
"departure_time" : "21:31:23" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "21:33:07" , 
"departure_time" : "21:33:23" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "21:35:16" , 
"departure_time" : "21:35:59" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "21:40:43" , 
"departure_time" : "21:40:43" , 
"distance_traveled" : 30.7256
} ], 
"1603" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:23:00" , 
"departure_time" : "18:23:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:34:03" , 
"departure_time" : "18:34:46" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:55:43" , 
"departure_time" : "18:57:02" , 
"distance_traveled" : 20.9674
}, 
{ 
"stop_id" : 64,
"arrival_time" : "19:01:19" , 
"departure_time" : "19:02:11" , 
"distance_traveled" : 22.1951
}, 
{ 
"stop_id" : 151,
"arrival_time" : "19:04:52" , 
"departure_time" : "19:05:28" , 
"distance_traveled" : 23.4371
}, 
{ 
"stop_id" : 3,
"arrival_time" : "19:09:36" , 
"departure_time" : "19:10:48" , 
"distance_traveled" : 24.7769
}, 
{ 
"stop_id" : 128,
"arrival_time" : "19:15:12" , 
"departure_time" : "19:15:58" , 
"distance_traveled" : 26.6597
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "19:17:46" , 
"departure_time" : "19:19:04" , 
"distance_traveled" : 27.9782
}, 
{ 
"stop_id" : 78,
"arrival_time" : "19:22:18" , 
"departure_time" : "19:23:58" , 
"distance_traveled" : 29.315
}, 
{ 
"stop_id" : 144,
"arrival_time" : "19:25:40" , 
"departure_time" : "19:25:40" , 
"distance_traveled" : 30.6924
} ], 
"1604" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "06:53:00" , 
"departure_time" : "06:56:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:05:34" , 
"departure_time" : "07:05:36" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "07:12:02" , 
"departure_time" : "07:13:23" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 121,
"arrival_time" : "07:19:21" , 
"departure_time" : "07:20:45" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "07:24:24" , 
"departure_time" : "07:25:00" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "07:26:36" , 
"departure_time" : "07:27:15" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "07:30:39" , 
"departure_time" : "07:31:00" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "07:33:21" , 
"departure_time" : "07:34:24" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "07:37:03" , 
"departure_time" : "07:37:34" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "07:40:31" , 
"departure_time" : "07:40:31" , 
"distance_traveled" : 22.3157
} ], 
"1605" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:02:00" , 
"departure_time" : "18:03:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:14:09" , 
"departure_time" : "18:15:18" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "18:23:09" , 
"departure_time" : "18:24:35" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "18:27:26" , 
"departure_time" : "18:28:13" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 121,
"arrival_time" : "18:31:47" , 
"departure_time" : "18:32:20" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "18:36:33" , 
"departure_time" : "18:36:34" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "18:40:01" , 
"departure_time" : "18:41:06" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "18:45:05" , 
"departure_time" : "18:45:54" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:48:49" , 
"departure_time" : "18:48:52" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "18:52:03" , 
"departure_time" : "18:52:38" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "18:55:35" , 
"departure_time" : "18:55:35" , 
"distance_traveled" : 22.3157
} ], 
"1606" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "10:39:00" , 
"departure_time" : "10:40:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "10:50:25" , 
"departure_time" : "10:51:38" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "10:59:13" , 
"departure_time" : "11:00:00" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "11:02:47" , 
"departure_time" : "11:03:59" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "11:05:12" , 
"departure_time" : "11:05:22" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "11:07:10" , 
"departure_time" : "11:08:25" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "11:13:15" , 
"departure_time" : "11:14:54" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "11:16:39" , 
"departure_time" : "11:17:53" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "11:20:14" , 
"departure_time" : "11:20:43" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "11:22:29" , 
"departure_time" : "11:22:29" , 
"distance_traveled" : 19.8432
} ], 
"1607" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:51:00" , 
"departure_time" : "16:53:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:03:34" , 
"departure_time" : "17:04:39" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 126,
"arrival_time" : "17:20:05" , 
"departure_time" : "17:21:39" , 
"distance_traveled" : 16.8733
}, 
{ 
"stop_id" : 51,
"arrival_time" : "17:24:34" , 
"departure_time" : "17:26:14" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "17:27:40" , 
"departure_time" : "17:29:11" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "17:31:31" , 
"departure_time" : "17:32:34" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "17:34:03" , 
"departure_time" : "17:34:46" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "17:37:43" , 
"departure_time" : "17:38:19" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "17:42:36" , 
"departure_time" : "17:43:45" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "17:45:09" , 
"departure_time" : "17:46:16" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "17:49:07" , 
"departure_time" : "17:50:33" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "17:52:26" , 
"departure_time" : "17:52:26" , 
"distance_traveled" : 29.571
} ], 
"1608" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "11:39:00" , 
"departure_time" : "11:41:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "11:51:04" , 
"departure_time" : "11:51:30" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "11:58:26" , 
"departure_time" : "11:58:34" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "12:01:08" , 
"departure_time" : "12:01:59" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "12:05:51" , 
"departure_time" : "12:06:47" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "12:07:56" , 
"departure_time" : "12:07:58" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "12:13:02" , 
"departure_time" : "12:13:31" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "12:16:29" , 
"departure_time" : "12:17:14" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "12:19:45" , 
"departure_time" : "12:20:19" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "12:22:34" , 
"departure_time" : "12:22:34" , 
"distance_traveled" : 19.8432
} ], 
"1609" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:20:00" , 
"departure_time" : "17:20:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:31:19" , 
"departure_time" : "17:31:54" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 126,
"arrival_time" : "17:49:35" , 
"departure_time" : "17:49:47" , 
"distance_traveled" : 16.8733
}, 
{ 
"stop_id" : 51,
"arrival_time" : "17:53:12" , 
"departure_time" : "17:53:50" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "17:57:38" , 
"departure_time" : "17:58:39" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "18:02:01" , 
"departure_time" : "18:02:10" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "18:04:09" , 
"departure_time" : "18:04:57" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "18:08:48" , 
"departure_time" : "18:09:10" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "18:13:22" , 
"departure_time" : "18:14:28" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "18:17:06" , 
"departure_time" : "18:17:38" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "18:20:32" , 
"departure_time" : "18:21:20" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "18:23:48" , 
"departure_time" : "18:23:48" , 
"distance_traveled" : 29.571
} ], 
"1610" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "07:24:00" , 
"departure_time" : "07:26:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:36:37" , 
"departure_time" : "07:36:44" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "07:43:07" , 
"departure_time" : "07:43:19" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 121,
"arrival_time" : "07:49:12" , 
"departure_time" : "07:50:17" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "07:55:05" , 
"departure_time" : "07:56:00" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "07:57:55" , 
"departure_time" : "07:59:22" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "08:01:27" , 
"departure_time" : "08:02:42" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "08:05:15" , 
"departure_time" : "08:05:33" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "08:07:18" , 
"departure_time" : "08:07:22" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "08:10:04" , 
"departure_time" : "08:10:04" , 
"distance_traveled" : 22.3157
} ], 
"1611" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:49:00" , 
"departure_time" : "17:49:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:00:11" , 
"departure_time" : "18:00:51" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 126,
"arrival_time" : "18:18:40" , 
"departure_time" : "18:19:26" , 
"distance_traveled" : 16.8733
}, 
{ 
"stop_id" : 51,
"arrival_time" : "18:22:46" , 
"departure_time" : "18:23:53" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:27:07" , 
"departure_time" : "18:27:44" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "18:30:37" , 
"departure_time" : "18:30:51" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "18:33:14" , 
"departure_time" : "18:33:15" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "18:38:01" , 
"departure_time" : "18:39:11" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "18:44:10" , 
"departure_time" : "18:44:21" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "18:46:11" , 
"departure_time" : "18:47:01" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "18:49:50" , 
"departure_time" : "18:50:47" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "18:53:57" , 
"departure_time" : "18:53:57" , 
"distance_traveled" : 29.571
} ], 
"1612" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:26:00" , 
"departure_time" : "16:28:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:38:11" , 
"departure_time" : "16:38:18" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "16:44:07" , 
"departure_time" : "16:45:27" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "16:48:20" , 
"departure_time" : "16:48:26" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "16:50:06" , 
"departure_time" : "16:50:55" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "16:53:49" , 
"departure_time" : "16:54:47" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "16:56:58" , 
"departure_time" : "16:58:06" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "17:03:08" , 
"departure_time" : "17:04:08" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "17:07:00" , 
"departure_time" : "17:08:27" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "17:11:27" , 
"departure_time" : "17:12:34" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "17:15:07" , 
"departure_time" : "17:15:07" , 
"distance_traveled" : 21.0006
} ], 
"1613" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "08:30:00" , 
"departure_time" : "08:32:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:42:08" , 
"departure_time" : "08:42:34" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "08:49:26" , 
"departure_time" : "08:50:39" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "08:53:13" , 
"departure_time" : "08:54:11" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "08:56:58" , 
"departure_time" : "08:57:56" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "08:58:58" , 
"departure_time" : "09:00:10" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "09:05:12" , 
"departure_time" : "09:05:46" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "09:08:34" , 
"departure_time" : "09:09:12" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "09:11:38" , 
"departure_time" : "09:12:29" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "09:16:51" , 
"departure_time" : "09:17:27" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "09:19:36" , 
"departure_time" : "09:21:10" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "09:24:34" , 
"departure_time" : "09:24:34" , 
"distance_traveled" : 22.3157
} ], 
"1614" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:23:00" , 
"departure_time" : "16:24:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:34:02" , 
"departure_time" : "16:34:16" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 131,
"arrival_time" : "16:55:14" , 
"departure_time" : "16:55:29" , 
"distance_traveled" : 20.9674
}, 
{ 
"stop_id" : 64,
"arrival_time" : "16:58:15" , 
"departure_time" : "16:59:05" , 
"distance_traveled" : 22.1951
}, 
{ 
"stop_id" : 151,
"arrival_time" : "17:02:50" , 
"departure_time" : "17:02:53" , 
"distance_traveled" : 23.4371
}, 
{ 
"stop_id" : 3,
"arrival_time" : "17:06:03" , 
"departure_time" : "17:06:34" , 
"distance_traveled" : 24.7769
}, 
{ 
"stop_id" : 128,
"arrival_time" : "17:10:31" , 
"departure_time" : "17:11:02" , 
"distance_traveled" : 26.6597
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "17:13:31" , 
"departure_time" : "17:14:24" , 
"distance_traveled" : 27.9782
}, 
{ 
"stop_id" : 78,
"arrival_time" : "17:16:53" , 
"departure_time" : "17:17:27" , 
"distance_traveled" : 29.315
}, 
{ 
"stop_id" : 144,
"arrival_time" : "17:20:34" , 
"departure_time" : "17:20:34" , 
"distance_traveled" : 30.6924
} ], 
"1615" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:19:00" , 
"departure_time" : "16:19:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:30:07" , 
"departure_time" : "16:31:31" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "16:39:24" , 
"departure_time" : "16:39:40" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "16:41:16" , 
"departure_time" : "16:42:28" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "16:46:12" , 
"departure_time" : "16:47:00" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "16:47:48" , 
"departure_time" : "16:49:25" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "16:54:37" , 
"departure_time" : "16:55:56" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "16:58:19" , 
"departure_time" : "16:58:58" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "17:00:39" , 
"departure_time" : "17:02:16" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "17:05:37" , 
"departure_time" : "17:05:40" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "17:07:03" , 
"departure_time" : "17:07:30" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "17:09:27" , 
"departure_time" : "17:09:27" , 
"distance_traveled" : 22.3157
} ], 
"1616" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:23:00" , 
"departure_time" : "18:24:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:34:40" , 
"departure_time" : "18:35:06" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:55:26" , 
"departure_time" : "18:56:36" , 
"distance_traveled" : 20.9674
}, 
{ 
"stop_id" : 64,
"arrival_time" : "19:01:10" , 
"departure_time" : "19:01:59" , 
"distance_traveled" : 22.1951
}, 
{ 
"stop_id" : 151,
"arrival_time" : "19:04:49" , 
"departure_time" : "19:05:11" , 
"distance_traveled" : 23.4371
}, 
{ 
"stop_id" : 3,
"arrival_time" : "19:09:22" , 
"departure_time" : "19:10:10" , 
"distance_traveled" : 24.7769
}, 
{ 
"stop_id" : 128,
"arrival_time" : "19:14:48" , 
"departure_time" : "19:15:51" , 
"distance_traveled" : 26.6597
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "19:18:03" , 
"departure_time" : "19:19:40" , 
"distance_traveled" : 27.9782
}, 
{ 
"stop_id" : 78,
"arrival_time" : "19:22:37" , 
"departure_time" : "19:23:17" , 
"distance_traveled" : 29.315
}, 
{ 
"stop_id" : 144,
"arrival_time" : "19:24:40" , 
"departure_time" : "19:24:40" , 
"distance_traveled" : 30.6924
} ], 
"1617" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:27:00" , 
"departure_time" : "17:28:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:38:31" , 
"departure_time" : "17:38:43" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "17:47:12" , 
"departure_time" : "17:48:26" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "17:52:14" , 
"departure_time" : "17:52:52" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "17:54:38" , 
"departure_time" : "17:55:15" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "17:58:37" , 
"departure_time" : "17:59:26" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "18:03:49" , 
"departure_time" : "18:04:51" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "18:08:02" , 
"departure_time" : "18:09:00" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "18:11:58" , 
"departure_time" : "18:12:21" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:15:23" , 
"departure_time" : "18:16:54" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "18:19:31" , 
"departure_time" : "18:20:52" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "18:21:21" , 
"departure_time" : "18:21:21" , 
"distance_traveled" : 22.3157
} ], 
"1618" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:02:00" , 
"departure_time" : "18:04:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:13:56" , 
"departure_time" : "18:14:08" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "18:22:12" , 
"departure_time" : "18:22:33" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "18:26:21" , 
"departure_time" : "18:27:27" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 121,
"arrival_time" : "18:32:06" , 
"departure_time" : "18:33:33" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "18:37:27" , 
"departure_time" : "18:38:18" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "18:40:51" , 
"departure_time" : "18:41:14" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "18:44:23" , 
"departure_time" : "18:44:41" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:48:18" , 
"departure_time" : "18:49:41" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "18:53:23" , 
"departure_time" : "18:54:54" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "18:56:31" , 
"departure_time" : "18:56:31" , 
"distance_traveled" : 22.3157
} ], 
"1619" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "22:17:00" , 
"departure_time" : "22:19:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "22:28:57" , 
"departure_time" : "22:30:02" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "22:37:05" , 
"departure_time" : "22:37:42" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "22:39:37" , 
"departure_time" : "22:39:55" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "22:43:18" , 
"departure_time" : "22:44:03" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "22:45:45" , 
"departure_time" : "22:46:37" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "22:51:52" , 
"departure_time" : "22:52:05" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "22:54:13" , 
"departure_time" : "22:55:11" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "22:58:58" , 
"departure_time" : "23:00:07" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "23:02:09" , 
"departure_time" : "23:03:26" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "23:06:17" , 
"departure_time" : "23:07:14" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "23:07:57" , 
"departure_time" : "23:07:57" , 
"distance_traveled" : 22.3157
} ], 
"1620" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:51:00" , 
"departure_time" : "16:53:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:03:03" , 
"departure_time" : "17:04:42" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 126,
"arrival_time" : "17:20:39" , 
"departure_time" : "17:22:18" , 
"distance_traveled" : 16.8733
}, 
{ 
"stop_id" : 51,
"arrival_time" : "17:24:39" , 
"departure_time" : "17:25:25" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "17:26:46" , 
"departure_time" : "17:28:06" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "17:31:20" , 
"departure_time" : "17:31:35" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "17:33:15" , 
"departure_time" : "17:34:19" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "17:38:04" , 
"departure_time" : "17:38:22" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "17:42:18" , 
"departure_time" : "17:43:37" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "17:45:19" , 
"departure_time" : "17:46:32" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "17:49:13" , 
"departure_time" : "17:49:15" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "17:51:02" , 
"departure_time" : "17:51:02" , 
"distance_traveled" : 29.571
} ], 
"1621" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "09:31:00" , 
"departure_time" : "09:32:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:43:14" , 
"departure_time" : "09:44:02" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "09:48:48" , 
"departure_time" : "09:49:22" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "09:50:34" , 
"departure_time" : "09:50:55" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "09:53:21" , 
"departure_time" : "09:54:11" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "09:56:50" , 
"departure_time" : "09:57:55" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "10:00:05" , 
"departure_time" : "10:00:20" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "10:05:15" , 
"departure_time" : "10:05:29" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "10:10:14" , 
"departure_time" : "10:11:05" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "10:14:51" , 
"departure_time" : "10:16:19" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "10:19:28" , 
"departure_time" : "10:20:50" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "10:22:22" , 
"departure_time" : "10:23:32" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "10:26:10" , 
"departure_time" : "10:26:10" , 
"distance_traveled" : 23.4703
} ], 
"1622" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:20:00" , 
"departure_time" : "17:21:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:31:40" , 
"departure_time" : "17:33:07" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 126,
"arrival_time" : "17:50:27" , 
"departure_time" : "17:51:02" , 
"distance_traveled" : 16.8733
}, 
{ 
"stop_id" : 51,
"arrival_time" : "17:53:35" , 
"departure_time" : "17:53:54" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "17:57:19" , 
"departure_time" : "17:58:17" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "18:01:58" , 
"departure_time" : "18:03:08" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "18:05:10" , 
"departure_time" : "18:06:47" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "18:09:37" , 
"departure_time" : "18:10:08" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "18:13:31" , 
"departure_time" : "18:14:26" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "18:16:55" , 
"departure_time" : "18:17:13" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "18:20:18" , 
"departure_time" : "18:20:42" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "18:23:24" , 
"departure_time" : "18:23:24" , 
"distance_traveled" : 29.571
} ], 
"1623" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "12:46:00" , 
"departure_time" : "12:47:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "12:57:51" , 
"departure_time" : "12:58:48" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "13:03:57" , 
"departure_time" : "13:05:04" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "13:06:07" , 
"departure_time" : "13:06:11" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "13:08:04" , 
"departure_time" : "13:09:23" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "13:12:19" , 
"departure_time" : "13:12:41" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "13:15:22" , 
"departure_time" : "13:15:57" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "13:21:35" , 
"departure_time" : "13:22:30" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "13:26:55" , 
"departure_time" : "13:28:29" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "13:31:34" , 
"departure_time" : "13:32:34" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "13:35:00" , 
"departure_time" : "13:35:30" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "13:37:30" , 
"departure_time" : "13:38:27" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "13:40:57" , 
"departure_time" : "13:40:57" , 
"distance_traveled" : 23.4703
} ], 
"1624" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:49:00" , 
"departure_time" : "17:51:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:01:09" , 
"departure_time" : "18:02:38" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 126,
"arrival_time" : "18:19:29" , 
"departure_time" : "18:20:15" , 
"distance_traveled" : 16.8733
}, 
{ 
"stop_id" : 51,
"arrival_time" : "18:22:46" , 
"departure_time" : "18:23:49" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:27:03" , 
"departure_time" : "18:28:21" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "18:31:18" , 
"departure_time" : "18:32:27" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "18:34:09" , 
"departure_time" : "18:35:48" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "18:39:39" , 
"departure_time" : "18:40:34" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "18:43:55" , 
"departure_time" : "18:44:23" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "18:46:28" , 
"departure_time" : "18:46:38" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "18:49:10" , 
"departure_time" : "18:49:48" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "18:53:38" , 
"departure_time" : "18:53:38" , 
"distance_traveled" : 29.571
} ], 
"1625" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "13:44:00" , 
"departure_time" : "13:45:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "13:55:48" , 
"departure_time" : "13:57:28" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "14:02:40" , 
"departure_time" : "14:03:45" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "14:04:05" , 
"departure_time" : "14:04:42" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "14:06:37" , 
"departure_time" : "14:07:16" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "14:09:39" , 
"departure_time" : "14:10:24" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "14:13:45" , 
"departure_time" : "14:15:10" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "14:20:25" , 
"departure_time" : "14:21:28" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "14:25:03" , 
"departure_time" : "14:26:24" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "14:29:21" , 
"departure_time" : "14:29:59" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "14:32:38" , 
"departure_time" : "14:33:53" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "14:36:15" , 
"departure_time" : "14:37:43" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "14:41:28" , 
"departure_time" : "14:41:28" , 
"distance_traveled" : 23.4703
} ], 
"1626" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "08:30:00" , 
"departure_time" : "08:32:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:42:15" , 
"departure_time" : "08:42:38" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "08:49:23" , 
"departure_time" : "08:50:54" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "08:53:31" , 
"departure_time" : "08:53:36" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "08:56:05" , 
"departure_time" : "08:57:28" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "08:59:23" , 
"departure_time" : "09:00:53" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "09:05:30" , 
"departure_time" : "09:06:11" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "09:08:41" , 
"departure_time" : "09:08:57" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "09:11:16" , 
"departure_time" : "09:11:55" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "09:16:39" , 
"departure_time" : "09:17:21" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "09:19:42" , 
"departure_time" : "09:19:53" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "09:23:11" , 
"departure_time" : "09:23:11" , 
"distance_traveled" : 22.3157
} ], 
"1627" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "15:36:00" , 
"departure_time" : "15:36:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "15:47:34" , 
"departure_time" : "15:48:10" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "15:53:36" , 
"departure_time" : "15:53:38" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "15:56:02" , 
"departure_time" : "15:56:59" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "15:58:57" , 
"departure_time" : "15:59:11" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "16:01:14" , 
"departure_time" : "16:02:43" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "16:05:29" , 
"departure_time" : "16:06:03" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "16:11:34" , 
"departure_time" : "16:11:52" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "16:15:18" , 
"departure_time" : "16:15:30" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "16:19:12" , 
"departure_time" : "16:19:33" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "16:23:21" , 
"departure_time" : "16:24:24" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "16:28:03" , 
"departure_time" : "16:29:12" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "16:31:09" , 
"departure_time" : "16:31:09" , 
"distance_traveled" : 23.4703
} ], 
"1628" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:19:00" , 
"departure_time" : "16:21:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:31:06" , 
"departure_time" : "16:32:44" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "16:39:38" , 
"departure_time" : "16:40:47" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "16:42:09" , 
"departure_time" : "16:42:40" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "16:45:31" , 
"departure_time" : "16:46:00" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "16:47:29" , 
"departure_time" : "16:48:54" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "16:54:25" , 
"departure_time" : "16:55:24" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "16:57:59" , 
"departure_time" : "16:58:51" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "17:00:52" , 
"departure_time" : "17:02:24" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "17:05:32" , 
"departure_time" : "17:07:02" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "17:08:30" , 
"departure_time" : "17:08:55" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "17:09:25" , 
"departure_time" : "17:09:25" , 
"distance_traveled" : 22.3157
} ], 
"1629" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:13:00" , 
"departure_time" : "17:14:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:25:31" , 
"departure_time" : "17:26:54" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "17:32:23" , 
"departure_time" : "17:32:59" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "17:34:36" , 
"departure_time" : "17:34:37" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "17:38:01" , 
"departure_time" : "17:38:32" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "17:41:31" , 
"departure_time" : "17:42:31" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "17:46:00" , 
"departure_time" : "17:47:20" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "17:52:20" , 
"departure_time" : "17:53:38" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "17:57:18" , 
"departure_time" : "17:58:08" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "18:00:50" , 
"departure_time" : "18:01:56" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:05:06" , 
"departure_time" : "18:05:09" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "18:08:03" , 
"departure_time" : "18:08:12" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "18:10:09" , 
"departure_time" : "18:10:09" , 
"distance_traveled" : 23.4703
} ], 
"1630" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:27:00" , 
"departure_time" : "17:27:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:38:16" , 
"departure_time" : "17:39:22" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "17:48:06" , 
"departure_time" : "17:49:40" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "17:52:34" , 
"departure_time" : "17:53:41" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "17:55:07" , 
"departure_time" : "17:56:46" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "17:59:39" , 
"departure_time" : "17:59:58" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "18:03:19" , 
"departure_time" : "18:03:59" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "18:07:40" , 
"departure_time" : "18:08:26" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "18:11:46" , 
"departure_time" : "18:13:09" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:16:23" , 
"departure_time" : "18:17:56" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "18:19:33" , 
"departure_time" : "18:20:05" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "18:20:32" , 
"departure_time" : "18:20:32" , 
"distance_traveled" : 22.3157
} ], 
"1631" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:46:00" , 
"departure_time" : "17:47:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:57:42" , 
"departure_time" : "17:59:08" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "18:06:26" , 
"departure_time" : "18:07:01" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "18:08:35" , 
"departure_time" : "18:08:54" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "18:11:19" , 
"departure_time" : "18:12:14" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "18:15:55" , 
"departure_time" : "18:16:20" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "18:19:25" , 
"departure_time" : "18:19:31" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "18:25:06" , 
"departure_time" : "18:25:52" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "18:30:46" , 
"departure_time" : "18:32:04" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "18:35:18" , 
"departure_time" : "18:35:36" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:38:18" , 
"departure_time" : "18:38:27" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "18:42:09" , 
"departure_time" : "18:43:31" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "18:46:22" , 
"departure_time" : "18:46:22" , 
"distance_traveled" : 23.4703
} ], 
"1632" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "22:17:00" , 
"departure_time" : "22:18:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "22:28:31" , 
"departure_time" : "22:29:03" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "22:36:32" , 
"departure_time" : "22:37:30" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "22:39:58" , 
"departure_time" : "22:41:01" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "22:44:03" , 
"departure_time" : "22:45:13" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "22:46:10" , 
"departure_time" : "22:46:38" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "22:51:28" , 
"departure_time" : "22:52:41" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "22:55:13" , 
"departure_time" : "22:55:42" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "22:58:29" , 
"departure_time" : "22:58:48" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "23:01:19" , 
"departure_time" : "23:02:16" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "23:05:57" , 
"departure_time" : "23:06:45" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "23:07:48" , 
"departure_time" : "23:07:48" , 
"distance_traveled" : 22.3157
} ], 
"1633" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:20:00" , 
"departure_time" : "18:21:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:31:45" , 
"departure_time" : "18:32:09" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "18:38:24" , 
"departure_time" : "18:39:01" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "18:41:37" , 
"departure_time" : "18:42:36" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "18:44:59" , 
"departure_time" : "18:45:40" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "18:48:41" , 
"departure_time" : "18:49:19" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "18:52:38" , 
"departure_time" : "18:53:15" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "18:58:37" , 
"departure_time" : "18:59:10" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "19:03:33" , 
"departure_time" : "19:04:35" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "19:08:02" , 
"departure_time" : "19:09:38" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "19:12:36" , 
"departure_time" : "19:13:47" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "19:16:11" , 
"departure_time" : "19:17:42" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "19:19:31" , 
"departure_time" : "19:19:31" , 
"distance_traveled" : 23.4703
} ], 
"1634" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "09:31:00" , 
"departure_time" : "09:32:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:42:05" , 
"departure_time" : "09:42:49" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "09:48:44" , 
"departure_time" : "09:50:19" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "09:51:35" , 
"departure_time" : "09:51:41" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "09:53:06" , 
"departure_time" : "09:53:20" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "09:56:14" , 
"departure_time" : "09:57:46" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "10:00:32" , 
"departure_time" : "10:00:55" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "10:05:23" , 
"departure_time" : "10:06:11" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "10:10:48" , 
"departure_time" : "10:12:12" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "10:15:24" , 
"departure_time" : "10:15:33" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "10:18:09" , 
"departure_time" : "10:19:03" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "10:21:54" , 
"departure_time" : "10:22:02" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "10:25:08" , 
"departure_time" : "10:25:08" , 
"distance_traveled" : 23.4703
} ], 
"1635" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "14:35:00" , 
"departure_time" : "14:35:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "14:46:44" , 
"departure_time" : "14:47:43" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "14:54:59" , 
"departure_time" : "14:55:34" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "14:57:35" , 
"departure_time" : "14:58:13" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "15:01:38" , 
"departure_time" : "15:02:37" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "15:03:59" , 
"departure_time" : "15:04:15" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "15:09:16" , 
"departure_time" : "15:10:01" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "15:12:45" , 
"departure_time" : "15:13:11" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "15:16:26" , 
"departure_time" : "15:17:29" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "15:20:03" , 
"departure_time" : "15:20:23" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "15:23:20" , 
"departure_time" : "15:23:49" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "15:26:29" , 
"departure_time" : "15:27:04" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "15:30:35" , 
"departure_time" : "15:32:07" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "15:36:32" , 
"departure_time" : "15:37:59" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "15:39:27" , 
"departure_time" : "15:39:58" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "15:42:31" , 
"departure_time" : "15:42:58" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "15:45:27" , 
"departure_time" : "15:45:27" , 
"distance_traveled" : 29.571
} ], 
"1636" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "12:46:00" , 
"departure_time" : "12:47:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "12:57:37" , 
"departure_time" : "12:58:05" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "13:03:28" , 
"departure_time" : "13:03:36" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "13:05:08" , 
"departure_time" : "13:05:23" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "13:08:15" , 
"departure_time" : "13:09:31" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "13:12:16" , 
"departure_time" : "13:13:00" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "13:15:44" , 
"departure_time" : "13:16:58" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "13:22:14" , 
"departure_time" : "13:22:58" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "13:26:44" , 
"departure_time" : "13:28:07" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "13:31:23" , 
"departure_time" : "13:31:48" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "13:34:25" , 
"departure_time" : "13:35:29" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "13:38:04" , 
"departure_time" : "13:38:13" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "13:40:09" , 
"departure_time" : "13:40:09" , 
"distance_traveled" : 23.4703
} ], 
"1637" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "07:53:00" , 
"departure_time" : "07:54:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:05:12" , 
"departure_time" : "08:06:20" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "08:13:08" , 
"departure_time" : "08:14:24" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "08:16:16" , 
"departure_time" : "08:16:38" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 121,
"arrival_time" : "08:20:22" , 
"departure_time" : "08:21:16" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "08:25:54" , 
"departure_time" : "08:26:56" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "08:29:02" , 
"departure_time" : "08:30:19" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "08:33:17" , 
"departure_time" : "08:33:34" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "08:35:17" , 
"departure_time" : "08:36:44" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "08:40:27" , 
"departure_time" : "08:41:43" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "08:43:16" , 
"departure_time" : "08:43:21" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "08:46:05" , 
"departure_time" : "08:46:12" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "08:51:07" , 
"departure_time" : "08:51:11" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "08:54:04" , 
"departure_time" : "08:54:32" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "08:57:28" , 
"departure_time" : "08:58:37" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "09:02:09" , 
"departure_time" : "09:02:09" , 
"distance_traveled" : 29.571
} ], 
"1638" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "13:44:00" , 
"departure_time" : "13:46:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "13:56:14" , 
"departure_time" : "13:57:30" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "14:02:16" , 
"departure_time" : "14:02:57" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "14:03:41" , 
"departure_time" : "14:05:00" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "14:07:19" , 
"departure_time" : "14:08:43" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "14:10:24" , 
"departure_time" : "14:10:41" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "14:13:17" , 
"departure_time" : "14:13:29" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "14:19:12" , 
"departure_time" : "14:19:41" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "14:24:29" , 
"departure_time" : "14:24:54" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "14:28:25" , 
"departure_time" : "14:29:31" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "14:33:06" , 
"departure_time" : "14:33:59" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "14:35:53" , 
"departure_time" : "14:36:07" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "14:40:14" , 
"departure_time" : "14:40:14" , 
"distance_traveled" : 23.4703
} ], 
"1639" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "05:48:00" , 
"departure_time" : "05:48:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "05:59:19" , 
"departure_time" : "05:59:57" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "06:05:38" , 
"departure_time" : "06:05:45" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "06:07:07" , 
"departure_time" : "06:07:24" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "06:10:17" , 
"departure_time" : "06:10:44" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "06:13:27" , 
"departure_time" : "06:14:14" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "06:17:47" , 
"departure_time" : "06:18:01" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "06:22:14" , 
"departure_time" : "06:23:14" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "06:27:00" , 
"departure_time" : "06:28:30" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "06:31:30" , 
"departure_time" : "06:31:41" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "06:34:11" , 
"departure_time" : "06:34:53" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "06:37:42" , 
"departure_time" : "06:39:17" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "06:42:35" , 
"departure_time" : "06:43:40" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "06:48:05" , 
"departure_time" : "06:49:23" , 
"distance_traveled" : 28.0116
}, 
{ 
"stop_id" : 78,
"arrival_time" : "06:51:18" , 
"departure_time" : "06:51:19" , 
"distance_traveled" : 29.3483
}, 
{ 
"stop_id" : 144,
"arrival_time" : "06:54:01" , 
"departure_time" : "06:54:01" , 
"distance_traveled" : 30.7258
} ], 
"1640" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "15:36:00" , 
"departure_time" : "15:36:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "15:47:51" , 
"departure_time" : "15:48:31" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "15:53:40" , 
"departure_time" : "15:54:48" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "15:57:08" , 
"departure_time" : "15:58:26" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "15:59:18" , 
"departure_time" : "16:00:04" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "16:01:46" , 
"departure_time" : "16:02:26" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "16:04:40" , 
"departure_time" : "16:05:57" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "16:12:17" , 
"departure_time" : "16:12:30" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "16:15:13" , 
"departure_time" : "16:16:19" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "16:20:06" , 
"departure_time" : "16:20:18" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "16:23:12" , 
"departure_time" : "16:23:25" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "16:27:13" , 
"departure_time" : "16:28:47" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "16:31:34" , 
"departure_time" : "16:31:34" , 
"distance_traveled" : 23.4703
} ], 
"1641" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "12:39:00" , 
"departure_time" : "12:41:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "12:50:15" , 
"departure_time" : "12:51:50" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "12:58:35" , 
"departure_time" : "12:58:48" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "13:01:13" , 
"departure_time" : "13:01:50" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "13:04:37" , 
"departure_time" : "13:04:50" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "13:07:13" , 
"departure_time" : "13:08:38" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "13:13:25" , 
"departure_time" : "13:14:40" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "13:16:15" , 
"departure_time" : "13:16:49" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "13:19:34" , 
"departure_time" : "13:20:39" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "13:23:05" , 
"departure_time" : "13:23:47" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "13:26:42" , 
"departure_time" : "13:27:07" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "13:29:25" , 
"departure_time" : "13:29:54" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "13:34:29" , 
"departure_time" : "13:35:15" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "13:38:46" , 
"departure_time" : "13:39:07" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "13:41:21" , 
"departure_time" : "13:41:27" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "13:44:06" , 
"departure_time" : "13:45:46" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "13:49:40" , 
"departure_time" : "13:49:40" , 
"distance_traveled" : 29.571
} ], 
"1642" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:13:00" , 
"departure_time" : "17:14:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:24:12" , 
"departure_time" : "17:24:20" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "17:31:08" , 
"departure_time" : "17:32:08" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "17:35:00" , 
"departure_time" : "17:35:35" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "17:38:35" , 
"departure_time" : "17:39:52" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "17:42:17" , 
"departure_time" : "17:43:00" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "17:45:43" , 
"departure_time" : "17:45:53" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "17:51:10" , 
"departure_time" : "17:51:25" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "17:56:15" , 
"departure_time" : "17:57:47" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "18:01:32" , 
"departure_time" : "18:02:27" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:04:55" , 
"departure_time" : "18:05:20" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "18:08:25" , 
"departure_time" : "18:09:00" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "18:10:35" , 
"departure_time" : "18:10:35" , 
"distance_traveled" : 23.4703
} ], 
"1643" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "13:39:00" , 
"departure_time" : "13:39:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "13:50:12" , 
"departure_time" : "13:50:15" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "13:58:03" , 
"departure_time" : "13:59:16" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "14:02:13" , 
"departure_time" : "14:03:37" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "14:06:24" , 
"departure_time" : "14:07:58" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "14:08:34" , 
"departure_time" : "14:08:49" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "14:13:15" , 
"departure_time" : "14:13:49" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "14:16:34" , 
"departure_time" : "14:17:56" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "14:21:22" , 
"departure_time" : "14:22:25" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "14:24:03" , 
"departure_time" : "14:25:34" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "14:28:31" , 
"departure_time" : "14:29:34" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "14:31:03" , 
"departure_time" : "14:32:26" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "14:35:23" , 
"departure_time" : "14:35:45" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "14:39:22" , 
"departure_time" : "14:40:05" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "14:42:43" , 
"departure_time" : "14:44:19" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "14:46:36" , 
"departure_time" : "14:47:58" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "14:49:22" , 
"departure_time" : "14:49:22" , 
"distance_traveled" : 29.571
} ], 
"1644" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:46:00" , 
"departure_time" : "17:48:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:58:36" , 
"departure_time" : "17:59:22" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "18:05:46" , 
"departure_time" : "18:05:53" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "18:08:07" , 
"departure_time" : "18:09:12" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "18:12:05" , 
"departure_time" : "18:12:14" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "18:15:09" , 
"departure_time" : "18:16:13" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "18:20:04" , 
"departure_time" : "18:21:08" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "18:26:04" , 
"departure_time" : "18:27:20" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "18:31:16" , 
"departure_time" : "18:32:12" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "18:34:56" , 
"departure_time" : "18:36:28" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:39:32" , 
"departure_time" : "18:40:20" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "18:42:48" , 
"departure_time" : "18:43:03" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "18:45:15" , 
"departure_time" : "18:45:15" , 
"distance_traveled" : 23.4703
} ], 
"1645" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "15:21:00" , 
"departure_time" : "15:22:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "15:32:51" , 
"departure_time" : "15:33:00" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "15:40:09" , 
"departure_time" : "15:40:49" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "15:43:40" , 
"departure_time" : "15:44:56" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "15:48:16" , 
"departure_time" : "15:49:00" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "15:50:44" , 
"departure_time" : "15:51:01" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "15:56:17" , 
"departure_time" : "15:56:29" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "15:59:12" , 
"departure_time" : "15:59:54" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "16:03:42" , 
"departure_time" : "16:04:21" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "16:06:39" , 
"departure_time" : "16:07:40" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "16:11:01" , 
"departure_time" : "16:11:26" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "16:13:25" , 
"departure_time" : "16:14:00" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "16:17:35" , 
"departure_time" : "16:17:56" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "16:22:21" , 
"departure_time" : "16:22:54" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "16:25:33" , 
"departure_time" : "16:26:08" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "16:29:35" , 
"departure_time" : "16:30:31" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "16:31:56" , 
"departure_time" : "16:31:56" , 
"distance_traveled" : 29.571
} ], 
"1646" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:20:00" , 
"departure_time" : "18:22:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:32:31" , 
"departure_time" : "18:33:51" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "18:39:20" , 
"departure_time" : "18:40:42" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "18:42:22" , 
"departure_time" : "18:42:57" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "18:44:35" , 
"departure_time" : "18:45:51" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "18:49:16" , 
"departure_time" : "18:49:52" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "18:52:36" , 
"departure_time" : "18:52:45" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "18:58:09" , 
"departure_time" : "18:58:34" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "19:03:25" , 
"departure_time" : "19:04:56" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "19:08:31" , 
"departure_time" : "19:09:41" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "19:12:10" , 
"departure_time" : "19:12:43" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "19:15:33" , 
"departure_time" : "19:16:26" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "19:18:53" , 
"departure_time" : "19:18:53" , 
"distance_traveled" : 23.4703
} ], 
"1647" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:36:00" , 
"departure_time" : "18:37:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:47:38" , 
"departure_time" : "18:47:45" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "18:55:07" , 
"departure_time" : "18:56:37" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "19:00:30" , 
"departure_time" : "19:00:55" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "19:03:25" , 
"departure_time" : "19:03:53" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "19:06:28" , 
"departure_time" : "19:07:56" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "19:13:28" , 
"departure_time" : "19:13:34" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "19:16:06" , 
"departure_time" : "19:17:13" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "19:21:07" , 
"departure_time" : "19:21:49" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "19:24:42" , 
"departure_time" : "19:26:12" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "19:30:30" , 
"departure_time" : "19:30:32" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "19:33:02" , 
"departure_time" : "19:33:12" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "19:39:10" , 
"departure_time" : "19:39:22" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "19:44:12" , 
"departure_time" : "19:44:54" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "19:47:42" , 
"departure_time" : "19:47:50" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "19:51:08" , 
"departure_time" : "19:51:52" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "19:54:44" , 
"departure_time" : "19:54:44" , 
"distance_traveled" : 29.571
} ], 
"1648" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "14:35:00" , 
"departure_time" : "14:36:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "14:47:07" , 
"departure_time" : "14:47:51" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "14:54:44" , 
"departure_time" : "14:55:27" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "14:57:43" , 
"departure_time" : "14:58:47" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "15:02:04" , 
"departure_time" : "15:02:49" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "15:03:45" , 
"departure_time" : "15:04:05" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "15:09:20" , 
"departure_time" : "15:09:52" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "15:12:32" , 
"departure_time" : "15:12:35" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "15:16:03" , 
"departure_time" : "15:17:25" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "15:20:22" , 
"departure_time" : "15:20:49" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "15:23:27" , 
"departure_time" : "15:24:24" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "15:26:57" , 
"departure_time" : "15:27:09" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "15:30:12" , 
"departure_time" : "15:31:39" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "15:36:27" , 
"departure_time" : "15:36:38" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "15:38:11" , 
"departure_time" : "15:39:09" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "15:42:58" , 
"departure_time" : "15:43:23" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "15:45:25" , 
"departure_time" : "15:45:25" , 
"distance_traveled" : 29.571
} ], 
"1649" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "19:18:00" , 
"departure_time" : "19:18:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:29:28" , 
"departure_time" : "19:30:47" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "19:38:19" , 
"departure_time" : "19:38:29" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "19:40:10" , 
"departure_time" : "19:41:34" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "19:45:24" , 
"departure_time" : "19:46:23" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "19:47:59" , 
"departure_time" : "19:49:27" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "19:53:28" , 
"departure_time" : "19:54:23" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "19:56:55" , 
"departure_time" : "19:57:19" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "19:59:24" , 
"departure_time" : "20:00:56" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "20:04:32" , 
"departure_time" : "20:05:23" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "20:06:51" , 
"departure_time" : "20:07:35" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "20:10:44" , 
"departure_time" : "20:12:16" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "20:15:32" , 
"departure_time" : "20:16:43" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "20:20:11" , 
"departure_time" : "20:20:56" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "20:22:45" , 
"departure_time" : "20:23:36" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "20:25:51" , 
"departure_time" : "20:27:04" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "20:30:13" , 
"departure_time" : "20:30:13" , 
"distance_traveled" : 29.571
} ], 
"1650" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "07:53:00" , 
"departure_time" : "07:55:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:04:52" , 
"departure_time" : "08:06:32" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "08:13:40" , 
"departure_time" : "08:14:53" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "08:16:13" , 
"departure_time" : "08:16:42" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 121,
"arrival_time" : "08:20:29" , 
"departure_time" : "08:20:51" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "08:25:22" , 
"departure_time" : "08:25:36" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "08:28:14" , 
"departure_time" : "08:28:43" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "08:32:29" , 
"departure_time" : "08:33:40" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "08:36:11" , 
"departure_time" : "08:37:04" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "08:39:53" , 
"departure_time" : "08:40:38" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "08:42:45" , 
"departure_time" : "08:44:18" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "08:47:33" , 
"departure_time" : "08:48:50" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "08:52:17" , 
"departure_time" : "08:52:19" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "08:54:02" , 
"departure_time" : "08:55:41" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "08:58:39" , 
"departure_time" : "08:59:56" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "09:02:17" , 
"departure_time" : "09:02:17" , 
"distance_traveled" : 29.571
} ], 
"1651" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "20:13:00" , 
"departure_time" : "20:15:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "20:24:57" , 
"departure_time" : "20:25:22" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "20:32:25" , 
"departure_time" : "20:32:54" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "20:36:29" , 
"departure_time" : "20:38:08" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "20:39:39" , 
"departure_time" : "20:40:13" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "20:41:34" , 
"departure_time" : "20:42:36" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "20:47:02" , 
"departure_time" : "20:47:24" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "20:49:22" , 
"departure_time" : "20:50:16" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "20:53:54" , 
"departure_time" : "20:54:21" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "20:56:27" , 
"departure_time" : "20:57:13" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "20:59:46" , 
"departure_time" : "21:00:06" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "21:03:20" , 
"departure_time" : "21:03:45" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "21:06:25" , 
"departure_time" : "21:06:47" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "21:10:22" , 
"departure_time" : "21:11:17" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "21:13:55" , 
"departure_time" : "21:14:26" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "21:16:31" , 
"departure_time" : "21:17:27" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "21:20:56" , 
"departure_time" : "21:20:56" , 
"distance_traveled" : 29.571
} ], 
"1652" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "05:48:00" , 
"departure_time" : "05:49:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "05:59:11" , 
"departure_time" : "05:59:23" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "06:05:12" , 
"departure_time" : "06:06:28" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "06:08:16" , 
"departure_time" : "06:08:40" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "06:10:24" , 
"departure_time" : "06:11:12" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "06:13:48" , 
"departure_time" : "06:15:17" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "06:18:29" , 
"departure_time" : "06:19:45" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "06:23:16" , 
"departure_time" : "06:23:56" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "06:26:40" , 
"departure_time" : "06:27:55" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "06:31:15" , 
"departure_time" : "06:32:52" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "06:35:37" , 
"departure_time" : "06:35:43" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "06:37:06" , 
"departure_time" : "06:37:39" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "06:41:33" , 
"departure_time" : "06:41:58" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "06:47:25" , 
"departure_time" : "06:48:26" , 
"distance_traveled" : 28.0116
}, 
{ 
"stop_id" : 78,
"arrival_time" : "06:51:01" , 
"departure_time" : "06:51:20" , 
"distance_traveled" : 29.3483
}, 
{ 
"stop_id" : 144,
"arrival_time" : "06:54:19" , 
"departure_time" : "06:54:19" , 
"distance_traveled" : 30.7258
} ], 
"1653" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "21:11:00" , 
"departure_time" : "21:11:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "21:22:07" , 
"departure_time" : "21:22:14" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "21:30:07" , 
"departure_time" : "21:30:35" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "21:33:28" , 
"departure_time" : "21:34:17" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "21:37:49" , 
"departure_time" : "21:38:49" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "21:41:00" , 
"departure_time" : "21:41:41" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "21:45:41" , 
"departure_time" : "21:46:42" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "21:50:01" , 
"departure_time" : "21:50:30" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "21:52:29" , 
"departure_time" : "21:52:53" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "21:56:24" , 
"departure_time" : "21:57:40" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "22:00:16" , 
"departure_time" : "22:00:22" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "22:03:06" , 
"departure_time" : "22:03:19" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "22:07:13" , 
"departure_time" : "22:08:11" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "22:12:58" , 
"departure_time" : "22:13:55" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "22:15:57" , 
"departure_time" : "22:17:21" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "22:19:24" , 
"departure_time" : "22:20:01" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "22:22:37" , 
"departure_time" : "22:22:37" , 
"distance_traveled" : 29.571
} ], 
"1654" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "12:39:00" , 
"departure_time" : "12:39:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "12:49:20" , 
"departure_time" : "12:49:25" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "12:57:05" , 
"departure_time" : "12:57:10" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "13:01:05" , 
"departure_time" : "13:01:42" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "13:04:37" , 
"departure_time" : "13:04:49" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "13:07:12" , 
"departure_time" : "13:08:21" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "13:13:09" , 
"departure_time" : "13:13:58" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "13:15:49" , 
"departure_time" : "13:16:00" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "13:19:11" , 
"departure_time" : "13:19:56" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "13:22:45" , 
"departure_time" : "13:22:58" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "13:26:13" , 
"departure_time" : "13:27:42" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "13:30:29" , 
"departure_time" : "13:31:57" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "13:35:28" , 
"departure_time" : "13:36:00" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "13:38:32" , 
"departure_time" : "13:38:47" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "13:41:15" , 
"departure_time" : "13:42:39" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "13:45:24" , 
"departure_time" : "13:45:56" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "13:48:32" , 
"departure_time" : "13:48:32" , 
"distance_traveled" : 29.571
} ], 
"1655" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "23:17:00" , 
"departure_time" : "23:17:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "23:28:04" , 
"departure_time" : "23:29:41" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "23:37:37" , 
"departure_time" : "23:38:53" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "23:40:16" , 
"departure_time" : "23:40:17" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "23:43:01" , 
"departure_time" : "23:43:23" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "23:45:22" , 
"departure_time" : "23:46:23" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "23:52:01" , 
"departure_time" : "23:53:22" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "23:55:21" , 
"departure_time" : "23:56:41" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "23:59:20" , 
"departure_time" : "24:00:56" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "24:02:36" , 
"departure_time" : "24:02:39" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "24:05:03" , 
"departure_time" : "24:05:54" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "24:08:51" , 
"departure_time" : "24:10:25" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "24:13:34" , 
"departure_time" : "24:14:27" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "24:17:53" , 
"departure_time" : "24:17:57" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "24:20:04" , 
"departure_time" : "24:21:20" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "24:24:16" , 
"departure_time" : "24:25:13" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "24:27:57" , 
"departure_time" : "24:27:57" , 
"distance_traveled" : 29.571
} ], 
"1656" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "13:39:00" , 
"departure_time" : "13:41:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "13:51:25" , 
"departure_time" : "13:51:50" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "13:58:25" , 
"departure_time" : "13:58:48" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "14:01:23" , 
"departure_time" : "14:01:29" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "14:05:06" , 
"departure_time" : "14:06:00" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "14:07:54" , 
"departure_time" : "14:08:07" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "14:13:13" , 
"departure_time" : "14:14:42" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "14:17:29" , 
"departure_time" : "14:18:26" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "14:20:57" , 
"departure_time" : "14:22:36" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "14:24:39" , 
"departure_time" : "14:25:44" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "14:28:05" , 
"departure_time" : "14:28:37" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "14:30:32" , 
"departure_time" : "14:31:39" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "14:35:07" , 
"departure_time" : "14:36:13" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "14:40:06" , 
"departure_time" : "14:40:20" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "14:42:14" , 
"departure_time" : "14:43:29" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "14:46:15" , 
"departure_time" : "14:46:58" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "14:48:43" , 
"departure_time" : "14:48:43" , 
"distance_traveled" : 29.571
} ], 
"1657" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "10:45:00" , 
"departure_time" : "10:45:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "10:56:07" , 
"departure_time" : "10:57:17" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "11:03:10" , 
"departure_time" : "11:04:09" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "11:04:59" , 
"departure_time" : "11:05:09" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "11:07:10" , 
"departure_time" : "11:08:38" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "11:12:28" , 
"departure_time" : "11:13:04" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "11:14:36" , 
"departure_time" : "11:14:37" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "11:21:01" , 
"departure_time" : "11:22:40" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "11:26:39" , 
"departure_time" : "11:26:41" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "11:29:02" , 
"departure_time" : "11:30:29" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "11:33:27" , 
"departure_time" : "11:33:54" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "11:35:27" , 
"departure_time" : "11:36:55" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "11:40:28" , 
"departure_time" : "11:40:30" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "11:42:02" , 
"departure_time" : "11:42:25" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "11:46:23" , 
"departure_time" : "11:46:40" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "11:49:17" , 
"departure_time" : "11:49:50" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "11:52:33" , 
"departure_time" : "11:53:21" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "11:56:48" , 
"departure_time" : "11:56:48" , 
"distance_traveled" : 30.7256
} ], 
"1658" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "15:21:00" , 
"departure_time" : "15:22:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "15:32:54" , 
"departure_time" : "15:33:59" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "15:41:05" , 
"departure_time" : "15:42:14" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "15:44:09" , 
"departure_time" : "15:44:18" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "15:47:09" , 
"departure_time" : "15:47:42" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "15:50:33" , 
"departure_time" : "15:50:43" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "15:56:10" , 
"departure_time" : "15:57:46" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "16:00:36" , 
"departure_time" : "16:02:00" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "16:04:24" , 
"departure_time" : "16:06:04" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "16:07:40" , 
"departure_time" : "16:09:09" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "16:11:29" , 
"departure_time" : "16:12:51" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "16:14:22" , 
"departure_time" : "16:14:41" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "16:17:19" , 
"departure_time" : "16:18:19" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "16:23:00" , 
"departure_time" : "16:24:36" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "16:26:36" , 
"departure_time" : "16:28:14" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "16:30:38" , 
"departure_time" : "16:32:18" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "16:32:40" , 
"departure_time" : "16:32:40" , 
"distance_traveled" : 29.571
} ], 
"1659" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "25:32:00" , 
"departure_time" : "25:34:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "25:44:08" , 
"departure_time" : "25:44:17" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "25:49:09" , 
"departure_time" : "25:50:36" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "25:52:27" , 
"departure_time" : "25:54:04" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "25:55:37" , 
"departure_time" : "25:56:54" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "25:58:17" , 
"departure_time" : "25:59:02" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "26:00:45" , 
"departure_time" : "26:00:58" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "26:05:13" , 
"departure_time" : "26:06:36" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "26:10:23" , 
"departure_time" : "26:11:07" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "26:13:44" , 
"departure_time" : "26:14:34" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "26:17:50" , 
"departure_time" : "26:19:23" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "26:21:33" , 
"departure_time" : "26:22:22" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "26:24:49" , 
"departure_time" : "26:25:02" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "26:27:13" , 
"departure_time" : "26:28:47" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "26:33:34" , 
"departure_time" : "26:34:32" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "26:34:58" , 
"departure_time" : "26:36:17" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "26:39:19" , 
"departure_time" : "26:39:22" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "26:41:03" , 
"departure_time" : "26:41:03" , 
"distance_traveled" : 30.7256
} ], 
"1660" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:36:00" , 
"departure_time" : "18:37:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:48:04" , 
"departure_time" : "18:48:33" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "18:55:29" , 
"departure_time" : "18:56:10" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "18:59:41" , 
"departure_time" : "19:00:06" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "19:03:25" , 
"departure_time" : "19:04:19" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "19:06:54" , 
"departure_time" : "19:08:30" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "19:13:36" , 
"departure_time" : "19:14:38" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "19:17:02" , 
"departure_time" : "19:18:37" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "19:21:35" , 
"departure_time" : "19:23:01" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "19:25:26" , 
"departure_time" : "19:25:32" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "19:29:06" , 
"departure_time" : "19:30:25" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "19:34:19" , 
"departure_time" : "19:35:59" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "19:40:40" , 
"departure_time" : "19:42:11" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "19:45:31" , 
"departure_time" : "19:46:20" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "19:47:49" , 
"departure_time" : "19:49:01" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "19:52:12" , 
"departure_time" : "19:53:50" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "19:55:38" , 
"departure_time" : "19:55:38" , 
"distance_traveled" : 29.571
} ], 
"1661" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "06:58:00" , 
"departure_time" : "07:00:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:10:03" , 
"departure_time" : "07:10:30" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "07:15:27" , 
"departure_time" : "07:16:53" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "07:18:26" , 
"departure_time" : "07:19:39" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "07:21:13" , 
"departure_time" : "07:21:50" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "07:23:37" , 
"departure_time" : "07:24:59" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "07:27:22" , 
"departure_time" : "07:28:32" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "07:32:10" , 
"departure_time" : "07:33:01" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "07:35:51" , 
"departure_time" : "07:36:19" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "07:39:28" , 
"departure_time" : "07:39:56" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "07:43:28" , 
"departure_time" : "07:44:41" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "07:47:13" , 
"departure_time" : "07:47:41" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "07:51:28" , 
"departure_time" : "07:52:12" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "07:55:44" , 
"departure_time" : "07:56:23" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "07:59:39" , 
"departure_time" : "08:01:05" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "08:03:26" , 
"departure_time" : "08:04:57" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "08:06:31" , 
"departure_time" : "08:07:46" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "08:10:15" , 
"departure_time" : "08:10:15" , 
"distance_traveled" : 30.7256
} ], 
"1662" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "19:18:00" , 
"departure_time" : "19:20:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:29:58" , 
"departure_time" : "19:31:11" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "19:38:13" , 
"departure_time" : "19:39:42" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "19:41:29" , 
"departure_time" : "19:41:32" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "19:44:03" , 
"departure_time" : "19:44:38" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "19:47:35" , 
"departure_time" : "19:47:39" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "19:52:04" , 
"departure_time" : "19:52:26" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "19:56:22" , 
"departure_time" : "19:57:42" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "20:00:20" , 
"departure_time" : "20:01:54" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "20:04:34" , 
"departure_time" : "20:05:54" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "20:07:20" , 
"departure_time" : "20:08:49" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "20:11:29" , 
"departure_time" : "20:11:39" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "20:14:10" , 
"departure_time" : "20:14:21" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "20:19:11" , 
"departure_time" : "20:20:34" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "20:23:23" , 
"departure_time" : "20:24:21" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "20:25:58" , 
"departure_time" : "20:26:39" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "20:29:41" , 
"departure_time" : "20:29:41" , 
"distance_traveled" : 29.571
} ], 
"1663" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "07:38:00" , 
"departure_time" : "07:39:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:49:31" , 
"departure_time" : "07:50:19" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "07:55:48" , 
"departure_time" : "07:57:23" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "07:58:35" , 
"departure_time" : "07:58:40" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "08:00:05" , 
"departure_time" : "08:00:48" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "08:03:43" , 
"departure_time" : "08:05:00" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "08:07:17" , 
"departure_time" : "08:07:57" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "08:11:40" , 
"departure_time" : "08:12:40" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "08:17:00" , 
"departure_time" : "08:17:25" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "08:20:25" , 
"departure_time" : "08:21:54" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "08:25:29" , 
"departure_time" : "08:26:49" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "08:28:20" , 
"departure_time" : "08:29:04" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "08:30:44" , 
"departure_time" : "08:31:58" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "08:35:14" , 
"departure_time" : "08:35:17" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "08:38:03" , 
"departure_time" : "08:38:04" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "08:41:01" , 
"departure_time" : "08:42:40" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "08:45:39" , 
"departure_time" : "08:46:29" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "08:48:50" , 
"departure_time" : "08:48:50" , 
"distance_traveled" : 30.7256
} ], 
"1664" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "20:13:00" , 
"departure_time" : "20:14:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "20:25:08" , 
"departure_time" : "20:25:45" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "20:32:37" , 
"departure_time" : "20:33:17" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "20:36:40" , 
"departure_time" : "20:37:17" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "20:38:37" , 
"departure_time" : "20:39:11" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "20:41:34" , 
"departure_time" : "20:42:37" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "20:47:03" , 
"departure_time" : "20:48:02" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "20:49:59" , 
"departure_time" : "20:51:03" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "20:54:04" , 
"departure_time" : "20:54:48" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "20:56:44" , 
"departure_time" : "20:57:49" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "21:00:05" , 
"departure_time" : "21:00:44" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "21:03:39" , 
"departure_time" : "21:03:56" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "21:06:17" , 
"departure_time" : "21:07:44" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "21:11:27" , 
"departure_time" : "21:12:36" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "21:14:09" , 
"departure_time" : "21:15:27" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "21:17:18" , 
"departure_time" : "21:17:26" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "21:20:08" , 
"departure_time" : "21:20:08" , 
"distance_traveled" : 29.571
} ], 
"1665" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "08:35:00" , 
"departure_time" : "08:35:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:46:18" , 
"departure_time" : "08:47:28" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "08:53:10" , 
"departure_time" : "08:53:54" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "08:54:44" , 
"departure_time" : "08:54:57" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "08:57:13" , 
"departure_time" : "08:58:18" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "09:01:05" , 
"departure_time" : "09:01:35" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "09:03:30" , 
"departure_time" : "09:04:48" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "09:10:18" , 
"departure_time" : "09:11:21" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "09:15:03" , 
"departure_time" : "09:15:26" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "09:18:23" , 
"departure_time" : "09:18:24" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "09:27:01" , 
"departure_time" : "09:27:49" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "09:30:48" , 
"departure_time" : "09:30:54" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "09:33:06" , 
"departure_time" : "09:33:36" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "09:37:30" , 
"departure_time" : "09:38:23" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "09:42:53" , 
"departure_time" : "09:43:26" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "09:45:33" , 
"departure_time" : "09:46:33" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "09:49:00" , 
"departure_time" : "09:50:10" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "09:52:10" , 
"departure_time" : "09:52:10" , 
"distance_traveled" : 30.7256
} ], 
"1666" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "21:11:00" , 
"departure_time" : "21:12:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "21:22:40" , 
"departure_time" : "21:22:52" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "21:30:12" , 
"departure_time" : "21:31:48" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "21:34:36" , 
"departure_time" : "21:34:38" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "21:37:02" , 
"departure_time" : "21:37:37" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "21:40:35" , 
"departure_time" : "21:41:09" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "21:45:34" , 
"departure_time" : "21:46:28" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "21:49:54" , 
"departure_time" : "21:50:14" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "21:52:20" , 
"departure_time" : "21:53:40" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "21:57:20" , 
"departure_time" : "21:58:40" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "22:00:20" , 
"departure_time" : "22:00:38" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "22:03:18" , 
"departure_time" : "22:04:29" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "22:08:11" , 
"departure_time" : "22:09:07" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "22:12:56" , 
"departure_time" : "22:13:48" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "22:15:52" , 
"departure_time" : "22:16:48" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "22:18:56" , 
"departure_time" : "22:19:44" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "22:22:48" , 
"departure_time" : "22:22:48" , 
"distance_traveled" : 29.571
} ], 
"1667" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "11:45:00" , 
"departure_time" : "11:47:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "11:57:15" , 
"departure_time" : "11:57:58" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "12:02:43" , 
"departure_time" : "12:03:06" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "12:04:23" , 
"departure_time" : "12:05:56" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "12:08:33" , 
"departure_time" : "12:09:52" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "12:12:19" , 
"departure_time" : "12:12:58" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "12:14:39" , 
"departure_time" : "12:15:23" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "12:21:44" , 
"departure_time" : "12:22:10" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "12:25:26" , 
"departure_time" : "12:25:58" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "12:29:32" , 
"departure_time" : "12:30:26" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "12:32:54" , 
"departure_time" : "12:32:56" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "12:35:02" , 
"departure_time" : "12:36:27" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "12:40:25" , 
"departure_time" : "12:41:49" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "12:43:24" , 
"departure_time" : "12:43:32" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "12:46:08" , 
"departure_time" : "12:46:23" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "12:49:15" , 
"departure_time" : "12:50:20" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "12:53:05" , 
"departure_time" : "12:53:19" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "12:56:14" , 
"departure_time" : "12:56:14" , 
"distance_traveled" : 30.7256
} ], 
"1668" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "23:17:00" , 
"departure_time" : "23:18:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "23:29:05" , 
"departure_time" : "23:30:00" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "23:36:55" , 
"departure_time" : "23:37:11" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "23:39:16" , 
"departure_time" : "23:40:45" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "23:44:29" , 
"departure_time" : "23:45:12" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "23:45:43" , 
"departure_time" : "23:47:08" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "23:52:25" , 
"departure_time" : "23:53:52" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "23:55:27" , 
"departure_time" : "23:55:59" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "23:58:32" , 
"departure_time" : "23:59:19" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "24:01:47" , 
"departure_time" : "24:02:27" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "24:05:40" , 
"departure_time" : "24:06:43" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "24:09:03" , 
"departure_time" : "24:10:19" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "24:13:16" , 
"departure_time" : "24:14:47" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "24:18:31" , 
"departure_time" : "24:18:49" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "24:20:18" , 
"departure_time" : "24:20:49" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "24:23:31" , 
"departure_time" : "24:24:34" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "24:28:03" , 
"departure_time" : "24:28:03" , 
"distance_traveled" : 29.571
} ], 
"1669" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "14:46:00" , 
"departure_time" : "14:48:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "14:57:59" , 
"departure_time" : "14:59:26" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "15:04:27" , 
"departure_time" : "15:04:41" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "15:05:14" , 
"departure_time" : "15:06:22" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "15:09:08" , 
"departure_time" : "15:10:22" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "15:12:14" , 
"departure_time" : "15:13:38" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "15:16:24" , 
"departure_time" : "15:17:16" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "15:21:52" , 
"departure_time" : "15:22:58" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "15:27:06" , 
"departure_time" : "15:27:39" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "15:30:33" , 
"departure_time" : "15:31:46" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "15:34:13" , 
"departure_time" : "15:34:26" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "15:37:13" , 
"departure_time" : "15:38:12" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "15:40:59" , 
"departure_time" : "15:42:05" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "15:46:06" , 
"departure_time" : "15:46:48" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "15:49:42" , 
"departure_time" : "15:49:44" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "15:52:02" , 
"departure_time" : "15:53:36" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "15:56:34" , 
"departure_time" : "15:57:40" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "15:59:06" , 
"departure_time" : "15:59:06" , 
"distance_traveled" : 30.7256
} ], 
"1670" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "10:45:00" , 
"departure_time" : "10:46:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "10:56:35" , 
"departure_time" : "10:57:37" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "11:03:02" , 
"departure_time" : "11:04:28" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "11:05:26" , 
"departure_time" : "11:05:45" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "11:07:19" , 
"departure_time" : "11:07:50" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "11:11:31" , 
"departure_time" : "11:12:28" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "11:14:57" , 
"departure_time" : "11:15:10" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "11:21:13" , 
"departure_time" : "11:21:19" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "11:25:06" , 
"departure_time" : "11:25:07" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "11:29:01" , 
"departure_time" : "11:29:29" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "11:32:28" , 
"departure_time" : "11:32:56" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "11:35:28" , 
"departure_time" : "11:35:45" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "11:39:17" , 
"departure_time" : "11:40:14" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "11:42:57" , 
"departure_time" : "11:43:19" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "11:46:22" , 
"departure_time" : "11:46:36" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "11:49:14" , 
"departure_time" : "11:49:39" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "11:52:25" , 
"departure_time" : "11:53:58" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "11:57:33" , 
"departure_time" : "11:57:33" , 
"distance_traveled" : 30.7256
} ], 
"1671" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:53:00" , 
"departure_time" : "18:55:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:05:18" , 
"departure_time" : "19:06:03" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "19:11:45" , 
"departure_time" : "19:11:56" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "19:14:11" , 
"departure_time" : "19:15:33" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "19:18:22" , 
"departure_time" : "19:19:25" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "19:21:03" , 
"departure_time" : "19:21:05" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "19:24:02" , 
"departure_time" : "19:24:45" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "19:31:43" , 
"departure_time" : "19:32:20" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "19:36:37" , 
"departure_time" : "19:36:44" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "19:40:07" , 
"departure_time" : "19:40:18" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "19:44:11" , 
"departure_time" : "19:45:33" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "19:48:22" , 
"departure_time" : "19:49:02" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "19:51:40" , 
"departure_time" : "19:51:55" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "19:55:15" , 
"departure_time" : "19:56:53" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "20:01:38" , 
"departure_time" : "20:02:28" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "20:02:50" , 
"departure_time" : "20:03:12" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "20:06:22" , 
"departure_time" : "20:06:30" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "20:09:08" , 
"departure_time" : "20:09:08" , 
"distance_traveled" : 30.7256
} ], 
"1672" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "25:32:00" , 
"departure_time" : "25:33:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "25:43:53" , 
"departure_time" : "25:44:12" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "25:49:19" , 
"departure_time" : "25:50:16" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "25:51:57" , 
"departure_time" : "25:52:24" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "25:54:27" , 
"departure_time" : "25:54:33" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "25:57:06" , 
"departure_time" : "25:58:45" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "26:01:39" , 
"departure_time" : "26:03:05" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "26:06:26" , 
"departure_time" : "26:06:54" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "26:09:28" , 
"departure_time" : "26:10:33" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "26:14:05" , 
"departure_time" : "26:15:01" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "26:17:56" , 
"departure_time" : "26:18:14" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "26:20:18" , 
"departure_time" : "26:21:19" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "26:25:01" , 
"departure_time" : "26:26:14" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "26:28:13" , 
"departure_time" : "26:28:51" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "26:32:38" , 
"departure_time" : "26:33:48" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "26:35:10" , 
"departure_time" : "26:35:12" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "26:38:02" , 
"departure_time" : "26:38:38" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "26:41:36" , 
"departure_time" : "26:41:36" , 
"distance_traveled" : 30.7256
} ], 
"1673" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "19:46:00" , 
"departure_time" : "19:47:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:57:40" , 
"departure_time" : "19:58:22" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "20:03:42" , 
"departure_time" : "20:04:55" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "20:07:13" , 
"departure_time" : "20:08:10" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "20:09:57" , 
"departure_time" : "20:10:32" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "20:12:35" , 
"departure_time" : "20:14:06" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "20:16:31" , 
"departure_time" : "20:17:17" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "20:21:46" , 
"departure_time" : "20:23:20" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "20:27:34" , 
"departure_time" : "20:28:14" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "20:30:40" , 
"departure_time" : "20:31:24" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "20:34:44" , 
"departure_time" : "20:35:29" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "20:38:45" , 
"departure_time" : "20:40:17" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "20:42:32" , 
"departure_time" : "20:42:58" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "20:45:26" , 
"departure_time" : "20:46:39" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "20:51:13" , 
"departure_time" : "20:51:44" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "20:53:31" , 
"departure_time" : "20:54:26" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "20:56:55" , 
"departure_time" : "20:57:58" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "21:01:03" , 
"departure_time" : "21:01:03" , 
"distance_traveled" : 30.7256
} ], 
"1674" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "06:58:00" , 
"departure_time" : "07:00:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:10:14" , 
"departure_time" : "07:11:53" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "07:16:39" , 
"departure_time" : "07:16:53" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "07:17:14" , 
"departure_time" : "07:17:18" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "07:20:04" , 
"departure_time" : "07:21:14" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "07:24:10" , 
"departure_time" : "07:25:29" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "07:27:19" , 
"departure_time" : "07:28:42" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "07:32:23" , 
"departure_time" : "07:32:31" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "07:35:08" , 
"departure_time" : "07:35:42" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "07:39:34" , 
"departure_time" : "07:40:43" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "07:44:09" , 
"departure_time" : "07:45:10" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "07:47:01" , 
"departure_time" : "07:48:36" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "07:52:35" , 
"departure_time" : "07:53:27" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "07:55:52" , 
"departure_time" : "07:56:46" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "07:59:54" , 
"departure_time" : "08:01:03" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "08:03:09" , 
"departure_time" : "08:04:32" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "08:06:23" , 
"departure_time" : "08:07:24" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "08:10:01" , 
"departure_time" : "08:10:01" , 
"distance_traveled" : 30.7256
} ], 
"1675" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "20:46:00" , 
"departure_time" : "20:48:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "20:58:25" , 
"departure_time" : "20:58:57" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "21:03:32" , 
"departure_time" : "21:03:58" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "21:06:26" , 
"departure_time" : "21:07:30" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "21:10:04" , 
"departure_time" : "21:10:35" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "21:12:31" , 
"departure_time" : "21:12:45" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "21:15:14" , 
"departure_time" : "21:16:46" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "21:22:32" , 
"departure_time" : "21:23:39" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "21:27:07" , 
"departure_time" : "21:27:30" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "21:30:23" , 
"departure_time" : "21:31:01" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "21:34:38" , 
"departure_time" : "21:35:36" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "21:38:58" , 
"departure_time" : "21:39:56" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "21:41:58" , 
"departure_time" : "21:43:38" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "21:46:40" , 
"departure_time" : "21:47:53" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "21:51:13" , 
"departure_time" : "21:52:23" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "21:54:10" , 
"departure_time" : "21:54:32" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "21:56:22" , 
"departure_time" : "21:56:54" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "22:00:32" , 
"departure_time" : "22:00:32" , 
"distance_traveled" : 30.7256
} ], 
"1676" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "07:38:00" , 
"departure_time" : "07:39:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:49:56" , 
"departure_time" : "07:51:35" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "07:56:39" , 
"departure_time" : "07:58:04" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "07:58:25" , 
"departure_time" : "07:58:31" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "08:00:06" , 
"departure_time" : "08:01:43" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "08:04:37" , 
"departure_time" : "08:06:09" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "08:07:32" , 
"departure_time" : "08:08:01" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "08:11:29" , 
"departure_time" : "08:12:30" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "08:17:01" , 
"departure_time" : "08:17:51" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "08:20:50" , 
"departure_time" : "08:20:56" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "08:24:06" , 
"departure_time" : "08:25:22" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "08:28:16" , 
"departure_time" : "08:29:09" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "08:30:53" , 
"departure_time" : "08:31:43" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "08:34:50" , 
"departure_time" : "08:36:03" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "08:39:13" , 
"departure_time" : "08:40:38" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "08:42:25" , 
"departure_time" : "08:43:59" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "08:45:34" , 
"departure_time" : "08:46:28" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "08:48:54" , 
"departure_time" : "08:48:54" , 
"distance_traveled" : 30.7256
} ], 
"1677" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "22:55:00" , 
"departure_time" : "22:57:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "23:07:11" , 
"departure_time" : "23:08:21" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "23:13:10" , 
"departure_time" : "23:13:29" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "23:14:19" , 
"departure_time" : "23:15:25" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "23:18:06" , 
"departure_time" : "23:18:11" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "23:21:05" , 
"departure_time" : "23:22:28" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "23:25:23" , 
"departure_time" : "23:25:43" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "23:31:20" , 
"departure_time" : "23:32:40" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "23:36:20" , 
"departure_time" : "23:37:22" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "23:40:02" , 
"departure_time" : "23:41:36" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "23:43:34" , 
"departure_time" : "23:44:45" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "23:46:11" , 
"departure_time" : "23:47:06" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "23:48:55" , 
"departure_time" : "23:49:04" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "23:51:09" , 
"departure_time" : "23:52:29" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "23:56:20" , 
"departure_time" : "23:57:22" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "24:00:02" , 
"departure_time" : "24:01:28" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "24:03:26" , 
"departure_time" : "24:04:36" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "24:07:10" , 
"departure_time" : "24:07:10" , 
"distance_traveled" : 30.7256
} ], 
"1678" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "08:35:00" , 
"departure_time" : "08:36:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:46:28" , 
"departure_time" : "08:46:36" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "08:52:08" , 
"departure_time" : "08:52:34" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "08:54:26" , 
"departure_time" : "08:55:27" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "08:58:01" , 
"departure_time" : "08:58:42" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "09:00:41" , 
"departure_time" : "09:01:41" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "09:04:00" , 
"departure_time" : "09:04:49" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "09:09:49" , 
"departure_time" : "09:10:51" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "09:15:02" , 
"departure_time" : "09:15:06" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "09:18:04" , 
"departure_time" : "09:18:48" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "09:27:44" , 
"departure_time" : "09:27:54" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "09:30:10" , 
"departure_time" : "09:30:25" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "09:33:15" , 
"departure_time" : "09:34:26" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "09:38:11" , 
"departure_time" : "09:38:23" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "09:42:12" , 
"departure_time" : "09:42:22" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "09:45:10" , 
"departure_time" : "09:45:40" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "09:48:30" , 
"departure_time" : "09:49:57" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "09:52:27" , 
"departure_time" : "09:52:27" , 
"distance_traveled" : 30.7256
} ], 
"1679" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:56:00" , 
"departure_time" : "16:59:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:08:35" , 
"departure_time" : "17:09:16" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "17:15:41" , 
"departure_time" : "17:17:14" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "17:20:33" , 
"departure_time" : "17:21:39" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 121,
"arrival_time" : "17:25:06" , 
"departure_time" : "17:25:12" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "17:30:06" , 
"departure_time" : "17:31:45" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "17:34:39" , 
"departure_time" : "17:35:00" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "17:37:21" , 
"departure_time" : "17:37:23" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "17:40:02" , 
"departure_time" : "17:40:02" , 
"distance_traveled" : 19.8432
} ], 
"1680" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "11:45:00" , 
"departure_time" : "11:45:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "11:56:53" , 
"departure_time" : "11:57:00" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "12:02:07" , 
"departure_time" : "12:02:23" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "12:04:16" , 
"departure_time" : "12:05:03" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "12:07:47" , 
"departure_time" : "12:09:21" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "12:12:34" , 
"departure_time" : "12:13:28" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "12:14:54" , 
"departure_time" : "12:15:12" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "12:21:18" , 
"departure_time" : "12:22:08" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "12:25:50" , 
"departure_time" : "12:27:29" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "12:30:39" , 
"departure_time" : "12:31:34" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "12:32:55" , 
"departure_time" : "12:34:15" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "12:36:20" , 
"departure_time" : "12:37:52" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "12:40:32" , 
"departure_time" : "12:41:13" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "12:42:41" , 
"departure_time" : "12:44:17" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "12:47:36" , 
"departure_time" : "12:47:59" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "12:49:23" , 
"departure_time" : "12:50:33" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "12:53:10" , 
"departure_time" : "12:54:05" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "12:56:55" , 
"departure_time" : "12:56:55" , 
"distance_traveled" : 30.7256
} ], 
"1681" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "14:46:00" , 
"departure_time" : "14:47:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "14:57:31" , 
"departure_time" : "14:57:44" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "15:03:13" , 
"departure_time" : "15:04:27" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "15:06:14" , 
"departure_time" : "15:06:20" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "15:08:06" , 
"departure_time" : "15:09:26" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "15:12:20" , 
"departure_time" : "15:12:57" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "15:15:37" , 
"departure_time" : "15:16:54" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "15:22:17" , 
"departure_time" : "15:23:31" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "15:27:14" , 
"departure_time" : "15:27:54" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "15:30:40" , 
"departure_time" : "15:30:45" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "15:33:05" , 
"departure_time" : "15:33:49" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "15:37:44" , 
"departure_time" : "15:38:05" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "15:40:21" , 
"departure_time" : "15:40:40" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "15:45:19" , 
"departure_time" : "15:46:55" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "15:50:36" , 
"departure_time" : "15:51:33" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "15:52:57" , 
"departure_time" : "15:53:31" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "15:55:34" , 
"departure_time" : "15:56:03" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "15:58:29" , 
"departure_time" : "15:58:29" , 
"distance_traveled" : 30.7256
} ], 
"1682" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:53:00" , 
"departure_time" : "18:54:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:05:24" , 
"departure_time" : "19:06:01" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "19:11:37" , 
"departure_time" : "19:11:57" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "19:14:20" , 
"departure_time" : "19:15:10" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "19:17:50" , 
"departure_time" : "19:18:50" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "19:21:00" , 
"departure_time" : "19:21:48" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "19:24:48" , 
"departure_time" : "19:26:24" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "19:32:36" , 
"departure_time" : "19:33:48" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "19:37:12" , 
"departure_time" : "19:38:27" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "19:41:15" , 
"departure_time" : "19:41:50" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "19:44:35" , 
"departure_time" : "19:45:45" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "19:48:10" , 
"departure_time" : "19:49:01" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "19:51:51" , 
"departure_time" : "19:53:26" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "19:56:35" , 
"departure_time" : "19:57:32" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "20:00:57" , 
"departure_time" : "20:01:26" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "20:02:29" , 
"departure_time" : "20:03:10" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "20:06:41" , 
"departure_time" : "20:07:41" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "20:10:00" , 
"departure_time" : "20:10:00" , 
"distance_traveled" : 30.7256
} ], 
"1683" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "19:46:00" , 
"departure_time" : "19:47:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:57:46" , 
"departure_time" : "19:58:01" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "20:03:15" , 
"departure_time" : "20:04:47" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "20:07:32" , 
"departure_time" : "20:09:11" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "20:10:39" , 
"departure_time" : "20:10:40" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "20:12:01" , 
"departure_time" : "20:13:13" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "20:16:12" , 
"departure_time" : "20:17:24" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "20:22:12" , 
"departure_time" : "20:22:23" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "20:26:11" , 
"departure_time" : "20:27:37" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "20:31:26" , 
"departure_time" : "20:33:03" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "20:35:37" , 
"departure_time" : "20:36:08" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "20:38:31" , 
"departure_time" : "20:39:49" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "20:42:18" , 
"departure_time" : "20:43:28" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "20:46:10" , 
"departure_time" : "20:46:19" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "20:50:09" , 
"departure_time" : "20:50:21" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "20:53:12" , 
"departure_time" : "20:54:04" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "20:56:52" , 
"departure_time" : "20:56:58" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "21:00:06" , 
"departure_time" : "21:00:06" , 
"distance_traveled" : 30.7256
} ], 
"1684" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "20:46:00" , 
"departure_time" : "20:46:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "20:57:16" , 
"departure_time" : "20:58:16" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "21:04:00" , 
"departure_time" : "21:05:03" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "21:07:03" , 
"departure_time" : "21:07:18" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "21:09:15" , 
"departure_time" : "21:09:39" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "21:12:24" , 
"departure_time" : "21:13:11" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "21:15:47" , 
"departure_time" : "21:15:59" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "21:21:12" , 
"departure_time" : "21:21:56" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "21:26:44" , 
"departure_time" : "21:27:18" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "21:30:34" , 
"departure_time" : "21:31:55" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "21:35:21" , 
"departure_time" : "21:35:44" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "21:38:23" , 
"departure_time" : "21:39:43" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "21:42:20" , 
"departure_time" : "21:43:41" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "21:46:21" , 
"departure_time" : "21:47:01" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "21:50:40" , 
"departure_time" : "21:51:17" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "21:53:37" , 
"departure_time" : "21:54:21" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "21:56:44" , 
"departure_time" : "21:57:21" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "22:00:37" , 
"departure_time" : "22:00:37" , 
"distance_traveled" : 30.7256
} ], 
"1685" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "22:55:00" , 
"departure_time" : "22:56:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "23:06:36" , 
"departure_time" : "23:07:45" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "23:13:09" , 
"departure_time" : "23:14:31" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "23:15:22" , 
"departure_time" : "23:15:36" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "23:17:14" , 
"departure_time" : "23:17:52" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "23:21:38" , 
"departure_time" : "23:22:16" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "23:24:38" , 
"departure_time" : "23:25:15" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "23:31:37" , 
"departure_time" : "23:32:34" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "23:35:57" , 
"departure_time" : "23:36:50" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "23:39:53" , 
"departure_time" : "23:41:11" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "23:43:18" , 
"departure_time" : "23:43:56" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "23:45:38" , 
"departure_time" : "23:46:28" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "23:48:50" , 
"departure_time" : "23:50:26" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "23:52:36" , 
"departure_time" : "23:54:02" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "23:56:26" , 
"departure_time" : "23:57:58" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "24:00:32" , 
"departure_time" : "24:01:02" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "24:02:30" , 
"departure_time" : "24:03:45" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "24:07:15" , 
"departure_time" : "24:07:15" , 
"distance_traveled" : 30.7256
} ], 
"1686" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:56:00" , 
"departure_time" : "16:58:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:07:51" , 
"departure_time" : "17:09:28" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "17:16:37" , 
"departure_time" : "17:17:44" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "17:20:07" , 
"departure_time" : "17:20:57" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 121,
"arrival_time" : "17:24:50" , 
"departure_time" : "17:26:17" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "17:31:27" , 
"departure_time" : "17:31:48" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "17:33:21" , 
"departure_time" : "17:34:32" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "17:38:11" , 
"departure_time" : "17:38:46" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "17:40:35" , 
"departure_time" : "17:40:35" , 
"distance_traveled" : 19.8432
} ], 
"1687" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:37:00" , 
"departure_time" : "17:38:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:48:57" , 
"departure_time" : "17:49:01" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "17:56:04" , 
"departure_time" : "17:57:20" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "18:01:16" , 
"departure_time" : "18:01:53" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "18:03:37" , 
"departure_time" : "18:04:17" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "18:06:40" , 
"departure_time" : "18:08:19" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "18:12:39" , 
"departure_time" : "18:13:10" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "18:14:31" , 
"departure_time" : "18:14:32" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "18:18:01" , 
"departure_time" : "18:19:10" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:22:09" , 
"departure_time" : "18:22:37" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "18:25:28" , 
"departure_time" : "18:25:34" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "18:28:06" , 
"departure_time" : "18:29:35" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "18:32:29" , 
"departure_time" : "18:33:23" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "18:35:54" , 
"departure_time" : "18:36:43" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "18:39:49" , 
"departure_time" : "18:40:13" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "18:42:24" , 
"departure_time" : "18:43:16" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "18:46:52" , 
"departure_time" : "18:46:52" , 
"distance_traveled" : 29.571
} ], 
"1688" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:01:00" , 
"departure_time" : "17:02:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:12:05" , 
"departure_time" : "17:12:32" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "17:17:27" , 
"departure_time" : "17:19:06" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "17:21:39" , 
"departure_time" : "17:22:40" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "17:23:01" , 
"departure_time" : "17:23:35" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "17:25:34" , 
"departure_time" : "17:26:33" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "17:29:59" , 
"departure_time" : "17:31:01" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "17:35:02" , 
"departure_time" : "17:35:59" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "17:38:57" , 
"departure_time" : "17:40:13" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "17:43:16" , 
"departure_time" : "17:44:52" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "17:47:36" , 
"departure_time" : "17:48:04" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "17:49:28" , 
"departure_time" : "17:49:50" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "17:53:22" , 
"departure_time" : "17:54:57" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "17:58:35" , 
"departure_time" : "17:59:11" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "18:02:36" , 
"departure_time" : "18:04:02" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "18:05:26" , 
"departure_time" : "18:05:50" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "18:08:24" , 
"departure_time" : "18:08:46" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "18:12:22" , 
"departure_time" : "18:12:22" , 
"distance_traveled" : 30.7256
} ], 
"1689" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:56:00" , 
"departure_time" : "17:57:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:08:23" , 
"departure_time" : "18:09:40" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "18:14:17" , 
"departure_time" : "18:15:34" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "18:16:17" , 
"departure_time" : "18:16:25" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "18:19:08" , 
"departure_time" : "18:20:01" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "18:22:53" , 
"departure_time" : "18:23:06" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "18:26:13" , 
"departure_time" : "18:27:23" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "18:34:10" , 
"departure_time" : "18:35:03" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "18:37:53" , 
"departure_time" : "18:38:53" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "18:42:00" , 
"departure_time" : "18:43:25" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:47:25" , 
"departure_time" : "18:47:58" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "18:50:33" , 
"departure_time" : "18:50:46" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "18:53:13" , 
"departure_time" : "18:54:52" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "18:57:39" , 
"departure_time" : "18:58:53" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "19:01:14" , 
"departure_time" : "19:01:15" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "19:04:01" , 
"departure_time" : "19:05:19" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "19:08:18" , 
"departure_time" : "19:08:51" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "19:11:33" , 
"departure_time" : "19:11:33" , 
"distance_traveled" : 30.7256
} ], 
"1690" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "24:21:00" , 
"departure_time" : "24:22:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "24:31:54" , 
"departure_time" : "24:33:09" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "24:39:15" , 
"departure_time" : "24:40:23" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "24:41:08" , 
"departure_time" : "24:42:44" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "24:44:36" , 
"departure_time" : "24:45:58" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "24:47:22" , 
"departure_time" : "24:48:45" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "24:51:23" , 
"departure_time" : "24:53:02" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "24:56:39" , 
"departure_time" : "24:57:26" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "24:59:47" , 
"departure_time" : "25:00:08" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "25:03:21" , 
"departure_time" : "25:04:56" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "25:07:35" , 
"departure_time" : "25:07:35" , 
"distance_traveled" : 21.0006
} ], 
"1691" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "25:32:00" , 
"departure_time" : "25:33:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "25:43:22" , 
"departure_time" : "25:43:35" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "25:49:13" , 
"departure_time" : "25:50:26" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "25:52:13" , 
"departure_time" : "25:53:06" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "25:54:53" , 
"departure_time" : "25:56:25" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "25:58:32" , 
"departure_time" : "25:59:11" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "26:00:39" , 
"departure_time" : "26:01:12" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "26:05:33" , 
"departure_time" : "26:06:39" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "26:10:06" , 
"departure_time" : "26:11:05" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "26:13:59" , 
"departure_time" : "26:15:37" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "26:18:38" , 
"departure_time" : "26:18:58" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "26:20:20" , 
"departure_time" : "26:21:04" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "26:24:44" , 
"departure_time" : "26:24:58" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "26:27:14" , 
"departure_time" : "26:28:45" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "26:33:31" , 
"departure_time" : "26:34:58" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "26:35:27" , 
"departure_time" : "26:35:51" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "26:38:24" , 
"departure_time" : "26:38:45" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "26:41:21" , 
"departure_time" : "26:41:21" , 
"distance_traveled" : 30.7256
} ], 
"1692" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "21:15:00" , 
"departure_time" : "21:15:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "21:25:30" , 
"departure_time" : "21:26:34" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "21:33:04" , 
"departure_time" : "21:33:44" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "21:34:40" , 
"departure_time" : "21:35:03" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "21:37:23" , 
"departure_time" : "21:37:31" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "21:40:08" , 
"departure_time" : "21:41:39" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "21:45:31" , 
"departure_time" : "21:46:00" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "21:49:29" , 
"departure_time" : "21:50:25" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "21:53:56" , 
"departure_time" : "21:54:20" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "21:57:24" , 
"departure_time" : "21:57:34" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "22:01:10" , 
"departure_time" : "22:01:10" , 
"distance_traveled" : 21.0006
} ], 
"1693" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "22:13:00" , 
"departure_time" : "22:14:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "22:24:26" , 
"departure_time" : "22:24:35" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "22:30:09" , 
"departure_time" : "22:31:01" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "22:32:52" , 
"departure_time" : "22:34:13" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "22:36:21" , 
"departure_time" : "22:37:39" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "22:39:18" , 
"departure_time" : "22:39:50" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "22:42:32" , 
"departure_time" : "22:42:55" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "22:48:23" , 
"departure_time" : "22:48:59" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "22:53:36" , 
"departure_time" : "22:54:09" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "22:57:33" , 
"departure_time" : "22:58:39" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "23:02:06" , 
"departure_time" : "23:02:06" , 
"distance_traveled" : 21.0006
} ], 
"1694" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "23:13:00" , 
"departure_time" : "23:14:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "23:23:30" , 
"departure_time" : "23:24:24" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "23:30:54" , 
"departure_time" : "23:31:22" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "23:32:28" , 
"departure_time" : "23:32:41" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "23:35:13" , 
"departure_time" : "23:36:43" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "23:39:30" , 
"departure_time" : "23:40:43" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "23:43:13" , 
"departure_time" : "23:44:11" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "23:48:58" , 
"departure_time" : "23:50:22" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "23:54:24" , 
"departure_time" : "23:55:45" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "23:58:21" , 
"departure_time" : "23:59:35" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "24:02:14" , 
"departure_time" : "24:02:14" , 
"distance_traveled" : 21.0006
} ], 
"1695" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "06:17:00" , 
"departure_time" : "06:19:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "06:27:51" , 
"departure_time" : "06:29:20" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "06:36:29" , 
"departure_time" : "06:38:04" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "06:40:35" , 
"departure_time" : "06:41:25" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 121,
"arrival_time" : "06:44:50" , 
"departure_time" : "06:45:00" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "06:49:10" , 
"departure_time" : "06:50:49" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "06:53:39" , 
"departure_time" : "06:54:25" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "06:55:46" , 
"departure_time" : "06:56:58" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "07:00:12" , 
"departure_time" : "07:00:53" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "07:03:41" , 
"departure_time" : "07:03:43" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "07:07:02" , 
"departure_time" : "07:07:02" , 
"distance_traveled" : 22.3157
} ], 
"1696" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "07:17:00" , 
"departure_time" : "07:17:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:27:27" , 
"departure_time" : "07:28:01" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "07:35:34" , 
"departure_time" : "07:37:10" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "07:40:36" , 
"departure_time" : "07:42:04" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "07:43:28" , 
"departure_time" : "07:44:57" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "07:46:29" , 
"departure_time" : "07:47:24" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "07:50:55" , 
"departure_time" : "07:51:20" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "07:54:25" , 
"departure_time" : "07:55:10" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "07:57:45" , 
"departure_time" : "07:58:48" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "08:02:03" , 
"departure_time" : "08:02:50" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "08:04:47" , 
"departure_time" : "08:05:48" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "08:09:01" , 
"departure_time" : "08:09:01" , 
"distance_traveled" : 22.3157
} ], 
"1697" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "08:17:00" , 
"departure_time" : "08:18:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:27:29" , 
"departure_time" : "08:27:40" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "08:35:11" , 
"departure_time" : "08:36:42" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "08:40:31" , 
"departure_time" : "08:40:39" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "08:42:08" , 
"departure_time" : "08:43:23" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "08:46:15" , 
"departure_time" : "08:47:39" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "08:51:24" , 
"departure_time" : "08:51:48" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "08:54:24" , 
"departure_time" : "08:54:57" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "08:57:33" , 
"departure_time" : "08:58:39" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "09:02:06" , 
"departure_time" : "09:03:02" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "09:04:56" , 
"departure_time" : "09:06:02" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "09:09:06" , 
"departure_time" : "09:09:06" , 
"distance_traveled" : 22.3157
} ], 
"1698" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "10:17:00" , 
"departure_time" : "10:19:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "10:28:28" , 
"departure_time" : "10:29:48" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "10:36:20" , 
"departure_time" : "10:37:02" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "10:39:42" , 
"departure_time" : "10:40:12" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "10:42:30" , 
"departure_time" : "10:43:42" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "10:46:12" , 
"departure_time" : "10:46:20" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "10:50:08" , 
"departure_time" : "10:50:18" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "10:54:10" , 
"departure_time" : "10:55:47" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "10:58:37" , 
"departure_time" : "10:59:32" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "11:01:55" , 
"departure_time" : "11:01:58" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "11:04:03" , 
"departure_time" : "11:04:55" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "11:08:52" , 
"departure_time" : "11:08:52" , 
"distance_traveled" : 22.3157
} ], 
"1699" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "12:17:00" , 
"departure_time" : "12:18:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "12:27:53" , 
"departure_time" : "12:28:34" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "12:35:41" , 
"departure_time" : "12:37:16" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "12:40:35" , 
"departure_time" : "12:40:40" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "12:42:05" , 
"departure_time" : "12:42:36" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "12:45:31" , 
"departure_time" : "12:47:11" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "12:51:40" , 
"departure_time" : "12:52:58" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "12:55:18" , 
"departure_time" : "12:56:15" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "12:57:57" , 
"departure_time" : "12:58:25" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "13:01:28" , 
"departure_time" : "13:02:10" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "13:04:42" , 
"departure_time" : "13:05:27" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "13:08:45" , 
"departure_time" : "13:08:45" , 
"distance_traveled" : 22.3157
} ], 
"1700" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "13:17:00" , 
"departure_time" : "13:18:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "13:27:41" , 
"departure_time" : "13:29:05" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "13:36:24" , 
"departure_time" : "13:36:27" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "13:39:03" , 
"departure_time" : "13:39:25" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "13:42:22" , 
"departure_time" : "13:43:00" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "13:45:38" , 
"departure_time" : "13:46:07" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "13:50:29" , 
"departure_time" : "13:50:49" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "13:54:20" , 
"departure_time" : "13:54:34" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "13:57:14" , 
"departure_time" : "13:57:47" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "14:01:33" , 
"departure_time" : "14:02:40" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "14:05:07" , 
"departure_time" : "14:06:04" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "14:08:57" , 
"departure_time" : "14:08:57" , 
"distance_traveled" : 22.3157
} ], 
"1701" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "14:17:00" , 
"departure_time" : "14:18:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "14:27:31" , 
"departure_time" : "14:27:57" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "14:35:26" , 
"departure_time" : "14:36:14" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "14:39:48" , 
"departure_time" : "14:40:53" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "14:43:05" , 
"departure_time" : "14:43:49" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "14:45:44" , 
"departure_time" : "14:45:49" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "14:50:05" , 
"departure_time" : "14:50:11" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "14:54:06" , 
"departure_time" : "14:54:33" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "14:57:27" , 
"departure_time" : "14:58:22" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "15:01:55" , 
"departure_time" : "15:03:23" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "15:05:28" , 
"departure_time" : "15:05:40" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "15:08:12" , 
"departure_time" : "15:08:12" , 
"distance_traveled" : 22.3157
} ], 
"1702" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "15:17:00" , 
"departure_time" : "15:17:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "15:27:36" , 
"departure_time" : "15:28:14" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "15:35:38" , 
"departure_time" : "15:35:43" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "15:39:05" , 
"departure_time" : "15:39:44" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "15:42:39" , 
"departure_time" : "15:44:07" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "15:46:28" , 
"departure_time" : "15:47:19" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "15:50:51" , 
"departure_time" : "15:51:56" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "15:55:05" , 
"departure_time" : "15:55:43" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "15:57:38" , 
"departure_time" : "15:58:54" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "16:02:16" , 
"departure_time" : "16:03:04" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "16:04:48" , 
"departure_time" : "16:06:17" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "16:09:29" , 
"departure_time" : "16:09:29" , 
"distance_traveled" : 22.3157
} ], 
"1703" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:17:00" , 
"departure_time" : "16:19:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:28:04" , 
"departure_time" : "16:28:10" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "16:35:06" , 
"departure_time" : "16:35:43" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "16:39:37" , 
"departure_time" : "16:40:19" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "16:42:42" , 
"departure_time" : "16:43:37" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "16:45:55" , 
"departure_time" : "16:46:45" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "16:50:50" , 
"departure_time" : "16:51:01" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "16:54:11" , 
"departure_time" : "16:55:13" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "16:58:02" , 
"departure_time" : "16:58:30" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "17:01:28" , 
"departure_time" : "17:03:06" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "17:05:38" , 
"departure_time" : "17:05:42" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "17:07:04" , 
"departure_time" : "17:07:04" , 
"distance_traveled" : 22.3157
} ], 
"1704" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:17:00" , 
"departure_time" : "17:17:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:27:09" , 
"departure_time" : "17:27:18" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "17:35:09" , 
"departure_time" : "17:36:27" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "17:40:18" , 
"departure_time" : "17:41:29" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "17:43:11" , 
"departure_time" : "17:44:26" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "17:46:15" , 
"departure_time" : "17:46:22" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "17:50:07" , 
"departure_time" : "17:50:17" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "17:54:10" , 
"departure_time" : "17:55:31" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "17:58:21" , 
"departure_time" : "17:59:40" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:02:19" , 
"departure_time" : "18:03:33" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "18:05:14" , 
"departure_time" : "18:06:46" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "18:09:32" , 
"departure_time" : "18:09:32" , 
"distance_traveled" : 22.3157
} ], 
"1705" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:17:00" , 
"departure_time" : "18:18:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:27:05" , 
"departure_time" : "18:27:14" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "18:35:09" , 
"departure_time" : "18:35:19" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "18:39:10" , 
"departure_time" : "18:39:57" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "18:42:47" , 
"departure_time" : "18:43:33" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "18:45:46" , 
"departure_time" : "18:47:17" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "18:51:31" , 
"departure_time" : "18:51:37" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "18:54:06" , 
"departure_time" : "18:54:09" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "18:57:03" , 
"departure_time" : "18:58:16" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "19:02:13" , 
"departure_time" : "19:03:22" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "19:05:09" , 
"departure_time" : "19:05:59" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "19:07:50" , 
"departure_time" : "19:07:50" , 
"distance_traveled" : 22.3157
} ], 
"1706" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "19:17:00" , 
"departure_time" : "19:18:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:27:34" , 
"departure_time" : "19:27:42" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "19:35:08" , 
"departure_time" : "19:35:35" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "19:39:27" , 
"departure_time" : "19:40:02" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "19:42:35" , 
"departure_time" : "19:42:56" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "19:45:21" , 
"departure_time" : "19:46:55" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "19:51:34" , 
"departure_time" : "19:52:19" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "19:54:45" , 
"departure_time" : "19:55:06" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "19:57:21" , 
"departure_time" : "19:58:07" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "20:01:46" , 
"departure_time" : "20:02:54" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "20:05:08" , 
"departure_time" : "20:05:44" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "20:06:36" , 
"departure_time" : "20:06:36" , 
"distance_traveled" : 22.3157
} ], 
"1707" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "20:17:00" , 
"departure_time" : "20:19:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "20:28:32" , 
"departure_time" : "20:29:03" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "20:35:31" , 
"departure_time" : "20:36:37" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "20:40:06" , 
"departure_time" : "20:40:08" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "20:42:02" , 
"departure_time" : "20:42:18" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "20:45:16" , 
"departure_time" : "20:46:44" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "20:51:28" , 
"departure_time" : "20:52:27" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "20:54:59" , 
"departure_time" : "20:55:13" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "20:57:14" , 
"departure_time" : "20:57:17" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "21:00:03" , 
"departure_time" : "21:00:44" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "21:04:41" , 
"departure_time" : "21:05:50" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "21:09:09" , 
"departure_time" : "21:09:09" , 
"distance_traveled" : 22.3157
} ], 
"1708" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "22:21:00" , 
"departure_time" : "22:23:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "22:32:10" , 
"departure_time" : "22:33:06" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "22:39:56" , 
"departure_time" : "22:40:12" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "22:43:16" , 
"departure_time" : "22:43:23" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "22:46:07" , 
"departure_time" : "22:46:38" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "22:49:31" , 
"departure_time" : "22:49:39" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "22:54:08" , 
"departure_time" : "22:54:24" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "22:58:16" , 
"departure_time" : "22:58:49" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "23:01:33" , 
"departure_time" : "23:03:02" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "23:06:29" , 
"departure_time" : "23:06:56" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "23:08:27" , 
"departure_time" : "23:09:04" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "23:11:37" , 
"departure_time" : "23:12:21" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "23:15:44" , 
"departure_time" : "23:16:14" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "23:19:30" , 
"departure_time" : "23:20:00" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "23:22:30" , 
"departure_time" : "23:23:45" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "23:26:15" , 
"departure_time" : "23:27:07" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "23:29:52" , 
"departure_time" : "23:29:52" , 
"distance_traveled" : 29.571
} ], 
"1709" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "23:21:00" , 
"departure_time" : "23:22:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "23:31:34" , 
"departure_time" : "23:32:58" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "23:40:24" , 
"departure_time" : "23:41:57" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "23:44:33" , 
"departure_time" : "23:45:39" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "23:47:06" , 
"departure_time" : "23:48:39" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "23:50:33" , 
"departure_time" : "23:51:37" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "23:55:04" , 
"departure_time" : "23:55:33" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "23:58:29" , 
"departure_time" : "23:58:59" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "24:01:30" , 
"departure_time" : "24:01:38" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "24:05:08" , 
"departure_time" : "24:06:06" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "24:08:58" , 
"departure_time" : "24:09:35" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "24:11:37" , 
"departure_time" : "24:12:36" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "24:15:59" , 
"departure_time" : "24:16:27" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "24:19:28" , 
"departure_time" : "24:19:56" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "24:22:28" , 
"departure_time" : "24:22:55" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "24:25:27" , 
"departure_time" : "24:26:10" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "24:29:43" , 
"departure_time" : "24:29:43" , 
"distance_traveled" : 29.571
} ], 
"1710" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "06:25:00" , 
"departure_time" : "06:26:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "06:35:59" , 
"departure_time" : "06:36:37" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "06:41:38" , 
"departure_time" : "06:41:59" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "06:44:21" , 
"departure_time" : "06:45:43" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "06:47:22" , 
"departure_time" : "06:47:27" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "06:49:05" , 
"departure_time" : "06:50:28" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "06:54:23" , 
"departure_time" : "06:54:32" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "06:59:09" , 
"departure_time" : "06:59:32" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "07:04:23" , 
"departure_time" : "07:05:25" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "07:09:02" , 
"departure_time" : "07:10:15" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "07:13:13" , 
"departure_time" : "07:14:12" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "07:15:59" , 
"departure_time" : "07:16:05" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "07:19:06" , 
"departure_time" : "07:19:14" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "07:23:08" , 
"departure_time" : "07:23:58" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "07:28:50" , 
"departure_time" : "07:29:12" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "07:31:22" , 
"departure_time" : "07:32:37" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "07:35:15" , 
"departure_time" : "07:35:33" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "07:40:18" , 
"departure_time" : "07:40:18" , 
"distance_traveled" : 30.7256
} ], 
"1711" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "07:25:00" , 
"departure_time" : "07:26:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:35:54" , 
"departure_time" : "07:36:58" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "07:42:04" , 
"departure_time" : "07:43:44" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "07:45:40" , 
"departure_time" : "07:46:30" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "07:46:50" , 
"departure_time" : "07:47:48" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "07:49:58" , 
"departure_time" : "07:50:10" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "07:53:12" , 
"departure_time" : "07:53:36" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "07:59:24" , 
"departure_time" : "08:00:09" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "08:04:45" , 
"departure_time" : "08:06:01" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "08:09:16" , 
"departure_time" : "08:10:21" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "08:13:05" , 
"departure_time" : "08:13:25" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "08:15:20" , 
"departure_time" : "08:16:27" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "08:20:07" , 
"departure_time" : "08:21:45" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "08:24:38" , 
"departure_time" : "08:25:32" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "08:28:54" , 
"departure_time" : "08:29:43" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "08:31:49" , 
"departure_time" : "08:33:17" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "08:35:28" , 
"departure_time" : "08:36:36" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "08:41:08" , 
"departure_time" : "08:41:08" , 
"distance_traveled" : 30.7256
} ], 
"1712" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "08:25:00" , 
"departure_time" : "08:27:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:36:08" , 
"departure_time" : "08:37:22" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "08:42:14" , 
"departure_time" : "08:42:15" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "08:44:01" , 
"departure_time" : "08:45:28" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "08:47:27" , 
"departure_time" : "08:48:51" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "08:50:24" , 
"departure_time" : "08:51:06" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "08:53:42" , 
"departure_time" : "08:54:58" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "09:00:16" , 
"departure_time" : "09:01:42" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "09:05:26" , 
"departure_time" : "09:05:46" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "09:08:20" , 
"departure_time" : "09:08:36" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "09:12:16" , 
"departure_time" : "09:13:28" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "09:16:12" , 
"departure_time" : "09:16:20" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "09:19:08" , 
"departure_time" : "09:20:07" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "09:23:59" , 
"departure_time" : "09:24:32" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "09:28:33" , 
"departure_time" : "09:30:04" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "09:32:31" , 
"departure_time" : "09:32:44" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "09:34:13" , 
"departure_time" : "09:35:50" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "09:41:37" , 
"departure_time" : "09:41:37" , 
"distance_traveled" : 30.7256
} ], 
"1713" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "09:25:00" , 
"departure_time" : "09:26:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:35:01" , 
"departure_time" : "09:35:58" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "09:41:57" , 
"departure_time" : "09:42:15" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "09:44:18" , 
"departure_time" : "09:45:25" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "09:47:07" , 
"departure_time" : "09:47:44" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "09:49:37" , 
"departure_time" : "09:50:06" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "09:53:29" , 
"departure_time" : "09:54:55" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "10:00:26" , 
"departure_time" : "10:00:42" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "10:04:16" , 
"departure_time" : "10:04:20" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "10:08:04" , 
"departure_time" : "10:09:36" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "10:13:32" , 
"departure_time" : "10:13:36" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "10:15:04" , 
"departure_time" : "10:15:58" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "10:19:54" , 
"departure_time" : "10:20:36" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "10:23:42" , 
"departure_time" : "10:24:17" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "10:28:35" , 
"departure_time" : "10:28:57" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "10:31:22" , 
"departure_time" : "10:31:53" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "10:34:31" , 
"departure_time" : "10:35:49" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "10:41:18" , 
"departure_time" : "10:41:18" , 
"distance_traveled" : 30.7256
} ], 
"1714" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "10:25:00" , 
"departure_time" : "10:27:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "10:36:29" , 
"departure_time" : "10:37:10" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "10:41:41" , 
"departure_time" : "10:43:07" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "10:45:26" , 
"departure_time" : "10:45:35" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "10:46:09" , 
"departure_time" : "10:46:39" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "10:49:30" , 
"departure_time" : "10:50:16" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "10:53:46" , 
"departure_time" : "10:54:52" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "11:00:06" , 
"departure_time" : "11:00:57" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "11:04:51" , 
"departure_time" : "11:05:21" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "11:08:30" , 
"departure_time" : "11:09:22" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "11:12:52" , 
"departure_time" : "11:13:11" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "11:15:19" , 
"departure_time" : "11:16:10" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "11:19:51" , 
"departure_time" : "11:20:29" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "11:23:38" , 
"departure_time" : "11:24:35" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "11:28:57" , 
"departure_time" : "11:29:42" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "11:31:45" , 
"departure_time" : "11:32:56" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "11:35:11" , 
"departure_time" : "11:35:39" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "11:40:28" , 
"departure_time" : "11:40:28" , 
"distance_traveled" : 30.7256
} ], 
"1715" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "11:25:00" , 
"departure_time" : "11:26:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "11:36:30" , 
"departure_time" : "11:37:56" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "11:42:26" , 
"departure_time" : "11:43:40" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "11:45:14" , 
"departure_time" : "11:45:25" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "11:46:11" , 
"departure_time" : "11:46:29" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "11:49:18" , 
"departure_time" : "11:50:44" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "11:54:26" , 
"departure_time" : "11:54:48" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "11:59:22" , 
"departure_time" : "12:00:49" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "12:05:27" , 
"departure_time" : "12:05:36" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "12:08:09" , 
"departure_time" : "12:08:20" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "12:12:11" , 
"departure_time" : "12:12:35" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "12:15:24" , 
"departure_time" : "12:16:49" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "12:20:25" , 
"departure_time" : "12:21:41" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "12:24:16" , 
"departure_time" : "12:24:50" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "12:28:34" , 
"departure_time" : "12:29:50" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "12:32:16" , 
"departure_time" : "12:32:48" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "12:34:32" , 
"departure_time" : "12:35:12" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "12:40:40" , 
"departure_time" : "12:40:40" , 
"distance_traveled" : 30.7256
} ], 
"1716" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "12:25:00" , 
"departure_time" : "12:27:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "12:36:23" , 
"departure_time" : "12:37:55" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "12:42:32" , 
"departure_time" : "12:44:11" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "12:45:39" , 
"departure_time" : "12:47:08" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "12:47:29" , 
"departure_time" : "12:47:53" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "12:49:24" , 
"departure_time" : "12:49:30" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "12:53:06" , 
"departure_time" : "12:53:37" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "12:59:31" , 
"departure_time" : "12:59:59" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "13:04:28" , 
"departure_time" : "13:05:16" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "13:08:48" , 
"departure_time" : "13:09:49" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "13:13:01" , 
"departure_time" : "13:13:34" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "13:15:33" , 
"departure_time" : "13:16:46" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "13:20:13" , 
"departure_time" : "13:21:35" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "13:24:22" , 
"departure_time" : "13:24:24" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "13:28:02" , 
"departure_time" : "13:28:56" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "13:31:54" , 
"departure_time" : "13:32:53" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "13:34:59" , 
"departure_time" : "13:36:11" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "13:41:12" , 
"departure_time" : "13:41:12" , 
"distance_traveled" : 30.7256
} ], 
"1717" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "13:25:00" , 
"departure_time" : "13:27:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "13:36:28" , 
"departure_time" : "13:37:07" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "13:41:39" , 
"departure_time" : "13:43:15" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "13:45:36" , 
"departure_time" : "13:47:02" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "13:47:26" , 
"departure_time" : "13:48:42" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "13:50:16" , 
"departure_time" : "13:50:51" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "13:53:35" , 
"departure_time" : "13:54:29" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "13:59:54" , 
"departure_time" : "14:00:10" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "14:04:16" , 
"departure_time" : "14:05:23" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "14:09:07" , 
"departure_time" : "14:10:08" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "14:13:01" , 
"departure_time" : "14:13:55" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "14:15:54" , 
"departure_time" : "14:16:01" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "14:19:07" , 
"departure_time" : "14:20:34" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "14:24:27" , 
"departure_time" : "14:24:31" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "14:28:04" , 
"departure_time" : "14:29:09" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "14:32:05" , 
"departure_time" : "14:32:29" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "14:34:24" , 
"departure_time" : "14:35:07" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "14:40:43" , 
"departure_time" : "14:40:43" , 
"distance_traveled" : 30.7256
} ], 
"1718" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "14:25:00" , 
"departure_time" : "14:25:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "14:35:08" , 
"departure_time" : "14:35:44" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "14:41:36" , 
"departure_time" : "14:43:02" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "14:45:26" , 
"departure_time" : "14:46:09" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "14:46:43" , 
"departure_time" : "14:48:07" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "14:50:24" , 
"departure_time" : "14:51:21" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "14:53:57" , 
"departure_time" : "14:54:03" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "14:59:06" , 
"departure_time" : "14:59:52" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "15:04:46" , 
"departure_time" : "15:05:46" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "15:09:00" , 
"departure_time" : "15:09:25" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "15:12:25" , 
"departure_time" : "15:12:28" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "15:15:03" , 
"departure_time" : "15:15:22" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "15:19:19" , 
"departure_time" : "15:19:54" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "15:23:35" , 
"departure_time" : "15:23:46" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "15:28:11" , 
"departure_time" : "15:28:47" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "15:31:36" , 
"departure_time" : "15:32:18" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "15:34:42" , 
"departure_time" : "15:35:18" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "15:40:36" , 
"departure_time" : "15:40:36" , 
"distance_traveled" : 30.7256
} ], 
"1719" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "15:25:00" , 
"departure_time" : "15:26:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "15:35:55" , 
"departure_time" : "15:37:23" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "15:42:28" , 
"departure_time" : "15:43:40" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "15:45:12" , 
"departure_time" : "15:45:16" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "15:46:04" , 
"departure_time" : "15:47:02" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "15:49:58" , 
"departure_time" : "15:51:21" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "15:53:23" , 
"departure_time" : "15:53:48" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "15:59:25" , 
"departure_time" : "16:00:26" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "16:04:01" , 
"departure_time" : "16:05:28" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "16:08:27" , 
"departure_time" : "16:09:45" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "16:12:18" , 
"departure_time" : "16:13:12" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "16:15:54" , 
"departure_time" : "16:16:20" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "16:18:26" , 
"departure_time" : "16:20:01" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "16:23:35" , 
"departure_time" : "16:24:00" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "16:27:25" , 
"departure_time" : "16:28:09" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "16:30:44" , 
"departure_time" : "16:31:13" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "16:33:29" , 
"departure_time" : "16:33:52" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "16:39:23" , 
"departure_time" : "16:39:23" , 
"distance_traveled" : 30.7256
} ], 
"1720" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:25:00" , 
"departure_time" : "16:25:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:35:05" , 
"departure_time" : "16:35:32" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "16:41:27" , 
"departure_time" : "16:42:50" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "16:45:23" , 
"departure_time" : "16:46:23" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "16:48:00" , 
"departure_time" : "16:48:31" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "16:50:31" , 
"departure_time" : "16:51:06" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "16:53:35" , 
"departure_time" : "16:53:42" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "17:00:07" , 
"departure_time" : "17:00:31" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "17:04:24" , 
"departure_time" : "17:04:49" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "17:08:25" , 
"departure_time" : "17:09:11" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "17:12:46" , 
"departure_time" : "17:14:07" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "17:17:21" , 
"departure_time" : "17:18:47" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "17:20:26" , 
"departure_time" : "17:21:02" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "17:23:36" , 
"departure_time" : "17:25:11" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "17:29:35" , 
"departure_time" : "17:30:08" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "17:31:33" , 
"departure_time" : "17:32:11" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "17:34:38" , 
"departure_time" : "17:35:43" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "17:40:05" , 
"departure_time" : "17:40:05" , 
"distance_traveled" : 30.7256
} ], 
"1721" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:25:00" , 
"departure_time" : "17:26:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:35:45" , 
"departure_time" : "17:35:54" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "17:41:09" , 
"departure_time" : "17:41:47" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "17:44:38" , 
"departure_time" : "17:45:54" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "17:47:16" , 
"departure_time" : "17:47:54" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "17:49:38" , 
"departure_time" : "17:50:05" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "17:53:27" , 
"departure_time" : "17:54:16" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "17:59:49" , 
"departure_time" : "18:01:10" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "18:05:21" , 
"departure_time" : "18:06:33" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "18:09:12" , 
"departure_time" : "18:10:36" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:13:24" , 
"departure_time" : "18:14:21" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "18:15:57" , 
"departure_time" : "18:16:50" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "18:19:53" , 
"departure_time" : "18:20:05" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "18:23:12" , 
"departure_time" : "18:23:38" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "18:28:26" , 
"departure_time" : "18:29:12" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "18:31:46" , 
"departure_time" : "18:32:13" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "18:34:27" , 
"departure_time" : "18:36:06" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "18:41:39" , 
"departure_time" : "18:41:39" , 
"distance_traveled" : 30.7256
} ], 
"1722" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:25:00" , 
"departure_time" : "18:26:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:35:05" , 
"departure_time" : "18:36:13" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "18:42:08" , 
"departure_time" : "18:43:31" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "18:45:23" , 
"departure_time" : "18:46:29" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "18:47:06" , 
"departure_time" : "18:47:13" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "18:49:07" , 
"departure_time" : "18:49:26" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "18:53:19" , 
"departure_time" : "18:53:42" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "18:59:23" , 
"departure_time" : "18:59:52" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "19:04:29" , 
"departure_time" : "19:05:12" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "19:08:43" , 
"departure_time" : "19:09:10" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "19:12:27" , 
"departure_time" : "19:13:52" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "19:16:25" , 
"departure_time" : "19:17:43" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "19:20:18" , 
"departure_time" : "19:20:38" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "19:23:20" , 
"departure_time" : "19:23:53" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "19:28:33" , 
"departure_time" : "19:30:05" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "19:32:32" , 
"departure_time" : "19:34:08" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "19:35:36" , 
"departure_time" : "19:36:32" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "19:40:56" , 
"departure_time" : "19:40:56" , 
"distance_traveled" : 30.7256
} ], 
"1723" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "19:25:00" , 
"departure_time" : "19:26:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:35:57" , 
"departure_time" : "19:37:07" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "19:42:10" , 
"departure_time" : "19:42:49" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "19:44:39" , 
"departure_time" : "19:45:29" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "19:46:50" , 
"departure_time" : "19:48:25" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "19:50:35" , 
"departure_time" : "19:52:00" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "19:54:25" , 
"departure_time" : "19:55:10" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "19:59:45" , 
"departure_time" : "19:59:46" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "20:04:01" , 
"departure_time" : "20:04:11" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "20:08:10" , 
"departure_time" : "20:09:09" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "20:12:59" , 
"departure_time" : "20:14:26" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "20:16:27" , 
"departure_time" : "20:17:29" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "20:20:02" , 
"departure_time" : "20:20:19" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "20:23:17" , 
"departure_time" : "20:23:20" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "20:28:03" , 
"departure_time" : "20:29:30" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "20:32:27" , 
"departure_time" : "20:33:10" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "20:34:43" , 
"departure_time" : "20:36:04" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "20:41:21" , 
"departure_time" : "20:41:21" , 
"distance_traveled" : 30.7256
} ], 
"1724" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "20:25:00" , 
"departure_time" : "20:26:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "20:35:12" , 
"departure_time" : "20:36:00" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "20:42:48" , 
"departure_time" : "20:44:21" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "20:45:33" , 
"departure_time" : "20:47:06" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "20:48:33" , 
"departure_time" : "20:50:01" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "20:51:28" , 
"departure_time" : "20:53:02" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "20:55:34" , 
"departure_time" : "20:56:37" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "21:01:03" , 
"departure_time" : "21:01:17" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "21:05:14" , 
"departure_time" : "21:05:23" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "21:09:09" , 
"departure_time" : "21:10:00" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "21:13:51" , 
"departure_time" : "21:14:09" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "21:17:18" , 
"departure_time" : "21:18:32" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "21:21:14" , 
"departure_time" : "21:22:50" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "21:25:36" , 
"departure_time" : "21:27:13" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "21:30:37" , 
"departure_time" : "21:31:02" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "21:32:25" , 
"departure_time" : "21:33:09" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "21:35:44" , 
"departure_time" : "21:36:49" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "21:41:05" , 
"departure_time" : "21:41:05" , 
"distance_traveled" : 30.7256
} ], 
"1725" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "06:18:00" , 
"departure_time" : "06:20:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "06:39:40" , 
"departure_time" : "06:40:11" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "06:49:31" , 
"departure_time" : "06:50:39" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "06:57:08" , 
"departure_time" : "06:57:24" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "07:09:16" , 
"departure_time" : "07:10:35" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "07:25:19" , 
"departure_time" : "07:25:45" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "07:34:26" , 
"departure_time" : "07:35:12" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "07:39:46" , 
"departure_time" : "07:40:15" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "07:46:29" , 
"departure_time" : "07:46:32" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:18:03" , 
"departure_time" : "08:19:34" , 
"distance_traveled" : 91.4981
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:31:31" , 
"departure_time" : "08:31:31" , 
"distance_traveled" : 95.0638
} ], 
"1726" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "16:05:00" , 
"departure_time" : "16:07:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "16:26:39" , 
"departure_time" : "16:28:15" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "16:38:36" , 
"departure_time" : "16:40:07" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "16:46:31" , 
"departure_time" : "16:47:35" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "16:59:04" , 
"departure_time" : "16:59:05" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "17:15:01" , 
"departure_time" : "17:15:56" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "17:25:55" , 
"departure_time" : "17:27:32" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "17:32:37" , 
"departure_time" : "17:33:10" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "17:38:33" , 
"departure_time" : "17:39:22" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:12:49" , 
"departure_time" : "18:14:09" , 
"distance_traveled" : 91.4981
}, 
{ 
"stop_id" : 63,
"arrival_time" : "18:25:20" , 
"departure_time" : "18:25:20" , 
"distance_traveled" : 95.0638
} ], 
"1727" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "16:05:00" , 
"departure_time" : "16:07:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "16:27:00" , 
"departure_time" : "16:27:34" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "16:37:34" , 
"departure_time" : "16:38:48" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "16:46:14" , 
"departure_time" : "16:47:21" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "16:59:07" , 
"departure_time" : "17:00:05" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "17:15:58" , 
"departure_time" : "17:17:01" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "17:26:03" , 
"departure_time" : "17:26:22" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "17:31:19" , 
"departure_time" : "17:32:34" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "17:39:15" , 
"departure_time" : "17:40:24" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:13:09" , 
"departure_time" : "18:13:26" , 
"distance_traveled" : 91.4981
}, 
{ 
"stop_id" : 63,
"arrival_time" : "18:24:17" , 
"departure_time" : "18:24:17" , 
"distance_traveled" : 95.0638
} ], 
"1728" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "06:18:00" , 
"departure_time" : "06:18:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "06:38:07" , 
"departure_time" : "06:38:50" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "06:49:43" , 
"departure_time" : "06:50:56" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "06:57:13" , 
"departure_time" : "06:57:47" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "07:09:34" , 
"departure_time" : "07:09:58" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "07:24:24" , 
"departure_time" : "07:25:33" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "07:35:09" , 
"departure_time" : "07:35:22" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "07:39:13" , 
"departure_time" : "07:40:10" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "07:46:57" , 
"departure_time" : "07:47:00" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:18:03" , 
"departure_time" : "08:18:07" , 
"distance_traveled" : 91.4981
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:30:04" , 
"departure_time" : "08:30:04" , 
"distance_traveled" : 95.0638
} ], 
"1729" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "17:28:00" , 
"departure_time" : "17:28:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "17:48:01" , 
"departure_time" : "17:48:43" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "18:00:42" , 
"departure_time" : "18:01:18" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "18:07:36" , 
"departure_time" : "18:07:54" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "18:19:18" , 
"departure_time" : "18:20:20" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "18:35:02" , 
"departure_time" : "18:36:03" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "18:45:01" , 
"departure_time" : "18:46:32" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "18:51:31" , 
"departure_time" : "18:52:09" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "18:57:38" , 
"departure_time" : "18:57:57" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 131,
"arrival_time" : "19:09:19" , 
"departure_time" : "19:09:49" , 
"distance_traveled" : 74.0966
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:28:30" , 
"departure_time" : "19:30:00" , 
"distance_traveled" : 91.504
}, 
{ 
"stop_id" : 63,
"arrival_time" : "19:40:30" , 
"departure_time" : "19:40:30" , 
"distance_traveled" : 95.0638
} ], 
"1730" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "17:28:00" , 
"departure_time" : "17:30:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "17:48:49" , 
"departure_time" : "17:50:27" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "18:01:38" , 
"departure_time" : "18:02:05" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "18:07:27" , 
"departure_time" : "18:08:03" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "18:19:36" , 
"departure_time" : "18:20:54" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "18:35:18" , 
"departure_time" : "18:36:20" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "18:45:02" , 
"departure_time" : "18:46:34" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "18:51:32" , 
"departure_time" : "18:51:52" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "18:57:20" , 
"departure_time" : "18:57:38" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 131,
"arrival_time" : "19:09:18" , 
"departure_time" : "19:10:22" , 
"distance_traveled" : 74.0966
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:29:04" , 
"departure_time" : "19:30:10" , 
"distance_traveled" : 91.504
}, 
{ 
"stop_id" : 63,
"arrival_time" : "19:40:06" , 
"departure_time" : "19:40:06" , 
"distance_traveled" : 95.0638
} ], 
"1731" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "07:19:00" , 
"departure_time" : "07:21:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "07:41:30" , 
"departure_time" : "07:42:34" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "07:52:04" , 
"departure_time" : "07:53:30" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "07:59:26" , 
"departure_time" : "08:01:06" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "08:11:40" , 
"departure_time" : "08:12:11" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "08:25:31" , 
"departure_time" : "08:25:41" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "08:35:10" , 
"departure_time" : "08:36:40" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "08:41:30" , 
"departure_time" : "08:42:43" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "08:48:13" , 
"departure_time" : "08:48:52" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "08:51:39" , 
"departure_time" : "08:52:11" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:21:32" , 
"departure_time" : "09:22:06" , 
"distance_traveled" : 91.4981
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:33:34" , 
"departure_time" : "09:33:34" , 
"distance_traveled" : 95.0638
} ], 
"1732" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "07:19:00" , 
"departure_time" : "07:20:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "07:41:14" , 
"departure_time" : "07:41:25" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "07:51:11" , 
"departure_time" : "07:52:24" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "07:59:13" , 
"departure_time" : "08:00:16" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "08:11:03" , 
"departure_time" : "08:12:22" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "08:26:19" , 
"departure_time" : "08:26:37" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "08:35:18" , 
"departure_time" : "08:36:44" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "08:41:26" , 
"departure_time" : "08:41:53" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "08:47:27" , 
"departure_time" : "08:47:29" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "08:51:02" , 
"departure_time" : "08:52:02" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:22:00" , 
"departure_time" : "09:22:33" , 
"distance_traveled" : 91.4981
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:33:33" , 
"departure_time" : "09:33:33" , 
"distance_traveled" : 95.0638
} ], 
"1733" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "15:04:00" , 
"departure_time" : "15:04:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "15:24:08" , 
"departure_time" : "15:25:20" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "15:36:12" , 
"departure_time" : "15:37:03" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "15:42:51" , 
"departure_time" : "15:43:09" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "15:55:18" , 
"departure_time" : "15:56:18" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "16:11:00" , 
"departure_time" : "16:12:16" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "16:21:16" , 
"departure_time" : "16:21:36" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "16:25:20" , 
"departure_time" : "16:25:32" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "16:32:12" , 
"departure_time" : "16:33:00" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 78,
"arrival_time" : "16:34:48" , 
"departure_time" : "16:35:02" , 
"distance_traveled" : 65.7714
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "16:37:14" , 
"departure_time" : "16:37:40" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 128,
"arrival_time" : "16:41:26" , 
"departure_time" : "16:41:37" , 
"distance_traveled" : 68.3926
}, 
{ 
"stop_id" : 3,
"arrival_time" : "16:44:11" , 
"departure_time" : "16:44:54" , 
"distance_traveled" : 70.3095
}, 
{ 
"stop_id" : 131,
"arrival_time" : "16:51:43" , 
"departure_time" : "16:53:07" , 
"distance_traveled" : 74.0992
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:15:24" , 
"departure_time" : "17:16:05" , 
"distance_traveled" : 91.5038
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:26:41" , 
"departure_time" : "17:26:41" , 
"distance_traveled" : 95.0636
} ], 
"1734" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "15:04:00" , 
"departure_time" : "15:05:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "15:24:20" , 
"departure_time" : "15:25:20" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "15:36:00" , 
"departure_time" : "15:37:30" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "15:43:30" , 
"departure_time" : "15:43:35" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "15:55:05" , 
"departure_time" : "15:56:17" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "16:11:12" , 
"departure_time" : "16:12:17" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "16:21:05" , 
"departure_time" : "16:22:11" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "16:26:06" , 
"departure_time" : "16:27:00" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "16:32:54" , 
"departure_time" : "16:33:22" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 78,
"arrival_time" : "16:34:28" , 
"departure_time" : "16:35:33" , 
"distance_traveled" : 65.7714
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "16:38:05" , 
"departure_time" : "16:39:25" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 128,
"arrival_time" : "16:42:20" , 
"departure_time" : "16:42:36" , 
"distance_traveled" : 68.3926
}, 
{ 
"stop_id" : 3,
"arrival_time" : "16:44:16" , 
"departure_time" : "16:45:20" , 
"distance_traveled" : 70.3095
}, 
{ 
"stop_id" : 131,
"arrival_time" : "16:52:04" , 
"departure_time" : "16:52:06" , 
"distance_traveled" : 74.0992
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:14:02" , 
"departure_time" : "17:14:33" , 
"distance_traveled" : 91.5038
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:26:31" , 
"departure_time" : "17:26:31" , 
"distance_traveled" : 95.0636
} ], 
"1735" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "08:57:00" , 
"departure_time" : "08:57:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "09:18:09" , 
"departure_time" : "09:18:12" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "09:29:03" , 
"departure_time" : "09:30:12" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "09:37:09" , 
"departure_time" : "09:38:26" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "09:49:17" , 
"departure_time" : "09:49:31" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "10:03:14" , 
"departure_time" : "10:03:31" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "10:13:17" , 
"departure_time" : "10:13:54" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "10:18:37" , 
"departure_time" : "10:19:54" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "10:28:17" , 
"departure_time" : "10:29:18" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "10:32:01" , 
"departure_time" : "10:33:34" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 131,
"arrival_time" : "10:42:33" , 
"departure_time" : "10:43:56" , 
"distance_traveled" : 74.0964
}, 
{ 
"stop_id" : 51,
"arrival_time" : "10:46:23" , 
"departure_time" : "10:47:27" , 
"distance_traveled" : 75.5074
}, 
{ 
"stop_id" : 126,
"arrival_time" : "10:49:04" , 
"departure_time" : "10:50:19" , 
"distance_traveled" : 77.0477
}, 
{ 
"stop_id" : 25,
"arrival_time" : "10:52:15" , 
"departure_time" : "10:53:23" , 
"distance_traveled" : 78.2987
}, 
{ 
"stop_id" : 121,
"arrival_time" : "10:57:08" , 
"departure_time" : "10:58:25" , 
"distance_traveled" : 81.0263
}, 
{ 
"stop_id" : 134,
"arrival_time" : "11:05:17" , 
"departure_time" : "11:06:11" , 
"distance_traveled" : 85.2642
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "11:12:54" , 
"departure_time" : "11:14:02" , 
"distance_traveled" : 90.3824
}, 
{ 
"stop_id" : 63,
"arrival_time" : "11:25:08" , 
"departure_time" : "11:25:08" , 
"distance_traveled" : 93.9422
} ], 
"1736" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "08:57:00" , 
"departure_time" : "08:59:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "09:19:14" , 
"departure_time" : "09:20:11" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "09:29:57" , 
"departure_time" : "09:30:43" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "09:36:46" , 
"departure_time" : "09:37:07" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "09:48:21" , 
"departure_time" : "09:49:13" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "10:03:52" , 
"departure_time" : "10:04:41" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "10:13:49" , 
"departure_time" : "10:14:13" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "10:18:24" , 
"departure_time" : "10:19:41" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "10:28:17" , 
"departure_time" : "10:28:24" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "10:31:07" , 
"departure_time" : "10:31:19" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 131,
"arrival_time" : "10:41:12" , 
"departure_time" : "10:42:13" , 
"distance_traveled" : 74.0964
}, 
{ 
"stop_id" : 51,
"arrival_time" : "10:46:01" , 
"departure_time" : "10:46:41" , 
"distance_traveled" : 75.5074
}, 
{ 
"stop_id" : 126,
"arrival_time" : "10:48:40" , 
"departure_time" : "10:49:01" , 
"distance_traveled" : 77.0477
}, 
{ 
"stop_id" : 25,
"arrival_time" : "10:51:21" , 
"departure_time" : "10:52:32" , 
"distance_traveled" : 78.2987
}, 
{ 
"stop_id" : 121,
"arrival_time" : "10:57:11" , 
"departure_time" : "10:58:27" , 
"distance_traveled" : 81.0263
}, 
{ 
"stop_id" : 134,
"arrival_time" : "11:05:16" , 
"departure_time" : "11:06:22" , 
"distance_traveled" : 85.2642
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "11:13:06" , 
"departure_time" : "11:13:26" , 
"distance_traveled" : 90.3824
}, 
{ 
"stop_id" : 63,
"arrival_time" : "11:24:20" , 
"departure_time" : "11:24:20" , 
"distance_traveled" : 93.9422
} ], 
"1737" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "10:57:00" , 
"departure_time" : "10:58:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "11:19:09" , 
"departure_time" : "11:19:34" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "11:29:25" , 
"departure_time" : "11:30:55" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "11:37:30" , 
"departure_time" : "11:38:17" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "11:48:47" , 
"departure_time" : "11:48:52" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "12:03:05" , 
"departure_time" : "12:04:20" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "12:14:15" , 
"departure_time" : "12:15:28" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "12:19:13" , 
"departure_time" : "12:20:36" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "12:28:23" , 
"departure_time" : "12:29:51" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "12:32:28" , 
"departure_time" : "12:33:36" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 131,
"arrival_time" : "12:42:08" , 
"departure_time" : "12:42:35" , 
"distance_traveled" : 74.0964
}, 
{ 
"stop_id" : 51,
"arrival_time" : "12:45:27" , 
"departure_time" : "12:47:05" , 
"distance_traveled" : 75.5074
}, 
{ 
"stop_id" : 126,
"arrival_time" : "12:49:38" , 
"departure_time" : "12:51:09" , 
"distance_traveled" : 77.0477
}, 
{ 
"stop_id" : 25,
"arrival_time" : "12:52:31" , 
"departure_time" : "12:54:01" , 
"distance_traveled" : 78.2987
}, 
{ 
"stop_id" : 121,
"arrival_time" : "12:57:30" , 
"departure_time" : "12:57:39" , 
"distance_traveled" : 81.0263
}, 
{ 
"stop_id" : 134,
"arrival_time" : "13:04:09" , 
"departure_time" : "13:05:35" , 
"distance_traveled" : 85.2642
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "13:13:26" , 
"departure_time" : "13:13:51" , 
"distance_traveled" : 90.3824
}, 
{ 
"stop_id" : 63,
"arrival_time" : "13:24:25" , 
"departure_time" : "13:24:25" , 
"distance_traveled" : 93.9422
} ], 
"1738" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "10:57:00" , 
"departure_time" : "10:57:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "11:18:05" , 
"departure_time" : "11:18:33" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "11:29:28" , 
"departure_time" : "11:30:11" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "11:36:43" , 
"departure_time" : "11:38:18" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "11:49:35" , 
"departure_time" : "11:49:37" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "12:03:02" , 
"departure_time" : "12:03:30" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "12:13:28" , 
"departure_time" : "12:14:07" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "12:18:39" , 
"departure_time" : "12:20:03" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "12:28:24" , 
"departure_time" : "12:29:17" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "12:31:53" , 
"departure_time" : "12:33:23" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 131,
"arrival_time" : "12:42:30" , 
"departure_time" : "12:43:50" , 
"distance_traveled" : 74.0964
}, 
{ 
"stop_id" : 51,
"arrival_time" : "12:46:20" , 
"departure_time" : "12:46:34" , 
"distance_traveled" : 75.5074
}, 
{ 
"stop_id" : 126,
"arrival_time" : "12:48:14" , 
"departure_time" : "12:49:25" , 
"distance_traveled" : 77.0477
}, 
{ 
"stop_id" : 25,
"arrival_time" : "12:52:11" , 
"departure_time" : "12:53:51" , 
"distance_traveled" : 78.2987
}, 
{ 
"stop_id" : 121,
"arrival_time" : "12:57:40" , 
"departure_time" : "12:59:15" , 
"distance_traveled" : 81.0263
}, 
{ 
"stop_id" : 134,
"arrival_time" : "13:05:35" , 
"departure_time" : "13:06:21" , 
"distance_traveled" : 85.2642
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "13:12:46" , 
"departure_time" : "13:13:52" , 
"distance_traveled" : 90.3824
}, 
{ 
"stop_id" : 63,
"arrival_time" : "13:25:06" , 
"departure_time" : "13:25:06" , 
"distance_traveled" : 93.9422
} ], 
"1739" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "04:41:00" , 
"departure_time" : "04:42:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "05:01:18" , 
"departure_time" : "05:01:56" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "05:12:38" , 
"departure_time" : "05:12:49" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "05:19:11" , 
"departure_time" : "05:19:47" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "05:31:36" , 
"departure_time" : "05:32:24" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "05:46:48" , 
"departure_time" : "05:47:46" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "05:56:58" , 
"departure_time" : "05:57:33" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "06:01:35" , 
"departure_time" : "06:02:41" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "06:09:06" , 
"departure_time" : "06:09:48" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 78,
"arrival_time" : "06:11:42" , 
"departure_time" : "06:11:56" , 
"distance_traveled" : 65.7714
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "06:14:14" , 
"departure_time" : "06:15:13" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 128,
"arrival_time" : "06:17:59" , 
"departure_time" : "06:18:59" , 
"distance_traveled" : 68.3926
}, 
{ 
"stop_id" : 3,
"arrival_time" : "06:21:00" , 
"departure_time" : "06:22:39" , 
"distance_traveled" : 70.3095
}, 
{ 
"stop_id" : 151,
"arrival_time" : "06:24:39" , 
"departure_time" : "06:25:45" , 
"distance_traveled" : 71.6453
}, 
{ 
"stop_id" : 64,
"arrival_time" : "06:28:06" , 
"departure_time" : "06:29:28" , 
"distance_traveled" : 72.8689
}, 
{ 
"stop_id" : 131,
"arrival_time" : "06:31:22" , 
"departure_time" : "06:31:31" , 
"distance_traveled" : 74.0964
}, 
{ 
"stop_id" : 52,
"arrival_time" : "06:33:09" , 
"departure_time" : "06:33:49" , 
"distance_traveled" : 75.5417
}, 
{ 
"stop_id" : 58,
"arrival_time" : "06:37:40" , 
"departure_time" : "06:37:50" , 
"distance_traveled" : 77.2483
}, 
{ 
"stop_id" : 116,
"arrival_time" : "06:42:10" , 
"departure_time" : "06:42:53" , 
"distance_traveled" : 79.343
}, 
{ 
"stop_id" : 29,
"arrival_time" : "06:48:43" , 
"departure_time" : "06:49:53" , 
"distance_traveled" : 82.8674
}, 
{ 
"stop_id" : 115,
"arrival_time" : "06:52:10" , 
"departure_time" : "06:53:16" , 
"distance_traveled" : 84.5212
}, 
{ 
"stop_id" : 33,
"arrival_time" : "06:55:06" , 
"departure_time" : "06:56:29" , 
"distance_traveled" : 85.7778
}, 
{ 
"stop_id" : 75,
"arrival_time" : "06:58:23" , 
"departure_time" : "06:59:21" , 
"distance_traveled" : 86.879
}, 
{ 
"stop_id" : 66,
"arrival_time" : "06:59:58" , 
"departure_time" : "07:00:47" , 
"distance_traveled" : 87.4602
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:07:49" , 
"departure_time" : "07:08:01" , 
"distance_traveled" : 91.5805
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:19:12" , 
"departure_time" : "07:19:12" , 
"distance_traveled" : 95.1403
} ], 
"1740" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "04:41:00" , 
"departure_time" : "04:41:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "05:01:32" , 
"departure_time" : "05:02:26" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "05:12:54" , 
"departure_time" : "05:13:09" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "05:19:15" , 
"departure_time" : "05:20:25" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "05:32:10" , 
"departure_time" : "05:33:04" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "05:46:54" , 
"departure_time" : "05:46:55" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "05:56:01" , 
"departure_time" : "05:56:11" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "06:01:10" , 
"departure_time" : "06:01:16" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "06:08:06" , 
"departure_time" : "06:09:17" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 78,
"arrival_time" : "06:12:11" , 
"departure_time" : "06:13:25" , 
"distance_traveled" : 65.7714
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "06:15:14" , 
"departure_time" : "06:16:50" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 128,
"arrival_time" : "06:18:36" , 
"departure_time" : "06:19:05" , 
"distance_traveled" : 68.3926
}, 
{ 
"stop_id" : 3,
"arrival_time" : "06:20:29" , 
"departure_time" : "06:21:17" , 
"distance_traveled" : 70.3095
}, 
{ 
"stop_id" : 151,
"arrival_time" : "06:23:48" , 
"departure_time" : "06:24:23" , 
"distance_traveled" : 71.6453
}, 
{ 
"stop_id" : 64,
"arrival_time" : "06:27:35" , 
"departure_time" : "06:27:51" , 
"distance_traveled" : 72.8689
}, 
{ 
"stop_id" : 131,
"arrival_time" : "06:30:16" , 
"departure_time" : "06:31:07" , 
"distance_traveled" : 74.0964
}, 
{ 
"stop_id" : 52,
"arrival_time" : "06:33:51" , 
"departure_time" : "06:35:13" , 
"distance_traveled" : 75.5417
}, 
{ 
"stop_id" : 58,
"arrival_time" : "06:38:22" , 
"departure_time" : "06:39:35" , 
"distance_traveled" : 77.2483
}, 
{ 
"stop_id" : 116,
"arrival_time" : "06:43:13" , 
"departure_time" : "06:44:17" , 
"distance_traveled" : 79.343
}, 
{ 
"stop_id" : 29,
"arrival_time" : "06:49:04" , 
"departure_time" : "06:50:43" , 
"distance_traveled" : 82.8674
}, 
{ 
"stop_id" : 115,
"arrival_time" : "06:52:39" , 
"departure_time" : "06:53:07" , 
"distance_traveled" : 84.5212
}, 
{ 
"stop_id" : 33,
"arrival_time" : "06:54:28" , 
"departure_time" : "06:56:01" , 
"distance_traveled" : 85.7778
}, 
{ 
"stop_id" : 75,
"arrival_time" : "06:58:33" , 
"departure_time" : "06:59:43" , 
"distance_traveled" : 86.879
}, 
{ 
"stop_id" : 66,
"arrival_time" : "07:00:10" , 
"departure_time" : "07:00:11" , 
"distance_traveled" : 87.4602
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:07:01" , 
"departure_time" : "07:08:12" , 
"distance_traveled" : 91.5805
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:20:11" , 
"departure_time" : "07:20:11" , 
"distance_traveled" : 95.1403
} ], 
"1741" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "20:41:00" , 
"departure_time" : "20:43:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "21:03:02" , 
"departure_time" : "21:04:05" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "21:14:03" , 
"departure_time" : "21:14:35" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "21:20:32" , 
"departure_time" : "21:21:24" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "21:32:52" , 
"departure_time" : "21:34:02" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "21:48:10" , 
"departure_time" : "21:48:57" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "21:57:47" , 
"departure_time" : "21:59:19" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "22:03:32" , 
"departure_time" : "22:04:23" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "22:08:51" , 
"departure_time" : "22:08:57" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 78,
"arrival_time" : "22:11:06" , 
"departure_time" : "22:11:07" , 
"distance_traveled" : 65.7714
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "22:14:01" , 
"departure_time" : "22:14:43" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 128,
"arrival_time" : "22:17:42" , 
"departure_time" : "22:17:46" , 
"distance_traveled" : 68.3926
}, 
{ 
"stop_id" : 3,
"arrival_time" : "22:20:04" , 
"departure_time" : "22:20:54" , 
"distance_traveled" : 70.3095
}, 
{ 
"stop_id" : 151,
"arrival_time" : "22:23:50" , 
"departure_time" : "22:24:16" , 
"distance_traveled" : 71.6453
}, 
{ 
"stop_id" : 64,
"arrival_time" : "22:27:26" , 
"departure_time" : "22:28:19" , 
"distance_traveled" : 72.8689
}, 
{ 
"stop_id" : 131,
"arrival_time" : "22:30:53" , 
"departure_time" : "22:31:32" , 
"distance_traveled" : 74.0964
}, 
{ 
"stop_id" : 52,
"arrival_time" : "22:33:39" , 
"departure_time" : "22:33:43" , 
"distance_traveled" : 75.5417
}, 
{ 
"stop_id" : 58,
"arrival_time" : "22:37:04" , 
"departure_time" : "22:37:20" , 
"distance_traveled" : 77.2483
}, 
{ 
"stop_id" : 116,
"arrival_time" : "22:42:16" , 
"departure_time" : "22:42:35" , 
"distance_traveled" : 79.343
}, 
{ 
"stop_id" : 29,
"arrival_time" : "22:48:19" , 
"departure_time" : "22:49:30" , 
"distance_traveled" : 82.8674
}, 
{ 
"stop_id" : 115,
"arrival_time" : "22:52:11" , 
"departure_time" : "22:53:13" , 
"distance_traveled" : 84.5212
}, 
{ 
"stop_id" : 33,
"arrival_time" : "22:55:02" , 
"departure_time" : "22:56:28" , 
"distance_traveled" : 85.7778
}, 
{ 
"stop_id" : 75,
"arrival_time" : "22:58:26" , 
"departure_time" : "22:59:54" , 
"distance_traveled" : 86.879
}, 
{ 
"stop_id" : 66,
"arrival_time" : "23:00:28" , 
"departure_time" : "23:01:16" , 
"distance_traveled" : 87.4602
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "23:07:48" , 
"departure_time" : "23:08:47" , 
"distance_traveled" : 91.5805
}, 
{ 
"stop_id" : 63,
"arrival_time" : "23:19:59" , 
"departure_time" : "23:19:59" , 
"distance_traveled" : 95.1403
} ], 
"1742" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "20:41:00" , 
"departure_time" : "20:42:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "21:02:27" , 
"departure_time" : "21:03:08" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "21:13:41" , 
"departure_time" : "21:14:46" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "21:21:05" , 
"departure_time" : "21:22:26" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "21:33:21" , 
"departure_time" : "21:34:44" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "21:48:23" , 
"departure_time" : "21:49:09" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "21:57:46" , 
"departure_time" : "21:58:41" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "22:02:55" , 
"departure_time" : "22:03:16" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "22:08:21" , 
"departure_time" : "22:08:33" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 78,
"arrival_time" : "22:11:12" , 
"departure_time" : "22:11:16" , 
"distance_traveled" : 65.7714
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "22:14:04" , 
"departure_time" : "22:14:07" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 128,
"arrival_time" : "22:17:03" , 
"departure_time" : "22:18:26" , 
"distance_traveled" : 68.3926
}, 
{ 
"stop_id" : 3,
"arrival_time" : "22:21:23" , 
"departure_time" : "22:21:53" , 
"distance_traveled" : 70.3095
}, 
{ 
"stop_id" : 151,
"arrival_time" : "22:23:30" , 
"departure_time" : "22:23:55" , 
"distance_traveled" : 71.6453
}, 
{ 
"stop_id" : 64,
"arrival_time" : "22:27:25" , 
"departure_time" : "22:28:01" , 
"distance_traveled" : 72.8689
}, 
{ 
"stop_id" : 131,
"arrival_time" : "22:30:36" , 
"departure_time" : "22:31:46" , 
"distance_traveled" : 74.0964
}, 
{ 
"stop_id" : 52,
"arrival_time" : "22:34:10" , 
"departure_time" : "22:34:45" , 
"distance_traveled" : 75.5417
}, 
{ 
"stop_id" : 58,
"arrival_time" : "22:37:35" , 
"departure_time" : "22:38:22" , 
"distance_traveled" : 77.2483
}, 
{ 
"stop_id" : 116,
"arrival_time" : "22:42:47" , 
"departure_time" : "22:43:02" , 
"distance_traveled" : 79.343
}, 
{ 
"stop_id" : 29,
"arrival_time" : "22:48:15" , 
"departure_time" : "22:49:31" , 
"distance_traveled" : 82.8674
}, 
{ 
"stop_id" : 115,
"arrival_time" : "22:52:16" , 
"departure_time" : "22:52:56" , 
"distance_traveled" : 84.5212
}, 
{ 
"stop_id" : 33,
"arrival_time" : "22:54:40" , 
"departure_time" : "22:54:43" , 
"distance_traveled" : 85.7778
}, 
{ 
"stop_id" : 75,
"arrival_time" : "22:57:03" , 
"departure_time" : "22:57:39" , 
"distance_traveled" : 86.879
}, 
{ 
"stop_id" : 66,
"arrival_time" : "22:59:36" , 
"departure_time" : "23:00:28" , 
"distance_traveled" : 87.4602
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "23:07:52" , 
"departure_time" : "23:07:55" , 
"distance_traveled" : 91.5805
}, 
{ 
"stop_id" : 63,
"arrival_time" : "23:19:03" , 
"departure_time" : "23:19:03" , 
"distance_traveled" : 95.1403
} ], 
"1743" :  [ 
{ 
"stop_id" : 86,
"arrival_time" : "15:20:00" , 
"departure_time" : "15:20:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 26,
"arrival_time" : "15:27:52" , 
"departure_time" : "15:28:38" , 
"distance_traveled" : 6.0362
}, 
{ 
"stop_id" : 135,
"arrival_time" : "15:39:46" , 
"departure_time" : "15:40:24" , 
"distance_traveled" : 16.1331
}, 
{ 
"stop_id" : 57,
"arrival_time" : "15:57:38" , 
"departure_time" : "15:57:58" , 
"distance_traveled" : 26.9248
}, 
{ 
"stop_id" : 149,
"arrival_time" : "16:07:20" , 
"departure_time" : "16:08:28" , 
"distance_traveled" : 34.4816
}, 
{ 
"stop_id" : 137,
"arrival_time" : "16:13:08" , 
"departure_time" : "16:13:58" , 
"distance_traveled" : 37.1144
}, 
{ 
"stop_id" : 144,
"arrival_time" : "16:20:50" , 
"departure_time" : "16:21:01" , 
"distance_traveled" : 41.092
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "16:24:11" , 
"departure_time" : "16:24:54" , 
"distance_traveled" : 43.8066
}, 
{ 
"stop_id" : 131,
"arrival_time" : "16:35:43" , 
"departure_time" : "16:36:16" , 
"distance_traveled" : 50.7949
}, 
{ 
"stop_id" : 126,
"arrival_time" : "16:40:33" , 
"departure_time" : "16:40:47" , 
"distance_traveled" : 53.7462
}, 
{ 
"stop_id" : 134,
"arrival_time" : "16:52:14" , 
"departure_time" : "16:52:25" , 
"distance_traveled" : 61.9627
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:01:11" , 
"departure_time" : "17:01:36" , 
"distance_traveled" : 67.0809
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:13:25" , 
"departure_time" : "17:13:25" , 
"distance_traveled" : 70.6407
} ], 
"1744" :  [ 
{ 
"stop_id" : 86,
"arrival_time" : "15:20:00" , 
"departure_time" : "15:21:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 26,
"arrival_time" : "15:28:14" , 
"departure_time" : "15:29:27" , 
"distance_traveled" : 6.0362
}, 
{ 
"stop_id" : 135,
"arrival_time" : "15:40:13" , 
"departure_time" : "15:40:40" , 
"distance_traveled" : 16.1331
}, 
{ 
"stop_id" : 57,
"arrival_time" : "15:57:27" , 
"departure_time" : "15:58:04" , 
"distance_traveled" : 26.9248
}, 
{ 
"stop_id" : 149,
"arrival_time" : "16:07:37" , 
"departure_time" : "16:08:57" , 
"distance_traveled" : 34.4816
}, 
{ 
"stop_id" : 137,
"arrival_time" : "16:13:20" , 
"departure_time" : "16:14:17" , 
"distance_traveled" : 37.1144
}, 
{ 
"stop_id" : 144,
"arrival_time" : "16:20:57" , 
"departure_time" : "16:22:05" , 
"distance_traveled" : 41.092
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "16:25:08" , 
"departure_time" : "16:25:11" , 
"distance_traveled" : 43.8066
}, 
{ 
"stop_id" : 131,
"arrival_time" : "16:35:03" , 
"departure_time" : "16:35:07" , 
"distance_traveled" : 50.7949
}, 
{ 
"stop_id" : 126,
"arrival_time" : "16:40:04" , 
"departure_time" : "16:41:29" , 
"distance_traveled" : 53.7462
}, 
{ 
"stop_id" : 134,
"arrival_time" : "16:53:25" , 
"departure_time" : "16:54:07" , 
"distance_traveled" : 61.9627
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:01:42" , 
"departure_time" : "17:02:16" , 
"distance_traveled" : 67.0809
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:13:34" , 
"departure_time" : "17:13:34" , 
"distance_traveled" : 70.6407
} ], 
"1745" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "04:31:00" , 
"departure_time" : "04:32:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "04:50:48" , 
"departure_time" : "04:51:18" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "05:02:30" , 
"departure_time" : "05:03:37" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "05:10:07" , 
"departure_time" : "05:10:20" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "05:21:13" , 
"departure_time" : "05:22:30" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "05:36:17" , 
"departure_time" : "05:36:26" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "05:46:09" , 
"departure_time" : "05:46:29" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "05:51:20" , 
"departure_time" : "05:52:37" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "06:01:17" , 
"departure_time" : "06:02:02" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "06:05:45" , 
"departure_time" : "06:06:09" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "06:35:24" , 
"departure_time" : "06:35:36" , 
"distance_traveled" : 91.4981
}, 
{ 
"stop_id" : 63,
"arrival_time" : "06:47:12" , 
"departure_time" : "06:47:12" , 
"distance_traveled" : 95.0638
} ], 
"1746" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "04:31:00" , 
"departure_time" : "04:32:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "04:51:18" , 
"departure_time" : "04:52:45" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "05:03:27" , 
"departure_time" : "05:04:05" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "05:09:38" , 
"departure_time" : "05:10:28" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "05:21:50" , 
"departure_time" : "05:23:18" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "05:36:28" , 
"departure_time" : "05:37:20" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "05:46:52" , 
"departure_time" : "05:47:02" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "05:51:10" , 
"departure_time" : "05:51:31" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "06:00:21" , 
"departure_time" : "06:00:46" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "06:05:25" , 
"departure_time" : "06:06:05" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "06:35:40" , 
"departure_time" : "06:36:28" , 
"distance_traveled" : 91.4981
}, 
{ 
"stop_id" : 63,
"arrival_time" : "06:47:48" , 
"departure_time" : "06:47:48" , 
"distance_traveled" : 95.0638
} ], 
"1747" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "04:59:00" , 
"departure_time" : "05:00:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "05:19:51" , 
"departure_time" : "05:20:07" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "05:30:16" , 
"departure_time" : "05:31:32" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "05:39:16" , 
"departure_time" : "05:39:27" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "05:50:11" , 
"departure_time" : "05:50:40" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "06:05:29" , 
"departure_time" : "06:06:41" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "06:16:12" , 
"departure_time" : "06:17:16" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "06:21:04" , 
"departure_time" : "06:21:19" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "06:28:15" , 
"departure_time" : "06:28:30" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "06:32:15" , 
"departure_time" : "06:32:31" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:01:16" , 
"departure_time" : "07:01:35" , 
"distance_traveled" : 91.4981
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:13:19" , 
"departure_time" : "07:13:19" , 
"distance_traveled" : 95.0638
} ], 
"1748" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "04:59:00" , 
"departure_time" : "05:00:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "05:20:25" , 
"departure_time" : "05:21:27" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "05:31:02" , 
"departure_time" : "05:32:12" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "05:39:10" , 
"departure_time" : "05:39:49" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "05:50:39" , 
"departure_time" : "05:51:47" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "06:06:08" , 
"departure_time" : "06:07:42" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "06:16:34" , 
"departure_time" : "06:17:18" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "06:20:44" , 
"departure_time" : "06:20:59" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "06:28:15" , 
"departure_time" : "06:29:23" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "06:33:08" , 
"departure_time" : "06:33:27" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:01:19" , 
"departure_time" : "07:02:59" , 
"distance_traveled" : 91.4981
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:14:40" , 
"departure_time" : "07:14:40" , 
"distance_traveled" : 95.0638
} ], 
"1749" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "05:30:00" , 
"departure_time" : "05:32:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "05:49:30" , 
"departure_time" : "05:49:54" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "06:01:24" , 
"departure_time" : "06:02:19" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "06:08:55" , 
"departure_time" : "06:09:29" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "06:21:34" , 
"departure_time" : "06:21:38" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "06:36:04" , 
"departure_time" : "06:37:14" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "06:47:10" , 
"departure_time" : "06:48:21" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "06:52:11" , 
"departure_time" : "06:52:50" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "06:59:39" , 
"departure_time" : "06:59:43" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "07:03:04" , 
"departure_time" : "07:03:17" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:33:13" , 
"departure_time" : "07:33:29" , 
"distance_traveled" : 91.4981
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:45:16" , 
"departure_time" : "07:45:16" , 
"distance_traveled" : 95.0638
} ], 
"1750" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "05:30:00" , 
"departure_time" : "05:31:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "05:49:55" , 
"departure_time" : "05:51:35" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "06:02:40" , 
"departure_time" : "06:03:04" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "06:08:24" , 
"departure_time" : "06:09:25" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "06:22:01" , 
"departure_time" : "06:22:16" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "06:36:15" , 
"departure_time" : "06:37:14" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "06:46:59" , 
"departure_time" : "06:47:46" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "06:51:47" , 
"departure_time" : "06:53:16" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "07:00:29" , 
"departure_time" : "07:00:47" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "07:03:18" , 
"departure_time" : "07:03:59" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:33:41" , 
"departure_time" : "07:34:12" , 
"distance_traveled" : 91.4981
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:45:31" , 
"departure_time" : "07:45:31" , 
"distance_traveled" : 95.0638
} ], 
"1751" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "06:51:00" , 
"departure_time" : "06:51:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "07:10:20" , 
"departure_time" : "07:10:42" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "07:21:22" , 
"departure_time" : "07:22:12" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "07:29:50" , 
"departure_time" : "07:30:39" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "07:41:49" , 
"departure_time" : "07:43:09" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "07:57:20" , 
"departure_time" : "07:58:07" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "08:06:47" , 
"departure_time" : "08:08:13" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "08:12:26" , 
"departure_time" : "08:13:17" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "08:19:51" , 
"departure_time" : "08:21:09" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "08:24:18" , 
"departure_time" : "08:25:02" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:53:44" , 
"departure_time" : "08:54:05" , 
"distance_traveled" : 91.4981
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:05:21" , 
"departure_time" : "09:05:21" , 
"distance_traveled" : 95.0638
} ], 
"1752" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "06:51:00" , 
"departure_time" : "06:52:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "07:10:41" , 
"departure_time" : "07:11:12" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "07:21:31" , 
"departure_time" : "07:22:12" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "07:29:41" , 
"departure_time" : "07:31:08" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "07:42:27" , 
"departure_time" : "07:42:59" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "07:56:32" , 
"departure_time" : "07:57:26" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "08:06:54" , 
"departure_time" : "08:07:00" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "08:11:06" , 
"departure_time" : "08:11:25" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "08:19:19" , 
"departure_time" : "08:20:30" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "08:24:11" , 
"departure_time" : "08:24:51" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:53:40" , 
"departure_time" : "08:54:47" , 
"distance_traveled" : 91.4981
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:06:07" , 
"departure_time" : "09:06:07" , 
"distance_traveled" : 95.0638
} ], 
"1753" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "07:39:00" , 
"departure_time" : "07:40:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "07:59:07" , 
"departure_time" : "08:00:20" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "08:11:13" , 
"departure_time" : "08:12:24" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "08:19:11" , 
"departure_time" : "08:19:40" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "08:30:29" , 
"departure_time" : "08:30:39" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "08:45:10" , 
"departure_time" : "08:46:05" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "08:55:55" , 
"departure_time" : "08:55:59" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "09:00:04" , 
"departure_time" : "09:00:58" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "09:08:54" , 
"departure_time" : "09:09:44" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "09:12:50" , 
"departure_time" : "09:13:33" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:40:43" , 
"departure_time" : "09:41:25" , 
"distance_traveled" : 91.4981
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:52:42" , 
"departure_time" : "09:52:42" , 
"distance_traveled" : 95.0638
} ], 
"1754" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "07:39:00" , 
"departure_time" : "07:39:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "07:59:07" , 
"departure_time" : "07:59:29" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "08:10:22" , 
"departure_time" : "08:11:40" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "08:19:18" , 
"departure_time" : "08:19:37" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "08:30:19" , 
"departure_time" : "08:30:40" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "08:45:21" , 
"departure_time" : "08:46:41" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "08:56:20" , 
"departure_time" : "08:56:58" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "09:00:38" , 
"departure_time" : "09:00:53" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "09:08:15" , 
"departure_time" : "09:09:54" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "09:13:39" , 
"departure_time" : "09:14:52" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:41:13" , 
"departure_time" : "09:41:50" , 
"distance_traveled" : 91.4981
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:52:37" , 
"departure_time" : "09:52:37" , 
"distance_traveled" : 95.0638
} ], 
"1755" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "09:21:00" , 
"departure_time" : "09:21:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "09:42:09" , 
"departure_time" : "09:43:37" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "09:54:28" , 
"departure_time" : "09:54:45" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "10:00:17" , 
"departure_time" : "10:01:35" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "10:14:18" , 
"departure_time" : "10:15:19" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "10:29:01" , 
"departure_time" : "10:29:48" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "10:38:47" , 
"departure_time" : "10:40:02" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "10:44:15" , 
"departure_time" : "10:44:41" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "10:50:26" , 
"departure_time" : "10:51:01" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "10:54:35" , 
"departure_time" : "10:55:06" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "11:26:31" , 
"departure_time" : "11:27:35" , 
"distance_traveled" : 91.4981
}, 
{ 
"stop_id" : 63,
"arrival_time" : "11:39:04" , 
"departure_time" : "11:39:04" , 
"distance_traveled" : 95.0638
} ], 
"1756" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "09:21:00" , 
"departure_time" : "09:23:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "09:42:59" , 
"departure_time" : "09:43:20" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "09:53:21" , 
"departure_time" : "09:54:42" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "10:01:21" , 
"departure_time" : "10:01:28" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "10:13:07" , 
"departure_time" : "10:13:29" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "10:28:22" , 
"departure_time" : "10:29:12" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "10:38:50" , 
"departure_time" : "10:39:59" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "10:44:09" , 
"departure_time" : "10:45:13" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "10:51:04" , 
"departure_time" : "10:52:24" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "10:55:20" , 
"departure_time" : "10:56:11" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "11:26:51" , 
"departure_time" : "11:28:21" , 
"distance_traveled" : 91.4981
}, 
{ 
"stop_id" : 63,
"arrival_time" : "11:39:30" , 
"departure_time" : "11:39:30" , 
"distance_traveled" : 95.0638
} ], 
"1757" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "13:35:00" , 
"departure_time" : "13:37:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "13:57:24" , 
"departure_time" : "13:58:21" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "14:07:57" , 
"departure_time" : "14:08:32" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "14:14:35" , 
"departure_time" : "14:15:07" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "14:27:32" , 
"departure_time" : "14:28:46" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "14:43:14" , 
"departure_time" : "14:44:24" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "14:53:10" , 
"departure_time" : "14:54:41" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "14:59:31" , 
"departure_time" : "14:59:40" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "15:06:09" , 
"departure_time" : "15:06:12" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "15:10:03" , 
"departure_time" : "15:11:28" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 131,
"arrival_time" : "15:21:25" , 
"departure_time" : "15:21:59" , 
"distance_traveled" : 74.0964
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "15:42:34" , 
"departure_time" : "15:42:36" , 
"distance_traveled" : 91.5038
}, 
{ 
"stop_id" : 63,
"arrival_time" : "15:54:02" , 
"departure_time" : "15:54:02" , 
"distance_traveled" : 95.0636
} ], 
"1758" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "13:35:00" , 
"departure_time" : "13:35:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "13:56:26" , 
"departure_time" : "13:57:25" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "14:07:59" , 
"departure_time" : "14:08:41" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "14:14:42" , 
"departure_time" : "14:15:26" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "14:27:44" , 
"departure_time" : "14:28:40" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "14:42:56" , 
"departure_time" : "14:44:32" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "14:53:36" , 
"departure_time" : "14:54:07" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "14:58:31" , 
"departure_time" : "14:59:46" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "15:07:15" , 
"departure_time" : "15:07:28" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "15:10:13" , 
"departure_time" : "15:11:26" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 131,
"arrival_time" : "15:21:13" , 
"departure_time" : "15:21:48" , 
"distance_traveled" : 74.0964
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "15:42:35" , 
"departure_time" : "15:42:40" , 
"distance_traveled" : 91.5038
}, 
{ 
"stop_id" : 63,
"arrival_time" : "15:54:05" , 
"departure_time" : "15:54:05" , 
"distance_traveled" : 95.0636
} ], 
"1759" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "06:03:00" , 
"departure_time" : "06:03:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "06:23:19" , 
"departure_time" : "06:24:18" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "06:34:59" , 
"departure_time" : "06:36:18" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "06:43:19" , 
"departure_time" : "06:44:27" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "06:56:08" , 
"departure_time" : "06:56:24" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "07:10:16" , 
"departure_time" : "07:10:44" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "07:20:28" , 
"departure_time" : "07:20:44" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "07:25:16" , 
"departure_time" : "07:25:47" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "07:33:31" , 
"departure_time" : "07:34:38" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 78,
"arrival_time" : "07:37:07" , 
"departure_time" : "07:37:29" , 
"distance_traveled" : 65.7714
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "07:40:22" , 
"departure_time" : "07:40:58" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 128,
"arrival_time" : "07:44:36" , 
"departure_time" : "07:45:00" , 
"distance_traveled" : 68.3926
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:14:24" , 
"departure_time" : "08:15:26" , 
"distance_traveled" : 91.4981
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:27:02" , 
"departure_time" : "08:27:02" , 
"distance_traveled" : 95.0638
} ], 
"1760" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "06:03:00" , 
"departure_time" : "06:04:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "06:23:32" , 
"departure_time" : "06:24:58" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "06:35:26" , 
"departure_time" : "06:35:39" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "06:42:13" , 
"departure_time" : "06:43:45" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "06:56:32" , 
"departure_time" : "06:58:12" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "07:11:40" , 
"departure_time" : "07:13:13" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "07:21:33" , 
"departure_time" : "07:22:18" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "07:25:45" , 
"departure_time" : "07:27:20" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "07:34:35" , 
"departure_time" : "07:35:27" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 78,
"arrival_time" : "07:36:52" , 
"departure_time" : "07:37:52" , 
"distance_traveled" : 65.7714
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "07:41:00" , 
"departure_time" : "07:41:48" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 128,
"arrival_time" : "07:44:48" , 
"departure_time" : "07:45:29" , 
"distance_traveled" : 68.3926
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:14:41" , 
"departure_time" : "08:15:41" , 
"distance_traveled" : 91.4981
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:27:00" , 
"departure_time" : "08:27:00" , 
"distance_traveled" : 95.0638
} ], 
"1761" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "21:22:00" , 
"departure_time" : "21:23:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "21:43:23" , 
"departure_time" : "21:44:10" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "21:57:47" , 
"departure_time" : "21:59:10" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "22:05:23" , 
"departure_time" : "22:06:58" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "22:17:35" , 
"departure_time" : "22:18:05" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "22:30:30" , 
"departure_time" : "22:30:44" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "22:40:14" , 
"departure_time" : "22:41:26" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "22:46:12" , 
"departure_time" : "22:47:01" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "22:53:49" , 
"departure_time" : "22:55:08" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 78,
"arrival_time" : "22:57:19" , 
"departure_time" : "22:58:57" , 
"distance_traveled" : 65.7714
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "23:00:38" , 
"departure_time" : "23:01:49" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 128,
"arrival_time" : "23:03:11" , 
"departure_time" : "23:04:38" , 
"distance_traveled" : 68.3926
}, 
{ 
"stop_id" : 3,
"arrival_time" : "23:06:27" , 
"departure_time" : "23:07:22" , 
"distance_traveled" : 70.3095
}, 
{ 
"stop_id" : 131,
"arrival_time" : "23:12:55" , 
"departure_time" : "23:13:26" , 
"distance_traveled" : 74.0992
}, 
{ 
"stop_id" : 126,
"arrival_time" : "23:17:31" , 
"departure_time" : "23:19:07" , 
"distance_traveled" : 77.0534
}, 
{ 
"stop_id" : 134,
"arrival_time" : "23:30:36" , 
"departure_time" : "23:30:40" , 
"distance_traveled" : 85.2699
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "23:37:04" , 
"departure_time" : "23:38:42" , 
"distance_traveled" : 90.3881
}, 
{ 
"stop_id" : 63,
"arrival_time" : "23:50:38" , 
"departure_time" : "23:50:38" , 
"distance_traveled" : 93.9479
} ], 
"1762" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "21:22:00" , 
"departure_time" : "21:24:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "21:43:51" , 
"departure_time" : "21:44:18" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "21:57:27" , 
"departure_time" : "21:59:00" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "22:05:33" , 
"departure_time" : "22:06:54" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "22:17:21" , 
"departure_time" : "22:17:40" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "22:30:19" , 
"departure_time" : "22:30:38" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "22:40:19" , 
"departure_time" : "22:41:31" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "22:46:12" , 
"departure_time" : "22:47:12" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "22:54:00" , 
"departure_time" : "22:55:23" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 78,
"arrival_time" : "22:57:23" , 
"departure_time" : "22:58:06" , 
"distance_traveled" : 65.7714
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "22:59:43" , 
"departure_time" : "23:00:58" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 128,
"arrival_time" : "23:03:15" , 
"departure_time" : "23:03:29" , 
"distance_traveled" : 68.3926
}, 
{ 
"stop_id" : 3,
"arrival_time" : "23:05:14" , 
"departure_time" : "23:06:06" , 
"distance_traveled" : 70.3095
}, 
{ 
"stop_id" : 131,
"arrival_time" : "23:12:52" , 
"departure_time" : "23:13:25" , 
"distance_traveled" : 74.0992
}, 
{ 
"stop_id" : 126,
"arrival_time" : "23:17:33" , 
"departure_time" : "23:17:38" , 
"distance_traveled" : 77.0534
}, 
{ 
"stop_id" : 134,
"arrival_time" : "23:29:05" , 
"departure_time" : "23:29:48" , 
"distance_traveled" : 85.2699
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "23:37:43" , 
"departure_time" : "23:37:55" , 
"distance_traveled" : 90.3881
}, 
{ 
"stop_id" : 63,
"arrival_time" : "23:49:12" , 
"departure_time" : "23:49:12" , 
"distance_traveled" : 93.9479
} ], 
"1763" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "03:46:00" , 
"departure_time" : "03:46:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "04:06:31" , 
"departure_time" : "04:07:28" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "04:17:57" , 
"departure_time" : "04:19:03" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "04:25:06" , 
"departure_time" : "04:25:33" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "04:37:27" , 
"departure_time" : "04:37:57" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "04:52:30" , 
"departure_time" : "04:52:38" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "05:02:08" , 
"departure_time" : "05:02:44" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "05:07:36" , 
"departure_time" : "05:09:11" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "05:16:35" , 
"departure_time" : "05:17:13" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 131,
"arrival_time" : "05:27:38" , 
"departure_time" : "05:28:59" , 
"distance_traveled" : 74.0966
}, 
{ 
"stop_id" : 51,
"arrival_time" : "05:32:21" , 
"departure_time" : "05:33:35" , 
"distance_traveled" : 75.5076
}, 
{ 
"stop_id" : 126,
"arrival_time" : "05:36:14" , 
"departure_time" : "05:36:23" , 
"distance_traveled" : 77.0479
}, 
{ 
"stop_id" : 25,
"arrival_time" : "05:38:09" , 
"departure_time" : "05:39:30" , 
"distance_traveled" : 78.2989
}, 
{ 
"stop_id" : 121,
"arrival_time" : "05:44:21" , 
"departure_time" : "05:44:37" , 
"distance_traveled" : 81.0265
}, 
{ 
"stop_id" : 46,
"arrival_time" : "05:46:16" , 
"departure_time" : "05:47:21" , 
"distance_traveled" : 82.3051
}, 
{ 
"stop_id" : 134,
"arrival_time" : "05:53:05" , 
"departure_time" : "05:54:12" , 
"distance_traveled" : 85.2646
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "06:01:07" , 
"departure_time" : "06:01:55" , 
"distance_traveled" : 90.3828
}, 
{ 
"stop_id" : 63,
"arrival_time" : "06:12:48" , 
"departure_time" : "06:12:48" , 
"distance_traveled" : 93.9426
} ], 
"1764" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "03:46:00" , 
"departure_time" : "03:47:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "04:07:01" , 
"departure_time" : "04:08:20" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "04:18:19" , 
"departure_time" : "04:18:24" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "04:24:05" , 
"departure_time" : "04:25:11" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "04:38:06" , 
"departure_time" : "04:38:31" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "04:52:25" , 
"departure_time" : "04:52:41" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "05:02:16" , 
"departure_time" : "05:02:58" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "05:07:42" , 
"departure_time" : "05:08:35" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "05:15:53" , 
"departure_time" : "05:17:15" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 131,
"arrival_time" : "05:28:22" , 
"departure_time" : "05:29:34" , 
"distance_traveled" : 74.0966
}, 
{ 
"stop_id" : 51,
"arrival_time" : "05:32:12" , 
"departure_time" : "05:33:28" , 
"distance_traveled" : 75.5076
}, 
{ 
"stop_id" : 126,
"arrival_time" : "05:36:16" , 
"departure_time" : "05:36:25" , 
"distance_traveled" : 77.0479
}, 
{ 
"stop_id" : 25,
"arrival_time" : "05:38:09" , 
"departure_time" : "05:39:12" , 
"distance_traveled" : 78.2989
}, 
{ 
"stop_id" : 121,
"arrival_time" : "05:44:03" , 
"departure_time" : "05:45:04" , 
"distance_traveled" : 81.0265
}, 
{ 
"stop_id" : 46,
"arrival_time" : "05:47:01" , 
"departure_time" : "05:47:50" , 
"distance_traveled" : 82.3051
}, 
{ 
"stop_id" : 134,
"arrival_time" : "05:52:49" , 
"departure_time" : "05:53:25" , 
"distance_traveled" : 85.2646
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "06:00:36" , 
"departure_time" : "06:00:38" , 
"distance_traveled" : 90.3828
}, 
{ 
"stop_id" : 63,
"arrival_time" : "06:12:02" , 
"departure_time" : "06:12:02" , 
"distance_traveled" : 93.9426
} ], 
"1765" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "11:35:00" , 
"departure_time" : "11:36:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "11:57:38" , 
"departure_time" : "11:58:41" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "12:08:03" , 
"departure_time" : "12:08:26" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "12:14:23" , 
"departure_time" : "12:14:29" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "12:27:06" , 
"departure_time" : "12:27:57" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "12:42:51" , 
"departure_time" : "12:43:11" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "12:52:20" , 
"departure_time" : "12:52:36" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "12:57:16" , 
"departure_time" : "12:57:44" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "13:04:28" , 
"departure_time" : "13:05:59" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 78,
"arrival_time" : "13:08:31" , 
"departure_time" : "13:09:01" , 
"distance_traveled" : 65.7714
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "13:10:30" , 
"departure_time" : "13:11:42" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 128,
"arrival_time" : "13:14:12" , 
"departure_time" : "13:15:05" , 
"distance_traveled" : 68.3926
}, 
{ 
"stop_id" : 3,
"arrival_time" : "13:16:53" , 
"departure_time" : "13:17:36" , 
"distance_traveled" : 70.3095
}, 
{ 
"stop_id" : 151,
"arrival_time" : "13:20:43" , 
"departure_time" : "13:21:36" , 
"distance_traveled" : 71.6453
}, 
{ 
"stop_id" : 64,
"arrival_time" : "13:23:53" , 
"departure_time" : "13:25:15" , 
"distance_traveled" : 72.8689
}, 
{ 
"stop_id" : 131,
"arrival_time" : "13:27:22" , 
"departure_time" : "13:27:35" , 
"distance_traveled" : 74.0964
}, 
{ 
"stop_id" : 51,
"arrival_time" : "13:30:13" , 
"departure_time" : "13:31:45" , 
"distance_traveled" : 75.5074
}, 
{ 
"stop_id" : 126,
"arrival_time" : "13:35:32" , 
"departure_time" : "13:36:45" , 
"distance_traveled" : 77.0477
}, 
{ 
"stop_id" : 25,
"arrival_time" : "13:38:13" , 
"departure_time" : "13:39:47" , 
"distance_traveled" : 78.2987
}, 
{ 
"stop_id" : 121,
"arrival_time" : "13:43:34" , 
"departure_time" : "13:44:25" , 
"distance_traveled" : 81.0263
}, 
{ 
"stop_id" : 46,
"arrival_time" : "13:45:51" , 
"departure_time" : "13:46:35" , 
"distance_traveled" : 82.3049
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "13:48:44" , 
"departure_time" : "13:49:44" , 
"distance_traveled" : 83.3269
}, 
{ 
"stop_id" : 134,
"arrival_time" : "13:54:00" , 
"departure_time" : "13:54:30" , 
"distance_traveled" : 85.2642
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "14:01:30" , 
"departure_time" : "14:02:20" , 
"distance_traveled" : 90.3824
}, 
{ 
"stop_id" : 63,
"arrival_time" : "14:13:50" , 
"departure_time" : "14:13:50" , 
"distance_traveled" : 93.9422
} ], 
"1766" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "11:35:00" , 
"departure_time" : "11:35:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "11:56:06" , 
"departure_time" : "11:57:24" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "12:08:18" , 
"departure_time" : "12:09:18" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "12:15:00" , 
"departure_time" : "12:16:33" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "12:28:33" , 
"departure_time" : "12:29:39" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "12:43:06" , 
"departure_time" : "12:44:24" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "12:53:18" , 
"departure_time" : "12:54:51" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "12:58:33" , 
"departure_time" : "12:58:49" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "13:04:16" , 
"departure_time" : "13:05:12" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 78,
"arrival_time" : "13:07:56" , 
"departure_time" : "13:08:45" , 
"distance_traveled" : 65.7714
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "13:10:49" , 
"departure_time" : "13:12:19" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 128,
"arrival_time" : "13:14:30" , 
"departure_time" : "13:15:19" , 
"distance_traveled" : 68.3926
}, 
{ 
"stop_id" : 3,
"arrival_time" : "13:16:49" , 
"departure_time" : "13:18:17" , 
"distance_traveled" : 70.3095
}, 
{ 
"stop_id" : 151,
"arrival_time" : "13:21:28" , 
"departure_time" : "13:22:10" , 
"distance_traveled" : 71.6453
}, 
{ 
"stop_id" : 64,
"arrival_time" : "13:23:42" , 
"departure_time" : "13:23:58" , 
"distance_traveled" : 72.8689
}, 
{ 
"stop_id" : 131,
"arrival_time" : "13:26:16" , 
"departure_time" : "13:27:34" , 
"distance_traveled" : 74.0964
}, 
{ 
"stop_id" : 51,
"arrival_time" : "13:31:18" , 
"departure_time" : "13:31:21" , 
"distance_traveled" : 75.5074
}, 
{ 
"stop_id" : 126,
"arrival_time" : "13:34:03" , 
"departure_time" : "13:34:43" , 
"distance_traveled" : 77.0477
}, 
{ 
"stop_id" : 25,
"arrival_time" : "13:37:40" , 
"departure_time" : "13:39:04" , 
"distance_traveled" : 78.2987
}, 
{ 
"stop_id" : 121,
"arrival_time" : "13:43:24" , 
"departure_time" : "13:44:11" , 
"distance_traveled" : 81.0263
}, 
{ 
"stop_id" : 46,
"arrival_time" : "13:45:47" , 
"departure_time" : "13:46:24" , 
"distance_traveled" : 82.3049
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "13:48:37" , 
"departure_time" : "13:49:33" , 
"distance_traveled" : 83.3269
}, 
{ 
"stop_id" : 134,
"arrival_time" : "13:53:56" , 
"departure_time" : "13:55:33" , 
"distance_traveled" : 85.2642
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "14:02:37" , 
"departure_time" : "14:04:05" , 
"distance_traveled" : 90.3824
}, 
{ 
"stop_id" : 63,
"arrival_time" : "14:14:28" , 
"departure_time" : "14:14:28" , 
"distance_traveled" : 93.9422
} ], 
"1767" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "05:48:00" , 
"departure_time" : "05:49:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "06:08:20" , 
"departure_time" : "06:08:48" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "06:19:28" , 
"departure_time" : "06:20:35" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "06:28:07" , 
"departure_time" : "06:28:46" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "06:39:39" , 
"departure_time" : "06:40:08" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "06:54:29" , 
"departure_time" : "06:55:54" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:47:25" , 
"departure_time" : "07:47:28" , 
"distance_traveled" : 90.3826
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:58:03" , 
"departure_time" : "07:58:03" , 
"distance_traveled" : 93.9424
} ], 
"1768" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "05:48:00" , 
"departure_time" : "05:49:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "06:08:57" , 
"departure_time" : "06:08:58" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "06:19:01" , 
"departure_time" : "06:19:20" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "06:27:19" , 
"departure_time" : "06:28:11" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "06:39:52" , 
"departure_time" : "06:40:05" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "06:54:13" , 
"departure_time" : "06:54:57" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:46:44" , 
"departure_time" : "07:47:57" , 
"distance_traveled" : 90.3826
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:59:13" , 
"departure_time" : "07:59:13" , 
"distance_traveled" : 93.9424
} ], 
"1769" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "06:18:00" , 
"departure_time" : "06:19:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "06:38:05" , 
"departure_time" : "06:39:24" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "06:50:19" , 
"departure_time" : "06:51:41" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "06:57:22" , 
"departure_time" : "06:57:59" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "07:09:37" , 
"departure_time" : "07:09:50" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "07:24:13" , 
"departure_time" : "07:24:21" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "07:34:08" , 
"departure_time" : "07:35:40" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "07:40:32" , 
"departure_time" : "07:41:55" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "07:47:23" , 
"departure_time" : "07:48:58" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:19:35" , 
"departure_time" : "08:21:06" , 
"distance_traveled" : 91.4981
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:31:31" , 
"departure_time" : "08:31:31" , 
"distance_traveled" : 95.0638
} ], 
"1770" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "17:28:00" , 
"departure_time" : "17:29:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "17:48:17" , 
"departure_time" : "17:49:18" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "18:01:01" , 
"departure_time" : "18:01:30" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "18:07:29" , 
"departure_time" : "18:08:24" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "18:19:55" , 
"departure_time" : "18:20:06" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "18:34:11" , 
"departure_time" : "18:34:52" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "18:44:41" , 
"departure_time" : "18:46:15" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "18:51:34" , 
"departure_time" : "18:51:54" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "18:57:20" , 
"departure_time" : "18:58:30" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 131,
"arrival_time" : "19:10:10" , 
"departure_time" : "19:11:21" , 
"distance_traveled" : 74.0966
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:29:11" , 
"departure_time" : "19:30:43" , 
"distance_traveled" : 91.504
}, 
{ 
"stop_id" : 63,
"arrival_time" : "19:40:32" , 
"departure_time" : "19:40:32" , 
"distance_traveled" : 95.0638
} ], 
"1771" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "07:19:00" , 
"departure_time" : "07:21:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "07:40:40" , 
"departure_time" : "07:41:27" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "07:51:47" , 
"departure_time" : "07:52:05" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "07:58:18" , 
"departure_time" : "07:59:43" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "08:11:25" , 
"departure_time" : "08:11:44" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "08:25:19" , 
"departure_time" : "08:25:42" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "08:35:23" , 
"departure_time" : "08:36:52" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "08:41:29" , 
"departure_time" : "08:41:59" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "08:47:30" , 
"departure_time" : "08:47:54" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "08:51:24" , 
"departure_time" : "08:51:51" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:21:27" , 
"departure_time" : "09:22:55" , 
"distance_traveled" : 91.4981
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:34:28" , 
"departure_time" : "09:34:28" , 
"distance_traveled" : 95.0638
} ], 
"1772" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "15:04:00" , 
"departure_time" : "15:05:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "15:24:04" , 
"departure_time" : "15:24:40" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "15:35:36" , 
"departure_time" : "15:36:04" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "15:42:28" , 
"departure_time" : "15:43:10" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "15:55:42" , 
"departure_time" : "15:56:53" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "16:11:11" , 
"departure_time" : "16:12:33" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "16:21:22" , 
"departure_time" : "16:22:37" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "16:26:15" , 
"departure_time" : "16:26:36" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "16:32:21" , 
"departure_time" : "16:33:11" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 78,
"arrival_time" : "16:34:50" , 
"departure_time" : "16:34:54" , 
"distance_traveled" : 65.7714
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "16:37:04" , 
"departure_time" : "16:37:26" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 128,
"arrival_time" : "16:41:22" , 
"departure_time" : "16:42:29" , 
"distance_traveled" : 68.3926
}, 
{ 
"stop_id" : 3,
"arrival_time" : "16:45:07" , 
"departure_time" : "16:45:31" , 
"distance_traveled" : 70.3095
}, 
{ 
"stop_id" : 131,
"arrival_time" : "16:51:24" , 
"departure_time" : "16:51:39" , 
"distance_traveled" : 74.0992
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:14:15" , 
"departure_time" : "17:14:53" , 
"distance_traveled" : 91.5038
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:26:38" , 
"departure_time" : "17:26:38" , 
"distance_traveled" : 95.0636
} ], 
"1773" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "08:57:00" , 
"departure_time" : "08:58:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "09:19:05" , 
"departure_time" : "09:19:54" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "09:29:49" , 
"departure_time" : "09:31:17" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "09:37:28" , 
"departure_time" : "09:39:05" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "09:49:37" , 
"departure_time" : "09:51:11" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "10:04:34" , 
"departure_time" : "10:05:48" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "10:14:14" , 
"departure_time" : "10:15:35" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "10:19:21" , 
"departure_time" : "10:20:49" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "10:28:28" , 
"departure_time" : "10:29:45" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "10:32:17" , 
"departure_time" : "10:33:00" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 131,
"arrival_time" : "10:41:43" , 
"departure_time" : "10:42:16" , 
"distance_traveled" : 74.0964
}, 
{ 
"stop_id" : 51,
"arrival_time" : "10:45:33" , 
"departure_time" : "10:46:48" , 
"distance_traveled" : 75.5074
}, 
{ 
"stop_id" : 126,
"arrival_time" : "10:49:15" , 
"departure_time" : "10:50:02" , 
"distance_traveled" : 77.0477
}, 
{ 
"stop_id" : 25,
"arrival_time" : "10:51:47" , 
"departure_time" : "10:52:03" , 
"distance_traveled" : 78.2987
}, 
{ 
"stop_id" : 121,
"arrival_time" : "10:56:16" , 
"departure_time" : "10:56:31" , 
"distance_traveled" : 81.0263
}, 
{ 
"stop_id" : 134,
"arrival_time" : "11:04:15" , 
"departure_time" : "11:04:52" , 
"distance_traveled" : 85.2642
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "11:12:37" , 
"departure_time" : "11:13:10" , 
"distance_traveled" : 90.3824
}, 
{ 
"stop_id" : 63,
"arrival_time" : "11:24:33" , 
"departure_time" : "11:24:33" , 
"distance_traveled" : 93.9422
} ], 
"1774" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "10:57:00" , 
"departure_time" : "10:57:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "11:18:06" , 
"departure_time" : "11:18:37" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "11:29:31" , 
"departure_time" : "11:30:23" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "11:36:52" , 
"departure_time" : "11:37:23" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "11:48:31" , 
"departure_time" : "11:48:34" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "12:03:03" , 
"departure_time" : "12:03:52" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "12:13:49" , 
"departure_time" : "12:14:18" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "12:18:29" , 
"departure_time" : "12:19:25" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "12:27:56" , 
"departure_time" : "12:28:20" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "12:31:24" , 
"departure_time" : "12:32:57" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 131,
"arrival_time" : "12:42:33" , 
"departure_time" : "12:43:29" , 
"distance_traveled" : 74.0964
}, 
{ 
"stop_id" : 51,
"arrival_time" : "12:45:56" , 
"departure_time" : "12:46:40" , 
"distance_traveled" : 75.5074
}, 
{ 
"stop_id" : 126,
"arrival_time" : "12:48:44" , 
"departure_time" : "12:50:22" , 
"distance_traveled" : 77.0477
}, 
{ 
"stop_id" : 25,
"arrival_time" : "12:52:38" , 
"departure_time" : "12:53:44" , 
"distance_traveled" : 78.2987
}, 
{ 
"stop_id" : 121,
"arrival_time" : "12:57:06" , 
"departure_time" : "12:58:03" , 
"distance_traveled" : 81.0263
}, 
{ 
"stop_id" : 134,
"arrival_time" : "13:04:57" , 
"departure_time" : "13:06:25" , 
"distance_traveled" : 85.2642
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "13:13:28" , 
"departure_time" : "13:14:33" , 
"distance_traveled" : 90.3824
}, 
{ 
"stop_id" : 63,
"arrival_time" : "13:25:05" , 
"departure_time" : "13:25:05" , 
"distance_traveled" : 93.9422
} ], 
"1775" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "04:41:00" , 
"departure_time" : "04:42:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "05:01:12" , 
"departure_time" : "05:02:19" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "05:13:07" , 
"departure_time" : "05:13:30" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "05:19:23" , 
"departure_time" : "05:20:02" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "05:31:39" , 
"departure_time" : "05:32:44" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "05:47:05" , 
"departure_time" : "05:47:39" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "05:56:34" , 
"departure_time" : "05:57:25" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "06:01:51" , 
"departure_time" : "06:02:03" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "06:08:12" , 
"departure_time" : "06:08:43" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 78,
"arrival_time" : "06:11:31" , 
"departure_time" : "06:11:33" , 
"distance_traveled" : 65.7714
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "06:14:02" , 
"departure_time" : "06:15:31" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 128,
"arrival_time" : "06:18:29" , 
"departure_time" : "06:19:13" , 
"distance_traveled" : 68.3926
}, 
{ 
"stop_id" : 3,
"arrival_time" : "06:20:44" , 
"departure_time" : "06:21:18" , 
"distance_traveled" : 70.3095
}, 
{ 
"stop_id" : 151,
"arrival_time" : "06:23:34" , 
"departure_time" : "06:23:49" , 
"distance_traveled" : 71.6453
}, 
{ 
"stop_id" : 64,
"arrival_time" : "06:27:15" , 
"departure_time" : "06:28:03" , 
"distance_traveled" : 72.8689
}, 
{ 
"stop_id" : 131,
"arrival_time" : "06:30:48" , 
"departure_time" : "06:31:32" , 
"distance_traveled" : 74.0964
}, 
{ 
"stop_id" : 52,
"arrival_time" : "06:33:44" , 
"departure_time" : "06:34:29" , 
"distance_traveled" : 75.5417
}, 
{ 
"stop_id" : 58,
"arrival_time" : "06:37:45" , 
"departure_time" : "06:39:11" , 
"distance_traveled" : 77.2483
}, 
{ 
"stop_id" : 116,
"arrival_time" : "06:43:26" , 
"departure_time" : "06:44:53" , 
"distance_traveled" : 79.343
}, 
{ 
"stop_id" : 29,
"arrival_time" : "06:49:27" , 
"departure_time" : "06:49:58" , 
"distance_traveled" : 82.8674
}, 
{ 
"stop_id" : 115,
"arrival_time" : "06:51:31" , 
"departure_time" : "06:52:46" , 
"distance_traveled" : 84.5212
}, 
{ 
"stop_id" : 33,
"arrival_time" : "06:55:15" , 
"departure_time" : "06:56:42" , 
"distance_traveled" : 85.7778
}, 
{ 
"stop_id" : 75,
"arrival_time" : "06:58:27" , 
"departure_time" : "07:00:07" , 
"distance_traveled" : 86.879
}, 
{ 
"stop_id" : 66,
"arrival_time" : "07:00:40" , 
"departure_time" : "07:01:30" , 
"distance_traveled" : 87.4602
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:07:50" , 
"departure_time" : "07:09:30" , 
"distance_traveled" : 91.5805
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:20:40" , 
"departure_time" : "07:20:40" , 
"distance_traveled" : 95.1403
} ], 
"1776" :  [ 
{ 
"stop_id" : 123,
"arrival_time" : "20:41:00" , 
"departure_time" : "20:43:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 113,
"arrival_time" : "21:02:28" , 
"departure_time" : "21:03:17" , 
"distance_traveled" : 13.5739
}, 
{ 
"stop_id" : 86,
"arrival_time" : "21:13:49" , 
"departure_time" : "21:14:38" , 
"distance_traveled" : 23.3123
}, 
{ 
"stop_id" : 26,
"arrival_time" : "21:20:49" , 
"departure_time" : "21:21:02" , 
"distance_traveled" : 29.3377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "21:32:13" , 
"departure_time" : "21:33:18" , 
"distance_traveled" : 39.4347
}, 
{ 
"stop_id" : 57,
"arrival_time" : "21:48:05" , 
"departure_time" : "21:49:18" , 
"distance_traveled" : 50.2263
}, 
{ 
"stop_id" : 149,
"arrival_time" : "21:58:13" , 
"departure_time" : "21:59:48" , 
"distance_traveled" : 57.7831
}, 
{ 
"stop_id" : 137,
"arrival_time" : "22:03:35" , 
"departure_time" : "22:03:36" , 
"distance_traveled" : 60.4159
}, 
{ 
"stop_id" : 144,
"arrival_time" : "22:08:01" , 
"departure_time" : "22:08:51" , 
"distance_traveled" : 64.3936
}, 
{ 
"stop_id" : 78,
"arrival_time" : "22:11:50" , 
"departure_time" : "22:13:29" , 
"distance_traveled" : 65.7714
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "22:15:39" , 
"departure_time" : "22:15:42" , 
"distance_traveled" : 67.1081
}, 
{ 
"stop_id" : 128,
"arrival_time" : "22:17:03" , 
"departure_time" : "22:17:38" , 
"distance_traveled" : 68.3926
}, 
{ 
"stop_id" : 3,
"arrival_time" : "22:20:35" , 
"departure_time" : "22:20:36" , 
"distance_traveled" : 70.3095
}, 
{ 
"stop_id" : 151,
"arrival_time" : "22:23:01" , 
"departure_time" : "22:23:54" , 
"distance_traveled" : 71.6453
}, 
{ 
"stop_id" : 64,
"arrival_time" : "22:27:53" , 
"departure_time" : "22:28:02" , 
"distance_traveled" : 72.8689
}, 
{ 
"stop_id" : 131,
"arrival_time" : "22:30:09" , 
"departure_time" : "22:31:39" , 
"distance_traveled" : 74.0964
}, 
{ 
"stop_id" : 52,
"arrival_time" : "22:34:30" , 
"departure_time" : "22:34:57" , 
"distance_traveled" : 75.5417
}, 
{ 
"stop_id" : 58,
"arrival_time" : "22:37:27" , 
"departure_time" : "22:38:29" , 
"distance_traveled" : 77.2483
}, 
{ 
"stop_id" : 116,
"arrival_time" : "22:43:02" , 
"departure_time" : "22:43:48" , 
"distance_traveled" : 79.343
}, 
{ 
"stop_id" : 29,
"arrival_time" : "22:48:46" , 
"departure_time" : "22:49:53" , 
"distance_traveled" : 82.8674
}, 
{ 
"stop_id" : 115,
"arrival_time" : "22:52:07" , 
"departure_time" : "22:53:02" , 
"distance_traveled" : 84.5212
}, 
{ 
"stop_id" : 33,
"arrival_time" : "22:54:55" , 
"departure_time" : "22:55:06" , 
"distance_traveled" : 85.7778
}, 
{ 
"stop_id" : 75,
"arrival_time" : "22:57:11" , 
"departure_time" : "22:57:47" , 
"distance_traveled" : 86.879
}, 
{ 
"stop_id" : 66,
"arrival_time" : "22:59:36" , 
"departure_time" : "23:00:24" , 
"distance_traveled" : 87.4602
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "23:07:48" , 
"departure_time" : "23:09:00" , 
"distance_traveled" : 91.5805
}, 
{ 
"stop_id" : 63,
"arrival_time" : "23:20:12" , 
"departure_time" : "23:20:12" , 
"distance_traveled" : 95.1403
} ], 
"1777" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:19:00" , 
"departure_time" : "17:20:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:29:44" , 
"departure_time" : "17:31:03" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 144,
"arrival_time" : "18:01:19" , 
"departure_time" : "18:01:37" , 
"distance_traveled" : 30.6705
}, 
{ 
"stop_id" : 137,
"arrival_time" : "18:07:18" , 
"departure_time" : "18:08:19" , 
"distance_traveled" : 34.6371
}, 
{ 
"stop_id" : 149,
"arrival_time" : "18:13:01" , 
"departure_time" : "18:14:20" , 
"distance_traveled" : 37.2809
}, 
{ 
"stop_id" : 57,
"arrival_time" : "18:24:19" , 
"departure_time" : "18:25:37" , 
"distance_traveled" : 44.8377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "18:36:18" , 
"departure_time" : "18:36:31" , 
"distance_traveled" : 55.6292
}, 
{ 
"stop_id" : 26,
"arrival_time" : "18:47:13" , 
"departure_time" : "18:48:04" , 
"distance_traveled" : 65.7256
}, 
{ 
"stop_id" : 86,
"arrival_time" : "18:54:51" , 
"departure_time" : "18:55:42" , 
"distance_traveled" : 71.7511
}, 
{ 
"stop_id" : 113,
"arrival_time" : "19:06:51" , 
"departure_time" : "19:07:46" , 
"distance_traveled" : 81.4896
}, 
{ 
"stop_id" : 123,
"arrival_time" : "19:26:55" , 
"departure_time" : "19:26:55" , 
"distance_traveled" : 95.1165
} ], 
"1778" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:01:00" , 
"departure_time" : "16:02:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:11:24" , 
"departure_time" : "16:13:00" , 
"distance_traveled" : 3.5595
}, 
{ 
"stop_id" : 128,
"arrival_time" : "16:39:36" , 
"departure_time" : "16:40:10" , 
"distance_traveled" : 26.6369
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "16:41:34" , 
"departure_time" : "16:43:00" , 
"distance_traveled" : 27.9559
}, 
{ 
"stop_id" : 144,
"arrival_time" : "16:46:26" , 
"departure_time" : "16:47:42" , 
"distance_traveled" : 30.6705
}, 
{ 
"stop_id" : 137,
"arrival_time" : "16:54:16" , 
"departure_time" : "16:55:35" , 
"distance_traveled" : 34.6373
}, 
{ 
"stop_id" : 149,
"arrival_time" : "16:59:19" , 
"departure_time" : "17:00:04" , 
"distance_traveled" : 37.2811
}, 
{ 
"stop_id" : 57,
"arrival_time" : "17:09:45" , 
"departure_time" : "17:11:21" , 
"distance_traveled" : 44.8375
}, 
{ 
"stop_id" : 135,
"arrival_time" : "17:25:36" , 
"departure_time" : "17:26:30" , 
"distance_traveled" : 55.6297
}, 
{ 
"stop_id" : 26,
"arrival_time" : "17:35:54" , 
"departure_time" : "17:37:12" , 
"distance_traveled" : 65.7275
}, 
{ 
"stop_id" : 86,
"arrival_time" : "17:44:18" , 
"departure_time" : "17:44:36" , 
"distance_traveled" : 71.7525
}, 
{ 
"stop_id" : 113,
"arrival_time" : "17:56:18" , 
"departure_time" : "17:57:31" , 
"distance_traveled" : 81.4915
}, 
{ 
"stop_id" : 123,
"arrival_time" : "18:19:13" , 
"departure_time" : "18:19:13" , 
"distance_traveled" : 95.1188
} ], 
"1779" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:19:00" , 
"departure_time" : "17:20:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:29:42" , 
"departure_time" : "17:30:01" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 144,
"arrival_time" : "18:00:19" , 
"departure_time" : "18:01:31" , 
"distance_traveled" : 30.6705
}, 
{ 
"stop_id" : 137,
"arrival_time" : "18:08:12" , 
"departure_time" : "18:08:59" , 
"distance_traveled" : 34.6371
}, 
{ 
"stop_id" : 149,
"arrival_time" : "18:12:47" , 
"departure_time" : "18:13:07" , 
"distance_traveled" : 37.2809
}, 
{ 
"stop_id" : 57,
"arrival_time" : "18:23:20" , 
"departure_time" : "18:24:29" , 
"distance_traveled" : 44.8377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "18:36:09" , 
"departure_time" : "18:36:55" , 
"distance_traveled" : 55.6292
}, 
{ 
"stop_id" : 26,
"arrival_time" : "18:47:46" , 
"departure_time" : "18:49:21" , 
"distance_traveled" : 65.7256
}, 
{ 
"stop_id" : 86,
"arrival_time" : "18:55:35" , 
"departure_time" : "18:55:57" , 
"distance_traveled" : 71.7511
}, 
{ 
"stop_id" : 113,
"arrival_time" : "19:06:22" , 
"departure_time" : "19:07:32" , 
"distance_traveled" : 81.4896
}, 
{ 
"stop_id" : 123,
"arrival_time" : "19:27:10" , 
"departure_time" : "19:27:10" , 
"distance_traveled" : 95.1165
} ], 
"1780" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:13:00" , 
"departure_time" : "18:15:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:24:09" , 
"departure_time" : "18:25:25" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:44:16" , 
"departure_time" : "18:45:32" , 
"distance_traveled" : 20.9674
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "18:53:16" , 
"departure_time" : "18:54:54" , 
"distance_traveled" : 27.9559
}, 
{ 
"stop_id" : 144,
"arrival_time" : "18:58:38" , 
"departure_time" : "18:59:28" , 
"distance_traveled" : 30.6705
}, 
{ 
"stop_id" : 137,
"arrival_time" : "19:04:50" , 
"departure_time" : "19:05:56" , 
"distance_traveled" : 34.6371
}, 
{ 
"stop_id" : 149,
"arrival_time" : "19:10:06" , 
"departure_time" : "19:10:28" , 
"distance_traveled" : 37.2809
}, 
{ 
"stop_id" : 57,
"arrival_time" : "19:20:22" , 
"departure_time" : "19:21:48" , 
"distance_traveled" : 44.8377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "19:36:26" , 
"departure_time" : "19:37:36" , 
"distance_traveled" : 55.6292
}, 
{ 
"stop_id" : 26,
"arrival_time" : "19:47:10" , 
"departure_time" : "19:48:45" , 
"distance_traveled" : 65.7256
}, 
{ 
"stop_id" : 86,
"arrival_time" : "19:55:35" , 
"departure_time" : "19:55:56" , 
"distance_traveled" : 71.7511
}, 
{ 
"stop_id" : 113,
"arrival_time" : "20:05:21" , 
"departure_time" : "20:06:19" , 
"distance_traveled" : 81.4896
}, 
{ 
"stop_id" : 123,
"arrival_time" : "20:27:58" , 
"departure_time" : "20:27:58" , 
"distance_traveled" : 95.1165
} ], 
"1781" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "13:21:00" , 
"departure_time" : "13:22:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "13:31:16" , 
"departure_time" : "13:31:23" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 131,
"arrival_time" : "13:52:07" , 
"departure_time" : "13:52:47" , 
"distance_traveled" : 20.9674
}, 
{ 
"stop_id" : 3,
"arrival_time" : "13:58:40" , 
"departure_time" : "13:59:20" , 
"distance_traveled" : 24.76
}, 
{ 
"stop_id" : 128,
"arrival_time" : "14:03:40" , 
"departure_time" : "14:03:46" , 
"distance_traveled" : 26.6428
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "14:06:06" , 
"departure_time" : "14:06:21" , 
"distance_traveled" : 27.9614
}, 
{ 
"stop_id" : 78,
"arrival_time" : "14:09:15" , 
"departure_time" : "14:10:29" , 
"distance_traveled" : 29.2981
}, 
{ 
"stop_id" : 144,
"arrival_time" : "14:13:14" , 
"departure_time" : "14:14:37" , 
"distance_traveled" : 30.6756
}, 
{ 
"stop_id" : 137,
"arrival_time" : "14:20:23" , 
"departure_time" : "14:21:19" , 
"distance_traveled" : 34.6426
}, 
{ 
"stop_id" : 149,
"arrival_time" : "14:24:56" , 
"departure_time" : "14:25:34" , 
"distance_traveled" : 37.2864
}, 
{ 
"stop_id" : 57,
"arrival_time" : "14:35:38" , 
"departure_time" : "14:37:15" , 
"distance_traveled" : 44.8432
}, 
{ 
"stop_id" : 135,
"arrival_time" : "14:51:37" , 
"departure_time" : "14:52:09" , 
"distance_traveled" : 55.6347
}, 
{ 
"stop_id" : 26,
"arrival_time" : "15:03:32" , 
"departure_time" : "15:05:00" , 
"distance_traveled" : 65.7311
}, 
{ 
"stop_id" : 86,
"arrival_time" : "15:11:28" , 
"departure_time" : "15:12:47" , 
"distance_traveled" : 71.7566
}, 
{ 
"stop_id" : 113,
"arrival_time" : "15:28:19" , 
"departure_time" : "15:29:03" , 
"distance_traveled" : 81.4951
}, 
{ 
"stop_id" : 123,
"arrival_time" : "15:48:44" , 
"departure_time" : "15:48:44" , 
"distance_traveled" : 95.122
} ], 
"1782" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "09:20:00" , 
"departure_time" : "09:22:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:31:33" , 
"departure_time" : "09:31:43" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "09:38:10" , 
"departure_time" : "09:39:47" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 121,
"arrival_time" : "09:46:37" , 
"departure_time" : "09:47:20" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "09:50:43" , 
"departure_time" : "09:52:15" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "09:55:32" , 
"departure_time" : "09:56:54" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "09:58:22" , 
"departure_time" : "09:58:34" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "10:01:12" , 
"departure_time" : "10:01:23" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "10:10:11" , 
"departure_time" : "10:11:44" , 
"distance_traveled" : 26.8345
}, 
{ 
"stop_id" : 144,
"arrival_time" : "10:16:33" , 
"departure_time" : "10:16:49" , 
"distance_traveled" : 29.5491
}, 
{ 
"stop_id" : 137,
"arrival_time" : "10:24:16" , 
"departure_time" : "10:24:30" , 
"distance_traveled" : 33.5157
}, 
{ 
"stop_id" : 149,
"arrival_time" : "10:29:14" , 
"departure_time" : "10:30:36" , 
"distance_traveled" : 36.1595
}, 
{ 
"stop_id" : 57,
"arrival_time" : "10:41:22" , 
"departure_time" : "10:42:21" , 
"distance_traveled" : 43.7163
}, 
{ 
"stop_id" : 135,
"arrival_time" : "10:55:59" , 
"departure_time" : "10:56:12" , 
"distance_traveled" : 54.5078
}, 
{ 
"stop_id" : 26,
"arrival_time" : "11:07:13" , 
"departure_time" : "11:08:09" , 
"distance_traveled" : 64.6042
}, 
{ 
"stop_id" : 86,
"arrival_time" : "11:15:56" , 
"departure_time" : "11:16:57" , 
"distance_traveled" : 70.6297
}, 
{ 
"stop_id" : 113,
"arrival_time" : "11:27:01" , 
"departure_time" : "11:27:12" , 
"distance_traveled" : 80.3682
}, 
{ 
"stop_id" : 123,
"arrival_time" : "11:48:11" , 
"departure_time" : "11:48:11" , 
"distance_traveled" : 93.9951
} ], 
"1783" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "24:39:00" , 
"departure_time" : "24:39:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "24:50:41" , 
"departure_time" : "24:51:55" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "24:59:14" , 
"departure_time" : "24:59:49" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "25:02:35" , 
"departure_time" : "25:03:12" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "25:05:37" , 
"departure_time" : "25:05:55" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "25:08:18" , 
"departure_time" : "25:08:19" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "25:12:01" , 
"departure_time" : "25:13:28" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "25:17:27" , 
"departure_time" : "25:18:06" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "25:19:39" , 
"departure_time" : "25:20:32" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "25:22:53" , 
"departure_time" : "25:23:01" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "25:25:08" , 
"departure_time" : "25:25:32" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "25:29:24" , 
"departure_time" : "25:30:56" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "25:33:32" , 
"departure_time" : "25:34:21" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "25:37:49" , 
"departure_time" : "25:38:29" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "25:40:40" , 
"departure_time" : "25:41:40" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "25:44:00" , 
"departure_time" : "25:45:17" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "25:47:17" , 
"departure_time" : "25:47:59" , 
"distance_traveled" : 29.571
}, 
{ 
"stop_id" : 137,
"arrival_time" : "25:53:42" , 
"departure_time" : "25:54:47" , 
"distance_traveled" : 33.5381
}, 
{ 
"stop_id" : 149,
"arrival_time" : "25:59:05" , 
"departure_time" : "25:59:54" , 
"distance_traveled" : 36.1818
}, 
{ 
"stop_id" : 57,
"arrival_time" : "26:09:49" , 
"departure_time" : "26:10:33" , 
"distance_traveled" : 43.7386
}, 
{ 
"stop_id" : 135,
"arrival_time" : "26:24:44" , 
"departure_time" : "26:26:07" , 
"distance_traveled" : 54.5301
}, 
{ 
"stop_id" : 26,
"arrival_time" : "26:36:23" , 
"departure_time" : "26:37:07" , 
"distance_traveled" : 64.6265
}, 
{ 
"stop_id" : 86,
"arrival_time" : "26:43:44" , 
"departure_time" : "26:44:18" , 
"distance_traveled" : 70.6521
}, 
{ 
"stop_id" : 113,
"arrival_time" : "26:54:34" , 
"departure_time" : "26:54:53" , 
"distance_traveled" : 80.3905
}, 
{ 
"stop_id" : 123,
"arrival_time" : "27:14:19" , 
"departure_time" : "27:14:19" , 
"distance_traveled" : 94.0174
} ], 
"1784" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "11:20:00" , 
"departure_time" : "11:20:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "11:30:24" , 
"departure_time" : "11:30:28" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "11:38:04" , 
"departure_time" : "11:38:54" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 121,
"arrival_time" : "11:45:50" , 
"departure_time" : "11:46:13" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "11:50:23" , 
"departure_time" : "11:50:49" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "11:54:26" , 
"departure_time" : "11:55:55" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "11:58:29" , 
"departure_time" : "11:58:58" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "12:01:29" , 
"departure_time" : "12:02:56" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "12:11:27" , 
"departure_time" : "12:12:10" , 
"distance_traveled" : 26.8345
}, 
{ 
"stop_id" : 144,
"arrival_time" : "12:15:43" , 
"departure_time" : "12:16:55" , 
"distance_traveled" : 29.5491
}, 
{ 
"stop_id" : 137,
"arrival_time" : "12:25:12" , 
"departure_time" : "12:25:15" , 
"distance_traveled" : 33.5157
}, 
{ 
"stop_id" : 149,
"arrival_time" : "12:29:03" , 
"departure_time" : "12:30:31" , 
"distance_traveled" : 36.1595
}, 
{ 
"stop_id" : 57,
"arrival_time" : "12:41:28" , 
"departure_time" : "12:43:03" , 
"distance_traveled" : 43.7163
}, 
{ 
"stop_id" : 135,
"arrival_time" : "12:56:35" , 
"departure_time" : "12:56:50" , 
"distance_traveled" : 54.5078
}, 
{ 
"stop_id" : 26,
"arrival_time" : "13:06:15" , 
"departure_time" : "13:06:41" , 
"distance_traveled" : 64.6042
}, 
{ 
"stop_id" : 86,
"arrival_time" : "13:14:26" , 
"departure_time" : "13:14:34" , 
"distance_traveled" : 70.6297
}, 
{ 
"stop_id" : 113,
"arrival_time" : "13:27:08" , 
"departure_time" : "13:27:57" , 
"distance_traveled" : 80.3682
}, 
{ 
"stop_id" : 123,
"arrival_time" : "13:49:49" , 
"departure_time" : "13:49:49" , 
"distance_traveled" : 93.9951
} ], 
"1785" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:01:00" , 
"departure_time" : "16:03:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:12:30" , 
"departure_time" : "16:13:04" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 128,
"arrival_time" : "16:38:34" , 
"departure_time" : "16:40:04" , 
"distance_traveled" : 26.6371
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "16:42:30" , 
"departure_time" : "16:43:17" , 
"distance_traveled" : 27.9559
}, 
{ 
"stop_id" : 144,
"arrival_time" : "16:45:47" , 
"departure_time" : "16:46:55" , 
"distance_traveled" : 30.6705
}, 
{ 
"stop_id" : 137,
"arrival_time" : "16:54:08" , 
"departure_time" : "16:54:50" , 
"distance_traveled" : 34.6371
}, 
{ 
"stop_id" : 149,
"arrival_time" : "16:58:42" , 
"departure_time" : "16:59:31" , 
"distance_traveled" : 37.2809
}, 
{ 
"stop_id" : 57,
"arrival_time" : "17:09:49" , 
"departure_time" : "17:10:59" , 
"distance_traveled" : 44.8377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "17:25:10" , 
"departure_time" : "17:25:15" , 
"distance_traveled" : 55.6292
}, 
{ 
"stop_id" : 26,
"arrival_time" : "17:35:05" , 
"departure_time" : "17:36:29" , 
"distance_traveled" : 65.7256
}, 
{ 
"stop_id" : 86,
"arrival_time" : "17:44:24" , 
"departure_time" : "17:45:05" , 
"distance_traveled" : 71.7511
}, 
{ 
"stop_id" : 113,
"arrival_time" : "17:56:41" , 
"departure_time" : "17:57:55" , 
"distance_traveled" : 81.4896
}, 
{ 
"stop_id" : 123,
"arrival_time" : "18:19:14" , 
"departure_time" : "18:19:14" , 
"distance_traveled" : 95.1165
} ], 
"1786" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "21:28:00" , 
"departure_time" : "21:30:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "21:39:10" , 
"departure_time" : "21:39:19" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "21:46:09" , 
"departure_time" : "21:46:30" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 121,
"arrival_time" : "21:53:21" , 
"departure_time" : "21:54:22" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "21:59:01" , 
"departure_time" : "22:00:09" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "22:02:08" , 
"departure_time" : "22:03:32" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "22:06:24" , 
"departure_time" : "22:06:27" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "22:08:03" , 
"departure_time" : "22:08:31" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "22:11:28" , 
"departure_time" : "22:13:07" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "22:15:39" , 
"departure_time" : "22:15:53" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "22:18:14" , 
"departure_time" : "22:19:53" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "22:23:39" , 
"departure_time" : "22:24:04" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "22:25:25" , 
"departure_time" : "22:26:50" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "22:30:25" , 
"departure_time" : "22:30:54" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "22:32:29" , 
"departure_time" : "22:33:54" , 
"distance_traveled" : 29.571
}, 
{ 
"stop_id" : 137,
"arrival_time" : "22:40:25" , 
"departure_time" : "22:41:00" , 
"distance_traveled" : 33.5381
}, 
{ 
"stop_id" : 149,
"arrival_time" : "22:44:35" , 
"departure_time" : "22:45:31" , 
"distance_traveled" : 36.1818
}, 
{ 
"stop_id" : 57,
"arrival_time" : "22:55:56" , 
"departure_time" : "22:56:13" , 
"distance_traveled" : 43.7386
}, 
{ 
"stop_id" : 135,
"arrival_time" : "23:10:17" , 
"departure_time" : "23:10:24" , 
"distance_traveled" : 54.5301
}, 
{ 
"stop_id" : 26,
"arrival_time" : "23:22:07" , 
"departure_time" : "23:22:55" , 
"distance_traveled" : 64.6265
}, 
{ 
"stop_id" : 86,
"arrival_time" : "23:29:48" , 
"departure_time" : "23:29:54" , 
"distance_traveled" : 70.6521
}, 
{ 
"stop_id" : 113,
"arrival_time" : "23:41:06" , 
"departure_time" : "23:41:10" , 
"distance_traveled" : 80.3905
}, 
{ 
"stop_id" : 123,
"arrival_time" : "24:02:04" , 
"departure_time" : "24:02:04" , 
"distance_traveled" : 94.0174
} ], 
"1787" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:13:00" , 
"departure_time" : "18:13:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:23:13" , 
"departure_time" : "18:24:00" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:43:47" , 
"departure_time" : "18:45:11" , 
"distance_traveled" : 20.9674
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "18:53:24" , 
"departure_time" : "18:54:26" , 
"distance_traveled" : 27.9559
}, 
{ 
"stop_id" : 144,
"arrival_time" : "18:58:02" , 
"departure_time" : "18:58:44" , 
"distance_traveled" : 30.6705
}, 
{ 
"stop_id" : 137,
"arrival_time" : "19:04:42" , 
"departure_time" : "19:05:55" , 
"distance_traveled" : 34.6371
}, 
{ 
"stop_id" : 149,
"arrival_time" : "19:10:13" , 
"departure_time" : "19:11:45" , 
"distance_traveled" : 37.2809
}, 
{ 
"stop_id" : 57,
"arrival_time" : "19:21:32" , 
"departure_time" : "19:23:02" , 
"distance_traveled" : 44.8377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "19:36:30" , 
"departure_time" : "19:37:46" , 
"distance_traveled" : 55.6292
}, 
{ 
"stop_id" : 26,
"arrival_time" : "19:47:16" , 
"departure_time" : "19:48:18" , 
"distance_traveled" : 65.7256
}, 
{ 
"stop_id" : 86,
"arrival_time" : "19:55:02" , 
"departure_time" : "19:55:05" , 
"distance_traveled" : 71.7511
}, 
{ 
"stop_id" : 113,
"arrival_time" : "20:05:03" , 
"departure_time" : "20:06:21" , 
"distance_traveled" : 81.4896
}, 
{ 
"stop_id" : 123,
"arrival_time" : "20:28:18" , 
"departure_time" : "20:28:18" , 
"distance_traveled" : 95.1165
} ], 
"1788" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "24:39:00" , 
"departure_time" : "24:41:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "24:51:26" , 
"departure_time" : "24:51:32" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "24:58:06" , 
"departure_time" : "24:58:33" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "25:02:27" , 
"departure_time" : "25:04:05" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "25:06:38" , 
"departure_time" : "25:07:52" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "25:09:14" , 
"departure_time" : "25:10:21" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "25:13:07" , 
"departure_time" : "25:13:32" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "25:16:25" , 
"departure_time" : "25:16:43" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "25:19:18" , 
"departure_time" : "25:19:21" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "25:22:03" , 
"departure_time" : "25:23:17" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "25:26:14" , 
"departure_time" : "25:27:05" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "25:29:51" , 
"departure_time" : "25:30:14" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "25:32:23" , 
"departure_time" : "25:33:33" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "25:38:10" , 
"departure_time" : "25:38:16" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "25:40:06" , 
"departure_time" : "25:41:10" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "25:44:04" , 
"departure_time" : "25:44:55" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "25:46:51" , 
"departure_time" : "25:47:42" , 
"distance_traveled" : 29.571
}, 
{ 
"stop_id" : 137,
"arrival_time" : "25:53:51" , 
"departure_time" : "25:54:38" , 
"distance_traveled" : 33.5381
}, 
{ 
"stop_id" : 149,
"arrival_time" : "25:58:47" , 
"departure_time" : "25:59:14" , 
"distance_traveled" : 36.1818
}, 
{ 
"stop_id" : 57,
"arrival_time" : "26:09:27" , 
"departure_time" : "26:10:29" , 
"distance_traveled" : 43.7386
}, 
{ 
"stop_id" : 135,
"arrival_time" : "26:25:02" , 
"departure_time" : "26:25:06" , 
"distance_traveled" : 54.5301
}, 
{ 
"stop_id" : 26,
"arrival_time" : "26:35:04" , 
"departure_time" : "26:36:27" , 
"distance_traveled" : 64.6265
}, 
{ 
"stop_id" : 86,
"arrival_time" : "26:44:23" , 
"departure_time" : "26:44:51" , 
"distance_traveled" : 70.6521
}, 
{ 
"stop_id" : 113,
"arrival_time" : "26:54:28" , 
"departure_time" : "26:55:54" , 
"distance_traveled" : 80.3905
}, 
{ 
"stop_id" : 123,
"arrival_time" : "27:15:26" , 
"departure_time" : "27:15:26" , 
"distance_traveled" : 94.0174
} ], 
"1789" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "13:21:00" , 
"departure_time" : "13:23:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "13:32:01" , 
"departure_time" : "13:32:40" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 131,
"arrival_time" : "13:52:39" , 
"departure_time" : "13:53:14" , 
"distance_traveled" : 20.9674
}, 
{ 
"stop_id" : 3,
"arrival_time" : "13:58:35" , 
"departure_time" : "13:58:50" , 
"distance_traveled" : 24.76
}, 
{ 
"stop_id" : 128,
"arrival_time" : "14:03:15" , 
"departure_time" : "14:04:50" , 
"distance_traveled" : 26.6428
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "14:07:35" , 
"departure_time" : "14:08:47" , 
"distance_traveled" : 27.9614
}, 
{ 
"stop_id" : 78,
"arrival_time" : "14:10:12" , 
"departure_time" : "14:10:39" , 
"distance_traveled" : 29.2981
}, 
{ 
"stop_id" : 144,
"arrival_time" : "14:12:27" , 
"departure_time" : "14:13:53" , 
"distance_traveled" : 30.6756
}, 
{ 
"stop_id" : 137,
"arrival_time" : "14:20:26" , 
"departure_time" : "14:21:59" , 
"distance_traveled" : 34.6426
}, 
{ 
"stop_id" : 149,
"arrival_time" : "14:25:33" , 
"departure_time" : "14:25:38" , 
"distance_traveled" : 37.2864
}, 
{ 
"stop_id" : 57,
"arrival_time" : "14:35:05" , 
"departure_time" : "14:35:32" , 
"distance_traveled" : 44.8432
}, 
{ 
"stop_id" : 135,
"arrival_time" : "14:50:27" , 
"departure_time" : "14:51:57" , 
"distance_traveled" : 55.6347
}, 
{ 
"stop_id" : 26,
"arrival_time" : "15:04:30" , 
"departure_time" : "15:05:19" , 
"distance_traveled" : 65.7311
}, 
{ 
"stop_id" : 86,
"arrival_time" : "15:10:49" , 
"departure_time" : "15:11:23" , 
"distance_traveled" : 71.7566
}, 
{ 
"stop_id" : 113,
"arrival_time" : "15:27:34" , 
"departure_time" : "15:28:48" , 
"distance_traveled" : 81.4951
}, 
{ 
"stop_id" : 123,
"arrival_time" : "15:49:14" , 
"departure_time" : "15:49:14" , 
"distance_traveled" : 95.122
} ], 
"1790" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "24:39:00" , 
"departure_time" : "24:41:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "24:51:07" , 
"departure_time" : "24:51:23" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "24:58:16" , 
"departure_time" : "24:58:34" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "25:02:18" , 
"departure_time" : "25:02:46" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "25:05:28" , 
"departure_time" : "25:07:06" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "25:09:38" , 
"departure_time" : "25:10:06" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "25:12:28" , 
"departure_time" : "25:13:19" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "25:16:51" , 
"departure_time" : "25:17:43" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "25:19:52" , 
"departure_time" : "25:20:39" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "25:22:47" , 
"departure_time" : "25:23:00" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "25:25:13" , 
"departure_time" : "25:26:51" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "25:30:38" , 
"departure_time" : "25:32:04" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "25:33:26" , 
"departure_time" : "25:34:25" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "25:37:59" , 
"departure_time" : "25:38:58" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "25:40:59" , 
"departure_time" : "25:41:35" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "25:43:36" , 
"departure_time" : "25:44:49" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "25:47:13" , 
"departure_time" : "25:48:53" , 
"distance_traveled" : 29.571
}, 
{ 
"stop_id" : 137,
"arrival_time" : "25:54:40" , 
"departure_time" : "25:55:18" , 
"distance_traveled" : 33.5381
}, 
{ 
"stop_id" : 149,
"arrival_time" : "25:58:38" , 
"departure_time" : "25:59:37" , 
"distance_traveled" : 36.1818
}, 
{ 
"stop_id" : 57,
"arrival_time" : "26:09:59" , 
"departure_time" : "26:10:10" , 
"distance_traveled" : 43.7386
}, 
{ 
"stop_id" : 135,
"arrival_time" : "26:24:11" , 
"departure_time" : "26:24:49" , 
"distance_traveled" : 54.5301
}, 
{ 
"stop_id" : 26,
"arrival_time" : "26:35:38" , 
"departure_time" : "26:36:11" , 
"distance_traveled" : 64.6265
}, 
{ 
"stop_id" : 86,
"arrival_time" : "26:43:33" , 
"departure_time" : "26:44:08" , 
"distance_traveled" : 70.6521
}, 
{ 
"stop_id" : 113,
"arrival_time" : "26:54:35" , 
"departure_time" : "26:55:30" , 
"distance_traveled" : 80.3905
}, 
{ 
"stop_id" : 123,
"arrival_time" : "27:14:55" , 
"departure_time" : "27:14:55" , 
"distance_traveled" : 94.0174
} ], 
"1791" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "09:20:00" , 
"departure_time" : "09:21:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:30:26" , 
"departure_time" : "09:31:47" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "09:39:21" , 
"departure_time" : "09:40:12" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 121,
"arrival_time" : "09:45:51" , 
"departure_time" : "09:47:23" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "09:51:32" , 
"departure_time" : "09:52:55" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "09:55:23" , 
"departure_time" : "09:56:50" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "09:58:27" , 
"departure_time" : "09:59:52" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "10:02:25" , 
"departure_time" : "10:02:56" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "10:10:31" , 
"departure_time" : "10:11:52" , 
"distance_traveled" : 26.8345
}, 
{ 
"stop_id" : 144,
"arrival_time" : "10:16:21" , 
"departure_time" : "10:17:42" , 
"distance_traveled" : 29.5491
}, 
{ 
"stop_id" : 137,
"arrival_time" : "10:25:21" , 
"departure_time" : "10:26:13" , 
"distance_traveled" : 33.5157
}, 
{ 
"stop_id" : 149,
"arrival_time" : "10:29:52" , 
"departure_time" : "10:30:20" , 
"distance_traveled" : 36.1595
}, 
{ 
"stop_id" : 57,
"arrival_time" : "10:40:28" , 
"departure_time" : "10:41:56" , 
"distance_traveled" : 43.7163
}, 
{ 
"stop_id" : 135,
"arrival_time" : "10:56:28" , 
"departure_time" : "10:57:19" , 
"distance_traveled" : 54.5078
}, 
{ 
"stop_id" : 26,
"arrival_time" : "11:07:51" , 
"departure_time" : "11:08:10" , 
"distance_traveled" : 64.6042
}, 
{ 
"stop_id" : 86,
"arrival_time" : "11:15:19" , 
"departure_time" : "11:16:49" , 
"distance_traveled" : 70.6297
}, 
{ 
"stop_id" : 113,
"arrival_time" : "11:27:30" , 
"departure_time" : "11:28:42" , 
"distance_traveled" : 80.3682
}, 
{ 
"stop_id" : 123,
"arrival_time" : "11:49:12" , 
"departure_time" : "11:49:12" , 
"distance_traveled" : 93.9951
} ], 
"1792" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "14:41:00" , 
"departure_time" : "14:43:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "14:53:16" , 
"departure_time" : "14:54:46" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "15:21:30" , 
"departure_time" : "15:21:53" , 
"distance_traveled" : 27.9559
}, 
{ 
"stop_id" : 144,
"arrival_time" : "15:25:23" , 
"departure_time" : "15:25:43" , 
"distance_traveled" : 30.6705
}, 
{ 
"stop_id" : 137,
"arrival_time" : "15:32:20" , 
"departure_time" : "15:32:45" , 
"distance_traveled" : 34.6371
}, 
{ 
"stop_id" : 149,
"arrival_time" : "15:38:25" , 
"departure_time" : "15:40:01" , 
"distance_traveled" : 37.2809
}, 
{ 
"stop_id" : 57,
"arrival_time" : "15:50:36" , 
"departure_time" : "15:50:54" , 
"distance_traveled" : 44.8377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "16:04:18" , 
"departure_time" : "16:05:05" , 
"distance_traveled" : 55.6292
}, 
{ 
"stop_id" : 26,
"arrival_time" : "16:15:47" , 
"departure_time" : "16:15:58" , 
"distance_traveled" : 65.7256
}, 
{ 
"stop_id" : 86,
"arrival_time" : "16:23:11" , 
"departure_time" : "16:23:11" , 
"distance_traveled" : 71.7511
} ], 
"1793" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "11:20:00" , 
"departure_time" : "11:21:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "11:31:35" , 
"departure_time" : "11:31:49" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "11:38:14" , 
"departure_time" : "11:39:18" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 121,
"arrival_time" : "11:46:04" , 
"departure_time" : "11:47:03" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "11:50:59" , 
"departure_time" : "11:51:59" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "11:55:00" , 
"departure_time" : "11:55:24" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "11:57:24" , 
"departure_time" : "11:58:04" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "12:01:40" , 
"departure_time" : "12:03:01" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "12:11:21" , 
"departure_time" : "12:12:55" , 
"distance_traveled" : 26.8345
}, 
{ 
"stop_id" : 144,
"arrival_time" : "12:16:34" , 
"departure_time" : "12:16:44" , 
"distance_traveled" : 29.5491
}, 
{ 
"stop_id" : 137,
"arrival_time" : "12:24:10" , 
"departure_time" : "12:24:50" , 
"distance_traveled" : 33.5157
}, 
{ 
"stop_id" : 149,
"arrival_time" : "12:29:40" , 
"departure_time" : "12:30:20" , 
"distance_traveled" : 36.1595
}, 
{ 
"stop_id" : 57,
"arrival_time" : "12:40:40" , 
"departure_time" : "12:41:29" , 
"distance_traveled" : 43.7163
}, 
{ 
"stop_id" : 135,
"arrival_time" : "12:55:49" , 
"departure_time" : "12:56:20" , 
"distance_traveled" : 54.5078
}, 
{ 
"stop_id" : 26,
"arrival_time" : "13:06:31" , 
"departure_time" : "13:07:08" , 
"distance_traveled" : 64.6042
}, 
{ 
"stop_id" : 86,
"arrival_time" : "13:14:37" , 
"departure_time" : "13:15:41" , 
"distance_traveled" : 70.6297
}, 
{ 
"stop_id" : 113,
"arrival_time" : "13:28:04" , 
"departure_time" : "13:29:37" , 
"distance_traveled" : 80.3682
}, 
{ 
"stop_id" : 123,
"arrival_time" : "13:50:33" , 
"departure_time" : "13:50:33" , 
"distance_traveled" : 93.9951
} ], 
"1794" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "12:42:00" , 
"departure_time" : "12:44:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "12:54:07" , 
"departure_time" : "12:55:02" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 131,
"arrival_time" : "13:13:55" , 
"departure_time" : "13:15:29" , 
"distance_traveled" : 20.9674
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "13:23:34" , 
"departure_time" : "13:24:29" , 
"distance_traveled" : 27.9559
}, 
{ 
"stop_id" : 144,
"arrival_time" : "13:27:55" , 
"departure_time" : "13:28:10" , 
"distance_traveled" : 30.6705
}, 
{ 
"stop_id" : 137,
"arrival_time" : "13:34:15" , 
"departure_time" : "13:34:19" , 
"distance_traveled" : 34.6371
}, 
{ 
"stop_id" : 149,
"arrival_time" : "13:39:04" , 
"departure_time" : "13:39:47" , 
"distance_traveled" : 37.2809
}, 
{ 
"stop_id" : 57,
"arrival_time" : "13:50:43" , 
"departure_time" : "13:51:58" , 
"distance_traveled" : 44.8377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "14:06:15" , 
"departure_time" : "14:06:21" , 
"distance_traveled" : 55.6292
}, 
{ 
"stop_id" : 26,
"arrival_time" : "14:21:06" , 
"departure_time" : "14:22:15" , 
"distance_traveled" : 65.7256
}, 
{ 
"stop_id" : 86,
"arrival_time" : "14:30:09" , 
"departure_time" : "14:30:09" , 
"distance_traveled" : 71.7511
} ], 
"1795" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "21:28:00" , 
"departure_time" : "21:30:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "21:39:27" , 
"departure_time" : "21:40:06" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "21:46:39" , 
"departure_time" : "21:47:18" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 121,
"arrival_time" : "21:53:39" , 
"departure_time" : "21:54:23" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "21:58:44" , 
"departure_time" : "22:00:12" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "22:02:28" , 
"departure_time" : "22:03:10" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "22:05:42" , 
"departure_time" : "22:05:45" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "22:08:03" , 
"departure_time" : "22:08:45" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "22:11:42" , 
"departure_time" : "22:12:52" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "22:15:10" , 
"departure_time" : "22:16:16" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "22:19:06" , 
"departure_time" : "22:20:13" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "22:23:07" , 
"departure_time" : "22:24:46" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "22:26:39" , 
"departure_time" : "22:28:02" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "22:30:23" , 
"departure_time" : "22:31:09" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "22:32:46" , 
"departure_time" : "22:33:31" , 
"distance_traveled" : 29.571
}, 
{ 
"stop_id" : 137,
"arrival_time" : "22:39:45" , 
"departure_time" : "22:41:20" , 
"distance_traveled" : 33.5381
}, 
{ 
"stop_id" : 149,
"arrival_time" : "22:45:35" , 
"departure_time" : "22:46:44" , 
"distance_traveled" : 36.1818
}, 
{ 
"stop_id" : 57,
"arrival_time" : "22:56:09" , 
"departure_time" : "22:57:26" , 
"distance_traveled" : 43.7386
}, 
{ 
"stop_id" : 135,
"arrival_time" : "23:11:17" , 
"departure_time" : "23:11:58" , 
"distance_traveled" : 54.5301
}, 
{ 
"stop_id" : 26,
"arrival_time" : "23:22:41" , 
"departure_time" : "23:22:50" , 
"distance_traveled" : 64.6265
}, 
{ 
"stop_id" : 86,
"arrival_time" : "23:29:09" , 
"departure_time" : "23:30:12" , 
"distance_traveled" : 70.6521
}, 
{ 
"stop_id" : 113,
"arrival_time" : "23:42:03" , 
"departure_time" : "23:43:30" , 
"distance_traveled" : 80.3905
}, 
{ 
"stop_id" : 123,
"arrival_time" : "24:03:27" , 
"departure_time" : "24:03:27" , 
"distance_traveled" : 94.0174
} ], 
"1796" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:07:00" , 
"departure_time" : "16:08:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:18:10" , 
"departure_time" : "16:19:11" , 
"distance_traveled" : 3.5595
}, 
{ 
"stop_id" : 144,
"arrival_time" : "16:49:01" , 
"departure_time" : "16:50:34" , 
"distance_traveled" : 30.6705
}, 
{ 
"stop_id" : 137,
"arrival_time" : "16:57:33" , 
"departure_time" : "16:58:57" , 
"distance_traveled" : 34.6373
}, 
{ 
"stop_id" : 149,
"arrival_time" : "17:02:24" , 
"departure_time" : "17:03:17" , 
"distance_traveled" : 37.2811
}, 
{ 
"stop_id" : 57,
"arrival_time" : "17:12:53" , 
"departure_time" : "17:13:44" , 
"distance_traveled" : 44.8375
}, 
{ 
"stop_id" : 135,
"arrival_time" : "17:27:51" , 
"departure_time" : "17:28:05" , 
"distance_traveled" : 55.6297
}, 
{ 
"stop_id" : 26,
"arrival_time" : "17:38:14" , 
"departure_time" : "17:38:32" , 
"distance_traveled" : 65.7275
}, 
{ 
"stop_id" : 86,
"arrival_time" : "17:46:18" , 
"departure_time" : "17:47:01" , 
"distance_traveled" : 71.7525
}, 
{ 
"stop_id" : 113,
"arrival_time" : "17:58:43" , 
"departure_time" : "18:00:22" , 
"distance_traveled" : 81.4915
}, 
{ 
"stop_id" : 123,
"arrival_time" : "18:19:39" , 
"departure_time" : "18:19:39" , 
"distance_traveled" : 95.1188
} ], 
"1797" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "14:41:00" , 
"departure_time" : "14:44:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "14:53:30" , 
"departure_time" : "14:54:00" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "15:20:30" , 
"departure_time" : "15:21:37" , 
"distance_traveled" : 27.9559
}, 
{ 
"stop_id" : 144,
"arrival_time" : "15:26:07" , 
"departure_time" : "15:27:45" , 
"distance_traveled" : 30.6705
}, 
{ 
"stop_id" : 137,
"arrival_time" : "15:33:38" , 
"departure_time" : "15:34:50" , 
"distance_traveled" : 34.6371
}, 
{ 
"stop_id" : 149,
"arrival_time" : "15:39:12" , 
"departure_time" : "15:40:21" , 
"distance_traveled" : 37.2809
}, 
{ 
"stop_id" : 57,
"arrival_time" : "15:50:09" , 
"departure_time" : "15:51:39" , 
"distance_traveled" : 44.8377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "16:05:30" , 
"departure_time" : "16:06:25" , 
"distance_traveled" : 55.6292
}, 
{ 
"stop_id" : 26,
"arrival_time" : "16:15:55" , 
"departure_time" : "16:17:12" , 
"distance_traveled" : 65.7256
}, 
{ 
"stop_id" : 86,
"arrival_time" : "16:24:17" , 
"departure_time" : "16:24:17" , 
"distance_traveled" : 71.7511
} ], 
"1798" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:47:00" , 
"departure_time" : "16:49:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:59:27" , 
"departure_time" : "17:00:46" , 
"distance_traveled" : 3.5595
}, 
{ 
"stop_id" : 144,
"arrival_time" : "17:30:19" , 
"departure_time" : "17:31:37" , 
"distance_traveled" : 30.6705
}, 
{ 
"stop_id" : 137,
"arrival_time" : "17:38:18" , 
"departure_time" : "17:39:53" , 
"distance_traveled" : 34.6373
}, 
{ 
"stop_id" : 149,
"arrival_time" : "17:43:35" , 
"departure_time" : "17:44:48" , 
"distance_traveled" : 37.2811
}, 
{ 
"stop_id" : 57,
"arrival_time" : "17:54:13" , 
"departure_time" : "17:55:45" , 
"distance_traveled" : 44.8375
}, 
{ 
"stop_id" : 135,
"arrival_time" : "18:09:32" , 
"departure_time" : "18:10:44" , 
"distance_traveled" : 55.6297
}, 
{ 
"stop_id" : 26,
"arrival_time" : "18:21:12" , 
"departure_time" : "18:22:14" , 
"distance_traveled" : 65.7275
}, 
{ 
"stop_id" : 86,
"arrival_time" : "18:29:02" , 
"departure_time" : "18:29:33" , 
"distance_traveled" : 71.7525
}, 
{ 
"stop_id" : 113,
"arrival_time" : "18:39:31" , 
"departure_time" : "18:39:42" , 
"distance_traveled" : 81.4915
}, 
{ 
"stop_id" : 123,
"arrival_time" : "19:00:11" , 
"departure_time" : "19:00:11" , 
"distance_traveled" : 95.1188
} ], 
"1799" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:14:00" , 
"departure_time" : "18:15:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:26:15" , 
"departure_time" : "18:27:41" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 57,
"arrival_time" : "19:18:26" , 
"departure_time" : "19:18:47" , 
"distance_traveled" : 55.8458
}, 
{ 
"stop_id" : 135,
"arrival_time" : "19:32:21" , 
"departure_time" : "19:33:49" , 
"distance_traveled" : 66.6455
}, 
{ 
"stop_id" : 26,
"arrival_time" : "19:45:28" , 
"departure_time" : "19:46:28" , 
"distance_traveled" : 76.7419
}, 
{ 
"stop_id" : 86,
"arrival_time" : "19:53:00" , 
"departure_time" : "19:53:30" , 
"distance_traveled" : 82.7674
}, 
{ 
"stop_id" : 113,
"arrival_time" : "20:04:30" , 
"departure_time" : "20:05:03" , 
"distance_traveled" : 92.5059
}, 
{ 
"stop_id" : 123,
"arrival_time" : "20:24:33" , 
"departure_time" : "20:24:33" , 
"distance_traveled" : 106.1328
} ], 
"1800" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:15:00" , 
"departure_time" : "17:16:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:27:20" , 
"departure_time" : "17:27:50" , 
"distance_traveled" : 3.5595
}, 
{ 
"stop_id" : 144,
"arrival_time" : "17:57:30" , 
"departure_time" : "17:58:15" , 
"distance_traveled" : 30.6705
}, 
{ 
"stop_id" : 137,
"arrival_time" : "18:05:45" , 
"departure_time" : "18:07:09" , 
"distance_traveled" : 34.6373
}, 
{ 
"stop_id" : 149,
"arrival_time" : "18:11:24" , 
"departure_time" : "18:11:51" , 
"distance_traveled" : 37.2811
}, 
{ 
"stop_id" : 57,
"arrival_time" : "18:21:27" , 
"departure_time" : "18:22:39" , 
"distance_traveled" : 44.8375
}, 
{ 
"stop_id" : 135,
"arrival_time" : "18:37:12" , 
"departure_time" : "18:38:39" , 
"distance_traveled" : 55.6297
}, 
{ 
"stop_id" : 26,
"arrival_time" : "18:49:27" , 
"departure_time" : "18:50:14" , 
"distance_traveled" : 65.7275
}, 
{ 
"stop_id" : 86,
"arrival_time" : "18:56:47" , 
"departure_time" : "18:57:54" , 
"distance_traveled" : 71.7525
}, 
{ 
"stop_id" : 113,
"arrival_time" : "19:08:07" , 
"departure_time" : "19:09:32" , 
"distance_traveled" : 81.4915
}, 
{ 
"stop_id" : 123,
"arrival_time" : "19:29:25" , 
"departure_time" : "19:29:25" , 
"distance_traveled" : 95.1188
} ], 
"1801" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "12:42:00" , 
"departure_time" : "12:44:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "12:53:46" , 
"departure_time" : "12:53:57" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 131,
"arrival_time" : "13:13:11" , 
"departure_time" : "13:14:03" , 
"distance_traveled" : 20.9674
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "13:22:52" , 
"departure_time" : "13:22:58" , 
"distance_traveled" : 27.9559
}, 
{ 
"stop_id" : 144,
"arrival_time" : "13:27:06" , 
"departure_time" : "13:27:26" , 
"distance_traveled" : 30.6705
}, 
{ 
"stop_id" : 137,
"arrival_time" : "13:34:20" , 
"departure_time" : "13:34:55" , 
"distance_traveled" : 34.6371
}, 
{ 
"stop_id" : 149,
"arrival_time" : "13:39:35" , 
"departure_time" : "13:40:21" , 
"distance_traveled" : 37.2809
}, 
{ 
"stop_id" : 57,
"arrival_time" : "13:50:46" , 
"departure_time" : "13:51:10" , 
"distance_traveled" : 44.8377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "14:05:24" , 
"departure_time" : "14:05:50" , 
"distance_traveled" : 55.6292
}, 
{ 
"stop_id" : 26,
"arrival_time" : "14:21:26" , 
"departure_time" : "14:22:35" , 
"distance_traveled" : 65.7256
}, 
{ 
"stop_id" : 86,
"arrival_time" : "14:31:09" , 
"departure_time" : "14:31:09" , 
"distance_traveled" : 71.7511
} ], 
"1802" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "19:57:00" , 
"departure_time" : "19:59:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "20:08:52" , 
"departure_time" : "20:09:42" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 144,
"arrival_time" : "20:38:50" , 
"departure_time" : "20:38:58" , 
"distance_traveled" : 30.6705
}, 
{ 
"stop_id" : 137,
"arrival_time" : "20:45:08" , 
"departure_time" : "20:46:30" , 
"distance_traveled" : 34.6371
}, 
{ 
"stop_id" : 149,
"arrival_time" : "20:51:22" , 
"departure_time" : "20:51:53" , 
"distance_traveled" : 37.2809
}, 
{ 
"stop_id" : 57,
"arrival_time" : "21:01:31" , 
"departure_time" : "21:02:12" , 
"distance_traveled" : 44.8377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "21:15:41" , 
"departure_time" : "21:16:54" , 
"distance_traveled" : 55.6292
}, 
{ 
"stop_id" : 26,
"arrival_time" : "21:28:13" , 
"departure_time" : "21:28:23" , 
"distance_traveled" : 65.7256
}, 
{ 
"stop_id" : 86,
"arrival_time" : "21:34:10" , 
"departure_time" : "21:34:49" , 
"distance_traveled" : 71.7511
}, 
{ 
"stop_id" : 113,
"arrival_time" : "21:52:39" , 
"departure_time" : "21:53:34" , 
"distance_traveled" : 81.4896
}, 
{ 
"stop_id" : 123,
"arrival_time" : "22:12:55" , 
"departure_time" : "22:12:55" , 
"distance_traveled" : 95.1165
} ], 
"1803" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:07:00" , 
"departure_time" : "16:08:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:18:14" , 
"departure_time" : "16:18:26" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 144,
"arrival_time" : "16:48:12" , 
"departure_time" : "16:49:08" , 
"distance_traveled" : 30.6705
}, 
{ 
"stop_id" : 137,
"arrival_time" : "16:56:56" , 
"departure_time" : "16:57:01" , 
"distance_traveled" : 34.6371
}, 
{ 
"stop_id" : 149,
"arrival_time" : "17:01:05" , 
"departure_time" : "17:01:23" , 
"distance_traveled" : 37.2809
}, 
{ 
"stop_id" : 57,
"arrival_time" : "17:12:18" , 
"departure_time" : "17:13:56" , 
"distance_traveled" : 44.8377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "17:28:38" , 
"departure_time" : "17:29:24" , 
"distance_traveled" : 55.6292
}, 
{ 
"stop_id" : 26,
"arrival_time" : "17:38:46" , 
"departure_time" : "17:39:59" , 
"distance_traveled" : 65.7256
}, 
{ 
"stop_id" : 86,
"arrival_time" : "17:47:13" , 
"departure_time" : "17:47:41" , 
"distance_traveled" : 71.7511
}, 
{ 
"stop_id" : 113,
"arrival_time" : "17:58:28" , 
"departure_time" : "17:59:18" , 
"distance_traveled" : 81.4896
}, 
{ 
"stop_id" : 123,
"arrival_time" : "18:18:50" , 
"departure_time" : "18:18:50" , 
"distance_traveled" : 95.1165
} ], 
"1804" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "08:25:00" , 
"departure_time" : "08:26:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:36:10" , 
"departure_time" : "08:37:35" , 
"distance_traveled" : 3.5595
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "09:08:25" , 
"departure_time" : "09:09:09" , 
"distance_traveled" : 27.9559
}, 
{ 
"stop_id" : 144,
"arrival_time" : "09:11:44" , 
"departure_time" : "09:13:08" , 
"distance_traveled" : 30.6705
}, 
{ 
"stop_id" : 137,
"arrival_time" : "09:20:24" , 
"departure_time" : "09:20:32" , 
"distance_traveled" : 34.6373
}, 
{ 
"stop_id" : 149,
"arrival_time" : "09:24:08" , 
"departure_time" : "09:24:53" , 
"distance_traveled" : 37.2811
}, 
{ 
"stop_id" : 57,
"arrival_time" : "09:35:45" , 
"departure_time" : "09:36:09" , 
"distance_traveled" : 44.8375
}, 
{ 
"stop_id" : 135,
"arrival_time" : "09:50:24" , 
"departure_time" : "09:51:18" , 
"distance_traveled" : 55.6297
}, 
{ 
"stop_id" : 26,
"arrival_time" : "10:11:54" , 
"departure_time" : "10:12:04" , 
"distance_traveled" : 65.7275
}, 
{ 
"stop_id" : 86,
"arrival_time" : "10:19:10" , 
"departure_time" : "10:19:46" , 
"distance_traveled" : 71.7525
}, 
{ 
"stop_id" : 113,
"arrival_time" : "10:30:36" , 
"departure_time" : "10:31:04" , 
"distance_traveled" : 81.4915
}, 
{ 
"stop_id" : 123,
"arrival_time" : "10:51:28" , 
"departure_time" : "10:51:28" , 
"distance_traveled" : 95.1188
} ], 
"1805" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:47:00" , 
"departure_time" : "16:48:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:58:48" , 
"departure_time" : "16:58:49" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 144,
"arrival_time" : "17:29:01" , 
"departure_time" : "17:30:14" , 
"distance_traveled" : 30.6705
}, 
{ 
"stop_id" : 137,
"arrival_time" : "17:38:13" , 
"departure_time" : "17:38:18" , 
"distance_traveled" : 34.6371
}, 
{ 
"stop_id" : 149,
"arrival_time" : "17:42:05" , 
"departure_time" : "17:43:35" , 
"distance_traveled" : 37.2809
}, 
{ 
"stop_id" : 57,
"arrival_time" : "17:54:30" , 
"departure_time" : "17:54:57" , 
"distance_traveled" : 44.8377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "18:08:27" , 
"departure_time" : "18:09:56" , 
"distance_traveled" : 55.6292
}, 
{ 
"stop_id" : 26,
"arrival_time" : "18:21:29" , 
"departure_time" : "18:21:42" , 
"distance_traveled" : 65.7256
}, 
{ 
"stop_id" : 86,
"arrival_time" : "18:28:13" , 
"departure_time" : "18:28:33" , 
"distance_traveled" : 71.7511
}, 
{ 
"stop_id" : 113,
"arrival_time" : "18:39:20" , 
"departure_time" : "18:40:39" , 
"distance_traveled" : 81.4896
}, 
{ 
"stop_id" : 123,
"arrival_time" : "19:01:19" , 
"departure_time" : "19:01:19" , 
"distance_traveled" : 95.1165
} ], 
"1806" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:27:00" , 
"departure_time" : "18:29:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:39:36" , 
"departure_time" : "18:40:20" , 
"distance_traveled" : 3.5595
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "19:07:44" , 
"departure_time" : "19:09:12" , 
"distance_traveled" : 27.9559
}, 
{ 
"stop_id" : 144,
"arrival_time" : "19:12:28" , 
"departure_time" : "19:13:55" , 
"distance_traveled" : 30.6705
}, 
{ 
"stop_id" : 137,
"arrival_time" : "19:20:27" , 
"departure_time" : "19:20:32" , 
"distance_traveled" : 34.6373
}, 
{ 
"stop_id" : 149,
"arrival_time" : "19:24:05" , 
"departure_time" : "19:25:06" , 
"distance_traveled" : 37.2811
}, 
{ 
"stop_id" : 57,
"arrival_time" : "19:36:01" , 
"departure_time" : "19:36:30" , 
"distance_traveled" : 44.8375
}, 
{ 
"stop_id" : 135,
"arrival_time" : "19:50:29" , 
"departure_time" : "19:51:06" , 
"distance_traveled" : 55.6297
}, 
{ 
"stop_id" : 26,
"arrival_time" : "20:01:37" , 
"departure_time" : "20:03:04" , 
"distance_traveled" : 65.7275
}, 
{ 
"stop_id" : 86,
"arrival_time" : "20:10:27" , 
"departure_time" : "20:10:52" , 
"distance_traveled" : 71.7525
}, 
{ 
"stop_id" : 113,
"arrival_time" : "20:20:25" , 
"departure_time" : "20:21:46" , 
"distance_traveled" : 81.4915
}, 
{ 
"stop_id" : 123,
"arrival_time" : "20:42:21" , 
"departure_time" : "20:42:21" , 
"distance_traveled" : 95.1188
} ], 
"1807" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:15:00" , 
"departure_time" : "17:16:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:26:34" , 
"departure_time" : "17:27:44" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 144,
"arrival_time" : "17:58:10" , 
"departure_time" : "17:58:21" , 
"distance_traveled" : 30.6705
}, 
{ 
"stop_id" : 137,
"arrival_time" : "18:05:11" , 
"departure_time" : "18:05:20" , 
"distance_traveled" : 34.6371
}, 
{ 
"stop_id" : 149,
"arrival_time" : "18:10:09" , 
"departure_time" : "18:10:23" , 
"distance_traveled" : 37.2809
}, 
{ 
"stop_id" : 57,
"arrival_time" : "18:21:14" , 
"departure_time" : "18:21:52" , 
"distance_traveled" : 44.8377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "18:36:38" , 
"departure_time" : "18:37:54" , 
"distance_traveled" : 55.6292
}, 
{ 
"stop_id" : 26,
"arrival_time" : "18:49:16" , 
"departure_time" : "18:50:04" , 
"distance_traveled" : 65.7256
}, 
{ 
"stop_id" : 86,
"arrival_time" : "18:56:48" , 
"departure_time" : "18:57:23" , 
"distance_traveled" : 71.7511
}, 
{ 
"stop_id" : 113,
"arrival_time" : "19:07:35" , 
"departure_time" : "19:07:37" , 
"distance_traveled" : 81.4896
}, 
{ 
"stop_id" : 123,
"arrival_time" : "19:28:02" , 
"departure_time" : "19:28:02" , 
"distance_traveled" : 95.1165
} ], 
"1808" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:57:00" , 
"departure_time" : "18:57:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:08:17" , 
"departure_time" : "19:09:42" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "19:38:25" , 
"departure_time" : "19:39:35" , 
"distance_traveled" : 27.9559
}, 
{ 
"stop_id" : 144,
"arrival_time" : "19:43:10" , 
"departure_time" : "19:43:18" , 
"distance_traveled" : 30.6705
}, 
{ 
"stop_id" : 137,
"arrival_time" : "19:49:08" , 
"departure_time" : "19:50:31" , 
"distance_traveled" : 34.6371
}, 
{ 
"stop_id" : 149,
"arrival_time" : "19:55:23" , 
"departure_time" : "19:55:50" , 
"distance_traveled" : 37.2809
}, 
{ 
"stop_id" : 57,
"arrival_time" : "20:05:27" , 
"departure_time" : "20:06:33" , 
"distance_traveled" : 44.8377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "20:21:06" , 
"departure_time" : "20:21:49" , 
"distance_traveled" : 55.6292
}, 
{ 
"stop_id" : 26,
"arrival_time" : "20:32:43" , 
"departure_time" : "20:34:12" , 
"distance_traveled" : 65.7256
}, 
{ 
"stop_id" : 86,
"arrival_time" : "20:41:29" , 
"departure_time" : "20:42:36" , 
"distance_traveled" : 71.7511
}, 
{ 
"stop_id" : 113,
"arrival_time" : "20:52:07" , 
"departure_time" : "20:53:21" , 
"distance_traveled" : 81.4896
}, 
{ 
"stop_id" : 123,
"arrival_time" : "21:12:14" , 
"departure_time" : "21:12:14" , 
"distance_traveled" : 95.1165
} ], 
"1809" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "19:57:00" , 
"departure_time" : "19:59:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "20:09:23" , 
"departure_time" : "20:09:42" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 144,
"arrival_time" : "20:38:19" , 
"departure_time" : "20:39:23" , 
"distance_traveled" : 30.6705
}, 
{ 
"stop_id" : 137,
"arrival_time" : "20:46:04" , 
"departure_time" : "20:46:53" , 
"distance_traveled" : 34.6371
}, 
{ 
"stop_id" : 149,
"arrival_time" : "20:50:49" , 
"departure_time" : "20:52:22" , 
"distance_traveled" : 37.2809
}, 
{ 
"stop_id" : 57,
"arrival_time" : "21:02:33" , 
"departure_time" : "21:03:34" , 
"distance_traveled" : 44.8377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "21:16:01" , 
"departure_time" : "21:17:40" , 
"distance_traveled" : 55.6292
}, 
{ 
"stop_id" : 26,
"arrival_time" : "21:28:39" , 
"departure_time" : "21:30:07" , 
"distance_traveled" : 65.7256
}, 
{ 
"stop_id" : 86,
"arrival_time" : "21:35:28" , 
"departure_time" : "21:36:34" , 
"distance_traveled" : 71.7511
}, 
{ 
"stop_id" : 113,
"arrival_time" : "21:53:06" , 
"departure_time" : "21:53:24" , 
"distance_traveled" : 81.4896
}, 
{ 
"stop_id" : 123,
"arrival_time" : "22:13:18" , 
"departure_time" : "22:13:18" , 
"distance_traveled" : 95.1165
} ], 
"1810" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:41:00" , 
"departure_time" : "17:42:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:53:27" , 
"departure_time" : "17:54:26" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "18:23:59" , 
"departure_time" : "18:24:12" , 
"distance_traveled" : 27.9559
}, 
{ 
"stop_id" : 78,
"arrival_time" : "18:27:13" , 
"departure_time" : "18:28:30" , 
"distance_traveled" : 29.2926
}, 
{ 
"stop_id" : 144,
"arrival_time" : "18:31:17" , 
"departure_time" : "18:32:28" , 
"distance_traveled" : 30.6701
}, 
{ 
"stop_id" : 137,
"arrival_time" : "18:38:11" , 
"departure_time" : "18:39:03" , 
"distance_traveled" : 34.6371
}, 
{ 
"stop_id" : 149,
"arrival_time" : "18:42:52" , 
"departure_time" : "18:44:32" , 
"distance_traveled" : 37.2809
}, 
{ 
"stop_id" : 57,
"arrival_time" : "18:54:40" , 
"departure_time" : "18:55:26" , 
"distance_traveled" : 44.8377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "19:08:46" , 
"departure_time" : "19:09:28" , 
"distance_traveled" : 55.6292
}, 
{ 
"stop_id" : 26,
"arrival_time" : "19:20:42" , 
"departure_time" : "19:21:48" , 
"distance_traveled" : 65.7256
}, 
{ 
"stop_id" : 86,
"arrival_time" : "19:29:06" , 
"departure_time" : "19:29:42" , 
"distance_traveled" : 71.7511
}, 
{ 
"stop_id" : 113,
"arrival_time" : "19:39:36" , 
"departure_time" : "19:41:14" , 
"distance_traveled" : 81.4896
}, 
{ 
"stop_id" : 123,
"arrival_time" : "20:00:38" , 
"departure_time" : "20:00:38" , 
"distance_traveled" : 95.1165
} ], 
"1811" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "08:25:00" , 
"departure_time" : "08:26:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:36:13" , 
"departure_time" : "08:37:28" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "09:08:15" , 
"departure_time" : "09:09:15" , 
"distance_traveled" : 27.9559
}, 
{ 
"stop_id" : 144,
"arrival_time" : "09:12:00" , 
"departure_time" : "09:12:02" , 
"distance_traveled" : 30.6705
}, 
{ 
"stop_id" : 137,
"arrival_time" : "09:19:02" , 
"departure_time" : "09:20:28" , 
"distance_traveled" : 34.6371
}, 
{ 
"stop_id" : 149,
"arrival_time" : "09:25:26" , 
"departure_time" : "09:26:13" , 
"distance_traveled" : 37.2809
}, 
{ 
"stop_id" : 57,
"arrival_time" : "09:35:47" , 
"departure_time" : "09:37:15" , 
"distance_traveled" : 44.8377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "09:51:28" , 
"departure_time" : "09:51:30" , 
"distance_traveled" : 55.6292
}, 
{ 
"stop_id" : 26,
"arrival_time" : "10:11:02" , 
"departure_time" : "10:11:07" , 
"distance_traveled" : 65.7256
}, 
{ 
"stop_id" : 86,
"arrival_time" : "10:19:05" , 
"departure_time" : "10:20:35" , 
"distance_traveled" : 71.7511
}, 
{ 
"stop_id" : 113,
"arrival_time" : "10:31:30" , 
"departure_time" : "10:31:32" , 
"distance_traveled" : 81.4896
}, 
{ 
"stop_id" : 123,
"arrival_time" : "10:51:02" , 
"departure_time" : "10:51:02" , 
"distance_traveled" : 95.1165
} ], 
"1812" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "09:47:00" , 
"departure_time" : "09:48:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:59:00" , 
"departure_time" : "10:00:05" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "10:06:05" , 
"departure_time" : "10:06:56" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "10:09:51" , 
"departure_time" : "10:10:32" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 121,
"arrival_time" : "10:13:41" , 
"departure_time" : "10:13:59" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "10:19:18" , 
"departure_time" : "10:19:35" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "10:22:17" , 
"departure_time" : "10:23:28" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "10:26:11" , 
"departure_time" : "10:26:24" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "10:29:13" , 
"departure_time" : "10:30:17" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 3,
"arrival_time" : "10:38:04" , 
"departure_time" : "10:38:17" , 
"distance_traveled" : 23.633
}, 
{ 
"stop_id" : 128,
"arrival_time" : "10:42:13" , 
"departure_time" : "10:42:29" , 
"distance_traveled" : 25.5157
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "10:44:16" , 
"departure_time" : "10:44:59" , 
"distance_traveled" : 26.8343
}, 
{ 
"stop_id" : 78,
"arrival_time" : "10:48:43" , 
"departure_time" : "10:50:06" , 
"distance_traveled" : 28.171
}, 
{ 
"stop_id" : 144,
"arrival_time" : "10:52:23" , 
"departure_time" : "10:52:59" , 
"distance_traveled" : 29.5485
}, 
{ 
"stop_id" : 137,
"arrival_time" : "10:58:36" , 
"departure_time" : "11:00:03" , 
"distance_traveled" : 33.5155
}, 
{ 
"stop_id" : 149,
"arrival_time" : "11:04:27" , 
"departure_time" : "11:06:02" , 
"distance_traveled" : 36.1593
}, 
{ 
"stop_id" : 57,
"arrival_time" : "11:15:35" , 
"departure_time" : "11:16:02" , 
"distance_traveled" : 43.7161
}, 
{ 
"stop_id" : 135,
"arrival_time" : "11:29:27" , 
"departure_time" : "11:31:04" , 
"distance_traveled" : 54.5076
}, 
{ 
"stop_id" : 26,
"arrival_time" : "11:41:37" , 
"departure_time" : "11:42:15" , 
"distance_traveled" : 64.604
}, 
{ 
"stop_id" : 86,
"arrival_time" : "11:48:38" , 
"departure_time" : "11:50:18" , 
"distance_traveled" : 70.6295
}, 
{ 
"stop_id" : 113,
"arrival_time" : "12:02:40" , 
"departure_time" : "12:03:07" , 
"distance_traveled" : 80.368
}, 
{ 
"stop_id" : 123,
"arrival_time" : "12:21:27" , 
"departure_time" : "12:21:27" , 
"distance_traveled" : 93.9949
} ], 
"1813" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:27:00" , 
"departure_time" : "18:28:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:38:54" , 
"departure_time" : "18:39:58" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "19:08:04" , 
"departure_time" : "19:08:57" , 
"distance_traveled" : 27.9559
}, 
{ 
"stop_id" : 144,
"arrival_time" : "19:11:53" , 
"departure_time" : "19:12:28" , 
"distance_traveled" : 30.6705
}, 
{ 
"stop_id" : 137,
"arrival_time" : "19:19:35" , 
"departure_time" : "19:21:09" , 
"distance_traveled" : 34.6371
}, 
{ 
"stop_id" : 149,
"arrival_time" : "19:25:34" , 
"departure_time" : "19:26:07" , 
"distance_traveled" : 37.2809
}, 
{ 
"stop_id" : 57,
"arrival_time" : "19:35:33" , 
"departure_time" : "19:37:07" , 
"distance_traveled" : 44.8377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "19:51:34" , 
"departure_time" : "19:51:48" , 
"distance_traveled" : 55.6292
}, 
{ 
"stop_id" : 26,
"arrival_time" : "20:01:14" , 
"departure_time" : "20:01:37" , 
"distance_traveled" : 65.7256
}, 
{ 
"stop_id" : 86,
"arrival_time" : "20:09:23" , 
"departure_time" : "20:09:43" , 
"distance_traveled" : 71.7511
}, 
{ 
"stop_id" : 113,
"arrival_time" : "20:20:20" , 
"departure_time" : "20:21:58" , 
"distance_traveled" : 81.4896
}, 
{ 
"stop_id" : 123,
"arrival_time" : "20:42:38" , 
"departure_time" : "20:42:38" , 
"distance_traveled" : 95.1165
} ], 
"1814" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "24:39:00" , 
"departure_time" : "24:41:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "24:50:58" , 
"departure_time" : "24:51:36" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "24:58:38" , 
"departure_time" : "24:59:29" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "25:02:51" , 
"departure_time" : "25:03:51" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "25:06:00" , 
"departure_time" : "25:06:24" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "25:08:24" , 
"departure_time" : "25:09:48" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "25:13:24" , 
"departure_time" : "25:13:50" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "25:16:26" , 
"departure_time" : "25:17:38" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "25:20:12" , 
"departure_time" : "25:21:16" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "25:23:04" , 
"departure_time" : "25:23:19" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "25:25:15" , 
"departure_time" : "25:26:44" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "25:30:29" , 
"departure_time" : "25:32:03" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "25:33:34" , 
"departure_time" : "25:33:53" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "25:37:19" , 
"departure_time" : "25:38:44" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "25:41:25" , 
"departure_time" : "25:42:40" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "25:44:15" , 
"departure_time" : "25:45:12" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "25:46:57" , 
"departure_time" : "25:47:56" , 
"distance_traveled" : 29.571
}, 
{ 
"stop_id" : 137,
"arrival_time" : "25:53:59" , 
"departure_time" : "25:54:32" , 
"distance_traveled" : 33.5381
}, 
{ 
"stop_id" : 149,
"arrival_time" : "25:58:33" , 
"departure_time" : "25:59:47" , 
"distance_traveled" : 36.1818
}, 
{ 
"stop_id" : 57,
"arrival_time" : "26:10:14" , 
"departure_time" : "26:11:17" , 
"distance_traveled" : 43.7386
}, 
{ 
"stop_id" : 135,
"arrival_time" : "26:25:03" , 
"departure_time" : "26:25:51" , 
"distance_traveled" : 54.5301
}, 
{ 
"stop_id" : 26,
"arrival_time" : "26:35:48" , 
"departure_time" : "26:36:11" , 
"distance_traveled" : 64.6265
}, 
{ 
"stop_id" : 86,
"arrival_time" : "26:43:23" , 
"departure_time" : "26:44:45" , 
"distance_traveled" : 70.6521
}, 
{ 
"stop_id" : 113,
"arrival_time" : "26:55:22" , 
"departure_time" : "26:55:34" , 
"distance_traveled" : 80.3905
}, 
{ 
"stop_id" : 123,
"arrival_time" : "27:14:12" , 
"departure_time" : "27:14:12" , 
"distance_traveled" : 94.0174
} ], 
"1815" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:57:00" , 
"departure_time" : "18:58:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:09:00" , 
"departure_time" : "19:09:50" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "19:37:50" , 
"departure_time" : "19:39:28" , 
"distance_traveled" : 27.9559
}, 
{ 
"stop_id" : 144,
"arrival_time" : "19:43:38" , 
"departure_time" : "19:43:41" , 
"distance_traveled" : 30.6705
}, 
{ 
"stop_id" : 137,
"arrival_time" : "19:49:03" , 
"departure_time" : "19:49:38" , 
"distance_traveled" : 34.6371
}, 
{ 
"stop_id" : 149,
"arrival_time" : "19:54:35" , 
"departure_time" : "19:55:59" , 
"distance_traveled" : 37.2809
}, 
{ 
"stop_id" : 57,
"arrival_time" : "20:06:24" , 
"departure_time" : "20:07:27" , 
"distance_traveled" : 44.8377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "20:21:03" , 
"departure_time" : "20:22:16" , 
"distance_traveled" : 55.6292
}, 
{ 
"stop_id" : 26,
"arrival_time" : "20:33:13" , 
"departure_time" : "20:33:33" , 
"distance_traveled" : 65.7256
}, 
{ 
"stop_id" : 86,
"arrival_time" : "20:40:20" , 
"departure_time" : "20:41:50" , 
"distance_traveled" : 71.7511
}, 
{ 
"stop_id" : 113,
"arrival_time" : "20:52:30" , 
"departure_time" : "20:53:11" , 
"distance_traveled" : 81.4896
}, 
{ 
"stop_id" : 123,
"arrival_time" : "21:11:41" , 
"departure_time" : "21:11:41" , 
"distance_traveled" : 95.1165
} ], 
"1816" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "21:58:00" , 
"departure_time" : "21:59:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "22:09:51" , 
"departure_time" : "22:10:04" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "22:15:13" , 
"departure_time" : "22:16:33" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "22:18:20" , 
"departure_time" : "22:19:18" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "22:20:58" , 
"departure_time" : "22:21:58" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "22:24:00" , 
"departure_time" : "22:24:54" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "22:26:54" , 
"departure_time" : "22:27:01" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "22:32:07" , 
"departure_time" : "22:33:38" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "22:37:31" , 
"departure_time" : "22:38:52" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "22:41:21" , 
"departure_time" : "22:41:47" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "22:44:26" , 
"departure_time" : "22:46:00" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "22:48:34" , 
"departure_time" : "22:49:37" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "22:52:03" , 
"departure_time" : "22:52:06" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "22:54:03" , 
"departure_time" : "22:55:19" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "23:00:16" , 
"departure_time" : "23:01:36" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "23:02:20" , 
"departure_time" : "23:02:25" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "23:05:05" , 
"departure_time" : "23:05:41" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "23:08:36" , 
"departure_time" : "23:09:12" , 
"distance_traveled" : 30.7256
}, 
{ 
"stop_id" : 137,
"arrival_time" : "23:15:36" , 
"departure_time" : "23:17:14" , 
"distance_traveled" : 34.6926
}, 
{ 
"stop_id" : 149,
"arrival_time" : "23:21:38" , 
"departure_time" : "23:22:53" , 
"distance_traveled" : 37.3364
}, 
{ 
"stop_id" : 57,
"arrival_time" : "23:32:15" , 
"departure_time" : "23:32:47" , 
"distance_traveled" : 44.8932
}, 
{ 
"stop_id" : 135,
"arrival_time" : "23:45:32" , 
"departure_time" : "23:45:45" , 
"distance_traveled" : 55.6847
}, 
{ 
"stop_id" : 26,
"arrival_time" : "23:57:13" , 
"departure_time" : "23:58:17" , 
"distance_traveled" : 65.7811
}, 
{ 
"stop_id" : 86,
"arrival_time" : "24:05:04" , 
"departure_time" : "24:06:26" , 
"distance_traveled" : 71.8066
}, 
{ 
"stop_id" : 113,
"arrival_time" : "24:17:22" , 
"departure_time" : "24:18:40" , 
"distance_traveled" : 81.5451
}, 
{ 
"stop_id" : 123,
"arrival_time" : "24:37:18" , 
"departure_time" : "24:37:18" , 
"distance_traveled" : 95.172
} ], 
"1817" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:41:00" , 
"departure_time" : "17:43:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:53:26" , 
"departure_time" : "17:54:46" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "18:24:20" , 
"departure_time" : "18:24:36" , 
"distance_traveled" : 27.9559
}, 
{ 
"stop_id" : 78,
"arrival_time" : "18:27:16" , 
"departure_time" : "18:27:59" , 
"distance_traveled" : 29.2926
}, 
{ 
"stop_id" : 144,
"arrival_time" : "18:30:43" , 
"departure_time" : "18:32:04" , 
"distance_traveled" : 30.6701
}, 
{ 
"stop_id" : 137,
"arrival_time" : "18:38:21" , 
"departure_time" : "18:39:40" , 
"distance_traveled" : 34.6371
}, 
{ 
"stop_id" : 149,
"arrival_time" : "18:43:19" , 
"departure_time" : "18:44:31" , 
"distance_traveled" : 37.2809
}, 
{ 
"stop_id" : 57,
"arrival_time" : "18:54:12" , 
"departure_time" : "18:54:50" , 
"distance_traveled" : 44.8377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "19:08:38" , 
"departure_time" : "19:08:52" , 
"distance_traveled" : 55.6292
}, 
{ 
"stop_id" : 26,
"arrival_time" : "19:20:14" , 
"departure_time" : "19:21:08" , 
"distance_traveled" : 65.7256
}, 
{ 
"stop_id" : 86,
"arrival_time" : "19:28:54" , 
"departure_time" : "19:30:23" , 
"distance_traveled" : 71.7511
}, 
{ 
"stop_id" : 113,
"arrival_time" : "19:40:29" , 
"departure_time" : "19:40:45" , 
"distance_traveled" : 81.4896
}, 
{ 
"stop_id" : 123,
"arrival_time" : "19:59:16" , 
"departure_time" : "19:59:16" , 
"distance_traveled" : 95.1165
} ], 
"1818" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:14:00" , 
"departure_time" : "18:15:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:26:26" , 
"departure_time" : "18:27:04" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 57,
"arrival_time" : "19:17:38" , 
"departure_time" : "19:17:39" , 
"distance_traveled" : 55.8458
}, 
{ 
"stop_id" : 135,
"arrival_time" : "19:32:01" , 
"departure_time" : "19:33:00" , 
"distance_traveled" : 66.6455
}, 
{ 
"stop_id" : 26,
"arrival_time" : "19:44:59" , 
"departure_time" : "19:46:21" , 
"distance_traveled" : 76.7419
}, 
{ 
"stop_id" : 86,
"arrival_time" : "19:53:22" , 
"departure_time" : "19:54:28" , 
"distance_traveled" : 82.7674
}, 
{ 
"stop_id" : 113,
"arrival_time" : "20:05:06" , 
"departure_time" : "20:05:57" , 
"distance_traveled" : 92.5059
}, 
{ 
"stop_id" : 123,
"arrival_time" : "20:24:51" , 
"departure_time" : "20:24:51" , 
"distance_traveled" : 106.1328
} ], 
"1819" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "09:47:00" , 
"departure_time" : "09:48:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:58:21" , 
"departure_time" : "09:59:36" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "10:06:15" , 
"departure_time" : "10:06:56" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "10:09:41" , 
"departure_time" : "10:09:45" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 121,
"arrival_time" : "10:13:04" , 
"departure_time" : "10:13:24" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "10:19:20" , 
"departure_time" : "10:20:56" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "10:23:36" , 
"departure_time" : "10:24:10" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "10:25:34" , 
"departure_time" : "10:27:11" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "10:30:37" , 
"departure_time" : "10:30:50" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 3,
"arrival_time" : "10:37:13" , 
"departure_time" : "10:38:38" , 
"distance_traveled" : 23.633
}, 
{ 
"stop_id" : 128,
"arrival_time" : "10:43:25" , 
"departure_time" : "10:44:19" , 
"distance_traveled" : 25.5157
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "10:44:54" , 
"departure_time" : "10:46:24" , 
"distance_traveled" : 26.8343
}, 
{ 
"stop_id" : 78,
"arrival_time" : "10:49:30" , 
"departure_time" : "10:49:59" , 
"distance_traveled" : 28.171
}, 
{ 
"stop_id" : 144,
"arrival_time" : "10:51:29" , 
"departure_time" : "10:51:53" , 
"distance_traveled" : 29.5485
}, 
{ 
"stop_id" : 137,
"arrival_time" : "10:58:24" , 
"departure_time" : "10:59:39" , 
"distance_traveled" : 33.5155
}, 
{ 
"stop_id" : 149,
"arrival_time" : "11:04:15" , 
"departure_time" : "11:04:40" , 
"distance_traveled" : 36.1593
}, 
{ 
"stop_id" : 57,
"arrival_time" : "11:14:25" , 
"departure_time" : "11:15:20" , 
"distance_traveled" : 43.7161
}, 
{ 
"stop_id" : 135,
"arrival_time" : "11:29:55" , 
"departure_time" : "11:30:53" , 
"distance_traveled" : 54.5076
}, 
{ 
"stop_id" : 26,
"arrival_time" : "11:40:58" , 
"departure_time" : "11:42:19" , 
"distance_traveled" : 64.604
}, 
{ 
"stop_id" : 86,
"arrival_time" : "11:49:21" , 
"departure_time" : "11:49:52" , 
"distance_traveled" : 70.6295
}, 
{ 
"stop_id" : 113,
"arrival_time" : "12:01:31" , 
"departure_time" : "12:01:56" , 
"distance_traveled" : 80.368
}, 
{ 
"stop_id" : 123,
"arrival_time" : "12:21:25" , 
"departure_time" : "12:21:25" , 
"distance_traveled" : 93.9949
} ], 
"1820" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "24:39:00" , 
"departure_time" : "24:40:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "24:51:18" , 
"departure_time" : "24:52:55" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "24:59:37" , 
"departure_time" : "25:00:14" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "25:02:37" , 
"departure_time" : "25:03:40" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "25:06:03" , 
"departure_time" : "25:07:34" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "25:09:31" , 
"departure_time" : "25:11:09" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "25:13:38" , 
"departure_time" : "25:14:35" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "25:16:57" , 
"departure_time" : "25:17:11" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "25:19:14" , 
"departure_time" : "25:20:41" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "25:23:27" , 
"departure_time" : "25:25:07" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "25:26:40" , 
"departure_time" : "25:28:16" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "25:30:36" , 
"departure_time" : "25:30:37" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "25:32:01" , 
"departure_time" : "25:33:11" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "25:38:10" , 
"departure_time" : "25:39:08" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "25:40:58" , 
"departure_time" : "25:41:02" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "25:43:04" , 
"departure_time" : "25:44:10" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "25:47:06" , 
"departure_time" : "25:48:34" , 
"distance_traveled" : 29.571
}, 
{ 
"stop_id" : 137,
"arrival_time" : "25:54:28" , 
"departure_time" : "25:55:45" , 
"distance_traveled" : 33.5381
}, 
{ 
"stop_id" : 149,
"arrival_time" : "25:59:17" , 
"departure_time" : "26:00:13" , 
"distance_traveled" : 36.1818
}, 
{ 
"stop_id" : 57,
"arrival_time" : "26:09:56" , 
"departure_time" : "26:11:18" , 
"distance_traveled" : 43.7386
}, 
{ 
"stop_id" : 135,
"arrival_time" : "26:25:22" , 
"departure_time" : "26:26:38" , 
"distance_traveled" : 54.5301
}, 
{ 
"stop_id" : 26,
"arrival_time" : "26:36:16" , 
"departure_time" : "26:36:38" , 
"distance_traveled" : 64.6265
}, 
{ 
"stop_id" : 86,
"arrival_time" : "26:43:22" , 
"departure_time" : "26:44:42" , 
"distance_traveled" : 70.6521
}, 
{ 
"stop_id" : 113,
"arrival_time" : "26:55:20" , 
"departure_time" : "26:56:07" , 
"distance_traveled" : 80.3905
}, 
{ 
"stop_id" : 123,
"arrival_time" : "27:15:47" , 
"departure_time" : "27:15:47" , 
"distance_traveled" : 94.0174
} ], 
"1821" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "21:58:00" , 
"departure_time" : "21:59:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "22:10:10" , 
"departure_time" : "22:10:56" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 66,
"arrival_time" : "22:15:46" , 
"departure_time" : "22:16:30" , 
"distance_traveled" : 7.6585
}, 
{ 
"stop_id" : 75,
"arrival_time" : "22:17:44" , 
"departure_time" : "22:17:47" , 
"distance_traveled" : 8.218
}, 
{ 
"stop_id" : 33,
"arrival_time" : "22:20:03" , 
"departure_time" : "22:20:11" , 
"distance_traveled" : 9.3191
}, 
{ 
"stop_id" : 115,
"arrival_time" : "22:23:08" , 
"departure_time" : "22:23:40" , 
"distance_traveled" : 10.5657
}, 
{ 
"stop_id" : 29,
"arrival_time" : "22:26:32" , 
"departure_time" : "22:27:04" , 
"distance_traveled" : 12.2295
}, 
{ 
"stop_id" : 116,
"arrival_time" : "22:32:32" , 
"departure_time" : "22:33:42" , 
"distance_traveled" : 15.7517
}, 
{ 
"stop_id" : 58,
"arrival_time" : "22:37:10" , 
"departure_time" : "22:37:14" , 
"distance_traveled" : 17.8487
}, 
{ 
"stop_id" : 52,
"arrival_time" : "22:40:04" , 
"departure_time" : "22:40:45" , 
"distance_traveled" : 19.5386
}, 
{ 
"stop_id" : 131,
"arrival_time" : "22:44:41" , 
"departure_time" : "22:44:53" , 
"distance_traveled" : 21.0006
}, 
{ 
"stop_id" : 64,
"arrival_time" : "22:47:12" , 
"departure_time" : "22:48:17" , 
"distance_traveled" : 22.2282
}, 
{ 
"stop_id" : 151,
"arrival_time" : "22:52:05" , 
"departure_time" : "22:53:33" , 
"distance_traveled" : 23.4703
}, 
{ 
"stop_id" : 3,
"arrival_time" : "22:55:28" , 
"departure_time" : "22:56:52" , 
"distance_traveled" : 24.81
}, 
{ 
"stop_id" : 128,
"arrival_time" : "23:00:24" , 
"departure_time" : "23:00:28" , 
"distance_traveled" : 26.6928
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "23:01:04" , 
"departure_time" : "23:01:38" , 
"distance_traveled" : 28.0114
}, 
{ 
"stop_id" : 78,
"arrival_time" : "23:05:34" , 
"departure_time" : "23:06:13" , 
"distance_traveled" : 29.3481
}, 
{ 
"stop_id" : 144,
"arrival_time" : "23:08:39" , 
"departure_time" : "23:09:07" , 
"distance_traveled" : 30.7256
}, 
{ 
"stop_id" : 137,
"arrival_time" : "23:15:28" , 
"departure_time" : "23:16:21" , 
"distance_traveled" : 34.6926
}, 
{ 
"stop_id" : 149,
"arrival_time" : "23:20:53" , 
"departure_time" : "23:21:54" , 
"distance_traveled" : 37.3364
}, 
{ 
"stop_id" : 57,
"arrival_time" : "23:32:01" , 
"departure_time" : "23:33:00" , 
"distance_traveled" : 44.8932
}, 
{ 
"stop_id" : 135,
"arrival_time" : "23:45:59" , 
"departure_time" : "23:46:08" , 
"distance_traveled" : 55.6847
}, 
{ 
"stop_id" : 26,
"arrival_time" : "23:57:09" , 
"departure_time" : "23:57:32" , 
"distance_traveled" : 65.7811
}, 
{ 
"stop_id" : 86,
"arrival_time" : "24:04:23" , 
"departure_time" : "24:05:36" , 
"distance_traveled" : 71.8066
}, 
{ 
"stop_id" : 113,
"arrival_time" : "24:17:13" , 
"departure_time" : "24:18:27" , 
"distance_traveled" : 81.5451
}, 
{ 
"stop_id" : 123,
"arrival_time" : "24:37:14" , 
"departure_time" : "24:37:14" , 
"distance_traveled" : 95.172
} ], 
"1822" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:19:00" , 
"departure_time" : "17:20:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:29:14" , 
"departure_time" : "17:30:29" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 144,
"arrival_time" : "18:01:15" , 
"departure_time" : "18:02:00" , 
"distance_traveled" : 30.6705
}, 
{ 
"stop_id" : 137,
"arrival_time" : "18:07:45" , 
"departure_time" : "18:07:52" , 
"distance_traveled" : 34.6371
}, 
{ 
"stop_id" : 149,
"arrival_time" : "18:12:07" , 
"departure_time" : "18:12:12" , 
"distance_traveled" : 37.2809
}, 
{ 
"stop_id" : 57,
"arrival_time" : "18:23:05" , 
"departure_time" : "18:24:44" , 
"distance_traveled" : 44.8377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "18:36:39" , 
"departure_time" : "18:37:25" , 
"distance_traveled" : 55.6292
}, 
{ 
"stop_id" : 26,
"arrival_time" : "18:47:46" , 
"departure_time" : "18:48:08" , 
"distance_traveled" : 65.7256
}, 
{ 
"stop_id" : 86,
"arrival_time" : "18:54:22" , 
"departure_time" : "18:54:58" , 
"distance_traveled" : 71.7511
}, 
{ 
"stop_id" : 113,
"arrival_time" : "19:06:36" , 
"departure_time" : "19:06:55" , 
"distance_traveled" : 81.4896
}, 
{ 
"stop_id" : 123,
"arrival_time" : "19:26:19" , 
"departure_time" : "19:26:19" , 
"distance_traveled" : 95.1165
} ], 
"1823" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "24:39:00" , 
"departure_time" : "24:40:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "24:51:36" , 
"departure_time" : "24:51:43" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "24:58:07" , 
"departure_time" : "24:58:46" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 43599,
"arrival_time" : "25:02:39" , 
"departure_time" : "25:03:39" , 
"distance_traveled" : 10.6155
}, 
{ 
"stop_id" : 46,
"arrival_time" : "25:06:00" , 
"departure_time" : "25:07:33" , 
"distance_traveled" : 11.6375
}, 
{ 
"stop_id" : 121,
"arrival_time" : "25:09:33" , 
"departure_time" : "25:09:58" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "25:12:25" , 
"departure_time" : "25:13:00" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "25:16:35" , 
"departure_time" : "25:17:44" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "25:20:09" , 
"departure_time" : "25:21:10" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "25:23:01" , 
"departure_time" : "25:24:19" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "25:26:18" , 
"departure_time" : "25:26:57" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "25:29:39" , 
"departure_time" : "25:30:49" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "25:33:10" , 
"departure_time" : "25:33:47" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "25:37:37" , 
"departure_time" : "25:38:56" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "25:41:19" , 
"departure_time" : "25:41:31" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "25:43:12" , 
"departure_time" : "25:43:39" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "25:46:27" , 
"departure_time" : "25:47:58" , 
"distance_traveled" : 29.571
}, 
{ 
"stop_id" : 137,
"arrival_time" : "25:54:31" , 
"departure_time" : "25:55:38" , 
"distance_traveled" : 33.5381
}, 
{ 
"stop_id" : 149,
"arrival_time" : "25:59:07" , 
"departure_time" : "25:59:25" , 
"distance_traveled" : 36.1818
}, 
{ 
"stop_id" : 57,
"arrival_time" : "26:09:18" , 
"departure_time" : "26:09:53" , 
"distance_traveled" : 43.7386
}, 
{ 
"stop_id" : 135,
"arrival_time" : "26:24:35" , 
"departure_time" : "26:24:50" , 
"distance_traveled" : 54.5301
}, 
{ 
"stop_id" : 26,
"arrival_time" : "26:35:15" , 
"departure_time" : "26:35:40" , 
"distance_traveled" : 64.6265
}, 
{ 
"stop_id" : 86,
"arrival_time" : "26:43:25" , 
"departure_time" : "26:44:19" , 
"distance_traveled" : 70.6521
}, 
{ 
"stop_id" : 113,
"arrival_time" : "26:54:54" , 
"departure_time" : "26:55:18" , 
"distance_traveled" : 80.3905
}, 
{ 
"stop_id" : 123,
"arrival_time" : "27:14:24" , 
"departure_time" : "27:14:24" , 
"distance_traveled" : 94.0174
} ], 
"1824" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:01:00" , 
"departure_time" : "16:01:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:11:26" , 
"departure_time" : "16:12:26" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 128,
"arrival_time" : "16:39:00" , 
"departure_time" : "16:39:13" , 
"distance_traveled" : 26.6371
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "16:41:13" , 
"departure_time" : "16:42:28" , 
"distance_traveled" : 27.9559
}, 
{ 
"stop_id" : 144,
"arrival_time" : "16:46:15" , 
"departure_time" : "16:46:35" , 
"distance_traveled" : 30.6705
}, 
{ 
"stop_id" : 137,
"arrival_time" : "16:53:20" , 
"departure_time" : "16:53:39" , 
"distance_traveled" : 34.6371
}, 
{ 
"stop_id" : 149,
"arrival_time" : "16:58:19" , 
"departure_time" : "16:59:46" , 
"distance_traveled" : 37.2809
}, 
{ 
"stop_id" : 57,
"arrival_time" : "17:10:27" , 
"departure_time" : "17:11:56" , 
"distance_traveled" : 44.8377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "17:25:29" , 
"departure_time" : "17:27:08" , 
"distance_traveled" : 55.6292
}, 
{ 
"stop_id" : 26,
"arrival_time" : "17:36:39" , 
"departure_time" : "17:36:59" , 
"distance_traveled" : 65.7256
}, 
{ 
"stop_id" : 86,
"arrival_time" : "17:43:20" , 
"departure_time" : "17:44:58" , 
"distance_traveled" : 71.7511
}, 
{ 
"stop_id" : 113,
"arrival_time" : "17:57:38" , 
"departure_time" : "17:59:12" , 
"distance_traveled" : 81.4896
}, 
{ 
"stop_id" : 123,
"arrival_time" : "18:19:34" , 
"departure_time" : "18:19:34" , 
"distance_traveled" : 95.1165
} ], 
"1825" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:13:00" , 
"departure_time" : "18:15:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:24:25" , 
"departure_time" : "18:25:50" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 131,
"arrival_time" : "18:44:25" , 
"departure_time" : "18:45:57" , 
"distance_traveled" : 20.9674
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "18:53:32" , 
"departure_time" : "18:55:12" , 
"distance_traveled" : 27.9559
}, 
{ 
"stop_id" : 144,
"arrival_time" : "18:58:40" , 
"departure_time" : "18:59:11" , 
"distance_traveled" : 30.6705
}, 
{ 
"stop_id" : 137,
"arrival_time" : "19:04:31" , 
"departure_time" : "19:05:14" , 
"distance_traveled" : 34.6371
}, 
{ 
"stop_id" : 149,
"arrival_time" : "19:09:43" , 
"departure_time" : "19:10:26" , 
"distance_traveled" : 37.2809
}, 
{ 
"stop_id" : 57,
"arrival_time" : "19:20:43" , 
"departure_time" : "19:20:45" , 
"distance_traveled" : 44.8377
}, 
{ 
"stop_id" : 135,
"arrival_time" : "19:35:02" , 
"departure_time" : "19:35:48" , 
"distance_traveled" : 55.6292
}, 
{ 
"stop_id" : 26,
"arrival_time" : "19:46:46" , 
"departure_time" : "19:46:55" , 
"distance_traveled" : 65.7256
}, 
{ 
"stop_id" : 86,
"arrival_time" : "19:54:09" , 
"departure_time" : "19:54:49" , 
"distance_traveled" : 71.7511
}, 
{ 
"stop_id" : 113,
"arrival_time" : "20:05:40" , 
"departure_time" : "20:06:36" , 
"distance_traveled" : 81.4896
}, 
{ 
"stop_id" : 123,
"arrival_time" : "20:27:56" , 
"departure_time" : "20:27:56" , 
"distance_traveled" : 95.1165
} ], 
"1826" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "13:21:00" , 
"departure_time" : "13:23:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "13:32:40" , 
"departure_time" : "13:33:19" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 131,
"arrival_time" : "13:52:39" , 
"departure_time" : "13:53:15" , 
"distance_traveled" : 20.9674
}, 
{ 
"stop_id" : 3,
"arrival_time" : "13:58:36" , 
"departure_time" : "13:59:38" , 
"distance_traveled" : 24.76
}, 
{ 
"stop_id" : 128,
"arrival_time" : "14:04:02" , 
"departure_time" : "14:05:41" , 
"distance_traveled" : 26.6428
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "14:07:39" , 
"departure_time" : "14:09:02" , 
"distance_traveled" : 27.9614
}, 
{ 
"stop_id" : 78,
"arrival_time" : "14:10:23" , 
"departure_time" : "14:10:58" , 
"distance_traveled" : 29.2981
}, 
{ 
"stop_id" : 144,
"arrival_time" : "14:12:35" , 
"departure_time" : "14:13:55" , 
"distance_traveled" : 30.6756
}, 
{ 
"stop_id" : 137,
"arrival_time" : "14:20:20" , 
"departure_time" : "14:21:40" , 
"distance_traveled" : 34.6426
}, 
{ 
"stop_id" : 149,
"arrival_time" : "14:25:20" , 
"departure_time" : "14:26:49" , 
"distance_traveled" : 37.2864
}, 
{ 
"stop_id" : 57,
"arrival_time" : "14:36:29" , 
"departure_time" : "14:37:15" , 
"distance_traveled" : 44.8432
}, 
{ 
"stop_id" : 135,
"arrival_time" : "14:50:46" , 
"departure_time" : "14:51:41" , 
"distance_traveled" : 55.6347
}, 
{ 
"stop_id" : 26,
"arrival_time" : "15:03:55" , 
"departure_time" : "15:04:38" , 
"distance_traveled" : 65.7311
}, 
{ 
"stop_id" : 86,
"arrival_time" : "15:10:43" , 
"departure_time" : "15:11:31" , 
"distance_traveled" : 71.7566
}, 
{ 
"stop_id" : 113,
"arrival_time" : "15:27:48" , 
"departure_time" : "15:29:26" , 
"distance_traveled" : 81.4951
}, 
{ 
"stop_id" : 123,
"arrival_time" : "15:49:38" , 
"departure_time" : "15:49:38" , 
"distance_traveled" : 95.122
} ], 
"1827" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "09:20:00" , 
"departure_time" : "09:22:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:31:07" , 
"departure_time" : "09:32:07" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "09:39:00" , 
"departure_time" : "09:39:56" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 121,
"arrival_time" : "09:45:56" , 
"departure_time" : "09:47:09" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "09:51:13" , 
"departure_time" : "09:51:50" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "09:54:37" , 
"departure_time" : "09:56:16" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "09:58:39" , 
"departure_time" : "10:00:13" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "10:02:34" , 
"departure_time" : "10:03:24" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "10:10:50" , 
"departure_time" : "10:10:57" , 
"distance_traveled" : 26.8345
}, 
{ 
"stop_id" : 144,
"arrival_time" : "10:15:07" , 
"departure_time" : "10:15:34" , 
"distance_traveled" : 29.5491
}, 
{ 
"stop_id" : 137,
"arrival_time" : "10:24:27" , 
"departure_time" : "10:25:22" , 
"distance_traveled" : 33.5157
}, 
{ 
"stop_id" : 149,
"arrival_time" : "10:29:55" , 
"departure_time" : "10:30:42" , 
"distance_traveled" : 36.1595
}, 
{ 
"stop_id" : 57,
"arrival_time" : "10:40:47" , 
"departure_time" : "10:42:01" , 
"distance_traveled" : 43.7163
}, 
{ 
"stop_id" : 135,
"arrival_time" : "10:56:14" , 
"departure_time" : "10:56:21" , 
"distance_traveled" : 54.5078
}, 
{ 
"stop_id" : 26,
"arrival_time" : "11:07:07" , 
"departure_time" : "11:07:22" , 
"distance_traveled" : 64.6042
}, 
{ 
"stop_id" : 86,
"arrival_time" : "11:15:15" , 
"departure_time" : "11:16:51" , 
"distance_traveled" : 70.6297
}, 
{ 
"stop_id" : 113,
"arrival_time" : "11:27:36" , 
"departure_time" : "11:28:14" , 
"distance_traveled" : 80.3682
}, 
{ 
"stop_id" : 123,
"arrival_time" : "11:48:38" , 
"departure_time" : "11:48:38" , 
"distance_traveled" : 93.9951
} ], 
"1828" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "11:20:00" , 
"departure_time" : "11:20:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "11:30:12" , 
"departure_time" : "11:31:24" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "11:39:12" , 
"departure_time" : "11:40:20" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 121,
"arrival_time" : "11:46:08" , 
"departure_time" : "11:46:30" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "11:50:22" , 
"departure_time" : "11:51:31" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "11:55:09" , 
"departure_time" : "11:56:30" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "11:58:21" , 
"departure_time" : "11:58:31" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "12:01:10" , 
"departure_time" : "12:02:16" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "12:11:06" , 
"departure_time" : "12:11:34" , 
"distance_traveled" : 26.8345
}, 
{ 
"stop_id" : 144,
"arrival_time" : "12:15:28" , 
"departure_time" : "12:17:02" , 
"distance_traveled" : 29.5491
}, 
{ 
"stop_id" : 137,
"arrival_time" : "12:25:34" , 
"departure_time" : "12:25:54" , 
"distance_traveled" : 33.5157
}, 
{ 
"stop_id" : 149,
"arrival_time" : "12:29:20" , 
"departure_time" : "12:30:47" , 
"distance_traveled" : 36.1595
}, 
{ 
"stop_id" : 57,
"arrival_time" : "12:41:27" , 
"departure_time" : "12:41:32" , 
"distance_traveled" : 43.7163
}, 
{ 
"stop_id" : 135,
"arrival_time" : "12:55:05" , 
"departure_time" : "12:55:36" , 
"distance_traveled" : 54.5078
}, 
{ 
"stop_id" : 26,
"arrival_time" : "13:06:31" , 
"departure_time" : "13:07:25" , 
"distance_traveled" : 64.6042
}, 
{ 
"stop_id" : 86,
"arrival_time" : "13:14:54" , 
"departure_time" : "13:16:32" , 
"distance_traveled" : 70.6297
}, 
{ 
"stop_id" : 113,
"arrival_time" : "13:28:38" , 
"departure_time" : "13:29:24" , 
"distance_traveled" : 80.3682
}, 
{ 
"stop_id" : 123,
"arrival_time" : "13:49:46" , 
"departure_time" : "13:49:46" , 
"distance_traveled" : 93.9951
} ], 
"1829" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "21:28:00" , 
"departure_time" : "21:29:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "21:39:04" , 
"departure_time" : "21:40:25" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 134,
"arrival_time" : "21:47:21" , 
"departure_time" : "21:47:35" , 
"distance_traveled" : 8.6782
}, 
{ 
"stop_id" : 121,
"arrival_time" : "21:53:14" , 
"departure_time" : "21:53:53" , 
"distance_traveled" : 12.9161
}, 
{ 
"stop_id" : 25,
"arrival_time" : "21:58:39" , 
"departure_time" : "22:00:16" , 
"distance_traveled" : 15.6438
}, 
{ 
"stop_id" : 126,
"arrival_time" : "22:02:37" , 
"departure_time" : "22:02:40" , 
"distance_traveled" : 16.8947
}, 
{ 
"stop_id" : 51,
"arrival_time" : "22:05:03" , 
"departure_time" : "22:06:13" , 
"distance_traveled" : 18.4343
}, 
{ 
"stop_id" : 131,
"arrival_time" : "22:09:10" , 
"departure_time" : "22:09:51" , 
"distance_traveled" : 19.8432
}, 
{ 
"stop_id" : 64,
"arrival_time" : "22:11:41" , 
"departure_time" : "22:13:21" , 
"distance_traveled" : 21.0737
}, 
{ 
"stop_id" : 151,
"arrival_time" : "22:15:40" , 
"departure_time" : "22:16:28" , 
"distance_traveled" : 22.3157
}, 
{ 
"stop_id" : 3,
"arrival_time" : "22:18:48" , 
"departure_time" : "22:20:08" , 
"distance_traveled" : 23.6555
}, 
{ 
"stop_id" : 128,
"arrival_time" : "22:23:20" , 
"departure_time" : "22:24:29" , 
"distance_traveled" : 25.5383
}, 
{ 
"stop_id" : 38417,
"arrival_time" : "22:26:09" , 
"departure_time" : "22:26:28" , 
"distance_traveled" : 26.8568
}, 
{ 
"stop_id" : 78,
"arrival_time" : "22:29:19" , 
"departure_time" : "22:29:31" , 
"distance_traveled" : 28.1936
}, 
{ 
"stop_id" : 144,
"arrival_time" : "22:32:12" , 
"departure_time" : "22:33:06" , 
"distance_traveled" : 29.571
}, 
{ 
"stop_id" : 137,
"arrival_time" : "22:39:54" , 
"departure_time" : "22:41:11" , 
"distance_traveled" : 33.5381
}, 
{ 
"stop_id" : 149,
"arrival_time" : "22:45:17" , 
"departure_time" : "22:46:36" , 
"distance_traveled" : 36.1818
}, 
{ 
"stop_id" : 57,
"arrival_time" : "22:56:19" , 
"departure_time" : "22:56:39" , 
"distance_traveled" : 43.7386
}, 
{ 
"stop_id" : 135,
"arrival_time" : "23:10:20" , 
"departure_time" : "23:11:07" , 
"distance_traveled" : 54.5301
}, 
{ 
"stop_id" : 26,
"arrival_time" : "23:22:47" , 
"departure_time" : "23:23:13" , 
"distance_traveled" : 64.6265
}, 
{ 
"stop_id" : 86,
"arrival_time" : "23:29:26" , 
"departure_time" : "23:29:34" , 
"distance_traveled" : 70.6521
}, 
{ 
"stop_id" : 113,
"arrival_time" : "23:41:08" , 
"departure_time" : "23:42:19" , 
"distance_traveled" : 80.3905
}, 
{ 
"stop_id" : 123,
"arrival_time" : "24:03:11" , 
"departure_time" : "24:03:11" , 
"distance_traveled" : 94.0174
} ], 
"1830" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "06:02:00" , 
"departure_time" : "06:04:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 136,
"arrival_time" : "06:07:00" , 
"departure_time" : "06:07:15" , 
"distance_traveled" : 2.268
}, 
{ 
"stop_id" : 87,
"arrival_time" : "06:09:15" , 
"departure_time" : "06:09:51" , 
"distance_traveled" : 3.3424
}, 
{ 
"stop_id" : 81,
"arrival_time" : "06:13:36" , 
"departure_time" : "06:15:10" , 
"distance_traveled" : 4.9511
}, 
{ 
"stop_id" : 140,
"arrival_time" : "06:17:34" , 
"departure_time" : "06:18:46" , 
"distance_traveled" : 6.2335
}, 
{ 
"stop_id" : 97,
"arrival_time" : "06:19:12" , 
"departure_time" : "06:19:24" , 
"distance_traveled" : 7.0051
}, 
{ 
"stop_id" : 61,
"arrival_time" : "06:20:12" , 
"departure_time" : "06:20:20" , 
"distance_traveled" : 7.9331
}, 
{ 
"stop_id" : 112,
"arrival_time" : "06:22:08" , 
"departure_time" : "06:23:41" , 
"distance_traveled" : 8.6409
}, 
{ 
"stop_id" : 23,
"arrival_time" : "06:25:33" , 
"departure_time" : "06:26:18" , 
"distance_traveled" : 9.5419
}, 
{ 
"stop_id" : 37,
"arrival_time" : "06:26:45" , 
"departure_time" : "06:27:44" , 
"distance_traveled" : 10.0697
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:31:59" , 
"departure_time" : "06:32:15" , 
"distance_traveled" : 12.3174
}, 
{ 
"stop_id" : 63,
"arrival_time" : "06:47:16" , 
"departure_time" : "06:47:16" , 
"distance_traveled" : 20.1057
} ], 
"1831" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "07:55:00" , 
"departure_time" : "07:56:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:59:57" , 
"departure_time" : "08:00:46" , 
"distance_traveled" : 2.268
}, 
{ 
"stop_id" : 87,
"arrival_time" : "08:02:49" , 
"departure_time" : "08:04:26" , 
"distance_traveled" : 3.3424
}, 
{ 
"stop_id" : 81,
"arrival_time" : "08:07:37" , 
"departure_time" : "08:07:49" , 
"distance_traveled" : 4.9511
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:09:12" , 
"departure_time" : "08:09:54" , 
"distance_traveled" : 6.2335
}, 
{ 
"stop_id" : 97,
"arrival_time" : "08:11:42" , 
"departure_time" : "08:12:45" , 
"distance_traveled" : 7.0051
}, 
{ 
"stop_id" : 61,
"arrival_time" : "08:15:03" , 
"departure_time" : "08:16:02" , 
"distance_traveled" : 7.9331
}, 
{ 
"stop_id" : 112,
"arrival_time" : "08:16:59" , 
"departure_time" : "08:17:53" , 
"distance_traveled" : 8.6409
}, 
{ 
"stop_id" : 23,
"arrival_time" : "08:19:54" , 
"departure_time" : "08:21:21" , 
"distance_traveled" : 9.5419
}, 
{ 
"stop_id" : 37,
"arrival_time" : "08:22:27" , 
"departure_time" : "08:23:09" , 
"distance_traveled" : 10.0697
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:26:42" , 
"departure_time" : "08:27:47" , 
"distance_traveled" : 12.3174
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:43:05" , 
"departure_time" : "08:43:05" , 
"distance_traveled" : 20.1057
} ], 
"1832" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "06:02:00" , 
"departure_time" : "06:03:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 136,
"arrival_time" : "06:06:25" , 
"departure_time" : "06:07:50" , 
"distance_traveled" : 2.268
}, 
{ 
"stop_id" : 87,
"arrival_time" : "06:10:25" , 
"departure_time" : "06:10:32" , 
"distance_traveled" : 3.3424
}, 
{ 
"stop_id" : 81,
"arrival_time" : "06:13:07" , 
"departure_time" : "06:14:05" , 
"distance_traveled" : 4.9511
}, 
{ 
"stop_id" : 140,
"arrival_time" : "06:16:58" , 
"departure_time" : "06:17:36" , 
"distance_traveled" : 6.2335
}, 
{ 
"stop_id" : 97,
"arrival_time" : "06:18:38" , 
"departure_time" : "06:20:18" , 
"distance_traveled" : 7.0051
}, 
{ 
"stop_id" : 61,
"arrival_time" : "06:21:40" , 
"departure_time" : "06:22:11" , 
"distance_traveled" : 7.9331
}, 
{ 
"stop_id" : 112,
"arrival_time" : "06:22:31" , 
"departure_time" : "06:23:22" , 
"distance_traveled" : 8.6409
}, 
{ 
"stop_id" : 23,
"arrival_time" : "06:24:51" , 
"departure_time" : "06:25:40" , 
"distance_traveled" : 9.5419
}, 
{ 
"stop_id" : 37,
"arrival_time" : "06:26:49" , 
"departure_time" : "06:27:48" , 
"distance_traveled" : 10.0697
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:31:59" , 
"departure_time" : "06:32:14" , 
"distance_traveled" : 12.3174
}, 
{ 
"stop_id" : 63,
"arrival_time" : "06:47:15" , 
"departure_time" : "06:47:15" , 
"distance_traveled" : 20.1057
} ], 
"1833" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "08:30:00" , 
"departure_time" : "08:30:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 136,
"arrival_time" : "08:34:23" , 
"departure_time" : "08:36:02" , 
"distance_traveled" : 2.268
}, 
{ 
"stop_id" : 87,
"arrival_time" : "08:38:39" , 
"departure_time" : "08:38:55" , 
"distance_traveled" : 3.3424
}, 
{ 
"stop_id" : 81,
"arrival_time" : "08:40:16" , 
"departure_time" : "08:41:27" , 
"distance_traveled" : 4.9511
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:44:11" , 
"departure_time" : "08:44:22" , 
"distance_traveled" : 6.2335
}, 
{ 
"stop_id" : 97,
"arrival_time" : "08:45:11" , 
"departure_time" : "08:46:24" , 
"distance_traveled" : 7.0051
}, 
{ 
"stop_id" : 61,
"arrival_time" : "08:49:13" , 
"departure_time" : "08:50:26" , 
"distance_traveled" : 7.9331
}, 
{ 
"stop_id" : 112,
"arrival_time" : "08:51:13" , 
"departure_time" : "08:51:47" , 
"distance_traveled" : 8.6409
}, 
{ 
"stop_id" : 23,
"arrival_time" : "08:52:34" , 
"departure_time" : "08:53:06" , 
"distance_traveled" : 9.5419
}, 
{ 
"stop_id" : 37,
"arrival_time" : "08:54:32" , 
"departure_time" : "08:54:51" , 
"distance_traveled" : 10.0697
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:59:19" , 
"departure_time" : "09:00:55" , 
"distance_traveled" : 12.3174
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:16:36" , 
"departure_time" : "09:16:36" , 
"distance_traveled" : 20.1057
} ], 
"1834" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "07:55:00" , 
"departure_time" : "07:57:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 136,
"arrival_time" : "08:00:07" , 
"departure_time" : "08:01:33" , 
"distance_traveled" : 2.268
}, 
{ 
"stop_id" : 87,
"arrival_time" : "08:03:26" , 
"departure_time" : "08:04:00" , 
"distance_traveled" : 3.3424
}, 
{ 
"stop_id" : 81,
"arrival_time" : "08:06:34" , 
"departure_time" : "08:07:15" , 
"distance_traveled" : 4.9511
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:09:41" , 
"departure_time" : "08:11:18" , 
"distance_traveled" : 6.2335
}, 
{ 
"stop_id" : 97,
"arrival_time" : "08:12:37" , 
"departure_time" : "08:13:41" , 
"distance_traveled" : 7.0051
}, 
{ 
"stop_id" : 61,
"arrival_time" : "08:15:04" , 
"departure_time" : "08:15:56" , 
"distance_traveled" : 7.9331
}, 
{ 
"stop_id" : 112,
"arrival_time" : "08:16:52" , 
"departure_time" : "08:17:08" , 
"distance_traveled" : 8.6409
}, 
{ 
"stop_id" : 23,
"arrival_time" : "08:19:16" , 
"departure_time" : "08:19:34" , 
"distance_traveled" : 9.5419
}, 
{ 
"stop_id" : 37,
"arrival_time" : "08:21:18" , 
"departure_time" : "08:22:11" , 
"distance_traveled" : 10.0697
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:26:53" , 
"departure_time" : "08:28:08" , 
"distance_traveled" : 12.3174
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:43:15" , 
"departure_time" : "08:43:15" , 
"distance_traveled" : 20.1057
} ], 
"1835" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "17:00:00" , 
"departure_time" : "17:01:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 136,
"arrival_time" : "17:04:31" , 
"departure_time" : "17:05:57" , 
"distance_traveled" : 2.268
}, 
{ 
"stop_id" : 87,
"arrival_time" : "17:08:26" , 
"departure_time" : "17:09:42" , 
"distance_traveled" : 3.3424
}, 
{ 
"stop_id" : 81,
"arrival_time" : "17:11:16" , 
"departure_time" : "17:12:06" , 
"distance_traveled" : 4.9511
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:13:50" , 
"departure_time" : "17:14:43" , 
"distance_traveled" : 6.2335
}, 
{ 
"stop_id" : 97,
"arrival_time" : "17:15:53" , 
"departure_time" : "17:17:12" , 
"distance_traveled" : 7.0051
}, 
{ 
"stop_id" : 61,
"arrival_time" : "17:18:19" , 
"departure_time" : "17:18:23" , 
"distance_traveled" : 7.9331
}, 
{ 
"stop_id" : 112,
"arrival_time" : "17:20:04" , 
"departure_time" : "17:20:10" , 
"distance_traveled" : 8.6409
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:22:06" , 
"departure_time" : "17:22:55" , 
"distance_traveled" : 9.5419
}, 
{ 
"stop_id" : 37,
"arrival_time" : "17:24:49" , 
"departure_time" : "17:25:26" , 
"distance_traveled" : 10.0697
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:29:37" , 
"departure_time" : "17:29:48" , 
"distance_traveled" : 12.3174
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:45:11" , 
"departure_time" : "17:45:11" , 
"distance_traveled" : 20.1057
} ], 
"1836" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "08:30:00" , 
"departure_time" : "08:31:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 136,
"arrival_time" : "08:34:58" , 
"departure_time" : "08:35:18" , 
"distance_traveled" : 2.268
}, 
{ 
"stop_id" : 87,
"arrival_time" : "08:37:20" , 
"departure_time" : "08:38:23" , 
"distance_traveled" : 3.3424
}, 
{ 
"stop_id" : 81,
"arrival_time" : "08:41:03" , 
"departure_time" : "08:41:12" , 
"distance_traveled" : 4.9511
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:43:09" , 
"departure_time" : "08:43:42" , 
"distance_traveled" : 6.2335
}, 
{ 
"stop_id" : 97,
"arrival_time" : "08:45:33" , 
"departure_time" : "08:46:36" , 
"distance_traveled" : 7.0051
}, 
{ 
"stop_id" : 61,
"arrival_time" : "08:49:03" , 
"departure_time" : "08:49:51" , 
"distance_traveled" : 7.9331
}, 
{ 
"stop_id" : 112,
"arrival_time" : "08:50:48" , 
"departure_time" : "08:52:12" , 
"distance_traveled" : 8.6409
}, 
{ 
"stop_id" : 23,
"arrival_time" : "08:53:24" , 
"departure_time" : "08:54:39" , 
"distance_traveled" : 9.5419
}, 
{ 
"stop_id" : 37,
"arrival_time" : "08:55:15" , 
"departure_time" : "08:55:33" , 
"distance_traveled" : 10.0697
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:59:18" , 
"departure_time" : "09:00:24" , 
"distance_traveled" : 12.3174
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:16:06" , 
"departure_time" : "09:16:06" , 
"distance_traveled" : 20.1057
} ], 
"1837" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "18:00:00" , 
"departure_time" : "18:02:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 136,
"arrival_time" : "18:05:29" , 
"departure_time" : "18:06:43" , 
"distance_traveled" : 2.268
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:08:14" , 
"departure_time" : "18:08:46" , 
"distance_traveled" : 3.3424
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:10:32" , 
"departure_time" : "18:12:09" , 
"distance_traveled" : 4.9511
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:14:37" , 
"departure_time" : "18:15:31" , 
"distance_traveled" : 6.2335
}, 
{ 
"stop_id" : 97,
"arrival_time" : "18:15:54" , 
"departure_time" : "18:16:51" , 
"distance_traveled" : 7.0051
}, 
{ 
"stop_id" : 61,
"arrival_time" : "18:17:57" , 
"departure_time" : "18:18:40" , 
"distance_traveled" : 7.9331
}, 
{ 
"stop_id" : 112,
"arrival_time" : "18:20:43" , 
"departure_time" : "18:22:08" , 
"distance_traveled" : 8.6409
}, 
{ 
"stop_id" : 23,
"arrival_time" : "18:23:25" , 
"departure_time" : "18:23:57" , 
"distance_traveled" : 9.5419
}, 
{ 
"stop_id" : 37,
"arrival_time" : "18:24:32" , 
"departure_time" : "18:24:37" , 
"distance_traveled" : 10.0697
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:29:05" , 
"departure_time" : "18:30:04" , 
"distance_traveled" : 12.3174
}, 
{ 
"stop_id" : 63,
"arrival_time" : "18:45:59" , 
"departure_time" : "18:45:59" , 
"distance_traveled" : 20.1057
} ], 
"1838" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "17:00:00" , 
"departure_time" : "17:02:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 136,
"arrival_time" : "17:05:39" , 
"departure_time" : "17:07:01" , 
"distance_traveled" : 2.268
}, 
{ 
"stop_id" : 87,
"arrival_time" : "17:08:22" , 
"departure_time" : "17:09:48" , 
"distance_traveled" : 3.3424
}, 
{ 
"stop_id" : 81,
"arrival_time" : "17:11:26" , 
"departure_time" : "17:12:45" , 
"distance_traveled" : 4.9511
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:14:19" , 
"departure_time" : "17:15:42" , 
"distance_traveled" : 6.2335
}, 
{ 
"stop_id" : 97,
"arrival_time" : "17:16:23" , 
"departure_time" : "17:16:44" , 
"distance_traveled" : 7.0051
}, 
{ 
"stop_id" : 61,
"arrival_time" : "17:17:21" , 
"departure_time" : "17:18:17" , 
"distance_traveled" : 7.9331
}, 
{ 
"stop_id" : 112,
"arrival_time" : "17:20:56" , 
"departure_time" : "17:22:03" , 
"distance_traveled" : 8.6409
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:23:07" , 
"departure_time" : "17:24:21" , 
"distance_traveled" : 9.5419
}, 
{ 
"stop_id" : 37,
"arrival_time" : "17:25:14" , 
"departure_time" : "17:26:07" , 
"distance_traveled" : 10.0697
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:29:53" , 
"departure_time" : "17:30:59" , 
"distance_traveled" : 12.3174
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:46:06" , 
"departure_time" : "17:46:06" , 
"distance_traveled" : 20.1057
} ], 
"1839" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "19:00:00" , 
"departure_time" : "19:02:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 136,
"arrival_time" : "19:05:23" , 
"departure_time" : "19:05:47" , 
"distance_traveled" : 2.268
}, 
{ 
"stop_id" : 87,
"arrival_time" : "19:07:24" , 
"departure_time" : "19:09:02" , 
"distance_traveled" : 3.3424
}, 
{ 
"stop_id" : 81,
"arrival_time" : "19:11:38" , 
"departure_time" : "19:13:09" , 
"distance_traveled" : 4.9511
}, 
{ 
"stop_id" : 140,
"arrival_time" : "19:14:31" , 
"departure_time" : "19:15:42" , 
"distance_traveled" : 6.2335
}, 
{ 
"stop_id" : 97,
"arrival_time" : "19:16:11" , 
"departure_time" : "19:17:14" , 
"distance_traveled" : 7.0051
}, 
{ 
"stop_id" : 61,
"arrival_time" : "19:18:03" , 
"departure_time" : "19:19:08" , 
"distance_traveled" : 7.9331
}, 
{ 
"stop_id" : 112,
"arrival_time" : "19:21:05" , 
"departure_time" : "19:22:23" , 
"distance_traveled" : 8.6409
}, 
{ 
"stop_id" : 23,
"arrival_time" : "19:23:18" , 
"departure_time" : "19:23:36" , 
"distance_traveled" : 9.5419
}, 
{ 
"stop_id" : 37,
"arrival_time" : "19:24:18" , 
"departure_time" : "19:25:38" , 
"distance_traveled" : 10.0697
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:30:20" , 
"departure_time" : "19:31:40" , 
"distance_traveled" : 12.3174
}, 
{ 
"stop_id" : 63,
"arrival_time" : "19:46:20" , 
"departure_time" : "19:46:20" , 
"distance_traveled" : 20.1057
} ], 
"1840" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "18:00:00" , 
"departure_time" : "18:02:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 136,
"arrival_time" : "18:04:58" , 
"departure_time" : "18:05:49" , 
"distance_traveled" : 2.268
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:07:51" , 
"departure_time" : "18:08:40" , 
"distance_traveled" : 3.3424
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:10:49" , 
"departure_time" : "18:11:25" , 
"distance_traveled" : 4.9511
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:13:36" , 
"departure_time" : "18:14:21" , 
"distance_traveled" : 6.2335
}, 
{ 
"stop_id" : 97,
"arrival_time" : "18:15:45" , 
"departure_time" : "18:16:49" , 
"distance_traveled" : 7.0051
}, 
{ 
"stop_id" : 61,
"arrival_time" : "18:18:04" , 
"departure_time" : "18:18:38" , 
"distance_traveled" : 7.9331
}, 
{ 
"stop_id" : 112,
"arrival_time" : "18:20:34" , 
"departure_time" : "18:21:25" , 
"distance_traveled" : 8.6409
}, 
{ 
"stop_id" : 23,
"arrival_time" : "18:22:51" , 
"departure_time" : "18:24:22" , 
"distance_traveled" : 9.5419
}, 
{ 
"stop_id" : 37,
"arrival_time" : "18:25:31" , 
"departure_time" : "18:26:34" , 
"distance_traveled" : 10.0697
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:30:03" , 
"departure_time" : "18:31:35" , 
"distance_traveled" : 12.3174
}, 
{ 
"stop_id" : 63,
"arrival_time" : "18:46:32" , 
"departure_time" : "18:46:32" , 
"distance_traveled" : 20.1057
} ], 
"1841" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "06:40:00" , 
"departure_time" : "06:42:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "06:47:40" , 
"departure_time" : "06:48:36" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "06:50:56" , 
"departure_time" : "06:51:47" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "06:56:51" , 
"departure_time" : "06:57:53" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "07:01:02" , 
"departure_time" : "07:01:39" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "07:04:37" , 
"departure_time" : "07:04:56" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "07:08:19" , 
"departure_time" : "07:08:23" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "07:12:04" , 
"departure_time" : "07:12:11" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:18:07" , 
"departure_time" : "07:19:12" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:23:05" , 
"departure_time" : "07:24:42" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:26:37" , 
"departure_time" : "07:27:12" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:29:35" , 
"departure_time" : "07:31:00" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:33:25" , 
"departure_time" : "07:34:06" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 112,
"arrival_time" : "07:37:41" , 
"departure_time" : "07:38:52" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "07:41:11" , 
"departure_time" : "07:41:49" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:46:38" , 
"departure_time" : "07:47:40" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:58:02" , 
"departure_time" : "07:58:53" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:09:51" , 
"departure_time" : "08:09:51" , 
"distance_traveled" : 43.2223
} ], 
"1842" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "19:00:00" , 
"departure_time" : "19:02:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 136,
"arrival_time" : "19:05:10" , 
"departure_time" : "19:06:31" , 
"distance_traveled" : 2.268
}, 
{ 
"stop_id" : 87,
"arrival_time" : "19:08:21" , 
"departure_time" : "19:08:45" , 
"distance_traveled" : 3.3424
}, 
{ 
"stop_id" : 81,
"arrival_time" : "19:10:24" , 
"departure_time" : "19:11:21" , 
"distance_traveled" : 4.9511
}, 
{ 
"stop_id" : 140,
"arrival_time" : "19:13:57" , 
"departure_time" : "19:15:37" , 
"distance_traveled" : 6.2335
}, 
{ 
"stop_id" : 97,
"arrival_time" : "19:16:40" , 
"departure_time" : "19:17:43" , 
"distance_traveled" : 7.0051
}, 
{ 
"stop_id" : 61,
"arrival_time" : "19:18:03" , 
"departure_time" : "19:18:53" , 
"distance_traveled" : 7.9331
}, 
{ 
"stop_id" : 112,
"arrival_time" : "19:20:50" , 
"departure_time" : "19:21:04" , 
"distance_traveled" : 8.6409
}, 
{ 
"stop_id" : 23,
"arrival_time" : "19:22:14" , 
"departure_time" : "19:22:15" , 
"distance_traveled" : 9.5419
}, 
{ 
"stop_id" : 37,
"arrival_time" : "19:24:01" , 
"departure_time" : "19:25:06" , 
"distance_traveled" : 10.0697
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:30:05" , 
"departure_time" : "19:31:01" , 
"distance_traveled" : 12.3174
}, 
{ 
"stop_id" : 63,
"arrival_time" : "19:45:56" , 
"departure_time" : "19:45:56" , 
"distance_traveled" : 20.1057
} ], 
"1843" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "04:03:00" , 
"departure_time" : "04:04:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "04:10:45" , 
"departure_time" : "04:11:19" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "04:13:34" , 
"departure_time" : "04:14:15" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "04:19:41" , 
"departure_time" : "04:20:19" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "04:23:38" , 
"departure_time" : "04:25:00" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "04:28:22" , 
"departure_time" : "04:28:33" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "04:31:11" , 
"departure_time" : "04:32:36" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "04:36:25" , 
"departure_time" : "04:37:02" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "04:42:37" , 
"departure_time" : "04:42:56" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "04:47:19" , 
"departure_time" : "04:48:04" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "04:50:45" , 
"departure_time" : "04:51:17" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "04:54:32" , 
"departure_time" : "04:54:39" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "04:57:07" , 
"departure_time" : "04:57:29" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 97,
"arrival_time" : "05:00:22" , 
"departure_time" : "05:02:01" , 
"distance_traveled" : 27.4884
}, 
{ 
"stop_id" : 112,
"arrival_time" : "05:05:39" , 
"departure_time" : "05:06:16" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "05:07:37" , 
"departure_time" : "05:08:16" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "05:10:39" , 
"departure_time" : "05:10:47" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "05:16:08" , 
"departure_time" : "05:17:29" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:27:21" , 
"departure_time" : "05:29:00" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "05:40:39" , 
"departure_time" : "05:40:39" , 
"distance_traveled" : 43.2223
} ], 
"1844" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "04:03:00" , 
"departure_time" : "04:05:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "04:10:26" , 
"departure_time" : "04:10:37" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "04:13:11" , 
"departure_time" : "04:13:37" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "04:19:26" , 
"departure_time" : "04:19:36" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "04:23:10" , 
"departure_time" : "04:23:20" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "04:27:10" , 
"departure_time" : "04:27:44" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "04:31:34" , 
"departure_time" : "04:33:12" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "04:36:38" , 
"departure_time" : "04:36:42" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "04:42:04" , 
"departure_time" : "04:43:20" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "04:48:16" , 
"departure_time" : "04:48:54" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "04:50:38" , 
"departure_time" : "04:51:24" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "04:54:46" , 
"departure_time" : "04:55:23" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "04:57:37" , 
"departure_time" : "04:58:27" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 97,
"arrival_time" : "05:00:50" , 
"departure_time" : "05:01:27" , 
"distance_traveled" : 27.4884
}, 
{ 
"stop_id" : 112,
"arrival_time" : "05:04:37" , 
"departure_time" : "05:05:44" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "05:08:07" , 
"departure_time" : "05:08:58" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "05:10:51" , 
"departure_time" : "05:11:25" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "05:16:34" , 
"departure_time" : "05:17:54" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:27:20" , 
"departure_time" : "05:28:35" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "05:40:15" , 
"departure_time" : "05:40:15" , 
"distance_traveled" : 43.2223
} ], 
"1845" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "05:05:00" , 
"departure_time" : "05:06:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "05:12:12" , 
"departure_time" : "05:13:25" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "05:20:13" , 
"departure_time" : "05:21:07" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "05:23:54" , 
"departure_time" : "05:25:24" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "05:28:30" , 
"departure_time" : "05:29:41" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "05:32:11" , 
"departure_time" : "05:32:12" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "05:35:01" , 
"departure_time" : "05:35:05" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "05:42:04" , 
"departure_time" : "05:42:07" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "05:47:03" , 
"departure_time" : "05:47:37" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "05:50:34" , 
"departure_time" : "05:50:53" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "05:54:19" , 
"departure_time" : "05:54:28" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "05:57:09" , 
"departure_time" : "05:57:23" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 61,
"arrival_time" : "06:01:14" , 
"departure_time" : "06:01:54" , 
"distance_traveled" : 28.4163
}, 
{ 
"stop_id" : 112,
"arrival_time" : "06:04:40" , 
"departure_time" : "06:04:49" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "06:07:09" , 
"departure_time" : "06:08:06" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 37,
"arrival_time" : "06:10:57" , 
"departure_time" : "06:10:59" , 
"distance_traveled" : 30.5527
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:16:02" , 
"departure_time" : "06:16:12" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:32:10" , 
"departure_time" : "06:32:28" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:45:18" , 
"departure_time" : "06:45:18" , 
"distance_traveled" : 43.2222
} ], 
"1846" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "07:05:00" , 
"departure_time" : "07:05:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "07:12:13" , 
"departure_time" : "07:13:09" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "07:19:56" , 
"departure_time" : "07:20:31" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "07:23:35" , 
"departure_time" : "07:23:51" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "07:27:16" , 
"departure_time" : "07:28:37" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "07:32:21" , 
"departure_time" : "07:33:07" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "07:35:46" , 
"departure_time" : "07:36:09" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:42:23" , 
"departure_time" : "07:42:40" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:47:17" , 
"departure_time" : "07:47:20" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:50:03" , 
"departure_time" : "07:50:05" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:54:02" , 
"departure_time" : "07:54:48" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:57:46" , 
"departure_time" : "07:59:08" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 61,
"arrival_time" : "08:02:22" , 
"departure_time" : "08:03:49" , 
"distance_traveled" : 28.4163
}, 
{ 
"stop_id" : 112,
"arrival_time" : "08:05:27" , 
"departure_time" : "08:06:56" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "08:08:29" , 
"departure_time" : "08:08:55" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 37,
"arrival_time" : "08:10:26" , 
"departure_time" : "08:10:29" , 
"distance_traveled" : 30.5527
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:16:03" , 
"departure_time" : "08:17:26" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:26:23" , 
"departure_time" : "08:26:48" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:39:25" , 
"departure_time" : "08:39:25" , 
"distance_traveled" : 43.2222
} ], 
"1847" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "13:05:00" , 
"departure_time" : "13:05:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "13:12:28" , 
"departure_time" : "13:12:53" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "13:19:25" , 
"departure_time" : "13:19:45" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "13:23:20" , 
"departure_time" : "13:23:33" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "13:27:13" , 
"departure_time" : "13:27:22" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "13:31:09" , 
"departure_time" : "13:31:44" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "13:35:35" , 
"departure_time" : "13:36:24" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "13:42:49" , 
"departure_time" : "13:43:13" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "13:47:24" , 
"departure_time" : "13:47:58" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "13:50:34" , 
"departure_time" : "13:52:03" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "13:55:29" , 
"departure_time" : "13:56:16" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "13:57:47" , 
"departure_time" : "13:58:15" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 61,
"arrival_time" : "14:01:28" , 
"departure_time" : "14:02:14" , 
"distance_traveled" : 28.4163
}, 
{ 
"stop_id" : 112,
"arrival_time" : "14:04:46" , 
"departure_time" : "14:05:06" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "14:07:20" , 
"departure_time" : "14:08:52" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 37,
"arrival_time" : "14:11:32" , 
"departure_time" : "14:12:34" , 
"distance_traveled" : 30.5527
}, 
{ 
"stop_id" : 106,
"arrival_time" : "14:17:02" , 
"departure_time" : "14:17:09" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:25:07" , 
"departure_time" : "14:26:21" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "14:40:14" , 
"departure_time" : "14:40:14" , 
"distance_traveled" : 43.2222
} ], 
"1848" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "06:40:00" , 
"departure_time" : "06:41:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "06:47:39" , 
"departure_time" : "06:48:50" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "06:51:11" , 
"departure_time" : "06:51:39" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "06:56:28" , 
"departure_time" : "06:57:31" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "07:01:03" , 
"departure_time" : "07:01:22" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "07:04:19" , 
"departure_time" : "07:05:47" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "07:09:28" , 
"departure_time" : "07:10:54" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "07:13:26" , 
"departure_time" : "07:14:18" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:18:52" , 
"departure_time" : "07:20:20" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:23:28" , 
"departure_time" : "07:24:03" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:25:35" , 
"departure_time" : "07:26:18" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:29:43" , 
"departure_time" : "07:30:10" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:32:27" , 
"departure_time" : "07:32:56" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 112,
"arrival_time" : "07:37:29" , 
"departure_time" : "07:38:31" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "07:41:02" , 
"departure_time" : "07:42:15" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:47:13" , 
"departure_time" : "07:47:31" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:57:18" , 
"departure_time" : "07:58:07" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:09:49" , 
"departure_time" : "08:09:49" , 
"distance_traveled" : 43.2223
} ], 
"1849" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "15:05:00" , 
"departure_time" : "15:06:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "15:12:13" , 
"departure_time" : "15:12:49" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "15:19:36" , 
"departure_time" : "15:20:54" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "15:24:18" , 
"departure_time" : "15:25:06" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "15:27:48" , 
"departure_time" : "15:29:11" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "15:32:23" , 
"departure_time" : "15:32:25" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "15:35:02" , 
"departure_time" : "15:35:51" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "15:42:49" , 
"departure_time" : "15:43:24" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "15:47:35" , 
"departure_time" : "15:47:55" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "15:50:20" , 
"departure_time" : "15:50:31" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "15:54:11" , 
"departure_time" : "15:55:46" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "15:58:35" , 
"departure_time" : "15:59:07" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 61,
"arrival_time" : "16:01:32" , 
"departure_time" : "16:02:04" , 
"distance_traveled" : 28.4163
}, 
{ 
"stop_id" : 112,
"arrival_time" : "16:04:32" , 
"departure_time" : "16:06:11" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "16:08:39" , 
"departure_time" : "16:08:49" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 37,
"arrival_time" : "16:10:10" , 
"departure_time" : "16:10:40" , 
"distance_traveled" : 30.5527
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:16:30" , 
"departure_time" : "16:16:38" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:25:08" , 
"departure_time" : "16:26:39" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "16:40:31" , 
"departure_time" : "16:40:31" , 
"distance_traveled" : 43.2222
} ], 
"1850" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "19:05:00" , 
"departure_time" : "19:07:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "19:13:22" , 
"departure_time" : "19:14:00" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "19:19:38" , 
"departure_time" : "19:21:11" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "19:24:33" , 
"departure_time" : "19:25:38" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "19:28:05" , 
"departure_time" : "19:29:09" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "19:32:04" , 
"departure_time" : "19:32:57" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "19:35:53" , 
"departure_time" : "19:35:57" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "19:42:04" , 
"departure_time" : "19:43:18" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "19:48:14" , 
"departure_time" : "19:48:51" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "19:50:37" , 
"departure_time" : "19:51:18" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "19:54:41" , 
"departure_time" : "19:55:27" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "19:57:46" , 
"departure_time" : "19:57:49" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 61,
"arrival_time" : "20:01:03" , 
"departure_time" : "20:01:10" , 
"distance_traveled" : 28.4163
}, 
{ 
"stop_id" : 112,
"arrival_time" : "20:04:07" , 
"departure_time" : "20:05:18" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "20:08:11" , 
"departure_time" : "20:08:27" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 37,
"arrival_time" : "20:10:16" , 
"departure_time" : "20:10:20" , 
"distance_traveled" : 30.5527
}, 
{ 
"stop_id" : 106,
"arrival_time" : "20:16:04" , 
"departure_time" : "20:16:36" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:27:32" , 
"departure_time" : "20:29:11" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "20:41:39" , 
"departure_time" : "20:41:39" , 
"distance_traveled" : 43.2222
} ], 
"1851" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "05:05:00" , 
"departure_time" : "05:07:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "05:12:40" , 
"departure_time" : "05:13:30" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "05:19:50" , 
"departure_time" : "05:21:25" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "05:24:35" , 
"departure_time" : "05:24:38" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "05:27:03" , 
"departure_time" : "05:28:29" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "05:32:26" , 
"departure_time" : "05:33:30" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "05:36:04" , 
"departure_time" : "05:36:53" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "05:42:49" , 
"departure_time" : "05:44:22" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "05:48:33" , 
"departure_time" : "05:49:59" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "05:51:26" , 
"departure_time" : "05:51:46" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "05:54:20" , 
"departure_time" : "05:55:48" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "05:58:28" , 
"departure_time" : "05:58:43" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 61,
"arrival_time" : "06:01:15" , 
"departure_time" : "06:01:31" , 
"distance_traveled" : 28.4163
}, 
{ 
"stop_id" : 112,
"arrival_time" : "06:04:16" , 
"departure_time" : "06:04:42" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "06:07:26" , 
"departure_time" : "06:08:15" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 37,
"arrival_time" : "06:10:49" , 
"departure_time" : "06:11:02" , 
"distance_traveled" : 30.5527
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:16:13" , 
"departure_time" : "06:17:41" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:33:28" , 
"departure_time" : "06:35:07" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:46:39" , 
"departure_time" : "06:46:39" , 
"distance_traveled" : 43.2222
} ], 
"1852" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "21:05:00" , 
"departure_time" : "21:07:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "21:12:23" , 
"departure_time" : "21:13:23" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "21:20:00" , 
"departure_time" : "21:21:25" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "21:24:25" , 
"departure_time" : "21:24:34" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "21:27:09" , 
"departure_time" : "21:27:39" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "21:31:30" , 
"departure_time" : "21:32:24" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "21:35:54" , 
"departure_time" : "21:36:13" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "21:42:19" , 
"departure_time" : "21:43:40" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "21:48:21" , 
"departure_time" : "21:48:53" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "21:50:32" , 
"departure_time" : "21:50:59" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "21:54:27" , 
"departure_time" : "21:55:31" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "21:58:04" , 
"departure_time" : "21:59:01" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 61,
"arrival_time" : "22:01:57" , 
"departure_time" : "22:02:09" , 
"distance_traveled" : 28.4163
}, 
{ 
"stop_id" : 112,
"arrival_time" : "22:04:12" , 
"departure_time" : "22:04:29" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "22:07:17" , 
"departure_time" : "22:08:35" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 37,
"arrival_time" : "22:11:18" , 
"departure_time" : "22:12:42" , 
"distance_traveled" : 30.5527
}, 
{ 
"stop_id" : 106,
"arrival_time" : "22:17:24" , 
"departure_time" : "22:18:55" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:26:31" , 
"departure_time" : "22:27:43" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "22:40:12" , 
"departure_time" : "22:40:12" , 
"distance_traveled" : 43.2222
} ], 
"1853" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "07:05:00" , 
"departure_time" : "07:06:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "07:12:32" , 
"departure_time" : "07:12:38" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "07:19:06" , 
"departure_time" : "07:20:20" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "07:24:14" , 
"departure_time" : "07:25:08" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "07:27:54" , 
"departure_time" : "07:29:32" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "07:32:38" , 
"departure_time" : "07:33:46" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "07:36:08" , 
"departure_time" : "07:36:59" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:42:51" , 
"departure_time" : "07:43:04" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:47:13" , 
"departure_time" : "07:48:42" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:51:29" , 
"departure_time" : "07:51:35" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:54:06" , 
"departure_time" : "07:54:42" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:57:36" , 
"departure_time" : "07:57:59" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 61,
"arrival_time" : "08:01:23" , 
"departure_time" : "08:02:02" , 
"distance_traveled" : 28.4163
}, 
{ 
"stop_id" : 112,
"arrival_time" : "08:04:39" , 
"departure_time" : "08:04:56" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "08:07:17" , 
"departure_time" : "08:08:45" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 37,
"arrival_time" : "08:11:28" , 
"departure_time" : "08:12:03" , 
"distance_traveled" : 30.5527
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:16:35" , 
"departure_time" : "08:17:36" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:26:01" , 
"departure_time" : "08:27:04" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:40:03" , 
"departure_time" : "08:40:03" , 
"distance_traveled" : 43.2222
} ], 
"1854" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "12:05:00" , 
"departure_time" : "12:06:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "12:12:37" , 
"departure_time" : "12:12:51" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "12:19:14" , 
"departure_time" : "12:19:49" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "12:23:35" , 
"departure_time" : "12:24:41" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "12:28:06" , 
"departure_time" : "12:28:31" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "12:31:25" , 
"departure_time" : "12:32:59" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "12:36:34" , 
"departure_time" : "12:37:05" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "12:42:31" , 
"departure_time" : "12:44:05" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "12:48:34" , 
"departure_time" : "12:50:08" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "12:51:34" , 
"departure_time" : "12:52:48" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "12:55:14" , 
"departure_time" : "12:55:35" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "12:57:21" , 
"departure_time" : "12:58:52" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 97,
"arrival_time" : "13:01:31" , 
"departure_time" : "13:02:31" , 
"distance_traveled" : 27.4883
}, 
{ 
"stop_id" : 112,
"arrival_time" : "13:05:00" , 
"departure_time" : "13:06:08" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "13:08:08" , 
"departure_time" : "13:08:37" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 37,
"arrival_time" : "13:10:29" , 
"departure_time" : "13:11:08" , 
"distance_traveled" : 30.5527
}, 
{ 
"stop_id" : 106,
"arrival_time" : "13:16:39" , 
"departure_time" : "13:17:53" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:28:14" , 
"departure_time" : "13:29:11" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "13:41:57" , 
"departure_time" : "13:41:57" , 
"distance_traveled" : 43.2222
} ], 
"1855" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "13:05:00" , 
"departure_time" : "13:05:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "13:12:01" , 
"departure_time" : "13:13:16" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "13:20:15" , 
"departure_time" : "13:21:55" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "13:24:40" , 
"departure_time" : "13:24:42" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "13:27:02" , 
"departure_time" : "13:28:06" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "13:32:04" , 
"departure_time" : "13:33:42" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "13:36:38" , 
"departure_time" : "13:37:04" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "13:42:26" , 
"departure_time" : "13:42:47" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "13:47:21" , 
"departure_time" : "13:48:06" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "13:50:45" , 
"departure_time" : "13:50:53" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "13:54:08" , 
"departure_time" : "13:54:54" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "13:57:46" , 
"departure_time" : "13:59:22" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 61,
"arrival_time" : "14:02:36" , 
"departure_time" : "14:03:14" , 
"distance_traveled" : 28.4163
}, 
{ 
"stop_id" : 112,
"arrival_time" : "14:04:38" , 
"departure_time" : "14:04:52" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "14:07:14" , 
"departure_time" : "14:08:28" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 37,
"arrival_time" : "14:11:14" , 
"departure_time" : "14:12:18" , 
"distance_traveled" : 30.5527
}, 
{ 
"stop_id" : 106,
"arrival_time" : "14:17:04" , 
"departure_time" : "14:17:06" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:25:02" , 
"departure_time" : "14:25:59" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "14:39:57" , 
"departure_time" : "14:39:57" , 
"distance_traveled" : 43.2222
} ], 
"1856" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "16:05:00" , 
"departure_time" : "16:06:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "16:12:04" , 
"departure_time" : "16:13:37" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "16:20:33" , 
"departure_time" : "16:22:00" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "16:24:27" , 
"departure_time" : "16:26:07" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "16:28:40" , 
"departure_time" : "16:29:39" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "16:31:59" , 
"departure_time" : "16:32:36" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "16:35:37" , 
"departure_time" : "16:36:21" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:42:44" , 
"departure_time" : "16:44:19" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "16:48:35" , 
"departure_time" : "16:49:26" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "16:50:51" , 
"departure_time" : "16:51:43" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "16:54:52" , 
"departure_time" : "16:55:30" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "16:57:38" , 
"departure_time" : "16:58:32" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 97,
"arrival_time" : "17:00:54" , 
"departure_time" : "17:02:17" , 
"distance_traveled" : 27.4883
}, 
{ 
"stop_id" : 112,
"arrival_time" : "17:05:23" , 
"departure_time" : "17:06:36" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:08:13" , 
"departure_time" : "17:09:13" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 37,
"arrival_time" : "17:11:00" , 
"departure_time" : "17:12:32" , 
"distance_traveled" : 30.5527
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:17:32" , 
"departure_time" : "17:17:45" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:25:13" , 
"departure_time" : "17:26:19" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "17:42:06" , 
"departure_time" : "17:42:06" , 
"distance_traveled" : 43.2222
} ], 
"1857" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "15:05:00" , 
"departure_time" : "15:06:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "15:12:10" , 
"departure_time" : "15:13:41" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "15:20:31" , 
"departure_time" : "15:20:36" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "15:23:05" , 
"departure_time" : "15:23:36" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "15:27:31" , 
"departure_time" : "15:28:09" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "15:31:38" , 
"departure_time" : "15:33:04" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "15:36:26" , 
"departure_time" : "15:37:46" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "15:43:20" , 
"departure_time" : "15:43:28" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "15:47:08" , 
"departure_time" : "15:48:03" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "15:50:55" , 
"departure_time" : "15:51:10" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "15:54:15" , 
"departure_time" : "15:55:49" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "15:58:34" , 
"departure_time" : "15:58:53" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 61,
"arrival_time" : "16:01:19" , 
"departure_time" : "16:02:52" , 
"distance_traveled" : 28.4163
}, 
{ 
"stop_id" : 112,
"arrival_time" : "16:05:33" , 
"departure_time" : "16:06:34" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "16:08:01" , 
"departure_time" : "16:08:21" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 37,
"arrival_time" : "16:10:20" , 
"departure_time" : "16:10:55" , 
"distance_traveled" : 30.5527
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:16:35" , 
"departure_time" : "16:16:59" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:25:24" , 
"departure_time" : "16:26:27" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "16:40:03" , 
"departure_time" : "16:40:03" , 
"distance_traveled" : 43.2222
} ], 
"1858" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "18:05:00" , 
"departure_time" : "18:07:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "18:13:21" , 
"departure_time" : "18:14:43" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "18:20:22" , 
"departure_time" : "18:21:38" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "18:24:16" , 
"departure_time" : "18:25:35" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "18:28:19" , 
"departure_time" : "18:29:45" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "18:32:26" , 
"departure_time" : "18:33:01" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "18:35:35" , 
"departure_time" : "18:37:13" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:43:38" , 
"departure_time" : "18:44:30" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "18:47:52" , 
"departure_time" : "18:48:39" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:50:47" , 
"departure_time" : "18:51:19" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:54:32" , 
"departure_time" : "18:54:38" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:57:06" , 
"departure_time" : "18:57:51" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 97,
"arrival_time" : "19:00:45" , 
"departure_time" : "19:01:53" , 
"distance_traveled" : 27.4883
}, 
{ 
"stop_id" : 112,
"arrival_time" : "19:05:08" , 
"departure_time" : "19:06:47" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "19:08:39" , 
"departure_time" : "19:09:58" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 37,
"arrival_time" : "19:11:19" , 
"departure_time" : "19:11:30" , 
"distance_traveled" : 30.5527
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:16:11" , 
"departure_time" : "19:16:38" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:27:27" , 
"departure_time" : "19:28:23" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "19:41:56" , 
"departure_time" : "19:41:56" , 
"distance_traveled" : 43.2222
} ], 
"1859" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "19:05:00" , 
"departure_time" : "19:06:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "19:12:38" , 
"departure_time" : "19:13:49" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "19:20:11" , 
"departure_time" : "19:21:42" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "19:24:31" , 
"departure_time" : "19:25:55" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "19:28:24" , 
"departure_time" : "19:29:14" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "19:31:50" , 
"departure_time" : "19:32:57" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "19:36:07" , 
"departure_time" : "19:37:33" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "19:43:26" , 
"departure_time" : "19:43:55" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "19:47:29" , 
"departure_time" : "19:48:12" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "19:50:43" , 
"departure_time" : "19:52:10" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "19:55:27" , 
"departure_time" : "19:55:32" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "19:57:05" , 
"departure_time" : "19:57:18" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 61,
"arrival_time" : "20:01:13" , 
"departure_time" : "20:02:39" , 
"distance_traveled" : 28.4163
}, 
{ 
"stop_id" : 112,
"arrival_time" : "20:05:26" , 
"departure_time" : "20:05:38" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "20:07:12" , 
"departure_time" : "20:08:23" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 37,
"arrival_time" : "20:11:11" , 
"departure_time" : "20:12:39" , 
"distance_traveled" : 30.5527
}, 
{ 
"stop_id" : 106,
"arrival_time" : "20:17:28" , 
"departure_time" : "20:18:46" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:28:18" , 
"departure_time" : "20:28:31" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "20:40:13" , 
"departure_time" : "20:40:13" , 
"distance_traveled" : 43.2222
} ], 
"1860" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "22:05:00" , 
"departure_time" : "22:05:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "22:12:18" , 
"departure_time" : "22:12:23" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "22:19:05" , 
"departure_time" : "22:19:51" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "22:23:46" , 
"departure_time" : "22:23:59" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "22:27:13" , 
"departure_time" : "22:27:54" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "22:31:41" , 
"departure_time" : "22:32:38" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "22:35:57" , 
"departure_time" : "22:37:01" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "22:43:04" , 
"departure_time" : "22:44:26" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "22:48:22" , 
"departure_time" : "22:49:53" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "22:51:31" , 
"departure_time" : "22:52:14" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "22:54:43" , 
"departure_time" : "22:54:46" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "22:57:03" , 
"departure_time" : "22:58:43" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 97,
"arrival_time" : "23:01:40" , 
"departure_time" : "23:03:04" , 
"distance_traveled" : 27.4883
}, 
{ 
"stop_id" : 112,
"arrival_time" : "23:05:24" , 
"departure_time" : "23:06:57" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "23:08:33" , 
"departure_time" : "23:10:01" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 37,
"arrival_time" : "23:11:28" , 
"departure_time" : "23:11:46" , 
"distance_traveled" : 30.5527
}, 
{ 
"stop_id" : 106,
"arrival_time" : "23:16:18" , 
"departure_time" : "23:17:03" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:25:45" , 
"departure_time" : "23:27:15" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "23:40:30" , 
"departure_time" : "23:40:30" , 
"distance_traveled" : 43.2222
} ], 
"1861" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "21:05:00" , 
"departure_time" : "21:07:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "21:12:32" , 
"departure_time" : "21:13:20" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "21:19:48" , 
"departure_time" : "21:21:28" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "21:24:40" , 
"departure_time" : "21:25:52" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "21:28:12" , 
"departure_time" : "21:28:47" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "21:31:35" , 
"departure_time" : "21:32:36" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "21:36:01" , 
"departure_time" : "21:37:25" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "21:43:24" , 
"departure_time" : "21:44:15" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "21:47:51" , 
"departure_time" : "21:48:54" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "21:51:03" , 
"departure_time" : "21:51:28" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "21:54:25" , 
"departure_time" : "21:55:29" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "21:58:04" , 
"departure_time" : "21:58:31" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 61,
"arrival_time" : "22:01:27" , 
"departure_time" : "22:01:33" , 
"distance_traveled" : 28.4163
}, 
{ 
"stop_id" : 112,
"arrival_time" : "22:04:06" , 
"departure_time" : "22:04:56" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "22:07:50" , 
"departure_time" : "22:09:02" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 37,
"arrival_time" : "22:11:12" , 
"departure_time" : "22:12:05" , 
"distance_traveled" : 30.5527
}, 
{ 
"stop_id" : 106,
"arrival_time" : "22:16:53" , 
"departure_time" : "22:17:12" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:25:19" , 
"departure_time" : "22:25:59" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "22:39:40" , 
"departure_time" : "22:39:40" , 
"distance_traveled" : 43.2222
} ], 
"1862" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "09:03:00" , 
"departure_time" : "09:04:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "09:10:45" , 
"departure_time" : "09:11:19" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "09:13:34" , 
"departure_time" : "09:14:35" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "09:20:01" , 
"departure_time" : "09:20:30" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "09:23:29" , 
"departure_time" : "09:24:09" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "09:27:40" , 
"departure_time" : "09:27:47" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "09:31:07" , 
"departure_time" : "09:31:32" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "09:35:25" , 
"departure_time" : "09:36:02" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "09:42:37" , 
"departure_time" : "09:44:01" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "09:48:24" , 
"departure_time" : "09:50:04" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "09:51:40" , 
"departure_time" : "09:51:42" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "09:54:02" , 
"departure_time" : "09:54:51" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "09:57:49" , 
"departure_time" : "09:58:49" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 61,
"arrival_time" : "10:02:00" , 
"departure_time" : "10:02:35" , 
"distance_traveled" : 28.4165
}, 
{ 
"stop_id" : 112,
"arrival_time" : "10:04:35" , 
"departure_time" : "10:05:40" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "10:08:05" , 
"departure_time" : "10:08:26" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "10:10:21" , 
"departure_time" : "10:11:52" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "10:17:31" , 
"departure_time" : "10:18:11" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:25:40" , 
"departure_time" : "10:26:17" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:38:37" , 
"departure_time" : "10:38:37" , 
"distance_traveled" : 43.2223
} ], 
"1863" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "12:05:00" , 
"departure_time" : "12:05:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "12:12:05" , 
"departure_time" : "12:13:27" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "12:20:22" , 
"departure_time" : "12:21:50" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "12:24:28" , 
"departure_time" : "12:25:41" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "12:28:13" , 
"departure_time" : "12:28:27" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "12:31:14" , 
"departure_time" : "12:31:24" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "12:35:10" , 
"departure_time" : "12:36:12" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "12:43:02" , 
"departure_time" : "12:44:40" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "12:48:38" , 
"departure_time" : "12:49:43" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "12:51:05" , 
"departure_time" : "12:52:35" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "12:55:30" , 
"departure_time" : "12:57:07" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "12:58:37" , 
"departure_time" : "13:00:13" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 97,
"arrival_time" : "13:01:36" , 
"departure_time" : "13:02:41" , 
"distance_traveled" : 27.4883
}, 
{ 
"stop_id" : 112,
"arrival_time" : "13:05:05" , 
"departure_time" : "13:05:30" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "13:07:25" , 
"departure_time" : "13:08:13" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 37,
"arrival_time" : "13:10:48" , 
"departure_time" : "13:12:25" , 
"distance_traveled" : 30.5527
}, 
{ 
"stop_id" : 106,
"arrival_time" : "13:17:37" , 
"departure_time" : "13:17:48" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:27:11" , 
"departure_time" : "13:28:20" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "13:42:09" , 
"departure_time" : "13:42:09" , 
"distance_traveled" : 43.2222
} ], 
"1864" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "11:03:00" , 
"departure_time" : "11:04:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "11:10:40" , 
"departure_time" : "11:10:53" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "11:13:13" , 
"departure_time" : "11:14:26" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "11:20:13" , 
"departure_time" : "11:21:50" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "11:24:37" , 
"departure_time" : "11:25:47" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "11:28:10" , 
"departure_time" : "11:28:23" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "11:31:13" , 
"departure_time" : "11:32:45" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "11:36:32" , 
"departure_time" : "11:38:02" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "11:43:30" , 
"departure_time" : "11:44:10" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "11:47:40" , 
"departure_time" : "11:47:46" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "11:50:06" , 
"departure_time" : "11:51:25" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "11:55:19" , 
"departure_time" : "11:56:53" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "11:58:34" , 
"departure_time" : "12:00:11" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 61,
"arrival_time" : "12:02:37" , 
"departure_time" : "12:04:07" , 
"distance_traveled" : 28.4165
}, 
{ 
"stop_id" : 112,
"arrival_time" : "12:05:30" , 
"departure_time" : "12:05:55" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "12:07:25" , 
"departure_time" : "12:08:07" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "12:10:42" , 
"departure_time" : "12:11:35" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "12:16:53" , 
"departure_time" : "12:17:01" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:25:08" , 
"departure_time" : "12:25:12" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "12:40:04" , 
"departure_time" : "12:40:04" , 
"distance_traveled" : 43.2223
} ], 
"1865" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "16:05:00" , 
"departure_time" : "16:05:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "16:12:35" , 
"departure_time" : "16:13:22" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "16:19:47" , 
"departure_time" : "16:20:05" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "16:23:18" , 
"departure_time" : "16:24:02" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "16:27:44" , 
"departure_time" : "16:28:56" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "16:32:12" , 
"departure_time" : "16:33:34" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "16:36:22" , 
"departure_time" : "16:37:59" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:43:37" , 
"departure_time" : "16:44:07" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "16:47:30" , 
"departure_time" : "16:47:55" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "16:50:25" , 
"departure_time" : "16:50:55" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "16:54:30" , 
"departure_time" : "16:55:52" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "16:58:22" , 
"departure_time" : "16:59:08" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 97,
"arrival_time" : "17:00:46" , 
"departure_time" : "17:02:21" , 
"distance_traveled" : 27.4883
}, 
{ 
"stop_id" : 112,
"arrival_time" : "17:05:35" , 
"departure_time" : "17:06:58" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:08:23" , 
"departure_time" : "17:09:59" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 37,
"arrival_time" : "17:11:36" , 
"departure_time" : "17:12:09" , 
"distance_traveled" : 30.5527
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:16:33" , 
"departure_time" : "17:17:14" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:25:41" , 
"departure_time" : "17:26:25" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "17:41:44" , 
"departure_time" : "17:41:44" , 
"distance_traveled" : 43.2222
} ], 
"1866" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "17:03:00" , 
"departure_time" : "17:04:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "17:10:17" , 
"departure_time" : "17:11:13" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "17:13:56" , 
"departure_time" : "17:14:34" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "17:19:38" , 
"departure_time" : "17:21:10" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "17:24:32" , 
"departure_time" : "17:25:59" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "17:28:27" , 
"departure_time" : "17:29:22" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "17:31:55" , 
"departure_time" : "17:32:14" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "17:35:19" , 
"departure_time" : "17:36:25" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:43:06" , 
"departure_time" : "17:43:23" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "17:47:17" , 
"departure_time" : "17:47:55" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "17:50:38" , 
"departure_time" : "17:52:11" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "17:55:33" , 
"departure_time" : "17:55:59" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:57:26" , 
"departure_time" : "17:57:54" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 61,
"arrival_time" : "18:01:28" , 
"departure_time" : "18:02:08" , 
"distance_traveled" : 28.4165
}, 
{ 
"stop_id" : 112,
"arrival_time" : "18:04:40" , 
"departure_time" : "18:05:16" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "18:07:36" , 
"departure_time" : "18:08:52" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "18:11:16" , 
"departure_time" : "18:11:59" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:16:43" , 
"departure_time" : "18:17:56" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:28:13" , 
"departure_time" : "18:28:39" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:41:26" , 
"departure_time" : "18:41:26" , 
"distance_traveled" : 43.2223
} ], 
"1867" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "18:05:00" , 
"departure_time" : "18:06:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "18:13:15" , 
"departure_time" : "18:13:18" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "18:19:03" , 
"departure_time" : "18:19:16" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "18:23:13" , 
"departure_time" : "18:23:45" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "18:27:32" , 
"departure_time" : "18:28:11" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "18:31:39" , 
"departure_time" : "18:33:14" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "18:36:35" , 
"departure_time" : "18:36:44" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:42:09" , 
"departure_time" : "18:42:10" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "18:47:01" , 
"departure_time" : "18:47:05" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:50:04" , 
"departure_time" : "18:51:13" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:55:09" , 
"departure_time" : "18:55:59" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:57:50" , 
"departure_time" : "18:58:46" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 97,
"arrival_time" : "19:00:56" , 
"departure_time" : "19:02:21" , 
"distance_traveled" : 27.4883
}, 
{ 
"stop_id" : 112,
"arrival_time" : "19:05:25" , 
"departure_time" : "19:06:19" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "19:07:54" , 
"departure_time" : "19:08:24" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 37,
"arrival_time" : "19:10:30" , 
"departure_time" : "19:10:35" , 
"distance_traveled" : 30.5527
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:16:05" , 
"departure_time" : "19:16:51" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:27:46" , 
"departure_time" : "19:29:14" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "19:42:28" , 
"departure_time" : "19:42:28" , 
"distance_traveled" : 43.2222
} ], 
"1868" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "23:03:00" , 
"departure_time" : "23:05:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "23:11:22" , 
"departure_time" : "23:12:52" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "23:14:30" , 
"departure_time" : "23:15:40" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "23:20:10" , 
"departure_time" : "23:20:50" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "23:23:40" , 
"departure_time" : "23:24:06" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "23:27:26" , 
"departure_time" : "23:28:04" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "23:31:38" , 
"departure_time" : "23:33:01" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "23:36:23" , 
"departure_time" : "23:37:30" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "23:43:07" , 
"departure_time" : "23:43:46" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "23:47:39" , 
"departure_time" : "23:48:30" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "23:50:51" , 
"departure_time" : "23:52:02" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "23:55:11" , 
"departure_time" : "23:55:37" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "23:57:26" , 
"departure_time" : "23:58:02" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 61,
"arrival_time" : "24:01:36" , 
"departure_time" : "24:02:41" , 
"distance_traveled" : 28.4165
}, 
{ 
"stop_id" : 112,
"arrival_time" : "24:05:05" , 
"departure_time" : "24:05:20" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "24:07:15" , 
"departure_time" : "24:07:47" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "24:10:32" , 
"departure_time" : "24:10:59" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "24:16:27" , 
"departure_time" : "24:17:16" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:25:49" , 
"departure_time" : "24:27:28" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "24:40:39" , 
"departure_time" : "24:40:39" , 
"distance_traveled" : 43.2223
} ], 
"1869" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "22:05:00" , 
"departure_time" : "22:08:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "22:13:29" , 
"departure_time" : "22:13:40" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "22:19:11" , 
"departure_time" : "22:20:44" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "22:24:33" , 
"departure_time" : "22:25:49" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "22:28:16" , 
"departure_time" : "22:29:12" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "22:31:56" , 
"departure_time" : "22:32:20" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "22:35:24" , 
"departure_time" : "22:35:28" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "22:42:04" , 
"departure_time" : "22:43:38" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "22:48:34" , 
"departure_time" : "22:49:43" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "22:51:09" , 
"departure_time" : "22:51:50" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "22:54:41" , 
"departure_time" : "22:54:56" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "22:57:15" , 
"departure_time" : "22:57:42" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 97,
"arrival_time" : "23:00:27" , 
"departure_time" : "23:01:46" , 
"distance_traveled" : 27.4883
}, 
{ 
"stop_id" : 112,
"arrival_time" : "23:05:19" , 
"departure_time" : "23:06:46" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "23:08:27" , 
"departure_time" : "23:09:47" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 37,
"arrival_time" : "23:11:20" , 
"departure_time" : "23:12:43" , 
"distance_traveled" : 30.5527
}, 
{ 
"stop_id" : 106,
"arrival_time" : "23:17:23" , 
"departure_time" : "23:18:06" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:25:43" , 
"departure_time" : "23:26:58" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "23:40:15" , 
"departure_time" : "23:40:15" , 
"distance_traveled" : 43.2222
} ], 
"1870" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "06:04:00" , 
"departure_time" : "06:06:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "06:11:56" , 
"departure_time" : "06:12:29" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "06:13:33" , 
"departure_time" : "06:14:19" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "06:19:46" , 
"departure_time" : "06:21:25" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "06:24:39" , 
"departure_time" : "06:25:47" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "06:28:08" , 
"departure_time" : "06:29:39" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "06:32:31" , 
"departure_time" : "06:32:42" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "06:35:11" , 
"departure_time" : "06:36:23" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "06:43:12" , 
"departure_time" : "06:43:35" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "06:47:23" , 
"departure_time" : "06:49:03" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "06:51:40" , 
"departure_time" : "06:52:21" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "06:54:41" , 
"departure_time" : "06:54:58" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "06:57:17" , 
"departure_time" : "06:58:43" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 97,
"arrival_time" : "07:01:26" , 
"departure_time" : "07:02:25" , 
"distance_traveled" : 27.4884
}, 
{ 
"stop_id" : 112,
"arrival_time" : "07:04:59" , 
"departure_time" : "07:06:15" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "07:08:16" , 
"departure_time" : "07:08:33" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "07:10:17" , 
"departure_time" : "07:10:36" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:16:19" , 
"departure_time" : "07:17:18" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:25:59" , 
"departure_time" : "07:27:02" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:40:03" , 
"departure_time" : "07:40:03" , 
"distance_traveled" : 43.2223
} ], 
"1871" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "09:03:00" , 
"departure_time" : "09:04:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "09:10:14" , 
"departure_time" : "09:10:21" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "09:13:07" , 
"departure_time" : "09:14:22" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "09:20:15" , 
"departure_time" : "09:20:21" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "09:23:06" , 
"departure_time" : "09:24:13" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "09:28:07" , 
"departure_time" : "09:28:59" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "09:31:52" , 
"departure_time" : "09:33:15" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "09:36:23" , 
"departure_time" : "09:36:55" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "09:42:32" , 
"departure_time" : "09:42:57" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "09:47:25" , 
"departure_time" : "09:47:56" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "09:50:31" , 
"departure_time" : "09:51:15" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "09:54:44" , 
"departure_time" : "09:55:51" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "09:58:07" , 
"departure_time" : "09:59:19" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 61,
"arrival_time" : "10:02:12" , 
"departure_time" : "10:03:49" , 
"distance_traveled" : 28.4165
}, 
{ 
"stop_id" : 112,
"arrival_time" : "10:05:37" , 
"departure_time" : "10:06:22" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "10:07:45" , 
"departure_time" : "10:09:17" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "10:11:32" , 
"departure_time" : "10:12:08" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "10:16:36" , 
"departure_time" : "10:18:08" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:26:32" , 
"departure_time" : "10:28:02" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:39:30" , 
"departure_time" : "10:39:30" , 
"distance_traveled" : 43.2223
} ], 
"1872" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "08:03:00" , 
"departure_time" : "08:04:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "08:10:04" , 
"departure_time" : "08:10:21" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "08:13:17" , 
"departure_time" : "08:14:55" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "08:20:38" , 
"departure_time" : "08:21:02" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "08:23:24" , 
"departure_time" : "08:23:56" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "08:27:32" , 
"departure_time" : "08:28:15" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "08:31:43" , 
"departure_time" : "08:32:22" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "08:35:39" , 
"departure_time" : "08:35:54" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "08:42:15" , 
"departure_time" : "08:42:22" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "08:47:07" , 
"departure_time" : "08:48:44" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "08:51:37" , 
"departure_time" : "08:51:45" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "08:54:08" , 
"departure_time" : "08:54:31" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:57:23" , 
"departure_time" : "08:57:52" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 97,
"arrival_time" : "09:00:29" , 
"departure_time" : "09:00:34" , 
"distance_traveled" : 27.4884
}, 
{ 
"stop_id" : 112,
"arrival_time" : "09:04:05" , 
"departure_time" : "09:04:37" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "09:07:32" , 
"departure_time" : "09:08:31" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "09:10:59" , 
"departure_time" : "09:11:52" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:16:53" , 
"departure_time" : "09:17:38" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:25:45" , 
"departure_time" : "09:26:37" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:39:52" , 
"departure_time" : "09:39:52" , 
"distance_traveled" : 43.2223
} ], 
"1873" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "11:03:00" , 
"departure_time" : "11:05:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "11:11:34" , 
"departure_time" : "11:11:54" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "11:13:20" , 
"departure_time" : "11:13:33" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "11:19:13" , 
"departure_time" : "11:19:25" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "11:23:12" , 
"departure_time" : "11:23:23" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "11:27:11" , 
"departure_time" : "11:28:45" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "11:32:34" , 
"departure_time" : "11:33:04" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "11:35:30" , 
"departure_time" : "11:36:55" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "11:43:25" , 
"departure_time" : "11:43:57" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "11:47:32" , 
"departure_time" : "11:48:05" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "11:50:33" , 
"departure_time" : "11:50:39" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "11:54:06" , 
"departure_time" : "11:54:39" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "11:57:33" , 
"departure_time" : "11:58:20" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 61,
"arrival_time" : "12:01:47" , 
"departure_time" : "12:02:18" , 
"distance_traveled" : 28.4165
}, 
{ 
"stop_id" : 112,
"arrival_time" : "12:04:31" , 
"departure_time" : "12:06:04" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "12:08:33" , 
"departure_time" : "12:08:34" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "12:10:01" , 
"departure_time" : "12:10:31" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "12:16:30" , 
"departure_time" : "12:17:57" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:26:27" , 
"departure_time" : "12:28:01" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "12:41:34" , 
"departure_time" : "12:41:34" , 
"distance_traveled" : 43.2223
} ], 
"1874" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "10:03:00" , 
"departure_time" : "10:04:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "10:10:09" , 
"departure_time" : "10:10:51" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "10:13:42" , 
"departure_time" : "10:13:53" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "10:19:11" , 
"departure_time" : "10:19:46" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "10:23:35" , 
"departure_time" : "10:24:51" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "10:28:16" , 
"departure_time" : "10:29:20" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "10:32:04" , 
"departure_time" : "10:33:26" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "10:36:22" , 
"departure_time" : "10:37:06" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "10:42:44" , 
"departure_time" : "10:44:16" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "10:48:32" , 
"departure_time" : "10:49:03" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "10:50:31" , 
"departure_time" : "10:51:56" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "10:55:25" , 
"departure_time" : "10:56:48" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "10:58:23" , 
"departure_time" : "10:59:09" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 97,
"arrival_time" : "11:00:46" , 
"departure_time" : "11:01:42" , 
"distance_traveled" : 27.4884
}, 
{ 
"stop_id" : 112,
"arrival_time" : "11:04:56" , 
"departure_time" : "11:06:20" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "11:08:24" , 
"departure_time" : "11:08:40" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "11:10:16" , 
"departure_time" : "11:11:20" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "11:17:04" , 
"departure_time" : "11:17:43" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:25:39" , 
"departure_time" : "11:26:35" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "11:39:56" , 
"departure_time" : "11:39:56" , 
"distance_traveled" : 43.2223
} ], 
"1875" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "17:03:00" , 
"departure_time" : "17:04:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "17:10:07" , 
"departure_time" : "17:10:17" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "17:13:10" , 
"departure_time" : "17:13:22" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "17:19:12" , 
"departure_time" : "17:20:52" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "17:24:40" , 
"departure_time" : "17:26:06" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "17:28:26" , 
"departure_time" : "17:28:59" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "17:31:33" , 
"departure_time" : "17:31:36" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "17:35:03" , 
"departure_time" : "17:35:32" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:42:29" , 
"departure_time" : "17:42:46" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "17:47:17" , 
"departure_time" : "17:47:39" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "17:50:22" , 
"departure_time" : "17:50:47" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "17:54:25" , 
"departure_time" : "17:55:14" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:57:49" , 
"departure_time" : "17:58:50" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 61,
"arrival_time" : "18:02:01" , 
"departure_time" : "18:02:21" , 
"distance_traveled" : 28.4165
}, 
{ 
"stop_id" : 112,
"arrival_time" : "18:04:20" , 
"departure_time" : "18:05:30" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "18:08:10" , 
"departure_time" : "18:09:48" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "18:11:38" , 
"departure_time" : "18:12:50" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:17:12" , 
"departure_time" : "18:17:19" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:27:07" , 
"departure_time" : "18:27:35" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:41:28" , 
"departure_time" : "18:41:28" , 
"distance_traveled" : 43.2223
} ], 
"1876" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "14:03:00" , 
"departure_time" : "14:04:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "14:10:53" , 
"departure_time" : "14:11:13" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "14:13:20" , 
"departure_time" : "14:13:56" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "14:19:36" , 
"departure_time" : "14:20:18" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "14:23:42" , 
"departure_time" : "14:24:59" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "14:28:17" , 
"departure_time" : "14:29:08" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "14:31:51" , 
"departure_time" : "14:31:52" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "14:35:01" , 
"departure_time" : "14:35:16" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "14:42:15" , 
"departure_time" : "14:43:09" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "14:47:54" , 
"departure_time" : "14:49:30" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "14:51:36" , 
"departure_time" : "14:51:57" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "14:54:21" , 
"departure_time" : "14:55:36" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "14:58:15" , 
"departure_time" : "14:58:30" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 97,
"arrival_time" : "15:00:15" , 
"departure_time" : "15:00:28" , 
"distance_traveled" : 27.4884
}, 
{ 
"stop_id" : 112,
"arrival_time" : "15:04:13" , 
"departure_time" : "15:05:44" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "15:08:31" , 
"departure_time" : "15:09:06" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "15:10:35" , 
"departure_time" : "15:11:06" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:16:31" , 
"departure_time" : "15:17:36" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:26:05" , 
"departure_time" : "15:26:48" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "15:39:43" , 
"departure_time" : "15:39:43" , 
"distance_traveled" : 43.2223
} ], 
"1877" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "23:03:00" , 
"departure_time" : "23:04:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "23:10:48" , 
"departure_time" : "23:11:16" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "23:13:28" , 
"departure_time" : "23:14:50" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "23:20:22" , 
"departure_time" : "23:21:24" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "23:24:02" , 
"departure_time" : "23:25:33" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "23:28:31" , 
"departure_time" : "23:29:08" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "23:31:37" , 
"departure_time" : "23:31:56" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "23:35:19" , 
"departure_time" : "23:35:54" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "23:42:35" , 
"departure_time" : "23:43:22" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "23:47:47" , 
"departure_time" : "23:49:16" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "23:51:29" , 
"departure_time" : "23:52:49" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "23:55:20" , 
"departure_time" : "23:55:29" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "23:57:09" , 
"departure_time" : "23:57:53" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 61,
"arrival_time" : "24:01:44" , 
"departure_time" : "24:02:27" , 
"distance_traveled" : 28.4165
}, 
{ 
"stop_id" : 112,
"arrival_time" : "24:04:43" , 
"departure_time" : "24:05:43" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "24:08:00" , 
"departure_time" : "24:08:42" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "24:10:42" , 
"departure_time" : "24:11:28" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "24:16:46" , 
"departure_time" : "24:17:52" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:26:06" , 
"departure_time" : "24:27:02" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "24:39:56" , 
"departure_time" : "24:39:56" , 
"distance_traveled" : 43.2223
} ], 
"1878" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "20:03:00" , 
"departure_time" : "20:05:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "20:11:24" , 
"departure_time" : "20:12:07" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "20:13:43" , 
"departure_time" : "20:14:43" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "20:20:00" , 
"departure_time" : "20:20:55" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "20:23:55" , 
"departure_time" : "20:24:52" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "20:27:57" , 
"departure_time" : "20:28:40" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "20:31:43" , 
"departure_time" : "20:32:10" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "20:35:27" , 
"departure_time" : "20:35:51" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "20:42:24" , 
"departure_time" : "20:42:50" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "20:47:26" , 
"departure_time" : "20:48:22" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "20:50:56" , 
"departure_time" : "20:52:33" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "20:55:37" , 
"departure_time" : "20:56:05" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "20:57:28" , 
"departure_time" : "20:58:19" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 97,
"arrival_time" : "21:00:51" , 
"departure_time" : "21:02:25" , 
"distance_traveled" : 27.4884
}, 
{ 
"stop_id" : 112,
"arrival_time" : "21:05:34" , 
"departure_time" : "21:06:28" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "21:07:54" , 
"departure_time" : "21:08:32" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "21:10:38" , 
"departure_time" : "21:10:53" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "21:16:15" , 
"departure_time" : "21:16:48" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:25:33" , 
"departure_time" : "21:26:09" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "21:39:36" , 
"departure_time" : "21:39:36" , 
"distance_traveled" : 43.2223
} ], 
"1879" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "06:04:00" , 
"departure_time" : "06:04:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "06:11:21" , 
"departure_time" : "06:11:42" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "06:13:21" , 
"departure_time" : "06:14:56" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "06:20:35" , 
"departure_time" : "06:21:10" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "06:23:35" , 
"departure_time" : "06:24:25" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "06:27:50" , 
"departure_time" : "06:29:06" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "06:32:16" , 
"departure_time" : "06:32:20" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "06:35:04" , 
"departure_time" : "06:35:37" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "06:42:33" , 
"departure_time" : "06:43:49" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "06:48:16" , 
"departure_time" : "06:49:39" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "06:51:23" , 
"departure_time" : "06:51:54" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "06:54:31" , 
"departure_time" : "06:55:29" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "06:57:58" , 
"departure_time" : "06:58:02" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 97,
"arrival_time" : "07:00:04" , 
"departure_time" : "07:00:10" , 
"distance_traveled" : 27.4884
}, 
{ 
"stop_id" : 112,
"arrival_time" : "07:04:06" , 
"departure_time" : "07:04:22" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "07:07:16" , 
"departure_time" : "07:08:14" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "07:10:58" , 
"departure_time" : "07:12:20" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:17:22" , 
"departure_time" : "07:17:40" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:25:18" , 
"departure_time" : "07:26:46" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:40:28" , 
"departure_time" : "07:40:28" , 
"distance_traveled" : 43.2223
} ], 
"1880" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "06:44:00" , 
"departure_time" : "06:46:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "06:53:00" , 
"departure_time" : "06:54:32" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "07:00:32" , 
"departure_time" : "07:02:05" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "07:04:33" , 
"departure_time" : "07:04:54" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "07:07:21" , 
"departure_time" : "07:07:58" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "07:12:37" , 
"departure_time" : "07:12:45" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "07:16:08" , 
"departure_time" : "07:16:51" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:32:43" , 
"departure_time" : "07:33:37" , 
"distance_traveled" : 26.7136
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:41:54" , 
"departure_time" : "07:42:40" , 
"distance_traveled" : 32.7958
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:04:46" , 
"departure_time" : "08:04:46" , 
"distance_traveled" : 43.2178
} ], 
"1881" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "08:03:00" , 
"departure_time" : "08:05:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "08:11:16" , 
"departure_time" : "08:12:52" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "08:14:36" , 
"departure_time" : "08:15:37" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "08:20:01" , 
"departure_time" : "08:21:16" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "08:24:15" , 
"departure_time" : "08:25:10" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "08:27:55" , 
"departure_time" : "08:28:42" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "08:31:47" , 
"departure_time" : "08:33:03" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "08:36:16" , 
"departure_time" : "08:36:54" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "08:42:38" , 
"departure_time" : "08:43:03" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "08:47:25" , 
"departure_time" : "08:48:24" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "08:50:59" , 
"departure_time" : "08:52:29" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "08:55:30" , 
"departure_time" : "08:57:10" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:58:40" , 
"departure_time" : "08:58:53" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 97,
"arrival_time" : "09:00:13" , 
"departure_time" : "09:01:22" , 
"distance_traveled" : 27.4884
}, 
{ 
"stop_id" : 112,
"arrival_time" : "09:05:09" , 
"departure_time" : "09:05:12" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "09:07:03" , 
"departure_time" : "09:07:20" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "09:10:17" , 
"departure_time" : "09:11:10" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:16:53" , 
"departure_time" : "09:18:26" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:26:33" , 
"departure_time" : "09:27:47" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:40:14" , 
"departure_time" : "09:40:14" , 
"distance_traveled" : 43.2223
} ], 
"1882" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "05:08:00" , 
"departure_time" : "05:10:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 81,
"arrival_time" : "05:18:25" , 
"departure_time" : "05:18:34" , 
"distance_traveled" : 4.9504
}, 
{ 
"stop_id" : 140,
"arrival_time" : "05:20:09" , 
"departure_time" : "05:20:36" , 
"distance_traveled" : 6.2328
}, 
{ 
"stop_id" : 97,
"arrival_time" : "05:22:27" , 
"departure_time" : "05:23:08" , 
"distance_traveled" : 7.0044
}, 
{ 
"stop_id" : 61,
"arrival_time" : "05:24:41" , 
"departure_time" : "05:25:58" , 
"distance_traveled" : 7.9324
}, 
{ 
"stop_id" : 112,
"arrival_time" : "05:28:17" , 
"departure_time" : "05:29:02" , 
"distance_traveled" : 8.6402
}, 
{ 
"stop_id" : 23,
"arrival_time" : "05:29:45" , 
"departure_time" : "05:29:54" , 
"distance_traveled" : 9.5411
}, 
{ 
"stop_id" : 37,
"arrival_time" : "05:31:09" , 
"departure_time" : "05:32:23" , 
"distance_traveled" : 10.0689
}, 
{ 
"stop_id" : 106,
"arrival_time" : "05:37:14" , 
"departure_time" : "05:37:31" , 
"distance_traveled" : 12.3167
}, 
{ 
"stop_id" : 63,
"arrival_time" : "05:53:17" , 
"departure_time" : "05:53:17" , 
"distance_traveled" : 20.1049
} ], 
"1883" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "10:03:00" , 
"departure_time" : "10:03:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "10:10:29" , 
"departure_time" : "10:11:34" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "10:14:05" , 
"departure_time" : "10:14:18" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "10:19:13" , 
"departure_time" : "10:20:12" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "10:23:59" , 
"departure_time" : "10:25:07" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "10:28:08" , 
"departure_time" : "10:29:09" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "10:32:01" , 
"departure_time" : "10:32:39" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "10:35:38" , 
"departure_time" : "10:36:38" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "10:43:00" , 
"departure_time" : "10:44:22" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "10:48:22" , 
"departure_time" : "10:49:45" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "10:51:23" , 
"departure_time" : "10:51:44" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "10:54:21" , 
"departure_time" : "10:55:34" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "10:58:13" , 
"departure_time" : "10:58:28" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 97,
"arrival_time" : "11:00:15" , 
"departure_time" : "11:01:20" , 
"distance_traveled" : 27.4884
}, 
{ 
"stop_id" : 112,
"arrival_time" : "11:05:05" , 
"departure_time" : "11:06:45" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "11:08:40" , 
"departure_time" : "11:10:15" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "11:11:35" , 
"departure_time" : "11:12:48" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "11:17:13" , 
"departure_time" : "11:18:16" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:26:03" , 
"departure_time" : "11:27:13" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "11:40:10" , 
"departure_time" : "11:40:10" , 
"distance_traveled" : 43.2223
} ], 
"1884" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "06:56:00" , 
"departure_time" : "06:58:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:07:33" , 
"departure_time" : "07:08:22" , 
"distance_traveled" : 4.9504
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:09:49" , 
"departure_time" : "07:09:52" , 
"distance_traveled" : 6.2328
}, 
{ 
"stop_id" : 97,
"arrival_time" : "07:12:03" , 
"departure_time" : "07:12:10" , 
"distance_traveled" : 7.0044
}, 
{ 
"stop_id" : 61,
"arrival_time" : "07:14:07" , 
"departure_time" : "07:15:09" , 
"distance_traveled" : 7.9324
}, 
{ 
"stop_id" : 112,
"arrival_time" : "07:18:02" , 
"departure_time" : "07:19:31" , 
"distance_traveled" : 8.6402
}, 
{ 
"stop_id" : 23,
"arrival_time" : "07:21:29" , 
"departure_time" : "07:22:20" , 
"distance_traveled" : 9.5411
}, 
{ 
"stop_id" : 37,
"arrival_time" : "07:22:51" , 
"departure_time" : "07:24:27" , 
"distance_traveled" : 10.0689
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:29:36" , 
"departure_time" : "07:30:15" , 
"distance_traveled" : 12.3167
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:45:39" , 
"departure_time" : "07:45:39" , 
"distance_traveled" : 20.1049
} ], 
"1885" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "14:03:00" , 
"departure_time" : "14:04:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "14:11:03" , 
"departure_time" : "14:12:19" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "14:14:16" , 
"departure_time" : "14:14:43" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "14:19:27" , 
"departure_time" : "14:19:30" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "14:23:03" , 
"departure_time" : "14:23:41" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "14:27:38" , 
"departure_time" : "14:28:16" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "14:31:38" , 
"departure_time" : "14:33:08" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "14:36:30" , 
"departure_time" : "14:37:47" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "14:43:17" , 
"departure_time" : "14:44:57" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "14:48:40" , 
"departure_time" : "14:48:46" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "14:50:06" , 
"departure_time" : "14:51:11" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "14:55:05" , 
"departure_time" : "14:55:17" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "14:57:12" , 
"departure_time" : "14:57:32" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 97,
"arrival_time" : "15:00:20" , 
"departure_time" : "15:01:52" , 
"distance_traveled" : 27.4884
}, 
{ 
"stop_id" : 112,
"arrival_time" : "15:05:32" , 
"departure_time" : "15:07:09" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "15:08:37" , 
"departure_time" : "15:08:43" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "15:10:06" , 
"departure_time" : "15:10:33" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:16:27" , 
"departure_time" : "15:17:06" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:25:39" , 
"departure_time" : "15:25:57" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "15:39:18" , 
"departure_time" : "15:39:18" , 
"distance_traveled" : 43.2223
} ], 
"1886" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "07:32:00" , 
"departure_time" : "07:33:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:45:52" , 
"departure_time" : "07:46:06" , 
"distance_traveled" : 4.9504
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:49:14" , 
"departure_time" : "07:49:16" , 
"distance_traveled" : 6.2328
}, 
{ 
"stop_id" : 97,
"arrival_time" : "07:52:02" , 
"departure_time" : "07:53:28" , 
"distance_traveled" : 7.0044
}, 
{ 
"stop_id" : 61,
"arrival_time" : "07:56:26" , 
"departure_time" : "07:57:09" , 
"distance_traveled" : 7.9324
}, 
{ 
"stop_id" : 112,
"arrival_time" : "07:58:43" , 
"departure_time" : "07:59:30" , 
"distance_traveled" : 8.6402
}, 
{ 
"stop_id" : 23,
"arrival_time" : "08:01:47" , 
"departure_time" : "08:02:50" , 
"distance_traveled" : 9.5411
}, 
{ 
"stop_id" : 37,
"arrival_time" : "08:05:03" , 
"departure_time" : "08:06:06" , 
"distance_traveled" : 10.0689
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:10:03" , 
"departure_time" : "08:10:44" , 
"distance_traveled" : 12.3167
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:27:41" , 
"departure_time" : "08:27:41" , 
"distance_traveled" : 20.1049
} ], 
"1887" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "20:03:00" , 
"departure_time" : "20:04:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "20:11:13" , 
"departure_time" : "20:12:21" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "20:14:08" , 
"departure_time" : "20:15:04" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "20:19:56" , 
"departure_time" : "20:20:03" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "20:23:07" , 
"departure_time" : "20:24:32" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "20:28:25" , 
"departure_time" : "20:29:15" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "20:31:50" , 
"departure_time" : "20:32:27" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "20:35:37" , 
"departure_time" : "20:37:04" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "20:43:27" , 
"departure_time" : "20:43:53" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "20:47:26" , 
"departure_time" : "20:47:35" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "20:50:09" , 
"departure_time" : "20:50:24" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "20:54:15" , 
"departure_time" : "20:55:02" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "20:57:47" , 
"departure_time" : "20:57:48" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 97,
"arrival_time" : "21:00:01" , 
"departure_time" : "21:00:39" , 
"distance_traveled" : 27.4884
}, 
{ 
"stop_id" : 112,
"arrival_time" : "21:04:38" , 
"departure_time" : "21:05:59" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "21:08:21" , 
"departure_time" : "21:09:11" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "21:10:50" , 
"departure_time" : "21:12:25" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "21:17:35" , 
"departure_time" : "21:18:53" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:26:18" , 
"departure_time" : "21:26:30" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "21:39:12" , 
"departure_time" : "21:39:12" , 
"distance_traveled" : 43.2223
} ], 
"1888" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "17:40:00" , 
"departure_time" : "17:40:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 81,
"arrival_time" : "17:48:04" , 
"departure_time" : "17:48:17" , 
"distance_traveled" : 4.9504
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:50:13" , 
"departure_time" : "17:51:13" , 
"distance_traveled" : 6.2328
}, 
{ 
"stop_id" : 97,
"arrival_time" : "17:54:00" , 
"departure_time" : "17:54:18" , 
"distance_traveled" : 7.0044
}, 
{ 
"stop_id" : 61,
"arrival_time" : "17:55:18" , 
"departure_time" : "17:55:36" , 
"distance_traveled" : 7.9324
}, 
{ 
"stop_id" : 112,
"arrival_time" : "17:57:18" , 
"departure_time" : "17:58:23" , 
"distance_traveled" : 8.6402
}, 
{ 
"stop_id" : 23,
"arrival_time" : "18:00:05" , 
"departure_time" : "18:00:20" , 
"distance_traveled" : 9.5411
}, 
{ 
"stop_id" : 37,
"arrival_time" : "18:02:15" , 
"departure_time" : "18:03:21" , 
"distance_traveled" : 10.0689
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:07:06" , 
"departure_time" : "18:07:49" , 
"distance_traveled" : 12.3167
}, 
{ 
"stop_id" : 63,
"arrival_time" : "18:22:43" , 
"departure_time" : "18:22:43" , 
"distance_traveled" : 20.1049
} ], 
"1889" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "10:06:00" , 
"departure_time" : "10:08:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "10:14:36" , 
"departure_time" : "10:14:43" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "10:16:07" , 
"departure_time" : "10:16:40" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "10:22:33" , 
"departure_time" : "10:22:55" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "10:27:22" , 
"departure_time" : "10:28:28" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "10:32:06" , 
"departure_time" : "10:32:07" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "10:35:01" , 
"departure_time" : "10:35:23" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "10:39:22" , 
"departure_time" : "10:40:11" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "10:46:49" , 
"departure_time" : "10:48:11" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 106,
"arrival_time" : "11:04:22" , 
"departure_time" : "11:04:43" , 
"distance_traveled" : 32.7902
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:13:21" , 
"departure_time" : "11:14:16" , 
"distance_traveled" : 38.2239
}, 
{ 
"stop_id" : 105,
"arrival_time" : "11:26:55" , 
"departure_time" : "11:26:55" , 
"distance_traveled" : 43.2119
} ], 
"1890" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "18:47:00" , 
"departure_time" : "18:49:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:56:13" , 
"departure_time" : "18:56:32" , 
"distance_traveled" : 4.9504
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:58:19" , 
"departure_time" : "18:59:17" , 
"distance_traveled" : 6.2328
}, 
{ 
"stop_id" : 97,
"arrival_time" : "19:00:58" , 
"departure_time" : "19:02:06" , 
"distance_traveled" : 7.0044
}, 
{ 
"stop_id" : 61,
"arrival_time" : "19:03:08" , 
"departure_time" : "19:03:32" , 
"distance_traveled" : 7.9324
}, 
{ 
"stop_id" : 112,
"arrival_time" : "19:04:24" , 
"departure_time" : "19:04:33" , 
"distance_traveled" : 8.6402
}, 
{ 
"stop_id" : 23,
"arrival_time" : "19:07:09" , 
"departure_time" : "19:08:13" , 
"distance_traveled" : 9.5411
}, 
{ 
"stop_id" : 37,
"arrival_time" : "19:10:04" , 
"departure_time" : "19:10:54" , 
"distance_traveled" : 10.0689
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:14:50" , 
"departure_time" : "19:15:48" , 
"distance_traveled" : 12.3167
}, 
{ 
"stop_id" : 63,
"arrival_time" : "19:29:58" , 
"departure_time" : "19:29:58" , 
"distance_traveled" : 20.1049
} ], 
"1891" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "06:44:00" , 
"departure_time" : "06:45:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "06:52:50" , 
"departure_time" : "06:53:17" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "06:59:27" , 
"departure_time" : "06:59:36" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "07:03:09" , 
"departure_time" : "07:04:46" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "07:08:37" , 
"departure_time" : "07:09:38" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "07:13:01" , 
"departure_time" : "07:14:33" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "07:17:32" , 
"departure_time" : "07:18:07" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:32:35" , 
"departure_time" : "07:32:50" , 
"distance_traveled" : 26.7136
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:41:15" , 
"departure_time" : "07:41:32" , 
"distance_traveled" : 32.7958
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:04:17" , 
"departure_time" : "08:04:17" , 
"distance_traveled" : 43.2178
} ], 
"1892" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "10:28:00" , 
"departure_time" : "10:28:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 136,
"arrival_time" : "10:32:27" , 
"departure_time" : "10:33:23" , 
"distance_traveled" : 2.268
}, 
{ 
"stop_id" : 87,
"arrival_time" : "10:35:56" , 
"departure_time" : "10:36:15" , 
"distance_traveled" : 3.3424
}, 
{ 
"stop_id" : 81,
"arrival_time" : "10:38:19" , 
"departure_time" : "10:38:48" , 
"distance_traveled" : 4.9511
}, 
{ 
"stop_id" : 140,
"arrival_time" : "10:42:29" , 
"departure_time" : "10:43:40" , 
"distance_traveled" : 6.2335
}, 
{ 
"stop_id" : 112,
"arrival_time" : "10:47:11" , 
"departure_time" : "10:48:12" , 
"distance_traveled" : 8.6407
}, 
{ 
"stop_id" : 23,
"arrival_time" : "10:51:01" , 
"departure_time" : "10:52:32" , 
"distance_traveled" : 9.5417
}, 
{ 
"stop_id" : 106,
"arrival_time" : "10:56:31" , 
"departure_time" : "10:57:13" , 
"distance_traveled" : 12.3172
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:05:42" , 
"departure_time" : "11:06:27" , 
"distance_traveled" : 17.7509
}, 
{ 
"stop_id" : 105,
"arrival_time" : "11:19:45" , 
"departure_time" : "11:19:45" , 
"distance_traveled" : 22.739
} ], 
"1893" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "05:08:00" , 
"departure_time" : "05:09:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 81,
"arrival_time" : "05:17:34" , 
"departure_time" : "05:19:11" , 
"distance_traveled" : 4.9504
}, 
{ 
"stop_id" : 140,
"arrival_time" : "05:21:37" , 
"departure_time" : "05:22:29" , 
"distance_traveled" : 6.2328
}, 
{ 
"stop_id" : 97,
"arrival_time" : "05:22:52" , 
"departure_time" : "05:24:31" , 
"distance_traveled" : 7.0044
}, 
{ 
"stop_id" : 61,
"arrival_time" : "05:25:39" , 
"departure_time" : "05:26:59" , 
"distance_traveled" : 7.9324
}, 
{ 
"stop_id" : 112,
"arrival_time" : "05:28:20" , 
"departure_time" : "05:29:41" , 
"distance_traveled" : 8.6402
}, 
{ 
"stop_id" : 23,
"arrival_time" : "05:30:21" , 
"departure_time" : "05:31:18" , 
"distance_traveled" : 9.5411
}, 
{ 
"stop_id" : 37,
"arrival_time" : "05:31:57" , 
"departure_time" : "05:33:15" , 
"distance_traveled" : 10.0689
}, 
{ 
"stop_id" : 106,
"arrival_time" : "05:37:18" , 
"departure_time" : "05:38:39" , 
"distance_traveled" : 12.3167
}, 
{ 
"stop_id" : 63,
"arrival_time" : "05:54:21" , 
"departure_time" : "05:54:21" , 
"distance_traveled" : 20.1049
} ], 
"1894" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "07:33:00" , 
"departure_time" : "07:36:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "07:42:39" , 
"departure_time" : "07:43:48" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "07:49:09" , 
"departure_time" : "07:49:12" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "07:52:03" , 
"departure_time" : "07:52:27" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "07:56:24" , 
"departure_time" : "07:57:21" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "08:01:57" , 
"departure_time" : "08:03:11" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "08:07:14" , 
"departure_time" : "08:07:39" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "08:13:25" , 
"departure_time" : "08:14:37" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:25:12" , 
"departure_time" : "08:25:39" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:55:27" , 
"departure_time" : "08:55:27" , 
"distance_traveled" : 43.1983
} ], 
"1895" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "06:56:00" , 
"departure_time" : "06:57:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:06:34" , 
"departure_time" : "07:07:10" , 
"distance_traveled" : 4.9504
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:09:36" , 
"departure_time" : "07:10:34" , 
"distance_traveled" : 6.2328
}, 
{ 
"stop_id" : 97,
"arrival_time" : "07:12:58" , 
"departure_time" : "07:14:08" , 
"distance_traveled" : 7.0044
}, 
{ 
"stop_id" : 61,
"arrival_time" : "07:15:10" , 
"departure_time" : "07:16:17" , 
"distance_traveled" : 7.9324
}, 
{ 
"stop_id" : 112,
"arrival_time" : "07:18:07" , 
"departure_time" : "07:18:51" , 
"distance_traveled" : 8.6402
}, 
{ 
"stop_id" : 23,
"arrival_time" : "07:20:44" , 
"departure_time" : "07:21:06" , 
"distance_traveled" : 9.5411
}, 
{ 
"stop_id" : 37,
"arrival_time" : "07:22:22" , 
"departure_time" : "07:23:22" , 
"distance_traveled" : 10.0689
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:29:00" , 
"departure_time" : "07:30:04" , 
"distance_traveled" : 12.3167
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:46:04" , 
"departure_time" : "07:46:04" , 
"distance_traveled" : 20.1049
} ], 
"1896" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "07:04:00" , 
"departure_time" : "07:06:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "07:13:35" , 
"departure_time" : "07:13:42" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "07:19:07" , 
"departure_time" : "07:19:19" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "07:24:12" , 
"departure_time" : "07:25:36" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "07:29:24" , 
"departure_time" : "07:29:33" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "07:32:09" , 
"departure_time" : "07:32:39" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "07:37:30" , 
"departure_time" : "07:38:52" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:46:22" , 
"departure_time" : "07:47:43" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:52:21" , 
"departure_time" : "07:53:40" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:05:19" , 
"departure_time" : "08:05:21" , 
"distance_traveled" : 32.79
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:26:02" , 
"departure_time" : "08:26:02" , 
"distance_traveled" : 43.2119
} ], 
"1897" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "07:32:00" , 
"departure_time" : "07:32:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:45:17" , 
"departure_time" : "07:46:21" , 
"distance_traveled" : 4.9504
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:50:04" , 
"departure_time" : "07:50:27" , 
"distance_traveled" : 6.2328
}, 
{ 
"stop_id" : 97,
"arrival_time" : "07:52:23" , 
"departure_time" : "07:53:49" , 
"distance_traveled" : 7.0044
}, 
{ 
"stop_id" : 61,
"arrival_time" : "07:56:26" , 
"departure_time" : "07:57:31" , 
"distance_traveled" : 7.9324
}, 
{ 
"stop_id" : 112,
"arrival_time" : "07:59:05" , 
"departure_time" : "07:59:30" , 
"distance_traveled" : 8.6402
}, 
{ 
"stop_id" : 23,
"arrival_time" : "08:01:25" , 
"departure_time" : "08:02:42" , 
"distance_traveled" : 9.5411
}, 
{ 
"stop_id" : 37,
"arrival_time" : "08:05:17" , 
"departure_time" : "08:06:53" , 
"distance_traveled" : 10.0689
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:10:36" , 
"departure_time" : "08:12:00" , 
"distance_traveled" : 12.3167
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:28:24" , 
"departure_time" : "08:28:24" , 
"distance_traveled" : 20.1049
} ], 
"1898" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "06:09:00" , 
"departure_time" : "06:11:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "06:17:37" , 
"departure_time" : "06:18:54" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "06:25:17" , 
"departure_time" : "06:26:12" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "06:29:55" , 
"departure_time" : "06:30:57" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "06:34:02" , 
"departure_time" : "06:34:28" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "06:37:26" , 
"departure_time" : "06:37:28" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "06:41:02" , 
"departure_time" : "06:41:16" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "06:48:14" , 
"departure_time" : "06:49:10" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "06:52:56" , 
"departure_time" : "06:54:11" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "06:57:15" , 
"departure_time" : "06:57:19" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:01:04" , 
"departure_time" : "07:02:04" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:33:00" , 
"departure_time" : "07:33:00" , 
"distance_traveled" : 43.1886
} ], 
"1899" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "17:40:00" , 
"departure_time" : "17:41:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 81,
"arrival_time" : "17:48:55" , 
"departure_time" : "17:49:44" , 
"distance_traveled" : 4.9504
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:50:49" , 
"departure_time" : "17:51:03" , 
"distance_traveled" : 6.2328
}, 
{ 
"stop_id" : 97,
"arrival_time" : "17:53:14" , 
"departure_time" : "17:53:56" , 
"distance_traveled" : 7.0044
}, 
{ 
"stop_id" : 61,
"arrival_time" : "17:55:42" , 
"departure_time" : "17:56:32" , 
"distance_traveled" : 7.9324
}, 
{ 
"stop_id" : 112,
"arrival_time" : "17:57:50" , 
"departure_time" : "17:59:06" , 
"distance_traveled" : 8.6402
}, 
{ 
"stop_id" : 23,
"arrival_time" : "18:00:16" , 
"departure_time" : "18:01:38" , 
"distance_traveled" : 9.5411
}, 
{ 
"stop_id" : 37,
"arrival_time" : "18:03:22" , 
"departure_time" : "18:04:56" , 
"distance_traveled" : 10.0689
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:07:34" , 
"departure_time" : "18:08:53" , 
"distance_traveled" : 12.3167
}, 
{ 
"stop_id" : 63,
"arrival_time" : "18:23:19" , 
"departure_time" : "18:23:19" , 
"distance_traveled" : 20.1049
} ], 
"1900" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "09:06:00" , 
"departure_time" : "09:07:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "09:13:11" , 
"departure_time" : "09:14:33" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "09:17:22" , 
"departure_time" : "09:18:33" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "09:23:11" , 
"departure_time" : "09:24:15" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "09:28:04" , 
"departure_time" : "09:29:08" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "09:32:04" , 
"departure_time" : "09:32:12" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "09:35:08" , 
"departure_time" : "09:35:55" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "09:39:47" , 
"departure_time" : "09:41:19" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "09:47:32" , 
"departure_time" : "09:49:10" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 106,
"arrival_time" : "10:04:38" , 
"departure_time" : "10:05:41" , 
"distance_traveled" : 32.7902
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:26:03" , 
"departure_time" : "10:26:03" , 
"distance_traveled" : 43.2125
} ], 
"1901" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "18:47:00" , 
"departure_time" : "18:49:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:56:28" , 
"departure_time" : "18:57:08" , 
"distance_traveled" : 4.9504
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:58:40" , 
"departure_time" : "18:59:35" , 
"distance_traveled" : 6.2328
}, 
{ 
"stop_id" : 97,
"arrival_time" : "19:00:55" , 
"departure_time" : "19:01:50" , 
"distance_traveled" : 7.0044
}, 
{ 
"stop_id" : 61,
"arrival_time" : "19:02:55" , 
"departure_time" : "19:03:07" , 
"distance_traveled" : 7.9324
}, 
{ 
"stop_id" : 112,
"arrival_time" : "19:04:12" , 
"departure_time" : "19:04:26" , 
"distance_traveled" : 8.6402
}, 
{ 
"stop_id" : 23,
"arrival_time" : "19:07:14" , 
"departure_time" : "19:07:32" , 
"distance_traveled" : 9.5411
}, 
{ 
"stop_id" : 37,
"arrival_time" : "19:09:18" , 
"departure_time" : "19:09:27" , 
"distance_traveled" : 10.0689
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:14:09" , 
"departure_time" : "19:15:11" , 
"distance_traveled" : 12.3167
}, 
{ 
"stop_id" : 63,
"arrival_time" : "19:30:02" , 
"departure_time" : "19:30:02" , 
"distance_traveled" : 20.1049
} ], 
"1902" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "10:06:00" , 
"departure_time" : "10:08:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "10:14:08" , 
"departure_time" : "10:15:29" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "10:17:21" , 
"departure_time" : "10:18:25" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "10:23:04" , 
"departure_time" : "10:24:09" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "10:28:05" , 
"departure_time" : "10:28:22" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "10:31:17" , 
"departure_time" : "10:32:50" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "10:36:33" , 
"departure_time" : "10:36:41" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "10:39:08" , 
"departure_time" : "10:39:30" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "10:46:22" , 
"departure_time" : "10:47:15" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 106,
"arrival_time" : "11:03:53" , 
"departure_time" : "11:04:18" , 
"distance_traveled" : 32.7902
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:13:25" , 
"departure_time" : "11:14:37" , 
"distance_traveled" : 38.2239
}, 
{ 
"stop_id" : 105,
"arrival_time" : "11:27:12" , 
"departure_time" : "11:27:12" , 
"distance_traveled" : 43.2119
} ], 
"1903" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "10:28:00" , 
"departure_time" : "10:29:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 136,
"arrival_time" : "10:32:40" , 
"departure_time" : "10:33:31" , 
"distance_traveled" : 2.268
}, 
{ 
"stop_id" : 87,
"arrival_time" : "10:35:51" , 
"departure_time" : "10:37:14" , 
"distance_traveled" : 3.3424
}, 
{ 
"stop_id" : 81,
"arrival_time" : "10:39:23" , 
"departure_time" : "10:40:10" , 
"distance_traveled" : 4.9511
}, 
{ 
"stop_id" : 140,
"arrival_time" : "10:42:47" , 
"departure_time" : "10:44:22" , 
"distance_traveled" : 6.2335
}, 
{ 
"stop_id" : 112,
"arrival_time" : "10:47:35" , 
"departure_time" : "10:47:56" , 
"distance_traveled" : 8.6407
}, 
{ 
"stop_id" : 23,
"arrival_time" : "10:50:21" , 
"departure_time" : "10:51:48" , 
"distance_traveled" : 9.5417
}, 
{ 
"stop_id" : 106,
"arrival_time" : "10:56:27" , 
"departure_time" : "10:57:05" , 
"distance_traveled" : 12.3172
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:05:38" , 
"departure_time" : "11:06:33" , 
"distance_traveled" : 17.7509
}, 
{ 
"stop_id" : 105,
"arrival_time" : "11:19:55" , 
"departure_time" : "11:19:55" , 
"distance_traveled" : 22.739
} ], 
"1904" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "19:27:00" , 
"departure_time" : "19:29:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 136,
"arrival_time" : "19:32:20" , 
"departure_time" : "19:33:01" , 
"distance_traveled" : 2.268
}, 
{ 
"stop_id" : 87,
"arrival_time" : "19:34:41" , 
"departure_time" : "19:34:54" , 
"distance_traveled" : 3.3424
}, 
{ 
"stop_id" : 81,
"arrival_time" : "19:38:13" , 
"departure_time" : "19:38:17" , 
"distance_traveled" : 4.9511
}, 
{ 
"stop_id" : 140,
"arrival_time" : "19:41:04" , 
"departure_time" : "19:41:53" , 
"distance_traveled" : 6.2335
}, 
{ 
"stop_id" : 97,
"arrival_time" : "19:43:49" , 
"departure_time" : "19:45:17" , 
"distance_traveled" : 7.0051
}, 
{ 
"stop_id" : 61,
"arrival_time" : "19:46:28" , 
"departure_time" : "19:47:07" , 
"distance_traveled" : 7.9331
}, 
{ 
"stop_id" : 112,
"arrival_time" : "19:47:39" , 
"departure_time" : "19:48:43" , 
"distance_traveled" : 8.6409
}, 
{ 
"stop_id" : 23,
"arrival_time" : "19:51:04" , 
"departure_time" : "19:52:07" , 
"distance_traveled" : 9.5419
}, 
{ 
"stop_id" : 37,
"arrival_time" : "19:53:03" , 
"departure_time" : "19:54:10" , 
"distance_traveled" : 10.0697
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:58:07" , 
"departure_time" : "19:58:46" , 
"distance_traveled" : 12.3174
}, 
{ 
"stop_id" : 63,
"arrival_time" : "20:12:39" , 
"departure_time" : "20:12:39" , 
"distance_traveled" : 20.1057
} ], 
"1905" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "07:33:00" , 
"departure_time" : "07:34:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "07:41:53" , 
"departure_time" : "07:42:06" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "07:48:13" , 
"departure_time" : "07:49:10" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "07:52:57" , 
"departure_time" : "07:53:18" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "07:56:21" , 
"departure_time" : "07:57:00" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "08:01:39" , 
"departure_time" : "08:03:09" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "08:07:30" , 
"departure_time" : "08:08:15" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "08:13:45" , 
"departure_time" : "08:14:30" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:24:45" , 
"departure_time" : "08:24:53" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:55:08" , 
"departure_time" : "08:55:08" , 
"distance_traveled" : 43.1983
} ], 
"1906" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "15:45:00" , 
"departure_time" : "15:46:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "15:54:04" , 
"departure_time" : "15:55:25" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "16:01:21" , 
"departure_time" : "16:01:29" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "16:04:08" , 
"departure_time" : "16:05:43" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "16:09:35" , 
"departure_time" : "16:09:36" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "16:12:01" , 
"departure_time" : "16:13:11" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "16:17:10" , 
"departure_time" : "16:18:18" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:23:08" , 
"departure_time" : "16:24:14" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "16:28:06" , 
"departure_time" : "16:28:38" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "16:30:32" , 
"departure_time" : "16:31:04" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:42:32" , 
"departure_time" : "16:43:30" , 
"distance_traveled" : 32.7898
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:53:58" , 
"departure_time" : "16:54:18" , 
"distance_traveled" : 38.2235
}, 
{ 
"stop_id" : 105,
"arrival_time" : "17:06:20" , 
"departure_time" : "17:06:20" , 
"distance_traveled" : 43.2116
} ], 
"1907" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "07:04:00" , 
"departure_time" : "07:04:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "07:12:35" , 
"departure_time" : "07:12:53" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "07:19:18" , 
"departure_time" : "07:20:42" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "07:25:24" , 
"departure_time" : "07:25:28" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "07:28:04" , 
"departure_time" : "07:28:34" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "07:32:30" , 
"departure_time" : "07:34:05" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "07:38:35" , 
"departure_time" : "07:39:35" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:46:00" , 
"departure_time" : "07:46:15" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:51:15" , 
"departure_time" : "07:52:40" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:05:25" , 
"departure_time" : "08:06:38" , 
"distance_traveled" : 32.79
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:27:13" , 
"departure_time" : "08:27:13" , 
"distance_traveled" : 43.2119
} ], 
"1908" :  [ 
{ 
"stop_id" : 92,
"arrival_time" : "08:49:00" , 
"departure_time" : "08:50:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 30,
"arrival_time" : "08:52:09" , 
"departure_time" : "08:53:18" , 
"distance_traveled" : 2.0962
}, 
{ 
"stop_id" : 77,
"arrival_time" : "08:57:09" , 
"departure_time" : "08:57:56" , 
"distance_traveled" : 4.2617
}, 
{ 
"stop_id" : 27,
"arrival_time" : "09:00:47" , 
"departure_time" : "09:01:41" , 
"distance_traveled" : 6.2794
}, 
{ 
"stop_id" : 145,
"arrival_time" : "09:05:54" , 
"departure_time" : "09:06:54" , 
"distance_traveled" : 9.7277
}, 
{ 
"stop_id" : 136,
"arrival_time" : "09:11:00" , 
"departure_time" : "09:11:59" , 
"distance_traveled" : 11.9956
}, 
{ 
"stop_id" : 87,
"arrival_time" : "09:13:59" , 
"departure_time" : "09:15:03" , 
"distance_traveled" : 13.0701
}, 
{ 
"stop_id" : 81,
"arrival_time" : "09:17:04" , 
"departure_time" : "09:17:25" , 
"distance_traveled" : 14.6788
}, 
{ 
"stop_id" : 140,
"arrival_time" : "09:19:21" , 
"departure_time" : "09:20:54" , 
"distance_traveled" : 15.9612
}, 
{ 
"stop_id" : 112,
"arrival_time" : "09:24:33" , 
"departure_time" : "09:24:37" , 
"distance_traveled" : 18.3684
}, 
{ 
"stop_id" : 23,
"arrival_time" : "09:25:04" , 
"departure_time" : "09:26:05" , 
"distance_traveled" : 19.2693
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:31:01" , 
"departure_time" : "09:32:00" , 
"distance_traveled" : 22.0449
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:46:59" , 
"departure_time" : "09:46:59" , 
"distance_traveled" : 29.8331
} ], 
"1909" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "06:09:00" , 
"departure_time" : "06:10:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "06:17:17" , 
"departure_time" : "06:18:35" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "06:25:18" , 
"departure_time" : "06:26:47" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "06:30:29" , 
"departure_time" : "06:32:05" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "06:34:36" , 
"departure_time" : "06:36:00" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "06:38:24" , 
"departure_time" : "06:39:38" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "06:42:14" , 
"departure_time" : "06:43:53" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "06:49:39" , 
"departure_time" : "06:49:44" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "06:52:05" , 
"departure_time" : "06:52:25" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "06:56:20" , 
"departure_time" : "06:57:33" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:02:13" , 
"departure_time" : "07:03:22" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:33:09" , 
"departure_time" : "07:33:09" , 
"distance_traveled" : 43.1886
} ], 
"1910" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "05:33:00" , 
"departure_time" : "05:34:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "05:40:23" , 
"departure_time" : "05:40:39" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "05:47:16" , 
"departure_time" : "05:47:49" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "05:52:33" , 
"departure_time" : "05:54:07" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "05:57:34" , 
"departure_time" : "05:58:23" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "06:01:49" , 
"departure_time" : "06:02:13" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "06:05:24" , 
"departure_time" : "06:06:28" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "06:12:04" , 
"departure_time" : "06:12:32" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 81,
"arrival_time" : "06:18:28" , 
"departure_time" : "06:19:15" , 
"distance_traveled" : 25.4335
}, 
{ 
"stop_id" : 140,
"arrival_time" : "06:22:47" , 
"departure_time" : "06:23:54" , 
"distance_traveled" : 26.7159
}, 
{ 
"stop_id" : 23,
"arrival_time" : "06:29:07" , 
"departure_time" : "06:30:45" , 
"distance_traveled" : 30.0227
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:34:38" , 
"departure_time" : "06:35:44" , 
"distance_traveled" : 32.7983
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:46:06" , 
"departure_time" : "06:46:14" , 
"distance_traveled" : 38.232
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:58:08" , 
"departure_time" : "06:58:08" , 
"distance_traveled" : 43.2201
} ], 
"1911" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "09:06:00" , 
"departure_time" : "09:06:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "09:13:40" , 
"departure_time" : "09:14:40" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "09:17:00" , 
"departure_time" : "09:17:35" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "09:22:35" , 
"departure_time" : "09:22:50" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "09:27:15" , 
"departure_time" : "09:27:38" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "09:31:23" , 
"departure_time" : "09:32:20" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "09:35:57" , 
"departure_time" : "09:36:18" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "09:39:21" , 
"departure_time" : "09:40:18" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "09:46:57" , 
"departure_time" : "09:47:30" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 106,
"arrival_time" : "10:03:33" , 
"departure_time" : "10:03:44" , 
"distance_traveled" : 32.7902
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:25:11" , 
"departure_time" : "10:25:11" , 
"distance_traveled" : 43.2125
} ], 
"1912" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "05:54:00" , 
"departure_time" : "05:54:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "06:01:42" , 
"departure_time" : "06:01:50" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "06:04:08" , 
"departure_time" : "06:04:48" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "06:10:40" , 
"departure_time" : "06:11:29" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "06:14:49" , 
"departure_time" : "06:14:59" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "06:18:10" , 
"departure_time" : "06:18:36" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "06:22:26" , 
"departure_time" : "06:23:45" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "06:27:19" , 
"departure_time" : "06:28:13" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "06:33:54" , 
"departure_time" : "06:34:19" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "06:38:25" , 
"departure_time" : "06:38:33" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "06:41:08" , 
"departure_time" : "06:41:23" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:55:15" , 
"departure_time" : "06:55:54" , 
"distance_traveled" : 32.79
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:05:39" , 
"departure_time" : "07:06:50" , 
"distance_traveled" : 38.2237
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:19:11" , 
"departure_time" : "07:19:11" , 
"distance_traveled" : 43.2117
} ], 
"1913" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "19:27:00" , 
"departure_time" : "19:29:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 136,
"arrival_time" : "19:32:04" , 
"departure_time" : "19:32:55" , 
"distance_traveled" : 2.268
}, 
{ 
"stop_id" : 87,
"arrival_time" : "19:34:51" , 
"departure_time" : "19:35:47" , 
"distance_traveled" : 3.3424
}, 
{ 
"stop_id" : 81,
"arrival_time" : "19:38:56" , 
"departure_time" : "19:39:56" , 
"distance_traveled" : 4.9511
}, 
{ 
"stop_id" : 140,
"arrival_time" : "19:42:00" , 
"departure_time" : "19:43:10" , 
"distance_traveled" : 6.2335
}, 
{ 
"stop_id" : 97,
"arrival_time" : "19:44:10" , 
"departure_time" : "19:45:27" , 
"distance_traveled" : 7.0051
}, 
{ 
"stop_id" : 61,
"arrival_time" : "19:46:17" , 
"departure_time" : "19:46:56" , 
"distance_traveled" : 7.9331
}, 
{ 
"stop_id" : 112,
"arrival_time" : "19:47:39" , 
"departure_time" : "19:48:57" , 
"distance_traveled" : 8.6409
}, 
{ 
"stop_id" : 23,
"arrival_time" : "19:51:18" , 
"departure_time" : "19:51:30" , 
"distance_traveled" : 9.5419
}, 
{ 
"stop_id" : 37,
"arrival_time" : "19:52:12" , 
"departure_time" : "19:53:29" , 
"distance_traveled" : 10.0697
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:58:17" , 
"departure_time" : "19:58:42" , 
"distance_traveled" : 12.3174
}, 
{ 
"stop_id" : 63,
"arrival_time" : "20:12:25" , 
"departure_time" : "20:12:25" , 
"distance_traveled" : 20.1057
} ], 
"1914" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "08:08:00" , 
"departure_time" : "08:09:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "08:16:16" , 
"departure_time" : "08:17:42" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "08:18:26" , 
"departure_time" : "08:19:44" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "08:24:18" , 
"departure_time" : "08:25:25" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "08:29:07" , 
"departure_time" : "08:30:14" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "08:33:07" , 
"departure_time" : "08:34:13" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "08:38:06" , 
"departure_time" : "08:38:20" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "08:41:14" , 
"departure_time" : "08:42:08" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "08:48:54" , 
"departure_time" : "08:50:01" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "08:53:07" , 
"departure_time" : "08:54:35" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "08:56:28" , 
"departure_time" : "08:57:31" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:08:03" , 
"departure_time" : "09:08:10" , 
"distance_traveled" : 32.79
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:18:07" , 
"departure_time" : "09:18:43" , 
"distance_traveled" : 38.2237
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:31:36" , 
"departure_time" : "09:31:36" , 
"distance_traveled" : 43.2117
} ], 
"1915" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "15:45:00" , 
"departure_time" : "15:46:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "15:54:02" , 
"departure_time" : "15:54:04" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "16:00:02" , 
"departure_time" : "16:01:40" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "16:05:38" , 
"departure_time" : "16:06:36" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "16:08:58" , 
"departure_time" : "16:09:13" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "16:12:15" , 
"departure_time" : "16:13:07" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "16:16:52" , 
"departure_time" : "16:17:23" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:22:31" , 
"departure_time" : "16:23:19" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "16:27:48" , 
"departure_time" : "16:29:19" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "16:31:31" , 
"departure_time" : "16:33:05" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:43:34" , 
"departure_time" : "16:44:39" , 
"distance_traveled" : 32.7898
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:54:05" , 
"departure_time" : "16:55:41" , 
"distance_traveled" : 38.2235
}, 
{ 
"stop_id" : 105,
"arrival_time" : "17:07:36" , 
"departure_time" : "17:07:36" , 
"distance_traveled" : 43.2116
} ], 
"1916" :  [ 
{ 
"stop_id" : 92,
"arrival_time" : "06:02:00" , 
"departure_time" : "06:04:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 30,
"arrival_time" : "06:05:55" , 
"departure_time" : "06:06:56" , 
"distance_traveled" : 2.0962
}, 
{ 
"stop_id" : 77,
"arrival_time" : "06:10:01" , 
"departure_time" : "06:10:43" , 
"distance_traveled" : 4.2617
}, 
{ 
"stop_id" : 27,
"arrival_time" : "06:13:42" , 
"departure_time" : "06:13:56" , 
"distance_traveled" : 6.2794
}, 
{ 
"stop_id" : 145,
"arrival_time" : "06:19:14" , 
"departure_time" : "06:20:05" , 
"distance_traveled" : 9.7277
}, 
{ 
"stop_id" : 81,
"arrival_time" : "06:27:51" , 
"departure_time" : "06:29:23" , 
"distance_traveled" : 14.678
}, 
{ 
"stop_id" : 140,
"arrival_time" : "06:31:32" , 
"departure_time" : "06:32:27" , 
"distance_traveled" : 15.9604
}, 
{ 
"stop_id" : 97,
"arrival_time" : "06:33:55" , 
"departure_time" : "06:34:45" , 
"distance_traveled" : 16.732
}, 
{ 
"stop_id" : 61,
"arrival_time" : "06:36:50" , 
"departure_time" : "06:37:01" , 
"distance_traveled" : 17.66
}, 
{ 
"stop_id" : 112,
"arrival_time" : "06:39:11" , 
"departure_time" : "06:40:33" , 
"distance_traveled" : 18.3678
}, 
{ 
"stop_id" : 23,
"arrival_time" : "06:43:22" , 
"departure_time" : "06:43:54" , 
"distance_traveled" : 19.2688
}, 
{ 
"stop_id" : 37,
"arrival_time" : "06:45:32" , 
"departure_time" : "06:47:07" , 
"distance_traveled" : 19.7966
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:51:35" , 
"departure_time" : "06:51:50" , 
"distance_traveled" : 22.0443
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:07:15" , 
"departure_time" : "07:07:15" , 
"distance_traveled" : 29.8326
} ], 
"1917" :  [ 
{ 
"stop_id" : 92,
"arrival_time" : "08:49:00" , 
"departure_time" : "08:50:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 30,
"arrival_time" : "08:53:03" , 
"departure_time" : "08:54:31" , 
"distance_traveled" : 2.0962
}, 
{ 
"stop_id" : 77,
"arrival_time" : "08:57:28" , 
"departure_time" : "08:57:45" , 
"distance_traveled" : 4.2617
}, 
{ 
"stop_id" : 27,
"arrival_time" : "09:00:17" , 
"departure_time" : "09:01:25" , 
"distance_traveled" : 6.2794
}, 
{ 
"stop_id" : 145,
"arrival_time" : "09:06:08" , 
"departure_time" : "09:07:07" , 
"distance_traveled" : 9.7277
}, 
{ 
"stop_id" : 136,
"arrival_time" : "09:10:59" , 
"departure_time" : "09:11:36" , 
"distance_traveled" : 11.9956
}, 
{ 
"stop_id" : 87,
"arrival_time" : "09:13:37" , 
"departure_time" : "09:14:52" , 
"distance_traveled" : 13.0701
}, 
{ 
"stop_id" : 81,
"arrival_time" : "09:17:15" , 
"departure_time" : "09:18:18" , 
"distance_traveled" : 14.6788
}, 
{ 
"stop_id" : 140,
"arrival_time" : "09:20:03" , 
"departure_time" : "09:21:36" , 
"distance_traveled" : 15.9612
}, 
{ 
"stop_id" : 112,
"arrival_time" : "09:24:33" , 
"departure_time" : "09:26:12" , 
"distance_traveled" : 18.3684
}, 
{ 
"stop_id" : 23,
"arrival_time" : "09:26:39" , 
"departure_time" : "09:27:55" , 
"distance_traveled" : 19.2693
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:31:16" , 
"departure_time" : "09:32:17" , 
"distance_traveled" : 22.0449
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:47:01" , 
"departure_time" : "09:47:01" , 
"distance_traveled" : 29.8331
} ], 
"1918" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "17:50:00" , 
"departure_time" : "17:51:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "17:57:05" , 
"departure_time" : "17:57:08" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "18:04:03" , 
"departure_time" : "18:04:24" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "18:08:21" , 
"departure_time" : "18:08:33" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "18:12:12" , 
"departure_time" : "18:13:49" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "18:17:37" , 
"departure_time" : "18:19:14" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "18:21:37" , 
"departure_time" : "18:22:35" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:26:58" , 
"departure_time" : "18:28:36" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "18:32:38" , 
"departure_time" : "18:34:00" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:35:22" , 
"departure_time" : "18:35:40" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:37:18" , 
"departure_time" : "18:38:52" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:42:34" , 
"departure_time" : "18:42:49" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 23,
"arrival_time" : "18:46:15" , 
"departure_time" : "18:46:43" , 
"distance_traveled" : 30.0235
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:52:28" , 
"departure_time" : "18:52:43" , 
"distance_traveled" : 32.7991
}, 
{ 
"stop_id" : 105,
"arrival_time" : "19:14:15" , 
"departure_time" : "19:14:15" , 
"distance_traveled" : 43.221
} ], 
"1919" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "05:33:00" , 
"departure_time" : "05:33:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "05:40:03" , 
"departure_time" : "05:40:17" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "05:47:14" , 
"departure_time" : "05:48:00" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "05:52:46" , 
"departure_time" : "05:53:26" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "05:56:40" , 
"departure_time" : "05:57:13" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "06:01:33" , 
"departure_time" : "06:02:52" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "06:06:19" , 
"departure_time" : "06:06:45" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "06:11:26" , 
"departure_time" : "06:12:39" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 81,
"arrival_time" : "06:19:13" , 
"departure_time" : "06:19:43" , 
"distance_traveled" : 25.4335
}, 
{ 
"stop_id" : 140,
"arrival_time" : "06:22:30" , 
"departure_time" : "06:23:03" , 
"distance_traveled" : 26.7159
}, 
{ 
"stop_id" : 23,
"arrival_time" : "06:28:33" , 
"departure_time" : "06:30:03" , 
"distance_traveled" : 30.0227
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:34:30" , 
"departure_time" : "06:35:45" , 
"distance_traveled" : 32.7983
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:46:15" , 
"departure_time" : "06:47:01" , 
"distance_traveled" : 38.232
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:58:46" , 
"departure_time" : "06:58:46" , 
"distance_traveled" : 43.2201
} ], 
"1920" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "18:27:00" , 
"departure_time" : "18:28:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "18:36:25" , 
"departure_time" : "18:37:42" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "18:44:17" , 
"departure_time" : "18:44:57" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "18:47:40" , 
"departure_time" : "18:49:10" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "18:52:30" , 
"departure_time" : "18:52:32" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "18:55:02" , 
"departure_time" : "18:55:34" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "18:59:32" , 
"departure_time" : "19:00:15" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "19:06:43" , 
"departure_time" : "19:07:46" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 87,
"arrival_time" : "19:13:03" , 
"departure_time" : "19:14:36" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "19:17:33" , 
"departure_time" : "19:19:12" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "19:20:39" , 
"departure_time" : "19:21:27" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 112,
"arrival_time" : "19:24:48" , 
"departure_time" : "19:25:12" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "19:27:24" , 
"departure_time" : "19:28:54" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:34:30" , 
"departure_time" : "19:35:26" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:43:56" , 
"departure_time" : "19:44:54" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "19:56:58" , 
"departure_time" : "19:56:58" , 
"distance_traveled" : 43.2223
} ], 
"1921" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "05:54:00" , 
"departure_time" : "05:55:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "06:01:48" , 
"departure_time" : "06:02:00" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "06:04:12" , 
"departure_time" : "06:04:45" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "06:10:33" , 
"departure_time" : "06:12:04" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "06:15:31" , 
"departure_time" : "06:16:50" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "06:19:19" , 
"departure_time" : "06:19:48" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "06:22:29" , 
"departure_time" : "06:23:59" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "06:27:30" , 
"departure_time" : "06:27:52" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "06:33:22" , 
"departure_time" : "06:34:40" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "06:39:18" , 
"departure_time" : "06:40:30" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "06:42:12" , 
"departure_time" : "06:42:18" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:55:06" , 
"departure_time" : "06:55:38" , 
"distance_traveled" : 32.79
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:05:32" , 
"departure_time" : "07:07:03" , 
"distance_traveled" : 38.2237
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:19:31" , 
"departure_time" : "07:19:31" , 
"distance_traveled" : 43.2117
} ], 
"1922" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "19:58:00" , 
"departure_time" : "20:00:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "20:05:44" , 
"departure_time" : "20:06:24" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "20:11:40" , 
"departure_time" : "20:12:35" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "20:15:55" , 
"departure_time" : "20:16:12" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "20:19:17" , 
"departure_time" : "20:20:54" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "20:24:37" , 
"departure_time" : "20:24:55" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "20:27:18" , 
"departure_time" : "20:27:53" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "20:33:35" , 
"departure_time" : "20:34:13" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "20:38:38" , 
"departure_time" : "20:38:58" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "20:41:20" , 
"departure_time" : "20:42:35" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "20:46:15" , 
"departure_time" : "20:46:27" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "20:48:12" , 
"departure_time" : "20:49:19" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 23,
"arrival_time" : "20:55:07" , 
"departure_time" : "20:55:57" , 
"distance_traveled" : 30.0235
}, 
{ 
"stop_id" : 106,
"arrival_time" : "21:00:50" , 
"departure_time" : "21:00:58" , 
"distance_traveled" : 32.7991
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:10:08" , 
"departure_time" : "21:10:17" , 
"distance_traveled" : 38.2328
}, 
{ 
"stop_id" : 105,
"arrival_time" : "21:23:09" , 
"departure_time" : "21:23:09" , 
"distance_traveled" : 43.2208
} ], 
"1923" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "08:08:00" , 
"departure_time" : "08:09:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "08:16:23" , 
"departure_time" : "08:17:24" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "08:18:01" , 
"departure_time" : "08:19:35" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "08:24:34" , 
"departure_time" : "08:26:07" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "08:29:33" , 
"departure_time" : "08:31:08" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "08:33:35" , 
"departure_time" : "08:34:44" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "08:38:09" , 
"departure_time" : "08:38:31" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "08:41:22" , 
"departure_time" : "08:42:43" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "08:49:21" , 
"departure_time" : "08:50:07" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "08:52:46" , 
"departure_time" : "08:53:55" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "08:56:09" , 
"departure_time" : "08:56:27" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:07:18" , 
"departure_time" : "09:08:12" , 
"distance_traveled" : 32.79
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:18:54" , 
"departure_time" : "09:19:06" , 
"distance_traveled" : 38.2237
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:31:12" , 
"departure_time" : "09:31:12" , 
"distance_traveled" : 43.2117
} ], 
"1924" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "13:58:00" , 
"departure_time" : "13:59:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "14:08:13" , 
"departure_time" : "14:09:32" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "14:15:19" , 
"departure_time" : "14:16:05" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "14:18:46" , 
"departure_time" : "14:19:40" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "14:22:54" , 
"departure_time" : "14:23:41" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "14:26:47" , 
"departure_time" : "14:27:01" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "14:30:14" , 
"departure_time" : "14:31:23" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "14:37:09" , 
"departure_time" : "14:38:05" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "14:40:56" , 
"departure_time" : "14:41:55" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "14:43:59" , 
"departure_time" : "14:44:41" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "14:47:42" , 
"departure_time" : "14:49:10" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "14:51:28" , 
"departure_time" : "14:51:39" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 112,
"arrival_time" : "14:55:11" , 
"departure_time" : "14:55:19" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "14:58:08" , 
"departure_time" : "14:58:52" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:04:44" , 
"departure_time" : "15:05:31" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 105,
"arrival_time" : "15:24:47" , 
"departure_time" : "15:24:47" , 
"distance_traveled" : 43.2223
} ], 
"1925" :  [ 
{ 
"stop_id" : 92,
"arrival_time" : "06:02:00" , 
"departure_time" : "06:03:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 30,
"arrival_time" : "06:06:12" , 
"departure_time" : "06:06:57" , 
"distance_traveled" : 2.0962
}, 
{ 
"stop_id" : 77,
"arrival_time" : "06:09:45" , 
"departure_time" : "06:10:59" , 
"distance_traveled" : 4.2617
}, 
{ 
"stop_id" : 27,
"arrival_time" : "06:14:14" , 
"departure_time" : "06:15:27" , 
"distance_traveled" : 6.2794
}, 
{ 
"stop_id" : 145,
"arrival_time" : "06:20:13" , 
"departure_time" : "06:21:43" , 
"distance_traveled" : 9.7277
}, 
{ 
"stop_id" : 81,
"arrival_time" : "06:28:30" , 
"departure_time" : "06:29:22" , 
"distance_traveled" : 14.678
}, 
{ 
"stop_id" : 140,
"arrival_time" : "06:30:52" , 
"departure_time" : "06:32:12" , 
"distance_traveled" : 15.9604
}, 
{ 
"stop_id" : 97,
"arrival_time" : "06:34:20" , 
"departure_time" : "06:35:38" , 
"distance_traveled" : 16.732
}, 
{ 
"stop_id" : 61,
"arrival_time" : "06:37:18" , 
"departure_time" : "06:38:40" , 
"distance_traveled" : 17.66
}, 
{ 
"stop_id" : 112,
"arrival_time" : "06:40:22" , 
"departure_time" : "06:41:44" , 
"distance_traveled" : 18.3678
}, 
{ 
"stop_id" : 23,
"arrival_time" : "06:43:22" , 
"departure_time" : "06:44:57" , 
"distance_traveled" : 19.2688
}, 
{ 
"stop_id" : 37,
"arrival_time" : "06:46:35" , 
"departure_time" : "06:47:04" , 
"distance_traveled" : 19.7966
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:50:29" , 
"departure_time" : "06:51:33" , 
"distance_traveled" : 22.0443
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:08:04" , 
"departure_time" : "07:08:04" , 
"distance_traveled" : 29.8326
} ], 
"1926" :  [ 
{ 
"stop_id" : 93,
"arrival_time" : "17:56:00" , 
"departure_time" : "17:57:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 101,
"arrival_time" : "18:01:53" , 
"departure_time" : "18:03:03" , 
"distance_traveled" : 2.1907
}, 
{ 
"stop_id" : 67,
"arrival_time" : "18:08:10" , 
"departure_time" : "18:08:56" , 
"distance_traveled" : 4.6784
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "18:12:46" , 
"departure_time" : "18:13:58" , 
"distance_traveled" : 7.1047
}, 
{ 
"stop_id" : 35,
"arrival_time" : "18:22:12" , 
"departure_time" : "18:22:23" , 
"distance_traveled" : 12.0525
}, 
{ 
"stop_id" : 34,
"arrival_time" : "18:28:11" , 
"departure_time" : "18:29:25" , 
"distance_traveled" : 16.261
}, 
{ 
"stop_id" : 91,
"arrival_time" : "18:36:14" , 
"departure_time" : "18:36:16" , 
"distance_traveled" : 20.5593
}, 
{ 
"stop_id" : 92,
"arrival_time" : "18:39:02" , 
"departure_time" : "18:40:38" , 
"distance_traveled" : 22.8
}, 
{ 
"stop_id" : 30,
"arrival_time" : "18:44:36" , 
"departure_time" : "18:46:07" , 
"distance_traveled" : 24.9042
}, 
{ 
"stop_id" : 77,
"arrival_time" : "18:48:31" , 
"departure_time" : "18:49:25" , 
"distance_traveled" : 27.0697
}, 
{ 
"stop_id" : 27,
"arrival_time" : "18:51:54" , 
"departure_time" : "18:53:02" , 
"distance_traveled" : 29.0873
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:59:08" , 
"departure_time" : "19:00:17" , 
"distance_traveled" : 32.5356
}, 
{ 
"stop_id" : 136,
"arrival_time" : "19:04:09" , 
"departure_time" : "19:04:51" , 
"distance_traveled" : 34.8036
}, 
{ 
"stop_id" : 87,
"arrival_time" : "19:06:42" , 
"departure_time" : "19:07:40" , 
"distance_traveled" : 35.878
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:19:58" , 
"departure_time" : "19:20:23" , 
"distance_traveled" : 44.8422
}, 
{ 
"stop_id" : 63,
"arrival_time" : "19:36:25" , 
"departure_time" : "19:36:25" , 
"distance_traveled" : 52.6305
} ], 
"1927" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "17:50:00" , 
"departure_time" : "17:51:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "17:58:14" , 
"departure_time" : "17:59:27" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "18:05:13" , 
"departure_time" : "18:05:23" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "18:08:10" , 
"departure_time" : "18:09:06" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "18:12:56" , 
"departure_time" : "18:13:13" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "18:16:17" , 
"departure_time" : "18:17:57" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "18:21:40" , 
"departure_time" : "18:22:57" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:27:17" , 
"departure_time" : "18:27:39" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "18:31:22" , 
"departure_time" : "18:32:49" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:35:27" , 
"departure_time" : "18:35:38" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:37:11" , 
"departure_time" : "18:38:28" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:42:17" , 
"departure_time" : "18:43:34" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 23,
"arrival_time" : "18:47:17" , 
"departure_time" : "18:48:50" , 
"distance_traveled" : 30.0235
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:53:33" , 
"departure_time" : "18:54:36" , 
"distance_traveled" : 32.7991
}, 
{ 
"stop_id" : 105,
"arrival_time" : "19:15:03" , 
"departure_time" : "19:15:03" , 
"distance_traveled" : 43.221
} ], 
"1928" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "15:20:00" , 
"departure_time" : "15:21:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "15:28:07" , 
"departure_time" : "15:29:45" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "15:36:38" , 
"departure_time" : "15:38:03" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "15:40:25" , 
"departure_time" : "15:41:08" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "15:43:43" , 
"departure_time" : "15:44:09" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "15:47:26" , 
"departure_time" : "15:47:36" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "15:51:10" , 
"departure_time" : "15:51:25" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "15:58:15" , 
"departure_time" : "15:59:14" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 81,
"arrival_time" : "16:06:59" , 
"departure_time" : "16:07:06" , 
"distance_traveled" : 25.4335
}, 
{ 
"stop_id" : 140,
"arrival_time" : "16:10:07" , 
"departure_time" : "16:11:20" , 
"distance_traveled" : 26.7159
}, 
{ 
"stop_id" : 97,
"arrival_time" : "16:13:13" , 
"departure_time" : "16:13:42" , 
"distance_traveled" : 27.4875
}, 
{ 
"stop_id" : 61,
"arrival_time" : "16:15:29" , 
"departure_time" : "16:15:44" , 
"distance_traveled" : 28.4155
}, 
{ 
"stop_id" : 112,
"arrival_time" : "16:18:15" , 
"departure_time" : "16:19:35" , 
"distance_traveled" : 29.1233
}, 
{ 
"stop_id" : 23,
"arrival_time" : "16:22:20" , 
"departure_time" : "16:23:20" , 
"distance_traveled" : 30.0242
}, 
{ 
"stop_id" : 37,
"arrival_time" : "16:25:00" , 
"departure_time" : "16:26:38" , 
"distance_traveled" : 30.5521
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:30:38" , 
"departure_time" : "16:32:07" , 
"distance_traveled" : 32.7998
}, 
{ 
"stop_id" : 105,
"arrival_time" : "16:53:29" , 
"departure_time" : "16:53:29" , 
"distance_traveled" : 43.2218
} ], 
"1929" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "18:27:00" , 
"departure_time" : "18:29:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "18:37:25" , 
"departure_time" : "18:37:27" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "18:43:02" , 
"departure_time" : "18:43:17" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "18:47:15" , 
"departure_time" : "18:48:47" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "18:52:32" , 
"departure_time" : "18:53:30" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "18:55:58" , 
"departure_time" : "18:56:33" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "18:59:35" , 
"departure_time" : "19:00:53" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "19:07:18" , 
"departure_time" : "19:08:48" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 87,
"arrival_time" : "19:13:30" , 
"departure_time" : "19:13:57" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "19:16:27" , 
"departure_time" : "19:17:17" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "19:19:50" , 
"departure_time" : "19:20:43" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 112,
"arrival_time" : "19:24:53" , 
"departure_time" : "19:25:47" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "19:27:54" , 
"departure_time" : "19:28:28" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:33:34" , 
"departure_time" : "19:33:59" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:43:25" , 
"departure_time" : "19:44:29" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "19:57:04" , 
"departure_time" : "19:57:04" , 
"distance_traveled" : 43.2223
} ], 
"1930" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "11:58:00" , 
"departure_time" : "12:00:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "12:08:33" , 
"departure_time" : "12:08:57" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "12:14:24" , 
"departure_time" : "12:15:00" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "12:18:36" , 
"departure_time" : "12:18:45" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "12:22:09" , 
"departure_time" : "12:23:12" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "12:27:03" , 
"departure_time" : "12:28:35" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "12:31:32" , 
"departure_time" : "12:32:05" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "12:36:33" , 
"departure_time" : "12:37:06" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "12:40:33" , 
"departure_time" : "12:42:07" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "12:44:34" , 
"departure_time" : "12:44:56" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "12:47:22" , 
"departure_time" : "12:48:17" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "12:50:55" , 
"departure_time" : "12:51:34" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 112,
"arrival_time" : "12:55:39" , 
"departure_time" : "12:57:07" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "12:59:28" , 
"departure_time" : "12:59:56" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 106,
"arrival_time" : "13:04:28" , 
"departure_time" : "13:04:56" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:14:28" , 
"departure_time" : "13:15:24" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "13:27:56" , 
"departure_time" : "13:27:56" , 
"distance_traveled" : 43.2222
} ], 
"1931" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "19:58:00" , 
"departure_time" : "20:00:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "20:06:28" , 
"departure_time" : "20:07:35" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "20:12:07" , 
"departure_time" : "20:12:13" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "20:15:06" , 
"departure_time" : "20:15:56" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "20:19:50" , 
"departure_time" : "20:20:41" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "20:23:51" , 
"departure_time" : "20:25:19" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "20:28:28" , 
"departure_time" : "20:30:00" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "20:34:32" , 
"departure_time" : "20:35:39" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "20:39:07" , 
"departure_time" : "20:40:19" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "20:42:12" , 
"departure_time" : "20:42:57" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "20:45:45" , 
"departure_time" : "20:46:10" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "20:48:25" , 
"departure_time" : "20:49:49" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 23,
"arrival_time" : "20:55:24" , 
"departure_time" : "20:56:10" , 
"distance_traveled" : 30.0235
}, 
{ 
"stop_id" : 106,
"arrival_time" : "21:00:46" , 
"departure_time" : "21:02:04" , 
"distance_traveled" : 32.7991
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:11:18" , 
"departure_time" : "21:11:33" , 
"distance_traveled" : 38.2328
}, 
{ 
"stop_id" : 105,
"arrival_time" : "21:23:15" , 
"departure_time" : "21:23:15" , 
"distance_traveled" : 43.2208
} ], 
"1932" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "12:58:00" , 
"departure_time" : "12:59:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "13:08:19" , 
"departure_time" : "13:09:22" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "13:15:03" , 
"departure_time" : "13:16:24" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "13:19:21" , 
"departure_time" : "13:20:53" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "13:23:32" , 
"departure_time" : "13:24:09" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "13:26:37" , 
"departure_time" : "13:26:53" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "13:30:16" , 
"departure_time" : "13:31:24" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "13:37:08" , 
"departure_time" : "13:38:14" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "13:41:06" , 
"departure_time" : "13:42:45" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "13:44:39" , 
"departure_time" : "13:46:02" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "13:48:23" , 
"departure_time" : "13:49:52" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "13:51:29" , 
"departure_time" : "13:51:35" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 112,
"arrival_time" : "13:55:06" , 
"departure_time" : "13:55:08" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "13:58:02" , 
"departure_time" : "13:58:35" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 106,
"arrival_time" : "14:04:33" , 
"departure_time" : "14:05:25" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:14:52" , 
"departure_time" : "14:15:07" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "14:27:15" , 
"departure_time" : "14:27:15" , 
"distance_traveled" : 43.2222
} ], 
"1933" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "13:58:00" , 
"departure_time" : "13:59:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "14:08:12" , 
"departure_time" : "14:09:42" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "14:15:30" , 
"departure_time" : "14:15:43" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "14:18:13" , 
"departure_time" : "14:19:11" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "14:22:58" , 
"departure_time" : "14:23:38" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "14:26:40" , 
"departure_time" : "14:27:04" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "14:30:24" , 
"departure_time" : "14:31:02" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "14:36:38" , 
"departure_time" : "14:38:09" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "14:41:31" , 
"departure_time" : "14:42:52" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "14:44:21" , 
"departure_time" : "14:44:36" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "14:47:15" , 
"departure_time" : "14:48:34" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "14:51:19" , 
"departure_time" : "14:52:40" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 112,
"arrival_time" : "14:56:21" , 
"departure_time" : "14:56:27" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "14:58:06" , 
"departure_time" : "14:58:23" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:04:17" , 
"departure_time" : "15:05:50" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 105,
"arrival_time" : "15:25:33" , 
"departure_time" : "15:25:33" , 
"distance_traveled" : 43.2223
} ], 
"1934" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "16:48:00" , 
"departure_time" : "16:50:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "16:55:50" , 
"departure_time" : "16:56:55" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "17:04:05" , 
"departure_time" : "17:05:06" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "17:08:01" , 
"departure_time" : "17:08:02" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "17:11:01" , 
"departure_time" : "17:11:02" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "17:15:01" , 
"departure_time" : "17:15:47" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "17:19:46" , 
"departure_time" : "17:20:57" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:27:11" , 
"departure_time" : "17:27:14" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "17:30:03" , 
"departure_time" : "17:30:19" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "17:33:16" , 
"departure_time" : "17:33:32" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "17:37:16" , 
"departure_time" : "17:37:52" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:41:36" , 
"departure_time" : "17:42:30" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 112,
"arrival_time" : "17:45:54" , 
"departure_time" : "17:46:56" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:50:02" , 
"departure_time" : "17:51:30" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:55:28" , 
"departure_time" : "17:55:43" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:05:15" , 
"departure_time" : "18:06:14" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:18:59" , 
"departure_time" : "18:18:59" , 
"distance_traveled" : 43.2222
} ], 
"1935" :  [ 
{ 
"stop_id" : 93,
"arrival_time" : "17:56:00" , 
"departure_time" : "17:58:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 101,
"arrival_time" : "18:02:09" , 
"departure_time" : "18:03:10" , 
"distance_traveled" : 2.1907
}, 
{ 
"stop_id" : 67,
"arrival_time" : "18:08:01" , 
"departure_time" : "18:09:27" , 
"distance_traveled" : 4.6784
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "18:13:26" , 
"departure_time" : "18:13:28" , 
"distance_traveled" : 7.1047
}, 
{ 
"stop_id" : 35,
"arrival_time" : "18:21:02" , 
"departure_time" : "18:21:10" , 
"distance_traveled" : 12.0525
}, 
{ 
"stop_id" : 34,
"arrival_time" : "18:28:08" , 
"departure_time" : "18:29:46" , 
"distance_traveled" : 16.261
}, 
{ 
"stop_id" : 91,
"arrival_time" : "18:36:38" , 
"departure_time" : "18:37:19" , 
"distance_traveled" : 20.5593
}, 
{ 
"stop_id" : 92,
"arrival_time" : "18:39:41" , 
"departure_time" : "18:40:35" , 
"distance_traveled" : 22.8
}, 
{ 
"stop_id" : 30,
"arrival_time" : "18:43:54" , 
"departure_time" : "18:44:44" , 
"distance_traveled" : 24.9042
}, 
{ 
"stop_id" : 77,
"arrival_time" : "18:47:50" , 
"departure_time" : "18:48:34" , 
"distance_traveled" : 27.0697
}, 
{ 
"stop_id" : 27,
"arrival_time" : "18:51:44" , 
"departure_time" : "18:53:12" , 
"distance_traveled" : 29.0873
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:59:28" , 
"departure_time" : "18:59:57" , 
"distance_traveled" : 32.5356
}, 
{ 
"stop_id" : 136,
"arrival_time" : "19:03:29" , 
"departure_time" : "19:03:48" , 
"distance_traveled" : 34.8036
}, 
{ 
"stop_id" : 87,
"arrival_time" : "19:06:19" , 
"departure_time" : "19:07:46" , 
"distance_traveled" : 35.878
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:20:27" , 
"departure_time" : "19:21:53" , 
"distance_traveled" : 44.8422
}, 
{ 
"stop_id" : 63,
"arrival_time" : "19:37:26" , 
"departure_time" : "19:37:26" , 
"distance_traveled" : 52.6305
} ], 
"1936" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "19:03:00" , 
"departure_time" : "19:05:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "19:10:58" , 
"departure_time" : "19:12:18" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "19:17:20" , 
"departure_time" : "19:18:44" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "19:21:24" , 
"departure_time" : "19:22:02" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "19:24:38" , 
"departure_time" : "19:24:51" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "19:27:13" , 
"departure_time" : "19:28:46" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "19:32:33" , 
"departure_time" : "19:34:10" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "19:39:37" , 
"departure_time" : "19:39:40" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "19:42:03" , 
"departure_time" : "19:43:09" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "19:46:06" , 
"departure_time" : "19:46:36" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "19:49:30" , 
"departure_time" : "19:50:48" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "19:53:18" , 
"departure_time" : "19:54:54" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 112,
"arrival_time" : "19:57:36" , 
"departure_time" : "19:57:52" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "20:00:16" , 
"departure_time" : "20:01:53" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 106,
"arrival_time" : "20:06:37" , 
"departure_time" : "20:06:39" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:16:02" , 
"departure_time" : "20:17:31" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "20:30:29" , 
"departure_time" : "20:30:29" , 
"distance_traveled" : 43.2222
} ], 
"1937" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "15:20:00" , 
"departure_time" : "15:21:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "15:28:24" , 
"departure_time" : "15:29:15" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "15:35:51" , 
"departure_time" : "15:37:24" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "15:40:33" , 
"departure_time" : "15:40:36" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "15:43:03" , 
"departure_time" : "15:43:23" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "15:47:20" , 
"departure_time" : "15:47:25" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "15:51:05" , 
"departure_time" : "15:51:50" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "15:58:45" , 
"departure_time" : "15:59:02" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 81,
"arrival_time" : "16:06:17" , 
"departure_time" : "16:06:45" , 
"distance_traveled" : 25.4335
}, 
{ 
"stop_id" : 140,
"arrival_time" : "16:10:28" , 
"departure_time" : "16:11:48" , 
"distance_traveled" : 26.7159
}, 
{ 
"stop_id" : 97,
"arrival_time" : "16:13:20" , 
"departure_time" : "16:14:48" , 
"distance_traveled" : 27.4875
}, 
{ 
"stop_id" : 61,
"arrival_time" : "16:16:28" , 
"departure_time" : "16:18:03" , 
"distance_traveled" : 28.4155
}, 
{ 
"stop_id" : 112,
"arrival_time" : "16:19:35" , 
"departure_time" : "16:20:05" , 
"distance_traveled" : 29.1233
}, 
{ 
"stop_id" : 23,
"arrival_time" : "16:21:30" , 
"departure_time" : "16:22:22" , 
"distance_traveled" : 30.0242
}, 
{ 
"stop_id" : 37,
"arrival_time" : "16:24:52" , 
"departure_time" : "16:26:07" , 
"distance_traveled" : 30.5521
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:30:15" , 
"departure_time" : "16:31:43" , 
"distance_traveled" : 32.7998
}, 
{ 
"stop_id" : 105,
"arrival_time" : "16:53:28" , 
"departure_time" : "16:53:28" , 
"distance_traveled" : 43.2218
} ], 
"1938" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "21:41:00" , 
"departure_time" : "21:44:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "21:50:34" , 
"departure_time" : "21:51:25" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "21:56:51" , 
"departure_time" : "21:57:27" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "22:00:36" , 
"departure_time" : "22:01:22" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "22:04:46" , 
"departure_time" : "22:06:00" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "22:09:14" , 
"departure_time" : "22:10:50" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "22:13:36" , 
"departure_time" : "22:15:15" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "22:19:39" , 
"departure_time" : "22:20:43" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "22:24:04" , 
"departure_time" : "22:25:09" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "22:27:05" , 
"departure_time" : "22:27:08" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "22:30:03" , 
"departure_time" : "22:31:40" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "22:34:37" , 
"departure_time" : "22:34:45" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 112,
"arrival_time" : "22:38:08" , 
"departure_time" : "22:39:13" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "22:42:05" , 
"departure_time" : "22:42:34" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 106,
"arrival_time" : "22:47:29" , 
"departure_time" : "22:47:37" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:58:08" , 
"departure_time" : "22:58:53" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "23:11:45" , 
"departure_time" : "23:11:45" , 
"distance_traveled" : 43.2222
} ], 
"1939" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "11:58:00" , 
"departure_time" : "11:59:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "12:08:13" , 
"departure_time" : "12:09:13" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "12:15:00" , 
"departure_time" : "12:15:06" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "12:18:06" , 
"departure_time" : "12:18:37" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "12:22:31" , 
"departure_time" : "12:24:08" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "12:27:37" , 
"departure_time" : "12:27:45" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "12:30:08" , 
"departure_time" : "12:30:14" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "12:36:06" , 
"departure_time" : "12:37:04" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "12:40:58" , 
"departure_time" : "12:41:08" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "12:43:10" , 
"departure_time" : "12:43:17" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "12:47:07" , 
"departure_time" : "12:48:03" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "12:50:56" , 
"departure_time" : "12:51:24" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 112,
"arrival_time" : "12:55:28" , 
"departure_time" : "12:55:48" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "12:58:20" , 
"departure_time" : "12:59:41" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 106,
"arrival_time" : "13:05:21" , 
"departure_time" : "13:05:51" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:14:30" , 
"departure_time" : "13:16:04" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "13:28:34" , 
"departure_time" : "13:28:34" , 
"distance_traveled" : 43.2222
} ], 
"1940" :  [ 
{ 
"stop_id" : 93,
"arrival_time" : "06:07:00" , 
"departure_time" : "06:09:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 101,
"arrival_time" : "06:12:34" , 
"departure_time" : "06:13:38" , 
"distance_traveled" : 2.1907
}, 
{ 
"stop_id" : 67,
"arrival_time" : "06:18:04" , 
"departure_time" : "06:18:42" , 
"distance_traveled" : 4.6784
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "06:22:38" , 
"departure_time" : "06:23:30" , 
"distance_traveled" : 7.1047
}, 
{ 
"stop_id" : 35,
"arrival_time" : "06:30:52" , 
"departure_time" : "06:31:12" , 
"distance_traveled" : 12.0525
}, 
{ 
"stop_id" : 34,
"arrival_time" : "06:37:20" , 
"departure_time" : "06:38:01" , 
"distance_traveled" : 16.261
}, 
{ 
"stop_id" : 94,
"arrival_time" : "06:39:41" , 
"departure_time" : "06:40:10" , 
"distance_traveled" : 16.8684
}, 
{ 
"stop_id" : 91,
"arrival_time" : "06:46:29" , 
"departure_time" : "06:47:18" , 
"distance_traveled" : 20.5595
}, 
{ 
"stop_id" : 92,
"arrival_time" : "06:50:49" , 
"departure_time" : "06:52:11" , 
"distance_traveled" : 22.8002
}, 
{ 
"stop_id" : 30,
"arrival_time" : "06:55:22" , 
"departure_time" : "06:55:34" , 
"distance_traveled" : 24.9044
}, 
{ 
"stop_id" : 77,
"arrival_time" : "06:58:12" , 
"departure_time" : "06:59:36" , 
"distance_traveled" : 27.0699
}, 
{ 
"stop_id" : 27,
"arrival_time" : "07:03:24" , 
"departure_time" : "07:04:52" , 
"distance_traveled" : 29.0875
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:10:28" , 
"departure_time" : "07:11:31" , 
"distance_traveled" : 32.5358
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:19:03" , 
"departure_time" : "07:20:43" , 
"distance_traveled" : 37.4862
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:23:40" , 
"departure_time" : "07:25:03" , 
"distance_traveled" : 38.7686
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:33:23" , 
"departure_time" : "07:34:16" , 
"distance_traveled" : 44.8508
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:50:53" , 
"departure_time" : "07:50:53" , 
"distance_traveled" : 52.639
} ], 
"1941" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "12:58:00" , 
"departure_time" : "12:59:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "13:07:32" , 
"departure_time" : "13:09:00" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "13:15:28" , 
"departure_time" : "13:16:58" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "13:19:30" , 
"departure_time" : "13:21:01" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "13:23:31" , 
"departure_time" : "13:24:46" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "13:27:15" , 
"departure_time" : "13:28:31" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "13:31:16" , 
"departure_time" : "13:31:48" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "13:36:32" , 
"departure_time" : "13:37:14" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "13:40:42" , 
"departure_time" : "13:41:38" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "13:43:56" , 
"departure_time" : "13:45:14" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "13:48:18" , 
"departure_time" : "13:48:43" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "13:50:25" , 
"departure_time" : "13:51:35" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 112,
"arrival_time" : "13:56:10" , 
"departure_time" : "13:56:25" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "13:58:15" , 
"departure_time" : "13:59:33" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 106,
"arrival_time" : "14:05:18" , 
"departure_time" : "14:05:44" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:14:26" , 
"departure_time" : "14:15:45" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "14:28:19" , 
"departure_time" : "14:28:19" , 
"distance_traveled" : 43.2222
} ], 
"1942" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "20:39:00" , 
"departure_time" : "20:41:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "20:48:17" , 
"departure_time" : "20:48:41" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "20:53:24" , 
"departure_time" : "20:54:27" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "20:58:03" , 
"departure_time" : "20:59:06" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "21:02:03" , 
"departure_time" : "21:03:37" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "21:06:34" , 
"departure_time" : "21:07:18" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "21:09:44" , 
"departure_time" : "21:10:41" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "21:15:57" , 
"departure_time" : "21:16:54" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "21:20:57" , 
"departure_time" : "21:22:28" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "21:24:31" , 
"departure_time" : "21:25:16" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "21:27:45" , 
"departure_time" : "21:28:20" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "21:30:35" , 
"departure_time" : "21:31:51" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 112,
"arrival_time" : "21:36:16" , 
"departure_time" : "21:36:23" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "21:38:07" , 
"departure_time" : "21:38:26" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 106,
"arrival_time" : "21:44:19" , 
"departure_time" : "21:44:34" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:54:15" , 
"departure_time" : "21:54:41" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "22:07:26" , 
"departure_time" : "22:07:26" , 
"distance_traveled" : 43.2225
} ], 
"1943" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "16:48:00" , 
"departure_time" : "16:48:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "16:55:05" , 
"departure_time" : "16:55:42" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "17:03:37" , 
"departure_time" : "17:03:52" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "17:07:15" , 
"departure_time" : "17:07:26" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "17:11:11" , 
"departure_time" : "17:12:10" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "17:15:59" , 
"departure_time" : "17:17:30" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "17:20:31" , 
"departure_time" : "17:21:29" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:26:58" , 
"departure_time" : "17:28:06" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "17:31:08" , 
"departure_time" : "17:32:40" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "17:34:32" , 
"departure_time" : "17:35:35" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "17:38:03" , 
"departure_time" : "17:39:36" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:42:33" , 
"departure_time" : "17:43:32" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 112,
"arrival_time" : "17:45:59" , 
"departure_time" : "17:47:09" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:50:10" , 
"departure_time" : "17:50:35" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:54:25" , 
"departure_time" : "17:55:33" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:06:08" , 
"departure_time" : "18:07:48" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:19:40" , 
"departure_time" : "18:19:40" , 
"distance_traveled" : 43.2222
} ], 
"1944" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "04:16:00" , 
"departure_time" : "04:17:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "04:23:15" , 
"departure_time" : "04:24:16" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "04:27:01" , 
"departure_time" : "04:27:26" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "04:31:25" , 
"departure_time" : "04:31:54" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "04:35:29" , 
"departure_time" : "04:36:00" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "04:39:31" , 
"departure_time" : "04:40:05" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "04:43:34" , 
"departure_time" : "04:45:07" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "04:47:33" , 
"departure_time" : "04:47:59" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "04:53:26" , 
"departure_time" : "04:54:55" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "04:58:29" , 
"departure_time" : "04:58:36" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "05:00:07" , 
"departure_time" : "05:01:11" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "05:05:04" , 
"departure_time" : "05:05:21" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "05:08:17" , 
"departure_time" : "05:08:50" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 112,
"arrival_time" : "05:12:33" , 
"departure_time" : "05:13:20" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "05:16:47" , 
"departure_time" : "05:17:28" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 106,
"arrival_time" : "05:21:41" , 
"departure_time" : "05:22:24" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:31:43" , 
"departure_time" : "05:32:28" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "05:44:45" , 
"departure_time" : "05:44:45" , 
"distance_traveled" : 43.2223
} ], 
"1945" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "19:03:00" , 
"departure_time" : "19:05:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "19:11:29" , 
"departure_time" : "19:11:45" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "19:16:16" , 
"departure_time" : "19:17:42" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "19:21:26" , 
"departure_time" : "19:21:57" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "19:24:31" , 
"departure_time" : "19:25:05" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "19:27:34" , 
"departure_time" : "19:28:55" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "19:32:21" , 
"departure_time" : "19:32:53" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "19:38:32" , 
"departure_time" : "19:39:20" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "19:42:48" , 
"departure_time" : "19:43:05" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "19:45:17" , 
"departure_time" : "19:46:34" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "19:50:17" , 
"departure_time" : "19:51:53" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "19:53:36" , 
"departure_time" : "19:54:07" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 112,
"arrival_time" : "19:56:31" , 
"departure_time" : "19:57:56" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "20:01:25" , 
"departure_time" : "20:01:37" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 106,
"arrival_time" : "20:05:12" , 
"departure_time" : "20:06:04" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:16:52" , 
"departure_time" : "20:17:55" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "20:30:03" , 
"departure_time" : "20:30:03" , 
"distance_traveled" : 43.2222
} ], 
"1946" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "05:01:00" , 
"departure_time" : "05:02:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "05:08:23" , 
"departure_time" : "05:09:05" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "05:10:42" , 
"departure_time" : "05:11:15" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "05:16:33" , 
"departure_time" : "05:17:39" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "05:21:06" , 
"departure_time" : "05:22:06" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "05:25:00" , 
"departure_time" : "05:25:43" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "05:28:43" , 
"departure_time" : "05:28:55" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "05:32:12" , 
"departure_time" : "05:33:48" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "05:39:36" , 
"departure_time" : "05:40:24" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "05:42:48" , 
"departure_time" : "05:43:23" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "05:45:35" , 
"departure_time" : "05:46:18" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "05:49:43" , 
"departure_time" : "05:49:46" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "05:52:03" , 
"departure_time" : "05:53:39" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 112,
"arrival_time" : "05:58:36" , 
"departure_time" : "05:59:58" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "06:01:22" , 
"departure_time" : "06:02:43" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:07:21" , 
"departure_time" : "06:08:28" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:17:07" , 
"departure_time" : "06:17:57" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:29:50" , 
"departure_time" : "06:29:50" , 
"distance_traveled" : 43.2223
} ], 
"1947" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "21:41:00" , 
"departure_time" : "21:42:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "21:49:57" , 
"departure_time" : "21:50:08" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "21:56:11" , 
"departure_time" : "21:56:30" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "22:00:19" , 
"departure_time" : "22:01:35" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "22:05:16" , 
"departure_time" : "22:06:11" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "22:08:55" , 
"departure_time" : "22:09:59" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "22:13:04" , 
"departure_time" : "22:13:25" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "22:18:21" , 
"departure_time" : "22:18:24" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "22:23:03" , 
"departure_time" : "22:23:17" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "22:26:14" , 
"departure_time" : "22:27:01" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "22:30:47" , 
"departure_time" : "22:31:36" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "22:33:49" , 
"departure_time" : "22:34:52" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 112,
"arrival_time" : "22:39:03" , 
"departure_time" : "22:39:40" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "22:41:37" , 
"departure_time" : "22:42:44" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 106,
"arrival_time" : "22:48:07" , 
"departure_time" : "22:48:12" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:58:05" , 
"departure_time" : "22:58:49" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "23:11:44" , 
"departure_time" : "23:11:44" , 
"distance_traveled" : 43.2222
} ], 
"1948" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "14:39:00" , 
"departure_time" : "14:40:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "14:48:54" , 
"departure_time" : "14:49:29" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "14:51:35" , 
"departure_time" : "14:52:50" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "14:58:15" , 
"departure_time" : "14:59:07" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "15:01:52" , 
"departure_time" : "15:02:08" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "15:05:16" , 
"departure_time" : "15:06:30" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "15:10:14" , 
"departure_time" : "15:10:45" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "15:13:31" , 
"departure_time" : "15:13:45" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "15:19:14" , 
"departure_time" : "15:20:32" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "15:24:18" , 
"departure_time" : "15:24:55" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "15:26:37" , 
"departure_time" : "15:27:18" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "15:30:41" , 
"departure_time" : "15:32:02" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "15:34:21" , 
"departure_time" : "15:35:47" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 112,
"arrival_time" : "15:39:26" , 
"departure_time" : "15:39:27" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "15:41:01" , 
"departure_time" : "15:42:09" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:48:08" , 
"departure_time" : "15:48:36" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:57:28" , 
"departure_time" : "15:58:42" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "16:12:14" , 
"departure_time" : "16:12:14" , 
"distance_traveled" : 43.2223
} ], 
"1949" :  [ 
{ 
"stop_id" : 93,
"arrival_time" : "06:07:00" , 
"departure_time" : "06:09:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 101,
"arrival_time" : "06:13:25" , 
"departure_time" : "06:14:37" , 
"distance_traveled" : 2.1907
}, 
{ 
"stop_id" : 67,
"arrival_time" : "06:18:12" , 
"departure_time" : "06:19:36" , 
"distance_traveled" : 4.6784
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "06:23:24" , 
"departure_time" : "06:24:09" , 
"distance_traveled" : 7.1047
}, 
{ 
"stop_id" : 35,
"arrival_time" : "06:30:45" , 
"departure_time" : "06:31:55" , 
"distance_traveled" : 12.0525
}, 
{ 
"stop_id" : 34,
"arrival_time" : "06:38:10" , 
"departure_time" : "06:39:24" , 
"distance_traveled" : 16.261
}, 
{ 
"stop_id" : 94,
"arrival_time" : "06:40:14" , 
"departure_time" : "06:41:27" , 
"distance_traveled" : 16.8684
}, 
{ 
"stop_id" : 91,
"arrival_time" : "06:47:13" , 
"departure_time" : "06:47:58" , 
"distance_traveled" : 20.5595
}, 
{ 
"stop_id" : 92,
"arrival_time" : "06:50:45" , 
"departure_time" : "06:51:33" , 
"distance_traveled" : 22.8002
}, 
{ 
"stop_id" : 30,
"arrival_time" : "06:54:48" , 
"departure_time" : "06:54:58" , 
"distance_traveled" : 24.9044
}, 
{ 
"stop_id" : 77,
"arrival_time" : "06:58:10" , 
"departure_time" : "06:58:52" , 
"distance_traveled" : 27.0699
}, 
{ 
"stop_id" : 27,
"arrival_time" : "07:02:42" , 
"departure_time" : "07:04:08" , 
"distance_traveled" : 29.0875
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:10:26" , 
"departure_time" : "07:11:11" , 
"distance_traveled" : 32.5358
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:18:45" , 
"departure_time" : "07:19:56" , 
"distance_traveled" : 37.4862
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:23:11" , 
"departure_time" : "07:24:39" , 
"distance_traveled" : 38.7686
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:33:28" , 
"departure_time" : "07:34:04" , 
"distance_traveled" : 44.8508
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:50:36" , 
"departure_time" : "07:50:36" , 
"distance_traveled" : 52.639
} ], 
"1950" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "16:03:00" , 
"departure_time" : "16:03:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "16:10:03" , 
"departure_time" : "16:10:24" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "16:12:21" , 
"departure_time" : "16:12:55" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "16:18:34" , 
"departure_time" : "16:19:55" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "16:23:21" , 
"departure_time" : "16:24:49" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "16:27:28" , 
"departure_time" : "16:28:31" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "16:31:03" , 
"departure_time" : "16:31:44" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "16:34:41" , 
"departure_time" : "16:36:12" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:41:31" , 
"departure_time" : "16:43:05" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "16:45:34" , 
"departure_time" : "16:46:11" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "16:47:37" , 
"departure_time" : "16:48:46" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "16:52:09" , 
"departure_time" : "16:53:33" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "16:55:24" , 
"departure_time" : "16:57:01" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 112,
"arrival_time" : "17:00:37" , 
"departure_time" : "17:01:05" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:02:28" , 
"departure_time" : "17:03:26" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:08:58" , 
"departure_time" : "17:09:57" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:19:59" , 
"departure_time" : "17:20:48" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "17:31:49" , 
"departure_time" : "17:31:49" , 
"distance_traveled" : 43.2223
} ], 
"1951" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "20:39:00" , 
"departure_time" : "20:40:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "20:48:03" , 
"departure_time" : "20:49:27" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "20:54:24" , 
"departure_time" : "20:54:52" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "20:57:28" , 
"departure_time" : "20:58:17" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "21:01:49" , 
"departure_time" : "21:02:56" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "21:06:07" , 
"departure_time" : "21:07:06" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "21:09:59" , 
"departure_time" : "21:10:38" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "21:15:39" , 
"departure_time" : "21:16:02" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "21:20:23" , 
"departure_time" : "21:21:45" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "21:24:22" , 
"departure_time" : "21:24:47" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "21:27:25" , 
"departure_time" : "21:28:15" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "21:30:50" , 
"departure_time" : "21:30:51" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 112,
"arrival_time" : "21:35:01" , 
"departure_time" : "21:35:09" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "21:38:08" , 
"departure_time" : "21:38:34" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 106,
"arrival_time" : "21:44:26" , 
"departure_time" : "21:45:26" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:55:00" , 
"departure_time" : "21:56:04" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "22:08:04" , 
"departure_time" : "22:08:04" , 
"distance_traveled" : 43.2225
} ], 
"1952" :  [ 
{ 
"stop_id" : 54,
"arrival_time" : "06:42:00" , 
"departure_time" : "06:44:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 93,
"arrival_time" : "06:54:31" , 
"departure_time" : "06:56:08" , 
"distance_traveled" : 7.3807
}, 
{ 
"stop_id" : 101,
"arrival_time" : "06:59:37" , 
"departure_time" : "07:00:44" , 
"distance_traveled" : 9.5714
}, 
{ 
"stop_id" : 67,
"arrival_time" : "07:04:07" , 
"departure_time" : "07:04:33" , 
"distance_traveled" : 12.0591
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "07:07:26" , 
"departure_time" : "07:08:25" , 
"distance_traveled" : 14.4854
}, 
{ 
"stop_id" : 35,
"arrival_time" : "07:15:59" , 
"departure_time" : "07:17:08" , 
"distance_traveled" : 19.4331
}, 
{ 
"stop_id" : 34,
"arrival_time" : "07:23:09" , 
"departure_time" : "07:23:18" , 
"distance_traveled" : 23.6417
}, 
{ 
"stop_id" : 94,
"arrival_time" : "07:25:09" , 
"departure_time" : "07:25:19" , 
"distance_traveled" : 24.2491
}, 
{ 
"stop_id" : 91,
"arrival_time" : "07:32:10" , 
"departure_time" : "07:32:33" , 
"distance_traveled" : 27.9402
}, 
{ 
"stop_id" : 92,
"arrival_time" : "07:36:23" , 
"departure_time" : "07:36:51" , 
"distance_traveled" : 30.1809
}, 
{ 
"stop_id" : 30,
"arrival_time" : "07:41:28" , 
"departure_time" : "07:42:56" , 
"distance_traveled" : 32.285
}, 
{ 
"stop_id" : 77,
"arrival_time" : "07:46:28" , 
"departure_time" : "07:47:01" , 
"distance_traveled" : 34.4506
}, 
{ 
"stop_id" : 27,
"arrival_time" : "07:49:33" , 
"departure_time" : "07:50:17" , 
"distance_traveled" : 36.4682
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:57:44" , 
"departure_time" : "07:57:47" , 
"distance_traveled" : 39.9165
}, 
{ 
"stop_id" : 136,
"arrival_time" : "08:02:03" , 
"departure_time" : "08:03:15" , 
"distance_traveled" : 42.1845
}, 
{ 
"stop_id" : 87,
"arrival_time" : "08:06:12" , 
"departure_time" : "08:07:10" , 
"distance_traveled" : 43.2589
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:18:58" , 
"departure_time" : "08:20:30" , 
"distance_traveled" : 52.2231
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:35:32" , 
"departure_time" : "08:35:32" , 
"distance_traveled" : 60.0114
} ], 
"1953" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "04:16:00" , 
"departure_time" : "04:18:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "04:24:17" , 
"departure_time" : "04:25:06" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "04:26:49" , 
"departure_time" : "04:27:26" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "04:31:37" , 
"departure_time" : "04:32:09" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "04:35:32" , 
"departure_time" : "04:35:44" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "04:39:12" , 
"departure_time" : "04:40:16" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "04:44:04" , 
"departure_time" : "04:44:09" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "04:46:05" , 
"departure_time" : "04:46:11" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "04:53:06" , 
"departure_time" : "04:53:33" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "04:57:27" , 
"departure_time" : "04:57:46" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "05:00:19" , 
"departure_time" : "05:00:43" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "05:04:24" , 
"departure_time" : "05:04:50" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "05:08:26" , 
"departure_time" : "05:08:40" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 112,
"arrival_time" : "05:12:14" , 
"departure_time" : "05:13:46" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "05:17:32" , 
"departure_time" : "05:19:10" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 106,
"arrival_time" : "05:22:38" , 
"departure_time" : "05:22:52" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:31:14" , 
"departure_time" : "05:31:25" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "05:44:11" , 
"departure_time" : "05:44:11" , 
"distance_traveled" : 43.2223
} ], 
"1954" :  [ 
{ 
"stop_id" : 54,
"arrival_time" : "16:51:00" , 
"departure_time" : "16:52:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 93,
"arrival_time" : "17:03:28" , 
"departure_time" : "17:04:45" , 
"distance_traveled" : 7.3807
}, 
{ 
"stop_id" : 101,
"arrival_time" : "17:07:17" , 
"departure_time" : "17:07:50" , 
"distance_traveled" : 9.5714
}, 
{ 
"stop_id" : 67,
"arrival_time" : "17:13:33" , 
"departure_time" : "17:14:05" , 
"distance_traveled" : 12.0591
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "17:17:32" , 
"departure_time" : "17:18:10" , 
"distance_traveled" : 14.4854
}, 
{ 
"stop_id" : 35,
"arrival_time" : "17:26:38" , 
"departure_time" : "17:27:21" , 
"distance_traveled" : 19.4331
}, 
{ 
"stop_id" : 34,
"arrival_time" : "17:33:43" , 
"departure_time" : "17:34:29" , 
"distance_traveled" : 23.6417
}, 
{ 
"stop_id" : 94,
"arrival_time" : "17:36:46" , 
"departure_time" : "17:37:33" , 
"distance_traveled" : 24.2491
}, 
{ 
"stop_id" : 91,
"arrival_time" : "17:42:47" , 
"departure_time" : "17:43:22" , 
"distance_traveled" : 27.9402
}, 
{ 
"stop_id" : 92,
"arrival_time" : "17:46:35" , 
"departure_time" : "17:46:46" , 
"distance_traveled" : 30.1809
}, 
{ 
"stop_id" : 30,
"arrival_time" : "17:50:11" , 
"departure_time" : "17:51:25" , 
"distance_traveled" : 32.285
}, 
{ 
"stop_id" : 77,
"arrival_time" : "17:55:14" , 
"departure_time" : "17:56:29" , 
"distance_traveled" : 34.4506
}, 
{ 
"stop_id" : 27,
"arrival_time" : "17:59:15" , 
"departure_time" : "17:59:57" , 
"distance_traveled" : 36.4682
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:05:42" , 
"departure_time" : "18:06:18" , 
"distance_traveled" : 39.9165
}, 
{ 
"stop_id" : 136,
"arrival_time" : "18:10:36" , 
"departure_time" : "18:11:34" , 
"distance_traveled" : 42.1845
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:13:58" , 
"departure_time" : "18:14:50" , 
"distance_traveled" : 43.2589
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:27:52" , 
"departure_time" : "18:29:07" , 
"distance_traveled" : 52.2231
}, 
{ 
"stop_id" : 63,
"arrival_time" : "18:46:15" , 
"departure_time" : "18:46:15" , 
"distance_traveled" : 60.0114
} ], 
"1955" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "05:01:00" , 
"departure_time" : "05:03:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "05:09:30" , 
"departure_time" : "05:10:47" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "05:11:17" , 
"departure_time" : "05:12:53" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "05:17:36" , 
"departure_time" : "05:19:09" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "05:21:33" , 
"departure_time" : "05:21:59" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "05:24:26" , 
"departure_time" : "05:25:26" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "05:29:00" , 
"departure_time" : "05:30:38" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "05:33:38" , 
"departure_time" : "05:34:48" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "05:39:10" , 
"departure_time" : "05:40:43" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "05:43:33" , 
"departure_time" : "05:44:35" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "05:46:02" , 
"departure_time" : "05:47:00" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "05:49:58" , 
"departure_time" : "05:51:19" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "05:53:21" , 
"departure_time" : "05:53:32" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 112,
"arrival_time" : "05:57:11" , 
"departure_time" : "05:58:17" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "06:01:06" , 
"departure_time" : "06:02:12" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:07:06" , 
"departure_time" : "06:07:51" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:16:45" , 
"departure_time" : "06:16:55" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:29:10" , 
"departure_time" : "06:29:10" , 
"distance_traveled" : 43.2223
} ], 
"1956" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "20:26:00" , 
"departure_time" : "20:26:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "20:33:04" , 
"departure_time" : "20:33:36" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "20:40:32" , 
"departure_time" : "20:42:00" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "20:44:28" , 
"departure_time" : "20:45:07" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "20:47:39" , 
"departure_time" : "20:49:05" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "20:52:26" , 
"departure_time" : "20:53:15" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "20:55:49" , 
"departure_time" : "20:56:03" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "21:00:14" , 
"departure_time" : "21:01:47" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "21:05:33" , 
"departure_time" : "21:05:48" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "21:07:15" , 
"departure_time" : "21:07:19" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "21:11:04" , 
"departure_time" : "21:12:16" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "21:15:12" , 
"departure_time" : "21:16:14" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 97,
"arrival_time" : "21:17:02" , 
"departure_time" : "21:17:22" , 
"distance_traveled" : 27.4883
}, 
{ 
"stop_id" : 61,
"arrival_time" : "21:18:20" , 
"departure_time" : "21:18:47" , 
"distance_traveled" : 28.4163
}, 
{ 
"stop_id" : 112,
"arrival_time" : "21:20:27" , 
"departure_time" : "21:21:45" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "21:23:18" , 
"departure_time" : "21:23:48" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "21:24:30" , 
"departure_time" : "21:25:36" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "21:30:06" , 
"departure_time" : "21:30:33" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 63,
"arrival_time" : "21:46:27" , 
"departure_time" : "21:46:27" , 
"distance_traveled" : 40.5888
} ], 
"1957" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "14:39:00" , 
"departure_time" : "14:39:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "14:48:10" , 
"departure_time" : "14:49:32" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "14:52:22" , 
"departure_time" : "14:52:46" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "14:57:24" , 
"departure_time" : "14:58:19" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "15:01:55" , 
"departure_time" : "15:03:21" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "15:06:26" , 
"departure_time" : "15:06:44" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "15:09:18" , 
"departure_time" : "15:09:22" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "15:13:04" , 
"departure_time" : "15:14:34" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "15:20:30" , 
"departure_time" : "15:20:48" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "15:23:18" , 
"departure_time" : "15:24:40" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "15:27:22" , 
"departure_time" : "15:28:35" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "15:31:13" , 
"departure_time" : "15:32:11" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "15:33:58" , 
"departure_time" : "15:34:38" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 112,
"arrival_time" : "15:38:40" , 
"departure_time" : "15:39:16" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "15:41:36" , 
"departure_time" : "15:42:11" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:47:35" , 
"departure_time" : "15:48:17" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:57:42" , 
"departure_time" : "15:58:40" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "16:11:58" , 
"departure_time" : "16:11:58" , 
"distance_traveled" : 43.2223
} ], 
"1958" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "10:49:00" , 
"departure_time" : "10:50:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "10:58:27" , 
"departure_time" : "10:59:42" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "11:02:15" , 
"departure_time" : "11:03:39" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "11:08:24" , 
"departure_time" : "11:09:19" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "11:11:55" , 
"departure_time" : "11:13:30" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "11:16:35" , 
"departure_time" : "11:17:39" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "11:20:04" , 
"departure_time" : "11:21:16" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "11:24:12" , 
"departure_time" : "11:24:36" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "11:29:24" , 
"departure_time" : "11:29:34" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "11:33:10" , 
"departure_time" : "11:33:30" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "11:36:20" , 
"departure_time" : "11:37:19" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "11:40:59" , 
"departure_time" : "11:41:40" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "11:43:41" , 
"departure_time" : "11:44:12" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 112,
"arrival_time" : "11:48:31" , 
"departure_time" : "11:49:15" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "11:51:44" , 
"departure_time" : "11:52:24" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 106,
"arrival_time" : "11:57:40" , 
"departure_time" : "11:58:39" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:07:59" , 
"departure_time" : "12:08:58" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "12:21:59" , 
"departure_time" : "12:21:59" , 
"distance_traveled" : 43.2227
} ], 
"1959" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "16:03:00" , 
"departure_time" : "16:05:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "16:11:29" , 
"departure_time" : "16:12:20" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "16:12:51" , 
"departure_time" : "16:14:25" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "16:19:34" , 
"departure_time" : "16:20:16" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "16:22:42" , 
"departure_time" : "16:23:46" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "16:27:04" , 
"departure_time" : "16:28:03" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "16:30:59" , 
"departure_time" : "16:32:18" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "16:35:19" , 
"departure_time" : "16:35:20" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:40:01" , 
"departure_time" : "16:40:14" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "16:44:13" , 
"departure_time" : "16:45:15" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "16:48:02" , 
"departure_time" : "16:48:24" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "16:51:22" , 
"departure_time" : "16:52:59" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "16:55:37" , 
"departure_time" : "16:56:23" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 112,
"arrival_time" : "16:59:46" , 
"departure_time" : "17:01:14" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:03:28" , 
"departure_time" : "17:03:35" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:08:07" , 
"departure_time" : "17:08:39" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:19:32" , 
"departure_time" : "17:20:02" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "17:31:30" , 
"departure_time" : "17:31:30" , 
"distance_traveled" : 43.2223
} ], 
"1960" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "17:15:00" , 
"departure_time" : "17:15:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "17:23:17" , 
"departure_time" : "17:24:52" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "17:31:35" , 
"departure_time" : "17:32:45" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "17:35:10" , 
"departure_time" : "17:36:38" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "17:39:28" , 
"departure_time" : "17:41:08" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "17:43:40" , 
"departure_time" : "17:44:01" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "17:46:21" , 
"departure_time" : "17:47:02" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:52:41" , 
"departure_time" : "17:53:16" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "17:56:35" , 
"departure_time" : "17:58:08" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:00:33" , 
"departure_time" : "18:01:25" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:03:52" , 
"departure_time" : "18:05:17" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:07:25" , 
"departure_time" : "18:08:27" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 97,
"arrival_time" : "18:09:02" , 
"departure_time" : "18:09:26" , 
"distance_traveled" : 27.4883
}, 
{ 
"stop_id" : 61,
"arrival_time" : "18:10:24" , 
"departure_time" : "18:10:58" , 
"distance_traveled" : 28.4163
}, 
{ 
"stop_id" : 112,
"arrival_time" : "18:13:34" , 
"departure_time" : "18:14:19" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "18:16:45" , 
"departure_time" : "18:17:49" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "18:19:04" , 
"departure_time" : "18:19:42" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:23:38" , 
"departure_time" : "18:23:46" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:35:08" , 
"departure_time" : "18:35:40" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:48:32" , 
"departure_time" : "18:48:32" , 
"distance_traveled" : 43.2223
} ], 
"1961" :  [ 
{ 
"stop_id" : 54,
"arrival_time" : "06:42:00" , 
"departure_time" : "06:43:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 93,
"arrival_time" : "06:54:19" , 
"departure_time" : "06:54:33" , 
"distance_traveled" : 7.3807
}, 
{ 
"stop_id" : 101,
"arrival_time" : "06:58:14" , 
"departure_time" : "06:59:22" , 
"distance_traveled" : 9.5714
}, 
{ 
"stop_id" : 67,
"arrival_time" : "07:04:08" , 
"departure_time" : "07:05:26" , 
"distance_traveled" : 12.0591
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "07:08:18" , 
"departure_time" : "07:08:32" , 
"distance_traveled" : 14.4854
}, 
{ 
"stop_id" : 35,
"arrival_time" : "07:15:14" , 
"departure_time" : "07:15:24" , 
"distance_traveled" : 19.4331
}, 
{ 
"stop_id" : 34,
"arrival_time" : "07:22:10" , 
"departure_time" : "07:22:37" , 
"distance_traveled" : 23.6417
}, 
{ 
"stop_id" : 94,
"arrival_time" : "07:25:27" , 
"departure_time" : "07:25:46" , 
"distance_traveled" : 24.2491
}, 
{ 
"stop_id" : 91,
"arrival_time" : "07:32:19" , 
"departure_time" : "07:33:02" , 
"distance_traveled" : 27.9402
}, 
{ 
"stop_id" : 92,
"arrival_time" : "07:36:43" , 
"departure_time" : "07:36:52" , 
"distance_traveled" : 30.1809
}, 
{ 
"stop_id" : 30,
"arrival_time" : "07:41:09" , 
"departure_time" : "07:42:25" , 
"distance_traveled" : 32.285
}, 
{ 
"stop_id" : 77,
"arrival_time" : "07:46:16" , 
"departure_time" : "07:47:00" , 
"distance_traveled" : 34.4506
}, 
{ 
"stop_id" : 27,
"arrival_time" : "07:49:44" , 
"departure_time" : "07:50:23" , 
"distance_traveled" : 36.4682
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:57:39" , 
"departure_time" : "07:59:10" , 
"distance_traveled" : 39.9165
}, 
{ 
"stop_id" : 136,
"arrival_time" : "08:03:31" , 
"departure_time" : "08:04:41" , 
"distance_traveled" : 42.1845
}, 
{ 
"stop_id" : 87,
"arrival_time" : "08:06:10" , 
"departure_time" : "08:06:49" , 
"distance_traveled" : 43.2589
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:18:39" , 
"departure_time" : "08:19:31" , 
"distance_traveled" : 52.2231
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:34:52" , 
"departure_time" : "08:34:52" , 
"distance_traveled" : 60.0114
} ], 
"1962" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "16:19:00" , 
"departure_time" : "16:20:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "16:26:21" , 
"departure_time" : "16:27:01" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "16:28:40" , 
"departure_time" : "16:30:11" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "16:36:31" , 
"departure_time" : "16:37:01" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "16:38:30" , 
"departure_time" : "16:39:50" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "16:43:20" , 
"departure_time" : "16:43:56" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "16:46:36" , 
"departure_time" : "16:46:51" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "16:50:15" , 
"departure_time" : "16:50:17" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:57:02" , 
"departure_time" : "16:58:07" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "17:02:05" , 
"departure_time" : "17:02:16" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "17:04:11" , 
"departure_time" : "17:05:37" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "17:08:26" , 
"departure_time" : "17:09:32" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:12:06" , 
"departure_time" : "17:12:14" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 97,
"arrival_time" : "17:13:08" , 
"departure_time" : "17:14:03" , 
"distance_traveled" : 27.4884
}, 
{ 
"stop_id" : 61,
"arrival_time" : "17:16:55" , 
"departure_time" : "17:17:47" , 
"distance_traveled" : 28.4165
}, 
{ 
"stop_id" : 112,
"arrival_time" : "17:18:52" , 
"departure_time" : "17:19:25" , 
"distance_traveled" : 29.1242
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:21:33" , 
"departure_time" : "17:21:51" , 
"distance_traveled" : 30.0252
}, 
{ 
"stop_id" : 37,
"arrival_time" : "17:23:18" , 
"departure_time" : "17:24:03" , 
"distance_traveled" : 30.553
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:29:45" , 
"departure_time" : "17:29:58" , 
"distance_traveled" : 32.8008
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:47:13" , 
"departure_time" : "17:47:13" , 
"distance_traveled" : 40.589
} ], 
"1963" :  [ 
{ 
"stop_id" : 54,
"arrival_time" : "16:51:00" , 
"departure_time" : "16:51:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 93,
"arrival_time" : "17:02:04" , 
"departure_time" : "17:02:53" , 
"distance_traveled" : 7.3807
}, 
{ 
"stop_id" : 101,
"arrival_time" : "17:06:49" , 
"departure_time" : "17:06:50" , 
"distance_traveled" : 9.5714
}, 
{ 
"stop_id" : 67,
"arrival_time" : "17:13:01" , 
"departure_time" : "17:14:17" , 
"distance_traveled" : 12.0591
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "17:18:16" , 
"departure_time" : "17:18:45" , 
"distance_traveled" : 14.4854
}, 
{ 
"stop_id" : 35,
"arrival_time" : "17:26:29" , 
"departure_time" : "17:27:22" , 
"distance_traveled" : 19.4331
}, 
{ 
"stop_id" : 34,
"arrival_time" : "17:33:53" , 
"departure_time" : "17:34:21" , 
"distance_traveled" : 23.6417
}, 
{ 
"stop_id" : 94,
"arrival_time" : "17:36:28" , 
"departure_time" : "17:36:38" , 
"distance_traveled" : 24.2491
}, 
{ 
"stop_id" : 91,
"arrival_time" : "17:42:10" , 
"departure_time" : "17:43:24" , 
"distance_traveled" : 27.9402
}, 
{ 
"stop_id" : 92,
"arrival_time" : "17:47:14" , 
"departure_time" : "17:47:26" , 
"distance_traveled" : 30.1809
}, 
{ 
"stop_id" : 30,
"arrival_time" : "17:50:12" , 
"departure_time" : "17:50:22" , 
"distance_traveled" : 32.285
}, 
{ 
"stop_id" : 77,
"arrival_time" : "17:54:10" , 
"departure_time" : "17:54:59" , 
"distance_traveled" : 34.4506
}, 
{ 
"stop_id" : 27,
"arrival_time" : "17:58:49" , 
"departure_time" : "17:59:48" , 
"distance_traveled" : 36.4682
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:05:59" , 
"departure_time" : "18:06:32" , 
"distance_traveled" : 39.9165
}, 
{ 
"stop_id" : 136,
"arrival_time" : "18:10:33" , 
"departure_time" : "18:12:12" , 
"distance_traveled" : 42.1845
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:14:39" , 
"departure_time" : "18:15:20" , 
"distance_traveled" : 43.2589
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:27:41" , 
"departure_time" : "18:28:37" , 
"distance_traveled" : 52.2231
}, 
{ 
"stop_id" : 63,
"arrival_time" : "18:45:56" , 
"departure_time" : "18:45:56" , 
"distance_traveled" : 60.0114
} ], 
"1964" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "22:29:00" , 
"departure_time" : "22:31:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "22:37:06" , 
"departure_time" : "22:38:36" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "22:40:30" , 
"departure_time" : "22:41:36" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "22:46:06" , 
"departure_time" : "22:46:56" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "22:49:50" , 
"departure_time" : "22:51:05" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "22:53:15" , 
"departure_time" : "22:54:33" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "22:57:18" , 
"departure_time" : "22:58:07" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "23:00:49" , 
"departure_time" : "23:01:51" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "23:07:02" , 
"departure_time" : "23:07:32" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "23:10:30" , 
"departure_time" : "23:11:23" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "23:13:53" , 
"departure_time" : "23:14:06" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "23:16:13" , 
"departure_time" : "23:17:30" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "23:21:17" , 
"departure_time" : "23:22:10" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 97,
"arrival_time" : "23:22:53" , 
"departure_time" : "23:23:38" , 
"distance_traveled" : 27.4884
}, 
{ 
"stop_id" : 61,
"arrival_time" : "23:24:45" , 
"departure_time" : "23:25:59" , 
"distance_traveled" : 28.4165
}, 
{ 
"stop_id" : 112,
"arrival_time" : "23:27:14" , 
"departure_time" : "23:27:37" , 
"distance_traveled" : 29.1242
}, 
{ 
"stop_id" : 23,
"arrival_time" : "23:29:23" , 
"departure_time" : "23:30:07" , 
"distance_traveled" : 30.0252
}, 
{ 
"stop_id" : 37,
"arrival_time" : "23:31:44" , 
"departure_time" : "23:32:52" , 
"distance_traveled" : 30.553
}, 
{ 
"stop_id" : 106,
"arrival_time" : "23:37:08" , 
"departure_time" : "23:37:48" , 
"distance_traveled" : 32.8008
}, 
{ 
"stop_id" : 63,
"arrival_time" : "23:55:40" , 
"departure_time" : "23:55:40" , 
"distance_traveled" : 40.589
} ], 
"1965" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "20:26:00" , 
"departure_time" : "20:26:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "20:33:07" , 
"departure_time" : "20:34:25" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "20:41:18" , 
"departure_time" : "20:42:57" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "20:44:39" , 
"departure_time" : "20:46:17" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "20:48:38" , 
"departure_time" : "20:49:29" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "20:51:51" , 
"departure_time" : "20:53:25" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "20:56:34" , 
"departure_time" : "20:57:17" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "21:00:43" , 
"departure_time" : "21:01:53" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "21:05:10" , 
"departure_time" : "21:05:23" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "21:07:13" , 
"departure_time" : "21:07:36" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "21:11:23" , 
"departure_time" : "21:11:55" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "21:14:32" , 
"departure_time" : "21:15:53" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 97,
"arrival_time" : "21:17:21" , 
"departure_time" : "21:19:01" , 
"distance_traveled" : 27.4883
}, 
{ 
"stop_id" : 61,
"arrival_time" : "21:19:40" , 
"departure_time" : "21:20:21" , 
"distance_traveled" : 28.4163
}, 
{ 
"stop_id" : 112,
"arrival_time" : "21:20:41" , 
"departure_time" : "21:20:52" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "21:22:11" , 
"departure_time" : "21:22:26" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "21:24:15" , 
"departure_time" : "21:24:37" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "21:29:22" , 
"departure_time" : "21:29:37" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 63,
"arrival_time" : "21:46:15" , 
"departure_time" : "21:46:15" , 
"distance_traveled" : 40.5888
} ], 
"1966" :  [ 
{ 
"stop_id" : 54,
"arrival_time" : "20:32:00" , 
"departure_time" : "20:32:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 93,
"arrival_time" : "20:43:17" , 
"departure_time" : "20:44:56" , 
"distance_traveled" : 7.3807
}, 
{ 
"stop_id" : 101,
"arrival_time" : "20:49:39" , 
"departure_time" : "20:49:54" , 
"distance_traveled" : 9.5714
}, 
{ 
"stop_id" : 67,
"arrival_time" : "20:52:15" , 
"departure_time" : "20:53:08" , 
"distance_traveled" : 12.0591
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "20:56:53" , 
"departure_time" : "20:58:23" , 
"distance_traveled" : 14.4854
}, 
{ 
"stop_id" : 35,
"arrival_time" : "21:05:30" , 
"departure_time" : "21:06:39" , 
"distance_traveled" : 19.4331
}, 
{ 
"stop_id" : 34,
"arrival_time" : "21:11:09" , 
"departure_time" : "21:11:41" , 
"distance_traveled" : 23.6417
}, 
{ 
"stop_id" : 94,
"arrival_time" : "21:13:32" , 
"departure_time" : "21:15:05" , 
"distance_traveled" : 24.2491
}, 
{ 
"stop_id" : 91,
"arrival_time" : "21:20:33" , 
"departure_time" : "21:21:54" , 
"distance_traveled" : 27.9402
}, 
{ 
"stop_id" : 92,
"arrival_time" : "21:24:21" , 
"departure_time" : "21:25:42" , 
"distance_traveled" : 30.1809
}, 
{ 
"stop_id" : 30,
"arrival_time" : "21:28:21" , 
"departure_time" : "21:29:03" , 
"distance_traveled" : 32.285
}, 
{ 
"stop_id" : 77,
"arrival_time" : "21:31:42" , 
"departure_time" : "21:31:57" , 
"distance_traveled" : 34.4506
}, 
{ 
"stop_id" : 27,
"arrival_time" : "21:35:15" , 
"departure_time" : "21:35:22" , 
"distance_traveled" : 36.4682
}, 
{ 
"stop_id" : 145,
"arrival_time" : "21:41:07" , 
"departure_time" : "21:41:34" , 
"distance_traveled" : 39.9165
}, 
{ 
"stop_id" : 87,
"arrival_time" : "21:47:27" , 
"departure_time" : "21:48:11" , 
"distance_traveled" : 43.2591
}, 
{ 
"stop_id" : 140,
"arrival_time" : "21:53:44" , 
"departure_time" : "21:54:45" , 
"distance_traveled" : 46.1502
}, 
{ 
"stop_id" : 112,
"arrival_time" : "21:58:01" , 
"departure_time" : "21:58:07" , 
"distance_traveled" : 48.5574
}, 
{ 
"stop_id" : 23,
"arrival_time" : "22:00:06" , 
"departure_time" : "22:00:37" , 
"distance_traveled" : 49.4583
}, 
{ 
"stop_id" : 106,
"arrival_time" : "22:06:31" , 
"departure_time" : "22:07:56" , 
"distance_traveled" : 52.2339
}, 
{ 
"stop_id" : 63,
"arrival_time" : "22:25:25" , 
"departure_time" : "22:25:25" , 
"distance_traveled" : 60.0222
} ], 
"1967" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "10:49:00" , 
"departure_time" : "10:51:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "10:58:38" , 
"departure_time" : "10:59:43" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "11:02:05" , 
"departure_time" : "11:03:03" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "11:07:58" , 
"departure_time" : "11:08:50" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "11:11:52" , 
"departure_time" : "11:12:26" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "11:15:34" , 
"departure_time" : "11:17:03" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "11:20:29" , 
"departure_time" : "11:21:10" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "11:23:41" , 
"departure_time" : "11:25:11" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "11:30:30" , 
"departure_time" : "11:31:01" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "11:33:31" , 
"departure_time" : "11:34:43" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "11:37:12" , 
"departure_time" : "11:37:14" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "11:40:02" , 
"departure_time" : "11:41:31" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "11:44:29" , 
"departure_time" : "11:45:30" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 112,
"arrival_time" : "11:49:01" , 
"departure_time" : "11:50:36" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "11:52:35" , 
"departure_time" : "11:52:56" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 106,
"arrival_time" : "11:57:21" , 
"departure_time" : "11:57:45" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:07:24" , 
"departure_time" : "12:07:38" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "12:21:14" , 
"departure_time" : "12:21:14" , 
"distance_traveled" : 43.2227
} ], 
"1968" :  [ 
{ 
"stop_id" : 67,
"arrival_time" : "07:41:00" , 
"departure_time" : "07:42:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "07:46:15" , 
"departure_time" : "07:46:43" , 
"distance_traveled" : 2.4222
}, 
{ 
"stop_id" : 35,
"arrival_time" : "07:54:28" , 
"departure_time" : "07:54:37" , 
"distance_traveled" : 7.3699
}, 
{ 
"stop_id" : 34,
"arrival_time" : "08:00:09" , 
"departure_time" : "08:01:48" , 
"distance_traveled" : 11.5784
}, 
{ 
"stop_id" : 94,
"arrival_time" : "08:04:39" , 
"departure_time" : "08:05:18" , 
"distance_traveled" : 12.1858
}, 
{ 
"stop_id" : 91,
"arrival_time" : "08:10:39" , 
"departure_time" : "08:11:00" , 
"distance_traveled" : 15.8769
}, 
{ 
"stop_id" : 92,
"arrival_time" : "08:14:21" , 
"departure_time" : "08:14:22" , 
"distance_traveled" : 18.1176
}, 
{ 
"stop_id" : 30,
"arrival_time" : "08:18:01" , 
"departure_time" : "08:19:32" , 
"distance_traveled" : 20.2218
}, 
{ 
"stop_id" : 77,
"arrival_time" : "08:23:31" , 
"departure_time" : "08:24:01" , 
"distance_traveled" : 22.3873
}, 
{ 
"stop_id" : 27,
"arrival_time" : "08:26:30" , 
"departure_time" : "08:27:29" , 
"distance_traveled" : 24.4049
}, 
{ 
"stop_id" : 145,
"arrival_time" : "08:33:59" , 
"departure_time" : "08:35:21" , 
"distance_traveled" : 27.8532
}, 
{ 
"stop_id" : 81,
"arrival_time" : "08:42:22" , 
"departure_time" : "08:43:10" , 
"distance_traveled" : 32.8036
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:44:48" , 
"departure_time" : "08:46:09" , 
"distance_traveled" : 34.086
}, 
{ 
"stop_id" : 97,
"arrival_time" : "08:47:21" , 
"departure_time" : "08:48:13" , 
"distance_traveled" : 34.8576
}, 
{ 
"stop_id" : 61,
"arrival_time" : "08:49:52" , 
"departure_time" : "08:51:26" , 
"distance_traveled" : 35.7856
}, 
{ 
"stop_id" : 112,
"arrival_time" : "08:53:34" , 
"departure_time" : "08:54:23" , 
"distance_traveled" : 36.4934
}, 
{ 
"stop_id" : 23,
"arrival_time" : "08:54:49" , 
"departure_time" : "08:56:25" , 
"distance_traveled" : 37.3943
}, 
{ 
"stop_id" : 37,
"arrival_time" : "08:58:36" , 
"departure_time" : "08:58:50" , 
"distance_traveled" : 37.9222
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:02:14" , 
"departure_time" : "09:02:26" , 
"distance_traveled" : 40.1699
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:20:12" , 
"departure_time" : "09:20:12" , 
"distance_traveled" : 47.9581
} ], 
"1969" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "17:15:00" , 
"departure_time" : "17:16:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "17:24:23" , 
"departure_time" : "17:24:27" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "17:30:04" , 
"departure_time" : "17:30:37" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "17:34:33" , 
"departure_time" : "17:35:09" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "17:38:36" , 
"departure_time" : "17:39:21" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "17:42:45" , 
"departure_time" : "17:43:02" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "17:46:17" , 
"departure_time" : "17:47:45" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:53:28" , 
"departure_time" : "17:54:38" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "17:57:10" , 
"departure_time" : "17:58:37" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:00:27" , 
"departure_time" : "18:01:23" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:03:56" , 
"departure_time" : "18:05:11" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:07:15" , 
"departure_time" : "18:07:36" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 97,
"arrival_time" : "18:08:21" , 
"departure_time" : "18:09:41" , 
"distance_traveled" : 27.4883
}, 
{ 
"stop_id" : 61,
"arrival_time" : "18:11:20" , 
"departure_time" : "18:11:33" , 
"distance_traveled" : 28.4163
}, 
{ 
"stop_id" : 112,
"arrival_time" : "18:13:13" , 
"departure_time" : "18:13:50" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "18:16:37" , 
"departure_time" : "18:16:44" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "18:18:07" , 
"departure_time" : "18:18:22" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:23:15" , 
"departure_time" : "18:23:35" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:35:20" , 
"departure_time" : "18:35:40" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:48:20" , 
"departure_time" : "18:48:20" , 
"distance_traveled" : 43.2223
} ], 
"1970" :  [ 
{ 
"stop_id" : 54,
"arrival_time" : "11:58:00" , 
"departure_time" : "11:58:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 93,
"arrival_time" : "12:09:01" , 
"departure_time" : "12:09:42" , 
"distance_traveled" : 7.3807
}, 
{ 
"stop_id" : 101,
"arrival_time" : "12:13:41" , 
"departure_time" : "12:13:45" , 
"distance_traveled" : 9.5714
}, 
{ 
"stop_id" : 67,
"arrival_time" : "12:19:04" , 
"departure_time" : "12:19:28" , 
"distance_traveled" : 12.0591
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "12:23:24" , 
"departure_time" : "12:25:03" , 
"distance_traveled" : 14.4854
}, 
{ 
"stop_id" : 35,
"arrival_time" : "12:33:39" , 
"departure_time" : "12:34:30" , 
"distance_traveled" : 19.4331
}, 
{ 
"stop_id" : 34,
"arrival_time" : "12:40:51" , 
"departure_time" : "12:41:13" , 
"distance_traveled" : 23.6417
}, 
{ 
"stop_id" : 94,
"arrival_time" : "12:42:22" , 
"departure_time" : "12:43:25" , 
"distance_traveled" : 24.2491
}, 
{ 
"stop_id" : 91,
"arrival_time" : "12:50:03" , 
"departure_time" : "12:50:52" , 
"distance_traveled" : 27.9402
}, 
{ 
"stop_id" : 92,
"arrival_time" : "12:52:49" , 
"departure_time" : "12:54:03" , 
"distance_traveled" : 30.1809
}, 
{ 
"stop_id" : 30,
"arrival_time" : "12:57:14" , 
"departure_time" : "12:57:29" , 
"distance_traveled" : 32.285
}, 
{ 
"stop_id" : 77,
"arrival_time" : "13:00:15" , 
"departure_time" : "13:01:50" , 
"distance_traveled" : 34.4506
}, 
{ 
"stop_id" : 27,
"arrival_time" : "13:05:35" , 
"departure_time" : "13:06:08" , 
"distance_traveled" : 36.4682
}, 
{ 
"stop_id" : 145,
"arrival_time" : "13:11:33" , 
"departure_time" : "13:12:42" , 
"distance_traveled" : 39.9165
}, 
{ 
"stop_id" : 136,
"arrival_time" : "13:16:09" , 
"departure_time" : "13:16:36" , 
"distance_traveled" : 42.1845
}, 
{ 
"stop_id" : 87,
"arrival_time" : "13:18:27" , 
"departure_time" : "13:18:30" , 
"distance_traveled" : 43.2589
}, 
{ 
"stop_id" : 81,
"arrival_time" : "13:21:03" , 
"departure_time" : "13:22:33" , 
"distance_traveled" : 44.8676
}, 
{ 
"stop_id" : 140,
"arrival_time" : "13:26:30" , 
"departure_time" : "13:27:36" , 
"distance_traveled" : 46.15
}, 
{ 
"stop_id" : 97,
"arrival_time" : "13:28:06" , 
"departure_time" : "13:28:30" , 
"distance_traveled" : 46.9216
}, 
{ 
"stop_id" : 61,
"arrival_time" : "13:29:24" , 
"departure_time" : "13:30:08" , 
"distance_traveled" : 47.8496
}, 
{ 
"stop_id" : 112,
"arrival_time" : "13:32:44" , 
"departure_time" : "13:32:55" , 
"distance_traveled" : 48.5574
}, 
{ 
"stop_id" : 23,
"arrival_time" : "13:34:11" , 
"departure_time" : "13:35:08" , 
"distance_traveled" : 49.4583
}, 
{ 
"stop_id" : 37,
"arrival_time" : "13:37:57" , 
"departure_time" : "13:38:55" , 
"distance_traveled" : 49.9862
}, 
{ 
"stop_id" : 106,
"arrival_time" : "13:42:58" , 
"departure_time" : "13:44:20" , 
"distance_traveled" : 52.2339
}, 
{ 
"stop_id" : 63,
"arrival_time" : "14:01:22" , 
"departure_time" : "14:01:22" , 
"distance_traveled" : 60.0222
} ], 
"1971" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "16:19:00" , 
"departure_time" : "16:21:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "16:27:08" , 
"departure_time" : "16:28:35" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "16:29:27" , 
"departure_time" : "16:30:23" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "16:35:56" , 
"departure_time" : "16:36:37" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "16:38:41" , 
"departure_time" : "16:38:57" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "16:42:16" , 
"departure_time" : "16:43:12" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "16:46:56" , 
"departure_time" : "16:47:41" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "16:50:45" , 
"departure_time" : "16:51:53" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:58:08" , 
"departure_time" : "16:58:25" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "17:01:17" , 
"departure_time" : "17:01:30" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "17:04:13" , 
"departure_time" : "17:04:30" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "17:07:17" , 
"departure_time" : "17:08:33" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:12:16" , 
"departure_time" : "17:12:20" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 97,
"arrival_time" : "17:13:04" , 
"departure_time" : "17:13:41" , 
"distance_traveled" : 27.4884
}, 
{ 
"stop_id" : 61,
"arrival_time" : "17:16:37" , 
"departure_time" : "17:17:58" , 
"distance_traveled" : 28.4165
}, 
{ 
"stop_id" : 112,
"arrival_time" : "17:19:21" , 
"departure_time" : "17:19:49" , 
"distance_traveled" : 29.1242
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:21:28" , 
"departure_time" : "17:21:46" , 
"distance_traveled" : 30.0252
}, 
{ 
"stop_id" : 37,
"arrival_time" : "17:23:18" , 
"departure_time" : "17:24:53" , 
"distance_traveled" : 30.553
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:30:35" , 
"departure_time" : "17:32:05" , 
"distance_traveled" : 32.8008
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:48:30" , 
"departure_time" : "17:48:30" , 
"distance_traveled" : 40.589
} ], 
"1972" :  [ 
{ 
"stop_id" : 54,
"arrival_time" : "19:06:00" , 
"departure_time" : "19:08:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 93,
"arrival_time" : "19:17:48" , 
"departure_time" : "19:18:40" , 
"distance_traveled" : 7.3807
}, 
{ 
"stop_id" : 101,
"arrival_time" : "19:21:52" , 
"departure_time" : "19:22:16" , 
"distance_traveled" : 9.5714
}, 
{ 
"stop_id" : 67,
"arrival_time" : "19:27:24" , 
"departure_time" : "19:28:51" , 
"distance_traveled" : 12.0591
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "19:32:27" , 
"departure_time" : "19:34:04" , 
"distance_traveled" : 14.4854
}, 
{ 
"stop_id" : 35,
"arrival_time" : "19:40:37" , 
"departure_time" : "19:40:47" , 
"distance_traveled" : 19.4331
}, 
{ 
"stop_id" : 34,
"arrival_time" : "19:46:10" , 
"departure_time" : "19:46:37" , 
"distance_traveled" : 23.6417
}, 
{ 
"stop_id" : 94,
"arrival_time" : "19:48:27" , 
"departure_time" : "19:48:38" , 
"distance_traveled" : 24.2491
}, 
{ 
"stop_id" : 91,
"arrival_time" : "19:54:11" , 
"departure_time" : "19:54:17" , 
"distance_traveled" : 27.9402
}, 
{ 
"stop_id" : 92,
"arrival_time" : "19:58:06" , 
"departure_time" : "19:58:50" , 
"distance_traveled" : 30.1809
}, 
{ 
"stop_id" : 30,
"arrival_time" : "20:02:44" , 
"departure_time" : "20:04:00" , 
"distance_traveled" : 32.285
}, 
{ 
"stop_id" : 77,
"arrival_time" : "20:07:16" , 
"departure_time" : "20:07:22" , 
"distance_traveled" : 34.4506
}, 
{ 
"stop_id" : 27,
"arrival_time" : "20:10:06" , 
"departure_time" : "20:10:16" , 
"distance_traveled" : 36.4682
}, 
{ 
"stop_id" : 145,
"arrival_time" : "20:16:10" , 
"departure_time" : "20:17:27" , 
"distance_traveled" : 39.9165
}, 
{ 
"stop_id" : 136,
"arrival_time" : "20:22:17" , 
"departure_time" : "20:23:22" , 
"distance_traveled" : 42.1845
}, 
{ 
"stop_id" : 87,
"arrival_time" : "20:24:05" , 
"departure_time" : "20:25:05" , 
"distance_traveled" : 43.2589
}, 
{ 
"stop_id" : 81,
"arrival_time" : "20:28:00" , 
"departure_time" : "20:29:36" , 
"distance_traveled" : 44.8676
}, 
{ 
"stop_id" : 140,
"arrival_time" : "20:31:36" , 
"departure_time" : "20:32:19" , 
"distance_traveled" : 46.15
}, 
{ 
"stop_id" : 97,
"arrival_time" : "20:33:43" , 
"departure_time" : "20:34:06" , 
"distance_traveled" : 46.9216
}, 
{ 
"stop_id" : 61,
"arrival_time" : "20:35:23" , 
"departure_time" : "20:35:52" , 
"distance_traveled" : 47.8496
}, 
{ 
"stop_id" : 112,
"arrival_time" : "20:38:29" , 
"departure_time" : "20:39:20" , 
"distance_traveled" : 48.5574
}, 
{ 
"stop_id" : 23,
"arrival_time" : "20:40:51" , 
"departure_time" : "20:42:19" , 
"distance_traveled" : 49.4583
}, 
{ 
"stop_id" : 37,
"arrival_time" : "20:44:28" , 
"departure_time" : "20:44:55" , 
"distance_traveled" : 49.9862
}, 
{ 
"stop_id" : 106,
"arrival_time" : "20:48:27" , 
"departure_time" : "20:50:03" , 
"distance_traveled" : 52.2339
}, 
{ 
"stop_id" : 63,
"arrival_time" : "21:07:36" , 
"departure_time" : "21:07:36" , 
"distance_traveled" : 60.0222
} ], 
"1973" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "22:29:00" , 
"departure_time" : "22:32:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "22:37:27" , 
"departure_time" : "22:38:17" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "22:39:50" , 
"departure_time" : "22:41:05" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "22:46:15" , 
"departure_time" : "22:46:32" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "22:49:17" , 
"departure_time" : "22:49:37" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "22:52:20" , 
"departure_time" : "22:52:49" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "22:56:29" , 
"departure_time" : "22:57:53" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "23:01:24" , 
"departure_time" : "23:02:26" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "23:07:02" , 
"departure_time" : "23:07:06" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "23:10:04" , 
"departure_time" : "23:10:38" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "23:13:34" , 
"departure_time" : "23:14:18" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "23:16:44" , 
"departure_time" : "23:17:09" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "23:20:25" , 
"departure_time" : "23:21:51" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 97,
"arrival_time" : "23:23:26" , 
"departure_time" : "23:24:19" , 
"distance_traveled" : 27.4884
}, 
{ 
"stop_id" : 61,
"arrival_time" : "23:24:53" , 
"departure_time" : "23:25:17" , 
"distance_traveled" : 28.4165
}, 
{ 
"stop_id" : 112,
"arrival_time" : "23:26:24" , 
"departure_time" : "23:27:45" , 
"distance_traveled" : 29.1242
}, 
{ 
"stop_id" : 23,
"arrival_time" : "23:30:21" , 
"departure_time" : "23:31:00" , 
"distance_traveled" : 30.0252
}, 
{ 
"stop_id" : 37,
"arrival_time" : "23:31:39" , 
"departure_time" : "23:32:50" , 
"distance_traveled" : 30.553
}, 
{ 
"stop_id" : 106,
"arrival_time" : "23:37:11" , 
"departure_time" : "23:37:21" , 
"distance_traveled" : 32.8008
}, 
{ 
"stop_id" : 63,
"arrival_time" : "23:55:10" , 
"departure_time" : "23:55:10" , 
"distance_traveled" : 40.589
} ], 
"1974" :  [ 
{ 
"stop_id" : 81,
"arrival_time" : "08:00:00" , 
"departure_time" : "08:01:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:06:26" , 
"departure_time" : "08:07:01" , 
"distance_traveled" : 1.2824
}, 
{ 
"stop_id" : 23,
"arrival_time" : "08:12:35" , 
"departure_time" : "08:13:07" , 
"distance_traveled" : 4.5892
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:38:32" , 
"departure_time" : "08:38:32" , 
"distance_traveled" : 17.7638
} ], 
"1975" :  [ 
{ 
"stop_id" : 54,
"arrival_time" : "20:32:00" , 
"departure_time" : "20:34:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 93,
"arrival_time" : "20:44:38" , 
"departure_time" : "20:45:32" , 
"distance_traveled" : 7.3807
}, 
{ 
"stop_id" : 101,
"arrival_time" : "20:48:54" , 
"departure_time" : "20:48:57" , 
"distance_traveled" : 9.5714
}, 
{ 
"stop_id" : 67,
"arrival_time" : "20:52:03" , 
"departure_time" : "20:52:34" , 
"distance_traveled" : 12.0591
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "20:56:31" , 
"departure_time" : "20:57:47" , 
"distance_traveled" : 14.4854
}, 
{ 
"stop_id" : 35,
"arrival_time" : "21:05:16" , 
"departure_time" : "21:06:10" , 
"distance_traveled" : 19.4331
}, 
{ 
"stop_id" : 34,
"arrival_time" : "21:10:54" , 
"departure_time" : "21:12:00" , 
"distance_traveled" : 23.6417
}, 
{ 
"stop_id" : 94,
"arrival_time" : "21:14:06" , 
"departure_time" : "21:14:35" , 
"distance_traveled" : 24.2491
}, 
{ 
"stop_id" : 91,
"arrival_time" : "21:19:29" , 
"departure_time" : "21:20:44" , 
"distance_traveled" : 27.9402
}, 
{ 
"stop_id" : 92,
"arrival_time" : "21:24:15" , 
"departure_time" : "21:24:44" , 
"distance_traveled" : 30.1809
}, 
{ 
"stop_id" : 30,
"arrival_time" : "21:27:29" , 
"departure_time" : "21:27:43" , 
"distance_traveled" : 32.285
}, 
{ 
"stop_id" : 77,
"arrival_time" : "21:31:14" , 
"departure_time" : "21:32:43" , 
"distance_traveled" : 34.4506
}, 
{ 
"stop_id" : 27,
"arrival_time" : "21:36:29" , 
"departure_time" : "21:36:59" , 
"distance_traveled" : 36.4682
}, 
{ 
"stop_id" : 145,
"arrival_time" : "21:41:30" , 
"departure_time" : "21:42:45" , 
"distance_traveled" : 39.9165
}, 
{ 
"stop_id" : 87,
"arrival_time" : "21:48:15" , 
"departure_time" : "21:49:47" , 
"distance_traveled" : 43.2591
}, 
{ 
"stop_id" : 140,
"arrival_time" : "21:54:32" , 
"departure_time" : "21:55:03" , 
"distance_traveled" : 46.1502
}, 
{ 
"stop_id" : 112,
"arrival_time" : "21:57:31" , 
"departure_time" : "21:59:11" , 
"distance_traveled" : 48.5574
}, 
{ 
"stop_id" : 23,
"arrival_time" : "22:01:40" , 
"departure_time" : "22:02:50" , 
"distance_traveled" : 49.4583
}, 
{ 
"stop_id" : 106,
"arrival_time" : "22:07:10" , 
"departure_time" : "22:08:13" , 
"distance_traveled" : 52.2339
}, 
{ 
"stop_id" : 63,
"arrival_time" : "22:25:03" , 
"departure_time" : "22:25:03" , 
"distance_traveled" : 60.0222
} ], 
"1976" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "07:13:00" , 
"departure_time" : "07:15:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:22:30" , 
"departure_time" : "07:23:40" , 
"distance_traveled" : 3.3426
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:28:10" , 
"departure_time" : "07:28:15" , 
"distance_traveled" : 4.9513
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:48:05" , 
"departure_time" : "07:48:28" , 
"distance_traveled" : 17.7174
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:02:23" , 
"departure_time" : "08:02:23" , 
"distance_traveled" : 22.7055
} ], 
"1977" :  [ 
{ 
"stop_id" : 67,
"arrival_time" : "07:41:00" , 
"departure_time" : "07:42:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "07:46:30" , 
"departure_time" : "07:47:02" , 
"distance_traveled" : 2.4222
}, 
{ 
"stop_id" : 35,
"arrival_time" : "07:54:32" , 
"departure_time" : "07:56:00" , 
"distance_traveled" : 7.3699
}, 
{ 
"stop_id" : 34,
"arrival_time" : "08:01:28" , 
"departure_time" : "08:02:40" , 
"distance_traveled" : 11.5784
}, 
{ 
"stop_id" : 94,
"arrival_time" : "08:04:12" , 
"departure_time" : "08:04:28" , 
"distance_traveled" : 12.1858
}, 
{ 
"stop_id" : 91,
"arrival_time" : "08:10:16" , 
"departure_time" : "08:10:23" , 
"distance_traveled" : 15.8769
}, 
{ 
"stop_id" : 92,
"arrival_time" : "08:14:07" , 
"departure_time" : "08:15:04" , 
"distance_traveled" : 18.1176
}, 
{ 
"stop_id" : 30,
"arrival_time" : "08:18:57" , 
"departure_time" : "08:18:59" , 
"distance_traveled" : 20.2218
}, 
{ 
"stop_id" : 77,
"arrival_time" : "08:22:02" , 
"departure_time" : "08:22:15" , 
"distance_traveled" : 22.3873
}, 
{ 
"stop_id" : 27,
"arrival_time" : "08:26:13" , 
"departure_time" : "08:27:40" , 
"distance_traveled" : 24.4049
}, 
{ 
"stop_id" : 145,
"arrival_time" : "08:34:27" , 
"departure_time" : "08:35:20" , 
"distance_traveled" : 27.8532
}, 
{ 
"stop_id" : 81,
"arrival_time" : "08:41:53" , 
"departure_time" : "08:42:50" , 
"distance_traveled" : 32.8036
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:44:57" , 
"departure_time" : "08:45:07" , 
"distance_traveled" : 34.086
}, 
{ 
"stop_id" : 97,
"arrival_time" : "08:46:10" , 
"departure_time" : "08:47:32" , 
"distance_traveled" : 34.8576
}, 
{ 
"stop_id" : 61,
"arrival_time" : "08:50:22" , 
"departure_time" : "08:51:36" , 
"distance_traveled" : 35.7856
}, 
{ 
"stop_id" : 112,
"arrival_time" : "08:53:14" , 
"departure_time" : "08:54:42" , 
"distance_traveled" : 36.4934
}, 
{ 
"stop_id" : 23,
"arrival_time" : "08:55:28" , 
"departure_time" : "08:55:52" , 
"distance_traveled" : 37.3943
}, 
{ 
"stop_id" : 37,
"arrival_time" : "08:57:24" , 
"departure_time" : "08:57:47" , 
"distance_traveled" : 37.9222
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:02:23" , 
"departure_time" : "09:02:41" , 
"distance_traveled" : 40.1699
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:20:18" , 
"departure_time" : "09:20:18" , 
"distance_traveled" : 47.9581
} ], 
"1978" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "08:56:00" , 
"departure_time" : "08:57:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 81,
"arrival_time" : "09:03:49" , 
"departure_time" : "09:04:29" , 
"distance_traveled" : 4.9504
}, 
{ 
"stop_id" : 140,
"arrival_time" : "09:07:40" , 
"departure_time" : "09:08:48" , 
"distance_traveled" : 6.2328
}, 
{ 
"stop_id" : 112,
"arrival_time" : "09:13:08" , 
"departure_time" : "09:13:30" , 
"distance_traveled" : 8.64
}, 
{ 
"stop_id" : 23,
"arrival_time" : "09:16:22" , 
"departure_time" : "09:17:07" , 
"distance_traveled" : 9.5409
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:21:45" , 
"departure_time" : "09:21:56" , 
"distance_traveled" : 12.3165
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:42:11" , 
"departure_time" : "09:42:11" , 
"distance_traveled" : 22.7384
} ], 
"1979" :  [ 
{ 
"stop_id" : 54,
"arrival_time" : "11:58:00" , 
"departure_time" : "11:58:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 93,
"arrival_time" : "12:09:22" , 
"departure_time" : "12:09:39" , 
"distance_traveled" : 7.3807
}, 
{ 
"stop_id" : 101,
"arrival_time" : "12:13:17" , 
"departure_time" : "12:14:23" , 
"distance_traveled" : 9.5714
}, 
{ 
"stop_id" : 67,
"arrival_time" : "12:20:06" , 
"departure_time" : "12:20:40" , 
"distance_traveled" : 12.0591
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "12:23:34" , 
"departure_time" : "12:24:11" , 
"distance_traveled" : 14.4854
}, 
{ 
"stop_id" : 35,
"arrival_time" : "12:32:37" , 
"departure_time" : "12:33:15" , 
"distance_traveled" : 19.4331
}, 
{ 
"stop_id" : 34,
"arrival_time" : "12:40:38" , 
"departure_time" : "12:41:12" , 
"distance_traveled" : 23.6417
}, 
{ 
"stop_id" : 94,
"arrival_time" : "12:42:34" , 
"departure_time" : "12:43:04" , 
"distance_traveled" : 24.2491
}, 
{ 
"stop_id" : 91,
"arrival_time" : "12:49:30" , 
"departure_time" : "12:50:50" , 
"distance_traveled" : 27.9402
}, 
{ 
"stop_id" : 92,
"arrival_time" : "12:53:20" , 
"departure_time" : "12:54:09" , 
"distance_traveled" : 30.1809
}, 
{ 
"stop_id" : 30,
"arrival_time" : "12:56:49" , 
"departure_time" : "12:58:11" , 
"distance_traveled" : 32.285
}, 
{ 
"stop_id" : 77,
"arrival_time" : "13:01:22" , 
"departure_time" : "13:02:39" , 
"distance_traveled" : 34.4506
}, 
{ 
"stop_id" : 27,
"arrival_time" : "13:05:17" , 
"departure_time" : "13:05:32" , 
"distance_traveled" : 36.4682
}, 
{ 
"stop_id" : 145,
"arrival_time" : "13:11:15" , 
"departure_time" : "13:12:19" , 
"distance_traveled" : 39.9165
}, 
{ 
"stop_id" : 136,
"arrival_time" : "13:16:04" , 
"departure_time" : "13:16:11" , 
"distance_traveled" : 42.1845
}, 
{ 
"stop_id" : 87,
"arrival_time" : "13:18:07" , 
"departure_time" : "13:18:39" , 
"distance_traveled" : 43.2589
}, 
{ 
"stop_id" : 81,
"arrival_time" : "13:21:32" , 
"departure_time" : "13:21:41" , 
"distance_traveled" : 44.8676
}, 
{ 
"stop_id" : 140,
"arrival_time" : "13:25:09" , 
"departure_time" : "13:26:32" , 
"distance_traveled" : 46.15
}, 
{ 
"stop_id" : 97,
"arrival_time" : "13:28:23" , 
"departure_time" : "13:29:59" , 
"distance_traveled" : 46.9216
}, 
{ 
"stop_id" : 61,
"arrival_time" : "13:30:36" , 
"departure_time" : "13:31:36" , 
"distance_traveled" : 47.8496
}, 
{ 
"stop_id" : 112,
"arrival_time" : "13:33:00" , 
"departure_time" : "13:33:08" , 
"distance_traveled" : 48.5574
}, 
{ 
"stop_id" : 23,
"arrival_time" : "13:34:08" , 
"departure_time" : "13:35:25" , 
"distance_traveled" : 49.4583
}, 
{ 
"stop_id" : 37,
"arrival_time" : "13:38:17" , 
"departure_time" : "13:39:05" , 
"distance_traveled" : 49.9862
}, 
{ 
"stop_id" : 106,
"arrival_time" : "13:42:48" , 
"departure_time" : "13:44:19" , 
"distance_traveled" : 52.2339
}, 
{ 
"stop_id" : 63,
"arrival_time" : "14:01:31" , 
"departure_time" : "14:01:31" , 
"distance_traveled" : 60.0222
} ], 
"1980" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "08:20:00" , 
"departure_time" : "08:22:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 136,
"arrival_time" : "08:25:56" , 
"departure_time" : "08:26:17" , 
"distance_traveled" : 2.268
}, 
{ 
"stop_id" : 87,
"arrival_time" : "08:29:21" , 
"departure_time" : "08:29:52" , 
"distance_traveled" : 3.3424
}, 
{ 
"stop_id" : 81,
"arrival_time" : "08:33:31" , 
"departure_time" : "08:34:49" , 
"distance_traveled" : 4.9511
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:38:18" , 
"departure_time" : "08:39:03" , 
"distance_traveled" : 6.2335
}, 
{ 
"stop_id" : 112,
"arrival_time" : "08:42:45" , 
"departure_time" : "08:43:37" , 
"distance_traveled" : 8.6407
}, 
{ 
"stop_id" : 23,
"arrival_time" : "08:45:52" , 
"departure_time" : "08:46:01" , 
"distance_traveled" : 9.5417
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:51:09" , 
"departure_time" : "08:52:08" , 
"distance_traveled" : 12.3172
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:12:59" , 
"departure_time" : "09:12:59" , 
"distance_traveled" : 22.7392
} ], 
"1981" :  [ 
{ 
"stop_id" : 54,
"arrival_time" : "19:06:00" , 
"departure_time" : "19:08:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 93,
"arrival_time" : "19:18:37" , 
"departure_time" : "19:19:27" , 
"distance_traveled" : 7.3807
}, 
{ 
"stop_id" : 101,
"arrival_time" : "19:21:50" , 
"departure_time" : "19:22:51" , 
"distance_traveled" : 9.5714
}, 
{ 
"stop_id" : 67,
"arrival_time" : "19:28:01" , 
"departure_time" : "19:29:00" , 
"distance_traveled" : 12.0591
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "19:31:59" , 
"departure_time" : "19:32:03" , 
"distance_traveled" : 14.4854
}, 
{ 
"stop_id" : 35,
"arrival_time" : "19:39:04" , 
"departure_time" : "19:40:41" , 
"distance_traveled" : 19.4331
}, 
{ 
"stop_id" : 34,
"arrival_time" : "19:47:37" , 
"departure_time" : "19:48:18" , 
"distance_traveled" : 23.6417
}, 
{ 
"stop_id" : 94,
"arrival_time" : "19:48:41" , 
"departure_time" : "19:48:42" , 
"distance_traveled" : 24.2491
}, 
{ 
"stop_id" : 91,
"arrival_time" : "19:54:01" , 
"departure_time" : "19:55:09" , 
"distance_traveled" : 27.9402
}, 
{ 
"stop_id" : 92,
"arrival_time" : "19:59:08" , 
"departure_time" : "19:59:40" , 
"distance_traveled" : 30.1809
}, 
{ 
"stop_id" : 30,
"arrival_time" : "20:02:32" , 
"departure_time" : "20:04:01" , 
"distance_traveled" : 32.285
}, 
{ 
"stop_id" : 77,
"arrival_time" : "20:07:29" , 
"departure_time" : "20:07:32" , 
"distance_traveled" : 34.4506
}, 
{ 
"stop_id" : 27,
"arrival_time" : "20:10:03" , 
"departure_time" : "20:11:20" , 
"distance_traveled" : 36.4682
}, 
{ 
"stop_id" : 145,
"arrival_time" : "20:17:17" , 
"departure_time" : "20:18:32" , 
"distance_traveled" : 39.9165
}, 
{ 
"stop_id" : 136,
"arrival_time" : "20:22:15" , 
"departure_time" : "20:23:21" , 
"distance_traveled" : 42.1845
}, 
{ 
"stop_id" : 87,
"arrival_time" : "20:24:06" , 
"departure_time" : "20:24:55" , 
"distance_traveled" : 43.2589
}, 
{ 
"stop_id" : 81,
"arrival_time" : "20:27:49" , 
"departure_time" : "20:27:58" , 
"distance_traveled" : 44.8676
}, 
{ 
"stop_id" : 140,
"arrival_time" : "20:30:09" , 
"departure_time" : "20:30:32" , 
"distance_traveled" : 46.15
}, 
{ 
"stop_id" : 97,
"arrival_time" : "20:33:23" , 
"departure_time" : "20:34:00" , 
"distance_traveled" : 46.9216
}, 
{ 
"stop_id" : 61,
"arrival_time" : "20:35:37" , 
"departure_time" : "20:36:13" , 
"distance_traveled" : 47.8496
}, 
{ 
"stop_id" : 112,
"arrival_time" : "20:38:36" , 
"departure_time" : "20:39:36" , 
"distance_traveled" : 48.5574
}, 
{ 
"stop_id" : 23,
"arrival_time" : "20:41:00" , 
"departure_time" : "20:41:41" , 
"distance_traveled" : 49.4583
}, 
{ 
"stop_id" : 37,
"arrival_time" : "20:43:41" , 
"departure_time" : "20:44:41" , 
"distance_traveled" : 49.9862
}, 
{ 
"stop_id" : 106,
"arrival_time" : "20:49:00" , 
"departure_time" : "20:49:06" , 
"distance_traveled" : 52.2339
}, 
{ 
"stop_id" : 63,
"arrival_time" : "21:06:06" , 
"departure_time" : "21:06:06" , 
"distance_traveled" : 60.0222
} ], 
"1982" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "09:50:00" , 
"departure_time" : "09:50:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 136,
"arrival_time" : "09:55:27" , 
"departure_time" : "09:56:12" , 
"distance_traveled" : 2.268
}, 
{ 
"stop_id" : 87,
"arrival_time" : "09:58:45" , 
"departure_time" : "09:59:58" , 
"distance_traveled" : 3.3424
}, 
{ 
"stop_id" : 81,
"arrival_time" : "10:03:13" , 
"departure_time" : "10:04:34" , 
"distance_traveled" : 4.9511
}, 
{ 
"stop_id" : 140,
"arrival_time" : "10:07:21" , 
"departure_time" : "10:08:53" , 
"distance_traveled" : 6.2335
}, 
{ 
"stop_id" : 112,
"arrival_time" : "10:11:32" , 
"departure_time" : "10:13:08" , 
"distance_traveled" : 8.6407
}, 
{ 
"stop_id" : 23,
"arrival_time" : "10:15:36" , 
"departure_time" : "10:16:49" , 
"distance_traveled" : 9.5417
}, 
{ 
"stop_id" : 106,
"arrival_time" : "10:20:13" , 
"departure_time" : "10:20:57" , 
"distance_traveled" : 12.3172
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:40:44" , 
"departure_time" : "10:40:44" , 
"distance_traveled" : 22.7392
} ], 
"1983" :  [ 
{ 
"stop_id" : 81,
"arrival_time" : "08:00:00" , 
"departure_time" : "08:01:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:05:57" , 
"departure_time" : "08:06:53" , 
"distance_traveled" : 1.2824
}, 
{ 
"stop_id" : 23,
"arrival_time" : "08:12:56" , 
"departure_time" : "08:13:09" , 
"distance_traveled" : 4.5892
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:38:13" , 
"departure_time" : "08:38:13" , 
"distance_traveled" : 17.7638
} ], 
"1984" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "07:13:00" , 
"departure_time" : "07:14:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:22:25" , 
"departure_time" : "07:24:03" , 
"distance_traveled" : 3.3426
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:28:38" , 
"departure_time" : "07:29:02" , 
"distance_traveled" : 4.9513
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:48:24" , 
"departure_time" : "07:49:20" , 
"distance_traveled" : 17.7174
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:02:56" , 
"departure_time" : "08:02:56" , 
"distance_traveled" : 22.7055
} ], 
"1985" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "08:56:00" , 
"departure_time" : "08:57:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 81,
"arrival_time" : "09:03:54" , 
"departure_time" : "09:04:04" , 
"distance_traveled" : 4.9504
}, 
{ 
"stop_id" : 140,
"arrival_time" : "09:07:10" , 
"departure_time" : "09:08:01" , 
"distance_traveled" : 6.2328
}, 
{ 
"stop_id" : 112,
"arrival_time" : "09:12:51" , 
"departure_time" : "09:13:15" , 
"distance_traveled" : 8.64
}, 
{ 
"stop_id" : 23,
"arrival_time" : "09:16:24" , 
"departure_time" : "09:17:47" , 
"distance_traveled" : 9.5409
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:22:23" , 
"departure_time" : "09:22:51" , 
"distance_traveled" : 12.3165
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:42:28" , 
"departure_time" : "09:42:28" , 
"distance_traveled" : 22.7384
} ], 
"1986" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "08:20:00" , 
"departure_time" : "08:21:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 136,
"arrival_time" : "08:25:51" , 
"departure_time" : "08:27:03" , 
"distance_traveled" : 2.268
}, 
{ 
"stop_id" : 87,
"arrival_time" : "08:30:12" , 
"departure_time" : "08:30:43" , 
"distance_traveled" : 3.3424
}, 
{ 
"stop_id" : 81,
"arrival_time" : "08:33:31" , 
"departure_time" : "08:34:11" , 
"distance_traveled" : 4.9511
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:37:40" , 
"departure_time" : "08:38:40" , 
"distance_traveled" : 6.2335
}, 
{ 
"stop_id" : 112,
"arrival_time" : "08:43:00" , 
"departure_time" : "08:43:22" , 
"distance_traveled" : 8.6407
}, 
{ 
"stop_id" : 23,
"arrival_time" : "08:45:22" , 
"departure_time" : "08:46:42" , 
"distance_traveled" : 9.5417
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:52:20" , 
"departure_time" : "08:52:37" , 
"distance_traveled" : 12.3172
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:12:17" , 
"departure_time" : "09:12:17" , 
"distance_traveled" : 22.7392
} ], 
"1987" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "09:50:00" , 
"departure_time" : "09:51:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 136,
"arrival_time" : "09:56:05" , 
"departure_time" : "09:56:30" , 
"distance_traveled" : 2.268
}, 
{ 
"stop_id" : 87,
"arrival_time" : "09:58:25" , 
"departure_time" : "09:58:37" , 
"distance_traveled" : 3.3424
}, 
{ 
"stop_id" : 81,
"arrival_time" : "10:02:12" , 
"departure_time" : "10:03:25" , 
"distance_traveled" : 4.9511
}, 
{ 
"stop_id" : 140,
"arrival_time" : "10:07:13" , 
"departure_time" : "10:08:40" , 
"distance_traveled" : 6.2335
}, 
{ 
"stop_id" : 112,
"arrival_time" : "10:11:27" , 
"departure_time" : "10:12:53" , 
"distance_traveled" : 8.6407
}, 
{ 
"stop_id" : 23,
"arrival_time" : "10:15:26" , 
"departure_time" : "10:16:02" , 
"distance_traveled" : 9.5417
}, 
{ 
"stop_id" : 106,
"arrival_time" : "10:19:36" , 
"departure_time" : "10:19:56" , 
"distance_traveled" : 12.3172
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:40:20" , 
"departure_time" : "10:40:20" , 
"distance_traveled" : 22.7392
} ], 
"1988" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "23:30:00" , 
"departure_time" : "23:30:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "23:38:30" , 
"departure_time" : "23:39:00" , 
"distance_traveled" : 4.2091
}, 
{ 
"stop_id" : 91,
"arrival_time" : "23:45:30" , 
"departure_time" : "23:45:49" , 
"distance_traveled" : 8.5078
}, 
{ 
"stop_id" : 92,
"arrival_time" : "23:49:19" , 
"departure_time" : "23:50:50" , 
"distance_traveled" : 10.7481
}, 
{ 
"stop_id" : 30,
"arrival_time" : "23:54:31" , 
"departure_time" : "23:54:50" , 
"distance_traveled" : 12.853
}, 
{ 
"stop_id" : 77,
"arrival_time" : "23:57:19" , 
"departure_time" : "23:58:35" , 
"distance_traveled" : 15.0186
}, 
{ 
"stop_id" : 27,
"arrival_time" : "24:02:16" , 
"departure_time" : "24:03:56" , 
"distance_traveled" : 17.0364
}, 
{ 
"stop_id" : 145,
"arrival_time" : "24:08:40" , 
"departure_time" : "24:08:40" , 
"distance_traveled" : 20.485
} ], 
"1989" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "06:02:00" , 
"departure_time" : "06:05:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 136,
"arrival_time" : "06:07:38" , 
"departure_time" : "06:08:26" , 
"distance_traveled" : 2.268
}, 
{ 
"stop_id" : 87,
"arrival_time" : "06:09:48" , 
"departure_time" : "06:10:35" , 
"distance_traveled" : 3.3424
}, 
{ 
"stop_id" : 81,
"arrival_time" : "06:13:47" , 
"departure_time" : "06:15:01" , 
"distance_traveled" : 4.9511
}, 
{ 
"stop_id" : 140,
"arrival_time" : "06:17:14" , 
"departure_time" : "06:18:41" , 
"distance_traveled" : 6.2335
}, 
{ 
"stop_id" : 97,
"arrival_time" : "06:19:27" , 
"departure_time" : "06:20:38" , 
"distance_traveled" : 7.0051
}, 
{ 
"stop_id" : 61,
"arrival_time" : "06:21:11" , 
"departure_time" : "06:21:55" , 
"distance_traveled" : 7.9331
}, 
{ 
"stop_id" : 112,
"arrival_time" : "06:22:44" , 
"departure_time" : "06:23:23" , 
"distance_traveled" : 8.6409
}, 
{ 
"stop_id" : 23,
"arrival_time" : "06:24:39" , 
"departure_time" : "06:25:30" , 
"distance_traveled" : 9.5419
}, 
{ 
"stop_id" : 37,
"arrival_time" : "06:26:51" , 
"departure_time" : "06:27:13" , 
"distance_traveled" : 10.0697
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:31:22" , 
"departure_time" : "06:31:52" , 
"distance_traveled" : 12.3174
}, 
{ 
"stop_id" : 63,
"arrival_time" : "06:47:30" , 
"departure_time" : "06:47:30" , 
"distance_traveled" : 20.1057
} ], 
"1990" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "07:55:00" , 
"departure_time" : "07:56:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 136,
"arrival_time" : "08:00:23" , 
"departure_time" : "08:01:36" , 
"distance_traveled" : 2.268
}, 
{ 
"stop_id" : 87,
"arrival_time" : "08:03:13" , 
"departure_time" : "08:03:53" , 
"distance_traveled" : 3.3424
}, 
{ 
"stop_id" : 81,
"arrival_time" : "08:06:40" , 
"departure_time" : "08:07:24" , 
"distance_traveled" : 4.9511
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:09:44" , 
"departure_time" : "08:09:51" , 
"distance_traveled" : 6.2335
}, 
{ 
"stop_id" : 97,
"arrival_time" : "08:11:07" , 
"departure_time" : "08:11:09" , 
"distance_traveled" : 7.0051
}, 
{ 
"stop_id" : 61,
"arrival_time" : "08:14:02" , 
"departure_time" : "08:15:06" , 
"distance_traveled" : 7.9331
}, 
{ 
"stop_id" : 112,
"arrival_time" : "08:17:04" , 
"departure_time" : "08:17:27" , 
"distance_traveled" : 8.6409
}, 
{ 
"stop_id" : 23,
"arrival_time" : "08:19:23" , 
"departure_time" : "08:19:48" , 
"distance_traveled" : 9.5419
}, 
{ 
"stop_id" : 37,
"arrival_time" : "08:21:25" , 
"departure_time" : "08:22:51" , 
"distance_traveled" : 10.0697
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:27:26" , 
"departure_time" : "08:28:38" , 
"distance_traveled" : 12.3174
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:43:12" , 
"departure_time" : "08:43:12" , 
"distance_traveled" : 20.1057
} ], 
"1991" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "08:30:00" , 
"departure_time" : "08:32:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 136,
"arrival_time" : "08:35:25" , 
"departure_time" : "08:36:07" , 
"distance_traveled" : 2.268
}, 
{ 
"stop_id" : 87,
"arrival_time" : "08:37:42" , 
"departure_time" : "08:38:03" , 
"distance_traveled" : 3.3424
}, 
{ 
"stop_id" : 81,
"arrival_time" : "08:40:21" , 
"departure_time" : "08:41:16" , 
"distance_traveled" : 4.9511
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:43:55" , 
"departure_time" : "08:44:33" , 
"distance_traveled" : 6.2335
}, 
{ 
"stop_id" : 97,
"arrival_time" : "08:45:38" , 
"departure_time" : "08:46:39" , 
"distance_traveled" : 7.0051
}, 
{ 
"stop_id" : 61,
"arrival_time" : "08:49:01" , 
"departure_time" : "08:50:34" , 
"distance_traveled" : 7.9331
}, 
{ 
"stop_id" : 112,
"arrival_time" : "08:51:33" , 
"departure_time" : "08:52:59" , 
"distance_traveled" : 8.6409
}, 
{ 
"stop_id" : 23,
"arrival_time" : "08:53:26" , 
"departure_time" : "08:54:03" , 
"distance_traveled" : 9.5419
}, 
{ 
"stop_id" : 37,
"arrival_time" : "08:54:37" , 
"departure_time" : "08:55:29" , 
"distance_traveled" : 10.0697
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:59:52" , 
"departure_time" : "09:00:40" , 
"distance_traveled" : 12.3174
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:15:48" , 
"departure_time" : "09:15:48" , 
"distance_traveled" : 20.1057
} ], 
"1992" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "17:00:00" , 
"departure_time" : "17:01:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 136,
"arrival_time" : "17:04:47" , 
"departure_time" : "17:05:43" , 
"distance_traveled" : 2.268
}, 
{ 
"stop_id" : 87,
"arrival_time" : "17:07:56" , 
"departure_time" : "17:08:45" , 
"distance_traveled" : 3.3424
}, 
{ 
"stop_id" : 81,
"arrival_time" : "17:10:49" , 
"departure_time" : "17:11:51" , 
"distance_traveled" : 4.9511
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:14:02" , 
"departure_time" : "17:14:58" , 
"distance_traveled" : 6.2335
}, 
{ 
"stop_id" : 97,
"arrival_time" : "17:15:56" , 
"departure_time" : "17:16:30" , 
"distance_traveled" : 7.0051
}, 
{ 
"stop_id" : 61,
"arrival_time" : "17:17:34" , 
"departure_time" : "17:17:47" , 
"distance_traveled" : 7.9331
}, 
{ 
"stop_id" : 112,
"arrival_time" : "17:20:13" , 
"departure_time" : "17:21:41" , 
"distance_traveled" : 8.6409
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:23:28" , 
"departure_time" : "17:23:45" , 
"distance_traveled" : 9.5419
}, 
{ 
"stop_id" : 37,
"arrival_time" : "17:24:17" , 
"departure_time" : "17:24:39" , 
"distance_traveled" : 10.0697
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:29:22" , 
"departure_time" : "17:30:20" , 
"distance_traveled" : 12.3174
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:45:58" , 
"departure_time" : "17:45:58" , 
"distance_traveled" : 20.1057
} ], 
"1993" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "18:00:00" , 
"departure_time" : "18:01:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 136,
"arrival_time" : "18:04:19" , 
"departure_time" : "18:05:34" , 
"distance_traveled" : 2.268
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:08:15" , 
"departure_time" : "18:09:45" , 
"distance_traveled" : 3.3424
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:11:30" , 
"departure_time" : "18:12:57" , 
"distance_traveled" : 4.9511
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:14:27" , 
"departure_time" : "18:16:05" , 
"distance_traveled" : 6.2335
}, 
{ 
"stop_id" : 97,
"arrival_time" : "18:16:38" , 
"departure_time" : "18:18:08" , 
"distance_traveled" : 7.0051
}, 
{ 
"stop_id" : 61,
"arrival_time" : "18:18:30" , 
"departure_time" : "18:19:45" , 
"distance_traveled" : 7.9331
}, 
{ 
"stop_id" : 112,
"arrival_time" : "18:21:15" , 
"departure_time" : "18:21:31" , 
"distance_traveled" : 8.6409
}, 
{ 
"stop_id" : 23,
"arrival_time" : "18:22:16" , 
"departure_time" : "18:23:54" , 
"distance_traveled" : 9.5419
}, 
{ 
"stop_id" : 37,
"arrival_time" : "18:25:38" , 
"departure_time" : "18:26:44" , 
"distance_traveled" : 10.0697
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:30:06" , 
"departure_time" : "18:30:52" , 
"distance_traveled" : 12.3174
}, 
{ 
"stop_id" : 63,
"arrival_time" : "18:45:46" , 
"departure_time" : "18:45:46" , 
"distance_traveled" : 20.1057
} ], 
"1994" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "19:00:00" , 
"departure_time" : "19:01:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 136,
"arrival_time" : "19:05:01" , 
"departure_time" : "19:05:22" , 
"distance_traveled" : 2.268
}, 
{ 
"stop_id" : 87,
"arrival_time" : "19:07:21" , 
"departure_time" : "19:08:51" , 
"distance_traveled" : 3.3424
}, 
{ 
"stop_id" : 81,
"arrival_time" : "19:11:30" , 
"departure_time" : "19:13:06" , 
"distance_traveled" : 4.9511
}, 
{ 
"stop_id" : 140,
"arrival_time" : "19:14:36" , 
"departure_time" : "19:15:39" , 
"distance_traveled" : 6.2335
}, 
{ 
"stop_id" : 97,
"arrival_time" : "19:16:03" , 
"departure_time" : "19:16:51" , 
"distance_traveled" : 7.0051
}, 
{ 
"stop_id" : 61,
"arrival_time" : "19:17:48" , 
"departure_time" : "19:19:17" , 
"distance_traveled" : 7.9331
}, 
{ 
"stop_id" : 112,
"arrival_time" : "19:21:29" , 
"departure_time" : "19:21:48" , 
"distance_traveled" : 8.6409
}, 
{ 
"stop_id" : 23,
"arrival_time" : "19:22:19" , 
"departure_time" : "19:22:55" , 
"distance_traveled" : 9.5419
}, 
{ 
"stop_id" : 37,
"arrival_time" : "19:24:36" , 
"departure_time" : "19:24:42" , 
"distance_traveled" : 10.0697
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:29:06" , 
"departure_time" : "19:30:40" , 
"distance_traveled" : 12.3174
}, 
{ 
"stop_id" : 63,
"arrival_time" : "19:46:34" , 
"departure_time" : "19:46:34" , 
"distance_traveled" : 20.1057
} ], 
"1995" :  [ 
{ 
"stop_id" : 54,
"arrival_time" : "06:50:00" , 
"departure_time" : "06:52:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 93,
"arrival_time" : "07:02:20" , 
"departure_time" : "07:02:52" , 
"distance_traveled" : 7.3807
}, 
{ 
"stop_id" : 101,
"arrival_time" : "07:06:32" , 
"departure_time" : "07:07:48" , 
"distance_traveled" : 9.5714
}, 
{ 
"stop_id" : 67,
"arrival_time" : "07:13:16" , 
"departure_time" : "07:14:36" , 
"distance_traveled" : 12.0591
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "07:17:20" , 
"departure_time" : "07:18:46" , 
"distance_traveled" : 14.4854
}, 
{ 
"stop_id" : 35,
"arrival_time" : "07:25:26" , 
"departure_time" : "07:26:18" , 
"distance_traveled" : 19.4331
}, 
{ 
"stop_id" : 34,
"arrival_time" : "07:32:52" , 
"departure_time" : "07:33:37" , 
"distance_traveled" : 23.6417
}, 
{ 
"stop_id" : 94,
"arrival_time" : "07:35:45" , 
"departure_time" : "07:36:56" , 
"distance_traveled" : 24.2491
}, 
{ 
"stop_id" : 91,
"arrival_time" : "07:42:11" , 
"departure_time" : "07:43:39" , 
"distance_traveled" : 27.9402
}, 
{ 
"stop_id" : 92,
"arrival_time" : "07:46:28" , 
"departure_time" : "07:47:41" , 
"distance_traveled" : 30.1809
}, 
{ 
"stop_id" : 30,
"arrival_time" : "07:50:13" , 
"departure_time" : "07:51:27" , 
"distance_traveled" : 32.285
}, 
{ 
"stop_id" : 77,
"arrival_time" : "07:54:14" , 
"departure_time" : "07:54:44" , 
"distance_traveled" : 34.4506
}, 
{ 
"stop_id" : 27,
"arrival_time" : "07:57:30" , 
"departure_time" : "07:57:37" , 
"distance_traveled" : 36.4682
}, 
{ 
"stop_id" : 145,
"arrival_time" : "08:03:07" , 
"departure_time" : "08:03:52" , 
"distance_traveled" : 39.9165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:19:45" , 
"departure_time" : "08:20:57" , 
"distance_traveled" : 52.2233
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:38:12" , 
"departure_time" : "08:38:12" , 
"distance_traveled" : 60.0116
} ], 
"1996" :  [ 
{ 
"stop_id" : 54,
"arrival_time" : "16:12:00" , 
"departure_time" : "16:14:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 93,
"arrival_time" : "16:23:59" , 
"departure_time" : "16:24:03" , 
"distance_traveled" : 7.3807
}, 
{ 
"stop_id" : 101,
"arrival_time" : "16:27:04" , 
"departure_time" : "16:28:21" , 
"distance_traveled" : 9.5714
}, 
{ 
"stop_id" : 67,
"arrival_time" : "16:35:17" , 
"departure_time" : "16:36:40" , 
"distance_traveled" : 12.0591
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "16:39:23" , 
"departure_time" : "16:39:53" , 
"distance_traveled" : 14.4854
}, 
{ 
"stop_id" : 35,
"arrival_time" : "16:47:30" , 
"departure_time" : "16:47:36" , 
"distance_traveled" : 19.4331
}, 
{ 
"stop_id" : 34,
"arrival_time" : "16:54:06" , 
"departure_time" : "16:54:28" , 
"distance_traveled" : 23.6417
}, 
{ 
"stop_id" : 94,
"arrival_time" : "16:57:22" , 
"departure_time" : "16:57:57" , 
"distance_traveled" : 24.2491
}, 
{ 
"stop_id" : 91,
"arrival_time" : "17:03:35" , 
"departure_time" : "17:04:37" , 
"distance_traveled" : 27.9402
}, 
{ 
"stop_id" : 92,
"arrival_time" : "17:08:02" , 
"departure_time" : "17:09:22" , 
"distance_traveled" : 30.1809
}, 
{ 
"stop_id" : 30,
"arrival_time" : "17:12:20" , 
"departure_time" : "17:12:37" , 
"distance_traveled" : 32.285
}, 
{ 
"stop_id" : 77,
"arrival_time" : "17:15:17" , 
"departure_time" : "17:16:52" , 
"distance_traveled" : 34.4506
}, 
{ 
"stop_id" : 27,
"arrival_time" : "17:20:35" , 
"departure_time" : "17:21:18" , 
"distance_traveled" : 36.4682
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:26:43" , 
"departure_time" : "17:27:53" , 
"distance_traveled" : 39.9165
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:45:10" , 
"departure_time" : "17:45:18" , 
"distance_traveled" : 52.2233
}, 
{ 
"stop_id" : 63,
"arrival_time" : "18:02:08" , 
"departure_time" : "18:02:08" , 
"distance_traveled" : 60.0116
} ], 
"1997" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "06:40:00" , 
"departure_time" : "06:41:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "06:47:54" , 
"departure_time" : "06:49:02" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "06:51:08" , 
"departure_time" : "06:51:16" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "06:56:08" , 
"departure_time" : "06:57:48" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "07:01:40" , 
"departure_time" : "07:03:14" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "07:05:34" , 
"departure_time" : "07:06:11" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "07:08:37" , 
"departure_time" : "07:09:30" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "07:12:53" , 
"departure_time" : "07:14:09" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:19:16" , 
"departure_time" : "07:20:41" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:23:25" , 
"departure_time" : "07:24:47" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:26:22" , 
"departure_time" : "07:27:25" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:30:03" , 
"departure_time" : "07:31:13" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:33:10" , 
"departure_time" : "07:34:22" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 112,
"arrival_time" : "07:38:12" , 
"departure_time" : "07:38:59" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "07:40:47" , 
"departure_time" : "07:42:24" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:47:37" , 
"departure_time" : "07:48:14" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:57:37" , 
"departure_time" : "07:58:52" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:10:15" , 
"departure_time" : "08:10:15" , 
"distance_traveled" : 43.2223
} ], 
"1998" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "04:03:00" , 
"departure_time" : "04:05:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "04:11:14" , 
"departure_time" : "04:11:56" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "04:13:42" , 
"departure_time" : "04:15:09" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "04:20:27" , 
"departure_time" : "04:21:01" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "04:23:34" , 
"departure_time" : "04:24:28" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "04:27:54" , 
"departure_time" : "04:28:14" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "04:31:20" , 
"departure_time" : "04:32:40" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "04:36:20" , 
"departure_time" : "04:37:44" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "04:43:24" , 
"departure_time" : "04:44:07" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "04:47:43" , 
"departure_time" : "04:48:25" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "04:50:42" , 
"departure_time" : "04:51:15" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "04:54:33" , 
"departure_time" : "04:54:42" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "04:57:09" , 
"departure_time" : "04:58:10" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 97,
"arrival_time" : "05:01:01" , 
"departure_time" : "05:01:12" , 
"distance_traveled" : 27.4884
}, 
{ 
"stop_id" : 112,
"arrival_time" : "05:04:11" , 
"departure_time" : "05:05:46" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "05:08:35" , 
"departure_time" : "05:08:54" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "05:10:19" , 
"departure_time" : "05:10:42" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "05:16:23" , 
"departure_time" : "05:18:01" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:27:38" , 
"departure_time" : "05:28:09" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "05:39:31" , 
"departure_time" : "05:39:31" , 
"distance_traveled" : 43.2223
} ], 
"1999" :  [ 
{ 
"stop_id" : 54,
"arrival_time" : "05:16:00" , 
"departure_time" : "05:18:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 93,
"arrival_time" : "05:28:40" , 
"departure_time" : "05:29:20" , 
"distance_traveled" : 7.3807
}, 
{ 
"stop_id" : 101,
"arrival_time" : "05:31:40" , 
"departure_time" : "05:32:18" , 
"distance_traveled" : 9.5714
}, 
{ 
"stop_id" : 67,
"arrival_time" : "05:37:38" , 
"departure_time" : "05:39:00" , 
"distance_traveled" : 12.0591
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "05:42:22" , 
"departure_time" : "05:42:38" , 
"distance_traveled" : 14.4854
}, 
{ 
"stop_id" : 35,
"arrival_time" : "05:50:16" , 
"departure_time" : "05:50:43" , 
"distance_traveled" : 19.4331
}, 
{ 
"stop_id" : 34,
"arrival_time" : "05:58:27" , 
"departure_time" : "05:58:49" , 
"distance_traveled" : 23.6417
}, 
{ 
"stop_id" : 94,
"arrival_time" : "06:00:22" , 
"departure_time" : "06:01:22" , 
"distance_traveled" : 24.2491
}, 
{ 
"stop_id" : 91,
"arrival_time" : "06:08:00" , 
"departure_time" : "06:09:10" , 
"distance_traveled" : 27.9402
}, 
{ 
"stop_id" : 92,
"arrival_time" : "06:11:10" , 
"departure_time" : "06:12:16" , 
"distance_traveled" : 30.1809
}, 
{ 
"stop_id" : 30,
"arrival_time" : "06:15:06" , 
"departure_time" : "06:15:38" , 
"distance_traveled" : 32.285
}, 
{ 
"stop_id" : 77,
"arrival_time" : "06:18:32" , 
"departure_time" : "06:20:07" , 
"distance_traveled" : 34.4506
}, 
{ 
"stop_id" : 27,
"arrival_time" : "06:23:35" , 
"departure_time" : "06:24:11" , 
"distance_traveled" : 36.4682
}, 
{ 
"stop_id" : 145,
"arrival_time" : "06:29:36" , 
"departure_time" : "06:30:56" , 
"distance_traveled" : 39.9165
}, 
{ 
"stop_id" : 136,
"arrival_time" : "06:34:20" , 
"departure_time" : "06:34:47" , 
"distance_traveled" : 42.1845
}, 
{ 
"stop_id" : 87,
"arrival_time" : "06:36:27" , 
"departure_time" : "06:36:34" , 
"distance_traveled" : 43.2589
}, 
{ 
"stop_id" : 81,
"arrival_time" : "06:39:07" , 
"departure_time" : "06:39:47" , 
"distance_traveled" : 44.8676
}, 
{ 
"stop_id" : 140,
"arrival_time" : "06:43:40" , 
"departure_time" : "06:44:06" , 
"distance_traveled" : 46.15
}, 
{ 
"stop_id" : 97,
"arrival_time" : "06:45:26" , 
"departure_time" : "06:46:19" , 
"distance_traveled" : 46.9216
}, 
{ 
"stop_id" : 61,
"arrival_time" : "06:47:53" , 
"departure_time" : "06:48:52" , 
"distance_traveled" : 47.8496
}, 
{ 
"stop_id" : 112,
"arrival_time" : "06:50:59" , 
"departure_time" : "06:52:07" , 
"distance_traveled" : 48.5574
}, 
{ 
"stop_id" : 23,
"arrival_time" : "06:53:08" , 
"departure_time" : "06:53:10" , 
"distance_traveled" : 49.4583
}, 
{ 
"stop_id" : 37,
"arrival_time" : "06:55:02" , 
"departure_time" : "06:55:54" , 
"distance_traveled" : 49.9862
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:00:52" , 
"departure_time" : "07:01:01" , 
"distance_traveled" : 52.2339
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:18:09" , 
"departure_time" : "07:18:09" , 
"distance_traveled" : 60.0222
} ], 
"2000" :  [ 
{ 
"stop_id" : 54,
"arrival_time" : "13:58:00" , 
"departure_time" : "13:59:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 93,
"arrival_time" : "14:10:08" , 
"departure_time" : "14:10:19" , 
"distance_traveled" : 7.3807
}, 
{ 
"stop_id" : 101,
"arrival_time" : "14:13:11" , 
"departure_time" : "14:13:53" , 
"distance_traveled" : 9.5714
}, 
{ 
"stop_id" : 67,
"arrival_time" : "14:19:42" , 
"departure_time" : "14:19:51" , 
"distance_traveled" : 12.0591
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "14:23:09" , 
"departure_time" : "14:24:49" , 
"distance_traveled" : 14.4854
}, 
{ 
"stop_id" : 35,
"arrival_time" : "14:33:40" , 
"departure_time" : "14:35:13" , 
"distance_traveled" : 19.4331
}, 
{ 
"stop_id" : 34,
"arrival_time" : "14:41:33" , 
"departure_time" : "14:42:51" , 
"distance_traveled" : 23.6417
}, 
{ 
"stop_id" : 94,
"arrival_time" : "14:43:18" , 
"departure_time" : "14:44:36" , 
"distance_traveled" : 24.2491
}, 
{ 
"stop_id" : 91,
"arrival_time" : "14:50:18" , 
"departure_time" : "14:51:53" , 
"distance_traveled" : 27.9402
}, 
{ 
"stop_id" : 92,
"arrival_time" : "14:53:35" , 
"departure_time" : "14:53:43" , 
"distance_traveled" : 30.1809
}, 
{ 
"stop_id" : 30,
"arrival_time" : "14:56:08" , 
"departure_time" : "14:56:40" , 
"distance_traveled" : 32.285
}, 
{ 
"stop_id" : 77,
"arrival_time" : "15:00:32" , 
"departure_time" : "15:01:06" , 
"distance_traveled" : 34.4506
}, 
{ 
"stop_id" : 27,
"arrival_time" : "15:04:34" , 
"departure_time" : "15:05:24" , 
"distance_traveled" : 36.4682
}, 
{ 
"stop_id" : 145,
"arrival_time" : "15:11:50" , 
"departure_time" : "15:12:33" , 
"distance_traveled" : 39.9165
}, 
{ 
"stop_id" : 136,
"arrival_time" : "15:15:43" , 
"departure_time" : "15:15:44" , 
"distance_traveled" : 42.1845
}, 
{ 
"stop_id" : 87,
"arrival_time" : "15:18:01" , 
"departure_time" : "15:18:13" , 
"distance_traveled" : 43.2589
}, 
{ 
"stop_id" : 81,
"arrival_time" : "15:21:12" , 
"departure_time" : "15:22:02" , 
"distance_traveled" : 44.8676
}, 
{ 
"stop_id" : 140,
"arrival_time" : "15:25:50" , 
"departure_time" : "15:26:14" , 
"distance_traveled" : 46.15
}, 
{ 
"stop_id" : 97,
"arrival_time" : "15:27:24" , 
"departure_time" : "15:27:26" , 
"distance_traveled" : 46.9216
}, 
{ 
"stop_id" : 61,
"arrival_time" : "15:29:02" , 
"departure_time" : "15:30:00" , 
"distance_traveled" : 47.8496
}, 
{ 
"stop_id" : 112,
"arrival_time" : "15:32:58" , 
"departure_time" : "15:34:17" , 
"distance_traveled" : 48.5574
}, 
{ 
"stop_id" : 23,
"arrival_time" : "15:35:19" , 
"departure_time" : "15:36:26" , 
"distance_traveled" : 49.4583
}, 
{ 
"stop_id" : 37,
"arrival_time" : "15:38:07" , 
"departure_time" : "15:38:36" , 
"distance_traveled" : 49.9862
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:42:29" , 
"departure_time" : "15:43:04" , 
"distance_traveled" : 52.2339
}, 
{ 
"stop_id" : 63,
"arrival_time" : "16:00:35" , 
"departure_time" : "16:00:35" , 
"distance_traveled" : 60.0222
} ], 
"2001" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "07:05:00" , 
"departure_time" : "07:07:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "07:13:31" , 
"departure_time" : "07:13:50" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "07:19:19" , 
"departure_time" : "07:19:29" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "07:23:10" , 
"departure_time" : "07:24:41" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "07:28:31" , 
"departure_time" : "07:28:49" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "07:31:18" , 
"departure_time" : "07:32:15" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "07:35:57" , 
"departure_time" : "07:36:58" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:43:01" , 
"departure_time" : "07:43:41" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:47:40" , 
"departure_time" : "07:48:19" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:50:39" , 
"departure_time" : "07:52:09" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:55:30" , 
"departure_time" : "07:56:58" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:58:28" , 
"departure_time" : "07:59:01" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 61,
"arrival_time" : "08:01:33" , 
"departure_time" : "08:02:45" , 
"distance_traveled" : 28.4163
}, 
{ 
"stop_id" : 112,
"arrival_time" : "08:05:12" , 
"departure_time" : "08:05:59" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "08:07:47" , 
"departure_time" : "08:08:58" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 37,
"arrival_time" : "08:11:11" , 
"departure_time" : "08:12:40" , 
"distance_traveled" : 30.5527
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:17:29" , 
"departure_time" : "08:18:45" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:26:16" , 
"departure_time" : "08:26:34" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:39:18" , 
"departure_time" : "08:39:18" , 
"distance_traveled" : 43.2222
} ], 
"2002" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "13:05:00" , 
"departure_time" : "13:06:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "13:13:28" , 
"departure_time" : "13:13:31" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "13:19:03" , 
"departure_time" : "13:20:35" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "13:24:32" , 
"departure_time" : "13:26:11" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "13:28:39" , 
"departure_time" : "13:30:14" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "13:32:35" , 
"departure_time" : "13:34:09" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "13:36:34" , 
"departure_time" : "13:37:03" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "13:42:29" , 
"departure_time" : "13:44:09" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "13:48:40" , 
"departure_time" : "13:49:05" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "13:50:25" , 
"departure_time" : "13:51:47" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "13:55:22" , 
"departure_time" : "13:56:31" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "13:58:09" , 
"departure_time" : "13:59:05" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 61,
"arrival_time" : "14:01:56" , 
"departure_time" : "14:02:54" , 
"distance_traveled" : 28.4163
}, 
{ 
"stop_id" : 112,
"arrival_time" : "14:04:58" , 
"departure_time" : "14:06:11" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "14:08:13" , 
"departure_time" : "14:09:33" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 37,
"arrival_time" : "14:11:20" , 
"departure_time" : "14:11:47" , 
"distance_traveled" : 30.5527
}, 
{ 
"stop_id" : 106,
"arrival_time" : "14:16:27" , 
"departure_time" : "14:17:26" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:25:59" , 
"departure_time" : "14:26:56" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "14:39:57" , 
"departure_time" : "14:39:57" , 
"distance_traveled" : 43.2222
} ], 
"2003" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "15:05:00" , 
"departure_time" : "15:06:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "15:12:53" , 
"departure_time" : "15:13:59" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "15:20:06" , 
"departure_time" : "15:20:45" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "15:23:39" , 
"departure_time" : "15:24:05" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "15:27:26" , 
"departure_time" : "15:27:47" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "15:31:21" , 
"departure_time" : "15:31:45" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "15:35:24" , 
"departure_time" : "15:36:46" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "15:43:22" , 
"departure_time" : "15:43:50" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "15:47:28" , 
"departure_time" : "15:47:43" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "15:50:15" , 
"departure_time" : "15:50:26" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "15:54:11" , 
"departure_time" : "15:54:59" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "15:57:48" , 
"departure_time" : "15:57:56" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 61,
"arrival_time" : "16:01:08" , 
"departure_time" : "16:02:43" , 
"distance_traveled" : 28.4163
}, 
{ 
"stop_id" : 112,
"arrival_time" : "16:05:35" , 
"departure_time" : "16:06:45" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "16:08:10" , 
"departure_time" : "16:09:29" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 37,
"arrival_time" : "16:11:19" , 
"departure_time" : "16:11:34" , 
"distance_traveled" : 30.5527
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:16:15" , 
"departure_time" : "16:16:55" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:25:40" , 
"departure_time" : "16:25:57" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "16:39:17" , 
"departure_time" : "16:39:17" , 
"distance_traveled" : 43.2222
} ], 
"2004" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "19:05:00" , 
"departure_time" : "19:06:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "19:12:54" , 
"departure_time" : "19:13:25" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "19:19:31" , 
"departure_time" : "19:20:53" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "19:24:22" , 
"departure_time" : "19:25:56" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "19:28:34" , 
"departure_time" : "19:30:11" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "19:32:37" , 
"departure_time" : "19:32:38" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "19:35:01" , 
"departure_time" : "19:35:55" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "19:42:54" , 
"departure_time" : "19:43:14" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "19:47:20" , 
"departure_time" : "19:48:58" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "19:51:38" , 
"departure_time" : "19:53:06" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "19:55:28" , 
"departure_time" : "19:55:54" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "19:57:26" , 
"departure_time" : "19:58:22" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 61,
"arrival_time" : "20:01:56" , 
"departure_time" : "20:02:07" , 
"distance_traveled" : 28.4163
}, 
{ 
"stop_id" : 112,
"arrival_time" : "20:04:11" , 
"departure_time" : "20:04:22" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "20:07:11" , 
"departure_time" : "20:07:52" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 37,
"arrival_time" : "20:10:41" , 
"departure_time" : "20:11:38" , 
"distance_traveled" : 30.5527
}, 
{ 
"stop_id" : 106,
"arrival_time" : "20:16:57" , 
"departure_time" : "20:18:20" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:28:23" , 
"departure_time" : "20:29:21" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "20:40:58" , 
"departure_time" : "20:40:58" , 
"distance_traveled" : 43.2222
} ], 
"2005" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "21:05:00" , 
"departure_time" : "21:06:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "21:12:22" , 
"departure_time" : "21:13:48" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "21:20:26" , 
"departure_time" : "21:21:41" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "21:24:15" , 
"departure_time" : "21:24:46" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "21:27:31" , 
"departure_time" : "21:28:08" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "21:31:37" , 
"departure_time" : "21:32:09" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "21:35:32" , 
"departure_time" : "21:36:39" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "21:43:07" , 
"departure_time" : "21:44:26" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "21:48:19" , 
"departure_time" : "21:49:14" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "21:50:55" , 
"departure_time" : "21:52:21" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "21:55:26" , 
"departure_time" : "21:56:47" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "21:58:21" , 
"departure_time" : "21:58:50" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 61,
"arrival_time" : "22:01:29" , 
"departure_time" : "22:03:07" , 
"distance_traveled" : 28.4163
}, 
{ 
"stop_id" : 112,
"arrival_time" : "22:05:38" , 
"departure_time" : "22:06:07" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "22:07:29" , 
"departure_time" : "22:08:03" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 37,
"arrival_time" : "22:10:34" , 
"departure_time" : "22:11:39" , 
"distance_traveled" : 30.5527
}, 
{ 
"stop_id" : 106,
"arrival_time" : "22:17:05" , 
"departure_time" : "22:18:24" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:26:19" , 
"departure_time" : "22:27:18" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "22:39:59" , 
"departure_time" : "22:39:59" , 
"distance_traveled" : 43.2222
} ], 
"2006" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "12:05:00" , 
"departure_time" : "12:06:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "12:12:08" , 
"departure_time" : "12:12:43" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "12:19:35" , 
"departure_time" : "12:20:52" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "12:24:17" , 
"departure_time" : "12:24:21" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "12:27:04" , 
"departure_time" : "12:28:27" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "12:32:23" , 
"departure_time" : "12:32:36" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "12:35:13" , 
"departure_time" : "12:36:14" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "12:43:01" , 
"departure_time" : "12:43:11" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "12:47:10" , 
"departure_time" : "12:48:32" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "12:51:22" , 
"departure_time" : "12:52:51" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "12:55:29" , 
"departure_time" : "12:56:08" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "12:57:39" , 
"departure_time" : "12:57:56" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 97,
"arrival_time" : "13:00:17" , 
"departure_time" : "13:01:25" , 
"distance_traveled" : 27.4883
}, 
{ 
"stop_id" : 112,
"arrival_time" : "13:05:08" , 
"departure_time" : "13:06:16" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "13:08:08" , 
"departure_time" : "13:08:52" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 37,
"arrival_time" : "13:10:44" , 
"departure_time" : "13:12:08" , 
"distance_traveled" : 30.5527
}, 
{ 
"stop_id" : 106,
"arrival_time" : "13:17:24" , 
"departure_time" : "13:18:11" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:27:47" , 
"departure_time" : "13:28:57" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "13:42:10" , 
"departure_time" : "13:42:10" , 
"distance_traveled" : 43.2222
} ], 
"2007" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "16:05:00" , 
"departure_time" : "16:07:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "16:13:35" , 
"departure_time" : "16:15:13" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "16:20:38" , 
"departure_time" : "16:21:19" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "16:23:41" , 
"departure_time" : "16:24:52" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "16:28:11" , 
"departure_time" : "16:28:42" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "16:31:31" , 
"departure_time" : "16:31:34" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "16:35:03" , 
"departure_time" : "16:36:36" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:43:33" , 
"departure_time" : "16:44:33" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "16:48:00" , 
"departure_time" : "16:48:44" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "16:50:44" , 
"departure_time" : "16:50:56" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "16:54:12" , 
"departure_time" : "16:54:17" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "16:57:05" , 
"departure_time" : "16:57:11" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 97,
"arrival_time" : "17:00:06" , 
"departure_time" : "17:01:16" , 
"distance_traveled" : 27.4883
}, 
{ 
"stop_id" : 112,
"arrival_time" : "17:05:10" , 
"departure_time" : "17:06:44" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:08:34" , 
"departure_time" : "17:08:57" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 37,
"arrival_time" : "17:10:23" , 
"departure_time" : "17:11:46" , 
"distance_traveled" : 30.5527
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:17:23" , 
"departure_time" : "17:18:27" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:26:04" , 
"departure_time" : "17:27:36" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "17:42:32" , 
"departure_time" : "17:42:32" , 
"distance_traveled" : 43.2222
} ], 
"2008" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "18:05:00" , 
"departure_time" : "18:06:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "18:12:11" , 
"departure_time" : "18:12:40" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "18:19:29" , 
"departure_time" : "18:19:45" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "18:23:16" , 
"departure_time" : "18:24:02" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "18:27:46" , 
"departure_time" : "18:28:03" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "18:31:17" , 
"departure_time" : "18:31:47" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "18:35:30" , 
"departure_time" : "18:36:27" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:42:57" , 
"departure_time" : "18:44:17" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "18:48:20" , 
"departure_time" : "18:48:58" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:50:38" , 
"departure_time" : "18:50:56" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:54:18" , 
"departure_time" : "18:54:25" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:57:07" , 
"departure_time" : "18:57:19" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 97,
"arrival_time" : "19:00:12" , 
"departure_time" : "19:00:42" , 
"distance_traveled" : 27.4883
}, 
{ 
"stop_id" : 112,
"arrival_time" : "19:04:30" , 
"departure_time" : "19:04:52" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "19:07:22" , 
"departure_time" : "19:07:54" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 37,
"arrival_time" : "19:10:32" , 
"departure_time" : "19:11:18" , 
"distance_traveled" : 30.5527
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:16:46" , 
"departure_time" : "19:17:46" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:28:00" , 
"departure_time" : "19:29:11" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "19:42:11" , 
"departure_time" : "19:42:11" , 
"distance_traveled" : 43.2222
} ], 
"2009" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "22:05:00" , 
"departure_time" : "22:06:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "22:12:07" , 
"departure_time" : "22:13:45" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 91,
"arrival_time" : "22:20:38" , 
"departure_time" : "22:21:12" , 
"distance_traveled" : 8.5068
}, 
{ 
"stop_id" : 92,
"arrival_time" : "22:23:34" , 
"departure_time" : "22:24:56" , 
"distance_traveled" : 10.7475
}, 
{ 
"stop_id" : 30,
"arrival_time" : "22:28:22" , 
"departure_time" : "22:29:41" , 
"distance_traveled" : 12.8517
}, 
{ 
"stop_id" : 77,
"arrival_time" : "22:32:19" , 
"departure_time" : "22:32:38" , 
"distance_traveled" : 15.0172
}, 
{ 
"stop_id" : 27,
"arrival_time" : "22:35:19" , 
"departure_time" : "22:36:46" , 
"distance_traveled" : 17.0348
}, 
{ 
"stop_id" : 145,
"arrival_time" : "22:43:27" , 
"departure_time" : "22:44:54" , 
"distance_traveled" : 20.4831
}, 
{ 
"stop_id" : 136,
"arrival_time" : "22:48:27" , 
"departure_time" : "22:49:52" , 
"distance_traveled" : 22.7511
}, 
{ 
"stop_id" : 87,
"arrival_time" : "22:51:25" , 
"departure_time" : "22:52:15" , 
"distance_traveled" : 23.8256
}, 
{ 
"stop_id" : 81,
"arrival_time" : "22:54:50" , 
"departure_time" : "22:54:54" , 
"distance_traveled" : 25.4343
}, 
{ 
"stop_id" : 140,
"arrival_time" : "22:57:04" , 
"departure_time" : "22:57:20" , 
"distance_traveled" : 26.7167
}, 
{ 
"stop_id" : 97,
"arrival_time" : "23:00:16" , 
"departure_time" : "23:00:43" , 
"distance_traveled" : 27.4883
}, 
{ 
"stop_id" : 112,
"arrival_time" : "23:04:27" , 
"departure_time" : "23:04:30" , 
"distance_traveled" : 29.1239
}, 
{ 
"stop_id" : 23,
"arrival_time" : "23:07:03" , 
"departure_time" : "23:08:41" , 
"distance_traveled" : 30.0248
}, 
{ 
"stop_id" : 37,
"arrival_time" : "23:11:38" , 
"departure_time" : "23:12:46" , 
"distance_traveled" : 30.5527
}, 
{ 
"stop_id" : 106,
"arrival_time" : "23:17:08" , 
"departure_time" : "23:18:07" , 
"distance_traveled" : 32.8004
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:25:59" , 
"departure_time" : "23:26:30" , 
"distance_traveled" : 38.2341
}, 
{ 
"stop_id" : 105,
"arrival_time" : "23:39:31" , 
"departure_time" : "23:39:31" , 
"distance_traveled" : 43.2222
} ], 
"2010" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "05:05:00" , 
"departure_time" : "05:06:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "05:13:28" , 
"departure_time" : "05:14:09" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "05:13:41" , 
"departure_time" : "05:15:14" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "05:20:33" , 
"departure_time" : "05:21:04" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "05:23:31" , 
"departure_time" : "05:23:49" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "05:27:18" , 
"departure_time" : "05:27:25" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "05:31:07" , 
"departure_time" : "05:32:44" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "05:36:37" , 
"departure_time" : "05:38:12" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "05:43:35" , 
"departure_time" : "05:43:48" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "05:47:13" , 
"departure_time" : "05:48:40" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "05:51:27" , 
"departure_time" : "05:52:46" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "05:55:19" , 
"departure_time" : "05:56:00" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "05:57:41" , 
"departure_time" : "05:58:45" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 61,
"arrival_time" : "06:02:04" , 
"departure_time" : "06:02:05" , 
"distance_traveled" : 28.4165
}, 
{ 
"stop_id" : 112,
"arrival_time" : "06:04:01" , 
"departure_time" : "06:04:36" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "06:07:35" , 
"departure_time" : "06:08:47" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "06:11:12" , 
"departure_time" : "06:12:46" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:17:34" , 
"departure_time" : "06:18:22" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:32:48" , 
"departure_time" : "06:33:58" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:46:10" , 
"departure_time" : "06:46:10" , 
"distance_traveled" : 43.2223
} ], 
"2011" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "09:03:00" , 
"departure_time" : "09:04:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "09:10:03" , 
"departure_time" : "09:11:06" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "09:14:03" , 
"departure_time" : "09:15:28" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "09:20:25" , 
"departure_time" : "09:20:36" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "09:23:11" , 
"departure_time" : "09:23:47" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "09:27:36" , 
"departure_time" : "09:28:59" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "09:32:23" , 
"departure_time" : "09:32:54" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "09:35:31" , 
"departure_time" : "09:35:49" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "09:42:18" , 
"departure_time" : "09:42:59" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "09:47:41" , 
"departure_time" : "09:48:15" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "09:50:34" , 
"departure_time" : "09:50:40" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "09:54:06" , 
"departure_time" : "09:54:59" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "09:57:53" , 
"departure_time" : "09:59:08" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 61,
"arrival_time" : "10:02:15" , 
"departure_time" : "10:03:40" , 
"distance_traveled" : 28.4165
}, 
{ 
"stop_id" : 112,
"arrival_time" : "10:05:25" , 
"departure_time" : "10:06:38" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "10:08:13" , 
"departure_time" : "10:08:21" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "10:10:08" , 
"departure_time" : "10:10:59" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "10:16:51" , 
"departure_time" : "10:18:28" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:26:37" , 
"departure_time" : "10:26:59" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:38:22" , 
"departure_time" : "10:38:22" , 
"distance_traveled" : 43.2223
} ], 
"2012" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "11:03:00" , 
"departure_time" : "11:03:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "11:10:30" , 
"departure_time" : "11:11:32" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "11:14:02" , 
"departure_time" : "11:15:35" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "11:20:33" , 
"departure_time" : "11:21:06" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "11:23:33" , 
"departure_time" : "11:24:01" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "11:27:28" , 
"departure_time" : "11:28:14" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "11:31:46" , 
"departure_time" : "11:33:19" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "11:36:33" , 
"departure_time" : "11:37:14" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "11:42:41" , 
"departure_time" : "11:43:20" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "11:47:39" , 
"departure_time" : "11:47:46" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "11:50:07" , 
"departure_time" : "11:50:18" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "11:54:11" , 
"departure_time" : "11:54:30" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "11:57:19" , 
"departure_time" : "11:57:26" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 61,
"arrival_time" : "12:01:07" , 
"departure_time" : "12:02:05" , 
"distance_traveled" : 28.4165
}, 
{ 
"stop_id" : 112,
"arrival_time" : "12:04:58" , 
"departure_time" : "12:06:12" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "12:08:14" , 
"departure_time" : "12:09:21" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "12:11:07" , 
"departure_time" : "12:11:25" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "12:16:18" , 
"departure_time" : "12:16:33" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:25:15" , 
"departure_time" : "12:25:38" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "12:40:23" , 
"departure_time" : "12:40:23" , 
"distance_traveled" : 43.2223
} ], 
"2013" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "17:03:00" , 
"departure_time" : "17:04:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "17:10:42" , 
"departure_time" : "17:11:40" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "17:13:58" , 
"departure_time" : "17:14:58" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "17:20:00" , 
"departure_time" : "17:20:16" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "17:23:16" , 
"departure_time" : "17:23:31" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "17:27:15" , 
"departure_time" : "17:27:45" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "17:31:30" , 
"departure_time" : "17:32:20" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "17:35:50" , 
"departure_time" : "17:36:41" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:42:51" , 
"departure_time" : "17:43:52" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "17:48:01" , 
"departure_time" : "17:48:03" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "17:50:02" , 
"departure_time" : "17:51:36" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "17:55:34" , 
"departure_time" : "17:55:59" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:57:25" , 
"departure_time" : "17:58:15" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 61,
"arrival_time" : "18:01:50" , 
"departure_time" : "18:02:58" , 
"distance_traveled" : 28.4165
}, 
{ 
"stop_id" : 112,
"arrival_time" : "18:05:08" , 
"departure_time" : "18:05:36" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "18:07:28" , 
"departure_time" : "18:08:01" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "18:10:33" , 
"departure_time" : "18:10:42" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:16:09" , 
"departure_time" : "18:16:55" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:27:46" , 
"departure_time" : "18:28:09" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:41:23" , 
"departure_time" : "18:41:23" , 
"distance_traveled" : 43.2223
} ], 
"2014" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "23:03:00" , 
"departure_time" : "23:04:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "23:10:47" , 
"departure_time" : "23:11:34" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "23:13:47" , 
"departure_time" : "23:14:25" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "23:19:38" , 
"departure_time" : "23:21:11" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "23:24:33" , 
"departure_time" : "23:25:07" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "23:27:34" , 
"departure_time" : "23:28:53" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "23:32:19" , 
"departure_time" : "23:33:56" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "23:36:37" , 
"departure_time" : "23:37:46" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "23:43:09" , 
"departure_time" : "23:44:13" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "23:48:04" , 
"departure_time" : "23:48:32" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "23:50:28" , 
"departure_time" : "23:52:08" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "23:55:40" , 
"departure_time" : "23:56:36" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "23:57:56" , 
"departure_time" : "23:59:16" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 61,
"arrival_time" : "24:02:20" , 
"departure_time" : "24:03:07" , 
"distance_traveled" : 28.4165
}, 
{ 
"stop_id" : 112,
"arrival_time" : "24:04:47" , 
"departure_time" : "24:05:11" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "24:07:24" , 
"departure_time" : "24:08:07" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "24:10:43" , 
"departure_time" : "24:11:18" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "24:16:35" , 
"departure_time" : "24:17:33" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:25:58" , 
"departure_time" : "24:26:29" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "24:39:31" , 
"departure_time" : "24:39:31" , 
"distance_traveled" : 43.2223
} ], 
"2015" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "06:04:00" , 
"departure_time" : "06:05:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "06:11:32" , 
"departure_time" : "06:11:34" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "06:13:02" , 
"departure_time" : "06:14:28" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "06:20:26" , 
"departure_time" : "06:22:00" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "06:24:34" , 
"departure_time" : "06:26:08" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "06:28:34" , 
"departure_time" : "06:29:23" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "06:31:49" , 
"departure_time" : "06:33:15" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "06:36:26" , 
"departure_time" : "06:36:57" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "06:42:31" , 
"departure_time" : "06:42:57" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "06:47:26" , 
"departure_time" : "06:47:45" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "06:50:19" , 
"departure_time" : "06:51:47" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "06:55:28" , 
"departure_time" : "06:57:03" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "06:58:35" , 
"departure_time" : "06:58:53" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 97,
"arrival_time" : "07:00:18" , 
"departure_time" : "07:01:48" , 
"distance_traveled" : 27.4884
}, 
{ 
"stop_id" : 112,
"arrival_time" : "07:05:30" , 
"departure_time" : "07:06:43" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "07:08:13" , 
"departure_time" : "07:08:20" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "07:10:07" , 
"departure_time" : "07:11:33" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:17:26" , 
"departure_time" : "07:18:28" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:26:02" , 
"departure_time" : "07:26:23" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:39:21" , 
"departure_time" : "07:39:21" , 
"distance_traveled" : 43.2223
} ], 
"2016" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "08:03:00" , 
"departure_time" : "08:04:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "08:10:43" , 
"departure_time" : "08:11:50" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "08:14:07" , 
"departure_time" : "08:14:10" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "08:19:03" , 
"departure_time" : "08:19:53" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "08:23:50" , 
"departure_time" : "08:25:15" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "08:28:25" , 
"departure_time" : "08:28:43" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "08:31:18" , 
"departure_time" : "08:32:29" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "08:36:11" , 
"departure_time" : "08:37:26" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "08:43:15" , 
"departure_time" : "08:44:37" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "08:48:22" , 
"departure_time" : "08:48:40" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "08:50:18" , 
"departure_time" : "08:51:27" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "08:55:09" , 
"departure_time" : "08:56:32" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:58:23" , 
"departure_time" : "08:58:38" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 97,
"arrival_time" : "09:00:15" , 
"departure_time" : "09:00:37" , 
"distance_traveled" : 27.4884
}, 
{ 
"stop_id" : 112,
"arrival_time" : "09:04:22" , 
"departure_time" : "09:05:05" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "09:07:43" , 
"departure_time" : "09:07:50" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "09:10:07" , 
"departure_time" : "09:11:23" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:17:16" , 
"departure_time" : "09:17:46" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:25:30" , 
"departure_time" : "09:26:15" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:39:45" , 
"departure_time" : "09:39:45" , 
"distance_traveled" : 43.2223
} ], 
"2017" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "10:03:00" , 
"departure_time" : "10:03:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "10:10:14" , 
"departure_time" : "10:10:57" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "10:13:43" , 
"departure_time" : "10:15:10" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "10:20:27" , 
"departure_time" : "10:21:00" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "10:23:33" , 
"departure_time" : "10:24:15" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "10:27:42" , 
"departure_time" : "10:27:47" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "10:31:05" , 
"departure_time" : "10:31:50" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "10:35:45" , 
"departure_time" : "10:37:08" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "10:43:23" , 
"departure_time" : "10:45:01" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "10:48:38" , 
"departure_time" : "10:49:21" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "10:50:43" , 
"departure_time" : "10:51:32" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "10:54:49" , 
"departure_time" : "10:55:58" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "10:58:09" , 
"departure_time" : "10:59:24" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 97,
"arrival_time" : "11:01:15" , 
"departure_time" : "11:01:46" , 
"distance_traveled" : 27.4884
}, 
{ 
"stop_id" : 112,
"arrival_time" : "11:04:31" , 
"departure_time" : "11:05:30" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "11:07:59" , 
"departure_time" : "11:09:15" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "11:11:16" , 
"departure_time" : "11:12:56" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "11:17:40" , 
"departure_time" : "11:18:45" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:26:05" , 
"departure_time" : "11:26:27" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "11:39:22" , 
"departure_time" : "11:39:22" , 
"distance_traveled" : 43.2223
} ], 
"2018" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "14:03:00" , 
"departure_time" : "14:03:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "14:10:05" , 
"departure_time" : "14:10:25" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "14:13:20" , 
"departure_time" : "14:14:17" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "14:19:57" , 
"departure_time" : "14:21:29" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "14:24:32" , 
"departure_time" : "14:25:04" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "14:27:32" , 
"departure_time" : "14:28:51" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "14:32:19" , 
"departure_time" : "14:32:21" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "14:35:02" , 
"departure_time" : "14:36:02" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "14:43:00" , 
"departure_time" : "14:43:15" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "14:47:15" , 
"departure_time" : "14:48:40" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "14:51:25" , 
"departure_time" : "14:52:14" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "14:54:49" , 
"departure_time" : "14:56:25" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "14:58:36" , 
"departure_time" : "14:59:03" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 97,
"arrival_time" : "15:00:27" , 
"departure_time" : "15:00:57" , 
"distance_traveled" : 27.4884
}, 
{ 
"stop_id" : 112,
"arrival_time" : "15:04:30" , 
"departure_time" : "15:04:53" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "15:07:23" , 
"departure_time" : "15:07:42" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "15:10:19" , 
"departure_time" : "15:10:51" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:16:32" , 
"departure_time" : "15:17:51" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:26:19" , 
"departure_time" : "15:27:38" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "15:40:19" , 
"departure_time" : "15:40:19" , 
"distance_traveled" : 43.2223
} ], 
"2019" :  [ 
{ 
"stop_id" : 35,
"arrival_time" : "20:03:00" , 
"departure_time" : "20:05:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 34,
"arrival_time" : "20:10:43" , 
"departure_time" : "20:12:06" , 
"distance_traveled" : 4.2085
}, 
{ 
"stop_id" : 94,
"arrival_time" : "20:14:23" , 
"departure_time" : "20:15:41" , 
"distance_traveled" : 4.8159
}, 
{ 
"stop_id" : 91,
"arrival_time" : "20:20:18" , 
"departure_time" : "20:20:44" , 
"distance_traveled" : 8.507
}, 
{ 
"stop_id" : 92,
"arrival_time" : "20:23:26" , 
"departure_time" : "20:24:57" , 
"distance_traveled" : 10.7477
}, 
{ 
"stop_id" : 30,
"arrival_time" : "20:28:31" , 
"departure_time" : "20:28:32" , 
"distance_traveled" : 12.8519
}, 
{ 
"stop_id" : 77,
"arrival_time" : "20:31:01" , 
"departure_time" : "20:32:18" , 
"distance_traveled" : 15.0174
}, 
{ 
"stop_id" : 27,
"arrival_time" : "20:36:17" , 
"departure_time" : "20:37:18" , 
"distance_traveled" : 17.035
}, 
{ 
"stop_id" : 145,
"arrival_time" : "20:43:01" , 
"departure_time" : "20:43:06" , 
"distance_traveled" : 20.4833
}, 
{ 
"stop_id" : 136,
"arrival_time" : "20:47:05" , 
"departure_time" : "20:48:36" , 
"distance_traveled" : 22.7513
}, 
{ 
"stop_id" : 87,
"arrival_time" : "20:51:31" , 
"departure_time" : "20:52:56" , 
"distance_traveled" : 23.8258
}, 
{ 
"stop_id" : 81,
"arrival_time" : "20:55:25" , 
"departure_time" : "20:56:55" , 
"distance_traveled" : 25.4345
}, 
{ 
"stop_id" : 140,
"arrival_time" : "20:58:30" , 
"departure_time" : "20:59:23" , 
"distance_traveled" : 26.7169
}, 
{ 
"stop_id" : 97,
"arrival_time" : "21:00:53" , 
"departure_time" : "21:01:41" , 
"distance_traveled" : 27.4884
}, 
{ 
"stop_id" : 112,
"arrival_time" : "21:04:48" , 
"departure_time" : "21:05:00" , 
"distance_traveled" : 29.1241
}, 
{ 
"stop_id" : 23,
"arrival_time" : "21:07:12" , 
"departure_time" : "21:07:41" , 
"distance_traveled" : 30.025
}, 
{ 
"stop_id" : 37,
"arrival_time" : "21:10:29" , 
"departure_time" : "21:11:54" , 
"distance_traveled" : 30.5528
}, 
{ 
"stop_id" : 106,
"arrival_time" : "21:17:25" , 
"departure_time" : "21:18:04" , 
"distance_traveled" : 32.8006
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:25:39" , 
"departure_time" : "21:27:09" , 
"distance_traveled" : 38.2343
}, 
{ 
"stop_id" : 105,
"arrival_time" : "21:40:30" , 
"departure_time" : "21:40:30" , 
"distance_traveled" : 43.2223
} ], 
"2020" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "24:02:00" , 
"departure_time" : "24:05:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:12:31" , 
"departure_time" : "24:13:05" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "24:21:34" , 
"departure_time" : "24:23:13" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "24:29:39" , 
"departure_time" : "24:30:53" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "24:32:14" , 
"departure_time" : "24:33:27" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 140,
"arrival_time" : "24:37:13" , 
"departure_time" : "24:38:33" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "24:40:20" , 
"departure_time" : "24:40:57" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "24:43:37" , 
"departure_time" : "24:43:55" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "24:47:18" , 
"departure_time" : "24:48:04" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "24:52:46" , 
"departure_time" : "24:53:45" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "24:59:59" , 
"departure_time" : "25:00:27" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "25:03:28" , 
"departure_time" : "25:03:59" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "25:08:31" , 
"departure_time" : "25:09:48" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "25:13:17" , 
"departure_time" : "25:14:42" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "25:18:25" , 
"departure_time" : "25:19:50" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "25:25:25" , 
"departure_time" : "25:26:05" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "25:26:40" , 
"departure_time" : "25:27:22" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "25:36:42" , 
"departure_time" : "25:36:42" , 
"distance_traveled" : 43.1008
} ], 
"2021" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "24:02:00" , 
"departure_time" : "24:02:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:11:13" , 
"departure_time" : "24:12:53" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "24:22:40" , 
"departure_time" : "24:22:50" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "24:28:10" , 
"departure_time" : "24:28:45" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "24:31:35" , 
"departure_time" : "24:33:05" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 140,
"arrival_time" : "24:37:30" , 
"departure_time" : "24:37:36" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "24:39:06" , 
"departure_time" : "24:40:26" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "24:44:20" , 
"departure_time" : "24:45:27" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "24:48:07" , 
"departure_time" : "24:49:10" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "24:53:03" , 
"departure_time" : "24:53:32" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "24:59:29" , 
"departure_time" : "24:59:42" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "25:03:13" , 
"departure_time" : "25:04:41" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "25:09:28" , 
"departure_time" : "25:09:36" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "25:12:08" , 
"departure_time" : "25:13:48" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "25:18:40" , 
"departure_time" : "25:19:30" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "25:24:50" , 
"departure_time" : "25:25:55" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "25:27:05" , 
"departure_time" : "25:27:25" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "25:36:20" , 
"departure_time" : "25:36:20" , 
"distance_traveled" : 43.1008
} ], 
"2022" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "24:56:00" , 
"departure_time" : "24:57:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "25:05:53" , 
"departure_time" : "25:06:58" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "25:16:05" , 
"departure_time" : "25:17:19" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "25:21:14" , 
"departure_time" : "25:21:34" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "25:22:20" , 
"departure_time" : "25:23:21" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "25:26:01" , 
"departure_time" : "25:26:48" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "25:27:47" , 
"departure_time" : "25:29:21" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 97,
"arrival_time" : "25:31:34" , 
"departure_time" : "25:32:13" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "25:32:39" , 
"departure_time" : "25:32:43" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "25:35:04" , 
"departure_time" : "25:36:27" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "25:40:23" , 
"departure_time" : "25:41:09" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "25:43:46" , 
"departure_time" : "25:44:03" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "25:49:17" , 
"departure_time" : "25:49:42" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "25:55:25" , 
"departure_time" : "25:56:36" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "26:00:11" , 
"departure_time" : "26:01:15" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "26:05:04" , 
"departure_time" : "26:05:45" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "26:08:41" , 
"departure_time" : "26:09:38" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "26:13:57" , 
"departure_time" : "26:15:02" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "26:21:05" , 
"departure_time" : "26:21:15" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "26:30:10" , 
"departure_time" : "26:30:10" , 
"distance_traveled" : 43.1006
} ], 
"2023" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "24:56:00" , 
"departure_time" : "24:57:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "25:06:01" , 
"departure_time" : "25:06:28" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "25:15:27" , 
"departure_time" : "25:16:53" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "25:21:26" , 
"departure_time" : "25:22:48" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "25:23:22" , 
"departure_time" : "25:23:57" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "25:25:35" , 
"departure_time" : "25:27:02" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "25:28:27" , 
"departure_time" : "25:29:38" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 97,
"arrival_time" : "25:31:11" , 
"departure_time" : "25:32:34" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "25:33:23" , 
"departure_time" : "25:34:52" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "25:36:29" , 
"departure_time" : "25:37:46" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "25:40:17" , 
"departure_time" : "25:41:20" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "25:44:03" , 
"departure_time" : "25:45:16" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "25:50:13" , 
"departure_time" : "25:51:20" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "25:56:07" , 
"departure_time" : "25:56:31" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "25:59:24" , 
"departure_time" : "26:00:13" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "26:04:49" , 
"departure_time" : "26:05:05" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "26:08:16" , 
"departure_time" : "26:09:42" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "26:14:26" , 
"departure_time" : "26:15:27" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "26:21:01" , 
"departure_time" : "26:21:57" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "26:30:56" , 
"departure_time" : "26:30:56" , 
"distance_traveled" : 43.1006
} ], 
"2024" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "07:09:00" , 
"departure_time" : "07:10:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:25:05" , 
"departure_time" : "07:26:30" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 23,
"arrival_time" : "07:32:25" , 
"departure_time" : "07:33:28" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "07:35:03" , 
"departure_time" : "07:36:23" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "07:37:20" , 
"departure_time" : "07:38:03" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "07:38:43" , 
"departure_time" : "07:39:31" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:41:48" , 
"departure_time" : "07:43:18" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:45:30" , 
"departure_time" : "07:45:51" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:48:21" , 
"departure_time" : "07:49:37" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:52:16" , 
"departure_time" : "07:52:28" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:57:12" , 
"departure_time" : "07:57:12" , 
"distance_traveled" : 20.0947
} ], 
"2025" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "04:55:00" , 
"departure_time" : "04:55:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "05:11:26" , 
"departure_time" : "05:11:34" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "05:16:08" , 
"departure_time" : "05:17:12" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "05:19:04" , 
"departure_time" : "05:20:28" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "05:22:24" , 
"departure_time" : "05:23:15" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "05:23:51" , 
"departure_time" : "05:25:20" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "05:26:29" , 
"departure_time" : "05:27:25" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "05:28:56" , 
"departure_time" : "05:29:37" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "05:31:41" , 
"departure_time" : "05:32:10" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "05:34:29" , 
"departure_time" : "05:34:41" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "05:37:12" , 
"departure_time" : "05:37:23" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "05:42:11" , 
"departure_time" : "05:42:11" , 
"distance_traveled" : 20.0947
} ], 
"2026" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "06:36:00" , 
"departure_time" : "06:36:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:52:11" , 
"departure_time" : "06:53:35" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "06:58:24" , 
"departure_time" : "06:59:03" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "06:59:39" , 
"departure_time" : "07:00:51" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "07:03:12" , 
"departure_time" : "07:04:37" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "07:05:25" , 
"departure_time" : "07:06:06" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "07:06:41" , 
"departure_time" : "07:07:38" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:09:57" , 
"departure_time" : "07:11:30" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:13:33" , 
"departure_time" : "07:14:39" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:16:06" , 
"departure_time" : "07:16:54" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:18:48" , 
"departure_time" : "07:19:14" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:25:26" , 
"departure_time" : "07:25:26" , 
"distance_traveled" : 20.0947
} ], 
"2027" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "15:50:00" , 
"departure_time" : "15:50:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:06:18" , 
"departure_time" : "16:06:34" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "16:11:16" , 
"departure_time" : "16:12:55" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "16:14:39" , 
"departure_time" : "16:16:04" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "16:17:25" , 
"departure_time" : "16:18:06" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "16:19:41" , 
"departure_time" : "16:19:49" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "16:21:08" , 
"departure_time" : "16:22:10" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "16:25:02" , 
"departure_time" : "16:26:19" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "16:28:17" , 
"departure_time" : "16:29:49" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "16:32:32" , 
"departure_time" : "16:33:57" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "16:35:25" , 
"departure_time" : "16:35:27" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:39:02" , 
"departure_time" : "16:39:02" , 
"distance_traveled" : 20.0947
} ], 
"2028" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "07:09:00" , 
"departure_time" : "07:10:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:26:19" , 
"departure_time" : "07:26:57" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 23,
"arrival_time" : "07:31:38" , 
"departure_time" : "07:32:59" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "07:35:21" , 
"departure_time" : "07:35:23" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "07:36:02" , 
"departure_time" : "07:36:31" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "07:38:29" , 
"departure_time" : "07:39:59" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:42:30" , 
"departure_time" : "07:42:52" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:44:22" , 
"departure_time" : "07:45:55" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:49:33" , 
"departure_time" : "07:49:39" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:51:06" , 
"departure_time" : "07:51:48" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:57:42" , 
"departure_time" : "07:57:42" , 
"distance_traveled" : 20.0947
} ], 
"2029" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:50:00" , 
"departure_time" : "16:51:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:06:52" , 
"departure_time" : "17:07:01" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "17:11:09" , 
"departure_time" : "17:11:32" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:13:23" , 
"departure_time" : "17:13:53" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "17:16:30" , 
"departure_time" : "17:17:27" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "17:19:57" , 
"departure_time" : "17:19:58" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "17:21:01" , 
"departure_time" : "17:21:28" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:24:27" , 
"departure_time" : "17:24:38" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "17:27:11" , 
"departure_time" : "17:28:08" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "17:31:57" , 
"departure_time" : "17:32:54" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "17:34:57" , 
"departure_time" : "17:35:15" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:39:18" , 
"departure_time" : "17:39:18" , 
"distance_traveled" : 20.0947
} ], 
"2030" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "04:55:00" , 
"departure_time" : "04:56:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "05:12:07" , 
"departure_time" : "05:13:24" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "05:17:17" , 
"departure_time" : "05:18:09" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "05:18:52" , 
"departure_time" : "05:18:55" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "05:21:03" , 
"departure_time" : "05:22:25" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "05:24:22" , 
"departure_time" : "05:24:41" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "05:25:19" , 
"departure_time" : "05:25:58" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "05:28:39" , 
"departure_time" : "05:30:13" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "05:32:34" , 
"departure_time" : "05:33:12" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "05:34:38" , 
"departure_time" : "05:35:44" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "05:38:06" , 
"departure_time" : "05:39:26" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "05:43:20" , 
"departure_time" : "05:43:20" , 
"distance_traveled" : 20.0947
} ], 
"2031" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:40:00" , 
"departure_time" : "17:42:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:57:29" , 
"departure_time" : "17:58:11" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "18:02:42" , 
"departure_time" : "18:02:54" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "18:04:12" , 
"departure_time" : "18:04:43" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "18:07:31" , 
"departure_time" : "18:09:09" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "18:11:38" , 
"departure_time" : "18:11:46" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "18:12:08" , 
"departure_time" : "18:12:55" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:15:47" , 
"departure_time" : "18:16:25" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:18:38" , 
"departure_time" : "18:19:53" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:23:15" , 
"departure_time" : "18:24:13" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "18:25:58" , 
"departure_time" : "18:27:27" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:31:29" , 
"departure_time" : "18:31:29" , 
"distance_traveled" : 20.0947
} ], 
"2032" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "06:36:00" , 
"departure_time" : "06:38:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:53:07" , 
"departure_time" : "06:54:13" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "06:58:06" , 
"departure_time" : "06:59:16" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "07:00:10" , 
"departure_time" : "07:00:50" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "07:02:40" , 
"departure_time" : "07:03:12" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "07:04:32" , 
"departure_time" : "07:05:29" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "07:06:57" , 
"departure_time" : "07:07:25" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:09:28" , 
"departure_time" : "07:10:20" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:12:52" , 
"departure_time" : "07:13:46" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:15:54" , 
"departure_time" : "07:16:37" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:18:43" , 
"departure_time" : "07:19:58" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:26:15" , 
"departure_time" : "07:26:15" , 
"distance_traveled" : 20.0947
} ], 
"2033" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:35:00" , 
"departure_time" : "17:36:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:51:40" , 
"departure_time" : "17:53:07" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:59:27" , 
"departure_time" : "18:00:31" , 
"distance_traveled" : 13.1979
}, 
{ 
"stop_id" : 112,
"arrival_time" : "18:02:04" , 
"departure_time" : "18:02:23" , 
"distance_traveled" : 14.0973
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:06:19" , 
"departure_time" : "18:06:52" , 
"distance_traveled" : 16.4955
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:09:33" , 
"departure_time" : "18:10:51" , 
"distance_traveled" : 17.7778
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:14:18" , 
"departure_time" : "18:15:47" , 
"distance_traveled" : 19.3866
}, 
{ 
"stop_id" : 136,
"arrival_time" : "18:18:29" , 
"departure_time" : "18:19:15" , 
"distance_traveled" : 20.461
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:23:46" , 
"departure_time" : "18:25:07" , 
"distance_traveled" : 22.7286
}, 
{ 
"stop_id" : 27,
"arrival_time" : "18:30:21" , 
"departure_time" : "18:30:28" , 
"distance_traveled" : 26.1549
}, 
{ 
"stop_id" : 77,
"arrival_time" : "18:33:07" , 
"departure_time" : "18:33:52" , 
"distance_traveled" : 28.1502
}, 
{ 
"stop_id" : 30,
"arrival_time" : "18:38:45" , 
"departure_time" : "18:38:59" , 
"distance_traveled" : 30.3155
}, 
{ 
"stop_id" : 92,
"arrival_time" : "18:42:14" , 
"departure_time" : "18:42:30" , 
"distance_traveled" : 32.404
}, 
{ 
"stop_id" : 91,
"arrival_time" : "18:47:16" , 
"departure_time" : "18:47:38" , 
"distance_traveled" : 34.6345
}, 
{ 
"stop_id" : 94,
"arrival_time" : "18:54:22" , 
"departure_time" : "18:54:53" , 
"distance_traveled" : 38.3256
}, 
{ 
"stop_id" : 34,
"arrival_time" : "18:58:31" , 
"departure_time" : "18:59:16" , 
"distance_traveled" : 38.9019
}, 
{ 
"stop_id" : 35,
"arrival_time" : "19:09:45" , 
"departure_time" : "19:09:45" , 
"distance_traveled" : 43.1009
} ], 
"2034" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "15:50:00" , 
"departure_time" : "15:52:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:07:37" , 
"departure_time" : "16:08:13" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "16:11:36" , 
"departure_time" : "16:11:40" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "16:13:04" , 
"departure_time" : "16:13:28" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "16:16:24" , 
"departure_time" : "16:17:35" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "16:20:11" , 
"departure_time" : "16:21:33" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "16:22:22" , 
"departure_time" : "16:23:27" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "16:25:05" , 
"departure_time" : "16:26:41" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "16:28:36" , 
"departure_time" : "16:29:31" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "16:31:55" , 
"departure_time" : "16:33:21" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "16:35:26" , 
"departure_time" : "16:36:02" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:39:36" , 
"departure_time" : "16:39:36" , 
"distance_traveled" : 20.0947
} ], 
"2035" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "06:11:00" , 
"departure_time" : "06:11:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:20:18" , 
"departure_time" : "06:21:36" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:31:18" , 
"departure_time" : "06:32:02" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "06:36:44" , 
"departure_time" : "06:37:10" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "06:39:26" , 
"departure_time" : "06:39:44" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "06:42:18" , 
"departure_time" : "06:42:27" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "06:44:09" , 
"departure_time" : "06:44:27" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 140,
"arrival_time" : "06:48:18" , 
"departure_time" : "06:48:59" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "06:51:41" , 
"departure_time" : "06:52:11" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "06:56:30" , 
"departure_time" : "06:57:12" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:00:42" , 
"departure_time" : "07:00:59" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:08:17" , 
"departure_time" : "07:08:26" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "07:15:09" , 
"departure_time" : "07:16:13" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "07:20:04" , 
"departure_time" : "07:21:34" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "07:25:30" , 
"departure_time" : "07:26:55" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "07:29:25" , 
"departure_time" : "07:30:04" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "07:33:39" , 
"departure_time" : "07:34:31" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "07:40:52" , 
"departure_time" : "07:42:04" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "07:43:12" , 
"departure_time" : "07:44:17" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "07:57:05" , 
"departure_time" : "07:57:05" , 
"distance_traveled" : 43.1008
} ], 
"2036" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:50:00" , 
"departure_time" : "16:52:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:07:27" , 
"departure_time" : "17:08:07" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "17:11:40" , 
"departure_time" : "17:12:14" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:13:34" , 
"departure_time" : "17:14:42" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "17:17:08" , 
"departure_time" : "17:18:09" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "17:20:01" , 
"departure_time" : "17:20:05" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "17:21:04" , 
"departure_time" : "17:21:48" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:24:44" , 
"departure_time" : "17:25:59" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "17:28:15" , 
"departure_time" : "17:29:20" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "17:32:05" , 
"departure_time" : "17:32:19" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "17:34:14" , 
"departure_time" : "17:35:11" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:39:57" , 
"departure_time" : "17:39:57" , 
"distance_traveled" : 20.0947
} ], 
"2037" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "24:34:00" , 
"departure_time" : "24:36:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:44:14" , 
"departure_time" : "24:45:23" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "24:54:09" , 
"departure_time" : "24:54:24" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "24:58:15" , 
"departure_time" : "24:59:26" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "25:02:11" , 
"departure_time" : "25:02:47" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "25:04:36" , 
"departure_time" : "25:04:52" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "25:06:16" , 
"departure_time" : "25:06:40" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 97,
"arrival_time" : "25:09:24" , 
"departure_time" : "25:09:34" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "25:11:10" , 
"departure_time" : "25:11:19" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "25:14:09" , 
"departure_time" : "25:14:25" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "25:18:16" , 
"departure_time" : "25:19:05" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "25:22:49" , 
"departure_time" : "25:23:55" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "25:29:06" , 
"departure_time" : "25:29:49" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "25:34:43" , 
"departure_time" : "25:35:18" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "25:38:35" , 
"departure_time" : "25:40:11" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "25:44:36" , 
"departure_time" : "25:45:32" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "25:47:56" , 
"departure_time" : "25:49:27" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "25:52:31" , 
"departure_time" : "25:54:08" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "26:00:37" , 
"departure_time" : "26:01:52" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "26:14:15" , 
"departure_time" : "26:14:15" , 
"distance_traveled" : 43.1006
} ], 
"2038" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:40:00" , 
"departure_time" : "17:41:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:56:15" , 
"departure_time" : "17:56:26" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "18:02:11" , 
"departure_time" : "18:03:10" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "18:04:59" , 
"departure_time" : "18:06:36" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "18:08:37" , 
"departure_time" : "18:09:26" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "18:10:49" , 
"departure_time" : "18:10:51" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "18:12:02" , 
"departure_time" : "18:13:14" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:16:12" , 
"departure_time" : "18:16:14" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:18:02" , 
"departure_time" : "18:18:22" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:22:20" , 
"departure_time" : "18:23:59" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "18:26:39" , 
"departure_time" : "18:27:03" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:30:24" , 
"departure_time" : "18:30:24" , 
"distance_traveled" : 20.0947
} ], 
"2039" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "24:34:00" , 
"departure_time" : "24:34:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:43:21" , 
"departure_time" : "24:45:01" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "24:54:40" , 
"departure_time" : "24:54:50" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "24:58:10" , 
"departure_time" : "24:59:35" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "25:02:25" , 
"departure_time" : "25:03:42" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "25:05:17" , 
"departure_time" : "25:05:21" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "25:06:04" , 
"departure_time" : "25:07:33" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 97,
"arrival_time" : "25:10:29" , 
"departure_time" : "25:10:55" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "25:11:26" , 
"departure_time" : "25:11:27" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "25:14:01" , 
"departure_time" : "25:14:28" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "25:18:27" , 
"departure_time" : "25:19:48" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "25:23:21" , 
"departure_time" : "25:24:56" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "25:29:35" , 
"departure_time" : "25:31:02" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "25:35:27" , 
"departure_time" : "25:37:03" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "25:39:36" , 
"departure_time" : "25:40:02" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "25:43:26" , 
"departure_time" : "25:44:58" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "25:48:32" , 
"departure_time" : "25:48:38" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "25:51:06" , 
"departure_time" : "25:52:32" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "26:00:26" , 
"departure_time" : "26:01:26" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "26:14:00" , 
"departure_time" : "26:14:00" , 
"distance_traveled" : 43.1006
} ], 
"2040" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:35:00" , 
"departure_time" : "17:36:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:51:18" , 
"departure_time" : "17:52:54" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:59:36" , 
"departure_time" : "18:00:27" , 
"distance_traveled" : 13.1979
}, 
{ 
"stop_id" : 112,
"arrival_time" : "18:01:51" , 
"departure_time" : "18:03:25" , 
"distance_traveled" : 14.0973
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:07:34" , 
"departure_time" : "18:08:30" , 
"distance_traveled" : 16.4955
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:09:56" , 
"departure_time" : "18:10:00" , 
"distance_traveled" : 17.7778
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:13:04" , 
"departure_time" : "18:13:21" , 
"distance_traveled" : 19.3866
}, 
{ 
"stop_id" : 136,
"arrival_time" : "18:17:17" , 
"departure_time" : "18:18:04" , 
"distance_traveled" : 20.461
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:23:47" , 
"departure_time" : "18:24:33" , 
"distance_traveled" : 22.7286
}, 
{ 
"stop_id" : 27,
"arrival_time" : "18:29:46" , 
"departure_time" : "18:31:24" , 
"distance_traveled" : 26.1549
}, 
{ 
"stop_id" : 77,
"arrival_time" : "18:34:38" , 
"departure_time" : "18:36:17" , 
"distance_traveled" : 28.1502
}, 
{ 
"stop_id" : 30,
"arrival_time" : "18:39:39" , 
"departure_time" : "18:40:12" , 
"distance_traveled" : 30.3155
}, 
{ 
"stop_id" : 92,
"arrival_time" : "18:42:33" , 
"departure_time" : "18:42:57" , 
"distance_traveled" : 32.404
}, 
{ 
"stop_id" : 91,
"arrival_time" : "18:47:24" , 
"departure_time" : "18:48:14" , 
"distance_traveled" : 34.6345
}, 
{ 
"stop_id" : 94,
"arrival_time" : "18:54:50" , 
"departure_time" : "18:55:50" , 
"distance_traveled" : 38.3256
}, 
{ 
"stop_id" : 34,
"arrival_time" : "18:59:00" , 
"departure_time" : "18:59:12" , 
"distance_traveled" : 38.9019
}, 
{ 
"stop_id" : 35,
"arrival_time" : "19:09:12" , 
"departure_time" : "19:09:12" , 
"distance_traveled" : 43.1009
} ], 
"2041" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "25:19:00" , 
"departure_time" : "25:19:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "25:28:21" , 
"departure_time" : "25:28:58" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "25:38:37" , 
"departure_time" : "25:40:15" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "25:44:38" , 
"departure_time" : "25:45:47" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "25:46:09" , 
"departure_time" : "25:46:59" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "25:48:50" , 
"departure_time" : "25:50:24" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "25:51:34" , 
"departure_time" : "25:52:19" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 97,
"arrival_time" : "25:53:45" , 
"departure_time" : "25:54:12" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "25:55:27" , 
"departure_time" : "25:56:07" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "25:58:40" , 
"departure_time" : "25:59:50" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "26:03:10" , 
"departure_time" : "26:03:37" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "26:06:27" , 
"departure_time" : "26:07:22" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "26:13:55" , 
"departure_time" : "26:15:13" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "26:21:18" , 
"departure_time" : "26:22:19" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "26:25:01" , 
"departure_time" : "26:26:24" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "26:30:23" , 
"departure_time" : "26:30:43" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "26:33:20" , 
"departure_time" : "26:34:25" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "26:38:05" , 
"departure_time" : "26:38:44" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "26:44:39" , 
"departure_time" : "26:44:53" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "26:47:14" , 
"departure_time" : "26:47:36" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "27:02:22" , 
"departure_time" : "27:02:22" , 
"distance_traveled" : 43.1008
} ], 
"2042" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "06:11:00" , 
"departure_time" : "06:12:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:21:29" , 
"departure_time" : "06:22:55" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:31:26" , 
"departure_time" : "06:31:50" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "06:36:24" , 
"departure_time" : "06:37:41" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "06:40:17" , 
"departure_time" : "06:40:40" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "06:42:23" , 
"departure_time" : "06:42:38" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "06:44:15" , 
"departure_time" : "06:45:06" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 140,
"arrival_time" : "06:48:51" , 
"departure_time" : "06:49:50" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "06:51:59" , 
"departure_time" : "06:52:36" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "06:56:37" , 
"departure_time" : "06:57:45" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:01:08" , 
"departure_time" : "07:01:22" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:08:14" , 
"departure_time" : "07:09:54" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "07:16:40" , 
"departure_time" : "07:17:25" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "07:19:45" , 
"departure_time" : "07:20:31" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "07:24:46" , 
"departure_time" : "07:26:26" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "07:29:40" , 
"departure_time" : "07:30:21" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "07:33:41" , 
"departure_time" : "07:33:56" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "07:40:15" , 
"departure_time" : "07:40:44" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "07:42:29" , 
"departure_time" : "07:44:03" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "07:57:34" , 
"departure_time" : "07:57:34" , 
"distance_traveled" : 43.1008
} ], 
"2043" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "25:19:00" , 
"departure_time" : "25:21:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "25:28:31" , 
"departure_time" : "25:29:20" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "25:38:49" , 
"departure_time" : "25:39:29" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "25:43:40" , 
"departure_time" : "25:45:10" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "25:46:30" , 
"departure_time" : "25:47:35" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "25:49:05" , 
"departure_time" : "25:50:15" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "25:51:10" , 
"departure_time" : "25:52:21" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 97,
"arrival_time" : "25:54:11" , 
"departure_time" : "25:54:26" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "25:55:15" , 
"departure_time" : "25:56:02" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "25:58:47" , 
"departure_time" : "25:59:22" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "26:02:35" , 
"departure_time" : "26:02:44" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "26:06:09" , 
"departure_time" : "26:06:38" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "26:13:29" , 
"departure_time" : "26:15:05" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "26:21:36" , 
"departure_time" : "26:23:14" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "26:25:38" , 
"departure_time" : "26:26:50" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "26:30:12" , 
"departure_time" : "26:30:45" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "26:33:33" , 
"departure_time" : "26:34:55" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "26:38:22" , 
"departure_time" : "26:38:45" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "26:44:23" , 
"departure_time" : "26:44:45" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "26:47:22" , 
"departure_time" : "26:47:50" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "27:02:28" , 
"departure_time" : "27:02:28" , 
"distance_traveled" : 43.1008
} ], 
"2044" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "09:11:00" , 
"departure_time" : "09:11:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:20:20" , 
"departure_time" : "09:21:30" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:31:10" , 
"departure_time" : "09:31:52" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "09:36:42" , 
"departure_time" : "09:36:58" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "09:39:16" , 
"departure_time" : "09:40:54" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "09:43:38" , 
"departure_time" : "09:44:34" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "09:44:56" , 
"departure_time" : "09:46:09" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 140,
"arrival_time" : "09:49:13" , 
"departure_time" : "09:50:22" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "09:52:09" , 
"departure_time" : "09:52:37" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "09:56:28" , 
"departure_time" : "09:56:41" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "10:00:13" , 
"departure_time" : "10:00:37" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "10:08:24" , 
"departure_time" : "10:08:51" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "10:15:27" , 
"departure_time" : "10:15:34" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "10:19:07" , 
"departure_time" : "10:20:37" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "10:25:30" , 
"departure_time" : "10:25:55" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "10:28:25" , 
"departure_time" : "10:30:05" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "10:34:40" , 
"departure_time" : "10:35:24" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "10:40:44" , 
"departure_time" : "10:41:16" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "10:54:32" , 
"departure_time" : "10:54:32" , 
"distance_traveled" : 43.1006
} ], 
"2045" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "11:11:00" , 
"departure_time" : "11:12:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:21:14" , 
"departure_time" : "11:22:13" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "11:30:59" , 
"departure_time" : "11:31:18" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "11:36:19" , 
"departure_time" : "11:36:55" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "11:39:36" , 
"departure_time" : "11:40:20" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "11:42:44" , 
"departure_time" : "11:43:41" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "11:44:57" , 
"departure_time" : "11:45:01" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 140,
"arrival_time" : "11:48:04" , 
"departure_time" : "11:49:10" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "11:52:06" , 
"departure_time" : "11:52:54" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "11:56:48" , 
"departure_time" : "11:58:01" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "12:01:13" , 
"departure_time" : "12:02:29" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "12:09:16" , 
"departure_time" : "12:09:50" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "12:15:34" , 
"departure_time" : "12:16:23" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "12:19:49" , 
"departure_time" : "12:20:32" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "12:24:43" , 
"departure_time" : "12:25:55" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "12:29:12" , 
"departure_time" : "12:29:43" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "12:33:31" , 
"departure_time" : "12:33:48" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "12:40:17" , 
"departure_time" : "12:41:06" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "12:54:49" , 
"departure_time" : "12:54:49" , 
"distance_traveled" : 43.1006
} ], 
"2046" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:11:00" , 
"departure_time" : "15:12:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:20:36" , 
"departure_time" : "15:21:53" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:32:17" , 
"departure_time" : "15:32:22" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "15:36:05" , 
"departure_time" : "15:37:42" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "15:40:37" , 
"departure_time" : "15:41:18" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "15:42:41" , 
"departure_time" : "15:42:45" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "15:44:04" , 
"departure_time" : "15:45:29" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 140,
"arrival_time" : "15:49:25" , 
"departure_time" : "15:50:57" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "15:52:32" , 
"departure_time" : "15:53:10" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "15:56:38" , 
"departure_time" : "15:58:17" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "16:01:39" , 
"departure_time" : "16:02:51" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:09:12" , 
"departure_time" : "16:10:43" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "16:16:31" , 
"departure_time" : "16:17:07" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "16:19:36" , 
"departure_time" : "16:20:49" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "16:25:13" , 
"departure_time" : "16:26:07" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "16:28:54" , 
"departure_time" : "16:29:43" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "16:33:49" , 
"departure_time" : "16:34:00" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "16:40:11" , 
"departure_time" : "16:41:22" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "16:55:11" , 
"departure_time" : "16:55:11" , 
"distance_traveled" : 43.1006
} ], 
"2047" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "21:11:00" , 
"departure_time" : "21:13:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:21:26" , 
"departure_time" : "21:21:58" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "21:30:32" , 
"departure_time" : "21:31:37" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "21:37:05" , 
"departure_time" : "21:37:27" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "21:39:22" , 
"departure_time" : "21:40:14" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "21:42:52" , 
"departure_time" : "21:43:48" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "21:44:56" , 
"departure_time" : "21:45:53" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 140,
"arrival_time" : "21:48:57" , 
"departure_time" : "21:49:06" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "21:51:09" , 
"departure_time" : "21:51:55" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "21:56:46" , 
"departure_time" : "21:56:52" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "22:00:06" , 
"departure_time" : "22:01:44" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "22:09:38" , 
"departure_time" : "22:10:06" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "22:15:28" , 
"departure_time" : "22:16:39" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "22:20:11" , 
"departure_time" : "22:20:30" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "22:24:19" , 
"departure_time" : "22:25:58" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "22:29:39" , 
"departure_time" : "22:31:03" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "22:34:24" , 
"departure_time" : "22:35:44" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "22:41:20" , 
"departure_time" : "22:42:23" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "22:55:03" , 
"departure_time" : "22:55:03" , 
"distance_traveled" : 43.1006
} ], 
"2048" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "23:11:00" , 
"departure_time" : "23:13:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:21:03" , 
"departure_time" : "23:22:19" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "23:31:16" , 
"departure_time" : "23:32:06" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "23:36:50" , 
"departure_time" : "23:38:04" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "23:40:14" , 
"departure_time" : "23:41:35" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "23:43:21" , 
"departure_time" : "23:43:55" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "23:44:34" , 
"departure_time" : "23:45:08" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 140,
"arrival_time" : "23:48:34" , 
"departure_time" : "23:49:46" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "23:52:12" , 
"departure_time" : "23:53:37" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "23:57:25" , 
"departure_time" : "23:57:54" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "24:00:29" , 
"departure_time" : "24:00:43" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "24:08:14" , 
"departure_time" : "24:08:49" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "24:15:35" , 
"departure_time" : "24:16:36" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "24:20:01" , 
"departure_time" : "24:21:18" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "24:25:17" , 
"departure_time" : "24:26:35" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "24:29:18" , 
"departure_time" : "24:29:40" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "24:33:22" , 
"departure_time" : "24:33:26" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "24:40:04" , 
"departure_time" : "24:40:12" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "24:54:08" , 
"departure_time" : "24:54:08" , 
"distance_traveled" : 43.1006
} ], 
"2049" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "08:11:00" , 
"departure_time" : "08:12:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:21:14" , 
"departure_time" : "08:22:11" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:30:57" , 
"departure_time" : "08:31:55" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "08:36:58" , 
"departure_time" : "08:37:10" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "08:39:12" , 
"departure_time" : "08:40:11" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "08:42:59" , 
"departure_time" : "08:44:00" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 97,
"arrival_time" : "08:47:01" , 
"departure_time" : "08:48:10" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:49:09" , 
"departure_time" : "08:49:21" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "08:51:12" , 
"departure_time" : "08:52:10" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "08:56:58" , 
"departure_time" : "08:57:48" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "09:00:50" , 
"departure_time" : "09:01:25" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "09:08:35" , 
"departure_time" : "09:09:17" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "09:15:42" , 
"departure_time" : "09:17:21" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "09:20:39" , 
"departure_time" : "09:21:06" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "09:24:27" , 
"departure_time" : "09:24:54" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "09:28:27" , 
"departure_time" : "09:28:53" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "09:33:26" , 
"departure_time" : "09:34:48" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "09:41:22" , 
"departure_time" : "09:42:15" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "09:54:53" , 
"departure_time" : "09:54:53" , 
"distance_traveled" : 43.1006
} ], 
"2050" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "24:34:00" , 
"departure_time" : "24:34:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:43:03" , 
"departure_time" : "24:43:21" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "24:53:18" , 
"departure_time" : "24:54:20" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "24:59:02" , 
"departure_time" : "25:00:14" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "25:02:12" , 
"departure_time" : "25:03:17" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "25:05:05" , 
"departure_time" : "25:05:25" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "25:06:20" , 
"departure_time" : "25:07:33" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 97,
"arrival_time" : "25:10:13" , 
"departure_time" : "25:10:51" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "25:11:38" , 
"departure_time" : "25:11:46" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "25:14:08" , 
"departure_time" : "25:14:23" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "25:18:15" , 
"departure_time" : "25:19:49" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "25:23:34" , 
"departure_time" : "25:24:01" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "25:28:27" , 
"departure_time" : "25:29:13" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "25:34:46" , 
"departure_time" : "25:34:58" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "25:38:12" , 
"departure_time" : "25:39:32" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "25:44:20" , 
"departure_time" : "25:44:25" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "25:47:05" , 
"departure_time" : "25:48:12" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "25:52:07" , 
"departure_time" : "25:52:22" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "25:59:15" , 
"departure_time" : "26:00:16" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "26:14:01" , 
"departure_time" : "26:14:01" , 
"distance_traveled" : 43.1006
} ], 
"2051" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "12:11:00" , 
"departure_time" : "12:12:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:20:43" , 
"departure_time" : "12:22:00" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "12:31:17" , 
"departure_time" : "12:32:08" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "12:36:51" , 
"departure_time" : "12:37:37" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "12:39:46" , 
"departure_time" : "12:39:58" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "12:42:12" , 
"departure_time" : "12:42:43" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 97,
"arrival_time" : "12:46:31" , 
"departure_time" : "12:47:12" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "12:48:41" , 
"departure_time" : "12:49:59" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "12:52:18" , 
"departure_time" : "12:53:53" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "12:57:35" , 
"departure_time" : "12:59:02" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "13:01:27" , 
"departure_time" : "13:01:42" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "13:08:15" , 
"departure_time" : "13:09:44" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "13:16:29" , 
"departure_time" : "13:17:50" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "13:20:21" , 
"departure_time" : "13:20:59" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "13:24:38" , 
"departure_time" : "13:25:14" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "13:28:36" , 
"departure_time" : "13:28:55" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "13:33:19" , 
"departure_time" : "13:34:49" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "13:41:30" , 
"departure_time" : "13:41:59" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "13:54:29" , 
"departure_time" : "13:54:29" , 
"distance_traveled" : 43.1006
} ], 
"2052" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "14:11:00" , 
"departure_time" : "14:12:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:21:04" , 
"departure_time" : "14:21:33" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "14:30:29" , 
"departure_time" : "14:31:37" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "14:37:08" , 
"departure_time" : "14:37:50" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "14:39:42" , 
"departure_time" : "14:41:07" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "14:43:25" , 
"departure_time" : "14:44:05" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 97,
"arrival_time" : "14:46:40" , 
"departure_time" : "14:47:43" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "14:49:03" , 
"departure_time" : "14:49:27" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "14:51:24" , 
"departure_time" : "14:52:58" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "14:57:34" , 
"departure_time" : "14:58:27" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "15:00:53" , 
"departure_time" : "15:02:00" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "15:09:07" , 
"departure_time" : "15:09:49" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "15:15:42" , 
"departure_time" : "15:16:17" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "15:19:35" , 
"departure_time" : "15:20:50" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "15:25:15" , 
"departure_time" : "15:26:38" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "15:29:23" , 
"departure_time" : "15:30:18" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "15:33:55" , 
"departure_time" : "15:34:42" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "15:40:47" , 
"departure_time" : "15:41:05" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "15:54:18" , 
"departure_time" : "15:54:18" , 
"distance_traveled" : 43.1006
} ], 
"2053" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "25:19:00" , 
"departure_time" : "25:19:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "25:28:34" , 
"departure_time" : "25:30:14" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "25:39:40" , 
"departure_time" : "25:40:19" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "25:43:39" , 
"departure_time" : "25:44:51" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "25:46:12" , 
"departure_time" : "25:47:21" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "25:49:09" , 
"departure_time" : "25:49:48" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "25:50:39" , 
"departure_time" : "25:50:43" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 97,
"arrival_time" : "25:53:04" , 
"departure_time" : "25:53:45" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "25:55:41" , 
"departure_time" : "25:56:33" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "25:58:52" , 
"departure_time" : "25:59:19" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "26:02:27" , 
"departure_time" : "26:03:16" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "26:06:49" , 
"departure_time" : "26:07:35" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "26:13:46" , 
"departure_time" : "26:14:04" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "26:20:18" , 
"departure_time" : "26:21:28" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "26:25:10" , 
"departure_time" : "26:25:17" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "26:29:07" , 
"departure_time" : "26:30:05" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "26:33:58" , 
"departure_time" : "26:35:02" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "26:38:04" , 
"departure_time" : "26:38:56" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "26:44:52" , 
"departure_time" : "26:45:29" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "26:47:37" , 
"departure_time" : "26:49:08" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "27:03:31" , 
"departure_time" : "27:03:31" , 
"distance_traveled" : 43.1008
} ], 
"2054" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:11:00" , 
"departure_time" : "20:13:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:20:54" , 
"departure_time" : "20:21:05" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "20:30:11" , 
"departure_time" : "20:30:56" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "20:36:45" , 
"departure_time" : "20:37:31" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "20:39:46" , 
"departure_time" : "20:40:15" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "20:42:29" , 
"departure_time" : "20:44:00" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 97,
"arrival_time" : "20:47:31" , 
"departure_time" : "20:48:10" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "20:48:39" , 
"departure_time" : "20:48:44" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "20:51:05" , 
"departure_time" : "20:52:03" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "20:56:58" , 
"departure_time" : "20:58:34" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "21:01:36" , 
"departure_time" : "21:02:46" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "21:09:10" , 
"departure_time" : "21:09:49" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "21:15:39" , 
"departure_time" : "21:16:27" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "21:19:48" , 
"departure_time" : "21:21:24" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "21:25:36" , 
"departure_time" : "21:27:09" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "21:29:33" , 
"departure_time" : "21:29:46" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "21:33:13" , 
"departure_time" : "21:34:35" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "21:41:22" , 
"departure_time" : "21:43:01" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "21:55:39" , 
"departure_time" : "21:55:39" , 
"distance_traveled" : 43.1006
} ], 
"2055" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "07:11:00" , 
"departure_time" : "07:12:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:20:04" , 
"departure_time" : "07:20:58" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:30:54" , 
"departure_time" : "07:31:08" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "07:36:14" , 
"departure_time" : "07:37:38" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "07:40:24" , 
"departure_time" : "07:40:54" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "07:42:30" , 
"departure_time" : "07:43:33" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "07:45:03" , 
"departure_time" : "07:45:55" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:48:52" , 
"departure_time" : "07:49:24" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:51:32" , 
"departure_time" : "07:52:02" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:56:30" , 
"departure_time" : "07:57:59" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "08:01:29" , 
"departure_time" : "08:01:50" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "08:08:21" , 
"departure_time" : "08:09:45" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "08:16:24" , 
"departure_time" : "08:17:55" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "08:20:31" , 
"departure_time" : "08:20:58" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "08:24:27" , 
"departure_time" : "08:25:16" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "08:28:49" , 
"departure_time" : "08:29:07" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "08:33:18" , 
"departure_time" : "08:34:29" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "08:41:11" , 
"departure_time" : "08:42:47" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "08:43:36" , 
"departure_time" : "08:44:07" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "08:56:31" , 
"departure_time" : "08:56:31" , 
"distance_traveled" : 43.1008
} ], 
"2056" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "09:11:00" , 
"departure_time" : "09:13:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:21:32" , 
"departure_time" : "09:22:30" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:30:58" , 
"departure_time" : "09:31:13" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "09:36:15" , 
"departure_time" : "09:37:07" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "09:39:52" , 
"departure_time" : "09:40:07" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "09:42:15" , 
"departure_time" : "09:43:04" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "09:44:49" , 
"departure_time" : "09:45:37" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 140,
"arrival_time" : "09:48:48" , 
"departure_time" : "09:49:16" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "09:51:28" , 
"departure_time" : "09:51:57" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "09:56:29" , 
"departure_time" : "09:57:32" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "10:01:03" , 
"departure_time" : "10:02:24" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "10:09:21" , 
"departure_time" : "10:10:52" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "10:16:31" , 
"departure_time" : "10:18:06" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "10:20:35" , 
"departure_time" : "10:21:42" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "10:25:07" , 
"departure_time" : "10:25:45" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "10:28:38" , 
"departure_time" : "10:30:10" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "10:34:32" , 
"departure_time" : "10:35:20" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "10:40:48" , 
"departure_time" : "10:41:15" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "10:54:27" , 
"departure_time" : "10:54:27" , 
"distance_traveled" : 43.1006
} ], 
"2057" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "13:11:00" , 
"departure_time" : "13:11:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:20:19" , 
"departure_time" : "13:20:23" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "13:30:04" , 
"departure_time" : "13:30:41" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "13:36:37" , 
"departure_time" : "13:38:09" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "13:40:32" , 
"departure_time" : "13:42:05" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "13:43:33" , 
"departure_time" : "13:43:48" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "13:44:15" , 
"departure_time" : "13:44:43" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 140,
"arrival_time" : "13:48:28" , 
"departure_time" : "13:48:40" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "13:51:12" , 
"departure_time" : "13:52:46" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "13:57:34" , 
"departure_time" : "13:58:07" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "14:00:33" , 
"departure_time" : "14:01:43" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "14:09:10" , 
"departure_time" : "14:09:20" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "14:15:10" , 
"departure_time" : "14:15:41" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "14:19:31" , 
"departure_time" : "14:20:18" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "14:24:47" , 
"departure_time" : "14:25:05" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "14:28:18" , 
"departure_time" : "14:29:57" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "14:34:39" , 
"departure_time" : "14:35:54" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "14:41:15" , 
"departure_time" : "14:41:25" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "14:42:10" , 
"departure_time" : "14:43:20" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "14:57:10" , 
"departure_time" : "14:57:10" , 
"distance_traveled" : 43.1008
} ], 
"2058" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "11:11:00" , 
"departure_time" : "11:13:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:20:59" , 
"departure_time" : "11:21:44" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "11:30:45" , 
"departure_time" : "11:30:59" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "11:36:14" , 
"departure_time" : "11:37:16" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "11:40:02" , 
"departure_time" : "11:41:23" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "11:43:21" , 
"departure_time" : "11:44:30" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "11:45:09" , 
"departure_time" : "11:45:33" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 140,
"arrival_time" : "11:48:24" , 
"departure_time" : "11:48:56" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "11:51:32" , 
"departure_time" : "11:51:46" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "11:56:14" , 
"departure_time" : "11:57:28" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "12:01:14" , 
"departure_time" : "12:02:24" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "12:09:10" , 
"departure_time" : "12:09:40" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "12:15:30" , 
"departure_time" : "12:15:50" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "12:19:20" , 
"departure_time" : "12:20:33" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "12:25:13" , 
"departure_time" : "12:26:00" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "12:28:47" , 
"departure_time" : "12:29:14" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "12:33:27" , 
"departure_time" : "12:33:57" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "12:40:30" , 
"departure_time" : "12:40:31" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "12:54:01" , 
"departure_time" : "12:54:01" , 
"distance_traveled" : 43.1006
} ], 
"2059" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:11:00" , 
"departure_time" : "17:11:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:20:45" , 
"departure_time" : "17:20:48" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:30:03" , 
"departure_time" : "17:30:52" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "17:36:49" , 
"departure_time" : "17:38:26" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:40:37" , 
"departure_time" : "17:41:29" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "17:42:52" , 
"departure_time" : "17:43:28" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "17:44:36" , 
"departure_time" : "17:45:55" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:49:19" , 
"departure_time" : "17:50:55" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "17:52:36" , 
"departure_time" : "17:53:05" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "17:56:29" , 
"departure_time" : "17:56:41" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "18:00:12" , 
"departure_time" : "18:01:12" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:09:00" , 
"departure_time" : "18:10:38" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "18:16:38" , 
"departure_time" : "18:18:17" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "18:20:39" , 
"departure_time" : "18:20:45" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "18:24:06" , 
"departure_time" : "18:25:23" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "18:29:17" , 
"departure_time" : "18:30:03" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "18:33:46" , 
"departure_time" : "18:35:19" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "18:41:33" , 
"departure_time" : "18:41:58" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "18:42:25" , 
"departure_time" : "18:43:49" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "18:57:24" , 
"departure_time" : "18:57:24" , 
"distance_traveled" : 43.1008
} ], 
"2060" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:11:00" , 
"departure_time" : "15:13:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:21:23" , 
"departure_time" : "15:22:31" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:32:08" , 
"departure_time" : "15:32:51" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "15:36:43" , 
"departure_time" : "15:37:10" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "15:39:27" , 
"departure_time" : "15:40:29" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "15:43:02" , 
"departure_time" : "15:43:38" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "15:44:36" , 
"departure_time" : "15:45:29" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 140,
"arrival_time" : "15:48:53" , 
"departure_time" : "15:49:21" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "15:51:28" , 
"departure_time" : "15:51:30" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "15:56:02" , 
"departure_time" : "15:56:10" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "16:00:08" , 
"departure_time" : "16:00:20" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:08:12" , 
"departure_time" : "16:09:49" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "16:16:37" , 
"departure_time" : "16:17:40" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "16:20:03" , 
"departure_time" : "16:21:19" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "16:25:16" , 
"departure_time" : "16:25:41" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "16:28:25" , 
"departure_time" : "16:29:15" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "16:33:50" , 
"departure_time" : "16:35:14" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "16:41:24" , 
"departure_time" : "16:41:49" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "16:54:25" , 
"departure_time" : "16:54:25" , 
"distance_traveled" : 43.1006
} ], 
"2061" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:11:00" , 
"departure_time" : "19:11:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:20:01" , 
"departure_time" : "19:20:06" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:30:05" , 
"departure_time" : "19:31:23" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "19:37:18" , 
"departure_time" : "19:38:50" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "19:40:32" , 
"departure_time" : "19:42:09" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "19:43:37" , 
"departure_time" : "19:44:08" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "19:44:31" , 
"departure_time" : "19:45:44" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 140,
"arrival_time" : "19:49:13" , 
"departure_time" : "19:49:36" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "19:51:23" , 
"departure_time" : "19:51:59" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "19:56:36" , 
"departure_time" : "19:57:40" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "20:01:04" , 
"departure_time" : "20:02:25" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "20:09:21" , 
"departure_time" : "20:10:10" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "20:15:49" , 
"departure_time" : "20:16:44" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "20:19:55" , 
"departure_time" : "20:21:03" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "20:25:08" , 
"departure_time" : "20:26:37" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "20:29:29" , 
"departure_time" : "20:29:34" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "20:33:05" , 
"departure_time" : "20:33:22" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "20:40:17" , 
"departure_time" : "20:40:20" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "20:42:03" , 
"departure_time" : "20:43:28" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "20:57:25" , 
"departure_time" : "20:57:25" , 
"distance_traveled" : 43.1008
} ], 
"2062" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "21:11:00" , 
"departure_time" : "21:13:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:21:18" , 
"departure_time" : "21:22:01" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "21:30:43" , 
"departure_time" : "21:30:48" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "21:36:05" , 
"departure_time" : "21:36:44" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "21:39:39" , 
"departure_time" : "21:40:08" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "21:42:29" , 
"departure_time" : "21:43:13" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "21:44:44" , 
"departure_time" : "21:44:54" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 140,
"arrival_time" : "21:48:10" , 
"departure_time" : "21:49:02" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "21:51:52" , 
"departure_time" : "21:52:05" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "21:56:13" , 
"departure_time" : "21:56:23" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "22:00:10" , 
"departure_time" : "22:00:59" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "22:08:49" , 
"departure_time" : "22:09:16" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "22:15:27" , 
"departure_time" : "22:16:46" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "22:20:19" , 
"departure_time" : "22:21:00" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "22:24:41" , 
"departure_time" : "22:25:21" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "22:28:40" , 
"departure_time" : "22:29:23" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "22:33:43" , 
"departure_time" : "22:35:14" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "22:41:31" , 
"departure_time" : "22:42:39" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "22:55:08" , 
"departure_time" : "22:55:08" , 
"distance_traveled" : 43.1006
} ], 
"2063" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "10:11:00" , 
"departure_time" : "10:12:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:20:51" , 
"departure_time" : "10:21:46" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "10:30:55" , 
"departure_time" : "10:30:58" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "10:36:03" , 
"departure_time" : "10:36:31" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "10:39:28" , 
"departure_time" : "10:39:48" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "10:42:20" , 
"departure_time" : "10:43:30" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 97,
"arrival_time" : "10:47:10" , 
"departure_time" : "10:48:23" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "10:49:13" , 
"departure_time" : "10:49:45" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "10:51:32" , 
"departure_time" : "10:53:00" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "10:57:28" , 
"departure_time" : "10:57:40" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "11:00:12" , 
"departure_time" : "11:01:50" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "11:09:38" , 
"departure_time" : "11:09:47" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "11:15:09" , 
"departure_time" : "11:15:49" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "11:19:40" , 
"departure_time" : "11:20:35" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "11:24:55" , 
"departure_time" : "11:25:46" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "11:28:51" , 
"departure_time" : "11:29:21" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "11:33:30" , 
"departure_time" : "11:34:26" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "11:40:56" , 
"departure_time" : "11:42:32" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "11:43:36" , 
"departure_time" : "11:45:09" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "11:57:33" , 
"departure_time" : "11:57:33" , 
"distance_traveled" : 43.1008
} ], 
"2064" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "23:11:00" , 
"departure_time" : "23:13:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:21:01" , 
"departure_time" : "23:22:28" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "23:31:27" , 
"departure_time" : "23:31:55" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "23:36:28" , 
"departure_time" : "23:37:21" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "23:39:53" , 
"departure_time" : "23:41:30" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "23:43:37" , 
"departure_time" : "23:44:25" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "23:44:48" , 
"departure_time" : "23:45:41" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 140,
"arrival_time" : "23:48:53" , 
"departure_time" : "23:49:42" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "23:51:49" , 
"departure_time" : "23:52:14" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "23:56:25" , 
"departure_time" : "23:57:30" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "24:01:05" , 
"departure_time" : "24:02:12" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "24:09:07" , 
"departure_time" : "24:09:27" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "24:15:20" , 
"departure_time" : "24:15:40" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "24:19:20" , 
"departure_time" : "24:20:35" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "24:25:15" , 
"departure_time" : "24:26:17" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "24:29:02" , 
"departure_time" : "24:29:52" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "24:33:50" , 
"departure_time" : "24:34:40" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "24:40:50" , 
"departure_time" : "24:40:52" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "24:54:02" , 
"departure_time" : "24:54:02" , 
"distance_traveled" : 43.1006
} ], 
"2065" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:11:00" , 
"departure_time" : "16:11:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:20:13" , 
"departure_time" : "16:21:33" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:31:20" , 
"departure_time" : "16:31:30" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "16:36:10" , 
"departure_time" : "16:36:59" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "16:39:49" , 
"departure_time" : "16:40:14" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "16:42:25" , 
"departure_time" : "16:42:31" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 97,
"arrival_time" : "16:46:06" , 
"departure_time" : "16:47:15" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "16:49:09" , 
"departure_time" : "16:49:13" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "16:51:04" , 
"departure_time" : "16:51:18" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "16:56:14" , 
"departure_time" : "16:57:38" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "17:01:24" , 
"departure_time" : "17:02:22" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:08:58" , 
"departure_time" : "17:09:47" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "17:15:49" , 
"departure_time" : "17:17:22" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "17:20:33" , 
"departure_time" : "17:21:57" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "17:25:24" , 
"departure_time" : "17:26:00" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "17:28:36" , 
"departure_time" : "17:29:51" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "17:34:15" , 
"departure_time" : "17:34:39" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "17:40:24" , 
"departure_time" : "17:40:51" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "17:42:27" , 
"departure_time" : "17:42:49" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "17:56:22" , 
"departure_time" : "17:56:22" , 
"distance_traveled" : 43.1008
} ], 
"2066" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "08:11:00" , 
"departure_time" : "08:11:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:20:25" , 
"departure_time" : "08:21:13" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:30:48" , 
"departure_time" : "08:31:02" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "08:36:14" , 
"departure_time" : "08:36:15" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "08:39:01" , 
"departure_time" : "08:40:24" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "08:43:23" , 
"departure_time" : "08:44:31" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 97,
"arrival_time" : "08:47:08" , 
"departure_time" : "08:48:12" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:49:04" , 
"departure_time" : "08:50:01" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "08:51:57" , 
"departure_time" : "08:52:22" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "08:56:25" , 
"departure_time" : "08:57:28" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "09:01:03" , 
"departure_time" : "09:02:14" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "09:09:11" , 
"departure_time" : "09:09:13" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "09:15:02" , 
"departure_time" : "09:15:21" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "09:19:19" , 
"departure_time" : "09:19:52" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "09:24:33" , 
"departure_time" : "09:25:23" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "09:28:50" , 
"departure_time" : "09:30:03" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "09:34:13" , 
"departure_time" : "09:34:23" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "09:40:10" , 
"departure_time" : "09:41:03" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "09:54:53" , 
"departure_time" : "09:54:53" , 
"distance_traveled" : 43.1006
} ], 
"2067" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:11:00" , 
"departure_time" : "18:13:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:21:19" , 
"departure_time" : "18:21:57" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:30:38" , 
"departure_time" : "18:32:02" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "18:37:24" , 
"departure_time" : "18:39:04" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "18:40:40" , 
"departure_time" : "18:40:53" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "18:42:13" , 
"departure_time" : "18:43:11" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 97,
"arrival_time" : "18:46:58" , 
"departure_time" : "18:48:38" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:49:40" , 
"departure_time" : "18:50:56" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:52:16" , 
"departure_time" : "18:53:45" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:57:29" , 
"departure_time" : "18:58:53" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "19:01:24" , 
"departure_time" : "19:02:44" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "19:09:20" , 
"departure_time" : "19:09:58" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "19:15:38" , 
"departure_time" : "19:16:16" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "19:19:38" , 
"departure_time" : "19:20:53" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "19:25:15" , 
"departure_time" : "19:25:29" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "19:28:14" , 
"departure_time" : "19:28:58" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "19:33:44" , 
"departure_time" : "19:34:00" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "19:40:16" , 
"departure_time" : "19:40:49" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "19:42:33" , 
"departure_time" : "19:42:43" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "19:56:10" , 
"departure_time" : "19:56:10" , 
"distance_traveled" : 43.1008
} ], 
"2068" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "12:11:00" , 
"departure_time" : "12:11:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:20:12" , 
"departure_time" : "12:21:48" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "12:31:36" , 
"departure_time" : "12:31:55" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "12:36:19" , 
"departure_time" : "12:37:23" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "12:40:04" , 
"departure_time" : "12:41:43" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "12:43:39" , 
"departure_time" : "12:44:48" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 97,
"arrival_time" : "12:47:09" , 
"departure_time" : "12:47:44" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "12:48:35" , 
"departure_time" : "12:49:11" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "12:51:36" , 
"departure_time" : "12:51:53" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "12:56:17" , 
"departure_time" : "12:57:16" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "13:00:59" , 
"departure_time" : "13:01:55" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "13:08:56" , 
"departure_time" : "13:10:15" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "13:16:19" , 
"departure_time" : "13:16:36" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "13:19:17" , 
"departure_time" : "13:20:13" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "13:24:56" , 
"departure_time" : "13:26:33" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "13:29:37" , 
"departure_time" : "13:31:12" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "13:34:35" , 
"departure_time" : "13:36:12" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "13:41:37" , 
"departure_time" : "13:42:06" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "13:54:29" , 
"departure_time" : "13:54:29" , 
"distance_traveled" : 43.1006
} ], 
"2069" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "22:11:00" , 
"departure_time" : "22:12:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:20:34" , 
"departure_time" : "22:21:21" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "22:30:47" , 
"departure_time" : "22:31:22" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "22:36:35" , 
"departure_time" : "22:36:40" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "22:39:05" , 
"departure_time" : "22:39:13" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "22:42:08" , 
"departure_time" : "22:43:46" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 97,
"arrival_time" : "22:47:38" , 
"departure_time" : "22:49:14" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "22:49:36" , 
"departure_time" : "22:50:19" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "22:51:43" , 
"departure_time" : "22:52:53" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "22:57:10" , 
"departure_time" : "22:57:18" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "23:00:08" , 
"departure_time" : "23:00:16" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "23:08:08" , 
"departure_time" : "23:08:30" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "23:15:22" , 
"departure_time" : "23:15:27" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "23:19:05" , 
"departure_time" : "23:19:10" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "23:24:05" , 
"departure_time" : "23:24:47" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "23:28:42" , 
"departure_time" : "23:30:00" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "23:34:18" , 
"departure_time" : "23:35:26" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "23:41:08" , 
"departure_time" : "23:41:29" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "23:42:21" , 
"departure_time" : "23:43:44" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "23:57:23" , 
"departure_time" : "23:57:23" , 
"distance_traveled" : 43.1008
} ], 
"2070" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "14:11:00" , 
"departure_time" : "14:12:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:20:19" , 
"departure_time" : "14:21:17" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "14:30:58" , 
"departure_time" : "14:32:32" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "14:37:34" , 
"departure_time" : "14:37:36" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "14:39:02" , 
"departure_time" : "14:40:18" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "14:43:16" , 
"departure_time" : "14:43:20" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 97,
"arrival_time" : "14:46:04" , 
"departure_time" : "14:47:39" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "14:49:35" , 
"departure_time" : "14:50:58" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "14:52:23" , 
"departure_time" : "14:52:32" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "14:56:09" , 
"departure_time" : "14:57:30" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "15:01:21" , 
"departure_time" : "15:02:55" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "15:09:34" , 
"departure_time" : "15:10:05" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "15:15:31" , 
"departure_time" : "15:16:25" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "15:19:54" , 
"departure_time" : "15:21:22" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "15:25:28" , 
"departure_time" : "15:26:28" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "15:29:00" , 
"departure_time" : "15:29:42" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "15:33:42" , 
"departure_time" : "15:34:39" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "15:40:57" , 
"departure_time" : "15:42:11" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "15:55:14" , 
"departure_time" : "15:55:14" , 
"distance_traveled" : 43.1006
} ], 
"2071" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:42:00" , 
"departure_time" : "17:43:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:58:19" , 
"departure_time" : "17:58:53" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "18:03:34" , 
"departure_time" : "18:04:55" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "18:07:21" , 
"departure_time" : "18:08:23" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "18:10:02" , 
"departure_time" : "18:11:25" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "18:12:23" , 
"departure_time" : "18:13:21" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "18:13:58" , 
"departure_time" : "18:15:04" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:17:06" , 
"departure_time" : "18:18:30" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:20:24" , 
"departure_time" : "18:21:08" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:27:44" , 
"departure_time" : "18:27:44" , 
"distance_traveled" : 20.0943
} ], 
"2072" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:11:00" , 
"departure_time" : "20:11:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:20:13" , 
"departure_time" : "20:21:39" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "20:31:26" , 
"departure_time" : "20:31:46" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "20:36:20" , 
"departure_time" : "20:37:57" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "20:40:37" , 
"departure_time" : "20:41:38" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "20:43:01" , 
"departure_time" : "20:44:03" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 97,
"arrival_time" : "20:47:02" , 
"departure_time" : "20:47:07" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "20:48:05" , 
"departure_time" : "20:49:41" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "20:52:36" , 
"departure_time" : "20:53:19" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "20:56:43" , 
"departure_time" : "20:57:32" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "21:00:49" , 
"departure_time" : "21:01:49" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "21:09:00" , 
"departure_time" : "21:09:18" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "21:15:18" , 
"departure_time" : "21:15:37" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "21:19:19" , 
"departure_time" : "21:20:45" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "21:25:26" , 
"departure_time" : "21:26:56" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "21:29:30" , 
"departure_time" : "21:30:08" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "21:33:38" , 
"departure_time" : "21:33:51" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "21:40:13" , 
"departure_time" : "21:40:25" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "21:54:12" , 
"departure_time" : "21:54:12" , 
"distance_traveled" : 43.1006
} ], 
"2073" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "06:41:00" , 
"departure_time" : "06:41:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:50:08" , 
"departure_time" : "06:50:58" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:01:50" , 
"departure_time" : "07:03:29" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "07:08:39" , 
"departure_time" : "07:09:07" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "07:10:28" , 
"departure_time" : "07:11:41" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:16:13" , 
"departure_time" : "07:16:44" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:18:31" , 
"departure_time" : "07:19:04" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:21:33" , 
"departure_time" : "07:21:51" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:25:18" , 
"departure_time" : "07:26:58" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:32:40" , 
"departure_time" : "07:32:40" , 
"distance_traveled" : 22.7284
} ], 
"2074" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "07:11:00" , 
"departure_time" : "07:12:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:20:18" , 
"departure_time" : "07:20:34" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:30:16" , 
"departure_time" : "07:31:23" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "07:37:07" , 
"departure_time" : "07:38:43" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "07:40:36" , 
"departure_time" : "07:41:07" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "07:42:31" , 
"departure_time" : "07:44:10" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "07:45:39" , 
"departure_time" : "07:47:19" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:49:40" , 
"departure_time" : "07:50:03" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:51:23" , 
"departure_time" : "07:52:17" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:56:54" , 
"departure_time" : "07:58:31" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "08:01:37" , 
"departure_time" : "08:02:35" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "08:08:58" , 
"departure_time" : "08:09:47" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "08:15:49" , 
"departure_time" : "08:17:05" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "08:20:16" , 
"departure_time" : "08:21:28" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "08:25:12" , 
"departure_time" : "08:26:42" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "08:29:30" , 
"departure_time" : "08:31:06" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "08:34:36" , 
"departure_time" : "08:35:54" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "08:41:18" , 
"departure_time" : "08:42:32" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "08:43:14" , 
"departure_time" : "08:43:54" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "08:56:40" , 
"departure_time" : "08:56:40" , 
"distance_traveled" : 43.1008
} ], 
"2075" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "08:24:00" , 
"departure_time" : "08:26:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:34:29" , 
"departure_time" : "08:35:48" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:44:19" , 
"departure_time" : "08:44:50" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "08:49:31" , 
"departure_time" : "08:50:08" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "08:52:37" , 
"departure_time" : "08:53:46" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:58:09" , 
"departure_time" : "08:58:58" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "09:01:49" , 
"departure_time" : "09:02:41" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "09:05:52" , 
"departure_time" : "09:06:54" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "09:10:02" , 
"departure_time" : "09:10:32" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "09:15:30" , 
"departure_time" : "09:15:30" , 
"distance_traveled" : 22.7284
} ], 
"2076" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "13:11:00" , 
"departure_time" : "13:13:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:21:39" , 
"departure_time" : "13:22:08" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "13:30:29" , 
"departure_time" : "13:31:08" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "13:36:39" , 
"departure_time" : "13:37:27" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "13:39:48" , 
"departure_time" : "13:41:17" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "13:43:29" , 
"departure_time" : "13:43:53" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "13:44:24" , 
"departure_time" : "13:44:28" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 140,
"arrival_time" : "13:48:04" , 
"departure_time" : "13:48:54" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "13:51:50" , 
"departure_time" : "13:52:19" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "13:56:29" , 
"departure_time" : "13:56:31" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "14:00:02" , 
"departure_time" : "14:00:23" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "14:08:21" , 
"departure_time" : "14:08:56" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "14:15:35" , 
"departure_time" : "14:15:56" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "14:19:21" , 
"departure_time" : "14:20:50" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "14:25:29" , 
"departure_time" : "14:25:50" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "14:28:21" , 
"departure_time" : "14:28:48" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "14:33:27" , 
"departure_time" : "14:33:44" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "14:40:17" , 
"departure_time" : "14:41:42" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "14:43:25" , 
"departure_time" : "14:43:30" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "14:56:05" , 
"departure_time" : "14:56:05" , 
"distance_traveled" : 43.1008
} ], 
"2077" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "09:22:00" , 
"departure_time" : "09:23:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:32:35" , 
"departure_time" : "09:33:17" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:40:42" , 
"departure_time" : "09:41:09" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "09:45:27" , 
"departure_time" : "09:46:22" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "09:48:55" , 
"departure_time" : "09:49:26" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 140,
"arrival_time" : "09:53:31" , 
"departure_time" : "09:53:59" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "09:56:28" , 
"departure_time" : "09:58:05" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "10:00:37" , 
"departure_time" : "10:00:48" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "10:02:11" , 
"departure_time" : "10:02:31" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "10:08:20" , 
"departure_time" : "10:08:20" , 
"distance_traveled" : 22.7284
} ], 
"2078" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:11:00" , 
"departure_time" : "17:11:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:20:14" , 
"departure_time" : "17:21:34" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:31:20" , 
"departure_time" : "17:31:41" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "17:36:21" , 
"departure_time" : "17:37:38" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:40:17" , 
"departure_time" : "17:41:31" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "17:43:14" , 
"departure_time" : "17:43:55" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "17:44:41" , 
"departure_time" : "17:45:40" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:48:59" , 
"departure_time" : "17:49:44" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "17:51:45" , 
"departure_time" : "17:52:08" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "17:56:23" , 
"departure_time" : "17:57:48" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "18:01:25" , 
"departure_time" : "18:02:01" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:08:36" , 
"departure_time" : "18:09:43" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "18:16:07" , 
"departure_time" : "18:16:30" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "18:19:23" , 
"departure_time" : "18:20:22" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "18:24:59" , 
"departure_time" : "18:25:03" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "18:28:04" , 
"departure_time" : "18:29:01" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "18:33:57" , 
"departure_time" : "18:34:00" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "18:40:03" , 
"departure_time" : "18:41:13" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "18:43:10" , 
"departure_time" : "18:43:34" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "18:56:24" , 
"departure_time" : "18:56:24" , 
"distance_traveled" : 43.1008
} ], 
"2079" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:07:00" , 
"departure_time" : "18:08:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:24:04" , 
"departure_time" : "18:24:47" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "18:28:43" , 
"departure_time" : "18:29:51" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "18:31:08" , 
"departure_time" : "18:31:29" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "18:33:21" , 
"departure_time" : "18:33:32" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "18:35:11" , 
"departure_time" : "18:36:05" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "18:38:54" , 
"departure_time" : "18:39:01" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:40:07" , 
"departure_time" : "18:41:32" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:44:25" , 
"departure_time" : "18:44:31" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:47:06" , 
"departure_time" : "18:47:26" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:54:20" , 
"departure_time" : "18:54:20" , 
"distance_traveled" : 20.0949
} ], 
"2080" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:11:00" , 
"departure_time" : "19:12:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:20:40" , 
"departure_time" : "19:21:55" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:31:15" , 
"departure_time" : "19:32:25" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "19:37:10" , 
"departure_time" : "19:37:45" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "19:39:35" , 
"departure_time" : "19:41:02" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "19:43:27" , 
"departure_time" : "19:43:36" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "19:44:09" , 
"departure_time" : "19:45:02" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 140,
"arrival_time" : "19:48:53" , 
"departure_time" : "19:49:11" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "19:51:18" , 
"departure_time" : "19:52:56" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "19:57:38" , 
"departure_time" : "19:58:51" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "20:01:13" , 
"departure_time" : "20:02:16" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "20:09:03" , 
"departure_time" : "20:10:00" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "20:15:57" , 
"departure_time" : "20:17:01" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "20:20:04" , 
"departure_time" : "20:20:07" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "20:24:03" , 
"departure_time" : "20:25:31" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "20:29:28" , 
"departure_time" : "20:30:26" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "20:33:58" , 
"departure_time" : "20:35:08" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "20:41:10" , 
"departure_time" : "20:41:59" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "20:42:49" , 
"departure_time" : "20:43:43" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "20:56:54" , 
"departure_time" : "20:56:54" , 
"distance_traveled" : 43.1008
} ], 
"2081" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:07:00" , 
"departure_time" : "16:08:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:24:18" , 
"departure_time" : "16:25:52" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 37,
"arrival_time" : "16:30:34" , 
"departure_time" : "16:31:52" , 
"distance_traveled" : 12.6701
}, 
{ 
"stop_id" : 23,
"arrival_time" : "16:33:18" , 
"departure_time" : "16:34:05" , 
"distance_traveled" : 13.1979
}, 
{ 
"stop_id" : 112,
"arrival_time" : "16:35:47" , 
"departure_time" : "16:36:11" , 
"distance_traveled" : 14.0973
}, 
{ 
"stop_id" : 61,
"arrival_time" : "16:37:24" , 
"departure_time" : "16:37:30" , 
"distance_traveled" : 14.8049
}, 
{ 
"stop_id" : 97,
"arrival_time" : "16:40:06" , 
"departure_time" : "16:41:45" , 
"distance_traveled" : 15.733
}, 
{ 
"stop_id" : 140,
"arrival_time" : "16:43:39" , 
"departure_time" : "16:45:00" , 
"distance_traveled" : 16.4955
}, 
{ 
"stop_id" : 81,
"arrival_time" : "16:46:21" , 
"departure_time" : "16:46:56" , 
"distance_traveled" : 17.7778
}, 
{ 
"stop_id" : 87,
"arrival_time" : "16:49:35" , 
"departure_time" : "16:51:01" , 
"distance_traveled" : 19.3866
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:57:26" , 
"departure_time" : "16:57:26" , 
"distance_traveled" : 22.7288
} ], 
"2082" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "10:11:00" , 
"departure_time" : "10:13:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:20:35" , 
"departure_time" : "10:22:05" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "10:31:30" , 
"departure_time" : "10:33:04" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "10:37:34" , 
"departure_time" : "10:38:23" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "10:39:49" , 
"departure_time" : "10:41:24" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "10:43:35" , 
"departure_time" : "10:43:43" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 97,
"arrival_time" : "10:46:08" , 
"departure_time" : "10:47:45" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "10:49:37" , 
"departure_time" : "10:50:46" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "10:52:09" , 
"departure_time" : "10:52:51" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "10:56:42" , 
"departure_time" : "10:57:36" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "11:00:54" , 
"departure_time" : "11:02:08" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "11:09:14" , 
"departure_time" : "11:10:23" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "11:16:09" , 
"departure_time" : "11:16:45" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "11:19:36" , 
"departure_time" : "11:19:48" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "11:24:12" , 
"departure_time" : "11:25:52" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "11:29:40" , 
"departure_time" : "11:31:19" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "11:34:39" , 
"departure_time" : "11:36:10" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "11:41:31" , 
"departure_time" : "11:41:58" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "11:42:27" , 
"departure_time" : "11:43:38" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "11:57:11" , 
"departure_time" : "11:57:11" , 
"distance_traveled" : 43.1008
} ], 
"2083" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:43:00" , 
"departure_time" : "16:45:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:02:23" , 
"departure_time" : "17:03:13" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 37,
"arrival_time" : "17:06:50" , 
"departure_time" : "17:06:58" , 
"distance_traveled" : 12.6701
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:09:08" , 
"departure_time" : "17:10:37" , 
"distance_traveled" : 13.1979
}, 
{ 
"stop_id" : 112,
"arrival_time" : "17:13:29" , 
"departure_time" : "17:14:53" , 
"distance_traveled" : 14.0973
}, 
{ 
"stop_id" : 61,
"arrival_time" : "17:15:24" , 
"departure_time" : "17:16:45" , 
"distance_traveled" : 14.8049
}, 
{ 
"stop_id" : 97,
"arrival_time" : "17:17:21" , 
"departure_time" : "17:18:12" , 
"distance_traveled" : 15.733
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:19:51" , 
"departure_time" : "17:21:13" , 
"distance_traveled" : 16.4955
}, 
{ 
"stop_id" : 81,
"arrival_time" : "17:23:22" , 
"departure_time" : "17:23:27" , 
"distance_traveled" : 17.7778
}, 
{ 
"stop_id" : 87,
"arrival_time" : "17:26:05" , 
"departure_time" : "17:26:57" , 
"distance_traveled" : 19.3866
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:32:52" , 
"departure_time" : "17:32:52" , 
"distance_traveled" : 22.7288
} ], 
"2084" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:11:00" , 
"departure_time" : "16:13:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:21:25" , 
"departure_time" : "16:22:54" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:31:29" , 
"departure_time" : "16:32:55" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "16:37:26" , 
"departure_time" : "16:38:19" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "16:39:53" , 
"departure_time" : "16:40:27" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "16:42:34" , 
"departure_time" : "16:43:11" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 97,
"arrival_time" : "16:46:37" , 
"departure_time" : "16:48:06" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "16:49:29" , 
"departure_time" : "16:50:36" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "16:52:07" , 
"departure_time" : "16:52:29" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "16:56:22" , 
"departure_time" : "16:58:01" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "17:01:39" , 
"departure_time" : "17:03:13" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:09:34" , 
"departure_time" : "17:10:50" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "17:16:16" , 
"departure_time" : "17:17:55" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "17:20:39" , 
"departure_time" : "17:21:43" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "17:25:04" , 
"departure_time" : "17:26:04" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "17:29:00" , 
"departure_time" : "17:29:32" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "17:33:32" , 
"departure_time" : "17:33:44" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "17:40:12" , 
"departure_time" : "17:41:12" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "17:43:00" , 
"departure_time" : "17:43:11" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "17:56:11" , 
"departure_time" : "17:56:11" , 
"distance_traveled" : 43.1008
} ], 
"2085" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:15:00" , 
"departure_time" : "16:15:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:33:20" , 
"departure_time" : "16:34:55" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 136,
"arrival_time" : "16:48:35" , 
"departure_time" : "16:49:12" , 
"distance_traveled" : 20.4612
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:52:37" , 
"departure_time" : "16:53:15" , 
"distance_traveled" : 22.7288
}, 
{ 
"stop_id" : 27,
"arrival_time" : "16:58:38" , 
"departure_time" : "16:59:58" , 
"distance_traveled" : 26.1551
}, 
{ 
"stop_id" : 77,
"arrival_time" : "17:03:20" , 
"departure_time" : "17:04:50" , 
"distance_traveled" : 28.1504
}, 
{ 
"stop_id" : 30,
"arrival_time" : "17:07:30" , 
"departure_time" : "17:08:25" , 
"distance_traveled" : 30.3157
}, 
{ 
"stop_id" : 92,
"arrival_time" : "17:10:55" , 
"departure_time" : "17:11:33" , 
"distance_traveled" : 32.4042
}, 
{ 
"stop_id" : 91,
"arrival_time" : "17:14:38" , 
"departure_time" : "17:16:13" , 
"distance_traveled" : 34.6347
}, 
{ 
"stop_id" : 34,
"arrival_time" : "17:23:35" , 
"departure_time" : "17:24:59" , 
"distance_traveled" : 38.9019
}, 
{ 
"stop_id" : 35,
"arrival_time" : "17:31:24" , 
"departure_time" : "17:31:24" , 
"distance_traveled" : 43.1009
} ], 
"2086" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:11:00" , 
"departure_time" : "18:13:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:20:49" , 
"departure_time" : "18:21:09" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:30:20" , 
"departure_time" : "18:31:21" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "18:37:01" , 
"departure_time" : "18:38:20" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "18:40:19" , 
"departure_time" : "18:41:40" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "18:43:21" , 
"departure_time" : "18:44:02" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 97,
"arrival_time" : "18:46:41" , 
"departure_time" : "18:48:10" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:49:29" , 
"departure_time" : "18:50:58" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:52:29" , 
"departure_time" : "18:52:47" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:56:18" , 
"departure_time" : "18:56:28" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "19:00:10" , 
"departure_time" : "19:00:49" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "19:08:39" , 
"departure_time" : "19:08:41" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "19:15:02" , 
"departure_time" : "19:16:00" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "19:19:58" , 
"departure_time" : "19:20:16" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "19:24:18" , 
"departure_time" : "19:25:31" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "19:29:13" , 
"departure_time" : "19:29:22" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "19:33:09" , 
"departure_time" : "19:33:47" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "19:40:38" , 
"departure_time" : "19:41:14" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "19:42:36" , 
"departure_time" : "19:43:44" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "19:57:08" , 
"departure_time" : "19:57:08" , 
"distance_traveled" : 43.1008
} ], 
"2087" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:56:00" , 
"departure_time" : "18:57:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:13:36" , 
"departure_time" : "19:14:53" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 136,
"arrival_time" : "19:30:17" , 
"departure_time" : "19:31:30" , 
"distance_traveled" : 20.4612
}, 
{ 
"stop_id" : 145,
"arrival_time" : "19:37:13" , 
"departure_time" : "19:37:46" , 
"distance_traveled" : 22.7288
}, 
{ 
"stop_id" : 27,
"arrival_time" : "19:43:33" , 
"departure_time" : "19:43:50" , 
"distance_traveled" : 26.1551
}, 
{ 
"stop_id" : 77,
"arrival_time" : "19:47:17" , 
"departure_time" : "19:48:46" , 
"distance_traveled" : 28.1504
}, 
{ 
"stop_id" : 30,
"arrival_time" : "19:54:29" , 
"departure_time" : "19:55:53" , 
"distance_traveled" : 30.3157
}, 
{ 
"stop_id" : 92,
"arrival_time" : "19:58:24" , 
"departure_time" : "19:59:49" , 
"distance_traveled" : 32.4042
}, 
{ 
"stop_id" : 91,
"arrival_time" : "20:03:25" , 
"departure_time" : "20:03:34" , 
"distance_traveled" : 34.6347
}, 
{ 
"stop_id" : 34,
"arrival_time" : "20:10:09" , 
"departure_time" : "20:11:35" , 
"distance_traveled" : 38.9019
}, 
{ 
"stop_id" : 35,
"arrival_time" : "20:20:26" , 
"departure_time" : "20:20:26" , 
"distance_traveled" : 43.1009
} ], 
"2088" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "22:11:00" , 
"departure_time" : "22:13:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:21:19" , 
"departure_time" : "22:21:33" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "22:30:14" , 
"departure_time" : "22:30:46" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "22:36:32" , 
"departure_time" : "22:37:17" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "22:39:45" , 
"departure_time" : "22:40:56" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "22:43:11" , 
"departure_time" : "22:43:37" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 97,
"arrival_time" : "22:46:26" , 
"departure_time" : "22:47:46" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "22:49:20" , 
"departure_time" : "22:49:21" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "22:51:01" , 
"departure_time" : "22:52:15" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "22:57:14" , 
"departure_time" : "22:57:54" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "23:00:40" , 
"departure_time" : "23:01:52" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "23:09:12" , 
"departure_time" : "23:10:02" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "23:15:50" , 
"departure_time" : "23:16:44" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "23:19:54" , 
"departure_time" : "23:20:53" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "23:24:59" , 
"departure_time" : "23:25:06" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "23:28:07" , 
"departure_time" : "23:28:27" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "23:33:20" , 
"departure_time" : "23:33:22" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "23:40:02" , 
"departure_time" : "23:40:41" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "23:42:39" , 
"departure_time" : "23:44:12" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "23:57:33" , 
"departure_time" : "23:57:33" , 
"distance_traveled" : 43.1008
} ], 
"2089" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "04:43:00" , 
"departure_time" : "04:46:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "05:02:29" , 
"departure_time" : "05:03:20" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "05:06:51" , 
"departure_time" : "05:07:43" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "05:08:52" , 
"departure_time" : "05:09:09" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "05:11:17" , 
"departure_time" : "05:11:38" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "05:13:21" , 
"departure_time" : "05:14:42" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "05:16:21" , 
"departure_time" : "05:17:38" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "05:18:17" , 
"departure_time" : "05:19:06" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "05:20:49" , 
"departure_time" : "05:22:00" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "05:25:11" , 
"departure_time" : "05:25:42" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "05:27:31" , 
"departure_time" : "05:28:44" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "05:32:13" , 
"departure_time" : "05:32:13" , 
"distance_traveled" : 20.0947
} ], 
"2090" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:20:00" , 
"departure_time" : "18:21:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:30:01" , 
"departure_time" : "18:31:13" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:42:12" , 
"departure_time" : "18:43:49" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 145,
"arrival_time" : "19:02:37" , 
"departure_time" : "19:02:52" , 
"distance_traveled" : 22.7286
}, 
{ 
"stop_id" : 27,
"arrival_time" : "19:08:15" , 
"departure_time" : "19:09:12" , 
"distance_traveled" : 26.1549
}, 
{ 
"stop_id" : 77,
"arrival_time" : "19:12:57" , 
"departure_time" : "19:13:33" , 
"distance_traveled" : 28.1502
}, 
{ 
"stop_id" : 30,
"arrival_time" : "19:17:36" , 
"departure_time" : "19:18:14" , 
"distance_traveled" : 30.3155
}, 
{ 
"stop_id" : 92,
"arrival_time" : "19:21:38" , 
"departure_time" : "19:22:37" , 
"distance_traveled" : 32.404
}, 
{ 
"stop_id" : 91,
"arrival_time" : "19:26:59" , 
"departure_time" : "19:27:36" , 
"distance_traveled" : 34.6345
}, 
{ 
"stop_id" : 34,
"arrival_time" : "19:34:37" , 
"departure_time" : "19:35:10" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "19:43:33" , 
"departure_time" : "19:43:33" , 
"distance_traveled" : 43.1008
} ], 
"2091" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "07:33:00" , 
"departure_time" : "07:35:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:52:40" , 
"departure_time" : "07:52:49" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "07:57:09" , 
"departure_time" : "07:58:34" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "08:00:25" , 
"departure_time" : "08:00:57" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "08:02:32" , 
"departure_time" : "08:03:55" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "08:05:23" , 
"departure_time" : "08:05:30" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "08:06:07" , 
"departure_time" : "08:06:43" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:09:36" , 
"departure_time" : "08:09:56" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "08:12:20" , 
"departure_time" : "08:13:05" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "08:16:45" , 
"departure_time" : "08:18:19" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "08:19:34" , 
"departure_time" : "08:20:17" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "08:22:43" , 
"departure_time" : "08:22:43" , 
"distance_traveled" : 20.0947
} ], 
"2092" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:42:00" , 
"departure_time" : "17:43:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:58:54" , 
"departure_time" : "18:00:33" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "18:04:39" , 
"departure_time" : "18:05:30" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "18:06:51" , 
"departure_time" : "18:07:05" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "18:09:14" , 
"departure_time" : "18:09:50" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "18:11:36" , 
"departure_time" : "18:12:07" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "18:13:31" , 
"departure_time" : "18:14:53" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:17:22" , 
"departure_time" : "18:18:11" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:19:49" , 
"departure_time" : "18:21:22" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:28:33" , 
"departure_time" : "18:28:33" , 
"distance_traveled" : 20.0943
} ], 
"2093" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:52:00" , 
"departure_time" : "17:53:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 23,
"arrival_time" : "18:14:19" , 
"departure_time" : "18:15:02" , 
"distance_traveled" : 13.1746
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:21:43" , 
"departure_time" : "18:23:09" , 
"distance_traveled" : 16.4723
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:34:26" , 
"departure_time" : "18:34:30" , 
"distance_traveled" : 22.7057
}, 
{ 
"stop_id" : 27,
"arrival_time" : "18:40:04" , 
"departure_time" : "18:40:39" , 
"distance_traveled" : 26.132
}, 
{ 
"stop_id" : 77,
"arrival_time" : "18:45:35" , 
"departure_time" : "18:46:12" , 
"distance_traveled" : 28.1273
}, 
{ 
"stop_id" : 30,
"arrival_time" : "18:50:37" , 
"departure_time" : "18:52:02" , 
"distance_traveled" : 30.2926
}, 
{ 
"stop_id" : 92,
"arrival_time" : "18:55:25" , 
"departure_time" : "18:56:13" , 
"distance_traveled" : 32.3811
}, 
{ 
"stop_id" : 91,
"arrival_time" : "18:58:48" , 
"departure_time" : "18:58:56" , 
"distance_traveled" : 34.6116
}, 
{ 
"stop_id" : 34,
"arrival_time" : "19:06:08" , 
"departure_time" : "19:06:20" , 
"distance_traveled" : 38.8788
}, 
{ 
"stop_id" : 35,
"arrival_time" : "19:15:12" , 
"departure_time" : "19:15:12" , 
"distance_traveled" : 43.0778
} ], 
"2094" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "06:41:00" , 
"departure_time" : "06:41:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:50:43" , 
"departure_time" : "06:51:47" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:02:04" , 
"departure_time" : "07:02:47" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "07:07:43" , 
"departure_time" : "07:08:28" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "07:10:45" , 
"departure_time" : "07:11:12" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:15:27" , 
"departure_time" : "07:16:59" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:19:32" , 
"departure_time" : "07:20:22" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:21:50" , 
"departure_time" : "07:22:41" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:25:51" , 
"departure_time" : "07:26:45" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:31:54" , 
"departure_time" : "07:31:54" , 
"distance_traveled" : 22.7284
} ], 
"2095" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:26:00" , 
"departure_time" : "15:28:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:44:06" , 
"departure_time" : "15:44:56" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 136,
"arrival_time" : "15:57:50" , 
"departure_time" : "15:59:28" , 
"distance_traveled" : 20.4612
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:03:38" , 
"departure_time" : "16:04:40" , 
"distance_traveled" : 22.7288
}, 
{ 
"stop_id" : 27,
"arrival_time" : "16:09:02" , 
"departure_time" : "16:10:27" , 
"distance_traveled" : 26.1551
}, 
{ 
"stop_id" : 77,
"arrival_time" : "16:13:25" , 
"departure_time" : "16:14:33" , 
"distance_traveled" : 28.1504
}, 
{ 
"stop_id" : 30,
"arrival_time" : "16:17:08" , 
"departure_time" : "16:17:59" , 
"distance_traveled" : 30.3157
}, 
{ 
"stop_id" : 92,
"arrival_time" : "16:20:51" , 
"departure_time" : "16:21:37" , 
"distance_traveled" : 32.4042
}, 
{ 
"stop_id" : 91,
"arrival_time" : "16:24:46" , 
"departure_time" : "16:25:39" , 
"distance_traveled" : 34.6347
}, 
{ 
"stop_id" : 34,
"arrival_time" : "16:32:53" , 
"departure_time" : "16:32:56" , 
"distance_traveled" : 38.9019
}, 
{ 
"stop_id" : 35,
"arrival_time" : "16:39:03" , 
"departure_time" : "16:39:03" , 
"distance_traveled" : 43.1009
} ], 
"2096" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "08:24:00" , 
"departure_time" : "08:25:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:34:00" , 
"departure_time" : "08:34:55" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:43:55" , 
"departure_time" : "08:45:22" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "08:50:27" , 
"departure_time" : "08:50:47" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "08:52:20" , 
"departure_time" : "08:54:00" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:58:40" , 
"departure_time" : "08:59:34" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "09:01:54" , 
"departure_time" : "09:01:57" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "09:05:03" , 
"departure_time" : "09:05:09" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "09:09:06" , 
"departure_time" : "09:10:44" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "09:16:38" , 
"departure_time" : "09:16:38" , 
"distance_traveled" : 22.7284
} ], 
"2097" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:26:00" , 
"departure_time" : "19:28:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:43:56" , 
"departure_time" : "19:44:53" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 136,
"arrival_time" : "19:57:57" , 
"departure_time" : "19:58:55" , 
"distance_traveled" : 20.4612
}, 
{ 
"stop_id" : 145,
"arrival_time" : "20:02:58" , 
"departure_time" : "20:03:07" , 
"distance_traveled" : 22.7288
}, 
{ 
"stop_id" : 27,
"arrival_time" : "20:08:09" , 
"departure_time" : "20:08:30" , 
"distance_traveled" : 26.1551
}, 
{ 
"stop_id" : 77,
"arrival_time" : "20:12:21" , 
"departure_time" : "20:13:45" , 
"distance_traveled" : 28.1504
}, 
{ 
"stop_id" : 30,
"arrival_time" : "20:17:24" , 
"departure_time" : "20:17:45" , 
"distance_traveled" : 30.3157
}, 
{ 
"stop_id" : 92,
"arrival_time" : "20:20:21" , 
"departure_time" : "20:21:10" , 
"distance_traveled" : 32.4042
}, 
{ 
"stop_id" : 91,
"arrival_time" : "20:25:49" , 
"departure_time" : "20:26:42" , 
"distance_traveled" : 34.6347
}, 
{ 
"stop_id" : 94,
"arrival_time" : "20:32:53" , 
"departure_time" : "20:33:04" , 
"distance_traveled" : 38.3258
}, 
{ 
"stop_id" : 34,
"arrival_time" : "20:35:11" , 
"departure_time" : "20:36:45" , 
"distance_traveled" : 38.9021
}, 
{ 
"stop_id" : 35,
"arrival_time" : "20:45:34" , 
"departure_time" : "20:45:34" , 
"distance_traveled" : 43.1011
} ], 
"2098" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "09:22:00" , 
"departure_time" : "09:24:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:31:30" , 
"departure_time" : "09:31:44" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:40:14" , 
"departure_time" : "09:41:38" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "09:46:24" , 
"departure_time" : "09:47:54" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "09:49:30" , 
"departure_time" : "09:49:47" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 140,
"arrival_time" : "09:53:17" , 
"departure_time" : "09:54:08" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "09:56:51" , 
"departure_time" : "09:57:13" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "09:59:22" , 
"departure_time" : "09:59:55" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "10:02:33" , 
"departure_time" : "10:02:57" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "10:08:24" , 
"departure_time" : "10:08:24" , 
"distance_traveled" : 22.7284
} ], 
"2099" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:45:00" , 
"departure_time" : "16:45:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:54:33" , 
"departure_time" : "16:55:13" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:06:40" , 
"departure_time" : "17:06:48" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 136,
"arrival_time" : "17:22:08" , 
"departure_time" : "17:22:38" , 
"distance_traveled" : 20.461
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:27:30" , 
"departure_time" : "17:28:31" , 
"distance_traveled" : 22.7286
}, 
{ 
"stop_id" : 27,
"arrival_time" : "17:34:01" , 
"departure_time" : "17:34:16" , 
"distance_traveled" : 26.1549
}, 
{ 
"stop_id" : 77,
"arrival_time" : "17:37:15" , 
"departure_time" : "17:38:52" , 
"distance_traveled" : 28.1502
}, 
{ 
"stop_id" : 30,
"arrival_time" : "17:43:37" , 
"departure_time" : "17:44:01" , 
"distance_traveled" : 30.3155
}, 
{ 
"stop_id" : 92,
"arrival_time" : "17:46:24" , 
"departure_time" : "17:47:29" , 
"distance_traveled" : 32.404
}, 
{ 
"stop_id" : 91,
"arrival_time" : "17:52:05" , 
"departure_time" : "17:52:12" , 
"distance_traveled" : 34.6345
}, 
{ 
"stop_id" : 34,
"arrival_time" : "17:59:07" , 
"departure_time" : "18:00:34" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "18:07:27" , 
"departure_time" : "18:07:27" , 
"distance_traveled" : 43.1008
} ], 
"2100" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:07:00" , 
"departure_time" : "18:09:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:23:52" , 
"departure_time" : "18:24:38" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "18:28:46" , 
"departure_time" : "18:29:17" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "18:30:31" , 
"departure_time" : "18:31:29" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "18:33:58" , 
"departure_time" : "18:34:07" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "18:35:09" , 
"departure_time" : "18:36:37" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "18:39:28" , 
"departure_time" : "18:39:54" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:40:26" , 
"departure_time" : "18:42:03" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:44:37" , 
"departure_time" : "18:46:12" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:48:35" , 
"departure_time" : "18:48:41" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:54:06" , 
"departure_time" : "18:54:06" , 
"distance_traveled" : 20.0949
} ], 
"2101" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:20:00" , 
"departure_time" : "18:21:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:31:21" , 
"departure_time" : "18:32:57" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:42:36" , 
"departure_time" : "18:44:09" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 145,
"arrival_time" : "19:02:33" , 
"departure_time" : "19:03:05" , 
"distance_traveled" : 22.7286
}, 
{ 
"stop_id" : 27,
"arrival_time" : "19:08:32" , 
"departure_time" : "19:09:14" , 
"distance_traveled" : 26.1549
}, 
{ 
"stop_id" : 77,
"arrival_time" : "19:12:42" , 
"departure_time" : "19:12:47" , 
"distance_traveled" : 28.1502
}, 
{ 
"stop_id" : 30,
"arrival_time" : "19:17:05" , 
"departure_time" : "19:18:04" , 
"distance_traveled" : 30.3155
}, 
{ 
"stop_id" : 92,
"arrival_time" : "19:21:59" , 
"departure_time" : "19:23:33" , 
"distance_traveled" : 32.404
}, 
{ 
"stop_id" : 91,
"arrival_time" : "19:27:34" , 
"departure_time" : "19:28:26" , 
"distance_traveled" : 34.6345
}, 
{ 
"stop_id" : 34,
"arrival_time" : "19:34:52" , 
"departure_time" : "19:35:53" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "19:44:01" , 
"departure_time" : "19:44:01" , 
"distance_traveled" : 43.1008
} ], 
"2102" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:07:00" , 
"departure_time" : "16:08:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:24:26" , 
"departure_time" : "16:25:45" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 37,
"arrival_time" : "16:30:19" , 
"departure_time" : "16:31:19" , 
"distance_traveled" : 12.6701
}, 
{ 
"stop_id" : 23,
"arrival_time" : "16:33:00" , 
"departure_time" : "16:34:31" , 
"distance_traveled" : 13.1979
}, 
{ 
"stop_id" : 112,
"arrival_time" : "16:36:31" , 
"departure_time" : "16:38:10" , 
"distance_traveled" : 14.0973
}, 
{ 
"stop_id" : 61,
"arrival_time" : "16:38:39" , 
"departure_time" : "16:39:19" , 
"distance_traveled" : 14.8049
}, 
{ 
"stop_id" : 97,
"arrival_time" : "16:40:40" , 
"departure_time" : "16:41:18" , 
"distance_traveled" : 15.733
}, 
{ 
"stop_id" : 140,
"arrival_time" : "16:42:38" , 
"departure_time" : "16:43:43" , 
"distance_traveled" : 16.4955
}, 
{ 
"stop_id" : 81,
"arrival_time" : "16:46:05" , 
"departure_time" : "16:47:15" , 
"distance_traveled" : 17.7778
}, 
{ 
"stop_id" : 87,
"arrival_time" : "16:50:10" , 
"departure_time" : "16:51:46" , 
"distance_traveled" : 19.3866
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:57:36" , 
"departure_time" : "16:57:36" , 
"distance_traveled" : 22.7288
} ], 
"2103" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:14:00" , 
"departure_time" : "17:16:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:32:18" , 
"departure_time" : "17:33:46" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 81,
"arrival_time" : "17:45:28" , 
"departure_time" : "17:45:54" , 
"distance_traveled" : 17.7778
}, 
{ 
"stop_id" : 87,
"arrival_time" : "17:48:26" , 
"departure_time" : "17:49:11" , 
"distance_traveled" : 19.3866
}, 
{ 
"stop_id" : 136,
"arrival_time" : "17:52:45" , 
"departure_time" : "17:53:59" , 
"distance_traveled" : 20.461
}, 
{ 
"stop_id" : 27,
"arrival_time" : "18:04:14" , 
"departure_time" : "18:05:11" , 
"distance_traveled" : 26.1532
}, 
{ 
"stop_id" : 77,
"arrival_time" : "18:07:57" , 
"departure_time" : "18:08:02" , 
"distance_traveled" : 28.1485
}, 
{ 
"stop_id" : 30,
"arrival_time" : "18:12:05" , 
"departure_time" : "18:12:27" , 
"distance_traveled" : 30.3138
}, 
{ 
"stop_id" : 92,
"arrival_time" : "18:16:22" , 
"departure_time" : "18:17:09" , 
"distance_traveled" : 32.4023
}, 
{ 
"stop_id" : 91,
"arrival_time" : "18:21:47" , 
"departure_time" : "18:23:22" , 
"distance_traveled" : 34.6328
}, 
{ 
"stop_id" : 34,
"arrival_time" : "18:30:35" , 
"departure_time" : "18:32:12" , 
"distance_traveled" : 38.9
}, 
{ 
"stop_id" : 35,
"arrival_time" : "18:37:37" , 
"departure_time" : "18:37:37" , 
"distance_traveled" : 43.0991
} ], 
"2104" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:43:00" , 
"departure_time" : "16:46:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:02:32" , 
"departure_time" : "17:02:52" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 37,
"arrival_time" : "17:06:20" , 
"departure_time" : "17:07:06" , 
"distance_traveled" : 12.6701
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:09:46" , 
"departure_time" : "17:11:26" , 
"distance_traveled" : 13.1979
}, 
{ 
"stop_id" : 112,
"arrival_time" : "17:13:40" , 
"departure_time" : "17:14:01" , 
"distance_traveled" : 14.0973
}, 
{ 
"stop_id" : 61,
"arrival_time" : "17:14:21" , 
"departure_time" : "17:15:48" , 
"distance_traveled" : 14.8049
}, 
{ 
"stop_id" : 97,
"arrival_time" : "17:17:27" , 
"departure_time" : "17:17:55" , 
"distance_traveled" : 15.733
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:19:28" , 
"departure_time" : "17:19:43" , 
"distance_traveled" : 16.4955
}, 
{ 
"stop_id" : 81,
"arrival_time" : "17:22:15" , 
"departure_time" : "17:22:16" , 
"distance_traveled" : 17.7778
}, 
{ 
"stop_id" : 87,
"arrival_time" : "17:26:01" , 
"departure_time" : "17:27:11" , 
"distance_traveled" : 19.3866
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:33:10" , 
"departure_time" : "17:33:10" , 
"distance_traveled" : 22.7288
} ], 
"2105" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "08:38:00" , 
"departure_time" : "08:40:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:48:32" , 
"departure_time" : "08:48:54" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:57:22" , 
"departure_time" : "08:58:56" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 140,
"arrival_time" : "09:08:34" , 
"departure_time" : "09:08:56" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "09:10:22" , 
"departure_time" : "09:10:26" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "09:14:04" , 
"departure_time" : "09:15:08" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 145,
"arrival_time" : "09:24:04" , 
"departure_time" : "09:25:13" , 
"distance_traveled" : 22.7286
}, 
{ 
"stop_id" : 27,
"arrival_time" : "09:30:09" , 
"departure_time" : "09:30:56" , 
"distance_traveled" : 26.1549
}, 
{ 
"stop_id" : 77,
"arrival_time" : "09:33:47" , 
"departure_time" : "09:34:52" , 
"distance_traveled" : 28.1502
}, 
{ 
"stop_id" : 30,
"arrival_time" : "09:39:05" , 
"departure_time" : "09:39:56" , 
"distance_traveled" : 30.3155
}, 
{ 
"stop_id" : 92,
"arrival_time" : "09:42:51" , 
"departure_time" : "09:44:05" , 
"distance_traveled" : 32.404
}, 
{ 
"stop_id" : 91,
"arrival_time" : "09:48:14" , 
"departure_time" : "09:48:24" , 
"distance_traveled" : 34.6345
}, 
{ 
"stop_id" : 34,
"arrival_time" : "09:55:10" , 
"departure_time" : "09:56:16" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "10:04:06" , 
"departure_time" : "10:04:06" , 
"distance_traveled" : 43.1008
} ], 
"2106" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:15:00" , 
"departure_time" : "16:16:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:33:10" , 
"departure_time" : "16:33:16" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 136,
"arrival_time" : "16:47:06" , 
"departure_time" : "16:48:23" , 
"distance_traveled" : 20.4612
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:53:17" , 
"departure_time" : "16:54:24" , 
"distance_traveled" : 22.7288
}, 
{ 
"stop_id" : 27,
"arrival_time" : "16:59:07" , 
"departure_time" : "17:00:16" , 
"distance_traveled" : 26.1551
}, 
{ 
"stop_id" : 77,
"arrival_time" : "17:03:09" , 
"departure_time" : "17:04:13" , 
"distance_traveled" : 28.1504
}, 
{ 
"stop_id" : 30,
"arrival_time" : "17:07:04" , 
"departure_time" : "17:07:12" , 
"distance_traveled" : 30.3157
}, 
{ 
"stop_id" : 92,
"arrival_time" : "17:10:08" , 
"departure_time" : "17:10:28" , 
"distance_traveled" : 32.4042
}, 
{ 
"stop_id" : 91,
"arrival_time" : "17:14:20" , 
"departure_time" : "17:15:17" , 
"distance_traveled" : 34.6347
}, 
{ 
"stop_id" : 34,
"arrival_time" : "17:22:57" , 
"departure_time" : "17:23:18" , 
"distance_traveled" : 38.9019
}, 
{ 
"stop_id" : 35,
"arrival_time" : "17:30:21" , 
"departure_time" : "17:30:21" , 
"distance_traveled" : 43.1009
} ], 
"2107" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:34:00" , 
"departure_time" : "17:35:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:44:39" , 
"departure_time" : "17:46:07" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:56:28" , 
"departure_time" : "17:58:01" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:08:33" , 
"departure_time" : "18:09:23" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:10:50" , 
"departure_time" : "18:11:20" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "18:14:30" , 
"departure_time" : "18:15:46" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:22:16" , 
"departure_time" : "18:22:53" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "18:27:37" , 
"departure_time" : "18:28:47" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "18:32:10" , 
"departure_time" : "18:32:49" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "18:36:39" , 
"departure_time" : "18:37:07" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "18:40:28" , 
"departure_time" : "18:41:26" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "18:45:58" , 
"departure_time" : "18:47:38" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "18:54:40" , 
"departure_time" : "18:55:36" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "19:01:56" , 
"departure_time" : "19:01:56" , 
"distance_traveled" : 43.1006
} ], 
"2108" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:56:00" , 
"departure_time" : "18:57:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:13:26" , 
"departure_time" : "19:15:05" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 136,
"arrival_time" : "19:30:39" , 
"departure_time" : "19:31:03" , 
"distance_traveled" : 20.4612
}, 
{ 
"stop_id" : 145,
"arrival_time" : "19:36:24" , 
"departure_time" : "19:37:06" , 
"distance_traveled" : 22.7288
}, 
{ 
"stop_id" : 27,
"arrival_time" : "19:43:42" , 
"departure_time" : "19:44:46" , 
"distance_traveled" : 26.1551
}, 
{ 
"stop_id" : 77,
"arrival_time" : "19:48:04" , 
"departure_time" : "19:48:07" , 
"distance_traveled" : 28.1504
}, 
{ 
"stop_id" : 30,
"arrival_time" : "19:53:03" , 
"departure_time" : "19:53:19" , 
"distance_traveled" : 30.3157
}, 
{ 
"stop_id" : 92,
"arrival_time" : "19:57:16" , 
"departure_time" : "19:57:49" , 
"distance_traveled" : 32.4042
}, 
{ 
"stop_id" : 91,
"arrival_time" : "20:02:33" , 
"departure_time" : "20:04:10" , 
"distance_traveled" : 34.6347
}, 
{ 
"stop_id" : 34,
"arrival_time" : "20:11:37" , 
"departure_time" : "20:12:50" , 
"distance_traveled" : 38.9019
}, 
{ 
"stop_id" : 35,
"arrival_time" : "20:20:13" , 
"departure_time" : "20:20:13" , 
"distance_traveled" : 43.1009
} ], 
"2109" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "14:27:00" , 
"departure_time" : "14:29:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "14:47:07" , 
"departure_time" : "14:48:10" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 145,
"arrival_time" : "15:04:03" , 
"departure_time" : "15:04:49" , 
"distance_traveled" : 20.0949
}, 
{ 
"stop_id" : 27,
"arrival_time" : "15:09:46" , 
"departure_time" : "15:11:19" , 
"distance_traveled" : 23.5212
}, 
{ 
"stop_id" : 77,
"arrival_time" : "15:14:33" , 
"departure_time" : "15:16:08" , 
"distance_traveled" : 25.5165
}, 
{ 
"stop_id" : 30,
"arrival_time" : "15:18:35" , 
"departure_time" : "15:18:50" , 
"distance_traveled" : 27.6818
}, 
{ 
"stop_id" : 92,
"arrival_time" : "15:21:15" , 
"departure_time" : "15:22:23" , 
"distance_traveled" : 29.7703
}, 
{ 
"stop_id" : 91,
"arrival_time" : "15:27:08" , 
"departure_time" : "15:28:35" , 
"distance_traveled" : 32.0008
}, 
{ 
"stop_id" : 94,
"arrival_time" : "15:34:27" , 
"departure_time" : "15:34:29" , 
"distance_traveled" : 35.6919
}, 
{ 
"stop_id" : 34,
"arrival_time" : "15:35:02" , 
"departure_time" : "15:35:05" , 
"distance_traveled" : 36.2682
}, 
{ 
"stop_id" : 35,
"arrival_time" : "15:42:03" , 
"departure_time" : "15:42:08" , 
"distance_traveled" : 40.4672
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "15:50:05" , 
"departure_time" : "15:51:02" , 
"distance_traveled" : 45.415
}, 
{ 
"stop_id" : 67,
"arrival_time" : "15:55:57" , 
"departure_time" : "15:56:22" , 
"distance_traveled" : 47.8294
}, 
{ 
"stop_id" : 101,
"arrival_time" : "16:02:25" , 
"departure_time" : "16:03:08" , 
"distance_traveled" : 50.3013
}, 
{ 
"stop_id" : 93,
"arrival_time" : "16:07:43" , 
"departure_time" : "16:09:15" , 
"distance_traveled" : 52.5165
}, 
{ 
"stop_id" : 54,
"arrival_time" : "16:24:32" , 
"departure_time" : "16:24:32" , 
"distance_traveled" : 59.9006
} ], 
"2110" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "04:43:00" , 
"departure_time" : "04:46:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "05:02:36" , 
"departure_time" : "05:04:16" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "05:07:40" , 
"departure_time" : "05:09:01" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "05:09:21" , 
"departure_time" : "05:10:23" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "05:12:02" , 
"departure_time" : "05:13:08" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "05:14:06" , 
"departure_time" : "05:15:00" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "05:15:54" , 
"departure_time" : "05:16:35" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "05:17:41" , 
"departure_time" : "05:18:00" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "05:20:19" , 
"departure_time" : "05:21:27" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "05:25:08" , 
"departure_time" : "05:25:54" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "05:27:46" , 
"departure_time" : "05:28:03" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "05:31:17" , 
"departure_time" : "05:31:17" , 
"distance_traveled" : 20.0947
} ], 
"2111" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:05:00" , 
"departure_time" : "20:05:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "20:22:03" , 
"departure_time" : "20:23:34" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 23,
"arrival_time" : "20:30:31" , 
"departure_time" : "20:31:55" , 
"distance_traveled" : 13.1979
}, 
{ 
"stop_id" : 112,
"arrival_time" : "20:33:24" , 
"departure_time" : "20:34:40" , 
"distance_traveled" : 14.0973
}, 
{ 
"stop_id" : 140,
"arrival_time" : "20:38:16" , 
"departure_time" : "20:39:40" , 
"distance_traveled" : 16.4955
}, 
{ 
"stop_id" : 81,
"arrival_time" : "20:42:24" , 
"departure_time" : "20:43:17" , 
"distance_traveled" : 17.7778
}, 
{ 
"stop_id" : 87,
"arrival_time" : "20:45:53" , 
"departure_time" : "20:47:11" , 
"distance_traveled" : 19.3866
}, 
{ 
"stop_id" : 136,
"arrival_time" : "20:50:18" , 
"departure_time" : "20:51:06" , 
"distance_traveled" : 20.461
}, 
{ 
"stop_id" : 145,
"arrival_time" : "20:55:48" , 
"departure_time" : "20:57:03" , 
"distance_traveled" : 22.7286
}, 
{ 
"stop_id" : 27,
"arrival_time" : "21:02:15" , 
"departure_time" : "21:02:57" , 
"distance_traveled" : 26.1549
}, 
{ 
"stop_id" : 77,
"arrival_time" : "21:05:42" , 
"departure_time" : "21:06:48" , 
"distance_traveled" : 28.1502
}, 
{ 
"stop_id" : 30,
"arrival_time" : "21:11:06" , 
"departure_time" : "21:12:38" , 
"distance_traveled" : 30.3155
}, 
{ 
"stop_id" : 92,
"arrival_time" : "21:15:32" , 
"departure_time" : "21:15:58" , 
"distance_traveled" : 32.404
}, 
{ 
"stop_id" : 91,
"arrival_time" : "21:18:26" , 
"departure_time" : "21:19:46" , 
"distance_traveled" : 34.6345
}, 
{ 
"stop_id" : 34,
"arrival_time" : "21:27:20" , 
"departure_time" : "21:27:32" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "21:35:12" , 
"departure_time" : "21:35:12" , 
"distance_traveled" : 43.1008
} ], 
"2112" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "07:33:00" , 
"departure_time" : "07:34:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:52:19" , 
"departure_time" : "07:52:53" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "07:57:34" , 
"departure_time" : "07:58:11" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "07:59:37" , 
"departure_time" : "08:00:57" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "08:03:20" , 
"departure_time" : "08:04:06" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "08:04:46" , 
"departure_time" : "08:05:09" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "08:06:23" , 
"departure_time" : "08:06:53" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:09:30" , 
"departure_time" : "08:10:01" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "08:12:31" , 
"departure_time" : "08:13:33" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "08:17:02" , 
"departure_time" : "08:17:52" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "08:18:50" , 
"departure_time" : "08:19:21" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "08:22:31" , 
"departure_time" : "08:22:31" , 
"distance_traveled" : 20.0947
} ], 
"2113" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:35:00" , 
"departure_time" : "16:36:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:52:32" , 
"departure_time" : "16:52:37" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 23,
"arrival_time" : "16:58:05" , 
"departure_time" : "16:58:20" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "17:01:15" , 
"departure_time" : "17:02:05" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:06:50" , 
"departure_time" : "17:06:53" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "17:09:03" , 
"departure_time" : "17:10:15" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "17:14:12" , 
"departure_time" : "17:15:13" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:19:01" , 
"departure_time" : "17:19:48" , 
"distance_traveled" : 20.0949
}, 
{ 
"stop_id" : 27,
"arrival_time" : "17:24:47" , 
"departure_time" : "17:25:43" , 
"distance_traveled" : 23.5212
}, 
{ 
"stop_id" : 77,
"arrival_time" : "17:28:56" , 
"departure_time" : "17:29:22" , 
"distance_traveled" : 25.5165
}, 
{ 
"stop_id" : 30,
"arrival_time" : "17:31:26" , 
"departure_time" : "17:32:06" , 
"distance_traveled" : 27.6818
}, 
{ 
"stop_id" : 92,
"arrival_time" : "17:35:40" , 
"departure_time" : "17:36:47" , 
"distance_traveled" : 29.7703
}, 
{ 
"stop_id" : 91,
"arrival_time" : "17:40:07" , 
"departure_time" : "17:40:44" , 
"distance_traveled" : 32.0008
}, 
{ 
"stop_id" : 94,
"arrival_time" : "17:46:37" , 
"departure_time" : "17:47:40" , 
"distance_traveled" : 35.6919
}, 
{ 
"stop_id" : 34,
"arrival_time" : "17:50:03" , 
"departure_time" : "17:51:24" , 
"distance_traveled" : 36.2682
}, 
{ 
"stop_id" : 35,
"arrival_time" : "17:57:21" , 
"departure_time" : "17:57:21" , 
"distance_traveled" : 40.4672
} ], 
"2114" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:52:00" , 
"departure_time" : "17:53:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 23,
"arrival_time" : "18:14:07" , 
"departure_time" : "18:14:11" , 
"distance_traveled" : 13.1746
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:21:04" , 
"departure_time" : "18:21:31" , 
"distance_traveled" : 16.4723
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:33:27" , 
"departure_time" : "18:34:42" , 
"distance_traveled" : 22.7057
}, 
{ 
"stop_id" : 27,
"arrival_time" : "18:41:15" , 
"departure_time" : "18:41:18" , 
"distance_traveled" : 26.132
}, 
{ 
"stop_id" : 77,
"arrival_time" : "18:45:03" , 
"departure_time" : "18:45:47" , 
"distance_traveled" : 28.1273
}, 
{ 
"stop_id" : 30,
"arrival_time" : "18:50:44" , 
"departure_time" : "18:52:08" , 
"distance_traveled" : 30.2926
}, 
{ 
"stop_id" : 92,
"arrival_time" : "18:55:24" , 
"departure_time" : "18:56:05" , 
"distance_traveled" : 32.3811
}, 
{ 
"stop_id" : 91,
"arrival_time" : "18:58:41" , 
"departure_time" : "19:00:12" , 
"distance_traveled" : 34.6116
}, 
{ 
"stop_id" : 34,
"arrival_time" : "19:07:31" , 
"departure_time" : "19:08:50" , 
"distance_traveled" : 38.8788
}, 
{ 
"stop_id" : 35,
"arrival_time" : "19:16:19" , 
"departure_time" : "19:16:19" , 
"distance_traveled" : 43.0778
} ], 
"2115" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:28:00" , 
"departure_time" : "17:30:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:44:43" , 
"departure_time" : "17:46:15" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:55:32" , 
"departure_time" : "17:55:51" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "17:57:19" , 
"departure_time" : "17:57:55" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:01:36" , 
"departure_time" : "18:02:45" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:09:09" , 
"departure_time" : "18:10:14" , 
"distance_traveled" : 20.0949
}, 
{ 
"stop_id" : 27,
"arrival_time" : "18:15:05" , 
"departure_time" : "18:15:56" , 
"distance_traveled" : 23.5212
}, 
{ 
"stop_id" : 77,
"arrival_time" : "18:18:51" , 
"departure_time" : "18:19:27" , 
"distance_traveled" : 25.5165
}, 
{ 
"stop_id" : 30,
"arrival_time" : "18:22:36" , 
"departure_time" : "18:23:44" , 
"distance_traveled" : 27.6818
}, 
{ 
"stop_id" : 92,
"arrival_time" : "18:27:08" , 
"departure_time" : "18:27:34" , 
"distance_traveled" : 29.7703
}, 
{ 
"stop_id" : 91,
"arrival_time" : "18:30:26" , 
"departure_time" : "18:31:05" , 
"distance_traveled" : 32.0008
}, 
{ 
"stop_id" : 94,
"arrival_time" : "18:38:39" , 
"departure_time" : "18:39:19" , 
"distance_traveled" : 35.6919
}, 
{ 
"stop_id" : 34,
"arrival_time" : "18:40:40" , 
"departure_time" : "18:41:41" , 
"distance_traveled" : 36.2682
}, 
{ 
"stop_id" : 35,
"arrival_time" : "18:49:01" , 
"departure_time" : "18:49:54" , 
"distance_traveled" : 40.4672
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "18:55:53" , 
"departure_time" : "18:56:40" , 
"distance_traveled" : 45.415
}, 
{ 
"stop_id" : 67,
"arrival_time" : "19:00:47" , 
"departure_time" : "19:00:47" , 
"distance_traveled" : 47.8294
} ], 
"2116" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:26:00" , 
"departure_time" : "15:27:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:43:25" , 
"departure_time" : "15:44:37" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 136,
"arrival_time" : "15:58:12" , 
"departure_time" : "15:59:31" , 
"distance_traveled" : 20.4612
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:03:19" , 
"departure_time" : "16:03:38" , 
"distance_traveled" : 22.7288
}, 
{ 
"stop_id" : 27,
"arrival_time" : "16:08:19" , 
"departure_time" : "16:09:07" , 
"distance_traveled" : 26.1551
}, 
{ 
"stop_id" : 77,
"arrival_time" : "16:12:48" , 
"departure_time" : "16:12:50" , 
"distance_traveled" : 28.1504
}, 
{ 
"stop_id" : 30,
"arrival_time" : "16:16:02" , 
"departure_time" : "16:17:20" , 
"distance_traveled" : 30.3157
}, 
{ 
"stop_id" : 92,
"arrival_time" : "16:21:18" , 
"departure_time" : "16:21:57" , 
"distance_traveled" : 32.4042
}, 
{ 
"stop_id" : 91,
"arrival_time" : "16:24:39" , 
"departure_time" : "16:26:19" , 
"distance_traveled" : 34.6347
}, 
{ 
"stop_id" : 34,
"arrival_time" : "16:33:40" , 
"departure_time" : "16:35:19" , 
"distance_traveled" : 38.9019
}, 
{ 
"stop_id" : 35,
"arrival_time" : "16:40:39" , 
"departure_time" : "16:40:39" , 
"distance_traveled" : 43.1009
} ], 
"2117" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "07:49:00" , 
"departure_time" : "07:50:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:58:08" , 
"departure_time" : "07:59:09" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:09:01" , 
"departure_time" : "08:10:27" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "08:15:26" , 
"departure_time" : "08:15:58" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "08:17:32" , 
"departure_time" : "08:17:42" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:22:10" , 
"departure_time" : "08:22:25" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "08:25:15" , 
"departure_time" : "08:26:23" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "08:30:08" , 
"departure_time" : "08:31:08" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "08:33:00" , 
"departure_time" : "08:33:41" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "08:37:41" , 
"departure_time" : "08:38:51" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "08:44:10" , 
"departure_time" : "08:44:58" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "08:47:48" , 
"departure_time" : "08:48:44" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "08:51:56" , 
"departure_time" : "08:52:10" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "08:55:14" , 
"departure_time" : "08:55:31" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "09:00:17" , 
"departure_time" : "09:01:14" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "09:08:57" , 
"departure_time" : "09:08:58" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "09:17:01" , 
"departure_time" : "09:17:01" , 
"distance_traveled" : 43.1006
} ], 
"2118" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:26:00" , 
"departure_time" : "19:26:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:43:21" , 
"departure_time" : "19:44:55" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 136,
"arrival_time" : "19:58:34" , 
"departure_time" : "19:59:03" , 
"distance_traveled" : 20.4612
}, 
{ 
"stop_id" : 145,
"arrival_time" : "20:02:29" , 
"departure_time" : "20:04:06" , 
"distance_traveled" : 22.7288
}, 
{ 
"stop_id" : 27,
"arrival_time" : "20:09:37" , 
"departure_time" : "20:09:42" , 
"distance_traveled" : 26.1551
}, 
{ 
"stop_id" : 77,
"arrival_time" : "20:12:05" , 
"departure_time" : "20:12:09" , 
"distance_traveled" : 28.1504
}, 
{ 
"stop_id" : 30,
"arrival_time" : "20:16:04" , 
"departure_time" : "20:16:20" , 
"distance_traveled" : 30.3157
}, 
{ 
"stop_id" : 92,
"arrival_time" : "20:20:16" , 
"departure_time" : "20:20:41" , 
"distance_traveled" : 32.4042
}, 
{ 
"stop_id" : 91,
"arrival_time" : "20:25:25" , 
"departure_time" : "20:26:31" , 
"distance_traveled" : 34.6347
}, 
{ 
"stop_id" : 94,
"arrival_time" : "20:33:06" , 
"departure_time" : "20:34:25" , 
"distance_traveled" : 38.3258
}, 
{ 
"stop_id" : 34,
"arrival_time" : "20:36:19" , 
"departure_time" : "20:36:23" , 
"distance_traveled" : 38.9021
}, 
{ 
"stop_id" : 35,
"arrival_time" : "20:44:04" , 
"departure_time" : "20:44:04" , 
"distance_traveled" : 43.1011
} ], 
"2119" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "10:46:00" , 
"departure_time" : "10:46:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:56:10" , 
"departure_time" : "10:57:25" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "11:06:15" , 
"departure_time" : "11:06:46" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "11:11:31" , 
"departure_time" : "11:12:54" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "11:15:23" , 
"departure_time" : "11:16:40" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 140,
"arrival_time" : "11:20:17" , 
"departure_time" : "11:20:39" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "11:22:22" , 
"departure_time" : "11:22:37" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "11:26:15" , 
"departure_time" : "11:27:49" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "11:30:34" , 
"departure_time" : "11:30:42" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "11:34:08" , 
"departure_time" : "11:35:34" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "11:41:26" , 
"departure_time" : "11:42:21" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "11:44:55" , 
"departure_time" : "11:46:20" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "11:49:25" , 
"departure_time" : "11:51:03" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "11:53:38" , 
"departure_time" : "11:54:12" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "11:56:34" , 
"departure_time" : "11:57:22" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "12:04:48" , 
"departure_time" : "12:05:20" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "12:13:32" , 
"departure_time" : "12:13:32" , 
"distance_traveled" : 43.1006
} ], 
"2120" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:45:00" , 
"departure_time" : "16:46:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:54:42" , 
"departure_time" : "16:54:44" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:06:02" , 
"departure_time" : "17:06:47" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 136,
"arrival_time" : "17:22:45" , 
"departure_time" : "17:22:50" , 
"distance_traveled" : 20.461
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:27:05" , 
"departure_time" : "17:27:17" , 
"distance_traveled" : 22.7286
}, 
{ 
"stop_id" : 27,
"arrival_time" : "17:33:12" , 
"departure_time" : "17:34:06" , 
"distance_traveled" : 26.1549
}, 
{ 
"stop_id" : 77,
"arrival_time" : "17:37:54" , 
"departure_time" : "17:38:20" , 
"distance_traveled" : 28.1502
}, 
{ 
"stop_id" : 30,
"arrival_time" : "17:42:26" , 
"departure_time" : "17:43:15" , 
"distance_traveled" : 30.3155
}, 
{ 
"stop_id" : 92,
"arrival_time" : "17:46:49" , 
"departure_time" : "17:47:57" , 
"distance_traveled" : 32.404
}, 
{ 
"stop_id" : 91,
"arrival_time" : "17:52:08" , 
"departure_time" : "17:52:50" , 
"distance_traveled" : 34.6345
}, 
{ 
"stop_id" : 34,
"arrival_time" : "17:59:42" , 
"departure_time" : "18:01:18" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "18:07:36" , 
"departure_time" : "18:07:36" , 
"distance_traveled" : 43.1008
} ], 
"2121" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "11:46:00" , 
"departure_time" : "11:48:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:57:19" , 
"departure_time" : "11:58:49" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "12:06:30" , 
"departure_time" : "12:07:53" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "12:12:23" , 
"departure_time" : "12:13:41" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "12:15:18" , 
"departure_time" : "12:16:23" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 140,
"arrival_time" : "12:20:05" , 
"departure_time" : "12:21:15" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "12:23:10" , 
"departure_time" : "12:23:11" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "12:26:01" , 
"departure_time" : "12:26:54" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "12:29:53" , 
"departure_time" : "12:29:59" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "12:34:06" , 
"departure_time" : "12:35:12" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "12:41:06" , 
"departure_time" : "12:41:14" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "12:44:08" , 
"departure_time" : "12:44:10" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "12:48:02" , 
"departure_time" : "12:49:00" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "12:52:58" , 
"departure_time" : "12:53:48" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "12:56:50" , 
"departure_time" : "12:57:33" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "13:04:43" , 
"departure_time" : "13:05:25" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "13:15:42" , 
"departure_time" : "13:15:42" , 
"distance_traveled" : 43.1006
} ], 
"2122" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:14:00" , 
"departure_time" : "17:15:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:31:28" , 
"departure_time" : "17:31:55" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 81,
"arrival_time" : "17:44:27" , 
"departure_time" : "17:44:40" , 
"distance_traveled" : 17.7778
}, 
{ 
"stop_id" : 87,
"arrival_time" : "17:48:13" , 
"departure_time" : "17:49:30" , 
"distance_traveled" : 19.3866
}, 
{ 
"stop_id" : 136,
"arrival_time" : "17:53:17" , 
"departure_time" : "17:54:22" , 
"distance_traveled" : 20.461
}, 
{ 
"stop_id" : 27,
"arrival_time" : "18:04:05" , 
"departure_time" : "18:05:37" , 
"distance_traveled" : 26.1532
}, 
{ 
"stop_id" : 77,
"arrival_time" : "18:08:32" , 
"departure_time" : "18:09:32" , 
"distance_traveled" : 28.1485
}, 
{ 
"stop_id" : 30,
"arrival_time" : "18:13:00" , 
"departure_time" : "18:14:18" , 
"distance_traveled" : 30.3138
}, 
{ 
"stop_id" : 92,
"arrival_time" : "18:17:18" , 
"departure_time" : "18:18:48" , 
"distance_traveled" : 32.4023
}, 
{ 
"stop_id" : 91,
"arrival_time" : "18:22:30" , 
"departure_time" : "18:22:36" , 
"distance_traveled" : 34.6328
}, 
{ 
"stop_id" : 34,
"arrival_time" : "18:29:06" , 
"departure_time" : "18:30:32" , 
"distance_traveled" : 38.9
}, 
{ 
"stop_id" : 35,
"arrival_time" : "18:37:26" , 
"departure_time" : "18:37:26" , 
"distance_traveled" : 43.0991
} ], 
"2123" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "12:46:00" , 
"departure_time" : "12:48:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:57:23" , 
"departure_time" : "12:58:13" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "13:05:50" , 
"departure_time" : "13:06:39" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "13:11:49" , 
"departure_time" : "13:13:18" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "13:15:29" , 
"departure_time" : "13:16:51" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 140,
"arrival_time" : "13:20:22" , 
"departure_time" : "13:21:05" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "13:22:43" , 
"departure_time" : "13:24:01" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "13:27:18" , 
"departure_time" : "13:27:42" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "13:29:24" , 
"departure_time" : "13:29:32" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "13:34:08" , 
"departure_time" : "13:35:02" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "13:40:54" , 
"departure_time" : "13:42:21" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "13:45:27" , 
"departure_time" : "13:45:38" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "13:48:11" , 
"departure_time" : "13:49:08" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "13:52:57" , 
"departure_time" : "13:54:22" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "13:57:25" , 
"departure_time" : "13:58:39" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "14:05:14" , 
"departure_time" : "14:06:15" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "14:16:01" , 
"departure_time" : "14:16:01" , 
"distance_traveled" : 43.1006
} ], 
"2124" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "08:38:00" , 
"departure_time" : "08:39:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:47:22" , 
"departure_time" : "08:47:24" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:57:02" , 
"departure_time" : "08:58:17" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 140,
"arrival_time" : "09:08:15" , 
"departure_time" : "09:08:31" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "09:10:16" , 
"departure_time" : "09:10:44" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "09:14:28" , 
"departure_time" : "09:14:58" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 145,
"arrival_time" : "09:23:30" , 
"departure_time" : "09:24:25" , 
"distance_traveled" : 22.7286
}, 
{ 
"stop_id" : 27,
"arrival_time" : "09:29:55" , 
"departure_time" : "09:30:34" , 
"distance_traveled" : 26.1549
}, 
{ 
"stop_id" : 77,
"arrival_time" : "09:33:39" , 
"departure_time" : "09:35:14" , 
"distance_traveled" : 28.1502
}, 
{ 
"stop_id" : 30,
"arrival_time" : "09:39:35" , 
"departure_time" : "09:41:02" , 
"distance_traveled" : 30.3155
}, 
{ 
"stop_id" : 92,
"arrival_time" : "09:43:27" , 
"departure_time" : "09:44:45" , 
"distance_traveled" : 32.404
}, 
{ 
"stop_id" : 91,
"arrival_time" : "09:48:18" , 
"departure_time" : "09:49:03" , 
"distance_traveled" : 34.6345
}, 
{ 
"stop_id" : 34,
"arrival_time" : "09:55:45" , 
"departure_time" : "09:56:23" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "10:03:38" , 
"departure_time" : "10:03:38" , 
"distance_traveled" : 43.1008
} ], 
"2125" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "21:51:00" , 
"departure_time" : "21:52:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:02:01" , 
"departure_time" : "22:02:13" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "22:10:12" , 
"departure_time" : "22:10:40" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "22:17:28" , 
"departure_time" : "22:18:26" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "22:20:58" , 
"departure_time" : "22:21:33" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 140,
"arrival_time" : "22:25:35" , 
"departure_time" : "22:26:31" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "22:28:56" , 
"departure_time" : "22:29:43" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "22:32:47" , 
"departure_time" : "22:33:29" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "22:36:42" , 
"departure_time" : "22:37:29" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "22:42:47" , 
"departure_time" : "22:43:48" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "22:49:01" , 
"departure_time" : "22:50:11" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "22:53:10" , 
"departure_time" : "22:53:23" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "22:57:13" , 
"departure_time" : "22:57:44" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "23:01:31" , 
"departure_time" : "23:01:45" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "23:05:14" , 
"departure_time" : "23:06:34" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "23:14:20" , 
"departure_time" : "23:15:41" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "23:23:21" , 
"departure_time" : "23:23:21" , 
"distance_traveled" : 43.1006
} ], 
"2126" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:34:00" , 
"departure_time" : "17:35:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:44:27" , 
"departure_time" : "17:45:25" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:55:58" , 
"departure_time" : "17:57:07" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:08:09" , 
"departure_time" : "18:08:17" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:10:08" , 
"departure_time" : "18:11:48" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "18:15:40" , 
"departure_time" : "18:15:44" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:21:04" , 
"departure_time" : "18:21:47" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "18:27:43" , 
"departure_time" : "18:27:58" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "18:31:15" , 
"departure_time" : "18:32:42" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "18:37:27" , 
"departure_time" : "18:38:24" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "18:40:57" , 
"departure_time" : "18:41:41" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "18:45:44" , 
"departure_time" : "18:46:49" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "18:54:05" , 
"departure_time" : "18:54:06" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "19:01:01" , 
"departure_time" : "19:01:01" , 
"distance_traveled" : 43.1006
} ], 
"2127" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "22:56:00" , 
"departure_time" : "22:56:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:05:04" , 
"departure_time" : "23:05:56" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "23:15:52" , 
"departure_time" : "23:16:12" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "23:22:20" , 
"departure_time" : "23:23:34" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "23:26:14" , 
"departure_time" : "23:27:46" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 140,
"arrival_time" : "23:31:32" , 
"departure_time" : "23:32:08" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "23:33:36" , 
"departure_time" : "23:34:53" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "23:38:17" , 
"departure_time" : "23:39:17" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "23:42:00" , 
"departure_time" : "23:42:39" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "23:47:39" , 
"departure_time" : "23:48:15" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "23:53:36" , 
"departure_time" : "23:54:12" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "23:57:36" , 
"departure_time" : "23:59:08" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "24:03:32" , 
"departure_time" : "24:04:30" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "24:06:58" , 
"departure_time" : "24:07:12" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "24:10:14" , 
"departure_time" : "24:10:28" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "24:18:14" , 
"departure_time" : "24:18:49" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "24:27:35" , 
"departure_time" : "24:27:35" , 
"distance_traveled" : 43.1006
} ], 
"2128" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "14:27:00" , 
"departure_time" : "14:29:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "14:47:27" , 
"departure_time" : "14:48:01" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 145,
"arrival_time" : "15:03:34" , 
"departure_time" : "15:03:45" , 
"distance_traveled" : 20.0949
}, 
{ 
"stop_id" : 27,
"arrival_time" : "15:09:11" , 
"departure_time" : "15:09:55" , 
"distance_traveled" : 23.5212
}, 
{ 
"stop_id" : 77,
"arrival_time" : "15:13:44" , 
"departure_time" : "15:15:22" , 
"distance_traveled" : 25.5165
}, 
{ 
"stop_id" : 30,
"arrival_time" : "15:18:38" , 
"departure_time" : "15:19:28" , 
"distance_traveled" : 27.6818
}, 
{ 
"stop_id" : 92,
"arrival_time" : "15:21:50" , 
"departure_time" : "15:22:21" , 
"distance_traveled" : 29.7703
}, 
{ 
"stop_id" : 91,
"arrival_time" : "15:26:31" , 
"departure_time" : "15:26:45" , 
"distance_traveled" : 32.0008
}, 
{ 
"stop_id" : 94,
"arrival_time" : "15:33:14" , 
"departure_time" : "15:34:08" , 
"distance_traveled" : 35.6919
}, 
{ 
"stop_id" : 34,
"arrival_time" : "15:35:54" , 
"departure_time" : "15:36:57" , 
"distance_traveled" : 36.2682
}, 
{ 
"stop_id" : 35,
"arrival_time" : "15:43:03" , 
"departure_time" : "15:44:16" , 
"distance_traveled" : 40.4672
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "15:51:13" , 
"departure_time" : "15:52:31" , 
"distance_traveled" : 45.415
}, 
{ 
"stop_id" : 67,
"arrival_time" : "15:56:18" , 
"departure_time" : "15:56:19" , 
"distance_traveled" : 47.8294
}, 
{ 
"stop_id" : 101,
"arrival_time" : "16:02:01" , 
"departure_time" : "16:02:50" , 
"distance_traveled" : 50.3013
}, 
{ 
"stop_id" : 93,
"arrival_time" : "16:07:49" , 
"departure_time" : "16:08:52" , 
"distance_traveled" : 52.5165
}, 
{ 
"stop_id" : 54,
"arrival_time" : "16:24:03" , 
"departure_time" : "16:24:03" , 
"distance_traveled" : 59.9006
} ], 
"2129" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:02:00" , 
"departure_time" : "17:03:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:18:53" , 
"departure_time" : "17:20:10" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "17:24:17" , 
"departure_time" : "17:24:32" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:26:15" , 
"departure_time" : "17:27:02" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "17:29:47" , 
"departure_time" : "17:30:05" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "17:31:18" , 
"departure_time" : "17:32:23" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "17:34:05" , 
"departure_time" : "17:34:39" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:36:34" , 
"departure_time" : "17:37:33" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "17:39:59" , 
"departure_time" : "17:41:21" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:49:22" , 
"departure_time" : "17:49:27" , 
"distance_traveled" : 20.0943
}, 
{ 
"stop_id" : 27,
"arrival_time" : "17:54:05" , 
"departure_time" : "17:54:10" , 
"distance_traveled" : 23.5203
}, 
{ 
"stop_id" : 77,
"arrival_time" : "17:57:05" , 
"departure_time" : "17:58:37" , 
"distance_traveled" : 25.5155
}, 
{ 
"stop_id" : 30,
"arrival_time" : "18:02:32" , 
"departure_time" : "18:04:08" , 
"distance_traveled" : 27.6809
}, 
{ 
"stop_id" : 92,
"arrival_time" : "18:06:36" , 
"departure_time" : "18:06:47" , 
"distance_traveled" : 29.7693
}, 
{ 
"stop_id" : 91,
"arrival_time" : "18:09:11" , 
"departure_time" : "18:10:42" , 
"distance_traveled" : 31.9998
}, 
{ 
"stop_id" : 94,
"arrival_time" : "18:17:31" , 
"departure_time" : "18:19:03" , 
"distance_traveled" : 35.6909
}, 
{ 
"stop_id" : 34,
"arrival_time" : "18:20:32" , 
"departure_time" : "18:21:45" , 
"distance_traveled" : 36.2672
}, 
{ 
"stop_id" : 35,
"arrival_time" : "18:29:13" , 
"departure_time" : "18:29:13" , 
"distance_traveled" : 40.4663
} ], 
"2130" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:05:00" , 
"departure_time" : "20:06:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "20:22:18" , 
"departure_time" : "20:22:42" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 23,
"arrival_time" : "20:29:24" , 
"departure_time" : "20:29:34" , 
"distance_traveled" : 13.1979
}, 
{ 
"stop_id" : 112,
"arrival_time" : "20:32:10" , 
"departure_time" : "20:32:13" , 
"distance_traveled" : 14.0973
}, 
{ 
"stop_id" : 140,
"arrival_time" : "20:37:03" , 
"departure_time" : "20:38:04" , 
"distance_traveled" : 16.4955
}, 
{ 
"stop_id" : 81,
"arrival_time" : "20:42:01" , 
"departure_time" : "20:43:23" , 
"distance_traveled" : 17.7778
}, 
{ 
"stop_id" : 87,
"arrival_time" : "20:46:22" , 
"departure_time" : "20:47:03" , 
"distance_traveled" : 19.3866
}, 
{ 
"stop_id" : 136,
"arrival_time" : "20:49:41" , 
"departure_time" : "20:50:20" , 
"distance_traveled" : 20.461
}, 
{ 
"stop_id" : 145,
"arrival_time" : "20:55:39" , 
"departure_time" : "20:56:51" , 
"distance_traveled" : 22.7286
}, 
{ 
"stop_id" : 27,
"arrival_time" : "21:02:12" , 
"departure_time" : "21:02:56" , 
"distance_traveled" : 26.1549
}, 
{ 
"stop_id" : 77,
"arrival_time" : "21:05:44" , 
"departure_time" : "21:06:04" , 
"distance_traveled" : 28.1502
}, 
{ 
"stop_id" : 30,
"arrival_time" : "21:10:20" , 
"departure_time" : "21:10:58" , 
"distance_traveled" : 30.3155
}, 
{ 
"stop_id" : 92,
"arrival_time" : "21:14:38" , 
"departure_time" : "21:16:09" , 
"distance_traveled" : 32.404
}, 
{ 
"stop_id" : 91,
"arrival_time" : "21:19:31" , 
"departure_time" : "21:21:01" , 
"distance_traveled" : 34.6345
}, 
{ 
"stop_id" : 34,
"arrival_time" : "21:27:30" , 
"departure_time" : "21:27:40" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "21:35:10" , 
"departure_time" : "21:35:10" , 
"distance_traveled" : 43.1008
} ], 
"2131" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "15:55:00" , 
"departure_time" : "15:56:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:14:38" , 
"departure_time" : "16:14:54" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 140,
"arrival_time" : "16:22:16" , 
"departure_time" : "16:22:44" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "16:25:28" , 
"departure_time" : "16:25:34" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "16:28:06" , 
"departure_time" : "16:28:22" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:35:16" , 
"departure_time" : "16:35:25" , 
"distance_traveled" : 20.0949
}, 
{ 
"stop_id" : 27,
"arrival_time" : "16:41:09" , 
"departure_time" : "16:41:18" , 
"distance_traveled" : 23.5212
}, 
{ 
"stop_id" : 77,
"arrival_time" : "16:44:09" , 
"departure_time" : "16:45:16" , 
"distance_traveled" : 25.5165
}, 
{ 
"stop_id" : 30,
"arrival_time" : "16:49:07" , 
"departure_time" : "16:49:32" , 
"distance_traveled" : 27.6818
}, 
{ 
"stop_id" : 92,
"arrival_time" : "16:52:25" , 
"departure_time" : "16:54:00" , 
"distance_traveled" : 29.7703
}, 
{ 
"stop_id" : 91,
"arrival_time" : "16:57:35" , 
"departure_time" : "16:58:56" , 
"distance_traveled" : 32.0008
}, 
{ 
"stop_id" : 94,
"arrival_time" : "17:04:21" , 
"departure_time" : "17:04:38" , 
"distance_traveled" : 35.6919
}, 
{ 
"stop_id" : 34,
"arrival_time" : "17:06:17" , 
"departure_time" : "17:06:55" , 
"distance_traveled" : 36.2682
}, 
{ 
"stop_id" : 35,
"arrival_time" : "17:13:38" , 
"departure_time" : "17:13:58" , 
"distance_traveled" : 40.4672
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "17:20:20" , 
"departure_time" : "17:21:44" , 
"distance_traveled" : 45.415
}, 
{ 
"stop_id" : 67,
"arrival_time" : "17:27:24" , 
"departure_time" : "17:29:03" , 
"distance_traveled" : 47.8294
}, 
{ 
"stop_id" : 101,
"arrival_time" : "17:33:39" , 
"departure_time" : "17:34:30" , 
"distance_traveled" : 50.3013
}, 
{ 
"stop_id" : 93,
"arrival_time" : "17:36:51" , 
"departure_time" : "17:36:51" , 
"distance_traveled" : 52.5165
} ], 
"2132" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:35:00" , 
"departure_time" : "16:36:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:52:43" , 
"departure_time" : "16:53:03" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 23,
"arrival_time" : "16:58:20" , 
"departure_time" : "16:59:10" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "17:01:50" , 
"departure_time" : "17:03:09" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:07:19" , 
"departure_time" : "17:07:28" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "17:09:09" , 
"departure_time" : "17:09:39" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "17:13:30" , 
"departure_time" : "17:14:31" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:19:01" , 
"departure_time" : "17:20:35" , 
"distance_traveled" : 20.0949
}, 
{ 
"stop_id" : 27,
"arrival_time" : "17:25:34" , 
"departure_time" : "17:26:51" , 
"distance_traveled" : 23.5212
}, 
{ 
"stop_id" : 77,
"arrival_time" : "17:29:17" , 
"departure_time" : "17:30:40" , 
"distance_traveled" : 25.5165
}, 
{ 
"stop_id" : 30,
"arrival_time" : "17:32:23" , 
"departure_time" : "17:33:51" , 
"distance_traveled" : 27.6818
}, 
{ 
"stop_id" : 92,
"arrival_time" : "17:36:28" , 
"departure_time" : "17:37:51" , 
"distance_traveled" : 29.7703
}, 
{ 
"stop_id" : 91,
"arrival_time" : "17:40:23" , 
"departure_time" : "17:40:28" , 
"distance_traveled" : 32.0008
}, 
{ 
"stop_id" : 94,
"arrival_time" : "17:46:05" , 
"departure_time" : "17:46:08" , 
"distance_traveled" : 35.6919
}, 
{ 
"stop_id" : 34,
"arrival_time" : "17:49:03" , 
"departure_time" : "17:49:30" , 
"distance_traveled" : 36.2682
}, 
{ 
"stop_id" : 35,
"arrival_time" : "17:56:27" , 
"departure_time" : "17:56:27" , 
"distance_traveled" : 40.4672
} ], 
"2133" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "07:07:00" , 
"departure_time" : "07:07:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:16:15" , 
"departure_time" : "07:17:53" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:27:38" , 
"departure_time" : "07:27:47" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "07:32:09" , 
"departure_time" : "07:32:39" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "07:35:30" , 
"departure_time" : "07:35:58" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:40:28" , 
"departure_time" : "07:41:55" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:44:27" , 
"departure_time" : "07:45:25" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:47:58" , 
"departure_time" : "07:48:05" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:50:07" , 
"departure_time" : "07:51:19" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:56:12" , 
"departure_time" : "07:57:17" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "08:02:05" , 
"departure_time" : "08:02:09" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "08:05:04" , 
"departure_time" : "08:06:17" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "08:11:13" , 
"departure_time" : "08:12:42" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "08:15:29" , 
"departure_time" : "08:15:51" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "08:18:22" , 
"departure_time" : "08:19:43" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "08:26:21" , 
"departure_time" : "08:27:46" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "08:28:25" , 
"departure_time" : "08:29:00" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "08:35:35" , 
"departure_time" : "08:35:35" , 
"distance_traveled" : 43.1008
} ], 
"2134" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:28:00" , 
"departure_time" : "17:29:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:45:14" , 
"departure_time" : "17:45:42" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:54:28" , 
"departure_time" : "17:55:49" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "17:58:21" , 
"departure_time" : "17:59:38" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:02:17" , 
"departure_time" : "18:03:15" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:08:58" , 
"departure_time" : "18:09:27" , 
"distance_traveled" : 20.0949
}, 
{ 
"stop_id" : 27,
"arrival_time" : "18:14:29" , 
"departure_time" : "18:14:52" , 
"distance_traveled" : 23.5212
}, 
{ 
"stop_id" : 77,
"arrival_time" : "18:18:23" , 
"departure_time" : "18:18:35" , 
"distance_traveled" : 25.5165
}, 
{ 
"stop_id" : 30,
"arrival_time" : "18:22:12" , 
"departure_time" : "18:23:31" , 
"distance_traveled" : 27.6818
}, 
{ 
"stop_id" : 92,
"arrival_time" : "18:27:19" , 
"departure_time" : "18:28:27" , 
"distance_traveled" : 29.7703
}, 
{ 
"stop_id" : 91,
"arrival_time" : "18:31:08" , 
"departure_time" : "18:32:27" , 
"distance_traveled" : 32.0008
}, 
{ 
"stop_id" : 94,
"arrival_time" : "18:39:19" , 
"departure_time" : "18:40:48" , 
"distance_traveled" : 35.6919
}, 
{ 
"stop_id" : 34,
"arrival_time" : "18:41:29" , 
"departure_time" : "18:41:32" , 
"distance_traveled" : 36.2682
}, 
{ 
"stop_id" : 35,
"arrival_time" : "18:48:03" , 
"departure_time" : "18:49:04" , 
"distance_traveled" : 40.4672
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "18:56:01" , 
"departure_time" : "18:57:32" , 
"distance_traveled" : 45.415
}, 
{ 
"stop_id" : 67,
"arrival_time" : "19:01:31" , 
"departure_time" : "19:01:31" , 
"distance_traveled" : 47.8294
} ], 
"2135" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "10:04:00" , 
"departure_time" : "10:06:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:14:30" , 
"departure_time" : "10:14:48" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "10:23:18" , 
"departure_time" : "10:24:12" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "10:29:54" , 
"departure_time" : "10:30:17" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "10:32:23" , 
"departure_time" : "10:33:11" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 140,
"arrival_time" : "10:37:48" , 
"departure_time" : "10:38:25" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "10:40:37" , 
"departure_time" : "10:41:12" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "10:44:35" , 
"departure_time" : "10:45:02" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "10:47:27" , 
"departure_time" : "10:47:56" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "10:52:29" , 
"departure_time" : "10:54:00" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "10:58:31" , 
"departure_time" : "10:58:38" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "11:01:07" , 
"departure_time" : "11:02:36" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "11:06:29" , 
"departure_time" : "11:07:51" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "11:10:22" , 
"departure_time" : "11:11:14" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "11:13:52" , 
"departure_time" : "11:14:08" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "11:20:16" , 
"departure_time" : "11:20:34" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "11:23:18" , 
"departure_time" : "11:23:26" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "11:34:08" , 
"departure_time" : "11:34:08" , 
"distance_traveled" : 43.1008
} ], 
"2136" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "07:49:00" , 
"departure_time" : "07:49:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:58:03" , 
"departure_time" : "07:58:30" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:08:27" , 
"departure_time" : "08:09:05" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "08:14:38" , 
"departure_time" : "08:14:57" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "08:17:19" , 
"departure_time" : "08:17:56" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:22:37" , 
"departure_time" : "08:24:13" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "08:26:36" , 
"departure_time" : "08:27:44" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "08:30:08" , 
"departure_time" : "08:31:32" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "08:33:24" , 
"departure_time" : "08:34:26" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "08:38:02" , 
"departure_time" : "08:38:16" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "08:43:14" , 
"departure_time" : "08:43:49" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "08:47:35" , 
"departure_time" : "08:48:38" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "08:52:03" , 
"departure_time" : "08:52:19" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "08:55:16" , 
"departure_time" : "08:56:19" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "09:01:03" , 
"departure_time" : "09:02:35" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "09:09:32" , 
"departure_time" : "09:10:00" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "09:17:28" , 
"departure_time" : "09:17:28" , 
"distance_traveled" : 43.1006
} ], 
"2137" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "13:51:00" , 
"departure_time" : "13:52:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:01:33" , 
"departure_time" : "14:02:41" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "14:12:08" , 
"departure_time" : "14:13:43" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "14:18:35" , 
"departure_time" : "14:19:46" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "14:21:11" , 
"departure_time" : "14:21:44" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 140,
"arrival_time" : "14:25:33" , 
"departure_time" : "14:25:54" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "14:28:21" , 
"departure_time" : "14:29:35" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "14:33:14" , 
"departure_time" : "14:33:25" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "14:36:11" , 
"departure_time" : "14:36:50" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "14:42:39" , 
"departure_time" : "14:43:27" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "14:48:48" , 
"departure_time" : "14:49:27" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "14:52:39" , 
"departure_time" : "14:53:07" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "14:57:28" , 
"departure_time" : "14:59:08" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "15:02:40" , 
"departure_time" : "15:03:34" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "15:06:54" , 
"departure_time" : "15:07:41" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "15:13:47" , 
"departure_time" : "15:13:50" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "15:16:03" , 
"departure_time" : "15:17:07" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "15:26:04" , 
"departure_time" : "15:26:04" , 
"distance_traveled" : 43.1008
} ], 
"2138" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "10:46:00" , 
"departure_time" : "10:48:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:57:18" , 
"departure_time" : "10:57:29" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "11:05:11" , 
"departure_time" : "11:06:01" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "11:11:50" , 
"departure_time" : "11:13:13" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "11:15:23" , 
"departure_time" : "11:15:25" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 140,
"arrival_time" : "11:19:02" , 
"departure_time" : "11:20:19" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "11:23:17" , 
"departure_time" : "11:24:25" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "11:27:08" , 
"departure_time" : "11:28:48" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "11:30:40" , 
"departure_time" : "11:31:47" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "11:35:07" , 
"departure_time" : "11:36:19" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "11:41:12" , 
"departure_time" : "11:42:35" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "11:45:23" , 
"departure_time" : "11:46:48" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "11:49:25" , 
"departure_time" : "11:50:57" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "11:53:32" , 
"departure_time" : "11:53:40" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "11:56:08" , 
"departure_time" : "11:56:39" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "12:04:31" , 
"departure_time" : "12:04:54" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "12:13:23" , 
"departure_time" : "12:13:23" , 
"distance_traveled" : 43.1006
} ], 
"2139" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "19:34:00" , 
"departure_time" : "19:35:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:52:39" , 
"departure_time" : "19:52:46" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "19:57:07" , 
"departure_time" : "19:58:24" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "20:00:17" , 
"departure_time" : "20:00:27" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "20:02:10" , 
"departure_time" : "20:02:11" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "20:04:01" , 
"departure_time" : "20:05:01" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "20:08:00" , 
"departure_time" : "20:08:58" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "20:09:58" , 
"departure_time" : "20:11:06" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "20:13:08" , 
"departure_time" : "20:14:07" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "20:17:59" , 
"departure_time" : "20:18:41" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "20:20:42" , 
"departure_time" : "20:21:11" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "20:25:29" , 
"departure_time" : "20:26:40" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 27,
"arrival_time" : "20:32:11" , 
"departure_time" : "20:33:36" , 
"distance_traveled" : 23.521
}, 
{ 
"stop_id" : 77,
"arrival_time" : "20:36:25" , 
"departure_time" : "20:37:34" , 
"distance_traveled" : 25.5163
}, 
{ 
"stop_id" : 30,
"arrival_time" : "20:39:09" , 
"departure_time" : "20:39:10" , 
"distance_traveled" : 27.6816
}, 
{ 
"stop_id" : 92,
"arrival_time" : "20:42:01" , 
"departure_time" : "20:42:59" , 
"distance_traveled" : 29.7701
}, 
{ 
"stop_id" : 91,
"arrival_time" : "20:47:58" , 
"departure_time" : "20:49:14" , 
"distance_traveled" : 32.0006
}, 
{ 
"stop_id" : 34,
"arrival_time" : "20:56:16" , 
"departure_time" : "20:57:14" , 
"distance_traveled" : 36.2678
}, 
{ 
"stop_id" : 35,
"arrival_time" : "21:01:58" , 
"departure_time" : "21:01:58" , 
"distance_traveled" : 40.4669
} ], 
"2140" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "11:46:00" , 
"departure_time" : "11:47:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:56:21" , 
"departure_time" : "11:56:34" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "12:05:13" , 
"departure_time" : "12:05:23" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "12:11:10" , 
"departure_time" : "12:12:47" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "12:15:37" , 
"departure_time" : "12:17:04" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 140,
"arrival_time" : "12:20:27" , 
"departure_time" : "12:21:13" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "12:22:46" , 
"departure_time" : "12:24:08" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "12:27:22" , 
"departure_time" : "12:27:54" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "12:29:32" , 
"departure_time" : "12:29:51" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "12:34:19" , 
"departure_time" : "12:35:02" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "12:40:43" , 
"departure_time" : "12:40:58" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "12:44:15" , 
"departure_time" : "12:45:42" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "12:49:27" , 
"departure_time" : "12:50:05" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "12:52:38" , 
"departure_time" : "12:53:26" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "12:56:48" , 
"departure_time" : "12:58:02" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "13:05:14" , 
"departure_time" : "13:05:37" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "13:15:23" , 
"departure_time" : "13:15:23" , 
"distance_traveled" : 43.1006
} ], 
"2141" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:01:00" , 
"departure_time" : "18:02:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:18:23" , 
"departure_time" : "18:18:57" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:27:34" , 
"departure_time" : "18:28:00" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:30:26" , 
"departure_time" : "18:31:02" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:35:36" , 
"departure_time" : "18:35:45" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:43:09" , 
"departure_time" : "18:43:54" , 
"distance_traveled" : 20.0949
}, 
{ 
"stop_id" : 27,
"arrival_time" : "18:49:45" , 
"departure_time" : "18:51:13" , 
"distance_traveled" : 23.5212
}, 
{ 
"stop_id" : 77,
"arrival_time" : "18:54:28" , 
"departure_time" : "18:54:33" , 
"distance_traveled" : 25.5165
}, 
{ 
"stop_id" : 30,
"arrival_time" : "18:58:05" , 
"departure_time" : "18:58:19" , 
"distance_traveled" : 27.6818
}, 
{ 
"stop_id" : 92,
"arrival_time" : "19:02:14" , 
"departure_time" : "19:03:48" , 
"distance_traveled" : 29.7703
}, 
{ 
"stop_id" : 91,
"arrival_time" : "19:07:34" , 
"departure_time" : "19:08:05" , 
"distance_traveled" : 32.0008
}, 
{ 
"stop_id" : 94,
"arrival_time" : "19:14:31" , 
"departure_time" : "19:15:27" , 
"distance_traveled" : 35.6919
}, 
{ 
"stop_id" : 34,
"arrival_time" : "19:17:56" , 
"departure_time" : "19:18:40" , 
"distance_traveled" : 36.2682
}, 
{ 
"stop_id" : 35,
"arrival_time" : "19:25:44" , 
"departure_time" : "19:27:18" , 
"distance_traveled" : 40.4672
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "19:34:34" , 
"departure_time" : "19:36:09" , 
"distance_traveled" : 45.415
}, 
{ 
"stop_id" : 67,
"arrival_time" : "19:39:35" , 
"departure_time" : "19:40:17" , 
"distance_traveled" : 47.8294
}, 
{ 
"stop_id" : 101,
"arrival_time" : "19:45:42" , 
"departure_time" : "19:47:03" , 
"distance_traveled" : 50.3013
}, 
{ 
"stop_id" : 93,
"arrival_time" : "19:50:21" , 
"departure_time" : "19:50:37" , 
"distance_traveled" : 52.5165
}, 
{ 
"stop_id" : 54,
"arrival_time" : "20:04:16" , 
"departure_time" : "20:04:16" , 
"distance_traveled" : 59.9006
} ], 
"2142" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "12:46:00" , 
"departure_time" : "12:46:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:56:37" , 
"departure_time" : "12:56:44" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "13:05:07" , 
"departure_time" : "13:05:36" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "13:11:29" , 
"departure_time" : "13:11:42" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "13:14:13" , 
"departure_time" : "13:15:15" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 140,
"arrival_time" : "13:20:02" , 
"departure_time" : "13:21:41" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "13:23:39" , 
"departure_time" : "13:23:56" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "13:26:17" , 
"departure_time" : "13:26:30" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "13:29:13" , 
"departure_time" : "13:30:28" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "13:35:15" , 
"departure_time" : "13:36:28" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "13:41:13" , 
"departure_time" : "13:42:41" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "13:45:28" , 
"departure_time" : "13:45:55" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "13:48:27" , 
"departure_time" : "13:49:02" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "13:52:35" , 
"departure_time" : "13:54:01" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "13:57:26" , 
"departure_time" : "13:57:46" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "14:04:20" , 
"departure_time" : "14:05:47" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "14:16:27" , 
"departure_time" : "14:16:27" , 
"distance_traveled" : 43.1006
} ], 
"2143" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "14:32:00" , 
"departure_time" : "14:35:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:43:35" , 
"departure_time" : "14:43:56" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "14:51:21" , 
"departure_time" : "14:53:00" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "14:58:39" , 
"departure_time" : "14:58:59" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "15:00:20" , 
"departure_time" : "15:00:26" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 97,
"arrival_time" : "15:05:06" , 
"departure_time" : "15:05:46" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "15:07:40" , 
"departure_time" : "15:09:13" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "15:11:33" , 
"departure_time" : "15:12:46" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "15:15:13" , 
"departure_time" : "15:16:17" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "15:18:04" , 
"departure_time" : "15:18:58" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "15:22:54" , 
"departure_time" : "15:23:52" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "15:28:58" , 
"departure_time" : "15:30:07" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "15:33:09" , 
"departure_time" : "15:33:42" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "15:36:33" , 
"departure_time" : "15:36:52" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "15:40:19" , 
"departure_time" : "15:41:22" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "15:46:03" , 
"departure_time" : "15:47:12" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "15:53:09" , 
"departure_time" : "15:54:28" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "15:56:19" , 
"departure_time" : "15:57:03" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "16:05:44" , 
"departure_time" : "16:05:44" , 
"distance_traveled" : 43.1008
} ], 
"2144" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "21:51:00" , 
"departure_time" : "21:53:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:02:24" , 
"departure_time" : "22:03:37" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "22:11:13" , 
"departure_time" : "22:12:52" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "22:18:39" , 
"departure_time" : "22:19:33" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "22:20:54" , 
"departure_time" : "22:21:45" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 140,
"arrival_time" : "22:25:51" , 
"departure_time" : "22:26:32" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "22:28:41" , 
"departure_time" : "22:28:56" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "22:32:15" , 
"departure_time" : "22:33:50" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "22:37:35" , 
"departure_time" : "22:39:13" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "22:43:38" , 
"departure_time" : "22:45:15" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "22:49:37" , 
"departure_time" : "22:50:39" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "22:53:02" , 
"departure_time" : "22:53:31" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "22:57:29" , 
"departure_time" : "22:58:58" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "23:02:29" , 
"departure_time" : "23:03:12" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "23:05:43" , 
"departure_time" : "23:06:31" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "23:13:48" , 
"departure_time" : "23:14:07" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "23:22:19" , 
"departure_time" : "23:22:19" , 
"distance_traveled" : 43.1006
} ], 
"2145" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:51:00" , 
"departure_time" : "20:52:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:01:54" , 
"departure_time" : "21:02:40" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "21:10:46" , 
"departure_time" : "21:11:41" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "21:17:55" , 
"departure_time" : "21:19:28" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "21:21:33" , 
"departure_time" : "21:22:24" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 140,
"arrival_time" : "21:25:51" , 
"departure_time" : "21:25:52" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "21:28:01" , 
"departure_time" : "21:28:47" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "21:32:46" , 
"departure_time" : "21:32:51" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "21:36:05" , 
"departure_time" : "21:37:10" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "21:43:05" , 
"departure_time" : "21:43:55" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "21:48:50" , 
"departure_time" : "21:48:54" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "21:52:04" , 
"departure_time" : "21:52:38" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "21:57:34" , 
"departure_time" : "21:58:15" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "22:01:41" , 
"departure_time" : "22:02:19" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "22:05:38" , 
"departure_time" : "22:06:49" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "22:13:11" , 
"departure_time" : "22:14:28" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "22:16:17" , 
"departure_time" : "22:16:48" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "22:22:31" , 
"departure_time" : "22:22:31" , 
"distance_traveled" : 43.1008
} ], 
"2146" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "22:56:00" , 
"departure_time" : "22:56:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:05:06" , 
"departure_time" : "23:06:37" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "23:16:31" , 
"departure_time" : "23:17:22" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "23:22:51" , 
"departure_time" : "23:24:27" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "23:26:36" , 
"departure_time" : "23:27:05" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 140,
"arrival_time" : "23:30:29" , 
"departure_time" : "23:31:51" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "23:34:22" , 
"departure_time" : "23:34:25" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "23:37:03" , 
"departure_time" : "23:37:26" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "23:41:23" , 
"departure_time" : "23:42:49" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "23:48:26" , 
"departure_time" : "23:48:27" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "23:53:01" , 
"departure_time" : "23:53:14" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "23:57:13" , 
"departure_time" : "23:57:41" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "24:02:28" , 
"departure_time" : "24:03:57" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "24:07:29" , 
"departure_time" : "24:07:50" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "24:10:21" , 
"departure_time" : "24:11:45" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "24:19:24" , 
"departure_time" : "24:19:47" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "24:27:23" , 
"departure_time" : "24:27:23" , 
"distance_traveled" : 43.1006
} ], 
"2147" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "06:18:00" , 
"departure_time" : "06:18:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:36:20" , 
"departure_time" : "06:37:32" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "06:42:12" , 
"departure_time" : "06:42:47" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "06:43:35" , 
"departure_time" : "06:44:44" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "06:47:09" , 
"departure_time" : "06:47:52" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "06:49:43" , 
"departure_time" : "06:50:29" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "06:51:46" , 
"departure_time" : "06:53:08" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "06:54:22" , 
"departure_time" : "06:55:20" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "06:56:58" , 
"departure_time" : "06:57:41" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:00:43" , 
"departure_time" : "07:01:50" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:04:07" , 
"departure_time" : "07:04:47" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:08:40" , 
"departure_time" : "07:10:13" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 27,
"arrival_time" : "07:15:33" , 
"departure_time" : "07:16:36" , 
"distance_traveled" : 23.521
}, 
{ 
"stop_id" : 77,
"arrival_time" : "07:19:03" , 
"departure_time" : "07:19:36" , 
"distance_traveled" : 25.5163
}, 
{ 
"stop_id" : 30,
"arrival_time" : "07:22:33" , 
"departure_time" : "07:23:44" , 
"distance_traveled" : 27.6816
}, 
{ 
"stop_id" : 92,
"arrival_time" : "07:27:11" , 
"departure_time" : "07:27:56" , 
"distance_traveled" : 29.7701
}, 
{ 
"stop_id" : 91,
"arrival_time" : "07:30:45" , 
"departure_time" : "07:32:18" , 
"distance_traveled" : 32.0006
}, 
{ 
"stop_id" : 94,
"arrival_time" : "07:38:33" , 
"departure_time" : "07:39:21" , 
"distance_traveled" : 35.6917
}, 
{ 
"stop_id" : 34,
"arrival_time" : "07:40:48" , 
"departure_time" : "07:41:49" , 
"distance_traveled" : 36.268
}, 
{ 
"stop_id" : 35,
"arrival_time" : "07:49:01" , 
"departure_time" : "07:49:01" , 
"distance_traveled" : 40.467
} ], 
"2148" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:02:00" , 
"departure_time" : "17:04:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:19:22" , 
"departure_time" : "17:20:41" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "17:24:19" , 
"departure_time" : "17:25:18" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:26:59" , 
"departure_time" : "17:27:47" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "17:29:48" , 
"departure_time" : "17:29:51" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "17:31:03" , 
"departure_time" : "17:31:08" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "17:33:05" , 
"departure_time" : "17:34:00" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:36:55" , 
"departure_time" : "17:37:53" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "17:39:58" , 
"departure_time" : "17:40:25" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:48:27" , 
"departure_time" : "17:48:57" , 
"distance_traveled" : 20.0943
}, 
{ 
"stop_id" : 27,
"arrival_time" : "17:54:30" , 
"departure_time" : "17:55:44" , 
"distance_traveled" : 23.5203
}, 
{ 
"stop_id" : 77,
"arrival_time" : "17:58:14" , 
"departure_time" : "17:58:25" , 
"distance_traveled" : 25.5155
}, 
{ 
"stop_id" : 30,
"arrival_time" : "18:01:11" , 
"departure_time" : "18:02:44" , 
"distance_traveled" : 27.6809
}, 
{ 
"stop_id" : 92,
"arrival_time" : "18:06:33" , 
"departure_time" : "18:07:28" , 
"distance_traveled" : 29.7693
}, 
{ 
"stop_id" : 91,
"arrival_time" : "18:09:55" , 
"departure_time" : "18:11:25" , 
"distance_traveled" : 31.9998
}, 
{ 
"stop_id" : 94,
"arrival_time" : "18:17:30" , 
"departure_time" : "18:18:55" , 
"distance_traveled" : 35.6909
}, 
{ 
"stop_id" : 34,
"arrival_time" : "18:20:25" , 
"departure_time" : "18:21:47" , 
"distance_traveled" : 36.2672
}, 
{ 
"stop_id" : 35,
"arrival_time" : "18:29:22" , 
"departure_time" : "18:29:22" , 
"distance_traveled" : 40.4663
} ], 
"2149" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:38:00" , 
"departure_time" : "18:40:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:55:11" , 
"departure_time" : "18:56:16" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "19:01:05" , 
"departure_time" : "19:02:30" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "19:03:25" , 
"departure_time" : "19:04:52" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "19:06:27" , 
"departure_time" : "19:06:51" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "19:08:24" , 
"departure_time" : "19:09:47" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "19:11:23" , 
"departure_time" : "19:12:12" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "19:13:49" , 
"departure_time" : "19:13:51" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "19:16:02" , 
"departure_time" : "19:17:22" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "19:21:20" , 
"departure_time" : "19:21:28" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "19:23:08" , 
"departure_time" : "19:24:15" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "19:29:07" , 
"departure_time" : "19:29:35" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 27,
"arrival_time" : "19:34:28" , 
"departure_time" : "19:34:58" , 
"distance_traveled" : 23.521
}, 
{ 
"stop_id" : 77,
"arrival_time" : "19:38:30" , 
"departure_time" : "19:39:17" , 
"distance_traveled" : 25.5163
}, 
{ 
"stop_id" : 30,
"arrival_time" : "19:42:47" , 
"departure_time" : "19:43:46" , 
"distance_traveled" : 27.6816
}, 
{ 
"stop_id" : 92,
"arrival_time" : "19:46:59" , 
"departure_time" : "19:47:27" , 
"distance_traveled" : 29.7701
}, 
{ 
"stop_id" : 91,
"arrival_time" : "19:50:28" , 
"departure_time" : "19:51:49" , 
"distance_traveled" : 32.0006
}, 
{ 
"stop_id" : 94,
"arrival_time" : "19:58:21" , 
"departure_time" : "19:59:05" , 
"distance_traveled" : 35.6917
}, 
{ 
"stop_id" : 34,
"arrival_time" : "20:00:44" , 
"departure_time" : "20:01:37" , 
"distance_traveled" : 36.268
}, 
{ 
"stop_id" : 35,
"arrival_time" : "20:07:53" , 
"departure_time" : "20:07:53" , 
"distance_traveled" : 40.467
} ], 
"2150" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "15:55:00" , 
"departure_time" : "15:56:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:13:42" , 
"departure_time" : "16:14:23" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 140,
"arrival_time" : "16:22:41" , 
"departure_time" : "16:23:55" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "16:26:14" , 
"departure_time" : "16:26:58" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "16:28:44" , 
"departure_time" : "16:28:53" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:35:09" , 
"departure_time" : "16:35:57" , 
"distance_traveled" : 20.0949
}, 
{ 
"stop_id" : 27,
"arrival_time" : "16:41:48" , 
"departure_time" : "16:42:28" , 
"distance_traveled" : 23.5212
}, 
{ 
"stop_id" : 77,
"arrival_time" : "16:44:40" , 
"departure_time" : "16:46:02" , 
"distance_traveled" : 25.5165
}, 
{ 
"stop_id" : 30,
"arrival_time" : "16:49:22" , 
"departure_time" : "16:49:47" , 
"distance_traveled" : 27.6818
}, 
{ 
"stop_id" : 92,
"arrival_time" : "16:52:25" , 
"departure_time" : "16:53:51" , 
"distance_traveled" : 29.7703
}, 
{ 
"stop_id" : 91,
"arrival_time" : "16:57:26" , 
"departure_time" : "16:58:12" , 
"distance_traveled" : 32.0008
}, 
{ 
"stop_id" : 94,
"arrival_time" : "17:03:46" , 
"departure_time" : "17:05:17" , 
"distance_traveled" : 35.6919
}, 
{ 
"stop_id" : 34,
"arrival_time" : "17:07:31" , 
"departure_time" : "17:08:51" , 
"distance_traveled" : 36.2682
}, 
{ 
"stop_id" : 35,
"arrival_time" : "17:14:20" , 
"departure_time" : "17:14:30" , 
"distance_traveled" : 40.4672
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "17:20:10" , 
"departure_time" : "17:20:57" , 
"distance_traveled" : 45.415
}, 
{ 
"stop_id" : 67,
"arrival_time" : "17:26:47" , 
"departure_time" : "17:28:09" , 
"distance_traveled" : 47.8294
}, 
{ 
"stop_id" : 101,
"arrival_time" : "17:33:22" , 
"departure_time" : "17:34:54" , 
"distance_traveled" : 50.3013
}, 
{ 
"stop_id" : 93,
"arrival_time" : "17:37:32" , 
"departure_time" : "17:37:32" , 
"distance_traveled" : 52.5165
} ], 
"2151" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "08:02:00" , 
"departure_time" : "08:03:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:11:26" , 
"departure_time" : "08:12:44" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:21:18" , 
"departure_time" : "08:22:42" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "08:27:24" , 
"departure_time" : "08:28:02" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "08:28:38" , 
"departure_time" : "08:28:48" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "08:31:10" , 
"departure_time" : "08:31:32" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "08:34:22" , 
"departure_time" : "08:34:25" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 97,
"arrival_time" : "08:36:03" , 
"departure_time" : "08:37:22" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:40:19" , 
"departure_time" : "08:40:31" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "08:42:12" , 
"departure_time" : "08:43:43" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "08:47:31" , 
"departure_time" : "08:48:09" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "08:49:38" , 
"departure_time" : "08:49:49" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "08:55:11" , 
"departure_time" : "08:55:48" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "09:01:37" , 
"departure_time" : "09:02:12" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "09:05:35" , 
"departure_time" : "09:07:13" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "09:11:38" , 
"departure_time" : "09:13:00" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "09:15:22" , 
"departure_time" : "09:15:53" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "09:19:31" , 
"departure_time" : "09:20:03" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "09:27:32" , 
"departure_time" : "09:28:03" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "09:35:31" , 
"departure_time" : "09:35:31" , 
"distance_traveled" : 43.1006
} ], 
"2152" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "07:07:00" , 
"departure_time" : "07:07:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:16:23" , 
"departure_time" : "07:17:00" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:26:37" , 
"departure_time" : "07:27:00" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "07:32:23" , 
"departure_time" : "07:32:48" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "07:35:25" , 
"departure_time" : "07:36:36" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:41:11" , 
"departure_time" : "07:42:31" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:44:20" , 
"departure_time" : "07:45:20" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:48:00" , 
"departure_time" : "07:48:53" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:50:53" , 
"departure_time" : "07:51:21" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:55:28" , 
"departure_time" : "07:56:14" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "08:01:46" , 
"departure_time" : "08:03:24" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "08:06:38" , 
"departure_time" : "08:08:08" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "08:11:30" , 
"departure_time" : "08:13:01" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "08:15:31" , 
"departure_time" : "08:16:45" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "08:19:14" , 
"departure_time" : "08:20:10" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "08:25:56" , 
"departure_time" : "08:27:02" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "08:28:06" , 
"departure_time" : "08:28:56" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "08:35:50" , 
"departure_time" : "08:35:50" , 
"distance_traveled" : 43.1008
} ], 
"2153" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "22:13:00" , 
"departure_time" : "22:14:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:23:41" , 
"departure_time" : "22:23:46" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "22:32:05" , 
"departure_time" : "22:32:33" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "22:37:28" , 
"departure_time" : "22:37:49" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "22:40:21" , 
"departure_time" : "22:41:27" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "22:44:06" , 
"departure_time" : "22:44:31" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "22:45:25" , 
"departure_time" : "22:46:53" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 97,
"arrival_time" : "22:48:28" , 
"departure_time" : "22:50:05" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "22:51:37" , 
"departure_time" : "22:51:41" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "22:53:04" , 
"departure_time" : "22:53:52" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "22:57:48" , 
"departure_time" : "22:58:06" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "23:00:18" , 
"departure_time" : "23:01:23" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "23:06:05" , 
"departure_time" : "23:06:46" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "23:11:41" , 
"departure_time" : "23:12:26" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "23:15:45" , 
"departure_time" : "23:17:03" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "23:20:18" , 
"departure_time" : "23:21:49" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "23:24:31" , 
"departure_time" : "23:25:16" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "23:27:45" , 
"departure_time" : "23:28:47" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "23:36:02" , 
"departure_time" : "23:36:49" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "23:37:47" , 
"departure_time" : "23:38:47" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "23:46:00" , 
"departure_time" : "23:46:00" , 
"distance_traveled" : 43.1008
} ], 
"2154" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "10:04:00" , 
"departure_time" : "10:05:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:14:54" , 
"departure_time" : "10:15:25" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "10:23:31" , 
"departure_time" : "10:24:52" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "10:30:21" , 
"departure_time" : "10:31:57" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "10:33:36" , 
"departure_time" : "10:33:37" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 140,
"arrival_time" : "10:37:01" , 
"departure_time" : "10:37:58" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "10:40:57" , 
"departure_time" : "10:41:48" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "10:44:51" , 
"departure_time" : "10:45:49" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "10:47:58" , 
"departure_time" : "10:48:39" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "10:52:41" , 
"departure_time" : "10:54:16" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "10:58:35" , 
"departure_time" : "10:59:12" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "11:01:37" , 
"departure_time" : "11:02:08" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "11:05:31" , 
"departure_time" : "11:07:00" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "11:10:29" , 
"departure_time" : "11:12:06" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "11:14:37" , 
"departure_time" : "11:14:39" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "11:20:02" , 
"departure_time" : "11:20:55" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "11:23:53" , 
"departure_time" : "11:24:54" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "11:35:01" , 
"departure_time" : "11:35:01" , 
"distance_traveled" : 43.1008
} ], 
"2155" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "05:38:00" , 
"departure_time" : "05:40:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "05:57:09" , 
"departure_time" : "05:57:39" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "06:01:30" , 
"departure_time" : "06:01:50" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "06:04:20" , 
"departure_time" : "06:05:48" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "06:07:28" , 
"departure_time" : "06:08:37" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "06:09:09" , 
"departure_time" : "06:10:29" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "06:11:20" , 
"departure_time" : "06:11:48" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "06:13:28" , 
"departure_time" : "06:14:47" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "06:17:19" , 
"departure_time" : "06:17:28" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "06:19:09" , 
"departure_time" : "06:19:56" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "06:22:47" , 
"departure_time" : "06:23:49" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "06:29:02" , 
"departure_time" : "06:29:39" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 27,
"arrival_time" : "06:34:37" , 
"departure_time" : "06:36:14" , 
"distance_traveled" : 23.521
}, 
{ 
"stop_id" : 77,
"arrival_time" : "06:39:37" , 
"departure_time" : "06:41:07" , 
"distance_traveled" : 25.5163
}, 
{ 
"stop_id" : 30,
"arrival_time" : "06:43:30" , 
"departure_time" : "06:43:34" , 
"distance_traveled" : 27.6816
}, 
{ 
"stop_id" : 92,
"arrival_time" : "06:46:04" , 
"departure_time" : "06:46:21" , 
"distance_traveled" : 29.7701
}, 
{ 
"stop_id" : 91,
"arrival_time" : "06:51:17" , 
"departure_time" : "06:52:26" , 
"distance_traveled" : 32.0006
}, 
{ 
"stop_id" : 94,
"arrival_time" : "06:59:09" , 
"departure_time" : "07:00:28" , 
"distance_traveled" : 35.6917
}, 
{ 
"stop_id" : 34,
"arrival_time" : "07:02:19" , 
"departure_time" : "07:03:41" , 
"distance_traveled" : 36.268
}, 
{ 
"stop_id" : 35,
"arrival_time" : "07:09:22" , 
"departure_time" : "07:10:43" , 
"distance_traveled" : 40.467
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "07:18:21" , 
"departure_time" : "07:19:30" , 
"distance_traveled" : 45.4148
}, 
{ 
"stop_id" : 67,
"arrival_time" : "07:23:09" , 
"departure_time" : "07:24:11" , 
"distance_traveled" : 47.8292
}, 
{ 
"stop_id" : 101,
"arrival_time" : "07:29:02" , 
"departure_time" : "07:30:29" , 
"distance_traveled" : 50.3011
}, 
{ 
"stop_id" : 93,
"arrival_time" : "07:34:27" , 
"departure_time" : "07:35:19" , 
"distance_traveled" : 52.5163
}, 
{ 
"stop_id" : 54,
"arrival_time" : "07:48:52" , 
"departure_time" : "07:48:52" , 
"distance_traveled" : 59.9004
} ], 
"2156" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "13:51:00" , 
"departure_time" : "13:52:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:01:32" , 
"departure_time" : "14:02:52" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "14:12:20" , 
"departure_time" : "14:12:31" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "14:17:11" , 
"departure_time" : "14:17:52" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "14:20:41" , 
"departure_time" : "14:20:46" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 140,
"arrival_time" : "14:25:05" , 
"departure_time" : "14:25:52" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "14:28:47" , 
"departure_time" : "14:29:17" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "14:32:30" , 
"departure_time" : "14:32:35" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "14:36:05" , 
"departure_time" : "14:36:09" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "14:42:04" , 
"departure_time" : "14:43:33" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "14:49:29" , 
"departure_time" : "14:50:01" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "14:52:32" , 
"departure_time" : "14:53:08" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "14:57:36" , 
"departure_time" : "14:57:48" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "15:01:12" , 
"departure_time" : "15:01:32" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "15:06:20" , 
"departure_time" : "15:06:25" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "15:13:05" , 
"departure_time" : "15:13:46" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "15:16:41" , 
"departure_time" : "15:16:43" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "15:25:02" , 
"departure_time" : "15:25:02" , 
"distance_traveled" : 43.1008
} ], 
"2157" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "09:13:00" , 
"departure_time" : "09:13:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:31:36" , 
"departure_time" : "09:32:59" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "09:37:23" , 
"departure_time" : "09:38:56" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "09:39:33" , 
"departure_time" : "09:39:48" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "09:41:15" , 
"departure_time" : "09:42:51" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "09:44:36" , 
"departure_time" : "09:45:28" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "09:45:52" , 
"departure_time" : "09:46:38" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "09:48:46" , 
"departure_time" : "09:49:32" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "09:51:46" , 
"departure_time" : "09:51:51" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "09:54:05" , 
"departure_time" : "09:54:47" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "09:58:42" , 
"departure_time" : "09:59:03" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "10:04:21" , 
"departure_time" : "10:04:51" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 27,
"arrival_time" : "10:10:30" , 
"departure_time" : "10:11:14" , 
"distance_traveled" : 23.521
}, 
{ 
"stop_id" : 77,
"arrival_time" : "10:14:44" , 
"departure_time" : "10:15:40" , 
"distance_traveled" : 25.5163
}, 
{ 
"stop_id" : 30,
"arrival_time" : "10:18:56" , 
"departure_time" : "10:19:35" , 
"distance_traveled" : 27.6816
}, 
{ 
"stop_id" : 92,
"arrival_time" : "10:23:39" , 
"departure_time" : "10:23:47" , 
"distance_traveled" : 29.7701
}, 
{ 
"stop_id" : 91,
"arrival_time" : "10:29:08" , 
"departure_time" : "10:29:26" , 
"distance_traveled" : 32.0006
}, 
{ 
"stop_id" : 94,
"arrival_time" : "10:36:18" , 
"departure_time" : "10:36:58" , 
"distance_traveled" : 35.6917
}, 
{ 
"stop_id" : 34,
"arrival_time" : "10:39:40" , 
"departure_time" : "10:40:47" , 
"distance_traveled" : 36.268
}, 
{ 
"stop_id" : 35,
"arrival_time" : "10:47:07" , 
"departure_time" : "10:47:34" , 
"distance_traveled" : 40.467
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "10:53:27" , 
"departure_time" : "10:54:20" , 
"distance_traveled" : 45.4148
}, 
{ 
"stop_id" : 67,
"arrival_time" : "10:58:53" , 
"departure_time" : "10:59:22" , 
"distance_traveled" : 47.8292
}, 
{ 
"stop_id" : 101,
"arrival_time" : "11:05:29" , 
"departure_time" : "11:06:40" , 
"distance_traveled" : 50.3011
}, 
{ 
"stop_id" : 93,
"arrival_time" : "11:10:11" , 
"departure_time" : "11:10:30" , 
"distance_traveled" : 52.5163
}, 
{ 
"stop_id" : 54,
"arrival_time" : "11:28:19" , 
"departure_time" : "11:28:19" , 
"distance_traveled" : 59.9004
} ], 
"2158" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "19:34:00" , 
"departure_time" : "19:34:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:52:30" , 
"departure_time" : "19:52:49" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "19:57:19" , 
"departure_time" : "19:58:32" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "20:00:13" , 
"departure_time" : "20:01:02" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "20:02:49" , 
"departure_time" : "20:04:16" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "20:05:27" , 
"departure_time" : "20:05:49" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "20:07:22" , 
"departure_time" : "20:08:53" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "20:10:31" , 
"departure_time" : "20:11:08" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "20:12:37" , 
"departure_time" : "20:13:06" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "20:17:29" , 
"departure_time" : "20:17:32" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "20:20:03" , 
"departure_time" : "20:20:10" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "20:25:07" , 
"departure_time" : "20:26:15" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 27,
"arrival_time" : "20:32:08" , 
"departure_time" : "20:32:51" , 
"distance_traveled" : 23.521
}, 
{ 
"stop_id" : 77,
"arrival_time" : "20:35:43" , 
"departure_time" : "20:36:46" , 
"distance_traveled" : 25.5163
}, 
{ 
"stop_id" : 30,
"arrival_time" : "20:39:03" , 
"departure_time" : "20:39:23" , 
"distance_traveled" : 27.6816
}, 
{ 
"stop_id" : 92,
"arrival_time" : "20:42:20" , 
"departure_time" : "20:42:51" , 
"distance_traveled" : 29.7701
}, 
{ 
"stop_id" : 91,
"arrival_time" : "20:47:31" , 
"departure_time" : "20:48:14" , 
"distance_traveled" : 32.0006
}, 
{ 
"stop_id" : 34,
"arrival_time" : "20:55:43" , 
"departure_time" : "20:57:10" , 
"distance_traveled" : 36.2678
}, 
{ 
"stop_id" : 35,
"arrival_time" : "21:02:27" , 
"departure_time" : "21:02:27" , 
"distance_traveled" : 40.4669
} ], 
"2159" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "06:07:00" , 
"departure_time" : "06:09:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:17:05" , 
"departure_time" : "06:17:41" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:25:36" , 
"departure_time" : "06:26:56" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 140,
"arrival_time" : "06:37:20" , 
"departure_time" : "06:37:40" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "06:39:20" , 
"departure_time" : "06:39:55" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "06:43:35" , 
"departure_time" : "06:44:08" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 145,
"arrival_time" : "06:51:33" , 
"departure_time" : "06:51:33" , 
"distance_traveled" : 22.7286
} ], 
"2160" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:01:00" , 
"departure_time" : "18:02:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:17:47" , 
"departure_time" : "18:19:00" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:28:13" , 
"departure_time" : "18:29:05" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:30:52" , 
"departure_time" : "18:31:07" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:35:15" , 
"departure_time" : "18:35:25" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:43:10" , 
"departure_time" : "18:44:33" , 
"distance_traveled" : 20.0949
}, 
{ 
"stop_id" : 27,
"arrival_time" : "18:50:23" , 
"departure_time" : "18:51:16" , 
"distance_traveled" : 23.5212
}, 
{ 
"stop_id" : 77,
"arrival_time" : "18:53:53" , 
"departure_time" : "18:54:58" , 
"distance_traveled" : 25.5165
}, 
{ 
"stop_id" : 30,
"arrival_time" : "18:59:05" , 
"departure_time" : "19:00:30" , 
"distance_traveled" : 27.6818
}, 
{ 
"stop_id" : 92,
"arrival_time" : "19:03:25" , 
"departure_time" : "19:04:05" , 
"distance_traveled" : 29.7703
}, 
{ 
"stop_id" : 91,
"arrival_time" : "19:06:40" , 
"departure_time" : "19:07:57" , 
"distance_traveled" : 32.0008
}, 
{ 
"stop_id" : 94,
"arrival_time" : "19:15:17" , 
"departure_time" : "19:15:35" , 
"distance_traveled" : 35.6919
}, 
{ 
"stop_id" : 34,
"arrival_time" : "19:17:18" , 
"departure_time" : "19:18:54" , 
"distance_traveled" : 36.2682
}, 
{ 
"stop_id" : 35,
"arrival_time" : "19:26:36" , 
"departure_time" : "19:27:01" , 
"distance_traveled" : 40.4672
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "19:33:25" , 
"departure_time" : "19:33:43" , 
"distance_traveled" : 45.415
}, 
{ 
"stop_id" : 67,
"arrival_time" : "19:38:18" , 
"departure_time" : "19:39:19" , 
"distance_traveled" : 47.8294
}, 
{ 
"stop_id" : 101,
"arrival_time" : "19:46:01" , 
"departure_time" : "19:47:21" , 
"distance_traveled" : 50.3013
}, 
{ 
"stop_id" : 93,
"arrival_time" : "19:50:20" , 
"departure_time" : "19:50:28" , 
"distance_traveled" : 52.5165
}, 
{ 
"stop_id" : 54,
"arrival_time" : "20:04:08" , 
"departure_time" : "20:04:08" , 
"distance_traveled" : 59.9006
} ], 
"2161" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:22:00" , 
"departure_time" : "15:22:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:39:49" , 
"departure_time" : "15:40:07" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 23,
"arrival_time" : "15:45:18" , 
"departure_time" : "15:45:31" , 
"distance_traveled" : 13.1979
}, 
{ 
"stop_id" : 112,
"arrival_time" : "15:48:13" , 
"departure_time" : "15:49:00" , 
"distance_traveled" : 14.0973
}, 
{ 
"stop_id" : 140,
"arrival_time" : "15:53:47" , 
"departure_time" : "15:54:47" , 
"distance_traveled" : 16.4955
}, 
{ 
"stop_id" : 81,
"arrival_time" : "15:57:00" , 
"departure_time" : "15:58:13" , 
"distance_traveled" : 17.7778
}, 
{ 
"stop_id" : 87,
"arrival_time" : "16:01:13" , 
"departure_time" : "16:01:25" , 
"distance_traveled" : 19.3866
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:07:12" , 
"departure_time" : "16:07:12" , 
"distance_traveled" : 22.7288
} ], 
"2162" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "14:32:00" , 
"departure_time" : "14:32:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:42:12" , 
"departure_time" : "14:43:28" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "14:52:16" , 
"departure_time" : "14:52:30" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "14:57:14" , 
"departure_time" : "14:57:18" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "15:00:04" , 
"departure_time" : "15:00:05" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 97,
"arrival_time" : "15:05:01" , 
"departure_time" : "15:06:11" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "15:08:10" , 
"departure_time" : "15:08:31" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "15:10:21" , 
"departure_time" : "15:11:25" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "15:15:04" , 
"departure_time" : "15:16:35" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "15:18:31" , 
"departure_time" : "15:19:22" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "15:22:51" , 
"departure_time" : "15:23:07" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "15:28:16" , 
"departure_time" : "15:28:38" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "15:32:22" , 
"departure_time" : "15:33:48" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "15:37:26" , 
"departure_time" : "15:38:54" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "15:41:28" , 
"departure_time" : "15:42:00" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "15:45:32" , 
"departure_time" : "15:46:58" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "15:53:26" , 
"departure_time" : "15:53:52" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "15:55:26" , 
"departure_time" : "15:56:58" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "16:06:32" , 
"departure_time" : "16:06:32" , 
"distance_traveled" : 43.1008
} ], 
"2163" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:18:00" , 
"departure_time" : "19:21:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:36:30" , 
"departure_time" : "19:38:10" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 23,
"arrival_time" : "19:43:40" , 
"departure_time" : "19:44:20" , 
"distance_traveled" : 13.1979
}, 
{ 
"stop_id" : 112,
"arrival_time" : "19:45:40" , 
"departure_time" : "19:45:59" , 
"distance_traveled" : 14.0973
}, 
{ 
"stop_id" : 140,
"arrival_time" : "19:51:19" , 
"departure_time" : "19:52:45" , 
"distance_traveled" : 16.4955
}, 
{ 
"stop_id" : 81,
"arrival_time" : "19:56:26" , 
"departure_time" : "19:56:40" , 
"distance_traveled" : 17.7778
}, 
{ 
"stop_id" : 87,
"arrival_time" : "19:59:14" , 
"departure_time" : "19:59:49" , 
"distance_traveled" : 19.3866
}, 
{ 
"stop_id" : 145,
"arrival_time" : "20:07:35" , 
"departure_time" : "20:07:35" , 
"distance_traveled" : 22.7288
} ], 
"2164" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:51:00" , 
"departure_time" : "20:51:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:01:06" , 
"departure_time" : "21:02:00" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "21:10:54" , 
"departure_time" : "21:11:49" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "21:17:55" , 
"departure_time" : "21:18:54" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "21:20:59" , 
"departure_time" : "21:22:20" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 140,
"arrival_time" : "21:26:21" , 
"departure_time" : "21:27:23" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "21:29:02" , 
"departure_time" : "21:30:22" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "21:33:20" , 
"departure_time" : "21:33:49" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "21:36:29" , 
"departure_time" : "21:37:55" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "21:43:26" , 
"departure_time" : "21:44:39" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "21:49:13" , 
"departure_time" : "21:49:52" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "21:52:39" , 
"departure_time" : "21:53:54" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "21:58:15" , 
"departure_time" : "21:59:31" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "22:02:16" , 
"departure_time" : "22:03:24" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "22:06:08" , 
"departure_time" : "22:06:33" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "22:12:25" , 
"departure_time" : "22:12:52" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "22:15:27" , 
"departure_time" : "22:15:47" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "22:22:20" , 
"departure_time" : "22:22:20" , 
"distance_traveled" : 43.1008
} ], 
"2165" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:18:00" , 
"departure_time" : "18:18:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 23,
"arrival_time" : "18:40:36" , 
"departure_time" : "18:40:59" , 
"distance_traveled" : 13.1746
}, 
{ 
"stop_id" : 112,
"arrival_time" : "18:43:23" , 
"departure_time" : "18:43:46" , 
"distance_traveled" : 14.0741
}, 
{ 
"stop_id" : 97,
"arrival_time" : "18:47:23" , 
"departure_time" : "18:47:29" , 
"distance_traveled" : 15.7097
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:49:06" , 
"departure_time" : "18:50:19" , 
"distance_traveled" : 16.4722
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:54:13" , 
"departure_time" : "18:55:04" , 
"distance_traveled" : 17.7545
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:57:51" , 
"departure_time" : "18:58:44" , 
"distance_traveled" : 19.3633
}, 
{ 
"stop_id" : 136,
"arrival_time" : "19:01:53" , 
"departure_time" : "19:02:54" , 
"distance_traveled" : 20.4377
}, 
{ 
"stop_id" : 145,
"arrival_time" : "19:08:01" , 
"departure_time" : "19:08:01" , 
"distance_traveled" : 22.7053
} ], 
"2166" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "06:18:00" , 
"departure_time" : "06:19:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:36:57" , 
"departure_time" : "06:37:21" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "06:41:24" , 
"departure_time" : "06:41:30" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "06:43:06" , 
"departure_time" : "06:43:36" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "06:46:30" , 
"departure_time" : "06:47:35" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "06:50:05" , 
"departure_time" : "06:50:15" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "06:51:10" , 
"departure_time" : "06:51:19" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "06:53:09" , 
"departure_time" : "06:53:44" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "06:56:35" , 
"departure_time" : "06:57:48" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:01:13" , 
"departure_time" : "07:02:01" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:03:48" , 
"departure_time" : "07:05:26" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:09:38" , 
"departure_time" : "07:10:13" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 27,
"arrival_time" : "07:14:35" , 
"departure_time" : "07:15:17" , 
"distance_traveled" : 23.521
}, 
{ 
"stop_id" : 77,
"arrival_time" : "07:18:42" , 
"departure_time" : "07:19:36" , 
"distance_traveled" : 25.5163
}, 
{ 
"stop_id" : 30,
"arrival_time" : "07:22:54" , 
"departure_time" : "07:24:00" , 
"distance_traveled" : 27.6816
}, 
{ 
"stop_id" : 92,
"arrival_time" : "07:27:06" , 
"departure_time" : "07:28:08" , 
"distance_traveled" : 29.7701
}, 
{ 
"stop_id" : 91,
"arrival_time" : "07:31:02" , 
"departure_time" : "07:31:16" , 
"distance_traveled" : 32.0006
}, 
{ 
"stop_id" : 94,
"arrival_time" : "07:37:14" , 
"departure_time" : "07:37:19" , 
"distance_traveled" : 35.6917
}, 
{ 
"stop_id" : 34,
"arrival_time" : "07:40:05" , 
"departure_time" : "07:40:59" , 
"distance_traveled" : 36.268
}, 
{ 
"stop_id" : 35,
"arrival_time" : "07:48:54" , 
"departure_time" : "07:48:54" , 
"distance_traveled" : 40.467
} ], 
"2167" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:50:00" , 
"departure_time" : "18:51:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:59:50" , 
"departure_time" : "19:00:46" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:09:56" , 
"departure_time" : "19:11:30" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "19:17:34" , 
"departure_time" : "19:18:38" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "19:20:04" , 
"departure_time" : "19:20:16" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 140,
"arrival_time" : "19:24:12" , 
"departure_time" : "19:24:40" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "19:28:28" , 
"departure_time" : "19:29:22" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "19:33:54" , 
"departure_time" : "19:33:58" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 145,
"arrival_time" : "19:41:04" , 
"departure_time" : "19:41:04" , 
"distance_traveled" : 22.7286
} ], 
"2168" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:38:00" , 
"departure_time" : "18:39:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:55:33" , 
"departure_time" : "18:56:55" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "19:01:22" , 
"departure_time" : "19:01:33" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "19:02:11" , 
"departure_time" : "19:02:50" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "19:05:39" , 
"departure_time" : "19:06:52" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "19:09:13" , 
"departure_time" : "19:10:18" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "19:11:05" , 
"departure_time" : "19:11:59" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "19:13:54" , 
"departure_time" : "19:14:15" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "19:16:21" , 
"departure_time" : "19:17:32" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "19:21:11" , 
"departure_time" : "19:22:26" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "19:24:15" , 
"departure_time" : "19:25:05" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "19:28:50" , 
"departure_time" : "19:30:01" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 27,
"arrival_time" : "19:35:11" , 
"departure_time" : "19:35:37" , 
"distance_traveled" : 23.521
}, 
{ 
"stop_id" : 77,
"arrival_time" : "19:38:26" , 
"departure_time" : "19:39:47" , 
"distance_traveled" : 25.5163
}, 
{ 
"stop_id" : 30,
"arrival_time" : "19:43:21" , 
"departure_time" : "19:43:29" , 
"distance_traveled" : 27.6816
}, 
{ 
"stop_id" : 92,
"arrival_time" : "19:46:08" , 
"departure_time" : "19:46:37" , 
"distance_traveled" : 29.7701
}, 
{ 
"stop_id" : 91,
"arrival_time" : "19:50:29" , 
"departure_time" : "19:51:03" , 
"distance_traveled" : 32.0006
}, 
{ 
"stop_id" : 94,
"arrival_time" : "19:57:34" , 
"departure_time" : "19:57:50" , 
"distance_traveled" : 35.6917
}, 
{ 
"stop_id" : 34,
"arrival_time" : "20:00:16" , 
"departure_time" : "20:01:16" , 
"distance_traveled" : 36.268
}, 
{ 
"stop_id" : 35,
"arrival_time" : "20:08:00" , 
"departure_time" : "20:08:00" , 
"distance_traveled" : 40.467
} ], 
"2169" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "08:02:00" , 
"departure_time" : "08:03:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:11:28" , 
"departure_time" : "08:12:39" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:21:11" , 
"departure_time" : "08:22:28" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "08:27:17" , 
"departure_time" : "08:27:20" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "08:28:03" , 
"departure_time" : "08:29:11" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "08:32:08" , 
"departure_time" : "08:32:25" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "08:34:17" , 
"departure_time" : "08:34:59" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 97,
"arrival_time" : "08:36:42" , 
"departure_time" : "08:37:57" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:40:15" , 
"departure_time" : "08:41:50" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "08:43:35" , 
"departure_time" : "08:44:07" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "08:46:32" , 
"departure_time" : "08:47:19" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "08:49:47" , 
"departure_time" : "08:49:54" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "08:55:07" , 
"departure_time" : "08:56:26" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "09:02:19" , 
"departure_time" : "09:03:11" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "09:05:52" , 
"departure_time" : "09:06:37" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "09:10:45" , 
"departure_time" : "09:12:15" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "09:15:30" , 
"departure_time" : "09:16:54" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "09:20:24" , 
"departure_time" : "09:20:34" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "09:27:10" , 
"departure_time" : "09:27:36" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "09:35:26" , 
"departure_time" : "09:35:26" , 
"distance_traveled" : 43.1006
} ], 
"2170" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "22:13:00" , 
"departure_time" : "22:13:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:23:09" , 
"departure_time" : "22:24:33" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "22:33:24" , 
"departure_time" : "22:34:08" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "22:37:44" , 
"departure_time" : "22:39:03" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "22:41:19" , 
"departure_time" : "22:42:13" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "22:43:54" , 
"departure_time" : "22:44:16" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "22:45:22" , 
"departure_time" : "22:45:57" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 97,
"arrival_time" : "22:47:35" , 
"departure_time" : "22:47:41" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "22:50:06" , 
"departure_time" : "22:50:13" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "22:53:07" , 
"departure_time" : "22:54:08" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "22:58:01" , 
"departure_time" : "22:59:36" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "23:01:35" , 
"departure_time" : "23:01:37" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "23:05:02" , 
"departure_time" : "23:06:31" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "23:12:29" , 
"departure_time" : "23:12:49" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "23:15:20" , 
"departure_time" : "23:15:54" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "23:19:34" , 
"departure_time" : "23:20:36" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "23:24:02" , 
"departure_time" : "23:24:12" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "23:27:10" , 
"departure_time" : "23:28:04" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "23:35:54" , 
"departure_time" : "23:36:02" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "23:37:08" , 
"departure_time" : "23:37:24" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "23:45:16" , 
"departure_time" : "23:45:16" , 
"distance_traveled" : 43.1008
} ], 
"2171" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "05:38:00" , 
"departure_time" : "05:39:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "05:57:09" , 
"departure_time" : "05:57:28" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "06:01:19" , 
"departure_time" : "06:02:32" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "06:05:13" , 
"departure_time" : "06:05:53" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "06:06:40" , 
"departure_time" : "06:08:12" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "06:09:32" , 
"departure_time" : "06:10:59" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "06:11:27" , 
"departure_time" : "06:11:53" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "06:13:26" , 
"departure_time" : "06:14:48" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "06:17:22" , 
"departure_time" : "06:17:56" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "06:19:34" , 
"departure_time" : "06:19:51" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "06:22:17" , 
"departure_time" : "06:23:45" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "06:29:28" , 
"departure_time" : "06:30:37" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 27,
"arrival_time" : "06:35:09" , 
"departure_time" : "06:35:31" , 
"distance_traveled" : 23.521
}, 
{ 
"stop_id" : 77,
"arrival_time" : "06:38:22" , 
"departure_time" : "06:40:01" , 
"distance_traveled" : 25.5163
}, 
{ 
"stop_id" : 30,
"arrival_time" : "06:43:39" , 
"departure_time" : "06:44:10" , 
"distance_traveled" : 27.6816
}, 
{ 
"stop_id" : 92,
"arrival_time" : "06:46:31" , 
"departure_time" : "06:47:54" , 
"distance_traveled" : 29.7701
}, 
{ 
"stop_id" : 91,
"arrival_time" : "06:52:23" , 
"departure_time" : "06:53:57" , 
"distance_traveled" : 32.0006
}, 
{ 
"stop_id" : 94,
"arrival_time" : "06:59:34" , 
"departure_time" : "07:00:03" , 
"distance_traveled" : 35.6917
}, 
{ 
"stop_id" : 34,
"arrival_time" : "07:01:29" , 
"departure_time" : "07:01:55" , 
"distance_traveled" : 36.268
}, 
{ 
"stop_id" : 35,
"arrival_time" : "07:08:26" , 
"departure_time" : "07:09:21" , 
"distance_traveled" : 40.467
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "07:17:55" , 
"departure_time" : "07:18:47" , 
"distance_traveled" : 45.4148
}, 
{ 
"stop_id" : 67,
"arrival_time" : "07:22:52" , 
"departure_time" : "07:23:47" , 
"distance_traveled" : 47.8292
}, 
{ 
"stop_id" : 101,
"arrival_time" : "07:28:55" , 
"departure_time" : "07:29:45" , 
"distance_traveled" : 50.3011
}, 
{ 
"stop_id" : 93,
"arrival_time" : "07:33:50" , 
"departure_time" : "07:34:11" , 
"distance_traveled" : 52.5163
}, 
{ 
"stop_id" : 54,
"arrival_time" : "07:48:21" , 
"departure_time" : "07:48:21" , 
"distance_traveled" : 59.9004
} ], 
"2172" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "09:13:00" , 
"departure_time" : "09:14:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:31:52" , 
"departure_time" : "09:33:16" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "09:37:24" , 
"departure_time" : "09:37:34" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "09:38:10" , 
"departure_time" : "09:38:44" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "09:41:34" , 
"departure_time" : "09:43:01" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "09:44:27" , 
"departure_time" : "09:45:55" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "09:46:28" , 
"departure_time" : "09:46:45" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "09:48:17" , 
"departure_time" : "09:49:01" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "09:51:44" , 
"departure_time" : "09:52:22" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "09:54:38" , 
"departure_time" : "09:55:40" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "09:59:02" , 
"departure_time" : "09:59:44" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "10:04:42" , 
"departure_time" : "10:05:07" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 27,
"arrival_time" : "10:10:25" , 
"departure_time" : "10:11:36" , 
"distance_traveled" : 23.521
}, 
{ 
"stop_id" : 77,
"arrival_time" : "10:15:11" , 
"departure_time" : "10:16:35" , 
"distance_traveled" : 25.5163
}, 
{ 
"stop_id" : 30,
"arrival_time" : "10:19:24" , 
"departure_time" : "10:19:54" , 
"distance_traveled" : 27.6816
}, 
{ 
"stop_id" : 92,
"arrival_time" : "10:23:30" , 
"departure_time" : "10:23:50" , 
"distance_traveled" : 29.7701
}, 
{ 
"stop_id" : 91,
"arrival_time" : "10:29:20" , 
"departure_time" : "10:30:10" , 
"distance_traveled" : 32.0006
}, 
{ 
"stop_id" : 94,
"arrival_time" : "10:36:50" , 
"departure_time" : "10:37:17" , 
"distance_traveled" : 35.6917
}, 
{ 
"stop_id" : 34,
"arrival_time" : "10:39:27" , 
"departure_time" : "10:40:35" , 
"distance_traveled" : 36.268
}, 
{ 
"stop_id" : 35,
"arrival_time" : "10:47:08" , 
"departure_time" : "10:48:33" , 
"distance_traveled" : 40.467
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "10:54:25" , 
"departure_time" : "10:56:03" , 
"distance_traveled" : 45.4148
}, 
{ 
"stop_id" : 67,
"arrival_time" : "10:59:38" , 
"departure_time" : "11:00:19" , 
"distance_traveled" : 47.8292
}, 
{ 
"stop_id" : 101,
"arrival_time" : "11:05:41" , 
"departure_time" : "11:06:21" , 
"distance_traveled" : 50.3011
}, 
{ 
"stop_id" : 93,
"arrival_time" : "11:09:40" , 
"departure_time" : "11:09:55" , 
"distance_traveled" : 52.5163
}, 
{ 
"stop_id" : 54,
"arrival_time" : "11:28:15" , 
"departure_time" : "11:28:15" , 
"distance_traveled" : 59.9004
} ], 
"2173" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "06:07:00" , 
"departure_time" : "06:07:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:16:32" , 
"departure_time" : "06:17:19" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:25:47" , 
"departure_time" : "06:26:09" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 140,
"arrival_time" : "06:36:22" , 
"departure_time" : "06:37:03" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "06:39:41" , 
"departure_time" : "06:40:13" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "06:43:32" , 
"departure_time" : "06:43:42" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 145,
"arrival_time" : "06:51:10" , 
"departure_time" : "06:51:10" , 
"distance_traveled" : 22.7286
} ], 
"2174" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:22:00" , 
"departure_time" : "15:23:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:39:57" , 
"departure_time" : "15:40:18" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 23,
"arrival_time" : "15:45:21" , 
"departure_time" : "15:45:30" , 
"distance_traveled" : 13.1979
}, 
{ 
"stop_id" : 112,
"arrival_time" : "15:48:09" , 
"departure_time" : "15:49:17" , 
"distance_traveled" : 14.0973
}, 
{ 
"stop_id" : 140,
"arrival_time" : "15:54:08" , 
"departure_time" : "15:54:29" , 
"distance_traveled" : 16.4955
}, 
{ 
"stop_id" : 81,
"arrival_time" : "15:56:21" , 
"departure_time" : "15:57:48" , 
"distance_traveled" : 17.7778
}, 
{ 
"stop_id" : 87,
"arrival_time" : "16:01:27" , 
"departure_time" : "16:01:49" , 
"distance_traveled" : 19.3866
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:07:22" , 
"departure_time" : "16:07:22" , 
"distance_traveled" : 22.7288
} ], 
"2175" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:18:00" , 
"departure_time" : "19:19:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:36:32" , 
"departure_time" : "19:37:42" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 23,
"arrival_time" : "19:43:10" , 
"departure_time" : "19:44:40" , 
"distance_traveled" : 13.1979
}, 
{ 
"stop_id" : 112,
"arrival_time" : "19:46:30" , 
"departure_time" : "19:47:22" , 
"distance_traveled" : 14.0973
}, 
{ 
"stop_id" : 140,
"arrival_time" : "19:51:52" , 
"departure_time" : "19:52:29" , 
"distance_traveled" : 16.4955
}, 
{ 
"stop_id" : 81,
"arrival_time" : "19:55:37" , 
"departure_time" : "19:55:50" , 
"distance_traveled" : 17.7778
}, 
{ 
"stop_id" : 87,
"arrival_time" : "19:59:13" , 
"departure_time" : "19:59:58" , 
"distance_traveled" : 19.3866
}, 
{ 
"stop_id" : 145,
"arrival_time" : "20:07:45" , 
"departure_time" : "20:07:45" , 
"distance_traveled" : 22.7288
} ], 
"2176" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:18:00" , 
"departure_time" : "18:20:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 23,
"arrival_time" : "18:41:29" , 
"departure_time" : "18:42:15" , 
"distance_traveled" : 13.1746
}, 
{ 
"stop_id" : 112,
"arrival_time" : "18:43:46" , 
"departure_time" : "18:44:50" , 
"distance_traveled" : 14.0741
}, 
{ 
"stop_id" : 97,
"arrival_time" : "18:48:04" , 
"departure_time" : "18:48:17" , 
"distance_traveled" : 15.7097
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:49:13" , 
"departure_time" : "18:49:26" , 
"distance_traveled" : 16.4722
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:53:13" , 
"departure_time" : "18:53:49" , 
"distance_traveled" : 17.7545
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:57:36" , 
"departure_time" : "18:58:23" , 
"distance_traveled" : 19.3633
}, 
{ 
"stop_id" : 136,
"arrival_time" : "19:01:47" , 
"departure_time" : "19:02:24" , 
"distance_traveled" : 20.4377
}, 
{ 
"stop_id" : 145,
"arrival_time" : "19:07:37" , 
"departure_time" : "19:07:37" , 
"distance_traveled" : 22.7053
} ], 
"2177" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:50:00" , 
"departure_time" : "18:50:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:59:14" , 
"departure_time" : "19:00:52" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:10:38" , 
"departure_time" : "19:10:53" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 23,
"arrival_time" : "19:16:15" , 
"departure_time" : "19:17:39" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "19:20:24" , 
"departure_time" : "19:20:25" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 140,
"arrival_time" : "19:24:01" , 
"departure_time" : "19:24:40" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "19:28:39" , 
"departure_time" : "19:30:01" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "19:34:22" , 
"departure_time" : "19:35:06" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 145,
"arrival_time" : "19:41:44" , 
"departure_time" : "19:41:44" , 
"distance_traveled" : 22.7286
} ], 
"2178" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "07:09:00" , 
"departure_time" : "07:11:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:26:34" , 
"departure_time" : "07:27:02" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 23,
"arrival_time" : "07:31:28" , 
"departure_time" : "07:32:00" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "07:34:32" , 
"departure_time" : "07:35:00" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "07:36:28" , 
"departure_time" : "07:36:29" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "07:38:01" , 
"departure_time" : "07:39:24" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:42:23" , 
"departure_time" : "07:42:30" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:44:07" , 
"departure_time" : "07:44:39" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:48:32" , 
"departure_time" : "07:48:44" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:51:12" , 
"departure_time" : "07:52:35" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:58:23" , 
"departure_time" : "07:58:23" , 
"distance_traveled" : 20.0947
} ], 
"2179" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "04:55:00" , 
"departure_time" : "04:57:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "05:12:06" , 
"departure_time" : "05:12:27" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "05:16:21" , 
"departure_time" : "05:16:37" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "05:18:16" , 
"departure_time" : "05:19:37" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "05:22:21" , 
"departure_time" : "05:23:43" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "05:24:22" , 
"departure_time" : "05:24:49" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "05:25:27" , 
"departure_time" : "05:26:33" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "05:29:06" , 
"departure_time" : "05:30:18" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "05:32:12" , 
"departure_time" : "05:33:28" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "05:35:16" , 
"departure_time" : "05:36:46" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "05:38:30" , 
"departure_time" : "05:39:02" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "05:42:32" , 
"departure_time" : "05:42:32" , 
"distance_traveled" : 20.0947
} ], 
"2180" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "06:36:00" , 
"departure_time" : "06:36:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:52:17" , 
"departure_time" : "06:53:07" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "06:57:50" , 
"departure_time" : "06:58:19" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "06:59:29" , 
"departure_time" : "07:00:53" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "07:03:24" , 
"departure_time" : "07:04:22" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "07:04:58" , 
"departure_time" : "07:05:41" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "07:06:43" , 
"departure_time" : "07:06:56" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:09:13" , 
"departure_time" : "07:10:07" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:12:54" , 
"departure_time" : "07:13:37" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:15:43" , 
"departure_time" : "07:16:16" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:18:33" , 
"departure_time" : "07:18:44" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:25:11" , 
"departure_time" : "07:25:11" , 
"distance_traveled" : 20.0947
} ], 
"2181" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "15:50:00" , 
"departure_time" : "15:51:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:07:09" , 
"departure_time" : "16:08:23" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "16:12:14" , 
"departure_time" : "16:13:39" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "16:14:25" , 
"departure_time" : "16:15:22" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "16:16:57" , 
"departure_time" : "16:17:23" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "16:19:26" , 
"departure_time" : "16:21:04" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "16:22:38" , 
"departure_time" : "16:24:10" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "16:25:32" , 
"departure_time" : "16:25:46" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "16:27:14" , 
"departure_time" : "16:28:11" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "16:31:57" , 
"departure_time" : "16:33:12" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "16:35:15" , 
"departure_time" : "16:35:42" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:39:27" , 
"departure_time" : "16:39:27" , 
"distance_traveled" : 20.0947
} ], 
"2182" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:50:00" , 
"departure_time" : "16:51:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:07:25" , 
"departure_time" : "17:07:56" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "17:11:31" , 
"departure_time" : "17:12:02" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:13:31" , 
"departure_time" : "17:14:26" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "17:16:55" , 
"departure_time" : "17:17:31" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "17:19:36" , 
"departure_time" : "17:19:46" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "17:21:10" , 
"departure_time" : "17:22:49" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:25:39" , 
"departure_time" : "17:27:19" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "17:28:40" , 
"departure_time" : "17:30:13" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "17:32:33" , 
"departure_time" : "17:33:31" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "17:34:58" , 
"departure_time" : "17:36:00" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:40:02" , 
"departure_time" : "17:40:02" , 
"distance_traveled" : 20.0947
} ], 
"2183" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:40:00" , 
"departure_time" : "17:42:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:57:26" , 
"departure_time" : "17:59:03" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "18:03:37" , 
"departure_time" : "18:04:58" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "18:05:21" , 
"departure_time" : "18:05:46" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "18:07:25" , 
"departure_time" : "18:07:38" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "18:10:13" , 
"departure_time" : "18:10:53" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "18:12:40" , 
"departure_time" : "18:12:47" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:15:07" , 
"departure_time" : "18:15:56" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:18:49" , 
"departure_time" : "18:20:02" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:23:13" , 
"departure_time" : "18:23:40" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "18:25:27" , 
"departure_time" : "18:26:29" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:31:02" , 
"departure_time" : "18:31:02" , 
"distance_traveled" : 20.0947
} ], 
"2184" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:35:00" , 
"departure_time" : "17:36:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:51:31" , 
"departure_time" : "17:51:43" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:58:12" , 
"departure_time" : "17:58:51" , 
"distance_traveled" : 13.1979
}, 
{ 
"stop_id" : 112,
"arrival_time" : "18:01:39" , 
"departure_time" : "18:01:42" , 
"distance_traveled" : 14.0973
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:06:03" , 
"departure_time" : "18:06:20" , 
"distance_traveled" : 16.4955
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:09:17" , 
"departure_time" : "18:09:46" , 
"distance_traveled" : 17.7778
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:13:29" , 
"departure_time" : "18:14:05" , 
"distance_traveled" : 19.3866
}, 
{ 
"stop_id" : 136,
"arrival_time" : "18:17:36" , 
"departure_time" : "18:18:22" , 
"distance_traveled" : 20.461
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:23:46" , 
"departure_time" : "18:24:19" , 
"distance_traveled" : 22.7286
}, 
{ 
"stop_id" : 27,
"arrival_time" : "18:29:33" , 
"departure_time" : "18:29:58" , 
"distance_traveled" : 26.1549
}, 
{ 
"stop_id" : 77,
"arrival_time" : "18:33:25" , 
"departure_time" : "18:34:13" , 
"distance_traveled" : 28.1502
}, 
{ 
"stop_id" : 30,
"arrival_time" : "18:38:48" , 
"departure_time" : "18:39:57" , 
"distance_traveled" : 30.3155
}, 
{ 
"stop_id" : 92,
"arrival_time" : "18:43:09" , 
"departure_time" : "18:44:34" , 
"distance_traveled" : 32.404
}, 
{ 
"stop_id" : 91,
"arrival_time" : "18:48:25" , 
"departure_time" : "18:48:58" , 
"distance_traveled" : 34.6345
}, 
{ 
"stop_id" : 94,
"arrival_time" : "18:54:33" , 
"departure_time" : "18:55:02" , 
"distance_traveled" : 38.3256
}, 
{ 
"stop_id" : 34,
"arrival_time" : "18:58:29" , 
"departure_time" : "19:00:02" , 
"distance_traveled" : 38.9019
}, 
{ 
"stop_id" : 35,
"arrival_time" : "19:10:33" , 
"departure_time" : "19:10:33" , 
"distance_traveled" : 43.1009
} ], 
"2185" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "06:11:00" , 
"departure_time" : "06:13:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:20:38" , 
"departure_time" : "06:21:31" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:30:53" , 
"departure_time" : "06:31:28" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "06:36:35" , 
"departure_time" : "06:37:21" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "06:39:46" , 
"departure_time" : "06:41:20" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "06:43:34" , 
"departure_time" : "06:45:13" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "06:45:39" , 
"departure_time" : "06:46:48" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 140,
"arrival_time" : "06:49:09" , 
"departure_time" : "06:50:17" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "06:52:08" , 
"departure_time" : "06:52:48" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "06:56:40" , 
"departure_time" : "06:58:07" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:01:27" , 
"departure_time" : "07:01:54" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:08:27" , 
"departure_time" : "07:09:53" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "07:16:26" , 
"departure_time" : "07:17:35" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "07:20:09" , 
"departure_time" : "07:21:24" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "07:25:15" , 
"departure_time" : "07:26:37" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "07:29:22" , 
"departure_time" : "07:30:15" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "07:33:53" , 
"departure_time" : "07:35:18" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "07:41:25" , 
"departure_time" : "07:42:02" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "07:42:37" , 
"departure_time" : "07:43:33" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "07:56:56" , 
"departure_time" : "07:56:56" , 
"distance_traveled" : 43.1008
} ], 
"2186" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:30:00" , 
"departure_time" : "17:31:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:46:51" , 
"departure_time" : "17:47:23" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:52:32" , 
"departure_time" : "17:54:05" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "17:55:33" , 
"departure_time" : "17:56:14" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:59:41" , 
"departure_time" : "18:01:16" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:03:35" , 
"departure_time" : "18:04:39" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:07:04" , 
"departure_time" : "18:08:01" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "18:10:57" , 
"departure_time" : "18:12:06" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:18:09" , 
"departure_time" : "18:18:59" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 27,
"arrival_time" : "18:23:50" , 
"departure_time" : "18:24:27" , 
"distance_traveled" : 23.521
}, 
{ 
"stop_id" : 77,
"arrival_time" : "18:27:37" , 
"departure_time" : "18:27:38" , 
"distance_traveled" : 25.5163
}, 
{ 
"stop_id" : 30,
"arrival_time" : "18:32:01" , 
"departure_time" : "18:33:22" , 
"distance_traveled" : 27.6816
}, 
{ 
"stop_id" : 92,
"arrival_time" : "18:37:21" , 
"departure_time" : "18:38:10" , 
"distance_traveled" : 29.7701
}, 
{ 
"stop_id" : 91,
"arrival_time" : "18:41:49" , 
"departure_time" : "18:43:12" , 
"distance_traveled" : 32.0006
}, 
{ 
"stop_id" : 94,
"arrival_time" : "18:49:23" , 
"departure_time" : "18:50:36" , 
"distance_traveled" : 35.6917
}, 
{ 
"stop_id" : 34,
"arrival_time" : "18:53:13" , 
"departure_time" : "18:53:58" , 
"distance_traveled" : 36.268
}, 
{ 
"stop_id" : 35,
"arrival_time" : "19:00:45" , 
"departure_time" : "19:00:54" , 
"distance_traveled" : 40.467
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "19:08:09" , 
"departure_time" : "19:09:06" , 
"distance_traveled" : 45.4148
}, 
{ 
"stop_id" : 67,
"arrival_time" : "19:13:57" , 
"departure_time" : "19:15:11" , 
"distance_traveled" : 47.8292
}, 
{ 
"stop_id" : 101,
"arrival_time" : "19:21:14" , 
"departure_time" : "19:22:47" , 
"distance_traveled" : 50.3011
}, 
{ 
"stop_id" : 93,
"arrival_time" : "19:25:33" , 
"departure_time" : "19:27:10" , 
"distance_traveled" : 52.5163
}, 
{ 
"stop_id" : 54,
"arrival_time" : "19:40:37" , 
"departure_time" : "19:40:37" , 
"distance_traveled" : 59.9004
} ], 
"2187" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:30:00" , 
"departure_time" : "18:32:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:49:48" , 
"departure_time" : "18:50:32" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 23,
"arrival_time" : "18:55:44" , 
"departure_time" : "18:57:09" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "18:59:25" , 
"departure_time" : "19:00:43" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 140,
"arrival_time" : "19:04:18" , 
"departure_time" : "19:04:51" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "19:06:33" , 
"departure_time" : "19:07:47" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "19:11:14" , 
"departure_time" : "19:12:34" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "19:15:20" , 
"departure_time" : "19:16:55" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "19:21:35" , 
"departure_time" : "19:23:02" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 27,
"arrival_time" : "19:27:27" , 
"departure_time" : "19:28:31" , 
"distance_traveled" : 23.521
}, 
{ 
"stop_id" : 77,
"arrival_time" : "19:31:04" , 
"departure_time" : "19:32:23" , 
"distance_traveled" : 25.5163
}, 
{ 
"stop_id" : 30,
"arrival_time" : "19:36:19" , 
"departure_time" : "19:36:28" , 
"distance_traveled" : 27.6816
}, 
{ 
"stop_id" : 92,
"arrival_time" : "19:39:09" , 
"departure_time" : "19:40:27" , 
"distance_traveled" : 29.7701
}, 
{ 
"stop_id" : 91,
"arrival_time" : "19:45:18" , 
"departure_time" : "19:46:58" , 
"distance_traveled" : 32.0006
}, 
{ 
"stop_id" : 94,
"arrival_time" : "19:52:40" , 
"departure_time" : "19:53:42" , 
"distance_traveled" : 35.6917
}, 
{ 
"stop_id" : 34,
"arrival_time" : "19:55:02" , 
"departure_time" : "19:55:18" , 
"distance_traveled" : 36.268
}, 
{ 
"stop_id" : 35,
"arrival_time" : "20:03:16" , 
"departure_time" : "20:03:41" , 
"distance_traveled" : 40.467
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "20:11:25" , 
"departure_time" : "20:11:40" , 
"distance_traveled" : 45.4148
}, 
{ 
"stop_id" : 67,
"arrival_time" : "20:18:15" , 
"departure_time" : "20:19:00" , 
"distance_traveled" : 47.8292
}, 
{ 
"stop_id" : 101,
"arrival_time" : "20:25:45" , 
"departure_time" : "20:26:10" , 
"distance_traveled" : 50.3011
}, 
{ 
"stop_id" : 93,
"arrival_time" : "20:29:25" , 
"departure_time" : "20:30:46" , 
"distance_traveled" : 52.5163
}, 
{ 
"stop_id" : 54,
"arrival_time" : "20:46:21" , 
"departure_time" : "20:46:21" , 
"distance_traveled" : 59.9004
} ], 
"2188" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "10:44:00" , 
"departure_time" : "10:45:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "11:02:36" , 
"departure_time" : "11:02:39" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "11:07:03" , 
"departure_time" : "11:08:21" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "11:10:18" , 
"departure_time" : "11:11:33" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "11:13:15" , 
"departure_time" : "11:13:47" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "11:14:32" , 
"departure_time" : "11:16:08" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "11:17:36" , 
"departure_time" : "11:17:51" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "11:19:15" , 
"departure_time" : "11:19:31" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "11:22:16" , 
"departure_time" : "11:23:51" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "11:26:35" , 
"departure_time" : "11:27:39" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "11:30:04" , 
"departure_time" : "11:30:37" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "11:35:33" , 
"departure_time" : "11:35:48" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 27,
"arrival_time" : "11:41:15" , 
"departure_time" : "11:42:19" , 
"distance_traveled" : 23.521
}, 
{ 
"stop_id" : 77,
"arrival_time" : "11:46:04" , 
"departure_time" : "11:46:46" , 
"distance_traveled" : 25.5163
}, 
{ 
"stop_id" : 30,
"arrival_time" : "11:49:42" , 
"departure_time" : "11:50:14" , 
"distance_traveled" : 27.6816
}, 
{ 
"stop_id" : 92,
"arrival_time" : "11:53:32" , 
"departure_time" : "11:54:38" , 
"distance_traveled" : 29.7701
}, 
{ 
"stop_id" : 91,
"arrival_time" : "11:58:06" , 
"departure_time" : "11:59:39" , 
"distance_traveled" : 32.0006
}, 
{ 
"stop_id" : 94,
"arrival_time" : "12:05:33" , 
"departure_time" : "12:05:40" , 
"distance_traveled" : 35.6917
}, 
{ 
"stop_id" : 34,
"arrival_time" : "12:07:07" , 
"departure_time" : "12:08:13" , 
"distance_traveled" : 36.268
}, 
{ 
"stop_id" : 35,
"arrival_time" : "12:15:06" , 
"departure_time" : "12:15:56" , 
"distance_traveled" : 40.467
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "12:21:50" , 
"departure_time" : "12:22:26" , 
"distance_traveled" : 45.4148
}, 
{ 
"stop_id" : 67,
"arrival_time" : "12:26:36" , 
"departure_time" : "12:26:50" , 
"distance_traveled" : 47.8292
}, 
{ 
"stop_id" : 101,
"arrival_time" : "12:33:14" , 
"departure_time" : "12:33:39" , 
"distance_traveled" : 50.3011
}, 
{ 
"stop_id" : 93,
"arrival_time" : "12:37:25" , 
"departure_time" : "12:38:54" , 
"distance_traveled" : 52.5163
}, 
{ 
"stop_id" : 54,
"arrival_time" : "12:57:29" , 
"departure_time" : "12:57:29" , 
"distance_traveled" : 59.9004
} ], 
"2189" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "13:33:00" , 
"departure_time" : "13:35:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "13:52:53" , 
"departure_time" : "13:53:01" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "13:57:08" , 
"departure_time" : "13:57:27" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "13:59:19" , 
"departure_time" : "14:00:18" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "14:02:59" , 
"departure_time" : "14:04:27" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "14:05:28" , 
"departure_time" : "14:06:59" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "14:07:31" , 
"departure_time" : "14:08:09" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "14:08:38" , 
"departure_time" : "14:10:17" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "14:12:39" , 
"departure_time" : "14:12:49" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "14:16:10" , 
"departure_time" : "14:17:41" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "14:20:31" , 
"departure_time" : "14:21:21" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "14:25:50" , 
"departure_time" : "14:26:34" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 27,
"arrival_time" : "14:31:44" , 
"departure_time" : "14:32:41" , 
"distance_traveled" : 23.521
}, 
{ 
"stop_id" : 77,
"arrival_time" : "14:35:57" , 
"departure_time" : "14:36:02" , 
"distance_traveled" : 25.5163
}, 
{ 
"stop_id" : 30,
"arrival_time" : "14:39:05" , 
"departure_time" : "14:39:16" , 
"distance_traveled" : 27.6816
}, 
{ 
"stop_id" : 92,
"arrival_time" : "14:43:11" , 
"departure_time" : "14:44:44" , 
"distance_traveled" : 29.7701
}, 
{ 
"stop_id" : 91,
"arrival_time" : "14:48:33" , 
"departure_time" : "14:49:26" , 
"distance_traveled" : 32.0006
}, 
{ 
"stop_id" : 94,
"arrival_time" : "14:54:53" , 
"departure_time" : "14:56:22" , 
"distance_traveled" : 35.6917
}, 
{ 
"stop_id" : 34,
"arrival_time" : "14:58:29" , 
"departure_time" : "14:59:33" , 
"distance_traveled" : 36.268
}, 
{ 
"stop_id" : 35,
"arrival_time" : "15:05:04" , 
"departure_time" : "15:05:35" , 
"distance_traveled" : 40.467
}, 
{ 
"stop_id" : 39472,
"arrival_time" : "15:11:31" , 
"departure_time" : "15:12:02" , 
"distance_traveled" : 45.4148
}, 
{ 
"stop_id" : 67,
"arrival_time" : "15:17:31" , 
"departure_time" : "15:18:50" , 
"distance_traveled" : 47.8292
}, 
{ 
"stop_id" : 101,
"arrival_time" : "15:24:19" , 
"departure_time" : "15:24:45" , 
"distance_traveled" : 50.3011
}, 
{ 
"stop_id" : 93,
"arrival_time" : "15:28:26" , 
"departure_time" : "15:29:53" , 
"distance_traveled" : 52.5163
}, 
{ 
"stop_id" : 54,
"arrival_time" : "15:45:27" , 
"departure_time" : "15:45:27" , 
"distance_traveled" : 59.9004
} ], 
"2190" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "24:34:00" , 
"departure_time" : "24:36:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:43:53" , 
"departure_time" : "24:44:08" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "24:53:15" , 
"departure_time" : "24:53:29" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "24:58:14" , 
"departure_time" : "24:59:24" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "25:02:10" , 
"departure_time" : "25:02:27" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "25:04:17" , 
"departure_time" : "25:05:31" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "25:07:14" , 
"departure_time" : "25:07:17" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 97,
"arrival_time" : "25:09:03" , 
"departure_time" : "25:09:18" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "25:11:15" , 
"departure_time" : "25:11:29" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "25:14:14" , 
"departure_time" : "25:14:44" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "25:18:30" , 
"departure_time" : "25:18:45" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "25:22:15" , 
"departure_time" : "25:22:30" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "25:28:15" , 
"departure_time" : "25:29:44" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "25:35:29" , 
"departure_time" : "25:36:41" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "25:39:12" , 
"departure_time" : "25:40:27" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "25:44:15" , 
"departure_time" : "25:45:06" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "25:47:51" , 
"departure_time" : "25:48:42" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "25:51:51" , 
"departure_time" : "25:52:08" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "25:59:17" , 
"departure_time" : "25:59:53" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "26:13:36" , 
"departure_time" : "26:13:36" , 
"distance_traveled" : 43.1006
} ], 
"2191" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "25:19:00" , 
"departure_time" : "25:21:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "25:29:32" , 
"departure_time" : "25:30:48" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "25:39:16" , 
"departure_time" : "25:40:03" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "25:43:47" , 
"departure_time" : "25:43:56" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "25:45:09" , 
"departure_time" : "25:46:18" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "25:49:09" , 
"departure_time" : "25:49:54" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "25:50:45" , 
"departure_time" : "25:52:02" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 97,
"arrival_time" : "25:54:17" , 
"departure_time" : "25:54:23" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "25:55:06" , 
"departure_time" : "25:55:32" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "25:58:26" , 
"departure_time" : "25:59:08" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "26:02:42" , 
"departure_time" : "26:03:00" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "26:06:18" , 
"departure_time" : "26:07:30" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "26:14:12" , 
"departure_time" : "26:15:00" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "26:20:48" , 
"departure_time" : "26:21:48" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "26:25:00" , 
"departure_time" : "26:26:07" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "26:30:07" , 
"departure_time" : "26:30:19" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "26:33:12" , 
"departure_time" : "26:33:59" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "26:37:47" , 
"departure_time" : "26:38:20" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "26:44:33" , 
"departure_time" : "26:45:31" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "26:47:58" , 
"departure_time" : "26:49:37" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "27:03:39" , 
"departure_time" : "27:03:39" , 
"distance_traveled" : 43.1008
} ], 
"2192" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "09:11:00" , 
"departure_time" : "09:14:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:21:28" , 
"departure_time" : "09:22:42" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:31:14" , 
"departure_time" : "09:32:39" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "09:37:25" , 
"departure_time" : "09:38:44" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "09:40:19" , 
"departure_time" : "09:40:53" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "09:42:34" , 
"departure_time" : "09:43:34" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "09:45:00" , 
"departure_time" : "09:46:13" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 140,
"arrival_time" : "09:49:13" , 
"departure_time" : "09:49:57" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "09:51:44" , 
"departure_time" : "09:51:59" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "09:56:15" , 
"departure_time" : "09:57:11" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "10:00:56" , 
"departure_time" : "10:02:31" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "10:09:35" , 
"departure_time" : "10:10:32" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "10:15:57" , 
"departure_time" : "10:17:16" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "10:20:19" , 
"departure_time" : "10:21:29" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "10:25:10" , 
"departure_time" : "10:26:32" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "10:29:22" , 
"departure_time" : "10:30:30" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "10:34:08" , 
"departure_time" : "10:35:30" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "10:41:22" , 
"departure_time" : "10:42:10" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "10:54:48" , 
"departure_time" : "10:54:48" , 
"distance_traveled" : 43.1006
} ], 
"2193" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "11:11:00" , 
"departure_time" : "11:11:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:20:08" , 
"departure_time" : "11:20:22" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "11:30:14" , 
"departure_time" : "11:30:27" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "11:36:13" , 
"departure_time" : "11:37:33" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "11:40:20" , 
"departure_time" : "11:40:25" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "11:42:05" , 
"departure_time" : "11:42:39" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "11:44:34" , 
"departure_time" : "11:45:12" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 140,
"arrival_time" : "11:48:38" , 
"departure_time" : "11:48:49" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "11:51:11" , 
"departure_time" : "11:51:59" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "11:56:48" , 
"departure_time" : "11:58:18" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "12:01:30" , 
"departure_time" : "12:01:43" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "12:08:13" , 
"departure_time" : "12:09:07" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "12:15:54" , 
"departure_time" : "12:17:09" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "12:20:15" , 
"departure_time" : "12:21:28" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "12:25:13" , 
"departure_time" : "12:26:14" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "12:29:01" , 
"departure_time" : "12:30:35" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "12:34:34" , 
"departure_time" : "12:35:51" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "12:41:17" , 
"departure_time" : "12:42:07" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "12:54:50" , 
"departure_time" : "12:54:50" , 
"distance_traveled" : 43.1006
} ], 
"2194" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:11:00" , 
"departure_time" : "15:12:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:21:01" , 
"departure_time" : "15:22:34" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:32:33" , 
"departure_time" : "15:33:45" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "15:37:12" , 
"departure_time" : "15:37:40" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "15:39:28" , 
"departure_time" : "15:40:08" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "15:42:40" , 
"departure_time" : "15:43:02" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "15:44:22" , 
"departure_time" : "15:45:26" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 140,
"arrival_time" : "15:49:04" , 
"departure_time" : "15:50:25" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "15:52:21" , 
"departure_time" : "15:53:28" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "15:57:07" , 
"departure_time" : "15:58:43" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "16:01:36" , 
"departure_time" : "16:02:46" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:09:10" , 
"departure_time" : "16:09:39" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "16:15:29" , 
"departure_time" : "16:17:08" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "16:20:39" , 
"departure_time" : "16:21:18" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "16:24:39" , 
"departure_time" : "16:25:18" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "16:28:39" , 
"departure_time" : "16:30:04" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "16:34:25" , 
"departure_time" : "16:35:40" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "16:41:15" , 
"departure_time" : "16:42:30" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "16:55:15" , 
"departure_time" : "16:55:15" , 
"distance_traveled" : 43.1006
} ], 
"2195" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "21:11:00" , 
"departure_time" : "21:12:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:20:19" , 
"departure_time" : "21:21:02" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "21:30:43" , 
"departure_time" : "21:30:56" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "21:36:13" , 
"departure_time" : "21:36:58" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "21:39:45" , 
"departure_time" : "21:40:15" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "21:42:30" , 
"departure_time" : "21:42:34" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "21:44:04" , 
"departure_time" : "21:44:13" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 140,
"arrival_time" : "21:48:09" , 
"departure_time" : "21:48:43" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "21:51:34" , 
"departure_time" : "21:52:24" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "21:56:50" , 
"departure_time" : "21:58:21" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "22:01:31" , 
"departure_time" : "22:02:50" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "22:09:19" , 
"departure_time" : "22:10:07" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "22:15:48" , 
"departure_time" : "22:16:24" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "22:19:36" , 
"departure_time" : "22:20:39" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "22:25:03" , 
"departure_time" : "22:25:38" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "22:28:35" , 
"departure_time" : "22:29:15" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "22:33:40" , 
"departure_time" : "22:35:09" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "22:41:29" , 
"departure_time" : "22:41:45" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "22:54:16" , 
"departure_time" : "22:54:16" , 
"distance_traveled" : 43.1006
} ], 
"2196" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "23:11:00" , 
"departure_time" : "23:11:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:20:27" , 
"departure_time" : "23:21:27" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "23:31:00" , 
"departure_time" : "23:32:33" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "23:37:33" , 
"departure_time" : "23:37:34" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "23:39:01" , 
"departure_time" : "23:40:04" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "23:43:03" , 
"departure_time" : "23:43:49" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "23:44:46" , 
"departure_time" : "23:45:31" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 140,
"arrival_time" : "23:48:45" , 
"departure_time" : "23:49:36" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "23:51:51" , 
"departure_time" : "23:53:16" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "23:57:25" , 
"departure_time" : "23:58:20" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "24:00:55" , 
"departure_time" : "24:01:54" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "24:08:59" , 
"departure_time" : "24:09:10" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "24:15:11" , 
"departure_time" : "24:15:57" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "24:19:46" , 
"departure_time" : "24:20:01" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "24:24:15" , 
"departure_time" : "24:24:52" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "24:28:37" , 
"departure_time" : "24:29:06" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "24:33:29" , 
"departure_time" : "24:34:28" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "24:40:59" , 
"departure_time" : "24:41:30" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "24:54:31" , 
"departure_time" : "24:54:31" , 
"distance_traveled" : 43.1006
} ], 
"2197" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "08:11:00" , 
"departure_time" : "08:12:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:21:23" , 
"departure_time" : "08:22:29" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:31:06" , 
"departure_time" : "08:31:40" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "08:36:34" , 
"departure_time" : "08:37:21" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "08:39:47" , 
"departure_time" : "08:39:57" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "08:42:10" , 
"departure_time" : "08:42:41" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 97,
"arrival_time" : "08:46:31" , 
"departure_time" : "08:47:14" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:48:43" , 
"departure_time" : "08:49:41" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "08:51:58" , 
"departure_time" : "08:53:31" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "08:57:33" , 
"departure_time" : "08:58:05" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "09:00:32" , 
"departure_time" : "09:01:28" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "09:08:56" , 
"departure_time" : "09:10:01" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "09:16:05" , 
"departure_time" : "09:16:36" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "09:19:31" , 
"departure_time" : "09:19:35" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "09:24:04" , 
"departure_time" : "09:25:08" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "09:29:04" , 
"departure_time" : "09:30:07" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "09:34:03" , 
"departure_time" : "09:34:50" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "09:40:47" , 
"departure_time" : "09:42:04" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "09:55:17" , 
"departure_time" : "09:55:17" , 
"distance_traveled" : 43.1006
} ], 
"2198" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "12:11:00" , 
"departure_time" : "12:13:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:21:14" , 
"departure_time" : "12:21:49" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "12:30:35" , 
"departure_time" : "12:31:24" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "12:36:49" , 
"departure_time" : "12:37:23" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "12:39:34" , 
"departure_time" : "12:40:53" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "12:43:19" , 
"departure_time" : "12:44:52" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 97,
"arrival_time" : "12:47:33" , 
"departure_time" : "12:48:02" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "12:48:29" , 
"departure_time" : "12:48:48" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "12:51:19" , 
"departure_time" : "12:51:36" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "12:56:17" , 
"departure_time" : "12:56:42" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "13:00:25" , 
"departure_time" : "13:01:49" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "13:09:24" , 
"departure_time" : "13:10:06" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "13:15:42" , 
"departure_time" : "13:16:08" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "13:19:26" , 
"departure_time" : "13:20:19" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "13:24:53" , 
"departure_time" : "13:26:29" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "13:29:36" , 
"departure_time" : "13:31:13" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "13:34:37" , 
"departure_time" : "13:35:29" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "13:40:52" , 
"departure_time" : "13:40:59" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "13:54:07" , 
"departure_time" : "13:54:07" , 
"distance_traveled" : 43.1006
} ], 
"2199" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "14:11:00" , 
"departure_time" : "14:12:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:21:36" , 
"departure_time" : "14:22:18" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "14:30:42" , 
"departure_time" : "14:31:45" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "14:37:03" , 
"departure_time" : "14:37:11" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "14:39:08" , 
"departure_time" : "14:39:19" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "14:42:11" , 
"departure_time" : "14:42:40" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 97,
"arrival_time" : "14:46:29" , 
"departure_time" : "14:46:50" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "14:48:21" , 
"departure_time" : "14:48:49" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "14:51:28" , 
"departure_time" : "14:52:03" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "14:56:35" , 
"departure_time" : "14:56:49" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "15:00:14" , 
"departure_time" : "15:00:27" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "15:08:13" , 
"departure_time" : "15:09:25" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "15:16:12" , 
"departure_time" : "15:17:10" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "15:19:58" , 
"departure_time" : "15:20:32" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "15:24:34" , 
"departure_time" : "15:25:02" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "15:28:28" , 
"departure_time" : "15:29:18" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "15:33:50" , 
"departure_time" : "15:34:32" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "15:40:42" , 
"departure_time" : "15:41:59" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "15:55:17" , 
"departure_time" : "15:55:17" , 
"distance_traveled" : 43.1006
} ], 
"2200" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:11:00" , 
"departure_time" : "20:12:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:20:40" , 
"departure_time" : "20:21:14" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "20:30:34" , 
"departure_time" : "20:31:59" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "20:37:25" , 
"departure_time" : "20:37:42" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "20:39:17" , 
"departure_time" : "20:40:40" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "20:43:23" , 
"departure_time" : "20:44:37" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 97,
"arrival_time" : "20:47:14" , 
"departure_time" : "20:48:19" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "20:49:05" , 
"departure_time" : "20:50:01" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "20:51:56" , 
"departure_time" : "20:53:16" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "20:57:20" , 
"departure_time" : "20:57:47" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "21:00:27" , 
"departure_time" : "21:01:36" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "21:09:09" , 
"departure_time" : "21:09:23" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "21:15:14" , 
"departure_time" : "21:15:53" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "21:19:39" , 
"departure_time" : "21:20:54" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "21:25:15" , 
"departure_time" : "21:25:55" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "21:28:40" , 
"departure_time" : "21:29:39" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "21:33:59" , 
"departure_time" : "21:35:39" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 34,
"arrival_time" : "21:41:40" , 
"departure_time" : "21:43:04" , 
"distance_traveled" : 38.9015
}, 
{ 
"stop_id" : 35,
"arrival_time" : "21:55:24" , 
"departure_time" : "21:55:24" , 
"distance_traveled" : 43.1006
} ], 
"2201" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "07:11:00" , 
"departure_time" : "07:13:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:21:33" , 
"departure_time" : "07:22:57" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:31:24" , 
"departure_time" : "07:32:46" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "07:37:22" , 
"departure_time" : "07:38:02" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "07:39:40" , 
"departure_time" : "07:40:43" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "07:43:03" , 
"departure_time" : "07:44:26" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "07:45:23" , 
"departure_time" : "07:47:01" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:49:38" , 
"departure_time" : "07:51:17" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:52:39" , 
"departure_time" : "07:54:02" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:57:23" , 
"departure_time" : "07:58:19" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "08:00:56" , 
"departure_time" : "08:01:26" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "08:08:30" , 
"departure_time" : "08:08:45" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "08:15:15" , 
"departure_time" : "08:16:18" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "08:20:03" , 
"departure_time" : "08:20:40" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "08:24:37" , 
"departure_time" : "08:26:11" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "08:29:34" , 
"departure_time" : "08:30:20" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "08:33:46" , 
"departure_time" : "08:35:06" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "08:41:20" , 
"departure_time" : "08:42:52" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "08:43:32" , 
"departure_time" : "08:44:41" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "08:57:09" , 
"departure_time" : "08:57:09" , 
"distance_traveled" : 43.1008
} ], 
"2202" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "13:11:00" , 
"departure_time" : "13:12:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:20:16" , 
"departure_time" : "13:20:44" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "13:30:28" , 
"departure_time" : "13:31:07" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "13:36:39" , 
"departure_time" : "13:37:29" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "13:39:50" , 
"departure_time" : "13:41:06" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "13:43:16" , 
"departure_time" : "13:43:43" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "13:44:27" , 
"departure_time" : "13:44:50" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 140,
"arrival_time" : "13:48:23" , 
"departure_time" : "13:49:07" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "13:51:44" , 
"departure_time" : "13:52:29" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "13:56:45" , 
"departure_time" : "13:57:52" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "14:01:07" , 
"departure_time" : "14:02:25" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "14:09:18" , 
"departure_time" : "14:09:41" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "14:15:23" , 
"departure_time" : "14:16:48" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "14:20:25" , 
"departure_time" : "14:20:51" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "14:24:26" , 
"departure_time" : "14:25:10" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "14:28:44" , 
"departure_time" : "14:29:12" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "14:33:28" , 
"departure_time" : "14:35:04" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "14:41:36" , 
"departure_time" : "14:42:57" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "14:43:21" , 
"departure_time" : "14:44:08" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "14:56:47" , 
"departure_time" : "14:56:47" , 
"distance_traveled" : 43.1008
} ], 
"2203" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:11:00" , 
"departure_time" : "17:12:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:20:54" , 
"departure_time" : "17:22:04" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:31:10" , 
"departure_time" : "17:31:21" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "17:36:11" , 
"departure_time" : "17:37:03" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:39:52" , 
"departure_time" : "17:40:43" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "17:42:51" , 
"departure_time" : "17:43:52" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "17:45:01" , 
"departure_time" : "17:46:09" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:49:08" , 
"departure_time" : "17:49:42" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "17:51:34" , 
"departure_time" : "17:52:02" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "17:56:28" , 
"departure_time" : "17:57:52" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "18:01:24" , 
"departure_time" : "18:01:25" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:08:01" , 
"departure_time" : "18:08:43" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "18:15:42" , 
"departure_time" : "18:16:51" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "18:20:09" , 
"departure_time" : "18:21:10" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "18:25:01" , 
"departure_time" : "18:25:28" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "18:28:27" , 
"departure_time" : "18:29:07" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "18:33:40" , 
"departure_time" : "18:34:42" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "18:41:02" , 
"departure_time" : "18:41:32" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "18:42:30" , 
"departure_time" : "18:42:57" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "18:56:27" , 
"departure_time" : "18:56:27" , 
"distance_traveled" : 43.1008
} ], 
"2204" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:11:00" , 
"departure_time" : "19:12:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:20:38" , 
"departure_time" : "19:21:48" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:31:10" , 
"departure_time" : "19:32:20" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "19:37:10" , 
"departure_time" : "19:37:16" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "19:39:06" , 
"departure_time" : "19:40:44" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "19:43:38" , 
"departure_time" : "19:45:07" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 61,
"arrival_time" : "19:45:29" , 
"departure_time" : "19:46:35" , 
"distance_traveled" : 14.8047
}, 
{ 
"stop_id" : 140,
"arrival_time" : "19:49:06" , 
"departure_time" : "19:50:33" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "19:52:27" , 
"departure_time" : "19:52:30" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "19:56:03" , 
"departure_time" : "19:57:34" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "20:01:31" , 
"departure_time" : "20:01:48" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "20:08:17" , 
"departure_time" : "20:09:26" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "20:16:09" , 
"departure_time" : "20:17:10" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "20:20:01" , 
"departure_time" : "20:21:38" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "20:25:37" , 
"departure_time" : "20:26:40" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "20:29:03" , 
"departure_time" : "20:29:24" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "20:33:21" , 
"departure_time" : "20:34:50" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "20:41:29" , 
"departure_time" : "20:43:03" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "20:43:34" , 
"departure_time" : "20:43:45" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "20:56:11" , 
"departure_time" : "20:56:11" , 
"distance_traveled" : 43.1008
} ], 
"2205" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "10:11:00" , 
"departure_time" : "10:12:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:21:20" , 
"departure_time" : "10:22:25" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "10:31:05" , 
"departure_time" : "10:32:32" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "10:37:27" , 
"departure_time" : "10:38:56" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "10:40:29" , 
"departure_time" : "10:42:05" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "10:43:36" , 
"departure_time" : "10:44:19" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 97,
"arrival_time" : "10:46:43" , 
"departure_time" : "10:46:58" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "10:48:15" , 
"departure_time" : "10:49:23" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "10:52:08" , 
"departure_time" : "10:53:03" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "10:56:55" , 
"departure_time" : "10:58:05" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "11:01:10" , 
"departure_time" : "11:01:36" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "11:08:26" , 
"departure_time" : "11:09:21" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "11:15:55" , 
"departure_time" : "11:17:11" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "11:20:16" , 
"departure_time" : "11:21:18" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "11:25:02" , 
"departure_time" : "11:26:19" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "11:29:17" , 
"departure_time" : "11:30:54" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "11:34:37" , 
"departure_time" : "11:35:22" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "11:40:45" , 
"departure_time" : "11:42:12" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "11:43:27" , 
"departure_time" : "11:43:35" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "11:56:08" , 
"departure_time" : "11:56:08" , 
"distance_traveled" : 43.1008
} ], 
"2206" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:11:00" , 
"departure_time" : "16:12:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:21:14" , 
"departure_time" : "16:22:48" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:31:34" , 
"departure_time" : "16:33:02" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "16:37:28" , 
"departure_time" : "16:37:57" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "16:39:29" , 
"departure_time" : "16:40:11" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "16:42:42" , 
"departure_time" : "16:43:00" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 97,
"arrival_time" : "16:46:18" , 
"departure_time" : "16:46:59" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "16:48:41" , 
"departure_time" : "16:48:42" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "16:51:01" , 
"departure_time" : "16:52:28" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "16:57:27" , 
"departure_time" : "16:57:46" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "17:00:19" , 
"departure_time" : "17:00:25" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:08:06" , 
"departure_time" : "17:08:35" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "17:15:29" , 
"departure_time" : "17:15:36" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "17:19:07" , 
"departure_time" : "17:20:10" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "17:25:03" , 
"departure_time" : "17:26:27" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "17:29:24" , 
"departure_time" : "17:30:25" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "17:34:01" , 
"departure_time" : "17:34:56" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "17:40:55" , 
"departure_time" : "17:41:31" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "17:42:36" , 
"departure_time" : "17:44:07" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "17:57:31" , 
"departure_time" : "17:57:31" , 
"distance_traveled" : 43.1008
} ], 
"2207" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:11:00" , 
"departure_time" : "18:12:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:20:08" , 
"departure_time" : "18:20:33" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:30:25" , 
"departure_time" : "18:31:40" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "18:37:15" , 
"departure_time" : "18:38:35" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "18:40:20" , 
"departure_time" : "18:40:24" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "18:42:04" , 
"departure_time" : "18:42:31" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 97,
"arrival_time" : "18:46:27" , 
"departure_time" : "18:47:25" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:48:58" , 
"departure_time" : "18:50:10" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:52:12" , 
"departure_time" : "18:53:03" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:56:51" , 
"departure_time" : "18:57:48" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "19:00:57" , 
"departure_time" : "19:02:07" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "19:09:10" , 
"departure_time" : "19:09:26" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "19:15:16" , 
"departure_time" : "19:15:55" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "19:19:39" , 
"departure_time" : "19:20:32" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "19:24:53" , 
"departure_time" : "19:26:18" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "19:29:25" , 
"departure_time" : "19:30:18" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "19:33:53" , 
"departure_time" : "19:35:16" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "19:41:23" , 
"departure_time" : "19:43:03" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "19:43:40" , 
"departure_time" : "19:44:28" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "19:56:48" , 
"departure_time" : "19:56:48" , 
"distance_traveled" : 43.1008
} ], 
"2208" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "22:11:00" , 
"departure_time" : "22:11:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:20:04" , 
"departure_time" : "22:20:23" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 106,
"arrival_time" : "22:30:19" , 
"departure_time" : "22:31:18" , 
"distance_traveled" : 10.4222
}, 
{ 
"stop_id" : 37,
"arrival_time" : "22:36:59" , 
"departure_time" : "22:37:16" , 
"distance_traveled" : 12.6699
}, 
{ 
"stop_id" : 23,
"arrival_time" : "22:39:17" , 
"departure_time" : "22:40:31" , 
"distance_traveled" : 13.1977
}, 
{ 
"stop_id" : 112,
"arrival_time" : "22:43:14" , 
"departure_time" : "22:44:43" , 
"distance_traveled" : 14.0972
}, 
{ 
"stop_id" : 97,
"arrival_time" : "22:47:29" , 
"departure_time" : "22:48:10" , 
"distance_traveled" : 15.7328
}, 
{ 
"stop_id" : 140,
"arrival_time" : "22:48:41" , 
"departure_time" : "22:50:00" , 
"distance_traveled" : 16.4953
}, 
{ 
"stop_id" : 81,
"arrival_time" : "22:52:19" , 
"departure_time" : "22:53:13" , 
"distance_traveled" : 17.7777
}, 
{ 
"stop_id" : 87,
"arrival_time" : "22:56:54" , 
"departure_time" : "22:58:27" , 
"distance_traveled" : 19.3864
}, 
{ 
"stop_id" : 136,
"arrival_time" : "23:01:33" , 
"departure_time" : "23:02:07" , 
"distance_traveled" : 20.4608
}, 
{ 
"stop_id" : 145,
"arrival_time" : "23:08:34" , 
"departure_time" : "23:09:10" , 
"distance_traveled" : 22.7284
}, 
{ 
"stop_id" : 27,
"arrival_time" : "23:15:36" , 
"departure_time" : "23:17:02" , 
"distance_traveled" : 26.1547
}, 
{ 
"stop_id" : 77,
"arrival_time" : "23:20:26" , 
"departure_time" : "23:20:33" , 
"distance_traveled" : 28.15
}, 
{ 
"stop_id" : 30,
"arrival_time" : "23:24:07" , 
"departure_time" : "23:25:32" , 
"distance_traveled" : 30.3153
}, 
{ 
"stop_id" : 92,
"arrival_time" : "23:29:25" , 
"departure_time" : "23:29:31" , 
"distance_traveled" : 32.4038
}, 
{ 
"stop_id" : 91,
"arrival_time" : "23:33:06" , 
"departure_time" : "23:34:19" , 
"distance_traveled" : 34.6343
}, 
{ 
"stop_id" : 94,
"arrival_time" : "23:41:13" , 
"departure_time" : "23:41:31" , 
"distance_traveled" : 38.3254
}, 
{ 
"stop_id" : 34,
"arrival_time" : "23:42:18" , 
"departure_time" : "23:43:46" , 
"distance_traveled" : 38.9017
}, 
{ 
"stop_id" : 35,
"arrival_time" : "23:57:28" , 
"departure_time" : "23:57:28" , 
"distance_traveled" : 43.1008
} ], 
"2209" :  [ 
{ 
"stop_id" : 117,
"arrival_time" : "05:33:00" , 
"departure_time" : "05:34:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 45,
"arrival_time" : "05:38:27" , 
"departure_time" : "05:39:39" , 
"distance_traveled" : 2.3864
}, 
{ 
"stop_id" : 18,
"arrival_time" : "05:45:12" , 
"departure_time" : "05:45:43" , 
"distance_traveled" : 6.5206
}, 
{ 
"stop_id" : 12,
"arrival_time" : "05:47:31" , 
"departure_time" : "05:48:32" , 
"distance_traveled" : 7.6824
}, 
{ 
"stop_id" : 76,
"arrival_time" : "05:52:01" , 
"departure_time" : "05:53:14" , 
"distance_traveled" : 9.5644
}, 
{ 
"stop_id" : 88,
"arrival_time" : "05:55:13" , 
"departure_time" : "05:56:37" , 
"distance_traveled" : 11.204
}, 
{ 
"stop_id" : 143,
"arrival_time" : "05:58:24" , 
"departure_time" : "05:58:29" , 
"distance_traveled" : 12.8021
}, 
{ 
"stop_id" : 48,
"arrival_time" : "06:00:05" , 
"departure_time" : "06:01:05" , 
"distance_traveled" : 14.1564
}, 
{ 
"stop_id" : 17,
"arrival_time" : "06:05:00" , 
"departure_time" : "06:05:23" , 
"distance_traveled" : 15.5511
}, 
{ 
"stop_id" : 99,
"arrival_time" : "06:08:23" , 
"departure_time" : "06:08:55" , 
"distance_traveled" : 17.9172
}, 
{ 
"stop_id" : 104,
"arrival_time" : "06:12:32" , 
"departure_time" : "06:13:33" , 
"distance_traveled" : 19.5142
}, 
{ 
"stop_id" : 145,
"arrival_time" : "06:18:01" , 
"departure_time" : "06:19:29" , 
"distance_traveled" : 21.1919
}, 
{ 
"stop_id" : 136,
"arrival_time" : "06:22:28" , 
"departure_time" : "06:24:06" , 
"distance_traveled" : 23.4602
}, 
{ 
"stop_id" : 87,
"arrival_time" : "06:25:38" , 
"departure_time" : "06:26:49" , 
"distance_traveled" : 24.5347
}, 
{ 
"stop_id" : 81,
"arrival_time" : "06:29:11" , 
"departure_time" : "06:29:57" , 
"distance_traveled" : 26.1434
}, 
{ 
"stop_id" : 140,
"arrival_time" : "06:32:46" , 
"departure_time" : "06:33:40" , 
"distance_traveled" : 27.4258
}, 
{ 
"stop_id" : 61,
"arrival_time" : "06:35:54" , 
"departure_time" : "06:37:12" , 
"distance_traveled" : 29.1254
}, 
{ 
"stop_id" : 112,
"arrival_time" : "06:39:18" , 
"departure_time" : "06:40:33" , 
"distance_traveled" : 29.833
}, 
{ 
"stop_id" : 23,
"arrival_time" : "06:42:15" , 
"departure_time" : "06:42:30" , 
"distance_traveled" : 30.7339
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:47:15" , 
"departure_time" : "06:47:38" , 
"distance_traveled" : 33.5095
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:58:23" , 
"departure_time" : "06:59:44" , 
"distance_traveled" : 38.9432
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:12:21" , 
"departure_time" : "07:12:21" , 
"distance_traveled" : 43.9312
} ], 
"2210" :  [ 
{ 
"stop_id" : 117,
"arrival_time" : "05:33:00" , 
"departure_time" : "05:34:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 45,
"arrival_time" : "05:38:17" , 
"departure_time" : "05:38:48" , 
"distance_traveled" : 2.3864
}, 
{ 
"stop_id" : 18,
"arrival_time" : "05:44:31" , 
"departure_time" : "05:45:38" , 
"distance_traveled" : 6.5206
}, 
{ 
"stop_id" : 12,
"arrival_time" : "05:48:07" , 
"departure_time" : "05:49:03" , 
"distance_traveled" : 7.6824
}, 
{ 
"stop_id" : 76,
"arrival_time" : "05:51:56" , 
"departure_time" : "05:53:00" , 
"distance_traveled" : 9.5644
}, 
{ 
"stop_id" : 88,
"arrival_time" : "05:55:04" , 
"departure_time" : "05:56:15" , 
"distance_traveled" : 11.204
}, 
{ 
"stop_id" : 143,
"arrival_time" : "05:58:11" , 
"departure_time" : "05:59:09" , 
"distance_traveled" : 12.8021
}, 
{ 
"stop_id" : 48,
"arrival_time" : "06:00:58" , 
"departure_time" : "06:02:05" , 
"distance_traveled" : 14.1564
}, 
{ 
"stop_id" : 17,
"arrival_time" : "06:05:07" , 
"departure_time" : "06:06:36" , 
"distance_traveled" : 15.5511
}, 
{ 
"stop_id" : 99,
"arrival_time" : "06:09:29" , 
"departure_time" : "06:11:01" , 
"distance_traveled" : 17.9172
}, 
{ 
"stop_id" : 104,
"arrival_time" : "06:13:32" , 
"departure_time" : "06:13:49" , 
"distance_traveled" : 19.5142
}, 
{ 
"stop_id" : 145,
"arrival_time" : "06:17:17" , 
"departure_time" : "06:17:50" , 
"distance_traveled" : 21.1919
}, 
{ 
"stop_id" : 136,
"arrival_time" : "06:21:33" , 
"departure_time" : "06:23:06" , 
"distance_traveled" : 23.4602
}, 
{ 
"stop_id" : 87,
"arrival_time" : "06:25:33" , 
"departure_time" : "06:27:06" , 
"distance_traveled" : 24.5347
}, 
{ 
"stop_id" : 81,
"arrival_time" : "06:29:33" , 
"departure_time" : "06:30:07" , 
"distance_traveled" : 26.1434
}, 
{ 
"stop_id" : 140,
"arrival_time" : "06:32:34" , 
"departure_time" : "06:33:53" , 
"distance_traveled" : 27.4258
}, 
{ 
"stop_id" : 61,
"arrival_time" : "06:36:19" , 
"departure_time" : "06:37:17" , 
"distance_traveled" : 29.1254
}, 
{ 
"stop_id" : 112,
"arrival_time" : "06:38:58" , 
"departure_time" : "06:39:49" , 
"distance_traveled" : 29.833
}, 
{ 
"stop_id" : 23,
"arrival_time" : "06:41:51" , 
"departure_time" : "06:43:03" , 
"distance_traveled" : 30.7339
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:48:12" , 
"departure_time" : "06:49:44" , 
"distance_traveled" : 33.5095
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:59:32" , 
"departure_time" : "07:00:58" , 
"distance_traveled" : 38.9432
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:12:26" , 
"departure_time" : "07:12:26" , 
"distance_traveled" : 43.9312
} ], 
"2211" :  [ 
{ 
"stop_id" : 117,
"arrival_time" : "06:16:00" , 
"departure_time" : "06:18:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 45,
"arrival_time" : "06:22:11" , 
"departure_time" : "06:22:45" , 
"distance_traveled" : 2.3864
}, 
{ 
"stop_id" : 18,
"arrival_time" : "06:27:34" , 
"departure_time" : "06:28:55" , 
"distance_traveled" : 6.5206
}, 
{ 
"stop_id" : 12,
"arrival_time" : "06:31:21" , 
"departure_time" : "06:31:52" , 
"distance_traveled" : 7.6824
}, 
{ 
"stop_id" : 76,
"arrival_time" : "06:34:31" , 
"departure_time" : "06:35:35" , 
"distance_traveled" : 9.5644
}, 
{ 
"stop_id" : 88,
"arrival_time" : "06:38:04" , 
"departure_time" : "06:39:40" , 
"distance_traveled" : 11.204
}, 
{ 
"stop_id" : 143,
"arrival_time" : "06:41:36" , 
"departure_time" : "06:43:02" , 
"distance_traveled" : 12.8021
}, 
{ 
"stop_id" : 48,
"arrival_time" : "06:44:26" , 
"departure_time" : "06:45:24" , 
"distance_traveled" : 14.1564
}, 
{ 
"stop_id" : 17,
"arrival_time" : "06:47:58" , 
"departure_time" : "06:49:06" , 
"distance_traveled" : 15.5511
}, 
{ 
"stop_id" : 99,
"arrival_time" : "06:52:08" , 
"departure_time" : "06:52:24" , 
"distance_traveled" : 17.9172
}, 
{ 
"stop_id" : 104,
"arrival_time" : "06:55:16" , 
"departure_time" : "06:56:33" , 
"distance_traveled" : 19.5142
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:01:17" , 
"departure_time" : "07:01:28" , 
"distance_traveled" : 21.1919
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:04:11" , 
"departure_time" : "07:05:03" , 
"distance_traveled" : 23.4602
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:07:52" , 
"departure_time" : "07:08:24" , 
"distance_traveled" : 24.5347
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:11:32" , 
"departure_time" : "07:12:48" , 
"distance_traveled" : 26.1434
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:16:16" , 
"departure_time" : "07:16:47" , 
"distance_traveled" : 27.4258
}, 
{ 
"stop_id" : 61,
"arrival_time" : "07:18:31" , 
"departure_time" : "07:19:10" , 
"distance_traveled" : 29.1254
}, 
{ 
"stop_id" : 112,
"arrival_time" : "07:21:39" , 
"departure_time" : "07:22:15" , 
"distance_traveled" : 29.833
}, 
{ 
"stop_id" : 23,
"arrival_time" : "07:24:36" , 
"departure_time" : "07:25:55" , 
"distance_traveled" : 30.7339
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:31:19" , 
"departure_time" : "07:32:39" , 
"distance_traveled" : 33.5095
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:42:20" , 
"departure_time" : "07:43:54" , 
"distance_traveled" : 38.9432
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:55:34" , 
"departure_time" : "07:55:34" , 
"distance_traveled" : 43.9312
} ], 
"2212" :  [ 
{ 
"stop_id" : 117,
"arrival_time" : "06:16:00" , 
"departure_time" : "06:18:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 45,
"arrival_time" : "06:21:50" , 
"departure_time" : "06:22:15" , 
"distance_traveled" : 2.3864
}, 
{ 
"stop_id" : 18,
"arrival_time" : "06:27:25" , 
"departure_time" : "06:27:46" , 
"distance_traveled" : 6.5206
}, 
{ 
"stop_id" : 12,
"arrival_time" : "06:30:21" , 
"departure_time" : "06:30:52" , 
"distance_traveled" : 7.6824
}, 
{ 
"stop_id" : 76,
"arrival_time" : "06:34:31" , 
"departure_time" : "06:35:33" , 
"distance_traveled" : 9.5644
}, 
{ 
"stop_id" : 88,
"arrival_time" : "06:38:02" , 
"departure_time" : "06:39:20" , 
"distance_traveled" : 11.204
}, 
{ 
"stop_id" : 143,
"arrival_time" : "06:41:18" , 
"departure_time" : "06:42:21" , 
"distance_traveled" : 12.8021
}, 
{ 
"stop_id" : 48,
"arrival_time" : "06:44:03" , 
"departure_time" : "06:44:30" , 
"distance_traveled" : 14.1564
}, 
{ 
"stop_id" : 17,
"arrival_time" : "06:47:27" , 
"departure_time" : "06:48:43" , 
"distance_traveled" : 15.5511
}, 
{ 
"stop_id" : 99,
"arrival_time" : "06:52:16" , 
"departure_time" : "06:53:05" , 
"distance_traveled" : 17.9172
}, 
{ 
"stop_id" : 104,
"arrival_time" : "06:55:49" , 
"departure_time" : "06:57:24" , 
"distance_traveled" : 19.5142
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:01:35" , 
"departure_time" : "07:01:46" , 
"distance_traveled" : 21.1919
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:04:11" , 
"departure_time" : "07:05:46" , 
"distance_traveled" : 23.4602
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:08:35" , 
"departure_time" : "07:09:50" , 
"distance_traveled" : 24.5347
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:12:15" , 
"departure_time" : "07:13:30" , 
"distance_traveled" : 26.1434
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:16:15" , 
"departure_time" : "07:17:08" , 
"distance_traveled" : 27.4258
}, 
{ 
"stop_id" : 61,
"arrival_time" : "07:18:53" , 
"departure_time" : "07:19:34" , 
"distance_traveled" : 29.1254
}, 
{ 
"stop_id" : 112,
"arrival_time" : "07:21:41" , 
"departure_time" : "07:23:19" , 
"distance_traveled" : 29.833
}, 
{ 
"stop_id" : 23,
"arrival_time" : "07:25:38" , 
"departure_time" : "07:25:50" , 
"distance_traveled" : 30.7339
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:30:12" , 
"departure_time" : "07:31:36" , 
"distance_traveled" : 33.5095
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:42:24" , 
"departure_time" : "07:42:54" , 
"distance_traveled" : 38.9432
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:54:30" , 
"departure_time" : "07:54:30" , 
"distance_traveled" : 43.9312
} ], 
"2213" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "24:22:00" , 
"departure_time" : "24:23:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "24:26:08" , 
"departure_time" : "24:26:58" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "24:29:50" , 
"departure_time" : "24:30:19" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "24:41:29" , 
"departure_time" : "24:42:22" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "24:46:53" , 
"departure_time" : "24:47:26" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "24:49:33" , 
"departure_time" : "24:50:28" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "24:52:55" , 
"departure_time" : "24:54:22" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "24:56:27" , 
"departure_time" : "24:57:24" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "24:58:57" , 
"departure_time" : "25:00:03" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "25:02:06" , 
"departure_time" : "25:03:27" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "25:06:21" , 
"departure_time" : "25:07:10" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "25:08:49" , 
"departure_time" : "25:10:15" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "25:13:26" , 
"departure_time" : "25:13:26" , 
"distance_traveled" : 22.1182
} ], 
"2214" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "24:22:00" , 
"departure_time" : "24:25:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "24:26:35" , 
"departure_time" : "24:27:47" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "24:30:12" , 
"departure_time" : "24:31:37" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "24:42:25" , 
"departure_time" : "24:43:18" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "24:46:53" , 
"departure_time" : "24:47:02" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "24:49:09" , 
"departure_time" : "24:49:49" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "24:52:40" , 
"departure_time" : "24:53:45" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "24:56:05" , 
"departure_time" : "24:56:58" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "24:58:53" , 
"departure_time" : "24:59:05" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "25:01:12" , 
"departure_time" : "25:01:53" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "25:05:41" , 
"departure_time" : "25:06:23" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "25:08:42" , 
"departure_time" : "25:09:56" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "25:13:14" , 
"departure_time" : "25:13:14" , 
"distance_traveled" : 22.1182
} ], 
"2215" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "24:22:00" , 
"departure_time" : "24:24:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "24:25:50" , 
"departure_time" : "24:27:08" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "24:30:18" , 
"departure_time" : "24:30:19" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "24:41:01" , 
"departure_time" : "24:42:41" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "24:47:40" , 
"departure_time" : "24:47:50" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "24:49:10" , 
"departure_time" : "24:50:21" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "24:53:11" , 
"departure_time" : "24:53:55" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "24:55:44" , 
"departure_time" : "24:55:48" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "24:58:04" , 
"departure_time" : "24:59:42" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "25:02:38" , 
"departure_time" : "25:03:23" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "25:05:45" , 
"departure_time" : "25:06:47" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "25:09:02" , 
"departure_time" : "25:10:27" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "25:13:25" , 
"departure_time" : "25:13:25" , 
"distance_traveled" : 22.1182
} ], 
"2216" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "05:52:00" , 
"departure_time" : "05:53:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "05:55:12" , 
"departure_time" : "05:56:12" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "06:00:00" , 
"departure_time" : "06:01:03" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "06:06:03" , 
"departure_time" : "06:06:29" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "06:08:26" , 
"departure_time" : "06:09:57" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "06:12:31" , 
"departure_time" : "06:12:58" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "06:14:27" , 
"departure_time" : "06:15:07" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "06:17:40" , 
"departure_time" : "06:18:42" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "06:21:02" , 
"departure_time" : "06:21:44" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "06:24:42" , 
"departure_time" : "06:26:03" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "06:29:21" , 
"departure_time" : "06:30:57" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "06:32:36" , 
"departure_time" : "06:34:07" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "06:37:31" , 
"departure_time" : "06:37:31" , 
"distance_traveled" : 22.1182
} ], 
"2217" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "05:52:00" , 
"departure_time" : "05:53:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "05:55:26" , 
"departure_time" : "05:56:44" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "06:00:18" , 
"departure_time" : "06:00:30" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "06:05:12" , 
"departure_time" : "06:06:19" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "06:09:07" , 
"departure_time" : "06:10:04" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "06:11:57" , 
"departure_time" : "06:12:26" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "06:14:29" , 
"departure_time" : "06:15:18" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "06:17:49" , 
"departure_time" : "06:19:03" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "06:21:14" , 
"departure_time" : "06:22:24" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "06:25:10" , 
"departure_time" : "06:26:12" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "06:29:02" , 
"departure_time" : "06:29:51" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "06:31:49" , 
"departure_time" : "06:33:05" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "06:37:16" , 
"departure_time" : "06:37:16" , 
"distance_traveled" : 22.1182
} ], 
"2218" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "06:52:00" , 
"departure_time" : "06:53:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "06:55:28" , 
"departure_time" : "06:56:52" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "07:00:24" , 
"departure_time" : "07:01:30" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "07:06:06" , 
"departure_time" : "07:06:10" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "07:08:04" , 
"departure_time" : "07:09:05" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "07:12:01" , 
"departure_time" : "07:13:36" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "07:15:35" , 
"departure_time" : "07:16:33" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "07:17:58" , 
"departure_time" : "07:19:09" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "07:21:11" , 
"departure_time" : "07:21:26" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "07:24:15" , 
"departure_time" : "07:24:29" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "07:28:14" , 
"departure_time" : "07:29:52" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "07:32:38" , 
"departure_time" : "07:33:04" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:36:26" , 
"departure_time" : "07:36:26" , 
"distance_traveled" : 22.1182
} ], 
"2219" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "06:52:00" , 
"departure_time" : "06:52:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "06:55:08" , 
"departure_time" : "06:55:59" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "06:59:51" , 
"departure_time" : "07:00:03" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "07:05:12" , 
"departure_time" : "07:06:51" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "07:09:39" , 
"departure_time" : "07:09:40" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "07:11:01" , 
"departure_time" : "07:12:35" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "07:15:34" , 
"departure_time" : "07:15:51" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "07:17:17" , 
"departure_time" : "07:17:20" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "07:20:03" , 
"departure_time" : "07:21:08" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "07:25:05" , 
"departure_time" : "07:25:54" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "07:28:49" , 
"departure_time" : "07:30:09" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "07:32:20" , 
"departure_time" : "07:33:09" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:36:49" , 
"departure_time" : "07:36:49" , 
"distance_traveled" : 22.1182
} ], 
"2220" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "07:52:00" , 
"departure_time" : "07:53:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "07:55:19" , 
"departure_time" : "07:56:07" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "07:59:48" , 
"departure_time" : "08:00:07" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "08:05:19" , 
"departure_time" : "08:05:22" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "08:08:03" , 
"departure_time" : "08:08:48" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "08:11:45" , 
"departure_time" : "08:13:00" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "08:15:15" , 
"departure_time" : "08:15:46" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "08:17:31" , 
"departure_time" : "08:18:18" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "08:20:47" , 
"departure_time" : "08:21:22" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "08:24:35" , 
"departure_time" : "08:25:46" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "08:29:11" , 
"departure_time" : "08:30:13" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "08:32:02" , 
"departure_time" : "08:32:22" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "08:36:20" , 
"departure_time" : "08:36:20" , 
"distance_traveled" : 22.1182
} ], 
"2221" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "07:52:00" , 
"departure_time" : "07:53:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "07:56:36" , 
"departure_time" : "07:57:13" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "07:59:37" , 
"departure_time" : "08:00:54" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "08:06:17" , 
"departure_time" : "08:07:01" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "08:08:44" , 
"departure_time" : "08:09:57" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "08:12:13" , 
"departure_time" : "08:12:52" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "08:14:39" , 
"departure_time" : "08:14:49" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "08:17:10" , 
"departure_time" : "08:18:29" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "08:21:19" , 
"departure_time" : "08:21:46" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "08:24:27" , 
"departure_time" : "08:25:02" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "08:28:35" , 
"departure_time" : "08:29:12" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "08:31:37" , 
"departure_time" : "08:32:22" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "08:36:45" , 
"departure_time" : "08:36:45" , 
"distance_traveled" : 22.1182
} ], 
"2222" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "08:52:00" , 
"departure_time" : "08:53:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "08:55:55" , 
"departure_time" : "08:57:13" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "09:00:18" , 
"departure_time" : "09:01:28" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "09:06:10" , 
"departure_time" : "09:06:48" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "09:08:38" , 
"departure_time" : "09:09:44" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "09:12:06" , 
"departure_time" : "09:13:20" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "09:15:14" , 
"departure_time" : "09:16:14" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "09:18:00" , 
"departure_time" : "09:18:11" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "09:20:11" , 
"departure_time" : "09:21:46" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "09:25:35" , 
"departure_time" : "09:26:12" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "09:28:37" , 
"departure_time" : "09:28:43" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "09:31:06" , 
"departure_time" : "09:32:43" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "09:37:37" , 
"departure_time" : "09:37:37" , 
"distance_traveled" : 22.1182
} ], 
"2223" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "08:52:00" , 
"departure_time" : "08:54:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "08:56:15" , 
"departure_time" : "08:57:52" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "09:00:37" , 
"departure_time" : "09:01:40" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "09:06:03" , 
"departure_time" : "09:06:08" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "09:08:05" , 
"departure_time" : "09:08:24" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "09:11:19" , 
"departure_time" : "09:12:21" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "09:15:02" , 
"departure_time" : "09:15:57" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "09:17:55" , 
"departure_time" : "09:18:34" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "09:20:39" , 
"departure_time" : "09:21:49" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "09:25:10" , 
"departure_time" : "09:26:14" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "09:29:04" , 
"departure_time" : "09:29:50" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "09:31:46" , 
"departure_time" : "09:32:18" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "09:36:32" , 
"departure_time" : "09:36:32" , 
"distance_traveled" : 22.1182
} ], 
"2224" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "09:52:00" , 
"departure_time" : "09:52:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "09:55:26" , 
"departure_time" : "09:55:54" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "09:59:28" , 
"departure_time" : "10:00:52" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "10:06:24" , 
"departure_time" : "10:07:11" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "10:08:47" , 
"departure_time" : "10:10:25" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "10:12:38" , 
"departure_time" : "10:14:10" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "10:15:32" , 
"departure_time" : "10:16:59" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "10:18:27" , 
"departure_time" : "10:19:31" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "10:21:04" , 
"departure_time" : "10:21:13" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "10:24:09" , 
"departure_time" : "10:24:12" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "10:28:03" , 
"departure_time" : "10:29:36" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "10:32:33" , 
"departure_time" : "10:34:06" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "10:37:33" , 
"departure_time" : "10:37:33" , 
"distance_traveled" : 22.1182
} ], 
"2225" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "09:52:00" , 
"departure_time" : "09:55:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "09:56:38" , 
"departure_time" : "09:57:40" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "10:00:02" , 
"departure_time" : "10:01:28" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "10:06:26" , 
"departure_time" : "10:06:34" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "10:08:08" , 
"departure_time" : "10:09:08" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "10:12:00" , 
"departure_time" : "10:13:39" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "10:15:39" , 
"departure_time" : "10:17:00" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "10:18:21" , 
"departure_time" : "10:19:14" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "10:20:53" , 
"departure_time" : "10:21:52" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "10:24:59" , 
"departure_time" : "10:26:00" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "10:29:01" , 
"departure_time" : "10:29:26" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "10:31:25" , 
"departure_time" : "10:32:02" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "10:36:37" , 
"departure_time" : "10:36:37" , 
"distance_traveled" : 22.1182
} ], 
"2226" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "10:52:00" , 
"departure_time" : "10:53:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "10:55:44" , 
"departure_time" : "10:56:26" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "10:59:42" , 
"departure_time" : "11:01:11" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "11:06:29" , 
"departure_time" : "11:08:00" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "11:09:31" , 
"departure_time" : "11:09:51" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "11:11:20" , 
"departure_time" : "11:12:10" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "11:14:50" , 
"departure_time" : "11:16:04" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "11:18:14" , 
"departure_time" : "11:18:45" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "11:20:31" , 
"departure_time" : "11:22:11" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "11:25:40" , 
"departure_time" : "11:26:03" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "11:28:23" , 
"departure_time" : "11:29:08" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "11:31:45" , 
"departure_time" : "11:33:06" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "11:37:21" , 
"departure_time" : "11:37:21" , 
"distance_traveled" : 22.1182
} ], 
"2227" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "10:52:00" , 
"departure_time" : "10:53:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "10:55:35" , 
"departure_time" : "10:56:56" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "11:00:21" , 
"departure_time" : "11:00:43" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "11:05:22" , 
"departure_time" : "11:06:45" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "11:09:23" , 
"departure_time" : "11:10:33" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "11:12:10" , 
"departure_time" : "11:12:38" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "11:14:28" , 
"departure_time" : "11:14:52" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "11:17:24" , 
"departure_time" : "11:17:28" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "11:20:04" , 
"departure_time" : "11:20:05" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "11:24:01" , 
"departure_time" : "11:24:59" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "11:28:58" , 
"departure_time" : "11:30:33" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "11:32:35" , 
"departure_time" : "11:32:42" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "11:36:07" , 
"departure_time" : "11:36:07" , 
"distance_traveled" : 22.1182
} ], 
"2228" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "11:52:00" , 
"departure_time" : "11:53:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "11:56:24" , 
"departure_time" : "11:57:53" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "12:00:29" , 
"departure_time" : "12:02:07" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "12:06:38" , 
"departure_time" : "12:07:34" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "12:08:56" , 
"departure_time" : "12:09:22" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "12:11:26" , 
"departure_time" : "12:12:09" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "12:14:43" , 
"departure_time" : "12:15:54" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "12:18:11" , 
"departure_time" : "12:18:50" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "12:20:39" , 
"departure_time" : "12:21:32" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "12:24:53" , 
"departure_time" : "12:25:00" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "12:28:07" , 
"departure_time" : "12:29:16" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "12:32:09" , 
"departure_time" : "12:32:26" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "12:36:17" , 
"departure_time" : "12:36:17" , 
"distance_traveled" : 22.1182
} ], 
"2229" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "11:52:00" , 
"departure_time" : "11:53:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "11:56:37" , 
"departure_time" : "11:58:10" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "12:00:33" , 
"departure_time" : "12:00:44" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "12:05:11" , 
"departure_time" : "12:06:01" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "12:08:50" , 
"departure_time" : "12:09:58" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "12:12:08" , 
"departure_time" : "12:13:25" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "12:15:17" , 
"departure_time" : "12:16:10" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "12:17:53" , 
"departure_time" : "12:18:29" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "12:20:36" , 
"departure_time" : "12:20:44" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "12:24:08" , 
"departure_time" : "12:25:34" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "12:29:26" , 
"departure_time" : "12:29:52" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "12:31:26" , 
"departure_time" : "12:32:12" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "12:36:46" , 
"departure_time" : "12:36:46" , 
"distance_traveled" : 22.1182
} ], 
"2230" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "12:52:00" , 
"departure_time" : "12:53:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "12:55:16" , 
"departure_time" : "12:55:24" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "12:59:08" , 
"departure_time" : "13:00:15" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "13:06:07" , 
"departure_time" : "13:06:35" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "13:08:28" , 
"departure_time" : "13:09:12" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "13:11:44" , 
"departure_time" : "13:12:03" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "13:14:19" , 
"departure_time" : "13:14:56" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "13:17:37" , 
"departure_time" : "13:18:04" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "13:20:27" , 
"departure_time" : "13:20:47" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "13:24:20" , 
"departure_time" : "13:25:07" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "13:28:47" , 
"departure_time" : "13:30:25" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "13:32:38" , 
"departure_time" : "13:33:00" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "13:36:22" , 
"departure_time" : "13:36:22" , 
"distance_traveled" : 22.1182
} ], 
"2231" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "12:52:00" , 
"departure_time" : "12:53:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "12:56:04" , 
"departure_time" : "12:57:03" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "12:59:59" , 
"departure_time" : "13:00:50" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "13:05:51" , 
"departure_time" : "13:07:13" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "13:09:22" , 
"departure_time" : "13:10:22" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "13:12:00" , 
"departure_time" : "13:13:39" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "13:15:39" , 
"departure_time" : "13:15:56" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "13:17:17" , 
"departure_time" : "13:17:49" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "13:20:32" , 
"departure_time" : "13:20:53" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "13:24:21" , 
"departure_time" : "13:24:36" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "13:28:15" , 
"departure_time" : "13:28:29" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "13:31:14" , 
"departure_time" : "13:32:29" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "13:37:15" , 
"departure_time" : "13:37:15" , 
"distance_traveled" : 22.1182
} ], 
"2232" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "13:52:00" , 
"departure_time" : "13:54:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "13:55:59" , 
"departure_time" : "13:56:56" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "13:59:57" , 
"departure_time" : "14:00:30" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "14:05:33" , 
"departure_time" : "14:05:58" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "14:08:25" , 
"departure_time" : "14:08:43" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "14:11:18" , 
"departure_time" : "14:11:48" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "14:14:30" , 
"departure_time" : "14:14:44" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "14:17:14" , 
"departure_time" : "14:18:01" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "14:20:47" , 
"departure_time" : "14:22:10" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "14:25:23" , 
"departure_time" : "14:26:52" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "14:29:29" , 
"departure_time" : "14:30:08" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "14:31:39" , 
"departure_time" : "14:31:44" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "14:36:05" , 
"departure_time" : "14:36:05" , 
"distance_traveled" : 22.1182
} ], 
"2233" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "13:52:00" , 
"departure_time" : "13:53:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "13:56:29" , 
"departure_time" : "13:57:20" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "13:59:51" , 
"departure_time" : "14:00:17" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "14:05:26" , 
"departure_time" : "14:05:44" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "14:08:18" , 
"departure_time" : "14:09:37" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "14:12:19" , 
"departure_time" : "14:12:36" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "14:14:17" , 
"departure_time" : "14:14:35" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "14:17:18" , 
"departure_time" : "14:17:40" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "14:20:22" , 
"departure_time" : "14:21:44" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "14:25:22" , 
"departure_time" : "14:26:11" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "14:28:49" , 
"departure_time" : "14:29:36" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "14:31:47" , 
"departure_time" : "14:33:13" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "14:37:26" , 
"departure_time" : "14:37:26" , 
"distance_traveled" : 22.1182
} ], 
"2234" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "14:52:00" , 
"departure_time" : "14:54:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "14:56:12" , 
"departure_time" : "14:56:45" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "14:59:33" , 
"departure_time" : "15:00:36" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "15:06:03" , 
"departure_time" : "15:07:13" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "15:09:10" , 
"departure_time" : "15:09:37" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "15:11:27" , 
"departure_time" : "15:12:14" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "15:14:47" , 
"departure_time" : "15:15:24" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "15:17:37" , 
"departure_time" : "15:18:01" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "15:20:24" , 
"departure_time" : "15:20:41" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "15:24:17" , 
"departure_time" : "15:24:21" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "15:28:04" , 
"departure_time" : "15:28:22" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "15:31:18" , 
"departure_time" : "15:32:11" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "15:36:53" , 
"departure_time" : "15:36:53" , 
"distance_traveled" : 22.1182
} ], 
"2235" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "14:52:00" , 
"departure_time" : "14:54:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "14:56:27" , 
"departure_time" : "14:57:20" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "14:59:53" , 
"departure_time" : "15:00:21" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "15:05:28" , 
"departure_time" : "15:05:35" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "15:08:07" , 
"departure_time" : "15:09:31" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "15:12:24" , 
"departure_time" : "15:13:52" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "15:15:28" , 
"departure_time" : "15:16:45" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "15:18:17" , 
"departure_time" : "15:19:50" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "15:21:33" , 
"departure_time" : "15:21:44" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "15:24:11" , 
"departure_time" : "15:25:40" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "15:29:29" , 
"departure_time" : "15:30:09" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "15:31:40" , 
"departure_time" : "15:32:17" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "15:36:37" , 
"departure_time" : "15:36:37" , 
"distance_traveled" : 22.1182
} ], 
"2236" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "15:52:00" , 
"departure_time" : "15:53:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "15:56:07" , 
"departure_time" : "15:57:47" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "16:00:40" , 
"departure_time" : "16:01:53" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "16:06:13" , 
"departure_time" : "16:06:15" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "16:08:02" , 
"departure_time" : "16:08:49" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "16:11:47" , 
"departure_time" : "16:13:00" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "16:15:13" , 
"departure_time" : "16:15:17" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "16:17:04" , 
"departure_time" : "16:18:18" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "16:21:14" , 
"departure_time" : "16:22:04" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "16:24:50" , 
"departure_time" : "16:24:58" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "16:28:08" , 
"departure_time" : "16:28:27" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "16:31:19" , 
"departure_time" : "16:32:49" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:37:30" , 
"departure_time" : "16:37:30" , 
"distance_traveled" : 22.1182
} ], 
"2237" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "15:52:00" , 
"departure_time" : "15:54:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "15:55:51" , 
"departure_time" : "15:55:52" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "15:59:01" , 
"departure_time" : "16:00:41" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "16:06:40" , 
"departure_time" : "16:08:04" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "16:09:24" , 
"departure_time" : "16:10:37" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "16:12:13" , 
"departure_time" : "16:13:46" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "16:15:33" , 
"departure_time" : "16:15:38" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "16:17:05" , 
"departure_time" : "16:17:40" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "16:20:35" , 
"departure_time" : "16:22:06" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "16:25:31" , 
"departure_time" : "16:26:26" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "16:28:55" , 
"departure_time" : "16:29:46" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "16:31:51" , 
"departure_time" : "16:31:57" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:36:06" , 
"departure_time" : "16:36:06" , 
"distance_traveled" : 22.1182
} ], 
"2238" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "16:52:00" , 
"departure_time" : "16:53:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "16:56:25" , 
"departure_time" : "16:56:31" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "16:59:06" , 
"departure_time" : "16:59:34" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "17:05:28" , 
"departure_time" : "17:05:44" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "17:08:16" , 
"departure_time" : "17:09:07" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "17:11:51" , 
"departure_time" : "17:12:00" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "17:14:09" , 
"departure_time" : "17:14:11" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "17:17:02" , 
"departure_time" : "17:17:45" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "17:20:43" , 
"departure_time" : "17:21:00" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "17:24:17" , 
"departure_time" : "17:24:20" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "17:28:03" , 
"departure_time" : "17:28:13" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "17:31:10" , 
"departure_time" : "17:32:35" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:37:25" , 
"departure_time" : "17:37:25" , 
"distance_traveled" : 22.1182
} ], 
"2239" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "16:52:00" , 
"departure_time" : "16:53:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "16:55:23" , 
"departure_time" : "16:56:45" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "17:00:22" , 
"departure_time" : "17:00:33" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "17:05:11" , 
"departure_time" : "17:05:23" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "17:08:12" , 
"departure_time" : "17:09:05" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "17:11:53" , 
"departure_time" : "17:12:48" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "17:14:55" , 
"departure_time" : "17:15:02" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "17:17:07" , 
"departure_time" : "17:17:54" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "17:20:47" , 
"departure_time" : "17:21:54" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "17:25:07" , 
"departure_time" : "17:25:27" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "17:28:20" , 
"departure_time" : "17:29:11" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "17:31:51" , 
"departure_time" : "17:32:10" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:36:19" , 
"departure_time" : "17:36:19" , 
"distance_traveled" : 22.1182
} ], 
"2240" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "17:52:00" , 
"departure_time" : "17:53:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "17:56:19" , 
"departure_time" : "17:57:16" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "17:59:57" , 
"departure_time" : "18:01:02" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "18:06:05" , 
"departure_time" : "18:07:43" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "18:09:38" , 
"departure_time" : "18:09:40" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "18:11:02" , 
"departure_time" : "18:11:12" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "18:14:10" , 
"departure_time" : "18:15:38" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "18:18:28" , 
"departure_time" : "18:19:05" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "18:20:37" , 
"departure_time" : "18:20:58" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "18:24:21" , 
"departure_time" : "18:25:26" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "18:29:05" , 
"departure_time" : "18:29:14" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "18:31:09" , 
"departure_time" : "18:32:00" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:36:51" , 
"departure_time" : "18:36:51" , 
"distance_traveled" : 22.1182
} ], 
"2241" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "17:52:00" , 
"departure_time" : "17:54:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "17:56:17" , 
"departure_time" : "17:56:40" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "17:59:23" , 
"departure_time" : "17:59:31" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "18:05:08" , 
"departure_time" : "18:05:27" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "18:08:19" , 
"departure_time" : "18:09:04" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "18:11:45" , 
"departure_time" : "18:13:17" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "18:15:32" , 
"departure_time" : "18:17:07" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "18:18:35" , 
"departure_time" : "18:18:48" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "18:20:13" , 
"departure_time" : "18:20:15" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "18:24:02" , 
"departure_time" : "18:25:13" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "18:29:11" , 
"departure_time" : "18:29:18" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "18:31:07" , 
"departure_time" : "18:32:03" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:36:56" , 
"departure_time" : "18:36:56" , 
"distance_traveled" : 22.1182
} ], 
"2242" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "18:52:00" , 
"departure_time" : "18:54:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "18:56:25" , 
"departure_time" : "18:56:46" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "18:59:21" , 
"departure_time" : "19:00:48" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "19:06:27" , 
"departure_time" : "19:06:32" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "19:08:05" , 
"departure_time" : "19:08:47" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "19:11:42" , 
"departure_time" : "19:12:07" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "19:14:25" , 
"departure_time" : "19:15:04" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "19:17:39" , 
"departure_time" : "19:18:32" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "19:20:53" , 
"departure_time" : "19:21:18" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "19:24:25" , 
"departure_time" : "19:24:41" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "19:28:16" , 
"departure_time" : "19:29:06" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "19:31:50" , 
"departure_time" : "19:32:17" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "19:36:27" , 
"departure_time" : "19:36:27" , 
"distance_traveled" : 22.1182
} ], 
"2243" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "18:52:00" , 
"departure_time" : "18:52:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "18:55:09" , 
"departure_time" : "18:55:13" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "18:59:04" , 
"departure_time" : "19:00:26" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "19:06:22" , 
"departure_time" : "19:07:42" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "19:09:20" , 
"departure_time" : "19:10:15" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "19:11:55" , 
"departure_time" : "19:12:01" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "19:14:06" , 
"departure_time" : "19:15:06" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "19:18:00" , 
"departure_time" : "19:19:23" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "19:21:23" , 
"departure_time" : "19:22:06" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "19:24:43" , 
"departure_time" : "19:24:44" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "19:28:01" , 
"departure_time" : "19:29:32" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "19:32:31" , 
"departure_time" : "19:33:20" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "19:36:49" , 
"departure_time" : "19:36:49" , 
"distance_traveled" : 22.1182
} ], 
"2244" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "19:52:00" , 
"departure_time" : "19:53:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "19:55:20" , 
"departure_time" : "19:55:35" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "19:59:15" , 
"departure_time" : "20:00:46" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "20:06:31" , 
"departure_time" : "20:06:50" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "20:08:19" , 
"departure_time" : "20:08:53" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "20:11:34" , 
"departure_time" : "20:12:33" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "20:14:59" , 
"departure_time" : "20:16:28" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "20:18:29" , 
"departure_time" : "20:20:01" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "20:21:32" , 
"departure_time" : "20:23:01" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "20:25:29" , 
"departure_time" : "20:26:26" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "20:28:57" , 
"departure_time" : "20:29:26" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "20:31:29" , 
"departure_time" : "20:32:42" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "20:37:13" , 
"departure_time" : "20:37:13" , 
"distance_traveled" : 22.1182
} ], 
"2245" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "19:52:00" , 
"departure_time" : "19:54:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "19:56:04" , 
"departure_time" : "19:56:34" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "19:59:30" , 
"departure_time" : "19:59:34" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "20:05:04" , 
"departure_time" : "20:05:53" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "20:08:49" , 
"departure_time" : "20:09:37" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "20:11:48" , 
"departure_time" : "20:12:35" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "20:14:47" , 
"departure_time" : "20:16:18" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "20:18:31" , 
"departure_time" : "20:19:03" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "20:20:32" , 
"departure_time" : "20:20:43" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "20:24:11" , 
"departure_time" : "20:25:49" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "20:29:38" , 
"departure_time" : "20:30:55" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "20:32:17" , 
"departure_time" : "20:33:36" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "20:37:19" , 
"departure_time" : "20:37:19" , 
"distance_traveled" : 22.1182
} ], 
"2246" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "20:52:00" , 
"departure_time" : "20:54:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "20:56:26" , 
"departure_time" : "20:57:40" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "21:00:14" , 
"departure_time" : "21:00:36" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "21:05:22" , 
"departure_time" : "21:06:24" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "21:09:02" , 
"departure_time" : "21:09:26" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "21:11:24" , 
"departure_time" : "21:12:46" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "21:15:22" , 
"departure_time" : "21:16:52" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "21:18:30" , 
"departure_time" : "21:19:10" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "21:20:40" , 
"departure_time" : "21:22:15" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "21:25:35" , 
"departure_time" : "21:27:03" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "21:29:28" , 
"departure_time" : "21:30:19" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "21:31:51" , 
"departure_time" : "21:33:28" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "21:37:37" , 
"departure_time" : "21:37:37" , 
"distance_traveled" : 22.1182
} ], 
"2247" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "20:52:00" , 
"departure_time" : "20:54:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "20:56:03" , 
"departure_time" : "20:56:17" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "20:59:14" , 
"departure_time" : "20:59:35" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "21:05:21" , 
"departure_time" : "21:05:25" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "21:08:04" , 
"departure_time" : "21:09:10" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "21:12:06" , 
"departure_time" : "21:13:00" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "21:14:54" , 
"departure_time" : "21:15:39" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "21:17:45" , 
"departure_time" : "21:18:12" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "21:20:27" , 
"departure_time" : "21:21:13" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "21:24:46" , 
"departure_time" : "21:25:54" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "21:29:08" , 
"departure_time" : "21:29:20" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "21:31:12" , 
"departure_time" : "21:32:05" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "21:36:53" , 
"departure_time" : "21:36:53" , 
"distance_traveled" : 22.1182
} ], 
"2248" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "21:52:00" , 
"departure_time" : "21:54:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "21:56:22" , 
"departure_time" : "21:56:24" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "21:59:02" , 
"departure_time" : "22:00:36" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "22:06:34" , 
"departure_time" : "22:06:48" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "22:08:14" , 
"departure_time" : "22:08:47" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "22:11:33" , 
"departure_time" : "22:11:49" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "22:14:16" , 
"departure_time" : "22:15:15" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "22:17:59" , 
"departure_time" : "22:18:06" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "22:20:07" , 
"departure_time" : "22:20:14" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "22:24:07" , 
"departure_time" : "22:24:48" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "22:28:41" , 
"departure_time" : "22:30:12" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "22:32:31" , 
"departure_time" : "22:34:01" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "22:37:30" , 
"departure_time" : "22:37:30" , 
"distance_traveled" : 22.1182
} ], 
"2249" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "21:52:00" , 
"departure_time" : "21:53:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "21:55:16" , 
"departure_time" : "21:56:51" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "22:00:35" , 
"departure_time" : "22:01:16" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "22:05:41" , 
"departure_time" : "22:05:49" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "22:08:08" , 
"departure_time" : "22:09:44" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "22:12:36" , 
"departure_time" : "22:13:20" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "22:14:44" , 
"departure_time" : "22:14:50" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "22:17:06" , 
"departure_time" : "22:17:26" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "22:20:20" , 
"departure_time" : "22:20:57" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "22:24:37" , 
"departure_time" : "22:25:52" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "22:29:15" , 
"departure_time" : "22:29:22" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "22:31:07" , 
"departure_time" : "22:31:56" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "22:36:49" , 
"departure_time" : "22:36:49" , 
"distance_traveled" : 22.1182
} ], 
"2250" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "22:52:00" , 
"departure_time" : "22:53:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "22:55:15" , 
"departure_time" : "22:56:15" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "23:00:00" , 
"departure_time" : "23:00:06" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "23:05:06" , 
"departure_time" : "23:05:19" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "23:08:13" , 
"departure_time" : "23:09:46" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "23:12:33" , 
"departure_time" : "23:14:12" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "23:15:39" , 
"departure_time" : "23:16:26" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "23:17:47" , 
"departure_time" : "23:17:55" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "23:20:08" , 
"departure_time" : "23:20:20" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "23:24:12" , 
"departure_time" : "23:24:13" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "23:28:01" , 
"departure_time" : "23:29:39" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "23:32:38" , 
"departure_time" : "23:33:08" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "23:36:30" , 
"departure_time" : "23:36:30" , 
"distance_traveled" : 22.1182
} ], 
"2251" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "22:52:00" , 
"departure_time" : "22:52:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "22:55:18" , 
"departure_time" : "22:55:46" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "22:59:28" , 
"departure_time" : "23:01:02" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "23:06:34" , 
"departure_time" : "23:07:39" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "23:09:05" , 
"departure_time" : "23:10:40" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "23:12:35" , 
"departure_time" : "23:13:36" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "23:15:01" , 
"departure_time" : "23:15:54" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "23:17:53" , 
"departure_time" : "23:19:17" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "23:21:24" , 
"departure_time" : "23:21:30" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "23:24:06" , 
"departure_time" : "23:25:14" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "23:29:08" , 
"departure_time" : "23:29:27" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "23:31:19" , 
"departure_time" : "23:31:50" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "23:36:31" , 
"departure_time" : "23:36:31" , 
"distance_traveled" : 22.1182
} ], 
"2252" :  [ 
{ 
"stop_id" : 117,
"arrival_time" : "20:14:00" , 
"departure_time" : "20:14:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 45,
"arrival_time" : "20:18:26" , 
"departure_time" : "20:19:08" , 
"distance_traveled" : 2.3864
}, 
{ 
"stop_id" : 18,
"arrival_time" : "20:24:42" , 
"departure_time" : "20:26:08" , 
"distance_traveled" : 6.5206
}, 
{ 
"stop_id" : 12,
"arrival_time" : "20:28:26" , 
"departure_time" : "20:29:26" , 
"distance_traveled" : 7.6824
}, 
{ 
"stop_id" : 76,
"arrival_time" : "20:31:00" , 
"departure_time" : "20:32:09" , 
"distance_traveled" : 9.5644
}, 
{ 
"stop_id" : 88,
"arrival_time" : "20:34:09" , 
"departure_time" : "20:34:10" , 
"distance_traveled" : 11.204
}, 
{ 
"stop_id" : 143,
"arrival_time" : "20:37:01" , 
"departure_time" : "20:37:55" , 
"distance_traveled" : 12.8021
}, 
{ 
"stop_id" : 48,
"arrival_time" : "20:41:54" , 
"departure_time" : "20:42:27" , 
"distance_traveled" : 14.1564
}, 
{ 
"stop_id" : 17,
"arrival_time" : "20:44:33" , 
"departure_time" : "20:45:25" , 
"distance_traveled" : 15.5511
}, 
{ 
"stop_id" : 99,
"arrival_time" : "20:48:52" , 
"departure_time" : "20:49:55" , 
"distance_traveled" : 17.9172
}, 
{ 
"stop_id" : 104,
"arrival_time" : "20:52:03" , 
"departure_time" : "20:53:21" , 
"distance_traveled" : 19.5142
}, 
{ 
"stop_id" : 145,
"arrival_time" : "20:57:18" , 
"departure_time" : "20:58:37" , 
"distance_traveled" : 21.1919
}, 
{ 
"stop_id" : 106,
"arrival_time" : "21:13:19" , 
"departure_time" : "21:13:59" , 
"distance_traveled" : 33.4991
}, 
{ 
"stop_id" : 63,
"arrival_time" : "21:29:40" , 
"departure_time" : "21:29:40" , 
"distance_traveled" : 41.2873
} ], 
"2253" :  [ 
{ 
"stop_id" : 117,
"arrival_time" : "20:14:00" , 
"departure_time" : "20:15:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 45,
"arrival_time" : "20:18:53" , 
"departure_time" : "20:19:27" , 
"distance_traveled" : 2.3864
}, 
{ 
"stop_id" : 18,
"arrival_time" : "20:24:34" , 
"departure_time" : "20:24:58" , 
"distance_traveled" : 6.5206
}, 
{ 
"stop_id" : 12,
"arrival_time" : "20:27:24" , 
"departure_time" : "20:28:49" , 
"distance_traveled" : 7.6824
}, 
{ 
"stop_id" : 76,
"arrival_time" : "20:31:25" , 
"departure_time" : "20:31:32" , 
"distance_traveled" : 9.5644
}, 
{ 
"stop_id" : 88,
"arrival_time" : "20:33:07" , 
"departure_time" : "20:34:21" , 
"distance_traveled" : 11.204
}, 
{ 
"stop_id" : 143,
"arrival_time" : "20:38:14" , 
"departure_time" : "20:38:15" , 
"distance_traveled" : 12.8021
}, 
{ 
"stop_id" : 48,
"arrival_time" : "20:41:01" , 
"departure_time" : "20:42:38" , 
"distance_traveled" : 14.1564
}, 
{ 
"stop_id" : 17,
"arrival_time" : "20:45:37" , 
"departure_time" : "20:46:25" , 
"distance_traveled" : 15.5511
}, 
{ 
"stop_id" : 99,
"arrival_time" : "20:48:48" , 
"departure_time" : "20:49:57" , 
"distance_traveled" : 17.9172
}, 
{ 
"stop_id" : 104,
"arrival_time" : "20:52:09" , 
"departure_time" : "20:53:39" , 
"distance_traveled" : 19.5142
}, 
{ 
"stop_id" : 145,
"arrival_time" : "20:57:30" , 
"departure_time" : "20:58:54" , 
"distance_traveled" : 21.1919
}, 
{ 
"stop_id" : 106,
"arrival_time" : "21:13:24" , 
"departure_time" : "21:14:19" , 
"distance_traveled" : 33.4991
}, 
{ 
"stop_id" : 63,
"arrival_time" : "21:29:55" , 
"departure_time" : "21:29:55" , 
"distance_traveled" : 41.2873
} ], 
"2254" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "06:32:00" , 
"departure_time" : "06:33:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "06:36:33" , 
"departure_time" : "06:36:51" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "06:41:18" , 
"departure_time" : "06:41:52" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "06:47:34" , 
"departure_time" : "06:48:01" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "06:51:27" , 
"departure_time" : "06:51:32" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "06:55:05" , 
"departure_time" : "06:56:31" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "07:00:26" , 
"departure_time" : "07:00:42" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "07:02:16" , 
"departure_time" : "07:03:44" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "07:06:28" , 
"departure_time" : "07:08:08" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "07:10:40" , 
"departure_time" : "07:10:41" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "07:15:01" , 
"departure_time" : "07:15:36" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "07:19:35" , 
"departure_time" : "07:19:46" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:26:11" , 
"departure_time" : "07:26:21" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:33:10" , 
"departure_time" : "07:33:19" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 23,
"arrival_time" : "07:44:09" , 
"departure_time" : "07:45:47" , 
"distance_traveled" : 31.6498
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:12:38" , 
"departure_time" : "08:12:38" , 
"distance_traveled" : 44.8241
} ], 
"2255" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "06:32:00" , 
"departure_time" : "06:34:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "06:36:23" , 
"departure_time" : "06:36:43" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "06:41:20" , 
"departure_time" : "06:41:43" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "06:47:23" , 
"departure_time" : "06:47:38" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "06:51:15" , 
"departure_time" : "06:51:45" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "06:55:30" , 
"departure_time" : "06:57:10" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "07:00:40" , 
"departure_time" : "07:01:01" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "07:02:21" , 
"departure_time" : "07:02:23" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "07:05:02" , 
"departure_time" : "07:05:20" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "07:09:18" , 
"departure_time" : "07:10:46" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "07:16:28" , 
"departure_time" : "07:16:49" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "07:19:21" , 
"departure_time" : "07:20:51" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:27:30" , 
"departure_time" : "07:28:34" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:34:04" , 
"departure_time" : "07:35:22" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 23,
"arrival_time" : "07:45:18" , 
"departure_time" : "07:46:22" , 
"distance_traveled" : 31.6498
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:12:04" , 
"departure_time" : "08:12:04" , 
"distance_traveled" : 44.8241
} ], 
"2256" :  [ 
{ 
"stop_id" : 117,
"arrival_time" : "05:57:00" , 
"departure_time" : "05:58:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 45,
"arrival_time" : "06:01:43" , 
"departure_time" : "06:02:44" , 
"distance_traveled" : 2.3864
}, 
{ 
"stop_id" : 18,
"arrival_time" : "06:09:01" , 
"departure_time" : "06:09:16" , 
"distance_traveled" : 6.5206
}, 
{ 
"stop_id" : 12,
"arrival_time" : "06:11:15" , 
"departure_time" : "06:12:01" , 
"distance_traveled" : 7.6824
}, 
{ 
"stop_id" : 76,
"arrival_time" : "06:15:46" , 
"departure_time" : "06:16:12" , 
"distance_traveled" : 9.5644
}, 
{ 
"stop_id" : 88,
"arrival_time" : "06:18:26" , 
"departure_time" : "06:20:04" , 
"distance_traveled" : 11.204
}, 
{ 
"stop_id" : 143,
"arrival_time" : "06:22:38" , 
"departure_time" : "06:23:41" , 
"distance_traveled" : 12.8021
}, 
{ 
"stop_id" : 48,
"arrival_time" : "06:26:03" , 
"departure_time" : "06:27:28" , 
"distance_traveled" : 14.1564
}, 
{ 
"stop_id" : 17,
"arrival_time" : "06:29:25" , 
"departure_time" : "06:31:03" , 
"distance_traveled" : 15.5511
}, 
{ 
"stop_id" : 99,
"arrival_time" : "06:34:38" , 
"departure_time" : "06:35:03" , 
"distance_traveled" : 17.9172
}, 
{ 
"stop_id" : 104,
"arrival_time" : "06:37:25" , 
"departure_time" : "06:38:22" , 
"distance_traveled" : 19.5142
}, 
{ 
"stop_id" : 140,
"arrival_time" : "06:52:57" , 
"departure_time" : "06:54:27" , 
"distance_traveled" : 27.4252
}, 
{ 
"stop_id" : 112,
"arrival_time" : "06:57:30" , 
"departure_time" : "06:59:08" , 
"distance_traveled" : 29.8324
}, 
{ 
"stop_id" : 23,
"arrival_time" : "07:01:38" , 
"departure_time" : "07:02:45" , 
"distance_traveled" : 30.7333
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:07:07" , 
"departure_time" : "07:07:43" , 
"distance_traveled" : 33.5089
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:28:36" , 
"departure_time" : "07:28:36" , 
"distance_traveled" : 43.9309
} ], 
"2257" :  [ 
{ 
"stop_id" : 117,
"arrival_time" : "05:57:00" , 
"departure_time" : "05:57:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 45,
"arrival_time" : "06:01:13" , 
"departure_time" : "06:02:43" , 
"distance_traveled" : 2.3864
}, 
{ 
"stop_id" : 18,
"arrival_time" : "06:09:30" , 
"departure_time" : "06:10:57" , 
"distance_traveled" : 6.5206
}, 
{ 
"stop_id" : 12,
"arrival_time" : "06:12:27" , 
"departure_time" : "06:13:26" , 
"distance_traveled" : 7.6824
}, 
{ 
"stop_id" : 76,
"arrival_time" : "06:15:59" , 
"departure_time" : "06:17:21" , 
"distance_traveled" : 9.5644
}, 
{ 
"stop_id" : 88,
"arrival_time" : "06:19:22" , 
"departure_time" : "06:20:28" , 
"distance_traveled" : 11.204
}, 
{ 
"stop_id" : 143,
"arrival_time" : "06:22:06" , 
"departure_time" : "06:23:28" , 
"distance_traveled" : 12.8021
}, 
{ 
"stop_id" : 48,
"arrival_time" : "06:26:22" , 
"departure_time" : "06:27:42" , 
"distance_traveled" : 14.1564
}, 
{ 
"stop_id" : 17,
"arrival_time" : "06:29:20" , 
"departure_time" : "06:29:31" , 
"distance_traveled" : 15.5511
}, 
{ 
"stop_id" : 99,
"arrival_time" : "06:33:11" , 
"departure_time" : "06:33:37" , 
"distance_traveled" : 17.9172
}, 
{ 
"stop_id" : 104,
"arrival_time" : "06:37:26" , 
"departure_time" : "06:38:00" , 
"distance_traveled" : 19.5142
}, 
{ 
"stop_id" : 140,
"arrival_time" : "06:52:34" , 
"departure_time" : "06:52:59" , 
"distance_traveled" : 27.4252
}, 
{ 
"stop_id" : 112,
"arrival_time" : "06:56:25" , 
"departure_time" : "06:57:58" , 
"distance_traveled" : 29.8324
}, 
{ 
"stop_id" : 23,
"arrival_time" : "07:01:33" , 
"departure_time" : "07:01:40" , 
"distance_traveled" : 30.7333
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:06:07" , 
"departure_time" : "07:07:06" , 
"distance_traveled" : 33.5089
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:28:59" , 
"departure_time" : "07:28:59" , 
"distance_traveled" : 43.9309
} ], 
"2258" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "04:29:00" , 
"departure_time" : "04:30:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "04:32:14" , 
"departure_time" : "04:32:24" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "04:36:10" , 
"departure_time" : "04:36:45" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "04:42:35" , 
"departure_time" : "04:43:59" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "04:46:24" , 
"departure_time" : "04:48:02" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "04:49:38" , 
"departure_time" : "04:50:22" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "04:51:44" , 
"departure_time" : "04:51:48" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "04:54:04" , 
"departure_time" : "04:54:23" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "04:57:19" , 
"departure_time" : "04:57:37" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "05:00:18" , 
"departure_time" : "05:01:32" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "05:05:14" , 
"departure_time" : "05:06:04" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "05:07:50" , 
"departure_time" : "05:09:06" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "05:13:16" , 
"departure_time" : "05:14:01" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 136,
"arrival_time" : "05:16:45" , 
"departure_time" : "05:16:55" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 87,
"arrival_time" : "05:19:10" , 
"departure_time" : "05:20:38" , 
"distance_traveled" : 25.461
}, 
{ 
"stop_id" : 106,
"arrival_time" : "05:32:28" , 
"departure_time" : "05:32:46" , 
"distance_traveled" : 34.4252
}, 
{ 
"stop_id" : 63,
"arrival_time" : "05:46:18" , 
"departure_time" : "05:46:18" , 
"distance_traveled" : 42.2134
} ], 
"2259" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "04:29:00" , 
"departure_time" : "04:30:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "04:32:56" , 
"departure_time" : "04:33:42" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "04:36:46" , 
"departure_time" : "04:37:43" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "04:42:57" , 
"departure_time" : "04:44:31" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "04:46:34" , 
"departure_time" : "04:47:09" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "04:48:35" , 
"departure_time" : "04:49:46" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "04:52:11" , 
"departure_time" : "04:53:11" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "04:55:00" , 
"departure_time" : "04:55:50" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "04:57:50" , 
"departure_time" : "04:58:51" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "05:01:01" , 
"departure_time" : "05:01:25" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "05:04:24" , 
"departure_time" : "05:04:48" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "05:07:24" , 
"departure_time" : "05:07:44" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "05:12:20" , 
"departure_time" : "05:12:53" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 136,
"arrival_time" : "05:16:33" , 
"departure_time" : "05:16:53" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 87,
"arrival_time" : "05:19:20" , 
"departure_time" : "05:20:51" , 
"distance_traveled" : 25.461
}, 
{ 
"stop_id" : 106,
"arrival_time" : "05:32:31" , 
"departure_time" : "05:33:41" , 
"distance_traveled" : 34.4252
}, 
{ 
"stop_id" : 63,
"arrival_time" : "05:47:10" , 
"departure_time" : "05:47:10" , 
"distance_traveled" : 42.2134
} ], 
"2260" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "05:41:00" , 
"departure_time" : "05:42:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "05:45:41" , 
"departure_time" : "05:47:08" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "05:50:27" , 
"departure_time" : "05:51:26" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "05:55:59" , 
"departure_time" : "05:57:30" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "05:59:31" , 
"departure_time" : "06:00:53" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "06:03:22" , 
"departure_time" : "06:03:48" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "06:05:26" , 
"departure_time" : "06:05:30" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "06:08:04" , 
"departure_time" : "06:09:21" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "06:12:17" , 
"departure_time" : "06:13:53" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "06:15:36" , 
"departure_time" : "06:16:03" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "06:18:27" , 
"departure_time" : "06:18:49" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "06:22:22" , 
"departure_time" : "06:22:43" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "06:26:21" , 
"departure_time" : "06:27:29" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 136,
"arrival_time" : "06:32:08" , 
"departure_time" : "06:33:01" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 87,
"arrival_time" : "06:34:53" , 
"departure_time" : "06:36:07" , 
"distance_traveled" : 25.461
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:47:14" , 
"departure_time" : "06:48:11" , 
"distance_traveled" : 34.4252
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:03:57" , 
"departure_time" : "07:03:57" , 
"distance_traveled" : 42.2134
} ], 
"2261" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "05:41:00" , 
"departure_time" : "05:43:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "05:46:37" , 
"departure_time" : "05:48:11" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "05:50:34" , 
"departure_time" : "05:51:59" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "05:56:25" , 
"departure_time" : "05:56:52" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "05:58:27" , 
"departure_time" : "06:00:07" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "06:03:40" , 
"departure_time" : "06:05:05" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "06:06:25" , 
"departure_time" : "06:06:29" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "06:08:04" , 
"departure_time" : "06:09:43" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "06:12:39" , 
"departure_time" : "06:13:43" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "06:15:04" , 
"departure_time" : "06:15:29" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "06:18:25" , 
"departure_time" : "06:19:56" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "06:23:31" , 
"departure_time" : "06:24:21" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "06:26:50" , 
"departure_time" : "06:27:08" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 136,
"arrival_time" : "06:31:18" , 
"departure_time" : "06:31:26" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 87,
"arrival_time" : "06:34:08" , 
"departure_time" : "06:34:45" , 
"distance_traveled" : 25.461
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:46:37" , 
"departure_time" : "06:48:03" , 
"distance_traveled" : 34.4252
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:04:26" , 
"departure_time" : "07:04:26" , 
"distance_traveled" : 42.2134
} ], 
"2262" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "06:14:00" , 
"departure_time" : "06:15:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "06:18:15" , 
"departure_time" : "06:19:37" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "06:24:22" , 
"departure_time" : "06:24:49" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "06:29:27" , 
"departure_time" : "06:31:02" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "06:33:35" , 
"departure_time" : "06:35:05" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "06:36:30" , 
"departure_time" : "06:37:07" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "06:39:37" , 
"departure_time" : "06:40:44" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "06:43:07" , 
"departure_time" : "06:43:55" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "06:45:48" , 
"departure_time" : "06:45:56" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "06:48:08" , 
"departure_time" : "06:48:23" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "06:52:15" , 
"departure_time" : "06:53:06" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "06:56:51" , 
"departure_time" : "06:56:56" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:01:05" , 
"departure_time" : "07:01:24" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:06:19" , 
"departure_time" : "07:07:23" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:10:04" , 
"departure_time" : "07:11:02" , 
"distance_traveled" : 25.461
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:21:58" , 
"departure_time" : "07:22:07" , 
"distance_traveled" : 34.4252
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:37:09" , 
"departure_time" : "07:37:09" , 
"distance_traveled" : 42.2134
} ], 
"2263" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "06:14:00" , 
"departure_time" : "06:14:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "06:18:30" , 
"departure_time" : "06:19:25" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "06:23:55" , 
"departure_time" : "06:24:58" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "06:30:03" , 
"departure_time" : "06:30:18" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "06:32:15" , 
"departure_time" : "06:33:39" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "06:36:24" , 
"departure_time" : "06:37:02" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "06:39:38" , 
"departure_time" : "06:40:54" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "06:43:16" , 
"departure_time" : "06:43:40" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "06:45:24" , 
"departure_time" : "06:46:55" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "06:49:31" , 
"departure_time" : "06:50:59" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "06:53:28" , 
"departure_time" : "06:53:42" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "06:56:14" , 
"departure_time" : "06:57:20" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:02:06" , 
"departure_time" : "07:02:41" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:06:35" , 
"departure_time" : "07:07:06" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:09:31" , 
"departure_time" : "07:10:42" , 
"distance_traveled" : 25.461
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:22:11" , 
"departure_time" : "07:22:51" , 
"distance_traveled" : 34.4252
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:37:40" , 
"departure_time" : "07:37:40" , 
"distance_traveled" : 42.2134
} ], 
"2264" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "06:48:00" , 
"departure_time" : "06:50:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "06:53:27" , 
"departure_time" : "06:54:19" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "06:57:52" , 
"departure_time" : "06:59:12" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "07:04:20" , 
"departure_time" : "07:05:02" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "07:06:42" , 
"departure_time" : "07:07:39" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "07:10:57" , 
"departure_time" : "07:12:07" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "07:14:10" , 
"departure_time" : "07:14:15" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "07:16:05" , 
"departure_time" : "07:16:16" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "07:20:11" , 
"departure_time" : "07:20:51" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "07:23:40" , 
"departure_time" : "07:24:41" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "07:29:01" , 
"departure_time" : "07:29:24" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "07:32:23" , 
"departure_time" : "07:33:20" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:37:57" , 
"departure_time" : "07:38:32" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:42:35" , 
"departure_time" : "07:43:30" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:45:55" , 
"departure_time" : "07:47:25" , 
"distance_traveled" : 25.461
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:58:30" , 
"departure_time" : "07:58:46" , 
"distance_traveled" : 34.4252
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:13:16" , 
"departure_time" : "08:13:16" , 
"distance_traveled" : 42.2134
} ], 
"2265" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "06:48:00" , 
"departure_time" : "06:49:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "06:52:54" , 
"departure_time" : "06:53:25" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "06:57:31" , 
"departure_time" : "06:58:37" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "07:04:06" , 
"departure_time" : "07:05:28" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "07:07:22" , 
"departure_time" : "07:07:52" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "07:10:30" , 
"departure_time" : "07:11:55" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "07:14:25" , 
"departure_time" : "07:15:14" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "07:16:49" , 
"departure_time" : "07:17:15" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "07:20:26" , 
"departure_time" : "07:21:43" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "07:24:17" , 
"departure_time" : "07:24:41" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "07:28:24" , 
"departure_time" : "07:29:26" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "07:33:02" , 
"departure_time" : "07:34:14" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:38:12" , 
"departure_time" : "07:38:24" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:42:12" , 
"departure_time" : "07:43:51" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:46:39" , 
"departure_time" : "07:46:42" , 
"distance_traveled" : 25.461
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:57:03" , 
"departure_time" : "07:58:07" , 
"distance_traveled" : 34.4252
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:14:04" , 
"departure_time" : "08:14:04" , 
"distance_traveled" : 42.2134
} ], 
"2266" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "07:53:00" , 
"departure_time" : "07:55:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "07:57:27" , 
"departure_time" : "07:57:58" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "08:00:31" , 
"departure_time" : "08:01:13" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "08:07:42" , 
"departure_time" : "08:08:41" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "08:10:59" , 
"departure_time" : "08:11:53" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "08:13:54" , 
"departure_time" : "08:14:50" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "08:16:56" , 
"departure_time" : "08:17:55" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "08:19:59" , 
"departure_time" : "08:21:21" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "08:24:22" , 
"departure_time" : "08:24:49" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "08:26:27" , 
"departure_time" : "08:26:46" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "08:30:19" , 
"departure_time" : "08:30:37" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "08:34:18" , 
"departure_time" : "08:34:43" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "08:38:25" , 
"departure_time" : "08:38:40" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 136,
"arrival_time" : "08:43:15" , 
"departure_time" : "08:44:04" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 87,
"arrival_time" : "08:46:49" , 
"departure_time" : "08:47:36" , 
"distance_traveled" : 25.461
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:57:47" , 
"departure_time" : "08:58:18" , 
"distance_traveled" : 34.4252
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:13:31" , 
"departure_time" : "09:13:31" , 
"distance_traveled" : 42.2134
} ], 
"2267" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "07:53:00" , 
"departure_time" : "07:53:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "07:56:24" , 
"departure_time" : "07:56:36" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "08:00:12" , 
"departure_time" : "08:01:39" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "08:08:27" , 
"departure_time" : "08:09:30" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "08:11:03" , 
"departure_time" : "08:11:15" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "08:13:12" , 
"departure_time" : "08:14:33" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "08:17:21" , 
"departure_time" : "08:18:55" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "08:20:34" , 
"departure_time" : "08:21:14" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "08:23:40" , 
"departure_time" : "08:24:56" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "08:27:16" , 
"departure_time" : "08:27:41" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "08:30:25" , 
"departure_time" : "08:30:52" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "08:34:27" , 
"departure_time" : "08:34:49" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "08:38:22" , 
"departure_time" : "08:39:50" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 136,
"arrival_time" : "08:44:28" , 
"departure_time" : "08:45:49" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 87,
"arrival_time" : "08:47:21" , 
"departure_time" : "08:47:59" , 
"distance_traveled" : 25.461
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:57:38" , 
"departure_time" : "08:59:12" , 
"distance_traveled" : 34.4252
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:14:34" , 
"departure_time" : "09:14:34" , 
"distance_traveled" : 42.2134
} ], 
"2268" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "07:18:00" , 
"departure_time" : "07:21:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "07:23:26" , 
"departure_time" : "07:23:41" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "07:26:15" , 
"departure_time" : "07:26:54" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "07:33:39" , 
"departure_time" : "07:33:42" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "07:36:03" , 
"departure_time" : "07:37:38" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "07:40:35" , 
"departure_time" : "07:41:17" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "07:43:42" , 
"departure_time" : "07:44:22" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "07:46:40" , 
"departure_time" : "07:46:55" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "07:49:15" , 
"departure_time" : "07:50:04" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "07:53:49" , 
"departure_time" : "07:53:54" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "07:58:05" , 
"departure_time" : "07:59:01" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "08:01:56" , 
"departure_time" : "08:03:24" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "08:08:28" , 
"departure_time" : "08:08:38" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 81,
"arrival_time" : "08:15:10" , 
"departure_time" : "08:16:43" , 
"distance_traveled" : 27.0689
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:19:33" , 
"departure_time" : "08:20:52" , 
"distance_traveled" : 28.3513
}, 
{ 
"stop_id" : 97,
"arrival_time" : "08:22:19" , 
"departure_time" : "08:23:37" , 
"distance_traveled" : 29.1229
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:30:18" , 
"departure_time" : "08:31:21" , 
"distance_traveled" : 34.4335
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:47:03" , 
"departure_time" : "08:47:03" , 
"distance_traveled" : 42.2218
} ], 
"2269" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "07:18:00" , 
"departure_time" : "07:19:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "07:22:08" , 
"departure_time" : "07:22:59" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "07:26:51" , 
"departure_time" : "07:27:04" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "07:33:13" , 
"departure_time" : "07:34:47" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "07:37:34" , 
"departure_time" : "07:39:07" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "07:40:33" , 
"departure_time" : "07:40:36" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "07:43:03" , 
"departure_time" : "07:43:16" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "07:46:13" , 
"departure_time" : "07:46:24" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "07:49:11" , 
"departure_time" : "07:49:18" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "07:53:07" , 
"departure_time" : "07:54:39" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "07:59:32" , 
"departure_time" : "08:00:52" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "08:02:20" , 
"departure_time" : "08:02:34" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "08:07:14" , 
"departure_time" : "08:08:42" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 81,
"arrival_time" : "08:16:28" , 
"departure_time" : "08:17:46" , 
"distance_traveled" : 27.0689
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:19:18" , 
"departure_time" : "08:19:38" , 
"distance_traveled" : 28.3513
}, 
{ 
"stop_id" : 97,
"arrival_time" : "08:21:20" , 
"departure_time" : "08:21:34" , 
"distance_traveled" : 29.1229
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:29:14" , 
"departure_time" : "08:30:18" , 
"distance_traveled" : 34.4335
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:47:04" , 
"departure_time" : "08:47:04" , 
"distance_traveled" : 42.2218
} ], 
"2270" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "16:37:00" , 
"departure_time" : "16:39:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "16:41:16" , 
"departure_time" : "16:41:24" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "16:44:08" , 
"departure_time" : "16:45:17" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "16:52:09" , 
"departure_time" : "16:53:16" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "16:55:07" , 
"departure_time" : "16:56:07" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "16:58:00" , 
"departure_time" : "16:59:37" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "17:01:37" , 
"departure_time" : "17:03:17" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "17:04:40" , 
"departure_time" : "17:04:58" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "17:06:18" , 
"departure_time" : "17:06:59" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "17:09:41" , 
"departure_time" : "17:10:52" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "17:14:11" , 
"departure_time" : "17:14:17" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "17:16:06" , 
"departure_time" : "17:17:41" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:22:35" , 
"departure_time" : "17:24:06" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:30:31" , 
"departure_time" : "17:32:03" , 
"distance_traveled" : 28.3523
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:35:32" , 
"departure_time" : "17:36:26" , 
"distance_traveled" : 31.6591
}, 
{ 
"stop_id" : 37,
"arrival_time" : "17:37:54" , 
"departure_time" : "17:39:11" , 
"distance_traveled" : 32.1869
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:43:17" , 
"departure_time" : "17:44:00" , 
"distance_traveled" : 34.4347
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:59:43" , 
"departure_time" : "17:59:43" , 
"distance_traveled" : 42.2229
} ], 
"2271" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "16:37:00" , 
"departure_time" : "16:37:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "16:40:05" , 
"departure_time" : "16:40:20" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "16:44:15" , 
"departure_time" : "16:44:47" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "16:51:32" , 
"departure_time" : "16:52:19" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "16:54:47" , 
"departure_time" : "16:56:06" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "16:58:19" , 
"departure_time" : "16:59:44" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "17:01:25" , 
"departure_time" : "17:01:55" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "17:03:30" , 
"departure_time" : "17:04:45" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "17:07:15" , 
"departure_time" : "17:07:59" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "17:09:44" , 
"departure_time" : "17:09:54" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "17:13:10" , 
"departure_time" : "17:14:46" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "17:17:36" , 
"departure_time" : "17:17:57" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:21:21" , 
"departure_time" : "17:22:43" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:30:22" , 
"departure_time" : "17:31:18" , 
"distance_traveled" : 28.3523
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:34:56" , 
"departure_time" : "17:35:33" , 
"distance_traveled" : 31.6591
}, 
{ 
"stop_id" : 37,
"arrival_time" : "17:37:37" , 
"departure_time" : "17:38:11" , 
"distance_traveled" : 32.1869
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:42:34" , 
"departure_time" : "17:43:51" , 
"distance_traveled" : 34.4347
}, 
{ 
"stop_id" : 63,
"arrival_time" : "18:00:17" , 
"departure_time" : "18:00:17" , 
"distance_traveled" : 42.2229
} ], 
"2272" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "05:10:00" , 
"departure_time" : "05:11:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "05:14:09" , 
"departure_time" : "05:15:48" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "05:19:39" , 
"departure_time" : "05:20:45" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "05:25:06" , 
"departure_time" : "05:25:29" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "05:27:23" , 
"departure_time" : "05:28:21" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "05:30:58" , 
"departure_time" : "05:32:17" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "05:34:19" , 
"departure_time" : "05:35:44" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "05:37:25" , 
"departure_time" : "05:38:30" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "05:40:05" , 
"departure_time" : "05:41:04" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "05:43:59" , 
"departure_time" : "05:44:59" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "05:47:00" , 
"departure_time" : "05:47:41" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "05:50:41" , 
"departure_time" : "05:51:51" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "05:56:10" , 
"departure_time" : "05:57:13" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 136,
"arrival_time" : "06:00:03" , 
"departure_time" : "06:00:59" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 87,
"arrival_time" : "06:02:56" , 
"departure_time" : "06:04:36" , 
"distance_traveled" : 25.461
}, 
{ 
"stop_id" : 81,
"arrival_time" : "06:06:40" , 
"departure_time" : "06:07:54" , 
"distance_traveled" : 27.0697
}, 
{ 
"stop_id" : 140,
"arrival_time" : "06:09:14" , 
"departure_time" : "06:10:33" , 
"distance_traveled" : 28.3521
}, 
{ 
"stop_id" : 23,
"arrival_time" : "06:13:19" , 
"departure_time" : "06:14:22" , 
"distance_traveled" : 31.6589
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:18:03" , 
"departure_time" : "06:18:18" , 
"distance_traveled" : 34.4345
}, 
{ 
"stop_id" : 63,
"arrival_time" : "06:33:15" , 
"departure_time" : "06:33:15" , 
"distance_traveled" : 42.2227
} ], 
"2273" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "05:10:00" , 
"departure_time" : "05:10:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "05:14:10" , 
"departure_time" : "05:14:50" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "05:18:40" , 
"departure_time" : "05:19:52" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "05:25:12" , 
"departure_time" : "05:25:24" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "05:27:12" , 
"departure_time" : "05:27:47" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "05:30:35" , 
"departure_time" : "05:31:01" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "05:33:26" , 
"departure_time" : "05:35:01" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "05:37:35" , 
"departure_time" : "05:37:38" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "05:39:03" , 
"departure_time" : "05:39:06" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "05:43:03" , 
"departure_time" : "05:43:28" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "05:46:25" , 
"departure_time" : "05:47:15" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "05:50:50" , 
"departure_time" : "05:52:03" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "05:56:13" , 
"departure_time" : "05:56:35" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 136,
"arrival_time" : "05:59:22" , 
"departure_time" : "05:59:33" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 87,
"arrival_time" : "06:02:11" , 
"departure_time" : "06:02:35" , 
"distance_traveled" : 25.461
}, 
{ 
"stop_id" : 81,
"arrival_time" : "06:05:24" , 
"departure_time" : "06:05:28" , 
"distance_traveled" : 27.0697
}, 
{ 
"stop_id" : 140,
"arrival_time" : "06:08:04" , 
"departure_time" : "06:08:15" , 
"distance_traveled" : 28.3521
}, 
{ 
"stop_id" : 23,
"arrival_time" : "06:12:11" , 
"departure_time" : "06:12:38" , 
"distance_traveled" : 31.6589
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:17:27" , 
"departure_time" : "06:18:09" , 
"distance_traveled" : 34.4345
}, 
{ 
"stop_id" : 63,
"arrival_time" : "06:33:42" , 
"departure_time" : "06:33:42" , 
"distance_traveled" : 42.2227
} ], 
"2274" :  [ 
{ 
"stop_id" : 18,
"arrival_time" : "08:55:00" , 
"departure_time" : "08:56:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 12,
"arrival_time" : "08:59:20" , 
"departure_time" : "08:59:56" , 
"distance_traveled" : 1.1617
}, 
{ 
"stop_id" : 76,
"arrival_time" : "09:02:36" , 
"departure_time" : "09:03:25" , 
"distance_traveled" : 3.0438
}, 
{ 
"stop_id" : 88,
"arrival_time" : "09:05:49" , 
"departure_time" : "09:06:23" , 
"distance_traveled" : 4.6833
}, 
{ 
"stop_id" : 143,
"arrival_time" : "09:08:34" , 
"departure_time" : "09:09:42" , 
"distance_traveled" : 6.2814
}, 
{ 
"stop_id" : 48,
"arrival_time" : "09:12:08" , 
"departure_time" : "09:12:11" , 
"distance_traveled" : 7.6358
}, 
{ 
"stop_id" : 17,
"arrival_time" : "09:14:03" , 
"departure_time" : "09:14:25" , 
"distance_traveled" : 9.0305
}, 
{ 
"stop_id" : 99,
"arrival_time" : "09:18:22" , 
"departure_time" : "09:18:38" , 
"distance_traveled" : 11.3966
}, 
{ 
"stop_id" : 104,
"arrival_time" : "09:22:16" , 
"departure_time" : "09:22:54" , 
"distance_traveled" : 12.9936
}, 
{ 
"stop_id" : 145,
"arrival_time" : "09:26:38" , 
"departure_time" : "09:27:37" , 
"distance_traveled" : 14.6712
}, 
{ 
"stop_id" : 136,
"arrival_time" : "09:30:59" , 
"departure_time" : "09:32:37" , 
"distance_traveled" : 16.9396
}, 
{ 
"stop_id" : 87,
"arrival_time" : "09:34:38" , 
"departure_time" : "09:35:07" , 
"distance_traveled" : 18.014
}, 
{ 
"stop_id" : 81,
"arrival_time" : "09:37:29" , 
"departure_time" : "09:38:55" , 
"distance_traveled" : 19.6227
}, 
{ 
"stop_id" : 140,
"arrival_time" : "09:41:26" , 
"departure_time" : "09:42:52" , 
"distance_traveled" : 20.9051
}, 
{ 
"stop_id" : 97,
"arrival_time" : "09:43:26" , 
"departure_time" : "09:43:52" , 
"distance_traveled" : 21.6767
}, 
{ 
"stop_id" : 61,
"arrival_time" : "09:44:26" , 
"departure_time" : "09:44:27" , 
"distance_traveled" : 22.6047
}, 
{ 
"stop_id" : 112,
"arrival_time" : "09:47:01" , 
"departure_time" : "09:48:12" , 
"distance_traveled" : 23.3125
}, 
{ 
"stop_id" : 23,
"arrival_time" : "09:50:11" , 
"departure_time" : "09:51:11" , 
"distance_traveled" : 24.2134
}, 
{ 
"stop_id" : 37,
"arrival_time" : "09:52:00" , 
"departure_time" : "09:52:59" , 
"distance_traveled" : 24.7413
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:56:59" , 
"departure_time" : "09:57:26" , 
"distance_traveled" : 26.989
}, 
{ 
"stop_id" : 63,
"arrival_time" : "10:13:27" , 
"departure_time" : "10:13:27" , 
"distance_traveled" : 34.7773
} ], 
"2275" :  [ 
{ 
"stop_id" : 18,
"arrival_time" : "08:55:00" , 
"departure_time" : "08:56:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 12,
"arrival_time" : "08:59:33" , 
"departure_time" : "08:59:50" , 
"distance_traveled" : 1.1617
}, 
{ 
"stop_id" : 76,
"arrival_time" : "09:02:17" , 
"departure_time" : "09:02:58" , 
"distance_traveled" : 3.0438
}, 
{ 
"stop_id" : 88,
"arrival_time" : "09:05:41" , 
"departure_time" : "09:06:18" , 
"distance_traveled" : 4.6833
}, 
{ 
"stop_id" : 143,
"arrival_time" : "09:08:37" , 
"departure_time" : "09:08:58" , 
"distance_traveled" : 6.2814
}, 
{ 
"stop_id" : 48,
"arrival_time" : "09:11:21" , 
"departure_time" : "09:12:04" , 
"distance_traveled" : 7.6358
}, 
{ 
"stop_id" : 17,
"arrival_time" : "09:14:43" , 
"departure_time" : "09:15:38" , 
"distance_traveled" : 9.0305
}, 
{ 
"stop_id" : 99,
"arrival_time" : "09:18:55" , 
"departure_time" : "09:19:47" , 
"distance_traveled" : 11.3966
}, 
{ 
"stop_id" : 104,
"arrival_time" : "09:22:52" , 
"departure_time" : "09:23:36" , 
"distance_traveled" : 12.9936
}, 
{ 
"stop_id" : 145,
"arrival_time" : "09:26:44" , 
"departure_time" : "09:28:09" , 
"distance_traveled" : 14.6712
}, 
{ 
"stop_id" : 136,
"arrival_time" : "09:31:25" , 
"departure_time" : "09:32:12" , 
"distance_traveled" : 16.9396
}, 
{ 
"stop_id" : 87,
"arrival_time" : "09:33:47" , 
"departure_time" : "09:34:05" , 
"distance_traveled" : 18.014
}, 
{ 
"stop_id" : 81,
"arrival_time" : "09:37:18" , 
"departure_time" : "09:38:12" , 
"distance_traveled" : 19.6227
}, 
{ 
"stop_id" : 140,
"arrival_time" : "09:40:54" , 
"departure_time" : "09:42:24" , 
"distance_traveled" : 20.9051
}, 
{ 
"stop_id" : 97,
"arrival_time" : "09:43:30" , 
"departure_time" : "09:44:08" , 
"distance_traveled" : 21.6767
}, 
{ 
"stop_id" : 61,
"arrival_time" : "09:44:38" , 
"departure_time" : "09:45:57" , 
"distance_traveled" : 22.6047
}, 
{ 
"stop_id" : 112,
"arrival_time" : "09:48:19" , 
"departure_time" : "09:48:58" , 
"distance_traveled" : 23.3125
}, 
{ 
"stop_id" : 23,
"arrival_time" : "09:49:39" , 
"departure_time" : "09:49:56" , 
"distance_traveled" : 24.2134
}, 
{ 
"stop_id" : 37,
"arrival_time" : "09:51:17" , 
"departure_time" : "09:52:35" , 
"distance_traveled" : 24.7413
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:57:18" , 
"departure_time" : "09:57:50" , 
"distance_traveled" : 26.989
}, 
{ 
"stop_id" : 63,
"arrival_time" : "10:13:32" , 
"departure_time" : "10:13:32" , 
"distance_traveled" : 34.7773
} ], 
"2276" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "15:46:00" , 
"departure_time" : "15:47:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "15:51:16" , 
"departure_time" : "15:52:15" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "15:54:59" , 
"departure_time" : "15:55:05" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "16:01:06" , 
"departure_time" : "16:02:16" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "16:06:10" , 
"departure_time" : "16:07:25" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "16:09:15" , 
"departure_time" : "16:10:02" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "16:11:47" , 
"departure_time" : "16:13:22" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "16:15:35" , 
"departure_time" : "16:15:49" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "16:17:14" , 
"departure_time" : "16:18:03" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "16:20:49" , 
"departure_time" : "16:21:51" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "16:27:02" , 
"departure_time" : "16:27:46" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "16:29:44" , 
"departure_time" : "16:30:40" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:34:56" , 
"departure_time" : "16:36:04" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 81,
"arrival_time" : "16:43:08" , 
"departure_time" : "16:43:55" , 
"distance_traveled" : 27.0689
}, 
{ 
"stop_id" : 140,
"arrival_time" : "16:45:47" , 
"departure_time" : "16:46:12" , 
"distance_traveled" : 28.3513
}, 
{ 
"stop_id" : 97,
"arrival_time" : "16:47:25" , 
"departure_time" : "16:47:28" , 
"distance_traveled" : 29.1229
}, 
{ 
"stop_id" : 61,
"arrival_time" : "16:49:03" , 
"departure_time" : "16:49:09" , 
"distance_traveled" : 30.0509
}, 
{ 
"stop_id" : 112,
"arrival_time" : "16:52:06" , 
"departure_time" : "16:53:05" , 
"distance_traveled" : 30.7587
}, 
{ 
"stop_id" : 23,
"arrival_time" : "16:54:59" , 
"departure_time" : "16:56:11" , 
"distance_traveled" : 31.6597
}, 
{ 
"stop_id" : 37,
"arrival_time" : "16:58:12" , 
"departure_time" : "16:58:35" , 
"distance_traveled" : 32.1875
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:01:23" , 
"departure_time" : "17:02:24" , 
"distance_traveled" : 34.4352
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:18:01" , 
"departure_time" : "17:18:01" , 
"distance_traveled" : 42.2235
} ], 
"2277" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "15:46:00" , 
"departure_time" : "15:48:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "15:51:25" , 
"departure_time" : "15:52:39" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "15:55:14" , 
"departure_time" : "15:56:06" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "16:01:52" , 
"departure_time" : "16:02:46" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "16:05:54" , 
"departure_time" : "16:07:29" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "16:09:35" , 
"departure_time" : "16:10:48" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "16:12:13" , 
"departure_time" : "16:13:32" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "16:15:19" , 
"departure_time" : "16:16:34" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "16:18:15" , 
"departure_time" : "16:19:02" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "16:20:47" , 
"departure_time" : "16:21:47" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "16:27:00" , 
"departure_time" : "16:27:55" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "16:29:55" , 
"departure_time" : "16:30:23" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:34:28" , 
"departure_time" : "16:34:42" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 81,
"arrival_time" : "16:42:14" , 
"departure_time" : "16:43:51" , 
"distance_traveled" : 27.0689
}, 
{ 
"stop_id" : 140,
"arrival_time" : "16:46:37" , 
"departure_time" : "16:46:53" , 
"distance_traveled" : 28.3513
}, 
{ 
"stop_id" : 97,
"arrival_time" : "16:47:16" , 
"departure_time" : "16:48:24" , 
"distance_traveled" : 29.1229
}, 
{ 
"stop_id" : 61,
"arrival_time" : "16:50:08" , 
"departure_time" : "16:51:19" , 
"distance_traveled" : 30.0509
}, 
{ 
"stop_id" : 112,
"arrival_time" : "16:53:11" , 
"departure_time" : "16:54:36" , 
"distance_traveled" : 30.7587
}, 
{ 
"stop_id" : 23,
"arrival_time" : "16:55:25" , 
"departure_time" : "16:56:50" , 
"distance_traveled" : 31.6597
}, 
{ 
"stop_id" : 37,
"arrival_time" : "16:58:25" , 
"departure_time" : "16:59:29" , 
"distance_traveled" : 32.1875
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:02:04" , 
"departure_time" : "17:02:52" , 
"distance_traveled" : 34.4352
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:17:48" , 
"departure_time" : "17:17:48" , 
"distance_traveled" : 42.2235
} ], 
"2278" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "09:55:00" , 
"departure_time" : "09:56:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "09:58:57" , 
"departure_time" : "09:59:31" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "10:02:34" , 
"departure_time" : "10:04:04" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "10:11:30" , 
"departure_time" : "10:12:38" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "10:15:08" , 
"departure_time" : "10:16:43" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "10:18:35" , 
"departure_time" : "10:19:41" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "10:21:06" , 
"departure_time" : "10:22:42" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "10:24:36" , 
"departure_time" : "10:25:13" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "10:26:37" , 
"departure_time" : "10:27:48" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "10:31:11" , 
"departure_time" : "10:31:57" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "10:34:46" , 
"departure_time" : "10:35:01" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "10:38:15" , 
"departure_time" : "10:39:51" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "10:43:36" , 
"departure_time" : "10:51:46" , 
"distance_traveled" : 22.1186
}, 
{ 
"stop_id" : 136,
"arrival_time" : "10:54:10" , 
"departure_time" : "10:55:44" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 87,
"arrival_time" : "10:58:34" , 
"departure_time" : "10:59:43" , 
"distance_traveled" : 25.461
}, 
{ 
"stop_id" : 81,
"arrival_time" : "11:01:09" , 
"departure_time" : "11:02:24" , 
"distance_traveled" : 27.0697
}, 
{ 
"stop_id" : 140,
"arrival_time" : "11:04:15" , 
"departure_time" : "11:05:28" , 
"distance_traveled" : 28.3521
}, 
{ 
"stop_id" : 97,
"arrival_time" : "11:06:13" , 
"departure_time" : "11:06:28" , 
"distance_traveled" : 29.1237
}, 
{ 
"stop_id" : 61,
"arrival_time" : "11:07:15" , 
"departure_time" : "11:08:55" , 
"distance_traveled" : 30.0517
}, 
{ 
"stop_id" : 112,
"arrival_time" : "11:10:40" , 
"departure_time" : "11:12:05" , 
"distance_traveled" : 30.7595
}, 
{ 
"stop_id" : 23,
"arrival_time" : "11:13:25" , 
"departure_time" : "11:13:34" , 
"distance_traveled" : 31.6604
}, 
{ 
"stop_id" : 37,
"arrival_time" : "11:14:09" , 
"departure_time" : "11:15:18" , 
"distance_traveled" : 32.1883
}, 
{ 
"stop_id" : 106,
"arrival_time" : "11:20:09" , 
"departure_time" : "11:20:56" , 
"distance_traveled" : 34.436
}, 
{ 
"stop_id" : 63,
"arrival_time" : "11:38:47" , 
"departure_time" : "11:38:47" , 
"distance_traveled" : 42.2242
} ], 
"2279" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "09:55:00" , 
"departure_time" : "09:56:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "09:58:57" , 
"departure_time" : "09:59:22" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "10:02:25" , 
"departure_time" : "10:02:52" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "10:10:27" , 
"departure_time" : "10:11:57" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "10:15:30" , 
"departure_time" : "10:15:51" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "10:17:21" , 
"departure_time" : "10:18:02" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "10:20:41" , 
"departure_time" : "10:21:44" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "10:24:03" , 
"departure_time" : "10:25:02" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "10:26:59" , 
"departure_time" : "10:27:12" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "10:30:13" , 
"departure_time" : "10:31:38" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "10:35:25" , 
"departure_time" : "10:36:05" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "10:38:40" , 
"departure_time" : "10:39:45" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "10:43:05" , 
"departure_time" : "10:52:16" , 
"distance_traveled" : 22.1186
}, 
{ 
"stop_id" : 136,
"arrival_time" : "10:55:11" , 
"departure_time" : "10:56:18" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 87,
"arrival_time" : "10:58:07" , 
"departure_time" : "10:59:20" , 
"distance_traveled" : 25.461
}, 
{ 
"stop_id" : 81,
"arrival_time" : "11:01:13" , 
"departure_time" : "11:02:11" , 
"distance_traveled" : 27.0697
}, 
{ 
"stop_id" : 140,
"arrival_time" : "11:03:58" , 
"departure_time" : "11:04:12" , 
"distance_traveled" : 28.3521
}, 
{ 
"stop_id" : 97,
"arrival_time" : "11:05:14" , 
"departure_time" : "11:05:57" , 
"distance_traveled" : 29.1237
}, 
{ 
"stop_id" : 61,
"arrival_time" : "11:07:43" , 
"departure_time" : "11:07:58" , 
"distance_traveled" : 30.0517
}, 
{ 
"stop_id" : 112,
"arrival_time" : "11:09:15" , 
"departure_time" : "11:09:54" , 
"distance_traveled" : 30.7595
}, 
{ 
"stop_id" : 23,
"arrival_time" : "11:12:39" , 
"departure_time" : "11:14:08" , 
"distance_traveled" : 31.6604
}, 
{ 
"stop_id" : 37,
"arrival_time" : "11:15:29" , 
"departure_time" : "11:15:32" , 
"distance_traveled" : 32.1883
}, 
{ 
"stop_id" : 106,
"arrival_time" : "11:19:03" , 
"departure_time" : "11:19:09" , 
"distance_traveled" : 34.436
}, 
{ 
"stop_id" : 63,
"arrival_time" : "11:38:06" , 
"departure_time" : "11:38:06" , 
"distance_traveled" : 42.2242
} ], 
"2280" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "10:53:00" , 
"departure_time" : "10:54:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "10:57:20" , 
"departure_time" : "10:58:10" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "11:03:50" , 
"departure_time" : "11:04:41" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "11:09:51" , 
"departure_time" : "11:09:59" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "11:12:08" , 
"departure_time" : "11:13:25" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "11:16:17" , 
"departure_time" : "11:16:23" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "11:18:06" , 
"departure_time" : "11:19:27" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "11:22:21" , 
"departure_time" : "11:23:53" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "11:25:32" , 
"departure_time" : "11:26:08" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "11:28:36" , 
"departure_time" : "11:29:54" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "11:34:18" , 
"departure_time" : "11:35:52" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "11:38:34" , 
"departure_time" : "11:38:44" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "11:41:10" , 
"departure_time" : "11:41:56" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 136,
"arrival_time" : "11:46:46" , 
"departure_time" : "11:47:36" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 87,
"arrival_time" : "11:49:50" , 
"departure_time" : "11:51:23" , 
"distance_traveled" : 25.461
}, 
{ 
"stop_id" : 81,
"arrival_time" : "11:53:33" , 
"departure_time" : "11:53:53" , 
"distance_traveled" : 27.0697
}, 
{ 
"stop_id" : 140,
"arrival_time" : "11:55:20" , 
"departure_time" : "11:56:20" , 
"distance_traveled" : 28.3521
}, 
{ 
"stop_id" : 97,
"arrival_time" : "11:59:00" , 
"departure_time" : "12:00:32" , 
"distance_traveled" : 29.1237
}, 
{ 
"stop_id" : 61,
"arrival_time" : "12:01:32" , 
"departure_time" : "12:02:35" , 
"distance_traveled" : 30.0517
}, 
{ 
"stop_id" : 112,
"arrival_time" : "12:03:03" , 
"departure_time" : "12:03:12" , 
"distance_traveled" : 30.7595
}, 
{ 
"stop_id" : 23,
"arrival_time" : "12:04:09" , 
"departure_time" : "12:05:21" , 
"distance_traveled" : 31.6604
}, 
{ 
"stop_id" : 37,
"arrival_time" : "12:08:12" , 
"departure_time" : "12:08:42" , 
"distance_traveled" : 32.1883
}, 
{ 
"stop_id" : 106,
"arrival_time" : "12:11:30" , 
"departure_time" : "12:12:36" , 
"distance_traveled" : 34.436
}, 
{ 
"stop_id" : 63,
"arrival_time" : "12:30:06" , 
"departure_time" : "12:30:06" , 
"distance_traveled" : 42.2242
} ], 
"2281" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "10:53:00" , 
"departure_time" : "10:55:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "10:57:15" , 
"departure_time" : "10:57:28" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "11:03:13" , 
"departure_time" : "11:04:28" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "11:10:15" , 
"departure_time" : "11:11:08" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "11:12:53" , 
"departure_time" : "11:14:01" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "11:16:08" , 
"departure_time" : "11:16:49" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "11:18:41" , 
"departure_time" : "11:18:50" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "11:21:09" , 
"departure_time" : "11:21:45" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "11:24:36" , 
"departure_time" : "11:25:54" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "11:29:18" , 
"departure_time" : "11:30:03" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "11:33:45" , 
"departure_time" : "11:33:49" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "11:37:04" , 
"departure_time" : "11:38:03" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "11:41:59" , 
"departure_time" : "11:42:51" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 136,
"arrival_time" : "11:46:52" , 
"departure_time" : "11:48:09" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 87,
"arrival_time" : "11:50:17" , 
"departure_time" : "11:50:51" , 
"distance_traveled" : 25.461
}, 
{ 
"stop_id" : 81,
"arrival_time" : "11:52:34" , 
"departure_time" : "11:52:47" , 
"distance_traveled" : 27.0697
}, 
{ 
"stop_id" : 140,
"arrival_time" : "11:55:13" , 
"departure_time" : "11:56:48" , 
"distance_traveled" : 28.3521
}, 
{ 
"stop_id" : 97,
"arrival_time" : "11:59:35" , 
"departure_time" : "11:59:49" , 
"distance_traveled" : 29.1237
}, 
{ 
"stop_id" : 61,
"arrival_time" : "12:00:14" , 
"departure_time" : "12:00:18" , 
"distance_traveled" : 30.0517
}, 
{ 
"stop_id" : 112,
"arrival_time" : "12:02:04" , 
"departure_time" : "12:02:41" , 
"distance_traveled" : 30.7595
}, 
{ 
"stop_id" : 23,
"arrival_time" : "12:04:37" , 
"departure_time" : "12:05:04" , 
"distance_traveled" : 31.6604
}, 
{ 
"stop_id" : 37,
"arrival_time" : "12:07:27" , 
"departure_time" : "12:07:29" , 
"distance_traveled" : 32.1883
}, 
{ 
"stop_id" : 106,
"arrival_time" : "12:11:02" , 
"departure_time" : "12:11:44" , 
"distance_traveled" : 34.436
}, 
{ 
"stop_id" : 63,
"arrival_time" : "12:29:42" , 
"departure_time" : "12:29:42" , 
"distance_traveled" : 42.2242
} ], 
"2282" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "11:58:00" , 
"departure_time" : "12:00:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "12:03:29" , 
"departure_time" : "12:05:03" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "12:07:34" , 
"departure_time" : "12:08:14" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "12:12:40" , 
"departure_time" : "12:13:00" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "12:15:20" , 
"departure_time" : "12:16:57" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "12:19:37" , 
"departure_time" : "12:20:56" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "12:22:19" , 
"departure_time" : "12:22:43" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "12:24:24" , 
"departure_time" : "12:25:30" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "12:28:06" , 
"departure_time" : "12:28:18" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "12:30:12" , 
"departure_time" : "12:30:54" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "12:35:42" , 
"departure_time" : "12:36:16" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "12:40:34" , 
"departure_time" : "12:41:47" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "12:46:13" , 
"departure_time" : "12:46:21" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 136,
"arrival_time" : "12:49:08" , 
"departure_time" : "12:50:24" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 87,
"arrival_time" : "12:53:16" , 
"departure_time" : "12:54:29" , 
"distance_traveled" : 25.461
}, 
{ 
"stop_id" : 81,
"arrival_time" : "12:57:13" , 
"departure_time" : "12:58:10" , 
"distance_traveled" : 27.0697
}, 
{ 
"stop_id" : 140,
"arrival_time" : "12:59:57" , 
"departure_time" : "13:00:13" , 
"distance_traveled" : 28.3521
}, 
{ 
"stop_id" : 97,
"arrival_time" : "13:01:16" , 
"departure_time" : "13:01:48" , 
"distance_traveled" : 29.1237
}, 
{ 
"stop_id" : 61,
"arrival_time" : "13:03:32" , 
"departure_time" : "13:04:52" , 
"distance_traveled" : 30.0517
}, 
{ 
"stop_id" : 112,
"arrival_time" : "13:07:20" , 
"departure_time" : "13:07:38" , 
"distance_traveled" : 30.7595
}, 
{ 
"stop_id" : 23,
"arrival_time" : "13:08:18" , 
"departure_time" : "13:09:27" , 
"distance_traveled" : 31.6604
}, 
{ 
"stop_id" : 37,
"arrival_time" : "13:11:09" , 
"departure_time" : "13:12:14" , 
"distance_traveled" : 32.1883
}, 
{ 
"stop_id" : 106,
"arrival_time" : "13:15:05" , 
"departure_time" : "13:15:29" , 
"distance_traveled" : 34.436
}, 
{ 
"stop_id" : 63,
"arrival_time" : "13:32:24" , 
"departure_time" : "13:32:24" , 
"distance_traveled" : 42.2242
} ], 
"2283" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "11:58:00" , 
"departure_time" : "11:58:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "12:02:23" , 
"departure_time" : "12:03:17" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "12:06:54" , 
"departure_time" : "12:08:05" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "12:13:11" , 
"departure_time" : "12:14:27" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "12:16:16" , 
"departure_time" : "12:17:39" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "12:19:23" , 
"departure_time" : "12:19:45" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "12:21:22" , 
"departure_time" : "12:21:37" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "12:24:15" , 
"departure_time" : "12:24:42" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "12:27:27" , 
"departure_time" : "12:27:38" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "12:30:11" , 
"departure_time" : "12:30:34" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "12:35:23" , 
"departure_time" : "12:37:02" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "12:41:39" , 
"departure_time" : "12:42:02" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "12:45:23" , 
"departure_time" : "12:45:48" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 136,
"arrival_time" : "12:49:25" , 
"departure_time" : "12:49:26" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 87,
"arrival_time" : "12:52:01" , 
"departure_time" : "12:53:24" , 
"distance_traveled" : 25.461
}, 
{ 
"stop_id" : 81,
"arrival_time" : "12:57:23" , 
"departure_time" : "12:57:43" , 
"distance_traveled" : 27.0697
}, 
{ 
"stop_id" : 140,
"arrival_time" : "12:59:20" , 
"departure_time" : "13:00:16" , 
"distance_traveled" : 28.3521
}, 
{ 
"stop_id" : 97,
"arrival_time" : "13:01:56" , 
"departure_time" : "13:03:23" , 
"distance_traveled" : 29.1237
}, 
{ 
"stop_id" : 61,
"arrival_time" : "13:04:27" , 
"departure_time" : "13:06:02" , 
"distance_traveled" : 30.0517
}, 
{ 
"stop_id" : 112,
"arrival_time" : "13:07:35" , 
"departure_time" : "13:08:36" , 
"distance_traveled" : 30.7595
}, 
{ 
"stop_id" : 23,
"arrival_time" : "13:09:01" , 
"departure_time" : "13:09:23" , 
"distance_traveled" : 31.6604
}, 
{ 
"stop_id" : 37,
"arrival_time" : "13:10:22" , 
"departure_time" : "13:10:39" , 
"distance_traveled" : 32.1883
}, 
{ 
"stop_id" : 106,
"arrival_time" : "13:14:17" , 
"departure_time" : "13:14:46" , 
"distance_traveled" : 34.436
}, 
{ 
"stop_id" : 63,
"arrival_time" : "13:32:29" , 
"departure_time" : "13:32:29" , 
"distance_traveled" : 42.2242
} ], 
"2284" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "12:58:00" , 
"departure_time" : "12:58:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "13:02:24" , 
"departure_time" : "13:03:07" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "13:06:43" , 
"departure_time" : "13:07:45" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "13:13:02" , 
"departure_time" : "13:13:41" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "13:15:39" , 
"departure_time" : "13:16:54" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "13:19:15" , 
"departure_time" : "13:20:46" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "13:22:31" , 
"departure_time" : "13:22:34" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "13:24:03" , 
"departure_time" : "13:25:20" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "13:28:17" , 
"departure_time" : "13:29:30" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "13:31:13" , 
"departure_time" : "13:31:33" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "13:35:20" , 
"departure_time" : "13:36:58" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "13:41:38" , 
"departure_time" : "13:41:48" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "13:45:10" , 
"departure_time" : "13:45:41" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 136,
"arrival_time" : "13:49:31" , 
"departure_time" : "13:50:42" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 87,
"arrival_time" : "13:53:11" , 
"departure_time" : "13:54:17" , 
"distance_traveled" : 25.461
}, 
{ 
"stop_id" : 81,
"arrival_time" : "13:57:06" , 
"departure_time" : "13:57:27" , 
"distance_traveled" : 27.0697
}, 
{ 
"stop_id" : 140,
"arrival_time" : "13:59:21" , 
"departure_time" : "14:00:33" , 
"distance_traveled" : 28.3521
}, 
{ 
"stop_id" : 97,
"arrival_time" : "14:02:12" , 
"departure_time" : "14:02:15" , 
"distance_traveled" : 29.1237
}, 
{ 
"stop_id" : 61,
"arrival_time" : "14:03:03" , 
"departure_time" : "14:03:15" , 
"distance_traveled" : 30.0517
}, 
{ 
"stop_id" : 112,
"arrival_time" : "14:06:12" , 
"departure_time" : "14:07:43" , 
"distance_traveled" : 30.7595
}, 
{ 
"stop_id" : 23,
"arrival_time" : "14:09:31" , 
"departure_time" : "14:11:03" , 
"distance_traveled" : 31.6604
}, 
{ 
"stop_id" : 37,
"arrival_time" : "14:11:32" , 
"departure_time" : "14:12:48" , 
"distance_traveled" : 32.1883
}, 
{ 
"stop_id" : 106,
"arrival_time" : "14:15:16" , 
"departure_time" : "14:15:36" , 
"distance_traveled" : 34.436
}, 
{ 
"stop_id" : 63,
"arrival_time" : "14:32:20" , 
"departure_time" : "14:32:20" , 
"distance_traveled" : 42.2242
} ], 
"2285" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "12:58:00" , 
"departure_time" : "12:58:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "13:02:25" , 
"departure_time" : "13:03:31" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "13:07:06" , 
"departure_time" : "13:08:39" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "13:13:33" , 
"departure_time" : "13:14:22" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "13:15:49" , 
"departure_time" : "13:16:22" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "13:18:33" , 
"departure_time" : "13:19:09" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "13:21:36" , 
"departure_time" : "13:22:55" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "13:25:19" , 
"departure_time" : "13:26:04" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "13:27:45" , 
"departure_time" : "13:27:51" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "13:30:06" , 
"departure_time" : "13:30:55" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "13:35:49" , 
"departure_time" : "13:36:45" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "13:40:56" , 
"departure_time" : "13:42:10" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "13:46:14" , 
"departure_time" : "13:46:29" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 136,
"arrival_time" : "13:49:15" , 
"departure_time" : "13:49:30" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 87,
"arrival_time" : "13:52:15" , 
"departure_time" : "13:52:40" , 
"distance_traveled" : 25.461
}, 
{ 
"stop_id" : 81,
"arrival_time" : "13:56:25" , 
"departure_time" : "13:56:52" , 
"distance_traveled" : 27.0697
}, 
{ 
"stop_id" : 140,
"arrival_time" : "13:59:27" , 
"departure_time" : "13:59:37" , 
"distance_traveled" : 28.3521
}, 
{ 
"stop_id" : 97,
"arrival_time" : "14:01:10" , 
"departure_time" : "14:01:37" , 
"distance_traveled" : 29.1237
}, 
{ 
"stop_id" : 61,
"arrival_time" : "14:03:27" , 
"departure_time" : "14:04:55" , 
"distance_traveled" : 30.0517
}, 
{ 
"stop_id" : 112,
"arrival_time" : "14:07:28" , 
"departure_time" : "14:07:54" , 
"distance_traveled" : 30.7595
}, 
{ 
"stop_id" : 23,
"arrival_time" : "14:08:26" , 
"departure_time" : "14:09:50" , 
"distance_traveled" : 31.6604
}, 
{ 
"stop_id" : 37,
"arrival_time" : "14:11:24" , 
"departure_time" : "14:13:01" , 
"distance_traveled" : 32.1883
}, 
{ 
"stop_id" : 106,
"arrival_time" : "14:15:37" , 
"departure_time" : "14:16:25" , 
"distance_traveled" : 34.436
}, 
{ 
"stop_id" : 63,
"arrival_time" : "14:32:48" , 
"departure_time" : "14:32:48" , 
"distance_traveled" : 42.2242
} ], 
"2286" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "13:59:00" , 
"departure_time" : "14:01:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "14:03:40" , 
"departure_time" : "14:05:13" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "14:07:33" , 
"departure_time" : "14:08:30" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "14:12:57" , 
"departure_time" : "14:13:21" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "14:15:24" , 
"departure_time" : "14:17:04" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "14:19:40" , 
"departure_time" : "14:20:12" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "14:21:32" , 
"departure_time" : "14:23:09" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "14:25:37" , 
"departure_time" : "14:26:29" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "14:27:52" , 
"departure_time" : "14:28:59" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "14:31:07" , 
"departure_time" : "14:32:18" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "14:36:11" , 
"departure_time" : "14:36:40" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "14:39:29" , 
"departure_time" : "14:41:04" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "14:45:35" , 
"departure_time" : "14:47:14" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 136,
"arrival_time" : "14:49:39" , 
"departure_time" : "14:50:08" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 87,
"arrival_time" : "14:51:29" , 
"departure_time" : "14:52:25" , 
"distance_traveled" : 25.461
}, 
{ 
"stop_id" : 81,
"arrival_time" : "14:54:56" , 
"departure_time" : "14:55:56" , 
"distance_traveled" : 27.0697
}, 
{ 
"stop_id" : 140,
"arrival_time" : "14:58:00" , 
"departure_time" : "14:58:04" , 
"distance_traveled" : 28.3521
}, 
{ 
"stop_id" : 97,
"arrival_time" : "14:59:04" , 
"departure_time" : "15:00:00" , 
"distance_traveled" : 29.1237
}, 
{ 
"stop_id" : 61,
"arrival_time" : "15:02:56" , 
"departure_time" : "15:04:35" , 
"distance_traveled" : 30.0517
}, 
{ 
"stop_id" : 112,
"arrival_time" : "15:05:39" , 
"departure_time" : "15:05:54" , 
"distance_traveled" : 30.7595
}, 
{ 
"stop_id" : 23,
"arrival_time" : "15:06:15" , 
"departure_time" : "15:06:33" , 
"distance_traveled" : 31.6604
}, 
{ 
"stop_id" : 37,
"arrival_time" : "15:08:18" , 
"departure_time" : "15:09:47" , 
"distance_traveled" : 32.1883
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:13:29" , 
"departure_time" : "15:13:52" , 
"distance_traveled" : 34.436
}, 
{ 
"stop_id" : 63,
"arrival_time" : "15:30:23" , 
"departure_time" : "15:30:23" , 
"distance_traveled" : 42.2242
} ], 
"2287" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "13:59:00" , 
"departure_time" : "14:00:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "14:02:50" , 
"departure_time" : "14:03:03" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "14:06:13" , 
"departure_time" : "14:06:56" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "14:12:43" , 
"departure_time" : "14:13:02" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "14:15:19" , 
"departure_time" : "14:16:55" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "14:19:36" , 
"departure_time" : "14:20:21" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "14:21:45" , 
"departure_time" : "14:22:11" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "14:24:26" , 
"departure_time" : "14:26:04" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "14:28:38" , 
"departure_time" : "14:30:07" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "14:31:29" , 
"departure_time" : "14:32:27" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "14:35:58" , 
"departure_time" : "14:37:10" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "14:40:12" , 
"departure_time" : "14:40:17" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "14:44:05" , 
"departure_time" : "14:44:39" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 136,
"arrival_time" : "14:48:34" , 
"departure_time" : "14:49:30" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 87,
"arrival_time" : "14:51:56" , 
"departure_time" : "14:52:43" , 
"distance_traveled" : 25.461
}, 
{ 
"stop_id" : 81,
"arrival_time" : "14:54:47" , 
"departure_time" : "14:55:29" , 
"distance_traveled" : 27.0697
}, 
{ 
"stop_id" : 140,
"arrival_time" : "14:57:42" , 
"departure_time" : "14:58:22" , 
"distance_traveled" : 28.3521
}, 
{ 
"stop_id" : 97,
"arrival_time" : "14:59:40" , 
"departure_time" : "15:00:28" , 
"distance_traveled" : 29.1237
}, 
{ 
"stop_id" : 61,
"arrival_time" : "15:02:48" , 
"departure_time" : "15:03:57" , 
"distance_traveled" : 30.0517
}, 
{ 
"stop_id" : 112,
"arrival_time" : "15:05:09" , 
"departure_time" : "15:06:29" , 
"distance_traveled" : 30.7595
}, 
{ 
"stop_id" : 23,
"arrival_time" : "15:07:20" , 
"departure_time" : "15:07:37" , 
"distance_traveled" : 31.6604
}, 
{ 
"stop_id" : 37,
"arrival_time" : "15:08:17" , 
"departure_time" : "15:08:56" , 
"distance_traveled" : 32.1883
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:12:39" , 
"departure_time" : "15:13:50" , 
"distance_traveled" : 34.436
}, 
{ 
"stop_id" : 63,
"arrival_time" : "15:31:11" , 
"departure_time" : "15:31:11" , 
"distance_traveled" : 42.2242
} ], 
"2288" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "15:02:00" , 
"departure_time" : "15:03:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "15:05:46" , 
"departure_time" : "15:06:00" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "15:09:14" , 
"departure_time" : "15:09:39" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "15:15:25" , 
"departure_time" : "15:16:35" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "15:19:10" , 
"departure_time" : "15:20:41" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "15:22:31" , 
"departure_time" : "15:23:27" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "15:24:56" , 
"departure_time" : "15:25:33" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "15:27:37" , 
"departure_time" : "15:27:39" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "15:30:02" , 
"departure_time" : "15:30:30" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "15:33:28" , 
"departure_time" : "15:34:10" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "15:39:42" , 
"departure_time" : "15:40:37" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "15:43:55" , 
"departure_time" : "15:44:12" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "15:47:17" , 
"departure_time" : "15:48:48" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 136,
"arrival_time" : "15:52:31" , 
"departure_time" : "15:53:46" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 87,
"arrival_time" : "15:55:15" , 
"departure_time" : "15:55:36" , 
"distance_traveled" : 25.461
}, 
{ 
"stop_id" : 81,
"arrival_time" : "15:58:21" , 
"departure_time" : "15:59:19" , 
"distance_traveled" : 27.0697
}, 
{ 
"stop_id" : 140,
"arrival_time" : "16:01:58" , 
"departure_time" : "16:03:13" , 
"distance_traveled" : 28.3521
}, 
{ 
"stop_id" : 97,
"arrival_time" : "16:04:15" , 
"departure_time" : "16:04:45" , 
"distance_traveled" : 29.1237
}, 
{ 
"stop_id" : 61,
"arrival_time" : "16:05:30" , 
"departure_time" : "16:06:04" , 
"distance_traveled" : 30.0517
}, 
{ 
"stop_id" : 112,
"arrival_time" : "16:08:34" , 
"departure_time" : "16:09:24" , 
"distance_traveled" : 30.7595
}, 
{ 
"stop_id" : 23,
"arrival_time" : "16:10:50" , 
"departure_time" : "16:11:12" , 
"distance_traveled" : 31.6604
}, 
{ 
"stop_id" : 37,
"arrival_time" : "16:12:22" , 
"departure_time" : "16:13:09" , 
"distance_traveled" : 32.1883
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:16:47" , 
"departure_time" : "16:17:12" , 
"distance_traveled" : 34.436
}, 
{ 
"stop_id" : 63,
"arrival_time" : "16:34:25" , 
"departure_time" : "16:34:25" , 
"distance_traveled" : 42.2242
} ], 
"2289" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "15:02:00" , 
"departure_time" : "15:03:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "15:05:51" , 
"departure_time" : "15:06:58" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "15:10:07" , 
"departure_time" : "15:10:39" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "15:15:32" , 
"departure_time" : "15:16:42" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "15:19:10" , 
"departure_time" : "15:19:48" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "15:21:38" , 
"departure_time" : "15:22:36" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "15:24:58" , 
"departure_time" : "15:25:52" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "15:27:54" , 
"departure_time" : "15:28:21" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "15:30:27" , 
"departure_time" : "15:31:11" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "15:33:44" , 
"departure_time" : "15:34:25" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "15:39:41" , 
"departure_time" : "15:40:04" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "15:43:23" , 
"departure_time" : "15:44:36" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "15:48:13" , 
"departure_time" : "15:48:32" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 136,
"arrival_time" : "15:51:19" , 
"departure_time" : "15:52:59" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 87,
"arrival_time" : "15:55:40" , 
"departure_time" : "15:56:39" , 
"distance_traveled" : 25.461
}, 
{ 
"stop_id" : 81,
"arrival_time" : "15:58:59" , 
"departure_time" : "15:59:11" , 
"distance_traveled" : 27.0697
}, 
{ 
"stop_id" : 140,
"arrival_time" : "16:01:12" , 
"departure_time" : "16:01:57" , 
"distance_traveled" : 28.3521
}, 
{ 
"stop_id" : 97,
"arrival_time" : "16:03:45" , 
"departure_time" : "16:04:44" , 
"distance_traveled" : 29.1237
}, 
{ 
"stop_id" : 61,
"arrival_time" : "16:05:59" , 
"departure_time" : "16:06:55" , 
"distance_traveled" : 30.0517
}, 
{ 
"stop_id" : 112,
"arrival_time" : "16:08:56" , 
"departure_time" : "16:09:05" , 
"distance_traveled" : 30.7595
}, 
{ 
"stop_id" : 23,
"arrival_time" : "16:10:09" , 
"departure_time" : "16:11:17" , 
"distance_traveled" : 31.6604
}, 
{ 
"stop_id" : 37,
"arrival_time" : "16:13:08" , 
"departure_time" : "16:14:23" , 
"distance_traveled" : 32.1883
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:17:15" , 
"departure_time" : "16:18:03" , 
"distance_traveled" : 34.436
}, 
{ 
"stop_id" : 63,
"arrival_time" : "16:34:48" , 
"departure_time" : "16:34:48" , 
"distance_traveled" : 42.2242
} ], 
"2290" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "21:26:00" , 
"departure_time" : "21:27:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "21:29:17" , 
"departure_time" : "21:30:08" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "21:33:51" , 
"departure_time" : "21:35:30" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "21:40:39" , 
"departure_time" : "21:40:54" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "21:42:15" , 
"departure_time" : "21:43:52" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "21:46:37" , 
"departure_time" : "21:47:39" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "21:49:02" , 
"departure_time" : "21:49:13" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "21:52:11" , 
"departure_time" : "21:53:42" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "21:57:31" , 
"departure_time" : "21:58:12" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "21:59:41" , 
"departure_time" : "22:01:14" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "22:04:33" , 
"departure_time" : "22:04:51" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "22:06:18" , 
"departure_time" : "22:06:27" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "22:11:09" , 
"departure_time" : "22:12:15" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 136,
"arrival_time" : "22:16:06" , 
"departure_time" : "22:17:24" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 87,
"arrival_time" : "22:19:18" , 
"departure_time" : "22:20:49" , 
"distance_traveled" : 25.461
}, 
{ 
"stop_id" : 81,
"arrival_time" : "22:23:31" , 
"departure_time" : "22:23:59" , 
"distance_traveled" : 27.0697
}, 
{ 
"stop_id" : 140,
"arrival_time" : "22:25:28" , 
"departure_time" : "22:26:42" , 
"distance_traveled" : 28.3521
}, 
{ 
"stop_id" : 97,
"arrival_time" : "22:28:14" , 
"departure_time" : "22:28:35" , 
"distance_traveled" : 29.1237
}, 
{ 
"stop_id" : 61,
"arrival_time" : "22:29:21" , 
"departure_time" : "22:29:35" , 
"distance_traveled" : 30.0517
}, 
{ 
"stop_id" : 112,
"arrival_time" : "22:32:14" , 
"departure_time" : "22:32:35" , 
"distance_traveled" : 30.7595
}, 
{ 
"stop_id" : 23,
"arrival_time" : "22:34:21" , 
"departure_time" : "22:35:36" , 
"distance_traveled" : 31.6604
}, 
{ 
"stop_id" : 37,
"arrival_time" : "22:37:15" , 
"departure_time" : "22:37:49" , 
"distance_traveled" : 32.1883
}, 
{ 
"stop_id" : 106,
"arrival_time" : "22:41:34" , 
"departure_time" : "22:41:40" , 
"distance_traveled" : 34.436
}, 
{ 
"stop_id" : 63,
"arrival_time" : "22:58:06" , 
"departure_time" : "22:58:06" , 
"distance_traveled" : 42.2242
} ], 
"2291" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "21:26:00" , 
"departure_time" : "21:26:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "21:29:40" , 
"departure_time" : "21:30:21" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "21:33:41" , 
"departure_time" : "21:35:18" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "21:40:37" , 
"departure_time" : "21:41:28" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "21:42:51" , 
"departure_time" : "21:44:05" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "21:46:14" , 
"departure_time" : "21:47:01" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "21:48:47" , 
"departure_time" : "21:49:51" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "21:53:04" , 
"departure_time" : "21:54:17" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "21:57:13" , 
"departure_time" : "21:57:45" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "21:59:32" , 
"departure_time" : "22:00:00" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "22:03:28" , 
"departure_time" : "22:04:24" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "22:06:56" , 
"departure_time" : "22:08:03" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "22:12:07" , 
"departure_time" : "22:13:38" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 136,
"arrival_time" : "22:16:31" , 
"departure_time" : "22:18:11" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 87,
"arrival_time" : "22:19:40" , 
"departure_time" : "22:19:55" , 
"distance_traveled" : 25.461
}, 
{ 
"stop_id" : 81,
"arrival_time" : "22:22:15" , 
"departure_time" : "22:23:14" , 
"distance_traveled" : 27.0697
}, 
{ 
"stop_id" : 140,
"arrival_time" : "22:25:59" , 
"departure_time" : "22:26:05" , 
"distance_traveled" : 28.3521
}, 
{ 
"stop_id" : 97,
"arrival_time" : "22:27:06" , 
"departure_time" : "22:28:32" , 
"distance_traveled" : 29.1237
}, 
{ 
"stop_id" : 61,
"arrival_time" : "22:30:26" , 
"departure_time" : "22:31:58" , 
"distance_traveled" : 30.0517
}, 
{ 
"stop_id" : 112,
"arrival_time" : "22:33:32" , 
"departure_time" : "22:33:55" , 
"distance_traveled" : 30.7595
}, 
{ 
"stop_id" : 23,
"arrival_time" : "22:34:23" , 
"departure_time" : "22:34:43" , 
"distance_traveled" : 31.6604
}, 
{ 
"stop_id" : 37,
"arrival_time" : "22:36:20" , 
"departure_time" : "22:37:09" , 
"distance_traveled" : 32.1883
}, 
{ 
"stop_id" : 106,
"arrival_time" : "22:41:49" , 
"departure_time" : "22:42:17" , 
"distance_traveled" : 34.436
}, 
{ 
"stop_id" : 63,
"arrival_time" : "22:58:28" , 
"departure_time" : "22:58:28" , 
"distance_traveled" : 42.2242
} ], 
"2292" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "22:49:00" , 
"departure_time" : "22:50:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "22:53:08" , 
"departure_time" : "22:53:59" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "22:56:51" , 
"departure_time" : "22:58:11" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "23:05:20" , 
"departure_time" : "23:06:47" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "23:09:27" , 
"departure_time" : "23:09:51" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "23:11:24" , 
"departure_time" : "23:12:26" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "23:15:02" , 
"departure_time" : "23:15:16" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "23:17:14" , 
"departure_time" : "23:17:20" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "23:20:06" , 
"departure_time" : "23:20:25" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "23:23:19" , 
"departure_time" : "23:24:56" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "23:28:37" , 
"departure_time" : "23:29:41" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "23:31:04" , 
"departure_time" : "23:32:25" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "23:36:21" , 
"departure_time" : "23:36:55" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 136,
"arrival_time" : "23:40:34" , 
"departure_time" : "23:40:52" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 87,
"arrival_time" : "23:43:18" , 
"departure_time" : "23:44:02" , 
"distance_traveled" : 25.461
}, 
{ 
"stop_id" : 81,
"arrival_time" : "23:46:44" , 
"departure_time" : "23:46:56" , 
"distance_traveled" : 27.0697
}, 
{ 
"stop_id" : 140,
"arrival_time" : "23:49:12" , 
"departure_time" : "23:49:36" , 
"distance_traveled" : 28.3521
}, 
{ 
"stop_id" : 97,
"arrival_time" : "23:51:24" , 
"departure_time" : "23:51:34" , 
"distance_traveled" : 29.1237
}, 
{ 
"stop_id" : 61,
"arrival_time" : "23:53:10" , 
"departure_time" : "23:53:47" , 
"distance_traveled" : 30.0517
}, 
{ 
"stop_id" : 112,
"arrival_time" : "23:56:37" , 
"departure_time" : "23:58:04" , 
"distance_traveled" : 30.7595
}, 
{ 
"stop_id" : 23,
"arrival_time" : "23:59:27" , 
"departure_time" : "24:00:44" , 
"distance_traveled" : 31.6604
}, 
{ 
"stop_id" : 37,
"arrival_time" : "24:01:17" , 
"departure_time" : "24:01:26" , 
"distance_traveled" : 32.1883
}, 
{ 
"stop_id" : 106,
"arrival_time" : "24:05:09" , 
"departure_time" : "24:05:52" , 
"distance_traveled" : 34.436
}, 
{ 
"stop_id" : 63,
"arrival_time" : "24:22:43" , 
"departure_time" : "24:22:43" , 
"distance_traveled" : 42.2242
} ], 
"2293" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "22:49:00" , 
"departure_time" : "22:50:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "22:52:50" , 
"departure_time" : "22:52:59" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "22:56:09" , 
"departure_time" : "22:56:49" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "23:04:40" , 
"departure_time" : "23:04:49" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "23:08:09" , 
"departure_time" : "23:09:35" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "23:12:26" , 
"departure_time" : "23:13:23" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "23:14:57" , 
"departure_time" : "23:16:36" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "23:18:39" , 
"departure_time" : "23:19:20" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "23:20:41" , 
"departure_time" : "23:22:08" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "23:24:27" , 
"departure_time" : "23:25:50" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "23:28:23" , 
"departure_time" : "23:28:59" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "23:30:36" , 
"departure_time" : "23:30:50" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "23:35:14" , 
"departure_time" : "23:36:34" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 136,
"arrival_time" : "23:41:20" , 
"departure_time" : "23:42:39" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 87,
"arrival_time" : "23:44:19" , 
"departure_time" : "23:44:40" , 
"distance_traveled" : 25.461
}, 
{ 
"stop_id" : 81,
"arrival_time" : "23:46:21" , 
"departure_time" : "23:47:34" , 
"distance_traveled" : 27.0697
}, 
{ 
"stop_id" : 140,
"arrival_time" : "23:50:13" , 
"departure_time" : "23:51:25" , 
"distance_traveled" : 28.3521
}, 
{ 
"stop_id" : 97,
"arrival_time" : "23:52:12" , 
"departure_time" : "23:52:18" , 
"distance_traveled" : 29.1237
}, 
{ 
"stop_id" : 61,
"arrival_time" : "23:53:06" , 
"departure_time" : "23:53:12" , 
"distance_traveled" : 30.0517
}, 
{ 
"stop_id" : 112,
"arrival_time" : "23:56:06" , 
"departure_time" : "23:57:03" , 
"distance_traveled" : 30.7595
}, 
{ 
"stop_id" : 23,
"arrival_time" : "23:58:57" , 
"departure_time" : "23:59:21" , 
"distance_traveled" : 31.6604
}, 
{ 
"stop_id" : 37,
"arrival_time" : "24:00:24" , 
"departure_time" : "24:01:21" , 
"distance_traveled" : 32.1883
}, 
{ 
"stop_id" : 106,
"arrival_time" : "24:05:57" , 
"departure_time" : "24:07:00" , 
"distance_traveled" : 34.436
}, 
{ 
"stop_id" : 63,
"arrival_time" : "24:23:03" , 
"departure_time" : "24:23:03" , 
"distance_traveled" : 42.2242
} ], 
"2294" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "23:50:00" , 
"departure_time" : "23:51:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "23:53:36" , 
"departure_time" : "23:55:03" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "23:58:27" , 
"departure_time" : "23:59:24" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "24:05:57" , 
"departure_time" : "24:07:25" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "24:10:28" , 
"departure_time" : "24:11:25" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "24:12:57" , 
"departure_time" : "24:13:26" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "24:15:29" , 
"departure_time" : "24:15:53" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "24:18:24" , 
"departure_time" : "24:18:54" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "24:21:30" , 
"departure_time" : "24:22:01" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "24:24:31" , 
"departure_time" : "24:26:03" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "24:29:32" , 
"departure_time" : "24:30:44" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "24:32:12" , 
"departure_time" : "24:33:21" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "24:37:09" , 
"departure_time" : "24:38:02" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 136,
"arrival_time" : "24:40:53" , 
"departure_time" : "24:41:57" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 87,
"arrival_time" : "24:44:04" , 
"departure_time" : "24:45:06" , 
"distance_traveled" : 25.461
}, 
{ 
"stop_id" : 81,
"arrival_time" : "24:47:02" , 
"departure_time" : "24:47:34" , 
"distance_traveled" : 27.0697
}, 
{ 
"stop_id" : 140,
"arrival_time" : "24:49:32" , 
"departure_time" : "24:51:09" , 
"distance_traveled" : 28.3521
}, 
{ 
"stop_id" : 97,
"arrival_time" : "24:52:37" , 
"departure_time" : "24:53:51" , 
"distance_traveled" : 29.1237
}, 
{ 
"stop_id" : 61,
"arrival_time" : "24:54:14" , 
"departure_time" : "24:54:46" , 
"distance_traveled" : 30.0517
}, 
{ 
"stop_id" : 112,
"arrival_time" : "24:56:32" , 
"departure_time" : "24:57:33" , 
"distance_traveled" : 30.7595
}, 
{ 
"stop_id" : 23,
"arrival_time" : "24:59:01" , 
"departure_time" : "24:59:07" , 
"distance_traveled" : 31.6604
}, 
{ 
"stop_id" : 37,
"arrival_time" : "25:00:06" , 
"departure_time" : "25:00:55" , 
"distance_traveled" : 32.1883
}, 
{ 
"stop_id" : 106,
"arrival_time" : "25:04:49" , 
"departure_time" : "25:06:09" , 
"distance_traveled" : 34.436
}, 
{ 
"stop_id" : 63,
"arrival_time" : "25:21:20" , 
"departure_time" : "25:21:20" , 
"distance_traveled" : 42.2242
} ], 
"2295" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "23:50:00" , 
"departure_time" : "23:52:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "23:54:03" , 
"departure_time" : "23:54:24" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "23:57:21" , 
"departure_time" : "23:58:33" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "24:06:12" , 
"departure_time" : "24:06:16" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "24:09:04" , 
"departure_time" : "24:10:32" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "24:13:28" , 
"departure_time" : "24:13:32" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "24:15:04" , 
"departure_time" : "24:15:29" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "24:18:25" , 
"departure_time" : "24:20:00" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "24:22:35" , 
"departure_time" : "24:24:11" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "24:25:36" , 
"departure_time" : "24:25:56" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "24:28:20" , 
"departure_time" : "24:29:49" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "24:32:29" , 
"departure_time" : "24:34:08" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "24:37:39" , 
"departure_time" : "24:38:41" , 
"distance_traveled" : 22.1182
}, 
{ 
"stop_id" : 136,
"arrival_time" : "24:41:02" , 
"departure_time" : "24:41:49" , 
"distance_traveled" : 24.3866
}, 
{ 
"stop_id" : 87,
"arrival_time" : "24:43:47" , 
"departure_time" : "24:45:03" , 
"distance_traveled" : 25.461
}, 
{ 
"stop_id" : 81,
"arrival_time" : "24:47:16" , 
"departure_time" : "24:47:55" , 
"distance_traveled" : 27.0697
}, 
{ 
"stop_id" : 140,
"arrival_time" : "24:49:39" , 
"departure_time" : "24:50:34" , 
"distance_traveled" : 28.3521
}, 
{ 
"stop_id" : 97,
"arrival_time" : "24:51:55" , 
"departure_time" : "24:52:26" , 
"distance_traveled" : 29.1237
}, 
{ 
"stop_id" : 61,
"arrival_time" : "24:53:31" , 
"departure_time" : "24:54:23" , 
"distance_traveled" : 30.0517
}, 
{ 
"stop_id" : 112,
"arrival_time" : "24:56:52" , 
"departure_time" : "24:57:28" , 
"distance_traveled" : 30.7595
}, 
{ 
"stop_id" : 23,
"arrival_time" : "24:58:36" , 
"departure_time" : "25:00:02" , 
"distance_traveled" : 31.6604
}, 
{ 
"stop_id" : 37,
"arrival_time" : "25:01:26" , 
"departure_time" : "25:03:01" , 
"distance_traveled" : 32.1883
}, 
{ 
"stop_id" : 106,
"arrival_time" : "25:05:35" , 
"departure_time" : "25:05:49" , 
"distance_traveled" : 34.436
}, 
{ 
"stop_id" : 63,
"arrival_time" : "25:20:14" , 
"departure_time" : "25:20:14" , 
"distance_traveled" : 42.2242
} ], 
"2296" :  [ 
{ 
"stop_id" : 117,
"arrival_time" : "05:33:00" , 
"departure_time" : "05:33:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 45,
"arrival_time" : "05:38:13" , 
"departure_time" : "05:38:42" , 
"distance_traveled" : 2.3864
}, 
{ 
"stop_id" : 18,
"arrival_time" : "05:44:29" , 
"departure_time" : "05:45:46" , 
"distance_traveled" : 6.5206
}, 
{ 
"stop_id" : 12,
"arrival_time" : "05:48:17" , 
"departure_time" : "05:48:39" , 
"distance_traveled" : 7.6824
}, 
{ 
"stop_id" : 76,
"arrival_time" : "05:51:22" , 
"departure_time" : "05:52:06" , 
"distance_traveled" : 9.5644
}, 
{ 
"stop_id" : 88,
"arrival_time" : "05:54:44" , 
"departure_time" : "05:55:19" , 
"distance_traveled" : 11.204
}, 
{ 
"stop_id" : 143,
"arrival_time" : "05:57:35" , 
"departure_time" : "05:58:35" , 
"distance_traveled" : 12.8021
}, 
{ 
"stop_id" : 48,
"arrival_time" : "06:01:00" , 
"departure_time" : "06:02:09" , 
"distance_traveled" : 14.1564
}, 
{ 
"stop_id" : 17,
"arrival_time" : "06:05:09" , 
"departure_time" : "06:06:45" , 
"distance_traveled" : 15.5511
}, 
{ 
"stop_id" : 99,
"arrival_time" : "06:09:36" , 
"departure_time" : "06:10:59" , 
"distance_traveled" : 17.9172
}, 
{ 
"stop_id" : 104,
"arrival_time" : "06:13:23" , 
"departure_time" : "06:14:42" , 
"distance_traveled" : 19.5142
}, 
{ 
"stop_id" : 145,
"arrival_time" : "06:18:19" , 
"departure_time" : "06:19:31" , 
"distance_traveled" : 21.1919
}, 
{ 
"stop_id" : 136,
"arrival_time" : "06:22:12" , 
"departure_time" : "06:22:29" , 
"distance_traveled" : 23.4602
}, 
{ 
"stop_id" : 87,
"arrival_time" : "06:24:17" , 
"departure_time" : "06:24:42" , 
"distance_traveled" : 24.5347
}, 
{ 
"stop_id" : 81,
"arrival_time" : "06:28:25" , 
"departure_time" : "06:28:51" , 
"distance_traveled" : 26.1434
}, 
{ 
"stop_id" : 140,
"arrival_time" : "06:32:26" , 
"departure_time" : "06:33:09" , 
"distance_traveled" : 27.4258
}, 
{ 
"stop_id" : 61,
"arrival_time" : "06:35:43" , 
"departure_time" : "06:36:12" , 
"distance_traveled" : 29.1254
}, 
{ 
"stop_id" : 112,
"arrival_time" : "06:38:29" , 
"departure_time" : "06:39:49" , 
"distance_traveled" : 29.833
}, 
{ 
"stop_id" : 23,
"arrival_time" : "06:42:20" , 
"departure_time" : "06:42:23" , 
"distance_traveled" : 30.7339
}, 
{ 
"stop_id" : 106,
"arrival_time" : "06:47:03" , 
"departure_time" : "06:47:23" , 
"distance_traveled" : 33.5095
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:58:20" , 
"departure_time" : "06:59:13" , 
"distance_traveled" : 38.9432
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:11:53" , 
"departure_time" : "07:11:53" , 
"distance_traveled" : 43.9312
} ], 
"2297" :  [ 
{ 
"stop_id" : 117,
"arrival_time" : "06:16:00" , 
"departure_time" : "06:17:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 45,
"arrival_time" : "06:21:33" , 
"departure_time" : "06:22:43" , 
"distance_traveled" : 2.3864
}, 
{ 
"stop_id" : 18,
"arrival_time" : "06:28:10" , 
"departure_time" : "06:29:05" , 
"distance_traveled" : 6.5206
}, 
{ 
"stop_id" : 12,
"arrival_time" : "06:30:55" , 
"departure_time" : "06:32:21" , 
"distance_traveled" : 7.6824
}, 
{ 
"stop_id" : 76,
"arrival_time" : "06:35:26" , 
"departure_time" : "06:37:01" , 
"distance_traveled" : 9.5644
}, 
{ 
"stop_id" : 88,
"arrival_time" : "06:38:35" , 
"departure_time" : "06:38:59" , 
"distance_traveled" : 11.204
}, 
{ 
"stop_id" : 143,
"arrival_time" : "06:40:24" , 
"departure_time" : "06:40:35" , 
"distance_traveled" : 12.8021
}, 
{ 
"stop_id" : 48,
"arrival_time" : "06:43:11" , 
"departure_time" : "06:44:48" , 
"distance_traveled" : 14.1564
}, 
{ 
"stop_id" : 17,
"arrival_time" : "06:48:37" , 
"departure_time" : "06:50:13" , 
"distance_traveled" : 15.5511
}, 
{ 
"stop_id" : 99,
"arrival_time" : "06:52:36" , 
"departure_time" : "06:52:55" , 
"distance_traveled" : 17.9172
}, 
{ 
"stop_id" : 104,
"arrival_time" : "06:55:19" , 
"departure_time" : "06:55:44" , 
"distance_traveled" : 19.5142
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:00:25" , 
"departure_time" : "07:00:43" , 
"distance_traveled" : 21.1919
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:04:18" , 
"departure_time" : "07:05:30" , 
"distance_traveled" : 23.4602
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:08:12" , 
"departure_time" : "07:08:16" , 
"distance_traveled" : 24.5347
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:11:04" , 
"departure_time" : "07:11:47" , 
"distance_traveled" : 26.1434
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:15:43" , 
"departure_time" : "07:17:15" , 
"distance_traveled" : 27.4258
}, 
{ 
"stop_id" : 61,
"arrival_time" : "07:19:32" , 
"departure_time" : "07:20:50" , 
"distance_traveled" : 29.1254
}, 
{ 
"stop_id" : 112,
"arrival_time" : "07:22:18" , 
"departure_time" : "07:23:19" , 
"distance_traveled" : 29.833
}, 
{ 
"stop_id" : 23,
"arrival_time" : "07:25:01" , 
"departure_time" : "07:25:55" , 
"distance_traveled" : 30.7339
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:30:54" , 
"departure_time" : "07:32:12" , 
"distance_traveled" : 33.5095
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:42:18" , 
"departure_time" : "07:43:47" , 
"distance_traveled" : 38.9432
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:55:29" , 
"departure_time" : "07:55:29" , 
"distance_traveled" : 43.9312
} ], 
"2298" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "05:52:00" , 
"departure_time" : "05:54:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "05:56:15" , 
"departure_time" : "05:57:21" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "06:00:06" , 
"departure_time" : "06:00:41" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "06:05:35" , 
"departure_time" : "06:06:02" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "06:08:27" , 
"departure_time" : "06:08:58" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "06:11:31" , 
"departure_time" : "06:12:04" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "06:14:33" , 
"departure_time" : "06:14:36" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "06:17:03" , 
"departure_time" : "06:17:30" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "06:20:27" , 
"departure_time" : "06:20:34" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "06:24:07" , 
"departure_time" : "06:25:07" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "06:29:00" , 
"departure_time" : "06:29:05" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "06:31:05" , 
"departure_time" : "06:32:09" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "06:37:04" , 
"departure_time" : "06:37:04" , 
"distance_traveled" : 22.1182
} ], 
"2299" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "06:52:00" , 
"departure_time" : "06:54:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "06:56:02" , 
"departure_time" : "06:56:25" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "06:59:23" , 
"departure_time" : "07:00:07" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "07:05:44" , 
"departure_time" : "07:05:52" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "07:08:08" , 
"departure_time" : "07:09:16" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "07:12:08" , 
"departure_time" : "07:13:11" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "07:15:03" , 
"departure_time" : "07:15:58" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "07:17:55" , 
"departure_time" : "07:18:10" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "07:20:15" , 
"departure_time" : "07:20:34" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "07:24:19" , 
"departure_time" : "07:25:31" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "07:29:12" , 
"departure_time" : "07:30:14" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "07:32:02" , 
"departure_time" : "07:32:19" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:36:17" , 
"departure_time" : "07:36:17" , 
"distance_traveled" : 22.1182
} ], 
"2300" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "07:52:00" , 
"departure_time" : "07:52:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "07:55:28" , 
"departure_time" : "07:56:39" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "08:00:11" , 
"departure_time" : "08:01:09" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "08:05:58" , 
"departure_time" : "08:07:23" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "08:09:25" , 
"departure_time" : "08:11:05" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "08:12:40" , 
"departure_time" : "08:12:48" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "08:14:08" , 
"departure_time" : "08:15:24" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "08:18:16" , 
"departure_time" : "08:18:58" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "08:20:42" , 
"departure_time" : "08:22:10" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "08:25:28" , 
"departure_time" : "08:26:14" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "08:28:46" , 
"departure_time" : "08:29:30" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "08:31:44" , 
"departure_time" : "08:32:02" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "08:36:18" , 
"departure_time" : "08:36:18" , 
"distance_traveled" : 22.1182
} ], 
"2301" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "08:52:00" , 
"departure_time" : "08:53:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "08:55:55" , 
"departure_time" : "08:57:00" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "09:00:05" , 
"departure_time" : "09:00:09" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "09:05:04" , 
"departure_time" : "09:06:07" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "09:09:03" , 
"departure_time" : "09:09:24" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "09:11:21" , 
"departure_time" : "09:12:56" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "09:15:35" , 
"departure_time" : "09:16:37" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "09:18:02" , 
"departure_time" : "09:18:34" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "09:20:32" , 
"departure_time" : "09:21:11" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "09:24:39" , 
"departure_time" : "09:26:15" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "09:29:36" , 
"departure_time" : "09:30:46" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "09:32:10" , 
"departure_time" : "09:32:36" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "09:36:26" , 
"departure_time" : "09:36:26" , 
"distance_traveled" : 22.1182
} ], 
"2302" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "09:52:00" , 
"departure_time" : "09:52:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "09:55:11" , 
"departure_time" : "09:56:24" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "10:00:13" , 
"departure_time" : "10:00:23" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "10:05:10" , 
"departure_time" : "10:06:20" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "10:09:10" , 
"departure_time" : "10:10:17" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "10:12:07" , 
"departure_time" : "10:13:26" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "10:15:19" , 
"departure_time" : "10:16:35" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "10:18:16" , 
"departure_time" : "10:19:02" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "10:20:46" , 
"departure_time" : "10:21:29" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "10:24:43" , 
"departure_time" : "10:25:21" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "10:28:38" , 
"departure_time" : "10:30:12" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "10:32:34" , 
"departure_time" : "10:32:53" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "10:36:19" , 
"departure_time" : "10:36:19" , 
"distance_traveled" : 22.1182
} ], 
"2303" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "10:52:00" , 
"departure_time" : "10:52:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "10:55:03" , 
"departure_time" : "10:56:38" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "11:00:35" , 
"departure_time" : "11:00:43" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "11:05:08" , 
"departure_time" : "11:06:34" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "11:09:26" , 
"departure_time" : "11:11:05" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "11:12:39" , 
"departure_time" : "11:14:10" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "11:15:31" , 
"departure_time" : "11:16:06" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "11:17:35" , 
"departure_time" : "11:18:01" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "11:20:26" , 
"departure_time" : "11:21:17" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "11:24:51" , 
"departure_time" : "11:25:17" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "11:28:26" , 
"departure_time" : "11:28:28" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "11:31:02" , 
"departure_time" : "11:32:06" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "11:37:04" , 
"departure_time" : "11:37:04" , 
"distance_traveled" : 22.1182
} ], 
"2304" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "11:52:00" , 
"departure_time" : "11:53:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "11:55:28" , 
"departure_time" : "11:56:59" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "12:00:31" , 
"departure_time" : "12:01:03" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "12:05:32" , 
"departure_time" : "12:05:54" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "12:08:22" , 
"departure_time" : "12:10:00" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "12:12:38" , 
"departure_time" : "12:13:53" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "12:15:15" , 
"departure_time" : "12:16:13" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "12:17:58" , 
"departure_time" : "12:19:11" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "12:21:13" , 
"departure_time" : "12:22:03" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "12:24:50" , 
"departure_time" : "12:24:59" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "12:28:09" , 
"departure_time" : "12:28:53" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "12:31:44" , 
"departure_time" : "12:32:54" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "12:37:10" , 
"departure_time" : "12:37:10" , 
"distance_traveled" : 22.1182
} ], 
"2305" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "12:52:00" , 
"departure_time" : "12:53:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "12:55:33" , 
"departure_time" : "12:55:45" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "12:59:12" , 
"departure_time" : "12:59:41" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "13:05:29" , 
"departure_time" : "13:05:31" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "13:08:02" , 
"departure_time" : "13:09:11" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "13:12:09" , 
"departure_time" : "13:13:39" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "13:15:30" , 
"departure_time" : "13:15:58" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "13:17:28" , 
"departure_time" : "13:18:35" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "13:21:07" , 
"departure_time" : "13:21:23" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "13:24:16" , 
"departure_time" : "13:25:29" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "13:29:13" , 
"departure_time" : "13:30:37" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "13:32:24" , 
"departure_time" : "13:33:03" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "13:36:39" , 
"departure_time" : "13:36:39" , 
"distance_traveled" : 22.1182
} ], 
"2306" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "13:52:00" , 
"departure_time" : "13:54:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "13:56:28" , 
"departure_time" : "13:56:49" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "13:59:21" , 
"departure_time" : "14:00:11" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "14:05:50" , 
"departure_time" : "14:06:07" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "14:08:17" , 
"departure_time" : "14:08:37" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "14:11:20" , 
"departure_time" : "14:11:50" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "14:14:30" , 
"departure_time" : "14:15:02" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "14:17:32" , 
"departure_time" : "14:18:53" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "14:21:21" , 
"departure_time" : "14:22:20" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "14:24:59" , 
"departure_time" : "14:26:10" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "14:29:11" , 
"departure_time" : "14:29:50" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "14:31:39" , 
"departure_time" : "14:32:45" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "14:37:06" , 
"departure_time" : "14:37:06" , 
"distance_traveled" : 22.1182
} ], 
"2307" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "14:52:00" , 
"departure_time" : "14:53:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "14:55:30" , 
"departure_time" : "14:56:45" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "15:00:15" , 
"departure_time" : "15:00:57" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "15:05:42" , 
"departure_time" : "15:06:51" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "15:09:09" , 
"departure_time" : "15:09:24" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "15:11:15" , 
"departure_time" : "15:11:32" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "15:14:17" , 
"departure_time" : "15:14:27" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "15:17:10" , 
"departure_time" : "15:18:42" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "15:21:32" , 
"departure_time" : "15:21:44" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "15:24:12" , 
"departure_time" : "15:24:27" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "15:28:15" , 
"departure_time" : "15:29:00" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "15:31:45" , 
"departure_time" : "15:32:44" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "15:36:59" , 
"departure_time" : "15:36:59" , 
"distance_traveled" : 22.1182
} ], 
"2308" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "15:52:00" , 
"departure_time" : "15:54:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "15:56:20" , 
"departure_time" : "15:57:22" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "16:00:02" , 
"departure_time" : "16:01:39" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "16:06:37" , 
"departure_time" : "16:07:21" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "16:08:44" , 
"departure_time" : "16:09:15" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "16:11:31" , 
"departure_time" : "16:12:23" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "16:14:52" , 
"departure_time" : "16:15:35" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "16:17:43" , 
"departure_time" : "16:19:13" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "16:21:30" , 
"departure_time" : "16:22:30" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "16:25:00" , 
"departure_time" : "16:26:01" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "16:29:01" , 
"departure_time" : "16:29:18" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "16:31:17" , 
"departure_time" : "16:32:27" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:37:10" , 
"departure_time" : "16:37:10" , 
"distance_traveled" : 22.1182
} ], 
"2309" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "16:52:00" , 
"departure_time" : "16:53:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "16:55:35" , 
"departure_time" : "16:56:12" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "16:59:37" , 
"departure_time" : "17:01:07" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "17:06:30" , 
"departure_time" : "17:07:12" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "17:08:42" , 
"departure_time" : "17:10:21" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "17:12:39" , 
"departure_time" : "17:13:35" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "17:14:56" , 
"departure_time" : "17:16:12" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "17:18:16" , 
"departure_time" : "17:18:17" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "17:20:01" , 
"departure_time" : "17:21:31" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "17:25:30" , 
"departure_time" : "17:26:30" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "17:29:00" , 
"departure_time" : "17:29:14" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "17:31:14" , 
"departure_time" : "17:31:42" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:36:28" , 
"departure_time" : "17:36:28" , 
"distance_traveled" : 22.1182
} ], 
"2310" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "17:52:00" , 
"departure_time" : "17:54:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "17:56:35" , 
"departure_time" : "17:57:52" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "18:00:17" , 
"departure_time" : "18:00:35" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "18:05:18" , 
"departure_time" : "18:05:25" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "18:08:07" , 
"departure_time" : "18:09:44" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "18:12:37" , 
"departure_time" : "18:13:35" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "18:14:58" , 
"departure_time" : "18:15:23" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "18:17:25" , 
"departure_time" : "18:18:57" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "18:21:32" , 
"departure_time" : "18:22:14" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "18:24:42" , 
"departure_time" : "18:25:51" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "18:29:09" , 
"departure_time" : "18:30:27" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "18:32:18" , 
"departure_time" : "18:33:58" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:37:40" , 
"departure_time" : "18:37:40" , 
"distance_traveled" : 22.1182
} ], 
"2311" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "18:52:00" , 
"departure_time" : "18:54:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "18:55:51" , 
"departure_time" : "18:56:29" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "18:59:38" , 
"departure_time" : "19:00:21" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "19:05:43" , 
"departure_time" : "19:06:47" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "19:09:04" , 
"departure_time" : "19:09:10" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "19:11:06" , 
"departure_time" : "19:12:40" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "19:15:34" , 
"departure_time" : "19:16:43" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "19:18:09" , 
"departure_time" : "19:18:53" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "19:20:44" , 
"departure_time" : "19:20:52" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "19:24:08" , 
"departure_time" : "19:25:04" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "19:28:56" , 
"departure_time" : "19:29:53" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "19:31:57" , 
"departure_time" : "19:32:04" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "19:36:07" , 
"departure_time" : "19:36:07" , 
"distance_traveled" : 22.1182
} ], 
"2312" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "19:52:00" , 
"departure_time" : "19:52:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "19:55:35" , 
"departure_time" : "19:56:53" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "20:00:18" , 
"departure_time" : "20:01:54" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "20:06:36" , 
"departure_time" : "20:07:37" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "20:09:01" , 
"departure_time" : "20:09:10" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "20:11:09" , 
"departure_time" : "20:12:32" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "20:15:23" , 
"departure_time" : "20:16:00" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "20:17:37" , 
"departure_time" : "20:18:15" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "20:20:38" , 
"departure_time" : "20:21:13" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "20:24:35" , 
"departure_time" : "20:25:31" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "20:28:56" , 
"departure_time" : "20:30:30" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "20:32:34" , 
"departure_time" : "20:33:53" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "20:37:19" , 
"departure_time" : "20:37:19" , 
"distance_traveled" : 22.1182
} ], 
"2313" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "20:52:00" , 
"departure_time" : "20:53:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "20:55:07" , 
"departure_time" : "20:56:41" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "21:00:34" , 
"departure_time" : "21:01:10" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "21:05:36" , 
"departure_time" : "21:05:46" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "21:08:10" , 
"departure_time" : "21:09:32" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "21:12:22" , 
"departure_time" : "21:13:20" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "21:14:58" , 
"departure_time" : "21:16:31" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "21:18:33" , 
"departure_time" : "21:18:48" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "21:20:15" , 
"departure_time" : "21:21:45" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "21:25:30" , 
"departure_time" : "21:26:56" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "21:29:26" , 
"departure_time" : "21:30:27" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "21:32:01" , 
"departure_time" : "21:32:21" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "21:36:20" , 
"departure_time" : "21:36:20" , 
"distance_traveled" : 22.1182
} ], 
"2314" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "21:52:00" , 
"departure_time" : "21:53:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "21:56:24" , 
"departure_time" : "21:57:39" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "22:00:15" , 
"departure_time" : "22:00:49" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "22:05:34" , 
"departure_time" : "22:05:40" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "22:08:06" , 
"departure_time" : "22:09:11" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "22:12:05" , 
"departure_time" : "22:13:34" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "22:15:29" , 
"departure_time" : "22:15:40" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "22:17:11" , 
"departure_time" : "22:18:11" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "22:21:00" , 
"departure_time" : "22:21:23" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "22:24:23" , 
"departure_time" : "22:25:05" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "22:28:42" , 
"departure_time" : "22:29:36" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "22:31:54" , 
"departure_time" : "22:33:19" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "22:37:25" , 
"departure_time" : "22:37:25" , 
"distance_traveled" : 22.1182
} ], 
"2315" :  [ 
{ 
"stop_id" : 49,
"arrival_time" : "22:52:00" , 
"departure_time" : "22:53:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 117,
"arrival_time" : "22:55:12" , 
"departure_time" : "22:56:19" , 
"distance_traveled" : 0.9263
}, 
{ 
"stop_id" : 45,
"arrival_time" : "23:00:07" , 
"departure_time" : "23:01:40" , 
"distance_traveled" : 3.3127
}, 
{ 
"stop_id" : 18,
"arrival_time" : "23:06:33" , 
"departure_time" : "23:06:45" , 
"distance_traveled" : 7.447
}, 
{ 
"stop_id" : 12,
"arrival_time" : "23:08:12" , 
"departure_time" : "23:09:35" , 
"distance_traveled" : 8.6087
}, 
{ 
"stop_id" : 76,
"arrival_time" : "23:12:23" , 
"departure_time" : "23:13:11" , 
"distance_traveled" : 10.4907
}, 
{ 
"stop_id" : 88,
"arrival_time" : "23:14:48" , 
"departure_time" : "23:16:14" , 
"distance_traveled" : 12.1303
}, 
{ 
"stop_id" : 143,
"arrival_time" : "23:18:26" , 
"departure_time" : "23:18:29" , 
"distance_traveled" : 13.7284
}, 
{ 
"stop_id" : 48,
"arrival_time" : "23:20:03" , 
"departure_time" : "23:21:30" , 
"distance_traveled" : 15.0828
}, 
{ 
"stop_id" : 17,
"arrival_time" : "23:25:27" , 
"departure_time" : "23:26:47" , 
"distance_traveled" : 16.4775
}, 
{ 
"stop_id" : 99,
"arrival_time" : "23:29:20" , 
"departure_time" : "23:30:24" , 
"distance_traveled" : 18.8436
}, 
{ 
"stop_id" : 104,
"arrival_time" : "23:32:04" , 
"departure_time" : "23:32:51" , 
"distance_traveled" : 20.4405
}, 
{ 
"stop_id" : 145,
"arrival_time" : "23:36:47" , 
"departure_time" : "23:36:47" , 
"distance_traveled" : 22.1182
} ], 
"2316" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:03:00" , 
"departure_time" : "17:04:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:19:38" , 
"departure_time" : "17:20:27" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:26:49" , 
"departure_time" : "17:27:06" , 
"distance_traveled" : 13.1979
}, 
{ 
"stop_id" : 112,
"arrival_time" : "17:29:17" , 
"departure_time" : "17:30:00" , 
"distance_traveled" : 14.0973
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:34:43" , 
"departure_time" : "17:36:00" , 
"distance_traveled" : 16.4955
}, 
{ 
"stop_id" : 81,
"arrival_time" : "17:38:17" , 
"departure_time" : "17:39:14" , 
"distance_traveled" : 17.7778
}, 
{ 
"stop_id" : 87,
"arrival_time" : "17:41:57" , 
"departure_time" : "17:43:26" , 
"distance_traveled" : 19.3866
}, 
{ 
"stop_id" : 136,
"arrival_time" : "17:46:29" , 
"departure_time" : "17:47:55" , 
"distance_traveled" : 20.461
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:53:26" , 
"departure_time" : "17:55:00" , 
"distance_traveled" : 22.7286
}, 
{ 
"stop_id" : 104,
"arrival_time" : "17:58:34" , 
"departure_time" : "17:59:42" , 
"distance_traveled" : 24.4062
}, 
{ 
"stop_id" : 99,
"arrival_time" : "18:02:08" , 
"departure_time" : "18:02:52" , 
"distance_traveled" : 25.9919
}, 
{ 
"stop_id" : 17,
"arrival_time" : "18:06:44" , 
"departure_time" : "18:06:46" , 
"distance_traveled" : 28.3574
}, 
{ 
"stop_id" : 48,
"arrival_time" : "18:09:02" , 
"departure_time" : "18:10:37" , 
"distance_traveled" : 29.7517
}, 
{ 
"stop_id" : 143,
"arrival_time" : "18:17:35" , 
"departure_time" : "18:18:47" , 
"distance_traveled" : 31.1062
}, 
{ 
"stop_id" : 88,
"arrival_time" : "18:21:12" , 
"departure_time" : "18:21:55" , 
"distance_traveled" : 32.7044
}, 
{ 
"stop_id" : 76,
"arrival_time" : "18:24:43" , 
"departure_time" : "18:25:16" , 
"distance_traveled" : 34.3438
}, 
{ 
"stop_id" : 12,
"arrival_time" : "18:27:33" , 
"departure_time" : "18:27:53" , 
"distance_traveled" : 36.2259
}, 
{ 
"stop_id" : 18,
"arrival_time" : "18:31:20" , 
"departure_time" : "18:32:58" , 
"distance_traveled" : 37.3877
}, 
{ 
"stop_id" : 45,
"arrival_time" : "18:39:38" , 
"departure_time" : "18:40:45" , 
"distance_traveled" : 41.5218
}, 
{ 
"stop_id" : 117,
"arrival_time" : "18:43:07" , 
"departure_time" : "18:43:07" , 
"distance_traveled" : 43.9081
} ], 
"2317" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:03:00" , 
"departure_time" : "18:05:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:19:53" , 
"departure_time" : "18:20:30" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 23,
"arrival_time" : "18:26:37" , 
"departure_time" : "18:26:43" , 
"distance_traveled" : 13.1979
}, 
{ 
"stop_id" : 112,
"arrival_time" : "18:29:06" , 
"departure_time" : "18:29:59" , 
"distance_traveled" : 14.0973
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:34:53" , 
"departure_time" : "18:36:26" , 
"distance_traveled" : 16.4955
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:38:33" , 
"departure_time" : "18:39:22" , 
"distance_traveled" : 17.7778
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:41:49" , 
"departure_time" : "18:42:02" , 
"distance_traveled" : 19.3866
}, 
{ 
"stop_id" : 136,
"arrival_time" : "18:45:13" , 
"departure_time" : "18:46:44" , 
"distance_traveled" : 20.461
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:53:31" , 
"departure_time" : "18:54:43" , 
"distance_traveled" : 22.7286
}, 
{ 
"stop_id" : 104,
"arrival_time" : "18:58:12" , 
"departure_time" : "18:59:18" , 
"distance_traveled" : 24.4062
}, 
{ 
"stop_id" : 99,
"arrival_time" : "19:02:06" , 
"departure_time" : "19:02:22" , 
"distance_traveled" : 25.9919
}, 
{ 
"stop_id" : 17,
"arrival_time" : "19:06:16" , 
"departure_time" : "19:07:54" , 
"distance_traveled" : 28.3574
}, 
{ 
"stop_id" : 48,
"arrival_time" : "19:10:38" , 
"departure_time" : "19:11:02" , 
"distance_traveled" : 29.7517
}, 
{ 
"stop_id" : 143,
"arrival_time" : "19:16:24" , 
"departure_time" : "19:17:13" , 
"distance_traveled" : 31.1062
}, 
{ 
"stop_id" : 88,
"arrival_time" : "19:20:49" , 
"departure_time" : "19:20:55" , 
"distance_traveled" : 32.7044
}, 
{ 
"stop_id" : 76,
"arrival_time" : "19:24:06" , 
"departure_time" : "19:24:09" , 
"distance_traveled" : 34.3438
}, 
{ 
"stop_id" : 12,
"arrival_time" : "19:27:03" , 
"departure_time" : "19:28:43" , 
"distance_traveled" : 36.2259
}, 
{ 
"stop_id" : 18,
"arrival_time" : "19:32:40" , 
"departure_time" : "19:32:41" , 
"distance_traveled" : 37.3877
}, 
{ 
"stop_id" : 45,
"arrival_time" : "19:38:01" , 
"departure_time" : "19:39:15" , 
"distance_traveled" : 41.5218
}, 
{ 
"stop_id" : 117,
"arrival_time" : "19:43:14" , 
"departure_time" : "19:43:14" , 
"distance_traveled" : 43.9081
} ], 
"2318" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "24:14:00" , 
"departure_time" : "24:16:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "24:18:55" , 
"departure_time" : "24:20:07" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "24:22:12" , 
"departure_time" : "24:23:03" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "24:25:51" , 
"departure_time" : "24:27:16" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "24:29:25" , 
"departure_time" : "24:30:26" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "24:32:01" , 
"departure_time" : "24:33:23" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "24:35:22" , 
"departure_time" : "24:36:52" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "24:38:30" , 
"departure_time" : "24:40:01" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "24:41:31" , 
"departure_time" : "24:41:58" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "24:43:27" , 
"departure_time" : "24:44:57" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "24:50:30" , 
"departure_time" : "24:51:11" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "24:53:41" , 
"departure_time" : "24:53:51" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "24:58:10" , 
"departure_time" : "24:58:10" , 
"distance_traveled" : 22.1062
} ], 
"2319" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "24:14:00" , 
"departure_time" : "24:14:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "24:18:01" , 
"departure_time" : "24:19:27" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "24:22:26" , 
"departure_time" : "24:23:43" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "24:26:17" , 
"departure_time" : "24:27:44" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "24:29:27" , 
"departure_time" : "24:30:24" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "24:31:57" , 
"departure_time" : "24:32:36" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "24:34:39" , 
"departure_time" : "24:36:03" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "24:38:24" , 
"departure_time" : "24:39:12" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "24:40:48" , 
"departure_time" : "24:41:39" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "24:43:51" , 
"departure_time" : "24:44:34" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "24:49:43" , 
"departure_time" : "24:50:50" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "24:54:07" , 
"departure_time" : "24:54:42" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "24:58:35" , 
"departure_time" : "24:58:35" , 
"distance_traveled" : 22.1062
} ], 
"2320" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:03:00" , 
"departure_time" : "17:03:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:19:24" , 
"departure_time" : "17:19:57" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:26:33" , 
"departure_time" : "17:27:00" , 
"distance_traveled" : 13.1979
}, 
{ 
"stop_id" : 112,
"arrival_time" : "17:29:27" , 
"departure_time" : "17:31:00" , 
"distance_traveled" : 14.0973
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:35:33" , 
"departure_time" : "17:36:12" , 
"distance_traveled" : 16.4955
}, 
{ 
"stop_id" : 81,
"arrival_time" : "17:37:39" , 
"departure_time" : "17:39:10" , 
"distance_traveled" : 17.7778
}, 
{ 
"stop_id" : 87,
"arrival_time" : "17:42:31" , 
"departure_time" : "17:43:42" , 
"distance_traveled" : 19.3866
}, 
{ 
"stop_id" : 136,
"arrival_time" : "17:46:11" , 
"departure_time" : "17:46:18" , 
"distance_traveled" : 20.461
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:52:07" , 
"departure_time" : "17:53:44" , 
"distance_traveled" : 22.7286
}, 
{ 
"stop_id" : 104,
"arrival_time" : "17:58:37" , 
"departure_time" : "17:59:51" , 
"distance_traveled" : 24.4062
}, 
{ 
"stop_id" : 99,
"arrival_time" : "18:02:14" , 
"departure_time" : "18:03:34" , 
"distance_traveled" : 25.9919
}, 
{ 
"stop_id" : 17,
"arrival_time" : "18:07:20" , 
"departure_time" : "18:08:07" , 
"distance_traveled" : 28.3574
}, 
{ 
"stop_id" : 48,
"arrival_time" : "18:09:47" , 
"departure_time" : "18:10:03" , 
"distance_traveled" : 29.7517
}, 
{ 
"stop_id" : 143,
"arrival_time" : "18:16:16" , 
"departure_time" : "18:17:42" , 
"distance_traveled" : 31.1062
}, 
{ 
"stop_id" : 88,
"arrival_time" : "18:21:26" , 
"departure_time" : "18:22:34" , 
"distance_traveled" : 32.7044
}, 
{ 
"stop_id" : 76,
"arrival_time" : "18:25:08" , 
"departure_time" : "18:26:20" , 
"distance_traveled" : 34.3438
}, 
{ 
"stop_id" : 12,
"arrival_time" : "18:28:12" , 
"departure_time" : "18:28:25" , 
"distance_traveled" : 36.2259
}, 
{ 
"stop_id" : 18,
"arrival_time" : "18:31:13" , 
"departure_time" : "18:31:15" , 
"distance_traveled" : 37.3877
}, 
{ 
"stop_id" : 45,
"arrival_time" : "18:38:02" , 
"departure_time" : "18:39:30" , 
"distance_traveled" : 41.5218
}, 
{ 
"stop_id" : 117,
"arrival_time" : "18:43:28" , 
"departure_time" : "18:43:28" , 
"distance_traveled" : 43.9081
} ], 
"2321" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "25:31:00" , 
"departure_time" : "25:33:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "25:34:36" , 
"departure_time" : "25:36:16" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "25:38:40" , 
"departure_time" : "25:39:10" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "25:41:30" , 
"departure_time" : "25:43:02" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "25:45:32" , 
"departure_time" : "25:47:01" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "25:48:29" , 
"departure_time" : "25:48:59" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "25:50:30" , 
"departure_time" : "25:51:39" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "25:54:09" , 
"departure_time" : "25:54:53" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "25:56:44" , 
"departure_time" : "25:56:49" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "25:59:05" , 
"departure_time" : "26:00:15" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "26:07:10" , 
"departure_time" : "26:07:23" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "26:10:13" , 
"departure_time" : "26:10:53" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "26:16:40" , 
"departure_time" : "26:16:40" , 
"distance_traveled" : 22.1062
} ], 
"2322" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:03:00" , 
"departure_time" : "18:04:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:19:55" , 
"departure_time" : "18:20:30" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 23,
"arrival_time" : "18:26:35" , 
"departure_time" : "18:28:06" , 
"distance_traveled" : 13.1979
}, 
{ 
"stop_id" : 112,
"arrival_time" : "18:30:31" , 
"departure_time" : "18:31:09" , 
"distance_traveled" : 14.0973
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:34:38" , 
"departure_time" : "18:35:45" , 
"distance_traveled" : 16.4955
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:38:07" , 
"departure_time" : "18:39:46" , 
"distance_traveled" : 17.7778
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:42:39" , 
"departure_time" : "18:43:33" , 
"distance_traveled" : 19.3866
}, 
{ 
"stop_id" : 136,
"arrival_time" : "18:45:54" , 
"departure_time" : "18:47:16" , 
"distance_traveled" : 20.461
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:53:22" , 
"departure_time" : "18:54:28" , 
"distance_traveled" : 22.7286
}, 
{ 
"stop_id" : 104,
"arrival_time" : "18:58:06" , 
"departure_time" : "18:58:47" , 
"distance_traveled" : 24.4062
}, 
{ 
"stop_id" : 99,
"arrival_time" : "19:01:41" , 
"departure_time" : "19:02:07" , 
"distance_traveled" : 25.9919
}, 
{ 
"stop_id" : 17,
"arrival_time" : "19:06:26" , 
"departure_time" : "19:07:10" , 
"distance_traveled" : 28.3574
}, 
{ 
"stop_id" : 48,
"arrival_time" : "19:09:44" , 
"departure_time" : "19:09:59" , 
"distance_traveled" : 29.7517
}, 
{ 
"stop_id" : 143,
"arrival_time" : "19:16:15" , 
"departure_time" : "19:17:17" , 
"distance_traveled" : 31.1062
}, 
{ 
"stop_id" : 88,
"arrival_time" : "19:21:02" , 
"departure_time" : "19:22:19" , 
"distance_traveled" : 32.7044
}, 
{ 
"stop_id" : 76,
"arrival_time" : "19:25:17" , 
"departure_time" : "19:26:32" , 
"distance_traveled" : 34.3438
}, 
{ 
"stop_id" : 12,
"arrival_time" : "19:28:15" , 
"departure_time" : "19:29:28" , 
"distance_traveled" : 36.2259
}, 
{ 
"stop_id" : 18,
"arrival_time" : "19:32:13" , 
"departure_time" : "19:32:52" , 
"distance_traveled" : 37.3877
}, 
{ 
"stop_id" : 45,
"arrival_time" : "19:38:39" , 
"departure_time" : "19:39:23" , 
"distance_traveled" : 41.5218
}, 
{ 
"stop_id" : 117,
"arrival_time" : "19:42:44" , 
"departure_time" : "19:42:44" , 
"distance_traveled" : 43.9081
} ], 
"2323" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "25:31:00" , 
"departure_time" : "25:32:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "25:35:05" , 
"departure_time" : "25:35:48" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "25:37:43" , 
"departure_time" : "25:38:31" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "25:41:48" , 
"departure_time" : "25:42:50" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "25:45:02" , 
"departure_time" : "25:45:13" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "25:47:11" , 
"departure_time" : "25:47:18" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "25:50:07" , 
"departure_time" : "25:51:02" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "25:53:55" , 
"departure_time" : "25:54:50" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "25:56:55" , 
"departure_time" : "25:57:26" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "25:59:31" , 
"departure_time" : "25:59:48" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "26:06:17" , 
"departure_time" : "26:07:05" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "26:10:48" , 
"departure_time" : "26:12:26" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "26:17:38" , 
"departure_time" : "26:17:38" , 
"distance_traveled" : 22.1062
} ], 
"2324" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "25:31:00" , 
"departure_time" : "25:33:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "25:34:49" , 
"departure_time" : "25:35:36" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "25:37:47" , 
"departure_time" : "25:37:57" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "25:41:10" , 
"departure_time" : "25:42:12" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "25:45:02" , 
"departure_time" : "25:46:27" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "25:48:25" , 
"departure_time" : "25:48:45" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "25:50:20" , 
"departure_time" : "25:51:53" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "25:54:33" , 
"departure_time" : "25:55:02" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "25:56:29" , 
"departure_time" : "25:56:48" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "25:59:19" , 
"departure_time" : "26:00:58" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "26:07:39" , 
"departure_time" : "26:07:45" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "26:10:06" , 
"departure_time" : "26:11:41" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "26:17:35" , 
"departure_time" : "26:17:35" , 
"distance_traveled" : 22.1062
} ], 
"2325" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "26:20:00" , 
"departure_time" : "26:21:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "26:23:08" , 
"departure_time" : "26:23:15" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "26:26:07" , 
"departure_time" : "26:26:08" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "26:30:01" , 
"departure_time" : "26:30:11" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "26:33:10" , 
"departure_time" : "26:34:43" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "26:37:33" , 
"departure_time" : "26:38:04" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "26:39:31" , 
"departure_time" : "26:41:06" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "26:43:35" , 
"departure_time" : "26:44:19" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "26:45:44" , 
"departure_time" : "26:45:52" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "26:48:08" , 
"departure_time" : "26:48:22" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "26:55:14" , 
"departure_time" : "26:56:46" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "27:00:32" , 
"departure_time" : "27:00:37" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "27:05:05" , 
"departure_time" : "27:05:05" , 
"distance_traveled" : 22.1062
} ], 
"2326" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "26:20:00" , 
"departure_time" : "26:21:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "26:24:29" , 
"departure_time" : "26:25:16" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "26:26:47" , 
"departure_time" : "26:27:57" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "26:31:10" , 
"departure_time" : "26:31:37" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "26:33:27" , 
"departure_time" : "26:33:28" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "26:36:01" , 
"departure_time" : "26:36:03" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "26:39:02" , 
"departure_time" : "26:40:25" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "26:43:23" , 
"departure_time" : "26:43:40" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "26:45:17" , 
"departure_time" : "26:46:10" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "26:48:53" , 
"departure_time" : "26:50:26" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "26:56:33" , 
"departure_time" : "26:57:32" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "26:59:59" , 
"departure_time" : "27:00:07" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "27:05:08" , 
"departure_time" : "27:05:08" , 
"distance_traveled" : 22.1062
} ], 
"2327" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "26:20:00" , 
"departure_time" : "26:20:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "26:23:13" , 
"departure_time" : "26:24:53" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "26:27:40" , 
"departure_time" : "26:28:38" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "26:30:58" , 
"departure_time" : "26:31:47" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "26:33:49" , 
"departure_time" : "26:34:43" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "26:36:54" , 
"departure_time" : "26:38:14" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "26:40:20" , 
"departure_time" : "26:41:39" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "26:43:19" , 
"departure_time" : "26:44:24" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "26:46:05" , 
"departure_time" : "26:47:06" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "26:49:01" , 
"departure_time" : "26:49:50" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "26:55:49" , 
"departure_time" : "26:57:00" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "27:00:11" , 
"departure_time" : "27:00:13" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "27:05:02" , 
"departure_time" : "27:05:02" , 
"distance_traveled" : 22.1062
} ], 
"2328" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "07:14:00" , 
"departure_time" : "07:14:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "07:18:08" , 
"departure_time" : "07:19:47" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "07:25:39" , 
"departure_time" : "07:26:42" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "07:32:03" , 
"departure_time" : "07:33:39" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "07:35:36" , 
"departure_time" : "07:36:13" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "07:37:37" , 
"departure_time" : "07:38:27" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "07:40:50" , 
"departure_time" : "07:41:16" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "07:43:26" , 
"departure_time" : "07:44:49" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "07:47:23" , 
"departure_time" : "07:47:54" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "07:49:31" , 
"departure_time" : "07:49:51" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "07:56:20" , 
"departure_time" : "07:56:27" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "08:04:07" , 
"departure_time" : "08:04:29" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "08:08:22" , 
"departure_time" : "08:08:22" , 
"distance_traveled" : 22.1062
} ], 
"2329" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "08:14:00" , 
"departure_time" : "08:14:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "08:18:27" , 
"departure_time" : "08:19:19" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "08:24:52" , 
"departure_time" : "08:25:14" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "08:31:22" , 
"departure_time" : "08:31:34" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "08:34:12" , 
"departure_time" : "08:34:40" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "08:37:28" , 
"departure_time" : "08:37:49" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "08:40:21" , 
"departure_time" : "08:41:36" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "08:44:15" , 
"departure_time" : "08:44:58" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "08:46:43" , 
"departure_time" : "08:47:53" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "08:50:10" , 
"departure_time" : "08:50:48" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "08:56:38" , 
"departure_time" : "08:57:30" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "09:04:52" , 
"departure_time" : "09:06:12" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "09:09:20" , 
"departure_time" : "09:09:20" , 
"distance_traveled" : 22.1062
} ], 
"2330" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "24:14:00" , 
"departure_time" : "24:16:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "24:18:43" , 
"departure_time" : "24:19:56" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "24:22:13" , 
"departure_time" : "24:22:35" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "24:25:22" , 
"departure_time" : "24:26:42" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "24:29:20" , 
"departure_time" : "24:29:49" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "24:31:29" , 
"departure_time" : "24:32:10" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "24:34:41" , 
"departure_time" : "24:35:44" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "24:38:03" , 
"departure_time" : "24:38:20" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "24:40:17" , 
"departure_time" : "24:41:24" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "24:44:07" , 
"departure_time" : "24:44:34" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "24:49:27" , 
"departure_time" : "24:50:42" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "24:54:15" , 
"departure_time" : "24:54:39" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "24:58:24" , 
"departure_time" : "24:58:24" , 
"distance_traveled" : 22.1062
} ], 
"2331" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "09:14:00" , 
"departure_time" : "09:14:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "09:18:08" , 
"departure_time" : "09:18:47" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "09:24:39" , 
"departure_time" : "09:25:33" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "09:31:54" , 
"departure_time" : "09:32:10" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "09:34:16" , 
"departure_time" : "09:35:07" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "09:37:51" , 
"departure_time" : "09:39:15" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "09:41:24" , 
"departure_time" : "09:42:09" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "09:43:45" , 
"departure_time" : "09:44:20" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "09:46:35" , 
"departure_time" : "09:46:54" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "09:49:19" , 
"departure_time" : "09:50:51" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "09:57:32" , 
"departure_time" : "09:57:52" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "10:04:20" , 
"departure_time" : "10:05:13" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "10:08:53" , 
"departure_time" : "10:08:53" , 
"distance_traveled" : 22.1062
} ], 
"2332" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "10:14:00" , 
"departure_time" : "10:15:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "10:18:40" , 
"departure_time" : "10:19:25" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "10:24:45" , 
"departure_time" : "10:26:09" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "10:32:24" , 
"departure_time" : "10:32:33" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "10:34:09" , 
"departure_time" : "10:34:53" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "10:37:44" , 
"departure_time" : "10:38:11" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "10:40:27" , 
"departure_time" : "10:41:28" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "10:44:01" , 
"departure_time" : "10:45:34" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "10:47:33" , 
"departure_time" : "10:48:35" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "10:50:02" , 
"departure_time" : "10:51:39" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "10:57:37" , 
"departure_time" : "10:58:03" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "11:04:26" , 
"departure_time" : "11:04:51" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "11:08:25" , 
"departure_time" : "11:08:25" , 
"distance_traveled" : 22.1062
} ], 
"2333" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "07:14:00" , 
"departure_time" : "07:16:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "07:19:38" , 
"departure_time" : "07:20:54" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "07:25:16" , 
"departure_time" : "07:25:17" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "07:31:01" , 
"departure_time" : "07:32:06" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "07:35:05" , 
"departure_time" : "07:36:37" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "07:38:32" , 
"departure_time" : "07:39:40" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "07:41:08" , 
"departure_time" : "07:42:48" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "07:44:40" , 
"departure_time" : "07:46:09" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "07:47:29" , 
"departure_time" : "07:48:02" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "07:49:33" , 
"departure_time" : "07:51:01" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "07:57:28" , 
"departure_time" : "07:58:57" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "08:05:29" , 
"departure_time" : "08:07:03" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "08:09:34" , 
"departure_time" : "08:09:34" , 
"distance_traveled" : 22.1062
} ], 
"2334" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "11:14:00" , 
"departure_time" : "11:16:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "11:19:21" , 
"departure_time" : "11:19:38" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "11:24:17" , 
"departure_time" : "11:25:46" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "11:32:29" , 
"departure_time" : "11:33:21" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "11:34:52" , 
"departure_time" : "11:35:02" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "11:37:10" , 
"departure_time" : "11:37:22" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "11:40:12" , 
"departure_time" : "11:41:04" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "11:43:52" , 
"departure_time" : "11:45:10" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "11:47:18" , 
"departure_time" : "11:48:19" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "11:50:01" , 
"departure_time" : "11:50:32" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "11:56:31" , 
"departure_time" : "11:56:55" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "12:04:24" , 
"departure_time" : "12:05:02" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "12:08:38" , 
"departure_time" : "12:08:38" , 
"distance_traveled" : 22.1062
} ], 
"2335" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "08:14:00" , 
"departure_time" : "08:15:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "08:19:14" , 
"departure_time" : "08:19:56" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "08:24:42" , 
"departure_time" : "08:26:01" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "08:32:19" , 
"departure_time" : "08:33:32" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "08:35:13" , 
"departure_time" : "08:35:46" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "08:37:33" , 
"departure_time" : "08:38:27" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "08:40:54" , 
"departure_time" : "08:41:30" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "08:43:36" , 
"departure_time" : "08:44:28" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "08:46:52" , 
"departure_time" : "08:47:33" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "08:49:41" , 
"departure_time" : "08:51:21" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "08:57:40" , 
"departure_time" : "08:58:17" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "09:04:37" , 
"departure_time" : "09:05:44" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "09:09:07" , 
"departure_time" : "09:09:07" , 
"distance_traveled" : 22.1062
} ], 
"2336" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "12:14:00" , 
"departure_time" : "12:16:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "12:18:59" , 
"departure_time" : "12:20:18" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "12:25:19" , 
"departure_time" : "12:26:07" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "12:31:48" , 
"departure_time" : "12:32:32" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "12:34:44" , 
"departure_time" : "12:35:20" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "12:37:36" , 
"departure_time" : "12:39:16" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "12:41:40" , 
"departure_time" : "12:42:13" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "12:43:33" , 
"departure_time" : "12:44:44" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "12:47:11" , 
"departure_time" : "12:47:24" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "12:49:13" , 
"departure_time" : "12:50:53" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "12:57:40" , 
"departure_time" : "12:58:35" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "13:04:55" , 
"departure_time" : "13:06:06" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "13:09:11" , 
"departure_time" : "13:09:11" , 
"distance_traveled" : 22.1062
} ], 
"2337" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "09:14:00" , 
"departure_time" : "09:16:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "09:19:21" , 
"departure_time" : "09:19:47" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "09:24:26" , 
"departure_time" : "09:24:59" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "09:31:33" , 
"departure_time" : "09:31:54" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "09:34:21" , 
"departure_time" : "09:35:05" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "09:37:44" , 
"departure_time" : "09:38:35" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "09:40:51" , 
"departure_time" : "09:42:13" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "09:44:22" , 
"departure_time" : "09:44:38" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "09:46:16" , 
"departure_time" : "09:47:42" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "09:50:26" , 
"departure_time" : "09:51:41" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "09:57:15" , 
"departure_time" : "09:58:07" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "10:04:52" , 
"departure_time" : "10:05:49" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "10:08:57" , 
"departure_time" : "10:08:57" , 
"distance_traveled" : 22.1062
} ], 
"2338" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "13:14:00" , 
"departure_time" : "13:16:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "13:19:27" , 
"departure_time" : "13:19:38" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "13:24:11" , 
"departure_time" : "13:25:38" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "13:32:27" , 
"departure_time" : "13:32:29" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "13:34:02" , 
"departure_time" : "13:34:45" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "13:37:43" , 
"departure_time" : "13:39:08" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "13:41:25" , 
"departure_time" : "13:41:36" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "13:43:11" , 
"departure_time" : "13:44:29" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "13:47:18" , 
"departure_time" : "13:48:58" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "13:50:40" , 
"departure_time" : "13:52:18" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "13:57:38" , 
"departure_time" : "13:57:48" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "14:04:10" , 
"departure_time" : "14:04:32" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "14:08:22" , 
"departure_time" : "14:08:22" , 
"distance_traveled" : 22.1062
} ], 
"2339" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "10:14:00" , 
"departure_time" : "10:14:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "10:18:10" , 
"departure_time" : "10:18:33" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "10:24:23" , 
"departure_time" : "10:25:35" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "10:32:12" , 
"departure_time" : "10:33:35" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "10:35:23" , 
"departure_time" : "10:36:09" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "10:37:46" , 
"departure_time" : "10:39:03" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "10:41:17" , 
"departure_time" : "10:41:48" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "10:43:31" , 
"departure_time" : "10:43:51" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "10:46:20" , 
"departure_time" : "10:47:16" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "10:49:56" , 
"departure_time" : "10:50:52" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "10:56:56" , 
"departure_time" : "10:57:47" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "11:04:51" , 
"departure_time" : "11:05:30" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "11:08:39" , 
"departure_time" : "11:08:39" , 
"distance_traveled" : 22.1062
} ], 
"2340" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "14:14:00" , 
"departure_time" : "14:14:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "14:18:03" , 
"departure_time" : "14:18:25" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "14:24:22" , 
"departure_time" : "14:25:44" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "14:32:22" , 
"departure_time" : "14:33:29" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "14:35:07" , 
"departure_time" : "14:36:01" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "14:37:54" , 
"departure_time" : "14:38:23" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "14:40:29" , 
"departure_time" : "14:40:45" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "14:43:16" , 
"departure_time" : "14:44:25" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "14:47:09" , 
"departure_time" : "14:48:42" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "14:50:33" , 
"departure_time" : "14:51:30" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "14:56:57" , 
"departure_time" : "14:57:12" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "15:04:15" , 
"departure_time" : "15:05:32" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "15:09:17" , 
"departure_time" : "15:09:17" , 
"distance_traveled" : 22.1062
} ], 
"2341" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "11:14:00" , 
"departure_time" : "11:15:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "11:18:02" , 
"departure_time" : "11:19:31" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "11:25:29" , 
"departure_time" : "11:25:50" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "11:31:21" , 
"departure_time" : "11:32:23" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "11:35:02" , 
"departure_time" : "11:36:17" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "11:38:15" , 
"departure_time" : "11:38:46" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "11:40:31" , 
"departure_time" : "11:42:02" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "11:44:31" , 
"departure_time" : "11:45:19" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "11:46:48" , 
"departure_time" : "11:48:16" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "11:50:28" , 
"departure_time" : "11:51:06" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "11:56:38" , 
"departure_time" : "11:57:07" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "12:04:29" , 
"departure_time" : "12:04:41" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "12:08:12" , 
"departure_time" : "12:08:12" , 
"distance_traveled" : 22.1062
} ], 
"2342" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "15:14:00" , 
"departure_time" : "15:15:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "15:19:11" , 
"departure_time" : "15:20:40" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "15:25:29" , 
"departure_time" : "15:25:56" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "15:31:27" , 
"departure_time" : "15:31:58" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "15:34:31" , 
"departure_time" : "15:35:43" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "15:38:12" , 
"departure_time" : "15:38:39" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "15:40:27" , 
"departure_time" : "15:41:13" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "15:43:46" , 
"departure_time" : "15:44:07" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "15:46:21" , 
"departure_time" : "15:47:42" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "15:50:21" , 
"departure_time" : "15:51:41" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "15:57:20" , 
"departure_time" : "15:57:35" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "16:04:15" , 
"departure_time" : "16:04:35" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "16:08:20" , 
"departure_time" : "16:08:20" , 
"distance_traveled" : 22.1062
} ], 
"2343" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "12:14:00" , 
"departure_time" : "12:16:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "12:19:40" , 
"departure_time" : "12:20:01" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "12:24:21" , 
"departure_time" : "12:25:11" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "12:31:50" , 
"departure_time" : "12:33:06" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "12:35:16" , 
"departure_time" : "12:35:18" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "12:37:02" , 
"departure_time" : "12:38:10" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "12:41:08" , 
"departure_time" : "12:41:54" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "12:43:46" , 
"departure_time" : "12:43:47" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "12:46:01" , 
"departure_time" : "12:47:05" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "12:50:04" , 
"departure_time" : "12:51:40" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "12:57:36" , 
"departure_time" : "12:57:41" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "13:04:05" , 
"departure_time" : "13:05:38" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "13:09:33" , 
"departure_time" : "13:09:33" , 
"distance_traveled" : 22.1062
} ], 
"2344" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "16:14:00" , 
"departure_time" : "16:16:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "16:19:21" , 
"departure_time" : "16:19:27" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "16:24:06" , 
"departure_time" : "16:25:33" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "16:32:27" , 
"departure_time" : "16:33:24" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "16:34:57" , 
"departure_time" : "16:35:54" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "16:37:57" , 
"departure_time" : "16:38:31" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "16:40:34" , 
"departure_time" : "16:40:59" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "16:43:25" , 
"departure_time" : "16:44:11" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "16:46:46" , 
"departure_time" : "16:47:48" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "16:50:02" , 
"departure_time" : "16:51:03" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "16:57:01" , 
"departure_time" : "16:57:57" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "17:04:56" , 
"departure_time" : "17:06:34" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "17:09:38" , 
"departure_time" : "17:09:38" , 
"distance_traveled" : 22.1062
} ], 
"2345" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "13:14:00" , 
"departure_time" : "13:17:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "13:19:32" , 
"departure_time" : "13:20:54" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "13:25:22" , 
"departure_time" : "13:26:25" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "13:32:03" , 
"departure_time" : "13:32:53" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "13:34:50" , 
"departure_time" : "13:36:26" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "13:38:36" , 
"departure_time" : "13:39:47" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "13:41:11" , 
"departure_time" : "13:41:19" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "13:43:08" , 
"departure_time" : "13:43:42" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "13:46:34" , 
"departure_time" : "13:46:54" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "13:49:20" , 
"departure_time" : "13:49:25" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "13:56:05" , 
"departure_time" : "13:56:56" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "14:04:51" , 
"departure_time" : "14:05:13" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "14:08:22" , 
"departure_time" : "14:08:22" , 
"distance_traveled" : 22.1062
} ], 
"2346" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "17:14:00" , 
"departure_time" : "17:14:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "17:18:13" , 
"departure_time" : "17:19:11" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "17:24:58" , 
"departure_time" : "17:25:19" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "17:31:21" , 
"departure_time" : "17:32:22" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "17:35:01" , 
"departure_time" : "17:35:20" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "17:37:19" , 
"departure_time" : "17:37:42" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "17:40:23" , 
"departure_time" : "17:41:59" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "17:44:36" , 
"departure_time" : "17:45:50" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "17:47:14" , 
"departure_time" : "17:48:14" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "17:50:00" , 
"departure_time" : "17:50:06" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "17:56:06" , 
"departure_time" : "17:57:23" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "18:05:17" , 
"departure_time" : "18:06:54" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "18:09:37" , 
"departure_time" : "18:09:37" , 
"distance_traveled" : 22.1062
} ], 
"2347" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "14:14:00" , 
"departure_time" : "14:16:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "14:18:54" , 
"departure_time" : "14:19:28" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "14:24:34" , 
"departure_time" : "14:24:48" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "14:31:14" , 
"departure_time" : "14:31:57" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "14:34:43" , 
"departure_time" : "14:35:49" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "14:38:06" , 
"departure_time" : "14:39:08" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "14:41:02" , 
"departure_time" : "14:41:43" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "14:43:41" , 
"departure_time" : "14:44:22" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "14:46:41" , 
"departure_time" : "14:47:15" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "14:49:34" , 
"departure_time" : "14:49:51" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "14:56:17" , 
"departure_time" : "14:57:46" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "15:05:29" , 
"departure_time" : "15:05:32" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "15:08:03" , 
"departure_time" : "15:08:03" , 
"distance_traveled" : 22.1062
} ], 
"2348" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "18:14:00" , 
"departure_time" : "18:15:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "18:19:18" , 
"departure_time" : "18:20:30" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "18:25:12" , 
"departure_time" : "18:26:11" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "18:31:59" , 
"departure_time" : "18:32:48" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "18:34:49" , 
"departure_time" : "18:35:39" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "18:37:50" , 
"departure_time" : "18:38:48" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "18:40:58" , 
"departure_time" : "18:41:05" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "18:43:07" , 
"departure_time" : "18:44:18" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "18:47:11" , 
"departure_time" : "18:47:30" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "18:49:19" , 
"departure_time" : "18:49:45" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "18:56:26" , 
"departure_time" : "18:56:29" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "19:04:03" , 
"departure_time" : "19:04:37" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "19:08:34" , 
"departure_time" : "19:08:34" , 
"distance_traveled" : 22.1062
} ], 
"2349" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "15:14:00" , 
"departure_time" : "15:14:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "15:18:04" , 
"departure_time" : "15:18:15" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "15:24:11" , 
"departure_time" : "15:24:37" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "15:31:26" , 
"departure_time" : "15:32:09" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "15:34:43" , 
"departure_time" : "15:34:45" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "15:37:02" , 
"departure_time" : "15:38:07" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "15:41:05" , 
"departure_time" : "15:41:54" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "15:43:49" , 
"departure_time" : "15:44:29" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "15:46:40" , 
"departure_time" : "15:47:42" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "15:50:02" , 
"departure_time" : "15:50:44" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "15:56:42" , 
"departure_time" : "15:57:33" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "16:04:51" , 
"departure_time" : "16:06:06" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "16:09:15" , 
"departure_time" : "16:09:15" , 
"distance_traveled" : 22.1062
} ], 
"2350" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "19:14:00" , 
"departure_time" : "19:15:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "19:18:21" , 
"departure_time" : "19:19:24" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "19:25:03" , 
"departure_time" : "19:25:27" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "19:31:24" , 
"departure_time" : "19:32:09" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "19:34:45" , 
"departure_time" : "19:35:33" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "19:37:48" , 
"departure_time" : "19:37:59" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "19:40:11" , 
"departure_time" : "19:41:26" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "19:44:15" , 
"departure_time" : "19:44:21" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "19:46:06" , 
"departure_time" : "19:47:10" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "19:50:04" , 
"departure_time" : "19:51:16" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "19:57:12" , 
"departure_time" : "19:58:00" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "20:04:48" , 
"departure_time" : "20:05:16" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "20:08:28" , 
"departure_time" : "20:08:28" , 
"distance_traveled" : 22.1062
} ], 
"2351" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "16:14:00" , 
"departure_time" : "16:15:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "16:18:58" , 
"departure_time" : "16:20:09" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "16:25:11" , 
"departure_time" : "16:25:39" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "16:31:28" , 
"departure_time" : "16:31:40" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "16:34:12" , 
"departure_time" : "16:35:19" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "16:38:07" , 
"departure_time" : "16:39:06" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "16:40:59" , 
"departure_time" : "16:41:55" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "16:43:56" , 
"departure_time" : "16:44:12" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "16:46:16" , 
"departure_time" : "16:46:45" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "16:49:29" , 
"departure_time" : "16:49:59" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "16:56:30" , 
"departure_time" : "16:56:43" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "17:04:13" , 
"departure_time" : "17:04:27" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "17:08:14" , 
"departure_time" : "17:08:14" , 
"distance_traveled" : 22.1062
} ], 
"2352" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "20:14:00" , 
"departure_time" : "20:14:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "20:18:03" , 
"departure_time" : "20:19:32" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "20:25:29" , 
"departure_time" : "20:26:46" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "20:32:17" , 
"departure_time" : "20:33:08" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "20:34:51" , 
"departure_time" : "20:35:16" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "20:37:25" , 
"departure_time" : "20:38:14" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "20:40:49" , 
"departure_time" : "20:41:00" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "20:43:11" , 
"departure_time" : "20:44:25" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "20:47:14" , 
"departure_time" : "20:48:50" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "20:50:36" , 
"departure_time" : "20:51:50" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "20:57:14" , 
"departure_time" : "20:57:55" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "21:04:41" , 
"departure_time" : "21:05:37" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "21:08:56" , 
"departure_time" : "21:08:56" , 
"distance_traveled" : 22.1062
} ], 
"2353" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "17:14:00" , 
"departure_time" : "17:15:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "17:18:14" , 
"departure_time" : "17:18:31" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "17:24:17" , 
"departure_time" : "17:24:53" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "17:31:36" , 
"departure_time" : "17:33:09" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "17:35:33" , 
"departure_time" : "17:36:11" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "17:37:38" , 
"departure_time" : "17:37:48" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "17:40:10" , 
"departure_time" : "17:40:40" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "17:43:30" , 
"departure_time" : "17:44:52" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "17:47:22" , 
"departure_time" : "17:47:27" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "17:49:05" , 
"departure_time" : "17:49:10" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "17:56:05" , 
"departure_time" : "17:56:48" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "18:04:43" , 
"departure_time" : "18:05:00" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "18:08:17" , 
"departure_time" : "18:08:17" , 
"distance_traveled" : 22.1062
} ], 
"2354" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "21:14:00" , 
"departure_time" : "21:14:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "21:18:31" , 
"departure_time" : "21:19:40" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "21:25:09" , 
"departure_time" : "21:26:13" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "21:32:04" , 
"departure_time" : "21:33:28" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "21:35:24" , 
"departure_time" : "21:35:45" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "21:37:21" , 
"departure_time" : "21:37:48" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "21:40:27" , 
"departure_time" : "21:42:02" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "21:44:35" , 
"departure_time" : "21:45:44" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "21:47:09" , 
"departure_time" : "21:48:41" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "21:50:32" , 
"departure_time" : "21:50:38" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "21:56:06" , 
"departure_time" : "21:56:56" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "22:04:50" , 
"departure_time" : "22:06:19" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "22:09:29" , 
"departure_time" : "22:09:29" , 
"distance_traveled" : 22.1062
} ], 
"2355" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "18:14:00" , 
"departure_time" : "18:16:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "18:18:42" , 
"departure_time" : "18:19:14" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "18:24:32" , 
"departure_time" : "18:25:58" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "18:32:26" , 
"departure_time" : "18:34:04" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "18:35:38" , 
"departure_time" : "18:36:24" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "18:37:46" , 
"departure_time" : "18:38:38" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "18:40:52" , 
"departure_time" : "18:40:57" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "18:43:05" , 
"departure_time" : "18:43:13" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "18:46:08" , 
"departure_time" : "18:47:09" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "18:50:01" , 
"departure_time" : "18:51:30" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "18:57:29" , 
"departure_time" : "18:58:08" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "19:04:39" , 
"departure_time" : "19:04:49" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "19:08:10" , 
"departure_time" : "19:08:10" , 
"distance_traveled" : 22.1062
} ], 
"2356" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "22:14:00" , 
"departure_time" : "22:14:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "22:18:22" , 
"departure_time" : "22:19:03" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "22:24:41" , 
"departure_time" : "22:25:34" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "22:31:53" , 
"departure_time" : "22:31:59" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "22:34:06" , 
"departure_time" : "22:35:25" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "22:38:19" , 
"departure_time" : "22:38:30" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "22:40:11" , 
"departure_time" : "22:40:29" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "22:43:18" , 
"departure_time" : "22:44:14" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "22:46:56" , 
"departure_time" : "22:48:28" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "22:50:32" , 
"departure_time" : "22:51:52" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "22:57:20" , 
"departure_time" : "22:57:52" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "23:04:32" , 
"departure_time" : "23:04:38" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "23:08:06" , 
"departure_time" : "23:08:06" , 
"distance_traveled" : 22.1062
} ], 
"2357" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "19:14:00" , 
"departure_time" : "19:14:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "19:18:39" , 
"departure_time" : "19:19:00" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "19:24:21" , 
"departure_time" : "19:25:12" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "19:31:51" , 
"departure_time" : "19:33:13" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "19:35:22" , 
"departure_time" : "19:36:43" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "19:38:21" , 
"departure_time" : "19:39:09" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "19:40:48" , 
"departure_time" : "19:42:10" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "19:44:22" , 
"departure_time" : "19:45:55" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "19:47:33" , 
"departure_time" : "19:48:57" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "19:50:24" , 
"departure_time" : "19:51:39" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "19:57:15" , 
"departure_time" : "19:57:18" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "20:04:03" , 
"departure_time" : "20:04:38" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "20:08:35" , 
"departure_time" : "20:08:35" , 
"distance_traveled" : 22.1062
} ], 
"2358" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "23:14:00" , 
"departure_time" : "23:15:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "23:19:00" , 
"departure_time" : "23:20:11" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "23:25:11" , 
"departure_time" : "23:26:36" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "23:32:25" , 
"departure_time" : "23:33:44" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "23:35:19" , 
"departure_time" : "23:36:58" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "23:38:39" , 
"departure_time" : "23:39:50" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "23:41:11" , 
"departure_time" : "23:41:33" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "23:43:22" , 
"departure_time" : "23:44:34" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "23:47:12" , 
"departure_time" : "23:47:35" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "23:49:23" , 
"departure_time" : "23:50:18" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "23:55:55" , 
"departure_time" : "23:56:45" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "23:59:50" , 
"departure_time" : "24:01:07" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "24:05:17" , 
"departure_time" : "24:05:17" , 
"distance_traveled" : 22.1062
} ], 
"2359" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "20:14:00" , 
"departure_time" : "20:16:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "20:19:21" , 
"departure_time" : "20:20:55" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "20:25:34" , 
"departure_time" : "20:26:55" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "20:32:21" , 
"departure_time" : "20:32:36" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "20:34:15" , 
"departure_time" : "20:35:43" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "20:38:28" , 
"departure_time" : "20:38:55" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "20:40:27" , 
"departure_time" : "20:41:48" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "20:44:21" , 
"departure_time" : "20:44:49" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "20:46:28" , 
"departure_time" : "20:47:56" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "20:50:28" , 
"departure_time" : "20:50:52" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "20:56:24" , 
"departure_time" : "20:56:53" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "21:04:29" , 
"departure_time" : "21:05:46" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "21:09:17" , 
"departure_time" : "21:09:17" , 
"distance_traveled" : 22.1062
} ], 
"2360" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:48:00" , 
"departure_time" : "18:50:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:05:09" , 
"departure_time" : "19:06:19" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 145,
"arrival_time" : "19:22:10" , 
"departure_time" : "19:22:14" , 
"distance_traveled" : 20.0949
}, 
{ 
"stop_id" : 104,
"arrival_time" : "19:25:04" , 
"departure_time" : "19:25:28" , 
"distance_traveled" : 21.7725
}, 
{ 
"stop_id" : 99,
"arrival_time" : "19:29:24" , 
"departure_time" : "19:31:01" , 
"distance_traveled" : 23.3581
}, 
{ 
"stop_id" : 17,
"arrival_time" : "19:34:37" , 
"departure_time" : "19:34:46" , 
"distance_traveled" : 25.7237
}, 
{ 
"stop_id" : 48,
"arrival_time" : "19:36:09" , 
"departure_time" : "19:36:31" , 
"distance_traveled" : 27.118
}, 
{ 
"stop_id" : 143,
"arrival_time" : "19:39:22" , 
"departure_time" : "19:40:40" , 
"distance_traveled" : 28.4725
}, 
{ 
"stop_id" : 88,
"arrival_time" : "19:43:18" , 
"departure_time" : "19:44:54" , 
"distance_traveled" : 30.0706
}, 
{ 
"stop_id" : 76,
"arrival_time" : "19:46:36" , 
"departure_time" : "19:47:04" , 
"distance_traveled" : 31.71
}, 
{ 
"stop_id" : 12,
"arrival_time" : "19:48:28" , 
"departure_time" : "19:50:00" , 
"distance_traveled" : 33.5922
}, 
{ 
"stop_id" : 18,
"arrival_time" : "19:52:32" , 
"departure_time" : "19:53:44" , 
"distance_traveled" : 34.754
}, 
{ 
"stop_id" : 45,
"arrival_time" : "19:58:12" , 
"departure_time" : "19:58:26" , 
"distance_traveled" : 38.8881
}, 
{ 
"stop_id" : 117,
"arrival_time" : "20:01:14" , 
"departure_time" : "20:02:42" , 
"distance_traveled" : 41.2744
}, 
{ 
"stop_id" : 49,
"arrival_time" : "20:07:28" , 
"departure_time" : "20:07:28" , 
"distance_traveled" : 42.2008
} ], 
"2361" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "21:14:00" , 
"departure_time" : "21:16:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "21:19:20" , 
"departure_time" : "21:20:26" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "21:25:06" , 
"departure_time" : "21:26:29" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "21:32:23" , 
"departure_time" : "21:33:47" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "21:35:24" , 
"departure_time" : "21:35:39" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "21:37:15" , 
"departure_time" : "21:38:34" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "21:41:19" , 
"departure_time" : "21:42:30" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "21:44:11" , 
"departure_time" : "21:45:45" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "21:47:34" , 
"departure_time" : "21:48:02" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "21:49:28" , 
"departure_time" : "21:49:44" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "21:56:16" , 
"departure_time" : "21:57:24" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "22:05:08" , 
"departure_time" : "22:06:12" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "22:09:04" , 
"departure_time" : "22:09:04" , 
"distance_traveled" : 22.1062
} ], 
"2362" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "19:44:00" , 
"departure_time" : "19:45:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "20:00:36" , 
"departure_time" : "20:00:43" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 145,
"arrival_time" : "20:17:07" , 
"departure_time" : "20:18:05" , 
"distance_traveled" : 20.0949
}, 
{ 
"stop_id" : 104,
"arrival_time" : "20:21:58" , 
"departure_time" : "20:22:11" , 
"distance_traveled" : 21.7725
}, 
{ 
"stop_id" : 99,
"arrival_time" : "20:24:13" , 
"departure_time" : "20:24:46" , 
"distance_traveled" : 23.3581
}, 
{ 
"stop_id" : 17,
"arrival_time" : "20:28:33" , 
"departure_time" : "20:30:06" , 
"distance_traveled" : 25.7237
}, 
{ 
"stop_id" : 48,
"arrival_time" : "20:32:33" , 
"departure_time" : "20:33:59" , 
"distance_traveled" : 27.118
}, 
{ 
"stop_id" : 143,
"arrival_time" : "20:36:26" , 
"departure_time" : "20:37:54" , 
"distance_traveled" : 28.4725
}, 
{ 
"stop_id" : 88,
"arrival_time" : "20:40:28" , 
"departure_time" : "20:41:46" , 
"distance_traveled" : 30.0706
}, 
{ 
"stop_id" : 76,
"arrival_time" : "20:43:18" , 
"departure_time" : "20:43:52" , 
"distance_traveled" : 31.71
}, 
{ 
"stop_id" : 12,
"arrival_time" : "20:45:34" , 
"departure_time" : "20:46:21" , 
"distance_traveled" : 33.5922
}, 
{ 
"stop_id" : 18,
"arrival_time" : "20:48:47" , 
"departure_time" : "20:49:08" , 
"distance_traveled" : 34.754
}, 
{ 
"stop_id" : 45,
"arrival_time" : "20:54:21" , 
"departure_time" : "20:55:36" , 
"distance_traveled" : 38.8881
}, 
{ 
"stop_id" : 117,
"arrival_time" : "20:59:15" , 
"departure_time" : "21:00:01" , 
"distance_traveled" : 41.2744
}, 
{ 
"stop_id" : 49,
"arrival_time" : "21:04:46" , 
"departure_time" : "21:04:46" , 
"distance_traveled" : 42.2008
} ], 
"2363" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "22:14:00" , 
"departure_time" : "22:14:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "22:18:08" , 
"departure_time" : "22:19:11" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "22:25:03" , 
"departure_time" : "22:25:37" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "22:31:34" , 
"departure_time" : "22:32:19" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "22:34:45" , 
"departure_time" : "22:35:35" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "22:37:50" , 
"departure_time" : "22:37:59" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "22:40:09" , 
"departure_time" : "22:40:21" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "22:43:12" , 
"departure_time" : "22:44:30" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "22:47:18" , 
"departure_time" : "22:47:44" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "22:49:26" , 
"departure_time" : "22:49:40" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "22:56:14" , 
"departure_time" : "22:56:54" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "23:04:40" , 
"departure_time" : "23:05:45" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "23:09:05" , 
"departure_time" : "23:09:05" , 
"distance_traveled" : 22.1062
} ], 
"2364" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:28:00" , 
"departure_time" : "16:29:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:44:40" , 
"departure_time" : "16:45:30" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 136,
"arrival_time" : "16:58:50" , 
"departure_time" : "16:59:00" , 
"distance_traveled" : 17.8273
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:03:10" , 
"departure_time" : "17:03:50" , 
"distance_traveled" : 20.0949
}, 
{ 
"stop_id" : 104,
"arrival_time" : "17:08:40" , 
"departure_time" : "17:08:43" , 
"distance_traveled" : 21.7725
}, 
{ 
"stop_id" : 99,
"arrival_time" : "17:11:03" , 
"departure_time" : "17:11:55" , 
"distance_traveled" : 23.3581
}, 
{ 
"stop_id" : 17,
"arrival_time" : "17:16:52" , 
"departure_time" : "17:17:46" , 
"distance_traveled" : 25.7237
}, 
{ 
"stop_id" : 48,
"arrival_time" : "17:19:54" , 
"departure_time" : "17:20:11" , 
"distance_traveled" : 27.118
}, 
{ 
"stop_id" : 143,
"arrival_time" : "17:22:17" , 
"departure_time" : "17:22:25" , 
"distance_traveled" : 28.4725
}, 
{ 
"stop_id" : 88,
"arrival_time" : "17:25:08" , 
"departure_time" : "17:26:07" , 
"distance_traveled" : 30.0706
}, 
{ 
"stop_id" : 76,
"arrival_time" : "17:28:59" , 
"departure_time" : "17:30:18" , 
"distance_traveled" : 31.71
}, 
{ 
"stop_id" : 12,
"arrival_time" : "17:32:19" , 
"departure_time" : "17:33:14" , 
"distance_traveled" : 33.5922
}, 
{ 
"stop_id" : 18,
"arrival_time" : "17:34:55" , 
"departure_time" : "17:35:00" , 
"distance_traveled" : 34.754
}, 
{ 
"stop_id" : 45,
"arrival_time" : "17:40:05" , 
"departure_time" : "17:40:56" , 
"distance_traveled" : 38.8881
}, 
{ 
"stop_id" : 117,
"arrival_time" : "17:44:51" , 
"departure_time" : "17:45:16" , 
"distance_traveled" : 41.2744
}, 
{ 
"stop_id" : 49,
"arrival_time" : "17:49:25" , 
"departure_time" : "17:49:25" , 
"distance_traveled" : 42.2008
} ], 
"2365" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "23:14:00" , 
"departure_time" : "23:15:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "23:19:10" , 
"departure_time" : "23:19:20" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "23:24:10" , 
"departure_time" : "23:24:39" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "23:31:29" , 
"departure_time" : "23:33:09" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "23:35:40" , 
"departure_time" : "23:35:53" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "23:37:13" , 
"departure_time" : "23:38:17" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "23:41:04" , 
"departure_time" : "23:41:44" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "23:43:40" , 
"departure_time" : "23:45:06" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "23:47:26" , 
"departure_time" : "23:48:29" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "23:50:03" , 
"departure_time" : "23:50:23" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "23:55:20" , 
"departure_time" : "23:56:30" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "24:00:10" , 
"departure_time" : "24:01:40" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "24:05:30" , 
"departure_time" : "24:05:30" , 
"distance_traveled" : 22.1062
} ], 
"2366" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:35:00" , 
"departure_time" : "17:37:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:53:09" , 
"departure_time" : "17:54:26" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 136,
"arrival_time" : "18:09:17" , 
"departure_time" : "18:10:17" , 
"distance_traveled" : 17.8273
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:15:00" , 
"departure_time" : "18:15:38" , 
"distance_traveled" : 20.0949
}, 
{ 
"stop_id" : 104,
"arrival_time" : "18:19:38" , 
"departure_time" : "18:21:16" , 
"distance_traveled" : 21.7725
}, 
{ 
"stop_id" : 99,
"arrival_time" : "18:23:38" , 
"departure_time" : "18:24:17" , 
"distance_traveled" : 23.3581
}, 
{ 
"stop_id" : 17,
"arrival_time" : "18:26:39" , 
"departure_time" : "18:27:29" , 
"distance_traveled" : 25.7237
}, 
{ 
"stop_id" : 48,
"arrival_time" : "18:29:50" , 
"departure_time" : "18:31:14" , 
"distance_traveled" : 27.118
}, 
{ 
"stop_id" : 143,
"arrival_time" : "18:34:24" , 
"departure_time" : "18:35:47" , 
"distance_traveled" : 28.4725
}, 
{ 
"stop_id" : 88,
"arrival_time" : "18:37:23" , 
"departure_time" : "18:38:01" , 
"distance_traveled" : 30.0706
}, 
{ 
"stop_id" : 76,
"arrival_time" : "18:39:38" , 
"departure_time" : "18:39:45" , 
"distance_traveled" : 31.71
}, 
{ 
"stop_id" : 12,
"arrival_time" : "18:43:07" , 
"departure_time" : "18:43:24" , 
"distance_traveled" : 33.5922
}, 
{ 
"stop_id" : 18,
"arrival_time" : "18:46:17" , 
"departure_time" : "18:47:08" , 
"distance_traveled" : 34.754
}, 
{ 
"stop_id" : 45,
"arrival_time" : "18:53:51" , 
"departure_time" : "18:55:08" , 
"distance_traveled" : 38.8881
}, 
{ 
"stop_id" : 117,
"arrival_time" : "18:59:17" , 
"departure_time" : "19:00:54" , 
"distance_traveled" : 41.2744
}, 
{ 
"stop_id" : 49,
"arrival_time" : "19:07:37" , 
"departure_time" : "19:07:37" , 
"distance_traveled" : 42.2008
} ], 
"2367" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:48:00" , 
"departure_time" : "18:50:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "19:04:29" , 
"departure_time" : "19:04:34" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 145,
"arrival_time" : "19:21:05" , 
"departure_time" : "19:22:30" , 
"distance_traveled" : 20.0949
}, 
{ 
"stop_id" : 104,
"arrival_time" : "19:26:25" , 
"departure_time" : "19:27:30" , 
"distance_traveled" : 21.7725
}, 
{ 
"stop_id" : 99,
"arrival_time" : "19:30:05" , 
"departure_time" : "19:30:47" , 
"distance_traveled" : 23.3581
}, 
{ 
"stop_id" : 17,
"arrival_time" : "19:33:42" , 
"departure_time" : "19:35:17" , 
"distance_traveled" : 25.7237
}, 
{ 
"stop_id" : 48,
"arrival_time" : "19:37:35" , 
"departure_time" : "19:38:41" , 
"distance_traveled" : 27.118
}, 
{ 
"stop_id" : 143,
"arrival_time" : "19:40:06" , 
"departure_time" : "19:41:12" , 
"distance_traveled" : 28.4725
}, 
{ 
"stop_id" : 88,
"arrival_time" : "19:43:06" , 
"departure_time" : "19:44:14" , 
"distance_traveled" : 30.0706
}, 
{ 
"stop_id" : 76,
"arrival_time" : "19:46:08" , 
"departure_time" : "19:46:51" , 
"distance_traveled" : 31.71
}, 
{ 
"stop_id" : 12,
"arrival_time" : "19:48:43" , 
"departure_time" : "19:50:00" , 
"distance_traveled" : 33.5922
}, 
{ 
"stop_id" : 18,
"arrival_time" : "19:52:17" , 
"departure_time" : "19:53:00" , 
"distance_traveled" : 34.754
}, 
{ 
"stop_id" : 45,
"arrival_time" : "19:57:43" , 
"departure_time" : "19:59:08" , 
"distance_traveled" : 38.8881
}, 
{ 
"stop_id" : 117,
"arrival_time" : "20:02:25" , 
"departure_time" : "20:03:55" , 
"distance_traveled" : 41.2744
}, 
{ 
"stop_id" : 49,
"arrival_time" : "20:07:30" , 
"departure_time" : "20:07:30" , 
"distance_traveled" : 42.2008
} ], 
"2368" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:04:00" , 
"departure_time" : "18:06:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:20:52" , 
"departure_time" : "18:21:55" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 136,
"arrival_time" : "18:35:03" , 
"departure_time" : "18:35:25" , 
"distance_traveled" : 17.8273
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:38:22" , 
"departure_time" : "18:39:56" , 
"distance_traveled" : 20.0949
}, 
{ 
"stop_id" : 104,
"arrival_time" : "18:44:34" , 
"departure_time" : "18:45:10" , 
"distance_traveled" : 21.7725
}, 
{ 
"stop_id" : 99,
"arrival_time" : "18:46:36" , 
"departure_time" : "18:47:53" , 
"distance_traveled" : 23.3581
}, 
{ 
"stop_id" : 17,
"arrival_time" : "18:51:17" , 
"departure_time" : "18:52:22" , 
"distance_traveled" : 25.7237
}, 
{ 
"stop_id" : 48,
"arrival_time" : "18:54:05" , 
"departure_time" : "18:54:45" , 
"distance_traveled" : 27.118
}, 
{ 
"stop_id" : 143,
"arrival_time" : "18:56:40" , 
"departure_time" : "18:57:46" , 
"distance_traveled" : 28.4725
}, 
{ 
"stop_id" : 88,
"arrival_time" : "19:00:06" , 
"departure_time" : "19:01:26" , 
"distance_traveled" : 30.0706
}, 
{ 
"stop_id" : 76,
"arrival_time" : "19:03:20" , 
"departure_time" : "19:03:23" , 
"distance_traveled" : 31.71
}, 
{ 
"stop_id" : 12,
"arrival_time" : "19:05:03" , 
"departure_time" : "19:06:09" , 
"distance_traveled" : 33.5922
}, 
{ 
"stop_id" : 18,
"arrival_time" : "19:09:06" , 
"departure_time" : "19:09:08" , 
"distance_traveled" : 34.754
}, 
{ 
"stop_id" : 45,
"arrival_time" : "19:15:02" , 
"departure_time" : "19:15:06" , 
"distance_traveled" : 38.8881
}, 
{ 
"stop_id" : 117,
"arrival_time" : "19:20:04" , 
"departure_time" : "19:21:14" , 
"distance_traveled" : 41.2744
}, 
{ 
"stop_id" : 49,
"arrival_time" : "19:25:10" , 
"departure_time" : "19:25:10" , 
"distance_traveled" : 42.2008
} ], 
"2369" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "19:44:00" , 
"departure_time" : "19:45:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "20:00:47" , 
"departure_time" : "20:02:07" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 145,
"arrival_time" : "20:18:20" , 
"departure_time" : "20:18:47" , 
"distance_traveled" : 20.0949
}, 
{ 
"stop_id" : 104,
"arrival_time" : "20:21:27" , 
"departure_time" : "20:22:35" , 
"distance_traveled" : 21.7725
}, 
{ 
"stop_id" : 99,
"arrival_time" : "20:25:08" , 
"departure_time" : "20:25:24" , 
"distance_traveled" : 23.3581
}, 
{ 
"stop_id" : 17,
"arrival_time" : "20:28:16" , 
"departure_time" : "20:29:23" , 
"distance_traveled" : 25.7237
}, 
{ 
"stop_id" : 48,
"arrival_time" : "20:32:07" , 
"departure_time" : "20:32:31" , 
"distance_traveled" : 27.118
}, 
{ 
"stop_id" : 143,
"arrival_time" : "20:35:24" , 
"departure_time" : "20:36:32" , 
"distance_traveled" : 28.4725
}, 
{ 
"stop_id" : 88,
"arrival_time" : "20:40:08" , 
"departure_time" : "20:40:37" , 
"distance_traveled" : 30.0706
}, 
{ 
"stop_id" : 76,
"arrival_time" : "20:42:29" , 
"departure_time" : "20:43:17" , 
"distance_traveled" : 31.71
}, 
{ 
"stop_id" : 12,
"arrival_time" : "20:45:48" , 
"departure_time" : "20:46:45" , 
"distance_traveled" : 33.5922
}, 
{ 
"stop_id" : 18,
"arrival_time" : "20:48:57" , 
"departure_time" : "20:50:16" , 
"distance_traveled" : 34.754
}, 
{ 
"stop_id" : 45,
"arrival_time" : "20:55:19" , 
"departure_time" : "20:56:16" , 
"distance_traveled" : 38.8881
}, 
{ 
"stop_id" : 117,
"arrival_time" : "20:58:57" , 
"departure_time" : "20:59:34" , 
"distance_traveled" : 41.2744
}, 
{ 
"stop_id" : 49,
"arrival_time" : "21:04:37" , 
"departure_time" : "21:04:37" , 
"distance_traveled" : 42.2008
} ], 
"2370" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:08:00" , 
"departure_time" : "18:09:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:37:24" , 
"departure_time" : "18:38:24" , 
"distance_traveled" : 17.7547
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:42:00" , 
"departure_time" : "18:42:28" , 
"distance_traveled" : 19.3634
}, 
{ 
"stop_id" : 136,
"arrival_time" : "18:45:28" , 
"departure_time" : "18:46:49" , 
"distance_traveled" : 20.4379
}, 
{ 
"stop_id" : 104,
"arrival_time" : "18:54:21" , 
"departure_time" : "18:55:59" , 
"distance_traveled" : 24.3831
}, 
{ 
"stop_id" : 99,
"arrival_time" : "18:58:38" , 
"departure_time" : "19:00:02" , 
"distance_traveled" : 25.9688
}, 
{ 
"stop_id" : 17,
"arrival_time" : "19:03:24" , 
"departure_time" : "19:04:52" , 
"distance_traveled" : 28.3343
}, 
{ 
"stop_id" : 48,
"arrival_time" : "19:06:28" , 
"departure_time" : "19:07:55" , 
"distance_traveled" : 29.7286
}, 
{ 
"stop_id" : 143,
"arrival_time" : "19:10:27" , 
"departure_time" : "19:10:56" , 
"distance_traveled" : 31.0831
}, 
{ 
"stop_id" : 88,
"arrival_time" : "19:12:29" , 
"departure_time" : "19:13:26" , 
"distance_traveled" : 32.6812
}, 
{ 
"stop_id" : 76,
"arrival_time" : "19:15:57" , 
"departure_time" : "19:17:28" , 
"distance_traveled" : 34.3206
}, 
{ 
"stop_id" : 12,
"arrival_time" : "19:20:31" , 
"departure_time" : "19:20:36" , 
"distance_traveled" : 36.2028
}, 
{ 
"stop_id" : 18,
"arrival_time" : "19:22:05" , 
"departure_time" : "19:23:32" , 
"distance_traveled" : 37.3646
}, 
{ 
"stop_id" : 45,
"arrival_time" : "19:31:27" , 
"departure_time" : "19:32:25" , 
"distance_traveled" : 41.4987
}, 
{ 
"stop_id" : 117,
"arrival_time" : "19:35:58" , 
"departure_time" : "19:36:44" , 
"distance_traveled" : 43.885
}, 
{ 
"stop_id" : 49,
"arrival_time" : "19:41:46" , 
"departure_time" : "19:41:46" , 
"distance_traveled" : 44.8114
} ], 
"2371" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:28:00" , 
"departure_time" : "16:29:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "16:45:09" , 
"departure_time" : "16:46:18" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 136,
"arrival_time" : "16:59:09" , 
"departure_time" : "17:00:03" , 
"distance_traveled" : 17.8273
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:03:54" , 
"departure_time" : "17:04:33" , 
"distance_traveled" : 20.0949
}, 
{ 
"stop_id" : 104,
"arrival_time" : "17:08:39" , 
"departure_time" : "17:09:37" , 
"distance_traveled" : 21.7725
}, 
{ 
"stop_id" : 99,
"arrival_time" : "17:11:58" , 
"departure_time" : "17:12:23" , 
"distance_traveled" : 23.3581
}, 
{ 
"stop_id" : 17,
"arrival_time" : "17:16:25" , 
"departure_time" : "17:16:58" , 
"distance_traveled" : 25.7237
}, 
{ 
"stop_id" : 48,
"arrival_time" : "17:19:33" , 
"departure_time" : "17:19:39" , 
"distance_traveled" : 27.118
}, 
{ 
"stop_id" : 143,
"arrival_time" : "17:22:06" , 
"departure_time" : "17:22:38" , 
"distance_traveled" : 28.4725
}, 
{ 
"stop_id" : 88,
"arrival_time" : "17:25:32" , 
"departure_time" : "17:26:45" , 
"distance_traveled" : 30.0706
}, 
{ 
"stop_id" : 76,
"arrival_time" : "17:29:13" , 
"departure_time" : "17:29:30" , 
"distance_traveled" : 31.71
}, 
{ 
"stop_id" : 12,
"arrival_time" : "17:31:17" , 
"departure_time" : "17:32:47" , 
"distance_traveled" : 33.5922
}, 
{ 
"stop_id" : 18,
"arrival_time" : "17:35:30" , 
"departure_time" : "17:35:45" , 
"distance_traveled" : 34.754
}, 
{ 
"stop_id" : 45,
"arrival_time" : "17:40:15" , 
"departure_time" : "17:40:34" , 
"distance_traveled" : 38.8881
}, 
{ 
"stop_id" : 117,
"arrival_time" : "17:44:19" , 
"departure_time" : "17:45:05" , 
"distance_traveled" : 41.2744
}, 
{ 
"stop_id" : 49,
"arrival_time" : "17:49:46" , 
"departure_time" : "17:49:46" , 
"distance_traveled" : 42.2008
} ], 
"2372" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:06:00" , 
"departure_time" : "17:07:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:22:27" , 
"departure_time" : "17:23:22" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 87,
"arrival_time" : "17:35:55" , 
"departure_time" : "17:37:20" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "17:39:25" , 
"departure_time" : "17:40:16" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:44:51" , 
"departure_time" : "17:46:26" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 104,
"arrival_time" : "17:49:35" , 
"departure_time" : "17:51:13" , 
"distance_traveled" : 21.7723
}, 
{ 
"stop_id" : 99,
"arrival_time" : "17:52:38" , 
"departure_time" : "17:52:49" , 
"distance_traveled" : 23.358
}, 
{ 
"stop_id" : 17,
"arrival_time" : "17:55:11" , 
"departure_time" : "17:56:49" , 
"distance_traveled" : 25.7235
}, 
{ 
"stop_id" : 48,
"arrival_time" : "17:59:38" , 
"departure_time" : "18:01:06" , 
"distance_traveled" : 27.1178
}, 
{ 
"stop_id" : 143,
"arrival_time" : "18:02:28" , 
"departure_time" : "18:02:49" , 
"distance_traveled" : 28.4723
}, 
{ 
"stop_id" : 88,
"arrival_time" : "18:04:21" , 
"departure_time" : "18:04:58" , 
"distance_traveled" : 30.0705
}, 
{ 
"stop_id" : 76,
"arrival_time" : "18:07:37" , 
"departure_time" : "18:07:53" , 
"distance_traveled" : 31.7098
}, 
{ 
"stop_id" : 12,
"arrival_time" : "18:10:16" , 
"departure_time" : "18:10:26" , 
"distance_traveled" : 33.592
}, 
{ 
"stop_id" : 18,
"arrival_time" : "18:13:10" , 
"departure_time" : "18:14:50" , 
"distance_traveled" : 34.7538
}, 
{ 
"stop_id" : 45,
"arrival_time" : "18:20:40" , 
"departure_time" : "18:20:43" , 
"distance_traveled" : 38.8879
}, 
{ 
"stop_id" : 117,
"arrival_time" : "18:23:03" , 
"departure_time" : "18:24:42" , 
"distance_traveled" : 41.2742
}, 
{ 
"stop_id" : 49,
"arrival_time" : "18:29:39" , 
"departure_time" : "18:29:39" , 
"distance_traveled" : 42.2006
} ], 
"2373" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:35:00" , 
"departure_time" : "17:37:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:53:14" , 
"departure_time" : "17:54:50" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 136,
"arrival_time" : "18:09:36" , 
"departure_time" : "18:10:58" , 
"distance_traveled" : 17.8273
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:15:22" , 
"departure_time" : "18:16:54" , 
"distance_traveled" : 20.0949
}, 
{ 
"stop_id" : 104,
"arrival_time" : "18:20:32" , 
"departure_time" : "18:20:44" , 
"distance_traveled" : 21.7725
}, 
{ 
"stop_id" : 99,
"arrival_time" : "18:22:12" , 
"departure_time" : "18:23:47" , 
"distance_traveled" : 23.3581
}, 
{ 
"stop_id" : 17,
"arrival_time" : "18:27:35" , 
"departure_time" : "18:28:58" , 
"distance_traveled" : 25.7237
}, 
{ 
"stop_id" : 48,
"arrival_time" : "18:30:23" , 
"departure_time" : "18:31:19" , 
"distance_traveled" : 27.118
}, 
{ 
"stop_id" : 143,
"arrival_time" : "18:33:56" , 
"departure_time" : "18:35:01" , 
"distance_traveled" : 28.4725
}, 
{ 
"stop_id" : 88,
"arrival_time" : "18:37:05" , 
"departure_time" : "18:38:42" , 
"distance_traveled" : 30.0706
}, 
{ 
"stop_id" : 76,
"arrival_time" : "18:40:37" , 
"departure_time" : "18:41:01" , 
"distance_traveled" : 31.71
}, 
{ 
"stop_id" : 12,
"arrival_time" : "18:43:24" , 
"departure_time" : "18:44:48" , 
"distance_traveled" : 33.5922
}, 
{ 
"stop_id" : 18,
"arrival_time" : "18:47:24" , 
"departure_time" : "18:48:42" , 
"distance_traveled" : 34.754
}, 
{ 
"stop_id" : 45,
"arrival_time" : "18:54:18" , 
"departure_time" : "18:54:39" , 
"distance_traveled" : 38.8881
}, 
{ 
"stop_id" : 117,
"arrival_time" : "18:58:21" , 
"departure_time" : "18:59:12" , 
"distance_traveled" : 41.2744
}, 
{ 
"stop_id" : 49,
"arrival_time" : "19:06:51" , 
"departure_time" : "19:06:51" , 
"distance_traveled" : 42.2008
} ], 
"2374" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:18:00" , 
"departure_time" : "17:19:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:40:27" , 
"departure_time" : "17:40:52" , 
"distance_traveled" : 13.1746
}, 
{ 
"stop_id" : 112,
"arrival_time" : "17:43:25" , 
"departure_time" : "17:44:17" , 
"distance_traveled" : 14.0741
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:49:52" , 
"departure_time" : "17:51:27" , 
"distance_traveled" : 16.4722
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:03:35" , 
"departure_time" : "18:03:55" , 
"distance_traveled" : 22.7055
}, 
{ 
"stop_id" : 104,
"arrival_time" : "18:07:20" , 
"departure_time" : "18:08:05" , 
"distance_traveled" : 24.3831
}, 
{ 
"stop_id" : 99,
"arrival_time" : "18:11:45" , 
"departure_time" : "18:13:07" , 
"distance_traveled" : 25.9688
}, 
{ 
"stop_id" : 17,
"arrival_time" : "18:17:22" , 
"departure_time" : "18:18:53" , 
"distance_traveled" : 28.3343
}, 
{ 
"stop_id" : 48,
"arrival_time" : "18:20:31" , 
"departure_time" : "18:22:04" , 
"distance_traveled" : 29.7286
}, 
{ 
"stop_id" : 143,
"arrival_time" : "18:24:33" , 
"departure_time" : "18:25:51" , 
"distance_traveled" : 31.0831
}, 
{ 
"stop_id" : 88,
"arrival_time" : "18:27:18" , 
"departure_time" : "18:28:36" , 
"distance_traveled" : 32.6812
}, 
{ 
"stop_id" : 76,
"arrival_time" : "18:30:18" , 
"departure_time" : "18:30:57" , 
"distance_traveled" : 34.3206
}, 
{ 
"stop_id" : 12,
"arrival_time" : "18:33:39" , 
"departure_time" : "18:34:23" , 
"distance_traveled" : 36.2028
}, 
{ 
"stop_id" : 18,
"arrival_time" : "18:36:44" , 
"departure_time" : "18:36:54" , 
"distance_traveled" : 37.3646
}, 
{ 
"stop_id" : 45,
"arrival_time" : "18:44:10" , 
"departure_time" : "18:44:57" , 
"distance_traveled" : 41.4987
}, 
{ 
"stop_id" : 117,
"arrival_time" : "18:49:47" , 
"departure_time" : "18:49:48" , 
"distance_traveled" : 43.885
}, 
{ 
"stop_id" : 49,
"arrival_time" : "18:55:01" , 
"departure_time" : "18:55:01" , 
"distance_traveled" : 44.8114
} ], 
"2375" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:04:00" , 
"departure_time" : "18:04:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:20:56" , 
"departure_time" : "18:21:21" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 136,
"arrival_time" : "18:34:25" , 
"departure_time" : "18:35:45" , 
"distance_traveled" : 17.8273
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:39:20" , 
"departure_time" : "18:39:28" , 
"distance_traveled" : 20.0949
}, 
{ 
"stop_id" : 104,
"arrival_time" : "18:43:08" , 
"departure_time" : "18:43:17" , 
"distance_traveled" : 21.7725
}, 
{ 
"stop_id" : 99,
"arrival_time" : "18:46:09" , 
"departure_time" : "18:47:17" , 
"distance_traveled" : 23.3581
}, 
{ 
"stop_id" : 17,
"arrival_time" : "18:51:08" , 
"departure_time" : "18:52:45" , 
"distance_traveled" : 25.7237
}, 
{ 
"stop_id" : 48,
"arrival_time" : "18:54:37" , 
"departure_time" : "18:56:03" , 
"distance_traveled" : 27.118
}, 
{ 
"stop_id" : 143,
"arrival_time" : "18:57:26" , 
"departure_time" : "18:57:47" , 
"distance_traveled" : 28.4725
}, 
{ 
"stop_id" : 88,
"arrival_time" : "18:59:21" , 
"departure_time" : "19:00:17" , 
"distance_traveled" : 30.0706
}, 
{ 
"stop_id" : 76,
"arrival_time" : "19:02:56" , 
"departure_time" : "19:03:39" , 
"distance_traveled" : 31.71
}, 
{ 
"stop_id" : 12,
"arrival_time" : "19:05:43" , 
"departure_time" : "19:07:07" , 
"distance_traveled" : 33.5922
}, 
{ 
"stop_id" : 18,
"arrival_time" : "19:09:24" , 
"departure_time" : "19:09:39" , 
"distance_traveled" : 34.754
}, 
{ 
"stop_id" : 45,
"arrival_time" : "19:15:15" , 
"departure_time" : "19:16:17" , 
"distance_traveled" : 38.8881
}, 
{ 
"stop_id" : 117,
"arrival_time" : "19:21:02" , 
"departure_time" : "19:21:31" , 
"distance_traveled" : 41.2744
}, 
{ 
"stop_id" : 49,
"arrival_time" : "19:24:29" , 
"departure_time" : "19:24:29" , 
"distance_traveled" : 42.2008
} ], 
"2376" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "06:55:00" , 
"departure_time" : "06:56:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:13:36" , 
"departure_time" : "07:13:44" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "07:18:08" , 
"departure_time" : "07:18:30" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "07:21:22" , 
"departure_time" : "07:22:31" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "07:25:09" , 
"departure_time" : "07:26:15" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "07:27:06" , 
"departure_time" : "07:28:13" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "07:30:07" , 
"departure_time" : "07:31:34" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:32:27" , 
"departure_time" : "07:32:47" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:34:20" , 
"departure_time" : "07:35:26" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:39:06" , 
"departure_time" : "07:39:07" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:41:01" , 
"departure_time" : "07:41:59" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:46:58" , 
"departure_time" : "07:47:03" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 104,
"arrival_time" : "07:50:05" , 
"departure_time" : "07:50:57" , 
"distance_traveled" : 21.7723
}, 
{ 
"stop_id" : 99,
"arrival_time" : "07:56:52" , 
"departure_time" : "07:57:28" , 
"distance_traveled" : 23.358
}, 
{ 
"stop_id" : 17,
"arrival_time" : "08:02:36" , 
"departure_time" : "08:03:37" , 
"distance_traveled" : 25.7235
}, 
{ 
"stop_id" : 48,
"arrival_time" : "08:06:01" , 
"departure_time" : "08:07:00" , 
"distance_traveled" : 27.1178
}, 
{ 
"stop_id" : 143,
"arrival_time" : "08:11:59" , 
"departure_time" : "08:13:01" , 
"distance_traveled" : 28.4723
}, 
{ 
"stop_id" : 88,
"arrival_time" : "08:22:02" , 
"departure_time" : "08:22:20" , 
"distance_traveled" : 30.0705
}, 
{ 
"stop_id" : 76,
"arrival_time" : "08:24:18" , 
"departure_time" : "08:24:38" , 
"distance_traveled" : 31.7098
}, 
{ 
"stop_id" : 12,
"arrival_time" : "08:27:20" , 
"departure_time" : "08:28:02" , 
"distance_traveled" : 33.592
}, 
{ 
"stop_id" : 18,
"arrival_time" : "08:31:42" , 
"departure_time" : "08:31:42" , 
"distance_traveled" : 34.7538
} ], 
"2377" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:08:00" , 
"departure_time" : "18:10:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:38:30" , 
"departure_time" : "18:38:57" , 
"distance_traveled" : 17.7547
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:41:27" , 
"departure_time" : "18:42:33" , 
"distance_traveled" : 19.3634
}, 
{ 
"stop_id" : 136,
"arrival_time" : "18:46:06" , 
"departure_time" : "18:47:09" , 
"distance_traveled" : 20.4379
}, 
{ 
"stop_id" : 104,
"arrival_time" : "18:54:03" , 
"departure_time" : "18:54:38" , 
"distance_traveled" : 24.3831
}, 
{ 
"stop_id" : 99,
"arrival_time" : "18:57:35" , 
"departure_time" : "18:58:57" , 
"distance_traveled" : 25.9688
}, 
{ 
"stop_id" : 17,
"arrival_time" : "19:03:22" , 
"departure_time" : "19:05:02" , 
"distance_traveled" : 28.3343
}, 
{ 
"stop_id" : 48,
"arrival_time" : "19:06:40" , 
"departure_time" : "19:07:26" , 
"distance_traveled" : 29.7286
}, 
{ 
"stop_id" : 143,
"arrival_time" : "19:09:46" , 
"departure_time" : "19:10:44" , 
"distance_traveled" : 31.0831
}, 
{ 
"stop_id" : 88,
"arrival_time" : "19:12:58" , 
"departure_time" : "19:14:18" , 
"distance_traveled" : 32.6812
}, 
{ 
"stop_id" : 76,
"arrival_time" : "19:16:20" , 
"departure_time" : "19:17:07" , 
"distance_traveled" : 34.3206
}, 
{ 
"stop_id" : 12,
"arrival_time" : "19:19:47" , 
"departure_time" : "19:20:58" , 
"distance_traveled" : 36.2028
}, 
{ 
"stop_id" : 18,
"arrival_time" : "19:23:11" , 
"departure_time" : "19:24:31" , 
"distance_traveled" : 37.3646
}, 
{ 
"stop_id" : 45,
"arrival_time" : "19:31:20" , 
"departure_time" : "19:32:46" , 
"distance_traveled" : 41.4987
}, 
{ 
"stop_id" : 117,
"arrival_time" : "19:36:26" , 
"departure_time" : "19:37:02" , 
"distance_traveled" : 43.885
}, 
{ 
"stop_id" : 49,
"arrival_time" : "19:41:36" , 
"departure_time" : "19:41:36" , 
"distance_traveled" : 44.8114
} ], 
"2378" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "15:29:00" , 
"departure_time" : "15:31:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:47:33" , 
"departure_time" : "15:48:40" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "15:52:07" , 
"departure_time" : "15:52:47" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "15:54:40" , 
"departure_time" : "15:55:15" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "15:57:35" , 
"departure_time" : "15:58:14" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "15:59:39" , 
"departure_time" : "16:00:36" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "16:01:57" , 
"departure_time" : "16:02:25" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "16:04:28" , 
"departure_time" : "16:04:42" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "16:07:14" , 
"departure_time" : "16:07:44" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "16:11:30" , 
"departure_time" : "16:12:05" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "16:13:35" , 
"departure_time" : "16:15:04" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:19:29" , 
"departure_time" : "16:20:45" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 104,
"arrival_time" : "16:23:16" , 
"departure_time" : "16:24:07" , 
"distance_traveled" : 21.7723
}, 
{ 
"stop_id" : 99,
"arrival_time" : "16:25:51" , 
"departure_time" : "16:26:21" , 
"distance_traveled" : 23.358
}, 
{ 
"stop_id" : 17,
"arrival_time" : "16:29:30" , 
"departure_time" : "16:30:33" , 
"distance_traveled" : 25.7235
}, 
{ 
"stop_id" : 48,
"arrival_time" : "16:33:03" , 
"departure_time" : "16:34:36" , 
"distance_traveled" : 27.1178
}, 
{ 
"stop_id" : 143,
"arrival_time" : "16:36:33" , 
"departure_time" : "16:36:41" , 
"distance_traveled" : 28.4723
}, 
{ 
"stop_id" : 88,
"arrival_time" : "16:38:08" , 
"departure_time" : "16:39:24" , 
"distance_traveled" : 30.0705
}, 
{ 
"stop_id" : 76,
"arrival_time" : "16:42:16" , 
"departure_time" : "16:43:02" , 
"distance_traveled" : 31.7098
}, 
{ 
"stop_id" : 12,
"arrival_time" : "16:44:46" , 
"departure_time" : "16:46:04" , 
"distance_traveled" : 33.592
}, 
{ 
"stop_id" : 18,
"arrival_time" : "16:49:18" , 
"departure_time" : "16:49:18" , 
"distance_traveled" : 34.7538
} ], 
"2379" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:06:00" , 
"departure_time" : "17:07:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:22:12" , 
"departure_time" : "17:22:57" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 87,
"arrival_time" : "17:35:45" , 
"departure_time" : "17:37:19" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "17:39:34" , 
"departure_time" : "17:41:12" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:45:38" , 
"departure_time" : "17:47:08" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 104,
"arrival_time" : "17:49:30" , 
"departure_time" : "17:49:52" , 
"distance_traveled" : 21.7723
}, 
{ 
"stop_id" : 99,
"arrival_time" : "17:51:22" , 
"departure_time" : "17:51:48" , 
"distance_traveled" : 23.358
}, 
{ 
"stop_id" : 17,
"arrival_time" : "17:55:26" , 
"departure_time" : "17:57:01" , 
"distance_traveled" : 25.7235
}, 
{ 
"stop_id" : 48,
"arrival_time" : "17:59:35" , 
"departure_time" : "18:00:42" , 
"distance_traveled" : 27.1178
}, 
{ 
"stop_id" : 143,
"arrival_time" : "18:02:07" , 
"departure_time" : "18:02:58" , 
"distance_traveled" : 28.4723
}, 
{ 
"stop_id" : 88,
"arrival_time" : "18:04:51" , 
"departure_time" : "18:05:45" , 
"distance_traveled" : 30.0705
}, 
{ 
"stop_id" : 76,
"arrival_time" : "18:07:54" , 
"departure_time" : "18:08:20" , 
"distance_traveled" : 31.7098
}, 
{ 
"stop_id" : 12,
"arrival_time" : "18:10:26" , 
"departure_time" : "18:10:29" , 
"distance_traveled" : 33.592
}, 
{ 
"stop_id" : 18,
"arrival_time" : "18:13:03" , 
"departure_time" : "18:14:37" , 
"distance_traveled" : 34.7538
}, 
{ 
"stop_id" : 45,
"arrival_time" : "18:20:34" , 
"departure_time" : "18:21:00" , 
"distance_traveled" : 38.8879
}, 
{ 
"stop_id" : 117,
"arrival_time" : "18:23:26" , 
"departure_time" : "18:24:41" , 
"distance_traveled" : 41.2742
}, 
{ 
"stop_id" : 49,
"arrival_time" : "18:29:15" , 
"departure_time" : "18:29:15" , 
"distance_traveled" : 42.2006
} ], 
"2380" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "07:54:00" , 
"departure_time" : "07:56:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:14:18" , 
"departure_time" : "08:14:34" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "08:18:16" , 
"departure_time" : "08:19:56" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "08:21:40" , 
"departure_time" : "08:22:08" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "08:23:28" , 
"departure_time" : "08:24:05" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "08:25:37" , 
"departure_time" : "08:27:01" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "08:28:24" , 
"departure_time" : "08:29:01" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:30:37" , 
"departure_time" : "08:30:53" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "08:33:16" , 
"departure_time" : "08:34:24" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "08:38:08" , 
"departure_time" : "08:39:41" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "08:41:33" , 
"departure_time" : "08:41:59" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "08:44:26" , 
"departure_time" : "08:45:23" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 104,
"arrival_time" : "08:49:57" , 
"departure_time" : "08:50:34" , 
"distance_traveled" : 21.7723
}, 
{ 
"stop_id" : 99,
"arrival_time" : "08:53:37" , 
"departure_time" : "08:55:17" , 
"distance_traveled" : 23.358
}, 
{ 
"stop_id" : 17,
"arrival_time" : "08:57:40" , 
"departure_time" : "08:58:48" , 
"distance_traveled" : 25.7235
}, 
{ 
"stop_id" : 48,
"arrival_time" : "09:01:08" , 
"departure_time" : "09:02:07" , 
"distance_traveled" : 27.1178
}, 
{ 
"stop_id" : 143,
"arrival_time" : "09:05:59" , 
"departure_time" : "09:06:40" , 
"distance_traveled" : 28.4723
}, 
{ 
"stop_id" : 88,
"arrival_time" : "09:10:41" , 
"departure_time" : "09:12:20" , 
"distance_traveled" : 30.0705
}, 
{ 
"stop_id" : 76,
"arrival_time" : "09:14:39" , 
"departure_time" : "09:15:52" , 
"distance_traveled" : 31.7098
}, 
{ 
"stop_id" : 12,
"arrival_time" : "09:17:13" , 
"departure_time" : "09:18:06" , 
"distance_traveled" : 33.592
}, 
{ 
"stop_id" : 18,
"arrival_time" : "09:19:53" , 
"departure_time" : "09:20:09" , 
"distance_traveled" : 34.7538
}, 
{ 
"stop_id" : 45,
"arrival_time" : "09:25:16" , 
"departure_time" : "09:25:19" , 
"distance_traveled" : 38.8879
}, 
{ 
"stop_id" : 117,
"arrival_time" : "09:29:03" , 
"departure_time" : "09:29:44" , 
"distance_traveled" : 41.2742
}, 
{ 
"stop_id" : 49,
"arrival_time" : "09:34:41" , 
"departure_time" : "09:34:41" , 
"distance_traveled" : 42.2006
} ], 
"2381" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:18:00" , 
"departure_time" : "17:19:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:40:50" , 
"departure_time" : "17:41:01" , 
"distance_traveled" : 13.1746
}, 
{ 
"stop_id" : 112,
"arrival_time" : "17:43:11" , 
"departure_time" : "17:43:21" , 
"distance_traveled" : 14.0741
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:49:10" , 
"departure_time" : "17:50:20" , 
"distance_traveled" : 16.4722
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:03:10" , 
"departure_time" : "18:03:28" , 
"distance_traveled" : 22.7055
}, 
{ 
"stop_id" : 104,
"arrival_time" : "18:07:18" , 
"departure_time" : "18:08:30" , 
"distance_traveled" : 24.3831
}, 
{ 
"stop_id" : 99,
"arrival_time" : "18:12:12" , 
"departure_time" : "18:13:45" , 
"distance_traveled" : 25.9688
}, 
{ 
"stop_id" : 17,
"arrival_time" : "18:17:33" , 
"departure_time" : "18:18:31" , 
"distance_traveled" : 28.3343
}, 
{ 
"stop_id" : 48,
"arrival_time" : "18:19:58" , 
"departure_time" : "18:21:03" , 
"distance_traveled" : 29.7286
}, 
{ 
"stop_id" : 143,
"arrival_time" : "18:24:05" , 
"departure_time" : "18:24:25" , 
"distance_traveled" : 31.0831
}, 
{ 
"stop_id" : 88,
"arrival_time" : "18:26:20" , 
"departure_time" : "18:27:40" , 
"distance_traveled" : 32.6812
}, 
{ 
"stop_id" : 76,
"arrival_time" : "18:30:20" , 
"departure_time" : "18:31:07" , 
"distance_traveled" : 34.3206
}, 
{ 
"stop_id" : 12,
"arrival_time" : "18:33:47" , 
"departure_time" : "18:34:59" , 
"distance_traveled" : 36.2028
}, 
{ 
"stop_id" : 18,
"arrival_time" : "18:37:12" , 
"departure_time" : "18:38:49" , 
"distance_traveled" : 37.3646
}, 
{ 
"stop_id" : 45,
"arrival_time" : "18:45:37" , 
"departure_time" : "18:46:12" , 
"distance_traveled" : 41.4987
}, 
{ 
"stop_id" : 117,
"arrival_time" : "18:49:35" , 
"departure_time" : "18:50:53" , 
"distance_traveled" : 43.885
}, 
{ 
"stop_id" : 49,
"arrival_time" : "18:56:18" , 
"departure_time" : "18:56:18" , 
"distance_traveled" : 44.8114
} ], 
"2382" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "08:50:00" , 
"departure_time" : "08:52:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:09:24" , 
"departure_time" : "09:10:25" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "09:14:01" , 
"departure_time" : "09:15:22" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "09:16:21" , 
"departure_time" : "09:16:35" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "09:18:14" , 
"departure_time" : "09:18:55" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "09:20:41" , 
"departure_time" : "09:21:39" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "09:22:58" , 
"departure_time" : "09:24:18" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "09:25:20" , 
"departure_time" : "09:26:28" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "09:28:08" , 
"departure_time" : "09:29:11" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "09:31:03" , 
"departure_time" : "09:32:09" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "09:34:06" , 
"departure_time" : "09:35:11" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "09:39:05" , 
"departure_time" : "09:40:08" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 104,
"arrival_time" : "09:43:03" , 
"departure_time" : "09:44:03" , 
"distance_traveled" : 21.7723
}, 
{ 
"stop_id" : 99,
"arrival_time" : "09:46:00" , 
"departure_time" : "09:46:53" , 
"distance_traveled" : 23.358
}, 
{ 
"stop_id" : 17,
"arrival_time" : "09:49:53" , 
"departure_time" : "09:51:00" , 
"distance_traveled" : 25.7235
}, 
{ 
"stop_id" : 48,
"arrival_time" : "09:53:07" , 
"departure_time" : "09:53:49" , 
"distance_traveled" : 27.1178
}, 
{ 
"stop_id" : 143,
"arrival_time" : "09:55:42" , 
"departure_time" : "09:55:43" , 
"distance_traveled" : 28.4723
}, 
{ 
"stop_id" : 88,
"arrival_time" : "09:58:01" , 
"departure_time" : "09:59:29" , 
"distance_traveled" : 30.0705
}, 
{ 
"stop_id" : 76,
"arrival_time" : "10:02:28" , 
"departure_time" : "10:03:50" , 
"distance_traveled" : 31.7098
}, 
{ 
"stop_id" : 12,
"arrival_time" : "10:05:22" , 
"departure_time" : "10:05:40" , 
"distance_traveled" : 33.592
}, 
{ 
"stop_id" : 18,
"arrival_time" : "10:08:18" , 
"departure_time" : "10:08:26" , 
"distance_traveled" : 34.7538
}, 
{ 
"stop_id" : 45,
"arrival_time" : "10:14:08" , 
"departure_time" : "10:14:28" , 
"distance_traveled" : 38.8879
}, 
{ 
"stop_id" : 117,
"arrival_time" : "10:18:20" , 
"departure_time" : "10:18:21" , 
"distance_traveled" : 41.2742
}, 
{ 
"stop_id" : 49,
"arrival_time" : "10:23:01" , 
"departure_time" : "10:23:01" , 
"distance_traveled" : 42.2006
} ], 
"2383" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "06:55:00" , 
"departure_time" : "06:55:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "07:13:43" , 
"departure_time" : "07:14:37" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "07:18:54" , 
"departure_time" : "07:19:10" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "07:21:16" , 
"departure_time" : "07:21:41" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "07:24:25" , 
"departure_time" : "07:25:16" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "07:26:51" , 
"departure_time" : "07:27:54" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "07:30:03" , 
"departure_time" : "07:30:30" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "07:31:27" , 
"departure_time" : "07:32:55" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "07:35:28" , 
"departure_time" : "07:36:04" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "07:38:36" , 
"departure_time" : "07:39:03" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "07:41:27" , 
"departure_time" : "07:42:22" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "07:46:55" , 
"departure_time" : "07:46:58" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 104,
"arrival_time" : "07:50:03" , 
"departure_time" : "07:50:15" , 
"distance_traveled" : 21.7723
}, 
{ 
"stop_id" : 99,
"arrival_time" : "07:56:12" , 
"departure_time" : "07:56:15" , 
"distance_traveled" : 23.358
}, 
{ 
"stop_id" : 17,
"arrival_time" : "08:02:03" , 
"departure_time" : "08:03:02" , 
"distance_traveled" : 25.7235
}, 
{ 
"stop_id" : 48,
"arrival_time" : "08:05:59" , 
"departure_time" : "08:06:03" , 
"distance_traveled" : 27.1178
}, 
{ 
"stop_id" : 143,
"arrival_time" : "08:11:04" , 
"departure_time" : "08:12:01" , 
"distance_traveled" : 28.4723
}, 
{ 
"stop_id" : 88,
"arrival_time" : "08:21:57" , 
"departure_time" : "08:22:22" , 
"distance_traveled" : 30.0705
}, 
{ 
"stop_id" : 76,
"arrival_time" : "08:24:25" , 
"departure_time" : "08:25:12" , 
"distance_traveled" : 31.7098
}, 
{ 
"stop_id" : 12,
"arrival_time" : "08:27:47" , 
"departure_time" : "08:28:54" , 
"distance_traveled" : 33.592
}, 
{ 
"stop_id" : 18,
"arrival_time" : "08:32:07" , 
"departure_time" : "08:32:07" , 
"distance_traveled" : 34.7538
} ], 
"2384" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "09:36:00" , 
"departure_time" : "09:38:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:55:35" , 
"departure_time" : "09:56:53" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "10:00:18" , 
"departure_time" : "10:01:36" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "10:02:18" , 
"departure_time" : "10:02:42" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "10:04:24" , 
"departure_time" : "10:04:45" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "10:06:21" , 
"departure_time" : "10:08:00" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "10:09:39" , 
"departure_time" : "10:11:06" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "10:12:27" , 
"departure_time" : "10:13:53" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "10:15:26" , 
"departure_time" : "10:16:24" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "10:17:58" , 
"departure_time" : "10:18:41" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "10:20:43" , 
"departure_time" : "10:22:03" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "10:26:20" , 
"departure_time" : "10:26:55" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 104,
"arrival_time" : "10:29:35" , 
"departure_time" : "10:30:50" , 
"distance_traveled" : 21.7723
}, 
{ 
"stop_id" : 99,
"arrival_time" : "10:33:15" , 
"departure_time" : "10:34:19" , 
"distance_traveled" : 23.358
}, 
{ 
"stop_id" : 17,
"arrival_time" : "10:38:04" , 
"departure_time" : "10:38:34" , 
"distance_traveled" : 25.7235
}, 
{ 
"stop_id" : 48,
"arrival_time" : "10:40:30" , 
"departure_time" : "10:41:13" , 
"distance_traveled" : 27.1178
}, 
{ 
"stop_id" : 143,
"arrival_time" : "10:43:43" , 
"departure_time" : "10:44:28" , 
"distance_traveled" : 28.4723
}, 
{ 
"stop_id" : 88,
"arrival_time" : "10:46:45" , 
"departure_time" : "10:47:16" , 
"distance_traveled" : 30.0705
}, 
{ 
"stop_id" : 76,
"arrival_time" : "10:49:31" , 
"departure_time" : "10:50:58" , 
"distance_traveled" : 31.7098
}, 
{ 
"stop_id" : 12,
"arrival_time" : "10:53:27" , 
"departure_time" : "10:54:45" , 
"distance_traveled" : 33.592
}, 
{ 
"stop_id" : 18,
"arrival_time" : "10:56:18" , 
"departure_time" : "10:57:35" , 
"distance_traveled" : 34.7538
}, 
{ 
"stop_id" : 45,
"arrival_time" : "11:02:17" , 
"departure_time" : "11:02:58" , 
"distance_traveled" : 38.8879
}, 
{ 
"stop_id" : 117,
"arrival_time" : "11:05:41" , 
"departure_time" : "11:07:14" , 
"distance_traveled" : 41.2742
}, 
{ 
"stop_id" : 49,
"arrival_time" : "11:11:33" , 
"departure_time" : "11:11:33" , 
"distance_traveled" : 42.2006
} ], 
"2385" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "15:29:00" , 
"departure_time" : "15:32:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:47:27" , 
"departure_time" : "15:48:54" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "15:52:27" , 
"departure_time" : "15:52:58" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "15:54:31" , 
"departure_time" : "15:56:10" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "15:58:39" , 
"departure_time" : "15:59:39" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "16:00:00" , 
"departure_time" : "16:00:47" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "16:01:47" , 
"departure_time" : "16:02:46" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "16:04:59" , 
"departure_time" : "16:06:31" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "16:08:32" , 
"departure_time" : "16:10:00" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "16:12:28" , 
"departure_time" : "16:13:53" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "16:14:25" , 
"departure_time" : "16:15:21" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "16:18:56" , 
"departure_time" : "16:19:59" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 104,
"arrival_time" : "16:23:03" , 
"departure_time" : "16:24:24" , 
"distance_traveled" : 21.7723
}, 
{ 
"stop_id" : 99,
"arrival_time" : "16:26:21" , 
"departure_time" : "16:26:37" , 
"distance_traveled" : 23.358
}, 
{ 
"stop_id" : 17,
"arrival_time" : "16:29:16" , 
"departure_time" : "16:30:05" , 
"distance_traveled" : 25.7235
}, 
{ 
"stop_id" : 48,
"arrival_time" : "16:32:49" , 
"departure_time" : "16:34:01" , 
"distance_traveled" : 27.1178
}, 
{ 
"stop_id" : 143,
"arrival_time" : "16:36:12" , 
"departure_time" : "16:37:42" , 
"distance_traveled" : 28.4723
}, 
{ 
"stop_id" : 88,
"arrival_time" : "16:39:30" , 
"departure_time" : "16:39:48" , 
"distance_traveled" : 30.0705
}, 
{ 
"stop_id" : 76,
"arrival_time" : "16:41:18" , 
"departure_time" : "16:42:32" , 
"distance_traveled" : 31.7098
}, 
{ 
"stop_id" : 12,
"arrival_time" : "16:45:14" , 
"departure_time" : "16:45:40" , 
"distance_traveled" : 33.592
}, 
{ 
"stop_id" : 18,
"arrival_time" : "16:48:26" , 
"departure_time" : "16:48:26" , 
"distance_traveled" : 34.7538
} ], 
"2386" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "10:36:00" , 
"departure_time" : "10:37:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "10:55:21" , 
"departure_time" : "10:56:43" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "11:00:22" , 
"departure_time" : "11:01:59" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "11:02:37" , 
"departure_time" : "11:03:03" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "11:04:26" , 
"departure_time" : "11:05:14" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "11:06:48" , 
"departure_time" : "11:07:51" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "11:09:03" , 
"departure_time" : "11:10:08" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "11:11:05" , 
"departure_time" : "11:11:15" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "11:13:10" , 
"departure_time" : "11:14:49" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "11:18:39" , 
"departure_time" : "11:20:12" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "11:20:33" , 
"departure_time" : "11:20:51" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "11:24:18" , 
"departure_time" : "11:25:35" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 104,
"arrival_time" : "11:30:17" , 
"departure_time" : "11:31:26" , 
"distance_traveled" : 21.7723
}, 
{ 
"stop_id" : 99,
"arrival_time" : "11:33:09" , 
"departure_time" : "11:34:41" , 
"distance_traveled" : 23.358
}, 
{ 
"stop_id" : 17,
"arrival_time" : "11:36:32" , 
"departure_time" : "11:38:07" , 
"distance_traveled" : 25.7235
}, 
{ 
"stop_id" : 48,
"arrival_time" : "11:39:35" , 
"departure_time" : "11:40:30" , 
"distance_traveled" : 27.1178
}, 
{ 
"stop_id" : 143,
"arrival_time" : "11:41:55" , 
"departure_time" : "11:42:27" , 
"distance_traveled" : 28.4723
}, 
{ 
"stop_id" : 88,
"arrival_time" : "11:44:32" , 
"departure_time" : "11:45:36" , 
"distance_traveled" : 30.0705
}, 
{ 
"stop_id" : 76,
"arrival_time" : "11:48:04" , 
"departure_time" : "11:48:48" , 
"distance_traveled" : 31.7098
}, 
{ 
"stop_id" : 12,
"arrival_time" : "11:50:44" , 
"departure_time" : "11:51:05" , 
"distance_traveled" : 33.592
}, 
{ 
"stop_id" : 18,
"arrival_time" : "11:53:21" , 
"departure_time" : "11:54:57" , 
"distance_traveled" : 34.7538
}, 
{ 
"stop_id" : 45,
"arrival_time" : "12:00:36" , 
"departure_time" : "12:00:40" , 
"distance_traveled" : 38.8879
}, 
{ 
"stop_id" : 117,
"arrival_time" : "12:08:04" , 
"departure_time" : "12:09:01" , 
"distance_traveled" : 41.2742
}, 
{ 
"stop_id" : 49,
"arrival_time" : "12:15:57" , 
"departure_time" : "12:15:57" , 
"distance_traveled" : 42.2006
} ], 
"2387" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "07:54:00" , 
"departure_time" : "07:55:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "08:13:29" , 
"departure_time" : "08:14:18" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "08:18:49" , 
"departure_time" : "08:20:07" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "08:21:18" , 
"departure_time" : "08:21:37" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "08:23:19" , 
"departure_time" : "08:23:56" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "08:25:37" , 
"departure_time" : "08:26:19" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "08:27:42" , 
"departure_time" : "08:28:33" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "08:30:51" , 
"departure_time" : "08:31:54" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "08:34:03" , 
"departure_time" : "08:35:05" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "08:38:02" , 
"departure_time" : "08:38:37" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "08:40:35" , 
"departure_time" : "08:41:03" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "08:44:28" , 
"departure_time" : "08:45:49" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 104,
"arrival_time" : "08:50:21" , 
"departure_time" : "08:50:54" , 
"distance_traveled" : 21.7723
}, 
{ 
"stop_id" : 99,
"arrival_time" : "08:53:33" , 
"departure_time" : "08:54:46" , 
"distance_traveled" : 23.358
}, 
{ 
"stop_id" : 17,
"arrival_time" : "08:57:13" , 
"departure_time" : "08:58:21" , 
"distance_traveled" : 25.7235
}, 
{ 
"stop_id" : 48,
"arrival_time" : "09:01:08" , 
"departure_time" : "09:01:11" , 
"distance_traveled" : 27.1178
}, 
{ 
"stop_id" : 143,
"arrival_time" : "09:05:03" , 
"departure_time" : "09:05:13" , 
"distance_traveled" : 28.4723
}, 
{ 
"stop_id" : 88,
"arrival_time" : "09:10:10" , 
"departure_time" : "09:11:36" , 
"distance_traveled" : 30.0705
}, 
{ 
"stop_id" : 76,
"arrival_time" : "09:14:26" , 
"departure_time" : "09:14:42" , 
"distance_traveled" : 31.7098
}, 
{ 
"stop_id" : 12,
"arrival_time" : "09:16:16" , 
"departure_time" : "09:17:10" , 
"distance_traveled" : 33.592
}, 
{ 
"stop_id" : 18,
"arrival_time" : "09:19:54" , 
"departure_time" : "09:21:01" , 
"distance_traveled" : 34.7538
}, 
{ 
"stop_id" : 45,
"arrival_time" : "09:26:07" , 
"departure_time" : "09:26:34" , 
"distance_traveled" : 38.8879
}, 
{ 
"stop_id" : 117,
"arrival_time" : "09:29:27" , 
"departure_time" : "09:29:50" , 
"distance_traveled" : 41.2742
}, 
{ 
"stop_id" : 49,
"arrival_time" : "09:34:23" , 
"departure_time" : "09:34:23" , 
"distance_traveled" : 42.2006
} ], 
"2388" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "11:36:00" , 
"departure_time" : "11:37:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "11:55:19" , 
"departure_time" : "11:55:42" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "11:59:23" , 
"departure_time" : "11:59:51" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "12:01:28" , 
"departure_time" : "12:02:43" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "12:05:15" , 
"departure_time" : "12:06:38" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "12:07:23" , 
"departure_time" : "12:08:34" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "12:09:11" , 
"departure_time" : "12:10:20" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "12:11:09" , 
"departure_time" : "12:11:40" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "12:13:31" , 
"departure_time" : "12:13:40" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "12:17:09" , 
"departure_time" : "12:18:32" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "12:20:23" , 
"departure_time" : "12:21:08" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "12:24:45" , 
"departure_time" : "12:25:22" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 104,
"arrival_time" : "12:29:37" , 
"departure_time" : "12:30:59" , 
"distance_traveled" : 21.7723
}, 
{ 
"stop_id" : 99,
"arrival_time" : "12:33:22" , 
"departure_time" : "12:33:50" , 
"distance_traveled" : 23.358
}, 
{ 
"stop_id" : 17,
"arrival_time" : "12:37:28" , 
"departure_time" : "12:38:20" , 
"distance_traveled" : 25.7235
}, 
{ 
"stop_id" : 48,
"arrival_time" : "12:40:52" , 
"departure_time" : "12:42:09" , 
"distance_traveled" : 27.1178
}, 
{ 
"stop_id" : 143,
"arrival_time" : "12:44:17" , 
"departure_time" : "12:45:26" , 
"distance_traveled" : 28.4723
}, 
{ 
"stop_id" : 88,
"arrival_time" : "12:47:09" , 
"departure_time" : "12:47:58" , 
"distance_traveled" : 30.0705
}, 
{ 
"stop_id" : 76,
"arrival_time" : "12:49:49" , 
"departure_time" : "12:51:11" , 
"distance_traveled" : 31.7098
}, 
{ 
"stop_id" : 12,
"arrival_time" : "12:53:22" , 
"departure_time" : "12:54:25" , 
"distance_traveled" : 33.592
}, 
{ 
"stop_id" : 18,
"arrival_time" : "12:56:03" , 
"departure_time" : "12:57:03" , 
"distance_traveled" : 34.7538
}, 
{ 
"stop_id" : 45,
"arrival_time" : "13:02:00" , 
"departure_time" : "13:02:54" , 
"distance_traveled" : 38.8879
}, 
{ 
"stop_id" : 117,
"arrival_time" : "13:08:54" , 
"departure_time" : "13:10:33" , 
"distance_traveled" : 41.2742
}, 
{ 
"stop_id" : 49,
"arrival_time" : "13:16:39" , 
"departure_time" : "13:16:39" , 
"distance_traveled" : 42.2006
} ], 
"2389" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "08:50:00" , 
"departure_time" : "08:52:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:08:51" , 
"departure_time" : "09:09:18" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "09:13:27" , 
"departure_time" : "09:15:06" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "09:16:39" , 
"departure_time" : "09:17:25" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "09:18:46" , 
"departure_time" : "09:18:54" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "09:20:08" , 
"departure_time" : "09:20:37" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "09:22:29" , 
"departure_time" : "09:24:02" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "09:25:33" , 
"departure_time" : "09:26:41" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "09:28:08" , 
"departure_time" : "09:28:38" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "09:30:30" , 
"departure_time" : "09:31:55" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "09:34:25" , 
"departure_time" : "09:35:34" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "09:39:09" , 
"departure_time" : "09:40:15" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 104,
"arrival_time" : "09:43:06" , 
"departure_time" : "09:44:12" , 
"distance_traveled" : 21.7723
}, 
{ 
"stop_id" : 99,
"arrival_time" : "09:46:06" , 
"departure_time" : "09:46:30" , 
"distance_traveled" : 23.358
}, 
{ 
"stop_id" : 17,
"arrival_time" : "09:49:24" , 
"departure_time" : "09:49:45" , 
"distance_traveled" : 25.7235
}, 
{ 
"stop_id" : 48,
"arrival_time" : "09:52:21" , 
"departure_time" : "09:53:01" , 
"distance_traveled" : 27.1178
}, 
{ 
"stop_id" : 143,
"arrival_time" : "09:55:40" , 
"departure_time" : "09:56:55" , 
"distance_traveled" : 28.4723
}, 
{ 
"stop_id" : 88,
"arrival_time" : "09:59:15" , 
"departure_time" : "10:00:37" , 
"distance_traveled" : 30.0705
}, 
{ 
"stop_id" : 76,
"arrival_time" : "10:02:22" , 
"departure_time" : "10:03:24" , 
"distance_traveled" : 31.7098
}, 
{ 
"stop_id" : 12,
"arrival_time" : "10:05:02" , 
"departure_time" : "10:05:55" , 
"distance_traveled" : 33.592
}, 
{ 
"stop_id" : 18,
"arrival_time" : "10:08:53" , 
"departure_time" : "10:10:28" , 
"distance_traveled" : 34.7538
}, 
{ 
"stop_id" : 45,
"arrival_time" : "10:15:35" , 
"departure_time" : "10:16:04" , 
"distance_traveled" : 38.8879
}, 
{ 
"stop_id" : 117,
"arrival_time" : "10:18:29" , 
"departure_time" : "10:19:06" , 
"distance_traveled" : 41.2742
}, 
{ 
"stop_id" : 49,
"arrival_time" : "10:23:37" , 
"departure_time" : "10:23:37" , 
"distance_traveled" : 42.2006
} ], 
"2390" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "12:36:00" , 
"departure_time" : "12:37:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "12:54:44" , 
"departure_time" : "12:55:16" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "12:59:32" , 
"departure_time" : "13:00:41" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "13:02:09" , 
"departure_time" : "13:03:06" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "13:04:57" , 
"departure_time" : "13:06:26" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "13:07:29" , 
"departure_time" : "13:07:40" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "13:08:11" , 
"departure_time" : "13:09:24" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "13:12:13" , 
"departure_time" : "13:13:27" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "13:15:14" , 
"departure_time" : "13:16:03" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "13:17:49" , 
"departure_time" : "13:19:07" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "13:21:18" , 
"departure_time" : "13:21:53" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "13:25:35" , 
"departure_time" : "13:27:11" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 104,
"arrival_time" : "13:31:36" , 
"departure_time" : "13:32:12" , 
"distance_traveled" : 21.7723
}, 
{ 
"stop_id" : 99,
"arrival_time" : "13:33:36" , 
"departure_time" : "13:33:38" , 
"distance_traveled" : 23.358
}, 
{ 
"stop_id" : 17,
"arrival_time" : "13:38:02" , 
"departure_time" : "13:38:39" , 
"distance_traveled" : 25.7235
}, 
{ 
"stop_id" : 48,
"arrival_time" : "13:41:37" , 
"departure_time" : "13:42:13" , 
"distance_traveled" : 27.1178
}, 
{ 
"stop_id" : 143,
"arrival_time" : "13:44:36" , 
"departure_time" : "13:44:38" , 
"distance_traveled" : 28.4723
}, 
{ 
"stop_id" : 88,
"arrival_time" : "13:47:02" , 
"departure_time" : "13:48:05" , 
"distance_traveled" : 30.0705
}, 
{ 
"stop_id" : 76,
"arrival_time" : "13:51:03" , 
"departure_time" : "13:52:33" , 
"distance_traveled" : 31.7098
}, 
{ 
"stop_id" : 12,
"arrival_time" : "13:54:30" , 
"departure_time" : "13:54:41" , 
"distance_traveled" : 33.592
}, 
{ 
"stop_id" : 18,
"arrival_time" : "13:56:11" , 
"departure_time" : "13:57:44" , 
"distance_traveled" : 34.7538
}, 
{ 
"stop_id" : 45,
"arrival_time" : "14:03:33" , 
"departure_time" : "14:04:57" , 
"distance_traveled" : 38.8879
}, 
{ 
"stop_id" : 117,
"arrival_time" : "14:10:24" , 
"departure_time" : "14:11:10" , 
"distance_traveled" : 41.2742
}, 
{ 
"stop_id" : 49,
"arrival_time" : "14:16:46" , 
"departure_time" : "14:16:46" , 
"distance_traveled" : 42.2006
} ], 
"2391" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "09:36:00" , 
"departure_time" : "09:37:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "09:54:54" , 
"departure_time" : "09:55:51" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "09:59:57" , 
"departure_time" : "10:00:09" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "10:01:12" , 
"departure_time" : "10:02:44" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "10:05:32" , 
"departure_time" : "10:07:07" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "10:07:35" , 
"departure_time" : "10:08:54" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "10:09:19" , 
"departure_time" : "10:09:29" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "10:11:10" , 
"departure_time" : "10:11:33" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "10:14:23" , 
"departure_time" : "10:14:34" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "10:17:11" , 
"departure_time" : "10:17:59" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "10:20:48" , 
"departure_time" : "10:22:23" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "10:26:35" , 
"departure_time" : "10:27:51" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 104,
"arrival_time" : "10:30:16" , 
"departure_time" : "10:31:45" , 
"distance_traveled" : 21.7723
}, 
{ 
"stop_id" : 99,
"arrival_time" : "10:33:29" , 
"departure_time" : "10:35:04" , 
"distance_traveled" : 23.358
}, 
{ 
"stop_id" : 17,
"arrival_time" : "10:38:35" , 
"departure_time" : "10:39:34" , 
"distance_traveled" : 25.7235
}, 
{ 
"stop_id" : 48,
"arrival_time" : "10:40:59" , 
"departure_time" : "10:42:30" , 
"distance_traveled" : 27.1178
}, 
{ 
"stop_id" : 143,
"arrival_time" : "10:44:31" , 
"departure_time" : "10:44:59" , 
"distance_traveled" : 28.4723
}, 
{ 
"stop_id" : 88,
"arrival_time" : "10:46:28" , 
"departure_time" : "10:47:42" , 
"distance_traveled" : 30.0705
}, 
{ 
"stop_id" : 76,
"arrival_time" : "10:50:14" , 
"departure_time" : "10:50:23" , 
"distance_traveled" : 31.7098
}, 
{ 
"stop_id" : 12,
"arrival_time" : "10:52:09" , 
"departure_time" : "10:52:25" , 
"distance_traveled" : 33.592
}, 
{ 
"stop_id" : 18,
"arrival_time" : "10:55:16" , 
"departure_time" : "10:55:54" , 
"distance_traveled" : 34.7538
}, 
{ 
"stop_id" : 45,
"arrival_time" : "11:01:38" , 
"departure_time" : "11:02:58" , 
"distance_traveled" : 38.8879
}, 
{ 
"stop_id" : 117,
"arrival_time" : "11:06:20" , 
"departure_time" : "11:06:39" , 
"distance_traveled" : 41.2742
}, 
{ 
"stop_id" : 49,
"arrival_time" : "11:10:19" , 
"departure_time" : "11:10:19" , 
"distance_traveled" : 42.2006
} ], 
"2392" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "13:36:00" , 
"departure_time" : "13:36:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "13:54:01" , 
"departure_time" : "13:54:18" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "13:59:17" , 
"departure_time" : "14:00:23" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "14:02:06" , 
"departure_time" : "14:02:35" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "14:04:29" , 
"departure_time" : "14:05:44" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "14:07:15" , 
"departure_time" : "14:07:49" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "14:08:34" , 
"departure_time" : "14:09:10" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "14:11:36" , 
"departure_time" : "14:11:55" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "14:14:19" , 
"departure_time" : "14:15:17" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "14:17:58" , 
"departure_time" : "14:18:09" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "14:20:11" , 
"departure_time" : "14:20:56" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "14:25:45" , 
"departure_time" : "14:25:51" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 104,
"arrival_time" : "14:29:06" , 
"departure_time" : "14:29:13" , 
"distance_traveled" : 21.7723
}, 
{ 
"stop_id" : 99,
"arrival_time" : "14:32:07" , 
"departure_time" : "14:33:10" , 
"distance_traveled" : 23.358
}, 
{ 
"stop_id" : 17,
"arrival_time" : "14:38:03" , 
"departure_time" : "14:39:30" , 
"distance_traveled" : 25.7235
}, 
{ 
"stop_id" : 48,
"arrival_time" : "14:42:27" , 
"departure_time" : "14:42:41" , 
"distance_traveled" : 27.1178
}, 
{ 
"stop_id" : 143,
"arrival_time" : "14:44:14" , 
"departure_time" : "14:45:03" , 
"distance_traveled" : 28.4723
}, 
{ 
"stop_id" : 88,
"arrival_time" : "14:48:49" , 
"departure_time" : "14:49:43" , 
"distance_traveled" : 30.0705
}, 
{ 
"stop_id" : 76,
"arrival_time" : "14:51:54" , 
"departure_time" : "14:52:40" , 
"distance_traveled" : 31.7098
}, 
{ 
"stop_id" : 12,
"arrival_time" : "14:55:46" , 
"departure_time" : "14:56:43" , 
"distance_traveled" : 33.592
}, 
{ 
"stop_id" : 18,
"arrival_time" : "14:58:57" , 
"departure_time" : "14:59:28" , 
"distance_traveled" : 34.7538
}, 
{ 
"stop_id" : 45,
"arrival_time" : "15:05:31" , 
"departure_time" : "15:06:14" , 
"distance_traveled" : 38.8879
}, 
{ 
"stop_id" : 117,
"arrival_time" : "15:12:43" , 
"departure_time" : "15:13:54" , 
"distance_traveled" : 41.2742
}, 
{ 
"stop_id" : 49,
"arrival_time" : "15:20:11" , 
"departure_time" : "15:20:11" , 
"distance_traveled" : 42.2006
} ], 
"2393" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "10:36:00" , 
"departure_time" : "10:37:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "10:54:39" , 
"departure_time" : "10:54:55" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "10:59:16" , 
"departure_time" : "11:00:42" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "11:02:26" , 
"departure_time" : "11:03:46" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "11:05:20" , 
"departure_time" : "11:05:59" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "11:06:39" , 
"departure_time" : "11:08:09" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "11:09:30" , 
"departure_time" : "11:09:50" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "11:10:20" , 
"departure_time" : "11:11:44" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "11:14:24" , 
"departure_time" : "11:15:43" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "11:18:19" , 
"departure_time" : "11:18:24" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "11:19:05" , 
"departure_time" : "11:20:39" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "11:25:34" , 
"departure_time" : "11:27:01" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 104,
"arrival_time" : "11:30:27" , 
"departure_time" : "11:30:45" , 
"distance_traveled" : 21.7723
}, 
{ 
"stop_id" : 99,
"arrival_time" : "11:32:18" , 
"departure_time" : "11:32:44" , 
"distance_traveled" : 23.358
}, 
{ 
"stop_id" : 17,
"arrival_time" : "11:35:26" , 
"departure_time" : "11:36:17" , 
"distance_traveled" : 25.7235
}, 
{ 
"stop_id" : 48,
"arrival_time" : "11:38:51" , 
"departure_time" : "11:39:27" , 
"distance_traveled" : 27.1178
}, 
{ 
"stop_id" : 143,
"arrival_time" : "11:41:36" , 
"departure_time" : "11:42:54" , 
"distance_traveled" : 28.4723
}, 
{ 
"stop_id" : 88,
"arrival_time" : "11:45:18" , 
"departure_time" : "11:46:23" , 
"distance_traveled" : 30.0705
}, 
{ 
"stop_id" : 76,
"arrival_time" : "11:48:05" , 
"departure_time" : "11:49:44" , 
"distance_traveled" : 31.7098
}, 
{ 
"stop_id" : 12,
"arrival_time" : "11:51:39" , 
"departure_time" : "11:52:16" , 
"distance_traveled" : 33.592
}, 
{ 
"stop_id" : 18,
"arrival_time" : "11:53:37" , 
"departure_time" : "11:54:04" , 
"distance_traveled" : 34.7538
}, 
{ 
"stop_id" : 45,
"arrival_time" : "11:59:27" , 
"departure_time" : "12:00:08" , 
"distance_traveled" : 38.8879
}, 
{ 
"stop_id" : 117,
"arrival_time" : "12:08:41" , 
"departure_time" : "12:09:16" , 
"distance_traveled" : 41.2742
}, 
{ 
"stop_id" : 49,
"arrival_time" : "12:15:35" , 
"departure_time" : "12:15:35" , 
"distance_traveled" : 42.2006
} ], 
"2394" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "14:41:00" , 
"departure_time" : "14:43:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:00:29" , 
"departure_time" : "15:01:34" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "15:05:05" , 
"departure_time" : "15:05:33" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "15:06:28" , 
"departure_time" : "15:06:42" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "15:09:14" , 
"departure_time" : "15:09:35" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "15:11:21" , 
"departure_time" : "15:12:06" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "15:14:45" , 
"departure_time" : "15:14:51" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "15:16:06" , 
"departure_time" : "15:16:24" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "15:19:18" , 
"departure_time" : "15:20:36" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "15:24:18" , 
"departure_time" : "15:24:37" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "15:26:19" , 
"departure_time" : "15:27:50" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "15:32:31" , 
"departure_time" : "15:33:42" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 104,
"arrival_time" : "15:36:11" , 
"departure_time" : "15:36:38" , 
"distance_traveled" : 21.7723
}, 
{ 
"stop_id" : 99,
"arrival_time" : "15:38:27" , 
"departure_time" : "15:38:57" , 
"distance_traveled" : 23.358
}, 
{ 
"stop_id" : 17,
"arrival_time" : "15:42:30" , 
"departure_time" : "15:43:02" , 
"distance_traveled" : 25.7235
}, 
{ 
"stop_id" : 48,
"arrival_time" : "15:45:32" , 
"departure_time" : "15:46:37" , 
"distance_traveled" : 27.1178
}, 
{ 
"stop_id" : 143,
"arrival_time" : "15:49:05" , 
"departure_time" : "15:50:38" , 
"distance_traveled" : 28.4723
}, 
{ 
"stop_id" : 88,
"arrival_time" : "15:52:33" , 
"departure_time" : "15:53:12" , 
"distance_traveled" : 30.0705
}, 
{ 
"stop_id" : 76,
"arrival_time" : "15:54:39" , 
"departure_time" : "15:55:01" , 
"distance_traveled" : 31.7098
}, 
{ 
"stop_id" : 12,
"arrival_time" : "15:57:22" , 
"departure_time" : "15:57:38" , 
"distance_traveled" : 33.592
}, 
{ 
"stop_id" : 18,
"arrival_time" : "16:00:16" , 
"departure_time" : "16:01:12" , 
"distance_traveled" : 34.7538
}, 
{ 
"stop_id" : 45,
"arrival_time" : "16:06:56" , 
"departure_time" : "16:08:05" , 
"distance_traveled" : 38.8879
}, 
{ 
"stop_id" : 117,
"arrival_time" : "16:11:09" , 
"departure_time" : "16:12:28" , 
"distance_traveled" : 41.2742
}, 
{ 
"stop_id" : 49,
"arrival_time" : "16:16:19" , 
"departure_time" : "16:16:19" , 
"distance_traveled" : 42.2006
} ], 
"2395" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "11:36:00" , 
"departure_time" : "11:37:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "11:54:37" , 
"departure_time" : "11:55:48" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "12:00:11" , 
"departure_time" : "12:00:45" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "12:01:34" , 
"departure_time" : "12:02:16" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "12:04:42" , 
"departure_time" : "12:05:06" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "12:06:24" , 
"departure_time" : "12:06:53" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "12:08:29" , 
"departure_time" : "12:09:29" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "12:11:00" , 
"departure_time" : "12:12:38" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "12:14:38" , 
"departure_time" : "12:16:12" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "12:18:34" , 
"departure_time" : "12:19:24" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "12:19:50" , 
"departure_time" : "12:20:13" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "12:24:23" , 
"departure_time" : "12:25:57" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 104,
"arrival_time" : "12:30:34" , 
"departure_time" : "12:31:15" , 
"distance_traveled" : 21.7723
}, 
{ 
"stop_id" : 99,
"arrival_time" : "12:32:41" , 
"departure_time" : "12:32:47" , 
"distance_traveled" : 23.358
}, 
{ 
"stop_id" : 17,
"arrival_time" : "12:37:06" , 
"departure_time" : "12:37:14" , 
"distance_traveled" : 25.7235
}, 
{ 
"stop_id" : 48,
"arrival_time" : "12:40:08" , 
"departure_time" : "12:41:04" , 
"distance_traveled" : 27.1178
}, 
{ 
"stop_id" : 143,
"arrival_time" : "12:43:56" , 
"departure_time" : "12:44:11" , 
"distance_traveled" : 28.4723
}, 
{ 
"stop_id" : 88,
"arrival_time" : "12:46:15" , 
"departure_time" : "12:46:54" , 
"distance_traveled" : 30.0705
}, 
{ 
"stop_id" : 76,
"arrival_time" : "12:49:39" , 
"departure_time" : "12:51:00" , 
"distance_traveled" : 31.7098
}, 
{ 
"stop_id" : 12,
"arrival_time" : "12:53:21" , 
"departure_time" : "12:53:52" , 
"distance_traveled" : 33.592
}, 
{ 
"stop_id" : 18,
"arrival_time" : "12:55:31" , 
"departure_time" : "12:56:31" , 
"distance_traveled" : 34.7538
}, 
{ 
"stop_id" : 45,
"arrival_time" : "13:02:00" , 
"departure_time" : "13:02:40" , 
"distance_traveled" : 38.8879
}, 
{ 
"stop_id" : 117,
"arrival_time" : "13:08:40" , 
"departure_time" : "13:09:18" , 
"distance_traveled" : 41.2742
}, 
{ 
"stop_id" : 49,
"arrival_time" : "13:15:38" , 
"departure_time" : "13:15:38" , 
"distance_traveled" : 42.2006
} ], 
"2396" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "20:42:00" , 
"departure_time" : "20:43:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "21:00:42" , 
"departure_time" : "21:01:44" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "21:06:02" , 
"departure_time" : "21:07:27" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "21:08:25" , 
"departure_time" : "21:09:28" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "21:11:03" , 
"departure_time" : "21:12:11" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "21:13:08" , 
"departure_time" : "21:13:52" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "21:14:44" , 
"departure_time" : "21:15:46" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "21:17:02" , 
"departure_time" : "21:17:32" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "21:19:30" , 
"departure_time" : "21:19:55" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "21:23:25" , 
"departure_time" : "21:24:48" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "21:27:23" , 
"departure_time" : "21:28:10" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "21:31:47" , 
"departure_time" : "21:32:48" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 104,
"arrival_time" : "21:37:01" , 
"departure_time" : "21:38:09" , 
"distance_traveled" : 21.7723
}, 
{ 
"stop_id" : 99,
"arrival_time" : "21:40:08" , 
"departure_time" : "21:40:15" , 
"distance_traveled" : 23.358
}, 
{ 
"stop_id" : 17,
"arrival_time" : "21:43:07" , 
"departure_time" : "21:43:22" , 
"distance_traveled" : 25.7235
}, 
{ 
"stop_id" : 48,
"arrival_time" : "21:47:15" , 
"departure_time" : "21:48:34" , 
"distance_traveled" : 27.1178
}, 
{ 
"stop_id" : 143,
"arrival_time" : "21:52:19" , 
"departure_time" : "21:53:34" , 
"distance_traveled" : 28.4723
}, 
{ 
"stop_id" : 88,
"arrival_time" : "21:57:15" , 
"departure_time" : "21:58:20" , 
"distance_traveled" : 30.0705
}, 
{ 
"stop_id" : 76,
"arrival_time" : "22:00:05" , 
"departure_time" : "22:01:42" , 
"distance_traveled" : 31.7098
}, 
{ 
"stop_id" : 12,
"arrival_time" : "22:03:37" , 
"departure_time" : "22:04:58" , 
"distance_traveled" : 33.592
}, 
{ 
"stop_id" : 18,
"arrival_time" : "22:06:21" , 
"departure_time" : "22:07:40" , 
"distance_traveled" : 34.7538
}, 
{ 
"stop_id" : 45,
"arrival_time" : "22:12:19" , 
"departure_time" : "22:13:00" , 
"distance_traveled" : 38.8879
}, 
{ 
"stop_id" : 117,
"arrival_time" : "22:15:41" , 
"departure_time" : "22:16:40" , 
"distance_traveled" : 41.2742
}, 
{ 
"stop_id" : 49,
"arrival_time" : "22:20:59" , 
"departure_time" : "22:20:59" , 
"distance_traveled" : 42.2006
} ], 
"2397" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "12:36:00" , 
"departure_time" : "12:38:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "12:55:08" , 
"departure_time" : "12:56:40" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "13:00:32" , 
"departure_time" : "13:01:43" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "13:02:11" , 
"departure_time" : "13:02:17" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "13:04:06" , 
"departure_time" : "13:05:29" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "13:07:23" , 
"departure_time" : "13:07:31" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "13:08:08" , 
"departure_time" : "13:09:44" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "13:12:36" , 
"departure_time" : "13:14:00" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "13:15:24" , 
"departure_time" : "13:15:49" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "13:17:25" , 
"departure_time" : "13:17:29" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "13:20:04" , 
"departure_time" : "13:20:24" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "13:25:20" , 
"departure_time" : "13:25:48" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 104,
"arrival_time" : "13:30:28" , 
"departure_time" : "13:31:30" , 
"distance_traveled" : 21.7723
}, 
{ 
"stop_id" : 99,
"arrival_time" : "13:34:02" , 
"departure_time" : "13:35:32" , 
"distance_traveled" : 23.358
}, 
{ 
"stop_id" : 17,
"arrival_time" : "13:39:30" , 
"departure_time" : "13:40:30" , 
"distance_traveled" : 25.7235
}, 
{ 
"stop_id" : 48,
"arrival_time" : "13:42:00" , 
"departure_time" : "13:42:57" , 
"distance_traveled" : 27.1178
}, 
{ 
"stop_id" : 143,
"arrival_time" : "13:44:57" , 
"departure_time" : "13:45:14" , 
"distance_traveled" : 28.4723
}, 
{ 
"stop_id" : 88,
"arrival_time" : "13:47:17" , 
"departure_time" : "13:48:47" , 
"distance_traveled" : 30.0705
}, 
{ 
"stop_id" : 76,
"arrival_time" : "13:51:30" , 
"departure_time" : "13:52:50" , 
"distance_traveled" : 31.7098
}, 
{ 
"stop_id" : 12,
"arrival_time" : "13:54:20" , 
"departure_time" : "13:55:12" , 
"distance_traveled" : 33.592
}, 
{ 
"stop_id" : 18,
"arrival_time" : "13:56:52" , 
"departure_time" : "13:58:11" , 
"distance_traveled" : 34.7538
}, 
{ 
"stop_id" : 45,
"arrival_time" : "14:03:19" , 
"departure_time" : "14:03:56" , 
"distance_traveled" : 38.8879
}, 
{ 
"stop_id" : 117,
"arrival_time" : "14:09:37" , 
"departure_time" : "14:10:58" , 
"distance_traveled" : 41.2742
}, 
{ 
"stop_id" : 49,
"arrival_time" : "14:17:21" , 
"departure_time" : "14:17:21" , 
"distance_traveled" : 42.2006
} ], 
"2398" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "21:44:00" , 
"departure_time" : "21:45:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "22:02:12" , 
"departure_time" : "22:03:38" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "22:08:26" , 
"departure_time" : "22:08:38" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "22:09:12" , 
"departure_time" : "22:10:05" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "22:12:53" , 
"departure_time" : "22:13:15" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "22:14:22" , 
"departure_time" : "22:15:28" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "22:17:06" , 
"departure_time" : "22:17:25" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "22:18:19" , 
"departure_time" : "22:19:31" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "22:22:12" , 
"departure_time" : "22:22:43" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "22:25:31" , 
"departure_time" : "22:27:04" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "22:29:33" , 
"departure_time" : "22:30:17" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "22:33:44" , 
"departure_time" : "22:34:04" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 104,
"arrival_time" : "22:37:20" , 
"departure_time" : "22:38:05" , 
"distance_traveled" : 21.7723
}, 
{ 
"stop_id" : 99,
"arrival_time" : "22:40:45" , 
"departure_time" : "22:41:36" , 
"distance_traveled" : 23.358
}, 
{ 
"stop_id" : 17,
"arrival_time" : "22:44:51" , 
"departure_time" : "22:45:51" , 
"distance_traveled" : 25.7235
}, 
{ 
"stop_id" : 48,
"arrival_time" : "22:48:00" , 
"departure_time" : "22:48:55" , 
"distance_traveled" : 27.1178
}, 
{ 
"stop_id" : 143,
"arrival_time" : "22:50:55" , 
"departure_time" : "22:51:07" , 
"distance_traveled" : 28.4723
}, 
{ 
"stop_id" : 88,
"arrival_time" : "22:53:12" , 
"departure_time" : "22:54:05" , 
"distance_traveled" : 30.0705
}, 
{ 
"stop_id" : 76,
"arrival_time" : "22:56:53" , 
"departure_time" : "22:56:55" , 
"distance_traveled" : 31.7098
}, 
{ 
"stop_id" : 12,
"arrival_time" : "22:59:02" , 
"departure_time" : "23:00:00" , 
"distance_traveled" : 33.592
}, 
{ 
"stop_id" : 18,
"arrival_time" : "23:02:58" , 
"departure_time" : "23:04:22" , 
"distance_traveled" : 34.7538
}, 
{ 
"stop_id" : 45,
"arrival_time" : "23:10:24" , 
"departure_time" : "23:11:29" , 
"distance_traveled" : 38.8879
}, 
{ 
"stop_id" : 117,
"arrival_time" : "23:14:05" , 
"departure_time" : "23:14:32" , 
"distance_traveled" : 41.2742
}, 
{ 
"stop_id" : 49,
"arrival_time" : "23:19:27" , 
"departure_time" : "23:19:27" , 
"distance_traveled" : 42.2006
} ], 
"2399" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "13:36:00" , 
"departure_time" : "13:36:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "13:54:21" , 
"departure_time" : "13:54:28" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "13:59:07" , 
"departure_time" : "13:59:09" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "14:01:02" , 
"departure_time" : "14:02:08" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "14:05:06" , 
"departure_time" : "14:06:06" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "14:07:00" , 
"departure_time" : "14:07:55" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "14:08:55" , 
"departure_time" : "14:10:32" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "14:12:37" , 
"departure_time" : "14:13:23" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "14:14:46" , 
"departure_time" : "14:15:22" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "14:17:36" , 
"departure_time" : "14:18:34" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "14:20:58" , 
"departure_time" : "14:21:34" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "14:25:36" , 
"departure_time" : "14:27:11" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 104,
"arrival_time" : "14:30:35" , 
"departure_time" : "14:31:33" , 
"distance_traveled" : 21.7723
}, 
{ 
"stop_id" : 99,
"arrival_time" : "14:32:58" , 
"departure_time" : "14:33:02" , 
"distance_traveled" : 23.358
}, 
{ 
"stop_id" : 17,
"arrival_time" : "14:37:04" , 
"departure_time" : "14:38:01" , 
"distance_traveled" : 25.7235
}, 
{ 
"stop_id" : 48,
"arrival_time" : "14:41:57" , 
"departure_time" : "14:41:59" , 
"distance_traveled" : 27.1178
}, 
{ 
"stop_id" : 143,
"arrival_time" : "14:44:02" , 
"departure_time" : "14:44:43" , 
"distance_traveled" : 28.4723
}, 
{ 
"stop_id" : 88,
"arrival_time" : "14:48:41" , 
"departure_time" : "14:48:42" , 
"distance_traveled" : 30.0705
}, 
{ 
"stop_id" : 76,
"arrival_time" : "14:51:01" , 
"departure_time" : "14:51:31" , 
"distance_traveled" : 31.7098
}, 
{ 
"stop_id" : 12,
"arrival_time" : "14:55:30" , 
"departure_time" : "14:55:56" , 
"distance_traveled" : 33.592
}, 
{ 
"stop_id" : 18,
"arrival_time" : "14:58:26" , 
"departure_time" : "14:59:10" , 
"distance_traveled" : 34.7538
}, 
{ 
"stop_id" : 45,
"arrival_time" : "15:05:44" , 
"departure_time" : "15:07:24" , 
"distance_traveled" : 38.8879
}, 
{ 
"stop_id" : 117,
"arrival_time" : "15:13:40" , 
"departure_time" : "15:15:20" , 
"distance_traveled" : 41.2742
}, 
{ 
"stop_id" : 49,
"arrival_time" : "15:20:40" , 
"departure_time" : "15:20:40" , 
"distance_traveled" : 42.2006
} ], 
"2400" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "22:49:00" , 
"departure_time" : "22:51:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "23:07:27" , 
"departure_time" : "23:08:23" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "23:12:56" , 
"departure_time" : "23:13:58" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "23:15:02" , 
"departure_time" : "23:16:10" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "23:18:08" , 
"departure_time" : "23:19:11" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "23:20:03" , 
"departure_time" : "23:21:07" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "23:22:04" , 
"departure_time" : "23:23:43" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "23:24:39" , 
"departure_time" : "23:26:03" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "23:27:24" , 
"departure_time" : "23:28:44" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "23:31:20" , 
"departure_time" : "23:32:37" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "23:34:17" , 
"departure_time" : "23:34:40" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "23:38:23" , 
"departure_time" : "23:39:36" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 104,
"arrival_time" : "23:43:13" , 
"departure_time" : "23:44:14" , 
"distance_traveled" : 21.7723
}, 
{ 
"stop_id" : 99,
"arrival_time" : "23:46:01" , 
"departure_time" : "23:47:07" , 
"distance_traveled" : 23.358
}, 
{ 
"stop_id" : 17,
"arrival_time" : "23:50:06" , 
"departure_time" : "23:50:47" , 
"distance_traveled" : 25.7235
}, 
{ 
"stop_id" : 48,
"arrival_time" : "23:52:41" , 
"departure_time" : "23:53:15" , 
"distance_traveled" : 27.1178
}, 
{ 
"stop_id" : 143,
"arrival_time" : "23:55:34" , 
"departure_time" : "23:57:04" , 
"distance_traveled" : 28.4723
}, 
{ 
"stop_id" : 88,
"arrival_time" : "23:59:30" , 
"departure_time" : "24:00:59" , 
"distance_traveled" : 30.0705
}, 
{ 
"stop_id" : 76,
"arrival_time" : "24:02:29" , 
"departure_time" : "24:03:23" , 
"distance_traveled" : 31.7098
}, 
{ 
"stop_id" : 12,
"arrival_time" : "24:04:54" , 
"departure_time" : "24:05:30" , 
"distance_traveled" : 33.592
}, 
{ 
"stop_id" : 18,
"arrival_time" : "24:07:36" , 
"departure_time" : "24:07:38" , 
"distance_traveled" : 34.7538
}, 
{ 
"stop_id" : 45,
"arrival_time" : "24:13:02" , 
"departure_time" : "24:14:01" , 
"distance_traveled" : 38.8879
}, 
{ 
"stop_id" : 117,
"arrival_time" : "24:17:59" , 
"departure_time" : "24:18:13" , 
"distance_traveled" : 41.2742
}, 
{ 
"stop_id" : 49,
"arrival_time" : "24:23:14" , 
"departure_time" : "24:23:14" , 
"distance_traveled" : 42.2006
} ], 
"2401" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "14:41:00" , 
"departure_time" : "14:42:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "15:00:33" , 
"departure_time" : "15:01:38" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "15:05:05" , 
"departure_time" : "15:06:14" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "15:07:09" , 
"departure_time" : "15:07:56" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "15:09:47" , 
"departure_time" : "15:11:19" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "15:12:32" , 
"departure_time" : "15:13:59" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "15:15:27" , 
"departure_time" : "15:16:08" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "15:16:41" , 
"departure_time" : "15:17:45" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "15:20:04" , 
"departure_time" : "15:21:14" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "15:24:10" , 
"departure_time" : "15:25:14" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "15:27:04" , 
"departure_time" : "15:28:19" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "15:32:15" , 
"departure_time" : "15:33:07" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 104,
"arrival_time" : "15:35:52" , 
"departure_time" : "15:37:07" , 
"distance_traveled" : 21.7723
}, 
{ 
"stop_id" : 99,
"arrival_time" : "15:39:15" , 
"departure_time" : "15:39:31" , 
"distance_traveled" : 23.358
}, 
{ 
"stop_id" : 17,
"arrival_time" : "15:42:16" , 
"departure_time" : "15:43:08" , 
"distance_traveled" : 25.7235
}, 
{ 
"stop_id" : 48,
"arrival_time" : "15:45:52" , 
"departure_time" : "15:46:40" , 
"distance_traveled" : 27.1178
}, 
{ 
"stop_id" : 143,
"arrival_time" : "15:48:48" , 
"departure_time" : "15:49:27" , 
"distance_traveled" : 28.4723
}, 
{ 
"stop_id" : 88,
"arrival_time" : "15:51:39" , 
"departure_time" : "15:52:12" , 
"distance_traveled" : 30.0705
}, 
{ 
"stop_id" : 76,
"arrival_time" : "15:54:33" , 
"departure_time" : "15:55:07" , 
"distance_traveled" : 31.7098
}, 
{ 
"stop_id" : 12,
"arrival_time" : "15:57:34" , 
"departure_time" : "15:57:44" , 
"distance_traveled" : 33.592
}, 
{ 
"stop_id" : 18,
"arrival_time" : "16:00:10" , 
"departure_time" : "16:00:39" , 
"distance_traveled" : 34.7538
}, 
{ 
"stop_id" : 45,
"arrival_time" : "16:06:29" , 
"departure_time" : "16:07:05" , 
"distance_traveled" : 38.8879
}, 
{ 
"stop_id" : 117,
"arrival_time" : "16:10:36" , 
"departure_time" : "16:11:09" , 
"distance_traveled" : 41.2742
}, 
{ 
"stop_id" : 49,
"arrival_time" : "16:15:33" , 
"departure_time" : "16:15:33" , 
"distance_traveled" : 42.2006
} ], 
"2402" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "23:54:00" , 
"departure_time" : "23:55:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "24:12:53" , 
"departure_time" : "24:13:00" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "24:17:07" , 
"departure_time" : "24:18:02" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "24:19:55" , 
"departure_time" : "24:21:15" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "24:23:20" , 
"departure_time" : "24:23:36" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "24:24:16" , 
"departure_time" : "24:24:40" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "24:27:24" , 
"departure_time" : "24:28:35" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "24:30:11" , 
"departure_time" : "24:31:00" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "24:32:49" , 
"departure_time" : "24:33:38" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "24:36:49" , 
"departure_time" : "24:37:09" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "24:39:20" , 
"departure_time" : "24:41:00" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "24:46:40" , 
"departure_time" : "24:57:07" , 
"distance_traveled" : 20.0951
}, 
{ 
"stop_id" : 104,
"arrival_time" : "24:58:27" , 
"departure_time" : "24:59:23" , 
"distance_traveled" : 21.7731
}, 
{ 
"stop_id" : 99,
"arrival_time" : "25:01:56" , 
"departure_time" : "25:03:31" , 
"distance_traveled" : 23.3587
}, 
{ 
"stop_id" : 17,
"arrival_time" : "25:05:35" , 
"departure_time" : "25:07:11" , 
"distance_traveled" : 25.7242
}, 
{ 
"stop_id" : 48,
"arrival_time" : "25:08:36" , 
"departure_time" : "25:09:03" , 
"distance_traveled" : 27.1186
}, 
{ 
"stop_id" : 143,
"arrival_time" : "25:10:27" , 
"departure_time" : "25:12:06" , 
"distance_traveled" : 28.4731
}, 
{ 
"stop_id" : 88,
"arrival_time" : "25:14:39" , 
"departure_time" : "25:15:09" , 
"distance_traveled" : 30.0712
}, 
{ 
"stop_id" : 76,
"arrival_time" : "25:16:30" , 
"departure_time" : "25:16:37" , 
"distance_traveled" : 31.7106
}, 
{ 
"stop_id" : 12,
"arrival_time" : "25:19:07" , 
"departure_time" : "25:19:09" , 
"distance_traveled" : 33.5928
}, 
{ 
"stop_id" : 18,
"arrival_time" : "25:22:02" , 
"departure_time" : "25:23:27" , 
"distance_traveled" : 34.7545
}, 
{ 
"stop_id" : 45,
"arrival_time" : "25:29:25" , 
"departure_time" : "25:31:03" , 
"distance_traveled" : 38.8886
}, 
{ 
"stop_id" : 117,
"arrival_time" : "25:33:38" , 
"departure_time" : "25:34:21" , 
"distance_traveled" : 41.275
}, 
{ 
"stop_id" : 49,
"arrival_time" : "25:38:43" , 
"departure_time" : "25:38:43" , 
"distance_traveled" : 42.2013
} ], 
"2403" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "20:42:00" , 
"departure_time" : "20:44:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "21:01:32" , 
"departure_time" : "21:01:36" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "21:05:04" , 
"departure_time" : "21:06:25" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "21:08:21" , 
"departure_time" : "21:09:03" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "21:10:42" , 
"departure_time" : "21:11:04" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "21:12:22" , 
"departure_time" : "21:12:29" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "21:14:07" , 
"departure_time" : "21:15:12" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "21:17:05" , 
"departure_time" : "21:18:15" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "21:20:10" , 
"departure_time" : "21:20:45" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "21:23:35" , 
"departure_time" : "21:24:48" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "21:27:13" , 
"departure_time" : "21:28:21" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "21:32:08" , 
"departure_time" : "21:32:52" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 104,
"arrival_time" : "21:36:44" , 
"departure_time" : "21:38:16" , 
"distance_traveled" : 21.7723
}, 
{ 
"stop_id" : 99,
"arrival_time" : "21:40:32" , 
"departure_time" : "21:41:10" , 
"distance_traveled" : 23.358
}, 
{ 
"stop_id" : 17,
"arrival_time" : "21:43:38" , 
"departure_time" : "21:44:43" , 
"distance_traveled" : 25.7235
}, 
{ 
"stop_id" : 48,
"arrival_time" : "21:48:05" , 
"departure_time" : "21:49:12" , 
"distance_traveled" : 27.1178
}, 
{ 
"stop_id" : 143,
"arrival_time" : "21:52:07" , 
"departure_time" : "21:53:12" , 
"distance_traveled" : 28.4723
}, 
{ 
"stop_id" : 88,
"arrival_time" : "21:57:05" , 
"departure_time" : "21:57:51" , 
"distance_traveled" : 30.0705
}, 
{ 
"stop_id" : 76,
"arrival_time" : "21:59:46" , 
"departure_time" : "22:01:11" , 
"distance_traveled" : 31.7098
}, 
{ 
"stop_id" : 12,
"arrival_time" : "22:03:25" , 
"departure_time" : "22:04:34" , 
"distance_traveled" : 33.592
}, 
{ 
"stop_id" : 18,
"arrival_time" : "22:06:09" , 
"departure_time" : "22:06:26" , 
"distance_traveled" : 34.7538
}, 
{ 
"stop_id" : 45,
"arrival_time" : "22:11:17" , 
"departure_time" : "22:12:57" , 
"distance_traveled" : 38.8879
}, 
{ 
"stop_id" : 117,
"arrival_time" : "22:16:40" , 
"departure_time" : "22:16:59" , 
"distance_traveled" : 41.2742
}, 
{ 
"stop_id" : 49,
"arrival_time" : "22:20:19" , 
"departure_time" : "22:20:19" , 
"distance_traveled" : 42.2006
} ], 
"2404" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "21:44:00" , 
"departure_time" : "21:45:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "22:03:03" , 
"departure_time" : "22:04:04" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "22:08:01" , 
"departure_time" : "22:09:22" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "22:10:21" , 
"departure_time" : "22:10:34" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "22:12:13" , 
"departure_time" : "22:12:43" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "22:14:30" , 
"departure_time" : "22:15:07" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "22:16:37" , 
"departure_time" : "22:17:52" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "22:19:15" , 
"departure_time" : "22:20:14" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "22:21:59" , 
"departure_time" : "22:22:55" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "22:25:56" , 
"departure_time" : "22:27:23" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "22:29:27" , 
"departure_time" : "22:30:43" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "22:34:16" , 
"departure_time" : "22:35:10" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 104,
"arrival_time" : "22:37:54" , 
"departure_time" : "22:39:01" , 
"distance_traveled" : 21.7723
}, 
{ 
"stop_id" : 99,
"arrival_time" : "22:41:07" , 
"departure_time" : "22:41:46" , 
"distance_traveled" : 23.358
}, 
{ 
"stop_id" : 17,
"arrival_time" : "22:44:39" , 
"departure_time" : "22:45:59" , 
"distance_traveled" : 25.7235
}, 
{ 
"stop_id" : 48,
"arrival_time" : "22:48:20" , 
"departure_time" : "22:48:37" , 
"distance_traveled" : 27.1178
}, 
{ 
"stop_id" : 143,
"arrival_time" : "22:50:17" , 
"departure_time" : "22:51:36" , 
"distance_traveled" : 28.4723
}, 
{ 
"stop_id" : 88,
"arrival_time" : "22:54:19" , 
"departure_time" : "22:55:09" , 
"distance_traveled" : 30.0705
}, 
{ 
"stop_id" : 76,
"arrival_time" : "22:56:50" , 
"departure_time" : "22:58:26" , 
"distance_traveled" : 31.7098
}, 
{ 
"stop_id" : 12,
"arrival_time" : "23:00:36" , 
"departure_time" : "23:01:04" , 
"distance_traveled" : 33.592
}, 
{ 
"stop_id" : 18,
"arrival_time" : "23:02:28" , 
"departure_time" : "23:03:16" , 
"distance_traveled" : 34.7538
}, 
{ 
"stop_id" : 45,
"arrival_time" : "23:09:48" , 
"departure_time" : "23:10:40" , 
"distance_traveled" : 38.8879
}, 
{ 
"stop_id" : 117,
"arrival_time" : "23:13:52" , 
"departure_time" : "23:14:45" , 
"distance_traveled" : 41.2742
}, 
{ 
"stop_id" : 49,
"arrival_time" : "23:19:53" , 
"departure_time" : "23:19:53" , 
"distance_traveled" : 42.2006
} ], 
"2405" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "22:49:00" , 
"departure_time" : "22:50:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "23:07:21" , 
"departure_time" : "23:08:50" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "23:13:29" , 
"departure_time" : "23:14:38" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "23:15:09" , 
"departure_time" : "23:15:34" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "23:17:25" , 
"departure_time" : "23:18:36" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "23:20:11" , 
"departure_time" : "23:21:23" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "23:22:12" , 
"departure_time" : "23:22:40" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "23:23:28" , 
"departure_time" : "23:24:05" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "23:26:37" , 
"departure_time" : "23:27:03" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "23:30:26" , 
"departure_time" : "23:31:22" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "23:33:56" , 
"departure_time" : "23:35:17" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "23:39:21" , 
"departure_time" : "23:39:23" , 
"distance_traveled" : 20.0947
}, 
{ 
"stop_id" : 104,
"arrival_time" : "23:42:02" , 
"departure_time" : "23:43:16" , 
"distance_traveled" : 21.7723
}, 
{ 
"stop_id" : 99,
"arrival_time" : "23:46:14" , 
"departure_time" : "23:47:32" , 
"distance_traveled" : 23.358
}, 
{ 
"stop_id" : 17,
"arrival_time" : "23:50:18" , 
"departure_time" : "23:51:56" , 
"distance_traveled" : 25.7235
}, 
{ 
"stop_id" : 48,
"arrival_time" : "23:53:38" , 
"departure_time" : "23:54:34" , 
"distance_traveled" : 27.1178
}, 
{ 
"stop_id" : 143,
"arrival_time" : "23:55:56" , 
"departure_time" : "23:57:20" , 
"distance_traveled" : 28.4723
}, 
{ 
"stop_id" : 88,
"arrival_time" : "23:59:24" , 
"departure_time" : "23:59:54" , 
"distance_traveled" : 30.0705
}, 
{ 
"stop_id" : 76,
"arrival_time" : "24:01:30" , 
"departure_time" : "24:02:39" , 
"distance_traveled" : 31.7098
}, 
{ 
"stop_id" : 12,
"arrival_time" : "24:05:09" , 
"departure_time" : "24:06:44" , 
"distance_traveled" : 33.592
}, 
{ 
"stop_id" : 18,
"arrival_time" : "24:08:35" , 
"departure_time" : "24:08:37" , 
"distance_traveled" : 34.7538
}, 
{ 
"stop_id" : 45,
"arrival_time" : "24:13:02" , 
"departure_time" : "24:13:14" , 
"distance_traveled" : 38.8879
}, 
{ 
"stop_id" : 117,
"arrival_time" : "24:17:12" , 
"departure_time" : "24:18:16" , 
"distance_traveled" : 41.2742
}, 
{ 
"stop_id" : 49,
"arrival_time" : "24:24:04" , 
"departure_time" : "24:24:04" , 
"distance_traveled" : 42.2006
} ], 
"2406" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "23:54:00" , 
"departure_time" : "23:55:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "24:12:31" , 
"departure_time" : "24:12:47" , 
"distance_traveled" : 7.7884
}, 
{ 
"stop_id" : 37,
"arrival_time" : "24:17:16" , 
"departure_time" : "24:18:10" , 
"distance_traveled" : 10.0362
}, 
{ 
"stop_id" : 23,
"arrival_time" : "24:19:54" , 
"departure_time" : "24:20:32" , 
"distance_traveled" : 10.564
}, 
{ 
"stop_id" : 112,
"arrival_time" : "24:22:38" , 
"departure_time" : "24:22:46" , 
"distance_traveled" : 11.4634
}, 
{ 
"stop_id" : 61,
"arrival_time" : "24:24:08" , 
"departure_time" : "24:24:20" , 
"distance_traveled" : 12.171
}, 
{ 
"stop_id" : 97,
"arrival_time" : "24:27:12" , 
"departure_time" : "24:27:46" , 
"distance_traveled" : 13.0991
}, 
{ 
"stop_id" : 140,
"arrival_time" : "24:29:34" , 
"departure_time" : "24:30:57" , 
"distance_traveled" : 13.8616
}, 
{ 
"stop_id" : 81,
"arrival_time" : "24:33:23" , 
"departure_time" : "24:33:35" , 
"distance_traveled" : 15.1439
}, 
{ 
"stop_id" : 87,
"arrival_time" : "24:36:12" , 
"departure_time" : "24:36:39" , 
"distance_traveled" : 16.7527
}, 
{ 
"stop_id" : 136,
"arrival_time" : "24:39:27" , 
"departure_time" : "24:40:59" , 
"distance_traveled" : 17.8271
}, 
{ 
"stop_id" : 145,
"arrival_time" : "24:46:32" , 
"departure_time" : "24:57:35" , 
"distance_traveled" : 20.0951
}, 
{ 
"stop_id" : 104,
"arrival_time" : "24:59:03" , 
"departure_time" : "25:00:15" , 
"distance_traveled" : 21.7731
}, 
{ 
"stop_id" : 99,
"arrival_time" : "25:02:12" , 
"departure_time" : "25:03:46" , 
"distance_traveled" : 23.3587
}, 
{ 
"stop_id" : 17,
"arrival_time" : "25:05:34" , 
"departure_time" : "25:06:17" , 
"distance_traveled" : 25.7242
}, 
{ 
"stop_id" : 48,
"arrival_time" : "25:07:43" , 
"departure_time" : "25:09:05" , 
"distance_traveled" : 27.1186
}, 
{ 
"stop_id" : 143,
"arrival_time" : "25:11:22" , 
"departure_time" : "25:12:27" , 
"distance_traveled" : 28.4731
}, 
{ 
"stop_id" : 88,
"arrival_time" : "25:14:05" , 
"departure_time" : "25:14:45" , 
"distance_traveled" : 30.0712
}, 
{ 
"stop_id" : 76,
"arrival_time" : "25:16:40" , 
"departure_time" : "25:18:16" , 
"distance_traveled" : 31.7106
}, 
{ 
"stop_id" : 12,
"arrival_time" : "25:20:36" , 
"departure_time" : "25:20:45" , 
"distance_traveled" : 33.5928
}, 
{ 
"stop_id" : 18,
"arrival_time" : "25:22:09" , 
"departure_time" : "25:23:31" , 
"distance_traveled" : 34.7545
}, 
{ 
"stop_id" : 45,
"arrival_time" : "25:29:22" , 
"departure_time" : "25:30:30" , 
"distance_traveled" : 38.8886
}, 
{ 
"stop_id" : 117,
"arrival_time" : "25:33:08" , 
"departure_time" : "25:34:43" , 
"distance_traveled" : 41.275
}, 
{ 
"stop_id" : 49,
"arrival_time" : "25:39:35" , 
"departure_time" : "25:39:35" , 
"distance_traveled" : 42.2013
} ], 
"2407" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:03:00" , 
"departure_time" : "17:04:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "17:19:19" , 
"departure_time" : "17:20:02" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 23,
"arrival_time" : "17:26:43" , 
"departure_time" : "17:26:45" , 
"distance_traveled" : 13.1979
}, 
{ 
"stop_id" : 112,
"arrival_time" : "17:29:02" , 
"departure_time" : "17:30:22" , 
"distance_traveled" : 14.0973
}, 
{ 
"stop_id" : 140,
"arrival_time" : "17:35:20" , 
"departure_time" : "17:36:41" , 
"distance_traveled" : 16.4955
}, 
{ 
"stop_id" : 81,
"arrival_time" : "17:38:21" , 
"departure_time" : "17:39:08" , 
"distance_traveled" : 17.7778
}, 
{ 
"stop_id" : 87,
"arrival_time" : "17:41:47" , 
"departure_time" : "17:43:16" , 
"distance_traveled" : 19.3866
}, 
{ 
"stop_id" : 136,
"arrival_time" : "17:46:29" , 
"departure_time" : "17:47:54" , 
"distance_traveled" : 20.461
}, 
{ 
"stop_id" : 145,
"arrival_time" : "17:53:25" , 
"departure_time" : "17:55:04" , 
"distance_traveled" : 22.7286
}, 
{ 
"stop_id" : 104,
"arrival_time" : "17:58:39" , 
"departure_time" : "17:59:22" , 
"distance_traveled" : 24.4062
}, 
{ 
"stop_id" : 99,
"arrival_time" : "18:01:43" , 
"departure_time" : "18:03:22" , 
"distance_traveled" : 25.9919
}, 
{ 
"stop_id" : 17,
"arrival_time" : "18:07:39" , 
"departure_time" : "18:08:02" , 
"distance_traveled" : 28.3574
}, 
{ 
"stop_id" : 48,
"arrival_time" : "18:09:23" , 
"departure_time" : "18:10:40" , 
"distance_traveled" : 29.7517
}, 
{ 
"stop_id" : 143,
"arrival_time" : "18:17:17" , 
"departure_time" : "18:17:37" , 
"distance_traveled" : 31.1062
}, 
{ 
"stop_id" : 88,
"arrival_time" : "18:20:20" , 
"departure_time" : "18:20:54" , 
"distance_traveled" : 32.7044
}, 
{ 
"stop_id" : 76,
"arrival_time" : "18:24:34" , 
"departure_time" : "18:25:08" , 
"distance_traveled" : 34.3438
}, 
{ 
"stop_id" : 12,
"arrival_time" : "18:27:34" , 
"departure_time" : "18:28:13" , 
"distance_traveled" : 36.2259
}, 
{ 
"stop_id" : 18,
"arrival_time" : "18:31:39" , 
"departure_time" : "18:31:51" , 
"distance_traveled" : 37.3877
}, 
{ 
"stop_id" : 45,
"arrival_time" : "18:38:12" , 
"departure_time" : "18:39:22" , 
"distance_traveled" : 41.5218
}, 
{ 
"stop_id" : 117,
"arrival_time" : "18:43:10" , 
"departure_time" : "18:43:10" , 
"distance_traveled" : 43.9081
} ], 
"2408" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:03:00" , 
"departure_time" : "18:05:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 106,
"arrival_time" : "18:19:52" , 
"departure_time" : "18:21:09" , 
"distance_traveled" : 10.4223
}, 
{ 
"stop_id" : 23,
"arrival_time" : "18:27:17" , 
"departure_time" : "18:28:35" , 
"distance_traveled" : 13.1979
}, 
{ 
"stop_id" : 112,
"arrival_time" : "18:30:18" , 
"departure_time" : "18:31:57" , 
"distance_traveled" : 14.0973
}, 
{ 
"stop_id" : 140,
"arrival_time" : "18:35:39" , 
"departure_time" : "18:36:49" , 
"distance_traveled" : 16.4955
}, 
{ 
"stop_id" : 81,
"arrival_time" : "18:38:10" , 
"departure_time" : "18:39:17" , 
"distance_traveled" : 17.7778
}, 
{ 
"stop_id" : 87,
"arrival_time" : "18:42:07" , 
"departure_time" : "18:43:19" , 
"distance_traveled" : 19.3866
}, 
{ 
"stop_id" : 136,
"arrival_time" : "18:46:12" , 
"departure_time" : "18:47:48" , 
"distance_traveled" : 20.461
}, 
{ 
"stop_id" : 145,
"arrival_time" : "18:53:36" , 
"departure_time" : "18:54:32" , 
"distance_traveled" : 22.7286
}, 
{ 
"stop_id" : 104,
"arrival_time" : "18:57:56" , 
"departure_time" : "18:58:22" , 
"distance_traveled" : 24.4062
}, 
{ 
"stop_id" : 99,
"arrival_time" : "19:01:26" , 
"departure_time" : "19:01:38" , 
"distance_traveled" : 25.9919
}, 
{ 
"stop_id" : 17,
"arrival_time" : "19:06:12" , 
"departure_time" : "19:06:54" , 
"distance_traveled" : 28.3574
}, 
{ 
"stop_id" : 48,
"arrival_time" : "19:09:42" , 
"departure_time" : "19:10:16" , 
"distance_traveled" : 29.7517
}, 
{ 
"stop_id" : 143,
"arrival_time" : "19:16:34" , 
"departure_time" : "19:17:56" , 
"distance_traveled" : 31.1062
}, 
{ 
"stop_id" : 88,
"arrival_time" : "19:21:22" , 
"departure_time" : "19:21:31" , 
"distance_traveled" : 32.7044
}, 
{ 
"stop_id" : 76,
"arrival_time" : "19:24:09" , 
"departure_time" : "19:24:17" , 
"distance_traveled" : 34.3438
}, 
{ 
"stop_id" : 12,
"arrival_time" : "19:27:08" , 
"departure_time" : "19:28:01" , 
"distance_traveled" : 36.2259
}, 
{ 
"stop_id" : 18,
"arrival_time" : "19:31:53" , 
"departure_time" : "19:32:28" , 
"distance_traveled" : 37.3877
}, 
{ 
"stop_id" : 45,
"arrival_time" : "19:38:35" , 
"departure_time" : "19:38:55" , 
"distance_traveled" : 41.5218
}, 
{ 
"stop_id" : 117,
"arrival_time" : "19:42:20" , 
"departure_time" : "19:42:20" , 
"distance_traveled" : 43.9081
} ], 
"2409" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "24:14:00" , 
"departure_time" : "24:14:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "24:18:36" , 
"departure_time" : "24:19:56" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "24:22:20" , 
"departure_time" : "24:22:51" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "24:25:31" , 
"departure_time" : "24:26:56" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "24:29:25" , 
"departure_time" : "24:31:03" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "24:32:38" , 
"departure_time" : "24:33:02" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "24:34:24" , 
"departure_time" : "24:35:53" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "24:38:29" , 
"departure_time" : "24:38:53" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "24:40:24" , 
"departure_time" : "24:41:26" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "24:44:02" , 
"departure_time" : "24:44:49" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "24:49:47" , 
"departure_time" : "24:50:16" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "24:53:29" , 
"departure_time" : "24:53:49" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "24:58:20" , 
"departure_time" : "24:58:20" , 
"distance_traveled" : 22.1062
} ], 
"2410" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "07:14:00" , 
"departure_time" : "07:15:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "07:19:23" , 
"departure_time" : "07:20:40" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "07:25:17" , 
"departure_time" : "07:26:08" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "07:31:51" , 
"departure_time" : "07:33:05" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "07:35:14" , 
"departure_time" : "07:35:17" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "07:37:03" , 
"departure_time" : "07:37:18" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "07:40:15" , 
"departure_time" : "07:40:53" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "07:43:38" , 
"departure_time" : "07:43:49" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "07:46:11" , 
"departure_time" : "07:47:20" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "07:50:09" , 
"departure_time" : "07:51:33" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "07:57:24" , 
"departure_time" : "07:57:52" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "08:04:28" , 
"departure_time" : "08:04:39" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "08:08:11" , 
"departure_time" : "08:08:11" , 
"distance_traveled" : 22.1062
} ], 
"2411" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "08:14:00" , 
"departure_time" : "08:15:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "08:19:13" , 
"departure_time" : "08:20:44" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "08:25:31" , 
"departure_time" : "08:25:50" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "08:31:19" , 
"departure_time" : "08:31:47" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "08:34:28" , 
"departure_time" : "08:35:43" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "08:38:15" , 
"departure_time" : "08:38:53" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "08:40:38" , 
"departure_time" : "08:40:46" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "08:43:08" , 
"departure_time" : "08:44:44" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "08:47:36" , 
"departure_time" : "08:48:50" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "08:50:14" , 
"departure_time" : "08:50:24" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "08:56:10" , 
"departure_time" : "08:56:45" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "09:04:35" , 
"departure_time" : "09:05:13" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "09:08:38" , 
"departure_time" : "09:08:38" , 
"distance_traveled" : 22.1062
} ], 
"2412" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "09:14:00" , 
"departure_time" : "09:16:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "09:19:29" , 
"departure_time" : "09:21:09" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "09:25:40" , 
"departure_time" : "09:26:28" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "09:31:48" , 
"departure_time" : "09:33:22" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "09:35:34" , 
"departure_time" : "09:36:06" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "09:37:32" , 
"departure_time" : "09:38:00" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "09:40:28" , 
"departure_time" : "09:41:37" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "09:44:09" , 
"departure_time" : "09:44:38" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "09:46:29" , 
"departure_time" : "09:47:48" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "09:50:19" , 
"departure_time" : "09:51:49" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "09:57:30" , 
"departure_time" : "09:58:25" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "10:04:55" , 
"departure_time" : "10:05:51" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "10:08:56" , 
"departure_time" : "10:08:56" , 
"distance_traveled" : 22.1062
} ], 
"2413" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "10:14:00" , 
"departure_time" : "10:16:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "10:19:14" , 
"departure_time" : "10:19:57" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "10:24:43" , 
"departure_time" : "10:26:21" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "10:32:38" , 
"departure_time" : "10:33:32" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "10:34:54" , 
"departure_time" : "10:34:57" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "10:37:03" , 
"departure_time" : "10:37:55" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "10:40:52" , 
"departure_time" : "10:41:30" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "10:43:38" , 
"departure_time" : "10:44:24" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "10:46:46" , 
"departure_time" : "10:47:16" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "10:49:30" , 
"departure_time" : "10:49:41" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "10:56:11" , 
"departure_time" : "10:57:35" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "11:05:24" , 
"departure_time" : "11:06:56" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "11:09:32" , 
"departure_time" : "11:09:32" , 
"distance_traveled" : 22.1062
} ], 
"2414" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "11:14:00" , 
"departure_time" : "11:15:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "11:18:19" , 
"departure_time" : "11:19:04" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "11:24:45" , 
"departure_time" : "11:25:14" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "11:31:29" , 
"departure_time" : "11:32:19" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "11:34:50" , 
"departure_time" : "11:36:21" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "11:38:31" , 
"departure_time" : "11:39:03" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "11:40:32" , 
"departure_time" : "11:41:06" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "11:43:34" , 
"departure_time" : "11:44:09" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "11:46:35" , 
"departure_time" : "11:48:05" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "11:50:30" , 
"departure_time" : "11:50:34" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "11:56:04" , 
"departure_time" : "11:57:12" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "12:05:08" , 
"departure_time" : "12:06:34" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "12:09:26" , 
"departure_time" : "12:09:26" , 
"distance_traveled" : 22.1062
} ], 
"2415" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "12:14:00" , 
"departure_time" : "12:15:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "12:18:26" , 
"departure_time" : "12:18:28" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "12:24:02" , 
"departure_time" : "12:24:25" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "12:31:23" , 
"departure_time" : "12:32:33" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "12:35:10" , 
"departure_time" : "12:36:30" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "12:38:20" , 
"departure_time" : "12:38:22" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "12:40:02" , 
"departure_time" : "12:41:25" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "12:44:23" , 
"departure_time" : "12:44:39" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "12:46:16" , 
"departure_time" : "12:46:52" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "12:49:36" , 
"departure_time" : "12:51:00" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "12:57:24" , 
"departure_time" : "12:58:14" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "13:04:50" , 
"departure_time" : "13:05:01" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "13:08:11" , 
"departure_time" : "13:08:11" , 
"distance_traveled" : 22.1062
} ], 
"2416" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "13:14:00" , 
"departure_time" : "13:14:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "13:18:21" , 
"departure_time" : "13:19:14" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "13:24:53" , 
"departure_time" : "13:25:35" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "13:31:42" , 
"departure_time" : "13:32:38" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "13:34:56" , 
"departure_time" : "13:36:07" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "13:38:11" , 
"departure_time" : "13:38:37" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "13:40:26" , 
"departure_time" : "13:40:56" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "13:43:30" , 
"departure_time" : "13:43:53" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "13:46:23" , 
"departure_time" : "13:47:00" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "13:49:37" , 
"departure_time" : "13:50:37" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "13:57:00" , 
"departure_time" : "13:57:42" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "14:04:42" , 
"departure_time" : "14:05:50" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "14:09:08" , 
"departure_time" : "14:09:08" , 
"distance_traveled" : 22.1062
} ], 
"2417" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "14:14:00" , 
"departure_time" : "14:15:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "14:18:38" , 
"departure_time" : "14:20:08" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "14:25:30" , 
"departure_time" : "14:26:53" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "14:32:23" , 
"departure_time" : "14:32:59" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "14:34:36" , 
"departure_time" : "14:35:08" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "14:37:32" , 
"departure_time" : "14:37:40" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "14:40:08" , 
"departure_time" : "14:41:27" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "14:44:19" , 
"departure_time" : "14:45:27" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "14:47:08" , 
"departure_time" : "14:47:59" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "14:49:51" , 
"departure_time" : "14:50:40" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "14:56:49" , 
"departure_time" : "14:57:41" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "15:04:52" , 
"departure_time" : "15:05:13" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "15:08:21" , 
"departure_time" : "15:08:21" , 
"distance_traveled" : 22.1062
} ], 
"2418" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "15:14:00" , 
"departure_time" : "15:14:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "15:18:37" , 
"departure_time" : "15:19:21" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "15:24:44" , 
"departure_time" : "15:25:25" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "15:31:41" , 
"departure_time" : "15:32:37" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "15:34:56" , 
"departure_time" : "15:35:41" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "15:37:45" , 
"departure_time" : "15:38:24" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "15:40:39" , 
"departure_time" : "15:41:47" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "15:44:08" , 
"departure_time" : "15:44:32" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "15:46:24" , 
"departure_time" : "15:46:30" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "15:49:06" , 
"departure_time" : "15:50:24" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "15:57:18" , 
"departure_time" : "15:58:55" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "16:05:37" , 
"departure_time" : "16:05:45" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "16:08:08" , 
"departure_time" : "16:08:08" , 
"distance_traveled" : 22.1062
} ], 
"2419" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "16:14:00" , 
"departure_time" : "16:15:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "16:19:30" , 
"departure_time" : "16:20:31" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "16:25:01" , 
"departure_time" : "16:25:44" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "16:31:43" , 
"departure_time" : "16:33:01" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "16:35:18" , 
"departure_time" : "16:36:35" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "16:38:17" , 
"departure_time" : "16:39:19" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "16:41:02" , 
"departure_time" : "16:41:50" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "16:43:48" , 
"departure_time" : "16:44:28" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "16:46:40" , 
"departure_time" : "16:48:17" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "16:50:37" , 
"departure_time" : "16:51:11" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "16:56:34" , 
"departure_time" : "16:57:19" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "17:04:45" , 
"departure_time" : "17:05:36" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "17:08:51" , 
"departure_time" : "17:08:51" , 
"distance_traveled" : 22.1062
} ], 
"2420" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "17:14:00" , 
"departure_time" : "17:15:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "17:18:38" , 
"departure_time" : "17:19:26" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "17:24:48" , 
"departure_time" : "17:25:07" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "17:31:19" , 
"departure_time" : "17:31:32" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "17:34:13" , 
"departure_time" : "17:35:36" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "17:38:23" , 
"departure_time" : "17:38:42" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "17:40:19" , 
"departure_time" : "17:41:05" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "17:43:46" , 
"departure_time" : "17:44:53" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "17:47:07" , 
"departure_time" : "17:47:47" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "17:49:40" , 
"departure_time" : "17:50:18" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "17:56:38" , 
"departure_time" : "17:56:41" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "18:04:03" , 
"departure_time" : "18:04:40" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "18:08:37" , 
"departure_time" : "18:08:37" , 
"distance_traveled" : 22.1062
} ], 
"2421" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "18:14:00" , 
"departure_time" : "18:15:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "18:18:40" , 
"departure_time" : "18:19:29" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "18:24:49" , 
"departure_time" : "18:25:03" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "18:31:14" , 
"departure_time" : "18:31:19" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "18:34:05" , 
"departure_time" : "18:34:12" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "18:37:07" , 
"departure_time" : "18:38:01" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "18:40:54" , 
"departure_time" : "18:41:19" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "18:43:25" , 
"departure_time" : "18:44:48" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "18:47:23" , 
"departure_time" : "18:47:53" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "18:49:30" , 
"departure_time" : "18:51:07" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "18:57:37" , 
"departure_time" : "18:58:51" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "19:05:14" , 
"departure_time" : "19:06:08" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "19:08:54" , 
"departure_time" : "19:08:54" , 
"distance_traveled" : 22.1062
} ], 
"2422" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "19:14:00" , 
"departure_time" : "19:16:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "19:19:15" , 
"departure_time" : "19:19:29" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "19:24:14" , 
"departure_time" : "19:25:54" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "19:32:40" , 
"departure_time" : "19:32:49" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "19:34:09" , 
"departure_time" : "19:34:54" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "19:37:45" , 
"departure_time" : "19:39:24" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "19:41:39" , 
"departure_time" : "19:42:05" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "19:43:26" , 
"departure_time" : "19:44:26" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "19:47:00" , 
"departure_time" : "19:48:22" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "19:50:22" , 
"departure_time" : "19:51:12" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "19:56:50" , 
"departure_time" : "19:57:46" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "20:04:56" , 
"departure_time" : "20:06:01" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "20:09:05" , 
"departure_time" : "20:09:05" , 
"distance_traveled" : 22.1062
} ], 
"2423" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "20:14:00" , 
"departure_time" : "20:15:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "20:18:21" , 
"departure_time" : "20:19:32" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "20:25:11" , 
"departure_time" : "20:26:46" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "20:32:35" , 
"departure_time" : "20:32:41" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "20:34:06" , 
"departure_time" : "20:34:49" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "20:37:43" , 
"departure_time" : "20:38:16" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "20:40:33" , 
"departure_time" : "20:40:47" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "20:43:14" , 
"departure_time" : "20:44:39" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "20:47:25" , 
"departure_time" : "20:47:45" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "20:49:20" , 
"departure_time" : "20:49:30" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "20:56:10" , 
"departure_time" : "20:57:41" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "21:05:31" , 
"departure_time" : "21:06:46" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "21:09:15" , 
"departure_time" : "21:09:15" , 
"distance_traveled" : 22.1062
} ], 
"2424" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "21:14:00" , 
"departure_time" : "21:15:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "21:18:32" , 
"departure_time" : "21:19:12" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "21:24:40" , 
"departure_time" : "21:24:42" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "21:31:02" , 
"departure_time" : "21:31:33" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "21:34:31" , 
"departure_time" : "21:36:11" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "21:38:40" , 
"departure_time" : "21:40:17" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "21:41:37" , 
"departure_time" : "21:41:53" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "21:43:16" , 
"departure_time" : "21:43:49" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "21:46:33" , 
"departure_time" : "21:46:55" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "21:49:22" , 
"departure_time" : "21:49:51" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "21:56:29" , 
"departure_time" : "21:57:06" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "22:04:37" , 
"departure_time" : "22:05:31" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "22:08:54" , 
"departure_time" : "22:08:54" , 
"distance_traveled" : 22.1062
} ], 
"2425" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "22:14:00" , 
"departure_time" : "22:15:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "22:18:39" , 
"departure_time" : "22:19:13" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "22:24:34" , 
"departure_time" : "22:25:39" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "22:32:05" , 
"departure_time" : "22:32:26" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "22:34:21" , 
"departure_time" : "22:34:42" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "22:37:21" , 
"departure_time" : "22:37:30" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "22:40:09" , 
"departure_time" : "22:40:16" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "22:43:07" , 
"departure_time" : "22:43:37" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "22:46:30" , 
"departure_time" : "22:46:37" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "22:49:07" , 
"departure_time" : "22:50:31" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "22:57:24" , 
"departure_time" : "22:59:01" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "23:05:37" , 
"departure_time" : "23:06:39" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "23:09:02" , 
"departure_time" : "23:09:02" , 
"distance_traveled" : 22.1062
} ], 
"2426" :  [ 
{ 
"stop_id" : 145,
"arrival_time" : "23:14:00" , 
"departure_time" : "23:16:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 104,
"arrival_time" : "23:19:00" , 
"departure_time" : "23:19:25" , 
"distance_traveled" : 1.678
}, 
{ 
"stop_id" : 99,
"arrival_time" : "23:24:25" , 
"departure_time" : "23:25:45" , 
"distance_traveled" : 3.2636
}, 
{ 
"stop_id" : 17,
"arrival_time" : "23:32:20" , 
"departure_time" : "23:32:58" , 
"distance_traveled" : 5.6292
}, 
{ 
"stop_id" : 48,
"arrival_time" : "23:34:38" , 
"departure_time" : "23:36:00" , 
"distance_traveled" : 7.0235
}, 
{ 
"stop_id" : 143,
"arrival_time" : "23:38:22" , 
"departure_time" : "23:39:23" , 
"distance_traveled" : 8.378
}, 
{ 
"stop_id" : 88,
"arrival_time" : "23:41:01" , 
"departure_time" : "23:42:03" , 
"distance_traveled" : 9.9761
}, 
{ 
"stop_id" : 76,
"arrival_time" : "23:44:02" , 
"departure_time" : "23:45:05" , 
"distance_traveled" : 11.6155
}, 
{ 
"stop_id" : 12,
"arrival_time" : "23:47:03" , 
"departure_time" : "23:47:10" , 
"distance_traveled" : 13.4977
}, 
{ 
"stop_id" : 18,
"arrival_time" : "23:49:07" , 
"departure_time" : "23:50:14" , 
"distance_traveled" : 14.6595
}, 
{ 
"stop_id" : 45,
"arrival_time" : "23:56:07" , 
"departure_time" : "23:56:17" , 
"distance_traveled" : 18.7936
}, 
{ 
"stop_id" : 117,
"arrival_time" : "23:59:10" , 
"departure_time" : "23:59:28" , 
"distance_traveled" : 21.1799
}, 
{ 
"stop_id" : 49,
"arrival_time" : "24:04:18" , 
"departure_time" : "24:04:18" , 
"distance_traveled" : 22.1062
} ], 
"2427" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "06:29:00" , 
"departure_time" : "06:30:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "06:36:11" , 
"departure_time" : "06:36:26" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "06:42:15" , 
"departure_time" : "06:43:44" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "06:59:29" , 
"departure_time" : "07:00:09" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "07:02:40" , 
"departure_time" : "07:03:58" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "07:08:18" , 
"departure_time" : "07:08:33" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "07:12:15" , 
"departure_time" : "07:13:49" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "07:26:34" , 
"departure_time" : "07:27:27" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:32:53" , 
"departure_time" : "07:33:34" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:50:41" , 
"departure_time" : "07:50:41" , 
"distance_traveled" : 57.9102
} ], 
"2428" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "05:47:00" , 
"departure_time" : "05:48:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "05:53:24" , 
"departure_time" : "05:54:23" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "05:59:59" , 
"departure_time" : "06:00:24" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "06:16:25" , 
"departure_time" : "06:17:47" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "06:21:22" , 
"departure_time" : "06:22:15" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "06:25:53" , 
"departure_time" : "06:26:26" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "06:30:33" , 
"departure_time" : "06:31:07" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "06:43:34" , 
"departure_time" : "06:43:35" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:49:01" , 
"departure_time" : "06:50:08" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:57:07" , 
"departure_time" : "06:57:38" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:09:31" , 
"departure_time" : "07:09:31" , 
"distance_traveled" : 57.9102
} ], 
"2429" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "06:43:00" , 
"departure_time" : "06:45:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "06:50:35" , 
"departure_time" : "06:50:52" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "06:55:17" , 
"departure_time" : "06:56:18" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "07:13:01" , 
"departure_time" : "07:13:47" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "07:16:46" , 
"departure_time" : "07:17:17" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "07:21:31" , 
"departure_time" : "07:22:47" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "07:27:16" , 
"departure_time" : "07:27:47" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "07:39:31" , 
"departure_time" : "07:40:18" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:46:47" , 
"departure_time" : "07:47:57" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:54:10" , 
"departure_time" : "07:55:44" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:08:34" , 
"departure_time" : "08:08:34" , 
"distance_traveled" : 57.9102
} ], 
"2430" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "08:10:00" , 
"departure_time" : "08:13:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "08:17:28" , 
"departure_time" : "08:18:36" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "08:24:08" , 
"departure_time" : "08:24:27" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "08:40:19" , 
"departure_time" : "08:41:31" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "08:46:12" , 
"departure_time" : "08:47:21" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "08:52:09" , 
"departure_time" : "08:52:15" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "08:56:06" , 
"departure_time" : "08:56:48" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:09:42" , 
"departure_time" : "09:10:50" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:17:08" , 
"departure_time" : "09:18:42" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:24:34" , 
"departure_time" : "09:26:07" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:37:33" , 
"departure_time" : "09:37:33" , 
"distance_traveled" : 57.9102
} ], 
"2431" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "07:18:00" , 
"departure_time" : "07:20:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "07:24:59" , 
"departure_time" : "07:26:26" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "07:32:27" , 
"departure_time" : "07:32:33" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "07:48:06" , 
"departure_time" : "07:49:08" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "07:54:02" , 
"departure_time" : "07:54:31" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "07:58:29" , 
"departure_time" : "07:59:38" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "08:04:09" , 
"departure_time" : "08:05:25" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:20:16" , 
"departure_time" : "08:21:02" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:26:46" , 
"departure_time" : "08:27:47" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:34:01" , 
"departure_time" : "08:35:20" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:47:19" , 
"departure_time" : "08:47:19" , 
"distance_traveled" : 57.9102
} ], 
"2432" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "08:18:00" , 
"departure_time" : "08:19:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "08:24:06" , 
"departure_time" : "08:24:51" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "08:31:45" , 
"departure_time" : "08:32:47" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "08:49:02" , 
"departure_time" : "08:49:40" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "08:53:38" , 
"departure_time" : "08:54:21" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "08:58:43" , 
"departure_time" : "09:00:17" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "09:04:34" , 
"departure_time" : "09:05:56" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:22:22" , 
"departure_time" : "09:23:52" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:30:30" , 
"departure_time" : "09:31:48" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:37:18" , 
"departure_time" : "09:37:28" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:48:10" , 
"departure_time" : "09:48:10" , 
"distance_traveled" : 57.9102
} ], 
"2433" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "09:18:00" , 
"departure_time" : "09:18:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "09:24:09" , 
"departure_time" : "09:25:30" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "09:32:21" , 
"departure_time" : "09:32:35" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "09:48:14" , 
"departure_time" : "09:49:29" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "09:54:15" , 
"departure_time" : "09:54:36" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "09:58:21" , 
"departure_time" : "09:58:55" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "10:03:34" , 
"departure_time" : "10:04:39" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:19:05" , 
"departure_time" : "10:20:05" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:25:00" , 
"departure_time" : "10:26:22" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:32:22" , 
"departure_time" : "10:32:38" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:43:16" , 
"departure_time" : "10:43:16" , 
"distance_traveled" : 57.9102
} ], 
"2434" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "11:18:00" , 
"departure_time" : "11:18:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "11:24:05" , 
"departure_time" : "11:24:36" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "11:31:31" , 
"departure_time" : "11:31:59" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "11:48:28" , 
"departure_time" : "11:50:06" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "11:54:38" , 
"departure_time" : "11:54:47" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "11:58:09" , 
"departure_time" : "11:59:49" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "12:04:40" , 
"departure_time" : "12:05:38" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "12:18:58" , 
"departure_time" : "12:19:44" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:25:46" , 
"departure_time" : "12:26:32" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:32:46" , 
"departure_time" : "12:33:00" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "12:44:14" , 
"departure_time" : "12:44:14" , 
"distance_traveled" : 57.9102
} ], 
"2435" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "12:18:00" , 
"departure_time" : "12:18:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "12:24:33" , 
"departure_time" : "12:24:38" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "12:31:05" , 
"departure_time" : "12:31:23" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "12:48:18" , 
"departure_time" : "12:48:54" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "12:53:36" , 
"departure_time" : "12:55:09" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "12:59:33" , 
"departure_time" : "13:00:59" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "13:04:26" , 
"departure_time" : "13:05:04" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:18:38" , 
"departure_time" : "13:19:37" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:24:59" , 
"departure_time" : "13:25:42" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:31:43" , 
"departure_time" : "13:32:41" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "13:44:58" , 
"departure_time" : "13:44:58" , 
"distance_traveled" : 57.9102
} ], 
"2436" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "13:18:00" , 
"departure_time" : "13:19:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "13:25:01" , 
"departure_time" : "13:25:42" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:31:41" , 
"departure_time" : "13:32:15" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "13:48:34" , 
"departure_time" : "13:48:58" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "13:53:24" , 
"departure_time" : "13:53:40" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "13:58:16" , 
"departure_time" : "13:59:56" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "14:04:40" , 
"departure_time" : "14:05:06" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "14:18:26" , 
"departure_time" : "14:19:20" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:24:54" , 
"departure_time" : "14:25:56" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:32:02" , 
"departure_time" : "14:33:28" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "14:45:26" , 
"departure_time" : "14:45:26" , 
"distance_traveled" : 57.9102
} ], 
"2437" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "06:29:00" , 
"departure_time" : "06:32:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "06:36:39" , 
"departure_time" : "06:38:12" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "06:43:33" , 
"departure_time" : "06:44:39" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "06:59:06" , 
"departure_time" : "06:59:35" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "07:02:29" , 
"departure_time" : "07:02:44" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "07:07:15" , 
"departure_time" : "07:08:37" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "07:13:22" , 
"departure_time" : "07:14:55" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "07:26:33" , 
"departure_time" : "07:27:50" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:33:17" , 
"departure_time" : "07:34:08" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:50:51" , 
"departure_time" : "07:50:51" , 
"distance_traveled" : 57.9102
} ], 
"2438" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "15:22:00" , 
"departure_time" : "15:23:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "15:29:46" , 
"departure_time" : "15:30:25" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:36:39" , 
"departure_time" : "15:37:44" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "15:52:05" , 
"departure_time" : "15:52:30" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "15:55:25" , 
"departure_time" : "15:56:26" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "16:02:01" , 
"departure_time" : "16:02:14" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "16:06:13" , 
"departure_time" : "16:07:11" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:20:58" , 
"departure_time" : "16:21:20" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:26:22" , 
"departure_time" : "16:27:28" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:34:06" , 
"departure_time" : "16:34:25" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "16:46:19" , 
"departure_time" : "16:46:19" , 
"distance_traveled" : 57.9102
} ], 
"2439" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "08:10:00" , 
"departure_time" : "08:10:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "08:16:31" , 
"departure_time" : "08:16:46" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "08:23:15" , 
"departure_time" : "08:24:36" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "08:41:21" , 
"departure_time" : "08:42:49" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "08:46:28" , 
"departure_time" : "08:46:50" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "08:51:22" , 
"departure_time" : "08:52:51" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "08:57:29" , 
"departure_time" : "08:58:36" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:10:07" , 
"departure_time" : "09:11:47" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:17:40" , 
"departure_time" : "09:19:07" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:24:27" , 
"departure_time" : "09:25:42" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:37:15" , 
"departure_time" : "09:37:15" , 
"distance_traveled" : 57.9102
} ], 
"2440" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "16:18:00" , 
"departure_time" : "16:19:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "16:24:39" , 
"departure_time" : "16:25:03" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:31:24" , 
"departure_time" : "16:31:54" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "16:48:30" , 
"departure_time" : "16:49:54" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "16:54:24" , 
"departure_time" : "16:55:21" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "16:58:57" , 
"departure_time" : "16:59:02" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "17:03:05" , 
"departure_time" : "17:03:35" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:20:30" , 
"departure_time" : "17:20:50" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:28:20" , 
"departure_time" : "17:29:57" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:38:37" , 
"departure_time" : "17:39:43" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "17:51:06" , 
"departure_time" : "17:51:06" , 
"distance_traveled" : 57.9102
} ], 
"2441" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "17:19:00" , 
"departure_time" : "17:21:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "17:26:15" , 
"departure_time" : "17:27:36" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:33:21" , 
"departure_time" : "17:34:19" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "17:49:58" , 
"departure_time" : "17:50:23" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "17:54:25" , 
"departure_time" : "17:55:29" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "18:00:04" , 
"departure_time" : "18:00:20" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "18:04:16" , 
"departure_time" : "18:04:55" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:18:39" , 
"departure_time" : "18:18:40" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:24:01" , 
"departure_time" : "18:24:34" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:31:33" , 
"departure_time" : "18:32:30" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:44:57" , 
"departure_time" : "18:44:57" , 
"distance_traveled" : 57.9102
} ], 
"2442" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "18:15:00" , 
"departure_time" : "18:16:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "18:21:38" , 
"departure_time" : "18:22:04" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:28:26" , 
"departure_time" : "18:28:48" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "18:45:22" , 
"departure_time" : "18:46:32" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "18:51:10" , 
"departure_time" : "18:51:46" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "18:55:36" , 
"departure_time" : "18:55:43" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "19:00:07" , 
"departure_time" : "19:00:54" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:15:47" , 
"departure_time" : "19:17:07" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:23:20" , 
"departure_time" : "19:24:43" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:30:23" , 
"departure_time" : "19:31:27" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "19:44:04" , 
"departure_time" : "19:44:04" , 
"distance_traveled" : 57.9102
} ], 
"2443" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "05:47:00" , 
"departure_time" : "05:48:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "05:53:20" , 
"departure_time" : "05:53:33" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "05:59:13" , 
"departure_time" : "06:00:17" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "06:17:04" , 
"departure_time" : "06:18:21" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "06:21:17" , 
"departure_time" : "06:22:11" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "06:25:54" , 
"departure_time" : "06:26:42" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "06:30:48" , 
"departure_time" : "06:31:10" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "06:43:22" , 
"departure_time" : "06:43:40" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:49:18" , 
"departure_time" : "06:50:33" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:57:15" , 
"departure_time" : "06:57:51" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:09:36" , 
"departure_time" : "07:09:36" , 
"distance_traveled" : 57.9102
} ], 
"2444" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "10:21:00" , 
"departure_time" : "10:22:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "10:27:52" , 
"departure_time" : "10:29:32" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "10:35:40" , 
"departure_time" : "10:35:51" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "10:50:11" , 
"departure_time" : "10:50:53" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "10:54:42" , 
"departure_time" : "10:55:23" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "10:59:41" , 
"departure_time" : "10:59:58" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "11:04:17" , 
"departure_time" : "11:04:35" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "11:19:18" , 
"departure_time" : "11:19:24" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:26:06" , 
"departure_time" : "11:26:44" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:33:38" , 
"departure_time" : "11:35:03" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "11:47:25" , 
"departure_time" : "11:47:25" , 
"distance_traveled" : 57.9106
} ], 
"2445" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "06:43:00" , 
"departure_time" : "06:45:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "06:50:34" , 
"departure_time" : "06:51:37" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "06:56:03" , 
"departure_time" : "06:57:17" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "07:13:14" , 
"departure_time" : "07:14:29" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "07:17:15" , 
"departure_time" : "07:17:54" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "07:21:39" , 
"departure_time" : "07:22:16" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "07:26:37" , 
"departure_time" : "07:27:06" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "07:39:29" , 
"departure_time" : "07:41:03" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:47:34" , 
"departure_time" : "07:48:09" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:53:35" , 
"departure_time" : "07:54:05" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:07:30" , 
"departure_time" : "08:07:30" , 
"distance_traveled" : 57.9102
} ], 
"2446" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "05:01:00" , 
"departure_time" : "05:02:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "05:08:24" , 
"departure_time" : "05:09:18" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "05:14:54" , 
"departure_time" : "05:15:20" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "05:30:26" , 
"departure_time" : "05:31:28" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "05:35:02" , 
"departure_time" : "05:35:30" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "05:39:28" , 
"departure_time" : "05:39:36" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "05:44:08" , 
"departure_time" : "05:44:18" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "05:51:10" , 
"departure_time" : "05:51:34" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "05:55:24" , 
"departure_time" : "05:55:45" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "06:02:21" , 
"departure_time" : "06:03:41" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "06:08:20" , 
"departure_time" : "06:08:51" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:13:31" , 
"departure_time" : "06:13:49" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:21:18" , 
"departure_time" : "06:22:09" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:35:51" , 
"departure_time" : "06:35:51" , 
"distance_traveled" : 57.91
} ], 
"2447" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "25:11:00" , 
"departure_time" : "25:12:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "25:17:37" , 
"departure_time" : "25:17:53" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "25:24:16" , 
"departure_time" : "25:25:34" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "25:41:18" , 
"departure_time" : "25:42:51" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "25:45:33" , 
"departure_time" : "25:46:55" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "25:50:22" , 
"departure_time" : "25:51:07" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "25:54:45" , 
"departure_time" : "25:55:51" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "26:02:06" , 
"departure_time" : "26:02:22" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "26:05:16" , 
"departure_time" : "26:06:33" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "26:13:17" , 
"departure_time" : "26:14:50" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "26:16:33" , 
"departure_time" : "26:17:01" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "26:19:28" , 
"departure_time" : "26:19:33" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "26:25:05" , 
"departure_time" : "26:25:26" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "26:33:21" , 
"departure_time" : "26:34:16" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "26:46:55" , 
"departure_time" : "26:46:55" , 
"distance_traveled" : 57.9104
} ], 
"2448" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "05:58:00" , 
"departure_time" : "05:58:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "06:04:04" , 
"departure_time" : "06:04:31" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "06:11:27" , 
"departure_time" : "06:12:22" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "06:27:55" , 
"departure_time" : "06:28:58" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "06:32:03" , 
"departure_time" : "06:32:35" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "06:36:32" , 
"departure_time" : "06:37:50" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "06:42:18" , 
"departure_time" : "06:42:36" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "06:48:18" , 
"departure_time" : "06:49:07" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "06:52:49" , 
"departure_time" : "06:53:41" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "06:59:52" , 
"departure_time" : "07:00:50" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "07:04:58" , 
"departure_time" : "07:05:38" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:10:40" , 
"departure_time" : "07:12:06" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:19:26" , 
"departure_time" : "07:20:48" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:36:22" , 
"departure_time" : "07:36:22" , 
"distance_traveled" : 57.91
} ], 
"2449" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "06:58:00" , 
"departure_time" : "06:59:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "07:04:37" , 
"departure_time" : "07:06:08" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "07:12:31" , 
"departure_time" : "07:12:48" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "07:27:17" , 
"departure_time" : "07:28:40" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "07:32:23" , 
"departure_time" : "07:33:16" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "07:36:53" , 
"departure_time" : "07:37:06" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "07:41:13" , 
"departure_time" : "07:42:19" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "07:49:06" , 
"departure_time" : "07:49:31" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "07:52:25" , 
"departure_time" : "07:52:29" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "07:59:04" , 
"departure_time" : "07:59:34" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:04:30" , 
"departure_time" : "08:05:35" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:11:05" , 
"departure_time" : "08:12:25" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:19:20" , 
"departure_time" : "08:19:36" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:32:16" , 
"departure_time" : "08:32:16" , 
"distance_traveled" : 57.91
} ], 
"2450" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "07:18:00" , 
"departure_time" : "07:19:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "07:25:12" , 
"departure_time" : "07:25:13" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "07:31:01" , 
"departure_time" : "07:31:51" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "07:48:50" , 
"departure_time" : "07:49:09" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "07:53:19" , 
"departure_time" : "07:54:19" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "07:59:00" , 
"departure_time" : "07:59:54" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "08:03:54" , 
"departure_time" : "08:05:34" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:20:40" , 
"departure_time" : "08:21:14" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:26:34" , 
"departure_time" : "08:26:51" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:33:17" , 
"departure_time" : "08:33:31" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:46:14" , 
"departure_time" : "08:46:14" , 
"distance_traveled" : 57.9102
} ], 
"2451" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "07:58:00" , 
"departure_time" : "07:59:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "08:05:19" , 
"departure_time" : "08:06:59" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "08:12:40" , 
"departure_time" : "08:14:18" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "08:28:38" , 
"departure_time" : "08:29:43" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "08:32:05" , 
"departure_time" : "08:32:45" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "08:36:40" , 
"departure_time" : "08:37:25" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "08:41:45" , 
"departure_time" : "08:42:50" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:49:05" , 
"departure_time" : "08:50:09" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "08:53:04" , 
"departure_time" : "08:53:10" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "08:59:06" , 
"departure_time" : "08:59:56" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:04:50" , 
"departure_time" : "09:06:00" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:11:10" , 
"departure_time" : "09:12:18" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:19:08" , 
"departure_time" : "09:20:19" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:33:11" , 
"departure_time" : "09:33:11" , 
"distance_traveled" : 57.91
} ], 
"2452" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "08:18:00" , 
"departure_time" : "08:19:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "08:24:24" , 
"departure_time" : "08:24:29" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "08:31:05" , 
"departure_time" : "08:32:37" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "08:49:32" , 
"departure_time" : "08:50:13" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "08:53:41" , 
"departure_time" : "08:53:55" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "08:58:14" , 
"departure_time" : "08:59:21" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "09:04:07" , 
"departure_time" : "09:04:41" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:21:34" , 
"departure_time" : "09:21:46" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:29:12" , 
"departure_time" : "09:29:29" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:36:17" , 
"departure_time" : "09:36:39" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:48:22" , 
"departure_time" : "09:48:22" , 
"distance_traveled" : 57.9102
} ], 
"2453" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "09:00:00" , 
"departure_time" : "09:01:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "09:06:40" , 
"departure_time" : "09:07:21" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "09:13:41" , 
"departure_time" : "09:14:56" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "09:30:15" , 
"departure_time" : "09:31:53" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "09:34:38" , 
"departure_time" : "09:36:14" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "09:39:36" , 
"departure_time" : "09:39:41" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "09:43:05" , 
"departure_time" : "09:44:35" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "09:51:30" , 
"departure_time" : "09:52:37" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "09:55:07" , 
"departure_time" : "09:55:40" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "10:01:33" , 
"departure_time" : "10:01:45" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:06:12" , 
"departure_time" : "10:06:32" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:12:20" , 
"departure_time" : "10:13:55" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:22:35" , 
"departure_time" : "10:23:38" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:35:03" , 
"departure_time" : "10:35:03" , 
"distance_traveled" : 57.91
} ], 
"2454" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "09:18:00" , 
"departure_time" : "09:19:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "09:24:32" , 
"departure_time" : "09:24:49" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "09:31:17" , 
"departure_time" : "09:32:48" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "09:49:31" , 
"departure_time" : "09:49:53" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "09:53:22" , 
"departure_time" : "09:53:23" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "09:58:01" , 
"departure_time" : "09:59:03" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "10:04:02" , 
"departure_time" : "10:05:19" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:19:17" , 
"departure_time" : "10:20:17" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:25:00" , 
"departure_time" : "10:26:26" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:32:26" , 
"departure_time" : "10:33:52" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:44:26" , 
"departure_time" : "10:44:26" , 
"distance_traveled" : 57.9102
} ], 
"2455" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "10:00:00" , 
"departure_time" : "10:01:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "10:06:32" , 
"departure_time" : "10:06:46" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "10:13:14" , 
"departure_time" : "10:14:20" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "10:30:06" , 
"departure_time" : "10:31:08" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "10:34:02" , 
"departure_time" : "10:34:03" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "10:38:01" , 
"departure_time" : "10:39:09" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "10:44:08" , 
"departure_time" : "10:45:33" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "10:51:25" , 
"departure_time" : "10:52:17" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "10:54:52" , 
"departure_time" : "10:56:01" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "11:02:09" , 
"departure_time" : "11:03:22" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "11:07:13" , 
"departure_time" : "11:07:48" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:12:35" , 
"departure_time" : "11:13:16" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:20:41" , 
"departure_time" : "11:22:13" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "11:35:32" , 
"departure_time" : "11:35:32" , 
"distance_traveled" : 57.91
} ], 
"2456" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "11:18:00" , 
"departure_time" : "11:19:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "11:24:08" , 
"departure_time" : "11:25:35" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "11:32:27" , 
"departure_time" : "11:33:53" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "11:49:26" , 
"departure_time" : "11:49:46" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "11:53:20" , 
"departure_time" : "11:54:19" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "11:58:59" , 
"departure_time" : "12:00:07" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "12:04:08" , 
"departure_time" : "12:04:26" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "12:18:18" , 
"departure_time" : "12:18:34" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:25:16" , 
"departure_time" : "12:25:43" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:32:27" , 
"departure_time" : "12:34:03" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "12:45:36" , 
"departure_time" : "12:45:36" , 
"distance_traveled" : 57.9102
} ], 
"2457" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "12:00:00" , 
"departure_time" : "12:03:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "12:07:34" , 
"departure_time" : "12:08:31" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "12:13:57" , 
"departure_time" : "12:15:28" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "12:30:31" , 
"departure_time" : "12:31:33" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "12:34:02" , 
"departure_time" : "12:35:01" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "12:38:59" , 
"departure_time" : "12:40:26" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "12:44:27" , 
"departure_time" : "12:45:48" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "12:51:21" , 
"departure_time" : "12:51:56" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "12:54:35" , 
"departure_time" : "12:55:06" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "13:01:31" , 
"departure_time" : "13:01:46" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:06:15" , 
"departure_time" : "13:07:17" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:13:02" , 
"departure_time" : "13:14:09" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:21:07" , 
"departure_time" : "13:21:25" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "13:34:18" , 
"departure_time" : "13:34:18" , 
"distance_traveled" : 57.91
} ], 
"2458" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "12:18:00" , 
"departure_time" : "12:18:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "12:24:36" , 
"departure_time" : "12:25:27" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "12:31:51" , 
"departure_time" : "12:32:01" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "12:48:10" , 
"departure_time" : "12:48:16" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "12:53:06" , 
"departure_time" : "12:53:41" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "12:58:35" , 
"departure_time" : "12:59:16" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "13:03:41" , 
"departure_time" : "13:04:23" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:18:42" , 
"departure_time" : "13:19:53" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:25:11" , 
"departure_time" : "13:25:50" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:31:39" , 
"departure_time" : "13:32:24" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "13:44:45" , 
"departure_time" : "13:44:45" , 
"distance_traveled" : 57.9102
} ], 
"2459" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "14:58:00" , 
"departure_time" : "14:59:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "15:04:20" , 
"departure_time" : "15:04:51" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:11:31" , 
"departure_time" : "15:13:02" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "15:28:31" , 
"departure_time" : "15:28:46" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "15:31:15" , 
"departure_time" : "15:31:24" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "15:36:09" , 
"departure_time" : "15:37:05" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "15:41:56" , 
"departure_time" : "15:42:52" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "15:48:56" , 
"departure_time" : "15:50:29" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "15:53:33" , 
"departure_time" : "15:54:39" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "16:00:06" , 
"departure_time" : "16:01:11" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:05:05" , 
"departure_time" : "16:05:57" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:10:52" , 
"departure_time" : "16:12:26" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:19:34" , 
"departure_time" : "16:21:01" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "16:34:27" , 
"departure_time" : "16:34:27" , 
"distance_traveled" : 57.91
} ], 
"2460" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "13:18:00" , 
"departure_time" : "13:20:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "13:24:52" , 
"departure_time" : "13:25:17" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:31:25" , 
"departure_time" : "13:32:01" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "13:48:36" , 
"departure_time" : "13:49:53" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "13:54:17" , 
"departure_time" : "13:55:47" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "13:59:30" , 
"departure_time" : "14:00:05" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "14:03:35" , 
"departure_time" : "14:03:51" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "14:18:16" , 
"departure_time" : "14:19:30" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:25:14" , 
"departure_time" : "14:26:32" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:32:18" , 
"departure_time" : "14:33:48" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "14:45:30" , 
"departure_time" : "14:45:30" , 
"distance_traveled" : 57.9102
} ], 
"2461" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "16:02:00" , 
"departure_time" : "16:04:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "16:09:12" , 
"departure_time" : "16:10:42" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:16:30" , 
"departure_time" : "16:16:50" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "16:31:20" , 
"departure_time" : "16:32:01" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "16:35:41" , 
"departure_time" : "16:36:13" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "16:40:32" , 
"departure_time" : "16:41:03" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "16:45:31" , 
"departure_time" : "16:45:55" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "16:52:24" , 
"departure_time" : "16:53:26" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "16:57:02" , 
"departure_time" : "16:58:26" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "17:04:24" , 
"departure_time" : "17:05:32" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:09:08" , 
"departure_time" : "17:09:10" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:15:02" , 
"departure_time" : "17:16:24" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:24:22" , 
"departure_time" : "17:24:52" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "17:36:30" , 
"departure_time" : "17:36:30" , 
"distance_traveled" : 57.91
} ], 
"2462" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "15:22:00" , 
"departure_time" : "15:22:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "15:29:21" , 
"departure_time" : "15:30:09" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:36:48" , 
"departure_time" : "15:37:52" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "15:52:04" , 
"departure_time" : "15:52:08" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "15:55:04" , 
"departure_time" : "15:55:24" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "16:01:20" , 
"departure_time" : "16:01:49" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "16:06:29" , 
"departure_time" : "16:07:52" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:21:23" , 
"departure_time" : "16:21:54" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:26:31" , 
"departure_time" : "16:26:32" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:33:01" , 
"departure_time" : "16:34:28" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "16:47:27" , 
"departure_time" : "16:47:27" , 
"distance_traveled" : 57.9102
} ], 
"2463" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "19:09:00" , 
"departure_time" : "19:11:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "19:15:53" , 
"departure_time" : "19:17:21" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:23:28" , 
"departure_time" : "19:24:37" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "19:40:09" , 
"departure_time" : "19:41:48" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "19:45:39" , 
"departure_time" : "19:45:41" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "19:49:02" , 
"departure_time" : "19:50:23" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "19:55:21" , 
"departure_time" : "19:56:27" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:02:06" , 
"departure_time" : "20:03:00" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "20:05:54" , 
"departure_time" : "20:06:12" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "20:11:18" , 
"departure_time" : "20:12:56" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:17:38" , 
"departure_time" : "20:18:33" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:22:55" , 
"departure_time" : "20:24:12" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:30:17" , 
"departure_time" : "20:30:44" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "20:42:27" , 
"departure_time" : "20:42:27" , 
"distance_traveled" : 57.91
} ], 
"2464" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "16:18:00" , 
"departure_time" : "16:19:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "16:25:19" , 
"departure_time" : "16:26:43" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:32:24" , 
"departure_time" : "16:33:50" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "16:49:26" , 
"departure_time" : "16:49:38" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "16:53:12" , 
"departure_time" : "16:53:38" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "16:58:26" , 
"departure_time" : "16:58:59" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "17:03:33" , 
"departure_time" : "17:04:44" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:21:11" , 
"departure_time" : "17:21:39" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:28:28" , 
"departure_time" : "17:28:47" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:37:19" , 
"departure_time" : "17:38:41" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "17:51:22" , 
"departure_time" : "17:51:22" , 
"distance_traveled" : 57.9102
} ], 
"2465" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "19:56:00" , 
"departure_time" : "19:58:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "20:03:02" , 
"departure_time" : "20:04:20" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "20:10:18" , 
"departure_time" : "20:11:38" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "20:26:20" , 
"departure_time" : "20:27:37" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "20:30:17" , 
"departure_time" : "20:30:48" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "20:34:31" , 
"departure_time" : "20:35:37" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "20:40:06" , 
"departure_time" : "20:40:24" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:47:18" , 
"departure_time" : "20:47:52" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "20:52:34" , 
"departure_time" : "20:54:09" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "21:00:35" , 
"departure_time" : "21:00:54" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "21:04:19" , 
"departure_time" : "21:05:30" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:11:11" , 
"departure_time" : "21:11:16" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:18:05" , 
"departure_time" : "21:19:44" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "21:34:39" , 
"departure_time" : "21:34:39" , 
"distance_traveled" : 57.91
} ], 
"2466" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "17:19:00" , 
"departure_time" : "17:20:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "17:25:07" , 
"departure_time" : "17:26:25" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:33:18" , 
"departure_time" : "17:33:26" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "17:49:08" , 
"departure_time" : "17:50:47" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "17:55:39" , 
"departure_time" : "17:56:51" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "18:00:12" , 
"departure_time" : "18:01:11" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "18:04:59" , 
"departure_time" : "18:05:53" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:18:54" , 
"departure_time" : "18:20:02" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:25:08" , 
"departure_time" : "18:25:33" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:31:25" , 
"departure_time" : "18:32:07" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:44:42" , 
"departure_time" : "18:44:42" , 
"distance_traveled" : 57.9102
} ], 
"2467" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "21:09:00" , 
"departure_time" : "21:09:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "21:15:04" , 
"departure_time" : "21:15:55" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "21:22:51" , 
"departure_time" : "21:23:28" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "21:39:37" , 
"departure_time" : "21:40:46" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "21:45:09" , 
"departure_time" : "21:45:51" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "21:49:42" , 
"departure_time" : "21:50:06" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "21:54:24" , 
"departure_time" : "21:55:36" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "22:02:12" , 
"departure_time" : "22:02:22" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "22:05:10" , 
"departure_time" : "22:05:39" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "22:11:29" , 
"departure_time" : "22:11:40" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:16:11" , 
"departure_time" : "22:17:14" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:23:03" , 
"departure_time" : "22:24:15" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:30:12" , 
"departure_time" : "22:30:38" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "22:42:26" , 
"departure_time" : "22:42:26" , 
"distance_traveled" : 57.91
} ], 
"2468" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "18:15:00" , 
"departure_time" : "18:16:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "18:22:25" , 
"departure_time" : "18:22:52" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:28:27" , 
"departure_time" : "18:29:32" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "18:46:05" , 
"departure_time" : "18:47:00" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "18:50:55" , 
"departure_time" : "18:51:08" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "18:55:13" , 
"departure_time" : "18:56:25" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "19:01:12" , 
"departure_time" : "19:01:56" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:15:44" , 
"departure_time" : "19:17:24" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:23:40" , 
"departure_time" : "19:24:05" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:29:25" , 
"departure_time" : "19:30:33" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "19:44:08" , 
"departure_time" : "19:44:08" , 
"distance_traveled" : 57.9102
} ], 
"2469" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "21:58:00" , 
"departure_time" : "22:00:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "22:05:31" , 
"departure_time" : "22:05:59" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "22:11:28" , 
"departure_time" : "22:11:49" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "22:27:21" , 
"departure_time" : "22:28:33" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "22:32:12" , 
"departure_time" : "22:33:35" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "22:37:23" , 
"departure_time" : "22:37:35" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "22:41:12" , 
"departure_time" : "22:41:36" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "22:48:24" , 
"departure_time" : "22:49:53" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "22:53:29" , 
"departure_time" : "22:54:15" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "22:59:46" , 
"departure_time" : "23:01:04" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "23:05:18" , 
"departure_time" : "23:06:02" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "23:10:44" , 
"departure_time" : "23:11:38" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:17:54" , 
"departure_time" : "23:18:41" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "23:32:47" , 
"departure_time" : "23:32:47" , 
"distance_traveled" : 57.91
} ], 
"2470" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "10:21:00" , 
"departure_time" : "10:22:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "10:27:30" , 
"departure_time" : "10:28:23" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "10:34:53" , 
"departure_time" : "10:35:36" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "10:50:43" , 
"departure_time" : "10:51:16" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "10:54:33" , 
"departure_time" : "10:55:40" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "11:00:07" , 
"departure_time" : "11:01:24" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "11:05:17" , 
"departure_time" : "11:05:19" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "11:19:02" , 
"departure_time" : "11:19:10" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:26:08" , 
"departure_time" : "11:26:57" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:33:49" , 
"departure_time" : "11:35:02" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "11:47:13" , 
"departure_time" : "11:47:13" , 
"distance_traveled" : 57.9106
} ], 
"2471" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "23:58:00" , 
"departure_time" : "24:00:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "24:05:31" , 
"departure_time" : "24:06:38" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "24:12:07" , 
"departure_time" : "24:13:00" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "24:27:53" , 
"departure_time" : "24:29:11" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "24:32:18" , 
"departure_time" : "24:33:15" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "24:36:57" , 
"departure_time" : "24:37:09" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "24:41:12" , 
"departure_time" : "24:42:35" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "24:49:23" , 
"departure_time" : "24:50:55" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "24:53:32" , 
"departure_time" : "24:54:22" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "24:59:50" , 
"departure_time" : "25:00:03" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "25:04:13" , 
"departure_time" : "25:05:22" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "25:11:09" , 
"departure_time" : "25:12:48" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "25:18:39" , 
"departure_time" : "25:19:44" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "25:37:05" , 
"departure_time" : "25:37:05" , 
"distance_traveled" : 57.91
} ], 
"2472" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "05:01:00" , 
"departure_time" : "05:03:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "05:08:08" , 
"departure_time" : "05:09:10" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "05:15:02" , 
"departure_time" : "05:15:07" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "05:30:05" , 
"departure_time" : "05:30:40" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "05:34:35" , 
"departure_time" : "05:35:00" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "05:39:25" , 
"departure_time" : "05:39:46" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "05:44:21" , 
"departure_time" : "05:45:29" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "05:52:08" , 
"departure_time" : "05:53:17" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "05:56:09" , 
"departure_time" : "05:56:15" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "06:02:06" , 
"departure_time" : "06:03:03" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "06:07:57" , 
"departure_time" : "06:08:09" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:13:12" , 
"departure_time" : "06:14:04" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:21:52" , 
"departure_time" : "06:22:26" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:35:34" , 
"departure_time" : "06:35:34" , 
"distance_traveled" : 57.91
} ], 
"2473" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "17:00:00" , 
"departure_time" : "17:01:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "17:07:16" , 
"departure_time" : "17:07:40" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:13:24" , 
"departure_time" : "17:14:54" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "17:30:30" , 
"departure_time" : "17:32:00" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "17:34:30" , 
"departure_time" : "17:34:55" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "17:38:25" , 
"departure_time" : "17:39:54" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "17:44:29" , 
"departure_time" : "17:44:39" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "17:50:10" , 
"departure_time" : "17:50:46" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "17:54:36" , 
"departure_time" : "17:55:58" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "18:02:22" , 
"departure_time" : "18:02:59" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:06:37" , 
"departure_time" : "18:07:38" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:13:01" , 
"departure_time" : "18:13:14" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:20:13" , 
"departure_time" : "18:20:19" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:33:06" , 
"departure_time" : "18:33:06" , 
"distance_traveled" : 57.91
} ], 
"2474" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "05:58:00" , 
"departure_time" : "05:58:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "06:04:26" , 
"departure_time" : "06:04:43" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "06:11:17" , 
"departure_time" : "06:11:23" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "06:27:06" , 
"departure_time" : "06:27:18" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "06:31:12" , 
"departure_time" : "06:32:31" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "06:37:19" , 
"departure_time" : "06:37:30" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "06:41:11" , 
"departure_time" : "06:41:28" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "06:48:17" , 
"departure_time" : "06:49:18" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "06:53:01" , 
"departure_time" : "06:53:32" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "06:59:31" , 
"departure_time" : "07:00:30" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "07:04:59" , 
"departure_time" : "07:06:14" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:11:15" , 
"departure_time" : "07:12:01" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:18:46" , 
"departure_time" : "07:19:30" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:35:44" , 
"departure_time" : "07:35:44" , 
"distance_traveled" : 57.91
} ], 
"2475" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "18:00:00" , 
"departure_time" : "18:02:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "18:07:27" , 
"departure_time" : "18:08:09" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:13:42" , 
"departure_time" : "18:14:33" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "18:29:51" , 
"departure_time" : "18:29:57" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "18:33:06" , 
"departure_time" : "18:34:03" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "18:38:57" , 
"departure_time" : "18:38:58" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "18:43:01" , 
"departure_time" : "18:44:25" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:51:24" , 
"departure_time" : "18:51:26" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "18:54:02" , 
"departure_time" : "18:54:15" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "19:01:13" , 
"departure_time" : "19:01:25" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:06:12" , 
"departure_time" : "19:06:39" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:12:27" , 
"departure_time" : "19:12:30" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:20:03" , 
"departure_time" : "19:20:29" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "19:33:26" , 
"departure_time" : "19:33:26" , 
"distance_traveled" : 57.91
} ], 
"2476" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "06:58:00" , 
"departure_time" : "06:59:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "07:04:42" , 
"departure_time" : "07:05:33" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "07:11:51" , 
"departure_time" : "07:12:48" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "07:27:57" , 
"departure_time" : "07:28:10" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "07:31:13" , 
"departure_time" : "07:31:42" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "07:36:29" , 
"departure_time" : "07:37:08" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "07:41:39" , 
"departure_time" : "07:42:04" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "07:48:25" , 
"departure_time" : "07:49:05" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "07:52:40" , 
"departure_time" : "07:53:29" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "07:59:49" , 
"departure_time" : "08:00:55" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:05:06" , 
"departure_time" : "08:05:31" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:10:25" , 
"departure_time" : "08:10:45" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:18:20" , 
"departure_time" : "08:18:27" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:32:07" , 
"departure_time" : "08:32:07" , 
"distance_traveled" : 57.91
} ], 
"2477" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "10:58:00" , 
"departure_time" : "10:58:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "11:04:30" , 
"departure_time" : "11:06:05" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "11:12:35" , 
"departure_time" : "11:13:01" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "11:27:26" , 
"departure_time" : "11:27:44" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "11:31:18" , 
"departure_time" : "11:32:28" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "11:37:10" , 
"departure_time" : "11:38:11" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "11:42:01" , 
"departure_time" : "11:43:30" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "11:49:29" , 
"departure_time" : "11:51:06" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "11:53:37" , 
"departure_time" : "11:54:22" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "11:59:45" , 
"departure_time" : "12:01:19" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "12:03:34" , 
"departure_time" : "12:04:55" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "12:07:21" , 
"departure_time" : "12:07:44" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:12:23" , 
"departure_time" : "12:13:44" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:21:21" , 
"departure_time" : "12:22:59" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "12:37:38" , 
"departure_time" : "12:37:38" , 
"distance_traveled" : 57.91
} ], 
"2478" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "07:58:00" , 
"departure_time" : "08:00:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "08:05:14" , 
"departure_time" : "08:06:22" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "08:12:08" , 
"departure_time" : "08:12:36" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "08:27:28" , 
"departure_time" : "08:29:01" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "08:32:33" , 
"departure_time" : "08:32:53" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "08:36:20" , 
"departure_time" : "08:36:45" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "08:41:25" , 
"departure_time" : "08:42:34" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:49:09" , 
"departure_time" : "08:49:49" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "08:52:40" , 
"departure_time" : "08:53:32" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "08:59:52" , 
"departure_time" : "08:59:54" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:04:02" , 
"departure_time" : "09:05:32" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:11:30" , 
"departure_time" : "09:12:59" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:19:29" , 
"departure_time" : "09:20:42" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:33:13" , 
"departure_time" : "09:33:13" , 
"distance_traveled" : 57.91
} ], 
"2479" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "13:58:00" , 
"departure_time" : "13:59:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "14:05:27" , 
"departure_time" : "14:06:34" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "14:13:07" , 
"departure_time" : "14:14:44" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "14:28:37" , 
"departure_time" : "14:29:24" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "14:31:47" , 
"departure_time" : "14:33:25" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "14:37:38" , 
"departure_time" : "14:38:29" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "14:41:51" , 
"departure_time" : "14:42:45" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "14:48:54" , 
"departure_time" : "14:49:04" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "14:52:10" , 
"departure_time" : "14:53:04" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "14:59:54" , 
"departure_time" : "15:00:48" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "15:02:54" , 
"departure_time" : "15:02:58" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "15:06:04" , 
"departure_time" : "15:07:03" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:12:59" , 
"departure_time" : "15:14:13" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:21:14" , 
"departure_time" : "15:21:25" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "15:34:11" , 
"departure_time" : "15:34:11" , 
"distance_traveled" : 57.91
} ], 
"2480" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "09:00:00" , 
"departure_time" : "09:00:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "09:06:30" , 
"departure_time" : "09:07:48" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "09:14:18" , 
"departure_time" : "09:15:04" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "09:29:46" , 
"departure_time" : "09:29:51" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "09:33:05" , 
"departure_time" : "09:33:25" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "09:38:20" , 
"departure_time" : "09:38:51" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "09:43:31" , 
"departure_time" : "09:44:08" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "09:50:37" , 
"departure_time" : "09:51:06" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "09:54:29" , 
"departure_time" : "09:55:01" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "10:01:32" , 
"departure_time" : "10:01:45" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:06:13" , 
"departure_time" : "10:06:18" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:12:05" , 
"departure_time" : "10:13:30" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:22:25" , 
"departure_time" : "10:22:32" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:34:07" , 
"departure_time" : "10:34:07" , 
"distance_traveled" : 57.91
} ], 
"2481" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "22:57:00" , 
"departure_time" : "22:58:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "23:05:21" , 
"departure_time" : "23:06:09" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "23:11:48" , 
"departure_time" : "23:12:05" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "23:27:17" , 
"departure_time" : "23:28:38" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "23:32:21" , 
"departure_time" : "23:32:56" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "23:36:35" , 
"departure_time" : "23:38:15" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "23:42:40" , 
"departure_time" : "23:42:44" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "23:48:04" , 
"departure_time" : "23:48:12" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "23:52:08" , 
"departure_time" : "23:52:16" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "23:59:08" , 
"departure_time" : "24:00:09" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "24:03:01" , 
"departure_time" : "24:04:16" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "24:07:15" , 
"departure_time" : "24:08:26" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "24:13:11" , 
"departure_time" : "24:14:32" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:20:21" , 
"departure_time" : "24:21:08" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "24:32:47" , 
"departure_time" : "24:32:47" , 
"distance_traveled" : 57.91
} ], 
"2482" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "10:00:00" , 
"departure_time" : "10:01:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "10:06:47" , 
"departure_time" : "10:08:21" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "10:14:34" , 
"departure_time" : "10:14:38" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "10:29:04" , 
"departure_time" : "10:29:12" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "10:33:08" , 
"departure_time" : "10:33:44" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "10:38:36" , 
"departure_time" : "10:38:40" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "10:43:04" , 
"departure_time" : "10:44:32" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "10:51:28" , 
"departure_time" : "10:51:36" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "10:54:08" , 
"departure_time" : "10:54:51" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "11:01:43" , 
"departure_time" : "11:02:51" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "11:07:08" , 
"departure_time" : "11:08:44" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:13:36" , 
"departure_time" : "11:14:40" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:21:04" , 
"departure_time" : "11:21:47" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "11:34:43" , 
"departure_time" : "11:34:43" , 
"distance_traveled" : 57.91
} ], 
"2483" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "25:11:00" , 
"departure_time" : "25:12:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "25:17:29" , 
"departure_time" : "25:18:36" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "25:25:07" , 
"departure_time" : "25:25:46" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "25:40:39" , 
"departure_time" : "25:41:47" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "25:45:08" , 
"departure_time" : "25:45:20" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "25:49:12" , 
"departure_time" : "25:49:50" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "25:54:38" , 
"departure_time" : "25:55:50" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "26:02:12" , 
"departure_time" : "26:02:51" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "26:05:39" , 
"departure_time" : "26:05:59" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "26:12:20" , 
"departure_time" : "26:13:44" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "26:16:24" , 
"departure_time" : "26:16:26" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "26:19:02" , 
"departure_time" : "26:20:35" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "26:26:33" , 
"departure_time" : "26:27:33" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "26:34:00" , 
"departure_time" : "26:35:33" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "26:47:33" , 
"departure_time" : "26:47:33" , 
"distance_traveled" : 57.9104
} ], 
"2484" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "12:00:00" , 
"departure_time" : "12:01:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "12:06:24" , 
"departure_time" : "12:06:28" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "12:13:04" , 
"departure_time" : "12:14:43" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "12:30:39" , 
"departure_time" : "12:30:57" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "12:33:18" , 
"departure_time" : "12:34:44" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "12:39:26" , 
"departure_time" : "12:40:26" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "12:44:00" , 
"departure_time" : "12:44:53" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "12:50:53" , 
"departure_time" : "12:51:56" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "12:55:03" , 
"departure_time" : "12:56:13" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "13:02:10" , 
"departure_time" : "13:03:15" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:07:05" , 
"departure_time" : "13:07:50" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:12:45" , 
"departure_time" : "13:14:04" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:21:19" , 
"departure_time" : "13:22:18" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "13:34:59" , 
"departure_time" : "13:34:59" , 
"distance_traveled" : 57.91
} ], 
"2485" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "25:11:00" , 
"departure_time" : "25:13:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "25:18:07" , 
"departure_time" : "25:18:28" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "25:24:21" , 
"departure_time" : "25:24:26" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "25:40:05" , 
"departure_time" : "25:40:51" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "25:44:46" , 
"departure_time" : "25:45:13" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "25:49:27" , 
"departure_time" : "25:49:52" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "25:54:25" , 
"departure_time" : "25:55:30" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "26:02:05" , 
"departure_time" : "26:03:07" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "26:06:02" , 
"departure_time" : "26:07:06" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "26:13:04" , 
"departure_time" : "26:13:23" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "26:15:19" , 
"departure_time" : "26:15:33" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "26:19:14" , 
"departure_time" : "26:20:26" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "26:26:12" , 
"departure_time" : "26:27:07" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "26:33:55" , 
"departure_time" : "26:35:27" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "26:47:32" , 
"departure_time" : "26:47:32" , 
"distance_traveled" : 57.9104
} ], 
"2486" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "14:58:00" , 
"departure_time" : "15:00:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "15:04:40" , 
"departure_time" : "15:05:42" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:12:02" , 
"departure_time" : "15:13:11" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "15:28:09" , 
"departure_time" : "15:28:29" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "15:31:20" , 
"departure_time" : "15:31:24" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "15:36:04" , 
"departure_time" : "15:37:23" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "15:42:19" , 
"departure_time" : "15:42:46" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "15:48:27" , 
"departure_time" : "15:49:06" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "15:52:39" , 
"departure_time" : "15:53:26" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "15:59:47" , 
"departure_time" : "16:01:25" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:05:38" , 
"departure_time" : "16:07:16" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:11:38" , 
"departure_time" : "16:12:28" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:18:50" , 
"departure_time" : "16:19:42" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "16:33:52" , 
"departure_time" : "16:33:52" , 
"distance_traveled" : 57.91
} ], 
"2487" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "12:57:00" , 
"departure_time" : "12:58:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "13:03:39" , 
"departure_time" : "13:04:24" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:10:45" , 
"departure_time" : "13:11:09" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "13:26:24" , 
"departure_time" : "13:27:51" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "13:31:27" , 
"departure_time" : "13:32:14" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "13:35:47" , 
"departure_time" : "13:37:09" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "13:41:22" , 
"departure_time" : "13:42:29" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "13:48:07" , 
"departure_time" : "13:48:40" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "13:51:33" , 
"departure_time" : "13:52:57" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "13:59:24" , 
"departure_time" : "14:00:40" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "14:02:16" , 
"departure_time" : "14:03:39" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "14:05:23" , 
"departure_time" : "14:05:51" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:10:28" , 
"departure_time" : "14:10:39" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:18:11" , 
"departure_time" : "14:18:34" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "14:33:23" , 
"departure_time" : "14:33:23" , 
"distance_traveled" : 57.9104
} ], 
"2488" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "16:02:00" , 
"departure_time" : "16:03:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "16:08:46" , 
"departure_time" : "16:09:40" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:15:54" , 
"departure_time" : "16:16:00" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "16:31:06" , 
"departure_time" : "16:31:43" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "16:35:37" , 
"departure_time" : "16:37:13" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "16:41:36" , 
"departure_time" : "16:42:21" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "16:45:45" , 
"departure_time" : "16:47:03" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "16:53:18" , 
"departure_time" : "16:53:47" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "16:56:29" , 
"departure_time" : "16:57:30" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "17:04:01" , 
"departure_time" : "17:05:13" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:09:12" , 
"departure_time" : "17:10:04" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:15:52" , 
"departure_time" : "17:16:20" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:23:28" , 
"departure_time" : "17:24:42" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "17:37:14" , 
"departure_time" : "17:37:14" , 
"distance_traveled" : 57.91
} ], 
"2489" :  [ 
{ 
"stop_id" : 32906,
"arrival_time" : "08:19:00" , 
"departure_time" : "08:21:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 103,
"arrival_time" : "08:27:52" , 
"departure_time" : "08:28:48" , 
"distance_traveled" : 1.8108
}, 
{ 
"stop_id" : 38,
"arrival_time" : "08:32:56" , 
"departure_time" : "08:33:56" , 
"distance_traveled" : 4.1777
}, 
{ 
"stop_id" : 84,
"arrival_time" : "08:38:00" , 
"departure_time" : "08:38:39" , 
"distance_traveled" : 7.2534
}, 
{ 
"stop_id" : 83,
"arrival_time" : "08:42:39" , 
"departure_time" : "08:43:19" , 
"distance_traveled" : 9.857
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:57:40" , 
"departure_time" : "08:59:12" , 
"distance_traveled" : 21.825
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:04:32" , 
"departure_time" : "09:04:55" , 
"distance_traveled" : 24.3032
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:11:23" , 
"departure_time" : "09:11:51" , 
"distance_traveled" : 29.372
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:24:28" , 
"departure_time" : "09:24:28" , 
"distance_traveled" : 34.3604
} ], 
"2490" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "19:09:00" , 
"departure_time" : "19:11:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "19:16:36" , 
"departure_time" : "19:17:38" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:23:02" , 
"departure_time" : "19:24:04" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "19:40:02" , 
"departure_time" : "19:40:49" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "19:44:47" , 
"departure_time" : "19:45:10" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "19:49:23" , 
"departure_time" : "19:49:27" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "19:54:04" , 
"departure_time" : "19:55:23" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:02:19" , 
"departure_time" : "20:02:32" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "20:05:13" , 
"departure_time" : "20:06:09" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "20:11:56" , 
"departure_time" : "20:11:59" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:16:03" , 
"departure_time" : "20:16:11" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:22:08" , 
"departure_time" : "20:23:42" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:30:34" , 
"departure_time" : "20:31:13" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "20:42:39" , 
"departure_time" : "20:42:39" , 
"distance_traveled" : 57.91
} ], 
"2491" :  [ 
{ 
"stop_id" : 32906,
"arrival_time" : "08:40:00" , 
"departure_time" : "08:40:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 103,
"arrival_time" : "08:46:14" , 
"departure_time" : "08:47:28" , 
"distance_traveled" : 1.8108
}, 
{ 
"stop_id" : 38,
"arrival_time" : "08:51:14" , 
"departure_time" : "08:52:35" , 
"distance_traveled" : 4.1777
}, 
{ 
"stop_id" : 84,
"arrival_time" : "08:57:21" , 
"departure_time" : "08:57:32" , 
"distance_traveled" : 7.2534
}, 
{ 
"stop_id" : 83,
"arrival_time" : "09:01:11" , 
"departure_time" : "09:01:37" , 
"distance_traveled" : 9.857
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:15:26" , 
"departure_time" : "09:16:55" , 
"distance_traveled" : 21.825
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:22:29" , 
"departure_time" : "09:23:30" , 
"distance_traveled" : 24.3032
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:30:01" , 
"departure_time" : "09:30:46" , 
"distance_traveled" : 29.372
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:44:45" , 
"departure_time" : "09:44:45" , 
"distance_traveled" : 34.3604
} ], 
"2492" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "19:56:00" , 
"departure_time" : "19:57:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "20:02:47" , 
"departure_time" : "20:04:11" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "20:10:24" , 
"departure_time" : "20:10:48" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "20:25:24" , 
"departure_time" : "20:25:40" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "20:29:16" , 
"departure_time" : "20:30:38" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "20:35:22" , 
"departure_time" : "20:35:41" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "20:39:19" , 
"departure_time" : "20:40:22" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:48:03" , 
"departure_time" : "20:49:07" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "20:53:04" , 
"departure_time" : "20:54:39" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "21:00:35" , 
"departure_time" : "21:01:26" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "21:04:51" , 
"departure_time" : "21:05:51" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:11:00" , 
"departure_time" : "21:11:32" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:18:32" , 
"departure_time" : "21:20:04" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "21:34:32" , 
"departure_time" : "21:34:32" , 
"distance_traveled" : 57.91
} ], 
"2493" :  [ 
{ 
"stop_id" : 32906,
"arrival_time" : "09:00:00" , 
"departure_time" : "09:02:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 103,
"arrival_time" : "09:06:50" , 
"departure_time" : "09:07:15" , 
"distance_traveled" : 1.8108
}, 
{ 
"stop_id" : 38,
"arrival_time" : "09:10:25" , 
"departure_time" : "09:12:02" , 
"distance_traveled" : 4.1777
}, 
{ 
"stop_id" : 84,
"arrival_time" : "09:16:37" , 
"departure_time" : "09:17:02" , 
"distance_traveled" : 7.2534
}, 
{ 
"stop_id" : 83,
"arrival_time" : "09:20:25" , 
"departure_time" : "09:21:52" , 
"distance_traveled" : 9.857
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:35:27" , 
"departure_time" : "09:36:20" , 
"distance_traveled" : 21.825
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:40:53" , 
"departure_time" : "09:41:56" , 
"distance_traveled" : 24.3032
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:48:03" , 
"departure_time" : "09:49:06" , 
"distance_traveled" : 29.372
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:01:03" , 
"departure_time" : "10:01:03" , 
"distance_traveled" : 34.3604
} ], 
"2494" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "21:09:00" , 
"departure_time" : "21:10:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "21:15:46" , 
"departure_time" : "21:16:16" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "21:22:30" , 
"departure_time" : "21:22:41" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "21:39:11" , 
"departure_time" : "21:39:14" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "21:44:03" , 
"departure_time" : "21:44:22" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "21:49:19" , 
"departure_time" : "21:50:32" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "21:55:13" , 
"departure_time" : "21:56:02" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "22:01:49" , 
"departure_time" : "22:02:31" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "22:05:42" , 
"departure_time" : "22:07:02" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "22:12:20" , 
"departure_time" : "22:13:14" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:16:54" , 
"departure_time" : "22:17:37" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:22:43" , 
"departure_time" : "22:24:02" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:30:19" , 
"departure_time" : "22:31:35" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "22:43:16" , 
"departure_time" : "22:43:16" , 
"distance_traveled" : 57.91
} ], 
"2495" :  [ 
{ 
"stop_id" : 103,
"arrival_time" : "15:06:00" , 
"departure_time" : "15:07:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38,
"arrival_time" : "15:11:05" , 
"departure_time" : "15:12:32" , 
"distance_traveled" : 2.3723
}, 
{ 
"stop_id" : 84,
"arrival_time" : "15:17:27" , 
"departure_time" : "15:17:33" , 
"distance_traveled" : 5.4481
}, 
{ 
"stop_id" : 83,
"arrival_time" : "15:20:06" , 
"departure_time" : "15:20:41" , 
"distance_traveled" : 8.0517
}, 
{ 
"stop_id" : 127,
"arrival_time" : "15:27:35" , 
"departure_time" : "15:28:46" , 
"distance_traveled" : 11.8517
}, 
{ 
"stop_id" : 70,
"arrival_time" : "15:32:11" , 
"departure_time" : "15:33:13" , 
"distance_traveled" : 13.9102
}, 
{ 
"stop_id" : 41,
"arrival_time" : "15:39:02" , 
"departure_time" : "15:39:15" , 
"distance_traveled" : 17.1938
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "15:43:13" , 
"departure_time" : "15:43:59" , 
"distance_traveled" : 20.0195
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:49:46" , 
"departure_time" : "15:51:20" , 
"distance_traveled" : 22.4977
}, 
{ 
"stop_id" : 105,
"arrival_time" : "16:08:34" , 
"departure_time" : "16:08:34" , 
"distance_traveled" : 32.5545
} ], 
"2496" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "21:58:00" , 
"departure_time" : "22:00:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "22:05:14" , 
"departure_time" : "22:05:53" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "22:11:39" , 
"departure_time" : "22:13:07" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "22:28:28" , 
"departure_time" : "22:29:03" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "22:31:35" , 
"departure_time" : "22:32:13" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "22:36:38" , 
"departure_time" : "22:36:55" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "22:41:17" , 
"departure_time" : "22:42:04" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "22:48:47" , 
"departure_time" : "22:49:18" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "22:52:31" , 
"departure_time" : "22:53:19" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "22:59:48" , 
"departure_time" : "23:00:58" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "23:05:10" , 
"departure_time" : "23:05:33" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "23:10:23" , 
"departure_time" : "23:11:12" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:17:49" , 
"departure_time" : "23:19:13" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "23:33:24" , 
"departure_time" : "23:33:24" , 
"distance_traveled" : 57.91
} ], 
"2497" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "15:36:00" , 
"departure_time" : "15:38:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "15:42:59" , 
"departure_time" : "15:43:35" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:49:36" , 
"departure_time" : "15:49:58" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "16:05:22" , 
"departure_time" : "16:05:41" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "16:10:19" , 
"departure_time" : "16:10:26" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "16:15:07" , 
"departure_time" : "16:16:36" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "16:20:29" , 
"departure_time" : "16:21:28" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:33:59" , 
"departure_time" : "16:35:09" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:41:10" , 
"departure_time" : "16:41:44" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 105,
"arrival_time" : "16:58:34" , 
"departure_time" : "16:58:34" , 
"distance_traveled" : 57.9102
} ], 
"2498" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "23:58:00" , 
"departure_time" : "23:58:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "24:04:04" , 
"departure_time" : "24:04:57" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "24:11:53" , 
"departure_time" : "24:13:07" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "24:28:14" , 
"departure_time" : "24:29:17" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "24:32:03" , 
"departure_time" : "24:32:29" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "24:36:26" , 
"departure_time" : "24:38:01" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "24:42:35" , 
"departure_time" : "24:43:05" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "24:48:30" , 
"departure_time" : "24:49:23" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "24:52:53" , 
"departure_time" : "24:53:40" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "24:59:47" , 
"departure_time" : "25:00:53" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "25:05:06" , 
"departure_time" : "25:06:14" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "25:11:08" , 
"departure_time" : "25:12:46" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "25:18:38" , 
"departure_time" : "25:19:20" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "25:36:42" , 
"departure_time" : "25:36:42" , 
"distance_traveled" : 57.91
} ], 
"2499" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "04:51:00" , 
"departure_time" : "04:53:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "04:58:35" , 
"departure_time" : "04:59:38" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "05:05:03" , 
"departure_time" : "05:05:46" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "05:18:43" , 
"departure_time" : "05:20:20" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "05:24:37" , 
"departure_time" : "05:25:02" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "05:28:25" , 
"departure_time" : "05:29:30" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "05:33:05" , 
"departure_time" : "05:33:44" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "05:46:39" , 
"departure_time" : "05:48:07" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "05:53:28" , 
"departure_time" : "05:54:49" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:01:21" , 
"departure_time" : "06:01:33" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:14:12" , 
"departure_time" : "06:14:12" , 
"distance_traveled" : 57.9102
} ], 
"2500" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "17:00:00" , 
"departure_time" : "17:00:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "17:06:02" , 
"departure_time" : "17:07:29" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:14:27" , 
"departure_time" : "17:16:01" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "17:30:34" , 
"departure_time" : "17:31:10" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "17:33:36" , 
"departure_time" : "17:34:31" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "17:38:55" , 
"departure_time" : "17:39:43" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "17:43:48" , 
"departure_time" : "17:44:58" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "17:51:10" , 
"departure_time" : "17:52:06" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "17:54:56" , 
"departure_time" : "17:56:22" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "18:02:26" , 
"departure_time" : "18:03:10" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:06:44" , 
"departure_time" : "18:07:03" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:12:19" , 
"departure_time" : "18:12:28" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:20:09" , 
"departure_time" : "18:20:18" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:33:09" , 
"departure_time" : "18:33:09" , 
"distance_traveled" : 57.91
} ], 
"2501" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "16:12:00" , 
"departure_time" : "16:12:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "16:18:31" , 
"departure_time" : "16:18:50" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:25:19" , 
"departure_time" : "16:26:06" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "16:40:47" , 
"departure_time" : "16:41:52" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "16:45:05" , 
"departure_time" : "16:46:10" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "16:50:05" , 
"departure_time" : "16:51:17" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "16:55:12" , 
"departure_time" : "16:55:57" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:10:45" , 
"departure_time" : "17:11:28" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:17:43" , 
"departure_time" : "17:18:39" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:24:56" , 
"departure_time" : "17:26:01" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "17:39:05" , 
"departure_time" : "17:39:05" , 
"distance_traveled" : 57.9102
} ], 
"2502" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "18:00:00" , 
"departure_time" : "18:02:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "18:07:27" , 
"departure_time" : "18:07:48" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:13:21" , 
"departure_time" : "18:14:36" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "18:30:15" , 
"departure_time" : "18:31:09" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "18:33:54" , 
"departure_time" : "18:34:49" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "18:38:55" , 
"departure_time" : "18:40:21" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "18:44:26" , 
"departure_time" : "18:45:37" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:51:11" , 
"departure_time" : "18:52:33" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "18:55:22" , 
"departure_time" : "18:56:09" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "19:01:47" , 
"departure_time" : "19:02:16" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:06:29" , 
"departure_time" : "19:08:09" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:13:40" , 
"departure_time" : "19:14:22" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:20:42" , 
"departure_time" : "19:21:24" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "19:33:42" , 
"departure_time" : "19:33:42" , 
"distance_traveled" : 57.91
} ], 
"2503" :  [ 
{ 
"stop_id" : 32906,
"arrival_time" : "09:31:00" , 
"departure_time" : "09:31:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 103,
"arrival_time" : "09:36:06" , 
"departure_time" : "09:36:55" , 
"distance_traveled" : 1.8108
}, 
{ 
"stop_id" : 38,
"arrival_time" : "09:40:49" , 
"departure_time" : "09:41:48" , 
"distance_traveled" : 4.1777
}, 
{ 
"stop_id" : 84,
"arrival_time" : "09:45:59" , 
"departure_time" : "09:46:11" , 
"distance_traveled" : 7.2534
}, 
{ 
"stop_id" : 83,
"arrival_time" : "09:50:12" , 
"departure_time" : "09:51:12" , 
"distance_traveled" : 9.857
}, 
{ 
"stop_id" : 127,
"arrival_time" : "09:57:00" , 
"departure_time" : "09:57:49" , 
"distance_traveled" : 13.657
}, 
{ 
"stop_id" : 70,
"arrival_time" : "10:00:49" , 
"departure_time" : "10:01:50" , 
"distance_traveled" : 15.7155
}, 
{ 
"stop_id" : 41,
"arrival_time" : "10:08:01" , 
"departure_time" : "10:08:40" , 
"distance_traveled" : 18.9991
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:12:39" , 
"departure_time" : "10:12:59" , 
"distance_traveled" : 21.8248
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:18:20" , 
"departure_time" : "10:18:39" , 
"distance_traveled" : 24.303
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:25:19" , 
"departure_time" : "10:26:51" , 
"distance_traveled" : 29.3718
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:39:32" , 
"departure_time" : "10:39:32" , 
"distance_traveled" : 34.3598
} ], 
"2504" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "10:58:00" , 
"departure_time" : "11:00:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "11:05:19" , 
"departure_time" : "11:06:54" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "11:12:35" , 
"departure_time" : "11:13:37" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "11:28:02" , 
"departure_time" : "11:29:25" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "11:32:23" , 
"departure_time" : "11:33:19" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "11:36:56" , 
"departure_time" : "11:37:33" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "11:41:37" , 
"departure_time" : "11:41:51" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "11:48:14" , 
"departure_time" : "11:48:46" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "11:52:32" , 
"departure_time" : "11:52:55" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "11:59:23" , 
"departure_time" : "11:59:42" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "12:02:19" , 
"departure_time" : "12:03:13" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "12:06:54" , 
"departure_time" : "12:07:07" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:12:13" , 
"departure_time" : "12:12:46" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:20:33" , 
"departure_time" : "12:20:43" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "12:36:10" , 
"departure_time" : "12:36:10" , 
"distance_traveled" : 57.91
} ], 
"2505" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "07:23:00" , 
"departure_time" : "07:24:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "07:30:13" , 
"departure_time" : "07:30:34" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "07:36:21" , 
"departure_time" : "07:36:52" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "07:54:31" , 
"departure_time" : "07:56:02" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "08:00:31" , 
"departure_time" : "08:01:53" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "08:05:22" , 
"departure_time" : "08:06:04" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "08:09:42" , 
"departure_time" : "08:09:50" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:23:08" , 
"departure_time" : "08:24:09" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:29:01" , 
"departure_time" : "08:29:54" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:38:53" , 
"departure_time" : "08:39:41" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:51:48" , 
"departure_time" : "08:51:48" , 
"distance_traveled" : 57.9102
} ], 
"2506" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "13:58:00" , 
"departure_time" : "13:59:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "14:05:49" , 
"departure_time" : "14:06:05" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "14:12:16" , 
"departure_time" : "14:13:30" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "14:28:14" , 
"departure_time" : "14:29:41" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "14:32:27" , 
"departure_time" : "14:32:42" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "14:36:15" , 
"departure_time" : "14:37:18" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "14:42:03" , 
"departure_time" : "14:42:20" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "14:48:17" , 
"departure_time" : "14:48:29" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "14:52:12" , 
"departure_time" : "14:53:49" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "15:00:37" , 
"departure_time" : "15:01:48" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "15:03:11" , 
"departure_time" : "15:04:18" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "15:07:07" , 
"departure_time" : "15:08:34" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:13:27" , 
"departure_time" : "15:13:46" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:20:19" , 
"departure_time" : "15:21:20" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "15:35:01" , 
"departure_time" : "15:35:01" , 
"distance_traveled" : 57.91
} ], 
"2507" :  [ 
{ 
"stop_id" : 103,
"arrival_time" : "16:58:00" , 
"departure_time" : "16:59:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38,
"arrival_time" : "17:02:19" , 
"departure_time" : "17:03:15" , 
"distance_traveled" : 2.3723
}, 
{ 
"stop_id" : 84,
"arrival_time" : "17:07:56" , 
"departure_time" : "17:08:25" , 
"distance_traveled" : 5.4481
}, 
{ 
"stop_id" : 83,
"arrival_time" : "17:12:29" , 
"departure_time" : "17:12:31" , 
"distance_traveled" : 8.0517
}, 
{ 
"stop_id" : 127,
"arrival_time" : "17:19:02" , 
"departure_time" : "17:19:46" , 
"distance_traveled" : 11.8517
}, 
{ 
"stop_id" : 70,
"arrival_time" : "17:23:44" , 
"departure_time" : "17:24:24" , 
"distance_traveled" : 13.9102
}, 
{ 
"stop_id" : 41,
"arrival_time" : "17:30:40" , 
"departure_time" : "17:31:08" , 
"distance_traveled" : 17.1938
}, 
{ 
"stop_id" : 109,
"arrival_time" : "17:33:28" , 
"departure_time" : "17:33:40" , 
"distance_traveled" : 18.1695
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:37:12" , 
"departure_time" : "17:37:17" , 
"distance_traveled" : 20.0195
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:44:05" , 
"departure_time" : "17:45:24" , 
"distance_traveled" : 22.4977
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:52:19" , 
"departure_time" : "17:52:48" , 
"distance_traveled" : 27.5665
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:04:29" , 
"departure_time" : "18:04:29" , 
"distance_traveled" : 32.5545
} ], 
"2508" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "22:57:00" , 
"departure_time" : "22:58:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "23:04:49" , 
"departure_time" : "23:05:38" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "23:11:49" , 
"departure_time" : "23:13:16" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "23:28:27" , 
"departure_time" : "23:29:29" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "23:32:02" , 
"departure_time" : "23:32:55" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "23:36:53" , 
"departure_time" : "23:37:31" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "23:41:38" , 
"departure_time" : "23:41:48" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "23:48:10" , 
"departure_time" : "23:49:02" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "23:52:52" , 
"departure_time" : "23:53:24" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "23:59:32" , 
"departure_time" : "23:59:45" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "24:02:13" , 
"departure_time" : "24:02:31" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "24:06:18" , 
"departure_time" : "24:07:38" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "24:13:20" , 
"departure_time" : "24:13:50" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:19:30" , 
"departure_time" : "24:20:36" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "24:33:06" , 
"departure_time" : "24:33:06" , 
"distance_traveled" : 57.91
} ], 
"2509" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "09:51:00" , 
"departure_time" : "09:52:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "09:57:47" , 
"departure_time" : "09:58:09" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "10:04:22" , 
"departure_time" : "10:05:43" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "10:19:21" , 
"departure_time" : "10:20:32" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "10:24:11" , 
"departure_time" : "10:24:46" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "10:28:35" , 
"departure_time" : "10:29:59" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "10:33:24" , 
"departure_time" : "10:33:45" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "10:39:21" , 
"departure_time" : "10:40:32" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:51:11" , 
"departure_time" : "10:52:15" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:57:04" , 
"departure_time" : "10:57:09" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:03:05" , 
"departure_time" : "11:04:45" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "11:17:40" , 
"departure_time" : "11:17:40" , 
"distance_traveled" : 57.91
} ], 
"2510" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "12:57:00" , 
"departure_time" : "12:59:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "13:04:18" , 
"departure_time" : "13:05:32" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:11:14" , 
"departure_time" : "13:11:58" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "13:26:44" , 
"departure_time" : "13:28:23" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "13:31:39" , 
"departure_time" : "13:31:58" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "13:35:19" , 
"departure_time" : "13:35:57" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "13:40:38" , 
"departure_time" : "13:40:49" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "13:47:11" , 
"departure_time" : "13:48:51" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "13:52:40" , 
"departure_time" : "13:53:37" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "13:58:57" , 
"departure_time" : "14:00:12" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "14:02:15" , 
"departure_time" : "14:03:09" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "14:04:54" , 
"departure_time" : "14:05:14" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:10:20" , 
"departure_time" : "14:12:00" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:19:40" , 
"departure_time" : "14:21:16" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "14:34:36" , 
"departure_time" : "14:34:36" , 
"distance_traveled" : 57.9104
} ], 
"2511" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "16:41:00" , 
"departure_time" : "16:44:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "16:48:29" , 
"departure_time" : "16:50:06" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:55:37" , 
"departure_time" : "16:56:53" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "17:11:16" , 
"departure_time" : "17:12:29" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "17:16:13" , 
"departure_time" : "17:17:45" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "17:21:32" , 
"departure_time" : "17:22:48" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "17:26:16" , 
"departure_time" : "17:26:20" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "17:31:04" , 
"departure_time" : "17:31:57" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:42:53" , 
"departure_time" : "17:44:03" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:50:10" , 
"departure_time" : "17:51:46" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:57:36" , 
"departure_time" : "17:57:58" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:09:22" , 
"departure_time" : "18:09:22" , 
"distance_traveled" : 57.91
} ], 
"2512" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "06:23:00" , 
"departure_time" : "06:24:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "06:30:58" , 
"departure_time" : "06:32:26" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "06:38:28" , 
"departure_time" : "06:39:20" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:12:52" , 
"departure_time" : "07:14:22" , 
"distance_traveled" : 47.8536
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:20:30" , 
"departure_time" : "07:21:51" , 
"distance_traveled" : 52.9225
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:35:21" , 
"departure_time" : "07:35:21" , 
"distance_traveled" : 57.911
} ], 
"2513" :  [ 
{ 
"stop_id" : 32906,
"arrival_time" : "05:00:00" , 
"departure_time" : "05:02:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 103,
"arrival_time" : "05:05:45" , 
"departure_time" : "05:05:57" , 
"distance_traveled" : 1.8108
}, 
{ 
"stop_id" : 38,
"arrival_time" : "05:09:12" , 
"departure_time" : "05:09:56" , 
"distance_traveled" : 4.1777
}, 
{ 
"stop_id" : 84,
"arrival_time" : "05:14:44" , 
"departure_time" : "05:15:34" , 
"distance_traveled" : 7.2534
}, 
{ 
"stop_id" : 83,
"arrival_time" : "05:19:50" , 
"departure_time" : "05:21:08" , 
"distance_traveled" : 9.857
}, 
{ 
"stop_id" : 127,
"arrival_time" : "05:26:18" , 
"departure_time" : "05:26:23" , 
"distance_traveled" : 13.657
}, 
{ 
"stop_id" : 70,
"arrival_time" : "05:29:05" , 
"departure_time" : "05:29:11" , 
"distance_traveled" : 15.7155
}, 
{ 
"stop_id" : 41,
"arrival_time" : "05:35:06" , 
"departure_time" : "05:35:18" , 
"distance_traveled" : 18.9991
}, 
{ 
"stop_id" : 109,
"arrival_time" : "05:38:12" , 
"departure_time" : "05:38:20" , 
"distance_traveled" : 19.9748
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "05:41:08" , 
"departure_time" : "05:41:27" , 
"distance_traveled" : 21.8248
}, 
{ 
"stop_id" : 107,
"arrival_time" : "05:47:19" , 
"departure_time" : "05:48:25" , 
"distance_traveled" : 24.303
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:55:06" , 
"departure_time" : "05:56:34" , 
"distance_traveled" : 29.3718
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:08:28" , 
"departure_time" : "06:08:28" , 
"distance_traveled" : 34.3598
} ], 
"2514" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "06:59:00" , 
"departure_time" : "07:01:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "07:07:18" , 
"departure_time" : "07:07:29" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "07:13:11" , 
"departure_time" : "07:14:35" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:52:24" , 
"departure_time" : "07:52:41" , 
"distance_traveled" : 47.8536
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:59:17" , 
"departure_time" : "08:00:30" , 
"distance_traveled" : 52.9225
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:14:13" , 
"departure_time" : "08:14:13" , 
"distance_traveled" : 57.911
} ], 
"2515" :  [ 
{ 
"stop_id" : 32906,
"arrival_time" : "05:19:00" , 
"departure_time" : "05:21:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 103,
"arrival_time" : "05:27:53" , 
"departure_time" : "05:28:07" , 
"distance_traveled" : 1.8108
}, 
{ 
"stop_id" : 38,
"arrival_time" : "05:31:14" , 
"departure_time" : "05:32:10" , 
"distance_traveled" : 4.1777
}, 
{ 
"stop_id" : 84,
"arrival_time" : "05:36:56" , 
"departure_time" : "05:37:22" , 
"distance_traveled" : 7.2534
}, 
{ 
"stop_id" : 83,
"arrival_time" : "05:40:26" , 
"departure_time" : "05:41:16" , 
"distance_traveled" : 9.857
}, 
{ 
"stop_id" : 127,
"arrival_time" : "05:48:50" , 
"departure_time" : "05:49:14" , 
"distance_traveled" : 13.657
}, 
{ 
"stop_id" : 70,
"arrival_time" : "05:53:24" , 
"departure_time" : "05:55:02" , 
"distance_traveled" : 15.7155
}, 
{ 
"stop_id" : 41,
"arrival_time" : "06:00:38" , 
"departure_time" : "06:02:10" , 
"distance_traveled" : 18.9991
}, 
{ 
"stop_id" : 109,
"arrival_time" : "06:03:32" , 
"departure_time" : "06:05:12" , 
"distance_traveled" : 19.9748
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "06:06:40" , 
"departure_time" : "06:07:47" , 
"distance_traveled" : 21.8248
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:13:07" , 
"departure_time" : "06:14:20" , 
"distance_traveled" : 24.303
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:21:13" , 
"departure_time" : "06:22:48" , 
"distance_traveled" : 29.3718
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:34:35" , 
"departure_time" : "06:34:35" , 
"distance_traveled" : 34.3598
} ], 
"2516" :  [ 
{ 
"stop_id" : 32906,
"arrival_time" : "08:19:00" , 
"departure_time" : "08:21:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 103,
"arrival_time" : "08:27:54" , 
"departure_time" : "08:27:56" , 
"distance_traveled" : 1.8108
}, 
{ 
"stop_id" : 38,
"arrival_time" : "08:32:02" , 
"departure_time" : "08:33:10" , 
"distance_traveled" : 4.1777
}, 
{ 
"stop_id" : 84,
"arrival_time" : "08:38:08" , 
"departure_time" : "08:39:13" , 
"distance_traveled" : 7.2534
}, 
{ 
"stop_id" : 83,
"arrival_time" : "08:43:05" , 
"departure_time" : "08:43:09" , 
"distance_traveled" : 9.857
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:57:04" , 
"departure_time" : "08:58:08" , 
"distance_traveled" : 21.825
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:04:04" , 
"departure_time" : "09:04:17" , 
"distance_traveled" : 24.3032
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:11:13" , 
"departure_time" : "09:11:23" , 
"distance_traveled" : 29.372
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:24:10" , 
"departure_time" : "09:24:10" , 
"distance_traveled" : 34.3604
} ], 
"2517" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "05:21:00" , 
"departure_time" : "05:21:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "05:27:02" , 
"departure_time" : "05:27:22" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "05:34:20" , 
"departure_time" : "05:35:43" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "05:50:23" , 
"departure_time" : "05:51:44" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "05:54:21" , 
"departure_time" : "05:54:45" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "05:58:24" , 
"departure_time" : "05:59:25" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "06:04:01" , 
"departure_time" : "06:05:13" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "06:12:12" , 
"departure_time" : "06:12:37" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "06:16:25" , 
"departure_time" : "06:16:56" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "06:22:31" , 
"departure_time" : "06:22:40" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "06:25:09" , 
"departure_time" : "06:25:17" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "06:29:08" , 
"departure_time" : "06:29:23" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:35:15" , 
"departure_time" : "06:36:54" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:54:39" , 
"departure_time" : "06:54:39" , 
"distance_traveled" : 57.91
} ], 
"2518" :  [ 
{ 
"stop_id" : 32906,
"arrival_time" : "08:40:00" , 
"departure_time" : "08:43:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 103,
"arrival_time" : "08:47:35" , 
"departure_time" : "08:48:20" , 
"distance_traveled" : 1.8108
}, 
{ 
"stop_id" : 38,
"arrival_time" : "08:50:45" , 
"departure_time" : "08:51:12" , 
"distance_traveled" : 4.1777
}, 
{ 
"stop_id" : 84,
"arrival_time" : "08:56:27" , 
"departure_time" : "08:56:55" , 
"distance_traveled" : 7.2534
}, 
{ 
"stop_id" : 83,
"arrival_time" : "09:01:28" , 
"departure_time" : "09:02:00" , 
"distance_traveled" : 9.857
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:15:32" , 
"departure_time" : "09:17:06" , 
"distance_traveled" : 21.825
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:22:34" , 
"departure_time" : "09:23:34" , 
"distance_traveled" : 24.3032
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:30:00" , 
"departure_time" : "09:31:25" , 
"distance_traveled" : 29.372
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:45:25" , 
"departure_time" : "09:45:25" , 
"distance_traveled" : 34.3604
} ], 
"2519" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "17:27:00" , 
"departure_time" : "17:29:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "17:33:38" , 
"departure_time" : "17:35:11" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:41:33" , 
"departure_time" : "17:42:52" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "17:55:19" , 
"departure_time" : "17:55:22" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "17:58:03" , 
"departure_time" : "17:59:28" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "18:04:25" , 
"departure_time" : "18:04:50" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "18:08:25" , 
"departure_time" : "18:08:56" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:15:31" , 
"departure_time" : "18:15:34" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "18:19:03" , 
"departure_time" : "18:19:13" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "18:26:10" , 
"departure_time" : "18:26:56" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "18:29:46" , 
"departure_time" : "18:30:55" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:33:09" , 
"departure_time" : "18:33:46" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:38:37" , 
"departure_time" : "18:39:28" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:56:51" , 
"departure_time" : "18:56:51" , 
"distance_traveled" : 57.91
} ], 
"2520" :  [ 
{ 
"stop_id" : 32906,
"arrival_time" : "09:00:00" , 
"departure_time" : "09:02:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 103,
"arrival_time" : "09:07:28" , 
"departure_time" : "09:07:41" , 
"distance_traveled" : 1.8108
}, 
{ 
"stop_id" : 38,
"arrival_time" : "09:10:13" , 
"departure_time" : "09:10:53" , 
"distance_traveled" : 4.1777
}, 
{ 
"stop_id" : 84,
"arrival_time" : "09:15:40" , 
"departure_time" : "09:17:06" , 
"distance_traveled" : 7.2534
}, 
{ 
"stop_id" : 83,
"arrival_time" : "09:21:26" , 
"departure_time" : "09:21:43" , 
"distance_traveled" : 9.857
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:34:17" , 
"departure_time" : "09:34:41" , 
"distance_traveled" : 21.825
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:40:24" , 
"departure_time" : "09:41:53" , 
"distance_traveled" : 24.3032
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:48:29" , 
"departure_time" : "09:49:48" , 
"distance_traveled" : 29.372
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:01:19" , 
"departure_time" : "10:01:19" , 
"distance_traveled" : 34.3604
} ], 
"2521" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "10:41:00" , 
"departure_time" : "10:42:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "10:47:22" , 
"departure_time" : "10:48:03" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "10:54:41" , 
"departure_time" : "10:55:08" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "11:09:27" , 
"departure_time" : "11:09:44" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "11:14:17" , 
"departure_time" : "11:14:49" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "11:19:32" , 
"departure_time" : "11:20:39" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "11:25:07" , 
"departure_time" : "11:25:54" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "11:31:47" , 
"departure_time" : "11:32:17" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "11:36:30" , 
"departure_time" : "11:37:50" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "11:44:20" , 
"departure_time" : "11:45:52" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "11:49:32" , 
"departure_time" : "11:50:01" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:55:29" , 
"departure_time" : "11:56:54" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:03:25" , 
"departure_time" : "12:03:32" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "12:17:07" , 
"departure_time" : "12:17:07" , 
"distance_traveled" : 57.91
} ], 
"2522" :  [ 
{ 
"stop_id" : 103,
"arrival_time" : "15:06:00" , 
"departure_time" : "15:07:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38,
"arrival_time" : "15:12:13" , 
"departure_time" : "15:13:50" , 
"distance_traveled" : 2.3723
}, 
{ 
"stop_id" : 84,
"arrival_time" : "15:17:37" , 
"departure_time" : "15:18:19" , 
"distance_traveled" : 5.4481
}, 
{ 
"stop_id" : 83,
"arrival_time" : "15:20:42" , 
"departure_time" : "15:21:58" , 
"distance_traveled" : 8.0517
}, 
{ 
"stop_id" : 127,
"arrival_time" : "15:28:16" , 
"departure_time" : "15:28:54" , 
"distance_traveled" : 11.8517
}, 
{ 
"stop_id" : 70,
"arrival_time" : "15:31:38" , 
"departure_time" : "15:32:35" , 
"distance_traveled" : 13.9102
}, 
{ 
"stop_id" : 41,
"arrival_time" : "15:38:57" , 
"departure_time" : "15:39:05" , 
"distance_traveled" : 17.1938
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "15:43:08" , 
"departure_time" : "15:44:19" , 
"distance_traveled" : 20.0195
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:50:11" , 
"departure_time" : "15:51:23" , 
"distance_traveled" : 22.4977
}, 
{ 
"stop_id" : 105,
"arrival_time" : "16:08:12" , 
"departure_time" : "16:08:12" , 
"distance_traveled" : 32.5545
} ], 
"2523" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "11:28:00" , 
"departure_time" : "11:29:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "11:34:16" , 
"departure_time" : "11:34:33" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "11:41:17" , 
"departure_time" : "11:42:37" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "11:57:20" , 
"departure_time" : "11:58:30" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "12:02:10" , 
"departure_time" : "12:03:35" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "12:07:25" , 
"departure_time" : "12:07:43" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "12:11:18" , 
"departure_time" : "12:11:58" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "12:18:40" , 
"departure_time" : "12:19:46" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "12:23:06" , 
"departure_time" : "12:23:34" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "12:29:28" , 
"departure_time" : "12:30:18" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "12:34:50" , 
"departure_time" : "12:35:34" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:40:44" , 
"departure_time" : "12:41:14" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:47:30" , 
"departure_time" : "12:48:33" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "13:02:03" , 
"departure_time" : "13:02:03" , 
"distance_traveled" : 57.91
} ], 
"2524" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "15:36:00" , 
"departure_time" : "15:37:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "15:42:42" , 
"departure_time" : "15:43:48" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:50:06" , 
"departure_time" : "15:50:11" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "16:05:05" , 
"departure_time" : "16:06:43" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "16:11:38" , 
"departure_time" : "16:11:53" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "16:15:15" , 
"departure_time" : "16:15:22" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "16:19:07" , 
"departure_time" : "16:19:37" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:33:30" , 
"departure_time" : "16:34:42" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:41:12" , 
"departure_time" : "16:42:46" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 105,
"arrival_time" : "16:59:34" , 
"departure_time" : "16:59:34" , 
"distance_traveled" : 57.9102
} ], 
"2525" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "12:52:00" , 
"departure_time" : "12:54:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "12:58:51" , 
"departure_time" : "12:59:18" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:05:27" , 
"departure_time" : "13:05:42" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "13:20:15" , 
"departure_time" : "13:21:15" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "13:25:00" , 
"departure_time" : "13:25:36" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "13:29:36" , 
"departure_time" : "13:31:04" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "13:35:28" , 
"departure_time" : "13:35:41" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "13:40:13" , 
"departure_time" : "13:41:45" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "13:45:32" , 
"departure_time" : "13:47:02" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "13:52:30" , 
"departure_time" : "13:52:57" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:55:27" , 
"departure_time" : "13:56:32" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:02:05" , 
"departure_time" : "14:02:32" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:09:27" , 
"departure_time" : "14:10:46" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "14:25:19" , 
"departure_time" : "14:25:19" , 
"distance_traveled" : 57.91
} ], 
"2526" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "04:51:00" , 
"departure_time" : "04:53:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "04:57:47" , 
"departure_time" : "04:57:56" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "05:04:09" , 
"departure_time" : "05:04:53" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "05:18:44" , 
"departure_time" : "05:19:50" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "05:24:06" , 
"departure_time" : "05:24:31" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "05:28:25" , 
"departure_time" : "05:29:59" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "05:33:34" , 
"departure_time" : "05:34:25" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "05:46:51" , 
"departure_time" : "05:47:51" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "05:53:00" , 
"departure_time" : "05:54:14" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:01:14" , 
"departure_time" : "06:02:36" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:15:22" , 
"departure_time" : "06:15:22" , 
"distance_traveled" : 57.9102
} ], 
"2527" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "13:44:00" , 
"departure_time" : "13:45:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "13:50:26" , 
"departure_time" : "13:51:30" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:58:04" , 
"departure_time" : "13:59:39" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "14:12:35" , 
"departure_time" : "14:12:51" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "14:16:16" , 
"departure_time" : "14:16:43" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "14:21:27" , 
"departure_time" : "14:23:01" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "14:26:34" , 
"departure_time" : "14:27:58" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "14:33:24" , 
"departure_time" : "14:34:26" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "14:37:02" , 
"departure_time" : "14:38:37" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "14:44:35" , 
"departure_time" : "14:45:40" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "14:49:05" , 
"departure_time" : "14:49:33" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:54:28" , 
"departure_time" : "14:54:54" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:02:26" , 
"departure_time" : "15:02:53" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "15:15:27" , 
"departure_time" : "15:15:27" , 
"distance_traveled" : 57.91
} ], 
"2528" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "16:12:00" , 
"departure_time" : "16:13:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "16:19:26" , 
"departure_time" : "16:19:55" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:25:29" , 
"departure_time" : "16:26:08" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "16:40:39" , 
"departure_time" : "16:41:11" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "16:44:32" , 
"departure_time" : "16:45:41" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "16:50:09" , 
"departure_time" : "16:50:21" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "16:54:12" , 
"departure_time" : "16:54:20" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:10:08" , 
"departure_time" : "17:10:19" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:17:11" , 
"departure_time" : "17:18:35" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:25:24" , 
"departure_time" : "17:26:32" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "17:39:08" , 
"departure_time" : "17:39:08" , 
"distance_traveled" : 57.9102
} ], 
"2529" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "16:03:00" , 
"departure_time" : "16:04:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "16:09:15" , 
"departure_time" : "16:09:23" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:16:08" , 
"departure_time" : "16:17:02" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "16:31:54" , 
"departure_time" : "16:33:04" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "16:36:10" , 
"departure_time" : "16:36:28" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "16:40:18" , 
"departure_time" : "16:40:55" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "16:45:37" , 
"departure_time" : "16:46:19" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "16:52:42" , 
"departure_time" : "16:53:40" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "16:56:58" , 
"departure_time" : "16:57:17" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "17:02:19" , 
"departure_time" : "17:02:26" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:07:07" , 
"departure_time" : "17:07:42" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:14:35" , 
"departure_time" : "17:15:41" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:23:06" , 
"departure_time" : "17:23:58" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "17:35:52" , 
"departure_time" : "17:35:52" , 
"distance_traveled" : 57.91
} ], 
"2530" :  [ 
{ 
"stop_id" : 32906,
"arrival_time" : "09:31:00" , 
"departure_time" : "09:32:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 103,
"arrival_time" : "09:36:46" , 
"departure_time" : "09:37:03" , 
"distance_traveled" : 1.8108
}, 
{ 
"stop_id" : 38,
"arrival_time" : "09:40:17" , 
"departure_time" : "09:40:20" , 
"distance_traveled" : 4.1777
}, 
{ 
"stop_id" : 84,
"arrival_time" : "09:45:03" , 
"departure_time" : "09:45:56" , 
"distance_traveled" : 7.2534
}, 
{ 
"stop_id" : 83,
"arrival_time" : "09:50:53" , 
"departure_time" : "09:52:18" , 
"distance_traveled" : 9.857
}, 
{ 
"stop_id" : 127,
"arrival_time" : "09:57:25" , 
"departure_time" : "09:58:36" , 
"distance_traveled" : 13.657
}, 
{ 
"stop_id" : 70,
"arrival_time" : "10:01:11" , 
"departure_time" : "10:01:18" , 
"distance_traveled" : 15.7155
}, 
{ 
"stop_id" : 41,
"arrival_time" : "10:07:07" , 
"departure_time" : "10:08:44" , 
"distance_traveled" : 18.9991
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:13:37" , 
"departure_time" : "10:14:25" , 
"distance_traveled" : 21.8248
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:18:48" , 
"departure_time" : "10:19:00" , 
"distance_traveled" : 24.303
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:25:12" , 
"departure_time" : "10:25:37" , 
"distance_traveled" : 29.3718
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:38:25" , 
"departure_time" : "10:38:25" , 
"distance_traveled" : 34.3598
} ], 
"2531" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "18:08:00" , 
"departure_time" : "18:09:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "18:15:30" , 
"departure_time" : "18:16:32" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:22:02" , 
"departure_time" : "18:22:24" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "18:35:22" , 
"departure_time" : "18:36:52" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "18:40:30" , 
"departure_time" : "18:41:03" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "18:44:33" , 
"departure_time" : "18:45:49" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "18:50:16" , 
"departure_time" : "18:50:49" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:56:33" , 
"departure_time" : "18:57:53" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "19:01:20" , 
"departure_time" : "19:02:53" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "19:07:33" , 
"departure_time" : "19:08:44" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:11:11" , 
"departure_time" : "19:12:36" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:18:25" , 
"departure_time" : "19:18:29" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:24:04" , 
"departure_time" : "19:25:35" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "19:38:31" , 
"departure_time" : "19:38:31" , 
"distance_traveled" : 57.91
} ], 
"2532" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "07:23:00" , 
"departure_time" : "07:25:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "07:29:57" , 
"departure_time" : "07:30:16" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "07:36:19" , 
"departure_time" : "07:37:57" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "07:55:38" , 
"departure_time" : "07:57:08" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "08:00:30" , 
"departure_time" : "08:01:51" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "08:05:21" , 
"departure_time" : "08:05:54" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "08:09:33" , 
"departure_time" : "08:10:23" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:23:50" , 
"departure_time" : "08:23:52" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:28:02" , 
"departure_time" : "08:29:12" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:39:10" , 
"departure_time" : "08:39:42" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:51:32" , 
"departure_time" : "08:51:32" , 
"distance_traveled" : 57.9102
} ], 
"2533" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "19:15:00" , 
"departure_time" : "19:16:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "19:22:18" , 
"departure_time" : "19:22:35" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:28:17" , 
"departure_time" : "19:29:48" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "19:45:31" , 
"departure_time" : "19:46:49" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "19:49:18" , 
"departure_time" : "19:50:20" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "19:54:02" , 
"departure_time" : "19:55:07" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "20:00:05" , 
"departure_time" : "20:00:31" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:05:26" , 
"departure_time" : "20:07:00" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "20:10:34" , 
"departure_time" : "20:11:01" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "20:16:27" , 
"departure_time" : "20:17:31" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:22:04" , 
"departure_time" : "20:22:53" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:27:49" , 
"departure_time" : "20:29:05" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:35:16" , 
"departure_time" : "20:35:18" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "20:47:02" , 
"departure_time" : "20:47:02" , 
"distance_traveled" : 57.91
} ], 
"2534" :  [ 
{ 
"stop_id" : 103,
"arrival_time" : "16:58:00" , 
"departure_time" : "16:59:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38,
"arrival_time" : "17:03:21" , 
"departure_time" : "17:03:54" , 
"distance_traveled" : 2.3723
}, 
{ 
"stop_id" : 84,
"arrival_time" : "17:07:33" , 
"departure_time" : "17:09:03" , 
"distance_traveled" : 5.4481
}, 
{ 
"stop_id" : 83,
"arrival_time" : "17:13:30" , 
"departure_time" : "17:14:59" , 
"distance_traveled" : 8.0517
}, 
{ 
"stop_id" : 127,
"arrival_time" : "17:20:29" , 
"departure_time" : "17:20:37" , 
"distance_traveled" : 11.8517
}, 
{ 
"stop_id" : 70,
"arrival_time" : "17:23:08" , 
"departure_time" : "17:23:54" , 
"distance_traveled" : 13.9102
}, 
{ 
"stop_id" : 41,
"arrival_time" : "17:30:46" , 
"departure_time" : "17:31:28" , 
"distance_traveled" : 17.1938
}, 
{ 
"stop_id" : 109,
"arrival_time" : "17:33:42" , 
"departure_time" : "17:35:11" , 
"distance_traveled" : 18.1695
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:38:29" , 
"departure_time" : "17:38:41" , 
"distance_traveled" : 20.0195
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:44:12" , 
"departure_time" : "17:45:08" , 
"distance_traveled" : 22.4977
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:51:56" , 
"departure_time" : "17:53:33" , 
"distance_traveled" : 27.5665
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:05:37" , 
"departure_time" : "18:05:37" , 
"distance_traveled" : 32.5545
} ], 
"2535" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "19:56:00" , 
"departure_time" : "19:57:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "20:02:08" , 
"departure_time" : "20:03:39" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "20:10:31" , 
"departure_time" : "20:11:29" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "20:24:58" , 
"departure_time" : "20:25:52" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "20:29:54" , 
"departure_time" : "20:30:20" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "20:34:26" , 
"departure_time" : "20:34:31" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "20:38:05" , 
"departure_time" : "20:38:37" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:45:32" , 
"departure_time" : "20:46:49" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "20:50:17" , 
"departure_time" : "20:50:46" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "20:56:29" , 
"departure_time" : "20:58:07" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "21:02:38" , 
"departure_time" : "21:04:06" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:08:28" , 
"departure_time" : "21:09:51" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:15:23" , 
"departure_time" : "21:16:55" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "21:29:32" , 
"departure_time" : "21:29:32" , 
"distance_traveled" : 57.91
} ], 
"2536" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "09:51:00" , 
"departure_time" : "09:53:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "09:57:54" , 
"departure_time" : "09:58:00" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "10:04:06" , 
"departure_time" : "10:04:12" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "10:18:06" , 
"departure_time" : "10:18:33" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "10:23:27" , 
"departure_time" : "10:24:50" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "10:29:23" , 
"departure_time" : "10:30:27" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "10:33:04" , 
"departure_time" : "10:33:56" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "10:39:52" , 
"departure_time" : "10:41:32" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:51:40" , 
"departure_time" : "10:52:19" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:56:39" , 
"departure_time" : "10:56:46" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:03:07" , 
"departure_time" : "11:04:37" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "11:17:30" , 
"departure_time" : "11:17:30" , 
"distance_traveled" : 57.91
} ], 
"2537" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "20:41:00" , 
"departure_time" : "20:42:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "20:47:01" , 
"departure_time" : "20:47:54" , 
"distance_traveled" : 3.6536
}, 
{ 
"stop_id" : 125,
"arrival_time" : "20:54:53" , 
"departure_time" : "20:55:57" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "21:10:04" , 
"departure_time" : "21:10:35" , 
"distance_traveled" : 25.3614
}, 
{ 
"stop_id" : 38,
"arrival_time" : "21:13:31" , 
"departure_time" : "21:15:09" , 
"distance_traveled" : 27.7282
}, 
{ 
"stop_id" : 84,
"arrival_time" : "21:19:38" , 
"departure_time" : "21:19:53" , 
"distance_traveled" : 30.8044
}, 
{ 
"stop_id" : 83,
"arrival_time" : "21:23:15" , 
"departure_time" : "21:23:36" , 
"distance_traveled" : 33.4083
}, 
{ 
"stop_id" : 127,
"arrival_time" : "21:30:21" , 
"departure_time" : "21:31:53" , 
"distance_traveled" : 37.2085
}, 
{ 
"stop_id" : 70,
"arrival_time" : "21:35:32" , 
"departure_time" : "21:36:44" , 
"distance_traveled" : 39.2672
}, 
{ 
"stop_id" : 41,
"arrival_time" : "21:41:12" , 
"departure_time" : "21:41:35" , 
"distance_traveled" : 42.5508
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "21:45:23" , 
"departure_time" : "21:46:04" , 
"distance_traveled" : 45.3765
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:52:41" , 
"departure_time" : "21:53:44" , 
"distance_traveled" : 47.8551
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:00:03" , 
"departure_time" : "22:00:45" , 
"distance_traveled" : 52.9244
}, 
{ 
"stop_id" : 105,
"arrival_time" : "22:12:42" , 
"departure_time" : "22:12:42" , 
"distance_traveled" : 57.9127
} ], 
"2538" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "16:41:00" , 
"departure_time" : "16:42:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "16:47:42" , 
"departure_time" : "16:48:38" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:54:56" , 
"departure_time" : "16:55:01" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "17:10:05" , 
"departure_time" : "17:11:08" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "17:16:03" , 
"departure_time" : "17:16:21" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "17:20:18" , 
"departure_time" : "17:21:46" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "17:26:28" , 
"departure_time" : "17:27:22" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "17:31:54" , 
"departure_time" : "17:33:08" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:43:14" , 
"departure_time" : "17:44:34" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:50:20" , 
"departure_time" : "17:50:46" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:56:26" , 
"departure_time" : "17:57:56" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:10:30" , 
"departure_time" : "18:10:30" , 
"distance_traveled" : 57.91
} ], 
"2539" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "23:53:00" , 
"departure_time" : "23:55:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "24:00:18" , 
"departure_time" : "24:01:31" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "24:07:13" , 
"departure_time" : "24:07:47" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "24:20:34" , 
"departure_time" : "24:21:24" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "24:24:50" , 
"departure_time" : "24:25:56" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "24:30:06" , 
"departure_time" : "24:31:11" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "24:35:05" , 
"departure_time" : "24:36:20" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "24:42:15" , 
"departure_time" : "24:42:54" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "24:45:39" , 
"departure_time" : "24:46:07" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "24:51:28" , 
"departure_time" : "24:52:17" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "24:56:49" , 
"departure_time" : "24:56:56" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "25:02:07" , 
"departure_time" : "25:03:03" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "25:09:56" , 
"departure_time" : "25:11:12" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "25:23:16" , 
"departure_time" : "25:23:16" , 
"distance_traveled" : 57.91
} ], 
"2540" :  [ 
{ 
"stop_id" : 32906,
"arrival_time" : "05:00:00" , 
"departure_time" : "05:02:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 103,
"arrival_time" : "05:06:26" , 
"departure_time" : "05:08:03" , 
"distance_traveled" : 1.8108
}, 
{ 
"stop_id" : 38,
"arrival_time" : "05:10:37" , 
"departure_time" : "05:11:42" , 
"distance_traveled" : 4.1777
}, 
{ 
"stop_id" : 84,
"arrival_time" : "05:15:05" , 
"departure_time" : "05:15:59" , 
"distance_traveled" : 7.2534
}, 
{ 
"stop_id" : 83,
"arrival_time" : "05:19:54" , 
"departure_time" : "05:21:13" , 
"distance_traveled" : 9.857
}, 
{ 
"stop_id" : 127,
"arrival_time" : "05:26:19" , 
"departure_time" : "05:27:01" , 
"distance_traveled" : 13.657
}, 
{ 
"stop_id" : 70,
"arrival_time" : "05:29:42" , 
"departure_time" : "05:30:42" , 
"distance_traveled" : 15.7155
}, 
{ 
"stop_id" : 41,
"arrival_time" : "05:36:00" , 
"departure_time" : "05:36:04" , 
"distance_traveled" : 18.9991
}, 
{ 
"stop_id" : 109,
"arrival_time" : "05:38:04" , 
"departure_time" : "05:39:23" , 
"distance_traveled" : 19.9748
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "05:42:19" , 
"departure_time" : "05:43:19" , 
"distance_traveled" : 21.8248
}, 
{ 
"stop_id" : 107,
"arrival_time" : "05:48:00" , 
"departure_time" : "05:48:52" , 
"distance_traveled" : 24.303
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:54:52" , 
"departure_time" : "05:55:40" , 
"distance_traveled" : 29.3718
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:07:48" , 
"departure_time" : "06:07:48" , 
"distance_traveled" : 34.3598
} ], 
"2541" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "03:47:00" , 
"departure_time" : "03:49:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "03:54:23" , 
"departure_time" : "03:55:02" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "03:59:39" , 
"departure_time" : "03:59:45" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "04:13:06" , 
"departure_time" : "04:13:53" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "04:17:47" , 
"departure_time" : "04:19:26" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "04:23:39" , 
"departure_time" : "04:25:13" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "04:27:34" , 
"departure_time" : "04:29:05" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "04:34:31" , 
"departure_time" : "04:34:45" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "04:37:14" , 
"departure_time" : "04:38:38" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "04:44:24" , 
"departure_time" : "04:45:56" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "04:47:32" , 
"departure_time" : "04:47:54" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "04:50:22" , 
"departure_time" : "04:50:34" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "04:56:12" , 
"departure_time" : "04:56:38" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:03:26" , 
"departure_time" : "05:04:14" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "05:21:48" , 
"departure_time" : "05:21:48" , 
"distance_traveled" : 57.91
} ], 
"2542" :  [ 
{ 
"stop_id" : 32906,
"arrival_time" : "05:19:00" , 
"departure_time" : "05:21:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 103,
"arrival_time" : "05:28:31" , 
"departure_time" : "05:29:51" , 
"distance_traveled" : 1.8108
}, 
{ 
"stop_id" : 38,
"arrival_time" : "05:32:20" , 
"departure_time" : "05:32:42" , 
"distance_traveled" : 4.1777
}, 
{ 
"stop_id" : 84,
"arrival_time" : "05:36:22" , 
"departure_time" : "05:37:17" , 
"distance_traveled" : 7.2534
}, 
{ 
"stop_id" : 83,
"arrival_time" : "05:40:55" , 
"departure_time" : "05:41:03" , 
"distance_traveled" : 9.857
}, 
{ 
"stop_id" : 127,
"arrival_time" : "05:48:08" , 
"departure_time" : "05:48:20" , 
"distance_traveled" : 13.657
}, 
{ 
"stop_id" : 70,
"arrival_time" : "05:53:12" , 
"departure_time" : "05:53:46" , 
"distance_traveled" : 15.7155
}, 
{ 
"stop_id" : 41,
"arrival_time" : "05:59:34" , 
"departure_time" : "06:00:59" , 
"distance_traveled" : 18.9991
}, 
{ 
"stop_id" : 109,
"arrival_time" : "06:03:25" , 
"departure_time" : "06:05:02" , 
"distance_traveled" : 19.9748
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "06:06:37" , 
"departure_time" : "06:06:45" , 
"distance_traveled" : 21.8248
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:12:08" , 
"departure_time" : "06:13:35" , 
"distance_traveled" : 24.303
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:21:27" , 
"departure_time" : "06:22:56" , 
"distance_traveled" : 29.3718
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:34:29" , 
"departure_time" : "06:34:29" , 
"distance_traveled" : 34.3598
} ], 
"2543" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "05:46:00" , 
"departure_time" : "05:48:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "05:54:24" , 
"departure_time" : "05:55:16" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "06:01:52" , 
"departure_time" : "06:02:55" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "06:17:03" , 
"departure_time" : "06:17:47" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "06:21:44" , 
"departure_time" : "06:22:54" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "06:27:10" , 
"departure_time" : "06:28:40" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "06:32:30" , 
"departure_time" : "06:33:30" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "06:39:00" , 
"departure_time" : "06:40:32" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "06:43:32" , 
"departure_time" : "06:43:41" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "06:49:09" , 
"departure_time" : "06:49:39" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "06:51:30" , 
"departure_time" : "06:52:22" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "06:55:52" , 
"departure_time" : "06:56:10" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:01:18" , 
"departure_time" : "07:02:26" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:10:08" , 
"departure_time" : "07:10:19" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:21:11" , 
"departure_time" : "07:21:11" , 
"distance_traveled" : 57.91
} ], 
"2544" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "05:21:00" , 
"departure_time" : "05:22:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "05:28:39" , 
"departure_time" : "05:28:46" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "05:34:07" , 
"departure_time" : "05:35:15" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "05:50:08" , 
"departure_time" : "05:51:08" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "05:54:00" , 
"departure_time" : "05:54:50" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "05:58:50" , 
"departure_time" : "05:59:52" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "06:04:02" , 
"departure_time" : "06:04:10" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "06:11:08" , 
"departure_time" : "06:11:12" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "06:16:04" , 
"departure_time" : "06:17:25" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "06:23:21" , 
"departure_time" : "06:23:41" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "06:25:20" , 
"departure_time" : "06:25:25" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "06:29:05" , 
"departure_time" : "06:30:36" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:36:31" , 
"departure_time" : "06:37:54" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:54:23" , 
"departure_time" : "06:54:23" , 
"distance_traveled" : 57.91
} ], 
"2545" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "06:11:00" , 
"departure_time" : "06:12:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "06:17:01" , 
"departure_time" : "06:18:04" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "06:26:03" , 
"departure_time" : "06:27:36" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "06:41:33" , 
"departure_time" : "06:43:07" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "06:46:34" , 
"departure_time" : "06:46:37" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "06:50:03" , 
"departure_time" : "06:51:37" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "06:56:34" , 
"departure_time" : "06:57:19" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "07:02:45" , 
"departure_time" : "07:04:02" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "07:08:17" , 
"departure_time" : "07:08:59" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "07:14:42" , 
"departure_time" : "07:15:10" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "07:17:28" , 
"departure_time" : "07:18:50" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "07:22:22" , 
"departure_time" : "07:23:54" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:30:32" , 
"departure_time" : "07:32:10" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:38:38" , 
"departure_time" : "07:40:10" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:51:32" , 
"departure_time" : "07:51:32" , 
"distance_traveled" : 57.91
} ], 
"2546" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "17:27:00" , 
"departure_time" : "17:29:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "17:33:32" , 
"departure_time" : "17:34:25" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:40:53" , 
"departure_time" : "17:41:18" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "17:54:25" , 
"departure_time" : "17:55:55" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "17:59:30" , 
"departure_time" : "18:00:37" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "18:04:07" , 
"departure_time" : "18:04:14" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "18:08:07" , 
"departure_time" : "18:08:54" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:15:47" , 
"departure_time" : "18:17:03" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "18:20:16" , 
"departure_time" : "18:21:26" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "18:27:10" , 
"departure_time" : "18:27:26" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "18:29:16" , 
"departure_time" : "18:30:08" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:32:52" , 
"departure_time" : "18:34:13" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:39:21" , 
"departure_time" : "18:40:59" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:57:38" , 
"departure_time" : "18:57:38" , 
"distance_traveled" : 57.91
} ], 
"2547" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "12:21:00" , 
"departure_time" : "12:23:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "12:27:37" , 
"departure_time" : "12:27:40" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "12:34:03" , 
"departure_time" : "12:35:25" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "12:49:22" , 
"departure_time" : "12:50:43" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "12:53:21" , 
"departure_time" : "12:53:34" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "12:57:13" , 
"departure_time" : "12:57:50" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "13:02:37" , 
"departure_time" : "13:03:06" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "13:09:29" , 
"departure_time" : "13:09:53" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "13:13:24" , 
"departure_time" : "13:13:40" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "13:19:16" , 
"departure_time" : "13:19:23" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "13:22:07" , 
"departure_time" : "13:22:42" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:26:35" , 
"departure_time" : "13:27:28" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:33:53" , 
"departure_time" : "13:34:30" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:40:37" , 
"departure_time" : "13:41:27" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "13:53:50" , 
"departure_time" : "13:53:50" , 
"distance_traveled" : 57.91
} ], 
"2548" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "10:41:00" , 
"departure_time" : "10:43:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "10:48:15" , 
"departure_time" : "10:49:27" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "10:55:12" , 
"departure_time" : "10:56:27" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "11:10:15" , 
"departure_time" : "11:11:29" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "11:15:14" , 
"departure_time" : "11:16:21" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "11:20:07" , 
"departure_time" : "11:20:53" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "11:24:46" , 
"departure_time" : "11:25:09" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "11:31:23" , 
"departure_time" : "11:32:32" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "11:37:09" , 
"departure_time" : "11:37:20" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "11:43:11" , 
"departure_time" : "11:44:30" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "11:49:19" , 
"departure_time" : "11:50:50" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:56:31" , 
"departure_time" : "11:56:43" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:02:12" , 
"departure_time" : "12:02:39" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "12:17:27" , 
"departure_time" : "12:17:27" , 
"distance_traveled" : 57.91
} ], 
"2549" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "14:11:00" , 
"departure_time" : "14:11:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "14:17:20" , 
"departure_time" : "14:17:33" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "14:24:13" , 
"departure_time" : "14:25:12" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "14:38:59" , 
"departure_time" : "14:40:17" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "14:44:18" , 
"departure_time" : "14:45:19" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "14:49:01" , 
"departure_time" : "14:49:57" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "14:53:56" , 
"departure_time" : "14:55:21" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "15:00:25" , 
"departure_time" : "15:01:05" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "15:03:40" , 
"departure_time" : "15:03:41" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "15:09:01" , 
"departure_time" : "15:10:40" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "15:13:39" , 
"departure_time" : "15:14:51" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "15:17:12" , 
"departure_time" : "15:17:17" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:22:05" , 
"departure_time" : "15:22:27" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:30:22" , 
"departure_time" : "15:30:23" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "15:43:01" , 
"departure_time" : "15:43:01" , 
"distance_traveled" : 57.91
} ], 
"2550" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "11:28:00" , 
"departure_time" : "11:29:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "11:35:21" , 
"departure_time" : "11:36:11" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "11:41:50" , 
"departure_time" : "11:43:25" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "11:57:35" , 
"departure_time" : "11:58:34" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "12:01:59" , 
"departure_time" : "12:02:24" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "12:06:25" , 
"departure_time" : "12:07:28" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "12:12:03" , 
"departure_time" : "12:12:26" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "12:18:23" , 
"departure_time" : "12:18:30" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "12:22:07" , 
"departure_time" : "12:22:31" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "12:29:24" , 
"departure_time" : "12:29:41" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "12:34:17" , 
"departure_time" : "12:34:52" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:40:35" , 
"departure_time" : "12:41:55" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:48:20" , 
"departure_time" : "12:49:34" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "13:02:14" , 
"departure_time" : "13:02:14" , 
"distance_traveled" : 57.91
} ], 
"2551" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "15:12:00" , 
"departure_time" : "15:13:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "15:18:35" , 
"departure_time" : "15:18:41" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:25:06" , 
"departure_time" : "15:26:13" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "15:41:07" , 
"departure_time" : "15:41:47" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "15:44:40" , 
"departure_time" : "15:45:29" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "15:50:49" , 
"departure_time" : "15:52:12" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "15:56:23" , 
"departure_time" : "15:57:43" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "16:02:20" , 
"departure_time" : "16:03:47" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "16:06:27" , 
"departure_time" : "16:07:53" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "16:12:26" , 
"departure_time" : "16:13:07" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "16:14:41" , 
"departure_time" : "16:16:03" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:19:22" , 
"departure_time" : "16:20:26" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:25:04" , 
"departure_time" : "16:25:12" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:31:08" , 
"departure_time" : "16:32:11" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "16:45:03" , 
"departure_time" : "16:45:03" , 
"distance_traveled" : 57.91
} ], 
"2552" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "12:52:00" , 
"departure_time" : "12:53:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "12:58:36" , 
"departure_time" : "12:58:45" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:05:09" , 
"departure_time" : "13:05:54" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "13:20:45" , 
"departure_time" : "13:21:53" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "13:25:08" , 
"departure_time" : "13:25:21" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "13:29:13" , 
"departure_time" : "13:30:51" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "13:35:38" , 
"departure_time" : "13:37:01" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "13:41:23" , 
"departure_time" : "13:42:10" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "13:44:47" , 
"departure_time" : "13:46:11" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "13:52:24" , 
"departure_time" : "13:53:05" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:55:41" , 
"departure_time" : "13:56:19" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:01:38" , 
"departure_time" : "14:02:59" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:10:21" , 
"departure_time" : "14:10:56" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "14:24:35" , 
"departure_time" : "14:24:35" , 
"distance_traveled" : 57.91
} ], 
"2553" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "17:04:00" , 
"departure_time" : "17:04:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "17:10:12" , 
"departure_time" : "17:11:22" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:18:10" , 
"departure_time" : "17:18:16" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "17:31:06" , 
"departure_time" : "17:32:05" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "17:35:59" , 
"departure_time" : "17:36:14" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "17:40:15" , 
"departure_time" : "17:41:32" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "17:46:17" , 
"departure_time" : "17:46:18" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "17:52:01" , 
"departure_time" : "17:52:20" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "17:56:19" , 
"departure_time" : "17:57:54" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "18:03:35" , 
"departure_time" : "18:04:21" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "18:05:46" , 
"departure_time" : "18:06:38" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:09:52" , 
"departure_time" : "18:10:55" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:16:03" , 
"departure_time" : "18:17:21" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:23:18" , 
"departure_time" : "18:24:35" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:36:17" , 
"departure_time" : "18:36:17" , 
"distance_traveled" : 57.91
} ], 
"2554" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "13:44:00" , 
"departure_time" : "13:46:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "13:51:17" , 
"departure_time" : "13:52:51" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:58:34" , 
"departure_time" : "13:58:57" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "14:11:23" , 
"departure_time" : "14:11:46" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "14:16:23" , 
"departure_time" : "14:17:53" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "14:22:30" , 
"departure_time" : "14:23:07" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "14:25:37" , 
"departure_time" : "14:26:06" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "14:32:29" , 
"departure_time" : "14:33:53" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "14:37:24" , 
"departure_time" : "14:37:37" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "14:43:13" , 
"departure_time" : "14:43:51" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "14:48:38" , 
"departure_time" : "14:49:30" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:54:52" , 
"departure_time" : "14:55:14" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:02:22" , 
"departure_time" : "15:02:33" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "15:15:11" , 
"departure_time" : "15:15:11" , 
"distance_traveled" : 57.91
} ], 
"2555" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "21:10:00" , 
"departure_time" : "21:10:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "21:16:13" , 
"departure_time" : "21:16:19" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "21:23:06" , 
"departure_time" : "21:23:46" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "21:37:40" , 
"departure_time" : "21:37:47" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "21:41:07" , 
"departure_time" : "21:42:41" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "21:47:34" , 
"departure_time" : "21:49:02" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "21:52:28" , 
"departure_time" : "21:53:11" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "21:58:43" , 
"departure_time" : "22:00:17" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "22:02:34" , 
"departure_time" : "22:02:40" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "22:08:06" , 
"departure_time" : "22:08:53" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "22:11:47" , 
"departure_time" : "22:13:08" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:16:21" , 
"departure_time" : "22:17:24" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:22:03" , 
"departure_time" : "22:22:31" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:28:28" , 
"departure_time" : "22:29:10" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "22:42:42" , 
"departure_time" : "22:42:42" , 
"distance_traveled" : 57.91
} ], 
"2556" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "16:03:00" , 
"departure_time" : "16:05:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "16:10:33" , 
"departure_time" : "16:11:17" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:16:44" , 
"departure_time" : "16:17:53" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "16:32:09" , 
"departure_time" : "16:33:49" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "16:36:40" , 
"departure_time" : "16:38:08" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "16:41:28" , 
"departure_time" : "16:41:47" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "16:45:19" , 
"departure_time" : "16:45:24" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "16:52:05" , 
"departure_time" : "16:52:06" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "16:56:01" , 
"departure_time" : "16:57:27" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "17:03:26" , 
"departure_time" : "17:04:59" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:08:33" , 
"departure_time" : "17:08:42" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:14:09" , 
"departure_time" : "17:14:57" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:22:48" , 
"departure_time" : "17:22:56" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "17:35:08" , 
"departure_time" : "17:35:08" , 
"distance_traveled" : 57.91
} ], 
"2557" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "22:06:00" , 
"departure_time" : "22:07:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "22:13:16" , 
"departure_time" : "22:13:45" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "22:19:29" , 
"departure_time" : "22:20:41" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "22:34:12" , 
"departure_time" : "22:34:36" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "22:37:24" , 
"departure_time" : "22:38:41" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "22:43:17" , 
"departure_time" : "22:43:39" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "22:47:22" , 
"departure_time" : "22:48:52" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "22:55:30" , 
"departure_time" : "22:55:36" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "22:58:06" , 
"departure_time" : "22:58:38" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "23:04:32" , 
"departure_time" : "23:06:03" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "23:08:31" , 
"departure_time" : "23:09:29" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "23:11:58" , 
"departure_time" : "23:12:27" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "23:17:29" , 
"departure_time" : "23:17:42" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:24:13" , 
"departure_time" : "23:25:17" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "23:38:04" , 
"departure_time" : "23:38:04" , 
"distance_traveled" : 57.91
} ], 
"2558" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "18:08:00" , 
"departure_time" : "18:10:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "18:14:56" , 
"departure_time" : "18:15:08" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:21:12" , 
"departure_time" : "18:22:42" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "18:36:30" , 
"departure_time" : "18:37:56" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "18:40:26" , 
"departure_time" : "18:42:06" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "18:45:40" , 
"departure_time" : "18:46:18" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "18:49:38" , 
"departure_time" : "18:49:44" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:56:06" , 
"departure_time" : "18:56:58" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "19:00:52" , 
"departure_time" : "19:01:33" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "19:06:41" , 
"departure_time" : "19:06:49" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:10:08" , 
"departure_time" : "19:11:37" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:18:29" , 
"departure_time" : "19:19:13" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:24:44" , 
"departure_time" : "19:26:21" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "19:38:37" , 
"departure_time" : "19:38:37" , 
"distance_traveled" : 57.91
} ], 
"2559" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "23:20:00" , 
"departure_time" : "23:22:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "23:27:02" , 
"departure_time" : "23:27:04" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "23:33:02" , 
"departure_time" : "23:33:39" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "23:48:37" , 
"departure_time" : "23:49:26" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "23:52:49" , 
"departure_time" : "23:54:28" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "23:58:39" , 
"departure_time" : "23:59:15" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "24:02:36" , 
"departure_time" : "24:02:56" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "24:09:20" , 
"departure_time" : "24:10:43" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "24:14:23" , 
"departure_time" : "24:14:27" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "24:19:04" , 
"departure_time" : "24:20:25" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "24:23:21" , 
"departure_time" : "24:23:47" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "24:26:26" , 
"departure_time" : "24:27:13" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "24:32:47" , 
"departure_time" : "24:33:24" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:39:37" , 
"departure_time" : "24:39:53" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "24:55:16" , 
"departure_time" : "24:55:16" , 
"distance_traveled" : 57.91
} ], 
"2560" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "19:15:00" , 
"departure_time" : "19:16:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "19:21:55" , 
"departure_time" : "19:23:11" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:29:16" , 
"departure_time" : "19:29:57" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "19:44:41" , 
"departure_time" : "19:45:07" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "19:48:26" , 
"departure_time" : "19:49:29" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "19:54:03" , 
"departure_time" : "19:55:41" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "20:00:38" , 
"departure_time" : "20:00:46" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:05:08" , 
"departure_time" : "20:06:40" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "20:10:32" , 
"departure_time" : "20:12:09" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "20:17:37" , 
"departure_time" : "20:18:38" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:22:01" , 
"departure_time" : "20:23:32" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:28:31" , 
"departure_time" : "20:28:59" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:34:28" , 
"departure_time" : "20:35:25" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "20:47:57" , 
"departure_time" : "20:47:57" , 
"distance_traveled" : 57.91
} ], 
"2561" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "10:15:00" , 
"departure_time" : "10:16:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "10:21:40" , 
"departure_time" : "10:22:29" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "10:28:49" , 
"departure_time" : "10:29:15" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "10:42:26" , 
"departure_time" : "10:42:45" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "10:46:19" , 
"departure_time" : "10:46:42" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "10:51:23" , 
"departure_time" : "10:52:55" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "10:57:32" , 
"departure_time" : "10:57:41" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "11:03:09" , 
"departure_time" : "11:03:59" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "11:07:50" , 
"departure_time" : "11:07:56" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "11:13:06" , 
"departure_time" : "11:13:41" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "11:18:35" , 
"departure_time" : "11:18:56" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:24:21" , 
"departure_time" : "11:24:45" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:31:24" , 
"departure_time" : "11:33:00" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "11:45:36" , 
"departure_time" : "11:45:36" , 
"distance_traveled" : 57.9104
} ], 
"2562" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "19:56:00" , 
"departure_time" : "19:57:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "20:02:12" , 
"departure_time" : "20:02:54" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "20:09:42" , 
"departure_time" : "20:11:06" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "20:25:24" , 
"departure_time" : "20:27:04" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "20:30:40" , 
"departure_time" : "20:32:01" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "20:35:21" , 
"departure_time" : "20:36:23" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "20:39:02" , 
"departure_time" : "20:40:41" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:46:39" , 
"departure_time" : "20:46:42" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "20:49:03" , 
"departure_time" : "20:50:13" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "20:57:10" , 
"departure_time" : "20:58:48" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "21:02:38" , 
"departure_time" : "21:04:00" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:08:22" , 
"departure_time" : "21:09:06" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:14:44" , 
"departure_time" : "21:15:52" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "21:29:08" , 
"departure_time" : "21:29:08" , 
"distance_traveled" : 57.91
} ], 
"2563" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "11:52:00" , 
"departure_time" : "11:53:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "11:58:13" , 
"departure_time" : "11:58:59" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "12:05:46" , 
"departure_time" : "12:07:26" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "12:20:40" , 
"departure_time" : "12:21:01" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "12:24:21" , 
"departure_time" : "12:25:39" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "12:30:18" , 
"departure_time" : "12:30:47" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "12:33:29" , 
"departure_time" : "12:33:41" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "12:40:12" , 
"departure_time" : "12:41:00" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "12:44:48" , 
"departure_time" : "12:46:02" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "12:52:14" , 
"departure_time" : "12:53:39" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "12:56:25" , 
"departure_time" : "12:57:32" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:02:07" , 
"departure_time" : "13:02:36" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:09:29" , 
"departure_time" : "13:10:23" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "13:22:54" , 
"departure_time" : "13:22:54" , 
"distance_traveled" : 57.9104
} ], 
"2564" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "20:41:00" , 
"departure_time" : "20:42:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "20:47:19" , 
"departure_time" : "20:48:06" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "20:54:47" , 
"departure_time" : "20:56:18" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "21:10:31" , 
"departure_time" : "21:10:38" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "21:13:07" , 
"departure_time" : "21:14:03" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "21:18:56" , 
"departure_time" : "21:19:31" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "21:23:35" , 
"departure_time" : "21:24:18" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "21:30:43" , 
"departure_time" : "21:30:54" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "21:34:11" , 
"departure_time" : "21:35:05" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "21:40:54" , 
"departure_time" : "21:42:29" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "21:46:35" , 
"departure_time" : "21:47:32" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:52:57" , 
"departure_time" : "21:53:29" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:59:32" , 
"departure_time" : "21:59:54" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "22:12:22" , 
"departure_time" : "22:12:22" , 
"distance_traveled" : 57.91
} ], 
"2565" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "25:11:00" , 
"departure_time" : "25:11:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "25:17:08" , 
"departure_time" : "25:17:27" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "25:24:19" , 
"departure_time" : "25:24:25" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "25:40:06" , 
"departure_time" : "25:40:50" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "25:44:44" , 
"departure_time" : "25:45:27" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "25:49:43" , 
"departure_time" : "25:50:34" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "25:54:51" , 
"departure_time" : "25:55:43" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "26:01:52" , 
"departure_time" : "26:02:12" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "26:05:20" , 
"departure_time" : "26:05:58" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "26:12:38" , 
"departure_time" : "26:13:47" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "26:16:09" , 
"departure_time" : "26:17:25" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "26:20:16" , 
"departure_time" : "26:20:48" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "26:25:32" , 
"departure_time" : "26:27:10" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "26:34:38" , 
"departure_time" : "26:35:31" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "26:46:53" , 
"departure_time" : "26:46:53" , 
"distance_traveled" : 57.9104
} ], 
"2566" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "23:53:00" , 
"departure_time" : "23:55:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "24:00:13" , 
"departure_time" : "24:00:20" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "24:06:07" , 
"departure_time" : "24:07:20" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "24:21:13" , 
"departure_time" : "24:21:30" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "24:24:17" , 
"departure_time" : "24:24:38" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "24:29:21" , 
"departure_time" : "24:30:11" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "24:34:50" , 
"departure_time" : "24:35:54" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "24:42:04" , 
"departure_time" : "24:42:53" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "24:45:49" , 
"departure_time" : "24:47:18" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "24:52:29" , 
"departure_time" : "24:52:59" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "24:56:30" , 
"departure_time" : "24:57:52" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "25:03:22" , 
"departure_time" : "25:04:44" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "25:10:22" , 
"departure_time" : "25:12:02" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "25:23:40" , 
"departure_time" : "25:23:40" , 
"distance_traveled" : 57.91
} ], 
"2567" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "07:46:00" , 
"departure_time" : "07:48:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "07:53:34" , 
"departure_time" : "07:54:26" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "08:00:52" , 
"departure_time" : "08:02:31" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "08:16:39" , 
"departure_time" : "08:17:14" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "08:20:35" , 
"departure_time" : "08:20:52" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "08:25:17" , 
"departure_time" : "08:25:43" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "08:30:26" , 
"departure_time" : "08:31:58" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:37:32" , 
"departure_time" : "08:38:45" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "08:41:13" , 
"departure_time" : "08:41:23" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "08:46:10" , 
"departure_time" : "08:47:20" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "08:50:10" , 
"departure_time" : "08:51:28" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:54:18" , 
"departure_time" : "08:55:13" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:59:55" , 
"departure_time" : "09:01:02" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:07:07" , 
"departure_time" : "09:07:31" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:19:24" , 
"departure_time" : "09:19:24" , 
"distance_traveled" : 57.9104
} ], 
"2568" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "03:47:00" , 
"departure_time" : "03:48:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "03:54:28" , 
"departure_time" : "03:56:01" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "04:00:33" , 
"departure_time" : "04:02:08" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "04:14:35" , 
"departure_time" : "04:14:49" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "04:17:14" , 
"departure_time" : "04:18:18" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "04:23:04" , 
"departure_time" : "04:24:35" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "04:27:31" , 
"departure_time" : "04:28:42" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "04:34:11" , 
"departure_time" : "04:34:48" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "04:37:37" , 
"departure_time" : "04:38:02" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "04:43:25" , 
"departure_time" : "04:44:10" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "04:46:45" , 
"departure_time" : "04:47:33" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "04:50:48" , 
"departure_time" : "04:51:30" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "04:56:42" , 
"departure_time" : "04:56:52" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:03:10" , 
"departure_time" : "05:04:29" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "05:22:19" , 
"departure_time" : "05:22:19" , 
"distance_traveled" : 57.91
} ], 
"2569" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "13:09:00" , 
"departure_time" : "13:10:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "13:15:16" , 
"departure_time" : "13:15:37" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:22:21" , 
"departure_time" : "13:23:15" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "13:36:54" , 
"departure_time" : "13:37:39" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "13:40:45" , 
"departure_time" : "13:41:03" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "13:45:18" , 
"departure_time" : "13:46:44" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "13:51:26" , 
"departure_time" : "13:52:10" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "13:57:44" , 
"departure_time" : "13:58:31" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "14:01:47" , 
"departure_time" : "14:03:14" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "14:08:27" , 
"departure_time" : "14:10:05" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "14:11:38" , 
"departure_time" : "14:11:42" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "14:14:04" , 
"departure_time" : "14:15:01" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:21:57" , 
"departure_time" : "14:23:19" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:29:22" , 
"departure_time" : "14:30:39" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "14:43:17" , 
"departure_time" : "14:43:17" , 
"distance_traveled" : 57.9104
} ], 
"2570" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "05:46:00" , 
"departure_time" : "05:48:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "05:53:58" , 
"departure_time" : "05:54:04" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "06:01:06" , 
"departure_time" : "06:01:21" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "06:16:15" , 
"departure_time" : "06:17:47" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "06:22:32" , 
"departure_time" : "06:22:42" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "06:26:10" , 
"departure_time" : "06:27:03" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "06:31:53" , 
"departure_time" : "06:32:33" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "06:38:40" , 
"departure_time" : "06:39:26" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "06:42:46" , 
"departure_time" : "06:43:32" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "06:49:46" , 
"departure_time" : "06:50:39" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "06:51:53" , 
"departure_time" : "06:53:20" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "06:56:27" , 
"departure_time" : "06:56:51" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:01:24" , 
"departure_time" : "07:01:28" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:09:04" , 
"departure_time" : "07:09:19" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:21:15" , 
"departure_time" : "07:21:15" , 
"distance_traveled" : 57.91
} ], 
"2571" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "18:46:00" , 
"departure_time" : "18:47:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "18:53:23" , 
"departure_time" : "18:54:36" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:00:13" , 
"departure_time" : "19:01:08" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "19:14:55" , 
"departure_time" : "19:15:04" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "19:18:09" , 
"departure_time" : "19:18:40" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "19:23:31" , 
"departure_time" : "19:24:46" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "19:29:15" , 
"departure_time" : "19:30:43" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "19:36:28" , 
"departure_time" : "19:36:30" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "19:39:02" , 
"departure_time" : "19:40:04" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "19:46:02" , 
"departure_time" : "19:46:27" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "19:48:25" , 
"departure_time" : "19:49:25" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:53:00" , 
"departure_time" : "19:54:25" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:00:25" , 
"departure_time" : "20:00:30" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:06:05" , 
"departure_time" : "20:07:37" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "20:20:32" , 
"departure_time" : "20:20:32" , 
"distance_traveled" : 57.9104
} ], 
"2572" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "06:11:00" , 
"departure_time" : "06:12:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "06:17:17" , 
"departure_time" : "06:17:42" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "06:25:25" , 
"departure_time" : "06:26:39" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "06:41:14" , 
"departure_time" : "06:41:34" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "06:45:20" , 
"departure_time" : "06:46:57" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "06:51:37" , 
"departure_time" : "06:51:41" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "06:55:04" , 
"departure_time" : "06:56:10" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "07:03:06" , 
"departure_time" : "07:04:00" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "07:07:54" , 
"departure_time" : "07:07:56" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "07:14:02" , 
"departure_time" : "07:15:21" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "07:18:19" , 
"departure_time" : "07:18:52" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "07:21:33" , 
"departure_time" : "07:22:05" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:29:32" , 
"departure_time" : "07:30:55" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:38:23" , 
"departure_time" : "07:38:39" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:50:16" , 
"departure_time" : "07:50:16" , 
"distance_traveled" : 57.91
} ], 
"2573" :  [ 
{ 
"stop_id" : 83,
"arrival_time" : "17:39:00" , 
"departure_time" : "17:39:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:57:28" , 
"departure_time" : "17:57:59" , 
"distance_traveled" : 14.4519
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:07:31" , 
"departure_time" : "18:08:17" , 
"distance_traveled" : 19.5208
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:20:46" , 
"departure_time" : "18:20:46" , 
"distance_traveled" : 24.5089
} ], 
"2574" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "12:21:00" , 
"departure_time" : "12:21:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "12:27:05" , 
"departure_time" : "12:28:13" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "12:35:08" , 
"departure_time" : "12:36:24" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "12:49:16" , 
"departure_time" : "12:49:26" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "12:52:10" , 
"departure_time" : "12:52:57" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "12:57:47" , 
"departure_time" : "12:58:05" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "13:02:18" , 
"departure_time" : "13:02:59" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "13:09:41" , 
"departure_time" : "13:09:53" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "13:13:12" , 
"departure_time" : "13:14:23" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "13:20:11" , 
"departure_time" : "13:20:16" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "13:22:05" , 
"departure_time" : "13:22:44" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:26:39" , 
"departure_time" : "13:27:50" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:34:11" , 
"departure_time" : "13:34:13" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:40:02" , 
"departure_time" : "13:40:32" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "13:53:30" , 
"departure_time" : "13:53:30" , 
"distance_traveled" : 57.91
} ], 
"2575" :  [ 
{ 
"stop_id" : 37953,
"arrival_time" : "24:02:00" , 
"departure_time" : "24:03:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "24:09:39" , 
"departure_time" : "24:09:59" , 
"distance_traveled" : 2.4786
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:17:20" , 
"departure_time" : "24:18:09" , 
"distance_traveled" : 7.5479
}, 
{ 
"stop_id" : 105,
"arrival_time" : "24:32:49" , 
"departure_time" : "24:32:49" , 
"distance_traveled" : 12.5362
} ], 
"2576" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "14:11:00" , 
"departure_time" : "14:11:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "14:17:09" , 
"departure_time" : "14:17:19" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "14:24:10" , 
"departure_time" : "14:24:33" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "14:38:23" , 
"departure_time" : "14:39:14" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "14:43:51" , 
"departure_time" : "14:45:07" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "14:49:16" , 
"departure_time" : "14:50:51" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "14:54:35" , 
"departure_time" : "14:55:09" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "14:59:34" , 
"departure_time" : "14:59:49" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "15:03:15" , 
"departure_time" : "15:03:38" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "15:09:23" , 
"departure_time" : "15:09:48" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "15:12:25" , 
"departure_time" : "15:12:55" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "15:16:30" , 
"departure_time" : "15:17:58" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:23:28" , 
"departure_time" : "15:24:53" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:31:25" , 
"departure_time" : "15:32:17" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "15:43:52" , 
"departure_time" : "15:43:52" , 
"distance_traveled" : 57.91
} ], 
"2577" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "22:08:00" , 
"departure_time" : "22:09:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:16:07" , 
"departure_time" : "22:17:01" , 
"distance_traveled" : 5.0706
}, 
{ 
"stop_id" : 105,
"arrival_time" : "22:29:54" , 
"departure_time" : "22:29:54" , 
"distance_traveled" : 10.0591
} ], 
"2578" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "15:12:00" , 
"departure_time" : "15:13:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "15:18:50" , 
"departure_time" : "15:20:00" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:26:10" , 
"departure_time" : "15:26:16" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "15:40:06" , 
"departure_time" : "15:41:02" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "15:44:56" , 
"departure_time" : "15:46:25" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "15:51:29" , 
"departure_time" : "15:51:59" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "15:55:30" , 
"departure_time" : "15:56:28" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "16:01:58" , 
"departure_time" : "16:02:46" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "16:05:48" , 
"departure_time" : "16:07:01" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "16:12:13" , 
"departure_time" : "16:13:29" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "16:15:16" , 
"departure_time" : "16:16:47" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:19:31" , 
"departure_time" : "16:20:29" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:24:58" , 
"departure_time" : "16:25:57" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:31:59" , 
"departure_time" : "16:32:26" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "16:44:27" , 
"departure_time" : "16:44:27" , 
"distance_traveled" : 57.91
} ], 
"2579" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "05:06:00" , 
"departure_time" : "05:07:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "05:14:01" , 
"departure_time" : "05:14:42" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "05:20:41" , 
"departure_time" : "05:22:06" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 107,
"arrival_time" : "05:55:25" , 
"departure_time" : "05:56:28" , 
"distance_traveled" : 47.8536
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:13:03" , 
"departure_time" : "06:13:03" , 
"distance_traveled" : 57.9106
} ], 
"2580" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "17:04:00" , 
"departure_time" : "17:05:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "17:10:26" , 
"departure_time" : "17:11:08" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:17:42" , 
"departure_time" : "17:18:23" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "17:31:41" , 
"departure_time" : "17:33:16" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "17:36:35" , 
"departure_time" : "17:38:10" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "17:41:35" , 
"departure_time" : "17:41:40" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "17:45:05" , 
"departure_time" : "17:46:23" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "17:53:18" , 
"departure_time" : "17:53:38" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "17:56:20" , 
"departure_time" : "17:57:57" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "18:03:37" , 
"departure_time" : "18:03:46" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "18:05:09" , 
"departure_time" : "18:05:22" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:09:13" , 
"departure_time" : "18:10:09" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:15:56" , 
"departure_time" : "18:17:20" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:23:24" , 
"departure_time" : "18:24:40" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:36:16" , 
"departure_time" : "18:36:16" , 
"distance_traveled" : 57.91
} ], 
"2581" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "09:21:00" , 
"departure_time" : "09:23:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "09:28:24" , 
"departure_time" : "09:29:37" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "09:36:13" , 
"departure_time" : "09:37:06" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "09:49:53" , 
"departure_time" : "09:51:02" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:15:09" , 
"departure_time" : "10:15:15" , 
"distance_traveled" : 47.8536
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:33:06" , 
"departure_time" : "10:33:06" , 
"distance_traveled" : 57.911
} ], 
"2582" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "21:10:00" , 
"departure_time" : "21:10:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "21:16:18" , 
"departure_time" : "21:16:30" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "21:23:12" , 
"departure_time" : "21:23:21" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "21:37:09" , 
"departure_time" : "21:38:00" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "21:41:51" , 
"departure_time" : "21:43:09" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "21:47:18" , 
"departure_time" : "21:47:21" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "21:51:03" , 
"departure_time" : "21:51:08" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "21:58:05" , 
"departure_time" : "21:58:12" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "22:01:07" , 
"departure_time" : "22:01:23" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "22:08:16" , 
"departure_time" : "22:08:50" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "22:11:34" , 
"departure_time" : "22:12:36" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:16:02" , 
"departure_time" : "22:16:28" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:21:26" , 
"departure_time" : "22:22:53" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:29:27" , 
"departure_time" : "22:30:53" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "22:43:26" , 
"departure_time" : "22:43:26" , 
"distance_traveled" : 57.91
} ], 
"2583" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "07:31:00" , 
"departure_time" : "07:33:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "07:38:41" , 
"departure_time" : "07:39:02" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "07:45:21" , 
"departure_time" : "07:46:44" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:23:23" , 
"departure_time" : "08:24:02" , 
"distance_traveled" : 47.8536
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:42:39" , 
"departure_time" : "08:42:39" , 
"distance_traveled" : 57.911
} ], 
"2584" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "22:06:00" , 
"departure_time" : "22:07:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "22:12:55" , 
"departure_time" : "22:14:13" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "22:20:18" , 
"departure_time" : "22:21:14" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "22:33:56" , 
"departure_time" : "22:34:42" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "22:37:46" , 
"departure_time" : "22:39:17" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "22:43:31" , 
"departure_time" : "22:44:34" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "22:48:03" , 
"departure_time" : "22:48:28" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "22:54:25" , 
"departure_time" : "22:55:43" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "22:59:18" , 
"departure_time" : "23:00:28" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "23:05:10" , 
"departure_time" : "23:05:41" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "23:07:31" , 
"departure_time" : "23:08:56" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "23:12:25" , 
"departure_time" : "23:13:34" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "23:18:09" , 
"departure_time" : "23:18:12" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:24:03" , 
"departure_time" : "23:25:06" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "23:38:03" , 
"departure_time" : "23:38:03" , 
"distance_traveled" : 57.91
} ], 
"2585" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "06:01:00" , 
"departure_time" : "06:02:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "06:07:02" , 
"departure_time" : "06:08:16" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "06:16:14" , 
"departure_time" : "06:17:47" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:49:33" , 
"departure_time" : "06:50:09" , 
"distance_traveled" : 47.8536
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:56:36" , 
"departure_time" : "06:58:13" , 
"distance_traveled" : 52.9225
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:11:37" , 
"departure_time" : "07:11:37" , 
"distance_traveled" : 57.9106
} ], 
"2586" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "23:20:00" , 
"departure_time" : "23:22:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "23:26:31" , 
"departure_time" : "23:27:16" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "23:33:45" , 
"departure_time" : "23:33:49" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "23:48:04" , 
"departure_time" : "23:49:35" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "23:53:31" , 
"departure_time" : "23:53:34" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "23:57:03" , 
"departure_time" : "23:57:52" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "24:02:49" , 
"departure_time" : "24:04:14" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "24:10:25" , 
"departure_time" : "24:11:31" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "24:14:06" , 
"departure_time" : "24:14:42" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "24:19:36" , 
"departure_time" : "24:21:05" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "24:23:29" , 
"departure_time" : "24:24:45" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "24:27:16" , 
"departure_time" : "24:27:23" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "24:32:07" , 
"departure_time" : "24:33:23" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:40:16" , 
"departure_time" : "24:41:40" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "24:56:24" , 
"departure_time" : "24:56:24" , 
"distance_traveled" : 57.91
} ], 
"2587" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "06:46:00" , 
"departure_time" : "06:47:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "06:53:13" , 
"departure_time" : "06:53:42" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "07:01:29" , 
"departure_time" : "07:02:35" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:38:06" , 
"departure_time" : "07:38:21" , 
"distance_traveled" : 47.8536
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:44:15" , 
"departure_time" : "07:44:39" , 
"distance_traveled" : 52.9225
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:58:24" , 
"departure_time" : "07:58:24" , 
"distance_traveled" : 57.9106
} ], 
"2588" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "10:15:00" , 
"departure_time" : "10:16:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "10:22:05" , 
"departure_time" : "10:22:28" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "10:28:23" , 
"departure_time" : "10:28:40" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "10:42:17" , 
"departure_time" : "10:43:05" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "10:46:48" , 
"departure_time" : "10:47:26" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "10:51:38" , 
"departure_time" : "10:51:55" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "10:56:17" , 
"departure_time" : "10:56:40" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "11:03:23" , 
"departure_time" : "11:04:12" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "11:07:49" , 
"departure_time" : "11:09:00" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "11:14:11" , 
"departure_time" : "11:15:32" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "11:19:21" , 
"departure_time" : "11:20:12" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:24:51" , 
"departure_time" : "11:25:57" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:32:06" , 
"departure_time" : "11:32:45" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "11:44:39" , 
"departure_time" : "11:44:39" , 
"distance_traveled" : 57.9104
} ], 
"2589" :  [ 
{ 
"stop_id" : 32906,
"arrival_time" : "06:25:00" , 
"departure_time" : "06:26:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 103,
"arrival_time" : "06:33:18" , 
"departure_time" : "06:33:46" , 
"distance_traveled" : 1.8108
}, 
{ 
"stop_id" : 38,
"arrival_time" : "06:36:28" , 
"departure_time" : "06:36:37" , 
"distance_traveled" : 4.1777
}, 
{ 
"stop_id" : 84,
"arrival_time" : "06:42:09" , 
"departure_time" : "06:43:23" , 
"distance_traveled" : 7.2534
}, 
{ 
"stop_id" : 83,
"arrival_time" : "06:48:14" , 
"departure_time" : "06:49:54" , 
"distance_traveled" : 9.857
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:06:40" , 
"departure_time" : "07:07:39" , 
"distance_traveled" : 24.3034
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:23:59" , 
"departure_time" : "07:23:59" , 
"distance_traveled" : 34.3604
} ], 
"2590" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "11:52:00" , 
"departure_time" : "11:54:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "11:59:12" , 
"departure_time" : "11:59:26" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "12:05:14" , 
"departure_time" : "12:06:28" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "12:20:14" , 
"departure_time" : "12:21:25" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "12:25:11" , 
"departure_time" : "12:25:53" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "12:29:42" , 
"departure_time" : "12:31:02" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "12:34:20" , 
"departure_time" : "12:34:57" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "12:40:37" , 
"departure_time" : "12:41:18" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "12:44:41" , 
"departure_time" : "12:44:55" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "12:51:14" , 
"departure_time" : "12:51:41" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "12:55:27" , 
"departure_time" : "12:56:54" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:02:27" , 
"departure_time" : "13:02:33" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:09:06" , 
"departure_time" : "13:09:44" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "13:22:38" , 
"departure_time" : "13:22:38" , 
"distance_traveled" : 57.9104
} ], 
"2591" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "18:31:00" , 
"departure_time" : "18:31:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "18:37:02" , 
"departure_time" : "18:37:05" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:44:03" , 
"departure_time" : "18:45:04" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "19:00:01" , 
"departure_time" : "19:01:41" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:22:40" , 
"departure_time" : "19:22:58" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:27:18" , 
"departure_time" : "19:28:30" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 105,
"arrival_time" : "19:46:12" , 
"departure_time" : "19:46:12" , 
"distance_traveled" : 57.9102
} ], 
"2592" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "25:11:00" , 
"departure_time" : "25:12:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "25:17:21" , 
"departure_time" : "25:18:23" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "25:25:02" , 
"departure_time" : "25:25:50" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "25:40:48" , 
"departure_time" : "25:41:00" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "25:44:12" , 
"departure_time" : "25:44:20" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "25:49:08" , 
"departure_time" : "25:49:53" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "25:54:45" , 
"departure_time" : "25:54:46" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "26:01:01" , 
"departure_time" : "26:02:10" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "26:06:09" , 
"departure_time" : "26:06:21" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "26:12:12" , 
"departure_time" : "26:13:15" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "26:16:03" , 
"departure_time" : "26:16:50" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "26:19:47" , 
"departure_time" : "26:21:00" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "26:26:13" , 
"departure_time" : "26:27:34" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "26:34:21" , 
"departure_time" : "26:35:26" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "26:47:05" , 
"departure_time" : "26:47:05" , 
"distance_traveled" : 57.9104
} ], 
"2593" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "08:26:00" , 
"departure_time" : "08:28:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "08:34:20" , 
"departure_time" : "08:35:01" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "08:41:41" , 
"departure_time" : "08:43:13" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "08:56:32" , 
"departure_time" : "08:56:36" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:19:04" , 
"departure_time" : "09:20:39" , 
"distance_traveled" : 47.8536
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:27:35" , 
"departure_time" : "09:28:38" , 
"distance_traveled" : 52.9225
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:41:03" , 
"departure_time" : "09:41:03" , 
"distance_traveled" : 57.9106
} ], 
"2594" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "07:46:00" , 
"departure_time" : "07:47:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "07:53:36" , 
"departure_time" : "07:53:52" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "08:00:16" , 
"departure_time" : "08:00:25" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "08:15:09" , 
"departure_time" : "08:16:11" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "08:21:02" , 
"departure_time" : "08:22:04" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "08:26:02" , 
"departure_time" : "08:27:27" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "08:31:25" , 
"departure_time" : "08:32:21" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:36:56" , 
"departure_time" : "08:37:47" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "08:40:51" , 
"departure_time" : "08:41:48" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "08:46:57" , 
"departure_time" : "08:47:20" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "08:49:23" , 
"departure_time" : "08:49:30" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:53:07" , 
"departure_time" : "08:54:30" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:00:23" , 
"departure_time" : "09:01:10" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:06:47" , 
"departure_time" : "09:08:26" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:20:39" , 
"departure_time" : "09:20:39" , 
"distance_traveled" : 57.9104
} ], 
"2595" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "06:23:00" , 
"departure_time" : "06:25:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "06:30:58" , 
"departure_time" : "06:32:38" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "06:38:40" , 
"departure_time" : "06:38:53" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:12:13" , 
"departure_time" : "07:12:47" , 
"distance_traveled" : 47.8536
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:19:34" , 
"departure_time" : "07:20:15" , 
"distance_traveled" : 52.9225
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:34:41" , 
"departure_time" : "07:34:41" , 
"distance_traveled" : 57.911
} ], 
"2596" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "13:09:00" , 
"departure_time" : "13:10:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "13:16:07" , 
"departure_time" : "13:16:38" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:22:31" , 
"departure_time" : "13:23:06" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "13:36:35" , 
"departure_time" : "13:37:04" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "13:40:29" , 
"departure_time" : "13:41:51" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "13:46:22" , 
"departure_time" : "13:47:25" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "13:51:03" , 
"departure_time" : "13:52:30" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "13:58:27" , 
"departure_time" : "13:58:36" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "14:01:09" , 
"departure_time" : "14:01:20" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "14:07:11" , 
"departure_time" : "14:07:27" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "14:10:16" , 
"departure_time" : "14:11:29" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "14:15:13" , 
"departure_time" : "14:16:14" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:22:01" , 
"departure_time" : "14:22:21" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:28:20" , 
"departure_time" : "14:28:21" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "14:42:01" , 
"departure_time" : "14:42:01" , 
"distance_traveled" : 57.9104
} ], 
"2597" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "06:59:00" , 
"departure_time" : "06:59:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "07:06:06" , 
"departure_time" : "07:06:12" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "07:13:06" , 
"departure_time" : "07:13:08" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:51:02" , 
"departure_time" : "07:52:14" , 
"distance_traveled" : 47.8536
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:00:12" , 
"departure_time" : "08:01:37" , 
"distance_traveled" : 52.9225
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:14:25" , 
"departure_time" : "08:14:25" , 
"distance_traveled" : 57.911
} ], 
"2598" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "18:46:00" , 
"departure_time" : "18:48:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "18:53:30" , 
"departure_time" : "18:54:44" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:00:14" , 
"departure_time" : "19:01:03" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "19:14:49" , 
"departure_time" : "19:16:28" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "19:19:39" , 
"departure_time" : "19:20:08" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "19:23:29" , 
"departure_time" : "19:24:06" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "19:28:37" , 
"departure_time" : "19:28:42" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "19:35:05" , 
"departure_time" : "19:35:40" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "19:39:35" , 
"departure_time" : "19:40:28" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "19:45:53" , 
"departure_time" : "19:46:13" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "19:48:20" , 
"departure_time" : "19:48:52" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:52:32" , 
"departure_time" : "19:53:59" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:00:27" , 
"departure_time" : "20:01:50" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:07:23" , 
"departure_time" : "20:07:50" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "20:19:27" , 
"departure_time" : "20:19:27" , 
"distance_traveled" : 57.9104
} ], 
"2599" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "07:16:00" , 
"departure_time" : "07:17:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "07:23:39" , 
"departure_time" : "07:23:55" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "07:31:16" , 
"departure_time" : "07:32:15" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:06:59" , 
"departure_time" : "08:08:21" , 
"distance_traveled" : 47.8536
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:14:22" , 
"departure_time" : "08:15:16" , 
"distance_traveled" : 52.9225
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:28:54" , 
"departure_time" : "08:28:54" , 
"distance_traveled" : 57.911
} ], 
"2600" :  [ 
{ 
"stop_id" : 83,
"arrival_time" : "17:39:00" , 
"departure_time" : "17:40:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:57:39" , 
"departure_time" : "17:59:06" , 
"distance_traveled" : 14.4519
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:08:27" , 
"departure_time" : "18:09:23" , 
"distance_traveled" : 19.5208
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:20:56" , 
"departure_time" : "18:20:56" , 
"distance_traveled" : 24.5089
} ], 
"2601" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "08:06:00" , 
"departure_time" : "08:07:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "08:13:12" , 
"departure_time" : "08:13:14" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "08:20:02" , 
"departure_time" : "08:21:17" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:57:15" , 
"departure_time" : "08:58:28" , 
"distance_traveled" : 47.8536
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:04:13" , 
"departure_time" : "09:04:26" , 
"distance_traveled" : 52.9225
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:16:13" , 
"departure_time" : "09:16:13" , 
"distance_traveled" : 57.911
} ], 
"2602" :  [ 
{ 
"stop_id" : 37953,
"arrival_time" : "24:02:00" , 
"departure_time" : "24:02:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "24:09:04" , 
"departure_time" : "24:09:05" , 
"distance_traveled" : 2.4782
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:17:01" , 
"departure_time" : "24:18:01" , 
"distance_traveled" : 7.547
}, 
{ 
"stop_id" : 105,
"arrival_time" : "24:33:00" , 
"departure_time" : "24:33:00" , 
"distance_traveled" : 12.535
} ], 
"2603" :  [ 
{ 
"stop_id" : 32906,
"arrival_time" : "06:00:00" , 
"departure_time" : "06:01:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 103,
"arrival_time" : "06:07:10" , 
"departure_time" : "06:08:04" , 
"distance_traveled" : 1.8108
}, 
{ 
"stop_id" : 38,
"arrival_time" : "06:12:54" , 
"departure_time" : "06:14:07" , 
"distance_traveled" : 4.1777
}, 
{ 
"stop_id" : 84,
"arrival_time" : "06:19:13" , 
"departure_time" : "06:20:37" , 
"distance_traveled" : 7.2534
}, 
{ 
"stop_id" : 83,
"arrival_time" : "06:24:24" , 
"departure_time" : "06:25:47" , 
"distance_traveled" : 9.857
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:42:23" , 
"departure_time" : "06:42:59" , 
"distance_traveled" : 24.3034
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:48:36" , 
"departure_time" : "06:49:45" , 
"distance_traveled" : 29.3723
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:03:09" , 
"departure_time" : "07:03:09" , 
"distance_traveled" : 34.3604
} ], 
"2604" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "22:08:00" , 
"departure_time" : "22:10:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:16:13" , 
"departure_time" : "22:17:03" , 
"distance_traveled" : 5.0706
}, 
{ 
"stop_id" : 105,
"arrival_time" : "22:29:50" , 
"departure_time" : "22:29:50" , 
"distance_traveled" : 10.0591
} ], 
"2605" :  [ 
{ 
"stop_id" : 32906,
"arrival_time" : "06:52:00" , 
"departure_time" : "06:53:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 103,
"arrival_time" : "06:59:27" , 
"departure_time" : "06:59:51" , 
"distance_traveled" : 1.8108
}, 
{ 
"stop_id" : 38,
"arrival_time" : "07:04:24" , 
"departure_time" : "07:05:12" , 
"distance_traveled" : 4.1777
}, 
{ 
"stop_id" : 84,
"arrival_time" : "07:10:48" , 
"departure_time" : "07:10:51" , 
"distance_traveled" : 7.2534
}, 
{ 
"stop_id" : 83,
"arrival_time" : "07:15:03" , 
"departure_time" : "07:15:37" , 
"distance_traveled" : 9.857
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:34:34" , 
"departure_time" : "07:36:00" , 
"distance_traveled" : 24.3034
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:42:26" , 
"departure_time" : "07:43:31" , 
"distance_traveled" : 29.3723
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:55:05" , 
"departure_time" : "07:55:05" , 
"distance_traveled" : 34.3604
} ], 
"2606" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "05:06:00" , 
"departure_time" : "05:08:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "05:14:40" , 
"departure_time" : "05:16:03" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "05:21:23" , 
"departure_time" : "05:21:32" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 107,
"arrival_time" : "05:54:09" , 
"departure_time" : "05:54:48" , 
"distance_traveled" : 47.8536
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:12:39" , 
"departure_time" : "06:12:39" , 
"distance_traveled" : 57.9106
} ], 
"2607" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "08:54:00" , 
"departure_time" : "08:55:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "09:01:24" , 
"departure_time" : "09:01:30" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "09:08:06" , 
"departure_time" : "09:08:33" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "09:22:27" , 
"departure_time" : "09:22:45" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:45:18" , 
"departure_time" : "09:45:58" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:53:40" , 
"departure_time" : "09:53:47" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:00:07" , 
"departure_time" : "10:01:10" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:14:03" , 
"departure_time" : "10:14:03" , 
"distance_traveled" : 57.9102
} ], 
"2608" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "09:21:00" , 
"departure_time" : "09:23:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "09:28:11" , 
"departure_time" : "09:29:01" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "09:35:50" , 
"departure_time" : "09:36:01" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "09:49:11" , 
"departure_time" : "09:49:44" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:14:33" , 
"departure_time" : "10:15:33" , 
"distance_traveled" : 47.8536
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:34:00" , 
"departure_time" : "10:34:00" , 
"distance_traveled" : 57.911
} ], 
"2609" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "14:59:00" , 
"departure_time" : "15:00:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "15:05:37" , 
"departure_time" : "15:05:39" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:12:02" , 
"departure_time" : "15:13:04" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "15:27:02" , 
"departure_time" : "15:28:27" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "15:49:25" , 
"departure_time" : "15:50:31" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:55:06" , 
"departure_time" : "15:55:57" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:01:51" , 
"departure_time" : "16:02:33" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "16:15:42" , 
"departure_time" : "16:15:42" , 
"distance_traveled" : 57.9102
} ], 
"2610" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "07:31:00" , 
"departure_time" : "07:33:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "07:39:30" , 
"departure_time" : "07:40:01" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "07:45:31" , 
"departure_time" : "07:47:04" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:23:33" , 
"departure_time" : "08:24:16" , 
"distance_traveled" : 47.8536
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:42:43" , 
"departure_time" : "08:42:43" , 
"distance_traveled" : 57.911
} ], 
"2611" :  [ 
{ 
"stop_id" : 32906,
"arrival_time" : "07:15:00" , 
"departure_time" : "07:15:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 103,
"arrival_time" : "07:22:05" , 
"departure_time" : "07:23:00" , 
"distance_traveled" : 1.8108
}, 
{ 
"stop_id" : 38,
"arrival_time" : "07:28:55" , 
"departure_time" : "07:29:53" , 
"distance_traveled" : 4.1777
}, 
{ 
"stop_id" : 84,
"arrival_time" : "07:34:58" , 
"departure_time" : "07:36:38" , 
"distance_traveled" : 7.2534
}, 
{ 
"stop_id" : 83,
"arrival_time" : "07:41:40" , 
"departure_time" : "07:43:02" , 
"distance_traveled" : 9.857
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:00:22" , 
"departure_time" : "08:01:06" , 
"distance_traveled" : 24.3034
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:06:44" , 
"departure_time" : "08:07:00" , 
"distance_traveled" : 29.3723
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:21:16" , 
"departure_time" : "08:21:16" , 
"distance_traveled" : 34.3608
} ], 
"2612" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "06:01:00" , 
"departure_time" : "06:02:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "06:08:11" , 
"departure_time" : "06:09:20" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "06:16:09" , 
"departure_time" : "06:16:33" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:48:24" , 
"departure_time" : "06:49:36" , 
"distance_traveled" : 47.8536
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:57:12" , 
"departure_time" : "06:57:35" , 
"distance_traveled" : 52.9225
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:10:23" , 
"departure_time" : "07:10:23" , 
"distance_traveled" : 57.9106
} ], 
"2613" :  [ 
{ 
"stop_id" : 32906,
"arrival_time" : "07:36:00" , 
"departure_time" : "07:38:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 103,
"arrival_time" : "07:44:39" , 
"departure_time" : "07:44:57" , 
"distance_traveled" : 1.8108
}, 
{ 
"stop_id" : 38,
"arrival_time" : "07:48:18" , 
"departure_time" : "07:49:57" , 
"distance_traveled" : 4.1777
}, 
{ 
"stop_id" : 84,
"arrival_time" : "07:55:39" , 
"departure_time" : "07:55:59" , 
"distance_traveled" : 7.2534
}, 
{ 
"stop_id" : 83,
"arrival_time" : "07:59:20" , 
"departure_time" : "08:00:47" , 
"distance_traveled" : 9.857
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:17:27" , 
"departure_time" : "08:18:05" , 
"distance_traveled" : 24.3034
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:23:38" , 
"departure_time" : "08:24:08" , 
"distance_traveled" : 29.3723
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:36:30" , 
"departure_time" : "08:36:30" , 
"distance_traveled" : 34.3608
} ], 
"2614" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "06:46:00" , 
"departure_time" : "06:47:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "06:53:45" , 
"departure_time" : "06:54:13" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "07:01:28" , 
"departure_time" : "07:01:29" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:37:01" , 
"departure_time" : "07:37:58" , 
"distance_traveled" : 47.8536
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:44:57" , 
"departure_time" : "07:45:03" , 
"distance_traveled" : 52.9225
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:58:06" , 
"departure_time" : "07:58:06" , 
"distance_traveled" : 57.9106
} ], 
"2615" :  [ 
{ 
"stop_id" : 32906,
"arrival_time" : "07:55:00" , 
"departure_time" : "07:56:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 103,
"arrival_time" : "08:04:03" , 
"departure_time" : "08:04:27" , 
"distance_traveled" : 1.8108
}, 
{ 
"stop_id" : 38,
"arrival_time" : "08:08:24" , 
"departure_time" : "08:09:49" , 
"distance_traveled" : 4.1777
}, 
{ 
"stop_id" : 84,
"arrival_time" : "08:15:25" , 
"departure_time" : "08:15:41" , 
"distance_traveled" : 7.2534
}, 
{ 
"stop_id" : 83,
"arrival_time" : "08:19:16" , 
"departure_time" : "08:20:38" , 
"distance_traveled" : 9.857
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:39:22" , 
"departure_time" : "08:40:41" , 
"distance_traveled" : 24.3034
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:48:19" , 
"departure_time" : "08:48:54" , 
"distance_traveled" : 29.3723
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:01:35" , 
"departure_time" : "09:01:35" , 
"distance_traveled" : 34.3608
} ], 
"2616" :  [ 
{ 
"stop_id" : 32906,
"arrival_time" : "06:25:00" , 
"departure_time" : "06:26:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 103,
"arrival_time" : "06:32:38" , 
"departure_time" : "06:32:53" , 
"distance_traveled" : 1.8108
}, 
{ 
"stop_id" : 38,
"arrival_time" : "06:36:15" , 
"departure_time" : "06:37:35" , 
"distance_traveled" : 4.1777
}, 
{ 
"stop_id" : 84,
"arrival_time" : "06:43:20" , 
"departure_time" : "06:43:48" , 
"distance_traveled" : 7.2534
}, 
{ 
"stop_id" : 83,
"arrival_time" : "06:47:28" , 
"departure_time" : "06:48:18" , 
"distance_traveled" : 9.857
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:05:50" , 
"departure_time" : "07:06:49" , 
"distance_traveled" : 24.3034
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:23:59" , 
"departure_time" : "07:23:59" , 
"distance_traveled" : 34.3604
} ], 
"2617" :  [ 
{ 
"stop_id" : 103,
"arrival_time" : "07:07:00" , 
"departure_time" : "07:08:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38,
"arrival_time" : "07:12:12" , 
"departure_time" : "07:13:40" , 
"distance_traveled" : 2.3723
}, 
{ 
"stop_id" : 84,
"arrival_time" : "07:19:28" , 
"departure_time" : "07:20:43" , 
"distance_traveled" : 5.4481
}, 
{ 
"stop_id" : 83,
"arrival_time" : "07:25:15" , 
"departure_time" : "07:26:46" , 
"distance_traveled" : 8.0517
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:45:31" , 
"departure_time" : "07:45:41" , 
"distance_traveled" : 22.4981
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:52:10" , 
"departure_time" : "07:52:47" , 
"distance_traveled" : 27.567
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:06:37" , 
"departure_time" : "08:06:37" , 
"distance_traveled" : 32.5555
} ], 
"2618" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "18:31:00" , 
"departure_time" : "18:31:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "18:37:20" , 
"departure_time" : "18:37:57" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:44:37" , 
"departure_time" : "18:44:58" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "18:59:21" , 
"departure_time" : "19:00:36" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:22:15" , 
"departure_time" : "19:22:25" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:27:10" , 
"departure_time" : "19:27:23" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 105,
"arrival_time" : "19:45:13" , 
"departure_time" : "19:45:13" , 
"distance_traveled" : 57.9102
} ], 
"2619" :  [ 
{ 
"stop_id" : 103,
"arrival_time" : "07:32:00" , 
"departure_time" : "07:33:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38,
"arrival_time" : "07:39:25" , 
"departure_time" : "07:40:35" , 
"distance_traveled" : 2.3723
}, 
{ 
"stop_id" : 84,
"arrival_time" : "07:44:10" , 
"departure_time" : "07:44:22" , 
"distance_traveled" : 5.4481
}, 
{ 
"stop_id" : 83,
"arrival_time" : "07:49:12" , 
"departure_time" : "07:50:02" , 
"distance_traveled" : 8.0517
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:03:50" , 
"departure_time" : "08:04:44" , 
"distance_traveled" : 20.0197
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:10:54" , 
"departure_time" : "08:11:48" , 
"distance_traveled" : 22.4979
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:17:54" , 
"departure_time" : "08:19:16" , 
"distance_traveled" : 27.5667
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:33:22" , 
"departure_time" : "08:33:22" , 
"distance_traveled" : 32.5551
} ], 
"2620" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "08:26:00" , 
"departure_time" : "08:28:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "08:34:11" , 
"departure_time" : "08:35:20" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "08:42:09" , 
"departure_time" : "08:43:17" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "08:56:08" , 
"departure_time" : "08:57:34" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:20:26" , 
"departure_time" : "09:21:57" , 
"distance_traveled" : 47.8536
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:27:31" , 
"departure_time" : "09:28:25" , 
"distance_traveled" : 52.9225
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:40:54" , 
"departure_time" : "09:40:54" , 
"distance_traveled" : 57.9106
} ], 
"2621" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "04:22:00" , 
"departure_time" : "04:22:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "04:28:01" , 
"departure_time" : "04:28:47" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "04:35:46" , 
"departure_time" : "04:36:14" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "04:49:28" , 
"departure_time" : "04:50:47" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 83,
"arrival_time" : "04:59:19" , 
"departure_time" : "05:00:03" , 
"distance_traveled" : 33.417
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "05:12:44" , 
"departure_time" : "05:12:52" , 
"distance_traveled" : 45.3856
}, 
{ 
"stop_id" : 107,
"arrival_time" : "05:19:08" , 
"departure_time" : "05:20:28" , 
"distance_traveled" : 47.8638
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:28:20" , 
"departure_time" : "05:28:22" , 
"distance_traveled" : 52.9326
}, 
{ 
"stop_id" : 105,
"arrival_time" : "05:40:02" , 
"departure_time" : "05:40:02" , 
"distance_traveled" : 57.9206
} ], 
"2622" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "07:16:00" , 
"departure_time" : "07:16:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "07:23:10" , 
"departure_time" : "07:23:32" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "07:31:22" , 
"departure_time" : "07:31:48" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:06:26" , 
"departure_time" : "08:07:46" , 
"distance_traveled" : 47.8536
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:14:20" , 
"departure_time" : "08:14:29" , 
"distance_traveled" : 52.9225
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:28:09" , 
"departure_time" : "08:28:09" , 
"distance_traveled" : 57.911
} ], 
"2623" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "08:06:00" , 
"departure_time" : "08:06:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "08:13:06" , 
"departure_time" : "08:13:29" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "08:20:23" , 
"departure_time" : "08:22:00" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:57:37" , 
"departure_time" : "08:58:07" , 
"distance_traveled" : 47.8536
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:03:30" , 
"departure_time" : "09:05:04" , 
"distance_traveled" : 52.9225
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:17:34" , 
"departure_time" : "09:17:34" , 
"distance_traveled" : 57.911
} ], 
"2624" :  [ 
{ 
"stop_id" : 32906,
"arrival_time" : "06:00:00" , 
"departure_time" : "06:02:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 103,
"arrival_time" : "06:07:56" , 
"departure_time" : "06:08:28" , 
"distance_traveled" : 1.8108
}, 
{ 
"stop_id" : 38,
"arrival_time" : "06:12:32" , 
"departure_time" : "06:12:42" , 
"distance_traveled" : 4.1777
}, 
{ 
"stop_id" : 84,
"arrival_time" : "06:18:10" , 
"departure_time" : "06:18:22" , 
"distance_traveled" : 7.2534
}, 
{ 
"stop_id" : 83,
"arrival_time" : "06:23:12" , 
"departure_time" : "06:23:54" , 
"distance_traveled" : 9.857
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:41:42" , 
"departure_time" : "06:41:44" , 
"distance_traveled" : 24.3034
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:48:02" , 
"departure_time" : "06:48:52" , 
"distance_traveled" : 29.3723
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:02:50" , 
"departure_time" : "07:02:50" , 
"distance_traveled" : 34.3604
} ], 
"2625" :  [ 
{ 
"stop_id" : 32906,
"arrival_time" : "06:52:00" , 
"departure_time" : "06:54:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 103,
"arrival_time" : "07:00:15" , 
"departure_time" : "07:00:20" , 
"distance_traveled" : 1.8108
}, 
{ 
"stop_id" : 38,
"arrival_time" : "07:04:05" , 
"departure_time" : "07:05:37" , 
"distance_traveled" : 4.1777
}, 
{ 
"stop_id" : 84,
"arrival_time" : "07:11:32" , 
"departure_time" : "07:12:46" , 
"distance_traveled" : 7.2534
}, 
{ 
"stop_id" : 83,
"arrival_time" : "07:16:14" , 
"departure_time" : "07:16:40" , 
"distance_traveled" : 9.857
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:34:26" , 
"departure_time" : "07:34:52" , 
"distance_traveled" : 24.3034
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:41:26" , 
"departure_time" : "07:41:55" , 
"distance_traveled" : 29.3723
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:54:29" , 
"departure_time" : "07:54:29" , 
"distance_traveled" : 34.3604
} ], 
"2626" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "08:54:00" , 
"departure_time" : "08:55:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "09:01:57" , 
"departure_time" : "09:02:54" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "09:08:57" , 
"departure_time" : "09:09:48" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "09:22:51" , 
"departure_time" : "09:23:46" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:45:55" , 
"departure_time" : "09:46:55" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:54:00" , 
"departure_time" : "09:54:45" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:00:45" , 
"departure_time" : "10:01:59" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:14:14" , 
"departure_time" : "10:14:14" , 
"distance_traveled" : 57.9102
} ], 
"2627" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "14:59:00" , 
"departure_time" : "15:00:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "15:05:19" , 
"departure_time" : "15:05:32" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:12:13" , 
"departure_time" : "15:12:41" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "15:26:28" , 
"departure_time" : "15:28:06" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "15:49:38" , 
"departure_time" : "15:49:39" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:54:01" , 
"departure_time" : "15:55:31" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:02:30" , 
"departure_time" : "16:02:36" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "16:15:06" , 
"departure_time" : "16:15:06" , 
"distance_traveled" : 57.9102
} ], 
"2628" :  [ 
{ 
"stop_id" : 32906,
"arrival_time" : "07:15:00" , 
"departure_time" : "07:16:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 103,
"arrival_time" : "07:23:12" , 
"departure_time" : "07:23:27" , 
"distance_traveled" : 1.8108
}, 
{ 
"stop_id" : 38,
"arrival_time" : "07:28:15" , 
"departure_time" : "07:28:48" , 
"distance_traveled" : 4.1777
}, 
{ 
"stop_id" : 84,
"arrival_time" : "07:34:33" , 
"departure_time" : "07:34:34" , 
"distance_traveled" : 7.2534
}, 
{ 
"stop_id" : 83,
"arrival_time" : "07:40:01" , 
"departure_time" : "07:41:12" , 
"distance_traveled" : 9.857
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:00:11" , 
"departure_time" : "08:01:44" , 
"distance_traveled" : 24.3034
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:07:33" , 
"departure_time" : "08:07:34" , 
"distance_traveled" : 29.3723
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:21:01" , 
"departure_time" : "08:21:01" , 
"distance_traveled" : 34.3608
} ], 
"2629" :  [ 
{ 
"stop_id" : 32906,
"arrival_time" : "07:36:00" , 
"departure_time" : "07:37:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 103,
"arrival_time" : "07:44:04" , 
"departure_time" : "07:45:13" , 
"distance_traveled" : 1.8108
}, 
{ 
"stop_id" : 38,
"arrival_time" : "07:49:09" , 
"departure_time" : "07:49:19" , 
"distance_traveled" : 4.1777
}, 
{ 
"stop_id" : 84,
"arrival_time" : "07:54:10" , 
"departure_time" : "07:54:42" , 
"distance_traveled" : 7.2534
}, 
{ 
"stop_id" : 83,
"arrival_time" : "07:59:32" , 
"departure_time" : "08:01:00" , 
"distance_traveled" : 9.857
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:17:28" , 
"departure_time" : "08:19:03" , 
"distance_traveled" : 24.3034
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:24:35" , 
"departure_time" : "08:25:57" , 
"distance_traveled" : 29.3723
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:37:22" , 
"departure_time" : "08:37:22" , 
"distance_traveled" : 34.3608
} ], 
"2630" :  [ 
{ 
"stop_id" : 32906,
"arrival_time" : "07:55:00" , 
"departure_time" : "07:57:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 103,
"arrival_time" : "08:04:11" , 
"departure_time" : "08:05:03" , 
"distance_traveled" : 1.8108
}, 
{ 
"stop_id" : 38,
"arrival_time" : "08:08:52" , 
"departure_time" : "08:10:25" , 
"distance_traveled" : 4.1777
}, 
{ 
"stop_id" : 84,
"arrival_time" : "08:15:33" , 
"departure_time" : "08:15:47" , 
"distance_traveled" : 7.2534
}, 
{ 
"stop_id" : 83,
"arrival_time" : "08:19:14" , 
"departure_time" : "08:19:25" , 
"distance_traveled" : 9.857
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:38:11" , 
"departure_time" : "08:39:41" , 
"distance_traveled" : 24.3034
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:48:30" , 
"departure_time" : "08:50:05" , 
"distance_traveled" : 29.3723
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:02:35" , 
"departure_time" : "09:02:35" , 
"distance_traveled" : 34.3608
} ], 
"2631" :  [ 
{ 
"stop_id" : 103,
"arrival_time" : "07:07:00" , 
"departure_time" : "07:09:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38,
"arrival_time" : "07:12:31" , 
"departure_time" : "07:13:02" , 
"distance_traveled" : 2.3723
}, 
{ 
"stop_id" : 84,
"arrival_time" : "07:18:31" , 
"departure_time" : "07:18:50" , 
"distance_traveled" : 5.4481
}, 
{ 
"stop_id" : 83,
"arrival_time" : "07:24:19" , 
"departure_time" : "07:24:25" , 
"distance_traveled" : 8.0517
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:44:06" , 
"departure_time" : "07:44:52" , 
"distance_traveled" : 22.4981
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:52:46" , 
"departure_time" : "07:52:57" , 
"distance_traveled" : 27.567
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:06:11" , 
"departure_time" : "08:06:11" , 
"distance_traveled" : 32.5555
} ], 
"2632" :  [ 
{ 
"stop_id" : 103,
"arrival_time" : "07:32:00" , 
"departure_time" : "07:33:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38,
"arrival_time" : "07:39:15" , 
"departure_time" : "07:40:18" , 
"distance_traveled" : 2.3723
}, 
{ 
"stop_id" : 84,
"arrival_time" : "07:44:03" , 
"departure_time" : "07:45:34" , 
"distance_traveled" : 5.4481
}, 
{ 
"stop_id" : 83,
"arrival_time" : "07:50:31" , 
"departure_time" : "07:50:50" , 
"distance_traveled" : 8.0517
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:03:19" , 
"departure_time" : "08:04:01" , 
"distance_traveled" : 20.0197
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:10:42" , 
"departure_time" : "08:10:45" , 
"distance_traveled" : 22.4979
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:17:03" , 
"departure_time" : "08:17:24" , 
"distance_traveled" : 27.5667
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:32:21" , 
"departure_time" : "08:32:21" , 
"distance_traveled" : 32.5551
} ], 
"2633" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "04:22:00" , 
"departure_time" : "04:23:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "04:28:57" , 
"departure_time" : "04:29:49" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "04:35:52" , 
"departure_time" : "04:36:59" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "04:50:07" , 
"departure_time" : "04:50:25" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 83,
"arrival_time" : "04:58:18" , 
"departure_time" : "04:58:39" , 
"distance_traveled" : 33.417
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "05:12:21" , 
"departure_time" : "05:13:31" , 
"distance_traveled" : 45.3856
}, 
{ 
"stop_id" : 107,
"arrival_time" : "05:20:10" , 
"departure_time" : "05:20:32" , 
"distance_traveled" : 47.8638
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:27:22" , 
"departure_time" : "05:27:30" , 
"distance_traveled" : 52.9326
}, 
{ 
"stop_id" : 105,
"arrival_time" : "05:40:08" , 
"departure_time" : "05:40:08" , 
"distance_traveled" : 57.9206
} ], 
"2634" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "13:58:00" , 
"departure_time" : "13:59:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "14:06:21" , 
"departure_time" : "14:07:51" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "14:13:30" , 
"departure_time" : "14:13:53" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "14:27:23" , 
"departure_time" : "14:28:12" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "14:31:49" , 
"departure_time" : "14:31:53" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "14:36:04" , 
"departure_time" : "14:37:27" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "14:42:23" , 
"departure_time" : "14:43:44" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "14:49:21" , 
"departure_time" : "14:50:36" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "14:53:15" , 
"departure_time" : "14:54:25" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "15:00:10" , 
"departure_time" : "15:01:46" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "15:03:36" , 
"departure_time" : "15:03:43" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "15:06:07" , 
"departure_time" : "15:06:17" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:12:10" , 
"departure_time" : "15:12:55" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:20:45" , 
"departure_time" : "15:20:49" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "15:34:04" , 
"departure_time" : "15:34:04" , 
"distance_traveled" : 57.91
} ], 
"2635" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "06:29:00" , 
"departure_time" : "06:30:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "06:36:27" , 
"departure_time" : "06:36:38" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "06:42:11" , 
"departure_time" : "06:42:35" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "06:58:24" , 
"departure_time" : "06:59:49" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "07:03:25" , 
"departure_time" : "07:03:39" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "07:07:14" , 
"departure_time" : "07:08:54" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "07:13:40" , 
"departure_time" : "07:15:00" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "07:26:20" , 
"departure_time" : "07:27:13" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:32:53" , 
"departure_time" : "07:33:42" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:50:49" , 
"departure_time" : "07:50:49" , 
"distance_traveled" : 57.9102
} ], 
"2636" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "12:18:00" , 
"departure_time" : "12:19:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "12:24:15" , 
"departure_time" : "12:25:37" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "12:32:22" , 
"departure_time" : "12:32:30" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "12:48:08" , 
"departure_time" : "12:48:59" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "12:53:51" , 
"departure_time" : "12:54:28" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "12:58:37" , 
"departure_time" : "12:59:01" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "13:03:24" , 
"departure_time" : "13:03:49" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:18:25" , 
"departure_time" : "13:19:30" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:25:05" , 
"departure_time" : "13:25:27" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:31:22" , 
"departure_time" : "13:32:04" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "13:44:42" , 
"departure_time" : "13:44:42" , 
"distance_traveled" : 57.9102
} ], 
"2637" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "13:18:00" , 
"departure_time" : "13:19:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "13:24:30" , 
"departure_time" : "13:25:20" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:31:50" , 
"departure_time" : "13:31:57" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "13:48:07" , 
"departure_time" : "13:49:10" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "13:54:03" , 
"departure_time" : "13:54:15" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "13:58:12" , 
"departure_time" : "13:58:58" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "14:03:46" , 
"departure_time" : "14:04:19" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "14:18:33" , 
"departure_time" : "14:18:55" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:24:22" , 
"departure_time" : "14:24:47" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:31:25" , 
"departure_time" : "14:31:33" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "14:44:08" , 
"departure_time" : "14:44:08" , 
"distance_traveled" : 57.9102
} ], 
"2638" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "16:18:00" , 
"departure_time" : "16:19:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "16:25:10" , 
"departure_time" : "16:26:05" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:31:55" , 
"departure_time" : "16:32:41" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "16:48:46" , 
"departure_time" : "16:49:05" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "16:53:19" , 
"departure_time" : "16:54:45" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "16:59:26" , 
"departure_time" : "17:00:18" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "17:03:52" , 
"departure_time" : "17:05:07" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:21:15" , 
"departure_time" : "17:21:44" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:28:29" , 
"departure_time" : "17:28:34" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:37:05" , 
"departure_time" : "17:37:38" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "17:50:33" , 
"departure_time" : "17:50:33" , 
"distance_traveled" : 57.9102
} ], 
"2639" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "12:57:00" , 
"departure_time" : "12:58:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "13:04:20" , 
"departure_time" : "13:05:17" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:10:57" , 
"departure_time" : "13:11:33" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "13:26:36" , 
"departure_time" : "13:28:14" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "13:31:38" , 
"departure_time" : "13:32:35" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "13:35:57" , 
"departure_time" : "13:36:47" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "13:40:50" , 
"departure_time" : "13:41:31" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "13:47:41" , 
"departure_time" : "13:48:59" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "13:52:18" , 
"departure_time" : "13:53:30" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "13:59:12" , 
"departure_time" : "14:00:22" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "14:02:10" , 
"departure_time" : "14:03:00" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "14:04:50" , 
"departure_time" : "14:06:05" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:11:15" , 
"departure_time" : "14:12:14" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:18:59" , 
"departure_time" : "14:20:36" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "14:34:37" , 
"departure_time" : "14:34:37" , 
"distance_traveled" : 57.9104
} ], 
"2640" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "25:11:00" , 
"departure_time" : "25:12:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "25:17:20" , 
"departure_time" : "25:17:43" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "25:24:23" , 
"departure_time" : "25:24:43" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "25:40:20" , 
"departure_time" : "25:41:03" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "25:44:43" , 
"departure_time" : "25:46:00" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "25:50:17" , 
"departure_time" : "25:50:40" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "25:54:23" , 
"departure_time" : "25:55:12" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "26:01:49" , 
"departure_time" : "26:02:49" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "26:06:00" , 
"departure_time" : "26:06:58" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "26:12:58" , 
"departure_time" : "26:12:59" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "26:15:01" , 
"departure_time" : "26:15:40" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "26:19:39" , 
"departure_time" : "26:20:58" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "26:26:19" , 
"departure_time" : "26:27:18" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "26:33:59" , 
"departure_time" : "26:35:16" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "26:47:17" , 
"departure_time" : "26:47:17" , 
"distance_traveled" : 57.91
} ], 
"2641" :  [ 
{ 
"stop_id" : 103,
"arrival_time" : "05:17:00" , 
"departure_time" : "05:19:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38,
"arrival_time" : "05:23:09" , 
"departure_time" : "05:23:54" , 
"distance_traveled" : 2.3723
}, 
{ 
"stop_id" : 84,
"arrival_time" : "05:27:45" , 
"departure_time" : "05:28:51" , 
"distance_traveled" : 5.4481
}, 
{ 
"stop_id" : 83,
"arrival_time" : "05:33:06" , 
"departure_time" : "05:34:22" , 
"distance_traveled" : 8.0517
}, 
{ 
"stop_id" : 127,
"arrival_time" : "05:40:16" , 
"departure_time" : "05:40:40" , 
"distance_traveled" : 11.8517
}, 
{ 
"stop_id" : 70,
"arrival_time" : "05:43:24" , 
"departure_time" : "05:44:19" , 
"distance_traveled" : 13.9102
}, 
{ 
"stop_id" : 41,
"arrival_time" : "05:49:55" , 
"departure_time" : "05:51:17" , 
"distance_traveled" : 17.1938
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "05:55:22" , 
"departure_time" : "05:56:46" , 
"distance_traveled" : 20.0195
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:01:24" , 
"departure_time" : "06:03:00" , 
"distance_traveled" : 22.4977
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:12:36" , 
"departure_time" : "06:14:06" , 
"distance_traveled" : 27.5665
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:26:30" , 
"departure_time" : "06:26:30" , 
"distance_traveled" : 32.5549
} ], 
"2642" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "05:47:00" , 
"departure_time" : "05:49:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "05:54:20" , 
"departure_time" : "05:54:24" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "05:59:04" , 
"departure_time" : "05:59:53" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "06:16:49" , 
"departure_time" : "06:18:13" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "06:21:24" , 
"departure_time" : "06:22:17" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "06:25:53" , 
"departure_time" : "06:26:41" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "06:30:48" , 
"departure_time" : "06:31:32" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "06:43:44" , 
"departure_time" : "06:44:16" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:49:32" , 
"departure_time" : "06:49:59" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:56:27" , 
"departure_time" : "06:56:41" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:09:14" , 
"departure_time" : "07:09:14" , 
"distance_traveled" : 57.9102
} ], 
"2643" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "06:43:00" , 
"departure_time" : "06:43:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "06:49:22" , 
"departure_time" : "06:50:51" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "06:56:29" , 
"departure_time" : "06:57:48" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "07:13:19" , 
"departure_time" : "07:13:48" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "07:16:29" , 
"departure_time" : "07:17:12" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "07:21:43" , 
"departure_time" : "07:22:15" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "07:26:32" , 
"departure_time" : "07:27:20" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "07:39:48" , 
"departure_time" : "07:40:41" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:46:53" , 
"departure_time" : "07:47:27" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:53:34" , 
"departure_time" : "07:54:51" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:08:17" , 
"departure_time" : "08:08:17" , 
"distance_traveled" : 57.9102
} ], 
"2644" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "08:10:00" , 
"departure_time" : "08:12:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "08:17:04" , 
"departure_time" : "08:18:20" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "08:24:16" , 
"departure_time" : "08:25:11" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "08:40:55" , 
"departure_time" : "08:41:07" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "08:45:12" , 
"departure_time" : "08:45:20" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "08:51:08" , 
"departure_time" : "08:52:20" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "08:57:12" , 
"departure_time" : "08:58:35" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:10:23" , 
"departure_time" : "09:10:25" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:16:02" , 
"departure_time" : "09:17:25" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:24:23" , 
"departure_time" : "09:25:14" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:36:51" , 
"departure_time" : "09:36:51" , 
"distance_traveled" : 57.9102
} ], 
"2645" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "03:57:00" , 
"departure_time" : "03:58:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "04:03:19" , 
"departure_time" : "04:04:46" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "04:11:27" , 
"departure_time" : "04:11:36" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "04:27:09" , 
"departure_time" : "04:27:47" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "04:32:38" , 
"departure_time" : "04:34:16" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "04:38:38" , 
"departure_time" : "04:38:43" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "04:42:05" , 
"departure_time" : "04:42:53" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "04:49:48" , 
"departure_time" : "04:50:38" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "04:53:50" , 
"departure_time" : "04:54:46" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "04:59:56" , 
"departure_time" : "05:00:53" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "05:04:57" , 
"departure_time" : "05:06:10" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "05:11:13" , 
"departure_time" : "05:12:07" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:21:54" , 
"departure_time" : "05:21:59" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "05:35:05" , 
"departure_time" : "05:35:05" , 
"distance_traveled" : 57.91
} ], 
"2646" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "25:11:00" , 
"departure_time" : "25:11:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "25:17:13" , 
"departure_time" : "25:17:39" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "25:24:26" , 
"departure_time" : "25:25:13" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "25:40:47" , 
"departure_time" : "25:41:26" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "25:44:39" , 
"departure_time" : "25:46:12" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "25:50:33" , 
"departure_time" : "25:51:11" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "25:54:38" , 
"departure_time" : "25:55:22" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "26:01:44" , 
"departure_time" : "26:02:20" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "26:05:36" , 
"departure_time" : "26:06:38" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "26:13:02" , 
"departure_time" : "26:13:26" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "26:15:24" , 
"departure_time" : "26:16:37" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "26:20:13" , 
"departure_time" : "26:21:06" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "26:25:53" , 
"departure_time" : "26:27:13" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "26:34:20" , 
"departure_time" : "26:35:32" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "26:47:12" , 
"departure_time" : "26:47:12" , 
"distance_traveled" : 57.9104
} ], 
"2647" :  [ 
{ 
"stop_id" : 103,
"arrival_time" : "05:17:00" , 
"departure_time" : "05:18:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38,
"arrival_time" : "05:22:32" , 
"departure_time" : "05:23:49" , 
"distance_traveled" : 2.3723
}, 
{ 
"stop_id" : 84,
"arrival_time" : "05:28:17" , 
"departure_time" : "05:29:27" , 
"distance_traveled" : 5.4481
}, 
{ 
"stop_id" : 83,
"arrival_time" : "05:33:10" , 
"departure_time" : "05:33:24" , 
"distance_traveled" : 8.0517
}, 
{ 
"stop_id" : 127,
"arrival_time" : "05:39:14" , 
"departure_time" : "05:40:09" , 
"distance_traveled" : 11.8517
}, 
{ 
"stop_id" : 70,
"arrival_time" : "05:43:55" , 
"departure_time" : "05:44:00" , 
"distance_traveled" : 13.9102
}, 
{ 
"stop_id" : 41,
"arrival_time" : "05:49:05" , 
"departure_time" : "05:50:26" , 
"distance_traveled" : 17.1938
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "05:55:21" , 
"departure_time" : "05:56:12" , 
"distance_traveled" : 20.0195
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:00:51" , 
"departure_time" : "06:01:30" , 
"distance_traveled" : 22.4977
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:11:39" , 
"departure_time" : "06:12:33" , 
"distance_traveled" : 27.5665
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:25:54" , 
"departure_time" : "06:25:54" , 
"distance_traveled" : 32.5549
} ], 
"2648" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "07:18:00" , 
"departure_time" : "07:19:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "07:24:25" , 
"departure_time" : "07:25:10" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "07:31:45" , 
"departure_time" : "07:32:26" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "07:48:41" , 
"departure_time" : "07:50:19" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "07:54:38" , 
"departure_time" : "07:54:41" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "07:58:03" , 
"departure_time" : "07:58:25" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "08:03:22" , 
"departure_time" : "08:04:38" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:20:16" , 
"departure_time" : "08:21:23" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:27:07" , 
"departure_time" : "08:27:21" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:33:14" , 
"departure_time" : "08:33:48" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:46:34" , 
"departure_time" : "08:46:34" , 
"distance_traveled" : 57.9102
} ], 
"2649" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "08:18:00" , 
"departure_time" : "08:19:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "08:24:52" , 
"departure_time" : "08:26:31" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "08:32:39" , 
"departure_time" : "08:33:48" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "08:49:09" , 
"departure_time" : "08:50:34" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "08:54:25" , 
"departure_time" : "08:54:48" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "08:58:23" , 
"departure_time" : "08:58:45" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "09:03:22" , 
"departure_time" : "09:04:19" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:21:57" , 
"departure_time" : "09:22:39" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:29:42" , 
"departure_time" : "09:29:52" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:36:10" , 
"departure_time" : "09:37:03" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:48:53" , 
"departure_time" : "09:48:53" , 
"distance_traveled" : 57.9102
} ], 
"2650" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "09:18:00" , 
"departure_time" : "09:19:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "09:24:35" , 
"departure_time" : "09:25:13" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "09:31:38" , 
"departure_time" : "09:32:46" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "09:49:08" , 
"departure_time" : "09:50:43" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "09:54:35" , 
"departure_time" : "09:54:59" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "09:58:24" , 
"departure_time" : "09:59:33" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "10:04:09" , 
"departure_time" : "10:05:48" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:19:39" , 
"departure_time" : "10:19:57" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:24:18" , 
"departure_time" : "10:25:51" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:32:33" , 
"departure_time" : "10:33:55" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:44:22" , 
"departure_time" : "10:44:22" , 
"distance_traveled" : 57.9102
} ], 
"2651" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "11:18:00" , 
"departure_time" : "11:20:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "11:24:59" , 
"departure_time" : "11:25:25" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "11:31:26" , 
"departure_time" : "11:33:00" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "11:49:34" , 
"departure_time" : "11:51:13" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "11:54:39" , 
"departure_time" : "11:55:50" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "11:59:11" , 
"departure_time" : "11:59:34" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "12:03:23" , 
"departure_time" : "12:04:12" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "12:18:49" , 
"departure_time" : "12:20:22" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:26:33" , 
"departure_time" : "12:27:23" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:32:50" , 
"departure_time" : "12:34:05" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "12:45:15" , 
"departure_time" : "12:45:15" , 
"distance_traveled" : 57.9102
} ], 
"2652" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "15:22:00" , 
"departure_time" : "15:23:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "15:29:14" , 
"departure_time" : "15:29:40" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:36:26" , 
"departure_time" : "15:37:08" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "15:51:42" , 
"departure_time" : "15:52:22" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "15:55:40" , 
"departure_time" : "15:56:35" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "16:01:55" , 
"departure_time" : "16:02:21" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "16:06:26" , 
"departure_time" : "16:06:39" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:20:13" , 
"departure_time" : "16:20:52" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:26:39" , 
"departure_time" : "16:28:15" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:34:36" , 
"departure_time" : "16:35:10" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "16:46:34" , 
"departure_time" : "16:46:34" , 
"distance_traveled" : 57.9102
} ], 
"2653" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "18:15:00" , 
"departure_time" : "18:16:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "18:21:38" , 
"departure_time" : "18:21:46" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:28:08" , 
"departure_time" : "18:28:10" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "18:45:02" , 
"departure_time" : "18:46:18" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "18:51:16" , 
"departure_time" : "18:52:31" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "18:56:15" , 
"departure_time" : "18:57:37" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "19:01:22" , 
"departure_time" : "19:02:42" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:16:20" , 
"departure_time" : "19:16:33" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:22:13" , 
"departure_time" : "19:22:21" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:29:08" , 
"departure_time" : "19:30:37" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "19:44:29" , 
"departure_time" : "19:44:29" , 
"distance_traveled" : 57.9102
} ], 
"2654" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "10:21:00" , 
"departure_time" : "10:23:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "10:27:33" , 
"departure_time" : "10:28:08" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "10:34:35" , 
"departure_time" : "10:35:49" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "10:51:14" , 
"departure_time" : "10:51:54" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "10:54:40" , 
"departure_time" : "10:54:59" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "10:59:19" , 
"departure_time" : "11:00:56" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "11:05:37" , 
"departure_time" : "11:06:41" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "11:20:04" , 
"departure_time" : "11:21:37" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:27:33" , 
"departure_time" : "11:27:50" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:33:17" , 
"departure_time" : "11:33:54" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "11:46:37" , 
"departure_time" : "11:46:37" , 
"distance_traveled" : 57.9106
} ], 
"2655" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "05:01:00" , 
"departure_time" : "05:01:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "05:07:02" , 
"departure_time" : "05:07:39" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "05:14:37" , 
"departure_time" : "05:15:22" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "05:30:45" , 
"departure_time" : "05:30:48" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "05:34:03" , 
"departure_time" : "05:34:56" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "05:39:53" , 
"departure_time" : "05:40:02" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "05:44:09" , 
"departure_time" : "05:45:25" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "05:52:16" , 
"departure_time" : "05:53:56" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "05:56:40" , 
"departure_time" : "05:57:16" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "06:02:36" , 
"departure_time" : "06:02:50" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "06:07:14" , 
"departure_time" : "06:07:51" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:13:37" , 
"departure_time" : "06:14:12" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:21:35" , 
"departure_time" : "06:21:53" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:35:18" , 
"departure_time" : "06:35:18" , 
"distance_traveled" : 57.91
} ], 
"2656" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "05:58:00" , 
"departure_time" : "05:59:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "06:05:30" , 
"departure_time" : "06:05:56" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "06:11:26" , 
"departure_time" : "06:12:26" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "06:28:00" , 
"departure_time" : "06:28:59" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "06:31:59" , 
"departure_time" : "06:32:50" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "06:36:51" , 
"departure_time" : "06:37:40" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "06:41:49" , 
"departure_time" : "06:42:38" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "06:48:49" , 
"departure_time" : "06:48:54" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "06:52:05" , 
"departure_time" : "06:52:25" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "06:59:20" , 
"departure_time" : "06:59:34" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "07:04:14" , 
"departure_time" : "07:04:18" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:10:04" , 
"departure_time" : "07:11:32" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:19:28" , 
"departure_time" : "07:20:58" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:36:30" , 
"departure_time" : "07:36:30" , 
"distance_traveled" : 57.91
} ], 
"2657" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "06:58:00" , 
"departure_time" : "07:00:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "07:05:09" , 
"departure_time" : "07:05:32" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "07:11:23" , 
"departure_time" : "07:11:32" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "07:27:09" , 
"departure_time" : "07:27:41" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "07:31:32" , 
"departure_time" : "07:32:53" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "07:37:21" , 
"departure_time" : "07:38:46" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "07:42:25" , 
"departure_time" : "07:42:42" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "07:48:17" , 
"departure_time" : "07:48:42" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "07:52:25" , 
"departure_time" : "07:53:03" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "07:59:38" , 
"departure_time" : "08:00:19" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:04:41" , 
"departure_time" : "08:04:53" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:10:12" , 
"departure_time" : "08:10:22" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:18:10" , 
"departure_time" : "08:19:39" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:33:29" , 
"departure_time" : "08:33:29" , 
"distance_traveled" : 57.91
} ], 
"2658" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "07:58:00" , 
"departure_time" : "08:00:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "08:05:28" , 
"departure_time" : "08:06:47" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "08:12:19" , 
"departure_time" : "08:13:38" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "08:28:19" , 
"departure_time" : "08:28:22" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "08:31:03" , 
"departure_time" : "08:31:46" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "08:36:43" , 
"departure_time" : "08:37:03" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "08:41:20" , 
"departure_time" : "08:41:26" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:48:06" , 
"departure_time" : "08:49:38" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "08:53:32" , 
"departure_time" : "08:54:38" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "09:00:06" , 
"departure_time" : "09:01:46" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:05:40" , 
"departure_time" : "09:05:45" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:10:05" , 
"departure_time" : "09:10:15" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:18:10" , 
"departure_time" : "09:19:31" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:33:21" , 
"departure_time" : "09:33:21" , 
"distance_traveled" : 57.91
} ], 
"2659" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "09:00:00" , 
"departure_time" : "09:02:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "09:07:04" , 
"departure_time" : "09:07:51" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "09:13:47" , 
"departure_time" : "09:15:21" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "09:30:34" , 
"departure_time" : "09:31:43" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "09:34:09" , 
"departure_time" : "09:35:46" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "09:39:37" , 
"departure_time" : "09:40:24" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "09:43:47" , 
"departure_time" : "09:44:19" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "09:50:32" , 
"departure_time" : "09:51:03" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "09:54:31" , 
"departure_time" : "09:55:09" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "10:01:38" , 
"departure_time" : "10:02:01" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:06:23" , 
"departure_time" : "10:07:30" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:13:07" , 
"departure_time" : "10:14:07" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:22:00" , 
"departure_time" : "10:22:50" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:34:50" , 
"departure_time" : "10:34:50" , 
"distance_traveled" : 57.91
} ], 
"2660" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "10:00:00" , 
"departure_time" : "10:01:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "10:06:51" , 
"departure_time" : "10:07:40" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "10:13:49" , 
"departure_time" : "10:15:15" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "10:30:26" , 
"departure_time" : "10:31:06" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "10:33:40" , 
"departure_time" : "10:33:51" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "10:38:11" , 
"departure_time" : "10:39:38" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "10:44:27" , 
"departure_time" : "10:45:21" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "10:50:54" , 
"departure_time" : "10:50:58" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "10:54:04" , 
"departure_time" : "10:54:22" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "11:01:18" , 
"departure_time" : "11:02:51" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "11:07:33" , 
"departure_time" : "11:08:29" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:12:56" , 
"departure_time" : "11:13:07" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:20:11" , 
"departure_time" : "11:21:47" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "11:35:36" , 
"departure_time" : "11:35:36" , 
"distance_traveled" : 57.91
} ], 
"2661" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "19:09:00" , 
"departure_time" : "19:11:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "19:15:51" , 
"departure_time" : "19:16:03" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:22:12" , 
"departure_time" : "19:22:29" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "19:39:17" , 
"departure_time" : "19:40:41" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "19:45:24" , 
"departure_time" : "19:45:43" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "19:49:19" , 
"departure_time" : "19:50:04" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "19:54:45" , 
"departure_time" : "19:55:28" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:01:43" , 
"departure_time" : "20:01:52" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "20:05:09" , 
"departure_time" : "20:06:36" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "20:12:27" , 
"departure_time" : "20:13:45" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:17:18" , 
"departure_time" : "20:17:42" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:22:24" , 
"departure_time" : "20:22:29" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:29:05" , 
"departure_time" : "20:30:26" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "20:43:21" , 
"departure_time" : "20:43:21" , 
"distance_traveled" : 57.91
} ], 
"2662" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "19:56:00" , 
"departure_time" : "19:58:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "20:03:18" , 
"departure_time" : "20:04:28" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "20:10:10" , 
"departure_time" : "20:10:58" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "20:25:48" , 
"departure_time" : "20:26:22" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "20:29:34" , 
"departure_time" : "20:30:23" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "20:34:49" , 
"departure_time" : "20:34:51" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "20:39:02" , 
"departure_time" : "20:39:39" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:47:37" , 
"departure_time" : "20:49:09" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "20:53:32" , 
"departure_time" : "20:54:31" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "20:59:59" , 
"departure_time" : "21:01:33" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "21:05:34" , 
"departure_time" : "21:05:59" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:10:25" , 
"departure_time" : "21:11:54" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:19:29" , 
"departure_time" : "21:21:09" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "21:34:40" , 
"departure_time" : "21:34:40" , 
"distance_traveled" : 57.91
} ], 
"2663" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "21:09:00" , 
"departure_time" : "21:10:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "21:15:04" , 
"departure_time" : "21:16:05" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "21:23:01" , 
"departure_time" : "21:24:04" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "21:40:03" , 
"departure_time" : "21:40:21" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "21:44:18" , 
"departure_time" : "21:44:38" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "21:49:20" , 
"departure_time" : "21:49:52" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "21:54:32" , 
"departure_time" : "21:55:17" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "22:01:45" , 
"departure_time" : "22:02:44" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "22:05:59" , 
"departure_time" : "22:06:45" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "22:11:46" , 
"departure_time" : "22:12:18" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:16:32" , 
"departure_time" : "22:17:58" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:23:26" , 
"departure_time" : "22:24:37" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:30:11" , 
"departure_time" : "22:31:14" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "22:43:03" , 
"departure_time" : "22:43:03" , 
"distance_traveled" : 57.91
} ], 
"2664" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "21:58:00" , 
"departure_time" : "22:00:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "22:05:04" , 
"departure_time" : "22:06:21" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "22:12:17" , 
"departure_time" : "22:12:42" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "22:27:25" , 
"departure_time" : "22:28:32" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "22:32:07" , 
"departure_time" : "22:32:21" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "22:36:14" , 
"departure_time" : "22:36:51" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "22:41:37" , 
"departure_time" : "22:42:26" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "22:48:49" , 
"departure_time" : "22:50:07" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "22:53:18" , 
"departure_time" : "22:53:26" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "22:59:08" , 
"departure_time" : "22:59:43" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "23:04:35" , 
"departure_time" : "23:05:48" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "23:11:13" , 
"departure_time" : "23:11:27" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:17:14" , 
"departure_time" : "23:17:53" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "23:32:39" , 
"departure_time" : "23:32:39" , 
"distance_traveled" : 57.91
} ], 
"2665" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "23:58:00" , 
"departure_time" : "23:59:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "24:04:37" , 
"departure_time" : "24:05:35" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "24:11:58" , 
"departure_time" : "24:12:27" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "24:27:29" , 
"departure_time" : "24:28:07" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "24:31:38" , 
"departure_time" : "24:33:06" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "24:37:28" , 
"departure_time" : "24:39:01" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "24:42:33" , 
"departure_time" : "24:43:02" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "24:48:29" , 
"departure_time" : "24:49:57" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "24:53:28" , 
"departure_time" : "24:54:02" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "24:59:34" , 
"departure_time" : "25:00:35" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "25:05:01" , 
"departure_time" : "25:05:44" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "25:10:43" , 
"departure_time" : "25:12:06" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "25:18:23" , 
"departure_time" : "25:18:49" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "25:36:26" , 
"departure_time" : "25:36:26" , 
"distance_traveled" : 57.91
} ], 
"2666" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "17:00:00" , 
"departure_time" : "17:00:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "17:06:08" , 
"departure_time" : "17:06:28" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:13:20" , 
"departure_time" : "17:13:40" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "17:29:20" , 
"departure_time" : "17:30:07" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "17:33:47" , 
"departure_time" : "17:33:58" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "17:38:11" , 
"departure_time" : "17:39:27" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "17:44:16" , 
"departure_time" : "17:45:34" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "17:51:18" , 
"departure_time" : "17:52:43" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "17:55:25" , 
"departure_time" : "17:55:28" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "18:01:03" , 
"departure_time" : "18:02:08" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:07:05" , 
"departure_time" : "18:07:22" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:12:17" , 
"departure_time" : "18:13:36" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:21:19" , 
"departure_time" : "18:22:30" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:34:11" , 
"departure_time" : "18:34:11" , 
"distance_traveled" : 57.91
} ], 
"2667" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "18:00:00" , 
"departure_time" : "18:01:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "18:06:42" , 
"departure_time" : "18:07:23" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:13:41" , 
"departure_time" : "18:14:53" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "18:30:12" , 
"departure_time" : "18:31:21" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "18:34:09" , 
"departure_time" : "18:34:44" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "18:38:35" , 
"departure_time" : "18:39:57" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "18:44:22" , 
"departure_time" : "18:45:32" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:51:10" , 
"departure_time" : "18:51:25" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "18:54:15" , 
"departure_time" : "18:54:40" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "19:01:25" , 
"departure_time" : "19:01:47" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:06:22" , 
"departure_time" : "19:06:25" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:12:03" , 
"departure_time" : "19:12:44" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:20:41" , 
"departure_time" : "19:21:32" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "19:33:51" , 
"departure_time" : "19:33:51" , 
"distance_traveled" : 57.91
} ], 
"2668" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "10:58:00" , 
"departure_time" : "11:00:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "11:05:29" , 
"departure_time" : "11:06:39" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "11:12:10" , 
"departure_time" : "11:13:31" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "11:28:21" , 
"departure_time" : "11:29:02" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "11:31:41" , 
"departure_time" : "11:31:47" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "11:36:06" , 
"departure_time" : "11:37:27" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "11:42:21" , 
"departure_time" : "11:43:19" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "11:48:58" , 
"departure_time" : "11:48:59" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "11:52:01" , 
"departure_time" : "11:52:47" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "11:59:46" , 
"departure_time" : "12:01:16" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "12:03:30" , 
"departure_time" : "12:05:03" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "12:07:33" , 
"departure_time" : "12:07:34" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:12:01" , 
"departure_time" : "12:13:01" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:21:00" , 
"departure_time" : "12:22:27" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "12:37:27" , 
"departure_time" : "12:37:27" , 
"distance_traveled" : 57.91
} ], 
"2669" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "22:57:00" , 
"departure_time" : "22:58:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "23:04:15" , 
"departure_time" : "23:05:29" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "23:12:14" , 
"departure_time" : "23:12:40" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "23:27:26" , 
"departure_time" : "23:28:37" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "23:32:11" , 
"departure_time" : "23:33:34" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "23:37:23" , 
"departure_time" : "23:38:09" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "23:41:46" , 
"departure_time" : "23:41:58" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "23:48:12" , 
"departure_time" : "23:48:27" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "23:52:15" , 
"departure_time" : "23:53:26" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "24:00:11" , 
"departure_time" : "24:01:50" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 109,
"arrival_time" : "24:03:39" , 
"departure_time" : "24:04:37" , 
"distance_traveled" : 43.525
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "24:06:58" , 
"departure_time" : "24:07:12" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "24:12:14" , 
"departure_time" : "24:12:29" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:19:15" , 
"departure_time" : "24:19:52" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "24:32:37" , 
"departure_time" : "24:32:37" , 
"distance_traveled" : 57.91
} ], 
"2670" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "17:19:00" , 
"departure_time" : "17:19:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "17:25:15" , 
"departure_time" : "17:26:07" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:32:52" , 
"departure_time" : "17:34:04" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "17:50:12" , 
"departure_time" : "17:50:55" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "17:54:43" , 
"departure_time" : "17:54:48" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "17:59:05" , 
"departure_time" : "18:00:04" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "18:04:59" , 
"departure_time" : "18:06:34" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:19:35" , 
"departure_time" : "18:20:52" , 
"distance_traveled" : 45.3752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:25:17" , 
"departure_time" : "18:26:13" , 
"distance_traveled" : 47.8534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:31:56" , 
"departure_time" : "18:33:27" , 
"distance_traveled" : 52.9222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:45:31" , 
"departure_time" : "18:45:31" , 
"distance_traveled" : 57.9102
} ], 
"2671" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "12:00:00" , 
"departure_time" : "12:02:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "12:07:18" , 
"departure_time" : "12:08:24" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "12:14:06" , 
"departure_time" : "12:14:52" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "12:29:46" , 
"departure_time" : "12:30:59" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "12:34:13" , 
"departure_time" : "12:35:12" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "12:38:59" , 
"departure_time" : "12:39:31" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "12:43:32" , 
"departure_time" : "12:44:37" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "12:51:05" , 
"departure_time" : "12:52:03" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "12:54:58" , 
"departure_time" : "12:55:56" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "13:01:58" , 
"departure_time" : "13:02:17" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:06:19" , 
"departure_time" : "13:07:53" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:13:34" , 
"departure_time" : "13:14:25" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:20:51" , 
"departure_time" : "13:21:24" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "13:34:33" , 
"departure_time" : "13:34:33" , 
"distance_traveled" : 57.91
} ], 
"2672" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "14:58:00" , 
"departure_time" : "15:00:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "15:05:34" , 
"departure_time" : "15:06:50" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:12:16" , 
"departure_time" : "15:13:15" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "15:27:59" , 
"departure_time" : "15:29:34" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "15:32:35" , 
"departure_time" : "15:33:44" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "15:37:09" , 
"departure_time" : "15:38:25" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "15:42:16" , 
"departure_time" : "15:43:19" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "15:49:03" , 
"departure_time" : "15:50:34" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "15:53:31" , 
"departure_time" : "15:53:56" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "15:59:25" , 
"departure_time" : "16:00:26" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:05:01" , 
"departure_time" : "16:06:30" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:11:29" , 
"departure_time" : "16:12:14" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:18:45" , 
"departure_time" : "16:19:54" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "16:34:09" , 
"departure_time" : "16:34:09" , 
"distance_traveled" : 57.91
} ], 
"2673" :  [ 
{ 
"stop_id" : 148,
"arrival_time" : "16:02:00" , 
"departure_time" : "16:04:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "16:08:52" , 
"departure_time" : "16:09:06" , 
"distance_traveled" : 3.6538
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:15:14" , 
"departure_time" : "16:16:34" , 
"distance_traveled" : 9.6248
}, 
{ 
"stop_id" : 103,
"arrival_time" : "16:32:20" , 
"departure_time" : "16:33:17" , 
"distance_traveled" : 25.361
}, 
{ 
"stop_id" : 38,
"arrival_time" : "16:35:57" , 
"departure_time" : "16:36:05" , 
"distance_traveled" : 27.7278
}, 
{ 
"stop_id" : 84,
"arrival_time" : "16:40:08" , 
"departure_time" : "16:41:07" , 
"distance_traveled" : 30.8036
}, 
{ 
"stop_id" : 83,
"arrival_time" : "16:45:59" , 
"departure_time" : "16:46:38" , 
"distance_traveled" : 33.4072
}, 
{ 
"stop_id" : 127,
"arrival_time" : "16:52:39" , 
"departure_time" : "16:54:08" , 
"distance_traveled" : 37.2072
}, 
{ 
"stop_id" : 70,
"arrival_time" : "16:57:29" , 
"departure_time" : "16:58:59" , 
"distance_traveled" : 39.2657
}, 
{ 
"stop_id" : 41,
"arrival_time" : "17:04:30" , 
"departure_time" : "17:05:28" , 
"distance_traveled" : 42.5492
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:08:58" , 
"departure_time" : "17:09:00" , 
"distance_traveled" : 45.375
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:15:02" , 
"departure_time" : "17:15:30" , 
"distance_traveled" : 47.8532
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:23:28" , 
"departure_time" : "17:24:58" , 
"distance_traveled" : 52.922
}, 
{ 
"stop_id" : 105,
"arrival_time" : "17:37:30" , 
"departure_time" : "17:37:30" , 
"distance_traveled" : 57.91
} ], 
"2674" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "24:14:00" , 
"departure_time" : "24:16:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:23:59" , 
"departure_time" : "24:25:32" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "24:33:33" , 
"departure_time" : "24:35:09" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "24:39:36" , 
"departure_time" : "24:41:14" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "24:42:38" , 
"departure_time" : "24:44:13" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "24:45:35" , 
"departure_time" : "24:46:46" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "24:52:11" , 
"departure_time" : "24:53:16" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "24:56:05" , 
"departure_time" : "24:57:22" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "25:02:17" , 
"departure_time" : "25:03:05" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "25:06:48" , 
"departure_time" : "25:08:11" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "25:12:23" , 
"departure_time" : "25:13:35" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "25:16:12" , 
"departure_time" : "25:17:05" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "25:18:53" , 
"departure_time" : "25:20:05" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "25:33:12" , 
"departure_time" : "25:34:15" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "25:39:03" , 
"departure_time" : "25:40:03" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "25:54:00" , 
"departure_time" : "25:54:00" , 
"distance_traveled" : 57.9104
} ], 
"2675" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "24:14:00" , 
"departure_time" : "24:16:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:24:00" , 
"departure_time" : "24:24:11" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "24:32:11" , 
"departure_time" : "24:33:15" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "24:39:04" , 
"departure_time" : "24:39:55" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "24:41:51" , 
"departure_time" : "24:42:48" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "24:44:57" , 
"departure_time" : "24:46:34" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "24:52:37" , 
"departure_time" : "24:53:59" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "24:56:22" , 
"departure_time" : "24:57:33" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "25:02:11" , 
"departure_time" : "25:03:38" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "25:07:27" , 
"departure_time" : "25:08:10" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "25:11:43" , 
"departure_time" : "25:12:38" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "25:15:55" , 
"departure_time" : "25:17:27" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "25:19:32" , 
"departure_time" : "25:19:37" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "25:32:05" , 
"departure_time" : "25:33:22" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "25:39:17" , 
"departure_time" : "25:39:46" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "25:53:29" , 
"departure_time" : "25:53:29" , 
"distance_traveled" : 57.9104
} ], 
"2676" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "12:44:00" , 
"departure_time" : "12:45:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:54:05" , 
"departure_time" : "12:55:05" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:03:00" , 
"departure_time" : "13:04:00" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 83,
"arrival_time" : "13:20:00" , 
"departure_time" : "13:20:06" , 
"distance_traveled" : 24.5038
}, 
{ 
"stop_id" : 84,
"arrival_time" : "13:24:06" , 
"departure_time" : "13:25:13" , 
"distance_traveled" : 27.0947
}, 
{ 
"stop_id" : 38,
"arrival_time" : "13:30:07" , 
"departure_time" : "13:31:42" , 
"distance_traveled" : 30.1831
}, 
{ 
"stop_id" : 103,
"arrival_time" : "13:37:35" , 
"departure_time" : "13:39:07" , 
"distance_traveled" : 32.55
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:57:32" , 
"departure_time" : "13:58:31" , 
"distance_traveled" : 48.2862
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "14:03:59" , 
"departure_time" : "14:05:01" , 
"distance_traveled" : 54.257
}, 
{ 
"stop_id" : 148,
"arrival_time" : "14:13:02" , 
"departure_time" : "14:13:02" , 
"distance_traveled" : 57.9108
} ], 
"2677" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:44:00" , 
"departure_time" : "17:46:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:54:32" , 
"departure_time" : "17:55:05" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:02:33" , 
"departure_time" : "18:03:13" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 83,
"arrival_time" : "18:19:40" , 
"departure_time" : "18:19:56" , 
"distance_traveled" : 24.5038
}, 
{ 
"stop_id" : 84,
"arrival_time" : "18:24:16" , 
"departure_time" : "18:24:52" , 
"distance_traveled" : 27.0947
}, 
{ 
"stop_id" : 38,
"arrival_time" : "18:29:36" , 
"departure_time" : "18:30:04" , 
"distance_traveled" : 30.1831
}, 
{ 
"stop_id" : 103,
"arrival_time" : "18:33:28" , 
"departure_time" : "18:34:43" , 
"distance_traveled" : 32.55
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:49:15" , 
"departure_time" : "18:50:50" , 
"distance_traveled" : 48.2862
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "18:56:35" , 
"departure_time" : "18:58:12" , 
"distance_traveled" : 54.257
}, 
{ 
"stop_id" : 148,
"arrival_time" : "19:05:37" , 
"departure_time" : "19:05:37" , 
"distance_traveled" : 57.9108
} ], 
"2678" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:44:00" , 
"departure_time" : "18:46:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:54:20" , 
"departure_time" : "18:55:02" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:02:42" , 
"departure_time" : "19:03:05" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 83,
"arrival_time" : "19:19:23" , 
"departure_time" : "19:20:55" , 
"distance_traveled" : 24.5038
}, 
{ 
"stop_id" : 84,
"arrival_time" : "19:25:32" , 
"departure_time" : "19:27:04" , 
"distance_traveled" : 27.0947
}, 
{ 
"stop_id" : 38,
"arrival_time" : "19:30:32" , 
"departure_time" : "19:32:00" , 
"distance_traveled" : 30.1831
}, 
{ 
"stop_id" : 103,
"arrival_time" : "19:34:28" , 
"departure_time" : "19:35:45" , 
"distance_traveled" : 32.55
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:55:17" , 
"departure_time" : "19:55:49" , 
"distance_traveled" : 48.2862
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "20:02:32" , 
"departure_time" : "20:03:09" , 
"distance_traveled" : 54.257
}, 
{ 
"stop_id" : 148,
"arrival_time" : "20:11:37" , 
"departure_time" : "20:11:37" , 
"distance_traveled" : 57.9108
} ], 
"2679" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "24:14:00" , 
"departure_time" : "24:15:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:24:13" , 
"departure_time" : "24:25:41" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "24:33:28" , 
"departure_time" : "24:34:08" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "24:38:40" , 
"departure_time" : "24:38:48" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "24:41:08" , 
"departure_time" : "24:42:48" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "24:45:40" , 
"departure_time" : "24:46:09" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "24:51:29" , 
"departure_time" : "24:52:33" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "24:56:04" , 
"departure_time" : "24:57:21" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "25:02:17" , 
"departure_time" : "25:02:24" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "25:06:07" , 
"departure_time" : "25:06:33" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "25:11:26" , 
"departure_time" : "25:12:04" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "25:15:38" , 
"departure_time" : "25:16:29" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "25:18:51" , 
"departure_time" : "25:19:29" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "25:32:38" , 
"departure_time" : "25:33:27" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "25:38:49" , 
"departure_time" : "25:40:29" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "25:54:40" , 
"departure_time" : "25:54:40" , 
"distance_traveled" : 57.9104
} ], 
"2680" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "24:14:00" , 
"departure_time" : "24:16:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:24:17" , 
"departure_time" : "24:25:16" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "24:32:59" , 
"departure_time" : "24:33:05" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "24:38:06" , 
"departure_time" : "24:38:38" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "24:41:32" , 
"departure_time" : "24:43:12" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "24:45:40" , 
"departure_time" : "24:47:10" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "24:52:30" , 
"departure_time" : "24:52:43" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "24:55:13" , 
"departure_time" : "24:55:18" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "25:01:05" , 
"departure_time" : "25:02:21" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "25:07:16" , 
"departure_time" : "25:08:41" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "25:12:25" , 
"departure_time" : "25:13:54" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "25:16:29" , 
"departure_time" : "25:17:02" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "25:18:33" , 
"departure_time" : "25:18:53" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "25:32:20" , 
"departure_time" : "25:33:33" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "25:39:13" , 
"departure_time" : "25:40:29" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "25:54:16" , 
"departure_time" : "25:54:16" , 
"distance_traveled" : 57.9104
} ], 
"2681" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:55:00" , 
"departure_time" : "20:57:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:12:31" , 
"departure_time" : "21:14:11" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "21:17:40" , 
"departure_time" : "21:18:43" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "21:30:03" , 
"departure_time" : "21:30:39" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "21:34:36" , 
"departure_time" : "21:34:58" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "21:39:22" , 
"departure_time" : "21:39:28" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "21:43:06" , 
"departure_time" : "21:43:30" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "22:01:24" , 
"departure_time" : "22:01:25" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "22:08:01" , 
"departure_time" : "22:08:54" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "22:20:53" , 
"departure_time" : "22:20:53" , 
"distance_traveled" : 57.9104
} ], 
"2682" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:58:00" , 
"departure_time" : "17:58:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:13:02" , 
"departure_time" : "18:14:18" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:20:16" , 
"departure_time" : "18:21:47" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "18:34:31" , 
"departure_time" : "18:35:47" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "18:38:16" , 
"departure_time" : "18:39:00" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "18:42:44" , 
"departure_time" : "18:43:12" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "18:47:28" , 
"departure_time" : "18:49:01" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:03:33" , 
"departure_time" : "19:05:06" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "19:10:33" , 
"departure_time" : "19:11:48" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "19:21:15" , 
"departure_time" : "19:21:15" , 
"distance_traveled" : 57.9104
} ], 
"2683" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "12:44:00" , 
"departure_time" : "12:46:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:54:15" , 
"departure_time" : "12:55:18" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:03:03" , 
"departure_time" : "13:04:00" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 83,
"arrival_time" : "13:19:57" , 
"departure_time" : "13:20:44" , 
"distance_traveled" : 24.5038
}, 
{ 
"stop_id" : 84,
"arrival_time" : "13:24:47" , 
"departure_time" : "13:26:24" , 
"distance_traveled" : 27.0947
}, 
{ 
"stop_id" : 38,
"arrival_time" : "13:30:37" , 
"departure_time" : "13:30:53" , 
"distance_traveled" : 30.1831
}, 
{ 
"stop_id" : 103,
"arrival_time" : "13:36:16" , 
"departure_time" : "13:37:04" , 
"distance_traveled" : 32.55
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:56:48" , 
"departure_time" : "13:57:45" , 
"distance_traveled" : 48.2862
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "14:03:57" , 
"departure_time" : "14:04:21" , 
"distance_traveled" : 54.257
}, 
{ 
"stop_id" : 148,
"arrival_time" : "14:12:24" , 
"departure_time" : "14:12:24" , 
"distance_traveled" : 57.9108
} ], 
"2684" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "21:57:00" , 
"departure_time" : "21:58:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:14:03" , 
"departure_time" : "22:15:26" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:19:23" , 
"departure_time" : "22:20:57" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "22:33:34" , 
"departure_time" : "22:34:31" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "22:37:57" , 
"departure_time" : "22:39:19" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "22:43:22" , 
"departure_time" : "22:43:33" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "22:46:11" , 
"departure_time" : "22:47:24" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "23:02:13" , 
"departure_time" : "23:02:41" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "23:08:28" , 
"departure_time" : "23:09:30" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "23:21:02" , 
"departure_time" : "23:21:02" , 
"distance_traveled" : 57.9104
} ], 
"2685" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:44:00" , 
"departure_time" : "17:45:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:53:55" , 
"departure_time" : "17:55:25" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:03:30" , 
"departure_time" : "18:03:54" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 83,
"arrival_time" : "18:19:24" , 
"departure_time" : "18:20:19" , 
"distance_traveled" : 24.5038
}, 
{ 
"stop_id" : 84,
"arrival_time" : "18:24:55" , 
"departure_time" : "18:26:21" , 
"distance_traveled" : 27.0947
}, 
{ 
"stop_id" : 38,
"arrival_time" : "18:30:26" , 
"departure_time" : "18:31:49" , 
"distance_traveled" : 30.1831
}, 
{ 
"stop_id" : 103,
"arrival_time" : "18:34:23" , 
"departure_time" : "18:35:53" , 
"distance_traveled" : 32.55
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:49:30" , 
"departure_time" : "18:50:57" , 
"distance_traveled" : 48.2862
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "18:56:27" , 
"departure_time" : "18:57:07" , 
"distance_traveled" : 54.257
}, 
{ 
"stop_id" : 148,
"arrival_time" : "19:04:40" , 
"departure_time" : "19:04:40" , 
"distance_traveled" : 57.9108
} ], 
"2686" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "22:57:00" , 
"departure_time" : "22:57:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "23:12:10" , 
"departure_time" : "23:13:22" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "23:19:12" , 
"departure_time" : "23:20:19" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "23:33:07" , 
"departure_time" : "23:34:40" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "23:38:33" , 
"departure_time" : "23:39:02" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "23:42:29" , 
"departure_time" : "23:42:41" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "23:46:12" , 
"departure_time" : "23:47:05" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "24:02:53" , 
"departure_time" : "24:04:20" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "24:09:27" , 
"departure_time" : "24:10:53" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "24:21:26" , 
"departure_time" : "24:21:26" , 
"distance_traveled" : 57.9104
} ], 
"2687" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:44:00" , 
"departure_time" : "18:47:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:54:35" , 
"departure_time" : "18:56:13" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:03:38" , 
"departure_time" : "19:04:45" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 83,
"arrival_time" : "19:20:07" , 
"departure_time" : "19:20:08" , 
"distance_traveled" : 24.5038
}, 
{ 
"stop_id" : 84,
"arrival_time" : "19:24:01" , 
"departure_time" : "19:24:38" , 
"distance_traveled" : 27.0947
}, 
{ 
"stop_id" : 38,
"arrival_time" : "19:29:37" , 
"departure_time" : "19:30:12" , 
"distance_traveled" : 30.1831
}, 
{ 
"stop_id" : 103,
"arrival_time" : "19:33:35" , 
"departure_time" : "19:34:08" , 
"distance_traveled" : 32.55
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:54:33" , 
"departure_time" : "19:55:14" , 
"distance_traveled" : 48.2862
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "20:02:41" , 
"departure_time" : "20:04:12" , 
"distance_traveled" : 54.257
}, 
{ 
"stop_id" : 148,
"arrival_time" : "20:12:31" , 
"departure_time" : "20:12:31" , 
"distance_traveled" : 57.9108
} ], 
"2688" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "13:55:00" , 
"departure_time" : "13:57:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:05:34" , 
"departure_time" : "14:06:40" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:16:06" , 
"departure_time" : "14:17:22" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "14:22:16" , 
"departure_time" : "14:22:20" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "14:34:04" , 
"departure_time" : "14:34:29" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "14:39:25" , 
"departure_time" : "14:39:39" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "14:44:14" , 
"departure_time" : "14:45:11" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "14:49:57" , 
"departure_time" : "14:50:46" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:06:49" , 
"departure_time" : "15:08:10" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "15:14:21" , 
"departure_time" : "15:15:22" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "15:32:01" , 
"departure_time" : "15:32:01" , 
"distance_traveled" : 57.9104
} ], 
"2689" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "14:55:00" , 
"departure_time" : "14:56:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:04:52" , 
"departure_time" : "15:05:26" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:13:34" , 
"departure_time" : "15:14:51" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "15:20:17" , 
"departure_time" : "15:20:47" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "15:35:30" , 
"departure_time" : "15:35:33" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "15:39:03" , 
"departure_time" : "15:40:14" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "15:45:11" , 
"departure_time" : "15:46:46" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "15:50:35" , 
"departure_time" : "15:50:41" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:04:06" , 
"departure_time" : "16:04:34" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "16:10:28" , 
"departure_time" : "16:11:11" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "16:23:43" , 
"departure_time" : "16:23:43" , 
"distance_traveled" : 57.9104
} ], 
"2690" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:52:00" , 
"departure_time" : "15:54:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:03:40" , 
"departure_time" : "16:04:05" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:12:25" , 
"departure_time" : "16:13:32" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:18:07" , 
"departure_time" : "16:18:25" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "16:31:18" , 
"departure_time" : "16:32:43" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "16:37:25" , 
"departure_time" : "16:38:33" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "16:42:08" , 
"departure_time" : "16:43:32" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "16:46:24" , 
"departure_time" : "16:47:28" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:04:04" , 
"departure_time" : "17:04:16" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "17:10:12" , 
"departure_time" : "17:11:17" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "17:23:05" , 
"departure_time" : "17:23:05" , 
"distance_traveled" : 57.9104
} ], 
"2691" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:54:00" , 
"departure_time" : "16:55:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:03:01" , 
"departure_time" : "17:03:14" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:12:13" , 
"departure_time" : "17:13:33" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:20:20" , 
"departure_time" : "17:20:27" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "17:34:07" , 
"departure_time" : "17:35:17" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "17:39:10" , 
"departure_time" : "17:39:41" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "17:43:31" , 
"departure_time" : "17:44:03" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "17:48:32" , 
"departure_time" : "17:49:36" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:03:04" , 
"departure_time" : "18:04:16" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "18:11:12" , 
"departure_time" : "18:12:36" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "18:25:24" , 
"departure_time" : "18:25:24" , 
"distance_traveled" : 57.9104
} ], 
"2692" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:03:00" , 
"departure_time" : "19:04:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:12:02" , 
"departure_time" : "19:12:06" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:21:04" , 
"departure_time" : "19:22:11" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:27:07" , 
"departure_time" : "19:27:56" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "19:40:49" , 
"departure_time" : "19:40:59" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "19:45:10" , 
"departure_time" : "19:45:18" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "19:50:08" , 
"departure_time" : "19:50:36" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "19:54:28" , 
"departure_time" : "19:54:47" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "20:09:19" , 
"departure_time" : "20:09:36" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "20:16:17" , 
"departure_time" : "20:17:31" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "20:29:14" , 
"departure_time" : "20:29:14" , 
"distance_traveled" : 57.9104
} ], 
"2693" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:03:00" , 
"departure_time" : "20:05:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:13:16" , 
"departure_time" : "20:13:21" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:21:05" , 
"departure_time" : "20:21:21" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:26:16" , 
"departure_time" : "20:27:27" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "20:42:11" , 
"departure_time" : "20:42:33" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "20:46:22" , 
"departure_time" : "20:47:52" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "20:52:30" , 
"departure_time" : "20:52:46" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "20:55:16" , 
"departure_time" : "20:55:55" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "21:11:39" , 
"departure_time" : "21:11:45" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "21:18:06" , 
"departure_time" : "21:19:10" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "21:31:04" , 
"departure_time" : "21:31:04" , 
"distance_traveled" : 57.9104
} ], 
"2694" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "08:14:00" , 
"departure_time" : "08:15:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:23:17" , 
"departure_time" : "08:24:28" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:33:11" , 
"departure_time" : "08:34:27" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:39:16" , 
"departure_time" : "08:40:05" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "08:43:49" , 
"departure_time" : "08:45:07" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "08:51:18" , 
"departure_time" : "08:51:58" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:54:40" , 
"departure_time" : "08:55:29" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "09:00:49" , 
"departure_time" : "09:01:10" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "09:05:21" , 
"departure_time" : "09:06:39" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "09:11:18" , 
"departure_time" : "09:12:16" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "09:14:58" , 
"departure_time" : "09:15:28" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "09:29:30" , 
"departure_time" : "09:30:43" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "09:37:13" , 
"departure_time" : "09:38:13" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "09:49:00" , 
"departure_time" : "09:49:00" , 
"distance_traveled" : 57.9102
} ], 
"2695" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "10:14:00" , 
"departure_time" : "10:15:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:23:03" , 
"departure_time" : "10:23:46" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:32:43" , 
"departure_time" : "10:33:15" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:38:32" , 
"departure_time" : "10:39:47" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "10:44:15" , 
"departure_time" : "10:45:27" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "10:51:12" , 
"departure_time" : "10:51:32" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "10:54:20" , 
"departure_time" : "10:55:46" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "11:01:26" , 
"departure_time" : "11:01:35" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "11:05:09" , 
"departure_time" : "11:05:59" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "11:10:50" , 
"departure_time" : "11:12:30" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "11:15:40" , 
"departure_time" : "11:16:28" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "11:29:48" , 
"departure_time" : "11:30:13" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "11:36:25" , 
"departure_time" : "11:37:25" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "11:49:00" , 
"departure_time" : "11:49:00" , 
"distance_traveled" : 57.9102
} ], 
"2696" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "11:14:00" , 
"departure_time" : "11:15:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:23:54" , 
"departure_time" : "11:24:30" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:32:36" , 
"departure_time" : "11:32:47" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "11:38:11" , 
"departure_time" : "11:39:11" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "11:44:00" , 
"departure_time" : "11:44:31" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "11:50:31" , 
"departure_time" : "11:50:41" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "11:54:10" , 
"departure_time" : "11:54:56" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "12:00:46" , 
"departure_time" : "12:01:07" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "12:05:21" , 
"departure_time" : "12:06:20" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "12:10:59" , 
"departure_time" : "12:11:59" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "12:15:00" , 
"departure_time" : "12:16:11" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "12:30:11" , 
"departure_time" : "12:30:37" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "12:36:26" , 
"departure_time" : "12:37:15" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "12:48:49" , 
"departure_time" : "12:48:49" , 
"distance_traveled" : 57.9102
} ], 
"2697" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:14:00" , 
"departure_time" : "16:16:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:24:25" , 
"departure_time" : "16:25:57" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:33:32" , 
"departure_time" : "16:34:00" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:38:28" , 
"departure_time" : "16:39:16" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "16:43:48" , 
"departure_time" : "16:44:18" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "16:49:30" , 
"departure_time" : "16:49:34" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "16:53:04" , 
"departure_time" : "16:54:03" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "17:00:59" , 
"departure_time" : "17:02:32" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "17:06:33" , 
"departure_time" : "17:06:55" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "17:10:22" , 
"departure_time" : "17:11:46" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "17:15:24" , 
"departure_time" : "17:15:28" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:29:04" , 
"departure_time" : "17:30:25" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "17:36:21" , 
"departure_time" : "17:37:15" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "17:47:54" , 
"departure_time" : "17:47:54" , 
"distance_traveled" : 57.9102
} ], 
"2698" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "06:13:00" , 
"departure_time" : "06:14:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:22:34" , 
"departure_time" : "06:22:57" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:31:23" , 
"departure_time" : "06:32:44" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "06:38:21" , 
"departure_time" : "06:39:50" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "06:43:29" , 
"departure_time" : "06:44:40" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "06:50:11" , 
"departure_time" : "06:51:32" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "06:54:21" , 
"departure_time" : "06:55:30" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "07:00:09" , 
"departure_time" : "07:00:54" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "07:04:45" , 
"departure_time" : "07:05:17" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "07:09:32" , 
"departure_time" : "07:09:53" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "07:13:21" , 
"departure_time" : "07:13:29" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "07:28:08" , 
"departure_time" : "07:29:10" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "07:36:02" , 
"departure_time" : "07:37:37" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "07:47:35" , 
"departure_time" : "07:47:35" , 
"distance_traveled" : 57.9102
} ], 
"2699" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "07:14:00" , 
"departure_time" : "07:15:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:23:21" , 
"departure_time" : "07:23:27" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:32:06" , 
"departure_time" : "07:33:25" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "07:39:19" , 
"departure_time" : "07:40:55" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "07:44:36" , 
"departure_time" : "07:45:15" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "07:50:39" , 
"departure_time" : "07:51:12" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "07:54:33" , 
"departure_time" : "07:54:34" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "08:00:01" , 
"departure_time" : "08:01:41" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "08:06:40" , 
"departure_time" : "08:06:58" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "08:10:18" , 
"departure_time" : "08:10:36" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "08:14:18" , 
"departure_time" : "08:15:54" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "08:30:36" , 
"departure_time" : "08:32:01" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "08:37:25" , 
"departure_time" : "08:37:26" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "08:47:01" , 
"departure_time" : "08:47:01" , 
"distance_traveled" : 57.9102
} ], 
"2700" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "09:14:00" , 
"departure_time" : "09:15:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:24:16" , 
"departure_time" : "09:24:22" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:32:06" , 
"departure_time" : "09:32:49" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:38:43" , 
"departure_time" : "09:40:18" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "09:44:35" , 
"departure_time" : "09:46:10" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "09:51:35" , 
"departure_time" : "09:52:13" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "09:54:38" , 
"departure_time" : "09:55:01" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "10:00:23" , 
"departure_time" : "10:00:37" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "10:05:14" , 
"departure_time" : "10:05:36" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "10:10:22" , 
"departure_time" : "10:11:03" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "10:14:41" , 
"departure_time" : "10:15:30" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "10:29:49" , 
"departure_time" : "10:31:20" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "10:37:31" , 
"departure_time" : "10:37:42" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "10:48:11" , 
"departure_time" : "10:48:11" , 
"distance_traveled" : 57.9102
} ], 
"2701" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "24:14:00" , 
"departure_time" : "24:15:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:23:56" , 
"departure_time" : "24:24:14" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "24:32:18" , 
"departure_time" : "24:32:37" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "24:38:19" , 
"departure_time" : "24:38:30" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "24:41:11" , 
"departure_time" : "24:41:46" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "24:44:35" , 
"departure_time" : "24:45:09" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "24:51:34" , 
"departure_time" : "24:52:58" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "24:56:24" , 
"departure_time" : "24:56:36" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "25:01:12" , 
"departure_time" : "25:02:08" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "25:06:56" , 
"departure_time" : "25:08:01" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "25:12:05" , 
"departure_time" : "25:12:32" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "25:15:27" , 
"departure_time" : "25:15:46" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "25:18:19" , 
"departure_time" : "25:18:25" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "25:32:06" , 
"departure_time" : "25:32:34" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "25:38:28" , 
"departure_time" : "25:39:35" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "25:54:07" , 
"departure_time" : "25:54:07" , 
"distance_traveled" : 57.9104
} ], 
"2702" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:14:00" , 
"departure_time" : "17:16:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:23:53" , 
"departure_time" : "17:25:27" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:33:34" , 
"departure_time" : "17:34:09" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:38:35" , 
"departure_time" : "17:39:01" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "17:43:26" , 
"departure_time" : "17:45:05" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "17:50:39" , 
"departure_time" : "17:51:16" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "17:53:37" , 
"departure_time" : "17:53:38" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "18:00:01" , 
"departure_time" : "18:00:57" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "18:04:56" , 
"departure_time" : "18:05:25" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "18:09:29" , 
"departure_time" : "18:09:34" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "18:14:05" , 
"departure_time" : "18:15:30" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:30:25" , 
"departure_time" : "18:31:39" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "18:37:14" , 
"departure_time" : "18:38:53" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "18:48:39" , 
"departure_time" : "18:48:39" , 
"distance_traveled" : 57.9102
} ], 
"2703" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "12:01:00" , 
"departure_time" : "12:03:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:10:35" , 
"departure_time" : "12:11:30" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:18:55" , 
"departure_time" : "12:18:58" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 109,
"arrival_time" : "12:24:03" , 
"departure_time" : "12:24:25" , 
"distance_traveled" : 14.3875
}, 
{ 
"stop_id" : 41,
"arrival_time" : "12:27:22" , 
"departure_time" : "12:27:58" , 
"distance_traveled" : 15.3631
}, 
{ 
"stop_id" : 70,
"arrival_time" : "12:33:36" , 
"departure_time" : "12:33:39" , 
"distance_traveled" : 18.6468
}, 
{ 
"stop_id" : 127,
"arrival_time" : "12:36:03" , 
"departure_time" : "12:36:03" , 
"distance_traveled" : 20.7053
} ], 
"2704" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:14:00" , 
"departure_time" : "18:15:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:24:22" , 
"departure_time" : "18:25:05" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:32:43" , 
"departure_time" : "18:33:42" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:38:59" , 
"departure_time" : "18:39:53" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "18:43:54" , 
"departure_time" : "18:44:27" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "18:50:33" , 
"departure_time" : "18:52:00" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:55:27" , 
"departure_time" : "18:56:25" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "19:00:58" , 
"departure_time" : "19:01:02" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "19:05:04" , 
"departure_time" : "19:06:04" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "19:11:00" , 
"departure_time" : "19:12:10" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "19:15:10" , 
"departure_time" : "19:15:34" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:29:24" , 
"departure_time" : "19:31:00" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "19:37:36" , 
"departure_time" : "19:37:53" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "19:47:17" , 
"departure_time" : "19:47:17" , 
"distance_traveled" : 57.9102
} ], 
"2705" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:55:00" , 
"departure_time" : "20:55:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:11:29" , 
"departure_time" : "21:12:39" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "21:17:10" , 
"departure_time" : "21:17:28" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "21:29:18" , 
"departure_time" : "21:29:53" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "21:34:35" , 
"departure_time" : "21:35:56" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "21:40:21" , 
"departure_time" : "21:41:25" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "21:44:04" , 
"departure_time" : "21:45:08" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "22:02:04" , 
"departure_time" : "22:02:23" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "22:08:19" , 
"departure_time" : "22:08:44" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "22:20:25" , 
"departure_time" : "22:20:25" , 
"distance_traveled" : 57.9104
} ], 
"2706" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:14:00" , 
"departure_time" : "19:15:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:23:53" , 
"departure_time" : "19:23:58" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:32:05" , 
"departure_time" : "19:32:30" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:38:25" , 
"departure_time" : "19:39:42" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "19:44:17" , 
"departure_time" : "19:45:05" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "19:50:48" , 
"departure_time" : "19:51:11" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "19:54:23" , 
"departure_time" : "19:55:27" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "20:01:04" , 
"departure_time" : "20:01:40" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "20:05:36" , 
"departure_time" : "20:06:24" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "20:10:48" , 
"departure_time" : "20:11:51" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "20:15:03" , 
"departure_time" : "20:15:17" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "20:29:14" , 
"departure_time" : "20:30:54" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "20:37:40" , 
"departure_time" : "20:39:03" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "20:49:23" , 
"departure_time" : "20:49:23" , 
"distance_traveled" : 57.9102
} ], 
"2707" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:58:00" , 
"departure_time" : "18:00:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:13:53" , 
"departure_time" : "18:14:31" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:19:38" , 
"departure_time" : "18:19:44" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "18:33:06" , 
"departure_time" : "18:34:40" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "18:38:34" , 
"departure_time" : "18:39:29" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "18:42:55" , 
"departure_time" : "18:43:48" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "18:47:53" , 
"departure_time" : "18:48:02" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:02:09" , 
"departure_time" : "19:03:16" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "19:10:07" , 
"departure_time" : "19:10:47" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "19:20:40" , 
"departure_time" : "19:20:40" , 
"distance_traveled" : 57.9104
} ], 
"2708" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:14:00" , 
"departure_time" : "20:14:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:23:01" , 
"departure_time" : "20:23:43" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:32:42" , 
"departure_time" : "20:34:06" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:39:24" , 
"departure_time" : "20:40:52" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "20:44:28" , 
"departure_time" : "20:44:40" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "20:50:12" , 
"departure_time" : "20:50:41" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:54:29" , 
"departure_time" : "20:55:12" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "21:00:43" , 
"departure_time" : "21:01:33" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "21:05:50" , 
"departure_time" : "21:06:24" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "21:10:34" , 
"departure_time" : "21:11:19" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "21:14:45" , 
"departure_time" : "21:14:53" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "21:29:08" , 
"departure_time" : "21:30:33" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "21:37:25" , 
"departure_time" : "21:38:56" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "21:48:31" , 
"departure_time" : "21:48:31" , 
"distance_traveled" : 57.9102
} ], 
"2709" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "21:57:00" , 
"departure_time" : "21:58:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:13:03" , 
"departure_time" : "22:13:39" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:18:36" , 
"departure_time" : "22:19:51" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "22:33:15" , 
"departure_time" : "22:34:20" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "22:38:05" , 
"departure_time" : "22:39:21" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "22:43:16" , 
"departure_time" : "22:44:15" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "22:46:59" , 
"departure_time" : "22:47:50" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "23:01:51" , 
"departure_time" : "23:02:40" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "23:08:49" , 
"departure_time" : "23:09:31" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "23:20:42" , 
"departure_time" : "23:20:42" , 
"distance_traveled" : 57.9104
} ], 
"2710" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "05:10:00" , 
"departure_time" : "05:11:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:19:30" , 
"departure_time" : "05:20:26" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "05:28:56" , 
"departure_time" : "05:29:07" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "05:34:11" , 
"departure_time" : "05:35:25" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "05:38:14" , 
"departure_time" : "05:39:15" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "05:41:01" , 
"departure_time" : "05:42:03" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "05:48:02" , 
"departure_time" : "05:49:24" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "05:52:22" , 
"departure_time" : "05:53:06" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "05:57:44" , 
"departure_time" : "05:59:01" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "06:03:17" , 
"departure_time" : "06:04:25" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "06:08:08" , 
"departure_time" : "06:08:31" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "06:11:23" , 
"departure_time" : "06:12:50" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "06:27:27" , 
"departure_time" : "06:28:41" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "06:34:14" , 
"departure_time" : "06:35:52" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "06:45:38" , 
"departure_time" : "06:45:38" , 
"distance_traveled" : 57.9102
} ], 
"2711" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "22:57:00" , 
"departure_time" : "23:00:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "23:13:23" , 
"departure_time" : "23:13:30" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "23:18:07" , 
"departure_time" : "23:18:14" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "23:32:07" , 
"departure_time" : "23:32:35" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "23:37:28" , 
"departure_time" : "23:37:45" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "23:42:17" , 
"departure_time" : "23:43:50" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "23:47:33" , 
"departure_time" : "23:48:49" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "24:03:16" , 
"departure_time" : "24:03:33" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "24:08:17" , 
"departure_time" : "24:08:24" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "24:20:07" , 
"departure_time" : "24:20:07" , 
"distance_traveled" : 57.9104
} ], 
"2712" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "12:14:00" , 
"departure_time" : "12:15:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:24:06" , 
"departure_time" : "12:25:04" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:32:58" , 
"departure_time" : "12:33:22" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "12:38:24" , 
"departure_time" : "12:39:43" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "12:42:19" , 
"departure_time" : "12:42:24" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "12:44:05" , 
"departure_time" : "12:45:12" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "12:52:07" , 
"departure_time" : "12:52:26" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "12:55:19" , 
"departure_time" : "12:56:08" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "13:01:49" , 
"departure_time" : "13:03:16" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "13:07:27" , 
"departure_time" : "13:08:38" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "13:12:11" , 
"departure_time" : "13:12:28" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "13:15:17" , 
"departure_time" : "13:15:37" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:30:20" , 
"departure_time" : "13:30:33" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "13:37:13" , 
"departure_time" : "13:38:11" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "13:52:58" , 
"departure_time" : "13:52:58" , 
"distance_traveled" : 57.9102
} ], 
"2713" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "13:55:00" , 
"departure_time" : "13:56:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:05:32" , 
"departure_time" : "14:06:32" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:16:00" , 
"departure_time" : "14:16:12" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "14:21:12" , 
"departure_time" : "14:21:32" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "14:34:20" , 
"departure_time" : "14:35:11" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "14:39:51" , 
"departure_time" : "14:40:58" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "14:45:07" , 
"departure_time" : "14:45:27" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "14:49:20" , 
"departure_time" : "14:49:32" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:06:12" , 
"departure_time" : "15:06:30" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "15:13:18" , 
"departure_time" : "15:14:42" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "15:32:24" , 
"departure_time" : "15:32:24" , 
"distance_traveled" : 57.9104
} ], 
"2714" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "13:14:00" , 
"departure_time" : "13:16:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:24:05" , 
"departure_time" : "13:25:42" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:33:37" , 
"departure_time" : "13:34:30" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:38:53" , 
"departure_time" : "13:39:55" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "13:42:02" , 
"departure_time" : "13:42:09" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "13:44:07" , 
"departure_time" : "13:44:44" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "13:51:37" , 
"departure_time" : "13:53:14" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "13:56:37" , 
"departure_time" : "13:58:10" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "14:02:33" , 
"departure_time" : "14:03:58" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "14:07:25" , 
"departure_time" : "14:08:28" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "14:12:03" , 
"departure_time" : "14:13:04" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "14:16:01" , 
"departure_time" : "14:17:08" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "14:31:07" , 
"departure_time" : "14:31:10" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "14:37:03" , 
"departure_time" : "14:38:43" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "14:49:40" , 
"departure_time" : "14:49:40" , 
"distance_traveled" : 57.9102
} ], 
"2715" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "14:55:00" , 
"departure_time" : "14:56:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:04:18" , 
"departure_time" : "15:05:48" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:14:30" , 
"departure_time" : "15:15:29" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "15:19:59" , 
"departure_time" : "15:21:21" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "15:36:22" , 
"departure_time" : "15:36:43" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "15:39:21" , 
"departure_time" : "15:39:38" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "15:44:17" , 
"departure_time" : "15:44:44" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "15:49:27" , 
"departure_time" : "15:50:06" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:04:39" , 
"departure_time" : "16:04:49" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "16:10:10" , 
"departure_time" : "16:11:06" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "16:23:56" , 
"departure_time" : "16:23:56" , 
"distance_traveled" : 57.9104
} ], 
"2716" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "14:14:00" , 
"departure_time" : "14:16:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:24:27" , 
"departure_time" : "14:25:37" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:33:10" , 
"departure_time" : "14:34:30" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "14:39:20" , 
"departure_time" : "14:39:49" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "14:41:29" , 
"departure_time" : "14:42:46" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "14:45:17" , 
"departure_time" : "14:46:43" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "14:52:26" , 
"departure_time" : "14:52:40" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "14:55:14" , 
"departure_time" : "14:56:09" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "15:01:55" , 
"departure_time" : "15:02:50" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "15:06:55" , 
"departure_time" : "15:07:19" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "15:11:24" , 
"departure_time" : "15:11:46" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "15:15:22" , 
"departure_time" : "15:15:52" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:30:30" , 
"departure_time" : "15:31:47" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "15:38:17" , 
"departure_time" : "15:39:22" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "15:49:05" , 
"departure_time" : "15:49:05" , 
"distance_traveled" : 57.9102
} ], 
"2717" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:52:00" , 
"departure_time" : "15:53:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:02:09" , 
"departure_time" : "16:03:21" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:13:12" , 
"departure_time" : "16:13:28" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:17:16" , 
"departure_time" : "16:17:57" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "16:31:41" , 
"departure_time" : "16:32:17" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "16:36:36" , 
"departure_time" : "16:37:55" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "16:42:19" , 
"departure_time" : "16:42:49" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "16:45:30" , 
"departure_time" : "16:45:46" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:03:16" , 
"departure_time" : "17:04:42" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "17:11:26" , 
"departure_time" : "17:12:35" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "17:23:09" , 
"departure_time" : "17:23:09" , 
"distance_traveled" : 57.9104
} ], 
"2718" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:15:00" , 
"departure_time" : "15:17:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:25:38" , 
"departure_time" : "15:26:56" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:34:18" , 
"departure_time" : "15:35:36" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "15:40:18" , 
"departure_time" : "15:41:09" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "15:42:51" , 
"departure_time" : "15:43:30" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "15:45:39" , 
"departure_time" : "15:45:49" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "15:52:10" , 
"departure_time" : "15:53:25" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "15:57:15" , 
"departure_time" : "15:57:41" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "16:02:26" , 
"departure_time" : "16:02:44" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "16:07:18" , 
"departure_time" : "16:07:26" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "16:12:08" , 
"departure_time" : "16:13:16" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "16:17:08" , 
"departure_time" : "16:17:16" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:31:08" , 
"departure_time" : "16:31:48" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "16:38:40" , 
"departure_time" : "16:38:44" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "16:48:04" , 
"departure_time" : "16:48:04" , 
"distance_traveled" : 57.9102
} ], 
"2719" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:54:00" , 
"departure_time" : "16:55:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:04:26" , 
"departure_time" : "17:05:59" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:13:33" , 
"departure_time" : "17:14:44" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:20:11" , 
"departure_time" : "17:20:19" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "17:34:08" , 
"departure_time" : "17:34:13" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "17:38:05" , 
"departure_time" : "17:38:10" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "17:43:05" , 
"departure_time" : "17:44:04" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "17:48:59" , 
"departure_time" : "17:50:17" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:03:18" , 
"departure_time" : "18:03:20" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "18:10:02" , 
"departure_time" : "18:11:20" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "18:25:18" , 
"departure_time" : "18:25:18" , 
"distance_traveled" : 57.9104
} ], 
"2720" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "21:14:00" , 
"departure_time" : "21:16:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:24:08" , 
"departure_time" : "21:25:43" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:33:35" , 
"departure_time" : "21:34:50" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "21:39:15" , 
"departure_time" : "21:39:20" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "21:41:05" , 
"departure_time" : "21:41:51" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "21:44:46" , 
"departure_time" : "21:45:10" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "21:51:24" , 
"departure_time" : "21:52:00" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "21:55:36" , 
"departure_time" : "21:55:43" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "22:01:07" , 
"departure_time" : "22:01:58" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "22:06:51" , 
"departure_time" : "22:07:39" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "22:11:48" , 
"departure_time" : "22:12:07" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "22:15:19" , 
"departure_time" : "22:15:59" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "22:30:40" , 
"departure_time" : "22:31:49" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "22:38:09" , 
"departure_time" : "22:39:10" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "22:49:01" , 
"departure_time" : "22:49:01" , 
"distance_traveled" : 57.9102
} ], 
"2721" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:03:00" , 
"departure_time" : "19:04:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:12:35" , 
"departure_time" : "19:13:00" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:21:25" , 
"departure_time" : "19:22:05" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:26:40" , 
"departure_time" : "19:26:43" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "19:40:03" , 
"departure_time" : "19:40:37" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "19:45:34" , 
"departure_time" : "19:46:53" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "19:51:19" , 
"departure_time" : "19:51:54" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "19:54:35" , 
"departure_time" : "19:54:57" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "20:09:22" , 
"departure_time" : "20:10:43" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "20:17:21" , 
"departure_time" : "20:18:22" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "20:29:01" , 
"departure_time" : "20:29:01" , 
"distance_traveled" : 57.9104
} ], 
"2722" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "22:14:00" , 
"departure_time" : "22:15:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:23:39" , 
"departure_time" : "22:23:58" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:32:19" , 
"departure_time" : "22:33:30" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:39:11" , 
"departure_time" : "22:39:21" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "22:41:10" , 
"departure_time" : "22:41:38" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "22:44:28" , 
"departure_time" : "22:45:10" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "22:51:42" , 
"departure_time" : "22:52:16" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "22:55:34" , 
"departure_time" : "22:55:43" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "23:01:09" , 
"departure_time" : "23:02:37" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "23:07:28" , 
"departure_time" : "23:07:39" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "23:11:11" , 
"departure_time" : "23:11:26" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "23:15:15" , 
"departure_time" : "23:16:24" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "23:31:09" , 
"departure_time" : "23:31:55" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "23:37:46" , 
"departure_time" : "23:39:22" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "23:49:36" , 
"departure_time" : "23:49:36" , 
"distance_traveled" : 57.9102
} ], 
"2723" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:03:00" , 
"departure_time" : "20:05:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:13:22" , 
"departure_time" : "20:14:51" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:22:29" , 
"departure_time" : "20:23:09" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:26:40" , 
"departure_time" : "20:27:23" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "20:41:43" , 
"departure_time" : "20:42:54" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "20:47:11" , 
"departure_time" : "20:48:51" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "20:52:40" , 
"departure_time" : "20:53:25" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "20:55:45" , 
"departure_time" : "20:56:15" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "21:11:30" , 
"departure_time" : "21:11:45" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "21:18:15" , 
"departure_time" : "21:19:12" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "21:30:57" , 
"departure_time" : "21:30:57" , 
"distance_traveled" : 57.9104
} ], 
"2724" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "23:14:00" , 
"departure_time" : "23:15:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:23:07" , 
"departure_time" : "23:24:11" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "23:33:04" , 
"departure_time" : "23:34:10" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "23:39:06" , 
"departure_time" : "23:39:47" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "23:41:41" , 
"departure_time" : "23:42:41" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "23:45:00" , 
"departure_time" : "23:45:03" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "23:51:03" , 
"departure_time" : "23:51:23" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "23:55:20" , 
"departure_time" : "23:55:55" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "24:01:35" , 
"departure_time" : "24:02:17" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "24:06:42" , 
"departure_time" : "24:07:40" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "24:11:58" , 
"departure_time" : "24:13:19" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "24:16:21" , 
"departure_time" : "24:17:20" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "24:30:59" , 
"departure_time" : "24:32:36" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "24:38:37" , 
"departure_time" : "24:39:16" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "24:54:39" , 
"departure_time" : "24:54:39" , 
"distance_traveled" : 57.9102
} ], 
"2725" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "08:14:00" , 
"departure_time" : "08:15:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:24:18" , 
"departure_time" : "08:25:31" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:33:13" , 
"departure_time" : "08:34:00" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:38:47" , 
"departure_time" : "08:39:07" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "08:43:20" , 
"departure_time" : "08:43:30" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "08:50:10" , 
"departure_time" : "08:50:17" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:54:07" , 
"departure_time" : "08:54:09" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "09:00:02" , 
"departure_time" : "09:01:06" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "09:06:04" , 
"departure_time" : "09:07:32" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "09:11:28" , 
"departure_time" : "09:12:58" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "09:15:30" , 
"departure_time" : "09:16:08" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "09:29:38" , 
"departure_time" : "09:30:45" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "09:37:07" , 
"departure_time" : "09:37:19" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "09:48:12" , 
"departure_time" : "09:48:12" , 
"distance_traveled" : 57.9102
} ], 
"2726" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "25:22:00" , 
"departure_time" : "25:22:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "25:31:22" , 
"departure_time" : "25:32:44" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "25:41:22" , 
"departure_time" : "25:42:30" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "25:47:08" , 
"departure_time" : "25:47:36" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "25:50:28" , 
"departure_time" : "25:51:07" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "25:53:39" , 
"departure_time" : "25:54:34" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "25:59:55" , 
"departure_time" : "26:01:03" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "26:04:08" , 
"departure_time" : "26:05:05" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "26:10:57" , 
"departure_time" : "26:12:17" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "26:15:20" , 
"departure_time" : "26:17:00" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "26:20:40" , 
"departure_time" : "26:22:02" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "26:24:22" , 
"departure_time" : "26:25:38" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "26:29:16" , 
"departure_time" : "26:29:21" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "26:41:05" , 
"departure_time" : "26:42:26" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "26:48:21" , 
"departure_time" : "26:50:01" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "27:07:40" , 
"departure_time" : "27:07:40" , 
"distance_traveled" : 57.9104
} ], 
"2727" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "10:14:00" , 
"departure_time" : "10:16:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:23:34" , 
"departure_time" : "10:23:57" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:32:23" , 
"departure_time" : "10:32:25" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:38:02" , 
"departure_time" : "10:38:16" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "10:43:14" , 
"departure_time" : "10:43:35" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "10:50:21" , 
"departure_time" : "10:50:31" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "10:54:10" , 
"departure_time" : "10:54:54" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "11:00:44" , 
"departure_time" : "11:01:02" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "11:05:18" , 
"departure_time" : "11:06:40" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "11:11:22" , 
"departure_time" : "11:13:01" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "11:15:39" , 
"departure_time" : "11:16:38" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "11:29:59" , 
"departure_time" : "11:31:35" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "11:37:36" , 
"departure_time" : "11:37:56" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "11:48:20" , 
"departure_time" : "11:48:20" , 
"distance_traveled" : 57.9102
} ], 
"2728" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "25:22:00" , 
"departure_time" : "25:24:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "25:32:40" , 
"departure_time" : "25:34:00" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "25:41:20" , 
"departure_time" : "25:42:41" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "25:47:21" , 
"departure_time" : "25:47:34" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "25:50:13" , 
"departure_time" : "25:50:50" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "25:53:37" , 
"departure_time" : "25:54:02" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "25:59:25" , 
"departure_time" : "25:59:28" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "26:03:03" , 
"departure_time" : "26:04:23" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "26:11:20" , 
"departure_time" : "26:11:50" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "26:14:30" , 
"departure_time" : "26:14:59" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "26:19:29" , 
"departure_time" : "26:19:52" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "26:23:23" , 
"departure_time" : "26:24:27" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "26:29:04" , 
"departure_time" : "26:29:48" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "26:41:44" , 
"departure_time" : "26:42:01" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "26:47:17" , 
"departure_time" : "26:47:20" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "27:06:03" , 
"departure_time" : "27:06:03" , 
"distance_traveled" : 57.9104
} ], 
"2729" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "11:14:00" , 
"departure_time" : "11:15:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:24:39" , 
"departure_time" : "11:24:43" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:32:04" , 
"departure_time" : "11:33:21" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "11:39:17" , 
"departure_time" : "11:40:25" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "11:44:08" , 
"departure_time" : "11:45:28" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "11:51:20" , 
"departure_time" : "11:52:58" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "11:55:38" , 
"departure_time" : "11:57:08" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "12:01:30" , 
"departure_time" : "12:02:32" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "12:06:02" , 
"departure_time" : "12:07:25" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "12:11:23" , 
"departure_time" : "12:11:24" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "12:14:01" , 
"departure_time" : "12:14:25" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "12:29:24" , 
"departure_time" : "12:30:24" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "12:37:00" , 
"departure_time" : "12:38:16" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "12:49:16" , 
"departure_time" : "12:49:16" , 
"distance_traveled" : 57.9102
} ], 
"2730" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "12:01:00" , 
"departure_time" : "12:02:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:10:36" , 
"departure_time" : "12:12:00" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:19:24" , 
"departure_time" : "12:19:28" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 109,
"arrival_time" : "12:24:04" , 
"departure_time" : "12:25:23" , 
"distance_traveled" : 14.3875
}, 
{ 
"stop_id" : 41,
"arrival_time" : "12:28:19" , 
"departure_time" : "12:28:58" , 
"distance_traveled" : 15.3631
}, 
{ 
"stop_id" : 70,
"arrival_time" : "12:33:39" , 
"departure_time" : "12:35:07" , 
"distance_traveled" : 18.6468
}, 
{ 
"stop_id" : 127,
"arrival_time" : "12:37:28" , 
"departure_time" : "12:37:28" , 
"distance_traveled" : 20.7053
} ], 
"2731" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:14:00" , 
"departure_time" : "16:16:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:24:06" , 
"departure_time" : "16:25:09" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:33:03" , 
"departure_time" : "16:33:38" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:38:35" , 
"departure_time" : "16:39:55" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "16:44:20" , 
"departure_time" : "16:45:48" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "16:50:28" , 
"departure_time" : "16:50:37" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "16:53:09" , 
"departure_time" : "16:53:47" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "17:00:38" , 
"departure_time" : "17:01:08" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "17:05:30" , 
"departure_time" : "17:06:21" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "17:10:51" , 
"departure_time" : "17:12:27" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "17:15:36" , 
"departure_time" : "17:16:06" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:29:30" , 
"departure_time" : "17:30:57" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "17:36:27" , 
"departure_time" : "17:36:46" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "17:47:19" , 
"departure_time" : "17:47:19" , 
"distance_traveled" : 57.9102
} ], 
"2732" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "24:43:00" , 
"departure_time" : "24:43:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:52:38" , 
"departure_time" : "24:53:02" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "25:01:24" , 
"departure_time" : "25:01:30" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "25:07:06" , 
"departure_time" : "25:07:36" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "25:12:30" , 
"departure_time" : "25:14:04" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "25:20:34" , 
"departure_time" : "25:21:36" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "25:24:02" , 
"departure_time" : "25:24:49" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "25:29:47" , 
"departure_time" : "25:31:24" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "25:35:37" , 
"departure_time" : "25:37:11" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "25:40:34" , 
"departure_time" : "25:42:09" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "25:44:35" , 
"departure_time" : "25:45:16" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "25:48:41" , 
"departure_time" : "25:49:47" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "26:02:06" , 
"departure_time" : "26:03:28" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "26:08:22" , 
"departure_time" : "26:09:34" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "26:23:12" , 
"departure_time" : "26:23:12" , 
"distance_traveled" : 57.9104
} ], 
"2733" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "06:13:00" , 
"departure_time" : "06:14:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:22:25" , 
"departure_time" : "06:23:51" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:32:26" , 
"departure_time" : "06:34:05" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "06:38:39" , 
"departure_time" : "06:39:39" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "06:43:00" , 
"departure_time" : "06:43:58" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "06:49:58" , 
"departure_time" : "06:50:35" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "06:53:37" , 
"departure_time" : "06:54:58" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "07:00:21" , 
"departure_time" : "07:02:00" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "07:05:39" , 
"departure_time" : "07:07:13" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "07:10:34" , 
"departure_time" : "07:11:56" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "07:14:22" , 
"departure_time" : "07:15:18" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "07:28:56" , 
"departure_time" : "07:30:21" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "07:36:25" , 
"departure_time" : "07:36:37" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "07:46:12" , 
"departure_time" : "07:46:12" , 
"distance_traveled" : 57.9102
} ], 
"2734" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "24:43:00" , 
"departure_time" : "24:43:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:52:05" , 
"departure_time" : "24:52:57" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "25:01:52" , 
"departure_time" : "25:02:10" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "25:07:18" , 
"departure_time" : "25:07:56" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "25:12:38" , 
"departure_time" : "25:14:05" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "25:20:27" , 
"departure_time" : "25:20:37" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "25:23:10" , 
"departure_time" : "25:23:54" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "25:29:44" , 
"departure_time" : "25:31:06" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "25:35:22" , 
"departure_time" : "25:35:26" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "25:39:04" , 
"departure_time" : "25:40:09" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "25:44:05" , 
"departure_time" : "25:44:38" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "25:48:33" , 
"departure_time" : "25:48:46" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "26:01:13" , 
"departure_time" : "26:02:26" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "26:08:13" , 
"departure_time" : "26:08:42" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "26:22:29" , 
"departure_time" : "26:22:29" , 
"distance_traveled" : 57.9104
} ], 
"2735" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "07:14:00" , 
"departure_time" : "07:15:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:24:24" , 
"departure_time" : "07:25:57" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:33:33" , 
"departure_time" : "07:34:50" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "07:39:17" , 
"departure_time" : "07:40:39" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "07:44:22" , 
"departure_time" : "07:44:29" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "07:50:07" , 
"departure_time" : "07:50:43" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "07:54:36" , 
"departure_time" : "07:55:34" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "08:00:58" , 
"departure_time" : "08:01:28" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "08:05:30" , 
"departure_time" : "08:06:57" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "08:11:27" , 
"departure_time" : "08:12:58" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "08:15:31" , 
"departure_time" : "08:16:18" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "08:29:47" , 
"departure_time" : "08:31:16" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "08:37:29" , 
"departure_time" : "08:38:49" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "08:48:20" , 
"departure_time" : "08:48:20" , 
"distance_traveled" : 57.9102
} ], 
"2736" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "24:43:00" , 
"departure_time" : "24:45:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:52:55" , 
"departure_time" : "24:53:57" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "25:02:02" , 
"departure_time" : "25:02:58" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "25:07:56" , 
"departure_time" : "25:09:15" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "25:13:19" , 
"departure_time" : "25:14:50" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "25:20:31" , 
"departure_time" : "25:20:34" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "25:23:03" , 
"departure_time" : "25:24:10" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "25:30:07" , 
"departure_time" : "25:31:13" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "25:35:06" , 
"departure_time" : "25:35:08" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "25:39:02" , 
"departure_time" : "25:40:03" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "25:44:01" , 
"departure_time" : "25:44:47" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "25:48:46" , 
"departure_time" : "25:50:25" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "26:02:39" , 
"departure_time" : "26:03:53" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "26:08:14" , 
"departure_time" : "26:09:41" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "26:23:27" , 
"departure_time" : "26:23:27" , 
"distance_traveled" : 57.9104
} ], 
"2737" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "09:14:00" , 
"departure_time" : "09:17:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:24:33" , 
"departure_time" : "09:26:11" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:33:38" , 
"departure_time" : "09:35:15" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:39:37" , 
"departure_time" : "09:40:10" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "09:43:33" , 
"departure_time" : "09:43:35" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "09:50:02" , 
"departure_time" : "09:51:40" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "09:55:38" , 
"departure_time" : "09:57:02" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "10:01:24" , 
"departure_time" : "10:01:51" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "10:05:27" , 
"departure_time" : "10:06:59" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "10:11:32" , 
"departure_time" : "10:11:56" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "10:14:24" , 
"departure_time" : "10:15:42" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "10:30:18" , 
"departure_time" : "10:30:48" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "10:36:30" , 
"departure_time" : "10:37:46" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "10:49:16" , 
"departure_time" : "10:49:16" , 
"distance_traveled" : 57.9102
} ], 
"2738" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "08:05:00" , 
"departure_time" : "08:07:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:15:09" , 
"departure_time" : "08:16:25" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:24:16" , 
"departure_time" : "08:25:42" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:30:26" , 
"departure_time" : "08:32:06" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "08:35:40" , 
"departure_time" : "08:36:59" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "08:41:19" , 
"departure_time" : "08:42:13" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:44:54" , 
"departure_time" : "08:45:30" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "08:50:36" , 
"departure_time" : "08:51:48" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 103,
"arrival_time" : "09:01:12" , 
"departure_time" : "09:02:39" , 
"distance_traveled" : 32.5547
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "09:07:27" , 
"departure_time" : "09:07:27" , 
"distance_traveled" : 34.3589
} ], 
"2739" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:14:00" , 
"departure_time" : "17:16:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:24:00" , 
"departure_time" : "17:25:22" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:33:22" , 
"departure_time" : "17:34:17" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:38:55" , 
"departure_time" : "17:39:42" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "17:43:47" , 
"departure_time" : "17:44:20" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "17:49:33" , 
"departure_time" : "17:50:42" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "17:54:09" , 
"departure_time" : "17:54:17" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "18:00:08" , 
"departure_time" : "18:01:40" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "18:05:32" , 
"departure_time" : "18:05:41" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "18:09:09" , 
"departure_time" : "18:10:32" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "18:15:23" , 
"departure_time" : "18:16:17" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:29:54" , 
"departure_time" : "18:30:31" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "18:36:37" , 
"departure_time" : "18:37:10" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "18:47:33" , 
"departure_time" : "18:47:33" , 
"distance_traveled" : 57.9102
} ], 
"2740" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:50:00" , 
"departure_time" : "16:52:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:00:30" , 
"departure_time" : "17:01:26" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:09:56" , 
"departure_time" : "17:10:06" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:16:10" , 
"departure_time" : "17:16:23" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "17:31:13" , 
"departure_time" : "17:32:47" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "17:37:34" , 
"departure_time" : "17:38:25" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "17:41:51" , 
"departure_time" : "17:42:06" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "17:46:15" , 
"departure_time" : "17:46:21" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "17:52:06" , 
"departure_time" : "17:52:06" , 
"distance_traveled" : 34.3589
} ], 
"2741" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:14:00" , 
"departure_time" : "18:15:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:24:30" , 
"departure_time" : "18:25:52" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:33:22" , 
"departure_time" : "18:34:05" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:38:43" , 
"departure_time" : "18:39:39" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "18:43:56" , 
"departure_time" : "18:44:42" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "18:50:46" , 
"departure_time" : "18:51:41" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:54:55" , 
"departure_time" : "18:56:22" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "19:01:27" , 
"departure_time" : "19:01:42" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "19:05:15" , 
"departure_time" : "19:05:26" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "19:10:11" , 
"departure_time" : "19:11:23" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "19:15:12" , 
"departure_time" : "19:15:49" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:29:37" , 
"departure_time" : "19:30:45" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "19:37:08" , 
"departure_time" : "19:38:05" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "19:47:57" , 
"departure_time" : "19:47:57" , 
"distance_traveled" : 57.9102
} ], 
"2742" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:37:00" , 
"departure_time" : "18:39:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:47:18" , 
"departure_time" : "18:47:22" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:57:04" , 
"departure_time" : "18:57:34" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:03:30" , 
"departure_time" : "19:04:23" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "19:17:53" , 
"departure_time" : "19:19:09" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "19:23:16" , 
"departure_time" : "19:24:31" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "19:28:15" , 
"departure_time" : "19:29:50" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "19:33:35" , 
"departure_time" : "19:34:35" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "19:36:00" , 
"departure_time" : "19:36:00" , 
"distance_traveled" : 34.3589
} ], 
"2743" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:14:00" , 
"departure_time" : "19:16:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:24:19" , 
"departure_time" : "19:24:20" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:32:01" , 
"departure_time" : "19:32:35" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:38:34" , 
"departure_time" : "19:39:36" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "19:44:02" , 
"departure_time" : "19:44:22" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "19:50:20" , 
"departure_time" : "19:50:34" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "19:54:14" , 
"departure_time" : "19:54:19" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "20:00:05" , 
"departure_time" : "20:00:34" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "20:05:29" , 
"departure_time" : "20:06:12" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "20:10:43" , 
"departure_time" : "20:11:46" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "20:15:03" , 
"departure_time" : "20:15:21" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "20:29:18" , 
"departure_time" : "20:30:23" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "20:37:05" , 
"departure_time" : "20:38:33" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "20:49:28" , 
"departure_time" : "20:49:28" , 
"distance_traveled" : 57.9102
} ], 
"2744" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:12:00" , 
"departure_time" : "19:13:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:22:21" , 
"departure_time" : "19:22:28" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:31:07" , 
"departure_time" : "19:32:26" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:38:19" , 
"departure_time" : "19:38:50" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 103,
"arrival_time" : "19:59:31" , 
"departure_time" : "19:59:34" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "20:04:03" , 
"departure_time" : "20:04:47" , 
"distance_traveled" : 34.3589
}, 
{ 
"stop_id" : 125,
"arrival_time" : "20:17:44" , 
"departure_time" : "20:18:24" , 
"distance_traveled" : 48.286
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "20:24:40" , 
"departure_time" : "20:25:43" , 
"distance_traveled" : 54.2568
}, 
{ 
"stop_id" : 148,
"arrival_time" : "20:36:03" , 
"departure_time" : "20:36:03" , 
"distance_traveled" : 57.9106
} ], 
"2745" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:14:00" , 
"departure_time" : "20:15:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:23:33" , 
"departure_time" : "20:25:04" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:33:31" , 
"departure_time" : "20:33:40" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:38:09" , 
"departure_time" : "20:39:40" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "20:44:31" , 
"departure_time" : "20:45:23" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "20:50:52" , 
"departure_time" : "20:51:41" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:54:49" , 
"departure_time" : "20:55:35" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "21:00:46" , 
"departure_time" : "21:01:46" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "21:06:00" , 
"departure_time" : "21:07:39" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "21:11:39" , 
"departure_time" : "21:12:08" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "21:14:29" , 
"departure_time" : "21:14:31" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "21:29:02" , 
"departure_time" : "21:29:52" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "21:36:50" , 
"departure_time" : "21:38:18" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "21:48:28" , 
"departure_time" : "21:48:28" , 
"distance_traveled" : 57.9102
} ], 
"2746" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:30:00" , 
"departure_time" : "15:32:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:41:05" , 
"departure_time" : "15:42:25" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:50:20" , 
"departure_time" : "15:51:35" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 83,
"arrival_time" : "16:07:15" , 
"departure_time" : "16:08:32" , 
"distance_traveled" : 24.5038
}, 
{ 
"stop_id" : 84,
"arrival_time" : "16:11:17" , 
"departure_time" : "16:11:55" , 
"distance_traveled" : 27.0947
}, 
{ 
"stop_id" : 38,
"arrival_time" : "16:15:38" , 
"departure_time" : "16:16:22" , 
"distance_traveled" : 30.1831
}, 
{ 
"stop_id" : 103,
"arrival_time" : "16:20:44" , 
"departure_time" : "16:21:10" , 
"distance_traveled" : 32.55
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "16:24:26" , 
"departure_time" : "16:25:57" , 
"distance_traveled" : 34.3593
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:38:31" , 
"departure_time" : "16:39:24" , 
"distance_traveled" : 48.2864
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "16:44:53" , 
"departure_time" : "16:46:17" , 
"distance_traveled" : 54.2572
}, 
{ 
"stop_id" : 148,
"arrival_time" : "16:55:24" , 
"departure_time" : "16:55:24" , 
"distance_traveled" : 57.911
} ], 
"2747" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "05:10:00" , 
"departure_time" : "05:12:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:20:23" , 
"departure_time" : "05:21:46" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "05:29:23" , 
"departure_time" : "05:30:34" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "05:35:11" , 
"departure_time" : "05:36:06" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "05:37:55" , 
"departure_time" : "05:39:08" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "05:41:13" , 
"departure_time" : "05:42:13" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "05:48:00" , 
"departure_time" : "05:49:22" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "05:52:22" , 
"departure_time" : "05:53:44" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "05:58:22" , 
"departure_time" : "05:59:58" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "06:03:36" , 
"departure_time" : "06:04:15" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "06:07:39" , 
"departure_time" : "06:08:06" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "06:11:27" , 
"departure_time" : "06:12:31" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "06:27:04" , 
"departure_time" : "06:28:34" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "06:34:30" , 
"departure_time" : "06:35:19" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "06:44:49" , 
"departure_time" : "06:44:49" , 
"distance_traveled" : 57.9102
} ], 
"2748" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:07:00" , 
"departure_time" : "15:08:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:16:40" , 
"departure_time" : "15:17:27" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:26:47" , 
"departure_time" : "15:27:47" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "15:33:00" , 
"departure_time" : "15:33:40" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "15:37:40" , 
"departure_time" : "15:37:53" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "15:44:13" , 
"departure_time" : "15:45:01" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "15:48:48" , 
"departure_time" : "15:48:53" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "15:53:05" , 
"departure_time" : "15:53:31" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "15:58:26" , 
"departure_time" : "15:58:50" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "16:03:24" , 
"departure_time" : "16:04:09" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "16:07:45" , 
"departure_time" : "16:08:42" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "16:15:57" , 
"departure_time" : "16:15:57" , 
"distance_traveled" : 34.3587
} ], 
"2749" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "12:14:00" , 
"departure_time" : "12:16:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:24:39" , 
"departure_time" : "12:25:27" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:32:48" , 
"departure_time" : "12:33:05" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "12:38:17" , 
"departure_time" : "12:39:14" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "12:41:57" , 
"departure_time" : "12:42:15" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "12:44:18" , 
"departure_time" : "12:44:59" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "12:51:41" , 
"departure_time" : "12:53:03" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "12:56:22" , 
"departure_time" : "12:56:43" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "13:01:21" , 
"departure_time" : "13:01:42" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "13:06:21" , 
"departure_time" : "13:07:22" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "13:12:01" , 
"departure_time" : "13:13:03" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "13:16:02" , 
"departure_time" : "13:17:22" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:31:20" , 
"departure_time" : "13:32:48" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "13:38:28" , 
"departure_time" : "13:39:45" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "13:53:17" , 
"departure_time" : "13:53:17" , 
"distance_traveled" : 57.9102
} ], 
"2750" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:14:00" , 
"departure_time" : "18:15:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:30:17" , 
"departure_time" : "18:31:08" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:36:51" , 
"departure_time" : "18:37:08" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:47:17" , 
"departure_time" : "18:47:46" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "18:53:29" , 
"departure_time" : "18:55:02" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "18:59:33" , 
"departure_time" : "19:00:08" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "19:04:35" , 
"departure_time" : "19:05:43" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "19:09:08" , 
"departure_time" : "19:10:43" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "19:14:35" , 
"departure_time" : "19:14:42" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:25:07" , 
"departure_time" : "19:25:20" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "19:32:13" , 
"departure_time" : "19:33:40" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "19:45:27" , 
"departure_time" : "19:45:27" , 
"distance_traveled" : 57.9104
} ], 
"2751" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "13:14:00" , 
"departure_time" : "13:16:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:23:59" , 
"departure_time" : "13:25:23" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:33:24" , 
"departure_time" : "13:34:51" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:39:27" , 
"departure_time" : "13:41:06" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "13:42:39" , 
"departure_time" : "13:42:59" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "13:44:20" , 
"departure_time" : "13:45:14" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "13:51:54" , 
"departure_time" : "13:53:29" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "13:56:35" , 
"departure_time" : "13:58:15" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "14:02:40" , 
"departure_time" : "14:02:45" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "14:06:05" , 
"departure_time" : "14:07:05" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "14:12:00" , 
"departure_time" : "14:13:27" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "14:16:27" , 
"departure_time" : "14:16:43" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "14:30:16" , 
"departure_time" : "14:31:16" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "14:38:00" , 
"departure_time" : "14:38:07" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "14:48:07" , 
"departure_time" : "14:48:07" , 
"distance_traveled" : 57.9102
} ], 
"2752" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:37:00" , 
"departure_time" : "20:37:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:47:39" , 
"departure_time" : "20:49:00" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:57:21" , 
"departure_time" : "20:57:40" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "21:01:19" , 
"departure_time" : "21:02:51" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "21:16:32" , 
"departure_time" : "21:17:41" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "21:21:09" , 
"departure_time" : "21:22:23" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "21:26:14" , 
"departure_time" : "21:27:49" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "21:31:35" , 
"departure_time" : "21:32:40" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "21:35:05" , 
"departure_time" : "21:35:53" , 
"distance_traveled" : 34.3589
}, 
{ 
"stop_id" : 125,
"arrival_time" : "21:47:48" , 
"departure_time" : "21:48:23" , 
"distance_traveled" : 48.286
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "21:55:35" , 
"departure_time" : "21:57:06" , 
"distance_traveled" : 54.2568
}, 
{ 
"stop_id" : 148,
"arrival_time" : "22:08:31" , 
"departure_time" : "22:08:31" , 
"distance_traveled" : 57.9106
} ], 
"2753" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "14:14:00" , 
"departure_time" : "14:16:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:23:48" , 
"departure_time" : "14:24:00" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:32:12" , 
"departure_time" : "14:32:23" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "14:38:11" , 
"departure_time" : "14:39:38" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "14:42:27" , 
"departure_time" : "14:42:53" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "14:44:26" , 
"departure_time" : "14:44:53" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "14:51:27" , 
"departure_time" : "14:52:27" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "14:56:00" , 
"departure_time" : "14:57:00" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "15:02:00" , 
"departure_time" : "15:03:30" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "15:07:30" , 
"departure_time" : "15:09:09" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "15:12:39" , 
"departure_time" : "15:14:18" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "15:16:39" , 
"departure_time" : "15:16:58" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:30:19" , 
"departure_time" : "15:31:16" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "15:37:57" , 
"departure_time" : "15:38:59" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "15:49:02" , 
"departure_time" : "15:49:02" , 
"distance_traveled" : 57.9102
} ], 
"2754" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "14:29:00" , 
"departure_time" : "14:30:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:38:09" , 
"departure_time" : "14:38:59" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:48:50" , 
"departure_time" : "14:50:26" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "14:55:36" , 
"departure_time" : "14:57:14" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "14:58:38" , 
"departure_time" : "14:59:05" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "15:00:27" , 
"departure_time" : "15:01:17" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "15:07:50" , 
"departure_time" : "15:09:09" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "15:12:19" , 
"departure_time" : "15:12:43" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "15:16:24" , 
"departure_time" : "15:17:35" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "15:22:11" , 
"departure_time" : "15:23:18" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "15:27:07" , 
"departure_time" : "15:28:06" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "15:30:59" , 
"departure_time" : "15:32:06" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "15:39:07" , 
"departure_time" : "15:39:07" , 
"distance_traveled" : 34.3587
} ], 
"2755" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:15:00" , 
"departure_time" : "15:17:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:24:53" , 
"departure_time" : "15:26:07" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:34:14" , 
"departure_time" : "15:35:20" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "15:40:06" , 
"departure_time" : "15:40:22" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "15:42:16" , 
"departure_time" : "15:42:25" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "15:45:09" , 
"departure_time" : "15:46:42" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "15:53:33" , 
"departure_time" : "15:53:57" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "15:56:24" , 
"departure_time" : "15:56:30" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "16:02:06" , 
"departure_time" : "16:02:54" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "16:07:48" , 
"departure_time" : "16:08:51" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "16:13:03" , 
"departure_time" : "16:13:06" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "16:16:03" , 
"departure_time" : "16:16:19" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:31:16" , 
"departure_time" : "16:32:23" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "16:39:07" , 
"departure_time" : "16:40:06" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "16:48:59" , 
"departure_time" : "16:48:59" , 
"distance_traveled" : 57.9102
} ], 
"2756" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "21:54:00" , 
"departure_time" : "21:56:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:05:35" , 
"departure_time" : "22:06:10" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:13:35" , 
"departure_time" : "22:14:01" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:19:26" , 
"departure_time" : "22:19:30" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "22:22:04" , 
"departure_time" : "22:22:09" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "22:26:05" , 
"departure_time" : "22:26:23" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "22:32:18" , 
"departure_time" : "22:33:38" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "22:37:20" , 
"departure_time" : "22:38:01" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "22:43:41" , 
"departure_time" : "22:45:01" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "22:48:20" , 
"departure_time" : "22:49:06" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "22:52:46" , 
"departure_time" : "22:53:17" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "22:57:31" , 
"departure_time" : "22:58:43" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "23:07:12" , 
"departure_time" : "23:07:12" , 
"distance_traveled" : 34.3587
} ], 
"2757" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "21:14:00" , 
"departure_time" : "21:15:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:23:04" , 
"departure_time" : "21:23:44" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:32:40" , 
"departure_time" : "21:33:35" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "21:38:55" , 
"departure_time" : "21:40:04" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "21:42:09" , 
"departure_time" : "21:42:51" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "21:44:42" , 
"departure_time" : "21:45:04" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "21:51:22" , 
"departure_time" : "21:52:47" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "21:56:25" , 
"departure_time" : "21:57:18" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "22:01:53" , 
"departure_time" : "22:01:59" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "22:06:06" , 
"departure_time" : "22:06:08" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "22:11:02" , 
"departure_time" : "22:11:32" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "22:15:30" , 
"departure_time" : "22:15:42" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "22:30:12" , 
"departure_time" : "22:30:31" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "22:37:19" , 
"departure_time" : "22:38:12" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "22:48:53" , 
"departure_time" : "22:48:53" , 
"distance_traveled" : 57.9102
} ], 
"2758" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "07:56:00" , 
"departure_time" : "07:58:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:06:24" , 
"departure_time" : "08:07:09" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:13:45" , 
"departure_time" : "08:14:40" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:19:55" , 
"departure_time" : "08:20:07" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:30:12" , 
"departure_time" : "08:30:57" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "08:37:45" , 
"departure_time" : "08:38:28" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "08:42:43" , 
"departure_time" : "08:42:47" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "08:47:04" , 
"departure_time" : "08:47:42" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "08:51:38" , 
"departure_time" : "08:51:54" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "08:56:16" , 
"departure_time" : "08:56:30" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "09:09:14" , 
"departure_time" : "09:09:47" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "09:15:33" , 
"departure_time" : "09:15:46" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "09:27:13" , 
"departure_time" : "09:27:13" , 
"distance_traveled" : 57.9104
} ], 
"2759" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "22:14:00" , 
"departure_time" : "22:15:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:24:02" , 
"departure_time" : "22:25:04" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:33:02" , 
"departure_time" : "22:34:20" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:39:18" , 
"departure_time" : "22:40:51" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "22:42:33" , 
"departure_time" : "22:43:42" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "22:45:09" , 
"departure_time" : "22:45:54" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "22:51:45" , 
"departure_time" : "22:52:08" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "22:55:23" , 
"departure_time" : "22:55:33" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "23:01:10" , 
"departure_time" : "23:02:29" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "23:07:19" , 
"departure_time" : "23:08:15" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "23:11:56" , 
"departure_time" : "23:12:33" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "23:15:37" , 
"departure_time" : "23:16:02" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "23:30:25" , 
"departure_time" : "23:31:04" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "23:37:39" , 
"departure_time" : "23:37:42" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "23:48:03" , 
"departure_time" : "23:48:03" , 
"distance_traveled" : 57.9102
} ], 
"2760" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "08:41:00" , 
"departure_time" : "08:41:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:50:35" , 
"departure_time" : "08:51:29" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:59:54" , 
"departure_time" : "09:00:01" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:05:07" , 
"departure_time" : "09:06:39" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 127,
"arrival_time" : "09:17:32" , 
"departure_time" : "09:18:54" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "09:22:22" , 
"departure_time" : "09:23:06" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "09:26:44" , 
"departure_time" : "09:28:20" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "09:32:36" , 
"departure_time" : "09:33:17" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "09:36:41" , 
"departure_time" : "09:37:09" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "09:56:28" , 
"departure_time" : "09:57:21" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "10:03:53" , 
"departure_time" : "10:05:20" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "10:12:27" , 
"departure_time" : "10:12:27" , 
"distance_traveled" : 57.9102
} ], 
"2761" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "23:14:00" , 
"departure_time" : "23:15:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:23:03" , 
"departure_time" : "23:23:40" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "23:32:37" , 
"departure_time" : "23:33:43" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "23:39:06" , 
"departure_time" : "23:39:23" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "23:41:17" , 
"departure_time" : "23:42:05" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "23:44:48" , 
"departure_time" : "23:46:22" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "23:52:34" , 
"departure_time" : "23:54:01" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "23:56:27" , 
"departure_time" : "23:57:04" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "24:01:37" , 
"departure_time" : "24:02:08" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "24:06:31" , 
"departure_time" : "24:06:58" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "24:11:27" , 
"departure_time" : "24:12:00" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "24:15:33" , 
"departure_time" : "24:15:37" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "24:30:04" , 
"departure_time" : "24:30:10" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "24:37:06" , 
"departure_time" : "24:37:38" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "24:54:32" , 
"departure_time" : "24:54:32" , 
"distance_traveled" : 57.9102
} ], 
"2762" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:50:00" , 
"departure_time" : "17:50:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:00:17" , 
"departure_time" : "18:01:00" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:10:43" , 
"departure_time" : "18:11:52" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:25:09" , 
"departure_time" : "18:25:51" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "18:30:42" , 
"departure_time" : "18:31:28" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "18:35:46" , 
"departure_time" : "18:35:59" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "18:40:13" , 
"departure_time" : "18:40:42" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "18:45:29" , 
"departure_time" : "18:47:04" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "18:50:35" , 
"departure_time" : "18:51:35" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:04:00" , 
"departure_time" : "19:05:10" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "19:11:10" , 
"departure_time" : "19:12:36" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "19:26:26" , 
"departure_time" : "19:26:26" , 
"distance_traveled" : 57.9104
} ], 
"2763" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "25:22:00" , 
"departure_time" : "25:24:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "25:31:48" , 
"departure_time" : "25:33:13" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "25:41:25" , 
"departure_time" : "25:43:01" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "25:47:36" , 
"departure_time" : "25:49:06" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "25:51:30" , 
"departure_time" : "25:52:47" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "25:54:17" , 
"departure_time" : "25:55:28" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "26:00:11" , 
"departure_time" : "26:00:16" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "26:03:05" , 
"departure_time" : "26:03:47" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "26:10:42" , 
"departure_time" : "26:12:15" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "26:15:33" , 
"departure_time" : "26:15:57" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "26:19:24" , 
"departure_time" : "26:20:07" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "26:23:43" , 
"departure_time" : "26:24:20" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "26:28:37" , 
"departure_time" : "26:29:05" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "26:41:28" , 
"departure_time" : "26:42:53" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "26:48:25" , 
"departure_time" : "26:48:48" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "27:06:23" , 
"departure_time" : "27:06:23" , 
"distance_traveled" : 57.9104
} ], 
"2764" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:42:00" , 
"departure_time" : "15:42:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:58:15" , 
"departure_time" : "15:58:25" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:04:10" , 
"departure_time" : "16:04:21" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "16:09:11" , 
"departure_time" : "16:10:50" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "16:17:39" , 
"departure_time" : "16:18:56" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "16:21:17" , 
"departure_time" : "16:21:45" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "16:26:28" , 
"departure_time" : "16:27:44" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "16:32:16" , 
"departure_time" : "16:33:06" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "16:36:50" , 
"departure_time" : "16:36:57" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "16:41:07" , 
"departure_time" : "16:41:22" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:56:15" , 
"departure_time" : "16:57:15" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "17:04:00" , 
"departure_time" : "17:05:19" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "17:13:19" , 
"departure_time" : "17:13:19" , 
"distance_traveled" : 57.9102
} ], 
"2765" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:25:00" , 
"departure_time" : "17:27:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:36:21" , 
"departure_time" : "17:37:10" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:46:49" , 
"departure_time" : "17:48:20" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:52:31" , 
"departure_time" : "17:53:25" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:01:54" , 
"departure_time" : "18:02:52" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "18:08:58" , 
"departure_time" : "18:09:03" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "18:13:05" , 
"departure_time" : "18:13:46" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "18:19:41" , 
"departure_time" : "18:20:10" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "18:24:29" , 
"departure_time" : "18:24:42" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "18:27:13" , 
"departure_time" : "18:28:40" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:43:27" , 
"departure_time" : "18:44:07" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "18:50:40" , 
"departure_time" : "18:50:48" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "19:00:08" , 
"departure_time" : "19:00:08" , 
"distance_traveled" : 57.9104
} ], 
"2766" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "24:43:00" , 
"departure_time" : "24:44:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:53:12" , 
"departure_time" : "24:54:18" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "25:02:06" , 
"departure_time" : "25:03:42" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "25:08:36" , 
"departure_time" : "25:09:28" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "25:12:52" , 
"departure_time" : "25:14:16" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "25:20:24" , 
"departure_time" : "25:20:49" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "25:23:25" , 
"departure_time" : "25:24:07" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "25:29:42" , 
"departure_time" : "25:31:14" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "25:35:32" , 
"departure_time" : "25:37:11" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "25:40:39" , 
"departure_time" : "25:40:59" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "25:43:20" , 
"departure_time" : "25:43:47" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "25:48:27" , 
"departure_time" : "25:49:15" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "26:01:48" , 
"departure_time" : "26:03:20" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "26:08:32" , 
"departure_time" : "26:08:50" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "26:22:18" , 
"departure_time" : "26:22:18" , 
"distance_traveled" : 57.9104
} ], 
"2767" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "21:06:00" , 
"departure_time" : "21:07:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:16:00" , 
"departure_time" : "21:17:19" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:25:19" , 
"departure_time" : "21:26:59" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "21:31:40" , 
"departure_time" : "21:32:55" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 127,
"arrival_time" : "21:41:15" , 
"departure_time" : "21:41:30" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "21:47:15" , 
"departure_time" : "21:48:34" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "21:52:19" , 
"departure_time" : "21:53:55" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "21:57:36" , 
"departure_time" : "21:57:37" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "22:00:01" , 
"departure_time" : "22:01:21" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "22:06:20" , 
"departure_time" : "22:06:36" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "22:17:16" , 
"departure_time" : "22:18:08" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "22:24:52" , 
"departure_time" : "22:25:50" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "22:34:58" , 
"departure_time" : "22:34:58" , 
"distance_traveled" : 57.9104
} ], 
"2768" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "24:43:00" , 
"departure_time" : "24:45:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:53:08" , 
"departure_time" : "24:53:14" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "25:01:06" , 
"departure_time" : "25:01:18" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "25:07:12" , 
"departure_time" : "25:07:30" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "25:12:18" , 
"departure_time" : "25:12:39" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "25:19:21" , 
"departure_time" : "25:19:40" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "25:23:19" , 
"departure_time" : "25:24:29" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "25:30:10" , 
"departure_time" : "25:31:11" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "25:35:01" , 
"departure_time" : "25:36:24" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "25:40:23" , 
"departure_time" : "25:40:55" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "25:43:32" , 
"departure_time" : "25:45:06" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "25:49:34" , 
"departure_time" : "25:50:03" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "26:01:29" , 
"departure_time" : "26:02:48" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "26:08:19" , 
"departure_time" : "26:09:59" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "26:23:40" , 
"departure_time" : "26:23:40" , 
"distance_traveled" : 57.9104
} ], 
"2769" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "21:35:00" , 
"departure_time" : "21:38:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:45:21" , 
"departure_time" : "21:45:41" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:55:20" , 
"departure_time" : "21:56:03" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:00:43" , 
"departure_time" : "22:00:44" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 127,
"arrival_time" : "22:10:01" , 
"departure_time" : "22:10:28" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "22:16:27" , 
"departure_time" : "22:17:59" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "22:21:32" , 
"departure_time" : "22:23:00" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "22:26:28" , 
"departure_time" : "22:26:29" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "22:30:01" , 
"departure_time" : "22:31:26" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "22:35:25" , 
"departure_time" : "22:36:56" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "22:48:31" , 
"departure_time" : "22:49:42" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "22:55:11" , 
"departure_time" : "22:56:48" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "23:07:37" , 
"departure_time" : "23:07:37" , 
"distance_traveled" : 57.9104
} ], 
"2770" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "22:11:00" , 
"departure_time" : "22:13:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:20:32" , 
"departure_time" : "22:21:34" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:31:02" , 
"departure_time" : "22:32:17" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:37:15" , 
"departure_time" : "22:38:05" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 127,
"arrival_time" : "22:46:50" , 
"departure_time" : "22:46:56" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "22:52:06" , 
"departure_time" : "22:53:38" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "22:57:32" , 
"departure_time" : "22:57:55" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "23:01:23" , 
"departure_time" : "23:02:37" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "23:06:14" , 
"departure_time" : "23:07:11" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "23:10:57" , 
"departure_time" : "23:12:36" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "23:24:39" , 
"departure_time" : "23:26:17" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "23:31:38" , 
"departure_time" : "23:31:47" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "23:42:09" , 
"departure_time" : "23:42:09" , 
"distance_traveled" : 57.9104
} ], 
"2771" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:39:00" , 
"departure_time" : "18:39:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:55:17" , 
"departure_time" : "18:56:31" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 103,
"arrival_time" : "19:19:14" , 
"departure_time" : "19:19:54" , 
"distance_traveled" : 32.55
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "19:23:40" , 
"departure_time" : "19:24:23" , 
"distance_traveled" : 34.3593
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:36:43" , 
"departure_time" : "19:37:20" , 
"distance_traveled" : 48.2864
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "19:44:37" , 
"departure_time" : "19:45:13" , 
"distance_traveled" : 54.2572
}, 
{ 
"stop_id" : 148,
"arrival_time" : "19:55:36" , 
"departure_time" : "19:55:36" , 
"distance_traveled" : 57.911
} ], 
"2772" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "22:38:00" , 
"departure_time" : "22:40:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:48:28" , 
"departure_time" : "22:49:22" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:56:54" , 
"departure_time" : "22:57:51" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "23:02:57" , 
"departure_time" : "23:03:34" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 127,
"arrival_time" : "23:12:37" , 
"departure_time" : "23:13:25" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "23:17:48" , 
"departure_time" : "23:18:45" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "23:22:57" , 
"departure_time" : "23:24:06" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "23:28:09" , 
"departure_time" : "23:29:27" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "23:32:18" , 
"departure_time" : "23:32:26" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "23:36:08" , 
"departure_time" : "23:37:07" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "23:49:59" , 
"departure_time" : "23:50:25" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "23:56:26" , 
"departure_time" : "23:58:06" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "24:08:40" , 
"departure_time" : "24:08:40" , 
"distance_traveled" : 57.9104
} ], 
"2773" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "08:05:00" , 
"departure_time" : "08:07:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:14:52" , 
"departure_time" : "08:15:02" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:23:10" , 
"departure_time" : "08:24:41" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:30:31" , 
"departure_time" : "08:31:34" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "08:35:03" , 
"departure_time" : "08:35:28" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "08:40:25" , 
"departure_time" : "08:42:05" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:45:40" , 
"departure_time" : "08:46:16" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "08:50:36" , 
"departure_time" : "08:51:11" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 103,
"arrival_time" : "09:00:35" , 
"departure_time" : "09:02:15" , 
"distance_traveled" : 32.5547
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "09:07:40" , 
"departure_time" : "09:07:40" , 
"distance_traveled" : 34.3589
} ], 
"2774" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "06:11:00" , 
"departure_time" : "06:14:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:21:36" , 
"departure_time" : "06:21:52" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:28:16" , 
"departure_time" : "06:28:34" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "06:33:18" , 
"departure_time" : "06:33:26" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "06:38:08" , 
"departure_time" : "06:39:39" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "06:46:31" , 
"departure_time" : "06:47:06" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "06:49:35" , 
"departure_time" : "06:50:52" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "06:55:17" , 
"departure_time" : "06:55:51" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "06:59:34" , 
"departure_time" : "07:00:37" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "07:05:03" , 
"departure_time" : "07:06:01" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "07:08:58" , 
"departure_time" : "07:10:26" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "07:24:28" , 
"departure_time" : "07:25:13" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "07:30:45" , 
"departure_time" : "07:30:59" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "07:40:14" , 
"departure_time" : "07:40:14" , 
"distance_traveled" : 57.9102
} ], 
"2775" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:50:00" , 
"departure_time" : "16:50:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:59:29" , 
"departure_time" : "16:59:47" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:09:18" , 
"departure_time" : "17:10:41" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:17:23" , 
"departure_time" : "17:18:10" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "17:31:47" , 
"departure_time" : "17:32:47" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "17:37:00" , 
"departure_time" : "17:37:39" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "17:41:39" , 
"departure_time" : "17:42:36" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "17:46:57" , 
"departure_time" : "17:48:33" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "17:53:36" , 
"departure_time" : "17:53:36" , 
"distance_traveled" : 34.3589
} ], 
"2776" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "07:14:00" , 
"departure_time" : "07:16:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:23:37" , 
"departure_time" : "07:24:13" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:31:36" , 
"departure_time" : "07:32:03" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "07:37:27" , 
"departure_time" : "07:38:58" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "07:44:31" , 
"departure_time" : "07:44:46" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "07:48:15" , 
"departure_time" : "07:49:35" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "07:53:20" , 
"departure_time" : "07:53:59" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "07:58:39" , 
"departure_time" : "07:59:19" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "08:03:40" , 
"departure_time" : "08:04:32" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "08:08:52" , 
"departure_time" : "08:10:20" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "08:13:28" , 
"departure_time" : "08:13:35" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "08:26:07" , 
"departure_time" : "08:26:42" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "08:33:35" , 
"departure_time" : "08:34:39" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "08:46:04" , 
"departure_time" : "08:46:04" , 
"distance_traveled" : 57.9102
} ], 
"2777" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:37:00" , 
"departure_time" : "18:38:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:46:28" , 
"departure_time" : "18:47:38" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:58:10" , 
"departure_time" : "18:59:41" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:04:31" , 
"departure_time" : "19:05:59" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "19:18:28" , 
"departure_time" : "19:19:34" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "19:23:06" , 
"departure_time" : "19:23:27" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "19:27:21" , 
"departure_time" : "19:27:48" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "19:32:27" , 
"departure_time" : "19:33:36" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "19:36:09" , 
"departure_time" : "19:36:09" , 
"distance_traveled" : 34.3589
} ], 
"2778" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "09:19:00" , 
"departure_time" : "09:21:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:29:40" , 
"departure_time" : "09:30:15" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:37:35" , 
"departure_time" : "09:38:12" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:43:37" , 
"departure_time" : "09:45:13" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "09:48:36" , 
"departure_time" : "09:49:05" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "09:54:29" , 
"departure_time" : "09:55:01" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "09:58:32" , 
"departure_time" : "09:59:00" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "10:04:28" , 
"departure_time" : "10:05:13" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "10:08:45" , 
"departure_time" : "10:09:12" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "10:13:27" , 
"departure_time" : "10:14:36" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "10:18:09" , 
"departure_time" : "10:19:02" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "10:33:53" , 
"departure_time" : "10:35:32" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "10:40:39" , 
"departure_time" : "10:40:49" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "10:49:10" , 
"departure_time" : "10:49:10" , 
"distance_traveled" : 57.9102
} ], 
"2779" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:12:00" , 
"departure_time" : "19:13:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:23:18" , 
"departure_time" : "19:23:24" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:31:06" , 
"departure_time" : "19:32:42" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:38:36" , 
"departure_time" : "19:39:35" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 103,
"arrival_time" : "19:59:59" , 
"departure_time" : "20:01:14" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "20:05:15" , 
"departure_time" : "20:05:19" , 
"distance_traveled" : 34.3589
}, 
{ 
"stop_id" : 125,
"arrival_time" : "20:17:04" , 
"departure_time" : "20:18:33" , 
"distance_traveled" : 48.286
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "20:25:29" , 
"departure_time" : "20:26:02" , 
"distance_traveled" : 54.2568
}, 
{ 
"stop_id" : 148,
"arrival_time" : "20:35:33" , 
"departure_time" : "20:35:33" , 
"distance_traveled" : 57.9106
} ], 
"2780" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "10:01:00" , 
"departure_time" : "10:03:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:12:28" , 
"departure_time" : "10:13:45" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:22:17" , 
"departure_time" : "10:22:38" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:27:21" , 
"departure_time" : "10:27:36" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "10:31:15" , 
"departure_time" : "10:31:51" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "10:38:36" , 
"departure_time" : "10:39:06" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "10:42:30" , 
"departure_time" : "10:44:00" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "10:48:30" , 
"departure_time" : "10:49:42" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "10:53:12" , 
"departure_time" : "10:53:20" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "10:56:08" , 
"departure_time" : "10:57:38" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "11:01:30" , 
"departure_time" : "11:01:57" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "11:15:27" , 
"departure_time" : "11:16:20" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "11:22:53" , 
"departure_time" : "11:24:27" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "11:30:34" , 
"departure_time" : "11:30:34" , 
"distance_traveled" : 57.9102
} ], 
"2781" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:30:00" , 
"departure_time" : "15:32:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:40:29" , 
"departure_time" : "15:40:43" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:49:14" , 
"departure_time" : "15:50:05" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 83,
"arrival_time" : "16:06:51" , 
"departure_time" : "16:07:16" , 
"distance_traveled" : 24.5038
}, 
{ 
"stop_id" : 84,
"arrival_time" : "16:10:25" , 
"departure_time" : "16:11:50" , 
"distance_traveled" : 27.0947
}, 
{ 
"stop_id" : 38,
"arrival_time" : "16:16:25" , 
"departure_time" : "16:17:08" , 
"distance_traveled" : 30.1831
}, 
{ 
"stop_id" : 103,
"arrival_time" : "16:20:43" , 
"departure_time" : "16:21:50" , 
"distance_traveled" : 32.55
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "16:25:07" , 
"departure_time" : "16:25:57" , 
"distance_traveled" : 34.3593
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:37:50" , 
"departure_time" : "16:38:14" , 
"distance_traveled" : 48.2864
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "16:44:24" , 
"departure_time" : "16:45:50" , 
"distance_traveled" : 54.2572
}, 
{ 
"stop_id" : 148,
"arrival_time" : "16:55:26" , 
"departure_time" : "16:55:26" , 
"distance_traveled" : 57.911
} ], 
"2782" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "10:33:00" , 
"departure_time" : "10:34:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:43:15" , 
"departure_time" : "10:44:23" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:54:08" , 
"departure_time" : "10:54:45" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:59:37" , 
"departure_time" : "10:59:48" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "11:04:11" , 
"departure_time" : "11:05:45" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "11:11:34" , 
"departure_time" : "11:11:52" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "11:14:18" , 
"departure_time" : "11:14:35" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "11:20:17" , 
"departure_time" : "11:21:49" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "11:26:32" , 
"departure_time" : "11:27:23" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "11:30:51" , 
"departure_time" : "11:31:05" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "11:34:14" , 
"departure_time" : "11:35:14" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "11:39:00" , 
"departure_time" : "11:40:40" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "11:52:40" , 
"departure_time" : "11:53:42" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "11:58:02" , 
"departure_time" : "11:59:01" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "12:14:59" , 
"departure_time" : "12:14:59" , 
"distance_traveled" : 57.9104
} ], 
"2783" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:07:00" , 
"departure_time" : "15:09:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:17:03" , 
"departure_time" : "15:18:20" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:27:17" , 
"departure_time" : "15:27:37" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "15:32:20" , 
"departure_time" : "15:33:11" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "15:37:51" , 
"departure_time" : "15:39:04" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "15:45:13" , 
"departure_time" : "15:46:22" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "15:49:09" , 
"departure_time" : "15:49:52" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "15:53:43" , 
"departure_time" : "15:54:39" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "15:58:56" , 
"departure_time" : "16:00:25" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "16:04:29" , 
"departure_time" : "16:05:45" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "16:08:16" , 
"departure_time" : "16:09:07" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "16:15:51" , 
"departure_time" : "16:15:51" , 
"distance_traveled" : 34.3587
} ], 
"2784" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "11:37:00" , 
"departure_time" : "11:38:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:46:43" , 
"departure_time" : "11:47:15" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:55:32" , 
"departure_time" : "11:56:14" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "12:01:42" , 
"departure_time" : "12:01:57" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "12:06:15" , 
"departure_time" : "12:06:44" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "12:12:29" , 
"departure_time" : "12:13:41" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "12:17:12" , 
"departure_time" : "12:18:32" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "12:23:20" , 
"departure_time" : "12:24:01" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "12:27:41" , 
"departure_time" : "12:29:21" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "12:33:40" , 
"departure_time" : "12:33:45" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "12:36:05" , 
"departure_time" : "12:37:18" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "12:41:13" , 
"departure_time" : "12:42:49" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "12:55:36" , 
"departure_time" : "12:56:13" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "13:01:37" , 
"departure_time" : "13:02:33" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "13:13:56" , 
"departure_time" : "13:13:56" , 
"distance_traveled" : 57.9104
} ], 
"2785" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:14:00" , 
"departure_time" : "18:15:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:30:15" , 
"departure_time" : "18:31:44" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:37:29" , 
"departure_time" : "18:38:58" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:48:29" , 
"departure_time" : "18:49:51" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "18:54:22" , 
"departure_time" : "18:55:45" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "18:59:23" , 
"departure_time" : "18:59:57" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "19:04:34" , 
"departure_time" : "19:05:36" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "19:09:02" , 
"departure_time" : "19:09:31" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "19:13:29" , 
"departure_time" : "19:15:00" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:26:31" , 
"departure_time" : "19:27:09" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "19:32:38" , 
"departure_time" : "19:33:56" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "19:45:18" , 
"departure_time" : "19:45:18" , 
"distance_traveled" : 57.9104
} ], 
"2786" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "12:37:00" , 
"departure_time" : "12:39:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:47:30" , 
"departure_time" : "12:48:36" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:56:06" , 
"departure_time" : "12:56:24" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:01:18" , 
"departure_time" : "13:01:56" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "13:06:38" , 
"departure_time" : "13:06:52" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "13:12:14" , 
"departure_time" : "13:12:19" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "13:16:05" , 
"departure_time" : "13:16:26" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "13:22:21" , 
"departure_time" : "13:23:14" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "13:26:53" , 
"departure_time" : "13:27:51" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "13:31:58" , 
"departure_time" : "13:33:04" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "13:37:06" , 
"departure_time" : "13:37:46" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "13:40:40" , 
"departure_time" : "13:41:53" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:54:13" , 
"departure_time" : "13:55:33" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "14:01:20" , 
"departure_time" : "14:02:38" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "14:13:18" , 
"departure_time" : "14:13:18" , 
"distance_traveled" : 57.9104
} ], 
"2787" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:37:00" , 
"departure_time" : "20:39:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:47:55" , 
"departure_time" : "20:49:05" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:57:10" , 
"departure_time" : "20:58:27" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "21:02:17" , 
"departure_time" : "21:03:42" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "21:16:25" , 
"departure_time" : "21:17:00" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "21:20:35" , 
"departure_time" : "21:20:38" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "21:25:03" , 
"departure_time" : "21:25:14" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "21:30:11" , 
"departure_time" : "21:31:40" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "21:35:29" , 
"departure_time" : "21:35:35" , 
"distance_traveled" : 34.3589
}, 
{ 
"stop_id" : 125,
"arrival_time" : "21:47:06" , 
"departure_time" : "21:47:50" , 
"distance_traveled" : 48.286
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "21:55:44" , 
"departure_time" : "21:56:08" , 
"distance_traveled" : 54.2568
}, 
{ 
"stop_id" : 148,
"arrival_time" : "22:07:24" , 
"departure_time" : "22:07:24" , 
"distance_traveled" : 57.9106
} ], 
"2788" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "13:05:00" , 
"departure_time" : "13:06:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:14:40" , 
"departure_time" : "13:15:09" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:23:29" , 
"departure_time" : "13:23:55" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:29:26" , 
"departure_time" : "13:30:27" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "13:35:01" , 
"departure_time" : "13:36:22" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "13:41:21" , 
"departure_time" : "13:42:43" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "13:45:22" , 
"departure_time" : "13:45:39" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "13:50:17" , 
"departure_time" : "13:51:11" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "13:54:54" , 
"departure_time" : "13:55:26" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "13:59:32" , 
"departure_time" : "13:59:48" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "14:03:16" , 
"departure_time" : "14:04:09" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "14:07:53" , 
"departure_time" : "14:09:16" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "14:21:23" , 
"departure_time" : "14:22:27" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "14:28:04" , 
"departure_time" : "14:29:20" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "14:40:16" , 
"departure_time" : "14:40:16" , 
"distance_traveled" : 57.9104
} ], 
"2789" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "14:29:00" , 
"departure_time" : "14:30:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:38:39" , 
"departure_time" : "14:38:43" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:48:04" , 
"departure_time" : "14:48:30" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "14:54:26" , 
"departure_time" : "14:55:54" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "14:58:28" , 
"departure_time" : "14:59:18" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "15:00:50" , 
"departure_time" : "15:01:29" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "15:07:39" , 
"departure_time" : "15:07:45" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "15:11:06" , 
"departure_time" : "15:11:40" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "15:16:34" , 
"departure_time" : "15:18:06" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "15:22:32" , 
"departure_time" : "15:23:24" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "15:26:52" , 
"departure_time" : "15:27:02" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "15:30:10" , 
"departure_time" : "15:30:42" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "15:38:32" , 
"departure_time" : "15:38:32" , 
"distance_traveled" : 34.3587
} ], 
"2790" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "14:07:00" , 
"departure_time" : "14:08:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:16:50" , 
"departure_time" : "14:17:40" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:25:50" , 
"departure_time" : "14:26:50" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "14:32:00" , 
"departure_time" : "14:33:11" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "14:37:11" , 
"departure_time" : "14:38:03" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "14:43:52" , 
"departure_time" : "14:45:17" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "14:48:25" , 
"departure_time" : "14:48:32" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "14:52:07" , 
"departure_time" : "14:52:20" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "14:57:13" , 
"departure_time" : "14:58:53" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "15:03:40" , 
"departure_time" : "15:05:03" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "15:07:23" , 
"departure_time" : "15:08:38" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "15:11:15" , 
"departure_time" : "15:12:14" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:23:59" , 
"departure_time" : "15:24:03" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "15:30:04" , 
"departure_time" : "15:30:59" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "15:44:55" , 
"departure_time" : "15:44:55" , 
"distance_traveled" : 57.9104
} ], 
"2791" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "21:54:00" , 
"departure_time" : "21:56:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:05:18" , 
"departure_time" : "22:05:42" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:13:24" , 
"departure_time" : "22:14:38" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:20:14" , 
"departure_time" : "22:21:11" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "22:22:57" , 
"departure_time" : "22:22:59" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "22:26:02" , 
"departure_time" : "22:26:39" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "22:32:37" , 
"departure_time" : "22:33:02" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "22:36:25" , 
"departure_time" : "22:37:07" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "22:43:42" , 
"departure_time" : "22:45:17" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "22:48:35" , 
"departure_time" : "22:49:16" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "22:52:41" , 
"departure_time" : "22:54:21" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "22:58:40" , 
"departure_time" : "22:59:58" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "23:07:18" , 
"departure_time" : "23:07:18" , 
"distance_traveled" : 34.3587
} ], 
"2792" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "13:34:00" , 
"departure_time" : "13:36:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:44:30" , 
"departure_time" : "13:45:12" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:52:42" , 
"departure_time" : "13:52:43" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:58:01" , 
"departure_time" : "13:58:06" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "14:01:05" , 
"departure_time" : "14:02:45" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "14:06:40" , 
"departure_time" : "14:07:36" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "14:11:56" , 
"departure_time" : "14:13:36" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "14:16:40" , 
"departure_time" : "14:17:01" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "14:21:21" , 
"departure_time" : "14:21:30" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "14:25:09" , 
"departure_time" : "14:26:20" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "14:31:11" , 
"departure_time" : "14:32:13" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "14:36:02" , 
"departure_time" : "14:36:17" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "14:38:15" , 
"departure_time" : "14:39:46" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "14:52:31" , 
"departure_time" : "14:53:14" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "14:58:43" , 
"departure_time" : "14:59:24" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "15:13:41" , 
"departure_time" : "15:13:41" , 
"distance_traveled" : 57.9104
} ], 
"2793" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "07:56:00" , 
"departure_time" : "07:58:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:06:29" , 
"departure_time" : "08:07:01" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:13:32" , 
"departure_time" : "08:13:53" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:19:21" , 
"departure_time" : "08:20:13" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:30:52" , 
"departure_time" : "08:32:22" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "08:38:30" , 
"departure_time" : "08:39:33" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "08:43:03" , 
"departure_time" : "08:44:18" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "08:48:15" , 
"departure_time" : "08:49:20" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "08:52:05" , 
"departure_time" : "08:53:05" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "08:57:00" , 
"departure_time" : "08:57:16" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "09:09:16" , 
"departure_time" : "09:10:06" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "09:15:50" , 
"departure_time" : "09:16:03" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "09:27:13" , 
"departure_time" : "09:27:13" , 
"distance_traveled" : 57.9104
} ], 
"2794" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:47:00" , 
"departure_time" : "18:48:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:57:05" , 
"departure_time" : "18:58:09" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:06:04" , 
"departure_time" : "19:06:06" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:11:02" , 
"departure_time" : "19:11:03" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "19:14:01" , 
"departure_time" : "19:14:31" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "19:18:30" , 
"departure_time" : "19:19:35" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "19:25:05" , 
"departure_time" : "19:26:38" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "19:29:33" , 
"departure_time" : "19:30:43" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "19:35:10" , 
"departure_time" : "19:36:35" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "19:40:25" , 
"departure_time" : "19:40:55" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "19:44:30" , 
"departure_time" : "19:45:26" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "19:49:56" , 
"departure_time" : "19:50:51" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "19:53:55" , 
"departure_time" : "19:55:14" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "20:07:19" , 
"departure_time" : "20:07:50" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "20:13:31" , 
"departure_time" : "20:14:30" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "20:25:59" , 
"departure_time" : "20:25:59" , 
"distance_traveled" : 57.9104
} ], 
"2795" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "08:41:00" , 
"departure_time" : "08:42:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:50:01" , 
"departure_time" : "08:51:38" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:00:37" , 
"departure_time" : "09:01:18" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:05:41" , 
"departure_time" : "09:07:00" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 127,
"arrival_time" : "09:17:19" , 
"departure_time" : "09:18:06" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "09:21:47" , 
"departure_time" : "09:22:08" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "09:26:21" , 
"departure_time" : "09:26:46" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "09:31:25" , 
"departure_time" : "09:31:53" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "09:36:28" , 
"departure_time" : "09:36:53" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "09:56:25" , 
"departure_time" : "09:57:17" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "10:03:52" , 
"departure_time" : "10:04:21" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "10:11:29" , 
"departure_time" : "10:11:29" , 
"distance_traveled" : 57.9102
} ], 
"2796" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "04:15:00" , 
"departure_time" : "04:16:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "04:25:14" , 
"departure_time" : "04:26:50" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "04:36:36" , 
"departure_time" : "04:38:07" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "04:42:31" , 
"departure_time" : "04:44:11" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "04:45:40" , 
"departure_time" : "04:46:55" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "04:48:15" , 
"departure_time" : "04:48:35" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "04:53:20" , 
"departure_time" : "04:54:12" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "04:57:52" , 
"departure_time" : "04:58:20" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "05:03:28" , 
"departure_time" : "05:05:03" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "05:09:35" , 
"departure_time" : "05:09:52" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "05:13:17" , 
"departure_time" : "05:14:14" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "05:17:57" , 
"departure_time" : "05:18:02" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "05:33:05" , 
"departure_time" : "05:34:19" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "05:42:14" , 
"departure_time" : "05:43:16" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "05:55:02" , 
"departure_time" : "05:55:02" , 
"distance_traveled" : 57.9102
} ], 
"2797" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:50:00" , 
"departure_time" : "17:51:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:00:12" , 
"departure_time" : "18:01:06" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:10:54" , 
"departure_time" : "18:11:50" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:24:56" , 
"departure_time" : "18:26:02" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "18:31:06" , 
"departure_time" : "18:32:44" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "18:36:38" , 
"departure_time" : "18:36:55" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "18:40:17" , 
"departure_time" : "18:41:28" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "18:46:11" , 
"departure_time" : "18:46:23" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "18:49:12" , 
"departure_time" : "18:49:51" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:03:39" , 
"departure_time" : "19:04:44" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "19:11:05" , 
"departure_time" : "19:11:37" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "19:25:32" , 
"departure_time" : "19:25:32" , 
"distance_traveled" : 57.9104
} ], 
"2798" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "06:36:00" , 
"departure_time" : "06:37:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:45:51" , 
"departure_time" : "06:47:10" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:54:19" , 
"departure_time" : "06:54:52" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "06:59:33" , 
"departure_time" : "06:59:59" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "07:02:26" , 
"departure_time" : "07:03:52" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "07:06:26" , 
"departure_time" : "07:07:59" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "07:12:33" , 
"departure_time" : "07:12:56" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "07:15:23" , 
"departure_time" : "07:15:45" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "07:21:22" , 
"departure_time" : "07:21:47" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "07:26:25" , 
"departure_time" : "07:27:24" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "07:31:59" , 
"departure_time" : "07:33:00" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "07:37:01" , 
"departure_time" : "07:37:10" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "07:50:09" , 
"departure_time" : "07:51:47" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "07:57:38" , 
"departure_time" : "07:58:18" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "08:12:40" , 
"departure_time" : "08:12:40" , 
"distance_traveled" : 57.9102
} ], 
"2799" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:42:00" , 
"departure_time" : "15:43:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:58:50" , 
"departure_time" : "16:00:17" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:05:27" , 
"departure_time" : "16:06:59" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "16:10:32" , 
"departure_time" : "16:11:12" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "16:16:40" , 
"departure_time" : "16:17:03" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "16:20:23" , 
"departure_time" : "16:21:11" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "16:26:48" , 
"departure_time" : "16:27:13" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "16:31:25" , 
"departure_time" : "16:32:41" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "16:37:16" , 
"departure_time" : "16:37:19" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "16:41:03" , 
"departure_time" : "16:41:21" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:56:18" , 
"departure_time" : "16:56:44" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "17:03:26" , 
"departure_time" : "17:04:43" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "17:13:17" , 
"departure_time" : "17:13:17" , 
"distance_traveled" : 57.9102
} ], 
"2800" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "08:12:00" , 
"departure_time" : "08:13:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:21:18" , 
"departure_time" : "08:21:59" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:30:41" , 
"departure_time" : "08:30:54" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:36:13" , 
"departure_time" : "08:36:51" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "08:39:38" , 
"departure_time" : "08:41:12" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "08:43:34" , 
"departure_time" : "08:45:07" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "08:50:33" , 
"departure_time" : "08:52:12" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:54:39" , 
"departure_time" : "08:54:49" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "09:00:10" , 
"departure_time" : "09:01:11" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "09:05:01" , 
"departure_time" : "09:06:26" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "09:10:25" , 
"departure_time" : "09:11:27" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "09:14:02" , 
"departure_time" : "09:15:25" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "09:30:23" , 
"departure_time" : "09:30:58" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "09:35:35" , 
"departure_time" : "09:36:41" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "09:48:06" , 
"departure_time" : "09:48:06" , 
"distance_traveled" : 57.9102
} ], 
"2801" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:25:00" , 
"departure_time" : "17:26:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:35:09" , 
"departure_time" : "17:35:39" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:46:30" , 
"departure_time" : "17:47:40" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:52:10" , 
"departure_time" : "17:52:15" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:01:05" , 
"departure_time" : "18:02:23" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "18:09:18" , 
"departure_time" : "18:09:54" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "18:13:36" , 
"departure_time" : "18:14:12" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "18:19:36" , 
"departure_time" : "18:20:26" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "18:24:50" , 
"departure_time" : "18:25:03" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "18:27:13" , 
"departure_time" : "18:28:41" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:43:28" , 
"departure_time" : "18:44:37" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "18:51:09" , 
"departure_time" : "18:51:11" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "19:00:02" , 
"departure_time" : "19:00:02" , 
"distance_traveled" : 57.9104
} ], 
"2802" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "08:28:00" , 
"departure_time" : "08:29:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:38:30" , 
"departure_time" : "08:39:30" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:47:00" , 
"departure_time" : "08:47:13" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:52:13" , 
"departure_time" : "08:52:43" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "08:55:30" , 
"departure_time" : "08:56:07" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "08:58:37" , 
"departure_time" : "08:59:41" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "09:05:04" , 
"departure_time" : "09:06:34" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "09:09:30" , 
"departure_time" : "09:10:38" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "09:15:08" , 
"departure_time" : "09:15:23" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "09:18:15" , 
"departure_time" : "09:18:21" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "09:23:06" , 
"departure_time" : "09:23:29" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "09:27:23" , 
"departure_time" : "09:28:32" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "09:42:09" , 
"departure_time" : "09:43:47" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "09:49:38" , 
"departure_time" : "09:50:52" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "10:04:14" , 
"departure_time" : "10:04:14" , 
"distance_traveled" : 57.9102
} ], 
"2803" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "21:06:00" , 
"departure_time" : "21:07:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:15:22" , 
"departure_time" : "21:16:03" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:24:41" , 
"departure_time" : "21:25:56" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "21:31:15" , 
"departure_time" : "21:31:37" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 127,
"arrival_time" : "21:40:22" , 
"departure_time" : "21:41:55" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "21:48:33" , 
"departure_time" : "21:49:35" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "21:52:02" , 
"departure_time" : "21:53:28" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "21:57:26" , 
"departure_time" : "21:57:52" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "22:00:26" , 
"departure_time" : "22:01:51" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "22:06:25" , 
"departure_time" : "22:07:39" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "22:18:14" , 
"departure_time" : "22:18:25" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "22:24:11" , 
"departure_time" : "22:25:25" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "22:35:14" , 
"departure_time" : "22:35:14" , 
"distance_traveled" : 57.9104
} ], 
"2804" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "11:06:00" , 
"departure_time" : "11:07:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:16:37" , 
"departure_time" : "11:17:51" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:25:14" , 
"departure_time" : "11:25:56" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "11:30:42" , 
"departure_time" : "11:32:19" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "11:34:37" , 
"departure_time" : "11:34:47" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "11:36:10" , 
"departure_time" : "11:37:26" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "11:43:16" , 
"departure_time" : "11:43:20" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "11:46:04" , 
"departure_time" : "11:46:59" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "11:52:55" , 
"departure_time" : "11:52:57" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "11:56:02" , 
"departure_time" : "11:56:04" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "12:01:02" , 
"departure_time" : "12:01:54" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "12:05:52" , 
"departure_time" : "12:07:18" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "12:21:26" , 
"departure_time" : "12:23:04" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "12:28:38" , 
"departure_time" : "12:29:03" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "12:39:25" , 
"departure_time" : "12:39:25" , 
"distance_traveled" : 57.9102
} ], 
"2805" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "21:35:00" , 
"departure_time" : "21:36:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:45:28" , 
"departure_time" : "21:47:02" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:56:34" , 
"departure_time" : "21:56:53" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:00:19" , 
"departure_time" : "22:00:40" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 127,
"arrival_time" : "22:10:21" , 
"departure_time" : "22:10:55" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "22:16:34" , 
"departure_time" : "22:17:12" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "22:20:38" , 
"departure_time" : "22:20:52" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "22:25:14" , 
"departure_time" : "22:26:47" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "22:31:33" , 
"departure_time" : "22:33:10" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "22:35:37" , 
"departure_time" : "22:36:34" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "22:47:57" , 
"departure_time" : "22:49:37" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "22:55:40" , 
"departure_time" : "22:55:58" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "23:06:18" , 
"departure_time" : "23:06:18" , 
"distance_traveled" : 57.9104
} ], 
"2806" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:33:00" , 
"departure_time" : "16:34:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:44:06" , 
"departure_time" : "16:44:29" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:52:23" , 
"departure_time" : "16:52:46" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:58:23" , 
"departure_time" : "16:58:53" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "17:02:30" , 
"departure_time" : "17:03:21" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "17:05:51" , 
"departure_time" : "17:07:29" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "17:12:38" , 
"departure_time" : "17:14:13" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "17:16:35" , 
"departure_time" : "17:18:13" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "17:22:38" , 
"departure_time" : "17:23:01" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "17:25:23" , 
"departure_time" : "17:25:51" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "17:30:28" , 
"departure_time" : "17:31:36" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "17:35:08" , 
"departure_time" : "17:36:22" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:50:14" , 
"departure_time" : "17:51:18" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "17:57:04" , 
"departure_time" : "17:58:07" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "18:08:03" , 
"departure_time" : "18:08:03" , 
"distance_traveled" : 57.9102
} ], 
"2807" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "22:11:00" , 
"departure_time" : "22:12:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:20:24" , 
"departure_time" : "22:20:55" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:30:31" , 
"departure_time" : "22:30:39" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:36:08" , 
"departure_time" : "22:37:48" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 127,
"arrival_time" : "22:47:40" , 
"departure_time" : "22:48:05" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "22:52:25" , 
"departure_time" : "22:52:54" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "22:56:29" , 
"departure_time" : "22:57:33" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "23:02:04" , 
"departure_time" : "23:03:10" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "23:06:06" , 
"departure_time" : "23:06:32" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "23:10:26" , 
"departure_time" : "23:12:05" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "23:24:39" , 
"departure_time" : "23:26:03" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "23:31:24" , 
"departure_time" : "23:31:44" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "23:42:20" , 
"departure_time" : "23:42:20" , 
"distance_traveled" : 57.9104
} ], 
"2808" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:43:00" , 
"departure_time" : "19:44:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:53:32" , 
"departure_time" : "19:53:52" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:02:20" , 
"departure_time" : "20:03:54" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:09:34" , 
"departure_time" : "20:10:24" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "20:12:50" , 
"departure_time" : "20:14:23" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "20:16:33" , 
"departure_time" : "20:16:34" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "20:21:01" , 
"departure_time" : "20:22:40" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:26:39" , 
"departure_time" : "20:27:49" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "20:32:10" , 
"departure_time" : "20:32:30" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "20:35:20" , 
"departure_time" : "20:36:38" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "20:41:18" , 
"departure_time" : "20:41:23" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "20:44:05" , 
"departure_time" : "20:45:06" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "21:00:01" , 
"departure_time" : "21:00:56" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "21:05:55" , 
"departure_time" : "21:06:19" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "21:16:24" , 
"departure_time" : "21:16:24" , 
"distance_traveled" : 57.9102
} ], 
"2809" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "22:38:00" , 
"departure_time" : "22:39:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:47:50" , 
"departure_time" : "22:48:41" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:56:51" , 
"departure_time" : "22:58:27" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "23:03:36" , 
"departure_time" : "23:04:55" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 127,
"arrival_time" : "23:13:19" , 
"departure_time" : "23:14:41" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "23:18:22" , 
"departure_time" : "23:19:44" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "23:23:22" , 
"departure_time" : "23:24:48" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "23:28:26" , 
"departure_time" : "23:29:03" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "23:31:37" , 
"departure_time" : "23:31:50" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "23:36:13" , 
"departure_time" : "23:37:45" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "23:50:32" , 
"departure_time" : "23:51:30" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "23:56:58" , 
"departure_time" : "23:57:21" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "24:07:23" , 
"departure_time" : "24:07:23" , 
"distance_traveled" : 57.9104
} ], 
"2810" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "25:22:00" , 
"departure_time" : "25:23:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "25:32:05" , 
"departure_time" : "25:33:17" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "25:41:12" , 
"departure_time" : "25:42:00" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "25:46:48" , 
"departure_time" : "25:47:53" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "25:51:05" , 
"departure_time" : "25:51:08" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "25:53:03" , 
"departure_time" : "25:53:55" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "25:59:52" , 
"departure_time" : "26:00:08" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "26:03:16" , 
"departure_time" : "26:03:21" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "26:10:05" , 
"departure_time" : "26:11:42" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "26:15:37" , 
"departure_time" : "26:16:24" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "26:19:47" , 
"departure_time" : "26:21:22" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "26:24:35" , 
"departure_time" : "26:24:52" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "26:28:17" , 
"departure_time" : "26:28:27" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "26:41:10" , 
"departure_time" : "26:41:12" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "26:47:02" , 
"departure_time" : "26:48:08" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "27:07:06" , 
"departure_time" : "27:07:06" , 
"distance_traveled" : 57.9104
} ], 
"2811" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "06:11:00" , 
"departure_time" : "06:12:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:20:06" , 
"departure_time" : "06:21:37" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:29:31" , 
"departure_time" : "06:30:21" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "06:33:50" , 
"departure_time" : "06:35:05" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "06:39:15" , 
"departure_time" : "06:40:13" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "06:45:58" , 
"departure_time" : "06:46:35" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "06:49:37" , 
"departure_time" : "06:49:41" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "06:54:04" , 
"departure_time" : "06:55:44" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "07:00:40" , 
"departure_time" : "07:02:11" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "07:05:31" , 
"departure_time" : "07:06:09" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "07:08:38" , 
"departure_time" : "07:08:49" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "07:23:11" , 
"departure_time" : "07:24:12" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "07:31:01" , 
"departure_time" : "07:32:28" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "07:41:27" , 
"departure_time" : "07:41:27" , 
"distance_traveled" : 57.9102
} ], 
"2812" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "05:07:00" , 
"departure_time" : "05:09:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:16:38" , 
"departure_time" : "05:18:15" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "05:26:37" , 
"departure_time" : "05:27:46" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "05:32:09" , 
"departure_time" : "05:32:22" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "05:34:13" , 
"departure_time" : "05:35:40" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "05:38:27" , 
"departure_time" : "05:40:03" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "05:45:36" , 
"departure_time" : "05:46:54" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "05:49:18" , 
"departure_time" : "05:50:41" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "05:54:23" , 
"departure_time" : "05:54:53" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "05:58:30" , 
"departure_time" : "05:59:50" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "06:04:20" , 
"departure_time" : "06:05:49" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "06:08:29" , 
"departure_time" : "06:10:09" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "06:13:40" , 
"departure_time" : "06:14:58" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "06:26:18" , 
"departure_time" : "06:27:47" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "06:32:29" , 
"departure_time" : "06:33:31" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "06:44:02" , 
"departure_time" : "06:44:02" , 
"distance_traveled" : 57.9104
} ], 
"2813" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "07:14:00" , 
"departure_time" : "07:16:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:24:11" , 
"departure_time" : "07:24:14" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:31:03" , 
"departure_time" : "07:31:21" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "07:37:18" , 
"departure_time" : "07:38:45" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "07:44:27" , 
"departure_time" : "07:45:00" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "07:48:33" , 
"departure_time" : "07:48:47" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "07:52:14" , 
"departure_time" : "07:52:16" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "07:58:02" , 
"departure_time" : "07:58:24" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "08:03:22" , 
"departure_time" : "08:04:16" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "08:08:54" , 
"departure_time" : "08:10:27" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "08:13:33" , 
"departure_time" : "08:14:05" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "08:26:32" , 
"departure_time" : "08:27:54" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "08:34:22" , 
"departure_time" : "08:34:40" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "08:45:18" , 
"departure_time" : "08:45:18" , 
"distance_traveled" : 57.9102
} ], 
"2814" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "09:37:00" , 
"departure_time" : "09:37:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:46:17" , 
"departure_time" : "09:47:28" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:56:11" , 
"departure_time" : "09:56:46" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:01:35" , 
"departure_time" : "10:03:10" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "10:05:35" , 
"departure_time" : "10:06:04" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "10:07:29" , 
"departure_time" : "10:08:04" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "10:14:35" , 
"departure_time" : "10:15:38" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "10:19:03" , 
"departure_time" : "10:20:03" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "10:25:00" , 
"departure_time" : "10:25:36" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "10:28:36" , 
"departure_time" : "10:30:11" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "10:34:35" , 
"departure_time" : "10:35:05" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "10:37:30" , 
"departure_time" : "10:38:40" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "10:43:10" , 
"departure_time" : "10:43:56" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "10:55:46" , 
"departure_time" : "10:57:26" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "11:03:40" , 
"departure_time" : "11:04:39" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "11:14:59" , 
"departure_time" : "11:14:59" , 
"distance_traveled" : 57.9104
} ], 
"2815" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "09:19:00" , 
"departure_time" : "09:21:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:29:39" , 
"departure_time" : "09:31:01" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:38:22" , 
"departure_time" : "09:39:53" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:44:31" , 
"departure_time" : "09:46:10" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "09:48:39" , 
"departure_time" : "09:49:49" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "09:55:10" , 
"departure_time" : "09:56:40" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "09:59:30" , 
"departure_time" : "10:01:09" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "10:05:39" , 
"departure_time" : "10:06:22" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "10:08:43" , 
"departure_time" : "10:09:37" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "10:13:54" , 
"departure_time" : "10:14:50" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "10:17:56" , 
"departure_time" : "10:18:16" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "10:33:20" , 
"departure_time" : "10:34:46" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "10:40:26" , 
"departure_time" : "10:41:44" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "10:50:18" , 
"departure_time" : "10:50:18" , 
"distance_traveled" : 57.9102
} ], 
"2816" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "12:01:00" , 
"departure_time" : "12:02:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:10:06" , 
"departure_time" : "12:10:46" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:19:40" , 
"departure_time" : "12:20:57" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "12:26:17" , 
"departure_time" : "12:26:54" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "12:28:37" , 
"departure_time" : "12:29:03" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "12:31:26" , 
"departure_time" : "12:32:02" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "12:38:36" , 
"departure_time" : "12:39:09" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "12:42:33" , 
"departure_time" : "12:43:45" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "12:48:12" , 
"departure_time" : "12:48:14" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "12:52:02" , 
"departure_time" : "12:52:12" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "12:56:10" , 
"departure_time" : "12:56:58" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "13:00:48" , 
"departure_time" : "13:01:33" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "13:05:45" , 
"departure_time" : "13:06:40" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:18:55" , 
"departure_time" : "13:19:36" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "13:24:41" , 
"departure_time" : "13:26:10" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "13:36:29" , 
"departure_time" : "13:36:29" , 
"distance_traveled" : 57.9104
} ], 
"2817" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "10:01:00" , 
"departure_time" : "10:03:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:12:27" , 
"departure_time" : "10:13:40" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:22:13" , 
"departure_time" : "10:23:24" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:28:11" , 
"departure_time" : "10:28:17" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "10:31:06" , 
"departure_time" : "10:31:24" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "10:38:18" , 
"departure_time" : "10:38:54" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "10:42:36" , 
"departure_time" : "10:43:43" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "10:48:07" , 
"departure_time" : "10:48:12" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "10:52:05" , 
"departure_time" : "10:52:34" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "10:56:29" , 
"departure_time" : "10:57:59" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "11:01:30" , 
"departure_time" : "11:01:35" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "11:15:05" , 
"departure_time" : "11:15:49" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "11:22:44" , 
"departure_time" : "11:23:31" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "11:29:47" , 
"departure_time" : "11:29:47" , 
"distance_traveled" : 57.9102
} ], 
"2818" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:07:00" , 
"departure_time" : "20:09:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:18:22" , 
"departure_time" : "20:19:14" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:26:52" , 
"departure_time" : "20:28:03" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:33:11" , 
"departure_time" : "20:34:03" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "20:35:52" , 
"departure_time" : "20:36:38" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "20:38:46" , 
"departure_time" : "20:39:13" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "20:44:27" , 
"departure_time" : "20:45:53" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:50:26" , 
"departure_time" : "20:50:37" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "20:56:11" , 
"departure_time" : "20:56:38" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "21:01:27" , 
"departure_time" : "21:02:09" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "21:06:42" , 
"departure_time" : "21:07:02" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "21:10:20" , 
"departure_time" : "21:10:31" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "21:15:11" , 
"departure_time" : "21:15:39" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "21:27:28" , 
"departure_time" : "21:28:00" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "21:34:32" , 
"departure_time" : "21:35:35" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "21:47:03" , 
"departure_time" : "21:47:03" , 
"distance_traveled" : 57.9104
} ], 
"2819" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "10:33:00" , 
"departure_time" : "10:34:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:43:17" , 
"departure_time" : "10:44:47" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:54:30" , 
"departure_time" : "10:55:14" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:59:44" , 
"departure_time" : "10:59:48" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "11:04:04" , 
"departure_time" : "11:05:22" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "11:11:18" , 
"departure_time" : "11:12:11" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "11:14:53" , 
"departure_time" : "11:15:45" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "11:20:52" , 
"departure_time" : "11:22:32" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "11:26:40" , 
"departure_time" : "11:27:02" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "11:30:22" , 
"departure_time" : "11:31:16" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "11:34:54" , 
"departure_time" : "11:35:10" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "11:38:16" , 
"departure_time" : "11:38:43" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "11:51:27" , 
"departure_time" : "11:53:04" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "11:58:37" , 
"departure_time" : "12:00:01" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "12:15:24" , 
"departure_time" : "12:15:24" , 
"distance_traveled" : 57.9104
} ], 
"2820" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "23:06:00" , 
"departure_time" : "23:08:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:17:17" , 
"departure_time" : "23:17:23" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "23:24:06" , 
"departure_time" : "23:25:44" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "23:31:38" , 
"departure_time" : "23:32:46" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "23:34:08" , 
"departure_time" : "23:34:29" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "23:36:21" , 
"departure_time" : "23:37:32" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "23:44:11" , 
"departure_time" : "23:45:08" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "23:47:57" , 
"departure_time" : "23:48:29" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "23:53:32" , 
"departure_time" : "23:54:41" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "23:59:09" , 
"departure_time" : "24:00:05" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "24:03:56" , 
"departure_time" : "24:05:35" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "24:09:39" , 
"departure_time" : "24:10:04" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "24:13:25" , 
"departure_time" : "24:14:44" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "24:27:19" , 
"departure_time" : "24:28:30" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "24:34:11" , 
"departure_time" : "24:34:30" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "24:46:19" , 
"departure_time" : "24:46:19" , 
"distance_traveled" : 57.9104
} ], 
"2821" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "11:37:00" , 
"departure_time" : "11:37:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:46:27" , 
"departure_time" : "11:47:53" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:56:26" , 
"departure_time" : "11:57:36" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "12:02:10" , 
"departure_time" : "12:02:16" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "12:06:06" , 
"departure_time" : "12:06:15" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "12:12:09" , 
"departure_time" : "12:13:44" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "12:17:35" , 
"departure_time" : "12:19:00" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "12:23:25" , 
"departure_time" : "12:24:52" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "12:28:27" , 
"departure_time" : "12:29:39" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "12:33:12" , 
"departure_time" : "12:34:01" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "12:36:49" , 
"departure_time" : "12:37:47" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "12:40:58" , 
"departure_time" : "12:41:35" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "12:54:37" , 
"departure_time" : "12:56:09" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "13:02:32" , 
"departure_time" : "13:03:20" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "13:13:48" , 
"departure_time" : "13:13:48" , 
"distance_traveled" : 57.9104
} ], 
"2822" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "06:34:00" , 
"departure_time" : "06:35:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:49:53" , 
"departure_time" : "06:51:01" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 83,
"arrival_time" : "07:08:08" , 
"departure_time" : "07:08:36" , 
"distance_traveled" : 24.5038
}, 
{ 
"stop_id" : 103,
"arrival_time" : "07:16:28" , 
"departure_time" : "07:16:47" , 
"distance_traveled" : 32.5553
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "07:21:19" , 
"departure_time" : "07:21:19" , 
"distance_traveled" : 34.3595
} ], 
"2823" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "12:37:00" , 
"departure_time" : "12:37:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:46:24" , 
"departure_time" : "12:47:09" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:55:45" , 
"departure_time" : "12:57:00" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:02:15" , 
"departure_time" : "13:03:31" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "13:07:16" , 
"departure_time" : "13:08:44" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "13:13:28" , 
"departure_time" : "13:13:58" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "13:16:30" , 
"departure_time" : "13:17:47" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "13:23:17" , 
"departure_time" : "13:23:56" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "13:26:39" , 
"departure_time" : "13:28:05" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "13:32:26" , 
"departure_time" : "13:34:03" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "13:37:37" , 
"departure_time" : "13:38:56" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "13:41:19" , 
"departure_time" : "13:41:29" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:53:10" , 
"departure_time" : "13:53:32" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "14:00:22" , 
"departure_time" : "14:01:48" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "14:13:26" , 
"departure_time" : "14:13:26" , 
"distance_traveled" : 57.9104
} ], 
"2824" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:03:00" , 
"departure_time" : "17:05:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:19:39" , 
"departure_time" : "17:20:51" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:56:12" , 
"departure_time" : "17:56:36" , 
"distance_traveled" : 48.286
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "18:03:24" , 
"departure_time" : "18:04:36" , 
"distance_traveled" : 54.2568
}, 
{ 
"stop_id" : 148,
"arrival_time" : "18:16:12" , 
"departure_time" : "18:16:12" , 
"distance_traveled" : 57.9106
} ], 
"2825" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "13:05:00" , 
"departure_time" : "13:07:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:15:21" , 
"departure_time" : "13:15:54" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:23:33" , 
"departure_time" : "13:24:16" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:29:43" , 
"departure_time" : "13:30:15" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "13:34:32" , 
"departure_time" : "13:35:15" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "13:40:43" , 
"departure_time" : "13:41:48" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "13:45:05" , 
"departure_time" : "13:46:44" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "13:51:39" , 
"departure_time" : "13:53:06" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "13:55:27" , 
"departure_time" : "13:55:53" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "13:59:26" , 
"departure_time" : "14:00:48" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "14:04:22" , 
"departure_time" : "14:05:50" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "14:08:28" , 
"departure_time" : "14:10:03" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "14:21:35" , 
"departure_time" : "14:23:13" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "14:28:38" , 
"departure_time" : "14:28:45" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "14:39:07" , 
"departure_time" : "14:39:07" , 
"distance_traveled" : 57.9104
} ], 
"2826" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:01:00" , 
"departure_time" : "18:01:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:19:37" , 
"departure_time" : "18:20:37" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:53:00" , 
"departure_time" : "18:54:30" , 
"distance_traveled" : 48.286
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "19:02:30" , 
"departure_time" : "19:02:52" , 
"distance_traveled" : 54.2568
}, 
{ 
"stop_id" : 148,
"arrival_time" : "19:13:22" , 
"departure_time" : "19:13:22" , 
"distance_traveled" : 57.9106
} ], 
"2827" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "14:07:00" , 
"departure_time" : "14:07:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:16:02" , 
"departure_time" : "14:17:35" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:26:33" , 
"departure_time" : "14:26:46" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "14:31:13" , 
"departure_time" : "14:31:17" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "14:36:04" , 
"departure_time" : "14:36:23" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "14:43:19" , 
"departure_time" : "14:43:59" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "14:47:40" , 
"departure_time" : "14:48:59" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "14:53:19" , 
"departure_time" : "14:54:22" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "14:58:03" , 
"departure_time" : "14:58:49" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "15:02:46" , 
"departure_time" : "15:04:17" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "15:07:31" , 
"departure_time" : "15:08:13" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "15:10:42" , 
"departure_time" : "15:11:04" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:23:22" , 
"departure_time" : "15:24:19" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "15:30:57" , 
"departure_time" : "15:31:00" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "15:44:03" , 
"departure_time" : "15:44:03" , 
"distance_traveled" : 57.9104
} ], 
"2828" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:49:00" , 
"departure_time" : "19:49:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:05:05" , 
"departure_time" : "20:05:40" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 103,
"arrival_time" : "20:29:35" , 
"departure_time" : "20:29:56" , 
"distance_traveled" : 32.55
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "20:34:21" , 
"departure_time" : "20:35:21" , 
"distance_traveled" : 34.3593
}, 
{ 
"stop_id" : 125,
"arrival_time" : "20:49:00" , 
"departure_time" : "20:49:29" , 
"distance_traveled" : 48.2864
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "20:55:29" , 
"departure_time" : "20:56:56" , 
"distance_traveled" : 54.2572
}, 
{ 
"stop_id" : 148,
"arrival_time" : "21:08:27" , 
"departure_time" : "21:08:27" , 
"distance_traveled" : 57.911
} ], 
"2829" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "13:34:00" , 
"departure_time" : "13:36:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:43:53" , 
"departure_time" : "13:44:29" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:52:36" , 
"departure_time" : "13:53:57" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:59:21" , 
"departure_time" : "14:00:29" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "14:02:08" , 
"departure_time" : "14:02:14" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "14:05:06" , 
"departure_time" : "14:05:34" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "14:11:28" , 
"departure_time" : "14:12:22" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "14:15:54" , 
"departure_time" : "14:16:10" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "14:21:16" , 
"departure_time" : "14:21:24" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "14:25:08" , 
"departure_time" : "14:25:18" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "14:30:10" , 
"departure_time" : "14:30:21" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "14:35:11" , 
"departure_time" : "14:35:44" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "14:38:33" , 
"departure_time" : "14:38:45" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "14:51:12" , 
"departure_time" : "14:52:45" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "14:59:33" , 
"departure_time" : "15:00:52" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "15:14:19" , 
"departure_time" : "15:14:19" , 
"distance_traveled" : 57.9104
} ], 
"2830" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "05:41:00" , 
"departure_time" : "05:43:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:50:47" , 
"departure_time" : "05:51:54" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "05:59:07" , 
"departure_time" : "06:00:26" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "06:05:19" , 
"departure_time" : "06:05:45" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "06:17:26" , 
"departure_time" : "06:18:47" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 103,
"arrival_time" : "06:27:21" , 
"departure_time" : "06:28:51" , 
"distance_traveled" : 32.5549
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "06:34:30" , 
"departure_time" : "06:34:30" , 
"distance_traveled" : 34.3591
} ], 
"2831" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:47:00" , 
"departure_time" : "18:48:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:56:22" , 
"departure_time" : "18:57:01" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:05:39" , 
"departure_time" : "19:07:15" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:12:36" , 
"departure_time" : "19:12:44" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "19:14:08" , 
"departure_time" : "19:15:46" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "19:19:38" , 
"departure_time" : "19:21:10" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "19:25:32" , 
"departure_time" : "19:25:41" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "19:28:09" , 
"departure_time" : "19:29:15" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "19:35:06" , 
"departure_time" : "19:36:05" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "19:39:59" , 
"departure_time" : "19:40:06" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "19:44:07" , 
"departure_time" : "19:45:41" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "19:50:34" , 
"departure_time" : "19:51:57" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "19:54:23" , 
"departure_time" : "19:55:30" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "20:07:07" , 
"departure_time" : "20:08:03" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "20:13:56" , 
"departure_time" : "20:15:12" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "20:26:16" , 
"departure_time" : "20:26:16" , 
"distance_traveled" : 57.9104
} ], 
"2832" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:13:00" , 
"departure_time" : "16:15:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:24:16" , 
"departure_time" : "16:25:55" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:34:39" , 
"departure_time" : "16:35:24" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:09:45" , 
"departure_time" : "17:10:08" , 
"distance_traveled" : 48.286
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "17:18:23" , 
"departure_time" : "17:19:14" , 
"distance_traveled" : 54.2568
}, 
{ 
"stop_id" : 148,
"arrival_time" : "17:26:51" , 
"departure_time" : "17:26:51" , 
"distance_traveled" : 57.9106
} ], 
"2833" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "04:15:00" , 
"departure_time" : "04:16:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "04:24:46" , 
"departure_time" : "04:26:04" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "04:36:18" , 
"departure_time" : "04:36:35" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "04:41:17" , 
"departure_time" : "04:41:51" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "04:44:34" , 
"departure_time" : "04:45:22" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "04:47:48" , 
"departure_time" : "04:47:57" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "04:53:09" , 
"departure_time" : "04:53:22" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "04:57:13" , 
"departure_time" : "04:58:17" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "05:04:04" , 
"departure_time" : "05:04:59" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "05:08:55" , 
"departure_time" : "05:09:52" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "05:13:57" , 
"departure_time" : "05:15:06" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "05:18:09" , 
"departure_time" : "05:18:44" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "05:33:35" , 
"departure_time" : "05:33:58" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "05:41:23" , 
"departure_time" : "05:42:41" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "05:55:18" , 
"departure_time" : "05:55:18" , 
"distance_traveled" : 57.9102
} ], 
"2834" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:41:00" , 
"departure_time" : "16:43:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:51:48" , 
"departure_time" : "16:53:02" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:02:14" , 
"departure_time" : "17:02:38" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:34:24" , 
"departure_time" : "17:35:47" , 
"distance_traveled" : 48.286
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "17:43:23" , 
"departure_time" : "17:44:28" , 
"distance_traveled" : 54.2568
}, 
{ 
"stop_id" : 148,
"arrival_time" : "17:54:05" , 
"departure_time" : "17:54:05" , 
"distance_traveled" : 57.9106
} ], 
"2835" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "06:36:00" , 
"departure_time" : "06:37:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:45:50" , 
"departure_time" : "06:47:20" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:54:30" , 
"departure_time" : "06:55:05" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "06:59:35" , 
"departure_time" : "07:00:59" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "07:03:24" , 
"departure_time" : "07:04:49" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "07:06:25" , 
"departure_time" : "07:07:23" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "07:11:58" , 
"departure_time" : "07:12:41" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "07:15:43" , 
"departure_time" : "07:17:13" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "07:22:30" , 
"departure_time" : "07:23:21" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "07:26:51" , 
"departure_time" : "07:28:18" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "07:32:27" , 
"departure_time" : "07:33:22" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "07:36:55" , 
"departure_time" : "07:38:10" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "07:51:15" , 
"departure_time" : "07:52:29" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "07:57:14" , 
"departure_time" : "07:58:40" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "08:13:26" , 
"departure_time" : "08:13:26" , 
"distance_traveled" : 57.9102
} ], 
"2836" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:43:00" , 
"departure_time" : "17:46:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:54:35" , 
"departure_time" : "17:54:36" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:03:01" , 
"departure_time" : "18:04:33" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:37:32" , 
"departure_time" : "18:38:59" , 
"distance_traveled" : 48.286
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "18:44:27" , 
"departure_time" : "18:45:21" , 
"distance_traveled" : 54.2568
}, 
{ 
"stop_id" : 148,
"arrival_time" : "18:54:54" , 
"departure_time" : "18:54:54" , 
"distance_traveled" : 57.9106
} ], 
"2837" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "08:12:00" , 
"departure_time" : "08:14:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:22:22" , 
"departure_time" : "08:22:53" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:30:31" , 
"departure_time" : "08:31:15" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:36:44" , 
"departure_time" : "08:36:45" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "08:39:01" , 
"departure_time" : "08:40:12" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "08:43:11" , 
"departure_time" : "08:43:55" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "08:49:44" , 
"departure_time" : "08:50:25" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:53:41" , 
"departure_time" : "08:55:10" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "09:01:29" , 
"departure_time" : "09:02:04" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "09:04:35" , 
"departure_time" : "09:05:52" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "09:10:17" , 
"departure_time" : "09:10:38" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "09:13:21" , 
"departure_time" : "09:14:29" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "09:30:08" , 
"departure_time" : "09:30:21" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "09:35:13" , 
"departure_time" : "09:36:09" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "09:47:56" , 
"departure_time" : "09:47:56" , 
"distance_traveled" : 57.9102
} ], 
"2838" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:39:00" , 
"departure_time" : "18:41:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:56:31" , 
"departure_time" : "18:56:53" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 103,
"arrival_time" : "19:18:22" , 
"departure_time" : "19:19:09" , 
"distance_traveled" : 32.55
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "19:23:47" , 
"departure_time" : "19:24:49" , 
"distance_traveled" : 34.3593
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:37:02" , 
"departure_time" : "19:37:58" , 
"distance_traveled" : 48.2864
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "19:44:56" , 
"departure_time" : "19:45:10" , 
"distance_traveled" : 54.2572
}, 
{ 
"stop_id" : 148,
"arrival_time" : "19:55:14" , 
"departure_time" : "19:55:14" , 
"distance_traveled" : 57.911
} ], 
"2839" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "08:28:00" , 
"departure_time" : "08:28:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:37:12" , 
"departure_time" : "08:37:19" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:46:07" , 
"departure_time" : "08:47:46" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:53:39" , 
"departure_time" : "08:54:46" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "08:56:07" , 
"departure_time" : "08:56:31" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "08:58:24" , 
"departure_time" : "08:59:47" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "09:05:23" , 
"departure_time" : "09:05:52" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "09:08:29" , 
"departure_time" : "09:09:38" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "09:15:09" , 
"departure_time" : "09:15:54" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "09:18:45" , 
"departure_time" : "09:20:18" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "09:24:33" , 
"departure_time" : "09:25:59" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "09:28:26" , 
"departure_time" : "09:28:29" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "09:41:03" , 
"departure_time" : "09:42:19" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "09:49:16" , 
"departure_time" : "09:50:06" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "10:03:50" , 
"departure_time" : "10:03:50" , 
"distance_traveled" : 57.9102
} ], 
"2840" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "07:31:00" , 
"departure_time" : "07:33:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:41:24" , 
"departure_time" : "07:41:39" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:48:15" , 
"departure_time" : "07:48:48" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 83,
"arrival_time" : "08:05:33" , 
"departure_time" : "08:06:20" , 
"distance_traveled" : 24.5038
}, 
{ 
"stop_id" : 84,
"arrival_time" : "08:09:47" , 
"departure_time" : "08:10:48" , 
"distance_traveled" : 27.0947
}, 
{ 
"stop_id" : 38,
"arrival_time" : "08:15:01" , 
"departure_time" : "08:16:04" , 
"distance_traveled" : 30.1831
}, 
{ 
"stop_id" : 103,
"arrival_time" : "08:19:03" , 
"departure_time" : "08:19:09" , 
"distance_traveled" : 32.55
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "08:25:06" , 
"departure_time" : "08:25:06" , 
"distance_traveled" : 34.3593
} ], 
"2841" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "11:06:00" , 
"departure_time" : "11:07:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:17:07" , 
"departure_time" : "11:17:55" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:24:48" , 
"departure_time" : "11:26:28" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "11:31:40" , 
"departure_time" : "11:32:10" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "11:33:30" , 
"departure_time" : "11:35:03" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "11:37:33" , 
"departure_time" : "11:38:29" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "11:42:56" , 
"departure_time" : "11:44:30" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "11:47:34" , 
"departure_time" : "11:47:42" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "11:52:08" , 
"departure_time" : "11:53:00" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "11:56:52" , 
"departure_time" : "11:57:39" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "12:01:47" , 
"departure_time" : "12:03:22" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "12:06:35" , 
"departure_time" : "12:07:09" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "12:20:34" , 
"departure_time" : "12:21:32" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "12:27:58" , 
"departure_time" : "12:29:24" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "12:40:26" , 
"departure_time" : "12:40:26" , 
"distance_traveled" : 57.9102
} ], 
"2842" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:27:00" , 
"departure_time" : "16:29:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:37:51" , 
"departure_time" : "16:38:18" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:47:27" , 
"departure_time" : "16:48:21" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 83,
"arrival_time" : "17:04:54" , 
"departure_time" : "17:05:58" , 
"distance_traveled" : 24.5038
}, 
{ 
"stop_id" : 84,
"arrival_time" : "17:10:04" , 
"departure_time" : "17:11:25" , 
"distance_traveled" : 27.0947
}, 
{ 
"stop_id" : 38,
"arrival_time" : "17:15:21" , 
"departure_time" : "17:15:54" , 
"distance_traveled" : 30.1831
}, 
{ 
"stop_id" : 103,
"arrival_time" : "17:19:33" , 
"departure_time" : "17:20:59" , 
"distance_traveled" : 32.55
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "17:30:26" , 
"departure_time" : "17:30:26" , 
"distance_traveled" : 34.3593
} ], 
"2843" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:33:00" , 
"departure_time" : "16:35:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:44:24" , 
"departure_time" : "16:45:42" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:53:18" , 
"departure_time" : "16:53:53" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:58:35" , 
"departure_time" : "16:59:42" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "17:03:07" , 
"departure_time" : "17:04:33" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "17:06:26" , 
"departure_time" : "17:06:36" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "17:11:10" , 
"departure_time" : "17:12:28" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "17:16:18" , 
"departure_time" : "17:16:37" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "17:21:19" , 
"departure_time" : "17:22:36" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "17:26:17" , 
"departure_time" : "17:27:21" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "17:31:04" , 
"departure_time" : "17:31:33" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "17:34:29" , 
"departure_time" : "17:35:27" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:49:58" , 
"departure_time" : "17:50:09" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "17:56:11" , 
"departure_time" : "17:57:34" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "18:08:23" , 
"departure_time" : "18:08:23" , 
"distance_traveled" : 57.9102
} ], 
"2844" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:12:00" , 
"departure_time" : "17:13:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:22:35" , 
"departure_time" : "17:24:12" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:33:37" , 
"departure_time" : "17:34:23" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 83,
"arrival_time" : "17:49:46" , 
"departure_time" : "17:50:20" , 
"distance_traveled" : 24.5038
}, 
{ 
"stop_id" : 84,
"arrival_time" : "17:54:34" , 
"departure_time" : "17:54:51" , 
"distance_traveled" : 27.0947
}, 
{ 
"stop_id" : 38,
"arrival_time" : "17:59:17" , 
"departure_time" : "18:00:11" , 
"distance_traveled" : 30.1831
}, 
{ 
"stop_id" : 103,
"arrival_time" : "18:03:54" , 
"departure_time" : "18:04:36" , 
"distance_traveled" : 32.55
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "18:10:42" , 
"departure_time" : "18:10:42" , 
"distance_traveled" : 34.3593
} ], 
"2845" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:43:00" , 
"departure_time" : "19:45:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:53:32" , 
"departure_time" : "19:54:31" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:02:59" , 
"departure_time" : "20:04:11" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:09:12" , 
"departure_time" : "20:09:40" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "20:12:28" , 
"departure_time" : "20:13:26" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "20:15:58" , 
"departure_time" : "20:16:20" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "20:21:22" , 
"departure_time" : "20:22:02" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:25:40" , 
"departure_time" : "20:26:32" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "20:31:52" , 
"departure_time" : "20:33:04" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "20:36:12" , 
"departure_time" : "20:37:03" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "20:40:51" , 
"departure_time" : "20:42:10" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "20:45:19" , 
"departure_time" : "20:46:50" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "21:00:31" , 
"departure_time" : "21:02:11" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "21:06:40" , 
"departure_time" : "21:08:17" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "21:17:37" , 
"departure_time" : "21:17:37" , 
"distance_traveled" : 57.9102
} ], 
"2846" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:39:00" , 
"departure_time" : "17:42:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:50:23" , 
"departure_time" : "17:50:31" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:58:08" , 
"departure_time" : "17:58:54" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 83,
"arrival_time" : "18:16:46" , 
"departure_time" : "18:17:01" , 
"distance_traveled" : 24.5038
}, 
{ 
"stop_id" : 84,
"arrival_time" : "18:21:15" , 
"departure_time" : "18:21:36" , 
"distance_traveled" : 27.0947
}, 
{ 
"stop_id" : 38,
"arrival_time" : "18:26:21" , 
"departure_time" : "18:27:52" , 
"distance_traveled" : 30.1831
}, 
{ 
"stop_id" : 103,
"arrival_time" : "18:32:31" , 
"departure_time" : "18:34:02" , 
"distance_traveled" : 32.55
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "18:39:31" , 
"departure_time" : "18:39:31" , 
"distance_traveled" : 34.3593
} ], 
"2847" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "25:22:00" , 
"departure_time" : "25:24:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "25:32:14" , 
"departure_time" : "25:33:40" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "25:41:26" , 
"departure_time" : "25:41:54" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "25:46:28" , 
"departure_time" : "25:46:41" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "25:50:13" , 
"departure_time" : "25:51:13" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "25:54:00" , 
"departure_time" : "25:54:57" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "25:59:57" , 
"departure_time" : "26:01:01" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "26:04:04" , 
"departure_time" : "26:05:24" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "26:11:20" , 
"departure_time" : "26:11:51" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "26:14:31" , 
"departure_time" : "26:15:27" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "26:19:56" , 
"departure_time" : "26:20:05" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "26:23:09" , 
"departure_time" : "26:23:58" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "26:28:49" , 
"departure_time" : "26:30:01" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "26:42:12" , 
"departure_time" : "26:43:31" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "26:48:19" , 
"departure_time" : "26:49:50" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "27:07:31" , 
"departure_time" : "27:07:31" , 
"distance_traveled" : 57.9104
} ], 
"2848" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:16:00" , 
"departure_time" : "17:18:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:27:00" , 
"departure_time" : "17:28:06" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:38:06" , 
"departure_time" : "17:38:50" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:10:44" , 
"departure_time" : "18:11:46" , 
"distance_traveled" : 48.286
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "18:18:02" , 
"departure_time" : "18:19:13" , 
"distance_traveled" : 54.2568
}, 
{ 
"stop_id" : 148,
"arrival_time" : "18:30:11" , 
"departure_time" : "18:30:11" , 
"distance_traveled" : 57.9106
} ], 
"2849" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "05:07:00" , 
"departure_time" : "05:09:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:17:15" , 
"departure_time" : "05:17:30" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "05:25:15" , 
"departure_time" : "05:26:23" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "05:32:08" , 
"departure_time" : "05:32:39" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "05:34:31" , 
"departure_time" : "05:35:20" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "05:37:49" , 
"departure_time" : "05:38:22" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "05:44:33" , 
"departure_time" : "05:46:06" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "05:49:33" , 
"departure_time" : "05:50:55" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "05:54:22" , 
"departure_time" : "05:55:01" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "05:58:39" , 
"departure_time" : "05:59:40" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "06:04:01" , 
"departure_time" : "06:04:35" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "06:07:34" , 
"departure_time" : "06:08:52" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "06:13:18" , 
"departure_time" : "06:14:10" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "06:25:52" , 
"departure_time" : "06:26:32" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "06:31:40" , 
"departure_time" : "06:31:52" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "06:43:12" , 
"departure_time" : "06:43:12" , 
"distance_traveled" : 57.9104
} ], 
"2850" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:01:00" , 
"departure_time" : "15:02:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:17:02" , 
"departure_time" : "15:17:38" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "15:22:36" , 
"departure_time" : "15:23:49" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 103,
"arrival_time" : "15:44:13" , 
"departure_time" : "15:45:17" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "15:48:04" , 
"departure_time" : "15:48:14" , 
"distance_traveled" : 34.3589
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:59:10" , 
"departure_time" : "16:00:13" , 
"distance_traveled" : 48.286
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "16:09:03" , 
"departure_time" : "16:09:25" , 
"distance_traveled" : 54.2568
}, 
{ 
"stop_id" : 148,
"arrival_time" : "16:19:22" , 
"departure_time" : "16:19:22" , 
"distance_traveled" : 57.9106
} ], 
"2851" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "09:37:00" , 
"departure_time" : "09:38:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:47:00" , 
"departure_time" : "09:47:36" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:55:36" , 
"departure_time" : "09:57:01" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:02:25" , 
"departure_time" : "10:03:45" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "10:05:20" , 
"departure_time" : "10:05:36" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "10:07:16" , 
"departure_time" : "10:08:17" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "10:15:01" , 
"departure_time" : "10:15:13" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "10:18:12" , 
"departure_time" : "10:18:22" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "10:24:10" , 
"departure_time" : "10:24:39" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "10:28:29" , 
"departure_time" : "10:29:44" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "10:34:15" , 
"departure_time" : "10:35:14" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "10:37:59" , 
"departure_time" : "10:38:49" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "10:42:50" , 
"departure_time" : "10:44:22" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "10:56:32" , 
"departure_time" : "10:56:42" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "11:02:10" , 
"departure_time" : "11:02:36" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "11:14:26" , 
"departure_time" : "11:14:26" , 
"distance_traveled" : 57.9104
} ], 
"2852" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:12:00" , 
"departure_time" : "18:13:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:21:38" , 
"departure_time" : "18:21:42" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:32:04" , 
"departure_time" : "18:32:07" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 103,
"arrival_time" : "18:56:03" , 
"departure_time" : "18:57:25" , 
"distance_traveled" : 32.55
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "19:02:22" , 
"departure_time" : "19:02:34" , 
"distance_traveled" : 34.3593
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:15:12" , 
"departure_time" : "19:15:37" , 
"distance_traveled" : 48.2864
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "19:23:25" , 
"departure_time" : "19:24:04" , 
"distance_traveled" : 54.2572
}, 
{ 
"stop_id" : 148,
"arrival_time" : "19:35:39" , 
"departure_time" : "19:35:39" , 
"distance_traveled" : 57.911
} ], 
"2853" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "12:01:00" , 
"departure_time" : "12:01:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:10:09" , 
"departure_time" : "12:10:13" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:19:04" , 
"departure_time" : "12:19:13" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "12:25:09" , 
"departure_time" : "12:25:19" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "12:28:10" , 
"departure_time" : "12:29:41" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "12:32:31" , 
"departure_time" : "12:33:13" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "12:38:42" , 
"departure_time" : "12:39:55" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "12:43:13" , 
"departure_time" : "12:43:37" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "12:47:24" , 
"departure_time" : "12:49:03" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "12:53:39" , 
"departure_time" : "12:54:03" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "12:56:24" , 
"departure_time" : "12:56:36" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "13:00:12" , 
"departure_time" : "13:01:39" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "13:06:27" , 
"departure_time" : "13:06:43" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:18:16" , 
"departure_time" : "13:19:18" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "13:25:02" , 
"departure_time" : "13:25:54" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "13:35:52" , 
"departure_time" : "13:35:52" , 
"distance_traveled" : 57.9104
} ], 
"2854" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:16:00" , 
"departure_time" : "20:18:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:26:18" , 
"departure_time" : "20:27:45" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:36:27" , 
"departure_time" : "20:36:55" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 103,
"arrival_time" : "20:59:28" , 
"departure_time" : "21:00:10" , 
"distance_traveled" : 32.55
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "21:04:42" , 
"departure_time" : "21:05:38" , 
"distance_traveled" : 34.3593
}, 
{ 
"stop_id" : 125,
"arrival_time" : "21:17:56" , 
"departure_time" : "21:18:27" , 
"distance_traveled" : 48.2864
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "21:24:31" , 
"departure_time" : "21:24:47" , 
"distance_traveled" : 54.2572
}, 
{ 
"stop_id" : 148,
"arrival_time" : "21:36:16" , 
"departure_time" : "21:36:16" , 
"distance_traveled" : 57.911
} ], 
"2855" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:07:00" , 
"departure_time" : "20:07:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:17:11" , 
"departure_time" : "20:17:22" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:26:11" , 
"departure_time" : "20:26:50" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:32:39" , 
"departure_time" : "20:33:12" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "20:35:33" , 
"departure_time" : "20:36:04" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "20:38:31" , 
"departure_time" : "20:39:30" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "20:44:59" , 
"departure_time" : "20:46:36" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:50:37" , 
"departure_time" : "20:51:43" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "20:57:06" , 
"departure_time" : "20:57:20" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "21:01:14" , 
"departure_time" : "21:02:00" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "21:06:46" , 
"departure_time" : "21:06:50" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "21:10:04" , 
"departure_time" : "21:10:18" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "21:15:14" , 
"departure_time" : "21:16:01" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "21:27:47" , 
"departure_time" : "21:27:49" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "21:34:02" , 
"departure_time" : "21:34:11" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "21:46:09" , 
"departure_time" : "21:46:09" , 
"distance_traveled" : 57.9104
} ], 
"2856" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:01:00" , 
"departure_time" : "16:02:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:12:14" , 
"departure_time" : "16:12:24" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:21:10" , 
"departure_time" : "16:22:19" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:28:09" , 
"departure_time" : "16:29:17" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "16:42:08" , 
"departure_time" : "16:43:23" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "16:47:15" , 
"departure_time" : "16:47:20" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "16:51:05" , 
"departure_time" : "16:51:50" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "16:56:45" , 
"departure_time" : "16:57:34" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "17:04:49" , 
"departure_time" : "17:04:49" , 
"distance_traveled" : 34.3589
} ], 
"2857" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "23:06:00" , 
"departure_time" : "23:06:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:16:07" , 
"departure_time" : "23:16:28" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "23:24:21" , 
"departure_time" : "23:25:38" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "23:31:17" , 
"departure_time" : "23:32:37" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "23:34:20" , 
"departure_time" : "23:35:26" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "23:37:06" , 
"departure_time" : "23:37:27" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "23:43:21" , 
"departure_time" : "23:44:05" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "23:47:44" , 
"departure_time" : "23:48:34" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "23:53:50" , 
"departure_time" : "23:54:58" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "23:59:08" , 
"departure_time" : "24:00:25" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "24:04:17" , 
"departure_time" : "24:05:17" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "24:09:00" , 
"departure_time" : "24:10:11" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "24:14:11" , 
"departure_time" : "24:15:24" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "24:27:13" , 
"departure_time" : "24:27:23" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "24:33:10" , 
"departure_time" : "24:34:00" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "24:46:50" , 
"departure_time" : "24:46:50" , 
"distance_traveled" : 57.9104
} ], 
"2858" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "09:04:00" , 
"departure_time" : "09:06:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:14:22" , 
"departure_time" : "09:14:59" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:21:37" , 
"departure_time" : "09:22:26" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:27:49" , 
"departure_time" : "09:28:57" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 103,
"arrival_time" : "09:49:08" , 
"departure_time" : "09:49:27" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "10:03:19" , 
"departure_time" : "10:04:45" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "10:11:26" , 
"departure_time" : "10:12:49" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "10:20:23" , 
"departure_time" : "10:20:23" , 
"distance_traveled" : 57.9104
} ], 
"2859" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "06:34:00" , 
"departure_time" : "06:35:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:49:07" , 
"departure_time" : "06:50:00" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 83,
"arrival_time" : "07:07:53" , 
"departure_time" : "07:08:55" , 
"distance_traveled" : 24.5038
}, 
{ 
"stop_id" : 103,
"arrival_time" : "07:17:02" , 
"departure_time" : "07:17:19" , 
"distance_traveled" : 32.5553
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "07:21:17" , 
"departure_time" : "07:21:17" , 
"distance_traveled" : 34.3595
} ], 
"2860" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:20:00" , 
"departure_time" : "19:21:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:30:08" , 
"departure_time" : "19:31:23" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:39:15" , 
"departure_time" : "19:40:49" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 127,
"arrival_time" : "19:52:34" , 
"departure_time" : "19:53:11" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "19:57:37" , 
"departure_time" : "19:57:51" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "20:02:14" , 
"departure_time" : "20:02:36" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "20:08:22" , 
"departure_time" : "20:09:46" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "20:13:24" , 
"departure_time" : "20:14:09" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "20:21:45" , 
"departure_time" : "20:21:45" , 
"distance_traveled" : 34.3587
} ], 
"2861" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:03:00" , 
"departure_time" : "17:05:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:20:24" , 
"departure_time" : "17:20:32" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:55:08" , 
"departure_time" : "17:56:46" , 
"distance_traveled" : 48.286
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "18:04:38" , 
"departure_time" : "18:04:46" , 
"distance_traveled" : 54.2568
}, 
{ 
"stop_id" : 148,
"arrival_time" : "18:15:08" , 
"departure_time" : "18:15:08" , 
"distance_traveled" : 57.9106
} ], 
"2862" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:01:00" , 
"departure_time" : "18:01:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:19:41" , 
"departure_time" : "18:21:12" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:53:31" , 
"departure_time" : "18:54:38" , 
"distance_traveled" : 48.286
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "19:02:07" , 
"departure_time" : "19:02:21" , 
"distance_traveled" : 54.2568
}, 
{ 
"stop_id" : 148,
"arrival_time" : "19:13:14" , 
"departure_time" : "19:13:14" , 
"distance_traveled" : 57.9106
} ], 
"2863" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:49:00" , 
"departure_time" : "19:50:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:06:14" , 
"departure_time" : "20:06:56" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 103,
"arrival_time" : "20:29:42" , 
"departure_time" : "20:30:11" , 
"distance_traveled" : 32.55
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "20:34:29" , 
"departure_time" : "20:35:15" , 
"distance_traveled" : 34.3593
}, 
{ 
"stop_id" : 125,
"arrival_time" : "20:48:46" , 
"departure_time" : "20:49:32" , 
"distance_traveled" : 48.2864
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "20:55:46" , 
"departure_time" : "20:55:58" , 
"distance_traveled" : 54.2572
}, 
{ 
"stop_id" : 148,
"arrival_time" : "21:07:12" , 
"departure_time" : "21:07:12" , 
"distance_traveled" : 57.911
} ], 
"2864" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "05:41:00" , 
"departure_time" : "05:41:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:50:33" , 
"departure_time" : "05:51:08" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "05:58:35" , 
"departure_time" : "05:59:42" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "06:05:07" , 
"departure_time" : "06:06:01" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "06:17:54" , 
"departure_time" : "06:19:33" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 103,
"arrival_time" : "06:27:39" , 
"departure_time" : "06:28:30" , 
"distance_traveled" : 32.5549
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "06:33:51" , 
"departure_time" : "06:33:51" , 
"distance_traveled" : 34.3591
} ], 
"2865" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:13:00" , 
"departure_time" : "16:15:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:24:20" , 
"departure_time" : "16:24:21" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:33:01" , 
"departure_time" : "16:33:45" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:09:44" , 
"departure_time" : "17:10:42" , 
"distance_traveled" : 48.286
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "17:18:58" , 
"departure_time" : "17:19:47" , 
"distance_traveled" : 54.2568
}, 
{ 
"stop_id" : 148,
"arrival_time" : "17:26:49" , 
"departure_time" : "17:26:49" , 
"distance_traveled" : 57.9106
} ], 
"2866" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:41:00" , 
"departure_time" : "16:43:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:52:19" , 
"departure_time" : "16:52:20" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:01:01" , 
"departure_time" : "17:02:35" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:35:34" , 
"departure_time" : "17:36:09" , 
"distance_traveled" : 48.286
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "17:42:35" , 
"departure_time" : "17:43:41" , 
"distance_traveled" : 54.2568
}, 
{ 
"stop_id" : 148,
"arrival_time" : "17:54:06" , 
"departure_time" : "17:54:06" , 
"distance_traveled" : 57.9106
} ], 
"2867" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:43:00" , 
"departure_time" : "17:45:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:54:40" , 
"departure_time" : "17:55:16" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:03:36" , 
"departure_time" : "18:04:47" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:37:11" , 
"departure_time" : "18:38:12" , 
"distance_traveled" : 48.286
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "18:44:01" , 
"departure_time" : "18:44:26" , 
"distance_traveled" : 54.2568
}, 
{ 
"stop_id" : 148,
"arrival_time" : "18:54:25" , 
"departure_time" : "18:54:25" , 
"distance_traveled" : 57.9106
} ], 
"2868" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "07:31:00" , 
"departure_time" : "07:31:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:40:17" , 
"departure_time" : "07:40:32" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:48:15" , 
"departure_time" : "07:49:25" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 83,
"arrival_time" : "08:06:10" , 
"departure_time" : "08:06:28" , 
"distance_traveled" : 24.5038
}, 
{ 
"stop_id" : 84,
"arrival_time" : "08:09:18" , 
"departure_time" : "08:09:32" , 
"distance_traveled" : 27.0947
}, 
{ 
"stop_id" : 38,
"arrival_time" : "08:14:14" , 
"departure_time" : "08:14:20" , 
"distance_traveled" : 30.1831
}, 
{ 
"stop_id" : 103,
"arrival_time" : "08:18:06" , 
"departure_time" : "08:19:21" , 
"distance_traveled" : 32.55
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "08:26:15" , 
"departure_time" : "08:26:15" , 
"distance_traveled" : 34.3593
} ], 
"2869" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:27:00" , 
"departure_time" : "16:29:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:38:24" , 
"departure_time" : "16:39:18" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:47:54" , 
"departure_time" : "16:49:26" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 83,
"arrival_time" : "17:05:32" , 
"departure_time" : "17:06:04" , 
"distance_traveled" : 24.5038
}, 
{ 
"stop_id" : 84,
"arrival_time" : "17:09:32" , 
"departure_time" : "17:10:01" , 
"distance_traveled" : 27.0947
}, 
{ 
"stop_id" : 38,
"arrival_time" : "17:14:29" , 
"departure_time" : "17:15:47" , 
"distance_traveled" : 30.1831
}, 
{ 
"stop_id" : 103,
"arrival_time" : "17:20:18" , 
"departure_time" : "17:21:20" , 
"distance_traveled" : 32.55
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "17:30:02" , 
"departure_time" : "17:30:02" , 
"distance_traveled" : 34.3593
} ], 
"2870" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:12:00" , 
"departure_time" : "17:13:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:22:08" , 
"departure_time" : "17:23:28" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:33:20" , 
"departure_time" : "17:34:14" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 83,
"arrival_time" : "17:49:54" , 
"departure_time" : "17:50:24" , 
"distance_traveled" : 24.5038
}, 
{ 
"stop_id" : 84,
"arrival_time" : "17:54:30" , 
"departure_time" : "17:55:31" , 
"distance_traveled" : 27.0947
}, 
{ 
"stop_id" : 38,
"arrival_time" : "18:00:01" , 
"departure_time" : "18:01:05" , 
"distance_traveled" : 30.1831
}, 
{ 
"stop_id" : 103,
"arrival_time" : "18:04:04" , 
"departure_time" : "18:04:18" , 
"distance_traveled" : 32.55
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "18:10:14" , 
"departure_time" : "18:10:14" , 
"distance_traveled" : 34.3593
} ], 
"2871" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:39:00" , 
"departure_time" : "17:40:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:50:06" , 
"departure_time" : "17:51:10" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:59:04" , 
"departure_time" : "18:00:19" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 83,
"arrival_time" : "18:17:15" , 
"departure_time" : "18:17:44" , 
"distance_traveled" : 24.5038
}, 
{ 
"stop_id" : 84,
"arrival_time" : "18:21:29" , 
"departure_time" : "18:21:41" , 
"distance_traveled" : 27.0947
}, 
{ 
"stop_id" : 38,
"arrival_time" : "18:26:12" , 
"departure_time" : "18:27:47" , 
"distance_traveled" : 30.1831
}, 
{ 
"stop_id" : 103,
"arrival_time" : "18:32:35" , 
"departure_time" : "18:34:02" , 
"distance_traveled" : 32.55
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "18:39:27" , 
"departure_time" : "18:39:27" , 
"distance_traveled" : 34.3593
} ], 
"2872" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:16:00" , 
"departure_time" : "17:17:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:26:01" , 
"departure_time" : "17:26:15" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:37:14" , 
"departure_time" : "17:37:15" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:10:01" , 
"departure_time" : "18:11:01" , 
"distance_traveled" : 48.286
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "18:18:00" , 
"departure_time" : "18:19:34" , 
"distance_traveled" : 54.2568
}, 
{ 
"stop_id" : 148,
"arrival_time" : "18:30:34" , 
"departure_time" : "18:30:34" , 
"distance_traveled" : 57.9106
} ], 
"2873" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:01:00" , 
"departure_time" : "15:03:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:17:18" , 
"departure_time" : "15:17:38" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "15:22:20" , 
"departure_time" : "15:22:31" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 103,
"arrival_time" : "15:43:11" , 
"departure_time" : "15:44:17" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "15:48:06" , 
"departure_time" : "15:48:37" , 
"distance_traveled" : 34.3589
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:59:31" , 
"departure_time" : "15:59:46" , 
"distance_traveled" : 48.286
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "16:08:15" , 
"departure_time" : "16:09:33" , 
"distance_traveled" : 54.2568
}, 
{ 
"stop_id" : 148,
"arrival_time" : "16:20:18" , 
"departure_time" : "16:20:18" , 
"distance_traveled" : 57.9106
} ], 
"2874" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:12:00" , 
"departure_time" : "18:13:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:21:07" , 
"departure_time" : "18:21:56" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:32:49" , 
"departure_time" : "18:33:36" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 103,
"arrival_time" : "18:56:47" , 
"departure_time" : "18:58:21" , 
"distance_traveled" : 32.55
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "19:02:34" , 
"departure_time" : "19:03:42" , 
"distance_traveled" : 34.3593
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:16:08" , 
"departure_time" : "19:16:35" , 
"distance_traveled" : 48.2864
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "19:23:27" , 
"departure_time" : "19:24:17" , 
"distance_traveled" : 54.2572
}, 
{ 
"stop_id" : 148,
"arrival_time" : "19:35:50" , 
"departure_time" : "19:35:50" , 
"distance_traveled" : 57.911
} ], 
"2875" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:16:00" , 
"departure_time" : "20:18:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:26:20" , 
"departure_time" : "20:27:38" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:36:18" , 
"departure_time" : "20:37:21" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 103,
"arrival_time" : "21:00:03" , 
"departure_time" : "21:01:20" , 
"distance_traveled" : 32.55
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "21:05:17" , 
"departure_time" : "21:05:21" , 
"distance_traveled" : 34.3593
}, 
{ 
"stop_id" : 125,
"arrival_time" : "21:17:04" , 
"departure_time" : "21:18:27" , 
"distance_traveled" : 48.2864
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "21:25:23" , 
"departure_time" : "21:26:54" , 
"distance_traveled" : 54.2572
}, 
{ 
"stop_id" : 148,
"arrival_time" : "21:37:31" , 
"departure_time" : "21:37:31" , 
"distance_traveled" : 57.911
} ], 
"2876" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:01:00" , 
"departure_time" : "16:02:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:11:21" , 
"departure_time" : "16:12:06" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:21:45" , 
"departure_time" : "16:22:48" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:28:03" , 
"departure_time" : "16:28:45" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "16:41:42" , 
"departure_time" : "16:42:12" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "16:46:30" , 
"departure_time" : "16:47:08" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "16:51:38" , 
"departure_time" : "16:52:59" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "16:57:21" , 
"departure_time" : "16:57:47" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "17:04:26" , 
"departure_time" : "17:04:26" , 
"distance_traveled" : 34.3589
} ], 
"2877" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "09:04:00" , 
"departure_time" : "09:05:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:14:10" , 
"departure_time" : "09:14:32" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:21:22" , 
"departure_time" : "09:21:46" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:27:24" , 
"departure_time" : "09:28:14" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 103,
"arrival_time" : "09:48:50" , 
"departure_time" : "09:49:58" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "10:04:08" , 
"departure_time" : "10:04:42" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "10:10:34" , 
"departure_time" : "10:12:11" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "10:20:37" , 
"departure_time" : "10:20:37" , 
"distance_traveled" : 57.9104
} ], 
"2878" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:20:00" , 
"departure_time" : "19:22:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:29:53" , 
"departure_time" : "19:31:12" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:39:19" , 
"departure_time" : "19:40:55" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 127,
"arrival_time" : "19:52:36" , 
"departure_time" : "19:53:53" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "19:58:17" , 
"departure_time" : "19:59:10" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "20:02:53" , 
"departure_time" : "20:03:03" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "20:08:10" , 
"departure_time" : "20:09:45" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "20:13:35" , 
"departure_time" : "20:13:47" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "20:21:12" , 
"departure_time" : "20:21:12" , 
"distance_traveled" : 34.3587
} ], 
"2879" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "14:55:00" , 
"departure_time" : "14:55:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:04:40" , 
"departure_time" : "15:05:54" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:14:14" , 
"departure_time" : "15:14:30" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "15:19:16" , 
"departure_time" : "15:20:18" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "15:36:02" , 
"departure_time" : "15:36:17" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "15:39:15" , 
"departure_time" : "15:40:31" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "15:45:16" , 
"departure_time" : "15:46:09" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "15:49:53" , 
"departure_time" : "15:50:35" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:04:42" , 
"departure_time" : "16:05:36" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "16:10:54" , 
"departure_time" : "16:10:58" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "16:23:04" , 
"departure_time" : "16:23:04" , 
"distance_traveled" : 57.9104
} ], 
"2880" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "10:14:00" , 
"departure_time" : "10:15:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:24:09" , 
"departure_time" : "10:24:21" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:32:12" , 
"departure_time" : "10:33:15" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:39:03" , 
"departure_time" : "10:39:23" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "10:43:20" , 
"departure_time" : "10:43:46" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "10:50:26" , 
"departure_time" : "10:51:14" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "10:54:48" , 
"departure_time" : "10:55:15" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "11:00:27" , 
"departure_time" : "11:00:54" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "11:05:27" , 
"departure_time" : "11:05:45" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "11:10:18" , 
"departure_time" : "11:11:09" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "11:14:51" , 
"departure_time" : "11:15:52" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "11:30:01" , 
"departure_time" : "11:31:03" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "11:37:02" , 
"departure_time" : "11:37:09" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "11:48:07" , 
"departure_time" : "11:48:07" , 
"distance_traveled" : 57.9102
} ], 
"2881" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "11:14:00" , 
"departure_time" : "11:15:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:24:07" , 
"departure_time" : "11:25:28" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:33:21" , 
"departure_time" : "11:34:10" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "11:38:49" , 
"departure_time" : "11:40:12" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "11:44:23" , 
"departure_time" : "11:46:01" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "11:51:38" , 
"departure_time" : "11:52:14" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "11:54:36" , 
"departure_time" : "11:55:46" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "12:01:10" , 
"departure_time" : "12:01:38" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "12:05:28" , 
"departure_time" : "12:06:07" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "12:10:39" , 
"departure_time" : "12:10:50" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "12:14:11" , 
"departure_time" : "12:14:46" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "12:29:35" , 
"departure_time" : "12:30:03" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "12:36:28" , 
"departure_time" : "12:38:02" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "12:49:34" , 
"departure_time" : "12:49:34" , 
"distance_traveled" : 57.9102
} ], 
"2882" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "14:14:00" , 
"departure_time" : "14:16:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:24:19" , 
"departure_time" : "14:25:18" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:32:59" , 
"departure_time" : "14:34:11" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "14:39:12" , 
"departure_time" : "14:40:02" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "14:41:50" , 
"departure_time" : "14:43:13" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "14:45:23" , 
"departure_time" : "14:46:13" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "14:51:50" , 
"departure_time" : "14:52:18" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "14:55:28" , 
"departure_time" : "14:56:43" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "15:02:15" , 
"departure_time" : "15:03:13" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "15:06:58" , 
"departure_time" : "15:07:43" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "15:11:45" , 
"departure_time" : "15:13:15" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "15:16:30" , 
"departure_time" : "15:17:41" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:31:11" , 
"departure_time" : "15:31:44" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "15:37:33" , 
"departure_time" : "15:38:54" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "15:49:21" , 
"departure_time" : "15:49:21" , 
"distance_traveled" : 57.9102
} ], 
"2883" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "22:14:00" , 
"departure_time" : "22:17:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:24:39" , 
"departure_time" : "22:25:24" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:32:45" , 
"departure_time" : "22:33:26" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:38:41" , 
"departure_time" : "22:39:02" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "22:41:21" , 
"departure_time" : "22:42:34" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "22:45:13" , 
"departure_time" : "22:45:16" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "22:51:03" , 
"departure_time" : "22:52:38" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "22:56:35" , 
"departure_time" : "22:57:24" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "23:01:49" , 
"departure_time" : "23:02:48" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "23:06:59" , 
"departure_time" : "23:08:27" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "23:12:28" , 
"departure_time" : "23:14:08" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "23:16:40" , 
"departure_time" : "23:17:31" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "23:30:51" , 
"departure_time" : "23:30:56" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "23:37:05" , 
"departure_time" : "23:37:42" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "23:48:37" , 
"departure_time" : "23:48:37" , 
"distance_traveled" : 57.9102
} ], 
"2884" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "12:44:00" , 
"departure_time" : "12:44:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:53:02" , 
"departure_time" : "12:54:28" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:03:26" , 
"departure_time" : "13:04:42" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 83,
"arrival_time" : "13:20:16" , 
"departure_time" : "13:21:48" , 
"distance_traveled" : 24.5038
}, 
{ 
"stop_id" : 84,
"arrival_time" : "13:25:32" , 
"departure_time" : "13:26:37" , 
"distance_traveled" : 27.0947
}, 
{ 
"stop_id" : 38,
"arrival_time" : "13:30:05" , 
"departure_time" : "13:30:30" , 
"distance_traveled" : 30.1831
}, 
{ 
"stop_id" : 103,
"arrival_time" : "13:36:25" , 
"departure_time" : "13:36:49" , 
"distance_traveled" : 32.55
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:56:24" , 
"departure_time" : "13:56:33" , 
"distance_traveled" : 48.2862
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "14:03:09" , 
"departure_time" : "14:04:37" , 
"distance_traveled" : 54.257
}, 
{ 
"stop_id" : 148,
"arrival_time" : "14:13:28" , 
"departure_time" : "14:13:28" , 
"distance_traveled" : 57.9108
} ], 
"2885" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:44:00" , 
"departure_time" : "17:46:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:54:13" , 
"departure_time" : "17:55:00" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:02:47" , 
"departure_time" : "18:03:09" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 83,
"arrival_time" : "18:19:22" , 
"departure_time" : "18:19:52" , 
"distance_traveled" : 24.5038
}, 
{ 
"stop_id" : 84,
"arrival_time" : "18:24:30" , 
"departure_time" : "18:24:53" , 
"distance_traveled" : 27.0947
}, 
{ 
"stop_id" : 38,
"arrival_time" : "18:29:23" , 
"departure_time" : "18:31:02" , 
"distance_traveled" : 30.1831
}, 
{ 
"stop_id" : 103,
"arrival_time" : "18:34:39" , 
"departure_time" : "18:35:11" , 
"distance_traveled" : 32.55
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:48:32" , 
"departure_time" : "18:48:50" , 
"distance_traveled" : 48.2862
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "18:55:18" , 
"departure_time" : "18:55:32" , 
"distance_traveled" : 54.257
}, 
{ 
"stop_id" : 148,
"arrival_time" : "19:04:14" , 
"departure_time" : "19:04:14" , 
"distance_traveled" : 57.9108
} ], 
"2886" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:44:00" , 
"departure_time" : "18:44:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:53:31" , 
"departure_time" : "18:54:15" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:02:44" , 
"departure_time" : "19:03:36" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 83,
"arrival_time" : "19:19:52" , 
"departure_time" : "19:21:27" , 
"distance_traveled" : 24.5038
}, 
{ 
"stop_id" : 84,
"arrival_time" : "19:25:35" , 
"departure_time" : "19:25:51" , 
"distance_traveled" : 27.0947
}, 
{ 
"stop_id" : 38,
"arrival_time" : "19:29:16" , 
"departure_time" : "19:30:41" , 
"distance_traveled" : 30.1831
}, 
{ 
"stop_id" : 103,
"arrival_time" : "19:34:25" , 
"departure_time" : "19:35:04" , 
"distance_traveled" : 32.55
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:54:39" , 
"departure_time" : "19:55:22" , 
"distance_traveled" : 48.2862
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "20:02:43" , 
"departure_time" : "20:03:42" , 
"distance_traveled" : 54.257
}, 
{ 
"stop_id" : 148,
"arrival_time" : "20:11:59" , 
"departure_time" : "20:11:59" , 
"distance_traveled" : 57.9108
} ], 
"2887" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "04:15:00" , 
"departure_time" : "04:17:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "04:25:18" , 
"departure_time" : "04:25:27" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "04:32:09" , 
"departure_time" : "04:32:51" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "04:37:42" , 
"departure_time" : "04:39:11" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "04:42:29" , 
"departure_time" : "04:43:46" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "04:48:17" , 
"departure_time" : "04:48:39" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "04:50:22" , 
"departure_time" : "04:50:24" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "04:56:02" , 
"departure_time" : "04:56:09" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "05:01:07" , 
"departure_time" : "05:01:20" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "05:06:13" , 
"departure_time" : "05:07:09" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "05:10:56" , 
"departure_time" : "05:12:15" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "05:25:19" , 
"departure_time" : "05:26:22" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "05:32:03" , 
"departure_time" : "05:33:39" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "05:48:36" , 
"departure_time" : "05:48:36" , 
"distance_traveled" : 57.9102
} ], 
"2888" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "05:10:00" , 
"departure_time" : "05:12:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:19:52" , 
"departure_time" : "05:21:30" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "05:29:38" , 
"departure_time" : "05:30:32" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "05:34:54" , 
"departure_time" : "05:36:19" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "05:38:25" , 
"departure_time" : "05:38:34" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "05:40:09" , 
"departure_time" : "05:41:07" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "05:47:58" , 
"departure_time" : "05:49:00" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "05:52:02" , 
"departure_time" : "05:52:30" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "05:57:28" , 
"departure_time" : "05:58:42" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "06:03:14" , 
"departure_time" : "06:03:59" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "06:07:45" , 
"departure_time" : "06:08:17" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "06:11:32" , 
"departure_time" : "06:12:28" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "06:26:56" , 
"departure_time" : "06:27:02" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "06:33:06" , 
"departure_time" : "06:33:19" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "06:44:13" , 
"departure_time" : "06:44:13" , 
"distance_traveled" : 57.9102
} ], 
"2889" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "24:14:00" , 
"departure_time" : "24:15:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:24:09" , 
"departure_time" : "24:25:31" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "24:33:22" , 
"departure_time" : "24:34:55" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "24:39:33" , 
"departure_time" : "24:40:22" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "24:41:49" , 
"departure_time" : "24:43:21" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "24:45:32" , 
"departure_time" : "24:46:47" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "24:52:15" , 
"departure_time" : "24:53:43" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "24:56:28" , 
"departure_time" : "24:57:09" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "25:01:41" , 
"departure_time" : "25:01:52" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "25:06:11" , 
"departure_time" : "25:07:34" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "25:12:23" , 
"departure_time" : "25:13:21" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "25:15:58" , 
"departure_time" : "25:16:42" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "25:30:44" , 
"departure_time" : "25:31:40" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "25:37:56" , 
"departure_time" : "25:39:18" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "25:54:22" , 
"departure_time" : "25:54:22" , 
"distance_traveled" : 57.9102
} ], 
"2890" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "25:22:00" , 
"departure_time" : "25:24:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "25:31:48" , 
"departure_time" : "25:32:37" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "25:40:49" , 
"departure_time" : "25:42:04" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "25:47:15" , 
"departure_time" : "25:48:49" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "25:51:34" , 
"departure_time" : "25:52:17" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "25:53:43" , 
"departure_time" : "25:54:52" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "26:00:09" , 
"departure_time" : "26:00:39" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "26:03:30" , 
"departure_time" : "26:04:36" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "26:11:06" , 
"departure_time" : "26:11:42" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "26:14:36" , 
"departure_time" : "26:15:44" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "26:20:08" , 
"departure_time" : "26:21:16" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "26:24:08" , 
"departure_time" : "26:24:48" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 32906,
"arrival_time" : "26:28:40" , 
"departure_time" : "26:29:20" , 
"distance_traveled" : 34.3587
}, 
{ 
"stop_id" : 125,
"arrival_time" : "26:41:40" , 
"departure_time" : "26:43:17" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "26:48:37" , 
"departure_time" : "26:49:38" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "27:07:01" , 
"departure_time" : "27:07:01" , 
"distance_traveled" : 57.9104
} ], 
"2891" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "05:10:00" , 
"departure_time" : "05:11:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:19:50" , 
"departure_time" : "05:20:25" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "05:28:35" , 
"departure_time" : "05:28:56" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "05:34:21" , 
"departure_time" : "05:35:48" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "05:38:27" , 
"departure_time" : "05:39:07" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "05:40:40" , 
"departure_time" : "05:41:01" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "05:47:21" , 
"departure_time" : "05:47:39" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "05:51:18" , 
"departure_time" : "05:52:56" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "05:58:38" , 
"departure_time" : "05:59:54" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "06:03:16" , 
"departure_time" : "06:04:05" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "06:07:49" , 
"departure_time" : "06:08:17" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "06:11:28" , 
"departure_time" : "06:13:03" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "06:27:35" , 
"departure_time" : "06:28:16" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "06:33:41" , 
"departure_time" : "06:34:54" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "06:45:13" , 
"departure_time" : "06:45:13" , 
"distance_traveled" : 57.9102
} ], 
"2892" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:54:00" , 
"departure_time" : "20:56:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:12:18" , 
"departure_time" : "21:12:43" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "21:16:25" , 
"departure_time" : "21:17:36" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "21:30:11" , 
"departure_time" : "21:30:54" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "21:34:43" , 
"departure_time" : "21:34:56" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "21:39:13" , 
"departure_time" : "21:40:18" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "21:44:05" , 
"departure_time" : "21:44:57" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "22:01:52" , 
"departure_time" : "22:02:43" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "22:08:51" , 
"departure_time" : "22:09:32" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "22:20:41" , 
"departure_time" : "22:20:41" , 
"distance_traveled" : 57.9104
} ], 
"2893" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:58:00" , 
"departure_time" : "17:59:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:13:55" , 
"departure_time" : "18:15:11" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:20:16" , 
"departure_time" : "18:21:51" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "18:34:35" , 
"departure_time" : "18:34:42" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "18:37:07" , 
"departure_time" : "18:37:43" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "18:42:36" , 
"departure_time" : "18:43:56" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "18:48:20" , 
"departure_time" : "18:49:49" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:03:29" , 
"departure_time" : "19:03:51" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "19:09:22" , 
"departure_time" : "19:11:02" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "19:22:40" , 
"departure_time" : "19:22:40" , 
"distance_traveled" : 57.9104
} ], 
"2894" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "21:57:00" , 
"departure_time" : "21:59:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:14:04" , 
"departure_time" : "22:15:10" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:19:06" , 
"departure_time" : "22:19:55" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "22:32:49" , 
"departure_time" : "22:33:24" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "22:37:35" , 
"departure_time" : "22:37:46" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "22:42:11" , 
"departure_time" : "22:43:06" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "22:46:55" , 
"departure_time" : "22:48:02" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "23:02:07" , 
"departure_time" : "23:03:39" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "23:09:32" , 
"departure_time" : "23:09:41" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "23:20:09" , 
"departure_time" : "23:20:09" , 
"distance_traveled" : 57.9104
} ], 
"2895" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "22:57:00" , 
"departure_time" : "22:57:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "23:12:20" , 
"departure_time" : "23:13:41" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "23:19:21" , 
"departure_time" : "23:19:35" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "23:32:14" , 
"departure_time" : "23:33:07" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "23:37:53" , 
"departure_time" : "23:38:17" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "23:42:24" , 
"departure_time" : "23:43:52" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "23:47:28" , 
"departure_time" : "23:47:44" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "24:02:16" , 
"departure_time" : "24:02:44" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "24:08:28" , 
"departure_time" : "24:09:51" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "24:21:23" , 
"departure_time" : "24:21:23" , 
"distance_traveled" : 57.9104
} ], 
"2896" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "13:55:00" , 
"departure_time" : "13:57:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:05:46" , 
"departure_time" : "14:06:12" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:15:26" , 
"departure_time" : "14:16:49" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "14:22:23" , 
"departure_time" : "14:23:46" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "14:35:23" , 
"departure_time" : "14:36:50" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "14:40:27" , 
"departure_time" : "14:42:02" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "14:45:35" , 
"departure_time" : "14:46:36" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "14:50:01" , 
"departure_time" : "14:50:51" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:06:50" , 
"departure_time" : "15:07:59" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "15:14:09" , 
"departure_time" : "15:14:22" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "15:31:13" , 
"departure_time" : "15:31:13" , 
"distance_traveled" : 57.9104
} ], 
"2897" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:52:00" , 
"departure_time" : "15:53:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:03:09" , 
"departure_time" : "16:04:06" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:12:57" , 
"departure_time" : "16:13:37" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:17:40" , 
"departure_time" : "16:19:15" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "16:32:35" , 
"departure_time" : "16:32:39" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "16:36:04" , 
"departure_time" : "16:37:01" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "16:41:57" , 
"departure_time" : "16:42:03" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "16:45:06" , 
"departure_time" : "16:46:13" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:04:07" , 
"departure_time" : "17:04:15" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "17:10:08" , 
"departure_time" : "17:11:03" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "17:22:55" , 
"departure_time" : "17:22:55" , 
"distance_traveled" : 57.9104
} ], 
"2898" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:54:00" , 
"departure_time" : "16:56:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:04:17" , 
"departure_time" : "17:05:33" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:13:16" , 
"departure_time" : "17:13:17" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:19:01" , 
"departure_time" : "17:20:02" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "17:35:01" , 
"departure_time" : "17:36:40" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "17:39:39" , 
"departure_time" : "17:40:16" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "17:43:37" , 
"departure_time" : "17:44:08" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "17:48:31" , 
"departure_time" : "17:49:36" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:03:05" , 
"departure_time" : "18:03:14" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "18:10:09" , 
"departure_time" : "18:10:30" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "18:24:21" , 
"departure_time" : "18:24:21" , 
"distance_traveled" : 57.9104
} ], 
"2899" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:03:00" , 
"departure_time" : "19:03:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:12:01" , 
"departure_time" : "19:12:30" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:21:29" , 
"departure_time" : "19:22:20" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:26:51" , 
"departure_time" : "19:27:24" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "19:40:33" , 
"departure_time" : "19:41:01" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "19:45:28" , 
"departure_time" : "19:45:57" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "19:50:29" , 
"departure_time" : "19:51:57" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "19:55:28" , 
"departure_time" : "19:56:12" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "20:09:44" , 
"departure_time" : "20:09:46" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "20:16:02" , 
"departure_time" : "20:17:03" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "20:29:01" , 
"departure_time" : "20:29:01" , 
"distance_traveled" : 57.9104
} ], 
"2900" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:03:00" , 
"departure_time" : "20:04:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:12:53" , 
"departure_time" : "20:12:59" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:21:06" , 
"departure_time" : "20:21:48" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:26:42" , 
"departure_time" : "20:27:58" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 83,
"arrival_time" : "20:42:16" , 
"departure_time" : "20:43:47" , 
"distance_traveled" : 24.5034
}, 
{ 
"stop_id" : 84,
"arrival_time" : "20:47:31" , 
"departure_time" : "20:49:04" , 
"distance_traveled" : 27.0943
}, 
{ 
"stop_id" : 38,
"arrival_time" : "20:52:33" , 
"departure_time" : "20:53:19" , 
"distance_traveled" : 30.1828
}, 
{ 
"stop_id" : 103,
"arrival_time" : "20:55:46" , 
"departure_time" : "20:56:03" , 
"distance_traveled" : 32.5496
}, 
{ 
"stop_id" : 125,
"arrival_time" : "21:11:17" , 
"departure_time" : "21:12:21" , 
"distance_traveled" : 48.2858
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "21:19:04" , 
"departure_time" : "21:20:22" , 
"distance_traveled" : 54.2566
}, 
{ 
"stop_id" : 148,
"arrival_time" : "21:31:18" , 
"departure_time" : "21:31:18" , 
"distance_traveled" : 57.9104
} ], 
"2901" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "08:14:00" , 
"departure_time" : "08:15:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:23:39" , 
"departure_time" : "08:25:05" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:33:26" , 
"departure_time" : "08:34:41" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:39:15" , 
"departure_time" : "08:40:41" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "08:44:26" , 
"departure_time" : "08:45:56" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "08:51:30" , 
"departure_time" : "08:53:10" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:55:40" , 
"departure_time" : "08:56:30" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "09:00:50" , 
"departure_time" : "09:02:19" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "09:06:29" , 
"departure_time" : "09:08:04" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "09:11:35" , 
"departure_time" : "09:12:26" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "09:14:51" , 
"departure_time" : "09:16:19" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "09:30:28" , 
"departure_time" : "09:31:09" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "09:36:41" , 
"departure_time" : "09:38:00" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "09:49:19" , 
"departure_time" : "09:49:19" , 
"distance_traveled" : 57.9102
} ], 
"2902" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:14:00" , 
"departure_time" : "16:15:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:23:39" , 
"departure_time" : "16:24:31" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:32:52" , 
"departure_time" : "16:33:05" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:38:13" , 
"departure_time" : "16:38:21" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "16:43:08" , 
"departure_time" : "16:44:20" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "16:50:12" , 
"departure_time" : "16:50:45" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "16:53:33" , 
"departure_time" : "16:53:50" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "17:00:17" , 
"departure_time" : "17:01:56" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "17:06:39" , 
"departure_time" : "17:07:26" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "17:10:47" , 
"departure_time" : "17:12:12" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "17:15:25" , 
"departure_time" : "17:15:56" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:29:31" , 
"departure_time" : "17:30:35" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "17:36:04" , 
"departure_time" : "17:37:43" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "17:48:39" , 
"departure_time" : "17:48:39" , 
"distance_traveled" : 57.9102
} ], 
"2903" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "06:13:00" , 
"departure_time" : "06:15:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:22:25" , 
"departure_time" : "06:23:31" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:32:06" , 
"departure_time" : "06:32:45" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "06:37:39" , 
"departure_time" : "06:38:04" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "06:42:25" , 
"departure_time" : "06:43:46" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "06:50:21" , 
"departure_time" : "06:50:52" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "06:53:31" , 
"departure_time" : "06:54:01" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "06:59:30" , 
"departure_time" : "06:59:42" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "07:04:12" , 
"departure_time" : "07:04:51" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "07:09:39" , 
"departure_time" : "07:11:18" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "07:14:39" , 
"departure_time" : "07:15:02" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "07:28:23" , 
"departure_time" : "07:28:53" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "07:35:30" , 
"departure_time" : "07:36:05" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "07:46:35" , 
"departure_time" : "07:46:35" , 
"distance_traveled" : 57.9102
} ], 
"2904" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "07:14:00" , 
"departure_time" : "07:16:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:24:40" , 
"departure_time" : "07:26:08" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:33:28" , 
"departure_time" : "07:33:50" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "07:38:22" , 
"departure_time" : "07:38:52" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "07:43:30" , 
"departure_time" : "07:44:16" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "07:50:46" , 
"departure_time" : "07:51:40" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "07:54:54" , 
"departure_time" : "07:55:09" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "08:00:15" , 
"departure_time" : "08:01:39" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "08:06:24" , 
"departure_time" : "08:07:44" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "08:11:20" , 
"departure_time" : "08:12:57" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "08:15:37" , 
"departure_time" : "08:15:39" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "08:29:02" , 
"departure_time" : "08:29:11" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "08:36:09" , 
"departure_time" : "08:37:35" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "08:48:26" , 
"departure_time" : "08:48:26" , 
"distance_traveled" : 57.9102
} ], 
"2905" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "09:14:00" , 
"departure_time" : "09:16:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:23:43" , 
"departure_time" : "09:25:23" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:33:40" , 
"departure_time" : "09:34:47" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:39:07" , 
"departure_time" : "09:40:33" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "09:44:26" , 
"departure_time" : "09:45:06" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "09:50:40" , 
"departure_time" : "09:51:27" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "09:54:47" , 
"departure_time" : "09:54:52" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "10:00:05" , 
"departure_time" : "10:01:16" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "10:06:11" , 
"departure_time" : "10:07:16" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "10:11:05" , 
"departure_time" : "10:11:39" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "10:14:34" , 
"departure_time" : "10:16:04" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "10:30:30" , 
"departure_time" : "10:31:40" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "10:37:10" , 
"departure_time" : "10:38:23" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "10:49:13" , 
"departure_time" : "10:49:13" , 
"distance_traveled" : 57.9102
} ], 
"2906" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:14:00" , 
"departure_time" : "17:16:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:24:29" , 
"departure_time" : "17:24:53" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:32:24" , 
"departure_time" : "17:32:38" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:38:14" , 
"departure_time" : "17:39:29" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "17:44:15" , 
"departure_time" : "17:45:28" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "17:50:13" , 
"departure_time" : "17:50:33" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "17:53:20" , 
"departure_time" : "17:54:40" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "18:01:20" , 
"departure_time" : "18:02:46" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "18:05:26" , 
"departure_time" : "18:06:08" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "18:09:42" , 
"departure_time" : "18:09:57" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "18:14:15" , 
"departure_time" : "18:15:44" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:30:29" , 
"departure_time" : "18:30:31" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "18:36:02" , 
"departure_time" : "18:37:26" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "18:48:24" , 
"departure_time" : "18:48:24" , 
"distance_traveled" : 57.9102
} ], 
"2907" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:14:00" , 
"departure_time" : "18:15:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:23:14" , 
"departure_time" : "18:23:28" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:32:14" , 
"departure_time" : "18:33:47" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:39:33" , 
"departure_time" : "18:40:28" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "18:43:55" , 
"departure_time" : "18:45:09" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "18:51:14" , 
"departure_time" : "18:52:51" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:55:37" , 
"departure_time" : "18:56:44" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "19:01:07" , 
"departure_time" : "19:01:39" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "19:05:32" , 
"departure_time" : "19:06:21" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "19:10:49" , 
"departure_time" : "19:10:52" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "19:14:03" , 
"departure_time" : "19:15:22" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:30:19" , 
"departure_time" : "19:30:59" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "19:36:40" , 
"departure_time" : "19:37:22" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "19:47:42" , 
"departure_time" : "19:47:42" , 
"distance_traveled" : 57.9102
} ], 
"2908" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:14:00" , 
"departure_time" : "19:15:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:23:36" , 
"departure_time" : "19:24:34" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:32:58" , 
"departure_time" : "19:33:12" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:38:14" , 
"departure_time" : "19:38:34" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "19:43:20" , 
"departure_time" : "19:43:43" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "19:50:23" , 
"departure_time" : "19:51:07" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "19:54:44" , 
"departure_time" : "19:56:16" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "20:01:32" , 
"departure_time" : "20:02:20" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "20:05:48" , 
"departure_time" : "20:07:12" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "20:11:24" , 
"departure_time" : "20:12:16" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "20:14:52" , 
"departure_time" : "20:15:33" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "20:29:41" , 
"departure_time" : "20:30:29" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "20:36:48" , 
"departure_time" : "20:36:50" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "20:48:02" , 
"departure_time" : "20:48:02" , 
"distance_traveled" : 57.9102
} ], 
"2909" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:14:00" , 
"departure_time" : "20:15:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:23:58" , 
"departure_time" : "20:24:41" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:32:43" , 
"departure_time" : "20:33:46" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:39:03" , 
"departure_time" : "20:39:39" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "20:43:36" , 
"departure_time" : "20:44:16" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "20:50:40" , 
"departure_time" : "20:51:53" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:55:13" , 
"departure_time" : "20:56:48" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "21:01:35" , 
"departure_time" : "21:02:04" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "21:05:29" , 
"departure_time" : "21:06:08" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "21:10:39" , 
"departure_time" : "21:11:07" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "21:14:28" , 
"departure_time" : "21:14:43" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "21:29:15" , 
"departure_time" : "21:29:38" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "21:36:23" , 
"departure_time" : "21:37:21" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "21:47:58" , 
"departure_time" : "21:47:58" , 
"distance_traveled" : 57.9102
} ], 
"2910" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "12:14:00" , 
"departure_time" : "12:16:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:24:05" , 
"departure_time" : "12:25:29" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:33:24" , 
"departure_time" : "12:33:41" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "12:38:17" , 
"departure_time" : "12:38:50" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "12:41:33" , 
"departure_time" : "12:42:10" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "12:44:37" , 
"departure_time" : "12:44:50" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "12:51:13" , 
"departure_time" : "12:51:19" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "12:55:06" , 
"departure_time" : "12:55:54" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "13:01:48" , 
"departure_time" : "13:02:57" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "13:07:09" , 
"departure_time" : "13:08:05" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "13:11:56" , 
"departure_time" : "13:13:29" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "13:16:33" , 
"departure_time" : "13:17:15" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:30:42" , 
"departure_time" : "13:31:48" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "13:38:06" , 
"departure_time" : "13:39:06" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "13:53:00" , 
"departure_time" : "13:53:00" , 
"distance_traveled" : 57.9102
} ], 
"2911" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "13:14:00" , 
"departure_time" : "13:16:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:24:36" , 
"departure_time" : "13:26:13" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:33:37" , 
"departure_time" : "13:33:48" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:38:11" , 
"departure_time" : "13:39:44" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "13:42:33" , 
"departure_time" : "13:42:38" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "13:44:05" , 
"departure_time" : "13:45:44" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "13:52:39" , 
"departure_time" : "13:53:27" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "13:55:48" , 
"departure_time" : "13:56:37" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "14:01:49" , 
"departure_time" : "14:03:19" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "14:07:30" , 
"departure_time" : "14:09:10" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "14:12:40" , 
"departure_time" : "14:13:43" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "14:16:03" , 
"departure_time" : "14:16:16" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "14:30:13" , 
"departure_time" : "14:30:46" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "14:37:33" , 
"departure_time" : "14:38:52" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "14:49:19" , 
"departure_time" : "14:49:19" , 
"distance_traveled" : 57.9102
} ], 
"2912" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:15:00" , 
"departure_time" : "15:16:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:24:13" , 
"departure_time" : "15:24:45" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:33:32" , 
"departure_time" : "15:34:59" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "15:40:27" , 
"departure_time" : "15:41:32" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "15:43:05" , 
"departure_time" : "15:43:43" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "15:45:38" , 
"departure_time" : "15:45:45" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "15:52:07" , 
"departure_time" : "15:53:45" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "15:57:38" , 
"departure_time" : "15:57:53" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "16:02:15" , 
"departure_time" : "16:03:01" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "16:07:46" , 
"departure_time" : "16:08:20" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "16:12:34" , 
"departure_time" : "16:13:38" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "16:17:04" , 
"departure_time" : "16:18:15" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:32:11" , 
"departure_time" : "16:32:43" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "16:38:32" , 
"departure_time" : "16:38:56" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "16:48:24" , 
"departure_time" : "16:48:24" , 
"distance_traveled" : 57.9102
} ], 
"2913" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "21:14:00" , 
"departure_time" : "21:15:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:23:52" , 
"departure_time" : "21:24:18" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:32:26" , 
"departure_time" : "21:33:06" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "21:38:40" , 
"departure_time" : "21:39:57" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "21:42:17" , 
"departure_time" : "21:43:08" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "21:44:51" , 
"departure_time" : "21:46:23" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "21:52:32" , 
"departure_time" : "21:53:48" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "21:56:16" , 
"departure_time" : "21:56:23" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "22:01:07" , 
"departure_time" : "22:01:40" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "22:06:33" , 
"departure_time" : "22:06:45" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "22:11:12" , 
"departure_time" : "22:12:20" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "22:16:08" , 
"departure_time" : "22:17:18" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "22:31:10" , 
"departure_time" : "22:32:10" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "22:38:00" , 
"departure_time" : "22:38:26" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "22:48:26" , 
"departure_time" : "22:48:26" , 
"distance_traveled" : 57.9102
} ], 
"2914" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "23:14:00" , 
"departure_time" : "23:15:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:24:09" , 
"departure_time" : "23:24:28" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "23:32:19" , 
"departure_time" : "23:33:04" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "23:38:45" , 
"departure_time" : "23:39:37" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "23:41:52" , 
"departure_time" : "23:42:19" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "23:44:27" , 
"departure_time" : "23:45:07" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "23:51:40" , 
"departure_time" : "23:52:12" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "23:55:32" , 
"departure_time" : "23:56:28" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 83,
"arrival_time" : "24:01:56" , 
"departure_time" : "24:03:06" , 
"distance_traveled" : 24.5032
}, 
{ 
"stop_id" : 84,
"arrival_time" : "24:07:10" , 
"departure_time" : "24:07:49" , 
"distance_traveled" : 27.0941
}, 
{ 
"stop_id" : 38,
"arrival_time" : "24:11:39" , 
"departure_time" : "24:11:52" , 
"distance_traveled" : 30.1826
}, 
{ 
"stop_id" : 103,
"arrival_time" : "24:15:13" , 
"departure_time" : "24:16:14" , 
"distance_traveled" : 32.5494
}, 
{ 
"stop_id" : 125,
"arrival_time" : "24:31:01" , 
"departure_time" : "24:31:57" , 
"distance_traveled" : 48.2856
}, 
{ 
"stop_id" : 32905,
"arrival_time" : "24:37:56" , 
"departure_time" : "24:38:54" , 
"distance_traveled" : 54.2564
}, 
{ 
"stop_id" : 148,
"arrival_time" : "24:54:58" , 
"departure_time" : "24:54:58" , 
"distance_traveled" : 57.9102
} ], 
"2915" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "12:01:00" , 
"departure_time" : "12:03:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:11:36" , 
"departure_time" : "12:12:22" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:18:46" , 
"departure_time" : "12:20:15" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 109,
"arrival_time" : "12:25:29" , 
"departure_time" : "12:25:59" , 
"distance_traveled" : 14.3875
}, 
{ 
"stop_id" : 41,
"arrival_time" : "12:27:30" , 
"departure_time" : "12:29:09" , 
"distance_traveled" : 15.3631
}, 
{ 
"stop_id" : 70,
"arrival_time" : "12:34:39" , 
"departure_time" : "12:34:49" , 
"distance_traveled" : 18.6468
}, 
{ 
"stop_id" : 127,
"arrival_time" : "12:36:10" , 
"departure_time" : "12:36:10" , 
"distance_traveled" : 20.7053
} ], 
"2916" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "12:06:00" , 
"departure_time" : "12:06:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "12:13:06" , 
"departure_time" : "12:13:28" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "12:17:22" , 
"departure_time" : "12:18:28" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "12:24:06" , 
"departure_time" : "12:24:09" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "12:29:03" , 
"departure_time" : "12:29:19" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "12:33:16" , 
"departure_time" : "12:34:07" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "12:42:51" , 
"departure_time" : "12:43:55" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "12:48:04" , 
"departure_time" : "12:48:33" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "12:53:29" , 
"departure_time" : "12:54:56" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 127,
"arrival_time" : "13:01:27" , 
"departure_time" : "13:02:19" , 
"distance_traveled" : 30.1032
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:11:52" , 
"departure_time" : "13:13:03" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:18:11" , 
"departure_time" : "13:18:27" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:25:16" , 
"departure_time" : "13:25:45" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "13:38:29" , 
"departure_time" : "13:38:29" , 
"distance_traveled" : 50.8061
} ], 
"2917" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "17:03:00" , 
"departure_time" : "17:04:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "17:10:56" , 
"departure_time" : "17:12:36" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "17:16:40" , 
"departure_time" : "17:18:17" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "17:21:37" , 
"departure_time" : "17:22:17" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "17:26:40" , 
"departure_time" : "17:27:11" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "17:30:31" , 
"departure_time" : "17:31:58" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "17:41:27" , 
"departure_time" : "17:42:18" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "17:45:51" , 
"departure_time" : "17:45:56" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "17:50:05" , 
"departure_time" : "17:50:08" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "17:53:03" , 
"departure_time" : "17:54:29" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:01:26" , 
"departure_time" : "18:02:28" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:12:02" , 
"departure_time" : "18:12:26" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:17:24" , 
"departure_time" : "18:19:02" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:25:38" , 
"departure_time" : "18:27:09" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:38:31" , 
"departure_time" : "18:38:31" , 
"distance_traveled" : 50.8152
} ], 
"2918" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "18:03:00" , 
"departure_time" : "18:04:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "18:10:14" , 
"departure_time" : "18:11:16" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "18:16:02" , 
"departure_time" : "18:16:09" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "18:20:07" , 
"departure_time" : "18:21:39" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "18:27:32" , 
"departure_time" : "18:29:11" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "18:31:39" , 
"departure_time" : "18:33:07" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "18:41:28" , 
"departure_time" : "18:41:42" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "18:45:14" , 
"departure_time" : "18:45:31" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "18:50:17" , 
"departure_time" : "18:50:24" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "18:53:07" , 
"departure_time" : "18:54:30" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "19:01:23" , 
"departure_time" : "19:02:54" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:12:31" , 
"departure_time" : "19:12:58" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:17:27" , 
"departure_time" : "19:18:35" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:25:08" , 
"departure_time" : "19:25:18" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "19:37:10" , 
"departure_time" : "19:37:10" , 
"distance_traveled" : 50.8152
} ], 
"2919" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "12:06:00" , 
"departure_time" : "12:07:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "12:14:17" , 
"departure_time" : "12:15:35" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "12:18:18" , 
"departure_time" : "12:18:24" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "12:23:06" , 
"departure_time" : "12:24:33" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "12:30:27" , 
"departure_time" : "12:31:52" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "12:34:25" , 
"departure_time" : "12:36:02" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "12:43:37" , 
"departure_time" : "12:43:51" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "12:47:14" , 
"departure_time" : "12:48:25" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "12:54:11" , 
"departure_time" : "12:55:29" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 127,
"arrival_time" : "13:01:18" , 
"departure_time" : "13:02:05" , 
"distance_traveled" : 30.1032
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:11:47" , 
"departure_time" : "13:12:40" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:17:53" , 
"departure_time" : "13:19:15" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:26:22" , 
"departure_time" : "13:27:23" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "13:39:01" , 
"departure_time" : "13:39:01" , 
"distance_traveled" : 50.8061
} ], 
"2920" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "10:04:00" , 
"departure_time" : "10:05:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "10:11:49" , 
"departure_time" : "10:13:03" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "10:17:14" , 
"departure_time" : "10:17:31" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "10:21:17" , 
"departure_time" : "10:22:48" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "10:28:31" , 
"departure_time" : "10:29:21" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "10:31:50" , 
"departure_time" : "10:32:46" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "10:41:56" , 
"departure_time" : "10:43:17" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "10:47:21" , 
"departure_time" : "10:48:12" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "10:51:51" , 
"departure_time" : "10:52:35" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 127,
"arrival_time" : "11:00:44" , 
"departure_time" : "11:01:56" , 
"distance_traveled" : 30.1032
}, 
{ 
"stop_id" : 70,
"arrival_time" : "11:05:12" , 
"departure_time" : "11:06:14" , 
"distance_traveled" : 32.1617
}, 
{ 
"stop_id" : 41,
"arrival_time" : "11:12:02" , 
"departure_time" : "11:12:39" , 
"distance_traveled" : 35.4453
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "11:15:37" , 
"departure_time" : "11:17:02" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:23:25" , 
"departure_time" : "11:24:06" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:29:41" , 
"departure_time" : "11:30:09" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "11:42:28" , 
"departure_time" : "11:42:28" , 
"distance_traveled" : 50.8061
} ], 
"2921" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "17:03:00" , 
"departure_time" : "17:03:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "17:10:29" , 
"departure_time" : "17:10:49" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "17:15:20" , 
"departure_time" : "17:16:01" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "17:20:41" , 
"departure_time" : "17:21:51" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "17:27:10" , 
"departure_time" : "17:27:22" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "17:30:12" , 
"departure_time" : "17:31:29" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "17:41:17" , 
"departure_time" : "17:42:04" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "17:45:47" , 
"departure_time" : "17:47:08" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "17:51:21" , 
"departure_time" : "17:52:10" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "17:53:49" , 
"departure_time" : "17:55:12" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:01:23" , 
"departure_time" : "18:02:16" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:11:53" , 
"departure_time" : "18:12:49" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:17:56" , 
"departure_time" : "18:19:35" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:25:39" , 
"departure_time" : "18:26:02" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:37:23" , 
"departure_time" : "18:37:23" , 
"distance_traveled" : 50.8152
} ], 
"2922" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "14:04:00" , 
"departure_time" : "14:05:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "14:12:16" , 
"departure_time" : "14:13:35" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "14:17:19" , 
"departure_time" : "14:17:45" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "14:21:26" , 
"departure_time" : "14:22:51" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "14:28:25" , 
"departure_time" : "14:29:49" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "14:32:24" , 
"departure_time" : "14:33:02" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "14:41:38" , 
"departure_time" : "14:42:06" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "14:46:28" , 
"departure_time" : "14:46:40" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "14:51:12" , 
"departure_time" : "14:51:28" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 127,
"arrival_time" : "15:00:16" , 
"departure_time" : "15:01:26" , 
"distance_traveled" : 30.1032
}, 
{ 
"stop_id" : 70,
"arrival_time" : "15:05:10" , 
"departure_time" : "15:05:22" , 
"distance_traveled" : 32.1617
}, 
{ 
"stop_id" : 41,
"arrival_time" : "15:11:12" , 
"departure_time" : "15:12:08" , 
"distance_traveled" : 35.4453
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "15:15:56" , 
"departure_time" : "15:17:18" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:23:22" , 
"departure_time" : "15:23:30" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:29:08" , 
"departure_time" : "15:29:58" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "15:42:50" , 
"departure_time" : "15:42:50" , 
"distance_traveled" : 50.8061
} ], 
"2923" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "18:03:00" , 
"departure_time" : "18:04:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "18:10:44" , 
"departure_time" : "18:11:33" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "18:15:49" , 
"departure_time" : "18:16:39" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "18:20:50" , 
"departure_time" : "18:22:04" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "18:27:14" , 
"departure_time" : "18:27:55" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "18:30:41" , 
"departure_time" : "18:32:19" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "18:41:38" , 
"departure_time" : "18:42:39" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "18:46:01" , 
"departure_time" : "18:46:23" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "18:50:22" , 
"departure_time" : "18:50:38" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "18:53:16" , 
"departure_time" : "18:53:19" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "19:00:03" , 
"departure_time" : "19:01:12" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:12:09" , 
"departure_time" : "19:12:50" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:17:41" , 
"departure_time" : "19:19:03" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:25:22" , 
"departure_time" : "19:25:55" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "19:37:33" , 
"departure_time" : "19:37:33" , 
"distance_traveled" : 50.8152
} ], 
"2924" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "09:04:00" , 
"departure_time" : "09:05:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "09:10:33" , 
"departure_time" : "09:11:46" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "09:16:13" , 
"departure_time" : "09:16:18" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "09:20:05" , 
"departure_time" : "09:21:18" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "09:27:13" , 
"departure_time" : "09:27:24" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "09:30:11" , 
"departure_time" : "09:30:23" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "09:40:12" , 
"departure_time" : "09:41:34" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "09:46:22" , 
"departure_time" : "09:46:48" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "09:50:26" , 
"departure_time" : "09:50:49" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "09:53:23" , 
"departure_time" : "09:53:38" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "10:00:15" , 
"departure_time" : "10:01:50" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "10:05:35" , 
"departure_time" : "10:06:30" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "10:11:55" , 
"departure_time" : "10:12:02" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:15:07" , 
"departure_time" : "10:15:11" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:22:04" , 
"departure_time" : "10:23:42" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:30:38" , 
"departure_time" : "10:30:57" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:41:19" , 
"departure_time" : "10:41:19" , 
"distance_traveled" : 50.8152
} ], 
"2925" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "10:04:00" , 
"departure_time" : "10:05:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "10:12:34" , 
"departure_time" : "10:12:38" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "10:16:04" , 
"departure_time" : "10:16:53" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "10:21:49" , 
"departure_time" : "10:22:57" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "10:28:08" , 
"departure_time" : "10:28:46" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "10:31:38" , 
"departure_time" : "10:32:37" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "10:41:59" , 
"departure_time" : "10:42:56" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "10:46:57" , 
"departure_time" : "10:47:17" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "10:51:20" , 
"departure_time" : "10:51:58" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 127,
"arrival_time" : "11:00:38" , 
"departure_time" : "11:01:51" , 
"distance_traveled" : 30.1032
}, 
{ 
"stop_id" : 70,
"arrival_time" : "11:05:13" , 
"departure_time" : "11:06:24" , 
"distance_traveled" : 32.1617
}, 
{ 
"stop_id" : 41,
"arrival_time" : "11:12:11" , 
"departure_time" : "11:12:15" , 
"distance_traveled" : 35.4453
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "11:15:04" , 
"departure_time" : "11:16:33" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:23:29" , 
"departure_time" : "11:25:04" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:30:35" , 
"departure_time" : "11:31:30" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "11:42:55" , 
"departure_time" : "11:42:55" , 
"distance_traveled" : 50.8061
} ], 
"2926" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "11:03:00" , 
"departure_time" : "11:04:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "11:11:02" , 
"departure_time" : "11:11:20" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "11:15:18" , 
"departure_time" : "11:15:46" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "11:20:28" , 
"departure_time" : "11:21:42" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "11:27:14" , 
"departure_time" : "11:27:52" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "11:30:38" , 
"departure_time" : "11:31:12" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "11:40:34" , 
"departure_time" : "11:41:22" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "11:45:48" , 
"departure_time" : "11:46:55" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "11:51:07" , 
"departure_time" : "11:51:32" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "11:53:25" , 
"departure_time" : "11:54:11" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "12:00:46" , 
"departure_time" : "12:01:25" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "12:04:39" , 
"departure_time" : "12:05:08" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "12:11:29" , 
"departure_time" : "12:12:08" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "12:15:39" , 
"departure_time" : "12:15:46" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:22:07" , 
"departure_time" : "12:22:26" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:29:19" , 
"departure_time" : "12:30:54" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "12:43:35" , 
"departure_time" : "12:43:35" , 
"distance_traveled" : 50.8152
} ], 
"2927" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "14:04:00" , 
"departure_time" : "14:06:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "14:12:07" , 
"departure_time" : "14:13:45" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "14:17:38" , 
"departure_time" : "14:19:08" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "14:22:30" , 
"departure_time" : "14:23:57" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "14:28:27" , 
"departure_time" : "14:29:25" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "14:31:58" , 
"departure_time" : "14:32:41" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "14:41:43" , 
"departure_time" : "14:43:18" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "14:47:35" , 
"departure_time" : "14:48:59" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "14:52:24" , 
"departure_time" : "14:52:45" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 127,
"arrival_time" : "15:00:21" , 
"departure_time" : "15:01:09" , 
"distance_traveled" : 30.1032
}, 
{ 
"stop_id" : 70,
"arrival_time" : "15:04:48" , 
"departure_time" : "15:05:19" , 
"distance_traveled" : 32.1617
}, 
{ 
"stop_id" : 41,
"arrival_time" : "15:11:31" , 
"departure_time" : "15:12:30" , 
"distance_traveled" : 35.4453
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "15:15:59" , 
"departure_time" : "15:16:46" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:22:47" , 
"departure_time" : "15:24:08" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:30:21" , 
"departure_time" : "15:31:57" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "15:43:36" , 
"departure_time" : "15:43:36" , 
"distance_traveled" : 50.8061
} ], 
"2928" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "13:14:00" , 
"departure_time" : "13:16:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "13:22:05" , 
"departure_time" : "13:22:58" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "13:26:53" , 
"departure_time" : "13:27:07" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "13:31:14" , 
"departure_time" : "13:32:35" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "13:38:21" , 
"departure_time" : "13:39:27" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "13:42:06" , 
"departure_time" : "13:43:41" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "13:52:35" , 
"departure_time" : "13:52:49" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "13:56:14" , 
"departure_time" : "13:56:52" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "14:01:38" , 
"departure_time" : "14:03:04" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "14:05:26" , 
"departure_time" : "14:06:22" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "14:11:56" , 
"departure_time" : "14:12:17" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "14:15:21" , 
"departure_time" : "14:15:45" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "14:22:24" , 
"departure_time" : "14:23:16" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "14:27:52" , 
"departure_time" : "14:29:27" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:34:35" , 
"departure_time" : "14:35:40" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:41:05" , 
"departure_time" : "14:42:37" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "14:54:32" , 
"departure_time" : "14:54:32" , 
"distance_traveled" : 50.8152
} ], 
"2929" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "09:04:00" , 
"departure_time" : "09:06:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "09:10:43" , 
"departure_time" : "09:12:04" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "09:16:21" , 
"departure_time" : "09:16:54" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "09:20:33" , 
"departure_time" : "09:21:55" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "09:27:22" , 
"departure_time" : "09:28:16" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "09:30:54" , 
"departure_time" : "09:32:21" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "09:41:27" , 
"departure_time" : "09:42:52" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "09:46:25" , 
"departure_time" : "09:47:21" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "09:50:56" , 
"departure_time" : "09:51:23" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "09:53:27" , 
"departure_time" : "09:54:13" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "10:00:46" , 
"departure_time" : "10:02:13" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "10:05:27" , 
"departure_time" : "10:06:05" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "10:11:38" , 
"departure_time" : "10:12:48" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:16:10" , 
"departure_time" : "10:17:38" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:23:28" , 
"departure_time" : "10:24:32" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:30:04" , 
"departure_time" : "10:31:19" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:42:15" , 
"departure_time" : "10:42:15" , 
"distance_traveled" : 50.8152
} ], 
"2930" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "19:14:00" , 
"departure_time" : "19:15:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "19:20:21" , 
"departure_time" : "19:20:39" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "19:24:18" , 
"departure_time" : "19:25:36" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "19:31:18" , 
"departure_time" : "19:31:40" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "19:36:22" , 
"departure_time" : "19:37:58" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "19:41:36" , 
"departure_time" : "19:42:11" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "19:49:35" , 
"departure_time" : "19:50:29" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "19:54:54" , 
"departure_time" : "19:56:32" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "20:01:38" , 
"departure_time" : "20:02:08" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "20:03:30" , 
"departure_time" : "20:03:49" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:09:19" , 
"departure_time" : "20:10:33" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "20:14:14" , 
"departure_time" : "20:15:12" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "20:20:58" , 
"departure_time" : "20:21:50" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:25:52" , 
"departure_time" : "20:26:15" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:31:23" , 
"departure_time" : "20:32:44" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:39:21" , 
"departure_time" : "20:39:40" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "20:51:19" , 
"departure_time" : "20:51:19" , 
"distance_traveled" : 50.8152
} ], 
"2931" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "11:03:00" , 
"departure_time" : "11:03:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "11:10:25" , 
"departure_time" : "11:10:34" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "11:15:09" , 
"departure_time" : "11:15:11" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "11:20:02" , 
"departure_time" : "11:20:55" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "11:26:53" , 
"departure_time" : "11:28:07" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "11:31:14" , 
"departure_time" : "11:32:30" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "11:41:16" , 
"departure_time" : "11:42:21" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "11:46:05" , 
"departure_time" : "11:46:14" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "11:50:09" , 
"departure_time" : "11:50:55" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "11:53:46" , 
"departure_time" : "11:54:32" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "12:00:46" , 
"departure_time" : "12:02:23" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "12:05:37" , 
"departure_time" : "12:07:08" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "12:12:31" , 
"departure_time" : "12:14:04" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "12:16:33" , 
"departure_time" : "12:16:36" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:22:03" , 
"departure_time" : "12:23:22" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:30:19" , 
"departure_time" : "12:30:36" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "12:42:17" , 
"departure_time" : "12:42:17" , 
"distance_traveled" : 50.8152
} ], 
"2932" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "21:14:00" , 
"departure_time" : "21:15:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "21:20:53" , 
"departure_time" : "21:22:30" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "21:25:37" , 
"departure_time" : "21:25:38" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "21:30:01" , 
"departure_time" : "21:30:37" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "21:36:36" , 
"departure_time" : "21:36:42" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "21:40:06" , 
"departure_time" : "21:41:29" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "21:50:23" , 
"departure_time" : "21:50:55" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "21:54:32" , 
"departure_time" : "21:56:00" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "22:01:28" , 
"departure_time" : "22:03:04" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "22:04:36" , 
"departure_time" : "22:04:49" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "22:09:13" , 
"departure_time" : "22:10:16" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "22:14:03" , 
"departure_time" : "22:15:06" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "22:21:03" , 
"departure_time" : "22:21:29" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:25:26" , 
"departure_time" : "22:25:52" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:31:26" , 
"departure_time" : "22:32:03" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:38:37" , 
"departure_time" : "22:39:18" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "22:51:41" , 
"departure_time" : "22:51:41" , 
"distance_traveled" : 50.8152
} ], 
"2933" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "13:14:00" , 
"departure_time" : "13:16:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "13:22:27" , 
"departure_time" : "13:24:01" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "13:27:34" , 
"departure_time" : "13:28:03" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "13:31:29" , 
"departure_time" : "13:32:54" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "13:38:25" , 
"departure_time" : "13:39:38" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "13:42:13" , 
"departure_time" : "13:42:40" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "13:51:27" , 
"departure_time" : "13:52:53" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "13:57:26" , 
"departure_time" : "13:58:17" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "14:01:51" , 
"departure_time" : "14:03:22" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "14:05:31" , 
"departure_time" : "14:06:30" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "14:11:59" , 
"departure_time" : "14:12:14" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "14:15:15" , 
"departure_time" : "14:16:30" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "14:23:15" , 
"departure_time" : "14:23:25" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "14:27:10" , 
"departure_time" : "14:28:13" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:34:03" , 
"departure_time" : "14:34:49" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:40:46" , 
"departure_time" : "14:41:16" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "14:53:30" , 
"departure_time" : "14:53:30" , 
"distance_traveled" : 50.8152
} ], 
"2934" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "20:09:00" , 
"departure_time" : "20:09:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "20:16:04" , 
"departure_time" : "20:17:24" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "20:22:20" , 
"departure_time" : "20:22:54" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "20:26:34" , 
"departure_time" : "20:27:52" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "20:33:18" , 
"departure_time" : "20:33:54" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "20:36:36" , 
"departure_time" : "20:38:13" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "20:47:37" , 
"departure_time" : "20:47:42" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "20:51:05" , 
"departure_time" : "20:52:31" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "20:57:26" , 
"departure_time" : "20:58:08" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 127,
"arrival_time" : "21:05:42" , 
"departure_time" : "21:06:42" , 
"distance_traveled" : 30.1032
}, 
{ 
"stop_id" : 70,
"arrival_time" : "21:10:00" , 
"departure_time" : "21:10:05" , 
"distance_traveled" : 32.1617
}, 
{ 
"stop_id" : 41,
"arrival_time" : "21:16:05" , 
"departure_time" : "21:17:24" , 
"distance_traveled" : 35.4453
}, 
{ 
"stop_id" : 109,
"arrival_time" : "21:20:19" , 
"departure_time" : "21:20:23" , 
"distance_traveled" : 36.421
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "21:22:04" , 
"departure_time" : "21:22:40" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:29:36" , 
"departure_time" : "21:29:52" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:36:16" , 
"departure_time" : "21:37:52" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "21:50:36" , 
"departure_time" : "21:50:36" , 
"distance_traveled" : 50.8061
} ], 
"2935" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "19:14:00" , 
"departure_time" : "19:16:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "19:21:01" , 
"departure_time" : "19:21:34" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "19:24:33" , 
"departure_time" : "19:24:35" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "19:30:02" , 
"departure_time" : "19:30:28" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "19:36:26" , 
"departure_time" : "19:37:42" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "19:41:16" , 
"departure_time" : "19:41:58" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "19:49:42" , 
"departure_time" : "19:49:52" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "19:54:10" , 
"departure_time" : "19:55:10" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "20:01:00" , 
"departure_time" : "20:01:27" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "20:03:27" , 
"departure_time" : "20:03:36" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:09:09" , 
"departure_time" : "20:09:59" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "20:13:50" , 
"departure_time" : "20:14:29" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "20:20:39" , 
"departure_time" : "20:21:13" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:25:34" , 
"departure_time" : "20:25:42" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:31:08" , 
"departure_time" : "20:31:16" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:38:08" , 
"departure_time" : "20:38:40" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "20:51:32" , 
"departure_time" : "20:51:32" , 
"distance_traveled" : 50.8152
} ], 
"2936" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "22:04:00" , 
"departure_time" : "22:05:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "22:11:25" , 
"departure_time" : "22:12:33" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "22:16:08" , 
"departure_time" : "22:16:14" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "22:20:06" , 
"departure_time" : "22:20:22" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "22:26:16" , 
"departure_time" : "22:27:49" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "22:31:33" , 
"departure_time" : "22:33:04" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "22:41:31" , 
"departure_time" : "22:42:37" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "22:46:06" , 
"departure_time" : "22:46:08" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "22:50:02" , 
"departure_time" : "22:51:13" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 127,
"arrival_time" : "22:59:11" , 
"departure_time" : "22:59:25" , 
"distance_traveled" : 30.1032
}, 
{ 
"stop_id" : 70,
"arrival_time" : "23:02:14" , 
"departure_time" : "23:02:34" , 
"distance_traveled" : 32.1617
}, 
{ 
"stop_id" : 41,
"arrival_time" : "23:09:20" , 
"departure_time" : "23:10:52" , 
"distance_traveled" : 35.4453
}, 
{ 
"stop_id" : 109,
"arrival_time" : "23:13:32" , 
"departure_time" : "23:14:05" , 
"distance_traveled" : 36.421
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "23:15:33" , 
"departure_time" : "23:16:18" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "23:22:45" , 
"departure_time" : "23:23:47" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:30:02" , 
"departure_time" : "23:30:16" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "23:42:14" , 
"departure_time" : "23:42:14" , 
"distance_traveled" : 50.8061
} ], 
"2937" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "21:14:00" , 
"departure_time" : "21:14:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "21:20:05" , 
"departure_time" : "21:20:55" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "21:24:50" , 
"departure_time" : "21:25:57" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "21:31:07" , 
"departure_time" : "21:32:18" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "21:37:11" , 
"departure_time" : "21:38:50" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "21:41:39" , 
"departure_time" : "21:42:28" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "21:49:49" , 
"departure_time" : "21:51:26" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "21:55:37" , 
"departure_time" : "21:55:43" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "22:00:06" , 
"departure_time" : "22:00:07" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "22:03:01" , 
"departure_time" : "22:04:38" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "22:10:37" , 
"departure_time" : "22:10:52" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "22:13:15" , 
"departure_time" : "22:14:41" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "22:21:26" , 
"departure_time" : "22:22:57" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:26:31" , 
"departure_time" : "22:27:42" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:32:11" , 
"departure_time" : "22:33:36" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:39:25" , 
"departure_time" : "22:40:44" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "22:52:19" , 
"departure_time" : "22:52:19" , 
"distance_traveled" : 50.8152
} ], 
"2938" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "24:19:00" , 
"departure_time" : "24:21:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "24:26:05" , 
"departure_time" : "24:26:55" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "24:30:50" , 
"departure_time" : "24:32:23" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "24:36:33" , 
"departure_time" : "24:36:39" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "24:41:06" , 
"departure_time" : "24:41:30" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "24:45:24" , 
"departure_time" : "24:46:06" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "24:55:42" , 
"departure_time" : "24:56:27" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "25:00:45" , 
"departure_time" : "25:01:47" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "25:06:02" , 
"departure_time" : "25:06:10" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "25:08:08" , 
"departure_time" : "25:09:01" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "25:15:53" , 
"departure_time" : "25:17:15" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "25:20:22" , 
"departure_time" : "25:21:25" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "25:26:03" , 
"departure_time" : "25:27:39" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 109,
"arrival_time" : "25:29:36" , 
"departure_time" : "25:30:27" , 
"distance_traveled" : 36.4301
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "25:31:51" , 
"departure_time" : "25:33:07" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "25:38:16" , 
"departure_time" : "25:38:24" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "25:45:08" , 
"departure_time" : "25:45:46" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "26:03:38" , 
"departure_time" : "26:03:38" , 
"distance_traveled" : 50.8152
} ], 
"2939" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "20:09:00" , 
"departure_time" : "20:10:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "20:16:41" , 
"departure_time" : "20:17:50" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "20:22:09" , 
"departure_time" : "20:22:37" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "20:26:28" , 
"departure_time" : "20:27:23" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "20:32:55" , 
"departure_time" : "20:34:33" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "20:37:38" , 
"departure_time" : "20:37:40" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "20:46:02" , 
"departure_time" : "20:46:15" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "20:51:13" , 
"departure_time" : "20:51:21" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "20:56:08" , 
"departure_time" : "20:57:40" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 127,
"arrival_time" : "21:06:32" , 
"departure_time" : "21:06:43" , 
"distance_traveled" : 30.1032
}, 
{ 
"stop_id" : 70,
"arrival_time" : "21:09:11" , 
"departure_time" : "21:09:30" , 
"distance_traveled" : 32.1617
}, 
{ 
"stop_id" : 41,
"arrival_time" : "21:16:19" , 
"departure_time" : "21:17:43" , 
"distance_traveled" : 35.4453
}, 
{ 
"stop_id" : 109,
"arrival_time" : "21:20:24" , 
"departure_time" : "21:21:21" , 
"distance_traveled" : 36.421
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "21:22:57" , 
"departure_time" : "21:23:26" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:29:29" , 
"departure_time" : "21:31:03" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:37:34" , 
"departure_time" : "21:38:58" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "21:50:24" , 
"departure_time" : "21:50:24" , 
"distance_traveled" : 50.8061
} ], 
"2940" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "24:19:00" , 
"departure_time" : "24:21:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "24:26:18" , 
"departure_time" : "24:26:36" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "24:30:18" , 
"departure_time" : "24:31:03" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "24:35:45" , 
"departure_time" : "24:37:18" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "24:42:33" , 
"departure_time" : "24:44:05" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "24:46:32" , 
"departure_time" : "24:47:24" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "24:55:52" , 
"departure_time" : "24:57:17" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "25:01:25" , 
"departure_time" : "25:01:42" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "25:05:17" , 
"departure_time" : "25:05:51" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "25:08:34" , 
"departure_time" : "25:09:40" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "25:16:06" , 
"departure_time" : "25:17:09" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "25:20:03" , 
"departure_time" : "25:20:18" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "25:25:15" , 
"departure_time" : "25:25:28" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 109,
"arrival_time" : "25:28:13" , 
"departure_time" : "25:28:34" , 
"distance_traveled" : 36.4301
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "25:31:21" , 
"departure_time" : "25:32:50" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "25:38:29" , 
"departure_time" : "25:39:33" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "25:46:04" , 
"departure_time" : "25:46:42" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "26:03:38" , 
"departure_time" : "26:03:38" , 
"distance_traveled" : 50.8152
} ], 
"2941" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "22:04:00" , 
"departure_time" : "22:05:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "22:11:19" , 
"departure_time" : "22:12:29" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "22:16:10" , 
"departure_time" : "22:17:37" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "22:21:27" , 
"departure_time" : "22:23:01" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "22:27:34" , 
"departure_time" : "22:28:39" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "22:31:05" , 
"departure_time" : "22:31:11" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "22:40:06" , 
"departure_time" : "22:41:16" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "22:46:10" , 
"departure_time" : "22:47:42" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "22:51:32" , 
"departure_time" : "22:52:51" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 127,
"arrival_time" : "22:59:19" , 
"departure_time" : "22:59:23" , 
"distance_traveled" : 30.1032
}, 
{ 
"stop_id" : 70,
"arrival_time" : "23:02:04" , 
"departure_time" : "23:02:14" , 
"distance_traveled" : 32.1617
}, 
{ 
"stop_id" : 41,
"arrival_time" : "23:09:10" , 
"departure_time" : "23:10:04" , 
"distance_traveled" : 35.4453
}, 
{ 
"stop_id" : 109,
"arrival_time" : "23:12:54" , 
"departure_time" : "23:13:03" , 
"distance_traveled" : 36.421
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "23:15:09" , 
"departure_time" : "23:15:25" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "23:22:16" , 
"departure_time" : "23:23:46" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:30:30" , 
"departure_time" : "23:31:15" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "23:42:45" , 
"departure_time" : "23:42:45" , 
"distance_traveled" : 50.8061
} ], 
"2942" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "04:46:00" , 
"departure_time" : "04:47:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "04:52:46" , 
"departure_time" : "04:53:50" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "04:58:04" , 
"departure_time" : "04:58:19" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "05:02:15" , 
"departure_time" : "05:02:57" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "05:08:42" , 
"departure_time" : "05:09:02" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "05:12:20" , 
"departure_time" : "05:12:39" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "05:22:19" , 
"departure_time" : "05:23:09" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "05:27:50" , 
"departure_time" : "05:28:21" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "05:32:31" , 
"departure_time" : "05:33:59" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "05:36:28" , 
"departure_time" : "05:37:56" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "05:43:28" , 
"departure_time" : "05:44:27" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "05:46:59" , 
"departure_time" : "05:48:11" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "05:54:12" , 
"departure_time" : "05:55:14" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 109,
"arrival_time" : "05:57:02" , 
"departure_time" : "05:58:14" , 
"distance_traveled" : 36.4301
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "06:01:12" , 
"departure_time" : "06:01:31" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:06:19" , 
"departure_time" : "06:07:40" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:14:21" , 
"departure_time" : "06:15:43" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:28:22" , 
"departure_time" : "06:28:22" , 
"distance_traveled" : 50.8152
} ], 
"2943" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "24:19:00" , 
"departure_time" : "24:21:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "24:26:22" , 
"departure_time" : "24:26:42" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "24:30:20" , 
"departure_time" : "24:30:40" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "24:35:20" , 
"departure_time" : "24:36:56" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "24:42:36" , 
"departure_time" : "24:42:53" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "24:45:17" , 
"departure_time" : "24:45:34" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "24:55:17" , 
"departure_time" : "24:56:48" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "25:01:31" , 
"departure_time" : "25:02:05" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "25:05:34" , 
"departure_time" : "25:07:00" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "25:09:26" , 
"departure_time" : "25:09:58" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "25:15:32" , 
"departure_time" : "25:17:08" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "25:20:36" , 
"departure_time" : "25:21:19" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "25:25:43" , 
"departure_time" : "25:26:48" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 109,
"arrival_time" : "25:29:05" , 
"departure_time" : "25:29:47" , 
"distance_traveled" : 36.4301
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "25:31:42" , 
"departure_time" : "25:32:19" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "25:37:37" , 
"departure_time" : "25:38:24" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "25:45:47" , 
"departure_time" : "25:47:17" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "26:04:30" , 
"departure_time" : "26:04:30" , 
"distance_traveled" : 50.8152
} ], 
"2944" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "06:02:00" , 
"departure_time" : "06:04:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "06:09:26" , 
"departure_time" : "06:10:04" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "06:13:38" , 
"departure_time" : "06:14:10" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "06:18:32" , 
"departure_time" : "06:19:17" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "06:24:45" , 
"departure_time" : "06:25:13" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "06:28:28" , 
"departure_time" : "06:30:07" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "06:39:39" , 
"departure_time" : "06:40:09" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "06:43:30" , 
"departure_time" : "06:43:45" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "06:48:15" , 
"departure_time" : "06:48:46" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "06:51:31" , 
"departure_time" : "06:52:25" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "06:58:54" , 
"departure_time" : "07:00:30" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "07:03:36" , 
"departure_time" : "07:04:06" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "07:09:30" , 
"departure_time" : "07:10:11" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 109,
"arrival_time" : "07:12:41" , 
"departure_time" : "07:13:22" , 
"distance_traveled" : 36.4301
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "07:15:41" , 
"departure_time" : "07:16:15" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:22:34" , 
"departure_time" : "07:22:35" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:29:01" , 
"departure_time" : "07:29:48" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:42:47" , 
"departure_time" : "07:42:47" , 
"distance_traveled" : 50.8152
} ], 
"2945" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "07:02:00" , 
"departure_time" : "07:03:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "07:08:45" , 
"departure_time" : "07:09:04" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "07:13:19" , 
"departure_time" : "07:13:37" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "07:18:18" , 
"departure_time" : "07:19:02" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "07:24:44" , 
"departure_time" : "07:25:48" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "07:29:04" , 
"departure_time" : "07:30:17" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "07:39:13" , 
"departure_time" : "07:40:35" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "07:44:22" , 
"departure_time" : "07:45:38" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "07:49:16" , 
"departure_time" : "07:50:16" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "07:52:00" , 
"departure_time" : "07:53:37" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "07:59:37" , 
"departure_time" : "08:00:58" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "08:03:21" , 
"departure_time" : "08:04:48" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "08:10:27" , 
"departure_time" : "08:11:40" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 109,
"arrival_time" : "08:13:13" , 
"departure_time" : "08:14:28" , 
"distance_traveled" : 36.4301
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:16:15" , 
"departure_time" : "08:16:38" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:22:23" , 
"departure_time" : "08:22:44" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:29:21" , 
"departure_time" : "08:30:33" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:43:12" , 
"departure_time" : "08:43:12" , 
"distance_traveled" : 50.8152
} ], 
"2946" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "04:46:00" , 
"departure_time" : "04:47:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "04:52:24" , 
"departure_time" : "04:53:13" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "04:57:49" , 
"departure_time" : "04:59:06" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "05:03:17" , 
"departure_time" : "05:04:07" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "05:08:50" , 
"departure_time" : "05:09:10" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "05:12:20" , 
"departure_time" : "05:13:37" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "05:23:17" , 
"departure_time" : "05:24:27" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "05:28:10" , 
"departure_time" : "05:29:23" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "05:33:13" , 
"departure_time" : "05:33:16" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "05:35:03" , 
"departure_time" : "05:35:04" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "05:42:01" , 
"departure_time" : "05:43:09" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "05:47:08" , 
"departure_time" : "05:48:14" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "05:54:06" , 
"departure_time" : "05:54:26" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 109,
"arrival_time" : "05:56:20" , 
"departure_time" : "05:56:55" , 
"distance_traveled" : 36.4301
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "06:00:35" , 
"departure_time" : "06:01:37" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:07:02" , 
"departure_time" : "06:08:28" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:14:26" , 
"departure_time" : "06:15:23" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:27:57" , 
"departure_time" : "06:27:57" , 
"distance_traveled" : 50.8152
} ], 
"2947" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "15:01:00" , 
"departure_time" : "15:01:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "15:08:02" , 
"departure_time" : "15:08:27" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "15:13:25" , 
"departure_time" : "15:14:27" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "15:19:02" , 
"departure_time" : "15:19:03" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "15:24:01" , 
"departure_time" : "15:24:07" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "15:28:06" , 
"departure_time" : "15:29:28" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "15:39:22" , 
"departure_time" : "15:40:38" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "15:44:16" , 
"departure_time" : "15:45:47" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "15:49:31" , 
"departure_time" : "15:50:41" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "15:52:10" , 
"departure_time" : "15:52:15" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "15:58:05" , 
"departure_time" : "15:59:33" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "16:03:28" , 
"departure_time" : "16:04:33" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "16:10:05" , 
"departure_time" : "16:11:40" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 109,
"arrival_time" : "16:13:35" , 
"departure_time" : "16:14:53" , 
"distance_traveled" : 36.4301
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:16:18" , 
"departure_time" : "16:16:38" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:22:20" , 
"departure_time" : "16:22:55" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:30:35" , 
"departure_time" : "16:31:35" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "16:44:00" , 
"departure_time" : "16:44:00" , 
"distance_traveled" : 50.8152
} ], 
"2948" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "06:02:00" , 
"departure_time" : "06:03:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "06:08:31" , 
"departure_time" : "06:09:33" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "06:14:02" , 
"departure_time" : "06:15:26" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "06:19:24" , 
"departure_time" : "06:19:33" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "06:24:09" , 
"departure_time" : "06:25:00" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "06:28:51" , 
"departure_time" : "06:29:43" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "06:38:52" , 
"departure_time" : "06:39:38" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "06:43:46" , 
"departure_time" : "06:44:00" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "06:48:14" , 
"departure_time" : "06:48:48" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "06:51:34" , 
"departure_time" : "06:52:49" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "06:59:15" , 
"departure_time" : "06:59:55" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "07:02:40" , 
"departure_time" : "07:04:11" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "07:10:31" , 
"departure_time" : "07:11:48" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 109,
"arrival_time" : "07:13:17" , 
"departure_time" : "07:13:22" , 
"distance_traveled" : 36.4301
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "07:15:05" , 
"departure_time" : "07:16:09" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:23:04" , 
"departure_time" : "07:24:19" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:30:15" , 
"departure_time" : "07:31:34" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:43:19" , 
"departure_time" : "07:43:19" , 
"distance_traveled" : 50.8152
} ], 
"2949" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "16:01:00" , 
"departure_time" : "16:02:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "16:08:32" , 
"departure_time" : "16:08:38" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "16:13:06" , 
"departure_time" : "16:13:45" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "16:18:39" , 
"departure_time" : "16:19:41" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "16:25:02" , 
"departure_time" : "16:25:21" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "16:28:19" , 
"departure_time" : "16:29:57" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "16:39:38" , 
"departure_time" : "16:41:09" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "16:44:31" , 
"departure_time" : "16:44:59" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "16:48:28" , 
"departure_time" : "16:49:24" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "16:51:56" , 
"departure_time" : "16:53:03" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "16:59:07" , 
"departure_time" : "16:59:57" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "17:02:50" , 
"departure_time" : "17:03:48" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "17:09:58" , 
"departure_time" : "17:10:49" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 109,
"arrival_time" : "17:12:51" , 
"departure_time" : "17:13:37" , 
"distance_traveled" : 36.4301
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:15:46" , 
"departure_time" : "17:17:01" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:23:15" , 
"departure_time" : "17:23:57" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:30:42" , 
"departure_time" : "17:32:15" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "17:44:33" , 
"departure_time" : "17:44:33" , 
"distance_traveled" : 50.8152
} ], 
"2950" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "07:02:00" , 
"departure_time" : "07:05:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "07:09:38" , 
"departure_time" : "07:11:13" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "07:14:35" , 
"departure_time" : "07:15:09" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "07:18:34" , 
"departure_time" : "07:20:10" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "07:25:36" , 
"departure_time" : "07:26:27" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "07:28:51" , 
"departure_time" : "07:29:31" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "07:38:40" , 
"departure_time" : "07:38:48" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "07:43:08" , 
"departure_time" : "07:43:42" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "07:48:34" , 
"departure_time" : "07:49:11" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "07:51:37" , 
"departure_time" : "07:51:55" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "07:58:18" , 
"departure_time" : "07:58:59" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "08:02:41" , 
"departure_time" : "08:03:21" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "08:09:40" , 
"departure_time" : "08:10:42" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 109,
"arrival_time" : "08:13:02" , 
"departure_time" : "08:13:25" , 
"distance_traveled" : 36.4301
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:15:23" , 
"departure_time" : "08:15:53" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:22:30" , 
"departure_time" : "08:23:35" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:30:05" , 
"departure_time" : "08:30:10" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:42:05" , 
"departure_time" : "08:42:05" , 
"distance_traveled" : 50.8152
} ], 
"2951" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "23:33:00" , 
"departure_time" : "23:33:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "23:39:48" , 
"departure_time" : "23:40:19" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "23:44:31" , 
"departure_time" : "23:46:07" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "23:50:36" , 
"departure_time" : "23:50:43" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "23:55:07" , 
"departure_time" : "23:56:40" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "24:00:33" , 
"departure_time" : "24:02:07" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "24:10:34" , 
"departure_time" : "24:12:14" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "24:15:40" , 
"departure_time" : "24:15:48" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "24:19:08" , 
"departure_time" : "24:19:43" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "24:23:35" , 
"departure_time" : "24:24:17" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "24:29:42" , 
"departure_time" : "24:30:29" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "24:33:47" , 
"departure_time" : "24:33:55" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "24:40:08" , 
"departure_time" : "24:41:45" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "24:46:37" , 
"departure_time" : "24:47:22" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "24:51:45" , 
"departure_time" : "24:52:25" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:58:40" , 
"departure_time" : "24:59:38" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "25:18:58" , 
"departure_time" : "25:18:58" , 
"distance_traveled" : 50.8155
} ], 
"2952" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "15:01:00" , 
"departure_time" : "15:02:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "15:09:01" , 
"departure_time" : "15:10:37" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "15:14:36" , 
"departure_time" : "15:15:02" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "15:18:26" , 
"departure_time" : "15:19:37" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "15:25:11" , 
"departure_time" : "15:26:09" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "15:28:58" , 
"departure_time" : "15:29:21" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "15:38:23" , 
"departure_time" : "15:39:41" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "15:44:18" , 
"departure_time" : "15:44:21" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "15:48:03" , 
"departure_time" : "15:48:23" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "15:51:20" , 
"departure_time" : "15:52:33" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "15:59:13" , 
"departure_time" : "15:59:27" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "16:02:14" , 
"departure_time" : "16:02:39" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "16:09:25" , 
"departure_time" : "16:09:26" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 109,
"arrival_time" : "16:12:01" , 
"departure_time" : "16:12:47" , 
"distance_traveled" : 36.4301
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:15:46" , 
"departure_time" : "16:15:47" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:22:01" , 
"departure_time" : "16:22:08" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:30:07" , 
"departure_time" : "16:31:44" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "16:44:37" , 
"departure_time" : "16:44:37" , 
"distance_traveled" : 50.8152
} ], 
"2953" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "08:02:00" , 
"departure_time" : "08:04:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "08:09:15" , 
"departure_time" : "08:10:13" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "08:13:58" , 
"departure_time" : "08:15:01" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "08:19:03" , 
"departure_time" : "08:20:12" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "08:25:09" , 
"departure_time" : "08:25:58" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "08:28:49" , 
"departure_time" : "08:30:22" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "08:39:33" , 
"departure_time" : "08:41:06" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "08:44:33" , 
"departure_time" : "08:45:04" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "08:48:31" , 
"departure_time" : "08:50:11" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "08:52:40" , 
"departure_time" : "08:53:58" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:59:18" , 
"departure_time" : "09:00:20" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "09:03:02" , 
"departure_time" : "09:03:25" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "09:09:23" , 
"departure_time" : "09:10:33" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 109,
"arrival_time" : "09:13:10" , 
"departure_time" : "09:14:06" , 
"distance_traveled" : 36.4301
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:15:56" , 
"departure_time" : "09:17:15" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:23:19" , 
"departure_time" : "09:24:38" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:30:19" , 
"departure_time" : "09:31:28" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:43:09" , 
"departure_time" : "09:43:09" , 
"distance_traveled" : 50.8155
} ], 
"2954" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "16:01:00" , 
"departure_time" : "16:03:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "16:09:06" , 
"departure_time" : "16:10:07" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "16:14:01" , 
"departure_time" : "16:15:13" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "16:19:12" , 
"departure_time" : "16:19:31" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "16:24:19" , 
"departure_time" : "16:24:47" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "16:28:28" , 
"departure_time" : "16:28:53" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "16:38:25" , 
"departure_time" : "16:39:36" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "16:44:11" , 
"departure_time" : "16:45:16" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "16:49:05" , 
"departure_time" : "16:50:26" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "16:52:21" , 
"departure_time" : "16:53:33" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "16:59:12" , 
"departure_time" : "17:00:47" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "17:03:35" , 
"departure_time" : "17:04:17" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "17:09:42" , 
"departure_time" : "17:11:08" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 109,
"arrival_time" : "17:13:26" , 
"departure_time" : "17:14:26" , 
"distance_traveled" : 36.4301
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:16:00" , 
"departure_time" : "17:16:51" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:22:51" , 
"departure_time" : "17:23:09" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:30:18" , 
"departure_time" : "17:31:57" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "17:44:39" , 
"departure_time" : "17:44:39" , 
"distance_traveled" : 50.8152
} ], 
"2955" :  [ 
{ 
"stop_id" : 127,
"arrival_time" : "13:14:00" , 
"departure_time" : "13:16:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 70,
"arrival_time" : "13:18:59" , 
"departure_time" : "13:19:46" , 
"distance_traveled" : 2.0659
}, 
{ 
"stop_id" : 41,
"arrival_time" : "13:25:47" , 
"departure_time" : "13:27:03" , 
"distance_traveled" : 5.3494
}, 
{ 
"stop_id" : 109,
"arrival_time" : "13:29:16" , 
"departure_time" : "13:30:18" , 
"distance_traveled" : 6.3252
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:33:02" , 
"departure_time" : "13:33:38" , 
"distance_traveled" : 8.1752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:38:36" , 
"departure_time" : "13:40:15" , 
"distance_traveled" : 10.6534
}, 
{ 
"stop_id" : 105,
"arrival_time" : "13:57:39" , 
"departure_time" : "13:57:39" , 
"distance_traveled" : 20.7102
} ], 
"2956" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "23:33:00" , 
"departure_time" : "23:35:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "23:39:29" , 
"departure_time" : "23:40:43" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "23:45:14" , 
"departure_time" : "23:45:44" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "23:49:30" , 
"departure_time" : "23:49:53" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "23:55:23" , 
"departure_time" : "23:55:48" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "23:59:25" , 
"departure_time" : "24:00:52" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "24:10:27" , 
"departure_time" : "24:11:26" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "24:14:59" , 
"departure_time" : "24:16:10" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "24:20:11" , 
"departure_time" : "24:20:39" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "24:23:28" , 
"departure_time" : "24:25:01" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "24:30:33" , 
"departure_time" : "24:30:34" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "24:33:01" , 
"departure_time" : "24:33:57" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "24:40:56" , 
"departure_time" : "24:41:45" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "24:45:49" , 
"departure_time" : "24:46:30" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "24:51:41" , 
"departure_time" : "24:51:54" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:58:13" , 
"departure_time" : "24:59:34" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "25:19:21" , 
"departure_time" : "25:19:21" , 
"distance_traveled" : 50.8155
} ], 
"2957" :  [ 
{ 
"stop_id" : 127,
"arrival_time" : "09:43:00" , 
"departure_time" : "09:45:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 70,
"arrival_time" : "09:48:22" , 
"departure_time" : "09:49:01" , 
"distance_traveled" : 2.0659
}, 
{ 
"stop_id" : 41,
"arrival_time" : "09:53:39" , 
"departure_time" : "09:55:09" , 
"distance_traveled" : 5.3494
}, 
{ 
"stop_id" : 109,
"arrival_time" : "09:57:30" , 
"departure_time" : "09:59:03" , 
"distance_traveled" : 6.3252
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:01:33" , 
"departure_time" : "10:02:19" , 
"distance_traveled" : 8.1752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:08:46" , 
"departure_time" : "10:09:23" , 
"distance_traveled" : 10.6534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:16:37" , 
"departure_time" : "10:18:14" , 
"distance_traveled" : 15.7222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:33:37" , 
"departure_time" : "10:33:37" , 
"distance_traveled" : 20.7102
} ], 
"2958" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "08:02:00" , 
"departure_time" : "08:04:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "08:08:31" , 
"departure_time" : "08:09:02" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "08:13:31" , 
"departure_time" : "08:15:04" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "08:19:33" , 
"departure_time" : "08:20:05" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "08:24:32" , 
"departure_time" : "08:24:45" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "08:28:13" , 
"departure_time" : "08:28:58" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "08:38:45" , 
"departure_time" : "08:39:57" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "08:44:12" , 
"departure_time" : "08:45:04" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "08:48:52" , 
"departure_time" : "08:50:30" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "08:52:38" , 
"departure_time" : "08:52:42" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:58:04" , 
"departure_time" : "08:59:19" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "09:03:15" , 
"departure_time" : "09:04:38" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "09:10:23" , 
"departure_time" : "09:10:39" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 109,
"arrival_time" : "09:12:16" , 
"departure_time" : "09:13:31" , 
"distance_traveled" : 36.4301
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:16:15" , 
"departure_time" : "09:17:47" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:23:32" , 
"departure_time" : "09:25:08" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:30:36" , 
"departure_time" : "09:31:08" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:42:32" , 
"departure_time" : "09:42:32" , 
"distance_traveled" : 50.8155
} ], 
"2959" :  [ 
{ 
"stop_id" : 127,
"arrival_time" : "10:41:00" , 
"departure_time" : "10:42:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 70,
"arrival_time" : "10:45:49" , 
"departure_time" : "10:46:33" , 
"distance_traveled" : 2.0659
}, 
{ 
"stop_id" : 41,
"arrival_time" : "10:52:44" , 
"departure_time" : "10:53:21" , 
"distance_traveled" : 5.3494
}, 
{ 
"stop_id" : 109,
"arrival_time" : "10:55:37" , 
"departure_time" : "10:56:35" , 
"distance_traveled" : 6.3252
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:59:58" , 
"departure_time" : "11:01:07" , 
"distance_traveled" : 8.1752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:08:09" , 
"departure_time" : "11:08:57" , 
"distance_traveled" : 10.6534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:15:48" , 
"departure_time" : "11:17:04" , 
"distance_traveled" : 15.7222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "11:32:16" , 
"departure_time" : "11:32:16" , 
"distance_traveled" : 20.7102
} ], 
"2960" :  [ 
{ 
"stop_id" : 127,
"arrival_time" : "13:14:00" , 
"departure_time" : "13:16:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 70,
"arrival_time" : "13:18:52" , 
"departure_time" : "13:19:50" , 
"distance_traveled" : 2.0659
}, 
{ 
"stop_id" : 41,
"arrival_time" : "13:25:58" , 
"departure_time" : "13:26:18" , 
"distance_traveled" : 5.3494
}, 
{ 
"stop_id" : 109,
"arrival_time" : "13:28:20" , 
"departure_time" : "13:29:40" , 
"distance_traveled" : 6.3252
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:33:20" , 
"departure_time" : "13:33:51" , 
"distance_traveled" : 8.1752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:38:31" , 
"departure_time" : "13:38:34" , 
"distance_traveled" : 10.6534
}, 
{ 
"stop_id" : 105,
"arrival_time" : "13:56:03" , 
"departure_time" : "13:56:03" , 
"distance_traveled" : 20.7102
} ], 
"2961" :  [ 
{ 
"stop_id" : 127,
"arrival_time" : "18:09:00" , 
"departure_time" : "18:10:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 70,
"arrival_time" : "18:14:12" , 
"departure_time" : "18:15:31" , 
"distance_traveled" : 2.0659
}, 
{ 
"stop_id" : 41,
"arrival_time" : "18:20:19" , 
"departure_time" : "18:21:09" , 
"distance_traveled" : 5.3494
}, 
{ 
"stop_id" : 109,
"arrival_time" : "18:22:50" , 
"departure_time" : "18:24:11" , 
"distance_traveled" : 6.3252
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:27:21" , 
"departure_time" : "18:28:28" , 
"distance_traveled" : 8.1752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:33:07" , 
"departure_time" : "18:34:37" , 
"distance_traveled" : 10.6534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:40:30" , 
"departure_time" : "18:40:53" , 
"distance_traveled" : 15.7222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:52:23" , 
"departure_time" : "18:52:23" , 
"distance_traveled" : 20.7102
} ], 
"2962" :  [ 
{ 
"stop_id" : 127,
"arrival_time" : "09:43:00" , 
"departure_time" : "09:43:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 70,
"arrival_time" : "09:47:33" , 
"departure_time" : "09:48:40" , 
"distance_traveled" : 2.0659
}, 
{ 
"stop_id" : 41,
"arrival_time" : "09:54:07" , 
"departure_time" : "09:54:57" , 
"distance_traveled" : 5.3494
}, 
{ 
"stop_id" : 109,
"arrival_time" : "09:56:50" , 
"departure_time" : "09:57:46" , 
"distance_traveled" : 6.3252
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:00:56" , 
"departure_time" : "10:01:55" , 
"distance_traveled" : 8.1752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:08:59" , 
"departure_time" : "10:09:27" , 
"distance_traveled" : 10.6534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:16:28" , 
"departure_time" : "10:16:45" , 
"distance_traveled" : 15.7222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:32:17" , 
"departure_time" : "10:32:17" , 
"distance_traveled" : 20.7102
} ], 
"2963" :  [ 
{ 
"stop_id" : 127,
"arrival_time" : "19:09:00" , 
"departure_time" : "19:09:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 70,
"arrival_time" : "19:13:08" , 
"departure_time" : "19:13:20" , 
"distance_traveled" : 2.0659
}, 
{ 
"stop_id" : 41,
"arrival_time" : "19:19:12" , 
"departure_time" : "19:19:46" , 
"distance_traveled" : 5.3494
}, 
{ 
"stop_id" : 109,
"arrival_time" : "19:22:34" , 
"departure_time" : "19:23:35" , 
"distance_traveled" : 6.3252
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:27:01" , 
"departure_time" : "19:28:29" , 
"distance_traveled" : 8.1752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:33:28" , 
"departure_time" : "19:34:22" , 
"distance_traveled" : 10.6534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:39:54" , 
"departure_time" : "19:40:02" , 
"distance_traveled" : 15.7222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "19:52:08" , 
"departure_time" : "19:52:08" , 
"distance_traveled" : 20.7102
} ], 
"2964" :  [ 
{ 
"stop_id" : 127,
"arrival_time" : "10:41:00" , 
"departure_time" : "10:41:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 70,
"arrival_time" : "10:45:48" , 
"departure_time" : "10:46:46" , 
"distance_traveled" : 2.0659
}, 
{ 
"stop_id" : 41,
"arrival_time" : "10:52:58" , 
"departure_time" : "10:53:32" , 
"distance_traveled" : 5.3494
}, 
{ 
"stop_id" : 109,
"arrival_time" : "10:55:34" , 
"departure_time" : "10:57:10" , 
"distance_traveled" : 6.3252
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "11:00:36" , 
"departure_time" : "11:01:23" , 
"distance_traveled" : 8.1752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:07:47" , 
"departure_time" : "11:07:57" , 
"distance_traveled" : 10.6534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:15:10" , 
"departure_time" : "11:16:14" , 
"distance_traveled" : 15.7222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "11:32:04" , 
"departure_time" : "11:32:04" , 
"distance_traveled" : 20.7102
} ], 
"2965" :  [ 
{ 
"stop_id" : 127,
"arrival_time" : "19:46:00" , 
"departure_time" : "19:47:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 70,
"arrival_time" : "19:50:51" , 
"departure_time" : "19:52:08" , 
"distance_traveled" : 2.0659
}, 
{ 
"stop_id" : 41,
"arrival_time" : "19:58:17" , 
"departure_time" : "19:59:36" , 
"distance_traveled" : 5.3494
}, 
{ 
"stop_id" : 109,
"arrival_time" : "20:01:19" , 
"departure_time" : "20:01:41" , 
"distance_traveled" : 6.3252
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:03:22" , 
"departure_time" : "20:03:37" , 
"distance_traveled" : 8.1752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:10:15" , 
"departure_time" : "20:11:11" , 
"distance_traveled" : 10.6534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:17:56" , 
"departure_time" : "20:18:30" , 
"distance_traveled" : 15.7222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "20:32:34" , 
"departure_time" : "20:32:34" , 
"distance_traveled" : 20.7102
} ], 
"2966" :  [ 
{ 
"stop_id" : 127,
"arrival_time" : "18:09:00" , 
"departure_time" : "18:11:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 70,
"arrival_time" : "18:14:37" , 
"departure_time" : "18:15:53" , 
"distance_traveled" : 2.0659
}, 
{ 
"stop_id" : 41,
"arrival_time" : "18:20:16" , 
"departure_time" : "18:21:46" , 
"distance_traveled" : 5.3494
}, 
{ 
"stop_id" : 109,
"arrival_time" : "18:23:30" , 
"departure_time" : "18:24:56" , 
"distance_traveled" : 6.3252
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:27:26" , 
"departure_time" : "18:27:39" , 
"distance_traveled" : 8.1752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:32:13" , 
"departure_time" : "18:32:35" , 
"distance_traveled" : 10.6534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:39:22" , 
"departure_time" : "18:40:57" , 
"distance_traveled" : 15.7222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:53:35" , 
"departure_time" : "18:53:35" , 
"distance_traveled" : 20.7102
} ], 
"2967" :  [ 
{ 
"stop_id" : 127,
"arrival_time" : "21:46:00" , 
"departure_time" : "21:48:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 70,
"arrival_time" : "21:51:22" , 
"departure_time" : "21:52:13" , 
"distance_traveled" : 2.0659
}, 
{ 
"stop_id" : 41,
"arrival_time" : "21:57:51" , 
"departure_time" : "21:58:39" , 
"distance_traveled" : 5.3494
}, 
{ 
"stop_id" : 109,
"arrival_time" : "22:00:48" , 
"departure_time" : "22:01:00" , 
"distance_traveled" : 6.3252
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:03:12" , 
"departure_time" : "22:03:18" , 
"distance_traveled" : 8.1752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:10:06" , 
"departure_time" : "22:11:16" , 
"distance_traveled" : 10.6534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:18:10" , 
"departure_time" : "22:18:21" , 
"distance_traveled" : 15.7222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "22:32:11" , 
"departure_time" : "22:32:11" , 
"distance_traveled" : 20.7102
} ], 
"2968" :  [ 
{ 
"stop_id" : 127,
"arrival_time" : "19:09:00" , 
"departure_time" : "19:09:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 70,
"arrival_time" : "19:13:48" , 
"departure_time" : "19:15:27" , 
"distance_traveled" : 2.0659
}, 
{ 
"stop_id" : 41,
"arrival_time" : "19:20:39" , 
"departure_time" : "19:21:40" , 
"distance_traveled" : 5.3494
}, 
{ 
"stop_id" : 109,
"arrival_time" : "19:23:01" , 
"departure_time" : "19:24:30" , 
"distance_traveled" : 6.3252
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:27:29" , 
"departure_time" : "19:27:37" , 
"distance_traveled" : 8.1752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:32:08" , 
"departure_time" : "19:32:21" , 
"distance_traveled" : 10.6534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:39:13" , 
"departure_time" : "19:39:19" , 
"distance_traveled" : 15.7222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "19:52:06" , 
"departure_time" : "19:52:06" , 
"distance_traveled" : 20.7102
} ], 
"2969" :  [ 
{ 
"stop_id" : 139,
"arrival_time" : "19:03:00" , 
"departure_time" : "19:03:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 119,
"arrival_time" : "19:07:43" , 
"departure_time" : "19:08:58" , 
"distance_traveled" : 1.882
}, 
{ 
"stop_id" : 158,
"arrival_time" : "19:14:15" , 
"departure_time" : "19:14:20" , 
"distance_traveled" : 5.2998
}, 
{ 
"stop_id" : 127,
"arrival_time" : "19:21:05" , 
"departure_time" : "19:21:48" , 
"distance_traveled" : 9.0341
}, 
{ 
"stop_id" : 70,
"arrival_time" : "19:25:43" , 
"departure_time" : "19:26:56" , 
"distance_traveled" : 11.0926
}, 
{ 
"stop_id" : 41,
"arrival_time" : "19:33:13" , 
"departure_time" : "19:34:12" , 
"distance_traveled" : 14.3761
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:37:59" , 
"departure_time" : "19:38:08" , 
"distance_traveled" : 17.2019
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:43:09" , 
"departure_time" : "19:43:49" , 
"distance_traveled" : 19.6801
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:51:40" , 
"departure_time" : "19:52:51" , 
"distance_traveled" : 24.7489
}, 
{ 
"stop_id" : 105,
"arrival_time" : "20:05:11" , 
"departure_time" : "20:05:11" , 
"distance_traveled" : 29.7369
} ], 
"2970" :  [ 
{ 
"stop_id" : 127,
"arrival_time" : "19:46:00" , 
"departure_time" : "19:48:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 70,
"arrival_time" : "19:51:29" , 
"departure_time" : "19:52:50" , 
"distance_traveled" : 2.0659
}, 
{ 
"stop_id" : 41,
"arrival_time" : "19:58:21" , 
"departure_time" : "19:58:40" , 
"distance_traveled" : 5.3494
}, 
{ 
"stop_id" : 109,
"arrival_time" : "20:00:19" , 
"departure_time" : "20:01:04" , 
"distance_traveled" : 6.3252
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:03:45" , 
"departure_time" : "20:05:02" , 
"distance_traveled" : 8.1752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:11:17" , 
"departure_time" : "20:12:27" , 
"distance_traveled" : 10.6534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:18:10" , 
"departure_time" : "20:18:28" , 
"distance_traveled" : 15.7222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "20:32:18" , 
"departure_time" : "20:32:18" , 
"distance_traveled" : 20.7102
} ], 
"2971" :  [ 
{ 
"stop_id" : 139,
"arrival_time" : "07:39:00" , 
"departure_time" : "07:39:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 119,
"arrival_time" : "07:44:05" , 
"departure_time" : "07:44:33" , 
"distance_traveled" : 1.882
}, 
{ 
"stop_id" : 158,
"arrival_time" : "07:50:28" , 
"departure_time" : "07:52:01" , 
"distance_traveled" : 5.2998
}, 
{ 
"stop_id" : 11,
"arrival_time" : "07:55:33" , 
"departure_time" : "07:56:29" , 
"distance_traveled" : 6.7583
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:01:56" , 
"departure_time" : "08:02:25" , 
"distance_traveled" : 9.0432
}, 
{ 
"stop_id" : 70,
"arrival_time" : "08:06:29" , 
"departure_time" : "08:07:59" , 
"distance_traveled" : 11.1017
}, 
{ 
"stop_id" : 41,
"arrival_time" : "08:14:30" , 
"departure_time" : "08:15:50" , 
"distance_traveled" : 14.3852
}, 
{ 
"stop_id" : 109,
"arrival_time" : "08:17:20" , 
"departure_time" : "08:17:35" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:24:15" , 
"departure_time" : "08:25:14" , 
"distance_traveled" : 19.6881
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:32:59" , 
"departure_time" : "08:34:17" , 
"distance_traveled" : 24.7581
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:47:18" , 
"departure_time" : "08:47:18" , 
"distance_traveled" : 29.7462
} ], 
"2972" :  [ 
{ 
"stop_id" : 127,
"arrival_time" : "21:46:00" , 
"departure_time" : "21:48:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 70,
"arrival_time" : "21:51:31" , 
"departure_time" : "21:53:09" , 
"distance_traveled" : 2.0659
}, 
{ 
"stop_id" : 41,
"arrival_time" : "21:58:38" , 
"departure_time" : "22:00:05" , 
"distance_traveled" : 5.3494
}, 
{ 
"stop_id" : 109,
"arrival_time" : "22:01:27" , 
"departure_time" : "22:01:59" , 
"distance_traveled" : 6.3252
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:03:32" , 
"departure_time" : "22:03:52" , 
"distance_traveled" : 8.1752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:10:20" , 
"departure_time" : "22:11:55" , 
"distance_traveled" : 10.6534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:18:35" , 
"departure_time" : "22:19:11" , 
"distance_traveled" : 15.7222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "22:32:36" , 
"departure_time" : "22:32:36" , 
"distance_traveled" : 20.7102
} ], 
"2973" :  [ 
{ 
"stop_id" : 139,
"arrival_time" : "07:04:00" , 
"departure_time" : "07:05:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 119,
"arrival_time" : "07:09:25" , 
"departure_time" : "07:09:31" , 
"distance_traveled" : 1.882
}, 
{ 
"stop_id" : 158,
"arrival_time" : "07:14:06" , 
"departure_time" : "07:14:59" , 
"distance_traveled" : 5.2998
}, 
{ 
"stop_id" : 11,
"arrival_time" : "07:18:53" , 
"departure_time" : "07:20:14" , 
"distance_traveled" : 6.7583
}, 
{ 
"stop_id" : 127,
"arrival_time" : "07:28:21" , 
"departure_time" : "07:29:40" , 
"distance_traveled" : 9.0432
}, 
{ 
"stop_id" : 70,
"arrival_time" : "07:33:19" , 
"departure_time" : "07:34:26" , 
"distance_traveled" : 11.1017
}, 
{ 
"stop_id" : 41,
"arrival_time" : "07:41:07" , 
"departure_time" : "07:42:08" , 
"distance_traveled" : 14.3852
}, 
{ 
"stop_id" : 109,
"arrival_time" : "07:44:01" , 
"departure_time" : "07:44:25" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "07:47:24" , 
"departure_time" : "07:47:27" , 
"distance_traveled" : 17.211
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:55:03" , 
"departure_time" : "07:56:00" , 
"distance_traveled" : 19.6892
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:03:57" , 
"departure_time" : "08:04:36" , 
"distance_traveled" : 24.758
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:17:39" , 
"departure_time" : "08:17:39" , 
"distance_traveled" : 29.746
} ], 
"2974" :  [ 
{ 
"stop_id" : 139,
"arrival_time" : "19:03:00" , 
"departure_time" : "19:04:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 119,
"arrival_time" : "19:08:05" , 
"departure_time" : "19:08:07" , 
"distance_traveled" : 1.882
}, 
{ 
"stop_id" : 158,
"arrival_time" : "19:13:02" , 
"departure_time" : "19:14:14" , 
"distance_traveled" : 5.2998
}, 
{ 
"stop_id" : 127,
"arrival_time" : "19:22:12" , 
"departure_time" : "19:23:18" , 
"distance_traveled" : 9.0341
}, 
{ 
"stop_id" : 70,
"arrival_time" : "19:26:06" , 
"departure_time" : "19:26:22" , 
"distance_traveled" : 11.0926
}, 
{ 
"stop_id" : 41,
"arrival_time" : "19:32:16" , 
"departure_time" : "19:33:04" , 
"distance_traveled" : 14.3761
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:37:48" , 
"departure_time" : "19:38:36" , 
"distance_traveled" : 17.2019
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:43:48" , 
"departure_time" : "19:45:11" , 
"distance_traveled" : 19.6801
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:52:23" , 
"departure_time" : "19:52:25" , 
"distance_traveled" : 24.7489
}, 
{ 
"stop_id" : 105,
"arrival_time" : "20:04:02" , 
"departure_time" : "20:04:02" , 
"distance_traveled" : 29.7369
} ], 
"2975" :  [ 
{ 
"stop_id" : 139,
"arrival_time" : "08:02:00" , 
"departure_time" : "08:02:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 119,
"arrival_time" : "08:07:10" , 
"departure_time" : "08:08:02" , 
"distance_traveled" : 1.882
}, 
{ 
"stop_id" : 158,
"arrival_time" : "08:13:52" , 
"departure_time" : "08:14:30" , 
"distance_traveled" : 5.2998
}, 
{ 
"stop_id" : 11,
"arrival_time" : "08:16:38" , 
"departure_time" : "08:16:51" , 
"distance_traveled" : 6.7583
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:23:13" , 
"departure_time" : "08:23:50" , 
"distance_traveled" : 9.0432
}, 
{ 
"stop_id" : 70,
"arrival_time" : "08:27:37" , 
"departure_time" : "08:28:31" , 
"distance_traveled" : 11.1017
}, 
{ 
"stop_id" : 41,
"arrival_time" : "08:35:54" , 
"departure_time" : "08:36:13" , 
"distance_traveled" : 14.3852
}, 
{ 
"stop_id" : 109,
"arrival_time" : "08:38:19" , 
"departure_time" : "08:39:01" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:41:42" , 
"departure_time" : "08:42:59" , 
"distance_traveled" : 17.211
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:49:17" , 
"departure_time" : "08:49:57" , 
"distance_traveled" : 19.6892
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:55:40" , 
"departure_time" : "08:56:51" , 
"distance_traveled" : 24.758
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:09:11" , 
"departure_time" : "09:09:11" , 
"distance_traveled" : 29.746
} ], 
"2976" :  [ 
{ 
"stop_id" : 139,
"arrival_time" : "07:39:00" , 
"departure_time" : "07:41:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 119,
"arrival_time" : "07:44:57" , 
"departure_time" : "07:45:45" , 
"distance_traveled" : 1.882
}, 
{ 
"stop_id" : 158,
"arrival_time" : "07:50:48" , 
"departure_time" : "07:52:05" , 
"distance_traveled" : 5.2998
}, 
{ 
"stop_id" : 11,
"arrival_time" : "07:55:17" , 
"departure_time" : "07:56:50" , 
"distance_traveled" : 6.7583
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:02:33" , 
"departure_time" : "08:03:52" , 
"distance_traveled" : 9.0432
}, 
{ 
"stop_id" : 70,
"arrival_time" : "08:07:19" , 
"departure_time" : "08:07:59" , 
"distance_traveled" : 11.1017
}, 
{ 
"stop_id" : 41,
"arrival_time" : "08:13:40" , 
"departure_time" : "08:15:10" , 
"distance_traveled" : 14.3852
}, 
{ 
"stop_id" : 109,
"arrival_time" : "08:17:30" , 
"departure_time" : "08:18:38" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:25:08" , 
"departure_time" : "08:26:14" , 
"distance_traveled" : 19.6881
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:33:06" , 
"departure_time" : "08:34:46" , 
"distance_traveled" : 24.7581
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:47:40" , 
"departure_time" : "08:47:40" , 
"distance_traveled" : 29.7462
} ], 
"2977" :  [ 
{ 
"stop_id" : 139,
"arrival_time" : "09:13:00" , 
"departure_time" : "09:15:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 119,
"arrival_time" : "09:18:06" , 
"departure_time" : "09:18:09" , 
"distance_traveled" : 1.882
}, 
{ 
"stop_id" : 158,
"arrival_time" : "09:23:03" , 
"departure_time" : "09:23:04" , 
"distance_traveled" : 5.2998
}, 
{ 
"stop_id" : 11,
"arrival_time" : "09:26:01" , 
"departure_time" : "09:26:38" , 
"distance_traveled" : 6.7583
}, 
{ 
"stop_id" : 127,
"arrival_time" : "09:33:37" , 
"departure_time" : "09:33:55" , 
"distance_traveled" : 9.0432
}, 
{ 
"stop_id" : 70,
"arrival_time" : "09:37:18" , 
"departure_time" : "09:37:55" , 
"distance_traveled" : 11.1017
}, 
{ 
"stop_id" : 41,
"arrival_time" : "09:44:37" , 
"departure_time" : "09:45:59" , 
"distance_traveled" : 14.3852
}, 
{ 
"stop_id" : 109,
"arrival_time" : "09:48:22" , 
"departure_time" : "09:49:57" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:52:35" , 
"departure_time" : "09:54:10" , 
"distance_traveled" : 17.211
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:58:35" , 
"departure_time" : "10:00:09" , 
"distance_traveled" : 19.6892
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:05:34" , 
"departure_time" : "10:06:40" , 
"distance_traveled" : 24.758
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:18:06" , 
"departure_time" : "10:18:06" , 
"distance_traveled" : 29.746
} ], 
"2978" :  [ 
{ 
"stop_id" : 139,
"arrival_time" : "07:04:00" , 
"departure_time" : "07:05:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 119,
"arrival_time" : "07:09:43" , 
"departure_time" : "07:11:17" , 
"distance_traveled" : 1.882
}, 
{ 
"stop_id" : 158,
"arrival_time" : "07:15:34" , 
"departure_time" : "07:16:36" , 
"distance_traveled" : 5.2998
}, 
{ 
"stop_id" : 11,
"arrival_time" : "07:19:02" , 
"departure_time" : "07:19:23" , 
"distance_traveled" : 6.7583
}, 
{ 
"stop_id" : 127,
"arrival_time" : "07:27:21" , 
"departure_time" : "07:28:22" , 
"distance_traveled" : 9.0432
}, 
{ 
"stop_id" : 70,
"arrival_time" : "07:33:01" , 
"departure_time" : "07:34:28" , 
"distance_traveled" : 11.1017
}, 
{ 
"stop_id" : 41,
"arrival_time" : "07:41:27" , 
"departure_time" : "07:42:53" , 
"distance_traveled" : 14.3852
}, 
{ 
"stop_id" : 109,
"arrival_time" : "07:44:26" , 
"departure_time" : "07:44:37" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "07:47:11" , 
"departure_time" : "07:47:45" , 
"distance_traveled" : 17.211
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:55:34" , 
"departure_time" : "07:56:20" , 
"distance_traveled" : 19.6892
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:03:46" , 
"departure_time" : "08:04:48" , 
"distance_traveled" : 24.758
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:18:02" , 
"departure_time" : "08:18:02" , 
"distance_traveled" : 29.746
} ], 
"2979" :  [ 
{ 
"stop_id" : 139,
"arrival_time" : "20:08:00" , 
"departure_time" : "20:09:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 119,
"arrival_time" : "20:12:33" , 
"departure_time" : "20:12:53" , 
"distance_traveled" : 1.882
}, 
{ 
"stop_id" : 158,
"arrival_time" : "20:18:20" , 
"departure_time" : "20:18:54" , 
"distance_traveled" : 5.2998
}, 
{ 
"stop_id" : 11,
"arrival_time" : "20:21:34" , 
"departure_time" : "20:21:35" , 
"distance_traveled" : 6.7583
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:28:01" , 
"departure_time" : "20:28:25" , 
"distance_traveled" : 9.0432
}, 
{ 
"stop_id" : 70,
"arrival_time" : "20:32:24" , 
"departure_time" : "20:32:39" , 
"distance_traveled" : 11.1017
}, 
{ 
"stop_id" : 41,
"arrival_time" : "20:39:15" , 
"departure_time" : "20:40:49" , 
"distance_traveled" : 14.3852
}, 
{ 
"stop_id" : 109,
"arrival_time" : "20:42:34" , 
"departure_time" : "20:42:55" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:45:21" , 
"departure_time" : "20:46:01" , 
"distance_traveled" : 17.211
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:52:40" , 
"departure_time" : "20:53:23" , 
"distance_traveled" : 19.6892
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:01:43" , 
"departure_time" : "21:03:18" , 
"distance_traveled" : 24.758
}, 
{ 
"stop_id" : 105,
"arrival_time" : "21:15:35" , 
"departure_time" : "21:15:35" , 
"distance_traveled" : 29.746
} ], 
"2980" :  [ 
{ 
"stop_id" : 139,
"arrival_time" : "08:02:00" , 
"departure_time" : "08:04:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 119,
"arrival_time" : "08:07:30" , 
"departure_time" : "08:08:59" , 
"distance_traveled" : 1.882
}, 
{ 
"stop_id" : 158,
"arrival_time" : "08:14:29" , 
"departure_time" : "08:14:42" , 
"distance_traveled" : 5.2998
}, 
{ 
"stop_id" : 11,
"arrival_time" : "08:16:13" , 
"departure_time" : "08:16:21" , 
"distance_traveled" : 6.7583
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:23:08" , 
"departure_time" : "08:24:05" , 
"distance_traveled" : 9.0432
}, 
{ 
"stop_id" : 70,
"arrival_time" : "08:27:57" , 
"departure_time" : "08:28:30" , 
"distance_traveled" : 11.1017
}, 
{ 
"stop_id" : 41,
"arrival_time" : "08:35:33" , 
"departure_time" : "08:36:05" , 
"distance_traveled" : 14.3852
}, 
{ 
"stop_id" : 109,
"arrival_time" : "08:38:32" , 
"departure_time" : "08:39:38" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:42:06" , 
"departure_time" : "08:43:28" , 
"distance_traveled" : 17.211
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:49:22" , 
"departure_time" : "08:50:08" , 
"distance_traveled" : 19.6892
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:55:46" , 
"departure_time" : "08:56:28" , 
"distance_traveled" : 24.758
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:08:42" , 
"departure_time" : "09:08:42" , 
"distance_traveled" : 29.746
} ], 
"2981" :  [ 
{ 
"stop_id" : 139,
"arrival_time" : "18:28:00" , 
"departure_time" : "18:30:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 119,
"arrival_time" : "18:33:25" , 
"departure_time" : "18:35:04" , 
"distance_traveled" : 1.882
}, 
{ 
"stop_id" : 158,
"arrival_time" : "18:39:39" , 
"departure_time" : "18:41:01" , 
"distance_traveled" : 5.2998
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:47:22" , 
"departure_time" : "18:48:39" , 
"distance_traveled" : 9.0341
}, 
{ 
"stop_id" : 70,
"arrival_time" : "18:51:17" , 
"departure_time" : "18:52:49" , 
"distance_traveled" : 11.0926
}, 
{ 
"stop_id" : 41,
"arrival_time" : "18:58:32" , 
"departure_time" : "18:59:49" , 
"distance_traveled" : 14.3761
}, 
{ 
"stop_id" : 109,
"arrival_time" : "19:01:17" , 
"departure_time" : "19:02:07" , 
"distance_traveled" : 15.3519
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:04:50" , 
"departure_time" : "19:05:53" , 
"distance_traveled" : 17.2019
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:11:03" , 
"departure_time" : "19:11:34" , 
"distance_traveled" : 19.6801
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:17:31" , 
"departure_time" : "19:17:42" , 
"distance_traveled" : 24.7489
}, 
{ 
"stop_id" : 105,
"arrival_time" : "19:30:11" , 
"departure_time" : "19:30:11" , 
"distance_traveled" : 29.7373
} ], 
"2982" :  [ 
{ 
"stop_id" : 139,
"arrival_time" : "09:13:00" , 
"departure_time" : "09:13:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 119,
"arrival_time" : "09:17:47" , 
"departure_time" : "09:17:54" , 
"distance_traveled" : 1.882
}, 
{ 
"stop_id" : 158,
"arrival_time" : "09:23:07" , 
"departure_time" : "09:23:15" , 
"distance_traveled" : 5.2998
}, 
{ 
"stop_id" : 11,
"arrival_time" : "09:26:08" , 
"departure_time" : "09:27:21" , 
"distance_traveled" : 6.7583
}, 
{ 
"stop_id" : 127,
"arrival_time" : "09:34:13" , 
"departure_time" : "09:34:55" , 
"distance_traveled" : 9.0432
}, 
{ 
"stop_id" : 70,
"arrival_time" : "09:37:42" , 
"departure_time" : "09:38:19" , 
"distance_traveled" : 11.1017
}, 
{ 
"stop_id" : 41,
"arrival_time" : "09:44:37" , 
"departure_time" : "09:46:16" , 
"distance_traveled" : 14.3852
}, 
{ 
"stop_id" : 109,
"arrival_time" : "09:48:39" , 
"departure_time" : "09:49:41" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:52:02" , 
"departure_time" : "09:52:36" , 
"distance_traveled" : 17.211
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:57:34" , 
"departure_time" : "09:58:49" , 
"distance_traveled" : 19.6892
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:05:15" , 
"departure_time" : "10:06:18" , 
"distance_traveled" : 24.758
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:18:03" , 
"departure_time" : "10:18:03" , 
"distance_traveled" : 29.746
} ], 
"2983" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "07:10:00" , 
"departure_time" : "07:12:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "07:17:29" , 
"departure_time" : "07:17:58" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "07:20:29" , 
"departure_time" : "07:21:31" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "07:28:02" , 
"departure_time" : "07:28:49" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "07:33:47" , 
"departure_time" : "07:35:12" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "07:38:25" , 
"departure_time" : "07:38:54" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "07:47:29" , 
"departure_time" : "07:47:58" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "07:52:29" , 
"departure_time" : "07:53:34" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "07:59:05" , 
"departure_time" : "08:00:36" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:19:31" , 
"departure_time" : "08:20:25" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:26:54" , 
"departure_time" : "08:28:13" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:41:19" , 
"departure_time" : "08:41:19" , 
"distance_traveled" : 50.8061
} ], 
"2984" :  [ 
{ 
"stop_id" : 139,
"arrival_time" : "20:08:00" , 
"departure_time" : "20:10:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 119,
"arrival_time" : "20:13:08" , 
"departure_time" : "20:14:15" , 
"distance_traveled" : 1.882
}, 
{ 
"stop_id" : 158,
"arrival_time" : "20:19:07" , 
"departure_time" : "20:19:38" , 
"distance_traveled" : 5.2998
}, 
{ 
"stop_id" : 11,
"arrival_time" : "20:21:31" , 
"departure_time" : "20:21:33" , 
"distance_traveled" : 6.7583
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:28:02" , 
"departure_time" : "20:29:34" , 
"distance_traveled" : 9.0432
}, 
{ 
"stop_id" : 70,
"arrival_time" : "20:33:32" , 
"departure_time" : "20:34:35" , 
"distance_traveled" : 11.1017
}, 
{ 
"stop_id" : 41,
"arrival_time" : "20:40:03" , 
"departure_time" : "20:40:28" , 
"distance_traveled" : 14.3852
}, 
{ 
"stop_id" : 109,
"arrival_time" : "20:41:25" , 
"departure_time" : "20:41:54" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:45:29" , 
"departure_time" : "20:45:37" , 
"distance_traveled" : 17.211
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:52:08" , 
"departure_time" : "20:52:32" , 
"distance_traveled" : 19.6892
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:01:24" , 
"departure_time" : "21:02:40" , 
"distance_traveled" : 24.758
}, 
{ 
"stop_id" : 105,
"arrival_time" : "21:15:16" , 
"departure_time" : "21:15:16" , 
"distance_traveled" : 29.746
} ], 
"2985" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "18:17:00" , 
"departure_time" : "18:19:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "18:25:27" , 
"departure_time" : "18:25:58" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "18:28:31" , 
"departure_time" : "18:29:12" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "18:34:41" , 
"departure_time" : "18:36:04" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "18:41:23" , 
"departure_time" : "18:41:33" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "18:43:10" , 
"departure_time" : "18:43:11" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "18:53:01" , 
"departure_time" : "18:54:27" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "18:58:26" , 
"departure_time" : "18:59:21" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "19:03:55" , 
"departure_time" : "19:04:56" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:23:01" , 
"departure_time" : "19:23:52" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:30:51" , 
"departure_time" : "19:32:00" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "19:44:09" , 
"departure_time" : "19:44:09" , 
"distance_traveled" : 50.8061
} ], 
"2986" :  [ 
{ 
"stop_id" : 139,
"arrival_time" : "18:28:00" , 
"departure_time" : "18:30:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 119,
"arrival_time" : "18:33:35" , 
"departure_time" : "18:34:45" , 
"distance_traveled" : 1.882
}, 
{ 
"stop_id" : 158,
"arrival_time" : "18:39:10" , 
"departure_time" : "18:40:48" , 
"distance_traveled" : 5.2998
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:47:38" , 
"departure_time" : "18:48:06" , 
"distance_traveled" : 9.0341
}, 
{ 
"stop_id" : 70,
"arrival_time" : "18:50:28" , 
"departure_time" : "18:50:36" , 
"distance_traveled" : 11.0926
}, 
{ 
"stop_id" : 41,
"arrival_time" : "18:57:08" , 
"departure_time" : "18:57:44" , 
"distance_traveled" : 14.3761
}, 
{ 
"stop_id" : 109,
"arrival_time" : "19:00:36" , 
"departure_time" : "19:01:29" , 
"distance_traveled" : 15.3519
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:04:53" , 
"departure_time" : "19:05:55" , 
"distance_traveled" : 17.2019
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:11:02" , 
"departure_time" : "19:11:31" , 
"distance_traveled" : 19.6801
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:17:29" , 
"departure_time" : "19:18:53" , 
"distance_traveled" : 24.7489
}, 
{ 
"stop_id" : 105,
"arrival_time" : "19:31:24" , 
"departure_time" : "19:31:24" , 
"distance_traveled" : 29.7373
} ], 
"2987" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "06:12:00" , 
"departure_time" : "06:14:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "06:18:48" , 
"departure_time" : "06:18:55" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "06:22:07" , 
"departure_time" : "06:22:13" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "06:28:06" , 
"departure_time" : "06:28:11" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "06:34:05" , 
"departure_time" : "06:34:10" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "06:38:05" , 
"departure_time" : "06:38:50" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "06:47:45" , 
"departure_time" : "06:48:44" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "06:52:59" , 
"departure_time" : "06:53:22" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "06:58:23" , 
"departure_time" : "06:59:31" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "07:02:08" , 
"departure_time" : "07:03:37" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:20:29" , 
"departure_time" : "07:21:37" , 
"distance_traveled" : 40.7574
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:30:08" , 
"departure_time" : "07:30:18" , 
"distance_traveled" : 45.8275
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:42:10" , 
"departure_time" : "07:42:10" , 
"distance_traveled" : 50.8155
} ], 
"2988" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "07:10:00" , 
"departure_time" : "07:10:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "07:16:32" , 
"departure_time" : "07:16:41" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "07:20:09" , 
"departure_time" : "07:20:44" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "07:27:35" , 
"departure_time" : "07:28:40" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "07:34:05" , 
"departure_time" : "07:35:08" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "07:38:03" , 
"departure_time" : "07:39:31" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "07:48:28" , 
"departure_time" : "07:49:25" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "07:52:57" , 
"departure_time" : "07:53:32" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "07:58:35" , 
"departure_time" : "08:00:05" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:19:30" , 
"departure_time" : "08:20:52" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:27:22" , 
"departure_time" : "08:28:01" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:40:39" , 
"departure_time" : "08:40:39" , 
"distance_traveled" : 50.8061
} ], 
"2989" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "08:28:00" , 
"departure_time" : "08:29:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "08:34:34" , 
"departure_time" : "08:36:09" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "08:40:35" , 
"departure_time" : "08:42:11" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "08:46:36" , 
"departure_time" : "08:47:14" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "08:50:38" , 
"departure_time" : "08:50:43" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "08:54:05" , 
"departure_time" : "08:54:35" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "09:04:30" , 
"departure_time" : "09:04:47" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "09:09:17" , 
"departure_time" : "09:09:53" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "09:15:36" , 
"departure_time" : "09:16:44" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "09:19:08" , 
"departure_time" : "09:20:40" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:36:32" , 
"departure_time" : "09:37:26" , 
"distance_traveled" : 40.7574
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:42:54" , 
"departure_time" : "09:43:25" , 
"distance_traveled" : 45.8275
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:55:31" , 
"departure_time" : "09:55:31" , 
"distance_traveled" : 50.8155
} ], 
"2990" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "18:17:00" , 
"departure_time" : "18:18:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "18:24:49" , 
"departure_time" : "18:25:28" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "18:28:39" , 
"departure_time" : "18:29:56" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "18:35:17" , 
"departure_time" : "18:36:09" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "18:40:52" , 
"departure_time" : "18:41:59" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "18:44:07" , 
"departure_time" : "18:45:00" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "18:53:53" , 
"departure_time" : "18:53:55" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "18:57:02" , 
"departure_time" : "18:58:08" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "19:04:06" , 
"departure_time" : "19:04:42" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:22:36" , 
"departure_time" : "19:22:52" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:30:16" , 
"departure_time" : "19:31:21" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "19:44:05" , 
"departure_time" : "19:44:05" , 
"distance_traveled" : 50.8061
} ], 
"2991" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "03:58:00" , 
"departure_time" : "03:59:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "04:04:03" , 
"departure_time" : "04:05:37" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "04:09:34" , 
"departure_time" : "04:11:08" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "04:15:34" , 
"departure_time" : "04:15:57" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "04:19:23" , 
"departure_time" : "04:19:26" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "04:23:03" , 
"departure_time" : "04:24:03" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "04:34:00" , 
"departure_time" : "04:34:27" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "04:37:27" , 
"departure_time" : "04:38:41" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "04:44:14" , 
"departure_time" : "04:45:39" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "05:00:25" , 
"departure_time" : "05:01:34" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "05:06:09" , 
"departure_time" : "05:07:13" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:13:04" , 
"departure_time" : "05:14:23" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "05:31:19" , 
"departure_time" : "05:31:19" , 
"distance_traveled" : 50.8061
} ], 
"2992" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "06:12:00" , 
"departure_time" : "06:14:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "06:19:32" , 
"departure_time" : "06:19:44" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "06:22:12" , 
"departure_time" : "06:22:51" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "06:28:39" , 
"departure_time" : "06:29:35" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "06:34:56" , 
"departure_time" : "06:35:04" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "06:38:08" , 
"departure_time" : "06:39:48" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "06:48:40" , 
"departure_time" : "06:49:28" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "06:52:48" , 
"departure_time" : "06:53:25" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "06:58:37" , 
"departure_time" : "06:59:10" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "07:01:33" , 
"departure_time" : "07:01:55" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:19:22" , 
"departure_time" : "07:20:44" , 
"distance_traveled" : 40.7574
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:30:22" , 
"departure_time" : "07:31:22" , 
"distance_traveled" : 45.8275
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:43:00" , 
"departure_time" : "07:43:00" , 
"distance_traveled" : 50.8155
} ], 
"2993" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "17:40:00" , 
"departure_time" : "17:42:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "17:48:31" , 
"departure_time" : "17:49:27" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "17:51:56" , 
"departure_time" : "17:51:57" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "17:57:01" , 
"departure_time" : "17:58:40" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "18:04:39" , 
"departure_time" : "18:05:12" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "18:06:33" , 
"departure_time" : "18:08:03" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "18:17:30" , 
"departure_time" : "18:18:14" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "18:20:44" , 
"departure_time" : "18:21:01" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "18:26:17" , 
"departure_time" : "18:26:59" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:42:42" , 
"departure_time" : "18:42:49" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:48:07" , 
"departure_time" : "18:48:28" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:55:21" , 
"departure_time" : "18:56:08" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "19:08:47" , 
"departure_time" : "19:08:47" , 
"distance_traveled" : 50.8061
} ], 
"2994" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "08:28:00" , 
"departure_time" : "08:28:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "08:34:07" , 
"departure_time" : "08:34:35" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "08:39:28" , 
"departure_time" : "08:40:00" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "08:45:32" , 
"departure_time" : "08:46:09" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "08:50:37" , 
"departure_time" : "08:51:46" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "08:55:09" , 
"departure_time" : "08:55:27" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "09:04:18" , 
"departure_time" : "09:04:33" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "09:09:15" , 
"departure_time" : "09:09:57" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "09:15:42" , 
"departure_time" : "09:16:25" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "09:18:43" , 
"departure_time" : "09:19:09" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:35:26" , 
"departure_time" : "09:36:09" , 
"distance_traveled" : 40.7574
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:42:43" , 
"departure_time" : "09:42:47" , 
"distance_traveled" : 45.8275
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:55:04" , 
"departure_time" : "09:55:04" , 
"distance_traveled" : 50.8155
} ], 
"2995" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "19:20:00" , 
"departure_time" : "19:21:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "19:28:39" , 
"departure_time" : "19:29:10" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "19:32:31" , 
"departure_time" : "19:32:53" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "19:38:22" , 
"departure_time" : "19:39:45" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "19:45:23" , 
"departure_time" : "19:46:10" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "19:48:47" , 
"departure_time" : "19:49:52" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "19:58:05" , 
"departure_time" : "19:59:23" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "20:03:18" , 
"departure_time" : "20:03:26" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "20:08:08" , 
"departure_time" : "20:09:38" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:26:30" , 
"departure_time" : "20:27:43" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:33:13" , 
"departure_time" : "20:34:49" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:42:36" , 
"departure_time" : "20:42:59" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "20:53:23" , 
"departure_time" : "20:53:23" , 
"distance_traveled" : 50.8061
} ], 
"2996" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "03:58:00" , 
"departure_time" : "03:58:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "04:04:32" , 
"departure_time" : "04:04:52" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "04:08:20" , 
"departure_time" : "04:09:22" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "04:15:02" , 
"departure_time" : "04:16:12" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "04:20:10" , 
"departure_time" : "04:21:18" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "04:24:08" , 
"departure_time" : "04:25:29" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "04:34:21" , 
"departure_time" : "04:35:45" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "04:38:24" , 
"departure_time" : "04:39:34" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "04:44:10" , 
"departure_time" : "04:45:45" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "05:00:35" , 
"departure_time" : "05:02:02" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "05:06:27" , 
"departure_time" : "05:06:33" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:12:06" , 
"departure_time" : "05:12:18" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "05:30:12" , 
"departure_time" : "05:30:12" , 
"distance_traveled" : 50.8061
} ], 
"2997" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "06:49:00" , 
"departure_time" : "06:50:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "06:56:19" , 
"departure_time" : "06:56:59" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "06:59:40" , 
"departure_time" : "07:00:03" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "07:06:23" , 
"departure_time" : "07:06:57" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "07:12:34" , 
"departure_time" : "07:14:13" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "07:18:39" , 
"departure_time" : "07:20:08" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "07:28:29" , 
"departure_time" : "07:28:53" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "07:32:24" , 
"departure_time" : "07:33:30" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "07:39:06" , 
"departure_time" : "07:39:25" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:02:19" , 
"departure_time" : "08:02:34" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:10:15" , 
"departure_time" : "08:11:10" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:24:55" , 
"departure_time" : "08:24:55" , 
"distance_traveled" : 50.8064
} ], 
"2998" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "17:40:00" , 
"departure_time" : "17:41:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "17:47:19" , 
"departure_time" : "17:47:26" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "17:51:07" , 
"departure_time" : "17:51:32" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "17:57:25" , 
"departure_time" : "17:57:33" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "18:03:08" , 
"departure_time" : "18:04:00" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "18:06:52" , 
"departure_time" : "18:07:32" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "18:16:40" , 
"departure_time" : "18:17:09" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "18:20:29" , 
"departure_time" : "18:21:22" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "18:26:53" , 
"departure_time" : "18:28:21" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:43:28" , 
"departure_time" : "18:44:27" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:48:59" , 
"departure_time" : "18:49:34" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:55:35" , 
"departure_time" : "18:56:04" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "19:08:29" , 
"departure_time" : "19:08:29" , 
"distance_traveled" : 50.8061
} ], 
"2999" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "04:46:00" , 
"departure_time" : "04:46:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "04:52:27" , 
"departure_time" : "04:54:05" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "04:58:38" , 
"departure_time" : "05:00:00" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "05:04:22" , 
"departure_time" : "05:04:44" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "05:09:22" , 
"departure_time" : "05:09:25" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "05:13:03" , 
"departure_time" : "05:13:39" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "05:22:36" , 
"departure_time" : "05:23:03" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "05:27:27" , 
"departure_time" : "05:28:00" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "05:33:33" , 
"departure_time" : "05:35:00" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "05:37:27" , 
"departure_time" : "05:37:29" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "05:44:02" , 
"departure_time" : "05:44:44" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 107,
"arrival_time" : "05:58:42" , 
"departure_time" : "05:59:52" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:07:10" , 
"departure_time" : "06:08:39" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:20:29" , 
"departure_time" : "06:20:29" , 
"distance_traveled" : 50.8152
} ], 
"3000" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "19:20:00" , 
"departure_time" : "19:23:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "19:28:33" , 
"departure_time" : "19:30:08" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "19:33:35" , 
"departure_time" : "19:33:44" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "19:38:09" , 
"departure_time" : "19:39:49" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "19:45:40" , 
"departure_time" : "19:46:18" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "19:48:38" , 
"departure_time" : "19:50:02" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "19:58:24" , 
"departure_time" : "19:59:45" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "20:03:21" , 
"departure_time" : "20:04:06" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "20:08:45" , 
"departure_time" : "20:10:23" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:26:38" , 
"departure_time" : "20:26:41" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:32:03" , 
"departure_time" : "20:32:52" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:41:49" , 
"departure_time" : "20:42:36" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "20:53:47" , 
"departure_time" : "20:53:47" , 
"distance_traveled" : 50.8061
} ], 
"3001" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "05:33:00" , 
"departure_time" : "05:35:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "05:40:20" , 
"departure_time" : "05:41:43" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "05:44:23" , 
"departure_time" : "05:45:50" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "05:51:27" , 
"departure_time" : "05:52:40" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "05:57:13" , 
"departure_time" : "05:58:16" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "06:01:03" , 
"departure_time" : "06:02:41" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "06:11:38" , 
"departure_time" : "06:12:36" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "06:14:58" , 
"departure_time" : "06:16:10" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "06:21:12" , 
"departure_time" : "06:21:35" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "06:24:23" , 
"departure_time" : "06:24:30" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "06:31:07" , 
"departure_time" : "06:31:45" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:45:38" , 
"departure_time" : "06:45:46" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:53:08" , 
"departure_time" : "06:53:39" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:06:31" , 
"departure_time" : "07:06:31" , 
"distance_traveled" : 50.8152
} ], 
"3002" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "06:49:00" , 
"departure_time" : "06:51:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "06:56:40" , 
"departure_time" : "06:57:50" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "07:00:10" , 
"departure_time" : "07:01:45" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "07:07:35" , 
"departure_time" : "07:09:10" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "07:13:35" , 
"departure_time" : "07:14:42" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "07:18:07" , 
"departure_time" : "07:19:03" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "07:27:56" , 
"departure_time" : "07:29:30" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "07:33:34" , 
"departure_time" : "07:34:49" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "07:39:15" , 
"departure_time" : "07:40:49" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:03:34" , 
"departure_time" : "08:04:26" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:10:52" , 
"departure_time" : "08:11:48" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:24:56" , 
"departure_time" : "08:24:56" , 
"distance_traveled" : 50.8064
} ], 
"3003" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "04:25:00" , 
"departure_time" : "04:26:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "04:31:39" , 
"departure_time" : "04:32:00" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "04:35:21" , 
"departure_time" : "04:36:31" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "04:42:10" , 
"departure_time" : "04:43:23" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "04:47:13" , 
"departure_time" : "04:48:36" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "04:51:23" , 
"departure_time" : "04:52:18" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "05:00:55" , 
"departure_time" : "05:01:48" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "05:04:53" , 
"departure_time" : "05:05:10" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "05:10:17" , 
"departure_time" : "05:10:28" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "05:14:11" , 
"departure_time" : "05:14:59" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "05:20:48" , 
"departure_time" : "05:21:56" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "05:31:08" , 
"departure_time" : "05:32:22" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "05:38:14" , 
"departure_time" : "05:38:19" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:44:05" , 
"departure_time" : "05:44:59" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "05:58:54" , 
"departure_time" : "05:58:54" , 
"distance_traveled" : 50.8152
} ], 
"3004" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "04:46:00" , 
"departure_time" : "04:48:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "04:53:29" , 
"departure_time" : "04:53:37" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "04:57:08" , 
"departure_time" : "04:58:31" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "05:04:23" , 
"departure_time" : "05:04:30" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "05:09:07" , 
"departure_time" : "05:09:32" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "05:13:25" , 
"departure_time" : "05:14:12" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "05:22:47" , 
"departure_time" : "05:23:57" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "05:28:10" , 
"departure_time" : "05:29:01" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "05:33:51" , 
"departure_time" : "05:34:56" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "05:37:05" , 
"departure_time" : "05:38:26" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "05:45:21" , 
"departure_time" : "05:45:26" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 107,
"arrival_time" : "05:58:05" , 
"departure_time" : "05:58:15" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:06:10" , 
"departure_time" : "06:06:50" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:19:40" , 
"departure_time" : "06:19:40" , 
"distance_traveled" : 50.8152
} ], 
"3005" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "09:54:00" , 
"departure_time" : "09:54:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "10:01:05" , 
"departure_time" : "10:02:04" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "10:05:59" , 
"departure_time" : "10:07:08" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "10:12:09" , 
"departure_time" : "10:13:13" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "10:18:04" , 
"departure_time" : "10:19:22" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "10:22:18" , 
"departure_time" : "10:22:57" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "10:31:39" , 
"departure_time" : "10:32:05" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "10:36:26" , 
"departure_time" : "10:37:02" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "10:42:36" , 
"departure_time" : "10:44:15" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 127,
"arrival_time" : "10:51:39" , 
"departure_time" : "10:53:19" , 
"distance_traveled" : 30.1032
}, 
{ 
"stop_id" : 70,
"arrival_time" : "10:55:40" , 
"departure_time" : "10:55:41" , 
"distance_traveled" : 32.1617
}, 
{ 
"stop_id" : 41,
"arrival_time" : "11:01:01" , 
"departure_time" : "11:01:19" , 
"distance_traveled" : 35.4453
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "11:06:18" , 
"departure_time" : "11:07:15" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:12:57" , 
"departure_time" : "11:14:18" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:21:21" , 
"departure_time" : "11:21:30" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "11:34:09" , 
"departure_time" : "11:34:09" , 
"distance_traveled" : 50.8061
} ], 
"3006" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "05:33:00" , 
"departure_time" : "05:34:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "05:40:21" , 
"departure_time" : "05:41:27" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "05:44:06" , 
"departure_time" : "05:45:12" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "05:51:06" , 
"departure_time" : "05:52:01" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "05:56:55" , 
"departure_time" : "05:58:32" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "06:01:37" , 
"departure_time" : "06:01:52" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "06:10:15" , 
"departure_time" : "06:11:01" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "06:14:46" , 
"departure_time" : "06:14:52" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "06:20:06" , 
"departure_time" : "06:21:42" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "06:25:36" , 
"departure_time" : "06:26:04" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "06:31:28" , 
"departure_time" : "06:32:59" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:46:31" , 
"departure_time" : "06:47:38" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:54:07" , 
"departure_time" : "06:54:38" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:06:31" , 
"departure_time" : "07:06:31" , 
"distance_traveled" : 50.8152
} ], 
"3007" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "20:10:00" , 
"departure_time" : "20:11:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "20:17:48" , 
"departure_time" : "20:18:13" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "20:21:25" , 
"departure_time" : "20:21:56" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "20:27:31" , 
"departure_time" : "20:28:11" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "20:33:40" , 
"departure_time" : "20:33:41" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "20:37:01" , 
"departure_time" : "20:38:27" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "20:48:26" , 
"departure_time" : "20:50:05" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "20:52:39" , 
"departure_time" : "20:52:41" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "20:57:02" , 
"departure_time" : "20:58:13" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 127,
"arrival_time" : "21:06:11" , 
"departure_time" : "21:07:44" , 
"distance_traveled" : 30.1032
}, 
{ 
"stop_id" : 70,
"arrival_time" : "21:10:33" , 
"departure_time" : "21:11:03" , 
"distance_traveled" : 32.1617
}, 
{ 
"stop_id" : 41,
"arrival_time" : "21:17:30" , 
"departure_time" : "21:18:48" , 
"distance_traveled" : 35.4453
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "21:23:18" , 
"departure_time" : "21:24:15" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:28:57" , 
"departure_time" : "21:29:14" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:35:17" , 
"departure_time" : "21:36:24" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "21:49:07" , 
"departure_time" : "21:49:07" , 
"distance_traveled" : 50.8061
} ], 
"3008" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "04:25:00" , 
"departure_time" : "04:26:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "04:31:41" , 
"departure_time" : "04:32:24" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "04:35:43" , 
"departure_time" : "04:36:15" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "04:41:32" , 
"departure_time" : "04:42:07" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "04:46:35" , 
"departure_time" : "04:47:08" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "04:50:33" , 
"departure_time" : "04:51:37" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "05:01:04" , 
"departure_time" : "05:01:16" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "05:04:12" , 
"departure_time" : "05:05:38" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "05:11:26" , 
"departure_time" : "05:13:01" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "05:15:35" , 
"departure_time" : "05:16:40" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "05:21:05" , 
"departure_time" : "05:21:26" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "05:30:21" , 
"departure_time" : "05:31:02" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "05:37:41" , 
"departure_time" : "05:37:56" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:44:15" , 
"departure_time" : "05:44:35" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "05:58:20" , 
"departure_time" : "05:58:20" , 
"distance_traveled" : 50.8152
} ], 
"3009" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "21:11:00" , 
"departure_time" : "21:11:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "21:18:34" , 
"departure_time" : "21:18:56" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "21:22:22" , 
"departure_time" : "21:23:26" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "21:28:04" , 
"departure_time" : "21:29:40" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "21:34:36" , 
"departure_time" : "21:36:07" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "21:38:31" , 
"departure_time" : "21:39:18" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "21:46:47" , 
"departure_time" : "21:48:22" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "21:52:35" , 
"departure_time" : "21:53:22" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "21:57:47" , 
"departure_time" : "21:57:52" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 127,
"arrival_time" : "22:05:05" , 
"departure_time" : "22:05:24" , 
"distance_traveled" : 30.1032
}, 
{ 
"stop_id" : 70,
"arrival_time" : "22:09:19" , 
"departure_time" : "22:09:27" , 
"distance_traveled" : 32.1617
}, 
{ 
"stop_id" : 41,
"arrival_time" : "22:16:08" , 
"departure_time" : "22:16:29" , 
"distance_traveled" : 35.4453
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:21:21" , 
"departure_time" : "22:22:25" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:28:04" , 
"departure_time" : "22:29:02" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:34:58" , 
"departure_time" : "22:35:41" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "22:47:43" , 
"departure_time" : "22:47:43" , 
"distance_traveled" : 50.8061
} ], 
"3010" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "09:54:00" , 
"departure_time" : "09:55:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "10:01:45" , 
"departure_time" : "10:01:57" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "10:05:12" , 
"departure_time" : "10:05:41" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "10:11:29" , 
"departure_time" : "10:12:47" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "10:18:18" , 
"departure_time" : "10:19:36" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "10:22:18" , 
"departure_time" : "10:23:10" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "10:31:52" , 
"departure_time" : "10:32:27" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "10:36:35" , 
"departure_time" : "10:36:53" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "10:42:18" , 
"departure_time" : "10:42:42" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 127,
"arrival_time" : "10:50:24" , 
"departure_time" : "10:50:35" , 
"distance_traveled" : 30.1032
}, 
{ 
"stop_id" : 70,
"arrival_time" : "10:54:11" , 
"departure_time" : "10:55:05" , 
"distance_traveled" : 32.1617
}, 
{ 
"stop_id" : 41,
"arrival_time" : "11:01:54" , 
"departure_time" : "11:03:16" , 
"distance_traveled" : 35.4453
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "11:07:22" , 
"departure_time" : "11:07:37" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:12:15" , 
"departure_time" : "11:12:58" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:20:43" , 
"departure_time" : "11:21:21" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "11:34:38" , 
"departure_time" : "11:34:38" , 
"distance_traveled" : 50.8061
} ], 
"3011" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "13:53:00" , 
"departure_time" : "13:54:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "14:00:22" , 
"departure_time" : "14:00:39" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "14:04:17" , 
"departure_time" : "14:04:26" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "14:10:09" , 
"departure_time" : "14:10:55" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "14:16:46" , 
"departure_time" : "14:18:24" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "14:21:38" , 
"departure_time" : "14:22:06" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "14:29:28" , 
"departure_time" : "14:30:33" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "14:35:05" , 
"departure_time" : "14:35:57" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "14:39:52" , 
"departure_time" : "14:40:22" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "14:43:30" , 
"departure_time" : "14:44:04" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "14:50:34" , 
"departure_time" : "14:52:05" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "14:55:31" , 
"departure_time" : "14:55:42" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "15:00:11" , 
"departure_time" : "15:00:26" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "15:05:15" , 
"departure_time" : "15:05:25" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:13:10" , 
"departure_time" : "15:14:21" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:21:11" , 
"departure_time" : "15:21:29" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "15:34:18" , 
"departure_time" : "15:34:18" , 
"distance_traveled" : 50.8152
} ], 
"3012" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "20:10:00" , 
"departure_time" : "20:10:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "20:17:19" , 
"departure_time" : "20:17:56" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "20:21:37" , 
"departure_time" : "20:22:22" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "20:27:45" , 
"departure_time" : "20:29:12" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "20:34:27" , 
"departure_time" : "20:35:32" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "20:38:05" , 
"departure_time" : "20:39:43" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "20:48:38" , 
"departure_time" : "20:48:49" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "20:51:11" , 
"departure_time" : "20:52:29" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "20:58:18" , 
"departure_time" : "20:59:40" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 127,
"arrival_time" : "21:06:22" , 
"departure_time" : "21:06:35" , 
"distance_traveled" : 30.1032
}, 
{ 
"stop_id" : 70,
"arrival_time" : "21:09:13" , 
"departure_time" : "21:10:31" , 
"distance_traveled" : 32.1617
}, 
{ 
"stop_id" : 41,
"arrival_time" : "21:18:18" , 
"departure_time" : "21:18:44" , 
"distance_traveled" : 35.4453
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "21:22:26" , 
"departure_time" : "21:23:52" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:29:26" , 
"departure_time" : "21:30:56" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:36:30" , 
"departure_time" : "21:36:46" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "21:48:16" , 
"departure_time" : "21:48:16" , 
"distance_traveled" : 50.8061
} ], 
"3013" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "16:46:00" , 
"departure_time" : "16:46:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "16:53:05" , 
"departure_time" : "16:53:49" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "16:58:44" , 
"departure_time" : "16:58:54" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "17:03:10" , 
"departure_time" : "17:04:41" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "17:10:31" , 
"departure_time" : "17:11:02" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "17:13:31" , 
"departure_time" : "17:14:36" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "17:23:05" , 
"departure_time" : "17:24:02" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "17:27:57" , 
"departure_time" : "17:28:09" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "17:33:12" , 
"departure_time" : "17:34:36" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "17:37:24" , 
"departure_time" : "17:38:39" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "17:44:15" , 
"departure_time" : "17:45:24" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "17:48:09" , 
"departure_time" : "17:49:40" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "17:54:31" , 
"departure_time" : "17:54:38" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:58:07" , 
"departure_time" : "17:59:09" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:05:02" , 
"departure_time" : "18:05:17" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:11:15" , 
"departure_time" : "18:11:39" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:25:24" , 
"departure_time" : "18:25:24" , 
"distance_traveled" : 50.8152
} ], 
"3014" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "21:11:00" , 
"departure_time" : "21:12:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "21:18:52" , 
"departure_time" : "21:19:22" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "21:22:30" , 
"departure_time" : "21:23:57" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "21:28:27" , 
"departure_time" : "21:29:34" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "21:34:07" , 
"departure_time" : "21:34:23" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "21:37:16" , 
"departure_time" : "21:37:25" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "21:46:09" , 
"departure_time" : "21:46:54" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "21:51:45" , 
"departure_time" : "21:53:09" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "21:58:24" , 
"departure_time" : "21:59:25" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 127,
"arrival_time" : "22:06:01" , 
"departure_time" : "22:07:36" , 
"distance_traveled" : 30.1032
}, 
{ 
"stop_id" : 70,
"arrival_time" : "22:10:35" , 
"departure_time" : "22:12:03" , 
"distance_traveled" : 32.1617
}, 
{ 
"stop_id" : 41,
"arrival_time" : "22:17:28" , 
"departure_time" : "22:18:02" , 
"distance_traveled" : 35.4453
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:21:34" , 
"departure_time" : "22:21:52" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:27:18" , 
"departure_time" : "22:28:51" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:35:33" , 
"departure_time" : "22:36:57" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "22:48:24" , 
"departure_time" : "22:48:24" , 
"distance_traveled" : 50.8061
} ], 
"3015" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "22:24:00" , 
"departure_time" : "22:25:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "22:30:14" , 
"departure_time" : "22:31:32" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "22:35:18" , 
"departure_time" : "22:36:23" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "22:41:05" , 
"departure_time" : "22:41:47" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "22:46:42" , 
"departure_time" : "22:47:09" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "22:50:27" , 
"departure_time" : "22:51:24" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "22:59:57" , 
"departure_time" : "23:01:26" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "23:04:29" , 
"departure_time" : "23:05:39" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "23:10:10" , 
"departure_time" : "23:10:29" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "23:13:19" , 
"departure_time" : "23:14:59" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "23:21:40" , 
"departure_time" : "23:22:04" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "23:24:24" , 
"departure_time" : "23:24:38" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "23:30:14" , 
"departure_time" : "23:30:40" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "23:35:26" , 
"departure_time" : "23:36:56" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "23:43:30" , 
"departure_time" : "23:45:08" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:50:38" , 
"departure_time" : "23:51:37" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "24:02:59" , 
"departure_time" : "24:02:59" , 
"distance_traveled" : 50.8152
} ], 
"3016" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "13:53:00" , 
"departure_time" : "13:55:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "14:01:08" , 
"departure_time" : "14:01:37" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "14:04:29" , 
"departure_time" : "14:05:05" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "14:10:36" , 
"departure_time" : "14:10:57" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "14:16:21" , 
"departure_time" : "14:16:36" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "14:20:15" , 
"departure_time" : "14:21:23" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "14:30:08" , 
"departure_time" : "14:30:50" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "14:34:42" , 
"departure_time" : "14:35:59" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "14:40:17" , 
"departure_time" : "14:41:55" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "14:44:38" , 
"departure_time" : "14:46:14" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "14:51:36" , 
"departure_time" : "14:52:25" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "14:54:49" , 
"departure_time" : "14:55:37" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "15:00:48" , 
"departure_time" : "15:02:05" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "15:06:17" , 
"departure_time" : "15:07:52" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:14:35" , 
"departure_time" : "15:15:42" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:21:07" , 
"departure_time" : "15:22:04" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "15:34:57" , 
"departure_time" : "15:34:57" , 
"distance_traveled" : 50.8152
} ], 
"3017" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "10:53:00" , 
"departure_time" : "10:55:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "11:02:22" , 
"departure_time" : "11:03:38" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "11:06:16" , 
"departure_time" : "11:07:47" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "11:12:31" , 
"departure_time" : "11:13:46" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "11:18:15" , 
"departure_time" : "11:19:18" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "11:22:03" , 
"departure_time" : "11:22:51" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "11:31:48" , 
"departure_time" : "11:32:09" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "11:35:21" , 
"departure_time" : "11:36:59" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "11:42:38" , 
"departure_time" : "11:43:34" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 127,
"arrival_time" : "11:50:56" , 
"departure_time" : "11:52:33" , 
"distance_traveled" : 30.1032
}, 
{ 
"stop_id" : 70,
"arrival_time" : "11:55:37" , 
"departure_time" : "11:55:52" , 
"distance_traveled" : 32.1617
}, 
{ 
"stop_id" : 41,
"arrival_time" : "12:00:15" , 
"departure_time" : "12:01:33" , 
"distance_traveled" : 35.4453
}, 
{ 
"stop_id" : 109,
"arrival_time" : "12:04:18" , 
"departure_time" : "12:05:27" , 
"distance_traveled" : 36.421
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "12:08:09" , 
"departure_time" : "12:09:01" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:14:52" , 
"departure_time" : "12:15:26" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:21:34" , 
"departure_time" : "12:23:01" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "12:36:27" , 
"departure_time" : "12:36:27" , 
"distance_traveled" : 50.8061
} ], 
"3018" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "16:46:00" , 
"departure_time" : "16:48:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "16:54:13" , 
"departure_time" : "16:54:51" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "16:58:38" , 
"departure_time" : "16:59:10" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "17:03:32" , 
"departure_time" : "17:03:42" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "17:09:10" , 
"departure_time" : "17:09:23" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "17:13:13" , 
"departure_time" : "17:13:44" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "17:22:31" , 
"departure_time" : "17:22:38" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "17:27:07" , 
"departure_time" : "17:28:09" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "17:34:02" , 
"departure_time" : "17:34:38" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "17:36:36" , 
"departure_time" : "17:37:46" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "17:44:10" , 
"departure_time" : "17:44:30" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "17:47:20" , 
"departure_time" : "17:48:06" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "17:53:46" , 
"departure_time" : "17:54:29" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:58:43" , 
"departure_time" : "18:00:17" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:05:34" , 
"departure_time" : "18:06:37" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:12:03" , 
"departure_time" : "18:13:17" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:26:14" , 
"departure_time" : "18:26:14" , 
"distance_traveled" : 50.8152
} ], 
"3019" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "14:52:00" , 
"departure_time" : "14:54:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "15:00:24" , 
"departure_time" : "15:01:27" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "15:04:03" , 
"departure_time" : "15:04:35" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "15:09:32" , 
"departure_time" : "15:09:47" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "15:15:15" , 
"departure_time" : "15:16:07" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "15:19:52" , 
"departure_time" : "15:21:10" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "15:29:18" , 
"departure_time" : "15:30:06" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "15:33:48" , 
"departure_time" : "15:33:55" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "15:38:07" , 
"departure_time" : "15:39:10" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 127,
"arrival_time" : "15:47:03" , 
"departure_time" : "15:47:32" , 
"distance_traveled" : 30.1032
}, 
{ 
"stop_id" : 70,
"arrival_time" : "15:50:29" , 
"departure_time" : "15:50:59" , 
"distance_traveled" : 32.1617
}, 
{ 
"stop_id" : 41,
"arrival_time" : "15:57:30" , 
"departure_time" : "15:58:38" , 
"distance_traveled" : 35.4453
}, 
{ 
"stop_id" : 109,
"arrival_time" : "16:01:08" , 
"departure_time" : "16:02:32" , 
"distance_traveled" : 36.421
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:04:24" , 
"departure_time" : "16:05:03" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:09:39" , 
"departure_time" : "16:10:39" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:18:00" , 
"departure_time" : "16:19:32" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "16:31:32" , 
"departure_time" : "16:31:32" , 
"distance_traveled" : 50.8061
} ], 
"3020" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "22:24:00" , 
"departure_time" : "22:26:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "22:30:52" , 
"departure_time" : "22:32:28" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "22:35:36" , 
"departure_time" : "22:35:39" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "22:40:03" , 
"departure_time" : "22:40:15" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "22:46:12" , 
"departure_time" : "22:46:38" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "22:50:26" , 
"departure_time" : "22:50:35" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "22:59:09" , 
"departure_time" : "23:00:33" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "23:04:24" , 
"departure_time" : "23:05:31" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "23:10:07" , 
"departure_time" : "23:11:05" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "23:13:58" , 
"departure_time" : "23:14:03" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "23:20:05" , 
"departure_time" : "23:21:05" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "23:25:00" , 
"departure_time" : "23:26:11" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "23:31:11" , 
"departure_time" : "23:32:43" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "23:36:32" , 
"departure_time" : "23:37:37" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "23:43:05" , 
"departure_time" : "23:43:15" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:49:10" , 
"departure_time" : "23:49:39" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "24:02:29" , 
"departure_time" : "24:02:29" , 
"distance_traveled" : 50.8152
} ], 
"3021" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "12:54:00" , 
"departure_time" : "12:54:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "13:02:20" , 
"departure_time" : "13:03:27" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "13:07:07" , 
"departure_time" : "13:07:26" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "13:12:19" , 
"departure_time" : "13:12:29" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "13:18:10" , 
"departure_time" : "13:19:02" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "13:22:52" , 
"departure_time" : "13:23:24" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "13:32:32" , 
"departure_time" : "13:33:07" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "13:36:35" , 
"departure_time" : "13:38:09" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "13:43:34" , 
"departure_time" : "13:45:11" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 127,
"arrival_time" : "13:52:37" , 
"departure_time" : "13:53:42" , 
"distance_traveled" : 30.1032
}, 
{ 
"stop_id" : 70,
"arrival_time" : "13:56:05" , 
"departure_time" : "13:56:16" , 
"distance_traveled" : 32.1617
}, 
{ 
"stop_id" : 41,
"arrival_time" : "14:01:11" , 
"departure_time" : "14:02:44" , 
"distance_traveled" : 35.4453
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "14:07:33" , 
"departure_time" : "14:09:07" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:14:34" , 
"departure_time" : "14:14:53" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:23:19" , 
"departure_time" : "14:24:53" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "14:37:34" , 
"departure_time" : "14:37:34" , 
"distance_traveled" : 50.8064
} ], 
"3022" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "10:53:00" , 
"departure_time" : "10:55:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "11:02:02" , 
"departure_time" : "11:03:38" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "11:06:36" , 
"departure_time" : "11:07:13" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "11:11:37" , 
"departure_time" : "11:11:59" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "11:17:22" , 
"departure_time" : "11:17:23" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "11:21:01" , 
"departure_time" : "11:22:17" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "11:32:16" , 
"departure_time" : "11:33:45" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "11:36:29" , 
"departure_time" : "11:37:48" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "11:42:19" , 
"departure_time" : "11:43:31" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 127,
"arrival_time" : "11:51:12" , 
"departure_time" : "11:51:13" , 
"distance_traveled" : 30.1032
}, 
{ 
"stop_id" : 70,
"arrival_time" : "11:54:01" , 
"departure_time" : "11:54:11" , 
"distance_traveled" : 32.1617
}, 
{ 
"stop_id" : 41,
"arrival_time" : "12:00:10" , 
"departure_time" : "12:01:08" , 
"distance_traveled" : 35.4453
}, 
{ 
"stop_id" : 109,
"arrival_time" : "12:03:58" , 
"departure_time" : "12:05:11" , 
"distance_traveled" : 36.421
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "12:08:13" , 
"departure_time" : "12:09:41" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:15:28" , 
"departure_time" : "12:16:55" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:22:27" , 
"departure_time" : "12:23:48" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "12:36:21" , 
"departure_time" : "12:36:21" , 
"distance_traveled" : 50.8061
} ], 
"3023" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "24:19:00" , 
"departure_time" : "24:21:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "24:26:38" , 
"departure_time" : "24:27:33" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "24:30:55" , 
"departure_time" : "24:30:56" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "24:35:01" , 
"departure_time" : "24:36:35" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "24:42:34" , 
"departure_time" : "24:43:40" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "24:46:06" , 
"departure_time" : "24:46:26" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "24:55:20" , 
"departure_time" : "24:56:07" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "25:00:47" , 
"departure_time" : "25:02:10" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "25:06:23" , 
"departure_time" : "25:06:37" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "25:08:14" , 
"departure_time" : "25:09:10" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "25:15:56" , 
"departure_time" : "25:17:11" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "25:20:15" , 
"departure_time" : "25:21:49" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "25:26:34" , 
"departure_time" : "25:27:16" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 109,
"arrival_time" : "25:28:42" , 
"departure_time" : "25:28:48" , 
"distance_traveled" : 36.4301
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "25:31:06" , 
"departure_time" : "25:32:18" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "25:38:12" , 
"departure_time" : "25:39:32" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "25:46:20" , 
"departure_time" : "25:47:34" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "26:04:14" , 
"departure_time" : "26:04:14" , 
"distance_traveled" : 50.8152
} ], 
"3024" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "14:52:00" , 
"departure_time" : "14:54:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "14:59:58" , 
"departure_time" : "15:01:23" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "15:04:25" , 
"departure_time" : "15:05:28" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "15:10:03" , 
"departure_time" : "15:10:27" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "15:15:24" , 
"departure_time" : "15:16:08" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "15:19:44" , 
"departure_time" : "15:20:16" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "15:28:32" , 
"departure_time" : "15:29:34" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "15:34:02" , 
"departure_time" : "15:34:25" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "15:38:23" , 
"departure_time" : "15:39:57" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 127,
"arrival_time" : "15:47:34" , 
"departure_time" : "15:48:01" , 
"distance_traveled" : 30.1032
}, 
{ 
"stop_id" : 70,
"arrival_time" : "15:50:27" , 
"departure_time" : "15:51:34" , 
"distance_traveled" : 32.1617
}, 
{ 
"stop_id" : 41,
"arrival_time" : "15:58:07" , 
"departure_time" : "15:59:20" , 
"distance_traveled" : 35.4453
}, 
{ 
"stop_id" : 109,
"arrival_time" : "16:01:13" , 
"departure_time" : "16:01:50" , 
"distance_traveled" : 36.421
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:03:37" , 
"departure_time" : "16:04:55" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:10:18" , 
"departure_time" : "16:11:06" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:17:48" , 
"departure_time" : "16:18:44" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "16:30:56" , 
"departure_time" : "16:30:56" , 
"distance_traveled" : 50.8061
} ], 
"3025" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "09:12:00" , 
"departure_time" : "09:14:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "09:20:20" , 
"departure_time" : "09:22:00" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "09:24:40" , 
"departure_time" : "09:26:16" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "09:30:36" , 
"departure_time" : "09:30:44" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "09:35:08" , 
"departure_time" : "09:36:17" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "09:40:09" , 
"departure_time" : "09:40:20" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "09:49:11" , 
"departure_time" : "09:50:02" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "09:54:51" , 
"departure_time" : "09:56:20" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "10:00:29" , 
"departure_time" : "10:01:53" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "10:04:24" , 
"departure_time" : "10:05:30" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "10:11:06" , 
"departure_time" : "10:12:36" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "10:15:30" , 
"departure_time" : "10:16:39" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "10:22:09" , 
"departure_time" : "10:23:19" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 109,
"arrival_time" : "10:25:10" , 
"departure_time" : "10:26:42" , 
"distance_traveled" : 36.4301
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:29:32" , 
"departure_time" : "10:29:34" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:34:02" , 
"departure_time" : "10:35:10" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:42:08" , 
"departure_time" : "10:42:40" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:54:32" , 
"departure_time" : "10:54:32" , 
"distance_traveled" : 50.8152
} ], 
"3026" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "12:54:00" , 
"departure_time" : "12:55:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "13:03:22" , 
"departure_time" : "13:04:31" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "13:07:09" , 
"departure_time" : "13:08:42" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "13:13:33" , 
"departure_time" : "13:14:10" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "13:18:37" , 
"departure_time" : "13:19:13" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "13:22:36" , 
"departure_time" : "13:22:56" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "13:32:20" , 
"departure_time" : "13:32:28" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "13:36:08" , 
"departure_time" : "13:37:48" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "13:43:40" , 
"departure_time" : "13:44:16" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 127,
"arrival_time" : "13:51:36" , 
"departure_time" : "13:53:11" , 
"distance_traveled" : 30.1032
}, 
{ 
"stop_id" : 70,
"arrival_time" : "13:56:35" , 
"departure_time" : "13:58:11" , 
"distance_traveled" : 32.1617
}, 
{ 
"stop_id" : 41,
"arrival_time" : "14:02:36" , 
"departure_time" : "14:03:59" , 
"distance_traveled" : 35.4453
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "14:07:23" , 
"departure_time" : "14:08:35" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:14:12" , 
"departure_time" : "14:15:47" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:24:35" , 
"departure_time" : "14:25:18" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "14:36:43" , 
"departure_time" : "14:36:43" , 
"distance_traveled" : 50.8064
} ], 
"3027" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "15:46:00" , 
"departure_time" : "15:48:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "15:54:28" , 
"departure_time" : "15:55:44" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "15:58:16" , 
"departure_time" : "15:58:31" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "16:03:15" , 
"departure_time" : "16:04:37" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "16:10:22" , 
"departure_time" : "16:11:48" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "16:14:26" , 
"departure_time" : "16:14:58" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "16:23:32" , 
"departure_time" : "16:25:06" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "16:28:34" , 
"departure_time" : "16:28:48" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "16:33:14" , 
"departure_time" : "16:33:23" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "16:36:09" , 
"departure_time" : "16:36:15" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "16:42:06" , 
"departure_time" : "16:42:39" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "16:46:33" , 
"departure_time" : "16:47:24" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "16:53:51" , 
"departure_time" : "16:54:04" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 109,
"arrival_time" : "16:56:13" , 
"departure_time" : "16:56:17" , 
"distance_traveled" : 36.4301
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:59:04" , 
"departure_time" : "16:59:38" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:06:34" , 
"departure_time" : "17:07:56" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:17:22" , 
"departure_time" : "17:18:25" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "17:29:03" , 
"departure_time" : "17:29:03" , 
"distance_traveled" : 50.8152
} ], 
"3028" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "24:19:00" , 
"departure_time" : "24:21:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "24:26:10" , 
"departure_time" : "24:27:46" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "24:31:36" , 
"departure_time" : "24:31:44" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "24:35:08" , 
"departure_time" : "24:36:25" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "24:42:17" , 
"departure_time" : "24:42:42" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "24:45:25" , 
"departure_time" : "24:46:51" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "24:56:26" , 
"departure_time" : "24:57:12" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "25:00:46" , 
"departure_time" : "25:01:25" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "25:05:39" , 
"departure_time" : "25:06:51" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "25:09:12" , 
"departure_time" : "25:10:48" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "25:16:36" , 
"departure_time" : "25:16:44" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "25:19:08" , 
"departure_time" : "25:19:37" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "25:25:29" , 
"departure_time" : "25:25:59" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 109,
"arrival_time" : "25:28:30" , 
"departure_time" : "25:29:53" , 
"distance_traveled" : 36.4301
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "25:32:23" , 
"departure_time" : "25:33:13" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "25:37:50" , 
"departure_time" : "25:39:12" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "25:46:22" , 
"departure_time" : "25:47:52" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "26:04:30" , 
"departure_time" : "26:04:30" , 
"distance_traveled" : 50.8152
} ], 
"3029" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "11:54:00" , 
"departure_time" : "11:56:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "12:01:39" , 
"departure_time" : "12:01:54" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "12:05:15" , 
"departure_time" : "12:06:29" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "12:12:14" , 
"departure_time" : "12:12:19" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "12:17:05" , 
"departure_time" : "12:18:21" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "12:22:16" , 
"departure_time" : "12:23:20" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "12:31:04" , 
"departure_time" : "12:32:43" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "12:36:39" , 
"departure_time" : "12:37:24" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "12:40:45" , 
"departure_time" : "12:41:34" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "12:44:49" , 
"departure_time" : "12:45:38" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "12:51:49" , 
"departure_time" : "12:52:32" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "12:55:43" , 
"departure_time" : "12:56:44" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "13:02:01" , 
"departure_time" : "13:03:12" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:07:11" , 
"departure_time" : "13:08:31" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:14:20" , 
"departure_time" : "13:15:56" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:21:36" , 
"departure_time" : "13:22:37" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "13:34:01" , 
"departure_time" : "13:34:01" , 
"distance_traveled" : 50.8155
} ], 
"3030" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "09:12:00" , 
"departure_time" : "09:14:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "09:20:24" , 
"departure_time" : "09:21:28" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "09:24:04" , 
"departure_time" : "09:24:11" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "09:29:07" , 
"departure_time" : "09:29:28" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "09:35:21" , 
"departure_time" : "09:36:06" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "09:39:45" , 
"departure_time" : "09:40:50" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "09:50:05" , 
"departure_time" : "09:50:49" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "09:54:44" , 
"departure_time" : "09:55:48" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "10:00:04" , 
"departure_time" : "10:01:16" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "10:04:12" , 
"departure_time" : "10:05:13" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "10:11:01" , 
"departure_time" : "10:12:04" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "10:15:03" , 
"departure_time" : "10:16:18" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "10:22:15" , 
"departure_time" : "10:22:41" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 109,
"arrival_time" : "10:24:26" , 
"departure_time" : "10:24:50" , 
"distance_traveled" : 36.4301
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:28:24" , 
"departure_time" : "10:29:00" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:34:36" , 
"departure_time" : "10:35:10" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:41:34" , 
"departure_time" : "10:42:10" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:54:36" , 
"departure_time" : "10:54:36" , 
"distance_traveled" : 50.8152
} ], 
"3031" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "23:33:00" , 
"departure_time" : "23:34:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "23:39:38" , 
"departure_time" : "23:41:07" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "23:45:29" , 
"departure_time" : "23:45:55" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "23:49:26" , 
"departure_time" : "23:51:04" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "23:56:38" , 
"departure_time" : "23:56:54" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "23:59:16" , 
"departure_time" : "23:59:49" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "24:09:33" , 
"departure_time" : "24:10:44" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "24:15:11" , 
"departure_time" : "24:15:20" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "24:19:09" , 
"departure_time" : "24:20:11" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "24:24:02" , 
"departure_time" : "24:24:37" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "24:29:35" , 
"departure_time" : "24:29:53" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "24:33:18" , 
"departure_time" : "24:34:47" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "24:41:29" , 
"departure_time" : "24:42:13" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "24:45:44" , 
"departure_time" : "24:46:43" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "24:51:59" , 
"departure_time" : "24:53:13" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:59:14" , 
"departure_time" : "25:00:31" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "25:19:17" , 
"departure_time" : "25:19:17" , 
"distance_traveled" : 50.8155
} ], 
"3032" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "15:46:00" , 
"departure_time" : "15:48:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "15:54:28" , 
"departure_time" : "15:55:28" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "15:58:00" , 
"departure_time" : "15:59:16" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "16:04:16" , 
"departure_time" : "16:05:55" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "16:10:39" , 
"departure_time" : "16:12:12" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "16:14:33" , 
"departure_time" : "16:16:11" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "16:24:38" , 
"departure_time" : "16:25:45" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "16:28:07" , 
"departure_time" : "16:29:41" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "16:34:34" , 
"departure_time" : "16:35:04" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "16:36:30" , 
"departure_time" : "16:38:01" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "16:43:31" , 
"departure_time" : "16:44:06" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "16:46:35" , 
"departure_time" : "16:46:57" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "16:53:22" , 
"departure_time" : "16:53:28" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 109,
"arrival_time" : "16:56:06" , 
"departure_time" : "16:56:21" , 
"distance_traveled" : 36.4301
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:59:15" , 
"departure_time" : "17:00:33" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:07:18" , 
"departure_time" : "17:08:00" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:16:42" , 
"departure_time" : "17:16:58" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "17:28:16" , 
"departure_time" : "17:28:16" , 
"distance_traveled" : 50.8152
} ], 
"3033" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "05:57:00" , 
"departure_time" : "05:58:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "06:02:18" , 
"departure_time" : "06:02:59" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "06:06:41" , 
"departure_time" : "06:08:06" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "06:11:25" , 
"departure_time" : "06:12:25" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "06:15:00" , 
"departure_time" : "06:15:04" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "06:18:04" , 
"departure_time" : "06:18:38" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "06:22:34" , 
"departure_time" : "06:23:20" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "06:26:46" , 
"departure_time" : "06:27:28" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "06:30:42" , 
"departure_time" : "06:30:55" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "06:35:13" , 
"departure_time" : "06:36:51" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 73,
"arrival_time" : "06:43:38" , 
"departure_time" : "06:44:36" , 
"distance_traveled" : 19.2108
}, 
{ 
"stop_id" : 130,
"arrival_time" : "06:46:58" , 
"departure_time" : "06:47:01" , 
"distance_traveled" : 21.5562
}, 
{ 
"stop_id" : 85,
"arrival_time" : "06:52:03" , 
"departure_time" : "06:53:05" , 
"distance_traveled" : 25.1807
}, 
{ 
"stop_id" : 59,
"arrival_time" : "06:59:02" , 
"departure_time" : "06:59:55" , 
"distance_traveled" : 29.5975
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "07:03:53" , 
"departure_time" : "07:04:47" , 
"distance_traveled" : 31.3854
}, 
{ 
"stop_id" : 139,
"arrival_time" : "07:13:54" , 
"departure_time" : "07:14:56" , 
"distance_traveled" : 36.7695
}, 
{ 
"stop_id" : 158,
"arrival_time" : "07:23:02" , 
"departure_time" : "07:23:19" , 
"distance_traveled" : 42.0614
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:41:17" , 
"departure_time" : "07:41:40" , 
"distance_traveled" : 56.4417
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:00:23" , 
"departure_time" : "08:00:23" , 
"distance_traveled" : 66.4989
} ], 
"3034" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "11:54:00" , 
"departure_time" : "11:54:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "12:01:28" , 
"departure_time" : "12:01:52" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "12:05:24" , 
"departure_time" : "12:05:31" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "12:11:07" , 
"departure_time" : "12:12:24" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "12:18:17" , 
"departure_time" : "12:19:45" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "12:22:28" , 
"departure_time" : "12:23:26" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "12:30:58" , 
"departure_time" : "12:32:19" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "12:36:21" , 
"departure_time" : "12:37:13" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "12:40:52" , 
"departure_time" : "12:41:23" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "12:44:31" , 
"departure_time" : "12:46:05" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "12:52:34" , 
"departure_time" : "12:53:00" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "12:55:26" , 
"departure_time" : "12:56:59" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "13:02:33" , 
"departure_time" : "13:04:07" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:07:34" , 
"departure_time" : "13:08:47" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:14:13" , 
"departure_time" : "13:14:58" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:20:45" , 
"departure_time" : "13:21:19" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "13:33:34" , 
"departure_time" : "13:33:34" , 
"distance_traveled" : 50.8155
} ], 
"3035" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "07:57:00" , 
"departure_time" : "07:59:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "08:04:26" , 
"departure_time" : "08:04:34" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "08:07:08" , 
"departure_time" : "08:08:46" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "08:14:38" , 
"departure_time" : "08:14:59" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "08:19:21" , 
"departure_time" : "08:19:58" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "08:23:37" , 
"departure_time" : "08:25:02" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "08:34:25" , 
"departure_time" : "08:34:34" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "08:37:09" , 
"departure_time" : "08:38:11" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "08:44:02" , 
"departure_time" : "08:44:46" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "08:46:44" , 
"departure_time" : "08:48:01" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:54:17" , 
"departure_time" : "08:55:18" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "08:58:01" , 
"departure_time" : "08:59:39" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "09:05:38" , 
"departure_time" : "09:06:48" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 109,
"arrival_time" : "09:08:10" , 
"departure_time" : "09:08:27" , 
"distance_traveled" : 36.4301
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:11:17" , 
"departure_time" : "09:12:13" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:17:56" , 
"departure_time" : "09:18:38" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:24:42" , 
"departure_time" : "09:25:28" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:37:46" , 
"departure_time" : "09:37:46" , 
"distance_traveled" : 50.8155
} ], 
"3036" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "23:33:00" , 
"departure_time" : "23:33:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "23:39:01" , 
"departure_time" : "23:39:13" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "23:44:12" , 
"departure_time" : "23:44:58" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "23:49:46" , 
"departure_time" : "23:51:08" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "23:56:22" , 
"departure_time" : "23:57:01" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "23:59:39" , 
"departure_time" : "23:59:46" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "24:09:07" , 
"departure_time" : "24:10:20" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "24:15:13" , 
"departure_time" : "24:16:19" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "24:20:06" , 
"departure_time" : "24:21:25" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "24:24:19" , 
"departure_time" : "24:25:15" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "24:29:56" , 
"departure_time" : "24:30:30" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "24:33:34" , 
"departure_time" : "24:34:05" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "24:40:31" , 
"departure_time" : "24:40:38" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "24:45:07" , 
"departure_time" : "24:45:23" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "24:51:16" , 
"departure_time" : "24:52:13" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:58:57" , 
"departure_time" : "24:59:44" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "25:18:47" , 
"departure_time" : "25:18:47" , 
"distance_traveled" : 50.8155
} ], 
"3037" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "05:20:00" , 
"departure_time" : "05:21:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "05:24:39" , 
"departure_time" : "05:25:00" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "05:29:21" , 
"departure_time" : "05:30:48" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "05:34:27" , 
"departure_time" : "05:35:37" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "05:38:10" , 
"departure_time" : "05:38:16" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "05:41:06" , 
"departure_time" : "05:42:10" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "05:46:04" , 
"departure_time" : "05:46:51" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "05:49:47" , 
"departure_time" : "05:50:10" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "05:53:23" , 
"departure_time" : "05:55:01" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "06:00:38" , 
"departure_time" : "06:01:38" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 73,
"arrival_time" : "06:06:00" , 
"departure_time" : "06:06:25" , 
"distance_traveled" : 19.2108
}, 
{ 
"stop_id" : 130,
"arrival_time" : "06:09:25" , 
"departure_time" : "06:10:51" , 
"distance_traveled" : 21.5562
}, 
{ 
"stop_id" : 85,
"arrival_time" : "06:16:26" , 
"departure_time" : "06:18:01" , 
"distance_traveled" : 25.1807
}, 
{ 
"stop_id" : 59,
"arrival_time" : "06:22:35" , 
"departure_time" : "06:22:52" , 
"distance_traveled" : 29.5975
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "06:26:17" , 
"departure_time" : "06:27:13" , 
"distance_traveled" : 31.3854
}, 
{ 
"stop_id" : 139,
"arrival_time" : "06:35:56" , 
"departure_time" : "06:37:24" , 
"distance_traveled" : 36.7695
}, 
{ 
"stop_id" : 158,
"arrival_time" : "06:45:28" , 
"departure_time" : "06:46:29" , 
"distance_traveled" : 42.0614
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:04:01" , 
"departure_time" : "07:05:00" , 
"distance_traveled" : 56.4417
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:12:59" , 
"departure_time" : "07:13:46" , 
"distance_traveled" : 61.5104
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:25:47" , 
"departure_time" : "07:25:47" , 
"distance_traveled" : 66.4989
} ], 
"3038" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "05:57:00" , 
"departure_time" : "05:58:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "06:01:18" , 
"departure_time" : "06:02:16" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "06:06:58" , 
"departure_time" : "06:07:37" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "06:10:39" , 
"departure_time" : "06:12:05" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "06:15:26" , 
"departure_time" : "06:16:08" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "06:18:42" , 
"departure_time" : "06:20:22" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "06:23:40" , 
"departure_time" : "06:25:17" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "06:27:37" , 
"departure_time" : "06:28:22" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "06:30:45" , 
"departure_time" : "06:31:23" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "06:35:38" , 
"departure_time" : "06:37:05" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 73,
"arrival_time" : "06:43:27" , 
"departure_time" : "06:44:51" , 
"distance_traveled" : 19.2108
}, 
{ 
"stop_id" : 130,
"arrival_time" : "06:47:24" , 
"departure_time" : "06:47:31" , 
"distance_traveled" : 21.5562
}, 
{ 
"stop_id" : 85,
"arrival_time" : "06:52:07" , 
"departure_time" : "06:52:16" , 
"distance_traveled" : 25.1807
}, 
{ 
"stop_id" : 59,
"arrival_time" : "06:58:09" , 
"departure_time" : "06:59:28" , 
"distance_traveled" : 29.5975
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "07:04:19" , 
"departure_time" : "07:04:47" , 
"distance_traveled" : 31.3854
}, 
{ 
"stop_id" : 139,
"arrival_time" : "07:13:28" , 
"departure_time" : "07:13:40" , 
"distance_traveled" : 36.7695
}, 
{ 
"stop_id" : 158,
"arrival_time" : "07:22:12" , 
"departure_time" : "07:23:42" , 
"distance_traveled" : 42.0614
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:42:30" , 
"departure_time" : "07:43:05" , 
"distance_traveled" : 56.4417
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:00:35" , 
"departure_time" : "08:00:35" , 
"distance_traveled" : 66.4989
} ], 
"3039" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "06:54:00" , 
"departure_time" : "06:55:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "06:58:39" , 
"departure_time" : "07:00:04" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "07:04:25" , 
"departure_time" : "07:05:08" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "07:07:43" , 
"departure_time" : "07:08:43" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "07:12:00" , 
"departure_time" : "07:12:27" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "07:16:27" , 
"departure_time" : "07:16:50" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "07:19:23" , 
"departure_time" : "07:20:20" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "07:23:57" , 
"departure_time" : "07:25:00" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "07:28:03" , 
"departure_time" : "07:29:04" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "07:34:01" , 
"departure_time" : "07:34:30" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 73,
"arrival_time" : "07:39:29" , 
"departure_time" : "07:41:03" , 
"distance_traveled" : 19.2108
}, 
{ 
"stop_id" : 130,
"arrival_time" : "07:45:34" , 
"departure_time" : "07:46:15" , 
"distance_traveled" : 21.5562
}, 
{ 
"stop_id" : 85,
"arrival_time" : "07:50:41" , 
"departure_time" : "07:51:58" , 
"distance_traveled" : 25.1807
}, 
{ 
"stop_id" : 59,
"arrival_time" : "07:57:17" , 
"departure_time" : "07:58:22" , 
"distance_traveled" : 29.5975
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "08:02:05" , 
"departure_time" : "08:02:53" , 
"distance_traveled" : 31.3854
}, 
{ 
"stop_id" : 139,
"arrival_time" : "08:11:48" , 
"departure_time" : "08:12:09" , 
"distance_traveled" : 36.7695
}, 
{ 
"stop_id" : 119,
"arrival_time" : "08:15:21" , 
"departure_time" : "08:15:26" , 
"distance_traveled" : 38.6436
}, 
{ 
"stop_id" : 158,
"arrival_time" : "08:21:05" , 
"departure_time" : "08:21:26" , 
"distance_traveled" : 42.0614
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:42:21" , 
"departure_time" : "08:42:47" , 
"distance_traveled" : 56.4417
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:50:26" , 
"departure_time" : "08:50:27" , 
"distance_traveled" : 61.5104
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:03:01" , 
"departure_time" : "09:03:01" , 
"distance_traveled" : 66.4989
} ], 
"3040" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "07:57:00" , 
"departure_time" : "07:58:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "08:04:40" , 
"departure_time" : "08:05:52" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "08:08:12" , 
"departure_time" : "08:08:52" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "08:13:40" , 
"departure_time" : "08:14:40" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "08:20:00" , 
"departure_time" : "08:20:10" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "08:23:10" , 
"departure_time" : "08:24:50" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "08:34:40" , 
"departure_time" : "08:36:17" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "08:38:37" , 
"departure_time" : "08:39:04" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "08:43:27" , 
"departure_time" : "08:43:43" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "08:46:16" , 
"departure_time" : "08:47:32" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:54:16" , 
"departure_time" : "08:55:37" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "08:58:21" , 
"departure_time" : "08:58:32" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "09:04:11" , 
"departure_time" : "09:04:14" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 109,
"arrival_time" : "09:07:03" , 
"departure_time" : "09:07:29" , 
"distance_traveled" : 36.4301
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:11:26" , 
"departure_time" : "09:12:29" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:18:03" , 
"departure_time" : "09:18:39" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:24:36" , 
"departure_time" : "09:25:08" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:37:32" , 
"departure_time" : "09:37:32" , 
"distance_traveled" : 50.8155
} ], 
"3041" :  [ 
{ 
"stop_id" : 139,
"arrival_time" : "17:47:00" , 
"departure_time" : "17:48:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 119,
"arrival_time" : "17:51:41" , 
"departure_time" : "17:53:13" , 
"distance_traveled" : 1.882
}, 
{ 
"stop_id" : 158,
"arrival_time" : "17:58:32" , 
"departure_time" : "18:00:08" , 
"distance_traveled" : 5.2998
}, 
{ 
"stop_id" : 11,
"arrival_time" : "18:02:36" , 
"departure_time" : "18:03:53" , 
"distance_traveled" : 6.7583
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:09:17" , 
"departure_time" : "18:10:04" , 
"distance_traveled" : 9.0432
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:18:47" , 
"departure_time" : "18:19:42" , 
"distance_traveled" : 17.211
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:26:55" , 
"departure_time" : "18:26:59" , 
"distance_traveled" : 19.6892
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:44:04" , 
"departure_time" : "18:44:04" , 
"distance_traveled" : 29.746
} ], 
"3042" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "05:20:00" , 
"departure_time" : "05:21:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "05:25:37" , 
"departure_time" : "05:25:55" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "05:29:18" , 
"departure_time" : "05:30:16" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "05:33:58" , 
"departure_time" : "05:34:50" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "05:37:52" , 
"departure_time" : "05:39:13" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "05:42:21" , 
"departure_time" : "05:43:06" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "05:45:45" , 
"departure_time" : "05:46:56" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "05:50:11" , 
"departure_time" : "05:50:22" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "05:53:11" , 
"departure_time" : "05:54:24" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "06:00:13" , 
"departure_time" : "06:01:47" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 73,
"arrival_time" : "06:06:34" , 
"departure_time" : "06:07:49" , 
"distance_traveled" : 19.2108
}, 
{ 
"stop_id" : 130,
"arrival_time" : "06:10:15" , 
"departure_time" : "06:10:59" , 
"distance_traveled" : 21.5562
}, 
{ 
"stop_id" : 85,
"arrival_time" : "06:15:44" , 
"departure_time" : "06:17:15" , 
"distance_traveled" : 25.1807
}, 
{ 
"stop_id" : 59,
"arrival_time" : "06:22:31" , 
"departure_time" : "06:23:45" , 
"distance_traveled" : 29.5975
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "06:27:14" , 
"departure_time" : "06:28:54" , 
"distance_traveled" : 31.3854
}, 
{ 
"stop_id" : 139,
"arrival_time" : "06:36:40" , 
"departure_time" : "06:37:29" , 
"distance_traveled" : 36.7695
}, 
{ 
"stop_id" : 158,
"arrival_time" : "06:44:49" , 
"departure_time" : "06:46:05" , 
"distance_traveled" : 42.0614
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:04:16" , 
"departure_time" : "07:05:55" , 
"distance_traveled" : 56.4417
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:13:39" , 
"departure_time" : "07:15:13" , 
"distance_traveled" : 61.5104
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:26:34" , 
"departure_time" : "07:26:34" , 
"distance_traveled" : 66.4989
} ], 
"3043" :  [ 
{ 
"stop_id" : 139,
"arrival_time" : "16:46:00" , 
"departure_time" : "16:48:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 119,
"arrival_time" : "16:50:49" , 
"departure_time" : "16:50:59" , 
"distance_traveled" : 1.882
}, 
{ 
"stop_id" : 158,
"arrival_time" : "16:56:10" , 
"departure_time" : "16:57:25" , 
"distance_traveled" : 5.2998
}, 
{ 
"stop_id" : 127,
"arrival_time" : "17:04:15" , 
"departure_time" : "17:04:21" , 
"distance_traveled" : 9.0341
}, 
{ 
"stop_id" : 70,
"arrival_time" : "17:07:06" , 
"departure_time" : "17:07:47" , 
"distance_traveled" : 11.0926
}, 
{ 
"stop_id" : 41,
"arrival_time" : "17:14:41" , 
"departure_time" : "17:15:06" , 
"distance_traveled" : 14.3761
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:23:25" , 
"departure_time" : "17:24:07" , 
"distance_traveled" : 19.6801
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:30:42" , 
"departure_time" : "17:31:09" , 
"distance_traveled" : 24.7489
}, 
{ 
"stop_id" : 105,
"arrival_time" : "17:43:27" , 
"departure_time" : "17:43:27" , 
"distance_traveled" : 29.7369
} ], 
"3044" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "06:54:00" , 
"departure_time" : "06:55:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "06:58:49" , 
"departure_time" : "06:59:27" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "07:03:38" , 
"departure_time" : "07:03:46" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "07:07:08" , 
"departure_time" : "07:07:32" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "07:11:24" , 
"departure_time" : "07:12:32" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "07:17:08" , 
"departure_time" : "07:17:41" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "07:19:33" , 
"departure_time" : "07:19:44" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "07:23:11" , 
"departure_time" : "07:23:54" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "07:27:43" , 
"departure_time" : "07:28:35" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "07:33:52" , 
"departure_time" : "07:35:10" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 73,
"arrival_time" : "07:40:18" , 
"departure_time" : "07:41:09" , 
"distance_traveled" : 19.2108
}, 
{ 
"stop_id" : 130,
"arrival_time" : "07:44:51" , 
"departure_time" : "07:45:34" , 
"distance_traveled" : 21.5562
}, 
{ 
"stop_id" : 85,
"arrival_time" : "07:50:43" , 
"departure_time" : "07:52:09" , 
"distance_traveled" : 25.1807
}, 
{ 
"stop_id" : 59,
"arrival_time" : "07:57:26" , 
"departure_time" : "07:57:58" , 
"distance_traveled" : 29.5975
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "08:01:32" , 
"departure_time" : "08:01:58" , 
"distance_traveled" : 31.3854
}, 
{ 
"stop_id" : 139,
"arrival_time" : "08:11:26" , 
"departure_time" : "08:12:35" , 
"distance_traveled" : 36.7695
}, 
{ 
"stop_id" : 119,
"arrival_time" : "08:16:09" , 
"departure_time" : "08:17:24" , 
"distance_traveled" : 38.6436
}, 
{ 
"stop_id" : 158,
"arrival_time" : "08:22:15" , 
"departure_time" : "08:23:02" , 
"distance_traveled" : 42.0614
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:42:47" , 
"departure_time" : "08:43:41" , 
"distance_traveled" : 56.4417
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:50:54" , 
"departure_time" : "08:52:02" , 
"distance_traveled" : 61.5104
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:04:08" , 
"departure_time" : "09:04:08" , 
"distance_traveled" : 66.4989
} ], 
"3045" :  [ 
{ 
"stop_id" : 139,
"arrival_time" : "17:47:00" , 
"departure_time" : "17:48:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 119,
"arrival_time" : "17:51:10" , 
"departure_time" : "17:51:23" , 
"distance_traveled" : 1.882
}, 
{ 
"stop_id" : 158,
"arrival_time" : "17:57:13" , 
"departure_time" : "17:58:21" , 
"distance_traveled" : 5.2998
}, 
{ 
"stop_id" : 11,
"arrival_time" : "18:02:08" , 
"departure_time" : "18:03:37" , 
"distance_traveled" : 6.7583
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:09:29" , 
"departure_time" : "18:10:21" , 
"distance_traveled" : 9.0432
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:18:52" , 
"departure_time" : "18:19:09" , 
"distance_traveled" : 17.211
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:26:17" , 
"departure_time" : "18:26:47" , 
"distance_traveled" : 19.6892
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:44:30" , 
"departure_time" : "18:44:30" , 
"distance_traveled" : 29.746
} ], 
"3046" :  [ 
{ 
"stop_id" : 139,
"arrival_time" : "16:46:00" , 
"departure_time" : "16:48:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 119,
"arrival_time" : "16:51:37" , 
"departure_time" : "16:51:43" , 
"distance_traveled" : 1.882
}, 
{ 
"stop_id" : 158,
"arrival_time" : "16:56:06" , 
"departure_time" : "16:56:17" , 
"distance_traveled" : 5.2998
}, 
{ 
"stop_id" : 127,
"arrival_time" : "17:03:11" , 
"departure_time" : "17:04:20" , 
"distance_traveled" : 9.0341
}, 
{ 
"stop_id" : 70,
"arrival_time" : "17:08:09" , 
"departure_time" : "17:08:37" , 
"distance_traveled" : 11.0926
}, 
{ 
"stop_id" : 41,
"arrival_time" : "17:14:28" , 
"departure_time" : "17:15:58" , 
"distance_traveled" : 14.3761
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:24:30" , 
"departure_time" : "17:25:18" , 
"distance_traveled" : 19.6801
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:30:48" , 
"departure_time" : "17:32:17" , 
"distance_traveled" : 24.7489
}, 
{ 
"stop_id" : 105,
"arrival_time" : "17:44:29" , 
"departure_time" : "17:44:29" , 
"distance_traveled" : 29.7369
} ], 
"3047" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "04:03:00" , 
"departure_time" : "04:05:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "04:09:31" , 
"departure_time" : "04:10:24" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "04:13:53" , 
"departure_time" : "04:14:56" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "04:20:03" , 
"departure_time" : "04:20:25" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "04:25:22" , 
"departure_time" : "04:26:49" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "04:30:27" , 
"departure_time" : "04:31:46" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "04:40:19" , 
"departure_time" : "04:41:03" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "04:43:44" , 
"departure_time" : "04:44:42" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "04:49:58" , 
"departure_time" : "04:50:36" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "04:53:38" , 
"departure_time" : "04:54:21" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "05:00:43" , 
"departure_time" : "05:01:55" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "05:05:12" , 
"departure_time" : "05:06:05" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "05:10:53" , 
"departure_time" : "05:12:25" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 109,
"arrival_time" : "05:14:32" , 
"departure_time" : "05:15:24" , 
"distance_traveled" : 36.4301
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "05:16:52" , 
"departure_time" : "05:16:54" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "05:21:02" , 
"departure_time" : "05:21:20" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:29:18" , 
"departure_time" : "05:29:51" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "05:43:33" , 
"departure_time" : "05:43:33" , 
"distance_traveled" : 50.8152
} ], 
"3048" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "09:04:00" , 
"departure_time" : "09:05:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "09:11:05" , 
"departure_time" : "09:12:05" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "09:16:00" , 
"departure_time" : "09:17:20" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "09:21:20" , 
"departure_time" : "09:21:56" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "09:26:36" , 
"departure_time" : "09:27:39" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "09:31:03" , 
"departure_time" : "09:31:46" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "09:40:43" , 
"departure_time" : "09:42:02" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "09:46:19" , 
"departure_time" : "09:46:41" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "09:50:22" , 
"departure_time" : "09:50:23" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "09:53:01" , 
"departure_time" : "09:53:33" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "10:00:32" , 
"departure_time" : "10:01:28" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "10:04:56" , 
"departure_time" : "10:06:04" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "10:12:08" , 
"departure_time" : "10:13:40" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:16:32" , 
"departure_time" : "10:16:37" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:22:05" , 
"departure_time" : "10:23:00" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:29:55" , 
"departure_time" : "10:30:31" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:41:36" , 
"departure_time" : "10:41:36" , 
"distance_traveled" : 50.8152
} ], 
"3049" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "24:19:00" , 
"departure_time" : "24:21:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "24:26:27" , 
"departure_time" : "24:26:59" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "24:30:32" , 
"departure_time" : "24:31:07" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "24:35:35" , 
"departure_time" : "24:36:17" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "24:41:42" , 
"departure_time" : "24:42:08" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "24:45:26" , 
"departure_time" : "24:46:27" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "24:56:01" , 
"departure_time" : "24:56:39" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "25:00:38" , 
"departure_time" : "25:00:57" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "25:05:19" , 
"departure_time" : "25:05:56" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "25:08:37" , 
"departure_time" : "25:08:57" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "25:15:20" , 
"departure_time" : "25:15:31" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "25:19:11" , 
"departure_time" : "25:20:40" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "25:26:29" , 
"departure_time" : "25:27:14" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 109,
"arrival_time" : "25:28:45" , 
"departure_time" : "25:29:58" , 
"distance_traveled" : 36.4301
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "25:32:13" , 
"departure_time" : "25:32:35" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "25:37:22" , 
"departure_time" : "25:37:23" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "25:45:01" , 
"departure_time" : "25:46:27" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "26:04:26" , 
"departure_time" : "26:04:26" , 
"distance_traveled" : 50.8152
} ], 
"3050" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "12:06:00" , 
"departure_time" : "12:07:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "12:13:24" , 
"departure_time" : "12:14:24" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "12:18:00" , 
"departure_time" : "12:19:23" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "12:24:23" , 
"departure_time" : "12:25:13" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "12:29:50" , 
"departure_time" : "12:30:07" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "12:33:17" , 
"departure_time" : "12:34:10" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "12:42:53" , 
"departure_time" : "12:44:25" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "12:48:32" , 
"departure_time" : "12:49:00" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "12:53:28" , 
"departure_time" : "12:54:25" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 127,
"arrival_time" : "13:00:57" , 
"departure_time" : "13:02:22" , 
"distance_traveled" : 30.1032
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:12:25" , 
"departure_time" : "13:13:33" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:18:08" , 
"departure_time" : "13:19:01" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:25:53" , 
"departure_time" : "13:27:24" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "13:39:31" , 
"departure_time" : "13:39:31" , 
"distance_traveled" : 50.8061
} ], 
"3051" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "17:03:00" , 
"departure_time" : "17:06:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "17:11:33" , 
"departure_time" : "17:12:28" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "17:15:55" , 
"departure_time" : "17:16:49" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "17:20:54" , 
"departure_time" : "17:21:04" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "17:26:10" , 
"departure_time" : "17:27:34" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "17:31:24" , 
"departure_time" : "17:32:58" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "17:41:34" , 
"departure_time" : "17:42:03" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "17:45:29" , 
"departure_time" : "17:45:57" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "17:50:28" , 
"departure_time" : "17:51:03" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "17:53:35" , 
"departure_time" : "17:54:12" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:00:37" , 
"departure_time" : "18:02:06" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:12:29" , 
"departure_time" : "18:13:43" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:18:14" , 
"departure_time" : "18:18:46" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:24:32" , 
"departure_time" : "18:25:08" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:37:36" , 
"departure_time" : "18:37:36" , 
"distance_traveled" : 50.8152
} ], 
"3052" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "18:03:00" , 
"departure_time" : "18:03:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "18:10:16" , 
"departure_time" : "18:11:53" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "18:16:37" , 
"departure_time" : "18:17:49" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "18:21:12" , 
"departure_time" : "18:21:48" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "18:26:36" , 
"departure_time" : "18:26:39" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "18:30:03" , 
"departure_time" : "18:30:38" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "18:40:35" , 
"departure_time" : "18:41:24" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "18:45:49" , 
"departure_time" : "18:46:27" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "18:50:38" , 
"departure_time" : "18:51:29" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "18:53:51" , 
"departure_time" : "18:54:01" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "19:00:10" , 
"departure_time" : "19:01:10" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:12:00" , 
"departure_time" : "19:12:13" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:17:13" , 
"departure_time" : "19:17:40" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:24:27" , 
"departure_time" : "19:25:15" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "19:37:48" , 
"departure_time" : "19:37:48" , 
"distance_traveled" : 50.8152
} ], 
"3053" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "10:04:00" , 
"departure_time" : "10:05:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "10:12:04" , 
"departure_time" : "10:12:30" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "10:16:26" , 
"departure_time" : "10:17:54" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "10:22:28" , 
"departure_time" : "10:24:06" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "10:28:38" , 
"departure_time" : "10:30:17" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "10:32:39" , 
"departure_time" : "10:33:15" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "10:41:36" , 
"departure_time" : "10:41:41" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "10:46:05" , 
"departure_time" : "10:46:52" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "10:51:47" , 
"departure_time" : "10:52:08" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 127,
"arrival_time" : "11:00:21" , 
"departure_time" : "11:00:44" , 
"distance_traveled" : 30.1032
}, 
{ 
"stop_id" : 70,
"arrival_time" : "11:04:23" , 
"departure_time" : "11:05:52" , 
"distance_traveled" : 32.1617
}, 
{ 
"stop_id" : 41,
"arrival_time" : "11:12:29" , 
"departure_time" : "11:12:58" , 
"distance_traveled" : 35.4453
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "11:15:29" , 
"departure_time" : "11:17:05" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:23:36" , 
"departure_time" : "11:25:00" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:30:24" , 
"departure_time" : "11:30:55" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "11:42:31" , 
"departure_time" : "11:42:31" , 
"distance_traveled" : 50.8061
} ], 
"3054" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "14:04:00" , 
"departure_time" : "14:06:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "14:12:34" , 
"departure_time" : "14:12:46" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "14:16:12" , 
"departure_time" : "14:16:22" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "14:21:10" , 
"departure_time" : "14:21:37" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "14:27:27" , 
"departure_time" : "14:28:43" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "14:32:16" , 
"departure_time" : "14:33:39" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "14:42:23" , 
"departure_time" : "14:42:52" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "14:46:29" , 
"departure_time" : "14:47:10" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "14:51:41" , 
"departure_time" : "14:52:23" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 127,
"arrival_time" : "15:00:42" , 
"departure_time" : "15:00:57" , 
"distance_traveled" : 30.1032
}, 
{ 
"stop_id" : 70,
"arrival_time" : "15:04:15" , 
"departure_time" : "15:04:48" , 
"distance_traveled" : 32.1617
}, 
{ 
"stop_id" : 41,
"arrival_time" : "15:11:33" , 
"departure_time" : "15:12:27" , 
"distance_traveled" : 35.4453
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "15:15:54" , 
"departure_time" : "15:16:13" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:22:19" , 
"departure_time" : "15:23:31" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:30:12" , 
"departure_time" : "15:30:56" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "15:42:44" , 
"departure_time" : "15:42:44" , 
"distance_traveled" : 50.8061
} ], 
"3055" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "11:03:00" , 
"departure_time" : "11:04:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "11:10:17" , 
"departure_time" : "11:10:40" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "11:15:23" , 
"departure_time" : "11:15:51" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "11:20:28" , 
"departure_time" : "11:20:29" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "11:26:01" , 
"departure_time" : "11:26:15" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "11:30:14" , 
"departure_time" : "11:31:25" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "11:41:11" , 
"departure_time" : "11:41:14" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "11:45:03" , 
"departure_time" : "11:46:24" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "11:51:21" , 
"departure_time" : "11:52:08" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "11:53:47" , 
"departure_time" : "11:54:17" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "12:00:30" , 
"departure_time" : "12:02:01" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "12:05:31" , 
"departure_time" : "12:07:03" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "12:12:32" , 
"departure_time" : "12:13:57" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "12:16:25" , 
"departure_time" : "12:17:22" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:22:57" , 
"departure_time" : "12:24:07" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:30:10" , 
"departure_time" : "12:30:16" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "12:42:06" , 
"departure_time" : "12:42:06" , 
"distance_traveled" : 50.8152
} ], 
"3056" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "13:14:00" , 
"departure_time" : "13:15:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "13:22:25" , 
"departure_time" : "13:22:41" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "13:26:16" , 
"departure_time" : "13:27:52" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "13:32:36" , 
"departure_time" : "13:33:42" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "13:38:06" , 
"departure_time" : "13:39:17" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "13:42:11" , 
"departure_time" : "13:42:47" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "13:51:36" , 
"departure_time" : "13:52:09" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "13:56:33" , 
"departure_time" : "13:57:32" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "14:01:59" , 
"departure_time" : "14:02:12" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "14:04:13" , 
"departure_time" : "14:04:41" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "14:11:28" , 
"departure_time" : "14:11:41" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "14:15:13" , 
"departure_time" : "14:15:54" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "14:22:41" , 
"departure_time" : "14:23:09" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "14:27:28" , 
"departure_time" : "14:28:16" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:33:48" , 
"departure_time" : "14:35:00" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:41:12" , 
"departure_time" : "14:42:25" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "14:54:13" , 
"departure_time" : "14:54:13" , 
"distance_traveled" : 50.8152
} ], 
"3057" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "19:14:00" , 
"departure_time" : "19:16:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "19:20:58" , 
"departure_time" : "19:22:25" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "19:25:27" , 
"departure_time" : "19:26:11" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "19:30:44" , 
"departure_time" : "19:30:58" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "19:36:14" , 
"departure_time" : "19:36:44" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "19:40:30" , 
"departure_time" : "19:41:19" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "19:49:49" , 
"departure_time" : "19:51:02" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "19:55:13" , 
"departure_time" : "19:56:04" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "20:00:51" , 
"departure_time" : "20:02:15" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "20:04:24" , 
"departure_time" : "20:05:42" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:10:18" , 
"departure_time" : "20:11:45" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "20:14:27" , 
"departure_time" : "20:15:53" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "20:21:26" , 
"departure_time" : "20:21:56" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:25:30" , 
"departure_time" : "20:26:51" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:32:21" , 
"departure_time" : "20:33:38" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:39:17" , 
"departure_time" : "20:39:36" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "20:51:19" , 
"departure_time" : "20:51:19" , 
"distance_traveled" : 50.8152
} ], 
"3058" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "21:14:00" , 
"departure_time" : "21:15:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "21:21:29" , 
"departure_time" : "21:23:04" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "21:25:35" , 
"departure_time" : "21:27:11" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "21:31:36" , 
"departure_time" : "21:31:42" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "21:36:06" , 
"departure_time" : "21:37:38" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "21:41:32" , 
"departure_time" : "21:42:13" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "21:49:41" , 
"departure_time" : "21:49:44" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "21:54:03" , 
"departure_time" : "21:55:25" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "22:01:22" , 
"departure_time" : "22:01:46" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "22:03:24" , 
"departure_time" : "22:03:31" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "22:09:07" , 
"departure_time" : "22:10:17" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "22:14:10" , 
"departure_time" : "22:14:16" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "22:20:06" , 
"departure_time" : "22:20:46" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:25:40" , 
"departure_time" : "22:27:13" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:32:33" , 
"departure_time" : "22:33:23" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:38:50" , 
"departure_time" : "22:39:48" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "22:51:58" , 
"departure_time" : "22:51:58" , 
"distance_traveled" : 50.8152
} ], 
"3059" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "20:09:00" , 
"departure_time" : "20:11:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "20:17:36" , 
"departure_time" : "20:18:37" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "20:22:01" , 
"departure_time" : "20:23:30" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "20:27:29" , 
"departure_time" : "20:28:52" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "20:33:23" , 
"departure_time" : "20:34:13" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "20:36:50" , 
"departure_time" : "20:37:37" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "20:46:47" , 
"departure_time" : "20:47:23" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "20:51:36" , 
"departure_time" : "20:52:10" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "20:56:34" , 
"departure_time" : "20:58:11" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 127,
"arrival_time" : "21:06:37" , 
"departure_time" : "21:08:00" , 
"distance_traveled" : 30.1032
}, 
{ 
"stop_id" : 70,
"arrival_time" : "21:10:23" , 
"departure_time" : "21:11:46" , 
"distance_traveled" : 32.1617
}, 
{ 
"stop_id" : 41,
"arrival_time" : "21:17:23" , 
"departure_time" : "21:18:41" , 
"distance_traveled" : 35.4453
}, 
{ 
"stop_id" : 109,
"arrival_time" : "21:20:18" , 
"departure_time" : "21:21:12" , 
"distance_traveled" : 36.421
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "21:22:54" , 
"departure_time" : "21:23:04" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:29:10" , 
"departure_time" : "21:29:39" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:36:29" , 
"departure_time" : "21:37:05" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "21:49:36" , 
"departure_time" : "21:49:36" , 
"distance_traveled" : 50.8061
} ], 
"3060" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "22:04:00" , 
"departure_time" : "22:05:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "22:10:34" , 
"departure_time" : "22:10:36" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "22:15:02" , 
"departure_time" : "22:15:45" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "22:20:43" , 
"departure_time" : "22:22:19" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "22:27:36" , 
"departure_time" : "22:28:32" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "22:30:56" , 
"departure_time" : "22:30:59" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "22:40:03" , 
"departure_time" : "22:41:29" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "22:46:26" , 
"departure_time" : "22:47:36" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "22:51:10" , 
"departure_time" : "22:52:42" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 127,
"arrival_time" : "22:59:32" , 
"departure_time" : "22:59:59" , 
"distance_traveled" : 30.1032
}, 
{ 
"stop_id" : 70,
"arrival_time" : "23:02:27" , 
"departure_time" : "23:03:26" , 
"distance_traveled" : 32.1617
}, 
{ 
"stop_id" : 41,
"arrival_time" : "23:09:59" , 
"departure_time" : "23:11:36" , 
"distance_traveled" : 35.4453
}, 
{ 
"stop_id" : 109,
"arrival_time" : "23:13:37" , 
"departure_time" : "23:13:54" , 
"distance_traveled" : 36.421
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "23:15:17" , 
"departure_time" : "23:16:17" , 
"distance_traveled" : 38.271
}, 
{ 
"stop_id" : 107,
"arrival_time" : "23:23:00" , 
"departure_time" : "23:23:32" , 
"distance_traveled" : 40.7492
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:29:32" , 
"departure_time" : "23:30:30" , 
"distance_traveled" : 45.818
}, 
{ 
"stop_id" : 105,
"arrival_time" : "23:42:58" , 
"departure_time" : "23:42:58" , 
"distance_traveled" : 50.8061
} ], 
"3061" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "06:02:00" , 
"departure_time" : "06:04:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "06:09:33" , 
"departure_time" : "06:09:55" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "06:13:22" , 
"departure_time" : "06:15:00" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "06:19:38" , 
"departure_time" : "06:21:08" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "06:25:30" , 
"departure_time" : "06:26:13" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "06:28:43" , 
"departure_time" : "06:29:21" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "06:38:38" , 
"departure_time" : "06:39:01" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "06:43:23" , 
"departure_time" : "06:44:44" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "06:49:21" , 
"departure_time" : "06:49:27" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "06:51:06" , 
"departure_time" : "06:52:40" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "06:59:34" , 
"departure_time" : "07:00:53" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "07:03:19" , 
"departure_time" : "07:04:05" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "07:09:46" , 
"departure_time" : "07:10:27" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 109,
"arrival_time" : "07:12:41" , 
"departure_time" : "07:13:24" , 
"distance_traveled" : 36.4301
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "07:15:43" , 
"departure_time" : "07:16:03" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:22:20" , 
"departure_time" : "07:23:25" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:30:05" , 
"departure_time" : "07:31:41" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "07:43:36" , 
"departure_time" : "07:43:36" , 
"distance_traveled" : 50.8152
} ], 
"3062" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "07:02:00" , 
"departure_time" : "07:05:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "07:09:38" , 
"departure_time" : "07:11:12" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "07:14:34" , 
"departure_time" : "07:15:09" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "07:18:35" , 
"departure_time" : "07:18:52" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "07:24:17" , 
"departure_time" : "07:24:53" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "07:28:36" , 
"departure_time" : "07:29:10" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "07:38:34" , 
"departure_time" : "07:39:14" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "07:43:40" , 
"departure_time" : "07:44:27" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "07:48:47" , 
"departure_time" : "07:49:14" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "07:51:27" , 
"departure_time" : "07:52:22" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "07:58:55" , 
"departure_time" : "08:00:24" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "08:03:29" , 
"departure_time" : "08:04:23" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "08:09:54" , 
"departure_time" : "08:11:14" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 109,
"arrival_time" : "08:13:20" , 
"departure_time" : "08:14:49" , 
"distance_traveled" : 36.4301
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:16:29" , 
"departure_time" : "08:17:49" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:23:20" , 
"departure_time" : "08:24:17" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:29:57" , 
"departure_time" : "08:30:39" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:42:42" , 
"departure_time" : "08:42:42" , 
"distance_traveled" : 50.8152
} ], 
"3063" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "15:01:00" , 
"departure_time" : "15:03:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "15:09:39" , 
"departure_time" : "15:10:47" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "15:14:08" , 
"departure_time" : "15:14:57" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "15:18:49" , 
"departure_time" : "15:19:20" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "15:24:31" , 
"departure_time" : "15:25:58" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "15:29:27" , 
"departure_time" : "15:30:01" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "15:38:34" , 
"departure_time" : "15:39:05" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "15:43:31" , 
"departure_time" : "15:44:26" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "15:48:55" , 
"departure_time" : "15:50:09" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "15:52:14" , 
"departure_time" : "15:53:48" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "15:59:34" , 
"departure_time" : "16:00:01" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "16:02:27" , 
"departure_time" : "16:02:55" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "16:09:28" , 
"departure_time" : "16:10:42" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 109,
"arrival_time" : "16:13:14" , 
"departure_time" : "16:14:43" , 
"distance_traveled" : 36.4301
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:16:29" , 
"departure_time" : "16:16:32" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:22:03" , 
"departure_time" : "16:22:57" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:30:54" , 
"departure_time" : "16:32:00" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "16:44:06" , 
"departure_time" : "16:44:06" , 
"distance_traveled" : 50.8152
} ], 
"3064" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "16:01:00" , 
"departure_time" : "16:03:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "16:09:08" , 
"departure_time" : "16:09:24" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "16:13:16" , 
"departure_time" : "16:14:06" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "16:18:50" , 
"departure_time" : "16:20:04" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "16:25:14" , 
"departure_time" : "16:25:24" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "16:28:10" , 
"departure_time" : "16:28:26" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "16:38:16" , 
"departure_time" : "16:38:45" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "16:43:29" , 
"departure_time" : "16:44:11" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "16:48:42" , 
"departure_time" : "16:49:34" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "16:51:52" , 
"departure_time" : "16:52:22" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "16:58:30" , 
"departure_time" : "16:59:58" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "17:03:28" , 
"departure_time" : "17:05:02" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "17:10:34" , 
"departure_time" : "17:12:00" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 109,
"arrival_time" : "17:13:26" , 
"departure_time" : "17:14:14" , 
"distance_traveled" : 36.4301
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:15:48" , 
"departure_time" : "17:16:07" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:22:19" , 
"departure_time" : "17:23:20" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:31:01" , 
"departure_time" : "17:32:13" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "17:44:12" , 
"departure_time" : "17:44:12" , 
"distance_traveled" : 50.8152
} ], 
"3065" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "23:33:00" , 
"departure_time" : "23:34:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "23:39:17" , 
"departure_time" : "23:40:49" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "23:45:32" , 
"departure_time" : "23:45:51" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "23:49:19" , 
"departure_time" : "23:50:53" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "23:56:34" , 
"departure_time" : "23:56:36" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "23:59:02" , 
"departure_time" : "23:59:58" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "24:09:56" , 
"departure_time" : "24:10:11" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "24:14:15" , 
"departure_time" : "24:15:02" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "24:19:47" , 
"departure_time" : "24:20:38" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "24:23:51" , 
"departure_time" : "24:24:50" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "24:29:59" , 
"departure_time" : "24:31:39" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "24:34:40" , 
"departure_time" : "24:36:14" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "24:41:34" , 
"departure_time" : "24:43:09" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "24:46:35" , 
"departure_time" : "24:46:41" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "24:51:06" , 
"departure_time" : "24:52:13" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:59:07" , 
"departure_time" : "24:59:52" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "25:18:45" , 
"departure_time" : "25:18:45" , 
"distance_traveled" : 50.8155
} ], 
"3066" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "08:02:00" , 
"departure_time" : "08:03:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "08:08:37" , 
"departure_time" : "08:08:53" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "08:13:16" , 
"departure_time" : "08:13:47" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "08:18:31" , 
"departure_time" : "08:20:08" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "08:25:37" , 
"departure_time" : "08:26:11" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "08:28:34" , 
"departure_time" : "08:30:11" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "08:39:37" , 
"departure_time" : "08:39:40" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "08:43:03" , 
"departure_time" : "08:43:36" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "08:48:33" , 
"departure_time" : "08:50:09" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "08:52:36" , 
"departure_time" : "08:52:49" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:58:13" , 
"departure_time" : "08:58:58" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "09:02:45" , 
"departure_time" : "09:04:08" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "09:10:23" , 
"departure_time" : "09:11:04" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 109,
"arrival_time" : "09:12:41" , 
"departure_time" : "09:14:07" , 
"distance_traveled" : 36.4301
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:16:26" , 
"departure_time" : "09:17:04" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:22:38" , 
"departure_time" : "09:23:09" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:29:31" , 
"departure_time" : "09:30:23" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "09:42:52" , 
"departure_time" : "09:42:52" , 
"distance_traveled" : 50.8155
} ], 
"3067" :  [ 
{ 
"stop_id" : 127,
"arrival_time" : "13:14:00" , 
"departure_time" : "13:15:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 70,
"arrival_time" : "13:18:57" , 
"departure_time" : "13:19:57" , 
"distance_traveled" : 2.0659
}, 
{ 
"stop_id" : 41,
"arrival_time" : "13:26:00" , 
"departure_time" : "13:27:04" , 
"distance_traveled" : 5.3494
}, 
{ 
"stop_id" : 109,
"arrival_time" : "13:29:04" , 
"departure_time" : "13:29:53" , 
"distance_traveled" : 6.3252
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:32:49" , 
"departure_time" : "13:33:07" , 
"distance_traveled" : 8.1752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:38:18" , 
"departure_time" : "13:39:58" , 
"distance_traveled" : 10.6534
}, 
{ 
"stop_id" : 105,
"arrival_time" : "13:57:40" , 
"departure_time" : "13:57:40" , 
"distance_traveled" : 20.7102
} ], 
"3068" :  [ 
{ 
"stop_id" : 127,
"arrival_time" : "09:43:00" , 
"departure_time" : "09:45:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 70,
"arrival_time" : "09:48:14" , 
"departure_time" : "09:48:46" , 
"distance_traveled" : 2.0659
}, 
{ 
"stop_id" : 41,
"arrival_time" : "09:53:32" , 
"departure_time" : "09:53:41" , 
"distance_traveled" : 5.3494
}, 
{ 
"stop_id" : 109,
"arrival_time" : "09:56:09" , 
"departure_time" : "09:56:57" , 
"distance_traveled" : 6.3252
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:00:48" , 
"departure_time" : "10:01:52" , 
"distance_traveled" : 8.1752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:09:04" , 
"departure_time" : "10:10:34" , 
"distance_traveled" : 10.6534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:17:30" , 
"departure_time" : "10:17:34" , 
"distance_traveled" : 15.7222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:32:04" , 
"departure_time" : "10:32:04" , 
"distance_traveled" : 20.7102
} ], 
"3069" :  [ 
{ 
"stop_id" : 127,
"arrival_time" : "10:41:00" , 
"departure_time" : "10:41:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 70,
"arrival_time" : "10:45:37" , 
"departure_time" : "10:45:39" , 
"distance_traveled" : 2.0659
}, 
{ 
"stop_id" : 41,
"arrival_time" : "10:52:02" , 
"departure_time" : "10:52:22" , 
"distance_traveled" : 5.3494
}, 
{ 
"stop_id" : 109,
"arrival_time" : "10:55:20" , 
"departure_time" : "10:56:55" , 
"distance_traveled" : 6.3252
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "11:00:35" , 
"departure_time" : "11:01:39" , 
"distance_traveled" : 8.1752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:08:04" , 
"departure_time" : "11:08:41" , 
"distance_traveled" : 10.6534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:15:37" , 
"departure_time" : "11:15:39" , 
"distance_traveled" : 15.7222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "11:31:02" , 
"departure_time" : "11:31:02" , 
"distance_traveled" : 20.7102
} ], 
"3070" :  [ 
{ 
"stop_id" : 127,
"arrival_time" : "18:09:00" , 
"departure_time" : "18:10:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 70,
"arrival_time" : "18:14:40" , 
"departure_time" : "18:15:06" , 
"distance_traveled" : 2.0659
}, 
{ 
"stop_id" : 41,
"arrival_time" : "18:19:26" , 
"departure_time" : "18:19:52" , 
"distance_traveled" : 5.3494
}, 
{ 
"stop_id" : 109,
"arrival_time" : "18:22:26" , 
"departure_time" : "18:23:28" , 
"distance_traveled" : 6.3252
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:27:02" , 
"departure_time" : "18:27:17" , 
"distance_traveled" : 8.1752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:32:15" , 
"departure_time" : "18:32:37" , 
"distance_traveled" : 10.6534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:39:22" , 
"departure_time" : "18:39:26" , 
"distance_traveled" : 15.7222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "18:52:04" , 
"departure_time" : "18:52:04" , 
"distance_traveled" : 20.7102
} ], 
"3071" :  [ 
{ 
"stop_id" : 127,
"arrival_time" : "19:09:00" , 
"departure_time" : "19:10:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 70,
"arrival_time" : "19:14:14" , 
"departure_time" : "19:14:59" , 
"distance_traveled" : 2.0659
}, 
{ 
"stop_id" : 41,
"arrival_time" : "19:19:45" , 
"departure_time" : "19:21:14" , 
"distance_traveled" : 5.3494
}, 
{ 
"stop_id" : 109,
"arrival_time" : "19:23:29" , 
"departure_time" : "19:24:41" , 
"distance_traveled" : 6.3252
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:27:12" , 
"departure_time" : "19:28:07" , 
"distance_traveled" : 8.1752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:32:55" , 
"departure_time" : "19:34:14" , 
"distance_traveled" : 10.6534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:40:19" , 
"departure_time" : "19:41:33" , 
"distance_traveled" : 15.7222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "19:53:14" , 
"departure_time" : "19:53:14" , 
"distance_traveled" : 20.7102
} ], 
"3072" :  [ 
{ 
"stop_id" : 127,
"arrival_time" : "19:46:00" , 
"departure_time" : "19:47:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 70,
"arrival_time" : "19:50:33" , 
"departure_time" : "19:51:12" , 
"distance_traveled" : 2.0659
}, 
{ 
"stop_id" : 41,
"arrival_time" : "19:57:39" , 
"departure_time" : "19:57:40" , 
"distance_traveled" : 5.3494
}, 
{ 
"stop_id" : 109,
"arrival_time" : "20:00:01" , 
"departure_time" : "20:00:10" , 
"distance_traveled" : 6.3252
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:03:09" , 
"departure_time" : "20:04:11" , 
"distance_traveled" : 8.1752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:11:02" , 
"departure_time" : "20:12:24" , 
"distance_traveled" : 10.6534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:18:22" , 
"departure_time" : "20:18:54" , 
"distance_traveled" : 15.7222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "20:32:32" , 
"departure_time" : "20:32:32" , 
"distance_traveled" : 20.7102
} ], 
"3073" :  [ 
{ 
"stop_id" : 127,
"arrival_time" : "21:46:00" , 
"departure_time" : "21:46:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 70,
"arrival_time" : "21:50:19" , 
"departure_time" : "21:51:23" , 
"distance_traveled" : 2.0659
}, 
{ 
"stop_id" : 41,
"arrival_time" : "21:58:04" , 
"departure_time" : "21:58:08" , 
"distance_traveled" : 5.3494
}, 
{ 
"stop_id" : 109,
"arrival_time" : "22:00:04" , 
"departure_time" : "22:00:26" , 
"distance_traveled" : 6.3252
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:03:22" , 
"departure_time" : "22:04:25" , 
"distance_traveled" : 8.1752
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:11:03" , 
"departure_time" : "22:11:12" , 
"distance_traveled" : 10.6534
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:17:09" , 
"departure_time" : "22:17:30" , 
"distance_traveled" : 15.7222
}, 
{ 
"stop_id" : 105,
"arrival_time" : "22:32:21" , 
"departure_time" : "22:32:21" , 
"distance_traveled" : 20.7102
} ], 
"3074" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "04:46:00" , 
"departure_time" : "04:47:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 73,
"arrival_time" : "04:52:52" , 
"departure_time" : "04:53:14" , 
"distance_traveled" : 3.5184
}, 
{ 
"stop_id" : 130,
"arrival_time" : "04:57:22" , 
"departure_time" : "04:58:03" , 
"distance_traveled" : 5.8638
}, 
{ 
"stop_id" : 85,
"arrival_time" : "05:02:41" , 
"departure_time" : "05:02:42" , 
"distance_traveled" : 9.4883
}, 
{ 
"stop_id" : 59,
"arrival_time" : "05:08:01" , 
"departure_time" : "05:08:23" , 
"distance_traveled" : 13.9051
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "05:12:22" , 
"departure_time" : "05:12:31" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 139,
"arrival_time" : "05:22:09" , 
"departure_time" : "05:22:24" , 
"distance_traveled" : 21.0771
}, 
{ 
"stop_id" : 119,
"arrival_time" : "05:27:15" , 
"departure_time" : "05:28:54" , 
"distance_traveled" : 22.9511
}, 
{ 
"stop_id" : 158,
"arrival_time" : "05:33:39" , 
"departure_time" : "05:33:58" , 
"distance_traveled" : 26.3689
}, 
{ 
"stop_id" : 11,
"arrival_time" : "05:35:19" , 
"departure_time" : "05:35:25" , 
"distance_traveled" : 27.8275
}, 
{ 
"stop_id" : 127,
"arrival_time" : "05:42:06" , 
"departure_time" : "05:42:16" , 
"distance_traveled" : 30.1123
}, 
{ 
"stop_id" : 70,
"arrival_time" : "05:46:10" , 
"departure_time" : "05:46:35" , 
"distance_traveled" : 32.1708
}, 
{ 
"stop_id" : 41,
"arrival_time" : "05:53:25" , 
"departure_time" : "05:53:58" , 
"distance_traveled" : 35.4544
}, 
{ 
"stop_id" : 109,
"arrival_time" : "05:56:33" , 
"departure_time" : "05:57:10" , 
"distance_traveled" : 36.4301
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "06:00:37" , 
"departure_time" : "06:02:05" , 
"distance_traveled" : 38.2801
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:07:28" , 
"departure_time" : "06:08:23" , 
"distance_traveled" : 40.7583
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:13:55" , 
"departure_time" : "06:14:25" , 
"distance_traveled" : 45.8271
}, 
{ 
"stop_id" : 105,
"arrival_time" : "06:27:30" , 
"departure_time" : "06:27:30" , 
"distance_traveled" : 50.8152
} ], 
"3075" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "12:07:00" , 
"departure_time" : "12:08:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:17:03" , 
"departure_time" : "12:18:03" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:26:00" , 
"departure_time" : "12:27:11" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "12:32:11" , 
"departure_time" : "12:32:52" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 127,
"arrival_time" : "12:42:41" , 
"departure_time" : "12:43:58" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 158,
"arrival_time" : "12:50:17" , 
"departure_time" : "12:50:30" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "12:55:13" , 
"departure_time" : "12:56:44" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "13:01:31" , 
"departure_time" : "13:02:36" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "13:10:05" , 
"departure_time" : "13:11:33" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "13:13:28" , 
"departure_time" : "13:14:39" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "13:19:11" , 
"departure_time" : "13:20:15" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "13:25:04" , 
"departure_time" : "13:25:23" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "13:28:19" , 
"departure_time" : "13:29:33" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "13:39:14" , 
"departure_time" : "13:39:14" , 
"distance_traveled" : 50.8055
} ], 
"3076" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:07:00" , 
"departure_time" : "20:08:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:16:32" , 
"departure_time" : "20:17:19" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:25:47" , 
"departure_time" : "20:27:24" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:32:37" , 
"departure_time" : "20:34:04" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:44:27" , 
"departure_time" : "20:45:54" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "20:50:27" , 
"departure_time" : "20:52:06" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "20:53:39" , 
"departure_time" : "20:54:05" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "20:58:26" , 
"departure_time" : "20:58:38" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "21:03:12" , 
"departure_time" : "21:04:00" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "21:12:48" , 
"departure_time" : "21:13:22" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "21:16:34" , 
"departure_time" : "21:18:11" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "21:22:37" , 
"departure_time" : "21:23:32" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "21:27:55" , 
"departure_time" : "21:28:15" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "21:31:20" , 
"departure_time" : "21:31:37" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "21:40:17" , 
"departure_time" : "21:40:17" , 
"distance_traveled" : 50.8055
} ], 
"3077" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "21:07:00" , 
"departure_time" : "21:07:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:16:16" , 
"departure_time" : "21:17:27" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:26:11" , 
"departure_time" : "21:27:47" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "21:32:36" , 
"departure_time" : "21:33:10" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "21:36:34" , 
"departure_time" : "21:37:51" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "21:44:17" , 
"departure_time" : "21:45:29" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "21:48:12" , 
"departure_time" : "21:49:34" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 158,
"arrival_time" : "21:55:22" , 
"departure_time" : "21:55:50" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "22:00:28" , 
"departure_time" : "22:01:07" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "22:05:39" , 
"departure_time" : "22:06:16" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "22:14:37" , 
"departure_time" : "22:15:25" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "22:18:48" , 
"departure_time" : "22:20:12" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "22:25:24" , 
"departure_time" : "22:26:37" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "22:31:13" , 
"departure_time" : "22:31:46" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "22:34:33" , 
"departure_time" : "22:35:53" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "22:42:20" , 
"departure_time" : "22:42:20" , 
"distance_traveled" : 50.8055
} ], 
"3078" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "23:07:00" , 
"departure_time" : "23:09:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:17:22" , 
"departure_time" : "23:19:02" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "23:26:40" , 
"departure_time" : "23:26:49" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "23:31:09" , 
"departure_time" : "23:32:09" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "23:37:00" , 
"departure_time" : "23:38:10" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "23:44:10" , 
"departure_time" : "23:45:05" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "23:47:55" , 
"departure_time" : "23:49:01" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 158,
"arrival_time" : "23:55:06" , 
"departure_time" : "23:56:03" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "24:00:57" , 
"departure_time" : "24:01:23" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "24:05:26" , 
"departure_time" : "24:06:00" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "24:14:34" , 
"departure_time" : "24:16:13" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "24:19:39" , 
"departure_time" : "24:21:09" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "24:25:30" , 
"departure_time" : "24:25:45" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "24:30:15" , 
"departure_time" : "24:31:50" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "24:35:35" , 
"departure_time" : "24:36:38" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "24:42:03" , 
"departure_time" : "24:42:03" , 
"distance_traveled" : 50.8055
} ], 
"3079" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "25:00:00" , 
"departure_time" : "25:01:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "25:09:49" , 
"departure_time" : "25:10:01" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "25:18:12" , 
"departure_time" : "25:19:47" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "25:25:35" , 
"departure_time" : "25:26:14" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "25:29:39" , 
"departure_time" : "25:30:17" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "25:36:38" , 
"departure_time" : "25:38:12" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "25:41:34" , 
"departure_time" : "25:42:15" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "25:45:41" , 
"departure_time" : "25:47:08" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "25:49:27" , 
"departure_time" : "25:50:13" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "25:54:46" , 
"departure_time" : "25:55:50" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "26:00:04" , 
"departure_time" : "26:01:36" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "26:09:32" , 
"departure_time" : "26:10:58" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "26:13:26" , 
"departure_time" : "26:14:19" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "26:18:53" , 
"departure_time" : "26:20:27" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "26:25:34" , 
"departure_time" : "26:26:41" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "26:29:07" , 
"departure_time" : "26:30:10" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "26:43:03" , 
"departure_time" : "26:43:03" , 
"distance_traveled" : 50.8055
} ], 
"3080" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "25:00:00" , 
"departure_time" : "25:01:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "25:09:04" , 
"departure_time" : "25:10:16" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "25:19:12" , 
"departure_time" : "25:20:19" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "25:25:07" , 
"departure_time" : "25:26:04" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "25:29:57" , 
"departure_time" : "25:31:30" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "25:37:33" , 
"departure_time" : "25:37:55" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "25:40:22" , 
"departure_time" : "25:41:14" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "25:45:52" , 
"departure_time" : "25:45:53" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "25:48:01" , 
"departure_time" : "25:49:36" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "25:55:35" , 
"departure_time" : "25:56:56" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "26:00:21" , 
"departure_time" : "26:00:59" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "26:08:38" , 
"departure_time" : "26:08:51" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "26:12:13" , 
"departure_time" : "26:12:50" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "26:18:37" , 
"departure_time" : "26:19:22" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "26:24:45" , 
"departure_time" : "26:25:58" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "26:29:13" , 
"departure_time" : "26:30:46" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "26:43:33" , 
"departure_time" : "26:43:33" , 
"distance_traveled" : 50.8055
} ], 
"3081" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "25:00:00" , 
"departure_time" : "25:02:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "25:09:40" , 
"departure_time" : "25:10:32" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "25:18:52" , 
"departure_time" : "25:20:05" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "25:25:13" , 
"departure_time" : "25:25:56" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "25:29:43" , 
"departure_time" : "25:30:19" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "25:36:36" , 
"departure_time" : "25:37:29" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "25:40:53" , 
"departure_time" : "25:41:49" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "25:45:56" , 
"departure_time" : "25:46:37" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "25:48:41" , 
"departure_time" : "25:49:50" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "25:55:09" , 
"departure_time" : "25:55:27" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "25:59:18" , 
"departure_time" : "25:59:45" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "26:08:27" , 
"departure_time" : "26:08:54" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "26:12:27" , 
"departure_time" : "26:13:51" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "26:19:24" , 
"departure_time" : "26:20:12" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "26:24:48" , 
"departure_time" : "26:25:49" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "26:29:01" , 
"departure_time" : "26:29:07" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "26:42:06" , 
"departure_time" : "26:42:06" , 
"distance_traveled" : 50.8055
} ], 
"3082" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "07:53:00" , 
"departure_time" : "07:53:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:02:02" , 
"departure_time" : "08:02:21" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:11:19" , 
"departure_time" : "08:11:51" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:17:32" , 
"departure_time" : "08:17:36" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "08:22:04" , 
"departure_time" : "08:22:29" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "08:29:25" , 
"departure_time" : "08:30:38" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:34:13" , 
"departure_time" : "08:34:47" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "08:38:34" , 
"departure_time" : "08:38:37" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "08:41:03" , 
"departure_time" : "08:41:38" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "08:47:35" , 
"departure_time" : "08:49:09" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "08:54:34" , 
"departure_time" : "08:55:49" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "09:02:15" , 
"departure_time" : "09:02:57" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "09:05:42" , 
"departure_time" : "09:06:21" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "09:11:39" , 
"departure_time" : "09:12:05" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "09:17:26" , 
"departure_time" : "09:17:30" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "09:21:04" , 
"departure_time" : "09:22:01" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "09:30:57" , 
"departure_time" : "09:30:57" , 
"distance_traveled" : 50.8055
} ], 
"3083" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "08:53:00" , 
"departure_time" : "08:55:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:03:14" , 
"departure_time" : "09:03:55" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:11:41" , 
"departure_time" : "09:12:50" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:18:09" , 
"departure_time" : "09:18:10" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "09:22:01" , 
"departure_time" : "09:22:52" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "09:29:51" , 
"departure_time" : "09:30:08" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "09:33:17" , 
"departure_time" : "09:33:46" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "09:38:29" , 
"departure_time" : "09:38:44" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "09:41:15" , 
"departure_time" : "09:41:33" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "09:47:18" , 
"departure_time" : "09:48:32" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "09:54:14" , 
"departure_time" : "09:55:54" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "10:02:40" , 
"departure_time" : "10:03:17" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "10:05:37" , 
"departure_time" : "10:06:05" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "10:11:28" , 
"departure_time" : "10:11:56" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "10:17:28" , 
"departure_time" : "10:18:32" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "10:22:04" , 
"departure_time" : "10:22:12" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "10:31:08" , 
"departure_time" : "10:31:08" , 
"distance_traveled" : 50.8055
} ], 
"3084" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "24:05:00" , 
"departure_time" : "24:06:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:14:58" , 
"departure_time" : "24:15:28" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "24:22:30" , 
"departure_time" : "24:23:45" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "24:29:15" , 
"departure_time" : "24:29:45" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "24:32:30" , 
"departure_time" : "24:34:09" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "24:36:39" , 
"departure_time" : "24:36:59" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "24:42:20" , 
"departure_time" : "24:43:24" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "24:47:04" , 
"departure_time" : "24:48:37" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "24:52:33" , 
"departure_time" : "24:53:52" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "24:55:19" , 
"departure_time" : "24:56:58" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "25:01:39" , 
"departure_time" : "25:01:59" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "25:05:20" , 
"departure_time" : "25:05:52" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "25:14:32" , 
"departure_time" : "25:15:19" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "25:18:47" , 
"departure_time" : "25:20:27" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "25:25:40" , 
"departure_time" : "25:25:50" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "25:30:10" , 
"departure_time" : "25:31:41" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "25:35:31" , 
"departure_time" : "25:36:41" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "25:49:10" , 
"departure_time" : "25:49:10" , 
"distance_traveled" : 50.8055
} ], 
"3085" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "10:57:00" , 
"departure_time" : "10:59:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:07:34" , 
"departure_time" : "11:07:35" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:15:01" , 
"departure_time" : "11:16:01" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "11:22:00" , 
"departure_time" : "11:22:45" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "11:26:45" , 
"departure_time" : "11:27:41" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "11:33:56" , 
"departure_time" : "11:35:20" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "11:38:24" , 
"departure_time" : "11:39:31" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "11:43:07" , 
"departure_time" : "11:43:28" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "11:45:21" , 
"departure_time" : "11:45:58" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "11:51:37" , 
"departure_time" : "11:52:19" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "11:57:42" , 
"departure_time" : "11:57:45" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "12:05:03" , 
"departure_time" : "12:05:33" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "12:09:30" , 
"departure_time" : "12:10:54" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "12:16:24" , 
"departure_time" : "12:16:33" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "12:21:09" , 
"departure_time" : "12:22:15" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "12:26:06" , 
"departure_time" : "12:27:41" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "12:36:35" , 
"departure_time" : "12:36:35" , 
"distance_traveled" : 50.8055
} ], 
"3086" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "13:07:00" , 
"departure_time" : "13:10:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:17:39" , 
"departure_time" : "13:18:48" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:26:09" , 
"departure_time" : "13:27:21" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:32:12" , 
"departure_time" : "13:33:10" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "13:36:58" , 
"departure_time" : "13:37:45" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "13:43:47" , 
"departure_time" : "13:44:16" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "13:47:29" , 
"departure_time" : "13:48:19" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "13:53:50" , 
"departure_time" : "13:54:29" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "13:56:39" , 
"departure_time" : "13:57:50" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "14:03:11" , 
"departure_time" : "14:03:24" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "14:07:13" , 
"departure_time" : "14:08:35" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "14:17:22" , 
"departure_time" : "14:18:03" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "14:20:41" , 
"departure_time" : "14:22:12" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "14:27:31" , 
"departure_time" : "14:27:39" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "14:32:08" , 
"departure_time" : "14:33:20" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "14:37:12" , 
"departure_time" : "14:37:35" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "14:46:23" , 
"departure_time" : "14:46:23" , 
"distance_traveled" : 50.8055
} ], 
"3087" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "12:07:00" , 
"departure_time" : "12:08:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:17:25" , 
"departure_time" : "12:18:22" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:25:57" , 
"departure_time" : "12:27:30" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "12:32:33" , 
"departure_time" : "12:34:08" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 127,
"arrival_time" : "12:43:35" , 
"departure_time" : "12:45:02" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 158,
"arrival_time" : "12:50:27" , 
"departure_time" : "12:50:30" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "12:55:03" , 
"departure_time" : "12:56:29" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "13:01:26" , 
"departure_time" : "13:01:53" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "13:09:27" , 
"departure_time" : "13:10:19" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "13:12:52" , 
"departure_time" : "13:13:11" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "13:18:19" , 
"departure_time" : "13:18:37" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "13:24:18" , 
"departure_time" : "13:25:00" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "13:28:42" , 
"departure_time" : "13:28:47" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "13:38:05" , 
"departure_time" : "13:38:05" , 
"distance_traveled" : 50.8055
} ], 
"3088" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "14:07:00" , 
"departure_time" : "14:07:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:16:41" , 
"departure_time" : "14:18:06" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:26:25" , 
"departure_time" : "14:27:01" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "14:31:36" , 
"departure_time" : "14:33:10" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "14:37:34" , 
"departure_time" : "14:38:38" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "14:44:04" , 
"departure_time" : "14:45:34" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "14:48:30" , 
"departure_time" : "14:49:43" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "14:54:13" , 
"departure_time" : "14:54:39" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "14:56:26" , 
"departure_time" : "14:57:43" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "15:03:17" , 
"departure_time" : "15:03:45" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "15:07:28" , 
"departure_time" : "15:08:24" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "15:16:56" , 
"departure_time" : "15:17:14" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "15:20:18" , 
"departure_time" : "15:21:23" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "15:27:05" , 
"departure_time" : "15:27:45" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "15:32:40" , 
"departure_time" : "15:33:06" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "15:36:26" , 
"departure_time" : "15:38:04" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "15:47:38" , 
"departure_time" : "15:47:38" , 
"distance_traveled" : 50.8055
} ], 
"3089" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:07:00" , 
"departure_time" : "20:09:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:16:33" , 
"departure_time" : "20:17:03" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:25:30" , 
"departure_time" : "20:26:17" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:31:47" , 
"departure_time" : "20:32:35" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:43:48" , 
"departure_time" : "20:43:57" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "20:49:09" , 
"departure_time" : "20:50:19" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "20:53:10" , 
"departure_time" : "20:54:19" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "20:59:09" , 
"departure_time" : "20:59:35" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "21:03:26" , 
"departure_time" : "21:04:21" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "21:12:55" , 
"departure_time" : "21:13:56" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "21:17:01" , 
"departure_time" : "21:18:14" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "21:22:13" , 
"departure_time" : "21:22:45" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "21:27:32" , 
"departure_time" : "21:28:04" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "21:31:32" , 
"departure_time" : "21:32:55" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "21:41:23" , 
"departure_time" : "21:41:23" , 
"distance_traveled" : 50.8055
} ], 
"3090" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:07:00" , 
"departure_time" : "15:09:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:17:27" , 
"departure_time" : "15:18:50" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:26:23" , 
"departure_time" : "15:27:39" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "15:32:16" , 
"departure_time" : "15:33:44" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "15:37:28" , 
"departure_time" : "15:39:03" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "15:44:35" , 
"departure_time" : "15:44:38" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "15:47:03" , 
"departure_time" : "15:48:35" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "15:54:32" , 
"departure_time" : "15:54:47" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "15:56:15" , 
"departure_time" : "15:57:30" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "16:03:15" , 
"departure_time" : "16:04:01" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "16:07:46" , 
"departure_time" : "16:08:12" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "16:16:26" , 
"departure_time" : "16:17:39" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "16:21:13" , 
"departure_time" : "16:22:04" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "16:26:51" , 
"departure_time" : "16:27:12" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "16:32:21" , 
"departure_time" : "16:33:19" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "16:36:58" , 
"departure_time" : "16:37:00" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "16:46:02" , 
"departure_time" : "16:46:02" , 
"distance_traveled" : 50.8055
} ], 
"3091" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "21:07:00" , 
"departure_time" : "21:07:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:16:54" , 
"departure_time" : "21:18:09" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:26:15" , 
"departure_time" : "21:26:51" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "21:31:36" , 
"departure_time" : "21:33:10" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "21:37:34" , 
"departure_time" : "21:38:43" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "21:44:09" , 
"departure_time" : "21:45:43" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "21:48:34" , 
"departure_time" : "21:48:45" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 158,
"arrival_time" : "21:54:11" , 
"departure_time" : "21:54:31" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "22:00:20" , 
"departure_time" : "22:01:54" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "22:06:34" , 
"departure_time" : "22:07:16" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "22:14:42" , 
"departure_time" : "22:16:07" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "22:19:25" , 
"departure_time" : "22:19:28" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "22:24:03" , 
"departure_time" : "22:25:23" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "22:31:20" , 
"departure_time" : "22:31:38" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "22:34:18" , 
"departure_time" : "22:34:28" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "22:41:10" , 
"departure_time" : "22:41:10" , 
"distance_traveled" : 50.8055
} ], 
"3092" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:07:00" , 
"departure_time" : "16:07:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:16:37" , 
"departure_time" : "16:18:07" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:26:30" , 
"departure_time" : "16:27:58" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:32:28" , 
"departure_time" : "16:33:21" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "16:36:53" , 
"departure_time" : "16:37:33" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "16:43:40" , 
"departure_time" : "16:44:46" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "16:48:06" , 
"departure_time" : "16:49:43" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "16:54:37" , 
"departure_time" : "16:55:51" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "16:57:14" , 
"departure_time" : "16:57:38" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "17:02:24" , 
"departure_time" : "17:03:59" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "17:08:35" , 
"departure_time" : "17:08:54" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "17:16:19" , 
"departure_time" : "17:17:06" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "17:20:47" , 
"departure_time" : "17:22:26" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "17:27:39" , 
"departure_time" : "17:28:13" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "17:32:34" , 
"departure_time" : "17:34:13" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "17:37:39" , 
"departure_time" : "17:39:10" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "17:47:31" , 
"departure_time" : "17:47:31" , 
"distance_traveled" : 50.8055
} ], 
"3093" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "23:07:00" , 
"departure_time" : "23:09:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:16:29" , 
"departure_time" : "23:17:00" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "23:25:31" , 
"departure_time" : "23:26:29" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "23:31:58" , 
"departure_time" : "23:32:03" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "23:36:05" , 
"departure_time" : "23:37:20" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "23:44:15" , 
"departure_time" : "23:44:23" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "23:47:08" , 
"departure_time" : "23:47:26" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 158,
"arrival_time" : "23:54:18" , 
"departure_time" : "23:55:51" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "24:01:33" , 
"departure_time" : "24:02:50" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "24:06:17" , 
"departure_time" : "24:07:32" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "24:15:15" , 
"departure_time" : "24:15:55" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "24:18:40" , 
"departure_time" : "24:19:32" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "24:24:52" , 
"departure_time" : "24:25:55" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "24:31:03" , 
"departure_time" : "24:31:45" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "24:34:42" , 
"departure_time" : "24:36:00" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "24:42:18" , 
"departure_time" : "24:42:18" , 
"distance_traveled" : 50.8055
} ], 
"3094" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:07:00" , 
"departure_time" : "17:08:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:16:03" , 
"departure_time" : "17:17:15" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:26:12" , 
"departure_time" : "17:26:54" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:31:42" , 
"departure_time" : "17:33:07" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "17:37:25" , 
"departure_time" : "17:39:02" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "17:44:37" , 
"departure_time" : "17:45:05" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "17:47:28" , 
"departure_time" : "17:49:07" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "17:54:39" , 
"departure_time" : "17:55:15" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "17:56:36" , 
"departure_time" : "17:57:57" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "18:04:21" , 
"departure_time" : "18:04:41" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "18:07:20" , 
"departure_time" : "18:08:27" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "18:17:07" , 
"departure_time" : "18:18:45" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "18:21:38" , 
"departure_time" : "18:22:18" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "18:26:40" , 
"departure_time" : "18:28:15" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "18:33:35" , 
"departure_time" : "18:34:09" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "18:36:34" , 
"departure_time" : "18:37:25" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "18:46:51" , 
"departure_time" : "18:46:51" , 
"distance_traveled" : 50.8055
} ], 
"3095" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "07:53:00" , 
"departure_time" : "07:55:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:03:29" , 
"departure_time" : "08:05:05" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:12:36" , 
"departure_time" : "08:14:10" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:18:34" , 
"departure_time" : "08:19:14" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "08:22:40" , 
"departure_time" : "08:23:56" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "08:30:16" , 
"departure_time" : "08:31:05" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:33:49" , 
"departure_time" : "08:34:34" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "08:38:45" , 
"departure_time" : "08:38:46" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "08:41:01" , 
"departure_time" : "08:42:31" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "08:48:30" , 
"departure_time" : "08:49:06" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "08:53:36" , 
"departure_time" : "08:55:05" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "09:02:29" , 
"departure_time" : "09:03:41" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "09:06:12" , 
"departure_time" : "09:06:53" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "09:11:41" , 
"departure_time" : "09:12:14" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "09:17:33" , 
"departure_time" : "09:18:17" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "09:21:44" , 
"departure_time" : "09:22:15" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "09:30:31" , 
"departure_time" : "09:30:31" , 
"distance_traveled" : 50.8055
} ], 
"3096" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:07:00" , 
"departure_time" : "18:08:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:16:40" , 
"departure_time" : "18:17:02" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:25:22" , 
"departure_time" : "18:25:29" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:31:07" , 
"departure_time" : "18:31:09" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "18:36:02" , 
"departure_time" : "18:36:34" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "18:43:32" , 
"departure_time" : "18:44:43" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:48:11" , 
"departure_time" : "18:48:13" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "18:53:02" , 
"departure_time" : "18:54:09" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "18:57:07" , 
"departure_time" : "18:58:40" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "19:03:33" , 
"departure_time" : "19:04:28" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "19:07:55" , 
"departure_time" : "19:08:10" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "19:16:15" , 
"departure_time" : "19:17:28" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "19:21:13" , 
"departure_time" : "19:22:30" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "19:27:17" , 
"departure_time" : "19:27:39" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "19:32:22" , 
"departure_time" : "19:33:44" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "19:37:22" , 
"departure_time" : "19:38:53" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "19:47:31" , 
"departure_time" : "19:47:31" , 
"distance_traveled" : 50.8055
} ], 
"3097" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "08:53:00" , 
"departure_time" : "08:55:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:02:45" , 
"departure_time" : "09:03:18" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:11:33" , 
"departure_time" : "09:12:59" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:18:26" , 
"departure_time" : "09:19:41" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "09:23:15" , 
"departure_time" : "09:24:35" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "09:30:20" , 
"departure_time" : "09:30:54" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "09:33:34" , 
"departure_time" : "09:35:13" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "09:39:39" , 
"departure_time" : "09:40:38" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "09:41:59" , 
"departure_time" : "09:43:33" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "09:48:34" , 
"departure_time" : "09:49:21" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "09:53:47" , 
"departure_time" : "09:54:22" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "10:01:35" , 
"departure_time" : "10:01:37" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "10:05:02" , 
"departure_time" : "10:06:41" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "10:12:39" , 
"departure_time" : "10:13:04" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "10:17:25" , 
"departure_time" : "10:19:04" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "10:22:39" , 
"departure_time" : "10:22:55" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "10:31:16" , 
"departure_time" : "10:31:16" , 
"distance_traveled" : 50.8055
} ], 
"3098" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "22:07:00" , 
"departure_time" : "22:07:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:16:42" , 
"departure_time" : "22:17:19" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:25:37" , 
"departure_time" : "22:27:11" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:32:34" , 
"departure_time" : "22:32:37" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "22:36:03" , 
"departure_time" : "22:36:46" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "22:43:43" , 
"departure_time" : "22:44:35" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "22:47:52" , 
"departure_time" : "22:47:57" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "22:53:05" , 
"departure_time" : "22:54:23" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "22:57:18" , 
"departure_time" : "22:58:20" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "23:03:02" , 
"departure_time" : "23:04:07" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "23:08:05" , 
"departure_time" : "23:09:21" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "23:17:16" , 
"departure_time" : "23:17:21" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "23:20:05" , 
"departure_time" : "23:20:42" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "23:26:37" , 
"departure_time" : "23:26:42" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "23:32:05" , 
"departure_time" : "23:33:05" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "23:37:00" , 
"departure_time" : "23:37:24" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "23:44:24" , 
"departure_time" : "23:44:24" , 
"distance_traveled" : 50.8055
} ], 
"3099" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "10:57:00" , 
"departure_time" : "10:58:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:06:37" , 
"departure_time" : "11:07:09" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:15:32" , 
"departure_time" : "11:16:14" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "11:21:42" , 
"departure_time" : "11:22:59" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "11:27:17" , 
"departure_time" : "11:27:40" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "11:33:23" , 
"departure_time" : "11:33:59" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "11:37:36" , 
"departure_time" : "11:38:21" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "11:42:45" , 
"departure_time" : "11:42:56" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "11:45:11" , 
"departure_time" : "11:46:08" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "11:51:57" , 
"departure_time" : "11:52:15" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "11:57:18" , 
"departure_time" : "11:57:33" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "12:05:15" , 
"departure_time" : "12:06:17" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "12:10:02" , 
"departure_time" : "12:10:42" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "12:15:40" , 
"departure_time" : "12:16:36" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "12:21:56" , 
"departure_time" : "12:22:21" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "12:25:25" , 
"departure_time" : "12:26:42" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "12:36:17" , 
"departure_time" : "12:36:17" , 
"distance_traveled" : 50.8055
} ], 
"3100" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "06:53:00" , 
"departure_time" : "06:55:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:03:28" , 
"departure_time" : "07:03:30" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:11:02" , 
"departure_time" : "07:12:02" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "07:18:00" , 
"departure_time" : "07:18:40" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "07:20:40" , 
"departure_time" : "07:21:39" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "07:23:59" , 
"departure_time" : "07:24:15" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "07:30:16" , 
"departure_time" : "07:31:28" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "07:35:12" , 
"departure_time" : "07:35:25" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 158,
"arrival_time" : "07:41:13" , 
"departure_time" : "07:42:19" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "07:48:06" , 
"departure_time" : "07:49:45" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "07:53:39" , 
"departure_time" : "07:54:24" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "08:01:45" , 
"departure_time" : "08:02:32" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "08:05:47" , 
"departure_time" : "08:06:42" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "08:11:55" , 
"departure_time" : "08:12:42" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "08:17:47" , 
"departure_time" : "08:18:40" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "08:21:53" , 
"departure_time" : "08:22:06" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "08:30:13" , 
"departure_time" : "08:30:13" , 
"distance_traveled" : 50.8055
} ], 
"3101" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "13:07:00" , 
"departure_time" : "13:08:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:17:09" , 
"departure_time" : "13:18:15" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:26:06" , 
"departure_time" : "13:27:22" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:32:16" , 
"departure_time" : "13:33:20" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "13:37:04" , 
"departure_time" : "13:38:42" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "13:44:38" , 
"departure_time" : "13:44:41" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "13:47:03" , 
"departure_time" : "13:48:05" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "13:54:02" , 
"departure_time" : "13:55:30" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "13:57:28" , 
"departure_time" : "13:58:48" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "14:03:20" , 
"departure_time" : "14:03:51" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "14:07:31" , 
"departure_time" : "14:09:06" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "14:17:35" , 
"departure_time" : "14:18:08" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "14:20:33" , 
"departure_time" : "14:21:52" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "14:27:19" , 
"departure_time" : "14:28:46" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "14:33:27" , 
"departure_time" : "14:34:35" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "14:37:08" , 
"departure_time" : "14:38:08" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "14:47:00" , 
"departure_time" : "14:47:00" , 
"distance_traveled" : 50.8055
} ], 
"3102" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "24:05:00" , 
"departure_time" : "24:07:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:15:01" , 
"departure_time" : "24:16:26" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "24:23:25" , 
"departure_time" : "24:23:55" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "24:28:30" , 
"departure_time" : "24:29:19" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "24:32:49" , 
"departure_time" : "24:34:05" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "24:36:16" , 
"departure_time" : "24:37:00" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "24:42:44" , 
"departure_time" : "24:44:24" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "24:47:40" , 
"departure_time" : "24:47:56" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "24:51:16" , 
"departure_time" : "24:52:19" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "24:55:03" , 
"departure_time" : "24:55:06" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "25:00:03" , 
"departure_time" : "25:00:22" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "25:05:19" , 
"departure_time" : "25:06:57" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "25:15:38" , 
"departure_time" : "25:16:06" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "25:18:28" , 
"departure_time" : "25:19:57" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "25:25:29" , 
"departure_time" : "25:26:12" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "25:30:43" , 
"departure_time" : "25:31:21" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "25:34:38" , 
"departure_time" : "25:35:56" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "25:49:18" , 
"departure_time" : "25:49:18" , 
"distance_traveled" : 50.8055
} ], 
"3103" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "14:07:00" , 
"departure_time" : "14:08:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:16:34" , 
"departure_time" : "14:17:48" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:26:14" , 
"departure_time" : "14:27:53" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "14:32:39" , 
"departure_time" : "14:32:46" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "14:36:07" , 
"departure_time" : "14:37:13" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "14:44:06" , 
"departure_time" : "14:44:32" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "14:47:26" , 
"departure_time" : "14:48:59" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "14:54:33" , 
"departure_time" : "14:54:59" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "14:56:26" , 
"departure_time" : "14:57:56" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "15:03:30" , 
"departure_time" : "15:03:31" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "15:07:01" , 
"departure_time" : "15:07:37" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "15:16:36" , 
"departure_time" : "15:17:07" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "15:20:31" , 
"departure_time" : "15:21:53" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "15:27:22" , 
"departure_time" : "15:28:47" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "15:33:25" , 
"departure_time" : "15:34:55" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "15:37:30" , 
"departure_time" : "15:37:50" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "15:46:20" , 
"departure_time" : "15:46:20" , 
"distance_traveled" : 50.8055
} ], 
"3104" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "24:05:00" , 
"departure_time" : "24:05:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:14:14" , 
"departure_time" : "24:14:59" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "24:22:45" , 
"departure_time" : "24:23:30" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "24:28:45" , 
"departure_time" : "24:28:57" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "24:32:12" , 
"departure_time" : "24:33:41" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "24:36:29" , 
"departure_time" : "24:37:53" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "24:43:24" , 
"departure_time" : "24:43:35" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "24:46:11" , 
"departure_time" : "24:47:34" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "24:52:23" , 
"departure_time" : "24:52:46" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "24:54:23" , 
"departure_time" : "24:54:57" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "25:00:34" , 
"departure_time" : "25:02:06" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "25:06:32" , 
"departure_time" : "25:06:42" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "25:14:10" , 
"departure_time" : "25:15:20" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "25:19:10" , 
"departure_time" : "25:19:26" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "25:24:16" , 
"departure_time" : "25:24:32" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "25:30:16" , 
"departure_time" : "25:31:40" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "25:35:24" , 
"departure_time" : "25:36:31" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "25:49:07" , 
"departure_time" : "25:49:07" , 
"distance_traveled" : 50.8055
} ], 
"3105" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:07:00" , 
"departure_time" : "15:09:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:17:15" , 
"departure_time" : "15:18:39" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:26:24" , 
"departure_time" : "15:27:52" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "15:32:28" , 
"departure_time" : "15:33:51" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "15:37:23" , 
"departure_time" : "15:37:28" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "15:43:05" , 
"departure_time" : "15:43:09" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "15:47:04" , 
"departure_time" : "15:48:34" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "15:54:30" , 
"departure_time" : "15:56:07" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "15:57:37" , 
"departure_time" : "15:57:44" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "16:02:07" , 
"departure_time" : "16:02:50" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "16:07:43" , 
"departure_time" : "16:09:16" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "16:17:33" , 
"departure_time" : "16:18:19" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "16:20:46" , 
"departure_time" : "16:21:10" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "16:26:24" , 
"departure_time" : "16:27:33" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "16:33:09" , 
"departure_time" : "16:33:14" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "16:36:05" , 
"departure_time" : "16:37:29" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "16:47:24" , 
"departure_time" : "16:47:24" , 
"distance_traveled" : 50.8055
} ], 
"3106" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "05:53:00" , 
"departure_time" : "05:55:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:02:37" , 
"departure_time" : "06:03:54" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:12:17" , 
"departure_time" : "06:13:53" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "06:18:36" , 
"departure_time" : "06:18:53" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "06:20:17" , 
"departure_time" : "06:21:52" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "06:24:35" , 
"departure_time" : "06:25:20" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "06:30:45" , 
"departure_time" : "06:31:25" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "06:34:40" , 
"departure_time" : "06:36:00" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "06:41:20" , 
"departure_time" : "06:42:29" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "06:44:09" , 
"departure_time" : "06:45:09" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "06:50:00" , 
"departure_time" : "06:50:14" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "06:54:14" , 
"departure_time" : "06:55:43" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "07:04:29" , 
"departure_time" : "07:05:50" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "07:08:21" , 
"departure_time" : "07:08:52" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "07:13:31" , 
"departure_time" : "07:13:54" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "07:19:23" , 
"departure_time" : "07:19:36" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "07:23:13" , 
"departure_time" : "07:23:59" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "07:32:46" , 
"departure_time" : "07:32:46" , 
"distance_traveled" : 50.8055
} ], 
"3107" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:07:00" , 
"departure_time" : "16:08:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:16:54" , 
"departure_time" : "16:17:02" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:25:08" , 
"departure_time" : "16:25:54" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:31:46" , 
"departure_time" : "16:31:57" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "16:36:11" , 
"departure_time" : "16:36:39" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "16:43:28" , 
"departure_time" : "16:43:56" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "16:47:28" , 
"departure_time" : "16:48:21" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "16:53:53" , 
"departure_time" : "16:54:44" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "16:56:51" , 
"departure_time" : "16:57:18" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "17:02:27" , 
"departure_time" : "17:02:51" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "17:07:24" , 
"departure_time" : "17:07:29" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "17:16:05" , 
"departure_time" : "17:17:14" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "17:21:09" , 
"departure_time" : "17:22:37" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "17:27:28" , 
"departure_time" : "17:27:57" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "17:32:29" , 
"departure_time" : "17:33:49" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "17:37:20" , 
"departure_time" : "17:37:29" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "17:46:09" , 
"departure_time" : "17:46:09" , 
"distance_traveled" : 50.8055
} ], 
"3108" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "09:55:00" , 
"departure_time" : "09:55:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:04:10" , 
"departure_time" : "10:05:14" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:14:04" , 
"departure_time" : "10:14:33" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:19:29" , 
"departure_time" : "10:19:44" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "10:22:15" , 
"departure_time" : "10:22:40" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "10:25:25" , 
"departure_time" : "10:27:00" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "10:33:35" , 
"departure_time" : "10:35:02" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "10:37:27" , 
"departure_time" : "10:38:20" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "10:42:53" , 
"departure_time" : "10:44:12" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "10:46:19" , 
"departure_time" : "10:47:16" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "10:51:57" , 
"departure_time" : "10:53:31" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "10:57:34" , 
"departure_time" : "10:58:32" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "11:05:58" , 
"departure_time" : "11:07:34" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "11:10:36" , 
"departure_time" : "11:11:17" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "11:15:41" , 
"departure_time" : "11:17:04" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "11:22:23" , 
"departure_time" : "11:23:00" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "11:25:37" , 
"departure_time" : "11:26:10" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "11:35:33" , 
"departure_time" : "11:35:33" , 
"distance_traveled" : 50.8055
} ], 
"3109" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:07:00" , 
"departure_time" : "17:08:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:17:18" , 
"departure_time" : "17:18:15" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:25:57" , 
"departure_time" : "17:27:08" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:32:11" , 
"departure_time" : "17:32:24" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "17:36:13" , 
"departure_time" : "17:36:55" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "17:43:42" , 
"departure_time" : "17:44:57" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "17:48:15" , 
"departure_time" : "17:48:46" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "17:53:31" , 
"departure_time" : "17:53:45" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "17:56:14" , 
"departure_time" : "17:57:01" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "18:03:47" , 
"departure_time" : "18:05:18" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "18:08:31" , 
"departure_time" : "18:08:32" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "18:16:01" , 
"departure_time" : "18:17:34" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "18:21:33" , 
"departure_time" : "18:22:03" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "18:26:30" , 
"departure_time" : "18:27:13" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "18:32:43" , 
"departure_time" : "18:32:45" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "18:36:02" , 
"departure_time" : "18:36:39" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "18:46:37" , 
"departure_time" : "18:46:37" , 
"distance_traveled" : 50.8055
} ], 
"3110" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:07:00" , 
"departure_time" : "19:08:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:16:55" , 
"departure_time" : "19:17:58" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:26:03" , 
"departure_time" : "19:27:27" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:32:24" , 
"departure_time" : "19:32:57" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "19:35:33" , 
"departure_time" : "19:36:40" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "19:39:07" , 
"departure_time" : "19:39:26" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "19:44:19" , 
"departure_time" : "19:44:49" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "19:48:30" , 
"departure_time" : "19:48:40" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "19:55:10" , 
"departure_time" : "19:55:24" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "19:58:14" , 
"departure_time" : "19:58:57" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "20:03:43" , 
"departure_time" : "20:04:09" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "20:09:26" , 
"departure_time" : "20:10:39" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "20:19:13" , 
"departure_time" : "20:20:00" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "20:22:47" , 
"departure_time" : "20:23:37" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "20:27:50" , 
"departure_time" : "20:29:07" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "20:34:17" , 
"departure_time" : "20:34:53" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "20:37:36" , 
"departure_time" : "20:38:27" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "20:47:51" , 
"departure_time" : "20:47:51" , 
"distance_traveled" : 50.8055
} ], 
"3111" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:07:00" , 
"departure_time" : "18:08:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:16:57" , 
"departure_time" : "18:18:12" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:26:15" , 
"departure_time" : "18:27:09" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:31:54" , 
"departure_time" : "18:32:09" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "18:36:15" , 
"departure_time" : "18:37:40" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "18:44:25" , 
"departure_time" : "18:45:45" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:48:20" , 
"departure_time" : "18:49:49" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "18:54:29" , 
"departure_time" : "18:54:35" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "18:56:06" , 
"departure_time" : "18:57:35" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "19:03:29" , 
"departure_time" : "19:04:50" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "19:08:21" , 
"departure_time" : "19:09:39" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "19:17:18" , 
"departure_time" : "19:18:21" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "19:21:03" , 
"departure_time" : "19:22:12" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "19:27:09" , 
"departure_time" : "19:27:25" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "19:32:16" , 
"departure_time" : "19:32:35" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "19:36:19" , 
"departure_time" : "19:37:46" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "19:47:27" , 
"departure_time" : "19:47:27" , 
"distance_traveled" : 50.8055
} ], 
"3112" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:01:00" , 
"departure_time" : "17:03:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:18:21" , 
"departure_time" : "17:18:39" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:23:18" , 
"departure_time" : "17:24:30" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "17:28:12" , 
"departure_time" : "17:29:21" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "17:31:09" , 
"departure_time" : "17:31:50" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "17:36:41" , 
"departure_time" : "17:36:56" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "17:39:15" , 
"departure_time" : "17:39:15" , 
"distance_traveled" : 20.7032
} ], 
"3113" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "22:07:00" , 
"departure_time" : "22:07:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:16:18" , 
"departure_time" : "22:17:04" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:25:46" , 
"departure_time" : "22:27:07" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:32:21" , 
"departure_time" : "22:32:30" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "22:36:09" , 
"departure_time" : "22:36:21" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "22:43:12" , 
"departure_time" : "22:44:51" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "22:48:39" , 
"departure_time" : "22:50:18" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "22:54:39" , 
"departure_time" : "22:55:58" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "22:57:19" , 
"departure_time" : "22:57:27" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "23:02:08" , 
"departure_time" : "23:02:22" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "23:07:14" , 
"departure_time" : "23:08:10" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "23:16:56" , 
"departure_time" : "23:17:26" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "23:20:30" , 
"departure_time" : "23:21:11" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "23:26:41" , 
"departure_time" : "23:27:37" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "23:32:56" , 
"departure_time" : "23:34:14" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "23:37:18" , 
"departure_time" : "23:37:19" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "23:44:01" , 
"departure_time" : "23:44:01" , 
"distance_traveled" : 50.8055
} ], 
"3114" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:01:00" , 
"departure_time" : "18:02:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:18:18" , 
"departure_time" : "18:18:26" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:23:08" , 
"departure_time" : "18:24:30" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "18:27:22" , 
"departure_time" : "18:29:01" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "18:30:39" , 
"departure_time" : "18:30:45" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "18:36:06" , 
"departure_time" : "18:36:44" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:39:38" , 
"departure_time" : "18:39:38" , 
"distance_traveled" : 20.7032
} ], 
"3115" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "06:53:00" , 
"departure_time" : "06:53:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:02:14" , 
"departure_time" : "07:03:40" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:12:26" , 
"departure_time" : "07:12:58" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "07:17:32" , 
"departure_time" : "07:18:14" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "07:20:42" , 
"departure_time" : "07:21:01" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "07:23:19" , 
"departure_time" : "07:23:35" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "07:30:16" , 
"departure_time" : "07:31:10" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "07:34:54" , 
"departure_time" : "07:35:56" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 158,
"arrival_time" : "07:42:02" , 
"departure_time" : "07:42:04" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "07:47:02" , 
"departure_time" : "07:48:06" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "07:53:04" , 
"departure_time" : "07:53:50" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "08:01:46" , 
"departure_time" : "08:02:48" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "08:06:02" , 
"departure_time" : "08:06:43" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "08:11:41" , 
"departure_time" : "08:13:14" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "08:18:33" , 
"departure_time" : "08:19:57" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "08:22:24" , 
"departure_time" : "08:23:24" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "08:31:00" , 
"departure_time" : "08:31:00" , 
"distance_traveled" : 50.8055
} ], 
"3116" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:51:00" , 
"departure_time" : "19:53:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:07:02" , 
"departure_time" : "20:08:11" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:13:09" , 
"departure_time" : "20:14:18" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "20:17:09" , 
"departure_time" : "20:18:38" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "20:20:29" , 
"departure_time" : "20:20:39" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "20:26:10" , 
"departure_time" : "20:27:12" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:30:02" , 
"departure_time" : "20:30:02" , 
"distance_traveled" : 20.7032
} ], 
"3117" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "05:53:00" , 
"departure_time" : "05:54:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:02:44" , 
"departure_time" : "06:03:06" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:11:22" , 
"departure_time" : "06:12:41" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "06:18:19" , 
"departure_time" : "06:19:35" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "06:21:16" , 
"departure_time" : "06:22:55" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "06:24:39" , 
"departure_time" : "06:25:46" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "06:31:07" , 
"departure_time" : "06:32:13" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "06:35:06" , 
"departure_time" : "06:36:26" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "06:41:20" , 
"departure_time" : "06:41:54" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "06:43:34" , 
"departure_time" : "06:43:48" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "06:49:14" , 
"departure_time" : "06:49:41" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "06:54:27" , 
"departure_time" : "06:55:47" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "07:04:20" , 
"departure_time" : "07:05:41" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "07:08:21" , 
"departure_time" : "07:09:36" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "07:14:15" , 
"departure_time" : "07:15:25" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "07:20:10" , 
"departure_time" : "07:21:08" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "07:23:58" , 
"departure_time" : "07:24:50" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "07:32:52" , 
"departure_time" : "07:32:52" , 
"distance_traveled" : 50.8055
} ], 
"3118" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "08:07:00" , 
"departure_time" : "08:09:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:17:38" , 
"departure_time" : "08:18:06" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:26:28" , 
"departure_time" : "08:27:17" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:32:49" , 
"departure_time" : "08:34:13" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "08:36:24" , 
"departure_time" : "08:36:58" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "08:38:34" , 
"departure_time" : "08:39:58" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "08:46:24" , 
"departure_time" : "08:46:28" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:48:04" , 
"departure_time" : "08:48:04" , 
"distance_traveled" : 20.7032
} ], 
"3119" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "09:55:00" , 
"departure_time" : "09:55:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:04:50" , 
"departure_time" : "10:06:18" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:14:28" , 
"departure_time" : "10:15:08" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:19:40" , 
"departure_time" : "10:20:51" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "10:23:11" , 
"departure_time" : "10:23:26" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "10:25:15" , 
"departure_time" : "10:26:51" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "10:33:36" , 
"departure_time" : "10:34:24" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "10:36:48" , 
"departure_time" : "10:38:16" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "10:43:28" , 
"departure_time" : "10:43:59" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "10:45:31" , 
"departure_time" : "10:46:37" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "10:52:06" , 
"departure_time" : "10:53:05" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "10:56:59" , 
"departure_time" : "10:58:11" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "11:06:12" , 
"departure_time" : "11:06:14" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "11:09:02" , 
"departure_time" : "11:10:41" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "11:16:39" , 
"departure_time" : "11:16:51" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "11:21:12" , 
"departure_time" : "11:22:49" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "11:26:37" , 
"departure_time" : "11:26:38" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "11:35:01" , 
"departure_time" : "11:35:01" , 
"distance_traveled" : 50.8055
} ], 
"3120" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "09:07:00" , 
"departure_time" : "09:07:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:16:32" , 
"departure_time" : "09:17:02" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:25:30" , 
"departure_time" : "09:27:02" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:32:32" , 
"departure_time" : "09:33:15" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "09:34:43" , 
"departure_time" : "09:35:32" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "09:37:49" , 
"departure_time" : "09:38:58" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "09:45:09" , 
"departure_time" : "09:46:27" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "09:48:18" , 
"departure_time" : "09:48:18" , 
"distance_traveled" : 20.7032
} ], 
"3121" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:07:00" , 
"departure_time" : "19:09:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:16:56" , 
"departure_time" : "19:17:49" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:25:53" , 
"departure_time" : "19:26:56" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:32:03" , 
"departure_time" : "19:33:20" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "19:36:17" , 
"departure_time" : "19:37:37" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "19:39:20" , 
"departure_time" : "19:40:17" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "19:44:57" , 
"departure_time" : "19:45:25" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "19:48:28" , 
"departure_time" : "19:49:38" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "19:56:10" , 
"departure_time" : "19:56:50" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "19:58:40" , 
"departure_time" : "19:59:36" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "20:03:56" , 
"departure_time" : "20:05:25" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "20:10:29" , 
"departure_time" : "20:11:07" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "20:18:38" , 
"departure_time" : "20:19:46" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "20:23:08" , 
"departure_time" : "20:23:55" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "20:27:47" , 
"departure_time" : "20:28:15" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "20:33:28" , 
"departure_time" : "20:33:54" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "20:37:26" , 
"departure_time" : "20:37:53" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "20:47:27" , 
"departure_time" : "20:47:27" , 
"distance_traveled" : 50.8055
} ], 
"3122" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "11:07:00" , 
"departure_time" : "11:09:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:17:36" , 
"departure_time" : "11:18:57" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:26:21" , 
"departure_time" : "11:27:06" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "11:31:45" , 
"departure_time" : "11:32:30" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "11:34:45" , 
"departure_time" : "11:35:32" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "11:37:47" , 
"departure_time" : "11:39:06" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "11:45:19" , 
"departure_time" : "11:46:26" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "11:48:07" , 
"departure_time" : "11:48:07" , 
"distance_traveled" : 20.7032
} ], 
"3123" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:01:00" , 
"departure_time" : "17:03:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:18:01" , 
"departure_time" : "17:19:12" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:24:11" , 
"departure_time" : "17:24:19" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "17:27:08" , 
"departure_time" : "17:28:10" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "17:31:02" , 
"departure_time" : "17:32:27" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "17:37:25" , 
"departure_time" : "17:37:41" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "17:39:16" , 
"departure_time" : "17:39:16" , 
"distance_traveled" : 20.7032
} ], 
"3124" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:56:00" , 
"departure_time" : "15:57:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:07:11" , 
"departure_time" : "16:07:42" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:14:31" , 
"departure_time" : "16:15:22" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:20:51" , 
"departure_time" : "16:21:22" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "16:24:31" , 
"departure_time" : "16:25:13" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "16:27:42" , 
"departure_time" : "16:28:55" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "16:35:13" , 
"departure_time" : "16:35:49" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "16:38:36" , 
"departure_time" : "16:38:36" , 
"distance_traveled" : 20.7032
} ], 
"3125" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:01:00" , 
"departure_time" : "18:02:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:17:28" , 
"departure_time" : "18:18:40" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:24:12" , 
"departure_time" : "18:25:11" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "18:26:59" , 
"departure_time" : "18:28:24" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "18:30:25" , 
"departure_time" : "18:30:44" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "18:36:19" , 
"departure_time" : "18:36:42" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:39:23" , 
"departure_time" : "18:39:23" , 
"distance_traveled" : 20.7032
} ], 
"3126" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:36:00" , 
"departure_time" : "17:37:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:54:10" , 
"departure_time" : "17:54:44" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 158,
"arrival_time" : "18:11:34" , 
"departure_time" : "18:12:39" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 139,
"arrival_time" : "18:21:05" , 
"departure_time" : "18:22:40" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "18:31:35" , 
"departure_time" : "18:31:48" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "18:34:13" , 
"departure_time" : "18:34:24" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "18:40:11" , 
"departure_time" : "18:40:40" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "18:47:29" , 
"departure_time" : "18:47:58" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "18:51:29" , 
"departure_time" : "18:52:11" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "19:02:42" , 
"departure_time" : "19:02:42" , 
"distance_traveled" : 50.8055
} ], 
"3127" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:51:00" , 
"departure_time" : "19:52:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:06:19" , 
"departure_time" : "20:07:11" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:12:52" , 
"departure_time" : "20:13:09" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "20:16:17" , 
"departure_time" : "20:16:57" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "20:19:40" , 
"departure_time" : "20:20:57" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "20:27:17" , 
"departure_time" : "20:28:36" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:30:19" , 
"departure_time" : "20:30:19" , 
"distance_traveled" : 20.7032
} ], 
"3128" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:29:00" , 
"departure_time" : "18:31:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:39:00" , 
"departure_time" : "18:40:21" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:48:21" , 
"departure_time" : "18:49:52" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 158,
"arrival_time" : "19:08:31" , 
"departure_time" : "19:09:08" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 139,
"arrival_time" : "19:16:37" , 
"departure_time" : "19:17:28" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "19:25:51" , 
"departure_time" : "19:26:27" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "19:29:36" , 
"departure_time" : "19:31:14" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "19:37:38" , 
"departure_time" : "19:37:47" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "19:42:09" , 
"departure_time" : "19:43:49" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "19:47:40" , 
"departure_time" : "19:49:09" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "19:58:29" , 
"departure_time" : "19:58:29" , 
"distance_traveled" : 50.8055
} ], 
"3129" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "08:07:00" , 
"departure_time" : "08:09:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:17:27" , 
"departure_time" : "08:18:30" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:27:03" , 
"departure_time" : "08:27:19" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:32:16" , 
"departure_time" : "08:32:22" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "08:35:06" , 
"departure_time" : "08:36:35" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "08:39:29" , 
"departure_time" : "08:39:37" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "08:45:08" , 
"departure_time" : "08:45:23" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:48:15" , 
"departure_time" : "08:48:15" , 
"distance_traveled" : 20.7032
} ], 
"3130" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:05:00" , 
"departure_time" : "17:05:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:15:43" , 
"departure_time" : "17:16:43" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:26:00" , 
"departure_time" : "17:26:27" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 109,
"arrival_time" : "17:31:27" , 
"departure_time" : "17:32:33" , 
"distance_traveled" : 14.3875
}, 
{ 
"stop_id" : 41,
"arrival_time" : "17:36:06" , 
"departure_time" : "17:37:26" , 
"distance_traveled" : 15.3631
}, 
{ 
"stop_id" : 70,
"arrival_time" : "17:42:20" , 
"departure_time" : "17:43:35" , 
"distance_traveled" : 18.6468
}, 
{ 
"stop_id" : 127,
"arrival_time" : "17:47:15" , 
"departure_time" : "17:48:49" , 
"distance_traveled" : 20.7053
}, 
{ 
"stop_id" : 11,
"arrival_time" : "17:53:34" , 
"departure_time" : "17:54:24" , 
"distance_traveled" : 22.9856
}, 
{ 
"stop_id" : 158,
"arrival_time" : "17:55:50" , 
"departure_time" : "17:57:19" , 
"distance_traveled" : 24.4392
}, 
{ 
"stop_id" : 119,
"arrival_time" : "18:02:29" , 
"departure_time" : "18:02:43" , 
"distance_traveled" : 27.8574
}, 
{ 
"stop_id" : 139,
"arrival_time" : "18:05:14" , 
"departure_time" : "18:05:14" , 
"distance_traveled" : 29.7314
} ], 
"3131" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "09:07:00" , 
"departure_time" : "09:08:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:17:29" , 
"departure_time" : "09:17:44" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:25:15" , 
"departure_time" : "09:26:27" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:32:12" , 
"departure_time" : "09:33:15" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "09:35:03" , 
"departure_time" : "09:35:36" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "09:37:33" , 
"departure_time" : "09:38:35" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "09:45:02" , 
"departure_time" : "09:46:17" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "09:48:15" , 
"departure_time" : "09:48:15" , 
"distance_traveled" : 20.7032
} ], 
"3132" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:45:00" , 
"departure_time" : "15:47:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:02:05" , 
"departure_time" : "16:02:16" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 158,
"arrival_time" : "16:19:11" , 
"departure_time" : "16:20:10" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 139,
"arrival_time" : "16:28:59" , 
"departure_time" : "16:30:04" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "16:38:05" , 
"departure_time" : "16:38:06" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "16:40:01" , 
"departure_time" : "16:40:39" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "16:47:38" , 
"departure_time" : "16:49:10" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "16:54:32" , 
"departure_time" : "16:55:22" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "16:57:50" , 
"departure_time" : "16:59:04" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "17:08:14" , 
"departure_time" : "17:08:14" , 
"distance_traveled" : 50.8055
} ], 
"3133" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "11:07:00" , 
"departure_time" : "11:08:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:16:31" , 
"departure_time" : "11:18:08" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:26:37" , 
"departure_time" : "11:28:13" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "11:32:36" , 
"departure_time" : "11:32:37" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "11:34:01" , 
"departure_time" : "11:35:40" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "11:38:39" , 
"departure_time" : "11:39:29" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "11:44:50" , 
"departure_time" : "11:45:47" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "11:47:57" , 
"departure_time" : "11:47:57" , 
"distance_traveled" : 20.7032
} ], 
"3134" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:17:00" , 
"departure_time" : "15:19:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:28:28" , 
"departure_time" : "15:29:58" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:37:30" , 
"departure_time" : "15:38:02" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "15:42:32" , 
"departure_time" : "15:44:08" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "15:47:36" , 
"departure_time" : "15:48:11" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "15:49:35" , 
"departure_time" : "15:51:07" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "15:56:32" , 
"departure_time" : "15:57:09" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "15:59:37" , 
"departure_time" : "16:00:33" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "16:04:56" , 
"departure_time" : "16:06:28" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "16:09:32" , 
"departure_time" : "16:09:36" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "16:14:04" , 
"departure_time" : "16:14:24" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "16:21:20" , 
"departure_time" : "16:21:20" , 
"distance_traveled" : 29.7294
} ], 
"3135" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:56:00" , 
"departure_time" : "15:57:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:07:05" , 
"departure_time" : "16:07:31" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:14:26" , 
"departure_time" : "16:14:29" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:20:03" , 
"departure_time" : "16:21:28" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "16:25:25" , 
"departure_time" : "16:25:49" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "16:27:24" , 
"departure_time" : "16:28:59" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "16:35:35" , 
"departure_time" : "16:36:32" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "16:38:57" , 
"departure_time" : "16:38:57" , 
"distance_traveled" : 20.7032
} ], 
"3136" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:09:00" , 
"departure_time" : "16:11:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:20:39" , 
"departure_time" : "16:21:55" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:29:16" , 
"departure_time" : "16:30:19" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:35:03" , 
"departure_time" : "16:35:42" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "16:37:39" , 
"departure_time" : "16:37:45" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "16:41:06" , 
"departure_time" : "16:42:19" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "16:48:13" , 
"departure_time" : "16:48:51" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "16:51:38" , 
"departure_time" : "16:52:51" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "16:59:13" , 
"departure_time" : "16:59:37" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "17:01:24" , 
"departure_time" : "17:02:32" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "17:08:08" , 
"departure_time" : "17:09:22" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "17:15:14" , 
"departure_time" : "17:15:14" , 
"distance_traveled" : 29.7294
} ], 
"3137" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:04:00" , 
"departure_time" : "18:06:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:15:09" , 
"departure_time" : "18:15:57" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:23:48" , 
"departure_time" : "18:24:38" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 158,
"arrival_time" : "18:43:50" , 
"departure_time" : "18:44:13" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 139,
"arrival_time" : "18:52:23" , 
"departure_time" : "18:52:34" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "19:02:11" , 
"departure_time" : "19:03:24" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "19:07:13" , 
"departure_time" : "19:07:28" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "19:13:15" , 
"departure_time" : "19:14:13" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "19:20:58" , 
"departure_time" : "19:22:32" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "19:25:34" , 
"departure_time" : "19:26:16" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "19:31:42" , 
"departure_time" : "19:32:51" , 
"distance_traveled" : 50.8055
}, 
{ 
"stop_id" : 40,
"arrival_time" : "19:37:09" , 
"departure_time" : "19:37:56" , 
"distance_traveled" : 53.0739
}, 
{ 
"stop_id" : 4,
"arrival_time" : "19:40:47" , 
"departure_time" : "19:41:17" , 
"distance_traveled" : 55.09
}, 
{ 
"stop_id" : 8,
"arrival_time" : "19:44:30" , 
"departure_time" : "19:46:08" , 
"distance_traveled" : 56.6843
}, 
{ 
"stop_id" : 22,
"arrival_time" : "19:47:38" , 
"departure_time" : "19:49:13" , 
"distance_traveled" : 57.5131
}, 
{ 
"stop_id" : 15,
"arrival_time" : "19:52:35" , 
"departure_time" : "19:53:16" , 
"distance_traveled" : 59.1699
}, 
{ 
"stop_id" : 141,
"arrival_time" : "19:55:41" , 
"departure_time" : "19:57:02" , 
"distance_traveled" : 61.2879
}, 
{ 
"stop_id" : 79,
"arrival_time" : "20:00:21" , 
"departure_time" : "20:00:57" , 
"distance_traveled" : 63.4625
}, 
{ 
"stop_id" : 122,
"arrival_time" : "20:05:36" , 
"departure_time" : "20:05:44" , 
"distance_traveled" : 65.4178
}, 
{ 
"stop_id" : 13,
"arrival_time" : "20:12:08" , 
"departure_time" : "20:12:08" , 
"distance_traveled" : 66.4981
} ], 
"3138" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:29:00" , 
"departure_time" : "17:29:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:39:28" , 
"departure_time" : "17:40:54" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:51:26" , 
"departure_time" : "17:52:01" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:56:35" , 
"departure_time" : "17:57:48" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "18:00:13" , 
"departure_time" : "18:00:45" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "18:02:32" , 
"departure_time" : "18:02:36" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "18:09:04" , 
"departure_time" : "18:09:17" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:14:13" , 
"departure_time" : "18:15:21" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "18:21:08" , 
"departure_time" : "18:22:03" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "18:23:55" , 
"departure_time" : "18:24:37" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "18:29:42" , 
"departure_time" : "18:29:49" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "18:34:07" , 
"departure_time" : "18:34:07" , 
"distance_traveled" : 29.7294
} ], 
"3139" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:36:00" , 
"departure_time" : "17:37:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:54:28" , 
"departure_time" : "17:55:33" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 158,
"arrival_time" : "18:12:05" , 
"departure_time" : "18:13:04" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 139,
"arrival_time" : "18:20:59" , 
"departure_time" : "18:21:45" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "18:30:46" , 
"departure_time" : "18:31:24" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "18:34:38" , 
"departure_time" : "18:34:56" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "18:40:18" , 
"departure_time" : "18:40:38" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "18:47:20" , 
"departure_time" : "18:48:11" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "18:51:51" , 
"departure_time" : "18:53:09" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "19:03:18" , 
"departure_time" : "19:03:18" , 
"distance_traveled" : 50.8055
} ], 
"3140" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:16:00" , 
"departure_time" : "18:18:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:26:32" , 
"departure_time" : "18:28:07" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:38:35" , 
"departure_time" : "18:38:55" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:43:20" , 
"departure_time" : "18:44:17" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "18:46:57" , 
"departure_time" : "18:47:21" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "18:49:24" , 
"departure_time" : "18:50:24" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "18:57:00" , 
"departure_time" : "18:57:20" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "19:01:20" , 
"departure_time" : "19:02:29" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "19:10:09" , 
"departure_time" : "19:11:27" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "19:13:18" , 
"departure_time" : "19:14:48" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "19:20:30" , 
"departure_time" : "19:20:43" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "19:28:13" , 
"departure_time" : "19:28:13" , 
"distance_traveled" : 29.7294
} ], 
"3141" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:29:00" , 
"departure_time" : "18:30:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:39:09" , 
"departure_time" : "18:39:43" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:47:34" , 
"departure_time" : "18:48:05" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 158,
"arrival_time" : "19:07:31" , 
"departure_time" : "19:07:36" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 139,
"arrival_time" : "19:16:05" , 
"departure_time" : "19:16:16" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "19:25:11" , 
"departure_time" : "19:26:29" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "19:30:18" , 
"departure_time" : "19:30:27" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "19:36:09" , 
"departure_time" : "19:37:13" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "19:43:04" , 
"departure_time" : "19:43:58" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "19:46:54" , 
"departure_time" : "19:48:07" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "19:58:13" , 
"departure_time" : "19:58:13" , 
"distance_traveled" : 50.8055
} ], 
"3142" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:20:00" , 
"departure_time" : "17:21:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:30:44" , 
"departure_time" : "17:30:55" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:39:11" , 
"departure_time" : "17:39:14" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:45:03" , 
"departure_time" : "17:45:08" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 11,
"arrival_time" : "17:59:05" , 
"departure_time" : "17:59:23" , 
"distance_traveled" : 22.9869
}, 
{ 
"stop_id" : 158,
"arrival_time" : "18:03:18" , 
"departure_time" : "18:04:19" , 
"distance_traveled" : 24.4405
}, 
{ 
"stop_id" : 119,
"arrival_time" : "18:10:01" , 
"departure_time" : "18:11:07" , 
"distance_traveled" : 27.8587
}, 
{ 
"stop_id" : 139,
"arrival_time" : "18:15:06" , 
"departure_time" : "18:15:37" , 
"distance_traveled" : 29.7328
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "18:22:31" , 
"departure_time" : "18:23:40" , 
"distance_traveled" : 35.1169
}, 
{ 
"stop_id" : 59,
"arrival_time" : "18:27:09" , 
"departure_time" : "18:27:46" , 
"distance_traveled" : 36.9042
}, 
{ 
"stop_id" : 85,
"arrival_time" : "18:33:37" , 
"departure_time" : "18:34:19" , 
"distance_traveled" : 41.3212
}, 
{ 
"stop_id" : 130,
"arrival_time" : "18:39:42" , 
"departure_time" : "18:41:21" , 
"distance_traveled" : 44.9438
}, 
{ 
"stop_id" : 73,
"arrival_time" : "18:44:39" , 
"departure_time" : "18:44:52" , 
"distance_traveled" : 47.2911
}, 
{ 
"stop_id" : 74,
"arrival_time" : "18:53:13" , 
"departure_time" : "18:53:13" , 
"distance_traveled" : 50.8089
} ], 
"3143" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:05:00" , 
"departure_time" : "17:06:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:16:07" , 
"departure_time" : "17:16:30" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:25:23" , 
"departure_time" : "17:26:23" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 109,
"arrival_time" : "17:32:00" , 
"departure_time" : "17:32:50" , 
"distance_traveled" : 14.3875
}, 
{ 
"stop_id" : 41,
"arrival_time" : "17:35:50" , 
"departure_time" : "17:37:08" , 
"distance_traveled" : 15.3631
}, 
{ 
"stop_id" : 70,
"arrival_time" : "17:42:18" , 
"departure_time" : "17:42:39" , 
"distance_traveled" : 18.6468
}, 
{ 
"stop_id" : 127,
"arrival_time" : "17:46:21" , 
"departure_time" : "17:47:02" , 
"distance_traveled" : 20.7053
}, 
{ 
"stop_id" : 11,
"arrival_time" : "17:52:41" , 
"departure_time" : "17:54:02" , 
"distance_traveled" : 22.9856
}, 
{ 
"stop_id" : 158,
"arrival_time" : "17:56:21" , 
"departure_time" : "17:56:51" , 
"distance_traveled" : 24.4392
}, 
{ 
"stop_id" : 119,
"arrival_time" : "18:01:30" , 
"departure_time" : "18:02:13" , 
"distance_traveled" : 27.8574
}, 
{ 
"stop_id" : 139,
"arrival_time" : "18:05:43" , 
"departure_time" : "18:05:43" , 
"distance_traveled" : 29.7314
} ], 
"3144" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "14:46:00" , 
"departure_time" : "14:48:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:57:17" , 
"departure_time" : "14:58:35" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:06:18" , 
"departure_time" : "15:07:22" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "15:11:04" , 
"departure_time" : "15:11:26" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 127,
"arrival_time" : "15:21:22" , 
"departure_time" : "15:22:02" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 158,
"arrival_time" : "15:28:40" , 
"departure_time" : "15:29:29" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "15:34:49" , 
"departure_time" : "15:35:39" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "15:39:50" , 
"departure_time" : "15:40:41" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "15:48:51" , 
"departure_time" : "15:49:33" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "15:52:42" , 
"departure_time" : "15:54:14" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "15:59:32" , 
"departure_time" : "15:59:36" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "16:04:04" , 
"departure_time" : "16:04:32" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "16:08:28" , 
"departure_time" : "16:09:54" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "16:20:26" , 
"departure_time" : "16:20:26" , 
"distance_traveled" : 50.8055
} ], 
"3145" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:45:00" , 
"departure_time" : "15:47:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:01:42" , 
"departure_time" : "16:03:18" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 158,
"arrival_time" : "16:20:36" , 
"departure_time" : "16:21:25" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 139,
"arrival_time" : "16:28:49" , 
"departure_time" : "16:29:05" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "16:37:16" , 
"departure_time" : "16:38:00" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "16:40:44" , 
"departure_time" : "16:40:59" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "16:47:15" , 
"departure_time" : "16:48:40" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "16:54:25" , 
"departure_time" : "16:55:57" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "16:58:32" , 
"departure_time" : "16:59:26" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "17:07:54" , 
"departure_time" : "17:07:54" , 
"distance_traveled" : 50.8055
} ], 
"3146" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "13:43:00" , 
"departure_time" : "13:44:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:53:25" , 
"departure_time" : "13:54:36" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:03:11" , 
"departure_time" : "14:04:22" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "14:08:11" , 
"departure_time" : "14:09:31" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 127,
"arrival_time" : "14:20:20" , 
"departure_time" : "14:21:12" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "14:25:52" , 
"departure_time" : "14:26:59" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "14:29:07" , 
"departure_time" : "14:29:41" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "14:35:34" , 
"departure_time" : "14:36:10" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "14:40:36" , 
"departure_time" : "14:42:12" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "14:49:36" , 
"departure_time" : "14:50:40" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "14:53:04" , 
"departure_time" : "14:54:30" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "14:59:26" , 
"departure_time" : "15:00:18" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "15:04:52" , 
"departure_time" : "15:06:14" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "15:09:22" , 
"departure_time" : "15:10:00" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "15:19:38" , 
"departure_time" : "15:19:38" , 
"distance_traveled" : 50.8055
} ], 
"3147" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:17:00" , 
"departure_time" : "15:18:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:27:38" , 
"departure_time" : "15:28:09" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:36:31" , 
"departure_time" : "15:37:00" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "15:42:29" , 
"departure_time" : "15:43:42" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "15:47:13" , 
"departure_time" : "15:47:23" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "15:49:10" , 
"departure_time" : "15:50:25" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "15:56:15" , 
"departure_time" : "15:57:46" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "16:00:31" , 
"departure_time" : "16:00:56" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "16:04:25" , 
"departure_time" : "16:04:42" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "16:08:17" , 
"departure_time" : "16:09:57" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "16:15:40" , 
"departure_time" : "16:16:51" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "16:22:11" , 
"departure_time" : "16:22:11" , 
"distance_traveled" : 29.7294
} ], 
"3148" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:05:00" , 
"departure_time" : "19:07:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:16:06" , 
"departure_time" : "19:16:12" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:24:06" , 
"departure_time" : "19:25:06" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:31:00" , 
"departure_time" : "19:32:07" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 127,
"arrival_time" : "19:41:07" , 
"departure_time" : "19:42:41" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "19:48:34" , 
"departure_time" : "19:49:39" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "19:51:05" , 
"departure_time" : "19:51:15" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "19:56:10" , 
"departure_time" : "19:57:12" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "20:02:02" , 
"departure_time" : "20:02:08" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "20:10:06" , 
"departure_time" : "20:11:37" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "20:15:31" , 
"departure_time" : "20:17:01" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "20:22:30" , 
"departure_time" : "20:24:03" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "20:28:33" , 
"departure_time" : "20:29:14" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "20:31:41" , 
"departure_time" : "20:31:44" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "20:39:03" , 
"departure_time" : "20:39:03" , 
"distance_traveled" : 50.8055
} ], 
"3149" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:09:00" , 
"departure_time" : "16:10:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:20:11" , 
"departure_time" : "16:21:19" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:29:08" , 
"departure_time" : "16:30:08" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:35:00" , 
"departure_time" : "16:35:19" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "16:37:19" , 
"departure_time" : "16:37:53" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "16:41:34" , 
"departure_time" : "16:41:40" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "16:47:06" , 
"departure_time" : "16:47:38" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "16:51:32" , 
"departure_time" : "16:52:56" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "16:59:24" , 
"departure_time" : "17:00:51" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "17:02:27" , 
"departure_time" : "17:02:30" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "17:07:03" , 
"departure_time" : "17:07:38" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "17:14:35" , 
"departure_time" : "17:14:35" , 
"distance_traveled" : 29.7294
} ], 
"3150" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:22:00" , 
"departure_time" : "20:23:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:32:07" , 
"departure_time" : "20:33:39" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:42:32" , 
"departure_time" : "20:43:00" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:47:28" , 
"departure_time" : "20:48:20" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:57:52" , 
"departure_time" : "20:58:20" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "21:03:28" , 
"departure_time" : "21:04:14" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "21:06:46" , 
"departure_time" : "21:08:16" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "21:13:30" , 
"departure_time" : "21:14:16" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "21:17:46" , 
"departure_time" : "21:19:22" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "21:26:36" , 
"departure_time" : "21:27:04" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "21:29:28" , 
"departure_time" : "21:29:45" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "21:36:17" , 
"departure_time" : "21:37:05" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "21:42:48" , 
"departure_time" : "21:44:28" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "21:47:40" , 
"departure_time" : "21:48:08" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "21:57:28" , 
"departure_time" : "21:57:28" , 
"distance_traveled" : 50.8055
} ], 
"3151" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:29:00" , 
"departure_time" : "17:30:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:40:00" , 
"departure_time" : "17:40:51" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:50:51" , 
"departure_time" : "17:51:34" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:56:43" , 
"departure_time" : "17:57:22" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "17:59:39" , 
"departure_time" : "18:01:02" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "18:03:23" , 
"departure_time" : "18:04:18" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "18:09:55" , 
"departure_time" : "18:11:16" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:15:21" , 
"departure_time" : "18:15:39" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "18:20:18" , 
"departure_time" : "18:21:25" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "18:24:07" , 
"departure_time" : "18:24:32" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "18:29:25" , 
"departure_time" : "18:30:31" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "18:35:06" , 
"departure_time" : "18:35:06" , 
"distance_traveled" : 29.7294
} ], 
"3152" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "08:45:00" , 
"departure_time" : "08:46:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:54:38" , 
"departure_time" : "08:56:15" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:04:37" , 
"departure_time" : "09:05:36" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:09:59" , 
"departure_time" : "09:10:56" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "09:13:57" , 
"departure_time" : "09:14:58" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "09:21:01" , 
"departure_time" : "09:21:59" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "09:24:58" , 
"departure_time" : "09:25:05" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 158,
"arrival_time" : "09:30:07" , 
"departure_time" : "09:31:13" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "09:38:06" , 
"departure_time" : "09:38:34" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "09:41:28" , 
"departure_time" : "09:41:54" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "09:49:26" , 
"departure_time" : "09:51:05" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "09:54:39" , 
"departure_time" : "09:54:47" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "09:59:08" , 
"departure_time" : "09:59:31" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "10:05:23" , 
"departure_time" : "10:06:14" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "10:09:51" , 
"departure_time" : "10:11:06" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "10:24:15" , 
"departure_time" : "10:24:15" , 
"distance_traveled" : 50.8055
} ], 
"3153" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:16:00" , 
"departure_time" : "18:18:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:26:03" , 
"departure_time" : "18:27:00" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:37:57" , 
"departure_time" : "18:38:47" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:43:50" , 
"departure_time" : "18:44:56" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "18:47:06" , 
"departure_time" : "18:48:02" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "18:49:56" , 
"departure_time" : "18:49:59" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "18:56:03" , 
"departure_time" : "18:57:10" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "19:02:07" , 
"departure_time" : "19:02:35" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "19:09:28" , 
"departure_time" : "19:09:56" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "19:12:28" , 
"departure_time" : "19:13:59" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "19:20:31" , 
"departure_time" : "19:21:15" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "19:28:44" , 
"departure_time" : "19:28:44" , 
"distance_traveled" : 29.7294
} ], 
"3154" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "04:28:00" , 
"departure_time" : "04:29:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "04:45:03" , 
"departure_time" : "04:45:56" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "04:50:53" , 
"departure_time" : "04:52:04" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "04:54:11" , 
"departure_time" : "04:55:15" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "04:57:04" , 
"departure_time" : "04:57:15" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "05:03:11" , 
"departure_time" : "05:04:24" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "05:08:13" , 
"departure_time" : "05:09:37" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "05:13:24" , 
"departure_time" : "05:14:55" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "05:16:31" , 
"departure_time" : "05:17:16" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "05:21:45" , 
"departure_time" : "05:23:06" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "05:27:21" , 
"departure_time" : "05:28:51" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "05:35:30" , 
"departure_time" : "05:35:55" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "05:38:25" , 
"departure_time" : "05:39:49" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "05:45:24" , 
"departure_time" : "05:46:17" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "05:50:53" , 
"departure_time" : "05:50:59" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "05:54:06" , 
"departure_time" : "05:55:25" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "06:06:19" , 
"departure_time" : "06:06:19" , 
"distance_traveled" : 50.8055
} ], 
"3155" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:20:00" , 
"departure_time" : "17:21:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:30:26" , 
"departure_time" : "17:31:45" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:40:19" , 
"departure_time" : "17:40:51" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:45:32" , 
"departure_time" : "17:46:34" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 11,
"arrival_time" : "18:00:02" , 
"departure_time" : "18:01:26" , 
"distance_traveled" : 22.9869
}, 
{ 
"stop_id" : 158,
"arrival_time" : "18:04:24" , 
"departure_time" : "18:04:25" , 
"distance_traveled" : 24.4405
}, 
{ 
"stop_id" : 119,
"arrival_time" : "18:09:01" , 
"departure_time" : "18:10:35" , 
"distance_traveled" : 27.8587
}, 
{ 
"stop_id" : 139,
"arrival_time" : "18:15:34" , 
"departure_time" : "18:15:46" , 
"distance_traveled" : 29.7328
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "18:22:12" , 
"departure_time" : "18:23:03" , 
"distance_traveled" : 35.1169
}, 
{ 
"stop_id" : 59,
"arrival_time" : "18:26:51" , 
"departure_time" : "18:27:13" , 
"distance_traveled" : 36.9042
}, 
{ 
"stop_id" : 85,
"arrival_time" : "18:33:22" , 
"departure_time" : "18:33:50" , 
"distance_traveled" : 41.3212
}, 
{ 
"stop_id" : 130,
"arrival_time" : "18:39:28" , 
"departure_time" : "18:39:41" , 
"distance_traveled" : 44.9438
}, 
{ 
"stop_id" : 73,
"arrival_time" : "18:43:13" , 
"departure_time" : "18:44:50" , 
"distance_traveled" : 47.2911
}, 
{ 
"stop_id" : 74,
"arrival_time" : "18:54:37" , 
"departure_time" : "18:54:37" , 
"distance_traveled" : 50.8089
} ], 
"3156" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:24:00" , 
"departure_time" : "19:26:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:40:32" , 
"departure_time" : "19:41:48" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:47:16" , 
"departure_time" : "19:47:58" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "19:49:42" , 
"departure_time" : "19:50:15" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "19:52:33" , 
"departure_time" : "19:52:37" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "19:59:04" , 
"departure_time" : "20:00:33" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:04:29" , 
"departure_time" : "20:05:48" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "20:10:19" , 
"departure_time" : "20:11:53" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "20:13:34" , 
"departure_time" : "20:14:17" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "20:18:43" , 
"departure_time" : "20:19:16" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "20:22:33" , 
"departure_time" : "20:24:08" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "20:31:35" , 
"departure_time" : "20:32:11" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "20:33:36" , 
"departure_time" : "20:34:11" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "20:39:35" , 
"departure_time" : "20:40:49" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "20:46:14" , 
"departure_time" : "20:47:23" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "20:50:09" , 
"departure_time" : "20:50:18" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "20:59:09" , 
"departure_time" : "20:59:09" , 
"distance_traveled" : 50.8055
} ], 
"3157" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "14:46:00" , 
"departure_time" : "14:46:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:56:31" , 
"departure_time" : "14:56:47" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:05:16" , 
"departure_time" : "15:05:55" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "15:10:39" , 
"departure_time" : "15:11:28" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 127,
"arrival_time" : "15:21:49" , 
"departure_time" : "15:21:52" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 158,
"arrival_time" : "15:28:03" , 
"departure_time" : "15:29:24" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "15:35:21" , 
"departure_time" : "15:36:05" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "15:39:44" , 
"departure_time" : "15:41:14" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "15:49:30" , 
"departure_time" : "15:50:40" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "15:53:10" , 
"departure_time" : "15:54:33" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "15:59:23" , 
"departure_time" : "15:59:53" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "16:04:30" , 
"departure_time" : "16:05:25" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "16:08:55" , 
"departure_time" : "16:10:34" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "16:20:39" , 
"departure_time" : "16:20:39" , 
"distance_traveled" : 50.8055
} ], 
"3158" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "25:00:00" , 
"departure_time" : "25:02:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "25:10:03" , 
"departure_time" : "25:10:26" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "25:18:23" , 
"departure_time" : "25:18:45" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "25:24:22" , 
"departure_time" : "25:25:49" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "25:30:27" , 
"departure_time" : "25:31:12" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "25:36:45" , 
"departure_time" : "25:37:30" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "25:40:45" , 
"departure_time" : "25:41:32" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "25:45:47" , 
"departure_time" : "25:47:02" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "25:49:15" , 
"departure_time" : "25:50:02" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "25:55:47" , 
"departure_time" : "25:56:11" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "25:59:24" , 
"departure_time" : "26:00:36" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "26:09:12" , 
"departure_time" : "26:10:30" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "26:13:18" , 
"departure_time" : "26:14:09" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "26:18:51" , 
"departure_time" : "26:20:24" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "26:25:33" , 
"departure_time" : "26:27:01" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "26:29:28" , 
"departure_time" : "26:29:42" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "26:42:14" , 
"departure_time" : "26:42:14" , 
"distance_traveled" : 50.8055
} ], 
"3159" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "13:43:00" , 
"departure_time" : "13:43:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:53:21" , 
"departure_time" : "13:54:20" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:02:59" , 
"departure_time" : "14:03:48" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "14:07:49" , 
"departure_time" : "14:08:13" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 127,
"arrival_time" : "14:19:24" , 
"departure_time" : "14:20:01" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "14:25:37" , 
"departure_time" : "14:27:15" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "14:29:38" , 
"departure_time" : "14:30:37" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "14:35:59" , 
"departure_time" : "14:36:08" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "14:40:09" , 
"departure_time" : "14:41:13" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "14:49:04" , 
"departure_time" : "14:49:06" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "14:52:02" , 
"departure_time" : "14:52:19" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "14:58:17" , 
"departure_time" : "14:58:42" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "15:04:25" , 
"departure_time" : "15:04:32" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "15:08:07" , 
"departure_time" : "15:09:31" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "15:20:24" , 
"departure_time" : "15:20:24" , 
"distance_traveled" : 50.8055
} ], 
"3160" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "09:46:00" , 
"departure_time" : "09:48:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:55:39" , 
"departure_time" : "09:56:16" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:05:37" , 
"departure_time" : "10:06:53" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:11:16" , 
"departure_time" : "10:12:45" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "10:16:29" , 
"departure_time" : "10:17:24" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "10:22:55" , 
"departure_time" : "10:23:42" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "10:26:47" , 
"departure_time" : "10:27:39" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "10:32:52" , 
"departure_time" : "10:34:21" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "10:36:29" , 
"departure_time" : "10:37:25" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "10:42:56" , 
"departure_time" : "10:44:27" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "10:48:31" , 
"departure_time" : "10:50:01" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "10:56:30" , 
"departure_time" : "10:57:27" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "10:59:57" , 
"departure_time" : "11:01:01" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "11:07:04" , 
"departure_time" : "11:07:10" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "11:12:06" , 
"departure_time" : "11:12:50" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "11:16:44" , 
"departure_time" : "11:16:57" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "11:26:13" , 
"departure_time" : "11:26:13" , 
"distance_traveled" : 50.8055
} ], 
"3161" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:05:00" , 
"departure_time" : "19:06:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:16:01" , 
"departure_time" : "19:17:24" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:25:23" , 
"departure_time" : "19:26:52" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:31:29" , 
"departure_time" : "19:31:31" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 127,
"arrival_time" : "19:40:02" , 
"departure_time" : "19:40:48" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "19:47:46" , 
"departure_time" : "19:48:14" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "19:50:28" , 
"departure_time" : "19:52:04" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "19:57:36" , 
"departure_time" : "19:57:41" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "20:01:05" , 
"departure_time" : "20:01:10" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "20:10:05" , 
"departure_time" : "20:10:27" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "20:14:22" , 
"departure_time" : "20:15:00" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "20:21:38" , 
"departure_time" : "20:23:08" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "20:28:30" , 
"departure_time" : "20:30:03" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "20:32:33" , 
"departure_time" : "20:34:07" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "20:40:34" , 
"departure_time" : "20:40:34" , 
"distance_traveled" : 50.8055
} ], 
"3162" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "06:20:00" , 
"departure_time" : "06:22:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:29:28" , 
"departure_time" : "06:30:11" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:37:43" , 
"departure_time" : "06:38:58" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "06:43:15" , 
"departure_time" : "06:43:48" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "06:45:33" , 
"departure_time" : "06:46:33" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "06:49:00" , 
"departure_time" : "06:50:33" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "06:56:33" , 
"departure_time" : "06:57:41" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "07:00:08" , 
"departure_time" : "07:00:47" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 158,
"arrival_time" : "07:06:39" , 
"departure_time" : "07:08:14" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "07:13:35" , 
"departure_time" : "07:14:23" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "07:17:48" , 
"departure_time" : "07:18:25" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "07:25:37" , 
"departure_time" : "07:26:13" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "07:29:36" , 
"departure_time" : "07:30:11" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "07:35:35" , 
"departure_time" : "07:37:11" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "07:42:36" , 
"departure_time" : "07:42:44" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "07:45:08" , 
"departure_time" : "07:45:15" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "07:56:07" , 
"departure_time" : "07:56:07" , 
"distance_traveled" : 50.8055
} ], 
"3163" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:22:00" , 
"departure_time" : "20:23:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:32:38" , 
"departure_time" : "20:33:52" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:42:14" , 
"departure_time" : "20:43:36" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:48:22" , 
"departure_time" : "20:49:10" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:57:48" , 
"departure_time" : "20:58:22" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "21:03:34" , 
"departure_time" : "21:04:47" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "21:07:13" , 
"departure_time" : "21:07:14" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "21:12:01" , 
"departure_time" : "21:12:24" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "21:17:23" , 
"departure_time" : "21:18:42" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "21:26:19" , 
"departure_time" : "21:27:29" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "21:30:10" , 
"departure_time" : "21:31:18" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "21:37:08" , 
"departure_time" : "21:38:13" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "21:43:05" , 
"departure_time" : "21:44:03" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "21:46:58" , 
"departure_time" : "21:46:59" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "21:57:01" , 
"departure_time" : "21:57:01" , 
"distance_traveled" : 50.8055
} ], 
"3164" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "07:44:00" , 
"departure_time" : "07:44:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:53:27" , 
"departure_time" : "07:53:36" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:02:09" , 
"departure_time" : "08:02:15" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:08:06" , 
"departure_time" : "08:09:38" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "08:12:32" , 
"departure_time" : "08:13:21" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "08:14:49" , 
"departure_time" : "08:15:41" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "08:21:52" , 
"departure_time" : "08:22:36" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:25:44" , 
"departure_time" : "08:26:26" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 158,
"arrival_time" : "08:32:42" , 
"departure_time" : "08:33:56" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "08:39:14" , 
"departure_time" : "08:39:33" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "08:43:19" , 
"departure_time" : "08:43:50" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "08:51:31" , 
"departure_time" : "08:52:03" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "08:55:32" , 
"departure_time" : "08:57:04" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "09:02:32" , 
"departure_time" : "09:03:20" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "09:07:48" , 
"departure_time" : "09:08:50" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "09:12:02" , 
"departure_time" : "09:12:34" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "09:23:32" , 
"departure_time" : "09:23:32" , 
"distance_traveled" : 50.8055
} ], 
"3165" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "08:45:00" , 
"departure_time" : "08:45:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:54:20" , 
"departure_time" : "08:55:55" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:04:35" , 
"departure_time" : "09:06:02" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:10:27" , 
"departure_time" : "09:11:06" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "09:13:39" , 
"departure_time" : "09:14:21" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "09:20:42" , 
"departure_time" : "09:21:45" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "09:25:03" , 
"departure_time" : "09:26:06" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 158,
"arrival_time" : "09:31:03" , 
"departure_time" : "09:31:34" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "09:37:31" , 
"departure_time" : "09:37:52" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "09:41:21" , 
"departure_time" : "09:42:42" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "09:50:21" , 
"departure_time" : "09:50:44" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "09:53:23" , 
"departure_time" : "09:54:27" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "10:00:04" , 
"departure_time" : "10:01:07" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "10:06:03" , 
"departure_time" : "10:07:36" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "10:10:33" , 
"departure_time" : "10:11:19" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "10:23:46" , 
"departure_time" : "10:23:46" , 
"distance_traveled" : 50.8055
} ], 
"3166" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "10:41:00" , 
"departure_time" : "10:43:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:52:16" , 
"departure_time" : "10:53:22" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:01:06" , 
"departure_time" : "11:01:41" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "11:06:35" , 
"departure_time" : "11:07:04" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "11:09:29" , 
"departure_time" : "11:10:26" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "11:12:57" , 
"departure_time" : "11:14:20" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "11:20:23" , 
"departure_time" : "11:20:54" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "11:23:31" , 
"departure_time" : "11:24:28" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 158,
"arrival_time" : "11:30:57" , 
"departure_time" : "11:31:51" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "11:36:54" , 
"departure_time" : "11:37:07" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "11:41:13" , 
"departure_time" : "11:41:50" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "11:49:37" , 
"departure_time" : "11:51:12" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "11:54:35" , 
"departure_time" : "11:55:38" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "12:01:03" , 
"departure_time" : "12:01:35" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "12:06:32" , 
"departure_time" : "12:07:22" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "12:10:50" , 
"departure_time" : "12:11:11" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "12:23:21" , 
"departure_time" : "12:23:21" , 
"distance_traveled" : 50.8055
} ], 
"3167" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "04:28:00" , 
"departure_time" : "04:28:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "04:44:38" , 
"departure_time" : "04:44:46" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "04:50:08" , 
"departure_time" : "04:50:39" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "04:53:31" , 
"departure_time" : "04:54:03" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "04:56:32" , 
"departure_time" : "04:57:29" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "05:03:57" , 
"departure_time" : "05:05:01" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "05:08:04" , 
"departure_time" : "05:09:38" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "05:13:34" , 
"departure_time" : "05:14:21" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "05:15:47" , 
"departure_time" : "05:16:20" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "05:21:33" , 
"departure_time" : "05:22:24" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "05:26:51" , 
"departure_time" : "05:28:19" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "05:35:28" , 
"departure_time" : "05:36:00" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "05:38:32" , 
"departure_time" : "05:39:11" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "05:44:39" , 
"departure_time" : "05:45:47" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "05:51:08" , 
"departure_time" : "05:52:12" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "05:55:04" , 
"departure_time" : "05:55:18" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "06:05:14" , 
"departure_time" : "06:05:14" , 
"distance_traveled" : 50.8055
} ], 
"3168" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "12:43:00" , 
"departure_time" : "12:43:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:53:45" , 
"departure_time" : "12:54:55" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:03:10" , 
"departure_time" : "13:04:48" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:09:38" , 
"departure_time" : "13:10:13" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "13:11:35" , 
"departure_time" : "13:13:10" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "13:15:35" , 
"departure_time" : "13:16:01" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "13:21:26" , 
"departure_time" : "13:21:30" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "13:25:04" , 
"departure_time" : "13:25:59" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 158,
"arrival_time" : "13:32:55" , 
"departure_time" : "13:33:50" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "13:38:55" , 
"departure_time" : "13:39:18" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "13:43:23" , 
"departure_time" : "13:44:10" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "13:51:47" , 
"departure_time" : "13:53:25" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "13:56:38" , 
"departure_time" : "13:57:41" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "14:03:03" , 
"departure_time" : "14:04:22" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "14:09:19" , 
"departure_time" : "14:10:20" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "14:13:01" , 
"departure_time" : "14:14:26" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "14:24:25" , 
"departure_time" : "14:24:25" , 
"distance_traveled" : 50.8055
} ], 
"3169" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:24:00" , 
"departure_time" : "19:25:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:40:06" , 
"departure_time" : "19:40:18" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:46:12" , 
"departure_time" : "19:46:49" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "19:49:37" , 
"departure_time" : "19:50:32" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "19:52:55" , 
"departure_time" : "19:54:21" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "20:00:26" , 
"departure_time" : "20:00:54" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:03:28" , 
"departure_time" : "20:04:47" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "20:10:19" , 
"departure_time" : "20:11:23" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "20:13:04" , 
"departure_time" : "20:13:32" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "20:18:28" , 
"departure_time" : "20:19:11" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "20:22:43" , 
"departure_time" : "20:22:48" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "20:30:05" , 
"departure_time" : "20:31:39" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "20:34:34" , 
"departure_time" : "20:36:05" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "20:40:31" , 
"departure_time" : "20:41:22" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "20:45:51" , 
"departure_time" : "20:46:55" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "20:50:04" , 
"departure_time" : "20:51:23" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "21:00:19" , 
"departure_time" : "21:00:19" , 
"distance_traveled" : 50.8055
} ], 
"3170" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "21:38:00" , 
"departure_time" : "21:40:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:49:01" , 
"departure_time" : "21:49:55" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:59:54" , 
"departure_time" : "22:01:07" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:06:13" , 
"departure_time" : "22:07:01" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "22:08:48" , 
"departure_time" : "22:09:27" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "22:11:39" , 
"departure_time" : "22:11:51" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "22:17:12" , 
"departure_time" : "22:18:43" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "22:22:31" , 
"departure_time" : "22:23:27" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 158,
"arrival_time" : "22:28:56" , 
"departure_time" : "22:29:22" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "22:34:26" , 
"departure_time" : "22:34:51" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "22:38:25" , 
"departure_time" : "22:39:09" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "22:46:44" , 
"departure_time" : "22:48:06" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "22:50:22" , 
"departure_time" : "22:51:42" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "22:56:20" , 
"departure_time" : "22:57:32" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "23:02:12" , 
"departure_time" : "23:03:26" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "23:07:14" , 
"departure_time" : "23:08:30" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "23:17:16" , 
"departure_time" : "23:17:16" , 
"distance_traveled" : 50.8055
} ], 
"3171" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "25:00:00" , 
"departure_time" : "25:01:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "25:09:07" , 
"departure_time" : "25:09:57" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "25:18:50" , 
"departure_time" : "25:18:51" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "25:24:01" , 
"departure_time" : "25:24:41" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "25:29:40" , 
"departure_time" : "25:30:24" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "25:36:44" , 
"departure_time" : "25:38:12" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "25:41:28" , 
"departure_time" : "25:42:04" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "25:45:36" , 
"departure_time" : "25:46:56" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "25:49:20" , 
"departure_time" : "25:49:34" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "25:55:14" , 
"departure_time" : "25:55:19" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "25:59:05" , 
"departure_time" : "25:59:48" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "26:08:43" , 
"departure_time" : "26:09:52" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "26:13:09" , 
"departure_time" : "26:13:29" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "26:18:20" , 
"departure_time" : "26:19:08" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "26:24:48" , 
"departure_time" : "26:25:50" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "26:29:02" , 
"departure_time" : "26:30:33" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "26:43:31" , 
"departure_time" : "26:43:31" , 
"distance_traveled" : 50.8055
} ], 
"3172" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "23:18:00" , 
"departure_time" : "23:19:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:28:17" , 
"departure_time" : "23:29:24" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "23:37:07" , 
"departure_time" : "23:37:14" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "23:42:07" , 
"departure_time" : "23:43:01" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "23:46:54" , 
"departure_time" : "23:47:49" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "23:49:55" , 
"departure_time" : "23:51:29" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "23:56:34" , 
"departure_time" : "23:57:18" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "23:59:44" , 
"departure_time" : "24:01:10" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 158,
"arrival_time" : "24:07:26" , 
"departure_time" : "24:08:08" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "24:11:42" , 
"departure_time" : "24:12:53" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "24:17:11" , 
"departure_time" : "24:18:28" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "24:25:17" , 
"departure_time" : "24:26:43" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "24:29:26" , 
"departure_time" : "24:29:55" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "24:34:29" , 
"departure_time" : "24:34:41" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "24:40:12" , 
"departure_time" : "24:41:45" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "24:45:33" , 
"departure_time" : "24:46:55" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "25:00:22" , 
"departure_time" : "25:00:22" , 
"distance_traveled" : 50.8055
} ], 
"3173" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "09:46:00" , 
"departure_time" : "09:47:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:55:09" , 
"departure_time" : "09:55:23" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:05:14" , 
"departure_time" : "10:06:00" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:10:46" , 
"departure_time" : "10:11:46" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "10:16:00" , 
"departure_time" : "10:17:16" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "10:23:16" , 
"departure_time" : "10:24:51" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "10:27:35" , 
"departure_time" : "10:27:55" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "10:32:20" , 
"departure_time" : "10:33:26" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "10:36:06" , 
"departure_time" : "10:36:34" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "10:42:28" , 
"departure_time" : "10:43:27" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "10:47:59" , 
"departure_time" : "10:48:31" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "10:55:32" , 
"departure_time" : "10:55:45" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "10:59:13" , 
"departure_time" : "10:59:43" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "11:06:30" , 
"departure_time" : "11:06:42" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "11:12:12" , 
"departure_time" : "11:13:23" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "11:17:11" , 
"departure_time" : "11:18:23" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "11:27:12" , 
"departure_time" : "11:27:12" , 
"distance_traveled" : 50.8055
} ], 
"3174" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "24:05:00" , 
"departure_time" : "24:06:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:14:05" , 
"departure_time" : "24:15:12" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "24:23:07" , 
"departure_time" : "24:24:29" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "24:29:22" , 
"departure_time" : "24:29:51" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "24:32:29" , 
"departure_time" : "24:33:08" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "24:35:39" , 
"departure_time" : "24:36:26" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "24:42:47" , 
"departure_time" : "24:42:53" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "24:46:06" , 
"departure_time" : "24:46:31" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "24:51:25" , 
"departure_time" : "24:52:27" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "24:55:02" , 
"departure_time" : "24:56:14" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "25:02:12" , 
"departure_time" : "25:02:54" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "25:05:42" , 
"departure_time" : "25:06:41" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "25:14:59" , 
"departure_time" : "25:16:34" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "25:19:35" , 
"departure_time" : "25:21:04" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "25:25:29" , 
"departure_time" : "25:25:52" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "25:30:23" , 
"departure_time" : "25:30:37" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "25:34:14" , 
"departure_time" : "25:35:44" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "25:49:30" , 
"departure_time" : "25:49:30" , 
"distance_traveled" : 50.8055
} ], 
"3175" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "06:20:00" , 
"departure_time" : "06:21:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:29:01" , 
"departure_time" : "06:29:16" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:37:15" , 
"departure_time" : "06:38:19" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "06:43:04" , 
"departure_time" : "06:43:40" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "06:45:36" , 
"departure_time" : "06:47:09" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "06:49:33" , 
"departure_time" : "06:50:31" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "06:55:58" , 
"departure_time" : "06:56:27" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "06:59:29" , 
"departure_time" : "07:01:08" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 158,
"arrival_time" : "07:07:39" , 
"departure_time" : "07:08:02" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "07:12:23" , 
"departure_time" : "07:12:28" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "07:17:05" , 
"departure_time" : "07:18:11" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "07:26:06" , 
"departure_time" : "07:27:40" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "07:30:34" , 
"departure_time" : "07:30:46" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "07:35:12" , 
"departure_time" : "07:35:58" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "07:41:46" , 
"departure_time" : "07:42:41" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "07:45:55" , 
"departure_time" : "07:46:05" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "07:56:10" , 
"departure_time" : "07:56:10" , 
"distance_traveled" : 50.8055
} ], 
"3176" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "05:32:00" , 
"departure_time" : "05:33:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:43:37" , 
"departure_time" : "05:43:48" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "05:51:11" , 
"departure_time" : "05:52:25" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "05:57:14" , 
"departure_time" : "05:58:44" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "06:00:30" , 
"departure_time" : "06:01:44" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "06:03:14" , 
"departure_time" : "06:04:32" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "06:10:18" , 
"departure_time" : "06:10:41" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "06:13:23" , 
"departure_time" : "06:14:44" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "06:20:21" , 
"departure_time" : "06:21:54" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "06:23:33" , 
"departure_time" : "06:24:03" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "06:28:30" , 
"departure_time" : "06:28:39" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "06:33:09" , 
"departure_time" : "06:34:23" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "06:42:14" , 
"departure_time" : "06:42:19" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "06:45:05" , 
"departure_time" : "06:45:08" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "06:52:03" , 
"departure_time" : "06:53:14" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "06:59:11" , 
"departure_time" : "07:00:44" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "07:03:33" , 
"departure_time" : "07:04:56" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "07:13:23" , 
"departure_time" : "07:13:23" , 
"distance_traveled" : 50.8055
} ], 
"3177" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "07:44:00" , 
"departure_time" : "07:45:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:53:25" , 
"departure_time" : "07:53:45" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:02:20" , 
"departure_time" : "08:03:57" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:09:37" , 
"departure_time" : "08:09:44" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "08:11:07" , 
"departure_time" : "08:12:04" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "08:14:57" , 
"departure_time" : "08:15:28" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "08:21:31" , 
"departure_time" : "08:21:45" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:25:14" , 
"departure_time" : "08:25:40" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 158,
"arrival_time" : "08:32:26" , 
"departure_time" : "08:32:53" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "08:38:27" , 
"departure_time" : "08:38:48" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "08:43:21" , 
"departure_time" : "08:44:12" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "08:51:51" , 
"departure_time" : "08:52:10" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "08:55:19" , 
"departure_time" : "08:56:53" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "09:02:34" , 
"departure_time" : "09:03:43" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "09:08:09" , 
"departure_time" : "09:08:27" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "09:11:18" , 
"departure_time" : "09:12:18" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "09:24:00" , 
"departure_time" : "09:24:00" , 
"distance_traveled" : 50.8055
} ], 
"3178" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "07:01:00" , 
"departure_time" : "07:02:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:10:56" , 
"departure_time" : "07:12:04" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:19:08" , 
"departure_time" : "07:19:36" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "07:24:28" , 
"departure_time" : "07:25:27" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "07:27:59" , 
"departure_time" : "07:29:31" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "07:31:32" , 
"departure_time" : "07:32:08" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "07:37:36" , 
"departure_time" : "07:39:14" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "07:42:38" , 
"departure_time" : "07:44:18" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "07:48:40" , 
"departure_time" : "07:49:42" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "07:51:02" , 
"departure_time" : "07:52:04" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "07:57:02" , 
"departure_time" : "07:57:11" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "08:01:09" , 
"departure_time" : "08:02:07" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "08:10:58" , 
"departure_time" : "08:11:17" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "08:14:19" , 
"departure_time" : "08:14:59" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "08:20:40" , 
"departure_time" : "08:21:18" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "08:26:38" , 
"departure_time" : "08:28:04" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "08:31:26" , 
"departure_time" : "08:31:39" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "08:40:13" , 
"departure_time" : "08:40:13" , 
"distance_traveled" : 50.8055
} ], 
"3179" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "10:41:00" , 
"departure_time" : "10:41:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:51:42" , 
"departure_time" : "10:52:48" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:01:06" , 
"departure_time" : "11:02:29" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "11:07:23" , 
"departure_time" : "11:08:39" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "11:10:16" , 
"departure_time" : "11:10:25" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "11:12:09" , 
"departure_time" : "11:12:42" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "11:19:33" , 
"departure_time" : "11:19:54" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "11:23:21" , 
"departure_time" : "11:24:51" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 158,
"arrival_time" : "11:31:30" , 
"departure_time" : "11:32:35" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "11:37:05" , 
"departure_time" : "11:37:23" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "11:41:18" , 
"departure_time" : "11:41:28" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "11:49:10" , 
"departure_time" : "11:49:35" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "11:53:25" , 
"departure_time" : "11:54:09" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "12:00:44" , 
"departure_time" : "12:02:16" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "12:07:32" , 
"departure_time" : "12:08:44" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "12:11:12" , 
"departure_time" : "12:11:20" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "12:23:08" , 
"departure_time" : "12:23:08" , 
"distance_traveled" : 50.8055
} ], 
"3180" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "11:43:00" , 
"departure_time" : "11:43:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:53:28" , 
"departure_time" : "11:54:10" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:02:42" , 
"departure_time" : "12:03:31" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "12:08:49" , 
"departure_time" : "12:09:22" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "12:11:33" , 
"departure_time" : "12:11:54" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "12:14:21" , 
"departure_time" : "12:15:58" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "12:22:37" , 
"departure_time" : "12:23:34" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "12:25:57" , 
"departure_time" : "12:27:19" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "12:32:22" , 
"departure_time" : "12:32:46" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "12:34:24" , 
"departure_time" : "12:34:34" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "12:40:10" , 
"departure_time" : "12:41:09" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "12:45:59" , 
"departure_time" : "12:47:04" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "12:54:05" , 
"departure_time" : "12:54:52" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "12:57:47" , 
"departure_time" : "12:58:34" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "13:03:47" , 
"departure_time" : "13:04:47" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "13:10:00" , 
"departure_time" : "13:10:26" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "13:13:26" , 
"departure_time" : "13:14:24" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "13:23:58" , 
"departure_time" : "13:23:58" , 
"distance_traveled" : 50.8055
} ], 
"3181" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "12:43:00" , 
"departure_time" : "12:44:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:53:48" , 
"departure_time" : "12:55:20" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:03:32" , 
"departure_time" : "13:04:10" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:08:38" , 
"departure_time" : "13:09:56" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "13:12:18" , 
"departure_time" : "13:13:31" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "13:15:13" , 
"departure_time" : "13:16:02" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "13:21:49" , 
"departure_time" : "13:22:44" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "13:25:55" , 
"departure_time" : "13:26:09" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 158,
"arrival_time" : "13:32:14" , 
"departure_time" : "13:33:46" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "13:39:32" , 
"departure_time" : "13:40:12" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "13:43:40" , 
"departure_time" : "13:44:12" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "13:51:32" , 
"departure_time" : "13:52:31" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "13:55:59" , 
"departure_time" : "13:56:19" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "14:02:20" , 
"departure_time" : "14:03:44" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "14:09:24" , 
"departure_time" : "14:11:04" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "14:13:40" , 
"departure_time" : "14:15:14" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "14:24:34" , 
"departure_time" : "14:24:34" , 
"distance_traveled" : 50.8055
} ], 
"3182" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:55:00" , 
"departure_time" : "17:56:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:05:15" , 
"departure_time" : "18:06:32" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:17:17" , 
"departure_time" : "18:17:59" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:23:42" , 
"departure_time" : "18:25:18" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "18:28:36" , 
"departure_time" : "18:29:03" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "18:30:27" , 
"departure_time" : "18:31:35" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "18:38:08" , 
"departure_time" : "18:38:10" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:42:02" , 
"departure_time" : "18:43:08" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "18:49:06" , 
"departure_time" : "18:49:15" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "18:52:09" , 
"departure_time" : "18:53:11" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "19:00:02" , 
"departure_time" : "19:00:15" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "19:03:13" , 
"departure_time" : "19:04:33" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "19:13:20" , 
"departure_time" : "19:14:10" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "19:16:50" , 
"departure_time" : "19:18:14" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "19:24:24" , 
"departure_time" : "19:25:29" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "19:30:05" , 
"departure_time" : "19:31:06" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "19:34:01" , 
"departure_time" : "19:34:34" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "19:41:33" , 
"departure_time" : "19:41:33" , 
"distance_traveled" : 50.8055
} ], 
"3183" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "21:38:00" , 
"departure_time" : "21:40:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:49:35" , 
"departure_time" : "21:51:10" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:00:35" , 
"departure_time" : "22:00:48" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:05:13" , 
"departure_time" : "22:06:03" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "22:08:50" , 
"departure_time" : "22:09:08" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "22:11:18" , 
"departure_time" : "22:12:35" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "22:18:17" , 
"departure_time" : "22:18:38" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "22:21:21" , 
"departure_time" : "22:21:26" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 158,
"arrival_time" : "22:28:05" , 
"departure_time" : "22:28:17" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "22:34:12" , 
"departure_time" : "22:35:13" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "22:39:01" , 
"departure_time" : "22:39:43" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "22:46:42" , 
"departure_time" : "22:47:37" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "22:49:55" , 
"departure_time" : "22:51:21" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "22:56:26" , 
"departure_time" : "22:57:43" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "23:02:17" , 
"departure_time" : "23:02:58" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "23:06:41" , 
"departure_time" : "23:07:55" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "23:17:14" , 
"departure_time" : "23:17:14" , 
"distance_traveled" : 50.8055
} ], 
"3184" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:41:00" , 
"departure_time" : "20:43:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:52:17" , 
"departure_time" : "20:52:43" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:00:26" , 
"departure_time" : "21:01:53" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "21:07:27" , 
"departure_time" : "21:08:04" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "21:10:37" , 
"departure_time" : "21:10:57" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "21:13:20" , 
"departure_time" : "21:14:24" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "21:20:04" , 
"departure_time" : "21:21:32" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "21:24:28" , 
"departure_time" : "21:24:43" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "21:29:15" , 
"departure_time" : "21:29:58" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "21:32:43" , 
"departure_time" : "21:33:19" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "21:38:36" , 
"departure_time" : "21:39:39" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "21:43:03" , 
"departure_time" : "21:44:00" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "21:50:57" , 
"departure_time" : "21:51:45" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "21:54:48" , 
"departure_time" : "21:56:16" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "22:01:28" , 
"departure_time" : "22:02:52" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "22:06:24" , 
"departure_time" : "22:07:09" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "22:09:45" , 
"departure_time" : "22:11:15" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "22:22:30" , 
"departure_time" : "22:22:30" , 
"distance_traveled" : 50.8055
} ], 
"3185" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "23:18:00" , 
"departure_time" : "23:21:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:29:37" , 
"departure_time" : "23:30:14" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "23:36:37" , 
"departure_time" : "23:37:29" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "23:42:52" , 
"departure_time" : "23:43:00" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "23:46:08" , 
"departure_time" : "23:46:42" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "23:49:34" , 
"departure_time" : "23:50:55" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "23:56:21" , 
"departure_time" : "23:57:59" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "24:00:38" , 
"departure_time" : "24:00:40" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 158,
"arrival_time" : "24:06:02" , 
"departure_time" : "24:07:14" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "24:12:12" , 
"departure_time" : "24:13:16" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "24:17:04" , 
"departure_time" : "24:17:43" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "24:24:39" , 
"departure_time" : "24:24:56" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "24:28:17" , 
"departure_time" : "24:28:30" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "24:34:13" , 
"departure_time" : "24:35:05" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "24:40:52" , 
"departure_time" : "24:41:34" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "24:44:42" , 
"departure_time" : "24:44:55" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "24:59:13" , 
"departure_time" : "24:59:13" , 
"distance_traveled" : 50.8055
} ], 
"3186" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "22:20:00" , 
"departure_time" : "22:21:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:31:28" , 
"departure_time" : "22:32:05" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:40:37" , 
"departure_time" : "22:41:32" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:46:55" , 
"departure_time" : "22:47:10" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "22:49:15" , 
"departure_time" : "22:50:15" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "22:53:00" , 
"departure_time" : "22:53:31" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "22:58:31" , 
"departure_time" : "23:00:10" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "23:03:39" , 
"departure_time" : "23:05:07" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "23:09:28" , 
"departure_time" : "23:09:41" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "23:12:13" , 
"departure_time" : "23:12:23" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "23:18:10" , 
"departure_time" : "23:19:40" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "23:23:30" , 
"departure_time" : "23:23:33" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "23:30:03" , 
"departure_time" : "23:31:15" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "23:35:12" , 
"departure_time" : "23:36:35" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "23:41:23" , 
"departure_time" : "23:43:03" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "23:47:40" , 
"departure_time" : "23:49:15" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "23:51:35" , 
"departure_time" : "23:52:51" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "24:06:16" , 
"departure_time" : "24:06:16" , 
"distance_traveled" : 50.8055
} ], 
"3187" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "24:05:00" , 
"departure_time" : "24:06:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:14:19" , 
"departure_time" : "24:14:26" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "24:22:07" , 
"departure_time" : "24:22:27" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "24:28:20" , 
"departure_time" : "24:28:57" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "24:32:37" , 
"departure_time" : "24:33:05" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "24:35:28" , 
"departure_time" : "24:36:12" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "24:42:44" , 
"departure_time" : "24:44:23" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "24:47:39" , 
"departure_time" : "24:48:50" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "24:52:11" , 
"departure_time" : "24:53:21" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "24:55:10" , 
"departure_time" : "24:56:47" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "25:02:37" , 
"departure_time" : "25:04:15" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "25:06:38" , 
"departure_time" : "25:08:13" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "25:15:35" , 
"departure_time" : "25:16:00" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "25:18:25" , 
"departure_time" : "25:19:12" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "25:24:47" , 
"departure_time" : "25:25:06" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "25:30:19" , 
"departure_time" : "25:31:35" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "25:35:16" , 
"departure_time" : "25:35:23" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "25:48:07" , 
"departure_time" : "25:48:07" , 
"distance_traveled" : 50.8055
} ], 
"3188" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:01:00" , 
"departure_time" : "17:01:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:11:52" , 
"departure_time" : "17:13:02" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:22:10" , 
"departure_time" : "17:23:23" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 158,
"arrival_time" : "17:41:13" , 
"departure_time" : "17:41:27" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 139,
"arrival_time" : "17:49:14" , 
"departure_time" : "17:49:32" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "17:58:18" , 
"departure_time" : "17:58:36" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "18:02:18" , 
"departure_time" : "18:03:15" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "18:09:57" , 
"departure_time" : "18:10:20" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "18:15:23" , 
"departure_time" : "18:16:42" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "18:20:19" , 
"departure_time" : "18:20:42" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "18:26:23" , 
"departure_time" : "18:27:20" , 
"distance_traveled" : 50.8055
}, 
{ 
"stop_id" : 40,
"arrival_time" : "18:31:57" , 
"departure_time" : "18:33:07" , 
"distance_traveled" : 53.0739
}, 
{ 
"stop_id" : 4,
"arrival_time" : "18:36:10" , 
"departure_time" : "18:37:44" , 
"distance_traveled" : 55.09
}, 
{ 
"stop_id" : 8,
"arrival_time" : "18:40:34" , 
"departure_time" : "18:41:28" , 
"distance_traveled" : 56.6843
}, 
{ 
"stop_id" : 22,
"arrival_time" : "18:42:54" , 
"departure_time" : "18:42:57" , 
"distance_traveled" : 57.5131
}, 
{ 
"stop_id" : 15,
"arrival_time" : "18:46:03" , 
"departure_time" : "18:46:42" , 
"distance_traveled" : 59.1699
}, 
{ 
"stop_id" : 141,
"arrival_time" : "18:50:39" , 
"departure_time" : "18:51:20" , 
"distance_traveled" : 61.2879
}, 
{ 
"stop_id" : 79,
"arrival_time" : "18:54:41" , 
"departure_time" : "18:54:46" , 
"distance_traveled" : 63.4625
}, 
{ 
"stop_id" : 122,
"arrival_time" : "19:04:05" , 
"departure_time" : "19:04:06" , 
"distance_traveled" : 65.4178
}, 
{ 
"stop_id" : 13,
"arrival_time" : "19:07:01" , 
"departure_time" : "19:07:01" , 
"distance_traveled" : 66.4981
} ], 
"3189" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "05:32:00" , 
"departure_time" : "05:32:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:42:17" , 
"departure_time" : "05:43:29" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "05:52:12" , 
"departure_time" : "05:53:08" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "05:56:56" , 
"departure_time" : "05:57:55" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "05:59:59" , 
"departure_time" : "06:00:55" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "06:02:56" , 
"departure_time" : "06:04:11" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "06:10:15" , 
"departure_time" : "06:11:06" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "06:13:51" , 
"departure_time" : "06:15:13" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "06:20:22" , 
"departure_time" : "06:21:33" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "06:23:11" , 
"departure_time" : "06:24:35" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "06:29:24" , 
"departure_time" : "06:30:35" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "06:34:11" , 
"departure_time" : "06:34:37" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "06:41:26" , 
"departure_time" : "06:41:28" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "06:45:02" , 
"departure_time" : "06:46:33" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "06:53:31" , 
"departure_time" : "06:53:56" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "06:58:25" , 
"departure_time" : "06:58:41" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "07:02:16" , 
"departure_time" : "07:02:50" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "07:12:34" , 
"departure_time" : "07:12:34" , 
"distance_traveled" : 50.8055
} ], 
"3190" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:04:00" , 
"departure_time" : "18:05:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:14:55" , 
"departure_time" : "18:15:58" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:24:03" , 
"departure_time" : "18:25:15" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 158,
"arrival_time" : "18:44:12" , 
"departure_time" : "18:45:48" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 139,
"arrival_time" : "18:53:36" , 
"departure_time" : "18:54:55" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "19:03:19" , 
"departure_time" : "19:03:57" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "19:06:38" , 
"departure_time" : "19:07:06" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "19:13:28" , 
"departure_time" : "19:14:33" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "19:21:05" , 
"departure_time" : "19:21:10" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "19:24:05" , 
"departure_time" : "19:24:24" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "19:31:19" , 
"departure_time" : "19:31:41" , 
"distance_traveled" : 50.8055
}, 
{ 
"stop_id" : 40,
"arrival_time" : "19:36:22" , 
"departure_time" : "19:36:25" , 
"distance_traveled" : 53.0739
}, 
{ 
"stop_id" : 4,
"arrival_time" : "19:40:03" , 
"departure_time" : "19:40:52" , 
"distance_traveled" : 55.09
}, 
{ 
"stop_id" : 8,
"arrival_time" : "19:44:49" , 
"departure_time" : "19:46:01" , 
"distance_traveled" : 56.6843
}, 
{ 
"stop_id" : 22,
"arrival_time" : "19:47:12" , 
"departure_time" : "19:48:11" , 
"distance_traveled" : 57.5131
}, 
{ 
"stop_id" : 15,
"arrival_time" : "19:51:59" , 
"departure_time" : "19:52:59" , 
"distance_traveled" : 59.1699
}, 
{ 
"stop_id" : 141,
"arrival_time" : "19:56:00" , 
"departure_time" : "19:56:25" , 
"distance_traveled" : 61.2879
}, 
{ 
"stop_id" : 79,
"arrival_time" : "19:59:25" , 
"departure_time" : "19:59:42" , 
"distance_traveled" : 63.4625
}, 
{ 
"stop_id" : 122,
"arrival_time" : "20:05:17" , 
"departure_time" : "20:05:19" , 
"distance_traveled" : 65.4178
}, 
{ 
"stop_id" : 13,
"arrival_time" : "20:12:02" , 
"departure_time" : "20:12:02" , 
"distance_traveled" : 66.4981
} ], 
"3191" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "07:01:00" , 
"departure_time" : "07:02:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:11:19" , 
"departure_time" : "07:12:30" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:19:11" , 
"departure_time" : "07:20:13" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "07:25:02" , 
"departure_time" : "07:26:12" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "07:28:10" , 
"departure_time" : "07:28:51" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "07:30:41" , 
"departure_time" : "07:31:05" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "07:37:24" , 
"departure_time" : "07:37:46" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "07:41:22" , 
"departure_time" : "07:42:46" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "07:48:24" , 
"departure_time" : "07:50:00" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "07:51:36" , 
"departure_time" : "07:51:45" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "07:56:09" , 
"departure_time" : "07:57:36" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "08:02:27" , 
"departure_time" : "08:03:44" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "08:11:17" , 
"departure_time" : "08:11:35" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "08:14:18" , 
"departure_time" : "08:15:28" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "08:21:10" , 
"departure_time" : "08:21:30" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "08:26:20" , 
"departure_time" : "08:27:02" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "08:30:42" , 
"departure_time" : "08:31:15" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "08:40:33" , 
"departure_time" : "08:40:33" , 
"distance_traveled" : 50.8055
} ], 
"3192" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:30:00" , 
"departure_time" : "16:31:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:40:28" , 
"departure_time" : "16:40:52" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:51:24" , 
"departure_time" : "16:52:31" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 11,
"arrival_time" : "17:09:07" , 
"departure_time" : "17:09:44" , 
"distance_traveled" : 22.9869
}, 
{ 
"stop_id" : 158,
"arrival_time" : "17:11:37" , 
"departure_time" : "17:12:00" , 
"distance_traveled" : 24.4405
}, 
{ 
"stop_id" : 119,
"arrival_time" : "17:17:23" , 
"departure_time" : "17:18:03" , 
"distance_traveled" : 27.8587
}, 
{ 
"stop_id" : 139,
"arrival_time" : "17:22:40" , 
"departure_time" : "17:23:32" , 
"distance_traveled" : 29.7328
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "17:31:52" , 
"departure_time" : "17:32:30" , 
"distance_traveled" : 35.1169
}, 
{ 
"stop_id" : 59,
"arrival_time" : "17:35:38" , 
"departure_time" : "17:36:38" , 
"distance_traveled" : 36.9042
}, 
{ 
"stop_id" : 85,
"arrival_time" : "17:42:00" , 
"departure_time" : "17:42:03" , 
"distance_traveled" : 41.3212
}, 
{ 
"stop_id" : 130,
"arrival_time" : "17:47:03" , 
"departure_time" : "17:48:08" , 
"distance_traveled" : 44.9438
}, 
{ 
"stop_id" : 73,
"arrival_time" : "17:52:05" , 
"departure_time" : "17:52:51" , 
"distance_traveled" : 47.2911
}, 
{ 
"stop_id" : 74,
"arrival_time" : "17:58:46" , 
"departure_time" : "17:58:51" , 
"distance_traveled" : 50.8089
}, 
{ 
"stop_id" : 40,
"arrival_time" : "18:03:05" , 
"departure_time" : "18:03:32" , 
"distance_traveled" : 53.0773
}, 
{ 
"stop_id" : 4,
"arrival_time" : "18:07:27" , 
"departure_time" : "18:08:51" , 
"distance_traveled" : 55.0934
}, 
{ 
"stop_id" : 8,
"arrival_time" : "18:12:24" , 
"departure_time" : "18:13:08" , 
"distance_traveled" : 56.6877
}, 
{ 
"stop_id" : 22,
"arrival_time" : "18:14:44" , 
"departure_time" : "18:16:21" , 
"distance_traveled" : 57.5165
}, 
{ 
"stop_id" : 15,
"arrival_time" : "18:19:37" , 
"departure_time" : "18:19:55" , 
"distance_traveled" : 59.1733
}, 
{ 
"stop_id" : 141,
"arrival_time" : "18:22:18" , 
"departure_time" : "18:23:36" , 
"distance_traveled" : 61.2913
}, 
{ 
"stop_id" : 79,
"arrival_time" : "18:27:18" , 
"departure_time" : "18:28:02" , 
"distance_traveled" : 63.4659
}, 
{ 
"stop_id" : 122,
"arrival_time" : "18:31:44" , 
"departure_time" : "18:33:21" , 
"distance_traveled" : 65.4212
}, 
{ 
"stop_id" : 13,
"arrival_time" : "18:40:37" , 
"departure_time" : "18:40:37" , 
"distance_traveled" : 66.5015
} ], 
"3193" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "11:43:00" , 
"departure_time" : "11:46:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:54:25" , 
"departure_time" : "11:55:04" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:02:39" , 
"departure_time" : "12:03:10" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "12:08:31" , 
"departure_time" : "12:08:36" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "12:11:05" , 
"departure_time" : "12:12:22" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "12:15:17" , 
"departure_time" : "12:16:14" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "12:21:57" , 
"departure_time" : "12:22:46" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "12:25:49" , 
"departure_time" : "12:26:28" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "12:31:39" , 
"departure_time" : "12:32:47" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "12:35:08" , 
"departure_time" : "12:35:49" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "12:40:41" , 
"departure_time" : "12:42:05" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "12:46:24" , 
"departure_time" : "12:47:34" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "12:54:10" , 
"departure_time" : "12:54:57" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "12:57:47" , 
"departure_time" : "12:58:48" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "13:04:01" , 
"departure_time" : "13:05:10" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "13:10:09" , 
"departure_time" : "13:10:12" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "13:13:03" , 
"departure_time" : "13:13:10" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "13:23:07" , 
"departure_time" : "13:23:07" , 
"distance_traveled" : 50.8055
} ], 
"3194" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "06:47:00" , 
"departure_time" : "06:48:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:57:05" , 
"departure_time" : "06:57:43" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:04:38" , 
"departure_time" : "07:06:01" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "07:11:23" , 
"departure_time" : "07:11:36" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 158,
"arrival_time" : "07:24:13" , 
"departure_time" : "07:25:26" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 139,
"arrival_time" : "07:36:13" , 
"departure_time" : "07:36:13" , 
"distance_traveled" : 29.7294
} ], 
"3195" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:55:00" , 
"departure_time" : "17:57:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:06:19" , 
"departure_time" : "18:07:19" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:17:00" , 
"departure_time" : "18:17:27" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:23:27" , 
"departure_time" : "18:24:53" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "18:28:26" , 
"departure_time" : "18:28:52" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "18:30:26" , 
"departure_time" : "18:31:07" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "18:37:41" , 
"departure_time" : "18:39:19" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:43:38" , 
"departure_time" : "18:44:49" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "18:49:11" , 
"departure_time" : "18:50:10" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "18:52:59" , 
"departure_time" : "18:53:20" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "18:59:21" , 
"departure_time" : "19:00:36" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "19:04:15" , 
"departure_time" : "19:04:23" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "19:12:08" , 
"departure_time" : "19:12:36" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "19:16:28" , 
"departure_time" : "19:17:18" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "19:23:50" , 
"departure_time" : "19:24:31" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "19:29:41" , 
"departure_time" : "19:29:42" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "19:33:01" , 
"departure_time" : "19:33:18" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "19:41:17" , 
"departure_time" : "19:41:17" , 
"distance_traveled" : 50.8055
} ], 
"3196" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "05:47:00" , 
"departure_time" : "05:48:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:57:13" , 
"departure_time" : "05:58:39" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:05:26" , 
"departure_time" : "06:06:30" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "06:11:04" , 
"departure_time" : "06:12:05" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 158,
"arrival_time" : "06:28:01" , 
"departure_time" : "06:29:34" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "06:35:33" , 
"departure_time" : "06:36:35" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "06:40:02" , 
"departure_time" : "06:40:02" , 
"distance_traveled" : 29.7294
} ], 
"3197" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:41:00" , 
"departure_time" : "20:43:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:52:39" , 
"departure_time" : "20:53:36" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:00:57" , 
"departure_time" : "21:02:29" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "21:07:32" , 
"departure_time" : "21:08:19" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "21:10:47" , 
"departure_time" : "21:11:06" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "21:13:19" , 
"departure_time" : "21:14:14" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "21:19:55" , 
"departure_time" : "21:20:59" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "21:24:04" , 
"departure_time" : "21:24:25" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "21:29:21" , 
"departure_time" : "21:30:16" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "21:32:55" , 
"departure_time" : "21:33:50" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "21:38:55" , 
"departure_time" : "21:39:12" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "21:42:17" , 
"departure_time" : "21:43:29" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "21:51:12" , 
"departure_time" : "21:51:55" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "21:54:43" , 
"departure_time" : "21:56:08" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "22:01:25" , 
"departure_time" : "22:02:51" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "22:06:26" , 
"departure_time" : "22:07:48" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "22:10:22" , 
"departure_time" : "22:11:44" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "22:22:22" , 
"departure_time" : "22:22:22" , 
"distance_traveled" : 50.8055
} ], 
"3198" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "22:20:00" , 
"departure_time" : "22:21:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:30:27" , 
"departure_time" : "22:30:54" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:40:27" , 
"departure_time" : "22:41:56" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:47:29" , 
"departure_time" : "22:47:53" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "22:49:24" , 
"departure_time" : "22:49:35" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "22:52:11" , 
"departure_time" : "22:53:08" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "22:58:57" , 
"departure_time" : "23:00:11" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "23:03:14" , 
"departure_time" : "23:04:39" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "23:09:25" , 
"departure_time" : "23:10:12" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "23:12:47" , 
"departure_time" : "23:14:06" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "23:19:19" , 
"departure_time" : "23:20:19" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "23:23:00" , 
"departure_time" : "23:23:42" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "23:30:42" , 
"departure_time" : "23:31:38" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "23:34:56" , 
"departure_time" : "23:35:56" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "23:41:00" , 
"departure_time" : "23:41:15" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "23:46:15" , 
"departure_time" : "23:46:20" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "23:50:05" , 
"departure_time" : "23:50:47" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "24:05:42" , 
"departure_time" : "24:05:42" , 
"distance_traveled" : 50.8055
} ], 
"3199" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:01:00" , 
"departure_time" : "17:02:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:12:17" , 
"departure_time" : "17:13:17" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:22:00" , 
"departure_time" : "17:22:41" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 158,
"arrival_time" : "17:40:41" , 
"departure_time" : "17:41:08" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 139,
"arrival_time" : "17:49:27" , 
"departure_time" : "17:49:44" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "17:58:17" , 
"departure_time" : "17:59:27" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "18:03:10" , 
"departure_time" : "18:03:46" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "18:09:36" , 
"departure_time" : "18:11:11" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "18:16:35" , 
"departure_time" : "18:17:55" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "18:20:20" , 
"departure_time" : "18:21:55" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "18:27:35" , 
"departure_time" : "18:28:01" , 
"distance_traveled" : 50.8055
}, 
{ 
"stop_id" : 40,
"arrival_time" : "18:31:26" , 
"departure_time" : "18:32:04" , 
"distance_traveled" : 53.0739
}, 
{ 
"stop_id" : 4,
"arrival_time" : "18:35:38" , 
"departure_time" : "18:36:56" , 
"distance_traveled" : 55.09
}, 
{ 
"stop_id" : 8,
"arrival_time" : "18:40:18" , 
"departure_time" : "18:41:54" , 
"distance_traveled" : 56.6843
}, 
{ 
"stop_id" : 22,
"arrival_time" : "18:43:36" , 
"departure_time" : "18:44:58" , 
"distance_traveled" : 57.5131
}, 
{ 
"stop_id" : 15,
"arrival_time" : "18:47:22" , 
"departure_time" : "18:48:01" , 
"distance_traveled" : 59.1699
}, 
{ 
"stop_id" : 141,
"arrival_time" : "18:50:39" , 
"departure_time" : "18:51:00" , 
"distance_traveled" : 61.2879
}, 
{ 
"stop_id" : 79,
"arrival_time" : "18:54:21" , 
"departure_time" : "18:54:48" , 
"distance_traveled" : 63.4625
}, 
{ 
"stop_id" : 122,
"arrival_time" : "19:04:27" , 
"departure_time" : "19:06:06" , 
"distance_traveled" : 65.4178
}, 
{ 
"stop_id" : 13,
"arrival_time" : "19:08:39" , 
"departure_time" : "19:08:39" , 
"distance_traveled" : 66.4981
} ], 
"3200" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:30:00" , 
"departure_time" : "16:33:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:41:30" , 
"departure_time" : "16:41:39" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:51:09" , 
"departure_time" : "16:52:05" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 11,
"arrival_time" : "17:08:56" , 
"departure_time" : "17:09:09" , 
"distance_traveled" : 22.9869
}, 
{ 
"stop_id" : 158,
"arrival_time" : "17:11:13" , 
"departure_time" : "17:11:23" , 
"distance_traveled" : 24.4405
}, 
{ 
"stop_id" : 119,
"arrival_time" : "17:17:10" , 
"departure_time" : "17:17:30" , 
"distance_traveled" : 27.8587
}, 
{ 
"stop_id" : 139,
"arrival_time" : "17:22:20" , 
"departure_time" : "17:22:26" , 
"distance_traveled" : 29.7328
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "17:31:06" , 
"departure_time" : "17:32:36" , 
"distance_traveled" : 35.1169
}, 
{ 
"stop_id" : 59,
"arrival_time" : "17:36:30" , 
"departure_time" : "17:37:06" , 
"distance_traveled" : 36.9042
}, 
{ 
"stop_id" : 85,
"arrival_time" : "17:41:36" , 
"departure_time" : "17:42:01" , 
"distance_traveled" : 41.3212
}, 
{ 
"stop_id" : 130,
"arrival_time" : "17:47:25" , 
"departure_time" : "17:48:01" , 
"distance_traveled" : 44.9438
}, 
{ 
"stop_id" : 73,
"arrival_time" : "17:51:36" , 
"departure_time" : "17:53:09" , 
"distance_traveled" : 47.2911
}, 
{ 
"stop_id" : 74,
"arrival_time" : "17:59:33" , 
"departure_time" : "18:00:21" , 
"distance_traveled" : 50.8089
}, 
{ 
"stop_id" : 40,
"arrival_time" : "18:03:48" , 
"departure_time" : "18:04:17" , 
"distance_traveled" : 53.0773
}, 
{ 
"stop_id" : 4,
"arrival_time" : "18:07:29" , 
"departure_time" : "18:09:09" , 
"distance_traveled" : 55.0934
}, 
{ 
"stop_id" : 8,
"arrival_time" : "18:12:40" , 
"departure_time" : "18:12:49" , 
"distance_traveled" : 56.6877
}, 
{ 
"stop_id" : 22,
"arrival_time" : "18:14:09" , 
"departure_time" : "18:14:55" , 
"distance_traveled" : 57.5165
}, 
{ 
"stop_id" : 15,
"arrival_time" : "18:18:46" , 
"departure_time" : "18:19:11" , 
"distance_traveled" : 59.1733
}, 
{ 
"stop_id" : 141,
"arrival_time" : "18:22:25" , 
"departure_time" : "18:23:21" , 
"distance_traveled" : 61.2913
}, 
{ 
"stop_id" : 79,
"arrival_time" : "18:26:56" , 
"departure_time" : "18:27:53" , 
"distance_traveled" : 63.4659
}, 
{ 
"stop_id" : 122,
"arrival_time" : "18:31:57" , 
"departure_time" : "18:32:10" , 
"distance_traveled" : 65.4212
}, 
{ 
"stop_id" : 13,
"arrival_time" : "18:39:13" , 
"departure_time" : "18:39:13" , 
"distance_traveled" : 66.5015
} ], 
"3201" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "06:47:00" , 
"departure_time" : "06:48:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:57:22" , 
"departure_time" : "06:57:54" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:04:32" , 
"departure_time" : "07:05:26" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "07:10:54" , 
"departure_time" : "07:12:19" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 158,
"arrival_time" : "07:25:25" , 
"departure_time" : "07:26:56" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 139,
"arrival_time" : "07:36:31" , 
"departure_time" : "07:36:31" , 
"distance_traveled" : 29.7294
} ], 
"3202" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "05:47:00" , 
"departure_time" : "05:49:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:57:06" , 
"departure_time" : "05:57:43" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:04:37" , 
"departure_time" : "06:06:13" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "06:11:36" , 
"departure_time" : "06:12:34" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 158,
"arrival_time" : "06:27:58" , 
"departure_time" : "06:28:56" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "06:34:58" , 
"departure_time" : "06:35:39" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "06:39:41" , 
"departure_time" : "06:39:41" , 
"distance_traveled" : 29.7294
} ], 
"3203" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "05:03:00" , 
"departure_time" : "05:03:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "05:12:01" , 
"departure_time" : "05:13:38" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "05:22:37" , 
"departure_time" : "05:24:11" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "05:27:34" , 
"departure_time" : "05:28:10" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "05:30:36" , 
"departure_time" : "05:31:42" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "05:34:06" , 
"departure_time" : "05:35:32" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "05:39:26" , 
"departure_time" : "05:40:50" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "05:43:24" , 
"departure_time" : "05:43:40" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "05:48:16" , 
"departure_time" : "05:49:02" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "05:52:46" , 
"departure_time" : "05:54:11" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "05:59:25" , 
"departure_time" : "06:00:51" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "06:03:26" , 
"departure_time" : "06:03:36" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "06:11:10" , 
"departure_time" : "06:12:33" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "06:16:23" , 
"departure_time" : "06:17:08" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "06:20:45" , 
"departure_time" : "06:21:26" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "06:26:41" , 
"departure_time" : "06:28:08" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "06:31:27" , 
"departure_time" : "06:33:05" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "06:41:38" , 
"departure_time" : "06:41:38" , 
"distance_traveled" : 50.8055
} ], 
"3204" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "07:53:00" , 
"departure_time" : "07:56:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:03:40" , 
"departure_time" : "08:05:03" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:12:23" , 
"departure_time" : "08:12:45" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:17:22" , 
"departure_time" : "08:19:02" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "08:23:40" , 
"departure_time" : "08:24:19" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "08:29:39" , 
"departure_time" : "08:30:05" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:33:26" , 
"departure_time" : "08:34:53" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "08:39:27" , 
"departure_time" : "08:40:52" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "08:42:25" , 
"departure_time" : "08:42:30" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "08:47:05" , 
"departure_time" : "08:48:15" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "08:54:10" , 
"departure_time" : "08:54:34" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "09:01:24" , 
"departure_time" : "09:02:21" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "09:05:57" , 
"departure_time" : "09:07:03" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "09:12:06" , 
"departure_time" : "09:13:02" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "09:17:56" , 
"departure_time" : "09:18:25" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "09:21:29" , 
"departure_time" : "09:22:28" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "09:30:59" , 
"departure_time" : "09:30:59" , 
"distance_traveled" : 50.8055
} ], 
"3205" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "25:00:00" , 
"departure_time" : "25:02:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "25:10:28" , 
"departure_time" : "25:11:59" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "25:19:31" , 
"departure_time" : "25:20:28" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "25:24:57" , 
"departure_time" : "25:25:40" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "25:29:43" , 
"departure_time" : "25:30:34" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "25:36:51" , 
"departure_time" : "25:36:57" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "25:40:06" , 
"departure_time" : "25:41:18" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "25:46:12" , 
"departure_time" : "25:46:56" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "25:48:44" , 
"departure_time" : "25:49:35" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "25:54:51" , 
"departure_time" : "25:56:19" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "26:00:28" , 
"departure_time" : "26:00:41" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "26:08:13" , 
"departure_time" : "26:09:03" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "26:12:50" , 
"departure_time" : "26:13:46" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "26:18:56" , 
"departure_time" : "26:19:45" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "26:24:49" , 
"departure_time" : "26:25:23" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "26:28:34" , 
"departure_time" : "26:30:06" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "26:43:32" , 
"departure_time" : "26:43:32" , 
"distance_traveled" : 50.8055
} ], 
"3206" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "24:05:00" , 
"departure_time" : "24:06:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "24:14:27" , 
"departure_time" : "24:15:35" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "24:23:08" , 
"departure_time" : "24:24:18" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "24:29:10" , 
"departure_time" : "24:30:26" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "24:33:16" , 
"departure_time" : "24:34:56" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "24:36:40" , 
"departure_time" : "24:37:50" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "24:43:10" , 
"departure_time" : "24:44:11" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "24:47:01" , 
"departure_time" : "24:47:03" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "24:51:02" , 
"departure_time" : "24:51:55" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "24:54:53" , 
"departure_time" : "24:55:16" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "25:00:23" , 
"departure_time" : "25:01:21" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "25:05:58" , 
"departure_time" : "25:06:47" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "25:14:49" , 
"departure_time" : "25:15:07" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "25:18:18" , 
"departure_time" : "25:19:34" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "25:25:16" , 
"departure_time" : "25:26:31" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "25:31:15" , 
"departure_time" : "25:31:46" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "25:34:31" , 
"departure_time" : "25:35:00" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "25:48:29" , 
"departure_time" : "25:48:29" , 
"distance_traveled" : 50.8055
} ], 
"3207" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "07:53:00" , 
"departure_time" : "07:54:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:03:23" , 
"departure_time" : "08:04:04" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:11:41" , 
"departure_time" : "08:11:43" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:17:02" , 
"departure_time" : "08:17:15" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "08:22:13" , 
"departure_time" : "08:22:48" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "08:29:35" , 
"departure_time" : "08:29:41" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:33:06" , 
"departure_time" : "08:34:42" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "08:39:36" , 
"departure_time" : "08:41:05" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "08:42:29" , 
"departure_time" : "08:43:24" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "08:47:55" , 
"departure_time" : "08:49:05" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "08:54:10" , 
"departure_time" : "08:54:39" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "09:01:29" , 
"departure_time" : "09:01:48" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "09:05:19" , 
"departure_time" : "09:05:53" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "09:11:34" , 
"departure_time" : "09:12:13" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "09:17:39" , 
"departure_time" : "09:19:05" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "09:22:26" , 
"departure_time" : "09:23:27" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "09:31:01" , 
"departure_time" : "09:31:01" , 
"distance_traveled" : 50.8055
} ], 
"3208" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "12:07:00" , 
"departure_time" : "12:09:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:17:13" , 
"departure_time" : "12:18:52" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:26:39" , 
"departure_time" : "12:27:45" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "12:32:06" , 
"departure_time" : "12:32:50" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 127,
"arrival_time" : "12:42:44" , 
"departure_time" : "12:44:05" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 158,
"arrival_time" : "12:50:21" , 
"departure_time" : "12:51:05" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "12:55:44" , 
"departure_time" : "12:56:43" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "13:00:59" , 
"departure_time" : "13:01:35" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "13:09:36" , 
"departure_time" : "13:10:42" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "13:13:06" , 
"departure_time" : "13:14:03" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "13:18:57" , 
"departure_time" : "13:20:13" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "13:25:16" , 
"departure_time" : "13:26:25" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "13:29:09" , 
"departure_time" : "13:30:45" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "13:39:36" , 
"departure_time" : "13:39:36" , 
"distance_traveled" : 50.8055
} ], 
"3209" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:07:00" , 
"departure_time" : "20:09:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:17:09" , 
"departure_time" : "20:17:37" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:25:28" , 
"departure_time" : "20:26:52" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:32:24" , 
"departure_time" : "20:32:30" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:43:06" , 
"departure_time" : "20:44:32" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "20:50:26" , 
"departure_time" : "20:51:17" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "20:52:51" , 
"departure_time" : "20:54:27" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "20:59:36" , 
"departure_time" : "20:59:46" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "21:03:10" , 
"departure_time" : "21:03:56" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "21:12:46" , 
"departure_time" : "21:13:05" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "21:16:19" , 
"departure_time" : "21:16:51" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "21:21:32" , 
"departure_time" : "21:23:06" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "21:28:34" , 
"departure_time" : "21:28:53" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "21:31:19" , 
"departure_time" : "21:31:34" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "21:40:15" , 
"departure_time" : "21:40:15" , 
"distance_traveled" : 50.8055
} ], 
"3210" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "21:07:00" , 
"departure_time" : "21:08:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:17:23" , 
"departure_time" : "21:18:09" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:25:46" , 
"departure_time" : "21:25:52" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "21:31:06" , 
"departure_time" : "21:32:44" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "21:37:38" , 
"departure_time" : "21:38:51" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "21:44:13" , 
"departure_time" : "21:45:51" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "21:48:38" , 
"departure_time" : "21:50:14" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 158,
"arrival_time" : "21:55:36" , 
"departure_time" : "21:56:17" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "22:00:41" , 
"departure_time" : "22:02:08" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "22:06:27" , 
"departure_time" : "22:07:23" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "22:14:56" , 
"departure_time" : "22:15:49" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "22:18:53" , 
"departure_time" : "22:19:54" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "22:25:01" , 
"departure_time" : "22:25:04" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "22:30:03" , 
"departure_time" : "22:31:21" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "22:35:18" , 
"departure_time" : "22:36:17" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "22:42:59" , 
"departure_time" : "22:42:59" , 
"distance_traveled" : 50.8055
} ], 
"3211" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "23:07:00" , 
"departure_time" : "23:09:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "23:17:32" , 
"departure_time" : "23:18:25" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "23:25:53" , 
"departure_time" : "23:26:04" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "23:31:11" , 
"departure_time" : "23:32:06" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "23:36:55" , 
"departure_time" : "23:37:43" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "23:43:48" , 
"departure_time" : "23:44:18" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "23:47:30" , 
"departure_time" : "23:48:07" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 158,
"arrival_time" : "23:54:37" , 
"departure_time" : "23:54:56" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "24:00:19" , 
"departure_time" : "24:01:36" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "24:06:17" , 
"departure_time" : "24:06:33" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "24:14:16" , 
"departure_time" : "24:15:03" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "24:18:47" , 
"departure_time" : "24:20:13" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "24:25:26" , 
"departure_time" : "24:25:53" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "24:30:27" , 
"departure_time" : "24:31:03" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "24:34:36" , 
"departure_time" : "24:36:11" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "24:43:35" , 
"departure_time" : "24:43:35" , 
"distance_traveled" : 50.8055
} ], 
"3212" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "08:53:00" , 
"departure_time" : "08:55:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:02:26" , 
"departure_time" : "09:03:06" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:11:40" , 
"departure_time" : "09:12:59" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:18:19" , 
"departure_time" : "09:18:23" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "09:22:04" , 
"departure_time" : "09:23:30" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "09:30:26" , 
"departure_time" : "09:30:59" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "09:33:33" , 
"departure_time" : "09:34:17" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "09:38:44" , 
"departure_time" : "09:39:08" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "09:41:24" , 
"departure_time" : "09:42:58" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "09:48:34" , 
"departure_time" : "09:49:47" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "09:54:13" , 
"departure_time" : "09:55:06" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "10:01:53" , 
"departure_time" : "10:02:59" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "10:06:06" , 
"departure_time" : "10:06:35" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "10:11:29" , 
"departure_time" : "10:11:47" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "10:17:18" , 
"departure_time" : "10:17:41" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "10:21:23" , 
"departure_time" : "10:22:18" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "10:31:55" , 
"departure_time" : "10:31:55" , 
"distance_traveled" : 50.8055
} ], 
"3213" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "10:57:00" , 
"departure_time" : "10:59:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:07:22" , 
"departure_time" : "11:07:43" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:15:21" , 
"departure_time" : "11:15:37" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "11:21:16" , 
"departure_time" : "11:21:31" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "11:26:15" , 
"departure_time" : "11:26:43" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "11:33:28" , 
"departure_time" : "11:34:04" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "11:37:36" , 
"departure_time" : "11:38:13" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "11:42:37" , 
"departure_time" : "11:44:06" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "11:46:29" , 
"departure_time" : "11:47:42" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "11:52:13" , 
"departure_time" : "11:53:03" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "11:57:50" , 
"departure_time" : "11:59:18" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "12:06:28" , 
"departure_time" : "12:06:39" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "12:09:11" , 
"departure_time" : "12:09:22" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "12:15:11" , 
"departure_time" : "12:16:15" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "12:22:04" , 
"departure_time" : "12:22:33" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "12:25:29" , 
"departure_time" : "12:26:41" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "12:36:12" , 
"departure_time" : "12:36:12" , 
"distance_traveled" : 50.8055
} ], 
"3214" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "13:07:00" , 
"departure_time" : "13:09:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:16:52" , 
"departure_time" : "13:17:38" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:25:46" , 
"departure_time" : "13:26:51" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "13:32:05" , 
"departure_time" : "13:32:47" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "13:36:42" , 
"departure_time" : "13:36:50" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "13:43:08" , 
"departure_time" : "13:44:20" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "13:48:12" , 
"departure_time" : "13:49:52" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "13:54:40" , 
"departure_time" : "13:54:43" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "13:56:03" , 
"departure_time" : "13:56:19" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "14:02:16" , 
"departure_time" : "14:02:18" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "14:07:02" , 
"departure_time" : "14:07:04" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "14:16:02" , 
"departure_time" : "14:16:10" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "14:20:08" , 
"departure_time" : "14:20:47" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "14:26:39" , 
"departure_time" : "14:28:09" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "14:33:30" , 
"departure_time" : "14:34:11" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "14:36:41" , 
"departure_time" : "14:36:52" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "14:46:11" , 
"departure_time" : "14:46:11" , 
"distance_traveled" : 50.8055
} ], 
"3215" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "14:07:00" , 
"departure_time" : "14:08:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:17:01" , 
"departure_time" : "14:17:30" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:25:29" , 
"departure_time" : "14:25:40" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "14:31:11" , 
"departure_time" : "14:32:29" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "14:37:18" , 
"departure_time" : "14:37:40" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "14:43:22" , 
"departure_time" : "14:44:28" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "14:48:06" , 
"departure_time" : "14:48:21" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "14:53:15" , 
"departure_time" : "14:54:03" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "14:56:48" , 
"departure_time" : "14:57:45" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "15:02:57" , 
"departure_time" : "15:04:35" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "15:08:38" , 
"departure_time" : "15:09:38" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "15:17:00" , 
"departure_time" : "15:17:23" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "15:20:23" , 
"departure_time" : "15:22:00" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "15:27:37" , 
"departure_time" : "15:28:53" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "15:33:16" , 
"departure_time" : "15:34:07" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "15:36:51" , 
"departure_time" : "15:37:57" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "15:47:06" , 
"departure_time" : "15:47:06" , 
"distance_traveled" : 50.8055
} ], 
"3216" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:07:00" , 
"departure_time" : "15:09:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "15:17:37" , 
"departure_time" : "15:19:09" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:26:32" , 
"departure_time" : "15:26:56" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "15:31:24" , 
"departure_time" : "15:32:19" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "15:36:55" , 
"departure_time" : "15:38:19" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "15:44:24" , 
"departure_time" : "15:45:18" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "15:47:54" , 
"departure_time" : "15:49:17" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "15:54:23" , 
"departure_time" : "15:54:31" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "15:56:08" , 
"departure_time" : "15:56:41" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "16:02:33" , 
"departure_time" : "16:03:27" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "16:07:54" , 
"departure_time" : "16:08:19" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "16:16:25" , 
"departure_time" : "16:16:44" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "16:20:19" , 
"departure_time" : "16:21:47" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "16:27:28" , 
"departure_time" : "16:28:29" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "16:33:01" , 
"departure_time" : "16:34:04" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "16:37:03" , 
"departure_time" : "16:38:26" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "16:47:23" , 
"departure_time" : "16:47:23" , 
"distance_traveled" : 50.8055
} ], 
"3217" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:07:00" , 
"departure_time" : "16:08:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:16:22" , 
"departure_time" : "16:16:43" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:25:21" , 
"departure_time" : "16:26:51" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:32:30" , 
"departure_time" : "16:32:54" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "16:36:24" , 
"departure_time" : "16:36:47" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "16:43:23" , 
"departure_time" : "16:44:11" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "16:47:48" , 
"departure_time" : "16:48:08" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "16:53:20" , 
"departure_time" : "16:54:01" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "16:56:41" , 
"departure_time" : "16:56:58" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "17:02:17" , 
"departure_time" : "17:03:35" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "17:08:18" , 
"departure_time" : "17:08:23" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "17:16:05" , 
"departure_time" : "17:17:17" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "17:21:12" , 
"departure_time" : "17:22:39" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "17:27:27" , 
"departure_time" : "17:28:40" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "17:33:13" , 
"departure_time" : "17:33:56" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "17:36:43" , 
"departure_time" : "17:38:21" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "17:47:38" , 
"departure_time" : "17:47:38" , 
"distance_traveled" : 50.8055
} ], 
"3218" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:07:00" , 
"departure_time" : "17:08:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "17:16:18" , 
"departure_time" : "17:17:00" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:25:42" , 
"departure_time" : "17:26:53" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:32:11" , 
"departure_time" : "17:32:36" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "17:36:25" , 
"departure_time" : "17:36:26" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "17:43:01" , 
"departure_time" : "17:43:30" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "17:47:29" , 
"departure_time" : "17:48:36" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "17:54:07" , 
"departure_time" : "17:54:25" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "17:56:18" , 
"departure_time" : "17:57:54" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "18:04:36" , 
"departure_time" : "18:05:57" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "18:08:21" , 
"departure_time" : "18:09:39" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "18:17:18" , 
"departure_time" : "18:17:40" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "18:20:22" , 
"departure_time" : "18:21:53" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "18:27:31" , 
"departure_time" : "18:27:34" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "18:32:03" , 
"departure_time" : "18:33:31" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "18:37:28" , 
"departure_time" : "18:38:35" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "18:47:07" , 
"departure_time" : "18:47:07" , 
"distance_traveled" : 50.8055
} ], 
"3219" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:07:00" , 
"departure_time" : "18:09:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "18:17:26" , 
"departure_time" : "18:18:37" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:26:11" , 
"departure_time" : "18:26:59" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:31:48" , 
"departure_time" : "18:32:11" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "18:36:23" , 
"departure_time" : "18:38:01" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "18:44:38" , 
"departure_time" : "18:45:10" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:47:32" , 
"departure_time" : "18:48:16" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "18:53:44" , 
"departure_time" : "18:53:48" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "18:56:04" , 
"departure_time" : "18:57:15" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "19:03:11" , 
"departure_time" : "19:03:47" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "19:07:36" , 
"departure_time" : "19:08:33" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "19:16:57" , 
"departure_time" : "19:17:53" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "19:20:56" , 
"departure_time" : "19:21:38" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "19:26:42" , 
"departure_time" : "19:26:59" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "19:32:17" , 
"departure_time" : "19:33:04" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "19:36:47" , 
"departure_time" : "19:36:50" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "19:46:03" , 
"departure_time" : "19:46:03" , 
"distance_traveled" : 50.8055
} ], 
"3220" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "22:07:00" , 
"departure_time" : "22:08:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:17:37" , 
"departure_time" : "22:18:24" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:25:47" , 
"departure_time" : "22:26:04" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "22:31:17" , 
"departure_time" : "22:32:28" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 41,
"arrival_time" : "22:37:11" , 
"departure_time" : "22:38:27" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "22:44:16" , 
"departure_time" : "22:44:33" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "22:47:17" , 
"departure_time" : "22:47:25" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "22:53:08" , 
"departure_time" : "22:54:47" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "22:57:39" , 
"departure_time" : "22:59:05" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "23:03:26" , 
"departure_time" : "23:04:37" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "23:08:11" , 
"departure_time" : "23:09:39" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "23:17:28" , 
"departure_time" : "23:18:54" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "23:21:26" , 
"departure_time" : "23:21:49" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "23:26:23" , 
"departure_time" : "23:27:05" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "23:32:42" , 
"departure_time" : "23:34:10" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "23:37:28" , 
"departure_time" : "23:38:46" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "23:45:18" , 
"departure_time" : "23:45:18" , 
"distance_traveled" : 50.8055
} ], 
"3221" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "06:53:00" , 
"departure_time" : "06:55:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "07:03:11" , 
"departure_time" : "07:03:45" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:11:34" , 
"departure_time" : "07:12:59" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "07:18:25" , 
"departure_time" : "07:18:42" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "07:20:17" , 
"departure_time" : "07:20:29" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "07:23:12" , 
"departure_time" : "07:23:35" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "07:30:23" , 
"departure_time" : "07:31:31" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "07:35:08" , 
"departure_time" : "07:36:43" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 158,
"arrival_time" : "07:42:35" , 
"departure_time" : "07:42:49" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "07:47:14" , 
"departure_time" : "07:47:42" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "07:52:28" , 
"departure_time" : "07:54:01" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "08:02:33" , 
"departure_time" : "08:04:02" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "08:06:29" , 
"departure_time" : "08:07:26" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "08:11:57" , 
"departure_time" : "08:13:12" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "08:18:15" , 
"departure_time" : "08:19:39" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "08:22:24" , 
"departure_time" : "08:22:58" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "08:30:34" , 
"departure_time" : "08:30:34" , 
"distance_traveled" : 50.8055
} ], 
"3222" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "05:53:00" , 
"departure_time" : "05:54:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "06:03:00" , 
"departure_time" : "06:03:30" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:11:30" , 
"departure_time" : "06:11:35" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "06:17:05" , 
"departure_time" : "06:18:18" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "06:21:13" , 
"departure_time" : "06:22:40" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "06:24:27" , 
"departure_time" : "06:25:29" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "06:31:02" , 
"departure_time" : "06:31:54" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "06:34:52" , 
"departure_time" : "06:36:16" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "06:41:24" , 
"departure_time" : "06:42:09" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "06:43:45" , 
"departure_time" : "06:44:17" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "06:49:32" , 
"departure_time" : "06:49:57" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "06:54:25" , 
"departure_time" : "06:54:46" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "07:03:21" , 
"departure_time" : "07:04:22" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "07:08:01" , 
"departure_time" : "07:09:08" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "07:14:07" , 
"departure_time" : "07:15:43" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "07:20:36" , 
"departure_time" : "07:22:11" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "07:24:35" , 
"departure_time" : "07:26:11" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "07:33:36" , 
"departure_time" : "07:33:36" , 
"distance_traveled" : 50.8055
} ], 
"3223" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "09:55:00" , 
"departure_time" : "09:58:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:05:39" , 
"departure_time" : "10:06:29" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:13:50" , 
"departure_time" : "10:14:47" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "10:19:57" , 
"departure_time" : "10:21:11" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "10:23:14" , 
"departure_time" : "10:24:35" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "10:26:21" , 
"departure_time" : "10:27:29" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "10:33:08" , 
"departure_time" : "10:34:36" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "10:37:28" , 
"departure_time" : "10:38:24" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "10:42:56" , 
"departure_time" : "10:44:16" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "10:46:20" , 
"departure_time" : "10:47:22" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "10:52:02" , 
"departure_time" : "10:53:22" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "10:57:20" , 
"departure_time" : "10:57:23" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "11:05:03" , 
"departure_time" : "11:06:04" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "11:10:01" , 
"departure_time" : "11:10:40" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "11:15:39" , 
"departure_time" : "11:16:41" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "11:22:02" , 
"departure_time" : "11:22:14" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "11:25:12" , 
"departure_time" : "11:25:32" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "11:35:20" , 
"departure_time" : "11:35:20" , 
"distance_traveled" : 50.8055
} ], 
"3224" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:07:00" , 
"departure_time" : "19:07:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "19:16:38" , 
"departure_time" : "19:17:53" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:26:15" , 
"departure_time" : "19:27:22" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "19:32:07" , 
"departure_time" : "19:33:41" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "19:36:34" , 
"departure_time" : "19:36:51" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "19:38:17" , 
"departure_time" : "19:39:16" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "19:44:59" , 
"departure_time" : "19:45:58" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "19:48:59" , 
"departure_time" : "19:49:39" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "19:55:40" , 
"departure_time" : "19:56:08" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "19:58:28" , 
"departure_time" : "19:59:20" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "20:04:52" , 
"departure_time" : "20:05:09" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "20:09:17" , 
"departure_time" : "20:10:29" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "20:19:12" , 
"departure_time" : "20:19:43" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "20:22:31" , 
"departure_time" : "20:23:21" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "20:27:50" , 
"departure_time" : "20:28:15" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "20:33:25" , 
"departure_time" : "20:34:59" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "20:38:34" , 
"departure_time" : "20:39:22" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "20:47:48" , 
"departure_time" : "20:47:48" , 
"distance_traveled" : 50.8055
} ], 
"3225" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "17:01:00" , 
"departure_time" : "17:03:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:18:13" , 
"departure_time" : "17:18:25" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "17:23:12" , 
"departure_time" : "17:24:23" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "17:28:11" , 
"departure_time" : "17:28:56" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "17:30:45" , 
"departure_time" : "17:31:56" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "17:37:11" , 
"departure_time" : "17:38:09" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "17:39:58" , 
"departure_time" : "17:39:58" , 
"distance_traveled" : 20.7032
} ], 
"3226" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "18:01:00" , 
"departure_time" : "18:02:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:17:21" , 
"departure_time" : "18:17:27" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "18:23:06" , 
"departure_time" : "18:23:45" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "18:26:39" , 
"departure_time" : "18:26:42" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "18:29:03" , 
"departure_time" : "18:29:34" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "18:36:31" , 
"departure_time" : "18:36:51" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "18:39:20" , 
"departure_time" : "18:39:20" , 
"distance_traveled" : 20.7032
} ], 
"3227" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "19:51:00" , 
"departure_time" : "19:52:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:06:43" , 
"departure_time" : "20:07:20" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "20:12:37" , 
"departure_time" : "20:12:49" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "20:16:12" , 
"departure_time" : "20:17:51" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "20:20:39" , 
"departure_time" : "20:21:06" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "20:26:27" , 
"departure_time" : "20:28:07" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "20:30:40" , 
"departure_time" : "20:30:40" , 
"distance_traveled" : 20.7032
} ], 
"3228" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "08:07:00" , 
"departure_time" : "08:10:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:17:30" , 
"departure_time" : "08:18:28" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:26:58" , 
"departure_time" : "08:28:13" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "08:33:15" , 
"departure_time" : "08:33:54" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "08:35:39" , 
"departure_time" : "08:36:36" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "08:38:57" , 
"departure_time" : "08:40:23" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "08:46:26" , 
"departure_time" : "08:47:50" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "08:49:24" , 
"departure_time" : "08:49:24" , 
"distance_traveled" : 20.7032
} ], 
"3229" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "09:07:00" , 
"departure_time" : "09:09:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:16:56" , 
"departure_time" : "09:17:42" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:25:46" , 
"departure_time" : "09:27:01" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "09:32:15" , 
"departure_time" : "09:33:40" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "09:35:25" , 
"departure_time" : "09:35:53" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "09:37:28" , 
"departure_time" : "09:37:36" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "09:44:08" , 
"departure_time" : "09:45:36" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "09:48:28" , 
"departure_time" : "09:48:28" , 
"distance_traveled" : 20.7032
} ], 
"3230" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "11:07:00" , 
"departure_time" : "11:08:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:16:03" , 
"departure_time" : "11:16:30" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:25:27" , 
"departure_time" : "11:27:06" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "11:32:39" , 
"departure_time" : "11:34:11" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "11:35:32" , 
"departure_time" : "11:36:09" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "11:37:37" , 
"departure_time" : "11:38:39" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "11:45:02" , 
"departure_time" : "11:45:23" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "11:47:21" , 
"departure_time" : "11:47:21" , 
"distance_traveled" : 20.7032
} ], 
"3231" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "15:56:00" , 
"departure_time" : "15:57:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:06:57" , 
"departure_time" : "16:07:14" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:14:17" , 
"departure_time" : "16:14:28" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 37953,
"arrival_time" : "16:20:11" , 
"departure_time" : "16:20:21" , 
"distance_traveled" : 12.5354
}, 
{ 
"stop_id" : 109,
"arrival_time" : "16:24:10" , 
"departure_time" : "16:24:37" , 
"distance_traveled" : 14.3854
}, 
{ 
"stop_id" : 41,
"arrival_time" : "16:27:27" , 
"departure_time" : "16:28:51" , 
"distance_traveled" : 15.361
}, 
{ 
"stop_id" : 70,
"arrival_time" : "16:35:24" , 
"departure_time" : "16:35:37" , 
"distance_traveled" : 18.6447
}, 
{ 
"stop_id" : 127,
"arrival_time" : "16:38:13" , 
"departure_time" : "16:38:13" , 
"distance_traveled" : 20.7032
} ], 
"3232" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "06:05:00" , 
"departure_time" : "06:06:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "06:10:37" , 
"departure_time" : "06:11:13" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "06:14:36" , 
"departure_time" : "06:14:41" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "06:18:05" , 
"departure_time" : "06:19:05" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "06:23:00" , 
"departure_time" : "06:23:20" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "06:26:20" , 
"departure_time" : "06:26:39" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "06:30:19" , 
"departure_time" : "06:31:44" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "06:35:25" , 
"departure_time" : "06:36:28" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "06:39:03" , 
"departure_time" : "06:40:15" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "06:45:12" , 
"departure_time" : "06:45:36" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 73,
"arrival_time" : "06:50:24" , 
"departure_time" : "06:50:58" , 
"distance_traveled" : 19.2108
}, 
{ 
"stop_id" : 130,
"arrival_time" : "06:54:34" , 
"departure_time" : "06:55:11" , 
"distance_traveled" : 21.5562
}, 
{ 
"stop_id" : 85,
"arrival_time" : "07:00:37" , 
"departure_time" : "07:01:11" , 
"distance_traveled" : 25.1807
}, 
{ 
"stop_id" : 59,
"arrival_time" : "07:06:34" , 
"departure_time" : "07:07:20" , 
"distance_traveled" : 29.5975
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "07:10:46" , 
"departure_time" : "07:11:07" , 
"distance_traveled" : 31.3854
}, 
{ 
"stop_id" : 139,
"arrival_time" : "07:19:21" , 
"departure_time" : "07:20:15" , 
"distance_traveled" : 36.7695
}, 
{ 
"stop_id" : 119,
"arrival_time" : "07:24:54" , 
"departure_time" : "07:25:08" , 
"distance_traveled" : 38.6436
}, 
{ 
"stop_id" : 158,
"arrival_time" : "07:30:14" , 
"departure_time" : "07:30:33" , 
"distance_traveled" : 42.0614
}, 
{ 
"stop_id" : 127,
"arrival_time" : "07:37:19" , 
"departure_time" : "07:37:49" , 
"distance_traveled" : 45.7956
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:52:30" , 
"departure_time" : "07:52:53" , 
"distance_traveled" : 56.4417
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:01:23" , 
"departure_time" : "08:02:54" , 
"distance_traveled" : 61.5104
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:15:31" , 
"departure_time" : "08:15:31" , 
"distance_traveled" : 66.4985
} ], 
"3233" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "05:18:00" , 
"departure_time" : "05:20:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "05:22:57" , 
"departure_time" : "05:23:26" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "05:27:29" , 
"departure_time" : "05:28:44" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "05:32:15" , 
"departure_time" : "05:33:37" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "05:36:22" , 
"departure_time" : "05:36:55" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "05:39:33" , 
"departure_time" : "05:40:51" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "05:43:18" , 
"departure_time" : "05:44:16" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "05:46:58" , 
"departure_time" : "05:47:56" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "05:50:58" , 
"departure_time" : "05:51:25" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "05:57:27" , 
"departure_time" : "05:57:27" , 
"distance_traveled" : 15.693
} ], 
"3234" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "06:05:00" , 
"departure_time" : "06:05:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "06:09:12" , 
"departure_time" : "06:09:46" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "06:14:34" , 
"departure_time" : "06:15:07" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "06:18:33" , 
"departure_time" : "06:19:03" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "06:22:30" , 
"departure_time" : "06:23:47" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "06:27:17" , 
"departure_time" : "06:28:53" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "06:31:36" , 
"departure_time" : "06:31:47" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "06:34:11" , 
"departure_time" : "06:34:51" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "06:38:40" , 
"departure_time" : "06:39:59" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "06:45:19" , 
"departure_time" : "06:46:41" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 73,
"arrival_time" : "06:51:22" , 
"departure_time" : "06:52:33" , 
"distance_traveled" : 19.2108
}, 
{ 
"stop_id" : 130,
"arrival_time" : "06:55:11" , 
"departure_time" : "06:55:58" , 
"distance_traveled" : 21.5562
}, 
{ 
"stop_id" : 85,
"arrival_time" : "07:00:47" , 
"departure_time" : "07:01:29" , 
"distance_traveled" : 25.1807
}, 
{ 
"stop_id" : 59,
"arrival_time" : "07:06:42" , 
"departure_time" : "07:07:57" , 
"distance_traveled" : 29.5975
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "07:11:15" , 
"departure_time" : "07:12:05" , 
"distance_traveled" : 31.3854
}, 
{ 
"stop_id" : 139,
"arrival_time" : "07:19:50" , 
"departure_time" : "07:20:53" , 
"distance_traveled" : 36.7695
}, 
{ 
"stop_id" : 119,
"arrival_time" : "07:25:03" , 
"departure_time" : "07:26:26" , 
"distance_traveled" : 38.6436
}, 
{ 
"stop_id" : 158,
"arrival_time" : "07:31:23" , 
"departure_time" : "07:31:30" , 
"distance_traveled" : 42.0614
}, 
{ 
"stop_id" : 127,
"arrival_time" : "07:37:07" , 
"departure_time" : "07:38:45" , 
"distance_traveled" : 45.7956
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:53:38" , 
"departure_time" : "07:54:04" , 
"distance_traveled" : 56.4417
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:01:26" , 
"departure_time" : "08:02:02" , 
"distance_traveled" : 61.5104
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:14:36" , 
"departure_time" : "08:14:36" , 
"distance_traveled" : 66.4985
} ], 
"3235" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "07:18:00" , 
"departure_time" : "07:20:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "07:23:39" , 
"departure_time" : "07:23:59" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "07:27:20" , 
"departure_time" : "07:28:28" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "07:32:08" , 
"departure_time" : "07:33:25" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "07:36:17" , 
"departure_time" : "07:37:37" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "07:40:20" , 
"departure_time" : "07:41:52" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "07:43:32" , 
"departure_time" : "07:44:51" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "07:47:19" , 
"departure_time" : "07:48:59" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "07:51:40" , 
"departure_time" : "07:52:17" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "07:57:37" , 
"departure_time" : "07:57:37" , 
"distance_traveled" : 15.693
} ], 
"3236" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "05:18:00" , 
"departure_time" : "05:19:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "05:22:47" , 
"departure_time" : "05:24:23" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "05:28:36" , 
"departure_time" : "05:29:27" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "05:31:51" , 
"departure_time" : "05:32:13" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "05:35:22" , 
"departure_time" : "05:36:40" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "05:40:18" , 
"departure_time" : "05:40:25" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "05:42:07" , 
"departure_time" : "05:43:39" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "05:47:32" , 
"departure_time" : "05:47:34" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "05:50:02" , 
"departure_time" : "05:50:55" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "05:57:53" , 
"departure_time" : "05:57:53" , 
"distance_traveled" : 15.693
} ], 
"3237" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "09:20:00" , 
"departure_time" : "09:21:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "09:24:10" , 
"departure_time" : "09:24:30" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "09:29:20" , 
"departure_time" : "09:29:23" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "09:33:03" , 
"departure_time" : "09:34:41" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "09:38:38" , 
"departure_time" : "09:40:02" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "09:42:24" , 
"departure_time" : "09:42:36" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "09:44:12" , 
"departure_time" : "09:44:18" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "09:48:06" , 
"departure_time" : "09:48:59" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "09:52:53" , 
"departure_time" : "09:53:31" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "09:59:38" , 
"departure_time" : "09:59:38" , 
"distance_traveled" : 15.693
} ], 
"3238" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "07:18:00" , 
"departure_time" : "07:19:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "07:23:08" , 
"departure_time" : "07:23:27" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "07:27:19" , 
"departure_time" : "07:27:52" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "07:31:33" , 
"departure_time" : "07:33:09" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "07:36:36" , 
"departure_time" : "07:37:50" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "07:40:14" , 
"departure_time" : "07:41:36" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "07:43:22" , 
"departure_time" : "07:43:57" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "07:46:35" , 
"departure_time" : "07:47:29" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "07:50:54" , 
"departure_time" : "07:52:28" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "07:58:34" , 
"departure_time" : "07:58:34" , 
"distance_traveled" : 15.693
} ], 
"3239" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "11:22:00" , 
"departure_time" : "11:25:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "11:27:37" , 
"departure_time" : "11:27:59" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "11:31:22" , 
"departure_time" : "11:31:55" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "11:35:33" , 
"departure_time" : "11:36:44" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "11:40:11" , 
"departure_time" : "11:40:32" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "11:43:21" , 
"departure_time" : "11:44:46" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "11:47:25" , 
"departure_time" : "11:48:06" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "11:50:41" , 
"departure_time" : "11:51:16" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "11:54:35" , 
"departure_time" : "11:55:42" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "12:02:07" , 
"departure_time" : "12:02:07" , 
"distance_traveled" : 15.693
} ], 
"3240" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "09:20:00" , 
"departure_time" : "09:21:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "09:24:11" , 
"departure_time" : "09:25:06" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "09:29:55" , 
"departure_time" : "09:31:10" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "09:34:15" , 
"departure_time" : "09:35:40" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "09:38:25" , 
"departure_time" : "09:38:40" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "09:41:15" , 
"departure_time" : "09:41:25" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "09:44:10" , 
"departure_time" : "09:44:19" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "09:48:09" , 
"departure_time" : "09:49:39" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "09:53:30" , 
"departure_time" : "09:54:22" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "09:59:52" , 
"departure_time" : "09:59:52" , 
"distance_traveled" : 15.693
} ], 
"3241" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "13:20:00" , 
"departure_time" : "13:21:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "13:24:53" , 
"departure_time" : "13:26:15" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "13:30:22" , 
"departure_time" : "13:30:44" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "13:33:22" , 
"departure_time" : "13:33:25" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "13:37:03" , 
"departure_time" : "13:38:40" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "13:42:37" , 
"departure_time" : "13:43:00" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "13:44:23" , 
"departure_time" : "13:45:29" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "13:49:06" , 
"departure_time" : "13:49:44" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "13:52:38" , 
"departure_time" : "13:53:41" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "14:00:03" , 
"departure_time" : "14:00:03" , 
"distance_traveled" : 15.693
} ], 
"3242" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "11:22:00" , 
"departure_time" : "11:24:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "11:27:12" , 
"departure_time" : "11:27:51" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "11:31:39" , 
"departure_time" : "11:33:10" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "11:36:31" , 
"departure_time" : "11:37:59" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "11:40:28" , 
"departure_time" : "11:42:02" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "11:44:34" , 
"departure_time" : "11:44:59" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "11:46:25" , 
"departure_time" : "11:46:59" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "11:50:34" , 
"departure_time" : "11:51:04" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "11:54:30" , 
"departure_time" : "11:54:59" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "12:01:29" , 
"departure_time" : "12:01:29" , 
"distance_traveled" : 15.693
} ], 
"3243" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "15:17:00" , 
"departure_time" : "15:18:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "15:21:50" , 
"departure_time" : "15:23:22" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "15:27:32" , 
"departure_time" : "15:28:44" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "15:31:12" , 
"departure_time" : "15:32:20" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "15:35:08" , 
"departure_time" : "15:35:14" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "15:38:06" , 
"departure_time" : "15:39:18" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "15:42:12" , 
"departure_time" : "15:43:46" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "15:46:34" , 
"departure_time" : "15:47:39" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "15:50:05" , 
"departure_time" : "15:50:07" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "15:56:02" , 
"departure_time" : "15:56:02" , 
"distance_traveled" : 15.693
} ], 
"3244" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "13:20:00" , 
"departure_time" : "13:21:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "13:25:39" , 
"departure_time" : "13:25:47" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "13:29:08" , 
"departure_time" : "13:30:45" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "13:34:37" , 
"departure_time" : "13:36:08" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "13:38:31" , 
"departure_time" : "13:39:28" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "13:41:57" , 
"departure_time" : "13:43:26" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "13:45:29" , 
"departure_time" : "13:46:05" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "13:48:36" , 
"departure_time" : "13:49:54" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "13:53:18" , 
"departure_time" : "13:54:57" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "14:00:39" , 
"departure_time" : "14:00:39" , 
"distance_traveled" : 15.693
} ], 
"3245" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "17:19:00" , 
"departure_time" : "17:21:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "17:23:35" , 
"departure_time" : "17:24:56" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "17:29:21" , 
"departure_time" : "17:30:52" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "17:33:31" , 
"departure_time" : "17:33:45" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "17:36:14" , 
"departure_time" : "17:37:48" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "17:41:34" , 
"departure_time" : "17:41:54" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "17:43:20" , 
"departure_time" : "17:43:44" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "17:47:24" , 
"departure_time" : "17:48:10" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "17:51:46" , 
"departure_time" : "17:52:26" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "17:58:40" , 
"departure_time" : "17:58:40" , 
"distance_traveled" : 15.693
} ], 
"3246" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "15:17:00" , 
"departure_time" : "15:18:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "15:22:04" , 
"departure_time" : "15:23:24" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "15:27:20" , 
"departure_time" : "15:28:27" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "15:31:07" , 
"departure_time" : "15:31:47" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "15:34:40" , 
"departure_time" : "15:36:01" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "15:39:21" , 
"departure_time" : "15:40:17" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "15:41:56" , 
"departure_time" : "15:42:27" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "15:45:31" , 
"departure_time" : "15:46:51" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "15:50:20" , 
"departure_time" : "15:50:24" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "15:56:04" , 
"departure_time" : "15:56:04" , 
"distance_traveled" : 15.693
} ], 
"3247" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "18:30:00" , 
"departure_time" : "18:31:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "18:34:58" , 
"departure_time" : "18:35:37" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "18:39:39" , 
"departure_time" : "18:40:46" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "18:44:07" , 
"departure_time" : "18:44:29" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "18:47:22" , 
"departure_time" : "18:48:42" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "18:52:20" , 
"departure_time" : "18:53:45" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "18:55:25" , 
"departure_time" : "18:57:02" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "18:59:37" , 
"departure_time" : "18:59:44" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "19:02:07" , 
"departure_time" : "19:03:04" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "19:09:57" , 
"departure_time" : "19:09:57" , 
"distance_traveled" : 15.693
} ], 
"3248" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "17:19:00" , 
"departure_time" : "17:21:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "17:24:36" , 
"departure_time" : "17:25:22" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "17:28:46" , 
"departure_time" : "17:30:08" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "17:33:22" , 
"departure_time" : "17:34:15" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "17:36:53" , 
"departure_time" : "17:36:58" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "17:40:05" , 
"departure_time" : "17:40:58" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "17:43:53" , 
"departure_time" : "17:44:00" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "17:47:07" , 
"departure_time" : "17:47:20" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "17:51:13" , 
"departure_time" : "17:52:42" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "17:59:29" , 
"departure_time" : "17:59:29" , 
"distance_traveled" : 15.693
} ], 
"3249" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "20:30:00" , 
"departure_time" : "20:32:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "20:35:06" , 
"departure_time" : "20:35:15" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "20:39:09" , 
"departure_time" : "20:39:14" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "20:43:05" , 
"departure_time" : "20:43:18" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "20:47:13" , 
"departure_time" : "20:47:33" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "20:51:20" , 
"departure_time" : "20:51:56" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "20:54:36" , 
"departure_time" : "20:55:55" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "20:59:19" , 
"departure_time" : "21:00:11" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "21:02:52" , 
"departure_time" : "21:04:10" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "21:10:18" , 
"departure_time" : "21:10:18" , 
"distance_traveled" : 15.693
} ], 
"3250" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "18:30:00" , 
"departure_time" : "18:32:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "18:35:28" , 
"departure_time" : "18:37:03" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "18:40:35" , 
"departure_time" : "18:40:57" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "18:43:22" , 
"departure_time" : "18:44:49" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "18:48:27" , 
"departure_time" : "18:49:47" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "18:52:20" , 
"departure_time" : "18:53:35" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "18:55:15" , 
"departure_time" : "18:55:53" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "18:58:38" , 
"departure_time" : "18:59:28" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "19:02:50" , 
"departure_time" : "19:03:34" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "19:09:44" , 
"departure_time" : "19:09:44" , 
"distance_traveled" : 15.693
} ], 
"3251" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "21:20:00" , 
"departure_time" : "21:22:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "21:25:27" , 
"departure_time" : "21:26:39" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "21:30:12" , 
"departure_time" : "21:31:43" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "21:34:31" , 
"departure_time" : "21:34:37" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "21:37:06" , 
"departure_time" : "21:37:46" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "21:41:40" , 
"departure_time" : "21:43:11" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "21:45:31" , 
"departure_time" : "21:45:54" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "21:48:23" , 
"departure_time" : "21:48:44" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "21:52:21" , 
"departure_time" : "21:53:15" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "21:59:54" , 
"departure_time" : "21:59:54" , 
"distance_traveled" : 15.693
} ], 
"3252" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "20:30:00" , 
"departure_time" : "20:31:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "20:34:46" , 
"departure_time" : "20:34:50" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "20:39:04" , 
"departure_time" : "20:40:25" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "20:44:21" , 
"departure_time" : "20:44:39" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "20:47:18" , 
"departure_time" : "20:47:40" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "20:51:22" , 
"departure_time" : "20:52:46" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "20:55:24" , 
"departure_time" : "20:56:02" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "20:58:38" , 
"departure_time" : "20:58:50" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "21:02:12" , 
"departure_time" : "21:03:42" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "21:10:30" , 
"departure_time" : "21:10:30" , 
"distance_traveled" : 15.693
} ], 
"3253" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "23:35:00" , 
"departure_time" : "23:37:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "23:40:28" , 
"departure_time" : "23:42:05" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "23:45:37" , 
"departure_time" : "23:47:14" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "23:49:37" , 
"departure_time" : "23:50:49" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "23:53:12" , 
"departure_time" : "23:54:22" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "23:57:10" , 
"departure_time" : "23:58:03" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "23:59:53" , 
"departure_time" : "24:01:03" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "24:04:10" , 
"departure_time" : "24:04:24" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "24:07:14" , 
"departure_time" : "24:08:48" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "24:15:34" , 
"departure_time" : "24:15:34" , 
"distance_traveled" : 15.693
} ], 
"3254" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "21:20:00" , 
"departure_time" : "21:21:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "21:24:07" , 
"departure_time" : "21:25:03" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "21:29:56" , 
"departure_time" : "21:31:14" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "21:34:18" , 
"departure_time" : "21:34:26" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "21:37:08" , 
"departure_time" : "21:37:22" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "21:41:14" , 
"departure_time" : "21:42:11" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "21:44:57" , 
"departure_time" : "21:45:17" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "21:48:20" , 
"departure_time" : "21:49:34" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "21:53:14" , 
"departure_time" : "21:53:20" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "21:59:06" , 
"departure_time" : "21:59:06" , 
"distance_traveled" : 15.693
} ], 
"3255" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "04:52:00" , 
"departure_time" : "04:52:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "04:56:53" , 
"departure_time" : "04:57:43" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "05:01:50" , 
"departure_time" : "05:03:08" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "05:06:18" , 
"departure_time" : "05:07:23" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "05:10:05" , 
"departure_time" : "05:11:30" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "05:13:25" , 
"departure_time" : "05:13:39" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "05:15:14" , 
"departure_time" : "05:16:43" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "05:20:29" , 
"departure_time" : "05:21:05" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "05:23:36" , 
"departure_time" : "05:24:25" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "05:30:49" , 
"departure_time" : "05:30:49" , 
"distance_traveled" : 15.693
} ], 
"3256" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "23:35:00" , 
"departure_time" : "23:36:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "23:39:14" , 
"departure_time" : "23:39:35" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "23:44:21" , 
"departure_time" : "23:44:27" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "23:48:06" , 
"departure_time" : "23:48:27" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "23:52:21" , 
"departure_time" : "23:52:52" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "23:56:31" , 
"departure_time" : "23:56:38" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "23:59:07" , 
"departure_time" : "23:59:28" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "24:03:21" , 
"departure_time" : "24:04:41" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "24:08:20" , 
"departure_time" : "24:09:07" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "24:14:47" , 
"departure_time" : "24:14:47" , 
"distance_traveled" : 15.693
} ], 
"3257" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "06:27:00" , 
"departure_time" : "06:28:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "06:32:12" , 
"departure_time" : "06:33:02" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "06:36:50" , 
"departure_time" : "06:38:17" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "06:41:27" , 
"departure_time" : "06:41:32" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "06:44:05" , 
"departure_time" : "06:44:15" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "06:47:10" , 
"departure_time" : "06:48:21" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "06:51:11" , 
"departure_time" : "06:51:24" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "06:54:13" , 
"departure_time" : "06:55:10" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "06:58:57" , 
"departure_time" : "06:58:58" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "07:05:01" , 
"departure_time" : "07:05:01" , 
"distance_traveled" : 15.693
} ], 
"3258" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "04:52:00" , 
"departure_time" : "04:53:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "04:57:24" , 
"departure_time" : "04:58:16" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "05:01:52" , 
"departure_time" : "05:03:32" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "05:06:40" , 
"departure_time" : "05:06:54" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "05:09:14" , 
"departure_time" : "05:10:31" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "05:13:17" , 
"departure_time" : "05:14:37" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "05:16:20" , 
"departure_time" : "05:17:12" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "05:19:52" , 
"departure_time" : "05:20:38" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "05:23:46" , 
"departure_time" : "05:24:08" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "05:30:22" , 
"departure_time" : "05:30:22" , 
"distance_traveled" : 15.693
} ], 
"3259" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "07:46:00" , 
"departure_time" : "07:46:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "07:50:05" , 
"departure_time" : "07:51:03" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "07:55:58" , 
"departure_time" : "07:57:30" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "08:00:32" , 
"departure_time" : "08:01:49" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "08:04:17" , 
"departure_time" : "08:05:42" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "08:07:25" , 
"departure_time" : "08:07:49" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "08:09:24" , 
"departure_time" : "08:09:45" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "08:13:21" , 
"departure_time" : "08:14:57" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "08:18:36" , 
"departure_time" : "08:19:26" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "08:23:50" , 
"departure_time" : "08:23:50" , 
"distance_traveled" : 15.693
} ], 
"3260" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "06:27:00" , 
"departure_time" : "06:28:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "06:31:51" , 
"departure_time" : "06:32:22" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "06:36:31" , 
"departure_time" : "06:38:11" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "06:41:40" , 
"departure_time" : "06:42:41" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "06:45:01" , 
"departure_time" : "06:46:08" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "06:48:07" , 
"departure_time" : "06:48:58" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "06:50:51" , 
"departure_time" : "06:52:28" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "06:55:37" , 
"departure_time" : "06:55:53" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "06:58:16" , 
"departure_time" : "06:59:46" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "07:06:30" , 
"departure_time" : "07:06:30" , 
"distance_traveled" : 15.693
} ], 
"3261" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "08:27:00" , 
"departure_time" : "08:29:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "08:32:17" , 
"departure_time" : "08:33:15" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "08:36:58" , 
"departure_time" : "08:37:28" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "08:40:30" , 
"departure_time" : "08:41:02" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "08:44:32" , 
"departure_time" : "08:45:45" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "08:49:13" , 
"departure_time" : "08:50:15" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "08:53:02" , 
"departure_time" : "08:54:38" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "08:57:36" , 
"departure_time" : "08:59:15" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "09:01:39" , 
"departure_time" : "09:02:53" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "09:08:14" , 
"departure_time" : "09:08:14" , 
"distance_traveled" : 15.693
} ], 
"3262" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "07:46:00" , 
"departure_time" : "07:47:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "07:50:23" , 
"departure_time" : "07:50:36" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "07:55:13" , 
"departure_time" : "07:56:10" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "07:59:57" , 
"departure_time" : "08:01:17" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "08:04:20" , 
"departure_time" : "08:04:33" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "08:06:13" , 
"departure_time" : "08:06:20" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "08:09:07" , 
"departure_time" : "08:10:22" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "08:14:15" , 
"departure_time" : "08:14:48" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "08:17:33" , 
"departure_time" : "08:18:36" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "08:24:03" , 
"departure_time" : "08:24:03" , 
"distance_traveled" : 15.693
} ], 
"3263" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "10:09:00" , 
"departure_time" : "10:11:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "10:14:22" , 
"departure_time" : "10:15:37" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "10:19:15" , 
"departure_time" : "10:20:35" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "10:23:20" , 
"departure_time" : "10:24:04" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "10:26:44" , 
"departure_time" : "10:27:21" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "10:30:37" , 
"departure_time" : "10:31:55" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "10:34:18" , 
"departure_time" : "10:35:34" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "10:38:16" , 
"departure_time" : "10:38:55" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "10:41:39" , 
"departure_time" : "10:42:01" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "10:48:22" , 
"departure_time" : "10:48:22" , 
"distance_traveled" : 15.693
} ], 
"3264" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "08:27:00" , 
"departure_time" : "08:28:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "08:32:03" , 
"departure_time" : "08:33:03" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "08:37:00" , 
"departure_time" : "08:38:25" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "08:41:25" , 
"departure_time" : "08:41:36" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "08:44:11" , 
"departure_time" : "08:44:15" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "08:48:04" , 
"departure_time" : "08:49:31" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "08:53:27" , 
"departure_time" : "08:53:40" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "08:56:13" , 
"departure_time" : "08:57:00" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "09:00:47" , 
"departure_time" : "09:01:42" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "09:07:55" , 
"departure_time" : "09:07:55" , 
"distance_traveled" : 15.693
} ], 
"3265" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "11:10:00" , 
"departure_time" : "11:12:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "11:15:36" , 
"departure_time" : "11:16:56" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "11:20:20" , 
"departure_time" : "11:20:29" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "11:23:09" , 
"departure_time" : "11:24:39" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "11:28:30" , 
"departure_time" : "11:29:01" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "11:31:31" , 
"departure_time" : "11:32:26" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "11:34:55" , 
"departure_time" : "11:35:26" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "11:38:31" , 
"departure_time" : "11:39:20" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "11:42:49" , 
"departure_time" : "11:43:42" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "11:49:53" , 
"departure_time" : "11:49:53" , 
"distance_traveled" : 15.693
} ], 
"3266" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "10:09:00" , 
"departure_time" : "10:11:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "10:14:39" , 
"departure_time" : "10:15:57" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "10:19:18" , 
"departure_time" : "10:20:57" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "10:23:39" , 
"departure_time" : "10:25:11" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "10:27:32" , 
"departure_time" : "10:28:33" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "10:31:01" , 
"departure_time" : "10:31:05" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "10:33:04" , 
"departure_time" : "10:34:32" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "10:38:28" , 
"departure_time" : "10:39:20" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "10:41:52" , 
"departure_time" : "10:42:39" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "10:48:47" , 
"departure_time" : "10:48:47" , 
"distance_traveled" : 15.693
} ], 
"3267" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "13:09:00" , 
"departure_time" : "13:10:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "13:13:24" , 
"departure_time" : "13:14:37" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "13:19:13" , 
"departure_time" : "13:20:39" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "13:23:26" , 
"departure_time" : "13:24:35" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "13:27:09" , 
"departure_time" : "13:28:22" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "13:31:13" , 
"departure_time" : "13:31:40" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "13:33:27" , 
"departure_time" : "13:34:35" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "13:38:08" , 
"departure_time" : "13:39:31" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "13:42:23" , 
"departure_time" : "13:42:35" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "13:48:12" , 
"departure_time" : "13:48:12" , 
"distance_traveled" : 15.693
} ], 
"3268" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "11:10:00" , 
"departure_time" : "11:11:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "11:14:54" , 
"departure_time" : "11:15:34" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "11:19:40" , 
"departure_time" : "11:20:42" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "11:24:02" , 
"departure_time" : "11:24:46" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "11:27:44" , 
"departure_time" : "11:28:45" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "11:32:01" , 
"departure_time" : "11:33:09" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "11:35:08" , 
"departure_time" : "11:35:39" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "11:38:31" , 
"departure_time" : "11:39:20" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "11:42:49" , 
"departure_time" : "11:43:31" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "11:49:42" , 
"departure_time" : "11:49:42" , 
"distance_traveled" : 15.693
} ], 
"3269" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "15:02:00" , 
"departure_time" : "15:03:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "15:06:24" , 
"departure_time" : "15:06:58" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "15:11:34" , 
"departure_time" : "15:12:37" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "15:16:03" , 
"departure_time" : "15:16:48" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "15:19:45" , 
"departure_time" : "15:21:25" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "15:24:40" , 
"departure_time" : "15:25:04" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "15:26:24" , 
"departure_time" : "15:27:46" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "15:31:22" , 
"departure_time" : "15:31:30" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "15:34:08" , 
"departure_time" : "15:34:37" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "15:41:29" , 
"departure_time" : "15:41:29" , 
"distance_traveled" : 15.693
} ], 
"3270" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "13:09:00" , 
"departure_time" : "13:10:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "13:14:26" , 
"departure_time" : "13:15:58" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "13:19:32" , 
"departure_time" : "13:20:03" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "13:22:31" , 
"departure_time" : "13:22:54" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "13:26:23" , 
"departure_time" : "13:27:13" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "13:30:50" , 
"departure_time" : "13:32:22" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "13:34:32" , 
"departure_time" : "13:34:39" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "13:37:07" , 
"departure_time" : "13:38:13" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "13:42:06" , 
"departure_time" : "13:43:15" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "13:49:09" , 
"departure_time" : "13:49:09" , 
"distance_traveled" : 15.693
} ], 
"3271" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "16:02:00" , 
"departure_time" : "16:04:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "16:07:02" , 
"departure_time" : "16:07:45" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "16:11:43" , 
"departure_time" : "16:13:06" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "16:16:23" , 
"departure_time" : "16:16:39" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "16:19:16" , 
"departure_time" : "16:20:26" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "16:24:10" , 
"departure_time" : "16:24:14" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "16:26:04" , 
"departure_time" : "16:27:25" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "16:31:21" , 
"departure_time" : "16:32:32" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "16:35:11" , 
"departure_time" : "16:36:23" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "16:42:12" , 
"departure_time" : "16:42:12" , 
"distance_traveled" : 15.693
} ], 
"3272" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "15:02:00" , 
"departure_time" : "15:04:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "15:06:52" , 
"departure_time" : "15:08:07" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "15:12:15" , 
"departure_time" : "15:13:34" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "15:16:19" , 
"departure_time" : "15:17:20" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "15:20:01" , 
"departure_time" : "15:20:32" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "15:23:31" , 
"departure_time" : "15:23:32" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "15:26:01" , 
"departure_time" : "15:27:29" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "15:31:28" , 
"departure_time" : "15:32:11" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "15:34:43" , 
"departure_time" : "15:35:14" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "15:41:31" , 
"departure_time" : "15:41:31" , 
"distance_traveled" : 15.693
} ], 
"3273" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "17:32:00" , 
"departure_time" : "17:33:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "17:37:27" , 
"departure_time" : "17:37:58" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "17:41:31" , 
"departure_time" : "17:42:29" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "17:45:58" , 
"departure_time" : "17:47:07" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "17:50:09" , 
"departure_time" : "17:50:28" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "17:53:19" , 
"departure_time" : "17:53:39" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "17:56:20" , 
"departure_time" : "17:57:20" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "18:01:00" , 
"departure_time" : "18:02:02" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "18:05:02" , 
"departure_time" : "18:05:43" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "18:12:41" , 
"departure_time" : "18:12:41" , 
"distance_traveled" : 15.693
} ], 
"3274" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "16:02:00" , 
"departure_time" : "16:03:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "16:06:45" , 
"departure_time" : "16:08:06" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "16:12:21" , 
"departure_time" : "16:12:54" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "16:15:33" , 
"departure_time" : "16:16:32" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "16:19:59" , 
"departure_time" : "16:21:17" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "16:24:18" , 
"departure_time" : "16:25:48" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "16:27:30" , 
"departure_time" : "16:28:18" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "16:30:48" , 
"departure_time" : "16:32:16" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "16:35:28" , 
"departure_time" : "16:35:31" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "16:41:03" , 
"departure_time" : "16:41:03" , 
"distance_traveled" : 15.693
} ], 
"3275" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "19:27:00" , 
"departure_time" : "19:28:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "19:32:14" , 
"departure_time" : "19:32:45" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "19:36:31" , 
"departure_time" : "19:37:17" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "19:40:46" , 
"departure_time" : "19:41:41" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "19:44:55" , 
"departure_time" : "19:45:47" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "19:48:52" , 
"departure_time" : "19:49:16" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "19:51:24" , 
"departure_time" : "19:52:55" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "19:56:31" , 
"departure_time" : "19:56:51" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "19:59:20" , 
"departure_time" : "19:59:35" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "20:05:15" , 
"departure_time" : "20:05:15" , 
"distance_traveled" : 15.693
} ], 
"3276" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "17:32:00" , 
"departure_time" : "17:32:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "17:36:03" , 
"departure_time" : "17:36:23" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "17:41:20" , 
"departure_time" : "17:41:22" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "17:45:02" , 
"departure_time" : "17:46:30" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "17:50:28" , 
"departure_time" : "17:51:34" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "17:54:06" , 
"departure_time" : "17:54:43" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "17:56:37" , 
"departure_time" : "17:57:16" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "18:00:39" , 
"departure_time" : "18:01:56" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "18:05:17" , 
"departure_time" : "18:06:44" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "18:13:27" , 
"departure_time" : "18:13:27" , 
"distance_traveled" : 15.693
} ], 
"3277" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "20:28:00" , 
"departure_time" : "20:30:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "20:33:09" , 
"departure_time" : "20:33:51" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "20:37:42" , 
"departure_time" : "20:38:47" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "20:42:05" , 
"departure_time" : "20:43:28" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "20:46:23" , 
"departure_time" : "20:47:43" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "20:50:20" , 
"departure_time" : "20:51:48" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "20:53:28" , 
"departure_time" : "20:55:03" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "20:56:35" , 
"departure_time" : "20:57:05" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "20:59:30" , 
"departure_time" : "21:00:53" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "21:07:23" , 
"departure_time" : "21:07:23" , 
"distance_traveled" : 15.693
} ], 
"3278" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "19:27:00" , 
"departure_time" : "19:28:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "19:31:06" , 
"departure_time" : "19:32:04" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "19:36:58" , 
"departure_time" : "19:37:30" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "19:40:32" , 
"departure_time" : "19:40:47" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "19:44:15" , 
"departure_time" : "19:44:26" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "19:48:11" , 
"departure_time" : "19:48:21" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "19:51:10" , 
"departure_time" : "19:52:29" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "19:56:19" , 
"departure_time" : "19:57:06" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "19:59:47" , 
"departure_time" : "20:00:42" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "20:05:55" , 
"departure_time" : "20:05:55" , 
"distance_traveled" : 15.693
} ], 
"3279" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "22:49:00" , 
"departure_time" : "22:50:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "22:53:41" , 
"departure_time" : "22:54:35" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "22:58:54" , 
"departure_time" : "22:59:06" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "23:02:12" , 
"departure_time" : "23:03:41" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "23:07:29" , 
"departure_time" : "23:08:43" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "23:11:14" , 
"departure_time" : "23:12:51" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "23:14:37" , 
"departure_time" : "23:14:45" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "23:16:08" , 
"departure_time" : "23:17:42" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "23:21:34" , 
"departure_time" : "23:21:53" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "23:27:19" , 
"departure_time" : "23:27:19" , 
"distance_traveled" : 15.693
} ], 
"3280" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "20:28:00" , 
"departure_time" : "20:29:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "20:32:49" , 
"departure_time" : "20:33:52" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "20:38:03" , 
"departure_time" : "20:39:06" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "20:42:03" , 
"departure_time" : "20:43:28" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "20:46:25" , 
"departure_time" : "20:47:58" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "20:50:33" , 
"departure_time" : "20:51:58" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "20:53:25" , 
"departure_time" : "20:54:16" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "20:55:51" , 
"departure_time" : "20:56:33" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "20:59:42" , 
"departure_time" : "21:01:17" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "21:07:35" , 
"departure_time" : "21:07:35" , 
"distance_traveled" : 15.693
} ], 
"3281" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "23:34:00" , 
"departure_time" : "23:36:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "23:38:29" , 
"departure_time" : "23:38:42" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "23:43:13" , 
"departure_time" : "23:43:29" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "23:47:16" , 
"departure_time" : "23:48:19" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "23:52:03" , 
"departure_time" : "23:53:26" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "23:56:23" , 
"departure_time" : "23:57:15" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "23:58:52" , 
"departure_time" : "23:59:28" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "24:02:36" , 
"departure_time" : "24:02:42" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "24:06:06" , 
"departure_time" : "24:06:37" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "24:13:31" , 
"departure_time" : "24:13:31" , 
"distance_traveled" : 15.693
} ], 
"3282" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "22:49:00" , 
"departure_time" : "22:49:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "22:53:18" , 
"departure_time" : "22:54:16" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "22:58:58" , 
"departure_time" : "23:00:32" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "23:03:34" , 
"departure_time" : "23:04:57" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "23:07:23" , 
"departure_time" : "23:07:42" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "23:10:19" , 
"departure_time" : "23:11:42" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "23:14:23" , 
"departure_time" : "23:15:37" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "23:17:14" , 
"departure_time" : "23:18:10" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "23:20:56" , 
"departure_time" : "23:22:34" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "23:28:38" , 
"departure_time" : "23:28:38" , 
"distance_traveled" : 15.693
} ], 
"3283" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "23:34:00" , 
"departure_time" : "23:37:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "23:39:33" , 
"departure_time" : "23:39:42" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "23:43:09" , 
"departure_time" : "23:43:40" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "23:47:31" , 
"departure_time" : "23:48:02" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "23:51:31" , 
"departure_time" : "23:52:07" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "23:55:36" , 
"departure_time" : "23:56:57" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "23:59:21" , 
"departure_time" : "23:59:33" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "24:02:12" , 
"departure_time" : "24:02:42" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "24:06:30" , 
"departure_time" : "24:07:07" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "24:13:37" , 
"departure_time" : "24:13:37" , 
"distance_traveled" : 15.693
} ], 
"3284" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "06:05:00" , 
"departure_time" : "06:06:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "06:09:40" , 
"departure_time" : "06:10:45" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "06:15:05" , 
"departure_time" : "06:15:49" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "06:18:44" , 
"departure_time" : "06:20:24" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "06:23:40" , 
"departure_time" : "06:23:44" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "06:26:04" , 
"departure_time" : "06:27:29" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "06:31:25" , 
"departure_time" : "06:32:52" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "06:35:27" , 
"departure_time" : "06:36:38" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "06:39:11" , 
"departure_time" : "06:40:45" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "06:45:34" , 
"departure_time" : "06:47:08" , 
"distance_traveled" : 15.693
}, 
{ 
"stop_id" : 73,
"arrival_time" : "06:51:34" , 
"departure_time" : "06:52:22" , 
"distance_traveled" : 19.2108
}, 
{ 
"stop_id" : 130,
"arrival_time" : "06:54:48" , 
"departure_time" : "06:55:23" , 
"distance_traveled" : 21.5562
}, 
{ 
"stop_id" : 85,
"arrival_time" : "07:00:35" , 
"departure_time" : "07:01:23" , 
"distance_traveled" : 25.1807
}, 
{ 
"stop_id" : 59,
"arrival_time" : "07:06:48" , 
"departure_time" : "07:08:17" , 
"distance_traveled" : 29.5975
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "07:11:29" , 
"departure_time" : "07:12:29" , 
"distance_traveled" : 31.3854
}, 
{ 
"stop_id" : 139,
"arrival_time" : "07:20:00" , 
"departure_time" : "07:21:22" , 
"distance_traveled" : 36.7695
}, 
{ 
"stop_id" : 119,
"arrival_time" : "07:25:22" , 
"departure_time" : "07:25:24" , 
"distance_traveled" : 38.6436
}, 
{ 
"stop_id" : 158,
"arrival_time" : "07:30:02" , 
"departure_time" : "07:30:59" , 
"distance_traveled" : 42.0614
}, 
{ 
"stop_id" : 127,
"arrival_time" : "07:37:57" , 
"departure_time" : "07:39:25" , 
"distance_traveled" : 45.7956
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:53:28" , 
"departure_time" : "07:54:10" , 
"distance_traveled" : 56.4417
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "08:01:42" , 
"departure_time" : "08:02:22" , 
"distance_traveled" : 61.5104
}, 
{ 
"stop_id" : 105,
"arrival_time" : "08:14:40" , 
"departure_time" : "08:14:40" , 
"distance_traveled" : 66.4985
} ], 
"3285" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "05:18:00" , 
"departure_time" : "05:18:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "05:22:07" , 
"departure_time" : "05:23:04" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "05:27:57" , 
"departure_time" : "05:29:26" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "05:32:29" , 
"departure_time" : "05:32:32" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "05:35:03" , 
"departure_time" : "05:35:28" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "05:39:25" , 
"departure_time" : "05:39:40" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "05:42:15" , 
"departure_time" : "05:42:21" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "05:46:06" , 
"departure_time" : "05:47:39" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "05:51:33" , 
"departure_time" : "05:52:37" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "05:58:04" , 
"departure_time" : "05:58:04" , 
"distance_traveled" : 15.693
} ], 
"3286" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "07:18:00" , 
"departure_time" : "07:19:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "07:22:14" , 
"departure_time" : "07:22:26" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "07:27:12" , 
"departure_time" : "07:28:26" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "07:32:14" , 
"departure_time" : "07:32:36" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "07:35:22" , 
"departure_time" : "07:35:24" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "07:39:02" , 
"departure_time" : "07:40:38" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "07:43:36" , 
"departure_time" : "07:45:01" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "07:47:25" , 
"departure_time" : "07:48:08" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "07:50:43" , 
"departure_time" : "07:51:42" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "07:57:59" , 
"departure_time" : "07:57:59" , 
"distance_traveled" : 15.693
} ], 
"3287" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "09:20:00" , 
"departure_time" : "09:21:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "09:24:45" , 
"departure_time" : "09:26:00" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "09:30:15" , 
"departure_time" : "09:31:06" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "09:33:51" , 
"departure_time" : "09:34:45" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "09:37:54" , 
"departure_time" : "09:38:33" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "09:41:39" , 
"departure_time" : "09:42:47" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "09:45:08" , 
"departure_time" : "09:45:19" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "09:48:11" , 
"departure_time" : "09:48:20" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "09:52:09" , 
"departure_time" : "09:53:19" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "10:00:10" , 
"departure_time" : "10:00:10" , 
"distance_traveled" : 15.693
} ], 
"3288" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "11:22:00" , 
"departure_time" : "11:23:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "11:26:34" , 
"departure_time" : "11:27:19" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "11:31:45" , 
"departure_time" : "11:32:55" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "11:36:10" , 
"departure_time" : "11:36:50" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "11:39:40" , 
"departure_time" : "11:39:47" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "11:43:07" , 
"departure_time" : "11:44:38" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "11:47:31" , 
"departure_time" : "11:47:34" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "11:50:03" , 
"departure_time" : "11:50:14" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "11:54:11" , 
"departure_time" : "11:55:20" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "12:02:09" , 
"departure_time" : "12:02:09" , 
"distance_traveled" : 15.693
} ], 
"3289" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "13:20:00" , 
"departure_time" : "13:22:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "13:25:03" , 
"departure_time" : "13:26:15" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "13:30:12" , 
"departure_time" : "13:31:35" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "13:34:23" , 
"departure_time" : "13:35:40" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "13:38:17" , 
"departure_time" : "13:39:19" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "13:42:02" , 
"departure_time" : "13:42:51" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "13:44:49" , 
"departure_time" : "13:45:07" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "13:48:18" , 
"departure_time" : "13:49:27" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "13:53:09" , 
"departure_time" : "13:53:42" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "13:59:33" , 
"departure_time" : "13:59:33" , 
"distance_traveled" : 15.693
} ], 
"3290" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "15:17:00" , 
"departure_time" : "15:17:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "15:21:20" , 
"departure_time" : "15:22:05" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "15:26:45" , 
"departure_time" : "15:27:32" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "15:30:47" , 
"departure_time" : "15:30:51" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "15:34:04" , 
"departure_time" : "15:34:07" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "15:38:03" , 
"departure_time" : "15:39:23" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "15:42:20" , 
"departure_time" : "15:43:01" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "15:45:41" , 
"departure_time" : "15:46:15" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "15:49:34" , 
"departure_time" : "15:49:59" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "15:56:25" , 
"departure_time" : "15:56:25" , 
"distance_traveled" : 15.693
} ], 
"3291" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "17:19:00" , 
"departure_time" : "17:19:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "17:23:08" , 
"departure_time" : "17:23:52" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "17:28:44" , 
"departure_time" : "17:29:14" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "17:32:30" , 
"departure_time" : "17:33:18" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "17:36:48" , 
"departure_time" : "17:38:17" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "17:41:29" , 
"departure_time" : "17:41:57" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "17:43:28" , 
"departure_time" : "17:44:33" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "17:48:05" , 
"departure_time" : "17:48:53" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "17:51:48" , 
"departure_time" : "17:52:04" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "17:58:16" , 
"departure_time" : "17:58:16" , 
"distance_traveled" : 15.693
} ], 
"3292" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "18:30:00" , 
"departure_time" : "18:30:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "18:34:11" , 
"departure_time" : "18:34:17" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "18:39:06" , 
"departure_time" : "18:40:23" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "18:44:17" , 
"departure_time" : "18:45:40" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "18:48:23" , 
"departure_time" : "18:49:19" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "18:51:56" , 
"departure_time" : "18:53:25" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "18:55:29" , 
"departure_time" : "18:55:45" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "18:58:16" , 
"departure_time" : "18:58:59" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "19:02:43" , 
"departure_time" : "19:03:51" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "19:10:08" , 
"departure_time" : "19:10:08" , 
"distance_traveled" : 15.693
} ], 
"3293" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "20:30:00" , 
"departure_time" : "20:32:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "20:35:13" , 
"departure_time" : "20:35:56" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "20:39:43" , 
"departure_time" : "20:41:09" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "20:44:26" , 
"departure_time" : "20:44:43" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "20:47:17" , 
"departure_time" : "20:47:26" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "20:51:09" , 
"departure_time" : "20:52:04" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "20:54:55" , 
"departure_time" : "20:56:12" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "20:59:17" , 
"departure_time" : "21:00:40" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "21:03:23" , 
"departure_time" : "21:04:43" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "21:10:20" , 
"departure_time" : "21:10:20" , 
"distance_traveled" : 15.693
} ], 
"3294" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "21:20:00" , 
"departure_time" : "21:21:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "21:24:22" , 
"departure_time" : "21:25:40" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "21:30:18" , 
"departure_time" : "21:30:51" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "21:33:33" , 
"departure_time" : "21:34:50" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "21:38:17" , 
"departure_time" : "21:39:51" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "21:42:34" , 
"departure_time" : "21:43:15" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "21:44:41" , 
"departure_time" : "21:44:42" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "21:48:01" , 
"departure_time" : "21:49:31" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "21:53:30" , 
"departure_time" : "21:54:35" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "22:00:05" , 
"departure_time" : "22:00:05" , 
"distance_traveled" : 15.693
} ], 
"3295" :  [ 
{ 
"stop_id" : 13,
"arrival_time" : "23:35:00" , 
"departure_time" : "23:37:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 122,
"arrival_time" : "23:40:05" , 
"departure_time" : "23:41:45" , 
"distance_traveled" : 1.0805
}, 
{ 
"stop_id" : 79,
"arrival_time" : "23:45:40" , 
"departure_time" : "23:46:56" , 
"distance_traveled" : 3.0358
}, 
{ 
"stop_id" : 141,
"arrival_time" : "23:49:16" , 
"departure_time" : "23:49:32" , 
"distance_traveled" : 5.2104
}, 
{ 
"stop_id" : 15,
"arrival_time" : "23:52:16" , 
"departure_time" : "23:52:42" , 
"distance_traveled" : 7.3284
}, 
{ 
"stop_id" : 22,
"arrival_time" : "23:56:26" , 
"departure_time" : "23:56:43" , 
"distance_traveled" : 8.9854
}, 
{ 
"stop_id" : 8,
"arrival_time" : "23:59:17" , 
"departure_time" : "23:59:36" , 
"distance_traveled" : 9.814
}, 
{ 
"stop_id" : 4,
"arrival_time" : "24:03:19" , 
"departure_time" : "24:04:00" , 
"distance_traveled" : 11.4081
}, 
{ 
"stop_id" : 40,
"arrival_time" : "24:07:41" , 
"departure_time" : "24:08:38" , 
"distance_traveled" : 13.4246
}, 
{ 
"stop_id" : 74,
"arrival_time" : "24:14:57" , 
"departure_time" : "24:14:57" , 
"distance_traveled" : 15.693
} ], 
"3296" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "24:08:00" , 
"departure_time" : "24:09:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "24:12:07" , 
"departure_time" : "24:13:30" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "24:17:23" , 
"departure_time" : "24:18:55" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "24:21:32" , 
"departure_time" : "24:22:03" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "24:23:31" , 
"departure_time" : "24:24:13" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "24:27:42" , 
"departure_time" : "24:28:32" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "24:31:50" , 
"departure_time" : "24:32:47" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "24:35:57" , 
"departure_time" : "24:36:23" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "24:40:26" , 
"departure_time" : "24:42:05" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "24:50:39" , 
"departure_time" : "24:50:39" , 
"distance_traveled" : 15.693
} ], 
"3297" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "24:08:00" , 
"departure_time" : "24:10:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "24:13:06" , 
"departure_time" : "24:13:45" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "24:16:39" , 
"departure_time" : "24:17:15" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "24:20:36" , 
"departure_time" : "24:21:20" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "24:23:44" , 
"departure_time" : "24:24:13" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "24:27:29" , 
"departure_time" : "24:28:42" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "24:32:13" , 
"departure_time" : "24:33:27" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "24:36:14" , 
"departure_time" : "24:37:40" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "24:41:26" , 
"departure_time" : "24:41:40" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "24:49:14" , 
"departure_time" : "24:49:14" , 
"distance_traveled" : 15.693
} ], 
"3298" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "25:03:00" , 
"departure_time" : "25:04:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "25:08:28" , 
"departure_time" : "25:08:35" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "25:11:07" , 
"departure_time" : "25:11:41" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "25:15:34" , 
"departure_time" : "25:15:44" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "25:17:10" , 
"departure_time" : "25:18:10" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "25:22:00" , 
"departure_time" : "25:23:21" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "25:26:21" , 
"departure_time" : "25:28:01" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "25:29:40" , 
"departure_time" : "25:29:56" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "25:34:16" , 
"departure_time" : "25:34:41" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "25:44:25" , 
"departure_time" : "25:44:25" , 
"distance_traveled" : 15.693
} ], 
"3299" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "25:03:00" , 
"departure_time" : "25:05:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "25:08:35" , 
"departure_time" : "25:10:09" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "25:12:34" , 
"departure_time" : "25:13:58" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "25:16:24" , 
"departure_time" : "25:16:30" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "25:17:06" , 
"departure_time" : "25:17:17" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "25:21:11" , 
"departure_time" : "25:22:20" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "25:26:09" , 
"departure_time" : "25:26:23" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "25:28:14" , 
"departure_time" : "25:28:55" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "25:34:41" , 
"departure_time" : "25:35:08" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "25:44:27" , 
"departure_time" : "25:44:27" , 
"distance_traveled" : 15.693
} ], 
"3300" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:47:00" , 
"departure_time" : "16:48:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:56:56" , 
"departure_time" : "16:57:54" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:06:58" , 
"departure_time" : "17:07:27" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 127,
"arrival_time" : "17:19:29" , 
"departure_time" : "17:20:04" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "17:25:35" , 
"departure_time" : "17:26:27" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "17:29:52" , 
"departure_time" : "17:29:59" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "17:35:07" , 
"departure_time" : "17:36:37" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "17:41:30" , 
"departure_time" : "17:42:08" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "17:49:38" , 
"departure_time" : "17:49:48" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "17:53:10" , 
"departure_time" : "17:54:41" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "18:00:31" , 
"departure_time" : "18:01:18" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "18:05:47" , 
"departure_time" : "18:07:03" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "18:10:16" , 
"departure_time" : "18:10:44" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "18:15:28" , 
"departure_time" : "18:16:58" , 
"distance_traveled" : 50.8055
}, 
{ 
"stop_id" : 40,
"arrival_time" : "18:21:30" , 
"departure_time" : "18:22:16" , 
"distance_traveled" : 53.0739
}, 
{ 
"stop_id" : 4,
"arrival_time" : "18:24:46" , 
"departure_time" : "18:25:38" , 
"distance_traveled" : 55.09
}, 
{ 
"stop_id" : 8,
"arrival_time" : "18:28:52" , 
"departure_time" : "18:30:13" , 
"distance_traveled" : 56.6843
}, 
{ 
"stop_id" : 22,
"arrival_time" : "18:32:21" , 
"departure_time" : "18:33:45" , 
"distance_traveled" : 57.5131
}, 
{ 
"stop_id" : 15,
"arrival_time" : "18:36:24" , 
"departure_time" : "18:37:33" , 
"distance_traveled" : 59.1699
}, 
{ 
"stop_id" : 141,
"arrival_time" : "18:40:09" , 
"departure_time" : "18:41:32" , 
"distance_traveled" : 61.2879
}, 
{ 
"stop_id" : 79,
"arrival_time" : "18:44:23" , 
"departure_time" : "18:45:41" , 
"distance_traveled" : 63.4625
}, 
{ 
"stop_id" : 122,
"arrival_time" : "18:49:18" , 
"departure_time" : "18:49:21" , 
"distance_traveled" : 65.4178
}, 
{ 
"stop_id" : 13,
"arrival_time" : "18:56:03" , 
"departure_time" : "18:56:03" , 
"distance_traveled" : 66.4981
} ], 
"3301" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "24:47:00" , 
"departure_time" : "24:47:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "24:51:13" , 
"departure_time" : "24:52:13" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "24:56:00" , 
"departure_time" : "24:56:46" , 
"distance_traveled" : 4.2847
}, 
{ 
"stop_id" : 8,
"arrival_time" : "24:59:46" , 
"departure_time" : "25:00:24" , 
"distance_traveled" : 5.879
}, 
{ 
"stop_id" : 22,
"arrival_time" : "25:02:38" , 
"departure_time" : "25:03:53" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "25:07:15" , 
"departure_time" : "25:07:29" , 
"distance_traveled" : 8.3646
}, 
{ 
"stop_id" : 141,
"arrival_time" : "25:09:14" , 
"departure_time" : "25:10:20" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "25:14:06" , 
"departure_time" : "25:14:25" , 
"distance_traveled" : 12.6576
}, 
{ 
"stop_id" : 122,
"arrival_time" : "25:19:19" , 
"departure_time" : "25:20:10" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "25:29:51" , 
"departure_time" : "25:29:51" , 
"distance_traveled" : 15.693
} ], 
"3302" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "24:47:00" , 
"departure_time" : "24:48:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "24:51:53" , 
"departure_time" : "24:52:34" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "24:55:41" , 
"departure_time" : "24:56:48" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "25:00:07" , 
"departure_time" : "25:01:41" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "25:03:34" , 
"departure_time" : "25:04:44" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "25:07:10" , 
"departure_time" : "25:07:52" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "25:09:42" , 
"departure_time" : "25:10:43" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "25:14:01" , 
"departure_time" : "25:14:17" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "25:19:16" , 
"departure_time" : "25:19:43" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "25:28:27" , 
"departure_time" : "25:28:27" , 
"distance_traveled" : 15.693
} ], 
"3303" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:47:00" , 
"departure_time" : "16:48:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:56:47" , 
"departure_time" : "16:56:48" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:06:01" , 
"departure_time" : "17:06:16" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 127,
"arrival_time" : "17:19:15" , 
"departure_time" : "17:19:33" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "17:25:18" , 
"departure_time" : "17:25:50" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "17:29:32" , 
"departure_time" : "17:30:18" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "17:35:46" , 
"departure_time" : "17:36:21" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "17:40:35" , 
"departure_time" : "17:41:42" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "17:50:07" , 
"departure_time" : "17:51:41" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "17:54:34" , 
"departure_time" : "17:54:40" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "17:59:06" , 
"departure_time" : "17:59:18" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "18:05:12" , 
"departure_time" : "18:05:30" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "18:09:18" , 
"departure_time" : "18:10:20" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "18:16:02" , 
"departure_time" : "18:17:00" , 
"distance_traveled" : 50.8055
}, 
{ 
"stop_id" : 40,
"arrival_time" : "18:20:58" , 
"departure_time" : "18:22:15" , 
"distance_traveled" : 53.0739
}, 
{ 
"stop_id" : 4,
"arrival_time" : "18:25:17" , 
"departure_time" : "18:26:32" , 
"distance_traveled" : 55.09
}, 
{ 
"stop_id" : 8,
"arrival_time" : "18:29:15" , 
"departure_time" : "18:29:52" , 
"distance_traveled" : 56.6843
}, 
{ 
"stop_id" : 22,
"arrival_time" : "18:31:37" , 
"departure_time" : "18:32:03" , 
"distance_traveled" : 57.5131
}, 
{ 
"stop_id" : 15,
"arrival_time" : "18:35:26" , 
"departure_time" : "18:36:16" , 
"distance_traveled" : 59.1699
}, 
{ 
"stop_id" : 141,
"arrival_time" : "18:39:50" , 
"departure_time" : "18:40:35" , 
"distance_traveled" : 61.2879
}, 
{ 
"stop_id" : 79,
"arrival_time" : "18:43:45" , 
"departure_time" : "18:44:36" , 
"distance_traveled" : 63.4625
}, 
{ 
"stop_id" : 122,
"arrival_time" : "18:48:51" , 
"departure_time" : "18:49:56" , 
"distance_traveled" : 65.4178
}, 
{ 
"stop_id" : 13,
"arrival_time" : "18:57:05" , 
"departure_time" : "18:57:05" , 
"distance_traveled" : 66.4981
} ], 
"3304" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "26:47:00" , 
"departure_time" : "26:49:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "26:52:25" , 
"departure_time" : "26:52:28" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "26:55:03" , 
"departure_time" : "26:55:15" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "26:59:12" , 
"departure_time" : "27:00:43" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "27:02:31" , 
"departure_time" : "27:03:43" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "27:06:12" , 
"departure_time" : "27:07:33" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "27:10:21" , 
"departure_time" : "27:11:57" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "27:13:36" , 
"departure_time" : "27:14:13" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "27:18:37" , 
"departure_time" : "27:18:48" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "27:27:11" , 
"departure_time" : "27:27:11" , 
"distance_traveled" : 15.693
} ], 
"3305" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "26:47:00" , 
"departure_time" : "26:47:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "26:51:46" , 
"departure_time" : "26:53:06" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "26:56:20" , 
"departure_time" : "26:57:19" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "26:59:59" , 
"departure_time" : "27:01:30" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "27:02:31" , 
"departure_time" : "27:03:27" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "27:05:56" , 
"departure_time" : "27:07:26" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "27:10:30" , 
"departure_time" : "27:11:02" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "27:12:32" , 
"departure_time" : "27:12:57" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "27:18:25" , 
"departure_time" : "27:18:51" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "27:27:26" , 
"departure_time" : "27:27:26" , 
"distance_traveled" : 15.693
} ], 
"3306" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "08:35:00" , 
"departure_time" : "08:36:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "08:39:41" , 
"departure_time" : "08:39:47" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "08:43:06" , 
"departure_time" : "08:43:15" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "08:47:09" , 
"departure_time" : "08:48:10" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "08:51:01" , 
"departure_time" : "08:51:59" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "08:54:58" , 
"departure_time" : "08:55:15" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "08:57:17" , 
"departure_time" : "08:58:00" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "09:01:43" , 
"departure_time" : "09:02:18" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "09:10:35" , 
"departure_time" : "09:11:39" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "09:20:04" , 
"departure_time" : "09:20:04" , 
"distance_traveled" : 15.693
} ], 
"3307" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "10:36:00" , 
"departure_time" : "10:38:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "10:41:32" , 
"departure_time" : "10:42:22" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "10:44:50" , 
"departure_time" : "10:44:55" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "10:48:05" , 
"departure_time" : "10:49:04" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "10:51:59" , 
"departure_time" : "10:52:24" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "10:55:25" , 
"departure_time" : "10:55:43" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "10:58:18" , 
"departure_time" : "10:58:22" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "11:02:04" , 
"departure_time" : "11:02:15" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "11:11:11" , 
"departure_time" : "11:12:18" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "11:21:07" , 
"departure_time" : "11:21:07" , 
"distance_traveled" : 15.693
} ], 
"3308" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "12:40:00" , 
"departure_time" : "12:41:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "12:44:20" , 
"departure_time" : "12:45:08" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "12:48:48" , 
"departure_time" : "12:48:50" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "12:52:02" , 
"departure_time" : "12:52:31" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "12:55:29" , 
"departure_time" : "12:56:09" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "12:59:40" , 
"departure_time" : "13:00:52" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "13:03:12" , 
"departure_time" : "13:04:09" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "13:06:57" , 
"departure_time" : "13:08:11" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "13:16:14" , 
"departure_time" : "13:17:36" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "13:25:22" , 
"departure_time" : "13:25:22" , 
"distance_traveled" : 15.693
} ], 
"3309" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "14:51:00" , 
"departure_time" : "14:53:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "14:56:27" , 
"departure_time" : "14:57:11" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "14:59:44" , 
"departure_time" : "15:01:22" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "15:04:38" , 
"departure_time" : "15:06:10" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "15:07:32" , 
"departure_time" : "15:08:47" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "15:11:15" , 
"departure_time" : "15:12:06" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "15:13:51" , 
"departure_time" : "15:14:09" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "15:17:18" , 
"departure_time" : "15:17:24" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "15:26:06" , 
"departure_time" : "15:27:45" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "15:36:39" , 
"departure_time" : "15:36:39" , 
"distance_traveled" : 15.693
} ], 
"3310" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "16:51:00" , 
"departure_time" : "16:53:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "16:55:39" , 
"departure_time" : "16:55:51" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "16:59:12" , 
"departure_time" : "16:59:20" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "17:03:08" , 
"departure_time" : "17:04:39" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "17:07:31" , 
"departure_time" : "17:08:51" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "17:11:20" , 
"departure_time" : "17:12:51" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "17:14:31" , 
"departure_time" : "17:15:24" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "17:17:53" , 
"departure_time" : "17:18:16" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "17:26:23" , 
"departure_time" : "17:27:20" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "17:35:57" , 
"departure_time" : "17:35:57" , 
"distance_traveled" : 15.693
} ], 
"3311" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "24:47:00" , 
"departure_time" : "24:48:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "24:51:08" , 
"departure_time" : "24:51:38" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "24:55:30" , 
"departure_time" : "24:56:53" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "25:00:23" , 
"departure_time" : "25:00:49" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "25:02:26" , 
"departure_time" : "25:02:55" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "25:06:29" , 
"departure_time" : "25:08:08" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "25:10:39" , 
"departure_time" : "25:12:15" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "25:14:36" , 
"departure_time" : "25:16:09" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "25:20:33" , 
"departure_time" : "25:21:52" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "25:30:19" , 
"departure_time" : "25:30:19" , 
"distance_traveled" : 15.693
} ], 
"3312" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "18:51:00" , 
"departure_time" : "18:53:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "18:56:08" , 
"departure_time" : "18:56:37" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "18:59:29" , 
"departure_time" : "19:00:16" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "19:03:47" , 
"departure_time" : "19:05:14" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "19:07:27" , 
"departure_time" : "19:07:31" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "19:10:04" , 
"departure_time" : "19:11:40" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "19:14:36" , 
"departure_time" : "19:15:50" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "19:18:14" , 
"departure_time" : "19:18:45" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "19:26:31" , 
"departure_time" : "19:27:39" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "19:36:08" , 
"departure_time" : "19:36:08" , 
"distance_traveled" : 15.693
} ], 
"3313" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "26:47:00" , 
"departure_time" : "26:49:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "26:52:09" , 
"departure_time" : "26:52:50" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "26:55:41" , 
"departure_time" : "26:55:50" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "26:59:09" , 
"departure_time" : "26:59:14" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "27:01:05" , 
"departure_time" : "27:02:35" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "27:06:30" , 
"departure_time" : "27:07:22" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "27:09:52" , 
"departure_time" : "27:10:02" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "27:12:10" , 
"departure_time" : "27:12:18" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "27:18:08" , 
"departure_time" : "27:18:50" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "27:27:42" , 
"departure_time" : "27:27:42" , 
"distance_traveled" : 15.693
} ], 
"3314" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "19:51:00" , 
"departure_time" : "19:51:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "19:55:02" , 
"departure_time" : "19:55:27" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "19:59:25" , 
"departure_time" : "20:00:14" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "20:03:49" , 
"departure_time" : "20:04:53" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "20:07:04" , 
"departure_time" : "20:08:37" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "20:11:33" , 
"departure_time" : "20:12:53" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "20:14:20" , 
"departure_time" : "20:14:45" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "20:17:25" , 
"departure_time" : "20:18:02" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "20:26:37" , 
"departure_time" : "20:28:12" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "20:36:35" , 
"departure_time" : "20:36:35" , 
"distance_traveled" : 15.693
} ], 
"3315" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "08:35:00" , 
"departure_time" : "08:36:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "08:39:17" , 
"departure_time" : "08:40:25" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "08:44:08" , 
"departure_time" : "08:44:25" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "08:47:17" , 
"departure_time" : "08:47:19" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "08:50:02" , 
"departure_time" : "08:50:48" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "08:54:46" , 
"departure_time" : "08:55:40" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "08:57:54" , 
"departure_time" : "08:59:22" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "09:02:28" , 
"departure_time" : "09:03:38" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "09:11:10" , 
"departure_time" : "09:11:39" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "09:19:29" , 
"departure_time" : "09:19:29" , 
"distance_traveled" : 15.693
} ], 
"3316" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "21:45:00" , 
"departure_time" : "21:45:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "21:49:15" , 
"departure_time" : "21:49:33" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "21:53:18" , 
"departure_time" : "21:54:08" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "21:57:50" , 
"departure_time" : "21:57:57" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "22:00:07" , 
"departure_time" : "22:00:12" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "22:04:05" , 
"departure_time" : "22:04:49" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "22:07:44" , 
"departure_time" : "22:08:05" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "22:11:21" , 
"departure_time" : "22:12:55" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "22:18:34" , 
"departure_time" : "22:19:25" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "22:26:51" , 
"departure_time" : "22:26:51" , 
"distance_traveled" : 15.693
} ], 
"3317" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "10:36:00" , 
"departure_time" : "10:37:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "10:40:35" , 
"departure_time" : "10:42:03" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "10:45:28" , 
"departure_time" : "10:45:29" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "10:48:01" , 
"departure_time" : "10:49:04" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "10:52:03" , 
"departure_time" : "10:52:28" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "10:55:25" , 
"departure_time" : "10:56:11" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "10:58:46" , 
"departure_time" : "10:59:13" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "11:02:27" , 
"departure_time" : "11:03:30" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "11:12:03" , 
"departure_time" : "11:12:14" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "11:20:11" , 
"departure_time" : "11:20:11" , 
"distance_traveled" : 15.693
} ], 
"3318" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "22:47:00" , 
"departure_time" : "22:48:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "22:52:11" , 
"departure_time" : "22:53:42" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "22:56:31" , 
"departure_time" : "22:57:11" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "22:59:40" , 
"departure_time" : "23:01:19" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "23:03:39" , 
"departure_time" : "23:04:26" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "23:06:47" , 
"departure_time" : "23:07:20" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "23:09:33" , 
"departure_time" : "23:09:51" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "23:13:18" , 
"departure_time" : "23:14:52" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "23:20:34" , 
"departure_time" : "23:21:34" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "23:29:00" , 
"departure_time" : "23:29:00" , 
"distance_traveled" : 15.693
} ], 
"3319" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "12:40:00" , 
"departure_time" : "12:42:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "12:45:27" , 
"departure_time" : "12:46:46" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "12:49:19" , 
"departure_time" : "12:49:46" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "12:52:27" , 
"departure_time" : "12:52:32" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "12:55:05" , 
"departure_time" : "12:55:55" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "12:59:50" , 
"departure_time" : "13:01:13" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "13:03:23" , 
"departure_time" : "13:04:50" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "13:07:27" , 
"departure_time" : "13:08:50" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "13:16:23" , 
"departure_time" : "13:16:49" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "13:24:26" , 
"departure_time" : "13:24:26" , 
"distance_traveled" : 15.693
} ], 
"3320" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "07:24:00" , 
"departure_time" : "07:25:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "07:29:31" , 
"departure_time" : "07:29:56" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "07:32:25" , 
"departure_time" : "07:32:51" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "07:36:26" , 
"departure_time" : "07:36:29" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "07:39:03" , 
"departure_time" : "07:39:18" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "07:43:15" , 
"departure_time" : "07:44:24" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "07:48:09" , 
"departure_time" : "07:49:45" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "07:52:36" , 
"departure_time" : "07:53:09" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "07:56:33" , 
"departure_time" : "07:57:12" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "08:03:39" , 
"departure_time" : "08:03:39" , 
"distance_traveled" : 15.693
} ], 
"3321" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "14:51:00" , 
"departure_time" : "14:53:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "14:56:27" , 
"departure_time" : "14:56:55" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "14:59:28" , 
"departure_time" : "14:59:43" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "15:03:15" , 
"departure_time" : "15:04:54" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "15:07:39" , 
"departure_time" : "15:08:33" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "15:10:54" , 
"departure_time" : "15:11:05" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "15:13:11" , 
"departure_time" : "15:13:14" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "15:17:03" , 
"departure_time" : "15:17:38" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "15:26:35" , 
"departure_time" : "15:27:12" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "15:35:37" , 
"departure_time" : "15:35:37" , 
"distance_traveled" : 15.693
} ], 
"3322" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "08:45:00" , 
"departure_time" : "08:46:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "08:49:23" , 
"departure_time" : "08:49:46" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "08:53:23" , 
"departure_time" : "08:53:39" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "08:57:16" , 
"departure_time" : "08:58:51" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "09:01:35" , 
"departure_time" : "09:02:28" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "09:04:53" , 
"departure_time" : "09:05:07" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "09:08:14" , 
"departure_time" : "09:08:57" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "09:12:43" , 
"departure_time" : "09:13:43" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "09:18:00" , 
"departure_time" : "09:19:23" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "09:29:23" , 
"departure_time" : "09:29:23" , 
"distance_traveled" : 15.693
} ], 
"3323" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "16:51:00" , 
"departure_time" : "16:53:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "16:55:40" , 
"departure_time" : "16:56:56" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "17:00:16" , 
"departure_time" : "17:01:46" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "17:04:30" , 
"departure_time" : "17:05:20" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "17:06:50" , 
"departure_time" : "17:07:30" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "17:10:40" , 
"departure_time" : "17:11:16" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "17:13:36" , 
"departure_time" : "17:14:49" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "17:18:13" , 
"departure_time" : "17:19:46" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "17:27:33" , 
"departure_time" : "17:28:24" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "17:35:51" , 
"departure_time" : "17:35:51" , 
"distance_traveled" : 15.693
} ], 
"3324" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "09:26:00" , 
"departure_time" : "09:27:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "09:30:47" , 
"departure_time" : "09:31:09" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "09:34:22" , 
"departure_time" : "09:34:23" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "09:38:01" , 
"departure_time" : "09:39:39" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "09:42:38" , 
"departure_time" : "09:42:56" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "09:45:18" , 
"departure_time" : "09:46:26" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "09:50:08" , 
"departure_time" : "09:50:10" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "09:53:02" , 
"departure_time" : "09:54:02" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "10:00:00" , 
"departure_time" : "10:00:31" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "10:07:31" , 
"departure_time" : "10:07:31" , 
"distance_traveled" : 15.693
} ], 
"3325" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "18:51:00" , 
"departure_time" : "18:52:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "18:56:01" , 
"departure_time" : "18:57:27" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "19:00:26" , 
"departure_time" : "19:01:27" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "19:04:01" , 
"departure_time" : "19:05:30" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "19:07:29" , 
"departure_time" : "19:07:36" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "19:10:07" , 
"departure_time" : "19:10:25" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "19:13:18" , 
"departure_time" : "19:14:38" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "19:18:20" , 
"departure_time" : "19:19:51" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "19:27:31" , 
"departure_time" : "19:28:20" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "19:35:49" , 
"departure_time" : "19:35:49" , 
"distance_traveled" : 15.693
} ], 
"3326" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "11:29:00" , 
"departure_time" : "11:31:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "11:34:29" , 
"departure_time" : "11:36:06" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "11:38:37" , 
"departure_time" : "11:39:55" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "11:42:18" , 
"departure_time" : "11:43:20" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "11:45:02" , 
"departure_time" : "11:45:42" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "11:48:40" , 
"departure_time" : "11:49:31" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "11:52:51" , 
"departure_time" : "11:53:11" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "11:56:20" , 
"departure_time" : "11:56:21" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "12:02:01" , 
"departure_time" : "12:03:34" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "12:11:33" , 
"departure_time" : "12:11:33" , 
"distance_traveled" : 15.693
} ], 
"3327" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "19:51:00" , 
"departure_time" : "19:52:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "19:55:24" , 
"departure_time" : "19:56:50" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "20:00:26" , 
"departure_time" : "20:01:41" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "20:04:15" , 
"departure_time" : "20:04:52" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "20:06:37" , 
"departure_time" : "20:06:54" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "20:10:17" , 
"departure_time" : "20:11:50" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "20:14:33" , 
"departure_time" : "20:15:13" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "20:17:40" , 
"departure_time" : "20:18:04" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "20:26:24" , 
"departure_time" : "20:27:00" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "20:35:36" , 
"departure_time" : "20:35:36" , 
"distance_traveled" : 15.693
} ], 
"3328" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "12:26:00" , 
"departure_time" : "12:26:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "12:30:21" , 
"departure_time" : "12:31:22" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "12:35:01" , 
"departure_time" : "12:35:58" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "12:38:57" , 
"departure_time" : "12:40:36" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "12:42:39" , 
"departure_time" : "12:42:56" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "12:45:17" , 
"departure_time" : "12:46:25" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "12:50:08" , 
"departure_time" : "12:50:59" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "12:53:51" , 
"departure_time" : "12:53:56" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "12:59:05" , 
"departure_time" : "12:59:15" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "13:07:10" , 
"departure_time" : "13:07:10" , 
"distance_traveled" : 15.693
} ], 
"3329" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "21:45:00" , 
"departure_time" : "21:45:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "21:49:09" , 
"departure_time" : "21:50:11" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "21:54:02" , 
"departure_time" : "21:55:30" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "21:58:28" , 
"departure_time" : "21:59:37" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "22:01:09" , 
"departure_time" : "22:01:45" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "22:04:36" , 
"departure_time" : "22:04:40" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "22:07:04" , 
"departure_time" : "22:08:30" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "22:12:26" , 
"departure_time" : "22:12:48" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "22:17:22" , 
"departure_time" : "22:18:08" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "22:26:46" , 
"departure_time" : "22:26:46" , 
"distance_traveled" : 15.693
} ], 
"3330" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "14:26:00" , 
"departure_time" : "14:28:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "14:31:32" , 
"departure_time" : "14:32:13" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "14:34:41" , 
"departure_time" : "14:35:29" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "14:38:48" , 
"departure_time" : "14:38:50" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "14:41:02" , 
"departure_time" : "14:42:25" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "14:46:23" , 
"departure_time" : "14:46:35" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "14:49:12" , 
"departure_time" : "14:49:35" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "14:53:23" , 
"departure_time" : "14:53:29" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "15:02:06" , 
"departure_time" : "15:03:26" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "15:12:20" , 
"departure_time" : "15:12:20" , 
"distance_traveled" : 15.693
} ], 
"3331" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "22:47:00" , 
"departure_time" : "22:49:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "22:51:47" , 
"departure_time" : "22:53:02" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "22:56:15" , 
"departure_time" : "22:56:59" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "22:59:44" , 
"departure_time" : "23:00:51" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "23:03:07" , 
"departure_time" : "23:04:33" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "23:07:26" , 
"departure_time" : "23:08:08" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "23:09:42" , 
"departure_time" : "23:11:13" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "23:14:31" , 
"departure_time" : "23:16:08" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "23:20:37" , 
"departure_time" : "23:20:41" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "23:28:04" , 
"departure_time" : "23:28:04" , 
"distance_traveled" : 15.693
} ], 
"3332" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "16:23:00" , 
"departure_time" : "16:23:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "16:27:02" , 
"departure_time" : "16:27:33" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "16:31:31" , 
"departure_time" : "16:32:25" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "16:35:54" , 
"departure_time" : "16:36:16" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "16:38:22" , 
"departure_time" : "16:38:31" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "16:42:09" , 
"departure_time" : "16:42:16" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "16:46:07" , 
"departure_time" : "16:47:08" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "16:51:01" , 
"departure_time" : "16:52:30" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "16:58:29" , 
"departure_time" : "17:00:07" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "17:03:38" , 
"departure_time" : "17:03:38" , 
"distance_traveled" : 15.693
} ], 
"3333" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "07:24:00" , 
"departure_time" : "07:25:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "07:28:13" , 
"departure_time" : "07:28:59" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "07:32:46" , 
"departure_time" : "07:34:01" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "07:37:15" , 
"departure_time" : "07:38:10" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "07:39:55" , 
"departure_time" : "07:40:44" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "07:43:49" , 
"departure_time" : "07:44:24" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "07:47:35" , 
"departure_time" : "07:47:49" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "07:51:14" , 
"departure_time" : "07:52:45" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "07:57:31" , 
"departure_time" : "07:58:42" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "08:04:11" , 
"departure_time" : "08:04:11" , 
"distance_traveled" : 15.693
} ], 
"3334" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "17:14:00" , 
"departure_time" : "17:15:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "17:18:33" , 
"departure_time" : "17:19:55" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "17:23:22" , 
"departure_time" : "17:23:28" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "17:26:06" , 
"departure_time" : "17:26:36" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "17:29:30" , 
"departure_time" : "17:30:13" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "17:33:43" , 
"departure_time" : "17:33:44" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "17:37:01" , 
"departure_time" : "17:38:08" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "17:42:07" , 
"departure_time" : "17:42:47" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "17:48:40" , 
"departure_time" : "17:49:04" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "17:53:24" , 
"departure_time" : "17:53:24" , 
"distance_traveled" : 15.693
} ], 
"3335" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "08:45:00" , 
"departure_time" : "08:45:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "08:49:16" , 
"departure_time" : "08:49:29" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "08:53:13" , 
"departure_time" : "08:53:49" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "08:57:36" , 
"departure_time" : "08:58:22" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "09:00:46" , 
"departure_time" : "09:00:47" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "09:04:01" , 
"departure_time" : "09:05:21" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "09:09:20" , 
"departure_time" : "09:09:58" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "09:12:38" , 
"departure_time" : "09:14:15" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "09:18:37" , 
"departure_time" : "09:19:09" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "09:28:32" , 
"departure_time" : "09:28:32" , 
"distance_traveled" : 15.693
} ], 
"3336" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "19:07:00" , 
"departure_time" : "19:07:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "19:12:03" , 
"departure_time" : "19:12:12" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "19:16:09" , 
"departure_time" : "19:17:32" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "19:20:23" , 
"departure_time" : "19:21:26" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "19:23:03" , 
"departure_time" : "19:23:20" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "19:26:17" , 
"departure_time" : "19:27:41" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "19:31:24" , 
"departure_time" : "19:31:33" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "19:34:09" , 
"departure_time" : "19:35:19" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "19:41:10" , 
"departure_time" : "19:42:25" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "19:47:15" , 
"departure_time" : "19:47:15" , 
"distance_traveled" : 15.693
} ], 
"3337" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "09:26:00" , 
"departure_time" : "09:28:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "09:30:46" , 
"departure_time" : "09:32:20" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "09:35:34" , 
"departure_time" : "09:36:06" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "09:38:32" , 
"departure_time" : "09:39:04" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "09:41:32" , 
"departure_time" : "09:42:22" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "09:45:50" , 
"departure_time" : "09:45:51" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "09:49:01" , 
"departure_time" : "09:50:37" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "09:54:36" , 
"departure_time" : "09:55:07" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "09:59:31" , 
"departure_time" : "10:00:38" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "10:08:07" , 
"departure_time" : "10:08:07" , 
"distance_traveled" : 15.693
} ], 
"3338" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "20:00:00" , 
"departure_time" : "20:02:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "20:04:58" , 
"departure_time" : "20:06:10" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "20:09:12" , 
"departure_time" : "20:10:35" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "20:13:23" , 
"departure_time" : "20:14:26" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "20:16:03" , 
"departure_time" : "20:16:14" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "20:19:11" , 
"departure_time" : "20:19:53" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "20:23:42" , 
"departure_time" : "20:24:19" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "20:27:37" , 
"departure_time" : "20:28:14" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "20:32:37" , 
"departure_time" : "20:33:53" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "20:42:16" , 
"departure_time" : "20:42:16" , 
"distance_traveled" : 15.693
} ], 
"3339" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "11:29:00" , 
"departure_time" : "11:30:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "11:33:39" , 
"departure_time" : "11:35:01" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "11:38:22" , 
"departure_time" : "11:39:45" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "11:42:23" , 
"departure_time" : "11:43:58" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "11:45:35" , 
"departure_time" : "11:46:25" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "11:48:50" , 
"departure_time" : "11:49:00" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "11:52:10" , 
"departure_time" : "11:52:55" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "11:56:45" , 
"departure_time" : "11:58:25" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "12:03:40" , 
"departure_time" : "12:04:20" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "12:10:40" , 
"departure_time" : "12:10:40" , 
"distance_traveled" : 15.693
} ], 
"3340" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "20:43:00" , 
"departure_time" : "20:44:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "20:47:46" , 
"departure_time" : "20:49:11" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "20:52:25" , 
"departure_time" : "20:52:35" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "20:55:10" , 
"departure_time" : "20:56:34" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "20:59:24" , 
"departure_time" : "21:00:06" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "21:02:42" , 
"departure_time" : "21:03:41" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "21:06:59" , 
"departure_time" : "21:08:14" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "21:11:15" , 
"departure_time" : "21:11:17" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "21:15:02" , 
"departure_time" : "21:15:34" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "21:24:32" , 
"departure_time" : "21:24:32" , 
"distance_traveled" : 15.693
} ], 
"3341" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "12:26:00" , 
"departure_time" : "12:27:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "12:30:38" , 
"departure_time" : "12:31:45" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "12:35:07" , 
"departure_time" : "12:35:39" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "12:38:32" , 
"departure_time" : "12:38:53" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "12:41:21" , 
"departure_time" : "12:42:35" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "12:46:14" , 
"departure_time" : "12:47:36" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "12:50:22" , 
"departure_time" : "12:51:03" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "12:53:41" , 
"departure_time" : "12:54:46" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "13:00:05" , 
"departure_time" : "13:00:18" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "13:07:13" , 
"departure_time" : "13:07:13" , 
"distance_traveled" : 15.693
} ], 
"3342" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "22:00:00" , 
"departure_time" : "22:01:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "22:04:49" , 
"departure_time" : "22:04:53" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "22:08:04" , 
"departure_time" : "22:09:32" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "22:13:28" , 
"departure_time" : "22:14:37" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "22:16:09" , 
"departure_time" : "22:17:19" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "22:20:10" , 
"departure_time" : "22:21:05" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "22:23:55" , 
"departure_time" : "22:24:29" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "22:27:34" , 
"departure_time" : "22:27:42" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "22:32:08" , 
"departure_time" : "22:32:46" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "22:41:38" , 
"departure_time" : "22:41:38" , 
"distance_traveled" : 15.693
} ], 
"3343" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "14:26:00" , 
"departure_time" : "14:27:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "14:30:37" , 
"departure_time" : "14:31:29" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "14:34:52" , 
"departure_time" : "14:35:55" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "14:39:03" , 
"departure_time" : "14:39:49" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "14:41:46" , 
"departure_time" : "14:43:25" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "14:46:39" , 
"departure_time" : "14:46:52" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "14:49:13" , 
"departure_time" : "14:49:22" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "14:53:09" , 
"departure_time" : "14:54:07" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "15:02:58" , 
"departure_time" : "15:03:41" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "15:11:43" , 
"departure_time" : "15:11:43" , 
"distance_traveled" : 15.693
} ], 
"3344" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "16:23:00" , 
"departure_time" : "16:24:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "16:27:51" , 
"departure_time" : "16:28:05" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "16:31:14" , 
"departure_time" : "16:31:44" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "16:35:30" , 
"departure_time" : "16:36:35" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "16:39:05" , 
"departure_time" : "16:39:13" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "16:42:08" , 
"departure_time" : "16:43:29" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "16:47:21" , 
"departure_time" : "16:48:44" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "16:51:23" , 
"departure_time" : "16:52:12" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "16:57:49" , 
"departure_time" : "16:59:04" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "17:03:15" , 
"departure_time" : "17:03:15" , 
"distance_traveled" : 15.693
} ], 
"3345" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "17:14:00" , 
"departure_time" : "17:16:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "17:18:48" , 
"departure_time" : "17:20:02" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "17:23:14" , 
"departure_time" : "17:23:29" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "17:26:15" , 
"departure_time" : "17:26:54" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "17:29:39" , 
"departure_time" : "17:30:31" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "17:33:52" , 
"departure_time" : "17:34:49" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "17:37:57" , 
"departure_time" : "17:39:01" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "17:42:04" , 
"departure_time" : "17:42:46" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "17:48:42" , 
"departure_time" : "17:49:12" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "17:53:30" , 
"departure_time" : "17:53:30" , 
"distance_traveled" : 15.693
} ], 
"3346" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "19:07:00" , 
"departure_time" : "19:08:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "19:13:18" , 
"departure_time" : "19:14:48" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "19:17:30" , 
"departure_time" : "19:18:58" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "19:20:28" , 
"departure_time" : "19:21:10" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "19:22:42" , 
"departure_time" : "19:24:16" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "19:27:34" , 
"departure_time" : "19:28:49" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "19:31:15" , 
"departure_time" : "19:32:06" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "19:34:51" , 
"departure_time" : "19:35:45" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "19:40:54" , 
"departure_time" : "19:41:48" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "19:46:54" , 
"departure_time" : "19:46:54" , 
"distance_traveled" : 15.693
} ], 
"3347" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "20:00:00" , 
"departure_time" : "20:02:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "20:05:39" , 
"departure_time" : "20:07:12" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "20:09:33" , 
"departure_time" : "20:11:06" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "20:13:33" , 
"departure_time" : "20:13:37" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "20:15:04" , 
"departure_time" : "20:16:07" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "20:20:03" , 
"departure_time" : "20:21:15" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "20:24:12" , 
"departure_time" : "20:25:14" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "20:28:02" , 
"departure_time" : "20:29:23" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "20:33:21" , 
"departure_time" : "20:33:58" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "20:41:37" , 
"departure_time" : "20:41:37" , 
"distance_traveled" : 15.693
} ], 
"3348" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "20:43:00" , 
"departure_time" : "20:44:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "20:47:52" , 
"departure_time" : "20:48:49" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "20:51:57" , 
"departure_time" : "20:52:21" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "20:55:24" , 
"departure_time" : "20:56:12" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "20:58:48" , 
"departure_time" : "21:00:10" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "21:03:22" , 
"departure_time" : "21:04:54" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "21:07:32" , 
"departure_time" : "21:08:55" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "21:11:23" , 
"departure_time" : "21:12:34" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "21:16:11" , 
"departure_time" : "21:16:50" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "21:24:39" , 
"departure_time" : "21:24:39" , 
"distance_traveled" : 15.693
} ], 
"3349" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "22:00:00" , 
"departure_time" : "22:01:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "22:05:07" , 
"departure_time" : "22:05:37" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "22:08:30" , 
"departure_time" : "22:09:35" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "22:13:05" , 
"departure_time" : "22:13:41" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "22:15:36" , 
"departure_time" : "22:17:06" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "22:20:30" , 
"departure_time" : "22:20:55" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "22:23:25" , 
"departure_time" : "22:24:55" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "22:28:30" , 
"departure_time" : "22:29:40" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "22:33:10" , 
"departure_time" : "22:33:13" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "22:41:03" , 
"departure_time" : "22:41:03" , 
"distance_traveled" : 15.693
} ], 
"3350" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "16:47:00" , 
"departure_time" : "16:48:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "16:57:02" , 
"departure_time" : "16:58:06" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:07:04" , 
"departure_time" : "17:07:51" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 127,
"arrival_time" : "17:19:47" , 
"departure_time" : "17:20:20" , 
"distance_traveled" : 20.7032
}, 
{ 
"stop_id" : 11,
"arrival_time" : "17:25:33" , 
"departure_time" : "17:27:10" , 
"distance_traveled" : 22.9835
}, 
{ 
"stop_id" : 158,
"arrival_time" : "17:30:37" , 
"departure_time" : "17:30:40" , 
"distance_traveled" : 24.4371
}, 
{ 
"stop_id" : 119,
"arrival_time" : "17:35:03" , 
"departure_time" : "17:36:38" , 
"distance_traveled" : 27.8553
}, 
{ 
"stop_id" : 139,
"arrival_time" : "17:41:35" , 
"departure_time" : "17:41:37" , 
"distance_traveled" : 29.7294
}, 
{ 
"stop_id" : 37169,
"arrival_time" : "17:49:02" , 
"departure_time" : "17:49:39" , 
"distance_traveled" : 35.1134
}, 
{ 
"stop_id" : 59,
"arrival_time" : "17:53:37" , 
"departure_time" : "17:53:52" , 
"distance_traveled" : 36.9008
}, 
{ 
"stop_id" : 85,
"arrival_time" : "17:59:15" , 
"departure_time" : "18:00:29" , 
"distance_traveled" : 41.3178
}, 
{ 
"stop_id" : 130,
"arrival_time" : "18:06:14" , 
"departure_time" : "18:07:21" , 
"distance_traveled" : 44.9403
}, 
{ 
"stop_id" : 73,
"arrival_time" : "18:10:07" , 
"departure_time" : "18:11:31" , 
"distance_traveled" : 47.2877
}, 
{ 
"stop_id" : 74,
"arrival_time" : "18:16:24" , 
"departure_time" : "18:17:25" , 
"distance_traveled" : 50.8055
}, 
{ 
"stop_id" : 40,
"arrival_time" : "18:21:01" , 
"departure_time" : "18:21:50" , 
"distance_traveled" : 53.0739
}, 
{ 
"stop_id" : 4,
"arrival_time" : "18:24:49" , 
"departure_time" : "18:25:49" , 
"distance_traveled" : 55.09
}, 
{ 
"stop_id" : 8,
"arrival_time" : "18:29:00" , 
"departure_time" : "18:29:40" , 
"distance_traveled" : 56.6843
}, 
{ 
"stop_id" : 22,
"arrival_time" : "18:31:40" , 
"departure_time" : "18:33:16" , 
"distance_traveled" : 57.5131
}, 
{ 
"stop_id" : 15,
"arrival_time" : "18:36:36" , 
"departure_time" : "18:37:59" , 
"distance_traveled" : 59.1699
}, 
{ 
"stop_id" : 141,
"arrival_time" : "18:40:23" , 
"departure_time" : "18:41:30" , 
"distance_traveled" : 61.2879
}, 
{ 
"stop_id" : 79,
"arrival_time" : "18:44:07" , 
"departure_time" : "18:44:15" , 
"distance_traveled" : 63.4625
}, 
{ 
"stop_id" : 122,
"arrival_time" : "18:48:08" , 
"departure_time" : "18:49:33" , 
"distance_traveled" : 65.4178
}, 
{ 
"stop_id" : 13,
"arrival_time" : "18:57:25" , 
"departure_time" : "18:57:25" , 
"distance_traveled" : 66.4981
} ], 
"3351" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "24:47:00" , 
"departure_time" : "24:49:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "24:52:06" , 
"departure_time" : "24:53:29" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "24:56:23" , 
"departure_time" : "24:56:36" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "24:59:13" , 
"departure_time" : "25:00:33" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "25:03:20" , 
"departure_time" : "25:03:27" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "25:06:07" , 
"departure_time" : "25:07:16" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "25:10:09" , 
"departure_time" : "25:11:22" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "25:14:13" , 
"departure_time" : "25:15:09" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "25:19:56" , 
"departure_time" : "25:20:14" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "25:28:18" , 
"departure_time" : "25:28:18" , 
"distance_traveled" : 15.693
} ], 
"3352" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "08:35:00" , 
"departure_time" : "08:35:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "08:39:14" , 
"departure_time" : "08:40:27" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "08:44:13" , 
"departure_time" : "08:44:54" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "08:47:41" , 
"departure_time" : "08:48:52" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "08:51:11" , 
"departure_time" : "08:52:14" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "08:55:03" , 
"departure_time" : "08:55:51" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "08:57:48" , 
"departure_time" : "08:58:44" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "09:01:56" , 
"departure_time" : "09:02:25" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "09:10:29" , 
"departure_time" : "09:11:05" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "09:19:36" , 
"departure_time" : "09:19:36" , 
"distance_traveled" : 15.693
} ], 
"3353" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "10:36:00" , 
"departure_time" : "10:38:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "10:41:40" , 
"departure_time" : "10:42:40" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "10:45:00" , 
"departure_time" : "10:46:00" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "10:49:00" , 
"departure_time" : "10:49:53" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "10:51:53" , 
"departure_time" : "10:51:55" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "10:55:02" , 
"departure_time" : "10:56:11" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "10:59:09" , 
"departure_time" : "10:59:22" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "11:02:13" , 
"departure_time" : "11:02:23" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "11:11:10" , 
"departure_time" : "11:12:24" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "11:21:14" , 
"departure_time" : "11:21:14" , 
"distance_traveled" : 15.693
} ], 
"3354" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "12:40:00" , 
"departure_time" : "12:42:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "12:45:28" , 
"departure_time" : "12:45:51" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "12:48:23" , 
"departure_time" : "12:50:01" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "12:53:38" , 
"departure_time" : "12:54:38" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "12:56:00" , 
"departure_time" : "12:57:11" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "13:00:11" , 
"departure_time" : "13:01:46" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "13:03:35" , 
"departure_time" : "13:05:11" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "13:07:36" , 
"departure_time" : "13:07:56" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "13:15:20" , 
"departure_time" : "13:16:38" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "13:25:18" , 
"departure_time" : "13:25:18" , 
"distance_traveled" : 15.693
} ], 
"3355" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "14:51:00" , 
"departure_time" : "14:53:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "14:55:52" , 
"departure_time" : "14:57:12" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "15:00:20" , 
"departure_time" : "15:00:22" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "15:03:02" , 
"departure_time" : "15:04:14" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "15:07:12" , 
"departure_time" : "15:07:24" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "15:10:12" , 
"departure_time" : "15:11:11" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "15:13:59" , 
"departure_time" : "15:15:06" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "15:18:07" , 
"departure_time" : "15:19:13" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "15:27:06" , 
"departure_time" : "15:28:43" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "15:36:37" , 
"departure_time" : "15:36:37" , 
"distance_traveled" : 15.693
} ], 
"3356" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "16:51:00" , 
"departure_time" : "16:53:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "16:55:59" , 
"departure_time" : "16:57:37" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "17:00:38" , 
"departure_time" : "17:01:46" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "17:04:08" , 
"departure_time" : "17:05:36" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "17:07:28" , 
"departure_time" : "17:07:44" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "17:10:16" , 
"departure_time" : "17:10:48" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "17:13:32" , 
"departure_time" : "17:15:08" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "17:18:36" , 
"departure_time" : "17:18:41" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "17:26:05" , 
"departure_time" : "17:26:38" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "17:35:33" , 
"departure_time" : "17:35:33" , 
"distance_traveled" : 15.693
} ], 
"3357" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "18:51:00" , 
"departure_time" : "18:51:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "18:55:11" , 
"departure_time" : "18:56:50" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "19:00:39" , 
"departure_time" : "19:01:05" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "19:03:26" , 
"departure_time" : "19:04:34" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "19:07:08" , 
"departure_time" : "19:07:19" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "19:10:11" , 
"departure_time" : "19:10:25" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "19:13:14" , 
"departure_time" : "19:13:28" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "19:17:14" , 
"departure_time" : "19:17:26" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "19:26:12" , 
"departure_time" : "19:27:08" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "19:35:56" , 
"departure_time" : "19:35:56" , 
"distance_traveled" : 15.693
} ], 
"3358" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "19:51:00" , 
"departure_time" : "19:53:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "19:56:31" , 
"departure_time" : "19:56:56" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "19:59:25" , 
"departure_time" : "20:01:03" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "20:04:38" , 
"departure_time" : "20:05:07" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "20:06:29" , 
"departure_time" : "20:07:55" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "20:11:26" , 
"departure_time" : "20:11:28" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "20:13:02" , 
"departure_time" : "20:13:52" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "20:17:50" , 
"departure_time" : "20:19:02" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "20:27:12" , 
"departure_time" : "20:28:05" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "20:35:53" , 
"departure_time" : "20:35:53" , 
"distance_traveled" : 15.693
} ], 
"3359" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "21:45:00" , 
"departure_time" : "21:46:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "21:49:46" , 
"departure_time" : "21:50:11" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "21:53:25" , 
"departure_time" : "21:53:37" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "21:57:12" , 
"departure_time" : "21:58:08" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "22:00:56" , 
"departure_time" : "22:01:03" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "22:04:07" , 
"departure_time" : "22:04:21" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "22:07:14" , 
"departure_time" : "22:08:06" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "22:11:52" , 
"departure_time" : "22:12:09" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "22:17:17" , 
"departure_time" : "22:18:42" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "22:27:25" , 
"departure_time" : "22:27:25" , 
"distance_traveled" : 15.693
} ], 
"3360" :  [ 
{ 
"stop_id" : 74,
"arrival_time" : "22:47:00" , 
"departure_time" : "22:48:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 40,
"arrival_time" : "22:51:23" , 
"departure_time" : "22:52:16" , 
"distance_traveled" : 2.2687
}, 
{ 
"stop_id" : 4,
"arrival_time" : "22:55:53" , 
"departure_time" : "22:56:43" , 
"distance_traveled" : 4.2848
}, 
{ 
"stop_id" : 8,
"arrival_time" : "22:59:50" , 
"departure_time" : "23:00:55" , 
"distance_traveled" : 5.8792
}, 
{ 
"stop_id" : 22,
"arrival_time" : "23:03:05" , 
"departure_time" : "23:03:28" , 
"distance_traveled" : 6.708
}, 
{ 
"stop_id" : 15,
"arrival_time" : "23:06:23" , 
"departure_time" : "23:07:52" , 
"distance_traveled" : 8.3648
}, 
{ 
"stop_id" : 141,
"arrival_time" : "23:10:29" , 
"departure_time" : "23:11:56" , 
"distance_traveled" : 10.4828
}, 
{ 
"stop_id" : 79,
"arrival_time" : "23:14:27" , 
"departure_time" : "23:14:58" , 
"distance_traveled" : 12.6574
}, 
{ 
"stop_id" : 122,
"arrival_time" : "23:19:31" , 
"departure_time" : "23:20:45" , 
"distance_traveled" : 14.6127
}, 
{ 
"stop_id" : 13,
"arrival_time" : "23:29:14" , 
"departure_time" : "23:29:14" , 
"distance_traveled" : 15.693
} ], 
"3361" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "23:15:00" , 
"departure_time" : "23:16:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "23:17:42" , 
"departure_time" : "23:18:00" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "23:21:18" , 
"departure_time" : "23:21:28" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "23:23:10" , 
"departure_time" : "23:23:39" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "23:25:29" , 
"departure_time" : "23:25:33" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "23:27:04" , 
"departure_time" : "23:27:27" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "23:29:23" , 
"departure_time" : "23:29:48" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "23:30:25" , 
"departure_time" : "23:30:57" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "23:31:32" , 
"departure_time" : "23:32:47" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "23:33:15" , 
"departure_time" : "23:34:30" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "23:34:15" , 
"departure_time" : "23:34:25" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "23:35:10" , 
"departure_time" : "23:35:10" , 
"distance_traveled" : 4.8572
} ], 
"3362" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "23:35:00" , 
"departure_time" : "23:36:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "23:38:06" , 
"departure_time" : "23:38:28" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "23:41:22" , 
"departure_time" : "23:42:32" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "23:44:10" , 
"departure_time" : "23:44:54" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "23:45:44" , 
"departure_time" : "23:45:47" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "23:47:03" , 
"departure_time" : "23:48:04" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "23:50:01" , 
"departure_time" : "23:51:12" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "23:51:11" , 
"departure_time" : "23:52:33" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "23:52:22" , 
"departure_time" : "23:53:40" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "23:53:18" , 
"departure_time" : "23:54:39" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "23:54:21" , 
"departure_time" : "23:55:30" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "23:56:09" , 
"departure_time" : "23:56:09" , 
"distance_traveled" : 4.8572
} ], 
"3363" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "23:55:00" , 
"departure_time" : "23:56:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "23:57:44" , 
"departure_time" : "23:58:04" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "24:01:20" , 
"departure_time" : "24:01:40" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "24:03:20" , 
"departure_time" : "24:04:38" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "24:06:18" , 
"departure_time" : "24:07:36" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "24:08:18" , 
"departure_time" : "24:08:30" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "24:09:12" , 
"departure_time" : "24:10:01" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "24:10:49" , 
"departure_time" : "24:12:22" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "24:12:33" , 
"departure_time" : "24:13:51" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "24:13:18" , 
"departure_time" : "24:14:18" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "24:14:00" , 
"departure_time" : "24:15:21" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "24:16:21" , 
"departure_time" : "24:16:21" , 
"distance_traveled" : 4.8572
} ], 
"3364" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "24:15:00" , 
"departure_time" : "24:16:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "24:17:26" , 
"departure_time" : "24:18:15" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "24:21:49" , 
"departure_time" : "24:21:51" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "24:23:02" , 
"departure_time" : "24:24:21" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "24:26:19" , 
"departure_time" : "24:27:41" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "24:28:22" , 
"departure_time" : "24:28:33" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "24:29:11" , 
"departure_time" : "24:30:34" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "24:31:23" , 
"departure_time" : "24:32:59" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "24:32:36" , 
"departure_time" : "24:33:28" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "24:32:52" , 
"departure_time" : "24:33:17" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "24:33:25" , 
"departure_time" : "24:34:35" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "24:36:10" , 
"departure_time" : "24:36:10" , 
"distance_traveled" : 4.8572
} ], 
"3365" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "24:35:00" , 
"departure_time" : "24:36:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "24:37:48" , 
"departure_time" : "24:38:05" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "24:41:17" , 
"departure_time" : "24:42:38" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "24:44:21" , 
"departure_time" : "24:45:57" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "24:46:36" , 
"departure_time" : "24:47:24" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "24:47:48" , 
"departure_time" : "24:48:23" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "24:49:35" , 
"departure_time" : "24:49:47" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "24:50:12" , 
"departure_time" : "24:51:09" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "24:51:57" , 
"departure_time" : "24:53:35" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "24:53:38" , 
"departure_time" : "24:54:22" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "24:53:44" , 
"departure_time" : "24:54:22" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "24:55:38" , 
"departure_time" : "24:55:38" , 
"distance_traveled" : 4.8572
} ], 
"3366" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "24:55:00" , 
"departure_time" : "24:56:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "24:58:13" , 
"departure_time" : "24:59:19" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "25:02:06" , 
"departure_time" : "25:02:18" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "25:03:12" , 
"departure_time" : "25:03:17" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "25:05:05" , 
"departure_time" : "25:05:06" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "25:07:01" , 
"departure_time" : "25:07:16" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "25:09:15" , 
"departure_time" : "25:10:26" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "25:11:11" , 
"departure_time" : "25:12:11" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "25:12:00" , 
"departure_time" : "25:13:26" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "25:13:26" , 
"departure_time" : "25:14:09" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "25:13:43" , 
"departure_time" : "25:15:00" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "25:16:17" , 
"departure_time" : "25:16:17" , 
"distance_traveled" : 4.8572
} ], 
"3367" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "04:55:00" , 
"departure_time" : "04:57:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "04:57:52" , 
"departure_time" : "04:58:17" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "05:01:25" , 
"departure_time" : "05:01:26" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "05:03:01" , 
"departure_time" : "05:03:49" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "05:05:48" , 
"departure_time" : "05:05:58" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "05:07:10" , 
"departure_time" : "05:07:25" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "05:09:15" , 
"departure_time" : "05:09:41" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "05:10:26" , 
"departure_time" : "05:11:21" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "05:11:55" , 
"departure_time" : "05:12:41" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "05:12:46" , 
"departure_time" : "05:13:03" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "05:13:17" , 
"departure_time" : "05:14:06" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "05:15:49" , 
"departure_time" : "05:17:08" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "05:19:19" , 
"departure_time" : "05:19:54" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "05:21:35" , 
"departure_time" : "05:23:04" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "05:24:29" , 
"departure_time" : "05:25:03" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "05:24:34" , 
"departure_time" : "05:26:10" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "05:27:36" , 
"departure_time" : "05:27:36" , 
"distance_traveled" : 6.06
} ], 
"3368" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "05:15:00" , 
"departure_time" : "05:18:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "05:18:24" , 
"departure_time" : "05:19:20" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "05:21:56" , 
"departure_time" : "05:22:17" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "05:23:21" , 
"departure_time" : "05:24:56" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "05:26:35" , 
"departure_time" : "05:27:09" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "05:27:34" , 
"departure_time" : "05:29:00" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "05:30:26" , 
"departure_time" : "05:30:43" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "05:30:17" , 
"departure_time" : "05:31:17" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "05:32:00" , 
"departure_time" : "05:32:02" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "05:32:02" , 
"departure_time" : "05:32:37" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "05:33:35" , 
"departure_time" : "05:34:47" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "05:36:12" , 
"departure_time" : "05:36:29" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "05:38:17" , 
"departure_time" : "05:39:06" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "05:41:49" , 
"departure_time" : "05:42:14" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "05:43:25" , 
"departure_time" : "05:43:42" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "05:44:17" , 
"departure_time" : "05:45:16" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "05:46:59" , 
"departure_time" : "05:46:59" , 
"distance_traveled" : 6.06
} ], 
"3369" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "05:35:00" , 
"departure_time" : "05:37:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "05:38:02" , 
"departure_time" : "05:38:40" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "05:41:38" , 
"departure_time" : "05:42:13" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "05:43:35" , 
"departure_time" : "05:44:26" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "05:45:51" , 
"departure_time" : "05:46:53" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "05:48:02" , 
"departure_time" : "05:49:33" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "05:50:31" , 
"departure_time" : "05:52:03" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "05:51:32" , 
"departure_time" : "05:51:33" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "05:51:01" , 
"departure_time" : "05:52:34" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "05:53:33" , 
"departure_time" : "05:53:43" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "05:53:10" , 
"departure_time" : "05:53:41" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "05:55:31" , 
"departure_time" : "05:56:49" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "05:59:18" , 
"departure_time" : "05:59:41" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "06:01:23" , 
"departure_time" : "06:02:39" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "06:04:16" , 
"departure_time" : "06:04:35" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "06:04:19" , 
"departure_time" : "06:04:30" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "06:06:11" , 
"departure_time" : "06:06:11" , 
"distance_traveled" : 6.06
} ], 
"3370" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "05:55:00" , 
"departure_time" : "05:56:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "05:58:08" , 
"departure_time" : "05:58:38" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "06:01:30" , 
"departure_time" : "06:02:04" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "06:03:34" , 
"departure_time" : "06:03:38" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "06:05:04" , 
"departure_time" : "06:06:32" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:08:28" , 
"departure_time" : "06:08:57" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:09:29" , 
"departure_time" : "06:10:23" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:10:54" , 
"departure_time" : "06:11:43" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:11:49" , 
"departure_time" : "06:12:06" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:12:17" , 
"departure_time" : "06:13:05" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:13:48" , 
"departure_time" : "06:14:41" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "06:15:53" , 
"departure_time" : "06:16:16" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "06:18:23" , 
"departure_time" : "06:19:25" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "06:22:02" , 
"departure_time" : "06:23:21" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "06:24:19" , 
"departure_time" : "06:24:46" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "06:24:27" , 
"departure_time" : "06:25:03" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "06:26:36" , 
"departure_time" : "06:26:36" , 
"distance_traveled" : 6.06
} ], 
"3371" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "06:15:00" , 
"departure_time" : "06:15:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "06:17:17" , 
"departure_time" : "06:18:19" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "06:22:02" , 
"departure_time" : "06:22:20" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "06:23:18" , 
"departure_time" : "06:24:54" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "06:26:36" , 
"departure_time" : "06:27:11" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:27:35" , 
"departure_time" : "06:28:46" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:30:11" , 
"departure_time" : "06:31:29" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:31:18" , 
"departure_time" : "06:32:06" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:31:48" , 
"departure_time" : "06:32:02" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:32:14" , 
"departure_time" : "06:33:36" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:34:22" , 
"departure_time" : "06:35:02" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "06:35:40" , 
"departure_time" : "06:35:57" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "06:38:17" , 
"departure_time" : "06:39:29" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "06:42:12" , 
"departure_time" : "06:42:24" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "06:43:12" , 
"departure_time" : "06:43:38" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "06:44:26" , 
"departure_time" : "06:45:06" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "06:46:40" , 
"departure_time" : "06:46:40" , 
"distance_traveled" : 6.06
} ], 
"3372" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "06:35:00" , 
"departure_time" : "06:36:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "06:37:53" , 
"departure_time" : "06:38:17" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "06:41:24" , 
"departure_time" : "06:41:33" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "06:43:09" , 
"departure_time" : "06:44:33" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "06:46:24" , 
"departure_time" : "06:47:02" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:47:38" , 
"departure_time" : "06:48:17" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:49:39" , 
"departure_time" : "06:50:14" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:50:35" , 
"departure_time" : "06:51:04" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:51:29" , 
"departure_time" : "06:51:53" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:52:24" , 
"departure_time" : "06:53:37" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:54:13" , 
"departure_time" : "06:54:37" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "06:55:24" , 
"departure_time" : "06:55:54" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "06:58:30" , 
"departure_time" : "06:59:28" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "07:01:58" , 
"departure_time" : "07:02:10" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "07:03:12" , 
"departure_time" : "07:04:41" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "07:05:29" , 
"departure_time" : "07:06:11" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "07:06:42" , 
"departure_time" : "07:06:42" , 
"distance_traveled" : 6.06
} ], 
"3373" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "06:55:00" , 
"departure_time" : "06:56:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "06:57:23" , 
"departure_time" : "06:57:41" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:01:18" , 
"departure_time" : "07:01:42" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:03:24" , 
"departure_time" : "07:04:03" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:05:39" , 
"departure_time" : "07:07:15" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:08:36" , 
"departure_time" : "07:08:37" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:09:01" , 
"departure_time" : "07:10:28" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:11:27" , 
"departure_time" : "07:11:47" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:11:20" , 
"departure_time" : "07:12:44" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:13:24" , 
"departure_time" : "07:14:47" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:14:23" , 
"departure_time" : "07:14:39" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:15:16" , 
"departure_time" : "07:15:39" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "07:18:23" , 
"departure_time" : "07:19:12" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "07:21:49" , 
"departure_time" : "07:23:03" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "07:24:14" , 
"departure_time" : "07:24:55" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "07:24:41" , 
"departure_time" : "07:26:19" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "07:27:38" , 
"departure_time" : "07:27:38" , 
"distance_traveled" : 6.06
} ], 
"3374" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "07:15:00" , 
"departure_time" : "07:17:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "07:18:04" , 
"departure_time" : "07:18:12" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:21:08" , 
"departure_time" : "07:22:41" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:24:33" , 
"departure_time" : "07:24:55" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:25:22" , 
"departure_time" : "07:26:12" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:27:50" , 
"departure_time" : "07:29:24" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:30:34" , 
"departure_time" : "07:32:09" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:31:35" , 
"departure_time" : "07:33:06" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:32:31" , 
"departure_time" : "07:33:08" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:32:37" , 
"departure_time" : "07:33:33" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:33:56" , 
"departure_time" : "07:34:51" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:35:55" , 
"departure_time" : "07:37:13" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "07:39:18" , 
"departure_time" : "07:40:39" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "07:42:21" , 
"departure_time" : "07:43:02" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "07:43:41" , 
"departure_time" : "07:45:05" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "07:45:24" , 
"departure_time" : "07:46:49" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "07:47:25" , 
"departure_time" : "07:47:25" , 
"distance_traveled" : 6.06
} ], 
"3375" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "07:35:00" , 
"departure_time" : "07:36:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "07:37:17" , 
"departure_time" : "07:37:37" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:41:20" , 
"departure_time" : "07:42:19" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:43:59" , 
"departure_time" : "07:45:06" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:46:07" , 
"departure_time" : "07:47:13" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:48:06" , 
"departure_time" : "07:49:25" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:50:19" , 
"departure_time" : "07:51:53" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:51:34" , 
"departure_time" : "07:53:12" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:52:38" , 
"departure_time" : "07:52:41" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:52:03" , 
"departure_time" : "07:52:28" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:53:25" , 
"departure_time" : "07:54:16" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:55:51" , 
"departure_time" : "07:57:13" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "07:59:22" , 
"departure_time" : "08:00:33" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "08:02:11" , 
"departure_time" : "08:03:37" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "08:04:26" , 
"departure_time" : "08:04:31" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "08:04:05" , 
"departure_time" : "08:05:45" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "08:07:40" , 
"departure_time" : "08:07:40" , 
"distance_traveled" : 6.06
} ], 
"3376" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "07:55:00" , 
"departure_time" : "07:57:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "07:57:24" , 
"departure_time" : "07:58:27" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:02:03" , 
"departure_time" : "08:02:56" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:03:53" , 
"departure_time" : "08:05:19" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:06:26" , 
"departure_time" : "08:07:21" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:07:55" , 
"departure_time" : "08:08:44" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:09:49" , 
"departure_time" : "08:11:08" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:11:19" , 
"departure_time" : "08:12:34" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:12:15" , 
"departure_time" : "08:13:07" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:12:52" , 
"departure_time" : "08:13:12" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:13:20" , 
"departure_time" : "08:14:09" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:15:49" , 
"departure_time" : "08:16:17" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "08:18:28" , 
"departure_time" : "08:20:02" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "08:22:34" , 
"departure_time" : "08:23:23" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "08:23:49" , 
"departure_time" : "08:24:32" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "08:24:43" , 
"departure_time" : "08:25:46" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "08:27:03" , 
"departure_time" : "08:27:03" , 
"distance_traveled" : 6.06
} ], 
"3377" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "08:15:00" , 
"departure_time" : "08:16:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "08:17:36" , 
"departure_time" : "08:17:44" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:21:08" , 
"departure_time" : "08:22:40" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:24:32" , 
"departure_time" : "08:25:51" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:26:19" , 
"departure_time" : "08:26:42" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:27:23" , 
"departure_time" : "08:28:25" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:30:02" , 
"departure_time" : "08:30:44" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:30:42" , 
"departure_time" : "08:30:46" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:31:04" , 
"departure_time" : "08:31:23" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:32:19" , 
"departure_time" : "08:33:53" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:34:34" , 
"departure_time" : "08:34:37" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:35:03" , 
"departure_time" : "08:35:14" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "08:38:11" , 
"departure_time" : "08:38:53" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "08:41:42" , 
"departure_time" : "08:42:53" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "08:44:11" , 
"departure_time" : "08:45:41" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "08:45:30" , 
"departure_time" : "08:45:58" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "08:46:28" , 
"departure_time" : "08:46:28" , 
"distance_traveled" : 6.06
} ], 
"3378" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "08:35:00" , 
"departure_time" : "08:35:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "08:37:07" , 
"departure_time" : "08:38:18" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:42:11" , 
"departure_time" : "08:42:42" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:43:31" , 
"departure_time" : "08:44:47" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:46:16" , 
"departure_time" : "08:47:29" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:48:13" , 
"departure_time" : "08:49:46" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:50:33" , 
"departure_time" : "08:51:43" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:51:10" , 
"departure_time" : "08:51:38" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:51:28" , 
"departure_time" : "08:52:51" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:53:23" , 
"departure_time" : "08:54:44" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:54:21" , 
"departure_time" : "08:55:09" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:55:48" , 
"departure_time" : "08:55:49" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "08:58:01" , 
"departure_time" : "08:58:02" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "09:01:01" , 
"departure_time" : "09:01:11" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "09:03:10" , 
"departure_time" : "09:03:53" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "09:04:43" , 
"departure_time" : "09:05:27" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "09:06:44" , 
"departure_time" : "09:06:44" , 
"distance_traveled" : 6.06
} ], 
"3379" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "08:55:00" , 
"departure_time" : "08:57:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "08:58:28" , 
"departure_time" : "08:59:11" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:01:43" , 
"departure_time" : "09:02:55" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:04:12" , 
"departure_time" : "09:05:06" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:05:54" , 
"departure_time" : "09:07:14" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:08:20" , 
"departure_time" : "09:09:22" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:10:02" , 
"departure_time" : "09:10:21" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:10:19" , 
"departure_time" : "09:11:39" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:12:20" , 
"departure_time" : "09:13:30" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:13:10" , 
"departure_time" : "09:13:51" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:13:41" , 
"departure_time" : "09:13:56" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "09:15:15" , 
"departure_time" : "09:15:53" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "09:18:38" , 
"departure_time" : "09:19:42" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "09:22:04" , 
"departure_time" : "09:23:01" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "09:23:57" , 
"departure_time" : "09:24:56" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "09:24:59" , 
"departure_time" : "09:25:55" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "09:26:56" , 
"departure_time" : "09:26:56" , 
"distance_traveled" : 6.06
} ], 
"3380" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "09:15:00" , 
"departure_time" : "09:16:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "09:17:11" , 
"departure_time" : "09:18:06" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:21:55" , 
"departure_time" : "09:22:22" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:23:27" , 
"departure_time" : "09:23:51" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:25:24" , 
"departure_time" : "09:25:53" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:27:29" , 
"departure_time" : "09:27:39" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:29:10" , 
"departure_time" : "09:30:46" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:31:36" , 
"departure_time" : "09:32:34" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:31:58" , 
"departure_time" : "09:32:48" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:32:50" , 
"departure_time" : "09:32:59" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:33:09" , 
"departure_time" : "09:34:35" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "09:36:26" , 
"departure_time" : "09:36:28" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "09:38:02" , 
"departure_time" : "09:39:20" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "09:42:18" , 
"departure_time" : "09:42:23" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "09:43:05" , 
"departure_time" : "09:44:34" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "09:45:29" , 
"departure_time" : "09:47:08" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "09:47:39" , 
"departure_time" : "09:47:39" , 
"distance_traveled" : 6.06
} ], 
"3381" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "09:35:00" , 
"departure_time" : "09:37:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "09:37:47" , 
"departure_time" : "09:39:15" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:42:28" , 
"departure_time" : "09:43:14" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:43:46" , 
"departure_time" : "09:44:19" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:45:33" , 
"departure_time" : "09:46:02" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:47:29" , 
"departure_time" : "09:47:58" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:49:29" , 
"departure_time" : "09:51:04" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:51:35" , 
"departure_time" : "09:52:28" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:51:53" , 
"departure_time" : "09:52:52" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:52:59" , 
"departure_time" : "09:53:15" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:53:16" , 
"departure_time" : "09:54:14" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "09:55:58" , 
"departure_time" : "09:56:49" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "09:58:51" , 
"departure_time" : "09:59:46" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "10:01:55" , 
"departure_time" : "10:02:14" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "10:03:19" , 
"departure_time" : "10:04:08" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "10:04:49" , 
"departure_time" : "10:05:56" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "10:07:07" , 
"departure_time" : "10:07:07" , 
"distance_traveled" : 6.06
} ], 
"3382" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "09:55:00" , 
"departure_time" : "09:56:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "09:57:10" , 
"departure_time" : "09:58:06" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "10:01:56" , 
"departure_time" : "10:03:10" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "10:04:14" , 
"departure_time" : "10:04:32" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "10:05:18" , 
"departure_time" : "10:05:52" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "10:07:34" , 
"departure_time" : "10:08:10" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "10:09:36" , 
"departure_time" : "10:10:26" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "10:10:50" , 
"departure_time" : "10:11:30" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "10:11:40" , 
"departure_time" : "10:12:41" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "10:13:01" , 
"departure_time" : "10:13:36" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "10:13:35" , 
"departure_time" : "10:14:07" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "10:15:32" , 
"departure_time" : "10:16:31" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "10:18:59" , 
"departure_time" : "10:19:58" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "10:21:59" , 
"departure_time" : "10:23:09" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "10:24:10" , 
"departure_time" : "10:24:44" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "10:24:34" , 
"departure_time" : "10:25:35" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "10:27:01" , 
"departure_time" : "10:27:01" , 
"distance_traveled" : 6.06
} ], 
"3383" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "10:15:00" , 
"departure_time" : "10:16:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "10:17:31" , 
"departure_time" : "10:18:56" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "10:22:25" , 
"departure_time" : "10:22:28" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "10:23:03" , 
"departure_time" : "10:24:03" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "10:26:00" , 
"departure_time" : "10:27:21" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "10:28:21" , 
"departure_time" : "10:28:29" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "10:29:08" , 
"departure_time" : "10:30:47" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "10:31:39" , 
"departure_time" : "10:31:45" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "10:31:06" , 
"departure_time" : "10:31:45" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "10:32:39" , 
"departure_time" : "10:33:52" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "10:34:13" , 
"departure_time" : "10:34:28" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "10:35:15" , 
"departure_time" : "10:36:02" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "10:38:47" , 
"departure_time" : "10:38:55" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "10:41:08" , 
"departure_time" : "10:41:33" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "10:43:25" , 
"departure_time" : "10:44:36" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "10:45:11" , 
"departure_time" : "10:46:21" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "10:47:10" , 
"departure_time" : "10:47:10" , 
"distance_traveled" : 6.06
} ], 
"3384" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "10:35:00" , 
"departure_time" : "10:37:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "10:38:32" , 
"departure_time" : "10:38:43" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "10:41:11" , 
"departure_time" : "10:41:25" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "10:43:14" , 
"departure_time" : "10:44:51" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "10:46:37" , 
"departure_time" : "10:46:58" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "10:47:21" , 
"departure_time" : "10:48:10" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "10:49:49" , 
"departure_time" : "10:50:59" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "10:51:10" , 
"departure_time" : "10:51:19" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "10:51:09" , 
"departure_time" : "10:52:00" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "10:52:51" , 
"departure_time" : "10:53:36" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "10:53:45" , 
"departure_time" : "10:54:35" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "10:55:50" , 
"departure_time" : "10:57:25" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "10:59:35" , 
"departure_time" : "10:59:58" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "11:01:23" , 
"departure_time" : "11:01:56" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "11:03:33" , 
"departure_time" : "11:03:34" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "11:04:01" , 
"departure_time" : "11:05:25" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "11:07:24" , 
"departure_time" : "11:07:24" , 
"distance_traveled" : 6.06
} ], 
"3385" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "10:55:00" , 
"departure_time" : "10:57:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "10:57:36" , 
"departure_time" : "10:57:59" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "11:01:23" , 
"departure_time" : "11:02:00" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "11:03:37" , 
"departure_time" : "11:04:00" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "11:05:23" , 
"departure_time" : "11:06:00" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "11:07:37" , 
"departure_time" : "11:08:00" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "11:09:23" , 
"departure_time" : "11:09:46" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "11:10:23" , 
"departure_time" : "11:10:26" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "11:11:03" , 
"departure_time" : "11:12:19" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "11:13:16" , 
"departure_time" : "11:14:34" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "11:14:18" , 
"departure_time" : "11:15:24" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "11:16:06" , 
"departure_time" : "11:17:17" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "11:19:11" , 
"departure_time" : "11:20:04" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "11:21:53" , 
"departure_time" : "11:22:21" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "11:23:28" , 
"departure_time" : "11:23:37" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "11:24:09" , 
"departure_time" : "11:24:22" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "11:26:13" , 
"departure_time" : "11:26:13" , 
"distance_traveled" : 6.06
} ], 
"3386" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "11:15:00" , 
"departure_time" : "11:15:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "11:17:43" , 
"departure_time" : "11:18:44" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "11:22:01" , 
"departure_time" : "11:22:20" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "11:23:19" , 
"departure_time" : "11:24:51" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "11:26:32" , 
"departure_time" : "11:26:33" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "11:27:01" , 
"departure_time" : "11:27:27" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "11:29:26" , 
"departure_time" : "11:31:03" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "11:31:37" , 
"departure_time" : "11:31:48" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "11:31:11" , 
"departure_time" : "11:32:03" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "11:32:52" , 
"departure_time" : "11:33:08" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "11:33:16" , 
"departure_time" : "11:33:23" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "11:35:07" , 
"departure_time" : "11:36:34" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "11:39:27" , 
"departure_time" : "11:40:02" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "11:41:35" , 
"departure_time" : "11:42:34" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "11:43:59" , 
"departure_time" : "11:45:34" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "11:45:35" , 
"departure_time" : "11:46:09" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "11:46:34" , 
"departure_time" : "11:46:34" , 
"distance_traveled" : 6.06
} ], 
"3387" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "11:35:00" , 
"departure_time" : "11:35:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "11:37:24" , 
"departure_time" : "11:37:26" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "11:41:02" , 
"departure_time" : "11:41:44" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "11:43:42" , 
"departure_time" : "11:44:48" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "11:46:06" , 
"departure_time" : "11:47:28" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "11:48:22" , 
"departure_time" : "11:49:57" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "11:50:35" , 
"departure_time" : "11:51:34" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "11:50:59" , 
"departure_time" : "11:52:10" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "11:52:11" , 
"departure_time" : "11:52:55" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "11:52:44" , 
"departure_time" : "11:53:04" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "11:53:20" , 
"departure_time" : "11:54:41" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "11:56:21" , 
"departure_time" : "11:57:52" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "11:59:31" , 
"departure_time" : "12:00:12" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "12:01:41" , 
"departure_time" : "12:02:30" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "12:03:49" , 
"departure_time" : "12:05:19" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "12:05:30" , 
"departure_time" : "12:06:59" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "12:07:29" , 
"departure_time" : "12:07:29" , 
"distance_traveled" : 6.06
} ], 
"3388" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "11:55:00" , 
"departure_time" : "11:57:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "11:58:05" , 
"departure_time" : "11:58:43" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "12:01:38" , 
"departure_time" : "12:03:17" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "12:04:39" , 
"departure_time" : "12:05:39" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "12:06:00" , 
"departure_time" : "12:06:34" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "12:07:34" , 
"departure_time" : "12:07:48" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "12:09:14" , 
"departure_time" : "12:09:55" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "12:10:41" , 
"departure_time" : "12:11:59" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "12:12:18" , 
"departure_time" : "12:13:35" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "12:13:17" , 
"departure_time" : "12:13:53" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "12:13:36" , 
"departure_time" : "12:14:34" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "12:15:58" , 
"departure_time" : "12:16:05" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "12:18:07" , 
"departure_time" : "12:18:41" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "12:21:34" , 
"departure_time" : "12:21:43" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "12:23:09" , 
"departure_time" : "12:24:19" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "12:25:10" , 
"departure_time" : "12:26:17" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "12:27:07" , 
"departure_time" : "12:27:07" , 
"distance_traveled" : 6.06
} ], 
"3389" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "12:15:00" , 
"departure_time" : "12:17:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "12:18:26" , 
"departure_time" : "12:18:58" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "12:21:32" , 
"departure_time" : "12:22:01" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "12:23:29" , 
"departure_time" : "12:24:53" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "12:26:24" , 
"departure_time" : "12:26:48" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "12:27:24" , 
"departure_time" : "12:27:57" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "12:29:33" , 
"departure_time" : "12:30:07" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "12:30:34" , 
"departure_time" : "12:31:47" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "12:32:13" , 
"departure_time" : "12:33:10" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "12:32:57" , 
"departure_time" : "12:33:34" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "12:33:37" , 
"departure_time" : "12:35:00" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "12:36:23" , 
"departure_time" : "12:37:37" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "12:39:14" , 
"departure_time" : "12:40:40" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "12:42:26" , 
"departure_time" : "12:42:56" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "12:43:30" , 
"departure_time" : "12:44:28" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "12:44:58" , 
"departure_time" : "12:45:00" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "12:46:02" , 
"departure_time" : "12:46:02" , 
"distance_traveled" : 6.06
} ], 
"3390" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "12:35:00" , 
"departure_time" : "12:35:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "12:37:50" , 
"departure_time" : "12:39:16" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "12:42:26" , 
"departure_time" : "12:43:41" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "12:44:15" , 
"departure_time" : "12:45:23" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "12:46:08" , 
"departure_time" : "12:47:01" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "12:47:53" , 
"departure_time" : "12:48:58" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "12:50:05" , 
"departure_time" : "12:50:48" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "12:50:43" , 
"departure_time" : "12:50:44" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "12:51:01" , 
"departure_time" : "12:52:36" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "12:53:35" , 
"departure_time" : "12:53:51" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "12:53:16" , 
"departure_time" : "12:54:02" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "12:55:46" , 
"departure_time" : "12:56:27" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "12:58:41" , 
"departure_time" : "12:59:31" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "13:01:50" , 
"departure_time" : "13:02:50" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "13:04:00" , 
"departure_time" : "13:05:02" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "13:05:02" , 
"departure_time" : "13:05:15" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "13:06:13" , 
"departure_time" : "13:06:13" , 
"distance_traveled" : 6.06
} ], 
"3391" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "12:55:00" , 
"departure_time" : "12:56:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "12:57:56" , 
"departure_time" : "12:58:53" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "13:01:57" , 
"departure_time" : "13:03:21" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "13:04:24" , 
"departure_time" : "13:05:35" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "13:06:11" , 
"departure_time" : "13:06:17" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "13:07:06" , 
"departure_time" : "13:08:18" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "13:10:12" , 
"departure_time" : "13:10:24" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "13:10:12" , 
"departure_time" : "13:11:43" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "13:12:31" , 
"departure_time" : "13:12:50" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "13:12:19" , 
"departure_time" : "13:12:57" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "13:13:38" , 
"departure_time" : "13:14:14" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "13:15:36" , 
"departure_time" : "13:16:15" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "13:18:39" , 
"departure_time" : "13:20:11" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "13:22:32" , 
"departure_time" : "13:22:43" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "13:23:11" , 
"departure_time" : "13:24:02" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "13:24:51" , 
"departure_time" : "13:26:04" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "13:27:13" , 
"departure_time" : "13:27:13" , 
"distance_traveled" : 6.06
} ], 
"3392" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "13:15:00" , 
"departure_time" : "13:17:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "13:18:12" , 
"departure_time" : "13:19:29" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "13:22:17" , 
"departure_time" : "13:23:03" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "13:23:46" , 
"departure_time" : "13:25:19" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "13:26:33" , 
"departure_time" : "13:27:05" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "13:27:32" , 
"departure_time" : "13:28:21" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "13:29:49" , 
"departure_time" : "13:31:13" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "13:31:24" , 
"departure_time" : "13:32:21" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "13:31:57" , 
"departure_time" : "13:33:27" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "13:33:30" , 
"departure_time" : "13:34:53" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "13:34:23" , 
"departure_time" : "13:35:02" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "13:35:39" , 
"departure_time" : "13:35:53" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "13:38:14" , 
"departure_time" : "13:39:02" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "13:41:48" , 
"departure_time" : "13:42:14" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "13:43:26" , 
"departure_time" : "13:43:36" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "13:44:10" , 
"departure_time" : "13:45:14" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "13:47:04" , 
"departure_time" : "13:47:04" , 
"distance_traveled" : 6.06
} ], 
"3393" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "13:35:00" , 
"departure_time" : "13:37:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "13:38:05" , 
"departure_time" : "13:39:26" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "13:42:21" , 
"departure_time" : "13:43:01" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "13:43:40" , 
"departure_time" : "13:44:25" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "13:45:45" , 
"departure_time" : "13:46:02" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "13:47:17" , 
"departure_time" : "13:48:08" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "13:49:51" , 
"departure_time" : "13:50:15" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "13:50:24" , 
"departure_time" : "13:51:43" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "13:52:19" , 
"departure_time" : "13:53:59" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "13:53:40" , 
"departure_time" : "13:53:51" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "13:53:11" , 
"departure_time" : "13:53:50" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "13:55:39" , 
"departure_time" : "13:56:46" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "13:59:07" , 
"departure_time" : "13:59:18" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "14:01:11" , 
"departure_time" : "14:02:25" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "14:04:14" , 
"departure_time" : "14:04:34" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "14:04:20" , 
"departure_time" : "14:05:23" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "14:07:03" , 
"departure_time" : "14:07:03" , 
"distance_traveled" : 6.06
} ], 
"3394" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "13:55:00" , 
"departure_time" : "13:56:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "13:57:08" , 
"departure_time" : "13:58:17" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "14:02:09" , 
"departure_time" : "14:03:12" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "14:04:03" , 
"departure_time" : "14:04:49" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "14:05:46" , 
"departure_time" : "14:06:49" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "14:08:03" , 
"departure_time" : "14:09:32" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "14:10:29" , 
"departure_time" : "14:11:15" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "14:10:46" , 
"departure_time" : "14:11:39" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "14:11:53" , 
"departure_time" : "14:12:14" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "14:12:21" , 
"departure_time" : "14:13:56" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "14:14:35" , 
"departure_time" : "14:15:34" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "14:15:59" , 
"departure_time" : "14:16:52" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "14:18:53" , 
"departure_time" : "14:19:14" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "14:21:21" , 
"departure_time" : "14:21:31" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "14:23:10" , 
"departure_time" : "14:23:59" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "14:24:49" , 
"departure_time" : "14:26:13" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "14:27:24" , 
"departure_time" : "14:27:24" , 
"distance_traveled" : 6.06
} ], 
"3395" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "14:15:00" , 
"departure_time" : "14:17:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "14:18:33" , 
"departure_time" : "14:18:57" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "14:21:24" , 
"departure_time" : "14:22:41" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "14:24:17" , 
"departure_time" : "14:25:32" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "14:26:15" , 
"departure_time" : "14:27:02" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "14:27:47" , 
"departure_time" : "14:28:12" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "14:29:25" , 
"departure_time" : "14:29:58" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "14:30:33" , 
"departure_time" : "14:31:04" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "14:31:31" , 
"departure_time" : "14:31:58" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "14:32:27" , 
"departure_time" : "14:32:37" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "14:33:10" , 
"departure_time" : "14:33:11" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "14:35:01" , 
"departure_time" : "14:35:33" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "14:38:32" , 
"departure_time" : "14:38:38" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "14:41:06" , 
"departure_time" : "14:42:08" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "14:44:02" , 
"departure_time" : "14:45:06" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "14:45:04" , 
"departure_time" : "14:45:28" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "14:46:24" , 
"departure_time" : "14:46:24" , 
"distance_traveled" : 6.06
} ], 
"3396" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "14:35:00" , 
"departure_time" : "14:35:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "14:37:30" , 
"departure_time" : "14:39:01" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "14:42:31" , 
"departure_time" : "14:43:31" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "14:44:00" , 
"departure_time" : "14:44:57" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "14:45:57" , 
"departure_time" : "14:47:23" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "14:48:26" , 
"departure_time" : "14:48:46" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "14:49:20" , 
"departure_time" : "14:50:02" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "14:50:42" , 
"departure_time" : "14:51:06" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "14:51:24" , 
"departure_time" : "14:52:17" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "14:52:53" , 
"departure_time" : "14:53:42" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "14:53:49" , 
"departure_time" : "14:54:25" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "14:55:36" , 
"departure_time" : "14:56:33" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "14:58:57" , 
"departure_time" : "14:59:18" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "15:01:21" , 
"departure_time" : "15:01:46" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "15:03:25" , 
"departure_time" : "15:05:00" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "15:05:35" , 
"departure_time" : "15:05:37" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "15:06:02" , 
"departure_time" : "15:06:02" , 
"distance_traveled" : 6.06
} ], 
"3397" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "14:55:00" , 
"departure_time" : "14:55:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "14:57:15" , 
"departure_time" : "14:57:49" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "15:01:34" , 
"departure_time" : "15:03:08" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:04:34" , 
"departure_time" : "15:05:12" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:05:38" , 
"departure_time" : "15:06:17" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:07:39" , 
"departure_time" : "15:08:41" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:10:02" , 
"departure_time" : "15:10:10" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:10:08" , 
"departure_time" : "15:11:41" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:12:33" , 
"departure_time" : "15:13:33" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:13:00" , 
"departure_time" : "15:14:06" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:14:06" , 
"departure_time" : "15:15:26" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "15:16:20" , 
"departure_time" : "15:17:36" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "15:19:16" , 
"departure_time" : "15:19:46" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "15:21:30" , 
"departure_time" : "15:22:34" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "15:24:04" , 
"departure_time" : "15:24:12" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "15:24:08" , 
"departure_time" : "15:24:35" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "15:26:27" , 
"departure_time" : "15:26:27" , 
"distance_traveled" : 6.06
} ], 
"3398" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "15:15:00" , 
"departure_time" : "15:16:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "15:18:26" , 
"departure_time" : "15:18:35" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "15:21:09" , 
"departure_time" : "15:21:14" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:23:05" , 
"departure_time" : "15:23:45" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:25:40" , 
"departure_time" : "15:26:25" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:27:45" , 
"departure_time" : "15:28:22" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:29:37" , 
"departure_time" : "15:29:54" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:30:17" , 
"departure_time" : "15:30:50" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:31:33" , 
"departure_time" : "15:32:04" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:32:31" , 
"departure_time" : "15:32:49" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:33:18" , 
"departure_time" : "15:33:51" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "15:35:33" , 
"departure_time" : "15:36:03" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "15:38:30" , 
"departure_time" : "15:39:33" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "15:42:03" , 
"departure_time" : "15:43:03" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "15:44:00" , 
"departure_time" : "15:45:30" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "15:45:30" , 
"departure_time" : "15:45:48" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "15:46:18" , 
"departure_time" : "15:46:18" , 
"distance_traveled" : 6.06
} ], 
"3399" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "15:35:00" , 
"departure_time" : "15:36:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "15:37:57" , 
"departure_time" : "15:39:30" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "15:42:33" , 
"departure_time" : "15:42:45" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:43:12" , 
"departure_time" : "15:43:44" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:45:32" , 
"departure_time" : "15:45:58" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:47:26" , 
"departure_time" : "15:47:34" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:49:08" , 
"departure_time" : "15:50:20" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:51:12" , 
"departure_time" : "15:52:25" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:52:13" , 
"departure_time" : "15:52:42" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:52:29" , 
"departure_time" : "15:53:34" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:54:05" , 
"departure_time" : "15:54:34" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "15:55:29" , 
"departure_time" : "15:55:56" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "15:58:27" , 
"departure_time" : "15:58:54" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "16:01:27" , 
"departure_time" : "16:02:27" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "16:04:00" , 
"departure_time" : "16:04:52" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "16:04:52" , 
"departure_time" : "16:05:25" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "16:06:33" , 
"departure_time" : "16:06:33" , 
"distance_traveled" : 6.06
} ], 
"3400" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "15:55:00" , 
"departure_time" : "15:55:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "15:57:24" , 
"departure_time" : "15:58:06" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:01:42" , 
"departure_time" : "16:02:15" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:03:33" , 
"departure_time" : "16:04:27" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:05:54" , 
"departure_time" : "16:06:30" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:07:36" , 
"departure_time" : "16:07:48" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:09:12" , 
"departure_time" : "16:10:41" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:11:29" , 
"departure_time" : "16:12:39" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:12:10" , 
"departure_time" : "16:12:18" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:12:08" , 
"departure_time" : "16:13:11" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:14:03" , 
"departure_time" : "16:14:17" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:15:14" , 
"departure_time" : "16:16:51" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "16:19:37" , 
"departure_time" : "16:20:04" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "16:21:27" , 
"departure_time" : "16:22:56" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "16:24:29" , 
"departure_time" : "16:24:37" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "16:24:08" , 
"departure_time" : "16:25:39" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "16:27:31" , 
"departure_time" : "16:27:31" , 
"distance_traveled" : 6.06
} ], 
"3401" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "16:15:00" , 
"departure_time" : "16:16:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "16:17:01" , 
"departure_time" : "16:18:39" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:22:38" , 
"departure_time" : "16:23:26" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:23:48" , 
"departure_time" : "16:24:29" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:25:41" , 
"departure_time" : "16:26:07" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:27:26" , 
"departure_time" : "16:28:00" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:29:34" , 
"departure_time" : "16:31:01" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:31:27" , 
"departure_time" : "16:32:30" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:32:03" , 
"departure_time" : "16:32:12" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:32:09" , 
"departure_time" : "16:33:01" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:33:52" , 
"departure_time" : "16:34:38" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:35:46" , 
"departure_time" : "16:35:47" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "16:38:01" , 
"departure_time" : "16:39:26" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "16:42:25" , 
"departure_time" : "16:43:48" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "16:44:23" , 
"departure_time" : "16:44:25" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "16:44:02" , 
"departure_time" : "16:45:07" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "16:47:05" , 
"departure_time" : "16:47:05" , 
"distance_traveled" : 6.06
} ], 
"3402" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "16:35:00" , 
"departure_time" : "16:37:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "16:38:03" , 
"departure_time" : "16:38:39" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:41:36" , 
"departure_time" : "16:42:30" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:43:54" , 
"departure_time" : "16:44:19" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:45:25" , 
"departure_time" : "16:46:04" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:47:39" , 
"departure_time" : "16:49:03" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:50:24" , 
"departure_time" : "16:51:17" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:50:53" , 
"departure_time" : "16:51:32" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:51:39" , 
"departure_time" : "16:53:02" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:53:23" , 
"departure_time" : "16:54:43" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:54:20" , 
"departure_time" : "16:55:08" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:55:48" , 
"departure_time" : "16:56:07" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "16:58:19" , 
"departure_time" : "16:59:02" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "17:01:43" , 
"departure_time" : "17:03:11" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "17:04:28" , 
"departure_time" : "17:05:24" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "17:04:56" , 
"departure_time" : "17:05:02" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "17:06:06" , 
"departure_time" : "17:06:06" , 
"distance_traveled" : 6.06
} ], 
"3403" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "16:55:00" , 
"departure_time" : "16:55:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "16:57:36" , 
"departure_time" : "16:58:43" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:02:07" , 
"departure_time" : "17:02:59" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:03:52" , 
"departure_time" : "17:05:28" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:06:36" , 
"departure_time" : "17:07:02" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:07:26" , 
"departure_time" : "17:09:04" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:10:38" , 
"departure_time" : "17:11:43" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:11:05" , 
"departure_time" : "17:11:10" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:11:05" , 
"departure_time" : "17:11:18" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:12:13" , 
"departure_time" : "17:13:09" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:13:56" , 
"departure_time" : "17:15:20" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "17:16:24" , 
"departure_time" : "17:16:30" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "17:18:06" , 
"departure_time" : "17:19:30" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "17:22:24" , 
"departure_time" : "17:23:59" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "17:24:35" , 
"departure_time" : "17:24:40" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "17:24:05" , 
"departure_time" : "17:25:41" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "17:27:36" , 
"departure_time" : "17:27:36" , 
"distance_traveled" : 6.06
} ], 
"3404" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "17:15:00" , 
"departure_time" : "17:17:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "17:18:20" , 
"departure_time" : "17:19:36" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:22:16" , 
"departure_time" : "17:23:44" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:24:28" , 
"departure_time" : "17:24:34" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:25:06" , 
"departure_time" : "17:25:27" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:27:21" , 
"departure_time" : "17:28:30" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:30:09" , 
"departure_time" : "17:30:42" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:30:33" , 
"departure_time" : "17:32:09" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:32:36" , 
"departure_time" : "17:33:27" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:32:51" , 
"departure_time" : "17:33:01" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:33:10" , 
"departure_time" : "17:33:47" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "17:35:37" , 
"departure_time" : "17:37:10" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "17:39:33" , 
"departure_time" : "17:39:48" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "17:41:15" , 
"departure_time" : "17:42:46" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "17:44:31" , 
"departure_time" : "17:46:04" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "17:45:33" , 
"departure_time" : "17:45:46" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "17:46:13" , 
"departure_time" : "17:46:13" , 
"distance_traveled" : 6.06
} ], 
"3405" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "17:35:00" , 
"departure_time" : "17:35:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "17:37:20" , 
"departure_time" : "17:37:31" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:41:11" , 
"departure_time" : "17:42:47" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:44:36" , 
"departure_time" : "17:45:51" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:46:15" , 
"departure_time" : "17:47:48" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:48:33" , 
"departure_time" : "17:49:54" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:50:21" , 
"departure_time" : "17:51:43" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:51:22" , 
"departure_time" : "17:52:15" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:51:53" , 
"departure_time" : "17:52:09" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:52:16" , 
"departure_time" : "17:53:33" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:54:17" , 
"departure_time" : "17:55:13" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "17:55:56" , 
"departure_time" : "17:56:05" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "17:58:09" , 
"departure_time" : "17:58:41" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "18:01:32" , 
"departure_time" : "18:02:10" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "18:03:38" , 
"departure_time" : "18:04:37" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "18:04:59" , 
"departure_time" : "18:05:00" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "18:06:01" , 
"departure_time" : "18:06:01" , 
"distance_traveled" : 6.06
} ], 
"3406" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "17:55:00" , 
"departure_time" : "17:56:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "17:58:36" , 
"departure_time" : "17:59:20" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:01:44" , 
"departure_time" : "18:02:37" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:03:53" , 
"departure_time" : "18:05:07" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:06:14" , 
"departure_time" : "18:07:37" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:08:23" , 
"departure_time" : "18:09:09" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:09:46" , 
"departure_time" : "18:11:08" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:11:22" , 
"departure_time" : "18:12:48" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:12:26" , 
"departure_time" : "18:14:02" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:13:36" , 
"departure_time" : "18:14:59" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:14:23" , 
"departure_time" : "18:15:48" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:16:25" , 
"departure_time" : "18:18:03" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "18:19:38" , 
"departure_time" : "18:20:00" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "18:21:22" , 
"departure_time" : "18:22:25" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "18:24:03" , 
"departure_time" : "18:25:43" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "18:25:40" , 
"departure_time" : "18:27:13" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "18:27:33" , 
"departure_time" : "18:27:33" , 
"distance_traveled" : 6.06
} ], 
"3407" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "18:15:00" , 
"departure_time" : "18:17:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "18:18:15" , 
"departure_time" : "18:18:52" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:21:37" , 
"departure_time" : "18:21:40" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:23:03" , 
"departure_time" : "18:24:10" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:26:07" , 
"departure_time" : "18:27:44" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:28:37" , 
"departure_time" : "18:29:51" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:30:14" , 
"departure_time" : "18:30:47" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:30:33" , 
"departure_time" : "18:30:36" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:31:03" , 
"departure_time" : "18:32:15" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:33:12" , 
"departure_time" : "18:33:45" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:33:33" , 
"departure_time" : "18:34:39" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:36:06" , 
"departure_time" : "18:36:18" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "18:38:12" , 
"departure_time" : "18:39:31" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "18:42:19" , 
"departure_time" : "18:43:26" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "18:44:07" , 
"departure_time" : "18:44:49" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "18:44:42" , 
"departure_time" : "18:45:48" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "18:47:06" , 
"departure_time" : "18:47:06" , 
"distance_traveled" : 6.06
} ], 
"3408" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "18:35:00" , 
"departure_time" : "18:37:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "18:38:10" , 
"departure_time" : "18:39:35" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:42:25" , 
"departure_time" : "18:42:33" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:43:08" , 
"departure_time" : "18:44:28" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:46:20" , 
"departure_time" : "18:46:27" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:47:07" , 
"departure_time" : "18:47:08" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:49:01" , 
"departure_time" : "18:49:44" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:50:43" , 
"departure_time" : "18:51:43" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:52:00" , 
"departure_time" : "18:52:48" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:52:48" , 
"departure_time" : "18:52:49" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:53:01" , 
"departure_time" : "18:54:13" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:56:12" , 
"departure_time" : "18:57:05" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "18:58:53" , 
"departure_time" : "18:59:49" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "19:01:56" , 
"departure_time" : "19:03:23" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "19:04:27" , 
"departure_time" : "19:05:01" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "19:04:34" , 
"departure_time" : "19:05:58" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "19:07:24" , 
"departure_time" : "19:07:24" , 
"distance_traveled" : 6.06
} ], 
"3409" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "18:55:00" , 
"departure_time" : "18:56:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "18:57:31" , 
"departure_time" : "18:58:36" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "19:02:05" , 
"departure_time" : "19:02:52" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:03:47" , 
"departure_time" : "19:03:51" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:05:04" , 
"departure_time" : "19:05:47" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:07:43" , 
"departure_time" : "19:07:45" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "19:09:02" , 
"departure_time" : "19:09:10" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "19:10:08" , 
"departure_time" : "19:10:36" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "19:11:28" , 
"departure_time" : "19:12:57" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:13:29" , 
"departure_time" : "19:14:46" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "19:14:17" , 
"departure_time" : "19:15:18" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "19:16:01" , 
"departure_time" : "19:16:41" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "19:18:40" , 
"departure_time" : "19:19:27" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "19:21:47" , 
"departure_time" : "19:23:15" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "19:24:28" , 
"departure_time" : "19:26:02" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "19:25:34" , 
"departure_time" : "19:27:06" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "19:27:32" , 
"departure_time" : "19:27:32" , 
"distance_traveled" : 6.06
} ], 
"3410" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "19:15:00" , 
"departure_time" : "19:17:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "19:18:12" , 
"departure_time" : "19:19:25" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "19:22:13" , 
"departure_time" : "19:22:24" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:23:11" , 
"departure_time" : "19:24:25" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:26:14" , 
"departure_time" : "19:27:54" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:28:40" , 
"departure_time" : "19:30:13" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "19:30:33" , 
"departure_time" : "19:30:34" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "19:30:01" , 
"departure_time" : "19:31:07" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "19:32:06" , 
"departure_time" : "19:32:18" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:32:12" , 
"departure_time" : "19:33:41" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "19:34:29" , 
"departure_time" : "19:35:47" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "19:36:18" , 
"departure_time" : "19:37:04" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "19:38:46" , 
"departure_time" : "19:39:32" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "19:41:46" , 
"departure_time" : "19:42:34" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "19:43:48" , 
"departure_time" : "19:43:52" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "19:44:04" , 
"departure_time" : "19:45:26" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "19:47:22" , 
"departure_time" : "19:47:22" , 
"distance_traveled" : 6.06
} ], 
"3411" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "19:35:00" , 
"departure_time" : "19:36:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "19:37:37" , 
"departure_time" : "19:39:00" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "19:42:23" , 
"departure_time" : "19:42:45" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:43:22" , 
"departure_time" : "19:43:58" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:45:36" , 
"departure_time" : "19:46:55" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:48:19" , 
"departure_time" : "19:48:28" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "19:49:09" , 
"departure_time" : "19:49:25" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "19:50:16" , 
"departure_time" : "19:50:38" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "19:51:22" , 
"departure_time" : "19:52:46" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:53:24" , 
"departure_time" : "19:53:35" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "19:53:11" , 
"departure_time" : "19:54:47" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "19:56:36" , 
"departure_time" : "19:56:38" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "19:58:02" , 
"departure_time" : "19:58:45" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "20:01:43" , 
"departure_time" : "20:03:04" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "20:04:21" , 
"departure_time" : "20:05:55" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "20:05:34" , 
"departure_time" : "20:06:45" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "20:07:11" , 
"departure_time" : "20:07:11" , 
"distance_traveled" : 6.06
} ], 
"3412" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "19:55:00" , 
"departure_time" : "19:56:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "19:57:05" , 
"departure_time" : "19:57:51" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "20:01:46" , 
"departure_time" : "20:02:08" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "20:03:22" , 
"departure_time" : "20:04:33" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "20:06:11" , 
"departure_time" : "20:06:18" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "20:07:07" , 
"departure_time" : "20:08:35" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "20:10:28" , 
"departure_time" : "20:12:01" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "20:11:33" , 
"departure_time" : "20:12:32" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "20:11:59" , 
"departure_time" : "20:12:10" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "20:12:11" , 
"departure_time" : "20:12:13" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "20:13:02" , 
"departure_time" : "20:13:43" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "20:15:41" , 
"departure_time" : "20:16:53" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "20:19:12" , 
"departure_time" : "20:20:22" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "20:22:10" , 
"departure_time" : "20:23:04" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "20:23:54" , 
"departure_time" : "20:24:38" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "20:24:44" , 
"departure_time" : "20:25:31" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "20:26:47" , 
"departure_time" : "20:26:47" , 
"distance_traveled" : 6.06
} ], 
"3413" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "20:15:00" , 
"departure_time" : "20:17:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "20:18:30" , 
"departure_time" : "20:19:09" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "20:21:39" , 
"departure_time" : "20:22:36" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "20:23:57" , 
"departure_time" : "20:24:07" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "20:25:10" , 
"departure_time" : "20:25:51" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "20:27:41" , 
"departure_time" : "20:28:50" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "20:30:09" , 
"departure_time" : "20:30:58" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "20:30:49" , 
"departure_time" : "20:31:35" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "20:31:46" , 
"departure_time" : "20:33:22" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "20:33:36" , 
"departure_time" : "20:34:36" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "20:34:00" , 
"departure_time" : "20:34:40" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "20:35:40" , 
"departure_time" : "20:36:38" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "20:38:58" , 
"departure_time" : "20:40:24" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "20:42:26" , 
"departure_time" : "20:42:58" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "20:43:32" , 
"departure_time" : "20:43:34" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "20:44:02" , 
"departure_time" : "20:44:06" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "20:46:04" , 
"departure_time" : "20:46:04" , 
"distance_traveled" : 6.06
} ], 
"3414" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "20:35:00" , 
"departure_time" : "20:36:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "20:38:38" , 
"departure_time" : "20:39:32" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "20:41:54" , 
"departure_time" : "20:43:05" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "20:44:11" , 
"departure_time" : "20:45:11" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "20:46:00" , 
"departure_time" : "20:47:37" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "20:48:37" , 
"departure_time" : "20:48:43" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "20:49:06" , 
"departure_time" : "20:49:26" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "20:50:20" , 
"departure_time" : "20:50:35" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "20:51:15" , 
"departure_time" : "20:51:34" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "20:52:19" , 
"departure_time" : "20:52:24" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "20:53:05" , 
"departure_time" : "20:53:09" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "20:55:04" , 
"departure_time" : "20:56:13" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "20:59:09" , 
"departure_time" : "20:59:14" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "21:01:05" , 
"departure_time" : "21:01:30" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "21:03:25" , 
"departure_time" : "21:04:28" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "21:05:03" , 
"departure_time" : "21:06:40" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "21:07:37" , 
"departure_time" : "21:07:37" , 
"distance_traveled" : 6.06
} ], 
"3415" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "20:55:00" , 
"departure_time" : "20:57:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "20:58:03" , 
"departure_time" : "20:58:10" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "21:01:07" , 
"departure_time" : "21:02:40" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "21:04:33" , 
"departure_time" : "21:05:34" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "21:06:01" , 
"departure_time" : "21:06:38" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "21:07:37" , 
"departure_time" : "21:08:00" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "21:09:23" , 
"departure_time" : "21:10:38" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "21:11:15" , 
"departure_time" : "21:11:43" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "21:11:28" , 
"departure_time" : "21:12:52" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "21:13:24" , 
"departure_time" : "21:14:38" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "21:14:14" , 
"departure_time" : "21:15:40" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "21:16:26" , 
"departure_time" : "21:17:37" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "21:19:11" , 
"departure_time" : "21:19:35" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "21:21:24" , 
"departure_time" : "21:21:26" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "21:23:02" , 
"departure_time" : "21:24:35" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "21:25:33" , 
"departure_time" : "21:27:08" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "21:27:35" , 
"departure_time" : "21:27:35" , 
"distance_traveled" : 6.06
} ], 
"3416" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "21:15:00" , 
"departure_time" : "21:18:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "21:18:31" , 
"departure_time" : "21:20:02" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "21:22:31" , 
"departure_time" : "21:24:11" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "21:24:40" , 
"departure_time" : "21:26:11" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "21:26:31" , 
"departure_time" : "21:27:08" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "21:27:37" , 
"departure_time" : "21:28:39" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "21:30:02" , 
"departure_time" : "21:30:58" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "21:30:56" , 
"departure_time" : "21:31:50" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "21:31:54" , 
"departure_time" : "21:31:55" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "21:32:01" , 
"departure_time" : "21:32:43" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "21:33:42" , 
"departure_time" : "21:35:22" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "21:36:40" , 
"departure_time" : "21:37:13" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "21:38:33" , 
"departure_time" : "21:38:44" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "21:41:11" , 
"departure_time" : "21:41:15" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "21:43:04" , 
"departure_time" : "21:44:12" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "21:45:08" , 
"departure_time" : "21:45:40" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "21:46:32" , 
"departure_time" : "21:46:32" , 
"distance_traveled" : 6.06
} ], 
"3417" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "21:35:00" , 
"departure_time" : "21:36:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "21:38:15" , 
"departure_time" : "21:39:07" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "21:41:52" , 
"departure_time" : "21:42:10" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "21:43:18" , 
"departure_time" : "21:44:16" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "21:45:58" , 
"departure_time" : "21:47:28" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "21:48:30" , 
"departure_time" : "21:49:42" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "21:50:12" , 
"departure_time" : "21:51:29" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "21:51:17" , 
"departure_time" : "21:51:31" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "21:51:14" , 
"departure_time" : "21:52:43" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "21:53:29" , 
"departure_time" : "21:53:52" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "21:53:23" , 
"departure_time" : "21:53:37" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "21:55:14" , 
"departure_time" : "21:56:17" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "21:59:03" , 
"departure_time" : "22:00:29" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "22:02:26" , 
"departure_time" : "22:03:23" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "22:03:57" , 
"departure_time" : "22:04:57" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "22:05:00" , 
"departure_time" : "22:06:02" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "22:07:02" , 
"departure_time" : "22:07:02" , 
"distance_traveled" : 6.06
} ], 
"3418" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "21:55:00" , 
"departure_time" : "21:56:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "21:57:56" , 
"departure_time" : "21:58:56" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "22:02:00" , 
"departure_time" : "22:03:39" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "22:04:39" , 
"departure_time" : "22:05:33" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "22:05:54" , 
"departure_time" : "22:06:51" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "22:07:57" , 
"departure_time" : "22:09:28" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "22:10:31" , 
"departure_time" : "22:11:34" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "22:11:03" , 
"departure_time" : "22:12:31" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "22:12:28" , 
"departure_time" : "22:14:02" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "22:13:34" , 
"departure_time" : "22:13:44" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "22:13:10" , 
"departure_time" : "22:14:04" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "22:15:54" , 
"departure_time" : "22:17:27" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "22:19:33" , 
"departure_time" : "22:21:02" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "22:22:29" , 
"departure_time" : "22:22:51" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "22:23:22" , 
"departure_time" : "22:23:54" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "22:24:32" , 
"departure_time" : "22:25:12" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "22:26:40" , 
"departure_time" : "22:26:40" , 
"distance_traveled" : 6.06
} ], 
"3419" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "22:15:00" , 
"departure_time" : "22:17:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "22:18:26" , 
"departure_time" : "22:19:25" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "22:21:59" , 
"departure_time" : "22:23:10" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "22:24:11" , 
"departure_time" : "22:24:20" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "22:25:09" , 
"departure_time" : "22:25:22" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "22:27:13" , 
"departure_time" : "22:28:29" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "22:30:16" , 
"departure_time" : "22:30:58" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "22:30:42" , 
"departure_time" : "22:31:04" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "22:31:22" , 
"departure_time" : "22:32:37" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "22:33:15" , 
"departure_time" : "22:34:45" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "22:34:30" , 
"departure_time" : "22:35:46" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "22:36:16" , 
"departure_time" : "22:37:20" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "22:39:04" , 
"departure_time" : "22:39:52" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "22:41:48" , 
"departure_time" : "22:42:19" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "22:43:31" , 
"departure_time" : "22:44:25" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "22:44:54" , 
"departure_time" : "22:46:01" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "22:47:07" , 
"departure_time" : "22:47:07" , 
"distance_traveled" : 6.06
} ], 
"3420" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "22:35:00" , 
"departure_time" : "22:37:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "22:38:00" , 
"departure_time" : "22:39:30" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "22:42:30" , 
"departure_time" : "22:43:20" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "22:43:50" , 
"departure_time" : "22:44:59" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "22:46:09" , 
"departure_time" : "22:46:44" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "22:47:35" , 
"departure_time" : "22:48:18" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "22:49:43" , 
"departure_time" : "22:50:29" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "22:50:46" , 
"departure_time" : "22:51:29" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "22:51:43" , 
"departure_time" : "22:52:07" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "22:52:24" , 
"departure_time" : "22:53:42" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "22:54:18" , 
"departure_time" : "22:55:17" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "22:55:59" , 
"departure_time" : "22:56:38" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "22:58:39" , 
"departure_time" : "23:00:17" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "23:02:38" , 
"departure_time" : "23:03:07" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "23:03:29" , 
"departure_time" : "23:03:49" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "23:04:20" , 
"departure_time" : "23:05:14" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "23:06:54" , 
"departure_time" : "23:06:54" , 
"distance_traveled" : 6.06
} ], 
"3421" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "22:55:00" , 
"departure_time" : "22:56:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "22:57:08" , 
"departure_time" : "22:58:03" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "23:01:55" , 
"departure_time" : "23:02:47" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "23:03:52" , 
"departure_time" : "23:04:16" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "23:05:24" , 
"departure_time" : "23:06:27" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "23:08:03" , 
"departure_time" : "23:08:30" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "23:09:27" , 
"departure_time" : "23:10:33" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "23:11:06" , 
"departure_time" : "23:11:41" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "23:11:35" , 
"departure_time" : "23:12:04" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "23:12:29" , 
"departure_time" : "23:13:18" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "23:13:49" , 
"departure_time" : "23:15:23" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "23:16:34" , 
"departure_time" : "23:16:59" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "23:18:25" , 
"departure_time" : "23:18:49" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "23:21:24" , 
"departure_time" : "23:22:52" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "23:24:28" , 
"departure_time" : "23:25:02" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "23:24:34" , 
"departure_time" : "23:25:52" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "23:27:18" , 
"departure_time" : "23:27:18" , 
"distance_traveled" : 6.06
} ], 
"3422" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "23:45:00" , 
"departure_time" : "23:47:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "23:47:38" , 
"departure_time" : "23:48:38" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "23:48:00" , 
"departure_time" : "23:48:27" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "23:49:27" , 
"departure_time" : "23:49:32" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "23:50:05" , 
"departure_time" : "23:51:21" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "23:52:16" , 
"departure_time" : "23:52:49" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "23:53:33" , 
"departure_time" : "23:55:09" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "23:56:36" , 
"departure_time" : "23:57:03" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "23:57:27" , 
"departure_time" : "23:58:29" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "24:00:02" , 
"departure_time" : "24:00:12" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "24:03:10" , 
"departure_time" : "24:03:40" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "24:05:30" , 
"departure_time" : "24:05:30" , 
"distance_traveled" : 4.8619
} ], 
"3423" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "24:05:00" , 
"departure_time" : "24:05:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "24:06:03" , 
"departure_time" : "24:06:22" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "24:07:19" , 
"departure_time" : "24:08:25" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "24:10:06" , 
"departure_time" : "24:11:32" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "24:11:26" , 
"departure_time" : "24:12:59" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "24:12:33" , 
"departure_time" : "24:12:40" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "24:13:07" , 
"departure_time" : "24:14:19" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "24:16:12" , 
"departure_time" : "24:16:19" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "24:17:07" , 
"departure_time" : "24:17:47" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "24:19:40" , 
"departure_time" : "24:20:21" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "24:23:41" , 
"departure_time" : "24:24:03" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "24:25:22" , 
"departure_time" : "24:25:22" , 
"distance_traveled" : 4.8619
} ], 
"3424" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "24:25:00" , 
"departure_time" : "24:26:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "24:27:05" , 
"departure_time" : "24:27:53" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "24:27:48" , 
"departure_time" : "24:28:01" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "24:29:13" , 
"departure_time" : "24:30:03" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "24:30:50" , 
"departure_time" : "24:31:58" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "24:32:08" , 
"departure_time" : "24:33:39" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "24:34:31" , 
"departure_time" : "24:35:29" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "24:35:58" , 
"departure_time" : "24:37:22" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "24:38:24" , 
"departure_time" : "24:40:00" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "24:40:36" , 
"departure_time" : "24:42:16" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "24:44:40" , 
"departure_time" : "24:46:09" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "24:46:29" , 
"departure_time" : "24:46:29" , 
"distance_traveled" : 4.8619
} ], 
"3425" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "24:45:00" , 
"departure_time" : "24:47:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "24:46:52" , 
"departure_time" : "24:46:57" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "24:47:05" , 
"departure_time" : "24:47:27" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "24:49:22" , 
"departure_time" : "24:49:43" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "24:50:21" , 
"departure_time" : "24:50:52" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "24:51:31" , 
"departure_time" : "24:52:36" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "24:54:05" , 
"departure_time" : "24:54:50" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "24:55:45" , 
"departure_time" : "24:56:06" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "24:57:21" , 
"departure_time" : "24:57:42" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "24:59:21" , 
"departure_time" : "24:59:54" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "25:03:33" , 
"departure_time" : "25:04:44" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "25:06:11" , 
"departure_time" : "25:06:11" , 
"distance_traveled" : 4.8619
} ], 
"3426" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "25:05:00" , 
"departure_time" : "25:06:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "25:06:44" , 
"departure_time" : "25:07:08" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "25:07:24" , 
"departure_time" : "25:08:18" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "25:09:54" , 
"departure_time" : "25:10:31" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "25:10:37" , 
"departure_time" : "25:11:40" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "25:12:03" , 
"departure_time" : "25:13:08" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "25:14:05" , 
"departure_time" : "25:14:25" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "25:15:20" , 
"departure_time" : "25:16:23" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "25:18:03" , 
"departure_time" : "25:19:26" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "25:20:23" , 
"departure_time" : "25:21:32" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "25:24:09" , 
"departure_time" : "25:25:45" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "25:26:36" , 
"departure_time" : "25:26:36" , 
"distance_traveled" : 4.8619
} ], 
"3427" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "25:25:00" , 
"departure_time" : "25:28:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "25:27:26" , 
"departure_time" : "25:27:43" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "25:27:17" , 
"departure_time" : "25:27:54" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "25:29:37" , 
"departure_time" : "25:30:08" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "25:30:31" , 
"departure_time" : "25:31:57" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "25:32:26" , 
"departure_time" : "25:33:37" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "25:34:11" , 
"departure_time" : "25:34:22" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "25:35:11" , 
"departure_time" : "25:35:12" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "25:37:01" , 
"departure_time" : "25:38:17" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "25:40:16" , 
"departure_time" : "25:41:15" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "25:43:59" , 
"departure_time" : "25:44:20" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "25:45:21" , 
"departure_time" : "25:45:21" , 
"distance_traveled" : 4.8619
} ], 
"3428" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "05:39:00" , 
"departure_time" : "05:40:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "05:43:18" , 
"departure_time" : "05:43:56" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "05:45:38" , 
"departure_time" : "05:47:18" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "05:49:40" , 
"departure_time" : "05:50:55" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "05:52:15" , 
"departure_time" : "05:52:56" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "05:52:41" , 
"departure_time" : "05:52:56" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "05:53:15" , 
"departure_time" : "05:53:46" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "05:55:31" , 
"departure_time" : "05:55:44" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "05:56:13" , 
"departure_time" : "05:57:23" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "05:58:10" , 
"departure_time" : "05:59:17" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:00:07" , 
"departure_time" : "06:00:18" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "06:01:11" , 
"departure_time" : "06:01:40" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "06:03:29" , 
"departure_time" : "06:04:28" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "06:05:59" , 
"departure_time" : "06:07:27" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "06:10:28" , 
"departure_time" : "06:10:31" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "06:11:03" , 
"departure_time" : "06:11:03" , 
"distance_traveled" : 6.0843
} ], 
"3429" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "05:59:00" , 
"departure_time" : "05:59:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "06:02:08" , 
"departure_time" : "06:03:47" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "06:06:39" , 
"departure_time" : "06:06:59" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "06:08:20" , 
"departure_time" : "06:09:38" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "06:12:18" , 
"departure_time" : "06:12:20" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:12:02" , 
"departure_time" : "06:12:43" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:13:41" , 
"departure_time" : "06:13:52" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:15:11" , 
"departure_time" : "06:16:18" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:17:07" , 
"departure_time" : "06:18:31" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:18:24" , 
"departure_time" : "06:19:22" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:19:58" , 
"departure_time" : "06:20:46" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "06:21:48" , 
"departure_time" : "06:22:34" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "06:23:46" , 
"departure_time" : "06:25:09" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "06:26:23" , 
"departure_time" : "06:26:33" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "06:29:10" , 
"departure_time" : "06:29:49" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "06:31:39" , 
"departure_time" : "06:31:39" , 
"distance_traveled" : 6.0843
} ], 
"3430" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "06:19:00" , 
"departure_time" : "06:20:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "06:22:37" , 
"departure_time" : "06:23:15" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "06:25:38" , 
"departure_time" : "06:27:10" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "06:29:32" , 
"departure_time" : "06:31:12" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "06:32:40" , 
"departure_time" : "06:34:18" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:33:38" , 
"departure_time" : "06:34:12" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:33:34" , 
"departure_time" : "06:34:48" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:36:14" , 
"departure_time" : "06:36:49" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:36:35" , 
"departure_time" : "06:36:51" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:37:16" , 
"departure_time" : "06:38:44" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:40:28" , 
"departure_time" : "06:41:30" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "06:42:02" , 
"departure_time" : "06:43:07" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "06:44:05" , 
"departure_time" : "06:45:27" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "06:46:22" , 
"departure_time" : "06:47:47" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "06:50:25" , 
"departure_time" : "06:50:30" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "06:51:05" , 
"departure_time" : "06:51:05" , 
"distance_traveled" : 6.0843
} ], 
"3431" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "06:39:00" , 
"departure_time" : "06:39:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "06:42:50" , 
"departure_time" : "06:43:15" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "06:45:25" , 
"departure_time" : "06:46:20" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "06:48:55" , 
"departure_time" : "06:49:03" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "06:51:08" , 
"departure_time" : "06:52:34" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:53:26" , 
"departure_time" : "06:54:13" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:53:47" , 
"departure_time" : "06:54:50" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:56:03" , 
"departure_time" : "06:56:06" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:56:03" , 
"departure_time" : "06:56:05" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:57:02" , 
"departure_time" : "06:57:41" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:59:39" , 
"departure_time" : "07:01:19" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:02:40" , 
"departure_time" : "07:02:54" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:03:14" , 
"departure_time" : "07:04:10" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:05:56" , 
"departure_time" : "07:06:13" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "07:09:17" , 
"departure_time" : "07:10:27" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "07:12:10" , 
"departure_time" : "07:12:10" , 
"distance_traveled" : 6.0843
} ], 
"3432" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "06:59:00" , 
"departure_time" : "07:00:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "07:02:02" , 
"departure_time" : "07:02:26" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "07:05:24" , 
"departure_time" : "07:05:44" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:08:20" , 
"departure_time" : "07:09:58" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "07:12:38" , 
"departure_time" : "07:14:11" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:13:33" , 
"departure_time" : "07:15:05" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:14:32" , 
"departure_time" : "07:15:42" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:16:10" , 
"departure_time" : "07:16:28" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:16:18" , 
"departure_time" : "07:16:34" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:17:16" , 
"departure_time" : "07:17:47" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:19:31" , 
"departure_time" : "07:20:10" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:21:39" , 
"departure_time" : "07:22:56" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:24:17" , 
"departure_time" : "07:25:01" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:25:44" , 
"departure_time" : "07:26:57" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "07:30:13" , 
"departure_time" : "07:31:11" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "07:31:58" , 
"departure_time" : "07:31:58" , 
"distance_traveled" : 6.0843
} ], 
"3433" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "07:19:00" , 
"departure_time" : "07:20:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "07:22:15" , 
"departure_time" : "07:23:17" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "07:26:02" , 
"departure_time" : "07:27:31" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:29:29" , 
"departure_time" : "07:29:30" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "07:31:01" , 
"departure_time" : "07:32:15" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:33:14" , 
"departure_time" : "07:34:03" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:33:49" , 
"departure_time" : "07:35:13" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:36:24" , 
"departure_time" : "07:37:25" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:37:01" , 
"departure_time" : "07:37:59" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:37:58" , 
"departure_time" : "07:39:21" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:40:23" , 
"departure_time" : "07:40:38" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:41:15" , 
"departure_time" : "07:41:39" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:43:24" , 
"departure_time" : "07:43:48" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:45:24" , 
"departure_time" : "07:45:36" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "07:49:12" , 
"departure_time" : "07:50:27" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "07:52:15" , 
"departure_time" : "07:52:15" , 
"distance_traveled" : 6.0843
} ], 
"3434" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "07:39:00" , 
"departure_time" : "07:40:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "07:42:23" , 
"departure_time" : "07:43:00" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "07:45:37" , 
"departure_time" : "07:46:12" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:48:35" , 
"departure_time" : "07:49:02" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "07:51:27" , 
"departure_time" : "07:51:35" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:52:08" , 
"departure_time" : "07:52:45" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:53:37" , 
"departure_time" : "07:54:47" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:56:10" , 
"departure_time" : "07:56:17" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:56:07" , 
"departure_time" : "07:56:45" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:57:38" , 
"departure_time" : "07:58:07" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:59:29" , 
"departure_time" : "07:59:47" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:01:18" , 
"departure_time" : "08:02:11" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:03:53" , 
"departure_time" : "08:05:13" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:06:20" , 
"departure_time" : "08:06:36" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "08:09:16" , 
"departure_time" : "08:10:56" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "08:12:40" , 
"departure_time" : "08:12:40" , 
"distance_traveled" : 6.0843
} ], 
"3435" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "07:59:00" , 
"departure_time" : "08:01:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "08:02:27" , 
"departure_time" : "08:02:46" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "08:05:19" , 
"departure_time" : "08:06:01" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:08:42" , 
"departure_time" : "08:09:23" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "08:11:41" , 
"departure_time" : "08:13:12" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:13:31" , 
"departure_time" : "08:15:06" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:14:35" , 
"departure_time" : "08:15:28" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:15:53" , 
"departure_time" : "08:17:11" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:17:18" , 
"departure_time" : "08:18:34" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:18:16" , 
"departure_time" : "08:19:03" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:19:47" , 
"departure_time" : "08:20:48" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:22:01" , 
"departure_time" : "08:22:46" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:23:45" , 
"departure_time" : "08:24:12" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:25:27" , 
"departure_time" : "08:27:06" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "08:30:39" , 
"departure_time" : "08:31:08" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "08:31:29" , 
"departure_time" : "08:31:29" , 
"distance_traveled" : 6.0843
} ], 
"3436" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "08:19:00" , 
"departure_time" : "08:20:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "08:22:50" , 
"departure_time" : "08:24:02" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "08:26:12" , 
"departure_time" : "08:26:43" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:28:31" , 
"departure_time" : "08:30:03" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "08:32:32" , 
"departure_time" : "08:33:22" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:32:50" , 
"departure_time" : "08:33:47" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:33:57" , 
"departure_time" : "08:34:07" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:35:10" , 
"departure_time" : "08:36:02" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:36:52" , 
"departure_time" : "08:37:36" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:37:44" , 
"departure_time" : "08:38:13" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:39:29" , 
"departure_time" : "08:39:46" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:41:17" , 
"departure_time" : "08:41:24" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:43:07" , 
"departure_time" : "08:44:20" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:46:13" , 
"departure_time" : "08:46:43" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "08:49:30" , 
"departure_time" : "08:50:36" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "08:52:06" , 
"departure_time" : "08:52:06" , 
"distance_traveled" : 6.0843
} ], 
"3437" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "08:39:00" , 
"departure_time" : "08:40:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "08:42:18" , 
"departure_time" : "08:42:28" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "08:45:10" , 
"departure_time" : "08:46:32" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:49:22" , 
"departure_time" : "08:49:33" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "08:51:11" , 
"departure_time" : "08:52:05" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:52:54" , 
"departure_time" : "08:53:16" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:53:22" , 
"departure_time" : "08:53:56" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:55:34" , 
"departure_time" : "08:56:35" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:57:01" , 
"departure_time" : "08:57:20" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:57:19" , 
"departure_time" : "08:58:46" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:00:27" , 
"departure_time" : "09:00:39" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:01:12" , 
"departure_time" : "09:01:29" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:03:17" , 
"departure_time" : "09:04:08" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:05:51" , 
"departure_time" : "09:06:54" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "09:10:03" , 
"departure_time" : "09:11:35" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "09:12:32" , 
"departure_time" : "09:12:32" , 
"distance_traveled" : 6.0843
} ], 
"3438" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "08:59:00" , 
"departure_time" : "09:00:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "09:02:15" , 
"departure_time" : "09:03:17" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "09:06:02" , 
"departure_time" : "09:07:21" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "09:09:19" , 
"departure_time" : "09:10:59" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "09:12:40" , 
"departure_time" : "09:14:19" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:13:39" , 
"departure_time" : "09:14:05" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:13:26" , 
"departure_time" : "09:13:40" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:15:14" , 
"departure_time" : "09:16:04" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:16:50" , 
"departure_time" : "09:18:23" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:18:33" , 
"departure_time" : "09:19:02" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:19:29" , 
"departure_time" : "09:20:51" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:22:22" , 
"departure_time" : "09:23:53" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:24:31" , 
"departure_time" : "09:25:01" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:25:30" , 
"departure_time" : "09:26:49" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "09:30:19" , 
"departure_time" : "09:31:45" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "09:32:26" , 
"departure_time" : "09:32:26" , 
"distance_traveled" : 6.0843
} ], 
"3439" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "09:19:00" , 
"departure_time" : "09:21:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "09:23:31" , 
"departure_time" : "09:24:21" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "09:25:50" , 
"departure_time" : "09:25:54" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "09:28:04" , 
"departure_time" : "09:29:24" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "09:32:20" , 
"departure_time" : "09:33:25" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:33:05" , 
"departure_time" : "09:34:19" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:34:14" , 
"departure_time" : "09:35:39" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:36:25" , 
"departure_time" : "09:37:46" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:37:21" , 
"departure_time" : "09:38:55" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:38:34" , 
"departure_time" : "09:39:02" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:39:28" , 
"departure_time" : "09:39:36" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:41:08" , 
"departure_time" : "09:42:04" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:43:56" , 
"departure_time" : "09:44:30" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:45:34" , 
"departure_time" : "09:46:14" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "09:49:40" , 
"departure_time" : "09:51:14" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "09:52:34" , 
"departure_time" : "09:52:34" , 
"distance_traveled" : 6.0843
} ], 
"3440" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "09:39:00" , 
"departure_time" : "09:41:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "09:43:10" , 
"departure_time" : "09:43:31" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "09:45:21" , 
"departure_time" : "09:46:54" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "09:49:33" , 
"departure_time" : "09:49:53" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "09:51:20" , 
"departure_time" : "09:51:31" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:52:11" , 
"departure_time" : "09:53:18" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:54:07" , 
"departure_time" : "09:54:43" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:55:36" , 
"departure_time" : "09:56:35" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:56:59" , 
"departure_time" : "09:57:11" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:57:12" , 
"departure_time" : "09:57:13" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:59:01" , 
"departure_time" : "10:00:21" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "10:02:20" , 
"departure_time" : "10:03:54" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "10:04:34" , 
"departure_time" : "10:05:17" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "10:05:43" , 
"departure_time" : "10:06:55" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "10:10:12" , 
"departure_time" : "10:10:13" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "10:11:01" , 
"departure_time" : "10:11:01" , 
"distance_traveled" : 6.0843
} ], 
"3441" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "09:59:00" , 
"departure_time" : "10:00:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "10:03:08" , 
"departure_time" : "10:04:20" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "10:06:12" , 
"departure_time" : "10:06:17" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "10:08:05" , 
"departure_time" : "10:08:35" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "10:11:30" , 
"departure_time" : "10:12:10" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "10:12:40" , 
"departure_time" : "10:13:08" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "10:13:28" , 
"departure_time" : "10:15:00" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "10:16:32" , 
"departure_time" : "10:17:40" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "10:17:08" , 
"departure_time" : "10:18:09" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "10:18:01" , 
"departure_time" : "10:19:39" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "10:20:38" , 
"departure_time" : "10:21:16" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "10:21:38" , 
"departure_time" : "10:23:00" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "10:24:22" , 
"departure_time" : "10:25:02" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "10:25:40" , 
"departure_time" : "10:26:40" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "10:30:00" , 
"departure_time" : "10:31:23" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "10:32:23" , 
"departure_time" : "10:32:23" , 
"distance_traveled" : 6.0843
} ], 
"3442" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "10:19:00" , 
"departure_time" : "10:21:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "10:23:19" , 
"departure_time" : "10:24:03" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "10:25:44" , 
"departure_time" : "10:26:38" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "10:28:54" , 
"departure_time" : "10:29:06" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "10:31:12" , 
"departure_time" : "10:32:38" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "10:33:26" , 
"departure_time" : "10:34:23" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "10:33:57" , 
"departure_time" : "10:34:45" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "10:35:48" , 
"departure_time" : "10:36:13" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "10:36:25" , 
"departure_time" : "10:36:46" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "10:37:21" , 
"departure_time" : "10:38:24" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "10:40:03" , 
"departure_time" : "10:41:43" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "10:42:40" , 
"departure_time" : "10:44:10" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "10:44:30" , 
"departure_time" : "10:44:54" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "10:45:24" , 
"departure_time" : "10:45:33" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "10:49:09" , 
"departure_time" : "10:49:34" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "10:51:25" , 
"departure_time" : "10:51:25" , 
"distance_traveled" : 6.0843
} ], 
"3443" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "10:39:00" , 
"departure_time" : "10:40:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "10:43:20" , 
"departure_time" : "10:44:28" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "10:46:08" , 
"departure_time" : "10:46:21" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "10:48:13" , 
"departure_time" : "10:48:26" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "10:51:13" , 
"departure_time" : "10:52:32" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "10:53:19" , 
"departure_time" : "10:54:08" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "10:53:49" , 
"departure_time" : "10:54:55" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "10:56:06" , 
"departure_time" : "10:56:32" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "10:56:26" , 
"departure_time" : "10:56:42" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "10:57:16" , 
"departure_time" : "10:57:33" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "10:59:17" , 
"departure_time" : "11:00:05" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "11:01:48" , 
"departure_time" : "11:03:15" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "11:04:27" , 
"departure_time" : "11:04:55" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "11:05:28" , 
"departure_time" : "11:07:01" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "11:10:33" , 
"departure_time" : "11:11:50" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "11:12:17" , 
"departure_time" : "11:12:17" , 
"distance_traveled" : 6.0843
} ], 
"3444" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "10:59:00" , 
"departure_time" : "11:00:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "11:02:02" , 
"departure_time" : "11:02:20" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "11:05:18" , 
"departure_time" : "11:05:19" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "11:08:01" , 
"departure_time" : "11:08:36" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "11:11:35" , 
"departure_time" : "11:12:55" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "11:13:20" , 
"departure_time" : "11:13:30" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "11:13:10" , 
"departure_time" : "11:13:25" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "11:15:15" , 
"departure_time" : "11:15:46" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "11:16:31" , 
"departure_time" : "11:16:44" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "11:17:13" , 
"departure_time" : "11:18:16" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "11:20:03" , 
"departure_time" : "11:21:08" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "11:22:05" , 
"departure_time" : "11:23:37" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "11:24:32" , 
"departure_time" : "11:25:50" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "11:26:18" , 
"departure_time" : "11:27:44" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "11:30:26" , 
"departure_time" : "11:32:05" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "11:32:39" , 
"departure_time" : "11:32:39" , 
"distance_traveled" : 6.0843
} ], 
"3445" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "11:19:00" , 
"departure_time" : "11:21:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "11:22:39" , 
"departure_time" : "11:24:18" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "11:26:39" , 
"departure_time" : "11:27:11" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "11:28:32" , 
"departure_time" : "11:29:40" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "11:32:08" , 
"departure_time" : "11:33:41" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "11:33:33" , 
"departure_time" : "11:34:18" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "11:33:45" , 
"departure_time" : "11:35:14" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "11:36:29" , 
"departure_time" : "11:36:42" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "11:36:13" , 
"departure_time" : "11:36:24" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "11:37:11" , 
"departure_time" : "11:37:16" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "11:39:05" , 
"departure_time" : "11:40:34" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "11:42:29" , 
"departure_time" : "11:44:06" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "11:44:37" , 
"departure_time" : "11:45:22" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "11:45:45" , 
"departure_time" : "11:46:31" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "11:49:46" , 
"departure_time" : "11:50:38" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "11:51:52" , 
"departure_time" : "11:51:52" , 
"distance_traveled" : 6.0843
} ], 
"3446" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "11:39:00" , 
"departure_time" : "11:41:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "11:43:33" , 
"departure_time" : "11:44:36" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "11:46:03" , 
"departure_time" : "11:46:24" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "11:48:21" , 
"departure_time" : "11:48:26" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "11:51:05" , 
"departure_time" : "11:52:43" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "11:53:38" , 
"departure_time" : "11:54:04" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "11:53:26" , 
"departure_time" : "11:54:02" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "11:55:36" , 
"departure_time" : "11:56:20" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "11:56:44" , 
"departure_time" : "11:57:15" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "11:57:31" , 
"departure_time" : "11:57:32" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "11:59:01" , 
"departure_time" : "11:59:44" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "12:01:43" , 
"departure_time" : "12:03:15" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "12:04:32" , 
"departure_time" : "12:04:43" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "12:05:11" , 
"departure_time" : "12:06:43" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "12:10:32" , 
"departure_time" : "12:12:07" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "12:12:35" , 
"departure_time" : "12:12:35" , 
"distance_traveled" : 6.0843
} ], 
"3447" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "11:59:00" , 
"departure_time" : "12:00:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "12:02:15" , 
"departure_time" : "12:02:27" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "12:05:12" , 
"departure_time" : "12:06:47" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "12:09:35" , 
"departure_time" : "12:10:23" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "12:11:48" , 
"departure_time" : "12:12:05" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "12:12:17" , 
"departure_time" : "12:12:29" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "12:13:12" , 
"departure_time" : "12:13:36" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "12:15:24" , 
"departure_time" : "12:16:03" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "12:16:39" , 
"departure_time" : "12:16:53" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "12:17:14" , 
"departure_time" : "12:17:35" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "12:19:21" , 
"departure_time" : "12:20:15" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "12:21:54" , 
"departure_time" : "12:23:34" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "12:24:40" , 
"departure_time" : "12:25:48" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "12:26:08" , 
"departure_time" : "12:27:08" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "12:30:00" , 
"departure_time" : "12:31:30" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "12:32:30" , 
"departure_time" : "12:32:30" , 
"distance_traveled" : 6.0843
} ], 
"3448" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "12:19:00" , 
"departure_time" : "12:22:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "12:23:35" , 
"departure_time" : "12:24:56" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "12:26:21" , 
"departure_time" : "12:27:37" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "12:29:16" , 
"departure_time" : "12:30:27" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "12:32:11" , 
"departure_time" : "12:33:14" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "12:33:03" , 
"departure_time" : "12:33:55" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "12:33:52" , 
"departure_time" : "12:34:42" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "12:35:50" , 
"departure_time" : "12:37:09" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "12:37:19" , 
"departure_time" : "12:37:26" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "12:37:07" , 
"departure_time" : "12:38:02" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "12:39:55" , 
"departure_time" : "12:40:52" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "12:41:57" , 
"departure_time" : "12:43:09" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "12:44:12" , 
"departure_time" : "12:44:57" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "12:45:45" , 
"departure_time" : "12:45:55" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "12:49:10" , 
"departure_time" : "12:49:43" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "12:51:33" , 
"departure_time" : "12:51:33" , 
"distance_traveled" : 6.0843
} ], 
"3449" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "12:39:00" , 
"departure_time" : "12:40:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "12:43:24" , 
"departure_time" : "12:43:26" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "12:45:02" , 
"departure_time" : "12:45:55" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "12:48:53" , 
"departure_time" : "12:49:20" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "12:51:27" , 
"departure_time" : "12:51:38" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "12:52:11" , 
"departure_time" : "12:53:29" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "12:54:18" , 
"departure_time" : "12:55:26" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "12:56:08" , 
"departure_time" : "12:56:51" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "12:56:43" , 
"departure_time" : "12:58:23" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "12:58:40" , 
"departure_time" : "13:00:06" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "13:00:26" , 
"departure_time" : "13:01:02" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "13:01:36" , 
"departure_time" : "13:01:49" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "13:03:13" , 
"departure_time" : "13:04:05" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "13:05:52" , 
"departure_time" : "13:06:01" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "13:09:09" , 
"departure_time" : "13:10:14" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "13:12:05" , 
"departure_time" : "13:12:05" , 
"distance_traveled" : 6.0843
} ], 
"3450" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "12:59:00" , 
"departure_time" : "13:00:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "13:02:42" , 
"departure_time" : "13:03:12" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "13:05:30" , 
"departure_time" : "13:05:58" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "13:08:28" , 
"departure_time" : "13:10:05" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "13:12:37" , 
"departure_time" : "13:14:15" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "13:13:38" , 
"departure_time" : "13:15:15" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "13:14:37" , 
"departure_time" : "13:15:08" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "13:15:31" , 
"departure_time" : "13:15:44" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "13:16:13" , 
"departure_time" : "13:17:28" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "13:18:15" , 
"departure_time" : "13:19:25" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "13:20:10" , 
"departure_time" : "13:20:13" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "13:21:03" , 
"departure_time" : "13:22:41" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "13:24:38" , 
"departure_time" : "13:25:53" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "13:26:15" , 
"departure_time" : "13:27:45" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "13:30:30" , 
"departure_time" : "13:31:36" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "13:32:06" , 
"departure_time" : "13:32:06" , 
"distance_traveled" : 6.0843
} ], 
"3451" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "13:19:00" , 
"departure_time" : "13:20:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "13:22:45" , 
"departure_time" : "13:23:26" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "13:25:41" , 
"departure_time" : "13:26:39" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "13:28:58" , 
"departure_time" : "13:29:31" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "13:31:33" , 
"departure_time" : "13:32:40" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "13:33:07" , 
"departure_time" : "13:34:26" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "13:34:19" , 
"departure_time" : "13:35:16" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "13:35:57" , 
"departure_time" : "13:36:21" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "13:36:24" , 
"departure_time" : "13:37:40" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "13:38:16" , 
"departure_time" : "13:38:42" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "13:39:26" , 
"departure_time" : "13:40:05" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "13:41:39" , 
"departure_time" : "13:43:10" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "13:44:31" , 
"departure_time" : "13:45:50" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "13:46:19" , 
"departure_time" : "13:46:23" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "13:49:04" , 
"departure_time" : "13:49:22" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "13:51:18" , 
"departure_time" : "13:51:18" , 
"distance_traveled" : 6.0843
} ], 
"3452" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "13:39:00" , 
"departure_time" : "13:39:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "13:42:41" , 
"departure_time" : "13:43:37" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "13:45:56" , 
"departure_time" : "13:46:28" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "13:48:32" , 
"departure_time" : "13:49:22" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "13:51:50" , 
"departure_time" : "13:53:21" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "13:53:31" , 
"departure_time" : "13:54:29" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "13:53:58" , 
"departure_time" : "13:54:07" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "13:55:09" , 
"departure_time" : "13:56:44" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "13:57:35" , 
"departure_time" : "13:58:59" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "13:58:24" , 
"departure_time" : "13:59:58" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "14:00:34" , 
"departure_time" : "14:02:14" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "14:02:40" , 
"departure_time" : "14:02:48" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "14:03:08" , 
"departure_time" : "14:03:17" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "14:05:09" , 
"departure_time" : "14:06:17" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "14:10:08" , 
"departure_time" : "14:11:41" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "14:12:33" , 
"departure_time" : "14:12:33" , 
"distance_traveled" : 6.0843
} ], 
"3453" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "13:59:00" , 
"departure_time" : "14:01:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "14:03:09" , 
"departure_time" : "14:03:51" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "14:05:42" , 
"departure_time" : "14:05:58" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "14:08:16" , 
"departure_time" : "14:09:35" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "14:12:19" , 
"departure_time" : "14:13:58" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "14:13:39" , 
"departure_time" : "14:14:36" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "14:13:57" , 
"departure_time" : "14:14:17" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "14:15:20" , 
"departure_time" : "14:15:26" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "14:16:06" , 
"departure_time" : "14:16:14" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "14:17:08" , 
"departure_time" : "14:17:09" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "14:19:01" , 
"departure_time" : "14:19:18" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "14:21:17" , 
"departure_time" : "14:22:17" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "14:24:00" , 
"departure_time" : "14:24:41" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "14:25:41" , 
"departure_time" : "14:26:51" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "14:30:10" , 
"departure_time" : "14:30:57" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "14:31:47" , 
"departure_time" : "14:31:47" , 
"distance_traveled" : 6.0843
} ], 
"3454" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "14:19:00" , 
"departure_time" : "14:19:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "14:22:03" , 
"departure_time" : "14:22:58" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "14:25:55" , 
"departure_time" : "14:26:57" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "14:29:02" , 
"departure_time" : "14:30:41" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "14:32:39" , 
"departure_time" : "14:33:59" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "14:33:20" , 
"departure_time" : "14:33:37" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "14:33:17" , 
"departure_time" : "14:33:20" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "14:35:03" , 
"departure_time" : "14:36:30" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "14:37:27" , 
"departure_time" : "14:38:08" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "14:37:41" , 
"departure_time" : "14:38:20" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "14:39:39" , 
"departure_time" : "14:40:56" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "14:42:17" , 
"departure_time" : "14:43:55" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "14:44:38" , 
"departure_time" : "14:46:05" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "14:46:27" , 
"departure_time" : "14:47:20" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "14:49:53" , 
"departure_time" : "14:49:59" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "14:51:06" , 
"departure_time" : "14:51:06" , 
"distance_traveled" : 6.0843
} ], 
"3455" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "14:39:00" , 
"departure_time" : "14:40:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "14:43:14" , 
"departure_time" : "14:44:42" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "14:46:28" , 
"departure_time" : "14:46:54" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "14:48:26" , 
"departure_time" : "14:49:39" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "14:52:13" , 
"departure_time" : "14:53:27" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "14:53:14" , 
"departure_time" : "14:54:20" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "14:54:06" , 
"departure_time" : "14:55:10" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "14:56:04" , 
"departure_time" : "14:56:43" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "14:56:39" , 
"departure_time" : "14:57:02" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "14:57:23" , 
"departure_time" : "14:58:41" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:00:18" , 
"departure_time" : "15:01:44" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:02:26" , 
"departure_time" : "15:02:55" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:03:29" , 
"departure_time" : "15:03:50" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "15:05:21" , 
"departure_time" : "15:06:41" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "15:10:20" , 
"departure_time" : "15:10:32" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "15:11:12" , 
"departure_time" : "15:11:12" , 
"distance_traveled" : 6.0843
} ], 
"3456" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "14:59:00" , 
"departure_time" : "15:00:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "15:03:20" , 
"departure_time" : "15:04:46" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "15:06:26" , 
"departure_time" : "15:06:30" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "15:08:04" , 
"departure_time" : "15:08:51" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "15:11:47" , 
"departure_time" : "15:12:33" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:12:46" , 
"departure_time" : "15:13:27" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:13:41" , 
"departure_time" : "15:15:11" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:16:30" , 
"departure_time" : "15:17:08" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:16:38" , 
"departure_time" : "15:18:18" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:18:40" , 
"departure_time" : "15:20:01" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:20:21" , 
"departure_time" : "15:21:59" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:22:38" , 
"departure_time" : "15:24:18" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:24:40" , 
"departure_time" : "15:25:45" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "15:26:05" , 
"departure_time" : "15:27:36" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "15:30:31" , 
"departure_time" : "15:30:45" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "15:31:14" , 
"departure_time" : "15:31:14" , 
"distance_traveled" : 6.0843
} ], 
"3457" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "15:19:00" , 
"departure_time" : "15:19:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "15:22:05" , 
"departure_time" : "15:22:07" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "15:25:02" , 
"departure_time" : "15:25:48" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "15:28:46" , 
"departure_time" : "15:30:06" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "15:32:20" , 
"departure_time" : "15:32:59" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:32:39" , 
"departure_time" : "15:33:40" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:34:01" , 
"departure_time" : "15:34:04" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:35:03" , 
"departure_time" : "15:36:21" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:37:18" , 
"departure_time" : "15:38:32" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:38:14" , 
"departure_time" : "15:39:13" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:39:59" , 
"departure_time" : "15:41:17" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:42:18" , 
"departure_time" : "15:42:52" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:43:34" , 
"departure_time" : "15:43:58" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "15:45:24" , 
"departure_time" : "15:46:51" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "15:50:27" , 
"departure_time" : "15:50:33" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "15:51:06" , 
"departure_time" : "15:51:06" , 
"distance_traveled" : 6.0843
} ], 
"3458" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "15:39:00" , 
"departure_time" : "15:39:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "15:42:04" , 
"departure_time" : "15:42:35" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "15:45:31" , 
"departure_time" : "15:46:28" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "15:48:57" , 
"departure_time" : "15:50:06" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "15:52:09" , 
"departure_time" : "15:53:05" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:52:56" , 
"departure_time" : "15:54:19" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:54:23" , 
"departure_time" : "15:56:01" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:56:38" , 
"departure_time" : "15:58:03" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:57:25" , 
"departure_time" : "15:58:09" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:57:44" , 
"departure_time" : "15:59:02" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:00:18" , 
"departure_time" : "16:00:25" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:01:07" , 
"departure_time" : "16:01:34" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:03:27" , 
"departure_time" : "16:03:35" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:05:08" , 
"departure_time" : "16:06:00" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "16:09:52" , 
"departure_time" : "16:10:46" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "16:11:54" , 
"departure_time" : "16:11:54" , 
"distance_traveled" : 6.0843
} ], 
"3459" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "15:59:00" , 
"departure_time" : "16:00:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "16:02:33" , 
"departure_time" : "16:03:02" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "16:05:29" , 
"departure_time" : "16:05:33" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:08:04" , 
"departure_time" : "16:09:15" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "16:12:11" , 
"departure_time" : "16:12:51" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:12:40" , 
"departure_time" : "16:13:49" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:14:09" , 
"departure_time" : "16:15:49" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:16:40" , 
"departure_time" : "16:17:35" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:16:55" , 
"departure_time" : "16:17:01" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:17:06" , 
"departure_time" : "16:17:50" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:19:44" , 
"departure_time" : "16:20:17" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:21:33" , 
"departure_time" : "16:23:13" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:24:40" , 
"departure_time" : "16:24:59" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:25:19" , 
"departure_time" : "16:26:37" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "16:30:18" , 
"departure_time" : "16:31:15" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "16:31:57" , 
"departure_time" : "16:31:57" , 
"distance_traveled" : 6.0843
} ], 
"3460" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "16:19:00" , 
"departure_time" : "16:21:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "16:23:22" , 
"departure_time" : "16:24:28" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "16:26:06" , 
"departure_time" : "16:26:47" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:28:41" , 
"departure_time" : "16:29:28" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "16:31:47" , 
"departure_time" : "16:31:56" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:32:09" , 
"departure_time" : "16:32:34" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:33:25" , 
"departure_time" : "16:34:42" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:36:17" , 
"departure_time" : "16:37:04" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:36:47" , 
"departure_time" : "16:38:13" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:38:26" , 
"departure_time" : "16:39:29" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:40:03" , 
"departure_time" : "16:41:08" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:42:05" , 
"departure_time" : "16:43:40" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:44:35" , 
"departure_time" : "16:44:56" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:45:21" , 
"departure_time" : "16:46:34" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "16:50:13" , 
"departure_time" : "16:51:24" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "16:52:11" , 
"departure_time" : "16:52:11" , 
"distance_traveled" : 6.0843
} ], 
"3461" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "16:39:00" , 
"departure_time" : "16:40:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "16:42:23" , 
"departure_time" : "16:42:48" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "16:45:25" , 
"departure_time" : "16:46:30" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:49:05" , 
"departure_time" : "16:49:53" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "16:51:48" , 
"departure_time" : "16:51:59" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:52:11" , 
"departure_time" : "16:52:48" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:53:37" , 
"departure_time" : "16:54:29" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:55:52" , 
"departure_time" : "16:56:01" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:56:09" , 
"departure_time" : "16:57:16" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:58:07" , 
"departure_time" : "16:58:41" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:59:34" , 
"departure_time" : "17:01:09" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:02:35" , 
"departure_time" : "17:03:59" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:04:24" , 
"departure_time" : "17:05:18" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:05:54" , 
"departure_time" : "17:06:03" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "17:09:09" , 
"departure_time" : "17:09:21" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "17:11:12" , 
"departure_time" : "17:11:12" , 
"distance_traveled" : 6.0843
} ], 
"3462" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "16:59:00" , 
"departure_time" : "16:59:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "17:02:15" , 
"departure_time" : "17:03:39" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "17:06:24" , 
"departure_time" : "17:07:00" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "17:08:36" , 
"departure_time" : "17:10:05" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "17:12:29" , 
"departure_time" : "17:13:46" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:13:17" , 
"departure_time" : "17:13:40" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:13:23" , 
"departure_time" : "17:13:56" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:15:33" , 
"departure_time" : "17:15:53" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:16:20" , 
"departure_time" : "17:16:37" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:17:17" , 
"departure_time" : "17:17:27" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:19:10" , 
"departure_time" : "17:20:15" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:22:05" , 
"departure_time" : "17:22:40" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:23:35" , 
"departure_time" : "17:23:47" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:25:12" , 
"departure_time" : "17:25:31" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "17:29:19" , 
"departure_time" : "17:30:53" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "17:32:34" , 
"departure_time" : "17:32:34" , 
"distance_traveled" : 6.0843
} ], 
"3463" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "17:19:00" , 
"departure_time" : "17:21:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "17:23:19" , 
"departure_time" : "17:23:34" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "17:25:15" , 
"departure_time" : "17:25:52" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "17:28:37" , 
"departure_time" : "17:29:49" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "17:32:12" , 
"departure_time" : "17:32:55" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:32:43" , 
"departure_time" : "17:34:08" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:34:25" , 
"departure_time" : "17:34:50" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:35:25" , 
"departure_time" : "17:36:46" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:37:21" , 
"departure_time" : "17:38:14" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:37:53" , 
"departure_time" : "17:38:27" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:39:34" , 
"departure_time" : "17:41:04" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:42:30" , 
"departure_time" : "17:43:53" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:44:23" , 
"departure_time" : "17:45:59" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:46:36" , 
"departure_time" : "17:48:06" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "17:50:30" , 
"departure_time" : "17:51:16" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "17:51:46" , 
"departure_time" : "17:51:46" , 
"distance_traveled" : 6.0843
} ], 
"3464" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "17:39:00" , 
"departure_time" : "17:39:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "17:42:13" , 
"departure_time" : "17:43:51" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "17:46:38" , 
"departure_time" : "17:48:11" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "17:49:33" , 
"departure_time" : "17:50:24" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "17:51:51" , 
"departure_time" : "17:52:53" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:53:02" , 
"departure_time" : "17:54:34" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:54:32" , 
"departure_time" : "17:55:15" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:55:43" , 
"departure_time" : "17:55:46" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:56:03" , 
"departure_time" : "17:57:21" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:58:18" , 
"departure_time" : "17:58:53" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:59:35" , 
"departure_time" : "18:00:28" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:01:53" , 
"departure_time" : "18:02:08" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:03:15" , 
"departure_time" : "18:03:24" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:05:09" , 
"departure_time" : "18:05:12" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "18:09:03" , 
"departure_time" : "18:10:01" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "18:11:58" , 
"departure_time" : "18:11:58" , 
"distance_traveled" : 6.0843
} ], 
"3465" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "17:59:00" , 
"departure_time" : "18:00:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "18:02:50" , 
"departure_time" : "18:03:47" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "18:05:57" , 
"departure_time" : "18:07:09" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:09:12" , 
"departure_time" : "18:10:08" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "18:11:56" , 
"departure_time" : "18:12:53" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:12:57" , 
"departure_time" : "18:13:08" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:13:11" , 
"departure_time" : "18:14:09" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:15:58" , 
"departure_time" : "18:16:47" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:16:49" , 
"departure_time" : "18:18:19" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:18:30" , 
"departure_time" : "18:18:38" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:19:08" , 
"departure_time" : "18:20:09" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:22:01" , 
"departure_time" : "18:23:06" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:24:05" , 
"departure_time" : "18:24:48" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:25:43" , 
"departure_time" : "18:26:47" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "18:30:04" , 
"departure_time" : "18:30:46" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "18:31:42" , 
"departure_time" : "18:31:42" , 
"distance_traveled" : 6.0843
} ], 
"3466" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "18:19:00" , 
"departure_time" : "18:20:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "18:22:59" , 
"departure_time" : "18:24:27" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "18:26:28" , 
"departure_time" : "18:26:47" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:28:19" , 
"departure_time" : "18:28:23" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "18:31:04" , 
"departure_time" : "18:32:23" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:33:19" , 
"departure_time" : "18:33:21" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:33:02" , 
"departure_time" : "18:33:47" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:35:45" , 
"departure_time" : "18:36:10" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:36:25" , 
"departure_time" : "18:37:17" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:37:52" , 
"departure_time" : "18:37:53" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:39:01" , 
"departure_time" : "18:39:11" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:41:10" , 
"departure_time" : "18:41:56" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:43:46" , 
"departure_time" : "18:45:04" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:46:18" , 
"departure_time" : "18:46:19" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "18:49:01" , 
"departure_time" : "18:50:08" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "18:52:07" , 
"departure_time" : "18:52:07" , 
"distance_traveled" : 6.0843
} ], 
"3467" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "18:39:00" , 
"departure_time" : "18:41:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "18:43:15" , 
"departure_time" : "18:43:25" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "18:45:10" , 
"departure_time" : "18:45:15" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:48:05" , 
"departure_time" : "18:48:09" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "18:51:04" , 
"departure_time" : "18:52:14" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:53:10" , 
"departure_time" : "18:53:28" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:53:18" , 
"departure_time" : "18:54:07" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:55:49" , 
"departure_time" : "18:57:14" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:57:25" , 
"departure_time" : "18:57:34" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:57:09" , 
"departure_time" : "18:58:09" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:00:00" , 
"departure_time" : "19:00:08" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:01:08" , 
"departure_time" : "19:01:16" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:03:08" , 
"departure_time" : "19:04:12" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "19:06:04" , 
"departure_time" : "19:07:00" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "19:09:56" , 
"departure_time" : "19:11:12" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "19:12:16" , 
"departure_time" : "19:12:16" , 
"distance_traveled" : 6.0843
} ], 
"3468" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "18:59:00" , 
"departure_time" : "19:01:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "19:03:27" , 
"departure_time" : "19:04:05" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "19:05:38" , 
"departure_time" : "19:06:25" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "19:08:47" , 
"departure_time" : "19:10:21" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "19:12:34" , 
"departure_time" : "19:13:14" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "19:12:40" , 
"departure_time" : "19:12:57" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:13:17" , 
"departure_time" : "19:14:07" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "19:15:50" , 
"departure_time" : "19:17:07" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "19:17:17" , 
"departure_time" : "19:17:26" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "19:17:09" , 
"departure_time" : "19:17:38" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:19:29" , 
"departure_time" : "19:20:06" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:21:37" , 
"departure_time" : "19:22:50" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:24:13" , 
"departure_time" : "19:25:23" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "19:26:10" , 
"departure_time" : "19:26:36" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "19:29:26" , 
"departure_time" : "19:30:09" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "19:31:43" , 
"departure_time" : "19:31:43" , 
"distance_traveled" : 6.0843
} ], 
"3469" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "19:19:00" , 
"departure_time" : "19:21:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "19:23:24" , 
"departure_time" : "19:24:06" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "19:25:42" , 
"departure_time" : "19:25:50" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "19:28:08" , 
"departure_time" : "19:28:51" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "19:31:43" , 
"departure_time" : "19:33:08" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "19:33:25" , 
"departure_time" : "19:34:13" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:33:48" , 
"departure_time" : "19:34:10" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "19:35:22" , 
"departure_time" : "19:36:16" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "19:36:54" , 
"departure_time" : "19:38:03" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "19:38:09" , 
"departure_time" : "19:39:11" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:40:02" , 
"departure_time" : "19:40:53" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:41:51" , 
"departure_time" : "19:43:30" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:44:39" , 
"departure_time" : "19:45:32" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "19:45:53" , 
"departure_time" : "19:46:24" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "19:49:31" , 
"departure_time" : "19:50:13" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "19:51:42" , 
"departure_time" : "19:51:42" , 
"distance_traveled" : 6.0843
} ], 
"3470" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "19:39:00" , 
"departure_time" : "19:39:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "19:42:09" , 
"departure_time" : "19:43:17" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "19:46:08" , 
"departure_time" : "19:47:02" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "19:48:54" , 
"departure_time" : "19:50:12" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "19:52:18" , 
"departure_time" : "19:53:32" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "19:53:14" , 
"departure_time" : "19:53:23" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:53:09" , 
"departure_time" : "19:54:00" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "19:55:51" , 
"departure_time" : "19:56:06" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "19:56:15" , 
"departure_time" : "19:56:25" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "19:57:10" , 
"departure_time" : "19:58:35" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "20:00:25" , 
"departure_time" : "20:01:21" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "20:01:56" , 
"departure_time" : "20:03:04" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "20:04:08" , 
"departure_time" : "20:05:29" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "20:06:21" , 
"departure_time" : "20:07:27" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "20:10:06" , 
"departure_time" : "20:11:39" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "20:12:33" , 
"departure_time" : "20:12:33" , 
"distance_traveled" : 6.0843
} ], 
"3471" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "19:59:00" , 
"departure_time" : "20:01:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "20:02:38" , 
"departure_time" : "20:03:44" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "20:06:06" , 
"departure_time" : "20:07:42" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "20:09:36" , 
"departure_time" : "20:11:01" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "20:12:25" , 
"departure_time" : "20:13:50" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "20:13:25" , 
"departure_time" : "20:13:51" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "20:13:26" , 
"departure_time" : "20:14:34" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "20:16:08" , 
"departure_time" : "20:16:50" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "20:16:42" , 
"departure_time" : "20:16:45" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "20:17:03" , 
"departure_time" : "20:17:49" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "20:19:46" , 
"departure_time" : "20:20:42" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "20:21:56" , 
"departure_time" : "20:21:58" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "20:23:02" , 
"departure_time" : "20:24:10" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "20:26:08" , 
"departure_time" : "20:27:30" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "20:30:22" , 
"departure_time" : "20:30:59" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "20:31:37" , 
"departure_time" : "20:31:37" , 
"distance_traveled" : 6.0843
} ], 
"3472" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "20:19:00" , 
"departure_time" : "20:21:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "20:23:30" , 
"departure_time" : "20:25:03" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "20:26:33" , 
"departure_time" : "20:27:41" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "20:29:08" , 
"departure_time" : "20:30:05" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "20:31:57" , 
"departure_time" : "20:33:24" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "20:33:27" , 
"departure_time" : "20:34:25" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "20:33:58" , 
"departure_time" : "20:35:30" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "20:36:32" , 
"departure_time" : "20:36:54" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "20:36:22" , 
"departure_time" : "20:36:56" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "20:37:34" , 
"departure_time" : "20:38:44" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "20:40:10" , 
"departure_time" : "20:41:26" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "20:42:16" , 
"departure_time" : "20:43:26" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "20:44:10" , 
"departure_time" : "20:45:03" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "20:45:53" , 
"departure_time" : "20:47:09" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "20:50:16" , 
"departure_time" : "20:51:02" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "20:51:46" , 
"departure_time" : "20:51:46" , 
"distance_traveled" : 6.0843
} ], 
"3473" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "20:39:00" , 
"departure_time" : "20:40:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "20:42:24" , 
"departure_time" : "20:43:59" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "20:46:35" , 
"departure_time" : "20:48:04" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "20:49:29" , 
"departure_time" : "20:50:54" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "20:52:25" , 
"departure_time" : "20:53:36" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "20:53:11" , 
"departure_time" : "20:53:40" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "20:53:29" , 
"departure_time" : "20:55:08" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "20:56:39" , 
"departure_time" : "20:57:01" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "20:56:22" , 
"departure_time" : "20:57:22" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "20:58:00" , 
"departure_time" : "20:59:20" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "21:00:20" , 
"departure_time" : "21:00:43" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "21:01:23" , 
"departure_time" : "21:01:39" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "21:03:16" , 
"departure_time" : "21:04:27" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "21:06:11" , 
"departure_time" : "21:06:52" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "21:09:41" , 
"departure_time" : "21:10:14" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "21:11:33" , 
"departure_time" : "21:11:33" , 
"distance_traveled" : 6.0843
} ], 
"3474" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "20:59:00" , 
"departure_time" : "21:01:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "21:03:28" , 
"departure_time" : "21:04:40" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "21:06:12" , 
"departure_time" : "21:07:17" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "21:09:05" , 
"departure_time" : "21:09:13" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "21:11:08" , 
"departure_time" : "21:12:43" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "21:13:35" , 
"departure_time" : "21:14:22" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "21:13:47" , 
"departure_time" : "21:14:18" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "21:15:31" , 
"departure_time" : "21:16:16" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "21:16:45" , 
"departure_time" : "21:17:28" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "21:17:43" , 
"departure_time" : "21:18:38" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "21:19:55" , 
"departure_time" : "21:20:16" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "21:21:21" , 
"departure_time" : "21:21:44" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "21:23:23" , 
"departure_time" : "21:23:45" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "21:25:22" , 
"departure_time" : "21:26:00" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "21:29:38" , 
"departure_time" : "21:30:08" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "21:31:30" , 
"departure_time" : "21:31:30" , 
"distance_traveled" : 6.0843
} ], 
"3475" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "21:19:00" , 
"departure_time" : "21:21:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "21:23:35" , 
"departure_time" : "21:24:47" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "21:26:12" , 
"departure_time" : "21:26:58" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "21:28:46" , 
"departure_time" : "21:28:57" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "21:31:11" , 
"departure_time" : "21:31:54" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "21:32:43" , 
"departure_time" : "21:33:43" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "21:34:00" , 
"departure_time" : "21:34:07" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "21:35:07" , 
"departure_time" : "21:36:41" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "21:37:34" , 
"departure_time" : "21:38:03" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "21:37:29" , 
"departure_time" : "21:38:48" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "21:40:19" , 
"departure_time" : "21:40:44" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "21:41:25" , 
"departure_time" : "21:41:34" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "21:43:09" , 
"departure_time" : "21:43:22" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "21:45:13" , 
"departure_time" : "21:46:34" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "21:50:21" , 
"departure_time" : "21:50:49" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "21:51:28" , 
"departure_time" : "21:51:28" , 
"distance_traveled" : 6.0843
} ], 
"3476" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "21:39:00" , 
"departure_time" : "21:40:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "21:43:19" , 
"departure_time" : "21:43:42" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "21:45:23" , 
"departure_time" : "21:46:21" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "21:48:58" , 
"departure_time" : "21:50:03" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "21:52:05" , 
"departure_time" : "21:53:42" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "21:53:37" , 
"departure_time" : "21:53:49" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "21:53:12" , 
"departure_time" : "21:54:10" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "21:55:58" , 
"departure_time" : "21:56:47" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "21:56:49" , 
"departure_time" : "21:57:13" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "21:57:24" , 
"departure_time" : "21:57:51" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "21:59:27" , 
"departure_time" : "22:00:09" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "22:01:42" , 
"departure_time" : "22:02:18" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "22:03:36" , 
"departure_time" : "22:05:15" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "22:06:39" , 
"departure_time" : "22:07:27" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "22:09:48" , 
"departure_time" : "22:10:39" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "22:11:51" , 
"departure_time" : "22:11:51" , 
"distance_traveled" : 6.0843
} ], 
"3477" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "21:59:00" , 
"departure_time" : "22:01:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "22:03:26" , 
"departure_time" : "22:03:36" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "22:05:10" , 
"departure_time" : "22:06:09" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "22:08:59" , 
"departure_time" : "22:09:41" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "22:11:42" , 
"departure_time" : "22:12:05" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "22:12:23" , 
"departure_time" : "22:13:32" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "22:14:09" , 
"departure_time" : "22:15:20" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "22:16:11" , 
"departure_time" : "22:17:08" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "22:16:57" , 
"departure_time" : "22:18:35" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "22:18:38" , 
"departure_time" : "22:19:36" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "22:19:58" , 
"departure_time" : "22:21:27" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "22:22:29" , 
"departure_time" : "22:23:37" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "22:24:08" , 
"departure_time" : "22:24:27" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "22:25:19" , 
"departure_time" : "22:25:39" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "22:29:20" , 
"departure_time" : "22:29:36" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "22:31:16" , 
"departure_time" : "22:31:16" , 
"distance_traveled" : 6.0843
} ], 
"3478" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "22:19:00" , 
"departure_time" : "22:20:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "22:23:35" , 
"departure_time" : "22:25:15" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "22:26:40" , 
"departure_time" : "22:28:03" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "22:29:23" , 
"departure_time" : "22:29:57" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "22:31:34" , 
"departure_time" : "22:33:03" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "22:33:29" , 
"departure_time" : "22:34:40" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "22:34:11" , 
"departure_time" : "22:35:17" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "22:36:06" , 
"departure_time" : "22:37:45" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "22:37:39" , 
"departure_time" : "22:39:16" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "22:38:37" , 
"departure_time" : "22:39:11" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "22:39:34" , 
"departure_time" : "22:40:34" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "22:42:00" , 
"departure_time" : "22:43:29" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "22:44:29" , 
"departure_time" : "22:46:01" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "22:46:32" , 
"departure_time" : "22:46:43" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "22:49:11" , 
"departure_time" : "22:50:13" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "22:52:02" , 
"departure_time" : "22:52:02" , 
"distance_traveled" : 6.0843
} ], 
"3479" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "22:39:00" , 
"departure_time" : "22:40:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "22:42:54" , 
"departure_time" : "22:43:01" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "22:45:07" , 
"departure_time" : "22:45:36" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "22:48:29" , 
"departure_time" : "22:49:12" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "22:51:43" , 
"departure_time" : "22:53:06" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "22:53:23" , 
"departure_time" : "22:54:18" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "22:53:55" , 
"departure_time" : "22:54:55" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "22:56:00" , 
"departure_time" : "22:56:57" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "22:56:57" , 
"departure_time" : "22:58:26" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "22:58:29" , 
"departure_time" : "23:00:06" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "23:00:37" , 
"departure_time" : "23:01:23" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "23:01:46" , 
"departure_time" : "23:02:34" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "23:03:48" , 
"departure_time" : "23:04:42" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "23:05:54" , 
"departure_time" : "23:06:24" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "23:09:30" , 
"departure_time" : "23:10:13" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "23:11:43" , 
"departure_time" : "23:11:43" , 
"distance_traveled" : 6.0843
} ], 
"3480" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "22:59:00" , 
"departure_time" : "23:00:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "23:02:46" , 
"departure_time" : "23:03:06" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "23:05:20" , 
"departure_time" : "23:06:25" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "23:09:05" , 
"departure_time" : "23:10:37" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "23:12:32" , 
"departure_time" : "23:13:19" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "23:12:47" , 
"departure_time" : "23:14:24" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "23:14:37" , 
"departure_time" : "23:15:25" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "23:15:48" , 
"departure_time" : "23:17:02" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "23:17:14" , 
"departure_time" : "23:18:20" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "23:18:06" , 
"departure_time" : "23:19:18" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "23:20:12" , 
"departure_time" : "23:21:38" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "23:22:26" , 
"departure_time" : "23:23:18" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "23:23:52" , 
"departure_time" : "23:23:57" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "23:25:05" , 
"departure_time" : "23:25:11" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "23:29:06" , 
"departure_time" : "23:29:09" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "23:31:03" , 
"departure_time" : "23:31:03" , 
"distance_traveled" : 6.0843
} ], 
"3481" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "23:19:00" , 
"departure_time" : "23:19:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "23:22:48" , 
"departure_time" : "23:23:39" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "23:25:51" , 
"departure_time" : "23:27:13" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "23:29:22" , 
"departure_time" : "23:30:20" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "23:31:58" , 
"departure_time" : "23:32:01" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "23:32:03" , 
"departure_time" : "23:33:16" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "23:34:13" , 
"departure_time" : "23:35:51" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "23:36:38" , 
"departure_time" : "23:37:16" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "23:36:38" , 
"departure_time" : "23:36:48" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "23:37:10" , 
"departure_time" : "23:37:11" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "23:39:01" , 
"departure_time" : "23:39:28" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "23:41:27" , 
"departure_time" : "23:42:19" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "23:43:52" , 
"departure_time" : "23:44:15" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "23:45:23" , 
"departure_time" : "23:45:46" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "23:49:23" , 
"departure_time" : "23:50:41" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "23:52:18" , 
"departure_time" : "23:52:18" , 
"distance_traveled" : 6.0843
} ], 
"3482" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "23:39:00" , 
"departure_time" : "23:40:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "23:42:06" , 
"departure_time" : "23:42:42" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "23:45:36" , 
"departure_time" : "23:45:42" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "23:48:06" , 
"departure_time" : "23:48:22" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "23:51:16" , 
"departure_time" : "23:51:36" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "23:52:20" , 
"departure_time" : "23:52:48" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "23:53:28" , 
"departure_time" : "23:54:05" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "23:55:37" , 
"departure_time" : "23:55:45" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "23:56:08" , 
"departure_time" : "23:57:03" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "23:57:55" , 
"departure_time" : "23:58:00" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "23:59:05" , 
"departure_time" : "24:00:30" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "24:02:25" , 
"departure_time" : "24:02:42" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "24:03:17" , 
"departure_time" : "24:04:41" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "24:06:24" , 
"departure_time" : "24:07:35" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "24:10:11" , 
"departure_time" : "24:11:41" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "24:12:30" , 
"departure_time" : "24:12:30" , 
"distance_traveled" : 6.0843
} ], 
"3483" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "23:10:00" , 
"departure_time" : "23:12:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "23:12:32" , 
"departure_time" : "23:13:46" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "23:17:14" , 
"departure_time" : "23:17:16" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "23:18:02" , 
"departure_time" : "23:18:10" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "23:20:08" , 
"departure_time" : "23:21:16" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "23:23:08" , 
"departure_time" : "23:24:45" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "23:25:37" , 
"departure_time" : "23:27:01" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "23:26:24" , 
"departure_time" : "23:26:44" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "23:26:20" , 
"departure_time" : "23:26:51" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "23:27:31" , 
"departure_time" : "23:28:56" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "23:29:25" , 
"departure_time" : "23:30:25" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "23:31:00" , 
"departure_time" : "23:31:00" , 
"distance_traveled" : 4.8572
} ], 
"3484" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "23:35:00" , 
"departure_time" : "23:37:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "23:38:07" , 
"departure_time" : "23:39:39" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "23:42:32" , 
"departure_time" : "23:43:47" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "23:44:15" , 
"departure_time" : "23:45:02" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "23:45:47" , 
"departure_time" : "23:47:13" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "23:48:26" , 
"departure_time" : "23:49:04" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "23:49:38" , 
"departure_time" : "23:49:50" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "23:50:12" , 
"departure_time" : "23:50:33" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "23:51:21" , 
"departure_time" : "23:53:01" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "23:53:40" , 
"departure_time" : "23:54:18" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "23:53:38" , 
"departure_time" : "23:55:04" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "23:56:26" , 
"departure_time" : "23:56:26" , 
"distance_traveled" : 4.8572
} ], 
"3485" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "24:00:00" , 
"departure_time" : "24:02:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "24:02:52" , 
"departure_time" : "24:02:55" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "24:06:03" , 
"departure_time" : "24:06:46" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "24:08:43" , 
"departure_time" : "24:10:21" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "24:11:38" , 
"departure_time" : "24:13:03" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "24:13:25" , 
"departure_time" : "24:14:57" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "24:15:32" , 
"departure_time" : "24:15:48" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "24:15:16" , 
"departure_time" : "24:16:43" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "24:17:27" , 
"departure_time" : "24:18:59" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "24:18:32" , 
"departure_time" : "24:19:49" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "24:19:17" , 
"departure_time" : "24:19:38" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "24:20:21" , 
"departure_time" : "24:20:21" , 
"distance_traveled" : 4.8572
} ], 
"3486" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "24:25:00" , 
"departure_time" : "24:26:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "24:28:26" , 
"departure_time" : "24:30:04" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "24:32:38" , 
"departure_time" : "24:33:31" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "24:33:53" , 
"departure_time" : "24:34:05" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "24:35:12" , 
"departure_time" : "24:35:50" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "24:37:38" , 
"departure_time" : "24:38:16" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "24:39:38" , 
"departure_time" : "24:40:29" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "24:40:51" , 
"departure_time" : "24:41:08" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "24:41:17" , 
"departure_time" : "24:42:53" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "24:43:36" , 
"departure_time" : "24:44:24" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "24:43:48" , 
"departure_time" : "24:44:46" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "24:45:58" , 
"departure_time" : "24:45:58" , 
"distance_traveled" : 4.8572
} ], 
"3487" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "24:50:00" , 
"departure_time" : "24:51:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "24:52:10" , 
"departure_time" : "24:53:06" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "24:56:56" , 
"departure_time" : "24:57:39" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "24:58:43" , 
"departure_time" : "24:59:27" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "25:00:44" , 
"departure_time" : "25:02:23" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "25:03:39" , 
"departure_time" : "25:05:04" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "25:05:25" , 
"departure_time" : "25:06:12" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "25:05:47" , 
"departure_time" : "25:06:13" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "25:06:26" , 
"departure_time" : "25:08:00" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "25:08:34" , 
"departure_time" : "25:08:44" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "25:08:10" , 
"departure_time" : "25:09:29" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "25:11:19" , 
"departure_time" : "25:11:19" , 
"distance_traveled" : 4.8572
} ], 
"3488" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "04:50:00" , 
"departure_time" : "04:52:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "04:52:57" , 
"departure_time" : "04:53:23" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "04:56:26" , 
"departure_time" : "04:56:50" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "04:58:24" , 
"departure_time" : "04:58:42" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "05:00:18" , 
"departure_time" : "05:00:46" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "05:02:28" , 
"departure_time" : "05:03:25" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "05:04:57" , 
"departure_time" : "05:05:28" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "05:05:31" , 
"departure_time" : "05:06:13" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "05:06:42" , 
"departure_time" : "05:06:54" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "05:07:12" , 
"departure_time" : "05:07:51" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "05:08:39" , 
"departure_time" : "05:09:24" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "05:10:45" , 
"departure_time" : "05:11:59" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "05:14:14" , 
"departure_time" : "05:15:08" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "05:16:54" , 
"departure_time" : "05:16:55" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "05:18:01" , 
"departure_time" : "05:18:09" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "05:19:08" , 
"departure_time" : "05:19:23" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "05:21:15" , 
"departure_time" : "05:21:15" , 
"distance_traveled" : 6.06
} ], 
"3489" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "05:15:00" , 
"departure_time" : "05:16:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "05:18:05" , 
"departure_time" : "05:19:31" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "05:22:26" , 
"departure_time" : "05:23:42" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "05:24:16" , 
"departure_time" : "05:24:33" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "05:25:17" , 
"departure_time" : "05:26:12" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "05:27:55" , 
"departure_time" : "05:28:03" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "05:29:08" , 
"departure_time" : "05:30:35" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "05:31:27" , 
"departure_time" : "05:31:38" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "05:31:11" , 
"departure_time" : "05:31:28" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "05:32:17" , 
"departure_time" : "05:33:28" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "05:34:11" , 
"departure_time" : "05:35:24" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "05:36:13" , 
"departure_time" : "05:37:08" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "05:38:55" , 
"departure_time" : "05:39:20" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "05:41:25" , 
"departure_time" : "05:41:52" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "05:43:27" , 
"departure_time" : "05:43:56" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "05:44:29" , 
"departure_time" : "05:45:58" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "05:47:29" , 
"departure_time" : "05:47:29" , 
"distance_traveled" : 6.06
} ], 
"3490" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "05:40:00" , 
"departure_time" : "05:41:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "05:42:18" , 
"departure_time" : "05:43:55" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "05:47:37" , 
"departure_time" : "05:48:59" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "05:49:22" , 
"departure_time" : "05:50:19" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "05:50:57" , 
"departure_time" : "05:52:22" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "05:53:25" , 
"departure_time" : "05:54:02" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "05:54:37" , 
"departure_time" : "05:54:42" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "05:55:05" , 
"departure_time" : "05:55:52" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "05:56:47" , 
"departure_time" : "05:58:19" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "05:58:32" , 
"departure_time" : "05:59:45" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "05:59:13" , 
"departure_time" : "06:00:39" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "06:01:26" , 
"departure_time" : "06:02:46" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "06:04:20" , 
"departure_time" : "06:04:39" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "06:06:19" , 
"departure_time" : "06:06:34" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "06:08:15" , 
"departure_time" : "06:09:31" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "06:10:16" , 
"departure_time" : "06:11:31" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "06:12:15" , 
"departure_time" : "06:12:15" , 
"distance_traveled" : 6.06
} ], 
"3491" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "06:05:00" , 
"departure_time" : "06:07:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "06:08:05" , 
"departure_time" : "06:09:43" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "06:12:38" , 
"departure_time" : "06:13:37" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "06:13:59" , 
"departure_time" : "06:15:19" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "06:16:20" , 
"departure_time" : "06:17:17" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:17:57" , 
"departure_time" : "06:19:25" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:20:28" , 
"departure_time" : "06:21:32" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:21:04" , 
"departure_time" : "06:21:30" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:21:26" , 
"departure_time" : "06:21:31" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:22:05" , 
"departure_time" : "06:22:43" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:23:38" , 
"departure_time" : "06:24:06" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "06:25:28" , 
"departure_time" : "06:25:42" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "06:28:14" , 
"departure_time" : "06:28:37" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "06:31:23" , 
"departure_time" : "06:31:31" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "06:33:08" , 
"departure_time" : "06:34:32" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "06:35:24" , 
"departure_time" : "06:36:09" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "06:36:45" , 
"departure_time" : "06:36:45" , 
"distance_traveled" : 6.06
} ], 
"3492" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "06:30:00" , 
"departure_time" : "06:32:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "06:33:38" , 
"departure_time" : "06:33:51" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "06:36:13" , 
"departure_time" : "06:37:24" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "06:39:11" , 
"departure_time" : "06:40:15" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "06:41:04" , 
"departure_time" : "06:41:14" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:42:10" , 
"departure_time" : "06:42:54" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:44:44" , 
"departure_time" : "06:45:43" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:45:59" , 
"departure_time" : "06:47:29" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:47:30" , 
"departure_time" : "06:49:06" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:48:36" , 
"departure_time" : "06:48:46" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:48:10" , 
"departure_time" : "06:48:25" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "06:50:15" , 
"departure_time" : "06:50:36" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "06:53:21" , 
"departure_time" : "06:53:25" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "06:56:04" , 
"departure_time" : "06:56:49" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "06:58:45" , 
"departure_time" : "06:59:36" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "06:59:51" , 
"departure_time" : "07:01:07" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "07:02:16" , 
"departure_time" : "07:02:16" , 
"distance_traveled" : 6.06
} ], 
"3493" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "06:55:00" , 
"departure_time" : "06:57:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "06:58:31" , 
"departure_time" : "06:58:40" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:01:09" , 
"departure_time" : "07:02:49" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:04:40" , 
"departure_time" : "07:06:13" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:06:33" , 
"departure_time" : "07:08:01" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:08:28" , 
"departure_time" : "07:08:53" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:09:25" , 
"departure_time" : "07:10:44" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:11:19" , 
"departure_time" : "07:11:48" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:11:29" , 
"departure_time" : "07:11:59" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:12:30" , 
"departure_time" : "07:13:51" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:14:21" , 
"departure_time" : "07:14:51" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:15:30" , 
"departure_time" : "07:16:17" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "07:18:47" , 
"departure_time" : "07:19:18" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "07:21:31" , 
"departure_time" : "07:21:33" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "07:23:02" , 
"departure_time" : "07:23:12" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "07:24:10" , 
"departure_time" : "07:25:08" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "07:26:58" , 
"departure_time" : "07:26:58" , 
"distance_traveled" : 6.06
} ], 
"3494" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "07:20:00" , 
"departure_time" : "07:22:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "07:23:40" , 
"departure_time" : "07:24:28" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:26:48" , 
"departure_time" : "07:26:49" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:28:01" , 
"departure_time" : "07:28:17" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:30:16" , 
"departure_time" : "07:31:29" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:33:13" , 
"departure_time" : "07:34:05" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:34:52" , 
"departure_time" : "07:34:56" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:35:04" , 
"departure_time" : "07:35:26" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:36:22" , 
"departure_time" : "07:37:47" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:38:25" , 
"departure_time" : "07:39:41" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:39:16" , 
"departure_time" : "07:39:24" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:40:08" , 
"departure_time" : "07:40:57" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "07:43:49" , 
"departure_time" : "07:45:21" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "07:47:32" , 
"departure_time" : "07:48:19" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "07:48:47" , 
"departure_time" : "07:49:04" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "07:49:17" , 
"departure_time" : "07:50:40" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "07:52:23" , 
"departure_time" : "07:52:23" , 
"distance_traveled" : 6.06
} ], 
"3495" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "07:45:00" , 
"departure_time" : "07:46:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "07:47:01" , 
"departure_time" : "07:47:46" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:51:45" , 
"departure_time" : "07:52:50" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:54:05" , 
"departure_time" : "07:55:41" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:56:36" , 
"departure_time" : "07:58:04" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:58:28" , 
"departure_time" : "08:00:01" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:00:33" , 
"departure_time" : "08:00:34" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:00:01" , 
"departure_time" : "08:01:38" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:02:37" , 
"departure_time" : "08:03:49" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:03:12" , 
"departure_time" : "08:04:49" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:04:37" , 
"departure_time" : "08:05:04" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:05:27" , 
"departure_time" : "08:06:50" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "08:09:23" , 
"departure_time" : "08:10:01" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "08:11:38" , 
"departure_time" : "08:13:18" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "08:14:40" , 
"departure_time" : "08:16:20" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "08:15:40" , 
"departure_time" : "08:16:55" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "08:17:15" , 
"departure_time" : "08:17:15" , 
"distance_traveled" : 6.06
} ], 
"3496" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "08:10:00" , 
"departure_time" : "08:11:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "08:12:42" , 
"departure_time" : "08:14:11" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:17:29" , 
"departure_time" : "08:17:32" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:18:03" , 
"departure_time" : "08:18:37" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:20:34" , 
"departure_time" : "08:21:08" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:22:34" , 
"departure_time" : "08:23:40" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:25:06" , 
"departure_time" : "08:26:36" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:26:30" , 
"departure_time" : "08:27:29" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:26:59" , 
"departure_time" : "08:28:36" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:28:37" , 
"departure_time" : "08:29:30" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:28:53" , 
"departure_time" : "08:29:05" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:30:12" , 
"departure_time" : "08:30:56" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "08:33:44" , 
"departure_time" : "08:34:34" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "08:36:50" , 
"departure_time" : "08:37:06" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "08:38:16" , 
"departure_time" : "08:38:42" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "08:39:26" , 
"departure_time" : "08:40:21" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "08:41:55" , 
"departure_time" : "08:41:55" , 
"distance_traveled" : 6.06
} ], 
"3497" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "08:35:00" , 
"departure_time" : "08:36:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "08:38:01" , 
"departure_time" : "08:38:37" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:41:36" , 
"departure_time" : "08:42:56" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:44:20" , 
"departure_time" : "08:45:38" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:46:18" , 
"departure_time" : "08:47:55" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:48:37" , 
"departure_time" : "08:50:12" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:50:35" , 
"departure_time" : "08:51:38" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:51:03" , 
"departure_time" : "08:52:05" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:52:02" , 
"departure_time" : "08:53:25" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:53:23" , 
"departure_time" : "08:54:00" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:53:37" , 
"departure_time" : "08:55:06" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:56:29" , 
"departure_time" : "08:57:45" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "08:59:16" , 
"departure_time" : "09:00:48" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "09:02:32" , 
"departure_time" : "09:04:03" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "09:04:31" , 
"departure_time" : "09:05:56" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "09:05:25" , 
"departure_time" : "09:06:53" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "09:07:28" , 
"departure_time" : "09:07:28" , 
"distance_traveled" : 6.06
} ], 
"3498" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "09:00:00" , 
"departure_time" : "09:01:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "09:02:09" , 
"departure_time" : "09:02:44" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:06:35" , 
"departure_time" : "09:06:37" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:08:02" , 
"departure_time" : "09:08:59" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:10:57" , 
"departure_time" : "09:11:48" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:12:51" , 
"departure_time" : "09:13:05" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:14:14" , 
"departure_time" : "09:14:34" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:15:20" , 
"departure_time" : "09:16:45" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:17:25" , 
"departure_time" : "09:18:29" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:18:04" , 
"departure_time" : "09:19:34" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:19:30" , 
"departure_time" : "09:20:41" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "09:21:11" , 
"departure_time" : "09:22:12" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "09:24:01" , 
"departure_time" : "09:25:39" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "09:27:38" , 
"departure_time" : "09:27:55" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "09:28:17" , 
"departure_time" : "09:29:46" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "09:30:29" , 
"departure_time" : "09:32:08" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "09:32:39" , 
"departure_time" : "09:32:39" , 
"distance_traveled" : 6.06
} ], 
"3499" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "09:25:00" , 
"departure_time" : "09:27:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "09:27:45" , 
"departure_time" : "09:28:59" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:32:14" , 
"departure_time" : "09:32:44" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:33:30" , 
"departure_time" : "09:33:31" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:35:01" , 
"departure_time" : "09:36:19" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:38:18" , 
"departure_time" : "09:39:48" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:40:30" , 
"departure_time" : "09:41:29" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:40:59" , 
"departure_time" : "09:41:58" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:41:59" , 
"departure_time" : "09:42:27" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:42:28" , 
"departure_time" : "09:43:14" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:43:46" , 
"departure_time" : "09:44:08" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "09:45:22" , 
"departure_time" : "09:45:34" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "09:48:12" , 
"departure_time" : "09:48:14" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "09:51:02" , 
"departure_time" : "09:52:14" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "09:54:12" , 
"departure_time" : "09:55:33" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "09:55:21" , 
"departure_time" : "09:55:56" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "09:56:35" , 
"departure_time" : "09:56:35" , 
"distance_traveled" : 6.06
} ], 
"3500" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "09:50:00" , 
"departure_time" : "09:50:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "09:52:23" , 
"departure_time" : "09:53:35" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:57:12" , 
"departure_time" : "09:57:29" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:58:17" , 
"departure_time" : "09:58:36" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "10:00:19" , 
"departure_time" : "10:01:31" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "10:03:12" , 
"departure_time" : "10:03:18" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "10:04:06" , 
"departure_time" : "10:04:34" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "10:05:28" , 
"departure_time" : "10:05:41" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "10:06:13" , 
"departure_time" : "10:07:43" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "10:08:30" , 
"departure_time" : "10:09:46" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "10:09:16" , 
"departure_time" : "10:10:08" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "10:10:52" , 
"departure_time" : "10:11:58" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "10:14:06" , 
"departure_time" : "10:14:37" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "10:16:31" , 
"departure_time" : "10:17:25" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "10:18:54" , 
"departure_time" : "10:19:59" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "10:20:05" , 
"departure_time" : "10:21:21" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "10:22:16" , 
"departure_time" : "10:22:16" , 
"distance_traveled" : 6.06
} ], 
"3501" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "10:15:00" , 
"departure_time" : "10:17:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "10:18:06" , 
"departure_time" : "10:18:46" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "10:21:40" , 
"departure_time" : "10:23:03" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "10:24:23" , 
"departure_time" : "10:24:51" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "10:25:28" , 
"departure_time" : "10:25:43" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "10:27:15" , 
"departure_time" : "10:27:33" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "10:29:18" , 
"departure_time" : "10:29:45" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "10:30:27" , 
"departure_time" : "10:31:22" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "10:31:55" , 
"departure_time" : "10:32:28" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "10:32:33" , 
"departure_time" : "10:33:16" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "10:33:43" , 
"departure_time" : "10:33:46" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "10:35:03" , 
"departure_time" : "10:36:24" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "10:39:21" , 
"departure_time" : "10:39:39" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "10:41:18" , 
"departure_time" : "10:41:19" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "10:43:01" , 
"departure_time" : "10:43:06" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "10:44:05" , 
"departure_time" : "10:44:19" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "10:46:14" , 
"departure_time" : "10:46:14" , 
"distance_traveled" : 6.06
} ], 
"3502" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "10:40:00" , 
"departure_time" : "10:41:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "10:42:50" , 
"departure_time" : "10:43:04" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "10:46:14" , 
"departure_time" : "10:46:28" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "10:48:14" , 
"departure_time" : "10:49:38" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "10:51:24" , 
"departure_time" : "10:52:13" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "10:52:49" , 
"departure_time" : "10:53:18" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "10:54:29" , 
"departure_time" : "10:54:36" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "10:55:07" , 
"departure_time" : "10:55:14" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "10:56:07" , 
"departure_time" : "10:56:50" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "10:57:43" , 
"departure_time" : "10:58:44" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "10:59:01" , 
"departure_time" : "11:00:37" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "11:01:36" , 
"departure_time" : "11:02:44" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "11:04:08" , 
"departure_time" : "11:05:24" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "11:07:16" , 
"departure_time" : "11:08:19" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "11:09:03" , 
"departure_time" : "11:09:12" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "11:09:09" , 
"departure_time" : "11:10:33" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "11:12:24" , 
"departure_time" : "11:12:24" , 
"distance_traveled" : 6.06
} ], 
"3503" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "11:05:00" , 
"departure_time" : "11:06:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "11:07:09" , 
"departure_time" : "11:08:06" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "11:11:57" , 
"departure_time" : "11:12:48" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "11:13:51" , 
"departure_time" : "11:14:07" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "11:15:16" , 
"departure_time" : "11:16:24" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "11:18:08" , 
"departure_time" : "11:19:47" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "11:20:39" , 
"departure_time" : "11:21:29" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "11:20:50" , 
"departure_time" : "11:21:17" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "11:21:27" , 
"departure_time" : "11:22:25" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "11:22:58" , 
"departure_time" : "11:23:43" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "11:23:45" , 
"departure_time" : "11:25:04" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "11:26:19" , 
"departure_time" : "11:26:31" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "11:28:12" , 
"departure_time" : "11:29:04" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "11:31:52" , 
"departure_time" : "11:33:00" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "11:34:08" , 
"departure_time" : "11:35:18" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "11:35:10" , 
"departure_time" : "11:35:42" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "11:36:32" , 
"departure_time" : "11:36:32" , 
"distance_traveled" : 6.06
} ], 
"3504" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "11:30:00" , 
"departure_time" : "11:31:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "11:33:26" , 
"departure_time" : "11:33:42" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "11:36:16" , 
"departure_time" : "11:37:22" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "11:39:06" , 
"departure_time" : "11:40:35" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "11:41:29" , 
"departure_time" : "11:42:14" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "11:42:45" , 
"departure_time" : "11:43:34" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "11:44:49" , 
"departure_time" : "11:45:47" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "11:45:58" , 
"departure_time" : "11:46:44" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "11:46:46" , 
"departure_time" : "11:48:22" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "11:48:36" , 
"departure_time" : "11:50:11" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "11:49:35" , 
"departure_time" : "11:50:01" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "11:50:26" , 
"departure_time" : "11:50:32" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "11:53:06" , 
"departure_time" : "11:54:23" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "11:57:17" , 
"departure_time" : "11:57:55" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "11:58:38" , 
"departure_time" : "11:59:40" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "12:00:02" , 
"departure_time" : "12:01:13" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "12:02:11" , 
"departure_time" : "12:02:11" , 
"distance_traveled" : 6.06
} ], 
"3505" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "11:55:00" , 
"departure_time" : "11:57:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "11:58:10" , 
"departure_time" : "11:58:28" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "12:01:18" , 
"departure_time" : "12:01:40" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "12:03:22" , 
"departure_time" : "12:04:01" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "12:05:39" , 
"departure_time" : "12:05:58" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "12:07:19" , 
"departure_time" : "12:08:45" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "12:10:26" , 
"departure_time" : "12:10:41" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "12:10:15" , 
"departure_time" : "12:11:17" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "12:12:02" , 
"departure_time" : "12:13:36" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "12:13:34" , 
"departure_time" : "12:15:02" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "12:14:28" , 
"departure_time" : "12:16:08" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "12:16:40" , 
"departure_time" : "12:16:47" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "12:18:07" , 
"departure_time" : "12:19:44" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "12:22:37" , 
"departure_time" : "12:23:05" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "12:23:28" , 
"departure_time" : "12:23:49" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "12:24:21" , 
"departure_time" : "12:24:43" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "12:26:22" , 
"departure_time" : "12:26:22" , 
"distance_traveled" : 6.06
} ], 
"3506" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "12:20:00" , 
"departure_time" : "12:21:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "12:22:52" , 
"departure_time" : "12:24:25" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "12:27:33" , 
"departure_time" : "12:27:56" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "12:28:23" , 
"departure_time" : "12:29:57" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "12:31:34" , 
"departure_time" : "12:32:58" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "12:33:24" , 
"departure_time" : "12:34:07" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "12:34:43" , 
"departure_time" : "12:35:44" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "12:36:01" , 
"departure_time" : "12:37:20" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "12:37:19" , 
"departure_time" : "12:38:23" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "12:38:04" , 
"departure_time" : "12:38:47" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "12:38:43" , 
"departure_time" : "12:39:20" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "12:40:37" , 
"departure_time" : "12:41:58" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "12:44:21" , 
"departure_time" : "12:45:41" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "12:47:20" , 
"departure_time" : "12:47:33" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "12:48:13" , 
"departure_time" : "12:49:41" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "12:50:28" , 
"departure_time" : "12:50:41" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "12:51:13" , 
"departure_time" : "12:51:13" , 
"distance_traveled" : 6.06
} ], 
"3507" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "12:45:00" , 
"departure_time" : "12:46:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "12:47:58" , 
"departure_time" : "12:48:08" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "12:51:10" , 
"departure_time" : "12:52:08" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "12:53:58" , 
"departure_time" : "12:55:09" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "12:56:11" , 
"departure_time" : "12:57:09" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "12:57:58" , 
"departure_time" : "12:58:53" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "12:59:55" , 
"departure_time" : "13:01:27" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "13:01:32" , 
"departure_time" : "13:02:14" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "13:01:42" , 
"departure_time" : "13:03:18" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "13:03:36" , 
"departure_time" : "13:05:04" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "13:04:28" , 
"departure_time" : "13:05:29" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "13:06:01" , 
"departure_time" : "13:06:11" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "13:08:10" , 
"departure_time" : "13:08:12" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "13:11:02" , 
"departure_time" : "13:11:16" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "13:13:14" , 
"departure_time" : "13:14:16" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "13:15:02" , 
"departure_time" : "13:15:28" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "13:16:26" , 
"departure_time" : "13:16:26" , 
"distance_traveled" : 6.06
} ], 
"3508" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "13:10:00" , 
"departure_time" : "13:11:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "13:13:25" , 
"departure_time" : "13:13:44" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "13:16:19" , 
"departure_time" : "13:16:58" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "13:18:39" , 
"departure_time" : "13:20:05" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "13:21:26" , 
"departure_time" : "13:21:52" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "13:22:26" , 
"departure_time" : "13:23:24" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "13:24:58" , 
"departure_time" : "13:25:32" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "13:25:34" , 
"departure_time" : "13:25:50" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "13:26:16" , 
"departure_time" : "13:27:02" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "13:27:46" , 
"departure_time" : "13:28:59" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "13:29:13" , 
"departure_time" : "13:29:57" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "13:30:44" , 
"departure_time" : "13:31:36" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "13:33:52" , 
"departure_time" : "13:35:09" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "13:37:17" , 
"departure_time" : "13:37:55" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "13:38:38" , 
"departure_time" : "13:39:58" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "13:40:20" , 
"departure_time" : "13:41:42" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "13:42:22" , 
"departure_time" : "13:42:22" , 
"distance_traveled" : 6.06
} ], 
"3509" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "13:35:00" , 
"departure_time" : "13:37:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "13:37:43" , 
"departure_time" : "13:38:01" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "13:41:18" , 
"departure_time" : "13:41:48" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "13:43:30" , 
"departure_time" : "13:44:43" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "13:46:13" , 
"departure_time" : "13:47:45" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "13:48:32" , 
"departure_time" : "13:48:44" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "13:49:12" , 
"departure_time" : "13:50:43" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "13:51:31" , 
"departure_time" : "13:52:49" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "13:52:18" , 
"departure_time" : "13:53:43" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "13:53:25" , 
"departure_time" : "13:54:37" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "13:54:12" , 
"departure_time" : "13:54:17" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "13:55:05" , 
"departure_time" : "13:55:55" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "13:58:50" , 
"departure_time" : "14:00:30" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "14:02:40" , 
"departure_time" : "14:02:44" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "14:03:04" , 
"departure_time" : "14:04:40" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "14:05:36" , 
"departure_time" : "14:06:40" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "14:07:04" , 
"departure_time" : "14:07:04" , 
"distance_traveled" : 6.06
} ], 
"3510" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "14:00:00" , 
"departure_time" : "14:02:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "14:03:20" , 
"departure_time" : "14:04:06" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "14:06:46" , 
"departure_time" : "14:08:25" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "14:09:39" , 
"departure_time" : "14:10:56" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "14:11:17" , 
"departure_time" : "14:11:58" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "14:12:41" , 
"departure_time" : "14:14:19" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "14:15:38" , 
"departure_time" : "14:17:09" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "14:16:31" , 
"departure_time" : "14:17:21" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "14:16:50" , 
"departure_time" : "14:17:44" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "14:17:54" , 
"departure_time" : "14:18:38" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "14:18:44" , 
"departure_time" : "14:19:57" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "14:21:13" , 
"departure_time" : "14:22:50" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "14:24:37" , 
"departure_time" : "14:25:10" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "14:26:33" , 
"departure_time" : "14:26:49" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "14:28:16" , 
"departure_time" : "14:29:50" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "14:30:34" , 
"departure_time" : "14:31:36" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "14:32:02" , 
"departure_time" : "14:32:02" , 
"distance_traveled" : 6.06
} ], 
"3511" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "14:25:00" , 
"departure_time" : "14:26:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "14:27:08" , 
"departure_time" : "14:27:25" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "14:31:17" , 
"departure_time" : "14:31:32" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "14:33:15" , 
"departure_time" : "14:33:31" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "14:35:16" , 
"departure_time" : "14:36:08" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "14:37:52" , 
"departure_time" : "14:38:45" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "14:39:53" , 
"departure_time" : "14:40:10" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "14:40:17" , 
"departure_time" : "14:40:55" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "14:41:38" , 
"departure_time" : "14:43:05" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "14:43:27" , 
"departure_time" : "14:44:17" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "14:43:50" , 
"departure_time" : "14:45:14" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "14:46:24" , 
"departure_time" : "14:47:32" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "14:49:08" , 
"departure_time" : "14:49:09" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "14:51:01" , 
"departure_time" : "14:51:14" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "14:53:13" , 
"departure_time" : "14:54:11" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "14:54:58" , 
"departure_time" : "14:55:27" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "14:56:29" , 
"departure_time" : "14:56:29" , 
"distance_traveled" : 6.06
} ], 
"3512" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "14:50:00" , 
"departure_time" : "14:51:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "14:53:27" , 
"departure_time" : "14:54:45" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "14:57:18" , 
"departure_time" : "14:57:46" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "14:58:28" , 
"departure_time" : "14:59:39" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:01:11" , 
"departure_time" : "15:02:05" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:02:54" , 
"departure_time" : "15:03:12" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:04:18" , 
"departure_time" : "15:05:25" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:06:07" , 
"departure_time" : "15:07:15" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:07:08" , 
"departure_time" : "15:07:31" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:07:23" , 
"departure_time" : "15:07:38" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:08:15" , 
"departure_time" : "15:08:34" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "15:10:19" , 
"departure_time" : "15:11:08" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "15:13:49" , 
"departure_time" : "15:14:07" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "15:16:18" , 
"departure_time" : "15:17:15" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "15:18:57" , 
"departure_time" : "15:19:38" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "15:19:41" , 
"departure_time" : "15:19:57" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "15:21:16" , 
"departure_time" : "15:21:16" , 
"distance_traveled" : 6.06
} ], 
"3513" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "15:15:00" , 
"departure_time" : "15:15:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "15:17:05" , 
"departure_time" : "15:17:27" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "15:21:22" , 
"departure_time" : "15:22:01" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:23:39" , 
"departure_time" : "15:24:56" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:26:17" , 
"departure_time" : "15:26:26" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:27:09" , 
"departure_time" : "15:27:48" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:29:39" , 
"departure_time" : "15:30:26" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:30:47" , 
"departure_time" : "15:31:58" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:32:11" , 
"departure_time" : "15:33:46" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:33:35" , 
"departure_time" : "15:34:44" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:34:09" , 
"departure_time" : "15:34:35" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "15:35:26" , 
"departure_time" : "15:36:11" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "15:38:45" , 
"departure_time" : "15:40:14" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "15:42:29" , 
"departure_time" : "15:43:01" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "15:43:32" , 
"departure_time" : "15:43:55" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "15:44:23" , 
"departure_time" : "15:44:49" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "15:46:26" , 
"departure_time" : "15:46:26" , 
"distance_traveled" : 6.06
} ], 
"3514" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "15:40:00" , 
"departure_time" : "15:41:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "15:43:33" , 
"departure_time" : "15:43:50" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "15:46:17" , 
"departure_time" : "15:47:32" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:49:15" , 
"departure_time" : "15:50:35" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:51:20" , 
"departure_time" : "15:51:31" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:52:11" , 
"departure_time" : "15:53:29" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:55:18" , 
"departure_time" : "15:56:49" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:56:31" , 
"departure_time" : "15:56:51" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:56:20" , 
"departure_time" : "15:57:00" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:57:40" , 
"departure_time" : "15:58:36" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:58:56" , 
"departure_time" : "16:00:20" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:01:24" , 
"departure_time" : "16:01:53" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "16:03:29" , 
"departure_time" : "16:04:59" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "16:07:30" , 
"departure_time" : "16:08:27" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "16:08:57" , 
"departure_time" : "16:09:16" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "16:09:19" , 
"departure_time" : "16:10:25" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "16:12:06" , 
"departure_time" : "16:12:06" , 
"distance_traveled" : 6.06
} ], 
"3515" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "16:05:00" , 
"departure_time" : "16:07:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "16:08:12" , 
"departure_time" : "16:09:45" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:12:33" , 
"departure_time" : "16:12:53" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:13:20" , 
"departure_time" : "16:14:27" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:16:07" , 
"departure_time" : "16:16:58" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:17:51" , 
"departure_time" : "16:19:16" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:20:25" , 
"departure_time" : "16:21:13" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:20:48" , 
"departure_time" : "16:21:41" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:21:53" , 
"departure_time" : "16:23:02" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:23:09" , 
"departure_time" : "16:24:48" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:24:39" , 
"departure_time" : "16:25:44" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:26:05" , 
"departure_time" : "16:27:38" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "16:29:33" , 
"departure_time" : "16:29:40" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "16:31:07" , 
"departure_time" : "16:31:58" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "16:33:51" , 
"departure_time" : "16:35:22" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "16:35:31" , 
"departure_time" : "16:36:58" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "16:37:27" , 
"departure_time" : "16:37:27" , 
"distance_traveled" : 6.06
} ], 
"3516" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "16:30:00" , 
"departure_time" : "16:32:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "16:33:09" , 
"departure_time" : "16:33:20" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:36:11" , 
"departure_time" : "16:36:48" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:38:37" , 
"departure_time" : "16:38:57" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:40:20" , 
"departure_time" : "16:40:33" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:42:13" , 
"departure_time" : "16:42:17" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:44:04" , 
"departure_time" : "16:45:34" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:46:30" , 
"departure_time" : "16:47:05" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:46:35" , 
"departure_time" : "16:47:13" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:47:38" , 
"departure_time" : "16:48:34" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:48:56" , 
"departure_time" : "16:49:55" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:50:59" , 
"departure_time" : "16:51:21" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "16:53:22" , 
"departure_time" : "16:54:21" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "16:56:59" , 
"departure_time" : "16:57:13" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "16:58:14" , 
"departure_time" : "16:58:32" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "16:59:18" , 
"departure_time" : "16:59:34" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "17:01:16" , 
"departure_time" : "17:01:16" , 
"distance_traveled" : 6.06
} ], 
"3517" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "16:55:00" , 
"departure_time" : "16:55:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "16:57:24" , 
"departure_time" : "16:58:26" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:02:02" , 
"departure_time" : "17:03:04" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:04:02" , 
"departure_time" : "17:04:41" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:05:39" , 
"departure_time" : "17:05:44" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:07:05" , 
"departure_time" : "17:07:09" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:09:04" , 
"departure_time" : "17:09:17" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:10:13" , 
"departure_time" : "17:11:27" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:12:14" , 
"departure_time" : "17:12:38" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:12:24" , 
"departure_time" : "17:13:00" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:13:36" , 
"departure_time" : "17:13:56" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "17:15:20" , 
"departure_time" : "17:16:33" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "17:19:13" , 
"departure_time" : "17:20:52" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "17:22:39" , 
"departure_time" : "17:23:15" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "17:23:36" , 
"departure_time" : "17:24:30" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "17:24:54" , 
"departure_time" : "17:25:55" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "17:27:01" , 
"departure_time" : "17:27:01" , 
"distance_traveled" : 6.06
} ], 
"3518" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "17:20:00" , 
"departure_time" : "17:22:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "17:23:07" , 
"departure_time" : "17:24:32" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:27:25" , 
"departure_time" : "17:27:50" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:28:25" , 
"departure_time" : "17:28:30" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:30:05" , 
"departure_time" : "17:31:13" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:33:08" , 
"departure_time" : "17:33:47" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:34:39" , 
"departure_time" : "17:36:18" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:36:39" , 
"departure_time" : "17:38:16" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:37:37" , 
"departure_time" : "17:38:05" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:37:28" , 
"departure_time" : "17:38:25" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:38:57" , 
"departure_time" : "17:39:13" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "17:40:16" , 
"departure_time" : "17:41:14" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "17:43:58" , 
"departure_time" : "17:44:02" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "17:46:04" , 
"departure_time" : "17:46:44" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "17:48:40" , 
"departure_time" : "17:49:42" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "17:50:02" , 
"departure_time" : "17:51:17" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "17:52:15" , 
"departure_time" : "17:52:15" , 
"distance_traveled" : 6.06
} ], 
"3519" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "17:45:00" , 
"departure_time" : "17:46:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "17:47:01" , 
"departure_time" : "17:48:25" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:52:24" , 
"departure_time" : "17:53:32" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:54:08" , 
"departure_time" : "17:54:56" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:55:48" , 
"departure_time" : "17:57:19" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:58:31" , 
"departure_time" : "17:59:48" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:00:17" , 
"departure_time" : "18:01:41" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:01:24" , 
"departure_time" : "18:01:33" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:01:09" , 
"departure_time" : "18:02:27" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:03:18" , 
"departure_time" : "18:04:28" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:04:10" , 
"departure_time" : "18:05:44" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:06:34" , 
"departure_time" : "18:08:07" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "18:09:33" , 
"departure_time" : "18:10:48" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "18:12:15" , 
"departure_time" : "18:13:32" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "18:14:17" , 
"departure_time" : "18:14:28" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "18:14:11" , 
"departure_time" : "18:14:45" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "18:16:34" , 
"departure_time" : "18:16:34" , 
"distance_traveled" : 6.06
} ], 
"3520" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "18:10:00" , 
"departure_time" : "18:10:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "18:12:02" , 
"departure_time" : "18:12:32" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:16:30" , 
"departure_time" : "18:18:04" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:19:34" , 
"departure_time" : "18:20:12" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:20:38" , 
"departure_time" : "18:21:37" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:22:59" , 
"departure_time" : "18:23:27" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:24:28" , 
"departure_time" : "18:25:32" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:26:04" , 
"departure_time" : "18:27:39" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:27:35" , 
"departure_time" : "18:29:04" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:28:29" , 
"departure_time" : "18:28:35" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:28:06" , 
"departure_time" : "18:28:57" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:30:51" , 
"departure_time" : "18:31:22" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "18:33:31" , 
"departure_time" : "18:33:57" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "18:36:26" , 
"departure_time" : "18:36:52" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "18:38:26" , 
"departure_time" : "18:39:56" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "18:40:30" , 
"departure_time" : "18:41:52" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "18:42:22" , 
"departure_time" : "18:42:22" , 
"distance_traveled" : 6.06
} ], 
"3521" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "18:35:00" , 
"departure_time" : "18:37:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "18:38:31" , 
"departure_time" : "18:38:37" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:41:06" , 
"departure_time" : "18:42:09" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:44:03" , 
"departure_time" : "18:44:27" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:45:24" , 
"departure_time" : "18:46:59" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:48:35" , 
"departure_time" : "18:48:46" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:49:11" , 
"departure_time" : "18:50:24" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:51:13" , 
"departure_time" : "18:52:22" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:52:09" , 
"departure_time" : "18:53:42" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:53:33" , 
"departure_time" : "18:53:51" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:53:18" , 
"departure_time" : "18:54:03" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:55:45" , 
"departure_time" : "18:56:11" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "18:58:26" , 
"departure_time" : "18:58:54" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "19:01:28" , 
"departure_time" : "19:01:54" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "19:03:26" , 
"departure_time" : "19:03:52" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "19:04:26" , 
"departure_time" : "19:05:06" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "19:06:40" , 
"departure_time" : "19:06:40" , 
"distance_traveled" : 6.06
} ], 
"3522" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "19:00:00" , 
"departure_time" : "19:01:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "19:02:34" , 
"departure_time" : "19:03:33" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "19:06:59" , 
"departure_time" : "19:07:05" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:08:06" , 
"departure_time" : "19:08:33" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:10:27" , 
"departure_time" : "19:12:05" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:13:38" , 
"departure_time" : "19:13:48" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "19:14:10" , 
"departure_time" : "19:15:15" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "19:16:05" , 
"departure_time" : "19:17:35" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "19:17:30" , 
"departure_time" : "19:18:32" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:18:02" , 
"departure_time" : "19:18:27" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "19:18:25" , 
"departure_time" : "19:18:34" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "19:20:09" , 
"departure_time" : "19:21:23" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "19:24:14" , 
"departure_time" : "19:25:01" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "19:26:47" , 
"departure_time" : "19:26:50" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "19:28:03" , 
"departure_time" : "19:29:13" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "19:30:10" , 
"departure_time" : "19:31:31" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "19:32:21" , 
"departure_time" : "19:32:21" , 
"distance_traveled" : 6.06
} ], 
"3523" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "19:25:00" , 
"departure_time" : "19:27:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "19:28:20" , 
"departure_time" : "19:29:39" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "19:32:19" , 
"departure_time" : "19:32:52" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:33:33" , 
"departure_time" : "19:34:53" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:36:20" , 
"departure_time" : "19:37:42" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:38:22" , 
"departure_time" : "19:39:52" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "19:40:30" , 
"departure_time" : "19:40:31" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "19:40:01" , 
"departure_time" : "19:40:54" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "19:41:53" , 
"departure_time" : "19:43:08" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:43:15" , 
"departure_time" : "19:43:23" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "19:43:08" , 
"departure_time" : "19:44:00" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "19:45:52" , 
"departure_time" : "19:46:44" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "19:48:52" , 
"departure_time" : "19:48:54" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "19:51:02" , 
"departure_time" : "19:51:26" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "19:53:24" , 
"departure_time" : "19:53:48" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "19:54:24" , 
"departure_time" : "19:55:31" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "19:57:07" , 
"departure_time" : "19:57:07" , 
"distance_traveled" : 6.06
} ], 
"3524" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "19:50:00" , 
"departure_time" : "19:51:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "19:52:10" , 
"departure_time" : "19:52:12" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "19:56:02" , 
"departure_time" : "19:56:40" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:58:38" , 
"departure_time" : "19:59:42" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "20:01:04" , 
"departure_time" : "20:02:37" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "20:03:33" , 
"departure_time" : "20:03:58" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "20:04:25" , 
"departure_time" : "20:05:11" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "20:05:46" , 
"departure_time" : "20:06:11" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "20:06:25" , 
"departure_time" : "20:06:35" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "20:07:10" , 
"departure_time" : "20:08:46" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "20:09:36" , 
"departure_time" : "20:10:25" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "20:10:49" , 
"departure_time" : "20:11:25" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "20:13:36" , 
"departure_time" : "20:14:17" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "20:16:41" , 
"departure_time" : "20:17:38" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "20:18:57" , 
"departure_time" : "20:20:14" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "20:20:17" , 
"departure_time" : "20:20:59" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "20:21:42" , 
"departure_time" : "20:21:42" , 
"distance_traveled" : 6.06
} ], 
"3525" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "20:15:00" , 
"departure_time" : "20:16:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "20:17:22" , 
"departure_time" : "20:18:19" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "20:21:57" , 
"departure_time" : "20:22:41" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "20:23:44" , 
"departure_time" : "20:25:01" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "20:26:17" , 
"departure_time" : "20:27:40" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "20:28:23" , 
"departure_time" : "20:29:37" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "20:30:14" , 
"departure_time" : "20:31:45" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "20:31:31" , 
"departure_time" : "20:32:27" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "20:31:56" , 
"departure_time" : "20:32:14" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "20:32:18" , 
"departure_time" : "20:33:49" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "20:34:31" , 
"departure_time" : "20:35:45" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "20:36:14" , 
"departure_time" : "20:37:30" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "20:39:16" , 
"departure_time" : "20:39:19" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "20:41:03" , 
"departure_time" : "20:41:05" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "20:43:02" , 
"departure_time" : "20:43:43" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "20:44:41" , 
"departure_time" : "20:44:49" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "20:46:08" , 
"departure_time" : "20:46:08" , 
"distance_traveled" : 6.06
} ], 
"3526" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "20:40:00" , 
"departure_time" : "20:40:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "20:42:22" , 
"departure_time" : "20:42:57" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "20:46:35" , 
"departure_time" : "20:46:39" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "20:48:04" , 
"departure_time" : "20:48:41" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "20:50:37" , 
"departure_time" : "20:52:13" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "20:53:36" , 
"departure_time" : "20:54:44" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "20:55:08" , 
"departure_time" : "20:55:37" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "20:55:29" , 
"departure_time" : "20:57:01" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "20:57:32" , 
"departure_time" : "20:58:29" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "20:57:57" , 
"departure_time" : "20:58:48" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "20:58:51" , 
"departure_time" : "20:59:48" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "21:00:57" , 
"departure_time" : "21:01:53" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "21:03:56" , 
"departure_time" : "21:05:23" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "21:07:27" , 
"departure_time" : "21:08:26" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "21:08:59" , 
"departure_time" : "21:10:11" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "21:10:12" , 
"departure_time" : "21:11:48" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "21:12:36" , 
"departure_time" : "21:12:36" , 
"distance_traveled" : 6.06
} ], 
"3527" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "21:05:00" , 
"departure_time" : "21:07:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "21:07:40" , 
"departure_time" : "21:08:11" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "21:11:31" , 
"departure_time" : "21:12:34" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "21:14:03" , 
"departure_time" : "21:14:29" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "21:15:26" , 
"departure_time" : "21:15:33" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "21:17:07" , 
"departure_time" : "21:17:45" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "21:19:38" , 
"departure_time" : "21:20:36" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "21:20:58" , 
"departure_time" : "21:21:58" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "21:22:00" , 
"departure_time" : "21:22:34" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "21:22:34" , 
"departure_time" : "21:24:00" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "21:24:26" , 
"departure_time" : "21:24:52" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "21:25:26" , 
"departure_time" : "21:26:53" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "21:29:27" , 
"departure_time" : "21:30:13" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "21:31:46" , 
"departure_time" : "21:31:48" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "21:33:02" , 
"departure_time" : "21:33:19" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "21:34:17" , 
"departure_time" : "21:34:46" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "21:36:29" , 
"departure_time" : "21:36:29" , 
"distance_traveled" : 6.06
} ], 
"3528" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "21:30:00" , 
"departure_time" : "21:31:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "21:32:38" , 
"departure_time" : "21:34:09" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "21:37:31" , 
"departure_time" : "21:38:56" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "21:39:25" , 
"departure_time" : "21:40:05" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "21:40:40" , 
"departure_time" : "21:41:47" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "21:43:07" , 
"departure_time" : "21:44:20" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "21:45:13" , 
"departure_time" : "21:45:50" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "21:45:37" , 
"departure_time" : "21:47:11" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "21:47:34" , 
"departure_time" : "21:47:59" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "21:47:25" , 
"departure_time" : "21:48:09" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "21:48:44" , 
"departure_time" : "21:49:05" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "21:50:21" , 
"departure_time" : "21:51:37" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "21:54:16" , 
"departure_time" : "21:54:49" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "21:56:33" , 
"departure_time" : "21:57:18" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "21:58:45" , 
"departure_time" : "22:00:09" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "22:00:24" , 
"departure_time" : "22:00:36" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "22:01:12" , 
"departure_time" : "22:01:12" , 
"distance_traveled" : 6.06
} ], 
"3529" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "21:55:00" , 
"departure_time" : "21:56:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "21:58:00" , 
"departure_time" : "21:59:15" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "22:02:15" , 
"departure_time" : "22:02:41" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "22:03:26" , 
"departure_time" : "22:05:06" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "22:06:40" , 
"departure_time" : "22:06:41" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "22:07:01" , 
"departure_time" : "22:08:35" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "22:10:34" , 
"departure_time" : "22:12:01" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "22:11:27" , 
"departure_time" : "22:12:10" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "22:11:43" , 
"departure_time" : "22:12:54" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "22:13:11" , 
"departure_time" : "22:13:18" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "22:13:07" , 
"departure_time" : "22:14:47" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "22:16:40" , 
"departure_time" : "22:16:54" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "22:18:14" , 
"departure_time" : "22:18:58" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "22:21:44" , 
"departure_time" : "22:22:13" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "22:23:29" , 
"departure_time" : "22:24:24" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "22:24:55" , 
"departure_time" : "22:25:03" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "22:26:08" , 
"departure_time" : "22:26:08" , 
"distance_traveled" : 6.06
} ], 
"3530" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "22:20:00" , 
"departure_time" : "22:20:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "22:22:47" , 
"departure_time" : "22:23:38" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "22:26:51" , 
"departure_time" : "22:27:03" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "22:28:12" , 
"departure_time" : "22:28:28" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "22:30:16" , 
"departure_time" : "22:31:24" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "22:33:08" , 
"departure_time" : "22:34:09" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "22:35:01" , 
"departure_time" : "22:35:48" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "22:35:47" , 
"departure_time" : "22:36:32" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "22:36:45" , 
"departure_time" : "22:36:51" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "22:37:06" , 
"departure_time" : "22:38:15" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "22:39:09" , 
"departure_time" : "22:40:41" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "22:41:32" , 
"departure_time" : "22:41:46" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "22:43:14" , 
"departure_time" : "22:43:52" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "22:46:38" , 
"departure_time" : "22:47:57" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "22:49:19" , 
"departure_time" : "22:49:51" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "22:49:32" , 
"departure_time" : "22:50:23" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "22:51:51" , 
"departure_time" : "22:51:51" , 
"distance_traveled" : 6.06
} ], 
"3531" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "22:45:00" , 
"departure_time" : "22:46:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "22:47:52" , 
"departure_time" : "22:49:02" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "22:52:10" , 
"departure_time" : "22:52:47" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "22:53:37" , 
"departure_time" : "22:55:06" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "22:56:29" , 
"departure_time" : "22:56:57" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "22:57:28" , 
"departure_time" : "22:58:32" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "23:00:04" , 
"departure_time" : "23:01:24" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "23:01:20" , 
"departure_time" : "23:02:01" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "23:01:41" , 
"departure_time" : "23:02:33" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "23:02:52" , 
"departure_time" : "23:03:18" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "23:03:26" , 
"departure_time" : "23:04:43" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "23:06:17" , 
"departure_time" : "23:07:14" , 
"distance_traveled" : 4.8572
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "23:08:57" , 
"departure_time" : "23:10:10" , 
"distance_traveled" : 4.867
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "23:12:13" , 
"departure_time" : "23:13:50" , 
"distance_traveled" : 5.4413
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "23:14:37" , 
"departure_time" : "23:15:15" , 
"distance_traveled" : 5.7977
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "23:14:38" , 
"departure_time" : "23:15:01" , 
"distance_traveled" : 5.8951
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "23:16:23" , 
"departure_time" : "23:16:23" , 
"distance_traveled" : 6.06
} ], 
"3532" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "23:39:00" , 
"departure_time" : "23:39:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "23:40:01" , 
"departure_time" : "23:41:10" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "23:42:09" , 
"departure_time" : "23:42:51" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "23:43:42" , 
"departure_time" : "23:45:20" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "23:45:38" , 
"departure_time" : "23:46:50" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "23:46:12" , 
"departure_time" : "23:46:42" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "23:47:30" , 
"departure_time" : "23:49:07" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "23:50:37" , 
"departure_time" : "23:51:47" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "23:52:10" , 
"departure_time" : "23:52:51" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "23:53:41" , 
"departure_time" : "23:54:32" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "23:57:51" , 
"departure_time" : "23:58:56" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "24:00:05" , 
"departure_time" : "24:00:05" , 
"distance_traveled" : 4.8619
} ], 
"3533" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "24:04:00" , 
"departure_time" : "24:05:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "24:05:46" , 
"departure_time" : "24:06:35" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "24:06:49" , 
"departure_time" : "24:07:13" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "24:08:24" , 
"departure_time" : "24:08:46" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "24:09:22" , 
"departure_time" : "24:10:25" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "24:11:03" , 
"departure_time" : "24:11:31" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "24:12:28" , 
"departure_time" : "24:13:04" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "24:14:36" , 
"departure_time" : "24:15:15" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "24:16:39" , 
"departure_time" : "24:16:58" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "24:18:19" , 
"departure_time" : "24:19:28" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "24:23:09" , 
"departure_time" : "24:23:18" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "24:24:09" , 
"departure_time" : "24:24:09" , 
"distance_traveled" : 4.8619
} ], 
"3534" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "24:29:00" , 
"departure_time" : "24:30:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "24:31:33" , 
"departure_time" : "24:32:29" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "24:31:56" , 
"departure_time" : "24:32:17" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "24:33:21" , 
"departure_time" : "24:34:17" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "24:34:56" , 
"departure_time" : "24:36:04" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "24:36:08" , 
"departure_time" : "24:37:26" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "24:38:18" , 
"departure_time" : "24:39:27" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "24:40:09" , 
"departure_time" : "24:41:12" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "24:42:03" , 
"departure_time" : "24:42:58" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "24:43:55" , 
"departure_time" : "24:44:38" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "24:47:43" , 
"departure_time" : "24:48:53" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "24:50:10" , 
"departure_time" : "24:50:10" , 
"distance_traveled" : 4.8619
} ], 
"3535" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "24:54:00" , 
"departure_time" : "24:56:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "24:56:15" , 
"departure_time" : "24:57:32" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "24:57:17" , 
"departure_time" : "24:58:52" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "24:59:35" , 
"departure_time" : "24:59:39" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "24:59:04" , 
"departure_time" : "24:59:46" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "25:00:42" , 
"departure_time" : "25:01:18" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "25:02:36" , 
"departure_time" : "25:02:38" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "25:04:02" , 
"departure_time" : "25:05:32" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "25:07:30" , 
"departure_time" : "25:08:52" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "25:09:22" , 
"departure_time" : "25:09:30" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "25:12:08" , 
"departure_time" : "25:13:13" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "25:15:05" , 
"departure_time" : "25:15:05" , 
"distance_traveled" : 4.8619
} ], 
"3536" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "25:19:00" , 
"departure_time" : "25:21:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "25:21:04" , 
"departure_time" : "25:21:20" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "25:21:16" , 
"departure_time" : "25:22:49" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "25:24:33" , 
"departure_time" : "25:24:43" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "25:24:10" , 
"departure_time" : "25:24:40" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "25:25:30" , 
"departure_time" : "25:25:50" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "25:27:20" , 
"departure_time" : "25:28:35" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "25:30:15" , 
"departure_time" : "25:30:41" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "25:31:26" , 
"departure_time" : "25:32:01" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "25:33:35" , 
"departure_time" : "25:33:48" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "25:37:13" , 
"departure_time" : "25:38:53" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "25:40:40" , 
"departure_time" : "25:40:40" , 
"distance_traveled" : 4.8619
} ], 
"3537" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "05:25:00" , 
"departure_time" : "05:27:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "05:28:31" , 
"departure_time" : "05:28:54" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "05:31:23" , 
"departure_time" : "05:31:56" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "05:34:33" , 
"departure_time" : "05:35:58" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "05:38:25" , 
"departure_time" : "05:39:58" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "05:39:33" , 
"departure_time" : "05:40:30" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "05:39:57" , 
"departure_time" : "05:40:35" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "05:41:38" , 
"departure_time" : "05:42:21" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "05:42:43" , 
"departure_time" : "05:43:08" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "05:43:25" , 
"departure_time" : "05:44:53" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "05:46:28" , 
"departure_time" : "05:46:44" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "05:47:16" , 
"departure_time" : "05:48:34" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "05:50:18" , 
"departure_time" : "05:50:32" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "05:51:14" , 
"departure_time" : "05:52:15" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "05:56:01" , 
"departure_time" : "05:56:12" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "05:57:11" , 
"departure_time" : "05:57:11" , 
"distance_traveled" : 6.0843
} ], 
"3538" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "05:50:00" , 
"departure_time" : "05:50:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "05:53:24" , 
"departure_time" : "05:53:46" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "05:56:22" , 
"departure_time" : "05:56:38" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "05:59:16" , 
"departure_time" : "06:00:11" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "06:02:55" , 
"departure_time" : "06:03:00" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:03:05" , 
"departure_time" : "06:03:37" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:04:32" , 
"departure_time" : "06:05:03" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:06:31" , 
"departure_time" : "06:07:37" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:08:06" , 
"departure_time" : "06:08:39" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:08:33" , 
"departure_time" : "06:09:53" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:11:20" , 
"departure_time" : "06:11:30" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "06:12:10" , 
"departure_time" : "06:13:42" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "06:15:32" , 
"departure_time" : "06:16:18" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "06:16:46" , 
"departure_time" : "06:17:40" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "06:20:54" , 
"departure_time" : "06:21:18" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "06:22:24" , 
"departure_time" : "06:22:24" , 
"distance_traveled" : 6.0843
} ], 
"3539" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "06:15:00" , 
"departure_time" : "06:16:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "06:19:20" , 
"departure_time" : "06:20:56" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "06:22:36" , 
"departure_time" : "06:24:00" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "06:25:24" , 
"departure_time" : "06:26:09" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "06:27:45" , 
"departure_time" : "06:28:31" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:28:46" , 
"departure_time" : "06:30:20" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:30:34" , 
"departure_time" : "06:31:15" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:31:41" , 
"departure_time" : "06:32:21" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:32:40" , 
"departure_time" : "06:34:19" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:34:39" , 
"departure_time" : "06:36:16" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:36:37" , 
"departure_time" : "06:37:03" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "06:37:26" , 
"departure_time" : "06:38:17" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "06:39:51" , 
"departure_time" : "06:40:43" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "06:41:52" , 
"departure_time" : "06:42:13" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "06:45:21" , 
"departure_time" : "06:46:50" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "06:48:29" , 
"departure_time" : "06:48:29" , 
"distance_traveled" : 6.0843
} ], 
"3540" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "06:40:00" , 
"departure_time" : "06:42:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "06:43:31" , 
"departure_time" : "06:44:59" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "06:47:28" , 
"departure_time" : "06:47:30" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "06:49:02" , 
"departure_time" : "06:50:11" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "06:53:09" , 
"departure_time" : "06:53:36" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:53:27" , 
"departure_time" : "06:54:00" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:54:33" , 
"departure_time" : "06:55:46" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:57:13" , 
"departure_time" : "06:57:28" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:57:15" , 
"departure_time" : "06:57:42" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:58:27" , 
"departure_time" : "06:59:46" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:01:19" , 
"departure_time" : "07:02:07" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:02:48" , 
"departure_time" : "07:03:45" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:04:57" , 
"departure_time" : "07:06:33" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:07:36" , 
"departure_time" : "07:08:03" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "07:10:27" , 
"departure_time" : "07:11:48" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "07:13:21" , 
"departure_time" : "07:13:21" , 
"distance_traveled" : 6.0843
} ], 
"3541" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "07:05:00" , 
"departure_time" : "07:07:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "07:09:17" , 
"departure_time" : "07:10:29" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "07:12:12" , 
"departure_time" : "07:12:13" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:14:01" , 
"departure_time" : "07:15:04" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "07:18:03" , 
"departure_time" : "07:18:06" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:18:03" , 
"departure_time" : "07:18:46" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:19:43" , 
"departure_time" : "07:20:48" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:22:05" , 
"departure_time" : "07:23:11" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:23:06" , 
"departure_time" : "07:23:17" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:23:11" , 
"departure_time" : "07:23:29" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:25:18" , 
"departure_time" : "07:26:34" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:28:16" , 
"departure_time" : "07:29:52" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:30:36" , 
"departure_time" : "07:30:47" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:31:11" , 
"departure_time" : "07:32:50" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "07:36:39" , 
"departure_time" : "07:37:57" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "07:38:18" , 
"departure_time" : "07:38:18" , 
"distance_traveled" : 6.0843
} ], 
"3542" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "07:30:00" , 
"departure_time" : "07:32:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "07:34:25" , 
"departure_time" : "07:34:45" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "07:36:20" , 
"departure_time" : "07:37:39" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:40:19" , 
"departure_time" : "07:41:52" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "07:43:33" , 
"departure_time" : "07:44:24" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:43:51" , 
"departure_time" : "07:44:09" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:44:18" , 
"departure_time" : "07:44:33" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:46:15" , 
"departure_time" : "07:47:31" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:48:16" , 
"departure_time" : "07:49:45" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:49:29" , 
"departure_time" : "07:50:52" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:51:23" , 
"departure_time" : "07:52:48" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:53:25" , 
"departure_time" : "07:54:19" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:54:54" , 
"departure_time" : "07:55:51" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:56:57" , 
"departure_time" : "07:58:18" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "08:01:21" , 
"departure_time" : "08:01:51" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "08:02:30" , 
"departure_time" : "08:02:30" , 
"distance_traveled" : 6.0843
} ], 
"3543" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "07:55:00" , 
"departure_time" : "07:56:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "07:59:03" , 
"departure_time" : "08:00:03" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "08:02:00" , 
"departure_time" : "08:03:32" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:05:32" , 
"departure_time" : "08:06:43" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "08:08:11" , 
"departure_time" : "08:08:20" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:08:09" , 
"departure_time" : "08:09:38" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:10:29" , 
"departure_time" : "08:11:34" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:12:05" , 
"departure_time" : "08:13:35" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:13:30" , 
"departure_time" : "08:14:01" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:13:31" , 
"departure_time" : "08:14:20" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:15:49" , 
"departure_time" : "08:16:56" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:18:07" , 
"departure_time" : "08:19:39" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:20:32" , 
"departure_time" : "08:20:53" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:21:21" , 
"departure_time" : "08:22:18" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "08:25:57" , 
"departure_time" : "08:27:16" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "08:28:19" , 
"departure_time" : "08:28:19" , 
"distance_traveled" : 6.0843
} ], 
"3544" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "08:20:00" , 
"departure_time" : "08:22:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "08:24:03" , 
"departure_time" : "08:24:25" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "08:26:22" , 
"departure_time" : "08:27:27" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:30:05" , 
"departure_time" : "08:31:25" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "08:33:20" , 
"departure_time" : "08:34:29" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:34:09" , 
"departure_time" : "08:35:46" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:35:37" , 
"departure_time" : "08:37:13" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:37:36" , 
"departure_time" : "08:38:07" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:37:31" , 
"departure_time" : "08:37:50" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:38:19" , 
"departure_time" : "08:38:36" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:40:17" , 
"departure_time" : "08:40:21" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:42:04" , 
"departure_time" : "08:42:47" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:44:43" , 
"departure_time" : "08:45:57" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:47:14" , 
"departure_time" : "08:48:53" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "08:51:39" , 
"departure_time" : "08:52:41" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "08:53:02" , 
"departure_time" : "08:53:02" , 
"distance_traveled" : 6.0843
} ], 
"3545" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "08:45:00" , 
"departure_time" : "08:46:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "08:48:21" , 
"departure_time" : "08:49:03" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "08:51:42" , 
"departure_time" : "08:52:30" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:54:48" , 
"departure_time" : "08:54:59" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "08:57:11" , 
"departure_time" : "08:58:13" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:59:02" , 
"departure_time" : "08:59:18" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:59:16" , 
"departure_time" : "08:59:41" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:01:25" , 
"departure_time" : "09:01:35" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:02:10" , 
"departure_time" : "09:03:43" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:04:33" , 
"departure_time" : "09:04:45" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:05:12" , 
"departure_time" : "09:05:55" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:07:43" , 
"departure_time" : "09:08:42" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:09:59" , 
"departure_time" : "09:10:54" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:11:55" , 
"departure_time" : "09:12:39" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "09:15:44" , 
"departure_time" : "09:16:18" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "09:17:34" , 
"departure_time" : "09:17:34" , 
"distance_traveled" : 6.0843
} ], 
"3546" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "09:10:00" , 
"departure_time" : "09:11:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "09:13:49" , 
"departure_time" : "09:13:58" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "09:16:09" , 
"departure_time" : "09:17:09" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "09:20:00" , 
"departure_time" : "09:21:30" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "09:23:30" , 
"departure_time" : "09:24:57" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:24:27" , 
"departure_time" : "09:26:04" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:25:37" , 
"departure_time" : "09:26:47" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:27:10" , 
"departure_time" : "09:28:23" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:28:13" , 
"departure_time" : "09:29:22" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:29:09" , 
"departure_time" : "09:30:05" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:30:56" , 
"departure_time" : "09:31:41" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:32:45" , 
"departure_time" : "09:33:22" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:34:37" , 
"departure_time" : "09:35:12" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:36:35" , 
"departure_time" : "09:38:08" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "09:41:33" , 
"departure_time" : "09:42:30" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "09:42:57" , 
"departure_time" : "09:42:57" , 
"distance_traveled" : 6.0843
} ], 
"3547" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "09:35:00" , 
"departure_time" : "09:36:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "09:38:25" , 
"departure_time" : "09:39:34" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "09:42:09" , 
"departure_time" : "09:42:42" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "09:44:33" , 
"departure_time" : "09:44:44" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "09:47:11" , 
"departure_time" : "09:48:44" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:49:33" , 
"departure_time" : "09:50:16" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:49:43" , 
"departure_time" : "09:50:49" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:52:06" , 
"departure_time" : "09:53:00" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:52:54" , 
"departure_time" : "09:53:25" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:53:31" , 
"departure_time" : "09:54:27" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:55:56" , 
"departure_time" : "09:56:20" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:57:24" , 
"departure_time" : "09:57:49" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:59:25" , 
"departure_time" : "09:59:52" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "10:01:27" , 
"departure_time" : "10:02:01" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "10:05:34" , 
"departure_time" : "10:06:38" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "10:08:04" , 
"departure_time" : "10:08:04" , 
"distance_traveled" : 6.0843
} ], 
"3548" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "10:00:00" , 
"departure_time" : "10:02:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "10:04:07" , 
"departure_time" : "10:04:23" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "10:06:16" , 
"departure_time" : "10:06:59" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "10:09:43" , 
"departure_time" : "10:10:14" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "10:12:31" , 
"departure_time" : "10:12:37" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "10:13:06" , 
"departure_time" : "10:14:41" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "10:15:35" , 
"departure_time" : "10:17:08" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "10:17:33" , 
"departure_time" : "10:18:51" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "10:18:18" , 
"departure_time" : "10:19:20" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "10:19:02" , 
"departure_time" : "10:19:41" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "10:20:39" , 
"departure_time" : "10:20:46" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "10:22:07" , 
"departure_time" : "10:23:22" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "10:25:15" , 
"departure_time" : "10:26:15" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "10:27:00" , 
"departure_time" : "10:28:26" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "10:31:26" , 
"departure_time" : "10:31:45" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "10:32:19" , 
"departure_time" : "10:32:19" , 
"distance_traveled" : 6.0843
} ], 
"3549" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "10:25:00" , 
"departure_time" : "10:26:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "10:28:51" , 
"departure_time" : "10:30:25" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "10:32:34" , 
"departure_time" : "10:33:51" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "10:35:17" , 
"departure_time" : "10:35:20" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "10:37:03" , 
"departure_time" : "10:38:14" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "10:39:11" , 
"departure_time" : "10:39:45" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "10:39:34" , 
"departure_time" : "10:40:10" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "10:41:36" , 
"departure_time" : "10:42:11" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "10:42:35" , 
"departure_time" : "10:42:59" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "10:43:24" , 
"departure_time" : "10:44:17" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "10:45:53" , 
"departure_time" : "10:46:48" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "10:47:55" , 
"departure_time" : "10:48:53" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "10:49:58" , 
"departure_time" : "10:51:20" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "10:52:22" , 
"departure_time" : "10:53:34" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "10:56:12" , 
"departure_time" : "10:56:22" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "10:57:10" , 
"departure_time" : "10:57:10" , 
"distance_traveled" : 6.0843
} ], 
"3550" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "10:50:00" , 
"departure_time" : "10:50:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "10:53:44" , 
"departure_time" : "10:53:59" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "10:56:15" , 
"departure_time" : "10:57:22" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "11:00:07" , 
"departure_time" : "11:01:08" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "11:03:01" , 
"departure_time" : "11:03:37" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "11:03:36" , 
"departure_time" : "11:05:15" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "11:05:39" , 
"departure_time" : "11:06:49" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "11:07:10" , 
"departure_time" : "11:08:30" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "11:08:20" , 
"departure_time" : "11:09:06" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "11:08:46" , 
"departure_time" : "11:09:17" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "11:10:31" , 
"departure_time" : "11:11:22" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "11:12:51" , 
"departure_time" : "11:13:42" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "11:14:51" , 
"departure_time" : "11:15:09" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "11:16:18" , 
"departure_time" : "11:17:48" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "11:21:30" , 
"departure_time" : "11:22:24" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "11:22:54" , 
"departure_time" : "11:22:54" , 
"distance_traveled" : 6.0843
} ], 
"3551" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "11:15:00" , 
"departure_time" : "11:16:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "11:18:37" , 
"departure_time" : "11:20:05" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "11:22:28" , 
"departure_time" : "11:24:00" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "11:25:32" , 
"departure_time" : "11:27:11" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "11:28:39" , 
"departure_time" : "11:30:10" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "11:29:31" , 
"departure_time" : "11:31:04" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "11:30:33" , 
"departure_time" : "11:31:58" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "11:32:25" , 
"departure_time" : "11:33:42" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "11:33:17" , 
"departure_time" : "11:34:38" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "11:34:21" , 
"departure_time" : "11:34:46" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "11:35:25" , 
"departure_time" : "11:36:55" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "11:38:30" , 
"departure_time" : "11:39:04" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "11:39:34" , 
"departure_time" : "11:39:36" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "11:41:02" , 
"departure_time" : "11:41:48" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "11:45:46" , 
"departure_time" : "11:47:07" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "11:48:21" , 
"departure_time" : "11:48:21" , 
"distance_traveled" : 6.0843
} ], 
"3552" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "11:40:00" , 
"departure_time" : "11:42:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "11:43:55" , 
"departure_time" : "11:44:21" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "11:46:26" , 
"departure_time" : "11:46:57" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "11:49:31" , 
"departure_time" : "11:50:16" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "11:52:45" , 
"departure_time" : "11:54:00" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "11:54:15" , 
"departure_time" : "11:55:50" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "11:55:35" , 
"departure_time" : "11:55:54" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "11:56:19" , 
"departure_time" : "11:57:05" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "11:57:46" , 
"departure_time" : "11:58:59" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "11:59:13" , 
"departure_time" : "12:00:32" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "12:01:19" , 
"departure_time" : "12:02:24" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "12:03:05" , 
"departure_time" : "12:04:25" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "12:05:20" , 
"departure_time" : "12:06:18" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "12:06:58" , 
"departure_time" : "12:07:26" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "12:10:28" , 
"departure_time" : "12:11:56" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "12:13:28" , 
"departure_time" : "12:13:28" , 
"distance_traveled" : 6.0843
} ], 
"3553" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "12:05:00" , 
"departure_time" : "12:07:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "12:09:20" , 
"departure_time" : "12:10:02" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "12:11:42" , 
"departure_time" : "12:12:46" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "12:15:04" , 
"departure_time" : "12:15:35" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "12:17:31" , 
"departure_time" : "12:19:10" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "12:19:39" , 
"departure_time" : "12:20:03" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "12:19:24" , 
"departure_time" : "12:20:33" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "12:22:09" , 
"departure_time" : "12:23:02" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "12:22:53" , 
"departure_time" : "12:23:26" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "12:23:33" , 
"departure_time" : "12:25:05" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "12:26:32" , 
"departure_time" : "12:27:51" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "12:28:19" , 
"departure_time" : "12:29:23" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "12:30:04" , 
"departure_time" : "12:30:36" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "12:31:32" , 
"departure_time" : "12:31:49" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "12:35:17" , 
"departure_time" : "12:35:30" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "12:37:13" , 
"departure_time" : "12:37:13" , 
"distance_traveled" : 6.0843
} ], 
"3554" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "12:30:00" , 
"departure_time" : "12:31:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "12:34:05" , 
"departure_time" : "12:34:28" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "12:36:23" , 
"departure_time" : "12:36:36" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "12:39:13" , 
"departure_time" : "12:40:42" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "12:43:29" , 
"departure_time" : "12:43:34" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "12:43:05" , 
"departure_time" : "12:44:29" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "12:45:24" , 
"departure_time" : "12:46:10" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "12:46:46" , 
"departure_time" : "12:47:21" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "12:47:35" , 
"departure_time" : "12:48:29" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "12:48:54" , 
"departure_time" : "12:49:26" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "12:50:32" , 
"departure_time" : "12:50:53" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "12:52:21" , 
"departure_time" : "12:53:34" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "12:55:13" , 
"departure_time" : "12:55:43" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "12:56:30" , 
"departure_time" : "12:56:35" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "13:00:05" , 
"departure_time" : "13:00:45" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "13:02:40" , 
"departure_time" : "13:02:40" , 
"distance_traveled" : 6.0843
} ], 
"3555" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "12:55:00" , 
"departure_time" : "12:56:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "12:59:00" , 
"departure_time" : "12:59:31" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "13:01:31" , 
"departure_time" : "13:02:01" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "13:04:30" , 
"departure_time" : "13:05:15" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "13:07:45" , 
"departure_time" : "13:08:42" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "13:08:57" , 
"departure_time" : "13:09:09" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "13:09:12" , 
"departure_time" : "13:10:06" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "13:11:54" , 
"departure_time" : "13:13:13" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "13:13:19" , 
"departure_time" : "13:14:18" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "13:13:59" , 
"departure_time" : "13:14:12" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "13:15:13" , 
"departure_time" : "13:16:45" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "13:18:32" , 
"departure_time" : "13:18:37" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "13:19:05" , 
"departure_time" : "13:19:57" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "13:21:52" , 
"departure_time" : "13:22:19" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "13:25:27" , 
"departure_time" : "13:25:50" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "13:27:23" , 
"departure_time" : "13:27:23" , 
"distance_traveled" : 6.0843
} ], 
"3556" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "13:20:00" , 
"departure_time" : "13:21:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "13:23:53" , 
"departure_time" : "13:24:41" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "13:26:48" , 
"departure_time" : "13:28:12" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "13:30:24" , 
"departure_time" : "13:30:55" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "13:32:31" , 
"departure_time" : "13:32:33" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "13:33:02" , 
"departure_time" : "13:33:22" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "13:34:20" , 
"departure_time" : "13:34:51" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "13:36:31" , 
"departure_time" : "13:36:34" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "13:37:03" , 
"departure_time" : "13:37:48" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "13:38:45" , 
"departure_time" : "13:39:26" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "13:40:41" , 
"departure_time" : "13:41:53" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "13:43:12" , 
"departure_time" : "13:43:30" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "13:44:18" , 
"departure_time" : "13:45:28" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "13:47:10" , 
"departure_time" : "13:48:28" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "13:51:18" , 
"departure_time" : "13:51:42" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "13:52:24" , 
"departure_time" : "13:52:24" , 
"distance_traveled" : 6.0843
} ], 
"3557" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "13:45:00" , 
"departure_time" : "13:45:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "13:48:16" , 
"departure_time" : "13:49:46" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "13:52:30" , 
"departure_time" : "13:53:31" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "13:55:01" , 
"departure_time" : "13:56:41" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "13:58:40" , 
"departure_time" : "13:59:10" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "13:58:30" , 
"departure_time" : "14:00:08" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "14:00:38" , 
"departure_time" : "14:00:54" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "14:01:16" , 
"departure_time" : "14:02:47" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "14:03:31" , 
"departure_time" : "14:04:01" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "14:03:30" , 
"departure_time" : "14:05:04" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "14:06:34" , 
"departure_time" : "14:06:47" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "14:07:13" , 
"departure_time" : "14:08:45" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "14:10:32" , 
"departure_time" : "14:12:03" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "14:12:31" , 
"departure_time" : "14:13:15" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "14:15:44" , 
"departure_time" : "14:17:00" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "14:18:16" , 
"departure_time" : "14:18:16" , 
"distance_traveled" : 6.0843
} ], 
"3558" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "14:10:00" , 
"departure_time" : "14:12:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "14:13:45" , 
"departure_time" : "14:15:04" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "14:17:19" , 
"departure_time" : "14:18:52" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "14:20:33" , 
"departure_time" : "14:21:26" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "14:22:53" , 
"departure_time" : "14:23:24" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "14:23:31" , 
"departure_time" : "14:24:07" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "14:24:36" , 
"departure_time" : "14:26:15" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "14:27:39" , 
"departure_time" : "14:29:09" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "14:28:30" , 
"departure_time" : "14:29:02" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "14:28:32" , 
"departure_time" : "14:29:07" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "14:30:35" , 
"departure_time" : "14:31:11" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "14:32:36" , 
"departure_time" : "14:34:04" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "14:35:28" , 
"departure_time" : "14:36:44" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "14:37:16" , 
"departure_time" : "14:37:57" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "14:40:41" , 
"departure_time" : "14:41:12" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "14:42:31" , 
"departure_time" : "14:42:31" , 
"distance_traveled" : 6.0843
} ], 
"3559" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "14:35:00" , 
"departure_time" : "14:35:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "14:38:27" , 
"departure_time" : "14:39:50" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "14:42:23" , 
"departure_time" : "14:43:13" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "14:44:50" , 
"departure_time" : "14:45:08" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "14:47:18" , 
"departure_time" : "14:47:45" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "14:48:27" , 
"departure_time" : "14:49:50" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "14:50:23" , 
"departure_time" : "14:51:46" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "14:52:23" , 
"departure_time" : "14:53:17" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "14:52:54" , 
"departure_time" : "14:53:33" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "14:53:39" , 
"departure_time" : "14:54:05" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "14:55:26" , 
"departure_time" : "14:56:54" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "14:58:28" , 
"departure_time" : "14:59:00" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "14:59:32" , 
"departure_time" : "15:00:58" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "15:02:26" , 
"departure_time" : "15:02:35" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "15:05:09" , 
"departure_time" : "15:06:35" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "15:08:26" , 
"departure_time" : "15:08:26" , 
"distance_traveled" : 6.0843
} ], 
"3560" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "15:00:00" , 
"departure_time" : "15:02:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "15:04:05" , 
"departure_time" : "15:05:35" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "15:07:30" , 
"departure_time" : "15:08:45" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "15:10:15" , 
"departure_time" : "15:10:24" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "15:12:09" , 
"departure_time" : "15:12:12" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:13:03" , 
"departure_time" : "15:13:56" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:14:53" , 
"departure_time" : "15:15:56" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:17:03" , 
"departure_time" : "15:17:35" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:17:32" , 
"departure_time" : "15:18:06" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:18:34" , 
"departure_time" : "15:19:56" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:21:22" , 
"departure_time" : "15:23:00" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:23:38" , 
"departure_time" : "15:24:01" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:24:23" , 
"departure_time" : "15:24:25" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "15:26:02" , 
"departure_time" : "15:26:26" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "15:30:24" , 
"departure_time" : "15:31:10" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "15:32:46" , 
"departure_time" : "15:32:46" , 
"distance_traveled" : 6.0843
} ], 
"3561" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "15:25:00" , 
"departure_time" : "15:26:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "15:29:04" , 
"departure_time" : "15:29:54" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "15:31:50" , 
"departure_time" : "15:33:16" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "15:35:26" , 
"departure_time" : "15:35:51" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "15:37:25" , 
"departure_time" : "15:38:45" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:39:20" , 
"departure_time" : "15:40:30" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:40:10" , 
"departure_time" : "15:40:12" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:41:02" , 
"departure_time" : "15:42:41" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:43:39" , 
"departure_time" : "15:44:42" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:44:03" , 
"departure_time" : "15:44:23" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:45:20" , 
"departure_time" : "15:46:36" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:48:16" , 
"departure_time" : "15:48:56" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:49:40" , 
"departure_time" : "15:49:43" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "15:51:03" , 
"departure_time" : "15:52:07" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "15:56:04" , 
"departure_time" : "15:57:19" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "15:58:15" , 
"departure_time" : "15:58:15" , 
"distance_traveled" : 6.0843
} ], 
"3562" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "15:50:00" , 
"departure_time" : "15:52:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "15:53:50" , 
"departure_time" : "15:53:58" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "15:56:08" , 
"departure_time" : "15:56:40" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "15:59:32" , 
"departure_time" : "16:01:01" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "16:03:29" , 
"departure_time" : "16:03:35" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:03:06" , 
"departure_time" : "16:03:13" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:04:07" , 
"departure_time" : "16:05:02" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:06:55" , 
"departure_time" : "16:07:56" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:08:01" , 
"departure_time" : "16:08:49" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:08:48" , 
"departure_time" : "16:10:12" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:11:24" , 
"departure_time" : "16:12:13" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:12:49" , 
"departure_time" : "16:14:28" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:15:39" , 
"departure_time" : "16:17:09" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:17:30" , 
"departure_time" : "16:18:41" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "16:21:11" , 
"departure_time" : "16:21:55" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "16:22:44" , 
"departure_time" : "16:22:44" , 
"distance_traveled" : 6.0843
} ], 
"3563" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "16:15:00" , 
"departure_time" : "16:16:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "16:18:52" , 
"departure_time" : "16:19:31" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "16:21:39" , 
"departure_time" : "16:22:22" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:24:43" , 
"departure_time" : "16:25:43" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "16:28:00" , 
"departure_time" : "16:29:00" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:29:00" , 
"departure_time" : "16:30:11" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:30:11" , 
"departure_time" : "16:31:19" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:32:08" , 
"departure_time" : "16:33:45" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:33:37" , 
"departure_time" : "16:34:54" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:34:17" , 
"departure_time" : "16:35:01" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:35:44" , 
"departure_time" : "16:36:07" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:37:23" , 
"departure_time" : "16:38:14" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:39:51" , 
"departure_time" : "16:40:42" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:41:51" , 
"departure_time" : "16:42:52" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "16:46:01" , 
"departure_time" : "16:46:36" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "16:47:35" , 
"departure_time" : "16:47:35" , 
"distance_traveled" : 6.0843
} ], 
"3564" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "16:40:00" , 
"departure_time" : "16:40:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "16:43:13" , 
"departure_time" : "16:43:49" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "16:46:36" , 
"departure_time" : "16:48:14" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:50:38" , 
"departure_time" : "16:51:26" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "16:52:48" , 
"departure_time" : "16:53:08" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:53:20" , 
"departure_time" : "16:53:46" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:54:26" , 
"departure_time" : "16:54:37" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:56:11" , 
"departure_time" : "16:57:11" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:58:00" , 
"departure_time" : "16:58:16" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:58:16" , 
"departure_time" : "16:59:35" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:01:19" , 
"departure_time" : "17:01:48" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:02:29" , 
"departure_time" : "17:02:31" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:04:02" , 
"departure_time" : "17:04:54" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:06:52" , 
"departure_time" : "17:07:18" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "17:10:26" , 
"departure_time" : "17:11:21" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "17:12:55" , 
"departure_time" : "17:12:55" , 
"distance_traveled" : 6.0843
} ], 
"3565" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "17:05:00" , 
"departure_time" : "17:07:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "17:09:08" , 
"departure_time" : "17:10:12" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "17:12:04" , 
"departure_time" : "17:12:21" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "17:14:17" , 
"departure_time" : "17:15:53" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "17:18:36" , 
"departure_time" : "17:19:40" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:19:04" , 
"departure_time" : "17:19:06" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:19:02" , 
"departure_time" : "17:19:24" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:21:22" , 
"departure_time" : "17:22:03" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:22:41" , 
"departure_time" : "17:24:13" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:24:32" , 
"departure_time" : "17:26:11" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:26:39" , 
"departure_time" : "17:26:51" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:27:12" , 
"departure_time" : "17:27:24" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:29:12" , 
"departure_time" : "17:29:24" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:31:12" , 
"departure_time" : "17:32:47" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "17:36:35" , 
"departure_time" : "17:36:58" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "17:37:23" , 
"departure_time" : "17:37:23" , 
"distance_traveled" : 6.0843
} ], 
"3566" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "17:30:00" , 
"departure_time" : "17:30:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "17:33:34" , 
"departure_time" : "17:33:54" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "17:36:20" , 
"departure_time" : "17:37:34" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "17:40:14" , 
"departure_time" : "17:41:50" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "17:43:36" , 
"departure_time" : "17:43:44" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:43:08" , 
"departure_time" : "17:43:16" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:44:08" , 
"departure_time" : "17:45:00" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:46:52" , 
"departure_time" : "17:47:40" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:47:48" , 
"departure_time" : "17:49:24" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:49:36" , 
"departure_time" : "17:50:24" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:50:48" , 
"departure_time" : "17:52:11" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:53:23" , 
"departure_time" : "17:53:45" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:54:22" , 
"departure_time" : "17:55:11" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:56:49" , 
"departure_time" : "17:57:08" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "18:00:19" , 
"departure_time" : "18:00:24" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "18:02:05" , 
"departure_time" : "18:02:05" , 
"distance_traveled" : 6.0843
} ], 
"3567" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "17:55:00" , 
"departure_time" : "17:56:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "17:59:06" , 
"departure_time" : "17:59:21" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "18:01:15" , 
"departure_time" : "18:01:51" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:04:36" , 
"departure_time" : "18:05:43" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "18:08:07" , 
"departure_time" : "18:09:28" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:09:21" , 
"departure_time" : "18:10:47" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:10:26" , 
"departure_time" : "18:10:42" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:11:16" , 
"departure_time" : "18:12:21" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:13:05" , 
"departure_time" : "18:13:52" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:13:47" , 
"departure_time" : "18:14:11" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:15:24" , 
"departure_time" : "18:16:52" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:18:28" , 
"departure_time" : "18:19:14" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:19:46" , 
"departure_time" : "18:21:25" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:22:39" , 
"departure_time" : "18:24:06" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "18:26:27" , 
"departure_time" : "18:27:30" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "18:28:03" , 
"departure_time" : "18:28:03" , 
"distance_traveled" : 6.0843
} ], 
"3568" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "18:20:00" , 
"departure_time" : "18:21:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "18:23:44" , 
"departure_time" : "18:24:30" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "18:26:46" , 
"departure_time" : "18:27:27" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:29:41" , 
"departure_time" : "18:29:52" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "18:32:11" , 
"departure_time" : "18:33:01" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:33:50" , 
"departure_time" : "18:34:34" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:34:44" , 
"departure_time" : "18:35:11" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:36:27" , 
"departure_time" : "18:36:47" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:37:20" , 
"departure_time" : "18:38:34" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:39:14" , 
"departure_time" : "18:39:59" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:40:45" , 
"departure_time" : "18:41:23" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:42:38" , 
"departure_time" : "18:43:18" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:44:40" , 
"departure_time" : "18:45:36" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:46:56" , 
"departure_time" : "18:48:02" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "18:51:06" , 
"departure_time" : "18:51:25" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "18:52:19" , 
"departure_time" : "18:52:19" , 
"distance_traveled" : 6.0843
} ], 
"3569" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "18:45:00" , 
"departure_time" : "18:45:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "18:48:13" , 
"departure_time" : "18:49:49" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "18:52:36" , 
"departure_time" : "18:53:00" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:54:24" , 
"departure_time" : "18:54:57" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "18:57:33" , 
"departure_time" : "18:58:14" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:58:41" , 
"departure_time" : "19:00:06" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:00:25" , 
"departure_time" : "19:01:54" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "19:02:29" , 
"departure_time" : "19:02:30" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "19:02:01" , 
"departure_time" : "19:03:16" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "19:04:15" , 
"departure_time" : "19:05:33" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:06:18" , 
"departure_time" : "19:06:38" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:07:20" , 
"departure_time" : "19:08:50" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:10:30" , 
"departure_time" : "19:11:28" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "19:11:58" , 
"departure_time" : "19:12:57" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "19:15:59" , 
"departure_time" : "19:17:04" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "19:18:05" , 
"departure_time" : "19:18:05" , 
"distance_traveled" : 6.0843
} ], 
"3570" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "19:10:00" , 
"departure_time" : "19:12:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "19:14:30" , 
"departure_time" : "19:15:48" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "19:17:18" , 
"departure_time" : "19:17:45" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "19:19:27" , 
"departure_time" : "19:20:38" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "19:23:11" , 
"departure_time" : "19:24:35" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "19:24:24" , 
"departure_time" : "19:26:01" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:25:37" , 
"departure_time" : "19:25:58" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "19:26:21" , 
"departure_time" : "19:27:23" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "19:28:02" , 
"departure_time" : "19:28:33" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "19:28:31" , 
"departure_time" : "19:28:51" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:30:20" , 
"departure_time" : "19:31:29" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:33:09" , 
"departure_time" : "19:34:44" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:35:35" , 
"departure_time" : "19:37:06" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "19:37:31" , 
"departure_time" : "19:38:24" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "19:40:53" , 
"departure_time" : "19:41:10" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "19:42:17" , 
"departure_time" : "19:42:17" , 
"distance_traveled" : 6.0843
} ], 
"3571" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "19:35:00" , 
"departure_time" : "19:35:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "19:38:33" , 
"departure_time" : "19:39:11" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "19:41:38" , 
"departure_time" : "19:41:46" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "19:44:08" , 
"departure_time" : "19:45:35" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "19:48:27" , 
"departure_time" : "19:48:37" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "19:48:10" , 
"departure_time" : "19:48:24" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:49:14" , 
"departure_time" : "19:50:01" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "19:51:47" , 
"departure_time" : "19:52:05" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "19:52:18" , 
"departure_time" : "19:52:50" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "19:53:32" , 
"departure_time" : "19:54:30" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:55:58" , 
"departure_time" : "19:56:56" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:57:58" , 
"departure_time" : "19:59:11" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "20:00:13" , 
"departure_time" : "20:00:28" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "20:01:15" , 
"departure_time" : "20:02:31" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "20:06:16" , 
"departure_time" : "20:06:58" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "20:07:42" , 
"departure_time" : "20:07:42" , 
"distance_traveled" : 6.0843
} ], 
"3572" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "20:00:00" , 
"departure_time" : "20:00:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "20:03:12" , 
"departure_time" : "20:04:41" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "20:07:29" , 
"departure_time" : "20:08:48" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "20:10:19" , 
"departure_time" : "20:11:40" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "20:13:21" , 
"departure_time" : "20:14:08" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "20:13:47" , 
"departure_time" : "20:15:08" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "20:15:21" , 
"departure_time" : "20:16:40" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "20:17:19" , 
"departure_time" : "20:17:23" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "20:17:04" , 
"departure_time" : "20:17:15" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "20:18:11" , 
"departure_time" : "20:19:23" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "20:21:12" , 
"departure_time" : "20:21:43" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "20:22:31" , 
"departure_time" : "20:22:59" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "20:24:28" , 
"departure_time" : "20:25:59" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "20:27:31" , 
"departure_time" : "20:28:30" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "20:30:59" , 
"departure_time" : "20:31:15" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "20:32:16" , 
"departure_time" : "20:32:16" , 
"distance_traveled" : 6.0843
} ], 
"3573" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "20:25:00" , 
"departure_time" : "20:25:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "20:28:26" , 
"departure_time" : "20:28:36" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "20:31:10" , 
"departure_time" : "20:31:32" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "20:34:22" , 
"departure_time" : "20:35:30" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "20:38:08" , 
"departure_time" : "20:38:16" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "20:38:08" , 
"departure_time" : "20:38:15" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "20:39:07" , 
"departure_time" : "20:39:15" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "20:41:08" , 
"departure_time" : "20:42:47" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "20:43:39" , 
"departure_time" : "20:44:28" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "20:43:49" , 
"departure_time" : "20:44:23" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "20:45:34" , 
"departure_time" : "20:47:08" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "20:48:34" , 
"departure_time" : "20:49:11" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "20:49:37" , 
"departure_time" : "20:50:48" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "20:52:11" , 
"departure_time" : "20:52:46" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "20:55:35" , 
"departure_time" : "20:55:46" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "20:57:11" , 
"departure_time" : "20:57:11" , 
"distance_traveled" : 6.0843
} ], 
"3574" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "20:50:00" , 
"departure_time" : "20:51:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "20:54:25" , 
"departure_time" : "20:55:43" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "20:57:18" , 
"departure_time" : "20:57:50" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "20:59:32" , 
"departure_time" : "21:01:01" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "21:03:29" , 
"departure_time" : "21:04:45" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "21:04:16" , 
"departure_time" : "21:05:07" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "21:04:51" , 
"departure_time" : "21:05:32" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "21:06:41" , 
"departure_time" : "21:07:24" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "21:07:43" , 
"departure_time" : "21:08:50" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "21:09:07" , 
"departure_time" : "21:10:42" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "21:11:35" , 
"departure_time" : "21:12:24" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "21:12:49" , 
"departure_time" : "21:13:42" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "21:14:53" , 
"departure_time" : "21:16:25" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "21:17:32" , 
"departure_time" : "21:18:41" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "21:21:09" , 
"departure_time" : "21:22:48" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "21:23:39" , 
"departure_time" : "21:23:39" , 
"distance_traveled" : 6.0843
} ], 
"3575" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "21:15:00" , 
"departure_time" : "21:17:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "21:18:54" , 
"departure_time" : "21:19:00" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "21:21:06" , 
"departure_time" : "21:21:44" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "21:24:38" , 
"departure_time" : "21:25:11" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "21:27:33" , 
"departure_time" : "21:28:12" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "21:28:39" , 
"departure_time" : "21:29:16" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "21:29:37" , 
"departure_time" : "21:29:55" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "21:31:18" , 
"departure_time" : "21:31:22" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "21:32:04" , 
"departure_time" : "21:33:01" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "21:33:57" , 
"departure_time" : "21:34:37" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "21:35:40" , 
"departure_time" : "21:37:11" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "21:38:31" , 
"departure_time" : "21:39:45" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "21:40:14" , 
"departure_time" : "21:41:24" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "21:42:10" , 
"departure_time" : "21:43:41" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "21:46:31" , 
"departure_time" : "21:47:48" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "21:48:17" , 
"departure_time" : "21:48:17" , 
"distance_traveled" : 6.0843
} ], 
"3576" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "21:40:00" , 
"departure_time" : "21:42:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "21:44:07" , 
"departure_time" : "21:45:22" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "21:47:15" , 
"departure_time" : "21:47:46" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "21:49:31" , 
"departure_time" : "21:50:46" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "21:53:15" , 
"departure_time" : "21:54:44" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "21:54:29" , 
"departure_time" : "21:55:52" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "21:55:23" , 
"departure_time" : "21:56:10" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "21:56:47" , 
"departure_time" : "21:57:20" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "21:57:33" , 
"departure_time" : "21:57:50" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "21:58:17" , 
"departure_time" : "21:58:25" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "22:00:08" , 
"departure_time" : "22:00:47" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "22:02:39" , 
"departure_time" : "22:02:47" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "22:04:08" , 
"departure_time" : "22:04:33" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "22:06:25" , 
"departure_time" : "22:07:44" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "22:11:19" , 
"departure_time" : "22:12:13" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "22:12:54" , 
"departure_time" : "22:12:54" , 
"distance_traveled" : 6.0843
} ], 
"3577" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "22:05:00" , 
"departure_time" : "22:07:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "22:09:11" , 
"departure_time" : "22:09:21" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "22:11:10" , 
"departure_time" : "22:12:09" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "22:14:59" , 
"departure_time" : "22:15:27" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "22:17:28" , 
"departure_time" : "22:18:18" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "22:18:50" , 
"departure_time" : "22:18:58" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "22:19:08" , 
"departure_time" : "22:20:28" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "22:22:20" , 
"departure_time" : "22:22:48" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "22:22:28" , 
"departure_time" : "22:23:28" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "22:24:00" , 
"departure_time" : "22:25:02" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "22:26:02" , 
"departure_time" : "22:27:32" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "22:28:30" , 
"departure_time" : "22:29:57" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "22:30:27" , 
"departure_time" : "22:31:26" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "22:31:59" , 
"departure_time" : "22:32:02" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "22:35:03" , 
"departure_time" : "22:36:41" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "22:38:38" , 
"departure_time" : "22:38:38" , 
"distance_traveled" : 6.0843
} ], 
"3578" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "22:30:00" , 
"departure_time" : "22:32:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "22:33:29" , 
"departure_time" : "22:34:40" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "22:37:11" , 
"departure_time" : "22:38:26" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "22:40:15" , 
"departure_time" : "22:40:25" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "22:42:10" , 
"departure_time" : "22:43:13" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "22:44:03" , 
"departure_time" : "22:44:08" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "22:44:05" , 
"departure_time" : "22:44:32" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "22:46:27" , 
"departure_time" : "22:48:05" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "22:48:38" , 
"departure_time" : "22:49:43" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "22:49:05" , 
"departure_time" : "22:49:16" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "22:50:11" , 
"departure_time" : "22:50:31" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "22:52:20" , 
"departure_time" : "22:52:29" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "22:54:09" , 
"departure_time" : "22:55:39" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "22:57:30" , 
"departure_time" : "22:58:34" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "23:01:04" , 
"departure_time" : "23:01:19" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "23:02:15" , 
"departure_time" : "23:02:15" , 
"distance_traveled" : 6.0843
} ], 
"3579" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "22:55:00" , 
"departure_time" : "22:56:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "22:58:48" , 
"departure_time" : "22:59:47" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "23:01:59" , 
"departure_time" : "23:02:13" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "23:04:14" , 
"departure_time" : "23:05:34" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "23:08:20" , 
"departure_time" : "23:09:51" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "23:09:31" , 
"departure_time" : "23:09:38" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "23:09:07" , 
"departure_time" : "23:09:48" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "23:11:41" , 
"departure_time" : "23:13:00" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "23:13:19" , 
"departure_time" : "23:13:25" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "23:13:06" , 
"departure_time" : "23:13:15" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "23:15:09" , 
"departure_time" : "23:16:29" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "23:18:20" , 
"departure_time" : "23:18:49" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "23:19:29" , 
"departure_time" : "23:19:52" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "23:21:23" , 
"departure_time" : "23:21:49" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "23:25:26" , 
"departure_time" : "23:26:35" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "23:28:09" , 
"departure_time" : "23:28:09" , 
"distance_traveled" : 6.0843
} ], 
"3580" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "23:20:00" , 
"departure_time" : "23:21:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "23:23:02" , 
"departure_time" : "23:23:33" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "23:26:31" , 
"departure_time" : "23:26:38" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "23:29:07" , 
"departure_time" : "23:30:16" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "23:33:09" , 
"departure_time" : "23:33:12" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "23:33:03" , 
"departure_time" : "23:33:38" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "23:34:35" , 
"departure_time" : "23:34:54" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "23:36:19" , 
"departure_time" : "23:37:34" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "23:38:15" , 
"departure_time" : "23:39:33" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "23:39:18" , 
"departure_time" : "23:39:54" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "23:40:36" , 
"departure_time" : "23:41:05" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "23:42:29" , 
"departure_time" : "23:42:40" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "23:44:11" , 
"departure_time" : "23:45:14" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "23:47:03" , 
"departure_time" : "23:47:06" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "23:50:03" , 
"departure_time" : "23:50:41" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "23:52:38" , 
"departure_time" : "23:52:38" , 
"distance_traveled" : 6.0843
} ], 
"3581" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "04:10:00" , 
"departure_time" : "04:11:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "04:12:32" , 
"departure_time" : "04:13:24" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "04:16:52" , 
"departure_time" : "04:18:09" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "04:19:17" , 
"departure_time" : "04:20:29" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "04:21:12" , 
"departure_time" : "04:22:32" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "04:23:20" , 
"departure_time" : "04:23:47" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "04:24:27" , 
"departure_time" : "04:25:36" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "04:26:09" , 
"departure_time" : "04:27:24" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "04:27:15" , 
"departure_time" : "04:28:37" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "04:28:22" , 
"departure_time" : "04:28:30" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "04:28:08" , 
"departure_time" : "04:28:45" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "04:30:37" , 
"departure_time" : "04:30:37" , 
"distance_traveled" : 4.8572
} ], 
"3582" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "04:49:00" , 
"departure_time" : "04:50:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "04:52:16" , 
"departure_time" : "04:53:23" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "04:56:07" , 
"departure_time" : "04:56:23" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "04:57:16" , 
"departure_time" : "04:58:54" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "05:00:38" , 
"departure_time" : "05:02:12" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "05:02:34" , 
"departure_time" : "05:04:14" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "05:04:40" , 
"departure_time" : "05:05:07" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "05:04:27" , 
"departure_time" : "05:04:36" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "05:05:09" , 
"departure_time" : "05:05:45" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "05:06:36" , 
"departure_time" : "05:06:40" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "05:07:04" , 
"departure_time" : "05:07:13" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "05:09:09" , 
"departure_time" : "05:09:09" , 
"distance_traveled" : 4.8572
} ], 
"3583" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "04:55:00" , 
"departure_time" : "04:56:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "04:58:07" , 
"departure_time" : "04:58:16" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "05:01:09" , 
"departure_time" : "05:02:07" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "05:03:58" , 
"departure_time" : "05:05:31" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "05:06:33" , 
"departure_time" : "05:08:07" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "05:08:34" , 
"departure_time" : "05:10:13" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "05:10:39" , 
"departure_time" : "05:11:17" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "05:10:38" , 
"departure_time" : "05:12:15" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "05:12:37" , 
"departure_time" : "05:13:46" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "05:13:09" , 
"departure_time" : "05:14:14" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "05:14:05" , 
"departure_time" : "05:14:12" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "05:15:07" , 
"departure_time" : "05:15:07" , 
"distance_traveled" : 4.8572
} ], 
"3584" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "05:03:00" , 
"departure_time" : "05:04:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "05:06:13" , 
"departure_time" : "05:07:14" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "05:10:01" , 
"departure_time" : "05:11:12" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "05:12:11" , 
"departure_time" : "05:13:29" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "05:14:18" , 
"departure_time" : "05:14:22" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "05:15:04" , 
"departure_time" : "05:16:06" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "05:18:02" , 
"departure_time" : "05:18:45" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "05:18:43" , 
"departure_time" : "05:18:51" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "05:19:08" , 
"departure_time" : "05:19:38" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "05:20:30" , 
"departure_time" : "05:21:10" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "05:21:40" , 
"departure_time" : "05:21:47" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "05:23:07" , 
"departure_time" : "05:23:07" , 
"distance_traveled" : 4.8572
} ], 
"3585" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "05:17:00" , 
"departure_time" : "05:17:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "05:19:19" , 
"departure_time" : "05:20:59" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "05:24:40" , 
"departure_time" : "05:25:13" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "05:25:33" , 
"departure_time" : "05:25:56" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "05:27:23" , 
"departure_time" : "05:28:54" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "05:30:31" , 
"departure_time" : "05:32:02" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "05:32:31" , 
"departure_time" : "05:33:58" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "05:33:27" , 
"departure_time" : "05:34:13" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "05:33:46" , 
"departure_time" : "05:34:10" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "05:34:24" , 
"departure_time" : "05:35:11" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "05:35:47" , 
"departure_time" : "05:36:58" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "05:38:11" , 
"departure_time" : "05:38:11" , 
"distance_traveled" : 4.8572
} ], 
"3586" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "05:34:00" , 
"departure_time" : "05:36:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "05:37:38" , 
"departure_time" : "05:39:17" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "05:41:39" , 
"departure_time" : "05:42:46" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "05:43:07" , 
"departure_time" : "05:44:03" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "05:44:56" , 
"departure_time" : "05:45:32" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "05:46:36" , 
"departure_time" : "05:47:16" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "05:48:40" , 
"departure_time" : "05:49:26" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "05:49:46" , 
"departure_time" : "05:51:25" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "05:51:39" , 
"departure_time" : "05:51:40" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "05:51:01" , 
"departure_time" : "05:51:55" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "05:52:54" , 
"departure_time" : "05:53:25" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "05:54:31" , 
"departure_time" : "05:54:31" , 
"distance_traveled" : 4.8572
} ], 
"3587" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "05:46:00" , 
"departure_time" : "05:47:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "05:48:48" , 
"departure_time" : "05:49:49" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "05:53:01" , 
"departure_time" : "05:54:01" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "05:55:00" , 
"departure_time" : "05:56:31" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "05:57:31" , 
"departure_time" : "05:58:43" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "05:59:12" , 
"departure_time" : "06:00:06" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:00:54" , 
"departure_time" : "06:02:04" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:02:10" , 
"departure_time" : "06:03:19" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:03:09" , 
"departure_time" : "06:03:59" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:03:50" , 
"departure_time" : "06:04:18" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:04:28" , 
"departure_time" : "06:05:27" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "06:06:59" , 
"departure_time" : "06:06:59" , 
"distance_traveled" : 4.8572
} ], 
"3588" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "06:00:00" , 
"departure_time" : "06:02:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "06:03:36" , 
"departure_time" : "06:03:57" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "06:06:21" , 
"departure_time" : "06:07:09" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "06:08:48" , 
"departure_time" : "06:09:46" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "06:10:58" , 
"departure_time" : "06:12:17" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:13:19" , 
"departure_time" : "06:14:01" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:14:42" , 
"departure_time" : "06:15:18" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:15:36" , 
"departure_time" : "06:15:50" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:16:14" , 
"departure_time" : "06:17:26" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:18:12" , 
"departure_time" : "06:19:38" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:19:26" , 
"departure_time" : "06:20:46" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "06:21:20" , 
"departure_time" : "06:21:20" , 
"distance_traveled" : 4.8572
} ], 
"3589" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "06:08:00" , 
"departure_time" : "06:10:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "06:11:36" , 
"departure_time" : "06:12:04" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "06:14:28" , 
"departure_time" : "06:15:47" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "06:17:19" , 
"departure_time" : "06:17:28" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "06:18:09" , 
"departure_time" : "06:18:15" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:20:06" , 
"departure_time" : "06:20:19" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:22:13" , 
"departure_time" : "06:22:52" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:23:39" , 
"departure_time" : "06:23:59" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:24:20" , 
"departure_time" : "06:24:55" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:25:35" , 
"departure_time" : "06:26:42" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:27:07" , 
"departure_time" : "06:28:08" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "06:29:01" , 
"departure_time" : "06:29:01" , 
"distance_traveled" : 4.8572
} ], 
"3590" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "06:16:00" , 
"departure_time" : "06:17:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "06:18:19" , 
"departure_time" : "06:19:43" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "06:23:24" , 
"departure_time" : "06:24:55" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "06:25:31" , 
"departure_time" : "06:26:52" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "06:27:21" , 
"departure_time" : "06:27:39" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:28:18" , 
"departure_time" : "06:29:55" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:31:37" , 
"departure_time" : "06:31:54" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:31:17" , 
"departure_time" : "06:32:23" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:33:06" , 
"departure_time" : "06:33:21" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:33:15" , 
"departure_time" : "06:33:21" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:34:06" , 
"departure_time" : "06:34:53" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "06:36:47" , 
"departure_time" : "06:36:47" , 
"distance_traveled" : 4.8572
} ], 
"3591" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "06:24:00" , 
"departure_time" : "06:25:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "06:26:28" , 
"departure_time" : "06:27:55" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "06:31:27" , 
"departure_time" : "06:33:06" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "06:33:39" , 
"departure_time" : "06:35:03" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "06:35:24" , 
"departure_time" : "06:36:41" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:37:17" , 
"departure_time" : "06:38:43" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:39:26" , 
"departure_time" : "06:39:56" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:39:30" , 
"departure_time" : "06:40:12" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:40:42" , 
"departure_time" : "06:41:52" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:42:10" , 
"departure_time" : "06:43:47" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:43:37" , 
"departure_time" : "06:43:52" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "06:44:15" , 
"departure_time" : "06:44:15" , 
"distance_traveled" : 4.8572
} ], 
"3592" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "06:28:00" , 
"departure_time" : "06:28:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "06:30:02" , 
"departure_time" : "06:30:03" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "06:34:01" , 
"departure_time" : "06:34:45" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "06:36:44" , 
"departure_time" : "06:37:58" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "06:39:14" , 
"departure_time" : "06:40:29" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:41:15" , 
"departure_time" : "06:41:41" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:42:26" , 
"departure_time" : "06:42:37" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:43:11" , 
"departure_time" : "06:43:26" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:44:15" , 
"departure_time" : "06:45:09" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:45:54" , 
"departure_time" : "06:47:31" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:47:37" , 
"departure_time" : "06:47:42" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "06:48:05" , 
"departure_time" : "06:48:05" , 
"distance_traveled" : 4.8572
} ], 
"3593" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "06:37:00" , 
"departure_time" : "06:38:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "06:40:26" , 
"departure_time" : "06:40:57" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "06:43:31" , 
"departure_time" : "06:44:37" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "06:46:06" , 
"departure_time" : "06:46:43" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "06:47:37" , 
"departure_time" : "06:48:48" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:50:11" , 
"departure_time" : "06:50:33" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:51:22" , 
"departure_time" : "06:52:00" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:52:38" , 
"departure_time" : "06:53:28" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:53:50" , 
"departure_time" : "06:55:16" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:55:26" , 
"departure_time" : "06:55:31" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:55:05" , 
"departure_time" : "06:55:55" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "06:57:50" , 
"departure_time" : "06:57:50" , 
"distance_traveled" : 4.8572
} ], 
"3594" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "06:47:00" , 
"departure_time" : "06:48:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "06:50:09" , 
"departure_time" : "06:50:43" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "06:53:34" , 
"departure_time" : "06:53:54" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "06:55:20" , 
"departure_time" : "06:55:46" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "06:57:26" , 
"departure_time" : "06:58:08" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:59:42" , 
"departure_time" : "07:01:02" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:02:20" , 
"departure_time" : "07:03:32" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:03:12" , 
"departure_time" : "07:03:37" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:03:25" , 
"departure_time" : "07:03:28" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:04:03" , 
"departure_time" : "07:05:18" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:06:15" , 
"departure_time" : "07:07:12" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:07:57" , 
"departure_time" : "07:07:57" , 
"distance_traveled" : 4.8572
} ], 
"3595" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "06:57:00" , 
"departure_time" : "06:58:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "06:59:41" , 
"departure_time" : "07:00:52" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:04:11" , 
"departure_time" : "07:05:07" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:05:56" , 
"departure_time" : "07:07:27" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:08:31" , 
"departure_time" : "07:09:35" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:10:04" , 
"departure_time" : "07:10:26" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:11:22" , 
"departure_time" : "07:12:17" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:12:55" , 
"departure_time" : "07:12:58" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:13:03" , 
"departure_time" : "07:14:21" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:15:18" , 
"departure_time" : "07:16:51" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:16:33" , 
"departure_time" : "07:17:59" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:18:26" , 
"departure_time" : "07:18:26" , 
"distance_traveled" : 4.8572
} ], 
"3596" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "07:04:00" , 
"departure_time" : "07:05:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "07:06:04" , 
"departure_time" : "07:06:18" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:10:14" , 
"departure_time" : "07:11:01" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:12:47" , 
"departure_time" : "07:13:09" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:14:22" , 
"departure_time" : "07:14:29" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:16:07" , 
"departure_time" : "07:16:12" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:18:05" , 
"departure_time" : "07:18:21" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:19:16" , 
"departure_time" : "07:19:52" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:20:36" , 
"departure_time" : "07:20:59" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:21:23" , 
"departure_time" : "07:21:26" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:22:03" , 
"departure_time" : "07:23:15" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:25:12" , 
"departure_time" : "07:25:12" , 
"distance_traveled" : 4.8572
} ], 
"3597" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "07:11:00" , 
"departure_time" : "07:12:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "07:13:16" , 
"departure_time" : "07:13:50" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:17:34" , 
"departure_time" : "07:17:59" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:19:25" , 
"departure_time" : "07:20:13" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:21:48" , 
"departure_time" : "07:23:17" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:24:29" , 
"departure_time" : "07:25:28" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:25:59" , 
"departure_time" : "07:26:11" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:26:12" , 
"departure_time" : "07:27:18" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:28:06" , 
"departure_time" : "07:28:48" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:28:42" , 
"departure_time" : "07:30:21" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:30:39" , 
"departure_time" : "07:31:16" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:31:37" , 
"departure_time" : "07:31:37" , 
"distance_traveled" : 4.8572
} ], 
"3598" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "07:19:00" , 
"departure_time" : "07:20:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "07:22:09" , 
"departure_time" : "07:22:55" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:25:46" , 
"departure_time" : "07:27:18" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:28:32" , 
"departure_time" : "07:29:13" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:29:41" , 
"departure_time" : "07:29:51" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:31:10" , 
"departure_time" : "07:31:55" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:33:45" , 
"departure_time" : "07:34:10" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:34:25" , 
"departure_time" : "07:35:19" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:35:54" , 
"departure_time" : "07:37:26" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:37:32" , 
"departure_time" : "07:38:23" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:37:51" , 
"departure_time" : "07:39:12" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:40:21" , 
"departure_time" : "07:40:21" , 
"distance_traveled" : 4.8572
} ], 
"3599" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "07:24:00" , 
"departure_time" : "07:25:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "07:26:10" , 
"departure_time" : "07:27:18" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:31:08" , 
"departure_time" : "07:31:32" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:32:24" , 
"departure_time" : "07:33:08" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:34:44" , 
"departure_time" : "07:35:42" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:36:58" , 
"departure_time" : "07:37:29" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:38:31" , 
"departure_time" : "07:38:56" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:39:25" , 
"departure_time" : "07:39:39" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:40:14" , 
"departure_time" : "07:41:10" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:41:56" , 
"departure_time" : "07:42:13" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:42:17" , 
"departure_time" : "07:42:51" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:44:34" , 
"departure_time" : "07:44:34" , 
"distance_traveled" : 4.8572
} ], 
"3600" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "07:32:00" , 
"departure_time" : "07:32:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "07:34:20" , 
"departure_time" : "07:34:34" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:38:14" , 
"departure_time" : "07:39:35" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:41:21" , 
"departure_time" : "07:42:24" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:43:03" , 
"departure_time" : "07:44:35" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:45:32" , 
"departure_time" : "07:46:14" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:46:42" , 
"departure_time" : "07:47:27" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:47:45" , 
"departure_time" : "07:48:29" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:48:44" , 
"departure_time" : "07:49:39" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:49:55" , 
"departure_time" : "07:51:00" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:51:05" , 
"departure_time" : "07:51:12" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:52:07" , 
"departure_time" : "07:52:07" , 
"distance_traveled" : 4.8572
} ], 
"3601" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "07:39:00" , 
"departure_time" : "07:39:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "07:41:13" , 
"departure_time" : "07:42:09" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:45:56" , 
"departure_time" : "07:47:21" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:48:25" , 
"departure_time" : "07:49:28" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:50:03" , 
"departure_time" : "07:51:38" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:52:35" , 
"departure_time" : "07:53:15" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:53:40" , 
"departure_time" : "07:54:52" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:55:12" , 
"departure_time" : "07:55:47" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:55:35" , 
"departure_time" : "07:56:07" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:56:32" , 
"departure_time" : "07:57:02" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:57:30" , 
"departure_time" : "07:57:33" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:59:03" , 
"departure_time" : "07:59:03" , 
"distance_traveled" : 4.8572
} ], 
"3602" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "07:46:00" , 
"departure_time" : "07:47:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "07:49:03" , 
"departure_time" : "07:50:00" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:52:57" , 
"departure_time" : "07:53:45" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:54:48" , 
"departure_time" : "07:55:48" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:57:00" , 
"departure_time" : "07:57:46" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:58:46" , 
"departure_time" : "07:58:49" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:00:03" , 
"departure_time" : "08:00:32" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:01:29" , 
"departure_time" : "08:02:58" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:03:29" , 
"departure_time" : "08:04:07" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:03:38" , 
"departure_time" : "08:04:02" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:04:24" , 
"departure_time" : "08:04:51" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:06:27" , 
"departure_time" : "08:06:27" , 
"distance_traveled" : 4.8572
} ], 
"3603" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "07:53:00" , 
"departure_time" : "07:54:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "07:56:01" , 
"departure_time" : "07:57:23" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:00:22" , 
"departure_time" : "08:01:16" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:01:54" , 
"departure_time" : "08:02:39" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:03:45" , 
"departure_time" : "08:04:38" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:05:53" , 
"departure_time" : "08:06:01" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:07:08" , 
"departure_time" : "08:07:58" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:08:50" , 
"departure_time" : "08:09:58" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:10:08" , 
"departure_time" : "08:10:59" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:10:51" , 
"departure_time" : "08:11:27" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:11:36" , 
"departure_time" : "08:12:11" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:13:35" , 
"departure_time" : "08:13:35" , 
"distance_traveled" : 4.8572
} ], 
"3604" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "08:00:00" , 
"departure_time" : "08:01:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "08:02:54" , 
"departure_time" : "08:03:15" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:06:21" , 
"departure_time" : "08:07:22" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:09:01" , 
"departure_time" : "08:09:41" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:10:40" , 
"departure_time" : "08:10:50" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:12:10" , 
"departure_time" : "08:12:56" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:14:46" , 
"departure_time" : "08:15:49" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:16:03" , 
"departure_time" : "08:17:22" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:17:19" , 
"departure_time" : "08:18:33" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:18:14" , 
"departure_time" : "08:18:43" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:18:29" , 
"departure_time" : "08:19:48" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:21:19" , 
"departure_time" : "08:21:19" , 
"distance_traveled" : 4.8572
} ], 
"3605" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "08:08:00" , 
"departure_time" : "08:10:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "08:11:14" , 
"departure_time" : "08:12:40" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:15:26" , 
"departure_time" : "08:16:31" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:17:05" , 
"departure_time" : "08:17:07" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:18:02" , 
"departure_time" : "08:18:48" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:20:46" , 
"departure_time" : "08:21:34" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:22:48" , 
"departure_time" : "08:23:09" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:23:21" , 
"departure_time" : "08:24:07" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:24:46" , 
"departure_time" : "08:25:25" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:25:39" , 
"departure_time" : "08:26:56" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:27:17" , 
"departure_time" : "08:28:41" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:29:24" , 
"departure_time" : "08:29:24" , 
"distance_traveled" : 4.8572
} ], 
"3606" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "08:18:00" , 
"departure_time" : "08:20:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "08:21:25" , 
"departure_time" : "08:22:19" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:24:54" , 
"departure_time" : "08:25:14" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:26:20" , 
"departure_time" : "08:27:42" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:29:22" , 
"departure_time" : "08:30:18" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:30:56" , 
"departure_time" : "08:32:26" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:33:30" , 
"departure_time" : "08:33:36" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:33:06" , 
"departure_time" : "08:34:07" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:35:01" , 
"departure_time" : "08:35:38" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:35:37" , 
"departure_time" : "08:36:44" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:37:07" , 
"departure_time" : "08:37:39" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:38:32" , 
"departure_time" : "08:38:32" , 
"distance_traveled" : 4.8572
} ], 
"3607" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "08:28:00" , 
"departure_time" : "08:28:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "08:30:21" , 
"departure_time" : "08:31:47" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:35:26" , 
"departure_time" : "08:37:05" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:37:39" , 
"departure_time" : "08:38:58" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:39:19" , 
"departure_time" : "08:39:41" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:40:22" , 
"departure_time" : "08:40:41" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:42:19" , 
"departure_time" : "08:43:08" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:43:49" , 
"departure_time" : "08:44:40" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:44:51" , 
"departure_time" : "08:45:58" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:46:07" , 
"departure_time" : "08:47:29" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:47:22" , 
"departure_time" : "08:48:04" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:48:42" , 
"departure_time" : "08:48:42" , 
"distance_traveled" : 4.8572
} ], 
"3608" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "08:35:00" , 
"departure_time" : "08:37:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "08:38:31" , 
"departure_time" : "08:39:00" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:41:29" , 
"departure_time" : "08:42:22" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:43:53" , 
"departure_time" : "08:43:59" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:45:06" , 
"departure_time" : "08:46:21" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:48:15" , 
"departure_time" : "08:48:38" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:49:23" , 
"departure_time" : "08:49:42" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:50:19" , 
"departure_time" : "08:51:14" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:51:55" , 
"departure_time" : "08:52:24" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:52:29" , 
"departure_time" : "08:53:39" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:54:10" , 
"departure_time" : "08:54:47" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:55:37" , 
"departure_time" : "08:55:37" , 
"distance_traveled" : 4.8572
} ], 
"3609" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "08:42:00" , 
"departure_time" : "08:42:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "08:44:16" , 
"departure_time" : "08:45:48" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:49:32" , 
"departure_time" : "08:50:06" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:50:34" , 
"departure_time" : "08:51:16" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:52:42" , 
"departure_time" : "08:54:01" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:55:19" , 
"departure_time" : "08:55:33" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:56:14" , 
"departure_time" : "08:56:33" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:57:19" , 
"departure_time" : "08:57:21" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:58:02" , 
"departure_time" : "08:59:22" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:00:20" , 
"departure_time" : "09:01:12" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:00:52" , 
"departure_time" : "09:02:26" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "09:03:34" , 
"departure_time" : "09:03:34" , 
"distance_traveled" : 4.8572
} ], 
"3610" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "08:50:00" , 
"departure_time" : "08:51:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "08:52:11" , 
"departure_time" : "08:53:12" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:57:01" , 
"departure_time" : "08:57:19" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:58:18" , 
"departure_time" : "08:58:26" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:00:08" , 
"departure_time" : "09:01:09" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:03:01" , 
"departure_time" : "09:03:50" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:04:49" , 
"departure_time" : "09:05:40" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:05:51" , 
"departure_time" : "09:05:58" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:06:07" , 
"departure_time" : "09:06:49" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:07:42" , 
"departure_time" : "09:08:02" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:08:20" , 
"departure_time" : "09:08:42" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "09:10:22" , 
"departure_time" : "09:10:22" , 
"distance_traveled" : 4.8572
} ], 
"3611" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "08:55:00" , 
"departure_time" : "08:55:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "08:57:22" , 
"departure_time" : "08:57:39" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:01:17" , 
"departure_time" : "09:01:50" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:03:33" , 
"departure_time" : "09:04:32" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:05:59" , 
"departure_time" : "09:07:24" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:08:25" , 
"departure_time" : "09:08:36" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:09:11" , 
"departure_time" : "09:10:33" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:11:22" , 
"departure_time" : "09:11:36" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:11:14" , 
"departure_time" : "09:12:10" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:12:56" , 
"departure_time" : "09:14:18" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:14:22" , 
"departure_time" : "09:15:16" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "09:15:54" , 
"departure_time" : "09:15:54" , 
"distance_traveled" : 4.8572
} ], 
"3612" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "09:03:00" , 
"departure_time" : "09:04:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "09:05:34" , 
"departure_time" : "09:06:10" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:09:36" , 
"departure_time" : "09:10:29" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:11:53" , 
"departure_time" : "09:12:32" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:13:39" , 
"departure_time" : "09:15:05" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:16:26" , 
"departure_time" : "09:17:01" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:17:35" , 
"departure_time" : "09:17:45" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:18:10" , 
"departure_time" : "09:19:16" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:20:06" , 
"departure_time" : "09:21:10" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:21:04" , 
"departure_time" : "09:21:22" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:21:18" , 
"departure_time" : "09:21:49" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "09:23:31" , 
"departure_time" : "09:23:31" , 
"distance_traveled" : 4.8572
} ], 
"3613" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "09:11:00" , 
"departure_time" : "09:12:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "09:14:07" , 
"departure_time" : "09:14:59" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:17:52" , 
"departure_time" : "09:18:40" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:19:48" , 
"departure_time" : "09:21:26" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:22:38" , 
"departure_time" : "09:24:11" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:24:33" , 
"departure_time" : "09:25:56" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:26:23" , 
"departure_time" : "09:26:31" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:26:08" , 
"departure_time" : "09:26:39" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:27:31" , 
"departure_time" : "09:27:41" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:28:10" , 
"departure_time" : "09:29:46" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:30:36" , 
"departure_time" : "09:31:23" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "09:31:47" , 
"departure_time" : "09:31:47" , 
"distance_traveled" : 4.8572
} ], 
"3614" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "09:20:00" , 
"departure_time" : "09:22:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "09:23:29" , 
"departure_time" : "09:24:23" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:26:54" , 
"departure_time" : "09:28:09" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:29:15" , 
"departure_time" : "09:30:10" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:30:55" , 
"departure_time" : "09:32:05" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:33:10" , 
"departure_time" : "09:33:40" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:34:30" , 
"departure_time" : "09:35:49" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:36:19" , 
"departure_time" : "09:36:23" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:36:04" , 
"departure_time" : "09:37:28" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:38:24" , 
"departure_time" : "09:38:59" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:38:35" , 
"departure_time" : "09:39:34" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "09:40:59" , 
"departure_time" : "09:40:59" , 
"distance_traveled" : 4.8572
} ], 
"3615" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "09:26:00" , 
"departure_time" : "09:28:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "09:29:21" , 
"departure_time" : "09:30:13" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:32:52" , 
"departure_time" : "09:34:30" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:35:38" , 
"departure_time" : "09:36:31" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:36:53" , 
"departure_time" : "09:38:07" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:39:14" , 
"departure_time" : "09:39:29" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:40:15" , 
"departure_time" : "09:40:26" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:41:11" , 
"departure_time" : "09:42:07" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:42:56" , 
"departure_time" : "09:43:30" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:43:34" , 
"departure_time" : "09:44:07" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:44:33" , 
"departure_time" : "09:44:35" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "09:46:02" , 
"departure_time" : "09:46:02" , 
"distance_traveled" : 4.8572
} ], 
"3616" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "09:34:00" , 
"departure_time" : "09:34:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "09:36:01" , 
"departure_time" : "09:37:29" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:41:28" , 
"departure_time" : "09:41:39" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:42:11" , 
"departure_time" : "09:42:24" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:44:13" , 
"departure_time" : "09:45:27" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:47:14" , 
"departure_time" : "09:48:19" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:49:05" , 
"departure_time" : "09:50:07" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:50:02" , 
"departure_time" : "09:51:07" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:51:05" , 
"departure_time" : "09:52:08" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:52:03" , 
"departure_time" : "09:53:14" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:53:11" , 
"departure_time" : "09:53:12" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "09:54:01" , 
"departure_time" : "09:54:01" , 
"distance_traveled" : 4.8572
} ], 
"3617" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "09:42:00" , 
"departure_time" : "09:42:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "09:44:22" , 
"departure_time" : "09:44:44" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:48:22" , 
"departure_time" : "09:49:57" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:51:35" , 
"departure_time" : "09:53:05" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:53:30" , 
"departure_time" : "09:54:21" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:54:51" , 
"departure_time" : "09:55:21" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:56:30" , 
"departure_time" : "09:56:36" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:57:06" , 
"departure_time" : "09:58:34" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:59:28" , 
"departure_time" : "10:00:01" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:59:33" , 
"departure_time" : "10:00:11" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "10:00:38" , 
"departure_time" : "10:02:08" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "10:03:30" , 
"departure_time" : "10:03:30" , 
"distance_traveled" : 4.8572
} ], 
"3618" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "09:52:00" , 
"departure_time" : "09:54:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "09:54:33" , 
"departure_time" : "09:55:41" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:59:08" , 
"departure_time" : "10:00:20" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "10:01:12" , 
"departure_time" : "10:02:19" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "10:03:07" , 
"departure_time" : "10:03:42" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "10:04:35" , 
"departure_time" : "10:04:59" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "10:06:24" , 
"departure_time" : "10:06:42" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "10:07:18" , 
"departure_time" : "10:08:38" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "10:09:20" , 
"departure_time" : "10:09:35" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "10:09:15" , 
"departure_time" : "10:10:13" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "10:10:58" , 
"departure_time" : "10:11:48" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "10:12:50" , 
"departure_time" : "10:12:50" , 
"distance_traveled" : 4.8572
} ], 
"3619" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "10:02:00" , 
"departure_time" : "10:03:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "10:04:39" , 
"departure_time" : "10:05:27" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "10:08:48" , 
"departure_time" : "10:09:43" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "10:10:55" , 
"departure_time" : "10:11:22" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "10:12:27" , 
"departure_time" : "10:12:58" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "10:14:31" , 
"departure_time" : "10:15:51" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "10:17:20" , 
"departure_time" : "10:17:23" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "10:17:03" , 
"departure_time" : "10:17:15" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "10:18:12" , 
"departure_time" : "10:19:36" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "10:20:24" , 
"departure_time" : "10:20:54" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "10:20:30" , 
"departure_time" : "10:21:31" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "10:23:01" , 
"departure_time" : "10:23:01" , 
"distance_traveled" : 4.8572
} ], 
"3620" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "10:11:00" , 
"departure_time" : "10:12:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "10:13:32" , 
"departure_time" : "10:13:52" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "10:17:20" , 
"departure_time" : "10:17:51" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "10:19:31" , 
"departure_time" : "10:20:25" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "10:21:54" , 
"departure_time" : "10:23:07" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "10:24:13" , 
"departure_time" : "10:25:33" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "10:26:20" , 
"departure_time" : "10:26:26" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "10:26:06" , 
"departure_time" : "10:27:27" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "10:28:21" , 
"departure_time" : "10:28:54" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "10:28:33" , 
"departure_time" : "10:29:30" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "10:29:57" , 
"departure_time" : "10:30:36" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "10:31:39" , 
"departure_time" : "10:31:39" , 
"distance_traveled" : 4.8572
} ], 
"3621" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "10:22:00" , 
"departure_time" : "10:23:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "10:24:51" , 
"departure_time" : "10:25:59" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "10:29:08" , 
"departure_time" : "10:30:18" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "10:31:10" , 
"departure_time" : "10:32:18" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "10:33:08" , 
"departure_time" : "10:34:42" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "10:35:34" , 
"departure_time" : "10:37:06" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "10:37:32" , 
"departure_time" : "10:37:34" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "10:37:02" , 
"departure_time" : "10:37:33" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "10:38:31" , 
"departure_time" : "10:39:40" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "10:40:09" , 
"departure_time" : "10:40:47" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "10:40:38" , 
"departure_time" : "10:41:37" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "10:42:59" , 
"departure_time" : "10:42:59" , 
"distance_traveled" : 4.8572
} ], 
"3622" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "10:32:00" , 
"departure_time" : "10:34:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "10:35:22" , 
"departure_time" : "10:35:48" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "10:38:26" , 
"departure_time" : "10:40:06" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "10:41:40" , 
"departure_time" : "10:42:23" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "10:42:43" , 
"departure_time" : "10:43:55" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "10:45:12" , 
"departure_time" : "10:46:51" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "10:47:39" , 
"departure_time" : "10:49:06" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "10:48:27" , 
"departure_time" : "10:49:27" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "10:49:00" , 
"departure_time" : "10:49:03" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "10:49:03" , 
"departure_time" : "10:49:07" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "10:50:04" , 
"departure_time" : "10:50:09" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "10:52:05" , 
"departure_time" : "10:52:05" , 
"distance_traveled" : 4.8572
} ], 
"3623" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "10:42:00" , 
"departure_time" : "10:43:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "10:45:20" , 
"departure_time" : "10:45:58" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "10:48:38" , 
"departure_time" : "10:48:44" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "10:50:06" , 
"departure_time" : "10:50:27" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "10:52:21" , 
"departure_time" : "10:53:09" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "10:54:48" , 
"departure_time" : "10:55:48" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "10:57:00" , 
"departure_time" : "10:58:05" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "10:58:05" , 
"departure_time" : "10:59:17" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "10:59:12" , 
"departure_time" : "10:59:17" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "10:59:05" , 
"departure_time" : "10:59:59" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "11:00:54" , 
"departure_time" : "11:02:04" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "11:03:10" , 
"departure_time" : "11:03:10" , 
"distance_traveled" : 4.8572
} ], 
"3624" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "10:52:00" , 
"departure_time" : "10:53:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "10:54:18" , 
"departure_time" : "10:55:35" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "10:59:17" , 
"departure_time" : "10:59:22" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "11:00:05" , 
"departure_time" : "11:01:23" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "11:03:18" , 
"departure_time" : "11:04:19" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "11:05:01" , 
"departure_time" : "11:05:53" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "11:06:52" , 
"departure_time" : "11:08:32" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "11:08:40" , 
"departure_time" : "11:09:37" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "11:08:57" , 
"departure_time" : "11:09:34" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "11:09:37" , 
"departure_time" : "11:09:48" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "11:10:11" , 
"departure_time" : "11:11:03" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "11:12:52" , 
"departure_time" : "11:12:52" , 
"distance_traveled" : 4.8572
} ], 
"3625" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "11:02:00" , 
"departure_time" : "11:04:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "11:05:09" , 
"departure_time" : "11:05:55" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "11:08:46" , 
"departure_time" : "11:09:22" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "11:10:36" , 
"departure_time" : "11:10:37" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "11:12:01" , 
"departure_time" : "11:12:40" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "11:14:39" , 
"departure_time" : "11:15:14" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "11:16:35" , 
"departure_time" : "11:17:22" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "11:17:47" , 
"departure_time" : "11:18:04" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "11:18:17" , 
"departure_time" : "11:19:45" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "11:20:28" , 
"departure_time" : "11:20:35" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "11:20:07" , 
"departure_time" : "11:21:45" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "11:23:38" , 
"departure_time" : "11:23:38" , 
"distance_traveled" : 4.8572
} ], 
"3626" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "11:12:00" , 
"departure_time" : "11:13:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "11:14:14" , 
"departure_time" : "11:14:32" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "11:18:18" , 
"departure_time" : "11:18:44" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "11:20:26" , 
"departure_time" : "11:21:00" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "11:22:34" , 
"departure_time" : "11:23:27" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "11:24:53" , 
"departure_time" : "11:26:11" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "11:27:18" , 
"departure_time" : "11:28:24" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "11:28:06" , 
"departure_time" : "11:28:08" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "11:28:02" , 
"departure_time" : "11:29:24" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "11:30:22" , 
"departure_time" : "11:31:52" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "11:31:30" , 
"departure_time" : "11:32:36" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "11:33:06" , 
"departure_time" : "11:33:06" , 
"distance_traveled" : 4.8572
} ], 
"3627" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "11:22:00" , 
"departure_time" : "11:24:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "11:25:09" , 
"departure_time" : "11:25:55" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "11:28:46" , 
"departure_time" : "11:30:21" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "11:31:35" , 
"departure_time" : "11:32:33" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "11:32:58" , 
"departure_time" : "11:32:59" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "11:34:01" , 
"departure_time" : "11:34:44" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "11:36:43" , 
"departure_time" : "11:37:23" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "11:37:40" , 
"departure_time" : "11:37:56" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "11:38:16" , 
"departure_time" : "11:39:22" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "11:40:06" , 
"departure_time" : "11:41:40" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "11:41:34" , 
"departure_time" : "11:41:36" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "11:42:02" , 
"departure_time" : "11:42:02" , 
"distance_traveled" : 4.8572
} ], 
"3628" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "11:32:00" , 
"departure_time" : "11:33:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "11:34:59" , 
"departure_time" : "11:35:03" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "11:38:04" , 
"departure_time" : "11:39:33" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "11:41:29" , 
"departure_time" : "11:42:32" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "11:43:03" , 
"departure_time" : "11:43:57" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "11:44:54" , 
"departure_time" : "11:45:08" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "11:46:14" , 
"departure_time" : "11:47:42" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "11:48:28" , 
"departure_time" : "11:48:52" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "11:48:24" , 
"departure_time" : "11:48:45" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "11:49:21" , 
"departure_time" : "11:51:00" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "11:51:39" , 
"departure_time" : "11:51:46" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "11:52:07" , 
"departure_time" : "11:52:07" , 
"distance_traveled" : 4.8572
} ], 
"3629" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "11:42:00" , 
"departure_time" : "11:43:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "11:45:21" , 
"departure_time" : "11:46:46" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "11:49:25" , 
"departure_time" : "11:49:56" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "11:50:31" , 
"departure_time" : "11:51:30" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "11:52:59" , 
"departure_time" : "11:53:43" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "11:54:44" , 
"departure_time" : "11:56:13" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "11:57:29" , 
"departure_time" : "11:57:43" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "11:57:14" , 
"departure_time" : "11:57:27" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "11:58:13" , 
"departure_time" : "11:58:50" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "11:59:37" , 
"departure_time" : "11:59:46" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "12:00:09" , 
"departure_time" : "12:01:16" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "12:03:07" , 
"departure_time" : "12:03:07" , 
"distance_traveled" : 4.8572
} ], 
"3630" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "11:52:00" , 
"departure_time" : "11:54:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "11:55:07" , 
"departure_time" : "11:56:34" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "11:59:27" , 
"departure_time" : "11:59:32" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "12:00:05" , 
"departure_time" : "12:01:25" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "12:03:20" , 
"departure_time" : "12:04:58" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "12:05:38" , 
"departure_time" : "12:07:01" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "12:07:23" , 
"departure_time" : "12:08:38" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "12:08:15" , 
"departure_time" : "12:08:23" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "12:08:08" , 
"departure_time" : "12:08:09" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "12:09:01" , 
"departure_time" : "12:10:23" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "12:11:22" , 
"departure_time" : "12:11:35" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "12:12:13" , 
"departure_time" : "12:12:13" , 
"distance_traveled" : 4.8572
} ], 
"3631" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "12:02:00" , 
"departure_time" : "12:03:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "12:05:30" , 
"departure_time" : "12:06:09" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "12:08:39" , 
"departure_time" : "12:10:17" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "12:11:38" , 
"departure_time" : "12:11:49" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "12:12:11" , 
"departure_time" : "12:12:38" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "12:14:27" , 
"departure_time" : "12:14:34" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "12:16:07" , 
"departure_time" : "12:17:46" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "12:18:39" , 
"departure_time" : "12:19:20" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "12:18:41" , 
"departure_time" : "12:19:50" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "12:20:09" , 
"departure_time" : "12:20:51" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "12:20:42" , 
"departure_time" : "12:20:44" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "12:22:02" , 
"departure_time" : "12:22:02" , 
"distance_traveled" : 4.8572
} ], 
"3632" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "12:12:00" , 
"departure_time" : "12:13:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "12:15:13" , 
"departure_time" : "12:16:21" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "12:19:08" , 
"departure_time" : "12:20:12" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "12:21:04" , 
"departure_time" : "12:22:33" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "12:23:29" , 
"departure_time" : "12:23:56" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "12:24:27" , 
"departure_time" : "12:25:53" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "12:27:26" , 
"departure_time" : "12:28:47" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "12:28:21" , 
"departure_time" : "12:29:34" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "12:29:13" , 
"departure_time" : "12:30:32" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "12:30:19" , 
"departure_time" : "12:30:51" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "12:30:32" , 
"departure_time" : "12:30:47" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "12:32:15" , 
"departure_time" : "12:32:15" , 
"distance_traveled" : 4.8572
} ], 
"3633" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "12:22:00" , 
"departure_time" : "12:23:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "12:25:17" , 
"departure_time" : "12:26:32" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "12:29:15" , 
"departure_time" : "12:29:56" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "12:30:41" , 
"departure_time" : "12:32:17" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "12:33:36" , 
"departure_time" : "12:35:00" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "12:35:24" , 
"departure_time" : "12:35:28" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "12:36:04" , 
"departure_time" : "12:36:21" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "12:37:17" , 
"departure_time" : "12:38:28" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "12:39:11" , 
"departure_time" : "12:40:37" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "12:40:26" , 
"departure_time" : "12:41:08" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "12:40:42" , 
"departure_time" : "12:41:25" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "12:42:43" , 
"departure_time" : "12:42:43" , 
"distance_traveled" : 4.8572
} ], 
"3634" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "12:32:00" , 
"departure_time" : "12:32:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "12:34:09" , 
"departure_time" : "12:34:14" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "12:38:05" , 
"departure_time" : "12:38:08" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "12:40:03" , 
"departure_time" : "12:41:03" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "12:43:00" , 
"departure_time" : "12:43:21" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "12:44:21" , 
"departure_time" : "12:45:38" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "12:47:17" , 
"departure_time" : "12:48:55" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "12:48:38" , 
"departure_time" : "12:48:40" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "12:48:02" , 
"departure_time" : "12:48:06" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "12:49:04" , 
"departure_time" : "12:49:34" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "12:50:30" , 
"departure_time" : "12:51:52" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "12:53:22" , 
"departure_time" : "12:53:22" , 
"distance_traveled" : 4.8572
} ], 
"3635" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "12:42:00" , 
"departure_time" : "12:44:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "12:44:49" , 
"departure_time" : "12:45:20" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "12:48:31" , 
"departure_time" : "12:49:56" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "12:51:25" , 
"departure_time" : "12:53:04" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "12:53:39" , 
"departure_time" : "12:54:49" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "12:55:10" , 
"departure_time" : "12:55:48" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "12:56:38" , 
"departure_time" : "12:57:06" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "12:57:28" , 
"departure_time" : "12:59:05" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "12:59:37" , 
"departure_time" : "13:00:16" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "12:59:39" , 
"departure_time" : "13:00:41" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "13:01:02" , 
"departure_time" : "13:01:35" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "13:02:33" , 
"departure_time" : "13:02:33" , 
"distance_traveled" : 4.8572
} ], 
"3636" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "12:52:00" , 
"departure_time" : "12:52:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "12:54:14" , 
"departure_time" : "12:54:16" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "12:58:02" , 
"departure_time" : "12:58:40" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "13:00:38" , 
"departure_time" : "13:01:04" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "13:02:26" , 
"departure_time" : "13:02:35" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "13:04:09" , 
"departure_time" : "13:04:15" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "13:06:06" , 
"departure_time" : "13:06:25" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "13:07:19" , 
"departure_time" : "13:07:56" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "13:08:37" , 
"departure_time" : "13:10:03" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "13:10:26" , 
"departure_time" : "13:10:59" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "13:10:33" , 
"departure_time" : "13:11:57" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "13:13:24" , 
"departure_time" : "13:13:24" , 
"distance_traveled" : 4.8572
} ], 
"3637" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "13:02:00" , 
"departure_time" : "13:04:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "13:05:05" , 
"departure_time" : "13:06:03" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "13:08:58" , 
"departure_time" : "13:09:49" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "13:10:51" , 
"departure_time" : "13:11:26" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "13:12:35" , 
"departure_time" : "13:13:02" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "13:14:27" , 
"departure_time" : "13:14:59" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "13:16:32" , 
"departure_time" : "13:17:57" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "13:18:25" , 
"departure_time" : "13:19:09" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "13:18:44" , 
"departure_time" : "13:20:13" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "13:20:29" , 
"departure_time" : "13:21:18" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "13:20:49" , 
"departure_time" : "13:22:21" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "13:23:32" , 
"departure_time" : "13:23:32" , 
"distance_traveled" : 4.8572
} ], 
"3638" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "13:12:00" , 
"departure_time" : "13:14:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "13:14:44" , 
"departure_time" : "13:15:31" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "13:18:47" , 
"departure_time" : "13:19:58" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "13:21:11" , 
"departure_time" : "13:22:45" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "13:23:34" , 
"departure_time" : "13:25:01" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "13:25:27" , 
"departure_time" : "13:25:32" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "13:26:05" , 
"departure_time" : "13:27:06" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "13:28:01" , 
"departure_time" : "13:29:28" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "13:29:27" , 
"departure_time" : "13:31:00" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "13:30:33" , 
"departure_time" : "13:31:43" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "13:31:10" , 
"departure_time" : "13:31:53" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "13:32:43" , 
"departure_time" : "13:32:43" , 
"distance_traveled" : 4.8572
} ], 
"3639" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "13:22:00" , 
"departure_time" : "13:22:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "13:24:16" , 
"departure_time" : "13:25:27" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "13:29:11" , 
"departure_time" : "13:30:01" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "13:30:50" , 
"departure_time" : "13:32:08" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "13:33:18" , 
"departure_time" : "13:33:53" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "13:34:35" , 
"departure_time" : "13:35:30" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "13:36:55" , 
"departure_time" : "13:37:25" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "13:37:30" , 
"departure_time" : "13:38:38" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "13:39:08" , 
"departure_time" : "13:40:27" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "13:40:19" , 
"departure_time" : "13:41:33" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "13:41:14" , 
"departure_time" : "13:42:37" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "13:43:23" , 
"departure_time" : "13:43:23" , 
"distance_traveled" : 4.8572
} ], 
"3640" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "13:32:00" , 
"departure_time" : "13:34:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "13:34:48" , 
"departure_time" : "13:36:10" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "13:39:22" , 
"departure_time" : "13:39:23" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "13:40:01" , 
"departure_time" : "13:40:15" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "13:42:14" , 
"departure_time" : "13:42:17" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "13:44:03" , 
"departure_time" : "13:44:08" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "13:46:05" , 
"departure_time" : "13:47:43" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "13:48:38" , 
"departure_time" : "13:49:36" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "13:48:58" , 
"departure_time" : "13:49:55" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "13:49:57" , 
"departure_time" : "13:51:28" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "13:51:31" , 
"departure_time" : "13:52:34" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "13:53:03" , 
"departure_time" : "13:53:03" , 
"distance_traveled" : 4.8572
} ], 
"3641" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "13:42:00" , 
"departure_time" : "13:43:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "13:44:52" , 
"departure_time" : "13:45:04" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "13:48:12" , 
"departure_time" : "13:48:48" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "13:50:36" , 
"departure_time" : "13:51:46" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "13:53:10" , 
"departure_time" : "13:54:21" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "13:55:11" , 
"departure_time" : "13:55:17" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "13:56:06" , 
"departure_time" : "13:56:26" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "13:57:20" , 
"departure_time" : "13:57:49" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "13:58:29" , 
"departure_time" : "13:58:36" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "13:59:07" , 
"departure_time" : "14:00:26" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "14:01:19" , 
"departure_time" : "14:01:54" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "14:02:35" , 
"departure_time" : "14:02:35" , 
"distance_traveled" : 4.8572
} ], 
"3642" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "13:52:00" , 
"departure_time" : "13:53:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "13:54:55" , 
"departure_time" : "13:56:22" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "13:59:27" , 
"departure_time" : "14:00:57" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "14:01:30" , 
"departure_time" : "14:01:55" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "14:02:25" , 
"departure_time" : "14:03:59" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "14:05:34" , 
"departure_time" : "14:05:50" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "14:06:16" , 
"departure_time" : "14:06:52" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "14:07:36" , 
"departure_time" : "14:08:57" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "14:09:21" , 
"departure_time" : "14:10:32" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "14:10:11" , 
"departure_time" : "14:11:11" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "14:11:00" , 
"departure_time" : "14:11:19" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "14:12:19" , 
"departure_time" : "14:12:19" , 
"distance_traveled" : 4.8572
} ], 
"3643" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "14:02:00" , 
"departure_time" : "14:03:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "14:04:43" , 
"departure_time" : "14:05:33" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "14:08:50" , 
"departure_time" : "14:10:08" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "14:11:18" , 
"departure_time" : "14:11:39" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "14:12:21" , 
"departure_time" : "14:12:43" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "14:14:22" , 
"departure_time" : "14:14:38" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "14:16:16" , 
"departure_time" : "14:17:44" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "14:18:28" , 
"departure_time" : "14:19:10" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "14:18:42" , 
"departure_time" : "14:20:09" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "14:20:27" , 
"departure_time" : "14:20:42" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "14:20:15" , 
"departure_time" : "14:20:21" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "14:22:06" , 
"departure_time" : "14:22:06" , 
"distance_traveled" : 4.8572
} ], 
"3644" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "14:12:00" , 
"departure_time" : "14:12:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "14:14:16" , 
"departure_time" : "14:15:27" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "14:19:11" , 
"departure_time" : "14:19:17" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "14:20:06" , 
"departure_time" : "14:20:15" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "14:22:09" , 
"departure_time" : "14:23:37" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "14:25:28" , 
"departure_time" : "14:25:48" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "14:26:20" , 
"departure_time" : "14:27:35" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "14:28:15" , 
"departure_time" : "14:29:25" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "14:29:10" , 
"departure_time" : "14:30:26" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "14:30:16" , 
"departure_time" : "14:31:47" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "14:31:31" , 
"departure_time" : "14:31:47" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "14:32:16" , 
"departure_time" : "14:32:16" , 
"distance_traveled" : 4.8572
} ], 
"3645" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "14:22:00" , 
"departure_time" : "14:23:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "14:25:05" , 
"departure_time" : "14:26:14" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "14:29:09" , 
"departure_time" : "14:30:15" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "14:31:06" , 
"departure_time" : "14:31:42" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "14:32:36" , 
"departure_time" : "14:32:51" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "14:34:15" , 
"departure_time" : "14:35:18" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "14:37:03" , 
"departure_time" : "14:37:46" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "14:37:43" , 
"departure_time" : "14:38:52" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "14:39:09" , 
"departure_time" : "14:40:42" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "14:40:33" , 
"departure_time" : "14:41:58" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "14:41:25" , 
"departure_time" : "14:42:44" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "14:43:19" , 
"departure_time" : "14:43:19" , 
"distance_traveled" : 4.8572
} ], 
"3646" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "14:32:00" , 
"departure_time" : "14:33:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "14:34:07" , 
"departure_time" : "14:34:29" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "14:38:22" , 
"departure_time" : "14:38:26" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "14:40:04" , 
"departure_time" : "14:41:24" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "14:43:20" , 
"departure_time" : "14:44:23" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "14:45:03" , 
"departure_time" : "14:45:51" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "14:46:48" , 
"departure_time" : "14:48:11" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "14:48:23" , 
"departure_time" : "14:49:07" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "14:48:44" , 
"departure_time" : "14:48:59" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "14:49:15" , 
"departure_time" : "14:50:15" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "14:51:00" , 
"departure_time" : "14:52:02" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "14:53:02" , 
"departure_time" : "14:53:02" , 
"distance_traveled" : 4.8572
} ], 
"3647" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "14:42:00" , 
"departure_time" : "14:43:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "14:44:53" , 
"departure_time" : "14:45:54" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "14:49:01" , 
"departure_time" : "14:50:02" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "14:51:01" , 
"departure_time" : "14:51:18" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "14:52:17" , 
"departure_time" : "14:52:47" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "14:54:30" , 
"departure_time" : "14:55:10" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "14:56:40" , 
"departure_time" : "14:56:53" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "14:57:13" , 
"departure_time" : "14:57:51" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "14:58:38" , 
"departure_time" : "14:58:56" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "14:59:18" , 
"departure_time" : "14:59:55" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:00:37" , 
"departure_time" : "15:01:32" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "15:02:55" , 
"departure_time" : "15:02:55" , 
"distance_traveled" : 4.8572
} ], 
"3648" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "14:53:00" , 
"departure_time" : "14:54:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "14:55:53" , 
"departure_time" : "14:56:02" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "14:59:09" , 
"departure_time" : "15:00:40" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:02:31" , 
"departure_time" : "15:03:35" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:04:04" , 
"departure_time" : "15:04:54" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:05:50" , 
"departure_time" : "15:07:30" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:08:40" , 
"departure_time" : "15:10:01" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:09:21" , 
"departure_time" : "15:10:43" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:10:22" , 
"departure_time" : "15:11:28" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:11:06" , 
"departure_time" : "15:12:42" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:12:36" , 
"departure_time" : "15:14:13" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "15:14:37" , 
"departure_time" : "15:14:37" , 
"distance_traveled" : 4.8572
} ], 
"3649" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "15:01:00" , 
"departure_time" : "15:02:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "15:03:19" , 
"departure_time" : "15:04:58" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "15:08:39" , 
"departure_time" : "15:09:55" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:10:16" , 
"departure_time" : "15:10:25" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:11:09" , 
"departure_time" : "15:11:45" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:13:36" , 
"departure_time" : "15:14:43" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:16:07" , 
"departure_time" : "15:17:47" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:17:40" , 
"departure_time" : "15:19:04" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:18:24" , 
"departure_time" : "15:18:39" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:18:15" , 
"departure_time" : "15:18:45" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:19:30" , 
"departure_time" : "15:19:55" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "15:21:25" , 
"departure_time" : "15:21:25" , 
"distance_traveled" : 4.8572
} ], 
"3650" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "15:13:00" , 
"departure_time" : "15:14:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "15:16:29" , 
"departure_time" : "15:16:46" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "15:19:17" , 
"departure_time" : "15:20:56" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:22:39" , 
"departure_time" : "15:23:02" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:23:23" , 
"departure_time" : "15:24:40" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:26:17" , 
"departure_time" : "15:27:28" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:28:11" , 
"departure_time" : "15:29:50" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:29:39" , 
"departure_time" : "15:29:41" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:29:02" , 
"departure_time" : "15:30:07" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:31:05" , 
"departure_time" : "15:32:09" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:32:04" , 
"departure_time" : "15:32:07" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "15:33:03" , 
"departure_time" : "15:33:03" , 
"distance_traveled" : 4.8572
} ], 
"3651" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "15:24:00" , 
"departure_time" : "15:24:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "15:26:45" , 
"departure_time" : "15:27:13" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "15:30:28" , 
"departure_time" : "15:31:23" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:32:55" , 
"departure_time" : "15:34:31" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:35:36" , 
"departure_time" : "15:35:42" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:36:06" , 
"departure_time" : "15:37:16" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:39:10" , 
"departure_time" : "15:39:49" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:39:39" , 
"departure_time" : "15:40:14" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:40:35" , 
"departure_time" : "15:42:01" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:42:26" , 
"departure_time" : "15:42:34" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:42:08" , 
"departure_time" : "15:43:10" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "15:45:02" , 
"departure_time" : "15:45:02" , 
"distance_traveled" : 4.8572
} ], 
"3652" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "15:29:00" , 
"departure_time" : "15:31:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "15:32:08" , 
"departure_time" : "15:33:40" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "15:36:32" , 
"departure_time" : "15:36:59" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:37:27" , 
"departure_time" : "15:37:33" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:39:06" , 
"departure_time" : "15:39:32" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:41:26" , 
"departure_time" : "15:43:06" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:44:40" , 
"departure_time" : "15:46:07" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:45:27" , 
"departure_time" : "15:45:31" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:45:04" , 
"departure_time" : "15:46:07" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:47:03" , 
"departure_time" : "15:47:56" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:47:53" , 
"departure_time" : "15:48:10" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "15:49:17" , 
"departure_time" : "15:49:17" , 
"distance_traveled" : 4.8572
} ], 
"3653" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "15:36:00" , 
"departure_time" : "15:36:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "15:38:19" , 
"departure_time" : "15:38:50" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "15:42:31" , 
"departure_time" : "15:42:49" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:44:18" , 
"departure_time" : "15:45:36" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:47:18" , 
"departure_time" : "15:48:04" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:48:46" , 
"departure_time" : "15:49:47" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:51:01" , 
"departure_time" : "15:52:22" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:52:21" , 
"departure_time" : "15:53:50" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:53:29" , 
"departure_time" : "15:54:42" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:54:13" , 
"departure_time" : "15:55:22" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:55:09" , 
"departure_time" : "15:55:18" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "15:56:09" , 
"departure_time" : "15:56:09" , 
"distance_traveled" : 4.8572
} ], 
"3654" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "15:43:00" , 
"departure_time" : "15:44:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "15:46:11" , 
"departure_time" : "15:46:47" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "15:49:36" , 
"departure_time" : "15:50:19" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:51:43" , 
"departure_time" : "15:53:21" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:54:38" , 
"departure_time" : "15:54:56" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:55:18" , 
"departure_time" : "15:56:38" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:58:20" , 
"departure_time" : "15:59:57" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:59:37" , 
"departure_time" : "15:59:56" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:59:19" , 
"departure_time" : "16:00:35" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:01:16" , 
"departure_time" : "16:01:38" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:01:22" , 
"departure_time" : "16:03:02" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:04:40" , 
"departure_time" : "16:04:40" , 
"distance_traveled" : 4.8572
} ], 
"3655" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "15:56:00" , 
"departure_time" : "15:57:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "15:58:10" , 
"departure_time" : "15:59:27" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:03:17" , 
"departure_time" : "16:03:30" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:04:13" , 
"departure_time" : "16:04:46" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:06:33" , 
"departure_time" : "16:07:39" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:09:06" , 
"departure_time" : "16:10:41" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:11:35" , 
"departure_time" : "16:11:55" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:11:20" , 
"departure_time" : "16:12:45" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:13:25" , 
"departure_time" : "16:14:26" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:14:01" , 
"departure_time" : "16:15:00" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:14:59" , 
"departure_time" : "16:15:46" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:16:47" , 
"departure_time" : "16:16:47" , 
"distance_traveled" : 4.8572
} ], 
"3656" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "16:04:00" , 
"departure_time" : "16:05:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "16:07:06" , 
"departure_time" : "16:08:37" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:11:31" , 
"departure_time" : "16:11:32" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:12:01" , 
"departure_time" : "16:12:46" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:14:45" , 
"departure_time" : "16:14:56" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:16:11" , 
"departure_time" : "16:16:55" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:18:44" , 
"departure_time" : "16:19:34" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:19:50" , 
"departure_time" : "16:20:51" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:21:01" , 
"departure_time" : "16:21:03" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:21:02" , 
"departure_time" : "16:21:47" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:22:45" , 
"departure_time" : "16:24:20" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:25:35" , 
"departure_time" : "16:25:35" , 
"distance_traveled" : 4.8572
} ], 
"3657" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "16:11:00" , 
"departure_time" : "16:13:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "16:13:45" , 
"departure_time" : "16:14:16" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:17:31" , 
"departure_time" : "16:18:59" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:20:28" , 
"departure_time" : "16:21:05" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:21:37" , 
"departure_time" : "16:22:28" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:23:51" , 
"departure_time" : "16:25:15" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:26:24" , 
"departure_time" : "16:27:50" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:27:26" , 
"departure_time" : "16:28:57" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:28:31" , 
"departure_time" : "16:29:13" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:28:42" , 
"departure_time" : "16:30:03" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:30:21" , 
"departure_time" : "16:31:09" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:31:48" , 
"departure_time" : "16:31:48" , 
"distance_traveled" : 4.8572
} ], 
"3658" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "16:18:00" , 
"departure_time" : "16:20:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "16:21:18" , 
"departure_time" : "16:21:31" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:24:13" , 
"departure_time" : "16:25:30" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:27:17" , 
"departure_time" : "16:27:40" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:28:23" , 
"departure_time" : "16:29:32" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:31:09" , 
"departure_time" : "16:32:00" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:32:51" , 
"departure_time" : "16:34:19" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:34:28" , 
"departure_time" : "16:35:42" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:35:14" , 
"departure_time" : "16:35:25" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:35:11" , 
"departure_time" : "16:36:46" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:37:35" , 
"departure_time" : "16:38:09" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:38:34" , 
"departure_time" : "16:38:34" , 
"distance_traveled" : 4.8572
} ], 
"3659" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "16:26:00" , 
"departure_time" : "16:27:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "16:28:49" , 
"departure_time" : "16:29:15" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:32:26" , 
"departure_time" : "16:32:35" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:34:09" , 
"departure_time" : "16:35:06" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:36:57" , 
"departure_time" : "16:38:18" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:39:21" , 
"departure_time" : "16:40:59" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:41:38" , 
"departure_time" : "16:43:07" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:42:29" , 
"departure_time" : "16:42:56" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:42:27" , 
"departure_time" : "16:43:26" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:43:59" , 
"departure_time" : "16:45:12" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:45:13" , 
"departure_time" : "16:45:15" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:46:02" , 
"departure_time" : "16:46:02" , 
"distance_traveled" : 4.8572
} ], 
"3660" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "16:32:00" , 
"departure_time" : "16:32:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "16:34:17" , 
"departure_time" : "16:35:22" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:39:05" , 
"departure_time" : "16:39:15" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:40:10" , 
"departure_time" : "16:40:53" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:42:43" , 
"departure_time" : "16:44:18" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:45:35" , 
"departure_time" : "16:46:51" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:47:16" , 
"departure_time" : "16:48:02" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:47:46" , 
"departure_time" : "16:48:59" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:49:13" , 
"departure_time" : "16:50:14" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:50:01" , 
"departure_time" : "16:50:53" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:50:52" , 
"departure_time" : "16:52:07" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:53:15" , 
"departure_time" : "16:53:15" , 
"distance_traveled" : 4.8572
} ], 
"3661" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "16:39:00" , 
"departure_time" : "16:40:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "16:41:19" , 
"departure_time" : "16:42:57" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:46:38" , 
"departure_time" : "16:47:08" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:47:30" , 
"departure_time" : "16:48:31" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:50:01" , 
"departure_time" : "16:50:05" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:51:04" , 
"departure_time" : "16:51:52" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:53:48" , 
"departure_time" : "16:54:18" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:54:30" , 
"departure_time" : "16:55:55" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:56:25" , 
"departure_time" : "16:56:43" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:56:18" , 
"departure_time" : "16:56:49" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:57:31" , 
"departure_time" : "16:57:49" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:59:18" , 
"departure_time" : "16:59:18" , 
"distance_traveled" : 4.8572
} ], 
"3662" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "16:46:00" , 
"departure_time" : "16:47:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "16:48:51" , 
"departure_time" : "16:49:52" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:53:01" , 
"departure_time" : "16:53:21" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:54:20" , 
"departure_time" : "16:55:17" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:56:57" , 
"departure_time" : "16:58:17" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:59:20" , 
"departure_time" : "17:00:30" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:01:10" , 
"departure_time" : "17:01:45" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:01:35" , 
"departure_time" : "17:02:34" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:02:59" , 
"departure_time" : "17:04:07" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:04:08" , 
"departure_time" : "17:05:00" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:04:52" , 
"departure_time" : "17:06:02" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "17:07:10" , 
"departure_time" : "17:07:10" , 
"distance_traveled" : 4.8572
} ], 
"3663" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "16:53:00" , 
"departure_time" : "16:54:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "16:55:46" , 
"departure_time" : "16:56:43" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:59:57" , 
"departure_time" : "16:59:59" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:01:02" , 
"departure_time" : "17:01:08" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:03:06" , 
"departure_time" : "17:03:43" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:05:37" , 
"departure_time" : "17:06:07" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:07:30" , 
"departure_time" : "17:07:51" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:08:21" , 
"departure_time" : "17:09:31" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:10:10" , 
"departure_time" : "17:11:45" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:11:35" , 
"departure_time" : "17:12:15" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:11:40" , 
"departure_time" : "17:12:38" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "17:13:58" , 
"departure_time" : "17:13:58" , 
"distance_traveled" : 4.8572
} ], 
"3664" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "17:00:00" , 
"departure_time" : "17:01:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "17:02:02" , 
"departure_time" : "17:03:39" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:07:37" , 
"departure_time" : "17:07:55" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:08:18" , 
"departure_time" : "17:08:42" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:10:24" , 
"departure_time" : "17:11:49" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:13:25" , 
"departure_time" : "17:13:27" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:14:02" , 
"departure_time" : "17:15:34" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:16:32" , 
"departure_time" : "17:16:42" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:16:10" , 
"departure_time" : "17:16:54" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:17:44" , 
"departure_time" : "17:18:51" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:19:07" , 
"departure_time" : "17:19:56" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "17:20:49" , 
"departure_time" : "17:20:49" , 
"distance_traveled" : 4.8572
} ], 
"3665" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "17:07:00" , 
"departure_time" : "17:08:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "17:09:38" , 
"departure_time" : "17:10:56" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:14:18" , 
"departure_time" : "17:15:28" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:16:10" , 
"departure_time" : "17:17:26" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:18:16" , 
"departure_time" : "17:19:01" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:19:45" , 
"departure_time" : "17:21:04" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:22:19" , 
"departure_time" : "17:22:49" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:22:30" , 
"departure_time" : "17:23:24" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:23:54" , 
"departure_time" : "17:24:37" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:24:43" , 
"departure_time" : "17:25:22" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:25:39" , 
"departure_time" : "17:26:35" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "17:27:56" , 
"departure_time" : "17:27:56" , 
"distance_traveled" : 4.8572
} ], 
"3666" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "17:15:00" , 
"departure_time" : "17:16:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "17:17:36" , 
"departure_time" : "17:18:39" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:22:03" , 
"departure_time" : "17:22:55" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:23:52" , 
"departure_time" : "17:24:39" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:25:47" , 
"departure_time" : "17:27:02" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:28:15" , 
"departure_time" : "17:29:12" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:29:57" , 
"departure_time" : "17:31:34" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:31:37" , 
"departure_time" : "17:32:00" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:31:23" , 
"departure_time" : "17:32:37" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:33:14" , 
"departure_time" : "17:34:27" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:34:13" , 
"departure_time" : "17:34:18" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "17:35:05" , 
"departure_time" : "17:35:05" , 
"distance_traveled" : 4.8572
} ], 
"3667" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "17:27:00" , 
"departure_time" : "17:27:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "17:29:47" , 
"departure_time" : "17:29:56" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:33:09" , 
"departure_time" : "17:34:27" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:36:18" , 
"departure_time" : "17:37:41" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:38:23" , 
"departure_time" : "17:39:26" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:40:03" , 
"departure_time" : "17:41:36" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:42:33" , 
"departure_time" : "17:43:49" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:43:16" , 
"departure_time" : "17:43:27" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:43:11" , 
"departure_time" : "17:44:20" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:45:09" , 
"departure_time" : "17:46:11" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:46:02" , 
"departure_time" : "17:47:13" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "17:48:11" , 
"departure_time" : "17:48:11" , 
"distance_traveled" : 4.8572
} ], 
"3668" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "17:35:00" , 
"departure_time" : "17:36:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "17:37:33" , 
"departure_time" : "17:38:29" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:41:56" , 
"departure_time" : "17:42:42" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:43:46" , 
"departure_time" : "17:43:59" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:45:13" , 
"departure_time" : "17:45:46" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:47:33" , 
"departure_time" : "17:48:07" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:49:34" , 
"departure_time" : "17:49:53" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:50:19" , 
"departure_time" : "17:51:22" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:52:03" , 
"departure_time" : "17:52:27" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:52:24" , 
"departure_time" : "17:52:54" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:53:30" , 
"departure_time" : "17:54:38" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "17:56:08" , 
"departure_time" : "17:56:08" , 
"distance_traveled" : 4.8572
} ], 
"3669" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "17:42:00" , 
"departure_time" : "17:44:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "17:44:54" , 
"departure_time" : "17:46:30" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:49:36" , 
"departure_time" : "17:49:52" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:50:16" , 
"departure_time" : "17:50:34" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:52:18" , 
"departure_time" : "17:52:48" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:54:30" , 
"departure_time" : "17:54:38" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:56:08" , 
"departure_time" : "17:57:22" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:58:14" , 
"departure_time" : "17:59:29" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:59:15" , 
"departure_time" : "17:59:44" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:59:29" , 
"departure_time" : "17:59:46" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:00:17" , 
"departure_time" : "18:01:22" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:03:05" , 
"departure_time" : "18:03:05" , 
"distance_traveled" : 4.8572
} ], 
"3670" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "17:49:00" , 
"departure_time" : "17:51:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "17:52:16" , 
"departure_time" : "17:53:28" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:56:12" , 
"departure_time" : "17:56:27" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:57:15" , 
"departure_time" : "17:58:20" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:00:05" , 
"departure_time" : "18:00:13" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:01:08" , 
"departure_time" : "18:01:45" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:03:37" , 
"departure_time" : "18:03:49" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:04:12" , 
"departure_time" : "18:05:19" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:06:07" , 
"departure_time" : "18:06:29" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:06:22" , 
"departure_time" : "18:06:23" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:07:01" , 
"departure_time" : "18:08:18" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:10:17" , 
"departure_time" : "18:10:17" , 
"distance_traveled" : 4.8572
} ], 
"3671" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "17:57:00" , 
"departure_time" : "17:59:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "17:59:49" , 
"departure_time" : "18:00:56" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:04:07" , 
"departure_time" : "18:04:41" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:05:34" , 
"departure_time" : "18:06:12" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:07:38" , 
"departure_time" : "18:07:56" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:09:18" , 
"departure_time" : "18:09:38" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:11:20" , 
"departure_time" : "18:12:57" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:13:37" , 
"departure_time" : "18:14:38" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:14:01" , 
"departure_time" : "18:14:58" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:14:57" , 
"departure_time" : "18:16:12" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:16:15" , 
"departure_time" : "18:16:49" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:17:34" , 
"departure_time" : "18:17:34" , 
"distance_traveled" : 4.8572
} ], 
"3672" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "18:02:00" , 
"departure_time" : "18:03:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "18:04:52" , 
"departure_time" : "18:05:41" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:08:49" , 
"departure_time" : "18:09:23" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:10:34" , 
"departure_time" : "18:11:22" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:12:48" , 
"departure_time" : "18:14:13" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:15:25" , 
"departure_time" : "18:16:35" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:17:10" , 
"departure_time" : "18:17:29" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:17:19" , 
"departure_time" : "18:17:37" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:18:18" , 
"departure_time" : "18:19:09" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:19:51" , 
"departure_time" : "18:20:05" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:20:14" , 
"departure_time" : "18:21:33" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:23:19" , 
"departure_time" : "18:23:19" , 
"distance_traveled" : 4.8572
} ], 
"3673" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "18:10:00" , 
"departure_time" : "18:12:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "18:12:43" , 
"departure_time" : "18:13:53" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:17:10" , 
"departure_time" : "18:17:26" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:18:16" , 
"departure_time" : "18:18:54" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:20:38" , 
"departure_time" : "18:22:01" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:23:23" , 
"departure_time" : "18:24:57" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:25:34" , 
"departure_time" : "18:26:09" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:25:35" , 
"departure_time" : "18:27:07" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:27:32" , 
"departure_time" : "18:28:47" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:28:15" , 
"departure_time" : "18:28:39" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:28:24" , 
"departure_time" : "18:29:45" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:31:21" , 
"departure_time" : "18:31:21" , 
"distance_traveled" : 4.8572
} ], 
"3674" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "18:17:00" , 
"departure_time" : "18:18:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "18:19:16" , 
"departure_time" : "18:20:49" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:24:33" , 
"departure_time" : "18:24:44" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:25:11" , 
"departure_time" : "18:25:51" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:27:40" , 
"departure_time" : "18:27:45" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:29:05" , 
"departure_time" : "18:29:58" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:31:53" , 
"departure_time" : "18:32:56" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:33:03" , 
"departure_time" : "18:33:11" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:33:08" , 
"departure_time" : "18:34:39" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:35:31" , 
"departure_time" : "18:35:45" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:35:14" , 
"departure_time" : "18:35:56" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:37:42" , 
"departure_time" : "18:37:42" , 
"distance_traveled" : 4.8572
} ], 
"3675" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "18:24:00" , 
"departure_time" : "18:26:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "18:27:21" , 
"departure_time" : "18:27:43" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:30:22" , 
"departure_time" : "18:30:25" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:32:03" , 
"departure_time" : "18:32:56" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:34:53" , 
"departure_time" : "18:36:12" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:37:19" , 
"departure_time" : "18:37:47" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:38:28" , 
"departure_time" : "18:39:37" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:40:09" , 
"departure_time" : "18:41:33" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:41:24" , 
"departure_time" : "18:42:23" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:41:59" , 
"departure_time" : "18:42:15" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:42:16" , 
"departure_time" : "18:42:23" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:44:07" , 
"departure_time" : "18:44:07" , 
"distance_traveled" : 4.8572
} ], 
"3676" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "18:31:00" , 
"departure_time" : "18:31:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "18:33:25" , 
"departure_time" : "18:34:57" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:38:32" , 
"departure_time" : "18:39:29" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:39:57" , 
"departure_time" : "18:41:26" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:42:29" , 
"departure_time" : "18:42:43" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:43:14" , 
"departure_time" : "18:44:49" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:46:35" , 
"departure_time" : "18:48:11" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:47:36" , 
"departure_time" : "18:48:41" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:48:05" , 
"departure_time" : "18:48:53" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:48:48" , 
"departure_time" : "18:48:49" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:49:01" , 
"departure_time" : "18:50:40" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:52:39" , 
"departure_time" : "18:52:39" , 
"distance_traveled" : 4.8572
} ], 
"3677" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "18:38:00" , 
"departure_time" : "18:41:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "18:41:22" , 
"departure_time" : "18:41:32" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:44:10" , 
"departure_time" : "18:44:56" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:46:46" , 
"departure_time" : "18:47:57" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:49:11" , 
"departure_time" : "18:49:56" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:50:45" , 
"departure_time" : "18:51:34" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:52:49" , 
"departure_time" : "18:53:22" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:53:33" , 
"departure_time" : "18:54:33" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:55:00" , 
"departure_time" : "18:56:01" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:56:01" , 
"departure_time" : "18:56:08" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:56:07" , 
"departure_time" : "18:56:18" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:58:11" , 
"departure_time" : "18:58:11" , 
"distance_traveled" : 4.8572
} ], 
"3678" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "18:47:00" , 
"departure_time" : "18:48:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "18:50:09" , 
"departure_time" : "18:51:24" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:54:15" , 
"departure_time" : "18:54:25" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:55:10" , 
"departure_time" : "18:55:58" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:57:48" , 
"departure_time" : "18:58:11" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:59:23" , 
"departure_time" : "18:59:59" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "19:01:36" , 
"departure_time" : "19:02:44" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "19:03:08" , 
"departure_time" : "19:04:01" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "19:03:53" , 
"departure_time" : "19:04:28" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:04:35" , 
"departure_time" : "19:05:53" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "19:06:18" , 
"departure_time" : "19:06:58" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "19:07:40" , 
"departure_time" : "19:07:40" , 
"distance_traveled" : 4.8572
} ], 
"3679" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "18:57:00" , 
"departure_time" : "18:58:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "18:59:50" , 
"departure_time" : "19:01:21" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "19:04:31" , 
"departure_time" : "19:06:02" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:06:31" , 
"departure_time" : "19:07:41" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:08:10" , 
"departure_time" : "19:08:37" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:09:27" , 
"departure_time" : "19:10:19" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "19:11:52" , 
"departure_time" : "19:12:19" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "19:12:27" , 
"departure_time" : "19:12:54" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "19:13:27" , 
"departure_time" : "19:14:26" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:14:59" , 
"departure_time" : "19:15:58" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "19:15:59" , 
"departure_time" : "19:17:20" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "19:18:21" , 
"departure_time" : "19:18:21" , 
"distance_traveled" : 4.8572
} ], 
"3680" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "19:11:00" , 
"departure_time" : "19:14:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "19:14:40" , 
"departure_time" : "19:16:13" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "19:18:33" , 
"departure_time" : "19:19:49" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:20:16" , 
"departure_time" : "19:21:23" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:22:07" , 
"departure_time" : "19:22:39" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:23:32" , 
"departure_time" : "19:23:44" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "19:25:12" , 
"departure_time" : "19:25:25" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "19:26:13" , 
"departure_time" : "19:27:18" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "19:28:05" , 
"departure_time" : "19:28:34" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:28:29" , 
"departure_time" : "19:30:01" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "19:30:32" , 
"departure_time" : "19:30:39" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "19:31:07" , 
"departure_time" : "19:31:07" , 
"distance_traveled" : 4.8572
} ], 
"3681" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "19:25:00" , 
"departure_time" : "19:25:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "19:27:39" , 
"departure_time" : "19:29:14" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "19:32:35" , 
"departure_time" : "19:33:09" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:33:34" , 
"departure_time" : "19:34:54" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:36:20" , 
"departure_time" : "19:37:15" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:37:55" , 
"departure_time" : "19:39:27" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "19:40:32" , 
"departure_time" : "19:40:45" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "19:40:13" , 
"departure_time" : "19:40:43" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "19:41:30" , 
"departure_time" : "19:42:35" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:43:05" , 
"departure_time" : "19:43:33" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "19:43:28" , 
"departure_time" : "19:43:42" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "19:45:14" , 
"departure_time" : "19:45:14" , 
"distance_traveled" : 4.8572
} ], 
"3682" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "19:39:00" , 
"departure_time" : "19:40:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "19:42:00" , 
"departure_time" : "19:42:38" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "19:45:38" , 
"departure_time" : "19:46:04" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:47:26" , 
"departure_time" : "19:47:30" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:49:04" , 
"departure_time" : "19:49:35" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:51:31" , 
"departure_time" : "19:52:22" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "19:53:51" , 
"departure_time" : "19:54:19" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "19:54:28" , 
"departure_time" : "19:55:29" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "19:56:01" , 
"departure_time" : "19:57:31" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:57:30" , 
"departure_time" : "19:59:04" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "19:58:34" , 
"departure_time" : "19:59:41" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "20:00:07" , 
"departure_time" : "20:00:07" , 
"distance_traveled" : 4.8572
} ], 
"3683" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "19:53:00" , 
"departure_time" : "19:54:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "19:55:18" , 
"departure_time" : "19:56:31" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "20:00:13" , 
"departure_time" : "20:01:12" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "20:01:59" , 
"departure_time" : "20:03:14" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "20:04:15" , 
"departure_time" : "20:05:31" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "20:06:16" , 
"departure_time" : "20:06:20" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "20:07:04" , 
"departure_time" : "20:07:20" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "20:08:16" , 
"departure_time" : "20:09:34" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "20:10:18" , 
"departure_time" : "20:10:43" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "20:10:25" , 
"departure_time" : "20:10:40" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "20:11:15" , 
"departure_time" : "20:12:44" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "20:14:29" , 
"departure_time" : "20:14:29" , 
"distance_traveled" : 4.8572
} ], 
"3684" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "20:07:00" , 
"departure_time" : "20:09:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "20:10:24" , 
"departure_time" : "20:11:21" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "20:13:57" , 
"departure_time" : "20:15:29" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "20:16:32" , 
"departure_time" : "20:17:34" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "20:18:02" , 
"departure_time" : "20:18:42" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "20:19:40" , 
"departure_time" : "20:21:13" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "20:22:33" , 
"departure_time" : "20:23:21" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "20:22:48" , 
"departure_time" : "20:23:44" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "20:23:56" , 
"departure_time" : "20:25:12" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "20:25:16" , 
"departure_time" : "20:25:20" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "20:25:04" , 
"departure_time" : "20:25:10" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "20:27:06" , 
"departure_time" : "20:27:06" , 
"distance_traveled" : 4.8572
} ], 
"3685" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "20:36:00" , 
"departure_time" : "20:37:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "20:39:01" , 
"departure_time" : "20:39:15" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "20:42:14" , 
"departure_time" : "20:43:26" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "20:45:12" , 
"departure_time" : "20:45:48" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "20:46:36" , 
"departure_time" : "20:47:58" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "20:49:22" , 
"departure_time" : "20:49:50" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "20:50:28" , 
"departure_time" : "20:51:57" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "20:52:29" , 
"departure_time" : "20:53:44" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "20:53:15" , 
"departure_time" : "20:54:34" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "20:54:19" , 
"departure_time" : "20:55:10" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "20:54:51" , 
"departure_time" : "20:55:57" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "20:57:06" , 
"departure_time" : "20:57:06" , 
"distance_traveled" : 4.8572
} ], 
"3686" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "20:46:00" , 
"departure_time" : "20:48:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "20:49:29" , 
"departure_time" : "20:49:42" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "20:52:13" , 
"departure_time" : "20:52:40" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "20:54:27" , 
"departure_time" : "20:54:37" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "20:56:10" , 
"departure_time" : "20:57:15" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "20:59:05" , 
"departure_time" : "20:59:13" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "21:00:08" , 
"departure_time" : "21:00:23" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "21:01:15" , 
"departure_time" : "21:01:43" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "21:02:28" , 
"departure_time" : "21:03:12" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "21:03:44" , 
"departure_time" : "21:04:48" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "21:05:04" , 
"departure_time" : "21:05:14" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "21:06:10" , 
"departure_time" : "21:06:10" , 
"distance_traveled" : 4.8572
} ], 
"3687" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "20:56:00" , 
"departure_time" : "20:57:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "20:58:54" , 
"departure_time" : "20:58:59" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "21:02:05" , 
"departure_time" : "21:02:52" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "21:04:47" , 
"departure_time" : "21:06:25" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "21:07:38" , 
"departure_time" : "21:07:52" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "21:08:14" , 
"departure_time" : "21:09:38" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "21:11:24" , 
"departure_time" : "21:11:38" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "21:11:14" , 
"departure_time" : "21:11:50" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "21:12:36" , 
"departure_time" : "21:13:01" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "21:13:25" , 
"departure_time" : "21:13:43" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "21:14:18" , 
"departure_time" : "21:15:00" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "21:16:42" , 
"departure_time" : "21:16:42" , 
"distance_traveled" : 4.8572
} ], 
"3688" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "21:11:00" , 
"departure_time" : "21:13:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "21:14:37" , 
"departure_time" : "21:15:33" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "21:17:56" , 
"departure_time" : "21:18:04" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "21:19:08" , 
"departure_time" : "21:20:05" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "21:21:57" , 
"departure_time" : "21:22:17" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "21:23:20" , 
"departure_time" : "21:24:49" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "21:26:29" , 
"departure_time" : "21:27:17" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "21:26:48" , 
"departure_time" : "21:28:23" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "21:28:35" , 
"departure_time" : "21:28:48" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "21:28:13" , 
"departure_time" : "21:28:35" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "21:29:22" , 
"departure_time" : "21:30:12" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "21:31:50" , 
"departure_time" : "21:31:50" , 
"distance_traveled" : 4.8572
} ], 
"3689" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "21:30:00" , 
"departure_time" : "21:31:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "21:32:23" , 
"departure_time" : "21:33:02" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "21:36:39" , 
"departure_time" : "21:37:40" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "21:39:01" , 
"departure_time" : "21:40:13" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "21:41:12" , 
"departure_time" : "21:42:29" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "21:43:17" , 
"departure_time" : "21:43:51" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "21:44:34" , 
"departure_time" : "21:44:39" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "21:45:05" , 
"departure_time" : "21:45:36" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "21:46:31" , 
"departure_time" : "21:47:02" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "21:47:31" , 
"departure_time" : "21:47:41" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "21:48:10" , 
"departure_time" : "21:48:43" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "21:50:33" , 
"departure_time" : "21:50:33" , 
"distance_traveled" : 4.8572
} ], 
"3690" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "21:36:00" , 
"departure_time" : "21:37:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "21:38:53" , 
"departure_time" : "21:38:59" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "21:42:06" , 
"departure_time" : "21:42:32" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "21:44:26" , 
"departure_time" : "21:44:58" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "21:46:32" , 
"departure_time" : "21:46:59" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "21:48:27" , 
"departure_time" : "21:48:36" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "21:50:09" , 
"departure_time" : "21:50:43" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "21:51:34" , 
"departure_time" : "21:52:16" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "21:52:42" , 
"departure_time" : "21:53:19" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "21:53:37" , 
"departure_time" : "21:54:09" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "21:54:32" , 
"departure_time" : "21:54:53" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "21:56:21" , 
"departure_time" : "21:56:21" , 
"distance_traveled" : 4.8572
} ], 
"3691" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "21:52:00" , 
"departure_time" : "21:53:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "21:55:27" , 
"departure_time" : "21:56:26" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "21:58:59" , 
"departure_time" : "21:59:13" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "22:00:14" , 
"departure_time" : "22:00:59" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "22:02:45" , 
"departure_time" : "22:03:54" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "22:05:09" , 
"departure_time" : "22:05:16" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "22:06:07" , 
"departure_time" : "22:06:41" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "22:07:34" , 
"departure_time" : "22:07:53" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "22:08:19" , 
"departure_time" : "22:09:22" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "22:10:03" , 
"departure_time" : "22:10:06" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "22:10:03" , 
"departure_time" : "22:11:05" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "22:13:02" , 
"departure_time" : "22:13:02" , 
"distance_traveled" : 4.8572
} ], 
"3692" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "22:26:00" , 
"departure_time" : "22:28:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "22:29:05" , 
"departure_time" : "22:29:50" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "22:32:45" , 
"departure_time" : "22:33:55" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "22:35:10" , 
"departure_time" : "22:36:17" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "22:37:07" , 
"departure_time" : "22:38:16" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "22:39:09" , 
"departure_time" : "22:40:04" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "22:40:55" , 
"departure_time" : "22:41:52" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "22:41:57" , 
"departure_time" : "22:43:16" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "22:43:19" , 
"departure_time" : "22:44:53" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "22:44:34" , 
"departure_time" : "22:46:00" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "22:45:26" , 
"departure_time" : "22:46:13" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "22:46:47" , 
"departure_time" : "22:46:47" , 
"distance_traveled" : 4.8572
} ], 
"3693" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "23:05:00" , 
"departure_time" : "23:06:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "23:07:13" , 
"departure_time" : "23:08:17" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "23:12:04" , 
"departure_time" : "23:12:16" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "23:13:12" , 
"departure_time" : "23:13:22" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "23:15:10" , 
"departure_time" : "23:16:37" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "23:18:27" , 
"departure_time" : "23:18:48" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "23:19:21" , 
"departure_time" : "23:19:40" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "23:20:19" , 
"departure_time" : "23:20:33" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "23:21:14" , 
"departure_time" : "23:22:45" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "23:23:31" , 
"departure_time" : "23:23:53" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "23:23:22" , 
"departure_time" : "23:23:59" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "23:25:37" , 
"departure_time" : "23:25:37" , 
"distance_traveled" : 4.8572
} ], 
"3694" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "23:55:00" , 
"departure_time" : "23:56:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "23:57:47" , 
"departure_time" : "23:58:07" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "24:01:20" , 
"departure_time" : "24:01:24" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "24:03:04" , 
"departure_time" : "24:03:36" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "24:05:32" , 
"departure_time" : "24:05:49" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "24:07:17" , 
"departure_time" : "24:08:46" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "24:10:29" , 
"departure_time" : "24:10:57" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "24:10:28" , 
"departure_time" : "24:10:49" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "24:11:21" , 
"departure_time" : "24:11:22" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "24:12:01" , 
"departure_time" : "24:13:07" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "24:14:06" , 
"departure_time" : "24:15:21" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "24:16:15" , 
"departure_time" : "24:16:15" , 
"distance_traveled" : 4.8572
} ], 
"3695" :  [ 
{ 
"stop_id" : 38065,
"arrival_time" : "24:45:00" , 
"departure_time" : "24:47:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "24:48:30" , 
"departure_time" : "24:49:18" , 
"distance_traveled" : 0.4006
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "24:51:48" , 
"departure_time" : "24:53:15" , 
"distance_traveled" : 0.8252
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "24:54:27" , 
"departure_time" : "24:54:36" , 
"distance_traveled" : 1.3703
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "24:55:09" , 
"departure_time" : "24:56:27" , 
"distance_traveled" : 1.8814
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "24:58:18" , 
"departure_time" : "24:58:51" , 
"distance_traveled" : 2.4307
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "24:59:33" , 
"departure_time" : "24:59:51" , 
"distance_traveled" : 3.0044
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "25:00:18" , 
"departure_time" : "25:00:42" , 
"distance_traveled" : 3.4725
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "25:01:24" , 
"departure_time" : "25:02:58" , 
"distance_traveled" : 3.7331
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "25:03:34" , 
"departure_time" : "25:04:43" , 
"distance_traveled" : 4.2576
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "25:04:09" , 
"departure_time" : "25:04:48" , 
"distance_traveled" : 4.4379
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "25:05:39" , 
"departure_time" : "25:05:39" , 
"distance_traveled" : 4.8572
} ], 
"3696" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "06:28:00" , 
"departure_time" : "06:29:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "06:30:26" , 
"departure_time" : "06:31:28" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "06:33:02" , 
"departure_time" : "06:33:59" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:34:57" , 
"departure_time" : "06:34:58" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:36:01" , 
"departure_time" : "06:37:13" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:38:12" , 
"departure_time" : "06:39:15" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:39:03" , 
"departure_time" : "06:40:32" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:40:29" , 
"departure_time" : "06:40:44" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:40:15" , 
"departure_time" : "06:41:05" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "06:42:50" , 
"departure_time" : "06:42:50" , 
"distance_traveled" : 4.0362
} ], 
"3697" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "06:38:00" , 
"departure_time" : "06:39:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "06:40:25" , 
"departure_time" : "06:41:58" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "06:43:33" , 
"departure_time" : "06:44:09" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:44:36" , 
"departure_time" : "06:45:46" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:47:10" , 
"departure_time" : "06:48:01" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:47:51" , 
"departure_time" : "06:48:53" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:49:02" , 
"departure_time" : "06:50:42" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:50:40" , 
"departure_time" : "06:50:49" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:50:09" , 
"departure_time" : "06:50:48" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "06:52:39" , 
"departure_time" : "06:52:39" , 
"distance_traveled" : 4.0362
} ], 
"3698" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "06:46:00" , 
"departure_time" : "06:47:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "06:48:38" , 
"departure_time" : "06:48:40" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "06:50:02" , 
"departure_time" : "06:51:19" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:53:17" , 
"departure_time" : "06:53:23" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:54:06" , 
"departure_time" : "06:55:17" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:56:11" , 
"departure_time" : "06:56:45" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:56:34" , 
"departure_time" : "06:57:50" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:58:16" , 
"departure_time" : "06:59:50" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:59:34" , 
"departure_time" : "07:00:21" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:00:47" , 
"departure_time" : "07:00:47" , 
"distance_traveled" : 4.0362
} ], 
"3699" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "06:51:00" , 
"departure_time" : "06:53:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "06:54:37" , 
"departure_time" : "06:55:18" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "06:55:41" , 
"departure_time" : "06:56:55" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:58:14" , 
"departure_time" : "06:59:35" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:00:21" , 
"departure_time" : "07:00:34" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:00:13" , 
"departure_time" : "07:01:19" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:02:06" , 
"departure_time" : "07:02:37" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:02:31" , 
"departure_time" : "07:03:27" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:03:56" , 
"departure_time" : "07:04:22" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:05:26" , 
"departure_time" : "07:05:26" , 
"distance_traveled" : 4.0362
} ], 
"3700" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "06:59:00" , 
"departure_time" : "06:59:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:01:13" , 
"departure_time" : "07:02:40" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:04:27" , 
"departure_time" : "07:05:59" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:06:32" , 
"departure_time" : "07:08:09" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:08:37" , 
"departure_time" : "07:09:31" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:08:54" , 
"departure_time" : "07:09:04" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:09:10" , 
"departure_time" : "07:09:27" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:10:17" , 
"departure_time" : "07:10:49" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:11:32" , 
"departure_time" : "07:12:48" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:14:16" , 
"departure_time" : "07:14:16" , 
"distance_traveled" : 4.0362
} ], 
"3701" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "07:14:00" , 
"departure_time" : "07:16:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:17:18" , 
"departure_time" : "07:17:21" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:18:03" , 
"departure_time" : "07:18:43" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:20:40" , 
"departure_time" : "07:20:56" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:22:16" , 
"departure_time" : "07:23:22" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:24:06" , 
"departure_time" : "07:24:09" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:24:03" , 
"departure_time" : "07:25:41" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:26:38" , 
"departure_time" : "07:27:34" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:26:56" , 
"departure_time" : "07:27:09" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:28:13" , 
"departure_time" : "07:28:13" , 
"distance_traveled" : 4.0362
} ], 
"3702" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "07:21:00" , 
"departure_time" : "07:22:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:23:50" , 
"departure_time" : "07:24:05" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:25:15" , 
"departure_time" : "07:26:16" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:28:01" , 
"departure_time" : "07:28:49" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:29:48" , 
"departure_time" : "07:30:03" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:30:15" , 
"departure_time" : "07:31:10" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:31:55" , 
"departure_time" : "07:32:25" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:32:30" , 
"departure_time" : "07:32:41" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:33:11" , 
"departure_time" : "07:34:28" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:36:17" , 
"departure_time" : "07:36:17" , 
"distance_traveled" : 4.0362
} ], 
"3703" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "07:35:00" , 
"departure_time" : "07:36:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:37:32" , 
"departure_time" : "07:38:10" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:39:38" , 
"departure_time" : "07:40:14" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:41:36" , 
"departure_time" : "07:42:40" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:44:04" , 
"departure_time" : "07:44:21" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:44:17" , 
"departure_time" : "07:45:06" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:45:49" , 
"departure_time" : "07:46:17" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:46:28" , 
"departure_time" : "07:47:28" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:48:00" , 
"departure_time" : "07:48:51" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:49:51" , 
"departure_time" : "07:49:51" , 
"distance_traveled" : 4.0362
} ], 
"3704" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "07:42:00" , 
"departure_time" : "07:44:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:45:39" , 
"departure_time" : "07:45:55" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:46:16" , 
"departure_time" : "07:46:39" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:48:23" , 
"departure_time" : "07:48:56" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:50:33" , 
"departure_time" : "07:51:20" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:51:47" , 
"departure_time" : "07:51:51" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:52:04" , 
"departure_time" : "07:52:47" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:53:43" , 
"departure_time" : "07:54:17" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:54:34" , 
"departure_time" : "07:55:11" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:56:37" , 
"departure_time" : "07:56:37" , 
"distance_traveled" : 4.0362
} ], 
"3705" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "07:49:00" , 
"departure_time" : "07:50:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:51:24" , 
"departure_time" : "07:51:29" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:53:05" , 
"departure_time" : "07:53:10" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:55:05" , 
"departure_time" : "07:56:25" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:58:20" , 
"departure_time" : "07:59:13" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:58:53" , 
"departure_time" : "07:59:47" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:59:54" , 
"departure_time" : "08:00:00" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:00:06" , 
"departure_time" : "08:00:52" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:01:46" , 
"departure_time" : "08:02:59" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:04:13" , 
"departure_time" : "08:04:13" , 
"distance_traveled" : 4.0362
} ], 
"3706" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "07:55:00" , 
"departure_time" : "07:57:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:58:20" , 
"departure_time" : "07:59:39" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:00:19" , 
"departure_time" : "08:00:42" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:01:23" , 
"departure_time" : "08:02:40" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:04:17" , 
"departure_time" : "08:05:29" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:05:12" , 
"departure_time" : "08:06:45" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:06:33" , 
"departure_time" : "08:06:55" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:06:22" , 
"departure_time" : "08:07:32" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:08:10" , 
"departure_time" : "08:09:08" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:09:58" , 
"departure_time" : "08:09:58" , 
"distance_traveled" : 4.0362
} ], 
"3707" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "08:03:00" , 
"departure_time" : "08:05:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:06:24" , 
"departure_time" : "08:08:04" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:08:40" , 
"departure_time" : "08:09:11" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:09:31" , 
"departure_time" : "08:11:08" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:12:37" , 
"departure_time" : "08:14:06" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:13:29" , 
"departure_time" : "08:14:44" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:14:15" , 
"departure_time" : "08:15:45" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:15:30" , 
"departure_time" : "08:16:24" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:15:54" , 
"departure_time" : "08:15:58" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:17:04" , 
"departure_time" : "08:17:04" , 
"distance_traveled" : 4.0362
} ], 
"3708" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "08:10:00" , 
"departure_time" : "08:10:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:12:02" , 
"departure_time" : "08:12:11" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:14:09" , 
"departure_time" : "08:14:11" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:16:02" , 
"departure_time" : "08:16:44" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:18:42" , 
"departure_time" : "08:20:02" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:20:20" , 
"departure_time" : "08:21:18" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:20:58" , 
"departure_time" : "08:22:03" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:22:05" , 
"departure_time" : "08:23:02" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:22:57" , 
"departure_time" : "08:24:30" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:25:33" , 
"departure_time" : "08:25:33" , 
"distance_traveled" : 4.0362
} ], 
"3709" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "08:18:00" , 
"departure_time" : "08:20:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:20:39" , 
"departure_time" : "08:20:50" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:22:11" , 
"departure_time" : "08:23:43" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:25:32" , 
"departure_time" : "08:25:57" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:26:25" , 
"departure_time" : "08:26:35" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:27:10" , 
"departure_time" : "08:27:36" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:28:26" , 
"departure_time" : "08:29:30" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:30:04" , 
"departure_time" : "08:30:56" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:30:52" , 
"departure_time" : "08:31:49" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:32:57" , 
"departure_time" : "08:32:57" , 
"distance_traveled" : 4.0362
} ], 
"3710" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "08:21:00" , 
"departure_time" : "08:23:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:24:16" , 
"departure_time" : "08:25:17" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:26:01" , 
"departure_time" : "08:27:08" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:28:07" , 
"departure_time" : "08:28:14" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:29:07" , 
"departure_time" : "08:30:26" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:31:19" , 
"departure_time" : "08:31:29" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:31:10" , 
"departure_time" : "08:31:12" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:32:02" , 
"departure_time" : "08:33:35" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:34:33" , 
"departure_time" : "08:36:07" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:36:34" , 
"departure_time" : "08:36:34" , 
"distance_traveled" : 4.0362
} ], 
"3711" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "08:30:00" , 
"departure_time" : "08:32:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:33:19" , 
"departure_time" : "08:33:26" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:34:07" , 
"departure_time" : "08:35:07" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:37:00" , 
"departure_time" : "08:37:31" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:38:31" , 
"departure_time" : "08:38:33" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:39:02" , 
"departure_time" : "08:39:26" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:40:24" , 
"departure_time" : "08:41:07" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:41:43" , 
"departure_time" : "08:43:02" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:43:19" , 
"departure_time" : "08:43:26" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:44:07" , 
"departure_time" : "08:44:07" , 
"distance_traveled" : 4.0362
} ], 
"3712" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "08:38:00" , 
"departure_time" : "08:38:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:40:12" , 
"departure_time" : "08:41:40" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:43:28" , 
"departure_time" : "08:44:43" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:45:15" , 
"departure_time" : "08:46:49" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:47:34" , 
"departure_time" : "08:49:11" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:48:37" , 
"departure_time" : "08:49:00" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:48:23" , 
"departure_time" : "08:49:16" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:49:53" , 
"departure_time" : "08:50:21" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:50:28" , 
"departure_time" : "08:50:49" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:52:21" , 
"departure_time" : "08:52:21" , 
"distance_traveled" : 4.0362
} ], 
"3713" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "08:45:00" , 
"departure_time" : "08:46:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:47:46" , 
"departure_time" : "08:48:18" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:49:32" , 
"departure_time" : "08:49:34" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:51:02" , 
"departure_time" : "08:52:10" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:54:08" , 
"departure_time" : "08:54:18" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:54:10" , 
"departure_time" : "08:54:32" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:55:22" , 
"departure_time" : "08:56:58" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:57:36" , 
"departure_time" : "08:58:11" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:57:35" , 
"departure_time" : "08:58:39" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "09:00:04" , 
"departure_time" : "09:00:04" , 
"distance_traveled" : 4.0362
} ], 
"3714" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "08:52:00" , 
"departure_time" : "08:53:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:54:33" , 
"departure_time" : "08:56:02" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:57:29" , 
"departure_time" : "08:58:03" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:58:34" , 
"departure_time" : "08:59:48" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:01:14" , 
"departure_time" : "09:02:50" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:02:36" , 
"departure_time" : "09:03:17" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:02:41" , 
"departure_time" : "09:04:11" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:04:30" , 
"departure_time" : "09:05:54" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:05:24" , 
"departure_time" : "09:06:08" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "09:06:44" , 
"departure_time" : "09:06:44" , 
"distance_traveled" : 4.0362
} ], 
"3715" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "09:06:00" , 
"departure_time" : "09:07:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:08:47" , 
"departure_time" : "09:09:04" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:10:17" , 
"departure_time" : "09:11:49" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:13:32" , 
"departure_time" : "09:14:20" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:14:48" , 
"departure_time" : "09:15:00" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:15:12" , 
"departure_time" : "09:15:40" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:16:28" , 
"departure_time" : "09:16:46" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:17:18" , 
"departure_time" : "09:18:21" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:19:03" , 
"departure_time" : "09:19:53" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "09:20:50" , 
"departure_time" : "09:20:50" , 
"distance_traveled" : 4.0362
} ], 
"3716" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "09:13:00" , 
"departure_time" : "09:14:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:16:06" , 
"departure_time" : "09:16:21" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:17:15" , 
"departure_time" : "09:18:44" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:20:29" , 
"departure_time" : "09:20:53" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:21:24" , 
"departure_time" : "09:22:39" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:23:15" , 
"departure_time" : "09:24:28" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:24:13" , 
"departure_time" : "09:25:46" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:25:33" , 
"departure_time" : "09:25:39" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:25:06" , 
"departure_time" : "09:26:38" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "09:28:32" , 
"departure_time" : "09:28:32" , 
"distance_traveled" : 4.0362
} ], 
"3717" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "09:21:00" , 
"departure_time" : "09:23:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:24:20" , 
"departure_time" : "09:24:39" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:25:19" , 
"departure_time" : "09:26:27" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:28:08" , 
"departure_time" : "09:29:06" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:29:58" , 
"departure_time" : "09:31:18" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:31:20" , 
"departure_time" : "09:31:35" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:31:15" , 
"departure_time" : "09:31:32" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:32:17" , 
"departure_time" : "09:32:39" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:33:22" , 
"departure_time" : "09:33:31" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "09:35:09" , 
"departure_time" : "09:35:09" , 
"distance_traveled" : 4.0362
} ], 
"3718" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "15:32:00" , 
"departure_time" : "15:33:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:35:19" , 
"departure_time" : "15:36:05" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:36:46" , 
"departure_time" : "15:37:15" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:38:29" , 
"departure_time" : "15:38:46" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:40:17" , 
"departure_time" : "15:41:33" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:42:16" , 
"departure_time" : "15:42:57" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:42:41" , 
"departure_time" : "15:43:42" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:44:01" , 
"departure_time" : "15:44:34" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:44:33" , 
"departure_time" : "15:45:25" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "15:46:52" , 
"departure_time" : "15:46:52" , 
"distance_traveled" : 4.0362
} ], 
"3719" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "15:38:00" , 
"departure_time" : "15:40:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:41:34" , 
"departure_time" : "15:43:14" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:43:40" , 
"departure_time" : "15:45:02" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:45:22" , 
"departure_time" : "15:45:58" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:46:36" , 
"departure_time" : "15:47:30" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:47:54" , 
"departure_time" : "15:48:35" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:48:41" , 
"departure_time" : "15:49:57" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:50:16" , 
"departure_time" : "15:51:50" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:51:34" , 
"departure_time" : "15:52:43" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "15:53:09" , 
"departure_time" : "15:53:09" , 
"distance_traveled" : 4.0362
} ], 
"3720" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "15:46:00" , 
"departure_time" : "15:47:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:48:11" , 
"departure_time" : "15:49:48" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:51:37" , 
"departure_time" : "15:52:12" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:52:35" , 
"departure_time" : "15:53:27" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:54:52" , 
"departure_time" : "15:54:55" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:55:03" , 
"departure_time" : "15:56:14" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:57:11" , 
"departure_time" : "15:57:22" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:57:11" , 
"departure_time" : "15:58:44" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:59:33" , 
"departure_time" : "15:59:49" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:00:16" , 
"departure_time" : "16:00:16" , 
"distance_traveled" : 4.0362
} ], 
"3721" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "15:58:00" , 
"departure_time" : "15:59:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:00:56" , 
"departure_time" : "16:02:10" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:03:14" , 
"departure_time" : "16:03:58" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:04:44" , 
"departure_time" : "16:05:43" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:06:59" , 
"departure_time" : "16:07:47" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:07:48" , 
"departure_time" : "16:07:51" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:08:03" , 
"departure_time" : "16:09:32" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:10:29" , 
"departure_time" : "16:10:41" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:10:12" , 
"departure_time" : "16:10:57" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:12:45" , 
"departure_time" : "16:12:45" , 
"distance_traveled" : 4.0362
} ], 
"3722" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "16:07:00" , 
"departure_time" : "16:08:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:10:03" , 
"departure_time" : "16:11:24" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:12:21" , 
"departure_time" : "16:12:29" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:13:08" , 
"departure_time" : "16:13:37" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:15:29" , 
"departure_time" : "16:15:54" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:16:25" , 
"departure_time" : "16:16:55" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:17:30" , 
"departure_time" : "16:17:47" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:18:17" , 
"departure_time" : "16:19:40" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:20:23" , 
"departure_time" : "16:21:53" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:22:30" , 
"departure_time" : "16:22:30" , 
"distance_traveled" : 4.0362
} ], 
"3723" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "16:14:00" , 
"departure_time" : "16:15:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:16:19" , 
"departure_time" : "16:16:54" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:18:35" , 
"departure_time" : "16:19:46" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:21:11" , 
"departure_time" : "16:22:22" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:23:11" , 
"departure_time" : "16:24:22" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:24:11" , 
"departure_time" : "16:24:43" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:24:32" , 
"departure_time" : "16:25:56" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:26:24" , 
"departure_time" : "16:26:40" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:26:16" , 
"departure_time" : "16:27:28" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:29:12" , 
"departure_time" : "16:29:12" , 
"distance_traveled" : 4.0362
} ], 
"3724" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "16:21:00" , 
"departure_time" : "16:23:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:24:10" , 
"departure_time" : "16:25:26" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:26:16" , 
"departure_time" : "16:27:28" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:28:12" , 
"departure_time" : "16:28:17" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:29:05" , 
"departure_time" : "16:30:42" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:31:37" , 
"departure_time" : "16:32:25" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:31:48" , 
"departure_time" : "16:33:27" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:33:39" , 
"departure_time" : "16:34:25" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:33:46" , 
"departure_time" : "16:35:08" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:36:22" , 
"departure_time" : "16:36:22" , 
"distance_traveled" : 4.0362
} ], 
"3725" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "16:28:00" , 
"departure_time" : "16:30:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:30:53" , 
"departure_time" : "16:31:33" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:32:40" , 
"departure_time" : "16:33:13" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:34:33" , 
"departure_time" : "16:34:53" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:36:20" , 
"departure_time" : "16:37:27" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:38:07" , 
"departure_time" : "16:39:25" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:39:18" , 
"departure_time" : "16:40:48" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:40:30" , 
"departure_time" : "16:40:34" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:40:04" , 
"departure_time" : "16:40:28" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:42:24" , 
"departure_time" : "16:42:24" , 
"distance_traveled" : 4.0362
} ], 
"3726" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "16:42:00" , 
"departure_time" : "16:42:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:44:22" , 
"departure_time" : "16:45:20" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:46:58" , 
"departure_time" : "16:47:35" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:48:37" , 
"departure_time" : "16:49:44" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:51:07" , 
"departure_time" : "16:51:57" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:51:50" , 
"departure_time" : "16:53:00" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:53:10" , 
"departure_time" : "16:53:58" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:53:48" , 
"departure_time" : "16:54:06" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:54:18" , 
"departure_time" : "16:54:49" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:56:31" , 
"departure_time" : "16:56:31" , 
"distance_traveled" : 4.0362
} ], 
"3727" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "16:48:00" , 
"departure_time" : "16:49:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:51:23" , 
"departure_time" : "16:51:56" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:52:33" , 
"departure_time" : "16:54:10" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:55:37" , 
"departure_time" : "16:56:56" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:57:19" , 
"departure_time" : "16:58:18" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:57:59" , 
"departure_time" : "16:59:29" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:59:30" , 
"departure_time" : "16:59:53" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:59:23" , 
"departure_time" : "16:59:45" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:00:22" , 
"departure_time" : "17:01:05" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "17:02:43" , 
"departure_time" : "17:02:43" , 
"distance_traveled" : 4.0362
} ], 
"3728" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "16:56:00" , 
"departure_time" : "16:58:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:59:18" , 
"departure_time" : "16:59:52" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:00:34" , 
"departure_time" : "17:02:12" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:03:38" , 
"departure_time" : "17:04:39" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:05:01" , 
"departure_time" : "17:06:39" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:06:38" , 
"departure_time" : "17:07:44" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:07:06" , 
"departure_time" : "17:07:20" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:07:14" , 
"departure_time" : "17:07:43" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:08:29" , 
"departure_time" : "17:08:32" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "17:10:03" , 
"departure_time" : "17:10:03" , 
"distance_traveled" : 4.0362
} ], 
"3729" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "17:03:00" , 
"departure_time" : "17:03:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:05:43" , 
"departure_time" : "17:06:33" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:07:50" , 
"departure_time" : "17:08:53" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:10:03" , 
"departure_time" : "17:11:36" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:12:33" , 
"departure_time" : "17:12:50" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:12:17" , 
"departure_time" : "17:13:03" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:13:46" , 
"departure_time" : "17:14:39" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:14:53" , 
"departure_time" : "17:16:08" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:16:15" , 
"departure_time" : "17:17:07" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "17:17:52" , 
"departure_time" : "17:17:52" , 
"distance_traveled" : 4.0362
} ], 
"3730" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "17:10:00" , 
"departure_time" : "17:12:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:13:23" , 
"departure_time" : "17:13:44" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:14:21" , 
"departure_time" : "17:15:40" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:17:19" , 
"departure_time" : "17:18:14" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:18:55" , 
"departure_time" : "17:19:22" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:19:27" , 
"departure_time" : "17:20:46" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:21:19" , 
"departure_time" : "17:22:00" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:21:41" , 
"departure_time" : "17:22:31" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:22:50" , 
"departure_time" : "17:22:59" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "17:24:09" , 
"departure_time" : "17:24:09" , 
"distance_traveled" : 4.0362
} ], 
"3731" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "17:17:00" , 
"departure_time" : "17:18:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:20:37" , 
"departure_time" : "17:20:54" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:21:17" , 
"departure_time" : "17:22:36" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:24:19" , 
"departure_time" : "17:25:01" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:25:42" , 
"departure_time" : "17:26:52" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:27:10" , 
"departure_time" : "17:27:15" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:27:05" , 
"departure_time" : "17:27:50" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:28:45" , 
"departure_time" : "17:29:58" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:30:13" , 
"departure_time" : "17:31:45" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "17:32:32" , 
"departure_time" : "17:32:32" , 
"distance_traveled" : 4.0362
} ], 
"3732" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "17:25:00" , 
"departure_time" : "17:27:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:28:15" , 
"departure_time" : "17:29:23" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:30:08" , 
"departure_time" : "17:30:20" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:31:12" , 
"departure_time" : "17:31:52" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:33:40" , 
"departure_time" : "17:34:44" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:35:04" , 
"departure_time" : "17:36:25" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:36:21" , 
"departure_time" : "17:37:29" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:37:08" , 
"departure_time" : "17:38:19" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:38:11" , 
"departure_time" : "17:38:39" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "17:39:28" , 
"departure_time" : "17:39:28" , 
"distance_traveled" : 4.0362
} ], 
"3733" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "17:30:00" , 
"departure_time" : "17:30:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:32:31" , 
"departure_time" : "17:32:42" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:34:11" , 
"departure_time" : "17:34:33" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:36:22" , 
"departure_time" : "17:37:57" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:39:35" , 
"departure_time" : "17:41:05" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:40:30" , 
"departure_time" : "17:42:04" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:41:34" , 
"departure_time" : "17:43:14" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:42:40" , 
"departure_time" : "17:43:21" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:42:41" , 
"departure_time" : "17:44:16" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "17:45:35" , 
"departure_time" : "17:45:35" , 
"distance_traveled" : 4.0362
} ], 
"3734" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "17:38:00" , 
"departure_time" : "17:40:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:40:57" , 
"departure_time" : "17:42:06" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:43:09" , 
"departure_time" : "17:43:37" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:44:28" , 
"departure_time" : "17:45:58" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:47:30" , 
"departure_time" : "17:48:26" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:47:56" , 
"departure_time" : "17:48:26" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:48:30" , 
"departure_time" : "17:48:33" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:49:03" , 
"departure_time" : "17:50:27" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:51:24" , 
"departure_time" : "17:52:11" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "17:52:47" , 
"departure_time" : "17:52:47" , 
"distance_traveled" : 4.0362
} ], 
"3735" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "17:45:00" , 
"departure_time" : "17:46:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:47:49" , 
"departure_time" : "17:49:08" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:50:19" , 
"departure_time" : "17:50:22" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:51:03" , 
"departure_time" : "17:52:31" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:54:28" , 
"departure_time" : "17:55:55" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:55:27" , 
"departure_time" : "17:56:32" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:56:05" , 
"departure_time" : "17:57:17" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:57:12" , 
"departure_time" : "17:58:23" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:58:11" , 
"departure_time" : "17:58:19" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "17:59:08" , 
"departure_time" : "17:59:08" , 
"distance_traveled" : 4.0362
} ], 
"3736" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "17:52:00" , 
"departure_time" : "17:52:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:54:06" , 
"departure_time" : "17:55:01" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:56:55" , 
"departure_time" : "17:57:00" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:58:05" , 
"departure_time" : "17:58:16" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:00:11" , 
"departure_time" : "18:01:18" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:02:07" , 
"departure_time" : "18:03:32" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:03:25" , 
"departure_time" : "18:05:00" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:04:35" , 
"departure_time" : "18:05:49" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:05:14" , 
"departure_time" : "18:06:43" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:07:29" , 
"departure_time" : "18:07:29" , 
"distance_traveled" : 4.0362
} ], 
"3737" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "17:59:00" , 
"departure_time" : "18:01:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:01:49" , 
"departure_time" : "18:02:42" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:03:53" , 
"departure_time" : "18:04:22" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:05:29" , 
"departure_time" : "18:06:45" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:08:16" , 
"departure_time" : "18:09:56" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:09:40" , 
"departure_time" : "18:10:15" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:09:35" , 
"departure_time" : "18:10:30" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:10:55" , 
"departure_time" : "18:11:30" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:11:35" , 
"departure_time" : "18:12:29" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:13:54" , 
"departure_time" : "18:13:54" , 
"distance_traveled" : 4.0362
} ], 
"3738" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "18:13:00" , 
"departure_time" : "18:15:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:16:23" , 
"departure_time" : "18:18:02" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:18:39" , 
"departure_time" : "18:18:46" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:19:07" , 
"departure_time" : "18:19:09" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:21:02" , 
"departure_time" : "18:21:48" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:22:46" , 
"departure_time" : "18:23:59" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:24:13" , 
"departure_time" : "18:24:35" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:24:22" , 
"departure_time" : "18:25:16" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:25:54" , 
"departure_time" : "18:26:27" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:27:33" , 
"departure_time" : "18:27:33" , 
"distance_traveled" : 4.0362
} ], 
"3739" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "18:20:00" , 
"departure_time" : "18:21:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:23:24" , 
"departure_time" : "18:23:32" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:24:08" , 
"departure_time" : "18:24:11" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:26:03" , 
"departure_time" : "18:26:44" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:28:41" , 
"departure_time" : "18:29:31" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:29:50" , 
"departure_time" : "18:29:51" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:30:01" , 
"departure_time" : "18:31:32" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:32:31" , 
"departure_time" : "18:33:56" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:33:25" , 
"departure_time" : "18:33:54" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:34:29" , 
"departure_time" : "18:34:29" , 
"distance_traveled" : 4.0362
} ], 
"3740" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "18:27:00" , 
"departure_time" : "18:27:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:29:21" , 
"departure_time" : "18:30:49" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:32:28" , 
"departure_time" : "18:33:22" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:33:54" , 
"departure_time" : "18:34:52" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:35:58" , 
"departure_time" : "18:36:14" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:36:16" , 
"departure_time" : "18:36:20" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:37:04" , 
"departure_time" : "18:38:29" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:39:25" , 
"departure_time" : "18:40:00" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:39:35" , 
"departure_time" : "18:39:54" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:41:19" , 
"departure_time" : "18:41:19" , 
"distance_traveled" : 4.0362
} ], 
"3741" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "18:34:00" , 
"departure_time" : "18:34:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:36:07" , 
"departure_time" : "18:36:30" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:38:23" , 
"departure_time" : "18:38:44" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:40:21" , 
"departure_time" : "18:40:59" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:42:38" , 
"departure_time" : "18:42:41" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:43:03" , 
"departure_time" : "18:43:18" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:44:15" , 
"departure_time" : "18:45:35" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:46:20" , 
"departure_time" : "18:47:59" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:47:39" , 
"departure_time" : "18:47:43" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:48:04" , 
"departure_time" : "18:48:04" , 
"distance_traveled" : 4.0362
} ], 
"3742" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "18:40:00" , 
"departure_time" : "18:40:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:42:54" , 
"departure_time" : "18:43:00" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:44:06" , 
"departure_time" : "18:44:51" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:46:45" , 
"departure_time" : "18:47:33" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:48:48" , 
"departure_time" : "18:49:40" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:49:52" , 
"departure_time" : "18:50:20" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:50:28" , 
"departure_time" : "18:51:06" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:51:38" , 
"departure_time" : "18:53:15" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:53:37" , 
"departure_time" : "18:54:15" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:54:38" , 
"departure_time" : "18:54:38" , 
"distance_traveled" : 4.0362
} ], 
"3743" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "18:48:00" , 
"departure_time" : "18:48:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:50:13" , 
"departure_time" : "18:51:11" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:52:58" , 
"departure_time" : "18:53:08" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:54:10" , 
"departure_time" : "18:54:37" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:56:27" , 
"departure_time" : "18:57:25" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:57:58" , 
"departure_time" : "18:58:57" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:58:59" , 
"departure_time" : "19:00:18" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:00:19" , 
"departure_time" : "19:00:46" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "19:00:27" , 
"departure_time" : "19:01:58" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "19:03:31" , 
"departure_time" : "19:03:31" , 
"distance_traveled" : 4.0362
} ], 
"3744" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "18:58:00" , 
"departure_time" : "19:00:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:00:50" , 
"departure_time" : "19:02:01" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:03:11" , 
"departure_time" : "19:04:07" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:04:56" , 
"departure_time" : "19:05:10" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "19:06:14" , 
"departure_time" : "19:06:24" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "19:07:10" , 
"departure_time" : "19:08:11" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "19:09:01" , 
"departure_time" : "19:09:24" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:09:23" , 
"departure_time" : "19:10:10" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "19:10:47" , 
"departure_time" : "19:12:01" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "19:13:14" , 
"departure_time" : "19:13:14" , 
"distance_traveled" : 4.0362
} ], 
"3745" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "19:10:00" , 
"departure_time" : "19:12:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:12:46" , 
"departure_time" : "19:14:22" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:15:36" , 
"departure_time" : "19:16:15" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:16:39" , 
"departure_time" : "19:18:18" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "19:19:39" , 
"departure_time" : "19:20:55" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "19:20:16" , 
"departure_time" : "19:20:57" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "19:20:41" , 
"departure_time" : "19:21:30" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:21:49" , 
"departure_time" : "19:22:09" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "19:22:20" , 
"departure_time" : "19:23:06" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "19:24:46" , 
"departure_time" : "19:24:46" , 
"distance_traveled" : 4.0362
} ], 
"3746" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "19:24:00" , 
"departure_time" : "19:25:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:26:16" , 
"departure_time" : "19:27:53" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:29:37" , 
"departure_time" : "19:30:36" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:30:59" , 
"departure_time" : "19:31:42" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "19:32:43" , 
"departure_time" : "19:34:07" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "19:34:24" , 
"departure_time" : "19:34:52" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "19:34:28" , 
"departure_time" : "19:35:58" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:36:30" , 
"departure_time" : "19:37:11" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "19:36:41" , 
"departure_time" : "19:36:55" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "19:38:14" , 
"departure_time" : "19:38:14" , 
"distance_traveled" : 4.0362
} ], 
"3747" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "19:38:00" , 
"departure_time" : "19:38:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:40:08" , 
"departure_time" : "19:40:27" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:42:19" , 
"departure_time" : "19:43:12" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:44:53" , 
"departure_time" : "19:44:55" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "19:46:02" , 
"departure_time" : "19:47:41" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "19:48:39" , 
"departure_time" : "19:49:04" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "19:48:25" , 
"departure_time" : "19:49:05" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:49:40" , 
"departure_time" : "19:49:52" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "19:50:12" , 
"departure_time" : "19:51:07" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "19:52:55" , 
"departure_time" : "19:52:55" , 
"distance_traveled" : 4.0362
} ], 
"3748" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "19:52:00" , 
"departure_time" : "19:53:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:54:19" , 
"departure_time" : "19:54:29" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:56:10" , 
"departure_time" : "19:57:05" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:58:55" , 
"departure_time" : "19:59:32" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "20:00:37" , 
"departure_time" : "20:00:46" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "20:01:09" , 
"departure_time" : "20:01:46" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "20:02:37" , 
"departure_time" : "20:03:04" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "20:03:27" , 
"departure_time" : "20:04:52" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "20:05:25" , 
"departure_time" : "20:05:44" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "20:06:19" , 
"departure_time" : "20:06:19" , 
"distance_traveled" : 4.0362
} ], 
"3749" :  [ 
{ 
"stop_id" : 26316,
"arrival_time" : "20:20:00" , 
"departure_time" : "20:21:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "20:22:44" , 
"departure_time" : "20:23:39" , 
"distance_traveled" : 0.5492
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "20:24:55" , 
"departure_time" : "20:25:41" , 
"distance_traveled" : 1.0604
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "20:26:46" , 
"departure_time" : "20:28:15" , 
"distance_traveled" : 1.6097
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "20:29:29" , 
"departure_time" : "20:29:58" , 
"distance_traveled" : 2.1833
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "20:29:29" , 
"departure_time" : "20:30:41" , 
"distance_traveled" : 2.6515
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "20:31:12" , 
"departure_time" : "20:31:13" , 
"distance_traveled" : 2.9121
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "20:31:01" , 
"departure_time" : "20:31:44" , 
"distance_traveled" : 3.4366
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "20:32:43" , 
"departure_time" : "20:33:06" , 
"distance_traveled" : 3.6169
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "20:34:23" , 
"departure_time" : "20:34:23" , 
"distance_traveled" : 4.0362
} ], 
"3750" :  [ 
{ 
"stop_id" : 38064,
"arrival_time" : "05:57:00" , 
"departure_time" : "05:58:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "06:01:46" , 
"departure_time" : "06:02:23" , 
"distance_traveled" : 0.4278
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "06:03:37" , 
"departure_time" : "06:04:01" , 
"distance_traveled" : 0.9729
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "06:05:24" , 
"departure_time" : "06:06:27" , 
"distance_traveled" : 1.4841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:08:03" , 
"departure_time" : "06:08:18" , 
"distance_traveled" : 2.0333
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:09:15" , 
"departure_time" : "06:10:08" , 
"distance_traveled" : 2.607
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:10:53" , 
"departure_time" : "06:10:58" , 
"distance_traveled" : 3.0752
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:11:05" , 
"departure_time" : "06:11:13" , 
"distance_traveled" : 3.3358
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:12:08" , 
"departure_time" : "06:13:45" , 
"distance_traveled" : 3.8602
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:14:37" , 
"departure_time" : "06:15:27" , 
"distance_traveled" : 4.0405
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "06:15:50" , 
"departure_time" : "06:15:50" , 
"distance_traveled" : 4.4598
} ], 
"3751" :  [ 
{ 
"stop_id" : 38064,
"arrival_time" : "06:06:00" , 
"departure_time" : "06:08:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "06:11:21" , 
"departure_time" : "06:12:37" , 
"distance_traveled" : 0.4278
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "06:13:16" , 
"departure_time" : "06:14:27" , 
"distance_traveled" : 0.9729
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "06:15:11" , 
"departure_time" : "06:16:21" , 
"distance_traveled" : 1.4841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:17:10" , 
"departure_time" : "06:17:48" , 
"distance_traveled" : 2.0333
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:18:38" , 
"departure_time" : "06:19:37" , 
"distance_traveled" : 2.607
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:19:59" , 
"departure_time" : "06:20:26" , 
"distance_traveled" : 3.0752
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:20:27" , 
"departure_time" : "06:20:52" , 
"distance_traveled" : 3.3358
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:21:25" , 
"departure_time" : "06:22:03" , 
"distance_traveled" : 3.8602
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:22:38" , 
"departure_time" : "06:23:55" , 
"distance_traveled" : 4.0405
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "06:25:17" , 
"departure_time" : "06:25:17" , 
"distance_traveled" : 4.4598
} ], 
"3752" :  [ 
{ 
"stop_id" : 38064,
"arrival_time" : "07:03:00" , 
"departure_time" : "07:05:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:07:49" , 
"departure_time" : "07:08:27" , 
"distance_traveled" : 0.4278
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:09:38" , 
"departure_time" : "07:10:38" , 
"distance_traveled" : 0.9729
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:12:00" , 
"departure_time" : "07:12:19" , 
"distance_traveled" : 1.4841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:13:19" , 
"departure_time" : "07:14:34" , 
"distance_traveled" : 2.0333
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:16:15" , 
"departure_time" : "07:17:41" , 
"distance_traveled" : 2.607
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:17:26" , 
"departure_time" : "07:18:02" , 
"distance_traveled" : 3.0752
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:17:36" , 
"departure_time" : "07:18:08" , 
"distance_traveled" : 3.3358
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:18:32" , 
"departure_time" : "07:19:23" , 
"distance_traveled" : 3.8602
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:19:51" , 
"departure_time" : "07:20:26" , 
"distance_traveled" : 4.0405
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:21:35" , 
"departure_time" : "07:21:35" , 
"distance_traveled" : 4.4598
} ], 
"3753" :  [ 
{ 
"stop_id" : 38064,
"arrival_time" : "15:08:00" , 
"departure_time" : "15:09:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "15:12:46" , 
"departure_time" : "15:14:16" , 
"distance_traveled" : 0.4278
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:15:30" , 
"departure_time" : "15:16:39" , 
"distance_traveled" : 0.9729
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:17:09" , 
"departure_time" : "15:17:16" , 
"distance_traveled" : 1.4841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:18:07" , 
"departure_time" : "15:19:47" , 
"distance_traveled" : 2.0333
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:21:40" , 
"departure_time" : "15:23:14" , 
"distance_traveled" : 2.607
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:22:34" , 
"departure_time" : "15:22:56" , 
"distance_traveled" : 3.0752
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:22:22" , 
"departure_time" : "15:23:59" , 
"distance_traveled" : 3.3358
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:24:37" , 
"departure_time" : "15:26:16" , 
"distance_traveled" : 3.8602
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:25:39" , 
"departure_time" : "15:27:05" , 
"distance_traveled" : 4.0405
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "15:27:26" , 
"departure_time" : "15:27:26" , 
"distance_traveled" : 4.4598
} ], 
"3754" :  [ 
{ 
"stop_id" : 38064,
"arrival_time" : "15:12:00" , 
"departure_time" : "15:14:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "15:16:39" , 
"departure_time" : "15:17:39" , 
"distance_traveled" : 0.4278
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:19:00" , 
"departure_time" : "15:20:40" , 
"distance_traveled" : 0.9729
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:21:40" , 
"departure_time" : "15:22:24" , 
"distance_traveled" : 1.4841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:22:44" , 
"departure_time" : "15:24:06" , 
"distance_traveled" : 2.0333
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:25:22" , 
"departure_time" : "15:25:37" , 
"distance_traveled" : 2.607
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:25:15" , 
"departure_time" : "15:25:16" , 
"distance_traveled" : 3.0752
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:26:01" , 
"departure_time" : "15:27:25" , 
"distance_traveled" : 3.3358
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:28:24" , 
"departure_time" : "15:29:19" , 
"distance_traveled" : 3.8602
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:28:55" , 
"departure_time" : "15:29:24" , 
"distance_traveled" : 4.0405
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "15:30:29" , 
"departure_time" : "15:30:29" , 
"distance_traveled" : 4.4598
} ], 
"3755" :  [ 
{ 
"stop_id" : 38064,
"arrival_time" : "15:20:00" , 
"departure_time" : "15:20:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "15:24:08" , 
"departure_time" : "15:24:51" , 
"distance_traveled" : 0.4278
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:26:43" , 
"departure_time" : "15:27:39" , 
"distance_traveled" : 0.9729
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:28:56" , 
"departure_time" : "15:29:38" , 
"distance_traveled" : 1.4841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:30:42" , 
"departure_time" : "15:32:11" , 
"distance_traveled" : 2.0333
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:33:29" , 
"departure_time" : "15:35:03" , 
"distance_traveled" : 2.607
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:34:34" , 
"departure_time" : "15:35:46" , 
"distance_traveled" : 3.0752
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:35:12" , 
"departure_time" : "15:35:46" , 
"distance_traveled" : 3.3358
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:35:34" , 
"departure_time" : "15:35:48" , 
"distance_traveled" : 3.8602
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:36:14" , 
"departure_time" : "15:36:20" , 
"distance_traveled" : 4.0405
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "15:38:06" , 
"departure_time" : "15:38:06" , 
"distance_traveled" : 4.4598
} ], 
"3756" :  [ 
{ 
"stop_id" : 38064,
"arrival_time" : "15:22:00" , 
"departure_time" : "15:22:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "15:26:34" , 
"departure_time" : "15:27:25" , 
"distance_traveled" : 0.4278
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:28:51" , 
"departure_time" : "15:29:15" , 
"distance_traveled" : 0.9729
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:30:24" , 
"departure_time" : "15:31:50" , 
"distance_traveled" : 1.4841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:33:26" , 
"departure_time" : "15:33:45" , 
"distance_traveled" : 2.0333
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:34:19" , 
"departure_time" : "15:34:30" , 
"distance_traveled" : 2.607
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:35:11" , 
"departure_time" : "15:35:54" , 
"distance_traveled" : 3.0752
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:36:43" , 
"departure_time" : "15:36:53" , 
"distance_traveled" : 3.3358
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:37:10" , 
"departure_time" : "15:38:12" , 
"distance_traveled" : 3.8602
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:39:02" , 
"departure_time" : "15:40:27" , 
"distance_traveled" : 4.0405
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "15:41:25" , 
"departure_time" : "15:41:25" , 
"distance_traveled" : 4.4598
} ], 
"3757" :  [ 
{ 
"stop_id" : 38064,
"arrival_time" : "15:50:00" , 
"departure_time" : "15:52:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "15:55:18" , 
"departure_time" : "15:55:29" , 
"distance_traveled" : 0.4278
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:56:11" , 
"departure_time" : "15:57:33" , 
"distance_traveled" : 0.9729
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:59:22" , 
"departure_time" : "16:00:20" , 
"distance_traveled" : 1.4841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:00:58" , 
"departure_time" : "16:02:23" , 
"distance_traveled" : 2.0333
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:03:25" , 
"departure_time" : "16:04:09" , 
"distance_traveled" : 2.607
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:03:44" , 
"departure_time" : "16:04:49" , 
"distance_traveled" : 3.0752
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:05:05" , 
"departure_time" : "16:06:26" , 
"distance_traveled" : 3.3358
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:06:21" , 
"departure_time" : "16:06:35" , 
"distance_traveled" : 3.8602
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:06:14" , 
"departure_time" : "16:07:29" , 
"distance_traveled" : 4.0405
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:09:15" , 
"departure_time" : "16:09:15" , 
"distance_traveled" : 4.4598
} ], 
"3758" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "05:18:00" , 
"departure_time" : "05:19:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "05:21:25" , 
"departure_time" : "05:21:55" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "05:23:30" , 
"departure_time" : "05:24:21" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "05:24:51" , 
"departure_time" : "05:24:58" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "05:26:07" , 
"departure_time" : "05:26:07" , 
"distance_traveled" : 1.193
} ], 
"3759" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "05:43:00" , 
"departure_time" : "05:43:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "05:46:19" , 
"departure_time" : "05:47:24" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "05:49:05" , 
"departure_time" : "05:50:27" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "05:50:22" , 
"departure_time" : "05:50:43" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "05:51:21" , 
"departure_time" : "05:51:21" , 
"distance_traveled" : 1.193
} ], 
"3760" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "06:08:00" , 
"departure_time" : "06:09:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "06:12:24" , 
"departure_time" : "06:13:32" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "06:14:08" , 
"departure_time" : "06:14:37" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "06:14:29" , 
"departure_time" : "06:14:33" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "06:16:04" , 
"departure_time" : "06:16:04" , 
"distance_traveled" : 1.193
} ], 
"3761" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "06:30:00" , 
"departure_time" : "06:30:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "06:33:48" , 
"departure_time" : "06:35:06" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "06:36:18" , 
"departure_time" : "06:37:11" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "06:36:53" , 
"departure_time" : "06:37:12" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "06:38:19" , 
"departure_time" : "06:38:19" , 
"distance_traveled" : 1.193
} ], 
"3762" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "06:40:00" , 
"departure_time" : "06:41:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "06:44:26" , 
"departure_time" : "06:44:41" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "06:45:15" , 
"departure_time" : "06:46:43" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "06:47:28" , 
"departure_time" : "06:48:04" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "06:48:36" , 
"departure_time" : "06:48:36" , 
"distance_traveled" : 1.193
} ], 
"3763" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "06:50:00" , 
"departure_time" : "06:52:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "06:54:36" , 
"departure_time" : "06:55:51" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "06:56:15" , 
"departure_time" : "06:57:28" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "06:57:13" , 
"departure_time" : "06:57:35" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "06:58:22" , 
"departure_time" : "06:58:22" , 
"distance_traveled" : 1.193
} ], 
"3764" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "07:00:00" , 
"departure_time" : "07:01:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "07:03:39" , 
"departure_time" : "07:04:11" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "07:05:32" , 
"departure_time" : "07:06:43" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "07:07:11" , 
"departure_time" : "07:07:15" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "07:08:04" , 
"departure_time" : "07:08:04" , 
"distance_traveled" : 1.193
} ], 
"3765" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "07:10:00" , 
"departure_time" : "07:11:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "07:14:25" , 
"departure_time" : "07:14:50" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "07:15:25" , 
"departure_time" : "07:16:10" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "07:16:45" , 
"departure_time" : "07:17:14" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "07:18:29" , 
"departure_time" : "07:18:29" , 
"distance_traveled" : 1.193
} ], 
"3766" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "07:20:00" , 
"departure_time" : "07:21:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "07:23:34" , 
"departure_time" : "07:24:14" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "07:25:40" , 
"departure_time" : "07:26:12" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "07:26:32" , 
"departure_time" : "07:27:28" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "07:28:56" , 
"departure_time" : "07:28:56" , 
"distance_traveled" : 1.193
} ], 
"3767" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "07:30:00" , 
"departure_time" : "07:31:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "07:33:52" , 
"departure_time" : "07:34:18" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "07:35:26" , 
"departure_time" : "07:36:21" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "07:36:55" , 
"departure_time" : "07:38:10" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "07:39:15" , 
"departure_time" : "07:39:15" , 
"distance_traveled" : 1.193
} ], 
"3768" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "07:40:00" , 
"departure_time" : "07:42:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "07:44:37" , 
"departure_time" : "07:45:57" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "07:46:20" , 
"departure_time" : "07:46:40" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "07:46:20" , 
"departure_time" : "07:47:59" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "07:49:39" , 
"departure_time" : "07:49:39" , 
"distance_traveled" : 1.193
} ], 
"3769" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "07:50:00" , 
"departure_time" : "07:51:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "07:53:03" , 
"departure_time" : "07:54:02" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "07:55:59" , 
"departure_time" : "07:57:01" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "07:57:02" , 
"departure_time" : "07:58:31" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "07:59:29" , 
"departure_time" : "07:59:29" , 
"distance_traveled" : 1.193
} ], 
"3770" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "08:00:00" , 
"departure_time" : "08:02:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "08:03:45" , 
"departure_time" : "08:04:14" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "08:05:29" , 
"departure_time" : "08:06:54" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "08:07:25" , 
"departure_time" : "08:07:51" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "08:08:26" , 
"departure_time" : "08:08:26" , 
"distance_traveled" : 1.193
} ], 
"3771" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "08:10:00" , 
"departure_time" : "08:11:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "08:13:59" , 
"departure_time" : "08:14:19" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "08:15:20" , 
"departure_time" : "08:15:32" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "08:16:12" , 
"departure_time" : "08:16:41" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "08:18:29" , 
"departure_time" : "08:18:29" , 
"distance_traveled" : 1.193
} ], 
"3772" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "08:20:00" , 
"departure_time" : "08:21:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "08:23:40" , 
"departure_time" : "08:24:21" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "08:25:41" , 
"departure_time" : "08:26:54" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "08:27:13" , 
"departure_time" : "08:27:42" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "08:28:29" , 
"departure_time" : "08:28:29" , 
"distance_traveled" : 1.193
} ], 
"3773" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "08:30:00" , 
"departure_time" : "08:31:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "08:33:49" , 
"departure_time" : "08:34:00" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "08:35:11" , 
"departure_time" : "08:35:45" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "08:36:34" , 
"departure_time" : "08:36:41" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "08:38:07" , 
"departure_time" : "08:38:07" , 
"distance_traveled" : 1.193
} ], 
"3774" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "08:40:00" , 
"departure_time" : "08:40:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "08:43:26" , 
"departure_time" : "08:44:15" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "08:45:49" , 
"departure_time" : "08:46:09" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "08:46:20" , 
"departure_time" : "08:46:51" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "08:48:31" , 
"departure_time" : "08:48:31" , 
"distance_traveled" : 1.193
} ], 
"3775" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "08:50:00" , 
"departure_time" : "08:51:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "08:54:02" , 
"departure_time" : "08:54:46" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "08:55:44" , 
"departure_time" : "08:56:41" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "08:56:57" , 
"departure_time" : "08:58:29" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "08:59:32" , 
"departure_time" : "08:59:32" , 
"distance_traveled" : 1.193
} ], 
"3776" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "09:00:00" , 
"departure_time" : "09:01:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "09:03:12" , 
"departure_time" : "09:04:00" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "09:05:48" , 
"departure_time" : "09:06:43" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "09:06:55" , 
"departure_time" : "09:08:25" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "09:09:30" , 
"departure_time" : "09:09:30" , 
"distance_traveled" : 1.193
} ], 
"3777" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "09:10:00" , 
"departure_time" : "09:11:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "09:13:11" , 
"departure_time" : "09:14:45" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "09:16:34" , 
"departure_time" : "09:17:39" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "09:17:05" , 
"departure_time" : "09:18:19" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "09:19:14" , 
"departure_time" : "09:19:14" , 
"distance_traveled" : 1.193
} ], 
"3778" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "09:20:00" , 
"departure_time" : "09:22:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "09:24:02" , 
"departure_time" : "09:25:27" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "09:26:25" , 
"departure_time" : "09:27:09" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "09:26:44" , 
"departure_time" : "09:27:03" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "09:28:19" , 
"departure_time" : "09:28:19" , 
"distance_traveled" : 1.193
} ], 
"3779" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "09:30:00" , 
"departure_time" : "09:30:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "09:33:39" , 
"departure_time" : "09:34:14" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "09:35:35" , 
"departure_time" : "09:35:37" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "09:36:02" , 
"departure_time" : "09:37:40" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "09:39:38" , 
"departure_time" : "09:39:38" , 
"distance_traveled" : 1.193
} ], 
"3780" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "10:05:00" , 
"departure_time" : "10:07:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "10:09:03" , 
"departure_time" : "10:10:12" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "10:11:09" , 
"departure_time" : "10:12:12" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "10:12:03" , 
"departure_time" : "10:13:08" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "10:14:05" , 
"departure_time" : "10:14:05" , 
"distance_traveled" : 1.193
} ], 
"3781" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "10:35:00" , 
"departure_time" : "10:37:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "10:39:38" , 
"departure_time" : "10:39:56" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "10:40:18" , 
"departure_time" : "10:41:48" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "10:42:30" , 
"departure_time" : "10:42:39" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "10:43:09" , 
"departure_time" : "10:43:09" , 
"distance_traveled" : 1.193
} ], 
"3782" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "11:05:00" , 
"departure_time" : "11:06:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "11:09:01" , 
"departure_time" : "11:09:58" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "11:10:57" , 
"departure_time" : "11:11:10" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "11:11:13" , 
"departure_time" : "11:12:44" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "11:14:31" , 
"departure_time" : "11:14:31" , 
"distance_traveled" : 1.193
} ], 
"3783" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "11:35:00" , 
"departure_time" : "11:38:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "11:39:40" , 
"departure_time" : "11:40:17" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "11:40:37" , 
"departure_time" : "11:40:45" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "11:41:08" , 
"departure_time" : "11:42:23" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "11:44:15" , 
"departure_time" : "11:44:15" , 
"distance_traveled" : 1.193
} ], 
"3784" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "12:05:00" , 
"departure_time" : "12:06:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "12:08:12" , 
"departure_time" : "12:09:41" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "12:11:29" , 
"departure_time" : "12:13:09" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "12:12:40" , 
"departure_time" : "12:13:01" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "12:13:21" , 
"departure_time" : "12:13:21" , 
"distance_traveled" : 1.193
} ], 
"3785" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "12:35:00" , 
"departure_time" : "12:35:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "12:38:24" , 
"departure_time" : "12:38:36" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "12:40:12" , 
"departure_time" : "12:41:09" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "12:41:57" , 
"departure_time" : "12:42:11" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "12:43:14" , 
"departure_time" : "12:43:14" , 
"distance_traveled" : 1.193
} ], 
"3786" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "13:05:00" , 
"departure_time" : "13:05:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "13:08:24" , 
"departure_time" : "13:09:24" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "13:11:00" , 
"departure_time" : "13:12:39" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "13:12:39" , 
"departure_time" : "13:13:43" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "13:14:04" , 
"departure_time" : "13:14:04" , 
"distance_traveled" : 1.193
} ], 
"3787" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "13:35:00" , 
"departure_time" : "13:37:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "13:39:02" , 
"departure_time" : "13:39:08" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "13:40:06" , 
"departure_time" : "13:40:53" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "13:41:47" , 
"departure_time" : "13:43:00" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "13:44:13" , 
"departure_time" : "13:44:13" , 
"distance_traveled" : 1.193
} ], 
"3788" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "14:05:00" , 
"departure_time" : "14:07:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "14:09:18" , 
"departure_time" : "14:09:38" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "14:10:20" , 
"departure_time" : "14:10:24" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "14:11:04" , 
"departure_time" : "14:12:20" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "14:14:16" , 
"departure_time" : "14:14:16" , 
"distance_traveled" : 1.193
} ], 
"3789" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "14:35:00" , 
"departure_time" : "14:36:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "14:38:36" , 
"departure_time" : "14:39:22" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "14:40:46" , 
"departure_time" : "14:42:24" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "14:42:38" , 
"departure_time" : "14:43:44" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "14:44:06" , 
"departure_time" : "14:44:06" , 
"distance_traveled" : 1.193
} ], 
"3790" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "15:04:00" , 
"departure_time" : "15:05:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "15:07:04" , 
"departure_time" : "15:07:42" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "15:09:38" , 
"departure_time" : "15:10:50" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "15:11:12" , 
"departure_time" : "15:12:34" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "15:13:22" , 
"departure_time" : "15:13:22" , 
"distance_traveled" : 1.193
} ], 
"3791" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "15:35:00" , 
"departure_time" : "15:36:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "15:38:19" , 
"departure_time" : "15:39:03" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "15:40:44" , 
"departure_time" : "15:41:37" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "15:41:53" , 
"departure_time" : "15:42:35" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "15:43:42" , 
"departure_time" : "15:43:42" , 
"distance_traveled" : 1.193
} ], 
"3792" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "15:45:00" , 
"departure_time" : "15:47:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "15:49:29" , 
"departure_time" : "15:49:51" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "15:50:22" , 
"departure_time" : "15:50:30" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "15:51:08" , 
"departure_time" : "15:51:55" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "15:53:47" , 
"departure_time" : "15:53:47" , 
"distance_traveled" : 1.193
} ], 
"3793" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "15:55:00" , 
"departure_time" : "15:57:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "15:59:23" , 
"departure_time" : "16:00:10" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "16:00:47" , 
"departure_time" : "16:00:52" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "16:01:05" , 
"departure_time" : "16:01:52" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "16:03:47" , 
"departure_time" : "16:03:47" , 
"distance_traveled" : 1.193
} ], 
"3794" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "16:05:00" , 
"departure_time" : "16:06:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "16:08:53" , 
"departure_time" : "16:09:39" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "16:10:46" , 
"departure_time" : "16:12:13" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "16:12:27" , 
"departure_time" : "16:13:26" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "16:13:59" , 
"departure_time" : "16:13:59" , 
"distance_traveled" : 1.193
} ], 
"3795" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "16:15:00" , 
"departure_time" : "16:17:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "16:19:16" , 
"departure_time" : "16:20:17" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "16:21:01" , 
"departure_time" : "16:21:18" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "16:21:17" , 
"departure_time" : "16:21:24" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "16:23:07" , 
"departure_time" : "16:23:07" , 
"distance_traveled" : 1.193
} ], 
"3796" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "16:25:00" , 
"departure_time" : "16:26:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "16:29:16" , 
"departure_time" : "16:30:46" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "16:31:30" , 
"departure_time" : "16:32:21" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "16:31:51" , 
"departure_time" : "16:33:28" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "16:34:37" , 
"departure_time" : "16:34:37" , 
"distance_traveled" : 1.193
} ], 
"3797" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "16:35:00" , 
"departure_time" : "16:36:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "16:38:02" , 
"departure_time" : "16:39:01" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "16:40:59" , 
"departure_time" : "16:41:08" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "16:41:09" , 
"departure_time" : "16:41:51" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "16:43:42" , 
"departure_time" : "16:43:42" , 
"distance_traveled" : 1.193
} ], 
"3798" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "16:45:00" , 
"departure_time" : "16:46:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "16:49:04" , 
"departure_time" : "16:49:37" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "16:50:33" , 
"departure_time" : "16:50:57" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "16:51:24" , 
"departure_time" : "16:51:37" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "16:53:13" , 
"departure_time" : "16:53:13" , 
"distance_traveled" : 1.193
} ], 
"3799" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "16:55:00" , 
"departure_time" : "16:56:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "16:59:14" , 
"departure_time" : "17:00:44" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "17:01:30" , 
"departure_time" : "17:02:36" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "17:02:06" , 
"departure_time" : "17:02:46" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "17:03:40" , 
"departure_time" : "17:03:40" , 
"distance_traveled" : 1.193
} ], 
"3800" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "17:05:00" , 
"departure_time" : "17:05:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "17:08:11" , 
"departure_time" : "17:09:37" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "17:11:26" , 
"departure_time" : "17:12:33" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "17:12:07" , 
"departure_time" : "17:13:09" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "17:14:02" , 
"departure_time" : "17:14:02" , 
"distance_traveled" : 1.193
} ], 
"3801" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "17:15:00" , 
"departure_time" : "17:17:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "17:19:28" , 
"departure_time" : "17:20:20" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "17:20:52" , 
"departure_time" : "17:21:54" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "17:22:02" , 
"departure_time" : "17:22:37" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "17:23:35" , 
"departure_time" : "17:23:35" , 
"distance_traveled" : 1.193
} ], 
"3802" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "17:25:00" , 
"departure_time" : "17:27:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "17:29:34" , 
"departure_time" : "17:31:04" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "17:31:30" , 
"departure_time" : "17:31:37" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "17:31:07" , 
"departure_time" : "17:32:34" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "17:34:27" , 
"departure_time" : "17:34:27" , 
"distance_traveled" : 1.193
} ], 
"3803" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "17:35:00" , 
"departure_time" : "17:37:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "17:39:23" , 
"departure_time" : "17:39:38" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "17:40:15" , 
"departure_time" : "17:40:44" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "17:41:29" , 
"departure_time" : "17:41:41" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "17:43:12" , 
"departure_time" : "17:43:12" , 
"distance_traveled" : 1.193
} ], 
"3804" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "17:45:00" , 
"departure_time" : "17:46:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "17:49:08" , 
"departure_time" : "17:50:00" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "17:50:52" , 
"departure_time" : "17:51:10" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "17:51:18" , 
"departure_time" : "17:52:30" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "17:54:12" , 
"departure_time" : "17:54:12" , 
"distance_traveled" : 1.193
} ], 
"3805" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "17:55:00" , 
"departure_time" : "17:57:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "17:59:32" , 
"departure_time" : "18:00:53" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "18:01:21" , 
"departure_time" : "18:01:50" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "18:01:29" , 
"departure_time" : "18:02:23" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "18:03:54" , 
"departure_time" : "18:03:54" , 
"distance_traveled" : 1.193
} ], 
"3806" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "18:05:00" , 
"departure_time" : "18:07:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "18:09:32" , 
"departure_time" : "18:09:36" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "18:10:04" , 
"departure_time" : "18:11:39" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "18:12:35" , 
"departure_time" : "18:13:15" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "18:13:40" , 
"departure_time" : "18:13:40" , 
"distance_traveled" : 1.193
} ], 
"3807" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "18:15:00" , 
"departure_time" : "18:16:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "18:18:54" , 
"departure_time" : "18:20:03" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "18:21:09" , 
"departure_time" : "18:22:19" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "18:22:10" , 
"departure_time" : "18:22:18" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "18:23:08" , 
"departure_time" : "18:23:08" , 
"distance_traveled" : 1.193
} ], 
"3808" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "18:25:00" , 
"departure_time" : "18:25:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "18:28:42" , 
"departure_time" : "18:29:43" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "18:31:01" , 
"departure_time" : "18:31:46" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "18:31:45" , 
"departure_time" : "18:32:00" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "18:33:15" , 
"departure_time" : "18:33:15" , 
"distance_traveled" : 1.193
} ], 
"3809" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "18:35:00" , 
"departure_time" : "18:36:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "18:39:25" , 
"departure_time" : "18:40:39" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "18:41:14" , 
"departure_time" : "18:42:17" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "18:42:03" , 
"departure_time" : "18:42:05" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "18:43:02" , 
"departure_time" : "18:43:02" , 
"distance_traveled" : 1.193
} ], 
"3810" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "18:45:00" , 
"departure_time" : "18:46:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "18:49:34" , 
"departure_time" : "18:51:07" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "18:51:33" , 
"departure_time" : "18:51:39" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "18:51:06" , 
"departure_time" : "18:51:53" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "18:53:47" , 
"departure_time" : "18:53:47" , 
"distance_traveled" : 1.193
} ], 
"3811" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "18:55:00" , 
"departure_time" : "18:56:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "18:58:37" , 
"departure_time" : "18:59:48" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "19:01:11" , 
"departure_time" : "19:02:22" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "19:02:11" , 
"departure_time" : "19:03:02" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "19:03:51" , 
"departure_time" : "19:03:51" , 
"distance_traveled" : 1.193
} ], 
"3812" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "19:05:00" , 
"departure_time" : "19:06:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "19:08:14" , 
"departure_time" : "19:08:37" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "19:10:23" , 
"departure_time" : "19:11:20" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "19:11:57" , 
"departure_time" : "19:12:28" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "19:13:31" , 
"departure_time" : "19:13:31" , 
"distance_traveled" : 1.193
} ], 
"3813" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "19:15:00" , 
"departure_time" : "19:16:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "19:19:24" , 
"departure_time" : "19:19:36" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "19:20:12" , 
"departure_time" : "19:20:20" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "19:21:08" , 
"departure_time" : "19:22:27" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "19:24:19" , 
"departure_time" : "19:24:19" , 
"distance_traveled" : 1.193
} ], 
"3814" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "19:25:00" , 
"departure_time" : "19:26:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "19:28:22" , 
"departure_time" : "19:28:48" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "19:30:26" , 
"departure_time" : "19:30:36" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "19:31:10" , 
"departure_time" : "19:32:08" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "19:33:58" , 
"departure_time" : "19:33:58" , 
"distance_traveled" : 1.193
} ], 
"3815" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "19:35:00" , 
"departure_time" : "19:36:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "19:38:47" , 
"departure_time" : "19:39:10" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "19:40:23" , 
"departure_time" : "19:41:01" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "19:41:38" , 
"departure_time" : "19:42:31" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "19:43:53" , 
"departure_time" : "19:43:53" , 
"distance_traveled" : 1.193
} ], 
"3816" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "19:45:00" , 
"departure_time" : "19:46:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "19:49:04" , 
"departure_time" : "19:49:31" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "19:50:27" , 
"departure_time" : "19:51:06" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "19:51:39" , 
"departure_time" : "19:52:55" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "19:54:16" , 
"departure_time" : "19:54:16" , 
"distance_traveled" : 1.193
} ], 
"3817" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "19:55:00" , 
"departure_time" : "19:57:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "19:59:14" , 
"departure_time" : "20:00:12" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "20:00:58" , 
"departure_time" : "20:01:17" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "20:01:19" , 
"departure_time" : "20:01:44" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "20:03:25" , 
"departure_time" : "20:03:25" , 
"distance_traveled" : 1.193
} ], 
"3818" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "20:05:00" , 
"departure_time" : "20:06:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "20:08:53" , 
"departure_time" : "20:09:03" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "20:10:10" , 
"departure_time" : "20:10:21" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "20:11:11" , 
"departure_time" : "20:11:55" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "20:13:44" , 
"departure_time" : "20:13:44" , 
"distance_traveled" : 1.193
} ], 
"3819" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "20:28:00" , 
"departure_time" : "20:30:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "20:32:24" , 
"departure_time" : "20:33:06" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "20:33:42" , 
"departure_time" : "20:35:13" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "20:35:31" , 
"departure_time" : "20:36:04" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "20:36:33" , 
"departure_time" : "20:36:33" , 
"distance_traveled" : 1.193
} ], 
"3820" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "20:58:00" , 
"departure_time" : "20:59:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "21:01:38" , 
"departure_time" : "21:01:39" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "21:03:01" , 
"departure_time" : "21:04:17" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "21:05:16" , 
"departure_time" : "21:06:23" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "21:07:07" , 
"departure_time" : "21:07:07" , 
"distance_traveled" : 1.193
} ], 
"3821" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "21:28:00" , 
"departure_time" : "21:29:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "21:31:22" , 
"departure_time" : "21:32:32" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "21:34:10" , 
"departure_time" : "21:34:33" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "21:34:23" , 
"departure_time" : "21:34:57" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "21:36:34" , 
"departure_time" : "21:36:34" , 
"distance_traveled" : 1.193
} ], 
"3822" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "21:59:00" , 
"departure_time" : "22:00:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "22:02:56" , 
"departure_time" : "22:03:37" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "22:04:41" , 
"departure_time" : "22:05:07" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "22:05:26" , 
"departure_time" : "22:06:14" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "22:07:48" , 
"departure_time" : "22:07:48" , 
"distance_traveled" : 1.193
} ], 
"3823" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "22:28:00" , 
"departure_time" : "22:29:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "22:31:18" , 
"departure_time" : "22:31:55" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "22:33:37" , 
"departure_time" : "22:34:16" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "22:34:39" , 
"departure_time" : "22:36:12" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "22:37:33" , 
"departure_time" : "22:37:33" , 
"distance_traveled" : 1.193
} ], 
"3824" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "22:59:00" , 
"departure_time" : "23:00:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "23:02:24" , 
"departure_time" : "23:03:45" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "23:05:21" , 
"departure_time" : "23:05:56" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "23:05:35" , 
"departure_time" : "23:05:44" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "23:07:09" , 
"departure_time" : "23:07:09" , 
"distance_traveled" : 1.193
} ], 
"3825" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "23:28:00" , 
"departure_time" : "23:28:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "23:31:07" , 
"departure_time" : "23:31:33" , 
"distance_traveled" : 0.5742
}, 
{ 
"stop_id" : 39133,
"arrival_time" : "23:33:26" , 
"departure_time" : "23:34:43" , 
"distance_traveled" : 0.9307
}, 
{ 
"stop_id" : 39131,
"arrival_time" : "23:35:17" , 
"departure_time" : "23:36:55" , 
"distance_traveled" : 1.028
}, 
{ 
"stop_id" : 39130,
"arrival_time" : "23:37:38" , 
"departure_time" : "23:37:38" , 
"distance_traveled" : 1.193
} ], 
"3826" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "05:58:00" , 
"departure_time" : "06:00:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:00:06" , 
"departure_time" : "06:00:57" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:00:51" , 
"departure_time" : "06:01:57" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:03:06" , 
"departure_time" : "06:03:14" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:03:08" , 
"departure_time" : "06:03:19" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:04:11" , 
"departure_time" : "06:04:46" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:06:35" , 
"departure_time" : "06:08:05" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "06:09:30" , 
"departure_time" : "06:11:10" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "06:11:40" , 
"departure_time" : "06:12:56" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "06:13:16" , 
"departure_time" : "06:13:16" , 
"distance_traveled" : 4.0409
} ], 
"3827" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "06:19:00" , 
"departure_time" : "06:21:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:21:18" , 
"departure_time" : "06:22:15" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:21:57" , 
"departure_time" : "06:23:00" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:24:03" , 
"departure_time" : "06:25:25" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:25:22" , 
"departure_time" : "06:26:07" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:25:45" , 
"departure_time" : "06:27:24" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:28:39" , 
"departure_time" : "06:29:19" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "06:29:40" , 
"departure_time" : "06:29:53" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "06:31:13" , 
"departure_time" : "06:32:19" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "06:34:06" , 
"departure_time" : "06:34:06" , 
"distance_traveled" : 4.0409
} ], 
"3828" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "06:24:00" , 
"departure_time" : "06:25:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:25:05" , 
"departure_time" : "06:26:30" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:27:25" , 
"departure_time" : "06:28:36" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:29:11" , 
"departure_time" : "06:29:54" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:29:43" , 
"departure_time" : "06:30:58" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:31:15" , 
"departure_time" : "06:32:18" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:33:03" , 
"departure_time" : "06:33:49" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "06:34:46" , 
"departure_time" : "06:35:18" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "06:36:32" , 
"departure_time" : "06:37:40" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "06:39:08" , 
"departure_time" : "06:39:08" , 
"distance_traveled" : 4.0409
} ], 
"3829" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "06:32:00" , 
"departure_time" : "06:33:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:33:10" , 
"departure_time" : "06:33:48" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:34:38" , 
"departure_time" : "06:34:41" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:36:03" , 
"departure_time" : "06:37:13" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:38:10" , 
"departure_time" : "06:38:48" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:38:38" , 
"departure_time" : "06:38:45" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:40:07" , 
"departure_time" : "06:40:12" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "06:42:05" , 
"departure_time" : "06:42:47" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "06:44:42" , 
"departure_time" : "06:44:51" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "06:46:09" , 
"departure_time" : "06:46:09" , 
"distance_traveled" : 4.0409
} ], 
"3830" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "06:40:00" , 
"departure_time" : "06:40:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:41:09" , 
"departure_time" : "06:41:33" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:42:24" , 
"departure_time" : "06:44:00" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:45:36" , 
"departure_time" : "06:46:11" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:45:35" , 
"departure_time" : "06:45:53" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:46:18" , 
"departure_time" : "06:46:49" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:48:31" , 
"departure_time" : "06:49:45" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "06:51:14" , 
"departure_time" : "06:52:21" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "06:53:07" , 
"departure_time" : "06:53:36" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "06:54:29" , 
"departure_time" : "06:54:29" , 
"distance_traveled" : 4.0409
} ], 
"3831" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "06:52:00" , 
"departure_time" : "06:52:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:53:05" , 
"departure_time" : "06:53:34" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:54:29" , 
"departure_time" : "06:55:43" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:57:14" , 
"departure_time" : "06:57:45" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:57:31" , 
"departure_time" : "06:58:39" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:59:08" , 
"departure_time" : "06:59:52" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:00:44" , 
"departure_time" : "07:02:23" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:03:39" , 
"departure_time" : "07:05:18" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:05:39" , 
"departure_time" : "07:06:40" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:07:01" , 
"departure_time" : "07:07:01" , 
"distance_traveled" : 4.0409
} ], 
"3832" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "07:00:00" , 
"departure_time" : "07:01:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:01:04" , 
"departure_time" : "07:01:37" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:02:33" , 
"departure_time" : "07:02:50" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:04:17" , 
"departure_time" : "07:05:26" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:06:09" , 
"departure_time" : "07:06:45" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:06:36" , 
"departure_time" : "07:06:51" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:08:15" , 
"departure_time" : "07:08:21" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:10:06" , 
"departure_time" : "07:11:42" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:13:36" , 
"departure_time" : "07:14:56" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:15:20" , 
"departure_time" : "07:15:20" , 
"distance_traveled" : 4.0409
} ], 
"3833" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "07:14:00" , 
"departure_time" : "07:15:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:15:04" , 
"departure_time" : "07:16:43" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:17:39" , 
"departure_time" : "07:19:16" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:19:37" , 
"departure_time" : "07:21:03" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:20:26" , 
"departure_time" : "07:21:54" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:21:28" , 
"departure_time" : "07:21:40" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:22:12" , 
"departure_time" : "07:22:45" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:24:33" , 
"departure_time" : "07:24:51" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:26:18" , 
"departure_time" : "07:26:59" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:28:41" , 
"departure_time" : "07:28:41" , 
"distance_traveled" : 4.0409
} ], 
"3834" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "07:21:00" , 
"departure_time" : "07:22:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:22:19" , 
"departure_time" : "07:23:05" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:23:46" , 
"departure_time" : "07:25:25" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:26:39" , 
"departure_time" : "07:26:58" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:26:19" , 
"departure_time" : "07:26:26" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:27:07" , 
"departure_time" : "07:27:43" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:29:36" , 
"departure_time" : "07:30:51" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:32:15" , 
"departure_time" : "07:33:26" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:34:11" , 
"departure_time" : "07:34:28" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:35:17" , 
"departure_time" : "07:35:17" , 
"distance_traveled" : 4.0409
} ], 
"3835" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "07:28:00" , 
"departure_time" : "07:28:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:29:10" , 
"departure_time" : "07:29:54" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:30:44" , 
"departure_time" : "07:30:51" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:32:07" , 
"departure_time" : "07:32:58" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:33:51" , 
"departure_time" : "07:34:08" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:34:17" , 
"departure_time" : "07:35:24" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:37:07" , 
"departure_time" : "07:38:19" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:39:12" , 
"departure_time" : "07:40:08" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:40:56" , 
"departure_time" : "07:41:30" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:42:34" , 
"departure_time" : "07:42:34" , 
"distance_traveled" : 4.0409
} ], 
"3836" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "07:35:00" , 
"departure_time" : "07:35:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:36:14" , 
"departure_time" : "07:37:28" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:38:14" , 
"departure_time" : "07:39:45" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:40:31" , 
"departure_time" : "07:42:00" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:41:29" , 
"departure_time" : "07:43:05" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:42:36" , 
"departure_time" : "07:44:08" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:44:32" , 
"departure_time" : "07:46:07" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:46:35" , 
"departure_time" : "07:48:03" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:48:28" , 
"departure_time" : "07:48:55" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:49:27" , 
"departure_time" : "07:49:27" , 
"distance_traveled" : 4.0409
} ], 
"3837" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "07:43:00" , 
"departure_time" : "07:44:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:44:41" , 
"departure_time" : "07:46:06" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:46:25" , 
"departure_time" : "07:47:02" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:47:37" , 
"departure_time" : "07:48:46" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:49:09" , 
"departure_time" : "07:49:59" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:49:50" , 
"departure_time" : "07:51:10" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:52:20" , 
"departure_time" : "07:53:01" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:53:41" , 
"departure_time" : "07:54:35" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:55:54" , 
"departure_time" : "07:56:31" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:57:37" , 
"departure_time" : "07:57:37" , 
"distance_traveled" : 4.0409
} ], 
"3838" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "07:48:00" , 
"departure_time" : "07:48:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:49:11" , 
"departure_time" : "07:49:34" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:50:23" , 
"departure_time" : "07:51:57" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:53:34" , 
"departure_time" : "07:54:32" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:53:58" , 
"departure_time" : "07:54:18" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:54:20" , 
"departure_time" : "07:54:43" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:56:23" , 
"departure_time" : "07:56:40" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:58:17" , 
"departure_time" : "07:59:57" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:01:40" , 
"departure_time" : "08:02:47" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:03:07" , 
"departure_time" : "08:03:07" , 
"distance_traveled" : 4.0409
} ], 
"3839" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "07:56:00" , 
"departure_time" : "07:58:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:58:28" , 
"departure_time" : "07:58:39" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:58:11" , 
"departure_time" : "07:59:20" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:01:09" , 
"departure_time" : "08:01:22" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:01:13" , 
"departure_time" : "08:01:21" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:02:08" , 
"departure_time" : "08:03:43" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:05:35" , 
"departure_time" : "08:05:51" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:06:16" , 
"departure_time" : "08:06:54" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:08:38" , 
"departure_time" : "08:10:00" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:11:22" , 
"departure_time" : "08:11:22" , 
"distance_traveled" : 4.0409
} ], 
"3840" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "08:03:00" , 
"departure_time" : "08:05:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:05:29" , 
"departure_time" : "08:06:12" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:05:43" , 
"departure_time" : "08:06:57" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:08:14" , 
"departure_time" : "08:09:32" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:09:18" , 
"departure_time" : "08:09:57" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:09:39" , 
"departure_time" : "08:09:40" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:11:01" , 
"departure_time" : "08:12:07" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:14:06" , 
"departure_time" : "08:15:14" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:16:08" , 
"departure_time" : "08:17:20" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:18:12" , 
"departure_time" : "08:18:12" , 
"distance_traveled" : 4.0409
} ], 
"3841" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "08:10:00" , 
"departure_time" : "08:11:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:11:09" , 
"departure_time" : "08:12:33" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:13:24" , 
"departure_time" : "08:14:04" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:14:40" , 
"departure_time" : "08:15:26" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:15:46" , 
"departure_time" : "08:17:08" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:17:22" , 
"departure_time" : "08:18:24" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:19:02" , 
"departure_time" : "08:19:48" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:20:46" , 
"departure_time" : "08:21:23" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:22:37" , 
"departure_time" : "08:24:14" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:25:37" , 
"departure_time" : "08:25:37" , 
"distance_traveled" : 4.0409
} ], 
"3842" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "08:16:00" , 
"departure_time" : "08:19:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:18:26" , 
"departure_time" : "08:19:44" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:19:18" , 
"departure_time" : "08:19:40" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:20:22" , 
"departure_time" : "08:20:49" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:21:27" , 
"departure_time" : "08:23:04" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:23:37" , 
"departure_time" : "08:24:45" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:25:08" , 
"departure_time" : "08:25:58" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:26:50" , 
"departure_time" : "08:26:53" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:28:03" , 
"departure_time" : "08:29:14" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:31:11" , 
"departure_time" : "08:31:11" , 
"distance_traveled" : 4.0409
} ], 
"3843" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "08:24:00" , 
"departure_time" : "08:26:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:26:25" , 
"departure_time" : "08:28:04" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:27:39" , 
"departure_time" : "08:28:04" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:28:25" , 
"departure_time" : "08:29:25" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:30:00" , 
"departure_time" : "08:30:15" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:30:15" , 
"departure_time" : "08:30:44" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:32:29" , 
"departure_time" : "08:33:44" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:35:15" , 
"departure_time" : "08:36:39" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:37:24" , 
"departure_time" : "08:37:27" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:38:03" , 
"departure_time" : "08:38:03" , 
"distance_traveled" : 4.0409
} ], 
"3844" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "08:31:00" , 
"departure_time" : "08:31:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:32:06" , 
"departure_time" : "08:33:42" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:34:36" , 
"departure_time" : "08:35:19" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:35:43" , 
"departure_time" : "08:36:50" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:37:07" , 
"departure_time" : "08:37:34" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:37:27" , 
"departure_time" : "08:39:01" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:40:34" , 
"departure_time" : "08:41:24" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:41:50" , 
"departure_time" : "08:42:13" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:43:23" , 
"departure_time" : "08:44:31" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:46:08" , 
"departure_time" : "08:46:08" , 
"distance_traveled" : 4.0409
} ], 
"3845" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "08:45:00" , 
"departure_time" : "08:47:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:47:39" , 
"departure_time" : "08:48:03" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:47:24" , 
"departure_time" : "08:48:47" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:50:23" , 
"departure_time" : "08:51:02" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:50:39" , 
"departure_time" : "08:50:40" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:51:01" , 
"departure_time" : "08:51:27" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:53:26" , 
"departure_time" : "08:53:47" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:55:21" , 
"departure_time" : "08:55:22" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:57:01" , 
"departure_time" : "08:58:32" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:00:31" , 
"departure_time" : "09:00:31" , 
"distance_traveled" : 4.0409
} ], 
"3846" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "08:52:00" , 
"departure_time" : "08:53:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:53:22" , 
"departure_time" : "08:53:34" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:54:12" , 
"departure_time" : "08:55:49" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:57:37" , 
"departure_time" : "08:57:49" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:57:12" , 
"departure_time" : "08:57:16" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:58:04" , 
"departure_time" : "08:59:15" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:01:11" , 
"departure_time" : "09:01:19" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:02:08" , 
"departure_time" : "09:02:51" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:04:43" , 
"departure_time" : "09:06:06" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:07:23" , 
"departure_time" : "09:07:23" , 
"distance_traveled" : 4.0409
} ], 
"3847" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "08:59:00" , 
"departure_time" : "09:01:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:01:15" , 
"departure_time" : "09:02:39" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:02:24" , 
"departure_time" : "09:02:41" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:03:17" , 
"departure_time" : "09:04:25" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:05:08" , 
"departure_time" : "09:05:38" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:05:30" , 
"departure_time" : "09:06:25" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:07:55" , 
"departure_time" : "09:09:18" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:10:23" , 
"departure_time" : "09:12:03" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:12:40" , 
"departure_time" : "09:13:40" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:14:00" , 
"departure_time" : "09:14:00" , 
"distance_traveled" : 4.0409
} ], 
"3848" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "14:58:00" , 
"departure_time" : "15:00:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:00:12" , 
"departure_time" : "15:00:54" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:00:42" , 
"departure_time" : "15:01:56" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:03:14" , 
"departure_time" : "15:04:50" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:04:36" , 
"departure_time" : "15:05:51" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:05:15" , 
"departure_time" : "15:06:39" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:07:24" , 
"departure_time" : "15:08:31" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:09:07" , 
"departure_time" : "15:10:40" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:11:33" , 
"departure_time" : "15:12:01" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "15:12:28" , 
"departure_time" : "15:12:28" , 
"distance_traveled" : 4.0409
} ], 
"3849" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "15:17:00" , 
"departure_time" : "15:18:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:18:41" , 
"departure_time" : "15:19:31" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:19:50" , 
"departure_time" : "15:19:57" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:21:07" , 
"departure_time" : "15:21:50" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:22:43" , 
"departure_time" : "15:23:30" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:23:47" , 
"departure_time" : "15:25:15" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:26:28" , 
"departure_time" : "15:26:47" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:27:19" , 
"departure_time" : "15:27:44" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:29:25" , 
"departure_time" : "15:29:52" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "15:31:27" , 
"departure_time" : "15:31:27" , 
"distance_traveled" : 4.0409
} ], 
"3850" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "15:24:00" , 
"departure_time" : "15:25:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:26:13" , 
"departure_time" : "15:27:20" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:27:07" , 
"departure_time" : "15:27:44" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:28:37" , 
"departure_time" : "15:29:22" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:29:45" , 
"departure_time" : "15:31:09" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:31:24" , 
"departure_time" : "15:31:49" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:32:25" , 
"departure_time" : "15:33:05" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:34:40" , 
"departure_time" : "15:35:01" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:36:21" , 
"departure_time" : "15:36:26" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "15:38:05" , 
"departure_time" : "15:38:05" , 
"distance_traveled" : 4.0409
} ], 
"3851" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "15:36:00" , 
"departure_time" : "15:36:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:37:46" , 
"departure_time" : "15:38:26" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:38:40" , 
"departure_time" : "15:39:26" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:40:46" , 
"departure_time" : "15:42:09" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:42:23" , 
"departure_time" : "15:43:21" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:42:58" , 
"departure_time" : "15:44:06" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:45:08" , 
"departure_time" : "15:46:42" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:47:34" , 
"departure_time" : "15:48:03" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:48:29" , 
"departure_time" : "15:49:29" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "15:51:00" , 
"departure_time" : "15:51:00" , 
"distance_traveled" : 4.0409
} ], 
"3852" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "15:47:00" , 
"departure_time" : "15:48:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:48:12" , 
"departure_time" : "15:49:46" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:50:34" , 
"departure_time" : "15:52:13" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:52:39" , 
"departure_time" : "15:53:03" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:52:24" , 
"departure_time" : "15:54:01" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:54:37" , 
"departure_time" : "15:55:40" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:56:03" , 
"departure_time" : "15:56:47" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:57:44" , 
"departure_time" : "15:57:55" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:59:11" , 
"departure_time" : "15:59:18" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:01:07" , 
"departure_time" : "16:01:07" , 
"distance_traveled" : 4.0409
} ], 
"3853" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "15:53:00" , 
"departure_time" : "15:53:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:54:35" , 
"departure_time" : "15:55:27" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:55:52" , 
"departure_time" : "15:56:13" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:57:21" , 
"departure_time" : "15:57:32" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:58:11" , 
"departure_time" : "15:59:01" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:59:50" , 
"departure_time" : "16:00:10" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:01:20" , 
"departure_time" : "16:01:31" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:03:11" , 
"departure_time" : "16:03:26" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:05:15" , 
"departure_time" : "16:05:42" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:07:27" , 
"departure_time" : "16:07:27" , 
"distance_traveled" : 4.0409
} ], 
"3854" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "16:00:00" , 
"departure_time" : "16:01:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:02:22" , 
"departure_time" : "16:03:48" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:03:26" , 
"departure_time" : "16:04:51" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:05:25" , 
"departure_time" : "16:07:03" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:06:38" , 
"departure_time" : "16:06:54" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:06:16" , 
"departure_time" : "16:07:01" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:08:45" , 
"departure_time" : "16:08:57" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:10:12" , 
"departure_time" : "16:11:50" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:13:38" , 
"departure_time" : "16:15:13" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:15:35" , 
"departure_time" : "16:15:35" , 
"distance_traveled" : 4.0409
} ], 
"3855" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "16:07:00" , 
"departure_time" : "16:09:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:08:51" , 
"departure_time" : "16:08:59" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:09:08" , 
"departure_time" : "16:09:36" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:11:28" , 
"departure_time" : "16:13:04" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:13:36" , 
"departure_time" : "16:14:14" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:13:38" , 
"departure_time" : "16:13:59" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:15:21" , 
"departure_time" : "16:16:04" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:17:43" , 
"departure_time" : "16:18:00" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:19:17" , 
"departure_time" : "16:20:10" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:21:53" , 
"departure_time" : "16:21:53" , 
"distance_traveled" : 4.0409
} ], 
"3856" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "16:21:00" , 
"departure_time" : "16:23:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:23:14" , 
"departure_time" : "16:23:32" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:23:18" , 
"departure_time" : "16:23:20" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:25:02" , 
"departure_time" : "16:25:16" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:26:14" , 
"departure_time" : "16:26:44" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:27:30" , 
"departure_time" : "16:28:12" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:29:42" , 
"departure_time" : "16:30:11" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:31:29" , 
"departure_time" : "16:32:42" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:34:13" , 
"departure_time" : "16:34:25" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:35:12" , 
"departure_time" : "16:35:12" , 
"distance_traveled" : 4.0409
} ], 
"3857" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "16:28:00" , 
"departure_time" : "16:29:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:30:35" , 
"departure_time" : "16:32:05" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:31:30" , 
"departure_time" : "16:32:30" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:33:00" , 
"departure_time" : "16:34:18" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:34:18" , 
"departure_time" : "16:34:55" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:34:37" , 
"departure_time" : "16:35:25" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:36:48" , 
"departure_time" : "16:36:51" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:38:03" , 
"departure_time" : "16:38:17" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:40:14" , 
"departure_time" : "16:41:02" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:42:48" , 
"departure_time" : "16:42:48" , 
"distance_traveled" : 4.0409
} ], 
"3858" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "16:35:00" , 
"departure_time" : "16:36:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:36:36" , 
"departure_time" : "16:38:13" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:38:37" , 
"departure_time" : "16:38:40" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:39:03" , 
"departure_time" : "16:39:36" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:40:33" , 
"departure_time" : "16:41:48" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:42:15" , 
"departure_time" : "16:43:13" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:43:58" , 
"departure_time" : "16:44:32" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:45:34" , 
"departure_time" : "16:47:09" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:48:35" , 
"departure_time" : "16:50:15" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:50:40" , 
"departure_time" : "16:50:40" , 
"distance_traveled" : 4.0409
} ], 
"3859" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "16:44:00" , 
"departure_time" : "16:46:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:46:09" , 
"departure_time" : "16:47:32" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:47:23" , 
"departure_time" : "16:47:38" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:48:15" , 
"departure_time" : "16:49:51" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:50:36" , 
"departure_time" : "16:51:22" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:50:46" , 
"departure_time" : "16:51:13" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:52:27" , 
"departure_time" : "16:53:08" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:54:41" , 
"departure_time" : "16:54:51" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:56:10" , 
"departure_time" : "16:57:47" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:59:37" , 
"departure_time" : "16:59:37" , 
"distance_traveled" : 4.0409
} ], 
"3860" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "16:50:00" , 
"departure_time" : "16:51:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:51:08" , 
"departure_time" : "16:51:12" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:52:04" , 
"departure_time" : "16:53:00" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:54:56" , 
"departure_time" : "16:56:20" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:56:24" , 
"departure_time" : "16:57:44" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:57:20" , 
"departure_time" : "16:58:14" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:58:54" , 
"departure_time" : "17:00:05" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:01:11" , 
"departure_time" : "17:02:11" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:03:00" , 
"departure_time" : "17:04:25" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:05:25" , 
"departure_time" : "17:05:25" , 
"distance_traveled" : 4.0409
} ], 
"3861" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "16:55:00" , 
"departure_time" : "16:56:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:56:23" , 
"departure_time" : "16:56:46" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:57:23" , 
"departure_time" : "16:58:15" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:59:52" , 
"departure_time" : "17:00:10" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:00:18" , 
"departure_time" : "17:01:05" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:01:47" , 
"departure_time" : "17:01:58" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:03:11" , 
"departure_time" : "17:04:29" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:06:18" , 
"departure_time" : "17:06:50" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:07:32" , 
"departure_time" : "17:08:29" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:09:57" , 
"departure_time" : "17:09:57" , 
"distance_traveled" : 4.0409
} ], 
"3862" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "17:03:00" , 
"departure_time" : "17:05:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:05:32" , 
"departure_time" : "17:06:07" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:05:35" , 
"departure_time" : "17:06:55" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:08:20" , 
"departure_time" : "17:09:52" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:09:32" , 
"departure_time" : "17:09:42" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:09:10" , 
"departure_time" : "17:10:37" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:12:27" , 
"departure_time" : "17:13:03" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:13:36" , 
"departure_time" : "17:14:36" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:16:00" , 
"departure_time" : "17:16:38" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:17:38" , 
"departure_time" : "17:17:38" , 
"distance_traveled" : 4.0409
} ], 
"3863" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "17:10:00" , 
"departure_time" : "17:11:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:12:11" , 
"departure_time" : "17:12:12" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:12:01" , 
"departure_time" : "17:12:13" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:14:12" , 
"departure_time" : "17:14:33" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:15:21" , 
"departure_time" : "17:16:48" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:17:27" , 
"departure_time" : "17:18:33" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:19:06" , 
"departure_time" : "17:20:13" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:21:07" , 
"departure_time" : "17:21:31" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:22:24" , 
"departure_time" : "17:23:31" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:25:07" , 
"departure_time" : "17:25:07" , 
"distance_traveled" : 4.0409
} ], 
"3864" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "17:17:00" , 
"departure_time" : "17:19:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:19:32" , 
"departure_time" : "17:21:04" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:20:32" , 
"departure_time" : "17:22:11" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:22:39" , 
"departure_time" : "17:23:51" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:23:12" , 
"departure_time" : "17:23:24" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:23:12" , 
"departure_time" : "17:24:36" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:26:24" , 
"departure_time" : "17:26:47" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:27:23" , 
"departure_time" : "17:27:47" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:29:24" , 
"departure_time" : "17:30:22" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:31:58" , 
"departure_time" : "17:31:58" , 
"distance_traveled" : 4.0409
} ], 
"3865" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "17:24:00" , 
"departure_time" : "17:25:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:25:08" , 
"departure_time" : "17:26:18" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:27:10" , 
"departure_time" : "17:28:02" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:28:52" , 
"departure_time" : "17:29:09" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:29:17" , 
"departure_time" : "17:30:54" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:31:37" , 
"departure_time" : "17:33:17" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:33:40" , 
"departure_time" : "17:33:43" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:34:03" , 
"departure_time" : "17:35:28" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:37:25" , 
"departure_time" : "17:37:45" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:38:20" , 
"departure_time" : "17:38:20" , 
"distance_traveled" : 4.0409
} ], 
"3866" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "17:31:00" , 
"departure_time" : "17:32:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:33:34" , 
"departure_time" : "17:35:07" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:34:33" , 
"departure_time" : "17:34:46" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:35:13" , 
"departure_time" : "17:35:42" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:36:29" , 
"departure_time" : "17:37:12" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:37:43" , 
"departure_time" : "17:38:31" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:39:48" , 
"departure_time" : "17:40:04" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:41:16" , 
"departure_time" : "17:41:20" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:43:04" , 
"departure_time" : "17:43:58" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:45:54" , 
"departure_time" : "17:45:54" , 
"distance_traveled" : 4.0409
} ], 
"3867" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "17:38:00" , 
"departure_time" : "17:40:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:40:18" , 
"departure_time" : "17:40:42" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:40:24" , 
"departure_time" : "17:40:28" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:42:04" , 
"departure_time" : "17:42:09" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:43:05" , 
"departure_time" : "17:44:18" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:45:13" , 
"departure_time" : "17:45:37" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:46:24" , 
"departure_time" : "17:46:29" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:48:05" , 
"departure_time" : "17:49:45" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:51:40" , 
"departure_time" : "17:53:07" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:53:27" , 
"departure_time" : "17:53:27" , 
"distance_traveled" : 4.0409
} ], 
"3868" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "17:52:00" , 
"departure_time" : "17:53:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:53:16" , 
"departure_time" : "17:54:56" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:55:40" , 
"departure_time" : "17:56:28" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:56:48" , 
"departure_time" : "17:56:51" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:57:03" , 
"departure_time" : "17:58:23" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:59:20" , 
"departure_time" : "17:59:49" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:00:29" , 
"departure_time" : "18:00:55" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:02:26" , 
"departure_time" : "18:02:43" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:04:17" , 
"departure_time" : "18:05:19" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:07:02" , 
"departure_time" : "18:07:02" , 
"distance_traveled" : 4.0409
} ], 
"3869" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "17:59:00" , 
"departure_time" : "18:01:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:01:40" , 
"departure_time" : "18:02:46" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:02:06" , 
"departure_time" : "18:02:20" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:03:14" , 
"departure_time" : "18:04:29" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:05:15" , 
"departure_time" : "18:05:55" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:05:40" , 
"departure_time" : "18:05:44" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:07:04" , 
"departure_time" : "18:08:06" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:10:02" , 
"departure_time" : "18:11:01" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:11:59" , 
"departure_time" : "18:13:23" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:14:24" , 
"departure_time" : "18:14:24" , 
"distance_traveled" : 4.0409
} ], 
"3870" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "18:06:00" , 
"departure_time" : "18:08:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:08:06" , 
"departure_time" : "18:09:22" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:09:16" , 
"departure_time" : "18:09:31" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:10:15" , 
"departure_time" : "18:10:41" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:11:26" , 
"departure_time" : "18:12:41" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:13:15" , 
"departure_time" : "18:14:46" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:15:31" , 
"departure_time" : "18:16:31" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:17:00" , 
"departure_time" : "18:17:34" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:18:34" , 
"departure_time" : "18:18:51" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:20:17" , 
"departure_time" : "18:20:17" , 
"distance_traveled" : 4.0409
} ], 
"3871" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "18:14:00" , 
"departure_time" : "18:14:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:15:21" , 
"departure_time" : "18:16:34" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:17:13" , 
"departure_time" : "18:17:31" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:18:18" , 
"departure_time" : "18:19:04" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:19:46" , 
"departure_time" : "18:19:51" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:20:05" , 
"departure_time" : "18:21:34" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:23:29" , 
"departure_time" : "18:25:02" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:25:33" , 
"departure_time" : "18:25:37" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:26:04" , 
"departure_time" : "18:26:52" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:28:48" , 
"departure_time" : "18:28:48" , 
"distance_traveled" : 4.0409
} ], 
"3872" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "18:21:00" , 
"departure_time" : "18:23:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:23:12" , 
"departure_time" : "18:23:40" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:23:28" , 
"departure_time" : "18:23:45" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:25:17" , 
"departure_time" : "18:26:48" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:27:31" , 
"departure_time" : "18:28:19" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:27:48" , 
"departure_time" : "18:27:53" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:29:05" , 
"departure_time" : "18:30:40" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:32:35" , 
"departure_time" : "18:34:14" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:34:39" , 
"departure_time" : "18:35:08" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:35:29" , 
"departure_time" : "18:35:29" , 
"distance_traveled" : 4.0409
} ], 
"3873" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "18:26:00" , 
"departure_time" : "18:27:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:27:43" , 
"departure_time" : "18:28:57" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:29:14" , 
"departure_time" : "18:30:16" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:31:02" , 
"departure_time" : "18:31:54" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:31:52" , 
"departure_time" : "18:32:53" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:33:01" , 
"departure_time" : "18:33:30" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:34:29" , 
"departure_time" : "18:35:05" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:36:36" , 
"departure_time" : "18:37:55" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:39:19" , 
"departure_time" : "18:39:40" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:40:21" , 
"departure_time" : "18:40:21" , 
"distance_traveled" : 4.0409
} ], 
"3874" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "18:34:00" , 
"departure_time" : "18:34:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:35:33" , 
"departure_time" : "18:36:14" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:36:41" , 
"departure_time" : "18:36:53" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:38:12" , 
"departure_time" : "18:38:14" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:39:02" , 
"departure_time" : "18:39:19" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:40:17" , 
"departure_time" : "18:41:17" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:43:00" , 
"departure_time" : "18:44:40" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:45:40" , 
"departure_time" : "18:46:34" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:46:54" , 
"departure_time" : "18:48:23" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:49:29" , 
"departure_time" : "18:49:29" , 
"distance_traveled" : 4.0409
} ], 
"3875" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "18:48:00" , 
"departure_time" : "18:50:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:49:52" , 
"departure_time" : "18:51:10" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:51:18" , 
"departure_time" : "18:52:04" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:52:46" , 
"departure_time" : "18:53:20" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:53:34" , 
"departure_time" : "18:54:07" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:54:33" , 
"departure_time" : "18:55:53" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:57:20" , 
"departure_time" : "18:58:09" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:58:49" , 
"departure_time" : "18:59:37" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:00:48" , 
"departure_time" : "19:01:01" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "19:02:13" , 
"departure_time" : "19:02:13" , 
"distance_traveled" : 4.0409
} ], 
"3876" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "19:06:00" , 
"departure_time" : "19:07:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "19:08:39" , 
"departure_time" : "19:08:50" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:08:11" , 
"departure_time" : "19:09:26" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "19:11:15" , 
"departure_time" : "19:11:57" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "19:11:42" , 
"departure_time" : "19:11:53" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "19:12:11" , 
"departure_time" : "19:12:52" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:14:41" , 
"departure_time" : "19:16:06" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:17:25" , 
"departure_time" : "19:18:49" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:19:24" , 
"departure_time" : "19:19:39" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "19:20:15" , 
"departure_time" : "19:20:15" , 
"distance_traveled" : 4.0409
} ], 
"3877" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "19:16:00" , 
"departure_time" : "19:17:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "19:17:46" , 
"departure_time" : "19:18:07" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:18:21" , 
"departure_time" : "19:19:24" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "19:21:03" , 
"departure_time" : "19:21:59" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "19:21:56" , 
"departure_time" : "19:22:27" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "19:22:31" , 
"departure_time" : "19:22:35" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:24:04" , 
"departure_time" : "19:25:10" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:27:06" , 
"departure_time" : "19:27:34" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:28:28" , 
"departure_time" : "19:29:49" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "19:31:21" , 
"departure_time" : "19:31:21" , 
"distance_traveled" : 4.0409
} ], 
"3878" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "19:28:00" , 
"departure_time" : "19:29:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "19:29:13" , 
"departure_time" : "19:29:39" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:30:26" , 
"departure_time" : "19:30:36" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "19:32:10" , 
"departure_time" : "19:32:54" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "19:33:44" , 
"departure_time" : "19:34:20" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "19:34:36" , 
"departure_time" : "19:35:49" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:37:13" , 
"departure_time" : "19:37:43" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:38:30" , 
"departure_time" : "19:38:48" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:40:18" , 
"departure_time" : "19:41:21" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "19:43:03" , 
"departure_time" : "19:43:03" , 
"distance_traveled" : 4.0409
} ], 
"3879" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "19:56:00" , 
"departure_time" : "19:58:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "19:58:21" , 
"departure_time" : "19:58:25" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:58:04" , 
"departure_time" : "19:58:07" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "20:00:03" , 
"departure_time" : "20:01:32" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "20:02:29" , 
"departure_time" : "20:02:41" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "20:02:12" , 
"departure_time" : "20:03:14" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "20:05:02" , 
"departure_time" : "20:05:26" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "20:06:24" , 
"departure_time" : "20:07:39" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "20:09:15" , 
"departure_time" : "20:09:39" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "20:10:24" , 
"departure_time" : "20:10:24" , 
"distance_traveled" : 4.0409
} ], 
"3880" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "04:37:00" , 
"departure_time" : "04:37:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "04:38:18" , 
"departure_time" : "04:38:53" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "04:39:35" , 
"departure_time" : "04:40:18" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "04:41:43" , 
"departure_time" : "04:43:12" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "04:43:29" , 
"departure_time" : "04:44:33" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "04:44:04" , 
"departure_time" : "04:44:14" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "04:45:10" , 
"departure_time" : "04:46:36" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "04:48:26" , 
"departure_time" : "04:49:58" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "04:50:32" , 
"departure_time" : "04:52:08" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "04:52:36" , 
"departure_time" : "04:53:53" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "04:56:17" , 
"departure_time" : "04:57:28" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "04:58:11" , 
"departure_time" : "04:58:11" , 
"distance_traveled" : 4.8619
} ], 
"3881" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "05:13:00" , 
"departure_time" : "05:14:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "05:14:40" , 
"departure_time" : "05:15:28" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "05:15:48" , 
"departure_time" : "05:16:47" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "05:17:59" , 
"departure_time" : "05:19:13" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "05:19:14" , 
"departure_time" : "05:20:15" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "05:20:01" , 
"departure_time" : "05:21:06" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "05:22:05" , 
"departure_time" : "05:23:37" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "05:24:32" , 
"departure_time" : "05:25:29" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "05:25:57" , 
"departure_time" : "05:27:06" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "05:28:09" , 
"departure_time" : "05:28:49" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "05:31:40" , 
"departure_time" : "05:33:15" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "05:34:35" , 
"departure_time" : "05:34:35" , 
"distance_traveled" : 4.8619
} ], 
"3882" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "05:37:00" , 
"departure_time" : "05:39:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "05:39:17" , 
"departure_time" : "05:40:30" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "05:40:13" , 
"departure_time" : "05:40:14" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "05:41:01" , 
"departure_time" : "05:41:18" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "05:42:17" , 
"departure_time" : "05:42:59" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "05:43:42" , 
"departure_time" : "05:44:39" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "05:45:57" , 
"departure_time" : "05:47:37" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "05:48:40" , 
"departure_time" : "05:49:32" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "05:49:52" , 
"departure_time" : "05:50:17" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "05:51:25" , 
"departure_time" : "05:53:02" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "05:56:37" , 
"departure_time" : "05:57:06" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "05:57:29" , 
"departure_time" : "05:57:29" , 
"distance_traveled" : 4.8619
} ], 
"3883" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "05:42:00" , 
"departure_time" : "05:43:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "05:44:04" , 
"departure_time" : "05:45:07" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "05:45:03" , 
"departure_time" : "05:45:45" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "05:46:42" , 
"departure_time" : "05:47:44" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "05:48:02" , 
"departure_time" : "05:48:42" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "05:48:40" , 
"departure_time" : "05:49:41" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "05:51:01" , 
"departure_time" : "05:51:08" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "05:52:07" , 
"departure_time" : "05:52:25" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "05:54:18" , 
"departure_time" : "05:54:47" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "05:56:29" , 
"departure_time" : "05:57:04" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "06:00:35" , 
"departure_time" : "06:00:39" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "06:02:04" , 
"departure_time" : "06:02:04" , 
"distance_traveled" : 4.8619
} ], 
"3884" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "06:10:00" , 
"departure_time" : "06:11:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:12:28" , 
"departure_time" : "06:13:24" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:12:56" , 
"departure_time" : "06:14:15" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:15:19" , 
"departure_time" : "06:15:30" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:15:11" , 
"departure_time" : "06:15:41" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:16:30" , 
"departure_time" : "06:18:01" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:19:31" , 
"departure_time" : "06:20:06" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "06:20:35" , 
"departure_time" : "06:20:49" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "06:22:14" , 
"departure_time" : "06:23:44" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "06:25:30" , 
"departure_time" : "06:26:12" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "06:28:42" , 
"departure_time" : "06:29:36" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "06:30:54" , 
"departure_time" : "06:30:54" , 
"distance_traveled" : 4.8619
} ], 
"3885" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "06:35:00" , 
"departure_time" : "06:36:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:36:55" , 
"departure_time" : "06:38:13" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:38:18" , 
"departure_time" : "06:38:54" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:39:36" , 
"departure_time" : "06:39:44" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:40:08" , 
"departure_time" : "06:40:10" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:41:02" , 
"departure_time" : "06:42:34" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:44:32" , 
"departure_time" : "06:45:14" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "06:45:42" , 
"departure_time" : "06:46:54" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "06:48:12" , 
"departure_time" : "06:49:43" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "06:50:31" , 
"departure_time" : "06:50:43" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "06:53:12" , 
"departure_time" : "06:53:53" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "06:55:41" , 
"departure_time" : "06:55:41" , 
"distance_traveled" : 4.8619
} ], 
"3886" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "06:46:00" , 
"departure_time" : "06:46:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:47:12" , 
"departure_time" : "06:48:47" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:49:35" , 
"departure_time" : "06:50:43" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "06:51:08" , 
"departure_time" : "06:52:10" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "06:52:02" , 
"departure_time" : "06:52:48" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "06:52:46" , 
"departure_time" : "06:52:53" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "06:54:07" , 
"departure_time" : "06:55:33" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "06:57:26" , 
"departure_time" : "06:58:25" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "06:58:59" , 
"departure_time" : "06:59:01" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:00:02" , 
"departure_time" : "07:00:10" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "07:04:08" , 
"departure_time" : "07:05:00" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "07:06:52" , 
"departure_time" : "07:06:52" , 
"distance_traveled" : 4.8619
} ], 
"3887" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "06:56:00" , 
"departure_time" : "06:57:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "06:57:43" , 
"departure_time" : "06:59:19" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "06:59:36" , 
"departure_time" : "07:00:25" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:00:49" , 
"departure_time" : "07:02:21" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:02:32" , 
"departure_time" : "07:03:38" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:03:06" , 
"departure_time" : "07:03:11" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:04:05" , 
"departure_time" : "07:04:51" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:06:46" , 
"departure_time" : "07:08:15" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:09:29" , 
"departure_time" : "07:11:05" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:11:36" , 
"departure_time" : "07:12:51" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "07:15:15" , 
"departure_time" : "07:15:39" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "07:16:24" , 
"departure_time" : "07:16:24" , 
"distance_traveled" : 4.8619
} ], 
"3888" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "07:05:00" , 
"departure_time" : "07:05:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:06:18" , 
"departure_time" : "07:07:38" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:08:20" , 
"departure_time" : "07:08:28" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:09:08" , 
"departure_time" : "07:09:46" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:10:38" , 
"departure_time" : "07:11:27" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:11:49" , 
"departure_time" : "07:12:48" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:13:59" , 
"departure_time" : "07:14:22" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:15:23" , 
"departure_time" : "07:15:27" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:17:04" , 
"departure_time" : "07:17:51" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:19:47" , 
"departure_time" : "07:20:39" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "07:23:52" , 
"departure_time" : "07:24:01" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "07:25:09" , 
"departure_time" : "07:25:09" , 
"distance_traveled" : 4.8619
} ], 
"3889" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "07:10:00" , 
"departure_time" : "07:11:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:12:40" , 
"departure_time" : "07:12:47" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:12:07" , 
"departure_time" : "07:13:13" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:15:06" , 
"departure_time" : "07:15:54" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:15:48" , 
"departure_time" : "07:17:21" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:17:33" , 
"departure_time" : "07:18:12" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:18:39" , 
"departure_time" : "07:20:09" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:21:30" , 
"departure_time" : "07:22:09" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:22:39" , 
"departure_time" : "07:23:56" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:25:17" , 
"departure_time" : "07:26:42" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "07:29:25" , 
"departure_time" : "07:30:45" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "07:31:20" , 
"departure_time" : "07:31:20" , 
"distance_traveled" : 4.8619
} ], 
"3890" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "07:17:00" , 
"departure_time" : "07:18:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:18:09" , 
"departure_time" : "07:18:45" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:19:36" , 
"departure_time" : "07:21:02" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:22:26" , 
"departure_time" : "07:24:05" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:23:39" , 
"departure_time" : "07:23:58" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:23:19" , 
"departure_time" : "07:23:42" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:25:23" , 
"departure_time" : "07:25:47" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:27:24" , 
"departure_time" : "07:28:14" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:29:50" , 
"departure_time" : "07:30:29" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:31:39" , 
"departure_time" : "07:31:51" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "07:35:12" , 
"departure_time" : "07:36:31" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "07:38:19" , 
"departure_time" : "07:38:19" , 
"distance_traveled" : 4.8619
} ], 
"3891" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "07:25:00" , 
"departure_time" : "07:27:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:27:11" , 
"departure_time" : "07:28:03" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:27:52" , 
"departure_time" : "07:27:53" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:29:01" , 
"departure_time" : "07:30:31" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:31:30" , 
"departure_time" : "07:32:50" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:32:20" , 
"departure_time" : "07:32:53" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:33:33" , 
"departure_time" : "07:34:33" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:36:00" , 
"departure_time" : "07:37:40" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:38:40" , 
"departure_time" : "07:39:15" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:39:35" , 
"departure_time" : "07:40:15" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "07:43:40" , 
"departure_time" : "07:45:11" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "07:46:31" , 
"departure_time" : "07:46:31" , 
"distance_traveled" : 4.8619
} ], 
"3892" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "07:32:00" , 
"departure_time" : "07:35:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:34:34" , 
"departure_time" : "07:36:02" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:35:28" , 
"departure_time" : "07:37:02" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:37:34" , 
"departure_time" : "07:37:46" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:37:12" , 
"departure_time" : "07:38:46" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:39:34" , 
"departure_time" : "07:41:06" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:41:32" , 
"departure_time" : "07:43:00" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:43:28" , 
"departure_time" : "07:45:07" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:45:39" , 
"departure_time" : "07:46:21" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:46:42" , 
"departure_time" : "07:46:45" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "07:50:03" , 
"departure_time" : "07:50:11" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "07:52:08" , 
"departure_time" : "07:52:08" , 
"distance_traveled" : 4.8619
} ], 
"3893" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "07:39:00" , 
"departure_time" : "07:39:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:40:31" , 
"departure_time" : "07:42:03" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:42:32" , 
"departure_time" : "07:42:53" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:43:21" , 
"departure_time" : "07:43:33" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:44:12" , 
"departure_time" : "07:45:22" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:46:10" , 
"departure_time" : "07:46:35" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "07:47:25" , 
"departure_time" : "07:48:10" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "07:49:45" , 
"departure_time" : "07:50:04" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "07:51:19" , 
"departure_time" : "07:51:28" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "07:53:09" , 
"departure_time" : "07:54:44" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "07:58:35" , 
"departure_time" : "07:59:55" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "08:00:20" , 
"departure_time" : "08:00:20" , 
"distance_traveled" : 4.8619
} ], 
"3894" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "07:53:00" , 
"departure_time" : "07:55:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "07:55:33" , 
"departure_time" : "07:55:59" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "07:55:26" , 
"departure_time" : "07:56:37" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "07:58:11" , 
"departure_time" : "07:59:49" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "07:59:38" , 
"departure_time" : "08:00:30" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "07:59:52" , 
"departure_time" : "08:00:10" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:01:18" , 
"departure_time" : "08:02:28" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:04:10" , 
"departure_time" : "08:04:38" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:05:28" , 
"departure_time" : "08:06:42" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:08:14" , 
"departure_time" : "08:09:51" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "08:12:37" , 
"departure_time" : "08:13:06" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "08:13:29" , 
"departure_time" : "08:13:29" , 
"distance_traveled" : 4.8619
} ], 
"3895" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "08:00:00" , 
"departure_time" : "08:01:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:01:37" , 
"departure_time" : "08:01:55" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:02:18" , 
"departure_time" : "08:03:10" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:04:52" , 
"departure_time" : "08:04:54" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:05:02" , 
"departure_time" : "08:06:26" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:07:24" , 
"departure_time" : "08:07:29" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:08:05" , 
"departure_time" : "08:08:56" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:10:51" , 
"departure_time" : "08:11:21" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:12:30" , 
"departure_time" : "08:13:47" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:15:17" , 
"departure_time" : "08:15:51" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "08:18:34" , 
"departure_time" : "08:18:37" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "08:20:03" , 
"departure_time" : "08:20:03" , 
"distance_traveled" : 4.8619
} ], 
"3896" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "08:07:00" , 
"departure_time" : "08:07:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:08:51" , 
"departure_time" : "08:09:29" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:09:38" , 
"departure_time" : "08:11:01" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:12:23" , 
"departure_time" : "08:13:05" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:12:42" , 
"departure_time" : "08:14:13" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:14:31" , 
"departure_time" : "08:15:54" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:16:23" , 
"departure_time" : "08:17:39" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:18:16" , 
"departure_time" : "08:19:21" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:20:05" , 
"departure_time" : "08:21:35" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:22:30" , 
"departure_time" : "08:23:49" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "08:26:19" , 
"departure_time" : "08:27:25" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "08:28:06" , 
"departure_time" : "08:28:06" , 
"distance_traveled" : 4.8619
} ], 
"3897" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "08:14:00" , 
"departure_time" : "08:16:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:16:17" , 
"departure_time" : "08:17:34" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:17:17" , 
"departure_time" : "08:17:59" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:18:42" , 
"departure_time" : "08:19:56" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:20:14" , 
"departure_time" : "08:20:23" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:20:09" , 
"departure_time" : "08:21:12" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:23:03" , 
"departure_time" : "08:24:17" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:25:14" , 
"departure_time" : "08:26:17" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:27:03" , 
"departure_time" : "08:28:35" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:29:32" , 
"departure_time" : "08:31:12" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "08:33:40" , 
"departure_time" : "08:34:59" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "08:35:19" , 
"departure_time" : "08:35:19" , 
"distance_traveled" : 4.8619
} ], 
"3898" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "08:21:00" , 
"departure_time" : "08:23:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:22:58" , 
"departure_time" : "08:24:29" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:24:31" , 
"departure_time" : "08:24:45" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:25:14" , 
"departure_time" : "08:26:19" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:27:05" , 
"departure_time" : "08:27:41" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:27:36" , 
"departure_time" : "08:28:52" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:30:16" , 
"departure_time" : "08:31:42" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:32:26" , 
"departure_time" : "08:32:28" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:33:02" , 
"departure_time" : "08:34:02" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:36:00" , 
"departure_time" : "08:36:10" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "08:39:10" , 
"departure_time" : "08:40:41" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "08:42:31" , 
"departure_time" : "08:42:31" , 
"distance_traveled" : 4.8619
} ], 
"3899" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "08:28:00" , 
"departure_time" : "08:30:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:29:42" , 
"departure_time" : "08:31:10" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:31:28" , 
"departure_time" : "08:32:29" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:33:01" , 
"departure_time" : "08:33:53" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:33:52" , 
"departure_time" : "08:34:57" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:35:05" , 
"departure_time" : "08:36:21" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:37:16" , 
"departure_time" : "08:38:24" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:39:08" , 
"departure_time" : "08:40:22" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:41:14" , 
"departure_time" : "08:42:50" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:43:36" , 
"departure_time" : "08:44:52" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "08:47:16" , 
"departure_time" : "08:48:42" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "08:49:26" , 
"departure_time" : "08:49:26" , 
"distance_traveled" : 4.8619
} ], 
"3900" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "08:36:00" , 
"departure_time" : "08:38:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:38:07" , 
"departure_time" : "08:39:15" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:39:08" , 
"departure_time" : "08:39:49" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:40:41" , 
"departure_time" : "08:42:11" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:42:30" , 
"departure_time" : "08:42:44" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:42:14" , 
"departure_time" : "08:42:16" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:44:02" , 
"departure_time" : "08:45:23" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:47:21" , 
"departure_time" : "08:48:47" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:49:26" , 
"departure_time" : "08:50:10" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:50:44" , 
"departure_time" : "08:51:33" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "08:54:49" , 
"departure_time" : "08:55:16" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "08:56:27" , 
"departure_time" : "08:56:27" , 
"distance_traveled" : 4.8619
} ], 
"3901" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "08:41:00" , 
"departure_time" : "08:42:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:42:52" , 
"departure_time" : "08:43:08" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:43:16" , 
"departure_time" : "08:44:45" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:46:29" , 
"departure_time" : "08:46:59" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:46:30" , 
"departure_time" : "08:47:21" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:47:51" , 
"departure_time" : "08:48:19" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:49:28" , 
"departure_time" : "08:49:51" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:51:23" , 
"departure_time" : "08:51:33" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "08:53:10" , 
"departure_time" : "08:54:34" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "08:56:24" , 
"departure_time" : "08:56:31" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "08:59:07" , 
"departure_time" : "08:59:11" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "09:01:04" , 
"departure_time" : "09:01:04" , 
"distance_traveled" : 4.8619
} ], 
"3902" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "08:49:00" , 
"departure_time" : "08:50:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:51:27" , 
"departure_time" : "08:52:47" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:52:20" , 
"departure_time" : "08:53:31" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "08:54:11" , 
"departure_time" : "08:54:34" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "08:54:23" , 
"departure_time" : "08:55:50" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "08:56:27" , 
"departure_time" : "08:56:42" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "08:57:15" , 
"departure_time" : "08:58:13" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "08:59:58" , 
"departure_time" : "09:00:11" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:01:13" , 
"departure_time" : "09:02:53" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:04:40" , 
"departure_time" : "09:05:18" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "09:07:38" , 
"departure_time" : "09:08:12" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "09:09:34" , 
"departure_time" : "09:09:34" , 
"distance_traveled" : 4.8619
} ], 
"3903" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "08:56:00" , 
"departure_time" : "08:56:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "08:57:01" , 
"departure_time" : "08:58:23" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "08:59:22" , 
"departure_time" : "09:01:02" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:01:40" , 
"departure_time" : "09:03:01" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:02:21" , 
"departure_time" : "09:02:45" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:02:24" , 
"departure_time" : "09:02:42" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:04:18" , 
"departure_time" : "09:04:38" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:06:20" , 
"departure_time" : "09:07:20" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:09:00" , 
"departure_time" : "09:10:03" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:11:03" , 
"departure_time" : "09:11:19" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "09:14:16" , 
"departure_time" : "09:15:19" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "09:17:03" , 
"departure_time" : "09:17:03" , 
"distance_traveled" : 4.8619
} ], 
"3904" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "09:02:00" , 
"departure_time" : "09:04:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:04:20" , 
"departure_time" : "09:04:59" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:04:39" , 
"departure_time" : "09:06:18" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:07:39" , 
"departure_time" : "09:08:48" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:08:09" , 
"departure_time" : "09:09:31" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:09:22" , 
"departure_time" : "09:10:46" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:11:24" , 
"departure_time" : "09:12:17" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:12:53" , 
"departure_time" : "09:13:31" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:14:38" , 
"departure_time" : "09:15:08" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:16:30" , 
"departure_time" : "09:17:25" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "09:20:55" , 
"departure_time" : "09:21:02" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "09:22:07" , 
"departure_time" : "09:22:07" , 
"distance_traveled" : 4.8619
} ], 
"3905" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "09:06:00" , 
"departure_time" : "09:06:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:07:04" , 
"departure_time" : "09:08:15" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:09:11" , 
"departure_time" : "09:10:12" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:11:01" , 
"departure_time" : "09:11:49" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:11:48" , 
"departure_time" : "09:11:50" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:12:02" , 
"departure_time" : "09:13:26" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:15:24" , 
"departure_time" : "09:16:05" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:16:41" , 
"departure_time" : "09:18:02" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:19:21" , 
"departure_time" : "09:19:33" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:20:12" , 
"departure_time" : "09:21:17" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "09:25:05" , 
"departure_time" : "09:26:11" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "09:27:06" , 
"departure_time" : "09:27:06" , 
"distance_traveled" : 4.8619
} ], 
"3906" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "09:10:00" , 
"departure_time" : "09:11:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:11:46" , 
"departure_time" : "09:12:16" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:12:30" , 
"departure_time" : "09:14:00" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:15:30" , 
"departure_time" : "09:16:38" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:16:08" , 
"departure_time" : "09:16:34" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:16:26" , 
"departure_time" : "09:17:57" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:19:31" , 
"departure_time" : "09:20:11" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:20:40" , 
"departure_time" : "09:22:07" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:23:27" , 
"departure_time" : "09:24:36" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:25:09" , 
"departure_time" : "09:26:24" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "09:29:15" , 
"departure_time" : "09:29:16" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "09:30:01" , 
"departure_time" : "09:30:01" , 
"distance_traveled" : 4.8619
} ], 
"3907" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "09:24:00" , 
"departure_time" : "09:24:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:25:26" , 
"departure_time" : "09:25:57" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:26:31" , 
"departure_time" : "09:27:54" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:29:23" , 
"departure_time" : "09:29:36" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:29:13" , 
"departure_time" : "09:29:43" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:30:30" , 
"departure_time" : "09:32:08" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:33:38" , 
"departure_time" : "09:34:13" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:34:35" , 
"departure_time" : "09:35:43" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:37:08" , 
"departure_time" : "09:38:41" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:39:33" , 
"departure_time" : "09:39:52" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "09:42:19" , 
"departure_time" : "09:43:42" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "09:45:23" , 
"departure_time" : "09:45:23" , 
"distance_traveled" : 4.8619
} ], 
"3908" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "09:27:00" , 
"departure_time" : "09:29:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:29:25" , 
"departure_time" : "09:29:51" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:29:26" , 
"departure_time" : "09:30:16" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:31:50" , 
"departure_time" : "09:32:46" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:32:56" , 
"departure_time" : "09:33:30" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:33:34" , 
"departure_time" : "09:34:40" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:36:06" , 
"departure_time" : "09:36:44" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:37:38" , 
"departure_time" : "09:39:11" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:40:33" , 
"departure_time" : "09:41:59" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:42:26" , 
"departure_time" : "09:43:00" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "09:45:34" , 
"departure_time" : "09:46:40" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "09:48:06" , 
"departure_time" : "09:48:06" , 
"distance_traveled" : 4.8619
} ], 
"3909" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "09:31:00" , 
"departure_time" : "09:32:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:32:22" , 
"departure_time" : "09:32:39" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:33:17" , 
"departure_time" : "09:33:23" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:35:06" , 
"departure_time" : "09:35:21" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:36:15" , 
"departure_time" : "09:37:50" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:38:35" , 
"departure_time" : "09:38:55" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:39:20" , 
"departure_time" : "09:40:50" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:42:30" , 
"departure_time" : "09:43:28" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:43:58" , 
"departure_time" : "09:45:25" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:46:27" , 
"departure_time" : "09:47:59" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "09:50:32" , 
"departure_time" : "09:51:10" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "09:51:38" , 
"departure_time" : "09:51:38" , 
"distance_traveled" : 4.8619
} ], 
"3910" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "09:36:00" , 
"departure_time" : "09:36:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:37:19" , 
"departure_time" : "09:38:00" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:38:41" , 
"departure_time" : "09:39:45" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:41:04" , 
"departure_time" : "09:41:10" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:41:06" , 
"departure_time" : "09:42:33" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:43:27" , 
"departure_time" : "09:44:32" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:45:05" , 
"departure_time" : "09:46:11" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:47:06" , 
"departure_time" : "09:47:26" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:48:20" , 
"departure_time" : "09:49:38" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:51:18" , 
"departure_time" : "09:51:59" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "09:54:41" , 
"departure_time" : "09:56:11" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "09:57:30" , 
"departure_time" : "09:57:30" , 
"distance_traveled" : 4.8619
} ], 
"3911" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "09:40:00" , 
"departure_time" : "09:42:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:41:46" , 
"departure_time" : "09:42:20" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:42:34" , 
"departure_time" : "09:43:07" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:44:33" , 
"departure_time" : "09:46:09" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:46:36" , 
"departure_time" : "09:47:53" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:47:17" , 
"departure_time" : "09:47:56" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:48:39" , 
"departure_time" : "09:50:19" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:51:40" , 
"departure_time" : "09:53:19" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:53:39" , 
"departure_time" : "09:54:22" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:54:43" , 
"departure_time" : "09:55:08" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "09:58:25" , 
"departure_time" : "09:59:35" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "10:01:10" , 
"departure_time" : "10:01:10" , 
"distance_traveled" : 4.8619
} ], 
"3912" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "09:44:00" , 
"departure_time" : "09:46:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:46:11" , 
"departure_time" : "09:47:16" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:47:05" , 
"departure_time" : "09:48:01" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:48:56" , 
"departure_time" : "09:49:47" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:49:51" , 
"departure_time" : "09:50:52" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:51:01" , 
"departure_time" : "09:52:26" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:53:25" , 
"departure_time" : "09:54:18" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:54:53" , 
"departure_time" : "09:55:14" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:56:21" , 
"departure_time" : "09:56:44" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:58:23" , 
"departure_time" : "09:59:32" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "10:03:09" , 
"departure_time" : "10:04:00" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "10:04:51" , 
"departure_time" : "10:04:51" , 
"distance_traveled" : 4.8619
} ], 
"3913" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "09:50:00" , 
"departure_time" : "09:51:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:51:30" , 
"departure_time" : "09:53:05" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:53:35" , 
"departure_time" : "09:54:59" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:55:24" , 
"departure_time" : "09:56:52" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:56:28" , 
"departure_time" : "09:56:51" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:56:23" , 
"departure_time" : "09:57:23" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:59:00" , 
"departure_time" : "10:00:38" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "10:01:38" , 
"departure_time" : "10:01:44" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "10:02:06" , 
"departure_time" : "10:03:30" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "10:05:24" , 
"departure_time" : "10:06:02" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "10:08:38" , 
"departure_time" : "10:09:52" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "10:11:14" , 
"departure_time" : "10:11:14" , 
"distance_traveled" : 4.8619
} ], 
"3914" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "09:58:00" , 
"departure_time" : "10:00:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "10:00:02" , 
"departure_time" : "10:01:19" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "10:01:17" , 
"departure_time" : "10:02:45" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "10:03:28" , 
"departure_time" : "10:03:59" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "10:03:31" , 
"departure_time" : "10:04:39" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "10:05:08" , 
"departure_time" : "10:06:21" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "10:07:13" , 
"departure_time" : "10:08:06" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "10:08:53" , 
"departure_time" : "10:10:03" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "10:11:10" , 
"departure_time" : "10:12:06" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "10:12:56" , 
"departure_time" : "10:13:41" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "10:16:45" , 
"departure_time" : "10:17:11" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "10:18:26" , 
"departure_time" : "10:18:26" , 
"distance_traveled" : 4.8619
} ], 
"3915" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "10:06:00" , 
"departure_time" : "10:07:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "10:08:12" , 
"departure_time" : "10:08:42" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "10:08:30" , 
"departure_time" : "10:09:51" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "10:11:21" , 
"departure_time" : "10:12:24" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "10:12:03" , 
"departure_time" : "10:13:25" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "10:13:22" , 
"departure_time" : "10:13:59" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "10:14:37" , 
"departure_time" : "10:15:42" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "10:17:05" , 
"departure_time" : "10:18:43" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "10:19:38" , 
"departure_time" : "10:20:52" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "10:21:14" , 
"departure_time" : "10:21:34" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "10:24:20" , 
"departure_time" : "10:25:34" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "10:27:14" , 
"departure_time" : "10:27:14" , 
"distance_traveled" : 4.8619
} ], 
"3916" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "10:16:00" , 
"departure_time" : "10:17:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "10:17:35" , 
"departure_time" : "10:18:37" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "10:19:02" , 
"departure_time" : "10:19:15" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "10:20:13" , 
"departure_time" : "10:20:26" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "10:21:13" , 
"departure_time" : "10:21:49" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "10:22:36" , 
"departure_time" : "10:23:45" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "10:25:09" , 
"departure_time" : "10:26:03" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "10:26:54" , 
"departure_time" : "10:27:12" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "10:28:18" , 
"departure_time" : "10:29:02" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "10:30:44" , 
"departure_time" : "10:32:04" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "10:35:20" , 
"departure_time" : "10:36:42" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "10:37:22" , 
"departure_time" : "10:37:22" , 
"distance_traveled" : 4.8619
} ], 
"3917" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "10:26:00" , 
"departure_time" : "10:28:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "10:28:11" , 
"departure_time" : "10:28:44" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "10:28:33" , 
"departure_time" : "10:29:20" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "10:30:47" , 
"departure_time" : "10:31:35" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "10:31:48" , 
"departure_time" : "10:33:08" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "10:33:20" , 
"departure_time" : "10:34:26" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "10:35:06" , 
"departure_time" : "10:36:13" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "10:37:07" , 
"departure_time" : "10:37:35" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "10:38:28" , 
"departure_time" : "10:40:02" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "10:41:34" , 
"departure_time" : "10:43:02" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "10:45:28" , 
"departure_time" : "10:46:00" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "10:46:32" , 
"departure_time" : "10:46:32" , 
"distance_traveled" : 4.8619
} ], 
"3918" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "10:36:00" , 
"departure_time" : "10:38:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "10:38:37" , 
"departure_time" : "10:39:53" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "10:39:16" , 
"departure_time" : "10:39:18" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "10:40:02" , 
"departure_time" : "10:40:34" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "10:41:32" , 
"departure_time" : "10:42:21" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "10:42:49" , 
"departure_time" : "10:43:20" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "10:44:31" , 
"departure_time" : "10:45:59" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "10:47:28" , 
"departure_time" : "10:48:27" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "10:48:59" , 
"departure_time" : "10:50:00" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "10:51:01" , 
"departure_time" : "10:52:21" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "10:55:20" , 
"departure_time" : "10:55:38" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "10:56:18" , 
"departure_time" : "10:56:18" , 
"distance_traveled" : 4.8619
} ], 
"3919" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "10:46:00" , 
"departure_time" : "10:46:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "10:47:20" , 
"departure_time" : "10:48:12" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "10:48:52" , 
"departure_time" : "10:49:51" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "10:50:59" , 
"departure_time" : "10:51:59" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "10:52:00" , 
"departure_time" : "10:53:22" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "10:53:22" , 
"departure_time" : "10:53:34" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "10:54:12" , 
"departure_time" : "10:55:18" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "10:57:06" , 
"departure_time" : "10:58:07" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "10:59:01" , 
"departure_time" : "11:00:07" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "11:01:06" , 
"departure_time" : "11:01:16" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "11:04:10" , 
"departure_time" : "11:05:43" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "11:07:33" , 
"departure_time" : "11:07:33" , 
"distance_traveled" : 4.8619
} ], 
"3920" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "10:56:00" , 
"departure_time" : "10:58:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "10:57:55" , 
"departure_time" : "10:58:55" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "10:59:00" , 
"departure_time" : "10:59:17" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "11:00:17" , 
"departure_time" : "11:01:47" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "11:02:30" , 
"departure_time" : "11:03:20" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "11:02:50" , 
"departure_time" : "11:04:28" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "11:05:38" , 
"departure_time" : "11:05:50" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "11:06:12" , 
"departure_time" : "11:06:32" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "11:08:20" , 
"departure_time" : "11:08:24" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "11:10:04" , 
"departure_time" : "11:10:35" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "11:14:31" , 
"departure_time" : "11:15:25" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "11:16:54" , 
"departure_time" : "11:16:54" , 
"distance_traveled" : 4.8619
} ], 
"3921" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "11:06:00" , 
"departure_time" : "11:08:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "11:08:37" , 
"departure_time" : "11:10:16" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "11:09:39" , 
"departure_time" : "11:10:02" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "11:10:23" , 
"departure_time" : "11:10:45" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "11:11:22" , 
"departure_time" : "11:11:36" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "11:12:14" , 
"departure_time" : "11:12:55" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "11:14:41" , 
"departure_time" : "11:15:30" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "11:16:49" , 
"departure_time" : "11:16:55" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "11:18:06" , 
"departure_time" : "11:19:11" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "11:21:05" , 
"departure_time" : "11:21:28" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "11:24:23" , 
"departure_time" : "11:25:41" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "11:27:18" , 
"departure_time" : "11:27:18" , 
"distance_traveled" : 4.8619
} ], 
"3922" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "11:16:00" , 
"departure_time" : "11:17:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "11:17:15" , 
"departure_time" : "11:17:19" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "11:18:04" , 
"departure_time" : "11:19:17" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "11:21:13" , 
"departure_time" : "11:21:33" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "11:21:20" , 
"departure_time" : "11:22:35" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "11:23:15" , 
"departure_time" : "11:24:53" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "11:25:38" , 
"departure_time" : "11:26:37" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "11:26:59" , 
"departure_time" : "11:27:23" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "11:28:24" , 
"departure_time" : "11:28:57" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "11:30:33" , 
"departure_time" : "11:31:52" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "11:35:19" , 
"departure_time" : "11:36:48" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "11:37:29" , 
"departure_time" : "11:37:29" , 
"distance_traveled" : 4.8619
} ], 
"3923" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "11:26:00" , 
"departure_time" : "11:29:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "11:28:35" , 
"departure_time" : "11:29:27" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "11:28:52" , 
"departure_time" : "11:30:03" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "11:31:11" , 
"departure_time" : "11:32:21" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "11:32:10" , 
"departure_time" : "11:33:45" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "11:33:35" , 
"departure_time" : "11:33:39" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "11:34:04" , 
"departure_time" : "11:34:14" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "11:36:10" , 
"departure_time" : "11:37:31" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "11:39:21" , 
"departure_time" : "11:40:43" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "11:41:22" , 
"departure_time" : "11:42:59" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "11:45:37" , 
"departure_time" : "11:46:43" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "11:47:06" , 
"departure_time" : "11:47:06" , 
"distance_traveled" : 4.8619
} ], 
"3924" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "11:36:00" , 
"departure_time" : "11:38:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "11:38:30" , 
"departure_time" : "11:39:44" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "11:39:14" , 
"departure_time" : "11:39:55" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "11:40:41" , 
"departure_time" : "11:41:47" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "11:42:06" , 
"departure_time" : "11:43:43" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "11:43:37" , 
"departure_time" : "11:44:56" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "11:45:19" , 
"departure_time" : "11:46:32" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "11:47:13" , 
"departure_time" : "11:48:51" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "11:49:38" , 
"departure_time" : "11:50:57" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "11:51:19" , 
"departure_time" : "11:52:30" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "11:55:11" , 
"departure_time" : "11:55:56" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "11:56:45" , 
"departure_time" : "11:56:45" , 
"distance_traveled" : 4.8619
} ], 
"3925" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "11:46:00" , 
"departure_time" : "11:47:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "11:47:43" , 
"departure_time" : "11:48:44" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "11:49:01" , 
"departure_time" : "11:49:15" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "11:50:14" , 
"departure_time" : "11:51:14" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "11:52:00" , 
"departure_time" : "11:53:40" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "11:53:40" , 
"departure_time" : "11:55:01" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "11:55:21" , 
"departure_time" : "11:55:55" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "11:56:34" , 
"departure_time" : "11:58:03" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "11:59:29" , 
"departure_time" : "12:00:02" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "12:00:33" , 
"departure_time" : "12:01:11" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "12:04:38" , 
"departure_time" : "12:05:08" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "12:06:30" , 
"departure_time" : "12:06:30" , 
"distance_traveled" : 4.8619
} ], 
"3926" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "11:56:00" , 
"departure_time" : "11:58:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "11:58:31" , 
"departure_time" : "11:59:49" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "11:59:18" , 
"departure_time" : "11:59:57" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "12:00:39" , 
"departure_time" : "12:01:13" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "12:01:34" , 
"departure_time" : "12:02:14" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "12:02:40" , 
"departure_time" : "12:03:55" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "12:05:15" , 
"departure_time" : "12:06:00" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "12:06:45" , 
"departure_time" : "12:08:08" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "12:09:23" , 
"departure_time" : "12:10:13" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "12:10:50" , 
"departure_time" : "12:11:41" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "12:14:51" , 
"departure_time" : "12:15:37" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "12:16:46" , 
"departure_time" : "12:16:46" , 
"distance_traveled" : 4.8619
} ], 
"3927" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "12:06:00" , 
"departure_time" : "12:08:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "12:08:15" , 
"departure_time" : "12:08:55" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "12:08:40" , 
"departure_time" : "12:09:21" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "12:10:41" , 
"departure_time" : "12:11:40" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "12:11:59" , 
"departure_time" : "12:13:03" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "12:13:04" , 
"departure_time" : "12:13:20" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "12:14:16" , 
"departure_time" : "12:14:56" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "12:16:40" , 
"departure_time" : "12:17:09" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "12:18:29" , 
"departure_time" : "12:19:02" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "12:20:33" , 
"departure_time" : "12:21:12" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "12:24:39" , 
"departure_time" : "12:25:27" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "12:26:48" , 
"departure_time" : "12:26:48" , 
"distance_traveled" : 4.8619
} ], 
"3928" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "12:16:00" , 
"departure_time" : "12:17:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "12:17:55" , 
"departure_time" : "12:18:03" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "12:18:08" , 
"departure_time" : "12:19:04" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "12:20:56" , 
"departure_time" : "12:21:13" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "12:21:17" , 
"departure_time" : "12:22:26" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "12:23:09" , 
"departure_time" : "12:24:04" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "12:24:55" , 
"departure_time" : "12:26:20" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "12:27:25" , 
"departure_time" : "12:28:16" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "12:28:51" , 
"departure_time" : "12:29:11" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "12:30:20" , 
"departure_time" : "12:30:38" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "12:34:18" , 
"departure_time" : "12:34:21" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "12:36:03" , 
"departure_time" : "12:36:03" , 
"distance_traveled" : 4.8619
} ], 
"3929" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "12:26:00" , 
"departure_time" : "12:26:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "12:27:10" , 
"departure_time" : "12:27:34" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "12:28:24" , 
"departure_time" : "12:29:22" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "12:30:58" , 
"departure_time" : "12:32:31" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "12:32:33" , 
"departure_time" : "12:33:18" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "12:32:45" , 
"departure_time" : "12:33:52" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "12:35:07" , 
"departure_time" : "12:36:21" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "12:37:14" , 
"departure_time" : "12:38:23" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "12:39:09" , 
"departure_time" : "12:39:35" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "12:40:26" , 
"departure_time" : "12:41:07" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "12:44:41" , 
"departure_time" : "12:46:20" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "12:47:39" , 
"departure_time" : "12:47:39" , 
"distance_traveled" : 4.8619
} ], 
"3930" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "12:36:00" , 
"departure_time" : "12:38:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "12:38:20" , 
"departure_time" : "12:39:12" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "12:38:52" , 
"departure_time" : "12:40:29" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "12:41:37" , 
"departure_time" : "12:41:58" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "12:41:21" , 
"departure_time" : "12:42:00" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "12:42:39" , 
"departure_time" : "12:43:19" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "12:44:40" , 
"departure_time" : "12:45:07" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "12:46:27" , 
"departure_time" : "12:46:47" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "12:48:20" , 
"departure_time" : "12:49:11" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "12:50:51" , 
"departure_time" : "12:51:05" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "12:54:14" , 
"departure_time" : "12:54:25" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "12:56:11" , 
"departure_time" : "12:56:11" , 
"distance_traveled" : 4.8619
} ], 
"3931" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "12:46:00" , 
"departure_time" : "12:46:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "12:47:12" , 
"departure_time" : "12:48:44" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "12:49:32" , 
"departure_time" : "12:50:46" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "12:51:14" , 
"departure_time" : "12:51:19" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "12:51:05" , 
"departure_time" : "12:51:41" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "12:52:36" , 
"departure_time" : "12:53:24" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "12:54:48" , 
"departure_time" : "12:55:01" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "12:56:13" , 
"departure_time" : "12:57:39" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "12:59:26" , 
"departure_time" : "13:00:43" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "13:01:17" , 
"departure_time" : "13:01:56" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "13:04:39" , 
"departure_time" : "13:06:14" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "13:07:35" , 
"departure_time" : "13:07:35" , 
"distance_traveled" : 4.8619
} ], 
"3932" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "12:56:00" , 
"departure_time" : "12:57:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "12:57:07" , 
"departure_time" : "12:58:21" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "12:59:14" , 
"departure_time" : "13:00:13" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "13:00:59" , 
"departure_time" : "13:02:01" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "13:02:02" , 
"departure_time" : "13:02:16" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "13:02:14" , 
"departure_time" : "13:03:00" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "13:04:46" , 
"departure_time" : "13:06:23" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "13:07:37" , 
"departure_time" : "13:08:00" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "13:08:23" , 
"departure_time" : "13:09:57" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "13:11:34" , 
"departure_time" : "13:12:33" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "13:14:59" , 
"departure_time" : "13:15:09" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "13:16:10" , 
"departure_time" : "13:16:10" , 
"distance_traveled" : 4.8619
} ], 
"3933" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "13:06:00" , 
"departure_time" : "13:06:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "13:07:14" , 
"departure_time" : "13:08:28" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "13:09:14" , 
"departure_time" : "13:09:34" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "13:10:20" , 
"departure_time" : "13:11:48" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "13:12:28" , 
"departure_time" : "13:13:15" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "13:12:47" , 
"departure_time" : "13:13:15" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "13:14:28" , 
"departure_time" : "13:15:23" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "13:16:55" , 
"departure_time" : "13:16:58" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "13:18:03" , 
"departure_time" : "13:18:37" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "13:20:34" , 
"departure_time" : "13:21:39" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "13:25:05" , 
"departure_time" : "13:25:30" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "13:26:25" , 
"departure_time" : "13:26:25" , 
"distance_traveled" : 4.8619
} ], 
"3934" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "13:16:00" , 
"departure_time" : "13:17:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "13:18:07" , 
"departure_time" : "13:19:43" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "13:19:36" , 
"departure_time" : "13:19:43" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "13:20:07" , 
"departure_time" : "13:21:13" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "13:22:06" , 
"departure_time" : "13:22:38" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "13:22:32" , 
"departure_time" : "13:23:42" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "13:25:10" , 
"departure_time" : "13:25:21" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "13:26:11" , 
"departure_time" : "13:27:16" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "13:29:05" , 
"departure_time" : "13:29:56" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "13:30:51" , 
"departure_time" : "13:31:13" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "13:34:22" , 
"departure_time" : "13:34:30" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "13:36:08" , 
"departure_time" : "13:36:08" , 
"distance_traveled" : 4.8619
} ], 
"3935" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "13:26:00" , 
"departure_time" : "13:26:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "13:27:28" , 
"departure_time" : "13:29:03" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "13:29:35" , 
"departure_time" : "13:30:46" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "13:31:11" , 
"departure_time" : "13:31:20" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "13:31:09" , 
"departure_time" : "13:32:26" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "13:33:17" , 
"departure_time" : "13:34:05" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "13:34:48" , 
"departure_time" : "13:35:26" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "13:36:38" , 
"departure_time" : "13:37:10" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "13:38:32" , 
"departure_time" : "13:40:08" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "13:41:36" , 
"departure_time" : "13:43:10" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "13:45:34" , 
"departure_time" : "13:46:33" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "13:46:59" , 
"departure_time" : "13:46:59" , 
"distance_traveled" : 4.8619
} ], 
"3936" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "13:36:00" , 
"departure_time" : "13:37:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "13:37:56" , 
"departure_time" : "13:38:41" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "13:38:45" , 
"departure_time" : "13:39:00" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "13:40:15" , 
"departure_time" : "13:41:23" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "13:42:08" , 
"departure_time" : "13:42:42" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "13:42:34" , 
"departure_time" : "13:42:56" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "13:44:22" , 
"departure_time" : "13:45:23" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "13:47:01" , 
"departure_time" : "13:47:24" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "13:48:23" , 
"departure_time" : "13:49:55" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "13:51:32" , 
"departure_time" : "13:52:34" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "13:55:02" , 
"departure_time" : "13:55:32" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "13:56:30" , 
"departure_time" : "13:56:30" , 
"distance_traveled" : 4.8619
} ], 
"3937" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "13:46:00" , 
"departure_time" : "13:47:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "13:47:55" , 
"departure_time" : "13:48:32" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "13:48:37" , 
"departure_time" : "13:48:48" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "13:50:11" , 
"departure_time" : "13:50:36" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "13:51:25" , 
"departure_time" : "13:51:53" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "13:52:28" , 
"departure_time" : "13:52:51" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "13:54:23" , 
"departure_time" : "13:55:01" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "13:56:38" , 
"departure_time" : "13:58:17" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "13:59:39" , 
"departure_time" : "14:00:16" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "14:00:37" , 
"departure_time" : "14:01:28" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "14:04:51" , 
"departure_time" : "14:05:39" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "14:06:48" , 
"departure_time" : "14:06:48" , 
"distance_traveled" : 4.8619
} ], 
"3938" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "13:56:00" , 
"departure_time" : "13:57:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "13:57:29" , 
"departure_time" : "13:57:43" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "13:58:14" , 
"departure_time" : "13:58:24" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "14:00:10" , 
"departure_time" : "14:00:23" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "14:01:13" , 
"departure_time" : "14:01:41" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "14:02:28" , 
"departure_time" : "14:02:59" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "14:04:31" , 
"departure_time" : "14:04:38" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "14:06:07" , 
"departure_time" : "14:07:23" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "14:09:16" , 
"departure_time" : "14:09:50" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "14:10:34" , 
"departure_time" : "14:11:35" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "14:15:01" , 
"departure_time" : "14:16:34" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "14:17:33" , 
"departure_time" : "14:17:33" , 
"distance_traveled" : 4.8619
} ], 
"3939" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "14:06:00" , 
"departure_time" : "14:08:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "14:07:32" , 
"departure_time" : "14:07:47" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "14:08:15" , 
"departure_time" : "14:09:44" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "14:11:29" , 
"departure_time" : "14:11:43" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "14:11:14" , 
"departure_time" : "14:12:32" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "14:13:18" , 
"departure_time" : "14:14:46" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "14:15:28" , 
"departure_time" : "14:15:55" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "14:16:27" , 
"departure_time" : "14:17:36" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "14:19:09" , 
"departure_time" : "14:20:00" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "14:20:51" , 
"departure_time" : "14:22:05" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "14:25:14" , 
"departure_time" : "14:26:38" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "14:27:24" , 
"departure_time" : "14:27:24" , 
"distance_traveled" : 4.8619
} ], 
"3940" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "14:16:00" , 
"departure_time" : "14:17:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "14:17:04" , 
"departure_time" : "14:18:22" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "14:19:18" , 
"departure_time" : "14:20:03" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "14:20:45" , 
"departure_time" : "14:21:39" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "14:21:54" , 
"departure_time" : "14:22:56" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "14:23:02" , 
"departure_time" : "14:23:31" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "14:24:29" , 
"departure_time" : "14:25:44" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "14:27:15" , 
"departure_time" : "14:27:29" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "14:28:14" , 
"departure_time" : "14:29:18" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "14:31:04" , 
"departure_time" : "14:31:58" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "14:34:54" , 
"departure_time" : "14:35:08" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "14:36:14" , 
"departure_time" : "14:36:14" , 
"distance_traveled" : 4.8619
} ], 
"3941" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "14:26:00" , 
"departure_time" : "14:26:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "14:27:15" , 
"departure_time" : "14:27:20" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "14:28:05" , 
"departure_time" : "14:28:22" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "14:30:17" , 
"departure_time" : "14:30:27" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "14:31:10" , 
"departure_time" : "14:31:25" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "14:32:15" , 
"departure_time" : "14:32:20" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "14:34:05" , 
"departure_time" : "14:35:05" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "14:37:00" , 
"departure_time" : "14:37:33" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "14:38:33" , 
"departure_time" : "14:39:05" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "14:40:32" , 
"departure_time" : "14:40:46" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "14:44:14" , 
"departure_time" : "14:44:32" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "14:46:18" , 
"departure_time" : "14:46:18" , 
"distance_traveled" : 4.8619
} ], 
"3942" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "14:36:00" , 
"departure_time" : "14:36:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "14:37:08" , 
"departure_time" : "14:38:32" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "14:39:24" , 
"departure_time" : "14:39:44" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "14:40:20" , 
"departure_time" : "14:40:42" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "14:41:22" , 
"departure_time" : "14:41:53" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "14:42:31" , 
"departure_time" : "14:43:59" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "14:45:28" , 
"departure_time" : "14:47:05" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "14:47:37" , 
"departure_time" : "14:48:47" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "14:49:10" , 
"departure_time" : "14:50:45" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "14:51:35" , 
"departure_time" : "14:52:08" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "14:54:33" , 
"departure_time" : "14:54:41" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "14:56:08" , 
"departure_time" : "14:56:08" , 
"distance_traveled" : 4.8619
} ], 
"3943" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "14:48:00" , 
"departure_time" : "14:49:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "14:50:06" , 
"departure_time" : "14:51:24" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "14:51:18" , 
"departure_time" : "14:52:03" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "14:52:45" , 
"departure_time" : "14:52:59" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "14:53:14" , 
"departure_time" : "14:54:18" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "14:55:04" , 
"departure_time" : "14:55:49" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "14:56:45" , 
"departure_time" : "14:57:05" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "14:58:20" , 
"departure_time" : "14:59:59" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:01:39" , 
"departure_time" : "15:02:42" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "15:03:03" , 
"departure_time" : "15:03:46" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "15:06:43" , 
"departure_time" : "15:07:45" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "15:09:02" , 
"departure_time" : "15:09:02" , 
"distance_traveled" : 4.8619
} ], 
"3944" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "15:08:00" , 
"departure_time" : "15:09:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:09:15" , 
"departure_time" : "15:09:34" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:10:19" , 
"departure_time" : "15:11:23" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:13:04" , 
"departure_time" : "15:14:27" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:14:23" , 
"departure_time" : "15:15:42" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:15:19" , 
"departure_time" : "15:16:44" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:17:25" , 
"departure_time" : "15:19:00" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:19:35" , 
"departure_time" : "15:20:00" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:20:25" , 
"departure_time" : "15:21:17" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "15:22:52" , 
"departure_time" : "15:23:49" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "15:26:57" , 
"departure_time" : "15:27:44" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "15:28:47" , 
"departure_time" : "15:28:47" , 
"distance_traveled" : 4.8619
} ], 
"3945" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "15:30:00" , 
"departure_time" : "15:31:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:31:40" , 
"departure_time" : "15:33:18" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:33:38" , 
"departure_time" : "15:34:35" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:34:57" , 
"departure_time" : "15:35:25" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:35:28" , 
"departure_time" : "15:36:42" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:37:14" , 
"departure_time" : "15:38:10" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:38:56" , 
"departure_time" : "15:40:13" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:41:17" , 
"departure_time" : "15:41:46" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:42:29" , 
"departure_time" : "15:42:32" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "15:44:03" , 
"departure_time" : "15:45:13" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "15:49:10" , 
"departure_time" : "15:49:56" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "15:50:46" , 
"departure_time" : "15:50:46" , 
"distance_traveled" : 4.8619
} ], 
"3946" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "15:39:00" , 
"departure_time" : "15:41:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:41:26" , 
"departure_time" : "15:41:37" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:41:11" , 
"departure_time" : "15:42:23" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:44:12" , 
"departure_time" : "15:44:47" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:44:35" , 
"departure_time" : "15:45:46" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:46:11" , 
"departure_time" : "15:47:25" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:48:14" , 
"departure_time" : "15:48:42" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:49:28" , 
"departure_time" : "15:50:58" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:52:30" , 
"departure_time" : "15:53:45" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "15:54:15" , 
"departure_time" : "15:55:26" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "15:58:11" , 
"departure_time" : "15:58:21" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "15:59:10" , 
"departure_time" : "15:59:10" , 
"distance_traveled" : 4.8619
} ], 
"3947" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "15:42:00" , 
"departure_time" : "15:43:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:43:54" , 
"departure_time" : "15:45:10" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:45:16" , 
"departure_time" : "15:46:37" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:47:21" , 
"departure_time" : "15:48:29" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:48:08" , 
"departure_time" : "15:49:28" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:49:20" , 
"departure_time" : "15:49:24" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:50:04" , 
"departure_time" : "15:50:50" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "15:52:46" , 
"departure_time" : "15:53:17" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "15:54:31" , 
"departure_time" : "15:55:16" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "15:56:45" , 
"departure_time" : "15:58:24" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "16:01:39" , 
"departure_time" : "16:02:23" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "16:02:44" , 
"departure_time" : "16:02:44" , 
"distance_traveled" : 4.8619
} ], 
"3948" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "15:50:00" , 
"departure_time" : "15:51:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:51:27" , 
"departure_time" : "15:53:03" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:53:36" , 
"departure_time" : "15:54:54" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "15:55:18" , 
"departure_time" : "15:56:42" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "15:56:24" , 
"departure_time" : "15:57:42" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "15:57:18" , 
"departure_time" : "15:58:04" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "15:58:46" , 
"departure_time" : "15:59:07" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:00:21" , 
"departure_time" : "16:00:42" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:02:21" , 
"departure_time" : "16:02:28" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:04:07" , 
"departure_time" : "16:04:46" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "16:08:39" , 
"departure_time" : "16:08:53" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "16:10:14" , 
"departure_time" : "16:10:14" , 
"distance_traveled" : 4.8619
} ], 
"3949" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "15:57:00" , 
"departure_time" : "15:58:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "15:58:53" , 
"departure_time" : "15:59:25" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "15:59:32" , 
"departure_time" : "16:00:46" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:02:14" , 
"departure_time" : "16:03:48" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:03:34" , 
"departure_time" : "16:03:47" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:03:13" , 
"departure_time" : "16:03:56" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:05:43" , 
"departure_time" : "16:06:37" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:07:54" , 
"departure_time" : "16:08:52" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:09:58" , 
"departure_time" : "16:10:54" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:11:56" , 
"departure_time" : "16:12:37" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "16:15:41" , 
"departure_time" : "16:16:26" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "16:17:45" , 
"departure_time" : "16:17:45" , 
"distance_traveled" : 4.8619
} ], 
"3950" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "16:04:00" , 
"departure_time" : "16:05:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:05:43" , 
"departure_time" : "16:06:15" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:06:32" , 
"departure_time" : "16:07:31" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:08:59" , 
"departure_time" : "16:09:21" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:09:22" , 
"departure_time" : "16:10:00" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:10:38" , 
"departure_time" : "16:11:34" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:12:56" , 
"departure_time" : "16:14:29" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:15:33" , 
"departure_time" : "16:15:52" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:16:19" , 
"departure_time" : "16:16:54" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:18:35" , 
"departure_time" : "16:18:58" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "16:22:23" , 
"departure_time" : "16:24:00" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "16:25:37" , 
"departure_time" : "16:25:37" , 
"distance_traveled" : 4.8619
} ], 
"3951" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "16:12:00" , 
"departure_time" : "16:15:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:14:23" , 
"departure_time" : "16:14:49" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:14:26" , 
"departure_time" : "16:14:51" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:16:25" , 
"departure_time" : "16:17:12" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:17:47" , 
"departure_time" : "16:18:18" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:18:31" , 
"departure_time" : "16:19:30" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:20:59" , 
"departure_time" : "16:22:07" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:23:08" , 
"departure_time" : "16:23:11" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:24:03" , 
"departure_time" : "16:24:54" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:26:51" , 
"departure_time" : "16:27:56" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "16:31:05" , 
"departure_time" : "16:32:40" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "16:33:35" , 
"departure_time" : "16:33:35" , 
"distance_traveled" : 4.8619
} ], 
"3952" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "16:17:00" , 
"departure_time" : "16:19:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:19:06" , 
"departure_time" : "16:19:51" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:19:45" , 
"departure_time" : "16:20:45" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:22:00" , 
"departure_time" : "16:23:27" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:23:27" , 
"departure_time" : "16:24:37" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:24:10" , 
"departure_time" : "16:25:46" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:26:36" , 
"departure_time" : "16:28:15" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:28:39" , 
"departure_time" : "16:29:47" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:30:08" , 
"departure_time" : "16:30:41" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:31:33" , 
"departure_time" : "16:31:48" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "16:35:15" , 
"departure_time" : "16:35:54" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "16:37:39" , 
"departure_time" : "16:37:39" , 
"distance_traveled" : 4.8619
} ], 
"3953" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "16:25:00" , 
"departure_time" : "16:27:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:27:40" , 
"departure_time" : "16:28:47" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:28:07" , 
"departure_time" : "16:28:36" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:29:29" , 
"departure_time" : "16:30:35" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:31:06" , 
"departure_time" : "16:32:25" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:32:19" , 
"departure_time" : "16:32:22" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:33:03" , 
"departure_time" : "16:33:56" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:35:53" , 
"departure_time" : "16:37:04" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:38:11" , 
"departure_time" : "16:39:44" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:40:33" , 
"departure_time" : "16:41:17" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "16:43:44" , 
"departure_time" : "16:43:53" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "16:45:09" , 
"departure_time" : "16:45:09" , 
"distance_traveled" : 4.8619
} ], 
"3954" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "16:32:00" , 
"departure_time" : "16:33:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:33:58" , 
"departure_time" : "16:35:26" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:35:28" , 
"departure_time" : "16:35:42" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:36:14" , 
"departure_time" : "16:36:35" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:37:21" , 
"departure_time" : "16:38:16" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:38:55" , 
"departure_time" : "16:40:12" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:41:17" , 
"departure_time" : "16:41:22" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:42:05" , 
"departure_time" : "16:42:15" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:44:10" , 
"departure_time" : "16:44:35" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:46:25" , 
"departure_time" : "16:47:26" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "16:51:01" , 
"departure_time" : "16:51:43" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "16:52:42" , 
"departure_time" : "16:52:42" , 
"distance_traveled" : 4.8619
} ], 
"3955" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "16:40:00" , 
"departure_time" : "16:41:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:41:38" , 
"departure_time" : "16:43:05" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:43:27" , 
"departure_time" : "16:44:31" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:45:04" , 
"departure_time" : "16:45:46" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:45:42" , 
"departure_time" : "16:46:39" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:46:57" , 
"departure_time" : "16:47:34" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:48:37" , 
"departure_time" : "16:49:33" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:50:56" , 
"departure_time" : "16:52:03" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "16:53:07" , 
"departure_time" : "16:54:16" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "16:55:09" , 
"departure_time" : "16:56:03" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "16:58:54" , 
"departure_time" : "16:59:56" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "17:01:02" , 
"departure_time" : "17:01:02" , 
"distance_traveled" : 4.8619
} ], 
"3956" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "16:47:00" , 
"departure_time" : "16:48:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "16:48:37" , 
"departure_time" : "16:49:49" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "16:50:12" , 
"departure_time" : "16:51:04" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "16:51:52" , 
"departure_time" : "16:52:53" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "16:53:01" , 
"departure_time" : "16:54:27" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "16:54:26" , 
"departure_time" : "16:54:35" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "16:55:09" , 
"departure_time" : "16:56:10" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "16:58:01" , 
"departure_time" : "16:59:24" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:00:23" , 
"departure_time" : "17:01:32" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:02:09" , 
"departure_time" : "17:02:12" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "17:05:03" , 
"departure_time" : "17:05:26" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "17:07:23" , 
"departure_time" : "17:07:23" , 
"distance_traveled" : 4.8619
} ], 
"3957" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "16:59:00" , 
"departure_time" : "17:00:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:01:02" , 
"departure_time" : "17:01:59" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:01:57" , 
"departure_time" : "17:02:45" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:03:48" , 
"departure_time" : "17:04:20" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:04:32" , 
"departure_time" : "17:05:43" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:06:11" , 
"departure_time" : "17:06:29" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:07:18" , 
"departure_time" : "17:08:48" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:10:30" , 
"departure_time" : "17:11:19" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:11:49" , 
"departure_time" : "17:12:48" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:13:59" , 
"departure_time" : "17:14:01" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "17:17:02" , 
"departure_time" : "17:17:07" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "17:19:05" , 
"departure_time" : "17:19:05" , 
"distance_traveled" : 4.8619
} ], 
"3958" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "17:06:00" , 
"departure_time" : "17:07:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:08:04" , 
"departure_time" : "17:08:53" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:08:49" , 
"departure_time" : "17:09:48" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:10:59" , 
"departure_time" : "17:11:56" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:11:57" , 
"departure_time" : "17:12:55" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:12:58" , 
"departure_time" : "17:14:27" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:15:29" , 
"departure_time" : "17:16:35" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:17:06" , 
"departure_time" : "17:17:23" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:18:17" , 
"departure_time" : "17:18:47" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:20:30" , 
"departure_time" : "17:21:16" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "17:24:46" , 
"departure_time" : "17:25:30" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "17:26:44" , 
"departure_time" : "17:26:44" , 
"distance_traveled" : 4.8619
} ], 
"3959" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "17:14:00" , 
"departure_time" : "17:14:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:15:14" , 
"departure_time" : "17:15:39" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:16:25" , 
"departure_time" : "17:17:33" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:19:08" , 
"departure_time" : "17:19:39" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:19:31" , 
"departure_time" : "17:19:58" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:20:27" , 
"departure_time" : "17:21:46" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:23:19" , 
"departure_time" : "17:24:52" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:25:33" , 
"departure_time" : "17:25:46" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:26:13" , 
"departure_time" : "17:26:41" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:28:28" , 
"departure_time" : "17:30:05" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "17:33:37" , 
"departure_time" : "17:35:11" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "17:35:34" , 
"departure_time" : "17:35:34" , 
"distance_traveled" : 4.8619
} ], 
"3960" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "17:21:00" , 
"departure_time" : "17:24:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:23:39" , 
"departure_time" : "17:24:00" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:23:21" , 
"departure_time" : "17:24:46" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:26:25" , 
"departure_time" : "17:27:47" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:27:22" , 
"departure_time" : "17:28:16" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:27:54" , 
"departure_time" : "17:28:44" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:29:50" , 
"departure_time" : "17:30:16" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:31:26" , 
"departure_time" : "17:32:29" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:34:03" , 
"departure_time" : "17:34:35" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:35:32" , 
"departure_time" : "17:36:18" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "17:39:46" , 
"departure_time" : "17:41:20" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "17:42:34" , 
"departure_time" : "17:42:34" , 
"distance_traveled" : 4.8619
} ], 
"3961" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "17:28:00" , 
"departure_time" : "17:30:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:29:50" , 
"departure_time" : "17:31:30" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:31:40" , 
"departure_time" : "17:33:11" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:33:31" , 
"departure_time" : "17:34:47" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:34:16" , 
"departure_time" : "17:35:23" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:35:07" , 
"departure_time" : "17:35:41" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:36:34" , 
"departure_time" : "17:37:06" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:38:32" , 
"departure_time" : "17:39:33" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:41:01" , 
"departure_time" : "17:41:20" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:42:19" , 
"departure_time" : "17:43:19" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "17:47:00" , 
"departure_time" : "17:48:30" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "17:49:30" , 
"departure_time" : "17:49:30" , 
"distance_traveled" : 4.8619
} ], 
"3962" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "17:35:00" , 
"departure_time" : "17:38:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:37:40" , 
"departure_time" : "17:38:24" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:37:44" , 
"departure_time" : "17:37:55" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:39:11" , 
"departure_time" : "17:39:14" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:40:03" , 
"departure_time" : "17:41:33" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:42:30" , 
"departure_time" : "17:43:05" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:43:35" , 
"departure_time" : "17:45:00" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:46:25" , 
"departure_time" : "17:46:42" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:47:17" , 
"departure_time" : "17:47:37" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:49:20" , 
"departure_time" : "17:50:06" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "17:53:46" , 
"departure_time" : "17:55:25" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "17:56:39" , 
"departure_time" : "17:56:39" , 
"distance_traveled" : 4.8619
} ], 
"3963" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "17:43:00" , 
"departure_time" : "17:46:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:45:32" , 
"departure_time" : "17:46:31" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:45:59" , 
"departure_time" : "17:47:24" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:48:25" , 
"departure_time" : "17:49:25" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:49:00" , 
"departure_time" : "17:49:49" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:49:49" , 
"departure_time" : "17:50:37" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:51:48" , 
"departure_time" : "17:52:33" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:53:45" , 
"departure_time" : "17:54:51" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "17:56:06" , 
"departure_time" : "17:57:36" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "17:58:30" , 
"departure_time" : "17:59:42" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "18:02:12" , 
"departure_time" : "18:02:27" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "18:03:15" , 
"departure_time" : "18:03:15" , 
"distance_traveled" : 4.8619
} ], 
"3964" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "17:48:00" , 
"departure_time" : "17:49:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:49:48" , 
"departure_time" : "17:50:46" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:50:58" , 
"departure_time" : "17:51:38" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "17:52:40" , 
"departure_time" : "17:53:32" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "17:53:52" , 
"departure_time" : "17:54:22" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "17:54:30" , 
"departure_time" : "17:54:36" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "17:56:06" , 
"departure_time" : "17:57:39" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "17:59:33" , 
"departure_time" : "18:00:33" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:01:00" , 
"departure_time" : "18:02:01" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:03:01" , 
"departure_time" : "18:03:51" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "18:06:50" , 
"departure_time" : "18:07:15" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "18:08:25" , 
"departure_time" : "18:08:25" , 
"distance_traveled" : 4.8619
} ], 
"3965" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "17:56:00" , 
"departure_time" : "17:57:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "17:58:05" , 
"departure_time" : "17:58:57" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "17:58:52" , 
"departure_time" : "17:59:54" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:01:02" , 
"departure_time" : "18:01:06" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:01:04" , 
"departure_time" : "18:01:21" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:02:17" , 
"departure_time" : "18:02:19" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:04:02" , 
"departure_time" : "18:04:07" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:06:05" , 
"departure_time" : "18:07:36" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:09:31" , 
"departure_time" : "18:11:07" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:11:36" , 
"departure_time" : "18:12:51" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "18:15:15" , 
"departure_time" : "18:15:21" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "18:16:06" , 
"departure_time" : "18:16:06" , 
"distance_traveled" : 4.8619
} ], 
"3966" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "18:03:00" , 
"departure_time" : "18:03:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:04:49" , 
"departure_time" : "18:05:01" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:05:12" , 
"departure_time" : "18:06:49" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:08:37" , 
"departure_time" : "18:09:40" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:09:03" , 
"departure_time" : "18:10:01" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:09:58" , 
"departure_time" : "18:10:42" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:11:44" , 
"departure_time" : "18:11:55" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:13:11" , 
"departure_time" : "18:14:44" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:16:33" , 
"departure_time" : "18:17:11" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:17:38" , 
"departure_time" : "18:17:59" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "18:21:21" , 
"departure_time" : "18:22:02" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "18:23:41" , 
"departure_time" : "18:23:41" , 
"distance_traveled" : 4.8619
} ], 
"3967" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "18:10:00" , 
"departure_time" : "18:10:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:11:13" , 
"departure_time" : "18:12:20" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:13:07" , 
"departure_time" : "18:13:16" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:14:09" , 
"departure_time" : "18:15:39" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:16:30" , 
"departure_time" : "18:18:00" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:17:30" , 
"departure_time" : "18:17:56" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:18:26" , 
"departure_time" : "18:19:31" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:21:05" , 
"departure_time" : "18:22:07" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:23:02" , 
"departure_time" : "18:23:57" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:24:55" , 
"departure_time" : "18:25:07" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "18:28:12" , 
"departure_time" : "18:29:11" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "18:30:59" , 
"departure_time" : "18:30:59" , 
"distance_traveled" : 4.8619
} ], 
"3968" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "18:18:00" , 
"departure_time" : "18:19:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:19:59" , 
"departure_time" : "18:20:19" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:20:20" , 
"departure_time" : "18:21:39" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:23:19" , 
"departure_time" : "18:23:40" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:23:21" , 
"departure_time" : "18:24:56" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:25:35" , 
"departure_time" : "18:26:20" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:26:45" , 
"departure_time" : "18:27:31" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:28:46" , 
"departure_time" : "18:29:24" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:30:38" , 
"departure_time" : "18:31:32" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:32:54" , 
"departure_time" : "18:33:14" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "18:36:20" , 
"departure_time" : "18:36:48" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "18:38:28" , 
"departure_time" : "18:38:28" , 
"distance_traveled" : 4.8619
} ], 
"3969" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "18:31:00" , 
"departure_time" : "18:32:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:32:50" , 
"departure_time" : "18:33:12" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:33:22" , 
"departure_time" : "18:34:24" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:36:02" , 
"departure_time" : "18:37:18" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:37:16" , 
"departure_time" : "18:38:03" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:37:47" , 
"departure_time" : "18:38:29" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:39:42" , 
"departure_time" : "18:40:04" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:41:22" , 
"departure_time" : "18:41:41" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:43:19" , 
"departure_time" : "18:44:38" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:46:19" , 
"departure_time" : "18:46:34" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "18:49:15" , 
"departure_time" : "18:50:43" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "18:52:28" , 
"departure_time" : "18:52:28" , 
"distance_traveled" : 4.8619
} ], 
"3970" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "18:38:00" , 
"departure_time" : "18:41:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:40:35" , 
"departure_time" : "18:41:23" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:40:48" , 
"departure_time" : "18:41:44" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:42:56" , 
"departure_time" : "18:44:21" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:44:25" , 
"departure_time" : "18:45:09" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:44:44" , 
"departure_time" : "18:45:19" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:46:35" , 
"departure_time" : "18:47:15" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:48:40" , 
"departure_time" : "18:49:38" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:50:58" , 
"departure_time" : "18:52:14" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:53:16" , 
"departure_time" : "18:54:53" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "18:57:37" , 
"departure_time" : "18:59:00" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "18:59:23" , 
"departure_time" : "18:59:23" , 
"distance_traveled" : 4.8619
} ], 
"3971" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "18:41:00" , 
"departure_time" : "18:42:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:42:04" , 
"departure_time" : "18:43:10" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:44:06" , 
"departure_time" : "18:45:37" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:46:31" , 
"departure_time" : "18:47:13" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:46:42" , 
"departure_time" : "18:47:39" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:47:57" , 
"departure_time" : "18:49:18" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:50:21" , 
"departure_time" : "18:51:10" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:51:49" , 
"departure_time" : "18:52:49" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:54:00" , 
"departure_time" : "18:54:52" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "18:55:52" , 
"departure_time" : "18:56:27" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "18:59:35" , 
"departure_time" : "19:00:12" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "19:01:37" , 
"departure_time" : "19:01:37" , 
"distance_traveled" : 4.8619
} ], 
"3972" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "18:45:00" , 
"departure_time" : "18:45:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:46:07" , 
"departure_time" : "18:46:51" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:47:44" , 
"departure_time" : "18:49:08" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:50:24" , 
"departure_time" : "18:50:30" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:50:06" , 
"departure_time" : "18:50:09" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:51:03" , 
"departure_time" : "18:51:10" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "18:53:07" , 
"departure_time" : "18:54:38" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "18:56:31" , 
"departure_time" : "18:57:00" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "18:57:29" , 
"departure_time" : "18:58:47" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "19:00:18" , 
"departure_time" : "19:00:59" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "19:03:41" , 
"departure_time" : "19:03:58" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "19:05:17" , 
"departure_time" : "19:05:17" , 
"distance_traveled" : 4.8619
} ], 
"3973" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "18:51:00" , 
"departure_time" : "18:51:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:52:31" , 
"departure_time" : "18:53:56" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:54:25" , 
"departure_time" : "18:56:03" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:56:38" , 
"departure_time" : "18:57:08" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "18:56:30" , 
"departure_time" : "18:58:07" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "18:58:37" , 
"departure_time" : "18:59:54" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:00:17" , 
"departure_time" : "19:00:39" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:01:22" , 
"departure_time" : "19:02:38" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:04:16" , 
"departure_time" : "19:05:50" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "19:06:34" , 
"departure_time" : "19:06:40" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "19:09:06" , 
"departure_time" : "19:09:29" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "19:11:23" , 
"departure_time" : "19:11:23" , 
"distance_traveled" : 4.8619
} ], 
"3974" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "18:55:00" , 
"departure_time" : "18:56:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "18:57:21" , 
"departure_time" : "18:57:42" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "18:57:21" , 
"departure_time" : "18:57:27" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "18:59:06" , 
"departure_time" : "18:59:07" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "19:00:01" , 
"departure_time" : "19:00:44" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "19:01:43" , 
"departure_time" : "19:02:23" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:03:40" , 
"departure_time" : "19:03:43" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:05:03" , 
"departure_time" : "19:05:35" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:07:32" , 
"departure_time" : "19:08:14" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "19:09:42" , 
"departure_time" : "19:09:55" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "19:13:13" , 
"departure_time" : "19:14:36" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "19:16:23" , 
"departure_time" : "19:16:23" , 
"distance_traveled" : 4.8619
} ], 
"3975" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "18:59:00" , 
"departure_time" : "19:00:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "19:00:23" , 
"departure_time" : "19:01:55" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:02:32" , 
"departure_time" : "19:03:29" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "19:03:57" , 
"departure_time" : "19:04:36" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "19:04:39" , 
"departure_time" : "19:06:00" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "19:06:21" , 
"departure_time" : "19:07:09" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:07:48" , 
"departure_time" : "19:08:31" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:09:43" , 
"departure_time" : "19:10:13" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:11:30" , 
"departure_time" : "19:12:13" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "19:13:43" , 
"departure_time" : "19:15:13" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "19:18:30" , 
"departure_time" : "19:19:11" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "19:19:41" , 
"departure_time" : "19:19:41" , 
"distance_traveled" : 4.8619
} ], 
"3976" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "19:02:00" , 
"departure_time" : "19:03:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "19:03:53" , 
"departure_time" : "19:04:22" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:04:29" , 
"departure_time" : "19:04:55" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "19:06:26" , 
"departure_time" : "19:06:30" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "19:07:04" , 
"departure_time" : "19:07:11" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "19:08:07" , 
"departure_time" : "19:08:40" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:10:33" , 
"departure_time" : "19:10:55" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:12:22" , 
"departure_time" : "19:13:43" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:15:21" , 
"departure_time" : "19:15:30" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "19:16:09" , 
"departure_time" : "19:16:51" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "19:20:42" , 
"departure_time" : "19:22:19" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "19:23:37" , 
"departure_time" : "19:23:37" , 
"distance_traveled" : 4.8619
} ], 
"3977" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "19:11:00" , 
"departure_time" : "19:14:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "19:13:40" , 
"departure_time" : "19:14:55" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:14:15" , 
"departure_time" : "19:14:32" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "19:15:17" , 
"departure_time" : "19:16:46" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "19:17:29" , 
"departure_time" : "19:17:30" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "19:17:01" , 
"departure_time" : "19:17:53" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:19:52" , 
"departure_time" : "19:21:04" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:22:12" , 
"departure_time" : "19:22:25" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:23:13" , 
"departure_time" : "19:24:36" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "19:26:23" , 
"departure_time" : "19:27:32" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "19:30:09" , 
"departure_time" : "19:30:30" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "19:31:21" , 
"departure_time" : "19:31:21" , 
"distance_traveled" : 4.8619
} ], 
"3978" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "19:21:00" , 
"departure_time" : "19:21:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "19:22:02" , 
"departure_time" : "19:22:46" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:23:44" , 
"departure_time" : "19:25:15" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "19:26:31" , 
"departure_time" : "19:28:07" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "19:27:36" , 
"departure_time" : "19:28:03" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "19:27:27" , 
"departure_time" : "19:28:14" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:29:47" , 
"departure_time" : "19:31:26" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:32:39" , 
"departure_time" : "19:34:00" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:34:21" , 
"departure_time" : "19:35:07" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "19:35:46" , 
"departure_time" : "19:37:21" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "19:40:35" , 
"departure_time" : "19:40:38" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "19:41:03" , 
"departure_time" : "19:41:03" , 
"distance_traveled" : 4.8619
} ], 
"3979" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "19:35:00" , 
"departure_time" : "19:36:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "19:37:17" , 
"departure_time" : "19:38:38" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:38:21" , 
"departure_time" : "19:38:22" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "19:39:01" , 
"departure_time" : "19:40:19" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "19:41:18" , 
"departure_time" : "19:42:36" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "19:42:18" , 
"departure_time" : "19:42:38" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:43:20" , 
"departure_time" : "19:43:24" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:45:04" , 
"departure_time" : "19:45:58" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:47:54" , 
"departure_time" : "19:48:02" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "19:49:08" , 
"departure_time" : "19:50:20" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "19:54:12" , 
"departure_time" : "19:55:36" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "19:56:24" , 
"departure_time" : "19:56:24" , 
"distance_traveled" : 4.8619
} ], 
"3980" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "19:42:00" , 
"departure_time" : "19:44:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "19:44:28" , 
"departure_time" : "19:45:20" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:44:52" , 
"departure_time" : "19:46:09" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "19:47:17" , 
"departure_time" : "19:47:43" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "19:47:26" , 
"departure_time" : "19:48:18" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "19:48:52" , 
"departure_time" : "19:50:29" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:51:37" , 
"departure_time" : "19:52:17" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:52:40" , 
"departure_time" : "19:53:59" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "19:55:19" , 
"departure_time" : "19:56:56" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "19:57:37" , 
"departure_time" : "19:58:27" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "20:00:50" , 
"departure_time" : "20:02:07" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "20:03:17" , 
"departure_time" : "20:03:17" , 
"distance_traveled" : 4.8619
} ], 
"3981" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "19:49:00" , 
"departure_time" : "19:51:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "19:51:19" , 
"departure_time" : "19:51:21" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "19:51:02" , 
"departure_time" : "19:52:24" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "19:54:22" , 
"departure_time" : "19:54:31" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "19:54:09" , 
"departure_time" : "19:55:19" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "19:56:10" , 
"departure_time" : "19:56:20" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "19:57:10" , 
"departure_time" : "19:58:00" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "19:59:50" , 
"departure_time" : "19:59:51" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "20:01:01" , 
"departure_time" : "20:01:30" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "20:03:29" , 
"departure_time" : "20:04:48" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "20:08:19" , 
"departure_time" : "20:09:09" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "20:09:50" , 
"departure_time" : "20:09:50" , 
"distance_traveled" : 4.8619
} ], 
"3982" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "20:03:00" , 
"departure_time" : "20:04:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "20:04:56" , 
"departure_time" : "20:05:34" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "20:05:38" , 
"departure_time" : "20:06:40" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "20:08:02" , 
"departure_time" : "20:09:30" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "20:09:28" , 
"departure_time" : "20:11:00" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "20:10:32" , 
"departure_time" : "20:12:12" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "20:12:40" , 
"departure_time" : "20:13:43" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "20:14:03" , 
"departure_time" : "20:14:17" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "20:15:14" , 
"departure_time" : "20:16:39" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "20:18:25" , 
"departure_time" : "20:18:57" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "20:21:32" , 
"departure_time" : "20:22:01" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "20:23:29" , 
"departure_time" : "20:23:29" , 
"distance_traveled" : 4.8619
} ], 
"3983" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "20:11:00" , 
"departure_time" : "20:11:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "20:12:14" , 
"departure_time" : "20:13:33" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "20:14:19" , 
"departure_time" : "20:14:52" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "20:15:33" , 
"departure_time" : "20:16:17" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "20:16:44" , 
"departure_time" : "20:17:12" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "20:17:28" , 
"departure_time" : "20:17:38" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "20:19:10" , 
"departure_time" : "20:19:51" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "20:21:41" , 
"departure_time" : "20:23:02" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "20:24:21" , 
"departure_time" : "20:25:22" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "20:26:01" , 
"departure_time" : "20:26:37" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "20:29:36" , 
"departure_time" : "20:29:51" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "20:31:15" , 
"departure_time" : "20:31:15" , 
"distance_traveled" : 4.8619
} ], 
"3984" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "20:21:00" , 
"departure_time" : "20:22:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "20:22:47" , 
"departure_time" : "20:24:08" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "20:24:21" , 
"departure_time" : "20:25:52" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "20:26:31" , 
"departure_time" : "20:27:51" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "20:27:20" , 
"departure_time" : "20:27:30" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "20:27:10" , 
"departure_time" : "20:28:30" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "20:30:20" , 
"departure_time" : "20:31:46" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "20:32:26" , 
"departure_time" : "20:33:02" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "20:33:36" , 
"departure_time" : "20:34:40" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "20:36:04" , 
"departure_time" : "20:37:33" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "20:40:29" , 
"departure_time" : "20:41:45" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "20:42:16" , 
"departure_time" : "20:42:16" , 
"distance_traveled" : 4.8619
} ], 
"3985" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "20:31:00" , 
"departure_time" : "20:33:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "20:32:45" , 
"departure_time" : "20:33:13" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "20:33:28" , 
"departure_time" : "20:34:20" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "20:35:52" , 
"departure_time" : "20:36:07" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "20:36:15" , 
"departure_time" : "20:37:30" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "20:38:15" , 
"departure_time" : "20:38:56" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "20:39:41" , 
"departure_time" : "20:40:46" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "20:42:05" , 
"departure_time" : "20:42:49" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "20:43:44" , 
"departure_time" : "20:45:18" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "20:46:34" , 
"departure_time" : "20:47:22" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "20:49:48" , 
"departure_time" : "20:51:24" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "20:52:36" , 
"departure_time" : "20:52:36" , 
"distance_traveled" : 4.8619
} ], 
"3986" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "20:41:00" , 
"departure_time" : "20:43:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "20:42:49" , 
"departure_time" : "20:43:45" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "20:43:56" , 
"departure_time" : "20:44:50" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "20:45:54" , 
"departure_time" : "20:46:08" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "20:46:14" , 
"departure_time" : "20:47:11" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "20:47:57" , 
"departure_time" : "20:49:05" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "20:50:08" , 
"departure_time" : "20:50:55" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "20:51:47" , 
"departure_time" : "20:53:12" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "20:54:25" , 
"departure_time" : "20:55:19" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "20:55:54" , 
"departure_time" : "20:56:24" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "20:59:30" , 
"departure_time" : "21:00:23" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "21:01:53" , 
"departure_time" : "21:01:53" , 
"distance_traveled" : 4.8619
} ], 
"3987" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "21:01:00" , 
"departure_time" : "21:03:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "21:03:12" , 
"departure_time" : "21:04:14" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "21:04:02" , 
"departure_time" : "21:04:24" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "21:05:22" , 
"departure_time" : "21:05:55" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "21:06:33" , 
"departure_time" : "21:07:09" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "21:07:36" , 
"departure_time" : "21:08:55" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "21:10:19" , 
"departure_time" : "21:11:53" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "21:12:34" , 
"departure_time" : "21:12:36" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "21:13:02" , 
"departure_time" : "21:13:26" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "21:15:24" , 
"departure_time" : "21:16:38" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "21:20:14" , 
"departure_time" : "21:20:43" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "21:21:29" , 
"departure_time" : "21:21:29" , 
"distance_traveled" : 4.8619
} ], 
"3988" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "21:12:00" , 
"departure_time" : "21:13:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "21:14:07" , 
"departure_time" : "21:14:56" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "21:14:49" , 
"departure_time" : "21:15:06" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "21:16:17" , 
"departure_time" : "21:17:06" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "21:17:49" , 
"departure_time" : "21:18:29" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "21:18:40" , 
"departure_time" : "21:20:12" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "21:21:32" , 
"departure_time" : "21:22:39" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "21:23:07" , 
"departure_time" : "21:24:41" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "21:25:34" , 
"departure_time" : "21:27:03" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "21:27:29" , 
"departure_time" : "21:28:49" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "21:31:20" , 
"departure_time" : "21:31:44" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "21:32:24" , 
"departure_time" : "21:32:24" , 
"distance_traveled" : 4.8619
} ], 
"3989" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "21:21:00" , 
"departure_time" : "21:22:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "21:23:04" , 
"departure_time" : "21:23:05" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "21:23:01" , 
"departure_time" : "21:23:57" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "21:25:56" , 
"departure_time" : "21:26:26" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "21:26:30" , 
"departure_time" : "21:26:52" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "21:27:22" , 
"departure_time" : "21:28:29" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "21:30:07" , 
"departure_time" : "21:31:09" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "21:32:02" , 
"departure_time" : "21:32:26" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "21:33:24" , 
"departure_time" : "21:33:40" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "21:35:16" , 
"departure_time" : "21:36:05" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "21:39:49" , 
"departure_time" : "21:40:22" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "21:41:33" , 
"departure_time" : "21:41:33" , 
"distance_traveled" : 4.8619
} ], 
"3990" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "21:41:00" , 
"departure_time" : "21:42:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "21:43:17" , 
"departure_time" : "21:43:25" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "21:43:08" , 
"departure_time" : "21:44:01" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "21:45:53" , 
"departure_time" : "21:46:10" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "21:46:17" , 
"departure_time" : "21:47:34" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "21:48:17" , 
"departure_time" : "21:49:42" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "21:50:25" , 
"departure_time" : "21:52:02" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "21:52:37" , 
"departure_time" : "21:52:58" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "21:53:21" , 
"departure_time" : "21:53:38" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "21:55:17" , 
"departure_time" : "21:56:46" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "22:00:29" , 
"departure_time" : "22:00:36" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "22:01:07" , 
"departure_time" : "22:01:07" , 
"distance_traveled" : 4.8619
} ], 
"3991" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "22:00:00" , 
"departure_time" : "22:00:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "22:01:29" , 
"departure_time" : "22:01:50" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "22:02:21" , 
"departure_time" : "22:02:23" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "22:04:02" , 
"departure_time" : "22:05:26" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "22:06:24" , 
"departure_time" : "22:06:37" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "22:06:13" , 
"departure_time" : "22:07:01" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "22:08:48" , 
"departure_time" : "22:09:13" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "22:10:25" , 
"departure_time" : "22:10:48" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "22:12:23" , 
"departure_time" : "22:12:50" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "22:14:27" , 
"departure_time" : "22:15:30" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "22:19:03" , 
"departure_time" : "22:19:28" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "22:20:25" , 
"departure_time" : "22:20:25" , 
"distance_traveled" : 4.8619
} ], 
"3992" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "22:20:00" , 
"departure_time" : "22:20:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "22:21:32" , 
"departure_time" : "22:22:52" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "22:23:20" , 
"departure_time" : "22:24:37" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "22:25:17" , 
"departure_time" : "22:26:38" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "22:26:21" , 
"departure_time" : "22:26:45" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "22:26:24" , 
"departure_time" : "22:26:31" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "22:28:07" , 
"departure_time" : "22:28:41" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "22:30:34" , 
"departure_time" : "22:31:06" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "22:32:32" , 
"departure_time" : "22:33:54" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "22:35:22" , 
"departure_time" : "22:36:27" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "22:39:05" , 
"departure_time" : "22:40:11" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "22:41:06" , 
"departure_time" : "22:41:06" , 
"distance_traveled" : 4.8619
} ], 
"3993" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "22:40:00" , 
"departure_time" : "22:41:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "22:41:18" , 
"departure_time" : "22:41:21" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "22:42:03" , 
"departure_time" : "22:43:43" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "22:45:40" , 
"departure_time" : "22:45:51" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "22:45:11" , 
"departure_time" : "22:45:57" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "22:46:46" , 
"departure_time" : "22:48:07" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "22:49:21" , 
"departure_time" : "22:49:26" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "22:50:05" , 
"departure_time" : "22:51:21" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "22:53:16" , 
"departure_time" : "22:54:16" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "22:55:00" , 
"departure_time" : "22:56:18" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "22:59:18" , 
"departure_time" : "23:00:39" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "23:01:21" , 
"departure_time" : "23:01:21" , 
"distance_traveled" : 4.8619
} ], 
"3994" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "23:01:00" , 
"departure_time" : "23:03:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "23:03:25" , 
"departure_time" : "23:05:00" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "23:04:35" , 
"departure_time" : "23:05:20" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "23:05:45" , 
"departure_time" : "23:06:56" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "23:07:11" , 
"departure_time" : "23:07:48" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "23:07:37" , 
"departure_time" : "23:08:40" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "23:10:03" , 
"departure_time" : "23:11:42" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "23:12:39" , 
"departure_time" : "23:12:55" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "23:13:16" , 
"departure_time" : "23:14:40" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "23:16:24" , 
"departure_time" : "23:17:55" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "23:20:31" , 
"departure_time" : "23:20:44" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "23:21:13" , 
"departure_time" : "23:21:13" , 
"distance_traveled" : 4.8619
} ], 
"3995" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "23:30:00" , 
"departure_time" : "23:31:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "23:32:01" , 
"departure_time" : "23:32:51" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "23:32:50" , 
"departure_time" : "23:33:28" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "23:34:38" , 
"departure_time" : "23:34:50" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "23:35:12" , 
"departure_time" : "23:36:23" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "23:37:11" , 
"departure_time" : "23:37:25" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "23:38:14" , 
"departure_time" : "23:39:34" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "23:41:20" , 
"departure_time" : "23:41:24" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "23:42:04" , 
"departure_time" : "23:42:28" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "23:44:24" , 
"departure_time" : "23:45:33" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "23:49:09" , 
"departure_time" : "23:50:02" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "23:50:53" , 
"departure_time" : "23:50:53" , 
"distance_traveled" : 4.8619
} ], 
"3996" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "23:56:00" , 
"departure_time" : "23:57:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "23:57:54" , 
"departure_time" : "23:58:19" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "23:58:25" , 
"departure_time" : "23:59:36" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "24:01:11" , 
"departure_time" : "24:02:02" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "24:01:51" , 
"departure_time" : "24:01:52" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "24:02:01" , 
"departure_time" : "24:02:23" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "24:04:22" , 
"departure_time" : "24:05:19" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "24:06:57" , 
"departure_time" : "24:07:01" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "24:08:04" , 
"departure_time" : "24:09:33" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "24:11:29" , 
"departure_time" : "24:13:04" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "24:15:35" , 
"departure_time" : "24:16:59" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "24:17:24" , 
"departure_time" : "24:17:24" , 
"distance_traveled" : 4.8619
} ], 
"3997" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "24:20:00" , 
"departure_time" : "24:21:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "24:21:06" , 
"departure_time" : "24:22:13" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "24:23:07" , 
"departure_time" : "24:23:10" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "24:24:03" , 
"departure_time" : "24:24:59" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "24:25:56" , 
"departure_time" : "24:26:52" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "24:26:56" , 
"departure_time" : "24:27:20" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "24:28:24" , 
"departure_time" : "24:28:40" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "24:30:16" , 
"departure_time" : "24:30:44" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "24:32:28" , 
"departure_time" : "24:33:47" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "24:35:19" , 
"departure_time" : "24:35:44" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "24:38:25" , 
"departure_time" : "24:38:35" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "24:40:10" , 
"departure_time" : "24:40:10" , 
"distance_traveled" : 4.8619
} ], 
"3998" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "25:15:00" , 
"departure_time" : "25:15:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "25:16:47" , 
"departure_time" : "25:16:53" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "25:17:06" , 
"departure_time" : "25:18:21" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "25:20:15" , 
"departure_time" : "25:20:16" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "25:20:01" , 
"departure_time" : "25:20:46" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "25:21:45" , 
"departure_time" : "25:22:30" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "25:23:45" , 
"departure_time" : "25:24:56" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "25:26:11" , 
"departure_time" : "25:27:27" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "25:28:16" , 
"departure_time" : "25:29:22" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "25:30:06" , 
"departure_time" : "25:31:14" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "25:34:08" , 
"departure_time" : "25:34:34" , 
"distance_traveled" : 4.4655
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "25:35:26" , 
"departure_time" : "25:35:26" , 
"distance_traveled" : 4.8619
} ], 
"3999" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "09:14:00" , 
"departure_time" : "09:15:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:16:04" , 
"departure_time" : "09:16:53" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:16:49" , 
"departure_time" : "09:18:11" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:19:22" , 
"departure_time" : "09:20:37" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:20:15" , 
"departure_time" : "09:21:52" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:21:37" , 
"departure_time" : "09:22:35" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:22:58" , 
"departure_time" : "09:24:16" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:25:18" , 
"departure_time" : "09:26:05" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:26:47" , 
"departure_time" : "09:27:20" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:28:33" , 
"departure_time" : "09:29:34" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "09:33:01" , 
"departure_time" : "09:33:01" , 
"distance_traveled" : 4.4655
} ], 
"4000" :  [ 
{ 
"stop_id" : 26326,
"arrival_time" : "09:19:00" , 
"departure_time" : "09:21:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:21:29" , 
"departure_time" : "09:22:56" , 
"distance_traveled" : 0.4282
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:22:27" , 
"departure_time" : "09:22:50" , 
"distance_traveled" : 0.6085
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:23:23" , 
"departure_time" : "09:24:53" , 
"distance_traveled" : 1.133
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:25:30" , 
"departure_time" : "09:26:39" , 
"distance_traveled" : 1.3936
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:26:09" , 
"departure_time" : "09:26:49" , 
"distance_traveled" : 1.8617
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:27:40" , 
"departure_time" : "09:29:18" , 
"distance_traveled" : 2.4354
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:30:38" , 
"departure_time" : "09:32:06" , 
"distance_traveled" : 2.9847
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:32:28" , 
"departure_time" : "09:33:01" , 
"distance_traveled" : 3.4958
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:33:33" , 
"departure_time" : "09:34:57" , 
"distance_traveled" : 4.0409
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "09:38:24" , 
"departure_time" : "09:38:24" , 
"distance_traveled" : 4.4655
} ], 
"4001" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "05:30:00" , 
"departure_time" : "05:31:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "05:33:22" , 
"departure_time" : "05:33:31" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "05:36:09" , 
"departure_time" : "05:36:48" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "05:39:39" , 
"departure_time" : "05:39:39" , 
"distance_traveled" : 1.2125
} ], 
"4002" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "05:55:00" , 
"departure_time" : "05:56:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "05:59:08" , 
"departure_time" : "05:59:35" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "06:01:27" , 
"departure_time" : "06:02:25" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "06:04:58" , 
"departure_time" : "06:04:58" , 
"distance_traveled" : 1.2125
} ], 
"4003" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "06:20:00" , 
"departure_time" : "06:21:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "06:23:34" , 
"departure_time" : "06:24:18" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "06:26:44" , 
"departure_time" : "06:28:05" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "06:30:21" , 
"departure_time" : "06:30:21" , 
"distance_traveled" : 1.2125
} ], 
"4004" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "06:45:00" , 
"departure_time" : "06:47:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "06:48:59" , 
"departure_time" : "06:49:38" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "06:51:39" , 
"departure_time" : "06:53:09" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "06:55:30" , 
"departure_time" : "06:55:30" , 
"distance_traveled" : 1.2125
} ], 
"4005" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "06:55:00" , 
"departure_time" : "06:56:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "06:58:05" , 
"departure_time" : "06:58:54" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "07:01:49" , 
"departure_time" : "07:01:59" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:04:10" , 
"departure_time" : "07:04:10" , 
"distance_traveled" : 1.2125
} ], 
"4006" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "07:05:00" , 
"departure_time" : "07:05:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "07:08:01" , 
"departure_time" : "07:09:40" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "07:12:39" , 
"departure_time" : "07:13:19" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:14:40" , 
"departure_time" : "07:14:40" , 
"distance_traveled" : 1.2125
} ], 
"4007" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "07:15:00" , 
"departure_time" : "07:16:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "07:18:37" , 
"departure_time" : "07:19:29" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "07:21:52" , 
"departure_time" : "07:22:56" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:25:04" , 
"departure_time" : "07:25:04" , 
"distance_traveled" : 1.2125
} ], 
"4008" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "07:25:00" , 
"departure_time" : "07:26:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "07:28:20" , 
"departure_time" : "07:28:53" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "07:31:33" , 
"departure_time" : "07:31:43" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:34:10" , 
"departure_time" : "07:34:10" , 
"distance_traveled" : 1.2125
} ], 
"4009" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "07:35:00" , 
"departure_time" : "07:35:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "07:38:05" , 
"departure_time" : "07:39:03" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "07:41:58" , 
"departure_time" : "07:41:59" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:44:01" , 
"departure_time" : "07:44:01" , 
"distance_traveled" : 1.2125
} ], 
"4010" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "07:45:00" , 
"departure_time" : "07:45:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "07:48:55" , 
"departure_time" : "07:50:16" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "07:52:21" , 
"departure_time" : "07:52:37" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "07:54:16" , 
"departure_time" : "07:54:16" , 
"distance_traveled" : 1.2125
} ], 
"4011" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "07:55:00" , 
"departure_time" : "07:56:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "07:59:04" , 
"departure_time" : "08:00:32" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "08:02:28" , 
"departure_time" : "08:02:44" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:04:16" , 
"departure_time" : "08:04:16" , 
"distance_traveled" : 1.2125
} ], 
"4012" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "08:05:00" , 
"departure_time" : "08:05:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "08:08:10" , 
"departure_time" : "08:09:08" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "08:11:58" , 
"departure_time" : "08:13:19" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:15:21" , 
"departure_time" : "08:15:21" , 
"distance_traveled" : 1.2125
} ], 
"4013" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "08:15:00" , 
"departure_time" : "08:17:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "08:19:05" , 
"departure_time" : "08:19:55" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "08:21:50" , 
"departure_time" : "08:22:45" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:24:55" , 
"departure_time" : "08:24:55" , 
"distance_traveled" : 1.2125
} ], 
"4014" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "08:25:00" , 
"departure_time" : "08:26:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "08:28:29" , 
"departure_time" : "08:28:42" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "08:31:13" , 
"departure_time" : "08:31:21" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:34:08" , 
"departure_time" : "08:34:08" , 
"distance_traveled" : 1.2125
} ], 
"4015" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "08:35:00" , 
"departure_time" : "08:35:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "08:38:37" , 
"departure_time" : "08:40:11" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "08:42:34" , 
"departure_time" : "08:43:09" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:44:35" , 
"departure_time" : "08:44:35" , 
"distance_traveled" : 1.2125
} ], 
"4016" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "08:45:00" , 
"departure_time" : "08:46:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "08:49:10" , 
"departure_time" : "08:50:48" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "08:52:38" , 
"departure_time" : "08:53:43" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "08:55:05" , 
"departure_time" : "08:55:05" , 
"distance_traveled" : 1.2125
} ], 
"4017" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "08:55:00" , 
"departure_time" : "08:57:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "08:59:27" , 
"departure_time" : "09:00:48" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "09:02:21" , 
"departure_time" : "09:03:26" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "09:05:05" , 
"departure_time" : "09:05:05" , 
"distance_traveled" : 1.2125
} ], 
"4018" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "09:05:00" , 
"departure_time" : "09:07:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "09:09:30" , 
"departure_time" : "09:10:25" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "09:11:55" , 
"departure_time" : "09:13:19" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "09:15:24" , 
"departure_time" : "09:15:24" , 
"distance_traveled" : 1.2125
} ], 
"4019" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "09:15:00" , 
"departure_time" : "09:16:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "09:18:24" , 
"departure_time" : "09:18:57" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "09:21:33" , 
"departure_time" : "09:21:41" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "09:24:08" , 
"departure_time" : "09:24:08" , 
"distance_traveled" : 1.2125
} ], 
"4020" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "09:49:00" , 
"departure_time" : "09:50:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "09:52:58" , 
"departure_time" : "09:54:27" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "09:56:29" , 
"departure_time" : "09:56:34" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "09:58:05" , 
"departure_time" : "09:58:05" , 
"distance_traveled" : 1.2125
} ], 
"4021" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "10:23:00" , 
"departure_time" : "10:24:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "10:27:02" , 
"departure_time" : "10:27:49" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "10:29:47" , 
"departure_time" : "10:31:13" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "10:33:26" , 
"departure_time" : "10:33:26" , 
"distance_traveled" : 1.2125
} ], 
"4022" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "10:51:00" , 
"departure_time" : "10:53:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "10:54:49" , 
"departure_time" : "10:55:57" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "10:58:08" , 
"departure_time" : "10:58:36" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "11:00:28" , 
"departure_time" : "11:00:28" , 
"distance_traveled" : 1.2125
} ], 
"4023" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "11:21:00" , 
"departure_time" : "11:21:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "11:24:28" , 
"departure_time" : "11:24:53" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "11:27:25" , 
"departure_time" : "11:29:00" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "11:31:35" , 
"departure_time" : "11:31:35" , 
"distance_traveled" : 1.2125
} ], 
"4024" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "11:51:00" , 
"departure_time" : "11:54:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "11:55:36" , 
"departure_time" : "11:56:56" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "11:58:20" , 
"departure_time" : "11:58:51" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "12:00:31" , 
"departure_time" : "12:00:31" , 
"distance_traveled" : 1.2125
} ], 
"4025" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "12:21:00" , 
"departure_time" : "12:21:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "12:24:05" , 
"departure_time" : "12:25:18" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "12:28:13" , 
"departure_time" : "12:29:34" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "12:31:21" , 
"departure_time" : "12:31:21" , 
"distance_traveled" : 1.2125
} ], 
"4026" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "12:51:00" , 
"departure_time" : "12:52:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "12:54:13" , 
"departure_time" : "12:54:33" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "12:57:20" , 
"departure_time" : "12:58:08" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "13:00:48" , 
"departure_time" : "13:00:48" , 
"distance_traveled" : 1.2125
} ], 
"4027" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "13:21:00" , 
"departure_time" : "13:23:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "13:25:21" , 
"departure_time" : "13:26:11" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "13:27:50" , 
"departure_time" : "13:29:16" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "13:31:26" , 
"departure_time" : "13:31:26" , 
"distance_traveled" : 1.2125
} ], 
"4028" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "13:51:00" , 
"departure_time" : "13:53:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "13:54:39" , 
"departure_time" : "13:55:12" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "13:57:33" , 
"departure_time" : "13:59:11" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "14:01:38" , 
"departure_time" : "14:01:38" , 
"distance_traveled" : 1.2125
} ], 
"4029" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "14:21:00" , 
"departure_time" : "14:24:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "14:25:35" , 
"departure_time" : "14:26:34" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "14:27:59" , 
"departure_time" : "14:28:34" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "14:30:35" , 
"departure_time" : "14:30:35" , 
"distance_traveled" : 1.2125
} ], 
"4030" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "14:51:00" , 
"departure_time" : "14:53:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "14:55:33" , 
"departure_time" : "14:56:28" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "14:57:55" , 
"departure_time" : "14:59:20" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "15:01:25" , 
"departure_time" : "15:01:25" , 
"distance_traveled" : 1.2125
} ], 
"4031" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "15:16:00" , 
"departure_time" : "15:18:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "15:19:49" , 
"departure_time" : "15:20:35" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "15:22:46" , 
"departure_time" : "15:22:48" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "15:25:02" , 
"departure_time" : "15:25:02" , 
"distance_traveled" : 1.2125
} ], 
"4032" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "15:50:00" , 
"departure_time" : "15:50:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "15:53:34" , 
"departure_time" : "15:53:55" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "15:56:21" , 
"departure_time" : "15:56:49" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "15:59:28" , 
"departure_time" : "15:59:28" , 
"distance_traveled" : 1.2125
} ], 
"4033" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "16:00:00" , 
"departure_time" : "16:00:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "16:03:11" , 
"departure_time" : "16:04:14" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "16:07:03" , 
"departure_time" : "16:07:29" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:09:26" , 
"departure_time" : "16:09:26" , 
"distance_traveled" : 1.2125
} ], 
"4034" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "16:10:00" , 
"departure_time" : "16:11:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "16:14:07" , 
"departure_time" : "16:15:08" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "16:17:01" , 
"departure_time" : "16:17:52" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:19:51" , 
"departure_time" : "16:19:51" , 
"distance_traveled" : 1.2125
} ], 
"4035" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "16:20:00" , 
"departure_time" : "16:22:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "16:24:40" , 
"departure_time" : "16:25:51" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "16:27:11" , 
"departure_time" : "16:28:01" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:29:50" , 
"departure_time" : "16:29:50" , 
"distance_traveled" : 1.2125
} ], 
"4036" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "16:30:00" , 
"departure_time" : "16:32:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "16:34:29" , 
"departure_time" : "16:35:04" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "16:36:35" , 
"departure_time" : "16:37:37" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:40:02" , 
"departure_time" : "16:40:02" , 
"distance_traveled" : 1.2125
} ], 
"4037" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "16:40:00" , 
"departure_time" : "16:42:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "16:44:06" , 
"departure_time" : "16:44:41" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "16:46:35" , 
"departure_time" : "16:47:43" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:50:08" , 
"departure_time" : "16:50:08" , 
"distance_traveled" : 1.2125
} ], 
"4038" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "16:50:00" , 
"departure_time" : "16:52:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "16:54:09" , 
"departure_time" : "16:54:53" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "16:56:44" , 
"departure_time" : "16:57:15" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "16:59:31" , 
"departure_time" : "16:59:31" , 
"distance_traveled" : 1.2125
} ], 
"4039" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "17:00:00" , 
"departure_time" : "17:01:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "17:03:47" , 
"departure_time" : "17:05:26" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "17:07:39" , 
"departure_time" : "17:07:50" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "17:09:11" , 
"departure_time" : "17:09:11" , 
"distance_traveled" : 1.2125
} ], 
"4040" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "17:10:00" , 
"departure_time" : "17:11:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "17:14:15" , 
"departure_time" : "17:14:20" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "17:16:05" , 
"departure_time" : "17:17:09" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "17:20:04" , 
"departure_time" : "17:20:04" , 
"distance_traveled" : 1.2125
} ], 
"4041" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "17:20:00" , 
"departure_time" : "17:21:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "17:23:04" , 
"departure_time" : "17:24:16" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "17:27:12" , 
"departure_time" : "17:28:20" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "17:30:08" , 
"departure_time" : "17:30:08" , 
"distance_traveled" : 1.2125
} ], 
"4042" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "17:30:00" , 
"departure_time" : "17:31:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "17:33:23" , 
"departure_time" : "17:34:29" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "17:37:06" , 
"departure_time" : "17:37:43" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "17:39:37" , 
"departure_time" : "17:39:37" , 
"distance_traveled" : 1.2125
} ], 
"4043" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "17:40:00" , 
"departure_time" : "17:41:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "17:44:01" , 
"departure_time" : "17:44:30" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "17:46:29" , 
"departure_time" : "17:48:03" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "17:50:34" , 
"departure_time" : "17:50:34" , 
"distance_traveled" : 1.2125
} ], 
"4044" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "17:50:00" , 
"departure_time" : "17:52:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "17:53:47" , 
"departure_time" : "17:54:49" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "17:57:02" , 
"departure_time" : "17:58:15" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:00:13" , 
"departure_time" : "18:00:13" , 
"distance_traveled" : 1.2125
} ], 
"4045" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "18:00:00" , 
"departure_time" : "18:02:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "18:03:53" , 
"departure_time" : "18:04:59" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "18:07:06" , 
"departure_time" : "18:08:19" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:10:13" , 
"departure_time" : "18:10:13" , 
"distance_traveled" : 1.2125
} ], 
"4046" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "18:10:00" , 
"departure_time" : "18:12:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "18:14:32" , 
"departure_time" : "18:15:24" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "18:16:52" , 
"departure_time" : "18:17:04" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:19:12" , 
"departure_time" : "18:19:12" , 
"distance_traveled" : 1.2125
} ], 
"4047" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "18:20:00" , 
"departure_time" : "18:21:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "18:24:37" , 
"departure_time" : "18:26:00" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "18:27:23" , 
"departure_time" : "18:28:38" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:30:15" , 
"departure_time" : "18:30:15" , 
"distance_traveled" : 1.2125
} ], 
"4048" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "18:30:00" , 
"departure_time" : "18:32:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "18:33:56" , 
"departure_time" : "18:34:28" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "18:36:32" , 
"departure_time" : "18:37:55" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:40:23" , 
"departure_time" : "18:40:23" , 
"distance_traveled" : 1.2125
} ], 
"4049" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "18:40:00" , 
"departure_time" : "18:42:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "18:44:15" , 
"departure_time" : "18:44:57" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "18:46:42" , 
"departure_time" : "18:46:55" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:49:13" , 
"departure_time" : "18:49:13" , 
"distance_traveled" : 1.2125
} ], 
"4050" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "18:50:00" , 
"departure_time" : "18:50:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "18:53:16" , 
"departure_time" : "18:54:41" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "18:57:25" , 
"departure_time" : "18:57:51" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "18:59:26" , 
"departure_time" : "18:59:26" , 
"distance_traveled" : 1.2125
} ], 
"4051" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "19:00:00" , 
"departure_time" : "19:01:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "19:04:26" , 
"departure_time" : "19:05:00" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "19:06:34" , 
"departure_time" : "19:08:13" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "19:10:39" , 
"departure_time" : "19:10:39" , 
"distance_traveled" : 1.2125
} ], 
"4052" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "19:10:00" , 
"departure_time" : "19:12:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "19:13:59" , 
"departure_time" : "19:15:01" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "19:17:02" , 
"departure_time" : "19:17:06" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "19:19:04" , 
"departure_time" : "19:19:04" , 
"distance_traveled" : 1.2125
} ], 
"4053" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "19:20:00" , 
"departure_time" : "19:21:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "19:24:06" , 
"departure_time" : "19:24:24" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "19:26:18" , 
"departure_time" : "19:26:53" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "19:29:35" , 
"departure_time" : "19:29:35" , 
"distance_traveled" : 1.2125
} ], 
"4054" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "19:30:00" , 
"departure_time" : "19:31:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "19:33:28" , 
"departure_time" : "19:35:01" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "19:37:33" , 
"departure_time" : "19:38:21" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "19:39:48" , 
"departure_time" : "19:39:48" , 
"distance_traveled" : 1.2125
} ], 
"4055" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "19:40:00" , 
"departure_time" : "19:41:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "19:43:41" , 
"departure_time" : "19:44:30" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "19:46:49" , 
"departure_time" : "19:47:48" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "19:49:59" , 
"departure_time" : "19:49:59" , 
"distance_traveled" : 1.2125
} ], 
"4056" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "19:50:00" , 
"departure_time" : "19:52:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "19:54:14" , 
"departure_time" : "19:54:56" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "19:56:42" , 
"departure_time" : "19:56:59" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "19:59:17" , 
"departure_time" : "19:59:17" , 
"distance_traveled" : 1.2125
} ], 
"4057" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "20:17:00" , 
"departure_time" : "20:17:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "20:20:29" , 
"departure_time" : "20:22:04" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "20:24:35" , 
"departure_time" : "20:24:38" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "20:26:03" , 
"departure_time" : "20:26:03" , 
"distance_traveled" : 1.2125
} ], 
"4058" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "20:45:00" , 
"departure_time" : "20:46:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "20:49:30" , 
"departure_time" : "20:50:04" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "20:51:34" , 
"departure_time" : "20:51:47" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "20:54:13" , 
"departure_time" : "20:54:13" , 
"distance_traveled" : 1.2125
} ], 
"4059" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "21:15:00" , 
"departure_time" : "21:15:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "21:18:05" , 
"departure_time" : "21:18:26" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "21:21:21" , 
"departure_time" : "21:22:18" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "21:24:57" , 
"departure_time" : "21:24:57" , 
"distance_traveled" : 1.2125
} ], 
"4060" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "21:46:00" , 
"departure_time" : "21:47:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "21:49:42" , 
"departure_time" : "21:50:41" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "21:52:59" , 
"departure_time" : "21:54:15" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "21:56:16" , 
"departure_time" : "21:56:16" , 
"distance_traveled" : 1.2125
} ], 
"4061" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "22:14:00" , 
"departure_time" : "22:15:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "22:17:31" , 
"departure_time" : "22:19:07" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "22:21:36" , 
"departure_time" : "22:22:33" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "22:23:57" , 
"departure_time" : "22:23:57" , 
"distance_traveled" : 1.2125
} ], 
"4062" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "22:46:00" , 
"departure_time" : "22:47:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "22:49:27" , 
"departure_time" : "22:49:53" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "22:52:26" , 
"departure_time" : "22:52:39" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "22:55:13" , 
"departure_time" : "22:55:13" , 
"distance_traveled" : 1.2125
} ], 
"4063" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "23:14:00" , 
"departure_time" : "23:14:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "23:17:14" , 
"departure_time" : "23:17:51" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "23:20:37" , 
"departure_time" : "23:20:40" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "23:23:03" , 
"departure_time" : "23:23:03" , 
"distance_traveled" : 1.2125
} ], 
"4064" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "23:44:00" , 
"departure_time" : "23:45:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "23:48:30" , 
"departure_time" : "23:49:56" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "23:51:26" , 
"departure_time" : "23:51:56" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "23:53:30" , 
"departure_time" : "23:53:30" , 
"distance_traveled" : 1.2125
} ], 
"4065" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "09:25:00" , 
"departure_time" : "09:25:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "09:28:29" , 
"departure_time" : "09:29:47" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "09:32:18" , 
"departure_time" : "09:33:40" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "09:35:22" , 
"departure_time" : "09:36:39" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "09:38:17" , 
"departure_time" : "09:39:26" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:39:09" , 
"departure_time" : "09:40:08" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:39:59" , 
"departure_time" : "09:41:16" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:42:17" , 
"departure_time" : "09:43:08" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:42:51" , 
"departure_time" : "09:43:48" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:43:57" , 
"departure_time" : "09:45:17" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:46:20" , 
"departure_time" : "09:46:38" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:47:18" , 
"departure_time" : "09:47:53" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "09:49:35" , 
"departure_time" : "09:50:31" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "09:51:56" , 
"departure_time" : "09:52:16" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "09:55:20" , 
"departure_time" : "09:55:52" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "09:57:32" , 
"departure_time" : "09:57:32" , 
"distance_traveled" : 6.0843
} ], 
"4066" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "09:35:00" , 
"departure_time" : "09:36:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "09:39:01" , 
"departure_time" : "09:39:56" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "09:41:55" , 
"departure_time" : "09:42:18" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "09:44:23" , 
"departure_time" : "09:45:13" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "09:47:50" , 
"departure_time" : "09:49:10" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "09:49:20" , 
"departure_time" : "09:50:18" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "09:49:58" , 
"departure_time" : "09:51:35" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "09:52:37" , 
"departure_time" : "09:53:56" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "09:53:19" , 
"departure_time" : "09:54:41" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "09:54:22" , 
"departure_time" : "09:54:56" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "09:55:34" , 
"departure_time" : "09:56:02" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "09:57:28" , 
"departure_time" : "09:58:46" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "10:00:18" , 
"departure_time" : "10:01:22" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "10:02:04" , 
"departure_time" : "10:03:33" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "10:06:29" , 
"departure_time" : "10:08:03" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "10:08:34" , 
"departure_time" : "10:08:34" , 
"distance_traveled" : 6.0843
} ], 
"4067" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "20:00:00" , 
"departure_time" : "20:01:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "20:03:19" , 
"departure_time" : "20:04:30" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "20:07:11" , 
"departure_time" : "20:08:16" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "20:10:05" , 
"departure_time" : "20:10:51" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "20:12:46" , 
"departure_time" : "20:13:32" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "20:13:46" , 
"departure_time" : "20:15:08" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "20:15:22" , 
"departure_time" : "20:16:34" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "20:17:12" , 
"departure_time" : "20:18:50" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "20:18:38" , 
"departure_time" : "20:19:07" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "20:18:29" , 
"departure_time" : "20:18:40" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "20:20:11" , 
"departure_time" : "20:20:38" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "20:22:27" , 
"departure_time" : "20:22:40" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "20:24:13" , 
"departure_time" : "20:25:46" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "20:27:33" , 
"departure_time" : "20:28:01" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "20:30:28" , 
"departure_time" : "20:30:50" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "20:32:22" , 
"departure_time" : "20:32:22" , 
"distance_traveled" : 6.0843
} ], 
"4068" :  [ 
{ 
"stop_id" : 39130,
"arrival_time" : "20:10:00" , 
"departure_time" : "20:10:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 39132,
"arrival_time" : "20:13:11" , 
"departure_time" : "20:14:41" , 
"distance_traveled" : 0.2797
}, 
{ 
"stop_id" : 39134,
"arrival_time" : "20:17:30" , 
"departure_time" : "20:18:17" , 
"distance_traveled" : 0.7193
}, 
{ 
"stop_id" : 42545,
"arrival_time" : "20:19:47" , 
"departure_time" : "20:21:10" , 
"distance_traveled" : 1.2125
}, 
{ 
"stop_id" : 26326,
"arrival_time" : "20:23:23" , 
"departure_time" : "20:24:45" , 
"distance_traveled" : 1.2223
}, 
{ 
"stop_id" : 6900,
"arrival_time" : "20:24:22" , 
"departure_time" : "20:24:51" , 
"distance_traveled" : 1.6506
}, 
{ 
"stop_id" : 6997,
"arrival_time" : "20:24:29" , 
"departure_time" : "20:25:15" , 
"distance_traveled" : 1.8309
}, 
{ 
"stop_id" : 6995,
"arrival_time" : "20:26:46" , 
"departure_time" : "20:28:17" , 
"distance_traveled" : 2.3553
}, 
{ 
"stop_id" : 6957,
"arrival_time" : "20:28:31" , 
"departure_time" : "20:28:52" , 
"distance_traveled" : 2.6159
}, 
{ 
"stop_id" : 14986,
"arrival_time" : "20:28:21" , 
"departure_time" : "20:28:39" , 
"distance_traveled" : 3.0841
}, 
{ 
"stop_id" : 6966,
"arrival_time" : "20:30:18" , 
"departure_time" : "20:30:26" , 
"distance_traveled" : 3.6578
}, 
{ 
"stop_id" : 14984,
"arrival_time" : "20:32:08" , 
"departure_time" : "20:33:07" , 
"distance_traveled" : 4.207
}, 
{ 
"stop_id" : 6907,
"arrival_time" : "20:34:59" , 
"departure_time" : "20:35:58" , 
"distance_traveled" : 4.7182
}, 
{ 
"stop_id" : 26316,
"arrival_time" : "20:36:59" , 
"departure_time" : "20:37:57" , 
"distance_traveled" : 5.2633
}, 
{ 
"stop_id" : 38064,
"arrival_time" : "20:40:58" , 
"departure_time" : "20:41:02" , 
"distance_traveled" : 5.6879
}, 
{ 
"stop_id" : 38065,
"arrival_time" : "20:42:04" , 
"departure_time" : "20:42:04" , 
"distance_traveled" : 6.0843
} ], 
"4069" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "18:08:00" , 
"departure_time" : "18:08:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "18:13:04" , 
"departure_time" : "18:13:58" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "18:22:54" , 
"departure_time" : "18:23:55" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "18:26:01" , 
"departure_time" : "18:26:11" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "18:27:10" , 
"departure_time" : "18:27:14" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 62,
"arrival_time" : "18:31:04" , 
"departure_time" : "18:32:38" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "18:35:34" , 
"departure_time" : "18:36:05" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "18:37:31" , 
"departure_time" : "18:37:41" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "18:41:10" , 
"departure_time" : "18:42:09" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "18:44:59" , 
"departure_time" : "18:46:12" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "18:49:13" , 
"departure_time" : "18:49:52" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "18:56:39" , 
"departure_time" : "18:56:45" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "18:59:06" , 
"departure_time" : "19:00:27" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 160,
"arrival_time" : "19:05:21" , 
"departure_time" : "19:06:28" , 
"distance_traveled" : 20.8428
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:15:07" , 
"departure_time" : "19:16:02" , 
"distance_traveled" : 27.2042
}, 
{ 
"stop_id" : 63,
"arrival_time" : "19:26:55" , 
"departure_time" : "19:26:55" , 
"distance_traveled" : 30.764
} ], 
"4070" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "18:08:00" , 
"departure_time" : "18:09:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "18:13:41" , 
"departure_time" : "18:14:14" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "18:22:33" , 
"departure_time" : "18:23:50" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "18:26:17" , 
"departure_time" : "18:27:36" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "18:28:19" , 
"departure_time" : "18:29:36" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 62,
"arrival_time" : "18:32:17" , 
"departure_time" : "18:33:09" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "18:34:52" , 
"departure_time" : "18:35:35" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "18:37:43" , 
"departure_time" : "18:38:39" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "18:41:56" , 
"departure_time" : "18:43:25" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "18:45:29" , 
"departure_time" : "18:46:05" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "18:48:36" , 
"departure_time" : "18:49:59" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "18:57:23" , 
"departure_time" : "18:57:41" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "18:59:18" , 
"departure_time" : "18:59:50" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 160,
"arrival_time" : "19:04:32" , 
"departure_time" : "19:05:40" , 
"distance_traveled" : 20.8428
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:15:08" , 
"departure_time" : "19:16:36" , 
"distance_traveled" : 27.2042
}, 
{ 
"stop_id" : 63,
"arrival_time" : "19:27:28" , 
"departure_time" : "19:27:28" , 
"distance_traveled" : 30.764
} ], 
"4071" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "19:16:00" , 
"departure_time" : "19:18:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "19:22:00" , 
"departure_time" : "19:23:34" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "19:31:34" , 
"departure_time" : "19:31:37" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "19:33:03" , 
"departure_time" : "19:34:25" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "19:36:22" , 
"departure_time" : "19:36:36" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 62,
"arrival_time" : "19:39:14" , 
"departure_time" : "19:40:07" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "19:42:53" , 
"departure_time" : "19:42:59" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "19:45:06" , 
"departure_time" : "19:46:21" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "19:50:15" , 
"departure_time" : "19:51:31" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "19:53:16" , 
"departure_time" : "19:54:36" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "19:57:20" , 
"departure_time" : "19:58:43" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "20:01:23" , 
"departure_time" : "20:02:25" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "20:04:02" , 
"departure_time" : "20:04:27" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 160,
"arrival_time" : "20:08:25" , 
"departure_time" : "20:09:27" , 
"distance_traveled" : 20.8428
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "20:20:02" , 
"departure_time" : "20:21:02" , 
"distance_traveled" : 27.2042
}, 
{ 
"stop_id" : 63,
"arrival_time" : "20:32:00" , 
"departure_time" : "20:32:00" , 
"distance_traveled" : 30.764
} ], 
"4072" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "19:16:00" , 
"departure_time" : "19:18:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "19:22:16" , 
"departure_time" : "19:22:29" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "19:30:13" , 
"departure_time" : "19:30:36" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "19:33:23" , 
"departure_time" : "19:34:24" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "19:36:01" , 
"departure_time" : "19:36:25" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 62,
"arrival_time" : "19:39:24" , 
"departure_time" : "19:40:41" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "19:43:17" , 
"departure_time" : "19:43:26" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "19:45:09" , 
"departure_time" : "19:46:13" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "19:50:04" , 
"departure_time" : "19:51:11" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "19:53:07" , 
"departure_time" : "19:53:58" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "19:56:51" , 
"departure_time" : "19:57:34" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "20:00:43" , 
"departure_time" : "20:01:28" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "20:03:45" , 
"departure_time" : "20:04:16" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 160,
"arrival_time" : "20:08:31" , 
"departure_time" : "20:09:21" , 
"distance_traveled" : 20.8428
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "20:19:50" , 
"departure_time" : "20:20:28" , 
"distance_traveled" : 27.2042
}, 
{ 
"stop_id" : 63,
"arrival_time" : "20:31:38" , 
"departure_time" : "20:31:38" , 
"distance_traveled" : 30.764
} ], 
"4073" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "06:02:00" , 
"departure_time" : "06:04:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "06:08:38" , 
"departure_time" : "06:09:17" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "06:11:39" , 
"departure_time" : "06:13:18" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "06:16:39" , 
"departure_time" : "06:18:12" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "06:18:33" , 
"departure_time" : "06:19:47" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "06:20:14" , 
"departure_time" : "06:20:24" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "06:22:10" , 
"departure_time" : "06:23:31" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "06:26:21" , 
"departure_time" : "06:26:26" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "06:28:05" , 
"departure_time" : "06:29:12" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "06:33:07" , 
"departure_time" : "06:34:43" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "06:36:36" , 
"departure_time" : "06:37:38" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "06:41:02" , 
"departure_time" : "06:42:03" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "06:44:01" , 
"departure_time" : "06:44:43" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "06:46:42" , 
"departure_time" : "06:48:10" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "06:50:28" , 
"departure_time" : "06:51:17" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "06:53:49" , 
"departure_time" : "06:54:58" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:04:09" , 
"departure_time" : "07:04:42" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:15:33" , 
"departure_time" : "07:15:33" , 
"distance_traveled" : 30.7655
} ], 
"4074" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "06:02:00" , 
"departure_time" : "06:03:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "06:08:19" , 
"departure_time" : "06:08:42" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "06:11:23" , 
"departure_time" : "06:13:00" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "06:16:37" , 
"departure_time" : "06:17:33" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "06:17:56" , 
"departure_time" : "06:19:30" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "06:20:34" , 
"departure_time" : "06:21:04" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "06:22:30" , 
"departure_time" : "06:22:51" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "06:25:21" , 
"departure_time" : "06:26:50" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "06:29:29" , 
"departure_time" : "06:30:51" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "06:33:22" , 
"departure_time" : "06:34:01" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "06:35:39" , 
"departure_time" : "06:35:59" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "06:40:20" , 
"departure_time" : "06:41:30" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "06:44:10" , 
"departure_time" : "06:44:20" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "06:46:10" , 
"departure_time" : "06:47:33" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "06:50:23" , 
"departure_time" : "06:51:01" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "06:53:38" , 
"departure_time" : "06:55:08" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:04:30" , 
"departure_time" : "07:05:32" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:16:02" , 
"departure_time" : "07:16:02" , 
"distance_traveled" : 30.7655
} ], 
"4075" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "07:02:00" , 
"departure_time" : "07:04:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "07:08:07" , 
"departure_time" : "07:09:41" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "07:12:34" , 
"departure_time" : "07:12:49" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "07:14:15" , 
"departure_time" : "07:15:02" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "07:17:47" , 
"departure_time" : "07:19:07" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "07:20:20" , 
"departure_time" : "07:21:32" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "07:23:12" , 
"departure_time" : "07:24:27" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "07:26:15" , 
"departure_time" : "07:27:12" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "07:28:57" , 
"departure_time" : "07:29:43" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "07:31:46" , 
"departure_time" : "07:32:39" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "07:35:53" , 
"departure_time" : "07:36:39" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "07:39:46" , 
"departure_time" : "07:39:56" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "07:43:10" , 
"departure_time" : "07:44:19" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "07:47:09" , 
"departure_time" : "07:47:33" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "07:49:24" , 
"departure_time" : "07:50:32" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "07:54:08" , 
"departure_time" : "07:55:15" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:04:07" , 
"departure_time" : "08:04:35" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:15:28" , 
"departure_time" : "08:15:28" , 
"distance_traveled" : 30.7655
} ], 
"4076" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "07:02:00" , 
"departure_time" : "07:03:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "07:08:14" , 
"departure_time" : "07:08:52" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "07:11:38" , 
"departure_time" : "07:12:00" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "07:14:22" , 
"departure_time" : "07:15:13" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "07:17:51" , 
"departure_time" : "07:18:58" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "07:20:07" , 
"departure_time" : "07:20:19" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "07:22:12" , 
"departure_time" : "07:22:34" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "07:25:22" , 
"departure_time" : "07:26:42" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "07:29:20" , 
"departure_time" : "07:30:29" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "07:32:09" , 
"departure_time" : "07:33:35" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "07:36:26" , 
"departure_time" : "07:36:55" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "07:39:29" , 
"departure_time" : "07:40:36" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "07:44:07" , 
"departure_time" : "07:44:17" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "07:46:10" , 
"departure_time" : "07:46:18" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "07:49:08" , 
"departure_time" : "07:49:52" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "07:53:44" , 
"departure_time" : "07:53:59" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:03:15" , 
"departure_time" : "08:03:45" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:15:30" , 
"departure_time" : "08:15:30" , 
"distance_traveled" : 30.7655
} ], 
"4077" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "08:03:00" , 
"departure_time" : "08:04:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "08:08:43" , 
"departure_time" : "08:10:13" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "08:13:30" , 
"departure_time" : "08:14:03" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "08:16:33" , 
"departure_time" : "08:16:47" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "08:18:14" , 
"departure_time" : "08:19:51" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "08:21:37" , 
"departure_time" : "08:21:48" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "08:23:11" , 
"departure_time" : "08:23:53" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "08:26:42" , 
"departure_time" : "08:27:06" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "08:29:24" , 
"departure_time" : "08:30:14" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "08:33:50" , 
"departure_time" : "08:34:15" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "08:36:25" , 
"departure_time" : "08:36:37" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "08:41:12" , 
"departure_time" : "08:41:19" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "08:48:07" , 
"departure_time" : "08:49:18" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "08:52:11" , 
"departure_time" : "08:52:47" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "08:54:36" , 
"departure_time" : "08:54:37" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "08:57:01" , 
"departure_time" : "08:58:34" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:09:33" , 
"departure_time" : "09:10:52" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:21:19" , 
"departure_time" : "09:21:19" , 
"distance_traveled" : 30.7655
} ], 
"4078" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "08:03:00" , 
"departure_time" : "08:05:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "08:09:11" , 
"departure_time" : "08:09:59" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "08:12:48" , 
"departure_time" : "08:13:48" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "08:17:00" , 
"departure_time" : "08:17:02" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "08:18:02" , 
"departure_time" : "08:18:22" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "08:20:20" , 
"departure_time" : "08:20:33" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "08:23:13" , 
"departure_time" : "08:23:15" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "08:26:02" , 
"departure_time" : "08:27:23" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "08:30:21" , 
"departure_time" : "08:31:11" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "08:33:50" , 
"departure_time" : "08:34:32" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "08:36:42" , 
"departure_time" : "08:37:21" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "08:41:39" , 
"departure_time" : "08:41:41" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "08:48:02" , 
"departure_time" : "08:49:17" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "08:52:15" , 
"departure_time" : "08:53:10" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "08:54:55" , 
"departure_time" : "08:55:13" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "08:57:18" , 
"departure_time" : "08:58:30" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:09:12" , 
"departure_time" : "09:10:37" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:21:25" , 
"departure_time" : "09:21:25" , 
"distance_traveled" : 30.7655
} ], 
"4079" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "10:03:00" , 
"departure_time" : "10:05:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "10:08:41" , 
"departure_time" : "10:09:17" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "10:12:36" , 
"departure_time" : "10:13:24" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "10:16:48" , 
"departure_time" : "10:17:28" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "10:18:40" , 
"departure_time" : "10:18:45" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "10:20:05" , 
"departure_time" : "10:20:44" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "10:23:39" , 
"departure_time" : "10:25:15" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "10:27:36" , 
"departure_time" : "10:29:07" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "10:30:31" , 
"departure_time" : "10:31:00" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "10:33:29" , 
"departure_time" : "10:34:13" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "10:36:44" , 
"departure_time" : "10:37:41" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "10:41:57" , 
"departure_time" : "10:43:04" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "10:49:07" , 
"departure_time" : "10:50:43" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "10:52:36" , 
"departure_time" : "10:53:45" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "10:55:09" , 
"departure_time" : "10:56:38" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "10:58:29" , 
"departure_time" : "10:59:51" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "11:09:22" , 
"departure_time" : "11:10:56" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "11:21:34" , 
"departure_time" : "11:21:34" , 
"distance_traveled" : 30.7655
} ], 
"4080" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "10:03:00" , 
"departure_time" : "10:05:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "10:09:21" , 
"departure_time" : "10:09:46" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "10:12:25" , 
"departure_time" : "10:13:40" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "10:17:15" , 
"departure_time" : "10:18:15" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "10:19:00" , 
"departure_time" : "10:20:35" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "10:21:35" , 
"departure_time" : "10:22:58" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "10:24:23" , 
"departure_time" : "10:25:44" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "10:27:21" , 
"departure_time" : "10:27:41" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "10:29:20" , 
"departure_time" : "10:30:23" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "10:34:03" , 
"departure_time" : "10:35:05" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "10:37:02" , 
"departure_time" : "10:37:25" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "10:41:23" , 
"departure_time" : "10:42:40" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "10:49:17" , 
"departure_time" : "10:50:43" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "10:52:26" , 
"departure_time" : "10:54:04" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "10:55:38" , 
"departure_time" : "10:57:05" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "10:58:27" , 
"departure_time" : "10:58:41" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "11:08:14" , 
"departure_time" : "11:08:23" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "11:20:09" , 
"departure_time" : "11:20:09" , 
"distance_traveled" : 30.7655
} ], 
"4081" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "12:03:00" , 
"departure_time" : "12:04:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "12:08:55" , 
"departure_time" : "12:09:42" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "12:13:47" , 
"departure_time" : "12:14:03" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "12:16:16" , 
"departure_time" : "12:16:36" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "12:18:20" , 
"departure_time" : "12:19:59" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "12:22:39" , 
"departure_time" : "12:23:55" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "12:25:16" , 
"departure_time" : "12:25:40" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "12:27:24" , 
"departure_time" : "12:27:49" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "12:30:25" , 
"departure_time" : "12:31:46" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "12:35:21" , 
"departure_time" : "12:36:25" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "12:38:04" , 
"departure_time" : "12:39:28" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "12:43:24" , 
"departure_time" : "12:44:05" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "12:49:41" , 
"departure_time" : "12:50:21" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "12:52:40" , 
"departure_time" : "12:52:50" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "12:55:10" , 
"departure_time" : "12:56:24" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "12:59:14" , 
"departure_time" : "13:00:15" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "13:10:01" , 
"departure_time" : "13:10:26" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "13:21:25" , 
"departure_time" : "13:21:25" , 
"distance_traveled" : 30.7655
} ], 
"4082" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "12:03:00" , 
"departure_time" : "12:04:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "12:09:27" , 
"departure_time" : "12:10:01" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "12:13:34" , 
"departure_time" : "12:13:56" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "12:16:22" , 
"departure_time" : "12:16:51" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "12:18:29" , 
"departure_time" : "12:19:06" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "12:21:37" , 
"departure_time" : "12:23:02" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "12:25:25" , 
"departure_time" : "12:26:54" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "12:28:29" , 
"departure_time" : "12:29:44" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "12:31:15" , 
"departure_time" : "12:31:42" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "12:34:27" , 
"departure_time" : "12:35:07" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "12:37:40" , 
"departure_time" : "12:37:43" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "12:42:03" , 
"departure_time" : "12:43:11" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "12:50:08" , 
"departure_time" : "12:50:29" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "12:52:21" , 
"departure_time" : "12:53:55" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "12:56:34" , 
"departure_time" : "12:56:37" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "12:58:03" , 
"departure_time" : "12:59:05" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "13:10:02" , 
"departure_time" : "13:10:51" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "13:21:49" , 
"departure_time" : "13:21:49" , 
"distance_traveled" : 30.7655
} ], 
"4083" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "14:03:00" , 
"departure_time" : "14:05:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "14:09:36" , 
"departure_time" : "14:09:58" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "14:12:22" , 
"departure_time" : "14:13:49" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "14:17:27" , 
"departure_time" : "14:17:57" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "14:18:30" , 
"departure_time" : "14:19:04" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "14:20:34" , 
"departure_time" : "14:21:25" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "14:23:51" , 
"departure_time" : "14:24:37" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "14:26:46" , 
"departure_time" : "14:26:57" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "14:29:11" , 
"departure_time" : "14:30:41" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "14:34:30" , 
"departure_time" : "14:34:36" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "14:36:06" , 
"departure_time" : "14:37:44" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "14:42:38" , 
"departure_time" : "14:43:54" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "14:49:16" , 
"departure_time" : "14:50:07" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "14:51:51" , 
"departure_time" : "14:52:42" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "14:54:51" , 
"departure_time" : "14:56:03" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "14:58:12" , 
"departure_time" : "14:58:28" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "15:08:16" , 
"departure_time" : "15:09:15" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "15:20:59" , 
"departure_time" : "15:20:59" , 
"distance_traveled" : 30.7655
} ], 
"4084" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "14:03:00" , 
"departure_time" : "14:04:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "14:08:41" , 
"departure_time" : "14:08:44" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "14:12:03" , 
"departure_time" : "14:12:48" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "14:16:45" , 
"departure_time" : "14:18:03" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "14:19:18" , 
"departure_time" : "14:20:26" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "14:21:08" , 
"departure_time" : "14:21:16" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "14:23:08" , 
"departure_time" : "14:24:37" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "14:27:29" , 
"departure_time" : "14:28:10" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "14:29:41" , 
"departure_time" : "14:30:40" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "14:33:59" , 
"departure_time" : "14:34:33" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "14:36:34" , 
"departure_time" : "14:36:53" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "14:41:19" , 
"departure_time" : "14:41:26" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "14:48:07" , 
"departure_time" : "14:49:39" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "14:52:32" , 
"departure_time" : "14:52:59" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "14:54:27" , 
"departure_time" : "14:56:05" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "14:58:38" , 
"departure_time" : "14:59:55" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "15:09:17" , 
"departure_time" : "15:10:55" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "15:21:38" , 
"departure_time" : "15:21:38" , 
"distance_traveled" : 30.7655
} ], 
"4085" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "16:05:00" , 
"departure_time" : "16:07:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "16:10:25" , 
"departure_time" : "16:11:25" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "16:15:00" , 
"departure_time" : "16:15:41" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "16:18:41" , 
"departure_time" : "16:19:18" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "16:20:37" , 
"departure_time" : "16:22:15" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "16:23:38" , 
"departure_time" : "16:24:24" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "16:25:46" , 
"departure_time" : "16:27:04" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "16:29:18" , 
"departure_time" : "16:30:56" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "16:32:38" , 
"departure_time" : "16:34:13" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "16:36:35" , 
"departure_time" : "16:37:34" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "16:38:59" , 
"departure_time" : "16:39:01" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "16:43:02" , 
"departure_time" : "16:43:40" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "16:48:38" , 
"departure_time" : "16:49:52" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "16:52:14" , 
"departure_time" : "16:52:36" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "16:54:22" , 
"departure_time" : "16:54:46" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "16:58:24" , 
"departure_time" : "16:59:47" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:09:23" , 
"departure_time" : "17:10:44" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:21:21" , 
"departure_time" : "17:21:21" , 
"distance_traveled" : 30.7655
} ], 
"4086" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "16:05:00" , 
"departure_time" : "16:06:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "16:10:16" , 
"departure_time" : "16:10:22" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "16:14:06" , 
"departure_time" : "16:14:56" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "16:18:50" , 
"departure_time" : "16:19:54" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "16:21:04" , 
"departure_time" : "16:21:15" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "16:22:11" , 
"departure_time" : "16:23:03" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "16:25:52" , 
"departure_time" : "16:26:56" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "16:29:04" , 
"departure_time" : "16:30:08" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "16:32:04" , 
"departure_time" : "16:33:17" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "16:36:13" , 
"departure_time" : "16:37:33" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "16:39:20" , 
"departure_time" : "16:39:40" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "16:43:20" , 
"departure_time" : "16:44:21" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "16:49:01" , 
"departure_time" : "16:50:28" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "16:52:27" , 
"departure_time" : "16:53:20" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "16:54:53" , 
"departure_time" : "16:54:57" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "16:58:04" , 
"departure_time" : "16:58:06" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:08:02" , 
"departure_time" : "17:08:53" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:20:51" , 
"departure_time" : "17:20:51" , 
"distance_traveled" : 30.7655
} ], 
"4087" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "20:09:00" , 
"departure_time" : "20:10:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "20:14:32" , 
"departure_time" : "20:14:34" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "20:22:02" , 
"departure_time" : "20:22:21" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "20:25:19" , 
"departure_time" : "20:26:27" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "20:29:08" , 
"departure_time" : "20:30:16" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "20:31:08" , 
"departure_time" : "20:31:26" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "20:33:18" , 
"departure_time" : "20:33:29" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "20:36:11" , 
"departure_time" : "20:37:50" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "20:40:39" , 
"departure_time" : "20:41:39" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "20:43:00" , 
"departure_time" : "20:44:30" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "20:47:30" , 
"departure_time" : "20:47:55" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "20:50:25" , 
"departure_time" : "20:50:58" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "20:53:33" , 
"departure_time" : "20:54:18" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "20:56:45" , 
"departure_time" : "20:58:22" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "21:00:37" , 
"departure_time" : "21:01:18" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "21:03:41" , 
"departure_time" : "21:05:17" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "21:16:36" , 
"departure_time" : "21:17:22" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "21:27:46" , 
"departure_time" : "21:27:46" , 
"distance_traveled" : 30.7655
} ], 
"4088" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "20:09:00" , 
"departure_time" : "20:10:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "20:15:00" , 
"departure_time" : "20:15:35" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "20:22:35" , 
"departure_time" : "20:23:39" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "20:26:04" , 
"departure_time" : "20:27:42" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "20:29:38" , 
"departure_time" : "20:31:15" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "20:31:37" , 
"departure_time" : "20:33:13" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "20:34:36" , 
"departure_time" : "20:35:08" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "20:36:32" , 
"departure_time" : "20:36:56" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "20:39:24" , 
"departure_time" : "20:39:59" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "20:42:35" , 
"departure_time" : "20:43:45" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "20:47:10" , 
"departure_time" : "20:47:11" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "20:50:01" , 
"departure_time" : "20:50:52" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "20:53:51" , 
"departure_time" : "20:54:14" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "20:56:23" , 
"departure_time" : "20:56:37" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "20:59:14" , 
"departure_time" : "20:59:28" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "21:03:14" , 
"departure_time" : "21:04:03" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "21:15:49" , 
"departure_time" : "21:16:36" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "21:27:47" , 
"departure_time" : "21:27:47" , 
"distance_traveled" : 30.7655
} ], 
"4089" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "09:41:00" , 
"departure_time" : "09:43:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "09:47:39" , 
"departure_time" : "09:48:07" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "09:51:28" , 
"departure_time" : "09:52:18" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "10:22:50" , 
"departure_time" : "10:23:49" , 
"distance_traveled" : 27.1955
}, 
{ 
"stop_id" : 63,
"arrival_time" : "10:33:59" , 
"departure_time" : "10:33:59" , 
"distance_traveled" : 30.7553
} ], 
"4090" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "09:41:00" , 
"departure_time" : "09:42:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "09:46:48" , 
"departure_time" : "09:48:04" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "09:52:16" , 
"departure_time" : "09:52:57" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "10:22:41" , 
"departure_time" : "10:22:59" , 
"distance_traveled" : 27.1955
}, 
{ 
"stop_id" : 63,
"arrival_time" : "10:33:18" , 
"departure_time" : "10:33:18" , 
"distance_traveled" : 30.7553
} ], 
"4091" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "11:41:00" , 
"departure_time" : "11:41:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "11:46:05" , 
"departure_time" : "11:47:43" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "11:52:38" , 
"departure_time" : "11:53:13" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "12:22:35" , 
"departure_time" : "12:22:37" , 
"distance_traveled" : 27.1955
}, 
{ 
"stop_id" : 63,
"arrival_time" : "12:33:02" , 
"departure_time" : "12:33:02" , 
"distance_traveled" : 30.7553
} ], 
"4092" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "11:41:00" , 
"departure_time" : "11:42:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "11:47:25" , 
"departure_time" : "11:48:49" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "11:52:24" , 
"departure_time" : "11:53:38" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "12:23:14" , 
"departure_time" : "12:24:20" , 
"distance_traveled" : 27.1955
}, 
{ 
"stop_id" : 63,
"arrival_time" : "12:34:06" , 
"departure_time" : "12:34:06" , 
"distance_traveled" : 30.7553
} ], 
"4093" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "13:38:00" , 
"departure_time" : "13:39:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "13:43:37" , 
"departure_time" : "13:44:09" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "13:48:32" , 
"departure_time" : "13:50:12" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 110,
"arrival_time" : "14:04:40" , 
"departure_time" : "14:05:41" , 
"distance_traveled" : 15.6568
}, 
{ 
"stop_id" : 5,
"arrival_time" : "14:28:01" , 
"departure_time" : "14:29:07" , 
"distance_traveled" : 16.8951
}, 
{ 
"stop_id" : 43,
"arrival_time" : "14:31:06" , 
"departure_time" : "14:31:58" , 
"distance_traveled" : 18.042
}, 
{ 
"stop_id" : 146,
"arrival_time" : "14:33:52" , 
"departure_time" : "14:34:17" , 
"distance_traveled" : 19.1634
}, 
{ 
"stop_id" : 160,
"arrival_time" : "14:36:25" , 
"departure_time" : "14:36:49" , 
"distance_traveled" : 20.8379
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "14:46:24" , 
"departure_time" : "14:47:16" , 
"distance_traveled" : 27.1992
}, 
{ 
"stop_id" : 63,
"arrival_time" : "14:59:52" , 
"departure_time" : "14:59:52" , 
"distance_traveled" : 30.7591
} ], 
"4094" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "13:38:00" , 
"departure_time" : "13:40:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "13:44:32" , 
"departure_time" : "13:45:52" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "13:49:20" , 
"departure_time" : "13:50:23" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 110,
"arrival_time" : "14:04:03" , 
"departure_time" : "14:05:11" , 
"distance_traveled" : 15.6568
}, 
{ 
"stop_id" : 5,
"arrival_time" : "14:28:08" , 
"departure_time" : "14:28:27" , 
"distance_traveled" : 16.8951
}, 
{ 
"stop_id" : 43,
"arrival_time" : "14:30:19" , 
"departure_time" : "14:31:27" , 
"distance_traveled" : 18.042
}, 
{ 
"stop_id" : 146,
"arrival_time" : "14:34:08" , 
"departure_time" : "14:34:28" , 
"distance_traveled" : 19.1634
}, 
{ 
"stop_id" : 160,
"arrival_time" : "14:36:20" , 
"departure_time" : "14:37:42" , 
"distance_traveled" : 20.8379
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "14:47:22" , 
"departure_time" : "14:48:27" , 
"distance_traveled" : 27.1992
}, 
{ 
"stop_id" : 63,
"arrival_time" : "15:00:05" , 
"departure_time" : "15:00:05" , 
"distance_traveled" : 30.7591
} ], 
"4095" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "07:06:00" , 
"departure_time" : "07:07:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "07:12:38" , 
"departure_time" : "07:14:02" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "07:18:24" , 
"departure_time" : "07:20:03" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "07:21:39" , 
"departure_time" : "07:22:58" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "07:24:19" , 
"departure_time" : "07:24:46" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "07:26:27" , 
"departure_time" : "07:26:45" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "07:30:18" , 
"departure_time" : "07:31:50" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "07:35:32" , 
"departure_time" : "07:35:36" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "07:37:04" , 
"departure_time" : "07:37:10" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "07:41:06" , 
"departure_time" : "07:41:32" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "07:45:26" , 
"departure_time" : "07:46:32" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "07:51:06" , 
"departure_time" : "07:51:13" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:07:07" , 
"departure_time" : "08:08:10" , 
"distance_traveled" : 27.2023
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:20:03" , 
"departure_time" : "08:20:03" , 
"distance_traveled" : 30.7621
} ], 
"4096" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "07:06:00" , 
"departure_time" : "07:08:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "07:13:20" , 
"departure_time" : "07:14:23" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "07:18:03" , 
"departure_time" : "07:19:25" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "07:21:22" , 
"departure_time" : "07:21:42" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "07:23:20" , 
"departure_time" : "07:24:34" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "07:27:14" , 
"departure_time" : "07:28:29" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "07:31:15" , 
"departure_time" : "07:32:09" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "07:34:54" , 
"departure_time" : "07:35:36" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "07:37:42" , 
"departure_time" : "07:38:01" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "07:41:19" , 
"departure_time" : "07:42:55" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "07:46:36" , 
"departure_time" : "07:46:43" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "07:50:07" , 
"departure_time" : "07:50:59" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:07:52" , 
"departure_time" : "08:08:36" , 
"distance_traveled" : 27.2023
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:19:44" , 
"departure_time" : "08:19:44" , 
"distance_traveled" : 30.7621
} ], 
"4097" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "08:03:00" , 
"departure_time" : "08:04:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "08:09:40" , 
"departure_time" : "08:09:44" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "08:13:04" , 
"departure_time" : "08:14:19" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "08:17:15" , 
"departure_time" : "08:18:20" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "08:20:05" , 
"departure_time" : "08:20:37" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "08:21:32" , 
"departure_time" : "08:22:57" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "08:25:25" , 
"departure_time" : "08:26:31" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "08:28:06" , 
"departure_time" : "08:28:51" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "08:31:45" , 
"departure_time" : "08:32:49" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "08:35:04" , 
"departure_time" : "08:35:51" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "08:38:47" , 
"departure_time" : "08:39:02" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "08:42:15" , 
"departure_time" : "08:43:09" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:58:54" , 
"departure_time" : "08:59:58" , 
"distance_traveled" : 27.2023
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:11:04" , 
"departure_time" : "09:11:04" , 
"distance_traveled" : 30.7621
} ], 
"4098" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "08:03:00" , 
"departure_time" : "08:04:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "08:09:40" , 
"departure_time" : "08:10:47" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "08:14:07" , 
"departure_time" : "08:15:21" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "08:17:14" , 
"departure_time" : "08:17:25" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "08:19:11" , 
"departure_time" : "08:20:05" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "08:21:54" , 
"departure_time" : "08:22:27" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "08:24:33" , 
"departure_time" : "08:25:27" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "08:27:54" , 
"departure_time" : "08:28:51" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "08:31:57" , 
"departure_time" : "08:33:29" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "08:35:32" , 
"departure_time" : "08:36:32" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "08:39:00" , 
"departure_time" : "08:39:17" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "08:42:17" , 
"departure_time" : "08:43:32" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:59:15" , 
"departure_time" : "09:00:30" , 
"distance_traveled" : 27.2023
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:11:15" , 
"departure_time" : "09:11:15" , 
"distance_traveled" : 30.7621
} ], 
"4099" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "07:48:00" , 
"departure_time" : "07:50:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "07:54:08" , 
"departure_time" : "07:55:46" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "07:59:38" , 
"departure_time" : "08:01:02" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "08:02:24" , 
"departure_time" : "08:02:40" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 159,
"arrival_time" : "08:04:16" , 
"departure_time" : "08:04:48" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 156,
"arrival_time" : "08:09:32" , 
"departure_time" : "08:10:05" , 
"distance_traveled" : 9.986
}, 
{ 
"stop_id" : 111,
"arrival_time" : "08:14:33" , 
"departure_time" : "08:15:20" , 
"distance_traveled" : 12.6547
}, 
{ 
"stop_id" : 110,
"arrival_time" : "08:20:47" , 
"departure_time" : "08:21:51" , 
"distance_traveled" : 15.6833
}, 
{ 
"stop_id" : 5,
"arrival_time" : "08:24:04" , 
"departure_time" : "08:24:16" , 
"distance_traveled" : 16.9402
}, 
{ 
"stop_id" : 43,
"arrival_time" : "08:26:12" , 
"departure_time" : "08:27:06" , 
"distance_traveled" : 18.0871
}, 
{ 
"stop_id" : 146,
"arrival_time" : "08:30:54" , 
"departure_time" : "08:31:38" , 
"distance_traveled" : 19.2085
}, 
{ 
"stop_id" : 160,
"arrival_time" : "08:33:44" , 
"departure_time" : "08:34:26" , 
"distance_traveled" : 20.883
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:43:42" , 
"departure_time" : "08:44:17" , 
"distance_traveled" : 27.2443
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:55:35" , 
"departure_time" : "08:55:35" , 
"distance_traveled" : 30.8042
} ], 
"4100" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "07:48:00" , 
"departure_time" : "07:48:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "07:53:07" , 
"departure_time" : "07:54:43" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "07:59:36" , 
"departure_time" : "08:00:49" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "08:02:13" , 
"departure_time" : "08:02:28" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 159,
"arrival_time" : "08:04:15" , 
"departure_time" : "08:05:15" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 156,
"arrival_time" : "08:10:00" , 
"departure_time" : "08:10:18" , 
"distance_traveled" : 9.986
}, 
{ 
"stop_id" : 111,
"arrival_time" : "08:14:18" , 
"departure_time" : "08:15:20" , 
"distance_traveled" : 12.6547
}, 
{ 
"stop_id" : 110,
"arrival_time" : "08:21:02" , 
"departure_time" : "08:21:08" , 
"distance_traveled" : 15.6833
}, 
{ 
"stop_id" : 5,
"arrival_time" : "08:23:06" , 
"departure_time" : "08:24:42" , 
"distance_traveled" : 16.9402
}, 
{ 
"stop_id" : 43,
"arrival_time" : "08:27:36" , 
"departure_time" : "08:29:14" , 
"distance_traveled" : 18.0871
}, 
{ 
"stop_id" : 146,
"arrival_time" : "08:31:38" , 
"departure_time" : "08:33:11" , 
"distance_traveled" : 19.2085
}, 
{ 
"stop_id" : 160,
"arrival_time" : "08:34:33" , 
"departure_time" : "08:34:41" , 
"distance_traveled" : 20.883
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:43:08" , 
"departure_time" : "08:43:21" , 
"distance_traveled" : 27.2443
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:55:13" , 
"departure_time" : "08:55:13" , 
"distance_traveled" : 30.8042
} ], 
"4101" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "12:13:00" , 
"departure_time" : "12:14:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "12:20:16" , 
"departure_time" : "12:21:11" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "12:23:55" , 
"departure_time" : "12:24:57" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "12:27:02" , 
"departure_time" : "12:28:19" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "12:29:17" , 
"departure_time" : "12:30:41" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 62,
"arrival_time" : "12:33:24" , 
"departure_time" : "12:34:22" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "12:35:58" , 
"departure_time" : "12:36:17" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "12:39:19" , 
"departure_time" : "12:40:38" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "12:43:19" , 
"departure_time" : "12:44:08" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "12:46:49" , 
"departure_time" : "12:48:10" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "12:51:21" , 
"departure_time" : "12:52:01" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "12:53:40" , 
"departure_time" : "12:54:19" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "12:56:39" , 
"departure_time" : "12:58:12" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 160,
"arrival_time" : "13:02:33" , 
"departure_time" : "13:02:40" , 
"distance_traveled" : 20.8428
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "13:12:07" , 
"departure_time" : "13:13:27" , 
"distance_traveled" : 27.2042
}, 
{ 
"stop_id" : 63,
"arrival_time" : "13:25:20" , 
"departure_time" : "13:25:20" , 
"distance_traveled" : 30.764
} ], 
"4102" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "12:13:00" , 
"departure_time" : "12:15:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "12:19:45" , 
"departure_time" : "12:21:06" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "12:24:21" , 
"departure_time" : "12:24:32" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "12:26:11" , 
"departure_time" : "12:27:45" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "12:29:34" , 
"departure_time" : "12:29:45" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 62,
"arrival_time" : "12:32:11" , 
"departure_time" : "12:32:46" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "12:35:35" , 
"departure_time" : "12:35:42" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "12:39:07" , 
"departure_time" : "12:40:28" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "12:43:21" , 
"departure_time" : "12:43:45" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "12:46:24" , 
"departure_time" : "12:47:03" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "12:50:39" , 
"departure_time" : "12:51:04" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "12:53:25" , 
"departure_time" : "12:53:46" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "12:56:21" , 
"departure_time" : "12:57:10" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 160,
"arrival_time" : "13:01:49" , 
"departure_time" : "13:03:01" , 
"distance_traveled" : 20.8428
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "13:13:12" , 
"departure_time" : "13:13:22" , 
"distance_traveled" : 27.2042
}, 
{ 
"stop_id" : 63,
"arrival_time" : "13:24:10" , 
"departure_time" : "13:24:10" , 
"distance_traveled" : 30.764
} ], 
"4103" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "06:50:00" , 
"departure_time" : "06:51:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "06:57:14" , 
"departure_time" : "06:58:51" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "07:01:37" , 
"departure_time" : "07:02:22" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "07:03:45" , 
"departure_time" : "07:04:08" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "07:06:23" , 
"departure_time" : "07:07:12" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 62,
"arrival_time" : "07:11:49" , 
"departure_time" : "07:12:09" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "07:14:20" , 
"departure_time" : "07:15:54" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "07:18:34" , 
"departure_time" : "07:19:13" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "07:21:39" , 
"departure_time" : "07:23:10" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "07:26:31" , 
"departure_time" : "07:27:23" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "07:29:52" , 
"departure_time" : "07:31:02" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "07:34:10" , 
"departure_time" : "07:34:56" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "07:36:46" , 
"departure_time" : "07:37:17" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "07:39:31" , 
"departure_time" : "07:40:03" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "07:43:32" , 
"departure_time" : "07:44:08" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:54:36" , 
"departure_time" : "07:55:09" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:06:33" , 
"departure_time" : "08:06:33" , 
"distance_traveled" : 30.7655
} ], 
"4104" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "06:50:00" , 
"departure_time" : "06:50:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "06:56:26" , 
"departure_time" : "06:57:35" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "07:01:09" , 
"departure_time" : "07:02:05" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "07:03:56" , 
"departure_time" : "07:05:14" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "07:07:18" , 
"departure_time" : "07:08:34" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 62,
"arrival_time" : "07:12:16" , 
"departure_time" : "07:12:17" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "07:14:01" , 
"departure_time" : "07:14:10" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "07:17:09" , 
"departure_time" : "07:17:28" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "07:21:19" , 
"departure_time" : "07:21:51" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "07:25:32" , 
"departure_time" : "07:26:37" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "07:30:05" , 
"departure_time" : "07:30:29" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "07:33:24" , 
"departure_time" : "07:33:39" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "07:36:15" , 
"departure_time" : "07:37:41" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "07:40:26" , 
"departure_time" : "07:40:31" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "07:43:05" , 
"departure_time" : "07:43:17" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:54:12" , 
"departure_time" : "07:54:19" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:06:07" , 
"departure_time" : "08:06:07" , 
"distance_traveled" : 30.7655
} ], 
"4105" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "08:50:00" , 
"departure_time" : "08:50:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "08:55:16" , 
"departure_time" : "08:56:27" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "09:00:11" , 
"departure_time" : "09:01:12" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "09:04:01" , 
"departure_time" : "09:04:22" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "09:05:21" , 
"departure_time" : "09:06:34" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "09:08:13" , 
"departure_time" : "09:09:53" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "09:11:40" , 
"departure_time" : "09:12:12" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "09:13:32" , 
"departure_time" : "09:14:45" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "09:17:13" , 
"departure_time" : "09:18:14" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "09:20:01" , 
"departure_time" : "09:21:28" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "09:24:27" , 
"departure_time" : "09:25:23" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "09:27:56" , 
"departure_time" : "09:28:41" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "09:30:45" , 
"departure_time" : "09:31:41" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "09:33:56" , 
"departure_time" : "09:35:13" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 160,
"arrival_time" : "09:39:17" , 
"departure_time" : "09:39:42" , 
"distance_traveled" : 20.8428
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:48:25" , 
"departure_time" : "09:48:50" , 
"distance_traveled" : 27.2042
}, 
{ 
"stop_id" : 63,
"arrival_time" : "10:00:25" , 
"departure_time" : "10:00:25" , 
"distance_traveled" : 30.764
} ], 
"4106" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "08:50:00" , 
"departure_time" : "08:50:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "08:55:19" , 
"departure_time" : "08:55:56" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "08:59:37" , 
"departure_time" : "08:59:48" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "09:03:11" , 
"departure_time" : "09:03:43" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "09:05:32" , 
"departure_time" : "09:06:08" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "09:07:36" , 
"departure_time" : "09:08:36" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "09:11:00" , 
"departure_time" : "09:12:26" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "09:14:26" , 
"departure_time" : "09:15:02" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "09:16:36" , 
"departure_time" : "09:17:18" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "09:19:42" , 
"departure_time" : "09:19:55" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "09:23:13" , 
"departure_time" : "09:24:00" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "09:27:47" , 
"departure_time" : "09:28:45" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "09:30:58" , 
"departure_time" : "09:32:32" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "09:34:34" , 
"departure_time" : "09:36:05" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 160,
"arrival_time" : "09:39:31" , 
"departure_time" : "09:40:03" , 
"distance_traveled" : 20.8428
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:48:32" , 
"departure_time" : "09:48:42" , 
"distance_traveled" : 27.2042
}, 
{ 
"stop_id" : 63,
"arrival_time" : "10:00:10" , 
"departure_time" : "10:00:10" , 
"distance_traveled" : 30.764
} ], 
"4107" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "10:49:00" , 
"departure_time" : "10:50:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "10:55:09" , 
"departure_time" : "10:56:00" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "11:02:51" , 
"departure_time" : "11:02:52" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "11:05:01" , 
"departure_time" : "11:05:46" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "11:07:45" , 
"departure_time" : "11:08:39" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "11:09:54" , 
"departure_time" : "11:10:30" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "11:12:36" , 
"departure_time" : "11:14:10" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "11:16:34" , 
"departure_time" : "11:16:46" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "11:18:12" , 
"departure_time" : "11:19:40" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "11:23:28" , 
"departure_time" : "11:24:28" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "11:26:00" , 
"departure_time" : "11:27:26" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "11:30:26" , 
"departure_time" : "11:31:40" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "11:33:14" , 
"departure_time" : "11:33:59" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "11:35:45" , 
"departure_time" : "11:36:22" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 160,
"arrival_time" : "11:40:37" , 
"departure_time" : "11:42:17" , 
"distance_traveled" : 20.8428
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "11:51:40" , 
"departure_time" : "11:53:09" , 
"distance_traveled" : 27.2042
}, 
{ 
"stop_id" : 63,
"arrival_time" : "12:03:29" , 
"departure_time" : "12:03:29" , 
"distance_traveled" : 30.764
} ], 
"4108" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "10:49:00" , 
"departure_time" : "10:52:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "10:55:31" , 
"departure_time" : "10:55:34" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "11:02:03" , 
"departure_time" : "11:02:42" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "11:05:39" , 
"departure_time" : "11:06:59" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "11:08:20" , 
"departure_time" : "11:08:44" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "11:09:24" , 
"departure_time" : "11:09:44" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "11:12:20" , 
"departure_time" : "11:13:51" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "11:16:31" , 
"departure_time" : "11:18:10" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "11:19:39" , 
"departure_time" : "11:21:19" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "11:23:40" , 
"departure_time" : "11:24:10" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "11:25:30" , 
"departure_time" : "11:26:29" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "11:29:59" , 
"departure_time" : "11:31:21" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "11:33:22" , 
"departure_time" : "11:33:57" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "11:35:35" , 
"departure_time" : "11:36:23" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 160,
"arrival_time" : "11:40:48" , 
"departure_time" : "11:40:59" , 
"distance_traveled" : 20.8428
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "11:50:11" , 
"departure_time" : "11:51:11" , 
"distance_traveled" : 27.2042
}, 
{ 
"stop_id" : 63,
"arrival_time" : "12:03:00" , 
"departure_time" : "12:03:00" , 
"distance_traveled" : 30.764
} ], 
"4109" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "07:22:00" , 
"departure_time" : "07:23:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "07:28:31" , 
"departure_time" : "07:28:48" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "07:32:17" , 
"departure_time" : "07:33:24" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "07:36:07" , 
"departure_time" : "07:36:29" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "07:38:22" , 
"departure_time" : "07:39:09" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "07:40:47" , 
"departure_time" : "07:42:26" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "07:45:39" , 
"departure_time" : "07:46:27" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "07:47:48" , 
"departure_time" : "07:48:40" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 111,
"arrival_time" : "07:51:52" , 
"departure_time" : "07:53:20" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "07:56:28" , 
"departure_time" : "07:57:01" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "07:59:33" , 
"departure_time" : "08:00:48" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "08:04:15" , 
"departure_time" : "08:04:22" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "08:06:07" , 
"departure_time" : "08:07:19" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "08:10:12" , 
"departure_time" : "08:10:14" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "08:13:02" , 
"departure_time" : "08:14:33" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:24:31" , 
"departure_time" : "08:25:43" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:36:12" , 
"departure_time" : "08:36:12" , 
"distance_traveled" : 30.7655
} ], 
"4110" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "07:22:00" , 
"departure_time" : "07:24:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "07:29:14" , 
"departure_time" : "07:29:17" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "07:32:03" , 
"departure_time" : "07:33:03" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "07:36:00" , 
"departure_time" : "07:37:04" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "07:39:04" , 
"departure_time" : "07:40:08" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "07:41:04" , 
"departure_time" : "07:41:34" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "07:44:30" , 
"departure_time" : "07:45:48" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "07:48:18" , 
"departure_time" : "07:49:35" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 111,
"arrival_time" : "07:52:17" , 
"departure_time" : "07:52:50" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "07:55:33" , 
"departure_time" : "07:56:53" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "08:00:20" , 
"departure_time" : "08:01:50" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "08:04:30" , 
"departure_time" : "08:06:01" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "08:07:31" , 
"departure_time" : "08:08:03" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "08:09:32" , 
"departure_time" : "08:10:20" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "08:13:48" , 
"departure_time" : "08:14:58" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:24:10" , 
"departure_time" : "08:25:02" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:35:52" , 
"departure_time" : "08:35:52" , 
"distance_traveled" : 30.7655
} ], 
"4111" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "24:05:00" , 
"departure_time" : "24:05:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "24:10:03" , 
"departure_time" : "24:10:57" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "24:18:54" , 
"departure_time" : "24:19:30" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "24:21:36" , 
"departure_time" : "24:22:05" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "24:23:29" , 
"departure_time" : "24:24:46" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "24:26:17" , 
"departure_time" : "24:27:57" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "24:30:40" , 
"departure_time" : "24:32:14" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "24:32:34" , 
"departure_time" : "24:33:33" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "24:35:59" , 
"departure_time" : "24:37:18" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "24:39:19" , 
"departure_time" : "24:40:50" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "24:42:31" , 
"departure_time" : "24:43:19" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "24:45:48" , 
"departure_time" : "24:47:16" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "24:50:28" , 
"departure_time" : "24:51:58" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "24:52:30" , 
"departure_time" : "24:53:15" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "24:54:45" , 
"departure_time" : "24:55:39" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "24:58:54" , 
"departure_time" : "25:00:19" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "25:08:25" , 
"departure_time" : "25:10:05" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "25:20:40" , 
"departure_time" : "25:20:40" , 
"distance_traveled" : 30.7655
} ], 
"4112" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "24:05:00" , 
"departure_time" : "24:07:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "24:10:45" , 
"departure_time" : "24:11:12" , 
"distance_traveled" : 2.617
}, 
{ 
"stop_id" : 118,
"arrival_time" : "24:18:27" , 
"departure_time" : "24:18:39" , 
"distance_traveled" : 4.9585
}, 
{ 
"stop_id" : 90,
"arrival_time" : "24:21:12" , 
"departure_time" : "24:21:18" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "24:23:06" , 
"departure_time" : "24:23:59" , 
"distance_traveled" : 6.9089
}, 
{ 
"stop_id" : 159,
"arrival_time" : "24:25:53" , 
"departure_time" : "24:26:44" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "24:29:51" , 
"departure_time" : "24:31:10" , 
"distance_traveled" : 9.0697
}, 
{ 
"stop_id" : 156,
"arrival_time" : "24:32:19" , 
"departure_time" : "24:33:10" , 
"distance_traveled" : 9.985
}, 
{ 
"stop_id" : 42,
"arrival_time" : "24:35:51" , 
"departure_time" : "24:36:14" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "24:38:23" , 
"departure_time" : "24:39:59" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "24:42:36" , 
"departure_time" : "24:43:35" , 
"distance_traveled" : 13.9629
}, 
{ 
"stop_id" : 110,
"arrival_time" : "24:45:59" , 
"departure_time" : "24:46:01" , 
"distance_traveled" : 15.664
}, 
{ 
"stop_id" : 5,
"arrival_time" : "24:49:02" , 
"departure_time" : "24:49:12" , 
"distance_traveled" : 16.9023
}, 
{ 
"stop_id" : 43,
"arrival_time" : "24:51:10" , 
"departure_time" : "24:52:14" , 
"distance_traveled" : 18.0498
}, 
{ 
"stop_id" : 146,
"arrival_time" : "24:55:04" , 
"departure_time" : "24:56:01" , 
"distance_traveled" : 19.1708
}, 
{ 
"stop_id" : 160,
"arrival_time" : "24:58:57" , 
"departure_time" : "24:59:31" , 
"distance_traveled" : 20.8447
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "25:07:34" , 
"departure_time" : "25:08:10" , 
"distance_traveled" : 27.207
}, 
{ 
"stop_id" : 63,
"arrival_time" : "25:19:36" , 
"departure_time" : "25:19:36" , 
"distance_traveled" : 30.7663
} ], 
"4113" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "05:10:00" , 
"departure_time" : "05:10:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "05:15:12" , 
"departure_time" : "05:15:43" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "05:19:31" , 
"departure_time" : "05:19:54" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "05:22:23" , 
"departure_time" : "05:23:30" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "05:25:07" , 
"departure_time" : "05:25:14" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "05:26:07" , 
"departure_time" : "05:27:13" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "05:31:06" , 
"departure_time" : "05:32:34" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "05:33:28" , 
"departure_time" : "05:34:19" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "05:35:51" , 
"departure_time" : "05:36:09" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "05:39:18" , 
"departure_time" : "05:40:43" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "05:43:25" , 
"departure_time" : "05:43:48" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "05:46:23" , 
"departure_time" : "05:48:03" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "05:50:40" , 
"departure_time" : "05:51:40" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "05:53:00" , 
"departure_time" : "05:54:05" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "05:56:05" , 
"departure_time" : "05:57:13" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "06:00:08" , 
"departure_time" : "06:01:37" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "06:10:29" , 
"departure_time" : "06:11:51" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "06:22:22" , 
"departure_time" : "06:22:22" , 
"distance_traveled" : 30.7655
} ], 
"4114" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "05:10:00" , 
"departure_time" : "05:11:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "05:15:36" , 
"departure_time" : "05:17:10" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "05:20:34" , 
"departure_time" : "05:21:47" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "05:23:13" , 
"departure_time" : "05:23:19" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "05:24:06" , 
"departure_time" : "05:25:06" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "05:27:00" , 
"departure_time" : "05:27:02" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "05:30:02" , 
"departure_time" : "05:30:50" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "05:32:48" , 
"departure_time" : "05:33:42" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "05:35:54" , 
"departure_time" : "05:37:05" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "05:40:11" , 
"departure_time" : "05:40:31" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "05:42:20" , 
"departure_time" : "05:43:49" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "05:47:29" , 
"departure_time" : "05:48:36" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "05:50:07" , 
"departure_time" : "05:51:30" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "05:53:23" , 
"departure_time" : "05:54:53" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "05:56:30" , 
"departure_time" : "05:56:38" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "05:59:08" , 
"departure_time" : "05:59:41" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "06:09:33" , 
"departure_time" : "06:09:38" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "06:21:05" , 
"departure_time" : "06:21:05" , 
"distance_traveled" : 30.7655
} ], 
"4115" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "05:53:00" , 
"departure_time" : "05:54:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "06:00:09" , 
"departure_time" : "06:01:25" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "06:04:16" , 
"departure_time" : "06:05:29" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "06:07:13" , 
"departure_time" : "06:07:31" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "06:09:18" , 
"departure_time" : "06:10:33" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "06:12:15" , 
"departure_time" : "06:12:56" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "06:14:41" , 
"departure_time" : "06:14:46" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "06:17:05" , 
"departure_time" : "06:17:41" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "06:21:36" , 
"departure_time" : "06:21:38" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "06:24:02" , 
"departure_time" : "06:24:10" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "06:28:08" , 
"departure_time" : "06:29:04" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "06:32:56" , 
"departure_time" : "06:33:14" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "06:36:18" , 
"departure_time" : "06:37:42" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "06:40:24" , 
"departure_time" : "06:41:15" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "06:42:51" , 
"departure_time" : "06:44:30" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "06:47:39" , 
"departure_time" : "06:49:12" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "06:57:33" , 
"departure_time" : "06:58:21" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:08:48" , 
"departure_time" : "07:08:48" , 
"distance_traveled" : 30.7655
} ], 
"4116" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "05:53:00" , 
"departure_time" : "05:54:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "05:59:41" , 
"departure_time" : "06:01:19" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "06:04:38" , 
"departure_time" : "06:05:45" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "06:07:07" , 
"departure_time" : "06:07:13" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "06:09:06" , 
"departure_time" : "06:09:21" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "06:11:15" , 
"departure_time" : "06:11:49" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "06:14:34" , 
"departure_time" : "06:15:23" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "06:17:49" , 
"departure_time" : "06:19:02" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "06:22:13" , 
"departure_time" : "06:22:48" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "06:24:35" , 
"departure_time" : "06:24:49" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "06:28:14" , 
"departure_time" : "06:29:00" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "06:32:46" , 
"departure_time" : "06:32:58" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "06:36:12" , 
"departure_time" : "06:36:17" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "06:39:05" , 
"departure_time" : "06:40:37" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "06:43:32" , 
"departure_time" : "06:44:46" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "06:47:14" , 
"departure_time" : "06:48:27" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "06:57:13" , 
"departure_time" : "06:57:53" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:08:40" , 
"departure_time" : "07:08:40" , 
"distance_traveled" : 30.7655
} ], 
"4117" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "06:33:00" , 
"departure_time" : "06:34:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "06:39:44" , 
"departure_time" : "06:40:24" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "06:43:40" , 
"departure_time" : "06:44:27" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "06:46:47" , 
"departure_time" : "06:48:17" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "06:50:30" , 
"departure_time" : "06:52:04" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "06:53:34" , 
"departure_time" : "06:55:03" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "06:56:29" , 
"departure_time" : "06:57:40" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "06:59:11" , 
"departure_time" : "07:00:11" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "07:03:00" , 
"departure_time" : "07:04:03" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "07:06:03" , 
"departure_time" : "07:07:31" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "07:10:28" , 
"departure_time" : "07:10:52" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "07:13:24" , 
"departure_time" : "07:15:02" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "07:18:38" , 
"departure_time" : "07:19:21" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "07:20:43" , 
"departure_time" : "07:21:20" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "07:23:37" , 
"departure_time" : "07:25:14" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "07:28:37" , 
"departure_time" : "07:28:57" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:38:20" , 
"departure_time" : "07:39:19" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:50:59" , 
"departure_time" : "07:50:59" , 
"distance_traveled" : 30.7655
} ], 
"4118" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "06:33:00" , 
"departure_time" : "06:34:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "06:39:39" , 
"departure_time" : "06:40:32" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "06:43:53" , 
"departure_time" : "06:45:21" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "06:47:28" , 
"departure_time" : "06:48:09" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "06:49:41" , 
"departure_time" : "06:50:39" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "06:52:58" , 
"departure_time" : "06:54:09" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "06:56:11" , 
"departure_time" : "06:57:22" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "06:59:11" , 
"departure_time" : "06:59:31" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "07:02:20" , 
"departure_time" : "07:02:33" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "07:05:13" , 
"departure_time" : "07:06:38" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "07:10:25" , 
"departure_time" : "07:11:25" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "07:14:00" , 
"departure_time" : "07:15:37" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "07:18:37" , 
"departure_time" : "07:19:23" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "07:20:46" , 
"departure_time" : "07:21:52" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "07:24:06" , 
"departure_time" : "07:25:23" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "07:28:17" , 
"departure_time" : "07:29:35" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:39:18" , 
"departure_time" : "07:39:23" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:50:05" , 
"departure_time" : "07:50:05" , 
"distance_traveled" : 30.7655
} ], 
"4119" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "14:45:00" , 
"departure_time" : "14:45:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "14:50:13" , 
"departure_time" : "14:51:20" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "14:59:07" , 
"departure_time" : "14:59:32" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "15:01:25" , 
"departure_time" : "15:02:57" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "15:05:32" , 
"departure_time" : "15:06:55" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "15:07:23" , 
"departure_time" : "15:07:55" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "15:09:32" , 
"departure_time" : "15:10:04" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "15:12:32" , 
"departure_time" : "15:13:18" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "15:15:46" , 
"departure_time" : "15:16:43" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "15:18:57" , 
"departure_time" : "15:19:38" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "15:21:41" , 
"departure_time" : "15:21:51" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "15:26:10" , 
"departure_time" : "15:27:37" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "15:30:27" , 
"departure_time" : "15:31:59" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "15:33:32" , 
"departure_time" : "15:35:09" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "15:37:37" , 
"departure_time" : "15:38:00" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "15:39:23" , 
"departure_time" : "15:39:44" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "15:49:21" , 
"departure_time" : "15:50:53" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "16:02:32" , 
"departure_time" : "16:02:32" , 
"distance_traveled" : 30.7655
} ], 
"4120" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "14:45:00" , 
"departure_time" : "14:47:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "14:51:11" , 
"departure_time" : "14:51:36" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "14:58:25" , 
"departure_time" : "14:59:35" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "15:02:10" , 
"departure_time" : "15:03:02" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "15:04:52" , 
"departure_time" : "15:05:27" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "15:06:35" , 
"departure_time" : "15:07:09" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "15:09:34" , 
"departure_time" : "15:09:49" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "15:12:15" , 
"departure_time" : "15:13:39" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "15:16:24" , 
"departure_time" : "15:17:55" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "15:19:31" , 
"departure_time" : "15:20:09" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "15:21:38" , 
"departure_time" : "15:22:50" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "15:27:12" , 
"departure_time" : "15:27:37" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "15:29:25" , 
"departure_time" : "15:29:52" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "15:32:27" , 
"departure_time" : "15:32:47" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "15:36:20" , 
"departure_time" : "15:37:17" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "15:39:57" , 
"departure_time" : "15:41:29" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "15:50:32" , 
"departure_time" : "15:51:01" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "16:01:29" , 
"departure_time" : "16:01:29" , 
"distance_traveled" : 30.7655
} ], 
"4121" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "15:50:00" , 
"departure_time" : "15:51:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "15:55:50" , 
"departure_time" : "15:56:01" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "16:03:11" , 
"departure_time" : "16:04:44" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "16:07:33" , 
"departure_time" : "16:08:05" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "16:08:32" , 
"departure_time" : "16:09:54" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "16:11:22" , 
"departure_time" : "16:12:47" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "16:14:25" , 
"departure_time" : "16:15:42" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "16:17:17" , 
"departure_time" : "16:17:55" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "16:19:38" , 
"departure_time" : "16:19:47" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "16:23:09" , 
"departure_time" : "16:24:32" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "16:27:23" , 
"departure_time" : "16:27:27" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "16:30:04" , 
"departure_time" : "16:30:54" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "16:37:50" , 
"departure_time" : "16:39:04" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "16:41:14" , 
"departure_time" : "16:42:08" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "16:43:54" , 
"departure_time" : "16:44:36" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "16:46:42" , 
"departure_time" : "16:46:57" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:56:15" , 
"departure_time" : "16:57:45" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:10:30" , 
"departure_time" : "17:10:30" , 
"distance_traveled" : 30.7655
} ], 
"4122" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "15:50:00" , 
"departure_time" : "15:51:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "15:55:28" , 
"departure_time" : "15:56:36" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "16:04:08" , 
"departure_time" : "16:04:56" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "16:06:48" , 
"departure_time" : "16:08:06" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "16:09:18" , 
"departure_time" : "16:10:34" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "16:11:16" , 
"departure_time" : "16:11:37" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "16:13:21" , 
"departure_time" : "16:13:50" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "16:16:29" , 
"departure_time" : "16:17:34" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "16:20:05" , 
"departure_time" : "16:21:16" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "16:24:11" , 
"departure_time" : "16:25:06" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "16:26:55" , 
"departure_time" : "16:28:11" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "16:31:16" , 
"departure_time" : "16:31:56" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "16:37:40" , 
"departure_time" : "16:39:19" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "16:41:39" , 
"departure_time" : "16:41:44" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "16:43:05" , 
"departure_time" : "16:44:03" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "16:46:58" , 
"departure_time" : "16:48:12" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:57:14" , 
"departure_time" : "16:57:18" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:09:04" , 
"departure_time" : "17:09:04" , 
"distance_traveled" : 30.7655
} ], 
"4123" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "21:14:00" , 
"departure_time" : "21:14:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "21:20:24" , 
"departure_time" : "21:21:31" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "21:29:07" , 
"departure_time" : "21:29:24" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "21:31:17" , 
"departure_time" : "21:32:18" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "21:34:01" , 
"departure_time" : "21:35:11" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "21:36:10" , 
"departure_time" : "21:37:14" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "21:39:04" , 
"departure_time" : "21:39:43" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "21:41:39" , 
"departure_time" : "21:42:53" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "21:45:14" , 
"departure_time" : "21:45:46" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "21:47:32" , 
"departure_time" : "21:48:20" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "21:50:48" , 
"departure_time" : "21:52:07" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "21:55:19" , 
"departure_time" : "21:56:03" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "21:57:44" , 
"departure_time" : "21:57:58" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "22:00:14" , 
"departure_time" : "22:00:39" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "22:03:25" , 
"departure_time" : "22:04:20" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "22:10:55" , 
"departure_time" : "22:12:27" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "22:21:32" , 
"departure_time" : "22:22:05" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "22:32:33" , 
"departure_time" : "22:32:33" , 
"distance_traveled" : 30.7655
} ], 
"4124" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "21:14:00" , 
"departure_time" : "21:15:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "21:20:50" , 
"departure_time" : "21:21:06" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "21:28:16" , 
"departure_time" : "21:29:08" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "21:31:52" , 
"departure_time" : "21:33:26" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "21:34:34" , 
"departure_time" : "21:35:32" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "21:35:58" , 
"departure_time" : "21:37:37" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "21:39:39" , 
"departure_time" : "21:41:08" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "21:42:29" , 
"departure_time" : "21:43:04" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "21:44:35" , 
"departure_time" : "21:46:10" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "21:48:35" , 
"departure_time" : "21:49:27" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "21:50:52" , 
"departure_time" : "21:51:59" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "21:55:07" , 
"departure_time" : "21:55:44" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "21:57:37" , 
"departure_time" : "21:57:52" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "22:00:15" , 
"departure_time" : "22:01:09" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "22:03:54" , 
"departure_time" : "22:05:08" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "22:11:14" , 
"departure_time" : "22:12:38" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "22:21:24" , 
"departure_time" : "22:22:36" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "22:33:12" , 
"departure_time" : "22:33:12" , 
"distance_traveled" : 30.7655
} ], 
"4125" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "06:21:00" , 
"departure_time" : "06:22:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "06:27:29" , 
"departure_time" : "06:28:23" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "06:32:54" , 
"departure_time" : "06:33:07" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:03:13" , 
"departure_time" : "07:03:24" , 
"distance_traveled" : 27.1955
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:16:11" , 
"departure_time" : "07:16:11" , 
"distance_traveled" : 30.7553
} ], 
"4126" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "06:21:00" , 
"departure_time" : "06:21:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "06:27:34" , 
"departure_time" : "06:27:42" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "06:32:08" , 
"departure_time" : "06:32:26" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:03:18" , 
"departure_time" : "07:04:46" , 
"distance_traveled" : 27.1955
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:17:28" , 
"departure_time" : "07:17:28" , 
"distance_traveled" : 30.7553
} ], 
"4127" :  [ 
{ 
"stop_id" : 5,
"arrival_time" : "08:56:00" , 
"departure_time" : "08:57:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43,
"arrival_time" : "08:58:03" , 
"departure_time" : "08:58:38" , 
"distance_traveled" : 1.147
}, 
{ 
"stop_id" : 146,
"arrival_time" : "09:02:35" , 
"departure_time" : "09:03:07" , 
"distance_traveled" : 2.2684
}, 
{ 
"stop_id" : 160,
"arrival_time" : "09:05:32" , 
"departure_time" : "09:07:05" , 
"distance_traveled" : 3.9428
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:16:33" , 
"departure_time" : "09:17:42" , 
"distance_traveled" : 10.3042
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:28:09" , 
"departure_time" : "09:28:09" , 
"distance_traveled" : 13.864
} ], 
"4128" :  [ 
{ 
"stop_id" : 5,
"arrival_time" : "08:56:00" , 
"departure_time" : "08:57:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43,
"arrival_time" : "08:58:32" , 
"departure_time" : "08:59:24" , 
"distance_traveled" : 1.147
}, 
{ 
"stop_id" : 146,
"arrival_time" : "09:02:52" , 
"departure_time" : "09:04:23" , 
"distance_traveled" : 2.2684
}, 
{ 
"stop_id" : 160,
"arrival_time" : "09:06:31" , 
"departure_time" : "09:07:41" , 
"distance_traveled" : 3.9428
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:16:10" , 
"departure_time" : "09:17:44" , 
"distance_traveled" : 10.3042
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:28:34" , 
"departure_time" : "09:28:34" , 
"distance_traveled" : 13.864
} ], 
"4129" :  [ 
{ 
"stop_id" : 110,
"arrival_time" : "10:24:00" , 
"departure_time" : "10:27:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 5,
"arrival_time" : "10:31:26" , 
"departure_time" : "10:31:49" , 
"distance_traveled" : 1.2568
}, 
{ 
"stop_id" : 43,
"arrival_time" : "10:33:23" , 
"departure_time" : "10:34:02" , 
"distance_traveled" : 2.4038
}, 
{ 
"stop_id" : 146,
"arrival_time" : "10:36:39" , 
"departure_time" : "10:36:53" , 
"distance_traveled" : 3.5252
}, 
{ 
"stop_id" : 160,
"arrival_time" : "10:39:14" , 
"departure_time" : "10:40:15" , 
"distance_traveled" : 5.1996
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "10:50:01" , 
"departure_time" : "10:51:24" , 
"distance_traveled" : 11.561
}, 
{ 
"stop_id" : 63,
"arrival_time" : "11:02:23" , 
"departure_time" : "11:02:23" , 
"distance_traveled" : 15.1208
} ], 
"4130" :  [ 
{ 
"stop_id" : 110,
"arrival_time" : "10:24:00" , 
"departure_time" : "10:25:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 5,
"arrival_time" : "10:30:07" , 
"departure_time" : "10:31:19" , 
"distance_traveled" : 1.2568
}, 
{ 
"stop_id" : 43,
"arrival_time" : "10:34:12" , 
"departure_time" : "10:34:13" , 
"distance_traveled" : 2.4038
}, 
{ 
"stop_id" : 146,
"arrival_time" : "10:36:01" , 
"departure_time" : "10:36:54" , 
"distance_traveled" : 3.5252
}, 
{ 
"stop_id" : 160,
"arrival_time" : "10:39:53" , 
"departure_time" : "10:41:13" , 
"distance_traveled" : 5.1996
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "10:50:20" , 
"departure_time" : "10:51:27" , 
"distance_traveled" : 11.561
}, 
{ 
"stop_id" : 63,
"arrival_time" : "11:02:07" , 
"departure_time" : "11:02:07" , 
"distance_traveled" : 15.1208
} ], 
"4131" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "07:39:00" , 
"departure_time" : "07:40:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "07:45:30" , 
"departure_time" : "07:46:07" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "07:50:37" , 
"departure_time" : "07:52:03" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 114,
"arrival_time" : "07:55:26" , 
"departure_time" : "07:56:37" , 
"distance_traveled" : 6.9089
}, 
{ 
"stop_id" : 62,
"arrival_time" : "08:00:11" , 
"departure_time" : "08:01:24" , 
"distance_traveled" : 9.0697
}, 
{ 
"stop_id" : 42,
"arrival_time" : "08:04:13" , 
"departure_time" : "08:04:46" , 
"distance_traveled" : 11.1521
}, 
{ 
"stop_id" : 132,
"arrival_time" : "08:08:33" , 
"departure_time" : "08:08:41" , 
"distance_traveled" : 13.9572
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:28:08" , 
"departure_time" : "08:29:31" , 
"distance_traveled" : 27.1975
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:41:23" , 
"departure_time" : "08:41:23" , 
"distance_traveled" : 30.7576
} ], 
"4132" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "07:39:00" , 
"departure_time" : "07:41:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "07:46:23" , 
"departure_time" : "07:47:02" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "07:50:39" , 
"departure_time" : "07:50:50" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 114,
"arrival_time" : "07:54:11" , 
"departure_time" : "07:54:13" , 
"distance_traveled" : 6.9089
}, 
{ 
"stop_id" : 62,
"arrival_time" : "07:59:02" , 
"departure_time" : "08:00:17" , 
"distance_traveled" : 9.0697
}, 
{ 
"stop_id" : 42,
"arrival_time" : "08:04:15" , 
"departure_time" : "08:05:06" , 
"distance_traveled" : 11.1521
}, 
{ 
"stop_id" : 132,
"arrival_time" : "08:08:51" , 
"departure_time" : "08:09:40" , 
"distance_traveled" : 13.9572
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:28:49" , 
"departure_time" : "08:29:27" , 
"distance_traveled" : 27.1975
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:40:38" , 
"departure_time" : "08:40:38" , 
"distance_traveled" : 30.7576
} ], 
"4133" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "07:19:00" , 
"departure_time" : "07:20:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "07:24:28" , 
"departure_time" : "07:24:32" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "07:29:04" , 
"departure_time" : "07:29:24" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "07:32:20" , 
"departure_time" : "07:32:55" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "07:34:35" , 
"departure_time" : "07:35:18" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "07:36:43" , 
"departure_time" : "07:37:07" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "07:40:24" , 
"departure_time" : "07:41:31" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "07:43:07" , 
"departure_time" : "07:43:23" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "07:46:16" , 
"departure_time" : "07:46:48" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "07:49:32" , 
"departure_time" : "07:49:39" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "07:54:07" , 
"departure_time" : "07:54:53" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "07:58:46" , 
"departure_time" : "07:59:01" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "08:02:15" , 
"departure_time" : "08:02:45" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "08:05:30" , 
"departure_time" : "08:06:30" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "08:09:00" , 
"departure_time" : "08:09:37" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "08:12:37" , 
"departure_time" : "08:12:52" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:22:15" , 
"departure_time" : "08:23:38" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:35:23" , 
"departure_time" : "08:35:23" , 
"distance_traveled" : 30.7655
} ], 
"4134" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "05:17:00" , 
"departure_time" : "05:19:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "05:22:45" , 
"departure_time" : "05:23:50" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "05:27:05" , 
"departure_time" : "05:28:05" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "05:30:00" , 
"departure_time" : "05:31:01" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "05:33:01" , 
"departure_time" : "05:33:44" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "05:34:43" , 
"departure_time" : "05:34:52" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "05:37:09" , 
"departure_time" : "05:38:36" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "05:41:27" , 
"departure_time" : "05:42:11" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "05:44:44" , 
"departure_time" : "05:46:22" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "05:48:38" , 
"departure_time" : "05:48:49" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "05:52:11" , 
"departure_time" : "05:53:48" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "05:57:37" , 
"departure_time" : "05:58:52" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "06:01:15" , 
"departure_time" : "06:02:26" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "06:04:11" , 
"departure_time" : "06:05:12" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "06:07:01" , 
"departure_time" : "06:08:38" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "06:11:37" , 
"departure_time" : "06:12:39" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "06:21:02" , 
"departure_time" : "06:22:37" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "06:33:35" , 
"departure_time" : "06:33:35" , 
"distance_traveled" : 30.7655
} ], 
"4135" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "06:00:00" , 
"departure_time" : "06:03:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "06:06:31" , 
"departure_time" : "06:06:32" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "06:09:01" , 
"departure_time" : "06:09:35" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "06:12:34" , 
"departure_time" : "06:14:12" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "06:16:38" , 
"departure_time" : "06:17:05" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "06:17:27" , 
"departure_time" : "06:18:37" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "06:21:10" , 
"departure_time" : "06:22:09" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "06:23:59" , 
"departure_time" : "06:24:59" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "06:28:00" , 
"departure_time" : "06:28:09" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "06:30:09" , 
"departure_time" : "06:30:28" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "06:35:19" , 
"departure_time" : "06:35:22" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "06:39:03" , 
"departure_time" : "06:39:14" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "06:43:11" , 
"departure_time" : "06:44:31" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "06:47:20" , 
"departure_time" : "06:47:55" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "06:49:35" , 
"departure_time" : "06:50:13" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "06:53:38" , 
"departure_time" : "06:54:55" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "07:04:17" , 
"departure_time" : "07:04:31" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "07:15:14" , 
"departure_time" : "07:15:14" , 
"distance_traveled" : 30.7655
} ], 
"4136" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "07:00:00" , 
"departure_time" : "07:01:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "07:06:15" , 
"departure_time" : "07:07:45" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "07:10:30" , 
"departure_time" : "07:11:01" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "07:12:31" , 
"departure_time" : "07:13:58" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "07:16:27" , 
"departure_time" : "07:17:44" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "07:18:17" , 
"departure_time" : "07:18:50" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "07:20:33" , 
"departure_time" : "07:21:34" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "07:24:01" , 
"departure_time" : "07:25:22" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "07:28:21" , 
"departure_time" : "07:29:38" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "07:31:17" , 
"departure_time" : "07:32:01" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "07:35:44" , 
"departure_time" : "07:37:14" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "07:40:30" , 
"departure_time" : "07:42:04" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "07:44:34" , 
"departure_time" : "07:45:33" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "07:46:59" , 
"departure_time" : "07:48:26" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "07:50:27" , 
"departure_time" : "07:51:58" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "07:54:31" , 
"departure_time" : "07:55:43" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:04:12" , 
"departure_time" : "08:05:42" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "08:16:30" , 
"departure_time" : "08:16:30" , 
"distance_traveled" : 30.7655
} ], 
"4137" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "07:57:00" , 
"departure_time" : "07:59:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "08:03:06" , 
"departure_time" : "08:04:28" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "08:07:22" , 
"departure_time" : "08:08:38" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "08:10:16" , 
"departure_time" : "08:11:12" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "08:12:56" , 
"departure_time" : "08:13:24" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "08:14:28" , 
"departure_time" : "08:14:34" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "08:17:06" , 
"departure_time" : "08:18:01" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "08:20:55" , 
"departure_time" : "08:22:17" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "08:25:22" , 
"departure_time" : "08:27:02" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "08:28:40" , 
"departure_time" : "08:29:05" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "08:32:25" , 
"departure_time" : "08:33:36" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "08:38:11" , 
"departure_time" : "08:38:16" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "08:44:05" , 
"departure_time" : "08:45:18" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "08:48:13" , 
"departure_time" : "08:49:43" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "08:51:30" , 
"departure_time" : "08:52:57" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "08:54:27" , 
"departure_time" : "08:54:32" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:04:05" , 
"departure_time" : "09:04:46" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "09:16:41" , 
"departure_time" : "09:16:41" , 
"distance_traveled" : 30.7655
} ], 
"4138" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "09:05:00" , 
"departure_time" : "09:06:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "09:10:56" , 
"departure_time" : "09:11:04" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "09:18:08" , 
"departure_time" : "09:19:48" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "09:22:40" , 
"departure_time" : "09:23:42" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "09:24:02" , 
"departure_time" : "09:25:04" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "09:26:02" , 
"departure_time" : "09:26:54" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "09:29:52" , 
"departure_time" : "09:30:27" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "09:31:35" , 
"departure_time" : "09:32:17" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "09:35:42" , 
"departure_time" : "09:37:20" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "09:39:38" , 
"departure_time" : "09:40:05" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "09:43:27" , 
"departure_time" : "09:43:37" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "09:47:10" , 
"departure_time" : "09:48:29" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "09:52:19" , 
"departure_time" : "09:53:43" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "09:55:24" , 
"departure_time" : "09:55:40" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "09:57:16" , 
"departure_time" : "09:57:17" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "10:01:01" , 
"departure_time" : "10:02:10" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "10:12:09" , 
"departure_time" : "10:12:30" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "10:23:21" , 
"departure_time" : "10:23:21" , 
"distance_traveled" : 30.7655
} ], 
"4139" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "10:02:00" , 
"departure_time" : "10:02:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "10:07:20" , 
"departure_time" : "10:08:00" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "10:11:40" , 
"departure_time" : "10:13:16" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "10:15:36" , 
"departure_time" : "10:17:05" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "10:18:29" , 
"departure_time" : "10:19:02" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "10:19:33" , 
"departure_time" : "10:20:39" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "10:23:06" , 
"departure_time" : "10:23:45" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "10:25:39" , 
"departure_time" : "10:25:40" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "10:29:01" , 
"departure_time" : "10:30:07" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "10:33:06" , 
"departure_time" : "10:34:19" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "10:38:13" , 
"departure_time" : "10:38:37" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "10:42:24" , 
"departure_time" : "10:42:26" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "10:49:02" , 
"departure_time" : "10:50:04" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "10:53:02" , 
"departure_time" : "10:54:29" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "10:56:27" , 
"departure_time" : "10:57:54" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "10:59:27" , 
"departure_time" : "11:00:36" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "11:10:09" , 
"departure_time" : "11:10:46" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "11:21:37" , 
"departure_time" : "11:21:37" , 
"distance_traveled" : 30.7655
} ], 
"4140" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "12:02:00" , 
"departure_time" : "12:02:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "12:07:07" , 
"departure_time" : "12:07:24" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "12:11:17" , 
"departure_time" : "12:12:04" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "12:14:47" , 
"departure_time" : "12:15:50" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "12:18:03" , 
"departure_time" : "12:19:40" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "12:20:37" , 
"departure_time" : "12:20:46" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "12:22:09" , 
"departure_time" : "12:22:18" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "12:25:09" , 
"departure_time" : "12:26:36" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "12:30:27" , 
"departure_time" : "12:31:01" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "12:32:34" , 
"departure_time" : "12:33:17" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "12:37:43" , 
"departure_time" : "12:38:07" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "12:42:24" , 
"departure_time" : "12:43:08" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "12:49:44" , 
"departure_time" : "12:49:56" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "12:52:12" , 
"departure_time" : "12:53:38" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "12:56:26" , 
"departure_time" : "12:57:56" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "12:59:30" , 
"departure_time" : "13:01:03" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "13:10:33" , 
"departure_time" : "13:11:23" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "13:21:50" , 
"departure_time" : "13:21:50" , 
"distance_traveled" : 30.7655
} ], 
"4141" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "14:02:00" , 
"departure_time" : "14:04:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "14:08:19" , 
"departure_time" : "14:08:53" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "14:11:34" , 
"departure_time" : "14:12:41" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "14:15:07" , 
"departure_time" : "14:15:16" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "14:17:09" , 
"departure_time" : "14:18:39" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "14:20:30" , 
"departure_time" : "14:21:54" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "14:23:24" , 
"departure_time" : "14:24:06" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "14:25:42" , 
"departure_time" : "14:26:00" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "14:29:18" , 
"departure_time" : "14:29:53" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "14:32:35" , 
"departure_time" : "14:33:48" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "14:38:13" , 
"departure_time" : "14:38:40" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "14:42:27" , 
"departure_time" : "14:42:39" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "14:49:12" , 
"departure_time" : "14:50:37" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "14:53:25" , 
"departure_time" : "14:54:17" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "14:55:52" , 
"departure_time" : "14:56:11" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "14:58:19" , 
"departure_time" : "14:59:19" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "15:10:00" , 
"departure_time" : "15:10:11" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "15:21:11" , 
"departure_time" : "15:21:11" , 
"distance_traveled" : 30.7655
} ], 
"4142" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "16:05:00" , 
"departure_time" : "16:06:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "16:11:06" , 
"departure_time" : "16:12:12" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "16:15:06" , 
"departure_time" : "16:15:24" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "16:17:18" , 
"departure_time" : "16:18:57" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "16:20:39" , 
"departure_time" : "16:21:44" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "16:23:05" , 
"departure_time" : "16:24:04" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "16:25:59" , 
"departure_time" : "16:26:48" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "16:28:49" , 
"departure_time" : "16:29:16" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "16:31:27" , 
"departure_time" : "16:31:32" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "16:34:05" , 
"departure_time" : "16:34:22" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "16:39:17" , 
"departure_time" : "16:39:45" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "16:44:28" , 
"departure_time" : "16:45:35" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "16:50:07" , 
"departure_time" : "16:50:50" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "16:52:43" , 
"departure_time" : "16:54:09" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "16:56:26" , 
"departure_time" : "16:57:07" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "16:59:41" , 
"departure_time" : "17:00:33" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:09:52" , 
"departure_time" : "17:11:11" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "17:22:19" , 
"departure_time" : "17:22:19" , 
"distance_traveled" : 30.7655
} ], 
"4143" :  [ 
{ 
"stop_id" : 142,
"arrival_time" : "21:01:00" , 
"departure_time" : "21:03:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 100,
"arrival_time" : "21:07:08" , 
"departure_time" : "21:08:46" , 
"distance_traveled" : 2.6172
}, 
{ 
"stop_id" : 118,
"arrival_time" : "21:11:38" , 
"departure_time" : "21:12:00" , 
"distance_traveled" : 4.9587
}, 
{ 
"stop_id" : 90,
"arrival_time" : "21:13:22" , 
"departure_time" : "21:13:56" , 
"distance_traveled" : 6.2155
}, 
{ 
"stop_id" : 114,
"arrival_time" : "21:16:34" , 
"departure_time" : "21:17:13" , 
"distance_traveled" : 6.9087
}, 
{ 
"stop_id" : 159,
"arrival_time" : "21:18:39" , 
"departure_time" : "21:20:04" , 
"distance_traveled" : 7.7712
}, 
{ 
"stop_id" : 62,
"arrival_time" : "21:22:25" , 
"departure_time" : "21:23:00" , 
"distance_traveled" : 9.0693
}, 
{ 
"stop_id" : 156,
"arrival_time" : "21:24:35" , 
"departure_time" : "21:25:15" , 
"distance_traveled" : 9.9848
}, 
{ 
"stop_id" : 42,
"arrival_time" : "21:27:40" , 
"departure_time" : "21:28:52" , 
"distance_traveled" : 11.158
}, 
{ 
"stop_id" : 111,
"arrival_time" : "21:31:12" , 
"departure_time" : "21:32:16" , 
"distance_traveled" : 12.6536
}, 
{ 
"stop_id" : 132,
"arrival_time" : "21:36:04" , 
"departure_time" : "21:36:35" , 
"distance_traveled" : 13.9625
}, 
{ 
"stop_id" : 110,
"arrival_time" : "21:39:31" , 
"departure_time" : "21:40:17" , 
"distance_traveled" : 15.6633
}, 
{ 
"stop_id" : 5,
"arrival_time" : "21:46:46" , 
"departure_time" : "21:47:47" , 
"distance_traveled" : 16.9015
}, 
{ 
"stop_id" : 43,
"arrival_time" : "21:50:01" , 
"departure_time" : "21:51:37" , 
"distance_traveled" : 18.0485
}, 
{ 
"stop_id" : 146,
"arrival_time" : "21:53:36" , 
"departure_time" : "21:53:44" , 
"distance_traveled" : 19.1699
}, 
{ 
"stop_id" : 160,
"arrival_time" : "21:56:08" , 
"departure_time" : "21:56:22" , 
"distance_traveled" : 20.8443
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "22:08:14" , 
"departure_time" : "22:09:26" , 
"distance_traveled" : 27.2057
}, 
{ 
"stop_id" : 63,
"arrival_time" : "22:22:12" , 
"departure_time" : "22:22:12" , 
"distance_traveled" : 30.7655
} ], 
"4144" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "24:45:00" , 
"departure_time" : "24:46:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "24:55:07" , 
"departure_time" : "24:55:45" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "25:04:38" , 
"departure_time" : "25:04:56" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "25:07:18" , 
"departure_time" : "25:07:57" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "25:10:39" , 
"departure_time" : "25:11:51" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "25:14:12" , 
"departure_time" : "25:15:18" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "25:17:06" , 
"departure_time" : "25:18:27" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "25:22:21" , 
"departure_time" : "25:23:28" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "25:25:07" , 
"departure_time" : "25:25:50" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "25:27:43" , 
"departure_time" : "25:28:21" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "25:29:38" , 
"departure_time" : "25:30:50" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "25:33:12" , 
"departure_time" : "25:34:38" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "25:36:26" , 
"departure_time" : "25:36:32" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "25:38:06" , 
"departure_time" : "25:39:31" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "25:41:25" , 
"departure_time" : "25:41:46" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "25:44:21" , 
"departure_time" : "25:45:51" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "25:49:30" , 
"departure_time" : "25:50:32" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "25:56:02" , 
"departure_time" : "25:56:02" , 
"distance_traveled" : 30.6951
} ], 
"4145" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "24:45:00" , 
"departure_time" : "24:47:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "24:56:19" , 
"departure_time" : "24:57:11" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "25:04:52" , 
"departure_time" : "25:05:47" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "25:07:55" , 
"departure_time" : "25:08:14" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "25:10:19" , 
"departure_time" : "25:11:29" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "25:14:10" , 
"departure_time" : "25:14:23" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "25:16:13" , 
"departure_time" : "25:16:52" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "25:21:39" , 
"departure_time" : "25:22:45" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "25:25:06" , 
"departure_time" : "25:25:46" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "25:27:40" , 
"departure_time" : "25:28:19" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "25:29:39" , 
"departure_time" : "25:31:19" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "25:33:40" , 
"departure_time" : "25:35:12" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "25:36:32" , 
"departure_time" : "25:36:45" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "25:38:13" , 
"departure_time" : "25:38:39" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "25:40:26" , 
"departure_time" : "25:41:16" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "25:44:50" , 
"departure_time" : "25:45:14" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "25:48:24" , 
"departure_time" : "25:49:18" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "25:55:54" , 
"departure_time" : "25:55:54" , 
"distance_traveled" : 30.6951
} ], 
"4146" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "24:45:00" , 
"departure_time" : "24:46:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "24:56:03" , 
"departure_time" : "24:57:35" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "25:05:32" , 
"departure_time" : "25:06:35" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "25:08:03" , 
"departure_time" : "25:08:51" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "25:10:48" , 
"departure_time" : "25:11:48" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "25:14:00" , 
"departure_time" : "25:14:49" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "25:16:49" , 
"departure_time" : "25:17:36" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "25:21:47" , 
"departure_time" : "25:23:14" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "25:25:27" , 
"departure_time" : "25:25:52" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "25:27:25" , 
"departure_time" : "25:28:10" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "25:29:45" , 
"departure_time" : "25:30:25" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "25:32:40" , 
"departure_time" : "25:34:08" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "25:36:28" , 
"departure_time" : "25:37:24" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "25:38:56" , 
"departure_time" : "25:39:06" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "25:40:10" , 
"departure_time" : "25:41:17" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "25:45:07" , 
"departure_time" : "25:45:28" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "25:48:21" , 
"departure_time" : "25:48:34" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "25:55:13" , 
"departure_time" : "25:55:13" , 
"distance_traveled" : 30.6951
} ], 
"4147" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "08:13:00" , 
"departure_time" : "08:14:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:24:31" , 
"departure_time" : "08:25:36" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "08:34:05" , 
"departure_time" : "08:34:55" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "08:36:50" , 
"departure_time" : "08:36:52" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "08:39:02" , 
"departure_time" : "08:40:06" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "08:43:04" , 
"departure_time" : "08:43:36" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "08:46:32" , 
"departure_time" : "08:47:37" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "08:51:05" , 
"departure_time" : "08:52:28" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "08:54:23" , 
"departure_time" : "08:55:14" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "08:57:51" , 
"departure_time" : "08:58:48" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "08:59:57" , 
"departure_time" : "09:00:21" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "09:03:24" , 
"departure_time" : "09:03:59" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "09:06:35" , 
"departure_time" : "09:06:59" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "09:08:24" , 
"departure_time" : "09:09:47" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "09:11:23" , 
"departure_time" : "09:12:20" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "09:14:57" , 
"departure_time" : "09:15:45" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "09:18:48" , 
"departure_time" : "09:19:35" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "09:24:47" , 
"departure_time" : "09:24:47" , 
"distance_traveled" : 30.6951
} ], 
"4148" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "10:13:00" , 
"departure_time" : "10:15:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "10:24:25" , 
"departure_time" : "10:24:27" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "10:33:02" , 
"departure_time" : "10:33:54" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "10:36:52" , 
"departure_time" : "10:37:35" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "10:39:43" , 
"departure_time" : "10:40:03" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "10:42:20" , 
"departure_time" : "10:43:47" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "10:47:27" , 
"departure_time" : "10:48:13" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "10:50:46" , 
"departure_time" : "10:52:20" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "10:54:34" , 
"departure_time" : "10:55:36" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "10:58:02" , 
"departure_time" : "10:58:52" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "10:59:50" , 
"departure_time" : "11:00:15" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "11:03:25" , 
"departure_time" : "11:04:12" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "11:06:47" , 
"departure_time" : "11:08:20" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "11:09:33" , 
"departure_time" : "11:09:43" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "11:10:10" , 
"departure_time" : "11:11:09" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "11:14:59" , 
"departure_time" : "11:15:52" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "11:18:53" , 
"departure_time" : "11:19:23" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "11:24:30" , 
"departure_time" : "11:24:30" , 
"distance_traveled" : 30.6951
} ], 
"4149" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "08:13:00" , 
"departure_time" : "08:14:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:23:59" , 
"departure_time" : "08:25:28" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "08:34:29" , 
"departure_time" : "08:34:34" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "08:36:05" , 
"departure_time" : "08:37:06" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "08:40:01" , 
"departure_time" : "08:40:44" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "08:42:43" , 
"departure_time" : "08:43:10" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "08:46:27" , 
"departure_time" : "08:46:56" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "08:50:29" , 
"departure_time" : "08:51:58" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "08:54:29" , 
"departure_time" : "08:55:03" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "08:57:34" , 
"departure_time" : "08:58:04" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "08:59:30" , 
"departure_time" : "09:00:28" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "09:03:58" , 
"departure_time" : "09:05:06" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "09:07:08" , 
"departure_time" : "09:08:21" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "09:09:13" , 
"departure_time" : "09:10:12" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "09:10:59" , 
"departure_time" : "09:11:09" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "09:14:10" , 
"departure_time" : "09:14:31" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "09:18:21" , 
"departure_time" : "09:18:51" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "09:24:30" , 
"departure_time" : "09:24:30" , 
"distance_traveled" : 30.6951
} ], 
"4150" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "12:13:00" , 
"departure_time" : "12:13:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "12:23:21" , 
"departure_time" : "12:24:06" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "12:33:45" , 
"departure_time" : "12:33:50" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "12:37:05" , 
"departure_time" : "12:37:23" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "12:40:18" , 
"departure_time" : "12:40:43" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "12:43:25" , 
"departure_time" : "12:43:52" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "12:47:27" , 
"departure_time" : "12:48:59" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "12:52:32" , 
"departure_time" : "12:53:03" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "12:54:31" , 
"departure_time" : "12:54:50" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "12:58:19" , 
"departure_time" : "12:58:24" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "13:01:05" , 
"departure_time" : "13:01:38" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "13:04:33" , 
"departure_time" : "13:05:44" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "13:08:11" , 
"departure_time" : "13:08:52" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "13:09:41" , 
"departure_time" : "13:10:23" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "13:11:42" , 
"departure_time" : "13:12:19" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "13:15:37" , 
"departure_time" : "13:16:48" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "13:20:11" , 
"departure_time" : "13:21:10" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "13:25:59" , 
"departure_time" : "13:25:59" , 
"distance_traveled" : 30.6951
} ], 
"4151" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "10:13:00" , 
"departure_time" : "10:14:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "10:23:14" , 
"departure_time" : "10:24:33" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "10:34:19" , 
"departure_time" : "10:35:23" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "10:37:04" , 
"departure_time" : "10:38:24" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "10:40:20" , 
"departure_time" : "10:40:54" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "10:42:34" , 
"departure_time" : "10:43:27" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "10:46:53" , 
"departure_time" : "10:47:23" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "10:50:30" , 
"departure_time" : "10:50:43" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "10:53:13" , 
"departure_time" : "10:54:39" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "10:58:26" , 
"departure_time" : "11:00:02" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "11:00:36" , 
"departure_time" : "11:01:49" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "11:04:13" , 
"departure_time" : "11:04:30" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "11:06:17" , 
"departure_time" : "11:06:38" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "11:08:21" , 
"departure_time" : "11:08:40" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "11:10:19" , 
"departure_time" : "11:11:15" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "11:14:56" , 
"departure_time" : "11:16:25" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "11:19:29" , 
"departure_time" : "11:21:00" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "11:25:31" , 
"departure_time" : "11:25:31" , 
"distance_traveled" : 30.6951
} ], 
"4152" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "14:13:00" , 
"departure_time" : "14:15:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "14:23:38" , 
"departure_time" : "14:24:14" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "14:33:36" , 
"departure_time" : "14:34:57" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "14:37:21" , 
"departure_time" : "14:38:29" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "14:40:08" , 
"departure_time" : "14:41:02" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "14:42:54" , 
"departure_time" : "14:43:49" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "14:46:55" , 
"departure_time" : "14:47:57" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "14:51:02" , 
"departure_time" : "14:52:33" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "14:54:31" , 
"departure_time" : "14:54:37" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "14:57:06" , 
"departure_time" : "14:58:14" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "15:01:08" , 
"departure_time" : "15:02:03" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "15:03:55" , 
"departure_time" : "15:04:29" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "15:06:34" , 
"departure_time" : "15:07:50" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "15:09:16" , 
"departure_time" : "15:09:47" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "15:10:31" , 
"departure_time" : "15:11:38" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "15:15:07" , 
"departure_time" : "15:15:09" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "15:18:02" , 
"departure_time" : "15:18:31" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "15:24:29" , 
"departure_time" : "15:24:29" , 
"distance_traveled" : 30.6951
} ], 
"4153" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "12:13:00" , 
"departure_time" : "12:14:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "12:23:35" , 
"departure_time" : "12:24:08" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "12:33:33" , 
"departure_time" : "12:34:39" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "12:38:06" , 
"departure_time" : "12:39:06" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "12:41:00" , 
"departure_time" : "12:41:49" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "12:43:49" , 
"departure_time" : "12:44:29" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "12:47:40" , 
"departure_time" : "12:48:56" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "12:52:16" , 
"departure_time" : "12:52:54" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "12:54:38" , 
"departure_time" : "12:55:54" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "12:59:16" , 
"departure_time" : "12:59:30" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "13:01:14" , 
"departure_time" : "13:01:26" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "13:04:12" , 
"departure_time" : "13:04:49" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "13:07:37" , 
"departure_time" : "13:08:54" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "13:10:17" , 
"departure_time" : "13:11:50" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "13:12:33" , 
"departure_time" : "13:13:00" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "13:15:27" , 
"departure_time" : "13:16:52" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "13:20:25" , 
"departure_time" : "13:21:13" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "13:25:48" , 
"departure_time" : "13:25:48" , 
"distance_traveled" : 30.6951
} ], 
"4154" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:13:00" , 
"departure_time" : "16:15:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:24:38" , 
"departure_time" : "16:24:46" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "16:33:08" , 
"departure_time" : "16:33:26" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "16:37:18" , 
"departure_time" : "16:38:56" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "16:41:38" , 
"departure_time" : "16:41:44" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "16:43:06" , 
"departure_time" : "16:43:10" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "16:47:04" , 
"departure_time" : "16:47:24" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "16:51:20" , 
"departure_time" : "16:51:24" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "16:54:04" , 
"departure_time" : "16:54:31" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "16:58:27" , 
"departure_time" : "16:59:17" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "17:00:50" , 
"departure_time" : "17:01:25" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "17:04:35" , 
"departure_time" : "17:05:29" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "17:07:54" , 
"departure_time" : "17:09:29" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "17:10:35" , 
"departure_time" : "17:10:58" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "17:11:23" , 
"departure_time" : "17:11:25" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "17:15:02" , 
"departure_time" : "17:16:29" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "17:20:27" , 
"departure_time" : "17:21:41" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "17:26:14" , 
"departure_time" : "17:26:14" , 
"distance_traveled" : 30.6951
} ], 
"4155" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "14:13:00" , 
"departure_time" : "14:14:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "14:23:33" , 
"departure_time" : "14:24:11" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "14:33:38" , 
"departure_time" : "14:34:09" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "14:36:31" , 
"departure_time" : "14:37:56" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "14:40:25" , 
"departure_time" : "14:41:55" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "14:43:30" , 
"departure_time" : "14:43:39" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "14:46:09" , 
"departure_time" : "14:46:31" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "14:50:22" , 
"departure_time" : "14:51:32" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "14:54:10" , 
"departure_time" : "14:55:07" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "14:57:57" , 
"departure_time" : "14:58:59" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "15:01:02" , 
"departure_time" : "15:01:26" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "15:03:24" , 
"departure_time" : "15:04:22" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "15:06:58" , 
"departure_time" : "15:08:37" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "15:09:39" , 
"departure_time" : "15:10:56" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "15:11:17" , 
"departure_time" : "15:12:55" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "15:15:38" , 
"departure_time" : "15:17:07" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "15:19:29" , 
"departure_time" : "15:20:29" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "15:25:00" , 
"departure_time" : "15:25:00" , 
"distance_traveled" : 30.6951
} ], 
"4156" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:13:00" , 
"departure_time" : "17:14:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:23:48" , 
"departure_time" : "17:24:58" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "17:34:10" , 
"departure_time" : "17:34:31" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "17:36:21" , 
"departure_time" : "17:37:45" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "17:41:24" , 
"departure_time" : "17:43:00" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "17:44:36" , 
"departure_time" : "17:45:27" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "17:46:51" , 
"departure_time" : "17:46:53" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "17:50:02" , 
"departure_time" : "17:50:44" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "17:54:42" , 
"departure_time" : "17:55:21" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "17:57:39" , 
"departure_time" : "17:59:08" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "18:01:29" , 
"departure_time" : "18:02:05" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "18:03:36" , 
"departure_time" : "18:04:58" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "18:07:22" , 
"departure_time" : "18:08:45" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "18:10:23" , 
"departure_time" : "18:11:25" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "18:12:02" , 
"departure_time" : "18:12:11" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "18:14:09" , 
"departure_time" : "18:15:26" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "18:20:17" , 
"departure_time" : "18:21:41" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "18:26:24" , 
"departure_time" : "18:26:24" , 
"distance_traveled" : 30.6951
} ], 
"4157" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:13:00" , 
"departure_time" : "16:15:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:23:37" , 
"departure_time" : "16:24:18" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "16:33:41" , 
"departure_time" : "16:34:47" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "16:38:06" , 
"departure_time" : "16:38:33" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "16:40:27" , 
"departure_time" : "16:41:44" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "16:44:17" , 
"departure_time" : "16:45:05" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "16:47:48" , 
"departure_time" : "16:48:22" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "16:51:34" , 
"departure_time" : "16:51:59" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "16:54:25" , 
"departure_time" : "16:55:57" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "16:59:32" , 
"departure_time" : "17:00:08" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "17:00:36" , 
"departure_time" : "17:02:03" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "17:05:27" , 
"departure_time" : "17:06:21" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "17:07:54" , 
"departure_time" : "17:08:32" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "17:09:38" , 
"departure_time" : "17:10:10" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "17:11:32" , 
"departure_time" : "17:11:52" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "17:15:20" , 
"departure_time" : "17:16:02" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "17:19:42" , 
"departure_time" : "17:20:57" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "17:26:15" , 
"departure_time" : "17:26:15" , 
"distance_traveled" : 30.6951
} ], 
"4158" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:21:00" , 
"departure_time" : "18:23:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:32:19" , 
"departure_time" : "18:33:02" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "18:41:43" , 
"departure_time" : "18:42:55" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "18:45:12" , 
"departure_time" : "18:46:22" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "18:49:10" , 
"departure_time" : "18:49:36" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "18:51:26" , 
"departure_time" : "18:52:22" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "18:54:56" , 
"departure_time" : "18:56:17" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "19:00:21" , 
"departure_time" : "19:01:38" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "19:03:17" , 
"departure_time" : "19:03:21" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "19:05:04" , 
"departure_time" : "19:06:06" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "19:10:02" , 
"departure_time" : "19:10:41" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "19:11:39" , 
"departure_time" : "19:13:15" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "19:16:36" , 
"departure_time" : "19:18:05" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "19:18:29" , 
"departure_time" : "19:19:03" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "19:19:34" , 
"departure_time" : "19:20:55" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "19:24:21" , 
"departure_time" : "19:25:38" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "19:28:17" , 
"departure_time" : "19:29:03" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "19:33:46" , 
"departure_time" : "19:33:46" , 
"distance_traveled" : 30.6951
} ], 
"4159" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:13:00" , 
"departure_time" : "17:15:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:24:40" , 
"departure_time" : "17:24:42" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "17:33:02" , 
"departure_time" : "17:34:08" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "17:37:06" , 
"departure_time" : "17:38:21" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "17:41:15" , 
"departure_time" : "17:41:46" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "17:43:31" , 
"departure_time" : "17:44:13" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "17:46:42" , 
"departure_time" : "17:46:54" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "17:50:12" , 
"departure_time" : "17:50:13" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "17:54:01" , 
"departure_time" : "17:55:27" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "17:58:26" , 
"departure_time" : "17:59:44" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "18:01:18" , 
"departure_time" : "18:01:19" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "18:03:01" , 
"departure_time" : "18:03:21" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "18:06:20" , 
"departure_time" : "18:07:56" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "18:10:36" , 
"departure_time" : "18:12:09" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "18:12:33" , 
"departure_time" : "18:13:05" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "18:14:32" , 
"departure_time" : "18:15:46" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "18:20:14" , 
"departure_time" : "18:21:40" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "18:26:26" , 
"departure_time" : "18:26:26" , 
"distance_traveled" : 30.6951
} ], 
"4160" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "21:21:00" , 
"departure_time" : "21:23:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "21:32:29" , 
"departure_time" : "21:32:30" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "21:40:01" , 
"departure_time" : "21:41:25" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "21:45:24" , 
"departure_time" : "21:46:56" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "21:48:32" , 
"departure_time" : "21:50:01" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "21:51:29" , 
"departure_time" : "21:51:35" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "21:53:06" , 
"departure_time" : "21:53:53" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "21:57:47" , 
"departure_time" : "21:58:04" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "22:00:17" , 
"departure_time" : "22:01:50" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "22:05:33" , 
"departure_time" : "22:06:57" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "22:07:24" , 
"departure_time" : "22:08:07" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "22:10:43" , 
"departure_time" : "22:11:50" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "22:14:07" , 
"departure_time" : "22:15:42" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "22:16:35" , 
"departure_time" : "22:18:06" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "22:19:31" , 
"departure_time" : "22:20:34" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "22:22:03" , 
"departure_time" : "22:22:50" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "22:26:47" , 
"departure_time" : "22:26:55" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "22:33:08" , 
"departure_time" : "22:33:08" , 
"distance_traveled" : 30.6951
} ], 
"4161" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:21:00" , 
"departure_time" : "18:22:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:32:26" , 
"departure_time" : "18:33:55" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "18:42:29" , 
"departure_time" : "18:42:31" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "18:44:02" , 
"departure_time" : "18:45:35" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "18:49:33" , 
"departure_time" : "18:50:45" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "18:52:12" , 
"departure_time" : "18:53:27" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "18:55:15" , 
"departure_time" : "18:56:15" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "19:00:00" , 
"departure_time" : "19:00:42" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "19:02:42" , 
"departure_time" : "19:03:42" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "19:06:00" , 
"departure_time" : "19:06:17" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "19:09:17" , 
"departure_time" : "19:09:40" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "19:11:23" , 
"departure_time" : "19:12:46" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "19:16:23" , 
"departure_time" : "19:16:36" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "19:17:13" , 
"departure_time" : "19:18:38" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "19:20:25" , 
"departure_time" : "19:20:49" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "19:23:24" , 
"departure_time" : "19:23:41" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "19:27:17" , 
"departure_time" : "19:28:39" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "19:34:22" , 
"departure_time" : "19:34:22" , 
"distance_traveled" : 30.6951
} ], 
"4162" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "23:17:00" , 
"departure_time" : "23:19:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "23:28:09" , 
"departure_time" : "23:29:10" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "23:37:01" , 
"departure_time" : "23:37:22" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "23:40:21" , 
"departure_time" : "23:41:28" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "23:44:07" , 
"departure_time" : "23:44:53" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "23:46:46" , 
"departure_time" : "23:47:51" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "23:50:05" , 
"departure_time" : "23:50:54" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "23:53:49" , 
"departure_time" : "23:54:24" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "23:56:35" , 
"departure_time" : "23:57:08" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "24:00:33" , 
"departure_time" : "24:01:33" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "24:03:00" , 
"departure_time" : "24:03:38" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "24:06:38" , 
"departure_time" : "24:07:08" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "24:09:30" , 
"departure_time" : "24:10:00" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "24:11:30" , 
"departure_time" : "24:12:23" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "24:14:53" , 
"departure_time" : "24:16:04" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "24:18:11" , 
"departure_time" : "24:19:13" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "24:22:02" , 
"departure_time" : "24:22:10" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "24:28:08" , 
"departure_time" : "24:28:08" , 
"distance_traveled" : 30.6951
} ], 
"4163" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "21:21:00" , 
"departure_time" : "21:21:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "21:31:36" , 
"departure_time" : "21:32:52" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "21:41:16" , 
"departure_time" : "21:42:04" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "21:44:48" , 
"departure_time" : "21:45:22" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "21:47:34" , 
"departure_time" : "21:48:47" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "21:51:13" , 
"departure_time" : "21:52:40" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "21:54:27" , 
"departure_time" : "21:56:06" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "21:58:39" , 
"departure_time" : "21:59:59" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "22:01:20" , 
"departure_time" : "22:02:26" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "22:05:06" , 
"departure_time" : "22:05:52" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "22:06:46" , 
"departure_time" : "22:08:12" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "22:11:26" , 
"departure_time" : "22:12:25" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "22:13:59" , 
"departure_time" : "22:14:31" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "22:15:32" , 
"departure_time" : "22:16:40" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "22:19:08" , 
"departure_time" : "22:19:29" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "22:21:21" , 
"departure_time" : "22:21:26" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "22:26:05" , 
"departure_time" : "22:26:36" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "22:33:31" , 
"departure_time" : "22:33:31" , 
"distance_traveled" : 30.6951
} ], 
"4164" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "15:27:00" , 
"departure_time" : "15:28:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "15:37:58" , 
"departure_time" : "15:38:38" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 118,
"arrival_time" : "16:07:40" , 
"departure_time" : "16:09:04" , 
"distance_traveled" : 25.7968
}, 
{ 
"stop_id" : 100,
"arrival_time" : "16:17:24" , 
"departure_time" : "16:18:27" , 
"distance_traveled" : 28.1383
}, 
{ 
"stop_id" : 142,
"arrival_time" : "16:24:03" , 
"departure_time" : "16:24:03" , 
"distance_traveled" : 30.6741
} ], 
"4165" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "23:17:00" , 
"departure_time" : "23:18:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "23:27:02" , 
"departure_time" : "23:27:40" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "23:36:38" , 
"departure_time" : "23:37:18" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "23:40:40" , 
"departure_time" : "23:41:27" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "23:43:47" , 
"departure_time" : "23:44:56" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "23:47:09" , 
"departure_time" : "23:48:38" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "23:50:29" , 
"departure_time" : "23:50:41" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "23:53:12" , 
"departure_time" : "23:54:17" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "23:57:05" , 
"departure_time" : "23:58:34" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "24:01:29" , 
"departure_time" : "24:02:28" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "24:02:59" , 
"departure_time" : "24:03:56" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "24:06:57" , 
"departure_time" : "24:07:58" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "24:10:01" , 
"departure_time" : "24:10:24" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "24:11:23" , 
"departure_time" : "24:12:07" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "24:14:44" , 
"departure_time" : "24:15:32" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "24:17:48" , 
"departure_time" : "24:19:20" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "24:22:32" , 
"departure_time" : "24:23:25" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "24:28:53" , 
"departure_time" : "24:28:53" , 
"distance_traveled" : 30.6951
} ], 
"4166" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "19:29:00" , 
"departure_time" : "19:30:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:39:12" , 
"departure_time" : "19:39:23" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 118,
"arrival_time" : "20:14:11" , 
"departure_time" : "20:14:34" , 
"distance_traveled" : 25.7968
}, 
{ 
"stop_id" : 100,
"arrival_time" : "20:21:23" , 
"departure_time" : "20:22:24" , 
"distance_traveled" : 28.1383
}, 
{ 
"stop_id" : 142,
"arrival_time" : "20:29:01" , 
"departure_time" : "20:29:01" , 
"distance_traveled" : 30.6741
} ], 
"4167" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "15:27:00" , 
"departure_time" : "15:29:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "15:38:36" , 
"departure_time" : "15:39:34" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 118,
"arrival_time" : "16:07:58" , 
"departure_time" : "16:08:14" , 
"distance_traveled" : 25.7968
}, 
{ 
"stop_id" : 100,
"arrival_time" : "16:16:16" , 
"departure_time" : "16:17:11" , 
"distance_traveled" : 28.1383
}, 
{ 
"stop_id" : 142,
"arrival_time" : "16:23:55" , 
"departure_time" : "16:23:55" , 
"distance_traveled" : 30.6741
} ], 
"4168" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "15:00:00" , 
"departure_time" : "15:01:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "15:11:29" , 
"departure_time" : "15:12:29" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 132,
"arrival_time" : "15:33:00" , 
"departure_time" : "15:34:20" , 
"distance_traveled" : 16.8006
}, 
{ 
"stop_id" : 111,
"arrival_time" : "15:36:20" , 
"departure_time" : "15:37:08" , 
"distance_traveled" : 18.1097
}, 
{ 
"stop_id" : 42,
"arrival_time" : "15:39:48" , 
"departure_time" : "15:40:12" , 
"distance_traveled" : 19.6053
}, 
{ 
"stop_id" : 156,
"arrival_time" : "15:42:24" , 
"departure_time" : "15:42:41" , 
"distance_traveled" : 20.7722
}, 
{ 
"stop_id" : 62,
"arrival_time" : "15:45:17" , 
"departure_time" : "15:46:50" , 
"distance_traveled" : 21.6877
}, 
{ 
"stop_id" : 159,
"arrival_time" : "15:49:33" , 
"departure_time" : "15:50:41" , 
"distance_traveled" : 22.9858
}, 
{ 
"stop_id" : 114,
"arrival_time" : "15:52:08" , 
"departure_time" : "15:52:55" , 
"distance_traveled" : 23.8483
}, 
{ 
"stop_id" : 90,
"arrival_time" : "15:53:47" , 
"departure_time" : "15:54:07" , 
"distance_traveled" : 24.5225
}, 
{ 
"stop_id" : 118,
"arrival_time" : "15:56:20" , 
"departure_time" : "15:56:48" , 
"distance_traveled" : 25.7983
}, 
{ 
"stop_id" : 100,
"arrival_time" : "16:01:28" , 
"departure_time" : "16:01:38" , 
"distance_traveled" : 28.1398
}, 
{ 
"stop_id" : 142,
"arrival_time" : "16:06:10" , 
"departure_time" : "16:06:10" , 
"distance_traveled" : 30.6756
} ], 
"4169" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "19:29:00" , 
"departure_time" : "19:29:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:39:45" , 
"departure_time" : "19:41:02" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 118,
"arrival_time" : "20:15:17" , 
"departure_time" : "20:16:50" , 
"distance_traveled" : 25.7968
}, 
{ 
"stop_id" : 100,
"arrival_time" : "20:22:33" , 
"departure_time" : "20:22:41" , 
"distance_traveled" : 28.1383
}, 
{ 
"stop_id" : 142,
"arrival_time" : "20:28:08" , 
"departure_time" : "20:28:08" , 
"distance_traveled" : 30.6741
} ], 
"4170" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "08:56:00" , 
"departure_time" : "08:56:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:07:49" , 
"departure_time" : "09:08:28" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "09:16:39" , 
"departure_time" : "09:17:56" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 43,
"arrival_time" : "09:22:17" , 
"departure_time" : "09:22:54" , 
"distance_traveled" : 12.7316
}, 
{ 
"stop_id" : 5,
"arrival_time" : "09:24:37" , 
"departure_time" : "09:24:48" , 
"distance_traveled" : 13.8797
}, 
{ 
"stop_id" : 110,
"arrival_time" : "09:30:11" , 
"departure_time" : "09:30:32" , 
"distance_traveled" : 15.0992
}, 
{ 
"stop_id" : 132,
"arrival_time" : "09:35:21" , 
"departure_time" : "09:35:38" , 
"distance_traveled" : 16.8188
}, 
{ 
"stop_id" : 111,
"arrival_time" : "09:38:17" , 
"departure_time" : "09:39:43" , 
"distance_traveled" : 18.1277
}, 
{ 
"stop_id" : 42,
"arrival_time" : "09:42:26" , 
"departure_time" : "09:43:59" , 
"distance_traveled" : 19.6233
}, 
{ 
"stop_id" : 156,
"arrival_time" : "09:45:33" , 
"departure_time" : "09:46:55" , 
"distance_traveled" : 20.7902
}, 
{ 
"stop_id" : 62,
"arrival_time" : "09:48:22" , 
"departure_time" : "09:49:18" , 
"distance_traveled" : 21.7057
}, 
{ 
"stop_id" : 114,
"arrival_time" : "09:52:56" , 
"departure_time" : "09:53:37" , 
"distance_traveled" : 23.8663
}, 
{ 
"stop_id" : 90,
"arrival_time" : "09:54:41" , 
"departure_time" : "09:55:12" , 
"distance_traveled" : 24.5405
}, 
{ 
"stop_id" : 118,
"arrival_time" : "09:57:31" , 
"departure_time" : "09:58:50" , 
"distance_traveled" : 25.8163
}, 
{ 
"stop_id" : 100,
"arrival_time" : "10:03:19" , 
"departure_time" : "10:04:38" , 
"distance_traveled" : 28.1578
}, 
{ 
"stop_id" : 142,
"arrival_time" : "10:10:19" , 
"departure_time" : "10:10:19" , 
"distance_traveled" : 30.6936
} ], 
"4171" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "15:00:00" , 
"departure_time" : "15:02:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "15:12:35" , 
"departure_time" : "15:13:18" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 132,
"arrival_time" : "15:32:43" , 
"departure_time" : "15:34:23" , 
"distance_traveled" : 16.8006
}, 
{ 
"stop_id" : 111,
"arrival_time" : "15:36:40" , 
"departure_time" : "15:37:18" , 
"distance_traveled" : 18.1097
}, 
{ 
"stop_id" : 42,
"arrival_time" : "15:39:38" , 
"departure_time" : "15:40:57" , 
"distance_traveled" : 19.6053
}, 
{ 
"stop_id" : 156,
"arrival_time" : "15:43:19" , 
"departure_time" : "15:44:41" , 
"distance_traveled" : 20.7722
}, 
{ 
"stop_id" : 62,
"arrival_time" : "15:46:22" , 
"departure_time" : "15:48:00" , 
"distance_traveled" : 21.6877
}, 
{ 
"stop_id" : 159,
"arrival_time" : "15:49:38" , 
"departure_time" : "15:51:02" , 
"distance_traveled" : 22.9858
}, 
{ 
"stop_id" : 114,
"arrival_time" : "15:52:24" , 
"departure_time" : "15:53:54" , 
"distance_traveled" : 23.8483
}, 
{ 
"stop_id" : 90,
"arrival_time" : "15:54:30" , 
"departure_time" : "15:55:40" , 
"distance_traveled" : 24.5225
}, 
{ 
"stop_id" : 118,
"arrival_time" : "15:57:10" , 
"departure_time" : "15:58:27" , 
"distance_traveled" : 25.7983
}, 
{ 
"stop_id" : 100,
"arrival_time" : "16:02:17" , 
"departure_time" : "16:03:20" , 
"distance_traveled" : 28.1398
}, 
{ 
"stop_id" : 142,
"arrival_time" : "16:07:03" , 
"departure_time" : "16:07:03" , 
"distance_traveled" : 30.6756
} ], 
"4172" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "11:14:00" , 
"departure_time" : "11:16:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "11:26:15" , 
"departure_time" : "11:27:22" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "11:35:07" , 
"departure_time" : "11:36:23" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 43,
"arrival_time" : "11:43:16" , 
"departure_time" : "11:44:54" , 
"distance_traveled" : 12.7316
}, 
{ 
"stop_id" : 5,
"arrival_time" : "11:46:38" , 
"departure_time" : "11:47:12" , 
"distance_traveled" : 13.8797
}, 
{ 
"stop_id" : 110,
"arrival_time" : "11:48:34" , 
"departure_time" : "11:48:36" , 
"distance_traveled" : 15.0992
}, 
{ 
"stop_id" : 132,
"arrival_time" : "11:52:02" , 
"departure_time" : "11:52:50" , 
"distance_traveled" : 16.8188
}, 
{ 
"stop_id" : 111,
"arrival_time" : "11:56:48" , 
"departure_time" : "11:57:55" , 
"distance_traveled" : 18.1277
}, 
{ 
"stop_id" : 42,
"arrival_time" : "12:00:07" , 
"departure_time" : "12:00:43" , 
"distance_traveled" : 19.6233
}, 
{ 
"stop_id" : 156,
"arrival_time" : "12:02:36" , 
"departure_time" : "12:03:03" , 
"distance_traveled" : 20.7902
}, 
{ 
"stop_id" : 62,
"arrival_time" : "12:05:27" , 
"departure_time" : "12:07:01" , 
"distance_traveled" : 21.7057
}, 
{ 
"stop_id" : 114,
"arrival_time" : "12:10:34" , 
"departure_time" : "12:12:09" , 
"distance_traveled" : 23.8663
}, 
{ 
"stop_id" : 90,
"arrival_time" : "12:13:35" , 
"departure_time" : "12:14:06" , 
"distance_traveled" : 24.5405
}, 
{ 
"stop_id" : 118,
"arrival_time" : "12:15:31" , 
"departure_time" : "12:16:17" , 
"distance_traveled" : 25.8163
}, 
{ 
"stop_id" : 100,
"arrival_time" : "12:24:46" , 
"departure_time" : "12:26:09" , 
"distance_traveled" : 28.1578
}, 
{ 
"stop_id" : 142,
"arrival_time" : "12:32:23" , 
"departure_time" : "12:32:23" , 
"distance_traveled" : 30.6936
} ], 
"4173" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "08:56:00" , 
"departure_time" : "08:57:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:07:02" , 
"departure_time" : "09:07:33" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "09:16:31" , 
"departure_time" : "09:17:01" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 43,
"arrival_time" : "09:21:30" , 
"departure_time" : "09:21:46" , 
"distance_traveled" : 12.7316
}, 
{ 
"stop_id" : 5,
"arrival_time" : "09:24:16" , 
"departure_time" : "09:25:31" , 
"distance_traveled" : 13.8797
}, 
{ 
"stop_id" : 110,
"arrival_time" : "09:31:15" , 
"departure_time" : "09:31:55" , 
"distance_traveled" : 15.0992
}, 
{ 
"stop_id" : 132,
"arrival_time" : "09:35:40" , 
"departure_time" : "09:36:32" , 
"distance_traveled" : 16.8188
}, 
{ 
"stop_id" : 111,
"arrival_time" : "09:38:52" , 
"departure_time" : "09:39:51" , 
"distance_traveled" : 18.1277
}, 
{ 
"stop_id" : 42,
"arrival_time" : "09:41:59" , 
"departure_time" : "09:43:27" , 
"distance_traveled" : 19.6233
}, 
{ 
"stop_id" : 156,
"arrival_time" : "09:45:28" , 
"departure_time" : "09:45:30" , 
"distance_traveled" : 20.7902
}, 
{ 
"stop_id" : 62,
"arrival_time" : "09:47:02" , 
"departure_time" : "09:47:23" , 
"distance_traveled" : 21.7057
}, 
{ 
"stop_id" : 114,
"arrival_time" : "09:52:21" , 
"departure_time" : "09:52:48" , 
"distance_traveled" : 23.8663
}, 
{ 
"stop_id" : 90,
"arrival_time" : "09:54:27" , 
"departure_time" : "09:55:20" , 
"distance_traveled" : 24.5405
}, 
{ 
"stop_id" : 118,
"arrival_time" : "09:57:53" , 
"departure_time" : "09:58:15" , 
"distance_traveled" : 25.8163
}, 
{ 
"stop_id" : 100,
"arrival_time" : "10:02:22" , 
"departure_time" : "10:02:45" , 
"distance_traveled" : 28.1578
}, 
{ 
"stop_id" : 142,
"arrival_time" : "10:09:23" , 
"departure_time" : "10:09:23" , 
"distance_traveled" : 30.6936
} ], 
"4174" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "09:56:00" , 
"departure_time" : "09:57:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "10:07:43" , 
"departure_time" : "10:08:37" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "10:17:54" , 
"departure_time" : "10:17:59" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "10:20:05" , 
"departure_time" : "10:21:23" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "10:24:18" , 
"departure_time" : "10:25:34" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "10:27:16" , 
"departure_time" : "10:28:50" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "10:30:34" , 
"departure_time" : "10:32:13" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "10:34:39" , 
"departure_time" : "10:35:49" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "10:38:10" , 
"departure_time" : "10:39:12" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "10:41:02" , 
"departure_time" : "10:41:13" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "10:43:11" , 
"departure_time" : "10:43:31" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "10:46:20" , 
"departure_time" : "10:46:42" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 114,
"arrival_time" : "10:50:22" , 
"departure_time" : "10:51:14" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "10:53:52" , 
"departure_time" : "10:54:47" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "10:56:55" , 
"departure_time" : "10:57:40" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "11:00:45" , 
"departure_time" : "11:02:25" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "11:07:40" , 
"departure_time" : "11:07:40" , 
"distance_traveled" : 30.6951
} ], 
"4175" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "11:14:00" , 
"departure_time" : "11:16:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "11:26:16" , 
"departure_time" : "11:27:43" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "11:35:27" , 
"departure_time" : "11:37:00" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 43,
"arrival_time" : "11:43:33" , 
"departure_time" : "11:43:51" , 
"distance_traveled" : 12.7316
}, 
{ 
"stop_id" : 5,
"arrival_time" : "11:45:18" , 
"departure_time" : "11:46:30" , 
"distance_traveled" : 13.8797
}, 
{ 
"stop_id" : 110,
"arrival_time" : "11:49:12" , 
"departure_time" : "11:49:40" , 
"distance_traveled" : 15.0992
}, 
{ 
"stop_id" : 132,
"arrival_time" : "11:52:28" , 
"departure_time" : "11:53:17" , 
"distance_traveled" : 16.8188
}, 
{ 
"stop_id" : 111,
"arrival_time" : "11:56:49" , 
"departure_time" : "11:58:13" , 
"distance_traveled" : 18.1277
}, 
{ 
"stop_id" : 42,
"arrival_time" : "12:00:24" , 
"departure_time" : "12:01:54" , 
"distance_traveled" : 19.6233
}, 
{ 
"stop_id" : 156,
"arrival_time" : "12:03:30" , 
"departure_time" : "12:03:55" , 
"distance_traveled" : 20.7902
}, 
{ 
"stop_id" : 62,
"arrival_time" : "12:05:25" , 
"departure_time" : "12:06:24" , 
"distance_traveled" : 21.7057
}, 
{ 
"stop_id" : 114,
"arrival_time" : "12:09:59" , 
"departure_time" : "12:10:53" , 
"distance_traveled" : 23.8663
}, 
{ 
"stop_id" : 90,
"arrival_time" : "12:12:54" , 
"departure_time" : "12:13:34" , 
"distance_traveled" : 24.5405
}, 
{ 
"stop_id" : 118,
"arrival_time" : "12:15:40" , 
"departure_time" : "12:16:24" , 
"distance_traveled" : 25.8163
}, 
{ 
"stop_id" : 100,
"arrival_time" : "12:24:44" , 
"departure_time" : "12:25:08" , 
"distance_traveled" : 28.1578
}, 
{ 
"stop_id" : 142,
"arrival_time" : "12:31:24" , 
"departure_time" : "12:31:24" , 
"distance_traveled" : 30.6936
} ], 
"4176" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "12:34:00" , 
"departure_time" : "12:35:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "12:45:56" , 
"departure_time" : "12:47:26" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "12:56:30" , 
"departure_time" : "12:57:38" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "13:03:08" , 
"departure_time" : "13:04:13" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "13:06:05" , 
"departure_time" : "13:06:45" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "13:08:40" , 
"departure_time" : "13:09:15" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "13:11:35" , 
"departure_time" : "13:12:40" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "13:16:05" , 
"departure_time" : "13:17:37" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "13:19:32" , 
"departure_time" : "13:20:28" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "13:22:56" , 
"departure_time" : "13:23:32" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "13:25:36" , 
"departure_time" : "13:26:12" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "13:28:36" , 
"departure_time" : "13:29:22" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "13:31:46" , 
"departure_time" : "13:33:23" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "13:34:37" , 
"departure_time" : "13:34:48" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "13:35:11" , 
"departure_time" : "13:36:06" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "13:38:55" , 
"departure_time" : "13:39:44" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "13:48:49" , 
"departure_time" : "13:50:03" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "13:57:14" , 
"departure_time" : "13:57:14" , 
"distance_traveled" : 30.6951
} ], 
"4177" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "09:56:00" , 
"departure_time" : "09:57:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "10:07:43" , 
"departure_time" : "10:07:45" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "10:17:02" , 
"departure_time" : "10:18:15" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "10:21:13" , 
"departure_time" : "10:21:52" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "10:23:39" , 
"departure_time" : "10:23:56" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "10:26:17" , 
"departure_time" : "10:27:30" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "10:30:13" , 
"departure_time" : "10:30:18" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "10:33:05" , 
"departure_time" : "10:33:57" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "10:37:52" , 
"departure_time" : "10:38:13" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "10:40:21" , 
"departure_time" : "10:42:01" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "10:44:40" , 
"departure_time" : "10:44:45" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "10:46:05" , 
"departure_time" : "10:47:08" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 114,
"arrival_time" : "10:51:03" , 
"departure_time" : "10:51:31" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "10:53:28" , 
"departure_time" : "10:54:49" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "10:57:21" , 
"departure_time" : "10:57:58" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "11:00:37" , 
"departure_time" : "11:02:01" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "11:07:24" , 
"departure_time" : "11:07:24" , 
"distance_traveled" : 30.6951
} ], 
"4178" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "13:49:00" , 
"departure_time" : "13:51:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "14:00:56" , 
"departure_time" : "14:01:37" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "14:10:41" , 
"departure_time" : "14:12:19" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "14:17:38" , 
"departure_time" : "14:17:41" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "14:19:03" , 
"departure_time" : "14:19:26" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "14:22:23" , 
"departure_time" : "14:23:30" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "14:26:07" , 
"departure_time" : "14:26:41" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "14:30:34" , 
"departure_time" : "14:31:47" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "14:34:13" , 
"departure_time" : "14:35:18" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "14:37:05" , 
"departure_time" : "14:37:53" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "14:39:48" , 
"departure_time" : "14:40:58" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "14:43:10" , 
"departure_time" : "14:44:08" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "14:45:58" , 
"departure_time" : "14:47:26" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "14:48:28" , 
"departure_time" : "14:49:21" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "14:49:53" , 
"departure_time" : "14:50:45" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "14:53:52" , 
"departure_time" : "14:54:46" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "14:57:54" , 
"departure_time" : "14:58:05" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "15:04:11" , 
"departure_time" : "15:04:11" , 
"distance_traveled" : 30.6951
} ], 
"4179" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "12:34:00" , 
"departure_time" : "12:35:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "12:45:51" , 
"departure_time" : "12:46:45" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "12:55:54" , 
"departure_time" : "12:56:07" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "13:02:13" , 
"departure_time" : "13:03:03" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "13:05:50" , 
"departure_time" : "13:07:05" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "13:09:15" , 
"departure_time" : "13:09:21" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "13:11:06" , 
"departure_time" : "13:12:35" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "13:16:29" , 
"departure_time" : "13:17:58" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "13:19:29" , 
"departure_time" : "13:19:42" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "13:22:13" , 
"departure_time" : "13:23:09" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "13:25:56" , 
"departure_time" : "13:26:09" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "13:28:13" , 
"departure_time" : "13:28:18" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "13:31:05" , 
"departure_time" : "13:31:06" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "13:33:01" , 
"departure_time" : "13:34:29" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "13:36:28" , 
"departure_time" : "13:36:47" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "13:38:19" , 
"departure_time" : "13:38:59" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "13:48:40" , 
"departure_time" : "13:48:54" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "13:56:14" , 
"departure_time" : "13:56:14" , 
"distance_traveled" : 30.6951
} ], 
"4180" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:03:00" , 
"departure_time" : "16:04:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:14:12" , 
"departure_time" : "16:15:30" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "16:23:18" , 
"departure_time" : "16:24:44" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "16:27:26" , 
"departure_time" : "16:27:28" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "16:29:02" , 
"departure_time" : "16:29:32" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "16:32:30" , 
"departure_time" : "16:32:40" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "16:35:10" , 
"departure_time" : "16:36:06" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "16:39:56" , 
"departure_time" : "16:40:02" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "16:42:06" , 
"departure_time" : "16:42:45" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "16:46:39" , 
"departure_time" : "16:47:44" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "16:50:05" , 
"departure_time" : "16:50:16" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "16:52:11" , 
"departure_time" : "16:52:47" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "16:55:36" , 
"departure_time" : "16:57:05" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "16:58:29" , 
"departure_time" : "16:58:52" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "17:00:23" , 
"departure_time" : "17:00:44" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "17:03:21" , 
"departure_time" : "17:04:45" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "17:09:24" , 
"departure_time" : "17:09:52" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "17:13:28" , 
"departure_time" : "17:13:28" , 
"distance_traveled" : 30.6951
} ], 
"4181" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "13:49:00" , 
"departure_time" : "13:49:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "14:00:10" , 
"departure_time" : "14:00:56" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "14:10:46" , 
"departure_time" : "14:11:10" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "14:16:24" , 
"departure_time" : "14:18:01" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "14:20:37" , 
"departure_time" : "14:21:32" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "14:22:55" , 
"departure_time" : "14:23:51" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "14:25:56" , 
"departure_time" : "14:26:53" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "14:30:57" , 
"departure_time" : "14:31:17" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "14:33:20" , 
"departure_time" : "14:33:38" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "14:36:18" , 
"departure_time" : "14:37:37" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "14:40:19" , 
"departure_time" : "14:40:49" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "14:42:30" , 
"departure_time" : "14:42:57" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "14:45:27" , 
"departure_time" : "14:45:59" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "14:47:32" , 
"departure_time" : "14:48:45" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "14:50:13" , 
"departure_time" : "14:50:43" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "14:53:30" , 
"departure_time" : "14:53:51" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "14:57:21" , 
"departure_time" : "14:58:45" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "15:05:24" , 
"departure_time" : "15:05:24" , 
"distance_traveled" : 30.6951
} ], 
"4182" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:38:00" , 
"departure_time" : "16:40:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:50:05" , 
"departure_time" : "16:50:38" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "16:59:33" , 
"departure_time" : "16:59:34" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "17:02:01" , 
"departure_time" : "17:02:40" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "17:05:39" , 
"departure_time" : "17:06:26" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "17:08:47" , 
"departure_time" : "17:09:03" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "17:12:16" , 
"departure_time" : "17:12:26" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "17:16:10" , 
"departure_time" : "17:17:32" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "17:21:22" , 
"departure_time" : "17:21:33" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "17:23:11" , 
"departure_time" : "17:24:12" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "17:28:01" , 
"departure_time" : "17:29:36" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "17:31:35" , 
"departure_time" : "17:32:13" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "17:33:38" , 
"departure_time" : "17:35:10" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "17:36:32" , 
"departure_time" : "17:36:41" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "17:38:09" , 
"departure_time" : "17:38:30" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "17:41:21" , 
"departure_time" : "17:42:17" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "17:46:56" , 
"departure_time" : "17:47:06" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "17:51:10" , 
"departure_time" : "17:51:10" , 
"distance_traveled" : 30.6951
} ], 
"4183" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:03:00" , 
"departure_time" : "16:04:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:14:16" , 
"departure_time" : "16:15:42" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "16:23:26" , 
"departure_time" : "16:24:55" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "16:27:29" , 
"departure_time" : "16:27:52" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "16:29:23" , 
"departure_time" : "16:31:03" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "16:33:40" , 
"departure_time" : "16:34:16" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "16:35:36" , 
"departure_time" : "16:36:24" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "16:39:48" , 
"departure_time" : "16:40:04" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "16:42:16" , 
"departure_time" : "16:43:10" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "16:46:54" , 
"departure_time" : "16:47:29" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "16:49:35" , 
"departure_time" : "16:50:17" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "16:52:42" , 
"departure_time" : "16:54:12" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "16:56:30" , 
"departure_time" : "16:56:33" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "16:57:03" , 
"departure_time" : "16:58:41" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "17:01:38" , 
"departure_time" : "17:02:57" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "17:04:19" , 
"departure_time" : "17:04:24" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "17:08:05" , 
"departure_time" : "17:08:26" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "17:13:21" , 
"departure_time" : "17:13:21" , 
"distance_traveled" : 30.6951
} ], 
"4184" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:01:00" , 
"departure_time" : "17:01:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:12:38" , 
"departure_time" : "17:13:37" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "17:22:59" , 
"departure_time" : "17:23:10" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "17:25:11" , 
"departure_time" : "17:26:38" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "17:29:27" , 
"departure_time" : "17:30:14" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "17:31:47" , 
"departure_time" : "17:32:06" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "17:35:19" , 
"departure_time" : "17:36:15" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "17:39:56" , 
"departure_time" : "17:41:27" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "17:44:31" , 
"departure_time" : "17:44:48" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "17:46:17" , 
"departure_time" : "17:47:54" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "17:50:37" , 
"departure_time" : "17:50:45" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "17:52:08" , 
"departure_time" : "17:53:31" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "17:56:23" , 
"departure_time" : "17:57:37" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "17:59:14" , 
"departure_time" : "17:59:19" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "18:00:05" , 
"departure_time" : "18:00:33" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "18:03:28" , 
"departure_time" : "18:03:29" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "18:08:01" , 
"departure_time" : "18:08:08" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "18:13:07" , 
"departure_time" : "18:13:07" , 
"distance_traveled" : 30.6951
} ], 
"4185" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:38:00" , 
"departure_time" : "16:39:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:50:15" , 
"departure_time" : "16:51:22" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "17:00:07" , 
"departure_time" : "17:00:35" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "17:02:28" , 
"departure_time" : "17:03:21" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "17:05:53" , 
"departure_time" : "17:06:15" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "17:08:22" , 
"departure_time" : "17:09:32" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "17:13:10" , 
"departure_time" : "17:14:10" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "17:17:00" , 
"departure_time" : "17:17:37" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "17:20:37" , 
"departure_time" : "17:22:14" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "17:24:37" , 
"departure_time" : "17:25:56" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "17:28:19" , 
"departure_time" : "17:29:59" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "17:31:40" , 
"departure_time" : "17:31:46" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "17:33:06" , 
"departure_time" : "17:34:40" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "17:36:34" , 
"departure_time" : "17:37:38" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "17:39:04" , 
"departure_time" : "17:39:13" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "17:41:09" , 
"departure_time" : "17:41:13" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "17:46:04" , 
"departure_time" : "17:46:23" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "17:51:19" , 
"departure_time" : "17:51:19" , 
"distance_traveled" : 30.6951
} ], 
"4186" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:37:00" , 
"departure_time" : "17:37:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:48:29" , 
"departure_time" : "17:50:04" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "17:59:35" , 
"departure_time" : "18:00:21" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "18:02:46" , 
"departure_time" : "18:03:23" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "18:06:37" , 
"departure_time" : "18:06:41" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "18:10:04" , 
"departure_time" : "18:11:03" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "18:14:59" , 
"departure_time" : "18:16:39" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "18:20:40" , 
"departure_time" : "18:21:11" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "18:22:31" , 
"departure_time" : "18:23:39" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "18:27:08" , 
"departure_time" : "18:28:37" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "18:31:29" , 
"departure_time" : "18:32:29" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "18:34:00" , 
"departure_time" : "18:35:16" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "18:38:16" , 
"departure_time" : "18:39:45" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "18:41:29" , 
"departure_time" : "18:41:35" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "18:42:06" , 
"departure_time" : "18:43:12" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "18:47:06" , 
"departure_time" : "18:48:43" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "18:52:37" , 
"departure_time" : "18:53:12" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "18:56:35" , 
"departure_time" : "18:56:35" , 
"distance_traveled" : 30.6951
} ], 
"4187" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:01:00" , 
"departure_time" : "17:03:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:13:39" , 
"departure_time" : "17:14:41" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "17:23:02" , 
"departure_time" : "17:23:16" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "17:25:14" , 
"departure_time" : "17:26:15" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "17:29:01" , 
"departure_time" : "17:29:29" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "17:31:28" , 
"departure_time" : "17:32:36" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "17:36:08" , 
"departure_time" : "17:36:50" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "17:39:42" , 
"departure_time" : "17:41:13" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "17:44:31" , 
"departure_time" : "17:46:05" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "17:47:34" , 
"departure_time" : "17:48:49" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "17:50:15" , 
"departure_time" : "17:51:34" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "17:53:19" , 
"departure_time" : "17:54:37" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "17:56:18" , 
"departure_time" : "17:57:03" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "17:58:45" , 
"departure_time" : "17:59:50" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "18:01:05" , 
"departure_time" : "18:01:29" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "18:03:24" , 
"departure_time" : "18:03:40" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "18:08:16" , 
"departure_time" : "18:09:52" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "18:14:36" , 
"departure_time" : "18:14:36" , 
"distance_traveled" : 30.6951
} ], 
"4188" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:58:00" , 
"departure_time" : "17:59:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:09:22" , 
"departure_time" : "18:10:17" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "18:18:55" , 
"departure_time" : "18:19:39" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "18:22:44" , 
"departure_time" : "18:22:47" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "18:25:03" , 
"departure_time" : "18:25:11" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "18:29:08" , 
"departure_time" : "18:29:38" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "18:33:30" , 
"departure_time" : "18:34:53" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "18:39:23" , 
"departure_time" : "18:40:15" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "18:41:52" , 
"departure_time" : "18:42:57" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "18:46:05" , 
"departure_time" : "18:47:41" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "18:50:36" , 
"departure_time" : "18:50:43" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "18:52:07" , 
"departure_time" : "18:53:39" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "18:56:32" , 
"departure_time" : "18:57:59" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "18:59:27" , 
"departure_time" : "19:00:53" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "19:02:26" , 
"departure_time" : "19:04:06" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "19:05:40" , 
"departure_time" : "19:06:24" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "19:09:44" , 
"departure_time" : "19:10:17" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "19:14:33" , 
"departure_time" : "19:14:33" , 
"distance_traveled" : 30.6951
} ], 
"4189" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:37:00" , 
"departure_time" : "17:38:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:48:28" , 
"departure_time" : "17:49:37" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "17:59:09" , 
"departure_time" : "17:59:21" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "18:02:12" , 
"departure_time" : "18:03:51" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "18:07:39" , 
"departure_time" : "18:08:43" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "18:11:04" , 
"departure_time" : "18:11:29" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "18:14:25" , 
"departure_time" : "18:15:12" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "18:19:47" , 
"departure_time" : "18:21:01" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "18:23:14" , 
"departure_time" : "18:23:25" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "18:26:11" , 
"departure_time" : "18:26:33" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "18:30:22" , 
"departure_time" : "18:31:30" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "18:34:08" , 
"departure_time" : "18:34:38" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "18:37:30" , 
"departure_time" : "18:39:01" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "18:41:31" , 
"departure_time" : "18:43:01" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "18:43:30" , 
"departure_time" : "18:44:08" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "18:46:38" , 
"departure_time" : "18:47:49" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "18:52:11" , 
"departure_time" : "18:53:11" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "18:57:00" , 
"departure_time" : "18:57:00" , 
"distance_traveled" : 30.6951
} ], 
"4190" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:17:00" , 
"departure_time" : "18:19:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:29:09" , 
"departure_time" : "18:30:40" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "18:39:31" , 
"departure_time" : "18:40:26" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "18:41:55" , 
"departure_time" : "18:43:28" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "18:46:33" , 
"departure_time" : "18:46:42" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "18:48:09" , 
"departure_time" : "18:49:10" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "18:53:01" , 
"departure_time" : "18:54:30" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "18:58:29" , 
"departure_time" : "18:58:37" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "19:01:08" , 
"departure_time" : "19:02:06" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "19:04:58" , 
"departure_time" : "19:05:58" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "19:09:00" , 
"departure_time" : "19:10:04" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "19:12:04" , 
"departure_time" : "19:13:08" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "19:16:04" , 
"departure_time" : "19:16:33" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "19:17:29" , 
"departure_time" : "19:18:35" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "19:21:06" , 
"departure_time" : "19:21:49" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "19:24:43" , 
"departure_time" : "19:25:32" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "19:29:49" , 
"departure_time" : "19:30:23" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "19:34:34" , 
"departure_time" : "19:34:34" , 
"distance_traveled" : 30.6951
} ], 
"4191" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:58:00" , 
"departure_time" : "17:58:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:09:20" , 
"departure_time" : "18:10:26" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "18:19:06" , 
"departure_time" : "18:19:45" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "18:22:39" , 
"departure_time" : "18:23:12" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "18:25:33" , 
"departure_time" : "18:26:49" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "18:30:16" , 
"departure_time" : "18:31:33" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "18:34:17" , 
"departure_time" : "18:35:13" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "18:38:56" , 
"departure_time" : "18:40:19" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "18:42:23" , 
"departure_time" : "18:42:59" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "18:45:36" , 
"departure_time" : "18:47:03" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "18:50:27" , 
"departure_time" : "18:50:55" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "18:52:28" , 
"departure_time" : "18:53:31" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "18:56:03" , 
"departure_time" : "18:57:43" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "18:59:40" , 
"departure_time" : "19:00:28" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "19:01:48" , 
"departure_time" : "19:02:17" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "19:04:29" , 
"departure_time" : "19:06:00" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "19:10:31" , 
"departure_time" : "19:11:57" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "19:15:26" , 
"departure_time" : "19:15:26" , 
"distance_traveled" : 30.6951
} ], 
"4192" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:47:00" , 
"departure_time" : "18:49:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:59:07" , 
"departure_time" : "19:00:26" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "19:09:19" , 
"departure_time" : "19:10:46" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "19:13:27" , 
"departure_time" : "19:14:02" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "19:15:35" , 
"departure_time" : "19:17:00" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "19:19:25" , 
"departure_time" : "19:19:58" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "19:22:33" , 
"departure_time" : "19:23:05" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "19:26:32" , 
"departure_time" : "19:27:13" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "19:30:41" , 
"departure_time" : "19:31:06" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "19:33:25" , 
"departure_time" : "19:34:53" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "19:38:28" , 
"departure_time" : "19:38:51" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "19:40:23" , 
"departure_time" : "19:41:03" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "19:43:40" , 
"departure_time" : "19:45:19" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "19:47:39" , 
"departure_time" : "19:48:45" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "19:50:06" , 
"departure_time" : "19:50:51" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "19:52:45" , 
"departure_time" : "19:53:53" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "19:58:08" , 
"departure_time" : "19:58:44" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "20:02:36" , 
"departure_time" : "20:02:36" , 
"distance_traveled" : 30.6951
} ], 
"4193" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:17:00" , 
"departure_time" : "18:18:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:28:37" , 
"departure_time" : "18:28:50" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "18:38:13" , 
"departure_time" : "18:39:11" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "18:41:58" , 
"departure_time" : "18:43:37" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "18:46:39" , 
"departure_time" : "18:47:26" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "18:48:47" , 
"departure_time" : "18:48:54" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "18:52:07" , 
"departure_time" : "18:53:30" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "18:58:23" , 
"departure_time" : "18:58:31" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "19:01:08" , 
"departure_time" : "19:02:07" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "19:04:59" , 
"departure_time" : "19:06:38" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "19:09:39" , 
"departure_time" : "19:11:15" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "19:12:36" , 
"departure_time" : "19:13:37" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "19:16:01" , 
"departure_time" : "19:16:33" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "19:17:32" , 
"departure_time" : "19:18:24" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "19:20:52" , 
"departure_time" : "19:21:21" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "19:24:29" , 
"departure_time" : "19:24:57" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "19:29:28" , 
"departure_time" : "19:29:54" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "19:34:26" , 
"departure_time" : "19:34:26" , 
"distance_traveled" : 30.6951
} ], 
"4194" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "19:28:00" , 
"departure_time" : "19:29:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:39:38" , 
"departure_time" : "19:40:08" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "19:49:30" , 
"departure_time" : "19:50:42" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "19:53:12" , 
"departure_time" : "19:54:22" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "19:56:10" , 
"departure_time" : "19:57:27" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "19:59:17" , 
"departure_time" : "19:59:39" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "20:01:22" , 
"departure_time" : "20:02:09" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "20:06:47" , 
"departure_time" : "20:08:08" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "20:10:21" , 
"departure_time" : "20:10:26" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "20:12:05" , 
"departure_time" : "20:12:44" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "20:15:39" , 
"departure_time" : "20:16:12" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "20:18:33" , 
"departure_time" : "20:18:46" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "20:21:13" , 
"departure_time" : "20:21:45" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "20:24:32" , 
"departure_time" : "20:26:03" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "20:27:31" , 
"departure_time" : "20:28:43" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "20:30:12" , 
"departure_time" : "20:31:26" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "20:35:14" , 
"departure_time" : "20:36:14" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "20:40:00" , 
"departure_time" : "20:40:00" , 
"distance_traveled" : 30.6951
} ], 
"4195" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:47:00" , 
"departure_time" : "18:48:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:58:01" , 
"departure_time" : "18:59:19" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "19:09:18" , 
"departure_time" : "19:10:26" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "19:13:08" , 
"departure_time" : "19:13:32" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "19:15:24" , 
"departure_time" : "19:15:56" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "19:18:32" , 
"departure_time" : "19:20:01" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "19:23:29" , 
"departure_time" : "19:24:36" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "19:27:07" , 
"departure_time" : "19:27:22" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "19:30:15" , 
"departure_time" : "19:30:47" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "19:33:32" , 
"departure_time" : "19:34:31" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "19:37:59" , 
"departure_time" : "19:39:09" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "19:41:10" , 
"departure_time" : "19:42:37" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "19:44:27" , 
"departure_time" : "19:45:10" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "19:46:43" , 
"departure_time" : "19:48:02" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "19:50:19" , 
"departure_time" : "19:50:41" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "19:52:22" , 
"departure_time" : "19:53:46" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "19:58:24" , 
"departure_time" : "19:59:59" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "20:03:35" , 
"departure_time" : "20:03:35" , 
"distance_traveled" : 30.6951
} ], 
"4196" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "20:22:00" , 
"departure_time" : "20:24:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "20:34:06" , 
"departure_time" : "20:35:44" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "20:43:38" , 
"departure_time" : "20:43:49" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "20:45:11" , 
"departure_time" : "20:46:13" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "20:49:02" , 
"departure_time" : "20:50:37" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "20:52:35" , 
"departure_time" : "20:54:08" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "20:56:33" , 
"departure_time" : "20:58:07" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "21:00:34" , 
"departure_time" : "21:01:43" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "21:03:09" , 
"departure_time" : "21:04:31" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "21:06:22" , 
"departure_time" : "21:06:50" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "21:08:28" , 
"departure_time" : "21:10:05" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "21:12:37" , 
"departure_time" : "21:13:34" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "21:14:57" , 
"departure_time" : "21:15:47" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "21:17:50" , 
"departure_time" : "21:19:12" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "21:20:22" , 
"departure_time" : "21:21:49" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "21:23:27" , 
"departure_time" : "21:23:33" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "21:27:06" , 
"departure_time" : "21:27:38" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "21:32:32" , 
"departure_time" : "21:32:32" , 
"distance_traveled" : 30.6951
} ], 
"4197" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "19:28:00" , 
"departure_time" : "19:28:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:39:27" , 
"departure_time" : "19:41:07" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "19:50:40" , 
"departure_time" : "19:51:06" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "19:52:26" , 
"departure_time" : "19:52:52" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "19:55:26" , 
"departure_time" : "19:56:18" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "19:58:52" , 
"departure_time" : "20:00:13" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "20:02:21" , 
"departure_time" : "20:02:35" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "20:06:14" , 
"departure_time" : "20:07:15" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "20:10:01" , 
"departure_time" : "20:10:13" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "20:12:12" , 
"departure_time" : "20:13:51" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "20:16:39" , 
"departure_time" : "20:17:17" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "20:18:38" , 
"departure_time" : "20:19:55" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "20:22:17" , 
"departure_time" : "20:23:14" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "20:24:57" , 
"departure_time" : "20:25:12" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "20:26:15" , 
"departure_time" : "20:26:36" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "20:29:21" , 
"departure_time" : "20:30:38" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "20:35:17" , 
"departure_time" : "20:36:49" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "20:40:32" , 
"departure_time" : "20:40:32" , 
"distance_traveled" : 30.6951
} ], 
"4198" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "21:43:00" , 
"departure_time" : "21:45:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "21:54:50" , 
"departure_time" : "21:56:30" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "22:05:40" , 
"departure_time" : "22:05:42" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "22:07:02" , 
"departure_time" : "22:08:36" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "22:11:34" , 
"departure_time" : "22:11:56" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "22:13:22" , 
"departure_time" : "22:14:13" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "22:16:51" , 
"departure_time" : "22:17:14" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "22:20:23" , 
"departure_time" : "22:21:18" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "22:24:55" , 
"departure_time" : "22:25:12" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "22:27:17" , 
"departure_time" : "22:28:45" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "22:31:28" , 
"departure_time" : "22:31:36" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "22:33:08" , 
"departure_time" : "22:33:54" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "22:36:46" , 
"departure_time" : "22:37:41" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "22:38:55" , 
"departure_time" : "22:40:08" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "22:42:13" , 
"departure_time" : "22:43:25" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "22:45:12" , 
"departure_time" : "22:46:08" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "22:49:56" , 
"departure_time" : "22:51:02" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "22:55:06" , 
"departure_time" : "22:55:06" , 
"distance_traveled" : 30.6951
} ], 
"4199" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "20:22:00" , 
"departure_time" : "20:24:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "20:34:10" , 
"departure_time" : "20:34:53" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "20:42:43" , 
"departure_time" : "20:44:22" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "20:46:39" , 
"departure_time" : "20:47:52" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "20:49:13" , 
"departure_time" : "20:49:33" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "20:51:20" , 
"departure_time" : "20:52:08" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "20:55:48" , 
"departure_time" : "20:56:18" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "20:59:30" , 
"departure_time" : "21:00:03" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "21:02:33" , 
"departure_time" : "21:04:03" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "21:06:30" , 
"departure_time" : "21:07:13" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "21:08:43" , 
"departure_time" : "21:09:28" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "21:11:45" , 
"departure_time" : "21:13:05" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "21:15:20" , 
"departure_time" : "21:15:43" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "21:17:23" , 
"departure_time" : "21:18:17" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "21:19:54" , 
"departure_time" : "21:20:22" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "21:22:28" , 
"departure_time" : "21:24:04" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "21:28:36" , 
"departure_time" : "21:29:29" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "21:32:53" , 
"departure_time" : "21:32:53" , 
"distance_traveled" : 30.6951
} ], 
"4200" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "23:12:00" , 
"departure_time" : "23:13:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "23:23:15" , 
"departure_time" : "23:24:10" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "23:32:55" , 
"departure_time" : "23:33:08" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "23:36:13" , 
"departure_time" : "23:37:11" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "23:39:58" , 
"departure_time" : "23:40:08" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "23:42:10" , 
"departure_time" : "23:42:11" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "23:45:01" , 
"departure_time" : "23:45:13" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "23:49:12" , 
"departure_time" : "23:50:24" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "23:53:12" , 
"departure_time" : "23:53:26" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "23:56:14" , 
"departure_time" : "23:57:13" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "23:59:59" , 
"departure_time" : "24:00:02" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "24:02:03" , 
"departure_time" : "24:02:06" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "24:05:03" , 
"departure_time" : "24:06:15" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "24:08:12" , 
"departure_time" : "24:08:42" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "24:09:30" , 
"departure_time" : "24:11:01" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "24:14:31" , 
"departure_time" : "24:15:30" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "24:17:59" , 
"departure_time" : "24:19:38" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "24:23:39" , 
"departure_time" : "24:23:39" , 
"distance_traveled" : 30.6951
} ], 
"4201" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "21:43:00" , 
"departure_time" : "21:45:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "21:55:17" , 
"departure_time" : "21:56:00" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "22:04:43" , 
"departure_time" : "22:04:47" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "22:07:04" , 
"departure_time" : "22:07:57" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "22:10:53" , 
"departure_time" : "22:11:47" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "22:13:54" , 
"departure_time" : "22:14:52" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "22:16:58" , 
"departure_time" : "22:18:14" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "22:21:16" , 
"departure_time" : "22:21:41" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "22:24:25" , 
"departure_time" : "22:26:02" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "22:28:37" , 
"departure_time" : "22:29:04" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "22:30:27" , 
"departure_time" : "22:31:40" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "22:34:13" , 
"departure_time" : "22:34:55" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "22:36:42" , 
"departure_time" : "22:37:15" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "22:38:33" , 
"departure_time" : "22:40:01" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "22:42:28" , 
"departure_time" : "22:43:21" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "22:44:53" , 
"departure_time" : "22:45:04" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "22:49:11" , 
"departure_time" : "22:50:16" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "22:55:05" , 
"departure_time" : "22:55:05" , 
"distance_traveled" : 30.6951
} ], 
"4202" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "09:34:00" , 
"departure_time" : "09:35:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:44:46" , 
"departure_time" : "09:45:37" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 5,
"arrival_time" : "09:58:51" , 
"departure_time" : "10:00:05" , 
"distance_traveled" : 13.8604
}, 
{ 
"stop_id" : 110,
"arrival_time" : "10:02:14" , 
"departure_time" : "10:02:14" , 
"distance_traveled" : 15.0799
} ], 
"4203" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "23:12:00" , 
"departure_time" : "23:14:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "23:24:28" , 
"departure_time" : "23:25:18" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "23:32:50" , 
"departure_time" : "23:33:25" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "23:36:35" , 
"departure_time" : "23:37:02" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "23:39:27" , 
"departure_time" : "23:40:45" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "23:43:18" , 
"departure_time" : "23:44:03" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "23:45:45" , 
"departure_time" : "23:46:18" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "23:49:33" , 
"departure_time" : "23:50:28" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "23:52:55" , 
"departure_time" : "23:53:49" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "23:56:54" , 
"departure_time" : "23:56:55" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "23:59:01" , 
"departure_time" : "23:59:02" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "24:02:01" , 
"departure_time" : "24:03:25" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "24:06:24" , 
"departure_time" : "24:06:46" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "24:07:22" , 
"departure_time" : "24:07:28" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "24:09:06" , 
"departure_time" : "24:10:01" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "24:13:55" , 
"departure_time" : "24:15:16" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "24:18:21" , 
"departure_time" : "24:20:01" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "24:23:40" , 
"departure_time" : "24:23:40" , 
"distance_traveled" : 30.6951
} ], 
"4204" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:32:00" , 
"departure_time" : "17:34:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:43:57" , 
"departure_time" : "17:45:15" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 118,
"arrival_time" : "18:16:18" , 
"departure_time" : "18:17:26" , 
"distance_traveled" : 25.7968
}, 
{ 
"stop_id" : 100,
"arrival_time" : "18:21:08" , 
"departure_time" : "18:22:36" , 
"distance_traveled" : 28.1383
}, 
{ 
"stop_id" : 142,
"arrival_time" : "18:26:28" , 
"departure_time" : "18:26:28" , 
"distance_traveled" : 30.6741
} ], 
"4205" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "09:34:00" , 
"departure_time" : "09:35:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "09:44:11" , 
"departure_time" : "09:44:15" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 5,
"arrival_time" : "09:58:04" , 
"departure_time" : "09:58:35" , 
"distance_traveled" : 13.8604
}, 
{ 
"stop_id" : 110,
"arrival_time" : "10:01:31" , 
"departure_time" : "10:01:31" , 
"distance_traveled" : 15.0799
} ], 
"4206" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "15:14:00" , 
"departure_time" : "15:14:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "15:24:08" , 
"departure_time" : "15:25:24" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "15:34:16" , 
"departure_time" : "15:34:27" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "15:39:11" , 
"departure_time" : "15:39:24" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "15:42:13" , 
"departure_time" : "15:42:14" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "15:45:01" , 
"departure_time" : "15:46:34" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "15:49:33" , 
"departure_time" : "15:49:33" , 
"distance_traveled" : 15.1008
} ], 
"4207" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:32:00" , 
"departure_time" : "17:34:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:44:19" , 
"departure_time" : "17:44:22" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 118,
"arrival_time" : "18:15:03" , 
"departure_time" : "18:15:44" , 
"distance_traveled" : 25.7968
}, 
{ 
"stop_id" : 100,
"arrival_time" : "18:20:41" , 
"departure_time" : "18:20:58" , 
"distance_traveled" : 28.1383
}, 
{ 
"stop_id" : 142,
"arrival_time" : "18:25:17" , 
"departure_time" : "18:25:17" , 
"distance_traveled" : 30.6741
} ], 
"4208" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "15:14:00" , 
"departure_time" : "15:14:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "15:24:24" , 
"departure_time" : "15:24:38" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "15:33:14" , 
"departure_time" : "15:34:37" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "15:40:23" , 
"departure_time" : "15:40:40" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "15:42:17" , 
"departure_time" : "15:43:53" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "15:46:36" , 
"departure_time" : "15:47:32" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "15:48:56" , 
"departure_time" : "15:48:56" , 
"distance_traveled" : 15.1008
} ], 
"4209" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:50:00" , 
"departure_time" : "17:52:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:02:40" , 
"departure_time" : "18:03:36" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "18:10:56" , 
"departure_time" : "18:10:58" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "18:14:02" , 
"departure_time" : "18:14:35" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "18:17:33" , 
"departure_time" : "18:17:47" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "18:20:14" , 
"departure_time" : "18:20:22" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "18:24:08" , 
"departure_time" : "18:24:30" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "18:28:22" , 
"departure_time" : "18:29:49" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "18:33:27" , 
"departure_time" : "18:33:33" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "18:36:06" , 
"departure_time" : "18:36:37" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "18:39:31" , 
"departure_time" : "18:40:11" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "18:42:40" , 
"departure_time" : "18:43:42" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "18:46:02" , 
"departure_time" : "18:47:37" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "18:48:35" , 
"departure_time" : "18:49:02" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "18:50:27" , 
"departure_time" : "18:51:22" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "18:53:55" , 
"departure_time" : "18:55:29" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "18:59:34" , 
"departure_time" : "18:59:43" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "19:04:09" , 
"departure_time" : "19:04:09" , 
"distance_traveled" : 30.6951
} ], 
"4210" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "24:45:00" , 
"departure_time" : "24:46:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "24:56:03" , 
"departure_time" : "24:57:34" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "25:05:31" , 
"departure_time" : "25:07:05" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "25:08:34" , 
"departure_time" : "25:08:56" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "25:10:22" , 
"departure_time" : "25:11:48" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "25:14:26" , 
"departure_time" : "25:15:04" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "25:16:38" , 
"departure_time" : "25:17:41" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "25:22:03" , 
"departure_time" : "25:22:10" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "25:24:07" , 
"departure_time" : "25:24:31" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "25:27:24" , 
"departure_time" : "25:28:37" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "25:30:13" , 
"departure_time" : "25:31:03" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "25:32:50" , 
"departure_time" : "25:33:35" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "25:35:45" , 
"departure_time" : "25:37:23" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "25:39:38" , 
"departure_time" : "25:40:20" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "25:40:42" , 
"departure_time" : "25:41:22" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "25:44:40" , 
"departure_time" : "25:45:22" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "25:48:42" , 
"departure_time" : "25:50:11" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "25:56:29" , 
"departure_time" : "25:56:29" , 
"distance_traveled" : 30.6951
} ], 
"4211" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "08:09:00" , 
"departure_time" : "08:11:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "08:20:13" , 
"departure_time" : "08:21:22" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "08:30:09" , 
"departure_time" : "08:31:38" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "08:33:29" , 
"departure_time" : "08:33:42" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "08:35:13" , 
"departure_time" : "08:35:55" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "08:38:42" , 
"departure_time" : "08:39:10" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "08:42:28" , 
"departure_time" : "08:43:10" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "08:46:42" , 
"departure_time" : "08:47:39" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "08:50:57" , 
"departure_time" : "08:51:13" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "08:54:16" , 
"departure_time" : "08:55:25" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "08:57:09" , 
"departure_time" : "08:57:26" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "09:00:17" , 
"departure_time" : "09:01:51" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "09:04:34" , 
"departure_time" : "09:05:34" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "09:06:00" , 
"departure_time" : "09:06:44" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "09:07:44" , 
"departure_time" : "09:08:29" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "09:11:45" , 
"departure_time" : "09:12:42" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "09:15:57" , 
"departure_time" : "09:16:45" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "09:21:48" , 
"departure_time" : "09:21:48" , 
"distance_traveled" : 30.6951
} ], 
"4212" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "10:14:00" , 
"departure_time" : "10:15:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "10:24:19" , 
"departure_time" : "10:24:52" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "10:34:33" , 
"departure_time" : "10:35:53" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "10:38:20" , 
"departure_time" : "10:39:19" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "10:40:59" , 
"departure_time" : "10:42:36" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "10:44:37" , 
"departure_time" : "10:44:39" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "10:47:02" , 
"departure_time" : "10:47:41" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "10:51:39" , 
"departure_time" : "10:51:55" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "10:55:16" , 
"departure_time" : "10:56:41" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "11:00:25" , 
"departure_time" : "11:01:05" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "11:01:40" , 
"departure_time" : "11:02:29" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "11:05:49" , 
"departure_time" : "11:05:52" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "11:08:03" , 
"departure_time" : "11:08:44" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "11:10:41" , 
"departure_time" : "11:11:57" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "11:13:16" , 
"departure_time" : "11:14:43" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "11:17:27" , 
"departure_time" : "11:17:48" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "11:20:21" , 
"departure_time" : "11:20:51" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "11:26:30" , 
"departure_time" : "11:26:30" , 
"distance_traveled" : 30.6951
} ], 
"4213" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "12:14:00" , 
"departure_time" : "12:15:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "12:25:01" , 
"departure_time" : "12:25:20" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "12:34:19" , 
"departure_time" : "12:35:34" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "12:38:15" , 
"departure_time" : "12:38:37" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "12:40:22" , 
"departure_time" : "12:41:12" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "12:43:50" , 
"departure_time" : "12:43:52" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "12:47:02" , 
"departure_time" : "12:47:55" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "12:51:53" , 
"departure_time" : "12:52:33" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "12:55:40" , 
"departure_time" : "12:56:28" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "12:59:48" , 
"departure_time" : "13:01:24" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "13:03:36" , 
"departure_time" : "13:04:52" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "13:06:16" , 
"departure_time" : "13:07:55" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "13:09:39" , 
"departure_time" : "13:10:34" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "13:11:55" , 
"departure_time" : "13:12:28" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "13:13:33" , 
"departure_time" : "13:14:08" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "13:16:35" , 
"departure_time" : "13:17:22" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "13:21:47" , 
"departure_time" : "13:22:32" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "13:27:45" , 
"departure_time" : "13:27:45" , 
"distance_traveled" : 30.6951
} ], 
"4214" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "14:14:00" , 
"departure_time" : "14:15:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "14:25:06" , 
"departure_time" : "14:26:09" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "14:35:03" , 
"departure_time" : "14:36:30" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "14:38:27" , 
"departure_time" : "14:39:06" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "14:40:39" , 
"departure_time" : "14:41:48" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "14:44:09" , 
"departure_time" : "14:45:33" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "14:48:24" , 
"departure_time" : "14:49:54" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "14:52:30" , 
"departure_time" : "14:54:04" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "14:57:34" , 
"departure_time" : "14:58:20" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "14:59:46" , 
"departure_time" : "15:00:41" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "15:02:55" , 
"departure_time" : "15:03:42" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "15:05:47" , 
"departure_time" : "15:06:33" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "15:08:46" , 
"departure_time" : "15:08:57" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "15:11:11" , 
"departure_time" : "15:12:16" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "15:14:05" , 
"departure_time" : "15:15:26" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "15:17:21" , 
"departure_time" : "15:17:47" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "15:21:26" , 
"departure_time" : "15:21:59" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "15:27:33" , 
"departure_time" : "15:27:33" , 
"distance_traveled" : 30.6951
} ], 
"4215" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "16:14:00" , 
"departure_time" : "16:15:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "16:24:55" , 
"departure_time" : "16:26:04" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "16:35:09" , 
"departure_time" : "16:36:23" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "16:39:14" , 
"departure_time" : "16:40:53" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "16:42:39" , 
"departure_time" : "16:42:55" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "16:44:16" , 
"departure_time" : "16:45:29" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "16:49:13" , 
"departure_time" : "16:50:51" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "16:53:38" , 
"departure_time" : "16:54:31" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "16:56:53" , 
"departure_time" : "16:57:43" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "17:00:50" , 
"departure_time" : "17:01:45" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "17:02:55" , 
"departure_time" : "17:04:22" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "17:07:27" , 
"departure_time" : "17:08:46" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "17:10:19" , 
"departure_time" : "17:11:41" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "17:12:22" , 
"departure_time" : "17:12:59" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "17:13:37" , 
"departure_time" : "17:14:58" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "17:18:21" , 
"departure_time" : "17:19:13" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "17:21:52" , 
"departure_time" : "17:22:24" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "17:27:32" , 
"departure_time" : "17:27:32" , 
"distance_traveled" : 30.6951
} ], 
"4216" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "17:13:00" , 
"departure_time" : "17:13:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "17:23:26" , 
"departure_time" : "17:24:19" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "17:33:53" , 
"departure_time" : "17:34:21" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "17:36:28" , 
"departure_time" : "17:37:33" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "17:41:05" , 
"departure_time" : "17:42:41" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "17:44:36" , 
"departure_time" : "17:46:04" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "17:47:28" , 
"departure_time" : "17:48:28" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "17:51:00" , 
"departure_time" : "17:51:02" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "17:55:02" , 
"departure_time" : "17:56:21" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "17:59:19" , 
"departure_time" : "17:59:23" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "18:01:04" , 
"departure_time" : "18:01:59" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "18:04:55" , 
"departure_time" : "18:05:31" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "18:07:36" , 
"departure_time" : "18:07:59" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "18:10:23" , 
"departure_time" : "18:10:27" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "18:12:04" , 
"departure_time" : "18:12:31" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "18:15:27" , 
"departure_time" : "18:16:53" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "18:21:26" , 
"departure_time" : "18:21:48" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "18:26:22" , 
"departure_time" : "18:26:22" , 
"distance_traveled" : 30.6951
} ], 
"4217" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "18:22:00" , 
"departure_time" : "18:23:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "18:32:55" , 
"departure_time" : "18:33:24" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "18:42:29" , 
"departure_time" : "18:43:36" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "18:46:07" , 
"departure_time" : "18:47:25" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "18:50:18" , 
"departure_time" : "18:51:28" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "18:53:10" , 
"departure_time" : "18:54:15" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "18:56:05" , 
"departure_time" : "18:57:17" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "19:01:12" , 
"departure_time" : "19:02:30" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "19:05:18" , 
"departure_time" : "19:06:08" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "19:07:50" , 
"departure_time" : "19:07:55" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "19:11:05" , 
"departure_time" : "19:11:08" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "19:13:03" , 
"departure_time" : "19:13:37" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "19:17:34" , 
"departure_time" : "19:18:17" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "19:19:43" , 
"departure_time" : "19:21:08" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "19:22:25" , 
"departure_time" : "19:23:53" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "19:26:28" , 
"departure_time" : "19:26:29" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "19:29:01" , 
"departure_time" : "19:29:35" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "19:35:34" , 
"departure_time" : "19:35:34" , 
"distance_traveled" : 30.6951
} ], 
"4218" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "19:22:00" , 
"departure_time" : "19:24:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "19:33:26" , 
"departure_time" : "19:35:00" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "19:43:34" , 
"departure_time" : "19:45:03" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "19:46:29" , 
"departure_time" : "19:48:09" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "19:50:40" , 
"departure_time" : "19:52:17" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "19:53:37" , 
"departure_time" : "19:54:43" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "19:56:06" , 
"departure_time" : "19:57:02" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "20:00:56" , 
"departure_time" : "20:02:16" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "20:05:20" , 
"departure_time" : "20:05:32" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "20:07:12" , 
"departure_time" : "20:07:15" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "20:11:03" , 
"departure_time" : "20:11:21" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "20:13:18" , 
"departure_time" : "20:13:37" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "20:17:19" , 
"departure_time" : "20:18:58" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "20:20:39" , 
"departure_time" : "20:21:12" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "20:21:33" , 
"departure_time" : "20:22:13" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "20:25:40" , 
"departure_time" : "20:27:11" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "20:30:31" , 
"departure_time" : "20:31:18" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "20:35:47" , 
"departure_time" : "20:35:47" , 
"distance_traveled" : 30.6951
} ], 
"4219" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "21:13:00" , 
"departure_time" : "21:13:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "21:24:05" , 
"departure_time" : "21:24:45" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "21:33:40" , 
"departure_time" : "21:34:05" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "21:36:25" , 
"departure_time" : "21:37:42" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "21:40:17" , 
"departure_time" : "21:41:15" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "21:42:58" , 
"departure_time" : "21:43:46" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "21:45:48" , 
"departure_time" : "21:45:51" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "21:50:03" , 
"departure_time" : "21:50:19" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "21:54:16" , 
"departure_time" : "21:55:19" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "21:58:03" , 
"departure_time" : "21:58:47" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "22:00:44" , 
"departure_time" : "22:02:04" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "22:05:20" , 
"departure_time" : "22:06:05" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "22:07:45" , 
"departure_time" : "22:07:58" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "22:09:13" , 
"departure_time" : "22:09:47" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "22:12:34" , 
"departure_time" : "22:13:09" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "22:15:35" , 
"departure_time" : "22:16:09" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "22:20:34" , 
"departure_time" : "22:22:06" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "22:28:32" , 
"departure_time" : "22:28:32" , 
"distance_traveled" : 30.6951
} ], 
"4220" :  [ 
{ 
"stop_id" : 63,
"arrival_time" : "23:17:00" , 
"departure_time" : "23:18:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38174,
"arrival_time" : "23:27:12" , 
"departure_time" : "23:28:30" , 
"distance_traveled" : 3.56
}, 
{ 
"stop_id" : 160,
"arrival_time" : "23:37:18" , 
"departure_time" : "23:37:19" , 
"distance_traveled" : 9.9299
}, 
{ 
"stop_id" : 146,
"arrival_time" : "23:40:01" , 
"departure_time" : "23:41:26" , 
"distance_traveled" : 11.611
}, 
{ 
"stop_id" : 43,
"arrival_time" : "23:44:25" , 
"departure_time" : "23:45:59" , 
"distance_traveled" : 12.7343
}, 
{ 
"stop_id" : 5,
"arrival_time" : "23:47:34" , 
"departure_time" : "23:49:11" , 
"distance_traveled" : 13.8812
}, 
{ 
"stop_id" : 110,
"arrival_time" : "23:50:37" , 
"departure_time" : "23:52:06" , 
"distance_traveled" : 15.1008
}, 
{ 
"stop_id" : 132,
"arrival_time" : "23:54:29" , 
"departure_time" : "23:54:40" , 
"distance_traveled" : 16.8203
}, 
{ 
"stop_id" : 111,
"arrival_time" : "23:57:11" , 
"departure_time" : "23:58:21" , 
"distance_traveled" : 18.1292
}, 
{ 
"stop_id" : 42,
"arrival_time" : "24:02:10" , 
"departure_time" : "24:02:26" , 
"distance_traveled" : 19.6248
}, 
{ 
"stop_id" : 156,
"arrival_time" : "24:03:16" , 
"departure_time" : "24:03:32" , 
"distance_traveled" : 20.7917
}, 
{ 
"stop_id" : 62,
"arrival_time" : "24:07:16" , 
"departure_time" : "24:08:18" , 
"distance_traveled" : 21.7072
}, 
{ 
"stop_id" : 159,
"arrival_time" : "24:11:02" , 
"departure_time" : "24:12:07" , 
"distance_traveled" : 23.0053
}, 
{ 
"stop_id" : 114,
"arrival_time" : "24:13:05" , 
"departure_time" : "24:14:08" , 
"distance_traveled" : 23.8678
}, 
{ 
"stop_id" : 90,
"arrival_time" : "24:16:03" , 
"departure_time" : "24:16:16" , 
"distance_traveled" : 24.542
}, 
{ 
"stop_id" : 118,
"arrival_time" : "24:18:13" , 
"departure_time" : "24:19:36" , 
"distance_traveled" : 25.8178
}, 
{ 
"stop_id" : 100,
"arrival_time" : "24:23:23" , 
"departure_time" : "24:23:47" , 
"distance_traveled" : 28.1593
}, 
{ 
"stop_id" : 142,
"arrival_time" : "24:29:24" , 
"departure_time" : "24:29:24" , 
"distance_traveled" : 30.6951
} ], 
"4221" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "24:18:00" , 
"departure_time" : "24:19:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "24:23:56" , 
"departure_time" : "24:23:56" , 
"distance_traveled" : 2.6284
} ], 
"4222" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "24:18:00" , 
"departure_time" : "24:19:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "24:23:53" , 
"departure_time" : "24:23:53" , 
"distance_traveled" : 2.6284
} ], 
"4223" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "25:13:00" , 
"departure_time" : "25:14:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "25:18:20" , 
"departure_time" : "25:18:20" , 
"distance_traveled" : 2.6284
} ], 
"4224" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "25:13:00" , 
"departure_time" : "25:14:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "25:19:19" , 
"departure_time" : "25:19:19" , 
"distance_traveled" : 2.6284
} ], 
"4225" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "25:45:00" , 
"departure_time" : "25:47:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "25:51:28" , 
"departure_time" : "25:51:28" , 
"distance_traveled" : 2.6284
} ], 
"4226" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "25:45:00" , 
"departure_time" : "25:48:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "25:51:34" , 
"departure_time" : "25:51:34" , 
"distance_traveled" : 2.6284
} ], 
"4227" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "24:18:00" , 
"departure_time" : "24:21:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "24:24:27" , 
"departure_time" : "24:24:27" , 
"distance_traveled" : 2.6284
} ], 
"4228" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "24:18:00" , 
"departure_time" : "24:20:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "24:24:11" , 
"departure_time" : "24:24:11" , 
"distance_traveled" : 2.6284
} ], 
"4229" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "25:13:00" , 
"departure_time" : "25:15:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "25:19:17" , 
"departure_time" : "25:19:17" , 
"distance_traveled" : 2.6284
} ], 
"4230" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "25:13:00" , 
"departure_time" : "25:14:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "25:18:39" , 
"departure_time" : "25:18:39" , 
"distance_traveled" : 2.6284
} ], 
"4231" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "25:13:00" , 
"departure_time" : "25:15:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "25:19:36" , 
"departure_time" : "25:19:36" , 
"distance_traveled" : 2.6284
} ], 
"4232" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "24:18:00" , 
"departure_time" : "24:20:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "24:23:52" , 
"departure_time" : "24:23:52" , 
"distance_traveled" : 2.6284
} ], 
"4233" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "09:19:00" , 
"departure_time" : "09:21:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "09:25:08" , 
"departure_time" : "09:25:08" , 
"distance_traveled" : 2.6284
} ], 
"4234" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "10:02:00" , 
"departure_time" : "10:04:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "10:08:23" , 
"departure_time" : "10:08:23" , 
"distance_traveled" : 2.6284
} ], 
"4235" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "09:19:00" , 
"departure_time" : "09:21:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "09:24:58" , 
"departure_time" : "09:24:58" , 
"distance_traveled" : 2.6284
} ], 
"4236" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "10:23:00" , 
"departure_time" : "10:24:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "10:28:23" , 
"departure_time" : "10:28:23" , 
"distance_traveled" : 2.6284
} ], 
"4237" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "10:02:00" , 
"departure_time" : "10:02:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "10:07:33" , 
"departure_time" : "10:07:33" , 
"distance_traveled" : 2.6284
} ], 
"4238" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "10:58:00" , 
"departure_time" : "10:59:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "11:04:17" , 
"departure_time" : "11:04:17" , 
"distance_traveled" : 2.6284
} ], 
"4239" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "10:23:00" , 
"departure_time" : "10:25:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "10:29:16" , 
"departure_time" : "10:29:16" , 
"distance_traveled" : 2.6284
} ], 
"4240" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "11:20:00" , 
"departure_time" : "11:21:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "11:25:38" , 
"departure_time" : "11:25:38" , 
"distance_traveled" : 2.6284
} ], 
"4241" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "10:58:00" , 
"departure_time" : "10:59:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "11:04:01" , 
"departure_time" : "11:04:01" , 
"distance_traveled" : 2.6284
} ], 
"4242" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "12:00:00" , 
"departure_time" : "12:01:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "12:05:07" , 
"departure_time" : "12:05:07" , 
"distance_traveled" : 2.6284
} ], 
"4243" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "11:20:00" , 
"departure_time" : "11:20:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "11:25:28" , 
"departure_time" : "11:25:28" , 
"distance_traveled" : 2.6284
} ], 
"4244" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "12:20:00" , 
"departure_time" : "12:21:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "12:25:43" , 
"departure_time" : "12:25:43" , 
"distance_traveled" : 2.6284
} ], 
"4245" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "12:00:00" , 
"departure_time" : "12:00:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "12:05:10" , 
"departure_time" : "12:05:10" , 
"distance_traveled" : 2.6284
} ], 
"4246" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "12:59:00" , 
"departure_time" : "13:00:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:05:16" , 
"departure_time" : "13:05:16" , 
"distance_traveled" : 2.6284
} ], 
"4247" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "12:20:00" , 
"departure_time" : "12:21:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "12:25:05" , 
"departure_time" : "12:25:05" , 
"distance_traveled" : 2.6284
} ], 
"4248" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "13:20:00" , 
"departure_time" : "13:21:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:26:05" , 
"departure_time" : "13:26:05" , 
"distance_traveled" : 2.6284
} ], 
"4249" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "12:59:00" , 
"departure_time" : "13:01:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:05:10" , 
"departure_time" : "13:05:10" , 
"distance_traveled" : 2.6284
} ], 
"4250" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "14:01:00" , 
"departure_time" : "14:03:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "14:06:57" , 
"departure_time" : "14:06:57" , 
"distance_traveled" : 2.6284
} ], 
"4251" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "13:20:00" , 
"departure_time" : "13:21:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:25:04" , 
"departure_time" : "13:25:04" , 
"distance_traveled" : 2.6284
} ], 
"4252" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "15:00:00" , 
"departure_time" : "15:00:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:05:13" , 
"departure_time" : "15:05:13" , 
"distance_traveled" : 2.6284
} ], 
"4253" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "14:01:00" , 
"departure_time" : "14:02:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "14:07:02" , 
"departure_time" : "14:07:02" , 
"distance_traveled" : 2.6284
} ], 
"4254" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "15:25:00" , 
"departure_time" : "15:27:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:31:26" , 
"departure_time" : "15:31:26" , 
"distance_traveled" : 2.6284
} ], 
"4255" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "15:00:00" , 
"departure_time" : "15:02:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:06:01" , 
"departure_time" : "15:06:01" , 
"distance_traveled" : 2.6284
} ], 
"4256" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "16:00:00" , 
"departure_time" : "16:01:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:05:11" , 
"departure_time" : "16:05:11" , 
"distance_traveled" : 2.6284
} ], 
"4257" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "15:25:00" , 
"departure_time" : "15:26:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:31:21" , 
"departure_time" : "15:31:21" , 
"distance_traveled" : 2.6284
} ], 
"4258" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "16:20:00" , 
"departure_time" : "16:22:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:26:27" , 
"departure_time" : "16:26:27" , 
"distance_traveled" : 2.6284
} ], 
"4259" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "17:21:00" , 
"departure_time" : "17:24:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:27:33" , 
"departure_time" : "17:27:33" , 
"distance_traveled" : 2.6284
} ], 
"4260" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "16:20:00" , 
"departure_time" : "16:22:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:26:16" , 
"departure_time" : "16:26:16" , 
"distance_traveled" : 2.6284
} ], 
"4261" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "17:57:00" , 
"departure_time" : "17:58:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:02:20" , 
"departure_time" : "18:02:20" , 
"distance_traveled" : 2.6284
} ], 
"4262" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "17:21:00" , 
"departure_time" : "17:22:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:27:27" , 
"departure_time" : "17:27:27" , 
"distance_traveled" : 2.6284
} ], 
"4263" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "18:17:00" , 
"departure_time" : "18:19:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:23:21" , 
"departure_time" : "18:23:21" , 
"distance_traveled" : 2.6284
} ], 
"4264" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "17:57:00" , 
"departure_time" : "17:58:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:02:38" , 
"departure_time" : "18:02:38" , 
"distance_traveled" : 2.6284
} ], 
"4265" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "18:57:00" , 
"departure_time" : "18:58:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:02:22" , 
"departure_time" : "19:02:22" , 
"distance_traveled" : 2.6284
} ], 
"4266" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "18:17:00" , 
"departure_time" : "18:18:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:22:55" , 
"departure_time" : "18:22:55" , 
"distance_traveled" : 2.6284
} ], 
"4267" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "19:19:00" , 
"departure_time" : "19:20:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:24:27" , 
"departure_time" : "19:24:27" , 
"distance_traveled" : 2.6284
} ], 
"4268" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "18:57:00" , 
"departure_time" : "18:58:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:03:19" , 
"departure_time" : "19:03:19" , 
"distance_traveled" : 2.6284
} ], 
"4269" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "19:58:00" , 
"departure_time" : "20:00:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "20:03:55" , 
"departure_time" : "20:03:55" , 
"distance_traveled" : 2.6284
} ], 
"4270" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "19:19:00" , 
"departure_time" : "19:21:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:25:24" , 
"departure_time" : "19:25:24" , 
"distance_traveled" : 2.6284
} ], 
"4271" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "20:24:00" , 
"departure_time" : "20:27:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "20:30:39" , 
"departure_time" : "20:30:39" , 
"distance_traveled" : 2.6284
} ], 
"4272" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "21:06:00" , 
"departure_time" : "21:08:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "21:12:03" , 
"departure_time" : "21:12:03" , 
"distance_traveled" : 2.6284
} ], 
"4273" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "20:24:00" , 
"departure_time" : "20:25:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "20:29:37" , 
"departure_time" : "20:29:37" , 
"distance_traveled" : 2.6284
} ], 
"4274" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "21:26:00" , 
"departure_time" : "21:26:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "21:31:01" , 
"departure_time" : "21:31:01" , 
"distance_traveled" : 2.6284
} ], 
"4275" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "21:06:00" , 
"departure_time" : "21:07:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "21:12:30" , 
"departure_time" : "21:12:30" , 
"distance_traveled" : 2.6284
} ], 
"4276" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "21:58:00" , 
"departure_time" : "22:00:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "22:03:46" , 
"departure_time" : "22:03:46" , 
"distance_traveled" : 2.6284
} ], 
"4277" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "21:26:00" , 
"departure_time" : "21:26:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "21:31:13" , 
"departure_time" : "21:31:13" , 
"distance_traveled" : 2.6284
} ], 
"4278" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "22:22:00" , 
"departure_time" : "22:22:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "22:27:27" , 
"departure_time" : "22:27:27" , 
"distance_traveled" : 2.6284
} ], 
"4279" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "22:56:00" , 
"departure_time" : "22:58:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "23:02:37" , 
"departure_time" : "23:02:37" , 
"distance_traveled" : 2.6284
} ], 
"4280" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "22:22:00" , 
"departure_time" : "22:23:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "22:27:17" , 
"departure_time" : "22:27:17" , 
"distance_traveled" : 2.6284
} ], 
"4281" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "23:16:00" , 
"departure_time" : "23:16:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "23:21:42" , 
"departure_time" : "23:21:42" , 
"distance_traveled" : 2.6284
} ], 
"4282" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "22:56:00" , 
"departure_time" : "22:58:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "23:02:18" , 
"departure_time" : "23:02:18" , 
"distance_traveled" : 2.6284
} ], 
"4283" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "23:57:00" , 
"departure_time" : "23:59:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "24:03:13" , 
"departure_time" : "24:03:13" , 
"distance_traveled" : 2.6284
} ], 
"4284" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "23:16:00" , 
"departure_time" : "23:18:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "23:22:40" , 
"departure_time" : "23:22:40" , 
"distance_traveled" : 2.6284
} ], 
"4285" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "04:53:00" , 
"departure_time" : "04:55:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "04:58:20" , 
"departure_time" : "04:58:20" , 
"distance_traveled" : 2.6284
} ], 
"4286" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "23:57:00" , 
"departure_time" : "23:58:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "24:03:19" , 
"departure_time" : "24:03:19" , 
"distance_traveled" : 2.6284
} ], 
"4287" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "05:23:00" , 
"departure_time" : "05:24:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "05:28:25" , 
"departure_time" : "05:28:25" , 
"distance_traveled" : 2.6284
} ], 
"4288" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "04:53:00" , 
"departure_time" : "04:55:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "04:59:35" , 
"departure_time" : "04:59:35" , 
"distance_traveled" : 2.6284
} ], 
"4289" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "05:50:00" , 
"departure_time" : "05:52:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "05:56:18" , 
"departure_time" : "05:56:18" , 
"distance_traveled" : 2.6284
} ], 
"4290" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "05:23:00" , 
"departure_time" : "05:25:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "05:29:05" , 
"departure_time" : "05:29:05" , 
"distance_traveled" : 2.6284
} ], 
"4291" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "06:26:00" , 
"departure_time" : "06:27:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "06:31:42" , 
"departure_time" : "06:31:42" , 
"distance_traveled" : 2.6284
} ], 
"4292" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "05:50:00" , 
"departure_time" : "05:52:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "05:56:39" , 
"departure_time" : "05:56:39" , 
"distance_traveled" : 2.6284
} ], 
"4293" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "06:50:00" , 
"departure_time" : "06:51:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "06:55:14" , 
"departure_time" : "06:55:14" , 
"distance_traveled" : 2.6284
} ], 
"4294" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "06:26:00" , 
"departure_time" : "06:27:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "06:31:46" , 
"departure_time" : "06:31:46" , 
"distance_traveled" : 2.6284
} ], 
"4295" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "07:20:00" , 
"departure_time" : "07:21:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "07:25:16" , 
"departure_time" : "07:25:16" , 
"distance_traveled" : 2.6284
} ], 
"4296" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "06:50:00" , 
"departure_time" : "06:50:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "06:55:27" , 
"departure_time" : "06:55:27" , 
"distance_traveled" : 2.6284
} ], 
"4297" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "07:47:00" , 
"departure_time" : "07:48:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "07:52:55" , 
"departure_time" : "07:52:55" , 
"distance_traveled" : 2.6284
} ], 
"4298" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "07:20:00" , 
"departure_time" : "07:21:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "07:25:27" , 
"departure_time" : "07:25:27" , 
"distance_traveled" : 2.6284
} ], 
"4299" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "08:09:00" , 
"departure_time" : "08:10:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "08:14:39" , 
"departure_time" : "08:14:39" , 
"distance_traveled" : 2.6284
} ], 
"4300" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "07:47:00" , 
"departure_time" : "07:49:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "07:53:23" , 
"departure_time" : "07:53:23" , 
"distance_traveled" : 2.6284
} ], 
"4301" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "08:30:00" , 
"departure_time" : "08:32:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "08:36:26" , 
"departure_time" : "08:36:26" , 
"distance_traveled" : 2.6284
} ], 
"4302" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "08:09:00" , 
"departure_time" : "08:11:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "08:14:51" , 
"departure_time" : "08:14:51" , 
"distance_traveled" : 2.6284
} ], 
"4303" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "08:57:00" , 
"departure_time" : "08:58:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "09:02:10" , 
"departure_time" : "09:02:10" , 
"distance_traveled" : 2.6284
} ], 
"4304" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "08:30:00" , 
"departure_time" : "08:31:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "08:36:23" , 
"departure_time" : "08:36:23" , 
"distance_traveled" : 2.6284
} ], 
"4305" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "09:24:00" , 
"departure_time" : "09:26:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "09:30:17" , 
"departure_time" : "09:30:17" , 
"distance_traveled" : 2.6284
} ], 
"4306" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "08:57:00" , 
"departure_time" : "08:58:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "09:02:31" , 
"departure_time" : "09:02:31" , 
"distance_traveled" : 2.6284
} ], 
"4307" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "09:52:00" , 
"departure_time" : "09:52:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "09:57:08" , 
"departure_time" : "09:57:08" , 
"distance_traveled" : 2.6284
} ], 
"4308" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "09:24:00" , 
"departure_time" : "09:25:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "09:30:00" , 
"departure_time" : "09:30:00" , 
"distance_traveled" : 2.6284
} ], 
"4309" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "10:15:00" , 
"departure_time" : "10:16:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "10:20:47" , 
"departure_time" : "10:20:47" , 
"distance_traveled" : 2.6284
} ], 
"4310" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "09:52:00" , 
"departure_time" : "09:53:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "09:58:04" , 
"departure_time" : "09:58:04" , 
"distance_traveled" : 2.6284
} ], 
"4311" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "11:10:00" , 
"departure_time" : "11:11:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "11:15:25" , 
"departure_time" : "11:15:25" , 
"distance_traveled" : 2.6284
} ], 
"4312" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "10:15:00" , 
"departure_time" : "10:16:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "10:21:17" , 
"departure_time" : "10:21:17" , 
"distance_traveled" : 2.6284
} ], 
"4313" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "11:30:00" , 
"departure_time" : "11:32:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "11:36:02" , 
"departure_time" : "11:36:02" , 
"distance_traveled" : 2.6284
} ], 
"4314" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "11:10:00" , 
"departure_time" : "11:12:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "11:16:07" , 
"departure_time" : "11:16:07" , 
"distance_traveled" : 2.6284
} ], 
"4315" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "11:52:00" , 
"departure_time" : "11:54:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "11:58:36" , 
"departure_time" : "11:58:36" , 
"distance_traveled" : 2.6284
} ], 
"4316" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "11:30:00" , 
"departure_time" : "11:31:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "11:35:11" , 
"departure_time" : "11:35:11" , 
"distance_traveled" : 2.6284
} ], 
"4317" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "12:18:00" , 
"departure_time" : "12:18:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "12:23:27" , 
"departure_time" : "12:23:27" , 
"distance_traveled" : 2.6284
} ], 
"4318" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "11:52:00" , 
"departure_time" : "11:52:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "11:57:09" , 
"departure_time" : "11:57:09" , 
"distance_traveled" : 2.6284
} ], 
"4319" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "12:49:00" , 
"departure_time" : "12:50:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "12:55:39" , 
"departure_time" : "12:55:39" , 
"distance_traveled" : 2.6284
} ], 
"4320" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "12:18:00" , 
"departure_time" : "12:20:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "12:23:38" , 
"departure_time" : "12:23:38" , 
"distance_traveled" : 2.6284
} ], 
"4321" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "13:11:00" , 
"departure_time" : "13:12:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:17:06" , 
"departure_time" : "13:17:06" , 
"distance_traveled" : 2.6284
} ], 
"4322" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "12:49:00" , 
"departure_time" : "12:50:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "12:54:30" , 
"departure_time" : "12:54:30" , 
"distance_traveled" : 2.6284
} ], 
"4323" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "13:46:00" , 
"departure_time" : "13:47:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:52:05" , 
"departure_time" : "13:52:05" , 
"distance_traveled" : 2.6284
} ], 
"4324" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "13:11:00" , 
"departure_time" : "13:13:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:17:35" , 
"departure_time" : "13:17:35" , 
"distance_traveled" : 2.6284
} ], 
"4325" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "14:13:00" , 
"departure_time" : "14:16:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "14:19:29" , 
"departure_time" : "14:19:29" , 
"distance_traveled" : 2.6284
} ], 
"4326" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "13:46:00" , 
"departure_time" : "13:47:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:51:23" , 
"departure_time" : "13:51:23" , 
"distance_traveled" : 2.6284
} ], 
"4327" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "14:47:00" , 
"departure_time" : "14:48:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "14:52:48" , 
"departure_time" : "14:52:48" , 
"distance_traveled" : 2.6284
} ], 
"4328" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "14:13:00" , 
"departure_time" : "14:14:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "14:18:59" , 
"departure_time" : "14:18:59" , 
"distance_traveled" : 2.6284
} ], 
"4329" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "15:14:00" , 
"departure_time" : "15:15:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:19:28" , 
"departure_time" : "15:19:28" , 
"distance_traveled" : 2.6284
} ], 
"4330" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "14:47:00" , 
"departure_time" : "14:48:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "14:53:22" , 
"departure_time" : "14:53:22" , 
"distance_traveled" : 2.6284
} ], 
"4331" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "15:38:00" , 
"departure_time" : "15:39:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:43:03" , 
"departure_time" : "15:43:03" , 
"distance_traveled" : 2.6284
} ], 
"4332" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "15:14:00" , 
"departure_time" : "15:14:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:19:27" , 
"departure_time" : "15:19:27" , 
"distance_traveled" : 2.6284
} ], 
"4333" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "16:14:00" , 
"departure_time" : "16:15:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:20:10" , 
"departure_time" : "16:20:10" , 
"distance_traveled" : 2.6284
} ], 
"4334" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "15:38:00" , 
"departure_time" : "15:40:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:43:57" , 
"departure_time" : "15:43:57" , 
"distance_traveled" : 2.6284
} ], 
"4335" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "16:38:00" , 
"departure_time" : "16:40:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:44:33" , 
"departure_time" : "16:44:33" , 
"distance_traveled" : 2.6284
} ], 
"4336" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "16:14:00" , 
"departure_time" : "16:15:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:19:09" , 
"departure_time" : "16:19:09" , 
"distance_traveled" : 2.6284
} ], 
"4337" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "17:06:00" , 
"departure_time" : "17:06:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:11:15" , 
"departure_time" : "17:11:15" , 
"distance_traveled" : 2.6284
} ], 
"4338" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "16:38:00" , 
"departure_time" : "16:38:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:43:25" , 
"departure_time" : "16:43:25" , 
"distance_traveled" : 2.6284
} ], 
"4339" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "17:30:00" , 
"departure_time" : "17:30:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:35:20" , 
"departure_time" : "17:35:20" , 
"distance_traveled" : 2.6284
} ], 
"4340" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "17:06:00" , 
"departure_time" : "17:06:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:11:16" , 
"departure_time" : "17:11:16" , 
"distance_traveled" : 2.6284
} ], 
"4341" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "17:50:00" , 
"departure_time" : "17:51:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:55:57" , 
"departure_time" : "17:55:57" , 
"distance_traveled" : 2.6284
} ], 
"4342" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "17:30:00" , 
"departure_time" : "17:32:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:36:09" , 
"departure_time" : "17:36:09" , 
"distance_traveled" : 2.6284
} ], 
"4343" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "18:10:00" , 
"departure_time" : "18:11:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:15:11" , 
"departure_time" : "18:15:11" , 
"distance_traveled" : 2.6284
} ], 
"4344" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "17:50:00" , 
"departure_time" : "17:50:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:55:07" , 
"departure_time" : "17:55:07" , 
"distance_traveled" : 2.6284
} ], 
"4345" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "18:33:00" , 
"departure_time" : "18:34:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:39:01" , 
"departure_time" : "18:39:01" , 
"distance_traveled" : 2.6284
} ], 
"4346" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "18:10:00" , 
"departure_time" : "18:12:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:16:24" , 
"departure_time" : "18:16:24" , 
"distance_traveled" : 2.6284
} ], 
"4347" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "18:53:00" , 
"departure_time" : "18:55:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:58:44" , 
"departure_time" : "18:58:44" , 
"distance_traveled" : 2.6284
} ], 
"4348" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "18:33:00" , 
"departure_time" : "18:35:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:39:17" , 
"departure_time" : "18:39:17" , 
"distance_traveled" : 2.6284
} ], 
"4349" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "19:13:00" , 
"departure_time" : "19:15:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:18:53" , 
"departure_time" : "19:18:53" , 
"distance_traveled" : 2.6284
} ], 
"4350" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "18:53:00" , 
"departure_time" : "18:55:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:59:20" , 
"departure_time" : "18:59:20" , 
"distance_traveled" : 2.6284
} ], 
"4351" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "19:33:00" , 
"departure_time" : "19:35:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:39:22" , 
"departure_time" : "19:39:22" , 
"distance_traveled" : 2.6284
} ], 
"4352" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "19:13:00" , 
"departure_time" : "19:15:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:19:02" , 
"departure_time" : "19:19:02" , 
"distance_traveled" : 2.6284
} ], 
"4353" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "19:58:00" , 
"departure_time" : "19:59:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "20:03:51" , 
"departure_time" : "20:03:51" , 
"distance_traveled" : 2.6284
} ], 
"4354" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "19:33:00" , 
"departure_time" : "19:33:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:38:04" , 
"departure_time" : "19:38:04" , 
"distance_traveled" : 2.6284
} ], 
"4355" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "20:42:00" , 
"departure_time" : "20:42:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "20:47:54" , 
"departure_time" : "20:47:54" , 
"distance_traveled" : 2.6284
} ], 
"4356" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "19:58:00" , 
"departure_time" : "19:59:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "20:03:22" , 
"departure_time" : "20:03:22" , 
"distance_traveled" : 2.6284
} ], 
"4357" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "21:03:00" , 
"departure_time" : "21:04:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "21:09:15" , 
"departure_time" : "21:09:15" , 
"distance_traveled" : 2.6284
} ], 
"4358" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "20:42:00" , 
"departure_time" : "20:44:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "20:48:26" , 
"departure_time" : "20:48:26" , 
"distance_traveled" : 2.6284
} ], 
"4359" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "22:08:00" , 
"departure_time" : "22:09:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "22:13:21" , 
"departure_time" : "22:13:21" , 
"distance_traveled" : 2.6284
} ], 
"4360" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "21:03:00" , 
"departure_time" : "21:04:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "21:08:54" , 
"departure_time" : "21:08:54" , 
"distance_traveled" : 2.6284
} ], 
"4361" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "22:40:00" , 
"departure_time" : "22:41:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "22:45:24" , 
"departure_time" : "22:45:24" , 
"distance_traveled" : 2.6284
} ], 
"4362" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "22:08:00" , 
"departure_time" : "22:09:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "22:14:24" , 
"departure_time" : "22:14:24" , 
"distance_traveled" : 2.6284
} ], 
"4363" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "23:18:00" , 
"departure_time" : "23:19:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "23:23:11" , 
"departure_time" : "23:23:11" , 
"distance_traveled" : 2.6284
} ], 
"4364" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "22:40:00" , 
"departure_time" : "22:40:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "22:45:37" , 
"departure_time" : "22:45:37" , 
"distance_traveled" : 2.6284
} ], 
"4365" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "23:49:00" , 
"departure_time" : "23:50:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "23:54:55" , 
"departure_time" : "23:54:55" , 
"distance_traveled" : 2.6284
} ], 
"4366" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "23:18:00" , 
"departure_time" : "23:19:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "23:24:04" , 
"departure_time" : "23:24:04" , 
"distance_traveled" : 2.6284
} ], 
"4367" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "23:49:00" , 
"departure_time" : "23:50:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "23:54:18" , 
"departure_time" : "23:54:18" , 
"distance_traveled" : 2.6284
} ], 
"4368" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "16:00:00" , 
"departure_time" : "16:01:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:06:02" , 
"departure_time" : "16:06:02" , 
"distance_traveled" : 2.6284
} ], 
"4369" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "19:58:00" , 
"departure_time" : "19:59:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "20:03:37" , 
"departure_time" : "20:03:37" , 
"distance_traveled" : 2.6284
} ], 
"4370" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "21:58:00" , 
"departure_time" : "21:59:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "22:04:07" , 
"departure_time" : "22:04:07" , 
"distance_traveled" : 2.6284
} ], 
"4371" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "25:45:00" , 
"departure_time" : "25:46:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "25:50:23" , 
"departure_time" : "25:50:23" , 
"distance_traveled" : 2.6284
} ], 
"4372" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "14:01:00" , 
"departure_time" : "14:01:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "14:06:08" , 
"departure_time" : "14:06:08" , 
"distance_traveled" : 2.6284
} ], 
"4373" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "24:18:00" , 
"departure_time" : "24:19:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "24:24:14" , 
"departure_time" : "24:24:14" , 
"distance_traveled" : 2.6284
} ], 
"4374" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "25:13:00" , 
"departure_time" : "25:14:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "25:18:31" , 
"departure_time" : "25:18:31" , 
"distance_traveled" : 2.6284
} ], 
"4375" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "24:18:00" , 
"departure_time" : "24:19:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "24:24:24" , 
"departure_time" : "24:24:24" , 
"distance_traveled" : 2.6284
} ], 
"4376" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "25:13:00" , 
"departure_time" : "25:14:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "25:18:05" , 
"departure_time" : "25:18:05" , 
"distance_traveled" : 2.6284
} ], 
"4377" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "05:01:00" , 
"departure_time" : "05:02:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "05:07:25" , 
"departure_time" : "05:07:25" , 
"distance_traveled" : 2.6284
} ], 
"4378" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "05:39:00" , 
"departure_time" : "05:41:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "05:44:35" , 
"departure_time" : "05:44:35" , 
"distance_traveled" : 2.6284
} ], 
"4379" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "05:59:00" , 
"departure_time" : "06:00:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "06:05:01" , 
"departure_time" : "06:05:01" , 
"distance_traveled" : 2.6284
} ], 
"4380" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "06:58:00" , 
"departure_time" : "06:59:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "07:03:45" , 
"departure_time" : "07:03:45" , 
"distance_traveled" : 2.6284
} ], 
"4381" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "07:21:00" , 
"departure_time" : "07:22:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "07:27:12" , 
"departure_time" : "07:27:12" , 
"distance_traveled" : 2.6284
} ], 
"4382" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "07:58:00" , 
"departure_time" : "08:00:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "08:03:51" , 
"departure_time" : "08:03:51" , 
"distance_traveled" : 2.6284
} ], 
"4383" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "08:20:00" , 
"departure_time" : "08:20:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "08:25:06" , 
"departure_time" : "08:25:06" , 
"distance_traveled" : 2.6284
} ], 
"4384" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "08:55:00" , 
"departure_time" : "08:55:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "09:00:03" , 
"departure_time" : "09:00:03" , 
"distance_traveled" : 2.6284
} ], 
"4385" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "09:19:00" , 
"departure_time" : "09:19:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "09:24:47" , 
"departure_time" : "09:24:47" , 
"distance_traveled" : 2.6284
} ], 
"4386" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "10:02:00" , 
"departure_time" : "10:03:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "10:07:21" , 
"departure_time" : "10:07:21" , 
"distance_traveled" : 2.6284
} ], 
"4387" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "10:23:00" , 
"departure_time" : "10:24:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "10:29:10" , 
"departure_time" : "10:29:10" , 
"distance_traveled" : 2.6284
} ], 
"4388" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "10:58:00" , 
"departure_time" : "11:00:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "11:03:52" , 
"departure_time" : "11:03:52" , 
"distance_traveled" : 2.6284
} ], 
"4389" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "11:20:00" , 
"departure_time" : "11:21:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "11:26:07" , 
"departure_time" : "11:26:07" , 
"distance_traveled" : 2.6284
} ], 
"4390" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "12:00:00" , 
"departure_time" : "12:01:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "12:05:22" , 
"departure_time" : "12:05:22" , 
"distance_traveled" : 2.6284
} ], 
"4391" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "12:20:00" , 
"departure_time" : "12:20:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "12:25:20" , 
"departure_time" : "12:25:20" , 
"distance_traveled" : 2.6284
} ], 
"4392" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "12:59:00" , 
"departure_time" : "13:00:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:04:55" , 
"departure_time" : "13:04:55" , 
"distance_traveled" : 2.6284
} ], 
"4393" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "13:20:00" , 
"departure_time" : "13:22:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "13:26:08" , 
"departure_time" : "13:26:08" , 
"distance_traveled" : 2.6284
} ], 
"4394" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "15:00:00" , 
"departure_time" : "15:02:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:06:10" , 
"departure_time" : "15:06:10" , 
"distance_traveled" : 2.6284
} ], 
"4395" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "15:25:00" , 
"departure_time" : "15:27:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "15:30:57" , 
"departure_time" : "15:30:57" , 
"distance_traveled" : 2.6284
} ], 
"4396" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "16:00:00" , 
"departure_time" : "16:02:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:06:21" , 
"departure_time" : "16:06:21" , 
"distance_traveled" : 2.6284
} ], 
"4397" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "16:20:00" , 
"departure_time" : "16:22:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "16:26:37" , 
"departure_time" : "16:26:37" , 
"distance_traveled" : 2.6284
} ], 
"4398" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "17:21:00" , 
"departure_time" : "17:23:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "17:26:24" , 
"departure_time" : "17:26:24" , 
"distance_traveled" : 2.6284
} ], 
"4399" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "17:57:00" , 
"departure_time" : "17:57:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:02:09" , 
"departure_time" : "18:02:09" , 
"distance_traveled" : 2.6284
} ], 
"4400" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "18:17:00" , 
"departure_time" : "18:18:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "18:23:37" , 
"departure_time" : "18:23:37" , 
"distance_traveled" : 2.6284
} ], 
"4401" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "18:57:00" , 
"departure_time" : "18:59:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:03:17" , 
"departure_time" : "19:03:17" , 
"distance_traveled" : 2.6284
} ], 
"4402" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "19:19:00" , 
"departure_time" : "19:21:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "19:25:20" , 
"departure_time" : "19:25:20" , 
"distance_traveled" : 2.6284
} ], 
"4403" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "19:58:00" , 
"departure_time" : "20:00:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "20:04:39" , 
"departure_time" : "20:04:39" , 
"distance_traveled" : 2.6284
} ], 
"4404" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "20:24:00" , 
"departure_time" : "20:26:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "20:29:28" , 
"departure_time" : "20:29:28" , 
"distance_traveled" : 2.6284
} ], 
"4405" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "21:06:00" , 
"departure_time" : "21:07:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "21:12:23" , 
"departure_time" : "21:12:23" , 
"distance_traveled" : 2.6284
} ], 
"4406" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "21:26:00" , 
"departure_time" : "21:27:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "21:31:06" , 
"departure_time" : "21:31:06" , 
"distance_traveled" : 2.6284
} ], 
"4407" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "21:58:00" , 
"departure_time" : "21:59:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "22:04:14" , 
"departure_time" : "22:04:14" , 
"distance_traveled" : 2.6284
} ], 
"4408" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "22:22:00" , 
"departure_time" : "22:23:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "22:27:22" , 
"departure_time" : "22:27:22" , 
"distance_traveled" : 2.6284
} ], 
"4409" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "22:56:00" , 
"departure_time" : "22:57:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "23:02:04" , 
"departure_time" : "23:02:04" , 
"distance_traveled" : 2.6284
} ], 
"4410" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "23:16:00" , 
"departure_time" : "23:18:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "23:22:00" , 
"departure_time" : "23:22:00" , 
"distance_traveled" : 2.6284
} ], 
"4411" :  [ 
{ 
"stop_id" : 124,
"arrival_time" : "23:57:00" , 
"departure_time" : "23:59:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 125,
"arrival_time" : "24:03:20" , 
"departure_time" : "24:03:20" , 
"distance_traveled" : 2.6284
} ], 
"4412" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "24:31:00" , 
"departure_time" : "24:33:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "24:37:35" , 
"departure_time" : "24:37:35" , 
"distance_traveled" : 7.8261
} ], 
"4413" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "24:31:00" , 
"departure_time" : "24:33:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "24:36:26" , 
"departure_time" : "24:36:26" , 
"distance_traveled" : 7.8261
} ], 
"4414" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "25:37:00" , 
"departure_time" : "25:38:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "25:43:03" , 
"departure_time" : "25:43:03" , 
"distance_traveled" : 7.8261
} ], 
"4415" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "25:37:00" , 
"departure_time" : "25:38:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "25:42:08" , 
"departure_time" : "25:42:08" , 
"distance_traveled" : 7.8261
} ], 
"4416" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "24:07:00" , 
"departure_time" : "24:07:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "24:12:04" , 
"departure_time" : "24:12:04" , 
"distance_traveled" : 7.8261
} ], 
"4417" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "24:07:00" , 
"departure_time" : "24:08:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "24:12:56" , 
"departure_time" : "24:12:56" , 
"distance_traveled" : 7.8261
} ], 
"4418" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "24:35:00" , 
"departure_time" : "24:36:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "24:40:46" , 
"departure_time" : "24:40:46" , 
"distance_traveled" : 7.8261
} ], 
"4419" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "24:35:00" , 
"departure_time" : "24:36:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "24:40:23" , 
"departure_time" : "24:40:23" , 
"distance_traveled" : 7.8261
} ], 
"4420" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "24:07:00" , 
"departure_time" : "24:07:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "24:12:31" , 
"departure_time" : "24:12:31" , 
"distance_traveled" : 7.8261
} ], 
"4421" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "24:35:00" , 
"departure_time" : "24:36:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "24:41:13" , 
"departure_time" : "24:41:13" , 
"distance_traveled" : 7.8261
} ], 
"4422" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "09:05:00" , 
"departure_time" : "09:07:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "09:10:48" , 
"departure_time" : "09:10:48" , 
"distance_traveled" : 7.8261
} ], 
"4423" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "09:05:00" , 
"departure_time" : "09:06:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "09:10:57" , 
"departure_time" : "09:10:57" , 
"distance_traveled" : 7.8261
} ], 
"4424" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "09:34:00" , 
"departure_time" : "09:36:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "09:40:15" , 
"departure_time" : "09:40:15" , 
"distance_traveled" : 7.8261
} ], 
"4425" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "10:12:00" , 
"departure_time" : "10:14:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "10:17:54" , 
"departure_time" : "10:17:54" , 
"distance_traveled" : 7.8261
} ], 
"4426" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "10:12:00" , 
"departure_time" : "10:14:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "10:18:07" , 
"departure_time" : "10:18:07" , 
"distance_traveled" : 7.8261
} ], 
"4427" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "10:34:00" , 
"departure_time" : "10:35:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "10:39:38" , 
"departure_time" : "10:39:38" , 
"distance_traveled" : 7.8261
} ], 
"4428" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "11:09:00" , 
"departure_time" : "11:11:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "11:15:23" , 
"departure_time" : "11:15:23" , 
"distance_traveled" : 7.8261
} ], 
"4429" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "11:09:00" , 
"departure_time" : "11:10:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "11:14:12" , 
"departure_time" : "11:14:12" , 
"distance_traveled" : 7.8261
} ], 
"4430" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "11:34:00" , 
"departure_time" : "11:35:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "11:40:12" , 
"departure_time" : "11:40:12" , 
"distance_traveled" : 7.8261
} ], 
"4431" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "12:10:00" , 
"departure_time" : "12:11:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "12:15:34" , 
"departure_time" : "12:15:34" , 
"distance_traveled" : 7.8261
} ], 
"4432" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "12:10:00" , 
"departure_time" : "12:12:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "12:16:29" , 
"departure_time" : "12:16:29" , 
"distance_traveled" : 7.8261
} ], 
"4433" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "12:34:00" , 
"departure_time" : "12:36:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "12:39:41" , 
"departure_time" : "12:39:41" , 
"distance_traveled" : 7.8261
} ], 
"4434" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "13:09:00" , 
"departure_time" : "13:10:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "13:15:13" , 
"departure_time" : "13:15:13" , 
"distance_traveled" : 7.8261
} ], 
"4435" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "13:09:00" , 
"departure_time" : "13:10:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "13:14:07" , 
"departure_time" : "13:14:07" , 
"distance_traveled" : 7.8261
} ], 
"4436" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "13:35:00" , 
"departure_time" : "13:35:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "13:40:12" , 
"departure_time" : "13:40:12" , 
"distance_traveled" : 7.8261
} ], 
"4437" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "14:35:00" , 
"departure_time" : "14:36:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "14:41:05" , 
"departure_time" : "14:41:05" , 
"distance_traveled" : 7.8261
} ], 
"4438" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "15:11:00" , 
"departure_time" : "15:12:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "15:16:43" , 
"departure_time" : "15:16:43" , 
"distance_traveled" : 7.8261
} ], 
"4439" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "15:35:00" , 
"departure_time" : "15:36:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "15:40:51" , 
"departure_time" : "15:40:51" , 
"distance_traveled" : 7.8261
} ], 
"4440" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "16:10:00" , 
"departure_time" : "16:11:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "16:15:45" , 
"departure_time" : "16:15:45" , 
"distance_traveled" : 7.8261
} ], 
"4441" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "16:10:00" , 
"departure_time" : "16:11:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "16:15:39" , 
"departure_time" : "16:15:39" , 
"distance_traveled" : 7.8261
} ], 
"4442" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "17:11:00" , 
"departure_time" : "17:12:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "17:16:29" , 
"departure_time" : "17:16:29" , 
"distance_traveled" : 7.8261
} ], 
"4443" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "17:11:00" , 
"departure_time" : "17:12:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "17:17:14" , 
"departure_time" : "17:17:14" , 
"distance_traveled" : 7.8261
} ], 
"4444" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "17:34:00" , 
"departure_time" : "17:36:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "17:40:17" , 
"departure_time" : "17:40:17" , 
"distance_traveled" : 7.8261
} ], 
"4445" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "17:34:00" , 
"departure_time" : "17:35:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "17:39:13" , 
"departure_time" : "17:39:13" , 
"distance_traveled" : 7.8261
} ], 
"4446" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "18:07:00" , 
"departure_time" : "18:08:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "18:13:04" , 
"departure_time" : "18:13:04" , 
"distance_traveled" : 7.8261
} ], 
"4447" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "18:07:00" , 
"departure_time" : "18:08:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "18:12:08" , 
"departure_time" : "18:12:08" , 
"distance_traveled" : 7.8261
} ], 
"4448" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "18:35:00" , 
"departure_time" : "18:35:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "18:40:06" , 
"departure_time" : "18:40:06" , 
"distance_traveled" : 7.8261
} ], 
"4449" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "19:07:00" , 
"departure_time" : "19:08:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "19:13:40" , 
"departure_time" : "19:13:40" , 
"distance_traveled" : 7.8261
} ], 
"4450" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "19:07:00" , 
"departure_time" : "19:09:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "19:13:17" , 
"departure_time" : "19:13:17" , 
"distance_traveled" : 7.8261
} ], 
"4451" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "19:34:00" , 
"departure_time" : "19:35:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "19:39:42" , 
"departure_time" : "19:39:42" , 
"distance_traveled" : 7.8261
} ], 
"4452" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "20:14:00" , 
"departure_time" : "20:14:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "20:19:14" , 
"departure_time" : "20:19:14" , 
"distance_traveled" : 7.8261
} ], 
"4453" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "20:14:00" , 
"departure_time" : "20:14:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "20:19:37" , 
"departure_time" : "20:19:37" , 
"distance_traveled" : 7.8261
} ], 
"4454" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "20:34:00" , 
"departure_time" : "20:35:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "20:39:41" , 
"departure_time" : "20:39:41" , 
"distance_traveled" : 7.8261
} ], 
"4455" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "20:34:00" , 
"departure_time" : "20:36:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "20:40:22" , 
"departure_time" : "20:40:22" , 
"distance_traveled" : 7.8261
} ], 
"4456" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "21:16:00" , 
"departure_time" : "21:19:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "21:22:39" , 
"departure_time" : "21:22:39" , 
"distance_traveled" : 7.8261
} ], 
"4457" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "21:16:00" , 
"departure_time" : "21:18:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "21:21:25" , 
"departure_time" : "21:21:25" , 
"distance_traveled" : 7.8261
} ], 
"4458" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "21:36:00" , 
"departure_time" : "21:36:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "21:41:21" , 
"departure_time" : "21:41:21" , 
"distance_traveled" : 7.8261
} ], 
"4459" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "21:36:00" , 
"departure_time" : "21:36:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "21:41:27" , 
"departure_time" : "21:41:27" , 
"distance_traveled" : 7.8261
} ], 
"4460" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "22:08:00" , 
"departure_time" : "22:09:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "22:14:21" , 
"departure_time" : "22:14:21" , 
"distance_traveled" : 7.8261
} ], 
"4461" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "22:08:00" , 
"departure_time" : "22:10:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "22:14:08" , 
"departure_time" : "22:14:08" , 
"distance_traveled" : 7.8261
} ], 
"4462" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "22:35:00" , 
"departure_time" : "22:37:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "22:41:01" , 
"departure_time" : "22:41:01" , 
"distance_traveled" : 7.8261
} ], 
"4463" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "23:06:00" , 
"departure_time" : "23:07:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "23:11:25" , 
"departure_time" : "23:11:25" , 
"distance_traveled" : 7.8261
} ], 
"4464" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "23:06:00" , 
"departure_time" : "23:07:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "23:11:45" , 
"departure_time" : "23:11:45" , 
"distance_traveled" : 7.8261
} ], 
"4465" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "23:35:00" , 
"departure_time" : "23:36:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "23:41:08" , 
"departure_time" : "23:41:08" , 
"distance_traveled" : 7.8261
} ], 
"4466" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "04:43:00" , 
"departure_time" : "04:44:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "04:48:19" , 
"departure_time" : "04:48:19" , 
"distance_traveled" : 7.8261
} ], 
"4467" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "04:43:00" , 
"departure_time" : "04:43:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "04:48:06" , 
"departure_time" : "04:48:06" , 
"distance_traveled" : 7.8261
} ], 
"4468" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "05:11:00" , 
"departure_time" : "05:12:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "05:17:06" , 
"departure_time" : "05:17:06" , 
"distance_traveled" : 7.8261
} ], 
"4469" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "05:11:00" , 
"departure_time" : "05:13:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "05:17:33" , 
"departure_time" : "05:17:33" , 
"distance_traveled" : 7.8261
} ], 
"4470" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "05:38:00" , 
"departure_time" : "05:39:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "05:43:13" , 
"departure_time" : "05:43:13" , 
"distance_traveled" : 7.8261
} ], 
"4471" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "05:38:00" , 
"departure_time" : "05:39:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "05:43:49" , 
"departure_time" : "05:43:49" , 
"distance_traveled" : 7.8261
} ], 
"4472" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "06:09:00" , 
"departure_time" : "06:10:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "06:14:52" , 
"departure_time" : "06:14:52" , 
"distance_traveled" : 7.8261
} ], 
"4473" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "06:09:00" , 
"departure_time" : "06:11:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "06:15:40" , 
"departure_time" : "06:15:40" , 
"distance_traveled" : 7.8261
} ], 
"4474" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "06:36:00" , 
"departure_time" : "06:39:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "06:42:33" , 
"departure_time" : "06:42:33" , 
"distance_traveled" : 7.8261
} ], 
"4475" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "06:36:00" , 
"departure_time" : "06:38:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "06:42:20" , 
"departure_time" : "06:42:20" , 
"distance_traveled" : 7.8261
} ], 
"4476" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "07:05:00" , 
"departure_time" : "07:07:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "07:11:14" , 
"departure_time" : "07:11:14" , 
"distance_traveled" : 7.8261
} ], 
"4477" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "07:05:00" , 
"departure_time" : "07:07:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "07:11:35" , 
"departure_time" : "07:11:35" , 
"distance_traveled" : 7.8261
} ], 
"4478" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "07:30:00" , 
"departure_time" : "07:32:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "07:36:23" , 
"departure_time" : "07:36:23" , 
"distance_traveled" : 7.8261
} ], 
"4479" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "07:30:00" , 
"departure_time" : "07:31:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "07:35:14" , 
"departure_time" : "07:35:14" , 
"distance_traveled" : 7.8261
} ], 
"4480" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "07:57:00" , 
"departure_time" : "07:57:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "08:02:23" , 
"departure_time" : "08:02:23" , 
"distance_traveled" : 7.8261
} ], 
"4481" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "07:57:00" , 
"departure_time" : "07:57:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "08:02:18" , 
"departure_time" : "08:02:18" , 
"distance_traveled" : 7.8261
} ], 
"4482" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "08:19:00" , 
"departure_time" : "08:20:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "08:25:29" , 
"departure_time" : "08:25:29" , 
"distance_traveled" : 7.8261
} ], 
"4483" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "08:19:00" , 
"departure_time" : "08:20:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "08:24:06" , 
"departure_time" : "08:24:06" , 
"distance_traveled" : 7.8261
} ], 
"4484" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "08:40:00" , 
"departure_time" : "08:41:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "08:46:12" , 
"departure_time" : "08:46:12" , 
"distance_traveled" : 7.8261
} ], 
"4485" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "08:40:00" , 
"departure_time" : "08:42:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "08:46:23" , 
"departure_time" : "08:46:23" , 
"distance_traveled" : 7.8261
} ], 
"4486" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "09:14:00" , 
"departure_time" : "09:16:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "09:19:42" , 
"departure_time" : "09:19:42" , 
"distance_traveled" : 7.8261
} ], 
"4487" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "09:14:00" , 
"departure_time" : "09:15:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "09:19:29" , 
"departure_time" : "09:19:29" , 
"distance_traveled" : 7.8261
} ], 
"4488" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "09:34:00" , 
"departure_time" : "09:34:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "09:39:14" , 
"departure_time" : "09:39:14" , 
"distance_traveled" : 7.8261
} ], 
"4489" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "09:34:00" , 
"departure_time" : "09:34:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "09:39:01" , 
"departure_time" : "09:39:01" , 
"distance_traveled" : 7.8261
} ], 
"4490" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "10:02:00" , 
"departure_time" : "10:02:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "10:07:11" , 
"departure_time" : "10:07:11" , 
"distance_traveled" : 7.8261
} ], 
"4491" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "10:02:00" , 
"departure_time" : "10:03:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "10:08:35" , 
"departure_time" : "10:08:35" , 
"distance_traveled" : 7.8261
} ], 
"4492" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "11:00:00" , 
"departure_time" : "11:02:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "11:06:14" , 
"departure_time" : "11:06:14" , 
"distance_traveled" : 7.8261
} ], 
"4493" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "11:00:00" , 
"departure_time" : "11:01:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "11:05:38" , 
"departure_time" : "11:05:38" , 
"distance_traveled" : 7.8261
} ], 
"4494" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "11:20:00" , 
"departure_time" : "11:20:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "11:25:01" , 
"departure_time" : "11:25:01" , 
"distance_traveled" : 7.8261
} ], 
"4495" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "11:20:00" , 
"departure_time" : "11:21:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "11:26:17" , 
"departure_time" : "11:26:17" , 
"distance_traveled" : 7.8261
} ], 
"4496" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "11:40:00" , 
"departure_time" : "11:41:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "11:45:04" , 
"departure_time" : "11:45:04" , 
"distance_traveled" : 7.8261
} ], 
"4497" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "11:40:00" , 
"departure_time" : "11:41:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "11:46:02" , 
"departure_time" : "11:46:02" , 
"distance_traveled" : 7.8261
} ], 
"4498" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "12:02:00" , 
"departure_time" : "12:04:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "12:08:20" , 
"departure_time" : "12:08:20" , 
"distance_traveled" : 7.8261
} ], 
"4499" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "12:02:00" , 
"departure_time" : "12:04:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "12:08:27" , 
"departure_time" : "12:08:27" , 
"distance_traveled" : 7.8261
} ], 
"4500" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "12:28:00" , 
"departure_time" : "12:29:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "12:33:32" , 
"departure_time" : "12:33:32" , 
"distance_traveled" : 7.8261
} ], 
"4501" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "12:28:00" , 
"departure_time" : "12:30:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "12:34:32" , 
"departure_time" : "12:34:32" , 
"distance_traveled" : 7.8261
} ], 
"4502" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "12:59:00" , 
"departure_time" : "13:01:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "13:04:31" , 
"departure_time" : "13:04:31" , 
"distance_traveled" : 7.8261
} ], 
"4503" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "12:59:00" , 
"departure_time" : "13:00:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "13:05:18" , 
"departure_time" : "13:05:18" , 
"distance_traveled" : 7.8261
} ], 
"4504" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "13:25:00" , 
"departure_time" : "13:27:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "13:31:18" , 
"departure_time" : "13:31:18" , 
"distance_traveled" : 7.8261
} ], 
"4505" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "13:25:00" , 
"departure_time" : "13:26:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "13:30:11" , 
"departure_time" : "13:30:11" , 
"distance_traveled" : 7.8261
} ], 
"4506" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "13:58:00" , 
"departure_time" : "13:58:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "14:03:30" , 
"departure_time" : "14:03:30" , 
"distance_traveled" : 7.8261
} ], 
"4507" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "13:58:00" , 
"departure_time" : "14:00:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "14:04:40" , 
"departure_time" : "14:04:40" , 
"distance_traveled" : 7.8261
} ], 
"4508" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "14:25:00" , 
"departure_time" : "14:26:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "14:30:10" , 
"departure_time" : "14:30:10" , 
"distance_traveled" : 7.8261
} ], 
"4509" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "14:25:00" , 
"departure_time" : "14:25:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "14:30:10" , 
"departure_time" : "14:30:10" , 
"distance_traveled" : 7.8261
} ], 
"4510" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "14:57:00" , 
"departure_time" : "14:57:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "15:02:37" , 
"departure_time" : "15:02:37" , 
"distance_traveled" : 7.8261
} ], 
"4511" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "14:57:00" , 
"departure_time" : "14:58:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "15:02:37" , 
"departure_time" : "15:02:37" , 
"distance_traveled" : 7.8261
} ], 
"4512" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "15:28:00" , 
"departure_time" : "15:29:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "15:34:10" , 
"departure_time" : "15:34:10" , 
"distance_traveled" : 7.8261
} ], 
"4513" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "15:28:00" , 
"departure_time" : "15:30:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "15:34:19" , 
"departure_time" : "15:34:19" , 
"distance_traveled" : 7.8261
} ], 
"4514" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "16:04:00" , 
"departure_time" : "16:05:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "16:09:14" , 
"departure_time" : "16:09:14" , 
"distance_traveled" : 7.8261
} ], 
"4515" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "16:04:00" , 
"departure_time" : "16:05:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "16:09:57" , 
"departure_time" : "16:09:57" , 
"distance_traveled" : 7.8261
} ], 
"4516" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "16:24:00" , 
"departure_time" : "16:26:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "16:30:19" , 
"departure_time" : "16:30:19" , 
"distance_traveled" : 7.8261
} ], 
"4517" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "16:24:00" , 
"departure_time" : "16:25:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "16:29:23" , 
"departure_time" : "16:29:23" , 
"distance_traveled" : 7.8261
} ], 
"4518" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "16:48:00" , 
"departure_time" : "16:48:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "16:53:01" , 
"departure_time" : "16:53:01" , 
"distance_traveled" : 7.8261
} ], 
"4519" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "16:48:00" , 
"departure_time" : "16:48:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "16:53:06" , 
"departure_time" : "16:53:06" , 
"distance_traveled" : 7.8261
} ], 
"4520" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "17:16:00" , 
"departure_time" : "17:16:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "17:21:11" , 
"departure_time" : "17:21:11" , 
"distance_traveled" : 7.8261
} ], 
"4521" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "17:16:00" , 
"departure_time" : "17:16:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "17:21:24" , 
"departure_time" : "17:21:24" , 
"distance_traveled" : 7.8261
} ], 
"4522" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "17:40:00" , 
"departure_time" : "17:41:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "17:46:15" , 
"departure_time" : "17:46:15" , 
"distance_traveled" : 7.8261
} ], 
"4523" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "17:40:00" , 
"departure_time" : "17:41:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "17:45:01" , 
"departure_time" : "17:45:01" , 
"distance_traveled" : 7.8261
} ], 
"4524" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "18:00:00" , 
"departure_time" : "18:01:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "18:06:06" , 
"departure_time" : "18:06:06" , 
"distance_traveled" : 7.8261
} ], 
"4525" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "18:00:00" , 
"departure_time" : "18:02:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "18:05:55" , 
"departure_time" : "18:05:55" , 
"distance_traveled" : 7.8261
} ], 
"4526" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "18:20:00" , 
"departure_time" : "18:21:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "18:25:46" , 
"departure_time" : "18:25:46" , 
"distance_traveled" : 7.8261
} ], 
"4527" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "18:20:00" , 
"departure_time" : "18:22:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "18:26:32" , 
"departure_time" : "18:26:32" , 
"distance_traveled" : 7.8261
} ], 
"4528" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "18:43:00" , 
"departure_time" : "18:46:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "18:49:29" , 
"departure_time" : "18:49:29" , 
"distance_traveled" : 7.8261
} ], 
"4529" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "18:43:00" , 
"departure_time" : "18:45:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "18:49:17" , 
"departure_time" : "18:49:17" , 
"distance_traveled" : 7.8261
} ], 
"4530" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "19:03:00" , 
"departure_time" : "19:05:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "19:09:36" , 
"departure_time" : "19:09:36" , 
"distance_traveled" : 7.8261
} ], 
"4531" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "19:03:00" , 
"departure_time" : "19:05:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "19:08:28" , 
"departure_time" : "19:08:28" , 
"distance_traveled" : 7.8261
} ], 
"4532" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "19:23:00" , 
"departure_time" : "19:23:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "19:28:21" , 
"departure_time" : "19:28:21" , 
"distance_traveled" : 7.8261
} ], 
"4533" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "19:23:00" , 
"departure_time" : "19:23:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "19:28:38" , 
"departure_time" : "19:28:38" , 
"distance_traveled" : 7.8261
} ], 
"4534" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "19:43:00" , 
"departure_time" : "19:44:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "19:48:48" , 
"departure_time" : "19:48:48" , 
"distance_traveled" : 7.8261
} ], 
"4535" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "19:43:00" , 
"departure_time" : "19:45:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "19:49:34" , 
"departure_time" : "19:49:34" , 
"distance_traveled" : 7.8261
} ], 
"4536" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "20:22:00" , 
"departure_time" : "20:23:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "20:27:10" , 
"departure_time" : "20:27:10" , 
"distance_traveled" : 7.8261
} ], 
"4537" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "20:22:00" , 
"departure_time" : "20:23:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "20:28:13" , 
"departure_time" : "20:28:13" , 
"distance_traveled" : 7.8261
} ], 
"4538" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "20:53:00" , 
"departure_time" : "20:55:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "20:59:22" , 
"departure_time" : "20:59:22" , 
"distance_traveled" : 7.8261
} ], 
"4539" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "20:53:00" , 
"departure_time" : "20:56:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "20:59:40" , 
"departure_time" : "20:59:40" , 
"distance_traveled" : 7.8261
} ], 
"4540" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "21:54:00" , 
"departure_time" : "21:57:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "22:00:39" , 
"departure_time" : "22:00:39" , 
"distance_traveled" : 7.8261
} ], 
"4541" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "21:54:00" , 
"departure_time" : "21:56:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "22:00:18" , 
"departure_time" : "22:00:18" , 
"distance_traveled" : 7.8261
} ], 
"4542" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "22:22:00" , 
"departure_time" : "22:23:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "22:27:14" , 
"departure_time" : "22:27:14" , 
"distance_traveled" : 7.8261
} ], 
"4543" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "22:22:00" , 
"departure_time" : "22:23:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "22:28:25" , 
"departure_time" : "22:28:25" , 
"distance_traveled" : 7.8261
} ], 
"4544" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "22:52:00" , 
"departure_time" : "22:54:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "22:58:33" , 
"departure_time" : "22:58:33" , 
"distance_traveled" : 7.8261
} ], 
"4545" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "22:52:00" , 
"departure_time" : "22:54:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "22:57:32" , 
"departure_time" : "22:57:32" , 
"distance_traveled" : 7.8261
} ], 
"4546" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "23:28:00" , 
"departure_time" : "23:28:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "23:33:08" , 
"departure_time" : "23:33:08" , 
"distance_traveled" : 7.8261
} ], 
"4547" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "23:28:00" , 
"departure_time" : "23:28:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "23:33:49" , 
"departure_time" : "23:33:49" , 
"distance_traveled" : 7.8261
} ], 
"4548" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "23:59:00" , 
"departure_time" : "24:00:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "24:04:43" , 
"departure_time" : "24:04:43" , 
"distance_traveled" : 7.8261
} ], 
"4549" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "23:59:00" , 
"departure_time" : "23:59:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "24:04:05" , 
"departure_time" : "24:04:05" , 
"distance_traveled" : 7.8261
} ], 
"4550" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "21:25:00" , 
"departure_time" : "21:25:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "21:35:26" , 
"departure_time" : "21:35:26" , 
"distance_traveled" : 7.8261
} ], 
"4551" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "09:34:00" , 
"departure_time" : "09:34:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "09:39:23" , 
"departure_time" : "09:39:23" , 
"distance_traveled" : 7.8261
} ], 
"4552" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "10:34:00" , 
"departure_time" : "10:36:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "10:40:39" , 
"departure_time" : "10:40:39" , 
"distance_traveled" : 7.8261
} ], 
"4553" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "11:34:00" , 
"departure_time" : "11:37:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "11:40:40" , 
"departure_time" : "11:40:40" , 
"distance_traveled" : 7.8261
} ], 
"4554" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "12:34:00" , 
"departure_time" : "12:36:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "12:39:56" , 
"departure_time" : "12:39:56" , 
"distance_traveled" : 7.8261
} ], 
"4555" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "13:35:00" , 
"departure_time" : "13:36:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "13:40:35" , 
"departure_time" : "13:40:35" , 
"distance_traveled" : 7.8261
} ], 
"4556" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "14:35:00" , 
"departure_time" : "14:36:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "14:41:12" , 
"departure_time" : "14:41:12" , 
"distance_traveled" : 7.8261
} ], 
"4557" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "15:11:00" , 
"departure_time" : "15:13:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "15:17:33" , 
"departure_time" : "15:17:33" , 
"distance_traveled" : 7.8261
} ], 
"4558" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "15:35:00" , 
"departure_time" : "15:36:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "15:40:23" , 
"departure_time" : "15:40:23" , 
"distance_traveled" : 7.8261
} ], 
"4559" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "18:35:00" , 
"departure_time" : "18:36:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "18:41:08" , 
"departure_time" : "18:41:08" , 
"distance_traveled" : 7.8261
} ], 
"4560" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "19:34:00" , 
"departure_time" : "19:35:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "19:39:22" , 
"departure_time" : "19:39:22" , 
"distance_traveled" : 7.8261
} ], 
"4561" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "22:35:00" , 
"departure_time" : "22:35:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "22:40:32" , 
"departure_time" : "22:40:32" , 
"distance_traveled" : 7.8261
} ], 
"4562" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "23:35:00" , 
"departure_time" : "23:37:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "23:41:35" , 
"departure_time" : "23:41:35" , 
"distance_traveled" : 7.8261
} ], 
"4563" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "24:07:00" , 
"departure_time" : "24:08:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "24:12:17" , 
"departure_time" : "24:12:17" , 
"distance_traveled" : 7.8261
} ], 
"4564" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "24:35:00" , 
"departure_time" : "24:35:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "24:40:35" , 
"departure_time" : "24:40:35" , 
"distance_traveled" : 7.8261
} ], 
"4565" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "25:35:00" , 
"departure_time" : "25:37:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "25:41:32" , 
"departure_time" : "25:41:32" , 
"distance_traveled" : 7.8261
} ], 
"4566" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "24:07:00" , 
"departure_time" : "24:09:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "24:12:49" , 
"departure_time" : "24:12:49" , 
"distance_traveled" : 7.8261
} ], 
"4567" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "24:35:00" , 
"departure_time" : "24:36:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "24:40:27" , 
"departure_time" : "24:40:27" , 
"distance_traveled" : 7.8261
} ], 
"4568" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "04:46:00" , 
"departure_time" : "04:47:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "04:51:43" , 
"departure_time" : "04:51:43" , 
"distance_traveled" : 7.8261
} ], 
"4569" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "05:29:00" , 
"departure_time" : "05:30:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "05:35:07" , 
"departure_time" : "05:35:07" , 
"distance_traveled" : 7.8261
} ], 
"4570" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "05:49:00" , 
"departure_time" : "05:50:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "05:54:51" , 
"departure_time" : "05:54:51" , 
"distance_traveled" : 7.8261
} ], 
"4571" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "06:31:00" , 
"departure_time" : "06:32:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "06:36:36" , 
"departure_time" : "06:36:36" , 
"distance_traveled" : 7.8261
} ], 
"4572" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "07:10:00" , 
"departure_time" : "07:11:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "07:15:50" , 
"departure_time" : "07:15:50" , 
"distance_traveled" : 7.8261
} ], 
"4573" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "07:33:00" , 
"departure_time" : "07:35:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "07:39:19" , 
"departure_time" : "07:39:19" , 
"distance_traveled" : 7.8261
} ], 
"4574" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "08:09:00" , 
"departure_time" : "08:11:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "08:15:01" , 
"departure_time" : "08:15:01" , 
"distance_traveled" : 7.8261
} ], 
"4575" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "08:34:00" , 
"departure_time" : "08:35:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "08:39:08" , 
"departure_time" : "08:39:08" , 
"distance_traveled" : 7.8261
} ], 
"4576" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "09:05:00" , 
"departure_time" : "09:05:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "09:10:04" , 
"departure_time" : "09:10:04" , 
"distance_traveled" : 7.8261
} ], 
"4577" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "09:34:00" , 
"departure_time" : "09:34:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "09:39:53" , 
"departure_time" : "09:39:53" , 
"distance_traveled" : 7.8261
} ], 
"4578" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "10:12:00" , 
"departure_time" : "10:13:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "10:17:23" , 
"departure_time" : "10:17:23" , 
"distance_traveled" : 7.8261
} ], 
"4579" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "10:34:00" , 
"departure_time" : "10:36:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "10:40:37" , 
"departure_time" : "10:40:37" , 
"distance_traveled" : 7.8261
} ], 
"4580" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "11:09:00" , 
"departure_time" : "11:12:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "11:15:25" , 
"departure_time" : "11:15:25" , 
"distance_traveled" : 7.8261
} ], 
"4581" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "11:34:00" , 
"departure_time" : "11:36:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "11:40:02" , 
"departure_time" : "11:40:02" , 
"distance_traveled" : 7.8261
} ], 
"4582" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "12:10:00" , 
"departure_time" : "12:12:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "12:16:20" , 
"departure_time" : "12:16:20" , 
"distance_traveled" : 7.8261
} ], 
"4583" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "12:34:00" , 
"departure_time" : "12:36:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "12:39:42" , 
"departure_time" : "12:39:42" , 
"distance_traveled" : 7.8261
} ], 
"4584" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "13:09:00" , 
"departure_time" : "13:10:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "13:15:00" , 
"departure_time" : "13:15:00" , 
"distance_traveled" : 7.8261
} ], 
"4585" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "13:35:00" , 
"departure_time" : "13:36:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "13:40:19" , 
"departure_time" : "13:40:19" , 
"distance_traveled" : 7.8261
} ], 
"4586" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "14:35:00" , 
"departure_time" : "14:35:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "14:40:01" , 
"departure_time" : "14:40:01" , 
"distance_traveled" : 7.8261
} ], 
"4587" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "15:11:00" , 
"departure_time" : "15:11:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "15:16:02" , 
"departure_time" : "15:16:02" , 
"distance_traveled" : 7.8261
} ], 
"4588" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "15:35:00" , 
"departure_time" : "15:36:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "15:41:05" , 
"departure_time" : "15:41:05" , 
"distance_traveled" : 7.8261
} ], 
"4589" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "16:10:00" , 
"departure_time" : "16:12:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "16:16:06" , 
"departure_time" : "16:16:06" , 
"distance_traveled" : 7.8261
} ], 
"4590" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "17:11:00" , 
"departure_time" : "17:13:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "17:16:57" , 
"departure_time" : "17:16:57" , 
"distance_traveled" : 7.8261
} ], 
"4591" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "17:34:00" , 
"departure_time" : "17:35:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "17:39:24" , 
"departure_time" : "17:39:24" , 
"distance_traveled" : 7.8261
} ], 
"4592" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "18:07:00" , 
"departure_time" : "18:09:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "18:13:36" , 
"departure_time" : "18:13:36" , 
"distance_traveled" : 7.8261
} ], 
"4593" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "18:35:00" , 
"departure_time" : "18:37:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "18:41:02" , 
"departure_time" : "18:41:02" , 
"distance_traveled" : 7.8261
} ], 
"4594" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "19:07:00" , 
"departure_time" : "19:09:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "19:13:32" , 
"departure_time" : "19:13:32" , 
"distance_traveled" : 7.8261
} ], 
"4595" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "19:34:00" , 
"departure_time" : "19:36:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "19:40:10" , 
"departure_time" : "19:40:10" , 
"distance_traveled" : 7.8261
} ], 
"4596" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "20:14:00" , 
"departure_time" : "20:16:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "20:20:39" , 
"departure_time" : "20:20:39" , 
"distance_traveled" : 7.8261
} ], 
"4597" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "20:34:00" , 
"departure_time" : "20:36:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "20:39:32" , 
"departure_time" : "20:39:32" , 
"distance_traveled" : 7.8261
} ], 
"4598" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "21:16:00" , 
"departure_time" : "21:17:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "21:21:36" , 
"departure_time" : "21:21:36" , 
"distance_traveled" : 7.8261
} ], 
"4599" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "21:36:00" , 
"departure_time" : "21:37:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "21:42:02" , 
"departure_time" : "21:42:02" , 
"distance_traveled" : 7.8261
} ], 
"4600" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "22:08:00" , 
"departure_time" : "22:09:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "22:13:50" , 
"departure_time" : "22:13:50" , 
"distance_traveled" : 7.8261
} ], 
"4601" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "22:35:00" , 
"departure_time" : "22:37:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "22:41:23" , 
"departure_time" : "22:41:23" , 
"distance_traveled" : 7.8261
} ], 
"4602" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "23:06:00" , 
"departure_time" : "23:08:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "23:12:28" , 
"departure_time" : "23:12:28" , 
"distance_traveled" : 7.8261
} ], 
"4603" :  [ 
{ 
"stop_id" : 125,
"arrival_time" : "23:35:00" , 
"departure_time" : "23:36:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 124,
"arrival_time" : "23:40:05" , 
"departure_time" : "23:40:05" , 
"distance_traveled" : 7.8261
} ], 
"4604" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "06:41:00" , 
"departure_time" : "06:42:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "06:45:08" , 
"departure_time" : "06:45:45" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "06:48:37" , 
"departure_time" : "06:50:12" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "06:51:35" , 
"departure_time" : "06:52:29" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "06:56:54" , 
"departure_time" : "06:57:59" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "07:02:05" , 
"departure_time" : "07:03:39" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "07:07:34" , 
"departure_time" : "07:08:34" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "07:10:00" , 
"departure_time" : "07:10:53" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "07:14:53" , 
"departure_time" : "07:15:49" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 32,
"arrival_time" : "07:18:56" , 
"departure_time" : "07:19:56" , 
"distance_traveled" : 21.9134
}, 
{ 
"stop_id" : 31,
"arrival_time" : "07:24:00" , 
"departure_time" : "07:24:14" , 
"distance_traveled" : 24.0633
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "07:27:14" , 
"departure_time" : "07:27:50" , 
"distance_traveled" : 25.9152
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:39:36" , 
"departure_time" : "07:39:36" , 
"distance_traveled" : 31.1723
} ], 
"4605" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "06:14:00" , 
"departure_time" : "06:15:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "06:18:09" , 
"departure_time" : "06:18:33" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "06:21:24" , 
"departure_time" : "06:22:11" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "06:24:47" , 
"departure_time" : "06:25:38" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "06:30:51" , 
"departure_time" : "06:31:41" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "06:35:50" , 
"departure_time" : "06:37:03" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "06:39:13" , 
"departure_time" : "06:39:26" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "06:42:13" , 
"departure_time" : "06:42:19" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "06:47:06" , 
"departure_time" : "06:48:07" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "06:51:01" , 
"departure_time" : "06:51:50" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "06:54:49" , 
"departure_time" : "06:55:52" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "07:00:03" , 
"departure_time" : "07:01:14" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "07:04:11" , 
"departure_time" : "07:04:24" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:15:13" , 
"departure_time" : "07:15:13" , 
"distance_traveled" : 28.9392
} ], 
"4606" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "06:41:00" , 
"departure_time" : "06:41:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "06:44:29" , 
"departure_time" : "06:45:35" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "06:49:06" , 
"departure_time" : "06:50:17" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "06:51:11" , 
"departure_time" : "06:52:12" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "06:57:01" , 
"departure_time" : "06:57:21" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "07:01:20" , 
"departure_time" : "07:01:54" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "07:06:34" , 
"departure_time" : "07:07:47" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "07:10:13" , 
"departure_time" : "07:11:11" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "07:14:58" , 
"departure_time" : "07:15:02" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 32,
"arrival_time" : "07:18:04" , 
"departure_time" : "07:19:40" , 
"distance_traveled" : 21.9134
}, 
{ 
"stop_id" : 31,
"arrival_time" : "07:24:36" , 
"departure_time" : "07:25:12" , 
"distance_traveled" : 24.0633
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "07:27:36" , 
"departure_time" : "07:28:40" , 
"distance_traveled" : 25.9152
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:40:04" , 
"departure_time" : "07:40:04" , 
"distance_traveled" : 31.1723
} ], 
"4607" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "07:14:00" , 
"departure_time" : "07:15:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "07:17:53" , 
"departure_time" : "07:19:29" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "07:22:36" , 
"departure_time" : "07:22:46" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "07:24:10" , 
"departure_time" : "07:24:40" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "07:30:30" , 
"departure_time" : "07:31:10" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "07:35:40" , 
"departure_time" : "07:35:56" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "07:38:16" , 
"departure_time" : "07:39:15" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "07:42:59" , 
"departure_time" : "07:43:45" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "07:47:46" , 
"departure_time" : "07:49:03" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "07:51:17" , 
"departure_time" : "07:51:31" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "07:54:14" , 
"departure_time" : "07:55:34" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "08:00:20" , 
"departure_time" : "08:00:58" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "08:03:38" , 
"departure_time" : "08:05:13" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:16:35" , 
"departure_time" : "08:16:35" , 
"distance_traveled" : 28.9392
} ], 
"4608" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "23:36:00" , 
"departure_time" : "23:37:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "23:39:03" , 
"departure_time" : "23:39:10" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "23:43:07" , 
"departure_time" : "23:43:21" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "23:46:14" , 
"departure_time" : "23:46:50" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "23:52:36" , 
"departure_time" : "23:53:57" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "23:58:21" , 
"departure_time" : "23:59:05" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "24:00:44" , 
"departure_time" : "24:02:01" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "24:04:17" , 
"departure_time" : "24:05:29" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "24:09:12" , 
"departure_time" : "24:10:26" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "24:12:14" , 
"departure_time" : "24:13:20" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "24:15:06" , 
"departure_time" : "24:15:20" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "24:20:14" , 
"departure_time" : "24:21:34" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "24:25:20" , 
"departure_time" : "24:25:42" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "24:38:22" , 
"departure_time" : "24:38:22" , 
"distance_traveled" : 28.9392
} ], 
"4609" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "08:14:00" , 
"departure_time" : "08:14:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "08:17:26" , 
"departure_time" : "08:18:26" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "08:22:00" , 
"departure_time" : "08:22:49" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "08:24:49" , 
"departure_time" : "08:25:17" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "08:30:28" , 
"departure_time" : "08:30:36" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "08:35:08" , 
"departure_time" : "08:35:54" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "08:38:46" , 
"departure_time" : "08:38:49" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "08:42:03" , 
"departure_time" : "08:42:38" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "08:47:35" , 
"departure_time" : "08:48:23" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "08:50:48" , 
"departure_time" : "08:52:15" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "08:55:27" , 
"departure_time" : "08:56:17" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "08:59:50" , 
"departure_time" : "08:59:54" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "09:03:04" , 
"departure_time" : "09:04:33" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:16:29" , 
"departure_time" : "09:16:29" , 
"distance_traveled" : 28.9392
} ], 
"4610" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "06:14:00" , 
"departure_time" : "06:15:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "06:17:12" , 
"departure_time" : "06:18:04" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "06:21:52" , 
"departure_time" : "06:22:53" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "06:25:01" , 
"departure_time" : "06:25:26" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "06:30:25" , 
"departure_time" : "06:30:44" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "06:35:19" , 
"departure_time" : "06:35:36" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "06:38:17" , 
"departure_time" : "06:39:13" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "06:42:56" , 
"departure_time" : "06:43:59" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "06:48:03" , 
"departure_time" : "06:49:37" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "06:51:34" , 
"departure_time" : "06:52:59" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "06:55:25" , 
"departure_time" : "06:55:37" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "06:59:12" , 
"departure_time" : "06:59:32" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "07:03:20" , 
"departure_time" : "07:04:21" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:16:01" , 
"departure_time" : "07:16:01" , 
"distance_traveled" : 28.9392
} ], 
"4611" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "09:14:00" , 
"departure_time" : "09:15:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "09:17:37" , 
"departure_time" : "09:18:18" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "09:21:41" , 
"departure_time" : "09:22:25" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "09:24:44" , 
"departure_time" : "09:26:16" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "09:31:32" , 
"departure_time" : "09:31:39" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "09:35:07" , 
"departure_time" : "09:36:04" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "09:38:57" , 
"departure_time" : "09:39:58" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "09:43:01" , 
"departure_time" : "09:44:24" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "09:48:23" , 
"departure_time" : "09:49:15" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "09:50:52" , 
"departure_time" : "09:52:03" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "09:55:11" , 
"departure_time" : "09:55:47" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "09:59:36" , 
"departure_time" : "09:59:57" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "10:03:21" , 
"departure_time" : "10:03:57" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:15:36" , 
"departure_time" : "10:15:36" , 
"distance_traveled" : 28.9392
} ], 
"4612" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "07:14:00" , 
"departure_time" : "07:15:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "07:17:59" , 
"departure_time" : "07:18:59" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "07:22:00" , 
"departure_time" : "07:23:01" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "07:25:01" , 
"departure_time" : "07:25:16" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "07:30:15" , 
"departure_time" : "07:30:46" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "07:35:31" , 
"departure_time" : "07:36:00" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "07:38:29" , 
"departure_time" : "07:40:02" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "07:43:33" , 
"departure_time" : "07:44:10" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "07:47:37" , 
"departure_time" : "07:48:39" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "07:51:02" , 
"departure_time" : "07:52:30" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "07:55:28" , 
"departure_time" : "07:56:35" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "08:00:07" , 
"departure_time" : "08:01:02" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "08:03:55" , 
"departure_time" : "08:04:41" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:15:46" , 
"departure_time" : "08:15:46" , 
"distance_traveled" : 28.9392
} ], 
"4613" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "10:14:00" , 
"departure_time" : "10:15:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "10:17:36" , 
"departure_time" : "10:18:03" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "10:21:27" , 
"departure_time" : "10:22:08" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "10:24:41" , 
"departure_time" : "10:25:29" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "10:30:48" , 
"departure_time" : "10:32:03" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "10:36:15" , 
"departure_time" : "10:36:36" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "10:38:21" , 
"departure_time" : "10:39:00" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "10:42:39" , 
"departure_time" : "10:43:32" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "10:47:53" , 
"departure_time" : "10:48:47" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "10:50:54" , 
"departure_time" : "10:52:03" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "10:55:09" , 
"departure_time" : "10:56:08" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "10:59:59" , 
"departure_time" : "11:00:02" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "11:03:03" , 
"departure_time" : "11:03:27" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:15:24" , 
"departure_time" : "11:15:24" , 
"distance_traveled" : 28.9392
} ], 
"4614" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "08:14:00" , 
"departure_time" : "08:15:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "08:17:56" , 
"departure_time" : "08:19:12" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "08:22:16" , 
"departure_time" : "08:22:55" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "08:24:39" , 
"departure_time" : "08:25:54" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "08:31:15" , 
"departure_time" : "08:32:27" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "08:36:12" , 
"departure_time" : "08:37:35" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "08:39:23" , 
"departure_time" : "08:40:11" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "08:42:48" , 
"departure_time" : "08:43:01" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "08:47:13" , 
"departure_time" : "08:47:49" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "08:50:36" , 
"departure_time" : "08:51:31" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "08:54:55" , 
"departure_time" : "08:56:17" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "09:00:22" , 
"departure_time" : "09:00:32" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "09:03:10" , 
"departure_time" : "09:04:38" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:16:28" , 
"departure_time" : "09:16:28" , 
"distance_traveled" : 28.9392
} ], 
"4615" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "11:14:00" , 
"departure_time" : "11:15:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "11:17:15" , 
"departure_time" : "11:18:39" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "11:22:24" , 
"departure_time" : "11:23:42" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "11:25:18" , 
"departure_time" : "11:25:31" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "11:30:13" , 
"departure_time" : "11:31:05" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "11:35:52" , 
"departure_time" : "11:36:26" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "11:38:34" , 
"departure_time" : "11:38:49" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "11:42:15" , 
"departure_time" : "11:43:10" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "11:47:55" , 
"departure_time" : "11:49:35" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "11:51:40" , 
"departure_time" : "11:53:12" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "11:55:32" , 
"departure_time" : "11:57:03" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "12:00:31" , 
"departure_time" : "12:02:08" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "12:04:37" , 
"departure_time" : "12:05:18" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:15:41" , 
"departure_time" : "12:15:41" , 
"distance_traveled" : 28.9392
} ], 
"4616" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "09:14:00" , 
"departure_time" : "09:15:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "09:17:48" , 
"departure_time" : "09:17:50" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "09:21:02" , 
"departure_time" : "09:21:56" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "09:24:54" , 
"departure_time" : "09:26:17" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "09:31:23" , 
"departure_time" : "09:32:50" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "09:36:27" , 
"departure_time" : "09:36:48" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "09:38:21" , 
"departure_time" : "09:39:47" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "09:43:26" , 
"departure_time" : "09:44:32" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "09:48:06" , 
"departure_time" : "09:49:30" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "09:51:24" , 
"departure_time" : "09:51:55" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "09:54:31" , 
"departure_time" : "09:55:48" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "10:00:17" , 
"departure_time" : "10:00:59" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "10:03:42" , 
"departure_time" : "10:04:38" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:15:56" , 
"departure_time" : "10:15:56" , 
"distance_traveled" : 28.9392
} ], 
"4617" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "12:14:00" , 
"departure_time" : "12:15:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "12:17:51" , 
"departure_time" : "12:18:27" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "12:21:36" , 
"departure_time" : "12:22:01" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "12:24:25" , 
"departure_time" : "12:26:03" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "12:31:38" , 
"departure_time" : "12:32:43" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "12:36:05" , 
"departure_time" : "12:36:09" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "12:38:04" , 
"departure_time" : "12:39:40" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "12:43:36" , 
"departure_time" : "12:44:37" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "12:48:01" , 
"departure_time" : "12:49:39" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "12:51:38" , 
"departure_time" : "12:52:47" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "12:55:09" , 
"departure_time" : "12:56:03" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "12:59:54" , 
"departure_time" : "13:00:34" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "13:03:40" , 
"departure_time" : "13:04:16" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:15:36" , 
"departure_time" : "13:15:36" , 
"distance_traveled" : 28.9392
} ], 
"4618" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "10:14:00" , 
"departure_time" : "10:15:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "10:18:15" , 
"departure_time" : "10:19:00" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "10:21:45" , 
"departure_time" : "10:23:22" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "10:25:37" , 
"departure_time" : "10:26:30" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "10:30:53" , 
"departure_time" : "10:32:23" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "10:36:30" , 
"departure_time" : "10:36:42" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "10:38:12" , 
"departure_time" : "10:39:35" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "10:43:23" , 
"departure_time" : "10:44:50" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "10:48:27" , 
"departure_time" : "10:50:07" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "10:51:40" , 
"departure_time" : "10:51:57" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "10:54:17" , 
"departure_time" : "10:54:49" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "10:59:32" , 
"departure_time" : "10:59:46" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "11:03:14" , 
"departure_time" : "11:03:46" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:15:32" , 
"departure_time" : "11:15:32" , 
"distance_traveled" : 28.9392
} ], 
"4619" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "13:14:00" , 
"departure_time" : "13:15:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "13:18:01" , 
"departure_time" : "13:18:16" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "13:21:15" , 
"departure_time" : "13:22:52" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "13:25:37" , 
"departure_time" : "13:25:47" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "13:30:10" , 
"departure_time" : "13:30:46" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "13:35:36" , 
"departure_time" : "13:36:00" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "13:38:24" , 
"departure_time" : "13:39:43" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "13:43:19" , 
"departure_time" : "13:43:57" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "13:47:38" , 
"departure_time" : "13:49:18" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "13:51:40" , 
"departure_time" : "13:53:18" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "13:55:38" , 
"departure_time" : "13:56:00" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "13:59:22" , 
"departure_time" : "13:59:30" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "14:03:08" , 
"departure_time" : "14:03:23" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:15:15" , 
"departure_time" : "14:15:15" , 
"distance_traveled" : 28.9392
} ], 
"4620" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "11:14:00" , 
"departure_time" : "11:15:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "11:17:45" , 
"departure_time" : "11:18:33" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "11:21:48" , 
"departure_time" : "11:23:13" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "11:25:25" , 
"departure_time" : "11:25:30" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "11:30:05" , 
"departure_time" : "11:31:00" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "11:35:55" , 
"departure_time" : "11:37:09" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "11:39:14" , 
"departure_time" : "11:40:53" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "11:43:39" , 
"departure_time" : "11:44:36" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "11:47:57" , 
"departure_time" : "11:49:28" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "11:51:31" , 
"departure_time" : "11:52:58" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "11:55:27" , 
"departure_time" : "11:55:56" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "11:59:29" , 
"departure_time" : "12:00:18" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "12:03:49" , 
"departure_time" : "12:05:22" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:16:33" , 
"departure_time" : "12:16:33" , 
"distance_traveled" : 28.9392
} ], 
"4621" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "14:14:00" , 
"departure_time" : "14:17:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "14:18:27" , 
"departure_time" : "14:19:02" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "14:21:35" , 
"departure_time" : "14:21:52" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "14:24:17" , 
"departure_time" : "14:24:25" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "14:30:08" , 
"departure_time" : "14:31:33" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "14:36:25" , 
"departure_time" : "14:38:01" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "14:39:36" , 
"departure_time" : "14:40:30" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "14:42:54" , 
"departure_time" : "14:44:17" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "14:48:23" , 
"departure_time" : "14:49:42" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "14:51:19" , 
"departure_time" : "14:51:53" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "14:54:34" , 
"departure_time" : "14:54:48" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "14:59:14" , 
"departure_time" : "15:00:53" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "15:04:39" , 
"departure_time" : "15:05:45" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:16:06" , 
"departure_time" : "15:16:06" , 
"distance_traveled" : 28.9392
} ], 
"4622" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "12:14:00" , 
"departure_time" : "12:16:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "12:18:14" , 
"departure_time" : "12:19:43" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "12:22:29" , 
"departure_time" : "12:23:53" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "12:25:24" , 
"departure_time" : "12:25:59" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "12:30:35" , 
"departure_time" : "12:31:13" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "12:35:38" , 
"departure_time" : "12:36:56" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "12:39:18" , 
"departure_time" : "12:40:21" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "12:43:03" , 
"departure_time" : "12:43:16" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "12:47:13" , 
"departure_time" : "12:48:41" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "12:51:28" , 
"departure_time" : "12:52:34" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "12:55:06" , 
"departure_time" : "12:55:22" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "12:59:16" , 
"departure_time" : "13:00:13" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "13:03:57" , 
"departure_time" : "13:04:30" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:15:33" , 
"departure_time" : "13:15:33" , 
"distance_traveled" : 28.9392
} ], 
"4623" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "15:14:00" , 
"departure_time" : "15:15:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "15:18:22" , 
"departure_time" : "15:19:00" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "15:21:38" , 
"departure_time" : "15:21:43" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "15:24:05" , 
"departure_time" : "15:25:45" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "15:31:40" , 
"departure_time" : "15:32:50" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "15:36:10" , 
"departure_time" : "15:37:17" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "15:39:07" , 
"departure_time" : "15:40:24" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "15:43:17" , 
"departure_time" : "15:43:37" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "15:47:20" , 
"departure_time" : "15:48:19" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "15:50:59" , 
"departure_time" : "15:51:53" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "15:54:54" , 
"departure_time" : "15:55:55" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "16:00:01" , 
"departure_time" : "16:01:06" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "16:04:05" , 
"departure_time" : "16:05:20" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:16:15" , 
"departure_time" : "16:16:15" , 
"distance_traveled" : 28.9392
} ], 
"4624" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "13:14:00" , 
"departure_time" : "13:15:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "13:17:31" , 
"departure_time" : "13:18:39" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "13:22:08" , 
"departure_time" : "13:23:25" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "13:25:17" , 
"departure_time" : "13:26:48" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "13:31:31" , 
"departure_time" : "13:32:56" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "13:36:25" , 
"departure_time" : "13:37:36" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "13:39:11" , 
"departure_time" : "13:39:39" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "13:42:28" , 
"departure_time" : "13:42:32" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "13:47:04" , 
"departure_time" : "13:48:20" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "13:51:16" , 
"departure_time" : "13:52:40" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "13:55:24" , 
"departure_time" : "13:56:54" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "14:00:30" , 
"departure_time" : "14:00:52" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "14:03:22" , 
"departure_time" : "14:04:45" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:16:23" , 
"departure_time" : "14:16:23" , 
"distance_traveled" : 28.9392
} ], 
"4625" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "16:14:00" , 
"departure_time" : "16:16:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "16:17:41" , 
"departure_time" : "16:18:20" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "16:21:39" , 
"departure_time" : "16:22:11" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "16:24:32" , 
"departure_time" : "16:25:32" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "16:31:00" , 
"departure_time" : "16:31:53" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "16:35:53" , 
"departure_time" : "16:37:30" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "16:39:37" , 
"departure_time" : "16:40:43" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "16:43:06" , 
"departure_time" : "16:44:14" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "16:48:08" , 
"departure_time" : "16:48:49" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "16:50:41" , 
"departure_time" : "16:51:22" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "16:54:41" , 
"departure_time" : "16:55:41" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "17:00:00" , 
"departure_time" : "17:01:11" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "17:04:11" , 
"departure_time" : "17:04:49" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:15:38" , 
"departure_time" : "17:15:38" , 
"distance_traveled" : 28.9392
} ], 
"4626" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "14:14:00" , 
"departure_time" : "14:15:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "14:18:17" , 
"departure_time" : "14:18:42" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "14:21:25" , 
"departure_time" : "14:22:25" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "14:25:00" , 
"departure_time" : "14:25:35" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "14:30:35" , 
"departure_time" : "14:31:12" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "14:35:37" , 
"departure_time" : "14:36:56" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "14:39:19" , 
"departure_time" : "14:40:39" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "14:43:20" , 
"departure_time" : "14:44:59" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "14:48:39" , 
"departure_time" : "14:50:04" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "14:51:25" , 
"departure_time" : "14:52:38" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "14:55:13" , 
"departure_time" : "14:55:28" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "14:59:15" , 
"departure_time" : "15:00:01" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "15:03:46" , 
"departure_time" : "15:04:50" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:16:04" , 
"departure_time" : "15:16:04" , 
"distance_traveled" : 28.9392
} ], 
"4627" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "17:14:00" , 
"departure_time" : "17:16:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "17:18:37" , 
"departure_time" : "17:20:10" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "17:22:33" , 
"departure_time" : "17:22:37" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "17:24:04" , 
"departure_time" : "17:25:30" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "17:31:26" , 
"departure_time" : "17:32:32" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "17:36:06" , 
"departure_time" : "17:37:45" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "17:39:39" , 
"departure_time" : "17:41:00" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "17:43:21" , 
"departure_time" : "17:44:03" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "17:47:42" , 
"departure_time" : "17:47:49" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "17:50:07" , 
"departure_time" : "17:51:31" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "17:55:24" , 
"departure_time" : "17:56:20" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "17:59:56" , 
"departure_time" : "18:00:10" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "18:03:14" , 
"departure_time" : "18:04:30" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:16:16" , 
"departure_time" : "18:16:16" , 
"distance_traveled" : 28.9392
} ], 
"4628" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "15:14:00" , 
"departure_time" : "15:15:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "15:17:39" , 
"departure_time" : "15:18:56" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "15:22:17" , 
"departure_time" : "15:22:34" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "15:24:17" , 
"departure_time" : "15:25:27" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "15:31:10" , 
"departure_time" : "15:32:40" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "15:36:30" , 
"departure_time" : "15:37:53" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "15:39:23" , 
"departure_time" : "15:40:50" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "15:43:27" , 
"departure_time" : "15:43:58" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "15:47:31" , 
"departure_time" : "15:48:11" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "15:50:40" , 
"departure_time" : "15:52:07" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "15:55:27" , 
"departure_time" : "15:56:23" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "15:59:56" , 
"departure_time" : "16:00:13" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "16:03:17" , 
"departure_time" : "16:04:57" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:16:40" , 
"departure_time" : "16:16:40" , 
"distance_traveled" : 28.9392
} ], 
"4629" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "18:14:00" , 
"departure_time" : "18:16:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "18:18:16" , 
"departure_time" : "18:18:36" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "18:21:20" , 
"departure_time" : "18:22:46" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "18:25:26" , 
"departure_time" : "18:26:16" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "18:30:50" , 
"departure_time" : "18:32:22" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "18:36:32" , 
"departure_time" : "18:36:34" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "18:38:02" , 
"departure_time" : "18:38:26" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "18:42:24" , 
"departure_time" : "18:43:36" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "18:48:12" , 
"departure_time" : "18:48:44" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "18:50:32" , 
"departure_time" : "18:51:46" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "18:55:14" , 
"departure_time" : "18:56:23" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "19:00:09" , 
"departure_time" : "19:01:38" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "19:04:29" , 
"departure_time" : "19:05:00" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:15:31" , 
"departure_time" : "19:15:31" , 
"distance_traveled" : 28.9392
} ], 
"4630" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "16:14:00" , 
"departure_time" : "16:15:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "16:17:47" , 
"departure_time" : "16:19:05" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "16:22:18" , 
"departure_time" : "16:23:08" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "16:24:50" , 
"departure_time" : "16:26:29" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "16:31:39" , 
"departure_time" : "16:32:01" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "16:35:22" , 
"departure_time" : "16:36:39" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "16:39:17" , 
"departure_time" : "16:39:40" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "16:42:23" , 
"departure_time" : "16:43:29" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "16:48:06" , 
"departure_time" : "16:49:20" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "16:51:14" , 
"departure_time" : "16:52:03" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "16:54:49" , 
"departure_time" : "16:56:03" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "17:00:14" , 
"departure_time" : "17:01:35" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "17:04:21" , 
"departure_time" : "17:05:08" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:15:47" , 
"departure_time" : "17:15:47" , 
"distance_traveled" : 28.9392
} ], 
"4631" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "19:14:00" , 
"departure_time" : "19:15:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "19:17:45" , 
"departure_time" : "19:19:13" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "19:22:28" , 
"departure_time" : "19:23:57" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "19:25:29" , 
"departure_time" : "19:26:22" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "19:30:53" , 
"departure_time" : "19:32:12" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "19:36:19" , 
"departure_time" : "19:36:53" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "19:38:34" , 
"departure_time" : "19:40:08" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "19:43:34" , 
"departure_time" : "19:44:08" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "19:47:34" , 
"departure_time" : "19:48:24" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "19:50:50" , 
"departure_time" : "19:52:13" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "19:55:23" , 
"departure_time" : "19:56:36" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "20:00:13" , 
"departure_time" : "20:01:20" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "20:04:07" , 
"departure_time" : "20:04:21" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:15:14" , 
"departure_time" : "20:15:14" , 
"distance_traveled" : 28.9392
} ], 
"4632" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "17:14:00" , 
"departure_time" : "17:14:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "17:17:26" , 
"departure_time" : "17:18:25" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "17:21:59" , 
"departure_time" : "17:23:31" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "17:25:32" , 
"departure_time" : "17:26:25" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "17:30:53" , 
"departure_time" : "17:31:34" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "17:35:41" , 
"departure_time" : "17:36:19" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "17:38:38" , 
"departure_time" : "17:38:58" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "17:42:20" , 
"departure_time" : "17:42:31" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "17:47:11" , 
"departure_time" : "17:48:46" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "17:51:35" , 
"departure_time" : "17:53:01" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "17:55:26" , 
"departure_time" : "17:56:45" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "18:00:19" , 
"departure_time" : "18:01:28" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "18:04:09" , 
"departure_time" : "18:04:59" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:15:50" , 
"departure_time" : "18:15:50" , 
"distance_traveled" : 28.9392
} ], 
"4633" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "20:14:00" , 
"departure_time" : "20:16:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "20:18:37" , 
"departure_time" : "20:20:05" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "20:22:28" , 
"departure_time" : "20:22:57" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "20:24:29" , 
"departure_time" : "20:25:16" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "20:30:47" , 
"departure_time" : "20:32:05" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "20:36:18" , 
"departure_time" : "20:36:26" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "20:38:08" , 
"departure_time" : "20:38:17" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "20:42:09" , 
"departure_time" : "20:42:59" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "20:47:50" , 
"departure_time" : "20:48:30" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "20:50:40" , 
"departure_time" : "20:51:12" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "20:54:32" , 
"departure_time" : "20:55:08" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "20:59:36" , 
"departure_time" : "20:59:51" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "21:03:15" , 
"departure_time" : "21:04:15" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:16:00" , 
"departure_time" : "21:16:00" , 
"distance_traveled" : 28.9392
} ], 
"4634" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "18:14:00" , 
"departure_time" : "18:15:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "18:17:41" , 
"departure_time" : "18:19:08" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "18:22:27" , 
"departure_time" : "18:22:56" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "18:24:29" , 
"departure_time" : "18:24:55" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "18:30:26" , 
"departure_time" : "18:31:33" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "18:36:07" , 
"departure_time" : "18:37:00" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "18:38:53" , 
"departure_time" : "18:40:26" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "18:43:33" , 
"departure_time" : "18:44:25" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "18:47:52" , 
"departure_time" : "18:49:26" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "18:51:34" , 
"departure_time" : "18:51:59" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "18:54:25" , 
"departure_time" : "18:55:25" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "19:00:00" , 
"departure_time" : "19:00:25" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "19:03:25" , 
"departure_time" : "19:04:13" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:15:48" , 
"departure_time" : "19:15:48" , 
"distance_traveled" : 28.9392
} ], 
"4635" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "21:14:00" , 
"departure_time" : "21:15:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "21:17:30" , 
"departure_time" : "21:18:19" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "21:21:49" , 
"departure_time" : "21:22:18" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "21:24:29" , 
"departure_time" : "21:25:58" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "21:31:29" , 
"departure_time" : "21:32:29" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "21:36:00" , 
"departure_time" : "21:36:33" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "21:38:33" , 
"departure_time" : "21:39:56" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "21:43:23" , 
"departure_time" : "21:44:22" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "21:47:59" , 
"departure_time" : "21:49:17" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "21:51:18" , 
"departure_time" : "21:52:39" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "21:55:21" , 
"departure_time" : "21:55:31" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "21:59:10" , 
"departure_time" : "21:59:35" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "22:03:25" , 
"departure_time" : "22:04:38" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:16:13" , 
"departure_time" : "22:16:13" , 
"distance_traveled" : 28.9392
} ], 
"4636" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "19:14:00" , 
"departure_time" : "19:16:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "19:18:33" , 
"departure_time" : "19:19:41" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "19:22:08" , 
"departure_time" : "19:23:30" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "19:25:22" , 
"departure_time" : "19:25:47" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "19:30:25" , 
"departure_time" : "19:31:44" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "19:36:19" , 
"departure_time" : "19:36:29" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "19:38:10" , 
"departure_time" : "19:38:34" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "19:42:24" , 
"departure_time" : "19:43:41" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "19:48:17" , 
"departure_time" : "19:49:45" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "19:51:28" , 
"departure_time" : "19:52:51" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "19:55:23" , 
"departure_time" : "19:55:53" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "19:59:30" , 
"departure_time" : "20:00:58" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "20:04:28" , 
"departure_time" : "20:04:59" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:15:31" , 
"departure_time" : "20:15:31" , 
"distance_traveled" : 28.9392
} ], 
"4637" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "22:14:00" , 
"departure_time" : "22:15:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "22:18:27" , 
"departure_time" : "22:19:10" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "22:21:43" , 
"departure_time" : "22:22:01" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "22:24:18" , 
"departure_time" : "22:25:52" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "22:31:34" , 
"departure_time" : "22:32:33" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "22:35:59" , 
"departure_time" : "22:36:31" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "22:38:32" , 
"departure_time" : "22:39:08" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "22:42:36" , 
"departure_time" : "22:42:42" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "22:47:06" , 
"departure_time" : "22:48:05" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "22:50:59" , 
"departure_time" : "22:51:44" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "22:54:45" , 
"departure_time" : "22:55:22" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "22:59:37" , 
"departure_time" : "23:01:07" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "23:04:30" , 
"departure_time" : "23:05:21" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "23:15:51" , 
"departure_time" : "23:15:51" , 
"distance_traveled" : 28.9392
} ], 
"4638" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "20:14:00" , 
"departure_time" : "20:15:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "20:17:09" , 
"departure_time" : "20:18:43" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "20:22:34" , 
"departure_time" : "20:23:04" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "20:24:30" , 
"departure_time" : "20:24:47" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "20:30:17" , 
"departure_time" : "20:30:44" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "20:35:27" , 
"departure_time" : "20:35:46" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "20:38:19" , 
"departure_time" : "20:39:04" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "20:42:45" , 
"departure_time" : "20:43:48" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "20:48:03" , 
"departure_time" : "20:49:05" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "20:51:02" , 
"departure_time" : "20:51:43" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "20:54:41" , 
"departure_time" : "20:55:31" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "20:59:50" , 
"departure_time" : "20:59:53" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "21:03:03" , 
"departure_time" : "21:04:12" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:16:09" , 
"departure_time" : "21:16:09" , 
"distance_traveled" : 28.9392
} ], 
"4639" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "23:36:00" , 
"departure_time" : "23:38:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "23:40:21" , 
"departure_time" : "23:40:25" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "23:43:04" , 
"departure_time" : "23:43:36" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "23:46:32" , 
"departure_time" : "23:48:10" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "23:53:38" , 
"departure_time" : "23:54:21" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "23:57:43" , 
"departure_time" : "23:58:37" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "24:00:54" , 
"departure_time" : "24:01:05" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "24:03:11" , 
"departure_time" : "24:04:29" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "24:09:18" , 
"departure_time" : "24:10:46" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "24:12:28" , 
"departure_time" : "24:13:22" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "24:14:54" , 
"departure_time" : "24:15:31" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "24:20:37" , 
"departure_time" : "24:21:33" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "24:24:56" , 
"departure_time" : "24:25:05" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "24:38:09" , 
"departure_time" : "24:38:09" , 
"distance_traveled" : 28.9392
} ], 
"4640" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "21:14:00" , 
"departure_time" : "21:15:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "21:18:40" , 
"departure_time" : "21:19:32" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "21:21:52" , 
"departure_time" : "21:22:08" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "21:24:16" , 
"departure_time" : "21:24:38" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "21:30:22" , 
"departure_time" : "21:31:36" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "21:36:14" , 
"departure_time" : "21:36:49" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "21:38:35" , 
"departure_time" : "21:38:38" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "21:42:03" , 
"departure_time" : "21:42:08" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "21:47:05" , 
"departure_time" : "21:47:57" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "21:50:52" , 
"departure_time" : "21:52:11" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "21:55:19" , 
"departure_time" : "21:56:27" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "22:00:08" , 
"departure_time" : "22:00:47" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "22:03:39" , 
"departure_time" : "22:05:06" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:16:27" , 
"departure_time" : "22:16:27" , 
"distance_traveled" : 28.9392
} ], 
"4641" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "06:29:00" , 
"departure_time" : "06:31:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "06:33:14" , 
"departure_time" : "06:34:41" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "06:38:27" , 
"departure_time" : "06:38:52" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 120,
"arrival_time" : "06:47:25" , 
"departure_time" : "06:48:44" , 
"distance_traveled" : 12.7962
}, 
{ 
"stop_id" : 102,
"arrival_time" : "06:51:19" , 
"departure_time" : "06:52:34" , 
"distance_traveled" : 13.9409
}, 
{ 
"stop_id" : 44,
"arrival_time" : "06:55:15" , 
"departure_time" : "06:55:57" , 
"distance_traveled" : 15.1922
}, 
{ 
"stop_id" : 47,
"arrival_time" : "06:59:42" , 
"departure_time" : "06:59:45" , 
"distance_traveled" : 18.496
}, 
{ 
"stop_id" : 31,
"arrival_time" : "07:07:03" , 
"departure_time" : "07:07:51" , 
"distance_traveled" : 21.7875
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "07:11:48" , 
"departure_time" : "07:12:46" , 
"distance_traveled" : 23.6339
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:24:58" , 
"departure_time" : "07:24:58" , 
"distance_traveled" : 28.8911
} ], 
"4642" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "22:14:00" , 
"departure_time" : "22:16:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "22:18:06" , 
"departure_time" : "22:18:49" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "22:21:43" , 
"departure_time" : "22:22:41" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "22:24:58" , 
"departure_time" : "22:26:13" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "22:31:15" , 
"departure_time" : "22:31:16" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "22:35:01" , 
"departure_time" : "22:36:12" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "22:39:11" , 
"departure_time" : "22:40:51" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "22:43:40" , 
"departure_time" : "22:43:53" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "22:47:13" , 
"departure_time" : "22:48:16" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "22:51:03" , 
"departure_time" : "22:51:10" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "22:54:07" , 
"departure_time" : "22:54:37" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "22:59:30" , 
"departure_time" : "23:00:58" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "23:04:28" , 
"departure_time" : "23:04:30" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "23:15:02" , 
"departure_time" : "23:15:02" , 
"distance_traveled" : 28.9392
} ], 
"4643" :  [ 
{ 
"stop_id" : 60,
"arrival_time" : "05:51:00" , 
"departure_time" : "05:51:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6,
"arrival_time" : "05:55:42" , 
"departure_time" : "05:57:19" , 
"distance_traveled" : 1.7983
}, 
{ 
"stop_id" : 68,
"arrival_time" : "06:00:37" , 
"departure_time" : "06:01:33" , 
"distance_traveled" : 4.1822
}, 
{ 
"stop_id" : 157,
"arrival_time" : "06:05:56" , 
"departure_time" : "06:07:26" , 
"distance_traveled" : 7.9657
}, 
{ 
"stop_id" : 108,
"arrival_time" : "06:13:30" , 
"departure_time" : "06:14:55" , 
"distance_traveled" : 12.8652
}, 
{ 
"stop_id" : 129,
"arrival_time" : "06:21:25" , 
"departure_time" : "06:22:30" , 
"distance_traveled" : 16.342
}, 
{ 
"stop_id" : 138,
"arrival_time" : "06:24:05" , 
"departure_time" : "06:24:47" , 
"distance_traveled" : 17.5091
}, 
{ 
"stop_id" : 21,
"arrival_time" : "06:30:42" , 
"departure_time" : "06:30:43" , 
"distance_traveled" : 21.9506
}, 
{ 
"stop_id" : 36,
"arrival_time" : "06:36:01" , 
"departure_time" : "06:36:14" , 
"distance_traveled" : 26.192
}, 
{ 
"stop_id" : 155,
"arrival_time" : "06:47:13" , 
"departure_time" : "06:47:43" , 
"distance_traveled" : 33.6167
}, 
{ 
"stop_id" : 32,
"arrival_time" : "06:52:30" , 
"departure_time" : "06:53:52" , 
"distance_traveled" : 38.2487
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:11:22" , 
"departure_time" : "07:11:22" , 
"distance_traveled" : 47.4947
} ], 
"4644" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "06:29:00" , 
"departure_time" : "06:31:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "06:33:16" , 
"departure_time" : "06:33:34" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "06:37:18" , 
"departure_time" : "06:37:29" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 120,
"arrival_time" : "06:47:11" , 
"departure_time" : "06:48:01" , 
"distance_traveled" : 12.7962
}, 
{ 
"stop_id" : 102,
"arrival_time" : "06:50:50" , 
"departure_time" : "06:51:17" , 
"distance_traveled" : 13.9409
}, 
{ 
"stop_id" : 44,
"arrival_time" : "06:54:27" , 
"departure_time" : "06:55:53" , 
"distance_traveled" : 15.1922
}, 
{ 
"stop_id" : 47,
"arrival_time" : "07:00:26" , 
"departure_time" : "07:01:38" , 
"distance_traveled" : 18.496
}, 
{ 
"stop_id" : 31,
"arrival_time" : "07:08:12" , 
"departure_time" : "07:08:51" , 
"distance_traveled" : 21.7875
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "07:11:39" , 
"departure_time" : "07:12:45" , 
"distance_traveled" : 23.6339
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:25:06" , 
"departure_time" : "07:25:06" , 
"distance_traveled" : 28.8911
} ], 
"4645" :  [ 
{ 
"stop_id" : 60,
"arrival_time" : "06:12:00" , 
"departure_time" : "06:14:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6,
"arrival_time" : "06:17:22" , 
"departure_time" : "06:17:53" , 
"distance_traveled" : 1.7983
}, 
{ 
"stop_id" : 68,
"arrival_time" : "06:20:31" , 
"departure_time" : "06:21:37" , 
"distance_traveled" : 4.1822
}, 
{ 
"stop_id" : 157,
"arrival_time" : "06:27:06" , 
"departure_time" : "06:27:07" , 
"distance_traveled" : 7.9657
}, 
{ 
"stop_id" : 108,
"arrival_time" : "06:33:01" , 
"departure_time" : "06:33:19" , 
"distance_traveled" : 12.8652
}, 
{ 
"stop_id" : 129,
"arrival_time" : "06:42:18" , 
"departure_time" : "06:42:43" , 
"distance_traveled" : 16.342
}, 
{ 
"stop_id" : 138,
"arrival_time" : "06:45:25" , 
"departure_time" : "06:46:31" , 
"distance_traveled" : 17.5091
}, 
{ 
"stop_id" : 21,
"arrival_time" : "06:52:06" , 
"departure_time" : "06:52:59" , 
"distance_traveled" : 21.9506
}, 
{ 
"stop_id" : 36,
"arrival_time" : "06:58:53" , 
"departure_time" : "06:59:55" , 
"distance_traveled" : 26.192
}, 
{ 
"stop_id" : 155,
"arrival_time" : "07:10:02" , 
"departure_time" : "07:11:03" , 
"distance_traveled" : 33.6167
}, 
{ 
"stop_id" : 32,
"arrival_time" : "07:15:01" , 
"departure_time" : "07:15:29" , 
"distance_traveled" : 38.2487
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:32:28" , 
"departure_time" : "07:32:28" , 
"distance_traveled" : 47.4947
} ], 
"4646" :  [ 
{ 
"stop_id" : 60,
"arrival_time" : "05:51:00" , 
"departure_time" : "05:52:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6,
"arrival_time" : "05:55:46" , 
"departure_time" : "05:56:15" , 
"distance_traveled" : 1.7983
}, 
{ 
"stop_id" : 68,
"arrival_time" : "05:59:29" , 
"departure_time" : "06:01:07" , 
"distance_traveled" : 4.1822
}, 
{ 
"stop_id" : 157,
"arrival_time" : "06:06:38" , 
"departure_time" : "06:06:41" , 
"distance_traveled" : 7.9657
}, 
{ 
"stop_id" : 108,
"arrival_time" : "06:12:03" , 
"departure_time" : "06:13:40" , 
"distance_traveled" : 12.8652
}, 
{ 
"stop_id" : 129,
"arrival_time" : "06:21:37" , 
"departure_time" : "06:22:08" , 
"distance_traveled" : 16.342
}, 
{ 
"stop_id" : 138,
"arrival_time" : "06:23:31" , 
"departure_time" : "06:24:57" , 
"distance_traveled" : 17.5091
}, 
{ 
"stop_id" : 21,
"arrival_time" : "06:31:26" , 
"departure_time" : "06:32:40" , 
"distance_traveled" : 21.9506
}, 
{ 
"stop_id" : 36,
"arrival_time" : "06:37:14" , 
"departure_time" : "06:38:00" , 
"distance_traveled" : 26.192
}, 
{ 
"stop_id" : 155,
"arrival_time" : "06:47:46" , 
"departure_time" : "06:47:50" , 
"distance_traveled" : 33.6167
}, 
{ 
"stop_id" : 32,
"arrival_time" : "06:52:04" , 
"departure_time" : "06:52:13" , 
"distance_traveled" : 38.2487
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:10:09" , 
"departure_time" : "07:10:09" , 
"distance_traveled" : 47.4947
} ], 
"4647" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "06:50:00" , 
"departure_time" : "06:51:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "06:53:55" , 
"departure_time" : "06:55:27" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "06:59:32" , 
"departure_time" : "07:01:11" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "07:02:39" , 
"departure_time" : "07:02:54" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "07:07:15" , 
"departure_time" : "07:08:17" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "07:13:02" , 
"departure_time" : "07:14:23" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "07:16:21" , 
"departure_time" : "07:17:47" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "07:20:26" , 
"departure_time" : "07:21:21" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 47,
"arrival_time" : "07:24:55" , 
"departure_time" : "07:26:30" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 31,
"arrival_time" : "07:32:35" , 
"departure_time" : "07:33:35" , 
"distance_traveled" : 21.7881
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "07:37:00" , 
"departure_time" : "07:37:21" , 
"distance_traveled" : 23.6345
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:49:21" , 
"departure_time" : "07:49:21" , 
"distance_traveled" : 28.8917
} ], 
"4648" :  [ 
{ 
"stop_id" : 60,
"arrival_time" : "06:12:00" , 
"departure_time" : "06:13:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6,
"arrival_time" : "06:17:06" , 
"departure_time" : "06:17:56" , 
"distance_traveled" : 1.7983
}, 
{ 
"stop_id" : 68,
"arrival_time" : "06:20:50" , 
"departure_time" : "06:22:18" , 
"distance_traveled" : 4.1822
}, 
{ 
"stop_id" : 157,
"arrival_time" : "06:27:28" , 
"departure_time" : "06:27:44" , 
"distance_traveled" : 7.9657
}, 
{ 
"stop_id" : 108,
"arrival_time" : "06:33:16" , 
"departure_time" : "06:34:00" , 
"distance_traveled" : 12.8652
}, 
{ 
"stop_id" : 129,
"arrival_time" : "06:42:44" , 
"departure_time" : "06:43:50" , 
"distance_traveled" : 16.342
}, 
{ 
"stop_id" : 138,
"arrival_time" : "06:46:06" , 
"departure_time" : "06:46:27" , 
"distance_traveled" : 17.5091
}, 
{ 
"stop_id" : 21,
"arrival_time" : "06:51:21" , 
"departure_time" : "06:51:48" , 
"distance_traveled" : 21.9506
}, 
{ 
"stop_id" : 36,
"arrival_time" : "06:58:27" , 
"departure_time" : "06:59:45" , 
"distance_traveled" : 26.192
}, 
{ 
"stop_id" : 155,
"arrival_time" : "07:10:18" , 
"departure_time" : "07:10:31" , 
"distance_traveled" : 33.6167
}, 
{ 
"stop_id" : 32,
"arrival_time" : "07:14:13" , 
"departure_time" : "07:14:24" , 
"distance_traveled" : 38.2487
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:32:11" , 
"departure_time" : "07:32:11" , 
"distance_traveled" : 47.4947
} ], 
"4649" :  [ 
{ 
"stop_id" : 60,
"arrival_time" : "06:41:00" , 
"departure_time" : "06:42:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6,
"arrival_time" : "06:46:03" , 
"departure_time" : "06:46:46" , 
"distance_traveled" : 1.7983
}, 
{ 
"stop_id" : 68,
"arrival_time" : "06:49:43" , 
"departure_time" : "06:51:07" , 
"distance_traveled" : 4.1822
}, 
{ 
"stop_id" : 157,
"arrival_time" : "06:56:24" , 
"departure_time" : "06:57:26" , 
"distance_traveled" : 7.9657
}, 
{ 
"stop_id" : 108,
"arrival_time" : "07:03:02" , 
"departure_time" : "07:03:56" , 
"distance_traveled" : 12.8652
}, 
{ 
"stop_id" : 129,
"arrival_time" : "07:11:54" , 
"departure_time" : "07:12:09" , 
"distance_traveled" : 16.342
}, 
{ 
"stop_id" : 138,
"arrival_time" : "07:14:15" , 
"departure_time" : "07:14:27" , 
"distance_traveled" : 17.5091
}, 
{ 
"stop_id" : 24,
"arrival_time" : "07:19:12" , 
"departure_time" : "07:20:50" , 
"distance_traveled" : 20.8453
}, 
{ 
"stop_id" : 21,
"arrival_time" : "07:23:38" , 
"departure_time" : "07:24:25" , 
"distance_traveled" : 21.9566
}, 
{ 
"stop_id" : 36,
"arrival_time" : "07:29:47" , 
"departure_time" : "07:29:48" , 
"distance_traveled" : 26.1983
}, 
{ 
"stop_id" : 155,
"arrival_time" : "07:39:01" , 
"departure_time" : "07:39:52" , 
"distance_traveled" : 33.6229
}, 
{ 
"stop_id" : 32,
"arrival_time" : "07:44:51" , 
"departure_time" : "07:45:51" , 
"distance_traveled" : 38.2549
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:04:00" , 
"departure_time" : "08:04:00" , 
"distance_traveled" : 47.5009
} ], 
"4650" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "06:50:00" , 
"departure_time" : "06:52:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "06:54:15" , 
"departure_time" : "06:55:14" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "06:58:59" , 
"departure_time" : "06:59:45" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "07:01:46" , 
"departure_time" : "07:02:28" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "07:07:42" , 
"departure_time" : "07:07:54" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "07:12:12" , 
"departure_time" : "07:13:40" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "07:16:28" , 
"departure_time" : "07:16:53" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "07:19:25" , 
"departure_time" : "07:21:00" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 47,
"arrival_time" : "07:25:35" , 
"departure_time" : "07:26:47" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 31,
"arrival_time" : "07:32:12" , 
"departure_time" : "07:32:42" , 
"distance_traveled" : 21.7881
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "07:36:30" , 
"departure_time" : "07:37:20" , 
"distance_traveled" : 23.6345
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:49:50" , 
"departure_time" : "07:49:50" , 
"distance_traveled" : 28.8917
} ], 
"4651" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "13:47:00" , 
"departure_time" : "13:49:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "13:51:33" , 
"departure_time" : "13:51:38" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "13:55:05" , 
"departure_time" : "13:55:19" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "13:58:14" , 
"departure_time" : "13:58:18" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "14:05:04" , 
"departure_time" : "14:05:53" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "14:10:49" , 
"departure_time" : "14:12:19" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "14:15:30" , 
"departure_time" : "14:16:54" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "14:19:24" , 
"departure_time" : "14:19:39" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "14:23:15" , 
"departure_time" : "14:24:34" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 32,
"arrival_time" : "14:29:19" , 
"departure_time" : "14:30:18" , 
"distance_traveled" : 21.9134
}, 
{ 
"stop_id" : 31,
"arrival_time" : "14:34:59" , 
"departure_time" : "14:35:37" , 
"distance_traveled" : 24.0633
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "14:38:38" , 
"departure_time" : "14:39:37" , 
"distance_traveled" : 25.9152
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:48:59" , 
"departure_time" : "14:48:59" , 
"distance_traveled" : 31.1723
} ], 
"4652" :  [ 
{ 
"stop_id" : 60,
"arrival_time" : "06:41:00" , 
"departure_time" : "06:43:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6,
"arrival_time" : "06:46:11" , 
"departure_time" : "06:47:36" , 
"distance_traveled" : 1.7983
}, 
{ 
"stop_id" : 68,
"arrival_time" : "06:50:25" , 
"departure_time" : "06:50:55" , 
"distance_traveled" : 4.1822
}, 
{ 
"stop_id" : 157,
"arrival_time" : "06:55:30" , 
"departure_time" : "06:55:32" , 
"distance_traveled" : 7.9657
}, 
{ 
"stop_id" : 108,
"arrival_time" : "07:02:02" , 
"departure_time" : "07:02:34" , 
"distance_traveled" : 12.8652
}, 
{ 
"stop_id" : 129,
"arrival_time" : "07:11:32" , 
"departure_time" : "07:11:43" , 
"distance_traveled" : 16.342
}, 
{ 
"stop_id" : 138,
"arrival_time" : "07:14:11" , 
"departure_time" : "07:15:21" , 
"distance_traveled" : 17.5091
}, 
{ 
"stop_id" : 24,
"arrival_time" : "07:20:10" , 
"departure_time" : "07:20:18" , 
"distance_traveled" : 20.8453
}, 
{ 
"stop_id" : 21,
"arrival_time" : "07:22:08" , 
"departure_time" : "07:22:51" , 
"distance_traveled" : 21.9566
}, 
{ 
"stop_id" : 36,
"arrival_time" : "07:29:43" , 
"departure_time" : "07:31:12" , 
"distance_traveled" : 26.1983
}, 
{ 
"stop_id" : 155,
"arrival_time" : "07:40:29" , 
"departure_time" : "07:41:55" , 
"distance_traveled" : 33.6229
}, 
{ 
"stop_id" : 32,
"arrival_time" : "07:45:26" , 
"departure_time" : "07:45:30" , 
"distance_traveled" : 38.2549
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:03:04" , 
"departure_time" : "08:03:04" , 
"distance_traveled" : 47.5009
} ], 
"4653" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "04:31:00" , 
"departure_time" : "04:32:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "04:35:12" , 
"departure_time" : "04:35:51" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "04:39:39" , 
"departure_time" : "04:39:43" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "04:42:04" , 
"departure_time" : "04:43:14" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "04:49:10" , 
"departure_time" : "04:50:18" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "04:54:08" , 
"departure_time" : "04:55:17" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "04:57:09" , 
"departure_time" : "04:58:34" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "05:00:25" , 
"departure_time" : "05:01:51" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "05:05:26" , 
"departure_time" : "05:06:59" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 32,
"arrival_time" : "05:09:33" , 
"departure_time" : "05:10:37" , 
"distance_traveled" : 21.9134
}, 
{ 
"stop_id" : 31,
"arrival_time" : "05:15:04" , 
"departure_time" : "05:16:00" , 
"distance_traveled" : 24.0633
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "05:18:56" , 
"departure_time" : "05:19:17" , 
"distance_traveled" : 25.9152
}, 
{ 
"stop_id" : 107,
"arrival_time" : "05:29:21" , 
"departure_time" : "05:29:21" , 
"distance_traveled" : 31.1723
} ], 
"4654" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "13:47:00" , 
"departure_time" : "13:47:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "13:50:03" , 
"departure_time" : "13:51:37" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "13:56:34" , 
"departure_time" : "13:58:11" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "13:59:37" , 
"departure_time" : "14:01:00" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "14:06:23" , 
"departure_time" : "14:06:39" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "14:10:16" , 
"departure_time" : "14:11:24" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "14:15:08" , 
"departure_time" : "14:16:21" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "14:19:13" , 
"departure_time" : "14:20:01" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "14:23:48" , 
"departure_time" : "14:24:40" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 32,
"arrival_time" : "14:28:52" , 
"departure_time" : "14:30:19" , 
"distance_traveled" : 21.9134
}, 
{ 
"stop_id" : 31,
"arrival_time" : "14:35:27" , 
"departure_time" : "14:36:50" , 
"distance_traveled" : 24.0633
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "14:39:23" , 
"departure_time" : "14:39:44" , 
"distance_traveled" : 25.9152
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:48:21" , 
"departure_time" : "14:48:21" , 
"distance_traveled" : 31.1723
} ], 
"4655" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "07:19:00" , 
"departure_time" : "07:19:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "07:21:09" , 
"departure_time" : "07:22:11" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "07:27:02" , 
"departure_time" : "07:27:38" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "07:29:36" , 
"departure_time" : "07:30:30" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "07:36:54" , 
"departure_time" : "07:38:04" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "07:42:10" , 
"departure_time" : "07:42:48" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "07:44:38" , 
"departure_time" : "07:45:45" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "07:49:07" , 
"departure_time" : "07:50:40" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "07:54:33" , 
"departure_time" : "07:56:02" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 32,
"arrival_time" : "07:58:29" , 
"departure_time" : "07:58:59" , 
"distance_traveled" : 21.9134
}, 
{ 
"stop_id" : 31,
"arrival_time" : "08:03:30" , 
"departure_time" : "08:04:01" , 
"distance_traveled" : 24.0633
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "08:07:31" , 
"departure_time" : "08:08:59" , 
"distance_traveled" : 25.9152
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:22:28" , 
"departure_time" : "08:22:28" , 
"distance_traveled" : 31.1723
} ], 
"4656" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "04:31:00" , 
"departure_time" : "04:32:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "04:34:20" , 
"departure_time" : "04:34:56" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "04:39:36" , 
"departure_time" : "04:40:39" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "04:43:03" , 
"departure_time" : "04:44:16" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "04:49:13" , 
"departure_time" : "04:50:24" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "04:54:11" , 
"departure_time" : "04:55:42" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "04:57:31" , 
"departure_time" : "04:57:59" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "04:59:28" , 
"departure_time" : "05:00:52" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "05:05:24" , 
"departure_time" : "05:07:03" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 32,
"arrival_time" : "05:09:39" , 
"departure_time" : "05:09:44" , 
"distance_traveled" : 21.9134
}, 
{ 
"stop_id" : 31,
"arrival_time" : "05:14:05" , 
"departure_time" : "05:15:22" , 
"distance_traveled" : 24.0633
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "05:19:17" , 
"departure_time" : "05:20:56" , 
"distance_traveled" : 25.9152
}, 
{ 
"stop_id" : 107,
"arrival_time" : "05:30:39" , 
"departure_time" : "05:30:39" , 
"distance_traveled" : 31.1723
} ], 
"4657" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "14:45:00" , 
"departure_time" : "14:47:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "14:48:57" , 
"departure_time" : "14:50:07" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "14:53:10" , 
"departure_time" : "14:54:03" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "14:55:53" , 
"departure_time" : "14:56:10" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "15:01:17" , 
"departure_time" : "15:01:48" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "15:07:31" , 
"departure_time" : "15:09:06" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "15:11:35" , 
"departure_time" : "15:11:40" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "15:14:05" , 
"departure_time" : "15:14:55" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "15:18:50" , 
"departure_time" : "15:18:51" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 32,
"arrival_time" : "15:23:01" , 
"departure_time" : "15:23:11" , 
"distance_traveled" : 21.9134
}, 
{ 
"stop_id" : 31,
"arrival_time" : "15:28:10" , 
"departure_time" : "15:28:51" , 
"distance_traveled" : 24.0633
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "15:32:41" , 
"departure_time" : "15:32:42" , 
"distance_traveled" : 25.9152
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:42:01" , 
"departure_time" : "15:42:01" , 
"distance_traveled" : 31.1723
} ], 
"4658" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "07:19:00" , 
"departure_time" : "07:19:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "07:21:42" , 
"departure_time" : "07:22:31" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "07:26:49" , 
"departure_time" : "07:27:54" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "07:30:05" , 
"departure_time" : "07:31:33" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "07:37:28" , 
"departure_time" : "07:38:55" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "07:42:27" , 
"departure_time" : "07:42:36" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "07:44:09" , 
"departure_time" : "07:44:14" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "07:48:05" , 
"departure_time" : "07:48:12" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "07:53:07" , 
"departure_time" : "07:54:45" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 32,
"arrival_time" : "07:58:38" , 
"departure_time" : "07:58:59" , 
"distance_traveled" : 21.9134
}, 
{ 
"stop_id" : 31,
"arrival_time" : "08:03:21" , 
"departure_time" : "08:03:34" , 
"distance_traveled" : 24.0633
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "08:07:13" , 
"departure_time" : "08:07:40" , 
"distance_traveled" : 25.9152
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:21:27" , 
"departure_time" : "08:21:27" , 
"distance_traveled" : 31.1723
} ], 
"4659" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "22:09:00" , 
"departure_time" : "22:10:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "22:12:54" , 
"departure_time" : "22:13:43" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "22:17:49" , 
"departure_time" : "22:18:19" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "22:20:30" , 
"departure_time" : "22:21:56" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "22:26:26" , 
"departure_time" : "22:27:19" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "22:30:53" , 
"departure_time" : "22:31:14" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "22:33:21" , 
"departure_time" : "22:34:47" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "22:38:26" , 
"departure_time" : "22:38:37" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "22:41:11" , 
"departure_time" : "22:41:35" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 32,
"arrival_time" : "22:46:24" , 
"departure_time" : "22:47:23" , 
"distance_traveled" : 21.9134
}, 
{ 
"stop_id" : 31,
"arrival_time" : "22:51:59" , 
"departure_time" : "22:52:26" , 
"distance_traveled" : 24.0633
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "22:55:27" , 
"departure_time" : "22:56:34" , 
"distance_traveled" : 25.9152
}, 
{ 
"stop_id" : 107,
"arrival_time" : "23:07:07" , 
"departure_time" : "23:07:07" , 
"distance_traveled" : 31.1723
} ], 
"4660" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "14:45:00" , 
"departure_time" : "14:47:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "14:49:24" , 
"departure_time" : "14:51:01" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "14:53:37" , 
"departure_time" : "14:54:21" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "14:55:44" , 
"departure_time" : "14:56:10" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "15:01:26" , 
"departure_time" : "15:02:17" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "15:07:51" , 
"departure_time" : "15:09:21" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "15:11:30" , 
"departure_time" : "15:11:59" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "15:14:29" , 
"departure_time" : "15:16:03" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "15:19:34" , 
"departure_time" : "15:20:38" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 32,
"arrival_time" : "15:24:04" , 
"departure_time" : "15:25:04" , 
"distance_traveled" : 21.9134
}, 
{ 
"stop_id" : 31,
"arrival_time" : "15:29:00" , 
"departure_time" : "15:30:04" , 
"distance_traveled" : 24.0633
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "15:33:04" , 
"departure_time" : "15:34:40" , 
"distance_traveled" : 25.9152
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:43:36" , 
"departure_time" : "15:43:36" , 
"distance_traveled" : 31.1723
} ], 
"4661" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "23:38:00" , 
"departure_time" : "23:39:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "23:41:19" , 
"departure_time" : "23:42:33" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "23:46:14" , 
"departure_time" : "23:47:06" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "23:48:52" , 
"departure_time" : "23:49:43" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "23:54:51" , 
"departure_time" : "23:54:55" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "23:59:04" , 
"departure_time" : "24:00:32" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "24:03:28" , 
"departure_time" : "24:04:13" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "24:05:45" , 
"departure_time" : "24:06:27" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "24:10:42" , 
"departure_time" : "24:11:31" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 32,
"arrival_time" : "24:14:49" , 
"departure_time" : "24:15:34" , 
"distance_traveled" : 21.9134
}, 
{ 
"stop_id" : 31,
"arrival_time" : "24:20:45" , 
"departure_time" : "24:21:09" , 
"distance_traveled" : 24.0633
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "24:24:24" , 
"departure_time" : "24:24:35" , 
"distance_traveled" : 25.9152
}, 
{ 
"stop_id" : 107,
"arrival_time" : "24:38:11" , 
"departure_time" : "24:38:11" , 
"distance_traveled" : 31.1723
} ], 
"4662" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "22:09:00" , 
"departure_time" : "22:10:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "22:13:05" , 
"departure_time" : "22:13:52" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "22:17:47" , 
"departure_time" : "22:19:17" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "22:21:30" , 
"departure_time" : "22:22:54" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "22:26:24" , 
"departure_time" : "22:28:03" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "22:31:39" , 
"departure_time" : "22:32:46" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "22:34:07" , 
"departure_time" : "22:34:53" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "22:37:46" , 
"departure_time" : "22:38:22" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "22:41:36" , 
"departure_time" : "22:42:33" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 32,
"arrival_time" : "22:46:57" , 
"departure_time" : "22:48:05" , 
"distance_traveled" : 21.9134
}, 
{ 
"stop_id" : 31,
"arrival_time" : "22:52:08" , 
"departure_time" : "22:52:54" , 
"distance_traveled" : 24.0633
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "22:55:46" , 
"departure_time" : "22:56:44" , 
"distance_traveled" : 25.9152
}, 
{ 
"stop_id" : 107,
"arrival_time" : "23:06:58" , 
"departure_time" : "23:06:58" , 
"distance_traveled" : 31.1723
} ], 
"4663" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "10:47:00" , 
"departure_time" : "10:49:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "10:51:15" , 
"departure_time" : "10:52:41" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "10:56:26" , 
"departure_time" : "10:57:27" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "10:59:01" , 
"departure_time" : "10:59:42" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "11:05:41" , 
"departure_time" : "11:06:15" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "11:10:34" , 
"departure_time" : "11:11:24" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "11:14:50" , 
"departure_time" : "11:16:06" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "11:19:16" , 
"departure_time" : "11:20:12" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "11:23:56" , 
"departure_time" : "11:25:13" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 32,
"arrival_time" : "11:29:17" , 
"departure_time" : "11:29:38" , 
"distance_traveled" : 21.9134
}, 
{ 
"stop_id" : 31,
"arrival_time" : "11:34:21" , 
"departure_time" : "11:35:34" , 
"distance_traveled" : 24.0633
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "11:39:13" , 
"departure_time" : "11:40:17" , 
"distance_traveled" : 25.9152
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:51:04" , 
"departure_time" : "11:52:15" , 
"distance_traveled" : 31.1723
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:00:11" , 
"departure_time" : "12:01:21" , 
"distance_traveled" : 36.2413
}, 
{ 
"stop_id" : 105,
"arrival_time" : "12:14:10" , 
"departure_time" : "12:14:10" , 
"distance_traveled" : 41.2294
} ], 
"4664" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "23:38:00" , 
"departure_time" : "23:39:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "23:41:43" , 
"departure_time" : "23:42:16" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "23:45:33" , 
"departure_time" : "23:46:01" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "23:48:28" , 
"departure_time" : "23:48:37" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "23:54:09" , 
"departure_time" : "23:54:36" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "23:59:27" , 
"departure_time" : "24:00:07" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "24:02:40" , 
"departure_time" : "24:03:50" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "24:06:10" , 
"departure_time" : "24:06:33" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "24:10:23" , 
"departure_time" : "24:12:03" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 32,
"arrival_time" : "24:15:40" , 
"departure_time" : "24:16:33" , 
"distance_traveled" : 21.9134
}, 
{ 
"stop_id" : 31,
"arrival_time" : "24:20:53" , 
"departure_time" : "24:22:31" , 
"distance_traveled" : 24.0633
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "24:25:38" , 
"departure_time" : "24:27:10" , 
"distance_traveled" : 25.9152
}, 
{ 
"stop_id" : 107,
"arrival_time" : "24:39:32" , 
"departure_time" : "24:39:32" , 
"distance_traveled" : 31.1723
} ], 
"4665" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "11:47:00" , 
"departure_time" : "11:49:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "11:50:54" , 
"departure_time" : "11:51:38" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "11:55:44" , 
"departure_time" : "11:56:41" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "11:58:57" , 
"departure_time" : "11:59:05" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "12:05:08" , 
"departure_time" : "12:05:19" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "12:10:11" , 
"departure_time" : "12:10:59" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "12:14:48" , 
"departure_time" : "12:16:21" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "12:19:33" , 
"departure_time" : "12:20:49" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "12:24:16" , 
"departure_time" : "12:25:41" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 32,
"arrival_time" : "12:29:25" , 
"departure_time" : "12:30:13" , 
"distance_traveled" : 21.9134
}, 
{ 
"stop_id" : 31,
"arrival_time" : "12:34:48" , 
"departure_time" : "12:35:41" , 
"distance_traveled" : 24.0633
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "12:38:53" , 
"departure_time" : "12:40:11" , 
"distance_traveled" : 25.9152
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:50:18" , 
"departure_time" : "12:50:53" , 
"distance_traveled" : 31.1723
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:59:35" , 
"departure_time" : "13:01:02" , 
"distance_traveled" : 36.2413
}, 
{ 
"stop_id" : 105,
"arrival_time" : "13:13:27" , 
"departure_time" : "13:13:27" , 
"distance_traveled" : 41.2294
} ], 
"4666" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "10:47:00" , 
"departure_time" : "10:49:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "10:51:01" , 
"departure_time" : "10:51:34" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "10:55:33" , 
"departure_time" : "10:56:53" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "10:59:20" , 
"departure_time" : "11:00:00" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "11:05:40" , 
"departure_time" : "11:06:33" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "11:10:53" , 
"departure_time" : "11:10:57" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "11:14:04" , 
"departure_time" : "11:14:24" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "11:18:20" , 
"departure_time" : "11:18:56" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "11:23:36" , 
"departure_time" : "11:23:41" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 32,
"arrival_time" : "11:28:05" , 
"departure_time" : "11:28:11" , 
"distance_traveled" : 21.9134
}, 
{ 
"stop_id" : 31,
"arrival_time" : "11:34:06" , 
"departure_time" : "11:35:36" , 
"distance_traveled" : 24.0633
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "11:39:30" , 
"departure_time" : "11:40:02" , 
"distance_traveled" : 25.9152
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:50:32" , 
"departure_time" : "11:51:27" , 
"distance_traveled" : 31.1723
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:59:55" , 
"departure_time" : "12:01:31" , 
"distance_traveled" : 36.2413
}, 
{ 
"stop_id" : 105,
"arrival_time" : "12:14:36" , 
"departure_time" : "12:14:36" , 
"distance_traveled" : 41.2294
} ], 
"4667" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "19:52:00" , 
"departure_time" : "19:53:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "19:55:11" , 
"departure_time" : "19:56:00" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "20:00:49" , 
"departure_time" : "20:01:11" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "20:03:22" , 
"departure_time" : "20:04:07" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "20:08:45" , 
"departure_time" : "20:09:39" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "20:13:54" , 
"departure_time" : "20:14:48" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "20:16:54" , 
"departure_time" : "20:17:32" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "20:20:38" , 
"departure_time" : "20:20:51" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "20:24:13" , 
"departure_time" : "20:24:31" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 32,
"arrival_time" : "20:29:18" , 
"departure_time" : "20:30:12" , 
"distance_traveled" : 21.9134
}, 
{ 
"stop_id" : 31,
"arrival_time" : "20:34:54" , 
"departure_time" : "20:34:58" , 
"distance_traveled" : 24.0633
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "20:38:04" , 
"departure_time" : "20:38:06" , 
"distance_traveled" : 25.9152
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:49:02" , 
"departure_time" : "20:50:12" , 
"distance_traveled" : 31.1723
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:59:10" , 
"departure_time" : "21:00:15" , 
"distance_traveled" : 36.2413
}, 
{ 
"stop_id" : 105,
"arrival_time" : "21:12:05" , 
"departure_time" : "21:12:05" , 
"distance_traveled" : 41.2294
} ], 
"4668" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "11:47:00" , 
"departure_time" : "11:49:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "11:51:04" , 
"departure_time" : "11:51:53" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "11:55:49" , 
"departure_time" : "11:57:02" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "11:59:13" , 
"departure_time" : "12:00:10" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "12:05:57" , 
"departure_time" : "12:07:00" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "12:11:03" , 
"departure_time" : "12:11:21" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "12:14:18" , 
"departure_time" : "12:15:06" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "12:18:48" , 
"departure_time" : "12:19:13" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "12:23:25" , 
"departure_time" : "12:24:39" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 32,
"arrival_time" : "12:29:14" , 
"departure_time" : "12:29:56" , 
"distance_traveled" : 21.9134
}, 
{ 
"stop_id" : 31,
"arrival_time" : "12:34:42" , 
"departure_time" : "12:36:07" , 
"distance_traveled" : 24.0633
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "12:39:25" , 
"departure_time" : "12:39:37" , 
"distance_traveled" : 25.9152
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:49:12" , 
"departure_time" : "12:50:04" , 
"distance_traveled" : 31.1723
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:59:52" , 
"departure_time" : "13:00:23" , 
"distance_traveled" : 36.2413
}, 
{ 
"stop_id" : 105,
"arrival_time" : "13:12:31" , 
"departure_time" : "13:12:31" , 
"distance_traveled" : 41.2294
} ], 
"4669" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "20:49:00" , 
"departure_time" : "20:50:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "20:52:36" , 
"departure_time" : "20:52:51" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "20:57:15" , 
"departure_time" : "20:58:11" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "21:00:56" , 
"departure_time" : "21:01:02" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "21:05:06" , 
"departure_time" : "21:05:11" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "21:10:05" , 
"departure_time" : "21:11:37" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "21:14:32" , 
"departure_time" : "21:15:00" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "21:17:28" , 
"departure_time" : "21:18:11" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "21:21:43" , 
"departure_time" : "21:21:56" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 32,
"arrival_time" : "21:26:13" , 
"departure_time" : "21:27:14" , 
"distance_traveled" : 21.9134
}, 
{ 
"stop_id" : 31,
"arrival_time" : "21:32:01" , 
"departure_time" : "21:32:57" , 
"distance_traveled" : 24.0633
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "21:35:56" , 
"departure_time" : "21:37:24" , 
"distance_traveled" : 25.9152
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:48:28" , 
"departure_time" : "21:49:19" , 
"distance_traveled" : 31.1723
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:56:51" , 
"departure_time" : "21:56:58" , 
"distance_traveled" : 36.2413
}, 
{ 
"stop_id" : 105,
"arrival_time" : "22:10:07" , 
"departure_time" : "22:10:07" , 
"distance_traveled" : 41.2294
} ], 
"4670" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "19:52:00" , 
"departure_time" : "19:53:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "19:56:13" , 
"departure_time" : "19:57:23" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "20:01:10" , 
"departure_time" : "20:02:44" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "20:04:34" , 
"departure_time" : "20:05:00" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "20:08:26" , 
"departure_time" : "20:09:34" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "20:14:08" , 
"departure_time" : "20:14:30" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "20:16:22" , 
"departure_time" : "20:16:54" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "20:20:32" , 
"departure_time" : "20:21:08" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "20:24:36" , 
"departure_time" : "20:25:12" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 32,
"arrival_time" : "20:29:36" , 
"departure_time" : "20:30:46" , 
"distance_traveled" : 21.9134
}, 
{ 
"stop_id" : 31,
"arrival_time" : "20:35:10" , 
"departure_time" : "20:36:02" , 
"distance_traveled" : 24.0633
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "20:38:52" , 
"departure_time" : "20:40:19" , 
"distance_traveled" : 25.9152
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:50:27" , 
"departure_time" : "20:51:11" , 
"distance_traveled" : 31.1723
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:58:44" , 
"departure_time" : "20:59:08" , 
"distance_traveled" : 36.2413
}, 
{ 
"stop_id" : 105,
"arrival_time" : "21:11:24" , 
"departure_time" : "21:11:24" , 
"distance_traveled" : 41.2294
} ], 
"4671" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "07:39:00" , 
"departure_time" : "07:40:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "07:42:51" , 
"departure_time" : "07:43:54" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "07:48:03" , 
"departure_time" : "07:48:19" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "07:50:16" , 
"departure_time" : "07:51:50" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "07:57:34" , 
"departure_time" : "07:57:45" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "08:01:11" , 
"departure_time" : "08:02:47" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "08:06:36" , 
"departure_time" : "08:06:58" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "08:09:22" , 
"departure_time" : "08:09:37" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "08:14:15" , 
"departure_time" : "08:15:52" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "08:18:37" , 
"departure_time" : "08:19:04" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "08:21:27" , 
"departure_time" : "08:21:31" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "08:26:04" , 
"departure_time" : "08:27:02" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "08:30:58" , 
"departure_time" : "08:31:00" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:42:02" , 
"departure_time" : "08:42:02" , 
"distance_traveled" : 28.9392
} ], 
"4672" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "20:49:00" , 
"departure_time" : "20:50:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "20:53:08" , 
"departure_time" : "20:53:55" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "20:57:47" , 
"departure_time" : "20:58:43" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "21:00:56" , 
"departure_time" : "21:02:08" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "21:06:12" , 
"departure_time" : "21:07:48" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "21:11:36" , 
"departure_time" : "21:12:45" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "21:14:09" , 
"departure_time" : "21:15:31" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "21:18:22" , 
"departure_time" : "21:18:24" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "21:21:02" , 
"departure_time" : "21:21:22" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 32,
"arrival_time" : "21:26:20" , 
"departure_time" : "21:26:59" , 
"distance_traveled" : 21.9134
}, 
{ 
"stop_id" : 31,
"arrival_time" : "21:31:39" , 
"departure_time" : "21:32:23" , 
"distance_traveled" : 24.0633
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "21:35:44" , 
"departure_time" : "21:36:57" , 
"distance_traveled" : 25.9152
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:48:13" , 
"departure_time" : "21:49:21" , 
"distance_traveled" : 31.1723
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:57:08" , 
"departure_time" : "21:57:25" , 
"distance_traveled" : 36.2413
}, 
{ 
"stop_id" : 105,
"arrival_time" : "22:10:17" , 
"departure_time" : "22:10:17" , 
"distance_traveled" : 41.2294
} ], 
"4673" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "05:48:00" , 
"departure_time" : "05:49:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "05:52:38" , 
"departure_time" : "05:53:05" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "05:56:27" , 
"departure_time" : "05:56:36" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "05:59:09" , 
"departure_time" : "05:59:27" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "06:05:18" , 
"departure_time" : "06:06:01" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "06:10:43" , 
"departure_time" : "06:11:17" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "06:13:34" , 
"departure_time" : "06:14:16" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "06:16:42" , 
"departure_time" : "06:16:54" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "06:21:12" , 
"departure_time" : "06:22:13" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "06:26:01" , 
"departure_time" : "06:26:04" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "06:28:03" , 
"departure_time" : "06:28:51" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "06:34:48" , 
"departure_time" : "06:36:06" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "06:39:18" , 
"departure_time" : "06:40:45" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:51:27" , 
"departure_time" : "06:51:27" , 
"distance_traveled" : 28.9392
} ], 
"4674" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "07:39:00" , 
"departure_time" : "07:41:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "07:43:21" , 
"departure_time" : "07:43:52" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "07:47:31" , 
"departure_time" : "07:47:37" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "07:50:06" , 
"departure_time" : "07:51:00" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "07:56:54" , 
"departure_time" : "07:58:12" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "08:02:18" , 
"departure_time" : "08:02:51" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "08:05:33" , 
"departure_time" : "08:06:29" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "08:09:56" , 
"departure_time" : "08:11:04" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "08:15:08" , 
"departure_time" : "08:16:11" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "08:18:03" , 
"departure_time" : "08:18:24" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "08:21:21" , 
"departure_time" : "08:22:56" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "08:27:35" , 
"departure_time" : "08:27:54" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "08:30:19" , 
"departure_time" : "08:31:24" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:43:05" , 
"departure_time" : "08:43:05" , 
"distance_traveled" : 28.9392
} ], 
"4675" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "16:08:00" , 
"departure_time" : "16:10:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "16:12:08" , 
"departure_time" : "16:13:11" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "16:17:03" , 
"departure_time" : "16:18:13" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "16:20:10" , 
"departure_time" : "16:21:32" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "16:26:22" , 
"departure_time" : "16:27:21" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "16:30:59" , 
"departure_time" : "16:32:22" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "16:34:23" , 
"departure_time" : "16:35:07" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "16:36:44" , 
"departure_time" : "16:38:18" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "16:42:34" , 
"departure_time" : "16:43:49" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "16:45:15" , 
"departure_time" : "16:46:46" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "16:48:31" , 
"departure_time" : "16:48:46" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "16:53:15" , 
"departure_time" : "16:54:32" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "16:58:17" , 
"departure_time" : "16:59:24" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:10:07" , 
"departure_time" : "17:10:07" , 
"distance_traveled" : 28.9392
} ], 
"4676" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "05:48:00" , 
"departure_time" : "05:50:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "05:51:53" , 
"departure_time" : "05:52:54" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "05:57:01" , 
"departure_time" : "05:57:24" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "05:59:23" , 
"departure_time" : "06:00:50" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "06:06:27" , 
"departure_time" : "06:08:03" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "06:11:36" , 
"departure_time" : "06:12:27" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "06:13:51" , 
"departure_time" : "06:15:28" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "06:17:37" , 
"departure_time" : "06:18:26" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "06:21:49" , 
"departure_time" : "06:22:26" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "06:25:37" , 
"departure_time" : "06:25:47" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "06:28:10" , 
"departure_time" : "06:29:24" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "06:35:14" , 
"departure_time" : "06:35:26" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "06:38:12" , 
"departure_time" : "06:39:01" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:50:49" , 
"departure_time" : "06:50:49" , 
"distance_traveled" : 28.9392
} ], 
"4677" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "17:52:00" , 
"departure_time" : "17:53:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "17:56:09" , 
"departure_time" : "17:57:45" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "18:01:36" , 
"departure_time" : "18:01:51" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "18:03:15" , 
"departure_time" : "18:04:40" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "18:09:25" , 
"departure_time" : "18:09:34" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "18:13:09" , 
"departure_time" : "18:13:25" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "18:16:16" , 
"departure_time" : "18:17:21" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "18:21:05" , 
"departure_time" : "18:21:27" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "18:24:22" , 
"departure_time" : "18:25:34" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "18:29:12" , 
"departure_time" : "18:29:53" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "18:31:41" , 
"departure_time" : "18:32:56" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "18:37:15" , 
"departure_time" : "18:38:11" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "18:40:56" , 
"departure_time" : "18:42:22" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:53:26" , 
"departure_time" : "18:53:26" , 
"distance_traveled" : 28.9392
} ], 
"4678" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "16:08:00" , 
"departure_time" : "16:10:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "16:12:17" , 
"departure_time" : "16:12:34" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "16:16:17" , 
"departure_time" : "16:17:05" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "16:19:48" , 
"departure_time" : "16:20:57" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "16:26:09" , 
"departure_time" : "16:27:30" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "16:31:21" , 
"departure_time" : "16:32:16" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "16:33:55" , 
"departure_time" : "16:34:13" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "16:36:18" , 
"departure_time" : "16:37:34" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "16:42:16" , 
"departure_time" : "16:43:48" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "16:45:32" , 
"departure_time" : "16:46:32" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "16:48:00" , 
"departure_time" : "16:48:35" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "16:53:35" , 
"departure_time" : "16:54:41" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "16:58:06" , 
"departure_time" : "16:59:35" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:10:29" , 
"departure_time" : "17:10:29" , 
"distance_traveled" : 28.9392
} ], 
"4679" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "05:05:00" , 
"departure_time" : "05:07:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "05:09:22" , 
"departure_time" : "05:09:37" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "05:13:15" , 
"departure_time" : "05:13:37" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "05:16:22" , 
"departure_time" : "05:17:12" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "05:22:50" , 
"departure_time" : "05:23:18" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "05:27:28" , 
"departure_time" : "05:27:35" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "05:30:07" , 
"departure_time" : "05:31:16" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "05:34:09" , 
"departure_time" : "05:35:20" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "05:39:11" , 
"departure_time" : "05:40:05" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "05:41:54" , 
"departure_time" : "05:42:17" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "05:44:23" , 
"departure_time" : "05:44:37" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "05:50:14" , 
"departure_time" : "05:50:36" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "05:54:22" , 
"departure_time" : "05:55:16" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:06:54" , 
"departure_time" : "06:07:27" , 
"distance_traveled" : 28.9392
}, 
{ 
"stop_id" : 63,
"arrival_time" : "06:27:33" , 
"departure_time" : "06:27:33" , 
"distance_traveled" : 36.3576
} ], 
"4680" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "17:52:00" , 
"departure_time" : "17:53:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "17:56:09" , 
"departure_time" : "17:57:38" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "18:01:29" , 
"departure_time" : "18:01:38" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "18:03:09" , 
"departure_time" : "18:03:35" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "18:08:26" , 
"departure_time" : "18:09:33" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "18:14:07" , 
"departure_time" : "18:15:03" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "18:16:56" , 
"departure_time" : "18:17:56" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "18:21:00" , 
"departure_time" : "18:22:07" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "18:25:07" , 
"departure_time" : "18:26:44" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "18:29:37" , 
"departure_time" : "18:30:00" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "18:31:23" , 
"departure_time" : "18:31:52" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "18:36:29" , 
"departure_time" : "18:36:43" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "18:40:14" , 
"departure_time" : "18:41:47" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:53:33" , 
"departure_time" : "18:53:33" , 
"distance_traveled" : 28.9392
} ], 
"4681" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "08:43:00" , 
"departure_time" : "08:46:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "08:47:32" , 
"departure_time" : "08:48:36" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "08:52:04" , 
"departure_time" : "08:53:16" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "08:55:12" , 
"departure_time" : "08:56:29" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "09:01:17" , 
"departure_time" : "09:01:23" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "09:05:06" , 
"departure_time" : "09:06:03" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "09:08:57" , 
"departure_time" : "09:10:31" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "09:13:34" , 
"departure_time" : "09:14:50" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "09:17:16" , 
"departure_time" : "09:18:30" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "09:21:14" , 
"departure_time" : "09:22:17" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "09:24:03" , 
"departure_time" : "09:24:19" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "09:29:16" , 
"departure_time" : "09:30:41" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "09:34:25" , 
"departure_time" : "09:35:46" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:47:21" , 
"departure_time" : "09:47:41" , 
"distance_traveled" : 28.9392
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:54:20" , 
"departure_time" : "09:55:49" , 
"distance_traveled" : 34.0081
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:07:29" , 
"departure_time" : "10:07:29" , 
"distance_traveled" : 38.9962
} ], 
"4682" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "05:05:00" , 
"departure_time" : "05:08:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "05:09:35" , 
"departure_time" : "05:09:54" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "05:13:19" , 
"departure_time" : "05:13:30" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "05:16:11" , 
"departure_time" : "05:16:13" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "05:22:02" , 
"departure_time" : "05:22:26" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "05:27:24" , 
"departure_time" : "05:28:31" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "05:31:07" , 
"departure_time" : "05:31:54" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "05:33:47" , 
"departure_time" : "05:35:03" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "05:39:16" , 
"departure_time" : "05:39:34" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "05:41:18" , 
"departure_time" : "05:41:53" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "05:44:35" , 
"departure_time" : "05:45:06" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "05:50:31" , 
"departure_time" : "05:52:00" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "05:55:29" , 
"departure_time" : "05:56:03" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:06:34" , 
"departure_time" : "06:07:24" , 
"distance_traveled" : 28.9392
}, 
{ 
"stop_id" : 63,
"arrival_time" : "06:27:50" , 
"departure_time" : "06:27:50" , 
"distance_traveled" : 36.3576
} ], 
"4683" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "18:49:00" , 
"departure_time" : "18:50:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "18:52:35" , 
"departure_time" : "18:53:29" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "18:57:54" , 
"departure_time" : "18:58:57" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "19:01:03" , 
"departure_time" : "19:01:37" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "19:05:34" , 
"departure_time" : "19:05:55" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "19:10:21" , 
"departure_time" : "19:10:30" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "19:13:09" , 
"departure_time" : "19:14:07" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "19:17:58" , 
"departure_time" : "19:18:44" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "19:21:46" , 
"departure_time" : "19:22:14" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "19:25:28" , 
"departure_time" : "19:26:19" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "19:28:51" , 
"departure_time" : "19:29:22" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "19:33:31" , 
"departure_time" : "19:33:38" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "19:37:07" , 
"departure_time" : "19:37:47" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:51:40" , 
"departure_time" : "19:53:01" , 
"distance_traveled" : 28.9392
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:01:21" , 
"departure_time" : "20:01:44" , 
"distance_traveled" : 34.0081
}, 
{ 
"stop_id" : 105,
"arrival_time" : "20:14:23" , 
"departure_time" : "20:14:23" , 
"distance_traveled" : 38.9962
} ], 
"4684" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "08:43:00" , 
"departure_time" : "08:43:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "08:46:36" , 
"departure_time" : "08:47:07" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "08:51:31" , 
"departure_time" : "08:52:54" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "08:55:23" , 
"departure_time" : "08:55:36" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "09:00:13" , 
"departure_time" : "09:01:22" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "09:06:09" , 
"departure_time" : "09:07:09" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "09:09:00" , 
"departure_time" : "09:10:32" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "09:13:32" , 
"departure_time" : "09:14:30" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "09:16:58" , 
"departure_time" : "09:18:35" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "09:21:37" , 
"departure_time" : "09:22:48" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "09:24:11" , 
"departure_time" : "09:25:39" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "09:30:28" , 
"departure_time" : "09:31:06" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "09:33:38" , 
"departure_time" : "09:34:01" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:46:23" , 
"departure_time" : "09:46:24" , 
"distance_traveled" : 28.9392
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "09:54:01" , 
"departure_time" : "09:55:31" , 
"distance_traveled" : 34.0081
}, 
{ 
"stop_id" : 105,
"arrival_time" : "10:07:30" , 
"departure_time" : "10:07:30" , 
"distance_traveled" : 38.9962
} ], 
"4685" :  [ 
{ 
"stop_id" : 60,
"arrival_time" : "09:18:00" , 
"departure_time" : "09:20:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6,
"arrival_time" : "09:23:13" , 
"departure_time" : "09:23:46" , 
"distance_traveled" : 1.7983
}, 
{ 
"stop_id" : 68,
"arrival_time" : "09:26:33" , 
"departure_time" : "09:26:56" , 
"distance_traveled" : 4.1822
}, 
{ 
"stop_id" : 157,
"arrival_time" : "09:32:23" , 
"departure_time" : "09:33:01" , 
"distance_traveled" : 7.9657
}, 
{ 
"stop_id" : 108,
"arrival_time" : "09:39:38" , 
"departure_time" : "09:40:53" , 
"distance_traveled" : 12.8652
}, 
{ 
"stop_id" : 129,
"arrival_time" : "09:49:15" , 
"departure_time" : "09:50:07" , 
"distance_traveled" : 16.342
}, 
{ 
"stop_id" : 138,
"arrival_time" : "09:51:52" , 
"departure_time" : "09:51:55" , 
"distance_traveled" : 17.5091
}, 
{ 
"stop_id" : 24,
"arrival_time" : "09:56:03" , 
"departure_time" : "09:56:17" , 
"distance_traveled" : 20.8453
}, 
{ 
"stop_id" : 21,
"arrival_time" : "09:59:14" , 
"departure_time" : "10:00:14" , 
"distance_traveled" : 21.9566
}, 
{ 
"stop_id" : 36,
"arrival_time" : "10:06:00" , 
"departure_time" : "10:06:53" , 
"distance_traveled" : 26.1983
}, 
{ 
"stop_id" : 120,
"arrival_time" : "10:10:53" , 
"departure_time" : "10:11:19" , 
"distance_traveled" : 29.1383
}, 
{ 
"stop_id" : 102,
"arrival_time" : "10:13:26" , 
"departure_time" : "10:14:12" , 
"distance_traveled" : 30.283
}, 
{ 
"stop_id" : 44,
"arrival_time" : "10:16:46" , 
"departure_time" : "10:17:53" , 
"distance_traveled" : 31.5343
}, 
{ 
"stop_id" : 155,
"arrival_time" : "10:22:07" , 
"departure_time" : "10:23:33" , 
"distance_traveled" : 33.6229
}, 
{ 
"stop_id" : 32,
"arrival_time" : "10:27:26" , 
"departure_time" : "10:27:40" , 
"distance_traveled" : 38.2549
}, 
{ 
"stop_id" : 31,
"arrival_time" : "10:31:14" , 
"departure_time" : "10:32:19" , 
"distance_traveled" : 40.4047
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "10:36:05" , 
"departure_time" : "10:37:14" , 
"distance_traveled" : 42.2566
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:49:09" , 
"departure_time" : "10:50:22" , 
"distance_traveled" : 47.5138
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:58:13" , 
"departure_time" : "10:58:46" , 
"distance_traveled" : 52.5828
}, 
{ 
"stop_id" : 105,
"arrival_time" : "11:10:33" , 
"departure_time" : "11:10:33" , 
"distance_traveled" : 57.5708
} ], 
"4686" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "18:49:00" , 
"departure_time" : "18:51:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "18:53:30" , 
"departure_time" : "18:55:05" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "18:58:35" , 
"departure_time" : "18:58:44" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "19:00:09" , 
"departure_time" : "19:00:16" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "19:05:07" , 
"departure_time" : "19:06:32" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "19:11:25" , 
"departure_time" : "19:11:46" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "19:13:21" , 
"departure_time" : "19:13:41" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "19:17:20" , 
"departure_time" : "19:17:23" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "19:21:03" , 
"departure_time" : "19:22:32" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "19:26:29" , 
"departure_time" : "19:27:01" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "19:28:32" , 
"departure_time" : "19:30:05" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "19:34:33" , 
"departure_time" : "19:34:46" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "19:37:13" , 
"departure_time" : "19:37:28" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:51:15" , 
"departure_time" : "19:51:50" , 
"distance_traveled" : 28.9392
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:00:35" , 
"departure_time" : "20:01:16" , 
"distance_traveled" : 34.0081
}, 
{ 
"stop_id" : 105,
"arrival_time" : "20:14:41" , 
"departure_time" : "20:14:41" , 
"distance_traveled" : 38.9962
} ], 
"4687" :  [ 
{ 
"stop_id" : 60,
"arrival_time" : "15:03:00" , 
"departure_time" : "15:04:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6,
"arrival_time" : "15:07:26" , 
"departure_time" : "15:08:39" , 
"distance_traveled" : 1.7983
}, 
{ 
"stop_id" : 68,
"arrival_time" : "15:12:13" , 
"departure_time" : "15:13:34" , 
"distance_traveled" : 4.1822
}, 
{ 
"stop_id" : 157,
"arrival_time" : "15:18:21" , 
"departure_time" : "15:19:11" , 
"distance_traveled" : 7.9657
}, 
{ 
"stop_id" : 108,
"arrival_time" : "15:24:50" , 
"departure_time" : "15:25:20" , 
"distance_traveled" : 12.8652
}, 
{ 
"stop_id" : 129,
"arrival_time" : "15:32:30" , 
"departure_time" : "15:33:02" , 
"distance_traveled" : 16.342
}, 
{ 
"stop_id" : 138,
"arrival_time" : "15:35:32" , 
"departure_time" : "15:36:07" , 
"distance_traveled" : 17.5091
}, 
{ 
"stop_id" : 24,
"arrival_time" : "15:40:35" , 
"departure_time" : "15:41:32" , 
"distance_traveled" : 20.8453
}, 
{ 
"stop_id" : 21,
"arrival_time" : "15:44:57" , 
"departure_time" : "15:46:26" , 
"distance_traveled" : 21.9566
}, 
{ 
"stop_id" : 36,
"arrival_time" : "15:51:29" , 
"departure_time" : "15:52:05" , 
"distance_traveled" : 26.1983
}, 
{ 
"stop_id" : 120,
"arrival_time" : "15:55:36" , 
"departure_time" : "15:56:16" , 
"distance_traveled" : 29.1383
}, 
{ 
"stop_id" : 102,
"arrival_time" : "15:58:40" , 
"departure_time" : "16:00:11" , 
"distance_traveled" : 30.283
}, 
{ 
"stop_id" : 44,
"arrival_time" : "16:03:31" , 
"departure_time" : "16:04:29" , 
"distance_traveled" : 31.5343
}, 
{ 
"stop_id" : 155,
"arrival_time" : "16:06:58" , 
"departure_time" : "16:08:36" , 
"distance_traveled" : 33.6229
}, 
{ 
"stop_id" : 47,
"arrival_time" : "16:10:38" , 
"departure_time" : "16:12:12" , 
"distance_traveled" : 34.8381
}, 
{ 
"stop_id" : 32,
"arrival_time" : "16:14:34" , 
"departure_time" : "16:15:41" , 
"distance_traveled" : 36.0038
}, 
{ 
"stop_id" : 31,
"arrival_time" : "16:19:07" , 
"departure_time" : "16:20:18" , 
"distance_traveled" : 38.1716
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "16:23:11" , 
"departure_time" : "16:23:52" , 
"distance_traveled" : 40.0235
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:34:41" , 
"departure_time" : "16:34:41" , 
"distance_traveled" : 45.2807
} ], 
"4688" :  [ 
{ 
"stop_id" : 60,
"arrival_time" : "09:18:00" , 
"departure_time" : "09:19:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6,
"arrival_time" : "09:22:40" , 
"departure_time" : "09:23:55" , 
"distance_traveled" : 1.7983
}, 
{ 
"stop_id" : 68,
"arrival_time" : "09:27:15" , 
"departure_time" : "09:27:57" , 
"distance_traveled" : 4.1822
}, 
{ 
"stop_id" : 157,
"arrival_time" : "09:32:42" , 
"departure_time" : "09:33:47" , 
"distance_traveled" : 7.9657
}, 
{ 
"stop_id" : 108,
"arrival_time" : "09:40:05" , 
"departure_time" : "09:41:31" , 
"distance_traveled" : 12.8652
}, 
{ 
"stop_id" : 129,
"arrival_time" : "09:49:26" , 
"departure_time" : "09:50:12" , 
"distance_traveled" : 16.342
}, 
{ 
"stop_id" : 138,
"arrival_time" : "09:51:46" , 
"departure_time" : "09:52:40" , 
"distance_traveled" : 17.5091
}, 
{ 
"stop_id" : 24,
"arrival_time" : "09:56:54" , 
"departure_time" : "09:58:19" , 
"distance_traveled" : 20.8453
}, 
{ 
"stop_id" : 21,
"arrival_time" : "10:00:25" , 
"departure_time" : "10:01:02" , 
"distance_traveled" : 21.9566
}, 
{ 
"stop_id" : 36,
"arrival_time" : "10:05:37" , 
"departure_time" : "10:05:59" , 
"distance_traveled" : 26.1983
}, 
{ 
"stop_id" : 120,
"arrival_time" : "10:10:22" , 
"departure_time" : "10:11:39" , 
"distance_traveled" : 29.1383
}, 
{ 
"stop_id" : 102,
"arrival_time" : "10:14:17" , 
"departure_time" : "10:14:23" , 
"distance_traveled" : 30.283
}, 
{ 
"stop_id" : 44,
"arrival_time" : "10:16:06" , 
"departure_time" : "10:17:27" , 
"distance_traveled" : 31.5343
}, 
{ 
"stop_id" : 155,
"arrival_time" : "10:22:21" , 
"departure_time" : "10:22:54" , 
"distance_traveled" : 33.6229
}, 
{ 
"stop_id" : 32,
"arrival_time" : "10:26:33" , 
"departure_time" : "10:27:44" , 
"distance_traveled" : 38.2549
}, 
{ 
"stop_id" : 31,
"arrival_time" : "10:32:11" , 
"departure_time" : "10:32:29" , 
"distance_traveled" : 40.4047
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "10:35:18" , 
"departure_time" : "10:36:32" , 
"distance_traveled" : 42.2566
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:49:14" , 
"departure_time" : "10:50:29" , 
"distance_traveled" : 47.5138
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:58:15" , 
"departure_time" : "10:59:22" , 
"distance_traveled" : 52.5828
}, 
{ 
"stop_id" : 105,
"arrival_time" : "11:11:07" , 
"departure_time" : "11:11:07" , 
"distance_traveled" : 57.5708
} ], 
"4689" :  [ 
{ 
"stop_id" : 60,
"arrival_time" : "16:52:00" , 
"departure_time" : "16:54:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6,
"arrival_time" : "16:57:03" , 
"departure_time" : "16:58:42" , 
"distance_traveled" : 1.7983
}, 
{ 
"stop_id" : 68,
"arrival_time" : "17:01:39" , 
"departure_time" : "17:01:56" , 
"distance_traveled" : 4.1822
}, 
{ 
"stop_id" : 157,
"arrival_time" : "17:06:17" , 
"departure_time" : "17:07:17" , 
"distance_traveled" : 7.9657
}, 
{ 
"stop_id" : 108,
"arrival_time" : "17:14:00" , 
"departure_time" : "17:14:31" , 
"distance_traveled" : 12.8652
}, 
{ 
"stop_id" : 129,
"arrival_time" : "17:21:31" , 
"departure_time" : "17:23:00" , 
"distance_traveled" : 16.342
}, 
{ 
"stop_id" : 138,
"arrival_time" : "17:25:29" , 
"departure_time" : "17:26:15" , 
"distance_traveled" : 17.5091
}, 
{ 
"stop_id" : 24,
"arrival_time" : "17:29:46" , 
"departure_time" : "17:31:19" , 
"distance_traveled" : 20.8453
}, 
{ 
"stop_id" : 21,
"arrival_time" : "17:33:33" , 
"departure_time" : "17:35:09" , 
"distance_traveled" : 21.9566
}, 
{ 
"stop_id" : 36,
"arrival_time" : "17:40:36" , 
"departure_time" : "17:40:40" , 
"distance_traveled" : 26.1983
}, 
{ 
"stop_id" : 120,
"arrival_time" : "17:44:04" , 
"departure_time" : "17:44:31" , 
"distance_traveled" : 29.1383
}, 
{ 
"stop_id" : 102,
"arrival_time" : "17:47:27" , 
"departure_time" : "17:48:08" , 
"distance_traveled" : 30.283
}, 
{ 
"stop_id" : 44,
"arrival_time" : "17:50:41" , 
"departure_time" : "17:50:54" , 
"distance_traveled" : 31.5343
}, 
{ 
"stop_id" : 155,
"arrival_time" : "17:54:13" , 
"departure_time" : "17:55:04" , 
"distance_traveled" : 33.6229
}, 
{ 
"stop_id" : 47,
"arrival_time" : "17:58:51" , 
"departure_time" : "18:00:27" , 
"distance_traveled" : 34.8381
}, 
{ 
"stop_id" : 32,
"arrival_time" : "18:02:36" , 
"departure_time" : "18:03:34" , 
"distance_traveled" : 36.0038
}, 
{ 
"stop_id" : 31,
"arrival_time" : "18:06:58" , 
"departure_time" : "18:07:48" , 
"distance_traveled" : 38.1716
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "18:10:50" , 
"departure_time" : "18:11:23" , 
"distance_traveled" : 40.0235
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:20:33" , 
"departure_time" : "18:20:33" , 
"distance_traveled" : 45.2807
} ], 
"4690" :  [ 
{ 
"stop_id" : 60,
"arrival_time" : "15:03:00" , 
"departure_time" : "15:03:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6,
"arrival_time" : "15:07:12" , 
"departure_time" : "15:07:48" , 
"distance_traveled" : 1.7983
}, 
{ 
"stop_id" : 68,
"arrival_time" : "15:11:36" , 
"departure_time" : "15:13:14" , 
"distance_traveled" : 4.1822
}, 
{ 
"stop_id" : 157,
"arrival_time" : "15:18:38" , 
"departure_time" : "15:18:47" , 
"distance_traveled" : 7.9657
}, 
{ 
"stop_id" : 108,
"arrival_time" : "15:24:09" , 
"departure_time" : "15:25:41" , 
"distance_traveled" : 12.8652
}, 
{ 
"stop_id" : 129,
"arrival_time" : "15:33:32" , 
"departure_time" : "15:34:53" , 
"distance_traveled" : 16.342
}, 
{ 
"stop_id" : 138,
"arrival_time" : "15:36:21" , 
"departure_time" : "15:37:30" , 
"distance_traveled" : 17.5091
}, 
{ 
"stop_id" : 24,
"arrival_time" : "15:41:09" , 
"departure_time" : "15:41:48" , 
"distance_traveled" : 20.8453
}, 
{ 
"stop_id" : 21,
"arrival_time" : "15:44:39" , 
"departure_time" : "15:44:46" , 
"distance_traveled" : 21.9566
}, 
{ 
"stop_id" : 36,
"arrival_time" : "15:50:07" , 
"departure_time" : "15:50:30" , 
"distance_traveled" : 26.1983
}, 
{ 
"stop_id" : 120,
"arrival_time" : "15:55:23" , 
"departure_time" : "15:56:12" , 
"distance_traveled" : 29.1383
}, 
{ 
"stop_id" : 102,
"arrival_time" : "15:58:49" , 
"departure_time" : "15:59:20" , 
"distance_traveled" : 30.283
}, 
{ 
"stop_id" : 44,
"arrival_time" : "16:02:31" , 
"departure_time" : "16:03:03" , 
"distance_traveled" : 31.5343
}, 
{ 
"stop_id" : 155,
"arrival_time" : "16:06:32" , 
"departure_time" : "16:07:31" , 
"distance_traveled" : 33.6229
}, 
{ 
"stop_id" : 47,
"arrival_time" : "16:09:59" , 
"departure_time" : "16:10:54" , 
"distance_traveled" : 34.8381
}, 
{ 
"stop_id" : 32,
"arrival_time" : "16:13:55" , 
"departure_time" : "16:14:25" , 
"distance_traveled" : 36.0038
}, 
{ 
"stop_id" : 31,
"arrival_time" : "16:18:30" , 
"departure_time" : "16:19:49" , 
"distance_traveled" : 38.1716
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "16:23:19" , 
"departure_time" : "16:23:22" , 
"distance_traveled" : 40.0235
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:34:03" , 
"departure_time" : "16:34:03" , 
"distance_traveled" : 45.2807
} ], 
"4691" :  [ 
{ 
"stop_id" : 60,
"arrival_time" : "12:18:00" , 
"departure_time" : "12:19:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6,
"arrival_time" : "12:23:28" , 
"departure_time" : "12:23:30" , 
"distance_traveled" : 1.7983
}, 
{ 
"stop_id" : 68,
"arrival_time" : "12:26:02" , 
"departure_time" : "12:26:28" , 
"distance_traveled" : 4.1822
}, 
{ 
"stop_id" : 157,
"arrival_time" : "12:32:26" , 
"departure_time" : "12:32:36" , 
"distance_traveled" : 7.9657
}, 
{ 
"stop_id" : 108,
"arrival_time" : "12:39:10" , 
"departure_time" : "12:40:21" , 
"distance_traveled" : 12.8652
}, 
{ 
"stop_id" : 129,
"arrival_time" : "12:49:11" , 
"departure_time" : "12:50:22" , 
"distance_traveled" : 16.342
}, 
{ 
"stop_id" : 138,
"arrival_time" : "12:52:11" , 
"departure_time" : "12:53:25" , 
"distance_traveled" : 17.5091
}, 
{ 
"stop_id" : 24,
"arrival_time" : "12:57:14" , 
"departure_time" : "12:58:22" , 
"distance_traveled" : 20.8453
}, 
{ 
"stop_id" : 21,
"arrival_time" : "13:00:08" , 
"departure_time" : "13:01:00" , 
"distance_traveled" : 21.9566
}, 
{ 
"stop_id" : 36,
"arrival_time" : "13:05:52" , 
"departure_time" : "13:06:02" , 
"distance_traveled" : 26.1983
}, 
{ 
"stop_id" : 120,
"arrival_time" : "13:10:10" , 
"departure_time" : "13:11:45" , 
"distance_traveled" : 29.1383
}, 
{ 
"stop_id" : 102,
"arrival_time" : "13:14:35" , 
"departure_time" : "13:15:04" , 
"distance_traveled" : 30.283
}, 
{ 
"stop_id" : 44,
"arrival_time" : "13:16:29" , 
"departure_time" : "13:17:24" , 
"distance_traveled" : 31.5343
}, 
{ 
"stop_id" : 155,
"arrival_time" : "13:21:55" , 
"departure_time" : "13:23:01" , 
"distance_traveled" : 33.6229
}, 
{ 
"stop_id" : 47,
"arrival_time" : "13:25:06" , 
"departure_time" : "13:26:33" , 
"distance_traveled" : 34.8381
}, 
{ 
"stop_id" : 32,
"arrival_time" : "13:29:27" , 
"departure_time" : "13:30:22" , 
"distance_traveled" : 36.0038
}, 
{ 
"stop_id" : 31,
"arrival_time" : "13:33:55" , 
"departure_time" : "13:34:53" , 
"distance_traveled" : 38.1716
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "13:38:58" , 
"departure_time" : "13:39:07" , 
"distance_traveled" : 40.0235
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:49:09" , 
"departure_time" : "13:49:21" , 
"distance_traveled" : 45.2807
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:58:12" , 
"departure_time" : "13:59:02" , 
"distance_traveled" : 50.3496
}, 
{ 
"stop_id" : 105,
"arrival_time" : "14:13:50" , 
"departure_time" : "14:13:50" , 
"distance_traveled" : 55.3377
} ], 
"4692" :  [ 
{ 
"stop_id" : 60,
"arrival_time" : "16:52:00" , 
"departure_time" : "16:54:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6,
"arrival_time" : "16:57:33" , 
"departure_time" : "16:57:51" , 
"distance_traveled" : 1.7983
}, 
{ 
"stop_id" : 68,
"arrival_time" : "17:00:18" , 
"departure_time" : "17:01:58" , 
"distance_traveled" : 4.1822
}, 
{ 
"stop_id" : 157,
"arrival_time" : "17:07:40" , 
"departure_time" : "17:08:50" , 
"distance_traveled" : 7.9657
}, 
{ 
"stop_id" : 108,
"arrival_time" : "17:14:10" , 
"departure_time" : "17:14:35" , 
"distance_traveled" : 12.8652
}, 
{ 
"stop_id" : 129,
"arrival_time" : "17:21:25" , 
"departure_time" : "17:22:03" , 
"distance_traveled" : 16.342
}, 
{ 
"stop_id" : 138,
"arrival_time" : "17:24:38" , 
"departure_time" : "17:25:20" , 
"distance_traveled" : 17.5091
}, 
{ 
"stop_id" : 24,
"arrival_time" : "17:29:42" , 
"departure_time" : "17:31:20" , 
"distance_traveled" : 20.8453
}, 
{ 
"stop_id" : 21,
"arrival_time" : "17:33:38" , 
"departure_time" : "17:35:17" , 
"distance_traveled" : 21.9566
}, 
{ 
"stop_id" : 36,
"arrival_time" : "17:40:39" , 
"departure_time" : "17:42:09" , 
"distance_traveled" : 26.1983
}, 
{ 
"stop_id" : 120,
"arrival_time" : "17:45:30" , 
"departure_time" : "17:45:59" , 
"distance_traveled" : 29.1383
}, 
{ 
"stop_id" : 102,
"arrival_time" : "17:47:29" , 
"departure_time" : "17:49:03" , 
"distance_traveled" : 30.283
}, 
{ 
"stop_id" : 44,
"arrival_time" : "17:51:34" , 
"departure_time" : "17:51:44" , 
"distance_traveled" : 31.5343
}, 
{ 
"stop_id" : 155,
"arrival_time" : "17:54:10" , 
"departure_time" : "17:54:52" , 
"distance_traveled" : 33.6229
}, 
{ 
"stop_id" : 47,
"arrival_time" : "17:58:42" , 
"departure_time" : "17:59:52" , 
"distance_traveled" : 34.8381
}, 
{ 
"stop_id" : 32,
"arrival_time" : "18:02:10" , 
"departure_time" : "18:02:17" , 
"distance_traveled" : 36.0038
}, 
{ 
"stop_id" : 31,
"arrival_time" : "18:06:07" , 
"departure_time" : "18:06:25" , 
"distance_traveled" : 38.1716
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "18:10:18" , 
"departure_time" : "18:10:27" , 
"distance_traveled" : 40.0235
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:20:09" , 
"departure_time" : "18:20:09" , 
"distance_traveled" : 45.2807
} ], 
"4693" :  [ 
{ 
"stop_id" : 120,
"arrival_time" : "08:32:00" , 
"departure_time" : "08:33:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 102,
"arrival_time" : "08:35:59" , 
"departure_time" : "08:36:28" , 
"distance_traveled" : 1.1449
}, 
{ 
"stop_id" : 44,
"arrival_time" : "08:38:29" , 
"departure_time" : "08:40:03" , 
"distance_traveled" : 2.3962
}, 
{ 
"stop_id" : 155,
"arrival_time" : "08:44:34" , 
"departure_time" : "08:45:08" , 
"distance_traveled" : 4.4848
}, 
{ 
"stop_id" : 32,
"arrival_time" : "08:48:34" , 
"departure_time" : "08:48:51" , 
"distance_traveled" : 9.1169
}, 
{ 
"stop_id" : 31,
"arrival_time" : "08:53:17" , 
"departure_time" : "08:54:57" , 
"distance_traveled" : 11.2667
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "08:59:40" , 
"departure_time" : "09:00:36" , 
"distance_traveled" : 13.1186
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:09:56" , 
"departure_time" : "09:09:56" , 
"distance_traveled" : 18.3758
} ], 
"4694" :  [ 
{ 
"stop_id" : 60,
"arrival_time" : "12:18:00" , 
"departure_time" : "12:19:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6,
"arrival_time" : "12:23:02" , 
"departure_time" : "12:23:10" , 
"distance_traveled" : 1.7983
}, 
{ 
"stop_id" : 68,
"arrival_time" : "12:26:08" , 
"departure_time" : "12:26:41" , 
"distance_traveled" : 4.1822
}, 
{ 
"stop_id" : 157,
"arrival_time" : "12:32:33" , 
"departure_time" : "12:33:50" , 
"distance_traveled" : 7.9657
}, 
{ 
"stop_id" : 108,
"arrival_time" : "12:40:17" , 
"departure_time" : "12:41:12" , 
"distance_traveled" : 12.8652
}, 
{ 
"stop_id" : 129,
"arrival_time" : "12:48:55" , 
"departure_time" : "12:48:56" , 
"distance_traveled" : 16.342
}, 
{ 
"stop_id" : 138,
"arrival_time" : "12:51:01" , 
"departure_time" : "12:52:06" , 
"distance_traveled" : 17.5091
}, 
{ 
"stop_id" : 24,
"arrival_time" : "12:57:05" , 
"departure_time" : "12:57:38" , 
"distance_traveled" : 20.8453
}, 
{ 
"stop_id" : 21,
"arrival_time" : "12:59:33" , 
"departure_time" : "13:00:47" , 
"distance_traveled" : 21.9566
}, 
{ 
"stop_id" : 36,
"arrival_time" : "13:06:14" , 
"departure_time" : "13:06:52" , 
"distance_traveled" : 26.1983
}, 
{ 
"stop_id" : 120,
"arrival_time" : "13:10:38" , 
"departure_time" : "13:12:03" , 
"distance_traveled" : 29.1383
}, 
{ 
"stop_id" : 102,
"arrival_time" : "13:14:25" , 
"departure_time" : "13:14:53" , 
"distance_traveled" : 30.283
}, 
{ 
"stop_id" : 44,
"arrival_time" : "13:16:28" , 
"departure_time" : "13:16:59" , 
"distance_traveled" : 31.5343
}, 
{ 
"stop_id" : 155,
"arrival_time" : "13:21:31" , 
"departure_time" : "13:22:31" , 
"distance_traveled" : 33.6229
}, 
{ 
"stop_id" : 47,
"arrival_time" : "13:25:00" , 
"departure_time" : "13:26:26" , 
"distance_traveled" : 34.8381
}, 
{ 
"stop_id" : 32,
"arrival_time" : "13:29:26" , 
"departure_time" : "13:30:57" , 
"distance_traveled" : 36.0038
}, 
{ 
"stop_id" : 31,
"arrival_time" : "13:34:31" , 
"departure_time" : "13:34:51" , 
"distance_traveled" : 38.1716
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "13:38:20" , 
"departure_time" : "13:39:32" , 
"distance_traveled" : 40.0235
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:50:12" , 
"departure_time" : "13:50:49" , 
"distance_traveled" : 45.2807
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:58:37" , 
"departure_time" : "13:59:05" , 
"distance_traveled" : 50.3496
}, 
{ 
"stop_id" : 105,
"arrival_time" : "14:13:28" , 
"departure_time" : "14:13:28" , 
"distance_traveled" : 55.3377
} ], 
"4695" :  [ 
{ 
"stop_id" : 120,
"arrival_time" : "08:32:00" , 
"departure_time" : "08:34:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 102,
"arrival_time" : "08:36:38" , 
"departure_time" : "08:37:42" , 
"distance_traveled" : 1.1449
}, 
{ 
"stop_id" : 44,
"arrival_time" : "08:39:04" , 
"departure_time" : "08:40:20" , 
"distance_traveled" : 2.3962
}, 
{ 
"stop_id" : 155,
"arrival_time" : "08:44:16" , 
"departure_time" : "08:44:27" , 
"distance_traveled" : 4.4848
}, 
{ 
"stop_id" : 32,
"arrival_time" : "08:48:11" , 
"departure_time" : "08:48:23" , 
"distance_traveled" : 9.1169
}, 
{ 
"stop_id" : 31,
"arrival_time" : "08:53:12" , 
"departure_time" : "08:53:16" , 
"distance_traveled" : 11.2667
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "08:58:04" , 
"departure_time" : "08:59:24" , 
"distance_traveled" : 13.1186
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:10:20" , 
"departure_time" : "09:10:20" , 
"distance_traveled" : 18.3758
} ], 
"4696" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "06:41:00" , 
"departure_time" : "06:43:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "06:45:32" , 
"departure_time" : "06:46:59" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "06:49:27" , 
"departure_time" : "06:49:48" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "06:50:21" , 
"departure_time" : "06:51:05" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "06:56:44" , 
"departure_time" : "06:57:46" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "07:02:02" , 
"departure_time" : "07:02:50" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "07:06:48" , 
"departure_time" : "07:08:17" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "07:10:29" , 
"departure_time" : "07:11:17" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "07:14:48" , 
"departure_time" : "07:15:12" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 32,
"arrival_time" : "07:18:24" , 
"departure_time" : "07:19:17" , 
"distance_traveled" : 21.9134
}, 
{ 
"stop_id" : 31,
"arrival_time" : "07:23:53" , 
"departure_time" : "07:24:16" , 
"distance_traveled" : 24.0633
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "07:27:23" , 
"departure_time" : "07:28:49" , 
"distance_traveled" : 25.9152
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:40:26" , 
"departure_time" : "07:40:26" , 
"distance_traveled" : 31.1723
} ], 
"4697" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "05:04:00" , 
"departure_time" : "05:06:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "05:08:12" , 
"departure_time" : "05:08:27" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "05:11:15" , 
"departure_time" : "05:11:34" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "05:14:19" , 
"departure_time" : "05:14:46" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "05:20:27" , 
"departure_time" : "05:21:18" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "05:25:51" , 
"departure_time" : "05:27:25" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "05:29:34" , 
"departure_time" : "05:30:11" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "05:32:37" , 
"departure_time" : "05:32:50" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "05:37:13" , 
"departure_time" : "05:37:35" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "05:40:22" , 
"departure_time" : "05:40:29" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "05:44:07" , 
"departure_time" : "05:45:34" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "05:50:27" , 
"departure_time" : "05:51:20" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "05:53:53" , 
"departure_time" : "05:55:11" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "06:06:18" , 
"departure_time" : "06:06:18" , 
"distance_traveled" : 28.9392
} ], 
"4698" :  [ 
{ 
"stop_id" : 60,
"arrival_time" : "05:45:00" , 
"departure_time" : "05:47:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6,
"arrival_time" : "05:50:31" , 
"departure_time" : "05:51:25" , 
"distance_traveled" : 1.7983
}, 
{ 
"stop_id" : 68,
"arrival_time" : "05:53:54" , 
"departure_time" : "05:54:37" , 
"distance_traveled" : 4.1822
}, 
{ 
"stop_id" : 157,
"arrival_time" : "05:59:43" , 
"departure_time" : "06:00:56" , 
"distance_traveled" : 7.9657
}, 
{ 
"stop_id" : 108,
"arrival_time" : "06:07:13" , 
"departure_time" : "06:07:19" , 
"distance_traveled" : 12.8652
}, 
{ 
"stop_id" : 129,
"arrival_time" : "06:14:06" , 
"departure_time" : "06:15:37" , 
"distance_traveled" : 16.342
}, 
{ 
"stop_id" : 138,
"arrival_time" : "06:18:31" , 
"departure_time" : "06:19:16" , 
"distance_traveled" : 17.5091
}, 
{ 
"stop_id" : 24,
"arrival_time" : "06:21:45" , 
"departure_time" : "06:22:43" , 
"distance_traveled" : 20.8453
}, 
{ 
"stop_id" : 21,
"arrival_time" : "06:24:58" , 
"departure_time" : "06:25:56" , 
"distance_traveled" : 21.9566
}, 
{ 
"stop_id" : 36,
"arrival_time" : "06:30:58" , 
"departure_time" : "06:31:11" , 
"distance_traveled" : 26.1983
}, 
{ 
"stop_id" : 120,
"arrival_time" : "06:35:13" , 
"departure_time" : "06:35:14" , 
"distance_traveled" : 29.1383
}, 
{ 
"stop_id" : 102,
"arrival_time" : "06:38:01" , 
"departure_time" : "06:39:33" , 
"distance_traveled" : 30.283
}, 
{ 
"stop_id" : 44,
"arrival_time" : "06:43:32" , 
"departure_time" : "06:43:35" , 
"distance_traveled" : 31.5343
}, 
{ 
"stop_id" : 155,
"arrival_time" : "06:47:03" , 
"departure_time" : "06:47:19" , 
"distance_traveled" : 33.6229
}, 
{ 
"stop_id" : 47,
"arrival_time" : "06:50:16" , 
"departure_time" : "06:51:37" , 
"distance_traveled" : 34.8381
}, 
{ 
"stop_id" : 32,
"arrival_time" : "06:55:21" , 
"departure_time" : "06:56:24" , 
"distance_traveled" : 36.0038
}, 
{ 
"stop_id" : 31,
"arrival_time" : "07:00:03" , 
"departure_time" : "07:01:42" , 
"distance_traveled" : 38.1716
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "07:04:39" , 
"departure_time" : "07:05:52" , 
"distance_traveled" : 40.0235
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:16:13" , 
"departure_time" : "07:16:13" , 
"distance_traveled" : 45.2807
} ], 
"4699" :  [ 
{ 
"stop_id" : 60,
"arrival_time" : "06:45:00" , 
"departure_time" : "06:47:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 6,
"arrival_time" : "06:50:08" , 
"departure_time" : "06:51:38" , 
"distance_traveled" : 1.7983
}, 
{ 
"stop_id" : 68,
"arrival_time" : "06:54:30" , 
"departure_time" : "06:54:55" , 
"distance_traveled" : 4.1822
}, 
{ 
"stop_id" : 157,
"arrival_time" : "06:59:25" , 
"departure_time" : "07:00:26" , 
"distance_traveled" : 7.9657
}, 
{ 
"stop_id" : 108,
"arrival_time" : "07:07:01" , 
"departure_time" : "07:07:59" , 
"distance_traveled" : 12.8652
}, 
{ 
"stop_id" : 129,
"arrival_time" : "07:14:58" , 
"departure_time" : "07:15:57" , 
"distance_traveled" : 16.342
}, 
{ 
"stop_id" : 138,
"arrival_time" : "07:17:59" , 
"departure_time" : "07:18:11" , 
"distance_traveled" : 17.5091
}, 
{ 
"stop_id" : 24,
"arrival_time" : "07:21:12" , 
"departure_time" : "07:21:51" , 
"distance_traveled" : 20.8453
}, 
{ 
"stop_id" : 21,
"arrival_time" : "07:24:39" , 
"departure_time" : "07:25:57" , 
"distance_traveled" : 21.9566
}, 
{ 
"stop_id" : 36,
"arrival_time" : "07:31:18" , 
"departure_time" : "07:31:38" , 
"distance_traveled" : 26.1983
}, 
{ 
"stop_id" : 120,
"arrival_time" : "07:35:20" , 
"departure_time" : "07:36:22" , 
"distance_traveled" : 29.1383
}, 
{ 
"stop_id" : 102,
"arrival_time" : "07:39:02" , 
"departure_time" : "07:40:06" , 
"distance_traveled" : 30.283
}, 
{ 
"stop_id" : 44,
"arrival_time" : "07:43:04" , 
"departure_time" : "07:44:42" , 
"distance_traveled" : 31.5343
}, 
{ 
"stop_id" : 155,
"arrival_time" : "07:48:38" , 
"departure_time" : "07:49:37" , 
"distance_traveled" : 33.6229
}, 
{ 
"stop_id" : 47,
"arrival_time" : "07:50:59" , 
"departure_time" : "07:52:31" , 
"distance_traveled" : 34.8381
}, 
{ 
"stop_id" : 32,
"arrival_time" : "07:55:32" , 
"departure_time" : "07:56:43" , 
"distance_traveled" : 36.0038
}, 
{ 
"stop_id" : 31,
"arrival_time" : "08:00:11" , 
"departure_time" : "08:00:21" , 
"distance_traveled" : 38.1716
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "08:03:10" , 
"departure_time" : "08:03:19" , 
"distance_traveled" : 40.0235
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:15:09" , 
"departure_time" : "08:15:09" , 
"distance_traveled" : 45.2807
} ], 
"4700" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "06:14:00" , 
"departure_time" : "06:14:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "06:17:26" , 
"departure_time" : "06:18:11" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "06:21:45" , 
"departure_time" : "06:22:18" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "06:24:33" , 
"departure_time" : "06:26:12" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "06:31:39" , 
"departure_time" : "06:32:35" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "06:35:56" , 
"departure_time" : "06:36:09" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "06:38:13" , 
"departure_time" : "06:39:33" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "06:43:20" , 
"departure_time" : "06:44:44" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "06:48:24" , 
"departure_time" : "06:48:52" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "06:50:28" , 
"departure_time" : "06:51:45" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "06:55:17" , 
"departure_time" : "06:56:29" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "07:00:12" , 
"departure_time" : "07:00:45" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "07:03:33" , 
"departure_time" : "07:04:42" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "07:16:09" , 
"departure_time" : "07:16:09" , 
"distance_traveled" : 28.9392
} ], 
"4701" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "07:14:00" , 
"departure_time" : "07:15:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "07:17:21" , 
"departure_time" : "07:18:54" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "07:22:33" , 
"departure_time" : "07:23:14" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "07:24:41" , 
"departure_time" : "07:25:56" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "07:31:15" , 
"departure_time" : "07:32:12" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "07:35:57" , 
"departure_time" : "07:36:18" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "07:38:21" , 
"departure_time" : "07:39:27" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "07:43:06" , 
"departure_time" : "07:43:49" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "07:47:43" , 
"departure_time" : "07:47:50" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "07:50:07" , 
"departure_time" : "07:50:34" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "07:54:27" , 
"departure_time" : "07:55:14" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "07:59:47" , 
"departure_time" : "08:00:35" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "08:03:48" , 
"departure_time" : "08:04:35" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "08:15:47" , 
"departure_time" : "08:15:47" , 
"distance_traveled" : 28.9392
} ], 
"4702" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "08:14:00" , 
"departure_time" : "08:16:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "08:18:22" , 
"departure_time" : "08:18:26" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "08:21:04" , 
"departure_time" : "08:21:49" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "08:24:45" , 
"departure_time" : "08:25:15" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "08:30:30" , 
"departure_time" : "08:30:56" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "08:35:26" , 
"departure_time" : "08:36:10" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "08:38:44" , 
"departure_time" : "08:39:05" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "08:42:21" , 
"departure_time" : "08:43:39" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "08:48:18" , 
"departure_time" : "08:49:53" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "08:51:35" , 
"departure_time" : "08:51:39" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "08:54:04" , 
"departure_time" : "08:55:29" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "09:00:25" , 
"departure_time" : "09:01:25" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "09:04:00" , 
"departure_time" : "09:04:34" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "09:15:34" , 
"departure_time" : "09:15:34" , 
"distance_traveled" : 28.9392
} ], 
"4703" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "09:14:00" , 
"departure_time" : "09:15:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "09:18:07" , 
"departure_time" : "09:18:59" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "09:21:52" , 
"departure_time" : "09:22:59" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "09:25:07" , 
"departure_time" : "09:25:30" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "09:30:23" , 
"departure_time" : "09:30:48" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "09:35:25" , 
"departure_time" : "09:35:45" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "09:38:20" , 
"departure_time" : "09:39:14" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "09:42:54" , 
"departure_time" : "09:43:55" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "09:48:01" , 
"departure_time" : "09:48:44" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "09:50:43" , 
"departure_time" : "09:52:06" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "09:55:23" , 
"departure_time" : "09:56:37" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "10:00:14" , 
"departure_time" : "10:01:21" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "10:04:07" , 
"departure_time" : "10:04:16" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "10:15:09" , 
"departure_time" : "10:15:09" , 
"distance_traveled" : 28.9392
} ], 
"4704" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "10:14:00" , 
"departure_time" : "10:15:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "10:18:03" , 
"departure_time" : "10:19:17" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "10:22:14" , 
"departure_time" : "10:23:09" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "10:24:55" , 
"departure_time" : "10:25:04" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "10:30:09" , 
"departure_time" : "10:31:43" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "10:36:34" , 
"departure_time" : "10:37:36" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "10:39:02" , 
"departure_time" : "10:40:29" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "10:43:27" , 
"departure_time" : "10:44:12" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "10:47:45" , 
"departure_time" : "10:48:10" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "10:50:25" , 
"departure_time" : "10:50:28" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "10:54:03" , 
"departure_time" : "10:54:56" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "10:59:53" , 
"departure_time" : "11:00:35" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "11:03:42" , 
"departure_time" : "11:05:06" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:16:24" , 
"departure_time" : "11:16:24" , 
"distance_traveled" : 28.9392
} ], 
"4705" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "11:14:00" , 
"departure_time" : "11:16:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "11:17:54" , 
"departure_time" : "11:18:06" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "11:21:12" , 
"departure_time" : "11:22:45" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "11:25:33" , 
"departure_time" : "11:25:43" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "11:30:10" , 
"departure_time" : "11:30:12" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "11:35:02" , 
"departure_time" : "11:35:12" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "11:38:10" , 
"departure_time" : "11:39:14" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "11:43:04" , 
"departure_time" : "11:43:20" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "11:47:16" , 
"departure_time" : "11:48:48" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "11:51:32" , 
"departure_time" : "11:53:07" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "11:55:35" , 
"departure_time" : "11:56:26" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "11:59:51" , 
"departure_time" : "12:01:03" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "12:04:12" , 
"departure_time" : "12:04:18" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:15:06" , 
"departure_time" : "12:15:06" , 
"distance_traveled" : 28.9392
} ], 
"4706" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "12:14:00" , 
"departure_time" : "12:14:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "12:17:33" , 
"departure_time" : "12:17:57" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "12:21:24" , 
"departure_time" : "12:21:47" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "12:24:23" , 
"departure_time" : "12:25:25" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "12:31:02" , 
"departure_time" : "12:31:28" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "12:35:26" , 
"departure_time" : "12:35:44" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "12:38:18" , 
"departure_time" : "12:39:33" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "12:43:15" , 
"departure_time" : "12:44:54" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "12:48:39" , 
"departure_time" : "12:50:10" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "12:51:31" , 
"departure_time" : "12:52:47" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "12:55:16" , 
"departure_time" : "12:56:50" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "13:00:34" , 
"departure_time" : "13:01:16" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "13:03:42" , 
"departure_time" : "13:05:15" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:16:33" , 
"departure_time" : "13:16:33" , 
"distance_traveled" : 28.9392
} ], 
"4707" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "13:14:00" , 
"departure_time" : "13:16:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "13:18:11" , 
"departure_time" : "13:18:40" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "13:21:29" , 
"departure_time" : "13:21:49" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "13:24:20" , 
"departure_time" : "13:25:37" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "13:31:17" , 
"departure_time" : "13:31:18" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "13:35:01" , 
"departure_time" : "13:35:22" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "13:38:21" , 
"departure_time" : "13:39:55" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "13:43:34" , 
"departure_time" : "13:44:46" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "13:48:12" , 
"departure_time" : "13:48:27" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "13:50:15" , 
"departure_time" : "13:51:44" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "13:55:29" , 
"departure_time" : "13:55:36" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "13:59:07" , 
"departure_time" : "14:00:16" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "14:04:09" , 
"departure_time" : "14:04:23" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:15:14" , 
"departure_time" : "14:15:14" , 
"distance_traveled" : 28.9392
} ], 
"4708" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "14:14:00" , 
"departure_time" : "14:14:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "14:17:23" , 
"departure_time" : "14:17:24" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "14:21:01" , 
"departure_time" : "14:22:17" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "14:25:16" , 
"departure_time" : "14:26:10" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "14:30:54" , 
"departure_time" : "14:32:01" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "14:36:07" , 
"departure_time" : "14:37:41" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "14:39:34" , 
"departure_time" : "14:40:37" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "14:43:03" , 
"departure_time" : "14:44:26" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "14:48:23" , 
"departure_time" : "14:49:43" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "14:51:20" , 
"departure_time" : "14:52:36" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "14:55:16" , 
"departure_time" : "14:56:37" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "15:00:21" , 
"departure_time" : "15:01:12" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "15:03:51" , 
"departure_time" : "15:05:26" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:16:35" , 
"departure_time" : "15:16:35" , 
"distance_traveled" : 28.9392
} ], 
"4709" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "15:14:00" , 
"departure_time" : "15:16:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "15:18:15" , 
"departure_time" : "15:19:33" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "15:22:18" , 
"departure_time" : "15:23:29" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "15:25:11" , 
"departure_time" : "15:25:40" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "15:30:29" , 
"departure_time" : "15:31:09" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "15:35:40" , 
"departure_time" : "15:35:47" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "15:38:07" , 
"departure_time" : "15:39:20" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "15:43:13" , 
"departure_time" : "15:44:10" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "15:47:57" , 
"departure_time" : "15:49:34" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "15:51:37" , 
"departure_time" : "15:52:03" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "15:54:26" , 
"departure_time" : "15:55:56" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "16:00:30" , 
"departure_time" : "16:01:36" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "16:04:06" , 
"departure_time" : "16:04:19" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "16:15:13" , 
"departure_time" : "16:15:13" , 
"distance_traveled" : 28.9392
} ], 
"4710" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "16:14:00" , 
"departure_time" : "16:15:03" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "16:17:50" , 
"departure_time" : "16:18:13" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "16:21:23" , 
"departure_time" : "16:21:26" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "16:24:03" , 
"departure_time" : "16:24:15" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "16:30:12" , 
"departure_time" : "16:31:40" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "16:36:28" , 
"departure_time" : "16:37:47" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "16:39:19" , 
"departure_time" : "16:39:56" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "16:42:37" , 
"departure_time" : "16:43:41" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "16:48:04" , 
"departure_time" : "16:48:25" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "16:50:21" , 
"departure_time" : "16:51:59" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "16:55:38" , 
"departure_time" : "16:56:33" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "16:59:55" , 
"departure_time" : "17:01:21" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "17:04:26" , 
"departure_time" : "17:06:01" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "17:16:35" , 
"departure_time" : "17:16:35" , 
"distance_traveled" : 28.9392
} ], 
"4711" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "17:14:00" , 
"departure_time" : "17:16:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "17:17:49" , 
"departure_time" : "17:18:06" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "17:21:17" , 
"departure_time" : "17:21:55" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "17:24:38" , 
"departure_time" : "17:24:42" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "17:30:04" , 
"departure_time" : "17:30:17" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "17:35:13" , 
"departure_time" : "17:36:05" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "17:38:52" , 
"departure_time" : "17:40:19" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "17:43:27" , 
"departure_time" : "17:44:23" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "17:47:56" , 
"departure_time" : "17:47:59" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "17:50:03" , 
"departure_time" : "17:51:24" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "17:55:21" , 
"departure_time" : "17:56:53" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "18:00:32" , 
"departure_time" : "18:02:03" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "18:04:31" , 
"departure_time" : "18:04:39" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "18:15:08" , 
"departure_time" : "18:15:08" , 
"distance_traveled" : 28.9392
} ], 
"4712" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "18:14:00" , 
"departure_time" : "18:15:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "18:18:40" , 
"departure_time" : "18:20:20" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "18:22:40" , 
"departure_time" : "18:23:44" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "18:25:04" , 
"departure_time" : "18:26:43" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "18:31:39" , 
"departure_time" : "18:32:01" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "18:35:22" , 
"departure_time" : "18:35:49" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "18:38:27" , 
"departure_time" : "18:40:05" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "18:43:38" , 
"departure_time" : "18:45:11" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "18:48:33" , 
"departure_time" : "18:49:34" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "18:51:01" , 
"departure_time" : "18:52:29" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "18:55:28" , 
"departure_time" : "18:57:06" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "19:00:38" , 
"departure_time" : "19:01:11" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "19:03:33" , 
"departure_time" : "19:04:30" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "19:15:57" , 
"departure_time" : "19:15:57" , 
"distance_traveled" : 28.9392
} ], 
"4713" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "19:14:00" , 
"departure_time" : "19:15:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "19:17:52" , 
"departure_time" : "19:18:18" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "19:21:26" , 
"departure_time" : "19:21:30" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "19:24:04" , 
"departure_time" : "19:24:32" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "19:30:28" , 
"departure_time" : "19:30:49" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "19:35:21" , 
"departure_time" : "19:36:42" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "19:39:21" , 
"departure_time" : "19:40:35" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "19:43:14" , 
"departure_time" : "19:43:38" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "19:47:24" , 
"departure_time" : "19:48:39" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "19:51:15" , 
"departure_time" : "19:51:48" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "19:54:33" , 
"departure_time" : "19:55:54" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "20:00:21" , 
"departure_time" : "20:00:46" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "20:03:25" , 
"departure_time" : "20:04:52" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "20:16:27" , 
"departure_time" : "20:16:27" , 
"distance_traveled" : 28.9392
} ], 
"4714" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "20:14:00" , 
"departure_time" : "20:15:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "20:17:01" , 
"departure_time" : "20:17:40" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "20:21:39" , 
"departure_time" : "20:22:17" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "20:24:38" , 
"departure_time" : "20:25:12" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "20:30:34" , 
"departure_time" : "20:32:13" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "20:36:39" , 
"departure_time" : "20:37:03" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "20:38:24" , 
"departure_time" : "20:39:43" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "20:43:19" , 
"departure_time" : "20:44:45" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "20:48:26" , 
"departure_time" : "20:48:55" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "20:50:29" , 
"departure_time" : "20:51:57" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "20:55:28" , 
"departure_time" : "20:56:19" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "20:59:51" , 
"departure_time" : "21:01:19" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "21:04:28" , 
"departure_time" : "21:04:44" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:15:16" , 
"departure_time" : "21:15:16" , 
"distance_traveled" : 28.9392
} ], 
"4715" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "21:14:00" , 
"departure_time" : "21:15:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "21:17:54" , 
"departure_time" : "21:18:07" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "21:21:13" , 
"departure_time" : "21:21:19" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "21:24:06" , 
"departure_time" : "21:25:34" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "21:31:28" , 
"departure_time" : "21:32:09" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "21:35:41" , 
"departure_time" : "21:35:54" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "21:38:13" , 
"departure_time" : "21:39:41" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "21:43:28" , 
"departure_time" : "21:44:23" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "21:47:55" , 
"departure_time" : "21:48:02" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "21:50:07" , 
"departure_time" : "21:51:38" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "21:55:31" , 
"departure_time" : "21:56:30" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "21:59:59" , 
"departure_time" : "22:01:03" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "22:04:04" , 
"departure_time" : "22:04:35" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:15:31" , 
"departure_time" : "22:15:31" , 
"distance_traveled" : 28.9392
} ], 
"4716" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "22:14:00" , 
"departure_time" : "22:15:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "22:17:42" , 
"departure_time" : "22:17:45" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "22:21:03" , 
"departure_time" : "22:22:07" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "22:25:04" , 
"departure_time" : "22:26:43" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "22:31:39" , 
"departure_time" : "22:32:38" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "22:35:59" , 
"departure_time" : "22:37:23" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "22:39:24" , 
"departure_time" : "22:41:01" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "22:43:37" , 
"departure_time" : "22:45:16" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "22:48:39" , 
"departure_time" : "22:49:30" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "22:50:51" , 
"departure_time" : "22:51:54" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "22:55:03" , 
"departure_time" : "22:55:47" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "22:59:44" , 
"departure_time" : "22:59:46" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "23:03:02" , 
"departure_time" : "23:04:21" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "23:16:19" , 
"departure_time" : "23:16:19" , 
"distance_traveled" : 28.9392
} ], 
"4717" :  [ 
{ 
"stop_id" : 129,
"arrival_time" : "23:36:00" , 
"departure_time" : "23:38:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 138,
"arrival_time" : "23:39:41" , 
"departure_time" : "23:40:43" , 
"distance_traveled" : 1.1676
}, 
{ 
"stop_id" : 24,
"arrival_time" : "23:44:02" , 
"departure_time" : "23:45:38" , 
"distance_traveled" : 4.5038
}, 
{ 
"stop_id" : 21,
"arrival_time" : "23:47:36" , 
"departure_time" : "23:48:37" , 
"distance_traveled" : 5.6152
}, 
{ 
"stop_id" : 36,
"arrival_time" : "23:53:01" , 
"departure_time" : "23:54:19" , 
"distance_traveled" : 9.8568
}, 
{ 
"stop_id" : 120,
"arrival_time" : "23:58:18" , 
"departure_time" : "23:58:57" , 
"distance_traveled" : 12.7968
}, 
{ 
"stop_id" : 102,
"arrival_time" : "24:00:39" , 
"departure_time" : "24:01:18" , 
"distance_traveled" : 13.9415
}, 
{ 
"stop_id" : 44,
"arrival_time" : "24:03:39" , 
"departure_time" : "24:04:40" , 
"distance_traveled" : 15.1928
}, 
{ 
"stop_id" : 155,
"arrival_time" : "24:09:01" , 
"departure_time" : "24:09:32" , 
"distance_traveled" : 17.2814
}, 
{ 
"stop_id" : 47,
"arrival_time" : "24:11:31" , 
"departure_time" : "24:12:20" , 
"distance_traveled" : 18.4966
}, 
{ 
"stop_id" : 32,
"arrival_time" : "24:14:49" , 
"departure_time" : "24:16:14" , 
"distance_traveled" : 19.6623
}, 
{ 
"stop_id" : 31,
"arrival_time" : "24:21:25" , 
"departure_time" : "24:23:04" , 
"distance_traveled" : 21.8301
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "24:25:39" , 
"departure_time" : "24:26:23" , 
"distance_traveled" : 23.682
}, 
{ 
"stop_id" : 107,
"arrival_time" : "24:38:44" , 
"departure_time" : "24:38:44" , 
"distance_traveled" : 28.9392
} ], 
"4718" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "24:29:00" , 
"departure_time" : "24:30:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "24:38:20" , 
"departure_time" : "24:39:22" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "24:42:02" , 
"departure_time" : "24:42:48" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "24:46:46" , 
"departure_time" : "24:47:38" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 155,
"arrival_time" : "24:50:52" , 
"departure_time" : "24:52:21" , 
"distance_traveled" : 11.6123
}, 
{ 
"stop_id" : 44,
"arrival_time" : "24:55:29" , 
"departure_time" : "24:56:25" , 
"distance_traveled" : 13.7009
}, 
{ 
"stop_id" : 102,
"arrival_time" : "24:57:56" , 
"departure_time" : "24:58:48" , 
"distance_traveled" : 14.9523
}, 
{ 
"stop_id" : 120,
"arrival_time" : "25:00:52" , 
"departure_time" : "25:01:37" , 
"distance_traveled" : 16.097
}, 
{ 
"stop_id" : 36,
"arrival_time" : "25:05:45" , 
"departure_time" : "25:07:00" , 
"distance_traveled" : 19.0369
}, 
{ 
"stop_id" : 21,
"arrival_time" : "25:11:15" , 
"departure_time" : "25:12:38" , 
"distance_traveled" : 23.2784
}, 
{ 
"stop_id" : 24,
"arrival_time" : "25:14:23" , 
"departure_time" : "25:15:25" , 
"distance_traveled" : 24.3898
}, 
{ 
"stop_id" : 138,
"arrival_time" : "25:19:02" , 
"departure_time" : "25:19:59" , 
"distance_traveled" : 27.7233
}, 
{ 
"stop_id" : 129,
"arrival_time" : "25:28:57" , 
"departure_time" : "25:28:57" , 
"distance_traveled" : 28.8871
} ], 
"4719" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "24:29:00" , 
"departure_time" : "24:30:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "24:38:03" , 
"departure_time" : "24:38:20" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "24:41:17" , 
"departure_time" : "24:41:51" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "24:46:34" , 
"departure_time" : "24:47:55" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 155,
"arrival_time" : "24:51:21" , 
"departure_time" : "24:52:30" , 
"distance_traveled" : 11.6123
}, 
{ 
"stop_id" : 44,
"arrival_time" : "24:55:09" , 
"departure_time" : "24:55:24" , 
"distance_traveled" : 13.7009
}, 
{ 
"stop_id" : 102,
"arrival_time" : "24:57:15" , 
"departure_time" : "24:58:47" , 
"distance_traveled" : 14.9523
}, 
{ 
"stop_id" : 120,
"arrival_time" : "25:01:32" , 
"departure_time" : "25:02:02" , 
"distance_traveled" : 16.097
}, 
{ 
"stop_id" : 36,
"arrival_time" : "25:05:30" , 
"departure_time" : "25:06:42" , 
"distance_traveled" : 19.0369
}, 
{ 
"stop_id" : 21,
"arrival_time" : "25:11:12" , 
"departure_time" : "25:11:59" , 
"distance_traveled" : 23.2784
}, 
{ 
"stop_id" : 24,
"arrival_time" : "25:13:47" , 
"departure_time" : "25:15:23" , 
"distance_traveled" : 24.3898
}, 
{ 
"stop_id" : 138,
"arrival_time" : "25:19:36" , 
"departure_time" : "25:20:39" , 
"distance_traveled" : 27.7233
}, 
{ 
"stop_id" : 129,
"arrival_time" : "25:29:03" , 
"departure_time" : "25:29:03" , 
"distance_traveled" : 28.8871
} ], 
"4720" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "17:13:00" , 
"departure_time" : "17:14:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "17:22:20" , 
"departure_time" : "17:22:38" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "17:25:18" , 
"departure_time" : "17:26:35" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "17:31:17" , 
"departure_time" : "17:32:20" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 155,
"arrival_time" : "17:35:03" , 
"departure_time" : "17:36:33" , 
"distance_traveled" : 11.6123
}, 
{ 
"stop_id" : 44,
"arrival_time" : "17:39:30" , 
"departure_time" : "17:40:52" , 
"distance_traveled" : 13.7009
}, 
{ 
"stop_id" : 102,
"arrival_time" : "17:42:22" , 
"departure_time" : "17:43:27" , 
"distance_traveled" : 14.9523
}, 
{ 
"stop_id" : 120,
"arrival_time" : "17:47:05" , 
"departure_time" : "17:48:13" , 
"distance_traveled" : 16.097
}, 
{ 
"stop_id" : 36,
"arrival_time" : "17:52:08" , 
"departure_time" : "17:53:45" , 
"distance_traveled" : 19.0369
}, 
{ 
"stop_id" : 21,
"arrival_time" : "17:58:37" , 
"departure_time" : "17:58:48" , 
"distance_traveled" : 23.2784
}, 
{ 
"stop_id" : 24,
"arrival_time" : "17:59:11" , 
"departure_time" : "17:59:20" , 
"distance_traveled" : 24.3898
}, 
{ 
"stop_id" : 138,
"arrival_time" : "18:04:09" , 
"departure_time" : "18:04:29" , 
"distance_traveled" : 27.7233
}, 
{ 
"stop_id" : 129,
"arrival_time" : "18:11:20" , 
"departure_time" : "18:11:20" , 
"distance_traveled" : 28.8871
} ], 
"4721" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "07:38:00" , 
"departure_time" : "07:39:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "07:47:40" , 
"departure_time" : "07:48:48" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "07:51:08" , 
"departure_time" : "07:52:24" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "07:56:16" , 
"departure_time" : "07:56:44" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "07:58:28" , 
"departure_time" : "07:59:39" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "08:02:11" , 
"departure_time" : "08:03:00" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "08:06:49" , 
"departure_time" : "08:07:30" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "08:09:41" , 
"departure_time" : "08:11:04" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "08:14:23" , 
"departure_time" : "08:15:48" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "08:19:25" , 
"departure_time" : "08:21:00" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "08:24:35" , 
"departure_time" : "08:25:44" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "08:27:09" , 
"departure_time" : "08:28:13" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "08:33:04" , 
"departure_time" : "08:34:21" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "08:43:17" , 
"departure_time" : "08:43:17" , 
"distance_traveled" : 28.9235
} ], 
"4722" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "08:38:00" , 
"departure_time" : "08:39:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "08:47:08" , 
"departure_time" : "08:48:01" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "08:50:53" , 
"departure_time" : "08:51:34" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "08:55:41" , 
"departure_time" : "08:56:19" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "08:58:38" , 
"departure_time" : "08:59:24" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "09:01:46" , 
"departure_time" : "09:03:26" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "09:07:40" , 
"departure_time" : "09:08:13" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "09:09:33" , 
"departure_time" : "09:10:44" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "09:14:11" , 
"departure_time" : "09:14:12" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "09:18:01" , 
"departure_time" : "09:19:06" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "09:24:05" , 
"departure_time" : "09:24:55" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "09:26:50" , 
"departure_time" : "09:27:46" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "09:32:56" , 
"departure_time" : "09:33:19" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "09:42:23" , 
"departure_time" : "09:42:23" , 
"distance_traveled" : 28.9235
} ], 
"4723" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "17:13:00" , 
"departure_time" : "17:13:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "17:22:03" , 
"departure_time" : "17:23:11" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "17:26:08" , 
"departure_time" : "17:26:17" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "17:30:09" , 
"departure_time" : "17:30:58" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 155,
"arrival_time" : "17:34:49" , 
"departure_time" : "17:36:06" , 
"distance_traveled" : 11.6123
}, 
{ 
"stop_id" : 44,
"arrival_time" : "17:39:17" , 
"departure_time" : "17:39:56" , 
"distance_traveled" : 13.7009
}, 
{ 
"stop_id" : 102,
"arrival_time" : "17:41:39" , 
"departure_time" : "17:41:41" , 
"distance_traveled" : 14.9523
}, 
{ 
"stop_id" : 120,
"arrival_time" : "17:46:02" , 
"departure_time" : "17:47:23" , 
"distance_traveled" : 16.097
}, 
{ 
"stop_id" : 36,
"arrival_time" : "17:52:21" , 
"departure_time" : "17:53:00" , 
"distance_traveled" : 19.0369
}, 
{ 
"stop_id" : 21,
"arrival_time" : "17:57:39" , 
"departure_time" : "17:58:22" , 
"distance_traveled" : 23.2784
}, 
{ 
"stop_id" : 24,
"arrival_time" : "17:59:43" , 
"departure_time" : "18:01:05" , 
"distance_traveled" : 24.3898
}, 
{ 
"stop_id" : 138,
"arrival_time" : "18:05:22" , 
"departure_time" : "18:06:37" , 
"distance_traveled" : 27.7233
}, 
{ 
"stop_id" : 129,
"arrival_time" : "18:12:15" , 
"departure_time" : "18:12:15" , 
"distance_traveled" : 28.8871
} ], 
"4724" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "09:38:00" , 
"departure_time" : "09:39:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "09:47:21" , 
"departure_time" : "09:48:20" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "09:50:59" , 
"departure_time" : "09:51:57" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "09:55:58" , 
"departure_time" : "09:57:19" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "09:59:21" , 
"departure_time" : "09:59:51" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "10:01:30" , 
"departure_time" : "10:02:57" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "10:07:27" , 
"departure_time" : "10:07:58" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "10:09:31" , 
"departure_time" : "10:10:42" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "10:14:11" , 
"departure_time" : "10:14:37" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "10:18:26" , 
"departure_time" : "10:19:23" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "10:23:57" , 
"departure_time" : "10:25:11" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "10:27:14" , 
"departure_time" : "10:28:01" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "10:32:47" , 
"departure_time" : "10:33:56" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "10:43:09" , 
"departure_time" : "10:43:09" , 
"distance_traveled" : 28.9235
} ], 
"4725" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "10:38:00" , 
"departure_time" : "10:40:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "10:47:51" , 
"departure_time" : "10:48:59" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "10:51:08" , 
"departure_time" : "10:51:24" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "10:55:16" , 
"departure_time" : "10:56:36" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "10:59:20" , 
"departure_time" : "11:00:55" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "11:02:35" , 
"departure_time" : "11:03:15" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "11:06:40" , 
"departure_time" : "11:08:15" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "11:10:35" , 
"departure_time" : "11:11:34" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "11:13:59" , 
"departure_time" : "11:15:30" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "11:19:31" , 
"departure_time" : "11:20:21" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "11:23:50" , 
"departure_time" : "11:24:52" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "11:27:02" , 
"departure_time" : "11:27:48" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "11:32:46" , 
"departure_time" : "11:33:07" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "11:42:21" , 
"departure_time" : "11:42:21" , 
"distance_traveled" : 28.9235
} ], 
"4726" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "11:38:00" , 
"departure_time" : "11:39:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "11:47:54" , 
"departure_time" : "11:49:13" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "11:51:19" , 
"departure_time" : "11:52:58" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "11:56:39" , 
"departure_time" : "11:57:10" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "11:58:31" , 
"departure_time" : "11:59:48" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "12:02:17" , 
"departure_time" : "12:02:43" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "12:06:26" , 
"departure_time" : "12:07:20" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "12:09:54" , 
"departure_time" : "12:09:55" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "12:13:01" , 
"departure_time" : "12:13:35" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "12:18:34" , 
"departure_time" : "12:19:02" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "12:23:28" , 
"departure_time" : "12:24:44" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "12:27:16" , 
"departure_time" : "12:28:22" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "12:33:06" , 
"departure_time" : "12:33:38" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "12:42:32" , 
"departure_time" : "12:42:32" , 
"distance_traveled" : 28.9235
} ], 
"4727" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "12:38:00" , 
"departure_time" : "12:39:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "12:47:43" , 
"departure_time" : "12:48:20" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "12:50:37" , 
"departure_time" : "12:51:03" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "12:55:26" , 
"departure_time" : "12:56:42" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "12:59:16" , 
"departure_time" : "12:59:43" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "13:01:27" , 
"departure_time" : "13:01:41" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "13:06:14" , 
"departure_time" : "13:06:36" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "13:09:22" , 
"departure_time" : "13:10:22" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "13:14:00" , 
"departure_time" : "13:15:13" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "13:19:13" , 
"departure_time" : "13:19:51" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "13:23:38" , 
"departure_time" : "13:24:51" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "13:27:13" , 
"departure_time" : "13:27:24" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "13:32:11" , 
"departure_time" : "13:33:41" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "13:43:30" , 
"departure_time" : "13:43:30" , 
"distance_traveled" : 28.9235
} ], 
"4728" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "07:38:00" , 
"departure_time" : "07:39:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "07:47:10" , 
"departure_time" : "07:48:38" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "07:51:28" , 
"departure_time" : "07:52:40" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "07:56:12" , 
"departure_time" : "07:56:52" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "07:58:40" , 
"departure_time" : "07:58:47" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "08:01:07" , 
"departure_time" : "08:01:58" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "08:06:51" , 
"departure_time" : "08:07:56" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "08:10:05" , 
"departure_time" : "08:11:20" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "08:14:15" , 
"departure_time" : "08:15:49" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "08:19:34" , 
"departure_time" : "08:20:59" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "08:24:25" , 
"departure_time" : "08:25:40" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "08:27:15" , 
"departure_time" : "08:28:08" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "08:32:53" , 
"departure_time" : "08:34:10" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "08:43:17" , 
"departure_time" : "08:43:17" , 
"distance_traveled" : 28.9235
} ], 
"4729" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "13:38:00" , 
"departure_time" : "13:39:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "13:47:26" , 
"departure_time" : "13:48:44" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "13:51:18" , 
"departure_time" : "13:52:52" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "13:56:34" , 
"departure_time" : "13:57:05" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "13:58:31" , 
"departure_time" : "13:59:51" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "14:02:20" , 
"departure_time" : "14:02:56" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "14:06:36" , 
"departure_time" : "14:08:10" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "14:10:34" , 
"departure_time" : "14:11:43" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "14:14:09" , 
"departure_time" : "14:14:37" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "14:18:28" , 
"departure_time" : "14:19:05" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "14:23:37" , 
"departure_time" : "14:24:13" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "14:26:36" , 
"departure_time" : "14:27:03" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "14:32:27" , 
"departure_time" : "14:34:01" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "14:43:34" , 
"departure_time" : "14:43:34" , 
"distance_traveled" : 28.9235
} ], 
"4730" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "08:38:00" , 
"departure_time" : "08:39:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "08:47:09" , 
"departure_time" : "08:47:42" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "08:50:33" , 
"departure_time" : "08:50:35" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "08:55:02" , 
"departure_time" : "08:55:23" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "08:58:21" , 
"departure_time" : "08:59:03" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "09:01:42" , 
"departure_time" : "09:02:04" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "09:06:22" , 
"departure_time" : "09:07:24" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "09:10:02" , 
"departure_time" : "09:10:35" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "09:13:33" , 
"departure_time" : "09:14:16" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "09:18:43" , 
"departure_time" : "09:19:53" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "09:24:10" , 
"departure_time" : "09:24:58" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "09:26:48" , 
"departure_time" : "09:28:10" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "09:33:22" , 
"departure_time" : "09:34:51" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "09:43:29" , 
"departure_time" : "09:43:29" , 
"distance_traveled" : 28.9235
} ], 
"4731" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "14:38:00" , 
"departure_time" : "14:39:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "14:47:11" , 
"departure_time" : "14:47:40" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "14:50:29" , 
"departure_time" : "14:52:04" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "14:56:35" , 
"departure_time" : "14:56:46" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "14:58:11" , 
"departure_time" : "14:58:30" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "15:01:19" , 
"departure_time" : "15:01:45" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "15:06:26" , 
"departure_time" : "15:07:00" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "15:09:34" , 
"departure_time" : "15:10:35" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "15:14:01" , 
"departure_time" : "15:15:19" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "15:19:18" , 
"departure_time" : "15:19:28" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "15:23:10" , 
"departure_time" : "15:23:55" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "15:26:45" , 
"departure_time" : "15:27:01" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "15:32:16" , 
"departure_time" : "15:33:50" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "15:43:34" , 
"departure_time" : "15:43:34" , 
"distance_traveled" : 28.9235
} ], 
"4732" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "09:38:00" , 
"departure_time" : "09:41:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "09:48:26" , 
"departure_time" : "09:48:47" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "09:50:21" , 
"departure_time" : "09:51:59" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "09:56:38" , 
"departure_time" : "09:56:55" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "09:58:17" , 
"departure_time" : "09:59:17" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "10:02:00" , 
"departure_time" : "10:03:11" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "10:07:11" , 
"departure_time" : "10:07:30" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "10:09:19" , 
"departure_time" : "10:10:26" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "10:14:07" , 
"departure_time" : "10:14:50" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "10:18:43" , 
"departure_time" : "10:19:07" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "10:23:24" , 
"departure_time" : "10:24:09" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "10:26:45" , 
"departure_time" : "10:27:35" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "10:32:50" , 
"departure_time" : "10:34:30" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "10:43:40" , 
"departure_time" : "10:43:40" , 
"distance_traveled" : 28.9235
} ], 
"4733" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "15:38:00" , 
"departure_time" : "15:40:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "15:47:58" , 
"departure_time" : "15:48:17" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "15:50:19" , 
"departure_time" : "15:51:39" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "15:56:20" , 
"departure_time" : "15:57:57" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "15:59:37" , 
"departure_time" : "16:00:11" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "16:01:34" , 
"departure_time" : "16:02:50" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "16:07:16" , 
"departure_time" : "16:07:21" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "16:09:05" , 
"departure_time" : "16:09:27" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "16:13:22" , 
"departure_time" : "16:13:50" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "16:18:28" , 
"departure_time" : "16:19:24" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "16:23:56" , 
"departure_time" : "16:24:46" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "16:26:50" , 
"departure_time" : "16:28:18" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "16:33:28" , 
"departure_time" : "16:34:11" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "16:42:43" , 
"departure_time" : "16:42:43" , 
"distance_traveled" : 28.9235
} ], 
"4734" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "10:38:00" , 
"departure_time" : "10:39:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "10:48:03" , 
"departure_time" : "10:49:09" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "10:51:06" , 
"departure_time" : "10:52:00" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "10:55:54" , 
"departure_time" : "10:57:34" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "10:59:40" , 
"departure_time" : "11:00:26" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "11:01:46" , 
"departure_time" : "11:02:19" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "11:06:33" , 
"departure_time" : "11:07:21" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "11:09:48" , 
"departure_time" : "11:10:22" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "11:13:34" , 
"departure_time" : "11:14:50" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "11:19:16" , 
"departure_time" : "11:20:47" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "11:24:31" , 
"departure_time" : "11:26:06" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "11:27:35" , 
"departure_time" : "11:28:34" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "11:32:59" , 
"departure_time" : "11:34:36" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "11:43:37" , 
"departure_time" : "11:43:37" , 
"distance_traveled" : 28.9235
} ], 
"4735" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "16:38:00" , 
"departure_time" : "16:40:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "16:47:45" , 
"departure_time" : "16:48:22" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "16:50:37" , 
"departure_time" : "16:51:02" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "16:55:25" , 
"departure_time" : "16:55:48" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "16:58:23" , 
"departure_time" : "16:59:10" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "17:01:47" , 
"departure_time" : "17:03:24" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "17:07:37" , 
"departure_time" : "17:08:03" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "17:09:26" , 
"departure_time" : "17:10:37" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "17:14:11" , 
"departure_time" : "17:15:43" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "17:19:32" , 
"departure_time" : "17:19:49" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "17:23:17" , 
"departure_time" : "17:23:46" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "17:26:29" , 
"departure_time" : "17:27:24" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "17:32:55" , 
"departure_time" : "17:33:36" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "17:42:41" , 
"departure_time" : "17:42:41" , 
"distance_traveled" : 28.9235
} ], 
"4736" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "11:38:00" , 
"departure_time" : "11:39:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "11:48:10" , 
"departure_time" : "11:49:35" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "11:51:25" , 
"departure_time" : "11:53:01" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "11:56:36" , 
"departure_time" : "11:57:33" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "11:58:57" , 
"departure_time" : "11:58:58" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "12:01:01" , 
"departure_time" : "12:02:15" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "12:07:14" , 
"departure_time" : "12:08:16" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "12:10:02" , 
"departure_time" : "12:11:00" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "12:13:58" , 
"departure_time" : "12:14:31" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "12:18:33" , 
"departure_time" : "12:18:56" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "12:23:23" , 
"departure_time" : "12:24:04" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "12:26:41" , 
"departure_time" : "12:28:04" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "12:33:23" , 
"departure_time" : "12:33:55" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "12:42:32" , 
"departure_time" : "12:42:32" , 
"distance_traveled" : 28.9235
} ], 
"4737" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "17:38:00" , 
"departure_time" : "17:38:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "17:47:02" , 
"departure_time" : "17:48:36" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "17:51:34" , 
"departure_time" : "17:51:59" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "17:55:25" , 
"departure_time" : "17:56:40" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "17:59:15" , 
"departure_time" : "18:00:28" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "18:02:13" , 
"departure_time" : "18:03:11" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "18:06:58" , 
"departure_time" : "18:08:05" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "18:10:07" , 
"departure_time" : "18:10:26" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "18:13:19" , 
"departure_time" : "18:13:53" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "18:18:34" , 
"departure_time" : "18:20:10" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "18:24:36" , 
"departure_time" : "18:24:40" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "18:26:04" , 
"departure_time" : "18:27:19" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "18:33:15" , 
"departure_time" : "18:33:22" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "18:42:07" , 
"departure_time" : "18:42:07" , 
"distance_traveled" : 28.9235
} ], 
"4738" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "12:38:00" , 
"departure_time" : "12:38:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "12:47:18" , 
"departure_time" : "12:48:17" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "12:50:59" , 
"departure_time" : "12:51:44" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "12:55:45" , 
"departure_time" : "12:57:04" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "12:59:19" , 
"departure_time" : "12:59:22" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "13:01:03" , 
"departure_time" : "13:01:36" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "13:06:33" , 
"departure_time" : "13:06:43" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "13:09:10" , 
"departure_time" : "13:09:43" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "13:13:33" , 
"departure_time" : "13:14:05" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "13:18:32" , 
"departure_time" : "13:19:42" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "13:24:10" , 
"departure_time" : "13:25:38" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "13:27:28" , 
"departure_time" : "13:27:32" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "13:32:04" , 
"departure_time" : "13:33:07" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "13:43:03" , 
"departure_time" : "13:43:03" , 
"distance_traveled" : 28.9235
} ], 
"4739" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "18:38:00" , 
"departure_time" : "18:40:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "18:48:37" , 
"departure_time" : "18:49:30" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "18:50:53" , 
"departure_time" : "18:51:02" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "18:55:09" , 
"departure_time" : "18:56:36" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "18:59:27" , 
"departure_time" : "19:00:03" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "19:01:36" , 
"departure_time" : "19:03:04" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "19:07:28" , 
"departure_time" : "19:09:01" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "19:10:33" , 
"departure_time" : "19:12:09" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "19:14:36" , 
"departure_time" : "19:14:45" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "19:18:09" , 
"departure_time" : "19:18:56" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "19:23:47" , 
"departure_time" : "19:24:23" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "19:26:36" , 
"departure_time" : "19:27:01" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "19:32:25" , 
"departure_time" : "19:33:58" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "19:43:33" , 
"departure_time" : "19:43:33" , 
"distance_traveled" : 28.9235
} ], 
"4740" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "13:38:00" , 
"departure_time" : "13:39:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "13:47:11" , 
"departure_time" : "13:48:09" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "13:50:58" , 
"departure_time" : "13:51:01" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "13:55:03" , 
"departure_time" : "13:56:18" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "13:59:15" , 
"departure_time" : "14:00:01" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "14:01:46" , 
"departure_time" : "14:02:49" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "14:07:03" , 
"departure_time" : "14:08:36" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "14:10:33" , 
"departure_time" : "14:11:26" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "14:13:53" , 
"departure_time" : "14:14:58" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "14:19:05" , 
"departure_time" : "14:19:11" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "14:23:06" , 
"departure_time" : "14:24:44" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "14:27:38" , 
"departure_time" : "14:28:19" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "14:32:41" , 
"departure_time" : "14:34:02" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "14:43:21" , 
"departure_time" : "14:43:21" , 
"distance_traveled" : 28.9235
} ], 
"4741" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "19:38:00" , 
"departure_time" : "19:40:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "19:48:27" , 
"departure_time" : "19:49:23" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "19:50:56" , 
"departure_time" : "19:52:04" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "19:56:08" , 
"departure_time" : "19:57:32" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "19:59:24" , 
"departure_time" : "19:59:46" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "20:01:22" , 
"departure_time" : "20:01:54" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "20:06:32" , 
"departure_time" : "20:07:28" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "20:09:56" , 
"departure_time" : "20:11:29" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "20:14:33" , 
"departure_time" : "20:15:54" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "20:19:21" , 
"departure_time" : "20:19:58" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "20:23:37" , 
"departure_time" : "20:24:34" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "20:26:57" , 
"departure_time" : "20:27:13" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "20:32:16" , 
"departure_time" : "20:32:57" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "20:42:41" , 
"departure_time" : "20:42:41" , 
"distance_traveled" : 28.9235
} ], 
"4742" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "14:38:00" , 
"departure_time" : "14:40:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "14:48:20" , 
"departure_time" : "14:48:31" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "14:50:11" , 
"departure_time" : "14:50:45" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "14:55:34" , 
"departure_time" : "14:56:23" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "14:58:49" , 
"departure_time" : "15:00:21" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "15:02:32" , 
"departure_time" : "15:04:05" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "15:07:33" , 
"departure_time" : "15:07:36" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "15:09:03" , 
"departure_time" : "15:10:00" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "15:13:57" , 
"departure_time" : "15:14:55" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "15:18:58" , 
"departure_time" : "15:19:30" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "15:23:32" , 
"departure_time" : "15:24:08" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "15:26:36" , 
"departure_time" : "15:28:07" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "15:33:31" , 
"departure_time" : "15:35:09" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "15:43:38" , 
"departure_time" : "15:43:38" , 
"distance_traveled" : 28.9235
} ], 
"4743" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "20:38:00" , 
"departure_time" : "20:40:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "20:47:29" , 
"departure_time" : "20:47:35" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "20:50:06" , 
"departure_time" : "20:51:00" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "20:55:54" , 
"departure_time" : "20:57:00" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "20:59:06" , 
"departure_time" : "21:00:28" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "21:02:22" , 
"departure_time" : "21:03:46" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "21:07:24" , 
"departure_time" : "21:08:42" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "21:10:18" , 
"departure_time" : "21:11:57" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "21:14:39" , 
"departure_time" : "21:15:50" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "21:19:11" , 
"departure_time" : "21:19:27" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "21:23:16" , 
"departure_time" : "21:23:58" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "21:26:42" , 
"departure_time" : "21:27:22" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "21:32:40" , 
"departure_time" : "21:34:06" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "21:43:26" , 
"departure_time" : "21:43:26" , 
"distance_traveled" : 28.9235
} ], 
"4744" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "15:38:00" , 
"departure_time" : "15:40:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "15:47:44" , 
"departure_time" : "15:48:08" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "15:50:24" , 
"departure_time" : "15:50:58" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "15:55:34" , 
"departure_time" : "15:57:03" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "15:59:29" , 
"departure_time" : "16:00:28" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "16:01:59" , 
"departure_time" : "16:02:55" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "16:06:56" , 
"departure_time" : "16:07:02" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "16:09:06" , 
"departure_time" : "16:09:25" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "16:13:19" , 
"departure_time" : "16:14:21" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "16:19:02" , 
"departure_time" : "16:19:45" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "16:23:43" , 
"departure_time" : "16:24:38" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "16:26:55" , 
"departure_time" : "16:28:31" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "16:33:36" , 
"departure_time" : "16:34:14" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "16:42:38" , 
"departure_time" : "16:42:38" , 
"distance_traveled" : 28.9235
} ], 
"4745" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "21:38:00" , 
"departure_time" : "21:40:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "21:48:30" , 
"departure_time" : "21:50:05" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "21:51:35" , 
"departure_time" : "21:52:20" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "21:55:45" , 
"departure_time" : "21:56:05" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "21:58:20" , 
"departure_time" : "21:59:54" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "22:02:34" , 
"departure_time" : "22:03:14" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "22:06:40" , 
"departure_time" : "22:08:12" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "22:10:32" , 
"departure_time" : "22:11:56" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "22:14:24" , 
"departure_time" : "22:14:39" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "22:18:15" , 
"departure_time" : "22:18:16" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "22:23:01" , 
"departure_time" : "22:23:31" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "22:26:30" , 
"departure_time" : "22:26:43" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "22:32:13" , 
"departure_time" : "22:32:21" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "22:42:08" , 
"departure_time" : "22:42:08" , 
"distance_traveled" : 28.9235
} ], 
"4746" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "16:38:00" , 
"departure_time" : "16:38:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "16:47:51" , 
"departure_time" : "16:48:53" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "16:51:02" , 
"departure_time" : "16:51:59" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "16:55:57" , 
"departure_time" : "16:57:17" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "16:59:20" , 
"departure_time" : "17:00:57" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "17:02:37" , 
"departure_time" : "17:02:58" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "17:06:21" , 
"departure_time" : "17:06:44" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "17:09:23" , 
"departure_time" : "17:10:35" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "17:14:12" , 
"departure_time" : "17:14:44" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "17:18:32" , 
"departure_time" : "17:19:33" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "17:24:01" , 
"departure_time" : "17:24:31" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "17:26:30" , 
"departure_time" : "17:27:03" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "17:32:33" , 
"departure_time" : "17:33:00" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "17:42:27" , 
"departure_time" : "17:42:27" , 
"distance_traveled" : 28.9235
} ], 
"4747" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "22:38:00" , 
"departure_time" : "22:39:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "22:48:03" , 
"departure_time" : "22:48:29" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "22:50:26" , 
"departure_time" : "22:50:48" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "22:55:22" , 
"departure_time" : "22:56:13" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "22:58:51" , 
"departure_time" : "23:00:02" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "23:02:11" , 
"departure_time" : "23:02:57" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "23:06:46" , 
"departure_time" : "23:07:19" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "23:09:33" , 
"departure_time" : "23:11:01" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "23:14:28" , 
"departure_time" : "23:15:51" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "23:19:23" , 
"departure_time" : "23:20:29" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "23:24:06" , 
"departure_time" : "23:24:19" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "23:26:13" , 
"departure_time" : "23:27:33" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "23:33:20" , 
"departure_time" : "23:34:07" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "23:42:47" , 
"departure_time" : "23:42:47" , 
"distance_traveled" : 28.9235
} ], 
"4748" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "17:38:00" , 
"departure_time" : "17:40:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "17:48:14" , 
"departure_time" : "17:49:05" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "17:50:51" , 
"departure_time" : "17:52:25" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "17:56:34" , 
"departure_time" : "17:57:21" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "17:58:47" , 
"departure_time" : "17:59:19" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "18:01:32" , 
"departure_time" : "18:03:10" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "18:07:38" , 
"departure_time" : "18:07:39" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "18:09:01" , 
"departure_time" : "18:09:11" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "18:13:10" , 
"departure_time" : "18:14:12" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "18:19:02" , 
"departure_time" : "18:19:25" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "18:23:23" , 
"departure_time" : "18:23:35" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "18:26:12" , 
"departure_time" : "18:27:25" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "18:33:13" , 
"departure_time" : "18:34:12" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "18:42:59" , 
"departure_time" : "18:42:59" , 
"distance_traveled" : 28.9235
} ], 
"4749" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "23:38:00" , 
"departure_time" : "23:40:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "23:48:20" , 
"departure_time" : "23:49:07" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "23:50:47" , 
"departure_time" : "23:51:40" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "23:55:53" , 
"departure_time" : "23:56:07" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "23:58:14" , 
"departure_time" : "23:59:27" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "24:02:13" , 
"departure_time" : "24:02:46" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "24:06:33" , 
"departure_time" : "24:06:49" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "24:09:16" , 
"departure_time" : "24:10:27" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "24:14:11" , 
"departure_time" : "24:15:37" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "24:19:26" , 
"departure_time" : "24:20:53" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "24:24:27" , 
"departure_time" : "24:24:30" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "24:26:03" , 
"departure_time" : "24:27:42" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "24:33:39" , 
"departure_time" : "24:33:49" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "24:42:10" , 
"departure_time" : "24:42:10" , 
"distance_traveled" : 28.9235
} ], 
"4750" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "18:38:00" , 
"departure_time" : "18:39:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "18:48:05" , 
"departure_time" : "18:49:44" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "18:51:39" , 
"departure_time" : "18:52:31" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "18:55:52" , 
"departure_time" : "18:56:54" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "18:59:02" , 
"departure_time" : "18:59:20" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "19:01:18" , 
"departure_time" : "19:02:47" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "19:07:29" , 
"departure_time" : "19:08:39" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "19:10:10" , 
"departure_time" : "19:10:17" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "19:13:07" , 
"departure_time" : "19:14:21" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "19:19:14" , 
"departure_time" : "19:19:22" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "19:23:08" , 
"departure_time" : "19:23:25" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "19:26:17" , 
"departure_time" : "19:27:02" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "19:32:45" , 
"departure_time" : "19:34:10" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "19:43:25" , 
"departure_time" : "19:43:25" , 
"distance_traveled" : 28.9235
} ], 
"4751" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "25:28:00" , 
"departure_time" : "25:30:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "25:38:15" , 
"departure_time" : "25:39:51" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "25:41:36" , 
"departure_time" : "25:42:38" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "25:46:02" , 
"departure_time" : "25:46:34" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "25:47:32" , 
"departure_time" : "25:48:30" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "25:50:58" , 
"departure_time" : "25:51:35" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "25:54:37" , 
"departure_time" : "25:54:44" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "25:57:07" , 
"departure_time" : "25:57:19" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "26:00:12" , 
"departure_time" : "26:01:32" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "26:06:20" , 
"departure_time" : "26:07:45" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "26:12:25" , 
"departure_time" : "26:13:13" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "26:13:48" , 
"departure_time" : "26:15:25" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "26:19:37" , 
"departure_time" : "26:20:32" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "26:34:55" , 
"departure_time" : "26:34:55" , 
"distance_traveled" : 28.9235
} ], 
"4752" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "19:38:00" , 
"departure_time" : "19:39:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "19:47:36" , 
"departure_time" : "19:48:45" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "19:51:09" , 
"departure_time" : "19:51:36" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "19:55:27" , 
"departure_time" : "19:56:00" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "19:58:33" , 
"departure_time" : "19:59:23" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "20:01:50" , 
"departure_time" : "20:03:28" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "20:07:38" , 
"departure_time" : "20:08:51" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "20:10:13" , 
"departure_time" : "20:10:30" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "20:13:17" , 
"departure_time" : "20:14:32" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "20:19:15" , 
"departure_time" : "20:19:41" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "20:23:26" , 
"departure_time" : "20:24:39" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "20:27:13" , 
"departure_time" : "20:27:37" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "20:32:24" , 
"departure_time" : "20:33:26" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "20:43:02" , 
"departure_time" : "20:43:02" , 
"distance_traveled" : 28.9235
} ], 
"4753" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "25:28:00" , 
"departure_time" : "25:29:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "25:37:28" , 
"departure_time" : "25:38:30" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "25:41:02" , 
"departure_time" : "25:42:21" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "25:46:19" , 
"departure_time" : "25:47:59" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "25:48:40" , 
"departure_time" : "25:50:06" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "25:51:26" , 
"departure_time" : "25:51:48" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "25:54:22" , 
"departure_time" : "25:55:28" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "25:58:06" , 
"departure_time" : "25:58:43" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "26:00:37" , 
"departure_time" : "26:02:14" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "26:06:37" , 
"departure_time" : "26:07:15" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "26:11:38" , 
"departure_time" : "26:12:44" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "26:14:06" , 
"departure_time" : "26:15:27" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "26:19:21" , 
"departure_time" : "26:19:31" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "26:34:10" , 
"departure_time" : "26:34:10" , 
"distance_traveled" : 28.9235
} ], 
"4754" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "20:38:00" , 
"departure_time" : "20:39:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "20:48:04" , 
"departure_time" : "20:49:37" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "20:51:33" , 
"departure_time" : "20:53:12" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "20:56:39" , 
"departure_time" : "20:56:43" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "20:58:04" , 
"departure_time" : "20:58:33" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "21:01:29" , 
"departure_time" : "21:02:56" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "21:07:27" , 
"departure_time" : "21:08:08" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "21:09:41" , 
"departure_time" : "21:10:17" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "21:13:36" , 
"departure_time" : "21:13:37" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "21:18:01" , 
"departure_time" : "21:18:37" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "21:23:36" , 
"departure_time" : "21:25:16" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "21:27:40" , 
"departure_time" : "21:29:00" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "21:33:20" , 
"departure_time" : "21:34:24" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "21:43:04" , 
"departure_time" : "21:43:04" , 
"distance_traveled" : 28.9235
} ], 
"4755" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "25:28:00" , 
"departure_time" : "25:29:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "25:37:47" , 
"departure_time" : "25:39:02" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "25:41:15" , 
"departure_time" : "25:42:25" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "25:46:10" , 
"departure_time" : "25:47:29" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "25:48:19" , 
"departure_time" : "25:49:04" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "25:50:45" , 
"departure_time" : "25:51:33" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "25:54:48" , 
"departure_time" : "25:56:17" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "25:58:29" , 
"departure_time" : "25:59:05" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "26:00:36" , 
"departure_time" : "26:02:04" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "26:06:28" , 
"departure_time" : "26:07:53" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "26:12:25" , 
"departure_time" : "26:13:20" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "26:13:55" , 
"departure_time" : "26:14:06" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "26:18:11" , 
"departure_time" : "26:19:16" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "26:35:05" , 
"departure_time" : "26:35:05" , 
"distance_traveled" : 28.9235
} ], 
"4756" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "21:38:00" , 
"departure_time" : "21:39:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "21:47:33" , 
"departure_time" : "21:48:25" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "21:50:52" , 
"departure_time" : "21:52:16" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "21:56:24" , 
"departure_time" : "21:56:42" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "21:58:18" , 
"departure_time" : "21:59:28" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "22:02:10" , 
"departure_time" : "22:03:38" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "22:07:28" , 
"departure_time" : "22:09:03" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "22:10:35" , 
"departure_time" : "22:12:05" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "22:14:30" , 
"departure_time" : "22:15:44" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "22:19:14" , 
"departure_time" : "22:19:56" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "22:23:42" , 
"departure_time" : "22:25:00" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "22:27:18" , 
"departure_time" : "22:28:08" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "22:32:50" , 
"departure_time" : "22:33:55" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "22:43:05" , 
"departure_time" : "22:43:05" , 
"distance_traveled" : 28.9235
} ], 
"4757" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "25:28:00" , 
"departure_time" : "25:29:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "25:37:44" , 
"departure_time" : "25:39:20" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "25:41:36" , 
"departure_time" : "25:42:30" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "25:45:54" , 
"departure_time" : "25:46:24" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "25:47:30" , 
"departure_time" : "25:48:17" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "25:50:47" , 
"departure_time" : "25:52:18" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "25:55:31" , 
"departure_time" : "25:56:03" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "25:57:32" , 
"departure_time" : "25:58:33" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "26:01:01" , 
"departure_time" : "26:01:14" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "26:05:13" , 
"departure_time" : "26:05:38" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "26:11:25" , 
"departure_time" : "26:12:10" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "26:13:45" , 
"departure_time" : "26:14:46" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "26:19:01" , 
"departure_time" : "26:19:33" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "26:34:32" , 
"departure_time" : "26:34:32" , 
"distance_traveled" : 28.9235
} ], 
"4758" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "22:38:00" , 
"departure_time" : "22:39:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "22:48:15" , 
"departure_time" : "22:49:40" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "22:51:25" , 
"departure_time" : "22:52:20" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "22:55:55" , 
"departure_time" : "22:57:33" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "22:59:38" , 
"departure_time" : "23:00:28" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "23:01:50" , 
"departure_time" : "23:02:52" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "23:07:02" , 
"departure_time" : "23:07:11" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "23:09:09" , 
"departure_time" : "23:10:14" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "23:14:05" , 
"departure_time" : "23:14:19" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "23:18:14" , 
"departure_time" : "23:18:43" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "23:23:29" , 
"departure_time" : "23:24:09" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "23:26:40" , 
"departure_time" : "23:27:53" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "23:33:13" , 
"departure_time" : "23:33:37" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "23:42:24" , 
"departure_time" : "23:42:24" , 
"distance_traveled" : 28.9235
} ], 
"4759" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "25:28:00" , 
"departure_time" : "25:29:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "25:38:20" , 
"departure_time" : "25:39:11" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "25:40:51" , 
"departure_time" : "25:41:43" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "25:45:52" , 
"departure_time" : "25:46:32" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "25:47:40" , 
"departure_time" : "25:48:50" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "25:51:10" , 
"departure_time" : "25:52:33" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "25:55:23" , 
"departure_time" : "25:55:57" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "25:57:34" , 
"departure_time" : "25:57:55" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "26:00:21" , 
"departure_time" : "26:00:30" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "26:05:09" , 
"departure_time" : "26:06:46" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "26:12:37" , 
"departure_time" : "26:12:49" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "26:13:12" , 
"departure_time" : "26:13:46" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "26:18:34" , 
"departure_time" : "26:20:09" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "26:35:35" , 
"departure_time" : "26:35:35" , 
"distance_traveled" : 28.9235
} ], 
"4760" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "23:38:00" , 
"departure_time" : "23:40:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "23:48:24" , 
"departure_time" : "23:48:57" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "23:50:33" , 
"departure_time" : "23:50:40" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "23:55:07" , 
"departure_time" : "23:55:20" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "23:58:13" , 
"departure_time" : "23:58:40" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "24:01:27" , 
"departure_time" : "24:02:15" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "24:06:48" , 
"departure_time" : "24:07:47" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "24:09:59" , 
"departure_time" : "24:11:34" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "24:14:35" , 
"departure_time" : "24:15:50" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "24:19:15" , 
"departure_time" : "24:20:46" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "24:24:31" , 
"departure_time" : "24:25:53" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "24:27:22" , 
"departure_time" : "24:28:40" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "24:33:18" , 
"departure_time" : "24:34:47" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "24:43:29" , 
"departure_time" : "24:43:29" , 
"distance_traveled" : 28.9235
} ], 
"4761" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "17:35:00" , 
"departure_time" : "17:37:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 155,
"arrival_time" : "17:52:11" , 
"departure_time" : "17:53:45" , 
"distance_traveled" : 11.6123
}, 
{ 
"stop_id" : 120,
"arrival_time" : "17:59:34" , 
"departure_time" : "17:59:36" , 
"distance_traveled" : 16.097
}, 
{ 
"stop_id" : 36,
"arrival_time" : "18:03:02" , 
"departure_time" : "18:03:10" , 
"distance_traveled" : 19.0369
}, 
{ 
"stop_id" : 21,
"arrival_time" : "18:09:08" , 
"departure_time" : "18:09:25" , 
"distance_traveled" : 23.2784
}, 
{ 
"stop_id" : 24,
"arrival_time" : "18:12:17" , 
"departure_time" : "18:13:49" , 
"distance_traveled" : 24.3898
}, 
{ 
"stop_id" : 138,
"arrival_time" : "18:19:32" , 
"departure_time" : "18:20:16" , 
"distance_traveled" : 27.7233
}, 
{ 
"stop_id" : 129,
"arrival_time" : "18:21:44" , 
"departure_time" : "18:22:35" , 
"distance_traveled" : 28.8871
}, 
{ 
"stop_id" : 108,
"arrival_time" : "18:27:51" , 
"departure_time" : "18:29:17" , 
"distance_traveled" : 32.3644
}, 
{ 
"stop_id" : 157,
"arrival_time" : "18:35:26" , 
"departure_time" : "18:36:16" , 
"distance_traveled" : 37.2638
}, 
{ 
"stop_id" : 68,
"arrival_time" : "18:40:50" , 
"departure_time" : "18:41:26" , 
"distance_traveled" : 41.0473
}, 
{ 
"stop_id" : 6,
"arrival_time" : "18:45:36" , 
"departure_time" : "18:46:17" , 
"distance_traveled" : 43.4057
}, 
{ 
"stop_id" : 60,
"arrival_time" : "18:54:41" , 
"departure_time" : "18:54:41" , 
"distance_traveled" : 45.1968
} ], 
"4762" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "25:28:00" , 
"departure_time" : "25:29:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "25:37:43" , 
"departure_time" : "25:39:02" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "25:41:19" , 
"departure_time" : "25:42:53" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "25:46:34" , 
"departure_time" : "25:48:14" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "25:48:40" , 
"departure_time" : "25:48:41" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "25:50:01" , 
"departure_time" : "25:50:51" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "25:54:50" , 
"departure_time" : "25:56:06" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "25:58:16" , 
"departure_time" : "25:58:45" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "26:00:29" , 
"departure_time" : "26:00:55" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "26:05:26" , 
"departure_time" : "26:05:47" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "26:11:21" , 
"departure_time" : "26:12:29" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "26:14:08" , 
"departure_time" : "26:15:04" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "26:18:56" , 
"departure_time" : "26:19:42" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "26:34:46" , 
"departure_time" : "26:34:46" , 
"distance_traveled" : 28.9235
} ], 
"4763" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "18:25:00" , 
"departure_time" : "18:27:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 155,
"arrival_time" : "18:43:32" , 
"departure_time" : "18:44:18" , 
"distance_traveled" : 11.6123
}, 
{ 
"stop_id" : 120,
"arrival_time" : "18:48:46" , 
"departure_time" : "18:49:02" , 
"distance_traveled" : 16.097
}, 
{ 
"stop_id" : 36,
"arrival_time" : "18:54:16" , 
"departure_time" : "18:55:37" , 
"distance_traveled" : 19.0369
}, 
{ 
"stop_id" : 21,
"arrival_time" : "19:01:21" , 
"departure_time" : "19:02:48" , 
"distance_traveled" : 23.2784
}, 
{ 
"stop_id" : 24,
"arrival_time" : "19:04:27" , 
"departure_time" : "19:05:01" , 
"distance_traveled" : 24.3898
}, 
{ 
"stop_id" : 138,
"arrival_time" : "19:08:34" , 
"departure_time" : "19:09:40" , 
"distance_traveled" : 27.7233
}, 
{ 
"stop_id" : 129,
"arrival_time" : "19:12:06" , 
"departure_time" : "19:12:30" , 
"distance_traveled" : 28.8871
}, 
{ 
"stop_id" : 108,
"arrival_time" : "19:17:24" , 
"departure_time" : "19:17:26" , 
"distance_traveled" : 32.3644
}, 
{ 
"stop_id" : 157,
"arrival_time" : "19:24:02" , 
"departure_time" : "19:24:29" , 
"distance_traveled" : 37.2638
}, 
{ 
"stop_id" : 68,
"arrival_time" : "19:31:27" , 
"departure_time" : "19:31:31" , 
"distance_traveled" : 41.0473
}, 
{ 
"stop_id" : 6,
"arrival_time" : "19:35:04" , 
"departure_time" : "19:35:12" , 
"distance_traveled" : 43.4057
}, 
{ 
"stop_id" : 60,
"arrival_time" : "19:45:08" , 
"departure_time" : "19:45:08" , 
"distance_traveled" : 45.1968
} ], 
"4764" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "25:28:00" , 
"departure_time" : "25:28:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "25:37:35" , 
"departure_time" : "25:38:00" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "25:40:25" , 
"departure_time" : "25:41:55" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "25:46:30" , 
"departure_time" : "25:47:50" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "25:48:20" , 
"departure_time" : "25:48:32" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "25:50:12" , 
"departure_time" : "25:50:45" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "25:54:33" , 
"departure_time" : "25:55:00" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "25:57:27" , 
"departure_time" : "25:58:13" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "26:00:46" , 
"departure_time" : "26:01:29" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "26:05:43" , 
"departure_time" : "26:05:54" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "26:11:11" , 
"departure_time" : "26:12:38" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "26:14:27" , 
"departure_time" : "26:15:29" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "26:19:02" , 
"departure_time" : "26:20:30" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "26:35:28" , 
"departure_time" : "26:35:28" , 
"distance_traveled" : 28.9235
} ], 
"4765" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "09:06:00" , 
"departure_time" : "09:07:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "09:15:09" , 
"departure_time" : "09:15:34" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "09:18:25" , 
"departure_time" : "09:19:23" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "09:23:58" , 
"departure_time" : "09:25:29" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 155,
"arrival_time" : "09:28:31" , 
"departure_time" : "09:29:21" , 
"distance_traveled" : 11.6123
}, 
{ 
"stop_id" : 44,
"arrival_time" : "09:32:50" , 
"departure_time" : "09:33:39" , 
"distance_traveled" : 13.7009
}, 
{ 
"stop_id" : 102,
"arrival_time" : "09:35:49" , 
"departure_time" : "09:37:29" , 
"distance_traveled" : 14.9523
}, 
{ 
"stop_id" : 120,
"arrival_time" : "09:39:40" , 
"departure_time" : "09:39:53" , 
"distance_traveled" : 16.097
}, 
{ 
"stop_id" : 36,
"arrival_time" : "09:43:13" , 
"departure_time" : "09:43:59" , 
"distance_traveled" : 19.0369
}, 
{ 
"stop_id" : 21,
"arrival_time" : "09:49:46" , 
"departure_time" : "09:50:28" , 
"distance_traveled" : 23.2784
}, 
{ 
"stop_id" : 24,
"arrival_time" : "09:52:42" , 
"departure_time" : "09:53:57" , 
"distance_traveled" : 24.3898
}, 
{ 
"stop_id" : 138,
"arrival_time" : "09:58:15" , 
"departure_time" : "09:59:22" , 
"distance_traveled" : 27.7233
}, 
{ 
"stop_id" : 129,
"arrival_time" : "10:12:07" , 
"departure_time" : "10:12:07" , 
"distance_traveled" : 28.8871
} ], 
"4766" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "17:16:00" , 
"departure_time" : "17:17:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "17:25:01" , 
"departure_time" : "17:26:04" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "17:30:03" , 
"departure_time" : "17:31:26" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "17:35:23" , 
"departure_time" : "17:35:38" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 155,
"arrival_time" : "17:38:15" , 
"departure_time" : "17:39:28" , 
"distance_traveled" : 11.6123
}, 
{ 
"stop_id" : 44,
"arrival_time" : "17:44:13" , 
"departure_time" : "17:45:08" , 
"distance_traveled" : 13.7009
}, 
{ 
"stop_id" : 102,
"arrival_time" : "17:46:55" , 
"departure_time" : "17:48:00" , 
"distance_traveled" : 14.9523
}, 
{ 
"stop_id" : 120,
"arrival_time" : "17:50:05" , 
"departure_time" : "17:50:10" , 
"distance_traveled" : 16.097
}, 
{ 
"stop_id" : 36,
"arrival_time" : "17:54:05" , 
"departure_time" : "17:54:54" , 
"distance_traveled" : 19.0369
}, 
{ 
"stop_id" : 21,
"arrival_time" : "18:00:49" , 
"departure_time" : "18:01:25" , 
"distance_traveled" : 23.2784
}, 
{ 
"stop_id" : 24,
"arrival_time" : "18:03:36" , 
"departure_time" : "18:04:01" , 
"distance_traveled" : 24.3898
}, 
{ 
"stop_id" : 138,
"arrival_time" : "18:08:25" , 
"departure_time" : "18:09:16" , 
"distance_traveled" : 27.7233
}, 
{ 
"stop_id" : 129,
"arrival_time" : "18:13:51" , 
"departure_time" : "18:13:51" , 
"distance_traveled" : 28.8871
} ], 
"4767" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "25:28:00" , 
"departure_time" : "25:29:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "25:37:20" , 
"departure_time" : "25:38:21" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "25:41:01" , 
"departure_time" : "25:41:17" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "25:45:16" , 
"departure_time" : "25:46:16" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "25:48:00" , 
"departure_time" : "25:48:31" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "25:50:31" , 
"departure_time" : "25:50:33" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "25:54:02" , 
"departure_time" : "25:54:06" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "25:57:04" , 
"departure_time" : "25:58:18" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "26:01:14" , 
"departure_time" : "26:01:57" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "26:05:43" , 
"departure_time" : "26:05:53" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "26:11:10" , 
"departure_time" : "26:12:07" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "26:13:57" , 
"departure_time" : "26:15:26" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "26:19:29" , 
"departure_time" : "26:20:50" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "26:35:21" , 
"departure_time" : "26:35:21" , 
"distance_traveled" : 28.9235
} ], 
"4768" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "18:05:00" , 
"departure_time" : "18:06:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "18:14:04" , 
"departure_time" : "18:15:20" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "18:19:16" , 
"departure_time" : "18:20:10" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "18:23:54" , 
"departure_time" : "18:23:58" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 155,
"arrival_time" : "18:28:04" , 
"departure_time" : "18:28:44" , 
"distance_traveled" : 11.6123
}, 
{ 
"stop_id" : 44,
"arrival_time" : "18:33:40" , 
"departure_time" : "18:34:01" , 
"distance_traveled" : 13.7009
}, 
{ 
"stop_id" : 102,
"arrival_time" : "18:37:21" , 
"departure_time" : "18:37:53" , 
"distance_traveled" : 14.9523
}, 
{ 
"stop_id" : 120,
"arrival_time" : "18:40:32" , 
"departure_time" : "18:42:11" , 
"distance_traveled" : 16.097
}, 
{ 
"stop_id" : 36,
"arrival_time" : "18:46:39" , 
"departure_time" : "18:48:16" , 
"distance_traveled" : 19.0369
}, 
{ 
"stop_id" : 21,
"arrival_time" : "18:52:37" , 
"departure_time" : "18:53:38" , 
"distance_traveled" : 23.2784
}, 
{ 
"stop_id" : 24,
"arrival_time" : "18:55:01" , 
"departure_time" : "18:56:22" , 
"distance_traveled" : 24.3898
}, 
{ 
"stop_id" : 138,
"arrival_time" : "19:01:21" , 
"departure_time" : "19:01:50" , 
"distance_traveled" : 27.7233
}, 
{ 
"stop_id" : 129,
"arrival_time" : "19:07:29" , 
"departure_time" : "19:07:29" , 
"distance_traveled" : 28.8871
} ], 
"4769" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "25:28:00" , 
"departure_time" : "25:29:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "25:37:44" , 
"departure_time" : "25:38:17" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "25:40:33" , 
"departure_time" : "25:41:46" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "25:46:13" , 
"departure_time" : "25:46:34" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "25:47:21" , 
"departure_time" : "25:47:48" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "25:50:27" , 
"departure_time" : "25:51:35" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "25:55:08" , 
"departure_time" : "25:56:45" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "25:58:37" , 
"departure_time" : "26:00:06" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "26:01:29" , 
"departure_time" : "26:01:33" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "26:05:04" , 
"departure_time" : "26:06:19" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "26:12:15" , 
"departure_time" : "26:12:27" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "26:13:12" , 
"departure_time" : "26:14:17" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "26:19:05" , 
"departure_time" : "26:20:11" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "26:35:06" , 
"departure_time" : "26:35:06" , 
"distance_traveled" : 28.9235
} ], 
"4770" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "06:05:00" , 
"departure_time" : "06:06:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "06:14:44" , 
"departure_time" : "06:15:59" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "06:19:15" , 
"departure_time" : "06:20:28" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "06:23:13" , 
"departure_time" : "06:24:08" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "06:25:55" , 
"departure_time" : "06:27:15" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "06:29:20" , 
"departure_time" : "06:30:56" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "06:34:36" , 
"departure_time" : "06:35:48" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "06:37:12" , 
"departure_time" : "06:38:30" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "06:41:18" , 
"departure_time" : "06:41:26" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "06:45:08" , 
"departure_time" : "06:45:23" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "06:50:15" , 
"departure_time" : "06:51:18" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "06:54:03" , 
"departure_time" : "06:54:08" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "06:59:05" , 
"departure_time" : "06:59:40" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "07:03:35" , 
"departure_time" : "07:03:35" , 
"distance_traveled" : 28.9235
} ], 
"4771" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "18:25:00" , 
"departure_time" : "18:25:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 155,
"arrival_time" : "18:42:01" , 
"departure_time" : "18:43:37" , 
"distance_traveled" : 11.6123
}, 
{ 
"stop_id" : 120,
"arrival_time" : "18:49:36" , 
"departure_time" : "18:51:08" , 
"distance_traveled" : 16.097
}, 
{ 
"stop_id" : 36,
"arrival_time" : "18:55:32" , 
"departure_time" : "18:56:23" , 
"distance_traveled" : 19.0369
}, 
{ 
"stop_id" : 21,
"arrival_time" : "19:00:51" , 
"departure_time" : "19:01:08" , 
"distance_traveled" : 23.2784
}, 
{ 
"stop_id" : 24,
"arrival_time" : "19:03:17" , 
"departure_time" : "19:04:29" , 
"distance_traveled" : 24.3898
}, 
{ 
"stop_id" : 138,
"arrival_time" : "19:09:12" , 
"departure_time" : "19:10:11" , 
"distance_traveled" : 27.7233
}, 
{ 
"stop_id" : 129,
"arrival_time" : "19:11:59" , 
"departure_time" : "19:13:24" , 
"distance_traveled" : 28.8871
}, 
{ 
"stop_id" : 108,
"arrival_time" : "19:18:25" , 
"departure_time" : "19:19:27" , 
"distance_traveled" : 32.3644
}, 
{ 
"stop_id" : 157,
"arrival_time" : "19:25:02" , 
"departure_time" : "19:26:19" , 
"distance_traveled" : 37.2638
}, 
{ 
"stop_id" : 68,
"arrival_time" : "19:32:17" , 
"departure_time" : "19:32:23" , 
"distance_traveled" : 41.0473
}, 
{ 
"stop_id" : 6,
"arrival_time" : "19:35:06" , 
"departure_time" : "19:35:43" , 
"distance_traveled" : 43.4057
}, 
{ 
"stop_id" : 60,
"arrival_time" : "19:45:37" , 
"departure_time" : "19:45:37" , 
"distance_traveled" : 45.1968
} ], 
"4772" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "07:59:00" , 
"departure_time" : "08:00:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "08:08:40" , 
"departure_time" : "08:08:52" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "08:12:12" , 
"departure_time" : "08:12:49" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "08:17:37" , 
"departure_time" : "08:18:05" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "08:20:28" , 
"departure_time" : "08:20:41" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "08:23:13" , 
"departure_time" : "08:23:26" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "08:28:13" , 
"departure_time" : "08:29:12" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "08:31:59" , 
"departure_time" : "08:32:38" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "08:34:39" , 
"departure_time" : "08:35:39" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "08:40:00" , 
"departure_time" : "08:40:46" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "08:45:46" , 
"departure_time" : "08:46:57" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "08:49:11" , 
"departure_time" : "08:49:36" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "08:53:25" , 
"departure_time" : "08:53:54" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "09:07:29" , 
"departure_time" : "09:07:29" , 
"distance_traveled" : 28.9235
} ], 
"4773" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "18:33:00" , 
"departure_time" : "18:33:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "18:42:09" , 
"departure_time" : "18:42:44" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "18:46:35" , 
"departure_time" : "18:47:49" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "18:52:14" , 
"departure_time" : "18:52:53" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "18:54:39" , 
"departure_time" : "18:55:54" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "18:58:15" , 
"departure_time" : "18:58:37" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "19:02:22" , 
"departure_time" : "19:03:48" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "19:07:26" , 
"departure_time" : "19:09:05" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "19:10:39" , 
"departure_time" : "19:12:03" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "19:15:24" , 
"departure_time" : "19:17:04" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "19:21:40" , 
"departure_time" : "19:23:09" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "19:25:29" , 
"departure_time" : "19:26:15" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "19:29:46" , 
"departure_time" : "19:30:29" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "19:36:43" , 
"departure_time" : "19:36:43" , 
"distance_traveled" : 28.9235
} ], 
"4774" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "16:11:00" , 
"departure_time" : "16:12:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "16:20:41" , 
"departure_time" : "16:21:56" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "16:25:15" , 
"departure_time" : "16:26:25" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "16:30:10" , 
"departure_time" : "16:30:22" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "16:32:12" , 
"departure_time" : "16:33:44" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "16:36:32" , 
"departure_time" : "16:37:38" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "16:41:06" , 
"departure_time" : "16:41:08" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "16:43:02" , 
"departure_time" : "16:44:33" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "16:48:31" , 
"departure_time" : "16:49:14" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "16:52:43" , 
"departure_time" : "16:53:45" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "16:59:02" , 
"departure_time" : "17:00:26" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "17:02:24" , 
"departure_time" : "17:03:46" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "17:08:22" , 
"departure_time" : "17:08:48" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "17:12:26" , 
"departure_time" : "17:12:26" , 
"distance_traveled" : 28.9235
} ], 
"4775" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "17:35:00" , 
"departure_time" : "17:35:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 155,
"arrival_time" : "17:51:01" , 
"departure_time" : "17:51:32" , 
"distance_traveled" : 11.6123
}, 
{ 
"stop_id" : 120,
"arrival_time" : "17:58:31" , 
"departure_time" : "17:59:22" , 
"distance_traveled" : 16.097
}, 
{ 
"stop_id" : 36,
"arrival_time" : "18:03:51" , 
"departure_time" : "18:05:31" , 
"distance_traveled" : 19.0369
}, 
{ 
"stop_id" : 21,
"arrival_time" : "18:10:40" , 
"departure_time" : "18:10:49" , 
"distance_traveled" : 23.2784
}, 
{ 
"stop_id" : 24,
"arrival_time" : "18:12:09" , 
"departure_time" : "18:12:13" , 
"distance_traveled" : 24.3898
}, 
{ 
"stop_id" : 138,
"arrival_time" : "18:18:04" , 
"departure_time" : "18:19:06" , 
"distance_traveled" : 27.7233
}, 
{ 
"stop_id" : 129,
"arrival_time" : "18:22:02" , 
"departure_time" : "18:22:15" , 
"distance_traveled" : 28.8871
}, 
{ 
"stop_id" : 108,
"arrival_time" : "18:27:13" , 
"departure_time" : "18:28:30" , 
"distance_traveled" : 32.3644
}, 
{ 
"stop_id" : 157,
"arrival_time" : "18:35:17" , 
"departure_time" : "18:35:26" , 
"distance_traveled" : 37.2638
}, 
{ 
"stop_id" : 68,
"arrival_time" : "18:40:09" , 
"departure_time" : "18:40:36" , 
"distance_traveled" : 41.0473
}, 
{ 
"stop_id" : 6,
"arrival_time" : "18:45:27" , 
"departure_time" : "18:45:34" , 
"distance_traveled" : 43.4057
}, 
{ 
"stop_id" : 60,
"arrival_time" : "18:54:07" , 
"departure_time" : "18:54:07" , 
"distance_traveled" : 45.1968
} ], 
"4776" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "17:42:00" , 
"departure_time" : "17:42:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "17:51:37" , 
"departure_time" : "17:52:51" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "17:56:14" , 
"departure_time" : "17:57:09" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "18:00:55" , 
"departure_time" : "18:01:54" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "18:03:59" , 
"departure_time" : "18:04:08" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "18:07:09" , 
"departure_time" : "18:08:45" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "18:12:36" , 
"departure_time" : "18:13:32" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "18:15:56" , 
"departure_time" : "18:16:23" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "18:18:27" , 
"departure_time" : "18:19:26" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "18:24:59" , 
"departure_time" : "18:26:10" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "18:31:11" , 
"departure_time" : "18:32:19" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "18:34:08" , 
"departure_time" : "18:35:35" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "18:39:27" , 
"departure_time" : "18:40:44" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "18:45:17" , 
"departure_time" : "18:45:17" , 
"distance_traveled" : 28.9235
} ], 
"4777" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "09:06:00" , 
"departure_time" : "09:07:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "09:15:32" , 
"departure_time" : "09:16:09" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "09:18:37" , 
"departure_time" : "09:18:44" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "09:23:07" , 
"departure_time" : "09:24:39" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 155,
"arrival_time" : "09:28:32" , 
"departure_time" : "09:29:45" , 
"distance_traveled" : 11.6123
}, 
{ 
"stop_id" : 44,
"arrival_time" : "09:33:13" , 
"departure_time" : "09:33:30" , 
"distance_traveled" : 13.7009
}, 
{ 
"stop_id" : 102,
"arrival_time" : "09:35:17" , 
"departure_time" : "09:35:22" , 
"distance_traveled" : 14.9523
}, 
{ 
"stop_id" : 120,
"arrival_time" : "09:38:05" , 
"departure_time" : "09:39:11" , 
"distance_traveled" : 16.097
}, 
{ 
"stop_id" : 36,
"arrival_time" : "09:44:06" , 
"departure_time" : "09:45:05" , 
"distance_traveled" : 19.0369
}, 
{ 
"stop_id" : 21,
"arrival_time" : "09:49:59" , 
"departure_time" : "09:50:16" , 
"distance_traveled" : 23.2784
}, 
{ 
"stop_id" : 24,
"arrival_time" : "09:52:17" , 
"departure_time" : "09:52:50" , 
"distance_traveled" : 24.3898
}, 
{ 
"stop_id" : 138,
"arrival_time" : "09:57:33" , 
"departure_time" : "09:57:52" , 
"distance_traveled" : 27.7233
}, 
{ 
"stop_id" : 129,
"arrival_time" : "10:11:19" , 
"departure_time" : "10:11:19" , 
"distance_traveled" : 28.8871
} ], 
"4778" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "18:33:00" , 
"departure_time" : "18:33:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "18:42:04" , 
"departure_time" : "18:42:37" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "18:46:33" , 
"departure_time" : "18:47:04" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "18:51:31" , 
"departure_time" : "18:51:35" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "18:54:04" , 
"departure_time" : "18:55:19" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "18:58:15" , 
"departure_time" : "18:59:29" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "19:03:14" , 
"departure_time" : "19:04:13" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "19:06:59" , 
"departure_time" : "19:08:06" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "19:10:07" , 
"departure_time" : "19:11:15" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "19:15:08" , 
"departure_time" : "19:15:38" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "19:20:30" , 
"departure_time" : "19:21:44" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "19:25:14" , 
"departure_time" : "19:25:15" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "19:29:01" , 
"departure_time" : "19:30:36" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "19:37:35" , 
"departure_time" : "19:37:35" , 
"distance_traveled" : 28.9235
} ], 
"4779" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "17:16:00" , 
"departure_time" : "17:18:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "17:25:39" , 
"departure_time" : "17:25:54" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "17:29:15" , 
"departure_time" : "17:30:49" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "17:35:34" , 
"departure_time" : "17:35:35" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 155,
"arrival_time" : "17:38:01" , 
"departure_time" : "17:39:06" , 
"distance_traveled" : 11.6123
}, 
{ 
"stop_id" : 44,
"arrival_time" : "17:44:05" , 
"departure_time" : "17:45:16" , 
"distance_traveled" : 13.7009
}, 
{ 
"stop_id" : 102,
"arrival_time" : "17:47:11" , 
"departure_time" : "17:48:00" , 
"distance_traveled" : 14.9523
}, 
{ 
"stop_id" : 120,
"arrival_time" : "17:49:49" , 
"departure_time" : "17:50:16" , 
"distance_traveled" : 16.097
}, 
{ 
"stop_id" : 36,
"arrival_time" : "17:54:27" , 
"departure_time" : "17:55:50" , 
"distance_traveled" : 19.0369
}, 
{ 
"stop_id" : 21,
"arrival_time" : "18:01:23" , 
"departure_time" : "18:01:35" , 
"distance_traveled" : 23.2784
}, 
{ 
"stop_id" : 24,
"arrival_time" : "18:03:12" , 
"departure_time" : "18:03:48" , 
"distance_traveled" : 24.3898
}, 
{ 
"stop_id" : 138,
"arrival_time" : "18:08:36" , 
"departure_time" : "18:08:54" , 
"distance_traveled" : 27.7233
}, 
{ 
"stop_id" : 129,
"arrival_time" : "18:13:18" , 
"departure_time" : "18:13:18" , 
"distance_traveled" : 28.8871
} ], 
"4780" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "20:12:00" , 
"departure_time" : "20:13:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "20:22:10" , 
"departure_time" : "20:22:54" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "20:24:44" , 
"departure_time" : "20:25:01" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "20:29:17" , 
"departure_time" : "20:29:57" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "20:32:40" , 
"departure_time" : "20:33:45" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "20:36:05" , 
"departure_time" : "20:36:55" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "20:40:50" , 
"departure_time" : "20:41:17" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "20:43:27" , 
"departure_time" : "20:44:51" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "20:47:24" , 
"departure_time" : "20:48:13" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "20:51:49" , 
"departure_time" : "20:52:55" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "20:58:06" , 
"departure_time" : "20:59:04" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "21:00:58" , 
"departure_time" : "21:01:48" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "21:05:50" , 
"departure_time" : "21:06:30" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "21:11:40" , 
"departure_time" : "21:11:40" , 
"distance_traveled" : 28.9235
} ], 
"4781" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "18:05:00" , 
"departure_time" : "18:06:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "18:14:40" , 
"departure_time" : "18:15:56" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "18:19:16" , 
"departure_time" : "18:20:37" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "18:24:21" , 
"departure_time" : "18:25:00" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 155,
"arrival_time" : "18:28:39" , 
"departure_time" : "18:28:59" , 
"distance_traveled" : 11.6123
}, 
{ 
"stop_id" : 44,
"arrival_time" : "18:33:20" , 
"departure_time" : "18:33:21" , 
"distance_traveled" : 13.7009
}, 
{ 
"stop_id" : 102,
"arrival_time" : "18:37:01" , 
"departure_time" : "18:38:17" , 
"distance_traveled" : 14.9523
}, 
{ 
"stop_id" : 120,
"arrival_time" : "18:41:16" , 
"departure_time" : "18:41:49" , 
"distance_traveled" : 16.097
}, 
{ 
"stop_id" : 36,
"arrival_time" : "18:45:33" , 
"departure_time" : "18:45:48" , 
"distance_traveled" : 19.0369
}, 
{ 
"stop_id" : 21,
"arrival_time" : "18:51:15" , 
"departure_time" : "18:52:01" , 
"distance_traveled" : 23.2784
}, 
{ 
"stop_id" : 24,
"arrival_time" : "18:54:46" , 
"departure_time" : "18:55:06" , 
"distance_traveled" : 24.3898
}, 
{ 
"stop_id" : 138,
"arrival_time" : "19:00:20" , 
"departure_time" : "19:00:23" , 
"distance_traveled" : 27.7233
}, 
{ 
"stop_id" : 129,
"arrival_time" : "19:07:03" , 
"departure_time" : "19:07:03" , 
"distance_traveled" : 28.8871
} ], 
"4782" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "10:44:00" , 
"departure_time" : "10:44:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:53:13" , 
"departure_time" : "10:53:42" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:06:29" , 
"departure_time" : "11:07:22" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "11:15:53" , 
"departure_time" : "11:16:48" , 
"distance_traveled" : 15.3146
}, 
{ 
"stop_id" : 31,
"arrival_time" : "11:18:55" , 
"departure_time" : "11:19:26" , 
"distance_traveled" : 17.161
}, 
{ 
"stop_id" : 32,
"arrival_time" : "11:23:31" , 
"departure_time" : "11:24:09" , 
"distance_traveled" : 19.3049
}, 
{ 
"stop_id" : 155,
"arrival_time" : "11:27:38" , 
"departure_time" : "11:28:46" , 
"distance_traveled" : 21.6676
}, 
{ 
"stop_id" : 44,
"arrival_time" : "11:33:08" , 
"departure_time" : "11:34:46" , 
"distance_traveled" : 23.7563
}, 
{ 
"stop_id" : 102,
"arrival_time" : "11:36:38" , 
"departure_time" : "11:37:33" , 
"distance_traveled" : 25.0076
}, 
{ 
"stop_id" : 120,
"arrival_time" : "11:38:55" , 
"departure_time" : "11:40:25" , 
"distance_traveled" : 26.1523
}, 
{ 
"stop_id" : 36,
"arrival_time" : "11:44:30" , 
"departure_time" : "11:45:28" , 
"distance_traveled" : 29.0922
}, 
{ 
"stop_id" : 21,
"arrival_time" : "11:49:58" , 
"departure_time" : "11:51:09" , 
"distance_traveled" : 33.3337
}, 
{ 
"stop_id" : 24,
"arrival_time" : "11:53:11" , 
"departure_time" : "11:53:23" , 
"distance_traveled" : 34.4451
}, 
{ 
"stop_id" : 138,
"arrival_time" : "11:57:12" , 
"departure_time" : "11:58:40" , 
"distance_traveled" : 37.7786
}, 
{ 
"stop_id" : 129,
"arrival_time" : "12:11:28" , 
"departure_time" : "12:11:28" , 
"distance_traveled" : 38.9424
} ], 
"4783" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "06:05:00" , 
"departure_time" : "06:07:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "06:15:06" , 
"departure_time" : "06:16:40" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "06:19:34" , 
"departure_time" : "06:19:51" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "06:22:17" , 
"departure_time" : "06:23:19" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "06:26:02" , 
"departure_time" : "06:26:51" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "06:28:49" , 
"departure_time" : "06:29:34" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "06:33:45" , 
"departure_time" : "06:34:15" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "06:36:30" , 
"departure_time" : "06:36:58" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "06:40:28" , 
"departure_time" : "06:41:36" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "06:46:08" , 
"departure_time" : "06:47:10" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "06:51:02" , 
"departure_time" : "06:52:14" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "06:54:12" , 
"departure_time" : "06:54:16" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "06:59:04" , 
"departure_time" : "06:59:54" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "07:03:50" , 
"departure_time" : "07:03:50" , 
"distance_traveled" : 28.9235
} ], 
"4784" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "11:49:00" , 
"departure_time" : "11:50:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:58:12" , 
"departure_time" : "11:59:24" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:09:12" , 
"departure_time" : "12:09:55" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "12:17:43" , 
"departure_time" : "12:19:18" , 
"distance_traveled" : 15.3146
}, 
{ 
"stop_id" : 31,
"arrival_time" : "12:21:35" , 
"departure_time" : "12:22:55" , 
"distance_traveled" : 17.161
}, 
{ 
"stop_id" : 32,
"arrival_time" : "12:26:20" , 
"departure_time" : "12:27:19" , 
"distance_traveled" : 19.3049
}, 
{ 
"stop_id" : 155,
"arrival_time" : "12:29:59" , 
"departure_time" : "12:31:24" , 
"distance_traveled" : 21.6676
}, 
{ 
"stop_id" : 44,
"arrival_time" : "12:35:25" , 
"departure_time" : "12:35:42" , 
"distance_traveled" : 23.7563
}, 
{ 
"stop_id" : 102,
"arrival_time" : "12:37:17" , 
"departure_time" : "12:38:28" , 
"distance_traveled" : 25.0076
}, 
{ 
"stop_id" : 120,
"arrival_time" : "12:41:11" , 
"departure_time" : "12:42:13" , 
"distance_traveled" : 26.1523
}, 
{ 
"stop_id" : 36,
"arrival_time" : "12:46:02" , 
"departure_time" : "12:47:37" , 
"distance_traveled" : 29.0922
}, 
{ 
"stop_id" : 21,
"arrival_time" : "12:52:35" , 
"departure_time" : "12:53:37" , 
"distance_traveled" : 33.3337
}, 
{ 
"stop_id" : 24,
"arrival_time" : "12:55:02" , 
"departure_time" : "12:56:39" , 
"distance_traveled" : 34.4451
}, 
{ 
"stop_id" : 138,
"arrival_time" : "13:00:37" , 
"departure_time" : "13:01:16" , 
"distance_traveled" : 37.7786
}, 
{ 
"stop_id" : 129,
"arrival_time" : "13:11:39" , 
"departure_time" : "13:11:39" , 
"distance_traveled" : 38.9424
} ], 
"4785" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "07:59:00" , 
"departure_time" : "07:59:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "08:08:03" , 
"departure_time" : "08:09:04" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "08:13:01" , 
"departure_time" : "08:13:28" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "08:17:27" , 
"departure_time" : "08:17:57" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "08:20:30" , 
"departure_time" : "08:20:33" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "08:23:03" , 
"departure_time" : "08:24:19" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "08:29:16" , 
"departure_time" : "08:29:56" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "08:31:40" , 
"departure_time" : "08:32:07" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "08:34:27" , 
"departure_time" : "08:34:39" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "08:39:12" , 
"departure_time" : "08:40:03" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "08:45:51" , 
"departure_time" : "08:46:30" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "08:48:39" , 
"departure_time" : "08:49:31" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "08:53:52" , 
"departure_time" : "08:54:17" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "09:07:25" , 
"departure_time" : "09:07:25" , 
"distance_traveled" : 28.9235
} ], 
"4786" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "13:47:00" , 
"departure_time" : "13:47:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:56:08" , 
"departure_time" : "13:56:14" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:06:06" , 
"departure_time" : "14:06:25" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "14:15:19" , 
"departure_time" : "14:16:17" , 
"distance_traveled" : 15.3146
}, 
{ 
"stop_id" : 31,
"arrival_time" : "14:18:58" , 
"departure_time" : "14:20:27" , 
"distance_traveled" : 17.161
}, 
{ 
"stop_id" : 32,
"arrival_time" : "14:24:29" , 
"departure_time" : "14:24:57" , 
"distance_traveled" : 19.3049
}, 
{ 
"stop_id" : 47,
"arrival_time" : "14:26:28" , 
"departure_time" : "14:27:19" , 
"distance_traveled" : 20.4888
}, 
{ 
"stop_id" : 155,
"arrival_time" : "14:29:51" , 
"departure_time" : "14:30:56" , 
"distance_traveled" : 21.704
}, 
{ 
"stop_id" : 44,
"arrival_time" : "14:35:05" , 
"departure_time" : "14:36:21" , 
"distance_traveled" : 23.7926
}, 
{ 
"stop_id" : 102,
"arrival_time" : "14:38:16" , 
"departure_time" : "14:39:43" , 
"distance_traveled" : 25.0439
}, 
{ 
"stop_id" : 120,
"arrival_time" : "14:42:27" , 
"departure_time" : "14:44:05" , 
"distance_traveled" : 26.1886
}, 
{ 
"stop_id" : 36,
"arrival_time" : "14:47:38" , 
"departure_time" : "14:47:40" , 
"distance_traveled" : 29.1286
}, 
{ 
"stop_id" : 21,
"arrival_time" : "14:51:02" , 
"departure_time" : "14:52:01" , 
"distance_traveled" : 33.3701
}, 
{ 
"stop_id" : 24,
"arrival_time" : "14:54:59" , 
"departure_time" : "14:56:22" , 
"distance_traveled" : 34.4814
}, 
{ 
"stop_id" : 138,
"arrival_time" : "15:01:23" , 
"departure_time" : "15:01:59" , 
"distance_traveled" : 37.815
}, 
{ 
"stop_id" : 129,
"arrival_time" : "15:12:36" , 
"departure_time" : "15:12:36" , 
"distance_traveled" : 38.9788
} ], 
"4787" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "16:11:00" , 
"departure_time" : "16:12:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "16:20:50" , 
"departure_time" : "16:21:42" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "16:24:52" , 
"departure_time" : "16:25:08" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "16:29:16" , 
"departure_time" : "16:29:52" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "16:32:36" , 
"departure_time" : "16:33:33" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "16:35:57" , 
"departure_time" : "16:36:28" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "16:40:31" , 
"departure_time" : "16:41:08" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "16:43:37" , 
"departure_time" : "16:44:21" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "16:47:44" , 
"departure_time" : "16:49:01" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "16:53:17" , 
"departure_time" : "16:53:19" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "16:58:02" , 
"departure_time" : "16:58:16" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "17:01:14" , 
"departure_time" : "17:01:39" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "17:07:25" , 
"departure_time" : "17:08:35" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "17:13:10" , 
"departure_time" : "17:13:10" , 
"distance_traveled" : 28.9235
} ], 
"4788" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "21:48:00" , 
"departure_time" : "21:49:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:57:30" , 
"departure_time" : "21:58:38" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:09:08" , 
"departure_time" : "22:09:26" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "22:17:18" , 
"departure_time" : "22:17:30" , 
"distance_traveled" : 15.3146
}, 
{ 
"stop_id" : 31,
"arrival_time" : "22:20:12" , 
"departure_time" : "22:21:43" , 
"distance_traveled" : 17.161
}, 
{ 
"stop_id" : 32,
"arrival_time" : "22:26:31" , 
"departure_time" : "22:27:06" , 
"distance_traveled" : 19.3049
}, 
{ 
"stop_id" : 47,
"arrival_time" : "22:28:35" , 
"departure_time" : "22:29:36" , 
"distance_traveled" : 20.4888
}, 
{ 
"stop_id" : 155,
"arrival_time" : "22:32:01" , 
"departure_time" : "22:32:37" , 
"distance_traveled" : 21.704
}, 
{ 
"stop_id" : 44,
"arrival_time" : "22:36:36" , 
"departure_time" : "22:37:27" , 
"distance_traveled" : 23.7926
}, 
{ 
"stop_id" : 102,
"arrival_time" : "22:39:51" , 
"departure_time" : "22:40:40" , 
"distance_traveled" : 25.0439
}, 
{ 
"stop_id" : 120,
"arrival_time" : "22:42:49" , 
"departure_time" : "22:43:08" , 
"distance_traveled" : 26.1886
}, 
{ 
"stop_id" : 36,
"arrival_time" : "22:48:19" , 
"departure_time" : "22:48:38" , 
"distance_traveled" : 29.1286
}, 
{ 
"stop_id" : 21,
"arrival_time" : "22:53:19" , 
"departure_time" : "22:54:18" , 
"distance_traveled" : 33.3701
}, 
{ 
"stop_id" : 24,
"arrival_time" : "22:56:59" , 
"departure_time" : "22:57:25" , 
"distance_traveled" : 34.4814
}, 
{ 
"stop_id" : 138,
"arrival_time" : "23:02:26" , 
"departure_time" : "23:03:23" , 
"distance_traveled" : 37.815
}, 
{ 
"stop_id" : 129,
"arrival_time" : "23:09:57" , 
"departure_time" : "23:09:57" , 
"distance_traveled" : 38.9788
} ], 
"4789" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "17:42:00" , 
"departure_time" : "17:43:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "17:51:43" , 
"departure_time" : "17:52:53" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "17:56:10" , 
"departure_time" : "17:56:33" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "18:00:23" , 
"departure_time" : "18:00:56" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "18:03:33" , 
"departure_time" : "18:03:58" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "18:07:25" , 
"departure_time" : "18:09:01" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "18:12:36" , 
"departure_time" : "18:13:59" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "18:16:23" , 
"departure_time" : "18:18:03" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "18:19:40" , 
"departure_time" : "18:21:11" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "18:25:31" , 
"departure_time" : "18:27:03" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "18:31:32" , 
"departure_time" : "18:32:43" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "18:34:11" , 
"departure_time" : "18:34:26" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "18:38:15" , 
"departure_time" : "18:39:34" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "18:45:19" , 
"departure_time" : "18:45:19" , 
"distance_traveled" : 28.9235
} ], 
"4790" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "07:21:00" , 
"departure_time" : "07:23:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "07:31:18" , 
"departure_time" : "07:32:47" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "07:34:29" , 
"departure_time" : "07:35:53" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "07:39:24" , 
"departure_time" : "07:40:02" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "07:41:38" , 
"departure_time" : "07:42:06" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "07:44:28" , 
"departure_time" : "07:45:17" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "07:49:49" , 
"departure_time" : "07:51:09" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "07:53:20" , 
"departure_time" : "07:54:49" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "07:56:29" , 
"departure_time" : "07:57:14" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "08:00:45" , 
"departure_time" : "08:01:36" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "08:06:51" , 
"departure_time" : "08:08:04" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "08:10:13" , 
"departure_time" : "08:11:26" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "08:15:13" , 
"departure_time" : "08:16:14" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "08:18:01" , 
"departure_time" : "08:18:58" , 
"distance_traveled" : 28.9235
}, 
{ 
"stop_id" : 108,
"arrival_time" : "08:24:57" , 
"departure_time" : "08:26:28" , 
"distance_traveled" : 32.4008
}, 
{ 
"stop_id" : 157,
"arrival_time" : "08:32:31" , 
"departure_time" : "08:33:42" , 
"distance_traveled" : 37.3002
}, 
{ 
"stop_id" : 68,
"arrival_time" : "08:39:11" , 
"departure_time" : "08:39:27" , 
"distance_traveled" : 41.0837
}, 
{ 
"stop_id" : 6,
"arrival_time" : "08:42:16" , 
"departure_time" : "08:43:08" , 
"distance_traveled" : 43.442
}, 
{ 
"stop_id" : 60,
"arrival_time" : "08:52:52" , 
"departure_time" : "08:52:52" , 
"distance_traveled" : 45.2331
} ], 
"4791" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "20:12:00" , 
"departure_time" : "20:14:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "20:22:32" , 
"departure_time" : "20:22:40" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "20:24:08" , 
"departure_time" : "20:24:16" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "20:29:08" , 
"departure_time" : "20:29:26" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "20:32:18" , 
"departure_time" : "20:32:20" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "20:35:02" , 
"departure_time" : "20:36:19" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "20:41:17" , 
"departure_time" : "20:41:55" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "20:43:38" , 
"departure_time" : "20:44:50" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "20:47:12" , 
"departure_time" : "20:47:55" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "20:51:43" , 
"departure_time" : "20:52:22" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "20:57:39" , 
"departure_time" : "20:58:03" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "21:00:24" , 
"departure_time" : "21:01:56" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "21:06:32" , 
"departure_time" : "21:07:49" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "21:12:17" , 
"departure_time" : "21:12:17" , 
"distance_traveled" : 28.9235
} ], 
"4792" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "10:06:00" , 
"departure_time" : "10:08:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "10:16:25" , 
"departure_time" : "10:16:48" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "10:18:23" , 
"departure_time" : "10:18:52" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "10:23:29" , 
"departure_time" : "10:23:56" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "10:26:27" , 
"departure_time" : "10:27:57" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "10:30:30" , 
"departure_time" : "10:30:32" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "10:34:02" , 
"departure_time" : "10:34:28" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "10:37:26" , 
"departure_time" : "10:38:05" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "10:41:39" , 
"departure_time" : "10:42:51" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "10:47:12" , 
"departure_time" : "10:47:26" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "10:51:14" , 
"departure_time" : "10:52:52" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "10:55:38" , 
"departure_time" : "10:56:05" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "11:00:27" , 
"departure_time" : "11:02:03" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "11:04:36" , 
"departure_time" : "11:04:40" , 
"distance_traveled" : 28.9235
}, 
{ 
"stop_id" : 108,
"arrival_time" : "11:09:04" , 
"departure_time" : "11:10:08" , 
"distance_traveled" : 32.4008
}, 
{ 
"stop_id" : 157,
"arrival_time" : "11:17:04" , 
"departure_time" : "11:17:20" , 
"distance_traveled" : 37.3002
}, 
{ 
"stop_id" : 68,
"arrival_time" : "11:22:16" , 
"departure_time" : "11:22:36" , 
"distance_traveled" : 41.0837
}, 
{ 
"stop_id" : 6,
"arrival_time" : "11:27:20" , 
"departure_time" : "11:28:34" , 
"distance_traveled" : 43.442
}, 
{ 
"stop_id" : 60,
"arrival_time" : "11:41:14" , 
"departure_time" : "11:41:14" , 
"distance_traveled" : 45.2331
} ], 
"4793" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "10:44:00" , 
"departure_time" : "10:46:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "10:53:51" , 
"departure_time" : "10:54:10" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "11:06:19" , 
"departure_time" : "11:06:39" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "11:15:20" , 
"departure_time" : "11:15:57" , 
"distance_traveled" : 15.3146
}, 
{ 
"stop_id" : 31,
"arrival_time" : "11:18:37" , 
"departure_time" : "11:18:45" , 
"distance_traveled" : 17.161
}, 
{ 
"stop_id" : 32,
"arrival_time" : "11:23:08" , 
"departure_time" : "11:24:36" , 
"distance_traveled" : 19.3049
}, 
{ 
"stop_id" : 155,
"arrival_time" : "11:28:28" , 
"departure_time" : "11:28:52" , 
"distance_traveled" : 21.6676
}, 
{ 
"stop_id" : 44,
"arrival_time" : "11:32:24" , 
"departure_time" : "11:33:34" , 
"distance_traveled" : 23.7563
}, 
{ 
"stop_id" : 102,
"arrival_time" : "11:36:10" , 
"departure_time" : "11:36:25" , 
"distance_traveled" : 25.0076
}, 
{ 
"stop_id" : 120,
"arrival_time" : "11:38:15" , 
"departure_time" : "11:38:28" , 
"distance_traveled" : 26.1523
}, 
{ 
"stop_id" : 36,
"arrival_time" : "11:43:13" , 
"departure_time" : "11:43:39" , 
"distance_traveled" : 29.0922
}, 
{ 
"stop_id" : 21,
"arrival_time" : "11:49:26" , 
"departure_time" : "11:50:36" , 
"distance_traveled" : 33.3337
}, 
{ 
"stop_id" : 24,
"arrival_time" : "11:53:10" , 
"departure_time" : "11:53:38" , 
"distance_traveled" : 34.4451
}, 
{ 
"stop_id" : 138,
"arrival_time" : "11:57:28" , 
"departure_time" : "11:58:52" , 
"distance_traveled" : 37.7786
}, 
{ 
"stop_id" : 129,
"arrival_time" : "12:11:24" , 
"departure_time" : "12:11:24" , 
"distance_traveled" : 38.9424
} ], 
"4794" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "16:44:00" , 
"departure_time" : "16:45:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "16:54:15" , 
"departure_time" : "16:55:53" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "16:59:38" , 
"departure_time" : "17:00:36" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "17:03:58" , 
"departure_time" : "17:04:09" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "17:06:11" , 
"departure_time" : "17:06:14" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "17:10:03" , 
"departure_time" : "17:11:09" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "17:16:06" , 
"departure_time" : "17:17:35" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "17:19:29" , 
"departure_time" : "17:21:06" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "17:23:37" , 
"departure_time" : "17:24:11" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "17:27:34" , 
"departure_time" : "17:28:16" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "17:33:42" , 
"departure_time" : "17:34:46" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "17:37:04" , 
"departure_time" : "17:37:23" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "17:42:19" , 
"departure_time" : "17:42:30" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "17:45:11" , 
"departure_time" : "17:45:37" , 
"distance_traveled" : 28.9235
}, 
{ 
"stop_id" : 108,
"arrival_time" : "17:52:26" , 
"departure_time" : "17:53:20" , 
"distance_traveled" : 32.4008
}, 
{ 
"stop_id" : 157,
"arrival_time" : "17:59:54" , 
"departure_time" : "18:00:25" , 
"distance_traveled" : 37.3002
}, 
{ 
"stop_id" : 68,
"arrival_time" : "18:06:31" , 
"departure_time" : "18:07:20" , 
"distance_traveled" : 41.0837
}, 
{ 
"stop_id" : 6,
"arrival_time" : "18:11:49" , 
"departure_time" : "18:12:44" , 
"distance_traveled" : 43.442
}, 
{ 
"stop_id" : 60,
"arrival_time" : "18:20:55" , 
"departure_time" : "18:20:55" , 
"distance_traveled" : 45.2331
} ], 
"4795" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "11:49:00" , 
"departure_time" : "11:51:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "11:59:27" , 
"departure_time" : "12:00:08" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "12:08:41" , 
"departure_time" : "12:08:48" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "12:17:07" , 
"departure_time" : "12:17:42" , 
"distance_traveled" : 15.3146
}, 
{ 
"stop_id" : 31,
"arrival_time" : "12:20:35" , 
"departure_time" : "12:20:49" , 
"distance_traveled" : 17.161
}, 
{ 
"stop_id" : 32,
"arrival_time" : "12:25:14" , 
"departure_time" : "12:26:25" , 
"distance_traveled" : 19.3049
}, 
{ 
"stop_id" : 155,
"arrival_time" : "12:30:11" , 
"departure_time" : "12:30:41" , 
"distance_traveled" : 21.6676
}, 
{ 
"stop_id" : 44,
"arrival_time" : "12:34:30" , 
"departure_time" : "12:34:44" , 
"distance_traveled" : 23.7563
}, 
{ 
"stop_id" : 102,
"arrival_time" : "12:37:14" , 
"departure_time" : "12:37:25" , 
"distance_traveled" : 25.0076
}, 
{ 
"stop_id" : 120,
"arrival_time" : "12:40:11" , 
"departure_time" : "12:40:43" , 
"distance_traveled" : 26.1523
}, 
{ 
"stop_id" : 36,
"arrival_time" : "12:45:32" , 
"departure_time" : "12:45:43" , 
"distance_traveled" : 29.0922
}, 
{ 
"stop_id" : 21,
"arrival_time" : "12:51:11" , 
"departure_time" : "12:51:15" , 
"distance_traveled" : 33.3337
}, 
{ 
"stop_id" : 24,
"arrival_time" : "12:54:04" , 
"departure_time" : "12:54:46" , 
"distance_traveled" : 34.4451
}, 
{ 
"stop_id" : 138,
"arrival_time" : "12:59:42" , 
"departure_time" : "13:01:15" , 
"distance_traveled" : 37.7786
}, 
{ 
"stop_id" : 129,
"arrival_time" : "13:12:33" , 
"departure_time" : "13:12:33" , 
"distance_traveled" : 38.9424
} ], 
"4796" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "19:12:00" , 
"departure_time" : "19:14:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "19:22:20" , 
"departure_time" : "19:22:43" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "19:25:23" , 
"departure_time" : "19:25:36" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "19:30:13" , 
"departure_time" : "19:30:42" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "19:33:29" , 
"departure_time" : "19:33:42" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "19:36:13" , 
"departure_time" : "19:36:14" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "19:41:01" , 
"departure_time" : "19:42:21" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "19:46:20" , 
"departure_time" : "19:47:06" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "19:48:46" , 
"departure_time" : "19:49:33" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "19:53:47" , 
"departure_time" : "19:55:05" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "20:00:18" , 
"departure_time" : "20:01:41" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "20:03:23" , 
"departure_time" : "20:03:49" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "20:07:26" , 
"departure_time" : "20:08:00" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "20:10:34" , 
"departure_time" : "20:11:17" , 
"distance_traveled" : 28.9235
}, 
{ 
"stop_id" : 108,
"arrival_time" : "20:17:43" , 
"departure_time" : "20:18:03" , 
"distance_traveled" : 32.4008
}, 
{ 
"stop_id" : 157,
"arrival_time" : "20:24:20" , 
"departure_time" : "20:24:44" , 
"distance_traveled" : 37.3002
}, 
{ 
"stop_id" : 68,
"arrival_time" : "20:30:24" , 
"departure_time" : "20:31:01" , 
"distance_traveled" : 41.0837
}, 
{ 
"stop_id" : 6,
"arrival_time" : "20:35:37" , 
"departure_time" : "20:35:51" , 
"distance_traveled" : 43.442
}, 
{ 
"stop_id" : 60,
"arrival_time" : "20:44:14" , 
"departure_time" : "20:44:14" , 
"distance_traveled" : 45.2331
} ], 
"4797" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "13:47:00" , 
"departure_time" : "13:47:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "13:56:22" , 
"departure_time" : "13:57:33" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "14:07:11" , 
"departure_time" : "14:08:45" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "14:16:34" , 
"departure_time" : "14:17:47" , 
"distance_traveled" : 15.3146
}, 
{ 
"stop_id" : 31,
"arrival_time" : "14:19:13" , 
"departure_time" : "14:19:37" , 
"distance_traveled" : 17.161
}, 
{ 
"stop_id" : 32,
"arrival_time" : "14:23:24" , 
"departure_time" : "14:24:27" , 
"distance_traveled" : 19.3049
}, 
{ 
"stop_id" : 47,
"arrival_time" : "14:27:03" , 
"departure_time" : "14:27:14" , 
"distance_traveled" : 20.4888
}, 
{ 
"stop_id" : 155,
"arrival_time" : "14:29:11" , 
"departure_time" : "14:30:11" , 
"distance_traveled" : 21.704
}, 
{ 
"stop_id" : 44,
"arrival_time" : "14:35:00" , 
"departure_time" : "14:35:25" , 
"distance_traveled" : 23.7926
}, 
{ 
"stop_id" : 102,
"arrival_time" : "14:37:25" , 
"departure_time" : "14:38:18" , 
"distance_traveled" : 25.0439
}, 
{ 
"stop_id" : 120,
"arrival_time" : "14:41:53" , 
"departure_time" : "14:43:33" , 
"distance_traveled" : 26.1886
}, 
{ 
"stop_id" : 36,
"arrival_time" : "14:47:40" , 
"departure_time" : "14:47:52" , 
"distance_traveled" : 29.1286
}, 
{ 
"stop_id" : 21,
"arrival_time" : "14:51:12" , 
"departure_time" : "14:51:19" , 
"distance_traveled" : 33.3701
}, 
{ 
"stop_id" : 24,
"arrival_time" : "14:54:07" , 
"departure_time" : "14:54:40" , 
"distance_traveled" : 34.4814
}, 
{ 
"stop_id" : 138,
"arrival_time" : "15:00:33" , 
"departure_time" : "15:02:08" , 
"distance_traveled" : 37.815
}, 
{ 
"stop_id" : 129,
"arrival_time" : "15:13:35" , 
"departure_time" : "15:13:35" , 
"distance_traveled" : 38.9788
} ], 
"4798" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "12:49:00" , 
"departure_time" : "12:52:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:59:38" , 
"departure_time" : "13:00:44" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:09:06" , 
"departure_time" : "13:09:17" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "13:17:11" , 
"departure_time" : "13:18:17" , 
"distance_traveled" : 15.3146
}, 
{ 
"stop_id" : 31,
"arrival_time" : "13:21:06" , 
"departure_time" : "13:22:16" , 
"distance_traveled" : 17.161
}, 
{ 
"stop_id" : 32,
"arrival_time" : "13:26:10" , 
"departure_time" : "13:27:08" , 
"distance_traveled" : 19.3049
}, 
{ 
"stop_id" : 155,
"arrival_time" : "13:29:58" , 
"departure_time" : "13:30:53" , 
"distance_traveled" : 21.6676
}, 
{ 
"stop_id" : 44,
"arrival_time" : "13:34:55" , 
"departure_time" : "13:36:14" , 
"distance_traveled" : 23.7563
}, 
{ 
"stop_id" : 102,
"arrival_time" : "13:38:19" , 
"departure_time" : "13:39:04" , 
"distance_traveled" : 25.0076
}, 
{ 
"stop_id" : 120,
"arrival_time" : "13:40:45" , 
"departure_time" : "13:42:05" , 
"distance_traveled" : 26.1523
}, 
{ 
"stop_id" : 36,
"arrival_time" : "13:46:20" , 
"departure_time" : "13:46:29" , 
"distance_traveled" : 29.0922
}, 
{ 
"stop_id" : 21,
"arrival_time" : "13:51:09" , 
"departure_time" : "13:52:32" , 
"distance_traveled" : 33.3337
}, 
{ 
"stop_id" : 24,
"arrival_time" : "13:55:23" , 
"departure_time" : "13:55:29" , 
"distance_traveled" : 34.4451
}, 
{ 
"stop_id" : 138,
"arrival_time" : "13:59:06" , 
"departure_time" : "14:00:19" , 
"distance_traveled" : 37.7786
}, 
{ 
"stop_id" : 129,
"arrival_time" : "14:03:13" , 
"departure_time" : "14:03:38" , 
"distance_traveled" : 38.9424
}, 
{ 
"stop_id" : 108,
"arrival_time" : "14:09:25" , 
"departure_time" : "14:09:29" , 
"distance_traveled" : 42.4197
}, 
{ 
"stop_id" : 157,
"arrival_time" : "14:16:04" , 
"departure_time" : "14:17:33" , 
"distance_traveled" : 47.3191
}, 
{ 
"stop_id" : 68,
"arrival_time" : "14:23:29" , 
"departure_time" : "14:24:43" , 
"distance_traveled" : 51.1027
}, 
{ 
"stop_id" : 6,
"arrival_time" : "14:28:14" , 
"departure_time" : "14:28:58" , 
"distance_traveled" : 53.461
}, 
{ 
"stop_id" : 60,
"arrival_time" : "14:41:44" , 
"departure_time" : "14:41:44" , 
"distance_traveled" : 55.2521
} ], 
"4799" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "21:48:00" , 
"departure_time" : "21:50:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "21:58:28" , 
"departure_time" : "21:58:44" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "22:08:16" , 
"departure_time" : "22:08:36" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "22:17:20" , 
"departure_time" : "22:17:44" , 
"distance_traveled" : 15.3146
}, 
{ 
"stop_id" : 31,
"arrival_time" : "22:20:24" , 
"departure_time" : "22:20:47" , 
"distance_traveled" : 17.161
}, 
{ 
"stop_id" : 32,
"arrival_time" : "22:25:23" , 
"departure_time" : "22:25:40" , 
"distance_traveled" : 19.3049
}, 
{ 
"stop_id" : 47,
"arrival_time" : "22:28:17" , 
"departure_time" : "22:28:58" , 
"distance_traveled" : 20.4888
}, 
{ 
"stop_id" : 155,
"arrival_time" : "22:31:41" , 
"departure_time" : "22:32:48" , 
"distance_traveled" : 21.704
}, 
{ 
"stop_id" : 44,
"arrival_time" : "22:37:07" , 
"departure_time" : "22:38:05" , 
"distance_traveled" : 23.7926
}, 
{ 
"stop_id" : 102,
"arrival_time" : "22:39:58" , 
"departure_time" : "22:40:45" , 
"distance_traveled" : 25.0439
}, 
{ 
"stop_id" : 120,
"arrival_time" : "22:42:47" , 
"departure_time" : "22:43:20" , 
"distance_traveled" : 26.1886
}, 
{ 
"stop_id" : 36,
"arrival_time" : "22:48:33" , 
"departure_time" : "22:48:53" , 
"distance_traveled" : 29.1286
}, 
{ 
"stop_id" : 21,
"arrival_time" : "22:53:20" , 
"departure_time" : "22:53:58" , 
"distance_traveled" : 33.3701
}, 
{ 
"stop_id" : 24,
"arrival_time" : "22:56:38" , 
"departure_time" : "22:57:32" , 
"distance_traveled" : 34.4814
}, 
{ 
"stop_id" : 138,
"arrival_time" : "23:02:54" , 
"departure_time" : "23:03:27" , 
"distance_traveled" : 37.815
}, 
{ 
"stop_id" : 129,
"arrival_time" : "23:09:33" , 
"departure_time" : "23:09:33" , 
"distance_traveled" : 38.9788
} ], 
"4800" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "22:48:00" , 
"departure_time" : "22:50:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:58:39" , 
"departure_time" : "23:00:01" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "23:09:22" , 
"departure_time" : "23:09:49" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "23:17:27" , 
"departure_time" : "23:18:14" , 
"distance_traveled" : 15.3146
}, 
{ 
"stop_id" : 31,
"arrival_time" : "23:20:47" , 
"departure_time" : "23:21:14" , 
"distance_traveled" : 17.161
}, 
{ 
"stop_id" : 32,
"arrival_time" : "23:25:27" , 
"departure_time" : "23:26:41" , 
"distance_traveled" : 19.3049
}, 
{ 
"stop_id" : 155,
"arrival_time" : "23:30:14" , 
"departure_time" : "23:31:50" , 
"distance_traveled" : 21.6676
}, 
{ 
"stop_id" : 44,
"arrival_time" : "23:35:36" , 
"departure_time" : "23:35:40" , 
"distance_traveled" : 23.7563
}, 
{ 
"stop_id" : 102,
"arrival_time" : "23:37:04" , 
"departure_time" : "23:38:04" , 
"distance_traveled" : 25.0076
}, 
{ 
"stop_id" : 120,
"arrival_time" : "23:41:00" , 
"departure_time" : "23:42:13" , 
"distance_traveled" : 26.1523
}, 
{ 
"stop_id" : 36,
"arrival_time" : "23:46:13" , 
"departure_time" : "23:46:47" , 
"distance_traveled" : 29.0922
}, 
{ 
"stop_id" : 21,
"arrival_time" : "23:51:34" , 
"departure_time" : "23:52:03" , 
"distance_traveled" : 33.3337
}, 
{ 
"stop_id" : 24,
"arrival_time" : "23:54:29" , 
"departure_time" : "23:55:26" , 
"distance_traveled" : 34.4451
}, 
{ 
"stop_id" : 138,
"arrival_time" : "23:59:57" , 
"departure_time" : "24:00:01" , 
"distance_traveled" : 37.7786
}, 
{ 
"stop_id" : 129,
"arrival_time" : "24:02:04" , 
"departure_time" : "24:03:03" , 
"distance_traveled" : 38.9424
}, 
{ 
"stop_id" : 108,
"arrival_time" : "24:08:59" , 
"departure_time" : "24:10:03" , 
"distance_traveled" : 42.4197
}, 
{ 
"stop_id" : 157,
"arrival_time" : "24:16:04" , 
"departure_time" : "24:16:48" , 
"distance_traveled" : 47.3191
}, 
{ 
"stop_id" : 68,
"arrival_time" : "24:22:44" , 
"departure_time" : "24:23:01" , 
"distance_traveled" : 51.1027
}, 
{ 
"stop_id" : 6,
"arrival_time" : "24:26:17" , 
"departure_time" : "24:26:58" , 
"distance_traveled" : 53.461
}, 
{ 
"stop_id" : 60,
"arrival_time" : "24:36:41" , 
"departure_time" : "24:36:41" , 
"distance_traveled" : 55.2521
} ], 
"4801" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "07:21:00" , 
"departure_time" : "07:23:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "07:31:32" , 
"departure_time" : "07:31:42" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "07:33:10" , 
"departure_time" : "07:33:48" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "07:38:38" , 
"departure_time" : "07:39:33" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "07:41:55" , 
"departure_time" : "07:43:04" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "07:45:09" , 
"departure_time" : "07:45:23" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "07:49:14" , 
"departure_time" : "07:49:56" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "07:52:42" , 
"departure_time" : "07:53:04" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "07:55:22" , 
"departure_time" : "07:55:23" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "08:00:01" , 
"departure_time" : "08:00:03" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "08:06:02" , 
"departure_time" : "08:06:48" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "08:09:46" , 
"departure_time" : "08:11:24" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "08:15:38" , 
"departure_time" : "08:16:46" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "08:18:08" , 
"departure_time" : "08:18:10" , 
"distance_traveled" : 28.9235
}, 
{ 
"stop_id" : 108,
"arrival_time" : "08:24:02" , 
"departure_time" : "08:24:10" , 
"distance_traveled" : 32.4008
}, 
{ 
"stop_id" : 157,
"arrival_time" : "08:31:08" , 
"departure_time" : "08:31:24" , 
"distance_traveled" : 37.3002
}, 
{ 
"stop_id" : 68,
"arrival_time" : "08:38:16" , 
"departure_time" : "08:38:55" , 
"distance_traveled" : 41.0837
}, 
{ 
"stop_id" : 6,
"arrival_time" : "08:42:39" , 
"departure_time" : "08:43:49" , 
"distance_traveled" : 43.442
}, 
{ 
"stop_id" : 60,
"arrival_time" : "08:53:10" , 
"departure_time" : "08:53:10" , 
"distance_traveled" : 45.2331
} ], 
"4802" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "14:39:00" , 
"departure_time" : "14:40:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:48:19" , 
"departure_time" : "14:48:32" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:01:13" , 
"departure_time" : "15:01:32" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "15:10:19" , 
"departure_time" : "15:10:40" , 
"distance_traveled" : 15.3146
}, 
{ 
"stop_id" : 31,
"arrival_time" : "15:13:21" , 
"departure_time" : "15:13:37" , 
"distance_traveled" : 17.161
}, 
{ 
"stop_id" : 32,
"arrival_time" : "15:18:16" , 
"departure_time" : "15:19:15" , 
"distance_traveled" : 19.3049
}, 
{ 
"stop_id" : 47,
"arrival_time" : "15:21:59" , 
"departure_time" : "15:22:18" , 
"distance_traveled" : 20.4888
}, 
{ 
"stop_id" : 155,
"arrival_time" : "15:24:19" , 
"departure_time" : "15:25:05" , 
"distance_traveled" : 21.704
}, 
{ 
"stop_id" : 44,
"arrival_time" : "15:28:46" , 
"departure_time" : "15:29:37" , 
"distance_traveled" : 23.7926
}, 
{ 
"stop_id" : 102,
"arrival_time" : "15:31:51" , 
"departure_time" : "15:32:52" , 
"distance_traveled" : 25.0439
}, 
{ 
"stop_id" : 120,
"arrival_time" : "15:36:01" , 
"departure_time" : "15:36:52" , 
"distance_traveled" : 26.1886
}, 
{ 
"stop_id" : 36,
"arrival_time" : "15:40:51" , 
"departure_time" : "15:42:06" , 
"distance_traveled" : 29.1286
}, 
{ 
"stop_id" : 21,
"arrival_time" : "15:46:15" , 
"departure_time" : "15:47:14" , 
"distance_traveled" : 33.3701
}, 
{ 
"stop_id" : 24,
"arrival_time" : "15:48:59" , 
"departure_time" : "15:49:36" , 
"distance_traveled" : 34.4814
}, 
{ 
"stop_id" : 138,
"arrival_time" : "15:53:37" , 
"departure_time" : "15:54:08" , 
"distance_traveled" : 37.815
}, 
{ 
"stop_id" : 129,
"arrival_time" : "15:56:31" , 
"departure_time" : "15:57:35" , 
"distance_traveled" : 38.9788
}, 
{ 
"stop_id" : 108,
"arrival_time" : "16:03:04" , 
"departure_time" : "16:03:29" , 
"distance_traveled" : 42.4561
}, 
{ 
"stop_id" : 157,
"arrival_time" : "16:09:25" , 
"departure_time" : "16:11:03" , 
"distance_traveled" : 47.3555
}, 
{ 
"stop_id" : 68,
"arrival_time" : "16:16:38" , 
"departure_time" : "16:16:51" , 
"distance_traveled" : 51.139
}, 
{ 
"stop_id" : 6,
"arrival_time" : "16:20:13" , 
"departure_time" : "16:21:33" , 
"distance_traveled" : 53.4973
}, 
{ 
"stop_id" : 60,
"arrival_time" : "16:31:20" , 
"departure_time" : "16:31:20" , 
"distance_traveled" : 55.2884
} ], 
"4803" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "10:06:00" , 
"departure_time" : "10:08:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "10:15:48" , 
"departure_time" : "10:17:27" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "10:19:39" , 
"departure_time" : "10:19:59" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "10:23:20" , 
"departure_time" : "10:24:45" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "10:27:25" , 
"departure_time" : "10:27:47" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "10:29:22" , 
"departure_time" : "10:30:47" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "10:35:25" , 
"departure_time" : "10:36:10" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "10:37:45" , 
"departure_time" : "10:38:04" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "10:41:19" , 
"departure_time" : "10:42:49" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "10:47:30" , 
"departure_time" : "10:48:35" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "10:52:05" , 
"departure_time" : "10:52:55" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "10:54:50" , 
"departure_time" : "10:55:14" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "11:00:24" , 
"departure_time" : "11:01:18" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "11:03:54" , 
"departure_time" : "11:03:55" , 
"distance_traveled" : 28.9235
}, 
{ 
"stop_id" : 108,
"arrival_time" : "11:09:01" , 
"departure_time" : "11:09:30" , 
"distance_traveled" : 32.4008
}, 
{ 
"stop_id" : 157,
"arrival_time" : "11:16:29" , 
"departure_time" : "11:17:12" , 
"distance_traveled" : 37.3002
}, 
{ 
"stop_id" : 68,
"arrival_time" : "11:22:43" , 
"departure_time" : "11:22:50" , 
"distance_traveled" : 41.0837
}, 
{ 
"stop_id" : 6,
"arrival_time" : "11:27:07" , 
"departure_time" : "11:27:32" , 
"distance_traveled" : 43.442
}, 
{ 
"stop_id" : 60,
"arrival_time" : "11:40:25" , 
"departure_time" : "11:40:25" , 
"distance_traveled" : 45.2331
} ], 
"4804" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:48:00" , 
"departure_time" : "20:49:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:57:51" , 
"departure_time" : "20:58:49" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:08:58" , 
"departure_time" : "21:10:32" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "21:18:34" , 
"departure_time" : "21:19:31" , 
"distance_traveled" : 15.3146
}, 
{ 
"stop_id" : 31,
"arrival_time" : "21:21:57" , 
"departure_time" : "21:22:06" , 
"distance_traveled" : 17.161
}, 
{ 
"stop_id" : 32,
"arrival_time" : "21:25:09" , 
"departure_time" : "21:26:08" , 
"distance_traveled" : 19.3049
}, 
{ 
"stop_id" : 47,
"arrival_time" : "21:28:59" , 
"departure_time" : "21:30:36" , 
"distance_traveled" : 20.4888
}, 
{ 
"stop_id" : 155,
"arrival_time" : "21:32:37" , 
"departure_time" : "21:34:06" , 
"distance_traveled" : 21.704
}, 
{ 
"stop_id" : 44,
"arrival_time" : "21:37:29" , 
"departure_time" : "21:37:33" , 
"distance_traveled" : 23.7926
}, 
{ 
"stop_id" : 102,
"arrival_time" : "21:39:04" , 
"departure_time" : "21:40:22" , 
"distance_traveled" : 25.0439
}, 
{ 
"stop_id" : 120,
"arrival_time" : "21:43:18" , 
"departure_time" : "21:44:38" , 
"distance_traveled" : 26.1886
}, 
{ 
"stop_id" : 36,
"arrival_time" : "21:48:20" , 
"departure_time" : "21:48:25" , 
"distance_traveled" : 29.1286
}, 
{ 
"stop_id" : 21,
"arrival_time" : "21:52:05" , 
"departure_time" : "21:52:43" , 
"distance_traveled" : 33.3701
}, 
{ 
"stop_id" : 24,
"arrival_time" : "21:55:38" , 
"departure_time" : "21:56:15" , 
"distance_traveled" : 34.4814
}, 
{ 
"stop_id" : 138,
"arrival_time" : "22:00:37" , 
"departure_time" : "22:00:52" , 
"distance_traveled" : 37.815
}, 
{ 
"stop_id" : 129,
"arrival_time" : "22:03:15" , 
"departure_time" : "22:03:28" , 
"distance_traveled" : 38.9788
}, 
{ 
"stop_id" : 108,
"arrival_time" : "22:10:13" , 
"departure_time" : "22:10:53" , 
"distance_traveled" : 42.4561
}, 
{ 
"stop_id" : 157,
"arrival_time" : "22:17:40" , 
"departure_time" : "22:18:08" , 
"distance_traveled" : 47.3555
}, 
{ 
"stop_id" : 68,
"arrival_time" : "22:23:28" , 
"departure_time" : "22:23:45" , 
"distance_traveled" : 51.139
}, 
{ 
"stop_id" : 6,
"arrival_time" : "22:28:17" , 
"departure_time" : "22:29:23" , 
"distance_traveled" : 53.4973
}, 
{ 
"stop_id" : 60,
"arrival_time" : "22:38:06" , 
"departure_time" : "22:38:06" , 
"distance_traveled" : 55.2884
} ], 
"4805" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "16:44:00" , 
"departure_time" : "16:46:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "16:55:12" , 
"departure_time" : "16:56:07" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "16:58:55" , 
"departure_time" : "16:59:31" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "17:03:36" , 
"departure_time" : "17:04:19" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "17:06:43" , 
"departure_time" : "17:06:55" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "17:10:12" , 
"departure_time" : "17:10:47" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "17:15:35" , 
"departure_time" : "17:15:55" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "17:18:20" , 
"departure_time" : "17:19:22" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "17:23:02" , 
"departure_time" : "17:24:34" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "17:28:32" , 
"departure_time" : "17:29:03" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "17:33:31" , 
"departure_time" : "17:35:06" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "17:37:35" , 
"departure_time" : "17:37:50" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "17:42:15" , 
"departure_time" : "17:42:32" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "17:45:17" , 
"departure_time" : "17:45:52" , 
"distance_traveled" : 28.9235
}, 
{ 
"stop_id" : 108,
"arrival_time" : "17:52:35" , 
"departure_time" : "17:52:38" , 
"distance_traveled" : 32.4008
}, 
{ 
"stop_id" : 157,
"arrival_time" : "17:59:03" , 
"departure_time" : "18:00:21" , 
"distance_traveled" : 37.3002
}, 
{ 
"stop_id" : 68,
"arrival_time" : "18:07:18" , 
"departure_time" : "18:08:41" , 
"distance_traveled" : 41.0837
}, 
{ 
"stop_id" : 6,
"arrival_time" : "18:12:23" , 
"departure_time" : "18:13:52" , 
"distance_traveled" : 43.442
}, 
{ 
"stop_id" : 60,
"arrival_time" : "18:21:29" , 
"departure_time" : "18:21:29" , 
"distance_traveled" : 45.2331
} ], 
"4806" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "19:12:00" , 
"departure_time" : "19:14:01" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "19:21:32" , 
"departure_time" : "19:22:02" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "19:25:30" , 
"departure_time" : "19:26:31" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "19:31:01" , 
"departure_time" : "19:31:15" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "19:33:14" , 
"departure_time" : "19:34:05" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "19:36:51" , 
"departure_time" : "19:37:52" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "19:42:01" , 
"departure_time" : "19:42:28" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "19:45:27" , 
"departure_time" : "19:45:32" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "19:48:05" , 
"departure_time" : "19:49:19" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "19:54:14" , 
"departure_time" : "19:55:14" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "20:00:00" , 
"departure_time" : "20:00:24" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "20:02:24" , 
"departure_time" : "20:02:57" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "20:07:33" , 
"departure_time" : "20:09:05" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "20:11:32" , 
"departure_time" : "20:12:31" , 
"distance_traveled" : 28.9235
}, 
{ 
"stop_id" : 108,
"arrival_time" : "20:17:59" , 
"departure_time" : "20:18:05" , 
"distance_traveled" : 32.4008
}, 
{ 
"stop_id" : 157,
"arrival_time" : "20:24:06" , 
"departure_time" : "20:24:34" , 
"distance_traveled" : 37.3002
}, 
{ 
"stop_id" : 68,
"arrival_time" : "20:30:28" , 
"departure_time" : "20:31:33" , 
"distance_traveled" : 41.0837
}, 
{ 
"stop_id" : 6,
"arrival_time" : "20:36:05" , 
"departure_time" : "20:37:37" , 
"distance_traveled" : 43.442
}, 
{ 
"stop_id" : 60,
"arrival_time" : "20:45:32" , 
"departure_time" : "20:45:32" , 
"distance_traveled" : 45.2331
} ], 
"4807" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "12:49:00" , 
"departure_time" : "12:52:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "12:59:40" , 
"departure_time" : "13:00:28" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "13:08:48" , 
"departure_time" : "13:09:33" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "13:17:45" , 
"departure_time" : "13:18:13" , 
"distance_traveled" : 15.3146
}, 
{ 
"stop_id" : 31,
"arrival_time" : "13:20:28" , 
"departure_time" : "13:21:21" , 
"distance_traveled" : 17.161
}, 
{ 
"stop_id" : 32,
"arrival_time" : "13:25:53" , 
"departure_time" : "13:26:05" , 
"distance_traveled" : 19.3049
}, 
{ 
"stop_id" : 155,
"arrival_time" : "13:29:12" , 
"departure_time" : "13:29:47" , 
"distance_traveled" : 21.6676
}, 
{ 
"stop_id" : 44,
"arrival_time" : "13:34:35" , 
"departure_time" : "13:36:02" , 
"distance_traveled" : 23.7563
}, 
{ 
"stop_id" : 102,
"arrival_time" : "13:38:27" , 
"departure_time" : "13:38:31" , 
"distance_traveled" : 25.0076
}, 
{ 
"stop_id" : 120,
"arrival_time" : "13:40:04" , 
"departure_time" : "13:40:42" , 
"distance_traveled" : 26.1523
}, 
{ 
"stop_id" : 36,
"arrival_time" : "13:45:38" , 
"departure_time" : "13:46:58" , 
"distance_traveled" : 29.0922
}, 
{ 
"stop_id" : 21,
"arrival_time" : "13:52:20" , 
"departure_time" : "13:53:47" , 
"distance_traveled" : 33.3337
}, 
{ 
"stop_id" : 24,
"arrival_time" : "13:55:27" , 
"departure_time" : "13:55:52" , 
"distance_traveled" : 34.4451
}, 
{ 
"stop_id" : 138,
"arrival_time" : "13:59:25" , 
"departure_time" : "14:00:32" , 
"distance_traveled" : 37.7786
}, 
{ 
"stop_id" : 129,
"arrival_time" : "14:03:07" , 
"departure_time" : "14:03:49" , 
"distance_traveled" : 38.9424
}, 
{ 
"stop_id" : 108,
"arrival_time" : "14:09:42" , 
"departure_time" : "14:11:10" , 
"distance_traveled" : 42.4197
}, 
{ 
"stop_id" : 157,
"arrival_time" : "14:17:28" , 
"departure_time" : "14:17:50" , 
"distance_traveled" : 47.3191
}, 
{ 
"stop_id" : 68,
"arrival_time" : "14:22:22" , 
"departure_time" : "14:22:35" , 
"distance_traveled" : 51.1027
}, 
{ 
"stop_id" : 6,
"arrival_time" : "14:27:13" , 
"departure_time" : "14:27:43" , 
"distance_traveled" : 53.461
}, 
{ 
"stop_id" : 60,
"arrival_time" : "14:41:30" , 
"departure_time" : "14:41:30" , 
"distance_traveled" : 55.2521
} ], 
"4808" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "22:48:00" , 
"departure_time" : "22:48:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "22:57:21" , 
"departure_time" : "22:58:48" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "23:09:27" , 
"departure_time" : "23:09:58" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "23:17:31" , 
"departure_time" : "23:18:40" , 
"distance_traveled" : 15.3146
}, 
{ 
"stop_id" : 31,
"arrival_time" : "23:21:09" , 
"departure_time" : "23:21:33" , 
"distance_traveled" : 17.161
}, 
{ 
"stop_id" : 32,
"arrival_time" : "23:25:24" , 
"departure_time" : "23:25:31" , 
"distance_traveled" : 19.3049
}, 
{ 
"stop_id" : 155,
"arrival_time" : "23:29:07" , 
"departure_time" : "23:30:16" , 
"distance_traveled" : 21.6676
}, 
{ 
"stop_id" : 44,
"arrival_time" : "23:35:09" , 
"departure_time" : "23:36:22" , 
"distance_traveled" : 23.7563
}, 
{ 
"stop_id" : 102,
"arrival_time" : "23:38:13" , 
"departure_time" : "23:39:22" , 
"distance_traveled" : 25.0076
}, 
{ 
"stop_id" : 120,
"arrival_time" : "23:41:09" , 
"departure_time" : "23:42:45" , 
"distance_traveled" : 26.1523
}, 
{ 
"stop_id" : 36,
"arrival_time" : "23:46:36" , 
"departure_time" : "23:47:56" , 
"distance_traveled" : 29.0922
}, 
{ 
"stop_id" : 21,
"arrival_time" : "23:52:20" , 
"departure_time" : "23:52:51" , 
"distance_traveled" : 33.3337
}, 
{ 
"stop_id" : 24,
"arrival_time" : "23:54:31" , 
"departure_time" : "23:55:29" , 
"distance_traveled" : 34.4451
}, 
{ 
"stop_id" : 138,
"arrival_time" : "23:59:58" , 
"departure_time" : "24:00:48" , 
"distance_traveled" : 37.7786
}, 
{ 
"stop_id" : 129,
"arrival_time" : "24:02:50" , 
"departure_time" : "24:04:16" , 
"distance_traveled" : 38.9424
}, 
{ 
"stop_id" : 108,
"arrival_time" : "24:09:26" , 
"departure_time" : "24:11:03" , 
"distance_traveled" : 42.4197
}, 
{ 
"stop_id" : 157,
"arrival_time" : "24:16:37" , 
"departure_time" : "24:16:51" , 
"distance_traveled" : 47.3191
}, 
{ 
"stop_id" : 68,
"arrival_time" : "24:22:14" , 
"departure_time" : "24:23:18" , 
"distance_traveled" : 51.1027
}, 
{ 
"stop_id" : 6,
"arrival_time" : "24:27:04" , 
"departure_time" : "24:28:16" , 
"distance_traveled" : 53.461
}, 
{ 
"stop_id" : 60,
"arrival_time" : "24:37:12" , 
"departure_time" : "24:37:12" , 
"distance_traveled" : 55.2521
} ], 
"4809" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "14:39:00" , 
"departure_time" : "14:41:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "14:49:14" , 
"departure_time" : "14:49:21" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "15:01:07" , 
"departure_time" : "15:02:24" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "15:11:17" , 
"departure_time" : "15:11:33" , 
"distance_traveled" : 15.3146
}, 
{ 
"stop_id" : 31,
"arrival_time" : "15:13:16" , 
"departure_time" : "15:13:44" , 
"distance_traveled" : 17.161
}, 
{ 
"stop_id" : 32,
"arrival_time" : "15:18:28" , 
"departure_time" : "15:18:45" , 
"distance_traveled" : 19.3049
}, 
{ 
"stop_id" : 47,
"arrival_time" : "15:21:17" , 
"departure_time" : "15:22:24" , 
"distance_traveled" : 20.4888
}, 
{ 
"stop_id" : 155,
"arrival_time" : "15:25:07" , 
"departure_time" : "15:26:40" , 
"distance_traveled" : 21.704
}, 
{ 
"stop_id" : 44,
"arrival_time" : "15:29:33" , 
"departure_time" : "15:30:08" , 
"distance_traveled" : 23.7926
}, 
{ 
"stop_id" : 102,
"arrival_time" : "15:31:35" , 
"departure_time" : "15:32:21" , 
"distance_traveled" : 25.0439
}, 
{ 
"stop_id" : 120,
"arrival_time" : "15:35:46" , 
"departure_time" : "15:37:05" , 
"distance_traveled" : 26.1886
}, 
{ 
"stop_id" : 36,
"arrival_time" : "15:41:19" , 
"departure_time" : "15:41:26" , 
"distance_traveled" : 29.1286
}, 
{ 
"stop_id" : 21,
"arrival_time" : "15:45:07" , 
"departure_time" : "15:45:27" , 
"distance_traveled" : 33.3701
}, 
{ 
"stop_id" : 24,
"arrival_time" : "15:48:20" , 
"departure_time" : "15:49:46" , 
"distance_traveled" : 34.4814
}, 
{ 
"stop_id" : 138,
"arrival_time" : "15:54:26" , 
"departure_time" : "15:55:18" , 
"distance_traveled" : 37.815
}, 
{ 
"stop_id" : 129,
"arrival_time" : "15:56:52" , 
"departure_time" : "15:57:06" , 
"distance_traveled" : 38.9788
}, 
{ 
"stop_id" : 108,
"arrival_time" : "16:02:14" , 
"departure_time" : "16:03:41" , 
"distance_traveled" : 42.4561
}, 
{ 
"stop_id" : 157,
"arrival_time" : "16:10:27" , 
"departure_time" : "16:11:43" , 
"distance_traveled" : 47.3555
}, 
{ 
"stop_id" : 68,
"arrival_time" : "16:16:16" , 
"departure_time" : "16:17:50" , 
"distance_traveled" : 51.139
}, 
{ 
"stop_id" : 6,
"arrival_time" : "16:21:34" , 
"departure_time" : "16:23:08" , 
"distance_traveled" : 53.4973
}, 
{ 
"stop_id" : 60,
"arrival_time" : "16:31:34" , 
"departure_time" : "16:31:34" , 
"distance_traveled" : 55.2884
} ], 
"4810" :  [ 
{ 
"stop_id" : 105,
"arrival_time" : "20:48:00" , 
"departure_time" : "20:49:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38187,
"arrival_time" : "20:57:22" , 
"departure_time" : "20:57:43" , 
"distance_traveled" : 4.9884
}, 
{ 
"stop_id" : 107,
"arrival_time" : "21:08:21" , 
"departure_time" : "21:08:56" , 
"distance_traveled" : 10.0572
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "21:17:35" , 
"departure_time" : "21:17:46" , 
"distance_traveled" : 15.3146
}, 
{ 
"stop_id" : 31,
"arrival_time" : "21:21:11" , 
"departure_time" : "21:21:56" , 
"distance_traveled" : 17.161
}, 
{ 
"stop_id" : 32,
"arrival_time" : "21:25:45" , 
"departure_time" : "21:26:34" , 
"distance_traveled" : 19.3049
}, 
{ 
"stop_id" : 47,
"arrival_time" : "21:28:49" , 
"departure_time" : "21:29:07" , 
"distance_traveled" : 20.4888
}, 
{ 
"stop_id" : 155,
"arrival_time" : "21:31:18" , 
"departure_time" : "21:32:58" , 
"distance_traveled" : 21.704
}, 
{ 
"stop_id" : 44,
"arrival_time" : "21:37:40" , 
"departure_time" : "21:38:59" , 
"distance_traveled" : 23.7926
}, 
{ 
"stop_id" : 102,
"arrival_time" : "21:40:19" , 
"departure_time" : "21:41:42" , 
"distance_traveled" : 25.0439
}, 
{ 
"stop_id" : 120,
"arrival_time" : "21:43:23" , 
"departure_time" : "21:44:53" , 
"distance_traveled" : 26.1886
}, 
{ 
"stop_id" : 36,
"arrival_time" : "21:48:30" , 
"departure_time" : "21:49:56" , 
"distance_traveled" : 29.1286
}, 
{ 
"stop_id" : 21,
"arrival_time" : "21:53:26" , 
"departure_time" : "21:54:04" , 
"distance_traveled" : 33.3701
}, 
{ 
"stop_id" : 24,
"arrival_time" : "21:55:38" , 
"departure_time" : "21:56:14" , 
"distance_traveled" : 34.4814
}, 
{ 
"stop_id" : 138,
"arrival_time" : "22:00:36" , 
"departure_time" : "22:01:01" , 
"distance_traveled" : 37.815
}, 
{ 
"stop_id" : 129,
"arrival_time" : "22:03:25" , 
"departure_time" : "22:04:25" , 
"distance_traveled" : 38.9788
}, 
{ 
"stop_id" : 108,
"arrival_time" : "22:11:00" , 
"departure_time" : "22:11:18" , 
"distance_traveled" : 42.4561
}, 
{ 
"stop_id" : 157,
"arrival_time" : "22:17:18" , 
"departure_time" : "22:18:51" , 
"distance_traveled" : 47.3555
}, 
{ 
"stop_id" : 68,
"arrival_time" : "22:24:33" , 
"departure_time" : "22:25:36" , 
"distance_traveled" : 51.139
}, 
{ 
"stop_id" : 6,
"arrival_time" : "22:29:03" , 
"departure_time" : "22:29:34" , 
"distance_traveled" : 53.4973
}, 
{ 
"stop_id" : 60,
"arrival_time" : "22:37:31" , 
"departure_time" : "22:37:31" , 
"distance_traveled" : 55.2884
} ], 
"4811" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "25:28:00" , 
"departure_time" : "25:29:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "25:38:00" , 
"departure_time" : "25:38:29" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "25:40:29" , 
"departure_time" : "25:40:39" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "25:45:10" , 
"departure_time" : "25:46:39" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "25:48:29" , 
"departure_time" : "25:50:05" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "25:51:36" , 
"departure_time" : "25:52:59" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "25:55:23" , 
"departure_time" : "25:56:07" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "25:57:44" , 
"departure_time" : "25:58:30" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "26:00:46" , 
"departure_time" : "26:00:48" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "26:05:02" , 
"departure_time" : "26:05:30" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "26:11:28" , 
"departure_time" : "26:12:42" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "26:14:14" , 
"departure_time" : "26:15:45" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "26:19:31" , 
"departure_time" : "26:20:42" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "26:35:11" , 
"departure_time" : "26:35:11" , 
"distance_traveled" : 28.9235
} ], 
"4812" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "06:38:00" , 
"departure_time" : "06:39:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "06:47:41" , 
"departure_time" : "06:47:55" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "06:50:14" , 
"departure_time" : "06:51:42" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "06:56:28" , 
"departure_time" : "06:56:41" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "06:58:13" , 
"departure_time" : "06:59:03" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "07:01:50" , 
"departure_time" : "07:03:20" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "07:07:30" , 
"departure_time" : "07:08:31" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "07:10:01" , 
"departure_time" : "07:11:12" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "07:14:11" , 
"departure_time" : "07:14:21" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "07:18:10" , 
"departure_time" : "07:19:20" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "07:24:10" , 
"departure_time" : "07:25:23" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "07:27:13" , 
"departure_time" : "07:28:15" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "07:33:02" , 
"departure_time" : "07:33:03" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "07:42:01" , 
"departure_time" : "07:42:01" , 
"distance_traveled" : 28.9235
} ], 
"4813" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "17:13:00" , 
"departure_time" : "17:13:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "17:22:32" , 
"departure_time" : "17:23:47" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "17:26:15" , 
"departure_time" : "17:26:24" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "17:30:09" , 
"departure_time" : "17:31:06" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 155,
"arrival_time" : "17:34:57" , 
"departure_time" : "17:36:20" , 
"distance_traveled" : 11.6123
}, 
{ 
"stop_id" : 44,
"arrival_time" : "17:39:23" , 
"departure_time" : "17:41:00" , 
"distance_traveled" : 13.7009
}, 
{ 
"stop_id" : 102,
"arrival_time" : "17:42:37" , 
"departure_time" : "17:44:11" , 
"distance_traveled" : 14.9523
}, 
{ 
"stop_id" : 120,
"arrival_time" : "17:47:34" , 
"departure_time" : "17:48:34" , 
"distance_traveled" : 16.097
}, 
{ 
"stop_id" : 36,
"arrival_time" : "17:52:00" , 
"departure_time" : "17:53:32" , 
"distance_traveled" : 19.0369
}, 
{ 
"stop_id" : 21,
"arrival_time" : "17:58:32" , 
"departure_time" : "17:59:25" , 
"distance_traveled" : 23.2784
}, 
{ 
"stop_id" : 24,
"arrival_time" : "17:59:53" , 
"departure_time" : "18:00:46" , 
"distance_traveled" : 24.3898
}, 
{ 
"stop_id" : 138,
"arrival_time" : "18:04:53" , 
"departure_time" : "18:05:07" , 
"distance_traveled" : 27.7233
}, 
{ 
"stop_id" : 129,
"arrival_time" : "18:07:14" , 
"departure_time" : "18:08:29" , 
"distance_traveled" : 28.8871
}, 
{ 
"stop_id" : 108,
"arrival_time" : "18:15:15" , 
"departure_time" : "18:16:02" , 
"distance_traveled" : 32.3644
}, 
{ 
"stop_id" : 157,
"arrival_time" : "18:21:47" , 
"departure_time" : "18:22:59" , 
"distance_traveled" : 37.2638
}, 
{ 
"stop_id" : 68,
"arrival_time" : "18:28:12" , 
"departure_time" : "18:29:17" , 
"distance_traveled" : 41.0473
}, 
{ 
"stop_id" : 6,
"arrival_time" : "18:32:05" , 
"departure_time" : "18:32:57" , 
"distance_traveled" : 43.4057
}, 
{ 
"stop_id" : 60,
"arrival_time" : "18:43:52" , 
"departure_time" : "18:43:52" , 
"distance_traveled" : 45.1968
} ], 
"4814" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "15:38:00" , 
"departure_time" : "15:40:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "15:48:30" , 
"departure_time" : "15:49:01" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "15:50:31" , 
"departure_time" : "15:50:40" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "15:55:09" , 
"departure_time" : "15:56:40" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "15:59:31" , 
"departure_time" : "16:00:21" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "16:01:50" , 
"departure_time" : "16:03:18" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "16:07:28" , 
"departure_time" : "16:07:31" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "16:09:03" , 
"departure_time" : "16:10:41" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "16:14:38" , 
"departure_time" : "16:15:11" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "16:18:33" , 
"departure_time" : "16:20:04" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "16:24:31" , 
"departure_time" : "16:25:05" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "16:26:34" , 
"departure_time" : "16:27:12" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "16:32:38" , 
"departure_time" : "16:32:56" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "16:34:18" , 
"departure_time" : "16:35:37" , 
"distance_traveled" : 28.9235
}, 
{ 
"stop_id" : 108,
"arrival_time" : "16:42:19" , 
"departure_time" : "16:43:56" , 
"distance_traveled" : 32.4008
}, 
{ 
"stop_id" : 157,
"arrival_time" : "16:49:37" , 
"departure_time" : "16:50:50" , 
"distance_traveled" : 37.3002
}, 
{ 
"stop_id" : 68,
"arrival_time" : "16:55:13" , 
"departure_time" : "16:55:44" , 
"distance_traveled" : 41.0837
}, 
{ 
"stop_id" : 6,
"arrival_time" : "16:59:31" , 
"departure_time" : "16:59:42" , 
"distance_traveled" : 43.442
}, 
{ 
"stop_id" : 60,
"arrival_time" : "17:10:11" , 
"departure_time" : "17:10:11" , 
"distance_traveled" : 45.2331
} ], 
"4815" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "18:38:00" , 
"departure_time" : "18:38:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "18:47:12" , 
"departure_time" : "18:48:47" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "18:51:35" , 
"departure_time" : "18:51:53" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "18:55:18" , 
"departure_time" : "18:56:33" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "18:59:15" , 
"departure_time" : "18:59:46" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "19:01:31" , 
"departure_time" : "19:02:46" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "19:07:15" , 
"departure_time" : "19:07:35" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "19:09:20" , 
"departure_time" : "19:10:48" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "19:14:28" , 
"departure_time" : "19:14:42" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "19:18:14" , 
"departure_time" : "19:19:04" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "19:23:50" , 
"departure_time" : "19:23:57" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "19:26:07" , 
"departure_time" : "19:26:54" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "19:32:47" , 
"departure_time" : "19:32:53" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "19:34:06" , 
"departure_time" : "19:34:41" , 
"distance_traveled" : 28.9235
}, 
{ 
"stop_id" : 108,
"arrival_time" : "19:41:35" , 
"departure_time" : "19:41:43" , 
"distance_traveled" : 32.4008
}, 
{ 
"stop_id" : 157,
"arrival_time" : "19:48:08" , 
"departure_time" : "19:49:48" , 
"distance_traveled" : 37.3002
}, 
{ 
"stop_id" : 68,
"arrival_time" : "19:55:40" , 
"departure_time" : "19:56:47" , 
"distance_traveled" : 41.0837
}, 
{ 
"stop_id" : 6,
"arrival_time" : "20:00:07" , 
"departure_time" : "20:01:21" , 
"distance_traveled" : 43.442
}, 
{ 
"stop_id" : 60,
"arrival_time" : "20:11:14" , 
"departure_time" : "20:11:14" , 
"distance_traveled" : 45.2331
} ], 
"4816" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "15:38:00" , 
"departure_time" : "15:40:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "15:48:25" , 
"departure_time" : "15:49:30" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "15:51:05" , 
"departure_time" : "15:52:23" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "15:56:18" , 
"departure_time" : "15:57:30" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "15:59:12" , 
"departure_time" : "15:59:35" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "16:01:23" , 
"departure_time" : "16:01:37" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "16:06:14" , 
"departure_time" : "16:07:46" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "16:10:32" , 
"departure_time" : "16:10:59" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "16:13:27" , 
"departure_time" : "16:14:31" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "16:19:04" , 
"departure_time" : "16:19:30" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "16:23:26" , 
"departure_time" : "16:24:02" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "16:26:36" , 
"departure_time" : "16:26:40" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "16:32:04" , 
"departure_time" : "16:32:12" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "16:42:08" , 
"departure_time" : "16:42:08" , 
"distance_traveled" : 28.9235
} ], 
"4817" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "18:38:00" , 
"departure_time" : "18:39:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "18:48:29" , 
"departure_time" : "18:49:21" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "18:50:52" , 
"departure_time" : "18:51:19" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "18:55:27" , 
"departure_time" : "18:56:35" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "18:59:08" , 
"departure_time" : "19:00:16" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "19:02:08" , 
"departure_time" : "19:03:22" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "19:07:14" , 
"departure_time" : "19:08:53" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "19:10:39" , 
"departure_time" : "19:10:49" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "19:13:10" , 
"departure_time" : "19:13:44" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "19:18:34" , 
"departure_time" : "19:19:32" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "19:23:58" , 
"departure_time" : "19:23:59" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "19:26:01" , 
"departure_time" : "19:26:39" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "19:32:38" , 
"departure_time" : "19:33:27" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "19:42:49" , 
"departure_time" : "19:42:49" , 
"distance_traveled" : 28.9235
} ], 
"4818" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "07:38:00" , 
"departure_time" : "07:39:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "07:47:34" , 
"departure_time" : "07:48:32" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "07:50:58" , 
"departure_time" : "07:52:15" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "07:56:17" , 
"departure_time" : "07:56:30" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "07:58:13" , 
"departure_time" : "07:59:19" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "08:02:06" , 
"departure_time" : "08:02:30" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "08:06:24" , 
"departure_time" : "08:07:16" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "08:09:52" , 
"departure_time" : "08:11:04" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "08:14:12" , 
"departure_time" : "08:15:14" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "08:19:02" , 
"departure_time" : "08:19:45" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "08:23:43" , 
"departure_time" : "08:25:19" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "08:27:36" , 
"departure_time" : "08:28:03" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "08:32:27" , 
"departure_time" : "08:33:53" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "08:43:26" , 
"departure_time" : "08:43:26" , 
"distance_traveled" : 28.9235
} ], 
"4819" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "08:38:00" , 
"departure_time" : "08:39:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "08:47:23" , 
"departure_time" : "08:48:01" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "08:50:38" , 
"departure_time" : "08:52:08" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "08:56:30" , 
"departure_time" : "08:57:31" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "08:59:01" , 
"departure_time" : "08:59:41" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "09:01:40" , 
"departure_time" : "09:02:15" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "09:06:35" , 
"departure_time" : "09:07:54" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "09:10:19" , 
"departure_time" : "09:11:57" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "09:14:38" , 
"departure_time" : "09:15:07" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "09:18:29" , 
"departure_time" : "09:18:43" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "09:23:14" , 
"departure_time" : "09:24:51" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "09:27:37" , 
"departure_time" : "09:28:37" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "09:33:00" , 
"departure_time" : "09:33:37" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "09:42:37" , 
"departure_time" : "09:42:37" , 
"distance_traveled" : 28.9235
} ], 
"4820" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "09:38:00" , 
"departure_time" : "09:38:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "09:47:06" , 
"departure_time" : "09:48:07" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "09:51:01" , 
"departure_time" : "09:52:08" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "09:56:07" , 
"departure_time" : "09:57:30" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "09:59:23" , 
"departure_time" : "09:59:42" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "10:01:19" , 
"departure_time" : "10:02:41" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "10:07:22" , 
"departure_time" : "10:08:00" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "10:09:38" , 
"departure_time" : "10:10:22" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "10:13:44" , 
"departure_time" : "10:14:31" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "10:18:47" , 
"departure_time" : "10:20:21" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "10:24:34" , 
"departure_time" : "10:25:22" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "10:26:48" , 
"departure_time" : "10:27:45" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "10:32:57" , 
"departure_time" : "10:33:47" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "10:42:50" , 
"departure_time" : "10:42:50" , 
"distance_traveled" : 28.9235
} ], 
"4821" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "10:38:00" , 
"departure_time" : "10:38:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "10:47:05" , 
"departure_time" : "10:48:12" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "10:51:07" , 
"departure_time" : "10:51:23" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "10:55:16" , 
"departure_time" : "10:56:50" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "10:59:34" , 
"departure_time" : "10:59:46" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "11:01:12" , 
"departure_time" : "11:02:00" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "11:06:48" , 
"departure_time" : "11:08:23" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "11:10:35" , 
"departure_time" : "11:12:07" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "11:14:32" , 
"departure_time" : "11:14:35" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "11:18:03" , 
"departure_time" : "11:19:15" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "11:24:12" , 
"departure_time" : "11:25:12" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "11:27:00" , 
"departure_time" : "11:27:25" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "11:32:25" , 
"departure_time" : "11:32:41" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "11:42:16" , 
"departure_time" : "11:42:16" , 
"distance_traveled" : 28.9235
} ], 
"4822" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "11:38:00" , 
"departure_time" : "11:38:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "11:47:07" , 
"departure_time" : "11:47:31" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "11:50:24" , 
"departure_time" : "11:50:56" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "11:55:32" , 
"departure_time" : "11:56:09" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "11:58:37" , 
"departure_time" : "11:58:52" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "12:01:15" , 
"departure_time" : "12:01:53" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "12:06:38" , 
"departure_time" : "12:08:01" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "12:10:23" , 
"departure_time" : "12:11:51" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "12:14:28" , 
"departure_time" : "12:15:34" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "12:19:06" , 
"departure_time" : "12:20:08" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "12:24:02" , 
"departure_time" : "12:24:48" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "12:26:46" , 
"departure_time" : "12:28:06" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "12:33:20" , 
"departure_time" : "12:34:35" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "12:43:15" , 
"departure_time" : "12:43:15" , 
"distance_traveled" : 28.9235
} ], 
"4823" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "12:38:00" , 
"departure_time" : "12:40:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "12:48:05" , 
"departure_time" : "12:49:14" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "12:51:09" , 
"departure_time" : "12:51:16" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "12:55:07" , 
"departure_time" : "12:55:11" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "12:58:04" , 
"departure_time" : "12:58:34" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "13:01:30" , 
"departure_time" : "13:02:06" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "13:06:36" , 
"departure_time" : "13:07:38" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "13:10:02" , 
"departure_time" : "13:10:36" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "13:13:34" , 
"departure_time" : "13:14:46" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "13:19:12" , 
"departure_time" : "13:20:03" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "13:23:51" , 
"departure_time" : "13:25:14" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "13:27:23" , 
"departure_time" : "13:27:58" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "13:32:35" , 
"departure_time" : "13:33:45" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "13:43:10" , 
"departure_time" : "13:43:10" , 
"distance_traveled" : 28.9235
} ], 
"4824" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "13:38:00" , 
"departure_time" : "13:40:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "13:47:56" , 
"departure_time" : "13:48:19" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "13:50:23" , 
"departure_time" : "13:50:31" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "13:55:08" , 
"departure_time" : "13:56:07" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "13:58:59" , 
"departure_time" : "13:59:17" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "14:01:18" , 
"departure_time" : "14:02:18" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "14:07:00" , 
"departure_time" : "14:08:33" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "14:10:33" , 
"departure_time" : "14:10:39" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "14:13:06" , 
"departure_time" : "14:13:28" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "14:18:22" , 
"departure_time" : "14:18:48" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "14:23:26" , 
"departure_time" : "14:24:57" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "14:27:31" , 
"departure_time" : "14:28:19" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "14:32:48" , 
"departure_time" : "14:32:56" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "14:42:08" , 
"departure_time" : "14:42:08" , 
"distance_traveled" : 28.9235
} ], 
"4825" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "14:38:00" , 
"departure_time" : "14:38:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "14:47:41" , 
"departure_time" : "14:49:00" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "14:51:19" , 
"departure_time" : "14:51:45" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "14:55:26" , 
"departure_time" : "14:55:44" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "14:58:18" , 
"departure_time" : "14:59:42" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "15:02:24" , 
"departure_time" : "15:03:44" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "15:07:20" , 
"departure_time" : "15:08:47" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "15:10:27" , 
"departure_time" : "15:11:26" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "15:13:59" , 
"departure_time" : "15:15:16" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "15:19:17" , 
"departure_time" : "15:19:39" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "15:23:22" , 
"departure_time" : "15:23:52" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "15:26:30" , 
"departure_time" : "15:27:54" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "15:33:24" , 
"departure_time" : "15:33:30" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "15:42:06" , 
"departure_time" : "15:42:06" , 
"distance_traveled" : 28.9235
} ], 
"4826" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "16:38:00" , 
"departure_time" : "16:39:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "16:48:05" , 
"departure_time" : "16:49:42" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "16:51:37" , 
"departure_time" : "16:52:38" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "16:56:01" , 
"departure_time" : "16:57:02" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "16:59:01" , 
"departure_time" : "16:59:12" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "17:01:11" , 
"departure_time" : "17:02:35" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "17:07:24" , 
"departure_time" : "17:07:34" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "17:09:10" , 
"departure_time" : "17:09:46" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "17:13:36" , 
"departure_time" : "17:15:15" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "17:19:39" , 
"departure_time" : "17:20:38" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "17:23:59" , 
"departure_time" : "17:25:08" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "17:27:09" , 
"departure_time" : "17:28:38" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "17:33:29" , 
"departure_time" : "17:33:41" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "17:42:12" , 
"departure_time" : "17:42:12" , 
"distance_traveled" : 28.9235
} ], 
"4827" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "17:38:00" , 
"departure_time" : "17:39:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "17:48:14" , 
"departure_time" : "17:49:36" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "17:51:22" , 
"departure_time" : "17:53:00" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "17:56:38" , 
"departure_time" : "17:57:17" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "17:58:39" , 
"departure_time" : "18:00:06" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "18:02:27" , 
"departure_time" : "18:03:19" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "18:06:52" , 
"departure_time" : "18:07:33" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "18:09:41" , 
"departure_time" : "18:10:19" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "18:13:38" , 
"departure_time" : "18:13:41" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "18:18:03" , 
"departure_time" : "18:19:35" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "18:24:32" , 
"departure_time" : "18:24:41" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "18:26:09" , 
"departure_time" : "18:26:51" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "18:32:42" , 
"departure_time" : "18:32:59" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "18:42:17" , 
"departure_time" : "18:42:17" , 
"distance_traveled" : 28.9235
} ], 
"4828" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "19:38:00" , 
"departure_time" : "19:39:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "19:47:54" , 
"departure_time" : "19:48:10" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "19:50:16" , 
"departure_time" : "19:50:52" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "19:55:36" , 
"departure_time" : "19:55:41" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "19:58:05" , 
"departure_time" : "19:59:26" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "20:02:21" , 
"departure_time" : "20:03:36" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "20:07:15" , 
"departure_time" : "20:07:28" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "20:09:13" , 
"departure_time" : "20:10:21" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "20:14:08" , 
"departure_time" : "20:14:48" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "20:18:40" , 
"departure_time" : "20:20:06" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "20:24:26" , 
"departure_time" : "20:25:23" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "20:26:57" , 
"departure_time" : "20:27:38" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "20:32:41" , 
"departure_time" : "20:32:56" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "20:42:15" , 
"departure_time" : "20:42:15" , 
"distance_traveled" : 28.9235
} ], 
"4829" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "20:38:00" , 
"departure_time" : "20:39:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "20:48:08" , 
"departure_time" : "20:48:54" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "20:50:46" , 
"departure_time" : "20:51:07" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "20:55:21" , 
"departure_time" : "20:57:00" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "20:59:39" , 
"departure_time" : "21:01:18" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "21:02:39" , 
"departure_time" : "21:03:11" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "21:06:32" , 
"departure_time" : "21:06:37" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "21:09:05" , 
"departure_time" : "21:10:44" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "21:14:39" , 
"departure_time" : "21:14:58" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "21:18:19" , 
"departure_time" : "21:19:23" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "21:24:04" , 
"departure_time" : "21:25:31" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "21:27:27" , 
"departure_time" : "21:28:10" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "21:32:43" , 
"departure_time" : "21:32:47" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "21:42:04" , 
"departure_time" : "21:42:04" , 
"distance_traveled" : 28.9235
} ], 
"4830" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "21:38:00" , 
"departure_time" : "21:38:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "21:47:39" , 
"departure_time" : "21:48:36" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "21:50:57" , 
"departure_time" : "21:51:06" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "21:55:09" , 
"departure_time" : "21:56:45" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "21:59:36" , 
"departure_time" : "22:00:28" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "22:01:52" , 
"departure_time" : "22:03:09" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "22:07:17" , 
"departure_time" : "22:08:49" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "22:10:32" , 
"departure_time" : "22:11:14" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "22:13:42" , 
"departure_time" : "22:14:52" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "22:19:10" , 
"departure_time" : "22:20:19" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "22:24:09" , 
"departure_time" : "22:24:54" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "22:26:45" , 
"departure_time" : "22:27:01" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "22:32:16" , 
"departure_time" : "22:32:58" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "22:42:42" , 
"departure_time" : "22:42:42" , 
"distance_traveled" : 28.9235
} ], 
"4831" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "22:38:00" , 
"departure_time" : "22:40:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "22:48:24" , 
"departure_time" : "22:48:58" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "22:50:34" , 
"departure_time" : "22:51:45" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "22:56:11" , 
"departure_time" : "22:56:40" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "22:58:29" , 
"departure_time" : "22:59:35" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "23:02:06" , 
"departure_time" : "23:02:44" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "23:06:38" , 
"departure_time" : "23:06:50" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "23:09:12" , 
"departure_time" : "23:09:17" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "23:13:05" , 
"departure_time" : "23:14:42" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "23:19:37" , 
"departure_time" : "23:19:41" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "23:23:04" , 
"departure_time" : "23:23:52" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "23:26:48" , 
"departure_time" : "23:27:33" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "23:32:45" , 
"departure_time" : "23:34:17" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "23:43:32" , 
"departure_time" : "23:43:32" , 
"distance_traveled" : 28.9235
} ], 
"4832" :  [ 
{ 
"stop_id" : 107,
"arrival_time" : "23:38:00" , 
"departure_time" : "23:40:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38105,
"arrival_time" : "23:47:33" , 
"departure_time" : "23:47:45" , 
"distance_traveled" : 5.2593
}, 
{ 
"stop_id" : 31,
"arrival_time" : "23:50:12" , 
"departure_time" : "23:50:57" , 
"distance_traveled" : 7.1057
}, 
{ 
"stop_id" : 32,
"arrival_time" : "23:55:45" , 
"departure_time" : "23:56:18" , 
"distance_traveled" : 9.2496
}, 
{ 
"stop_id" : 47,
"arrival_time" : "23:58:33" , 
"departure_time" : "24:00:06" , 
"distance_traveled" : 10.4335
}, 
{ 
"stop_id" : 155,
"arrival_time" : "24:02:33" , 
"departure_time" : "24:02:57" , 
"distance_traveled" : 11.6487
}, 
{ 
"stop_id" : 44,
"arrival_time" : "24:06:24" , 
"departure_time" : "24:06:45" , 
"distance_traveled" : 13.7373
}, 
{ 
"stop_id" : 102,
"arrival_time" : "24:09:21" , 
"departure_time" : "24:10:21" , 
"distance_traveled" : 14.9886
}, 
{ 
"stop_id" : 120,
"arrival_time" : "24:14:00" , 
"departure_time" : "24:15:03" , 
"distance_traveled" : 16.1333
}, 
{ 
"stop_id" : 36,
"arrival_time" : "24:19:03" , 
"departure_time" : "24:20:18" , 
"distance_traveled" : 19.0733
}, 
{ 
"stop_id" : 21,
"arrival_time" : "24:24:15" , 
"departure_time" : "24:24:52" , 
"distance_traveled" : 23.3148
}, 
{ 
"stop_id" : 24,
"arrival_time" : "24:26:37" , 
"departure_time" : "24:27:37" , 
"distance_traveled" : 24.4261
}, 
{ 
"stop_id" : 138,
"arrival_time" : "24:33:00" , 
"departure_time" : "24:34:26" , 
"distance_traveled" : 27.7597
}, 
{ 
"stop_id" : 129,
"arrival_time" : "24:43:26" , 
"departure_time" : "24:43:26" , 
"distance_traveled" : 28.9235
} ], 
"4833" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "06:14:00" , 
"departure_time" : "06:15:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "06:16:21" , 
"departure_time" : "06:16:45" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "06:18:24" , 
"departure_time" : "06:20:03" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "06:26:39" , 
"departure_time" : "06:26:46" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "06:30:07" , 
"departure_time" : "06:30:54" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "06:33:47" , 
"departure_time" : "06:34:48" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "06:39:01" , 
"departure_time" : "06:39:04" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "06:40:03" , 
"departure_time" : "06:41:23" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "06:45:20" , 
"departure_time" : "06:45:41" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "06:48:21" , 
"departure_time" : "06:48:35" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "06:50:14" , 
"departure_time" : "06:50:18" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "06:55:04" , 
"departure_time" : "06:56:44" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "06:58:40" , 
"departure_time" : "06:59:22" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "06:59:42" , 
"departure_time" : "07:00:36" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "07:02:54" , 
"departure_time" : "07:03:16" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "07:04:22" , 
"departure_time" : "07:05:50" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "07:09:28" , 
"departure_time" : "07:09:38" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "07:13:10" , 
"departure_time" : "07:13:30" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "07:16:20" , 
"departure_time" : "07:16:54" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "07:18:34" , 
"departure_time" : "07:19:46" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "07:22:12" , 
"departure_time" : "07:22:12" , 
"distance_traveled" : 33.5915
} ], 
"4834" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "06:44:00" , 
"departure_time" : "06:45:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "06:46:15" , 
"departure_time" : "06:47:51" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "06:49:36" , 
"departure_time" : "06:49:58" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "06:55:22" , 
"departure_time" : "06:56:03" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "07:00:41" , 
"departure_time" : "07:01:16" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "07:03:35" , 
"departure_time" : "07:04:42" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "07:09:07" , 
"departure_time" : "07:10:43" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "07:11:36" , 
"departure_time" : "07:12:56" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "07:15:20" , 
"departure_time" : "07:16:36" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "07:19:16" , 
"departure_time" : "07:19:25" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "07:20:09" , 
"departure_time" : "07:21:01" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "07:25:52" , 
"departure_time" : "07:26:35" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "07:27:43" , 
"departure_time" : "07:29:15" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "07:30:32" , 
"departure_time" : "07:31:48" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "07:33:16" , 
"departure_time" : "07:33:26" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "07:34:10" , 
"departure_time" : "07:34:16" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "07:38:06" , 
"departure_time" : "07:39:46" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "07:44:40" , 
"departure_time" : "07:46:20" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "07:47:40" , 
"departure_time" : "07:49:02" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "07:49:22" , 
"departure_time" : "07:49:48" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "07:51:26" , 
"departure_time" : "07:51:26" , 
"distance_traveled" : 33.5915
} ], 
"4835" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "07:14:00" , 
"departure_time" : "07:14:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "07:16:23" , 
"departure_time" : "07:17:56" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "07:19:33" , 
"departure_time" : "07:20:15" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "07:25:42" , 
"departure_time" : "07:26:58" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "07:31:16" , 
"departure_time" : "07:32:22" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "07:34:06" , 
"departure_time" : "07:34:17" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "07:38:11" , 
"departure_time" : "07:39:06" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "07:40:55" , 
"departure_time" : "07:41:25" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "07:44:30" , 
"departure_time" : "07:45:50" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "07:49:20" , 
"departure_time" : "07:49:33" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "07:50:13" , 
"departure_time" : "07:51:15" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "07:56:02" , 
"departure_time" : "07:57:01" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "07:57:59" , 
"departure_time" : "07:58:53" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "07:59:54" , 
"departure_time" : "08:00:28" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "08:02:34" , 
"departure_time" : "08:03:51" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "08:05:17" , 
"departure_time" : "08:05:55" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "08:08:38" , 
"departure_time" : "08:10:01" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "08:14:23" , 
"departure_time" : "08:14:35" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "08:16:12" , 
"departure_time" : "08:16:21" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "08:18:09" , 
"departure_time" : "08:18:22" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "08:21:13" , 
"departure_time" : "08:21:13" , 
"distance_traveled" : 33.5915
} ], 
"4836" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "07:44:00" , 
"departure_time" : "07:45:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "07:47:01" , 
"departure_time" : "07:47:50" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "07:48:49" , 
"departure_time" : "07:49:45" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "07:55:56" , 
"departure_time" : "07:57:19" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "08:01:23" , 
"departure_time" : "08:02:08" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "08:03:45" , 
"departure_time" : "08:05:05" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "08:09:20" , 
"departure_time" : "08:09:55" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "08:10:35" , 
"departure_time" : "08:11:09" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "08:14:34" , 
"departure_time" : "08:15:06" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "08:18:32" , 
"departure_time" : "08:19:41" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "08:21:09" , 
"departure_time" : "08:22:07" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "08:25:58" , 
"departure_time" : "08:26:38" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "08:27:40" , 
"departure_time" : "08:28:33" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "08:29:53" , 
"departure_time" : "08:30:23" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "08:32:30" , 
"departure_time" : "08:32:34" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "08:34:04" , 
"departure_time" : "08:35:32" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "08:39:28" , 
"departure_time" : "08:40:50" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "08:44:22" , 
"departure_time" : "08:45:28" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "08:47:06" , 
"departure_time" : "08:48:06" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "08:49:00" , 
"departure_time" : "08:50:32" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "08:52:32" , 
"departure_time" : "08:52:32" , 
"distance_traveled" : 33.5915
} ], 
"4837" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "08:14:00" , 
"departure_time" : "08:15:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "08:16:03" , 
"departure_time" : "08:16:09" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "08:18:06" , 
"departure_time" : "08:18:35" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "08:25:29" , 
"departure_time" : "08:26:50" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "08:31:21" , 
"departure_time" : "08:31:50" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "08:33:29" , 
"departure_time" : "08:33:33" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "08:38:04" , 
"departure_time" : "08:39:16" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "08:41:12" , 
"departure_time" : "08:41:28" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "08:44:16" , 
"departure_time" : "08:44:58" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "08:48:42" , 
"departure_time" : "08:50:08" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "08:51:26" , 
"departure_time" : "08:52:40" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "08:56:14" , 
"departure_time" : "08:56:21" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "08:57:07" , 
"departure_time" : "08:57:45" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "08:59:38" , 
"departure_time" : "09:00:51" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "09:03:13" , 
"departure_time" : "09:03:51" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "09:04:38" , 
"departure_time" : "09:04:58" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "09:08:20" , 
"departure_time" : "09:09:00" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "09:13:40" , 
"departure_time" : "09:13:49" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "09:16:09" , 
"departure_time" : "09:16:17" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "09:18:08" , 
"departure_time" : "09:18:42" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "09:21:34" , 
"departure_time" : "09:21:34" , 
"distance_traveled" : 33.5915
} ], 
"4838" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "08:44:00" , 
"departure_time" : "08:45:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "08:46:38" , 
"departure_time" : "08:48:10" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "08:49:32" , 
"departure_time" : "08:50:11" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "08:55:39" , 
"departure_time" : "08:57:16" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "09:01:37" , 
"departure_time" : "09:02:03" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "09:03:26" , 
"departure_time" : "09:04:35" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "09:09:09" , 
"departure_time" : "09:10:37" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "09:11:28" , 
"departure_time" : "09:11:58" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "09:14:30" , 
"departure_time" : "09:14:31" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "09:18:01" , 
"departure_time" : "09:19:40" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "09:21:39" , 
"departure_time" : "09:23:10" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "09:26:31" , 
"departure_time" : "09:27:59" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "09:28:28" , 
"departure_time" : "09:28:54" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "09:29:26" , 
"departure_time" : "09:31:06" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "09:33:40" , 
"departure_time" : "09:35:08" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "09:35:28" , 
"departure_time" : "09:36:09" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "09:38:41" , 
"departure_time" : "09:38:45" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "09:43:04" , 
"departure_time" : "09:43:22" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "09:46:18" , 
"departure_time" : "09:47:54" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "09:49:36" , 
"departure_time" : "09:51:05" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "09:52:29" , 
"departure_time" : "09:52:29" , 
"distance_traveled" : 33.5915
} ], 
"4839" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "09:14:00" , 
"departure_time" : "09:16:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "09:16:56" , 
"departure_time" : "09:18:15" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "09:19:19" , 
"departure_time" : "09:20:35" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "09:26:16" , 
"departure_time" : "09:27:13" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "09:30:57" , 
"departure_time" : "09:32:03" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "09:34:06" , 
"departure_time" : "09:34:59" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "09:38:53" , 
"departure_time" : "09:39:22" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "09:40:29" , 
"departure_time" : "09:40:38" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "09:44:09" , 
"departure_time" : "09:44:34" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "09:48:25" , 
"departure_time" : "09:48:28" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "09:50:03" , 
"departure_time" : "09:50:41" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "09:55:38" , 
"departure_time" : "09:57:09" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "09:58:31" , 
"departure_time" : "09:59:23" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "09:59:52" , 
"departure_time" : "10:00:58" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "10:03:06" , 
"departure_time" : "10:03:20" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "10:04:14" , 
"departure_time" : "10:05:19" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "10:09:05" , 
"departure_time" : "10:10:34" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "10:14:29" , 
"departure_time" : "10:15:54" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "10:17:25" , 
"departure_time" : "10:18:20" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "10:18:55" , 
"departure_time" : "10:19:20" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "10:21:25" , 
"departure_time" : "10:21:25" , 
"distance_traveled" : 33.5915
} ], 
"4840" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "09:44:00" , 
"departure_time" : "09:45:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "09:47:04" , 
"departure_time" : "09:47:46" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "09:48:42" , 
"departure_time" : "09:50:19" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "09:56:37" , 
"departure_time" : "09:57:18" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "10:00:41" , 
"departure_time" : "10:00:47" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "10:03:06" , 
"departure_time" : "10:03:17" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "10:08:11" , 
"departure_time" : "10:09:03" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "10:10:52" , 
"departure_time" : "10:11:39" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "10:14:47" , 
"departure_time" : "10:14:56" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "10:18:09" , 
"departure_time" : "10:18:18" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "10:20:09" , 
"departure_time" : "10:20:27" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "10:25:18" , 
"departure_time" : "10:25:57" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "10:27:39" , 
"departure_time" : "10:28:34" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "10:29:55" , 
"departure_time" : "10:31:19" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "10:33:24" , 
"departure_time" : "10:34:53" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "10:35:29" , 
"departure_time" : "10:35:46" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "10:38:17" , 
"departure_time" : "10:39:10" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "10:43:53" , 
"departure_time" : "10:44:41" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "10:46:48" , 
"departure_time" : "10:47:10" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "10:48:22" , 
"departure_time" : "10:49:40" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "10:52:18" , 
"departure_time" : "10:52:18" , 
"distance_traveled" : 33.5915
} ], 
"4841" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "10:14:00" , 
"departure_time" : "10:15:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "10:16:33" , 
"departure_time" : "10:17:06" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "10:18:33" , 
"departure_time" : "10:18:36" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "10:25:03" , 
"departure_time" : "10:25:36" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "10:30:33" , 
"departure_time" : "10:31:21" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "10:33:48" , 
"departure_time" : "10:34:13" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "10:38:25" , 
"departure_time" : "10:38:38" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "10:40:13" , 
"departure_time" : "10:41:10" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "10:44:57" , 
"departure_time" : "10:46:26" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "10:49:29" , 
"departure_time" : "10:50:49" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "10:51:20" , 
"departure_time" : "10:52:33" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "10:56:13" , 
"departure_time" : "10:57:22" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "10:58:09" , 
"departure_time" : "10:59:38" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "11:00:29" , 
"departure_time" : "11:02:04" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "11:03:35" , 
"departure_time" : "11:04:11" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "11:04:36" , 
"departure_time" : "11:05:28" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "11:08:52" , 
"departure_time" : "11:09:19" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "11:13:27" , 
"departure_time" : "11:14:20" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "11:16:53" , 
"departure_time" : "11:17:47" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "11:18:54" , 
"departure_time" : "11:20:33" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "11:22:39" , 
"departure_time" : "11:22:39" , 
"distance_traveled" : 33.5915
} ], 
"4842" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "10:44:00" , 
"departure_time" : "10:46:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "10:47:15" , 
"departure_time" : "10:47:33" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "10:48:18" , 
"departure_time" : "10:48:24" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "10:55:06" , 
"departure_time" : "10:55:40" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "11:00:34" , 
"departure_time" : "11:01:41" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "11:04:07" , 
"departure_time" : "11:04:14" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "11:08:07" , 
"departure_time" : "11:08:16" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "11:10:09" , 
"departure_time" : "11:10:55" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "11:14:46" , 
"departure_time" : "11:16:04" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "11:19:18" , 
"departure_time" : "11:20:40" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "11:21:22" , 
"departure_time" : "11:22:44" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "11:26:22" , 
"departure_time" : "11:27:39" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "11:28:17" , 
"departure_time" : "11:29:26" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "11:30:09" , 
"departure_time" : "11:31:36" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "11:33:27" , 
"departure_time" : "11:34:00" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "11:34:33" , 
"departure_time" : "11:34:46" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "11:38:13" , 
"departure_time" : "11:39:39" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "11:44:26" , 
"departure_time" : "11:44:39" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "11:46:13" , 
"departure_time" : "11:47:35" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "11:49:22" , 
"departure_time" : "11:49:27" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "11:51:05" , 
"departure_time" : "11:51:05" , 
"distance_traveled" : 33.5915
} ], 
"4843" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "11:14:00" , 
"departure_time" : "11:15:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "11:17:37" , 
"departure_time" : "11:18:28" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "11:18:51" , 
"departure_time" : "11:19:40" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "11:25:49" , 
"departure_time" : "11:26:58" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "11:31:09" , 
"departure_time" : "11:32:44" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "11:34:35" , 
"departure_time" : "11:35:44" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "11:39:09" , 
"departure_time" : "11:40:14" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "11:41:05" , 
"departure_time" : "11:41:55" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "11:44:50" , 
"departure_time" : "11:46:00" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "11:49:10" , 
"departure_time" : "11:50:42" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "11:51:32" , 
"departure_time" : "11:52:45" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "11:56:13" , 
"departure_time" : "11:57:30" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "11:58:17" , 
"departure_time" : "11:59:48" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "12:00:31" , 
"departure_time" : "12:01:38" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "12:03:07" , 
"departure_time" : "12:04:04" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "12:04:57" , 
"departure_time" : "12:05:38" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "12:08:41" , 
"departure_time" : "12:09:55" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "12:14:14" , 
"departure_time" : "12:14:21" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "12:16:07" , 
"departure_time" : "12:17:44" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "12:19:37" , 
"departure_time" : "12:20:44" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "12:22:07" , 
"departure_time" : "12:22:07" , 
"distance_traveled" : 33.5915
} ], 
"4844" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "11:44:00" , 
"departure_time" : "11:45:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "11:46:32" , 
"departure_time" : "11:47:32" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "11:49:00" , 
"departure_time" : "11:49:39" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "11:55:39" , 
"departure_time" : "11:56:22" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "12:00:43" , 
"departure_time" : "12:01:07" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "12:03:24" , 
"departure_time" : "12:03:25" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "12:08:01" , 
"departure_time" : "12:09:00" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "12:10:59" , 
"departure_time" : "12:11:23" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "12:14:24" , 
"departure_time" : "12:15:31" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "12:19:07" , 
"departure_time" : "12:20:22" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "12:21:15" , 
"departure_time" : "12:22:43" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "12:26:28" , 
"departure_time" : "12:26:31" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "12:27:03" , 
"departure_time" : "12:28:28" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "12:30:25" , 
"departure_time" : "12:30:30" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "12:32:05" , 
"departure_time" : "12:33:24" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "12:35:19" , 
"departure_time" : "12:35:20" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "12:38:01" , 
"departure_time" : "12:39:00" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "12:43:59" , 
"departure_time" : "12:44:46" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "12:46:47" , 
"departure_time" : "12:47:29" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "12:48:42" , 
"departure_time" : "12:49:45" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "12:52:03" , 
"departure_time" : "12:52:03" , 
"distance_traveled" : 33.5915
} ], 
"4845" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "12:14:00" , 
"departure_time" : "12:16:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "12:17:33" , 
"departure_time" : "12:18:23" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "12:18:50" , 
"departure_time" : "12:19:36" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "12:25:46" , 
"departure_time" : "12:26:30" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "12:30:44" , 
"departure_time" : "12:30:47" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "12:33:03" , 
"departure_time" : "12:34:09" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "12:39:06" , 
"departure_time" : "12:39:08" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "12:40:02" , 
"departure_time" : "12:41:40" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "12:45:38" , 
"departure_time" : "12:46:45" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "12:49:07" , 
"departure_time" : "12:49:29" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "12:50:22" , 
"departure_time" : "12:51:43" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "12:56:21" , 
"departure_time" : "12:56:39" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "12:57:18" , 
"departure_time" : "12:58:44" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "13:00:26" , 
"departure_time" : "13:02:03" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "13:03:37" , 
"departure_time" : "13:03:58" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "13:04:21" , 
"departure_time" : "13:04:52" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "13:08:31" , 
"departure_time" : "13:08:41" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "13:13:10" , 
"departure_time" : "13:14:16" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "13:17:06" , 
"departure_time" : "13:17:29" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "13:18:23" , 
"departure_time" : "13:19:28" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "13:22:05" , 
"departure_time" : "13:22:05" , 
"distance_traveled" : 33.5915
} ], 
"4846" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "12:44:00" , 
"departure_time" : "12:46:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "12:47:35" , 
"departure_time" : "12:49:09" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "12:49:34" , 
"departure_time" : "12:50:58" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "12:56:24" , 
"departure_time" : "12:57:21" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "13:00:57" , 
"departure_time" : "13:01:36" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "13:03:39" , 
"departure_time" : "13:04:37" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "13:08:58" , 
"departure_time" : "13:10:24" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "13:11:26" , 
"departure_time" : "13:12:24" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "13:14:58" , 
"departure_time" : "13:15:40" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "13:18:42" , 
"departure_time" : "13:19:00" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "13:20:18" , 
"departure_time" : "13:20:59" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "13:25:41" , 
"departure_time" : "13:27:06" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "13:28:25" , 
"departure_time" : "13:28:41" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "13:29:16" , 
"departure_time" : "13:29:29" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "13:32:13" , 
"departure_time" : "13:33:37" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "13:35:24" , 
"departure_time" : "13:36:30" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "13:39:06" , 
"departure_time" : "13:39:33" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "13:43:27" , 
"departure_time" : "13:44:23" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "13:46:56" , 
"departure_time" : "13:47:02" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "13:48:06" , 
"departure_time" : "13:48:51" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "13:51:45" , 
"departure_time" : "13:51:45" , 
"distance_traveled" : 33.5915
} ], 
"4847" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "13:14:00" , 
"departure_time" : "13:15:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "13:16:22" , 
"departure_time" : "13:17:01" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "13:18:39" , 
"departure_time" : "13:19:36" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "13:25:57" , 
"departure_time" : "13:26:59" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "13:31:02" , 
"departure_time" : "13:31:54" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "13:33:52" , 
"departure_time" : "13:34:26" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "13:38:34" , 
"departure_time" : "13:39:41" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "13:41:07" , 
"departure_time" : "13:42:01" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "13:44:54" , 
"departure_time" : "13:45:59" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "13:49:05" , 
"departure_time" : "13:50:01" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "13:50:56" , 
"departure_time" : "13:51:26" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "13:55:30" , 
"departure_time" : "13:57:05" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "13:58:35" , 
"departure_time" : "14:00:11" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "14:00:36" , 
"departure_time" : "14:01:45" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "14:03:09" , 
"departure_time" : "14:03:22" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "14:04:13" , 
"departure_time" : "14:05:15" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "14:09:02" , 
"departure_time" : "14:09:04" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "14:13:02" , 
"departure_time" : "14:13:11" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "14:16:09" , 
"departure_time" : "14:17:29" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "14:19:20" , 
"departure_time" : "14:20:06" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "14:21:46" , 
"departure_time" : "14:21:46" , 
"distance_traveled" : 33.5915
} ], 
"4848" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "13:44:00" , 
"departure_time" : "13:46:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "13:47:19" , 
"departure_time" : "13:48:34" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "13:49:15" , 
"departure_time" : "13:49:23" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "13:55:08" , 
"departure_time" : "13:56:33" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "14:01:25" , 
"departure_time" : "14:02:50" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "14:04:25" , 
"departure_time" : "14:04:53" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "14:08:28" , 
"departure_time" : "14:09:39" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "14:11:11" , 
"departure_time" : "14:11:13" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "14:14:02" , 
"departure_time" : "14:15:23" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "14:19:21" , 
"departure_time" : "14:21:00" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "14:21:39" , 
"departure_time" : "14:23:03" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "14:26:24" , 
"departure_time" : "14:26:25" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "14:27:01" , 
"departure_time" : "14:27:56" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "14:29:55" , 
"departure_time" : "14:30:30" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "14:32:35" , 
"departure_time" : "14:32:49" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "14:34:14" , 
"departure_time" : "14:34:35" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "14:38:21" , 
"departure_time" : "14:39:47" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "14:44:26" , 
"departure_time" : "14:44:29" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "14:46:03" , 
"departure_time" : "14:46:30" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "14:48:27" , 
"departure_time" : "14:48:37" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "14:51:10" , 
"departure_time" : "14:51:10" , 
"distance_traveled" : 33.5915
} ], 
"4849" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "14:14:00" , 
"departure_time" : "14:14:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "14:16:32" , 
"departure_time" : "14:17:33" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "14:19:01" , 
"departure_time" : "14:19:44" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "14:25:43" , 
"departure_time" : "14:26:53" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "14:31:10" , 
"departure_time" : "14:32:36" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "14:34:26" , 
"departure_time" : "14:34:43" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "14:38:17" , 
"departure_time" : "14:39:33" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "14:41:16" , 
"departure_time" : "14:42:14" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "14:44:58" , 
"departure_time" : "14:45:54" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "14:48:56" , 
"departure_time" : "14:49:23" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "14:50:27" , 
"departure_time" : "14:51:05" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "14:55:38" , 
"departure_time" : "14:56:26" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "14:57:48" , 
"departure_time" : "14:58:50" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "15:00:02" , 
"departure_time" : "15:00:31" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "15:02:29" , 
"departure_time" : "15:02:58" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "15:04:29" , 
"departure_time" : "15:04:31" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "15:08:02" , 
"departure_time" : "15:08:58" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "15:13:56" , 
"departure_time" : "15:15:03" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "15:17:07" , 
"departure_time" : "15:17:29" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "15:18:22" , 
"departure_time" : "15:19:33" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "15:22:11" , 
"departure_time" : "15:22:11" , 
"distance_traveled" : 33.5915
} ], 
"4850" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "14:44:00" , 
"departure_time" : "14:46:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "14:47:12" , 
"departure_time" : "14:47:20" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "14:48:08" , 
"departure_time" : "14:49:08" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "14:56:00" , 
"departure_time" : "14:56:29" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "15:00:29" , 
"departure_time" : "15:00:46" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "15:03:17" , 
"departure_time" : "15:04:36" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "15:09:19" , 
"departure_time" : "15:09:47" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "15:10:28" , 
"departure_time" : "15:11:46" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "15:15:18" , 
"departure_time" : "15:16:33" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "15:19:15" , 
"departure_time" : "15:20:30" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "15:21:15" , 
"departure_time" : "15:21:21" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "15:25:06" , 
"departure_time" : "15:26:17" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "15:28:11" , 
"departure_time" : "15:28:20" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "15:29:09" , 
"departure_time" : "15:30:25" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "15:33:16" , 
"departure_time" : "15:33:58" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "15:34:42" , 
"departure_time" : "15:35:10" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "15:38:28" , 
"departure_time" : "15:38:56" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "15:43:28" , 
"departure_time" : "15:43:56" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "15:46:28" , 
"departure_time" : "15:46:40" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "15:48:12" , 
"departure_time" : "15:48:56" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "15:51:44" , 
"departure_time" : "15:51:44" , 
"distance_traveled" : 33.5915
} ], 
"4851" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "15:14:00" , 
"departure_time" : "15:15:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "15:16:49" , 
"departure_time" : "15:17:24" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "15:18:35" , 
"departure_time" : "15:19:04" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "15:25:29" , 
"departure_time" : "15:27:09" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "15:31:40" , 
"departure_time" : "15:33:09" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "15:34:29" , 
"departure_time" : "15:35:48" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "15:39:19" , 
"departure_time" : "15:39:56" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "15:40:37" , 
"departure_time" : "15:42:01" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "15:45:24" , 
"departure_time" : "15:46:48" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "15:49:24" , 
"departure_time" : "15:49:31" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "15:50:07" , 
"departure_time" : "15:50:44" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "15:55:37" , 
"departure_time" : "15:56:38" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "15:58:01" , 
"departure_time" : "15:58:51" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "15:59:50" , 
"departure_time" : "16:00:15" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "16:02:25" , 
"departure_time" : "16:03:40" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "16:05:15" , 
"departure_time" : "16:05:30" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "16:08:15" , 
"departure_time" : "16:09:28" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "16:14:13" , 
"departure_time" : "16:15:42" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "16:17:29" , 
"departure_time" : "16:17:39" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "16:18:10" , 
"departure_time" : "16:19:22" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "16:22:12" , 
"departure_time" : "16:22:12" , 
"distance_traveled" : 33.5915
} ], 
"4852" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "15:44:00" , 
"departure_time" : "15:46:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "15:47:00" , 
"departure_time" : "15:47:26" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "15:48:26" , 
"departure_time" : "15:49:49" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "15:56:23" , 
"departure_time" : "15:57:14" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "16:00:51" , 
"departure_time" : "16:02:03" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "16:04:12" , 
"departure_time" : "16:04:16" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "16:08:04" , 
"departure_time" : "16:08:15" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "16:10:11" , 
"departure_time" : "16:11:23" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "16:15:12" , 
"departure_time" : "16:15:36" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "16:18:24" , 
"departure_time" : "16:19:31" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "16:21:07" , 
"departure_time" : "16:22:40" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "16:26:33" , 
"departure_time" : "16:26:52" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "16:27:19" , 
"departure_time" : "16:28:55" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "16:30:36" , 
"departure_time" : "16:30:50" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "16:32:14" , 
"departure_time" : "16:33:03" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "16:34:49" , 
"departure_time" : "16:36:28" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "16:39:39" , 
"departure_time" : "16:40:59" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "16:44:20" , 
"departure_time" : "16:44:48" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "16:46:28" , 
"departure_time" : "16:46:42" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "16:48:14" , 
"departure_time" : "16:48:16" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "16:51:02" , 
"departure_time" : "16:51:02" , 
"distance_traveled" : 33.5915
} ], 
"4853" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "16:14:00" , 
"departure_time" : "16:14:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "16:16:40" , 
"departure_time" : "16:17:48" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "16:19:08" , 
"departure_time" : "16:19:38" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "16:25:30" , 
"departure_time" : "16:25:39" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "16:30:09" , 
"departure_time" : "16:31:24" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "16:34:15" , 
"departure_time" : "16:34:42" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "16:38:27" , 
"departure_time" : "16:39:03" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "16:40:36" , 
"departure_time" : "16:40:59" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "16:44:23" , 
"departure_time" : "16:45:30" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "16:49:07" , 
"departure_time" : "16:49:36" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "16:50:29" , 
"departure_time" : "16:50:36" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "16:55:07" , 
"departure_time" : "16:56:39" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "16:58:32" , 
"departure_time" : "16:58:58" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "16:59:26" , 
"departure_time" : "17:00:29" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "17:03:03" , 
"departure_time" : "17:04:27" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "17:05:24" , 
"departure_time" : "17:07:00" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "17:09:36" , 
"departure_time" : "17:11:16" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "17:14:40" , 
"departure_time" : "17:15:47" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "17:17:07" , 
"departure_time" : "17:18:36" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "17:19:29" , 
"departure_time" : "17:21:04" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "17:22:35" , 
"departure_time" : "17:22:35" , 
"distance_traveled" : 33.5915
} ], 
"4854" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "16:44:00" , 
"departure_time" : "16:46:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "16:47:09" , 
"departure_time" : "16:48:45" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "16:49:36" , 
"departure_time" : "16:50:52" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "16:56:16" , 
"departure_time" : "16:56:35" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "17:00:19" , 
"departure_time" : "17:00:42" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "17:03:23" , 
"departure_time" : "17:03:55" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "17:08:32" , 
"departure_time" : "17:09:02" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "17:10:30" , 
"departure_time" : "17:11:04" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "17:14:34" , 
"departure_time" : "17:15:22" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "17:18:48" , 
"departure_time" : "17:20:12" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "17:21:24" , 
"departure_time" : "17:21:53" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "17:25:29" , 
"departure_time" : "17:26:41" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "17:28:12" , 
"departure_time" : "17:29:33" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "17:30:21" , 
"departure_time" : "17:30:44" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "17:32:23" , 
"departure_time" : "17:33:24" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "17:35:01" , 
"departure_time" : "17:36:14" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "17:39:13" , 
"departure_time" : "17:39:24" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "17:43:11" , 
"departure_time" : "17:44:20" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "17:47:09" , 
"departure_time" : "17:47:19" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "17:48:10" , 
"departure_time" : "17:48:26" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "17:51:16" , 
"departure_time" : "17:51:16" , 
"distance_traveled" : 33.5915
} ], 
"4855" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "17:14:00" , 
"departure_time" : "17:14:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "17:16:19" , 
"departure_time" : "17:17:25" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "17:19:06" , 
"departure_time" : "17:20:42" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "17:26:36" , 
"departure_time" : "17:26:39" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "17:30:03" , 
"departure_time" : "17:30:52" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "17:33:49" , 
"departure_time" : "17:34:42" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "17:38:53" , 
"departure_time" : "17:39:48" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "17:40:55" , 
"departure_time" : "17:42:26" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "17:45:31" , 
"departure_time" : "17:46:05" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "17:48:34" , 
"departure_time" : "17:49:34" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "17:51:00" , 
"departure_time" : "17:51:36" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "17:55:36" , 
"departure_time" : "17:56:32" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "17:57:56" , 
"departure_time" : "17:59:31" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "18:00:35" , 
"departure_time" : "18:01:26" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "18:02:51" , 
"departure_time" : "18:03:37" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "18:04:46" , 
"departure_time" : "18:05:58" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "18:09:12" , 
"departure_time" : "18:09:45" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "18:13:33" , 
"departure_time" : "18:14:18" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "18:16:45" , 
"departure_time" : "18:17:38" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "18:18:53" , 
"departure_time" : "18:19:59" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "18:22:06" , 
"departure_time" : "18:22:06" , 
"distance_traveled" : 33.5915
} ], 
"4856" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "17:44:00" , 
"departure_time" : "17:45:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "17:46:24" , 
"departure_time" : "17:47:10" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "17:48:46" , 
"departure_time" : "17:49:35" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "17:55:49" , 
"departure_time" : "17:56:19" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "18:00:30" , 
"departure_time" : "18:00:38" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "18:03:08" , 
"departure_time" : "18:04:38" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "18:09:30" , 
"departure_time" : "18:09:46" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "18:10:16" , 
"departure_time" : "18:11:06" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "18:14:50" , 
"departure_time" : "18:16:27" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "18:19:37" , 
"departure_time" : "18:19:39" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "18:20:02" , 
"departure_time" : "18:21:04" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "18:26:02" , 
"departure_time" : "18:27:38" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "18:28:36" , 
"departure_time" : "18:28:58" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "18:29:22" , 
"departure_time" : "18:30:14" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "18:32:52" , 
"departure_time" : "18:34:22" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "18:35:30" , 
"departure_time" : "18:36:03" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "18:38:33" , 
"departure_time" : "18:38:43" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "18:43:10" , 
"departure_time" : "18:44:46" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "18:47:36" , 
"departure_time" : "18:47:51" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "18:48:15" , 
"departure_time" : "18:49:52" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "18:52:37" , 
"departure_time" : "18:52:37" , 
"distance_traveled" : 33.5915
} ], 
"4857" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "18:14:00" , 
"departure_time" : "18:16:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "18:16:32" , 
"departure_time" : "18:18:05" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "18:19:33" , 
"departure_time" : "18:20:38" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "18:26:05" , 
"departure_time" : "18:26:25" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "18:30:20" , 
"departure_time" : "18:31:05" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "18:33:45" , 
"departure_time" : "18:34:27" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "18:38:42" , 
"departure_time" : "18:39:11" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "18:40:29" , 
"departure_time" : "18:40:47" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "18:44:18" , 
"departure_time" : "18:45:54" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "18:49:36" , 
"departure_time" : "18:49:53" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "18:50:17" , 
"departure_time" : "18:50:24" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "18:55:07" , 
"departure_time" : "18:55:42" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "18:57:35" , 
"departure_time" : "18:58:33" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "18:59:58" , 
"departure_time" : "19:00:01" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "19:02:03" , 
"departure_time" : "19:02:31" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "19:04:28" , 
"departure_time" : "19:06:02" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "19:09:34" , 
"departure_time" : "19:11:14" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "19:14:40" , 
"departure_time" : "19:14:57" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "19:16:17" , 
"departure_time" : "19:16:29" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "19:18:12" , 
"departure_time" : "19:19:47" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "19:22:35" , 
"departure_time" : "19:22:35" , 
"distance_traveled" : 33.5915
} ], 
"4858" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "18:44:00" , 
"departure_time" : "18:47:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "18:47:27" , 
"departure_time" : "18:48:44" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "18:49:17" , 
"departure_time" : "18:49:39" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "18:55:22" , 
"departure_time" : "18:56:44" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "19:01:22" , 
"departure_time" : "19:01:37" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "19:03:15" , 
"departure_time" : "19:03:25" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "19:08:10" , 
"departure_time" : "19:09:20" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "19:11:10" , 
"departure_time" : "19:12:15" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "19:15:05" , 
"departure_time" : "19:15:31" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "19:18:26" , 
"departure_time" : "19:19:32" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "19:21:06" , 
"departure_time" : "19:22:12" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "19:26:06" , 
"departure_time" : "19:27:27" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "19:28:21" , 
"departure_time" : "19:28:47" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "19:29:26" , 
"departure_time" : "19:29:28" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "19:32:02" , 
"departure_time" : "19:33:29" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "19:35:27" , 
"departure_time" : "19:35:42" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "19:38:15" , 
"departure_time" : "19:39:03" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "19:43:48" , 
"departure_time" : "19:45:08" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "19:47:20" , 
"departure_time" : "19:48:49" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "19:49:29" , 
"departure_time" : "19:50:57" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "19:52:28" , 
"departure_time" : "19:52:28" , 
"distance_traveled" : 33.5915
} ], 
"4859" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "19:14:00" , 
"departure_time" : "19:16:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "19:16:37" , 
"departure_time" : "19:17:45" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "19:19:08" , 
"departure_time" : "19:20:30" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "19:26:22" , 
"departure_time" : "19:27:45" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "19:31:23" , 
"departure_time" : "19:32:44" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "19:34:21" , 
"departure_time" : "19:34:27" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "19:38:06" , 
"departure_time" : "19:39:06" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "19:41:00" , 
"departure_time" : "19:41:09" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "19:44:09" , 
"departure_time" : "19:44:31" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "19:48:22" , 
"departure_time" : "19:49:55" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "19:51:33" , 
"departure_time" : "19:51:44" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "19:55:11" , 
"departure_time" : "19:55:58" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "19:57:47" , 
"departure_time" : "19:58:26" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "19:59:39" , 
"departure_time" : "20:01:17" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "20:03:38" , 
"departure_time" : "20:04:25" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "20:04:47" , 
"departure_time" : "20:05:11" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "20:08:24" , 
"departure_time" : "20:09:46" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "20:14:22" , 
"departure_time" : "20:15:35" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "20:17:13" , 
"departure_time" : "20:17:39" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "20:18:26" , 
"departure_time" : "20:18:45" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "20:21:19" , 
"departure_time" : "20:21:19" , 
"distance_traveled" : 33.5915
} ], 
"4860" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "19:44:00" , 
"departure_time" : "19:44:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "19:46:28" , 
"departure_time" : "19:46:47" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "19:48:19" , 
"departure_time" : "19:49:12" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "19:55:53" , 
"departure_time" : "19:56:15" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "20:00:22" , 
"departure_time" : "20:01:30" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "20:04:08" , 
"departure_time" : "20:05:30" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "20:09:22" , 
"departure_time" : "20:10:07" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "20:10:45" , 
"departure_time" : "20:12:22" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "20:15:37" , 
"departure_time" : "20:15:53" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "20:18:16" , 
"departure_time" : "20:19:29" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "20:21:13" , 
"departure_time" : "20:22:37" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "20:26:24" , 
"departure_time" : "20:26:25" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "20:27:01" , 
"departure_time" : "20:28:25" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "20:30:24" , 
"departure_time" : "20:30:31" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "20:32:07" , 
"departure_time" : "20:33:38" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "20:35:31" , 
"departure_time" : "20:35:36" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "20:38:05" , 
"departure_time" : "20:38:21" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "20:43:16" , 
"departure_time" : "20:44:17" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "20:47:01" , 
"departure_time" : "20:47:49" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "20:48:48" , 
"departure_time" : "20:49:43" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "20:51:55" , 
"departure_time" : "20:51:55" , 
"distance_traveled" : 33.5915
} ], 
"4861" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "20:14:00" , 
"departure_time" : "20:16:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "20:17:19" , 
"departure_time" : "20:17:44" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "20:18:25" , 
"departure_time" : "20:19:23" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "20:25:58" , 
"departure_time" : "20:26:59" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "20:31:01" , 
"departure_time" : "20:32:22" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "20:34:21" , 
"departure_time" : "20:35:15" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "20:38:54" , 
"departure_time" : "20:40:32" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "20:41:38" , 
"departure_time" : "20:43:11" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "20:45:33" , 
"departure_time" : "20:46:44" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "20:49:11" , 
"departure_time" : "20:50:26" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "20:51:15" , 
"departure_time" : "20:52:40" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "20:56:25" , 
"departure_time" : "20:57:09" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "20:57:44" , 
"departure_time" : "20:58:19" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "20:59:35" , 
"departure_time" : "20:59:54" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "21:02:19" , 
"departure_time" : "21:02:56" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "21:04:37" , 
"departure_time" : "21:04:53" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "21:08:16" , 
"departure_time" : "21:09:35" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "21:14:19" , 
"departure_time" : "21:15:55" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "21:17:36" , 
"departure_time" : "21:18:36" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "21:19:00" , 
"departure_time" : "21:19:34" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "21:21:34" , 
"departure_time" : "21:21:34" , 
"distance_traveled" : 33.5915
} ], 
"4862" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "20:59:00" , 
"departure_time" : "20:59:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "21:01:19" , 
"departure_time" : "21:02:38" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "21:04:19" , 
"departure_time" : "21:04:56" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "21:10:37" , 
"departure_time" : "21:11:45" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "21:16:08" , 
"departure_time" : "21:16:57" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "21:18:49" , 
"departure_time" : "21:19:27" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "21:23:38" , 
"departure_time" : "21:24:25" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "21:25:47" , 
"departure_time" : "21:25:49" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "21:29:02" , 
"departure_time" : "21:30:30" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "21:34:28" , 
"departure_time" : "21:35:16" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "21:35:48" , 
"departure_time" : "21:35:59" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "21:40:11" , 
"departure_time" : "21:40:43" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "21:42:32" , 
"departure_time" : "21:43:18" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "21:44:46" , 
"departure_time" : "21:45:15" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "21:47:29" , 
"departure_time" : "21:48:10" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "21:49:41" , 
"departure_time" : "21:49:42" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "21:53:01" , 
"departure_time" : "21:54:33" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "21:59:32" , 
"departure_time" : "21:59:40" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "22:01:08" , 
"departure_time" : "22:01:54" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "22:03:46" , 
"departure_time" : "22:03:53" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "22:06:07" , 
"departure_time" : "22:06:07" , 
"distance_traveled" : 33.5915
} ], 
"4863" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "21:29:00" , 
"departure_time" : "21:29:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "21:31:20" , 
"departure_time" : "21:32:02" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "21:33:42" , 
"departure_time" : "21:34:47" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "21:41:05" , 
"departure_time" : "21:42:40" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "21:46:35" , 
"departure_time" : "21:46:45" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "21:48:10" , 
"departure_time" : "21:48:31" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "21:53:21" , 
"departure_time" : "21:54:18" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "21:55:57" , 
"departure_time" : "21:57:35" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "22:00:38" , 
"departure_time" : "22:00:50" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "22:03:12" , 
"departure_time" : "22:03:27" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "22:05:15" , 
"departure_time" : "22:05:43" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "22:10:28" , 
"departure_time" : "22:11:50" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "22:13:22" , 
"departure_time" : "22:13:39" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "22:14:17" , 
"departure_time" : "22:14:53" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "22:17:36" , 
"departure_time" : "22:17:56" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "22:19:20" , 
"departure_time" : "22:19:53" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "22:23:33" , 
"departure_time" : "22:24:07" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "22:28:34" , 
"departure_time" : "22:29:32" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "22:31:58" , 
"departure_time" : "22:32:32" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "22:33:34" , 
"departure_time" : "22:33:46" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "22:36:12" , 
"departure_time" : "22:36:12" , 
"distance_traveled" : 33.5915
} ], 
"4864" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "21:59:00" , 
"departure_time" : "21:59:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "22:01:45" , 
"departure_time" : "22:02:26" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "22:03:41" , 
"departure_time" : "22:05:07" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "22:11:26" , 
"departure_time" : "22:12:54" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "22:16:28" , 
"departure_time" : "22:16:40" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "22:18:12" , 
"departure_time" : "22:18:41" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "22:23:29" , 
"departure_time" : "22:23:55" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "22:25:26" , 
"departure_time" : "22:27:02" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "22:30:36" , 
"departure_time" : "22:30:48" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "22:33:12" , 
"departure_time" : "22:34:52" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "22:36:40" , 
"departure_time" : "22:37:43" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "22:41:03" , 
"departure_time" : "22:42:32" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "22:43:29" , 
"departure_time" : "22:44:35" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "22:45:06" , 
"departure_time" : "22:45:55" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "22:47:49" , 
"departure_time" : "22:49:06" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "22:50:17" , 
"departure_time" : "22:50:36" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "22:53:19" , 
"departure_time" : "22:54:15" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "22:58:56" , 
"departure_time" : "22:59:34" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "23:01:38" , 
"departure_time" : "23:02:56" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "23:04:18" , 
"departure_time" : "23:05:06" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "23:06:48" , 
"departure_time" : "23:06:48" , 
"distance_traveled" : 33.5915
} ], 
"4865" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "22:29:00" , 
"departure_time" : "22:30:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "22:31:30" , 
"departure_time" : "22:32:03" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "22:33:33" , 
"departure_time" : "22:34:47" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "22:41:14" , 
"departure_time" : "22:42:30" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "22:46:16" , 
"departure_time" : "22:47:25" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "22:49:09" , 
"departure_time" : "22:50:18" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "22:54:09" , 
"departure_time" : "22:54:15" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "22:55:06" , 
"departure_time" : "22:56:13" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "23:00:07" , 
"departure_time" : "23:01:35" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "23:04:28" , 
"departure_time" : "23:05:41" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "23:06:13" , 
"departure_time" : "23:06:15" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "23:10:02" , 
"departure_time" : "23:10:26" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "23:12:24" , 
"departure_time" : "23:13:25" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "23:15:01" , 
"departure_time" : "23:16:16" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "23:18:15" , 
"departure_time" : "23:18:20" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "23:19:05" , 
"departure_time" : "23:20:32" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "23:24:27" , 
"departure_time" : "23:25:07" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "23:28:40" , 
"departure_time" : "23:29:47" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "23:32:07" , 
"departure_time" : "23:33:04" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "23:33:57" , 
"departure_time" : "23:34:07" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "23:36:10" , 
"departure_time" : "23:36:10" , 
"distance_traveled" : 33.5915
} ], 
"4866" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "22:59:00" , 
"departure_time" : "23:00:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "23:02:10" , 
"departure_time" : "23:02:16" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "23:03:06" , 
"departure_time" : "23:04:43" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "23:11:37" , 
"departure_time" : "23:12:33" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "23:15:56" , 
"departure_time" : "23:16:48" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "23:18:52" , 
"departure_time" : "23:20:00" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "23:24:08" , 
"departure_time" : "23:24:56" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "23:25:48" , 
"departure_time" : "23:26:20" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "23:29:32" , 
"departure_time" : "23:31:06" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "23:34:34" , 
"departure_time" : "23:35:43" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "23:36:09" , 
"departure_time" : "23:36:34" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "23:40:25" , 
"departure_time" : "23:40:55" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "23:42:30" , 
"departure_time" : "23:43:57" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "23:45:27" , 
"departure_time" : "23:45:40" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "23:47:13" , 
"departure_time" : "23:47:28" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "23:49:15" , 
"departure_time" : "23:50:43" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "23:54:28" , 
"departure_time" : "23:55:24" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "23:58:56" , 
"departure_time" : "24:00:18" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "24:02:22" , 
"departure_time" : "24:02:39" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "24:03:17" , 
"departure_time" : "24:03:50" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "24:06:33" , 
"departure_time" : "24:06:33" , 
"distance_traveled" : 33.5915
} ], 
"4867" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "23:29:00" , 
"departure_time" : "23:30:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "23:32:01" , 
"departure_time" : "23:33:15" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "23:34:14" , 
"departure_time" : "23:34:17" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "23:40:03" , 
"departure_time" : "23:40:58" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "23:45:55" , 
"departure_time" : "23:46:28" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "23:48:33" , 
"departure_time" : "23:49:25" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "23:53:52" , 
"departure_time" : "23:54:12" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "23:55:20" , 
"departure_time" : "23:55:28" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "23:59:08" , 
"departure_time" : "23:59:33" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "24:03:25" , 
"departure_time" : "24:04:30" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "24:06:05" , 
"departure_time" : "24:06:34" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "24:10:29" , 
"departure_time" : "24:11:10" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "24:12:41" , 
"departure_time" : "24:13:57" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "24:15:16" , 
"departure_time" : "24:15:17" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "24:17:01" , 
"departure_time" : "24:18:32" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "24:20:31" , 
"departure_time" : "24:22:11" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "24:24:40" , 
"departure_time" : "24:25:09" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "24:28:29" , 
"departure_time" : "24:29:26" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "24:31:57" , 
"departure_time" : "24:33:36" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "24:34:39" , 
"departure_time" : "24:35:17" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "24:36:38" , 
"departure_time" : "24:36:38" , 
"distance_traveled" : 33.5915
} ], 
"4868" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "23:59:00" , 
"departure_time" : "24:00:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "24:01:49" , 
"departure_time" : "24:02:46" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "24:03:57" , 
"departure_time" : "24:04:49" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "24:10:52" , 
"departure_time" : "24:11:39" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "24:15:47" , 
"departure_time" : "24:17:21" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "24:19:34" , 
"departure_time" : "24:19:55" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "24:23:21" , 
"departure_time" : "24:23:48" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "24:25:27" , 
"departure_time" : "24:26:38" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "24:30:11" , 
"departure_time" : "24:30:14" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "24:33:03" , 
"departure_time" : "24:34:02" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "24:35:59" , 
"departure_time" : "24:37:02" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "24:41:03" , 
"departure_time" : "24:41:07" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "24:42:04" , 
"departure_time" : "24:43:02" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "24:44:58" , 
"departure_time" : "24:45:22" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "24:47:24" , 
"departure_time" : "24:47:52" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "24:49:28" , 
"departure_time" : "24:50:11" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "24:53:43" , 
"departure_time" : "24:53:44" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "24:58:01" , 
"departure_time" : "24:59:41" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "25:02:40" , 
"departure_time" : "25:04:07" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "25:04:27" , 
"departure_time" : "25:04:28" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "25:06:01" , 
"departure_time" : "25:06:01" , 
"distance_traveled" : 33.5915
} ], 
"4869" :  [ 
{ 
"stop_id" : 38305,
"arrival_time" : "05:52:00" , 
"departure_time" : "05:53:02" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "05:55:01" , 
"departure_time" : "05:55:09" , 
"distance_traveled" : 1.6337
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "05:58:08" , 
"departure_time" : "05:58:09" , 
"distance_traveled" : 3.1894
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "06:03:01" , 
"departure_time" : "06:04:33" , 
"distance_traveled" : 5.8267
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "06:07:32" , 
"departure_time" : "06:08:46" , 
"distance_traveled" : 6.2515
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "06:10:14" , 
"departure_time" : "06:10:30" , 
"distance_traveled" : 6.6322
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "06:11:16" , 
"departure_time" : "06:11:16" , 
"distance_traveled" : 6.9731
} ], 
"4870" :  [ 
{ 
"stop_id" : 38305,
"arrival_time" : "06:52:00" , 
"departure_time" : "06:53:28" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "06:55:12" , 
"departure_time" : "06:56:00" , 
"distance_traveled" : 1.6337
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "06:58:48" , 
"departure_time" : "07:00:11" , 
"distance_traveled" : 3.1894
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "07:04:23" , 
"departure_time" : "07:05:10" , 
"distance_traveled" : 5.8267
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "07:06:47" , 
"departure_time" : "07:08:26" , 
"distance_traveled" : 6.2515
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "07:09:39" , 
"departure_time" : "07:10:40" , 
"distance_traveled" : 6.6322
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "07:12:01" , 
"departure_time" : "07:12:01" , 
"distance_traveled" : 6.9731
} ], 
"4871" :  [ 
{ 
"stop_id" : 38306,
"arrival_time" : "05:27:00" , 
"departure_time" : "05:28:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "05:32:25" , 
"departure_time" : "05:33:53" , 
"distance_traveled" : 2.6407
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "05:36:28" , 
"departure_time" : "05:38:01" , 
"distance_traveled" : 3.0655
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "05:38:33" , 
"departure_time" : "05:39:58" , 
"distance_traveled" : 3.4462
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "05:40:25" , 
"departure_time" : "05:40:25" , 
"distance_traveled" : 3.7871
} ], 
"4872" :  [ 
{ 
"stop_id" : 38306,
"arrival_time" : "06:27:00" , 
"departure_time" : "06:29:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "06:33:13" , 
"departure_time" : "06:33:16" , 
"distance_traveled" : 2.6407
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "06:35:03" , 
"departure_time" : "06:35:08" , 
"distance_traveled" : 3.0655
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "06:37:05" , 
"departure_time" : "06:38:10" , 
"distance_traveled" : 3.4462
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "06:40:05" , 
"departure_time" : "06:40:05" , 
"distance_traveled" : 3.7871
} ], 
"4873" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "05:44:00" , 
"departure_time" : "05:45:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "05:46:32" , 
"departure_time" : "05:47:19" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "05:48:47" , 
"departure_time" : "05:50:22" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "05:53:35" , 
"departure_time" : "05:54:59" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "05:58:24" , 
"departure_time" : "05:58:27" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "05:59:03" , 
"departure_time" : "06:00:21" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "06:03:18" , 
"departure_time" : "06:04:51" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "06:06:33" , 
"departure_time" : "06:08:12" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "06:08:39" , 
"departure_time" : "06:09:44" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "06:10:05" , 
"departure_time" : "06:11:01" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "06:14:56" , 
"departure_time" : "06:16:08" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "06:17:12" , 
"departure_time" : "06:17:23" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "06:20:11" , 
"departure_time" : "06:21:07" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "06:24:56" , 
"departure_time" : "06:25:43" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "06:26:47" , 
"departure_time" : "06:28:09" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "06:33:22" , 
"departure_time" : "06:34:02" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "06:35:40" , 
"departure_time" : "06:35:52" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "06:40:12" , 
"departure_time" : "06:41:38" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "06:47:26" , 
"departure_time" : "06:48:35" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "06:49:09" , 
"departure_time" : "06:50:07" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "06:51:58" , 
"departure_time" : "06:51:58" , 
"distance_traveled" : 33.5428
} ], 
"4874" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "06:14:00" , 
"departure_time" : "06:15:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "06:16:13" , 
"departure_time" : "06:17:17" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "06:19:04" , 
"departure_time" : "06:20:27" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "06:23:23" , 
"departure_time" : "06:24:47" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "06:28:24" , 
"departure_time" : "06:29:31" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "06:30:07" , 
"departure_time" : "06:31:02" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "06:32:55" , 
"departure_time" : "06:33:29" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "06:35:34" , 
"departure_time" : "06:35:40" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "06:37:06" , 
"departure_time" : "06:37:40" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "06:39:34" , 
"departure_time" : "06:39:47" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "06:44:13" , 
"departure_time" : "06:44:20" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "06:46:07" , 
"departure_time" : "06:46:27" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "06:50:20" , 
"departure_time" : "06:50:41" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "06:54:21" , 
"departure_time" : "06:54:58" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "06:56:37" , 
"departure_time" : "06:58:07" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "07:03:30" , 
"departure_time" : "07:05:04" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "07:06:34" , 
"departure_time" : "07:07:46" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "07:11:12" , 
"departure_time" : "07:12:44" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "07:17:32" , 
"departure_time" : "07:18:00" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "07:18:28" , 
"departure_time" : "07:20:07" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "07:22:39" , 
"departure_time" : "07:22:39" , 
"distance_traveled" : 33.5428
} ], 
"4875" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "06:44:00" , 
"departure_time" : "06:45:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "06:46:07" , 
"departure_time" : "06:46:49" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "06:48:42" , 
"departure_time" : "06:49:03" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "06:52:21" , 
"departure_time" : "06:53:28" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "06:58:07" , 
"departure_time" : "06:59:08" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "07:00:01" , 
"departure_time" : "07:01:03" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "07:03:02" , 
"departure_time" : "07:03:33" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "07:05:31" , 
"departure_time" : "07:05:58" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "07:07:27" , 
"departure_time" : "07:07:57" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "07:09:30" , 
"departure_time" : "07:09:55" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "07:14:25" , 
"departure_time" : "07:15:55" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "07:17:30" , 
"departure_time" : "07:18:57" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "07:21:27" , 
"departure_time" : "07:22:02" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "07:24:35" , 
"departure_time" : "07:24:50" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "07:26:15" , 
"departure_time" : "07:26:41" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "07:32:26" , 
"departure_time" : "07:33:47" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "07:36:21" , 
"departure_time" : "07:37:03" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "07:40:42" , 
"departure_time" : "07:42:13" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "07:47:31" , 
"departure_time" : "07:47:44" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "07:48:13" , 
"departure_time" : "07:49:34" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "07:52:21" , 
"departure_time" : "07:52:21" , 
"distance_traveled" : 33.5428
} ], 
"4876" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "07:14:00" , 
"departure_time" : "07:16:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "07:17:31" , 
"departure_time" : "07:18:48" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "07:19:17" , 
"departure_time" : "07:19:28" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "07:22:11" , 
"departure_time" : "07:23:12" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "07:28:01" , 
"departure_time" : "07:29:00" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "07:29:59" , 
"departure_time" : "07:30:24" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "07:32:25" , 
"departure_time" : "07:32:44" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "07:35:19" , 
"departure_time" : "07:36:51" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "07:38:32" , 
"departure_time" : "07:39:12" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "07:39:40" , 
"departure_time" : "07:40:37" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "07:44:57" , 
"departure_time" : "07:45:22" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "07:46:25" , 
"departure_time" : "07:48:03" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "07:51:38" , 
"departure_time" : "07:51:41" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "07:54:03" , 
"departure_time" : "07:55:05" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "07:57:02" , 
"departure_time" : "07:58:25" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "08:03:23" , 
"departure_time" : "08:03:44" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "08:05:21" , 
"departure_time" : "08:06:59" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "08:11:38" , 
"departure_time" : "08:12:33" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "08:16:55" , 
"departure_time" : "08:17:38" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "08:18:43" , 
"departure_time" : "08:20:04" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "08:22:21" , 
"departure_time" : "08:22:21" , 
"distance_traveled" : 33.5428
} ], 
"4877" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "07:44:00" , 
"departure_time" : "07:46:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "07:46:47" , 
"departure_time" : "07:47:08" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "07:48:21" , 
"departure_time" : "07:49:17" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "07:52:56" , 
"departure_time" : "07:53:27" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "07:57:31" , 
"departure_time" : "07:58:12" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "07:59:41" , 
"departure_time" : "08:00:11" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "08:02:30" , 
"departure_time" : "08:03:45" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "08:06:15" , 
"departure_time" : "08:07:46" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "08:08:31" , 
"departure_time" : "08:09:32" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "08:10:01" , 
"departure_time" : "08:11:08" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "08:15:07" , 
"departure_time" : "08:16:31" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "08:17:24" , 
"departure_time" : "08:17:46" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "08:20:22" , 
"departure_time" : "08:20:32" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "08:24:10" , 
"departure_time" : "08:25:43" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "08:27:33" , 
"departure_time" : "08:28:15" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "08:32:42" , 
"departure_time" : "08:34:03" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "08:36:21" , 
"departure_time" : "08:36:49" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "08:40:28" , 
"departure_time" : "08:41:27" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "08:46:59" , 
"departure_time" : "08:47:54" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "08:48:55" , 
"departure_time" : "08:50:32" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "08:52:37" , 
"departure_time" : "08:52:37" , 
"distance_traveled" : 33.5428
} ], 
"4878" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "08:14:00" , 
"departure_time" : "08:16:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "08:16:46" , 
"departure_time" : "08:17:52" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "08:19:06" , 
"departure_time" : "08:20:43" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "08:23:37" , 
"departure_time" : "08:24:49" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "08:28:12" , 
"departure_time" : "08:28:57" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "08:29:45" , 
"departure_time" : "08:29:49" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "08:32:04" , 
"departure_time" : "08:33:00" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "08:35:56" , 
"departure_time" : "08:37:30" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "08:38:34" , 
"departure_time" : "08:39:08" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "08:39:34" , 
"departure_time" : "08:39:52" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "08:44:18" , 
"departure_time" : "08:44:30" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "08:46:12" , 
"departure_time" : "08:46:28" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "08:50:16" , 
"departure_time" : "08:50:55" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "08:54:39" , 
"departure_time" : "08:54:52" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "08:56:13" , 
"departure_time" : "08:57:09" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "09:02:56" , 
"departure_time" : "09:04:25" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "09:06:29" , 
"departure_time" : "09:07:36" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "09:11:07" , 
"departure_time" : "09:11:55" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "09:16:48" , 
"departure_time" : "09:16:56" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "09:18:08" , 
"departure_time" : "09:19:13" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "09:22:05" , 
"departure_time" : "09:22:05" , 
"distance_traveled" : 33.5428
} ], 
"4879" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "08:44:00" , 
"departure_time" : "08:45:18" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "08:46:13" , 
"departure_time" : "08:46:44" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "08:48:31" , 
"departure_time" : "08:49:36" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "08:53:05" , 
"departure_time" : "08:54:04" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "08:57:59" , 
"departure_time" : "08:58:02" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "08:59:03" , 
"departure_time" : "08:59:35" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "09:02:32" , 
"departure_time" : "09:02:38" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "09:05:06" , 
"departure_time" : "09:06:12" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "09:08:06" , 
"departure_time" : "09:09:15" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "09:10:09" , 
"departure_time" : "09:11:44" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "09:15:35" , 
"departure_time" : "09:16:59" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "09:17:24" , 
"departure_time" : "09:18:21" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "09:20:57" , 
"departure_time" : "09:22:33" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "09:25:36" , 
"departure_time" : "09:25:48" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "09:26:12" , 
"departure_time" : "09:27:30" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "09:33:18" , 
"departure_time" : "09:34:10" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "09:35:52" , 
"departure_time" : "09:36:03" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "09:40:11" , 
"departure_time" : "09:40:56" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "09:46:45" , 
"departure_time" : "09:48:00" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "09:49:15" , 
"departure_time" : "09:49:52" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "09:51:37" , 
"departure_time" : "09:51:37" , 
"distance_traveled" : 33.5428
} ], 
"4880" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "09:14:00" , 
"departure_time" : "09:15:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "09:16:39" , 
"departure_time" : "09:17:18" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "09:18:39" , 
"departure_time" : "09:19:27" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "09:22:48" , 
"departure_time" : "09:22:55" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "09:27:07" , 
"departure_time" : "09:27:24" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "09:29:17" , 
"departure_time" : "09:30:46" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "09:33:29" , 
"departure_time" : "09:33:44" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "09:35:15" , 
"departure_time" : "09:36:30" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "09:38:15" , 
"departure_time" : "09:39:21" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "09:40:06" , 
"departure_time" : "09:40:14" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "09:44:08" , 
"departure_time" : "09:45:05" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "09:46:57" , 
"departure_time" : "09:48:21" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "09:51:24" , 
"departure_time" : "09:51:54" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "09:54:30" , 
"departure_time" : "09:55:55" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "09:57:25" , 
"departure_time" : "09:58:08" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "10:02:43" , 
"departure_time" : "10:04:14" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "10:06:31" , 
"departure_time" : "10:07:10" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "10:10:39" , 
"departure_time" : "10:10:57" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "10:16:18" , 
"departure_time" : "10:16:26" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "10:18:08" , 
"departure_time" : "10:19:37" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "10:22:29" , 
"departure_time" : "10:22:29" , 
"distance_traveled" : 33.5428
} ], 
"4881" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "09:44:00" , 
"departure_time" : "09:45:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "09:46:16" , 
"departure_time" : "09:47:34" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "09:49:18" , 
"departure_time" : "09:50:33" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "09:53:15" , 
"departure_time" : "09:53:40" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "09:57:25" , 
"departure_time" : "09:57:33" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "09:59:08" , 
"departure_time" : "09:59:34" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "10:02:26" , 
"departure_time" : "10:02:42" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "10:05:16" , 
"departure_time" : "10:06:44" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "10:08:28" , 
"departure_time" : "10:09:06" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "10:09:38" , 
"departure_time" : "10:10:58" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "10:15:20" , 
"departure_time" : "10:16:05" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "10:16:45" , 
"departure_time" : "10:18:14" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "10:21:29" , 
"departure_time" : "10:23:06" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "10:25:37" , 
"departure_time" : "10:26:27" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "10:26:50" , 
"departure_time" : "10:28:13" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "10:33:23" , 
"departure_time" : "10:33:26" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "10:35:03" , 
"departure_time" : "10:35:30" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "10:40:27" , 
"departure_time" : "10:41:52" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "10:47:25" , 
"departure_time" : "10:48:22" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "10:48:57" , 
"departure_time" : "10:50:29" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "10:52:32" , 
"departure_time" : "10:52:32" , 
"distance_traveled" : 33.5428
} ], 
"4882" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "10:14:00" , 
"departure_time" : "10:16:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "10:17:10" , 
"departure_time" : "10:17:39" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "10:18:29" , 
"departure_time" : "10:18:31" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "10:22:02" , 
"departure_time" : "10:22:21" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "10:27:19" , 
"departure_time" : "10:28:15" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "10:29:56" , 
"departure_time" : "10:30:33" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "10:32:37" , 
"departure_time" : "10:34:07" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "10:36:30" , 
"departure_time" : "10:36:50" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "10:37:20" , 
"departure_time" : "10:37:59" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "10:39:39" , 
"departure_time" : "10:39:48" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "10:44:09" , 
"departure_time" : "10:45:09" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "10:47:00" , 
"departure_time" : "10:47:31" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "10:50:31" , 
"departure_time" : "10:51:46" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "10:55:15" , 
"departure_time" : "10:56:41" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "10:57:26" , 
"departure_time" : "10:58:10" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "11:02:44" , 
"departure_time" : "11:03:25" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "11:05:41" , 
"departure_time" : "11:06:14" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "11:10:33" , 
"departure_time" : "11:12:08" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "11:17:35" , 
"departure_time" : "11:17:45" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "11:18:10" , 
"departure_time" : "11:19:32" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "11:22:22" , 
"departure_time" : "11:22:22" , 
"distance_traveled" : 33.5428
} ], 
"4883" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "10:44:00" , 
"departure_time" : "10:45:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "10:46:17" , 
"departure_time" : "10:47:23" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "10:49:06" , 
"departure_time" : "10:50:17" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "10:53:11" , 
"departure_time" : "10:54:12" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "10:58:01" , 
"departure_time" : "10:58:58" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "10:59:57" , 
"departure_time" : "11:00:44" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "11:02:47" , 
"departure_time" : "11:04:20" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "11:06:33" , 
"departure_time" : "11:07:00" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "11:07:27" , 
"departure_time" : "11:08:08" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "11:09:41" , 
"departure_time" : "11:10:25" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "11:14:44" , 
"departure_time" : "11:14:58" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "11:16:14" , 
"departure_time" : "11:16:32" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "11:20:18" , 
"departure_time" : "11:21:33" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "11:25:15" , 
"departure_time" : "11:25:27" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "11:26:12" , 
"departure_time" : "11:26:31" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "11:32:19" , 
"departure_time" : "11:33:46" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "11:36:27" , 
"departure_time" : "11:37:01" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "11:40:34" , 
"departure_time" : "11:40:46" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "11:46:12" , 
"departure_time" : "11:46:31" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "11:48:19" , 
"departure_time" : "11:49:47" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "11:52:28" , 
"departure_time" : "11:52:28" , 
"distance_traveled" : 33.5428
} ], 
"4884" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "11:14:00" , 
"departure_time" : "11:15:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "11:16:21" , 
"departure_time" : "11:17:26" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "11:19:05" , 
"departure_time" : "11:20:24" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "11:23:19" , 
"departure_time" : "11:24:52" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "11:28:33" , 
"departure_time" : "11:29:24" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "11:29:51" , 
"departure_time" : "11:30:34" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "11:32:43" , 
"departure_time" : "11:34:11" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "11:36:28" , 
"departure_time" : "11:37:34" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "11:38:06" , 
"departure_time" : "11:38:12" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "11:39:06" , 
"departure_time" : "11:40:44" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "11:45:38" , 
"departure_time" : "11:46:12" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "11:46:34" , 
"departure_time" : "11:47:01" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "11:50:27" , 
"departure_time" : "11:50:43" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "11:54:16" , 
"departure_time" : "11:55:25" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "11:57:09" , 
"departure_time" : "11:58:49" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "12:03:40" , 
"departure_time" : "12:05:12" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "12:06:32" , 
"departure_time" : "12:06:54" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "12:10:22" , 
"departure_time" : "12:11:11" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "12:16:49" , 
"departure_time" : "12:18:00" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "12:19:11" , 
"departure_time" : "12:19:28" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "12:21:17" , 
"departure_time" : "12:21:17" , 
"distance_traveled" : 33.5428
} ], 
"4885" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "11:44:00" , 
"departure_time" : "11:45:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "11:46:53" , 
"departure_time" : "11:47:59" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "11:49:06" , 
"departure_time" : "11:50:35" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "11:53:29" , 
"departure_time" : "11:53:31" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "11:57:02" , 
"departure_time" : "11:57:11" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "11:59:09" , 
"departure_time" : "12:00:38" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "12:03:29" , 
"departure_time" : "12:04:59" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "12:06:30" , 
"departure_time" : "12:07:16" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "12:07:46" , 
"departure_time" : "12:08:46" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "12:10:00" , 
"departure_time" : "12:11:08" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "12:15:08" , 
"departure_time" : "12:15:09" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "12:16:01" , 
"departure_time" : "12:16:56" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "12:20:55" , 
"departure_time" : "12:22:03" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "12:25:08" , 
"departure_time" : "12:25:25" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "12:26:17" , 
"departure_time" : "12:26:23" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "12:32:06" , 
"departure_time" : "12:33:12" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "12:36:06" , 
"departure_time" : "12:37:26" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "12:41:20" , 
"departure_time" : "12:41:42" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "12:46:22" , 
"departure_time" : "12:47:18" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "12:48:56" , 
"departure_time" : "12:49:08" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "12:51:12" , 
"departure_time" : "12:51:12" , 
"distance_traveled" : 33.5428
} ], 
"4886" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "12:14:00" , 
"departure_time" : "12:14:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "12:16:01" , 
"departure_time" : "12:17:18" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "12:19:17" , 
"departure_time" : "12:19:46" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "12:22:29" , 
"departure_time" : "12:24:00" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "12:28:31" , 
"departure_time" : "12:29:49" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "12:30:18" , 
"departure_time" : "12:31:18" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "12:33:00" , 
"departure_time" : "12:33:07" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "12:35:07" , 
"departure_time" : "12:36:19" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "12:38:12" , 
"departure_time" : "12:38:27" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "12:39:15" , 
"departure_time" : "12:40:29" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "12:45:14" , 
"departure_time" : "12:45:43" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "12:46:29" , 
"departure_time" : "12:47:02" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "12:50:33" , 
"departure_time" : "12:51:09" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "12:54:36" , 
"departure_time" : "12:54:40" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "12:56:04" , 
"departure_time" : "12:57:24" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "13:03:20" , 
"departure_time" : "13:04:50" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "13:06:30" , 
"departure_time" : "13:06:57" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "13:10:27" , 
"departure_time" : "13:11:38" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "13:17:11" , 
"departure_time" : "13:18:13" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "13:19:02" , 
"departure_time" : "13:19:06" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "13:21:04" , 
"departure_time" : "13:21:04" , 
"distance_traveled" : 33.5428
} ], 
"4887" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "12:44:00" , 
"departure_time" : "12:44:15" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "12:46:11" , 
"departure_time" : "12:46:25" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "12:48:14" , 
"departure_time" : "12:49:06" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "12:52:52" , 
"departure_time" : "12:54:16" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "12:58:24" , 
"departure_time" : "12:59:50" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "13:00:26" , 
"departure_time" : "13:01:14" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "13:02:48" , 
"departure_time" : "13:04:10" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "13:06:22" , 
"departure_time" : "13:07:24" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "13:08:02" , 
"departure_time" : "13:08:18" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "13:09:16" , 
"departure_time" : "13:09:55" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "13:14:39" , 
"departure_time" : "13:16:08" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "13:17:29" , 
"departure_time" : "13:18:17" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "13:20:48" , 
"departure_time" : "13:21:27" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "13:24:39" , 
"departure_time" : "13:26:03" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "13:27:24" , 
"departure_time" : "13:27:44" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "13:32:20" , 
"departure_time" : "13:32:27" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "13:35:07" , 
"departure_time" : "13:35:59" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "13:40:52" , 
"departure_time" : "13:41:14" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "13:46:22" , 
"departure_time" : "13:46:53" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "13:48:31" , 
"departure_time" : "13:48:55" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "13:51:24" , 
"departure_time" : "13:51:24" , 
"distance_traveled" : 33.5428
} ], 
"4888" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "13:14:00" , 
"departure_time" : "13:15:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "13:17:27" , 
"departure_time" : "13:18:03" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "13:18:36" , 
"departure_time" : "13:19:53" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "13:23:17" , 
"departure_time" : "13:24:35" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "13:28:18" , 
"departure_time" : "13:29:01" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "13:29:43" , 
"departure_time" : "13:30:40" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "13:32:57" , 
"departure_time" : "13:34:27" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "13:36:30" , 
"departure_time" : "13:37:05" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "13:37:35" , 
"departure_time" : "13:39:04" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "13:40:29" , 
"departure_time" : "13:41:00" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "13:44:31" , 
"departure_time" : "13:45:01" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "13:46:30" , 
"departure_time" : "13:48:10" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "13:51:40" , 
"departure_time" : "13:51:52" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "13:54:12" , 
"departure_time" : "13:55:37" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "13:57:25" , 
"departure_time" : "13:58:08" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "14:02:43" , 
"departure_time" : "14:03:20" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "14:05:37" , 
"departure_time" : "14:05:56" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "14:10:19" , 
"departure_time" : "14:11:32" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "14:17:13" , 
"departure_time" : "14:17:56" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "14:18:43" , 
"departure_time" : "14:19:44" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "14:22:01" , 
"departure_time" : "14:22:01" , 
"distance_traveled" : 33.5428
} ], 
"4889" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "13:44:00" , 
"departure_time" : "13:45:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "13:46:11" , 
"departure_time" : "13:46:38" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "13:48:27" , 
"departure_time" : "13:48:47" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "13:52:20" , 
"departure_time" : "13:53:48" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "13:58:28" , 
"departure_time" : "13:59:45" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "14:00:17" , 
"departure_time" : "14:01:27" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "14:03:10" , 
"departure_time" : "14:03:16" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "14:05:06" , 
"departure_time" : "14:05:15" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "14:07:09" , 
"departure_time" : "14:08:44" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "14:10:35" , 
"departure_time" : "14:12:02" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "14:15:27" , 
"departure_time" : "14:15:39" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "14:16:12" , 
"departure_time" : "14:16:42" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "14:20:30" , 
"departure_time" : "14:21:51" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "14:25:21" , 
"departure_time" : "14:26:07" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "14:26:46" , 
"departure_time" : "14:27:16" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "14:32:30" , 
"departure_time" : "14:34:00" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "14:36:30" , 
"departure_time" : "14:36:32" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "14:40:02" , 
"departure_time" : "14:40:27" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "14:46:25" , 
"departure_time" : "14:46:53" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "14:48:28" , 
"departure_time" : "14:49:21" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "14:51:53" , 
"departure_time" : "14:51:53" , 
"distance_traveled" : 33.5428
} ], 
"4890" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "14:14:00" , 
"departure_time" : "14:15:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "14:16:59" , 
"departure_time" : "14:18:31" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "14:19:32" , 
"departure_time" : "14:20:22" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "14:22:50" , 
"departure_time" : "14:24:05" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "14:28:15" , 
"departure_time" : "14:29:49" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "14:30:34" , 
"departure_time" : "14:31:13" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "14:32:39" , 
"departure_time" : "14:34:15" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "14:36:36" , 
"departure_time" : "14:38:01" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "14:38:25" , 
"departure_time" : "14:39:45" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "14:40:20" , 
"departure_time" : "14:40:22" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "14:44:02" , 
"departure_time" : "14:45:22" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "14:47:20" , 
"departure_time" : "14:48:55" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "14:51:35" , 
"departure_time" : "14:51:46" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "14:54:11" , 
"departure_time" : "14:55:33" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "14:57:22" , 
"departure_time" : "14:57:49" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "15:02:27" , 
"departure_time" : "15:03:48" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "15:06:21" , 
"departure_time" : "15:06:36" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "15:10:15" , 
"departure_time" : "15:10:21" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "15:16:06" , 
"departure_time" : "15:16:31" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "15:18:25" , 
"departure_time" : "15:20:00" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "15:22:35" , 
"departure_time" : "15:22:35" , 
"distance_traveled" : 33.5428
} ], 
"4891" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "14:44:00" , 
"departure_time" : "14:46:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "14:46:47" , 
"departure_time" : "14:48:13" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "14:49:26" , 
"departure_time" : "14:49:55" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "14:52:29" , 
"departure_time" : "14:52:55" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "14:57:26" , 
"departure_time" : "14:57:41" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "14:59:15" , 
"departure_time" : "15:00:45" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "15:03:30" , 
"departure_time" : "15:04:27" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "15:05:57" , 
"departure_time" : "15:06:25" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "15:07:28" , 
"departure_time" : "15:08:06" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "15:09:38" , 
"departure_time" : "15:10:22" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "15:14:44" , 
"departure_time" : "15:14:51" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "15:16:07" , 
"departure_time" : "15:16:55" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "15:20:48" , 
"departure_time" : "15:21:35" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "15:24:47" , 
"departure_time" : "15:25:23" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "15:26:36" , 
"departure_time" : "15:27:54" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "15:33:18" , 
"departure_time" : "15:33:22" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "15:35:04" , 
"departure_time" : "15:35:59" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "15:40:55" , 
"departure_time" : "15:42:08" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "15:47:13" , 
"departure_time" : "15:48:00" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "15:48:47" , 
"departure_time" : "15:50:24" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "15:52:37" , 
"departure_time" : "15:52:37" , 
"distance_traveled" : 33.5428
} ], 
"4892" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "15:14:00" , 
"departure_time" : "15:17:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "15:17:27" , 
"departure_time" : "15:17:56" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "15:18:29" , 
"departure_time" : "15:20:04" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "15:23:35" , 
"departure_time" : "15:25:13" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "15:28:38" , 
"departure_time" : "15:29:54" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "15:30:16" , 
"departure_time" : "15:31:10" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "15:32:54" , 
"departure_time" : "15:34:10" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "15:36:16" , 
"departure_time" : "15:37:32" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "15:38:16" , 
"departure_time" : "15:38:45" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "15:39:29" , 
"departure_time" : "15:40:19" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "15:44:50" , 
"departure_time" : "15:46:06" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "15:47:16" , 
"departure_time" : "15:48:32" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "15:51:16" , 
"departure_time" : "15:52:10" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "15:54:54" , 
"departure_time" : "15:55:00" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "15:56:06" , 
"departure_time" : "15:57:13" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "16:03:07" , 
"departure_time" : "16:04:47" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "16:06:40" , 
"departure_time" : "16:07:39" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "16:10:59" , 
"departure_time" : "16:11:35" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "16:16:36" , 
"departure_time" : "16:17:50" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "16:19:14" , 
"departure_time" : "16:19:49" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "16:21:35" , 
"departure_time" : "16:21:35" , 
"distance_traveled" : 33.5428
} ], 
"4893" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "15:44:00" , 
"departure_time" : "15:46:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "15:47:29" , 
"departure_time" : "15:49:04" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "15:49:35" , 
"departure_time" : "15:50:05" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "15:52:30" , 
"departure_time" : "15:53:42" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "15:58:12" , 
"departure_time" : "15:58:50" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "15:59:38" , 
"departure_time" : "16:01:17" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "16:03:39" , 
"departure_time" : "16:04:03" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "16:05:24" , 
"departure_time" : "16:05:53" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "16:07:29" , 
"departure_time" : "16:08:46" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "16:10:17" , 
"departure_time" : "16:11:35" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "16:15:18" , 
"departure_time" : "16:15:45" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "16:16:27" , 
"departure_time" : "16:17:57" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "16:21:30" , 
"departure_time" : "16:21:53" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "16:24:23" , 
"departure_time" : "16:25:15" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "16:26:52" , 
"departure_time" : "16:27:34" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "16:32:42" , 
"departure_time" : "16:33:54" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "16:36:12" , 
"departure_time" : "16:37:41" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "16:41:29" , 
"departure_time" : "16:41:31" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "16:46:02" , 
"departure_time" : "16:46:34" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "16:48:32" , 
"departure_time" : "16:49:05" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "16:51:33" , 
"departure_time" : "16:51:33" , 
"distance_traveled" : 33.5428
} ], 
"4894" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "16:14:00" , 
"departure_time" : "16:14:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "16:16:17" , 
"departure_time" : "16:16:42" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "16:18:25" , 
"departure_time" : "16:19:59" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "16:23:34" , 
"departure_time" : "16:23:46" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "16:27:12" , 
"departure_time" : "16:28:05" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "16:29:53" , 
"departure_time" : "16:30:33" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "16:32:40" , 
"departure_time" : "16:33:46" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "16:36:06" , 
"departure_time" : "16:37:15" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "16:38:09" , 
"departure_time" : "16:39:12" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "16:40:03" , 
"departure_time" : "16:41:38" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "16:45:35" , 
"departure_time" : "16:47:05" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "16:47:30" , 
"departure_time" : "16:47:38" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "16:50:08" , 
"departure_time" : "16:50:34" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "16:54:26" , 
"departure_time" : "16:54:52" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "16:56:26" , 
"departure_time" : "16:57:24" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "17:02:58" , 
"departure_time" : "17:03:55" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "17:05:57" , 
"departure_time" : "17:06:46" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "17:10:49" , 
"departure_time" : "17:11:27" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "17:16:38" , 
"departure_time" : "17:17:56" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "17:19:18" , 
"departure_time" : "17:20:38" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "17:22:20" , 
"departure_time" : "17:22:20" , 
"distance_traveled" : 33.5428
} ], 
"4895" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "16:44:00" , 
"departure_time" : "16:45:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "16:46:16" , 
"departure_time" : "16:47:46" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "16:49:30" , 
"departure_time" : "16:50:02" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "16:52:32" , 
"departure_time" : "16:52:55" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "16:57:23" , 
"departure_time" : "16:57:41" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "16:59:18" , 
"departure_time" : "17:00:51" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "17:03:33" , 
"departure_time" : "17:04:26" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "17:05:53" , 
"departure_time" : "17:06:46" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "17:07:53" , 
"departure_time" : "17:09:10" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "17:10:17" , 
"departure_time" : "17:10:43" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "17:14:26" , 
"departure_time" : "17:15:25" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "17:16:59" , 
"departure_time" : "17:17:52" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "17:20:53" , 
"departure_time" : "17:22:30" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "17:25:37" , 
"departure_time" : "17:27:14" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "17:27:37" , 
"departure_time" : "17:28:41" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "17:33:04" , 
"departure_time" : "17:33:18" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "17:35:14" , 
"departure_time" : "17:35:45" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "17:40:31" , 
"departure_time" : "17:41:06" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "17:46:35" , 
"departure_time" : "17:47:58" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "17:49:23" , 
"departure_time" : "17:50:11" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "17:51:48" , 
"departure_time" : "17:51:48" , 
"distance_traveled" : 33.5428
} ], 
"4896" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "17:14:00" , 
"departure_time" : "17:15:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "17:16:36" , 
"departure_time" : "17:17:42" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "17:19:06" , 
"departure_time" : "17:19:07" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "17:22:01" , 
"departure_time" : "17:22:07" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "17:27:06" , 
"departure_time" : "17:27:26" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "17:29:20" , 
"departure_time" : "17:30:24" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "17:33:04" , 
"departure_time" : "17:34:13" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "17:36:09" , 
"departure_time" : "17:37:10" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "17:38:01" , 
"departure_time" : "17:39:40" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "17:40:39" , 
"departure_time" : "17:41:34" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "17:44:55" , 
"departure_time" : "17:45:24" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "17:46:29" , 
"departure_time" : "17:47:27" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "17:50:58" , 
"departure_time" : "17:52:38" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "17:55:40" , 
"departure_time" : "17:56:35" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "17:56:55" , 
"departure_time" : "17:57:23" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "18:02:28" , 
"departure_time" : "18:03:13" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "18:05:45" , 
"departure_time" : "18:06:00" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "18:10:15" , 
"departure_time" : "18:10:16" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "18:16:01" , 
"departure_time" : "18:17:00" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "18:18:59" , 
"departure_time" : "18:20:34" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "18:22:35" , 
"departure_time" : "18:22:35" , 
"distance_traveled" : 33.5428
} ], 
"4897" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "17:44:00" , 
"departure_time" : "17:45:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "17:46:11" , 
"departure_time" : "17:47:31" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "17:49:20" , 
"departure_time" : "17:50:29" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "17:53:09" , 
"departure_time" : "17:53:27" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "17:57:18" , 
"departure_time" : "17:58:56" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "18:00:38" , 
"departure_time" : "18:01:18" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "18:02:40" , 
"departure_time" : "18:03:17" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "18:05:37" , 
"departure_time" : "18:07:12" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "18:08:35" , 
"departure_time" : "18:09:24" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "18:09:49" , 
"departure_time" : "18:10:22" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "18:14:33" , 
"departure_time" : "18:15:43" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "18:17:10" , 
"departure_time" : "18:18:15" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "18:21:05" , 
"departure_time" : "18:22:43" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "18:25:38" , 
"departure_time" : "18:26:51" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "18:27:13" , 
"departure_time" : "18:28:37" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "18:33:24" , 
"departure_time" : "18:34:59" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "18:36:35" , 
"departure_time" : "18:37:56" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "18:41:21" , 
"departure_time" : "18:41:29" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "18:46:08" , 
"departure_time" : "18:46:15" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "18:48:07" , 
"departure_time" : "18:48:30" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "18:51:23" , 
"departure_time" : "18:51:23" , 
"distance_traveled" : 33.5428
} ], 
"4898" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "18:14:00" , 
"departure_time" : "18:15:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "18:17:11" , 
"departure_time" : "18:18:35" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "18:19:24" , 
"departure_time" : "18:20:40" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "18:23:16" , 
"departure_time" : "18:24:01" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "18:27:45" , 
"departure_time" : "18:29:07" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "18:30:22" , 
"departure_time" : "18:30:27" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "18:32:05" , 
"departure_time" : "18:32:18" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "18:35:13" , 
"departure_time" : "18:36:01" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "18:37:48" , 
"departure_time" : "18:38:44" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "18:39:56" , 
"departure_time" : "18:41:00" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "18:45:04" , 
"departure_time" : "18:45:41" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "18:46:37" , 
"departure_time" : "18:47:27" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "18:50:50" , 
"departure_time" : "18:51:41" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "18:54:51" , 
"departure_time" : "18:55:59" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "18:57:08" , 
"departure_time" : "18:57:46" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "19:02:38" , 
"departure_time" : "19:03:24" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "19:05:46" , 
"departure_time" : "19:06:47" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "19:11:01" , 
"departure_time" : "19:11:17" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "19:16:16" , 
"departure_time" : "19:17:17" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "19:19:01" , 
"departure_time" : "19:19:10" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "19:21:09" , 
"departure_time" : "19:21:09" , 
"distance_traveled" : 33.5428
} ], 
"4899" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "18:44:00" , 
"departure_time" : "18:45:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "18:47:25" , 
"departure_time" : "18:48:23" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "18:48:58" , 
"departure_time" : "18:49:10" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "18:52:12" , 
"departure_time" : "18:53:15" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "18:58:03" , 
"departure_time" : "18:58:12" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "18:59:09" , 
"departure_time" : "18:59:25" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "19:02:16" , 
"departure_time" : "19:02:37" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "19:05:21" , 
"departure_time" : "19:05:43" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "19:07:22" , 
"departure_time" : "19:08:56" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "19:10:34" , 
"departure_time" : "19:11:49" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "19:15:15" , 
"departure_time" : "19:16:30" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "19:17:15" , 
"departure_time" : "19:17:48" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "19:20:33" , 
"departure_time" : "19:21:54" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "19:25:21" , 
"departure_time" : "19:25:22" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "19:26:01" , 
"departure_time" : "19:26:10" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "19:32:09" , 
"departure_time" : "19:32:26" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "19:35:17" , 
"departure_time" : "19:35:57" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "19:40:40" , 
"departure_time" : "19:41:55" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "19:47:15" , 
"departure_time" : "19:48:13" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "19:48:58" , 
"departure_time" : "19:49:54" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "19:51:56" , 
"departure_time" : "19:51:56" , 
"distance_traveled" : 33.5428
} ], 
"4900" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "19:14:00" , 
"departure_time" : "19:15:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "19:16:30" , 
"departure_time" : "19:16:42" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "19:18:12" , 
"departure_time" : "19:19:41" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "19:23:29" , 
"departure_time" : "19:23:43" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "19:27:14" , 
"departure_time" : "19:28:45" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "19:30:31" , 
"departure_time" : "19:31:05" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "19:32:34" , 
"departure_time" : "19:33:51" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "19:36:17" , 
"departure_time" : "19:36:21" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "19:37:04" , 
"departure_time" : "19:38:23" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "19:40:19" , 
"departure_time" : "19:41:59" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "19:45:40" , 
"departure_time" : "19:46:41" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "19:47:01" , 
"departure_time" : "19:47:44" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "19:50:43" , 
"departure_time" : "19:52:19" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "19:55:36" , 
"departure_time" : "19:56:47" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "19:57:11" , 
"departure_time" : "19:58:37" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "20:03:26" , 
"departure_time" : "20:03:54" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "20:05:28" , 
"departure_time" : "20:05:51" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "20:10:23" , 
"departure_time" : "20:10:31" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "20:16:08" , 
"departure_time" : "20:16:17" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "20:18:09" , 
"departure_time" : "20:18:51" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "20:21:42" , 
"departure_time" : "20:21:42" , 
"distance_traveled" : 33.5428
} ], 
"4901" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "19:44:00" , 
"departure_time" : "19:46:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "19:47:29" , 
"departure_time" : "19:48:54" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "19:49:25" , 
"departure_time" : "19:50:43" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "19:53:18" , 
"departure_time" : "19:53:24" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "19:57:06" , 
"departure_time" : "19:57:31" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "19:59:25" , 
"departure_time" : "20:00:04" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "20:02:39" , 
"departure_time" : "20:03:25" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "20:05:46" , 
"departure_time" : "20:06:26" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "20:07:40" , 
"departure_time" : "20:09:09" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "20:10:29" , 
"departure_time" : "20:11:59" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "20:15:30" , 
"departure_time" : "20:15:40" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "20:16:10" , 
"departure_time" : "20:17:06" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "20:20:56" , 
"departure_time" : "20:21:49" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "20:24:53" , 
"departure_time" : "20:25:24" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "20:26:31" , 
"departure_time" : "20:27:45" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "20:33:14" , 
"departure_time" : "20:34:31" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "20:36:17" , 
"departure_time" : "20:36:49" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "20:40:32" , 
"departure_time" : "20:41:10" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "20:46:38" , 
"departure_time" : "20:47:20" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "20:48:42" , 
"departure_time" : "20:49:01" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "20:51:19" , 
"departure_time" : "20:51:19" , 
"distance_traveled" : 33.5428
} ], 
"4902" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "20:14:00" , 
"departure_time" : "20:15:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "20:16:58" , 
"departure_time" : "20:18:12" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "20:19:14" , 
"departure_time" : "20:20:43" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "20:23:29" , 
"departure_time" : "20:24:03" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "20:27:34" , 
"departure_time" : "20:27:50" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "20:29:16" , 
"departure_time" : "20:29:37" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "20:32:21" , 
"departure_time" : "20:32:55" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "20:35:34" , 
"departure_time" : "20:35:58" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "20:37:24" , 
"departure_time" : "20:37:28" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "20:39:04" , 
"departure_time" : "20:39:38" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "20:44:34" , 
"departure_time" : "20:45:48" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "20:47:14" , 
"departure_time" : "20:47:28" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "20:50:14" , 
"departure_time" : "20:50:48" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "20:54:34" , 
"departure_time" : "20:54:48" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "20:56:14" , 
"departure_time" : "20:57:30" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "21:03:16" , 
"departure_time" : "21:03:31" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "21:05:15" , 
"departure_time" : "21:05:35" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "21:10:20" , 
"departure_time" : "21:11:22" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "21:17:02" , 
"departure_time" : "21:17:39" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "21:18:37" , 
"departure_time" : "21:19:56" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "21:22:19" , 
"departure_time" : "21:22:19" , 
"distance_traveled" : 33.5428
} ], 
"4903" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "20:59:00" , 
"departure_time" : "21:00:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "21:01:01" , 
"departure_time" : "21:02:17" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "21:04:16" , 
"departure_time" : "21:04:38" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "21:07:22" , 
"departure_time" : "21:07:42" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "21:12:20" , 
"departure_time" : "21:13:43" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "21:15:23" , 
"departure_time" : "21:16:41" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "21:18:18" , 
"departure_time" : "21:18:22" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "21:20:04" , 
"departure_time" : "21:20:23" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "21:22:19" , 
"departure_time" : "21:22:37" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "21:24:18" , 
"departure_time" : "21:24:59" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "21:29:41" , 
"departure_time" : "21:29:43" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "21:31:02" , 
"departure_time" : "21:32:25" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "21:36:23" , 
"departure_time" : "21:36:50" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "21:39:27" , 
"departure_time" : "21:40:18" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "21:41:51" , 
"departure_time" : "21:43:16" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "21:48:25" , 
"departure_time" : "21:48:28" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "21:50:03" , 
"departure_time" : "21:50:26" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "21:55:23" , 
"departure_time" : "21:57:01" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "22:02:38" , 
"departure_time" : "22:03:56" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "22:04:18" , 
"departure_time" : "22:05:38" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "22:07:20" , 
"departure_time" : "22:07:20" , 
"distance_traveled" : 33.5428
} ], 
"4904" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "21:29:00" , 
"departure_time" : "21:31:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "21:32:26" , 
"departure_time" : "21:33:05" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "21:33:39" , 
"departure_time" : "21:34:32" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "21:37:53" , 
"departure_time" : "21:38:34" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "21:42:41" , 
"departure_time" : "21:44:18" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "21:45:37" , 
"departure_time" : "21:47:05" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "21:48:28" , 
"departure_time" : "21:49:07" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "21:50:39" , 
"departure_time" : "21:50:50" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "21:52:11" , 
"departure_time" : "21:53:45" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "21:55:34" , 
"departure_time" : "21:56:56" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "22:00:22" , 
"departure_time" : "22:00:52" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "22:01:30" , 
"departure_time" : "22:02:58" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "22:06:28" , 
"departure_time" : "22:06:46" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "22:09:18" , 
"departure_time" : "22:09:56" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "22:11:38" , 
"departure_time" : "22:12:32" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "22:17:54" , 
"departure_time" : "22:19:17" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "22:21:23" , 
"departure_time" : "22:22:19" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "22:25:56" , 
"departure_time" : "22:27:35" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "22:32:39" , 
"departure_time" : "22:34:14" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "22:34:35" , 
"departure_time" : "22:34:37" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "22:36:02" , 
"departure_time" : "22:36:02" , 
"distance_traveled" : 33.5428
} ], 
"4905" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "21:59:00" , 
"departure_time" : "22:00:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "22:02:24" , 
"departure_time" : "22:02:50" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "22:03:26" , 
"departure_time" : "22:03:47" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "22:07:21" , 
"departure_time" : "22:08:03" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "22:12:42" , 
"departure_time" : "22:13:45" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "22:15:03" , 
"departure_time" : "22:15:36" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "22:17:33" , 
"departure_time" : "22:18:09" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "22:20:36" , 
"departure_time" : "22:20:39" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "22:22:03" , 
"departure_time" : "22:23:05" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "22:25:02" , 
"departure_time" : "22:26:24" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "22:30:22" , 
"departure_time" : "22:31:41" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "22:32:19" , 
"departure_time" : "22:33:50" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "22:36:31" , 
"departure_time" : "22:37:33" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "22:40:02" , 
"departure_time" : "22:41:03" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "22:42:01" , 
"departure_time" : "22:42:16" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "22:47:15" , 
"departure_time" : "22:47:23" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "22:50:08" , 
"departure_time" : "22:50:46" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "22:55:38" , 
"departure_time" : "22:56:04" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "23:01:26" , 
"departure_time" : "23:02:44" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "23:04:18" , 
"departure_time" : "23:04:31" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "23:06:13" , 
"departure_time" : "23:06:13" , 
"distance_traveled" : 33.5428
} ], 
"4906" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "22:29:00" , 
"departure_time" : "22:30:04" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "22:31:51" , 
"departure_time" : "22:33:31" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "22:34:40" , 
"departure_time" : "22:35:17" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "22:37:37" , 
"departure_time" : "22:37:52" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "22:42:15" , 
"departure_time" : "22:42:24" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "22:44:09" , 
"departure_time" : "22:44:49" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "22:47:40" , 
"departure_time" : "22:48:58" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "22:51:18" , 
"departure_time" : "22:51:39" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "22:52:21" , 
"departure_time" : "22:53:06" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "22:54:45" , 
"departure_time" : "22:55:58" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "23:00:13" , 
"departure_time" : "23:00:28" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "23:01:15" , 
"departure_time" : "23:02:36" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "23:06:21" , 
"departure_time" : "23:07:09" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "23:09:48" , 
"departure_time" : "23:10:40" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "23:11:52" , 
"departure_time" : "23:11:58" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "23:17:06" , 
"departure_time" : "23:18:04" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "23:20:58" , 
"departure_time" : "23:21:51" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "23:25:53" , 
"departure_time" : "23:26:11" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "23:31:18" , 
"departure_time" : "23:32:28" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "23:34:10" , 
"departure_time" : "23:34:54" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "23:36:44" , 
"departure_time" : "23:36:44" , 
"distance_traveled" : 33.5428
} ], 
"4907" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "22:59:00" , 
"departure_time" : "23:00:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "23:02:00" , 
"departure_time" : "23:03:06" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "23:04:06" , 
"departure_time" : "23:04:39" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "23:07:33" , 
"departure_time" : "23:08:53" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "23:13:20" , 
"departure_time" : "23:14:54" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "23:15:34" , 
"departure_time" : "23:16:51" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "23:18:17" , 
"departure_time" : "23:19:26" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "23:21:09" , 
"departure_time" : "23:22:48" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "23:23:39" , 
"departure_time" : "23:24:00" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "23:24:21" , 
"departure_time" : "23:25:54" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "23:30:33" , 
"departure_time" : "23:30:57" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "23:31:24" , 
"departure_time" : "23:32:12" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "23:35:48" , 
"departure_time" : "23:36:11" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "23:39:23" , 
"departure_time" : "23:40:05" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "23:41:42" , 
"departure_time" : "23:42:10" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "23:47:28" , 
"departure_time" : "23:48:50" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "23:51:22" , 
"departure_time" : "23:51:26" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "23:55:04" , 
"departure_time" : "23:56:14" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "24:02:10" , 
"departure_time" : "24:03:43" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "24:04:33" , 
"departure_time" : "24:04:56" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "24:06:23" , 
"departure_time" : "24:06:23" , 
"distance_traveled" : 33.5428
} ], 
"4908" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "23:29:00" , 
"departure_time" : "23:30:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "23:31:54" , 
"departure_time" : "23:32:58" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "23:34:04" , 
"departure_time" : "23:35:09" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "23:38:05" , 
"departure_time" : "23:38:46" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "23:42:41" , 
"departure_time" : "23:43:15" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "23:44:34" , 
"departure_time" : "23:45:27" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "23:47:53" , 
"departure_time" : "23:48:05" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "23:50:12" , 
"departure_time" : "23:50:19" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "23:52:07" , 
"departure_time" : "23:52:33" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "23:54:26" , 
"departure_time" : "23:55:41" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "24:00:15" , 
"departure_time" : "24:00:43" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "24:01:28" , 
"departure_time" : "24:02:02" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "24:05:34" , 
"departure_time" : "24:06:18" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "24:09:44" , 
"departure_time" : "24:11:12" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "24:12:28" , 
"departure_time" : "24:13:13" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "24:17:45" , 
"departure_time" : "24:17:58" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "24:20:13" , 
"departure_time" : "24:20:43" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "24:25:30" , 
"departure_time" : "24:26:24" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "24:31:54" , 
"departure_time" : "24:32:20" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "24:33:26" , 
"departure_time" : "24:34:50" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "24:37:24" , 
"departure_time" : "24:37:24" , 
"distance_traveled" : 33.5428
} ], 
"4909" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "23:59:00" , 
"departure_time" : "24:01:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "24:02:32" , 
"departure_time" : "24:02:34" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "24:03:02" , 
"departure_time" : "24:03:29" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "24:07:27" , 
"departure_time" : "24:08:25" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "24:12:58" , 
"departure_time" : "24:14:29" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "24:15:31" , 
"departure_time" : "24:16:00" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "24:17:29" , 
"departure_time" : "24:17:53" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "24:20:24" , 
"departure_time" : "24:21:26" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "24:23:02" , 
"departure_time" : "24:24:19" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "24:25:17" , 
"departure_time" : "24:26:49" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "24:30:32" , 
"departure_time" : "24:32:10" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "24:32:38" , 
"departure_time" : "24:33:15" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "24:35:37" , 
"departure_time" : "24:36:13" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "24:39:36" , 
"departure_time" : "24:39:46" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "24:41:10" , 
"departure_time" : "24:41:12" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "24:47:02" , 
"departure_time" : "24:47:27" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "24:50:25" , 
"departure_time" : "24:52:03" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "24:56:38" , 
"departure_time" : "24:56:58" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "25:01:20" , 
"departure_time" : "25:02:09" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "25:03:49" , 
"departure_time" : "25:03:59" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "25:06:10" , 
"departure_time" : "25:06:10" , 
"distance_traveled" : 33.5428
} ], 
"4910" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "06:14:00" , 
"departure_time" : "06:14:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "06:16:19" , 
"departure_time" : "06:17:09" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "06:18:50" , 
"departure_time" : "06:19:32" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "06:25:42" , 
"departure_time" : "06:25:54" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "06:30:12" , 
"departure_time" : "06:31:36" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "06:34:24" , 
"departure_time" : "06:34:44" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "06:38:20" , 
"departure_time" : "06:39:37" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "06:41:17" , 
"departure_time" : "06:42:09" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "06:44:52" , 
"departure_time" : "06:46:01" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "06:49:09" , 
"departure_time" : "06:50:06" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "06:50:57" , 
"departure_time" : "06:51:38" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "06:55:41" , 
"departure_time" : "06:56:59" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "06:58:18" , 
"departure_time" : "06:59:57" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "07:00:39" , 
"departure_time" : "07:02:15" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "07:03:36" , 
"departure_time" : "07:04:51" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "07:05:15" , 
"departure_time" : "07:06:34" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "07:09:19" , 
"departure_time" : "07:10:54" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "07:14:35" , 
"departure_time" : "07:15:53" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "07:17:18" , 
"departure_time" : "07:17:49" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "07:18:31" , 
"departure_time" : "07:19:52" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "07:22:21" , 
"departure_time" : "07:22:21" , 
"distance_traveled" : 33.5915
} ], 
"4911" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "06:44:00" , 
"departure_time" : "06:46:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "06:47:09" , 
"departure_time" : "06:47:27" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "06:48:18" , 
"departure_time" : "06:48:21" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "06:55:03" , 
"departure_time" : "06:55:49" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "07:00:46" , 
"departure_time" : "07:01:42" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "07:03:56" , 
"departure_time" : "07:05:11" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "07:09:15" , 
"departure_time" : "07:09:26" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "07:10:11" , 
"departure_time" : "07:10:16" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "07:14:05" , 
"departure_time" : "07:14:52" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "07:18:47" , 
"departure_time" : "07:20:25" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "07:21:38" , 
"departure_time" : "07:23:03" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "07:26:25" , 
"departure_time" : "07:27:45" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "07:28:20" , 
"departure_time" : "07:29:08" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "07:29:48" , 
"departure_time" : "07:30:20" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "07:32:32" , 
"departure_time" : "07:33:35" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "07:35:03" , 
"departure_time" : "07:36:27" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "07:39:24" , 
"departure_time" : "07:40:56" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "07:44:32" , 
"departure_time" : "07:45:39" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "07:47:07" , 
"departure_time" : "07:47:45" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "07:48:38" , 
"departure_time" : "07:49:48" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "07:52:10" , 
"departure_time" : "07:52:10" , 
"distance_traveled" : 33.5915
} ], 
"4912" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "07:14:00" , 
"departure_time" : "07:16:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "07:17:32" , 
"departure_time" : "07:18:36" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "07:19:04" , 
"departure_time" : "07:20:04" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "07:26:00" , 
"departure_time" : "07:27:20" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "07:31:20" , 
"departure_time" : "07:31:36" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "07:33:16" , 
"departure_time" : "07:34:55" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "07:39:39" , 
"departure_time" : "07:41:06" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "07:41:27" , 
"departure_time" : "07:42:13" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "07:44:46" , 
"departure_time" : "07:45:30" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "07:48:44" , 
"departure_time" : "07:50:18" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "07:51:34" , 
"departure_time" : "07:53:05" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "07:56:31" , 
"departure_time" : "07:56:39" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "07:57:08" , 
"departure_time" : "07:57:09" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "07:59:01" , 
"departure_time" : "07:59:09" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "08:02:08" , 
"departure_time" : "08:03:24" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "08:05:16" , 
"departure_time" : "08:05:37" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "08:08:21" , 
"departure_time" : "08:09:21" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "08:14:00" , 
"departure_time" : "08:15:17" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "08:17:17" , 
"departure_time" : "08:18:25" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "08:19:08" , 
"departure_time" : "08:19:37" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "08:21:29" , 
"departure_time" : "08:21:29" , 
"distance_traveled" : 33.5915
} ], 
"4913" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "07:44:00" , 
"departure_time" : "07:44:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "07:46:26" , 
"departure_time" : "07:46:28" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "07:48:02" , 
"departure_time" : "07:48:24" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "07:55:22" , 
"departure_time" : "07:55:56" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "08:00:34" , 
"departure_time" : "08:01:43" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "08:04:09" , 
"departure_time" : "08:05:18" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "08:09:09" , 
"departure_time" : "08:10:00" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "08:10:51" , 
"departure_time" : "08:11:28" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "08:14:37" , 
"departure_time" : "08:15:27" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "08:18:50" , 
"departure_time" : "08:19:45" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "08:20:55" , 
"departure_time" : "08:22:24" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "08:26:29" , 
"departure_time" : "08:27:36" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "08:28:07" , 
"departure_time" : "08:28:29" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "08:29:22" , 
"departure_time" : "08:29:50" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "08:32:28" , 
"departure_time" : "08:32:29" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "08:34:01" , 
"departure_time" : "08:35:17" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "08:39:16" , 
"departure_time" : "08:40:10" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "08:43:54" , 
"departure_time" : "08:44:32" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "08:46:38" , 
"departure_time" : "08:47:06" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "08:48:28" , 
"departure_time" : "08:48:48" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "08:51:20" , 
"departure_time" : "08:51:20" , 
"distance_traveled" : 33.5915
} ], 
"4914" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "08:14:00" , 
"departure_time" : "08:15:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "08:16:47" , 
"departure_time" : "08:17:26" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "08:18:39" , 
"departure_time" : "08:18:41" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "08:25:02" , 
"departure_time" : "08:26:01" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "08:30:59" , 
"departure_time" : "08:32:30" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "08:34:31" , 
"departure_time" : "08:35:47" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "08:39:16" , 
"departure_time" : "08:40:15" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "08:40:59" , 
"departure_time" : "08:41:31" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "08:44:32" , 
"departure_time" : "08:44:36" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "08:48:04" , 
"departure_time" : "08:48:46" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "08:50:42" , 
"departure_time" : "08:50:55" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "08:55:13" , 
"departure_time" : "08:55:33" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "08:57:20" , 
"departure_time" : "08:58:20" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "09:00:00" , 
"departure_time" : "09:00:27" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "09:02:27" , 
"departure_time" : "09:03:23" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "09:04:56" , 
"departure_time" : "09:05:31" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "09:08:35" , 
"departure_time" : "09:08:53" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "09:13:18" , 
"departure_time" : "09:13:36" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "09:16:18" , 
"departure_time" : "09:16:52" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "09:18:34" , 
"departure_time" : "09:19:37" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "09:22:03" , 
"departure_time" : "09:22:03" , 
"distance_traveled" : 33.5915
} ], 
"4915" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "08:44:00" , 
"departure_time" : "08:45:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "08:46:43" , 
"departure_time" : "08:47:26" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "08:48:43" , 
"departure_time" : "08:50:01" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "08:56:18" , 
"departure_time" : "08:57:06" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "09:00:48" , 
"departure_time" : "09:00:58" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "09:03:10" , 
"departure_time" : "09:03:37" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "09:08:27" , 
"departure_time" : "09:09:36" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "09:11:09" , 
"departure_time" : "09:12:29" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "09:15:20" , 
"departure_time" : "09:16:25" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "09:19:05" , 
"departure_time" : "09:20:10" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "09:21:05" , 
"departure_time" : "09:22:25" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "09:26:20" , 
"departure_time" : "09:27:25" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "09:28:05" , 
"departure_time" : "09:28:36" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "09:29:31" , 
"departure_time" : "09:29:52" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "09:32:21" , 
"departure_time" : "09:32:28" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "09:34:07" , 
"departure_time" : "09:35:01" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "09:38:54" , 
"departure_time" : "09:39:25" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "09:43:31" , 
"departure_time" : "09:44:14" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "09:46:43" , 
"departure_time" : "09:47:38" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "09:48:55" , 
"departure_time" : "09:50:01" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "09:52:06" , 
"departure_time" : "09:52:06" , 
"distance_traveled" : 33.5915
} ], 
"4916" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "09:14:00" , 
"departure_time" : "09:16:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "09:17:36" , 
"departure_time" : "09:17:51" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "09:18:15" , 
"departure_time" : "09:19:19" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "09:26:04" , 
"departure_time" : "09:26:08" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "09:30:04" , 
"departure_time" : "09:31:40" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "09:34:36" , 
"departure_time" : "09:35:42" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "09:39:06" , 
"departure_time" : "09:39:35" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "09:40:29" , 
"departure_time" : "09:41:38" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "09:45:09" , 
"departure_time" : "09:45:51" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "09:48:42" , 
"departure_time" : "09:50:15" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "09:51:33" , 
"departure_time" : "09:53:12" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "09:56:39" , 
"departure_time" : "09:57:29" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "09:57:50" , 
"departure_time" : "09:58:37" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "09:59:47" , 
"departure_time" : "10:00:33" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "10:02:46" , 
"departure_time" : "10:02:48" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "10:04:02" , 
"departure_time" : "10:05:06" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "10:09:04" , 
"departure_time" : "10:09:06" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "10:13:02" , 
"departure_time" : "10:13:22" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "10:16:20" , 
"departure_time" : "10:16:58" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "10:18:38" , 
"departure_time" : "10:18:45" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "10:21:07" , 
"departure_time" : "10:21:07" , 
"distance_traveled" : 33.5915
} ], 
"4917" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "09:44:00" , 
"departure_time" : "09:45:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "09:46:59" , 
"departure_time" : "09:48:31" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "09:49:32" , 
"departure_time" : "09:50:32" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "09:56:00" , 
"departure_time" : "09:56:30" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "10:00:30" , 
"departure_time" : "10:00:42" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "10:03:12" , 
"departure_time" : "10:03:37" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "10:08:25" , 
"departure_time" : "10:09:53" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "10:11:28" , 
"departure_time" : "10:12:41" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "10:15:13" , 
"departure_time" : "10:15:43" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "10:18:30" , 
"departure_time" : "10:18:40" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "10:20:10" , 
"departure_time" : "10:20:42" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "10:25:32" , 
"departure_time" : "10:25:55" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "10:27:23" , 
"departure_time" : "10:27:59" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "10:29:36" , 
"departure_time" : "10:30:18" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "10:32:42" , 
"departure_time" : "10:33:40" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "10:34:58" , 
"departure_time" : "10:35:46" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "10:38:48" , 
"departure_time" : "10:39:08" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "10:43:20" , 
"departure_time" : "10:43:27" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "10:46:07" , 
"departure_time" : "10:46:11" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "10:48:04" , 
"departure_time" : "10:48:12" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "10:51:08" , 
"departure_time" : "10:51:08" , 
"distance_traveled" : 33.5915
} ], 
"4918" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "10:14:00" , 
"departure_time" : "10:15:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "10:17:13" , 
"departure_time" : "10:17:43" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "10:18:30" , 
"departure_time" : "10:19:57" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "10:26:27" , 
"departure_time" : "10:26:49" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "10:30:22" , 
"departure_time" : "10:31:28" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "10:34:06" , 
"departure_time" : "10:34:20" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "10:38:14" , 
"departure_time" : "10:39:44" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "10:41:30" , 
"departure_time" : "10:41:45" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "10:44:15" , 
"departure_time" : "10:44:36" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "10:48:21" , 
"departure_time" : "10:48:57" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "10:50:36" , 
"departure_time" : "10:52:15" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "10:56:39" , 
"departure_time" : "10:58:05" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "10:58:26" , 
"departure_time" : "11:00:05" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "11:00:39" , 
"departure_time" : "11:01:58" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "11:03:19" , 
"departure_time" : "11:04:22" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "11:05:03" , 
"departure_time" : "11:06:18" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "11:09:15" , 
"departure_time" : "11:10:49" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "11:14:34" , 
"departure_time" : "11:15:50" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "11:17:16" , 
"departure_time" : "11:18:18" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "11:19:02" , 
"departure_time" : "11:20:24" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "11:22:22" , 
"departure_time" : "11:22:22" , 
"distance_traveled" : 33.5915
} ], 
"4919" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "10:44:00" , 
"departure_time" : "10:46:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "10:47:00" , 
"departure_time" : "10:47:17" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "10:48:17" , 
"departure_time" : "10:49:44" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "10:56:27" , 
"departure_time" : "10:57:20" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "11:00:53" , 
"departure_time" : "11:00:57" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "11:03:04" , 
"departure_time" : "11:03:51" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "11:08:47" , 
"departure_time" : "11:10:11" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "11:11:24" , 
"departure_time" : "11:11:33" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "11:14:09" , 
"departure_time" : "11:15:01" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "11:18:52" , 
"departure_time" : "11:19:54" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "11:21:02" , 
"departure_time" : "11:21:52" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "11:25:50" , 
"departure_time" : "11:26:08" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "11:27:18" , 
"departure_time" : "11:28:50" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "11:30:32" , 
"departure_time" : "11:30:39" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "11:32:07" , 
"departure_time" : "11:32:21" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "11:34:14" , 
"departure_time" : "11:34:58" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "11:38:44" , 
"departure_time" : "11:40:20" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "11:44:36" , 
"departure_time" : "11:45:49" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "11:47:13" , 
"departure_time" : "11:47:21" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "11:48:08" , 
"departure_time" : "11:49:00" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "11:51:52" , 
"departure_time" : "11:51:52" , 
"distance_traveled" : 33.5915
} ], 
"4920" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "11:14:00" , 
"departure_time" : "11:15:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "11:16:47" , 
"departure_time" : "11:18:04" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "11:19:17" , 
"departure_time" : "11:19:24" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "11:25:07" , 
"departure_time" : "11:25:21" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "11:30:14" , 
"departure_time" : "11:30:40" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "11:33:26" , 
"departure_time" : "11:34:21" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "11:38:55" , 
"departure_time" : "11:40:08" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "11:41:13" , 
"departure_time" : "11:41:50" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "11:44:37" , 
"departure_time" : "11:45:09" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "11:48:32" , 
"departure_time" : "11:49:41" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "11:51:09" , 
"departure_time" : "11:52:16" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "11:56:07" , 
"departure_time" : "11:57:42" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "11:58:35" , 
"departure_time" : "11:58:57" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "11:59:22" , 
"departure_time" : "12:00:13" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "12:02:51" , 
"departure_time" : "12:03:26" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "12:04:35" , 
"departure_time" : "12:05:05" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "12:08:30" , 
"departure_time" : "12:09:44" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "12:14:14" , 
"departure_time" : "12:15:13" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "12:16:59" , 
"departure_time" : "12:17:14" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "12:18:15" , 
"departure_time" : "12:19:03" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "12:21:48" , 
"departure_time" : "12:21:48" , 
"distance_traveled" : 33.5915
} ], 
"4921" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "11:44:00" , 
"departure_time" : "11:45:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "11:46:33" , 
"departure_time" : "11:46:44" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "11:48:11" , 
"departure_time" : "11:48:43" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "11:55:32" , 
"departure_time" : "11:55:39" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "12:00:07" , 
"departure_time" : "12:00:55" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "12:03:48" , 
"departure_time" : "12:04:35" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "12:08:47" , 
"departure_time" : "12:09:03" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "12:10:16" , 
"departure_time" : "12:10:17" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "12:14:01" , 
"departure_time" : "12:15:25" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "12:19:24" , 
"departure_time" : "12:20:56" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "12:21:32" , 
"departure_time" : "12:22:25" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "12:25:53" , 
"departure_time" : "12:27:27" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "12:28:34" , 
"departure_time" : "12:28:37" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "12:29:03" , 
"departure_time" : "12:30:39" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "12:33:36" , 
"departure_time" : "12:34:19" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "12:34:43" , 
"departure_time" : "12:36:21" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "12:39:38" , 
"departure_time" : "12:40:32" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "12:43:54" , 
"departure_time" : "12:45:06" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "12:47:12" , 
"departure_time" : "12:47:48" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "12:48:36" , 
"departure_time" : "12:48:44" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "12:51:08" , 
"departure_time" : "12:51:08" , 
"distance_traveled" : 33.5915
} ], 
"4922" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "12:14:00" , 
"departure_time" : "12:15:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "12:16:58" , 
"departure_time" : "12:18:20" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "12:19:22" , 
"departure_time" : "12:20:18" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "12:25:56" , 
"departure_time" : "12:26:16" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "12:30:20" , 
"departure_time" : "12:31:41" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "12:34:21" , 
"departure_time" : "12:35:09" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "12:38:48" , 
"departure_time" : "12:39:06" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "12:40:18" , 
"departure_time" : "12:41:33" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "12:45:15" , 
"departure_time" : "12:46:29" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "12:49:14" , 
"departure_time" : "12:50:12" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "12:50:58" , 
"departure_time" : "12:52:04" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "12:56:06" , 
"departure_time" : "12:57:37" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "12:58:31" , 
"departure_time" : "12:59:29" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "12:59:58" , 
"departure_time" : "13:00:20" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "13:02:22" , 
"departure_time" : "13:03:51" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "13:05:29" , 
"departure_time" : "13:06:39" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "13:09:10" , 
"departure_time" : "13:09:18" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "13:13:08" , 
"departure_time" : "13:13:55" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "13:16:47" , 
"departure_time" : "13:17:02" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "13:18:15" , 
"departure_time" : "13:19:19" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "13:22:04" , 
"departure_time" : "13:22:04" , 
"distance_traveled" : 33.5915
} ], 
"4923" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "12:44:00" , 
"departure_time" : "12:45:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "12:46:16" , 
"departure_time" : "12:46:57" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "12:48:41" , 
"departure_time" : "12:48:57" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "12:55:16" , 
"departure_time" : "12:56:25" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "13:01:09" , 
"departure_time" : "13:01:52" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "13:03:43" , 
"departure_time" : "13:05:06" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "13:09:23" , 
"departure_time" : "13:10:38" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "13:11:15" , 
"departure_time" : "13:11:19" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "13:14:04" , 
"departure_time" : "13:15:36" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "13:19:32" , 
"departure_time" : "13:20:16" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "13:20:44" , 
"departure_time" : "13:22:07" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "13:26:23" , 
"departure_time" : "13:26:45" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "13:27:22" , 
"departure_time" : "13:28:20" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "13:29:58" , 
"departure_time" : "13:30:19" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "13:32:21" , 
"departure_time" : "13:33:52" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "13:35:31" , 
"departure_time" : "13:36:02" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "13:38:31" , 
"departure_time" : "13:38:37" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "13:43:06" , 
"departure_time" : "13:44:08" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "13:47:02" , 
"departure_time" : "13:47:07" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "13:48:05" , 
"departure_time" : "13:49:35" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "13:52:30" , 
"departure_time" : "13:52:30" , 
"distance_traveled" : 33.5915
} ], 
"4924" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "13:14:00" , 
"departure_time" : "13:16:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "13:17:12" , 
"departure_time" : "13:18:00" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "13:18:48" , 
"departure_time" : "13:19:01" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "13:25:13" , 
"departure_time" : "13:26:08" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "13:30:55" , 
"departure_time" : "13:32:18" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "13:34:23" , 
"departure_time" : "13:34:49" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "13:38:26" , 
"departure_time" : "13:39:42" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "13:41:16" , 
"departure_time" : "13:42:56" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "13:45:40" , 
"departure_time" : "13:45:43" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "13:48:03" , 
"departure_time" : "13:49:14" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "13:51:11" , 
"departure_time" : "13:52:50" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "13:56:39" , 
"departure_time" : "13:56:49" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "13:57:10" , 
"departure_time" : "13:57:36" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "13:59:26" , 
"departure_time" : "14:00:34" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "14:03:08" , 
"departure_time" : "14:04:29" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "14:05:21" , 
"departure_time" : "14:05:51" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "14:08:30" , 
"departure_time" : "14:08:39" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "14:13:09" , 
"departure_time" : "14:13:38" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "14:16:29" , 
"departure_time" : "14:17:34" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "14:19:05" , 
"departure_time" : "14:20:31" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "14:22:26" , 
"departure_time" : "14:22:26" , 
"distance_traveled" : 33.5915
} ], 
"4925" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "13:44:00" , 
"departure_time" : "13:45:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "13:46:30" , 
"departure_time" : "13:47:47" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "13:49:17" , 
"departure_time" : "13:49:21" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "13:55:04" , 
"departure_time" : "13:55:29" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "14:00:25" , 
"departure_time" : "14:01:59" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "14:04:34" , 
"departure_time" : "14:05:28" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "14:08:54" , 
"departure_time" : "14:09:55" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "14:11:01" , 
"departure_time" : "14:11:08" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "14:14:07" , 
"departure_time" : "14:15:32" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "14:19:25" , 
"departure_time" : "14:20:52" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "14:21:27" , 
"departure_time" : "14:21:29" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "14:25:02" , 
"departure_time" : "14:26:12" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "14:28:10" , 
"departure_time" : "14:29:00" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "14:29:50" , 
"departure_time" : "14:30:52" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "14:33:02" , 
"departure_time" : "14:34:14" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "14:35:12" , 
"departure_time" : "14:36:31" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "14:39:19" , 
"departure_time" : "14:39:45" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "14:43:26" , 
"departure_time" : "14:43:32" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "14:46:06" , 
"departure_time" : "14:47:45" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "14:49:39" , 
"departure_time" : "14:50:00" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "14:51:21" , 
"departure_time" : "14:51:21" , 
"distance_traveled" : 33.5915
} ], 
"4926" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "14:14:00" , 
"departure_time" : "14:14:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "14:16:32" , 
"departure_time" : "14:16:44" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "14:18:12" , 
"departure_time" : "14:19:27" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "14:26:15" , 
"departure_time" : "14:26:58" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "14:30:43" , 
"departure_time" : "14:30:53" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "14:33:10" , 
"departure_time" : "14:33:52" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "14:38:42" , 
"departure_time" : "14:40:22" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "14:41:40" , 
"departure_time" : "14:42:57" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "14:45:17" , 
"departure_time" : "14:45:28" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "14:48:11" , 
"departure_time" : "14:48:34" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "14:50:23" , 
"departure_time" : "14:51:41" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "14:56:18" , 
"departure_time" : "14:56:35" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "14:57:17" , 
"departure_time" : "14:57:29" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "14:59:12" , 
"departure_time" : "15:00:47" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "15:03:35" , 
"departure_time" : "15:05:07" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "15:05:32" , 
"departure_time" : "15:06:42" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "15:09:10" , 
"departure_time" : "15:10:10" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "15:14:00" , 
"departure_time" : "15:14:20" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "15:16:20" , 
"departure_time" : "15:17:03" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "15:18:43" , 
"departure_time" : "15:20:09" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "15:22:26" , 
"departure_time" : "15:22:26" , 
"distance_traveled" : 33.5915
} ], 
"4927" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "14:44:00" , 
"departure_time" : "14:46:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "14:46:44" , 
"departure_time" : "14:47:52" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "14:49:08" , 
"departure_time" : "14:49:51" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "14:55:43" , 
"departure_time" : "14:55:59" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "15:00:16" , 
"departure_time" : "15:00:46" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "15:03:30" , 
"departure_time" : "15:04:47" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "15:09:17" , 
"departure_time" : "15:10:41" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "15:11:24" , 
"departure_time" : "15:11:29" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "15:14:05" , 
"departure_time" : "15:15:06" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "15:19:01" , 
"departure_time" : "15:20:26" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "15:21:25" , 
"departure_time" : "15:22:48" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "15:26:23" , 
"departure_time" : "15:26:35" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "15:27:12" , 
"departure_time" : "15:27:48" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "15:29:36" , 
"departure_time" : "15:30:36" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "15:33:00" , 
"departure_time" : "15:34:25" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "15:35:25" , 
"departure_time" : "15:37:02" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "15:39:37" , 
"departure_time" : "15:41:02" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "15:44:25" , 
"departure_time" : "15:45:02" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "15:46:37" , 
"departure_time" : "15:46:41" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "15:48:04" , 
"departure_time" : "15:49:27" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "15:52:23" , 
"departure_time" : "15:52:23" , 
"distance_traveled" : 33.5915
} ], 
"4928" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "15:14:00" , 
"departure_time" : "15:15:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "15:16:29" , 
"departure_time" : "15:17:42" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "15:19:13" , 
"departure_time" : "15:20:01" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "15:25:48" , 
"departure_time" : "15:26:37" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "15:30:49" , 
"departure_time" : "15:30:56" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "15:33:07" , 
"departure_time" : "15:33:13" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "15:38:06" , 
"departure_time" : "15:39:33" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "15:41:27" , 
"departure_time" : "15:41:32" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "15:44:05" , 
"departure_time" : "15:44:57" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "15:48:52" , 
"departure_time" : "15:50:22" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "15:51:30" , 
"departure_time" : "15:53:00" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "15:56:30" , 
"departure_time" : "15:57:25" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "15:57:55" , 
"departure_time" : "15:59:09" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "16:00:14" , 
"departure_time" : "16:00:42" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "16:02:28" , 
"departure_time" : "16:04:05" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "16:05:37" , 
"departure_time" : "16:07:02" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "16:09:25" , 
"departure_time" : "16:09:43" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "16:13:18" , 
"departure_time" : "16:14:06" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "16:16:48" , 
"departure_time" : "16:16:50" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "16:18:02" , 
"departure_time" : "16:18:10" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "16:21:08" , 
"departure_time" : "16:21:08" , 
"distance_traveled" : 33.5915
} ], 
"4929" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "15:44:00" , 
"departure_time" : "15:44:26" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "15:46:18" , 
"departure_time" : "15:47:37" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "15:49:19" , 
"departure_time" : "15:50:04" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "15:55:45" , 
"departure_time" : "15:56:43" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "16:00:58" , 
"departure_time" : "16:02:16" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "16:04:18" , 
"departure_time" : "16:04:38" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "16:08:20" , 
"departure_time" : "16:08:21" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "16:10:01" , 
"departure_time" : "16:10:29" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "16:14:28" , 
"departure_time" : "16:14:49" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "16:18:21" , 
"departure_time" : "16:19:32" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "16:21:11" , 
"departure_time" : "16:22:51" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "16:26:40" , 
"departure_time" : "16:27:28" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "16:27:48" , 
"departure_time" : "16:28:08" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "16:29:20" , 
"departure_time" : "16:30:50" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "16:33:30" , 
"departure_time" : "16:34:32" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "16:35:02" , 
"departure_time" : "16:36:06" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "16:39:04" , 
"departure_time" : "16:39:26" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "16:43:22" , 
"departure_time" : "16:44:19" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "16:46:57" , 
"departure_time" : "16:47:26" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "16:48:29" , 
"departure_time" : "16:49:35" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "16:52:06" , 
"departure_time" : "16:52:06" , 
"distance_traveled" : 33.5915
} ], 
"4930" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "16:14:00" , 
"departure_time" : "16:15:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "16:16:51" , 
"departure_time" : "16:18:30" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "16:19:39" , 
"departure_time" : "16:20:16" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "16:25:37" , 
"departure_time" : "16:26:24" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "16:30:47" , 
"departure_time" : "16:31:08" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "16:33:21" , 
"departure_time" : "16:34:21" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "16:39:00" , 
"departure_time" : "16:39:14" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "16:40:14" , 
"departure_time" : "16:41:47" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "16:45:33" , 
"departure_time" : "16:45:50" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "16:48:17" , 
"departure_time" : "16:49:54" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "16:51:37" , 
"departure_time" : "16:52:05" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "16:55:28" , 
"departure_time" : "16:55:57" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "16:57:29" , 
"departure_time" : "16:59:05" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "17:00:36" , 
"departure_time" : "17:00:53" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "17:02:17" , 
"departure_time" : "17:02:44" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "17:04:27" , 
"departure_time" : "17:05:23" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "17:08:56" , 
"departure_time" : "17:09:35" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "17:13:39" , 
"departure_time" : "17:13:51" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "17:16:12" , 
"departure_time" : "17:17:25" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "17:19:13" , 
"departure_time" : "17:20:36" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "17:22:23" , 
"departure_time" : "17:22:23" , 
"distance_traveled" : 33.5915
} ], 
"4931" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "16:44:00" , 
"departure_time" : "16:46:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "16:47:30" , 
"departure_time" : "16:48:15" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "16:48:45" , 
"departure_time" : "16:49:59" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "16:56:14" , 
"departure_time" : "16:56:25" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "17:00:11" , 
"departure_time" : "17:01:42" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "17:04:31" , 
"departure_time" : "17:05:41" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "17:09:10" , 
"departure_time" : "17:09:19" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "17:10:09" , 
"departure_time" : "17:11:33" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "17:15:24" , 
"departure_time" : "17:16:36" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "17:19:12" , 
"departure_time" : "17:20:11" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "17:20:59" , 
"departure_time" : "17:22:04" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "17:26:05" , 
"departure_time" : "17:26:34" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "17:27:29" , 
"departure_time" : "17:28:40" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "17:30:11" , 
"departure_time" : "17:31:05" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "17:32:54" , 
"departure_time" : "17:33:18" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "17:34:24" , 
"departure_time" : "17:35:38" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "17:39:14" , 
"departure_time" : "17:40:02" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "17:43:48" , 
"departure_time" : "17:44:21" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "17:46:33" , 
"departure_time" : "17:48:04" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "17:49:31" , 
"departure_time" : "17:49:55" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "17:51:24" , 
"departure_time" : "17:51:24" , 
"distance_traveled" : 33.5915
} ], 
"4932" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "17:14:00" , 
"departure_time" : "17:15:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "17:17:09" , 
"departure_time" : "17:17:34" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "17:18:25" , 
"departure_time" : "17:19:25" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "17:26:00" , 
"departure_time" : "17:26:29" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "17:30:29" , 
"departure_time" : "17:31:39" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "17:34:10" , 
"departure_time" : "17:34:24" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "17:38:14" , 
"departure_time" : "17:38:20" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "17:40:06" , 
"departure_time" : "17:40:39" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "17:44:33" , 
"departure_time" : "17:45:38" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "17:49:05" , 
"departure_time" : "17:50:28" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "17:51:23" , 
"departure_time" : "17:51:32" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "17:55:09" , 
"departure_time" : "17:56:02" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "17:57:53" , 
"departure_time" : "17:58:14" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "17:59:21" , 
"departure_time" : "18:00:11" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "18:02:50" , 
"departure_time" : "18:02:54" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "18:04:04" , 
"departure_time" : "18:04:35" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "18:08:31" , 
"departure_time" : "18:09:58" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "18:14:27" , 
"departure_time" : "18:14:49" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "18:16:22" , 
"departure_time" : "18:17:19" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "18:18:57" , 
"departure_time" : "18:19:57" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "18:22:00" , 
"departure_time" : "18:22:00" , 
"distance_traveled" : 33.5915
} ], 
"4933" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "17:44:00" , 
"departure_time" : "17:45:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "17:46:48" , 
"departure_time" : "17:47:22" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "17:48:34" , 
"departure_time" : "17:48:53" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "17:55:19" , 
"departure_time" : "17:56:08" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "18:00:49" , 
"departure_time" : "18:02:14" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "18:04:25" , 
"departure_time" : "18:05:48" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "18:09:23" , 
"departure_time" : "18:09:46" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "18:10:23" , 
"departure_time" : "18:11:37" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "18:15:14" , 
"departure_time" : "18:16:28" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "18:19:14" , 
"departure_time" : "18:19:33" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "18:20:19" , 
"departure_time" : "18:21:23" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "18:26:04" , 
"departure_time" : "18:26:26" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "18:27:22" , 
"departure_time" : "18:28:31" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "18:30:09" , 
"departure_time" : "18:30:49" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "18:32:40" , 
"departure_time" : "18:33:56" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "18:35:16" , 
"departure_time" : "18:35:36" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "18:38:20" , 
"departure_time" : "18:38:58" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "18:43:38" , 
"departure_time" : "18:45:06" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "18:47:28" , 
"departure_time" : "18:48:54" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "18:49:26" , 
"departure_time" : "18:50:14" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "18:51:48" , 
"departure_time" : "18:51:48" , 
"distance_traveled" : 33.5915
} ], 
"4934" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "18:14:00" , 
"departure_time" : "18:16:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "18:17:24" , 
"departure_time" : "18:18:00" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "18:18:36" , 
"departure_time" : "18:19:38" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "18:26:02" , 
"departure_time" : "18:27:41" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "18:31:39" , 
"departure_time" : "18:33:19" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "18:34:40" , 
"departure_time" : "18:35:22" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "18:38:42" , 
"departure_time" : "18:40:09" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "18:41:27" , 
"departure_time" : "18:41:52" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "18:44:25" , 
"departure_time" : "18:45:56" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "18:49:31" , 
"departure_time" : "18:50:28" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "18:50:57" , 
"departure_time" : "18:51:15" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "18:55:18" , 
"departure_time" : "18:56:42" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "18:58:24" , 
"departure_time" : "18:59:11" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "18:59:47" , 
"departure_time" : "19:00:04" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "19:02:17" , 
"departure_time" : "19:03:19" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "19:05:02" , 
"departure_time" : "19:05:43" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "19:08:41" , 
"departure_time" : "19:09:13" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "19:13:32" , 
"departure_time" : "19:14:23" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "19:16:51" , 
"departure_time" : "19:18:12" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "19:19:21" , 
"departure_time" : "19:19:31" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "19:21:10" , 
"departure_time" : "19:21:10" , 
"distance_traveled" : 33.5915
} ], 
"4935" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "18:44:00" , 
"departure_time" : "18:45:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "18:47:40" , 
"departure_time" : "18:49:14" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "18:49:34" , 
"departure_time" : "18:50:09" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "18:55:35" , 
"departure_time" : "18:57:09" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "19:01:34" , 
"departure_time" : "19:01:52" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "19:03:18" , 
"departure_time" : "19:04:09" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "19:08:51" , 
"departure_time" : "19:08:56" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "19:10:05" , 
"departure_time" : "19:11:10" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "19:15:05" , 
"departure_time" : "19:16:37" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "19:19:32" , 
"departure_time" : "19:20:24" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "19:20:52" , 
"departure_time" : "19:21:35" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "19:25:43" , 
"departure_time" : "19:26:10" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "19:27:27" , 
"departure_time" : "19:28:16" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "19:29:49" , 
"departure_time" : "19:30:32" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "19:32:43" , 
"departure_time" : "19:33:39" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "19:34:56" , 
"departure_time" : "19:35:21" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "19:38:25" , 
"departure_time" : "19:39:45" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "19:44:20" , 
"departure_time" : "19:44:58" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "19:46:38" , 
"departure_time" : "19:47:10" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "19:48:32" , 
"departure_time" : "19:49:59" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "19:52:27" , 
"departure_time" : "19:52:27" , 
"distance_traveled" : 33.5915
} ], 
"4936" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "19:14:00" , 
"departure_time" : "19:16:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "19:17:21" , 
"departure_time" : "19:18:12" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "19:18:51" , 
"departure_time" : "19:19:29" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "19:25:38" , 
"departure_time" : "19:27:06" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "19:31:28" , 
"departure_time" : "19:32:50" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "19:34:22" , 
"departure_time" : "19:34:27" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "19:38:05" , 
"departure_time" : "19:38:23" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "19:40:18" , 
"departure_time" : "19:40:31" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "19:44:13" , 
"departure_time" : "19:45:03" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "19:48:50" , 
"departure_time" : "19:49:48" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "19:50:58" , 
"departure_time" : "19:51:32" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "19:55:34" , 
"departure_time" : "19:57:13" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "19:58:39" , 
"departure_time" : "19:59:25" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "19:59:46" , 
"departure_time" : "20:00:10" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "20:02:24" , 
"departure_time" : "20:03:09" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "20:04:45" , 
"departure_time" : "20:06:12" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "20:09:27" , 
"departure_time" : "20:10:05" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "20:13:38" , 
"departure_time" : "20:14:45" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "20:17:07" , 
"departure_time" : "20:17:41" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "20:18:34" , 
"departure_time" : "20:18:35" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "20:21:01" , 
"departure_time" : "20:21:01" , 
"distance_traveled" : 33.5915
} ], 
"4937" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "19:44:00" , 
"departure_time" : "19:44:23" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "19:46:22" , 
"departure_time" : "19:47:53" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "19:49:31" , 
"departure_time" : "19:49:48" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "19:55:17" , 
"departure_time" : "19:56:26" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "20:01:09" , 
"departure_time" : "20:02:14" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "20:04:05" , 
"departure_time" : "20:04:46" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "20:08:41" , 
"departure_time" : "20:08:51" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "20:10:10" , 
"departure_time" : "20:10:53" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "20:14:43" , 
"departure_time" : "20:15:46" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "20:19:03" , 
"departure_time" : "20:20:04" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "20:21:01" , 
"departure_time" : "20:22:27" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "20:26:26" , 
"departure_time" : "20:27:41" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "20:28:15" , 
"departure_time" : "20:29:37" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "20:30:22" , 
"departure_time" : "20:30:37" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "20:32:15" , 
"departure_time" : "20:33:20" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "20:35:05" , 
"departure_time" : "20:36:22" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "20:39:17" , 
"departure_time" : "20:39:19" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "20:43:02" , 
"departure_time" : "20:43:06" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "20:46:04" , 
"departure_time" : "20:47:29" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "20:49:25" , 
"departure_time" : "20:50:22" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "20:51:57" , 
"departure_time" : "20:51:57" , 
"distance_traveled" : 33.5915
} ], 
"4938" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "20:14:00" , 
"departure_time" : "20:14:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "20:16:02" , 
"departure_time" : "20:16:29" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "20:18:27" , 
"departure_time" : "20:19:24" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "20:25:57" , 
"departure_time" : "20:27:21" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "20:31:24" , 
"departure_time" : "20:32:58" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "20:34:34" , 
"departure_time" : "20:35:41" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "20:39:07" , 
"departure_time" : "20:39:13" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "20:40:06" , 
"departure_time" : "20:41:39" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "20:45:33" , 
"departure_time" : "20:46:47" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "20:49:14" , 
"departure_time" : "20:50:30" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "20:51:16" , 
"departure_time" : "20:51:58" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "20:55:42" , 
"departure_time" : "20:56:56" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "20:58:14" , 
"departure_time" : "20:59:43" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "21:00:29" , 
"departure_time" : "21:02:06" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "21:03:37" , 
"departure_time" : "21:04:33" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "21:04:56" , 
"departure_time" : "21:05:49" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "21:08:53" , 
"departure_time" : "21:10:33" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "21:14:40" , 
"departure_time" : "21:15:52" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "21:17:12" , 
"departure_time" : "21:17:25" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "21:18:13" , 
"departure_time" : "21:18:36" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "21:21:23" , 
"departure_time" : "21:21:23" , 
"distance_traveled" : 33.5915
} ], 
"4939" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "20:59:00" , 
"departure_time" : "21:00:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "21:02:11" , 
"departure_time" : "21:02:52" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "21:03:41" , 
"departure_time" : "21:04:07" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "21:10:26" , 
"departure_time" : "21:11:03" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "21:15:37" , 
"departure_time" : "21:17:14" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "21:19:37" , 
"departure_time" : "21:20:55" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "21:24:18" , 
"departure_time" : "21:25:55" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "21:26:37" , 
"departure_time" : "21:26:49" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "21:29:12" , 
"departure_time" : "21:29:17" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "21:33:05" , 
"departure_time" : "21:34:09" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "21:36:04" , 
"departure_time" : "21:36:45" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "21:40:41" , 
"departure_time" : "21:41:00" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "21:42:19" , 
"departure_time" : "21:43:19" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "21:45:00" , 
"departure_time" : "21:46:00" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "21:48:00" , 
"departure_time" : "21:48:23" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "21:49:23" , 
"departure_time" : "21:50:31" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "21:54:08" , 
"departure_time" : "21:55:07" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "21:58:59" , 
"departure_time" : "21:59:17" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "22:01:18" , 
"departure_time" : "22:01:40" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "22:03:22" , 
"departure_time" : "22:04:21" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "22:06:59" , 
"departure_time" : "22:06:59" , 
"distance_traveled" : 33.5915
} ], 
"4940" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "21:30:00" , 
"departure_time" : "21:31:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "21:32:41" , 
"departure_time" : "21:33:21" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "21:34:40" , 
"departure_time" : "21:34:53" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "21:42:13" , 
"departure_time" : "21:42:39" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "21:45:26" , 
"departure_time" : "21:46:00" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "21:48:34" , 
"departure_time" : "21:48:37" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "21:52:03" , 
"departure_time" : "21:52:11" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "21:55:08" , 
"departure_time" : "21:55:08" , 
"distance_traveled" : 15.8438
} ], 
"4941" :  [ 
{ 
"stop_id" : 38305,
"arrival_time" : "05:52:00" , 
"departure_time" : "05:52:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "05:54:01" , 
"departure_time" : "05:55:29" , 
"distance_traveled" : 1.6337
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "05:59:28" , 
"departure_time" : "05:59:43" , 
"distance_traveled" : 3.1894
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "06:03:15" , 
"departure_time" : "06:03:23" , 
"distance_traveled" : 5.8267
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "06:06:08" , 
"departure_time" : "06:06:34" , 
"distance_traveled" : 6.2515
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "06:09:26" , 
"departure_time" : "06:10:38" , 
"distance_traveled" : 6.6322
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "06:12:12" , 
"departure_time" : "06:12:12" , 
"distance_traveled" : 6.9731
} ], 
"4942" :  [ 
{ 
"stop_id" : 38305,
"arrival_time" : "06:52:00" , 
"departure_time" : "06:53:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "06:54:34" , 
"departure_time" : "06:56:09" , 
"distance_traveled" : 1.6337
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "06:59:35" , 
"departure_time" : "07:00:32" , 
"distance_traveled" : 3.1894
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "07:03:57" , 
"departure_time" : "07:04:23" , 
"distance_traveled" : 5.8267
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "07:06:26" , 
"departure_time" : "07:08:06" , 
"distance_traveled" : 6.2515
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "07:10:40" , 
"departure_time" : "07:11:06" , 
"distance_traveled" : 6.6322
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "07:11:26" , 
"departure_time" : "07:11:26" , 
"distance_traveled" : 6.9731
} ], 
"4943" :  [ 
{ 
"stop_id" : 38306,
"arrival_time" : "05:27:00" , 
"departure_time" : "05:28:14" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "05:32:48" , 
"departure_time" : "05:33:29" , 
"distance_traveled" : 2.6407
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "05:35:41" , 
"departure_time" : "05:35:52" , 
"distance_traveled" : 3.0655
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "05:37:11" , 
"departure_time" : "05:37:33" , 
"distance_traveled" : 3.4462
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "05:39:22" , 
"departure_time" : "05:39:22" , 
"distance_traveled" : 3.7871
} ], 
"4944" :  [ 
{ 
"stop_id" : 38306,
"arrival_time" : "06:27:00" , 
"departure_time" : "06:27:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "06:32:05" , 
"departure_time" : "06:32:28" , 
"distance_traveled" : 2.6407
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "06:35:23" , 
"departure_time" : "06:35:55" , 
"distance_traveled" : 3.0655
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "06:37:32" , 
"departure_time" : "06:37:51" , 
"distance_traveled" : 3.4462
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "06:39:19" , 
"departure_time" : "06:39:19" , 
"distance_traveled" : 3.7871
} ], 
"4945" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "05:44:00" , 
"departure_time" : "05:45:13" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "05:46:54" , 
"departure_time" : "05:47:32" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "05:48:38" , 
"departure_time" : "05:49:07" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "05:52:29" , 
"departure_time" : "05:53:33" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "05:58:04" , 
"departure_time" : "05:59:05" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "06:00:01" , 
"departure_time" : "06:01:31" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "06:03:30" , 
"departure_time" : "06:04:04" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "06:05:34" , 
"departure_time" : "06:07:03" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "06:08:29" , 
"departure_time" : "06:09:51" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "06:10:22" , 
"departure_time" : "06:10:28" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "06:14:06" , 
"departure_time" : "06:15:27" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "06:17:21" , 
"departure_time" : "06:18:35" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "06:21:14" , 
"departure_time" : "06:22:26" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "06:25:12" , 
"departure_time" : "06:26:11" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "06:26:59" , 
"departure_time" : "06:28:20" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "06:33:21" , 
"departure_time" : "06:33:23" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "06:35:02" , 
"departure_time" : "06:36:36" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "06:41:34" , 
"departure_time" : "06:43:11" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "06:47:37" , 
"departure_time" : "06:47:52" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "06:48:15" , 
"departure_time" : "06:48:40" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "06:51:25" , 
"departure_time" : "06:51:25" , 
"distance_traveled" : 33.5428
} ], 
"4946" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "06:14:00" , 
"departure_time" : "06:14:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "06:16:07" , 
"departure_time" : "06:16:39" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "06:18:32" , 
"departure_time" : "06:18:46" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "06:22:14" , 
"departure_time" : "06:22:48" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "06:27:34" , 
"departure_time" : "06:28:00" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "06:29:26" , 
"departure_time" : "06:30:37" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "06:33:11" , 
"departure_time" : "06:34:35" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "06:36:24" , 
"departure_time" : "06:38:00" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "06:38:36" , 
"departure_time" : "06:39:18" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "06:39:42" , 
"departure_time" : "06:39:51" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "06:44:09" , 
"departure_time" : "06:44:48" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "06:46:39" , 
"departure_time" : "06:47:50" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "06:51:11" , 
"departure_time" : "06:51:39" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "06:54:28" , 
"departure_time" : "06:54:49" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "06:56:21" , 
"departure_time" : "06:56:56" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "07:02:35" , 
"departure_time" : "07:03:01" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "07:05:26" , 
"departure_time" : "07:06:29" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "07:11:03" , 
"departure_time" : "07:11:44" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "07:16:41" , 
"departure_time" : "07:17:39" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "07:18:58" , 
"departure_time" : "07:20:31" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "07:22:33" , 
"departure_time" : "07:22:33" , 
"distance_traveled" : 33.5428
} ], 
"4947" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "06:44:00" , 
"departure_time" : "06:47:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "06:47:34" , 
"departure_time" : "06:48:04" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "06:48:30" , 
"departure_time" : "06:48:59" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "06:52:29" , 
"departure_time" : "06:53:55" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "06:58:26" , 
"departure_time" : "06:58:30" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "06:59:04" , 
"departure_time" : "07:00:06" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "07:03:02" , 
"departure_time" : "07:04:19" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "07:06:17" , 
"departure_time" : "07:07:18" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "07:08:01" , 
"departure_time" : "07:09:41" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "07:10:40" , 
"departure_time" : "07:10:43" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "07:14:03" , 
"departure_time" : "07:14:25" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "07:16:22" , 
"departure_time" : "07:16:23" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "07:20:01" , 
"departure_time" : "07:20:22" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "07:24:21" , 
"departure_time" : "07:24:34" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "07:26:13" , 
"departure_time" : "07:26:48" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "07:32:35" , 
"departure_time" : "07:33:14" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "07:35:39" , 
"departure_time" : "07:37:18" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "07:41:39" , 
"departure_time" : "07:42:30" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "07:46:51" , 
"departure_time" : "07:47:45" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "07:48:54" , 
"departure_time" : "07:49:48" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "07:51:54" , 
"departure_time" : "07:51:54" , 
"distance_traveled" : 33.5428
} ], 
"4948" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "07:14:00" , 
"departure_time" : "07:15:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "07:16:26" , 
"departure_time" : "07:18:01" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "07:19:35" , 
"departure_time" : "07:20:25" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "07:22:50" , 
"departure_time" : "07:23:50" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "07:28:00" , 
"departure_time" : "07:28:08" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "07:29:08" , 
"departure_time" : "07:29:49" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "07:32:41" , 
"departure_time" : "07:33:48" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "07:36:07" , 
"departure_time" : "07:37:31" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "07:38:24" , 
"departure_time" : "07:39:35" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "07:40:11" , 
"departure_time" : "07:40:35" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "07:44:24" , 
"departure_time" : "07:45:16" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "07:46:52" , 
"departure_time" : "07:48:17" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "07:51:25" , 
"departure_time" : "07:52:43" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "07:55:18" , 
"departure_time" : "07:56:50" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "07:57:32" , 
"departure_time" : "07:58:48" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "08:03:16" , 
"departure_time" : "08:04:34" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "08:06:18" , 
"departure_time" : "08:06:41" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "08:10:23" , 
"departure_time" : "08:11:04" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "08:16:41" , 
"departure_time" : "08:17:24" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "08:18:43" , 
"departure_time" : "08:20:02" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "08:22:19" , 
"departure_time" : "08:22:19" , 
"distance_traveled" : 33.5428
} ], 
"4949" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "07:44:00" , 
"departure_time" : "07:45:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "07:46:16" , 
"departure_time" : "07:46:56" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "07:48:40" , 
"departure_time" : "07:48:45" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "07:52:05" , 
"departure_time" : "07:53:27" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "07:58:22" , 
"departure_time" : "07:59:35" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "08:00:13" , 
"departure_time" : "08:00:48" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "08:02:35" , 
"departure_time" : "08:03:50" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "08:06:15" , 
"departure_time" : "08:07:53" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "08:08:38" , 
"departure_time" : "08:09:13" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "08:09:35" , 
"departure_time" : "08:10:46" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "08:15:11" , 
"departure_time" : "08:15:37" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "08:16:26" , 
"departure_time" : "08:18:05" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "08:21:39" , 
"departure_time" : "08:22:22" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "08:24:43" , 
"departure_time" : "08:25:37" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "08:26:54" , 
"departure_time" : "08:28:05" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "08:33:11" , 
"departure_time" : "08:33:33" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "08:35:22" , 
"departure_time" : "08:36:48" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "08:41:26" , 
"departure_time" : "08:42:59" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "08:47:33" , 
"departure_time" : "08:48:37" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "08:49:04" , 
"departure_time" : "08:50:43" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "08:52:39" , 
"departure_time" : "08:52:39" , 
"distance_traveled" : 33.5428
} ], 
"4950" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "08:14:00" , 
"departure_time" : "08:16:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "08:17:18" , 
"departure_time" : "08:18:06" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "08:18:48" , 
"departure_time" : "08:19:57" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "08:23:09" , 
"departure_time" : "08:23:33" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "08:27:24" , 
"departure_time" : "08:28:43" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "08:30:19" , 
"departure_time" : "08:30:59" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "08:32:40" , 
"departure_time" : "08:33:50" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "08:36:10" , 
"departure_time" : "08:37:07" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "08:37:57" , 
"departure_time" : "08:38:21" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "08:39:24" , 
"departure_time" : "08:40:52" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "08:45:28" , 
"departure_time" : "08:47:03" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "08:47:35" , 
"departure_time" : "08:48:24" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "08:50:49" , 
"departure_time" : "08:51:34" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "08:54:45" , 
"departure_time" : "08:55:07" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "08:56:22" , 
"departure_time" : "08:57:43" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "09:03:21" , 
"departure_time" : "09:04:18" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "09:05:57" , 
"departure_time" : "09:07:32" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "09:11:35" , 
"departure_time" : "09:11:41" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "09:16:06" , 
"departure_time" : "09:17:19" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "09:19:13" , 
"departure_time" : "09:19:52" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "09:21:39" , 
"departure_time" : "09:21:39" , 
"distance_traveled" : 33.5428
} ], 
"4951" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "08:44:00" , 
"departure_time" : "08:45:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "08:47:01" , 
"departure_time" : "08:47:15" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "08:48:14" , 
"departure_time" : "08:48:48" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "08:52:34" , 
"departure_time" : "08:53:02" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "08:57:28" , 
"departure_time" : "08:58:55" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "09:00:27" , 
"departure_time" : "09:00:49" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "09:02:22" , 
"departure_time" : "09:02:41" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "09:05:19" , 
"departure_time" : "09:06:39" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "09:08:20" , 
"departure_time" : "09:09:27" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "09:10:07" , 
"departure_time" : "09:10:34" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "09:14:27" , 
"departure_time" : "09:15:31" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "09:17:04" , 
"departure_time" : "09:17:59" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "09:20:55" , 
"departure_time" : "09:21:18" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "09:24:23" , 
"departure_time" : "09:25:29" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "09:27:06" , 
"departure_time" : "09:28:22" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "09:33:16" , 
"departure_time" : "09:33:53" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "09:35:37" , 
"departure_time" : "09:36:43" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "09:41:06" , 
"departure_time" : "09:42:19" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "09:47:13" , 
"departure_time" : "09:47:44" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "09:48:31" , 
"departure_time" : "09:49:46" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "09:52:15" , 
"departure_time" : "09:52:15" , 
"distance_traveled" : 33.5428
} ], 
"4952" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "09:14:00" , 
"departure_time" : "09:16:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "09:17:25" , 
"departure_time" : "09:18:04" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "09:18:39" , 
"departure_time" : "09:19:47" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "09:23:08" , 
"departure_time" : "09:23:45" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "09:27:37" , 
"departure_time" : "09:28:35" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "09:29:58" , 
"departure_time" : "09:30:27" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "09:32:29" , 
"departure_time" : "09:34:06" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "09:36:37" , 
"departure_time" : "09:38:15" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "09:38:38" , 
"departure_time" : "09:40:06" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "09:40:28" , 
"departure_time" : "09:40:54" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "09:44:26" , 
"departure_time" : "09:44:43" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "09:46:17" , 
"departure_time" : "09:47:50" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "09:51:33" , 
"departure_time" : "09:51:38" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "09:54:05" , 
"departure_time" : "09:54:26" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "09:56:21" , 
"departure_time" : "09:56:25" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "10:02:04" , 
"departure_time" : "10:02:54" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "10:05:50" , 
"departure_time" : "10:07:06" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "10:11:16" , 
"departure_time" : "10:12:36" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "10:17:20" , 
"departure_time" : "10:17:21" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "10:18:01" , 
"departure_time" : "10:18:25" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "10:21:24" , 
"departure_time" : "10:21:24" , 
"distance_traveled" : 33.5428
} ], 
"4953" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "09:44:00" , 
"departure_time" : "09:44:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "09:46:23" , 
"departure_time" : "09:47:45" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "09:49:22" , 
"departure_time" : "09:49:57" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "09:52:35" , 
"departure_time" : "09:53:47" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "09:58:12" , 
"departure_time" : "09:59:12" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "10:00:00" , 
"departure_time" : "10:01:13" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "10:03:13" , 
"departure_time" : "10:04:16" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "10:06:03" , 
"departure_time" : "10:06:16" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "10:07:13" , 
"departure_time" : "10:08:36" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "10:10:23" , 
"departure_time" : "10:10:59" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "10:14:36" , 
"departure_time" : "10:14:58" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "10:16:22" , 
"departure_time" : "10:17:43" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "10:21:21" , 
"departure_time" : "10:22:36" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "10:25:15" , 
"departure_time" : "10:25:59" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "10:26:44" , 
"departure_time" : "10:27:50" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "10:33:06" , 
"departure_time" : "10:34:07" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "10:36:01" , 
"departure_time" : "10:36:50" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "10:40:49" , 
"departure_time" : "10:41:56" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "10:47:07" , 
"departure_time" : "10:47:32" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "10:48:25" , 
"departure_time" : "10:49:27" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "10:52:02" , 
"departure_time" : "10:52:02" , 
"distance_traveled" : 33.5428
} ], 
"4954" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "10:14:00" , 
"departure_time" : "10:16:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "10:17:22" , 
"departure_time" : "10:18:32" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "10:19:10" , 
"departure_time" : "10:20:22" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "10:23:12" , 
"departure_time" : "10:23:55" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "10:27:43" , 
"departure_time" : "10:28:37" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "10:29:54" , 
"departure_time" : "10:30:03" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "10:32:09" , 
"departure_time" : "10:32:44" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "10:35:35" , 
"departure_time" : "10:36:36" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "10:38:01" , 
"departure_time" : "10:39:07" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "10:40:06" , 
"departure_time" : "10:40:18" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "10:44:12" , 
"departure_time" : "10:44:20" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "10:46:08" , 
"departure_time" : "10:47:20" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "10:51:12" , 
"departure_time" : "10:51:40" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "10:54:28" , 
"departure_time" : "10:55:35" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "10:57:07" , 
"departure_time" : "10:57:37" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "11:02:30" , 
"departure_time" : "11:02:52" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "11:05:22" , 
"departure_time" : "11:05:41" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "11:10:19" , 
"departure_time" : "11:11:47" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "11:17:28" , 
"departure_time" : "11:18:40" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "11:19:12" , 
"departure_time" : "11:20:37" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "11:22:25" , 
"departure_time" : "11:22:25" , 
"distance_traveled" : 33.5428
} ], 
"4955" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "10:44:00" , 
"departure_time" : "10:45:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "10:46:22" , 
"departure_time" : "10:48:00" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "10:49:38" , 
"departure_time" : "10:50:19" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "10:52:41" , 
"departure_time" : "10:52:49" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "10:57:08" , 
"departure_time" : "10:58:10" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "11:00:02" , 
"departure_time" : "11:01:09" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "11:03:07" , 
"departure_time" : "11:04:27" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "11:06:20" , 
"departure_time" : "11:07:18" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "11:07:58" , 
"departure_time" : "11:09:28" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "11:10:30" , 
"departure_time" : "11:10:37" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "11:14:07" , 
"departure_time" : "11:14:31" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "11:16:24" , 
"departure_time" : "11:17:39" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "11:21:15" , 
"departure_time" : "11:21:58" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "11:24:43" , 
"departure_time" : "11:25:24" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "11:26:41" , 
"departure_time" : "11:26:50" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "11:32:09" , 
"departure_time" : "11:32:21" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "11:35:12" , 
"departure_time" : "11:36:33" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "11:41:21" , 
"departure_time" : "11:41:41" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "11:46:20" , 
"departure_time" : "11:47:29" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "11:49:09" , 
"departure_time" : "11:50:18" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "11:52:09" , 
"departure_time" : "11:52:09" , 
"distance_traveled" : 33.5428
} ], 
"4956" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "11:14:00" , 
"departure_time" : "11:15:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "11:16:39" , 
"departure_time" : "11:16:49" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "11:18:10" , 
"departure_time" : "11:19:17" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "11:23:07" , 
"departure_time" : "11:24:29" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "11:28:22" , 
"departure_time" : "11:28:48" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "11:29:26" , 
"departure_time" : "11:30:43" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "11:33:17" , 
"departure_time" : "11:34:28" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "11:36:11" , 
"departure_time" : "11:37:12" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "11:38:01" , 
"departure_time" : "11:38:50" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "11:39:49" , 
"departure_time" : "11:39:53" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "11:44:04" , 
"departure_time" : "11:45:11" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "11:47:07" , 
"departure_time" : "11:47:45" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "11:50:38" , 
"departure_time" : "11:51:20" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "11:54:42" , 
"departure_time" : "11:55:23" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "11:56:41" , 
"departure_time" : "11:57:10" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "12:02:29" , 
"departure_time" : "12:03:07" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "12:05:38" , 
"departure_time" : "12:07:08" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "12:11:30" , 
"departure_time" : "12:12:54" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "12:17:24" , 
"departure_time" : "12:18:46" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "12:19:22" , 
"departure_time" : "12:20:58" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "12:22:36" , 
"departure_time" : "12:22:36" , 
"distance_traveled" : 33.5428
} ], 
"4957" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "11:44:00" , 
"departure_time" : "11:47:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "11:47:29" , 
"departure_time" : "11:47:56" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "11:48:27" , 
"departure_time" : "11:48:58" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "11:52:31" , 
"departure_time" : "11:53:10" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "11:57:39" , 
"departure_time" : "11:58:11" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "11:59:32" , 
"departure_time" : "12:00:43" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "12:03:11" , 
"departure_time" : "12:03:12" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "12:05:01" , 
"departure_time" : "12:06:34" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "12:08:33" , 
"departure_time" : "12:08:38" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "12:09:05" , 
"departure_time" : "12:09:55" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "12:14:50" , 
"departure_time" : "12:15:53" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "12:17:03" , 
"departure_time" : "12:18:41" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "12:21:38" , 
"departure_time" : "12:22:01" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "12:24:23" , 
"departure_time" : "12:25:57" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "12:27:34" , 
"departure_time" : "12:28:41" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "12:33:07" , 
"departure_time" : "12:34:03" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "12:35:56" , 
"departure_time" : "12:37:21" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "12:41:25" , 
"departure_time" : "12:41:48" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "12:46:23" , 
"departure_time" : "12:47:52" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "12:49:29" , 
"departure_time" : "12:50:50" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "12:52:21" , 
"departure_time" : "12:52:21" , 
"distance_traveled" : 33.5428
} ], 
"4958" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "12:14:00" , 
"departure_time" : "12:16:12" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "12:16:51" , 
"departure_time" : "12:17:44" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "12:18:53" , 
"departure_time" : "12:19:34" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "12:22:41" , 
"departure_time" : "12:23:08" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "12:27:27" , 
"departure_time" : "12:28:37" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "12:30:10" , 
"departure_time" : "12:31:18" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "12:33:08" , 
"departure_time" : "12:34:28" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "12:36:20" , 
"departure_time" : "12:37:41" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "12:38:21" , 
"departure_time" : "12:39:13" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "12:39:52" , 
"departure_time" : "12:40:45" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "12:44:53" , 
"departure_time" : "12:46:16" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "12:47:23" , 
"departure_time" : "12:47:47" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "12:50:24" , 
"departure_time" : "12:50:41" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "12:54:17" , 
"departure_time" : "12:54:44" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "12:56:27" , 
"departure_time" : "12:57:08" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "13:02:41" , 
"departure_time" : "13:02:59" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "13:05:18" , 
"departure_time" : "13:06:05" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "13:10:47" , 
"departure_time" : "13:11:21" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "13:16:34" , 
"departure_time" : "13:17:28" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "13:18:54" , 
"departure_time" : "13:19:37" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "13:21:43" , 
"departure_time" : "13:21:43" , 
"distance_traveled" : 33.5428
} ], 
"4959" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "12:44:00" , 
"departure_time" : "12:45:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "12:46:50" , 
"departure_time" : "12:48:23" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "12:49:33" , 
"departure_time" : "12:50:24" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "12:52:51" , 
"departure_time" : "12:53:07" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "12:57:16" , 
"departure_time" : "12:58:38" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "13:00:22" , 
"departure_time" : "13:01:17" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "13:02:55" , 
"departure_time" : "13:03:28" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "13:05:33" , 
"departure_time" : "13:06:19" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "13:07:46" , 
"departure_time" : "13:08:18" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "13:09:32" , 
"departure_time" : "13:10:20" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "13:14:48" , 
"departure_time" : "13:15:26" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "13:16:38" , 
"departure_time" : "13:18:00" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "13:21:22" , 
"departure_time" : "13:22:21" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "13:24:59" , 
"departure_time" : "13:25:05" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "13:26:06" , 
"departure_time" : "13:27:17" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "13:33:11" , 
"departure_time" : "13:34:18" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "13:36:07" , 
"departure_time" : "13:36:25" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "13:40:18" , 
"departure_time" : "13:40:49" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "13:46:31" , 
"departure_time" : "13:46:52" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "13:48:21" , 
"departure_time" : "13:49:09" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "13:51:48" , 
"departure_time" : "13:51:48" , 
"distance_traveled" : 33.5428
} ], 
"4960" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "13:14:00" , 
"departure_time" : "13:15:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "13:16:55" , 
"departure_time" : "13:18:24" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "13:19:29" , 
"departure_time" : "13:20:23" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "13:22:54" , 
"departure_time" : "13:23:41" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "13:27:47" , 
"departure_time" : "13:28:22" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "13:29:35" , 
"departure_time" : "13:29:44" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "13:32:09" , 
"departure_time" : "13:33:18" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "13:36:09" , 
"departure_time" : "13:36:18" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "13:37:09" , 
"departure_time" : "13:38:33" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "13:40:24" , 
"departure_time" : "13:41:18" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "13:44:54" , 
"departure_time" : "13:45:10" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "13:46:16" , 
"departure_time" : "13:47:28" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "13:51:12" , 
"departure_time" : "13:51:32" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "13:54:20" , 
"departure_time" : "13:54:27" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "13:56:07" , 
"departure_time" : "13:57:34" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "14:03:27" , 
"departure_time" : "14:03:52" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "14:05:25" , 
"departure_time" : "14:06:42" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "14:11:17" , 
"departure_time" : "14:11:24" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "14:16:07" , 
"departure_time" : "14:17:30" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "14:19:23" , 
"departure_time" : "14:19:30" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "14:21:07" , 
"departure_time" : "14:21:07" , 
"distance_traveled" : 33.5428
} ], 
"4961" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "13:44:00" , 
"departure_time" : "13:45:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "13:47:02" , 
"departure_time" : "13:48:33" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "13:49:31" , 
"departure_time" : "13:50:11" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "13:52:40" , 
"departure_time" : "13:53:37" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "13:57:57" , 
"departure_time" : "13:58:22" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "13:59:25" , 
"departure_time" : "14:00:33" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "14:03:08" , 
"departure_time" : "14:04:29" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "14:06:21" , 
"departure_time" : "14:07:34" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "14:08:13" , 
"departure_time" : "14:08:33" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "14:09:20" , 
"departure_time" : "14:09:38" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "14:14:18" , 
"departure_time" : "14:15:27" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "14:17:09" , 
"departure_time" : "14:17:13" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "14:20:04" , 
"departure_time" : "14:20:44" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "14:24:40" , 
"departure_time" : "14:24:41" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "14:26:01" , 
"departure_time" : "14:26:53" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "14:32:52" , 
"departure_time" : "14:33:44" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "14:35:52" , 
"departure_time" : "14:36:34" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "14:40:42" , 
"departure_time" : "14:42:19" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "14:47:37" , 
"departure_time" : "14:48:23" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "14:48:46" , 
"departure_time" : "14:49:56" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "14:52:10" , 
"departure_time" : "14:52:10" , 
"distance_traveled" : 33.5428
} ], 
"4962" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "14:14:00" , 
"departure_time" : "14:16:35" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "14:17:25" , 
"departure_time" : "14:18:01" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "14:18:36" , 
"departure_time" : "14:18:38" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "14:22:02" , 
"departure_time" : "14:22:48" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "14:27:46" , 
"departure_time" : "14:28:37" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "14:29:51" , 
"departure_time" : "14:29:57" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "14:32:06" , 
"departure_time" : "14:33:08" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "14:36:02" , 
"departure_time" : "14:37:05" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "14:38:03" , 
"departure_time" : "14:39:42" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "14:40:39" , 
"departure_time" : "14:42:15" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "14:45:36" , 
"departure_time" : "14:46:59" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "14:47:23" , 
"departure_time" : "14:47:30" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "14:50:07" , 
"departure_time" : "14:51:38" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "14:55:31" , 
"departure_time" : "14:55:35" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "14:56:04" , 
"departure_time" : "14:57:19" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "15:03:15" , 
"departure_time" : "15:04:54" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "15:06:39" , 
"departure_time" : "15:07:12" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "15:10:33" , 
"departure_time" : "15:11:04" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "15:16:31" , 
"departure_time" : "15:17:52" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "15:19:21" , 
"departure_time" : "15:20:41" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "15:22:20" , 
"departure_time" : "15:22:20" , 
"distance_traveled" : 33.5428
} ], 
"4963" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "14:44:00" , 
"departure_time" : "14:45:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "14:46:07" , 
"departure_time" : "14:46:53" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "14:48:46" , 
"departure_time" : "14:49:24" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "14:52:38" , 
"departure_time" : "14:54:05" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "14:58:27" , 
"departure_time" : "14:59:58" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "15:00:31" , 
"departure_time" : "15:02:03" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "15:03:32" , 
"departure_time" : "15:03:42" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "15:05:10" , 
"departure_time" : "15:06:22" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "15:08:12" , 
"departure_time" : "15:09:49" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "15:10:37" , 
"departure_time" : "15:11:29" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "15:14:52" , 
"departure_time" : "15:16:17" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "15:17:25" , 
"departure_time" : "15:18:26" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "15:21:01" , 
"departure_time" : "15:21:26" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "15:24:25" , 
"departure_time" : "15:24:54" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "15:26:29" , 
"departure_time" : "15:27:48" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "15:33:19" , 
"departure_time" : "15:33:50" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "15:35:31" , 
"departure_time" : "15:35:34" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "15:40:03" , 
"departure_time" : "15:41:17" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "15:47:14" , 
"departure_time" : "15:47:38" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "15:48:24" , 
"departure_time" : "15:50:04" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "15:52:40" , 
"departure_time" : "15:52:40" , 
"distance_traveled" : 33.5428
} ], 
"4964" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "15:14:00" , 
"departure_time" : "15:16:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "15:16:56" , 
"departure_time" : "15:17:47" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "15:18:51" , 
"departure_time" : "15:19:52" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "15:23:01" , 
"departure_time" : "15:23:55" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "15:27:54" , 
"departure_time" : "15:28:57" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "15:30:03" , 
"departure_time" : "15:31:38" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "15:33:35" , 
"departure_time" : "15:34:30" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "15:35:55" , 
"departure_time" : "15:36:29" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "15:37:34" , 
"departure_time" : "15:37:47" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "15:39:13" , 
"departure_time" : "15:39:16" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "15:44:03" , 
"departure_time" : "15:44:10" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "15:46:07" , 
"departure_time" : "15:47:35" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "15:51:28" , 
"departure_time" : "15:52:04" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "15:54:36" , 
"departure_time" : "15:54:43" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "15:56:07" , 
"departure_time" : "15:57:17" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "16:03:10" , 
"departure_time" : "16:03:35" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "16:05:25" , 
"departure_time" : "16:06:32" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "16:11:07" , 
"departure_time" : "16:11:27" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "16:16:20" , 
"departure_time" : "16:16:21" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "16:18:01" , 
"departure_time" : "16:19:34" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "16:22:33" , 
"departure_time" : "16:22:33" , 
"distance_traveled" : 33.5428
} ], 
"4965" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "15:44:00" , 
"departure_time" : "15:46:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "15:47:12" , 
"departure_time" : "15:47:26" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "15:48:14" , 
"departure_time" : "15:48:35" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "15:52:21" , 
"departure_time" : "15:53:20" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "15:57:59" , 
"departure_time" : "15:59:31" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "16:00:32" , 
"departure_time" : "16:01:50" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "16:03:18" , 
"departure_time" : "16:03:52" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "16:05:34" , 
"departure_time" : "16:06:08" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "16:07:34" , 
"departure_time" : "16:09:00" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "16:10:26" , 
"departure_time" : "16:10:40" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "16:14:14" , 
"departure_time" : "16:14:51" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "16:16:37" , 
"departure_time" : "16:16:45" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "16:20:08" , 
"departure_time" : "16:21:12" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "16:25:04" , 
"departure_time" : "16:26:23" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "16:27:19" , 
"departure_time" : "16:28:38" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "16:33:19" , 
"departure_time" : "16:34:47" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "16:36:28" , 
"departure_time" : "16:37:29" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "16:41:01" , 
"departure_time" : "16:42:31" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "16:47:30" , 
"departure_time" : "16:47:33" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "16:48:03" , 
"departure_time" : "16:48:34" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "16:51:31" , 
"departure_time" : "16:51:31" , 
"distance_traveled" : 33.5428
} ], 
"4966" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "16:14:00" , 
"departure_time" : "16:15:56" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "16:17:25" , 
"departure_time" : "16:17:28" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "16:18:03" , 
"departure_time" : "16:19:11" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "16:23:08" , 
"departure_time" : "16:24:11" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "16:28:03" , 
"departure_time" : "16:28:41" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "16:29:38" , 
"departure_time" : "16:30:01" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "16:32:23" , 
"departure_time" : "16:32:49" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "16:35:26" , 
"departure_time" : "16:35:35" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "16:37:09" , 
"departure_time" : "16:38:49" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "16:40:40" , 
"departure_time" : "16:41:50" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "16:45:10" , 
"departure_time" : "16:46:46" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "16:47:36" , 
"departure_time" : "16:49:16" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "16:51:40" , 
"departure_time" : "16:52:35" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "16:54:55" , 
"departure_time" : "16:56:14" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "16:57:19" , 
"departure_time" : "16:58:37" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "17:03:18" , 
"departure_time" : "17:03:52" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "17:05:34" , 
"departure_time" : "17:06:26" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "17:10:52" , 
"departure_time" : "17:12:06" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "17:17:14" , 
"departure_time" : "17:17:52" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "17:18:38" , 
"departure_time" : "17:19:53" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "17:22:15" , 
"departure_time" : "17:22:15" , 
"distance_traveled" : 33.5428
} ], 
"4967" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "16:44:00" , 
"departure_time" : "16:45:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "16:46:40" , 
"departure_time" : "16:46:53" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "16:48:13" , 
"departure_time" : "16:49:52" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "16:53:39" , 
"departure_time" : "16:54:34" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "16:57:55" , 
"departure_time" : "16:59:35" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "17:00:40" , 
"departure_time" : "17:00:42" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "17:02:02" , 
"departure_time" : "17:02:25" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "17:05:23" , 
"departure_time" : "17:05:55" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "17:07:32" , 
"departure_time" : "17:07:39" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "17:09:07" , 
"departure_time" : "17:09:33" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "17:14:26" , 
"departure_time" : "17:15:11" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "17:16:45" , 
"departure_time" : "17:17:58" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "17:21:13" , 
"departure_time" : "17:22:38" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "17:25:25" , 
"departure_time" : "17:25:49" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "17:26:24" , 
"departure_time" : "17:27:16" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "17:32:52" , 
"departure_time" : "17:33:42" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "17:35:50" , 
"departure_time" : "17:37:25" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "17:41:35" , 
"departure_time" : "17:42:17" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "17:46:42" , 
"departure_time" : "17:48:01" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "17:49:19" , 
"departure_time" : "17:49:23" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "17:51:04" , 
"departure_time" : "17:51:04" , 
"distance_traveled" : 33.5428
} ], 
"4968" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "17:14:00" , 
"departure_time" : "17:15:37" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "17:17:33" , 
"departure_time" : "17:17:34" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "17:18:01" , 
"departure_time" : "17:18:35" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "17:22:34" , 
"departure_time" : "17:23:15" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "17:27:41" , 
"departure_time" : "17:29:15" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "17:30:34" , 
"departure_time" : "17:31:44" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "17:33:10" , 
"departure_time" : "17:33:35" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "17:35:25" , 
"departure_time" : "17:35:51" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "17:37:26" , 
"departure_time" : "17:37:37" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "17:39:11" , 
"departure_time" : "17:40:46" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "17:45:35" , 
"departure_time" : "17:46:57" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "17:47:22" , 
"departure_time" : "17:47:37" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "17:50:15" , 
"departure_time" : "17:51:43" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "17:55:28" , 
"departure_time" : "17:56:29" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "17:57:01" , 
"departure_time" : "17:58:18" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "18:03:17" , 
"departure_time" : "18:03:20" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "18:05:03" , 
"departure_time" : "18:05:39" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "18:10:36" , 
"departure_time" : "18:11:54" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "18:17:18" , 
"departure_time" : "18:18:26" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "18:19:08" , 
"departure_time" : "18:20:22" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "18:22:14" , 
"departure_time" : "18:22:14" , 
"distance_traveled" : 33.5428
} ], 
"4969" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "17:44:00" , 
"departure_time" : "17:46:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "17:47:39" , 
"departure_time" : "17:48:23" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "17:48:44" , 
"departure_time" : "17:49:01" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "17:52:17" , 
"departure_time" : "17:52:44" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "17:57:27" , 
"departure_time" : "17:58:49" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "18:00:22" , 
"departure_time" : "18:00:32" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "18:02:10" , 
"departure_time" : "18:02:37" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "18:05:27" , 
"departure_time" : "18:07:05" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "18:08:38" , 
"departure_time" : "18:09:26" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "18:09:48" , 
"departure_time" : "18:10:51" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "18:15:03" , 
"departure_time" : "18:15:14" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "18:16:11" , 
"departure_time" : "18:16:32" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "18:20:21" , 
"departure_time" : "18:20:55" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "18:24:34" , 
"departure_time" : "18:25:29" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "18:26:55" , 
"departure_time" : "18:26:58" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "18:32:03" , 
"departure_time" : "18:33:13" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "18:36:10" , 
"departure_time" : "18:37:29" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "18:41:19" , 
"departure_time" : "18:41:53" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "18:46:34" , 
"departure_time" : "18:47:38" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "18:49:04" , 
"departure_time" : "18:50:31" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "18:52:27" , 
"departure_time" : "18:52:27" , 
"distance_traveled" : 33.5428
} ], 
"4970" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "18:14:00" , 
"departure_time" : "18:16:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "18:16:50" , 
"departure_time" : "18:17:08" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "18:18:18" , 
"departure_time" : "18:19:38" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "18:23:20" , 
"departure_time" : "18:24:43" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "18:28:23" , 
"departure_time" : "18:28:24" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "18:29:01" , 
"departure_time" : "18:29:31" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "18:32:30" , 
"departure_time" : "18:34:01" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "18:36:31" , 
"departure_time" : "18:37:51" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "18:38:20" , 
"departure_time" : "18:38:25" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "18:39:05" , 
"departure_time" : "18:40:31" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "18:45:26" , 
"departure_time" : "18:46:38" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "18:47:12" , 
"departure_time" : "18:47:22" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "18:50:10" , 
"departure_time" : "18:51:39" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "18:55:29" , 
"departure_time" : "18:56:32" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "18:57:03" , 
"departure_time" : "18:58:12" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "19:03:09" , 
"departure_time" : "19:03:30" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "19:05:21" , 
"departure_time" : "19:06:57" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "19:11:36" , 
"departure_time" : "19:12:53" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "19:17:17" , 
"departure_time" : "19:18:54" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "19:19:37" , 
"departure_time" : "19:19:45" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "19:21:08" , 
"departure_time" : "19:21:08" , 
"distance_traveled" : 33.5428
} ], 
"4971" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "18:44:00" , 
"departure_time" : "18:44:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "18:46:02" , 
"departure_time" : "18:46:39" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "18:48:37" , 
"departure_time" : "18:49:08" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "18:52:31" , 
"departure_time" : "18:52:48" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "18:57:17" , 
"departure_time" : "18:58:16" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "18:59:59" , 
"departure_time" : "19:00:11" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "19:02:12" , 
"departure_time" : "19:03:34" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "19:06:22" , 
"departure_time" : "19:06:30" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "19:07:08" , 
"departure_time" : "19:08:46" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "19:10:38" , 
"departure_time" : "19:11:30" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "19:14:52" , 
"departure_time" : "19:15:42" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "19:16:50" , 
"departure_time" : "19:17:57" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "19:21:07" , 
"departure_time" : "19:22:08" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "19:25:01" , 
"departure_time" : "19:25:49" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "19:26:48" , 
"departure_time" : "19:28:02" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "19:33:14" , 
"departure_time" : "19:33:34" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "19:35:20" , 
"departure_time" : "19:35:54" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "19:40:34" , 
"departure_time" : "19:40:54" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "19:46:20" , 
"departure_time" : "19:47:12" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "19:48:52" , 
"departure_time" : "19:48:59" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "19:51:07" , 
"departure_time" : "19:51:07" , 
"distance_traveled" : 33.5428
} ], 
"4972" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "19:14:00" , 
"departure_time" : "19:14:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "19:16:43" , 
"departure_time" : "19:16:46" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "19:18:03" , 
"departure_time" : "19:18:58" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "19:22:55" , 
"departure_time" : "19:24:34" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "19:28:39" , 
"departure_time" : "19:29:42" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "19:30:03" , 
"departure_time" : "19:30:32" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "19:32:29" , 
"departure_time" : "19:32:44" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "19:35:15" , 
"departure_time" : "19:36:12" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "19:37:57" , 
"departure_time" : "19:38:35" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "19:39:38" , 
"departure_time" : "19:39:51" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "19:44:13" , 
"departure_time" : "19:45:20" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "19:47:07" , 
"departure_time" : "19:48:33" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "19:51:26" , 
"departure_time" : "19:52:01" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "19:54:35" , 
"departure_time" : "19:55:10" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "19:56:35" , 
"departure_time" : "19:57:59" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "20:03:24" , 
"departure_time" : "20:03:53" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "20:05:29" , 
"departure_time" : "20:07:04" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "20:11:35" , 
"departure_time" : "20:13:13" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "20:17:38" , 
"departure_time" : "20:18:43" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "20:19:05" , 
"departure_time" : "20:20:14" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "20:22:09" , 
"departure_time" : "20:22:09" , 
"distance_traveled" : 33.5428
} ], 
"4973" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "19:44:00" , 
"departure_time" : "19:45:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "19:46:24" , 
"departure_time" : "19:47:31" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "19:49:07" , 
"departure_time" : "19:50:19" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "19:53:12" , 
"departure_time" : "19:54:47" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "19:58:35" , 
"departure_time" : "19:58:50" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "19:59:15" , 
"departure_time" : "20:00:24" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "20:03:09" , 
"departure_time" : "20:03:34" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "20:05:25" , 
"departure_time" : "20:05:36" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "20:07:11" , 
"departure_time" : "20:07:50" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "20:09:39" , 
"departure_time" : "20:11:17" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "20:15:38" , 
"departure_time" : "20:17:15" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "20:17:37" , 
"departure_time" : "20:18:40" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "20:21:03" , 
"departure_time" : "20:22:18" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "20:25:15" , 
"departure_time" : "20:26:30" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "20:27:15" , 
"departure_time" : "20:27:52" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "20:32:37" , 
"departure_time" : "20:33:56" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "20:36:19" , 
"departure_time" : "20:36:49" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "20:40:30" , 
"departure_time" : "20:40:38" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "20:46:08" , 
"departure_time" : "20:46:37" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "20:48:29" , 
"departure_time" : "20:48:59" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "20:51:30" , 
"departure_time" : "20:51:30" , 
"distance_traveled" : 33.5428
} ], 
"4974" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "20:14:00" , 
"departure_time" : "20:15:44" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "20:17:14" , 
"departure_time" : "20:17:25" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "20:18:11" , 
"departure_time" : "20:19:41" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "20:23:30" , 
"departure_time" : "20:24:05" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "20:27:35" , 
"departure_time" : "20:28:39" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "20:30:04" , 
"departure_time" : "20:31:43" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "20:33:39" , 
"departure_time" : "20:34:38" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "20:35:59" , 
"departure_time" : "20:36:04" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "20:37:05" , 
"departure_time" : "20:38:21" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "20:40:16" , 
"departure_time" : "20:40:42" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "20:44:26" , 
"departure_time" : "20:44:50" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "20:46:24" , 
"departure_time" : "20:47:54" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "20:51:30" , 
"departure_time" : "20:51:55" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "20:54:25" , 
"departure_time" : "20:55:50" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "20:57:25" , 
"departure_time" : "20:58:07" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "21:02:42" , 
"departure_time" : "21:03:27" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "21:05:45" , 
"departure_time" : "21:06:25" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "21:10:40" , 
"departure_time" : "21:10:58" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "21:16:18" , 
"departure_time" : "21:17:03" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "21:18:45" , 
"departure_time" : "21:19:58" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "21:22:13" , 
"departure_time" : "21:22:13" , 
"distance_traveled" : 33.5428
} ], 
"4975" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "20:59:00" , 
"departure_time" : "21:00:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "21:01:46" , 
"departure_time" : "21:03:21" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "21:04:35" , 
"departure_time" : "21:05:27" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "21:07:52" , 
"departure_time" : "21:09:32" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "21:13:40" , 
"departure_time" : "21:15:07" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "21:15:27" , 
"departure_time" : "21:15:57" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "21:17:30" , 
"departure_time" : "21:18:39" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "21:21:09" , 
"departure_time" : "21:22:30" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "21:23:21" , 
"departure_time" : "21:24:01" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "21:24:40" , 
"departure_time" : "21:26:12" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "21:30:32" , 
"departure_time" : "21:32:01" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "21:32:29" , 
"departure_time" : "21:32:59" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "21:35:30" , 
"departure_time" : "21:36:54" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "21:40:24" , 
"departure_time" : "21:41:39" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "21:42:15" , 
"departure_time" : "21:42:57" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "21:47:42" , 
"departure_time" : "21:49:20" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "21:51:38" , 
"departure_time" : "21:52:07" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "21:55:29" , 
"departure_time" : "21:55:38" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "22:01:09" , 
"departure_time" : "22:02:22" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "22:04:13" , 
"departure_time" : "22:05:30" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "22:07:17" , 
"departure_time" : "22:07:17" , 
"distance_traveled" : 33.5428
} ], 
"4976" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "21:29:00" , 
"departure_time" : "21:31:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "21:32:16" , 
"departure_time" : "21:32:47" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "21:33:31" , 
"departure_time" : "21:34:33" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "21:38:02" , 
"departure_time" : "21:39:27" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "21:43:25" , 
"departure_time" : "21:44:52" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "21:45:27" , 
"departure_time" : "21:46:56" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "21:48:29" , 
"departure_time" : "21:48:29" , 
"distance_traveled" : 6.9218
} ], 
"4977" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "05:45:00" , 
"departure_time" : "05:48:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "05:48:38" , 
"departure_time" : "05:49:25" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "05:49:47" , 
"departure_time" : "05:50:08" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "05:56:21" , 
"departure_time" : "05:57:49" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "06:02:28" , 
"departure_time" : "06:03:09" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "06:04:41" , 
"departure_time" : "06:05:57" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "06:10:16" , 
"departure_time" : "06:10:52" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "06:11:36" , 
"departure_time" : "06:11:55" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "06:15:19" , 
"departure_time" : "06:16:14" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "06:19:55" , 
"departure_time" : "06:19:59" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "06:21:04" , 
"departure_time" : "06:22:10" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "06:27:06" , 
"departure_time" : "06:27:50" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "06:28:44" , 
"departure_time" : "06:30:12" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "06:31:28" , 
"departure_time" : "06:32:31" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "06:34:03" , 
"departure_time" : "06:34:55" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "06:35:52" , 
"departure_time" : "06:35:58" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "06:39:06" , 
"departure_time" : "06:39:07" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "06:44:01" , 
"departure_time" : "06:44:16" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "06:47:15" , 
"departure_time" : "06:47:48" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "06:49:33" , 
"departure_time" : "06:51:03" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "06:53:30" , 
"departure_time" : "06:53:30" , 
"distance_traveled" : 33.5915
} ], 
"4978" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "05:57:00" , 
"departure_time" : "05:59:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "06:00:15" , 
"departure_time" : "06:00:55" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "06:01:40" , 
"departure_time" : "06:02:31" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "06:08:51" , 
"departure_time" : "06:09:40" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "06:13:49" , 
"departure_time" : "06:14:54" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "06:17:05" , 
"departure_time" : "06:18:11" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "06:22:06" , 
"departure_time" : "06:23:32" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "06:24:26" , 
"departure_time" : "06:25:00" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "06:27:34" , 
"departure_time" : "06:27:39" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "06:31:05" , 
"departure_time" : "06:32:19" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "06:34:14" , 
"departure_time" : "06:34:24" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "06:38:10" , 
"departure_time" : "06:39:45" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "06:41:35" , 
"departure_time" : "06:41:42" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "06:42:07" , 
"departure_time" : "06:43:36" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "06:46:29" , 
"departure_time" : "06:47:53" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "06:48:24" , 
"departure_time" : "06:48:50" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "06:51:26" , 
"departure_time" : "06:52:23" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "06:56:57" , 
"departure_time" : "06:57:19" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "06:59:22" , 
"departure_time" : "07:00:04" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "07:01:42" , 
"departure_time" : "07:02:07" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "07:04:25" , 
"departure_time" : "07:04:25" , 
"distance_traveled" : 33.5915
} ], 
"4979" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "06:12:00" , 
"departure_time" : "06:13:58" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "06:15:33" , 
"departure_time" : "06:15:51" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "06:16:18" , 
"departure_time" : "06:17:03" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "06:23:45" , 
"departure_time" : "06:23:46" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "06:28:01" , 
"departure_time" : "06:28:05" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "06:31:04" , 
"departure_time" : "06:31:41" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "06:36:37" , 
"departure_time" : "06:36:39" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "06:38:02" , 
"departure_time" : "06:38:21" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "06:42:19" , 
"departure_time" : "06:42:20" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "06:46:01" , 
"departure_time" : "06:46:20" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "06:48:19" , 
"departure_time" : "06:49:40" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "06:54:21" , 
"departure_time" : "06:54:36" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "06:55:15" , 
"departure_time" : "06:56:08" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "06:57:53" , 
"departure_time" : "06:58:12" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "07:00:19" , 
"departure_time" : "07:00:43" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "07:02:24" , 
"departure_time" : "07:03:38" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "07:07:14" , 
"departure_time" : "07:07:54" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "07:11:40" , 
"departure_time" : "07:12:05" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "07:14:25" , 
"departure_time" : "07:14:38" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "07:16:13" , 
"departure_time" : "07:16:39" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "07:19:26" , 
"departure_time" : "07:19:26" , 
"distance_traveled" : 33.5915
} ], 
"4980" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "06:27:00" , 
"departure_time" : "06:28:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "06:29:41" , 
"departure_time" : "06:29:56" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "06:31:15" , 
"departure_time" : "06:32:00" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "06:38:45" , 
"departure_time" : "06:40:05" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "06:44:20" , 
"departure_time" : "06:45:50" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "06:47:30" , 
"departure_time" : "06:48:12" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "06:51:42" , 
"departure_time" : "06:51:46" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "06:53:04" , 
"departure_time" : "06:53:08" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "06:57:04" , 
"departure_time" : "06:57:23" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "07:01:19" , 
"departure_time" : "07:02:00" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "07:03:41" , 
"departure_time" : "07:04:17" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "07:08:36" , 
"departure_time" : "07:09:14" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "07:10:38" , 
"departure_time" : "07:11:59" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "07:13:21" , 
"departure_time" : "07:14:21" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "07:16:00" , 
"departure_time" : "07:16:42" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "07:17:42" , 
"departure_time" : "07:18:18" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "07:21:36" , 
"departure_time" : "07:22:46" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "07:27:10" , 
"departure_time" : "07:27:17" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "07:29:07" , 
"departure_time" : "07:29:10" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "07:31:03" , 
"departure_time" : "07:32:27" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "07:35:24" , 
"departure_time" : "07:35:24" , 
"distance_traveled" : 33.5915
} ], 
"4981" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "06:42:00" , 
"departure_time" : "06:43:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "06:44:28" , 
"departure_time" : "06:44:47" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "06:46:19" , 
"departure_time" : "06:47:11" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "06:53:52" , 
"departure_time" : "06:54:23" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "06:58:31" , 
"departure_time" : "07:00:02" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "07:02:31" , 
"departure_time" : "07:02:55" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "07:06:24" , 
"departure_time" : "07:07:00" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "07:08:36" , 
"departure_time" : "07:09:52" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "07:13:16" , 
"departure_time" : "07:14:03" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "07:16:47" , 
"departure_time" : "07:17:18" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "07:18:31" , 
"departure_time" : "07:18:45" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "07:23:14" , 
"departure_time" : "07:24:47" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "07:26:33" , 
"departure_time" : "07:28:05" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "07:28:32" , 
"departure_time" : "07:28:37" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "07:30:05" , 
"departure_time" : "07:31:40" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "07:33:35" , 
"departure_time" : "07:33:37" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "07:36:02" , 
"departure_time" : "07:36:10" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "07:41:08" , 
"departure_time" : "07:42:12" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "07:45:04" , 
"departure_time" : "07:46:04" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "07:47:00" , 
"departure_time" : "07:47:08" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "07:49:08" , 
"departure_time" : "07:49:08" , 
"distance_traveled" : 33.5915
} ], 
"4982" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "06:57:00" , 
"departure_time" : "06:57:17" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "06:59:09" , 
"departure_time" : "06:59:21" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "07:01:12" , 
"departure_time" : "07:01:33" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "07:08:21" , 
"departure_time" : "07:09:13" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "07:13:52" , 
"departure_time" : "07:15:02" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "07:17:10" , 
"departure_time" : "07:17:26" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "07:21:16" , 
"departure_time" : "07:22:33" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "07:24:17" , 
"departure_time" : "07:25:00" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "07:27:43" , 
"departure_time" : "07:28:34" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "07:31:51" , 
"departure_time" : "07:32:34" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "07:33:43" , 
"departure_time" : "07:35:21" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "07:39:38" , 
"departure_time" : "07:40:20" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "07:40:42" , 
"departure_time" : "07:41:52" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "07:43:10" , 
"departure_time" : "07:44:44" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "07:46:34" , 
"departure_time" : "07:47:20" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "07:47:46" , 
"departure_time" : "07:48:22" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "07:51:36" , 
"departure_time" : "07:52:55" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "07:57:19" , 
"departure_time" : "07:58:34" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "08:00:15" , 
"departure_time" : "08:00:37" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "08:01:22" , 
"departure_time" : "08:02:37" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "08:05:15" , 
"departure_time" : "08:05:15" , 
"distance_traveled" : 33.5915
} ], 
"4983" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "07:12:00" , 
"departure_time" : "07:14:09" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "07:14:54" , 
"departure_time" : "07:15:00" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "07:16:06" , 
"departure_time" : "07:17:33" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "07:24:27" , 
"departure_time" : "07:25:19" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "07:28:52" , 
"departure_time" : "07:29:07" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "07:31:15" , 
"departure_time" : "07:31:39" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "07:36:24" , 
"departure_time" : "07:37:01" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "07:38:37" , 
"departure_time" : "07:38:42" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "07:42:05" , 
"departure_time" : "07:42:12" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "07:46:07" , 
"departure_time" : "07:46:41" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "07:48:34" , 
"departure_time" : "07:50:07" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "07:54:33" , 
"departure_time" : "07:55:56" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "07:56:23" , 
"departure_time" : "07:56:47" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "07:57:24" , 
"departure_time" : "07:59:01" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "08:01:37" , 
"departure_time" : "08:02:52" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "08:03:15" , 
"departure_time" : "08:04:06" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "08:06:51" , 
"departure_time" : "08:07:31" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "08:11:40" , 
"departure_time" : "08:12:21" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "08:14:41" , 
"departure_time" : "08:15:12" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "08:16:31" , 
"departure_time" : "08:17:55" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "08:20:24" , 
"departure_time" : "08:20:24" , 
"distance_traveled" : 33.5915
} ], 
"4984" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "07:27:00" , 
"departure_time" : "07:28:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "07:29:07" , 
"departure_time" : "07:29:35" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "07:31:28" , 
"departure_time" : "07:32:43" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "07:39:15" , 
"departure_time" : "07:40:28" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "07:44:13" , 
"departure_time" : "07:45:41" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "07:47:28" , 
"departure_time" : "07:48:21" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "07:51:53" , 
"departure_time" : "07:52:00" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "07:53:07" , 
"departure_time" : "07:53:15" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "07:57:08" , 
"departure_time" : "07:58:14" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "08:02:06" , 
"departure_time" : "08:02:57" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "08:03:51" , 
"departure_time" : "08:05:11" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "08:09:20" , 
"departure_time" : "08:10:08" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "08:10:48" , 
"departure_time" : "08:12:07" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "08:13:19" , 
"departure_time" : "08:14:15" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "08:15:56" , 
"departure_time" : "08:16:52" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "08:17:56" , 
"departure_time" : "08:19:08" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "08:22:12" , 
"departure_time" : "08:23:24" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "08:27:12" , 
"departure_time" : "08:27:37" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "08:29:25" , 
"departure_time" : "08:30:22" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "08:31:57" , 
"departure_time" : "08:32:17" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "08:34:20" , 
"departure_time" : "08:34:20" , 
"distance_traveled" : 33.5915
} ], 
"4985" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "07:42:00" , 
"departure_time" : "07:43:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "07:45:12" , 
"departure_time" : "07:45:21" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "07:46:09" , 
"departure_time" : "07:47:22" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "07:54:13" , 
"departure_time" : "07:55:46" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "07:59:33" , 
"departure_time" : "08:00:10" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "08:01:37" , 
"departure_time" : "08:01:46" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "08:06:09" , 
"departure_time" : "08:07:27" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "08:09:18" , 
"departure_time" : "08:09:53" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "08:12:35" , 
"departure_time" : "08:12:38" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "08:16:03" , 
"departure_time" : "08:16:26" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "08:18:23" , 
"departure_time" : "08:20:03" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "08:24:40" , 
"departure_time" : "08:25:49" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "08:26:09" , 
"departure_time" : "08:26:19" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "08:27:10" , 
"departure_time" : "08:27:32" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "08:30:22" , 
"departure_time" : "08:31:19" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "08:32:57" , 
"departure_time" : "08:33:10" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "08:36:13" , 
"departure_time" : "08:36:15" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "08:41:02" , 
"departure_time" : "08:42:18" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "08:45:16" , 
"departure_time" : "08:46:43" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "08:47:27" , 
"departure_time" : "08:49:07" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "08:50:40" , 
"departure_time" : "08:50:40" , 
"distance_traveled" : 33.5915
} ], 
"4986" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "07:57:00" , 
"departure_time" : "07:59:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "08:00:01" , 
"departure_time" : "08:01:35" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "08:02:34" , 
"departure_time" : "08:03:41" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "08:09:07" , 
"departure_time" : "08:09:33" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "08:13:26" , 
"departure_time" : "08:14:47" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "08:17:21" , 
"departure_time" : "08:18:09" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "08:21:48" , 
"departure_time" : "08:23:15" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "08:24:27" , 
"departure_time" : "08:25:51" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "08:28:24" , 
"departure_time" : "08:29:00" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "08:31:36" , 
"departure_time" : "08:32:57" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "08:34:21" , 
"departure_time" : "08:35:21" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "08:39:00" , 
"departure_time" : "08:39:14" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "08:40:14" , 
"departure_time" : "08:40:46" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "08:42:32" , 
"departure_time" : "08:43:17" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "08:45:45" , 
"departure_time" : "08:46:29" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "08:47:44" , 
"departure_time" : "08:49:09" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "08:52:25" , 
"departure_time" : "08:52:47" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "08:56:22" , 
"departure_time" : "08:57:37" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "09:00:15" , 
"departure_time" : "09:01:43" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "09:02:28" , 
"departure_time" : "09:02:40" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "09:04:12" , 
"departure_time" : "09:04:12" , 
"distance_traveled" : 33.5915
} ], 
"4987" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "08:12:00" , 
"departure_time" : "08:12:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "08:14:12" , 
"departure_time" : "08:14:27" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "08:16:15" , 
"departure_time" : "08:17:16" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "08:24:01" , 
"departure_time" : "08:24:55" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "08:28:54" , 
"departure_time" : "08:29:28" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "08:31:34" , 
"departure_time" : "08:32:41" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "08:37:07" , 
"departure_time" : "08:38:27" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "08:39:20" , 
"departure_time" : "08:39:36" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "08:42:16" , 
"departure_time" : "08:43:01" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "08:46:45" , 
"departure_time" : "08:47:56" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "08:49:11" , 
"departure_time" : "08:50:05" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "08:53:54" , 
"departure_time" : "08:54:49" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "08:55:55" , 
"departure_time" : "08:57:20" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "08:58:25" , 
"departure_time" : "08:59:55" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "09:01:30" , 
"departure_time" : "09:02:48" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "09:03:18" , 
"departure_time" : "09:04:58" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "09:07:40" , 
"departure_time" : "09:08:45" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "09:12:05" , 
"departure_time" : "09:12:30" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "09:14:25" , 
"departure_time" : "09:14:57" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "09:16:32" , 
"departure_time" : "09:16:50" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "09:19:18" , 
"departure_time" : "09:19:18" , 
"distance_traveled" : 33.5915
} ], 
"4988" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "08:27:00" , 
"departure_time" : "08:28:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "08:30:24" , 
"departure_time" : "08:32:04" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "08:32:40" , 
"departure_time" : "08:33:33" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "08:38:53" , 
"departure_time" : "08:39:47" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "08:43:54" , 
"departure_time" : "08:44:43" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "08:46:49" , 
"departure_time" : "08:47:18" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "08:51:29" , 
"departure_time" : "08:51:39" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "08:53:10" , 
"departure_time" : "08:53:56" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "08:57:46" , 
"departure_time" : "08:59:08" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "09:02:22" , 
"departure_time" : "09:02:39" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "09:03:17" , 
"departure_time" : "09:04:43" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "09:09:26" , 
"departure_time" : "09:10:26" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "09:11:00" , 
"departure_time" : "09:12:02" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "09:13:02" , 
"departure_time" : "09:14:02" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "09:16:00" , 
"departure_time" : "09:16:47" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "09:17:47" , 
"departure_time" : "09:19:00" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "09:22:13" , 
"departure_time" : "09:22:37" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "09:26:24" , 
"departure_time" : "09:26:37" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "09:29:13" , 
"departure_time" : "09:30:42" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "09:32:29" , 
"departure_time" : "09:32:46" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "09:34:17" , 
"departure_time" : "09:34:17" , 
"distance_traveled" : 33.5915
} ], 
"4989" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "08:57:00" , 
"departure_time" : "08:57:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "08:59:28" , 
"departure_time" : "09:00:15" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "09:01:47" , 
"departure_time" : "09:02:31" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "09:08:44" , 
"departure_time" : "09:08:51" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "09:13:07" , 
"departure_time" : "09:14:05" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "09:16:58" , 
"departure_time" : "09:18:01" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "09:22:03" , 
"departure_time" : "09:22:06" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "09:23:03" , 
"departure_time" : "09:23:23" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "09:27:20" , 
"departure_time" : "09:27:31" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "09:31:11" , 
"departure_time" : "09:31:17" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "09:33:06" , 
"departure_time" : "09:33:07" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "09:38:01" , 
"departure_time" : "09:39:08" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "09:41:07" , 
"departure_time" : "09:42:35" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "09:43:28" , 
"departure_time" : "09:43:35" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "09:45:07" , 
"departure_time" : "09:45:25" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "09:47:18" , 
"departure_time" : "09:48:06" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "09:51:48" , 
"departure_time" : "09:52:18" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "09:56:30" , 
"departure_time" : "09:58:08" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "10:00:38" , 
"departure_time" : "10:01:55" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "10:02:17" , 
"departure_time" : "10:02:21" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "10:04:04" , 
"departure_time" : "10:04:04" , 
"distance_traveled" : 33.5915
} ], 
"4990" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "09:27:00" , 
"departure_time" : "09:27:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "09:29:23" , 
"departure_time" : "09:30:21" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "09:31:58" , 
"departure_time" : "09:32:18" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "09:38:20" , 
"departure_time" : "09:39:03" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "09:43:43" , 
"departure_time" : "09:45:06" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "09:47:23" , 
"departure_time" : "09:48:30" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "09:52:07" , 
"departure_time" : "09:53:35" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "09:54:28" , 
"departure_time" : "09:55:44" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "09:58:16" , 
"departure_time" : "09:59:27" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "10:02:11" , 
"departure_time" : "10:03:20" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "10:04:09" , 
"departure_time" : "10:05:31" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "10:09:22" , 
"departure_time" : "10:09:40" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "10:10:18" , 
"departure_time" : "10:10:59" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "10:12:41" , 
"departure_time" : "10:14:01" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "10:16:20" , 
"departure_time" : "10:17:53" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "10:18:33" , 
"departure_time" : "10:18:48" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "10:21:15" , 
"departure_time" : "10:21:27" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "10:26:12" , 
"departure_time" : "10:27:50" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "10:30:38" , 
"departure_time" : "10:31:41" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "10:32:03" , 
"departure_time" : "10:33:09" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "10:35:06" , 
"departure_time" : "10:35:06" , 
"distance_traveled" : 33.5915
} ], 
"4991" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "09:57:00" , 
"departure_time" : "09:58:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "09:59:34" , 
"departure_time" : "10:01:03" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "10:02:29" , 
"departure_time" : "10:03:59" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "10:09:30" , 
"departure_time" : "10:10:02" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "10:13:32" , 
"departure_time" : "10:13:35" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "10:16:03" , 
"departure_time" : "10:16:23" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "10:21:20" , 
"departure_time" : "10:21:31" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "10:23:11" , 
"departure_time" : "10:23:19" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "10:27:08" , 
"departure_time" : "10:28:22" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "10:32:14" , 
"departure_time" : "10:32:43" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "10:33:29" , 
"departure_time" : "10:34:26" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "10:38:57" , 
"departure_time" : "10:39:39" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "10:40:42" , 
"departure_time" : "10:41:50" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "10:43:08" , 
"departure_time" : "10:43:57" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "10:45:49" , 
"departure_time" : "10:46:02" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "10:47:13" , 
"departure_time" : "10:48:05" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "10:51:52" , 
"departure_time" : "10:53:00" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "10:57:08" , 
"departure_time" : "10:57:29" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "10:59:21" , 
"departure_time" : "11:00:36" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "11:02:15" , 
"departure_time" : "11:02:30" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "11:04:15" , 
"departure_time" : "11:04:15" , 
"distance_traveled" : 33.5915
} ], 
"4992" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "10:27:00" , 
"departure_time" : "10:28:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "10:30:12" , 
"departure_time" : "10:31:02" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "10:31:50" , 
"departure_time" : "10:33:25" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "10:39:35" , 
"departure_time" : "10:40:28" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "10:43:53" , 
"departure_time" : "10:44:15" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "10:46:22" , 
"departure_time" : "10:47:05" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "10:51:43" , 
"departure_time" : "10:52:51" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "10:54:08" , 
"departure_time" : "10:54:27" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "10:57:19" , 
"departure_time" : "10:58:26" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "11:02:07" , 
"departure_time" : "11:03:21" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "11:04:14" , 
"departure_time" : "11:05:40" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "11:09:26" , 
"departure_time" : "11:10:45" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "11:11:19" , 
"departure_time" : "11:12:15" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "11:12:56" , 
"departure_time" : "11:14:09" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "11:16:13" , 
"departure_time" : "11:17:51" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "11:18:38" , 
"departure_time" : "11:19:54" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "11:22:16" , 
"departure_time" : "11:23:02" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "11:26:46" , 
"departure_time" : "11:27:30" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "11:29:44" , 
"departure_time" : "11:31:22" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "11:32:38" , 
"departure_time" : "11:33:53" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "11:35:15" , 
"departure_time" : "11:35:15" , 
"distance_traveled" : 33.5915
} ], 
"4993" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "10:57:00" , 
"departure_time" : "10:58:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "10:59:44" , 
"departure_time" : "11:01:02" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "11:02:18" , 
"departure_time" : "11:03:21" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "11:09:03" , 
"departure_time" : "11:10:22" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "11:14:19" , 
"departure_time" : "11:14:36" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "11:16:17" , 
"departure_time" : "11:16:56" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "11:21:39" , 
"departure_time" : "11:22:27" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "11:23:48" , 
"departure_time" : "11:24:58" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "11:28:10" , 
"departure_time" : "11:28:43" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "11:31:33" , 
"departure_time" : "11:32:21" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "11:33:48" , 
"departure_time" : "11:35:14" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "11:39:26" , 
"departure_time" : "11:39:52" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "11:40:26" , 
"departure_time" : "11:42:02" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "11:43:36" , 
"departure_time" : "11:43:47" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "11:45:11" , 
"departure_time" : "11:45:47" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "11:47:36" , 
"departure_time" : "11:48:01" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "11:51:25" , 
"departure_time" : "11:51:28" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "11:56:03" , 
"departure_time" : "11:56:33" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "11:59:30" , 
"departure_time" : "12:00:05" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "12:01:35" , 
"departure_time" : "12:02:13" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "12:04:38" , 
"departure_time" : "12:04:38" , 
"distance_traveled" : 33.5915
} ], 
"4994" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "11:27:00" , 
"departure_time" : "11:28:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "11:30:00" , 
"departure_time" : "11:31:36" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "11:32:36" , 
"departure_time" : "11:32:39" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "11:38:03" , 
"departure_time" : "11:39:36" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "11:44:33" , 
"departure_time" : "11:45:22" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "11:46:49" , 
"departure_time" : "11:47:22" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "11:51:33" , 
"departure_time" : "11:52:37" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "11:54:04" , 
"departure_time" : "11:55:07" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "11:58:03" , 
"departure_time" : "11:58:40" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "12:01:37" , 
"departure_time" : "12:02:16" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "12:03:39" , 
"departure_time" : "12:03:56" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "12:08:17" , 
"departure_time" : "12:08:19" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "12:10:02" , 
"departure_time" : "12:10:48" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "12:12:46" , 
"departure_time" : "12:13:41" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "12:15:55" , 
"departure_time" : "12:16:33" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "12:17:38" , 
"departure_time" : "12:18:53" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "12:22:15" , 
"departure_time" : "12:23:14" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "12:26:59" , 
"departure_time" : "12:28:25" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "12:30:26" , 
"departure_time" : "12:30:39" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "12:31:13" , 
"departure_time" : "12:31:31" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "12:34:18" , 
"departure_time" : "12:34:18" , 
"distance_traveled" : 33.5915
} ], 
"4995" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "11:57:00" , 
"departure_time" : "11:58:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "11:59:48" , 
"departure_time" : "12:00:54" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "12:02:06" , 
"departure_time" : "12:03:17" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "12:09:11" , 
"departure_time" : "12:09:16" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "12:13:05" , 
"departure_time" : "12:13:16" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "12:16:11" , 
"departure_time" : "12:16:37" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "12:21:26" , 
"departure_time" : "12:21:57" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "12:23:31" , 
"departure_time" : "12:23:35" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "12:27:04" , 
"departure_time" : "12:28:08" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "12:32:04" , 
"departure_time" : "12:33:33" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "12:34:29" , 
"departure_time" : "12:35:54" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "12:39:25" , 
"departure_time" : "12:39:54" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "12:40:29" , 
"departure_time" : "12:41:04" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "12:42:35" , 
"departure_time" : "12:44:10" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "12:46:35" , 
"departure_time" : "12:48:09" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "12:48:34" , 
"departure_time" : "12:49:21" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "12:51:47" , 
"departure_time" : "12:51:59" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "12:56:12" , 
"departure_time" : "12:57:10" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "12:59:58" , 
"departure_time" : "13:00:44" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "13:01:46" , 
"departure_time" : "13:02:21" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "13:04:35" , 
"departure_time" : "13:04:35" , 
"distance_traveled" : 33.5915
} ], 
"4996" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "12:27:00" , 
"departure_time" : "12:28:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "12:29:49" , 
"departure_time" : "12:29:57" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "12:31:08" , 
"departure_time" : "12:32:03" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "12:38:55" , 
"departure_time" : "12:40:07" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "12:44:12" , 
"departure_time" : "12:44:29" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "12:46:17" , 
"departure_time" : "12:47:57" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "12:52:40" , 
"departure_time" : "12:54:13" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "12:54:33" , 
"departure_time" : "12:55:57" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "12:58:24" , 
"departure_time" : "12:59:57" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "13:02:33" , 
"departure_time" : "13:03:24" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "13:03:51" , 
"departure_time" : "13:04:41" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "13:08:50" , 
"departure_time" : "13:09:27" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "13:10:37" , 
"departure_time" : "13:11:50" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "13:13:13" , 
"departure_time" : "13:14:07" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "13:15:54" , 
"departure_time" : "13:16:56" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "13:18:02" , 
"departure_time" : "13:19:16" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "13:22:14" , 
"departure_time" : "13:23:00" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "13:26:46" , 
"departure_time" : "13:27:29" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "13:29:43" , 
"departure_time" : "13:31:19" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "13:32:36" , 
"departure_time" : "13:34:11" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "13:35:35" , 
"departure_time" : "13:35:35" , 
"distance_traveled" : 33.5915
} ], 
"4997" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "12:57:00" , 
"departure_time" : "13:00:05" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "13:00:30" , 
"departure_time" : "13:00:34" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "13:01:04" , 
"departure_time" : "13:02:15" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "13:09:11" , 
"departure_time" : "13:10:02" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "13:13:51" , 
"departure_time" : "13:14:58" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "13:17:07" , 
"departure_time" : "13:18:44" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "13:22:37" , 
"departure_time" : "13:22:48" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "13:23:11" , 
"departure_time" : "13:23:13" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "13:27:02" , 
"departure_time" : "13:27:14" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "13:31:12" , 
"departure_time" : "13:32:07" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "13:33:55" , 
"departure_time" : "13:35:13" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "13:39:18" , 
"departure_time" : "13:40:00" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "13:40:42" , 
"departure_time" : "13:41:29" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "13:42:47" , 
"departure_time" : "13:44:09" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "13:46:22" , 
"departure_time" : "13:46:34" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "13:47:12" , 
"departure_time" : "13:48:07" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "13:51:55" , 
"departure_time" : "13:52:33" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "13:56:38" , 
"departure_time" : "13:57:28" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "13:59:50" , 
"departure_time" : "14:00:41" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "14:01:51" , 
"departure_time" : "14:02:06" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "14:04:15" , 
"departure_time" : "14:04:15" , 
"distance_traveled" : 33.5915
} ], 
"4998" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "13:27:00" , 
"departure_time" : "13:28:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "13:30:28" , 
"departure_time" : "13:30:58" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "13:31:30" , 
"departure_time" : "13:32:39" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "13:39:09" , 
"departure_time" : "13:40:16" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "13:44:07" , 
"departure_time" : "13:44:17" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "13:46:10" , 
"departure_time" : "13:47:33" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "13:52:23" , 
"departure_time" : "13:53:49" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "13:54:26" , 
"departure_time" : "13:55:26" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "13:58:00" , 
"departure_time" : "13:59:12" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "14:02:12" , 
"departure_time" : "14:03:07" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "14:03:55" , 
"departure_time" : "14:04:10" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "14:08:15" , 
"departure_time" : "14:09:34" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "14:11:19" , 
"departure_time" : "14:11:54" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "14:12:35" , 
"departure_time" : "14:13:22" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "14:15:47" , 
"departure_time" : "14:16:44" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "14:17:57" , 
"departure_time" : "14:18:01" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "14:21:04" , 
"departure_time" : "14:22:08" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "14:27:04" , 
"departure_time" : "14:28:05" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "14:30:01" , 
"departure_time" : "14:30:53" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "14:31:52" , 
"departure_time" : "14:33:12" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "14:35:20" , 
"departure_time" : "14:35:20" , 
"distance_traveled" : 33.5915
} ], 
"4999" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "13:57:00" , 
"departure_time" : "13:58:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "13:59:27" , 
"departure_time" : "13:59:44" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "14:01:17" , 
"departure_time" : "14:01:23" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "14:08:06" , 
"departure_time" : "14:09:37" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "14:14:31" , 
"departure_time" : "14:15:39" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "14:17:08" , 
"departure_time" : "14:17:20" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "14:21:12" , 
"departure_time" : "14:22:29" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "14:24:17" , 
"departure_time" : "14:24:45" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "14:27:28" , 
"departure_time" : "14:28:31" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "14:32:03" , 
"departure_time" : "14:32:42" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "14:33:39" , 
"departure_time" : "14:34:51" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "14:39:12" , 
"departure_time" : "14:40:08" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "14:40:56" , 
"departure_time" : "14:42:13" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "14:43:17" , 
"departure_time" : "14:43:35" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "14:45:18" , 
"departure_time" : "14:46:20" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "14:48:02" , 
"departure_time" : "14:48:56" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "14:51:54" , 
"departure_time" : "14:52:07" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "14:56:13" , 
"departure_time" : "14:57:07" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "14:59:54" , 
"departure_time" : "15:00:31" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "15:01:37" , 
"departure_time" : "15:02:37" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "15:05:00" , 
"departure_time" : "15:05:00" , 
"distance_traveled" : 33.5915
} ], 
"5000" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "14:27:00" , 
"departure_time" : "14:28:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "14:29:57" , 
"departure_time" : "14:30:42" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "14:31:45" , 
"departure_time" : "14:32:39" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "14:38:54" , 
"departure_time" : "14:39:54" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "14:44:00" , 
"departure_time" : "14:45:12" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "14:47:12" , 
"departure_time" : "14:47:58" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "14:51:46" , 
"departure_time" : "14:53:09" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "14:54:23" , 
"departure_time" : "14:54:29" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "14:57:06" , 
"departure_time" : "14:57:52" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "15:01:46" , 
"departure_time" : "15:02:44" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "15:03:58" , 
"departure_time" : "15:05:31" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "15:09:33" , 
"departure_time" : "15:11:13" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "15:11:40" , 
"departure_time" : "15:12:58" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "15:13:18" , 
"departure_time" : "15:14:29" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "15:16:11" , 
"departure_time" : "15:16:17" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "15:17:06" , 
"departure_time" : "15:18:44" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "15:22:38" , 
"departure_time" : "15:23:59" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "15:27:21" , 
"departure_time" : "15:28:20" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "15:29:59" , 
"departure_time" : "15:30:58" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "15:31:59" , 
"departure_time" : "15:32:44" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "15:34:45" , 
"departure_time" : "15:34:45" , 
"distance_traveled" : 33.5915
} ], 
"5001" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "14:57:00" , 
"departure_time" : "14:59:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "15:00:34" , 
"departure_time" : "15:01:03" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "15:01:29" , 
"departure_time" : "15:02:52" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "15:09:23" , 
"departure_time" : "15:09:25" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "15:13:02" , 
"departure_time" : "15:14:19" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "15:17:17" , 
"departure_time" : "15:17:39" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "15:21:22" , 
"departure_time" : "15:22:02" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "15:23:40" , 
"departure_time" : "15:24:05" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "15:27:25" , 
"departure_time" : "15:27:37" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "15:31:12" , 
"departure_time" : "15:32:25" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "15:34:13" , 
"departure_time" : "15:35:07" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "15:38:54" , 
"departure_time" : "15:39:24" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "15:40:30" , 
"departure_time" : "15:40:54" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "15:42:24" , 
"departure_time" : "15:43:34" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "15:46:10" , 
"departure_time" : "15:46:59" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "15:47:49" , 
"departure_time" : "15:49:24" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "15:52:35" , 
"departure_time" : "15:52:52" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "15:56:17" , 
"departure_time" : "15:56:54" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "15:59:37" , 
"departure_time" : "16:01:08" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "16:02:31" , 
"departure_time" : "16:03:44" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "16:05:13" , 
"departure_time" : "16:05:13" , 
"distance_traveled" : 33.5915
} ], 
"5002" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "15:27:00" , 
"departure_time" : "15:29:19" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "15:30:06" , 
"departure_time" : "15:30:22" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "15:31:16" , 
"departure_time" : "15:31:18" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "15:38:02" , 
"departure_time" : "15:39:39" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "15:44:37" , 
"departure_time" : "15:45:58" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "15:47:21" , 
"departure_time" : "15:47:40" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "15:51:19" , 
"departure_time" : "15:52:06" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "15:53:47" , 
"departure_time" : "15:53:56" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "15:57:09" , 
"departure_time" : "15:57:54" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "16:01:45" , 
"departure_time" : "16:03:08" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "16:04:23" , 
"departure_time" : "16:05:20" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "16:08:57" , 
"departure_time" : "16:09:42" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "16:10:45" , 
"departure_time" : "16:12:16" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "16:13:31" , 
"departure_time" : "16:14:41" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "16:16:10" , 
"departure_time" : "16:17:15" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "16:18:05" , 
"departure_time" : "16:18:41" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "16:21:36" , 
"departure_time" : "16:23:16" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "16:27:40" , 
"departure_time" : "16:29:06" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "16:30:26" , 
"departure_time" : "16:31:17" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "16:31:51" , 
"departure_time" : "16:32:04" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "16:34:13" , 
"departure_time" : "16:34:13" , 
"distance_traveled" : 33.5915
} ], 
"5003" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "15:42:00" , 
"departure_time" : "15:42:22" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "15:44:09" , 
"departure_time" : "15:44:15" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "15:46:06" , 
"departure_time" : "15:46:44" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "15:53:38" , 
"departure_time" : "15:53:47" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "15:58:09" , 
"departure_time" : "15:58:49" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "16:01:40" , 
"departure_time" : "16:02:47" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "16:07:07" , 
"departure_time" : "16:07:31" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "16:08:24" , 
"departure_time" : "16:09:40" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "16:13:16" , 
"departure_time" : "16:14:54" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "16:17:38" , 
"departure_time" : "16:18:08" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "16:18:30" , 
"departure_time" : "16:18:58" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "16:23:28" , 
"departure_time" : "16:24:44" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "16:26:16" , 
"departure_time" : "16:27:20" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "16:28:04" , 
"departure_time" : "16:28:33" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "16:30:29" , 
"departure_time" : "16:31:17" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "16:32:48" , 
"departure_time" : "16:34:25" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "16:37:37" , 
"departure_time" : "16:38:20" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "16:41:43" , 
"departure_time" : "16:42:57" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "16:45:14" , 
"departure_time" : "16:46:01" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "16:46:47" , 
"departure_time" : "16:47:40" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "16:49:53" , 
"departure_time" : "16:49:53" , 
"distance_traveled" : 33.5915
} ], 
"5004" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "15:57:00" , 
"departure_time" : "15:57:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "15:59:01" , 
"departure_time" : "16:00:32" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "16:02:31" , 
"departure_time" : "16:03:01" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "16:08:30" , 
"departure_time" : "16:09:47" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "16:14:17" , 
"departure_time" : "16:15:40" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "16:17:23" , 
"departure_time" : "16:18:24" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "16:22:01" , 
"departure_time" : "16:23:38" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "16:24:37" , 
"departure_time" : "16:26:08" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "16:28:31" , 
"departure_time" : "16:29:01" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "16:31:30" , 
"departure_time" : "16:32:27" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "16:33:57" , 
"departure_time" : "16:35:15" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "16:39:18" , 
"departure_time" : "16:40:50" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "16:41:32" , 
"departure_time" : "16:42:12" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "16:42:40" , 
"departure_time" : "16:44:20" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "16:46:40" , 
"departure_time" : "16:47:00" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "16:47:20" , 
"departure_time" : "16:48:03" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "16:51:43" , 
"departure_time" : "16:52:48" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "16:57:05" , 
"departure_time" : "16:58:31" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "17:00:26" , 
"departure_time" : "17:02:04" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "17:02:38" , 
"departure_time" : "17:02:50" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "17:04:12" , 
"departure_time" : "17:04:12" , 
"distance_traveled" : 33.5915
} ], 
"5005" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "16:12:00" , 
"departure_time" : "16:12:25" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "16:14:13" , 
"departure_time" : "16:15:49" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "16:17:36" , 
"departure_time" : "16:18:38" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "16:24:02" , 
"departure_time" : "16:25:03" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "16:29:01" , 
"departure_time" : "16:29:41" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "16:31:40" , 
"departure_time" : "16:33:11" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "16:37:31" , 
"departure_time" : "16:38:20" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "16:38:49" , 
"departure_time" : "16:39:34" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "16:42:45" , 
"departure_time" : "16:44:19" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "16:47:34" , 
"departure_time" : "16:47:59" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "16:48:25" , 
"departure_time" : "16:49:59" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "16:54:34" , 
"departure_time" : "16:56:11" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "16:56:37" , 
"departure_time" : "16:57:10" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "16:57:33" , 
"departure_time" : "16:57:50" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "17:00:17" , 
"departure_time" : "17:00:46" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "17:02:29" , 
"departure_time" : "17:02:48" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "17:06:19" , 
"departure_time" : "17:07:55" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "17:12:36" , 
"departure_time" : "17:13:26" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "17:14:50" , 
"departure_time" : "17:15:29" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "17:16:39" , 
"departure_time" : "17:16:51" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "17:19:12" , 
"departure_time" : "17:19:12" , 
"distance_traveled" : 33.5915
} ], 
"5006" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "16:27:00" , 
"departure_time" : "16:28:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "16:30:30" , 
"departure_time" : "16:30:39" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "16:31:09" , 
"departure_time" : "16:31:23" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "16:38:14" , 
"departure_time" : "16:39:07" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "16:43:53" , 
"departure_time" : "16:44:17" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "16:46:24" , 
"departure_time" : "16:48:04" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "16:52:40" , 
"departure_time" : "16:52:51" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "16:53:11" , 
"departure_time" : "16:54:45" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "16:58:34" , 
"departure_time" : "16:58:54" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "17:01:20" , 
"departure_time" : "17:02:55" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "17:04:35" , 
"departure_time" : "17:05:14" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "17:08:39" , 
"departure_time" : "17:08:58" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "17:10:19" , 
"departure_time" : "17:10:21" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "17:12:02" , 
"departure_time" : "17:13:27" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "17:16:25" , 
"departure_time" : "17:17:19" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "17:17:54" , 
"departure_time" : "17:18:53" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "17:21:59" , 
"departure_time" : "17:22:13" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "17:26:14" , 
"departure_time" : "17:27:39" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "17:30:25" , 
"departure_time" : "17:32:04" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "17:32:39" , 
"departure_time" : "17:34:19" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "17:35:40" , 
"departure_time" : "17:35:40" , 
"distance_traveled" : 33.5915
} ], 
"5007" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "16:42:00" , 
"departure_time" : "16:43:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "16:44:15" , 
"departure_time" : "16:44:23" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "16:46:08" , 
"departure_time" : "16:47:42" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "16:54:34" , 
"departure_time" : "16:54:40" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "16:58:06" , 
"departure_time" : "16:59:27" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "17:02:21" , 
"departure_time" : "17:02:27" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "17:06:06" , 
"departure_time" : "17:07:17" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "17:09:11" , 
"departure_time" : "17:09:43" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "17:12:32" , 
"departure_time" : "17:14:06" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "17:17:34" , 
"departure_time" : "17:17:54" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "17:18:20" , 
"departure_time" : "17:19:41" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "17:24:21" , 
"departure_time" : "17:24:56" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "17:25:35" , 
"departure_time" : "17:26:18" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "17:27:43" , 
"departure_time" : "17:28:59" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "17:31:16" , 
"departure_time" : "17:32:03" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "17:32:47" , 
"departure_time" : "17:34:01" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "17:37:14" , 
"departure_time" : "17:37:28" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "17:41:14" , 
"departure_time" : "17:41:51" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "17:44:37" , 
"departure_time" : "17:44:52" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "17:46:15" , 
"departure_time" : "17:46:26" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "17:49:11" , 
"departure_time" : "17:49:11" , 
"distance_traveled" : 33.5915
} ], 
"5008" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "16:57:00" , 
"departure_time" : "16:58:43" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "17:00:32" , 
"departure_time" : "17:02:02" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "17:02:30" , 
"departure_time" : "17:02:45" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "17:08:15" , 
"departure_time" : "17:09:37" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "17:14:22" , 
"departure_time" : "17:15:01" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "17:16:39" , 
"departure_time" : "17:18:13" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "17:22:34" , 
"departure_time" : "17:23:38" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "17:24:04" , 
"departure_time" : "17:24:55" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "17:27:51" , 
"departure_time" : "17:27:53" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "17:31:02" , 
"departure_time" : "17:32:33" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "17:34:31" , 
"departure_time" : "17:35:53" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "17:39:22" , 
"departure_time" : "17:39:34" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "17:40:12" , 
"departure_time" : "17:40:18" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "17:42:06" , 
"departure_time" : "17:42:26" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "17:45:20" , 
"departure_time" : "17:46:57" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "17:48:37" , 
"departure_time" : "17:49:02" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "17:51:25" , 
"departure_time" : "17:52:37" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "17:57:12" , 
"departure_time" : "17:57:25" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "17:59:13" , 
"departure_time" : "17:59:21" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "18:01:08" , 
"departure_time" : "18:02:41" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "18:05:33" , 
"departure_time" : "18:05:33" , 
"distance_traveled" : 33.5915
} ], 
"5009" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "17:12:00" , 
"departure_time" : "17:15:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "17:15:34" , 
"departure_time" : "17:15:59" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "17:16:25" , 
"departure_time" : "17:17:39" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "17:24:14" , 
"departure_time" : "17:25:36" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "17:29:22" , 
"departure_time" : "17:30:30" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "17:32:08" , 
"departure_time" : "17:32:54" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "17:36:46" , 
"departure_time" : "17:37:11" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "17:38:25" , 
"departure_time" : "17:39:28" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "17:43:03" , 
"departure_time" : "17:43:40" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "17:46:37" , 
"departure_time" : "17:47:49" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "17:49:12" , 
"departure_time" : "17:49:21" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "17:53:09" , 
"departure_time" : "17:54:05" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "17:55:56" , 
"departure_time" : "17:56:12" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "17:57:16" , 
"departure_time" : "17:57:49" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "18:00:33" , 
"departure_time" : "18:00:43" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "18:02:10" , 
"departure_time" : "18:02:17" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "18:06:07" , 
"departure_time" : "18:06:18" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "18:11:11" , 
"departure_time" : "18:11:23" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "18:14:12" , 
"departure_time" : "18:14:34" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "18:16:22" , 
"departure_time" : "18:17:53" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "18:20:31" , 
"departure_time" : "18:20:31" , 
"distance_traveled" : 33.5915
} ], 
"5010" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "17:27:00" , 
"departure_time" : "17:29:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "17:30:07" , 
"departure_time" : "17:31:29" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "17:32:22" , 
"departure_time" : "17:32:30" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "17:38:08" , 
"departure_time" : "17:39:07" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "17:43:59" , 
"departure_time" : "17:44:31" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "17:46:32" , 
"departure_time" : "17:47:00" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "17:51:28" , 
"departure_time" : "17:52:29" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "17:54:01" , 
"departure_time" : "17:54:52" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "17:57:51" , 
"departure_time" : "17:58:44" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "18:01:53" , 
"departure_time" : "18:02:41" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "18:03:48" , 
"departure_time" : "18:04:09" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "18:08:21" , 
"departure_time" : "18:08:31" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "18:10:10" , 
"departure_time" : "18:11:18" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "18:13:08" , 
"departure_time" : "18:13:39" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "18:15:31" , 
"departure_time" : "18:15:50" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "18:17:19" , 
"departure_time" : "18:17:58" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "18:21:39" , 
"departure_time" : "18:22:07" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "18:26:28" , 
"departure_time" : "18:27:00" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "18:29:32" , 
"departure_time" : "18:31:12" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "18:32:40" , 
"departure_time" : "18:33:11" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "18:34:31" , 
"departure_time" : "18:34:31" , 
"distance_traveled" : 33.5915
} ], 
"5011" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "17:42:00" , 
"departure_time" : "17:43:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "17:44:40" , 
"departure_time" : "17:45:25" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "17:46:45" , 
"departure_time" : "17:47:16" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "17:53:31" , 
"departure_time" : "17:53:36" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "17:58:05" , 
"departure_time" : "17:59:33" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "18:02:28" , 
"departure_time" : "18:03:40" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "18:07:12" , 
"departure_time" : "18:07:27" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "18:08:15" , 
"departure_time" : "18:09:01" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "18:12:46" , 
"departure_time" : "18:14:04" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "18:17:18" , 
"departure_time" : "18:18:41" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "18:19:23" , 
"departure_time" : "18:19:48" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "18:23:25" , 
"departure_time" : "18:23:34" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "18:25:09" , 
"departure_time" : "18:25:47" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "18:27:38" , 
"departure_time" : "18:29:18" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "18:31:40" , 
"departure_time" : "18:33:14" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "18:33:34" , 
"departure_time" : "18:34:51" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "18:37:17" , 
"departure_time" : "18:38:51" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "18:42:34" , 
"departure_time" : "18:42:41" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "18:44:07" , 
"departure_time" : "18:44:16" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "18:46:09" , 
"departure_time" : "18:46:39" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "18:49:30" , 
"departure_time" : "18:49:30" , 
"distance_traveled" : 33.5915
} ], 
"5012" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "17:57:00" , 
"departure_time" : "17:58:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "17:59:40" , 
"departure_time" : "17:59:52" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "18:01:12" , 
"departure_time" : "18:02:03" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "18:08:51" , 
"departure_time" : "18:09:17" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "18:13:26" , 
"departure_time" : "18:13:33" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "18:16:07" , 
"departure_time" : "18:17:12" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "18:22:05" , 
"departure_time" : "18:22:28" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "18:23:23" , 
"departure_time" : "18:24:24" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "18:28:01" , 
"departure_time" : "18:28:08" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "18:31:07" , 
"departure_time" : "18:32:03" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "18:33:56" , 
"departure_time" : "18:35:17" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "18:39:21" , 
"departure_time" : "18:40:39" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "18:41:18" , 
"departure_time" : "18:42:18" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "18:43:00" , 
"departure_time" : "18:44:19" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "18:46:19" , 
"departure_time" : "18:46:40" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "18:47:21" , 
"departure_time" : "18:48:56" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "18:52:35" , 
"departure_time" : "18:53:42" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "18:57:07" , 
"departure_time" : "18:57:40" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "18:59:33" , 
"departure_time" : "19:01:01" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "19:02:28" , 
"departure_time" : "19:04:01" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "19:05:33" , 
"departure_time" : "19:05:33" , 
"distance_traveled" : 33.5915
} ], 
"5013" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "18:12:00" , 
"departure_time" : "18:14:06" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "18:14:33" , 
"departure_time" : "18:14:54" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "18:16:21" , 
"departure_time" : "18:18:00" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "18:24:39" , 
"departure_time" : "18:24:40" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "18:28:01" , 
"departure_time" : "18:28:12" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "18:31:11" , 
"departure_time" : "18:31:21" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "18:36:10" , 
"departure_time" : "18:36:34" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "18:38:24" , 
"departure_time" : "18:39:57" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "18:43:33" , 
"departure_time" : "18:43:57" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "18:46:24" , 
"departure_time" : "18:46:40" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "18:48:16" , 
"departure_time" : "18:49:22" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "18:54:06" , 
"departure_time" : "18:54:36" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "18:55:30" , 
"departure_time" : "18:56:04" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "18:57:34" , 
"departure_time" : "18:57:45" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "19:00:11" , 
"departure_time" : "19:01:31" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "19:03:20" , 
"departure_time" : "19:04:46" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "19:07:26" , 
"departure_time" : "19:08:21" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "19:11:55" , 
"departure_time" : "19:13:33" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "19:15:38" , 
"departure_time" : "19:16:38" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "19:17:00" , 
"departure_time" : "19:18:25" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "19:20:25" , 
"departure_time" : "19:20:25" , 
"distance_traveled" : 33.5915
} ], 
"5014" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "18:27:00" , 
"departure_time" : "18:29:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "18:30:14" , 
"departure_time" : "18:31:30" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "18:32:16" , 
"departure_time" : "18:32:49" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "18:38:33" , 
"departure_time" : "18:40:01" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "18:44:28" , 
"departure_time" : "18:44:35" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "18:46:07" , 
"departure_time" : "18:46:37" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "18:51:30" , 
"departure_time" : "18:52:54" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "18:54:24" , 
"departure_time" : "18:55:04" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "18:57:40" , 
"departure_time" : "18:59:13" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "19:02:33" , 
"departure_time" : "19:03:14" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "19:03:41" , 
"departure_time" : "19:05:14" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "19:09:33" , 
"departure_time" : "19:10:05" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "19:10:32" , 
"departure_time" : "19:10:38" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "19:12:06" , 
"departure_time" : "19:12:49" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "19:15:43" , 
"departure_time" : "19:16:22" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "19:17:39" , 
"departure_time" : "19:18:03" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "19:21:24" , 
"departure_time" : "19:22:37" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "19:27:13" , 
"departure_time" : "19:28:10" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "19:29:57" , 
"departure_time" : "19:31:16" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "19:32:19" , 
"departure_time" : "19:33:39" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "19:35:20" , 
"departure_time" : "19:35:20" , 
"distance_traveled" : 33.5915
} ], 
"5015" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "18:42:00" , 
"departure_time" : "18:44:50" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "18:45:30" , 
"departure_time" : "18:46:34" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "18:47:04" , 
"departure_time" : "18:47:05" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "18:53:01" , 
"departure_time" : "18:54:19" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "18:59:18" , 
"departure_time" : "19:00:07" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "19:01:49" , 
"departure_time" : "19:03:09" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "19:07:20" , 
"departure_time" : "19:08:09" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "19:08:49" , 
"departure_time" : "19:10:04" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "19:13:15" , 
"departure_time" : "19:14:38" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "19:17:23" , 
"departure_time" : "19:18:39" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "19:19:16" , 
"departure_time" : "19:20:20" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "19:24:04" , 
"departure_time" : "19:25:33" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "19:26:29" , 
"departure_time" : "19:27:47" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "19:28:18" , 
"departure_time" : "19:29:56" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "19:31:38" , 
"departure_time" : "19:32:51" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "19:33:13" , 
"departure_time" : "19:34:23" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "19:37:10" , 
"departure_time" : "19:37:19" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "19:41:09" , 
"departure_time" : "19:42:46" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "19:45:37" , 
"departure_time" : "19:46:27" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "19:46:50" , 
"departure_time" : "19:47:31" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "19:49:41" , 
"departure_time" : "19:49:41" , 
"distance_traveled" : 33.5915
} ], 
"5016" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "18:57:00" , 
"departure_time" : "18:58:31" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "18:59:50" , 
"departure_time" : "19:00:09" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "19:01:19" , 
"departure_time" : "19:01:25" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "19:08:06" , 
"departure_time" : "19:09:10" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "19:14:04" , 
"departure_time" : "19:15:27" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "19:17:23" , 
"departure_time" : "19:17:45" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "19:21:22" , 
"departure_time" : "19:22:26" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "19:24:04" , 
"departure_time" : "19:25:44" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "19:28:40" , 
"departure_time" : "19:28:48" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "19:31:08" , 
"departure_time" : "19:31:48" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "19:33:40" , 
"departure_time" : "19:34:30" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "19:38:50" , 
"departure_time" : "19:39:31" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "19:40:41" , 
"departure_time" : "19:42:20" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "19:43:39" , 
"departure_time" : "19:44:26" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "19:45:47" , 
"departure_time" : "19:46:33" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "19:47:46" , 
"departure_time" : "19:49:17" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "19:52:31" , 
"departure_time" : "19:54:02" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "19:57:31" , 
"departure_time" : "19:57:51" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "19:59:20" , 
"departure_time" : "19:59:42" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "20:01:22" , 
"departure_time" : "20:02:44" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "20:05:22" , 
"departure_time" : "20:05:22" , 
"distance_traveled" : 33.5915
} ], 
"5017" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "19:27:00" , 
"departure_time" : "19:28:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "19:29:14" , 
"departure_time" : "19:30:53" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "19:32:39" , 
"departure_time" : "19:32:53" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "19:38:14" , 
"departure_time" : "19:39:41" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "19:44:27" , 
"departure_time" : "19:45:15" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "19:46:48" , 
"departure_time" : "19:47:10" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "19:51:22" , 
"departure_time" : "19:51:55" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "19:53:33" , 
"departure_time" : "19:55:07" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "19:58:34" , 
"departure_time" : "19:59:58" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "20:02:24" , 
"departure_time" : "20:03:10" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "20:03:46" , 
"departure_time" : "20:04:52" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "20:09:06" , 
"departure_time" : "20:09:21" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "20:10:15" , 
"departure_time" : "20:11:28" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "20:13:13" , 
"departure_time" : "20:13:38" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "20:15:25" , 
"departure_time" : "20:15:28" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "20:17:03" , 
"departure_time" : "20:17:32" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "20:21:29" , 
"departure_time" : "20:22:08" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "20:26:39" , 
"departure_time" : "20:27:57" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "20:30:18" , 
"departure_time" : "20:31:18" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "20:32:00" , 
"departure_time" : "20:32:17" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "20:34:17" , 
"departure_time" : "20:34:17" , 
"distance_traveled" : 33.5915
} ], 
"5018" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "19:57:00" , 
"departure_time" : "19:58:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "20:00:40" , 
"departure_time" : "20:01:09" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "20:01:29" , 
"departure_time" : "20:03:09" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "20:09:40" , 
"departure_time" : "20:10:00" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "20:13:20" , 
"departure_time" : "20:14:47" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "20:17:27" , 
"departure_time" : "20:18:26" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "20:21:59" , 
"departure_time" : "20:22:11" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "20:23:12" , 
"departure_time" : "20:23:49" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "20:27:37" , 
"departure_time" : "20:27:54" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "20:31:17" , 
"departure_time" : "20:31:52" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "20:33:35" , 
"departure_time" : "20:34:07" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "20:38:32" , 
"departure_time" : "20:38:44" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "20:40:12" , 
"departure_time" : "20:41:36" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "20:43:24" , 
"departure_time" : "20:44:23" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "20:45:59" , 
"departure_time" : "20:46:06" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "20:47:07" , 
"departure_time" : "20:47:20" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "20:51:13" , 
"departure_time" : "20:52:48" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "20:57:35" , 
"departure_time" : "20:58:16" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "20:59:41" , 
"departure_time" : "21:00:53" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "21:02:12" , 
"departure_time" : "21:02:33" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "21:04:21" , 
"departure_time" : "21:04:21" , 
"distance_traveled" : 33.5915
} ], 
"5019" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "20:27:00" , 
"departure_time" : "20:27:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "20:29:32" , 
"departure_time" : "20:30:53" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "20:32:21" , 
"departure_time" : "20:33:04" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "20:38:43" , 
"departure_time" : "20:38:44" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "20:43:01" , 
"departure_time" : "20:43:45" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "20:46:44" , 
"departure_time" : "20:46:57" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "20:51:13" , 
"departure_time" : "20:51:50" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "20:53:37" , 
"departure_time" : "20:55:06" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "20:58:29" , 
"departure_time" : "20:59:05" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "21:01:36" , 
"departure_time" : "21:02:47" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "21:04:11" , 
"departure_time" : "21:05:26" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "21:09:15" , 
"departure_time" : "21:10:19" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "21:11:04" , 
"departure_time" : "21:12:28" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "21:13:24" , 
"departure_time" : "21:13:56" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "21:15:32" , 
"departure_time" : "21:16:58" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "21:18:26" , 
"departure_time" : "21:18:34" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "21:21:08" , 
"departure_time" : "21:21:14" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "21:26:06" , 
"departure_time" : "21:26:24" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "21:29:18" , 
"departure_time" : "21:29:26" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "21:31:08" , 
"departure_time" : "21:32:26" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "21:35:18" , 
"departure_time" : "21:35:18" , 
"distance_traveled" : 33.5915
} ], 
"5020" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "21:00:00" , 
"departure_time" : "21:02:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "21:03:36" , 
"departure_time" : "21:03:45" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "21:04:09" , 
"departure_time" : "21:05:46" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "21:12:37" , 
"departure_time" : "21:14:11" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "21:17:34" , 
"departure_time" : "21:18:55" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "21:20:21" , 
"departure_time" : "21:21:03" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "21:24:42" , 
"departure_time" : "21:25:56" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "21:27:14" , 
"departure_time" : "21:27:53" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "21:30:39" , 
"departure_time" : "21:32:05" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "21:35:26" , 
"departure_time" : "21:36:19" , 
"distance_traveled" : 20.5396
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "21:36:53" , 
"departure_time" : "21:37:13" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "21:41:20" , 
"departure_time" : "21:42:18" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "21:43:58" , 
"departure_time" : "21:44:42" , 
"distance_traveled" : 24.8521
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "21:45:44" , 
"departure_time" : "21:45:55" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "21:48:11" , 
"departure_time" : "21:49:00" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "21:50:49" , 
"departure_time" : "21:51:17" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "21:54:28" , 
"departure_time" : "21:55:37" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "22:00:09" , 
"departure_time" : "22:01:13" , 
"distance_traveled" : 32.4451
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "22:03:04" , 
"departure_time" : "22:03:06" , 
"distance_traveled" : 32.8699
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "22:04:02" , 
"departure_time" : "22:04:25" , 
"distance_traveled" : 33.2506
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "22:07:23" , 
"departure_time" : "22:07:23" , 
"distance_traveled" : 33.5915
} ], 
"5021" :  [ 
{ 
"stop_id" : 38297,
"arrival_time" : "05:59:00" , 
"departure_time" : "05:59:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "06:01:15" , 
"departure_time" : "06:01:58" , 
"distance_traveled" : 0.5407
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "06:04:43" , 
"departure_time" : "06:05:07" , 
"distance_traveled" : 3.1527
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "06:07:24" , 
"departure_time" : "06:07:44" , 
"distance_traveled" : 5.2366
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "06:09:20" , 
"departure_time" : "06:09:23" , 
"distance_traveled" : 6.0015
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "06:13:03" , 
"departure_time" : "06:13:36" , 
"distance_traveled" : 8.6754
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "06:15:33" , 
"departure_time" : "06:17:13" , 
"distance_traveled" : 9.5491
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "06:18:40" , 
"departure_time" : "06:19:22" , 
"distance_traveled" : 10.036
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "06:19:42" , 
"departure_time" : "06:20:44" , 
"distance_traveled" : 11.3208
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "06:22:02" , 
"departure_time" : "06:22:39" , 
"distance_traveled" : 12.9491
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "06:25:37" , 
"departure_time" : "06:26:33" , 
"distance_traveled" : 14.5047
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "06:30:56" , 
"departure_time" : "06:32:14" , 
"distance_traveled" : 17.142
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "06:34:18" , 
"departure_time" : "06:35:40" , 
"distance_traveled" : 17.5669
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "06:36:22" , 
"departure_time" : "06:37:01" , 
"distance_traveled" : 17.9475
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "06:38:39" , 
"departure_time" : "06:38:39" , 
"distance_traveled" : 18.2884
} ], 
"5022" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "21:15:00" , 
"departure_time" : "21:16:20" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "21:24:41" , 
"departure_time" : "21:26:05" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "21:32:24" , 
"departure_time" : "21:33:15" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "21:36:51" , 
"departure_time" : "21:36:54" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "21:38:03" , 
"departure_time" : "21:39:35" , 
"distance_traveled" : 15.8438
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "21:43:32" , 
"departure_time" : "21:44:54" , 
"distance_traveled" : 18.4557
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "21:47:22" , 
"departure_time" : "21:48:59" , 
"distance_traveled" : 21.3045
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "21:52:37" , 
"departure_time" : "21:53:19" , 
"distance_traveled" : 23.9784
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "21:54:42" , 
"departure_time" : "21:55:43" , 
"distance_traveled" : 25.339
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "21:58:01" , 
"departure_time" : "21:59:31" , 
"distance_traveled" : 26.6239
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "22:00:30" , 
"departure_time" : "22:01:04" , 
"distance_traveled" : 28.2521
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "22:03:34" , 
"departure_time" : "22:03:58" , 
"distance_traveled" : 29.8078
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "22:08:24" , 
"departure_time" : "22:08:24" , 
"distance_traveled" : 32.4451
} ], 
"5023" :  [ 
{ 
"stop_id" : 38291,
"arrival_time" : "21:28:00" , 
"departure_time" : "21:29:41" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "21:31:17" , 
"departure_time" : "21:31:26" , 
"distance_traveled" : 0.4879
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "21:32:09" , 
"departure_time" : "21:33:28" , 
"distance_traveled" : 0.95
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "21:40:19" , 
"departure_time" : "21:40:54" , 
"distance_traveled" : 5.9795
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "21:44:35" , 
"departure_time" : "21:45:47" , 
"distance_traveled" : 9.8265
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "21:48:12" , 
"departure_time" : "21:49:11" , 
"distance_traveled" : 12.0066
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "21:52:59" , 
"departure_time" : "21:53:29" , 
"distance_traveled" : 15.3042
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "21:55:30" , 
"departure_time" : "21:55:30" , 
"distance_traveled" : 15.8438
} ], 
"5024" :  [ 
{ 
"stop_id" : 38306,
"arrival_time" : "05:27:00" , 
"departure_time" : "05:28:46" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "05:33:16" , 
"departure_time" : "05:33:59" , 
"distance_traveled" : 2.6407
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "05:35:43" , 
"departure_time" : "05:37:23" , 
"distance_traveled" : 3.0655
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "05:38:40" , 
"departure_time" : "05:39:00" , 
"distance_traveled" : 3.4462
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "05:39:20" , 
"departure_time" : "05:39:20" , 
"distance_traveled" : 3.7871
} ], 
"5025" :  [ 
{ 
"stop_id" : 38306,
"arrival_time" : "05:40:00" , 
"departure_time" : "05:40:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "05:45:22" , 
"departure_time" : "05:45:48" , 
"distance_traveled" : 2.6407
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "05:48:26" , 
"departure_time" : "05:50:06" , 
"distance_traveled" : 3.0655
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "05:51:40" , 
"departure_time" : "05:52:46" , 
"distance_traveled" : 3.4462
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "05:53:06" , 
"departure_time" : "05:53:06" , 
"distance_traveled" : 3.7871
} ], 
"5026" :  [ 
{ 
"stop_id" : 38306,
"arrival_time" : "05:55:00" , 
"departure_time" : "05:57:32" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "06:01:26" , 
"departure_time" : "06:02:25" , 
"distance_traveled" : 2.6407
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "06:03:59" , 
"departure_time" : "06:04:33" , 
"distance_traveled" : 3.0655
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "06:05:34" , 
"departure_time" : "06:07:00" , 
"distance_traveled" : 3.4462
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "06:08:26" , 
"departure_time" : "06:08:26" , 
"distance_traveled" : 3.7871
} ], 
"5027" :  [ 
{ 
"stop_id" : 38306,
"arrival_time" : "06:10:00" , 
"departure_time" : "06:11:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "06:15:25" , 
"departure_time" : "06:16:08" , 
"distance_traveled" : 2.6407
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "06:18:43" , 
"departure_time" : "06:20:12" , 
"distance_traveled" : 3.0655
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "06:21:29" , 
"departure_time" : "06:21:57" , 
"distance_traveled" : 3.4462
}, 
{ 
"stop_id" : 38310,
"arrival_time" : "06:22:28" , 
"departure_time" : "06:22:28" , 
"distance_traveled" : 3.7871
} ], 
"5028" :  [ 
{ 
"stop_id" : 38305,
"arrival_time" : "05:30:00" , 
"departure_time" : "05:30:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "05:32:31" , 
"departure_time" : "05:33:30" , 
"distance_traveled" : 1.6337
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "05:36:59" , 
"departure_time" : "05:37:59" , 
"distance_traveled" : 3.1894
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "05:42:00" , 
"departure_time" : "05:42:00" , 
"distance_traveled" : 5.8267
} ], 
"5029" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "06:00:00" , 
"departure_time" : "06:01:53" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "06:02:53" , 
"departure_time" : "06:04:07" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "06:05:14" , 
"departure_time" : "06:06:41" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "06:09:27" , 
"departure_time" : "06:10:19" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "06:13:52" , 
"departure_time" : "06:15:18" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "06:16:26" , 
"departure_time" : "06:17:31" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "06:20:05" , 
"departure_time" : "06:20:26" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "06:21:21" , 
"departure_time" : "06:22:54" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "06:23:33" , 
"departure_time" : "06:25:06" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "06:25:33" , 
"departure_time" : "06:26:36" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "06:29:03" , 
"departure_time" : "06:29:11" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "06:30:08" , 
"departure_time" : "06:30:32" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "06:34:24" , 
"departure_time" : "06:34:47" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "06:38:23" , 
"departure_time" : "06:40:03" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "06:41:40" , 
"departure_time" : "06:42:29" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "06:46:49" , 
"departure_time" : "06:47:46" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "06:49:57" , 
"departure_time" : "06:50:04" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "06:54:07" , 
"departure_time" : "06:54:42" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "07:00:35" , 
"departure_time" : "07:01:52" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "07:03:17" , 
"departure_time" : "07:04:36" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "07:06:19" , 
"departure_time" : "07:06:19" , 
"distance_traveled" : 33.5428
} ], 
"5030" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "06:13:00" , 
"departure_time" : "06:14:29" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "06:15:10" , 
"departure_time" : "06:16:36" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "06:18:26" , 
"departure_time" : "06:19:54" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "06:22:28" , 
"departure_time" : "06:23:17" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "06:26:49" , 
"departure_time" : "06:28:04" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "06:29:15" , 
"departure_time" : "06:29:38" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "06:31:23" , 
"departure_time" : "06:31:26" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "06:34:03" , 
"departure_time" : "06:34:40" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "06:36:37" , 
"departure_time" : "06:36:56" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "06:38:19" , 
"departure_time" : "06:38:26" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "06:43:07" , 
"departure_time" : "06:43:38" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "06:45:31" , 
"departure_time" : "06:45:42" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "06:49:11" , 
"departure_time" : "06:50:51" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "06:54:40" , 
"departure_time" : "06:54:46" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "06:55:06" , 
"departure_time" : "06:56:16" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "07:02:10" , 
"departure_time" : "07:03:33" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "07:05:23" , 
"departure_time" : "07:06:22" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "07:09:59" , 
"departure_time" : "07:10:40" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "07:15:41" , 
"departure_time" : "07:15:49" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "07:17:08" , 
"departure_time" : "07:17:41" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "07:20:33" , 
"departure_time" : "07:20:33" , 
"distance_traveled" : 33.5428
} ], 
"5031" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "06:28:00" , 
"departure_time" : "06:29:39" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "06:31:06" , 
"departure_time" : "06:31:34" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "06:32:28" , 
"departure_time" : "06:33:49" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "06:37:21" , 
"departure_time" : "06:38:51" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "06:42:30" , 
"departure_time" : "06:43:06" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "06:43:36" , 
"departure_time" : "06:45:01" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "06:47:25" , 
"departure_time" : "06:48:19" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "06:49:54" , 
"departure_time" : "06:50:04" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "06:51:10" , 
"departure_time" : "06:52:14" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "06:54:04" , 
"departure_time" : "06:54:05" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "06:58:01" , 
"departure_time" : "06:59:06" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "07:01:05" , 
"departure_time" : "07:02:02" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "07:04:57" , 
"departure_time" : "07:05:30" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "07:08:33" , 
"departure_time" : "07:08:42" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "07:10:09" , 
"departure_time" : "07:11:21" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "07:17:12" , 
"departure_time" : "07:17:21" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "07:19:09" , 
"departure_time" : "07:19:46" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "07:24:37" , 
"departure_time" : "07:26:15" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "07:31:38" , 
"departure_time" : "07:33:13" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "07:33:35" , 
"departure_time" : "07:33:43" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "07:35:08" , 
"departure_time" : "07:35:08" , 
"distance_traveled" : 33.5428
} ], 
"5032" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "06:43:00" , 
"departure_time" : "06:44:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "06:46:02" , 
"departure_time" : "06:47:00" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "06:47:58" , 
"departure_time" : "06:48:32" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "06:51:34" , 
"departure_time" : "06:52:18" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "06:56:44" , 
"departure_time" : "06:58:16" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "06:59:32" , 
"departure_time" : "06:59:33" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "07:01:01" , 
"departure_time" : "07:01:22" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "07:04:21" , 
"departure_time" : "07:05:45" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "07:07:24" , 
"departure_time" : "07:07:26" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "07:08:02" , 
"departure_time" : "07:09:09" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "07:14:07" , 
"departure_time" : "07:15:08" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "07:16:01" , 
"departure_time" : "07:16:31" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "07:19:30" , 
"departure_time" : "07:20:32" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "07:24:02" , 
"departure_time" : "07:24:12" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "07:25:10" , 
"departure_time" : "07:26:00" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "07:31:50" , 
"departure_time" : "07:32:45" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "07:34:55" , 
"departure_time" : "07:35:47" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "07:39:52" , 
"departure_time" : "07:40:37" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "07:45:45" , 
"departure_time" : "07:46:14" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "07:47:29" , 
"departure_time" : "07:49:02" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "07:51:33" , 
"departure_time" : "07:51:33" , 
"distance_traveled" : 33.5428
} ], 
"5033" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "06:58:00" , 
"departure_time" : "06:59:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "07:00:21" , 
"departure_time" : "07:01:56" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "07:03:35" , 
"departure_time" : "07:04:54" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "07:07:19" , 
"departure_time" : "07:08:40" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "07:12:21" , 
"departure_time" : "07:13:47" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "07:14:26" , 
"departure_time" : "07:16:06" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "07:17:40" , 
"departure_time" : "07:18:49" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "07:20:09" , 
"departure_time" : "07:21:02" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "07:21:53" , 
"departure_time" : "07:22:56" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "07:24:03" , 
"departure_time" : "07:24:04" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "07:28:01" , 
"departure_time" : "07:29:11" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "07:31:10" , 
"departure_time" : "07:31:27" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "07:34:17" , 
"departure_time" : "07:34:53" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "07:38:36" , 
"departure_time" : "07:38:56" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "07:40:20" , 
"departure_time" : "07:41:59" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "07:47:39" , 
"departure_time" : "07:49:06" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "07:50:27" , 
"departure_time" : "07:51:47" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "07:55:20" , 
"departure_time" : "07:55:36" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "08:00:16" , 
"departure_time" : "08:00:45" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "08:02:29" , 
"departure_time" : "08:03:13" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "08:05:44" , 
"departure_time" : "08:05:44" , 
"distance_traveled" : 33.5428
} ], 
"5034" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "07:13:00" , 
"departure_time" : "07:14:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "07:16:11" , 
"departure_time" : "07:16:45" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "07:17:34" , 
"departure_time" : "07:19:06" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "07:22:32" , 
"departure_time" : "07:22:42" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "07:26:10" , 
"departure_time" : "07:26:24" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "07:28:14" , 
"departure_time" : "07:29:13" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "07:31:59" , 
"departure_time" : "07:33:24" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "07:35:25" , 
"departure_time" : "07:36:02" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "07:36:37" , 
"departure_time" : "07:37:33" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "07:38:56" , 
"departure_time" : "07:39:59" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "07:44:03" , 
"departure_time" : "07:45:25" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "07:46:22" , 
"departure_time" : "07:47:09" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "07:49:47" , 
"departure_time" : "07:50:04" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "07:53:17" , 
"departure_time" : "07:53:27" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "07:55:10" , 
"departure_time" : "07:55:30" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "08:01:20" , 
"departure_time" : "08:02:22" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "08:05:02" , 
"departure_time" : "08:05:40" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "08:09:38" , 
"departure_time" : "08:11:05" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "08:16:27" , 
"departure_time" : "08:16:28" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "08:17:01" , 
"departure_time" : "08:18:35" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "08:21:34" , 
"departure_time" : "08:21:34" , 
"distance_traveled" : 33.5428
} ], 
"5035" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "07:28:00" , 
"departure_time" : "07:30:36" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "07:31:02" , 
"departure_time" : "07:31:13" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "07:32:11" , 
"departure_time" : "07:33:47" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "07:37:36" , 
"departure_time" : "07:38:11" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "07:41:35" , 
"departure_time" : "07:42:57" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "07:44:22" , 
"departure_time" : "07:44:56" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "07:46:34" , 
"departure_time" : "07:46:38" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "07:49:04" , 
"departure_time" : "07:49:19" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "07:51:15" , 
"departure_time" : "07:51:32" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "07:53:17" , 
"departure_time" : "07:53:42" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "07:58:25" , 
"departure_time" : "07:59:13" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "08:00:48" , 
"departure_time" : "08:02:22" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "08:05:34" , 
"departure_time" : "08:05:47" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "08:08:13" , 
"departure_time" : "08:09:12" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "08:10:59" , 
"departure_time" : "08:11:21" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "08:16:22" , 
"departure_time" : "08:16:34" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "08:19:12" , 
"departure_time" : "08:20:00" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "08:24:48" , 
"departure_time" : "08:25:49" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "08:31:01" , 
"departure_time" : "08:32:30" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "08:33:29" , 
"departure_time" : "08:34:39" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "08:36:10" , 
"departure_time" : "08:36:10" , 
"distance_traveled" : 33.5428
} ], 
"5036" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "07:43:00" , 
"departure_time" : "07:45:47" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "07:46:37" , 
"departure_time" : "07:48:09" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "07:48:32" , 
"departure_time" : "07:49:15" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "07:51:43" , 
"departure_time" : "07:52:38" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "07:56:55" , 
"departure_time" : "07:58:19" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "07:59:24" , 
"departure_time" : "07:59:57" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "08:01:33" , 
"departure_time" : "08:02:51" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "08:05:18" , 
"departure_time" : "08:06:40" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "08:07:22" , 
"departure_time" : "08:08:48" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "08:09:26" , 
"departure_time" : "08:10:37" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "08:14:11" , 
"departure_time" : "08:15:14" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "08:16:03" , 
"departure_time" : "08:16:20" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "08:19:17" , 
"departure_time" : "08:20:35" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "08:24:18" , 
"departure_time" : "08:25:11" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "08:25:53" , 
"departure_time" : "08:26:48" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "08:31:55" , 
"departure_time" : "08:33:33" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "08:35:38" , 
"departure_time" : "08:36:11" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "08:39:33" , 
"departure_time" : "08:40:12" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "08:45:39" , 
"departure_time" : "08:46:43" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "08:48:04" , 
"departure_time" : "08:48:43" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "08:50:39" , 
"departure_time" : "08:50:39" , 
"distance_traveled" : 33.5428
} ], 
"5037" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "07:58:00" , 
"departure_time" : "07:58:57" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "08:00:18" , 
"departure_time" : "08:01:12" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "08:02:54" , 
"departure_time" : "08:03:44" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "08:06:50" , 
"departure_time" : "08:08:08" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "08:12:18" , 
"departure_time" : "08:12:19" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "08:13:01" , 
"departure_time" : "08:14:31" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "08:17:30" , 
"departure_time" : "08:19:10" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "08:20:40" , 
"departure_time" : "08:21:13" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "08:21:33" , 
"departure_time" : "08:23:10" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "08:24:37" , 
"departure_time" : "08:25:46" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "08:29:09" , 
"departure_time" : "08:29:18" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "08:30:09" , 
"departure_time" : "08:31:31" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "08:35:22" , 
"departure_time" : "08:36:54" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "08:39:32" , 
"departure_time" : "08:40:40" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "08:41:08" , 
"departure_time" : "08:42:20" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "08:47:12" , 
"departure_time" : "08:47:21" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "08:49:09" , 
"departure_time" : "08:50:24" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "08:55:15" , 
"departure_time" : "08:56:11" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "09:00:56" , 
"departure_time" : "09:01:02" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "09:02:06" , 
"departure_time" : "09:03:15" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "09:06:09" , 
"departure_time" : "09:06:09" , 
"distance_traveled" : 33.5428
} ], 
"5038" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "08:13:00" , 
"departure_time" : "08:14:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "08:15:42" , 
"departure_time" : "08:16:10" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "08:17:28" , 
"departure_time" : "08:18:25" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "08:21:57" , 
"departure_time" : "08:22:02" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "08:26:05" , 
"departure_time" : "08:27:35" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "08:29:30" , 
"departure_time" : "08:31:02" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "08:32:32" , 
"departure_time" : "08:32:48" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "08:34:16" , 
"departure_time" : "08:35:29" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "08:37:13" , 
"departure_time" : "08:37:21" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "08:38:08" , 
"departure_time" : "08:39:17" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "08:44:09" , 
"departure_time" : "08:44:42" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "08:45:33" , 
"departure_time" : "08:46:51" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "08:50:18" , 
"departure_time" : "08:51:41" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "08:54:23" , 
"departure_time" : "08:55:11" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "08:55:48" , 
"departure_time" : "08:56:32" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "09:01:44" , 
"departure_time" : "09:01:51" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "09:04:07" , 
"departure_time" : "09:05:26" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "09:10:19" , 
"departure_time" : "09:11:46" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "09:16:27" , 
"departure_time" : "09:17:38" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "09:18:11" , 
"departure_time" : "09:19:49" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "09:21:38" , 
"departure_time" : "09:21:38" , 
"distance_traveled" : 33.5428
} ], 
"5039" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "08:28:00" , 
"departure_time" : "08:30:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "08:31:16" , 
"departure_time" : "08:31:18" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "08:32:02" , 
"departure_time" : "08:32:29" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "08:36:27" , 
"departure_time" : "08:37:32" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "08:42:05" , 
"departure_time" : "08:43:26" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "08:44:21" , 
"departure_time" : "08:44:54" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "08:46:33" , 
"departure_time" : "08:47:59" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "08:50:26" , 
"departure_time" : "08:51:22" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "08:51:56" , 
"departure_time" : "08:53:32" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "08:54:36" , 
"departure_time" : "08:56:09" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "08:59:33" , 
"departure_time" : "09:00:45" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "09:01:12" , 
"departure_time" : "09:01:20" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "09:04:08" , 
"departure_time" : "09:05:35" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "09:09:27" , 
"departure_time" : "09:10:33" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "09:11:06" , 
"departure_time" : "09:11:31" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "09:16:25" , 
"departure_time" : "09:17:20" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "09:19:55" , 
"departure_time" : "09:20:22" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "09:24:27" , 
"departure_time" : "09:26:02" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "09:31:35" , 
"departure_time" : "09:31:51" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "09:32:16" , 
"departure_time" : "09:33:00" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "09:35:44" , 
"departure_time" : "09:35:44" , 
"distance_traveled" : 33.5428
} ], 
"5040" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "08:58:00" , 
"departure_time" : "09:00:24" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "09:01:40" , 
"departure_time" : "09:02:41" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "09:03:01" , 
"departure_time" : "09:03:18" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "09:06:17" , 
"departure_time" : "09:07:14" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "09:11:57" , 
"departure_time" : "09:12:31" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "09:13:34" , 
"departure_time" : "09:15:14" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "09:17:40" , 
"departure_time" : "09:18:33" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "09:19:53" , 
"departure_time" : "09:20:27" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "09:21:34" , 
"departure_time" : "09:21:42" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "09:23:08" , 
"departure_time" : "09:23:50" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "09:28:42" , 
"departure_time" : "09:28:54" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "09:30:12" , 
"departure_time" : "09:30:44" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "09:34:32" , 
"departure_time" : "09:35:08" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "09:38:36" , 
"departure_time" : "09:39:59" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "09:41:23" , 
"departure_time" : "09:42:11" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "09:46:48" , 
"departure_time" : "09:48:10" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "09:50:22" , 
"departure_time" : "09:51:35" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "09:55:13" , 
"departure_time" : "09:56:42" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "10:01:29" , 
"departure_time" : "10:02:15" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "10:02:46" , 
"departure_time" : "10:04:02" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "10:06:16" , 
"departure_time" : "10:06:16" , 
"distance_traveled" : 33.5428
} ], 
"5041" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "09:28:00" , 
"departure_time" : "09:29:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "09:30:29" , 
"departure_time" : "09:30:30" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "09:32:01" , 
"departure_time" : "09:32:53" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "09:36:52" , 
"departure_time" : "09:37:29" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "09:41:37" , 
"departure_time" : "09:42:04" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "09:43:27" , 
"departure_time" : "09:44:50" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "09:47:23" , 
"departure_time" : "09:49:01" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "09:50:38" , 
"departure_time" : "09:51:35" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "09:51:57" , 
"departure_time" : "09:52:10" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "09:53:13" , 
"departure_time" : "09:53:56" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "09:58:43" , 
"departure_time" : "10:00:10" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "10:01:27" , 
"departure_time" : "10:01:39" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "10:04:12" , 
"departure_time" : "10:04:56" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "10:08:44" , 
"departure_time" : "10:09:42" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "10:10:58" , 
"departure_time" : "10:12:21" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "10:17:23" , 
"departure_time" : "10:18:55" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "10:20:32" , 
"departure_time" : "10:20:53" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "10:24:21" , 
"departure_time" : "10:25:48" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "10:31:27" , 
"departure_time" : "10:31:31" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "10:32:04" , 
"departure_time" : "10:33:41" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "10:36:37" , 
"departure_time" : "10:36:37" , 
"distance_traveled" : 33.5428
} ], 
"5042" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "09:58:00" , 
"departure_time" : "10:00:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "10:00:56" , 
"departure_time" : "10:01:07" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "10:02:11" , 
"departure_time" : "10:03:40" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "10:07:29" , 
"departure_time" : "10:08:36" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "10:12:07" , 
"departure_time" : "10:13:22" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "10:14:15" , 
"departure_time" : "10:14:17" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "10:16:02" , 
"departure_time" : "10:16:48" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "10:19:46" , 
"departure_time" : "10:21:12" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "10:22:26" , 
"departure_time" : "10:23:03" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "10:23:37" , 
"departure_time" : "10:23:43" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "10:28:06" , 
"departure_time" : "10:29:10" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "10:31:04" , 
"departure_time" : "10:31:58" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "10:34:54" , 
"departure_time" : "10:36:12" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "10:39:18" , 
"departure_time" : "10:40:08" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "10:40:50" , 
"departure_time" : "10:41:39" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "10:46:49" , 
"departure_time" : "10:47:26" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "10:49:37" , 
"departure_time" : "10:50:01" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "10:54:24" , 
"departure_time" : "10:54:51" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "11:00:27" , 
"departure_time" : "11:01:59" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "11:03:32" , 
"departure_time" : "11:03:57" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "11:05:25" , 
"departure_time" : "11:05:25" , 
"distance_traveled" : 33.5428
} ], 
"5043" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "10:28:00" , 
"departure_time" : "10:28:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "10:30:09" , 
"departure_time" : "10:30:24" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "10:32:15" , 
"departure_time" : "10:33:39" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "10:37:24" , 
"departure_time" : "10:38:38" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "10:42:14" , 
"departure_time" : "10:43:15" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "10:44:01" , 
"departure_time" : "10:44:48" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "10:46:47" , 
"departure_time" : "10:47:53" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "10:50:06" , 
"departure_time" : "10:50:25" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "10:51:19" , 
"departure_time" : "10:51:50" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "10:53:31" , 
"departure_time" : "10:54:47" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "10:59:16" , 
"departure_time" : "10:59:53" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "11:00:37" , 
"departure_time" : "11:01:14" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "11:04:37" , 
"departure_time" : "11:05:27" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "11:08:50" , 
"departure_time" : "11:10:28" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "11:11:38" , 
"departure_time" : "11:13:15" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "11:17:37" , 
"departure_time" : "11:18:16" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "11:19:39" , 
"departure_time" : "11:19:46" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "11:24:07" , 
"departure_time" : "11:25:08" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "11:31:01" , 
"departure_time" : "11:32:37" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "11:33:36" , 
"departure_time" : "11:34:10" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "11:35:34" , 
"departure_time" : "11:35:34" , 
"distance_traveled" : 33.5428
} ], 
"5044" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "10:58:00" , 
"departure_time" : "10:58:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "11:00:15" , 
"departure_time" : "11:01:05" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "11:02:50" , 
"departure_time" : "11:03:03" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "11:06:13" , 
"departure_time" : "11:06:20" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "11:11:07" , 
"departure_time" : "11:11:39" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "11:13:32" , 
"departure_time" : "11:13:58" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "11:16:26" , 
"departure_time" : "11:17:59" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "11:20:33" , 
"departure_time" : "11:20:50" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "11:21:17" , 
"departure_time" : "11:22:38" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "11:24:21" , 
"departure_time" : "11:25:45" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "11:29:24" , 
"departure_time" : "11:30:39" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "11:31:15" , 
"departure_time" : "11:32:05" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "11:34:50" , 
"departure_time" : "11:35:36" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "11:38:46" , 
"departure_time" : "11:39:45" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "11:40:59" , 
"departure_time" : "11:42:37" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "11:47:38" , 
"departure_time" : "11:48:01" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "11:49:23" , 
"departure_time" : "11:50:50" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "11:55:27" , 
"departure_time" : "11:56:15" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "12:00:48" , 
"departure_time" : "12:00:53" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "12:02:05" , 
"departure_time" : "12:02:46" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "12:05:41" , 
"departure_time" : "12:05:41" , 
"distance_traveled" : 33.5428
} ], 
"5045" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "11:28:00" , 
"departure_time" : "11:29:00" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "11:30:19" , 
"departure_time" : "11:30:49" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "11:32:30" , 
"departure_time" : "11:32:51" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "11:36:21" , 
"departure_time" : "11:37:01" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "11:41:40" , 
"departure_time" : "11:42:59" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "11:44:19" , 
"departure_time" : "11:44:37" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "11:46:18" , 
"departure_time" : "11:47:46" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "11:50:28" , 
"departure_time" : "11:51:16" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "11:51:48" , 
"departure_time" : "11:53:00" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "11:54:12" , 
"departure_time" : "11:55:38" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "11:59:26" , 
"departure_time" : "12:00:23" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "12:00:57" , 
"departure_time" : "12:02:32" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "12:05:35" , 
"departure_time" : "12:06:56" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "12:09:21" , 
"departure_time" : "12:10:31" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "12:11:10" , 
"departure_time" : "12:12:20" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "12:17:10" , 
"departure_time" : "12:17:47" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "12:19:37" , 
"departure_time" : "12:20:00" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "12:24:23" , 
"departure_time" : "12:24:44" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "12:30:21" , 
"departure_time" : "12:31:47" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "12:33:26" , 
"departure_time" : "12:33:54" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "12:35:28" , 
"departure_time" : "12:35:28" , 
"distance_traveled" : 33.5428
} ], 
"5046" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "11:58:00" , 
"departure_time" : "11:58:42" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "12:00:14" , 
"departure_time" : "12:01:53" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "12:03:39" , 
"departure_time" : "12:04:58" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "12:07:19" , 
"departure_time" : "12:08:56" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "12:12:37" , 
"departure_time" : "12:13:11" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "12:13:34" , 
"departure_time" : "12:14:11" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "12:16:37" , 
"departure_time" : "12:17:41" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "12:20:04" , 
"departure_time" : "12:20:42" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "12:21:38" , 
"departure_time" : "12:22:55" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "12:24:17" , 
"departure_time" : "12:24:36" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "12:28:19" , 
"departure_time" : "12:29:22" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "12:31:03" , 
"departure_time" : "12:32:25" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "12:35:22" , 
"departure_time" : "12:35:30" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "12:38:08" , 
"departure_time" : "12:39:36" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "12:41:28" , 
"departure_time" : "12:42:00" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "12:46:32" , 
"departure_time" : "12:47:30" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "12:49:58" , 
"departure_time" : "12:51:17" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "12:55:19" , 
"departure_time" : "12:55:36" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "13:00:17" , 
"departure_time" : "13:01:21" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "13:03:04" , 
"departure_time" : "13:03:46" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "13:05:42" , 
"departure_time" : "13:05:42" , 
"distance_traveled" : 33.5428
} ], 
"5047" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "12:28:00" , 
"departure_time" : "12:30:07" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "12:31:25" , 
"departure_time" : "12:32:52" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "12:33:27" , 
"departure_time" : "12:34:28" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "12:37:01" , 
"departure_time" : "12:38:21" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "12:42:20" , 
"departure_time" : "12:43:48" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "12:44:28" , 
"departure_time" : "12:44:34" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "12:46:06" , 
"departure_time" : "12:47:01" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "12:49:55" , 
"departure_time" : "12:50:14" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "12:51:19" , 
"departure_time" : "12:51:34" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "12:53:15" , 
"departure_time" : "12:53:25" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "12:58:10" , 
"departure_time" : "12:59:48" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "13:01:38" , 
"departure_time" : "13:02:04" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "13:04:26" , 
"departure_time" : "13:06:01" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "13:09:35" , 
"departure_time" : "13:10:13" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "13:10:38" , 
"departure_time" : "13:10:55" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "13:16:17" , 
"departure_time" : "13:16:32" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "13:19:15" , 
"departure_time" : "13:19:24" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "13:24:09" , 
"departure_time" : "13:24:26" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "13:30:17" , 
"departure_time" : "13:31:11" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "13:32:54" , 
"departure_time" : "13:33:00" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "13:35:06" , 
"departure_time" : "13:35:06" , 
"distance_traveled" : 33.5428
} ], 
"5048" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "12:58:00" , 
"departure_time" : "12:59:11" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "13:01:05" , 
"departure_time" : "13:01:11" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "13:02:06" , 
"departure_time" : "13:02:17" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "13:06:11" , 
"departure_time" : "13:07:24" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "13:12:13" , 
"departure_time" : "13:13:30" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "13:14:17" , 
"departure_time" : "13:14:19" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "13:16:02" , 
"departure_time" : "13:16:43" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "13:19:41" , 
"departure_time" : "13:20:30" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "13:21:49" , 
"departure_time" : "13:23:28" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "13:24:39" , 
"departure_time" : "13:25:22" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "13:28:43" , 
"departure_time" : "13:30:21" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "13:31:38" , 
"departure_time" : "13:32:39" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "13:35:01" , 
"departure_time" : "13:36:10" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "13:39:09" , 
"departure_time" : "13:40:33" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "13:41:24" , 
"departure_time" : "13:42:32" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "13:47:08" , 
"departure_time" : "13:47:40" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "13:49:32" , 
"departure_time" : "13:50:03" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "13:54:31" , 
"departure_time" : "13:55:22" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "14:00:51" , 
"departure_time" : "14:01:08" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "14:02:17" , 
"departure_time" : "14:02:41" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "14:05:24" , 
"departure_time" : "14:05:24" , 
"distance_traveled" : 33.5428
} ], 
"5049" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "13:28:00" , 
"departure_time" : "13:29:40" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "13:31:16" , 
"departure_time" : "13:31:52" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "13:32:36" , 
"departure_time" : "13:32:51" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "13:36:15" , 
"departure_time" : "13:37:35" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "13:42:20" , 
"departure_time" : "13:43:46" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "13:44:26" , 
"departure_time" : "13:44:36" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "13:46:10" , 
"departure_time" : "13:47:22" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "13:50:12" , 
"departure_time" : "13:50:28" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "13:51:16" , 
"departure_time" : "13:51:48" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "13:53:32" , 
"departure_time" : "13:54:25" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "13:58:53" , 
"departure_time" : "14:00:06" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "14:01:13" , 
"departure_time" : "14:02:04" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "14:04:51" , 
"departure_time" : "14:05:19" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "14:08:28" , 
"departure_time" : "14:08:56" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "14:10:28" , 
"departure_time" : "14:11:58" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "14:17:30" , 
"departure_time" : "14:18:26" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "14:19:56" , 
"departure_time" : "14:20:44" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "14:24:48" , 
"departure_time" : "14:24:58" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "14:30:10" , 
"departure_time" : "14:30:20" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "14:32:10" , 
"departure_time" : "14:32:32" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "14:35:22" , 
"departure_time" : "14:35:22" , 
"distance_traveled" : 33.5428
} ], 
"5050" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "13:58:00" , 
"departure_time" : "13:59:49" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "14:01:27" , 
"departure_time" : "14:02:28" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "14:03:01" , 
"departure_time" : "14:04:00" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "14:06:59" , 
"departure_time" : "14:07:21" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "14:11:22" , 
"departure_time" : "14:12:11" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "14:13:49" , 
"departure_time" : "14:15:18" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "14:17:29" , 
"departure_time" : "14:17:55" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "14:19:26" , 
"departure_time" : "14:20:07" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "14:21:41" , 
"departure_time" : "14:23:02" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "14:24:21" , 
"departure_time" : "14:24:45" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "14:28:24" , 
"departure_time" : "14:29:58" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "14:31:34" , 
"departure_time" : "14:32:44" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "14:35:10" , 
"departure_time" : "14:35:37" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "14:38:27" , 
"departure_time" : "14:39:03" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "14:40:36" , 
"departure_time" : "14:41:24" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "14:46:48" , 
"departure_time" : "14:46:53" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "14:49:05" , 
"departure_time" : "14:50:18" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "14:55:13" , 
"departure_time" : "14:56:53" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "15:01:40" , 
"departure_time" : "15:03:06" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "15:03:26" , 
"departure_time" : "15:04:05" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "15:05:39" , 
"departure_time" : "15:05:39" , 
"distance_traveled" : 33.5428
} ], 
"5051" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "14:28:00" , 
"departure_time" : "14:30:10" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "14:31:31" , 
"departure_time" : "14:31:34" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "14:32:03" , 
"departure_time" : "14:33:25" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "14:37:22" , 
"departure_time" : "14:37:48" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "14:41:26" , 
"departure_time" : "14:42:22" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "14:43:56" , 
"departure_time" : "14:44:51" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "14:46:55" , 
"departure_time" : "14:47:19" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "14:49:24" , 
"departure_time" : "14:49:32" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "14:51:08" , 
"departure_time" : "14:51:30" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "14:53:22" , 
"departure_time" : "14:54:48" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "14:59:26" , 
"departure_time" : "15:01:06" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "15:01:40" , 
"departure_time" : "15:03:05" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "15:05:25" , 
"departure_time" : "15:06:21" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "15:08:56" , 
"departure_time" : "15:09:42" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "15:10:46" , 
"departure_time" : "15:11:11" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "15:16:25" , 
"departure_time" : "15:16:31" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "15:19:06" , 
"departure_time" : "15:20:34" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "15:25:28" , 
"departure_time" : "15:26:11" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "15:30:43" , 
"departure_time" : "15:31:38" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "15:32:55" , 
"departure_time" : "15:33:47" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "15:35:52" , 
"departure_time" : "15:35:52" , 
"distance_traveled" : 33.5428
} ], 
"5052" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "14:58:00" , 
"departure_time" : "14:59:16" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "15:00:24" , 
"departure_time" : "15:01:38" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "15:03:14" , 
"departure_time" : "15:04:15" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "15:07:01" , 
"departure_time" : "15:08:24" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "15:12:23" , 
"departure_time" : "15:13:23" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "15:14:00" , 
"departure_time" : "15:15:30" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "15:17:30" , 
"departure_time" : "15:18:39" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "15:20:09" , 
"departure_time" : "15:21:36" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "15:22:27" , 
"departure_time" : "15:23:08" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "15:23:41" , 
"departure_time" : "15:25:12" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "15:29:31" , 
"departure_time" : "15:29:54" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "15:30:23" , 
"departure_time" : "15:31:38" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "15:35:15" , 
"departure_time" : "15:35:54" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "15:38:39" , 
"departure_time" : "15:39:41" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "15:41:02" , 
"departure_time" : "15:41:46" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "15:46:44" , 
"departure_time" : "15:47:42" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "15:49:58" , 
"departure_time" : "15:51:15" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "15:55:17" , 
"departure_time" : "15:55:23" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "16:00:06" , 
"departure_time" : "16:00:15" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "16:02:09" , 
"departure_time" : "16:02:37" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "16:05:28" , 
"departure_time" : "16:05:28" , 
"distance_traveled" : 33.5428
} ], 
"5053" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "15:28:00" , 
"departure_time" : "15:29:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "15:30:40" , 
"departure_time" : "15:32:19" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "15:33:39" , 
"departure_time" : "15:34:05" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "15:36:26" , 
"departure_time" : "15:36:50" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "15:41:24" , 
"departure_time" : "15:42:24" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "15:44:00" , 
"departure_time" : "15:45:14" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "15:47:14" , 
"departure_time" : "15:47:55" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "15:49:41" , 
"departure_time" : "15:51:07" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "15:52:26" , 
"departure_time" : "15:52:35" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "15:53:09" , 
"departure_time" : "15:54:22" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "15:59:13" , 
"departure_time" : "15:59:33" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "16:00:20" , 
"departure_time" : "16:01:23" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "16:05:03" , 
"departure_time" : "16:05:51" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "16:08:48" , 
"departure_time" : "16:10:15" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "16:11:27" , 
"departure_time" : "16:12:45" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "16:17:18" , 
"departure_time" : "16:18:11" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "16:19:53" , 
"departure_time" : "16:20:03" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "16:24:10" , 
"departure_time" : "16:25:12" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "16:31:02" , 
"departure_time" : "16:32:10" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "16:33:08" , 
"departure_time" : "16:34:35" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "16:36:27" , 
"departure_time" : "16:36:27" , 
"distance_traveled" : 33.5428
} ], 
"5054" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "15:58:00" , 
"departure_time" : "16:00:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "16:00:41" , 
"departure_time" : "16:01:13" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "16:02:32" , 
"departure_time" : "16:03:37" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "16:07:05" , 
"departure_time" : "16:07:34" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "16:11:29" , 
"departure_time" : "16:12:04" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "16:13:35" , 
"departure_time" : "16:15:10" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "16:17:35" , 
"departure_time" : "16:19:06" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "16:20:31" , 
"departure_time" : "16:21:24" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "16:21:53" , 
"departure_time" : "16:23:03" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "16:24:10" , 
"departure_time" : "16:24:44" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "16:28:34" , 
"departure_time" : "16:29:28" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "16:30:54" , 
"departure_time" : "16:31:15" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "16:34:21" , 
"departure_time" : "16:35:20" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "16:38:59" , 
"departure_time" : "16:40:20" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "16:41:21" , 
"departure_time" : "16:41:56" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "16:46:35" , 
"departure_time" : "16:47:29" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "16:49:54" , 
"departure_time" : "16:51:11" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "16:55:17" , 
"departure_time" : "16:56:54" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "17:01:37" , 
"departure_time" : "17:02:44" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "17:03:07" , 
"departure_time" : "17:03:20" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "17:05:13" , 
"departure_time" : "17:05:13" , 
"distance_traveled" : 33.5428
} ], 
"5055" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "16:13:00" , 
"departure_time" : "16:13:51" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "16:15:38" , 
"departure_time" : "16:16:40" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "16:18:02" , 
"departure_time" : "16:18:06" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "16:21:04" , 
"departure_time" : "16:21:21" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "16:26:17" , 
"departure_time" : "16:26:20" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "16:28:03" , 
"departure_time" : "16:29:00" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "16:31:57" , 
"departure_time" : "16:32:31" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "16:34:34" , 
"departure_time" : "16:35:16" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "16:36:42" , 
"departure_time" : "16:37:58" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "16:39:16" , 
"departure_time" : "16:40:02" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "16:43:46" , 
"departure_time" : "16:45:14" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "16:46:28" , 
"departure_time" : "16:47:52" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "16:50:24" , 
"departure_time" : "16:51:55" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "16:54:31" , 
"departure_time" : "16:55:43" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "16:56:12" , 
"departure_time" : "16:57:01" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "17:01:49" , 
"departure_time" : "17:02:39" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "17:04:50" , 
"departure_time" : "17:06:05" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "17:10:15" , 
"departure_time" : "17:10:30" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "17:15:15" , 
"departure_time" : "17:16:27" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "17:18:12" , 
"departure_time" : "17:18:30" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "17:20:18" , 
"departure_time" : "17:20:18" , 
"distance_traveled" : 33.5428
} ], 
"5056" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "16:28:00" , 
"departure_time" : "16:28:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "16:30:37" , 
"departure_time" : "16:32:03" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "16:33:26" , 
"departure_time" : "16:33:28" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "16:36:02" , 
"departure_time" : "16:37:29" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "16:42:27" , 
"departure_time" : "16:43:37" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "16:44:10" , 
"departure_time" : "16:44:39" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "16:46:29" , 
"departure_time" : "16:47:42" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "16:50:13" , 
"departure_time" : "16:51:47" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "16:52:34" , 
"departure_time" : "16:52:35" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "16:53:01" , 
"departure_time" : "16:53:31" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "16:58:30" , 
"departure_time" : "16:58:32" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "17:00:02" , 
"departure_time" : "17:01:28" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "17:05:26" , 
"departure_time" : "17:05:47" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "17:08:21" , 
"departure_time" : "17:08:50" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "17:10:29" , 
"departure_time" : "17:11:28" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "17:16:59" , 
"departure_time" : "17:17:27" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "17:19:28" , 
"departure_time" : "17:19:47" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "17:24:19" , 
"departure_time" : "17:24:45" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "17:30:26" , 
"departure_time" : "17:31:01" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "17:32:35" , 
"departure_time" : "17:33:21" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "17:35:46" , 
"departure_time" : "17:35:46" , 
"distance_traveled" : 33.5428
} ], 
"5057" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "16:43:00" , 
"departure_time" : "16:44:45" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "16:45:59" , 
"departure_time" : "16:46:37" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "16:47:38" , 
"departure_time" : "16:48:30" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "16:51:52" , 
"departure_time" : "16:52:43" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "16:56:51" , 
"departure_time" : "16:58:04" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "16:59:13" , 
"departure_time" : "16:59:53" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "17:01:40" , 
"departure_time" : "17:03:10" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "17:05:30" , 
"departure_time" : "17:06:18" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "17:06:48" , 
"departure_time" : "17:08:04" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "17:09:16" , 
"departure_time" : "17:10:56" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "17:14:40" , 
"departure_time" : "17:15:01" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "17:15:21" , 
"departure_time" : "17:16:09" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "17:19:48" , 
"departure_time" : "17:19:52" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "17:23:04" , 
"departure_time" : "17:24:05" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "17:26:01" , 
"departure_time" : "17:26:31" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "17:31:30" , 
"departure_time" : "17:32:02" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "17:34:32" , 
"departure_time" : "17:35:41" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "17:40:09" , 
"departure_time" : "17:40:50" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "17:45:41" , 
"departure_time" : "17:47:17" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "17:48:36" , 
"departure_time" : "17:48:52" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "17:50:16" , 
"departure_time" : "17:50:16" , 
"distance_traveled" : 33.5428
} ], 
"5058" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "16:58:00" , 
"departure_time" : "16:59:54" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "17:01:38" , 
"departure_time" : "17:02:39" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "17:03:01" , 
"departure_time" : "17:04:38" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "17:07:37" , 
"departure_time" : "17:08:42" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "17:12:05" , 
"departure_time" : "17:12:08" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "17:13:03" , 
"departure_time" : "17:13:47" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "17:16:44" , 
"departure_time" : "17:17:33" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "17:19:49" , 
"departure_time" : "17:20:00" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "17:21:11" , 
"departure_time" : "17:21:36" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "17:23:25" , 
"departure_time" : "17:23:33" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "17:28:08" , 
"departure_time" : "17:28:47" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "17:30:39" , 
"departure_time" : "17:31:46" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "17:35:07" , 
"departure_time" : "17:35:23" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "17:38:16" , 
"departure_time" : "17:38:38" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "17:40:22" , 
"departure_time" : "17:40:33" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "17:46:11" , 
"departure_time" : "17:47:14" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "17:50:03" , 
"departure_time" : "17:51:24" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "17:55:21" , 
"departure_time" : "17:55:44" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "18:00:23" , 
"departure_time" : "18:00:55" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "18:02:32" , 
"departure_time" : "18:02:53" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "18:05:21" , 
"departure_time" : "18:05:21" , 
"distance_traveled" : 33.5428
} ], 
"5059" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "17:13:00" , 
"departure_time" : "17:14:59" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "17:16:38" , 
"departure_time" : "17:18:10" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "17:18:32" , 
"departure_time" : "17:19:49" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "17:22:17" , 
"departure_time" : "17:23:47" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "17:27:30" , 
"departure_time" : "17:28:51" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "17:29:21" , 
"departure_time" : "17:29:47" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "17:31:26" , 
"departure_time" : "17:31:58" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "17:34:32" , 
"departure_time" : "17:34:42" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "17:36:10" , 
"departure_time" : "17:36:33" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "17:38:23" , 
"departure_time" : "17:38:46" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "17:43:23" , 
"departure_time" : "17:43:52" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "17:45:29" , 
"departure_time" : "17:46:55" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "17:50:26" , 
"departure_time" : "17:52:06" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "17:54:40" , 
"departure_time" : "17:56:13" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "17:56:33" , 
"departure_time" : "17:56:44" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "18:01:11" , 
"departure_time" : "18:02:42" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "18:05:31" , 
"departure_time" : "18:05:37" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "18:09:06" , 
"departure_time" : "18:09:38" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "18:15:32" , 
"departure_time" : "18:16:53" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "18:18:21" , 
"departure_time" : "18:18:30" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "18:20:09" , 
"departure_time" : "18:20:09" , 
"distance_traveled" : 33.5428
} ], 
"5060" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "17:28:00" , 
"departure_time" : "17:29:38" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "17:31:29" , 
"departure_time" : "17:32:39" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "17:33:10" , 
"departure_time" : "17:33:42" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "17:36:32" , 
"departure_time" : "17:37:49" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "17:42:17" , 
"departure_time" : "17:42:40" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "17:43:23" , 
"departure_time" : "17:44:13" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "17:46:50" , 
"departure_time" : "17:48:09" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "17:50:19" , 
"departure_time" : "17:50:45" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "17:51:26" , 
"departure_time" : "17:52:30" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "17:54:04" , 
"departure_time" : "17:54:22" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "17:58:18" , 
"departure_time" : "17:58:43" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "18:00:25" , 
"departure_time" : "18:01:35" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "18:05:10" , 
"departure_time" : "18:05:22" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "18:08:12" , 
"departure_time" : "18:08:17" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "18:10:05" , 
"departure_time" : "18:11:34" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "18:17:29" , 
"departure_time" : "18:18:22" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "18:19:53" , 
"departure_time" : "18:20:57" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "18:25:04" , 
"departure_time" : "18:26:21" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "18:31:17" , 
"departure_time" : "18:32:53" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "18:33:36" , 
"departure_time" : "18:33:55" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "18:35:19" , 
"departure_time" : "18:35:19" , 
"distance_traveled" : 33.5428
} ], 
"5061" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "17:43:00" , 
"departure_time" : "17:43:34" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "17:45:15" , 
"departure_time" : "17:46:11" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "17:47:56" , 
"departure_time" : "17:48:04" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "17:51:08" , 
"departure_time" : "17:52:47" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "17:57:39" , 
"departure_time" : "17:58:51" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "17:59:12" , 
"departure_time" : "17:59:41" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "18:01:29" , 
"departure_time" : "18:01:58" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "18:04:29" , 
"departure_time" : "18:05:34" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "18:07:05" , 
"departure_time" : "18:07:48" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "18:08:43" , 
"departure_time" : "18:09:23" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "18:13:40" , 
"departure_time" : "18:14:16" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "18:15:36" , 
"departure_time" : "18:16:57" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "18:20:21" , 
"departure_time" : "18:22:01" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "18:24:40" , 
"departure_time" : "18:25:05" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "18:25:25" , 
"departure_time" : "18:26:55" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "18:32:30" , 
"departure_time" : "18:33:29" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "18:34:59" , 
"departure_time" : "18:35:32" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "18:39:33" , 
"departure_time" : "18:40:27" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "18:45:54" , 
"departure_time" : "18:47:23" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "18:48:29" , 
"departure_time" : "18:48:54" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "18:50:25" , 
"departure_time" : "18:50:25" , 
"distance_traveled" : 33.5428
} ], 
"5062" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "17:58:00" , 
"departure_time" : "17:59:30" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "18:01:05" , 
"departure_time" : "18:02:20" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "18:03:15" , 
"departure_time" : "18:04:26" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "18:07:11" , 
"departure_time" : "18:07:54" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "18:11:43" , 
"departure_time" : "18:11:54" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "18:13:11" , 
"departure_time" : "18:13:48" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "18:16:37" , 
"departure_time" : "18:16:55" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "18:19:18" , 
"departure_time" : "18:19:57" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "18:21:39" , 
"departure_time" : "18:22:22" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "18:23:43" , 
"departure_time" : "18:24:14" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "18:28:31" , 
"departure_time" : "18:28:42" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "18:30:11" , 
"departure_time" : "18:31:00" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "18:34:49" , 
"departure_time" : "18:35:56" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "18:39:07" , 
"departure_time" : "18:39:15" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "18:40:08" , 
"departure_time" : "18:41:48" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "18:47:40" , 
"departure_time" : "18:48:25" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "18:49:45" , 
"departure_time" : "18:50:48" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "18:55:03" , 
"departure_time" : "18:55:19" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "19:00:16" , 
"departure_time" : "19:01:41" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "19:03:25" , 
"departure_time" : "19:04:37" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "19:06:12" , 
"departure_time" : "19:06:12" , 
"distance_traveled" : 33.5428
} ], 
"5063" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "18:13:00" , 
"departure_time" : "18:15:08" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "18:15:56" , 
"departure_time" : "18:17:31" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "18:18:35" , 
"departure_time" : "18:19:21" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "18:21:46" , 
"departure_time" : "18:23:07" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "18:27:21" , 
"departure_time" : "18:27:35" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "18:28:14" , 
"departure_time" : "18:29:03" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "18:31:49" , 
"departure_time" : "18:33:25" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "18:35:36" , 
"departure_time" : "18:35:59" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "18:36:23" , 
"departure_time" : "18:37:41" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "18:39:18" , 
"departure_time" : "18:39:57" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "18:43:39" , 
"departure_time" : "18:44:19" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "18:45:40" , 
"departure_time" : "18:46:50" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "18:50:10" , 
"departure_time" : "18:50:54" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "18:53:44" , 
"departure_time" : "18:53:45" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "18:55:01" , 
"departure_time" : "18:55:42" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "19:01:41" , 
"departure_time" : "19:03:14" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "19:05:33" , 
"departure_time" : "19:06:25" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "19:09:52" , 
"departure_time" : "19:11:25" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "19:16:33" , 
"departure_time" : "19:17:33" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "19:18:00" , 
"departure_time" : "19:18:32" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "19:20:32" , 
"departure_time" : "19:20:32" , 
"distance_traveled" : 33.5428
} ], 
"5064" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "18:28:00" , 
"departure_time" : "18:29:55" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "18:31:23" , 
"departure_time" : "18:32:15" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "18:32:52" , 
"departure_time" : "18:33:04" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "18:36:12" , 
"departure_time" : "18:37:46" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "18:42:34" , 
"departure_time" : "18:43:16" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "18:43:42" , 
"departure_time" : "18:44:36" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "18:46:54" , 
"departure_time" : "18:46:58" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "18:49:04" , 
"departure_time" : "18:50:42" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "18:52:38" , 
"departure_time" : "18:53:37" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "18:53:59" , 
"departure_time" : "18:55:07" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "18:59:08" , 
"departure_time" : "19:00:28" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "19:01:20" , 
"departure_time" : "19:01:48" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "19:04:28" , 
"departure_time" : "19:05:24" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "19:08:56" , 
"departure_time" : "19:09:17" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "19:10:21" , 
"departure_time" : "19:10:23" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "19:16:02" , 
"departure_time" : "19:16:40" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "19:19:38" , 
"departure_time" : "19:20:04" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "19:24:26" , 
"departure_time" : "19:25:55" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "19:31:29" , 
"departure_time" : "19:31:43" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "19:32:14" , 
"departure_time" : "19:33:24" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "19:36:10" , 
"departure_time" : "19:36:10" , 
"distance_traveled" : 33.5428
} ], 
"5065" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "18:43:00" , 
"departure_time" : "18:44:27" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "18:45:17" , 
"departure_time" : "18:45:22" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "18:47:05" , 
"departure_time" : "18:48:17" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "18:52:12" , 
"departure_time" : "18:53:25" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "18:57:13" , 
"departure_time" : "18:58:05" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "18:58:52" , 
"departure_time" : "18:59:23" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "19:01:31" , 
"departure_time" : "19:03:02" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "19:05:31" , 
"departure_time" : "19:06:32" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "19:07:01" , 
"departure_time" : "19:08:02" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "19:09:01" , 
"departure_time" : "19:09:41" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "19:13:40" , 
"departure_time" : "19:15:10" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "19:16:30" , 
"departure_time" : "19:17:57" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "19:20:27" , 
"departure_time" : "19:21:43" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "19:24:16" , 
"departure_time" : "19:24:34" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "19:25:18" , 
"departure_time" : "19:26:27" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "19:32:09" , 
"departure_time" : "19:33:06" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "19:34:57" , 
"departure_time" : "19:35:31" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "19:39:34" , 
"departure_time" : "19:39:59" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "19:45:25" , 
"departure_time" : "19:46:41" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "19:48:16" , 
"departure_time" : "19:48:35" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "19:50:19" , 
"departure_time" : "19:50:19" , 
"distance_traveled" : 33.5428
} ], 
"5066" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "18:58:00" , 
"departure_time" : "18:58:48" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "19:00:29" , 
"departure_time" : "19:01:14" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "19:02:45" , 
"departure_time" : "19:03:54" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "19:07:09" , 
"departure_time" : "19:07:47" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "19:11:38" , 
"departure_time" : "19:12:59" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "19:14:21" , 
"departure_time" : "19:14:32" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "19:16:11" , 
"departure_time" : "19:17:08" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "19:19:57" , 
"departure_time" : "19:21:09" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "19:22:12" , 
"departure_time" : "19:23:06" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "19:23:54" , 
"departure_time" : "19:25:34" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "19:29:40" , 
"departure_time" : "19:30:55" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "19:31:15" , 
"departure_time" : "19:31:26" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "19:34:11" , 
"departure_time" : "19:35:07" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "19:38:56" , 
"departure_time" : "19:39:10" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "19:40:14" , 
"departure_time" : "19:41:42" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "19:47:28" , 
"departure_time" : "19:48:08" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "19:49:40" , 
"departure_time" : "19:50:44" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "19:55:04" , 
"departure_time" : "19:55:57" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "20:00:53" , 
"departure_time" : "20:00:59" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "20:02:06" , 
"departure_time" : "20:02:13" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "20:05:07" , 
"departure_time" : "20:05:07" , 
"distance_traveled" : 33.5428
} ], 
"5067" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "19:28:00" , 
"departure_time" : "19:29:33" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "19:31:26" , 
"departure_time" : "19:32:39" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "19:33:13" , 
"departure_time" : "19:33:36" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "19:36:23" , 
"departure_time" : "19:37:31" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "19:42:08" , 
"departure_time" : "19:43:30" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "19:44:22" , 
"departure_time" : "19:44:48" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "19:46:26" , 
"departure_time" : "19:47:21" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "19:49:55" , 
"departure_time" : "19:51:05" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "19:52:10" , 
"departure_time" : "19:52:26" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "19:53:16" , 
"departure_time" : "19:54:27" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "19:59:11" , 
"departure_time" : "19:59:20" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "20:00:09" , 
"departure_time" : "20:00:10" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "20:04:01" , 
"departure_time" : "20:04:40" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "20:08:39" , 
"departure_time" : "20:09:50" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "20:11:11" , 
"departure_time" : "20:12:37" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "20:17:26" , 
"departure_time" : "20:17:27" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "20:19:01" , 
"departure_time" : "20:20:02" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "20:25:01" , 
"departure_time" : "20:25:53" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "20:30:52" , 
"departure_time" : "20:32:01" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "20:33:09" , 
"departure_time" : "20:33:17" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "20:35:08" , 
"departure_time" : "20:35:08" , 
"distance_traveled" : 33.5428
} ], 
"5068" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "19:58:00" , 
"departure_time" : "19:58:21" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "20:00:13" , 
"departure_time" : "20:01:02" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "20:02:49" , 
"departure_time" : "20:04:29" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "20:07:40" , 
"departure_time" : "20:08:33" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "20:11:53" , 
"departure_time" : "20:13:31" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "20:14:38" , 
"departure_time" : "20:15:56" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "20:17:18" , 
"departure_time" : "20:17:22" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "20:19:04" , 
"departure_time" : "20:20:28" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "20:22:24" , 
"departure_time" : "20:23:13" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "20:23:49" , 
"departure_time" : "20:25:09" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "20:29:20" , 
"departure_time" : "20:30:35" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "20:31:15" , 
"departure_time" : "20:31:18" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "20:34:03" , 
"departure_time" : "20:35:13" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "20:39:10" , 
"departure_time" : "20:39:56" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "20:40:46" , 
"departure_time" : "20:41:22" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "20:46:36" , 
"departure_time" : "20:47:08" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "20:49:32" , 
"departure_time" : "20:50:34" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "20:55:02" , 
"departure_time" : "20:55:25" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "21:00:23" , 
"departure_time" : "21:01:44" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "21:03:21" , 
"departure_time" : "21:04:38" , 
"distance_traveled" : 33.0598
}, 
{ 
"stop_id" : 38291,
"arrival_time" : "21:06:17" , 
"departure_time" : "21:06:17" , 
"distance_traveled" : 33.5428
} ], 
"5069" :  [ 
{ 
"stop_id" : 38310,
"arrival_time" : "20:30:00" , 
"departure_time" : "20:32:52" , 
"distance_traveled" : 0.0
}, 
{ 
"stop_id" : 38309,
"arrival_time" : "20:33:35" , 
"departure_time" : "20:34:36" , 
"distance_traveled" : 0.3443
}, 
{ 
"stop_id" : 38308,
"arrival_time" : "20:35:01" , 
"departure_time" : "20:35:09" , 
"distance_traveled" : 0.725
}, 
{ 
"stop_id" : 38307,
"arrival_time" : "20:38:08" , 
"departure_time" : "20:39:25" , 
"distance_traveled" : 1.1498
}, 
{ 
"stop_id" : 38306,
"arrival_time" : "20:44:17" , 
"departure_time" : "20:45:01" , 
"distance_traveled" : 3.7871
}, 
{ 
"stop_id" : 43288,
"arrival_time" : "20:45:44" , 
"departure_time" : "20:47:06" , 
"distance_traveled" : 5.3449
}, 
{ 
"stop_id" : 38305,
"arrival_time" : "20:49:22" , 
"departure_time" : "20:50:58" , 
"distance_traveled" : 6.9218
}, 
{ 
"stop_id" : 38304,
"arrival_time" : "20:52:36" , 
"departure_time" : "20:53:37" , 
"distance_traveled" : 8.1884
}, 
{ 
"stop_id" : 38303,
"arrival_time" : "20:54:01" , 
"departure_time" : "20:55:31" , 
"distance_traveled" : 8.6956
}, 
{ 
"stop_id" : 38302,
"arrival_time" : "20:56:30" , 
"departure_time" : "20:57:52" , 
"distance_traveled" : 9.5693
}, 
{ 
"stop_id" : 38301,
"arrival_time" : "21:01:22" , 
"departure_time" : "21:01:54" , 
"distance_traveled" : 12.2432
}, 
{ 
"stop_id" : 38300,
"arrival_time" : "21:02:32" , 
"departure_time" : "21:03:55" , 
"distance_traveled" : 13.0081
}, 
{ 
"stop_id" : 38299,
"arrival_time" : "21:07:23" , 
"departure_time" : "21:08:10" , 
"distance_traveled" : 15.092
}, 
{ 
"stop_id" : 38298,
"arrival_time" : "21:10:47" , 
"departure_time" : "21:11:05" , 
"distance_traveled" : 17.704
}, 
{ 
"stop_id" : 38297,
"arrival_time" : "21:12:18" , 
"departure_time" : "21:13:10" , 
"distance_traveled" : 18.2436
}, 
{ 
"stop_id" : 38296,
"arrival_time" : "21:18:52" , 
"departure_time" : "21:19:49" , 
"distance_traveled" : 21.5411
}, 
{ 
"stop_id" : 38295,
"arrival_time" : "21:21:57" , 
"departure_time" : "21:23:01" , 
"distance_traveled" : 23.7212
}, 
{ 
"stop_id" : 38294,
"arrival_time" : "21:27:04" , 
"departure_time" : "21:27:25" , 
"distance_traveled" : 27.5682
}, 
{ 
"stop_id" : 38293,
"arrival_time" : "21:32:21" , 
"departure_time" : "21:33:51" , 
"distance_traveled" : 32.5977
}, 
{ 
"stop_id" : 38292,
"arrival_time" : "21:35:30" , 
"departure_time" : "21:35:53" , 
"distance_traveled" : 33.0598
}, 
    { 
        "stop_id" : 38291,
        "arrival_time" : "21:37:23" , 
        "departure_time" : "21:37:23" , 
        "distance_traveled" : 33.5428
    }
]
}
}